(function () {
    'use strict';

    angular
        .module('app.front', ['ngComboDatePicker', 'chart.js', 'slickCarousel'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.home', {
                url: '/home?reunionId&subtraceId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/home/home.html',
                        controller: 'HomeController as vm'
                    }
                },
                reloadOnSearch: false
            })
            .state('app.groupement', {
                abstract: true,
                url: '/groupement'
            })
            .state('app.groupement.restitutions', {
                url: '/restitutions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/suivi-enquete/suivi-enquete.html',
                        controller: 'AdminSuiviEnqueteController'
                    }
                }
            })
            .state('app.groupement.restitutions.suivi-enquete', {
                url: '/suivi-enquete',
                params: {
                    initialTab: 'diffusion'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/suivi-enquete/suivi-enquete.html',
                        controller: 'AdminSuiviEnqueteController'
                    }
                }
            })
            .state('app.groupement.restitutions.pharmacies-engagees', {
                url: '/pharmacies-engagees',
                params: {
                    initialTab: 'pharmacies'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/suivi-enquete/suivi-enquete.html',
                        controller: 'AdminSuiviEnqueteController'
                    }
                }
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('SelectTableauDeBordController', SelectTableauDeBordController);

    function SelectTableauDeBordController($rootScope, $scope, $mdDialog, $q, toastr, index, exclude, TableauDeBordService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10,
            exclude: exclude,
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id && $scope.selected[i].year === element.year) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }


        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                TableauDeBordService.getPagination($scope.pagination).then(function (res) {
                    var idYearsSelected = $scope.selected.map(function (row) { return { id: row.id, year: row.year } })
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        for (var j = 0; j < idYearsSelected.length; j++) {
                            if (idYearsSelected[j].id === row.id && idYearsSelected[j].year === row.year) {
                                row.selected = true
                                break
                            }
                        }
                    }
                    resolve(res)
                }).catch(function (err) {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'INDICATEUR_DU_TABLEAU_DE_BORD', index: index })
            $mdDialog.hide()
        }

        $scope.apercu = function (row) {

            $mdDialog.show({
                templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/apercu_indicateur_popup.html',
                parent: angular.element(document.body),
                controller: 'ApercuIndicateurController',
                multiple: true,
                locals: {
                    indicateurId: row.id,
                    year: row.year
                }
            });
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('SelectTachesPlanningController', SelectTachesPlanningController);

    function SelectTachesPlanningController($rootScope, $scope, $mdDialog, $q, toastr, index, excludeIds, TachesGeneralesService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10,
            excludeIds: excludeIds,
            gtThanToday: true
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }


        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                var pagination = angular.copy($scope.pagination)
                if ($scope.pagination.page < 0) {
                    pagination.page = -(pagination.page + 1)
                    pagination.gtThanToday = false
                } else {
                    pagination.gtThanToday = true
                }
                $scope.pagination.gtThanToday = pagination.gtThanToday

                TachesGeneralesService.getPagination(pagination).then(function (res) {
                    var idsSelected = $scope.selected.map(function (row) { return row.id })
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        if (idsSelected.lastIndexOf(row.id) > -1) {
                            row.selected = true
                        }
                    }
                    resolve(res)
                }).catch(function () {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'TACHE_ET_EVENEMENT_PLANIFIE', index: index })
            $mdDialog.hide()
        }

        $scope.apercu = function (row) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                clickOutsideToClose: true,
                multiple: true,
                templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
                locals: {
                    type: "AUTRE",
                    datasource: {
                        task: row,
                        echeance: new Date(row.echeance)
                    }
                },
                controller: "DialogController"
            }).then(function (param) {
                if (param) {
                    $scope.findResults().then(function (res) {
                        for (var i = 0; i < res.data.results.length; i++) {
                            if (row.id === res.data.results[i].id) {
                                for (var j = 0; j < $scope.dto.results.length; j++) {
                                    if ($scope.dto.results[j].id === row.id) {
                                        var selected = $scope.dto.results[j].selected
                                        $scope.dto.results[j] = res.data.results[i]
                                        $scope.dto.results[j].selected = selected
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                    })
                }
            }).catch(function () {
            });

        }

        $scope.backToToday = function () {
            $scope.pagination = {
                page: 0,
                nbrResults: 10,
                excludeIds: excludeIds,
                gtThanToday: true
            }
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
            }).catch(function () {

            })
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('JoindreMesEvalController', JoindreMesEvalController);

    function JoindreMesEvalController($rootScope, $scope, $mdDialog, $q, toastr, index, elements, SatisfactionService, AuditService, AutoEvaluationService, AutoControlesService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10,
            evaluation: {
                excludeFlashIds: [],
                excludeAuditIds: [],
                excludeSatisfactionIds: [],
                excludeAutoEvalIds: []
            }
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        for (var i = 0; i < elements.length; i++) {
            var element = elements[i]
            if (element.type === 'AUTO_EVALUATION') {
                $scope.pagination.evaluation.excludeAutoEvalIds.push(element.associationId)
            } else if (element.type === 'RAPPORT_D_AUDIT') {
                $scope.pagination.evaluation.excludeAuditIds.push(element.associationId)
            } else if (element.type === 'SATISFACTION_CLIENT') {
                $scope.pagination.evaluation.excludeSatisfactionIds.push(element.associationId)
            } else if (element.type === 'FLASH_QUALITE') {
                $scope.pagination.evaluation.excludeAutoEvalIds.push(element.associationId)
            }
        }

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id && $scope.selected[i].type === element.type) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }

        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                SatisfactionService.getPagination($scope.pagination).then(function (res) {
                    for (var i = 0; i < res.data.results.length; i++) {
                        if (res.data.results[i].type === 'AUTO_EVALUATION') {
                            res.data.results[i].typeLibelle = 'Auto-évaluation'
                        } else if (res.data.results[i].type === 'RAPPORT_D_AUDIT') {
                            res.data.results[i].typeLibelle = 'Audit'
                        } else if (res.data.results[i].type === 'SATISFACTION_CLIENT') {
                            res.data.results[i].typeLibelle = 'Satisfaction client'
                        } else if (res.data.results[i].type === 'FLASH_QUALITE') {
                            res.data.results[i].typeLibelle = 'Flash Qualité'
                        }
                    }
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        for (var j = 0; j < $scope.selected.length; j++) {
                            if ($scope.selected[j].id === row.id && $scope.selected[j].type === row.type) {
                                row.selected = true
                                break
                            }
                        }
                    }
                    resolve(res)
                }).catch(function () {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'MES_EVALUATIONS', index: index })
            $mdDialog.hide()
        }

        $scope.apercu = function (row) {
            if (row.type === 'FLASH_QUALITE') {
                AutoControlesService.getFlashDataById(row.id).then(function (res) {
                    $scope.openDialog(res, row.type)
                }).catch(function () {

                })
            } else if (row.type === 'RAPPORT_D_AUDIT') {
                AuditService.findById(row.id).then(function (res) {
                    $scope.openDialog(res, row.type)
                }).catch(function () {

                })
            } else if (row.type === 'SATISFACTION_CLIENT') {
                SatisfactionService.findById(row.id).then(function (res) {
                    $scope.openDialog(res.data, row.type)
                }).catch(function () {

                })
            } else if (row.type === 'AUTO_EVALUATION') {
                AutoEvaluationService.findById(row.id).then(function (res) {
                    $scope.openDialog(res.data, row.type)
                }).catch(function () {

                })
            }

        }

        $scope.openDialog = function (data, type) {
            $mdDialog.show({
                templateUrl: 'app/main/front/home/popup/apercu_popup.html',
                parent: angular.element(document.body),
                controller: 'ApercuController',
                multiple: true,
                locals: {
                    pj: {
                        type: 'MES_EVALUATIONS',
                        monEval: { type: type, data: data }
                    },
                    info: null
                }
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('ApercuIndicateurController', ApercuIndicateurController);

    function ApercuIndicateurController($rootScope, $scope, $mdDialog, $q, indicateurId, year, TABLEAU_BORD_PERIODS, TableauDeBordService) {
        $scope.indicateur = {
            dataIndicateurs: []
        }
        $scope.periods = TABLEAU_BORD_PERIODS;

        if (indicateurId && year) {
            TableauDeBordService.findByIdAndYear(indicateurId, year, $rootScope.user.isTeam).then(function (res) {
                $scope.indicateur = res.data
            }).catch(function () {
                toastr.error('Une erreur est survenue')
            })
        }

        $scope.checkGoalOK = function (data, indicateur) {
            if (indicateur.goalType != null && indicateur.goal != null && data.value != null) {
                if (indicateur.goalType === 'HIGHER') {
                    return data.value > indicateur.goal;
                } else if (indicateur.goalType === 'LOWER') {
                    return data.value < indicateur.goal;
                }
            }
            return null;
        };

        $scope.average = function (dataIndicateurs) {
            var nb = 0;
            var sum = 0;
            dataIndicateurs.forEach(function (data) {
                if (data.value != null && !Number.isNaN(data.value)) {
                    nb++;
                    sum += parseFloat(data.value);
                }
            });
            if (nb !== 0) {
                var average = sum / nb;
                if (Number.isInteger(average)) {
                    return average;
                } else {
                    return average.toFixed(2);
                }
            } else {
                return 0;
            }
        };

        $scope.isToday = function (data, period) {
            var today = new Date();
            var isToday = false;
            if (period === 'mensuel') {
                isToday = data.index === today.getMonth();
            } else if (period === 'trimestriel') {
                var trimestre = (today.getMonth() + 1) / 4;
                isToday = trimestre < data.index + 1;
            } else if (period === 'annuel') {
                isToday = true;
            }
            return isToday;
        };

        $scope.printNumber = function (nb) {
            if (Number.isInteger(nb)) {
                return nb;
            } else {
                return nb.toFixed(2);
            }
        };

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('AddSubtraceController', AddSubtraceController);

    function AddSubtraceController($scope, $state, datasource, toastr, $mdDialog, EquipeDetailService, TraceService) {


        $scope._baseResource = "/api/rest/trace";
        $scope.collaborateurs = []
        $scope.subtraceToAdd = angular.copy(datasource.subtraceToAdd)
        if ($scope.subtraceToAdd.parameters != null) {
            for (var i = 0; i < $scope.subtraceToAdd.parameters.length; i++) {
                var param = $scope.subtraceToAdd.parameters[i]
                if (param.type === 'LIST') {
                    param.options = param.options.map(o => { return { name: o, disabled: true } })
                    // Valeur d'une option supprimée depuis la saisie : affichée et conservée tant qu'on
                    // ne la change pas, mais plus proposée au choix
                    if (param.value && !param.options.some(o => o.name === param.value)) {
                        param.options.push({ name: param.value, removed: true })
                    }
                } else if (param.type === 'DATE' && param.value != null) {
                    param.value = new Date(param.value)
                }
            }
        }
        $scope.trace = angular.copy(datasource.trace)
        if ($scope.trace.parameters != null) {
            for (var i = 0; i < $scope.trace.parameters.length; i++) {
                var param = $scope.trace.parameters[i]
                if (param.type === 'LIST') {
                    param.options = param.options.map(o => { return { name: o, disabled: true } })
                }
            }
        }

        $scope.loadingAdd = false

        $scope.saveChanges = function (subtrace, index) {
            if ($scope.loadingUpdate) {
                return
            }
            $scope.loadingUpdate = true
            var fmData = new FormData()
            var sub = angular.copy(subtrace)
            sub.date = sub.dateTmp.getTime()
            fmData.append('dto', angular.toJson(sub))
            var files = document.getElementById('file_' + subtrace.id).getElementsByTagName('input')['document_input_file'].files
            if (files.length > 0) {
                fmData.append('file', files[0], files[0].name)
            }

            TraceService.saveEditSubtrace(fmData).then(function (res) {

                subtrace.openModify = false;
                subtrace = res
                if (subtrace.dateTmp != null) {
                    subtrace.date = subtrace.dateTmp.getTime();
                }
                $scope.loadingUpdate = false
                $scope.subtraces[index] = angular.copy(subtrace);
                toastr.success("Changements enregistrés avec succès");
            }).catch(function (err) {
                $scope.loadingUpdate = false
                toastr.error("Erreur pendant l'enregistrement");
            })
        }

        $scope.getCollaborateurs = function () {
            return EquipeDetailService.getCollaborateurs().then(function (data) {
                $scope.collaborateurs = data;
                buildCollaborateurOptions();
            }).catch(function (response) {
                console.log("Error getCollaborateurs()");
            });
        }
        $scope.getCollaborateurs();

        // Colonnes « Liste des collaborateurs » : les collaborateurs actifs, au format du rapporteur
        // (NOM Prénom). Celui déjà enregistré, s'il a été supprimé depuis, reste affiché et conservé tant
        // qu'on ne le change pas, mais n'est plus proposé au choix.
        function buildCollaborateurOptions() {
            var actifs = $scope.collaborateurs.map(function (c) {
                return { id: c.id, label: c.surname + ' ' + c.name }
            })
            var params = $scope.subtraceToAdd.parameters || []
            params.forEach(function (param) {
                if (param.type !== 'COLLABORATEUR') {
                    return
                }
                param.collaborateurOptions = angular.copy(actifs)
                if (param.collaborateurId != null && !actifs.some(o => o.id === param.collaborateurId)) {
                    param.collaborateurOptions.push({ id: param.collaborateurId, label: param.value, removed: true })
                }
            })
        }

        // « + Ajouter un nouveau collaborateur » de la liste Rapporteur (valeur 0). La fenêtre d'ajout
        // s'ouvre par-dessus celle-ci (multiple) et avec son propre scope : EquipeDetailController
        // remplacerait sinon getCollaborateurs et collaborateurs de cette fenêtre.
        $scope.changeCollab = function (idSelected) {
            if (idSelected !== 0) {
                return
            }
            $mdDialog.show({
                templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                controller: 'EquipeDetailController'
            }).then(function (id) {
                $scope.getCollaborateurs().then(function () {
                    $scope.subtraceToAdd.reporter.id = id || null
                })
            }).catch(function () {
                $scope.subtraceToAdd.reporter.id = null
            })
        }



        $scope.saveNewSubTrace = function () {
            if ($scope.subtraceToAdd == null || $scope.subtraceToAdd == {}) {
                return;
            }
            if ($scope.loadingAdd) {
                return
            }
            $scope.loadingAdd = true
            var fmData = new FormData()
            var sub = angular.copy($scope.subtraceToAdd)
            sub.date = sub.date.getTime()
            for (var i = 0; i < sub.parameters.length; i++) {
                var param = sub.parameters[i]
                if (param.type === 'LIST') {
                    delete param.options
                } else if (param.type === 'COLLABORATEUR') {
                    delete param.collaborateurOptions
                }
            }
            fmData.append('dto', angular.toJson(sub))
            if ($scope.subtraceToAdd.documents != null) {
                for (var i = 0; i < $scope.subtraceToAdd.documents.length; i++) {
                    var document = $scope.subtraceToAdd.documents[i]
                    if (document.file != null) {
                        fmData.append('files', document.file, document.attachmentOriginalName)
                        delete document.file
                    }
                }
            }
            if (sub.id != null) {
                TraceService.saveEditSubtrace(fmData).then(function (res) {
                    $mdDialog.hide(res);
                    $scope.loadingAdd = false;
                    toastr.success("Changements enregistrés avec succès");
                }).catch(function (err) {
                    $scope.loadingAdd = false;
                    toastr.error("Erreur pendant l'enregistrement");
                })
            } else {
                TraceService.saveSubtrace(fmData, $scope.trace.id).then(function (res) {
                    toastr.success("Nouvelle ligne ajoutée");
                    $mdDialog.hide('success');
                    $scope.loadingAdd = false;
                }).catch(function (err) {
                    $scope.loadingAdd = false;
                    toastr.error("Erreur pendant l'enregistrement");
                })
            }
        }

        $scope.closeModal = function () {
            $mdDialog.hide();
        }

        $scope.addParameter = function (type) {
            $scope.traceToUpdate.parameters.push({ name: null, index: $scope.traceToUpdate.parameters.length, type: type })
        }

        $scope.deleteRow = function (index) {
            var trace = angular.copy($scope.traceToUpdate.parameters[index])
            trace.toDelete = true
            $scope.traceToUpdate.deletedParameters.push(trace)
            $scope.traceToUpdate.parameters.splice(index, 1)
            for (var i = 0; i < $scope.traceToUpdate.parameters.length; i++) {
                $scope.traceToUpdate.parameters[i].index = i
            }
        }

        $scope.openAddSubtrace = function () {
            $scope.subtraceToAdd = {};
            $scope.subtraceToAdd.date = new Date();
            $scope.subtraceToAdd.parameters = $scope.trace.parameters;
            $mdDialog.show({
                templateUrl: 'app/main/front/controle/trace/subtraces/popup/add_subtrace.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            }).then(function () {
            }).catch(function () {
            });
        }

        $scope.openJoindreFile = function () {

            $('#add_file').off('change')
            $('#add_file').on('change', function (evt) {
                if (evt.target.files.length > 0) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        if ($scope.subtraceToAdd.documents == null) {
                            $scope.subtraceToAdd.documents = []
                        }
                        $scope.subtraceToAdd.documents.push({
                            attachmentOriginalName: evt.target.files[0].name,
                            file: new Blob([e.target.result]),
                        })
                        $('#add_file').val('')
                        $scope.$apply()
                    };
                    reader.readAsArrayBuffer(evt.target.files[0]);
                }
            })
            $('#add_file').click()
        }

        $scope.deleteDocument = function (index) {
            $scope.subtraceToAdd.documents.splice(index, 1)
        }

        $scope.downloadDoc = function (id) {
            if (id != null) {
                location.href = $scope._baseResource + '/download/document/' + id;
            }
        }

        $scope.openToInformation = function () {
            $mdDialog.show({
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                templateUrl: 'app/main/front/controle/trace/popup/to_information_popup.html',
                scope: $scope,
                preserveScope: true
            }).then(function (param) {
            }).catch(function () {

            });
        }

        $scope.toInformation = function () {
            $state.go('app.home', { subtraceId: $scope.subtraceToAdd.id })
        }

    };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('DemarcheSelectionTasksController', DemarcheSelectionTasksController);

  function DemarcheSelectionTasksController($scope, toastr, DemarcheService, TASKS_CATEGORIES_QUALITY, TASKS_DEMARCHE_NBR_SELECTED_MAX, $filter, $state) {
    $scope.tasksNotDone = [];
    $scope.TASKS_CATEGORIES_QUALITY = angular.copy(TASKS_CATEGORIES_QUALITY);
    $scope.TASKS_DEMARCHE_NBR_SELECTED_MAX = TASKS_DEMARCHE_NBR_SELECTED_MAX;

    $scope.isLimitNbrSelectedReached = function () {
      if ($filter('filter')($scope.tasksNotDone, {
        selected: true
      }).length >= TASKS_DEMARCHE_NBR_SELECTED_MAX) {
        return true;
      }

      return false;
    };

    $scope.select = function () {
      var idsSelected = $filter('filter')($scope.tasksNotDone, {
        selected: true
      }).map(function (task) {
        return task.id;
      });

      DemarcheService.setSelected(idsSelected).then(function (res) {
        $state.go('app.equipe.planning-general', { tab: 'qualite' })
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la sélection des tâches');
      });
    };

    $scope.goBack = function () {
      $state.go('app.equipe.planning-general', { tab: 'qualite' })
    };

    $scope.selectTask = function (task) {
      if (!task.selected && $scope.isLimitNbrSelectedReached()) {
        toastr.error('Vous avez déjà sélectionné 3 tâches');
      }
    };

    function init() {
      DemarcheService.findDemarcheQualiteNotDoneTasksByPharmacy().then(function (data) {
        var sortable = [];

        data.forEach(function (task) {
          sortable.push(task);
        });

        sortable.sort(function (a, b) {
          if (a.title < b.title)
            return -1;
          if (a.title > b.title)
            return 1;
          return 0;
        });
        $scope.tasksNotDone = sortable;
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération des tâches');
      });
    }

    init();
  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('NotesInternesService', NotesInternesService);

  function NotesInternesService($q, $http) {
    var URL_NOTESINTERNES = "/api/rest/notesInternes";
    var URL_DOWNLOAD = "/api/rest/docgeneration";

    var getNotesInternes = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + '/' + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteNote = function (note) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + "/delete",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: note
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var undraft = function (planStrat) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + "/draft",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: planStrat
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var save = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadNoteInterne = function (noteId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_DOWNLOAD + "/NOTES_INTERNES/" + noteId,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var sendMail = function (noteId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + "/mail/" + noteId,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };


    var findIndicateurByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + "/indicateur/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findAuditByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_NOTESINTERNES + "/audit/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      getNotesInternes: getNotesInternes,
      save: save,
      deleteNote: deleteNote,
      downloadNoteInterne: downloadNoteInterne,
      sendMail: sendMail,
      findById: findById,
      findIndicateurByPharmacyAndPage: findIndicateurByPharmacyAndPage,
      findAuditByPharmacyAndPage: findAuditByPharmacyAndPage
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('NotesInternesController', NotesInternesController);

  function NotesInternesController($scope, $state, NotesInternesService, $mdDialog, PERMISSIONS) {
    $scope.notesInternes = [];
    $scope.permissions = PERMISSIONS;
    NotesInternesService.getNotesInternes().then(function (data) {
      $scope.notesInternes = data;
    }).catch(function (err) {
      console.log("Error getNotesInternes()");
    })

    $scope.goAddNote = function () {
      $state.go('app.qualite.communication-interne.notes-internes.add');
    }

    $scope.display = function (note) {
      $state.go('app.qualite.communication-interne.notes-internes.display', { note: note, id: note.id });
    }

    $scope.update = function (note) {
      $state.go('app.qualite.communication-interne.notes-internes.add', {
        note: note
      });
    }

    $scope.displayPopUpDelete = function (note, index) {
      $scope.noteToDelete = angular.copy(note);
      $scope.indexToDelete = index;
      $scope.deletePlanPopUp = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/popup/delete_note.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.noteToDelete = {};
        $scope.indexToDelete = null;
      }).catch(function () {
        $scope.noteToDelete = {};
        $scope.indexToDelete = null;
      });
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.deleteNote = function () {
        var dto = {
            id: $scope.noteToDelete.id,
            deleted: true
        }
      NotesInternesService.deleteNote(dto).then(function (data) {
        $scope.hidePopup();
        $scope.notesInternes.splice($scope.indexToDelete, 1);
      }).catch(function (err) {
        console.log("Error deleteNote()");
      })
    }

    $scope.goCommunicationInterne = function() {
      $state.go('app.qualite.communication-interne');
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('DisplayNoteInterneController', DisplayNoteInterneController);

  function DisplayNoteInterneController($scope, $state, $stateParams, NotesInternesService, NOTES_INTERNES_CATEGORIES,toastr, $mdDialog) {
    $scope.categories = angular.copy(NOTES_INTERNES_CATEGORIES);
    $scope.otherComment = [];
    $scope.note = {};
    $scope.loading = false;

    if ($stateParams.note != null) {
      $scope.note = $stateParams.note;
      prepareNote();
    } else if($stateParams.id != null) {
      NotesInternesService.findById($stateParams.id).then(function(res) {
        $scope.note = res;
        prepareNote();
      }).catch(function(err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération de la note interne.');
      });
    } else {
      $state.go('app.qualite.communication-interne.notes-internes');
    }

    $scope.goBack = function () {
      $state.go('app.qualite.communication-interne.notes-internes');
    };

    $scope.generateDoc = function (noteId) {
      NotesInternesService.downloadNoteInterne(noteId).then(function (data) {
        window.open("/api/rest/docgeneration/download/?location=" + data);
      }).catch(function (error) {

      });
    };

    $scope.openPopupMail = function() {
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/popup/send_mail.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {}).catch(function () {});
    };

    $scope.sendMail = function () {
      if(!$scope.loading){
        $scope.loading = true;
        NotesInternesService.sendMail($scope.note.id).then(function (data) {
          toastr.success('Email envoyé avec succès !');
        }).catch(function (error) {
          toastr.success('Erreur dans l\'envoi du mail');
        }).finally(function(){
          $scope.loading = false;
        });
      }
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.cancelPopup = function () {
      $mdDialog.cancel();
    };

    function prepareNote() {
      for (var i = 0; i < $scope.note.subNotes.length; i++) {
        if ($scope.note.subNotes[i].malfunction != null) {
          $scope.categories.malfunctions.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].document != null) {
          $scope.categories.documents.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].tacheGenerale != null) {
          $scope.categories.tasks.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].action != null) {
          $scope.categories.actions.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].indicateur != null) {
          $scope.categories.indicators.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].autoEvaluation != null) {
          $scope.categories.evaluations.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].satisfactionClient != null) {
          $scope.categories.satisfaction.elements.push($scope.note.subNotes[i]);
        } 
        else if ($scope.note.subNotes[i].audit != null) {
          $scope.categories.audit.elements.push($scope.note.subNotes[i]);
        } 
        else {
          $scope.otherComment.push($scope.note.subNotes[i]);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AddNoteInterneController', AddNoteInterneController);

  function AddNoteInterneController($mdDialog, $scope, $stateParams, $state, AuditService, NotesInternesService, SatisfactionService,
    TABLEAU_BORD_PERIODS, MalfunctionService, TachesGeneralesService, TableauDeBordService, $rootScope, AutoEvaluationService,
    GENERAL_TASK_PERIOD_JSON, STATUSES_MALFUNCTION, DocumentService, NOTES_INTERNES_PAGES, NOTES_INTERNES_CATEGORIES, STATUT_DOCS, $timeout) {
    $scope.recurrencesGeneralTasks = angular.copy(GENERAL_TASK_PERIOD_JSON);
    $scope.periodsIndicators = angular.copy(TABLEAU_BORD_PERIODS);
    $scope.statusesMalfunctions = angular.copy(STATUSES_MALFUNCTION);
    $scope.otherComment = null;
    $scope.categories = angular.copy(NOTES_INTERNES_CATEGORIES);
    $scope.pages = angular.copy(NOTES_INTERNES_PAGES);
    $scope.statutDocs = STATUT_DOCS;
    $scope.note = {};
    $scope.eltFound;
    $scope.editMode = false;

    $scope.goBack = function () {
      $state.go('app.qualite.communication-interne.notes-internes');
    };

    $scope.loadMore = function (categorie) {
      $scope.pages[categorie].page = $scope.pages[categorie].page + 1;
      $scope.categories[categorie].loaded = false;
      $scope.show(categorie, false);
    }

    var checkEltInList = function (elt, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == elt.id) {
          return true;
        }
      }
      return false;
    }

    $scope.eltChecked = function (categorie) {
      var checked = false;
      for (var i = 0; i < $scope.categories[categorie].elements.length; i++) {
        if ($scope.categories[categorie].elements[i].checked) {
          checked = true;
          break;
        }
      }

      $scope.categories[categorie].checked = checked;
    };

    $scope.selectAllElement = function (categorie) {
      if (!$scope.categories[categorie].loaded) {
        $scope.show(categorie, true, null, null, true);
        return;
      }

      var nbrChecked = 0;

      for (var i = 0; i < $scope.categories[categorie].elements.length; i++) {
        if ($scope.categories[categorie].elements[i].checked) {
          nbrChecked++;
        } else {
          $scope.categories[categorie].elements[i].checked = true;
        }
      }

      if (nbrChecked === $scope.categories[categorie].elements.length) {
        for (var i = 0; i < $scope.categories[categorie].elements.length; i++) {
          $scope.categories[categorie].elements[i].checked = false;
        }

        $scope.categories[categorie].checked = true;
      } else {
        $scope.categories[categorie].checked = false;
      }

      $scope.categories[categorie].show = true;
    };

    $scope.show = function (categorie, changeShow, id, comment, selectAllAfter) {

      if (changeShow && id == null) {
        $scope.categories[categorie].show = !$scope.categories[categorie].show;
      } else if (changeShow && id != null) {
        $scope.categories[categorie].show = true;
      }

      if (!$scope.categories[categorie].loaded) {
        var alreadyLoaded = false;

        if (id != null) {
          $scope.eltFound = false;
        }

        switch (categorie) {
          case "malfunctions":

            for (var i = 0; i < $scope.pages.malfunctions.loadedPages.length; i++) {
              if ($scope.pages.malfunctions.loadedPages[i] == $scope.pages.malfunctions.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.malfunctions.loadedPages.push($scope.pages.malfunctions.page);
              MalfunctionService.findByPharmacyAndPage($scope.pages.malfunctions.page, $scope.pages.malfunctions.nbrResults).then(function (res) {

                if (res.data !== undefined && res.data.data.length > 0) {
                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      for (var i = 0; i < res.data.data.length; i++) {
                        if ($scope.note.subNotes[j].malfunction != null && res.data.data[i].id == $scope.note.subNotes[j].malfunction.id) {
                          res.data.data[i].checked = true;
                        }
                      }
                    }
                  }
                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("malfunctions");
                    }
                  }
                  if (($scope.pages.malfunctions.page + 1) * $scope.pages.malfunctions.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }
                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getMalfunctions()");
                console.log(err);
              })
            }
            break;

          case "documents":

            for (var i = 0; i < $scope.pages.documents.loadedPages.length; i++) {
              if ($scope.pages.documents.loadedPages[i] == $scope.pages.documents.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.documents.loadedPages.push($scope.pages.documents.page);
              DocumentService.findByPharmacyAndPage($scope.pages.documents.page, $scope.pages.documents.nbrResults).then(function (res) {

                if (res.data !== undefined && res.data.length > 0) {
                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      for (var i = 0; i < res.data.length; i++) {
                        if ($scope.note.subNotes[j].document != null && res.data[i].id == $scope.note.subNotes[j].document.id) {
                          res.data[i].checked = true;
                        }
                      }
                    }
                  }
                }

                if (res.data !== undefined && res.data.length > 0) {
                  for (var i = 0; i < res.data.length; i++) {
                    var elt = res.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("documents");
                    }
                  }

                  if (($scope.pages.documents.page + 1) * $scope.pages.documents.nbrResults >= res.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }

                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log(err);
                console.log("Error getDocuments()");
              })
            } else if (id != null) {
              for (var i = 0; i < $scope.categories[categorie].elements.length; i++) {
                if ($scope.categories[categorie].elements[i].id == id) {
                  $scope.categories[categorie].elements[i].checked = true;
                  $scope.categories[categorie].elements[i].comment = comment;
                  break;
                }
              }
            }
            break;

          case "tasks":

            for (var i = 0; i < $scope.pages.tasks.loadedPages.length; i++) {
              if ($scope.pages.tasks.loadedPages[i] == $scope.pages.tasks.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.tasks.loadedPages.push($scope.pages.tasks.page);
              TachesGeneralesService.findNotReunionByPharmacyAndPage($scope.pages.tasks.page, $scope.pages.tasks.nbrResults).then(function (res) {

                if (res.data !== undefined && res.data.data.length > 0) {
                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      if ($scope.note.subNotes[j].tacheGenerale != null) {
                        for (var i = 0; i < res.data.data.length; i++) {
                          if (res.data.data[i].id == $scope.note.subNotes[j].tacheGenerale.id) {
                            res.data.data[i].checked = true;
                          }
                        }
                      }
                    }
                  }
                }

                if (res.data !== undefined && res.data.data.length > 0) {
                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("tasks");
                    }
                  }

                  if (($scope.pages.tasks.page + 1) * $scope.pages.tasks.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }

                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getTasksGenerales()");
              })
            }
            break;

          case "actions":

            for (var i = 0; i < $scope.pages.actions.loadedPages.length; i++) {
              if ($scope.pages.actions.loadedPages[i] == $scope.pages.actions.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.actions.loadedPages.push($scope.pages.actions.page);
              TachesGeneralesService.findReunionByPharmacyAndPage($scope.pages.actions.page, $scope.pages.actions.nbrResults).then(function (res) {
                if (res.data !== undefined && res.data.data.length > 0) {

                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      if ($scope.note.subNotes[j].action != null) {
                        for (var i = 0; i < res.data.data.length; i++) {
                          if (res.data[i].id == $scope.note.subNotes[j].action.id) {
                            res.data.data[i].checked = true;
                          }
                        }
                      }
                    }
                  }

                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("actions");
                    }
                  }

                  if (($scope.pages.actions.page + 1) * $scope.pages.actions.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }

                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getActions()");
              })
            }
            break;

          case "indicators":

            for (var i = 0; i < $scope.pages.indicators.loadedPages.length; i++) {
              if ($scope.pages.indicators.loadedPages[i] == $scope.pages.indicators.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.indicators.loadedPages.push($scope.pages.indicators.page);
              if ($rootScope.user) {
                if ($rootScope.user.isTitulaire || $rootScope.user.isPraq) {
                  NotesInternesService.findIndicateurByPharmacyAndPage($scope.pages.indicators.page, $scope.pages.indicators.nbrResults).then(function (res) {
                    if (res.data.data !== undefined && res.data.data.length > 0) {

                      if ($scope.note.subNotes != null) {
                        for (var j = 0; j < $scope.note.subNotes.length; j++) {
                          if ($scope.note.subNotes[j].indicateur != null) {
                            for (var i = 0; i < res.data.data.length; i++) {
                              if (res.data.data[i].id == $scope.note.subNotes[j].indicateur.id) {
                                res.data.data[i].checked = true;
                              }
                            }
                          }
                        }
                      }

                      for (var i = 0; i < res.data.data.length; i++) {
                        var elt = res.data.data[i];
                        if (id != null) {
                          if (id == elt.id) {
                            elt.checked = true;
                            $scope.eltFound = true;
                          }
                        }

                        if (comment != null && elt.checked) {
                          elt.comment = comment;
                        } else {
                          elt.comment = null;
                        }

                        if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                          $scope.categories[categorie].elements.push(elt);
                        }

                        if (id != null) {
                          $scope.eltChecked("indicators");
                        }
                      }

                      if (($scope.pages.indicators.page + 1) * $scope.pages.indicators.nbrResults >= res.data.recordsTotal) {
                        $scope.categories[categorie].allLoaded = true;
                      }
                    } else {
                      $scope.categories[categorie].allLoaded = true;
                    }

                    $scope.categories[categorie].loaded = true;

                    if (id != null && !$scope.eltFound) {
                      var elt = $scope.elementToAdd;
                      elt.checked = true;
                      if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                        $scope.categories[categorie].elements.push(elt);
                      }
                    }

                    if (selectAllAfter) {
                      $scope.selectAllElement(categorie);
                      $scope.categories[categorie].checked = true;
                    }
                  }).catch(function (err) {
                    console.log("Error getIndicateurs() praq");
                  });
                } else {
                  TableauDeBordService.findByPharmacyAndPage($scope.pages.indicators.page, $scope.pages.indicators.nbrResults, true).then(function (res) {
                    if (res.data !== undefined && res.data.data.length > 0) {

                      if ($scope.note.subNotes != null) {
                        for (var j = 0; j < $scope.note.subNotes.length; j++) {
                          if ($scope.note.subNotes[j].indicateur != null) {
                            for (var i = 0; i < res.data.data.length; i++) {
                              if (res.data.data[i].id == $scope.note.subNotes[j].indicateur.id) {
                                res.data.data[i].checked = true;
                              }
                            }
                          }
                        }
                      }

                      for (var i = 0; i < res.data.data.length; i++) {
                        var elt = res.data.data[i];
                        if (id != null) {
                          if (id == elt.id) {
                            elt.checked = true;
                            $scope.eltFound = true;
                          }
                        }

                        if (comment != null && elt.checked) {
                          elt.comment = comment;
                        } else {
                          elt.comment = null;
                        }

                        if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                          $scope.categories[categorie].elements.push(elt);
                        }

                        if (id != null) {
                          $scope.eltChecked("indicators");
                        }
                      }

                      if (($scope.pages.indicators.page + 1) * $scope.pages.indicators.nbrResults >= res.data.recordsTotal) {
                        $scope.categories[categorie].allLoaded = true;
                      }
                    } else {
                      $scope.categories[categorie].allLoaded = true;
                    }

                    $scope.categories[categorie].loaded = true;

                    if (id != null && !$scope.eltFound) {
                      var elt = $scope.elementToAdd;
                      elt.checked = true;
                      if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                        $scope.categories[categorie].elements.push(elt);
                      }
                    }

                    if (selectAllAfter) {
                      $scope.selectAllElement(categorie);
                      $scope.categories[categorie].checked = true;
                    }
                  }).catch(function (err) {
                    console.log("Error getIndicateurs() no praq");
                  });
                }
              }
            }
            break;

          case "evaluations":

            for (var i = 0; i < $scope.pages.evaluations.loadedPages.length; i++) {
              if ($scope.pages.evaluations.loadedPages[i] == $scope.pages.evaluations.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.evaluations.loadedPages.push($scope.pages.evaluations.page);
              AutoEvaluationService.findByPharmacyAndPage($scope.pages.evaluations.page, $scope.pages.evaluations.nbrResults).then(function (res) {
                if (res.data !== undefined && res.data.data.length > 0) {

                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      if ($scope.note.subNotes[j].autoEvaluation != null) {
                        for (var i = 0; i < res.data.data.length; i++) {
                          if (res.data.data[i].id == $scope.note.subNotes[j].autoEvaluation.id) {
                            res.data.data[i].checked = true;
                          }
                        }
                      }
                    }
                  }

                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("evaluations");
                    }
                  }

                  if (($scope.pages.evaluations.page + 1) * $scope.pages.evaluations.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }
                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getAutoEvaluations()");
              });
            }
            break;

          case "reports":

            for (var i = 0; i < $scope.pages.reports.loadedPages.length; i++) {
              if ($scope.pages.reports.loadedPages[i] == $scope.pages.reports.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.reports.loadedPages.push($scope.pages.reports.page);
              NotesInternesService.findAuditByPharmacyAndPage($scope.pages.reports.page, $scope.pages.reports.nbrResults).then(function (res) {
                if (res.data !== undefined && res.data.data.length > 0) {

                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      if ($scope.note.subNotes[j].audit != null) {
                        for (var i = 0; i < res.data.data.length; i++) {
                          if (res.data.data[i].id == $scope.note.subNotes[j].audit.id) {
                            res.data.data[i].checked = true;
                          }
                        }
                      }
                    }
                  }

                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("reports");
                    }
                  }

                  if (($scope.pages.reports.page + 1) * $scope.pages.reports.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }
                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getAudits()");
              });
            }
            break;

          case "satisfaction":

            for (var i = 0; i < $scope.pages.satisfaction.loadedPages.length; i++) {
              if ($scope.pages.satisfaction.loadedPages[i] == $scope.pages.satisfaction.page) {
                alreadyLoaded = true;
              }
            }

            if (!alreadyLoaded) {
              $scope.pages.satisfaction.loadedPages.push($scope.pages.satisfaction.page);
              SatisfactionService.findByPharmacyAndPage($scope.pages.satisfaction.page, $scope.pages.satisfaction.nbrResults).then(function (res) {
                if (res.data !== undefined && res.data.data.length > 0) {

                  if ($scope.note.subNotes != null) {
                    for (var j = 0; j < $scope.note.subNotes.length; j++) {
                      if ($scope.note.subNotes[j].satisfactionClient != null) {
                        for (var i = 0; i < res.data.data.length; i++) {
                          if (res.data.data[i].id == $scope.note.subNotes[j].satisfactionClient.id) {
                            res.data.data[i].checked = true;
                          }
                        }
                      }
                    }
                  }

                  for (var i = 0; i < res.data.data.length; i++) {
                    var elt = res.data.data[i];
                    if (id != null) {
                      if (id == elt.id) {
                        elt.checked = true;
                        $scope.eltFound = true;
                      }
                    }

                    if (comment != null && elt.checked) {
                      elt.comment = comment;
                    } else {
                      elt.comment = null;
                    }

                    if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                      $scope.categories[categorie].elements.push(elt);
                    }

                    if (id != null) {
                      $scope.eltChecked("satisfaction");
                    }
                  }

                  if (($scope.pages.satisfaction.page + 1) * $scope.pages.satisfaction.nbrResults >= res.data.recordsTotal) {
                    $scope.categories[categorie].allLoaded = true;
                  }
                } else {
                  $scope.categories[categorie].allLoaded = true;
                }
                $scope.categories[categorie].loaded = true;

                if (id != null && !$scope.eltFound) {
                  var elt = $scope.elementToAdd;
                  elt.checked = true;
                  if (!checkEltInList(elt, $scope.categories[categorie].elements)) {
                    $scope.categories[categorie].elements.push(elt);
                  }
                }

                if (selectAllAfter) {
                  $scope.selectAllElement(categorie);
                  $scope.categories[categorie].checked = true;
                }
              }).catch(function (err) {
                console.log("Error getSatisfactions()");
              });
            }
            break;
        }
      }
    }

    $scope.initUpload = function () {
      if ($stateParams.note != null) {
        $scope.editMode = true;
        $scope.note = $stateParams.note;
        for (var i = 0; i < $scope.note.subNotes.length; i++) {
          var cat;
          var id;
          var comment = $scope.note.subNotes[i].comment;
          if ($scope.note.subNotes[i].malfunction != null) {
            cat = "malfunctions";
            id = $scope.note.subNotes[i].malfunction.id;
            $scope.elementToAdd = $scope.note.subNotes[i].malfunction;
          } else if ($scope.note.subNotes[i].tacheGenerale != null) {
            cat = "tasks";
            id = $scope.note.subNotes[i].tacheGenerale.id;
            $scope.elementToAdd = $scope.note.subNotes[i].tacheGenerale;
          } else if ($scope.note.subNotes[i].indicateur != null) {
            cat = "indicators";
            id = $scope.note.subNotes[i].indicateur.id;
            $scope.elementToAdd = $scope.note.subNotes[i].indicateur;
          } else if ($scope.note.subNotes[i].autoEvaluation != null) {
            cat = "evaluations";
            id = $scope.note.subNotes[i].autoEvaluation.id;
            $scope.elementToAdd = $scope.note.subNotes[i].autoEvaluation;
          } else if ($scope.note.subNotes[i].satisfactionClient != null) {
            cat = "satisfaction";
            id = $scope.note.subNotes[i].satisfactionClient.id;
            $scope.elementToAdd = $scope.note.subNotes[i].satisfactionClient;
          } else if ($scope.note.subNotes[i].audit != null) {
            cat = "reports";
            id = $scope.note.subNotes[i].audit.id;
            $scope.elementToAdd = $scope.note.subNotes[i].audit;
          } else if ($scope.note.subNotes[i].document != null) {
            cat = "documents";
            id = $scope.note.subNotes[i].document.id;
            $scope.elementToAdd = $scope.note.subNotes[i].document;
          } else if ($scope.note.subNotes[i].action != null) {
            cat = "actions";
            id = $scope.note.subNotes[i].action.id;
            $scope.elementToAdd = $scope.note.subNotes[i].action;
          } else {
            $scope.otherComment = $scope.note.subNotes[i].comment;
          }

          if (cat != undefined) {
            $scope.show(cat, true, id, comment);
          }
        }
      }
    }

    $timeout(function () {
      $scope.initUpload();
    });

    $scope.hidePopUp = function () {
      $mdDialog.hide();
    }

    $scope.openDetails = function (element) {
      if (element.hasOwnProperty("auditName") && element.auditName != null) {
        $scope.auditToDisplay = element;
        $mdDialog.show({
          templateUrl: 'app/main/front/performances/audit/popup/display_audit.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () { }).catch(function () { });
      } else {
        $scope.elementDetails = element;
        console.log({ elementDetails: $scope.elementDetails })
        $scope.malfunctionPopup = $mdDialog.show({
          templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/popup/details_item.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          $scope.elementDetails = null;
        }).catch(function () {
          $scope.elementDetails = null;
        });
      }

    }

    $scope.sendAndGoPreview = function () {
      $scope.save(true);
    }

    $scope.save = function (noGoBack) {
      $scope.submitting = true;
      var dto = {
        subNotes: []
      };

      if ($scope.note.id != null) {
        dto.id = $scope.note.id;
      }

      for (var key in $scope.categories) {
        if ($scope.categories[key].checked) {
          for (var y = 0; y < $scope.categories[key].elements.length; y++) {
            if ($scope.categories[key].elements[y].checked) {
              var subNote = {};
              subNote.comment = $scope.categories[key].elements[y].comment;

              switch (key) {
                case "malfunctions":
                  subNote.malfunction = {};
                  subNote.malfunction.id = $scope.categories[key].elements[y].id;
                  break;
                case "documents":
                  subNote.document = {};
                  subNote.document.id = $scope.categories[key].elements[y].id;
                  break;
                case "tasks":
                  subNote.tacheGenerale = {};
                  subNote.tacheGenerale.id = $scope.categories[key].elements[y].id;
                  break;
                case "actions":
                  subNote.action = {};
                  subNote.action.id = $scope.categories[key].elements[y].id;
                  break;
                case "indicators":
                  subNote.indicateur = {};
                  subNote.indicateur.id = $scope.categories[key].elements[y].id;
                  break;
                case "evaluations":
                  subNote.autoEvaluation = {};
                  subNote.autoEvaluation.id = $scope.categories[key].elements[y].id;
                  break;
                case "reports":
                  subNote.audit = {};
                  subNote.audit.id = $scope.categories[key].elements[y].id;
                  break;
                case "satisfaction":
                  subNote.satisfactionClient = {};
                  subNote.satisfactionClient.id = $scope.categories[key].elements[y].id;
                  break;
              }

              dto.subNotes.push(subNote);
            }
          }
        }
      }

      if ($scope.otherComment != null && $scope.otherComment != "") {
        var subNote = {
          comment: $scope.otherComment
        };
        dto.subNotes.push(subNote);
      }

      NotesInternesService.save(dto).then(function (res) {
        $scope.submitting = true;

        if (!noGoBack) {
          $scope.goBack();
        } else {
          $state.go('app.qualite.communication-interne.notes-internes.display', { id: res.data });
        }
      }).catch(function (err) {
        $scope.submitting = true;
        console.log("Error saveNoteInterne()");
      })
    }
  };
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('CahierTransmissionService', CahierTransmissionService);

  function CahierTransmissionService($q, $http) {
    var URL_CAHIER = '/api/rest/information';

    var getNbrFront = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/nbrFront',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getFront = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/front',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setFrontPage = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/front/' + id,
          method: 'PUT',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteInfo = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteComment = function (infoID, commentID) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/deleteComment/' + infoID + "/" + commentID,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getAll = function (pagination, collabId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'collaborateurId': collabId != null && collabId != -1 ? collabId : undefined
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: pagination
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveInfoLuNonLu = function (infoId, lu, pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/saveLuNonLu/' + infoId + '/' + lu,
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: pagination
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var add = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/add',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var update = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/update',
          method: 'PUT',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var comment = function (comment) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/comment',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: comment
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var markAsView = function (collabId, infoId, pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/' + infoId + '/markAsView/' + collabId,
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getCollabInfos = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/getCollab/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      })
    }

    var loadPreviousComments = function (info) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/getPreviousComments/',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: info
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      })
    }

    var setPin = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + '/' + id + '/pin',
          method: 'PUT',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      })
    }

    var getDownloadLink = function (id) {
      return URL_CAHIER + "/download/" + id;
    };

    var getPDF = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + "/pdf/" + id,
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          responseType: 'arraybuffer'
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var findTags = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + "/tags",
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var saveTags = function (dtos) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CAHIER + "/tags",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          data: dtos
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    return {
      getNbrFront: getNbrFront,
      getFront: getFront,
      setFrontPage: setFrontPage,
      deleteInfo: deleteInfo,
      deleteComment: deleteComment,
      getAll: getAll,
      saveInfoLuNonLu: saveInfoLuNonLu,
      add: add,
      update: update,
      comment: comment,
      markAsView: markAsView,
      getCollabInfos: getCollabInfos,
      loadPreviousComments: loadPreviousComments,
      setPin: setPin,
      getDownloadLink: getDownloadLink,
      getPDF: getPDF,
      findTags: findTags,
      saveTags: saveTags,
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('HistoryBandeauxController', HistoryBandeauxController);

  function HistoryBandeauxController($scope, $state, AdministrationBandeauService, $mdDialog) {
    $scope.bandeaux = [];

    AdministrationBandeauService.getHistory().then(function (data) {
      $scope.bandeaux = data;
    }).catch(function (err) {
      console.log(err);
    })

    $scope.goAdministrationBandeau = function () {
      $state.go('app.qualite.communication-interne.administration-bandeau');
    }

    $scope.openDialogDelete = function (bandeau, index) {
      $scope.bandeauToDelete = bandeau;
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/delete_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDialogDisplay = function (bandeau) {
      $scope.bandeauToDisplay = bandeau;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/display_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.delete = function () {
      AdministrationBandeauService.deleteBandeau($scope.bandeauToDelete.id).then(function (res) {
        $scope.hidePopup();
        $scope.bandeaux.splice($scope.indexToDelete, 1);
      }).catch(function (err) {
        console.log(err);
      })
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }
  };
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('AdministrationBandeauService', AdministrationBandeauService);

  function AdministrationBandeauService($q, $http) {
    var URL_BANDEAU = "/api/rest/bandeauAccueil";

    var getCurrent = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getCurrentsAdmin = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/admin",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getBanner = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/banner",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getHistory = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/history",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getHistoryAdmin = function (type) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/admin/history/"+type,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteBandeau = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/delete/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var save = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return {
      getCurrent: getCurrent,
      getHistory: getHistory,
      deleteBandeau: deleteBandeau,
      save: save,
      getBanner: getBanner,
      getCurrentsAdmin: getCurrentsAdmin,
      getHistoryAdmin: getHistoryAdmin
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AdministrationBandeauController', AdministrationBandeauController);

  function AdministrationBandeauController($scope, $state, AdministrationBandeauService, $mdDialog, BANDEAU_DURATIONS, BANDEAU_CUSTOM_DURATIONS) {
    $scope.currentBandeau = {};
    $scope.durations = [];
    $scope.customDurations = [];
    $scope.noBandeau = false;
    $scope.interne = true;

    AdministrationBandeauService.getCurrent().then(function (data) {
      if (data != null) {
        $scope.currentBandeau = data;
      } else {
        $scope.noBandeau = true;
      }
    }).catch(function (err) {
      console.log(err);
    })

    $scope.openDialogNew = function () {
      $scope.newBandeau = {};
      $scope.titlePopupSave = "Ajouter un message";
      $scope.customDurationMode = false;

      if ($scope.durations.length === 0) {
        $scope.durations = BANDEAU_DURATIONS;
      }

      if ($scope.customDurations.length === 0) {
        $scope.customDurations = BANDEAU_CUSTOM_DURATIONS;
      }

      $scope.customDuration = {
        number: null,
        ms: $scope.durations[0].value
      };

      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/add_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDialogDelete = function () {
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/delete_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.delete = function() {
      AdministrationBandeauService.deleteBandeau($scope.currentBandeau.id).then(function(res) {
        $scope.hidePopup();
        $scope.currentBandeau = {};
        $scope.noBandeau = true;
      }).catch(function(err) {
        console.log(err);
      })
    }

    $scope.display = function() {
      console.log($scope.currentBandeau);
    }

    $scope.openDialogUpdate = function () {
      $scope.newBandeau = angular.copy($scope.currentBandeau);
      $scope.customDurationMode = true;
      $scope.titlePopupSave = "Modifier le message";

      if ($scope.durations.length === 0) {
        $scope.durations = BANDEAU_DURATIONS;
      }

      if ($scope.customDurations.length === 0) {
        $scope.customDurations = BANDEAU_CUSTOM_DURATIONS;
      }

      $scope.customDuration = {
        number: null,
        ms: $scope.durations[0].value
      };

      for (var i = 0; i < $scope.durations.length; i++) {
        if ($scope.durations[i].value === $scope.newBandeau.duration) {
          $scope.customDurationMode = false;
        }
      }

      if ($scope.customDurationMode) {
        for (var i = 0; i < $scope.customDurations.length; i++) {
          if ($scope.newBandeau.duration % $scope.customDurations[$scope.customDurations.length - 1 - i].value === 0) {
            $scope.customDuration.number = $scope.newBandeau.duration / $scope.customDurations[$scope.customDurations.length - 1 - i].value;
            $scope.customDuration.ms = $scope.customDurations[$scope.customDurations.length - 1 - i].value;
            break;
          }
        }
      }

      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/add_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDialogDisplay = function () {
      $scope.bandeauToDisplay = $scope.currentBandeau;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/display_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.saveBandeau = function () {
      if ($scope.customDurationMode) {
        if (Math.sign($scope.customDuration.number) === 1) {
          $scope.newBandeau.duration = $scope.customDuration.number * $scope.customDuration.ms;
        } else {
          return;
        }
      }

      $scope.submitting = true;

      $scope.newBandeau.contractType = 'LQO';

      AdministrationBandeauService.save($scope.newBandeau).then(function (data) {
        $scope.currentBandeau = data;
        $scope.noBandeau = false;
        $scope.submitting = false;
        $scope.hidePopup();
      })
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.setCustomDurationMode = function () {
      $scope.customDurationMode = !$scope.customDurationMode;
    }

    $scope.goCommunicationInterne = function () {
      $state.go('app.qualite.communication-interne');
    };

    $scope.goHistory = function() {
      $state.go("app.qualite.communication-interne.administration-bandeau.historique");
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('OrdreDuJourController', OrdreDuJourController);

  function OrdreDuJourController($scope, $rootScope, $filter, AuditService, $state, STATUSES_MALFUNCTION, $mdDialog, $timeout, $window, $location, PERMISSIONS, toastr, UserService, ReunionService, DocGenerationService, SELECT_HOURS_EVENTS,
    REUNION, api, TASKS_EVENTS_REMINDERS, GENERAL_TASK_PERIOD, TABLEAU_BORD_PERIODS, GENERAL_TASK_TYPES, TableauDeBordService, MalfunctionService, FicheProgresService, SatisfactionService, AutoControlesService, AutoEvaluationService, TachesGeneralesService, DocumentService, FolderService, EquipeDetailService) {
    // Check if dialog were opened from home

    $scope.libelles = {
      malfunctions: 'Dysfonctionnements',
      progressForms: 'Fiches de progrès',
      documents: 'Documents ajoutés',
      tasks: 'Tâches et événements planifiés',
      actions: 'Dernières actions décidées',
      indicateurs: 'Indicateurs du tableau de bord',
      evaluations: 'Mes évaluations',
      noteOdj: 'Suivi de l\'activité de l\'officine'
    }

    $scope._rubriquesSelected = []
    $scope.indicateurs = []
    $scope.indicateursFilter = []
    $scope.periods = TABLEAU_BORD_PERIODS;
    $scope._actionsDecidees = []

    if ($state.params.fromHome != null) {
      if ($state.params.fromHome) {
        $scope.fromHome = true;
      } else {
        $scope.fromHome = false;
      }
    } else {
      $scope.fromHome = false;
    }

    // Constants

    $scope.substituteText = "<strong>- Suivi de l'activité de l'officine</strong><p>&nbsp;</p>"
      + "<strong>- Organisation / animations commerciales / réglementation</strong><p>&nbsp;</p>"
      + "<strong>- Informations Produits et Fournisseurs</strong><p>&nbsp;</p>"
      + "<strong>- Compte-rendu de formation (le cas échéant)</strong><p>&nbsp;</p>";
    $scope.REUNION = REUNION;
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope.permissions = PERMISSIONS;
    $scope.hourEvents = SELECT_HOURS_EVENTS;
    $scope.STATUSES_MALFUNCTION = STATUSES_MALFUNCTION;
    $scope._recurrences = angular.copy(GENERAL_TASK_PERIOD);
    $scope.chartOptions = {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }

    $scope.tabs = {
      one: 'one',
      two: 'two',
      three: 'three'
    }

    $scope.tabActive = 'one'

    $scope.step1Form = {}
    $scope.step2Form = {}
    $scope.step3Form = {}


    // Variables

    $scope.refreshRubriquesSelected = function () {
      $scope._rubriquesSelected = []
      for (var i = 0; i < $scope._rubriques.length; i++) {
        $scope._rubriques[i].index = i
        if ($scope._rubriques[i].elements.length > 0) {
          $scope._rubriquesSelected.push($scope._rubriques[i].type)
        }
      }
    }

    $scope._initRubrique = function () {
      $scope._rubriques = []
      var rubriquesTypesPush = []
      var rubriques = angular.copy($scope.REUNION.ORDRES_DU_JOUR.RUBRIQUES);
      var rubriquesLibelle = rubriques.map(function (rubrique) {
        return rubrique.type
      })
      angular.forEach(rubriques, function (_rItem, _rIndex) {
        _rItem.page = {
          page: 0,
          output: 10,
          noMoreData: false,
          filter: null,
          sort: null
        };
        _rItem.elements = [];
      });
      for (var i = 0; i < $scope._thisReunion.ordreDuJour.elements.length; i++) {
        var element = $scope._thisReunion.ordreDuJour.elements[i]
        var indexOf = rubriquesLibelle.lastIndexOf(element.type)
        var mesEvalIndexOf = rubriquesLibelle.lastIndexOf('MES_EVALUATIONS')
        if (['NOTE_ODJ'].lastIndexOf(element.type) > -1) {
          $scope.hasOdjRubrique = true
        }
        if (['AUTO_EVALUATION', 'RAPPORT_D_AUDIT', 'SATISFACTION_CLIENT', 'FLASH_QUALITE'].lastIndexOf(element.type) > -1 && mesEvalIndexOf > -1 && rubriquesTypesPush.lastIndexOf(rubriques[mesEvalIndexOf].type) === -1) {
          $scope._rubriques.push(rubriques[mesEvalIndexOf])
          rubriquesTypesPush.push('MES_EVALUATIONS')
        } else if (indexOf > -1 && rubriquesTypesPush.lastIndexOf(rubriques[indexOf].type) === -1) {
          $scope._rubriques.push(rubriques[indexOf])
          rubriquesTypesPush.push(rubriques[indexOf].type)
        }
      }
      angular.forEach($scope._rubriques, function (_rItem, _rIndex) {
        _rItem.index = _rIndex
      });
    };



    $scope.cantUpdate = true;

    // check permissions to know if user can update ordre du jour
    UserService.getUserRoles().then(function (res) {
      if (res.data.includes('TITULAIRE') || res.data.includes('PRAQ')) {
        $scope.cantUpdate = false;
      }
    }).catch(function (err) {
      toastr.success('Erreur: impossible de récupérer vos droits');
    });

    // api

    $scope.api = api;

    // Helpers

    $scope._getHours = function (_date) {
      return _date.getHours();
    };

    $scope._setHours = function (_date, _hours) {
      _date.setHours(_hours);
    };

    $scope._getMinutes = function (_date) {
      return _date.getMinutes();
    };

    $scope._setMinutes = function (_date, _minutes) {
      _date.setMinutes(_minutes);
    };

    $scope._everyElements = function (_elements) {
      return _elements.every(function (_element) {
        return _element.selected;
      })
    };

    $scope._anyElement = function (_elements) {
      return _elements.find(function (_element) {
        return _element.selected;
      });
    };


    // Variables

    // Entry point

    $scope.init = function () {
      ReunionService.findReunion($state.params.id).then(function (response) {
        $scope.hasOdjRubrique = false;
        $scope.indicateursFilter = []
        $scope._actionsDecidees = []
        $scope._thisReunion = response.data;
        if (response.data.ordreDuJour.note == null) {
          $scope._thisReunion.ordreDuJour.note = '';
        }
        if ($scope._thisReunion.statut == 'Finaliser le compte-rendu' || $scope._thisReunion.archived) {
          if ($scope._thisReunion.noteCompteRendu == null && $scope._thisReunion.ordreDuJour && $scope._thisReunion.ordreDuJour.note) {
            $scope._thisReunion.noteCompteRendu = angular.copy($scope._thisReunion.ordreDuJour.note);
          }
          var presencesIds = $scope._thisReunion.presences.map(function (collaborateur) { return collaborateur.id })
          EquipeDetailService.getCollaborateurs().then(function (data) {
            $scope._users = data;
            for (var i = 0; i < $scope._users.length; i++) {
              var user = $scope._users[i]
              if (presencesIds.lastIndexOf(user.id) > -1) {
                user.selected = true
              }
            }
          }).catch(function (response) {

          });
          $scope._thisReunion.realisee = true;
          angular.forEach($scope._thisReunion.ordreDuJour.actionsDecidees, function (_adItem, _adIndex) {
            _adItem.categoryLibelle = "Action décidée / Réunion d'équipe";
            $scope._actionsDecidees.push(_adItem);
          });
          $scope.tabActive = 'three'
        } else if ($state.params.subTab) {
          $scope.tabActive = angular.copy($state.params.subTab)
          $state.go(
            $state.current.name,
            { subTab: null },
            {
              notify: false,
              location: 'replace',
              reload: false
            }
          );
        } else {
          $scope.tabActive = 'two'
        }
        var start = new Date($scope._thisReunion.dateStart);
        var startHours = start.getHours() * 60 * 60 * 1000 + start.getMinutes() * 60 * 1000;
        $scope._thisReunion.hourSelect = startHours;
        if ($scope._thisReunion.ordreDuJour != null) {
          if ($scope._thisReunion.ordreDuJour.rubriques.length > 0) {
            $scope._rubriques = $scope._thisReunion.ordreDuJour.rubriques.map(function (rubrique, index) {
              var libelle = ''
              switch (rubrique.type) {
                case 'DYSFONCTIONNEMENT':
                  libelle = $scope.libelles.malfunctions
                  break
                case 'PROGRESS_FORM':
                  libelle = $scope.libelles.progressForms
                  break
                case 'DOCUMENT_MODIFIE':
                  libelle = $scope.libelles.documents
                  break
                case 'TACHE_ET_EVENEMENT_PLANIFIE':
                  libelle = $scope.libelles.tasks
                  break
                case 'DERNIERE_ACTION_DECIDEE':
                  libelle = $scope.libelles.actions
                  break
                case 'INDICATEUR_DU_TABLEAU_DE_BORD':
                  libelle = $scope.libelles.indicateurs
                  break
                case 'MES_EVALUATIONS':
                  libelle = $scope.libelles.evaluations
                  break
                case 'TEXT':
                  if (rubrique.libelle != null) {
                    libelle = rubrique.libelle
                  } else {
                    libelle = 'Zone de texte'
                  }
                  break
                case 'NOTE_ODJ':
                  libelle = $scope.libelles.noteOdj
                  $scope.hasOdjRubrique = true
                  break
                default:
                  break
              }
              return {
                id: rubrique.id,
                type: rubrique.type,
                libelle: libelle,
                index: index,
                comment: rubrique.comment,
                elements: []
              }
            })
          } else {
            $scope._initRubrique();
          }
          for (var i = 0; i < $scope._thisReunion.ordreDuJour.elements.length; i++) {
            var element = $scope._thisReunion.ordreDuJour.elements[i]

            if (element.type === 'INDICATEUR_DU_TABLEAU_DE_BORD') {
              $scope.addElementToRubrique(element.type, element)
              var year = element.date
              if (year == null) {
                year = new Date($scope._thisReunion.dateStart).getFullYear()
              }
              $scope.indicateursFilter.push({ id: element.associationId, year: year })
            } else if (element.type === 'TEXT') {
              $scope.addElementToRubrique(element.type, element, element.rubriqueTextId)
            } else {
              $scope.addElementToRubrique(element.type, element)
            }
          }
          $scope.sortRubriquesEl()
          $scope.refreshRubriquesSelected()
          $scope.refreshIndicateurs()
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

    if (angular.isUndefined($state.params.id) || $state.params.id == null) {
      $scope._history();
      toastr.error("Une erreur s'est produite, veuillez réessayer plus tard.");
    } else {
      $scope.init();
    }

    $scope.refreshIndicateurs = function () {
      TableauDeBordService.findByIdsAndYear($scope.indicateursFilter).then(function (res) {
        $scope.indicateurs = res.data
      }).catch(function () {

      })
    }

    $scope.sortRubriquesEl = function () {
      for (var i = 0; i < $scope._rubriques.length; i++) {
        var rubrique = $scope._rubriques[i]
        if (['DYSFONCTIONNEMENT', 'PROGRESS_FORM', 'DOCUMENT_MODIFIE'].includes(rubrique.type)) {
          rubrique.elements.sort((a, b) => b.date - a.date)
        } else if (['TACHE_ET_EVENEMENT_PLANIFIE', 'DERNIERE_ACTION_DECIDEE'].includes(rubrique.type)) {
          rubrique.elements.sort((a, b) => b.echeance - a.echeance)
        }
      }
    }

    $scope.addElementToRubrique = function (type, element, rubriqueTextId) {
      for (var i = 0; i < $scope._rubriques.length; i++) {
        var rubrique = $scope._rubriques[i]
        if (rubrique.type === 'MES_EVALUATIONS') {
          if (['AUTO_EVALUATION', 'RAPPORT_D_AUDIT', 'SATISFACTION_CLIENT', 'FLASH_QUALITE'].lastIndexOf(type) > -1) {
            rubrique.elements.push(element)
          }
        } else if (rubrique.type === 'TEXT' && rubrique.id == rubriqueTextId) {
          rubrique.elements.push(element)
        } else if (rubrique.type != 'TEXT' && rubrique.type === type) {
          rubrique.elements.push(element)
        }
      }
    }

    $scope.findElementsFromRubrique = function (type) {
      var elements = []
      for (var i = 0; i < $scope._rubriques.length; i++) {
        var rubrique = $scope._rubriques[i]
        if (rubrique.type === type) {
          elements = rubrique.elements
        }
      }
      return elements
    }

    // Close dialog

    $scope._closeDialog = $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    // Ordre du jour

    $scope._rubriqueDetails = function (_rubrique) {
      _rubrique.showElements = !_rubrique.showElements
      angular.forEach($scope._rubriques, function (_rItem, _rIndex) {
        if (_rItem.type != _rubrique.type) {
          _rItem.showElements = false;
        }
      });
    };


    $scope._addToNextReunion = function (status) {
      $scope.elementToHandle.aAjouterALaProchaineReunion = status;
    }

    $scope._elementDetails = function (rubriqueType, elementAssociationId) {
      if (rubriqueType === "RAPPORT_D_AUDIT") {
        $scope.odjMode = true;
        AuditService.findById(elementAssociationId).then(function (data) {
          $scope.auditToDisplay = data;
          $mdDialog.show({
            templateUrl: 'app/main/front/qualite/audit/popup/display_audit.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            scope: $scope,
            preserveScope: true
          });
        }).catch(function (err) {
          console.log(err);
        });
      }
      else if (rubriqueType === "INDICATEUR_DU_TABLEAU_DE_BORD") {
        TableauDeBordService.getIndicateur(elementAssociationId, true).then(function (response) {
          $scope.generateGraph(response);
        }).catch(function (error) {
          console.log(error);
        });
      }
      else {
        $mdDialog.show({
          templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/elementDetails.dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        });
        ReunionService.elementAssociationDetails(rubriqueType, elementAssociationId).then(function (response) {
          $scope._element = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    };

    $scope.generateGraph = function (indicateur) {
      $scope.graphs = [indicateur];
      $scope.graphs[0].generate = true;
      $scope.generateGraphs();
    };

    $scope.generateGraphs = function () {
      $scope.generate();
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/indicator_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope._saveInfos = function () {
      $scope._thisReunion.dateStart.setHours(0, 0, 0, 0);
      ReunionService.save($scope._thisReunion).then(function (response) {
        toastr.success('Sauvegardé avec succès.');
        api._history()

      }).catch(function (error) {
      });
    }

    $scope._saveOrdreDuJour = function (goBack) {
      ReunionService.saveOrdreDuJour($scope._thisReunion, $scope._rubriques).then(function (response) {
        if (goBack) {
          toastr.success('Sauvegardé avec succès.');
          api._history()
        }
      }).catch(function (error) {
        console.log(error);
      });
    };

    // Action ordre du jour

    $scope._imprimerOrdreDuJourPourLEquipe = function () {
      ReunionService.saveOrdreDuJour($scope._thisReunion, $scope._rubriques).then(function (response) {
        $scope.init();
        DocGenerationService.generateDocumentTypeWithId("ORDRE_DU_JR_PROCHAINE_REUNION", $scope._thisReunion.id).then(function (response) { }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._imprimerMonSupportDetaile = function () {
      ReunionService.saveOrdreDuJour($scope._thisReunion, $scope._rubriques).then(function (response) {
        $scope.init();
        DocGenerationService.generateDocumentTypeWithId("ORDRE_DU_JR_DETAILLE_PROCHAINE_REUNION", $scope._thisReunion.id).then(function (response) { }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    };

    // Passage compte rendu

    $scope._reunionRealisee = function () {
      ReunionService.reunionRealisee($scope._thisReunion.id).then(function (response) {
        $scope._thisReunion.statut = response.data;
        // if ($scope._thisReunion.statut == 'Finaliser le compte-rendu') {
        //   $timeout(function () {
        //     document.getElementById('_WriteReportBtnContainer').scrollIntoView(true);
        //   });
        // }
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._redigerCompteRendu = function () {
      ReunionService.reunionRealisee($scope._thisReunion.id).then(function (response) {
        $scope._thisReunion.statut = response.data;
        $scope._thisReunion.realisee = true;
        ReunionService.saveOrdreDuJour($scope._thisReunion, $scope._rubriques).then(function (response) {
          $scope.tabActive = $scope.tabs.three
          $mdDialog.hide()
          $scope.init();
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.graphsDisplayed = [];

    $scope.generate = function () {
      $scope.graphsDisplayed = [];
      for (var i = 0; i < $scope.graphs.length; i++) {
        if ($scope.graphs[i].generate) {
          var graph;
          if ($scope.graphs[i].period == "MONTHLY") {
            var indicateurs = $filter('orderBy')($scope.graphs[i].dataIndicateurs, 'index');
            var months = ['jan', 'fev', 'mars', 'avr', 'mai', 'juin', 'juil', 'aout', 'sept', 'oct', 'nov', 'dec'];
            var labels = $filter('orderBy')(indicateurs, 'year').map(function (dataIndic) {
              return months[dataIndic.index];
            });

            graph = {
              series: ['indicateur'],
              labels: labels,
              data: [],
              title: $scope.graphs[i].title
            };

            for (var y = 0; y < indicateurs.length; y++) {
              if (indicateurs[y].value != null) {
                graph.data.push(indicateurs[y].value);
              } else {
                graph.data.push(0);
              }
            }
          }
          else if ($scope.graphs[i].period == "QUARTERLY") {
            var indicateurs = $filter('orderBy')($scope.graphs[i].dataIndicateurs, 'index');
            var semesters = ['semestre 1', 'semestre 2', 'semestre 3', 'semestre 4'];
            var labels = $filter('orderBy')(indicateurs, 'year').map(function (dataIndic) {
              return semesters[dataIndic.index];
            });
            graph = {
              series: ['indicateur'],
              labels: labels,
              data: [],
              title: $scope.graphs[i].title
            };
            for (var y = 0; y < indicateurs.length; y++) {
              if (indicateurs[y].value != null) {
                graph.data.push(indicateurs[y].value);
              } else {
                graph.data.push(0);
              }
            }
          }
          else if ($scope.graphs[i].period == "ANNUAL") {
            $scope.graphs[i].dataIndicateurs = $filter('orderBy')($scope.graphs[i].dataIndicateurs, 'year');
            var dataIndicateurs = $scope.graphs[i].dataIndicateurs;
            var labels = dataIndicateurs[1] != null ? [dataIndicateurs[0].year, dataIndicateurs[1].year] : [dataIndicateurs[0].year];
            var values = dataIndicateurs[1] != null ? [dataIndicateurs[0].value, dataIndicateurs[1].value] : [dataIndicateurs[0].value];
            var title = dataIndicateurs[1] != null ? ($scope.graphs[i].title + ' (' + $scope.graphs[i].dataIndicateurs[0].year
              + '-' + $scope.graphs[i].dataIndicateurs[1].year + ')') : $scope.graphs[i].title + ' (' + $scope.graphs[i].dataIndicateurs[0].year;
            graph = {
              series: ['indicateur'],
              labels: labels,
              data: values,
              title: title
            };
          }

          $scope.graphsDisplayed.push(graph);
        }
      }
    }

    $scope.downloadSinglePDF = function (graph, index) {
      var pdf = new jsPDF();
      pdf.setFontSize(22);

      var img = document.getElementById("chart" + index)
      var data = img.toDataURL("image/png", 1.0);

      pdf.text(20, 20, graph.title);
      pdf.addImage(data, 'PNG', 15, 40, 180, 90);

      pdf.save("graphique_" + graph.title + ".pdf");
    }

    $scope.downloadPDF = function () {
      var pdf = new jsPDF();
      pdf.setFontSize(22);

      for (var i = 0; i < $scope.graphsDisplayed.length; i++) {
        if (i != 0) {
          pdf.addPage();
        }

        var img = document.getElementById("chart" + i)
        var data = img.toDataURL("image/png", 1.0);

        pdf.text(20, 20, $scope.graphsDisplayed[i].title);
        pdf.addImage(data, 'PNG', 15, 40, 180, 90);
      }

      pdf.save("graphiques_indicateurs.pdf");
    }

    $scope.addToRubrique = function (type, libelle, row) {
      if (type === 'TEXT') {
        $scope._rubriques.push({
          libelle: libelle,
          type: type,
          index: $scope._rubriques.length,
          elements: [row]
        })
      } else {
        if ($scope._rubriques.map(function (rubrique) { return rubrique.type }).lastIndexOf(type) === -1) {
          $scope._rubriques.push({
            libelle: libelle,
            type: type,
            index: $scope._rubriques.length,
            elements: []
          })
        }
        for (var i = 0; i < $scope._rubriques.length; i++) {
          if ($scope._rubriques[i].type === type) {
            $scope._rubriques[i].elements.push(row)
          }
        }
      }
    }

    $scope.up = function (index) {
      var rubriqueToUp = angular.copy($scope._rubriques[index])
      rubriqueToUp.index = rubriqueToUp.index - 1
      var rubriqueToDown = angular.copy($scope._rubriques[index - 1])
      rubriqueToDown.index = rubriqueToDown.index + 1
      $scope._rubriques[index] = rubriqueToDown
      $scope._rubriques[index - 1] = rubriqueToUp
    }

    $scope.down = function (index) {
      var rubriqueToUp = angular.copy($scope._rubriques[index + 1])
      rubriqueToUp.index = rubriqueToUp.index - 1
      var rubriqueToDown = angular.copy($scope._rubriques[index])
      rubriqueToDown.index = rubriqueToDown.index + 1
      $scope._rubriques[index] = rubriqueToUp
      $scope._rubriques[index + 1] = rubriqueToDown
    }

    $scope.deleteRubrique = function (index) {
      if ($scope._rubriques[index].type === 'INDICATEUR_DU_TABLEAU_DE_BORD') {
        $scope.indicateursFilter = []
      }
      $scope._rubriques.splice(index, 1)
      $scope.refreshRubriquesSelected()
    }

    $scope.$on('resultsadded', function (event, data) {
      for (var i = 0; i < data.selected.length; i++) {
        var row = data.selected[i]
        if (data.type === 'MALFUNCTION') {
          $scope.addToRubrique('DYSFONCTIONNEMENT', $scope.libelles.malfunctions, {
            libelle: row.title,
            associationId: row.id,
            collaborateur: row.collaborateur,
            date: row.creation,
            type: 'DYSFONCTIONNEMENT',
            selected: true
          })
        } else if (data.type === 'PROGRESS_FORM') {
          $scope.addToRubrique('PROGRESS_FORM', $scope.libelles.progressForms, {
            libelle: row.title,
            associationId: row.id,
            collaborateur: row.collaborateur,
            date: row.creation,
            type: 'PROGRESS_FORM',
            selected: true
          })
        } else if (data.type === 'DOC') {
          $scope.addToRubrique('DOCUMENT_MODIFIE', $scope.libelles.documents, {
            libelle: row.name,
            associationId: row.id,
            date: row.uploadDate,
            type: 'DOCUMENT_MODIFIE',
            selected: true
          })
        } else if (data.type === 'MES_EVALUATIONS') {
          $scope.addToRubrique('MES_EVALUATIONS', $scope.libelles.evaluations, {
            libelle: row.name,
            associationId: row.id,
            date: row.uploadDate,
            type: row.type,
            selected: true
          })
        } else if (data.type === 'TACHE_ET_EVENEMENT_PLANIFIE') {
          $scope.addToRubrique('TACHE_ET_EVENEMENT_PLANIFIE', $scope.libelles.tasks, {
            libelle: row.title,
            associationId: row.id,
            collaborateur: row.responsable,
            date: row.echeance,
            type: 'TACHE_ET_EVENEMENT_PLANIFIE',
            selected: true
          })
        } else if (data.type === 'INDICATEUR_DU_TABLEAU_DE_BORD') {
          $scope.addToRubrique('INDICATEUR_DU_TABLEAU_DE_BORD', $scope.libelles.indicateurs, {
            libelle: row.title,
            associationId: row.id,
            date: row.year,
            type: 'INDICATEUR_DU_TABLEAU_DE_BORD',
            selected: true
          })
          $scope.indicateursFilter.push({ id: row.id, year: row.year })
          $scope.refreshIndicateurs()
        }
      }
      $scope.refreshRubriquesSelected()
      $scope.sortRubriquesEl()
      setTimeout(() => {
        var elements = document.getElementsByClassName('iv-Tabs-item-list-item');
        var element = elements[elements.length - 1];
        element.scrollIntoView()
      })
    })

    // V3
    $scope.popUpDysfonctionnements = function (elements) {
      $scope.dysfonctionnementPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/joindreDys_popup.html',
        parent: angular.element(document.body),
        controller: "JoindreDysController",
        multiple: true,
        locals: {
          reunionMode: true,
          index: null,
          excludeIds: elements ? elements.map(function (el) { return el.associationId }) : []
        }
      });
    };
    $scope.popUpFicheDeProgres = function (elements) {
      $scope.ficheDeProgresPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/joindreFDP_popup.html',
        parent: angular.element(document.body),
        controller: "JoindreFDPController",
        multiple: true,
        locals: {
          reunionMode: true,
          index: null,
          excludeIds: elements ? elements.map(function (el) { return el.associationId }) : []
        }
      });
    };
    $scope.popUpDocument = function (elements) {
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/joindreDoc_popup.html',
        parent: angular.element(document.body),
        controller: 'JoindreDocController',
        locals: {
          index: null,
          excludeIds: elements ? elements.filter(el => el.associationId).map(function (el) { return el.associationId }) : []
        }
      });
    };
    $scope.popUpPlanning = function (elements) {
      $scope.planningPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/select_tachesPlanning.html',
        parent: angular.element(document.body),
        controller: 'SelectTachesPlanningController',
        locals: {
          index: null,
          excludeIds: elements ? elements.map(function (el) { return el.associationId }) : []
        }
      });
    };
    $scope.popUpTDB = function (elements) {
      console.log(elements)
      $scope.TDBPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/select_tableauDeBord.html',
        parent: angular.element(document.body),
        controller: 'SelectTableauDeBordController',
        locals: {
          index: null,
          exclude: elements ? elements.map(function (el) { return { id: el.associationId, year: el.date } }) : []
        }
      });
    };
    $scope.popUpEvaluation = function (elements) {
      $scope.TDBPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/joindreMesEval_popup.html',
        parent: angular.element(document.body),
        controller: 'JoindreMesEvalController',
        locals: {
          index: null,
          elements: elements ? elements : []
        }
      });
    };

    $scope.previousStep = function () {
      if ($scope.tabActive === $scope.tabs.two) {
        $scope.step2Form.$setSubmitted()
        if ($scope.step2Form.$valid) {
          $scope._saveOrdreDuJour(false)
          $scope.tabActive = $scope.tabs.one
        }
      }
    }

    $scope.nextStep = function () {
      if ($scope.tabActive === $scope.tabs.one) {
        $scope.step1Form.$setSubmitted()
        if ($scope.step1Form.$valid) {
          $scope._thisReunion.dateStart.setHours(0, 0, 0, 0);
          ReunionService.save($scope._thisReunion).then(function (response) {
            $scope.tabActive = $scope.tabs.two
            $mdDialog.hide()
          }).catch(function (error) {
            toastr.error('Une erreur est survenue')
          });
        }
      } else if ($scope.tabActive === $scope.tabs.two) {
        $scope.popUpODJNext()
      }
    }

    $scope.popUpODJNext = function () {
      $scope.ODJPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/confirm_odj.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };
    $scope.popUpODJSubmit = function () {
      $scope.ODJPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/submit_odj.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.removeElement = function (index, parentIndex) {
      $scope._rubriques[parentIndex].elements.splice(index, 1)
      $scope.refreshRubriquesSelected()
    }

    $scope.showElement = function (element, type) {
      if (type === 'DYSFONCTIONNEMENT') {
        MalfunctionService.find(element.associationId).then(function (res) {
          $mdDialog.show({
            templateUrl: 'app/main/front/home/popup/apercu_popup.html',
            parent: angular.element(document.body),
            controller: 'ApercuController',
            multiple: true,
            locals: {
              pj: {
                type: 'MALFUNCTION',
                malfunction: res.data
              },
              info: null
            }
          });
        }).catch(function () {

        })
      } else if (type === 'PROGRESS_FORM') {
        FicheProgresService.find(element.associationId).then(function (res) {
          $mdDialog.show({
            templateUrl: 'app/main/front/home/popup/apercu_popup.html',
            parent: angular.element(document.body),
            controller: 'ApercuController',
            multiple: true,
            locals: {
              pj: {
                type: 'PROGRESS_FORM',
                progressForm: res.data
              },
              info: null
            }
          });
        }).catch(function () {

        })
      } else if (type === 'MES_EVALUATIONS') {
        if (element.type === 'FLASH_QUALITE') {
          AutoControlesService.getFlashDataById(element.associationId).then(function (res) {
            $scope.openMesEvalDialog(res, element.type)
          }).catch(function () {

          })
        } else if (element.type === 'RAPPORT_D_AUDIT') {
          AuditService.findById(element.associationId).then(function (res) {
            $scope.openMesEvalDialog(res, element.type)
          }).catch(function () {

          })
        } else if (element.type === 'SATISFACTION_CLIENT') {
          SatisfactionService.findById(element.associationId).then(function (res) {
            $scope.openMesEvalDialog(res.data, element.type)
          }).catch(function () {

          })
        } else if (element.type === 'AUTO_EVALUATION') {
          AutoEvaluationService.findById(element.associationId).then(function (res) {
            $scope.openMesEvalDialog(res.data, element.type)
          }).catch(function () {

          })
        }
      } else if (type === 'TACHE_ET_EVENEMENT_PLANIFIE' || type === 'DERNIERE_ACTION_DECIDEE') {
        $scope.openTaskDialog(element)
      } else if (type === 'INDICATEUR_DU_TABLEAU_DE_BORD') {
        $scope.openIndicateurDialog(element)
      } else if (type === 'ACTION_DECIDEE') {
        var el = { associationId: element.id }
        $scope.openTaskDialog(el)
      }
    }

    $scope.openIndicateurDialog = function (row) {
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/popup/apercu_indicateur_popup.html',
        parent: angular.element(document.body),
        controller: 'ApercuIndicateurController',
        multiple: true,
        locals: {
          indicateurId: row.id,
          year: row.dataIndicateurs[0].year
        }
      });
    }

    $scope.openMesEvalDialog = function (data, type) {
      $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/apercu_popup.html',
        parent: angular.element(document.body),
        controller: 'ApercuController',
        multiple: true,
        locals: {
          pj: {
            type: 'MES_EVALUATIONS',
            monEval: { type: type, data: data }
          },
          info: null
        }
      });
    }

    $scope.openTaskDialog = function (row) {
      TachesGeneralesService.findById(row.associationId).then(function (res) {

        var parentEl = angular.element(document.body);
        $mdDialog.show({
          parent: parentEl,
          clickOutsideToClose: true,
          multiple: true,
          templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
          locals: {
            type: "AUTRE",
            datasource: {
              task: res.data,
              echeance: new Date(res.data.echeance)
            }
          },
          controller: "DialogController"
        }).then(function (param) {
          if (param) {
            if (row.type != null) {
              // tache qui n'est pas dans action décidée
              ReunionService.elementAssociationDetails(row.type, row.associationId).then(function (res) {
                for (var i = 0; i < $scope._rubriques.length; i++) {
                  if ($scope._rubriques[i].type === 'TACHE_ET_EVENEMENT_PLANIFIE') {
                    for (var j = 0; j < $scope._rubriques[i].elements.length; j++) {
                      if ($scope._rubriques[i].elements[j].id === row.id) {
                        res.data.selected = true
                        res.data.associationId = row.associationId
                        res.data.type = 'TACHE_ET_EVENEMENT_PLANIFIE'
                        $scope._rubriques[i].elements[j] = res.data
                        break;
                      }
                    }
                    break;
                  }
                }
              })
            } else {
              $scope.init()
            }
          }
        }).catch(function () {
        });
      }).catch(function () {

      })

    }

    $scope.addTextRubrique = function () {
      $scope.addToRubrique('TEXT', $scope.libelles.text, {
        type: 'TEXT',
        selected: true
      })
      $scope.refreshRubriquesSelected()
    }

    $scope.download = function (element, type) {
      if (type === 'DOCUMENT_MODIFIE') {
        if (element.associationId) {
          $window.location.href = DocumentService.getDownloadLink(element.associationId);
        } else {
          $window.location.href = ReunionService.getDownloadLink(element.id);
        }
      } else if (element.type === 'AUTO_EVALUATION') {
        $window.location.href = AutoEvaluationService.getDownloadLink(element.associationId);
      } else if (element.type === 'SATISFACTION_CLIENT') {
        $window.location.href = SatisfactionService.getDownloadLink(element.associationId);
      } else if (element.type === 'RAPPORT_D_AUDIT') {
        $window.location.href = AuditService.getDownloadLink(element.associationId);
      }
    }

    $scope.openPDF = function (element) {
      if (element.associationId) {
        FolderService.getPDF(element.associationId).then(function (res) {
          var file = new Blob([res.data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        ReunionService.getPDF(element.id).then(function (res) {
          var file = new Blob([res.data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch(function (err) {
          console.log(err);
        });
      }
    };

    $scope.exportIndicateur = function (element) {
      TableauDeBordService.findByIdAndYear(element.id, element.dataIndicateurs[0].year, $rootScope.user.isTeam).then(function (res) {
        $scope.generateGraph(res.data)
      }).catch(function () {
        toastr.error('Une erreur est survenue')
      })
    }

    $scope._planifierUneAction = function () {
      $scope.addCollaborateurMode = false;
      $scope._today = new Date();
      $scope.minDateEcheance = angular.copy($scope._today);
      $scope.maxDateEcheance = angular.copy($scope.minDateEcheance);
      $scope.maxDateEcheance.setFullYear();
      $scope.maxDateEcheance.setFullYear($scope._today.getFullYear() + 20);
      $scope._categories = GENERAL_TASK_TYPES;
      $scope.fromReunionCompteRendu = true;
      $scope._task = {};
      for (var i = 0; i < $scope._categories.length; i++) {
        if ($scope._categories[i].value === 'ACTION_DECIDEE_REVUE_EQUIPE') {
          $scope._task.category = $scope._categories[i].value;
        }
      }
      $scope._recurrences = GENERAL_TASK_PERIOD;
      showTaskModal();
    };

    $scope._saveCompteRendu = function (fromTask) {
      var reunion = angular.copy($scope._thisReunion)
      reunion.presences = []
      reunion.absences = []
      for (var i = 0; i < $scope._users.length; i++) {
        if ($scope._users[i].selected) {
          reunion.presences.push($scope._users[i])
        } else {
          reunion.absences.push($scope._users[i])
        }
      }
      reunion.dateStart = new Date(reunion.dateStart).getTime()
      reunion.dateEnd = new Date(reunion.dateEnd).getTime()
      ReunionService.saveCompteRendu(reunion, $scope._rubriques).then(function (response) {
        if (fromTask) {
        } else {
          toastr.success('Sauvegardé avec succès.');
          $state.go('app.equipe.reunions');
        }
      }).catch(function (error) {
        console.log(error);
      });

    };

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "CRR",
          datasource: {
            task: $scope._task,
          },
        },
        controller: "DialogController"
      }).then(function (param) {
        param.categoryLibelle = "Action décidée / Réunion d'équipe";
        $scope._thisReunion.ordreDuJour.actionsDecidees.push(param);
        $scope._actionsDecidees.push(param);
        $scope._saveCompteRendu(true)
      }).catch(function () {

      });
    }

    $scope._actionDecideeFaite = function (_actionDecidee) {
      TachesGeneralesService.done(_actionDecidee.id).then(function (response) { }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._cloturerEtArchiverReunion = function () {
      if ($rootScope.user.isTeam) {
        $scope._saveCompteRendu()
      } else {
        var reunion = angular.copy($scope._thisReunion)
        reunion.presences = []
        reunion.absences = []
        for (var i = 0; i < $scope._users.length; i++) {
          if ($scope._users[i].selected) {
            reunion.presences.push($scope._users[i])
          } else {
            reunion.absences.push($scope._users[i])
          }
        }
        reunion.dateStart = new Date(reunion.dateStart).getTime()
        reunion.dateEnd = new Date(reunion.dateEnd).getTime()
        ReunionService.cloturerEtArchiverReunion(reunion, $scope._rubriques).then(function (response) {
          toastr.success('Sauvegardé avec succès.');
          $state.go('app.equipe.reunions.compte-rendu', {
            id: reunion.id,
            toHome: true
          });
          $rootScope.$broadcast('refreshCountNotifs');
        }).catch(function (error) {
          console.log(error);
        });
      }
    };

    $scope.printUsers = function (users) {
      var res = ''
      if (users != null) {
        for (var i = 0; i < users.length; i++) {
          res += users[i].surname + ' ' + users[i].name
          if (i < users.length - 1) {
            res += ' / '
          }
        }
      }
      return res
    }

    $scope._imprimerCompteRenduFinaliser = function () {
      DocGenerationService.generateDocumentTypeWithId("COMPTE_RENDU_DERNIERE_REUNION", $scope._thisReunion.id).then(function (response) { }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.openToInformation = function () {
      $mdDialog.show({
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/reunions/compte-rendu/popup/to_information_popup.html',
        scope: $scope,
        preserveScope: true
      }).then(function (param) {
      }).catch(function () {

      });
    }

    $scope.toInformation = function () {
      $state.go('app.home', { reunionId: $scope._thisReunion.id })
    }

    if ($state.params.toHome) {
      $location.search('toHome', null)
      $scope.openToInformation()
    }

    $scope.goToStep = function (tab) {
      if ($scope.tabActive != $scope.tabs.three) {
        $scope.tabActive = tab
        if ($scope.tabActive === $scope.tabs.one) {
          $scope.step1Form.$setSubmitted()
          if ($scope.step1Form.$valid) {
            $scope._thisReunion.dateStart.setHours(0, 0, 0, 0);
            ReunionService.save($scope._thisReunion).then(function (response) {
            }).catch(function (error) {
              toastr.error('Une erreur est survenue')
            });
          }
        } else {
          $scope._saveOrdreDuJour(false)
        }
      }
    }
    $scope.goBackFromCR = function () {
      $state.go('app.equipe.reunions', { tab: 'history' })
    }

    $scope.removeIndicateur = function (indicateurId, year) {
      for (var i = $scope.indicateursFilter.length - 1; i >= 0; i--) {
        if ($scope.indicateursFilter[i].id === indicateurId
          && $scope.indicateursFilter[i].year === year) {
          $scope.indicateursFilter.splice(i, 1)
          break
        }
      }
      $scope.refreshIndicateurs()
    }
    $scope.test = null
    $scope.openJoindreFile = function () {

      $('#add_info_file').off('change')
      $('#add_info_file').on('change', function (evt) {
        if (evt.target.files.length > 0) {
          var reader = new FileReader();
          reader.onload = function (e) {
            $scope.addToRubrique('DOCUMENT_MODIFIE', $scope.libelles.documents, {
              libelle: evt.target.files[0].name,
              file: new Blob([e.target.result]),
              date: new Date().getTime(),
              type: 'DOCUMENT_MODIFIE',
              selected: true
            })
            $('#add_info_file').val('')
            $scope.refreshRubriquesSelected()
            var elements = document.getElementsByClassName('iv-Tabs-item-list-item');
            if (elements && elements.length > 0) {
              var element = elements[elements.length - 1];
              element.scrollIntoView()
            }
            $scope.$apply()
          };
          reader.readAsArrayBuffer(evt.target.files[0]);
        }
      })
      $('#add_info_file').click()
    }
  };

})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('CompteRenduController', CompteRenduController);

  function CompteRenduController($scope, $timeout, $state, $mdDialog, toastr, api, ReunionService, EquipeDetailService, TachesGeneralesService, FicheProgresService,
    DocGenerationService, REUNION, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD, TASKS_EVENTS_REMINDERS, UserService, PERMISSIONS) {


    $scope.sortRubriquesEl = function () {
      for (var i = 0; i < $scope._rubriques.length; i++) {
        var rubrique = $scope._rubriques[i]
        if (['DYSFONCTIONNEMENT', 'PROGRESS_FORM', 'DOCUMENT_MODIFIE'].includes(rubrique.type)) {
          rubrique.elements.sort((a, b) => b.date - a.date)
        } else if (['TACHE_ET_EVENEMENT_PLANIFIE', 'DERNIERE_ACTION_DECIDEE'].includes(rubrique.type)) {
          rubrique.elements.sort((a, b) => b.echeance - a.echeance)
        }
      }
    }

    // Constants

    $scope.REUNION = REUNION;
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope._rubriques = angular.copy($scope.REUNION.ORDRES_DU_JOUR.RUBRIQUES);
    $scope.sortRubriquesEl();
    $scope.permissions = PERMISSIONS;

    // Variables
    $scope.today = new Date();
    $scope._fichesDeProgres = [];
    $scope._actionsDecidees = [];
    $scope.cantUpdate = true;
    $scope.intoSaving = false;

    // check permissions to know if user can update ordre du jour
    UserService.getUserRoles().then(function (res) {
      if (res.data.includes('TITULAIRE') || res.data.includes('PRAQ')) {
        $scope.cantUpdate = false;
      }
    }).catch(function (err) {
      toastr.success('Erreur: impossible de récupérer vos droits');
    });

    // helpers

    $scope._goToReunionsList = function () {
      $state.go('app.equipe.reunions');
    };

    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    // Entry point

    if (angular.isUndefined($state.params.id) || $state.params.id == null) {
      $scope._history();
      toastr.error("Une erreur s'est produite, veuillez réessayer plus tard.");
    } else {
      ReunionService.compteRenduDetails($state.params.id).then(function (response) {
        $scope._thisReunion = response.data;

        if ($scope._thisReunion.noteCompteRendu == null && $scope._thisReunion.ordreDuJour && $scope._thisReunion.ordreDuJour.note) {
          $scope._thisReunion.noteCompteRendu = angular.copy($scope._thisReunion.ordreDuJour.note);
        }

        angular.forEach($scope._thisReunion.ordreDuJour.fichesDeProgres, function (_fpItem, _fpIndex) {
          $scope._fichesDeProgres.push(_fpItem);
        });
        angular.forEach($scope._thisReunion.ordreDuJour.actionsDecidees, function (_adItem, _adIndex) {
          _adItem.categoryLibelle = "Action décidée / Réunion d'équipe";
          $scope._actionsDecidees.push(_adItem);
        });
      }).catch(function (error) {
        console.log(error);
      });
    }

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {
      console.log(error);
    });

    // Enregistrer compte-rendu


    $scope._saveCompteRendu = function () {
      ReunionService.saveCompteRendu($scope._thisReunion).then(function (response) {
        toastr.success('Sauvegardé avec succès.');
        $state.go('app.equipe.reunions');
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._cloturerEtArchiverReunion = function () {
      ReunionService.cloturerEtArchiverReunion($scope._thisReunion).then(function (response) {
        toastr.success('Sauvegardé avec succès.');
        $scope._goToReunionsList();
        $rootScope.$broadcast('refreshCountNotifs');
      }).catch(function (error) {
        console.log(error);
      });
    };

    // Action décidée

    $scope._actionDecideeFaite = function (_actionDecidee) {
      TachesGeneralesService.done(_actionDecidee.id).then(function (response) { }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._planifierUneAction = function () {
      $scope.addCollaborateurMode = false;
      $scope._today = new Date();
      $scope.minDateEcheance = angular.copy($scope._today);
      $scope.maxDateEcheance = angular.copy($scope.minDateEcheance);
      $scope.maxDateEcheance.setFullYear();
      $scope.maxDateEcheance.setFullYear($scope._today.getFullYear() + 20);
      $scope._categories = GENERAL_TASK_TYPES;
      $scope.fromReunionCompteRendu = true;
      $scope._task = {};
      for (var i = 0; i < $scope._categories.length; i++) {
        if ($scope._categories[i].value === 'ACTION_DECIDEE_REVUE_EQUIPE') {
          $scope._task.category = $scope._categories[i].value;
        }
      }
      $scope._recurrences = GENERAL_TASK_PERIOD;
      showTaskModal();
    };

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "CRR",
          datasource: {
            task: $scope._task,
          },
        },
        controller: "DialogController"
      }).then(function (param) {
        param.categoryLibelle = "Action décidée / Réunion d'équipe";
        $scope._thisReunion.ordreDuJour.actionsDecidees.push(param);
        $scope._actionsDecidees.push(param);
      }).catch(function () {

      });
    }

    $scope._save = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }
        $scope._task.echeance = $scope.echeance.getTime();
        var _taskCopy = angular.copy($scope._task);
        formData.append('dto', angular.toJson(_taskCopy));
        TachesGeneralesService.save(formData).then(function (response) {
          response.data.categoryLibelle = "Action décidée / Réunion d'équipe";
          $scope._thisReunion.ordreDuJour.actionsDecidees.push(response.data);
          $scope._actionsDecidees.push(response.data);
          $mdDialog.hide();
          $timeout(function () {
            $scope.intoSaving = false;
          });
        }).catch(function (error) {
          $scope.intoSaving = false;
          console.log(error);
        });
      }

    };

    // Fiches de progrès

    $scope._cloturerFicheDeProgres = function (_ficheProgres) {
      FicheProgresService.cloturerFicheDeProgres(_ficheProgres.id).then(function (response) {
        _ficheProgres.activated = false;
        toastr.success('Fiche de progrès cloturée avec succès.');
      }).catch(function (error) {
        if (error.status == 406) {
          toastr.warning(
            "Des tâches liées à cette fiche de progrès ne sont pas encore faites!",
            "Impossible de cloturer cette fiche de progrès", {
            "positionClass": "toast-bottom-center"
          }
          );
        } else {
          console.log(error);
        }
      });
    };

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    // Imprimer compte-rendu

    $scope._imprimerCompteRenduFinaliser = function () {
      DocGenerationService.generateDocumentTypeWithId("COMPTE_RENDU_DERNIERE_REUNION", $scope._thisReunion.id).then(function (response) { }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.ordreDuJourOrdering = function (element) {
      //ordonner les taches et actions par échéance et le reste par associationId
      if (element.type === 'TACHE_ET_EVENEMENT_PLANIFIE' || element.type === 'DERNIERE_ACTION_DECIDEE') {
        return element.echeance;
      } else {
        return element.associationId;
      }
    };

  }


})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('TemplatesController', TemplatesController);

  function TemplatesController($scope, toastr, $filter, $state, EquipeDetailService, $mdDialog, TraceService, PERMISSIONS, $timeout) {

    $scope.permissions = PERMISSIONS;
    var today = new Date();
    today.setSeconds(0, 0);
    $scope.subtraces = [];
    $scope.collaborateurs = [];
    $scope.trace = {};
    $scope.subtraceToAdd = {};

    $scope.loadingAdd = false
    $scope.loadingUpdate = false

    $scope.initPage = true;
    $scope.init = function (reset) {
      $scope.findById();
    }

    $scope.orderParameters = function (trace) {
      var params = angular.copy(trace.parameters);

      params.sort(function (a, b) {
        if (a.index < b.index) {
          return -1
        } else if (b.index < a.index) {
          return 1;
        } else {
          return 0;
        }
      })
      trace.parameters = params;
    }
    $scope.findById = function () {
      TraceService.findTemplateById($state.params.id).then(function (res) {
        $scope.trace = res;
        for (var i = 0; i < $scope.trace.parameters.length; i++) {
          var param = $scope.trace.parameters[i]
          if (param.type === 'LIST') {
            param.options = (param.options || []).map(function (o) { return { name: o } })
          }
        }
        $scope.orderParameters($scope.trace);
        $scope.subtraceToAdd = {};
        $scope.subtraceToAdd.date = new Date();
        $scope.subtraceToAdd.parameters = $scope.trace.parameters;
      }).catch(function (err) {

      })
    }
    $scope.init(true);

    $scope.closeModal = function () {
      $mdDialog.hide();
    }

    $scope.back = function () {
      $state.go('app.controle.trace', { tab: 'modeles' })
    }

    $scope.openNewTrace = function () {
      $state.go('app.controle.trace.template', { templateId: $state.params.id })
    }

  };
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('SubtracesController', SubtracesController);

	function SubtracesController($scope, toastr, $filter, $state, EquipeDetailService, $mdDialog, TraceService, PERMISSIONS, $timeout) {

		$scope._baseResource = "/api/rest/trace";


		$scope.permissions = PERMISSIONS;
		var today = new Date();
		today.setSeconds(0, 0);
		$scope.subtraces = [];
		$scope.collaborateurs = [];
		$scope.trace = {};
		$scope.traceToUpdate = {};
		$scope.subtraceToAdd = {};
		$scope.subtraceToUpdate = {};
		$scope.nameToEdit = null;
		$scope.pagination = {
			total: 0,
			page: 0,
			nbrResults: 20
		}
		$scope.filter = { searchTxt: '' }
		$scope.fromDate = { date: null };
		$scope.endDate = { date: null };
		$scope.staticSort = { column: null, direction: 'asc' }
		$scope.dynSort = { index: null, direction: 'asc' }
		$scope.searchMode = false
		$scope.loadingAdd = false
		$scope.loadingUpdate = false
		$scope.dateRangePicker = {
			date: { startDate: null, endDate: null },
			picker: null,
			options: {
				pickerClasses: 'custom-display', //angular-daterangepicker extra
				buttonClasses: 'btn',
				applyButtonClasses: 'btn-primary',
				cancelButtonClasses: 'btn-danger',
				showDropdowns: false,
				showCustomRangeLabel: false,
				// timePicker:true,
				locale: {
					applyLabel: "Confirmer",
					cancelLabel: 'Annuler',
					separator: " - ",
					//format: "YYYY-MM-DD", //will give you 2017-01-06
					format: "DD MMM YYYY", //will give you 6-Jan-17
					//format: "D-MMMM-YY", //will give you 6-January-17
					"daysOfWeek": [
						"Dim",
						"Lun",
						"Mar",
						"Mer",
						"Jeu",
						"Ven",
						"Sam"
					],
					"monthNames": [
						"Janvier",
						"Février",
						"Mars",
						"Avril",
						"Mai",
						"Juin",
						"Juillet",
						"Août",
						"Septembre",
						"Octobre",
						"Novembre",
						"Décembre"
					],
				},
				eventHandlers: {
					'apply.daterangepicker': function (event, picker) {
						$scope.getSubtracesByTraceAndDate(true);
					}
				}
			}
		};
		$scope.initPage = true;

		$scope.getMinWidthForParam = function (paramName) {
			const base = 140;
			const factor = 3;
			const calculated = paramName.length * factor;
			return Math.max(base, calculated) + 'px';
		};

		$scope.emptySearch = function () {
			$scope.filter.searchTxt = '';
			$scope.getSubtracesByTraceAndDate(true);
		}

		$scope.getSubtracesByTraceAndDate = function (reset, nextPage) {
			if (reset) {
				$scope.pagination = {
					total: 0,
					page: 0,
					nbrResults: 20
				}
			} else {
				if (nextPage) {
					$scope.pagination.page = $scope.pagination.page + 1;
				} else {
					$scope.pagination.page = $scope.pagination.page - 1;
				}
			}
			var date = {};
			if ($scope.fromDate.date) {
				date.startDate = $scope.fromDate.date.getTime();
			}

			if ($scope.endDate.date) {
				var date_ = new Date($scope.endDate.date);
				date_.setHours(23, 59, 59);
				date.endDate = date_.getTime();
			}

			if ($scope.dynSort.index != null) {
				$scope.pagination.sort = angular.copy($scope.dynSort)
			} else if ($scope.staticSort.column != null) {
				$scope.pagination.sort = angular.copy($scope.staticSort)
			} else {
				$scope.pagination.sort = null
			}
			$scope.searchMode = $scope.filter.searchTxt != null && $scope.filter.searchTxt.trim().length > 0

			TraceService.getSubtracesByTrace($scope.trace, $scope.pagination, date, $scope.filter.searchTxt).then(function (res) {
				$scope.fromDate.isOpen = false;
				$scope.endDate.isOpen = false;
				$scope.subtraces = res.dto;
				$scope.pagination.total = res.total;
			}).catch(function (err) {
			})
		}
		$scope.init = function (reset) {
			if (reset) {
				$scope.pagination = {
					total: 0,
					page: 0,
					nbrResults: 20
				}
			} else {
				$scope.pagination.page = $scope.pagination.page + 1;
			}
			$scope.findById();
			$scope.fromDate = { date: null };
			$scope.endDate = { date: null };
		}

		$scope.getPaginationFirstNumber = function () {
			if ($scope.pagination.total == 0) {
				return 0;
			} else {
				return $scope.pagination.page * $scope.pagination.nbrResults + 1;
			}
		}

		$scope.nbPages = function () {
			if ($scope.pagination == null || $scope.pagination.total == null) {
				return 0
			}
			var mod = $scope.pagination.total % $scope.pagination.nbrResults
			var res = Math.trunc($scope.pagination.total / $scope.pagination.nbrResults)
			if (mod != 0) {
				res += 1
			}
			return res
		}

		$scope.orderParameters = function (trace) {
			var params = angular.copy(trace.parameters);

			params.sort(function (a, b) {
				if (a.index < b.index) {
					return -1
				} else if (b.index < a.index) {
					return 1;
				} else {
					return 0;
				}
			})
			trace.parameters = params;
		}
		$scope.findById = function () {
			TraceService.findById($state.params.id).then(function (res) {
				$scope.trace = res;
				$scope.orderParameters($scope.trace);
				$scope.traceToUpdate = angular.copy($scope.trace)
				if ($scope.dynSort.index != null) {
					$scope.pagination.sort = angular.copy($scope.dynSort)
				} else if ($scope.staticSort.column != null) {
					$scope.pagination.sort = angular.copy($scope.staticSort)
				} else {
					$scope.pagination.sort = null
				}
				TraceService.getSubtracesByTrace($scope.trace, $scope.pagination, {}, $scope.filter.searchTxt).then(function (res) {
					$scope.subtraces = res.dto;
					$scope.pagination.total = res.total;
					if ($scope.initPage) {
						$scope.totalSubtrace = res.total;
						$scope.initPage = !$scope.initPage;
					}
				}).catch(function (err) {

				})
				$scope.subtraceToAdd = {};
				$scope.subtraceToAdd.date = new Date();
				$scope.subtraceToAdd.parameters = $scope.trace.parameters;
			}).catch(function (err) {

			})
		}
		$scope.showEditModal = function () {
			$state.go('app.controle.trace.update', { id: $scope.trace.id })
		}

		$scope.edit = function () {
			if ($scope.loadingEdit) {
				return;
			}
			$scope.loadingEdit = true;
			var traceToUpdate = angular.copy($scope.traceToUpdate)
			traceToUpdate.parameters = traceToUpdate.parameters.concat(traceToUpdate.deletedParameters)
			TraceService.edit(traceToUpdate).then(function (res) {
				toastr.success("Changements enregistrés avec succès!")
				$mdDialog.hide();
				$scope.loadingEdit = false;
				if (traceToUpdate.id != res.id) {
					$state.go('app.controle.trace.subtraces', { id: res.id })
				} else {
					$scope.trace = res;
					$scope.subtraceToAdd.parameters = $scope.trace.parameters;
					$scope.orderParameters($scope.trace);
					$scope.traceToUpdate = angular.copy($scope.trace)
					$scope.getSubtracesByTraceAndDate(true)
				}

			}).catch(function (err) {
				toastr.error("Erreur pendant la modification du nom");
				$scope.loadingEdit = false;
			})
		}
		$scope.getDateString = function (millis) {
			var date = new Date(millis);
			var day = "" + date.getDate();
			var month = "";
			switch (date.getMonth()) {
				case 0:
					month = " jan";
					break;
				case 1:
					month = " fév";
					break;
				case 2:
					month = " mar";
					break;
				case 3:
					month = " avr";
					break;
				case 4:
					month = " mai";
					break;
				case 5:
					month = " juin";
					break;
				case 6:
					month = " juil";
					break;
				case 7:
					month = " août";
					break;
				case 8:
					month = " sep";
					break;
				case 9:
					month = " oct";
					break;
				case 10:
					month = " nov";
					break;
				case 11:
					month = " déc";
					break;
				default:
					break;
			}



			return day + month + " " + date.getFullYear();
		}
		$scope.openExport = function () {
			$scope.exportDates = {}
			$scope.expPopup = $mdDialog.show({
				templateUrl: 'app/main/front/controle/trace/subtraces/popup/export.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				controller: SubtracesController,
				preserveScope: true
			}).then(function () {
			}).catch(function () {
			});
		}
		$scope.exportTrace = function () {
			TraceService.exportTrace($scope.trace, $scope.exportDates).then(function (res) {
				window.open("/api/rest/docgeneration/download/?location=" + res);
				$scope.exportDates = {};
				$mdDialog.hide();
			}).catch(function () {
				toastr.error("Erreur durant l'exportation")
			})
		}

		$scope.setToModif = function (subtrace, index) {
			// for (var i = 0; i < $scope.subtraces.length; i++) {
			// 	$scope.subtraces[i].openModify = false
			// }
			// subtrace.openModify = !subtrace.openModify;
			// subtrace.dateTmp = new Date(subtrace.date);
			$scope.subtraceToAdd = angular.copy(subtrace);
			$scope.subtraceToAdd.date = new Date($scope.subtraceToAdd.date)
			$mdDialog.show({
				templateUrl: 'app/main/front/controle/trace/subtraces/popup/add_subtrace.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				controller: 'AddSubtraceController',
				locals: {
					datasource: {
						subtraceToAdd: $scope.subtraceToAdd,
						trace: $scope.trace
					}
				},
				preserveScope: true
			}).then(function (param) {
				console.log(index, param)
				if (param) {
					$scope.subtraces[index] = angular.copy(param)
				}
			}).catch(function () {
			});

		}

		$scope.openHistory = function (subtrace, index) {
			TraceService.getSubtraceHistory(subtrace.id).then(function (data) {
				data.forEach(function (item) {
					$scope.orderParameters(item);
				});
				$scope.subtraceToShow = subtrace;
				$scope.subtraceToShowIndex = index
				$scope.subtraceHistories = data;
				$scope.historyPopup = $mdDialog.show({
					templateUrl: 'app/main/front/controle/trace/subtraces/popup/subtrace_history.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true
				}).then(function () {
				}).catch(function () {
				});
			}).catch(function () {
				toastr.error('Une erreur est survenue');
			});
		}

		$scope.delete = function (subtrace) {
			TraceService.deleteSubTrace($scope.trace, subtrace).then(function () {
				$scope.subtraceToDelete = null;
				$mdDialog.hide();
				$scope.init(true);
			}).catch(function () {
				toastr.error("Un problème est survenu durent la suppression")
			})
		}



		$scope.getCollaborateurs = function () {
			EquipeDetailService.getCollaborateurs().then(function (data) {
				$scope.collaborateurs = data;
			}).catch(function (response) {
				console.log("Error getCollaborateurs()");
			});
		}
		$scope.getCollaborateurs();




		$scope.saveNewSubTrace = function () {
			if ($scope.subtraceToAdd == null || $scope.subtraceToAdd == {}) {
				return;
			}
			if ($scope.loadingAdd) {
				return
			}
			$scope.loadingAdd = true
			var fmData = new FormData()
			var sub = angular.copy($scope.subtraceToAdd)
			sub.date = sub.date.getTime()
			fmData.append('dto', angular.toJson(sub))
			if ($scope.subtraceToAdd.documents != null) {
				for (var i = 0; i < $scope.subtraceToAdd.documents.length; i++) {
					var document = $scope.subtraceToAdd.documents[i]
					if (document.file != null) {
						fmData.append('files', document.file, document.attachmentOriginalName)
						delete document.file
					}
				}
			}
			TraceService.saveSubtrace(fmData, $scope.trace.id).then(function (res) {
				$mdDialog.hide();
				$scope.loadingAdd = false;
				$scope.newSubtrace.$setPristine();
				$scope.subtraceToAdd = {};
				$scope.subtraceToAdd.date = new Date();
				$scope.subtraceToAdd.parameters = $scope.trace.parameters;
				$scope.init(true);
			}).catch(function (err) {
				$scope.loadingAdd = false;
			})
		}
		$scope.init(true);

		$scope.closeModal = function () {
			$mdDialog.hide();
		}

		$scope.cancel = function (subtrace) {
			subtrace.openModify = !subtrace.openModify;
		};

		$scope.exportDocx = function (subtrace, trace) {
			var name = 'PHSQ-tracabilite-' + trace.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(' ', '-') + '-' + $filter('date')(subtrace.date, 'dd-MM-yyyy')
			if (trace.templateType === 'SUIVI_FORMATION') {
				name = 'Suivi de formation'
			}
			TraceService.downloadDocx(subtrace.id, name).then(function () {

			}).catch(function () {

			});
		}

		$scope.changeCollab = function (idSelected, toAdd) {
			$scope.idSelected = idSelected ? idSelected : $scope.idSelected;
			if (!idSelected) {
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};

				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$scope.equipePopup = $mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					controller: 'EquipeDetailController'
				}).then(function (data) {
					if (toAdd) {
						$scope.subtraceToAdd.reporter.id = data || $scope.idSelected;
					} else {
						$scope.subtraceToUpdate.reporter.id = data || $scope.idSelected;
					}
				}).catch(function (error) {
					if (toAdd) {
						$scope.subtraceToAdd.reporter.id = null;
					} else {
						$scope.subtraceToUpdate.reporter.id = null;
					}
				});
				return;
			}
		};

		$scope.download = function (id) {
			location.href = $scope._baseResource + '/download/' + id;
		}



		$scope.enableDynSort = function (index) {
			if ($scope.dynSort.index === index) {
				if ($scope.dynSort.direction === 'asc') {
					$scope.dynSort.direction = 'desc'
				} else if ($scope.dynSort.direction === 'desc') {
					$scope.dynSort.direction = null
					$scope.dynSort.index = null
				}
			} else {
				$scope.staticSort = { column: null, direction: null }
				$scope.dynSort.index = index
				$scope.dynSort.direction = 'asc'
			}
			$scope.getSubtracesByTraceAndDate(true)
		}

		$scope.enableStaticSort = function (prop) {
			if ($scope.staticSort.column === prop) {
				if ($scope.staticSort.direction === 'asc') {
					$scope.staticSort.direction = 'desc'
				} else if ($scope.staticSort.direction === 'desc') {
					$scope.staticSort.direction = null
					$scope.staticSort.column = null
				}
			} else {
				$scope.dynSort = { index: null, direction: null }
				$scope.staticSort.column = prop
				$scope.staticSort.direction = 'asc'
			}
			$scope.getSubtracesByTraceAndDate(true)
		}

		$scope.downIndex = function (index) {
			var copy = angular.copy($scope.traceToUpdate.parameters[index])
			$scope.traceToUpdate.parameters[index] = angular.copy($scope.traceToUpdate.parameters[index + 1])
			$scope.traceToUpdate.parameters[index + 1] = copy
		}

		$scope.upIndex = function (index) {
			var copy = angular.copy($scope.traceToUpdate.parameters[index])
			$scope.traceToUpdate.parameters[index] = angular.copy($scope.traceToUpdate.parameters[index - 1])
			$scope.traceToUpdate.parameters[index - 1] = copy
		}

		$scope.updateCheckbox = function (subtrace, index) {
			var fmData = new FormData()
			var sub = angular.copy(subtrace)
			// sub.date = sub.date.getTime()
			fmData.append('dto', angular.toJson(sub))

			TraceService.saveEditSubtrace(fmData).then(function (res) {

				subtrace.openModify = false;
				console.log(index, res)
				$scope.subtraces[index] = res
				toastr.success("Changements enregistrés avec succès");
			}).catch(function (err) {
				toastr.error("Erreur pendant l'enregistrement");
			})
		}

		$scope.$on('fileUploaded', function (event, data) {
			var fileinput = document.getElementById('file_').getElementsByTagName('input')["document_input_file"];
			if (data.id) {
				fileinput = document.getElementById('file_' + data.id).getElementsByTagName('input')["document_input_file"];
				$scope.subtraceToUpdate.nameOfDocument = "";
			} else {
				$scope.subtraceToAdd.nameOfDocument = "";
			}
			for (var i = 0; i < fileinput.files.length; i++) {
				var name = fileinput.files[i].name
				if (data.id) {
					$scope.subtraceToUpdate.nameOfDocument += name ? name : "Nom du fichier indisponible";
				} else {
					$scope.subtraceToAdd.nameOfDocument += name ? name : "Nom du fichier indisponible";
				}
			}
		});

		$scope.clearInputFile = function (subtraceToUpdate, id_input) {
			var elem = document.getElementById('file_').getElementsByTagName('input')[id_input];
			if (subtraceToUpdate.id) {
				elem = document.getElementById('file_' + subtraceToUpdate.id).getElementsByTagName('input')[id_input];
			}
			elem.value = ''
			subtraceToUpdate.attachmentOriginalName = null
			subtraceToUpdate.nameOfDocument = ''
		};

		$scope.back = function () {
			$state.go('app.controle.trace')
		}

		$scope.addParameter = function (type) {
			$scope.traceToUpdate.parameters.push({ name: null, index: $scope.traceToUpdate.parameters.length, type: type })
		}

		$scope.deleteRow = function (index) {
			var trace = angular.copy($scope.traceToUpdate.parameters[index])
			trace.toDelete = true
			$scope.traceToUpdate.deletedParameters.push(trace)
			$scope.traceToUpdate.parameters.splice(index, 1)
			for (var i = 0; i < $scope.traceToUpdate.parameters.length; i++) {
				$scope.traceToUpdate.parameters[i].index = i
			}
		}

		$scope.openAddSubtrace = function () {
			$scope.subtraceToAdd = {};
			$scope.subtraceToAdd.date = new Date();
			$scope.subtraceToAdd.parameters = $scope.trace.parameters;
			$mdDialog.show({
				templateUrl: 'app/main/front/controle/trace/subtraces/popup/add_subtrace.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				controller: 'AddSubtraceController',
				locals: {
					datasource: {
						subtraceToAdd: $scope.subtraceToAdd,
						trace: $scope.trace
					}
				},
				preserveScope: true
			}).then(function (param) {
				if (param) {
					$scope.init(true)
				}
			}).catch(function () {
			});
		}

		$scope.openJoindreFile = function () {

			$('#add_file').off('change')
			$('#add_file').on('change', function (evt) {
				if (evt.target.files.length > 0) {
					var reader = new FileReader();
					reader.onload = function (e) {
						if ($scope.subtraceToAdd.documents == null) {
							$scope.subtraceToAdd.documents = []
						}
						$scope.subtraceToAdd.documents.push({
							attachmentOriginalName: evt.target.files[0].name,
							file: new Blob([e.target.result]),
						})
						$('#add_file').val('')
						$scope.$apply()
					};
					reader.readAsArrayBuffer(evt.target.files[0]);
				}
			})
			$('#add_file').click()
		}

		$scope.deleteDocument = function (index) {
			$scope.subtraceToAdd.documents.splice(index, 1)
		}

		$scope.downloadDoc = function (id) {
			location.href = $scope._baseResource + '/download/document/' + id;
		}

		$scope.openToInformation = function (subtraceId) {
			$scope._subtraceToHome = subtraceId
			$mdDialog.show({
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				templateUrl: 'app/main/front/controle/trace/popup/to_information_popup.html',
				scope: $scope,
				preserveScope: true
			}).then(function (param) {
			}).catch(function () {

			});
		}

		$scope.toInformation = function () {
			$state.go('app.home', { subtraceId: $scope._subtraceToHome })
		}

	};
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OsysTriageController', OsysTriageController);

	/**
	 * PHSQ-240 — étapes 2 et 3 d'un triage : red flags, questions, conclusion. Reprend à `etape`.
	 * « Retour » depuis les red flags affiche le récapitulatif de l'étape 1, dans le même état
	 * (§8.1). Le front n'évalue aucune règle : il affiche l'état renvoyé par le serveur.
	 *
	 * La conclusion s'enregistre en continu (§8.6) : une requête en vol au plus, temporisation de
	 * 700 ms pour les champs texte ; « Valider le triage » attend que la file soit vide.
	 *
	 * @ngInject
	 */
	function OsysTriageController($scope, $state, $stateParams, $timeout, $window, $sce, toastr, OsysService, OsysVues,
		OsysDialogues, OsysFileEnvoi, ConfirmationGroupement) {
		var vm = this;
		var id = parseInt($stateParams.id, 10);
		var minuterieTexte = null;
		var file = OsysFileEnvoi.creer(function (dto) {
			return OsysService.conclusion(id, dto).then(function (t) {
				vm.enregistre = true;
				vm.t.rappels = t.rappels;
				vm.t.dureeCalculeeMin = t.dureeCalculeeMin;
			}).catch(function (err) {
				vm.enregistre = false;
				signaler(err);
			});
		});

		vm.t = null;
		vm.vue = null;
		vm.occupe = false;
		vm.c = null;
		vm.erreurs = {};
		vm.decisionOuverte = false;
		vm.dureeOuverte = false;
		vm.produit = { saisie: '', ouvert: false };
		vm.conseil = { saisie: '', ouvert: false };
		vm.enregistre = true;
		vm.L = OsysVues.LIBELLES;
		vm.libelleDelai = OsysVues.libelleDelai;
		vm.contexte = null;

		OsysService.chargerContexte().then(function (c) {
			vm.contexte = c;
		}).catch(angular.noop);

		// --- Chargement ---------------------------------------------------------------------------

		function charger() {
			return OsysService.triage(id).then(appliquer).catch(function (err) {
				if (err.status === 404) {
					toastr.error('Triage introuvable.');
					$state.go('app.osys.mesTriages');
					return;
				}
				signaler(err);
			});
		}

		function appliquer(t) {
			if (t.statut === 'VALIDE') {
				$state.go('app.osys.fin', { id: t.id });
				return;
			}
			if (t.statut !== 'EN_COURS') {
				toastr.info('Ce triage n’est plus en cours.');
				$state.go('app.osys.mesTriages');
				return;
			}
			vm.t = t;
			// Calculées une fois : un tableau littéral dans ng-repeat bouclerait le digest.
			vm.colonnes = [
				{ cle: 'medecin', orientation: 'MEDECIN', titre: t.arbre.libelleColonneMedecin || 'Orientation médecin' },
				{ cle: 'urgences', orientation: 'URGENCES', titre: t.arbre.libelleColonneUrgences || 'Urgences' }
			];
			// Signes cochés d'une issue de red flag (M37), calculés ici : un tableau neuf passé à
			// chaque digest par une liaison « < » boucle le digest.
			vm.redFlagsOrientation = t.etat.parRedFlag ? t.etat.redFlags.filter(function (r) { return r.coche; }) : [];
			if (vm.vue !== 'recap') {
				vm.vue = { RED_FLAGS: 'redflags', QUESTIONS: 'questions', CONCLUSION: 'conclusion' }[t.etape] || 'redflags';
			}
			if (vm.vue === 'conclusion') {
				initialiserConclusion(t);
			}
		}

		vm.etapeStepper = function () {
			return vm.vue === 'recap' ? 1 : vm.vue === 'conclusion' ? 3 : 2;
		};

		function passer(etape) {
			vm.occupe = true;
			return OsysService.etape(id, etape).then(function (t) {
				vm.vue = null;
				appliquer(t);
				$window.scrollTo(0, 0);
				var contenu = $window.document.getElementById('content');
				if (contenu) {
					contenu.scrollTop = 0;
				}
			}).catch(signaler).finally(function () {
				vm.occupe = false;
			});
		}

		// --- Récapitulatif de l'étape 1 (« Retour » depuis les red flags) ----------------------------

		vm.retourRecap = function () {
			vm.vue = 'recap';
		};

		vm.quitterRecap = function () {
			vm.vue = 'redflags';
		};

		// --- Red flags --------------------------------------------------------------------------------

		vm.colonne = function (orientation) {
			return vm.t ? vm.t.etat.redFlags.filter(function (r) { return r.orientation === orientation; }) : [];
		};

		vm.basculerRedFlag = function () {
			var codes = vm.t.etat.redFlags.filter(function (r) { return r.coche; }).map(function (r) { return r.code; });
			envoyerRedFlags(codes, false);
		};

		/** « Aucun des critères ci-dessus » : exclusive des autres cases, bascule immédiate. */
		vm.basculerAucun = function () {
			if (vm.t.etat.aucun) {
				vm.t.etat.redFlags.forEach(function (r) { r.coche = false; });
				envoyerRedFlags([], true);
			} else {
				envoyerRedFlags([], false);
			}
		};

		function envoyerRedFlags(codes, aucun) {
			vm.occupe = true;
			OsysService.redFlags(id, codes, aucun).then(appliquer).catch(function (err) {
				signaler(err);
				return charger();
			}).finally(function () {
				vm.occupe = false;
			});
		}

		vm.redFlagsCoches = function () {
			return vm.t ? vm.t.etat.redFlags.filter(function (r) { return r.coche; }) : [];
		};

		/** M23 : « Aucun » coché alors qu'un signe qui concerne ce patient ne l'est pas. */
		vm.signesConcernes = function () {
			if (!vm.t || !vm.t.etat.aucun) {
				return [];
			}
			return vm.t.etat.redFlags.filter(function (r) { return r.classement === 'CONCERNE' && !r.coche; });
		};

		vm.libellesCourts = function (signes) {
			return signes.map(function (r) { return r.libelleCourt || r.libelle; }).join(', ');
		};

		vm.peutQuitterRedFlags = function () {
			return vm.t && !vm.occupe && (vm.t.etat.aucun || vm.redFlagsCoches().length > 0);
		};

		vm.suivantRedFlags = function () {
			passer(vm.redFlagsCoches().length ? 'CONCLUSION' : 'QUESTIONS');
		};

		// --- Questions -------------------------------------------------------------------------------

		vm.questionsVisibles = function () {
			return vm.t ? vm.t.etat.questions.filter(function (q) { return q.type !== 'AIGUILLAGE'; }) : [];
		};

		vm.repondre = function (code, valeur) {
			vm.occupe = true;
			OsysService.reponse(id, code, valeur).then(appliquer).catch(function (err) {
				signaler(err);
				return charger();
			}).finally(function () {
				vm.occupe = false;
			});
		};

		vm.changerGestes = function () {
			var codes = [];
			vm.t.etat.questions.forEach(function (q) {
				(q.gestes || []).forEach(function (g) {
					if (g.coche) {
						codes.push(g.code);
					}
				});
			});
			vm.occupe = true;
			OsysService.gestes(id, codes).then(appliquer).catch(function (err) {
				signaler(err);
				return charger();
			}).finally(function () {
				vm.occupe = false;
			});
		};

		vm.modifierRedFlags = function () {
			passer('RED_FLAGS');
		};

		vm.suivantQuestions = function () {
			passer('CONCLUSION');
		};

		// --- Conclusion ------------------------------------------------------------------------------

		function initialiserConclusion(t) {
			var c = t.conclusion || {};
			vm.c = {
				priseEnCharge: c.priseEnCharge || vm.proposee(),
				motif: c.motif || '',
				contexte: c.contexte || '',
				produits: (c.produits || []).slice(),
				conseils: (c.conseils || []).slice(),
				qSansService: c.qSansService || null,
				qPourquoi: c.qPourquoi || null,
				qConnu: c.qConnu || null,
				satisfaction: c.satisfaction || null,
				dureeRetenueMin: c.dureeRetenueMin || null
			};
			vm.conseilsProposes = ((t.etat.issue && t.etat.issue.conseils) || []).slice();
			vm.c.conseils.forEach(function (x) {
				if (vm.conseilsProposes.indexOf(x) === -1) {
					vm.conseilsProposes.push(x);
				}
			});
			vm.decisionOuverte = vm.c.priseEnCharge !== vm.proposee();
			vm.dureeOuverte = !!c.dureeRetenueMin;
		}

		/** Prise en charge qui correspond à l'orientation proposée (OFFICINE → PHARMACIEN). */
		vm.proposee = function () {
			return vm.t && vm.t.etat.issue ? OsysVues.correspondance(vm.t.etat.issue.categorie) : null;
		};

		/**
		 * Composée ici : le minifieur HTML du build (maxLineLength 120) coupe la ligne après
		 * </strong>, et le retour à la ligne s'affichait en espace (« Pharmacien , comme proposé »).
		 * Les libellés sont des constantes du module.
		 */
		vm.phraseDecision = function () {
			var libelle = vm.c ? vm.L.PRISES_EN_CHARGE_DECISION[vm.c.priseEnCharge] || '' : '';
			return $sce.trustAsHtml('Prise en charge décidée avec votre patient\u00a0: <strong>' + libelle + '</strong>'
				+ (vm.differe() ? '' : ', comme proposé') + '.');
		};

		vm.differe = function () {
			return vm.c && vm.c.priseEnCharge !== vm.proposee();
		};

		/** Encart « Téléconsultation déconseillée » si l'orientation proposée ou décidée est Médecin. */
		vm.teleconsultation = function () {
			var tc = vm.t && vm.t.etat.teleconsultation;
			if (!tc || (!tc.connus.length && !tc.autres.length)) {
				return null;
			}
			return vm.proposee() === 'MEDECIN' || (vm.c && vm.c.priseEnCharge === 'MEDECIN') ? tc : null;
		};

		function dto() {
			return angular.copy(vm.c);
		}

		/** Enregistrement continu : immédiat pour un choix, après 700 ms pour un champ texte. */
		vm.enregistrer = function (texte) {
			vm.enregistre = false;
			if (minuterieTexte) {
				$timeout.cancel(minuterieTexte);
				minuterieTexte = null;
			}
			if (texte) {
				minuterieTexte = $timeout(function () {
					minuterieTexte = null;
					file.envoyer(dto());
				}, 700);
			} else {
				file.envoyer(dto());
			}
		};

		vm.choisirDecision = function () {
			delete vm.erreurs.motif;
			vm.enregistrer(false);
		};

		// Produits : puces, autocomplétion locale sur le catalogue de l'arbre, saisie libre.
		vm.suggestions = function () {
			var s = (vm.produit.saisie || '').trim().toLowerCase();
			var catalogue = (vm.t && vm.t.arbre.produits) || [];
			return catalogue.filter(function (p) {
				return vm.c.produits.indexOf(p) === -1 && (!s || p.toLowerCase().indexOf(s) !== -1);
			}).slice(0, 8);
		};

		vm.ajouterProduit = function (libelle) {
			var p = (libelle || vm.produit.saisie || '').trim();
			if (p && vm.c.produits.indexOf(p) === -1) {
				vm.c.produits.push(p);
				vm.enregistrer(false);
			}
			vm.produit.saisie = '';
			vm.produit.ouvert = false;
		};

		vm.retirerProduit = function (p) {
			vm.c.produits = vm.c.produits.filter(function (x) { return x !== p; });
			vm.enregistrer(false);
		};

		vm.toucheProduit = function ($event) {
			if ($event.keyCode === 13) {
				$event.preventDefault();
				vm.ajouterProduit();
			} else if ($event.keyCode === 27) {
				vm.produit.ouvert = false;
			}
		};

		vm.masquerSuggestions = function () {
			$timeout(function () {
				vm.produit.ouvert = false;
			}, 200);
		};

		// Conseils : pré-cochés depuis l'issue, ajout en saisie libre.
		vm.conseilCoche = function (x) {
			return vm.c.conseils.indexOf(x) !== -1;
		};

		vm.basculerConseil = function (x) {
			if (vm.conseilCoche(x)) {
				vm.c.conseils = vm.c.conseils.filter(function (y) { return y !== x; });
			} else {
				vm.c.conseils.push(x);
			}
			vm.enregistrer(false);
		};

		vm.ajouterConseil = function () {
			var x = (vm.conseil.saisie || '').trim();
			if (x) {
				if (vm.conseilsProposes.indexOf(x) === -1) {
					vm.conseilsProposes.push(x);
				}
				if (!vm.conseilCoche(x)) {
					vm.c.conseils.push(x);
				}
				vm.enregistrer(false);
			}
			vm.conseil = { saisie: '', ouvert: false };
		};

		vm.choisirSatisfaction = function (n) {
			vm.c.satisfaction = n;
			delete vm.erreurs.satisfaction;
			vm.enregistrer(false);
		};

		vm.choisirQuestion = function (champ) {
			delete vm.erreurs[champ];
			vm.enregistrer(false);
		};

		vm.dureeHorsBornes = function () {
			var d = vm.t && vm.t.dureeCalculeeMin;
			return d === null || angular.isUndefined(d) || d < 1 || d > 240;
		};

		// Rappels prévus : dates en clair, encart « Informez le patient ».
		vm.dateRappel = function (r) {
			if (r.avecHeure) {
				return 'aujourd’hui vers ' + OsysVues.heure(r.echeance);
			}
			return OsysVues.jourEnClair(r.echeance);
		};

		vm.phraseRappel = function () {
			var r = (vm.t && vm.t.rappels) || [];
			if (!r.length) {
				return null;
			}
			var dates = r.map(function (x) { return x.avecHeure ? vm.dateRappel(x) : 'le ' + vm.dateRappel(x); });
			return r.length === 1
				? 'qu’un rappel est prévu ' + dates[0] + '.'
				: 'que des rappels sont prévus ' + dates.slice(0, -1).join(', ') + ' et ' + dates[dates.length - 1] + '.';
		};

		function erreursConclusion() {
			var e = {};
			if (vm.differe() && !(vm.c.motif || '').trim()) {
				e.motif = 'Le motif est obligatoire quand votre choix diffère de l’orientation proposée.';
			}
			if (!(vm.c.contexte || '').trim()) {
				e.contexte = 'Le contexte connu ou identifié à l’officine est obligatoire.';
			}
			['qSansService', 'qPourquoi', 'qConnu'].forEach(function (champ) {
				if (!vm.c[champ]) {
					e[champ] = 'Réponse obligatoire.';
				}
			});
			if (!vm.c.satisfaction) {
				e.satisfaction = 'La satisfaction du patient est obligatoire.';
			}
			var d = vm.c.dureeRetenueMin;
			if (d === null || angular.isUndefined(d) || d === '') {
				if (vm.dureeHorsBornes()) {
					e.dureeRetenueMin = 'Indiquez la durée du triage (entre 1 et 240 minutes).';
				}
			} else if (d < 1 || d > 240) {
				e.dureeRetenueMin = 'La durée du triage est comprise entre 1 et 240 minutes.';
			}
			return e;
		}

		/** Champs manquants en rouge, défilement jusqu'au premier, avant tout appel (§8.4). */
		vm.valider = function ($event) {
			vm.erreurs = erreursConclusion();
			if (vm.erreurs.dureeRetenueMin) {
				vm.dureeOuverte = true;
			}
			if (Object.keys(vm.erreurs).length) {
				defiler();
				return;
			}
			vm.validation = true;
			if (minuterieTexte) {
				$timeout.cancel(minuterieTexte);
				minuterieTexte = null;
				file.envoyer(dto());
			}
			file.vider().then(function () {
				return OsysService.valider(id, true);
			}).then(function (verification) {
				if (!verification.avertissements || !verification.avertissements.length) {
					return true;
				}
				return ConfirmationGroupement.demander({
					classe: 'osy-confirm',
					titre: 'Valider le triage ?',
					texte: verification.avertissements.join(' '),
					confirmer: 'Valider quand même',
					annuler: 'Revenir au triage',
					danger: false,
					event: $event
				}).then(function () {
					return true;
				}).catch(function () {
					return false;
				});
			}).then(function (confirme) {
				if (!confirme) {
					return null;
				}
				return OsysService.valider(id, false).then(function () {
					$state.go('app.osys.fin', { id: id, valide: true });
				});
			}).catch(function (err) {
				(err.champs || []).forEach(function (c) {
					vm.erreurs[c.champ] = c.message;
				});
				if (err.champs && err.champs.length) {
					defiler();
				}
				signaler(err);
			}).finally(function () {
				vm.validation = false;
			});
		};

		vm.retourTriage = function () {
			if (minuterieTexte) {
				$timeout.cancel(minuterieTexte);
				minuterieTexte = null;
				file.envoyer(dto());
			}
			file.vider().then(function () {
				passer(vm.t.etat.parRedFlag ? 'RED_FLAGS' : 'QUESTIONS');
			});
		};

		// --- Retrait du consentement (étapes 2 et 3) ------------------------------------------------

		vm.retirerConsentement = function ($event) {
			var p = vm.t.patient;
			OsysDialogues.refus({ triageId: id, patient: { sexe: p.sexe }, trancheAge: tranche(p), event: $event })
				.then(function () {
					toastr.success('Retrait du consentement enregistré');
					$state.go('app.osys.mesTriages');
				}).catch(angular.noop);
		};

		/** Tranche d'âge depuis l'âge affiché (« 35 ans », « 8 mois ») : la fiche n'est pas relue. */
		function tranche(p) {
			var n = /an/.test(p.age || '') ? parseInt(p.age, 10) : 0;
			return n < 18 ? 'MOINS_18' : n < 40 ? 'DE_18_A_39' : n < 65 ? 'DE_40_A_64' : 'PLUS_65';
		}

		// --- Outils -------------------------------------------------------------------------------

		function defiler() {
			$timeout(function () {
				var champ = $window.document.querySelector('.osy-champ--erreur, .osy-bloc--erreur');
				if (champ) {
					champ.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			});
		}

		function signaler(err) {
			if (err && err.status === 423) {
				return;
			}
			toastr.error((err && err.message) || 'Enregistrement impossible.');
		}

		$scope.$on('osys:deverrouille', charger);
		$scope.$on('$destroy', function () {
			// Une saisie texte encore en attente part avant de quitter l'écran.
			if (minuterieTexte) {
				$timeout.cancel(minuterieTexte);
				file.envoyer(dto());
			}
		});

		charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OsysNouveauController', OsysNouveauController);

	/**
	 * PHSQ-240 — étape 1 d'un triage : situation (B1), patient et consentement (B2), nouveau
	 * patient (B3). Deux sous-vues du même contrôleur, sans changer d'URL (§8.1).
	 *
	 * Rien de patient ne va dans l'URL ni dans localStorage : seul l'identifiant du dernier
	 * titulaire choisi sur ce poste y est gardé (§8.6).
	 *
	 * @ngInject
	 */
	function OsysNouveauController($scope, $state, $window, $timeout, $location, toastr, OsysService, OsysVues, OsysDialogues) {
		var vm = this;
		var CLE_TITULAIRE = 'osys.dernierTitulaire';
		var minuterieRecherche = null;

		vm.vue = 'situation';
		vm.contexte = null;
		vm.arbre = null;
		vm.debut = null;
		vm.recherche = { texte: '', lignes: null, enCours: false, cherche: '' };
		vm.patient = null;
		vm.nouveau = null;
		vm.consentement = false;
		vm.habilitationId = null;
		vm.representant = { nom: '', lien: '' };
		vm.envoi = false;
		vm.erreurs = {};

		// Le lien est imprimé tel quel dans le compte rendu : « Représentant(e) : NOM (mère) ».
		vm.LIENS = [{ code: 'mère', libelle: 'Mère' }, { code: 'père', libelle: 'Père' }, { code: 'tuteur', libelle: 'Tuteur' },
			{ code: 'autre', libelle: 'Autre' }];
		vm.MOTIFS_SANS_NIR = OsysVues.MOTIFS_SANS_NIR;
		vm.libelleSexe = OsysVues.libelleSexe;

		// --- Contexte ----------------------------------------------------------------------------

		OsysService.chargerContexte().then(function (contexte) {
			vm.contexte = contexte;
			var habs = contexte.habilitations || [];
			if (habs.length === 1) {
				vm.habilitationId = habs[0].id;
			} else {
				var memorise = lireTitulaire();
				if (memorise && habs.some(function (h) { return h.id === memorise; })) {
					vm.habilitationId = memorise;
				}
			}
		}).catch(signaler);

		vm.bloque = function () {
			return vm.contexte && (!vm.contexte.moduleActif || !(vm.contexte.habilitations || []).length);
		};

		// --- B1, situation ----------------------------------------------------------------------

		/** Le choix est horodaté : c'est le `debut` du triage (B1, M18). */
		vm.choisirArbre = function (arbre) {
			vm.arbre = arbre;
			vm.debut = Date.now();
		};

		vm.continuerSituation = function ($event) {
			if (!vm.arbre || vm.bloque()) {
				return;
			}
			var cgu = vm.contexte.cgu;
			var suite = function () {
				vm.vue = 'patient';
				$location.search('etape', 'patient');
				if (vm.recherche.cherche) {
					rechercher(vm.recherche.cherche);
				}
			};
			if (cgu && cgu.texte && !cgu.acceptee) {
				OsysDialogues.cgu(cgu, $event).then(function () {
					cgu.acceptee = true;
					suite();
				}).catch(angular.noop);
			} else {
				suite();
			}
		};

		/** « ✎ Changer » : retour aux tuiles, le patient choisi est gardé (B2, M18). */
		vm.changerSituation = function () {
			vm.vue = 'situation';
			$location.search('etape', null);
		};

		// « Précédent » / « Suivant » du navigateur entre B1 et B2. Sans situation choisie (page
		// rechargée sur ?etape=patient), on repart de B1.
		if ($location.search().etape) {
			$location.search('etape', null).replace();
		}
		$scope.$on('$locationChangeSuccess', function () {
			var patient = $location.search().etape === 'patient';
			vm.vue = patient && vm.arbre ? 'patient' : 'situation';
		});

		// --- B2, recherche du patient --------------------------------------------------------------

		vm.saisieRecherche = function () {
			if (minuterieRecherche) {
				$timeout.cancel(minuterieRecherche);
			}
			var texte = (vm.recherche.texte || '').trim();
			if (texte.length < 3) {
				vm.recherche.lignes = null;
				vm.recherche.cherche = '';
				return;
			}
			minuterieRecherche = $timeout(function () {
				rechercher(texte);
			}, 350);
		};

		function rechercher(texte) {
			vm.recherche.enCours = true;
			OsysService.rechercherPatients(texte, vm.arbre && vm.arbre.code).then(function (lignes) {
				vm.recherche.lignes = lignes;
				vm.recherche.cherche = texte;
				// L'épisode récent dépend de la situation : on rafraîchit le patient choisi.
				if (vm.patient) {
					var meme = lignes.filter(function (l) { return l.id === vm.patient.id; })[0];
					if (meme) {
						vm.patient = meme;
					}
				}
				if (!lignes.length && !vm.patient && (!vm.nouveau || formulaireVierge())) {
					// Formulaire pas encore entamé : nom et prénom suivent la recherche.
					vm.creerPatient(texte);
				}
			}).catch(signaler).finally(function () {
				vm.recherche.enCours = false;
			});
		}

		/** Rien n'a été saisi dans le formulaire « Nouveau patient » au-delà du nom et du prénom pré-remplis. */
		function formulaireVierge() {
			var n = vm.nouveau;
			return !n.dateNaissance && !n.sexe && !n.nir && !n.sansNir && !n.telephone && !n.codePostal && !n.medecinTraitant;
		}

		/** Le patient choisi reste épinglé au-dessus des résultats (M18). */
		vm.lignesAffichees = function () {
			var lignes = vm.recherche.lignes || [];
			if (!vm.patient) {
				return lignes;
			}
			return [vm.patient].concat(lignes.filter(function (l) { return l.id !== vm.patient.id; }));
		};

		/** Changer de patient décoche le consentement (M18). */
		vm.choisirPatient = function (ligne) {
			if (!vm.patient || vm.patient.id !== ligne.id) {
				vm.consentement = false;
			}
			vm.patient = ligne;
			vm.nouveau = null;
			vm.erreurs = {};
			vm.representant = ligne.dernierRepresentant
				? { nom: ligne.dernierRepresentant.nom, lien: ligne.dernierRepresentant.lien }
				: { nom: '', lien: '' };
		};

		vm.dernierTriage = function (ligne) {
			var d = ligne.dernierTriage;
			if (!d) {
				return '—';
			}
			var etat = d.statut === 'EN_COURS' ? ' (en cours)' : d.statut === 'ABANDONNE' ? ' (abandonné)' : '';
			return OsysVues.date(d.date) + ' · ' + d.arbre + etat;
		};

		vm.mineur = function () {
			if (vm.patient) {
				return OsysVues.ans(vm.patient.dateNaissance) < 18;
			}
			if (vm.nouveau) {
				var iso = OsysVues.dateIso(vm.nouveau.dateNaissance);
				return !!iso && OsysVues.ans(iso) < 18;
			}
			return false;
		};

		// --- B3, nouveau patient ----------------------------------------------------------------

		/** Formulaire vide, pré-rempli du nom et du prénom tapés dans la recherche s'il y en a. */
		vm.creerPatient = function (texte) {
			var mots = (texte || '').trim().split(/\s+/).filter(function (m) { return m && !/\d/.test(m); });
			if (vm.patient) {
				vm.consentement = false;
			}
			vm.patient = null;
			vm.erreurs = {};
			vm.representant = { nom: '', lien: '' };
			vm.nouveau = {
				nom: (mots[0] || '').toUpperCase(),
				prenom: mots[1] ? mots[1].charAt(0).toUpperCase() + mots[1].slice(1) : '',
				dateNaissance: '',
				sexe: null,
				nir: '',
				sansNir: false,
				motifSansNir: null,
				telephone: '',
				codePostal: '',
				medecinTraitant: ''
			};
		};

		vm.formaterNir = function () {
			vm.nouveau.nir = OsysVues.formaterNir(vm.nouveau.nir);
		};

		vm.formaterDate = function () {
			vm.nouveau.dateNaissance = OsysVues.masqueDate(vm.nouveau.dateNaissance);
		};

		/** Avertissements NIR calculés en direct, avec l'algorithme du serveur (§7.3). */
		vm.controleNir = function () {
			var n = vm.nouveau;
			if (!n || n.sansNir || !n.nir) {
				return null;
			}
			return OsysVues.controlerNir(n.nir, n.sexe, OsysVues.dateIso(n.dateNaissance));
		};

		function erreursNouveau() {
			var n = vm.nouveau;
			var e = {};
			if (!n.nom || !n.nom.trim()) {
				e.nom = 'Nom obligatoire.';
			}
			if (!n.prenom || !n.prenom.trim()) {
				e.prenom = 'Prénom obligatoire.';
			}
			var iso = OsysVues.dateIso(n.dateNaissance);
			if (!iso) {
				e.dateNaissance = 'Date attendue au format jj/mm/aaaa.';
			} else if (OsysVues.ans(iso) < 0 || OsysVues.ans(iso) > 120) {
				e.dateNaissance = 'Date de naissance impossible.';
			}
			if (!n.sexe) {
				e.sexe = 'Sexe obligatoire.';
			}
			if (n.sansNir) {
				if (!n.motifSansNir) {
					e.motifSansNir = 'Motif obligatoire.';
				}
			} else {
				var c = vm.controleNir();
				if (!n.nir) {
					e.nir = 'NIR obligatoire, ou cochez « Patient sans NIR ».';
				} else if (c && c.erreur) {
					e.nir = c.erreur;
				}
			}
			if (!n.telephone || !n.telephone.trim()) {
				e.telephone = 'Téléphone obligatoire.';
			}
			if (!/^\d{5}$/.test((n.codePostal || '').trim()) && !(n.codePostal || '').trim()) {
				e.codePostal = 'Code postal obligatoire.';
			}
			return e;
		}

		// --- Consentement, titulaire, création ------------------------------------------------------

		vm.peutContinuer = function () {
			if (vm.envoi || !vm.consentement || !vm.habilitationId || (!vm.patient && !vm.nouveau)) {
				return false;
			}
			if (vm.mineur() && (!vm.representant.nom || !vm.representant.lien)) {
				return false;
			}
			return true;
		};

		vm.continuer = function (confirmerDoublon) {
			if (vm.nouveau) {
				vm.erreurs = erreursNouveau();
				if (Object.keys(vm.erreurs).length) {
					defiler();
					return;
				}
			}
			if (!vm.peutContinuer()) {
				return;
			}
			memoriserTitulaire(vm.habilitationId);
			var dto = {
				arbreCode: vm.arbre.code,
				debut: vm.debut,
				consentement: true,
				habilitationId: vm.habilitationId,
				confirmerDoublon: !!confirmerDoublon,
				representant: vm.mineur() ? { nom: vm.representant.nom.trim(), lien: vm.representant.lien } : null
			};
			if (vm.patient) {
				dto.patientId = vm.patient.id;
			} else {
				var n = vm.nouveau;
				dto.nouveauPatient = {
					nom: n.nom.trim(), prenom: n.prenom.trim(), dateNaissance: OsysVues.dateIso(n.dateNaissance), sexe: n.sexe,
					nir: n.sansNir ? null : n.nir, sansNir: n.sansNir, motifSansNir: n.sansNir ? n.motifSansNir : null,
					telephone: n.telephone.trim(), codePostal: n.codePostal.trim(), medecinTraitant: (n.medecinTraitant || '').trim() || null
				};
			}
			vm.envoi = true;
			OsysService.creerTriage(dto).then(function (triage) {
				$state.go('app.osys.triage', { id: triage.id });
			}).catch(function (err) {
				vm.envoi = false;
				if (err.code === 'DOUBLON_PATIENT' || err.code === 'DOUBLON_POSSIBLE') {
					OsysDialogues.doublon(err).then(function (choix) {
						if (choix.patient) {
							vm.choisirPatient(choix.patient);
							vm.consentement = true;
							vm.continuer(false);
						} else if (choix.creerQuandMeme) {
							vm.continuer(true);
						}
					}).catch(angular.noop);
					return;
				}
				if (err.champs && err.champs.length) {
					err.champs.forEach(function (c) {
						vm.erreurs[c.champ || c] = c.message || err.message;
					});
				}
				signaler(err);
			});
		};

		vm.imprimerConsentement = function () {
			OsysVues.ouvrirPdf(OsysService.urlConsentement(vm.patient && vm.patient.id, vm.habilitationId)).catch(signaler);
		};

		/** « Le patient refuse » : refus anonyme, pré-rempli depuis le patient choisi ou saisi (B4, M21). */
		vm.refuser = function ($event) {
			var source = vm.patient || (vm.nouveau && { dateNaissance: OsysVues.dateIso(vm.nouveau.dateNaissance), sexe: vm.nouveau.sexe });
			OsysDialogues.refus({ arbreCode: vm.arbre.code, patient: source, event: $event }).then(function () {
				toastr.success('Refus enregistré');
				$state.go('app.osys.mesTriages');
			}).catch(angular.noop);
		};

		// --- Outils -------------------------------------------------------------------------------

		function lireTitulaire() {
			try {
				var v = $window.localStorage.getItem(CLE_TITULAIRE);
				return v ? parseInt(v, 10) : null;
			} catch (e) {
				return null;
			}
		}

		function memoriserTitulaire(id) {
			try {
				$window.localStorage.setItem(CLE_TITULAIRE, String(id));
			} catch (e) {
				// stockage indisponible : la présélection ne se fera pas
			}
		}

		function defiler() {
			$timeout(function () {
				var champ = $window.document.querySelector('.osy-champ--erreur, .osy-erreur');
				if (champ) {
					champ.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			});
		}

		function signaler(err) {
			if (err && err.status === 423) {
				return;
			}
			toastr.error((err && err.message) || 'Enregistrement impossible.');
		}

		$scope.$on('$destroy', function () {
			if (minuterieRecherche) {
				$timeout.cancel(minuterieRecherche);
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OsysFinController', OsysFinController);

	/**
	 * PHSQ-240 — écran de fin (C4) : compte rendu et transmission, seule saisie encore permise
	 * après la validation. Rouvert depuis « Mes triages » (« Transmission ») : variante sans
	 * stepper ni « Triage enregistré », avec le seul bouton « Retour à Mes triages » (M15).
	 *
	 * @ngInject
	 */
	function OsysFinController($scope, $state, $stateParams, $http, $window, $q, $filter, toastr, OsysService, OsysVues) {
		var vm = this;
		var id = parseInt($stateParams.id, 10);

		// input[type=date] d'AngularJS veut un objet Date ; l'API échange des dates ISO « aaaa-mm-jj ».
		function versDate(iso) {
			var p = (iso || '').split('-').map(function (x) { return parseInt(x, 10); });
			return p.length === 3 ? new Date(p[0], p[1] - 1, p[2]) : null;
		}
		function versIso(d) {
			return d ? $filter('date')(d, 'yyyy-MM-dd') : null;
		}

		vm.rouvert = !$stateParams.valide;
		vm.t = null;
		vm.transmission = { mode: null, precision: '', date: versDate(OsysVues.aujourdhuiIso()) };
		vm.MODES = OsysVues.LIBELLES.MODES_TRANSMISSION;
		vm.erreurs = {};
		vm.envoi = false;
		vm.enregistree = false;
		vm.maxDate = OsysVues.aujourdhuiIso();

		function charger() {
			OsysService.triage(id).then(function (t) {
				if (t.statut !== 'VALIDE') {
					$state.go('app.osys.triage', { id: id });
					return;
				}
				vm.t = t;
				if (t.transmission && t.transmission.mode) {
					vm.transmission = { mode: t.transmission.mode, precision: t.transmission.precision || '',
						date: versDate(t.transmission.date || OsysVues.aujourdhuiIso()) };
					vm.enregistree = true;
				}
			}).catch(function (err) {
				if (err.status === 404) {
					toastr.error('Triage introuvable.');
					$state.go('app.osys.mesTriages');
					return;
				}
				signaler(err);
			});
		}

		vm.datesRappels = function () {
			var r = (vm.t && vm.t.rappels) || [];
			return r.map(function (x) {
				return x.avecHeure ? 'aujourd’hui vers ' + OsysVues.heure(x.echeance) : OsysVues.date(x.echeance);
			});
		};

		vm.avecDate = function () {
			return vm.transmission.mode && vm.transmission.mode !== 'MAIN_PROPRE_SANS_TRANSMISSION';
		};

		vm.changer = function () {
			vm.enregistree = false;
			vm.erreurs = {};
		};

		vm.enregistrer = function () {
			vm.erreurs = {};
			var t = vm.transmission;
			if (!t.mode) {
				vm.erreurs.mode = 'Le mode de transmission est obligatoire.';
			}
			if (t.mode === 'AUTRE' && !(t.precision || '').trim()) {
				vm.erreurs.precision = 'Précisez le mode de transmission.';
			}
			if (vm.avecDate() && t.date && versIso(t.date) > OsysVues.aujourdhuiIso()) {
				vm.erreurs.date = 'La date de transmission ne peut pas être dans le futur.';
			}
			if (Object.keys(vm.erreurs).length) {
				return;
			}
			vm.envoi = true;
			OsysService.transmission(id, {
				mode: t.mode,
				precision: t.mode === 'AUTRE' ? t.precision.trim() : null,
				date: vm.avecDate() ? versIso(t.date) : null
			}).then(function () {
				vm.enregistree = true;
				toastr.success('Transmission enregistrée.');
			}).catch(function (err) {
				(err.champs || []).forEach(function (c) {
					vm.erreurs[c.champ] = c.message;
				});
				signaler(err);
			}).finally(function () {
				vm.envoi = false;
			});
		};

		/** Téléchargement : nom du fichier lu dans `Content-Disposition` (CR_OSyS_<référence>_v<n>.pdf). */
		vm.telecharger = function () {
			$http.get(OsysService.urlCompteRendu(id), { responseType: 'arraybuffer', params: { '_v': new Date().getTime() } })
				.then(function (r) {
					var entete = r.headers('content-disposition') || '';
					var m = /filename="?([^";]+)"?/.exec(entete);
					var lien = $window.URL.createObjectURL(new $window.Blob([r.data], { type: 'application/pdf' }));
					var a = $window.document.createElement('a');
					a.href = lien;
					a.download = m ? m[1] : 'compte-rendu-osys.pdf';
					$window.document.body.appendChild(a);
					a.click();
					a.remove();
					$window.setTimeout(function () {
						$window.URL.revokeObjectURL(lien);
					}, 60000);
				}).catch(function () {
					toastr.error('Téléchargement impossible.');
				});
		};

		/** Impression : PDF ouvert dans un nouvel onglet préparé avant l'appel, puis `print()`. */
		vm.imprimer = function () {
			var onglet = $window.open('', '_blank');
			$http.get(OsysService.urlCompteRendu(id), { responseType: 'arraybuffer', params: { '_v': new Date().getTime() } })
				.then(function (r) {
					var lien = $window.URL.createObjectURL(new $window.Blob([r.data], { type: 'application/pdf' }));
					if (!onglet) {
						$window.location.href = lien;
						return;
					}
					onglet.location = lien;
					onglet.onload = function () {
						onglet.print();
					};
				}).catch(function () {
					if (onglet) {
						onglet.close();
					}
					toastr.error('Impression impossible.');
				});
		};

		function signaler(err) {
			if (err && err.status === 423) {
				return $q.resolve();
			}
			toastr.error((err && err.message) || 'Enregistrement impossible.');
		}

		$scope.$on('osys:deverrouille', charger);
		charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OsysMesTriagesController', OsysMesTriagesController);

	/**
	 * PHSQ-240 — « Mes triages » (Main, A2, A4 ; §7.5 et §8.4).
	 *
	 * La recherche reste dans le contrôleur, jamais dans l'URL (décision 23). Le 423 du verrou
	 * n'est pas signalé ici : la surcouche s'affiche, et l'écran se recharge au déverrouillage.
	 *
	 * @ngInject
	 */
	function OsysMesTriagesController($scope, $state, $stateParams, $timeout, $window, $document, toastr,
		OsysService, OsysVues, ConfirmationGroupement, OsysDialogues) {
		var vm = this;
		var anneau = null;

		vm.contexte = null;
		vm.tableau = null;
		vm.page = 1;
		vm.filtres = { mois: null, arbre: '' };
		vm.recherche = { texte: '', active: false, lignes: null, tronque: false, texteCherche: '', aide: null };

		vm.libelleMois = OsysVues.libelleMois;
		vm.libelleDelai = OsysVues.libelleDelai;
		vm.commence = OsysVues.commence;

		vm.sousTitre = function () {
			var c = vm.contexte;
			var n = (c.habilitations || []).length;
			return [c.officine.nom, c.officine.contratOsys ? 'compte OSyS' : null,
				n + (n > 1 ? ' titulaires habilités' : ' titulaire habilité')].filter(Boolean).join(' · ');
		};

		vm.pages = function () {
			var t = vm.tableau && vm.tableau.triagesDuMois;
			return t ? Math.ceil(t.total / t.parPage) : 0;
		};

		// --- Chargement --------------------------------------------------------------------------

		function charger() {
			OsysService.chargerContexte().then(function (contexte) {
				vm.contexte = contexte;
			}).catch(signaler);
			chargerTableau().then(function () {
				if ($stateParams.suivi) {
					$timeout(function () {
						var bloc = $document[0].getElementById('osy-suivi');
						if (bloc) {
							bloc.scrollIntoView({ behavior: 'smooth', block: 'start' });
						}
					}, 100);
				}
			});
		}

		function chargerTableau() {
			return OsysService.tableauDeBord(vm.filtres.mois, vm.filtres.arbre || null, vm.page).then(function (tableau) {
				vm.tableau = tableau;
				vm.filtres.mois = tableau.mois;
				dessinerAnneau();
			}).catch(signaler);
		}

		vm.changerFiltres = function () {
			vm.page = 1;
			chargerTableau();
		};

		vm.allerPage = function (page) {
			vm.page = page;
			chargerTableau();
		};

		// --- Recherche (A2) ---------------------------------------------------------------------

		vm.rechercher = function () {
			var texte = (vm.recherche.texte || '').trim();
			if (texte.length < 3) {
				vm.recherche.aide = 'Saisissez au moins 3 caractères, puis Entrée.';
				return;
			}
			vm.recherche.aide = null;
			vm.recherche.active = true;
			vm.recherche.lignes = null;
			OsysService.rechercherTriages(texte).then(function (resultat) {
				vm.recherche.lignes = resultat.lignes;
				vm.recherche.tronque = resultat.tronque;
				vm.recherche.texteCherche = texte;
			}).catch(function (err) {
				vm.recherche.active = false;
				signaler(err);
			});
		};

		/** Vider le champ fait sortir de la recherche (M17). */
		vm.saisieRecherche = function () {
			vm.recherche.aide = null;
			if (!vm.recherche.texte) {
				vm.effacerRecherche();
			}
		};

		vm.effacerRecherche = function () {
			var etaitActive = vm.recherche.active;
			vm.recherche = { texte: '', active: false, lignes: null, tronque: false, texteCherche: '', aide: null };
			if (etaitActive) {
				// Les cartes sont recréées par ng-if : l'anneau, lui, n'a pas bougé.
				chargerTableau();
			}
		};

		vm.titreRecherche = function () {
			var n = vm.recherche.lignes.length;
			if (!n) {
				return 'Aucun triage trouvé';
			}
			return (vm.recherche.tronque ? '50 premiers triages' : n + (n > 1 ? ' triages trouvés' : ' triage trouvé'))
				+ ' pour « ' + vm.recherche.texteCherche + ' »';
		};

		// --- Actions ----------------------------------------------------------------------------

		vm.reprendre = function (triageId) {
			$state.go('app.osys.triage', { id: triageId });
		};

		/** « MSSanté · 15/10 » si la transmission du compte rendu est enregistrée, sinon « À enregistrer ». */
		vm.transmissionCourte = function (ligne) {
			if (!ligne.modeTransmission) {
				return 'À enregistrer';
			}
			var mode = OsysVues.LIBELLES.MODES_TRANSMISSION_COURTS[ligne.modeTransmission] || ligne.modeTransmission;
			var date = (ligne.dateTransmission || '').split('-');
			return mode + (date.length === 3 ? ' · ' + date[2] + '/' + date[1] : '');
		};

		vm.transmission = function (triageId) {
			$state.go('app.osys.fin', { id: triageId });
		};

		vm.abandonner = function (ligne, $event) {
			ConfirmationGroupement.demander({
				classe: 'osy-confirm',
				titre: 'Abandonner ce triage ?',
				texte: 'Le triage de ' + ligne.patient.prenom + ' ' + ligne.patient.nom.toUpperCase()
					+ ' (' + ligne.arbre.libelle + ') sera abandonné. Il ne pourra plus être repris.',
				confirmer: 'Abandonner',
				annuler: 'Garder',
				danger: true,
				event: $event
			}).then(function () {
				return OsysService.abandonner(ligne.triageId).then(function () {
					toastr.success('Triage abandonné.');
					chargerTableau();
				});
			}).catch(function (err) {
				if (err) {
					signaler(err);
				}
			});
		};

		/** Le PDF est demandé par $http (cookie de session, 423) puis ouvert dans un onglet préparé
		 *  avant l'appel, sans quoi le bloqueur de fenêtres l'arrêterait (motif `openPDF`). */
		vm.ouvrirCompteRendu = function (triageId) {
			OsysVues.ouvrirPdf(OsysService.urlCompteRendu(triageId)).catch(signaler);
		};

		/**
		 * Fenêtre de rappel (C6-C8). Après l'enregistrement : Mes triages et la pastille du menu
		 * sont rechargés ; une réédition du compte rendu ouvre un toast cliquable vers le PDF.
		 */
		vm.rappeler = function (ligne, $event) {
			OsysDialogues.rappel(ligne.rappelId, $event).then(function (resultat) {
				$scope.$root.$broadcast('osys:rappel-enregistre');
				if (resultat && resultat.compteRenduVersion) {
					toastr.success('Compte rendu réédité (version ' + resultat.compteRenduVersion + ') : cliquez pour l\u2019ouvrir.',
						'Rappel enregistré', {
							timeOut: 15000,
							closeButton: true,
							onTap: function () {
								OsysVues.ouvrirPdf(OsysService.urlCompteRendu(ligne.triageId, resultat.compteRenduVersion)).catch(signaler);
							}
						});
				} else {
					toastr.success('Rappel enregistré.');
				}
			}).catch(function (err) {
				if (err) {
					signaler(err);
				}
				// Une fenêtre fermée sans enregistrement peut avoir laissé une tentative : on relit.
				chargerTableau();
			});
		};

		// --- Anneau du mois (E33) --------------------------------------------------------------

		function dessinerAnneau() {
			$timeout(function () {
				var canvas = $document[0].getElementById('osy-anneau');
				if (!canvas || !vm.tableau) {
					return;
				}
				var parts = vm.tableau.repartition.parArbre;
				var total = vm.tableau.repartition.total;
				var donnees = total ? parts.map(function (p) { return p.nombre; }) : [1];
				var couleurs = total ? parts.map(function (p) { return p.couleur || '#B0BEC5'; }) : ['#E3E8EE'];
				if (anneau) {
					anneau.destroy();
				}
				anneau = new $window.Chart(canvas.getContext('2d'), {
					type: 'doughnut',
					data: {
						labels: total ? parts.map(function (p) { return p.libelle; }) : [''],
						datasets: [{ data: donnees, backgroundColor: couleurs, borderColor: '#fff', borderWidth: 3 }]
					},
					options: {
						cutoutPercentage: 70,
						responsive: false,
						legend: { display: false },
						tooltips: { enabled: !!total },
						animation: { duration: 300 }
					}
				});
			});
		}

		// --- Erreurs ----------------------------------------------------------------------------

		function signaler(err) {
			if (err && err.status === 423) {
				return;
			}
			toastr.error((err && err.message) || 'Chargement impossible.');
		}

		$scope.$on('osys:deverrouille', charger);
		$scope.$on('osys:rappel-enregistre', charger);
		$scope.$on('$destroy', function () {
			if (anneau) {
				anneau.destroy();
			}
		});

		charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').factory('OsysDialogues', OsysDialogues);

	/**
	 * PHSQ-240 — fenêtres du module. Montées par $mdDialog dans <body>, HORS de `.osy-page` :
	 * leurs styles (`osy-fenetre`) sont à la racine de triage-osys.scss. Chaque fonction renvoie
	 * une promesse résolue à l'enregistrement, rejetée sans valeur à l'abandon.
	 *
	 * @ngInject
	 */
	function OsysDialogues($mdDialog, $q, OsysService) {
		var BASE = 'app/main/front/triage-osys/dialogs/';

		function ouvrir(gabarit, controleur, locaux, evenement) {
			return $mdDialog.show({
				templateUrl: BASE + gabarit,
				controller: controleur,
				controllerAs: 'd',
				bindToController: true,
				locals: locaux,
				targetEvent: evenement,
				clickOutsideToClose: false,
				escapeToClose: true,
				focusOnOpen: true,
				multiple: true
			});
		}

		return {
			/** Conditions d'utilisation des articles OSyS (D-47), avant le premier triage. */
			cgu: function (cgu, evenement) {
				return ouvrir('cgu.html', CguController, { cgu: cgu }, evenement);
			},
			/** 409 DOUBLON_PATIENT (même NIR) ou DOUBLON_POSSIBLE (même identité) à la création. */
			doublon: function (erreur, evenement) {
				return ouvrir('doublon.html', DoublonController, { erreur: erreur }, evenement);
			},
			/**
			 * Refus du patient (B4) ou retrait du consentement en cours de triage : tranche d'âge,
			 * sexe et motif, sans aucune donnée d'identité. `options.patient` pré-remplit la
			 * tranche et le sexe ; `options.triageId` en fait un retrait de consentement.
			 */
			refus: function (options) {
				return ouvrir('refus.html', RefusController, { options: options || {} }, (options || {}).event);
			},
			/**
			 * Fenêtre de rappel (C6, C7, C8). Le rappel est lu AVANT d'ouvrir la fenêtre : un refus
			 * (rappel à venir, M16 ; déjà clos) rejette avec l'erreur sans rien afficher — fermer une
			 * fenêtre pendant son animation d'ouverture la laissait à l'écran. Résolue avec
			 * {compteRenduVersion} quand un rappel est enregistré, rejetée sans valeur à l'abandon.
			 */
			rappel: function (rappelId, evenement) {
				return OsysService.rappel(rappelId).then(function (rappel) {
					return ouvrir('rappel.html', RappelController, { rappelId: rappelId, rappel: rappel }, evenement);
				});
			},
			/** Fiche patient (D-54) : identité sans NIR, modification, triages du patient. Lue avant l'ouverture. */
			fichePatient: function (patientId, evenement) {
				return $q.all([OsysService.patient(patientId), OsysService.triagesDuPatient(patientId)]).then(function (lus) {
					return ouvrir('fiche-patient.html', FichePatientController, { patientId: patientId, patient: lus[0], triages: lus[1] },
						evenement);
				});
			}
		};
	}

	/** @ngInject */
	function RappelController($mdDialog, $window, $sce, toastr, OsysService, OsysVues) {
		var d = this;
		var CLE_TITULAIRE = 'osys.dernierTitulaire';
		d.r = null;
		d.joint = null;
		d.resultat = null;
		d.saisie = { surveillance: {}, evolution: null, priseEnCharge: null, suiteDonnee: null, preconisationsSuivies: null,
			causeNonSuivi: '', satisfaction: null, commentaire: '' };
		d.apercu = null;
		d.erreurs = {};
		d.envoi = false;
		d.confirmation = null;
		d.decisionOuverte = false;
		// Résultats proposés pour une tentative (D-59) ; « Patient joint » n'est posé que par le serveur.
		d.RESULTATS_PROPOSES = { PAS_DE_REPONSE: 'Pas de réponse', MESSAGERIE: 'Messagerie, message laissé', NUMERO_ERRONE: 'Numéro erroné',
			AUTRE: 'Autre' };
		d.RESULTATS = angular.extend({ JOINT: 'Patient joint' }, d.RESULTATS_PROPOSES);
		d.EVOLUTIONS = { AMELIORATION: 'Amélioration', STABLE: 'État stable', AGGRAVATION: 'Aggravation' };
		d.SUITES = { AUCUNE: 'Aucune', MEDECIN: 'Consultation d\u2019un médecin', TELECONSULTATION: 'Téléconsultation', URGENCES: 'Urgences',
			AUTRE: 'Autre' };
		d.PRISES_EN_CHARGE = OsysVues.LIBELLES.PRISES_EN_CHARGE_DECISION;

		d.r = d.rappel;
		var habs = d.r.habilitations || [];
		if (habs.length === 1) {
			d.habilitationId = habs[0].id;
		} else {
			// Même présélection que « Triage réalisé par » (§3.6).
			try {
				var memorise = parseInt($window.localStorage.getItem(CLE_TITULAIRE), 10);
				if (habs.some(function (h) { return h.id === memorise; })) {
					d.habilitationId = memorise;
				}
			} catch (e) {
				// stockage indisponible : pas de présélection
			}
		}

		/** « Rappel du patient J+3 · Claire MOREAU », « Rappel du patient à 2 h · … » pour un H2 (§3.6). */
		d.titre = function () {
			var delai = d.r.delai === 'H2' ? 'à 2 h' : OsysVues.libelleDelai(d.r.delai);
			return 'Rappel du patient ' + delai + ' · ' + d.r.patient.prenom + ' ' + d.r.patient.nom.toUpperCase();
		};

		d.decisionTriage = function () {
			return { PHARMACIEN: 'prise en charge à l\u2019officine', MEDECIN: 'médecin', URGENCES: 'urgences' }[d.r.triage.priseEnCharge] || '—';
		};

		/** Numéros des sections : la nouvelle orientation ne s'insère que si l'arbre en prévoit une. */
		d.numero = function (section) {
			var base = d.r.tentatives.length ? 3 : 2;
			if (section === 'evolution') {
				return base;
			}
			if (section === 'orientation') {
				return base + 1;
			}
			return base + (d.apercu && d.apercu.issue ? 2 : 1);
		};

		d.urlPhoto = function (p) {
			return OsysService.urlPhoto(d.r.triage.id, p.id);
		};

		d.agrandir = function (p) {
			d.photoAgrandie = p;
		};

		d.choisirJoint = function (valeur) {
			d.joint = valeur;
			d.erreurs = {};
			d.confirmation = null;
		};

		d.repondre = function (code, valeur) {
			d.saisie.surveillance[code] = valeur;
			delete d.erreurs['surveillance.' + code];
			d.evaluer();
		};

		/** Chaque changement réévalue l'orientation ; rien n'est enregistré (rappels/{id}/evaluer). */
		d.evaluer = function () {
			delete d.erreurs.evolution;
			if (!d.saisie.evolution) {
				d.apercu = null;
				return;
			}
			OsysService.evaluerRappel(d.rappelId, { surveillance: d.saisie.surveillance, evolution: d.saisie.evolution }).then(function (apercu) {
				var avant = d.apercu && d.apercu.issue ? d.apercu.issue.titre : null;
				d.apercu = apercu;
				if (!apercu.issue) {
					d.saisie.priseEnCharge = null;
				} else if (apercu.issue.titre !== avant) {
					d.saisie.priseEnCharge = apercu.priseEnChargeProposee;
					d.decisionOuverte = false;
				}
			}).catch(function (err) {
				toastr.error(err.message || 'Évaluation impossible.');
			});
		};

		d.teleconsultation = function () {
			var tc = d.apercu && d.apercu.teleconsultation;
			if (!tc || (!tc.connus.length && !tc.autres.length)) {
				return null;
			}
			return d.apercu.priseEnChargeProposee === 'MEDECIN' || d.saisie.priseEnCharge === 'MEDECIN' ? tc : null;
		};

		d.phraseDecision = function () {
			var libelle = d.PRISES_EN_CHARGE[d.saisie.priseEnCharge] || '';
			var comme = d.saisie.priseEnCharge === d.apercu.priseEnChargeProposee ? ', comme proposé' : '';
			return $sce.trustAsHtml('Prise en charge décidée avec votre patient\u00a0: <strong>' + libelle + '</strong>' + comme + '.');
		};

		function memoriser() {
			try {
				$window.localStorage.setItem(CLE_TITULAIRE, String(d.habilitationId));
			} catch (e) {
				// stockage indisponible
			}
		}

		function exigerTitulaire() {
			if (!d.habilitationId) {
				d.erreurs.habilitationId = 'Indiquez qui réalise le rappel.';
				return false;
			}
			return true;
		}

		function erreurs(err) {
			(err.champs || []).forEach(function (c) {
				d.erreurs[c.champ] = c.message;
			});
			d.erreurGlobale = err.champs && err.champs.length ? 'Complétez les champs signalés.' : null;
			if (!d.erreurGlobale && err.status !== 423) {
				toastr.error(err.message || 'Enregistrement impossible.');
			}
		}

		/** « Enregistrer la tentative » ferme la fenêtre et recharge Mes triages (M40). */
		d.enregistrerTentative = function () {
			d.erreurs = {};
			var ok = exigerTitulaire();
			if (!d.resultat) {
				d.erreurs.resultat = 'Indiquez le résultat de la tentative.';
				ok = false;
			}
			if (!ok) {
				return;
			}
			d.envoi = true;
			memoriser();
			OsysService.tentative(d.rappelId, { habilitationId: d.habilitationId, resultat: d.resultat }).then(function () {
				toastr.success('Tentative enregistrée.');
				$mdDialog.hide({});
			}).catch(function (err) {
				d.envoi = false;
				erreurs(err);
			});
		};

		/** Clôture sans contact : confirmée, titulaire exigé, tentative en cours NON enregistrée (M40). */
		d.cloturer = function (statut) {
			d.erreurs = {};
			if (exigerTitulaire()) {
				d.confirmation = statut;
			}
		};

		d.confirmerCloture = function () {
			d.envoi = true;
			memoriser();
			OsysService.cloturer(d.rappelId, { statut: d.confirmation, habilitationId: d.habilitationId }).then(function () {
				toastr.success('Suivi clôturé.');
				$mdDialog.hide({});
			}).catch(function (err) {
				d.envoi = false;
				d.confirmation = null;
				erreurs(err);
			});
		};

		d.realiser = function () {
			d.erreurs = {};
			if (!exigerTitulaire()) {
				return;
			}
			d.envoi = true;
			memoriser();
			OsysService.realiserRappel(d.rappelId, {
				habilitationId: d.habilitationId,
				surveillance: d.saisie.surveillance,
				evolution: d.saisie.evolution,
				priseEnCharge: d.apercu && d.apercu.issue ? d.saisie.priseEnCharge : null,
				suiteDonnee: d.saisie.suiteDonnee,
				preconisationsSuivies: d.saisie.preconisationsSuivies,
				causeNonSuivi: d.saisie.preconisationsSuivies === false ? d.saisie.causeNonSuivi : null,
				satisfaction: d.saisie.satisfaction,
				commentaire: d.saisie.commentaire || null
			}).then(function (resultat) {
				$mdDialog.hide(resultat || {});
			}).catch(function (err) {
				d.envoi = false;
				erreurs(err);
			});
		};

		d.annuler = function () {
			$mdDialog.cancel();
		};
	}

	/** @ngInject */
	function FichePatientController($mdDialog, toastr, OsysService, OsysVues) {
		var d = this;
		d.p = d.patient;
		d.triages = d.triages || [];
		d.edition = null;
		d.erreurs = {};
		d.envoi = false;
		d.MOTIFS_SANS_NIR = OsysVues.MOTIFS_SANS_NIR;
		d.libelleSexe = OsysVues.libelleSexe;
		d.libelleDecision = function (code) {
			return OsysVues.LIBELLES.PRISES_EN_CHARGE_DECISION[code] || '—';
		};

		/** Même formulaire que B3 ; le NIR se remplace mais ne se relit jamais (vide = inchangé). */
		d.modifier = function () {
			var p = d.p;
			var date = p.dateNaissance ? p.dateNaissance.split('-') : null;
			d.edition = {
				nom: p.nom, prenom: p.prenom, dateNaissance: date ? date[2] + '/' + date[1] + '/' + date[0] : '', sexe: p.sexe,
				nir: '', sansNir: p.sansNir, motifSansNir: p.motifSansNir, telephone: p.telephone || '', codePostal: p.codePostal || '',
				medecinTraitant: p.medecinTraitant || ''
			};
			d.erreurs = {};
		};

		d.formaterNir = function () {
			d.edition.nir = OsysVues.formaterNir(d.edition.nir);
		};

		d.formaterDate = function () {
			d.edition.dateNaissance = OsysVues.masqueDate(d.edition.dateNaissance);
		};

		d.controleNir = function () {
			var e = d.edition;
			return e && !e.sansNir && e.nir ? OsysVues.controlerNir(e.nir, e.sexe, OsysVues.dateIso(e.dateNaissance)) : null;
		};

		d.enregistrer = function () {
			var e = d.edition;
			d.erreurs = {};
			var iso = OsysVues.dateIso(e.dateNaissance);
			if (!iso) {
				d.erreurs.dateNaissance = 'Date attendue au format jj/mm/aaaa.';
			}
			var c = d.controleNir();
			if (c && c.erreur) {
				d.erreurs.nir = c.erreur;
			}
			if (Object.keys(d.erreurs).length) {
				return;
			}
			d.envoi = true;
			OsysService.modifierPatient(d.patientId, {
				nom: e.nom, prenom: e.prenom, dateNaissance: iso, sexe: e.sexe, nir: e.sansNir || !e.nir ? null : e.nir,
				sansNir: e.sansNir, motifSansNir: e.sansNir ? e.motifSansNir : null, telephone: e.telephone, codePostal: e.codePostal,
				medecinTraitant: e.medecinTraitant || null
			}).then(function (p) {
				d.p = p;
				d.edition = null;
				toastr.success('Fiche enregistrée.');
			}).catch(function (err) {
				(err.champs || []).forEach(function (x) {
					d.erreurs[x.champ] = x.message;
				});
				if (!err.champs || !err.champs.length) {
					toastr.error(err.message || 'Enregistrement impossible.');
				}
			}).finally(function () {
				d.envoi = false;
			});
		};

		d.compteRendu = function (t) {
			OsysVues.ouvrirPdf(OsysService.urlCompteRendu(t.triageId)).catch(function (err) {
				toastr.error(err.message || 'Compte rendu indisponible.');
			});
		};

		d.fermer = function () {
			$mdDialog.hide(true);
		};
	}

	/** @ngInject */
	function CguController($mdDialog, OsysService, toastr) {
		var d = this;
		d.accepte = false;
		d.envoi = false;
		d.annuler = function () {
			$mdDialog.cancel();
		};
		d.valider = function () {
			d.envoi = true;
			OsysService.accepterCgu(d.cgu.version).then(function () {
				$mdDialog.hide(true);
			}).catch(function (err) {
				d.envoi = false;
				toastr.error(err.message || 'Enregistrement impossible.');
			});
		};
	}

	/** @ngInject */
	function DoublonController($mdDialog, OsysVues) {
		var d = this;
		d.possible = d.erreur.code === 'DOUBLON_POSSIBLE';
		d.patients = d.erreur.details || [];
		d.libelleSexe = OsysVues.libelleSexe;
		d.utiliser = function (patient) {
			$mdDialog.hide({ patient: patient });
		};
		d.creerQuandMeme = function () {
			$mdDialog.hide({ creerQuandMeme: true });
		};
		d.annuler = function () {
			$mdDialog.cancel();
		};
	}

	/** @ngInject */
	function RefusController($mdDialog, OsysService, OsysVues, toastr) {
		var d = this;
		var p = d.options.patient;
		d.retrait = !!d.options.triageId;
		d.TRANCHES = OsysVues.LIBELLES.TRANCHES_AGE;
		d.SEXES = OsysVues.LIBELLES.SEXES;
		d.MOTIFS = OsysVues.LIBELLES.MOTIFS_REFUS;
		// Aucune valeur présélectionnée, sauf ce qu'on sait déjà du patient (modifiable).
		d.saisie = {
			trancheAge: d.options.trancheAge || (p && p.dateNaissance ? OsysVues.trancheAge(p.dateNaissance) : null),
			sexe: p && p.sexe ? p.sexe : null,
			motif: null
		};
		d.envoi = false;
		d.complet = function () {
			return d.saisie.trancheAge && d.saisie.sexe && d.saisie.motif;
		};
		d.annuler = function () {
			$mdDialog.cancel();
		};
		d.valider = function () {
			if (!d.complet()) {
				return;
			}
			d.envoi = true;
			var appel = d.retrait
				? OsysService.retraitConsentement(d.options.triageId, d.saisie)
				: OsysService.refus(angular.extend({ arbreCode: d.options.arbreCode }, d.saisie));
			appel.then(function () {
				$mdDialog.hide(true);
			}).catch(function (err) {
				d.envoi = false;
				toastr.error(err.message || 'Enregistrement impossible.');
			});
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('osyStepper', osyStepper);

	/**
	 * PHSQ-240 — étapes du triage (§8.6) : « Situation et patient », « Triage », « Conclusion ».
	 * Fait (coche verte), en cours (bleu), à venir (gris). `ms-form-wizard` repose sur des
	 * md-tabs : il n'est pas utilisé.
	 *
	 * @ngInject
	 */
	function osyStepper() {
		return {
			restrict: 'E',
			scope: { etape: '<', termine: '<' },
			template:
				'<ol class="osy-stepper">' +
				'  <li class="osy-stepper__etape osy-stepper__etape--{{etat($index + 1)}}" ng-repeat="libelle in libelles">' +
				'    <span class="osy-stepper__rond">' +
				'      <md-icon ng-if="etat($index + 1) === \'fait\'" md-font-icon="icon-check" class="s16"></md-icon>' +
				'      <span ng-if="etat($index + 1) !== \'fait\'">{{$index + 1}}</span>' +
				'    </span>' +
				'    <span class="osy-stepper__libelle">{{libelle}}</span>' +
				'    <span class="osy-stepper__trait" ng-if="!$last"></span>' +
				'  </li>' +
				'</ol>',
			link: function (scope) {
				scope.libelles = ['Situation et patient', 'Triage', 'Conclusion'];
				scope.etat = function (n) {
					if (scope.termine || n < scope.etape) {
						return 'fait';
					}
					return n === scope.etape ? 'encours' : 'avenir';
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('osyQuestion', osyQuestion);

	/**
	 * PHSQ-240 — une question de l'étape 2, rendue d'après son type (§6.2) : libellé à gauche,
	 * réponse alignée à droite, boutons de même largeur. Le front n'évalue aucune règle : chaque
	 * réponse part au serveur (`on-repondre`), dont l'état remplace l'affichage.
	 *
	 * Score : la réponse n'est envoyée qu'une fois chaque groupe radio répondu (le serveur refuse
	 * un score incomplet) ; elle s'écrit `GROUPE=OPTION` par groupe radio et `GROUPE` par case cochée,
	 * séparés par « ; ».
	 *
	 * @ngInject
	 */
	function osyQuestion() {
		return {
			restrict: 'E',
			scope: { question: '<', occupe: '<', onRepondre: '&', onGeste: '&' },
			templateUrl: 'app/main/front/triage-osys/composants/osy-question.html',
			link: function (scope) {
				scope.choix = { radios: {}, cases: {} };

				// Calculés à chaque nouvelle question, jamais dans le gabarit : un ng-repeat sur une
				// fonction qui recrée ses objets boucle le digest (10 itérations, constaté en recette).
				scope.$watch('question', function (q) {
					scope.listeBoutons = q ? boutons(q) : [];
					scope.choix = { radios: {}, cases: {} };
					if (q && q.type === 'SCORE' && q.reponse) {
						q.reponse.split(';').forEach(function (morceau) {
							var i = morceau.indexOf('=');
							if (i > 0) {
								scope.choix.radios[morceau.substring(0, i)] = morceau.substring(i + 1);
							} else if (morceau) {
								scope.choix.cases[morceau] = true;
							}
						});
					}
				});

				function boutons(q) {
					if (q.type === 'CHOIX') {
						return q.options.map(function (o) { return { code: o.code, libelle: o.libelle }; });
					}
					var b = [{ code: 'OUI', libelle: 'Oui' }, { code: 'NON', libelle: 'Non' }];
					if (q.type === 'OUI_NON_NSP') {
						b.push({ code: 'NSP', libelle: 'Ne sait pas' });
					}
					return b;
				}

				scope.repondre = function (valeur) {
					if (!scope.occupe && valeur !== scope.question.reponse) {
						scope.onRepondre({ code: scope.question.code, valeur: valeur });
					}
				};

				scope.changerScore = function () {
					var q = scope.question;
					var morceaux = [];
					var complet = true;
					q.groupes.forEach(function (g) {
						if (g.type === 'RADIO') {
							if (scope.choix.radios[g.code]) {
								morceaux.push(g.code + '=' + scope.choix.radios[g.code]);
							} else {
								complet = false;
							}
						} else if (scope.choix.cases[g.code]) {
							morceaux.push(g.code);
						}
					});
					if (complet) {
						scope.repondre(morceaux.join(';'));
					}
				};

				scope.unite = function (n) {
					return Math.abs(n) > 1 ? 'points' : 'point';
				};

				scope.points = function (n) {
					return (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n);
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('osyPhotos', osyPhotos);

	/**
	 * PHSQ-240 — photos d'un triage (étape 3) : appareil photo de la tablette (`capture`), 3 au
	 * plus, vignettes avec suppression. Les images sont servies par l'API (cookie de session) ;
	 * le serveur les réencode en JPEG sans métadonnées.
	 *
	 * @ngInject
	 */
	function osyPhotos(OsysService, toastr) {
		return {
			restrict: 'E',
			scope: { triageId: '<', photos: '=', lectureSeule: '<' },
			template:
				'<div class="osy-photos">' +
				'  <div class="osy-photos__vignettes" ng-if="photos.length">' +
				'    <div class="osy-photos__vignette" ng-repeat="p in photos track by p.id">' +
				'      <img ng-src="{{url(p)}}" alt="Photo {{$index + 1}} du triage">' +
				'      <button type="button" class="osy-photos__supprimer" ng-if="!lectureSeule" ng-click="supprimer(p)"' +
				'              ng-disabled="envoi" aria-label="Supprimer la photo {{$index + 1}}">' +
				'        <md-icon md-font-icon="icon-close" class="s16"></md-icon></button>' +
				'    </div>' +
				'  </div>' +
				'  <label class="osy-btn osy-btn--principal osy-photos__ajouter" ng-if="!lectureSeule && photos.length < 3"' +
				'         ng-class="{\'osy-photos__ajouter--occupe\': envoi}">' +
				'    <md-icon md-font-icon="icon-camera" class="s18"></md-icon> {{envoi ? \'Envoi…\' : \'Prendre une photo\'}}' +
				'    <input type="file" accept="image/jpeg,image/png" capture="environment" class="osy-photos__fichier">' +
				'  </label>' +
				'  <p class="osy-note">Les photos sont archivées avec le triage (3 au plus), pour comparer lors du rappel.</p>' +
				'</div>',
			link: function (scope, element) {
				scope.envoi = false;
				scope.url = function (p) {
					return OsysService.urlPhoto(scope.triageId, p.id);
				};
				scope.supprimer = function (p) {
					scope.envoi = true;
					OsysService.supprimerPhoto(scope.triageId, p.id).then(function () {
						scope.photos = scope.photos.filter(function (x) { return x.id !== p.id; });
					}).catch(function (err) {
						toastr.error(err.message || 'Suppression impossible.');
					}).finally(function () {
						scope.envoi = false;
					});
				};
				// Le champ est recréé par ng-if : écoute déléguée sur l'élément de la directive.
				element.on('change', function (evenement) {
					var champ = evenement.target;
					if (!champ.classList.contains('osy-photos__fichier') || !champ.files.length) {
						return;
					}
					var fichier = champ.files[0];
					champ.value = '';
					scope.$apply(function () {
						scope.envoi = true;
					});
					OsysService.ajouterPhoto(scope.triageId, fichier).then(function (photo) {
						scope.photos = (scope.photos || []).concat([photo]);
					}).catch(function (err) {
						toastr.error(err.message || 'Photo refusée.');
					}).finally(function () {
						scope.envoi = false;
					});
				});
				scope.$on('$destroy', function () {
					element.off('change');
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('osyPatientLien', osyPatientLien);

	/**
	 * PHSQ-240 — pastille du patient en tête des étapes 2 et 3 : ouvre la fiche patient (D-54).
	 *
	 * @ngInject
	 */
	function osyPatientLien(OsysDialogues, toastr) {
		return {
			restrict: 'E',
			scope: { patient: '<' },
			template:
				'<button type="button" class="osy-btn osy-btn--contour osy-patient-lien" ng-if="patient" ng-click="ouvrir($event)">' +
				'  <md-icon md-font-icon="icon-account" class="s18"></md-icon> {{patient.prenom}} {{patient.nom | uppercase}}' +
				'</button>',
			link: function (scope) {
				scope.ouvrir = function ($event) {
					OsysDialogues.fichePatient(scope.patient.id, $event).catch(function (err) {
						if (err && err.message && err.status !== 423) {
							toastr.error(err.message);
						}
					});
				};
			}
		};
	}
})();

(function () {
	'use strict';

	/**
	 * PHSQ-240 — pastilles du module : décision (Officine, Médecin, Urgences, avec « après
	 * rappel », M13), suivi d'un triage, échéance d'un rappel.
	 */
	angular.module('app.front')
		.directive('osyPastille', osyPastille)
		.directive('osyDecision', osyDecision)
		.directive('osySuivi', osySuivi)
		.directive('osyEcheance', osyEcheance);

	/** @ngInject */
	function osyPastille() {
		return {
			restrict: 'E',
			transclude: true,
			scope: { type: '@', point: '@' },
			template: '<span class="osy-pastille osy-pastille--{{type}}" ng-class="{\'osy-pastille--point\': point !== \'non\'}" ng-transclude></span>'
		};
	}

	/** @ngInject */
	function osyDecision(OsysVues) {
		return {
			restrict: 'E',
			scope: { priseEnCharge: '<', apresRappel: '<' },
			template:
				'<span ng-if="pec" class="osy-decision">' +
				'  <span class="osy-pastille osy-pastille--point osy-pastille--{{pec.type}}">{{pec.libelle}}</span>' +
				'  <span class="osy-decision__apres" ng-if="apresRappel">après rappel</span>' +
				'</span>' +
				'<span ng-if="!pec">—</span>',
			link: function (scope) {
				scope.$watch('priseEnCharge', function (code) {
					scope.pec = OsysVues.priseEnCharge(code);
				});
			}
		};
	}

	/** « Rappel le 18/01 » (bleu), « Rappel aujourd'hui » (bleu), « Rappel à 14:20 » (ambre),
	 *  « Rappel en retard » (rouge), « Suivi terminé » (vert) ; « — » sans pastille. */
	/** @ngInject */
	function osySuivi() {
		return {
			restrict: 'E',
			scope: { texte: '<' },
			template: '<span ng-if="type" class="osy-pastille osy-pastille--{{type}}">{{texte}}</span><span ng-if="!type">{{texte || \'—\'}}</span>',
			link: function (scope) {
				scope.$watch('texte', function (texte) {
					texte = texte || '';
					scope.type = texte.indexOf('Rappel en retard') === 0 ? 'rouge'
						: texte.indexOf('Rappel à') === 0 ? 'ambre'
							: texte.indexOf('Rappel') === 0 ? 'bleu'
								: texte.indexOf('Suivi terminé') === 0 ? 'vert' : null;
				});
			}
		};
	}

	/** Échéance d'un rappel du Suivi : « En retard · 13/01 », « 14:20 » (rappel à heure) ou « Aujourd'hui ». */
	/** @ngInject */
	function osyEcheance(OsysVues, $filter) {
		return {
			restrict: 'E',
			scope: { ligne: '<' },
			template: '<span class="osy-pastille osy-pastille--point osy-pastille--{{type}}">{{texte}}</span>',
			link: function (scope) {
				scope.$watch('ligne', function (l) {
					if (!l) {
						return;
					}
					var date = $filter('date');
					var aujourdhui = OsysVues.memeJour(new Date(l.echeance), new Date());
					if (l.enRetard) {
						scope.type = 'rouge';
						scope.texte = 'En retard · ' + (aujourdhui && l.avecHeure ? date(l.echeance, 'HH:mm') : date(l.echeance, 'dd/MM'));
					} else if (l.avecHeure) {
						scope.type = 'ambre';
						scope.texte = date(l.echeance, 'HH:mm');
					} else {
						scope.type = 'bleu';
						scope.texte = 'Aujourd’hui';
					}
				});
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('osyOrientation', osyOrientation);

	/**
	 * PHSQ-240 — bloc d'orientation (étape 3, fenêtre de rappel) : grand pavé à la couleur de la
	 * catégorie, titre et puces de l'issue ; pour une issue de red flag, les signes cochés (M37).
	 * Non modifiable.
	 *
	 * @ngInject
	 */
	function osyOrientation() {
		return {
			restrict: 'E',
			scope: { issue: '<', redFlags: '<' },
			template:
				'<div class="osy-orientation osy-orientation--{{(issue.categorie || \'\').toLowerCase()}}" ng-if="issue">' +
				'  <h2 class="osy-orientation__titre">{{issue.titre}}</h2>' +
				'  <ul class="osy-orientation__puces" ng-if="issue.puces.length || redFlags.length">' +
				'    <li ng-repeat="p in issue.puces track by $index">{{p}}</li>' +
				'    <li ng-repeat="r in redFlags track by r.code">{{r.libelle}}</li>' +
				'  </ul>' +
				'  <p class="osy-orientation__associes" ng-if="issue.associesA">{{issue.associesA}}</p>' +
				'</div>'
		};
	}
})();

(function () {
    'use strict';
  
    angular.module('app.front')
      .service('DemarcheService', DemarcheService);
  
    function DemarcheService($q, $http) {
      var URL_DEMARCHE = '/api/rest/tacheGeneral/demarcheQualite';
  
      var findAnnualTasksByPharamcyAndPage = function (page) {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/annualTasks',
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: page
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      var findSelectedNotDoneTasksByPharmacy = function () {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/selectedNotDone',
            method: 'GET',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      var findDemarcheQualiteNotDoneTasksByPharmacy = function () {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/notDone',
            method: 'GET',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      var findDemarcheQualiteDoneTasksByPharmacy = function (page) {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/done',
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: page
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      var setSelected = function (ids) {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/select',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'ids': ids
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      var setDone = function (id) {
        return $q(function (resolve, reject) {
          $http({
            url: URL_DEMARCHE + '/done/' + id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (response) {
            reject(response);
          });
        });
      };
  
      return {
        findAnnualTasksByPharamcyAndPage: findAnnualTasksByPharamcyAndPage,
        findSelectedNotDoneTasksByPharmacy: findSelectedNotDoneTasksByPharmacy,
        findDemarcheQualiteNotDoneTasksByPharmacy: findDemarcheQualiteNotDoneTasksByPharmacy,
        findDemarcheQualiteDoneTasksByPharmacy: findDemarcheQualiteDoneTasksByPharmacy,
        setSelected: setSelected,
        setDone: setDone
      };
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('DemarcheController', DemarcheController);

  function DemarcheController($scope, toastr, DemarcheService, $state, $mdDialog, GENERAL_TASK_TYPES, $timeout,
    TachesGeneralesService, TASKS_EVENTS_REMINDERS, GENERAL_TASK_PERIOD, EquipeDetailService, GENERAL_TASK_TYPES_FIRST_YEAR_QUALITY) {
    var page = {
      annualTasks: {
        page: 0,
        output: 4
      },
      selectedDone: {
        page: 0,
        output: 4
      }
    };
    $scope.allLoaded = {
      annualTasks: false,
      selectedDone: false
    };

    $scope._baseResource = '/api/rest/tacheGeneral';
    $scope.annualTasks = [];
    $scope.tasksSelectedNotDone = [];
    $scope.tasksDone = [];
    $scope._users = [];
    $scope.fromQuality = true;
    $scope._categories = angular.copy(GENERAL_TASK_TYPES);
    $scope.reminders = angular.copy(TASKS_EVENTS_REMINDERS);
    $scope._recurrences = angular.copy(GENERAL_TASK_PERIOD);
    $scope.displayCheckBoxDone = true;
    var today = new Date();
    $scope.intoSaving = false;

    $scope.getAnnualTasks = function (reset) {
      if (reset) {
        page.annualTasks.page = 0;
        $scope.annualTasks = [];
        $scope.allLoaded.annualTasks = false;
      }

      DemarcheService.findAnnualTasksByPharamcyAndPage(page.annualTasks).then(function (data) {
        //if (data.length < page.annualTasks.output) {
          $scope.allLoaded.annualTasks = true;
        //}

        page.annualTasks.page++;

        $scope.annualTasks = $scope.annualTasks.concat(data);
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération des tâches annuelles');
      });
    };

    $scope.getTasksSelectedNotDone = function () {
      DemarcheService.findSelectedNotDoneTasksByPharmacy().then(function (data) {
        $scope.tasksSelectedNotDone = data;
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération des tâches à faire');
      });
    };

    $scope.getTasksSelectedDone = function (reset) {
      if (reset) {
        page.selectedDone.page = 0;
        $scope.tasksDone = [];
        $scope.allLoaded.selectedDone = false;
      }

      DemarcheService.findDemarcheQualiteDoneTasksByPharmacy(page.selectedDone).then(function (data) {
        if (data.length < page.selectedDone.output) {
          $scope.allLoaded.selectedDone = true;
        }

        page.selectedDone.page++;

        $scope.tasksDone = $scope.tasksDone.concat(data);
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération de tâches réalisées');
      });
    };

    $scope.goSelectionTasks = function () {
      $state.go('app.qualite.demarche.selection');
    };

    // Download
    $scope._downloadAttachement = function (_attachment) {
      location.href = $scope._baseResource + '/download/' + _attachment.id;
    };

    $scope._edit = function (task, isAnnual) {
      $scope.taskIsAnnual = isAnnual;
      $scope.addCollaborateurMode = false;
      $scope.editMode = true;
      $scope._task = angular.copy(task);

      if (task.hasOwnProperty('echeance') && task.echeance != null) {
        $scope.echeance = new Date(task.echeance);
      } else {
        $scope.echeance = angular.copy(today);
      }

      showTaskModal();
    };

    function showTaskModal($event){
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "DEMARCHE",
          datasource: {
            task: $scope._task,
            echeance: $scope.echeance
          },
        },
        controller: "DialogController"
      }).then(function(){
        if ($scope.taskIsAnnual) {
          $scope.getAnnualTasks(true);
        } else {
          $scope.getTasksSelectedNotDone();
          $scope.getTasksSelectedDone(true);
        }
      }).catch(function(){
                
      });
    }

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    // Save
    $scope._save = function () {
      if(!$scope.intoSaving){
        $scope.intoSaving=true;
        $scope._task.echeance = $scope.echeance.getTime();
        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }
        formData.append('dto', angular.toJson($scope._task));
        TachesGeneralesService.save(formData).then(function (response) {

          toastr.success('Sauvegardée avec succès.');
          $scope._closeDialog();
          $timeout(function(){
            $scope.intoSaving=false;
          });
          if ($scope.taskIsAnnual) {
            $scope.getAnnualTasks(true);
          } else {
            $scope.getTasksSelectedNotDone();
            $scope.getTasksSelectedDone(true);
          }
        }).catch(function (error) {
          $scope.intoSaving=false;
          console.log(error);
        });
      }
    };

    // Close dialog
    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    function init() {
      $scope.getAnnualTasks(false);
      $scope.getTasksSelectedNotDone();
      $scope.getTasksSelectedDone(false);
      $scope._categories = $scope._categories.concat(GENERAL_TASK_TYPES_FIRST_YEAR_QUALITY);

      // Users
      EquipeDetailService.getCollaborateurs().then(function (data) {
        $scope._users = data;
      }).catch(function (error) {
        console.log(error);
      });
    }

    init();
  }
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('CommunicationInterneController', CommunicationInterneController);

    function CommunicationInterneController($scope, $state) {
        $scope.goNotesInternes = function() {
            $state.go('app.qualite.communication-interne.notes-internes');
        };

        $scope.goAdministrationBandeau = function() {
            $state.go('app.qualite.communication-interne.administration-bandeau');
        };

        $scope.goCahierTransmission = function() {
            $state.go('app.qualite.communication-interne.cahier-transmission');
        };
    }
})();
(function () {
	'use strict';

	angular.module('app.front')
		.service('AutoEvaluationService', AutoEvaluationService);

	function AutoEvaluationService($q, $http) {
		var URL_AUTO_EVALUATION = "/api/rest/auto/evaluation";
		var working = false;

		var find = function () {
			return $q(function (resolve, reject) {
				$http({
					url: URL_AUTO_EVALUATION,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var save = function (fd) {
			return $q(function (resolve, reject) {
				if (working) {
					resolve(null);
				}

				working = true;
				$http({
					url: URL_AUTO_EVALUATION,
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": undefined },
					transformRequest: angular.identity,
					data: fd
				}).then(function (response) {
					working = false;
					resolve(response);
				}).catch(function (response) {
					working = false;
					reject(response);
				});
			});
		};

		var remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_AUTO_EVALUATION + "/" + id,
					method: "DELETE",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" },
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getDownloadLink = function (documentId) {
			return URL_AUTO_EVALUATION + "/download/" + documentId;
		};

		var findByPharmacyAndPage = function (page, nbrResults) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_AUTO_EVALUATION + "/list/" + page + "/" + nbrResults,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var addToODJ = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_AUTO_EVALUATION + "/addToODJ/" + id,
					method: "POST",
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						"Content-Type": "application/json; charset=UTF-8"
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		var findById = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_AUTO_EVALUATION + "/" + id,
					method: "GET",
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						"Content-Type": "application/json; charset=UTF-8"
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		return {
			find: find,
			save: save,
			remove: remove,
			getDownloadLink: getDownloadLink,
			findByPharmacyAndPage: findByPharmacyAndPage,
			addToODJ: addToODJ,
			findById: findById
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AutoEvaluationController', AutoEvaluationController);

  function AutoEvaluationController($scope, $state, $mdDialog, $window, toastr, AutoEvaluationService, PERMISSIONS) {
    $scope.satisfactions = [];
    $scope.permissions = PERMISSIONS;
    $scope.working = false;
    $scope.intoSaving = false;

    function initDocument() {
      $scope.document = {};
    }

    initDocument();

    $scope.refresh = function () {
      AutoEvaluationService.find().then(function (response) {
        $scope.satisfactions = response.data;
      }).catch(function (response) {

      });
    };
    $scope.refresh();

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.openAddFile = function () {
      $scope.editionMode = false;
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/auto-evaluation/add-auto-evaluation-popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initDocument();
      }).catch(function () {
        initDocument();
      });
    };

    $scope.openDeleteDocument = function (folder) {
      $scope.folderToDelete = angular.copy(folder);
      $scope.deleteFolderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/auto-evaluation/delete-auto-evaluation-popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.folderToDelete = {};
      }).catch(function () {
        $scope.folderToDelete = {};
      });
    };

    $scope.deleteFolder = function () {
      AutoEvaluationService.remove($scope.folderToDelete.id).then(function (response) {
        $scope.refresh();
        $scope.hidePopup();
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error('Auto-évaluation introuvable, veuillez actualiser la page');
        }
      });
    };

    $scope.download = function (doc) {
      if (doc) {
        $window.location.href = AutoEvaluationService.getDownloadLink(doc.id);
      } else if ($scope.autoEvaluationToDisplay && $scope.autoEvaluationToDisplay.id) {
        $window.location.href = AutoEvaluationService.getDownloadLink($scope.autoEvaluationToDisplay.id);
      }
    };

    $scope.saveDocument = function () {
      if ($scope.working) {
        return;
      }
      $scope.working = true;
      var input = document.getElementById('document_input_file');
      var file = null;
      if (input != null) {
        file = input.files[0];
      }
      var fd = new FormData();
      fd.append('file', file);
      fd.append('dto', angular.toJson($scope.document));
      AutoEvaluationService.save(fd).then(function (response) {
        $scope.refresh();
        $scope.hidePopup();
        $scope.working = false;
      }).catch(function (response) {
        $scope.working = false;
        toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
      });
    };

    $scope.addToODJ = function (autoeval) {
      if (autoeval.id != null) {
        AutoEvaluationService.addToODJ(autoeval.id).then(function (res) {
          toastr.success("Auto-évaluation ajoutéé à l'ordre du jour");
        }).catch(function (err) {
          console.log(err);
          toastr.error("Problème lors de l'ajout à l'ordre du jour");
        })
      } else {
        toastr.error("Problème lors de l'ajout à l'ordre du jour");
      }
    }

    $scope.display = function (autoEval) {
      $scope.autoEvaluationToDisplay = autoEval;
      $scope.autoEvalPopUp = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/auto-evaluation/display-auto-evaluation-popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.autoEvaluationToDisplay = {};
      }).catch(function () {
        $scope.autoEvaluationToDisplay = {};
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('FlashsController', FlashsController);

  function FlashsController($scope, toastr, TachesGeneralesService, $state, AutoControlesService, $mdDialog, GENERAL_TASK_TYPES, 
    TASKS_EVENTS_REMINDERS, GENERAL_TASK_PERIOD, EquipeDetailService, $stateParams, $timeout) {
    $scope.flashs = [];
    $scope.titleAutoCtrl = null;
    var paramsAutoCtrl = {};

    //TASK
    $scope._categories = GENERAL_TASK_TYPES;
    $scope._recurrences = GENERAL_TASK_PERIOD;
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope.fromAuto = ($state.current.name.lastIndexOf('app.qualite.auto-controles') > -1);
    $scope.addCollaborateurMode = false;
    $scope.intoSaving = false;

    if ($stateParams.autoCtrlID != null) {
      $scope.titleAutoCtrl = $stateParams.titleAutoCtrl;
      paramsAutoCtrl = {
        titleAutoCtrl: $stateParams.titleAutoCtrl,
        autoCtrlID: $stateParams.autoCtrlID
      };
      AutoControlesService.getFlashs($stateParams.autoCtrlID).then(function (data) {
        $scope.flashs = data;
      }).catch(function (err) {
        console.log("Error getFlashs()");
      });
    } else {
      $state.go('app.qualite.auto-controles');
    }

    $scope.goBack = function () {
      $state.go('app.qualite.auto-controles');
    }

    $scope.goFlash = function (flash) {
      $state.go('app.qualite.auto-controles.flash', {
        titleAutoCtrl: paramsAutoCtrl.titleAutoCtrl,
        autoCtrlID: paramsAutoCtrl.autoCtrlID,
        flashID: flash.id,
        titleFlash: flash.name
      })
    }

    //TASK
    $scope.onEcheanceChange = function (object) {
      object.echeance = object._echeance.valueOf();
    };

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {
      console.log(response);
    });

    $scope.planTache = function () {

      $scope._task = {};
      if ($scope.fromAuto) {
        for (var j = 0; j < $scope._categories.length; j++) {
          if ($scope._categories[j].value === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
            $scope._task.category = $scope._categories[j].value;
          }
        }
      }
      showTaskModal();
    }

    function showTaskModal(url){
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: url ? url : 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "QUALITE",
          datasource: {
            task: $scope._task
          }
        },
        controller: "DialogController"
      }).then(function(){
     
      }).catch(function(){
                
      });
    }

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    // Save
    $scope._save = function () {
      if(!$scope.intoSaving){
        $scope.intoSaving=true;
        $scope._task.echeance = $scope.echeance.getTime();
        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }
        formData.append('dto', angular.toJson($scope._task));
        TachesGeneralesService.save(formData).then(function (response) {
          toastr.success('Sauvegardée avec succès.');
          $scope._closeDialog();
          $timeout(function(){
            $scope.intoSaving=false;
          });
        }).catch(function (error) {
          $scope.intoSaving=false;
          console.log(error);
        });
      }
    };

    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    // Genration de document

    $scope.generateDoc = function () {
      var _type = "";
      if ($scope.titleAutoCtrl == "Accueillir les patients") {
        _type = "AUTO_CONTROLE_ACCUEIL_PATIENS";
      } else if ($scope.titleAutoCtrl == "Dispensation") {
        _type = "AUTO_CONTROLE_CONSEILLER_DISPERSER_PRODUITS";
      } else if ($scope.titleAutoCtrl == "Nouvelles missions") {
        _type = "AUTO_CONTROLE_PRENDRE_EN_CHARGE_NOUVELLES_MISSIONS";
      } else if ($scope.titleAutoCtrl == "Veille pharmaceutique") {
        _type = "AUTO_CONTROLE_VEILLE_PHARMA_TECH_ET_COMMERCIAL";
      } else if ($scope.titleAutoCtrl == "Préparations") {
        _type = "AUTO_CONTROLE_EFFECTUER_OU_SOUS_TRAITER_PREPARATION";
      } else if ($scope.titleAutoCtrl == "Commandes et stocks") {
        _type = "AUTO_CONTROLE_GERER_COMMANDE_ET_STOCK";
      } else if ($scope.titleAutoCtrl == "Facturation") {
        _type = "AUTO_CONTROLE_GERER_FACTURATION";
      }

      /*DocGenerationService.generateDocument(_type).then(function (response) {
      }).catch(function (error) {
        console.log(error);
      });*/

      var printWindow = window.open("/api/rest/docgeneration/download/support?type=" + _type);
      printWindow.print();

    };

  };
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('FlashController', FlashController);

    function FlashController($scope, $state, toastr, AutoControlesService, $stateParams, $mdDialog, EquipeDetailService) {
        $scope.flash = {};
        $scope.titleFlash = null;
        var paramsGoBack = {};
        $scope.collaborateurs = [];
        $scope.trueValue = true;
        $scope.falseValue = false;
        $scope.addCollaborateurMode = false;

        EquipeDetailService.getCollaborateurs().then(function (data) {
            $scope.collaborateurs = data;
        }).catch(function (err) {
            console.log("Error getCollaborateurs()");
        })

        if ($stateParams.flashID != null) {
            $scope.titleFlash = $stateParams.titleFlash;
            AutoControlesService.getFlashData($stateParams.flashID).then(function (data) {
                $scope.flash = data;
            }).catch(function (err) {
                console.log("Error getFlash()");
            });
        } else {
            $state.go('app.qualite.auto-controles');
        }

        if ($stateParams.autoCtrlID != null) {
            paramsGoBack = {
                autoCtrlID: $stateParams.autoCtrlID,
                titleAutoCtrl: $stateParams.titleAutoCtrl
            }
        }

        $scope.goBack = function () {
            $state.go('app.qualite.auto-controles.flashs', paramsGoBack);
        }

        $scope.validate = function () {
            $scope.submitting = true;
            AutoControlesService.saveFlashData($scope.flash).then(function (res) {
                $scope.submitting = false;
                $state.go('app.qualite.auto-controles.flashs', paramsGoBack);
            }).catch(function (err) {
                $scope.submitting = false;
                toastr.error('Erreur lors de l\'enregistrement');
                console.log("Error validate()");
            })
        }

        $scope.addCollaborateur = function () {
            if ($scope.addCollaborateurMode) {
                $scope.flash.newCollaborateur = {};
            } else {
                $scope.flash.collaborateurID = null;
            }

            $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
        }


        $scope.changeCollab = function (idSelected) {
            $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
            if (!idSelected) {
                $scope.collaborateur = {
                    name: null,
                    surname: null,
                    id: null,
                    fichePoste: {}
                };

                $scope.titlePopupSave = 'Ajouter un collaborateur';
                $scope.updateMode = false;
                $scope.descriptionMode = true;

                $scope.equipePopup = $mdDialog.show({
                    templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true,
                    controller: 'EquipeDetailController'
                }).then(function (data) {
                    $scope.flash.collaborateurID = data || $scope.idSelected;
                }).catch(function (error) {
                    $scope.flash.collaborateurID = null;
                });
                return;
            }
        };
    };
})();

(function () {
    'use strict';

    angular.module('app.front')
        .service('AutoControlesService', AutoControlesService);

    function AutoControlesService($q, $http) {
        var URL_AUTOCONTROLES = "/api/rest/autoControles";

        var getAutoCtrl = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: URL_AUTOCONTROLES + "/autoCtrl",
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response.data);
                }).catch(function (response) {
                    reject(response);
                });
            });
        }

        var getFlashs = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: URL_AUTOCONTROLES + "/flashs/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response.data);
                }).catch(function (response) {
                    reject(response);
                });
            });
        }

        var getFlashData = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: URL_AUTOCONTROLES + "/flashData/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response.data);
                }).catch(function (response) {
                    reject(response);
                });
            });
        }

        var saveFlashData = function (dto) {
            return $q(function (resolve, reject) {
                $http({
                    url: URL_AUTOCONTROLES + "/flashData",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        }

        var getFlashDataById = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: URL_AUTOCONTROLES + "/flashDataId/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response.data);
                }).catch(function (response) {
                    reject(response);
                });
            });
        }

        return {
            getAutoCtrl: getAutoCtrl,
            getFlashs: getFlashs,
            getFlashData: getFlashData,
            saveFlashData: saveFlashData,
            getFlashDataById: getFlashDataById
        };
    };
})();
(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('AutoControlesController', AutoControlesController);

    function AutoControlesController($scope, $state, AutoControlesService) {
        $scope.autoControles = [];
        $scope.order = 'index';

        AutoControlesService.getAutoCtrl().then(function(data) {
            $scope.autoControles = data;
        }).catch(function(err) {
            console.log("Error getAutoCtrl()");
        });

        $scope.goFlashs = function(autoCtrl) {
            $state.go('app.qualite.auto-controles.flashs', { autoCtrlID: autoCtrl.id, titleAutoCtrl: autoCtrl.name });
        }
    };
})();

(function () {
  'use strict';

  angular.module('app.front').service('AuditService', AuditService);

  function AuditService($q, $http) {
    var URL_AUDIT = "/api/rest/audit";

    var save = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var getAudits = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteAudit = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT + "/delete",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT + "/list/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getDownloadLink = function (id) {
      return URL_AUDIT + "/download/" + id;
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT + "/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var addToODJ = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT + "/addODJ/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var setConfidential = function (id, confidential) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_AUDIT + "/" + id + '/confidential',
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
            confidential: confidential
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return {
      save: save,
      getAudits: getAudits,
      getDownloadLink: getDownloadLink,
      deleteAudit: deleteAudit,
      findByPharmacyAndPage: findByPharmacyAndPage,
      addToODJ: addToODJ,
      findById: findById,
      setConfidential: setConfidential
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AuditController', AuditController);

  function AuditController($scope, $filter, toastr, $window, $state, $mdDialog, AuditService, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD,
    EquipeDetailService, TachesGeneralesService, DocumentService, PERMISSIONS, TASKS_EVENTS_REMINDERS, $timeout) {
    $scope.document = {
      auditName: null,
      comment: null
    };
    $scope._task = {};
    $scope._recurrences;
    $scope._users;
    $scope.fromAudit;
    $scope.audits = [];
    $scope.addTask = false;
    $scope.permissions = PERMISSIONS;
    $scope.fromAudit = ($state.current.name.lastIndexOf('app.qualite.audit') > -1);
    $scope.validFileAudit = true;
    $scope.working = false;

    $scope.audits = AuditService.getAudits().then(function (data) {
      $scope.audits = data;
      $scope.dataArray = Object.keys($scope.audits)
        .map(function (key) {
          return $scope.audits[key];
        });
    }).catch(function (err) {
      console.log(err);
    });

    $scope._dateToTimestamp = function (_date) {
      var _result = angular.copy(_date);
      return _result.getTime();
    };

    $scope.displayPopUpArchiveReport = function () {
      $scope.document = {
        auditName: null
      };
      $scope._task = {};
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/audit/popup/archive-report.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () { }).catch(function () { });
    }

    $scope.displayPopUpPlanTask = function () {
      $scope._task = {};
      $scope.fromAudit = true;
      $scope._categories = GENERAL_TASK_TYPES;
      $scope._recurrences = GENERAL_TASK_PERIOD;
      $scope.reminders = TASKS_EVENTS_REMINDERS;
      EquipeDetailService.getCollaborateurs().then(function (data) {
        $scope._users = data;
      }).catch(function (error) {
        console.log(error);
      });
      for (var j = 0; j < $scope._categories.length; j++) {
        if ($scope._categories[j].value === 'AUDITS_ET_ECARTS') {
          $scope._task.category = $scope._categories[j].value;
        }
      }

      showTaskModal();
    }

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "AUDIT",
          datasource: {
            task: $scope._task,
          },
        },
        controller: "DialogController"
      }).then(function () {
        // nothing
      }).catch(function () {

      });
    }

    // $scope._save = function () {
    //   if(!$scope.intoSaving){
    //     $scope.intoSaving=true;

    //     $scope._task.echeance = $scope.echeance.getTime();
    //     var file = document.getElementById('document_input_file').files[0];
    //     var formData = new FormData();
    //     if (file != null) {
    //       formData.append('file', file);
    //     }
    //     formData.append('dto', angular.toJson($scope._task));
    //     TachesGeneralesService.save(formData).then(function (response) {
    //       toastr.success('Sauvegardée avec succès.');
    //       $scope._closeDialog();
    //       $timeout(function(){
    //         $scope.intoSaving=false;
    //       });
    //     }).catch(function (error) {
    //       $scope.intoSaving=false;
    //       console.log(error);
    //     });
    //   }
    // };

    $scope._display = function (audit) {
      $scope.auditToDisplay = audit;
      $scope.deletePlanPopUp = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/audit/popup/display_audit.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.auditToDisplay = {};
      }).catch(function () {
        $scope.auditToDisplay = {};
      });
    }

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    $scope._closeDialog = function () {
      $mdDialog.hide();
    }

    $scope.setAddTask = function (state) {
      $scope.addTask = state;
    }

    $scope.saveDocument = function () {
      if ($scope.working) {
        return;
      }

      $scope.working = true;
      var input = document.getElementById('document_input_file');
      var file = null;
      if (input != null && input.files[0] != null) {
        file = input.files[0];
        $scope.fileName = file.name;

        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.document));

        AuditService.save(fd).then(function (data) {
          if (data != null) {
            $scope.audits.push(data);
            $scope.propertyName = 'uploadDate';
            $scope.reverse = true;
            $scope.audits = $filter('orderBy')($scope.audits, $scope.propertyName, $scope.reverse);
          }

          $scope.hidePopup();

          if ($scope.addTask) {
            $scope.displayPopUpPlanTask();
          }
          $scope.working = false;
        }).catch(function (response) {
          console.log(response);
          console.log("Error saveDocument()");
          $scope.working = false;
        });
      }
      else {
        $scope.validFileAudit = false;
        $scope.working = false;
      }
    }

    $scope.addOrdreJour = function (audit) {
      if (audit.id != null) {
        AuditService.addToODJ(audit.id).then(function (res) {
          toastr.success("Audit ajouté à l'ordre du jour");
        }).catch(function (err) {
          console.log(err);
          toastr.error("Problème lors de l'ajout à l'ordre du jour");
        })
      } else {
        toastr.error("Problème lors de l'ajout à l'ordre du jour");
      }
    }

    $scope.download = function (audit) {
      $window.location.href = AuditService.getDownloadLink(audit.id);
    };

    $scope.delete = function () {
      var dto = {
        id: $scope.auditToDelete.id,
        deleted: true
      };

      AuditService.deleteAudit(dto).then(function (res) {
        $scope.audits.splice($scope.indexToDelete, 1);
        $scope.hidePopup();
      }).catch(function (err) {

      });
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }


    $scope.displayDialogDelete = function (audit, index) {
      $scope.auditToDelete = angular.copy(audit);
      $scope.indexToDelete = index;
      $scope.deletePlanPopUp = $mdDialog.show({
        templateUrl: 'app/main/front/qualite/audit/popup/delete_audit.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.auditToDelete = {};
        $scope.indexToDelete = null;
      }).catch(function () {
        $scope.auditToDelete = {};
        $scope.indexToDelete = null;
      });
    }

    $scope.setConfidential = function (audit) {
      AuditService.setConfidential(audit.id, audit.confidential).then(function () {

      }).catch(function () {

      });
    };
  };
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('TableauDeBordService', TableauDeBordService);

  function TableauDeBordService($q, $http, $rootScope) {
    var URL_TABLEAUBORD = "/api/rest/indicateur";
    var URL_MALFUNCTIONS = "/api/rest/malfunction";

    var getIndicateursNotConfidential = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getDysfonctionnements = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_MALFUNCTIONS + "/graphDysfonctionnements",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getDysfonctionnementsEcor = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_MALFUNCTIONS + "/graphDysfonctionnementsEcor",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getGraphIndic = function (year, indicateurs) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_MALFUNCTIONS + "/graphIndicateurs",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateurs
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getDispensation = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_MALFUNCTIONS + "/graphDispensation",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getIndicateursActiveNotConfidential = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/actives/" + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getIndicateursConfidential = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/confidentials',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getIndicateursActiveConfidential = function (year, isTeam) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/confidentials/actives/' + year + '/' + isTeam,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getIndicateursArchived = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/archived/' + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getAllIndicateursArchived = function (begin, end) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/archived/all',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getYearsArchives = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/listYearsAchives",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listYears = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/years",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var hasArchived = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/hasArchived/' + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getIndicateursConfidentialArchived = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/confidentials/archived/' + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveIndicateur = function (indicateur) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateur
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getIndicateur = function (id, bool) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/find/' + id + "/" + !!bool,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteIndicateur = function (indicateur) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/delete',
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateur
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var archiveIndicateur = function (indicateur, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/archive/' + year,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateur
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveData = function (data) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/saveData',
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: data
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setActif = function (indicateur, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/active',
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateur
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setConfidential = function (indicateur) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/setConfidential',
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: indicateur
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var isAddWeatherOK = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + '/addWeatherOK',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findByPharmacyAndPage = function (page, nbrResults, weather) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/list/" + page + "/" + nbrResults + "/" + weather,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findWeather = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/weather",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var addToODJ = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/addToODJ/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var move = function (dto, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/move",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'year': year
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadXlsx = function (dtos, year, filename) {
      $http.post(URL_TABLEAUBORD + '/' + year + '/export', dtos,
        {
          responseType: 'arraybuffer'
        })
        .then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', 'valeurs_' + filename + '.xlsx');
          $rootScope.$broadcast('xlsxready');
          downloadLink[0].click();
        }).catch(function (error) {
          $rootScope.$broadcast('xlsxready');
          console.log(error);
        });
    };

    var getPagination = function (pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/paginated",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var findByIdAndYear = function (id, year, isTeam) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/" + id + '/' + year,
          method: "GET",
          params: { '_v': new Date().getTime(), isTeam: isTeam },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var findByIdsAndYear = function (dto, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TABLEAUBORD + "/compte-rendu",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    return {
      listYears: listYears,
      hasArchived: hasArchived,
      getIndicateursNotConfidential: getIndicateursNotConfidential,
      getIndicateursConfidential: getIndicateursConfidential,
      getIndicateursArchived: getIndicateursArchived,
      getAllIndicateursArchived: getAllIndicateursArchived,
      getIndicateursConfidentialArchived: getIndicateursConfidentialArchived,
      saveIndicateur: saveIndicateur,
      getIndicateur: getIndicateur,
      deleteIndicateur: deleteIndicateur,
      archiveIndicateur: archiveIndicateur,
      saveData: saveData,
      getIndicateursActiveConfidential: getIndicateursActiveConfidential,
      getIndicateursActiveNotConfidential: getIndicateursActiveNotConfidential,
      setActif: setActif,
      setConfidential: setConfidential,
      isAddWeatherOK: isAddWeatherOK,
      findByPharmacyAndPage: findByPharmacyAndPage,
      getYearsArchives: getYearsArchives,
      findWeather: findWeather,
      addToODJ: addToODJ,
      move: move,
      getDysfonctionnements: getDysfonctionnements,
      getDysfonctionnementsEcor: getDysfonctionnementsEcor,
      getGraphIndic: getGraphIndic,
      getDispensation: getDispensation,
      downloadXlsx: downloadXlsx,
      getPagination: getPagination,
      findByIdAndYear: findByIdAndYear,
      findByIdsAndYear: findByIdsAndYear
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('TableauDeBordController', TableauDeBordController);

  function TableauDeBordController($scope, $state, $rootScope, TableauDeBordService, $mdDialog, PERMISSIONS, toastr,
    TABLEAU_BORD_PERIODS, $timeout) {
    // helpers
    var quarterOfTheYear = function (date) {
      var month = date.getMonth() + 1;
      return (Math.floor(month / 3));
    };

    var today = new Date();
    $scope.yearChosen = today.getFullYear();
    $scope.currentYear = today.getFullYear();
    $scope.currentMonth = today.getMonth();
    $scope.currentQuarter = quarterOfTheYear(today);
    $scope.indicateurs = [];
    $scope.indicateursArchived = [];
    $scope.periods = TABLEAU_BORD_PERIODS;
    $scope.permissions = PERMISSIONS;
    $scope.years = [];
    $scope.orderMode = {
      active: false
    };
    $scope.hasArchive = false;
    $scope.archiveEmpty = true;
    $scope.archive = { value: 'none' };
    $scope.archiveMonth = { value: 'none', index: 0 };
    $scope.type = 'none';

    $scope.changeYear = function (operator) {
      $scope.yearChosen = operator === 'plus' ? $scope.yearChosen + 1 : $scope.yearChosen - 1;
      $scope.hasArchive = false;
      $scope.getIndicateurs();
    };

    $scope.getIndicateurs = function () {
      $scope.archiveEmpty = true;
      TableauDeBordService.hasArchived($scope.yearChosen).then(function (response) {
        $scope.hasArchive = response;
        if ($scope.hasArchive) {
          $scope.searchArchives('YEAR');
        }
      }).catch(function (error) {
        console.log(error);
      });

      if ($rootScope.user) {
        if ($rootScope.user.isTitulaire || $rootScope.user.isPraq) {
          TableauDeBordService.getIndicateursActiveConfidential($scope.yearChosen, $rootScope.user.isTeam).then(function (data) {
            $scope.indicateursSpecials = data.filter(function (element) {
              if ((element.status === 'MALFUNCTION' || element.status === 'DISPENSATION' || element.status === 'DYNAMIC' || element.status === 'ECOR') && element.dataIndicateurs.length > 0) {
                return element;
              }
            });
            $scope.indicateurs = data.filter(function (element) {
              if ((element.status !== 'MALFUNCTION' && element.status !== 'DISPENSATION' && element.status !== 'DYNAMIC' && element.status !== 'ECOR') && element.dataIndicateurs.length > 0) {
                return element;
              }
            });
          }).catch(function (err) {
            console.log('Error getIndicateurs() titulaire');
          });
        } else {
          TableauDeBordService.getIndicateursActiveNotConfidential($scope.yearChosen).then(function (data) {
            $scope.indicateursSpecials = data.filter(function (element) {
              if ((element.status === 'MALFUNCTION' || element.status === 'DISPENSATION' || element.status === 'DYNAMIC' || element.status === 'ECOR') && element.dataIndicateurs.length > 0) {
                return element;
              }
            });
            $scope.indicateurs = data.filter(function (element) {
              if ((element.status !== 'MALFUNCTION' && element.status !== 'DISPENSATION' && element.status !== 'DYNAMIC' && element.status !== 'ECOR') && element.dataIndicateurs.length > 0) {
                return element;
              }
            });
          }).catch(function (err) {
            console.log('Error getIndicateurs() no titulaire');
          });
        }
      } else {
        var listener = $scope.$on('rooScopeUser:ready', function (event, data) {
          $scope.getIndicateurs();
          listener();
        });
      }
    };

    $timeout(function () {
      $scope.getIndicateurs();
    });

    $scope.getYearsArchive = function () {
      TableauDeBordService.listYears().then(function (response) {
        $scope.years = [];
        if (response.length === 2) {
          var minYear = new Date(response[0].value).getFullYear();
          var maxYear = new Date(response[1].value).getFullYear();
          var i = maxYear;
          while (i >= minYear && i <= maxYear) {
            $scope.years.push({
              value: i
            });
            i--;
          }
        } else if (response.length === 1) {
          $scope.years.push({
            value: new Date(response[0].value).getFullYear()
          });
        }
      }).catch(function () {
        //$state.go('app.home');
      });
    };

    $scope.getYearsArchive();

    $scope.setConfidentiel = function (indicateur, state) {
      if (state) {
        indicateur.weather = false;
      }

      var indicateurSend = state ? {
        id: indicateur.id,
        confidential: state,
        weather: false
      } :
        {
          id: indicateur.id,
          confidential: state
        };

      TableauDeBordService.setConfidential(indicateurSend).then(function (data) {
        if ($rootScope.user) {
          if ($rootScope.user.isTitulaire || $rootScope.user.isPraq) {
            indicateur.confidential = state;
          } else {
            for (var i = 0; i < $scope.indicateurs.length; i++) {
              if ($scope.indicateurs[i].id === indicateur.id) {
                $scope.indicateurs.splice(i, 1);
                break;
              }
            }
          }
        }

      }).catch(function (err) {
        console.log('Error archive()');
      });
    };

    $scope.goAddIndicateur = function () {
      $state.go('app.performances.tableau-de-bord.add-indicateur');
    };

    $scope.move = function (indicateur, up) {
      var dto = {
        id: indicateur.id,
        up: up
      };

      TableauDeBordService.move(dto, $scope.yearChosen).then(function (res) {
        $scope.getIndicateurs();
      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.searchArchives = function (type) {
      $scope.type = type;
      $scope.indicateursArchived = [];
      if (type === 'YEAR') {
        if ($rootScope.user) {
          TableauDeBordService.getIndicateursArchived($scope.yearChosen).then(function (response) {
            $scope.indicateursArchived = response;
            $scope.months = [];
          }).catch(function () {
            toastr.error('Impossible de récupérer les dysfonctionnements');
            $scope.indicateursArchived = [];
          });
        }
      }
    };

    $scope.showPopUpArchive = function (indicateur, index, unarchive) {
      $scope.indicateurArchive = indicateur;
      $scope.indexArchive = index;
      $scope.unarchive = unarchive;

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/archive_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.archiveIndicateur = function () {
      var indicateurSend = {
        id: $scope.indicateurArchive.id,
        archived: !$scope.unarchive
      };

      TableauDeBordService.archiveIndicateur(indicateurSend, $scope.yearChosen).then(function (data) {
        if (!$scope.unarchive) {
          $scope.indicateurs.splice($scope.indexArchive, 1);
          $scope.getIndicateurs();
          $scope.searchArchives($scope.type);
        } else {
          $scope.indicateursArchived.splice($scope.indexArchive, 1);
          $scope.getIndicateurs();
        }
        $scope.searchArchives($scope.type);
        $scope.getYearsArchive();
        $scope.hidePopup();
      }).catch(function (err) {
        console.log('Error archive()');
      });
    };

    $scope.delete = function () {
      var indicateurSend = {
        id: $scope.indicateurDelete.id,
        deleted: true
      };

      TableauDeBordService.deleteIndicateur(indicateurSend).then(function (data) {
        $scope.hidePopup();
        $scope.indicateurs.splice($scope.indexDelete, 1);
      }).catch(function (err) {
        console.log('Error archive()');
      });
    };

    $scope.showPopUpDelete = function (indicateur, index) {
      $scope.indicateurDelete = indicateur;
      $scope.indexDelete = index;

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/delete_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.update = function (indicateur, index) {
      TableauDeBordService.isAddWeatherOK().then(function (res) {
        $scope.isAddWeatherOK = !!res;
        $scope.indicWeather = indicateur.weather;
      }).catch(function (err) {
        console.log('Error isAddWeatherOK()');
      });

      $scope.titlePopupSave = 'Modifier un indicateur';
      $scope.updateMode = true;
      $scope.indicateur = angular.copy(indicateur);
      $scope.indicateur.goal = parseFloat($scope.indicateur.goal);
      $scope.indexUpdate = index;

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/add_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.saveIndicateur = function () {
      var indicateur = angular.copy($scope.indicateur);
      if (indicateur.goal != null && !Number.isNaN(indicateur.goal)) {
        indicateur.goal = parseFloat(indicateur.goal);
      }
      TableauDeBordService.saveIndicateur(indicateur).then(function (res) {
        $mdDialog.hide();
        if ($scope.indicateur.confidential) {
          $scope.indicateur.weather = false;
        }
        $scope.indicateurs[$scope.indexUpdate] = res;
      }).catch(function (err) {
        console.log('Error saveIndicateur()');
        console.log(err);
      });
    };

    $scope.checkWeather = function () {
      if ($scope.indicateur.confidential) {
        $scope.indicateur.weather = false;
      }
    };

    $scope.saveChanges = function () {
      var data = [];

      for (var i = 0; i < $scope.indicateurs.length; i++) {
        for (var y = 0; y < $scope.indicateurs[i].dataIndicateurs.length; y++) {
          if ($scope.indicateurs[i].dataIndicateurs[y].changed != null && $scope.indicateurs[i].dataIndicateurs[y].changed === true) {
            data.push({
              id: $scope.indicateurs[i].dataIndicateurs[y].id,
              value: $scope.indicateurs[i].dataIndicateurs[y].value
            });
          }
        }
      }

      if (data !== []) {
        $scope.submitting = true;
        TableauDeBordService.saveData(data).then(function (data) {
          for (var i = 0; i < $scope.indicateurs.length; i++) {
            for (var y = 0; y < $scope.indicateurs[i].dataIndicateurs.length; y++) {
              $scope.indicateurs[i].dataIndicateurs[y].changed = false;
            }
          }

          $scope.submitting = false;
        }).catch(function (err) {
          $scope.submitting = false;
          console.log('Error saveChanges()');
        });
      }
    };

    $scope.saveOne = function (dataIndicateur) {
      if (dataIndicateur.value == "") {
        dataIndicateur.value = null;
      }
      TableauDeBordService.saveData([dataIndicateur]).then(function (data) {
        dataIndicateur.changed = false;
        $rootScope.$broadcast('refreshCountNotifs');
      }).catch(function (err) {
        console.log('Error saveChanges()');
      });
    };

    $scope.inputChanged = function (dataIndicateur) {
      if (dataIndicateur.changed == null) {
        dataIndicateur.changed = true;
      }
      if (dataIndicateur.value != null) {
        dataIndicateur.value = dataIndicateur.value.replace(',', '.');
        dataIndicateur.value = dataIndicateur.value.replace(' ', '');
      }
      $scope.saveOne(dataIndicateur);
    };

    $scope.inputUpdated = function (dataIndicateur) {
      if (dataIndicateur.changed == null) {
        dataIndicateur.changed = true;
      }
    };

    $scope.popUpGenerateGraphs = function () {
      $scope.graphs = angular.copy($scope.indicateursSpecials);
      Array.prototype.push.apply($scope.graphs, angular.copy($scope.indicateurs));

      for (var i = 0; i < $scope.graphs.length; i++) {
        $scope.graphs[i].generate = false;
      }

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/generate_graphs.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.generateGraph = function (indicateur) {
      $scope.graphs = [indicateur];
      $scope.graphs[0].generate = true;
      $scope.generateGraphs();
    };

    $scope.addToODJ = function (indic) {
      if (indic.id != null) {
        TableauDeBordService.addToODJ(indic.id).then(function (res) {
          toastr.success('Indicateur ajouté à l\'ordre du jour');
        }).catch(function (err) {
          console.log(err);
          toastr.error('Problème lors de l\'ajout à l\'ordre du jour');
        });
      } else {
        toastr.error('Problème lors de l\'ajout à l\'ordre du jour');
      }
    };

    $scope.generateGraphs = function () {
      $state.go('app.performances.graphs', {
        indicateurs: $scope.graphs,
        year: $scope.yearChosen
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.$on('$destroy', function () {
      $scope.saveChanges();
    });

    $scope.showArchive = function () {
      $scope.archiveEmpty = !$scope.archiveEmpty;
    };

    $scope.checkWeatherClass = function (indicateur, data) {
      var monthly = indicateur.period === 'MONTHLY';
      var quarterly = indicateur.period === 'QUARTERLY';
      var annual = indicateur.period === 'ANNUAL';
      var previousMonthIndex = $scope.currentMonth - 1;
      var lastYear = $scope.currentYear - 1;

      if (indicateur.weather) {
        if (monthly) {
          if ($scope.currentMonth === 0) {
            if (lastYear === $scope.yearChosen && data.index === 11) {
              return true;
            }
          } else if (data.index === previousMonthIndex && $scope.currentYear === $scope.yearChosen) {
            return true;
          }
        } else if (quarterly) {
          if ($scope.currentMonth === 0) {
            if (lastYear === $scope.yearChosen && data.index === 3) {
              return true;
            }
          } else {
            if (quarterOfTheYear(new Date($scope.currentYear, previousMonthIndex, 1)) === data.index && $scope.currentYear === $scope.yearChosen) {
              return true;
            }
          }
        } else if (annual) {
          if ($scope.currentMonth === 0) {
            if (lastYear === $scope.yearChosen) {
              return true;
            }
          } else {
            if ($scope.currentYear === $scope.yearChosen) {
              return true;
            }
          }
        }
        // if ($scope.currentYear === $scope.yearChosen) {
        //   if ((monthly && data.index === previousMonthIndex) || (quarterly && data.index === previousQuarterIndex) || annual) {
        //     return true;
        //   }
        // }
        // if (lastYear === $scope.yearChosen) {
        //   if ((monthly && data.index === 11 && $scope.currentMonth === 0) || (quarterly && data.index === 3 && $scope.currentQuarter === 0) || annual) {
        //     return true;
        //   }
        // }
      }

      return false;
    }

    $scope.checkGoalOK = function (data, indicateur) {
      if (indicateur.goalType != null && indicateur.goal != null && data.value != null) {
        if (indicateur.goalType === 'HIGHER') {
          return data.value > indicateur.goal;
        } else if (indicateur.goalType === 'LOWER') {
          return data.value < indicateur.goal;
        }
      }
      return null;
    };

    $scope.average = function (dataIndicateurs) {
      var nb = 0;
      var sum = 0;
      dataIndicateurs.forEach(function (data) {
        if (data.value != null && !Number.isNaN(data.value)) {
          nb++;
          sum += parseFloat(data.value);
        }
      });
      if (nb !== 0) {
        var average = sum / nb;
        if (Number.isInteger(average)) {
          return average;
        } else {
          return average.toFixed(2);
        }
      } else {
        return 0;
      }
    };

    $scope.isToday = function (data, period) {
      var today = new Date();
      var isToday = false;
      if (period === 'mensuel') {
        isToday = data.index === today.getMonth();
      } else if (period === 'trimestriel') {
        var trimestre = (today.getMonth() + 1) / 4;
        isToday = trimestre < data.index + 1;
      } else if (period === 'annuel') {
        isToday = true;
      }
      return isToday;
    };

    $scope.printNumber = function (nb) {
      if (Number.isInteger(nb)) {
        return nb;
      } else {
        return nb.toFixed(2);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('GraphsController', GraphsController);

  function GraphsController($rootScope, $scope, $state, $stateParams, $filter, $mdDialog, toastr, TableauDeBordService, MalfunctionService) {
    // set defaults to get minimum line width for general charts and doughnuts
    Chart.defaults.global.legend.generateLabels = function (chart) {
      var data = chart.data;
      return Chart.helpers.isArray(data.datasets) ? data.datasets.map(function (dataset, i) {
        return {
          text: dataset.label,
          fillStyle: (!Chart.helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
          hidden: !chart.isDatasetVisible(i),
          lineCap: dataset.borderCapStyle,
          lineDash: dataset.borderDash,
          lineDashOffset: dataset.borderDashOffset,
          lineJoin: dataset.borderJoinStyle,
          lineWidth: 0.01,
          strokeStyle: dataset.borderColor,
          pointStyle: dataset.pointStyle,

          // Below is extra data used for toggling the datasets
          datasetIndex: i
        };
      }, this) : [];
    };

    Chart.defaults.doughnut.legend.generateLabels = function (chart) {
      var data = chart.data;
      if (data.labels.length && data.datasets.length) {
        return data.labels.map(function (label, i) {
          var meta = chart.getDatasetMeta(0);
          var ds = data.datasets[0];
          var arc = meta.data[i];
          var custom = arc && arc.custom || {};
          var valueAtIndexOrDefault = Chart.helpers.valueAtIndexOrDefault;
          var arcOpts = chart.options.elements.arc;
          var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
          var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);

          return {
            text: label,
            fillStyle: fill,
            strokeStyle: stroke,
            lineWidth: 0.01,
            hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

            // Extra data used for toggling the correct item
            index: i
          };
        });
      }
      return [];
    };
    var widthImgInPDF = 180;
    var offset = 0;
    var doughnutOffset = 59;
    var doughnutWidth = 91;
    var textMargin = 33;
    var titleFontSize = 22;
    var goalFontSize = 6;
    $scope.graphsDisplayed = [];
    $scope.dysfonctionnements = [];
    $scope.dysfonctionnementsEcor = [];
    $scope.dispensationErrors = [];
    $scope.inLoad = false;
    $scope.loadingXlsx = false;





    $scope.goBack = function () {
      $scope.graphsDisplayed = [];
      $scope.graphs = [];
      $state.go('app.performances.tableau-de-bord');
    }
    $scope.getDysfonctionnements = function () {
      $scope.dysfonctionnements = [];

      TableauDeBordService.getDysfonctionnements($scope.year).then(function (response) {
        response.forEach(function (dysf) {
          $scope.dysfonctionnements.push(dysf);
        });

        setTimeout(function () {
          $scope.generateDysfonctionnements();
        })
      }).catch(function (error) {
        console.log(error);
      });
    }

    $scope.getDysfonctionnementsEcor = function () {
      $scope.dysfonctionnementsEcor = [];

      TableauDeBordService.getDysfonctionnementsEcor($scope.year).then(function (response) {
        response.forEach(function (dysf) {
          $scope.dysfonctionnementsEcor.push(dysf);
        });

        setTimeout(function () {
          $scope.generateDysfonctionnementsEcor();
        })
      }).catch(function (error) {
        console.log(error);
      });
    }


    $scope.dispensationAnyDetected = false;
    $scope.dispensationAnyDelivered = false;
    $scope.dispensationAnyError = false;

    $scope.getDispensation = function () {
      $scope.dispensationErrors = [];
      TableauDeBordService.getDispensation($scope.year).then(function (response) {

        response.forEach(function (disp) {
          if (disp.dispensation) {
            if (disp.dispensation.detector) {
              $scope.dispensationAnyDetected = true;
            }

            if (disp.dispensation.delivered != null) {
              $scope.dispensationAnyDelivered = true;
            }

            if (disp.dispensation.error != null) {
              $scope.dispensationAnyError = true;
            }
          }

          $scope.dispensationErrors.push(disp);
        });

        setTimeout(function () {
          $scope.generateDispensation();
        })

      }).catch(function (error) {
        console.log(error);
      });
    }


    $scope.getPerPriority = function (list, priority, month) {
      var dateBegin = new Date();
      dateBegin.setFullYear($scope.year);
      dateBegin.setMonth(month, 1);
      dateBegin.setHours(0, 0, 0, 0);


      var dateEnd = moment(dateBegin).add(1, 'M').add(-1, 'ms').toDate();


      var tmp = [];

      list.forEach(function (element) {
        if (element.creation >= dateBegin.getTime() && element.creation <= dateEnd.getTime() && !element.type.pharmacy) {

          if (element.priority == priority) {
            tmp.push(element);
          }
        }
      });
      return tmp.length;
    }

    $scope.getPerStatus = function (indexType, status) {
      var tmp = [];

      $scope.dysfonctionnements.forEach(function (dysf) {
        if (dysf.type.index == indexType) {
          switch (status) {
            case 'NON_TRAITE':
              if (!dysf.hasProgressForm && dysf.activated) {
                tmp.push(dysf);
              }
              break;
            case 'IN_PROGRESS':
              if (dysf.hasProgressForm && dysf.activated) {
                tmp.push(dysf);
              }
              break;
            case 'CLOTURED':
              if (dysf.activated == false) {
                tmp.push(dysf);
              }
              break;

            default:
              break;
          }
        }
      });
      return tmp.length;
    }

    $scope.getPerStatusEcor = function (indexType, status) {
      var tmp = [];

      $scope.dysfonctionnementsEcor.forEach(function (dysf) {
        if (dysf.type.index == indexType) {
          switch (status) {
            case 'NON_TRAITE':
              if (!dysf.hasProgressForm && dysf.activated) {
                tmp.push(dysf);
              }
              break;
            case 'IN_PROGRESS':
              if (dysf.hasProgressForm && dysf.activated) {
                tmp.push(dysf);
              }
              break;
            case 'CLOTURED':
              if (dysf.activated == false) {
                tmp.push(dysf);
              }
              break;

            default:
              break;
          }
        }
      });
      return tmp.length;
    }

    $scope.getByType = function (type) {
      var tmp = [];
      $scope.dysfonctionnements.forEach(function (dysf) {
        if (dysf.type.index == type) {
          tmp.push(dysf);
        }
      });
      return tmp.length;
    }

    $scope.getByDomain = function (domain) {
      var tmp = [];
      $scope.dysfonctionnementsEcor.forEach(function (dysf) {
        if (dysf.ecorDomain == domain) {
          tmp.push(domain);
        }
      });
      return tmp.length;
    }

    $scope.getByError = function (error) {
      var tmp = [];
      $scope.dispensationErrors.forEach(function (disp) {
        if (disp.dispensation && disp.dispensation.error) {
          if (disp.dispensation.error == error) {
            tmp.push(disp);
          }
        }
      });
      return tmp.length;
    }


    $scope.getByDetected = function (detectorEnum) {
      var tmp = [];

      $scope.dispensationErrors.forEach(function (element) {
        if (element.dispensation) {
          if (element.dispensation.detector) {
            if (element.dispensation.detector === detectorEnum) {
              tmp.push(element);
            }
          }
        }
      });
      return tmp.length;
    }

    $scope.getByDelivered = function (value) {
      var tmp = [];

      $scope.dispensationErrors.forEach(function (element) {
        if (element.dispensation) {
          if (element.dispensation.delivered != null && element.dispensation.delivered == value) {
            tmp.push(element);
          }
        }
      })
      return tmp.length;
    }

    $scope.generateDysfonctionnements = function () {
      var graphDysfonctDataPerPriority = {
        labels: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [{
          label: 'Importance faible',
          backgroundColor: '#B0CAD6',
          data: [
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 0),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 1),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 2),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 3),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 4),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 5),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 6),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 7),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 8),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 9),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 10),
            $scope.getPerPriority($scope.dysfonctionnements, 'LOW', 11)
          ]
        }, {
          label: 'Importance moyenne',
          backgroundColor: '#3CB4A1',
          data: [
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 0),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 1),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 2),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 3),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 4),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 5),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 6),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 7),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 8),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 9),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 10),
            $scope.getPerPriority($scope.dysfonctionnements, 'NORMAL', 11)
          ]
        }, {
          label: 'Importance forte',
          backgroundColor: '#007D8C',
          data: [
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 0),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 1),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 2),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 3),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 4),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 5),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 6),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 7),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 8),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 9),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 10),
            $scope.getPerPriority($scope.dysfonctionnements, 'HIGH', 11)
          ]
        }]
      };

      var graphDysfonctDataPerStatus = {
        labels: ['Dysfonctionnement', 'Insatisfaction client', 'Défaillance prestataire', 'Suggestion'],
        datasets: [{
          label: 'Non traité',
          backgroundColor: '#B0CAD6',
          data: [
            $scope.getPerStatus(1, 'NON_TRAITE'),
            $scope.getPerStatus(3, 'NON_TRAITE'),
            $scope.getPerStatus(4, 'NON_TRAITE'),
            $scope.getPerStatus(5, 'NON_TRAITE'),
          ]
        }, {
          label: 'Fiche de progrès ouverte',
          backgroundColor: '#3CB4A1',
          data: [
            $scope.getPerStatus(1, 'IN_PROGRESS'),
            $scope.getPerStatus(3, 'IN_PROGRESS'),
            $scope.getPerStatus(4, 'IN_PROGRESS'),
            $scope.getPerStatus(5, 'IN_PROGRESS'),
          ]
        }, {
          label: 'Clôturé',
          backgroundColor: '#007D8C',
          data: [
            $scope.getPerStatus(1, 'CLOTURED'),
            $scope.getPerStatus(3, 'CLOTURED'),
            $scope.getPerStatus(4, 'CLOTURED'),
            $scope.getPerStatus(5, 'CLOTURED'),
          ]
        }]
      };

      $scope.config = {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [
              $scope.getByType(1),
              $scope.getByType(3),
              $scope.getByType(4),
              $scope.getByType(5)
            ],
            backgroundColor: [
              '#445E7E',
              '#3CB4A1',
              '#B0CAD6',
              '#999999'
            ],
            label: 'TYPES DE DYSFONCTIONNEMENT:'
          }],
          labels: [
            'Dysfonctionnement',
            'Insatisfaction client',
            'Défaillance prestataire',
            'Suggestion'
          ]
        },
        options: {
          legend: {
            display: true,
            position: 'right',
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              fontSize: 11,
              fontStyle: '600',
              filter: function (legend, chartData) {
                var theData = chartData.datasets[0].data;
                var metaData = Object.entries(chartData.datasets[0]._meta)[0][1].data;
                var dataFiltered = theData.map(function (elm, index) {
                  return { ind: index, value: elm, hidden: metaData[index].hidden };
                });
                var currentValue = dataFiltered[legend.index].hidden ? 0 : dataFiltered[legend.index].value;
                var total = dataFiltered.reduce(function (acc, current) {
                  return current.hidden ? acc : acc + current.value;
                }, 0);
                var percent = parseFloat((currentValue / total * 100).toFixed(1));
                if (percent) {
                  legend.text += '  (' + Math.round(percent) + '%)';
                }
                else {
                  legend.text += '  (0%)';
                }
                return legend;
              },
              generateLabels: Chart.defaults.doughnut.legend.generateLabels
            }
          },
          responsive: true,
          title: {
            display: true,
            position: 'top',
            text: 'TYPES DE DYSFONCTIONNEMENT :',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',

            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 9,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var currentValue = dataset.data[tooltipItem.index];
                var percent = Math.floor(((currentValue / $scope.dysfonctionnements.filter(function (value) { return !value.type.pharmacy; }).length) * 100) + 0.5);
                return data.labels[tooltipItem.index] + " " + percent + "%";
              }
            }
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          elements: {
            arc: {
              borderWidth: 0
            }
          }
        }
      };
      var ctx = document.getElementById('canvasDysfPriority').getContext('2d');
      var ctx2 = document.getElementById('canvasDysfStatus').getContext('2d');
      $scope.myBarConfig = {
        type: 'bar',
        data: graphDysfonctDataPerPriority,
        options: {
          legend: {
            display: true,
            position: "top",
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              padding: 16,
              fontSize: 11,
              strokeStyle: '#f00',
              fontStyle: "600",
              generateLabels: Chart.defaults.global.legend.generateLabels
            }
          },
          title: {
            display: true,
            position: 'top',
            text: 'NOMBRE DE DYSFONCTIONNEMENTS (dont défaillance prestataire, insatisfaction client et suggestion)',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

            callbacks: {
              label: function (tooltipItem, data) {
                var forte = '   Forte:          ' + data.datasets[2].data[tooltipItem.index];
                var moyenne = '   Moyenne:   ' + data.datasets[1].data[tooltipItem.index];
                var faible = '   Faible:        ' + data.datasets[0].data[tooltipItem.index];

                if (tooltipItem.datasetIndex == 0) {
                  return faible;
                } else if (tooltipItem.datasetIndex == 1) {
                  return moyenne;
                } else {
                  return forte;
                }
              },
              title: function (tooltipItem) {
                var title = $scope.getMonthString(tooltipItem[0].xLabel);
                return title;
              }
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10,
                padding: 10,
                beginAtZero: true,

                callback: function (value) { if (value % 1 === 0) { return value; } }

              }
            }]
          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          }
        }
      };
      var myBar = new Chart(ctx, $scope.myBarConfig);

      $scope.myBar2Config = {
        type: 'bar',
        data: graphDysfonctDataPerStatus,
        options: {
          legend: {
            display: true,
            position: "top",
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              padding: 16,
              fontSize: 11,
              strokeStyle: '#f00',
              fontStyle: "600",
              generateLabels: Chart.defaults.global.legend.generateLabels
            }
          },
          title: {
            display: true,
            position: 'top',
            text: 'STATUT DES DYSFONCTIONNEMENTS (dont défaillance prestataire, insatisfaction client et suggestion)',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                beginAtZero: true,
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10,
                padding: 10,

                callback: function (value) { if (value % 1 === 0) { return value; } }
              }
            }]
          }
        }
      };

      var myBar2 = new Chart(ctx2, $scope.myBar2Config);

      if ($scope.dysfonctionnements.length > 0) {
        var ctx3 = document.getElementById('canvasDysfType').getContext('2d');
        var myDoughnut = new Chart(ctx3, $scope.config);
      }

    }

    $scope.generateDysfonctionnementsEcor = function () {
      var graphDysfonctDataPerPriority = {
        labels: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [{
          label: 'Importance faible',
          backgroundColor: '#B0CAD6',
          data: [
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 0),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 1),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 2),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 3),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 4),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 5),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 6),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 7),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 8),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 9),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 10),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'LOW', 11)
          ]
        }, {
          label: 'Importance moyenne',
          backgroundColor: '#3CB4A1',
          data: [
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 0),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 1),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 2),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 3),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 4),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 5),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 6),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 7),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 8),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 9),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 10),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'NORMAL', 11)
          ]
        }, {
          label: 'Importance forte',
          backgroundColor: '#007D8C',
          data: [
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 0),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 1),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 2),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 3),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 4),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 5),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 6),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 7),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 8),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 9),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 10),
            $scope.getPerPriority($scope.dysfonctionnementsEcor, 'HIGH', 11)
          ]
        }]
      };

      var graphDysfonctDataPerStatus = {
        labels: ['Dysfonctionnement 🌿 ECOR'],
        datasets: [{
          label: 'Non traité',
          backgroundColor: '#B0CAD6',
          data: [
            $scope.getPerStatusEcor(6, 'NON_TRAITE')
          ]
        }, {
          label: 'Fiche de progrès ouverte',
          backgroundColor: '#3CB4A1',
          data: [
            $scope.getPerStatusEcor(6, 'IN_PROGRESS')
          ]
        }, {
          label: 'Clôturé',
          backgroundColor: '#007D8C',
          data: [
            $scope.getPerStatusEcor(6, 'CLOTURED')
          ]
        }]
      };


      var ctx = document.getElementById('canvasDysfEcorPriority').getContext('2d');
      var ctx2 = document.getElementById('canvasDysfEcorStatus').getContext('2d');
      $scope.myBarConfig = {
        type: 'bar',
        data: graphDysfonctDataPerPriority,
        options: {
          legend: {
            display: true,
            position: "top",
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              padding: 16,
              fontSize: 11,
              strokeStyle: '#f00',
              fontStyle: "600",
              generateLabels: Chart.defaults.global.legend.generateLabels
            }
          },
          title: {
            display: true,
            position: 'top',
            text: 'Nombre de dysfonctionnements 🌿 ECOR',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

            callbacks: {
              label: function (tooltipItem, data) {
                var forte = '   Forte:          ' + data.datasets[2].data[tooltipItem.index];
                var moyenne = '   Moyenne:   ' + data.datasets[1].data[tooltipItem.index];
                var faible = '   Faible:        ' + data.datasets[0].data[tooltipItem.index];

                if (tooltipItem.datasetIndex == 0) {
                  return faible;
                } else if (tooltipItem.datasetIndex == 1) {
                  return moyenne;
                } else {
                  return forte;
                }
              },
              title: function (tooltipItem) {
                var title = $scope.getMonthString(tooltipItem[0].xLabel);
                return title;
              }
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10,
                padding: 10,
                beginAtZero: true,

                callback: function (value) { if (value % 1 === 0) { return value; } }

              }
            }]
          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          }
        }
      };
      var myBar = new Chart(ctx, $scope.myBarConfig);

      $scope.myBar2Config = {
        type: 'bar',
        data: graphDysfonctDataPerStatus,
        options: {
          legend: {
            display: true,
            position: "top",
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              padding: 16,
              fontSize: 11,
              strokeStyle: '#f00',
              fontStyle: "600",
              generateLabels: Chart.defaults.global.legend.generateLabels
            }
          },
          title: {
            display: true,
            position: 'top',
            text: 'Statut des dysfonctionnements 🌿 ECOR',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                beginAtZero: true,
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10,
                padding: 10,

                callback: function (value) { if (value % 1 === 0) { return value; } }
              }
            }]
          }
        }
      };

      var myBar2 = new Chart(ctx2, $scope.myBar2Config);

      var graphHorizontal = {
        labels: ['Achats - prestataires', 'Déchets', 'Energie', 'Organisation équipe', 'Parcours patients',
          'Autre'],
        datasets: [{
          label: 'Domaine impacté',
          backgroundColor: '#A8C4D1',
          borderColor: '#A8C4D1',
          data: [
            $scope.getByDomain('ACHAT'),
            $scope.getByDomain('DECHETS'),
            $scope.getByDomain('ENERGIE'),
            $scope.getByDomain('ORGANISATION'),
            $scope.getByDomain('PARCOURS'),
            $scope.getByDomain('AUTRE')
          ]
        }]
      };

      var horizontal = document.getElementById('canvasEcorHorizontal').getContext('2d');
      $scope.myBarHorizontalConfig = {
        type: 'horizontalBar',
        data: graphHorizontal,
        options: {
          legend: {
            display: false
          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          },
          title: {
            display: true,
            text: "DOMAINE IMPACTÉ",
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

            callbacks: {
              label: function (tooltipItem, data) {
                var total = '   Total:          ' + data.datasets[0].data[tooltipItem.index];
                return total;
              }
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 12,
                beginAtZero: true,
                callback: function (value) { if (value % 1 === 0) { return value; } }
              }
            }],
            yAxes: [{
              barPercentage: 0.5,
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 12,
                padding: 10,
                beginAtZero: true,
              }
            }]
          }
        }
      };
      var myBarHorizontal = new Chart(horizontal, $scope.myBarHorizontalConfig);

    }

    $scope.generateDispensation = function () {
      var graphDispensationDataPerPriority = {
        labels: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [{
          label: 'Importance faible',
          backgroundColor: '#B0CAD6',
          data: [
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 0),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 1),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 2),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 3),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 4),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 5),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 6),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 7),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 8),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 9),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 10),
            $scope.getPerPriority($scope.dispensationErrors, 'LOW', 11)
          ]
        }, {
          label: 'Importance moyenne',
          backgroundColor: '#3CB4A1',
          data: [
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 0),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 1),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 2),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 3),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 4),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 5),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 6),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 7),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 8),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 9),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 10),
            $scope.getPerPriority($scope.dispensationErrors, 'NORMAL', 11)
          ]
        }, {
          label: 'Importance forte',
          backgroundColor: '#007D8C',
          data: [
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 0),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 1),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 2),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 3),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 4),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 5),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 6),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 7),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 8),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 9),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 10),
            $scope.getPerPriority($scope.dispensationErrors, 'HIGH', 11)
          ]
        }]
      };

      var graphHorizontal = {
        labels: ['Mauvais produit', 'Mauvais dosage', 'Mauvaise forme galénique', 'Mauvais nombre de boîte', 'Oubli d\'un produit',
          'Vente d\'un périmé', 'Erreur de tarification / facturation', 'Non-respect des règles de délivrance', 'Erreur de prescription (dont incomplète)',
          'Autre'],
        datasets: [{
          label: 'Erreur',
          backgroundColor: '#A8C4D1',
          borderColor: '#A8C4D1',
          data: [
            $scope.getByError('BAD_PRODUCT'),
            $scope.getByError('BAD_DOSAGE'),
            $scope.getByError('BAD_PHARMACEUTICAL_FORM'),
            $scope.getByError('BAD_BOX_NUMBERS'),
            $scope.getByError('PRODUCT_FORGOT'),
            $scope.getByError('OBSELETE_SELL'),
            $scope.getByError('TARIF_ERROR'),
            $scope.getByError('NON_RESPECT_RULES'),
            $scope.getByError('PRESCRIPTION_ERROR'),
            $scope.getByError('OTHER'),
          ]
        }]
      };


      var ctx = document.getElementById('canvasDispensationPriority').getContext('2d');

      $scope.myBar3Config = {
        type: 'bar',
        data: graphDispensationDataPerPriority,
        options: {
          legend: {
            display: true,
            position: "top",
            reverse: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              padding: 16,
              fontSize: 11,
              strokeStyle: '#f00',
              fontStyle: "600",
              generateLabels: Chart.defaults.global.legend.generateLabels
            }
          },
          title: {
            display: true,
            position: 'top',
            fontColor: '#1A2A33',
            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            text: "NOMBRE D\'ERREURS DE DISPENSATION"
          },
          tooltips: {
            cornerRadius: 0,
            xPadding: 16,
            yPadding: 12,
            backgroundColor: 'rgba(26, 42, 51, 0.9)',
            titleFontSize: 11,
            titleMarginBottom: 8,
            titleFontStyle: '400',
            bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 11,
            bodyFontStyle: '400',
            bodyFontColor: 'rgba(255,255,255, 0.8)',
            bodySpacing: 6,
            multiKeyBackground: 'rgba(0,0,0,0)',

            callbacks: {
              label: function (tooltipItem, data) {
                var forte = '   Forte:          ' + data.datasets[2].data[tooltipItem.index];
                var moyenne = '   Moyenne:   ' + data.datasets[1].data[tooltipItem.index];
                var faible = '   Faible:        ' + data.datasets[0].data[tooltipItem.index];

                if (tooltipItem.datasetIndex == 0) {
                  return faible;
                } else if (tooltipItem.datasetIndex == 1) {
                  return moyenne;
                } else {
                  return forte;
                }
              },
              title: function (tooltipItem) {
                var title = $scope.getMonthString(tooltipItem[0].xLabel);
                return title;
              }
            }
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              maxBarThickness: 50,
              gridLines: {
                display: false,
                color: 'rgba(236, 239, 242, 1)'
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: 'rgba(255,255,255, 0)',
                color: 'rgba(236, 239, 242, 1)',
                drawBorder: false
              },
              ticks: {
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                fontSize: 10,
                padding: 10,
                beginAtZero: true,

                callback: function (value) { if (value % 1 === 0) { return value; } }

              }
            }]
          },
          elements: {
            rectangle: {
              borderWidth: 0
            }
          }
        }
      };
      var myBar3 = new Chart(ctx, $scope.myBar3Config);

      if ($scope.dispensationErrors.length > 0) {
        if ($scope.dispensationAnyDetected) {
          var ctx2 = document.getElementById('canvasDispensationDetected').getContext('2d');

          $scope.configCtx2 = {
            type: 'doughnut',
            data: {
              datasets: [{
                data: [
                  $scope.getByDetected('INTERNE_CONTROL'),
                  $scope.getByDetected('DMP'),
                  $scope.getByDetected('CLIENT'),
                  $scope.getByDetected('PAYER_ORGANISM')
                ],
                backgroundColor: [
                  '#445E7E',
                  '#007D8C',
                  '#3CB4A1',
                  '#B0CAD6'
                ],
                label: 'ERREUR DÉTECTÉE PAR :'
              }],
              labels: [
                'La pharmacie - contrôle interne',
                'La pharmacie - DMP',
                'Le client',
                'L\'organisme payeur'
              ]
            },
            options: {
              legend: {
                display: true,
                position: 'right',
                reverse: true,
                labels: {
                  usePointStyle: true,
                  boxWidth: 5,
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: 11,
                  fontStyle: '600',
                  filter: function (legend, chartData) {
                    var theData = chartData.datasets[0].data;
                    var metaData = Object.entries(chartData.datasets[0]._meta)[0][1].data;
                    var dataFiltered = theData.map(function (elm, index) {
                      return { ind: index, value: elm, hidden: metaData[index].hidden };
                    });
                    var currentValue = dataFiltered[legend.index].hidden ? 0 : dataFiltered[legend.index].value;
                    var total = dataFiltered.reduce(function (acc, current) {
                      return current.hidden ? acc : acc + current.value;
                    }, 0);
                    var percent = parseFloat((currentValue / total * 100).toFixed(1));
                    if (percent) {
                      legend.text += "  (" + percent + "%)";
                    }
                    else legend.text += "  (0%)";
                    return legend;
                  },
                  generateLabels: Chart.defaults.doughnut.legend.generateLabels
                }
              },
              responsive: true,
              title: {
                display: true,
                position: 'top',
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                text: 'ERREUR DÉTECTÉE PAR :'
              },
              tooltips: {
                cornerRadius: 0,
                xPadding: 16,
                yPadding: 12,
                backgroundColor: 'rgba(26, 42, 51, 0.9)',

                bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                bodyFontSize: 9,
                bodyFontStyle: '400',
                bodyFontColor: 'rgba(255,255,255, 0.8)',
                bodySpacing: 6,
                multiKeyBackground: 'rgba(0,0,0,0)',

                callbacks: {
                  label: function (tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                    var total = meta.total;
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                    return currentValue + ' (' + percentage + '%)';
                  },
                  title: function (tooltipItem, data) {
                    return data.labels[tooltipItem[0].index];
                  }
                }
              },
              animation: {
                animateScale: true,
                animateRotate: true
              },
              elements: {
                arc: {
                  borderWidth: 0
                }
              }
            }
          };
          var doughnutDetected = new Chart(ctx2, $scope.configCtx2);
        }



        if ($scope.dispensationAnyDelivered) {
          var ctx3 = document.getElementById('canvasDispensationDelivered').getContext('2d');
          $scope.configCtx3 = {
            type: 'doughnut',
            data: {
              datasets: [{
                data: [
                  $scope.getByDelivered(true),
                  $scope.getByDelivered(false)
                ],
                backgroundColor: [
                  '#007D8C',
                  '#3CB4A1'
                ],
                label: 'LE PRODUIT A ÉTÉ DÉLIVRÉ AU PATIENT :'
              }],
              labels: [
                'Oui',
                'Non'
              ]
            },
            options: {
              legend: {
                display: true,
                position: 'right',
                reverse: true,
                labels: {
                  usePointStyle: true,
                  boxWidth: 5,
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: 11,
                  fontStyle: '600',
                  filter: function (legend, chartData) {
                    var theData = chartData.datasets[0].data;
                    var metaData = Object.entries(chartData.datasets[0]._meta)[0][1].data;
                    var dataFiltered = theData.map(function (elm, index) {
                      return { ind: index, value: elm, hidden: metaData[index].hidden };
                    });
                    var currentValue = dataFiltered[legend.index].hidden ? 0 : dataFiltered[legend.index].value;
                    var total = dataFiltered.reduce(function (acc, current) {
                      return current.hidden ? acc : acc + current.value;
                    }, 0);
                    var percent = parseFloat((currentValue / total * 100).toFixed(1));
                    if (percent) {
                      legend.text += "  (" + percent + "%)";
                    }
                    else legend.text += "  (0%)";
                    return legend;
                  },
                  generateLabels: Chart.defaults.doughnut.legend.generateLabels
                }
              },
              responsive: true,
              title: {
                display: true,
                position: 'top',
                fontColor: '#1A2A33',
                fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                text: 'LE PRODUIT A ÉTÉ DÉLIVRÉ AU PATIENT :'

              },
              tooltips: {
                cornerRadius: 0,
                xPadding: 16,
                yPadding: 12,
                backgroundColor: 'rgba(26, 42, 51, 0.9)',

                bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                bodyFontSize: 9,
                bodyFontStyle: '400',
                bodyFontColor: 'rgba(255,255,255, 0.8)',
                bodySpacing: 6,
                multiKeyBackground: 'rgba(0,0,0,0)',

                callbacks: {
                  label: function (tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                    var total = meta.total;
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                    return currentValue + ' (' + percentage + '%)';
                  },
                  title: function (tooltipItem, data) {
                    return data.labels[tooltipItem[0].index];
                  }
                }
              },
              animation: {
                animateScale: true,
                animateRotate: true
              },
              elements: {
                arc: {
                  borderWidth: 0
                }
              }
            }
          };
          var doughnutDelivered = new Chart(ctx3, $scope.configCtx3);
        }



        var horizontal = document.getElementById('canvasDispensationHorizontal').getContext('2d');
        $scope.myBarHorizontalConfig = {
          type: 'horizontalBar',
          data: graphHorizontal,
          options: {
            legend: {
              display: false
            },
            elements: {
              rectangle: {
                borderWidth: 0
              }
            },
            title: {
              display: true,
              text: "CARACTÉRISATION DE L\'ERREUR",
              fontColor: '#1A2A33',
              fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
            },
            tooltips: {
              cornerRadius: 0,
              xPadding: 16,
              yPadding: 12,
              backgroundColor: 'rgba(26, 42, 51, 0.9)',
              titleFontSize: 11,
              titleMarginBottom: 8,
              titleFontStyle: '400',
              bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              bodyFontSize: 11,
              bodyFontStyle: '400',
              bodyFontColor: 'rgba(255,255,255, 0.8)',
              bodySpacing: 6,
              multiKeyBackground: 'rgba(0,0,0,0)',

              callbacks: {
                label: function (tooltipItem, data) {
                  var total = '   Total:          ' + data.datasets[0].data[tooltipItem.index];
                  return total;
                }
              }
            },
            responsive: true,
            scales: {
              xAxes: [{
                stacked: true,
                maxBarThickness: 50,
                gridLines: {
                  display: false,
                  color: 'rgba(236, 239, 242, 1)'
                },
                ticks: {
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: 12,
                  beginAtZero: true,
                  callback: function (value) { if (value % 1 === 0) { return value; } }
                }
              }],
              yAxes: [{
                barPercentage: 0.5,
                stacked: true,
                gridLines: {
                  zeroLineColor: 'rgba(255,255,255, 0)',
                  color: 'rgba(236, 239, 242, 1)',
                  drawBorder: false
                },
                ticks: {
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: 12,
                  padding: 10,
                  beginAtZero: true,
                }
              }]
            }
          }
        };
        var myBarHorizontal = new Chart(horizontal, $scope.myBarHorizontalConfig);



      }


    }

    $scope.showDysfonctionnements = false;
    $scope.showDysfonctionnementsEcor = false;
    $scope.showDispensation = false;
    $scope.getMonthString = function (month) {
      switch (month) {
        case "Jan":
          return "Janvier";
        case "Fev":
          return "Février";
        case "Mar":
          return "Mars";
        case "Avr":
          return "Avril";
        case "Mai":
          return "Mai";
        case "Juin":
          return "Juin";
        case "Juil":
          return "Juillet";
        case "Aou":
          return "Août";
        case "Sep":
          return "Septembre";
        case "Oct":
          return "Octobre";
        case "Nov":
          return "Novembre";
        case "Dec":
          return "Décembre";
        default:
          return month;
      }
    }

    $scope.getGraphIndicateur = function () {


      TableauDeBordService.getGraphIndic($scope.year, $scope.dynamicIndicator).then(function (data) {
        $scope.dynamicConfigs = { months: [], status: [] };
        setTimeout(function () {
          for (var i = 0; i < data.length; i++) {
            var str = 'indicmonth' + i;
            var ctx = document.getElementById(str).getContext('2d');
            // chartConfig.data = data[i].month;
            var myBar4Config = {
              type: 'bar',
              data: data[i].month,
              options: {
                // animation: {
                //   duration: 0
                // },
                // hover: {
                //   animationDuration: 0
                // },
                // responsiveAnimationDuration: 0,
                legend: {
                  display: true,
                  position: "top",
                  reverse: true,
                  labels: {
                    usePointStyle: true,
                    boxWidth: 5,
                    fontColor: '#1A2A33',
                    fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    padding: 16,
                    fontSize: 11,
                    strokeStyle: '#f00',
                    fontStyle: "600",
                    generateLabels: Chart.defaults.global.legend.generateLabels
                  }
                },
                title: {
                  display: true,
                  position: 'top',
                  text: 'Nombre de dysfonctionnements ' + ($scope.dynamicIndicator[i].title.toLowerCase().includes('dysfonctionnement') ? $scope.dynamicIndicator[i].title.substring(18) : $scope.dynamicIndicator[i].title),
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
                },
                tooltips: {
                  cornerRadius: 0,
                  xPadding: 16,
                  yPadding: 12,
                  backgroundColor: 'rgba(26, 42, 51, 0.9)',
                  titleFontSize: 11,
                  titleMarginBottom: 8,
                  titleFontStyle: '400',
                  bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  bodyFontSize: 11,
                  bodyFontStyle: '400',
                  bodyFontColor: 'rgba(255,255,255, 0.8)',
                  bodySpacing: 6,
                  multiKeyBackground: 'rgba(0,0,0,0)',

                  callbacks: {
                    label: function (tooltipItem, data) {
                      var forte = '   Forte:          ' + data.datasets[2].data[tooltipItem.index];
                      var moyenne = '   Moyenne:   ' + data.datasets[1].data[tooltipItem.index];
                      var faible = '   Faible:        ' + data.datasets[0].data[tooltipItem.index];

                      if (tooltipItem.datasetIndex == 0) {
                        return faible;
                      } else if (tooltipItem.datasetIndex == 1) {
                        return moyenne;
                      } else {
                        return forte;
                      }
                    },
                    title: function (tooltipItem) {
                      var title = $scope.getMonthString(tooltipItem[0].xLabel);
                      return title;
                    }
                  }
                },
                responsive: true,
                scales: {
                  xAxes: [{
                    stacked: true,
                    maxBarThickness: 50,
                    gridLines: {
                      display: false,
                      color: 'rgba(236, 239, 242, 1)'
                    },
                    ticks: {
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      fontSize: 10
                    }
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      zeroLineColor: 'rgba(255,255,255, 0)',
                      color: 'rgba(236, 239, 242, 1)',
                      drawBorder: false
                    },
                    ticks: {
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      fontSize: 10,
                      padding: 10,
                      beginAtZero: true,

                      callback: function (value) { if (value % 1 === 0) { return value; } }

                    }
                  }]
                },
                elements: {
                  rectangle: {
                    borderWidth: 0
                  }
                }
              }
            };
            $scope.dynamicConfigs.months.push(myBar4Config);
            var myBar4 = new Chart(ctx, myBar4Config);
            var strStatus = 'indicstatus' + i;
            var ctx2 = document.getElementById(strStatus).getContext('2d');
            var myBar5Config = {
              type: 'bar',
              data: data[i].status,
              options: {
                // animation: {
                //   duration: 0
                // },
                // hover: {
                //   animationDuration: 0
                // },
                // responsiveAnimationDuration: 0,
                legend: {
                  display: true,
                  position: "top",
                  reverse: true,
                  labels: {
                    usePointStyle: true,
                    boxWidth: 5,
                    fontColor: '#1A2A33',
                    fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    padding: 16,
                    fontSize: 11,
                    strokeStyle: '#f00',
                    fontStyle: "600",
                    generateLabels: Chart.defaults.global.legend.generateLabels
                  }
                },
                title: {
                  display: true,
                  position: 'top',
                  text: 'Statut des dysfonctionnements ' + ($scope.dynamicIndicator[i].title.toLowerCase().includes('dysfonctionnement') ? $scope.dynamicIndicator[i].title.substring(18) : $scope.dynamicIndicator[i].title),
                  fontColor: '#1A2A33',
                  fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
                },

                tooltips: {
                  cornerRadius: 0,
                  xPadding: 16,
                  yPadding: 12,
                  backgroundColor: 'rgba(26, 42, 51, 0.9)',
                  titleFontSize: 11,
                  titleMarginBottom: 8,
                  titleFontStyle: '400',
                  bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  bodyFontSize: 11,
                  bodyFontStyle: '400',
                  bodyFontColor: 'rgba(255,255,255, 0.8)',
                  bodySpacing: 6,
                  multiKeyBackground: 'rgba(0,0,0,0)',

                },
                elements: {
                  rectangle: {
                    borderWidth: 0
                  }
                },
                responsive: true,
                scales: {
                  xAxes: [{
                    stacked: true,
                    maxBarThickness: 50,
                    gridLines: {
                      display: false,
                      color: 'rgba(236, 239, 242, 1)'
                    },
                    ticks: {
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      fontSize: 10
                    }
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      zeroLineColor: 'rgba(255,255,255, 0)',
                      color: 'rgba(236, 239, 242, 1)',
                      drawBorder: false
                    },
                    ticks: {
                      beginAtZero: true,
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      fontSize: 10,
                      padding: 10,

                      callback: function (value) { if (value % 1 === 0) { return value; } }
                    }
                  }]
                }
              }
            };
            $scope.dynamicConfigs.status.push(myBar5Config);
            var myBar5 = new Chart(ctx2, myBar5Config);
            // myBar2.data.labels = data[i].status.labels;
            // myBar2.data.datasets = data[i].status.datasets;
            // myBar2.update();


          }
        })

      }).catch(function (data) {
        console.log(data);
      });
    }

    $scope.generate = function () {
      if (!$scope.graphs) {
        $state.go('app.performances.tableau-de-bord')
      }
      else {
        $scope.dynamicIndicator = [];
        for (var i = 0; i < $scope.graphs.length; i++) {
          if ($scope.graphs[i].generate) {
            if ($scope.graphs[i].status == "MALFUNCTION") {
              $scope.showDysfonctionnements = true;
              $scope.getDysfonctionnements();
            }
            else if ($scope.graphs[i].status == "DISPENSATION") {
              $scope.showDispensation = true;
              $scope.getDispensation();
            } else if ($scope.graphs[i].status === 'DYNAMIC') {
              $scope.dynamicIndicator.push($scope.graphs[i]);
            } else if ($scope.graphs[i].status === 'ECOR') {
              $scope.showDysfonctionnementsEcor = true;
              $scope.getDysfonctionnementsEcor();
            } else {
              var graph;
              if ($scope.graphs[i].period == "MONTHLY") {
                var indicateurs = $filter('orderBy')($scope.graphs[i].dataIndicateurs, 'index');

                var dataTmp = [];
                for (var y = 0; y < indicateurs.length; y++) {
                  if (indicateurs[y].value != null) {
                    dataTmp.push(indicateurs[y].value);
                  } else {
                    dataTmp.push(0);
                  }
                }

                var dataChart = {
                  labels: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
                  datasets: [{
                    backgroundColor: '#A8C4D1',
                    data: dataTmp
                  }]
                };

                $scope.chartConfig = {
                  type: 'bar',
                  data: dataChart,
                  options: {
                    legend: {
                      display: false,
                      position: "top",
                      reverse: true,
                      labels: {
                        usePointStyle: true,
                        boxWidth: 5,
                        fontColor: '#1A2A33',
                        fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        padding: 16,
                        fontSize: 11,
                        strokeStyle: '#f00',
                        fontStyle: "600",
                        generateLabels: Chart.defaults.global.legend.generateLabels
                      }
                    },
                    title: {
                      display: false,
                      position: 'top',
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    },
                    tooltips: {
                      cornerRadius: 0,
                      xPadding: 16,
                      yPadding: 12,
                      backgroundColor: 'rgba(26, 42, 51, 0.9)',
                      titleFontSize: 11,
                      titleMarginBottom: 8,
                      titleFontStyle: '400',
                      bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      bodyFontSize: 11,
                      bodyFontStyle: '400',
                      bodyFontColor: 'rgba(255,255,255, 0.8)',
                      bodySpacing: 6,
                      multiKeyBackground: 'rgba(0,0,0,0)',

                      custom: function (tooltip) {
                        if (!tooltip) return;
                        // disable displaying the color box;
                        tooltip.displayColors = false;
                      },
                      callbacks: {
                        label: function (tooltipItem, data) {
                          return;
                        },
                        title: function (tooltipItem, data) {
                          var title = $scope.getMonthString(tooltipItem[0].xLabel) + '   ' + tooltipItem[0].yLabel;
                          return title;
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      xAxes: [{
                        stacked: true,
                        maxBarThickness: 50,
                        gridLines: {
                          display: false,
                          color: 'rgba(236, 239, 242, 1)'
                        },
                        ticks: {
                          fontColor: '#1A2A33',
                          fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                          fontSize: 10
                        }
                      }],
                      yAxes: [{
                        stacked: true,
                        gridLines: {
                          zeroLineColor: 'rgba(236, 239, 242, 1)',
                          color: 'rgba(236, 239, 242, 1)',
                          drawBorder: false
                        },
                        ticks: {
                          fontColor: '#1A2A33',
                          fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                          fontSize: 10,
                          padding: 10,
                          beginAtZero: true,

                          callback: function (value) { if (value % 1 === 0) { return value; } }

                        }
                      }]
                    },
                    elements: {
                      rectangle: {
                        borderWidth: 0
                      }
                    }
                  }
                };

                graph = {
                  config: $scope.chartConfig,
                  title: $scope.graphs[i].title,
                  isAnnual: false,
                  indicateur: $scope.graphs[i]
                };

              } else if ($scope.graphs[i].period == "QUARTERLY") {
                var indicateurs = $filter('orderBy')($scope.graphs[i].dataIndicateurs, 'index');
                // graph = { series: ['indicateur'], labels: [ '1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre' ], data: [], title: $scope.graphs[i].title };
                // for (var y = 0; y < indicateurs.length; y++) {
                //   if (indicateurs[y].value != null) {
                //     graph.data.push(indicateurs[y].value);
                //   } else {
                //     graph.data.push(0);
                //   }
                // }

                var dataTmp = [];
                for (var y = 0; y < indicateurs.length; y++) {
                  if (indicateurs[y].value != null) {
                    dataTmp.push(indicateurs[y].value);
                  } else {
                    dataTmp.push(0);
                  }
                }

                var dataChart = {
                  labels: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre'],
                  datasets: [{
                    backgroundColor: '#A8C4D1',
                    data: dataTmp
                  }]
                };

                $scope.chart2Config = {
                  type: 'bar',
                  data: dataChart,
                  options: {
                    legend: {
                      display: false,
                      position: "top",
                      reverse: true,
                      labels: {
                        usePointStyle: true,
                        boxWidth: 5,
                        fontColor: '#1A2A33',
                        fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        padding: 16,
                        fontSize: 11,
                        strokeStyle: '#f00',
                        fontStyle: "600",
                        generateLabels: Chart.defaults.global.legend.generateLabels
                      }
                    },
                    title: {
                      display: false,
                      position: 'top',
                      fontColor: '#1A2A33',
                      fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                    },
                    tooltips: {
                      cornerRadius: 0,
                      xPadding: 16,
                      yPadding: 12,
                      backgroundColor: 'rgba(26, 42, 51, 0.9)',
                      titleFontSize: 11,
                      titleMarginBottom: 8,
                      titleFontStyle: '400',
                      bodyFontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      bodyFontSize: 11,
                      bodyFontStyle: '400',
                      bodyFontColor: 'rgba(255,255,255, 0.8)',
                      bodySpacing: 6,
                      multiKeyBackground: 'rgba(0,0,0,0)',

                      custom: function (tooltip) {
                        if (!tooltip) return;
                        // disable displaying the color box;
                        tooltip.displayColors = false;
                      },
                      callbacks: {
                        label: function (tooltipItem, data) {
                          return;
                        },
                        title: function (tooltipItem, data) {
                          var title = tooltipItem[0].xLabel + '   ' + tooltipItem[0].yLabel;
                          return title;
                        }
                      }
                    },
                    responsive: true,
                    scales: {
                      xAxes: [{
                        stacked: true,
                        maxBarThickness: 50,
                        gridLines: {
                          display: false,
                          color: 'rgba(236, 239, 242, 1)'
                        },
                        ticks: {
                          fontColor: '#1A2A33',
                          fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                          fontSize: 10
                        }
                      }],
                      yAxes: [{
                        stacked: true,
                        gridLines: {
                          zeroLineColor: 'rgba(255,255,255, 0)',
                          color: 'rgba(236, 239, 242, 1)',
                          drawBorder: false
                        },
                        ticks: {
                          fontColor: '#1A2A33',
                          fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                          fontSize: 10,
                          padding: 10,
                          beginAtZero: true,

                          callback: function (value) { if (value % 1 === 0) { return value; } }

                        }
                      }]
                    },
                    elements: {
                      rectangle: {
                        borderWidth: 0
                      }
                    }

                  }
                };

                graph = {
                  config: $scope.chart2Config,
                  title: $scope.graphs[i].title,
                  isAnnual: false,
                  indicateur: $scope.graphs[i]
                };
              } else if ($scope.graphs[i].period == "ANNUAL") {
                var indicateur = $scope.graphs[i].dataIndicateurs[0];
                indicateur.format = $scope.graphs[i].format;
                graph = {
                  title: $scope.graphs[i].title,
                  isAnnual: true,
                  indicateur: $scope.graphs[i]
                };
              }
              $scope.graphsDisplayed.push(graph);
            }
          }
          setTimeout(function () {
            for (var i = 0; i < $scope.graphsDisplayed.length; i++) {
              if ($scope.graphsDisplayed[i].isAnnual == false) {
                var str = 'chart' + i;
                var ctx = document.getElementById(str).getContext('2d');
                var chart = new Chart(ctx, $scope.graphsDisplayed[i].config);
              }
            }
          })
        }
        if ($scope.dynamicIndicator.length) {
          $scope.getGraphIndicateur();
        }
      }
    }



    var addIMGToPdf = function (id, pdf, height, canvas, doughnut, specialDoughnut) {
      if ((offset + 40 + height) > 280) {
        pdf.addPage();
        offset = 0;
      }
      var widthOffset = 15;
      var finalWidth = widthImgInPDF;
      if (doughnut != null) {
        finalWidth = doughnutWidth;
        if (specialDoughnut) {
          widthOffset = 52;
        } else {
          widthOffset = doughnutOffset;
        }

      }
      pdf.addImage(canvas.toDataURL('image/png', 1.0), 'PNG', widthOffset, 40 + offset, finalWidth, height, id, 'NONE', 0);
      return height + 10;
    };

    var createCanvas = function (w, h) {
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff'; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      return canvas;
    }

    $scope.downloadPDF = function () {
      $scope.inLoad = true;
      offset = 0;
      var pdf = new jsPDF();
      pdf.setFontSize(titleFontSize);


      if ($scope.dysfonctionnements.length > 0) {

        var canvas = createCanvas(1400, 350);
        var myBarConfig = angular.copy($scope.myBarConfig);
        myBarConfig.options.responsive = false;
        myBarConfig.options.animation = false;
        new Chart(canvas, myBarConfig);


        pdf.text(20, 20, 'Dysfonctionnements - Nombre');
        var height = addIMGToPdf('canvasDysfPriority', pdf, 46, canvas);
        var textToDisplay = '';
        if ($scope.dysInd.goal != null) {
          textToDisplay = 'Objectif : ' + $scope.dysInd.goal + ($scope.dysInd.format ? $scope.dysInd.format : '');
        }
        pdf.setFontSize(goalFontSize);
        textToDisplay += '  Moyenne : ' + $scope.average($scope.dysInd.dataIndicateurs) + ($scope.dysInd.format ? $scope.dysInd.format : '');
        pdf.text(textToDisplay, widthImgInPDF + 20, textMargin + height, {
          align: 'right'
        });
        pdf.setFontSize(titleFontSize);

        pdf.addPage();
        offset = 0;
        canvas = createCanvas(1400, 350);
        var myBar2Config = angular.copy($scope.myBar2Config);
        myBar2Config.options.responsive = false;
        myBar2Config.options.animation = false;
        new Chart(canvas, myBar2Config);
        pdf.text(20, 20, 'Dysfonctionnements - Statut');
        addIMGToPdf('canvasDysfStatus', pdf, 46, canvas);


        pdf.addPage();
        offset = 0;

        canvas = createCanvas(900, 450);
        var config = angular.copy($scope.config);
        config.options.responsive = false;
        config.options.animation = false;
        new Chart(canvas, config);

        pdf.text(20, 20, 'Dysfonctionnements - Type');
        addIMGToPdf('canvasDysfType', pdf, 46, canvas, true);
      }

      if ($scope.dysfonctionnementsEcor.length > 0) {

        if ($scope.dysfonctionnements.length > 0) {
          pdf.addPage();
        }

        var canvas = createCanvas(1400, 350);
        var myBarConfig = angular.copy($scope.myBarConfig);
        myBarConfig.options.responsive = false;
        myBarConfig.options.animation = false;
        new Chart(canvas, myBarConfig);


        pdf.text(20, 20, 'Dysfonctionnements ECOR - Nombre');
        var height = addIMGToPdf('canvasDysfEcorPriority', pdf, 46, canvas);
        var textToDisplay = '';
        if ($scope.dysEcorInd != null && $scope.dysEcorInd.goal != null) {
          textToDisplay = 'Objectif : ' + $scope.dysEcorInd.goal + ($scope.dysEcorInd.format ? $scope.dysEcorInd.format : '');
        }
        pdf.setFontSize(goalFontSize);
        textToDisplay += '  Moyenne : ' + $scope.average($scope.dysEcorInd.dataIndicateurs) + ($scope.dysEcorInd.format ? $scope.dysEcorInd.format : '');
        pdf.text(textToDisplay, widthImgInPDF + 20, textMargin + height, {
          align: 'right'
        });
        pdf.setFontSize(titleFontSize);

        pdf.addPage();
        offset = 0;
        canvas = createCanvas(1400, 350);
        var myBar2Config = angular.copy($scope.myBar2Config);
        myBar2Config.options.responsive = false;
        myBar2Config.options.animation = false;
        new Chart(canvas, myBar2Config);
        pdf.text(20, 20, 'Dysfonctionnements ECOR - Statut');
        addIMGToPdf('canvasDysfEcorStatus', pdf, 46, canvas);



        pdf.addPage();

        canvas = createCanvas(1400, 350);
        var myBarHorizontalConfig = angular.copy($scope.myBarHorizontalConfig);
        myBarHorizontalConfig.options.responsive = false;
        myBarHorizontalConfig.options.animation = false;
        new Chart(canvas, myBarHorizontalConfig);



        pdf.text(20, 20, 'Dysfonctionnements ECOR - Domaine impacté ');
        addIMGToPdf('canvasEcorHorizontal', pdf, 46, canvas);
      }



      if (!!$scope.showDispensation) {

        if ($scope.dysfonctionnements.length > 0 || $scope.dysfonctionnementsEcor.length > 0) {
          pdf.addPage();
        }

        canvas = createCanvas(1400, 350);
        var myBar3Config = angular.copy($scope.myBar3Config);
        if (myBar3Config != null) {
          myBar3Config.options.responsive = false;
          myBar3Config.options.animation = false;
          new Chart(canvas, myBar3Config);
          pdf.setFontSize(titleFontSize);
          pdf.text(20, 20, 'Erreurs de dispensation - Nombre');
          var height = addIMGToPdf('canvasDispensationPriority', pdf, 46, canvas);
          var textToDisplay = '';
          if ($scope.disInd.goal != null) {
            textToDisplay = 'Objectif : ' + $scope.disInd.goal + ($scope.disInd.format ? $scope.disInd.format : '');
          }
          pdf.setFontSize(goalFontSize);
          textToDisplay += '  Moyenne : ' + $scope.average($scope.disInd.dataIndicateurs) + ($scope.disInd.format ? $scope.disInd.format : '');
          pdf.text(textToDisplay, widthImgInPDF + 20, textMargin + height, {
            align: 'right'
          });
          pdf.setFontSize(titleFontSize);
        }
        if ($scope.dispensationAnyDetected) {
          pdf.addPage();

          canvas = createCanvas(900, 450);
          var configCtx2 = angular.copy($scope.configCtx2);
          configCtx2.options.responsive = false;
          configCtx2.options.animation = false;
          new Chart(canvas, configCtx2);

          pdf.text(20, 20, 'Erreurs de dispensation - Détecté par : ');
          addIMGToPdf('canvasDispensationDetected', pdf, 46, canvas, true);
        }

        if ($scope.dispensationAnyDelivered) {
          pdf.addPage();

          canvas = createCanvas(900, 450);
          var configCtx3 = angular.copy($scope.configCtx3);
          configCtx3.options.responsive = false;
          configCtx3.options.animation = false;
          new Chart(canvas, configCtx3);

          pdf.text(20, 20, 'Erreurs de dispensation - Délivré au client ');
          addIMGToPdf('canvasDispensationDelivered', pdf, 46, canvas, true, true);
        }

        if ($scope.dispensationAnyError) {
          pdf.addPage();

          canvas = createCanvas(1400, 350);
          var myBarHorizontalConfig = angular.copy($scope.myBarHorizontalConfig);
          myBarHorizontalConfig.options.responsive = false;
          myBarHorizontalConfig.options.animation = false;
          new Chart(canvas, myBarHorizontalConfig);



          pdf.text(20, 20, 'Erreurs de dispensation - Caractérisation de l\'erreur ');
          addIMGToPdf('canvasDispensationHorizontal', pdf, 46, canvas);
        }

      }

      for (var j = 0; j < $scope.dynamicIndicator.length; j++) {

        if (j !== 0 || ($scope.dysfonctionnements.length > 0 || !!$scope.showDispensation)) {
          pdf.addPage();
        }

        canvas = createCanvas(1400, 350);
        var configMonth = angular.copy($scope.dynamicConfigs.months[j]);
        configMonth.options.responsive = false;
        configMonth.options.animation = false;
        new Chart(canvas, configMonth);

        pdf.text(20, 20, $scope.dynamicIndicator[j].title + ' - Nombre');
        var height = addIMGToPdf('indicmonth' + j, pdf, 46, canvas);
        var textToDisplay = '';
        if ($scope.dynamicIndicator[j].goal != null) {
          textToDisplay = 'Objectif : ' + $scope.dynamicIndicator[j].goal + ($scope.dynamicIndicator[j].format ? $scope.dynamicIndicator[j].format : '');
        }
        pdf.setFontSize(goalFontSize);
        textToDisplay += '  Moyenne : ' + $scope.average($scope.dynamicIndicator[j].dataIndicateurs) + ($scope.dynamicIndicator[j].format ? $scope.dynamicIndicator[j].format : '');
        pdf.text(textToDisplay, widthImgInPDF + 20, textMargin + height, {
          align: 'right'
        });
        pdf.setFontSize(titleFontSize);

        pdf.addPage();
        offset = 0;

        canvas = createCanvas(1400, 350);
        var configStatus = angular.copy($scope.dynamicConfigs.status[j]);
        configStatus.options.responsive = false;
        configStatus.options.animation = false;
        new Chart(canvas, configStatus);

        pdf.text(20, 20, $scope.dynamicIndicator[j].title + ' - Statut');
        addIMGToPdf('indicstatus' + j, pdf, 46, canvas);

      }

      for (var i = 0; i < $scope.graphsDisplayed.length; i++) {
        if (i !== 0 || ($scope.dysfonctionnements.length > 0 || !!$scope.showDispensation || $scope.dynamicIndicator.length > 0)) {
          pdf.addPage();
          offset = 0;
        }

        var titleCopy = $scope.graphsDisplayed[i].title
          .replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').trim().toString();
        titleCopy = cutSentence(titleCopy, 50);
        pdf.text(20, 20, titleCopy);
        if ($scope.graphsDisplayed[i].isAnnual) {
          var textToDisplay = $scope.graphsDisplayed[i].indicateur.dataIndicateurs[0].value + ($scope.graphsDisplayed[i].indicateur.format ? $scope.graphsDisplayed[i].indicateur.format : '');
          pdf.text(textToDisplay, 20, 40 + offset);
        }
        else {
          canvas = createCanvas(1400, 350);
          var config = angular.copy($scope.graphsDisplayed[i].config);
          config.options.responsive = false;
          config.options.animation = false;
          new Chart(canvas, config);
          var height = addIMGToPdf("chart" + i, pdf, 46, canvas);
          var textToDisplay = '';
          if ($scope.graphsDisplayed[i].indicateur.goal != null) {
            textToDisplay = 'Objectif : ' + $scope.graphsDisplayed[i].indicateur.goal + ($scope.graphsDisplayed[i].indicateur.format ? $scope.graphsDisplayed[i].indicateur.format : '');
          }
          pdf.setFontSize(goalFontSize);
          textToDisplay += '  Moyenne : ' + $scope.average($scope.graphsDisplayed[i].indicateur.dataIndicateurs) + ($scope.graphsDisplayed[i].indicateur.format ? $scope.graphsDisplayed[i].indicateur.format : '');
          pdf.text(textToDisplay, widthImgInPDF + 20, textMargin + height + offset, {
            align: 'right'
          });
          pdf.setFontSize(titleFontSize);
        }
      }

      pdf.save("graphiques_indicateurs.pdf");
      $scope.inLoad = false;
    }

    var cutSentence = function (string, lgt, splitCharacter) {
      var sentence = [];
      if (string.length < 10) {
        return string;
      }
      var sentenceSplitted = splitCharacter != null && splitCharacter ? string.split(splitCharacter) : string.split(" ");
      string = "";
      for (var i = 0, iLen = sentenceSplitted.length; i < iLen; i++) {
        var currentLgt = string.length;
        var sentenceSpl_currentLgt = sentenceSplitted[i].length;
        if (currentLgt < lgt) {
          var sumOfLgt = currentLgt + sentenceSpl_currentLgt;
          if (sumOfLgt >= lgt) {
            sentence.push(string);
            offset += 8;
            string = "";
          }
          string += sentenceSplitted[i] + " ";
        }
        else {
          sentence.push(string);
          offset += 8;
          string = "";
        }
      }
      if (string.length > 0) {
        sentence.push(string);
        string = "";
      }
      return sentence;
    }

    $scope.downloadXlsx = function (indicateur, filename) {
      if ($scope.loadingXlsx) {
        return;
      }
      $scope.loadingXlsx = true;
      if (indicateur == null) {
        if (filename === 'Dysfonctionnements') {
          TableauDeBordService.downloadXlsx($scope.graphs.filter(function (item) { return item.generate && item.status === 'MALFUNCTION'; }), $scope.year, filename);
        } else if (filename === 'Erreurs de dispensation') {
          TableauDeBordService.downloadXlsx($scope.graphs.filter(function (item) { return item.generate && item.status === 'DISPENSATION'; }), $scope.year, filename);
        } else {
          TableauDeBordService.downloadXlsx($scope.graphs.filter(function (item) { return item.generate; }), $scope.year, filename);
        }
      } else {
        var indicateurs = [];
        indicateurs.push(indicateur);
        TableauDeBordService.downloadXlsx(indicateurs, $scope.year, filename);
      }
    };

    $scope.$on('xlsxready', function () {
      $scope.loadingXlsx = false;
    });

    $scope.getAverageFromGraph = function (indicateur, filename) {
      if (indicateur == null) {
        if (filename === 'Dysfonctionnements') {
          var ind = $scope.graphs.filter(function (item) { return item.generate && item.status === 'MALFUNCTION'; })[0];
          return $scope.average(ind.dataIndicateurs);
        } else if (filename === 'Erreurs de dispensation') {
          var ind = $scope.graphs.filter(function (item) { return item.generate && item.status === 'DISPENSATION'; })[0];
          return $scope.average(ind.dataIndicateurs);
        } else {
          console.log($scope.graphs.filter(function (item) { return item.generate; }), $scope.year, filename);
        }
      } else {
        return $scope.average(indicateur.dataIndicateurs) + (indicateur.format ? ' ' + indicateur.format : '');
        // TableauDeBordService.downloadXlsx(indicateurs, $scope.year, filename);
      }
    };

    $scope.average = function (dataIndicateurs) {
      var nb = 0;
      var sum = 0;
      dataIndicateurs.forEach(function (data) {
        if (data.value != null && !Number.isNaN(data.value)) {
          nb++;
          sum += parseFloat(data.value);
        }
      });
      if (nb !== 0) {
        var average = sum / nb;
        if (Number.isInteger(average)) {
          return average;
        } else {
          return average.toFixed(2);
        }
      } else {
        return 0;
      }
    };

    $scope.exportMalfunctions = function () {
      if ($scope.loadingExport) {
        return;
      }
      $scope.loadingExport = true;
      MalfunctionService.downloadXlsx(null, null).then(function () {
        $scope.loadingExport = false;
      }).catch(function () {
        $scope.loadingExport = false;
        toastr.error('Une erreur est survenue.');
      });

    };

    $scope.openExport = function () {
      $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/export.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    if ($stateParams.id && $stateParams.year) {
      TableauDeBordService.findByIdAndYear($stateParams.id, $stateParams.year, $rootScope.user.isTeam).then(function (res) {
        $scope.graphs = [res.data]
        $scope.graphs[0].generate = true;
        $scope.graphs.forEach(function (item) {
          if (item.generate) {
            if (item.status === 'MALFUNCTION') {
              $scope.dysInd = angular.copy(item);
            } else if (item.status === 'DISPENSATION') {
              $scope.disInd = angular.copy(item);
            }
          }
        })
        $scope.generate();


      }).catch(function () {
        toastr.error('Une erreur est survenue')
      })
    } else {
      if ($stateParams.indicateurs) {
        $scope.graphs = $stateParams.indicateurs;
        console.log($scope.graphs);
        $scope.graphs.forEach(function (item) {
          if (item.generate) {
            if (item.status === 'MALFUNCTION') {
              $scope.dysInd = angular.copy(item);
            } else if (item.status === 'DISPENSATION') {
              $scope.disInd = angular.copy(item);
            } else if (item.status === 'ECOR') {
              $scope.dysEcorInd = angular.copy(item);
            }
          }
        })

      }

      if ($stateParams.year) {
        $scope.year = $stateParams.year;
      }
      $scope.generate()
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AddIndicateurController', AddIndicateurController);

  function AddIndicateurController($scope, $state, TableauDeBordService, $mdDialog, $rootScope, TABLEAU_BORD_PERIODS, $timeout, toastr) {

    $scope.titlePopupSave = "Créer un indicateur";
    $scope.updateMode = false;
    $scope.indicateur = {
      title: null,
      period: "MONTHLY",
      goalType: 'LOWER',
      goal: null,
      confidential: false,
      weather: false,
      thresholdHigh: null,
      thresholdLow: null,
      format: null
    };
    $scope.indicateurs = [];
    $scope.addWeatherOK = false;
    $scope.true = true;
    $scope.periods = TABLEAU_BORD_PERIODS;
    $scope.mapIndicateurs = new Map();
    $scope.lastOpen = null;
    $scope.isTitulaire = null;
    $scope.nbIndicateur = 0;
    $scope.lastIndicateur = null;

    TableauDeBordService.isAddWeatherOK().then(function (res) {
      console.log(res);
      $scope.isAddWeatherOK = !!res;
    }).catch(function (err) {
      console.log("Error isAddWeatherOK()");
    });

    $scope.openWindow = function (indicateur) {
      if ($scope.lastOpen != null && $scope.mapIndicateurs.get($scope.lastOpen) === true) {
        $scope.mapIndicateurs.set($scope.lastOpen, false);
        if ($scope.lastIndicateur != null) {
          $scope.indicateurs = $scope.indicateurs.map(function (item) {
            if (item.id === $scope.lastIndicateur.id) {
              item = angular.copy($scope.lastIndicateur);
            }
            return item;
          });
        }
      }
      $scope.mapIndicateurs.set(indicateur.id, true);
      $scope.lastOpen = indicateur.id;
      $scope.lastIndicateur = angular.copy(indicateur);
    }
    $scope.closeWindow = function (indicateur) {
      $scope.mapIndicateurs.set(indicateur.id, false);
      $scope.lastOpen = null;
      //event.stopPropagation();
    }
    // $scope.isOpen = function(indicateur){
    //   return $scope.mapIndicateurs.get(indicateur.id);
    // }
    $scope.getIndicateurs = function () {
      $timeout(function () {
        if ($rootScope.user.isTitulaire) {
          TableauDeBordService.getIndicateursConfidential().then(function (data) {
            $scope.indicateurs = data;
            $scope.indicateurs.forEach(function (item) {
              $scope.mapIndicateurs.set(item.id, false);
            })
          }).catch(function (err) {
            console.log("Error getIndicateurs() titulaire");
          });
        } else {
          TableauDeBordService.getIndicateursNotConfidential().then(function (data) {
            $scope.indicateurs = data;
            $scope.indicateurs.forEach(function (item) {
              $scope.mapIndicateurs.set(item.id, false);
            })
          }).catch(function (err) {
            console.log("Error getIndicateurs() no titulaire");
          });
        }
      });
    }

    $timeout(function () {
      $scope.getIndicateurs();
    });

    $scope.active = function (items, state) {
      if (state == true) {
        $scope.nbIndicateur = 0;
      }
      var result = [];
      angular.forEach(items, function (item) {
        if (!!item.active == state) {
          result.push(item);
          if (state === true && item.weather) {
            $scope.nbIndicateur++;
          }

        }
      });

      return result;
    };

    $scope.popUpAddIndicateur = function () {
      $scope.titlePopupSave = "Créer un indicateur";
      $scope.updateMode = false;
      $scope.isAddWeatherOK = false;
      $scope.indicateur = {
        title: null,
        period: "MONTHLY",
        goalType: 'LOWER',
        goal: null,
        confidential: false,
        weather: false,
        thresholdHigh: null,
        thresholdLow: null,
        format: null
      };

      TableauDeBordService.isAddWeatherOK().then(function (res) {
        $scope.isAddWeatherOK = !!res;
      }).catch(function (err) {
        console.log("Error isAddWeatherOK()");
      });

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/add_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.goBack = function () {
      $state.go('app.performances.tableau-de-bord');
    };

    $scope.setActif = function (indicateur, state) {
      var ind = {
        id: indicateur.id,
        active: state
      };

      TableauDeBordService.setActif(ind, new Date().getFullYear()).then(function (res) {
        $scope.getIndicateurs();
        $rootScope.$broadcast('refreshCountNotifs');
      }).catch(function (err) {
        console.log("Error setActif()");
      });
    };

    $scope.update = function (indicateur, index) {
      $scope.titlePopupSave = "Modifier un indicateur";
      $scope.updateMode = true;
      $scope.indicateur = angular.copy(indicateur);
      $scope.indicateur.goal = parseFloat($scope.indicateur.goal);
      $scope.indexUpdate = index;
      $scope.isAddWeatherOK = false;

      if ($scope.indicateur.weather == true) {
        $scope.isAddWeatherOK = true;
      } else {
        TableauDeBordService.isAddWeatherOK().then(function (res) {
          $scope.isAddWeatherOK = !!res;
        }).catch(function (err) {
          console.log("Error isAddWeatherOK()");
        })
      }

      $scope.indicateurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/add_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.openDelete = function (indicateur, index) {
      $scope.indicateurDelete = indicateur;
      $scope.indicateurDeletePopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/tableau-de-bord/popup/delete_indicateur.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () { }).catch(function () { });
    }

    //TODO : refermer boite après suppression
    $scope.delete = function () {
      var indicateurSend = {
        id: $scope.indicateurDelete.id,
        deleted: true
      };

      TableauDeBordService.deleteIndicateur(indicateurSend).then(function (data) {
        $scope.getIndicateurs();
        $mdDialog.hide();
      }).catch(function (err) {
        console.log("Error delete()");
      });
    };

    $scope.changeWeather = function (indicateur) {
      if (indicateur.confidential) {
        indicateur.weather = false;
      }

    }
    $scope.setConfidentiel = function (indicateur, state) {
      var indicateurSend = {
        id: indicateur.id,
        confidential: state
      };

      TableauDeBordService.setConfidential(indicateurSend).then(function (data) {
        if ($rootScope.user.isTitulaire) {
          indicateur.confidential = state;
          if (indicateur.confidential) {
            indicateur.weather = false;
          }
        } else {
          for (var i = 0; i < $scope.indicateurs.length; i++) {
            if ($scope.indicateurs[i].id == indicateur.id) {
              $scope.indicateurs.splice(i, 1);
              break;
            }
          }
        }

      }).catch(function (err) {
        console.log("Error confidential()");
      })
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.checkWeather = function () {
      if ($scope.indicateur.confidential) {
        $scope.indicateur.weather = false;
      }
    }

    $scope.saveIndicateur = function (indicateur) {

      var indicateurSend;
      if (!indicateur) {
        indicateurSend = angular.copy($scope.indicateur);
      } else {
        indicateurSend = angular.copy(indicateur);
        $scope.updateMode = true;
      }

      $scope.submitting = true;
      if (indicateurSend.confidential) {
        indicateurSend.weather = false;
      }
      if (indicateurSend.goal != null && !Number.isNaN(indicateurSend.goal)) {
        indicateurSend.goal = parseFloat(indicateurSend.goal);
      }
      TableauDeBordService.saveIndicateur(indicateurSend).then(function (res) {
        if ($scope.updateMode) {
          for (var i = 0; i < $scope.indicateurs.length; i++) {
            if ($scope.indicateurs[i].id == indicateur.id) {
              $scope.indicateurs[i] = indicateur;
              break;
            }
          }
          toastr.success('L\'indicateur a bien été modifié.');
        } else {
          $scope.indicateurs.push(res);
          toastr.success('L\'indicateur a bien été sauvegardé.');
        }

        $mdDialog.hide();
        $scope.indicateur = {
          title: null,
          period: "MONTHLY",
          goalType: 'LOWER',
          goal: null,
          confidential: false,
          weather: false,
          thresholdHigh: null,
          thresholdLow: null,
          format: null
        };

        $scope.submitting = false;
        $scope.mapIndicateurs.set(indicateur.id, false);
        $scope.lastIndicateur = null;
        TableauDeBordService.isAddWeatherOK().then(function (res) {
          $scope.isAddWeatherOK = !!res;
        }).catch(function (err) {
          console.log("Error isAddWeatherOK()");
        });
      }).catch(function (err) {
        $scope.submitting = false;
        console.log("Error saveIndicateur()");
        console.log(err);
      });
    };

    $scope.inputChanged = function (indicateur) {
      if (indicateur.goal != null) {
        indicateur.goal = indicateur.goal.replace(',', '.');
        indicateur.goal = dataIndicateur.value.replace(' ', '');
      }
    };
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('RevueDeDirectionDetailsController', RevueDeDirectionDetailsController);

  function RevueDeDirectionDetailsController($scope, $state, TableauDeBordService, FicheProgresService, AuditService, RevueDeDirectionService,
    UserService, PERMISSIONS, TABLEAU_BORD_PERIODS, REVUE_DIRECTION_SORTS, $mdDialog, $window, $rootScope, GENERAL_TASK_TYPES,
    EquipeDetailService, GENERAL_TASK_PERIOD, $filter, TachesGeneralesService, TASKS_EVENTS_REMINDERS, toastr, SatisfactionService,
    AutoEvaluationService, $timeout, api) {
    $scope.api = api;
    $scope.string = '';
    $scope.category = {};
    $scope.fournisseurs = {};
    $scope._tasks = [];
    $scope.periods = TABLEAU_BORD_PERIODS;
    $scope._sorts = REVUE_DIRECTION_SORTS;
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope.permissions = PERMISSIONS;
    //TASK
    $scope.fromRDD = ($state.current.name.lastIndexOf('app.performances.bilan-de-performances') > -1);
    $scope._categories = GENERAL_TASK_TYPES;
    $scope._recurrences = GENERAL_TASK_PERIOD;
    $scope.addCollaborateurMode = false;
    $scope.cantUpdate = true;
    $scope.loadingSave = false;
    $scope.loadingCategoryForTask = false;
    $scope.lastAudit = null;

    // check permissions to know if user can update ordre du jour
    UserService.getUserRoles().then(function (res) {
      if (res.data.includes('TITULAIRE') || res.data.includes('PRAQ')) {
        $scope.cantUpdate = false;
      }
    }).catch(function (err) {
      toastr.success('Erreur: impossible de récupérer vos droits');
    });
    $scope.getFournisseurs = function () {
      RevueDeDirectionService.getFournisseurs({ order: { name: true } }).then(function (res) {
        $scope.fournisseurs = res.data;
      })
    }
    $scope.getFournisseurs();

    // Pagination - Filter - Sorting
    $scope.OUTPUT = 20;
    $scope._page = {
      page: 0,
      output: $scope.OUTPUT,
      filter: {
        category: 'ACTION_DECIDEE_REVUE_DIRECTION',
        recurrence: null,
        echeance: null,
        reminder: null,
        creation: null,
        responsable: null,
        managementReview: $state.params.id,
        done: false
      },
      sort: null
    };

    $scope.findTasks = function () {
      if (!$scope.category || !$scope.category.categoryTmpId) {
        $scope.category.tasks = [];
        return;
      }
      RevueDeDirectionService.findTasks($scope.category.categoryTmpId).then(function (res) {
        $scope.category.tasks = res.data
      }).catch(function () {
        $scope.category.tasks = [];
      })
    }

    //Taches

    $scope._findList = function () {
      TachesGeneralesService.page($scope._page).then(function (response) {
        if ($scope._page.page === 0 && response.data.length === 0) {
          $scope.noData = true;
        }
        if (response.data.length === 0) {
          $scope.noMoreData = true;
        }
        $scope.managementReview.tacheGenerales = $scope.managementReview.tacheGenerales.concat(response.data);
        $scope._page.page = $scope._page.page + 1;
        if (response.data.length < $scope.OUTPUT) {
          $scope.noMoreData = true;
        }
        var newList = [];
        $scope.managementReview.tacheGenerales.forEach(function (element) {
          var exists = false;
          newList.forEach(function (newElmt) {
            if (newElmt.title === element.title) {
              exists = true;
            }
          });
          if (!exists) {
            newList.push(element);
          }
        });
        $scope.managementReview.tacheGenerales = newList;
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.findElements = function (type) {
      RevueDeDirectionService.findListElementManagementReview($scope.OUTPUT, $scope._page.page, type, $state.params.id, $rootScope.user.isTeam).then(function (data) {
        $scope.typeElement = type;
        if ($scope.managementReview.elements) {
          $scope.managementReview.elements = $scope.managementReview.elements.concat(data.data);
        } else {
          $scope.managementReview.elements = data.data;
        }
        if (type == 'AUDIT') {
          var list = $scope.managementReview.elements.slice().sort(function (a, b) {
            return new Date(b.uploadDate) - new Date(a.uploadDate);
          });
          $scope.lastAudit = list[0];
        }
        $scope._page.page = $scope._page.page + 1;
        $scope.$broadcast('autoeval', $scope.managementReview.elements);
      }).catch(function (data) { });
    };

    $scope.findMalfunctions = function (type) {
      RevueDeDirectionService.findMalfunctionByTypeAndId(type, $state.params.id).then(function (response) {
        $scope.malfunctions = response.data;
      }).catch(function (response) {
        console.log('Error findMalfunctions()');
      });
    };

    $scope.findIndicateurs = function () {
      var date = new Date($scope.managementReview.creation);
      TableauDeBordService.getIndicateursActiveConfidential(date.getFullYear(), $rootScope.user.isTeam).then(function (response) {
        $scope.indicateurs = response;
      }).catch(function (response) {
        console.log('Error findIndicateurs()');
      });
    };

    $scope.openMalfunction = function (malfunction) {
      $rootScope.malfunction = malfunction;
      $rootScope.fromRDD = true;
      $scope.malfunctionPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/apercu_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: 'ApercuController',
        locals: {
          pj: { type: 'MALFUNCTION', malfunction: malfunction },
          info: null
        }
      }).then(function () {
        $rootScope.malfunction = null;
        $rootScope.fromRDD = null;
      }).catch(function () {
        $rootScope.malfunction = null;
        $rootScope.fromRDD = null;
      });
    };

    $scope.goToPlanStrat = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        planID: plan.id,
        rddParams: {
          category: $state.params.category,
          id: $state.params.id
        }
      });
    };

    $scope.goSWOT = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        planID: plan.id,
        display: 'SWOT',
        rddParams: {
          category: $state.params.category,
          id: $state.params.id
        }
      });
    };

    $scope.goRisks = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        planID: plan.id,
        display: 'risks',
        rddParams: {
          category: $state.params.category,
          id: $state.params.id
        }
      });
    };

    $scope._sortList = function () {
      $scope._page.page = 0;
      $scope.noMoreData = false;
      $scope.managementReview.tacheGenerales = [];
      $scope._findList();
    };

    $scope._dateToTimestamp = function (_date) {
      var _result = angular.copy(_date);
      return _result.getTime();
    };


    //TASK

    $scope.onEcheanceChange = function (object) {
      object.echeance = object._echeance.valueOf();
    };

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {
      console.log(response);
    });

    var buildAndOpenRddTaskModal = function () {
      $scope._task = {
        categoryTmp: $scope.category.categoryTmpId
      };
      if ($scope.fromRDD) {
        for (var j = 0; j < $scope._categories.length; j++) {
          if ($scope._categories[j].value === 'ACTION_DECIDEE_REVUE_DIRECTION') {
            $scope._task.category = $scope._categories[j].value;
          }
        }
        showTaskModal();
      }
    };

    var refreshCategoryTmpId = function (managementReview) {
      if (!managementReview || !managementReview.categories || !$scope.category) {
        return;
      }
      for (var i = 0; i < managementReview.categories.length; i++) {
        if (managementReview.categories[i].id === $scope.category.id) {
          $scope.category.categoryTmpId = managementReview.categories[i].categoryTmpId;
          break;
        }
      }
    };

    $scope.addAction = function () {
      if ($scope.loadingCategoryForTask) {
        return;
      }
      if ($scope.category && $scope.category.categoryTmpId) {
        buildAndOpenRddTaskModal();
        return;
      }
      $scope.loadingCategoryForTask = true;
      var categoryToSave = angular.copy($scope.category);
      categoryToSave.questions = $scope.changeDateToTime(categoryToSave.questions);
      RevueDeDirectionService.saveCategory(categoryToSave, $state.params.id).then(function (data) {
        return RevueDeDirectionService.getManagementReviewById(data.data);
      }).then(function (managementReviewResponse) {
        refreshCategoryTmpId(managementReviewResponse.data);
        if (!$scope.category || !$scope.category.categoryTmpId) {
          toastr.error("Impossible de récupérer la catégorie. Veuillez réessayer.");
          return;
        }
        buildAndOpenRddTaskModal();
      }).catch(function (err) {
        console.log(err);
        toastr.error("Impossible d'enregistrer la catégorie avant la création de la tâche.");
      }).finally(function () {
        $scope.loadingCategoryForTask = false;
      });
    }

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      if ($scope._task && !$scope._task.categoryTmp && $scope.category && $scope.category.categoryTmpId) {
        $scope._task.categoryTmp = $scope.category.categoryTmpId;
      }
      var datasource = {
        task: $scope._task,
        fromManagementReview: $scope.managementReview.id
      }
      if (typeof $scope._task.echeance === 'number') {
        datasource.echeance = new Date($scope._task.echeance)
      }
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "RDD",
          datasource: datasource,
        },
        controller: "DialogController"
      }).then(function () {
        // nothing
        $scope.findTasks()
      }).catch(function () {

      });
    }

    // $scope._save = function () {
    //   if(!$scope.intoSaving){
    //     $scope.intoSaving=true;

    //     $scope._task.echeance = $scope.echeance.getTime();
    //     $scope._task.fromManagementReview = $scope.managementReview.id;
    //     var file = document.getElementById('document_input_file').files[0];
    //     var formData = new FormData();
    //     if (file != null) {
    //       formData.append('file', file);
    //     }
    //     formData.append('dto', angular.toJson($scope._task));
    //     TachesGeneralesService.save(formData).then(function (response) {
    //       toastr.success('Sauvegardée avec succès.');
    //       $scope._closeDialog();
    //       $timeout(function(){
    //         $scope.intoSaving=false;
    //       });
    //     }).catch(function (error) {
    //       console.log(error);
    //       $scope.intoSaving=false;
    //     });
    //   }

    // };

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    $scope._closeDialog = function () {
      $mdDialog.hide();
    };


    $scope._done = function (id) {
      TachesGeneralesService.done(id).then(function (response) { }).catch(function (error) {
        console.log(error);
      });
    };

    // Taches fin


    $scope.changeTimeToDate = function (questions) {
      angular.forEach(questions, function (item, key) {
        item.subquestions = $scope.changeDateToTime(item.subquestions);
        if (item.type === 'CHECKBOX_WITH_DATE') {
          if (item.dateValue) {
            item.dateValueInput = new Date(item.dateValue);
          }
        }
      });
      return questions;
    };

    $scope.changeDateToTime = function (questions) {
      angular.forEach(questions, function (item, key) {
        item.subquestions = $scope.changeDateToTime(item.subquestions);
        if (item.type === 'CHECKBOX_WITH_DATE') {
          if (item.dateValueInput) {
            item.dateValue = item.dateValueInput.getTime();
          } else {
            item.dateValue = (new Date()).getTime();
          }
        }
      });
      return questions;
    };



    if (angular.isUndefined($state.params.category) || $state.params.category == null) {
      window.history.back();
    }
    else {
      $scope.category = $state.params.category;
      $scope.findTasks();
      $scope.changeTimeToDate($scope.category.questions);
      $scope.managementReview = {
        tacheGenerales: []
      };
      if ($state.params.managementReview) {
        $scope.managementReview = $state.params.managementReview;
      }
      if ($scope.category.type === 'TASK') {
        $scope._findList();
      }
      else if ($scope.category.type === 'INDICATEUR') {
        $scope.findIndicateurs();
      }
      else if ($scope.category.type) {
        $scope.findElements($scope.category.type);
      }
      if ($scope.category.malfunctionTypeIndex != null) {
        $scope.findMalfunctions($scope.category.malfunctionTypeIndex);
      }
      if ($scope.category.type === 'PROGRESS_FORM') {
        FicheProgresService.getNbrOpenedAndClosed($state.params.id).then(function (res) {
          for (var i = 0; i < $scope.category.questions.length; i++) {
            if ($scope.category.questions[i].index === 1) {
              $scope.category.questions[i].numberValue = res.data.nbrOpened;
            }
            if ($scope.category.questions[i].index === 2) {
              $scope.category.questions[i].numberValue = res.data.nbrClosed;
            }
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    }


    //Category
    $scope.exitDetails = function () {
      $state.go('app.performances.bilan-de-performances.add', {
        id: $state.params.id
      });
    };


    $scope.openModal = function (element) {
      if ($scope.typeElement === 'PROGRESS_FORM') {
        $scope.ficheProgres = element;
        $scope.fromRDD = true;
        $scope.tachesFC = [];
        FicheProgresService.getAllTacheByProgressId(element.id).then(function (response) {
          var taches = response;
          if (taches && taches.data && taches.data.length > 0) {
            angular.forEach(taches.data, function (item, key) {
              $scope.tachesFC.push({
                date: new Date(item.echeance).toLocaleDateString(),
                responsable: item.responsable.name + ' ' + item.responsable.surname,
                title: item.title,
                doneDate: item.doneDate,
                done: item.done
              });
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
        $scope.ficheProgresPopup = $mdDialog.show({
          templateUrl: 'app/main/front/malfunctions/popup/fiche_progres_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () { }).catch(function () { });
      } else if ($scope.typeElement === 'AUDIT') {
        $scope.auditToDisplay = element;
        $mdDialog.show({
          templateUrl: 'app/main/front/performances/mes-evaluations/popup/display_audit.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true,
          controller: 'AuditController'
        }).then(function () { }).catch(function () { });
      } else if ($scope.typeElement === 'SATISFACTION') {
        $scope.satisfactionClientToDisplay = element;
        $scope.satisfactionPopUp = $mdDialog.show({
          templateUrl: 'app/main/front/performances/mes-evaluations/popup/display-satisfaction-client-popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () { }).catch(function () { });
      } else if ($scope.typeElement == 'AUTO_EVALUATION') {
        $scope.autoEvaluationToDisplay = element;
        $scope.autoEvalPopUp = $mdDialog.show({
          templateUrl: 'app/main/front/performances/mes-evaluations/popup/display-auto-evaluation-popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          $scope.autoEvaluationToDisplay = {};
        }).catch(function () {
          $scope.autoEvaluationToDisplay = {};
        });
      }
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.saveCategory = function (category) {
      if ($scope.loadingSave) {
        return;
      }
      $scope.loadingSave = true;
      category.questions = $scope.changeDateToTime(category.questions);
      RevueDeDirectionService.saveCategory(category, $state.params.id).then(function (data) {
        $scope.loadingSave = false;
        $state.go('app.performances.bilan-de-performances.add', {
          id: data.data
        });
      }).catch(function (data) {
        $scope.loadingSave = false;
        console.log(data);
      });
    };
    // Category fin

    $scope.downloadSatisfaction = function (docid) {
      $window.location.href = SatisfactionService.getDownloadLink(docid);
    };

    $scope.download = function (doc) {
      if (doc) {
        if ($scope.typeElement === 'SATISFACTION') {
          $window.location.href = SatisfactionService.getDownloadLink(doc.id);
        } else if ($scope.typeElement == 'AUTO_EVALUATION') {
          $window.location.href = AutoEvaluationService.getDownloadLink(doc.id);
        }
        else if ($scope.typeElement == 'AUDIT') {
          $window.location.href = AuditService.getDownloadLink(doc.id);
        }
      } else if ($scope.satisfactionClientToDisplay && $scope.satisfactionClientToDisplay.id) {
        $window.location.href = SatisfactionService.getDownloadLink($scope.satisfactionClientToDisplay.id);
      } else if ($scope.autoEvaluationToDisplay && $scope.autoEvaluationToDisplay.id) {
        $window.location.href = AutoEvaluationService.getDownloadLink($scope.autoEvaluationToDisplay.id);
      }
    };

    $scope.dialogEvaluate = function (fournisseur) {
      $state.go("app.performances.evaluation-fournisseurs.details", { id: fournisseur.id });
    };

    $scope.openTdb = function () {
      var url = $state.href("app.performances.tableau-de-bord");
      window.open(url, "_blank");
    }

    $scope.openFdpRddModal = function () {
      $scope.fdpRddPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/joindreFDP_popup.html',
        parent: angular.element(document.body),
        controller: 'JoindreFDPController',
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          index: null,
          excludeIds: $scope.managementReview.elements.map(function (element) { return element.id }),
          reunionMode: false
        }
      })
    }

    $scope.refreshElements = function () {
      $scope.findElements($scope.category.type);
      FicheProgresService.getNbrOpenedAndClosed($state.params.id).then(function (res) {
        for (var i = 0; i < $scope.category.questions.length; i++) {
          if ($scope.category.questions[i].index === 1) {
            $scope.category.questions[i].numberValue = res.data.nbrOpened;
          }
          if ($scope.category.questions[i].index === 2) {
            $scope.category.questions[i].numberValue = res.data.nbrClosed;
          }
        }
      })
    }

    $scope.$on('resultsadded', function (event, data) {
      for (var i = 0; i < data.selected.length; i++) {
        if (data.type === 'PROGRESS_FORM') {
          var row = data.selected[i];
          $scope.managementReview.elements.push(row);
          FicheProgresService.linkedToManagementReview(row.id, $state.params.id, true).then(function (res) {
            $scope.refreshElements()
          }).catch(function (err) {
            console.log(err)
          })
        }
      }
    })

    $scope.removeFicheProgress = function (item) {
      FicheProgresService.linkedToManagementReview(item.id, $state.params.id, false).then(function (res) {
        $scope.refreshElements();
        $scope.managementReview.elements = $scope.managementReview.elements.filter(function (element) { return element.id !== item.id })
      }).catch(function (err) {
        console.log(err)
      })

    }

    $scope._actionDecideeFaite = function (_actionDecidee) {
      TachesGeneralesService.done(_actionDecidee.id).then(function (response) {
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope._openDeleteTask = function (task) {
      $scope._task = task;
      $scope.deleteRecurrentTasks = {
        value: false
      };
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/taches-generales/confirm_delete_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        onRemoving: function (event, promise) {
          $scope._task = null;
        }
      });
    };
    $scope._delete = function (task) {
      if ($scope.loadingDeleteTask) {
        return;
      }
      $scope.loadingDeleteTask = true;
      TachesGeneralesService.delete(task.id, $scope.deleteRecurrentTasks.value).then(function () {
        $scope.loadingDeleteTask = false;
        $scope.category.tasks = $scope.category.tasks.filter(t => t.id != task.id)
        $rootScope.$broadcast('refreshCountNotifs')
        toastr.success("La tâche a bien été supprimée");
        $mdDialog.hide()
      }).catch(function (error) {
        $scope.loadingDeleteTask = false;
        console.log(error);
      });

    };

    $scope.showElement = function (element) {
      $scope._task = angular.copy(element)
      if (!$scope._task.categoryTmp && $scope.category && $scope.category.categoryTmpId) {
        $scope._task.categoryTmp = $scope.category.categoryTmpId;
      }
      showTaskModal()
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('RevueDeDirectionService', RevueDeDirectionService);

  function RevueDeDirectionService($q, $http) {
    var URL_REVUEDEDIRECTION = "/api/rest/managementreview/";

    var getAllQuestion = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var isThereAnyInProgress = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "isThereAnyInProgress",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveCategory = function (category, idManagement) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "saveCategory",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            id: idManagement
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: category
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };


    var getManagementReviewById = function (idManagement) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + idManagement,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };

    var findAllManagementReview = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "findAll",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });


    };

    var findTasks = function (catId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "category/" + catId + '/tasks',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });


    };

    var deleteManagementReview = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var validateManagementReview = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };


    var initManagementReview = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "init",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var sendEmail = function (idManagement) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "init",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };


    var findListElementManagementReview = function (output, page, type, id, isTeam) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "elements/" + id + "/" + page + "/" + output,
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            type: type,
            isTeam: isTeam
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };

    var findMalfunctionByTypeAndId = function (typeIndex, id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + 'malfunctions/' + id + '/' + typeIndex,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getFournisseurs = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/supplier/search",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {

          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var exportRDD = function (rdd) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "generateDocX/" + rdd.id,
          method: "POST",
          responseType: 'arraybuffer',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {

          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var hideRdd = function (id, isHidden) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_REVUEDEDIRECTION + "hide/" + id,
          method: "PUT",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          params: {
            isHidden: isHidden
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      })
    }


    return {
      getAllQuestion: getAllQuestion,
      saveCategory: saveCategory,
      getManagementReviewById: getManagementReviewById,
      findAllManagementReview: findAllManagementReview,
      findTasks: findTasks,
      deleteManagementReview: deleteManagementReview,
      validateManagementReview: validateManagementReview,
      initManagementReview: initManagementReview,
      sendEmail: sendEmail,
      findListElementManagementReview: findListElementManagementReview,
      isThereAnyInProgress: isThereAnyInProgress,
      findMalfunctionByTypeAndId: findMalfunctionByTypeAndId,
      getFournisseurs: getFournisseurs,
      exportRDD: exportRDD,
      hideRdd: hideRdd
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('RevueDeDirectionController', RevueDeDirectionController);

  function RevueDeDirectionController($scope, $state, $mdDialog, RevueDeDirectionService, $filter, toastr) {
    $scope.string = '';
    $scope.categories = [];
    $scope.progress = 0;
    $scope.loading = false;
    $scope.findAllQuestions = function () {
      RevueDeDirectionService.getAllQuestion().then(function (data) {
        $scope.categories = data.data;
      }).catch(function (data) {
        console.log('Error findAllQuestions()');
      });
    };

    $scope.findManagementReviewById = function (idManagement) {
      RevueDeDirectionService.getManagementReviewById(idManagement).then(function (data) {
        $scope.managementReview = data.data;
        $scope.categories = data.data.categories;
        $scope.progress = $filter('filter')($scope.categories, { validated: true }).length / $scope.categories.length * 100;
      }).catch(function (data) {

      });
    };

    $scope.openValidateRDD = function (managementId) {
      $scope.managementId = managementId;
      $mdDialog.show({
        templateUrl: 'app/main/front/performances/revue-de-direction/validate_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });

    };

    $scope.validateRDD = function () {
      $scope.managementId = $scope.managementReview.id;
      RevueDeDirectionService.validateManagementReview($scope.managementId).then(function (data) {
        $scope.goToListReview();
      }).catch(function (data) {
        toastr.error("Une erreur est survenue lors de la validation du Bilan de performances");
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.init = function () {
      if (angular.isUndefined($state.params.id) || $state.params.id == "" || $state.params.id == null) {
        $scope.findAllQuestions();
      } else {
        $scope.findManagementReviewById($state.params.id);
      }

    };

    $scope.init();


    $scope.goToDetails = function (category) {
      $state.go("app.performances.bilan-de-performances.details-category", { category: category, id: $state.params.id, managementReview: $scope.managementReview });
    };

    $scope.goToListReview = function () {
      $state.go("app.performances.bilan-de-performances");
    }

    $scope.exportRDD = function () {
      $scope.loading = true;
      RevueDeDirectionService.exportRDD($scope.managementReview).then(function (data) {
        var byteArray = new Uint8Array(data);
        var a = window.document.createElement('a');
        var today = new Date($scope.managementReview.validationDate);
        a.href = window.URL.createObjectURL(new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }));
        var name = "Bilan_de_performances_" + today.toLocaleDateString();
        a.download = name + ".docx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        $scope.loading = false;
      }).catch(function (err) {
        toastr.error("Un problème est survenu pendant l'exportation")
        $scope.loading = false;
      })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('ListRevueDeDirectionController', ListRevueDeDirectionController);

  function ListRevueDeDirectionController($scope, $state, RevueDeDirectionService, $mdDialog, toastr, PERMISSIONS, $rootScope) {
    $scope.string = '';
    $scope.managementReviews = [];
    $scope.anyInProgress = true;
    $scope.permissions = PERMISSIONS;
    $scope.loading = false;

    $scope.checkProgress = function () {
      RevueDeDirectionService.isThereAnyInProgress().then(function (res) {
        $scope.anyInProgress = !!res;
      }).catch(function (err) {
        console.log(err);
      });
    }

    $scope.createRDD = function () {
      if ($scope.loading) {
        return
      }
      $scope.loading = true
      RevueDeDirectionService.isThereAnyInProgress().then(function (res) {
        $scope.anyInProgress = !!res;
        if ($scope.anyInProgress && $scope.managementReviews.length != 0) {
          toastr.error("Veuillez valider le Bilan de performances en cours avant d'en créer un nouveau.");
          $scope.loading = false
        } else {
          RevueDeDirectionService.initManagementReview().then(function (data) {
            $scope.loading = false
            $state.go("app.performances.bilan-de-performances.add", {
              id: data.data
            });
          }).catch(function (data) {
            $scope.loading = false
            console.log(data);
          });
        }
      }).catch(function (err) {
        console.log(err);
        $scope.loading = false
      });


    };

    $scope.findAllManagementReview = function () {
      RevueDeDirectionService.findAllManagementReview().then(function (data) {
        $scope.managementReviews = data.data;
      }).catch(function (data) {

      });
    };

    $scope.goToCategories = function (idManagement) {
      $state.go("app.performances.bilan-de-performances.add", {
        id: idManagement
      });
    };


    // Send email
    $scope.sendEmail = function (idManagement) {

    };
    //



    //Delete
    $scope.dialogDelete = function (id) {
      $scope.idToDelete = id;
      $mdDialog.show({
        templateUrl: 'app/main/front/performances/revue-de-direction/delete_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };


    $scope.deleteManagementReview = function (id) {
      RevueDeDirectionService.deleteManagementReview(id).then(function () {
        for (var i = 0; i < $scope.managementReviews.length; i++) {
          if ($scope.managementReviews[i].id == id) {
            $scope.managementReviews.splice(i, 1);
            break;
          }
        }
        $scope.checkProgress();
        $scope.hidePopup();
        toastr.success("Le Bilan de performances a bien été supprimé");
      }).catch(function (response) {
        console.log(response);
        console.log("Error deleteManagementReview()");
      });
    };
    //Delete fin

    $scope.init = function () {
      $scope.findAllManagementReview();
      $scope.checkProgress();
    };

    $scope.init();

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }


    $scope.hideRdd = function (management) {
      if (!management) {
        return;
      }
      management.isHidden = !management.isHidden;
      RevueDeDirectionService.hideRdd(management.id, management.isHidden).then(function () {
        if (management.isHidden) {
          toastr.success("Le Bilan de performances a bien été masqué pour l\'équipe");
        } else {
          toastr.success("Le Bilan de performances a bien été rendu visible pour l\'équipe");
        }
      }).catch(function () {
        toastr.error("Une erreur est survenue lors du masquage du Bilan de performances");
      });
    }

    $scope.filterRdds = function(management) {
      return $rootScope.user.isTitulaire || $rootScope.user.isAdmin ? true : management.isHidden ? false : true;
    };

  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('PlanStrategiqueService', PlanStrategiqueService);

  function PlanStrategiqueService($q, $http) {
    var URL_PLANSTRAT = "/api/rest/planStrat";
    var URL_DOWNLOAD = "/api/rest/docgeneration";

    var save = function (planStrat) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: planStrat
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteObjectif = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + "/deleteObjectif/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getPlansConfidential = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + '/confidentials',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + '/' + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findObjectivesById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + '/' + id + '/objectives',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setConfidential = function (planStrat) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + "/setConfidential",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: planStrat
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deletePlan = function (planStrat) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + "/delete",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: planStrat
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getPlansNotConfidential = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var undraft = function (planStrat) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + "/draft",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: planStrat
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var addToRDD = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + "/addToRDD/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var downloadSWOT = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_DOWNLOAD + "/SWOT/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadRisk = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_DOWNLOAD + "/ANALYSE_DES_RISQUES_DE_LA_PHARMACIE/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadObjective = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_DOWNLOAD + "/PLAN_STRATEGIQUE/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var duplicate = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PLANSTRAT + '/' + id + '/duplicate',
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      save: save,
      getPlansNotConfidential: getPlansNotConfidential,
      setConfidential: setConfidential,
      deletePlan: deletePlan,
      undraft: undraft,
      getPlansConfidential: getPlansConfidential,
      addToRDD: addToRDD,
      downloadSWOT: downloadSWOT,
      downloadRisk: downloadRisk,
      deleteObjectif: deleteObjectif,
      downloadObjective: downloadObjective,
      findById: findById,
      findObjectivesById: findObjectivesById,
      duplicate: duplicate
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('PlanStrategiqueController', PlanStrategiqueController);

	function PlanStrategiqueController($scope, PLAN_STRAT_EXPOSITIONS, PLAN_STRAT_CATEGORIES, toastr, TachesGeneralesService, $state,
		EquipeDetailService, PlanStrategiqueService, $mdDialog, $rootScope, $stateParams, $filter, PERMISSIONS, GENERAL_TASK_PERIOD,
		GENERAL_TASK_TYPES, TASKS_EVENTS_REMINDERS, $timeout) {
		$scope.permissions = angular.copy(PERMISSIONS);
		$scope.updateMode = false;
		$scope.startIndex = 0;
		//TASK
		$scope.fromPlan = ($state.current.name.lastIndexOf('app.performances.plan-strategique') > -1);
		$scope._categories = angular.copy(GENERAL_TASK_TYPES);
		$scope._recurrences = angular.copy(GENERAL_TASK_PERIOD);
		$scope.reminders = TASKS_EVENTS_REMINDERS;
		$scope.addCollaborateurMode = false;
		$scope.planObjectifMode = false;

		$scope.canUpdate = false;

		$scope.activate = false;

		$scope.loading = false

		$timeout(function () {
			if (!$rootScope.user.isTeam) {
				$scope.canUpdate = true;
			}
		});

		$scope.plan = {
			swot: {
				strengths: null,
				weaknesses: null,
				opportunities: null,
				threats: null
			},
			risks: [],
			objectives: [],
			draft: true
		};

		$scope.riskOther = {
			title: null,
			commentary: null,
			exposition: null,
			selected: false
		};

		$scope.objective = {
			title: null,
			theme: null,
			confidential: false
		};

		$scope.showRisksOther = false;
		$scope.risksOther = [];
		$scope.objectives = [];
		// step 3
		$scope.risksTasks = {}

		$scope.stepsPassed = {
			first: false,
			second: false
		};

		$scope.categories = angular.copy(PLAN_STRAT_CATEGORIES);
		$scope.expositions = angular.copy(PLAN_STRAT_EXPOSITIONS);
		$scope.expositionsJSON = {};

		//init json
		for (var i = 0; i < PLAN_STRAT_EXPOSITIONS.length; i++) {
			$scope.expositionsJSON[PLAN_STRAT_EXPOSITIONS[i].value] = PLAN_STRAT_EXPOSITIONS[i].title;
		}

		var deleteAllElementsFromArrayExceptEmptyTitles = function (array) {
			var arrayReturn = [];
			for (var i = 0; i < array.length; i++) {
				if (array[i].title === null || array[i].title === '') {
					arrayReturn.push(array[i]);
				}
			}

			return arrayReturn;
		};

		$scope.init = function () {
			$scope.risksTasks = {}
			$scope.objectives = []
			PlanStrategiqueService.findById($state.params.id).then(function (res) {
				$scope.plan = res;
				if (!$scope.plan.draft) {
					$scope.goBack();
					return;
				}
				var nbrObjectives = $scope.plan.objectives.length;
				for (var i = 0; i < (3 - nbrObjectives); i++) {
					$scope.addObjective();
				}
				for (var j = 0; j < $scope.plan.risks.length; j++) {
					if ($scope.plan.risks[j].hasOwnProperty('idEnum')) {
						for (var y = 0; y < $scope.categories.length; y++) {
							for (var z = 0; z < $scope.categories[y].risks.length; z++) {
								if ($scope.categories[y].risks[z].idEnum == $scope.plan.risks[j].idEnum) {
									$scope.categories[y].risks[z].selected = true;
									$scope.categories[y].risks[z].exposition = $scope.plan.risks[j].exposition;
									$scope.categories[y].show = true;
									break;
								}
							}
						}
					} else {
						var risk = $scope.plan.risks[j];
						risk.selected = true;
						$scope.risksOther.push(risk);
						$scope.showRisksOther = true;
					}
				}

				for (var k = 0; k < $scope.plan.objectives.length; k++) {
					if ($scope.canUpdate) {
						$scope.objectives.push($scope.plan.objectives[k]);
					}
					else {
						if (!$scope.plan.objectives[k].confidential) { //Equipe ne peut pas voir objectifs confidentiels
							$scope.objectives.push($scope.plan.objectives[k]);
						}
					}
				}

				for (const task of $scope.plan.tasks) {

					if ($scope.risksTasks['' + task.idEnum] != null) {
						$scope.risksTasks['' + task.idEnum].push(task)
					} else {
						let riskFound = null
						for (const category of $scope.categories) {
							for (const risk of category.risks) {
								if (risk.idEnum === task.idEnum) {
									riskFound = risk
									break
								}
							}
							if (riskFound) {
								break
							}
						}
						$scope.risksTasks['' + task.idEnum] = [task]
					}
				}

				$scope.objectives = $filter('orderBy')($scope.objectives, 'id');
				$scope.activatePlanButton2()
				$scope.updateMode = true;
			}).catch(function (err) {
				console.error(err);
				$scope.goBack();
			});
		}

		$scope.refreshObjectives = function () {
			PlanStrategiqueService.findObjectivesById($state.params.id).then(function (res) {
				$scope.objectives = []
				$scope.plan.objectives = res
				var nbrObjectives = $scope.plan.objectives.length;
				for (var i = 0; i < (3 - nbrObjectives); i++) {
					$scope.addObjective();
				}
				for (var k = 0; k < $scope.plan.objectives.length; k++) {
					if ($scope.canUpdate) {
						$scope.objectives.push($scope.plan.objectives[k]);
					}
					else {
						if (!$scope.plan.objectives[k].confidential) { //Equipe ne peut pas voir objectifs confidentiels
							$scope.objectives.push($scope.plan.objectives[k]);
						}
					}
				}
				$scope.objectives = $filter('orderBy')($scope.objectives, 'id');
			}).catch(function () {

			})
		}

		$scope.addObjective = function () {
			$scope.objectives.push(angular.copy($scope.objective));
		};

		if ($stateParams.step != null) {
			if ($stateParams.step == 'risks') {
				$scope.startIndex = 1;
			} else if ($stateParams.step == 'objectives') {
				$scope.startIndex = 2;
			}
		}

		if ($stateParams.id != null && $stateParams.id !== '') {
			$scope.init()
		} else {
			for (var l = 0; l < 3; l++) {
				$scope.addObjective();
			}
		}


		$scope.goBack = function () {
			if ($stateParams.rddParams == null) {
				$state.go("app.performances.plan-strategique").catch(angular.noop);
			} else {
				$state.go("app.performances.bilan-de-performances.details-category", $stateParams.rddParams).catch(angular.noop);
			}
		}




		//TASK

		$scope.activatePlanButton = function (title, theme) {
			if (theme != null && theme != undefined) {
				if (title != null && title != '') {
					$scope.activate = true;
				}
				else $scope.activate = false;
			}
		}

		$scope.activatePlanButton2 = function () {
			var obj = $scope.objectives.find(o => o.id)
			if (obj != null) {
				$scope.activatePlanButton(obj.title, obj.theme);
			}
			else $scope.activate = false;
		}

		$scope.onEcheanceChange = function (object) {
			object.echeance = object._echeance.valueOf();
		};

		EquipeDetailService.getCollaborateurs().then(function (data) {
			$scope._users = data;
		}).catch(function (response) {
			console.log(response);
		});

		$scope.planAction = function (risk) {
			EquipeDetailService.getCollaborateurs().then(function (data) {
				$scope._users = data;
			}).catch(function (error) {
				console.log(error);
			});

			$scope.planObjectifMode = false;
			$scope._task = {};
			if ($scope.fromPlan) {
				for (var j = 0; j < $scope._categories.length; j++) {
					if ($scope._categories[j].value === 'OBJECTIF_STRATEGIQUE') {
						$scope._task.category = $scope._categories[j].value;
					}
				}
			}
			if (risk) {
				$scope.risk = {
					idEnum: risk.idEnum,
					id: risk.id
				};
			}
			if (!$scope.planObjectifMode) {
				if ($scope.risk && $scope.risk.idEnum) {
					$scope._task.planId = $scope.plan.id;
					$scope._task.idEnum = $scope.risk.idEnum;
				}
			}
			showTaskModal();
		};

		function showTaskModal($event) {
			var parentEl = angular.element(document.body);
			var datasource = {
				task: $scope._task,
			}
			if (typeof $scope._task.echeance === 'number') {
				datasource.echeance = new Date($scope._task.echeance)
			}
			$mdDialog.show({
				parent: parentEl,
				clickOutsideToClose: true,
				templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
				locals: {
					type: "PLAN_STRATEGIQUE",
					datasource: datasource,
				},
				controller: "DialogController"
			}).then(function () {
			}).catch(function () {

			});
		}


		$scope.$on('refreshPlan', () => {
			$scope.init()
		})
		$scope.$on('refreshObjectives', () => {
			$scope.refreshObjectives()
		})

		// $scope._save = function () {
		//   if(!$scope.intoSaving){
		//     $scope.intoSaving=true;
		//     var file = document.getElementById('document_input_file').files[0];
		//     var formData = new FormData();

		//     if (file != null) {
		//       formData.append('file', file);
		//     }

		//     if (!$scope.planObjectifMode) {
		//       if ($scope.risk && $scope.risk.idEnum) {
		//         $scope._task.planId = $scope.plan.id;
		//         $scope._task.idEnum = $scope.risk.idEnum;
		//       }
		//     }
		//     $scope._task.echeance = $scope.echeance.getTime();
		//     formData.append('dto', angular.toJson($scope._task));
		//     TachesGeneralesService.save(formData).then(function (response) {
		//       if($scope.risk.id){
		//         $scope.risksOther.forEach(function(element){
		//           if(element.id && element.id==$scope.risk.id){
		//             if(!element.actions){
		//               element.actions = [];
		//               element.actions[element.actions.length] = response.data;
		//             }else{
		//               element.actions[element.actions.length] = response.data;
		//             }

		//           }
		//         });
		//       }
		//       toastr.success('Sauvegardée avec succès.');
		//       $scope._closeDialog();
		//       $timeout(function(){
		//         $scope.intoSaving=false;
		//       });
		//     }).catch(function (error) {
		//       $scope.intoSaving=false;
		//       console.log(error);
		//     });
		//   }
		// };

		$scope.saveRisk = function (risk) {
			if (!risk.exposition || !risk.title) {
				toastr.error("Veuillez remplir les champs titre et exposition");
				return;
			}
			TachesGeneralesService.saveRisk(risk).then(function (res) {
				risk.id = res.data.id;
			}).catch(function (err) {
				toastr.error("Un problème est survenu pendant l'enregistrement")
			});
		}
		$scope.addCollaborateur = function () {
			$scope.addCollaborateurMode = !$scope.addCollaborateurMode;
			$scope._task.responsable = {};
		};

		$scope._closeDialog = function () {
			$mdDialog.hide();
		};

		$scope.goListPlans = function () {
			$state.go('app.performances.plan-strategique').catch(angular.noop);
		};

		$scope.showCategorie = function (index) {
			if ($scope.categories[index].hasOwnProperty('show')) {
				$scope.categories[index].show = !$scope.categories[index].show;
			} else {
				$scope.categories[index].show = true;
			}
		};

		$scope.showRisk = function (parentIndex, index) {
			if ($scope.categories[parentIndex].risks[index].hasOwnProperty('show')) {
				$scope.categories[parentIndex].risks[index].show = !$scope.categories[parentIndex].risks[index].show;
			} else {
				$scope.categories[parentIndex].risks[index].show = true;
			}
		};

		$scope.showOther = function () {
			$scope.showRisksOther = !$scope.showRisksOther;
		};

		$scope.getSelectedRisks = function () {
			$scope.plan.risks = [];

			for (var i = 0; i < $scope.categories.length; i++) {
				for (var y = 0; y < $scope.categories[i].risks.length; y++) {
					if ($scope.categories[i].risks[y].selected) {
						var risk = $scope.categories[i].risks[y];
						//delete risk.selected;
						$scope.plan.risks.push(risk);
					}
				}
			}

			for (var i = 0; i < $scope.risksOther.length; i++) {
				if ($scope.risksOther[i].selected) {
					var risk = $scope.risksOther[i];
					//delete risk.selected;
					$scope.plan.risks.push(risk);
				}
			}

		};

		$scope.addRiskOther = function () {
			$scope.risksOther.push(angular.copy($scope.riskOther));
		};

		$scope.addRiskOther();

		$scope.nextStep = function (index) {
			if ($scope.objectives.length != 0) {
				for (var i = 0; i < $scope.objectives.length; i++) {
					if ($scope.objectives[i].id != null) {
						$scope.activatePlanButton($scope.objectives[i].title, $scope.objectives[i].theme);
						break;
					}
				}
			}

			if (index === 1) {
				$scope.stepsPassed.first = true;
			} else if (index === 2) {
				$scope.stepsPassed.second = true;
				if (!$rootScope.user.isTeam) {
					$scope.getSelectedRisks();
				}

			}
			//ce bloc pose probleme car les objectifs confidentiels deviennent visibles pour lEquipe, si en step 3 on fait precedent et suivant ensuite

			// PlanStrategiqueService.save($scope.plan).then(function (res) {
			//   $scope.plan = res;
			//   $scope.objectives = deleteAllElementsFromArrayExceptEmptyTitles($scope.objectives);
			//   for (var i = 0; i < $scope.plan.objectives.length; i++) {
			//     $scope.objectives.unshift($scope.plan.objectives[i]);
			//   }
			// }).catch(function (err) {
			//   console.log('Error savePlanStrat()');
			// });

			var content = document.getElementById('content');

			if (content != null) {
				content.scrollTop = 0;
			}
		};

		$scope.previousStep = function () {
			var content = document.getElementById('content');

			if (content != null) {
				content.scrollTop = 0;
			}
		};

		$scope.getObjectives = function () {
			$scope.plan.objectives = [];

			for (var i = 0; i < $scope.objectives.length; i++) {
				if ($scope.objectives[i].title != null && $scope.objectives[i].title != '') {
					$scope.plan.objectives.push($scope.objectives[i]);
				}
			}
		};

		$scope.openValidate = function () {
			$mdDialog.show({
				templateUrl: 'app/main/front/performances/plan-strategique/popup/validate_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {
			}).catch(function () {
			});
		};

		$scope.validate = function (bool, index) {
			if ($scope.loading) {
				return
			}
			$scope.loading = true
			$scope.getObjectives();
			if (index == 1) {
				$scope.stepsPassed.second = true;
				if (!$rootScope.user.isTeam) {
					$scope.getSelectedRisks();
				}
			}
			PlanStrategiqueService.save($scope.plan).then(function (res) {
				var creation = !$scope.plan.id;
				$scope.plan = res;
				$scope.loading = false

				if (bool) {
					// retour a la liste : ne pas reecrire l'url, sinon la transition vers
					// la liste serait annulee par la seconde ('transition superseded')
					$scope.goListPlans();
					return;
				}

				if (creation) {
					// pour changer l'url de création en url de modification du plan (permet l'utilisation du $state.params.id à jour)
					var newParams = angular.extend({}, $stateParams, { id: res.id });
					$state.go(
						$state.current.name,
						newParams,
						{
							notify: false,
							location: 'replace',
							reload: false
						}
					).catch(angular.noop);
				}
				// index null => validation du plan
				if (index == null) {
					$scope.undraftPlan();
				}
			}).catch(function (err) {
				$scope.loading = false
				console.log('Error savePlanStrat()');
			});
		};

		$scope.deleteObjective = function (objectif, index) {
			if (objectif.id != null) {
				PlanStrategiqueService.deleteObjectif(objectif.id).then(function (res) {
					$scope.objectives.splice(index, 1);
					toastr.success('Objectif supprimé du plan stratégique');
					$scope.activatePlanButton2();
				}).catch(function (err) {
					toastr.error("Impossible de supprimer l'objectif, veuillez réessayer plus tard");
				});
			} else {
				$scope.objectives.splice(index, 1);
				toastr.success('Objectif supprimé du plan stratégique');
				$scope.activatePlanButton2();
			}
		};

		$scope.undraftPlan = function () {
			var dto = {};

			if ($scope.plan.id != null) {
				//modification
				dto = {
					id: $scope.plan.id,
					draft: false
				};

				PlanStrategiqueService.undraft(dto).then(function (res) {
					$scope.plan.draft = false;
					$state.go('app.performances.plan-strategique.display', {
						planID: $scope.plan.id
					});
				}).catch(function (err) {
					console.log('Error undraftPlan()');
				});
			} else {
				//création
				$scope.plan.draft = false;
			}
		};

		$scope.planActionObjective = function (obj, index) {
			if (obj.title === null || obj.title === '') {
				toastr.error('Veuillez renseigner le titre de l\'objectif');
				return;
			}
			$scope.getObjectives();
			var objToPlan = null;

			EquipeDetailService.getCollaborateurs().then(function (data) {
				$scope._users = data;
			}).catch(function (error) {
				console.log(error);
			});

			if (!obj.id) {
				PlanStrategiqueService.save($scope.plan).then(function (res) {
					$scope.plan = angular.copy(res);

					$scope.objectives = deleteAllElementsFromArrayExceptEmptyTitles($scope.objectives);
					for (var i = 0; i < $scope.plan.objectives.length; i++) {
						$scope.objectives.push($scope.plan.objectives[i]);
					}
					$scope.objectives = $filter('orderBy')($scope.objectives, 'id');


					if ($scope.plan.objectives[$scope.plan.objectives.length - 1].title === obj.title) {
						objToPlan = $scope.plan.objectives[$scope.plan.objectives.length - 1];
					} else {
						for (var i = 0; i < $scope.plan.objectives.length; i++) {
							if ($scope.plan.objectives[i].title === obj.title) {
								objToPlan = $scope.plan.objectives[i];
							}
						}
					}

					if (objToPlan !== null && objToPlan.id !== null) {
						$scope._task = {
							objectivePlanStratID: objToPlan.id,
						};
						$scope.planObjectifMode = true;
						for (var j = 0; j < $scope._categories.length; j++) {
							if ($scope._categories[j].value === 'OBJECTIF_STRATEGIQUE') {
								$scope._task.category = $scope._categories[j].value;
							}
						}

						showTaskModal();
					}
				}).catch(function (err) {
					console.log(err);
				});
			} else {
				PlanStrategiqueService.save($scope.plan).then(function (res) {
					$scope.plan = angular.copy(res);

					$scope.objectives = deleteAllElementsFromArrayExceptEmptyTitles($scope.objectives);
					for (var i = 0; i < $scope.plan.objectives.length; i++) {
						$scope.objectives.push($scope.plan.objectives[i]);
					}
					$scope.objectives = $filter('orderBy')($scope.objectives, 'id');

					objToPlan = obj;

					if (objToPlan !== null && objToPlan.id !== null) {
						$scope._task = {
							objectivePlanStratID: objToPlan.id,
						};
						$scope.planObjectifMode = true;
						for (var j = 0; j < $scope._categories.length; j++) {
							if ($scope._categories[j].value === 'OBJECTIF_STRATEGIQUE') {
								$scope._task.category = $scope._categories[j].value;
							}
						}

						showTaskModal();
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		};

		$scope.showElement = function (element) {
			$scope._task = angular.copy(element)
			showTaskModal()
		}

		$scope._openDelete = function (task) {
			$scope._task = task;
			$scope.deleteRecurrentTasks = {
				value: false
			};
			$mdDialog.show({
				templateUrl: 'app/main/front/equipe/taches-generales/confirm_delete_dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true,
				onRemoving: function (event, promise) {
					$scope._task = null;
				}
			});
		};
		$scope._delete = function (task) {
			if ($scope.loadingDeleteTask) {
				return;
			}
			$scope.loadingDeleteTask = true;
			TachesGeneralesService.delete(task.id, $scope.deleteRecurrentTasks.value).then(function (response) {
				$scope.loadingDeleteTask = false;
				for (let i = 0; i < $scope.objectives.length; i++) {
					$scope.objectives[i].tasks = $scope.objectives[i].tasks.filter(t => t.id != task.id)
				}
				$rootScope.$broadcast('refreshCountNotifs')
				toastr.success("La tâche a bien été supprimée");
				$mdDialog.hide()
			}).catch(function (error) {
				$scope.loadingDeleteTask = false;
				console.log(error);
			});

		};

	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('ListPlansStrategiquesController', ListPlansStrategiquesController);

  function ListPlansStrategiquesController($scope, $state, PlanStrategiqueService, $rootScope, PERMISSIONS, $mdDialog, toastr, $timeout) {
    $scope.plansStrategiques = [];
    $scope.permissions = PERMISSIONS;
    $scope.planToDelete = {};
    $scope.indexToDelete;

    $scope.getPlans = function () {
      if ($rootScope.user) {
        if ($rootScope.user.isPraq || $rootScope.user.isTitulaire) {
          PlanStrategiqueService.getPlansConfidential().then(function (data) {
            $scope.plansStrategiques = data;
          }).catch(function (err) {
            console.log(err);
            console.log("Error getPlans() no praq");
          });
        } else {
          PlanStrategiqueService.getPlansNotConfidential().then(function (data) {
            $scope.plansStrategiques = data;
          }).catch(function (err) {
            console.log("Error getPlans() no praq");
          });
        }
      } else {
        var listener = $scope.$on('rooScopeUser:ready', function (event, data) {
          $scope.getPlans();
          listener();
        });
      }
    }

    $timeout(function () {
      $scope.getPlans();
    });

    $scope.goAddPlan = function () {
      $state.go("app.performances.plan-strategique.add");
    }

    $scope.update = function (plan) {
      $state.go("app.performances.plan-strategique.add", {
        plan: plan,
        id: plan.id
      });
    }

    $scope.update1 = function (plan) {
      $state.go("app.performances.plan-strategique.add", {
        plan: plan,
        step: 'risks',
        id: plan.id
      });
    }

    $scope.setConfidentiel = function (plan, state, index) {
      var dto = {
        id: plan.id,
        confidential: !state
      };
      PlanStrategiqueService.setConfidential(dto).then(function (data) {
        if ($rootScope.user.isTitulaire || $rootScope.user.isPraq) {
          plan.confidential = !state;
        } else {
          $scope.plansStrategiques.splice(index, 1);
        }
      }).catch(function (err) {
        console.log("Error setConfidential()");
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.delete = function () {
      var dto = {
        id: $scope.planToDelete.id,
        deleted: true
      };

      PlanStrategiqueService.deletePlan(dto).then(function (data) {
        $scope.plansStrategiques.splice($scope.indexToDelete, 1);
        $scope.hidePopup();
      }).catch(function (err) {
        console.log("Error delete()");
        console.log(err);
      });
    }

    $scope.goSWOT = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        display: 'SWOT',
        planID: plan.id
      });
    }

    $scope.goRisks = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        display: 'risks',
        planID: plan.id
      });
    }

    $scope.openPopUpDelete = function (plan, index) {
      $scope.planToDelete = angular.copy(plan);
      $scope.indexToDelete = index;
      $scope.deletePlanPopUp = $mdDialog.show({
        templateUrl: 'app/main/front/performances/plan-strategique/popup/delete_plan_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.planToDelete = {};
        $scope.indexToDelete = null;
      }).catch(function () {
        $scope.planToDelete = {};
        $scope.indexToDelete = null;
      });
    };

    $scope.display = function (plan) {
      $state.go('app.performances.plan-strategique.display', {
        // plan: plan,
        planID: plan.id
      });
    };

    $scope.openDuplicate = function (plan) {
      $scope.planToDuplicate = plan
      $scope.duplicatePopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/plan-strategique/popup/duplicate_plan.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.planToDuplicate = null;
      }).catch(function () {
        $scope.planToDuplicate = null;
      });
    }

    $scope.duplicate = function () {
      if ($scope.loadingDup) {
        return
      }
      $scope.loadingDup = true
      PlanStrategiqueService.duplicate($scope.planToDuplicate.id).then(function (res) {
        $scope.loadingDup = false
        toastr.success('Plan dupliqué')
        $mdDialog.hide()
        $state.go('app.performances.plan-strategique.add', { id: res.id, plan: res })
      }).catch(function () {
        $scope.loadingDup = false
      })
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('DisplayPlanStrategiqueController', DisplayPlanStrategiqueController);

  function DisplayPlanStrategiqueController($scope, $rootScope, $state, $stateParams, PlanStrategiqueService, PLAN_STRAT_CATEGORIES, PLAN_STRAT_EXPOSITIONS, $timeout) {
    $scope.swotMode = false;
    $scope.risksMode = false;
    $scope.allMode = false;
    $scope.managementReviewMode = false;
    $scope.expositionsJSON = {};
    $scope.risksTasks = {}
    $scope.risksOther = []
    $scope.categories = angular.copy(PLAN_STRAT_CATEGORIES);
    var liste = [];
    $timeout(function () {
      if ($rootScope.user.isTeam && $state.params.plan.objectives.length > 0) { //filtrage des objectifs confidentiels
        $state.params.plan.objectives.forEach(function (element) {
          if (element.confidential == false) {
            liste.push(element);
          }
        });
        $state.params.plan.objectives = liste;
      }
    });

    $scope.initRisks = function () {
      for (var j = 0; j < $scope.plan.risks.length; j++) {
        if ($scope.plan.risks[j].hasOwnProperty('idEnum')) {
          for (var y = 0; y < $scope.categories.length; y++) {
            for (var z = 0; z < $scope.categories[y].risks.length; z++) {
              if ($scope.categories[y].risks[z].idEnum == $scope.plan.risks[j].idEnum) {
                $scope.categories[y].risks[z].selected = true;
                $scope.categories[y].risks[z].exposition = $scope.plan.risks[j].exposition;
                $scope.categories[y].show = true;
                break;
              }
            }
          }
        } else {
          var risk = $scope.plan.risks[j];
          risk.selected = true;
          $scope.risksOther.push(risk);
          $scope.showRisksOther = true;
        }
      }

      for (const task of $scope.plan.tasks) {

        if ($scope.risksTasks['' + task.idEnum] != null) {
          $scope.risksTasks['' + task.idEnum].push(task)
        } else {
          let riskFound = null
          for (const category of $scope.categories) {
            for (const risk of category.risks) {
              if (risk.idEnum === task.idEnum) {
                riskFound = risk
                break
              }
            }
            if (riskFound) {
              break
            }
          }
          $scope.risksTasks['' + task.idEnum] = [task]
        }
      }
    }

    //init json
    for (var i = 0; i < PLAN_STRAT_EXPOSITIONS.length; i++) {
      $scope.expositionsJSON[PLAN_STRAT_EXPOSITIONS[i].value] = PLAN_STRAT_EXPOSITIONS[i].title;
    }

    $scope.goBack = function () {
      if ($stateParams.rddParams == null) {
        $state.go("app.performances.plan-strategique");
      } else {
        $state.go("app.performances.bilan-de-performances.details-category", $stateParams.rddParams);
      }
    }

    if ($stateParams.rddParams != null) {
      $scope.managementReviewMode = true;
    }

    if ($stateParams.plan != null) {
      $scope.plan = $stateParams.plan;
      $scope.initRisks()
    } else if ($stateParams.planID != null) {
      PlanStrategiqueService.findById($stateParams.planID).then(function (res) {
        $scope.plan = res;
        $scope.initRisks()
      }).catch(function (err) {
        console.error(err);
        $scope.goBack();
      });
    } else {
      $scope.goBack();
    }

    if ($stateParams.display != null && $stateParams.display !== '') {
      if ($stateParams.display == 'SWOT') {
        $scope.swotMode = true;
      } else if ($stateParams.display == 'risks') {
        $scope.risksMode = true;
      }
    } else {
      $scope.allMode = true;
    }

    $scope.editSWOT = function () {
      $state.go("app.performances.plan-strategique.add", {
        plan: $scope.plan,
        id: $scope.plan.id
      });
    }

    $scope.download = function (type) {
      if (type == "SWOT" && $scope.plan && $scope.plan.swot && $scope.plan.swot.id) {
        PlanStrategiqueService.downloadSWOT($scope.plan.swot.id).then(function (data) {
          window.open("/api/rest/docgeneration/download/?location=" + data);
        }).catch(function (err) {
          console.log(err);
        })
      } else if (type == "RISK" && $scope.plan && $scope.plan.risks && $scope.plan.risks.length) {
        PlanStrategiqueService.downloadRisk($scope.plan.id).then(function (data) {
          window.open("/api/rest/docgeneration/download/?location=" + data);
        }).catch(function (error) {
          console.log(error);
        });
      } else if (type == 'OBJECTIVE' && $scope.plan && $scope.plan.objectives && $scope.plan.objectives.length) {
        PlanStrategiqueService.downloadObjective($scope.plan.id).then(function (data) {
          window.open("/api/rest/docgeneration/download/?location=" + data);
        }).catch(function (error) {
          console.log(error);
        });
      }

    };

    $scope.editRisks = function () {
      $state.go("app.performances.plan-strategique.add", {
        plan: $scope.plan,
        step: "risks",
        id: $scope.plan ? $scope.plan.id : null
      });
    }

    $scope.editObjectives = function () {
      $state.go("app.performances.plan-strategique.add", {
        plan: $scope.plan,
        step: "objectives",
        id: $scope.plan.id
      });
    }

  };
})();

(function () {
	'use strict';

	angular.module('app.front')
		.service('SatisfactionService', SatisfactionService);

	function SatisfactionService($q, $http) {
		var URL_SATISFACTION = "/api/rest/satisfaction/client";

		var find = function () {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var save = function (fd) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION,
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": undefined },
					transformRequest: angular.identity,
					data: fd
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION + "/" + id,
					method: "DELETE",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" },
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getDownloadLink = function (documentId) {
			return '/api/rest/satisfaction/client/download/' + documentId;
		};

		var findByPharmacyAndPage = function (page, nbrResults) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION + "/list/" + page + "/" + nbrResults,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var addToODJ = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION + "/addToODJ/" + id,
					method: "POST",
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						"Content-Type": "application/json; charset=UTF-8"
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getPagination = function (pagination) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION + "/paginated",
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" },
					data: pagination
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});

			});
		}

		var findById = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: URL_SATISFACTION + "/" + id,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" },
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});

			});
		}

		return {
			find: find,
			save: save,
			remove: remove,
			getDownloadLink: getDownloadLink,
			findByPharmacyAndPage: findByPharmacyAndPage,
			addToODJ: addToODJ,
			getPagination: getPagination,
			findById: findById
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('SatisfactionClientController', SatisfactionClientController);

  function SatisfactionClientController($scope, $rootScope, $state, $stateParams, $mdDialog, $window, toastr,
    SatisfactionService, PERMISSIONS, $timeout, AutoEvaluationService, AutoControlesService, AuditService,
    EquipeDetailService, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD, TASKS_EVENTS_REMINDERS,
    QuestionnaireSatisfactionCampaignService, QuestionnaireSatisfactionToolboxService) {
    var DEFAULT_DIFFUSION_MESSAGE = "Diffusez votre enquête via les canaux ci-dessous. Les liens sont tracés par origine (SMS, Email, QR code, Papier, Tablette, Réseaux sociaux).";
    var QUALITY_APPROACH_BOOKING_URL = "https://outlook.office.com/bookwithme/user/14f6b409e2b94ffc89f29b9b33c85dec%40phsq.fr/meetingtype/u5VyxOIdrUu_GDEb4uBHMw2?anonymous&ismsaljsauthenabled";

    $scope.satisfactions = [];
    $scope.autos = []
    $scope.audits = []
    $scope.flashs = []
    $scope.permissions = PERMISSIONS;
    $scope.tabs = {
      auto: 'auto',
      audit: 'audit',
      client: 'client',
      flash: 'flash',
      monEnquete: 'mon-enquete'
    }
    $scope.monEnqueteSubTabs = {
      enquete: 'enquete',
      toolbox: 'toolbox',
      results: 'results'
    };
    $scope.monEnqueteSubTabActive = $scope.monEnqueteSubTabs.enquete;
    $scope.questionnaireCampaignContext = null;
    $scope.smsData = { mobile: '' };
    $scope.emailData = { email: '' };
    $scope.emailSending = false;
    $scope.toolboxTools = [];
    $scope.toolboxLoading = false;
    $scope.monEnqueteResultsTabs = {
      solicitations: 'sollicitations',
      verbatims: 'verbatims',
      detailCriteres: 'detail-criteres',
      profils: 'profils'
    };
    $scope.monEnqueteResultsTabActive = $scope.monEnqueteResultsTabs.solicitations;
    $scope.questionnaireSolicitationStats = null;
    $scope.questionnaireSolicitationStatsLoading = false;
    $scope.questionnaireSolicitationStatsError = false;
    $scope.questionnaireVerbatimStats = null;
    $scope.questionnaireVerbatimStatsLoading = false;
    $scope.questionnaireVerbatimStatsError = false;
    $scope.questionnaireVerbatimPagination = {
      page: 1,
      nbrResults: 10,
      total: 0,
      pageCount: 0,
      searchText: ''
    };
    $scope.questionnaireCriteriaDetailsStats = null;
    $scope.questionnaireCriteriaDetailsStatsLoading = false;
    $scope.questionnaireCriteriaDetailsStatsError = false;
    $scope.questionnaireProfileStats = null;
    $scope.questionnaireProfileStatsLoading = false;
    $scope.questionnaireProfileStatsError = false;
    $scope.criteriaDetailsScopes = [
      { key: 'national', title: 'Ma pharmacie', data: null },
      { key: 'groupement', title: 'Mon groupement', data: null }
    ];
    $scope.selectedHistoricalSolicitationYear = null;
    $scope.resultsPosterPopupData = null;
    $scope.resultsPosterLoading = false;
    $scope.resultsPosterGenerating = false;

    var solicitationCharts = {};
    var criteriaDetailCharts = {};
    var profileCharts = {};
    var verbatimStatsRequestId = 0;
    var verbatimSearchDebouncePromise = null;
    var getChartDatasetColor = function (dataset, index) {
      if (!dataset || !dataset.backgroundColor) {
        return null;
      }
      if (angular.isArray(dataset.backgroundColor)) {
        return dataset.backgroundColor[index] || dataset.backgroundColor[dataset.backgroundColor.length - 1];
      }
      return dataset.backgroundColor;
    };
    var getHexColorRgb = function (color) {
      if (!color || color.charAt(0) !== '#') {
        return null;
      }
      var normalizedColor = color.slice(1);
      if (normalizedColor.length === 3) {
        normalizedColor = normalizedColor.charAt(0) + normalizedColor.charAt(0)
          + normalizedColor.charAt(1) + normalizedColor.charAt(1)
          + normalizedColor.charAt(2) + normalizedColor.charAt(2);
      }
      if (normalizedColor.length !== 6) {
        return null;
      }
      return {
        r: parseInt(normalizedColor.slice(0, 2), 16),
        g: parseInt(normalizedColor.slice(2, 4), 16),
        b: parseInt(normalizedColor.slice(4, 6), 16)
      };
    };
    var getChartContrastTextColor = function (backgroundColor) {
      var rgb = getHexColorRgb(backgroundColor);
      if (!rgb) {
        return '#ffffff';
      }
      var luminance = (0.299 * rgb.r) + (0.587 * rgb.g) + (0.114 * rgb.b);
      return luminance > 165 ? '#1e2a3a' : '#ffffff';
    };
    var resolveChartValueLabelColor = function (colorConfig, numericValue, dataset, index, chartInstance) {
      if (angular.isFunction(colorConfig)) {
        return colorConfig(numericValue, dataset, index, chartInstance);
      }
      return colorConfig || '#425166';
    };
    var getChartValueLabelCoordinates = function (model, isHorizontal, position, offset) {
      if (position === 'center') {
        return {
          x: isHorizontal ? model.base + ((model.x - model.base) / 2) : model.x,
          y: isHorizontal ? model.y : model.base + ((model.y - model.base) / 2),
          textAlign: 'center',
          textBaseline: 'middle'
        };
      }
      return {
        x: isHorizontal ? model.x + offset : model.x,
        y: isHorizontal ? model.y : model.y - offset,
        textAlign: isHorizontal ? 'left' : 'center',
        textBaseline: isHorizontal ? 'middle' : 'bottom'
      };
    };
    var chartValueLabelsPlugin = {
      afterDatasetsDraw: function (chartInstance) {
        var pluginOptions = ((chartInstance.config || {}).options || {}).valueLabels;
        if (!pluginOptions || !pluginOptions.enabled) {
          return;
        }

        var ctx = chartInstance.chart.ctx;
        var isHorizontal = chartInstance.config.type === 'horizontalBar';
        var fontSize = pluginOptions.fontSize || 11;
        var fontWeight = pluginOptions.fontWeight || '600';
        var fontFamily = pluginOptions.fontFamily || "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
        var offset = angular.isNumber(pluginOptions.offset) ? pluginOptions.offset : 8;
        var position = pluginOptions.position || (isHorizontal ? 'end' : 'top');

        ctx.save();
        ctx.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;

        angular.forEach((chartInstance.data && chartInstance.data.datasets) || [], function (dataset, datasetIndex) {
          var meta = chartInstance.getDatasetMeta(datasetIndex);
          if (!meta || meta.hidden) {
            return;
          }

          angular.forEach(meta.data || [], function (element, index) {
            var rawValue = dataset.data[index];
            var numericValue = Number(rawValue);
            if (!isFinite(numericValue)) {
              return;
            }
            if (pluginOptions.skipZero !== false && numericValue <= 0) {
              return;
            }

            var label = angular.isFunction(pluginOptions.formatter)
              ? pluginOptions.formatter(numericValue, dataset, index, chartInstance)
              : String(numericValue);
            if (!label) {
              return;
            }

            var model = element && element._model;
            if (!model) {
              return;
            }

            var coordinates = getChartValueLabelCoordinates(model, isHorizontal, position, offset);
            if (!coordinates) {
              return;
            }

            if (pluginOptions.skipIfTooSmall !== false && position === 'center') {
              var barSize = isHorizontal
                ? Math.abs((model.x || 0) - (model.base || 0))
                : Math.abs((model.y || 0) - (model.base || 0));
              if (barSize < ctx.measureText(label).width + 10) {
                return;
              }
            }

            ctx.fillStyle = resolveChartValueLabelColor(pluginOptions.color, numericValue, dataset, index, chartInstance);
            ctx.textAlign = coordinates.textAlign;
            ctx.textBaseline = coordinates.textBaseline;
            ctx.fillText(
              label,
              coordinates.x,
              coordinates.y
            );
          });
        });

        ctx.restore();
      }
    };

    var isNonLqoUser = !!($rootScope.user && $rootScope.user.isNonLqo);
    // Une officine sans LQO n'a que deux onglets : « Mon enquête » et « Auto-évaluation ».
    var ongletsNonLqo = [$scope.tabs.monEnquete, $scope.tabs.auto];

    if (isNonLqoUser && ongletsNonLqo.indexOf($stateParams.tab) < 0) {
      $scope.tabActive = $scope.tabs.monEnquete;
      $state.go($state.current.name, { tab: $scope.tabs.monEnquete }, { notify: false, location: 'replace' });
      $timeout(function () {
        if ($scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.enquete
            && !$scope.questionnaireSolicitationStats) {
          $scope.refreshQuestionnaireSolicitationStats(false);
        }
      }, 0);
    } else if ($stateParams.tab && $stateParams.tab === $scope.tabs.monEnquete) {
      $scope.tabActive = $scope.tabs.monEnquete;
      // Précharger les compteurs de réponses pour le sous-onglet "Enquête"
      $timeout(function () {
        if ($scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.enquete
            && !$scope.questionnaireSolicitationStats) {
          $scope.refreshQuestionnaireSolicitationStats(false);
        }
      }, 0);
    } else {
      $scope.tabActive = $scope.tabs.auto;
    }

    var openPublicQuestionnaire = function (source) {
      if (!$scope.questionnaireCampaignContext || !$scope.questionnaireCampaignContext.questionnaireIdentifier) {
        return;
      }
      var link = QuestionnaireSatisfactionCampaignService.buildPublicLink(
        $scope.questionnaireCampaignContext.questionnaireIdentifier,
        source,
        true
      );
      $window.open(link, '_blank');
    };

    var copyQuestionnaireLink = function (source, successMessage) {
      if (!$scope.questionnaireCampaignContext || !$scope.questionnaireCampaignContext.questionnaireIdentifier) {
        toastr.error('Lien indisponible');
        return;
      }
      var link = QuestionnaireSatisfactionCampaignService.buildPublicLink(
        $scope.questionnaireCampaignContext.questionnaireIdentifier,
        source,
        true
      );
      copyToClipboard(link).then(function () {
        toastr.success(successMessage);
      }).catch(function () {
        toastr.error('Copie impossible, veuillez réessayer.');
      });
    };

    var copyToClipboard = function (text) {
      if (!text) {
        return Promise.reject();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return Promise.resolve();
      } catch (e) {
        document.body.removeChild(textArea);
        return Promise.reject(e);
      }
    };

    var parseFilenameFromContentDisposition = function (contentDisposition) {
      if (!contentDisposition) {
        return null;
      }
      var filenameMatch = contentDisposition.match(/filename\\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i);
      if (!filenameMatch) {
        return null;
      }
      var rawFilename = filenameMatch[1] || filenameMatch[2];
      if (!rawFilename) {
        return null;
      }
      try {
        return decodeURIComponent(rawFilename);
      } catch (e) {
        return rawFilename;
      }
    };

    var downloadArrayBufferFile = function (response, fallbackFilename, fallbackMimeType) {
      var headers = response && response.headers ? response.headers : function () { return null; };
      var contentDisposition = headers('content-disposition') || headers('Content-Disposition');
      var filename = parseFilenameFromContentDisposition(contentDisposition) || fallbackFilename;
      var contentType = headers('content-type') || headers('Content-Type') || fallbackMimeType || 'application/octet-stream';

      var file = new Blob([response.data], { type: contentType });
      var url = ($window.URL || window.URL).createObjectURL(file);
      var downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      ($window.URL || window.URL).revokeObjectURL(url);
    };

    var decodeArrayBufferErrorMessage = function (response) {
      if (!response || !response.data) {
        return null;
      }
      if (response.data.message) {
        return response.data.message;
      }
      if (!(response.data instanceof ArrayBuffer)) {
        return null;
      }
      try {
        var uintArray = new Uint8Array(response.data);
        var raw = '';
        for (var i = 0; i < uintArray.length; i++) {
          raw += String.fromCharCode(uintArray[i]);
        }
        var parsed = JSON.parse(raw);
        return parsed && parsed.message ? parsed.message : null;
      } catch (e) {
        return null;
      }
    };

    $scope.refreshQuestionnaireCampaignContext = function (forceRefresh) {
      QuestionnaireSatisfactionCampaignService.getContext(!!forceRefresh).then(function (context) {
        $scope.questionnaireCampaignContext = context;
      }).catch(function () {
        $scope.questionnaireCampaignContext = null;
      });
    };

    $scope.openQualityApproach = function () {
      $window.open(QUALITY_APPROACH_BOOKING_URL, '_blank');
    };

    $scope.getOutsideCampaignMessage = function (context) {
      var year = context && context.nextCampaignYear;
      if (angular.isNumber(year)) {
        return "La prochaine campagne enquête débutera en " + year + ". Vos résultats de la campagne précédente restent consultables dans l'onglet Satisfaction clients.";
      }
      return "La campagne enquête n'est pas active actuellement.";
    };

    $scope.getCampaignYear = function () {
      var ctx = $scope.questionnaireCampaignContext;
      if (ctx && angular.isNumber(ctx.dateDebutCampagne)) {
        return new Date(ctx.dateDebutCampagne).getFullYear();
      }
      return new Date().getFullYear();
    };

    $scope.getDaysUntilCampaignStart = function () {
      var ctx = $scope.questionnaireCampaignContext;
      if (!ctx || !angular.isNumber(ctx.dateDebutCampagne)) {
        return null;
      }
      var startMidnight = new Date(ctx.dateDebutCampagne);
      startMidnight.setHours(0, 0, 0, 0);
      var todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);
      var diffMs = startMidnight.getTime() - todayMidnight.getTime();
      var days = Math.ceil(diffMs / (24 * 60 * 60 * 1000));
      return days >= 0 ? days : null;
    };

    $scope.shouldShowCampaignTeaser = function () {
      var ctx = $scope.questionnaireCampaignContext;
      if (!ctx || ctx.discoveryPharmacy || ctx.campaignActive || ctx.campaignClosed) {
        return false;
      }
      var days = $scope.getDaysUntilCampaignStart();
      return days !== null && days > 0 && days <= 30;
    };

    $scope.getQuestionnaireDiffusionMessage = function () {
      if ($scope.questionnaireCampaignContext && $scope.questionnaireCampaignContext.diffusionMessage) {
        return $scope.questionnaireCampaignContext.diffusionMessage;
      }
      return DEFAULT_DIFFUSION_MESSAGE;
    };

    var extractTools = function (data) {
      if (angular.isArray(data)) {
        return data;
      }
      if (data && angular.isArray(data.tools)) {
        return data.tools;
      }
      return [];
    };

    $scope.refreshToolboxTools = function () {
      $scope.toolboxLoading = true;
      QuestionnaireSatisfactionToolboxService.getTools().then(function (data) {
        $scope.toolboxTools = extractTools(data);
      }).catch(function () {
        $scope.toolboxTools = [];
        toastr.error('Erreur lors du chargement de la boîte à outils');
      }).finally(function () {
        $scope.toolboxLoading = false;
      });
    };


    var destroySolicitationChart = function (chartKey) {
      if (solicitationCharts[chartKey]) {
        solicitationCharts[chartKey].destroy();
        solicitationCharts[chartKey] = null;
      }
    };

    var destroySolicitationCharts = function () {
      destroySolicitationChart('current');
      destroySolicitationChart('historical');
    };

    var destroyCriteriaDetailChart = function (chartKey) {
      if (criteriaDetailCharts[chartKey]) {
        criteriaDetailCharts[chartKey].destroy();
        criteriaDetailCharts[chartKey] = null;
      }
    };

    var destroyCriteriaDetailCharts = function () {
      angular.forEach(criteriaDetailCharts, function (_, chartKey) {
        destroyCriteriaDetailChart(chartKey);
      });
    };

    var destroyProfileChart = function (chartKey) {
      if (profileCharts[chartKey]) {
        profileCharts[chartKey].destroy();
        profileCharts[chartKey] = null;
      }
    };

    var destroyProfileCharts = function () {
      angular.forEach(profileCharts, function (_, chartKey) {
        destroyProfileChart(chartKey);
      });
    };

    var hasSolicitationResultsTabSelected = function () {
      return $scope.tabActive === $scope.tabs.monEnquete
        && $scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.results
        && $scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.solicitations;
    };

    var loadActiveMonEnqueteResultsTab = function (forceRefresh) {
      if ($scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.verbatims) {
        destroySolicitationCharts();
        destroyCriteriaDetailCharts();
        destroyProfileCharts();
        $scope.refreshQuestionnaireVerbatimStats(forceRefresh);
        return;
      }
      if ($scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.detailCriteres) {
        destroySolicitationCharts();
        destroyProfileCharts();
        $scope.refreshQuestionnaireCriteriaDetailsStats(forceRefresh);
        return;
      }
      if ($scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.profils) {
        destroySolicitationCharts();
        destroyCriteriaDetailCharts();
        $scope.refreshQuestionnaireProfileStats(forceRefresh);
        return;
      }
      destroyCriteriaDetailCharts();
      destroyProfileCharts();
      $scope.refreshQuestionnaireSolicitationStats(forceRefresh);
    };

    var getQuestionnaireVerbatimTableScrollTop = function () {
      var tableAnchor = $window.document.getElementById('qsClientVerbatimTableAnchor');
      if (!tableAnchor || !tableAnchor.getBoundingClientRect) {
        return null;
      }
      var currentOffset = $window.pageYOffset || 0;
      var absoluteTop = tableAnchor.getBoundingClientRect().top + currentOffset;
      return Math.max(absoluteTop - 16, 0);
    };

    var buildQuestionnaireVerbatimPageNumbers = function () {
      var total = Number($scope.questionnaireVerbatimPagination.total) || 0;
      var pageSize = Number($scope.questionnaireVerbatimPagination.nbrResults) || 1;
      var currentPage = Number($scope.questionnaireVerbatimPagination.page) || 1;
      var paginationRange = 9;
      var pageCount = total > 0 ? Math.max(Math.ceil(total / pageSize), 1) : 0;

      if (pageCount <= 0) {
        return [];
      }

      var pages = [];
      var halfWay = Math.ceil(paginationRange / 2);
      var position;

      if (currentPage <= halfWay) {
        position = 'start';
      } else if (pageCount - halfWay < currentPage) {
        position = 'end';
      } else {
        position = 'middle';
      }

      var ellipsesNeeded = paginationRange < pageCount;
      var i = 1;
      while (i <= pageCount && i <= paginationRange) {
        var pageNumber;
        if (i === paginationRange) {
          pageNumber = pageCount;
        } else if (i === 1) {
          pageNumber = i;
        } else if (paginationRange < pageCount) {
          if (pageCount - halfWay < currentPage) {
            pageNumber = pageCount - paginationRange + i;
          } else if (halfWay < currentPage) {
            pageNumber = currentPage - halfWay + i;
          } else {
            pageNumber = i;
          }
        } else {
          pageNumber = i;
        }

        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...');
        } else {
          pages.push(pageNumber);
        }
        i++;
      }
      return pages;
    };

    var syncCriteriaDetailsScopes = function () {
      var stats = $scope.questionnaireCriteriaDetailsStats || {};
      angular.forEach($scope.criteriaDetailsScopes, function (scope) {
        scope.data = stats[scope.key] || null;
      });
    };

    var getHistoricalSolicitationCampaigns = function () {
      return (($scope.questionnaireSolicitationStats && $scope.questionnaireSolicitationStats.historicalCampaigns) || []).slice().sort(function (left, right) {
        return right.year - left.year;
      });
    };

    var getSelectedHistoricalSolicitationCampaign = function () {
      var historicalCampaigns = getHistoricalSolicitationCampaigns();
      if (!historicalCampaigns.length) {
        return null;
      }
      for (var i = 0; i < historicalCampaigns.length; i++) {
        if (historicalCampaigns[i].year === $scope.selectedHistoricalSolicitationYear) {
          return historicalCampaigns[i];
        }
      }
      return historicalCampaigns[0];
    };

    var syncSelectedHistoricalSolicitationYear = function () {
      var selectedCampaign = getSelectedHistoricalSolicitationCampaign();
      $scope.selectedHistoricalSolicitationYear = selectedCampaign ? selectedCampaign.year : null;
    };

    var buildSolicitationChartPayload = function (campaigns) {
      var labels = [];
      var sent = [];
      var partial = [];
      var completed = [];
      // Si plusieurs campagnes (comparaison historique), on préfixe par l'année,
      // sinon on garde uniquement le nom du canal (titre de la card déjà explicite).
      var multi = (campaigns || []).length > 1;

      angular.forEach(campaigns || [], function (campaign) {
        angular.forEach((campaign && campaign.channels) || [], function (channel) {
          labels.push(multi ? (campaign.year + ' · ' + channel.label) : channel.label);
          sent.push(channel.sent || 0);
          partial.push(channel.partial || 0);
          completed.push(channel.completed || 0);
        });
      });

      return {
        labels: labels,
        datasets: [
          {
            // Envoyées = volume total (fond bleu doux, ton neutre)
            label: 'Envoyées',
            backgroundColor: 'rgba(33, 105, 213, 0.22)',
            borderColor: 'rgba(33, 105, 213, 0.9)',
            borderWidth: 1,
            data: sent
          },
          {
            // Partielles = commencées mais pas finies (orange)
            label: 'Partielles',
            backgroundColor: 'rgba(233, 120, 31, 0.85)',
            borderColor: '#d96810',
            borderWidth: 1,
            data: partial
          },
          {
            // Complétées = terminées (vert soutenu, cohérent avec la grille canaux)
            label: 'Complétées',
            backgroundColor: '#228b4c',
            borderColor: '#1f7a43',
            borderWidth: 1,
            data: completed
          }
        ]
      };
    };

    var buildSolicitationChartConfig = function (campaigns) {
      return {
        type: 'bar',
        plugins: [chartValueLabelsPlugin],
        data: buildSolicitationChartPayload(campaigns),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 28, right: 8, left: 4, bottom: 4 }
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 14,
              padding: 14,
              fontColor: '#4c5a73',
              fontSize: 12
            }
          },
          valueLabels: {
            enabled: true,
            color: '#1e2c3f',
            formatter: formatChartNumericValue
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(30, 44, 63, 0.95)',
            titleFontColor: '#ffffff',
            bodyFontColor: '#e4e9f2',
            titleFontSize: 13,
            bodyFontSize: 12,
            cornerRadius: 8,
            xPadding: 12,
            yPadding: 10,
            displayColors: true,
            bodySpacing: 4
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                fontColor: '#4c5a73',
                fontSize: 12,
                padding: 8
              },
              categoryPercentage: 0.7,
              barPercentage: 0.78
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(76, 90, 115, 0.1)',
                drawBorder: false,
                zeroLineColor: 'rgba(76, 90, 115, 0.2)',
                zeroLineWidth: 1
              },
              ticks: {
                beginAtZero: true,
                fontColor: '#8c99b0',
                fontSize: 11,
                padding: 8,
                callback: function (value) {
                  if (Math.floor(value) === value) {
                    return value;
                  }
                }
              }
            }]
          }
        }
      };
    };

    var normalizeChartValue = function (value) {
      var numericValue = Number(value);
      if (!isFinite(numericValue)) {
        return null;
      }
      return Math.round(numericValue * 10) / 10;
    };

    var formatChartPercentageValue = function (value) {
      var normalizedValue = normalizeChartValue(value);
      if (normalizedValue === null) {
        return '';
      }
      var decimals = normalizedValue % 1 === 0 ? 0 : 1;
      return normalizedValue.toFixed(decimals).replace('.', ',') + ' %';
    };

    var formatChartNumericValue = function (value) {
      var normalizedValue = normalizeChartValue(value);
      if (normalizedValue === null) {
        return '';
      }
      var decimals = normalizedValue % 1 === 0 ? 0 : 1;
      return normalizedValue.toFixed(decimals).replace('.', ',');
    };

    var renderSolicitationChart = function (chartKey, canvasId, campaigns) {
      destroySolicitationChart(chartKey);
      if (!campaigns || !campaigns.length) {
        return;
      }
      var payload = buildSolicitationChartPayload(campaigns);
      if (!payload.labels.length) {
        return;
      }
      var canvas = document.getElementById(canvasId);
      if (!canvas) {
        return;
      }
      solicitationCharts[chartKey] = new Chart(canvas.getContext('2d'), buildSolicitationChartConfig(campaigns));
    };

    var renderSolicitationCharts = function () {
      if (!hasSolicitationResultsTabSelected() || !$scope.questionnaireSolicitationStats) {
        return;
      }
      $timeout(function () {
        renderSolicitationChart('current', 'qsSolicitationsCurrentChart', [$scope.questionnaireSolicitationStats.currentCampaign]);
        if ($scope.questionnaireSolicitationStats.historicalVisible) {
          syncSelectedHistoricalSolicitationYear();
          var selectedHistoricalCampaign = getSelectedHistoricalSolicitationCampaign();
          renderSolicitationChart('historical', 'qsSolicitationsHistoricalChart', selectedHistoricalCampaign ? [selectedHistoricalCampaign] : []);
        } else {
          destroySolicitationChart('historical');
        }
      }, 0);
    };


    var hasCriteriaDetailsResultsTabSelected = function () {
      return $scope.tabActive === $scope.tabs.monEnquete
        && $scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.results
        && $scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.detailCriteres;
    };

    var hasProfileResultsTabSelected = function () {
      return $scope.tabActive === $scope.tabs.monEnquete
        && $scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.results
        && $scope.monEnqueteResultsTabActive === $scope.monEnqueteResultsTabs.profils;
    };

    var splitCriteriaLabel = function (label, maxLength) {
      if (!label || label.length <= maxLength) {
        return label;
      }
      var words = label.split(' ');
      var lines = [];
      var currentLine = '';
      angular.forEach(words, function (word) {
        var candidate = currentLine ? currentLine + ' ' + word : word;
        if (candidate.length > maxLength && currentLine) {
          lines.push(currentLine);
          currentLine = word;
          return;
        }
        currentLine = candidate;
      });
      if (currentLine) {
        lines.push(currentLine);
      }
      return lines.length > 1 ? lines : label;
    };

    var createCriteriaChart = function (chartKey, canvasId, config) {
      destroyCriteriaDetailChart(chartKey);
      var canvas = document.getElementById(canvasId);
      if (!canvas) {
        return;
      }
      criteriaDetailCharts[chartKey] = new Chart(canvas.getContext('2d'), config);
    };

    var buildPercentageScale = function (axis) {
      return [{
        stacked: false,
        gridLines: {
          color: 'rgba(91, 107, 130, 0.15)',
          drawBorder: false
        },
        ticks: {
          beginAtZero: true,
          max: 100,
          fontColor: '#5b6b82',
          callback: function (value) {
            return value + '%';
          }
        }
      }];
    };

    var buildCriteriaBarChartConfig = function (labels, values, colors, horizontal) {
      return {
        type: horizontal ? 'horizontalBar' : 'bar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: colors,
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          layout: {
            padding: horizontal ? { right: 42 } : { top: 24 }
          },
          valueLabels: {
            enabled: true,
            color: '#425166',
            formatter: formatChartPercentageValue
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                var value = horizontal ? tooltipItem.xLabel : tooltipItem.yLabel;
                return value + '%';
              }
            }
          },
          scales: {
            xAxes: horizontal ? buildPercentageScale('x') : [{
              gridLines: { display: false, drawBorder: false },
              ticks: { autoSkip: false, fontColor: '#5b6b82' }
            }],
            yAxes: horizontal ? [{
              gridLines: { display: false, drawBorder: false },
              ticks: { fontColor: '#5b6b82' }
            }] : buildPercentageScale('y')
          }
        }
      };
    };

    var buildCriteriaGaugeChartConfig = function (average) {
      var safeAverage = angular.isNumber(average) ? Math.max(0, Math.min(10, average)) : 0;
      return {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [safeAverage, Math.max(0, 10 - safeAverage)],
            backgroundColor: ['#6cc343', '#7c7c7c'],
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          rotation: -Math.PI,
          circumference: Math.PI,
          cutoutPercentage: 72,
          legend: { display: false },
          tooltips: { enabled: false }
        }
      };
    };

    var buildCriteriaStackedChartConfig = function (rows) {
      var labels = [];
      var veryDissatisfied = [];
      var dissatisfied = [];
      var neutral = [];
      var satisfied = [];
      var verySatisfied = [];

      angular.forEach(rows || [], function (row) {
        labels.push(splitCriteriaLabel(row.label, 28));
        veryDissatisfied.push(row.veryDissatisfied || 0);
        dissatisfied.push(row.dissatisfied || 0);
        neutral.push(row.neutral || 0);
        satisfied.push(row.satisfied || 0);
        verySatisfied.push(row.verySatisfied || 0);
      });

      return {
        type: 'horizontalBar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: labels,
          datasets: [
            { label: 'Très insatisfait', data: veryDissatisfied, backgroundColor: '#df3e48', borderWidth: 0 },
            { label: 'Insatisfait', data: dissatisfied, backgroundColor: '#d2776c', borderWidth: 0 },
            { label: 'Neutre', data: neutral, backgroundColor: '#7c7c7c', borderWidth: 0 },
            { label: 'Satisfait', data: satisfied, backgroundColor: '#a1d273', borderWidth: 0 },
            { label: 'Très satisfait', data: verySatisfied, backgroundColor: '#83c14f', borderWidth: 0 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          valueLabels: {
            enabled: true,
            position: 'center',
            fontSize: 10,
            fontWeight: '700',
            color: function (_, dataset, index) {
              return getChartContrastTextColor(getChartDatasetColor(dataset, index));
            },
            formatter: formatChartPercentageValue
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.xLabel + '%';
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: { color: 'rgba(91, 107, 130, 0.15)', drawBorder: false },
              ticks: { beginAtZero: true, max: 100, fontColor: '#5b6b82', callback: function (value) { return value + '%'; } }
            }],
            yAxes: [{
              stacked: true,
              gridLines: { display: false, drawBorder: false },
              ticks: { fontColor: '#5b6b82' }
            }]
          }
        }
      };
    };

    var getCriteriaItemPercentages = function (items) {
      var values = [];
      angular.forEach(items || [], function (item) {
        values.push(item.percentage || 0);
      });
      return values;
    };

    var getCriteriaItemLabels = function (items, maxLength) {
      var labels = [];
      angular.forEach(items || [], function (item) {
        labels.push(splitCriteriaLabel(item.label, maxLength || 18));
      });
      return labels;
    };

    var getCriteriaBarColors = function (items, palette) {
      var colors = [];
      angular.forEach(items || [], function (item, index) {
        colors.push(palette[index] || palette[palette.length - 1]);
      });
      return colors;
    };

    var destroyCriteriaScopeCharts = function (scopeKey) {
      angular.forEach(['gauge', 'distribution', 'criteria', 'visit', 'priority', 'recommendation', 'urgent', 'customer'], function (suffix) {
        destroyCriteriaDetailChart(scopeKey + '-' + suffix);
      });
    };

    var renderCriteriaScopeCharts = function (scope) {
      if (!scope || !scope.key) {
        return;
      }
      if (!scope.data || !scope.data.questionnaireCount) {
        destroyCriteriaScopeCharts(scope.key);
        return;
      }

      createCriteriaChart(scope.key + '-gauge', 'qsCriteriaGaugeChart-' + scope.key, buildCriteriaGaugeChartConfig(scope.data.overallSatisfactionAverage));
      createCriteriaChart(scope.key + '-distribution', 'qsCriteriaDistributionChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.overallSatisfactionDistribution, 2),
        getCriteriaItemPercentages(scope.data.overallSatisfactionDistribution),
        ['#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#9dd46d', '#9dd46d'],
        false
      ));
      createCriteriaChart(scope.key + '-criteria', 'qsCriteriaStackedChart-' + scope.key, buildCriteriaStackedChartConfig(scope.data.criteriaEvaluation));
      createCriteriaChart(scope.key + '-visit', 'qsCriteriaVisitReasonsChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.visitReasons, 18),
        getCriteriaItemPercentages(scope.data.visitReasons),
        getCriteriaBarColors(scope.data.visitReasons, ['#4d7dbf', '#b44752', '#97b54c', '#7f5fa6', '#94a3b8']),
        false
      ));
      createCriteriaChart(scope.key + '-priority', 'qsCriteriaPrioritiesChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.environmentalPriorities, 26),
        getCriteriaItemPercentages(scope.data.environmentalPriorities),
        getCriteriaBarColors(scope.data.environmentalPriorities, ['#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#d8e7dd']),
        true
      ));
      createCriteriaChart(scope.key + '-recommendation', 'qsCriteriaRecommendationChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.recommendation && scope.data.recommendation.values, 10),
        getCriteriaItemPercentages(scope.data.recommendation && scope.data.recommendation.values),
        ['#9dd46d', '#d2776c'],
        false
      ));
      createCriteriaChart(scope.key + '-urgent', 'qsCriteriaUrgentCareChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.urgentCare, 26),
        getCriteriaItemPercentages(scope.data.urgentCare),
        getCriteriaBarColors(scope.data.urgentCare, ['#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#cfdbe8']),
        true
      ));
      createCriteriaChart(scope.key + '-customer', 'qsCriteriaCustomerChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.regularCustomer && scope.data.regularCustomer.values, 10),
        getCriteriaItemPercentages(scope.data.regularCustomer && scope.data.regularCustomer.values),
        ['#9dd46d', '#d2776c'],
        false
      ));
    };

    var renderCriteriaDetailsCharts = function () {
      if (!hasCriteriaDetailsResultsTabSelected() || !$scope.questionnaireCriteriaDetailsStats) {
        return;
      }
      $timeout(function () {
        angular.forEach($scope.criteriaDetailsScopes, function (scope) {
          renderCriteriaScopeCharts(scope);
        });
      }, 0);
    };

    var buildProfileChartConfig = function (question, campaignYear, colors) {
      var datasets = [];
      angular.forEach((question && question.values) || [], function (value, index) {
        datasets.push({
          label: value.label,
          data: [value.percentage || 0],
          backgroundColor: colors[index] || colors[colors.length - 1],
          borderColor: colors[index] || colors[colors.length - 1],
          borderWidth: 0,
          maxBarThickness: 56
        });
      });
      return {
        type: 'bar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: [String(campaignYear)],
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 24 }
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 14,
              fontColor: '#425166'
            }
          },
          valueLabels: {
            enabled: true,
            color: '#425166',
            formatter: formatChartPercentageValue
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.yLabel + '%';
              }
            }
          },
          scales: {
            xAxes: [{
              gridLines: { display: false, drawBorder: false },
              ticks: { fontColor: '#5b6b82' },
              categoryPercentage: 0.64,
              barPercentage: 0.9
            }],
            yAxes: buildPercentageScale('y')
          }
        }
      };
    };

    var renderProfileChart = function (chartKey, canvasId, question, campaignYear, colors) {
      destroyProfileChart(chartKey);
      if (!question || !question.values || !question.values.length) {
        return;
      }
      var canvas = document.getElementById(canvasId);
      if (!canvas) {
        return;
      }
      profileCharts[chartKey] = new Chart(canvas.getContext('2d'), buildProfileChartConfig(question, campaignYear, colors));
    };

    var renderProfileCharts = function () {
      if (!hasProfileResultsTabSelected() || !$scope.questionnaireProfileStats) {
        return;
      }
      $timeout(function () {
        renderProfileChart('gender', 'qsProfileGenderChart', $scope.questionnaireProfileStats.gender,
          $scope.questionnaireProfileStats.campaignYear, ['#b74fd7', '#79d44b']);
        renderProfileChart('age-range', 'qsProfileAgeRangeChart', $scope.questionnaireProfileStats.ageRange,
          $scope.questionnaireProfileStats.campaignYear, ['#b74fd7', '#7f20d5', '#75df45', '#4eb7ea', '#d7b44d']);
        renderProfileChart('regular-customer', 'qsProfileRegularCustomerChart', $scope.questionnaireProfileStats.regularCustomer,
          $scope.questionnaireProfileStats.campaignYear, ['#b74fd7', '#ef8a1f']);
      }, 0);
    };

    $scope.refreshQuestionnaireSolicitationStats = function (forceRefresh) {
      $scope.questionnaireSolicitationStatsLoading = true;
      $scope.questionnaireSolicitationStatsError = false;
      QuestionnaireSatisfactionCampaignService.getSolicitationStats(!!forceRefresh).then(function (data) {
        $scope.questionnaireSolicitationStats = data;
        syncSelectedHistoricalSolicitationYear();
        renderSolicitationCharts();
      }).catch(function () {
        $scope.questionnaireSolicitationStats = null;
        $scope.selectedHistoricalSolicitationYear = null;
        $scope.questionnaireSolicitationStatsError = true;
        destroySolicitationCharts();
      }).finally(function () {
        $scope.questionnaireSolicitationStatsLoading = false;
      });
    };

    $scope.refreshQuestionnaireVerbatimStats = function (forceRefresh, page, restoreScrollTop) {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      var targetPage = page && page > 0 ? page : ($scope.questionnaireVerbatimPagination.page || 1);
      var targetScrollTop = angular.isNumber(restoreScrollTop) ? restoreScrollTop : null;
      var requestId = ++verbatimStatsRequestId;

      $scope.questionnaireVerbatimStatsLoading = true;
      $scope.questionnaireVerbatimStatsError = false;
      $scope.questionnaireVerbatimPagination.page = targetPage;

      QuestionnaireSatisfactionCampaignService.getVerbatimStats(
        !!forceRefresh,
        targetPage,
        $scope.questionnaireVerbatimPagination.nbrResults,
        $scope.questionnaireVerbatimPagination.searchText
      ).then(function (data) {
        if (requestId !== verbatimStatsRequestId) {
          return;
        }

        var comments = data && angular.isArray(data.comments) ? data.comments : [];
        $scope.questionnaireVerbatimStats = data || null;
        if ($scope.questionnaireVerbatimStats) {
          $scope.questionnaireVerbatimStats.comments = comments;

          var resolvedPage = Number($scope.questionnaireVerbatimStats.page);
          if (isFinite(resolvedPage) && resolvedPage > 0) {
            $scope.questionnaireVerbatimPagination.page = resolvedPage;
          }

          var resolvedNbrResults = Number($scope.questionnaireVerbatimStats.nbrResults);
          if (isFinite(resolvedNbrResults) && resolvedNbrResults > 0) {
            $scope.questionnaireVerbatimPagination.nbrResults = resolvedNbrResults;
          }

          var resolvedTotal = Number($scope.questionnaireVerbatimStats.commentCount);
          $scope.questionnaireVerbatimPagination.total = isFinite(resolvedTotal) && resolvedTotal >= 0
            ? resolvedTotal
            : comments.length;
          $scope.questionnaireVerbatimPagination.pageCount = $scope.questionnaireVerbatimPagination.total > 0
            ? Math.max(Math.ceil($scope.questionnaireVerbatimPagination.total / ($scope.questionnaireVerbatimPagination.nbrResults || 1)), 1)
            : 0;
        } else {
          $scope.questionnaireVerbatimPagination.total = 0;
          $scope.questionnaireVerbatimPagination.pageCount = 0;
        }
      }).catch(function () {
        if (requestId !== verbatimStatsRequestId) {
          return;
        }
        $scope.questionnaireVerbatimStats = null;
        $scope.questionnaireVerbatimPagination.total = 0;
        $scope.questionnaireVerbatimPagination.pageCount = 0;
        $scope.questionnaireVerbatimStatsError = true;
      }).finally(function () {
        if (requestId !== verbatimStatsRequestId) {
          return;
        }
        $scope.questionnaireVerbatimStatsLoading = false;
        if (targetScrollTop !== null) {
          $timeout(function () {
            var content = $window.document.getElementById('content');
            if (content) {
              content.scrollTop = targetScrollTop;
            } else {
              $window.scrollTo(0, targetScrollTop);
            }
          }, 0);
        }
      });
    };

    $scope.refreshQuestionnaireCriteriaDetailsStats = function (forceRefresh) {
      $scope.questionnaireCriteriaDetailsStatsLoading = true;
      $scope.questionnaireCriteriaDetailsStatsError = false;
      QuestionnaireSatisfactionCampaignService.getCriteriaDetailsStats(!!forceRefresh).then(function (data) {
        $scope.questionnaireCriteriaDetailsStats = data;
        syncCriteriaDetailsScopes();
        renderCriteriaDetailsCharts();
      }).catch(function () {
        $scope.questionnaireCriteriaDetailsStats = null;
        syncCriteriaDetailsScopes();
        $scope.questionnaireCriteriaDetailsStatsError = true;
        destroyCriteriaDetailCharts();
      }).finally(function () {
        $scope.questionnaireCriteriaDetailsStatsLoading = false;
      });
    };

    $scope.refreshQuestionnaireProfileStats = function (forceRefresh) {
      $scope.questionnaireProfileStatsLoading = true;
      $scope.questionnaireProfileStatsError = false;
      QuestionnaireSatisfactionCampaignService.getProfileStats(!!forceRefresh).then(function (data) {
        $scope.questionnaireProfileStats = data;
        renderProfileCharts();
      }).catch(function () {
        $scope.questionnaireProfileStats = null;
        $scope.questionnaireProfileStatsError = true;
        destroyProfileCharts();
      }).finally(function () {
        $scope.questionnaireProfileStatsLoading = false;
      });
    };

    $scope.setMonEnqueteSubTab = function (tab) {
      $scope.monEnqueteSubTabActive = tab;
      if (tab === $scope.monEnqueteSubTabs.results) {
        loadActiveMonEnqueteResultsTab(false);
      } else {
        destroySolicitationCharts();
        destroyCriteriaDetailCharts();
        destroyProfileCharts();
        if (tab === $scope.monEnqueteSubTabs.enquete && !$scope.questionnaireSolicitationStats) {
          $scope.refreshQuestionnaireSolicitationStats(false);
        }
      }
    };

    // Helpers pour l'onglet "Mes résultats > Sollicitations"
    $scope.getSolicitationChannelList = function () {
      var stats = $scope.questionnaireSolicitationStats;
      if (!stats || !stats.currentCampaign || !stats.currentCampaign.channels) {
        return [];
      }
      // Ordre métier : SMS / Email en premier (canaux directs), puis QR / Lien, puis Tablette / Papier
      var order = ['SMS', 'EMAIL', 'QR_CODE', 'RESEAUX_SOCIAUX', 'TABLETTE', 'PAPIER'];
      var byKey = {};
      stats.currentCampaign.channels.forEach(function (c) { byKey[c.channel] = c; });
      var result = [];
      order.forEach(function (k) { if (byKey[k]) { result.push(byKey[k]); } });
      // Ajouter tout canal non listé dans l'ordre (robuste aux évolutions back)
      stats.currentCampaign.channels.forEach(function (c) {
        if (order.indexOf(c.channel) === -1) { result.push(c); }
      });
      return result;
    };

    $scope.getSolicitationTotalSent = function () {
      var list = $scope.getSolicitationChannelList();
      var s = 0;
      for (var i = 0; i < list.length; i++) { s += list[i].sent || 0; }
      return s;
    };

    $scope.getSolicitationTotalCompleted = function () {
      var list = $scope.getSolicitationChannelList();
      var s = 0;
      for (var i = 0; i < list.length; i++) { s += list[i].completed || 0; }
      return s;
    };

    $scope.getSolicitationTotalPartial = function () {
      var list = $scope.getSolicitationChannelList();
      var s = 0;
      for (var i = 0; i < list.length; i++) { s += list[i].partial || 0; }
      return s;
    };

    $scope.getSolicitationCompletionRate = function () {
      var sent = $scope.getSolicitationTotalSent();
      if (!sent) { return null; }
      return Math.round(($scope.getSolicitationTotalCompleted() / sent) * 100);
    };

    $scope.getSolicitationChannelRate = function (channel) {
      if (!channel || !channel.sent) { return null; }
      return Math.round((channel.completed / channel.sent) * 100);
    };

    $scope.getSolicitationChannelIconKind = function (channelKey) {
      switch (channelKey) {
        case 'SMS': return 'sms';
        case 'EMAIL': return 'email';
        case 'QR_CODE': return 'qr';
        case 'RESEAUX_SOCIAUX': return 'share';
        case 'TABLETTE': return 'tablet';
        case 'PAPIER': return 'paper';
        default: return 'other';
      }
    };

    // Helpers pour afficher les compteurs de réponses par canal dans l'onglet "Enquête"
    $scope.getEnqueteChannelStats = function (channelKey) {
      var stats = $scope.questionnaireSolicitationStats;
      if (!stats || !stats.currentCampaign || !stats.currentCampaign.channels) {
        return null;
      }
      for (var i = 0; i < stats.currentCampaign.channels.length; i++) {
        if (stats.currentCampaign.channels[i].channel === channelKey) {
          return stats.currentCampaign.channels[i];
        }
      }
      return null;
    };

    $scope.getEnqueteTotalCompleted = function () {
      var stats = $scope.questionnaireSolicitationStats;
      if (!stats || !stats.currentCampaign || !stats.currentCampaign.channels) {
        return null;
      }
      var total = 0;
      for (var i = 0; i < stats.currentCampaign.channels.length; i++) {
        total += stats.currentCampaign.channels[i].completed || 0;
      }
      return total;
    };

    $scope.setMonEnqueteResultsTab = function (tab) {
      if ($scope.monEnqueteResultsTabActive === tab) {
        return;
      }
      $scope.monEnqueteResultsTabActive = tab;
      if ($scope.monEnqueteSubTabActive !== $scope.monEnqueteSubTabs.results) {
        return;
      }
      loadActiveMonEnqueteResultsTab(false);
    };


    $scope.selectHistoricalSolicitationYear = function (year) {
      if ($scope.selectedHistoricalSolicitationYear === year) {
        return;
      }
      $scope.selectedHistoricalSolicitationYear = year;
      renderSolicitationCharts();
    };

    $scope.getHistoricalSolicitationCampaigns = function () {
      return getHistoricalSolicitationCampaigns();
    };

    $scope.getCriteriaDetailsScopes = function () {
      return $scope.criteriaDetailsScopes;
    };

    $scope.formatCriteriaAverage = function (value) {
      if (!angular.isNumber(value)) {
        return '-';
      }
      return value.toFixed(1).replace('.', ',');
    };

    $scope.formatProfilePercentage = function (value) {
      if (!angular.isNumber(value)) {
        return '0,0 %';
      }
      return value.toFixed(1).replace('.', ',') + ' %';
    };

    $scope.downloadToolboxTool = function (tool) {
      if (!tool || !tool.id) {
        return;
      }
      var url = QuestionnaireSatisfactionToolboxService.getDownloadUrl(tool.id);
      // Lien externe → nouvel onglet (préserve la page courante de l'utilisateur).
      if (tool.externalUrl) {
        $window.open(url, '_blank', 'noopener,noreferrer');
        return;
      }
      $window.location.href = url;
    };

    // Helpers pour afficher joliment les outils dans la Boîte à outils
    $scope.getToolboxToolExtension = function (tool) {
      if (!tool || !tool.originalFileName) {
        return '';
      }
      var parts = tool.originalFileName.split('.');
      if (parts.length < 2) {
        return '';
      }
      return parts[parts.length - 1].toLowerCase();
    };

    $scope.getToolboxToolTypeLabel = function (tool) {
      var ext = $scope.getToolboxToolExtension(tool);
      switch (ext) {
        case 'pdf': return 'Document PDF';
        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'csv': return 'Tableur Excel';
        case 'doc':
        case 'docx': return 'Document Word';
        case 'ppt':
        case 'pptx': return 'Présentation PowerPoint';
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'svg': return 'Image';
        case 'mp4':
        case 'webm':
        case 'mov':
        case 'm4v':
        case 'avi':
        case 'mkv': return 'Vidéo';
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'm4a': return 'Audio';
        case 'zip':
        case 'rar':
        case '7z': return 'Archive';
        case '': return 'Fichier';
        default: return ext.toUpperCase() + ' — Fichier';
      }
    };

    $scope.getToolboxToolIconKind = function (tool) {
      var ext = $scope.getToolboxToolExtension(tool);
      if (ext === 'pdf') return 'pdf';
      if (['xls', 'xlsx', 'xlsm', 'csv'].indexOf(ext) !== -1) return 'excel';
      if (['doc', 'docx'].indexOf(ext) !== -1) return 'word';
      if (['ppt', 'pptx'].indexOf(ext) !== -1) return 'ppt';
      if (['png', 'jpg', 'jpeg', 'gif', 'svg'].indexOf(ext) !== -1) return 'image';
      if (['mp4', 'webm', 'mov', 'm4v', 'avi', 'mkv'].indexOf(ext) !== -1) return 'video';
      if (['mp3', 'wav', 'ogg', 'm4a'].indexOf(ext) !== -1) return 'audio';
      if (['zip', 'rar', '7z'].indexOf(ext) !== -1) return 'archive';
      return 'file';
    };

    $scope.sendQuestionnaireBySms = function () {
      QuestionnaireSatisfactionCampaignService.sendBySms($scope.smsData.mobile).then(function () {
        toastr.success('Message SMS envoyé');
        $scope.smsData.mobile = '';
        $scope.refreshQuestionnaireSolicitationStats(true);
      }).catch(function (response) {
        if (response && response.status === 400) {
          var msg = response.data && (response.data.message || response.data);
          toastr.error(typeof msg === 'string' && msg.length > 0 ? msg : 'Numéro de mobile invalide');
          return;
        }
        toastr.error('L\'envoi a échoué, veuillez réessayer.');
      });
    };

    $scope.sendQuestionnaireByEmail = function () {
      if ($scope.emailSending) {
        return;
      }
      $scope.emailSending = true;
      QuestionnaireSatisfactionCampaignService.sendByEmail($scope.emailData.email).then(function () {
        toastr.success('Email envoyé');
        $scope.emailData.email = '';
        $scope.refreshQuestionnaireSolicitationStats(true);
      }).catch(function (response) {
        var errorMessage = null;
        if (response && response.data) {
          if (angular.isString(response.data)) {
            try {
              errorMessage = JSON.parse(response.data).message || response.data;
            } catch (e) {
              errorMessage = response.data;
            }
          } else if (response.data.message) {
            errorMessage = response.data.message;
          }
        }
        if (response && response.status === 400) {
          toastr.error(errorMessage || 'Adresse email invalide');
          return;
        }
        toastr.error('L\'envoi a échoué, veuillez réessayer.');
      }).finally(function () {
        $scope.emailSending = false;
      });
    };

    $scope.openPaperQuestionnaire = function () {
      openPublicQuestionnaire('PAPIER');
    };

    $scope.copyTabletQuestionnaireLink = function () {
      copyQuestionnaireLink('TABLETTE', 'Le lien du questionnaire pour la tablette a été copié dans votre presse-papier.');
    };

    $scope.copySocialLink = function () {
      copyQuestionnaireLink('RESEAUX_SOCIAUX', 'Le lien du questionnaire pour les réseaux sociaux a été copié dans votre presse-papier');
    };

    $scope.downloadQrCodePdf = function () {
      if (!$scope.questionnaireCampaignContext || !$scope.questionnaireCampaignContext.questionnaireIdentifier) {
        toastr.error('QR code indisponible');
        return;
      }
      $window.location.href = QuestionnaireSatisfactionCampaignService.getQrCodeDownloadUrl();
    };

    $scope.downloadQrCodePng = function () {
      if (!$scope.questionnaireCampaignContext || !$scope.questionnaireCampaignContext.questionnaireIdentifier) {
        toastr.error('QR code indisponible');
        return;
      }
      QuestionnaireSatisfactionCampaignService.downloadQrCodePng().then(function (response) {
        downloadArrayBufferFile(response, 'questionnaire-satisfaction-qr-code.png', 'image/png');
      }).catch(function () {
        toastr.error('QR code indisponible');
      });
    };

    $scope.downloadQuestionnaire1Page = function () {
      $window.open('/assets/documents/PHSQ_JQ2026_Questionnaire_Patients_1page.pdf', '_blank');
    };

    $scope.downloadQuestionnaire2Pages = function () {
      $window.open('/assets/documents/PHSQ_JQ2026_Questionnaire_Patients_2pages.pdf', '_blank');
    };

    $scope.openResultsPosterPopup = function () {
      if ($scope.resultsPosterLoading) {
        return;
      }
      if (!$scope.questionnaireCampaignContext || !$scope.questionnaireCampaignContext.campaignClosed) {
        toastr.error('La campagne doit être clôturée pour générer l\'affiche.');
        return;
      }

      $scope.resultsPosterLoading = true;
      QuestionnaireSatisfactionCampaignService.getResultsPosterContext().then(function (context) {
        var keywords = angular.isArray(context && context.keywords) ? context.keywords.slice(0, 3) : [];
        while (keywords.length < 3) {
          keywords.push('');
        }
        $scope.resultsPosterPopupData = {
          noteOnFiveLabel: context && context.noteOnFiveLabel ? context.noteOnFiveLabel : '0,0',
          generationMessage: context && context.generationMessage
            ? context.generationMessage
            : 'Le document sera généré avec une note de 0,0/5.',
          keywords: keywords,
          verbatimWords: angular.isArray(context && context.verbatimWords) ? context.verbatimWords.slice(0, 25) : [],
          verbatimDetailsOpen: false
        };

        $mdDialog.show({
          templateUrl: 'app/main/front/performances/mes-evaluations/popup/generate-results-poster-popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        });
      }).catch(function (response) {
        var message = response && response.data && response.data.message ? response.data.message : null;
        toastr.error(message || 'Impossible de préparer l\'affiche de résultats.');
      }).finally(function () {
        $scope.resultsPosterLoading = false;
      });
    };

    $scope.generateResultsPosterPdf = function () {
      if ($scope.resultsPosterGenerating || !$scope.resultsPosterPopupData) {
        return;
      }

      $scope.resultsPosterGenerating = true;
      var keywords = angular.isArray($scope.resultsPosterPopupData.keywords)
        ? $scope.resultsPosterPopupData.keywords.slice(0, 3)
        : ['', '', ''];
      while (keywords.length < 3) {
        keywords.push('');
      }

      QuestionnaireSatisfactionCampaignService.generateResultsPosterPdf(keywords).then(function (response) {
        downloadArrayBufferFile(response, 'affiche-resultats-enquete-satisfaction.pdf', 'application/pdf');
        toastr.success('Affiche de résultats générée');
        $scope.refreshQuestionnaireCampaignContext(true);
        $mdDialog.hide();
      }).catch(function (response) {
        var message = decodeArrayBufferErrorMessage(response)
          || (response && response.data && response.data.message ? response.data.message : null);
        toastr.error(message || 'La génération de l\'affiche a échoué.');
      }).finally(function () {
        $scope.resultsPosterGenerating = false;
      });
    };

    $scope.downloadClosedCampaignReportPdf = function () {
      var reportId = $scope.questionnaireCampaignContext && $scope.questionnaireCampaignContext.closedCampaignReportId;
      if (!reportId) {
        toastr.error('Synthèse indisponible');
        return;
      }
      $window.location.href = SatisfactionService.getDownloadLink(reportId);
    };

    $scope.downloadClosedCampaignResultsPosterPdf = function () {
      $window.location.href = QuestionnaireSatisfactionCampaignService.getResultsPosterDownloadUrl();
    };

    $scope.downloadVerbatimXlsx = function () {
      $window.location.href = QuestionnaireSatisfactionCampaignService.getVerbatimExportUrl(
        $scope.questionnaireVerbatimPagination.searchText
      );
    };

    $scope.getQuestionnaireVerbatimPageNumbers = function () {
      return buildQuestionnaireVerbatimPageNumbers();
    };

    $scope.onQuestionnaireVerbatimPageChange = function (newPageNumber, oldPageNumber) {
      if ($scope.monEnqueteResultsTabActive !== $scope.monEnqueteResultsTabs.verbatims) {
        return;
      }
      var targetPage = Number(newPageNumber);
      if (angular.isNumber(oldPageNumber) && Number(newPageNumber) === Number(oldPageNumber)) {
        return;
      }
      if (!isFinite(targetPage) || targetPage <= 0) {
        return;
      }
      var content = $window.document.getElementById('content');
      $scope.refreshQuestionnaireVerbatimStats(false, targetPage, content ? Number(content.scrollTop) || 0 : null);
    };

    $scope.onQuestionnaireVerbatimSearchChange = function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
      }
      verbatimSearchDebouncePromise = $timeout(function () {
        verbatimSearchDebouncePromise = null;
        $scope.refreshQuestionnaireVerbatimStats(false, 1);
      }, 300);
    };

    $scope.clearQuestionnaireVerbatimSearch = function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      if (!$scope.questionnaireVerbatimPagination.searchText) {
        return;
      }
      $scope.questionnaireVerbatimPagination.searchText = '';
      $scope.refreshQuestionnaireVerbatimStats(false, 1);
    };

    $scope.refreshQuestionnaireCampaignContext();
    $scope.refreshToolboxTools();
    loadActiveMonEnqueteResultsTab(false);

    function initDocument() {
      $scope.document = {};
    }

    initDocument();

    $scope.refresh = function () {
      SatisfactionService.find().then(function (response) {
        $scope.satisfactions = response.data;
      }).catch(function (response) {

      });
      AutoEvaluationService.find().then(function (response) {
        $scope.autos = response.data;
      }).catch(function (response) {

      });
      AutoControlesService.getAutoCtrl().then(function (data) {
        $scope.flashs = data;
      }).catch(function (err) {
        console.log("Error getAutoCtrl()");
      });

      AuditService.getAudits().then(function (data) {
        $scope.audits = data;
        $scope.dataArray = Object.keys($scope.audits)
          .map(function (key) {
            return $scope.audits[key];
          });
      }).catch(function (err) {
        console.log(err);
      });
    };
    $scope.refresh();

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.openAddFile = function () {
      $scope.editionMode = false;
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/mes-evaluations/popup/add-satisfaction-client-popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initDocument();
      }).catch(function () {
        initDocument();
      });
    };

    $scope.openDeleteDocument = function (folder, tab) {
      $scope.folderToDelete = angular.copy(folder);
      var templateUrl = null
      if (tab === $scope.tabs.auto) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/delete-auto-evaluation-popup.html'
      } else if (tab === $scope.tabs.client) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/delete-satisfaction-client-popup.html'
      } else if (tab === $scope.tabs.audit) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/delete_audit.html'
      }
      if (templateUrl != null) {
        $scope.deleteFolderPopup = $mdDialog.show({
          templateUrl: templateUrl,
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          $scope.folderToDelete = {};
        }).catch(function () {
          $scope.folderToDelete = {};
        });
      }
    };

    $scope.deleteFolder = function (tab) {
      if ($scope.tabs.auto === tab) {
        AutoEvaluationService.remove($scope.folderToDelete.id).then(function (response) {
          $scope.refresh();
          $scope.hidePopup();
        }).catch(function (response) {
          if (response.status === 404) {
            toastr.error('Auto-évaluation introuvable, veuillez actualiser la page');
          }
        });
      } else if ($scope.tabs.client === tab) {
        SatisfactionService.remove($scope.folderToDelete.id).then(function (response) {
          $scope.refresh();
          $scope.hidePopup();
        }).catch(function (response) {
          if (response.status === 404) {
            toastr.error('Satisfaction client introuvable, veuillez actualiser la page');
          }
        });
      } else if ($scope.tabs.audit === tab) {
        var dto = {
          id: $scope.folderToDelete.id,
          deleted: true
        };

        AuditService.deleteAudit(dto).then(function (res) {
          $scope.refresh()
          $scope.hidePopup();
        }).catch(function (err) {

        });
      } else if ($scope.tabs.flash === tab) {

      }
    };

    $scope.download = function (doc, tab) {
      if ($scope.tabs.auto === tab) {
        $window.location.href = AutoEvaluationService.getDownloadLink(doc.id);
      } else if ($scope.tabs.client === tab) {
        $window.location.href = SatisfactionService.getDownloadLink(doc.id);
      } else if ($scope.tabs.audit === tab) {
        $window.location.href = AuditService.getDownloadLink(doc.id);
      }
    };

    $scope.saveDocument = function (tab) {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        var input = document.getElementById('document_input_file');
        var file = null;
        if (input != null) {
          if (input.files.length == 0) {
            toastr.error('Vous devez sélectionnner un fichier');
            $scope.intoSaving = false;
            return;
          }
          file = input.files[0];
        }
        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.document));
        if ($scope.tabs.audit === tab) {
          AuditService.save(fd).then(function (data) {
            $scope.refresh()
            $scope.hidePopup();
            $scope.tabActive = tab
            $timeout(function () {
              $scope.intoSaving = false;
            });
          }).catch(function (response) {
            console.log(response);
            console.log("Error saveDocument()");
            $scope.intoSaving = false;
          });
        } else if ($scope.tabs.client === tab) {
          SatisfactionService.save(fd).then(function (response) {
            $scope.refresh();
            $scope.hidePopup();
            $scope.tabActive = tab
            $timeout(function () {
              $scope.intoSaving = false;
            });
          }).catch(function (response) {
            $scope.intoSaving = false;
            toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
          });
        } else if ($scope.tabs.auto === tab) {
          AutoEvaluationService.save(fd).then(function (response) {
            $scope.refresh();
            $scope.hidePopup();
            $scope.tabActive = tab
            $scope.working = false;
          }).catch(function (response) {
            $scope.working = false;
            toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
          });
        }
      }
    };

    $scope.addToODJ = function (document, tab) {
      if (document.id != null) {
        if ($scope.tabs.auto === tab) {
          AutoEvaluationService.addToODJ(document.id).then(function (res) {
            toastr.success("Auto-évaluation ajoutéé à l'ordre du jour");
          }).catch(function (err) {
            console.log(err);
            toastr.error("Problème lors de l'ajout à l'ordre du jour");
          })
        } else if ($scope.tabs.client === tab) {
          SatisfactionService.addToODJ(document.id).then(function (res) {
            toastr.success("Satisfaction client ajoutée à l'ordre du jour");
          }).catch(function (err) {
            console.log(err);
            toastr.error("Problème lors de l'ajout à l'ordre du jour");
          })
        } else if ($scope.tabs.audit === tab) {
          AuditService.addToODJ(document.id).then(function (res) {
            toastr.success("Audit ajouté à l'ordre du jour");
          }).catch(function (err) {
            console.log(err);
            toastr.error("Problème lors de l'ajout à l'ordre du jour");
          })
        } else if ($scope.tabs.flash === tab) {

        }

      } else {
        toastr.error("Problème lors de l'ajout à l'ordre du jour");
      }
    }

    $scope.display = function (satisfaction, tab) {
      $scope.satisfactionClientToDisplay = satisfaction;
      var templateUrl = null
      if (tab === $scope.tabs.auto) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/display-auto-evaluation-popup.html'
      } else if (tab === $scope.tabs.client) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/display-satisfaction-client-popup.html'
      } else if (tab === $scope.tabs.audit) {
        templateUrl = 'app/main/front/performances/mes-evaluations/popup/display_audit.html'
      }
      if (templateUrl == null) {
        $state.go('app.performances.mes-evaluations.flashs', { autoCtrlID: satisfaction.id, titleAutoCtrl: satisfaction.name });
      } else {
        $scope.satisfactionPopUp = $mdDialog.show({
          templateUrl: templateUrl,
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          $scope.satisfactionClientToDisplay = {};
        }).catch(function () {
          $scope.satisfactionClientToDisplay = {};
        });
      }
    }

    $scope.displayPopUpPlanTask = function () {
      $scope._task = {};
      $scope.fromAudit = true;
      $scope._categories = GENERAL_TASK_TYPES;
      $scope._recurrences = GENERAL_TASK_PERIOD;
      $scope.reminders = TASKS_EVENTS_REMINDERS;
      EquipeDetailService.getCollaborateurs().then(function (data) {
        $scope._users = data;
      }).catch(function (error) {
        console.log(error);
      });
      for (var j = 0; j < $scope._categories.length; j++) {
        if ($scope._categories[j].value === 'AUDITS_ET_ECARTS') {
          $scope._task.category = $scope._categories[j].value;
        }
      }

      showTaskModal();
    }

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "AUDIT",
          datasource: {
            task: $scope._task,
          },
        },
        controller: "DialogController"
      }).then(function () {
        // nothing
      }).catch(function () {

      });
    }

    $scope.setRestricted = function (audit, tab) {
      if ($scope.tabs.audit === tab) {
        AuditService.setConfidential(audit.id, !audit.confidential).then(function () {
          $scope.refresh()
        }).catch(function () {

        });
      }
    }

    $scope.setActive = function (tab) {
      if (isNonLqoUser && ongletsNonLqo.indexOf(tab) < 0) {
        return;
      }
      $scope.tabActive = tab
      if (tab === $scope.tabs.monEnquete) {
        $state.go($state.current.name, { tab: $scope.tabs.monEnquete }, { notify: false, location: 'replace' });
        if ($scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.results
            || $scope.monEnqueteSubTabActive === $scope.monEnqueteSubTabs.enquete) {
          $scope.refreshQuestionnaireSolicitationStats(false);
        }
      } else {
        destroySolicitationCharts();
        // Sans onglet dans l'adresse, une officine sans LQO retomberait sur « Mon enquête ».
        var onglet = isNonLqoUser && tab === $scope.tabs.auto ? $scope.tabs.auto : null;
        $state.go($state.current.name, { tab: onglet }, { notify: false, location: 'replace' });
      }
    }

    $scope.$on('fileUploaded', function () {
      var fileinput = document.getElementById("document_input_file");
      $scope.document.nameOfDocument = "";
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        $scope.document.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.clearInputFile = function (input, id_input) {
      var elem = document.getElementById(id_input);
      if (elem) {
        elem.value = "";
      }
      input.nameOfDocument = ""
      input.attachmentOriginalName = null
    };

    $scope.$on('$destroy', function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      destroySolicitationCharts();
    });

    $scope.$on('refreshQuestionnaireCampaignContext', function () {
      QuestionnaireSatisfactionCampaignService.clearCache();
      $scope.refreshQuestionnaireCampaignContext();
      if (hasSolicitationResultsTabSelected()) {
        $scope.refreshQuestionnaireSolicitationStats(true);
      }
    });

  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .service('QuestionnaireSatisfactionToolboxService', QuestionnaireSatisfactionToolboxService);

  function QuestionnaireSatisfactionToolboxService($q, $http) {
    var TOOLBOX_BASE_URL = '/api/rest/toolbox';

    function withVersion(params) {
      var nextParams = angular.extend({}, params || {});
      nextParams._v = new Date().getTime();
      return nextParams;
    }

    function getTools() {
      return $q(function (resolve, reject) {
        $http({
          method: 'GET',
          url: TOOLBOX_BASE_URL,
          params: withVersion()
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function getDownloadUrl(id) {
      return TOOLBOX_BASE_URL + '/' + id + '/download';
    }

    return {
      getTools: getTools,
      getDownloadUrl: getDownloadUrl
    };
  }
})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Sample
            'app.front',

            'app.error-404',

            'app.admin',

            'toastr',

            'ngYoutubeEmbed',

            'ngQuill',
            "ngSanitize",
            "com.2fdevs.videogular",
            "com.2fdevs.videogular.plugins.controls",
            "com.2fdevs.videogular.plugins.overlayplay",
            "com.2fdevs.videogular.plugins.poster",
            'ngBrowser',
            'daterangepicker',
            'angularUtils.directives.dirPagination'
        ]);
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .service('QuestionnaireSatisfactionCampaignService', QuestionnaireSatisfactionCampaignService);

  function QuestionnaireSatisfactionCampaignService($q, $http, $window) {
    var URL_QUESTIONNAIRE_CAMPAIGN = '/api/rest/questionnaireSatisfaction';
    var contextCache = null;
    var solicitationStatsCache = null;
    var verbatimStatsCache = {};
    var criteriaDetailsStatsCache = null;
    var profileStatsCache = null;

    var normalizeSource = function (source) {
      if (!source) {
        return 'DIRECT';
      }
      return source.toString().trim().toUpperCase();
    };

    var normalizeVerbatimSearchText = function (searchText) {
      return (searchText || '').toString().trim();
    };

    var buildVerbatimStatsCacheKey = function (page, nbrResults, searchText) {
      var targetPage = angular.isNumber(page) && page > 0 ? page : 1;
      var targetNbrResults = angular.isNumber(nbrResults) && nbrResults > 0 ? nbrResults : 10;
      return [targetPage, targetNbrResults, normalizeVerbatimSearchText(searchText).toLowerCase()].join('|');
    };

    var getContext = function (forceRefresh) {
      return $q(function (resolve, reject) {
        if (!forceRefresh && contextCache) {
          resolve(contextCache);
          return;
        }
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/context',
          method: 'GET',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          contextCache = response.data;
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getSolicitationStats = function (forceRefresh) {
      return $q(function (resolve, reject) {
        if (!forceRefresh && solicitationStatsCache) {
          resolve(solicitationStatsCache);
          return;
        }
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/solicitations',
          method: 'GET',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          solicitationStatsCache = response.data;
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getVerbatimStats = function (forceRefresh, page, nbrResults, searchText) {
      return $q(function (resolve, reject) {
        var targetPage = angular.isNumber(page) && page > 0 ? page : 1;
        var targetNbrResults = angular.isNumber(nbrResults) && nbrResults > 0 ? nbrResults : 10;
        var normalizedSearchText = normalizeVerbatimSearchText(searchText);
        var cacheKey = buildVerbatimStatsCacheKey(targetPage, targetNbrResults, normalizedSearchText);

        if (!forceRefresh && verbatimStatsCache[cacheKey]) {
          resolve(verbatimStatsCache[cacheKey]);
          return;
        }
        var params = {
          '_v': new Date().getTime(),
          page: targetPage,
          nbrResults: targetNbrResults
        };
        if (normalizedSearchText) {
          params.searchText = normalizedSearchText;
        }
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/verbatims',
          method: 'GET',
          params: params,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          verbatimStatsCache[cacheKey] = response.data;
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getCriteriaDetailsStats = function (forceRefresh) {
      return $q(function (resolve, reject) {
        if (!forceRefresh && criteriaDetailsStatsCache) {
          resolve(criteriaDetailsStatsCache);
          return;
        }
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/detail-criteres',
          method: 'GET',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          criteriaDetailsStatsCache = response.data;
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getProfileStats = function (forceRefresh) {
      return $q(function (resolve, reject) {
        if (!forceRefresh && profileStatsCache) {
          resolve(profileStatsCache);
          return;
        }
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/profils',
          method: 'GET',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          profileStatsCache = response.data;
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var sendByEmail = function (email) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/send/email',
          method: 'POST',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' },
          data: { email: email }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var sendBySms = function (mobile) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/send/sms',
          method: 'POST',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' },
          data: { mobile: mobile }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var buildPublicLink = function (questionnaireIdentifier, source, absolute) {
      if (!questionnaireIdentifier) {
        return '';
      }
      var normalizedSource = normalizeSource(source);
      var relativeLink = '/q/' + encodeURIComponent(questionnaireIdentifier) + '?source=' + encodeURIComponent(normalizedSource);
      if (!absolute) {
        return relativeLink;
      }
      return $window.location.origin + relativeLink;
    };

    var getQrCodeDownloadUrl = function () {
      return URL_QUESTIONNAIRE_CAMPAIGN + '/download/qr-code?_v=' + new Date().getTime();
    };

    var getQrCodePngDownloadUrl = function () {
      return URL_QUESTIONNAIRE_CAMPAIGN + '/download/qr-code/png?_v=' + new Date().getTime();
    };

    var downloadQrCodePng = function () {
      return $q(function (resolve, reject) {
        $http({
          url: getQrCodePngDownloadUrl(),
          method: 'GET',
          responseType: 'arraybuffer'
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getVerbatimExportUrl = function (searchText) {
      var url = URL_QUESTIONNAIRE_CAMPAIGN + '/results/verbatims/export?_v=' + new Date().getTime();
      var normalizedSearchText = normalizeVerbatimSearchText(searchText);
      if (normalizedSearchText) {
        url += '&searchText=' + encodeURIComponent(normalizedSearchText);
      }
      return url;
    };

    var getResultsPosterContext = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/affiche/context',
          method: 'GET',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var generateResultsPosterPdf = function (keywords) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_QUESTIONNAIRE_CAMPAIGN + '/results/affiche/download',
          method: 'POST',
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' },
          responseType: 'arraybuffer',
          data: { keywords: keywords || [] }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getResultsPosterDownloadUrl = function () {
      return URL_QUESTIONNAIRE_CAMPAIGN + '/results/affiche/download?_v=' + new Date().getTime();
    };

    var clearCache = function () {
      contextCache = null;
      solicitationStatsCache = null;
      verbatimStatsCache = {};
      criteriaDetailsStatsCache = null;
      profileStatsCache = null;
    };

    return {
      getContext: getContext,
      getSolicitationStats: getSolicitationStats,
      getVerbatimStats: getVerbatimStats,
      getCriteriaDetailsStats: getCriteriaDetailsStats,
      getProfileStats: getProfileStats,
      sendByEmail: sendByEmail,
      sendBySms: sendBySms,
      buildPublicLink: buildPublicLink,
      getQrCodeDownloadUrl: getQrCodeDownloadUrl,
      getQrCodePngDownloadUrl: getQrCodePngDownloadUrl,
      downloadQrCodePng: downloadQrCodePng,
      getVerbatimExportUrl: getVerbatimExportUrl,
      getResultsPosterContext: getResultsPosterContext,
      generateResultsPosterPdf: generateResultsPosterPdf,
      getResultsPosterDownloadUrl: getResultsPosterDownloadUrl,
      clearCache: clearCache
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('FlashsController', FlashsController);

  function FlashsController($scope, toastr, TachesGeneralesService, $state, AutoControlesService, $mdDialog, GENERAL_TASK_TYPES,
    TASKS_EVENTS_REMINDERS, GENERAL_TASK_PERIOD, EquipeDetailService, $stateParams, $timeout) {
    $scope.flashs = [];
    $scope.titleAutoCtrl = null;
    var paramsAutoCtrl = {};

    //TASK
    $scope._categories = GENERAL_TASK_TYPES;
    $scope._recurrences = GENERAL_TASK_PERIOD;
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope.fromAuto = ($state.current.name.lastIndexOf('app.performances.mes-evaluations') > -1);
    $scope.addCollaborateurMode = false;
    $scope.intoSaving = false;

    if ($stateParams.autoCtrlID != null) {
      $scope.titleAutoCtrl = $stateParams.titleAutoCtrl;
      paramsAutoCtrl = {
        titleAutoCtrl: $stateParams.titleAutoCtrl,
        autoCtrlID: $stateParams.autoCtrlID
      };
      AutoControlesService.getFlashs($stateParams.autoCtrlID).then(function (data) {
        $scope.flashs = data;
      }).catch(function (err) {
        console.log("Error getFlashs()");
      });
    } else {
      $state.go('app.performances.mes-evaluations');
    }

    $scope.goBack = function () {
      $state.go('app.performances.mes-evaluations');
    }

    $scope.goFlash = function (flash) {
      $state.go('app.performances.mes-evaluations.flash', {
        titleAutoCtrl: paramsAutoCtrl.titleAutoCtrl,
        autoCtrlID: paramsAutoCtrl.autoCtrlID,
        flashID: flash.id,
        titleFlash: flash.name
      })
    }

    //TASK
    $scope.onEcheanceChange = function (object) {
      object.echeance = object._echeance.valueOf();
    };

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {
      console.log(response);
    });

    $scope.planTache = function () {

      $scope._task = {};
      if ($scope.fromAuto) {
        for (var j = 0; j < $scope._categories.length; j++) {
          if ($scope._categories[j].value === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
            $scope._task.category = $scope._categories[j].value;
          }
        }
      }
      showTaskModal();
    }

    function showTaskModal(url) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: url ? url : 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "QUALITE",
          datasource: {
            task: $scope._task
          }
        },
        controller: "DialogController"
      }).then(function () {

      }).catch(function () {

      });
    }

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    // Save
    $scope._save = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;
        $scope._task.echeance = $scope.echeance.getTime();
        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }
        formData.append('dto', angular.toJson($scope._task));
        TachesGeneralesService.save(formData).then(function (response) {
          toastr.success('Sauvegardée avec succès.');
          $scope._closeDialog();
          $timeout(function () {
            $scope.intoSaving = false;
          });
        }).catch(function (error) {
          $scope.intoSaving = false;
          console.log(error);
        });
      }
    };

    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    // Genration de document

    $scope.generateDoc = function () {
      var _type = "";
      if ($scope.titleAutoCtrl == "Accueillir les patients") {
        _type = "AUTO_CONTROLE_ACCUEIL_PATIENS";
      } else if ($scope.titleAutoCtrl == "Dispensation") {
        _type = "AUTO_CONTROLE_CONSEILLER_DISPERSER_PRODUITS";
      } else if ($scope.titleAutoCtrl == "Nouvelles missions") {
        _type = "AUTO_CONTROLE_PRENDRE_EN_CHARGE_NOUVELLES_MISSIONS";
      } else if ($scope.titleAutoCtrl == "Veille pharmaceutique") {
        _type = "AUTO_CONTROLE_VEILLE_PHARMA_TECH_ET_COMMERCIAL";
      } else if ($scope.titleAutoCtrl == "Préparations") {
        _type = "AUTO_CONTROLE_EFFECTUER_OU_SOUS_TRAITER_PREPARATION";
      } else if ($scope.titleAutoCtrl == "Commandes et stocks") {
        _type = "AUTO_CONTROLE_GERER_COMMANDE_ET_STOCK";
      } else if ($scope.titleAutoCtrl == "Facturation") {
        _type = "AUTO_CONTROLE_GERER_FACTURATION";
      }

      /*DocGenerationService.generateDocument(_type).then(function (response) {
      }).catch(function (error) {
        console.log(error);
      });*/

      var printWindow = window.open("/api/rest/docgeneration/download/support?type=" + _type);
      printWindow.print();

    };

  };
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('FlashController', FlashController);

    function FlashController($scope, $state, toastr, AutoControlesService, $stateParams, $mdDialog, EquipeDetailService) {
        $scope.flash = {};
        $scope.titleFlash = null;
        var paramsGoBack = {};
        $scope.collaborateurs = [];
        $scope.trueValue = true;
        $scope.falseValue = false;
        $scope.addCollaborateurMode = false;


        if ($stateParams.flashID != null) {
            $scope.titleFlash = $stateParams.titleFlash;
            EquipeDetailService.getCollaborateurs().then(function (data) {
                $scope.collaborateurs = data;
                AutoControlesService.getFlashData($stateParams.flashID).then(function (data) {
                    $scope.flash = data;
                }).catch(function (err) {
                    console.log("Error getFlash()");
                });
            }).catch(function (err) {
                console.log("Error getCollaborateurs()");
            })
        } else {
            $state.go('app.performances.mes-evaluations');
        }

        if ($stateParams.autoCtrlID != null) {
            paramsGoBack = {
                autoCtrlID: $stateParams.autoCtrlID,
                titleAutoCtrl: $stateParams.titleAutoCtrl
            }
        }

        $scope.goBack = function () {
            $state.go('app.performances.mes-evaluations.flashs', paramsGoBack);
        }

        $scope.validate = function () {
            $scope.submitting = true;
            AutoControlesService.saveFlashData($scope.flash).then(function (res) {
                $scope.submitting = false;
                $state.go('app.performances.mes-evaluations.flashs', paramsGoBack);
            }).catch(function (err) {
                $scope.submitting = false;
                toastr.error('Erreur lors de l\'enregistrement');
                console.log("Error validate()");
            })
        }

        $scope.addCollaborateur = function () {
            if ($scope.addCollaborateurMode) {
                $scope.flash.newCollaborateur = {};
            } else {
                $scope.flash.collaborateurID = null;
            }

            $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
        }


        $scope.changeCollab = function (idSelected) {
            $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
            if (!idSelected) {
                $scope.collaborateur = {
                    name: null,
                    surname: null,
                    id: null,
                    fichePoste: {}
                };

                $scope.titlePopupSave = 'Ajouter un collaborateur';
                $scope.updateMode = false;
                $scope.descriptionMode = true;

                $scope.equipePopup = $mdDialog.show({
                    templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true,
                    controller: 'EquipeDetailController'
                }).then(function (data) {
                    $scope.flash.collaborateurID = data || $scope.idSelected;
                }).catch(function (error) {
                    $scope.flash.collaborateurID = null;
                });
                return;
            }
        };
    };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('EvaluationFournisseursDetailsController', EvaluationFournisseursDetailsController);

  function EvaluationFournisseursDetailsController($scope, $mdDialog, $state, EvaluationFournisseursService, $stateParams, toastr, STATUSES_MALFUNCTION, $rootScope, MalfunctionService, EVAL_FOURNISSEURS_STOCKS) {
    $scope.fournisseurEvaluation = {};
    $scope.oldFournisseurEvaluation = {};
    $scope.fournisseurEvaluatedName = null;
    $scope.stocksFournisseur = EVAL_FOURNISSEURS_STOCKS;
    $scope.statuses = STATUSES_MALFUNCTION;
    var today = new Date();
    $scope.yearChosen = today.getFullYear();
    $scope.currentYear = today.getFullYear();
    $scope.showEvaluation = false;
    $scope.showDocuments = false;
    $scope.documentChanged = false


    if ($stateParams.fournisseurEvaluation !== null) {
      $scope.fournisseurEvaluation = $stateParams.fournisseurEvaluation;
    } else {
      $state.go("app.performances.evaluation-fournisseurs");
    }

    if ($stateParams.fournisseurEvaluatedName !== null) {
      $scope.fournisseurEvaluatedName = $stateParams.fournisseurEvaluatedName;
    }

    $scope.changeYear = function (operator) {
      if ($scope.yearChosen + 1 <= $scope.currentYear && operator === 'plus' || operator !== 'plus') {
        $scope.yearChosen = operator === 'plus' ? $scope.yearChosen + 1 : $scope.yearChosen - 1;
        $scope.getEval();
      }
    };

    $scope.getEval = function () {
      $scope.fournisseurEvaluation = {};
      EvaluationFournisseursService.getEval($stateParams.id, $scope.yearChosen).then(function (res) {
        $scope.oldFournisseurEvaluation = angular.copy(res.data);
        $scope.fournisseurEvaluation = res.data;
      });
    };
    $scope.getEval();

    $scope.saveEvaluation = function () {
      var fmData = new FormData();
      if ($scope.fournisseurEvaluation.documents != null) {
        for (var i = 0; i < $scope.fournisseurEvaluation.documents.length; i++) {
          var doc = $scope.fournisseurEvaluation.documents[i]
          if (doc.file != null) {
            fmData.append('files', doc.file, doc.attachmentOriginalName)
            delete doc.file
          }
        }
      }
      fmData.append('dto', angular.toJson($scope.fournisseurEvaluation));
      EvaluationFournisseursService.saveEvaluation(fmData, $scope.yearChosen).then(function (res) {
        toastr.success('Evaluation enregistrée');
        $scope.goBack();
      }).catch(function (err) {
        console.log(err);
        console.log("Error saveEvaluation()");
      });
    }

    $scope.openMalfunction = function (malfunction) {
      $rootScope.malfunction = malfunction;
      if (malfunction.status === $scope.statuses.NOT_OPEN && !$rootScope.user.isTeam) {
        malfunction.status = $scope.statuses.NOT_READ;
        MalfunctionService.setOpened(malfunction.id).then(function (response) {
          $scope.refresh();
        }).catch(function (response) {

        });
      }
      $scope.malfunctionPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/apercu_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: 'ApercuController',
        locals: {
          pj: { type: 'MALFUNCTION', malfunction: malfunction },
          info: null
        }
      }).then(function () {
        $rootScope.malfunction = null;
      }).catch(function () {
        $rootScope.malfunction = null;
      });
    };

    $scope.reset = function () {
      $scope.fournisseurEvaluation = angular.copy($scope.oldFournisseurEvaluation);
    };

    $scope.goBack = function () {
      $state.go("app.performances.evaluation-fournisseurs");
    };

    $scope.showContact = function (fournisseur) {
      $scope.fournisseur = angular.copy(fournisseur);
      $mdDialog.show({
        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/contact_fournisseur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.changesAreWaiting = function () {
      return $scope.oldFournisseurEvaluation != null && (
        $scope.oldFournisseurEvaluation.stock !== $scope.fournisseurEvaluation.stock
        || $scope.oldFournisseurEvaluation.margin !== $scope.fournisseurEvaluation.margin
        || $scope.oldFournisseurEvaluation.valorizedStock !== $scope.fournisseurEvaluation.valorizedStock
        || $scope.oldFournisseurEvaluation.strategicalSupplier !== $scope.fournisseurEvaluation.strategicalSupplier
        || $scope.oldFournisseurEvaluation.mark !== $scope.fournisseurEvaluation.mark
        || $scope.oldFournisseurEvaluation.produitsmark !== $scope.fournisseurEvaluation.produitsmark
        || $scope.oldFournisseurEvaluation.organisationmark !== $scope.fournisseurEvaluation.organisationmark
        || $scope.oldFournisseurEvaluation.engagementsmark !== $scope.fournisseurEvaluation.engagementsmark
        || $scope.oldFournisseurEvaluation.evaluationCommentEngagement !== $scope.fournisseurEvaluation.evaluationCommentEngagement
        || $scope.oldFournisseurEvaluation.evaluationComment !== $scope.fournisseurEvaluation.evaluationComment
        || $scope.documentChanged);
    }

    $scope.$on('fileUploaded', function () {
      var fileinput = document.getElementById("document_input_file");
      $scope.document.nameOfDocument = "";
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        $scope.document.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.openJoindreFile = function () {
      $('#add_file').off('change')
      $('#add_file').on('change', function (evt) {
        if (evt.target.files.length > 0) {
          var reader = new FileReader();
          reader.onload = function (e) {
            if ($scope.fournisseurEvaluation.documents == null) {
              $scope.fournisseurEvaluation.documents = []
            }
            $scope.fournisseurEvaluation.documents.push({
              attachmentOriginalName: evt.target.files[0].name,
              file: new Blob([e.target.result]),
            })
            $('#add_file').val('')
            $scope.documentChanged = true
            $scope.$apply()
          };
          reader.readAsArrayBuffer(evt.target.files[0]);
        }
      })
      $('#add_file').click()
    }

    $scope.deleteDocument = function (index) {
      $scope.fournisseurEvaluation.documents.splice(index, 1)
      $scope.documentChanged = true
    }

    $scope.downloadDoc = function (id) {
      if (id != null) {
        location.href = '/api/rest/supplier/download/document/' + id + '/' + $scope.yearChosen;
      }
    }
  };


})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('EvaluationFournisseursService', EvaluationFournisseursService);

  function EvaluationFournisseursService($q, $http) {
    var URL_FOURNISSEUR = "/api/rest/supplier";

    var getFournisseurs = function (dto) {

      return $q(function (resolve, reject) {
        $http({
          url: URL_FOURNISSEUR + '/search',
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveFournisseur = function (fournisseur) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_FOURNISSEUR,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: fournisseur
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveEvaluation = function (fmData, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_FOURNISSEUR + "/evaluate",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            year: year
          },
          headers: {
            "Content-Type": undefined
          },
          data: fmData
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var deleteFournisseur = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_FOURNISSEUR + "/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getEval = function (id, year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_FOURNISSEUR + "/" + id + '/eval/' + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return {
      getFournisseurs: getFournisseurs,
      saveFournisseur: saveFournisseur,
      deleteFournisseur: deleteFournisseur,
      saveEvaluation: saveEvaluation,
      getEval: getEval
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('EvaluationFournisseursController', EvaluationFournisseursController);

  function EvaluationFournisseursController($scope, $state, EvaluationFournisseursService, $mdDialog, PERMISSIONS, EVAL_FOURNISSEURS_STOCKS, EVAL_FOURNISSEURS_TYPES, toastr) {
    $scope.fournisseurs = [];
    $scope.filterValue = '';
    $scope.triValue = '';
    $scope.updateMode = false;
    $scope.permissions = PERMISSIONS;
    $scope.titlePopupSave = "Ajouter un fournisseur";
    $scope.typesFournisseur = EVAL_FOURNISSEURS_TYPES;
    $scope.stocksFournisseur = EVAL_FOURNISSEURS_STOCKS;
    $scope.fournisseurEvaluatedName = null;
    $scope.fournisseurEvaluation = {
      stock: $scope.stocksFournisseur[0].id,
      strategicalSupplier: true,
      margin: null,
      mark: 10,
      evaluationComment: null,
      produitsmark: 10,
      organisationmark : 10,
      engagementsmark: 10,
      evaluationCommentEngagement: null,
      id: null,
      malfunctions: []
    };
    $scope.fournisseur = {
      name: null,
      type: null,
      contactName: null,
      contactPhone: null,
      comment: null,
      id: null
    };
    $scope.order = 'name';
    $scope.filter = {
      malfunctions: '! || !!',
      mark: '! || !!'
    };
    $scope.true = true;

    $scope.loading = true;

    $scope.filter = {
      criteria: {
        laboratory: false,
        serviceProvider: false,
        recentlyEvaluated: false,
        notEvaluatedSinceOneYear: false,
        withMalfunctions: false,
        withoutMalfunction: false,
        withEvaluationEcor: false
      },
      order: {
        name: true,
        evalDate: false
      }
    };

    $scope.findTypeById = function (id) {
      for (var i = 0; i < EVAL_FOURNISSEURS_TYPES.length; i++) {
        if (EVAL_FOURNISSEURS_TYPES[i].id === id) {
          return EVAL_FOURNISSEURS_TYPES[i].name;
        }
      }
    };

    $scope.search = function () {
      EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (data) {
        $scope.fournisseurs = data;
        $scope.loading = false;
      }).catch(function (response) {
        console.log("Error getFournisseurs()");
        $scope.loading = false;
      });
    };

    $scope.search();

    $scope.checkMalfunctions = function (mal) {
      if ($scope.filter.malfunctions == '! || !!') {
        return mal;
      } else if ($scope.filter.malfunctions) {
        return mal.hasOwnProperty("malfunctions");
      } else {
        return !mal.hasOwnProperty("malfunctions");
      }
    }

    $scope.saveFournisseur = function () {
      $scope.submitting = true;
      if ($scope.fournisseur.id == null) {
        $scope.new = true;
      } else {
        $scope.new = false;
      }
      EvaluationFournisseursService.saveFournisseur($scope.fournisseur).then(function (data) {
        $scope.hidePopup();
        $scope.search();
        if ($scope.updateMode) {
          toastr.success('Modifications enregistrées');
          $scope.updateMode = false;
        } else {
          toastr.success('Fournisseur enregistré');
        }
        $scope.updateMode = false;
        $scope.submitting = false;
      }).catch(function (response) {
        $scope.submitting = false;
        if (response.status == 409) {
          toastr.error('Un fournisseur avec le même nom a déjà été renseigné');
        } else {
          toastr.error('Une erreur s\'est produite! Impossible de sauvegarder le fournisseur');
        }
      });
    };

    $scope.changeOrder = function (order) {
      $scope.order = order;
    };

    $scope.changeFilter = function (section, value) {
      if ($scope.filter[section] == value) {
        $scope.filter[section] = '! || !!';
      } else {
        $scope.filter[section] = value;
      }
    }

    $scope.filterIndex = function (index) {
      $scope.filterValue = index;
    }

    $scope.triIndex = function (index) {
      $scope.triValue = index;
    }

    $scope.initFilter = function () {
      $scope.filter.criteria = {
        laboratory: false,
        serviceProvider: false,
        recentlyEvaluated: false,
        notEvaluatedSinceOneYear: false,
        withMalfunctions: false,
        withoutMalfunction: false,
        withEvaluationEcor: false
      };
    };

    $scope.initOrder = function () {
      $scope.filter.order = {
        name: false,
        evalDate: false
      }
    };

    $scope.deleteFournisseur = function (id) {
      EvaluationFournisseursService.deleteFournisseur(id).then(function () {
        for (var i = 0; i < $scope.fournisseurs.length; i++) {
          if ($scope.fournisseurs[i].id == id) {
            $scope.fournisseurs.splice(i, 1);
          }
        }
        toastr.success('Fournisseur supprimé');
      }).catch(function (response) {
        console.log("Error deleteFournisseur()");
      });
    }

    $scope.dialogDelete = function (id) {
      $scope.fournisseurPopup = $mdDialog.confirm({
        title: "Confirmation de suppression",
        textContent: "Voulez-vous vraiment supprimer ce fournisseur?",
        ok: "Oui",
        cancel: "Annuler"
      });

      $mdDialog.show($scope.fournisseurPopup).then(function () {
        $scope.deleteFournisseur(id);
      }).catch(function () { });
    }

    $scope.dialogEvaluate = function (fournisseur) {
      $state.go("app.performances.evaluation-fournisseurs.details", { id: fournisseur.id });
    };

    // $scope.saveEvaluation = function () {
    //   EvaluationFournisseursService.saveEvaluation($scope.fournisseurEvaluation).then(function (res) {
    //     for (var i = 0; i < $scope.fournisseurs.length; i++) {
    //       if ($scope.fournisseurs[i].id == $scope.fournisseurEvaluation.id) {
    //         $scope.fournisseurs[i].stock = $scope.fournisseurEvaluation.stock;
    //         $scope.fournisseurs[i].strategicalSupplier = $scope.fournisseurEvaluation.strategicalSupplier;
    //         $scope.fournisseurs[i].margin = $scope.fournisseurEvaluation.margin;
    //         $scope.fournisseurs[i].mark = $scope.fournisseurEvaluation.mark;
    //         $scope.fournisseurs[i].evaluationComment = $scope.fournisseurEvaluation.evaluationComment;
    //         break;
    //       }
    //     };
    //     $scope.hidePopup();
    //   }).catch(function (err) {
    //     console.log(err);
    //     console.log("Error saveEvaluation()");
    //   });
    // }

    $scope.dialogSave = function (updateMode, fournisseur) {
      if (updateMode) {
        $scope.updateMode = true;
        $scope.fournisseur = angular.copy(fournisseur);
        $scope.titlePopupSave = "Modifier un fournisseur";
      } else {
        $scope.fournisseur = {
          name: null,
          type: null,
          contactName: null,
          contactPhone: null,
          comment: null
        };
        $scope.titlePopupSave = "Ajouter un fournisseur";
      }

      $scope.fournisseurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/add_fournisseur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.printFilterValue = function () {
      if ($scope.filter.criteria.laboratory) {
        return 'Laboratoires';
      } else if ($scope.filter.criteria.serviceProvider) {
        return 'Prestataires de services';
      } else if ($scope.filter.criteria.recentlyEvaluated) {
        return 'Évalués récemment';
      } else if ($scope.filter.criteria.notEvaluatedSinceOneYear) {
        return 'Non évalués depuis 1 an';
      } else if ($scope.filter.criteria.withMalfunctions) {
        return 'Avec dysfonctionnements';
      } else if ($scope.filter.criteria.withoutMalfunction) {
        return 'Sans dysfonctionnement';
      } else if ($scope.filter.criteria.withEvaluationEcor){
        return 'Avec évaluation 🌿 ECOR';
      }
      return null;
    };

    $scope.printOrderValue = function () {
      if ($scope.filter.order.name) {
        return 'Nom';
      } else if ($scope.filter.order.evalDate) {
        return 'Date d\'évaluation';
      }
      return null;
    };

    $scope.showContact = function (fournisseur) {
      $scope.fournisseur = angular.copy(fournisseur);
      $mdDialog.show({
        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/contact_fournisseur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.openInfosEvalPopup = function () {
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/infos_eval_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

  };
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineSortieQualiteController', OfficineSortieQualiteController);

	/**
	 * Sous-page « Sortie de la démarche qualité » (`app.officine.sortieQualite`, spécification
	 * sortie-qualite § 5 et § 8.1).
	 *
	 * Le FORMULAIRE remplace le formulaire Brevo « Demande de sortie de la certification ISO 9001
	 * QMS PHARMA® » : raisons (au moins une), recommandation 0-10 (facultative), les trois
	 * engagements, la date effective souhaitée (aujourd'hui ou plus tard), les commentaires, puis la
	 * validation finale. Identité, CIP et groupement viennent du compte : jamais saisis.
	 *
	 * Il s'affiche quand rien n'est en cours, après une demande annulée, ou à la demande après une
	 * demande close (refusée ou traitée). Sinon la page montre le SUIVI, le même que « Mes demandes ».
	 *
	 * Après l'envoi : « Mes demandes », avec le message de confirmation de la spécification. Un 409
	 * (une demande est déjà ouverte, SQ6) ramène à l'accueil avec le message du CRM, tel quel.
	 */
	/** @ngInject */
	function OfficineSortieQualiteController($scope, $q, $rootScope, $state, $stateParams, OfficineEcran,
		OfficineService, toastr) {

		/** Spécification § 5.2, mot pour mot. */
		var CONFIRMATION = "Votre demande de sortie a été prise en compte et sera traitée par l'équipe PHSQ.";

		$scope.fiche = null;
		$scope.raisons = [];
		$scope.notes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
		$scope.aujourdhui = OfficineService.aujourdhuiIso();
		$scope.envoi = false;
		$scope.tentative = false;
		$scope.titreErreur = "La sortie de la démarche qualité n'a pas pu s'afficher";
		// Des OBJETS, pour que les `ng-model` des champs atteignent le contrôleur (portées filles).
		$scope.saisie = {
			raisons: {},
			raisonPrecision: '',
			nps: null,
			charte: false,
			communication: false,
			clotureLqo: false,
			dateSouhaitee: null,
			commentaires: '',
			validation: false
		};
		// Après une demande close : le formulaire s'ouvre à la demande (ou d'emblée, depuis « Mes demandes »).
		$scope.formulaire = { visible: !!$stateParams.nouvelle };

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([OfficineService.fiche(), OfficineService.sortieQualite(),
				OfficineService.raisonsSortieQualite()])
				.then(function (reponses) {
					$scope.fiche = reponses[0];
					$scope.sortieQualite = reponses[1] || null;
					$scope.raisons = reponses[2] || [];
				});
		});
		OfficineEcran.equiperDemandes($scope);

		/** Ici, « Déposer une nouvelle demande » (après une close) ouvre le formulaire en place. */
		$scope.demanderSortieQualite = function () {
			$scope.formulaire.visible = true;
		};

		$scope.afficherFormulaire = function () {
			var etat = $scope.etatQualite();
			if (etat === 'aucune' || etat === 'annulee') {
				return true;
			}
			return (etat === 'refusee' || etat === 'traitee') && $scope.formulaire.visible;
		};

		/** Après une demande close, « Annuler » revient au suivi ; sinon à l'accueil. */
		$scope.annuler = function () {
			var etat = $scope.etatQualite();
			if (etat === 'refusee' || etat === 'traitee') {
				$scope.formulaire.visible = false;
				return;
			}
			$state.go('app.officine');
		};

		/** Le compte qui valide : les engagements lui sont associés (spécification § 5.1). */
		$scope.compte = function () {
			return $rootScope.user ? $rootScope.user.mail : null;
		};

		/** Un second clic sur la note choisie la retire : la recommandation est facultative. */
		$scope.choisirNote = function (note) {
			$scope.saisie.nps = $scope.saisie.nps === note ? null : note;
		};

		// ---------------------------------------------------------------- Le contrôle

		function raisonsChoisies() {
			return $scope.raisons.filter(function (raison) {
				return !!$scope.saisie.raisons[raison.id];
			}).map(function (raison) {
				return raison.id;
			});
		}

		/**
		 * La première raison cochée qui exige une précision (« Autre », 12/10/2026), ou null : c'est
		 * elle qui fait paraître la zone « Précisez la raison », obligatoire.
		 */
		$scope.raisonExigeante = function () {
			return $scope.raisons.filter(function (raison) {
				return raison.precisionRequise && !!$scope.saisie.raisons[raison.id];
			})[0] || null;
		};

		function precision() {
			return String($scope.saisie.raisonPrecision || '').trim();
		}

		/** La date choisie, en `AAAA-MM-JJ`, ou `null` si elle manque ou précède aujourd'hui. */
		function dateValide() {
			var iso = OfficineService.versIso($scope.saisie.dateSouhaitee);
			return iso && iso >= $scope.aujourdhui ? iso : null;
		}

		function erreurs() {
			return {
				raisons: !raisonsChoisies().length,
				precision: !!$scope.raisonExigeante() && !precision(),
				charte: $scope.saisie.charte !== true,
				communication: $scope.saisie.communication !== true,
				clotureLqo: $scope.saisie.clotureLqo !== true,
				date: !dateValide(),
				validation: $scope.saisie.validation !== true
			};
		}

		/** Un champ ne se dit en faute qu'après une première tentative d'envoi. */
		$scope.manque = function (champ) {
			return $scope.tentative && erreurs()[champ];
		};

		$scope.valide = function () {
			var constat = erreurs();
			return Object.keys(constat).every(function (champ) {
				return !constat[champ];
			});
		};

		// ---------------------------------------------------------------- L'envoi

		$scope.transmettre = function () {
			$scope.tentative = true;
			if ($scope.envoi || !$scope.valide()) {
				return;
			}
			var commentaires = String($scope.saisie.commentaires || '').trim();
			// Le corps du contrat § 3.2, et rien d'autre. Les quatre engagements partent tels que
			// cochés : le serveur les horodate à la réception, et répond 400 s'il en manque un.
			var corps = {
				raisonIds: raisonsChoisies(),
				// Seulement si une raison cochée l'exige : sinon la zone n'existe pas à l'écran.
				raisonPrecision: $scope.raisonExigeante() ? precision() : null,
				dateSouhaitee: dateValide(),
				nps: angular.isNumber($scope.saisie.nps) ? $scope.saisie.nps : null,
				commentaires: commentaires || null,
				engagements: {
					charte: $scope.saisie.charte === true,
					communication: $scope.saisie.communication === true,
					clotureLqo: $scope.saisie.clotureLqo === true,
					validation: $scope.saisie.validation === true
				}
			};
			$scope.envoi = true;
			OfficineService.declarerSortieQualite(corps).then(function () {
				$state.go('app.officine.demandes', { confirmation: CONFIRMATION });
			}).catch(function (erreur) {
				if (erreur.conflit) {
					// SQ6 : une demande est déjà ouverte. Le message du CRM, TEL QUEL, sur l'accueil.
					$state.go('app.officine', { alerte: erreur.message }, { reload: 'app.officine' });
					return;
				}
				// La saisie reste à l'écran : un refus (400) ou une panne ne doit pas la faire perdre.
				toastr.error(erreur.message || 'Une erreur est survenue, veuillez réessayer plus tard.');
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('DeclarerSortieController', DeclarerSortieController);

	/**
	 * Sous-page « Sortie de groupement » (`app.officine.sortie`, adresse inchangée).
	 *
	 * Elle montre le FORMULAIRE quand rien n'est en cours (état A), ou après un refus quand
	 * l'officine choisit de redéclarer ; sinon le SUIVI, le même que dans « Mes demandes » : la
	 * déclaration ouverte et son retrait, le refus, la déclaration d'un tiers (amputée), ou l'absence
	 * de groupement à quitter (R20).
	 *
	 * Trois champs, TOUS FACULTATIFS (R17) : un envoi à vide est une déclaration valide. La
	 * destination distingue deux choses que le CRM distingue aussi : laissée vide, rien n'est dit ;
	 * « Je ne sais pas encore » CHOISI, l'officine a répondu qu'elle ne savait pas.
	 *
	 * Après l'envoi, « Mes demandes » affiche la déclaration. Un 409 (R3, une déclaration est déjà
	 * ouverte) ramène à l'accueil, qui affiche le message du CRM tel quel.
	 */
	/** @ngInject */
	function DeclarerSortieController($scope, $q, $state, $stateParams, OfficineEcran, OfficineService, toastr) {

		/** La valeur de « Je ne sais pas encore ». Jamais un identifiant : ceux du CRM sont numériques. */
		var INCONNUE = 'INCONNUE';

		$scope.INCONNUE = INCONNUE;
		$scope.fiche = null;
		$scope.causes = [];
		$scope.groupements = [];
		$scope.envoi = false;
		$scope.titreErreur = "La sortie de groupement n'a pas pu s'afficher";
		// Des OBJETS, pour que les `ng-model` des champs atteignent le contrôleur (portées filles).
		$scope.saisie = { motifId: null, destination: null, precisions: '' };
		// Après un refus : le formulaire s'ouvre à la demande (ou d'emblée, depuis « Mes demandes »).
		$scope.formulaire = { visible: !!$stateParams.nouvelle };

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([OfficineService.fiche(), OfficineService.sortie(), OfficineService.causesSortie(),
				OfficineService.groupements()])
				.then(function (reponses) {
					$scope.fiche = reponses[0];
					$scope.sortie = reponses[1] || null;
					$scope.causes = reponses[2] || [];
					$scope.groupements = reponses[3] || [];
				});
		});
		OfficineEcran.equiperDemandes($scope);

		/** Ici, « Déclarer une sortie de groupement » (après un refus) ouvre le formulaire en place. */
		$scope.declarer = function () {
			$scope.formulaire.visible = true;
		};

		$scope.afficherFormulaire = function () {
			var etat = $scope.etatGroupement();
			return etat === 'A' || (etat === 'E' && $scope.formulaire.visible);
		};

		/** Après un refus, « Annuler » revient au suivi ; sinon à l'accueil. */
		$scope.annuler = function () {
			if ($scope.etatGroupement() === 'E') {
				$scope.formulaire.visible = false;
				return;
			}
			$state.go('app.officine');
		};

		$scope.transmettre = function () {
			if ($scope.envoi) {
				return;
			}
			var destination = $scope.saisie.destination;
			var corps = {
				motifId: $scope.saisie.motifId || null,
				destinationGroupementId: destination && destination !== INCONNUE ? destination : null,
				destinationInconnue: destination === INCONNUE,
				precisions: String($scope.saisie.precisions || '').trim() || null
			};
			$scope.envoi = true;
			OfficineService.declarerSortie(corps).then(function () {
				$state.go('app.officine.demandes', { confirmation: 'Votre déclaration a été transmise à PHSQ.' });
			}).catch(function (erreur) {
				if (erreur.conflit) {
					// R3 : une déclaration est déjà ouverte. Le message du CRM, TEL QUEL, sur l'accueil.
					$state.go('app.officine', { alerte: erreur.message }, { reload: 'app.officine' });
					return;
				}
				// La saisie reste à l'écran : un refus ou une panne ne doit pas la faire perdre.
				toastr.error(erreur.message || 'Une erreur est survenue, veuillez réessayer plus tard.');
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('MonOfficineController', MonOfficineController);

	/**
	 * « Mon officine » — l'ACCUEIL (`app.officine`, spécification sortie-qualite § 8.1) : la carte de
	 * l'officine, puis sept tuiles en trois sections, chacune vers sa sous-page.
	 *
	 * L'accueil lit la fiche — c'est elle qui décide des écrans pleins (non rapprochée, référentiel
	 * éteint) — et les deux demandes adressées à PHSQ, pour la pastille de « Mes demandes ».
	 *
	 * ⚠️ L'échec de la lecture d'une demande SEULE n'emporte pas l'accueil : sa promesse est rattrapée
	 * avant le `$q.all`, et la tuile s'affiche simplement sans pastille. Les sous-pages, elles,
	 * basculent sur l'erreur : c'est là qu'on agit sur la demande.
	 */
	/** @ngInject */
	function MonOfficineController($scope, $q, $stateParams, OfficineEcran, OfficineService) {

		$scope.fiche = null;
		// Les trois sections et leurs sept tuiles : les mêmes que la rangée des sous-pages.
		$scope.sections = OfficineEcran.sections;
		$scope.titreErreur = "« Mon officine » n'a pas pu s'afficher";
		// Le refus rapporté par une sous-page (409), affiché une fois en tête.
		$scope.alerte = $stateParams.alerte || null;

		$scope.fermerAlerte = function () {
			$scope.alerte = null;
		};

		function sansEchec(promesse) {
			return promesse.catch(function () {
				return null;
			});
		}

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([
				OfficineService.fiche(),
				sansEchec(OfficineService.sortie()),
				sansEchec(OfficineService.sortieQualite())
			]).then(function (reponses) {
				$scope.fiche = reponses[0];
				$scope.sortie = reponses[1] || null;
				$scope.sortieQualite = reponses[2] || null;
			});
		});
		OfficineEcran.equiperDemandes($scope);

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineInformationsController', OfficineInformationsController);

	/**
	 * Sous-page « Informations et adresse » (`app.officine.informations`) : l'identité de l'officine en
	 * lecture seule, son adresse — modifiable dans une fenêtre —, son groupement et ceux qu'elle a
	 * quittés.
	 *
	 * La fenêtre (`OfficineAdresseDialogController`, adresse.dialog) rend la fiche relue par le CRM,
	 * qui remplace l'ancienne.
	 */
	/** @ngInject */
	function OfficineInformationsController($scope, $mdDialog, $document, OfficineEcran, OfficineService, toastr) {

		$scope.fiche = null;
		$scope.titreErreur = "Les informations de l'officine n'ont pas pu s'afficher";

		var ecran = OfficineEcran.equiper($scope, function () {
			return OfficineService.fiche().then(function (fiche) {
				$scope.fiche = fiche;
			});
		});

		$scope.ouvrirEdition = function (event) {
			$mdDialog.show({
				templateUrl: 'app/main/front/officine/informations/adresse.dialog.html',
				controller: 'OfficineAdresseDialogController',
				locals: { fiche: $scope.fiche },
				parent: angular.element($document[0].body),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: true
			}).then(function (fiche) {
				if (fiche) {
					$scope.fiche = fiche;
				}
				// Enregistrement immédiat, sans validation de PHSQ : on le dit, c'est un geste qui engage.
				toastr.success('Adresse enregistrée sur votre fiche PHSQ.');
			}, angular.noop);
		};

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineAdresseDialogController', OfficineAdresseDialogController);

	/**
	 * Modifier l'adresse de l'officine, dans une fenêtre ouverte depuis « Informations et adresse »
	 * (choix du PO : plus d'édition en place dans la carte).
	 *
	 * Quatre champs, pas huit : rue, complément, code postal, ville. Le nom, le code CIP, le
	 * sous-groupe et le numéro d'adhérent sont des IDENTIFIANTS, affichés en lecture seule sur la
	 * page — une officine qui se renommerait casserait le rapprochement de sa propre fiche. La liste
	 * blanche est tenue par le CRM ; le formulaire ne propose que ce qu'il acceptera.
	 *
	 * Enregistrement IMMÉDIAT, sans validation préalable de PHSQ (R17 vaut aussi pour l'adresse :
	 * une officine qui déménage n'attend personne). Rend, à la fermeture, la fiche relue par le CRM.
	 */
	/** @ngInject */
	function OfficineAdresseDialogController($scope, $mdDialog, OfficineService, fiche) {

		var adresse = (fiche && fiche.adresse) || {};

		function nettoyer(valeur) {
			return String(valeur || '').trim();
		}

		$scope.fiche = fiche;
		$scope.saisie = {
			rue: adresse.rue || '',
			adresseSuite: adresse.adresseSuite || '',
			codePostal: adresse.codePostal || '',
			ville: adresse.ville || ''
		};
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.erreur = null;

		/** Les trois champs que le CRM exige. Vides, rien n'est envoyé et le champ le dit. */
		$scope.manque = function (champ) {
			return $scope.tentative && !nettoyer($scope.saisie[champ]);
		};

		$scope.enregistrer = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			if ($scope.manque('rue') || $scope.manque('codePostal') || $scope.manque('ville') || $scope.envoi) {
				return;
			}
			$scope.envoi = true;
			OfficineService.modifierAdresse({
				rue: nettoyer($scope.saisie.rue),
				adresseSuite: nettoyer($scope.saisie.adresseSuite) || null,
				codePostal: nettoyer($scope.saisie.codePostal),
				ville: nettoyer($scope.saisie.ville)
			}).then(function (ficheRelue) {
				$mdDialog.hide(ficheRelue);
			}).catch(function (erreur) {
				// La saisie reste à l'écran : un refus ou une panne ne doit pas la faire perdre.
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('offNavigation', offNavigation);

	/**
	 * La rangée de mini-tuiles en tête de chaque sous-page de « Mon officine » (PHSQ-220) : les sept
	 * rubriques de l'accueil, mêmes icônes et mêmes couleurs de section, la rubrique ouverte en
	 * couleur pleine (`doc-card--active`, comme dans un dossier de la base documentaire).
	 *
	 * La pastille de « Mes demandes » compte les demandes OUVERTES (`demandesEnCours`). Une sous-page
	 * qui lit déjà les deux demandes (`OfficineEcran.equiperDemandes`) la fournit à la rangée par
	 * héritage de portée : le compte suit alors un retrait sans relecture. Les autres ne les lisent
	 * pas : la rangée les lit elle-même, et un échec la laisse simplement sans pastille.
	 *
	 * Usage : `<off-navigation></off-navigation>`, sous le fil d'Ariane.
	 */
	/** @ngInject */
	function offNavigation() {
		return {
			restrict: 'E',
			scope: true,
			templateUrl: 'app/main/front/officine/en-tete/navigation.html',
			controller: OfficineNavigationController
		};
	}

	/** @ngInject */
	function OfficineNavigationController($scope, $state, OfficineEcran, OfficineService) {

		$scope.sections = OfficineEcran.sections;

		$scope.estCourante = function (etat) {
			return $state.is(etat);
		};

		if (!angular.isFunction($scope.demandesEnCours)) {
			OfficineEcran.equiperDemandes($scope);
			OfficineService.sortie().then(function (sortie) {
				$scope.sortie = sortie || null;
			}).catch(angular.noop);
			OfficineService.sortieQualite().then(function (demande) {
				$scope.sortieQualite = demande || null;
			}).catch(angular.noop);
		}
	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('offBandeau', offBandeau);

	/**
	 * Le bandeau d'une sous-page de « Mon officine » (PHSQ-220) : dans la couleur pastel de la
	 * section de sa tuile, la grande icône, le titre (le `h1` de la page), la phrase d'aide, le lien
	 * « En savoir plus » qui déplie l'aide, et les actions principales de la page.
	 *
	 * L'icône, le titre et la couleur se lisent sur la rubrique (`OfficineEcran.sections`) : une
	 * tuile et son bandeau ne peuvent pas diverger. Le reste est fourni par la page, qui garde la
	 * main sur sa portée (`peutEcrire()`, `ouvrirPersonne()`…) :
	 *
	 *   <off-bandeau etat="app.officine.contacts">
	 *     <off-bandeau-phrase>…</off-bandeau-phrase>
	 *     <off-bandeau-aide><p>…</p></off-bandeau-aide>           (facultatif)
	 *     <off-bandeau-actions><button …></button></off-bandeau-actions>   (facultatif)
	 *   </off-bandeau>
	 */
	/** @ngInject */
	function offBandeau(OfficineEcran) {
		return {
			restrict: 'E',
			scope: {},
			transclude: {
				phrase: 'offBandeauPhrase',
				aide: '?offBandeauAide',
				actions: '?offBandeauActions'
			},
			templateUrl: 'app/main/front/officine/en-tete/bandeau.html',
			link: function (scope, element, attrs, controleur, transclude) {
				scope.rubrique = OfficineEcran.rubrique(attrs.etat) || {};
				scope.avecAide = transclude.isSlotFilled('aide');
				scope.avecActions = transclude.isSlotFilled('actions');
				scope.idAide = 'off-aide-' + String(attrs.etat || '').replace(/[^a-z0-9]+/gi, '-');
				// Un OBJET : l'aide vit sous un `ng-if`, donc sous une portée fille.
				scope.aide = { ouverte: false };

				scope.basculerAide = function () {
					scope.aide.ouverte = !scope.aide.ouverte;
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineDemandesController', OfficineDemandesController);

	/**
	 * Sous-page « Mes demandes » (`app.officine.demandes`) : les deux demandes que l'officine adresse
	 * à PHSQ — la déclaration de sortie de groupement et la demande de sortie de la démarche qualité —,
	 * chacune avec sa frise, son retrait possible, son refus. Le CRM sert, pour chacune, l'ouverte,
	 * sinon la dernière close de l'officine.
	 *
	 * Le paramètre `confirmation` porte le message qui suit un dépôt (sous-pages de sortie).
	 */
	/** @ngInject */
	function OfficineDemandesController($scope, $q, $stateParams, OfficineEcran, OfficineService) {

		$scope.fiche = null;
		$scope.titreErreur = "Vos demandes n'ont pas pu s'afficher";
		$scope.confirmation = $stateParams.confirmation || null;

		$scope.fermerConfirmation = function () {
			$scope.confirmation = null;
		};

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([OfficineService.fiche(), OfficineService.sortie(), OfficineService.sortieQualite()])
				.then(function (reponses) {
					$scope.fiche = reponses[0];
					$scope.sortie = reponses[1] || null;
					$scope.sortieQualite = reponses[2] || null;
				});
		});
		OfficineEcran.equiperDemandes($scope);

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineTransfertAccesDialogController', OfficineTransfertAccesDialogController);

	/**
	 * Transférer une place PrAQ ou Équipe OCCUPÉE à une autre personne de la liste (12/10/2026),
	 * depuis la carte de la place, page « Accès LQO ».
	 *
	 * Le même geste que « Donner » d'une ligne de la liste, vu depuis la place : `donnerAcces`. Quand la
	 * personne choisie n'a pas de compte, le compte de l'occupant CHANGE DE MAIN (décision du PO : « sur
	 * LQO cela ne fait que changer l'email ») — il prend son courriel, son mot de passe est remis à zéro
	 * et un lien d'activation lui part ; l'occupant ne peut plus se connecter. Quand elle en a un (une
	 * autre place), elle prend celle-ci et l'occupant quitte l'officine. L'écran le dit AVANT.
	 */
	/** @ngInject */
	function OfficineTransfertAccesDialogController($scope, $mdDialog, OfficineService, place, personnes, fiche) {

		var LIBELLES_ACCES = { PRAQ: 'Responsable Qualité', EQUIPE: 'Équipe', TITULAIRE: 'Titulaire' };

		function nomPropre(ligne) {
			return [ligne.prenom, ligne.nom].filter(function (morceau) {
				return morceau && String(morceau).trim();
			}).join(' ');
		}

		function nomDe(ligne) {
			if (!ligne) {
				return '';
			}
			return nomPropre(ligne) || ligne.mail || 'une personne sans nom';
		}

		var occupant = place.occupant;
		$scope.place = place;
		$scope.fiche = fiche;
		$scope.nomDe = nomDe;
		$scope.nomOccupant = nomDe(occupant);
		$scope.aUnNom = function (ligne) {
			return !!ligne && !!nomPropre(ligne);
		};
		// Une personne de la liste, avec un courriel, qui n'est ni l'occupant ni le titulaire.
		$scope.beneficiaires = (personnes || []).filter(function (ligne) {
			return !ligne.sansContact && ligne.contactId && ligne.mail && ligne.acces !== 'TITULAIRE'
				&& !(occupant && occupant.userId && ligne.userId === occupant.userId);
		});
		$scope.choix = { contactId: null };
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.erreur = null;

		$scope.beneficiaire = function () {
			return $scope.beneficiaires.filter(function (ligne) {
				return String(ligne.contactId) === String($scope.choix.contactId);
			})[0] || null;
		};

		$scope.consequence = function () {
			var cible = $scope.beneficiaire();
			if (!cible) {
				return null;
			}
			if (cible.acces) {
				return nomDe(cible) + ' a déjà l\'accès ' + LIBELLES_ACCES[cible.acces] + ' : il prendra l\'accès '
					+ place.libelle + ' et libérera le sien. Le compte de ' + $scope.nomOccupant
					+ ' quittera votre officine et ses sessions seront fermées.';
			}
			return 'Le compte ' + place.libelle + ' passe à ' + nomDe(cible) + ' : il prend son courriel ('
				+ cible.mail + '), qui recevra un lien pour créer son mot de passe. ' + $scope.nomOccupant
				+ ' ne pourra plus se connecter. Ce qui a été saisi avec ce compte reste sur le compte.';
		};

		$scope.valider = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			var cible = $scope.beneficiaire();
			if ($scope.envoi || !cible) {
				return;
			}
			$scope.envoi = true;
			OfficineService.donnerAcces(cible.contactId, place.slot).then(function () {
				$mdDialog.hide('L\'accès ' + place.libelle + ' est transféré à ' + nomDe(cible)
					+ (cible.acces ? '.' : ' : un lien d\'activation lui est envoyé.'));
			}).catch(function (erreur) {
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineRetirerContactDialogController', OfficineRetirerContactDialogController);

	/**
	 * Retirer une personne de la liste (12/10/2026) — elle passe ARCHIVÉE chez PHSQ. L'officine la
	 * fait revenir en l'ajoutant de nouveau avec son courriel : sa fiche est retrouvée.
	 *
	 * Deux règles du PO, tenues ici à l'écran et de nouveau par LQO et le CRM :
	 * - le CONTACT PRINCIPAL ne part pas seul : ce dialogue fait choisir son remplaçant, parmi les
	 *   personnes de la liste pourvues d'un courriel, et le CRM pose les deux dans le même geste ;
	 * - un ACCÈS PrAQ ou Équipe ne part pas avec la personne : il est TRANSFÉRÉ à une autre personne
	 *   de la liste, avant le retrait. Le même compte LQO change de main (nouveau courriel, mot de passe
	 *   à créer) quand la personne choisie n'en a pas. Le titulaire ne se retire pas : il cède son titre.
	 *
	 * Rend, à la fermeture, le message de confirmation que la liste affiche après s'être relue.
	 */
	/** @ngInject */
	function OfficineRetirerContactDialogController($scope, $mdDialog, OfficineService, personne, candidats, fiche) {

		var LIBELLES_ACCES = { PRAQ: 'Responsable Qualité', EQUIPE: 'Équipe' };

		function nomPropre(ligne) {
			return [ligne.prenom, ligne.nom].filter(function (morceau) {
				return morceau && String(morceau).trim();
			}).join(' ');
		}

		function nomDe(ligne) {
			if (!ligne) {
				return '';
			}
			return nomPropre(ligne) || ligne.mail || 'une personne sans nom';
		}

		function parId(id) {
			return (candidats || []).filter(function (ligne) {
				return String(ligne.contactId) === String(id);
			})[0] || null;
		}

		$scope.personne = personne;
		$scope.fiche = fiche;
		$scope.nomPersonne = nomDe(personne);
		$scope.nomDe = nomDe;
		$scope.aUnNom = function (ligne) {
			return !!ligne && !!nomPropre(ligne);
		};
		$scope.principal = !!personne.principal;
		// L'accès à transférer : PrAQ ou Équipe. Le titulaire n'arrive jamais ici (bouton grisé).
		$scope.acces = LIBELLES_ACCES[personne.acces] ? personne.acces : null;
		$scope.libelleAcces = $scope.acces ? LIBELLES_ACCES[$scope.acces] : null;
		// Une autre personne de la liste, avec un courriel : remplaçant du principal comme bénéficiaire
		// de l'accès. Le titulaire ne peut pas recevoir un autre accès.
		var autres = (candidats || []).filter(function (ligne) {
			return !ligne.sansContact && ligne.contactId && ligne.mail
				&& String(ligne.contactId) !== String(personne.contactId);
		});
		$scope.remplacants = autres;
		$scope.beneficiaires = autres.filter(function (ligne) {
			return ligne.acces !== 'TITULAIRE';
		});
		$scope.choix = { remplacantId: null, beneficiaireId: null };
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.erreur = null;

		$scope.manqueRemplacant = function () {
			return $scope.principal && !$scope.choix.remplacantId;
		};

		$scope.manqueBeneficiaire = function () {
			return !!$scope.acces && !$scope.choix.beneficiaireId;
		};

		$scope.beneficiaire = function () {
			return $scope.choix.beneficiaireId ? parId($scope.choix.beneficiaireId) : null;
		};

		/** Ce que devient l'accès, dit avant la confirmation. */
		$scope.consequenceTransfert = function () {
			var cible = $scope.beneficiaire();
			if (!cible) {
				return null;
			}
			if (cible.acces) {
				return nomDe(cible) + ' a déjà l\'accès ' + (LIBELLES_ACCES[cible.acces] || cible.acces)
					+ ' : il prendra l\'accès ' + $scope.libelleAcces + ' et libérera le sien. Le compte de '
					+ $scope.nomPersonne + ' quittera votre officine.';
			}
			return 'Le compte ' + $scope.libelleAcces + ' passe à ' + nomDe(cible) + ' : il prend son courriel ('
				+ cible.mail + '), qui recevra un lien pour créer son mot de passe. ' + $scope.nomPersonne
				+ ' ne pourra plus se connecter. Ce qui a été saisi avec ce compte reste sur le compte.';
		};

		$scope.valider = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			if ($scope.envoi || $scope.manqueRemplacant() || $scope.manqueBeneficiaire()) {
				return;
			}
			$scope.envoi = true;
			OfficineService.retirerPersonne(personne.contactId, $scope.principal ? $scope.choix.remplacantId : null,
				$scope.acces ? $scope.choix.beneficiaireId : null)
				.then(function () {
					var message = nomDe(personne) + ' a été retiré(e) de la liste.';
					var remplacant = $scope.principal ? parId($scope.choix.remplacantId) : null;
					if (remplacant) {
						message += ' ' + nomDe(remplacant) + ' est le nouveau contact principal.';
					}
					var beneficiaire = $scope.beneficiaire();
					if ($scope.acces && beneficiaire) {
						message += ' Son accès ' + $scope.libelleAcces + ' est transféré à ' + nomDe(beneficiaire) + '.';
					}
					$mdDialog.hide(message);
				}).catch(function (erreur) {
					$scope.erreur = erreur.message;
				}).finally(function () {
					$scope.envoi = false;
				});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficinePassationDialogController', OfficinePassationDialogController);

	/**
	 * Écran 7 — céder le titre de titulaire. LE SEUL GESTE DU LOT QU'UNE OFFICINE NE PEUT PAS
	 * DÉFAIRE SEULE : l'écran ne doit ni l'adoucir ni l'enterrer sous un « êtes-vous sûr ? ».
	 *
	 * 1. Le successeur est choisi parmi les personnes de la liste qui ont un courriel, hors
	 *    l'appelant lui-même : sans courriel, pas de compte à qui transmettre le titre.
	 * 2. Ce que l'appelant perd est dit en toutes lettres, calculé ICI par la règle même du back
	 *    (AccesOfficineService.placePourLAncienTitulaire) : la place que libère le successeur, sinon
	 *    une place vide, PrAQ d'abord, sinon rien — « et vous n'aurez plus accès à LQO ».
	 * 3. Le mot de passe est redemandé : c'est la preuve que c'est bien le titulaire, et non
	 *    quelqu'un devant son poste resté ouvert, qui cède son officine. Faux : 403, et RIEN n'est
	 *    écrit.
	 *
	 * Au 200, la session ne vaut plus rien — le serveur l'a déjà fermée. ⚠️ Le dialogue NE REDIRIGE
	 * PAS tout de suite : enchaîné sur la réponse, le retour à la connexion effaçait le message de
	 * succès en quelques millisecondes et l'ancien titulaire se retrouvait déconnecté sans savoir
	 * pourquoi. Il lit ce qui s'est passé, puis revient à la connexion par le bouton — ou par Échap,
	 * ou d'un clic à côté : toute fermeture après la passation y mène. Le retour se fait par un
	 * rechargement complet, qui vide aussi ce que l'application garde en mémoire.
	 */
	/** @ngInject */
	function OfficinePassationDialogController($scope, $rootScope, $mdDialog, $window, OfficineService,
		UserService, personnes, acces, fiche) {

		var LIBELLES = { PRAQ: 'Responsable Qualité', EQUIPE: 'Équipe' };

		function normaliser(mail) {
			return String(mail || '').trim().toLowerCase();
		}

		function nomPropre(ligne) {
			return [ligne.prenom, ligne.nom].filter(function (morceau) {
				return morceau && String(morceau).trim();
			}).join(' ');
		}

		function nomDe(ligne) {
			if (!ligne) {
				return '';
			}
			return nomPropre(ligne) || ligne.mail || '';
		}

		var moi = normaliser($rootScope.user && $rootScope.user.mail);

		$scope.fiche = fiche;
		$scope.nomDe = nomDe;
		// Sans nom, la personne est déjà désignée par son courriel : on ne le répète pas.
		$scope.aUnNom = function (ligne) {
			return !!ligne && !!nomPropre(ligne);
		};
		$scope.titulaire = (acces && acces.TITULAIRE) || { mail: $rootScope.user && $rootScope.user.mail };
		$scope.successeurs = (personnes || []).filter(function (ligne) {
			return !ligne.sansContact && ligne.contactId && normaliser(ligne.mail)
				&& normaliser(ligne.mail) !== moi && ligne.acces !== 'TITULAIRE';
		});
		$scope.choix = { contactId: null, motDePasse: '' };
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.termine = false;
		$scope.erreur = null;
		// Après le 200 : le successeur et ce que le SERVEUR dit que l'appelant conserve.
		$scope.resultat = null;

		var depart = false;

		function revenirALaConnexion() {
			if (depart) {
				return;
			}
			depart = true;
			UserService.logout().catch(angular.noop).finally(function () {
				$window.location.href = './login';
			});
		}

		$scope.revenirALaConnexion = revenirALaConnexion;

		// Échap et le clic à côté ferment le dialogue sans passer par le bouton : après la
		// passation, la page derrière lui n'a plus de session, on ne l'y laisse pas.
		$scope.$on('$destroy', function () {
			if ($scope.termine) {
				revenirALaConnexion();
			}
		});

		$scope.successeur = function () {
			var trouve = null;
			angular.forEach($scope.successeurs, function (ligne) {
				if (ligne.contactId === $scope.choix.contactId) {
					trouve = ligne;
				}
			});
			return trouve;
		};

		/** La place que l'appelant conservera, `null` s'il n'en garde aucune, `undefined` sans successeur. */
		$scope.placeConservee = function () {
			var successeur = $scope.successeur();
			if (!successeur) {
				return undefined;
			}
			if (successeur.acces === 'PRAQ' || successeur.acces === 'EQUIPE') {
				return successeur.acces;
			}
			if (!acces || !acces.PRAQ) {
				return 'PRAQ';
			}
			if (!acces.EQUIPE) {
				return 'EQUIPE';
			}
			return null;
		};

		$scope.libelle = function (slot) {
			return LIBELLES[slot] || slot;
		};

		$scope.manqueMotDePasse = function () {
			return $scope.tentative && !$scope.choix.motDePasse;
		};

		$scope.valider = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			var successeur = $scope.successeur();
			if (!successeur || !$scope.choix.motDePasse || $scope.envoi || $scope.termine) {
				return;
			}
			$scope.envoi = true;
			OfficineService.passerLeTitre(successeur.contactId, $scope.choix.motDePasse).then(function (reponse) {
				$scope.choix.motDePasse = '';
				$scope.resultat = {
					successeur: successeur,
					conserve: reponse && reponse.appelantConserve ? reponse.appelantConserve : null
				};
				$scope.termine = true;
			}).catch(function (erreur) {
				// Le mot de passe n'est jamais gardé après un échec.
				$scope.choix.motDePasse = '';
				$scope.erreur = erreur.status === 403
					? "Mot de passe incorrect. Rien n'a été modifié : vous êtes toujours titulaire."
					: erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			if (!$scope.termine) {
				$mdDialog.cancel();
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineContactDialogController', OfficineContactDialogController);

	/**
	 * Écran 8 — ajouter une personne, ou la corriger (le crayon de la liste ouvre le même dialogue,
	 * pré-rempli).
	 *
	 * Prénom et nom exigés, le reste facultatif — le courriel compris : une personne sans courriel
	 * est une personne de l'équipe comme une autre, elle ne pourra simplement pas recevoir d'accès.
	 *
	 * Les RÔLES (12/10/2026) : l'officine coche ceux que PHSQ lui a ouverts (`rolesContact()`). Ceux
	 * que PHSQ garde restent sur la personne, affichés sans case : le CRM ne retire jamais, depuis
	 * ici, un rôle que l'officine ne peut pas attribuer. Le contact principal reste désigné par PHSQ.
	 *
	 * ⚠️ Le courriel ne se CHANGE pas en correction (règle P9) : c'est la clé qui rapproche la
	 * personne de son compte LQO. Il se POSE, en revanche, sur une personne qui n'en a pas — c'est
	 * ce qui permet ensuite de lui donner un accès. D'où, au moment de le poser, la double saisie,
	 * le format strict et la suggestion de domaine : une faute de frappe, ici, ne se corrige plus.
	 *
	 * `prefill` (12/10/2026) : « Créer le contact » d'un compte LQO qu'aucune personne ne réclame —
	 * courriel et nom du compte, déjà connus : la double saisie est pré-remplie.
	 *
	 * Une personne RETIRÉE de la liste revient par ce même dialogue (12/10/2026) : son courriel répond
	 * `MAIL_CONTACT_ARCHIVE` avec son identifiant, et « La faire revenir » réactive sa fiche — puis y
	 * applique ce qui vient d'être saisi —, au lieu d'en créer une seconde.
	 *
	 * Rend, à la fermeture, le message de confirmation que la liste affiche après s'être relue.
	 */
	/** @ngInject */
	function OfficineContactDialogController($scope, $mdDialog, OfficineService, personne, fiche, personnes, prefill) {

		/**
		 * Le MÊME format que le CRM (`LqoApiService.FORMAT_MAIL`), sur l'adresse en minuscules :
		 * lettres, chiffres et `_ % + ' -` de part et d'autre de points isolés ; un domaine en
		 * étiquettes ASCII, terminé par au moins deux lettres.
		 */
		var FORMAT_MAIL = /^[a-z0-9_%+'-]+(\.[a-z0-9_%+'-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;
		var LONGUEUR_MAIL = 254;

		/** Les domaines les plus courants des officines : une adresse à une ou deux lettres près est suspecte. */
		var DOMAINES_COURANTS = ['gmail.com', 'orange.fr', 'wanadoo.fr', 'free.fr', 'sfr.fr', 'laposte.net',
			'hotmail.fr', 'hotmail.com', 'outlook.fr', 'outlook.com', 'live.fr', 'yahoo.fr', 'yahoo.com',
			'icloud.com', 'neuf.fr', 'bbox.fr', 'aliceadsl.fr', 'numericable.fr'];

		/** Les refus du serveur qui concernent le courriel : ils s'affichent sous le champ, pas en tête. */
		var MOTIFS_MAIL = ['MAIL_OBLIGATOIRE', 'MAIL_INVALIDE', 'MAIL_IMMUABLE', 'MAIL_DEJA_DANS_LA_LISTE',
			'MAIL_AUTRE_OFFICINE', 'MAIL_CONTACT_ARCHIVE', 'MAIL_COMPTE_LQO_AUTRE_OFFICINE'];

		function nettoyer(valeur) {
			return String(valeur || '').trim();
		}

		function normaliserMail(valeur) {
			return nettoyer(valeur).toLowerCase();
		}

		function nomDe(autre) {
			var nom = [autre.prenom, autre.nom].filter(Boolean).join(' ').trim();
			return nom || 'une autre personne';
		}

		/** Distance d'édition entre deux chaînes courtes (domaines). */
		function distance(a, b) {
			var ligne = [];
			var i;
			var j;
			for (j = 0; j <= b.length; j++) {
				ligne[j] = j;
			}
			for (i = 1; i <= a.length; i++) {
				var diagonale = ligne[0];
				ligne[0] = i;
				for (j = 1; j <= b.length; j++) {
					var dessus = ligne[j];
					ligne[j] = Math.min(ligne[j] + 1, ligne[j - 1] + 1, diagonale + (a[i - 1] === b[j - 1] ? 0 : 1));
					diagonale = dessus;
				}
			}
			return ligne[b.length];
		}

		$scope.fiche = fiche;
		$scope.modification = !!personne;
		$scope.mailInitial = personne ? nettoyer(personne.mail) : '';
		$scope.mailModifiable = !$scope.modification || !$scope.mailInitial;
		var depart = personne || prefill || {};
		$scope.saisie = {
			prenom: depart.prenom || '',
			nom: depart.nom || '',
			mail: personne ? $scope.mailInitial : nettoyer(depart.mail),
			// Le courriel d'un compte existant n'a pas de faute de frappe à craindre.
			mailConfirmation: !personne && prefill ? nettoyer(prefill.mail) : '',
			telephone: personne ? personne.telephone || '' : '',
			mobile: personne ? personne.mobile || '' : ''
		};
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.erreur = null;
		$scope.erreurMail = null;
		/** `{ contactId }` d'une personne retirée qui porte ce courriel : on peut la faire revenir. */
		$scope.archiveRetrouve = null;

		// ------------------------------------------------------------------------------ Les rôles

		var rolesPersonne = (personne && personne.rolesDetail) || [];
		$scope.roles = {
			charges: false,
			erreur: null,
			ouverts: [],
			coches: {},
			// Ceux que PHSQ garde : affichés, jamais envoyés, jamais retirés.
			gardes: rolesPersonne.filter(function (role) {
				return !role.attribuable;
			}).map(function (role) {
				return role.libelle;
			})
		};
		OfficineService.rolesContact().then(function (liste) {
			$scope.roles.ouverts = liste || [];
			rolesPersonne.forEach(function (role) {
				if (role.attribuable) {
					$scope.roles.coches[role.id] = true;
				}
			});
			$scope.roles.charges = true;
		}).catch(function () {
			// Sans la liste, `roleIds` ne part pas : les rôles restent tels quels, le reste s'enregistre.
			$scope.roles.erreur = "Les rôles n'ont pas pu être chargés : ils restent inchangés.";
		});

		// ---------------------------------------------------------------------------- Le courriel

		/**
		 * À la création, prénom ET nom sont exigés (chapitre 05, écran 8). En correction, il suffit
		 * que la personne garde un nom : le référentiel porte des contacts anciens au nom entier
		 * dans un seul champ, et exiger un prénom empêcherait d'y corriger un simple numéro.
		 */
		$scope.manque = function (champ) {
			if (!$scope.tentative) {
				return false;
			}
			if ($scope.modification) {
				return !nettoyer($scope.saisie.prenom) && !nettoyer($scope.saisie.nom);
			}
			return !nettoyer($scope.saisie[champ]);
		};

		/** Vrai si un courriel va être POSÉ : saisi, sur une personne qui n'en a pas encore. */
		$scope.mailSaisi = function () {
			return $scope.mailModifiable && !!normaliserMail($scope.saisie.mail);
		};

		/** Une autre personne de la liste porte déjà ce courriel ? (Les comptes LQO sans personne, non :
		 *  y poser leur adresse est justement ce qui les rapproche.) */
		function autrePersonneAvec(mail) {
			var autre = null;
			(personnes || []).some(function (p) {
				if (!p.sansContact && p.mail && normaliserMail(p.mail) === mail
					&& (!personne || String(p.contactId) !== String(personne.contactId))) {
					autre = p;
					return true;
				}
				return false;
			});
			return autre;
		}

		/** Ce qui cloche dans l'adresse, dit simplement ; null si le format est bon. */
		function defautFormat(mail) {
			if (/\s/.test(mail)) {
				return 'Ce courriel contient une espace : retirez-la.';
			}
			if (mail.indexOf('@') < 0) {
				return 'Il manque le « @ » de l\'adresse.';
			}
			if (/[^ -~]/.test(mail)) {
				return 'Ce courriel contient un accent ou un caractère spécial : vérifiez-le.';
			}
			return FORMAT_MAIL.test(mail) ? null : "Ce courriel n'est pas valide : vérifiez-le.";
		}

		/**
		 * Le premier problème du courriel, ou null. Le doublon dans la liste se signale dès la saisie ;
		 * le format, après une première tentative — pas à chaque lettre d'une adresse en cours.
		 */
		$scope.problemeMail = function () {
			if (!$scope.mailSaisi()) {
				return null;
			}
			var mail = normaliserMail($scope.saisie.mail);
			if (mail.length > LONGUEUR_MAIL) {
				return 'Ce courriel est trop long (' + LONGUEUR_MAIL + ' caractères au plus).';
			}
			var autre = autrePersonneAvec(mail);
			if (autre) {
				return 'Ce courriel est déjà celui de ' + nomDe(autre) + ', dans votre liste.';
			}
			return $scope.tentative ? defautFormat(mail) : null;
		};

		/** La double saisie : exigée dès qu'un courriel va être posé. */
		$scope.confirmationDifferente = function () {
			return $scope.tentative && $scope.mailSaisi()
				&& normaliserMail($scope.saisie.mailConfirmation) !== normaliserMail($scope.saisie.mail);
		};

		$scope.confirmationJuste = function () {
			return $scope.mailSaisi() && !!normaliserMail($scope.saisie.mailConfirmation)
				&& normaliserMail($scope.saisie.mailConfirmation) === normaliserMail($scope.saisie.mail);
		};

		/**
		 * « Vouliez-vous dire …@gmail.com ? » — pour un domaine à une ou deux lettres d'un domaine
		 * courant. Une suggestion, jamais un refus : l'officine peut avoir son propre domaine.
		 */
		$scope.suggestionMail = function () {
			if (!$scope.mailSaisi()) {
				return null;
			}
			var mail = normaliserMail($scope.saisie.mail);
			var arobase = mail.lastIndexOf('@');
			var domaine = arobase > 0 ? mail.slice(arobase + 1) : '';
			if (domaine.length < 5 || DOMAINES_COURANTS.indexOf(domaine) >= 0) {
				return null;
			}
			var proche = null;
			DOMAINES_COURANTS.some(function (courant) {
				var ecart = distance(domaine, courant);
				if (ecart > 0 && ecart <= 2) {
					proche = courant;
					return true;
				}
				return false;
			});
			return proche ? mail.slice(0, arobase + 1) + proche : null;
		};

		$scope.appliquerSuggestion = function () {
			var suggestion = $scope.suggestionMail();
			if (suggestion) {
				$scope.saisie.mail = suggestion;
				$scope.saisie.mailConfirmation = '';
			}
		};

		// Un refus du serveur vaut pour l'adresse qu'il a jugée : il s'efface dès qu'on la retouche.
		$scope.$watch('saisie.mail', function () {
			$scope.erreurMail = null;
			$scope.archiveRetrouve = null;
		});

		// --------------------------------------------------------------------------------- L'envoi

		/**
		 * Le corps d'une écriture, RECOMPOSÉ champ par champ : le CRM refuse tout champ hors contrat
		 * (400), et n'écrit que ceux qu'il reçoit — le courriel secondaire, que cet écran ne connaît pas,
		 * n'est donc jamais effacé par une correction. Sans le courriel : c'est `valider` qui le pose.
		 */
		function corpsSansCourriel() {
			var corps = {
				prenom: nettoyer($scope.saisie.prenom),
				nom: nettoyer($scope.saisie.nom),
				telephone: nettoyer($scope.saisie.telephone),
				mobile: nettoyer($scope.saisie.mobile)
			};
			// Les rôles ouverts VOULUS : cochés = posés, décochés = retirés. Absents si la liste n'a pas
			// pu être lue — le CRM n'y touche alors pas.
			if ($scope.roles.charges) {
				corps.roleIds = $scope.roles.ouverts.filter(function (role) {
					return $scope.roles.coches[role.id];
				}).map(function (role) {
					return role.id;
				});
			}
			return corps;
		}

		$scope.valider = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			if ($scope.manque('prenom') || $scope.manque('nom') || $scope.problemeMail() || $scope.erreurMail
				|| $scope.confirmationDifferente() || $scope.envoi) {
				return;
			}
			var corps = corpsSansCourriel();
			var mail = normaliserMail($scope.saisie.mail);
			if ($scope.mailModifiable && mail) {
				corps.mail = mail;
			}
			var appel = $scope.modification
				? OfficineService.modifierPersonne(personne.contactId, corps)
				: OfficineService.ajouterPersonne(corps);
			$scope.envoi = true;
			appel.then(function () {
				$mdDialog.hide($scope.modification
					? 'Contact enregistré sur votre fiche PHSQ.'
					: 'Contact ajouté sur votre fiche PHSQ.');
			}).catch(function (erreur) {
				if (MOTIFS_MAIL.indexOf(erreur.motifRefus) >= 0) {
					$scope.erreurMail = erreur.message;
					if (erreur.motifRefus === 'MAIL_CONTACT_ARCHIVE' && !$scope.modification
						&& erreur.details && erreur.details.contactId) {
						$scope.archiveRetrouve = { contactId: String(erreur.details.contactId) };
					}
				} else {
					$scope.erreur = erreur.message;
				}
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		/**
		 * Faire revenir la personne retirée qui porte ce courriel : sa fiche est réactivée, puis ce qui
		 * vient d'être saisi y est appliqué (nom, téléphones, rôles) — le courriel, lui, est déjà le sien.
		 */
		$scope.faireRevenir = function () {
			if (!$scope.archiveRetrouve || $scope.envoi) {
				return;
			}
			var contactId = $scope.archiveRetrouve.contactId;
			$scope.envoi = true;
			$scope.erreur = null;
			OfficineService.reactiverPersonne(contactId).then(function () {
				return OfficineService.modifierPersonne(contactId, corpsSansCourriel());
			}).then(function () {
				var nom = [nettoyer($scope.saisie.prenom), nettoyer($scope.saisie.nom)].filter(Boolean).join(' ');
				$mdDialog.hide((nom || 'La personne') + ' est de retour dans votre liste.');
			}).catch(function (erreur) {
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineContactsController', OfficineContactsController);

	/**
	 * Sous-page « Contacts » (`app.officine.contacts`) : les personnes de l'officine connues du
	 * référentiel PHSQ — ajouter, corriger. Les comptes LQO et leurs places ont leur propre page,
	 * « Accès LQO » (spécification Q13 : contacts et accès séparés).
	 *
	 * Le dialogue d'ajout et de correction est celui d'avant (`OfficineContactDialogController`).
	 */
	/** @ngInject */
	function OfficineContactsController($scope, $q, OfficineEcran, OfficineService) {

		$scope.fiche = null;
		$scope.titreErreur = "Les contacts de l'officine n'ont pas pu s'afficher";

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([OfficineService.fiche(), OfficineService.personnes()]).then(function (reponses) {
				$scope.fiche = reponses[0];
				$scope.poserPersonnes(reponses[1]);
			});
		});
		OfficineEcran.equiperPersonnes($scope);

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineAssignationDialogController', OfficineAssignationDialogController);

	/**
	 * Écran 6 — donner un accès LQO à une personne de la liste.
	 *
	 * Deux places proposées, PrAQ et Équipe. La place de titulaire n'y figure pas : elle ne se
	 * donne pas, elle se CÈDE (écran 7), et le back refuse `TITULAIRE` en 400.
	 *
	 * ⚠️ DONNER UNE PLACE OCCUPÉE LA RETIRE À SON OCCUPANT. L'écran doit l'avoir dit AVANT la
	 * confirmation, pas après : le bandeau nomme l'occupant, et le bouton devient « Transférer
	 * l'accès ». L'occupant vient de `acces`, servi avec la liste par le back.
	 */
	/** @ngInject */
	function OfficineAssignationDialogController($scope, $mdDialog, OfficineService, personne, acces, fiche) {

		function nomPropre(ligne) {
			return [ligne.prenom, ligne.nom].filter(function (morceau) {
				return morceau && String(morceau).trim();
			}).join(' ');
		}

		function nomDe(ligne) {
			if (!ligne) {
				return '';
			}
			return nomPropre(ligne) || ligne.mail || 'une personne sans nom';
		}

		$scope.personne = personne;
		$scope.fiche = fiche;
		$scope.nomPersonne = nomDe(personne);
		$scope.nomDe = nomDe;
		// Sans nom, la personne est déjà désignée par son courriel : on ne le répète pas.
		$scope.aUnNom = !!nomPropre(personne || {});
		$scope.titulaire = (acces && acces.TITULAIRE) || null;
		$scope.places = [
			{ slot: 'PRAQ', libelle: 'Responsable Qualité', description: 'Pharmacien Responsable Qualité', occupant: (acces && acces.PRAQ) || null },
			{ slot: 'EQUIPE', libelle: 'Équipe', description: 'Collaborateur', occupant: (acces && acces.EQUIPE) || null }
		];
		$scope.choix = { slot: null };
		$scope.envoi = false;
		$scope.erreur = null;

		$scope.placeChoisie = function () {
			var choisie = null;
			angular.forEach($scope.places, function (place) {
				if (place.slot === $scope.choix.slot) {
					choisie = place;
				}
			});
			return choisie;
		};

		$scope.choisir = function (place) {
			$scope.choix.slot = place.slot;
			$scope.erreur = null;
		};

		$scope.libelleBouton = function () {
			var place = $scope.placeChoisie();
			if (!place) {
				return "Donner l'accès";
			}
			return place.occupant ? "Transférer l'accès" : "Donner l'accès " + place.libelle;
		};

		$scope.valider = function () {
			var place = $scope.placeChoisie();
			if (!place || $scope.envoi) {
				return;
			}
			$scope.envoi = true;
			$scope.erreur = null;
			OfficineService.donnerAcces(personne.contactId, place.slot).then(function (reponse) {
				var message = 'Accès ' + place.libelle + ' donné à ' + $scope.nomPersonne + '.';
				if (reponse && reponse.compteCree) {
					// Le courriel est DÉPOSÉ dans la file d'envoi de LQO : on ne promet pas qu'il est reçu.
					message += ' Une invitation lui est envoyée.';
				}
				$mdDialog.hide(message);
			}).catch(function (erreur) {
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineContactPhsqController', OfficineContactPhsqController);

	/**
	 * Sous-page « Contacter PHSQ » (`app.officine.contact`) : le courriel et le téléphone de PHSQ.
	 *
	 * Servis par LQO lui-même (`/espace-officine/contact-phsq`), ils restent lisibles CRM éteint :
	 * l'écran ne lit pas la fiche, pour ne pas tomber avec elle.
	 */
	/** @ngInject */
	function OfficineContactPhsqController($scope, OfficineEcran, OfficineService) {

		$scope.titreErreur = "Les coordonnées de PHSQ n'ont pas pu s'afficher";

		var ecran = OfficineEcran.equiper($scope, function () {
			return OfficineService.contactPhsq().then(function (contact) {
				$scope.contact = contact && (contact.mail || contact.tel) ? contact : null;
			});
		}, { contact: false });

		/** « 04 78 00 00 00 » → « 0478000000 » : un lien `tel:` ne veut que des chiffres (et le +). */
		$scope.telephoneComposable = function () {
			return String(($scope.contact && $scope.contact.tel) || '').replace(/[^\d+]/g, '');
		};

		ecran.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('OfficineAccesController', OfficineAccesController);

	/**
	 * Sous-page « Accès LQO » (`app.officine.acces`) : les trois places de l'officine — Titulaire,
	 * PrAQ, Équipe — et leur occupant, les personnes de la liste à qui donner un accès, et les comptes
	 * LQO qu'aucune personne ne réclame.
	 *
	 * Les gestes et leurs dialogues sont ceux d'avant (contacts/) : donner un accès (la place occupée
	 * est nommée avant de confirmer), renvoyer l'invitation, céder le titre, corriger une personne.
	 */
	/** @ngInject */
	function OfficineAccesController($scope, $q, OfficineEcran, OfficineService) {

		$scope.fiche = null;
		$scope.titreErreur = "Les accès LQO de l'officine n'ont pas pu s'afficher";

		var ecran = OfficineEcran.equiper($scope, function () {
			return $q.all([OfficineService.fiche(), OfficineService.personnes()]).then(function (reponses) {
				$scope.fiche = reponses[0];
				$scope.poserPersonnes(reponses[1]);
			});
		});
		OfficineEcran.equiperPersonnes($scope);

		ecran.demarrer();
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('UpdateMalfunctionController', UpdateMalfunctionController);

  function UpdateMalfunctionController($scope, $state, $timeout, $mdDialog, $window, toastr, MalfunctionService, EquipeDetailService, EvaluationFournisseursService, PRIORITIES_MALFUNCTION, TYPES_SUPPLIER, TYPES_DESPENSATION, DISPENSATION_ERRORS, DISPENSATION_DATES, EVAL_FOURNISSEURS_TYPES, ECOR_DOMAINS) {
    $scope.priorities = PRIORITIES_MALFUNCTION;
    $scope.supplierTypes = TYPES_SUPPLIER;
    $scope.dispensationTypes = TYPES_DESPENSATION;
    $scope.dispensationErrors = DISPENSATION_ERRORS;
    $scope.dispensationDates = DISPENSATION_DATES;
    $scope.ecorDomains = []
    for (var i = 0; i < Object.keys(ECOR_DOMAINS).length; i++) {
      $scope.ecorDomains.push({ libelle: ECOR_DOMAINS[Object.keys(ECOR_DOMAINS)[i]], value: Object.keys(ECOR_DOMAINS)[i] })
    }
    $scope.isFirstWatch = true;
    $scope.typeToEdit = {};
    $scope.typeToAdd = {};
    $scope.filter = {
      criteria: {
        laboratory: false,
        serviceProvider: false,
        recentlyEvaluated: false,
        notEvaluatedSinceOneYear: false,
        withMalfunctions: false,
        withoutMalfunction: false
      },
      order: {
        name: true,
        evalDate: false
      }
    };
    MalfunctionService.find($state.params.id).then(function (response) {
      $scope.malfunction = response.data;
      $scope.malfunction.creation = new Date($scope.malfunction.creation)
      $scope.malfunctionCopy = angular.copy($scope.malfunction);
      if ($scope.malfunction.supplier) {
        EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (data) {
          $scope.suppliers = data;
        }).catch(function () {
          console.error('Error getFournisseurs()');
        });
      }
    }).catch(function () {
      $state.go('app.malfunctions');
    });

    MalfunctionService.listTypes().then(function (response) {
      $scope.types = response.data;
    }).catch(function () {
      $state.go('app.malfunctions');
    });

    EquipeDetailService.getCollaborateurs().then(function (response) {
      $scope.collaborateurs = response;
    }).catch(function () {
      toastr.error('Veuillez créer des collaborateurs avant d\'ajouter un dysfonctionnement');
    });


    $scope.$watch('malfunction.supplier.type', function (event) {


      if (event) {
        $scope.loading = true;
        if (!$scope.isFirstWatch) {
          $scope.malfunction.supplier = {
            type: event
          };
        } else {
          $scope.isFirstWatch = false;
        }
        if (event == 'LAB') {
          $scope.filter.criteria.laboratory = true;
          $scope.filter.criteria.serviceProvider = false;
        }
        else {
          $scope.filter.criteria.laboratory = false;
          $scope.filter.criteria.serviceProvider = true;
        }

        EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (data) {
          $scope.suppliers = data;
          $scope.loading = false;
          $scope.suppliersLoaded = true;

        }).catch(function () {
          console.error('Error getFournisseurs()');
        });
      }

    });

    $scope.updateMalfunction = function () {
      var fmData = new FormData();
      if ($scope.malfunction.documents != null) {
        for (var i = 0; i < $scope.malfunction.documents.length; i++) {
          var document = $scope.malfunction.documents[i]
          if (document.file != null) {
            fmData.append('files', document.file, document.attachmentOriginalName)
            delete document.file
          }
        }
      }
      if ($scope.malfunction.personIssued === undefined) {
        $scope.malfunction.personIssued = {};
      }
      var malfunction = angular.copy($scope.malfunction)
      malfunction.creation = malfunction.creation.getTime()
      fmData.append('dto', angular.toJson(malfunction));
      MalfunctionService.update(fmData).then(function () {
        $state.go('app.malfunctions');
      }).catch(function () {
        toastr.error('Erreur lors de la sauvegarde, veuillez réessayer plus tard');
      });
    };

    $scope.dialogSave = function (prestataire) {
      $scope.prestataire = prestataire;
      $scope.fournisseur = {
        name: null,
        type: null,
        contactName: null,
        contactPhone: null,
        comment: null
      };
      $scope.titlePopupSave = 'Ajouter un fournisseur';

      // $scope.typesFournisseur = EvaluationFournisseursService.getTypesFournisseur();
      $scope.typesFournisseur = EVAL_FOURNISSEURS_TYPES;

      $scope.fournisseurPopup = $mdDialog.show({
        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/add_fournisseur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.saveFournisseur = function () {
      EvaluationFournisseursService.saveFournisseur($scope.fournisseur).then(function (data) {
        $scope.hidePopup();
        $scope.fournisseur.id = data.data;
        var fournisseur = angular.copy($scope.fournisseur);
        $scope.loading = true;
        EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (res) {
          $scope.suppliers = res;
          $scope.loading = false;
          $scope.suppliersLoaded = true;

          $scope.suppliers.forEach(function (element) {
            if (element.id === fournisseur.id) {
              $scope.malfunction.supplier = element;
            }
          });

        }).catch(function () {
          console.error('Error getFournisseurs()');
          $scope.loading = false;
        });
      }).catch(function (response) {
        if (response.status === 409) {
          toastr.error('Un fournisseur avec le même nom a déjà été renseigné');
        } else {
          toastr.error('Une erreur s\'est produite! Impossible de sauvegarder le fournisseur');
        }
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.cancelUpdate = function () {
      $state.go('app.malfunctions');
    };

    $scope.openModalCreateType = function () {
      $scope.typeToAdd = {};
      $scope.typePopup = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/add/add_type.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.saveType = function () {
      if ($scope.loadingType) {
        return;
      }
      if ($scope.typeToAdd && $scope.typeToAdd.name && $scope.typeToAdd.name.length > 0 && $scope.typeToAdd.name.trim() !== ' ') {
        $scope.loadingType = true;
        MalfunctionService.saveType($scope.typeToAdd).then(function (res) {
          $scope.typeToAdd = {};
          toastr.success('Type ajouté avec succès');
          $scope.idType = res.data;
          MalfunctionService.listTypes().then(function (response) {
            $scope.types = response.data;
            $scope.loadingType = false;
            $scope.malfunction.type = $scope.types.filter(function (typ) {
              return typ.id === parseInt($scope.idType);
            })[0];
          });
        }).catch(function (response) {
          if (response.status === 406) {
            toastr.error('Cet intitulé existe déjà!');
          } else {
            toastr.error('Erreur pendant la sauvegarde du type');
          }
          $scope.loadingType = false;
        });
      }
    };

    $scope.closeModalType = function () {
      $mdDialog.hide();
      $scope.typeToAdd = {};
      $scope.typeToEdit = {};
    };

    $scope.openDeleteType = function (event, id) {
      event.stopPropagation();
      $scope.typeToDelete = id;
      MalfunctionService.countByType(id).then(function (data) {
        $scope.countType = parseInt(data.data);
        if ($scope.countType > 0) {
          $scope.replacementType = angular.copy($scope.types);
          $scope.replacementType = $scope.replacementType.filter(function (type) {
            return type.id !== $scope.typeToDelete;
          });
        }
        $scope.typePopupConfirm = $mdDialog.show({
          templateUrl: 'app/main/front/malfunctions/popup/confirm_delete_type.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true,
          multiple: true
        });
      }).catch(function (err) {

      });

    };



    $scope.openEditType = function (type) {
      if (!type.pharmacy) {
        return;
      }
      $scope.typeToEdit.name = type.name;
      $scope.typeToEdit.id = type.id;
      $scope.typePopupEdit = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/popup/edit_type.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        multiple: true
      });
    };

    $scope.deleteType = function (id) {
      $scope.loadingType = true;
      MalfunctionService.deleteType(id).then(function () {
        if ($scope.malfunctionCopy.type.id === id) {
          $scope.malfunction.type = $scope.types.filter(function (type) {
            return type.index === 1;
          })[0];
        }
        $scope.hidePopup();
        $scope.typeToDelete = null;
        toastr.success('Type supprimé avec succès');
        MalfunctionService.listTypes().then(function (response) {
          $scope.types = response.data;
          $scope.loadingType = false;
        });
      }).catch(function () {

        toastr.error('Erreur pendant la suppression du type');

        $scope.loadingType = false;
      });
    };

    $scope.editType = function () {
      if ($scope.typeToEdit && $scope.typeToEdit.name && $scope.typeToEdit.name.length > 0 && $scope.typeToEdit.name.trim() !== ' ') {

        MalfunctionService.saveType($scope.typeToEdit).then(function () {
          $scope.loadingType = true;
          $scope.typeToEdit = {};
          $mdDialog.hide();
          toastr.success('Type modifié avec succès');
          MalfunctionService.listTypes().then(function (response) {
            $scope.types = response.data;
            $scope.loadingType = false;
          });
        }).catch(function (response) {
          if (response.status === 406) {
            toastr.error('Cet intitulé existe déjà!');
          } else {
            toastr.error('Erreur pendant la sauvegarde du type');
          }
          $scope.loadingType = false;
        });
      }
    };

    $scope.changeCollab = function (idSelected) {
      $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
      if (!idSelected) {
        $scope.collaborateur = {
          name: null,
          surname: null,
          id: null,
          fichePoste: {}
        };

        $scope.titlePopupSave = 'Ajouter un collaborateur';
        $scope.updateMode = false;
        $scope.descriptionMode = true;

        $scope.equipePopup = $mdDialog.show({
          templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true,
          controller: 'EquipeDetailController'
        }).then(function (data) {
          $scope.malfunction.collaborateur.id = data || $scope.idSelected;
        }).catch(function (error) {
          $scope.malfunction.collaborateur.id = null;
        });
        return;
      }
    };

    $scope.changePerson = function (idSelected) {
      $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
      if (!idSelected) {
        $scope.collaborateur = {
          name: null,
          surname: null,
          id: null,
          fichePoste: {}
        };

        $scope.titlePopupSave = 'Ajouter un collaborateur';
        $scope.updateMode = false;
        $scope.descriptionMode = true;

        $scope.equipePopup = $mdDialog.show({
          templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true,
          controller: 'EquipeDetailController'
        }).then(function (data) {
          $scope.malfunction.personIssued.id = data || $scope.idSelected;
        }).catch(function (error) {
          $scope.malfunction.personIssued.id = null;
        });
        return;
      }
    };

    $scope.$on('fileUploaded', function () {
      var form = document.querySelector('form[name="updateMalfunctionForm"]');
      var fileinput = form.querySelector('#document_input_file');
      $scope.malfunction.nameOfDocument = "";
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        $scope.malfunction.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.openJoindreFile = function () {
      $('#update_file').off('change')
      $('#update_file').on('change', function (evt) {
        if (evt.target.files.length > 0) {
          var reader = new FileReader();
          reader.onload = function (e) {
            if ($scope.malfunction.documents == null) {
              $scope.malfunction.documents = []
            }
            $scope.malfunction.documents.push({
              attachmentOriginalName: evt.target.files[0].name,
              file: new Blob([e.target.result]),
            })
            $('#update_file').val('')
            $scope.$apply()
          };
          reader.readAsArrayBuffer(evt.target.files[0]);
        }
      })
      $('#update_file').click()
    }

    $scope.deleteDocument = function (index) {
      $scope.malfunction.documents.splice(index, 1)
    }

    $scope.downloadDoc = function (id) {
      if (id != null) {
        location.href = '/api/rest/malfunction/download/document/' + id;
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('AppelMedecinsService', AppelMedecinsService);

  function AppelMedecinsService($q, $http) {
    var URL_APPELMEDECINS = "/api/rest/appelmedecins";

    var getAppels = function (searchText) {
      var params = {
        '_v': new Date().getTime()
      };
      if (searchText != null) {
        params.q = searchText;
      }
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/search",
          method: "POST",
          params: params,
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getAppelsArchived = function (searchText) {
      var params = {
        '_v': new Date().getTime()
      };
      if (searchText != null) {
        params.q = searchText;
      }
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/searchArchived",
          method: "POST",
          params: params,
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveAppel = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          data: fd
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setArchive = function (appel) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/archive",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: appel
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getArchivedByYear = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/" + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var deleteAppel = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listYears = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/years",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listMonths = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/months/" + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var hasArchived = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/hasArchived",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listArchived = function (property, start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/archived",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'property': property,
            'start': start,
            'end': end
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var addComment = function (id, dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/" + id + "/comment",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadXlsx = function (start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_APPELMEDECINS + "/export",
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'start': start,
            'end': end
          },
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', 'appelsMedecins.xlsx');
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject();
        });
      });
    };

    return {
      saveAppel: saveAppel,
      getAppels: getAppels,
      getAppelsArchived: getAppelsArchived,
      deleteAppel: deleteAppel,
      setArchive: setArchive,
      getArchivedByYear: getArchivedByYear,
      listYears: listYears,
      listMonths: listMonths,
      hasArchived: hasArchived,
      listArchived: listArchived,
      findById: findById,
      addComment: addComment,
      downloadXlsx: downloadXlsx
    };
  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AppelMedecinsController', AppelMedecinsController);

  function AppelMedecinsController($scope, $state, $timeout, $mdDialog, EquipeDetailService, AppelMedecinsService, toastr) {
    $scope.appel = {
      nomMedecin: null,
      nomPatient: null,
      appelant: null,
      sujet: null,
      id: null
    };
    $scope.searchTxt = '';
    $scope.appels = [];
    $scope.appelsArchived = [];
    $scope.updateMode = false;
    $scope.archive = { value: 'all' };
    $scope.archiveMonth = { value: 'all', index: 0 };
    $scope.archiveYear = (new Date()).getFullYear();
    $scope.archiveEmpty = true;
    $scope._baseResource = "/api/rest/appelmedecins";
    $scope.intoSaving = false;
    $scope.searching = false;

    $scope.months = [];

    $scope.tabs = {
      active: true,
      archive: false
    };

    $scope.searchArchives = function (type) {
      $scope.type = type;
      $scope.appelsArchived = [];
      if (type === 'YEAR') {
        var date = $scope.initStartEnd('YEAR');
        //When loading the page
        AppelMedecinsService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
          if ($scope.archive.value === 'all') {
            $scope.appelsArchived = $scope.sortByRecent(response.data, 'creationDate');
            $scope.months = [];
          }
          else if (response.data.length > 10) {
            AppelMedecinsService.listMonths($scope.archive.value).then(function (months) {
              $scope.appelsArchived = $scope.sortByRecent(response.data, 'creationDate');
              $scope.months = months.data;
            }).catch(function () {
              toastr.error('Impossible de récupérer les dysfonctionnements');
              $scope.months = [];
            })
          } else {
            $scope.appelsArchived = $scope.sortByRecent(response.data, 'creationDate');
            $scope.months = [];
          }

        }).catch(function () {
          toastr.error('Impossible de récupérer les dysfonctionnements');
          $scope.appelsArchived = [];
        });
      }
      else if (type === 'MONTH') {
        if ($scope.archiveMonth.value === 'all') {
          date = $scope.initStartEnd('YEAR');
          AppelMedecinsService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
            $scope.appelsArchived = $scope.sortByRecent(response.data, 'creationDate');
          }).catch(function () {
            toastr.error('Impossible de récupérer les dysfonctionnements');
          })
        }
        else {
          date = $scope.initStartEnd('MONTH');
          AppelMedecinsService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
            $scope.appelsArchived = $scope.sortByRecent(response.data, 'creationDate');
          })
        }
      }
    };

    $scope.initStartEnd = function (type) {
      var today = new Date();
      var start = new Date(today.getFullYear(), 0, 1).getTime();
      var end = new Date(today.getFullYear(), 11, 31).getTime();
      if (!isNaN($scope.archive.value) && type === 'YEAR') {
        var year = parseInt($scope.archive.value);
        start = new Date(year, 0, 1).getTime();
        end = new Date(year, 11, 31).getTime();
      }
      else if (type === 'MONTH') {
        var month = $scope.archiveMonth.index;
        if ($scope.archiveMonth.value === 'all') {
          return 'all';
        }
        year = parseInt($scope.archive.value);
        start = new Date(year, month, 1).getTime();
        end = new Date(year, month, 31).getTime();
      }
      return { start: start, end: end };
    }

    $scope.sortByRecent = function (tab, property) {
      return tab.sort(function (elem1, elem2) {
        return elem2[property] - elem1[property];
      });
    }

    $scope.refresh = function () {
      AppelMedecinsService.listYears().then(function (response) {
        $scope.years = [];
        if (response.data.length === 2) {
          var minYear = new Date(response.data[0].value).getFullYear();
          var maxYear = new Date(response.data[1].value).getFullYear();
          var i = maxYear;
          while (i >= minYear && i <= maxYear) {
            $scope.years.push({
              value: i
            });
            i--;
          }
        } else if (response.data.length === 1) {
          $scope.years.push({
            value: new Date(response.data[0].value).getFullYear()
          });
        } else {

        }
      }).catch(function () {
        $state.go('app.home');
      });

      AppelMedecinsService.getAppels().then(function (data) {
        $scope.appels = $scope.sortByRecent(data, 'creationDate');
      }).catch(function (err) {
        console.log("Error getAppels()");
      });

      AppelMedecinsService.hasArchived().then(function (response) {
        $scope.archiveEmpty = response.data === false ? true : false;
        if (!$scope.archiveEmpty) {
          $scope.searchArchives($scope.type);
        }
      }).catch(function () {
        $scope.archiveEmpty = true;
      })
    };
    $scope.refresh();
    $scope.searchArchives('YEAR');

    function initAppel() {
      $scope.appel = {};
      $scope.comment = {};
    }

    $scope.openAppelPopup = function (appel, commentMode) {
      console.log(appel);
      $scope.comment = {};
      $scope.addCommentMode = !!commentMode;
      AppelMedecinsService.findById(appel.id).then(function (res) {
        $scope.appel = res.data;

        $scope.appelPopup = $mdDialog.show({
          templateUrl: 'app/main/front/malfunctions/appel-medecins/popup/appel_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          initAppel();
        }).catch(function () {
          initAppel();
        });
      }).catch(function (error) {
        console.log(error);
      });
    };

    EquipeDetailService.getCollaborateurs().then(function (response) {
      $scope.collaborateurs = response;
    }).catch(function () {
      toastr.error('Veuillez créer des collaborateurs avant d\'ajouter un dysfonctionnement');
    });

    $scope.openExport = function () {
      $scope.exportDates = {}
      $scope.expPopup = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/appel-medecins/popup/export.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: AppelMedecinsController,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.export = function () {
      if ($scope.loadingExport) {
        return;
      }
      $scope.loadingExport = true;
      AppelMedecinsService.downloadXlsx($scope.exportDates.startDate.getTime(), $scope.exportDates.endDate.getTime()).then(function () {
        $scope.loadingExport = false;
        $mdDialog.hide();
      }).catch(function () {
        $scope.loadingExport = false;
        toastr.error('Une erreur est survenue.');
      });

    };

    $scope.search = function () {
      if ($scope.searchTxt.length > 0) {
        $scope.searching = true;
        AppelMedecinsService.getAppels($scope.searchTxt).then(function (data) {
          $scope.appelsSearch = $scope.sortByRecent(data, 'creationDate');
          $scope.filterArchived();
        }).catch(function (err) {
          console.log("Error getAppels()");
        });
      } else {
        $scope.searching = false;
      }
    };

    $scope.filterArchived = function () {
      AppelMedecinsService.getAppelsArchived($scope.searchTxt).then(function (data) {
        $scope.appelsArchivedSearch = $scope.sortByRecent(data, 'creationDate');
      }).catch(function (err) {
        console.log("Error getAppelsArchived()");
      });
    };


    $scope.signalerAppelPopup = function (updateMode, appel) {
      $scope.updateMode = updateMode;
      if (updateMode) {
        $scope.appel = appel;
      } else {
        $scope.appel = {
          nomMedecin: null,
          nomPatient: null,
          appelant: null,
          sujet: null,
          id: null
        };
      }

      $scope.signalerAppelPopupVar = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/appel-medecins/popup/add_appel.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.addCollaborateur = function () {
      $scope.addAppelantMode = !$scope.addAppelantMode;
      $scope.appel.appelant = {};
    };

    $scope.setArchived = function (appel) {
      var appelSend = {
        id: appel.id,
        archived: appel.archived
      };

      AppelMedecinsService.setArchive(angular.copy(angular.toJson(appelSend))).then(function (res) {
        $scope.refresh();
        if (!appel.archived) {
          toastr.success('Désarchivé avec succès. Cet appel médecin sera à nouveau archivé dans 30 jours');
        }
      }).catch(function (err) {
        console.log("Error on setArchived()");
      });
    };

    $scope.saveAppel = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;
        var input = document.getElementById('document_input_file');
        var file = null;
        if (input != null) {
          file = input.files[0];
        }
        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.appel));
        AppelMedecinsService.saveAppel(fd).then(function (data) {
          $scope.appel = data;
          if ($scope.updateMode) {
            for (var i = 0; i < $scope.appels.length; i++) {
              if ($scope.appels[i].id == data) {
                this.appels[i] = $scope.appel;
                break;
              }
            }
          } else {
            $scope.appels.unshift($scope.appel);
          }

          $scope.hidePopup();
          toastr.success("Appel signalé avec succès");
          $timeout(function () {
            $scope.intoSaving = false;
          });
        }).catch(function (err) {
          $scope.intoSaving = false;
          toastr.error("Erreur lors du signalement de l'appel");
          console.log("error addAppel()");
        });
      }

    };

    $scope.download = function (id) {
      location.href = $scope._baseResource + '/download/' + id;
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.addAppelant = function () {
      $scope.addAppelantMode = !$scope.addAppelantMode;
      $scope.appel.appelant = {};
    };

    $scope.showAddComment = function () {
      $scope.addCommentMode = true;
      $timeout(function () {
        document.querySelector('#add_comment_input').scrollIntoView(true);
      });
    };

    $scope.cancelAddComment = function () {
      $scope.addCommentMode = false;
      $scope.comment = {};
    };

    $scope.addComment = function () {
      AppelMedecinsService.addComment($scope.appel.id, $scope.comment).then(function (res) {
        $scope.appel.comments.push(res.data);
        $scope.addCommentMode = false;
        $scope.comment = {};
        if ($scope.addCommentForm) {
          $scope.addCommentForm.$setPristine();
          $scope.addCommentForm.$setUntouched();
        }
      }).catch(function () {
        toastr.error('Une erreur est survenue');
      })
    };

    $scope.changeCollab = function (idSelected) {
      $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
      if (!idSelected) {
        $scope.collaborateur = {
          name: null,
          surname: null,
          id: null,
          fichePoste: {}
        };

        $scope.titlePopupSave = 'Ajouter un collaborateur';
        $scope.updateMode = false;
        $scope.descriptionMode = true;

        $scope.equipePopup = $mdDialog.show({
          templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true,
          multiple: true,
          controller: 'EquipeDetailController'
        }).then(function (data) {
          $scope.appel.appelant.id = data || $scope.idSelected;
        }).catch(function (error) {
          $scope.appel.appelant.id = null;
        });
        return;
      }
    };

    $scope.$on('fileUploaded', function () {
      var fileinput = document.getElementById("document_input_file");
      $scope.appel.nameOfDocument = "";
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        $scope.appel.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.clearInputFile = function (input, id_input) {
      var elem = document.getElementById(id_input);
      elem.value = "";
      input.nameOfDocument = ""
      input.attachmentOriginalName = null
    };

    $scope.cancelSearch = function () {
      $scope.searching = false;
      $scope.searchTxt = '';
    };

    $scope.switchTab = function (tab) {
      $scope.cancelSearch()
      var tabs = Object.keys($scope.tabs)
      for (var i = 0; i < tabs.length; i++) {
        $scope.tabs[tabs[i]] = false;
      }
      $scope.tabs[tab] = true;
      if ($scope.tabs.archive && $scope.appelsArchived.length === 0) {
        $scope.archive.value = 'all'
        $scope.months.length = 0
      }
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('AddMalfunctionController', AddMalfunctionController);

	function AddMalfunctionController($scope, $rootScope, $state, toastr, MalfunctionService, EquipeDetailService, EVAL_FOURNISSEURS_TYPES, PRIORITIES_MALFUNCTION, TYPES_SUPPLIER, TYPES_DESPENSATION, DISPENSATION_ERRORS, DISPENSATION_DATES, ECOR_DOMAINS, EvaluationFournisseursService, $mdDialog, $timeout) {
		var previousState;
		$scope.loading = false;

		if ($rootScope.fromHome) {
			$scope.fromHome = true;
			$rootScope.fromHome = false;
			$scope.backRoute = '././home/home';
			previousState = 'app.home';
		} else {
			$scope.fromHome = false;
			$scope.backRoute = './dysfonctionnements';
			previousState = 'app.malfunctions';
		}

		$scope.today = new Date()

		$scope.priorities = PRIORITIES_MALFUNCTION;
		$scope.supplierTypes = TYPES_SUPPLIER;
		$scope.dispensationTypes = TYPES_DESPENSATION;
		$scope.dispensationErrors = DISPENSATION_ERRORS;
		$scope.dispensationDates = DISPENSATION_DATES;
		$scope.ecorDomains = []
		for (var i = 0; i < Object.keys(ECOR_DOMAINS).length; i++) {
			$scope.ecorDomains.push({ libelle: ECOR_DOMAINS[Object.keys(ECOR_DOMAINS)[i]], value: Object.keys(ECOR_DOMAINS)[i] })
		}
		$scope.malfunction = {
			supplier: {
				type: null
			},
			priority: $scope.priorities.NORMAL,
			dispensation: {},
			creation: new Date()
		};
		$scope.suppliers = [];
		$scope.suppliersLoaded = false;
		$scope.addCollaborateurMode = false;
		$scope.addPersonIssuedMode = false;
		$scope.typeToEdit = {};
		$scope.typeToAdd = {};
		$scope.filter = {
			criteria: {
				laboratory: false,
				serviceProvider: false,
				recentlyEvaluated: false,
				notEvaluatedSinceOneYear: false,
				withMalfunctions: false,
				withoutMalfunction: false
			},
			order: {
				name: true,
				evalDate: false
			}
		};
		$scope.document = {};
		$scope.document.nameOfDocument = "";
		MalfunctionService.listTypes().then(function (response) {
			$scope.types = response.data;
		}).catch(function () {
			$state.go('app.malfunctions');
		});

		EquipeDetailService.getCollaborateurs().then(function (response) {
			$scope.collaborateurs = response;
		}).catch(function () {
			toastr.error('Veuillez créer des collaborateurs avant d\'ajouter un dysfonctionnement');
		});

		$scope.addMalfunction = function () {
			$scope.loading = true;
			var btn = document.getElementById('btnSaveMalfunction');
			if (!btn.disabled) {
				var fmData = new FormData();
				if ($scope.malfunction.documents != null) {
					for (var i = 0; i < $scope.malfunction.documents.length; i++) {
						var doc = $scope.malfunction.documents[i]
						if (doc.file != null) {
							fmData.append('files', doc.file, doc.attachmentOriginalName)
							delete doc.file
						}
					}
				}
				var malfunction = angular.copy($scope.malfunction)
				malfunction.creation = malfunction.creation.getTime()
				fmData.append('dto', angular.toJson(malfunction));
				btn.disabled = true;
				MalfunctionService.save(fmData).then(function () {
					$scope.loading = false;
					$rootScope.$broadcast('refreshCountNotifs');
					$state.go('app.malfunctions');
				}).catch(function () {
					$scope.loading = false;
					toastr.error('Erreur lors de la sauvegarde, veuillez réessayer plus tard');
					btn.disabled = false;
				});
			}

		};

		$scope.$watch('malfunction.supplier.type', function (event) {


			if (event) {
				$scope.loading = true;

				$scope.malfunction.supplier = {
					type: event
				};

				if (event == 'LAB') {
					$scope.filter.criteria.laboratory = true;
					$scope.filter.criteria.serviceProvider = false;
				}
				else {
					$scope.filter.criteria.laboratory = false;
					$scope.filter.criteria.serviceProvider = true;
				}

				EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (data) {
					$scope.suppliers = data;
					$scope.loading = false;
					$scope.suppliersLoaded = true;
				}).catch(function () {
					console.log('Error getFournisseurs()');
				});
			}

		});

		$scope.dialogSave = function (type) {
			$scope.prestataire = type;
			$scope.fournisseur = {
				name: null,
				type: null,
				contactName: null,
				contactPhone: null,
				comment: null
			};
			$scope.titlePopupSave = 'Ajouter un fournisseur';

			$scope.typesFournisseur = EVAL_FOURNISSEURS_TYPES;


			$scope.fournisseurPopup = $mdDialog.show({
				templateUrl: 'app/main/front/performances/evaluation-fournisseurs/popup/add_fournisseur_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			});
		};

		$scope.openModalCreateType = function () {
			$scope.typeToAdd = {};
			$scope.typePopup = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/add/add_type.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			});
		};

		$scope.closeModalType = function () {
			$scope.clicked = true;
			if ($scope.typeToAdd && $scope.typeToAdd.name && $scope.typeToAdd.name.length > 0 && $scope.typeToAdd.name.trim() !== ' ') {
				$scope.loadingType = true;
				MalfunctionService.saveType($scope.typeToAdd).then(function (res) {
					$scope.typeToAdd = {};
					toastr.success('Type ajouté avec succès');
					$scope.idType = res.data;
					MalfunctionService.listTypes().then(function (response) {
						$scope.types = response.data;
						$scope.loadingType = false;
						$scope.malfunction.type = $scope.types.filter(function (typ) {
							return typ.id === parseInt($scope.idType);
						})[0];
						console.log($scope.malfunction);
						$mdDialog.hide();
						$scope.typeToAdd = {};
						$scope.typeToEdit = {};
					});
				}).catch(function (response) {
					if (response.status === 406) {
						toastr.error('Cet intitulé existe déjà!');
					} else {
						toastr.error('Erreur pendant la sauvegarde du type');
					}
					$scope.loadingType = false;
				});
			} else {
				$mdDialog.hide();
				$scope.typeToAdd = {};
				$scope.typeToEdit = {};
			}
		};

		$scope.closeModal = function () {
			$mdDialog.hide();
			$scope.typeToAdd = {};
			$scope.typeToEdit = {};
		};

		$scope.saveType = function () {
			$scope.clicked = false;
			$timeout(function () {
				if ($scope.clicked || $scope.loadingType) {
					return;
				}
				if ($scope.typeToAdd && $scope.typeToAdd.name && $scope.typeToAdd.name.length > 0 && $scope.typeToAdd.name.trim() !== ' ') {
					$scope.loadingType = true;
					MalfunctionService.saveType($scope.typeToAdd).then(function (res) {
						$scope.typeToAdd = {};
						toastr.success('Type ajouté avec succès');
						$scope.idType = res.data;
						MalfunctionService.listTypes().then(function (response) {
							$scope.types = response.data;
							$scope.loadingType = false;
							$scope.malfunction.type = $scope.types.filter(function (typ) {
								return typ.id === parseInt($scope.idType);
							})[0];
							console.log($scope.malfunction);
						});
					}).catch(function (response) {
						if (response.status === 406) {
							toastr.error('Cet intitulé existe déjà!');
						} else {
							toastr.error('Erreur pendant la sauvegarde du type');
						}
						$scope.loadingType = false;
					});
				}
			}, 100);

		};

		$scope.editType = function () {
			if ($scope.typeToEdit && $scope.typeToEdit.name && $scope.typeToEdit.name.length > 0 && $scope.typeToEdit.name.trim() !== ' ') {

				MalfunctionService.saveType($scope.typeToEdit).then(function () {
					$scope.loadingType = true;
					$scope.typeToEdit = {};
					$mdDialog.hide();
					toastr.success('Type modifié avec succès');
					MalfunctionService.listTypes().then(function (response) {
						$scope.types = response.data;
						if ($scope.idType) {
							$scope.malfunction.type = $scope.types.filter(function (typ) {
								return typ.id === parseInt($scope.idType);
							})[0];
						}
						$scope.loadingType = false;
					});
				}).catch(function (response) {
					if (response.status === 406) {
						toastr.error('Cet intitulé existe déjà!');
					} else {
						toastr.error('Erreur pendant la sauvegarde du type');
					}
					$scope.loadingType = false;
				});
			}
		};

		$scope.openDeleteType = function (event, id) {
			event.stopPropagation();
			$scope.typeToDelete = id;
			MalfunctionService.countByType(id).then(function (data) {
				$scope.countType = parseInt(data.data);
				if ($scope.countType > 0) {
					$scope.replacementType = angular.copy($scope.types);
					$scope.replacementType = $scope.replacementType.filter(function (type) {
						return type.id !== $scope.typeToDelete;
					});
				}
				$scope.typePopupConfirm = $mdDialog.show({
					templateUrl: 'app/main/front/malfunctions/popup/confirm_delete_type.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					multiple: true
				});
			}).catch(function (err) {

			});

		};

		$scope.openEditType = function (type) {
			if (!type.pharmacy) {
				return;
			}
			$scope.typeToEdit.name = type.name;
			$scope.typeToEdit.id = type.id;
			$scope.typePopupEdit = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/popup/edit_type.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true,
				multiple: true
			});
		};

		$scope.deleteType = function (id) {
			$scope.loadingType = true;
			MalfunctionService.deleteType(id).then(function () {
				$scope.hidePopup();
				$scope.typeToDelete = null;
				toastr.success('Type supprimé avec succès');
				MalfunctionService.listTypes().then(function (response) {
					$scope.types = response.data;
					$scope.loadingType = false;
				});
			}).catch(function () {

				toastr.error('Erreur pendant la suppression du type');

				$scope.loadingType = false;
			});
		};


		$scope.saveFournisseur = function () {
			EvaluationFournisseursService.saveFournisseur($scope.fournisseur).then(function (data) {
				$scope.hidePopup();
				$scope.fournisseur.id = data.data;
				var fournisseur = angular.copy($scope.fournisseur);
				$scope.loading = true;
				EvaluationFournisseursService.getFournisseurs($scope.filter).then(function (res) {
					$scope.suppliers = res;
					$scope.loading = false;
					$scope.suppliersLoaded = true;
					$scope.malfunction.supplier = {};
					$scope.malfunction.supplier.type = $scope.fournisseur.type;
					$scope.suppliers.forEach(function (element) {
						if (element.id == fournisseur.id) {
							$scope.malfunction.supplier = angular.copy(element);
							console.log($scope.malfunction.supplier)
						}
					});

				}).catch(function () {
					console.log('Error getFournisseurs()');
					$scope.loading = false;
				});
			}).catch(function (response) {
				if (response.status === 409) {
					toastr.error('Un fournisseur avec le même nom a déjà été renseigné');
				} else {
					toastr.error('Une erreur s\'est produite! Impossible de sauvegarder le fournisseur');
				}
			});
		};

		$scope.hidePopup = function () {
			$scope.malfunction.typeReplace = null;
			$mdDialog.hide();
		};

		$scope.addCollaborateur = function () {
			$scope.addCollaborateurMode = !$scope.addCollaborateurMode;
			$scope.malfunction.collaborateur = {};
		};

		$scope.addPersonIssued = function () {
			$scope.addPersonIssuedMode = !$scope.addPersonIssuedMode;
			$scope.malfunction.personIssued = {};
		};

		$scope.goBack = function () {
			$state.go(previousState);
		};


		$scope.changeCollab = function (idSelected) {
			$scope.idSelected = idSelected ? idSelected : $scope.idSelected;
			if (!idSelected) {
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};

				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$scope.equipePopup = $mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					controller: 'EquipeDetailController'
				}).then(function (data) {
					$scope.malfunction.collaborateur.id = data || $scope.idSelected;
				}).catch(function (error) {
					$scope.malfunction.collaborateur.id = null;
				});
				return;
			}
		};

		$scope.changePerson = function (idSelected) {
			$scope.idSelected = idSelected ? idSelected : $scope.idSelected;
			if (!idSelected) {
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};

				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$scope.equipePopup = $mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					controller: 'EquipeDetailController'
				}).then(function (data) {
					$scope.malfunction.personIssued.id = data || $scope.idSelected;
				}).catch(function (error) {
					$scope.malfunction.personIssued.id = null;
				});
				return;
			}
		};

		$scope.$on('fileUploaded', function () {
			var fileinput = document.getElementById("document_input_file");
			$scope.document.nameOfDocument = "";
			for (var i = 0; i < fileinput.files.length; i++) {
				var name = fileinput.files[i].name
				$scope.document.nameOfDocument += name ? name : "Nom du fichier indisponible";
			}
		});

		$scope.openJoindreFile = function () {
			$('#add_file').off('change')
			$('#add_file').on('change', function (evt) {
				if (evt.target.files.length > 0) {
					var reader = new FileReader();
					reader.onload = function (e) {
						if ($scope.malfunction.documents == null) {
							$scope.malfunction.documents = []
						}
						$scope.malfunction.documents.push({
							attachmentOriginalName: evt.target.files[0].name,
							file: new Blob([e.target.result]),
						})
						$('#add_file').val('')
						$scope.$apply()
					};
					reader.readAsArrayBuffer(evt.target.files[0]);
				}
			})
			$('#add_file').click()
		}

		$scope.deleteDocument = function (index) {
			$scope.malfunction.documents.splice(index, 1)
		}

	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('AddFicheProgresController', AddFicheProgresController);

  function AddFicheProgresController($rootScope, $scope, $state, $mdDialog, toastr, FicheProgresService, MalfunctionService) {
    $scope.ficheProgres = {
      malfunction: {},
      type: {}
    };
    $scope.editionMode = !!$state.params.editionMode;
    $scope.types = [];
    $scope.isMalfunction = false;

    if ($state.params.ficheProgresId != null) {
      FicheProgresService.find($state.params.ficheProgresId).then(function (response) {
        var fp = response.data;

        if (!fp.type) {
          fp.type = {};
        }

        $scope.ficheProgres = fp;
        $scope.malfunction = response.data.malfunction;
      }).catch(function () {
        $state.go('app.fiches-progres', {'actionFromProgressForm' : null});
      })
    } else if ($state.params.malfunctionId) {
      $scope.isMalfunction = true;
      MalfunctionService.find($state.params.malfunctionId).then(function (response) {
        $scope.malfunction = response.data;
        $scope.ficheProgres.malfunction.id = $scope.malfunction.id;
        $scope.ficheProgres.title = $scope.malfunction.title + " " + $scope.malfunction.numProgress;
      }).catch(function (response) {
        $state.go('app.malfunctions');
      });
    }

    MalfunctionService.listTypes().then(function (response) {
			$scope.types = response.data;
		}).catch(function () {
			$state.go('app.malfunctions');
		});

    $scope.addFicheProgres = function (openTask) {
      var btn = document.getElementById("btnSaveFp");
      if(!btn.disabled){
        btn.disabled=true;
        if ($scope.editionMode) {
          FicheProgresService.update($scope.ficheProgres).then(function (response) {
            if (openTask) {
              $state.go('app.fiches-progres', {
                actionFromProgressForm: $scope.ficheProgres
              });
            } else {
              $state.go('app.fiches-progres', {
                actionFromProgressForm: null
              });
            }
            toastr.success("La fiche de progrès a été modifiée avec succès");
          }).catch(function () {
            toastr.error('Erreur lors de la sauvegarde, veuillez réessayer plus tard');
            btn.disabled=false;
          });
        } else {
          FicheProgresService.save($scope.ficheProgres).then(function (response) {
            if (openTask) {
              $state.go('app.fiches-progres', {
                actionFromProgressForm: response.data
              });
            } else {
              $state.go('app.fiches-progres', {
                actionFromProgressForm: null
              });
            }
            toastr.success("La fiche de progrès a été ajoutée avec succès");
          }).catch(function () {
            toastr.error('Erreur lors de la sauvegarde, veuillez réessayer plus tard');
            btn.disabled=false;
          });
        }
      }

    };

    $scope.cancel = function () {
      if($scope.isMalfunction){
        $state.go('app.malfunctions');
      }else{
        $state.go('app.fiches-progres'), {'actionFromProgressForm' : null};
      }
    };

    $scope.saveAndOpen = function (form) {
      form.$setSubmitted();
      $scope.addFicheProgres(true);
    };

    $scope.goBack = function() {
      $state.go('app.fiches-progres', {'actionFromProgressForm' : null});
    }

  };
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('JoindreReunionController', JoindreReunionController);

    function JoindreReunionController($rootScope, $scope, $mdDialog, $q, toastr, index, ReunionService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }

        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                ReunionService.getPagination($scope.pagination).then(function (res) {
                    var idsSelected = $scope.selected.map(function (row) { return row.id })
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        if (idsSelected.lastIndexOf(row.id) > -1) {
                            row.selected = true
                        }
                    }
                    resolve(res)
                }).catch(function () {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'REUNION', index: index })
            $mdDialog.hide()
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('JoindreFDPController', JoindreFDPController);

    function JoindreFDPController($rootScope, $scope, $mdDialog, $q, toastr, index, reunionMode, excludeIds, FicheProgresService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10,
            excludeIds: excludeIds
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }

        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                FicheProgresService.getPagination($scope.pagination).then(function (res) {
                    var idsSelected = $scope.selected.map(function (row) { return row.id })
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        if (idsSelected.lastIndexOf(row.id) > -1) {
                            row.selected = true
                        }
                    }
                    resolve(res)
                }).catch(function () {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'PROGRESS_FORM', index: index })
            $mdDialog.hide()
        }

        $scope.apercu = function (row) {
            if (reunionMode) {
                $mdDialog.show({
                    templateUrl: 'app/main/front/home/popup/apercu_popup.html',
                    parent: angular.element(document.body),
                    controller: 'ApercuController',
                    multiple: true,
                    locals: {
                        pj: {
                            type: 'PROGRESS_FORM',
                            progressForm: row
                        },
                        info: null
                    }
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('JoindreDysController', JoindreDysController);

    function JoindreDysController($rootScope, $scope, $mdDialog, $q, toastr, index, reunionMode, excludeIds, MalfunctionService) {

        $scope.pagination = {
            page: 0,
            nbrResults: 10,
            excludeIds: excludeIds
        }

        $scope.dto = {
            results: [],
            total: 0
        }

        $scope.selected = []

        $scope.checkSelected = function (element) {
            if (element.selected) {
                $scope.selected.push(angular.copy(element))
            } else {
                for (var i = $scope.selected.length - 1; i >= 0; i--) {
                    if ($scope.selected[i].id === element.id) {
                        $scope.selected.splice(i, 1)
                        break
                    }
                }
            }
        }

        $scope.findResults = function () {
            return $q(function (resolve, reject) {
                MalfunctionService.getPagination($scope.pagination).then(function (res) {
                    var idsSelected = $scope.selected.map(function (row) { return row.id })
                    for (var i = 0; i < res.data.results.length; i++) {
                        var row = res.data.results[i]
                        if (idsSelected.lastIndexOf(row.id) > -1) {
                            row.selected = true
                        }
                    }
                    resolve(res)
                }).catch(function () {
                    toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
                    reject()
                })

            })
        }
        $scope.findResults().then(function (res) {
            $scope.dto = res.data
        }).catch(function () {

        })



        $scope.previousPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page -= 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nextPage = function () {
            if ($scope.loadingPagination) {
                return
            }
            $scope.loadingPagination = true
            $scope.pagination.page += 1
            $scope.findResults().then(function (res) {
                $scope.dto = res.data
                $scope.loadingPagination = false
            }).catch(function () {
                $scope.loadingPagination = false
            })
        }

        $scope.nbPages = function () {
            if ($scope.dto == null || $scope.dto.total == null) {
                return 0
            }
            var mod = $scope.dto.total % $scope.pagination.nbrResults
            var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
            if (mod != 0) {
                res += 1
            }
            return res
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.selected, type: 'MALFUNCTION', index: index })
            $mdDialog.hide()
        }

        $scope.apercu = function (row) {
            if (reunionMode) {
                $mdDialog.show({
                    templateUrl: 'app/main/front/home/popup/apercu_popup.html',
                    parent: angular.element(document.body),
                    controller: 'ApercuController',
                    multiple: true,
                    locals: {
                        pj: {
                            type: 'MALFUNCTION',
                            malfunction: row
                        },
                        info: null
                    }
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('JoindreDocController', JoindreDocController);

    function JoindreDocController($rootScope, $scope, $mdDialog, toastr, index, excludeIds, DocumentService) {
        $scope.searching = false;
        // popup base doc
        $scope.popupDoc = {
            q: '',
            documents: []
        }

        $scope.searchDocuments = function () {
            if ($scope.popupDoc.q.length >= 1) {
                $scope.searching = true;
                DocumentService.findByPharmacyAndSearchText($scope.popupDoc.q, false, excludeIds).then(function (res) {
                    $scope.popupDoc.documents = res.data.documents;
                }).catch(function (err) {
                    console.log(err);
                    toastr.error('Erreur lors de la recherche');
                });
            } else {
                $scope.searching = false;
            }
        };


        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.addResults = function () {
            $rootScope.$broadcast('resultsadded', { selected: $scope.popupDoc.documents.filter(result => result.selected), type: 'DOC', index: index })
            $mdDialog.hide()
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('ApercuController', ApercuController);

    function ApercuController($rootScope, $scope, $mdDialog, $filter, $state, $window, $timeout, toastr, pj, info, PRIORITIES_MALFUNCTION_NAMES, TABLEAU_BORD_PERIODS, REUNION, TYPES_DESPENSATION, DISPENSATION_ERRORS, DISPENSATION_DATES, ECOR_DOMAINS, MalfunctionService, AutoEvaluationService, SatisfactionService, AuditService, TableauDeBordService, EquipeDetailService) {

        $scope.periods = TABLEAU_BORD_PERIODS;
        $scope.read = !!pj.read
        $scope.REUNION = REUNION;
        $scope.dispensationTypes = TYPES_DESPENSATION;
        $scope.dispensationErrors = DISPENSATION_ERRORS;
        $scope.dispensationDates = DISPENSATION_DATES;
        $scope.ecorDomains = ECOR_DOMAINS;
        $scope.libelles = {
            malfunctions: 'Dysfonctionnements',
            progressForms: 'Fiches de progrès',
            documents: 'Documents ajoutés',
            tasks: 'Tâches et événements planifiés',
            actions: 'Dernières actions décidées',
            indicateurs: 'Indicateurs du tableau de bord',
            evaluations: 'Mes évaluations',
            noteOdj: 'Suivi de l\'activité de l\'officine'
        }
        $scope.comment = {}

        $scope.showAddComment = function () {
            $scope.addCommentMode = true;
            $timeout(function () {
                document.querySelector('#add_comment_input').scrollIntoView(true);
            });
        };

        $scope.cancelAddComment = function () {
            $scope.addCommentMode = false;
            $scope.comment = {};
        };

        $scope.addComment = function () {
            if ($scope.comment == null || $scope.comment.text == null || $scope.comment.text.trim().length == 0) {
                $scope.noComment = true
            } else {
                $scope.noComment = false;
                MalfunctionService.addComment($scope.pj.malfunction.id, $scope.comment).then(function (res) {
                    $scope.pj.malfunction.comments.push(res.data);
                    $scope.addCommentMode = false;
                    $scope.comment = {};
                }).catch(function () {
                    toastr.errror('Une erreur est survenue');
                })
            }
        };


        var abreviateCollab = function (collab) {
            return collab.name.substr(0, 1).toUpperCase() + collab.surname.substr(0, 1).toUpperCase()
        }

        $scope.setRead = function () {
            $mdDialog.hide({ info: info })
        }

        $scope.printUsers = function (users) {
            var res = ''
            if (users != null) {
                for (var i = 0; i < users.length; i++) {
                    res += users[i].surname + ' ' + users[i].name
                    if (i < users.length - 1) {
                        res += ' / '
                    }
                }
            }
            return res
        }

        // UTILS REUNION FROM ordreDuJourController
        $scope._initRubrique = function () {
            $scope.hasOdjRubrique = false;
            $scope._rubriques = []
            var rubriquesTypesPush = []
            var rubriques = angular.copy($scope.REUNION.ORDRES_DU_JOUR.RUBRIQUES);
            var rubriquesLibelle = rubriques.map(function (rubrique) {
                return rubrique.type
            })
            angular.forEach(rubriques, function (_rItem, _rIndex) {
                _rItem.page = {
                    page: 0,
                    output: 10,
                    noMoreData: false,
                    filter: null,
                    sort: null
                };
                _rItem.elements = [];
            });
            for (var i = 0; i < $scope._thisReunion.ordreDuJour.elements.length; i++) {
                var element = $scope._thisReunion.ordreDuJour.elements[i]
                var indexOf = rubriquesLibelle.lastIndexOf(element.type)
                var mesEvalIndexOf = rubriquesLibelle.lastIndexOf('MES_EVALUATIONS')
                if (['NOTE_ODJ'].lastIndexOf(element.type) > -1) {
                    $scope.hasOdjRubrique = true
                }
                if (['AUTO_EVALUATION', 'RAPPORT_D_AUDIT', 'SATISFACTION_CLIENT', 'FLASH_QUALITE'].lastIndexOf(element.type) > -1 && mesEvalIndexOf > -1 && rubriquesTypesPush.lastIndexOf(rubriques[mesEvalIndexOf].type) === -1) {
                    $scope._rubriques.push(rubriques[mesEvalIndexOf])
                    rubriquesTypesPush.push('MES_EVALUATIONS')
                } else if (indexOf > -1 && rubriquesTypesPush.lastIndexOf(rubriques[indexOf].type) === -1) {
                    $scope._rubriques.push(rubriques[indexOf])
                    rubriquesTypesPush.push(rubriques[indexOf].type)
                }
            }
            angular.forEach($scope._rubriques, function (_rItem, _rIndex) {
                _rItem.index = _rIndex
            });
        };


        $scope.sortRubriquesEl = function () {
            for (var i = 0; i < $scope._rubriques.length; i++) {
                var rubrique = $scope._rubriques[i]
                if (['DYSFONCTIONNEMENT', 'PROGRESS_FORM', 'DOCUMENT_MODIFIE'].includes(rubrique.type)) {
                    rubrique.elements.sort((a, b) => b.date - a.date)
                } else if (['TACHE_ET_EVENEMENT_PLANIFIE', 'DERNIERE_ACTION_DECIDEE'].includes(rubrique.type)) {
                    rubrique.elements.sort((a, b) => b.echeance - a.echeance)
                }
            }
        }


        $scope.refreshRubriquesSelected = function () {
            $scope._rubriquesSelected = []
            for (var i = 0; i < $scope._rubriques.length; i++) {
                if ($scope._rubriques[i].elements.length > 0) {
                    $scope._rubriquesSelected.push($scope._rubriques[i].type)
                }
            }
        }

        $scope.initReunion = function (reunion) {
            $scope.hasOdjRubrique = false;
            $scope.indicateursFilter = []
            $scope._actionsDecidees = []
            $scope._thisReunion = reunion;
            if (reunion.ordreDuJour.note == null) {
                $scope._thisReunion.ordreDuJour.note = '';
            }
            if ($scope._thisReunion.statut == 'Finaliser le compte-rendu' || $scope._thisReunion.archived) {
                if ($scope._thisReunion.noteCompteRendu == null && $scope._thisReunion.ordreDuJour && $scope._thisReunion.ordreDuJour.note) {
                    $scope._thisReunion.noteCompteRendu = angular.copy($scope._thisReunion.ordreDuJour.note);
                }
                var presencesIds = $scope._thisReunion.presences.map(function (collaborateur) { return collaborateur.id })
                EquipeDetailService.getCollaborateurs().then(function (data) {
                    $scope._users = data;
                    for (var i = 0; i < $scope._users.length; i++) {
                        var user = $scope._users[i]
                        if (presencesIds.lastIndexOf(user.id) > -1) {
                            user.selected = true
                        }
                    }
                }).catch(function (response) {

                });
                $scope._thisReunion.realisee = true;
                angular.forEach($scope._thisReunion.ordreDuJour.actionsDecidees, function (_adItem, _adIndex) {
                    _adItem.categoryLibelle = "Action décidée / Réunion d'équipe";
                    $scope._actionsDecidees.push(_adItem);
                });
                $scope.tabActive = 'three'
            } else if ($state.params.subTab) {
                $scope.tabActive = angular.copy($state.params.subTab)
            } else {
                $scope.tabActive = 'two'
            }
            var start = new Date($scope._thisReunion.dateStart);
            var startHours = start.getHours() * 60 * 60 * 1000 + start.getMinutes() * 60 * 1000;
            $scope._thisReunion.hourSelect = startHours;
            if ($scope._thisReunion.ordreDuJour != null) {
                if ($scope._thisReunion.ordreDuJour.rubriques.length > 0) {
                    $scope._rubriques = $scope._thisReunion.ordreDuJour.rubriques.map(function (rubrique, index) {
                        var libelle = ''
                        switch (rubrique.type) {
                            case 'DYSFONCTIONNEMENT':
                                libelle = $scope.libelles.malfunctions
                                break
                            case 'PROGRESS_FORM':
                                libelle = $scope.libelles.progressForms
                                break
                            case 'DOCUMENT_MODIFIE':
                                libelle = $scope.libelles.documents
                                break
                            case 'TACHE_ET_EVENEMENT_PLANIFIE':
                                libelle = $scope.libelles.tasks
                                break
                            case 'DERNIERE_ACTION_DECIDEE':
                                libelle = $scope.libelles.actions
                                break
                            case 'INDICATEUR_DU_TABLEAU_DE_BORD':
                                libelle = $scope.libelles.indicateurs
                                break
                            case 'MES_EVALUATIONS':
                                libelle = $scope.libelles.evaluations
                                break
                            case 'TEXT':
                                if (rubrique.libelle != null) {
                                    libelle = rubrique.libelle
                                } else {
                                    libelle = 'Zone de texte'
                                }
                                break
                            case 'NOTE_ODJ':
                                libelle = $scope.libelles.noteOdj
                                $scope.hasOdjRubrique = true
                                break
                            default:
                                break
                        }
                        return {
                            id: rubrique.id,
                            type: rubrique.type,
                            libelle: libelle,
                            index: index,
                            comment: rubrique.comment,
                            elements: []
                        }
                    })
                } else {
                    $scope._initRubrique();
                }
                for (var i = 0; i < $scope._thisReunion.ordreDuJour.elements.length; i++) {
                    var element = $scope._thisReunion.ordreDuJour.elements[i]
                    if (element.type === 'INDICATEUR_DU_TABLEAU_DE_BORD') {
                        var year = element.date
                        if (year == null) {
                            year = new Date($scope._thisReunion.dateStart).getFullYear()
                        }
                        $scope.indicateursFilter.push({ id: element.associationId, year: year })
                        $scope.addElementToRubrique(element.type, element)
                    } else if (element.type === 'TEXT') {
                        $scope.addElementToRubrique(element.type, element, element.rubriqueTextId)
                    } else {
                        $scope.addElementToRubrique(element.type, element)
                    }
                }
                $scope.sortRubriquesEl()
                $scope.refreshRubriquesSelected()
                $scope.refreshIndicateurs()
            }
        }

        $scope.refreshIndicateurs = function () {
            TableauDeBordService.findByIdsAndYear($scope.indicateursFilter).then(function (res) {
                $scope.indicateurs = res.data
            }).catch(function () {

            })
        }

        $scope.addElementToRubrique = function (type, element, rubriqueTextId) {
            for (var i = 0; i < $scope._rubriques.length; i++) {
                var rubrique = $scope._rubriques[i]
                if (rubrique.type === 'MES_EVALUATIONS') {
                    if (['AUTO_EVALUATION', 'RAPPORT_D_AUDIT', 'SATISFACTION_CLIENT', 'FLASH_QUALITE'].lastIndexOf(type) > -1) {
                        rubrique.elements.push(element)
                    }
                } else if (rubrique.type === 'TEXT' && rubrique.id == rubriqueTextId) {
                    rubrique.elements.push(element)
                } else if (rubrique.type != 'TEXT' && rubrique.type === type) {
                    rubrique.elements.push(element)
                }
            }
        }
        // UTILS REUNION FROM ordreDuJourController

        $scope.init = function () {
            $scope.pj = pj
            $scope.infos = []
            $scope.dysfonctionnements = []
            if (pj.type === 'MALFUNCTION') {
                if (pj.addCommentMode) {
                    $scope.showAddComment()
                }
                $scope.title = 'Aperçu du dysfonctionnement'
                if (pj.malfunction.type.index === 2) {
                    $scope.infos.push({ libelle: 'Intitulé', value: pj.malfunction.title })
                    $scope.infos.push({ libelle: 'Type de dysfonctionnement', value: pj.malfunction.type.name })
                    $scope.infos.push({ libelle: 'Importance', value: PRIORITIES_MALFUNCTION_NAMES[pj.malfunction.priority], class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.malfunction.creation, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--right' })
                    if (pj.malfunction.dispensation.detector != null) {
                        var value = ''
                        if (pj.malfunction.dispensation.detector === $scope.dispensationTypes.INTERNE_CONTROL) {
                            value = 'La pharmacie - contrôle interne'
                        } else if (pj.malfunction.dispensation.detector === $scope.dispensationTypes.DMP) {
                            value = 'La pharmacie - DMP'
                        } else if (pj.malfunction.dispensation.detector === $scope.dispensationTypes.CLIENT) {
                            value = 'Le client'
                        } else if (pj.malfunction.dispensation.detector === $scope.dispensationTypes.PAYER_ORGANISM) {
                            value = 'L\'organisme payeur'
                        }
                        $scope.infos.push({ libelle: 'Erreur détectée par', value: value })
                    }
                    if (pj.malfunction.dispensation.error != null) {
                        var value = ''
                        for (var i = 0; i < $scope.dispensationErrors.length; i++) {
                            var error = $scope.dispensationErrors[i]
                            if (error.code === pj.malfunction.dispensation.error) {
                                value = error.libelle
                                break
                            }
                        }
                        $scope.infos.push({ libelle: 'Caractérisation de l\'erreur', value: value })
                    }
                    $scope.infos.push({ libelle: 'Produit délivré', value: pj.malfunction.dispensation.delivered ? 'Oui' : 'Non', class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Le traitement a été administré', value: pj.malfunction.dispensation.beginTraitement ? 'Oui' : 'Non', class: 'iv-Dialog__apercu__item--right' })
                    if (pj.malfunction.dispensation.beginTraitement) {
                        var value = ''
                        for (var i = 0; i < $scope.dispensationDates.length; i++) {
                            var error = $scope.dispensationDates[i]
                            if (error.code === pj.malfunction.dispensation.sinceWhen) {
                                value = error.libelle
                                break
                            }
                        }
                        $scope.infos.push({ libelle: 'Depuis quand', value: value, class: 'iv-Dialog__apercu__item--left' })
                    }
                    if (pj.malfunction.dispensation.beginTraitement) {
                        var value = ''
                        if (pj.malfunction.dispensation.consequence === 'ANY') {
                            value = 'Aucune'
                        } else if (pj.malfunction.dispensation.consequence === 'DOCTOR') {
                            value = 'Visite chez le médecin'
                        } else if (pj.malfunction.dispensation.consequence === 'HOSPITAL') {
                            value = 'Hospitalisation'
                        }
                        $scope.infos.push({ libelle: 'Conséquence pour le patient', value: value, class: 'iv-Dialog__apercu__item--right' })
                    }
                    $scope.infos.push({ libelle: 'Constat', value: pj.malfunction.description })
                    $scope.infos.push({ libelle: 'Rapporteur', value: pj.malfunction.collaborateur.name + ' ' + pj.malfunction.collaborateur.surname, class: pj.malfunction.personIssued != null ? 'iv-Dialog__apercu__item--left' : '' })
                    if (pj.malfunction.personIssued != null) {
                        $scope.infos.push({ libelle: 'Personne ayant délivré', value: pj.malfunction.personIssued.name + ' ' + pj.malfunction.personIssued.surname, class: 'iv-Dialog__apercu__item--right' })
                    }
                } else if (pj.malfunction.type.index === 4 || pj.malfunction.type.index === 6) {
                    $scope.infos.push({ libelle: 'Intitulé', value: pj.malfunction.title })
                    $scope.infos.push({ libelle: 'Type de dysfonctionnement', value: pj.malfunction.type.name })
                    $scope.infos.push({ libelle: 'Importance', value: PRIORITIES_MALFUNCTION_NAMES[pj.malfunction.priority], class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.malfunction.creation, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--right' })
                    if (pj.malfunction.type.index === 6) {
                        var libelle = ''
                        if (pj.malfunction.ecorDomain != null) {
                            libelle = $scope.ecorDomains[pj.malfunction.ecorDomain]
                        }
                        $scope.infos.push({ libelle: 'Domaine impacté', value: libelle })
                    }
                    if (pj.malfunction.supplier != null) {
                        $scope.infos.push({ libelle: 'Type de prestataire', value: pj.malfunction.supplier.type === 'LAB' ? 'Laboratoire' : 'Prestataire de services', class: 'iv-Dialog__apercu__item--left' })
                        $scope.infos.push({ libelle: 'Prestataire', value: pj.malfunction.supplier.name, class: 'iv-Dialog__apercu__item--right' })
                    }
                    $scope.infos.push({ libelle: 'Constat', value: pj.malfunction.description })
                    $scope.infos.push({ libelle: 'Rapporteur', value: pj.malfunction.collaborateur.name + ' ' + pj.malfunction.collaborateur.surname, class: 'iv-Dialog__apercu__item--left' })
                } else {
                    $scope.infos.push({ libelle: 'Intitulé', value: pj.malfunction.title })
                    $scope.infos.push({ libelle: 'Type de dysfonctionnement', value: pj.malfunction.type.name })
                    $scope.infos.push({ libelle: 'Importance', value: PRIORITIES_MALFUNCTION_NAMES[pj.malfunction.priority], class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.malfunction.creation, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--right' })
                    $scope.infos.push({ libelle: 'Constat', value: pj.malfunction.description })
                    $scope.infos.push({ libelle: 'Rapporteur', value: pj.malfunction.collaborateur.name + ' ' + pj.malfunction.collaborateur.surname, class: 'iv-Dialog__apercu__item--left' })
                }
            } else if (pj.type === 'REUNION') {
                $scope.title = 'Aperçu du Compte-rendu de réunion'
                $scope.initReunion(pj.reunion)
            } else if (pj.type === 'PROGRESS_FORM') {
                $scope.title = 'Aperçu de la fiche de progrès'
                $scope.infos.push({ libelle: 'Motif d\'ouverture de la fiche de progrès', value: pj.progressForm.type.name })
                $scope.infos.push({ libelle: 'Intitulé', value: pj.progressForm.title })
                $scope.infos.push({ libelle: 'Quelles sont les causes de la situation actuelle ?', value: pj.progressForm.reason })
                $scope.infos.push({ libelle: 'Quelles sont les sources d\'amélioration', value: pj.progressForm.fix })
                $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.progressForm.creation, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--left' })
            } else if (pj.type === 'MES_EVALUATIONS') {
                if (pj.monEval.type === 'FLASH_QUALITE') {
                    $scope.title = 'Aperçu du flash'
                    $scope.infos.push({ libelle: 'Nom du flash', value: pj.monEval.data.title })
                    $scope.infos.push({ libelle: 'Points forts', value: pj.monEval.data.plus })
                    $scope.infos.push({ libelle: 'Points faibles', value: pj.monEval.data.moins })
                    $scope.infos.push({ libelle: 'Dysfonctionnements rencontrés', value: pj.monEval.data.malfunctions })
                    $scope.infos.push({ libelle: 'Existe-t-il une procédure ?', value: pj.monEval.data.processExist ? 'Oui' : 'Non' })
                    $scope.infos.push({ libelle: 'Une procédure serait-elle utile ?', value: pj.monEval.data.processUseful ? 'Oui' : 'Non' })
                    $scope.infos.push({ libelle: 'Personne ayant réalisé l\'auto-contrôle ?', value: pj.monEval.data.newCollaborateur ? (pj.monEval.data.newCollaborateur.name + ' ' + pj.monEval.data.newCollaborateur.surname) : '' })
                } else if (pj.monEval.type === 'RAPPORT_D_AUDIT') {
                    $scope.title = 'Aperçu de l\'audit'
                    $scope.infos.push({ libelle: 'Nom de l\'audit', value: pj.monEval.data.auditName })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.monEval.data.uploadDate, 'dd/MM/yyyy') })
                    $scope.infos.push({ libelle: 'Ecarts majeurs', value: pj.monEval.data.ecartsMajeurs, class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Ecarts mineurs', value: pj.monEval.data.ecartsMineurs, class: 'iv-Dialog__apercu__item--right' })
                    $scope.infos.push({ libelle: 'Commentaires', value: pj.monEval.data.comment })
                } else if (pj.monEval.type === 'SATISFACTION_CLIENT') {
                    $scope.title = 'Aperçu de la satisfaction client'
                    $scope.infos.push({ libelle: 'Nom de la satisfaction client', value: pj.monEval.data.name })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.monEval.data.uploadDate, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Commentaires', value: pj.monEval.data.comment })
                } else if (pj.monEval.type === 'AUTO_EVALUATION') {
                    $scope.title = 'Aperçu de l\'auto-évaluation'
                    $scope.infos.push({ libelle: 'Nom de l\'auto-évaluation', value: pj.monEval.data.name })
                    $scope.infos.push({ libelle: 'Date', value: $filter('date')(pj.monEval.data.uploadDate, 'dd/MM/yyyy'), class: 'iv-Dialog__apercu__item--left' })
                    $scope.infos.push({ libelle: 'Commentaires', value: pj.monEval.data.comment })
                }
            }
        }
        $scope.init()



        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.downloadMalfunctionAttachment = function (id) {
            $window.location.href = '/api/rest/malfunction/download/document/' + id;
        };

        $scope.downloadMesEval = function (id, type) {
            if (type === 'AUTO_EVALUATION') {
                $window.location.href = AutoEvaluationService.getDownloadLink(id);
            } else if (type === 'SATISFACTION_CLIENT') {
                $window.location.href = SatisfactionService.getDownloadLink(id);
            } else if (type === 'RAPPORT_D_AUDIT') {
                $window.location.href = AuditService.getDownloadLink(id);
            }
        }

        $scope.openProgressForm = function (malfunction) {
            $scope.hidePopup();
            $state.go('app.malfunctions.add-fiche-progres', {
                malfunctionId: malfunction.id
            });
        };

        $scope.openProgressFormAssociated = function (malfunction) {
            $scope.hidePopup();
            $state.go('app.malfunctions.progress_forms_associated', { id: malfunction.id });
        }

        $scope.cancelShare = function () {
            $scope.pj.malfunction.shareDuration = 0;

            MalfunctionService.shareMalfunction($scope.pj.malfunction).then(function (data) {
                $scope.pj.malfunction.shareExpirationDate = 0;
                $scope.pj.malfunction.token = null;
            }).catch(function (err) {
                console.log(err);
            })
        }

        $scope.copyText = function () {
            $timeout(function () {
                var _element = angular.element(document.querySelector('#linkShare'));
                _element[0].select();
                document.execCommand('copy');
                toastr.success('Copié !')

                $timeout(function () {
                    $scope.displayDisable = true;
                }, 4000);
            }, 0);
        };

        $scope.disableMalfunction = function () {
            MalfunctionService.disableShareMalfunction($scope.pj.malfunction).then(function (res) {
                $scope.pj.malfunction.token = null;
                $scope.linkDisabled = true;
                toastr.success('Désactivé !')
                $timeout(function () {
                    $mdDialog.hide();
                }, 4000);
            });
        };

    }

})();
(function () {
	'use strict';

	angular.module('app.front').controller('GroupementPharmaciesController', GroupementPharmaciesController);

	/**
	 * Écran A — la liste des pharmacies, page d'arrivée de l'espace groupement (§3).
	 *
	 * ⚠️ Tout est calculé PAR LE CRM : pagination, tri, recherche, filtres et compteurs. L'écran ne
	 * charge jamais le parc entier pour l'afficher — un gros réseau compte plusieurs centaines
	 * d'officines (§10 Volumétrie).
	 *
	 * ⚠️ Ce parc n'est pas celui des « Pharmacies engagées » des Journées qualité : ici c'est TOUT
	 * le parc CRM du groupement, clientes LQO ou non. Les deux chiffres ne se recoupent pas, et le
	 * sous-titre le dit explicitement pour qu'on ne les confonde pas (§1).
	 */
	/** @ngInject */
	function GroupementPharmaciesController($scope, $rootScope, $state, EspaceGroupementService, UserService, toastr) {
		var TAILLE_PAGE = 25;

		/**
		 * Le SEUL filtre posé À L'ARRIVÉE (21/09/2026) : le parc qu'on vient consulter est celui
		 * des officines en activité. Sans lui, la liste ouvre sur les 295 fiches du réseau,
		 * « Sortie » comprises, et il faut poser un filtre avant de pouvoir travailler.
		 *
		 * Ce n'est PAS un filtre caché : il apparaît comme les autres, en étiquette « Statut :
		 * Actif », et se retire d'un clic sur sa croix. Les chiffres clés du bandeau le suivent —
		 * ils décrivent toujours le périmètre filtré, jamais le parc entier. Seule « Certifiées
		 * actives » y échappe, par construction (cf. `$scope.indicateurs`).
		 *
		 * ⚠️ La valeur est celle du référentiel CRM (`base_statut_pharmacie.statut_pharmacie`), pas
		 * un libellé d'écran : si elle y était renommée, l'arrivée n'afficherait plus aucune ligne.
		 */
		var STATUT_PAR_DEFAUT = 'Actif';

		/**
		 * La valeur « certifiée » telle que le CRM l'attend (cf. `libellesValeurs.certification`),
		 * pas un libellé d'écran. Elle ne sert plus qu'à l'indicateur « Certifiées actives » du
		 * bandeau, qui la pose quand on le clique.
		 *
		 * ⚠️ Elle N'EST PLUS posée à l'arrivée (21/09/2026) : ouvrir sur les seules certifiées
		 * cachait le reste du parc en activité, alors qu'un réseau vient d'abord voir TOUTES ses
		 * officines ouvertes. Se restreindre aux certifiées reste à un clic — l'indicateur —, et
		 * il emmène le statut avec lui (`avec`), donc le périmètre d'alors est inchangé.
		 */
		var CERTIFICATION_CERTIFIEE = 'certifiee';

		/**
		 * Les cinq indicateurs du bandeau, chacun cliquable comme un filtre (arbitrage 23).
		 *
		 * Quatre décrivent le PÉRIMÈTRE AFFICHÉ et suivent donc recherche et filtres. « Certifiées
		 * actives » fait exception (demande du 09/09/2026) : c'est un repère du parc — les
		 * officines en activité et certifiées du réseau — que le CRM calcule hors filtres. Le
		 * chiffre ne bouge pas quand on filtre ; `aide` le dit au survol pour qu'on n'y voie pas
		 * un compteur en panne.
		 *
		 * `avec` : filtres que l'indicateur emmène avec le sien quand on l'allume, parce que son
		 * libellé les promet. « Certifiées actives » compte les officines EN ACTIVITÉ : sans le
		 * statut, un clic depuis un parc non filtré ramenait aussi les certifiées sorties, et la
		 * liste dépassait le chiffre affiché juste au-dessus (constaté le 09/09/2026).
		 */
		$scope.indicateurs = [
			{ cle: 'pharmacies', libelle: 'Pharmacies', filtre: null },
			{ cle: 'engageesQualite', libelle: 'Engagées qualité', filtre: 'engage', valeur: 'oui' },
			{ cle: 'certifiees', libelle: 'Certifiées actives', filtre: 'certification',
				valeur: CERTIFICATION_CERTIFIEE, avec: { statut: STATUT_PAR_DEFAUT },
				aide: "Toutes les officines en activité et certifiées du réseau — ce chiffre ne suit pas les filtres" },
			{ cle: 'inscritesLqo', libelle: 'Inscrites LQO', filtre: 'lqoInscrit', valeur: 'oui' },
			{ cle: 'inscritesEcor', libelle: 'Inscrites ECOR', filtre: 'ecorInscrit', valeur: 'oui' }
		];

		/**
		 * Les huit filtres de la spécification, tous combinables (§3), plus « Groupement ».
		 *
		 * ⚠️ L'ORDRE SUIT CELUI DES COLONNES, déclarées juste en dessous : c'est la seule règle qui
		 * permette de retrouver un filtre sans lire toute la liste, le menu et le tableau se
		 * répondant. Y toucher sans toucher aux colonnes, ou l'inverse, casse la correspondance —
		 * et les étiquettes, qui se rangent dans le même ordre, la trahiraient aussitôt.
		 *
		 * « LQO » et « ECOR » n'ont PAS de colonne : ils restent collés à « Engagé qualité », dont
		 * ils sont les voisins de sens. « Dernier audit BVC » ferme donc la liste, comme sa
		 * colonne ferme le tableau.
		 *
		 * « Groupement » n'a de sens QU'EN VUE CONSOLIDÉE : dès qu'un réseau est sélectionné dans
		 * la barre du haut, le périmètre n'en contient qu'un et le filtre ne proposerait qu'une
		 * seule valeur — celle déjà appliquée. Il suit donc la même règle que la colonne du même nom.
		 */
		$scope.filtresDisponibles = [
			{ cle: 'groupement', libelle: 'Groupement', consolideeSeulement: true },
			{ cle: 'sousGroupe', libelle: 'Sous-groupement' },
			{ cle: 'ville', libelle: 'Ville' },
			{ cle: 'statut', libelle: 'Statut' },
			{ cle: 'anneeDernierEngagement', libelle: "Année d'engagement" },
			{ cle: 'certification', libelle: 'Certification' },
			{ cle: 'engage', libelle: 'Engagé qualité' },
			{ cle: 'lqoInscrit', libelle: 'LQO' },
			{ cle: 'ecorInscrit', libelle: 'ECOR' },
			// Les trois filtres de suivi des audits, dans l'ordre de leurs colonnes. Le contrôle
			// se déduit du type servi par les métadonnées, il n'y a rien à déclarer de plus ici :
			// deux bornes « de / à » pour le nombre, une LISTE D'ANNÉES pour les deux dates.
			//
			// ⚠️ Les deux derniers libellés disent « Année » là où leur colonne dit « Date »
			// (21/09/2026) : la colonne affiche bien une date, mais on la filtre par année —
			// « qui a été audité en 2025 ? » est la question posée, et une plage « du / au »
			// demandait deux calendriers pour l'exprimer. Le contrôle vient du CRM, qui sert ces
			// deux champs en liste des années réellement présentes dans le parc
			// (`LqoPharmacieApiDao.FILTER_DEFS`) : promettre « Date » ici ouvrirait un menu
			// d'années.
			{ cle: 'nbAuditsARealiser', libelle: 'Nb audits à réaliser' },
			{ cle: 'dateDernierAudit', libelle: 'Dernier audit - Année' },
			{ cle: 'dateDernierAuditBvc', libelle: 'Dernier audit BVC - Année' }
		];

		/**
		 * Libellés lisibles des valeurs de certification, qui ne sont pas des valeurs de colonne.
		 * Passés au menu de filtres, qui s'en sert pour le choix ET pour l'étiquette.
		 */
		$scope.libellesValeurs = {
			certification: {
				certifiee: 'Certifiée',
				en_cours: 'En cours',
				non_certifiee: 'Non certifiée',
				non_renseignee: 'Non renseignée'
			}
		};

		// Le code CIP ouvre le tableau : c'est l'identifiant que les officines et le réseau
		// s'échangent, la réf PHSQ ne servant qu'à retrouver la fiche de notre côté.
		$scope.colonnes = [
			{ cle: 'codeCip', libelle: 'Code CIP' },
			{ cle: 'numeroAdherent', libelle: "N° d'adhérent" },
			{ cle: 'identifiant', libelle: 'Réf PHSQ' },
			{ cle: 'groupement', libelle: 'Groupement', consolideeSeulement: true },
			{ cle: 'sousGroupe', libelle: 'Sous-groupe' },
			{ cle: 'nom', libelle: 'Nom' },
			{ cle: 'codePostal', libelle: 'Code postal' },
			{ cle: 'ville', libelle: 'Ville' },
			{ cle: 'statut', libelle: 'Statut' },
			{ cle: 'anneeDernierEngagement', libelle: 'Engagement' },
			{ cle: 'certification', libelle: 'Certification' },
			{ cle: 'engage', libelle: 'Engagé qualité' },
			// Les trois colonnes de SUIVI DES AUDITS, reprises telles quelles de la liste
			// pharmacies du CRM — mêmes intitulés et mêmes définitions (demande des réseaux du
			// 16/09/2026) : les audits non archivés restant à réaliser, puis la date du dernier
			// audit RÉALISÉ (pas le prochain planifié), puis celle du dernier BVC.
			{ cle: 'nbAuditsARealiser', libelle: 'Nb audits à réaliser', type: 'nombre' },
			{ cle: 'dateDernierAudit', libelle: 'Dernier audit - Date', type: 'date' },
			{ cle: 'dateDernierAuditBvc', libelle: 'Dernier audit BVC - Date', type: 'date' }
		];

		function filtresParDefaut() {
			return { statut: STATUT_PAR_DEFAUT };
		}

		$scope.pharmacies = [];
		$scope.compteurs = null;
		$scope.metasFiltres = {};
		$scope.filtres = filtresParDefaut();
		$scope.recherche = '';
		$scope.chargement = false;
		$scope.erreur = null;
		$scope.exportEnCours = false;
		// `pageSaisie` double `page` : c'est ce que l'utilisateur tape, qui peut être vide ou hors
		// bornes le temps de la frappe, alors que `page` est toujours la page réellement affichée.
		$scope.pagination = { page: 1, taille: TAILLE_PAGE, total: 0, pageSaisie: 1 };
		$scope.taillesPage = [10, 25, 50, 100];
		// Tri par nom A→Z par défaut (arbitrage 24).
		$scope.tri = { colonne: 'nom', sens: 'asc' };

		function groupementCourant() {
			return UserService.getSelectedGroupementId();
		}

		/**
		 * La colonne « Groupement » n'apparaît qu'en vue consolidée, c'est-à-dire quand le compte
		 * couvre plusieurs réseaux et n'en a sélectionné aucun (§3).
		 */
		$scope.estVueConsolidee = function () {
			return !groupementCourant() && ($rootScope.user && ($rootScope.user.groupements || []).length > 1);
		};

		$scope.filtresVisibles = function () {
			return $scope.filtresDisponibles.filter(function (filtre) {
				return !filtre.consolideeSeulement || $scope.estVueConsolidee();
			});
		};

		$scope.colonnesVisibles = function () {
			return $scope.colonnes.filter(function (colonne) {
				return !colonne.consolideeSeulement || $scope.estVueConsolidee();
			});
		};

		/** Paramètres envoyés au CRM : pagination, tri, recherche et filtres actifs. */
		function requete() {
			var query = angular.extend({}, $scope.filtres);
			query.pageIndex = $scope.pagination.page - 1;
			query.pageSize = $scope.pagination.taille;
			query.sortActive = $scope.tri.colonne;
			query.sortDirection = $scope.tri.sens;
			if (($scope.recherche || '').trim()) {
				query.q = $scope.recherche.trim();
			}
			return query;
		}

		$scope.charger = function () {
			$scope.chargement = true;
			$scope.erreur = null;
			var groupementId = groupementCourant();
			var query = requete();

			EspaceGroupementService.getPharmacies(groupementId, query).then(function (page) {
				$scope.pharmacies = (page && page.data) || [];
				$scope.pagination.total = (page && page.totalSize) || 0;
			}).catch(function (erreur) {
				$scope.pharmacies = [];
				$scope.pagination.total = 0;
				$scope.erreur = erreur;
			}).finally(function () {
				$scope.chargement = false;
			});

			// Les compteurs suivent la recherche et les filtres, mais pas la pagination : ils
			// décrivent le périmètre filtré, pas la page affichée (exigence n°2).
			var queryCompteurs = angular.extend({}, $scope.filtres);
			if (($scope.recherche || '').trim()) {
				queryCompteurs.q = $scope.recherche.trim();
			}
			EspaceGroupementService.getCompteurs(groupementId, queryCompteurs).then(function (compteurs) {
				$scope.compteurs = compteurs;
			}).catch(function () {
				$scope.compteurs = null;
			});
		};

		function chargerFiltres() {
			EspaceGroupementService.getFiltresPharmacies(groupementCourant()).then(function (metas) {
				$scope.metasFiltres = metas || {};
			}).catch(function () {
				$scope.metasFiltres = {};
			});
		}

		/**
		 * Un filtre vidé doit DISPARAÎTRE de la requête, pas y voyager à vide : sans cela
		 * `aDesFiltres()` croirait qu'un filtre est actif, et un paramètre creux partirait au CRM.
		 *
		 * ⚠️ Le menu de filtres retire déjà lui-même la clé qu'il vide ; la purge reste pour les
		 * filtres posés AILLEURS — les chiffres clés du bandeau — et pour les bornes numériques,
		 * qu'`input[type=number]` laisse à `undefined` plutôt que de les effacer.
		 */
		function purgerFiltres() {
			angular.forEach(Object.keys($scope.filtres), function (cle) {
				var valeur = $scope.filtres[cle];
				if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
					delete $scope.filtres[cle];
				}
			});
		}

		$scope.appliquer = function () {
			purgerFiltres();
			revenirPremierePage();
			$scope.charger();
		};

		/** ⚠️ `Math` n'existe pas dans la portée d'un gabarit AngularJS : le calcul reste ici. */
		$scope.nbPages = function () {
			return Math.max(1, Math.ceil(($scope.pagination.total || 0) / $scope.pagination.taille));
		};

		/** Remise en tête de liste : un filtre ou un tri qui change invalide le rang courant. */
		function revenirPremierePage() {
			$scope.pagination.page = 1;
			$scope.pagination.pageSaisie = 1;
		}

		/**
		 * Saut direct à une page.
		 *
		 * ⚠️ La borne est posée ICI et pas seulement par l'attribut `max` du champ : un
		 * `input[type=number]` n'empêche pas de taper 9999 au clavier, il se contente de le
		 * signaler. Une valeur illisible ramène simplement à la page courante.
		 */
		$scope.allerALaPage = function () {
			var demandee = parseInt($scope.pagination.pageSaisie, 10);
			if (!isFinite(demandee)) {
				$scope.pagination.pageSaisie = $scope.pagination.page;
				return;
			}
			demandee = Math.min(Math.max(demandee, 1), $scope.nbPages());
			$scope.pagination.pageSaisie = demandee;
			if (demandee !== $scope.pagination.page) {
				$scope.changerPage(demandee);
			}
		};

		/**
		 * Changement du nombre de lignes par page.
		 *
		 * On repart de la première : la 5ᵉ page de 25 lignes n'a pas d'équivalent en pages de 100,
		 * et rester sur un rang devenu hors bornes afficherait une page vide.
		 */
		$scope.changerTaille = function () {
			revenirPremierePage();
			$scope.charger();
		};

		$scope.changerPage = function (page) {
			$scope.pagination.page = page;
			$scope.pagination.pageSaisie = page;
			$scope.charger();
		};

		/** Un clic sur un en-tête trie ; un second clic inverse le sens. */
		$scope.trierPar = function (colonne) {
			if ($scope.tri.colonne === colonne) {
				$scope.tri.sens = $scope.tri.sens === 'asc' ? 'desc' : 'asc';
			} else {
				$scope.tri.colonne = colonne;
				$scope.tri.sens = 'asc';
			}
			$scope.appliquer();
		};

		/**
		 * Cliquer un indicateur pose son filtre ; recliquer l'enlève (arbitrage 23).
		 *
		 * Allumer pose aussi les filtres de `avec` (le statut, pour « Certifiées actives ») ;
		 * éteindre ne retire QUE le filtre propre de l'indicateur. Ces filtres-là décrivent le
		 * périmètre de consultation, pas l'indicateur : les emporter en s'éteignant ouvrirait le
		 * parc aux officines sorties, alors qu'on vient juste de refermer un critère.
		 */
		$scope.basculerIndicateur = function (indicateur) {
			if (!indicateur.filtre) {
				$scope.reinitialiser();
				return;
			}
			if ($scope.indicateurActif(indicateur)) {
				delete $scope.filtres[indicateur.filtre];
			} else {
				$scope.filtres[indicateur.filtre] = indicateur.valeur;
				angular.forEach(indicateur.avec || {}, function (valeur, cle) {
					$scope.filtres[cle] = valeur;
				});
			}
			$scope.appliquer();
		};

		/**
		 * Un indicateur n'est allumé que si TOUS ses filtres sont posés, `avec` compris : retirer
		 * l'étiquette « Statut : Actif » éteint donc « Certifiées actives », et le clic suivant
		 * repose les deux filtres — la liste répond alors exactement le chiffre affiché.
		 */
		$scope.indicateurActif = function (indicateur) {
			if (!indicateur.filtre || $scope.filtres[indicateur.filtre] !== indicateur.valeur) {
				return false;
			}
			var allume = true;
			angular.forEach(indicateur.avec || {}, function (valeur, cle) {
				if ($scope.filtres[cle] !== valeur) {
					allume = false;
				}
			});
			return allume;
		};

		$scope.aDesFiltres = function () {
			return Object.keys($scope.filtres).length > 0 || !!($scope.recherche || '').trim();
		};

		// Le bouton « effacer » vit sous un `ng-if`, donc dans une portée fille : une affectation
		// écrite dans le gabarit y créerait une variable locale sans jamais vider le champ.
		$scope.effacerRecherche = function () {
			$scope.recherche = '';
			$scope.appliquer();
		};

		$scope.reinitialiser = function () {
			$scope.filtres = {};
			$scope.recherche = '';
			$scope.appliquer();
		};

		$scope.ouvrirFiche = function (pharmacie) {
			$state.go('app.groupement.pharmacie', { reference: pharmacie.identifiant });
		};

		/** L'export reprend exactement ce qui est affiché : recherche et filtres compris (§8). */
		$scope.exporter = function () {
			if ($scope.exportEnCours) {
				return;
			}
			$scope.exportEnCours = true;
			var query = angular.extend({}, $scope.filtres);
			if (($scope.recherche || '').trim()) {
				query.q = $scope.recherche.trim();
			}
			query.sortActive = $scope.tri.colonne;
			query.sortDirection = $scope.tri.sens;
			EspaceGroupementService.exporterParc(groupementCourant(), query).catch(function (erreur) {
				toastr.error(erreur.message);
			}).finally(function () {
				$scope.exportEnCours = false;
			});
		};

		// Le sélecteur de la barre du haut change de réseau : tout est rechargé, filtres compris
		// (les valeurs proposées ne sont pas les mêmes d'un réseau à l'autre).
		var arreterEcoute = $scope.$on('groupementContextChanged', function () {
			$scope.filtres = filtresParDefaut();
			revenirPremierePage();
			chargerFiltres();
			$scope.charger();
		});
		$scope.$on('$destroy', arreterEcoute);

		chargerFiltres();
		$scope.charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('GroupementFichePharmacieController', GroupementFichePharmacieController);

	/**
	 * Écran B — la fiche pharmacie (§4) : entête fixe et trois onglets.
	 *
	 * Ce qui commande l'affichage des actions d'écriture, c'est le NIVEAU de l'utilisateur sur le
	 * groupement. Le back refuse de toute façon (401), mais un bouton qu'on ne peut pas actionner
	 * n'a rien à faire à l'écran.
	 *
	 * ⚠️ 16/09/2026 : l'onglet Contact n'est PLUS en lecture seule (il l'était par l'arbitrage 15)
	 * et la fiche d'audit se commente désormais (arbitrage 17 restreint à ses champs). Les gestes
	 * sur les contacts sont réservés au RESPONSABLE ; les règles métier restent celles du CRM,
	 * notamment l'unicité de l'e-mail principal (modifiable depuis PHSQ-237).
	 *
	 * Chantier PHSQ-220 (chapitre 06) : la sortie de groupement — un bouton dans le bandeau, un
	 * bloc de suivi en tête de la colonne de droite, un dialogue de déclaration. Puis (spécification
	 * sortie-qualite § 8.2) la sortie de la DÉMARCHE QUALITÉ, sur le même modèle exact : un second
	 * bouton, un second bloc, un second dialogue.
	 */
	/** @ngInject */
	function GroupementFichePharmacieController($scope, $rootScope, $state, $stateParams, $location, $q,
		$mdDialog, $document, ConfirmationGroupement, EspaceGroupementService, UserService, toastr) {

		var ONGLETS = ['pharmacie', 'contact', 'audits'];

		$scope.reference = $stateParams.reference;
		$scope.onglet = ONGLETS.indexOf($stateParams.tab) >= 0 ? $stateParams.tab : 'pharmacie';
		$scope.fiche = null;
		$scope.contacts = null;
		$scope.audits = null;
		$scope.chargement = true;
		$scope.erreur = null;
		// ⚠️ Un OBJET, pas une chaîne : la zone de saisie vit sous deux `ng-if` (le garde de
		// chargement puis l'onglet), donc sous deux portées filles. Un `ng-model` sur une valeur
		// simple y crée une propriété dans la portée fille et la saisie n'atteint jamais le
		// contrôleur — le bouton s'active, le clic ne fait rien. La règle AngularJS « toujours un
		// point » règle le problème une fois pour toutes.
		$scope.saisieCommentaire = { contenu: '' };
		$scope.enregistrement = false;
		// Un export docx passe par le CRM et prend une à deux secondes : sans état d'attente, on
		// clique deux fois et on génère deux fichiers.
		$scope.exportFiche = false;
		$scope.edition = null;
		// Saisie de contact : `null` = aucun formulaire ouvert ; `id` nul = création.
		$scope.contactEdition = null;
		$scope.depot = { titre: '', fichier: null };
		// La déclaration de sortie de l'officine, telle que le CRM la sert (null = aucune), et
		// l'échec de sa lecture, qui ne doit pas emporter la fiche avec lui.
		$scope.sortie = null;
		$scope.sortieErreur = null;
		$scope.retraitSortie = false;
		// La demande de sortie de la démarche qualité, sur le même modèle (spécification § 8.2).
		$scope.sortieQualite = null;
		$scope.sortieQualiteErreur = null;
		$scope.retraitSortieQualite = false;
		$scope.dateLongue = EspaceGroupementService.dateLongue;
		$scope.dateIso = EspaceGroupementService.dateIso;

		function groupementCourant() {
			return UserService.getSelectedGroupementId();
		}

		/**
		 * L'utilisateur est-il responsable ? En vue consolidée, il suffit de l'être sur au moins un
		 * réseau : l'officine affichée appartient forcément à l'un d'eux, et le back tranchera.
		 */
		$scope.niveauEcartLeve = EspaceGroupementService.niveauEcartLeve;

		$scope.estResponsable = function () {
			var groupements = ($rootScope.user && $rootScope.user.groupements) || [];
			var courant = groupementCourant();
			var responsable = false;
			angular.forEach(groupements, function (groupement) {
				if (groupement.isResponsable && (!courant || groupement.id === courant)) {
					responsable = true;
				}
			});
			return responsable;
		};

		$scope.changerOnglet = function (onglet) {
			$scope.onglet = onglet;
			// L'adresse suit l'onglet : la page reste partageable telle qu'on la voit.
			$location.search('tab', onglet === 'pharmacie' ? null : onglet);
			if (onglet === 'contact' && $scope.contacts === null) {
				chargerContacts();
			}
			if (onglet === 'audits' && $scope.audits === null) {
				chargerAudits();
			}
		};

		/**
		 * La fiche ET la déclaration de sortie, dans le même cycle (chapitre 06 § 8) : un second
		 * appel décalé ferait apparaître le bloc de suivi après coup, et sauter le bandeau.
		 *
		 * ⚠️ L'échec de la déclaration seule n'emporte pas la fiche : sa promesse est rattrapée
		 * avant le `$q.all`, et le bloc dit alors qu'il ne sait pas — plutôt qu'un bouton
		 * « Déclarer » qui buterait sur une déclaration déjà ouverte.
		 */
		function chargerFiche() {
			$scope.chargement = true;
			$scope.erreur = null;
			$q.all([
				EspaceGroupementService.getFiche(groupementCourant(), $scope.reference),
				lireSortie(),
				lireSortieQualite()
			]).then(function (resultats) {
				$scope.fiche = resultats[0];
			}).catch(function (erreur) {
				$scope.erreur = erreur;
			}).finally(function () {
				$scope.chargement = false;
				// Les onglets ne se chargent qu'à l'ouverture : inutile d'appeler le CRM trois fois
				// pour une fiche dont on ne regardera qu'un onglet.
				if ($scope.onglet === 'contact') {
					chargerContacts();
				}
				if ($scope.onglet === 'audits') {
					chargerAudits();
				}
			});
		}

		function lireSortie() {
			return EspaceGroupementService.sortie(groupementCourant(), $scope.reference).then(function (sortie) {
				$scope.sortie = sortie || null;
				$scope.sortieErreur = null;
			}).catch(function (erreur) {
				$scope.sortie = null;
				$scope.sortieErreur = erreur;
			});
		}

		/** Même règle que la déclaration de sortie : son échec n'emporte pas la fiche. */
		function lireSortieQualite() {
			return EspaceGroupementService.sortieQualite(groupementCourant(), $scope.reference).then(function (demande) {
				$scope.sortieQualite = demande || null;
				$scope.sortieQualiteErreur = null;
			}).catch(function (erreur) {
				$scope.sortieQualite = null;
				$scope.sortieQualiteErreur = erreur;
			});
		}

		function chargerContacts() {
			EspaceGroupementService.getContacts(groupementCourant(), $scope.reference).then(function (contacts) {
				$scope.contacts = contacts || [];
			}).catch(function (erreur) {
				$scope.contacts = [];
				toastr.error(erreur.message);
			});
		}

		function chargerAudits() {
			EspaceGroupementService.getAuditsDePharmacie(groupementCourant(), $scope.reference).then(function (audits) {
				$scope.audits = audits || [];
			}).catch(function (erreur) {
				$scope.audits = [];
				toastr.error(erreur.message);
			});
		}

		// --------------------------------------------- Sortie de groupement (PHSQ-220, chapitre 06)

		/** La forme amputée n'a que quatre clés (R26) : ni date, ni auteur, ni motif. */
		function estComplete(sortie) {
			return !!sortie && angular.isDefined(sortie.deposeeLe);
		}

		/**
		 * L'état du bloc « Sortie du groupement » — cinq états d'UN MÊME bloc (chapitre 06 § 8),
		 * lus sur le DTO tel que le CRM le sert, jamais recalculés :
		 *  - `null`           rien à montrer (écran 1) : aucune déclaration, ou une close annulée
		 *                     ou traitée — le groupement retrouve alors son bouton (P1, R19) ;
		 *  - `'indisponible'` la déclaration n'a pas pu être lue ;
		 *  - `'groupement'`   la sienne, ouverte (écran 3, puis la prise en charge du scénario 6) ;
		 *  - `'refusee'`      la sienne, refusée (écran 4) ;
		 *  - `'officine'`     celle de l'officine, en détail (écran 5, R15) ;
		 *  - `'tiers'`        saisie par PHSQ ou par un autre groupement : quatre clés (R26).
		 */
		$scope.etatSortie = function () {
			var sortie = $scope.sortie;
			if ($scope.sortieErreur) {
				return 'indisponible';
			}
			if (!sortie) {
				return null;
			}
			if (sortie.issue) {
				return sortie.issue === 'REFUSEE' && sortie.origine === 'GROUPEMENT' && estComplete(sortie)
					? 'refusee' : null;
			}
			if (!estComplete(sortie)) {
				return 'tiers';
			}
			return sortie.origine === 'OFFICINE' ? 'officine' : 'groupement';
		};

		/** La pastille de l'en-tête du bloc : deux états, puis l'issue (R9). Jamais une étape. */
		$scope.libelleEtatSortie = function () {
			var sortie = $scope.sortie;
			if (!sortie) {
				return '';
			}
			if (sortie.issue === 'REFUSEE') {
				return 'Déclarée refusée';
			}
			return sortie.etat === 'EN_COURS' ? 'En cours de traitement' : 'En attente de traitement';
		};

		/**
		 * Le bouton du bandeau : RESPONSABLE seul, et seulement tant qu'aucune déclaration n'occupe
		 * la place, quelle que soit son origine (chapitre 06 § 3). Un refus se redépose depuis le
		 * bloc, par « Déclarer à nouveau la sortie ».
		 */
		$scope.peutDeclarerSortie = function () {
			return !!$scope.fiche && !!$scope.fiche.groupement && $scope.estResponsable() && !$scope.etatSortie();
		};

		$scope.rechargerSortie = function () {
			lireSortie();
		};

		/**
		 * Le dialogue de l'écran 2. Il se ferme sur la déclaration transmise, ou sur le 409 de R3 —
		 * une déclaration est déjà ouverte, l'officine ou PHSQ ayant déclaré entre-temps : on relit
		 * alors la déclaration, pour montrer celle qui occupe la place.
		 */
		$scope.ouvrirDeclarationSortie = function (event) {
			$mdDialog.show({
				templateUrl: 'app/main/front/groupement/pharmacie/declarer-sortie.dialog.html',
				controller: 'GroupementDeclarerSortieDialogController',
				locals: { fiche: $scope.fiche, groupementId: groupementCourant(), reference: $scope.reference },
				parent: angular.element($document[0].body),
				targetEvent: event,
				clickOutsideToClose: true
			}).then(function (issue) {
				if (issue && issue.conflit) {
					toastr.error(issue.message);
				} else {
					toastr.success('Déclaration transmise à PHSQ.');
				}
				lireSortie();
			}).catch(angular.noop);
		};

		/**
		 * Retirer SA déclaration, tant que personne chez PHSQ ne s'en est saisi (R13) : le bouton
		 * ne s'affiche qu'alors. Si PHSQ l'a prise en charge entre-temps, le 409 le dit et la
		 * relecture montre la déclaration telle qu'elle est devenue.
		 */
		$scope.retirerDeclarationSortie = function (event) {
			if ($scope.retraitSortie) {
				return;
			}
			ConfirmationGroupement.demander({
				titre: 'Retirer la déclaration',
				texte: "La déclaration de sortie est annulée : PHSQ n'aura rien à instruire, et le "
					+ "rattachement de l'officine reste " + $scope.fiche.groupement + '.',
				detail: $scope.fiche.nom,
				confirmer: 'Retirer la déclaration',
				annuler: 'Garder la déclaration',
				event: event
			}).then(function () {
				$scope.retraitSortie = true;
				return EspaceGroupementService.retirerSortie(groupementCourant(), $scope.reference,
					$scope.sortie.id);
			}).then(function () {
				toastr.success('Déclaration retirée.');
				return lireSortie();
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
					lireSortie();
				}
			}).finally(function () {
				$scope.retraitSortie = false;
			});
		};

		// -------------------------- Sortie de la démarche qualité (PHSQ-220, spécification § 8.2)

		/**
		 * L'état du bloc « Sortie de la démarche qualité » — les mêmes états que la sortie de
		 * groupement, lus sur le DTO tel que le CRM le sert, jamais recalculés :
		 *  - `null`           rien à montrer : aucune demande, ou une close annulée ou traitée — le
		 *                     bouton du bandeau revient ;
		 *  - `'indisponible'` la demande n'a pas pu être lue ;
		 *  - `'groupement'`   la sienne, ouverte ;
		 *  - `'refusee'`      la sienne, refusée ;
		 *  - `'officine'`     celle de l'officine, ouverte, en détail ;
		 *  - `'tiers'`        déposée par PHSQ ou par un autre groupement : forme amputée.
		 */
		$scope.etatSortieQualite = function () {
			var demande = $scope.sortieQualite;
			if ($scope.sortieQualiteErreur) {
				return 'indisponible';
			}
			if (!demande) {
				return null;
			}
			if (demande.issue) {
				return demande.issue === 'REFUSEE' && demande.origine === 'GROUPEMENT' && estComplete(demande)
					? 'refusee' : null;
			}
			if (!estComplete(demande)) {
				return 'tiers';
			}
			return demande.origine === 'OFFICINE' ? 'officine' : 'groupement';
		};

		/** La pastille de l'en-tête du bloc : deux états, puis l'issue (SQ13). Jamais une étape. */
		$scope.libelleEtatSortieQualite = function () {
			var demande = $scope.sortieQualite;
			if (!demande) {
				return '';
			}
			if (demande.issue === 'REFUSEE') {
				return 'Refusée';
			}
			return demande.etat === 'EN_COURS' ? 'En cours de traitement' : 'En attente de traitement';
		};

		/** Le bouton du bandeau : RESPONSABLE seul, tant qu'aucune demande n'occupe la place. */
		$scope.peutDeclarerSortieQualite = function () {
			return !!$scope.fiche && $scope.estResponsable() && !$scope.etatSortieQualite();
		};

		$scope.rechargerSortieQualite = function () {
			lireSortieQualite();
		};

		/**
		 * Le dialogue de déclaration. Il se ferme sur la demande transmise, ou sur le 409 — une
		 * demande est déjà ouverte, l'officine ou PHSQ ayant déclaré entre-temps : on relit alors la
		 * demande, pour montrer celle qui occupe la place.
		 */
		$scope.ouvrirDeclarationSortieQualite = function (event) {
			$mdDialog.show({
				templateUrl: 'app/main/front/groupement/pharmacie/declarer-sortie-qualite.dialog.html',
				controller: 'GroupementDeclarerSortieQualiteDialogController',
				locals: { fiche: $scope.fiche, groupementId: groupementCourant(), reference: $scope.reference },
				parent: angular.element($document[0].body),
				targetEvent: event,
				clickOutsideToClose: true
			}).then(function (issue) {
				if (issue && issue.conflit) {
					toastr.error(issue.message);
				} else {
					toastr.success('Demande de sortie de la démarche qualité transmise à PHSQ.');
				}
				lireSortieQualite();
			}).catch(angular.noop);
		};

		/**
		 * Retirer SA demande, tant que personne chez PHSQ ne s'en est saisi (SQ8) : le bouton ne
		 * s'affiche qu'alors. Si PHSQ l'a prise en charge entre-temps, le 409 le dit et la relecture
		 * montre la demande telle qu'elle est devenue.
		 */
		$scope.retirerDemandeSortieQualite = function (event) {
			if ($scope.retraitSortieQualite) {
				return;
			}
			ConfirmationGroupement.demander({
				titre: 'Retirer la demande',
				texte: "La demande de sortie de la démarche qualité est annulée : PHSQ n'aura rien à instruire, "
					+ "et l'officine reste dans la démarche qualité.",
				detail: $scope.fiche.nom,
				confirmer: 'Retirer la demande',
				annuler: 'Garder la demande',
				event: event
			}).then(function () {
				$scope.retraitSortieQualite = true;
				return EspaceGroupementService.retirerSortieQualite(groupementCourant(), $scope.reference,
					$scope.sortieQualite.id);
			}).then(function () {
				toastr.success('Demande retirée.');
				return lireSortieQualite();
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
					lireSortieQualite();
				}
			}).finally(function () {
				$scope.retraitSortieQualite = false;
			});
		};

		// ------------------------------------------------------------ Coordonnées (§6)

		/** Les huit champs modifiables, et eux seuls. Tout le reste de la fiche est en lecture. */
		$scope.ouvrirEdition = function () {
			var adresse = $scope.fiche.adresse || {};
			$scope.edition = {
				// Ajouté le 16/09/2026 : le réseau apprend le premier qu'une officine a changé de
				// code. Le CRM en contrôle l'unicité et conserve l'ancien dans son historique.
				codeCip: $scope.fiche.codeCip,
				nom: $scope.fiche.nom,
				sousGroupe: $scope.fiche.sousGroupe,
				numeroAdherent: $scope.fiche.numeroAdherent,
				rue: adresse.rue,
				adresseSuite: adresse.adresseSuite,
				codePostal: adresse.codePostal,
				ville: adresse.ville
			};
		};

		$scope.annulerEdition = function () {
			$scope.edition = null;
		};

		/**
		 * Les cinq champs que le CRM exige (code CIP, nom, adresse, code postal, ville).
		 *
		 * Le contrôle est refait ici pour retenir le clic : sans lui, l'aller-retour se solde par
		 * un 400 dont le message parle du CRM, sans dire lequel des champs manque.
		 *
		 * ⚠️ Le code CIP est une suite de CHIFFRES, comme à la saisie interne : un code collé
		 * depuis un tableur (« 2 003 643 ») partirait sinon casser la correspondance LQO ↔ CRM.
		 * La règle d'unicité, elle, ne peut être tranchée que par le CRM (409 à l'enregistrement).
		 */
		$scope.codeCipValide = function () {
			return /^[0-9]+$/.test((($scope.edition || {}).codeCip || '').trim());
		};

		$scope.coordonneesValides = function () {
			var saisie = $scope.edition;
			if (!saisie) {
				return false;
			}
			return !!($scope.codeCipValide() && (saisie.nom || '').trim() && (saisie.rue || '').trim()
				&& (saisie.codePostal || '').trim() && (saisie.ville || '').trim());
		};

		$scope.enregistrerCoordonnees = function () {
			if (!$scope.coordonneesValides()) {
				return;
			}
			if ($scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			EspaceGroupementService.modifierCoordonnees(groupementCourant(), $scope.reference, $scope.edition)
				.then(function (fiche) {
					$scope.fiche = fiche;
					$scope.edition = null;
					// La modification part dans le CRM dès l'enregistrement, sans validation
					// préalable de PHSQ (arbitrage 35) : on le dit, c'est un geste qui engage.
					toastr.success('Coordonnées enregistrées dans le CRM.');
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.enregistrement = false;
				});
		};

		// ------------------------------------------------------------ Contacts (16/09/2026)

		/**
		 * Un seul formulaire de contact ouvert à la fois — création OU modification.
		 *
		 * L'e-mail principal se saisit à la création ET se modifie ensuite (PHSQ-237, 13/10/2026 ;
		 * il était immuable). Le contact garde son identité dans le CRM ; l'ancienne adresse ne
		 * reste qu'au journal du CRM, et le compte LQO qui la porterait n'est pas renommé.
		 */
		var FORMAT_MAIL = /^[^\s@;,:]+@[^\s@;,:]+\.[^\s@;,:]{2,}$/;

		$scope.ouvrirCreationContact = function () {
			$scope.contactEdition = {
				id: null, mail: '', mailInitial: '', nom: '', prenom: '', telephone: '', mobile: '',
				mailSecondaire: ''
			};
		};

		$scope.ouvrirEditionContact = function (contact) {
			$scope.contactEdition = {
				id: contact.id,
				mail: contact.mail,
				mailInitial: (contact.mail || '').trim(),
				nom: contact.nom,
				prenom: contact.prenom,
				telephone: contact.telephone,
				mobile: contact.mobile,
				mailSecondaire: contact.mailSecondaire
			};
		};

		$scope.annulerEditionContact = function () {
			$scope.contactEdition = null;
		};

		/**
		 * L'e-mail est-il exigé ? En modification, dès que le contact en a un : une adresse posée ne
		 * s'efface pas. En création, sauf si le contact principal de l'officine en a déjà un valide
		 * (MET-685, 14/10/2026) — il faut alors au moins un nom ou un prénom. Le CRM juge en dernier.
		 */
		$scope.mailObligatoire = function () {
			var saisie = $scope.contactEdition;
			if (!saisie) {
				return true;
			}
			if (saisie.id) {
				return !!saisie.mailInitial;
			}
			return !($scope.contacts || []).some(function (contact) {
				return contact.principal && FORMAT_MAIL.test((contact.mail || '').trim());
			});
		};

		/** Le champ e-mail est-il en défaut : adresse mal formée, ou absente alors qu'exigée ? */
		$scope.mailEnDefaut = function () {
			var saisie = $scope.contactEdition;
			if (!saisie) {
				return false;
			}
			var mail = (saisie.mail || '').trim();
			return mail !== '' ? !FORMAT_MAIL.test(mail) : $scope.mailObligatoire();
		};

		/**
		 * Pourquoi la saisie ne peut pas partir, ou null. Même forme d'adresse que le CRM : le
		 * contrôle retient le clic plutôt que le 400.
		 */
		$scope.motifSaisie = function () {
			var saisie = $scope.contactEdition;
			if (!saisie) {
				return null;
			}
			if ($scope.mailEnDefaut()) {
				return !saisie.id && !(saisie.mail || '').trim()
					? "E-mail obligatoire : le contact principal n'en a pas de valide."
					: 'Un e-mail valide est obligatoire.';
			}
			if (!(saisie.mail || '').trim() && !saisie.id
					&& !(saisie.nom || '').trim() && !(saisie.prenom || '').trim()) {
				return 'Sans e-mail, renseignez au moins un nom ou un prénom.';
			}
			return null;
		};

		$scope.contactValide = function () {
			return !!$scope.contactEdition && $scope.motifSaisie() === null;
		};

		/** L'e-mail saisi remplace-t-il une adresse existante ? L'écran prévient alors. */
		$scope.mailRemplace = function () {
			var saisie = $scope.contactEdition;
			if (!saisie || !saisie.id || !saisie.mailInitial) {
				return false;
			}
			var mail = (saisie.mail || '').trim().toLowerCase();
			return mail !== '' && mail !== saisie.mailInitial.toLowerCase();
		};

		/**
		 * Enregistre la saisie — création ou modification — et remplace la liste par celle que
		 * rend le CRM. On ne recompose pas l'état local : le serveur seul sait ce qu'il a retenu
		 * (ordre des contacts, contact principal déchu, e-mail normalisé en minuscules).
		 */
		$scope.enregistrerContact = function () {
			var saisie = $scope.contactEdition;
			if (!saisie || !$scope.contactValide() || $scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			// ⚠️ Le corps est RECOMPOSÉ champ par champ : le CRM refuse tout champ hors contrat
			// (400), et `id` — qui n'est qu'un repère d'écran — en fait partie.
			var corps = {
				nom: saisie.nom,
				prenom: saisie.prenom,
				telephone: saisie.telephone,
				mobile: saisie.mobile,
				mailSecondaire: saisie.mailSecondaire
			};
			var mail = (saisie.mail || '').trim();
			var appel;
			if (saisie.id) {
				// N'envoyer `mail` que s'il change : absent, le CRM laisse l'adresse en place.
				if (mail !== '' && mail.toLowerCase() !== (saisie.mailInitial || '').toLowerCase()) {
					corps.mail = mail;
				}
				appel = EspaceGroupementService.modifierContact(groupementCourant(), $scope.reference,
					saisie.id, corps);
			} else {
				if (mail !== '') {
					corps.mail = mail;
				}
				appel = EspaceGroupementService.creerContact(groupementCourant(), $scope.reference, corps);
			}
			appel.then(function (contacts) {
				$scope.contacts = contacts || [];
				$scope.contactEdition = null;
				toastr.success(saisie.id ? 'Contact enregistré dans le CRM.' : 'Contact ajouté dans le CRM.');
			}).catch(function (erreur) {
				toastr.error(erreur.message);
			}).finally(function () {
				$scope.enregistrement = false;
			});
		};

		/**
		 * Archivage : le contact sort de la liste active de l'officine, et le CRM le déchoit au
		 * passage s'il était le contact principal. Confirmation demandée — c'est un geste visible
		 * de PHSQ comme du réseau.
		 */
		$scope.archiverContact = function (contact, event) {
			ConfirmationGroupement.demander({
				titre: 'Archiver ce contact',
				texte: "Il n'apparaîtra plus dans les contacts actifs de l'officine, ni dans le CRM. "
					+ 'PHSQ peut le réactiver.',
				detail: [contact.prenom, contact.nom].join(' ').trim() || contact.mail,
				confirmer: 'Archiver',
				event: event
			}).then(function () {
				return EspaceGroupementService.archiverContact(groupementCourant(), $scope.reference, contact.id);
			}).then(function (contacts) {
				$scope.contacts = contacts || [];
				toastr.success('Contact archivé.');
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
				}
			});
		};

		/** Contact principal : celui que PHSQ appelle en premier. Un seul par officine. */
		$scope.definirContactPrincipal = function (contact) {
			if ($scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			EspaceGroupementService.definirContactPrincipal(groupementCourant(), $scope.reference, contact.id)
				.then(function (contacts) {
					$scope.contacts = contacts || [];
					toastr.success('Contact principal mis à jour.');
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.enregistrement = false;
				});
		};

		/**
		 * Palier de couleur d'un score d'auto-évaluation, aux seuils du CRM :
		 * vert à partir de 80, orange de 60 à 80, rouge en dessous.
		 *
		 * ⚠️ Un score absent n'est PAS un zéro. Le CRM affiche « 0.00 » en rouge dans ce cas, ce
		 * qui se lit comme une contre-performance alors que l'évaluation n'a simplement pas de
		 * note. On rend ici un palier distinct, affiché en tiret.
		 */
		$scope.niveauScore = function (score) {
			if (score === null || angular.isUndefined(score) || score === '') {
				return 'absent';
			}
			var valeur = Number(score);
			if (!isFinite(valeur)) {
				return 'absent';
			}
			if (valeur >= 80) {
				return 'bon';
			}
			return valeur >= 60 ? 'moyen' : 'faible';
		};

		/** Largeur de la jauge, bornée : un score au-delà de 100 déborderait de son rail. */
		$scope.largeurScore = function (score) {
			var valeur = Number(score);
			if (!isFinite(valeur) || valeur < 0) {
				return 0;
			}
			return Math.min(100, valeur);
		};

		// ------------------------------------------------- Commentaires (arbitrages 33 et 36)

		$scope.ajouterCommentaire = function () {
			var contenu = ($scope.saisieCommentaire.contenu || '').trim();
			if (!contenu || $scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			EspaceGroupementService.ajouterCommentaire(groupementCourant(), $scope.reference, contenu)
				.then(function (commentaire) {
					$scope.fiche.commentaires.unshift(commentaire);
					$scope.saisieCommentaire.contenu = '';
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.enregistrement = false;
				});
		};

		/**
		 * Un commentaire ne se modifie pas ; son auteur peut le supprimer (arbitrage 36).
		 * L'action n'est proposée qu'à lui : les notes de PHSQ et les reprises restent visibles
		 * mais intouchables.
		 */
		$scope.peutSupprimerCommentaire = function (commentaire) {
			var moi = $rootScope.user && $rootScope.user.id;
			return !!commentaire.auteurLqoUserId && String(commentaire.auteurLqoUserId) === String(moi);
		};

		/**
		 * ⚠️ La suppression est DÉFINITIVE et immédiate côté CRM — il n'y a ni corbeille ni
		 * annulation, et le journal du CRM ne conserve pas le texte supprimé. D'où la confirmation.
		 *
		 * La chaîne rejette dans deux cas : le renoncement, sans valeur, et l'échec de l'appel,
		 * avec l'erreur. Sans le test `if (erreur)`, refuser la confirmation afficherait un
		 * bandeau d'erreur alors que rien n'a échoué.
		 */
		$scope.supprimerCommentaire = function (commentaire, event) {
			ConfirmationGroupement.demander({
				titre: 'Supprimer ce commentaire',
				texte: 'Il sera définitivement retiré de la fiche dans le CRM. Cette action est irréversible.',
				detail: commentaire.contenu,
				confirmer: 'Supprimer',
				event: event
			}).then(function () {
				return EspaceGroupementService.supprimerCommentaire(groupementCourant(),
					$scope.reference, commentaire.id);
			}).then(function () {
				var index = $scope.fiche.commentaires.indexOf(commentaire);
				if (index >= 0) {
					$scope.fiche.commentaires.splice(index, 1);
				}
				toastr.success('Commentaire supprimé.');
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
				}
			});
		};

		// ------------------------------------------------ Documents (arbitrages 18, 19, 34)

		$scope.choisirFichier = function (element) {
			$scope.$apply(function () {
				$scope.depot.fichier = element.files && element.files[0] ? element.files[0] : null;
			});
		};

		$scope.deposerDocument = function () {
			if (!$scope.depot.fichier || $scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			EspaceGroupementService.deposerDocument(groupementCourant(), $scope.reference,
				$scope.depot.fichier, $scope.depot.titre)
				.then(function (doc) {
					$scope.fiche.documents.unshift(doc);
					$scope.depot = { titre: '', fichier: null };
					toastr.success('Document déposé.');
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.enregistrement = false;
				});
		};

		/** Même règle que pour un commentaire : le fichier est retiré du CRM sans retour possible. */
		$scope.supprimerDocument = function (doc, event) {
			ConfirmationGroupement.demander({
				titre: 'Supprimer ce document',
				texte: 'Il sera définitivement supprimé du CRM. Cette action est irréversible.',
				// Le nom du fichier est rappelé : sur une fiche qui en compte plusieurs, c'est le
				// seul moyen de vérifier qu'on supprime celui qu'on visait.
				detail: doc.titre || doc.nom,
				confirmer: 'Supprimer',
				event: event
			}).then(function () {
				return EspaceGroupementService.supprimerDocument(groupementCourant(),
					$scope.reference, doc.id);
			}).then(function () {
				var index = $scope.fiche.documents.indexOf(doc);
				if (index >= 0) {
					$scope.fiche.documents.splice(index, 1);
				}
				toastr.success('Document supprimé.');
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
				}
			});
		};

		$scope.telechargerDocument = function (doc) {
			EspaceGroupementService.telechargerDocument(groupementCourant(), doc.id,
				doc.titre || doc.nom).catch(function (erreur) {
					toastr.error(erreur.message);
				});
		};

		$scope.exporterFiche = function () {
			if ($scope.exportFiche) {
				return;
			}
			$scope.exportFiche = true;
			EspaceGroupementService.exporterFicheWord(groupementCourant(), $scope.reference, $scope.fiche.nom)
				.catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.exportFiche = false;
				});
		};

		$scope.ouvrirAudit = function (audit) {
			$state.go('app.groupement.audit', { reference: $scope.reference, auditId: audit.id });
		};

		$scope.retourListe = function () {
			$state.go('app.groupement.pharmacies');
		};

		chargerFiche();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('GroupementDeclarerSortieDialogController',
		GroupementDeclarerSortieDialogController);

	/**
	 * Écran 2 du chapitre 06 — déclarer la sortie de l'officine qu'on a sous les yeux.
	 *
	 * Deux champs, tous deux facultatifs (R17) : un envoi à vide est une déclaration valide. PAS de
	 * groupement de destination : un groupement qui perd une officine ignore généralement où elle
	 * va, et le CRM refuse le champ en 400.
	 *
	 * Se ferme sur `{ declaration }` une fois la déclaration transmise, ou sur `{ conflit, message }`
	 * quand une déclaration est déjà ouverte (R3, 409) : la fiche relit alors la déclaration qui
	 * occupe la place. Toute autre erreur reste affichée dans le dialogue, la saisie intacte.
	 */
	/** @ngInject */
	function GroupementDeclarerSortieDialogController($scope, $mdDialog, EspaceGroupementService, fiche,
		groupementId, reference) {

		$scope.fiche = fiche;
		// `null` tant que la liste n'est pas là : le champ reste inerte plutôt que de montrer une
		// liste vide qu'on prendrait pour un référentiel vide.
		$scope.causes = null;
		$scope.erreurCauses = null;
		$scope.saisie = { motifId: null, precisions: '' };
		$scope.envoi = false;
		$scope.erreur = null;

		// La même liste que le formulaire de l'officine (R17) : c'est ce qui rend les statistiques
		// de PHSQ comparables d'une source à l'autre.
		EspaceGroupementService.causesSortie(groupementId).then(function (causes) {
			$scope.causes = causes || [];
		}).catch(function (erreur) {
			$scope.causes = [];
			$scope.erreurCauses = erreur.message;
		});

		$scope.valider = function () {
			if ($scope.envoi) {
				return;
			}
			$scope.envoi = true;
			$scope.erreur = null;
			var precisions = String($scope.saisie.precisions || '').trim();
			// ⚠️ Deux clés, et pas une de plus : une clé de destination, même vide, n'a rien à faire
			// dans un dépôt de groupement.
			var corps = { motifId: $scope.saisie.motifId || null, precisions: precisions || null };
			EspaceGroupementService.declarerSortie(groupementId, reference, corps).then(function (declaration) {
				$mdDialog.hide({ declaration: declaration });
			}).catch(function (erreur) {
				if (erreur.status === 409) {
					$mdDialog.hide({ conflit: true, message: erreur.message });
					return;
				}
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('GroupementDeclarerSortieQualiteDialogController',
		GroupementDeclarerSortieQualiteDialogController);

	/**
	 * Espace groupement — déclarer la sortie de la démarche qualité de l'officine qu'on a sous les
	 * yeux (spécification sortie-qualite § 5.1 et § 8.2), sur le modèle exact de la déclaration de
	 * sortie de groupement.
	 *
	 * Trois champs : les raisons (au moins une), la date effective souhaitée (obligatoire,
	 * aujourd'hui ou plus tard), les commentaires (facultatifs). PAS de recommandation ni
	 * d'engagements : seule l'officine peut s'engager, PHSQ les recueille pendant le traitement — et
	 * le CRM refuse ces champs en 400.
	 *
	 * Se ferme sur `{ demande }` une fois la demande transmise, ou sur `{ conflit, message }` quand
	 * une demande est déjà ouverte pour l'officine (409) : la fiche relit alors celle qui occupe la
	 * place. Toute autre erreur reste affichée dans le dialogue, la saisie intacte.
	 */
	/** @ngInject */
	function GroupementDeclarerSortieQualiteDialogController($scope, $mdDialog, EspaceGroupementService, fiche,
		groupementId, reference) {

		$scope.fiche = fiche;
		// `null` tant que la liste n'est pas là : on ne montre pas une liste vide qu'on prendrait pour
		// un référentiel vide.
		$scope.raisons = null;
		$scope.erreurRaisons = null;
		$scope.aujourdhui = versIso(new Date());
		// Un OBJET, pour que les `ng-model` des champs atteignent le contrôleur (portées filles).
		$scope.saisie = { raisons: {}, raisonPrecision: '', dateSouhaitee: null, commentaires: '' };
		$scope.tentative = false;
		$scope.envoi = false;
		$scope.erreur = null;

		/** Une `Date` du poste → `AAAA-MM-JJ`, sur le jour LOCAL. */
		function versIso(date) {
			if (!angular.isDate(date) || isNaN(date.getTime())) {
				return null;
			}
			return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-'
				+ ('0' + date.getDate()).slice(-2);
		}

		EspaceGroupementService.raisonsSortieQualite(groupementId).then(function (raisons) {
			$scope.raisons = raisons || [];
		}).catch(function (erreur) {
			$scope.raisons = [];
			$scope.erreurRaisons = erreur.message;
		});

		$scope.raisonsChoisies = function () {
			return ($scope.raisons || []).filter(function (raison) {
				return !!$scope.saisie.raisons[raison.id];
			}).map(function (raison) {
				return raison.id;
			});
		};

		/**
		 * La première raison cochée qui exige une précision (« Autre », 12/10/2026), ou null : elle fait
		 * paraître la zone « Précisez la raison », obligatoire.
		 */
		$scope.raisonExigeante = function () {
			return ($scope.raisons || []).filter(function (raison) {
				return raison.precisionRequise && !!$scope.saisie.raisons[raison.id];
			})[0] || null;
		};

		$scope.manquePrecision = function () {
			return !!$scope.raisonExigeante() && !String($scope.saisie.raisonPrecision || '').trim();
		};

		/** La date choisie en `AAAA-MM-JJ`, ou `null` si elle manque ou précède aujourd'hui. */
		$scope.dateValide = function () {
			var iso = versIso($scope.saisie.dateSouhaitee);
			return iso && iso >= $scope.aujourdhui ? iso : null;
		};

		$scope.valider = function () {
			$scope.tentative = true;
			$scope.erreur = null;
			var raisonIds = $scope.raisonsChoisies();
			var dateSouhaitee = $scope.dateValide();
			if ($scope.envoi || !raisonIds.length || !dateSouhaitee || $scope.manquePrecision()) {
				return;
			}
			var commentaires = String($scope.saisie.commentaires || '').trim();
			// ⚠️ Ni `nps` ni `engagements` dans un dépôt de groupement. La précision ne part que si une
			// raison cochée l'exige (12/10/2026).
			var corps = {
				raisonIds: raisonIds,
				raisonPrecision: $scope.raisonExigeante() ? String($scope.saisie.raisonPrecision || '').trim() : null,
				dateSouhaitee: dateSouhaitee,
				commentaires: commentaires || null
			};
			$scope.envoi = true;
			EspaceGroupementService.declarerSortieQualite(groupementId, reference, corps).then(function (demande) {
				$mdDialog.hide({ demande: demande });
			}).catch(function (erreur) {
				if (erreur.status === 409) {
					$mdDialog.hide({ conflit: true, message: erreur.message });
					return;
				}
				$scope.erreur = erreur.message;
			}).finally(function () {
				$scope.envoi = false;
			});
		};

		$scope.fermer = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalGroupementPharmacieController',
		AutoEvalGroupementPharmacieController);

	/**
	 * Le détail d'une officine validée, vu par son groupement (spécification §5).
	 *
	 * ⚠️ C'est une SOUS-PAGE avec sa propre adresse, partageable entre collègues — le même parti
	 * pris que la fiche pharmacie de « Mes pharmacies ».
	 *
	 * ⚠️ Le retour ramène à la liste TELLE QU'ELLE ÉTAIT : `$state.previous` conserve les filtres
	 * et la page. Sans cela, le pilote qui ouvre la dixième officine d'une liste filtrée revient
	 * sur une première page non filtrée, et doit tout refaire à chaque consultation.
	 */
	/** @ngInject */
	function AutoEvalGroupementPharmacieController($scope, $state, $stateParams,
			AutoEvalGroupementService, UserService) {

		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.soumissionId = $stateParams.soumissionId;
		$scope.chargement = true;
		$scope.erreur = null;
		$scope.detail = null;

		$scope.aUneValeur = AutoEvalGroupementService.aUneValeur;

		// Nombre de points d'attention affichés d'emblée ; la liste complète s'ouvre d'un lien
		// (spécification §5). Huit : une officine en difficulté peut en déclencher trente.
		$scope.LIMITE_POINTS = 8;
		$scope.tousLesPoints = false;

		$scope.pointsAffiches = function () {
			var points = $scope.detail ? $scope.detail.pointsAttention || [] : [];
			return $scope.tousLesPoints ? points : points.slice(0, $scope.LIMITE_POINTS);
		};

		/** Les chapitres concernés, seuls à porter une barre : un chapitre sauté n'a pas de répartition. */
		$scope.chapitresConcernes = function () {
			var lignes = [];
			angular.forEach($scope.detail ? $scope.detail.chapitres : [], function (ligne) {
				if (ligne.concerne) {
					lignes.push(ligne);
				}
			});
			return lignes;
		};

		var MODALITES = ['OUI', 'EN_COURS', 'NON', 'NON_CONCERNE'];
		$scope.legendeModalites = function (palette) {
			var items = [];
			angular.forEach(MODALITES, function (valeur) {
				angular.forEach(palette || [], function (item) {
					if (item.valeur === valeur) {
						items.push(item);
					}
				});
			});
			return items;
		};

		AutoEvalGroupementService.getPharmacie($scope.annee, $scope.soumissionId,
				UserService.getSelectedGroupementId())
			.then(function (detail) {
				$scope.detail = detail;
				$scope.chargement = false;
			}).catch(function (erreur) {
				$scope.chargement = false;
				$scope.erreur = erreur;
			});

		$scope.retour = function () {
			// ⚠️ La forme est `{fromState, fromParams}` — celle que pose `index.run.js`, et non
			// celle d'une bibliothèque tierce.
			var precedent = $state.previous;
			if (precedent && precedent.fromState && precedent.fromState.name === 'app.groupement.autoeval') {
				$state.go(precedent.fromState.name, precedent.fromParams);
				return;
			}
			$state.go('app.groupement.autoeval', { annee: $scope.annee, tab: 'pharmacies' });
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').service('AutoEvalGroupementService', AutoEvalGroupementService);

	/**
	 * Accès à l'espace groupement de l'auto-évaluation qualité PHSQ.
	 *
	 * ⚠️ `groupementId` est le CODE CRM que le sélecteur de la barre du haut fournit. Il ne peut
	 * que RESTREINDRE le périmètre du compte : le serveur relit les droits à chaque appel, et un
	 * code hors périmètre rend 404. L'envoyer n'ouvre donc jamais rien — l'omettre donne la vue
	 * consolidée sur tous les réseaux de l'utilisateur.
	 *
	 * ⚠️ Gson omet les champs nuls : un pourcentage absent n'est pas zéro, c'est le tiret « — »
	 * de la spécification. Les écrans testent l'absence de clé, jamais `=== 0`.
	 */
	function AutoEvalGroupementService($q, $http, $window, $document) {
		var BASE = '/api/rest/autoEvaluation/groupement';

		var MESSAGE_ERREUR = 'Une erreur est survenue, veuillez réessayer plus tard.';

		function params(groupementId, extra) {
			var query = angular.extend({ '_v': new Date().getTime() }, extra || {});
			if (groupementId) {
				query.groupementId = groupementId;
			}
			// Les valeurs vides ne partent pas : un filtre vide est une condition inutile de plus.
			angular.forEach(query, function (valeur, cle) {
				if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
					delete query[cle];
				}
			});
			return query;
		}

		function get(url, query) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: query,
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		function toError(response) {
			var status = response ? response.status : 0;
			var data = response ? response.data : null;
			return {
				status: status,
				code: data && data.code ? data.code : null,
				message: (data && data.message) ? data.message
					: (status === 404 ? 'Cet élément ne fait pas partie de votre périmètre.' : MESSAGE_ERREUR)
			};
		}

		this.aUneValeur = function (valeur) {
			return valeur !== null && angular.isDefined(valeur);
		};

		this.getMillesimes = function () {
			return get(BASE + '/millesimes', params(null));
		};

		/** La boîte à outils du millésime et ses dates : la seule lecture admise avant l'ouverture. */
		this.getBoiteAOutils = function (annee) {
			return get(BASE + '/' + annee + '/boite-a-outils', params(null));
		};

		this.getDashboard = function (annee, groupementId) {
			return get(BASE + '/' + annee + '/dashboard', params(groupementId));
		};

		this.getResultats = function (annee, groupementId, anneeEngagement) {
			return get(BASE + '/' + annee + '/resultats',
				params(groupementId, { anneeEngagement: anneeEngagement }));
		};

		this.getPharmacies = function (annee, groupementId, query) {
			return get(BASE + '/' + annee + '/pharmacies', params(groupementId, query));
		};

		this.getPharmacie = function (annee, soumissionId, groupementId) {
			return get(BASE + '/' + annee + '/pharmacie/' + soumissionId, params(groupementId));
		};

		/**
		 * La fenêtre « Accès de l'officine » (21/10/2026) : comptes, e-mails de la campagne déjà
		 * envoyés, et ce que permet un renvoi du lancement. Toute officine du périmètre.
		 */
		this.getAcces = function (annee, soumissionId, groupementId) {
			return get(BASE + '/' + annee + '/pharmacie/' + soumissionId + '/acces', params(groupementId));
		};

		/**
		 * Renvoie l'e-mail de lancement à l'officine et rend la fenêtre à jour. Un refus — délai de
		 * quinze minutes, officine validée entre-temps — revient en 409 avec sa phrase.
		 */
		this.renvoyerLancement = function (annee, soumissionId, groupementId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE + '/' + annee + '/pharmacie/' + soumissionId + '/lancement',
					method: 'POST',
					params: params(groupementId)
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		};

		this.getProfil = function (annee, groupementId, anneeEngagement) {
			return get(BASE + '/' + annee + '/profil',
				params(groupementId, { anneeEngagement: anneeEngagement }));
		};

		/** « Focus du réseau » : la part des officines qui déclenchent chaque focus. */
		this.getFocus = function (annee, groupementId, anneeEngagement) {
			return get(BASE + '/' + annee + '/focus',
				params(groupementId, { anneeEngagement: anneeEngagement }));
		};

		this.getDemandesContact = function (annee, groupementId) {
			return get(BASE + '/' + annee + '/demandes-contact', params(groupementId));
		};

		/**
		 * Onglet « Satisfaction » : le Baromètre du réseau comparé au national, puis les réponses
		 * nominatives de chaque officine (décision PHSQ du 17/10/2026).
		 */
		this.getSatisfaction = function (annee, groupementId) {
			return get(BASE + '/' + annee + '/satisfaction', params(groupementId));
		};

		this.getSatisfactionOfficines = function (annee, groupementId, query) {
			return get(BASE + '/' + annee + '/satisfaction/officines', params(groupementId, query));
		};

		// ---------------------------------------------------------------- exports

		this.exporter = function (annee, type, groupementId, anneeEngagement) {
			return download(BASE + '/' + annee + '/export',
				params(groupementId, { type: type, anneeEngagement: anneeEngagement }),
				'auto-evaluation-' + annee + '-' + type + '.xlsx');
		};

		/**
		 * LE RAPPORT DE SYNTHÈSE du réseau : la feuille du groupement, au format du classeur que
		 * PHSQ relit d'une année sur l'autre.
		 */
		this.exporterRapportSynthese = function (annee, groupementId) {
			return download(BASE + '/' + annee + '/export/rapport-synthese', params(groupementId),
				'Autoevaluation_PHSQ_Synthese' + annee + '.xlsx');
		};

		/** L'export « Satisfaction » du réseau : répartition, puis une ligne par officine. */
		this.exporterSatisfaction = function (annee, groupementId) {
			return download(BASE + '/' + annee + '/export/satisfaction', params(groupementId),
				'Autoevaluation_' + annee + '_Satisfaction.xlsx');
		};

		this.demanderArchive = function (annee, groupementId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE + '/' + annee + '/export/rapports',
					method: 'POST',
					params: params(groupementId)
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		};

		this.getArchive = function (id) {
			return get(BASE + '/export/' + id, params(null));
		};

		this.getArchives = function (annee) {
			return get(BASE + '/' + annee + '/exports', params(null));
		};

		this.telechargerArchive = function (id) {
			return download(BASE + '/export/' + id + '/fichier', params(null), 'rapports.zip');
		};

		/**
		 * Télécharge un flux binaire en respectant le nom proposé par le serveur.
		 *
		 * ⚠️ Le lien est créé puis retiré : un `href` direct ne permettrait pas de nommer le
		 * fichier d'après l'en-tête `Content-Disposition`.
		 */
		function download(url, query, nomParDefaut) {
			return $q(function (resolve, reject) {
				$http({ url: url, method: 'GET', params: query, responseType: 'arraybuffer' })
					.then(function (response) {
						var type = (response.headers('Content-Type') || 'application/octet-stream').split(';')[0];
						var blob = new Blob([response.data], { type: type });
						var nom = parseFilename(response.headers('Content-Disposition')) || nomParDefaut;
						var objectUrl = $window.URL.createObjectURL(blob);
						var racine = $document[0];
						var lien = racine.createElement('a');
						lien.href = objectUrl;
						lien.download = nom;
						racine.body.appendChild(lien);
						lien.click();
						racine.body.removeChild(lien);
						$window.URL.revokeObjectURL(objectUrl);
						resolve(nom);
					}).catch(function (response) {
						reject(toError(response));
					});
			});
		}

		function parseFilename(disposition) {
			if (!disposition) {
				return null;
			}
			var utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
			if (utf8 && utf8[1]) {
				try {
					return decodeURIComponent(utf8[1]);
				} catch (error) {
					return utf8[1];
				}
			}
			var simple = /filename="?([^";]+)"?/i.exec(disposition);
			return simple && simple[1] ? simple[1] : null;
		}
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalGroupementController', AutoEvalGroupementController);

	/**
	 * L'ESPACE GROUPEMENT de l'auto-évaluation : quatre onglets pour un millésime (spécification §5).
	 *
	 * ⚠️ L'ONGLET EST DANS L'ADRESSE. Un pilote qualité envoie à un collègue le lien de ce qu'il
	 * regarde ; l'ancien écran de restitution changeait d'onglet sans changer d'URL, et l'on ne
	 * pouvait pas partager une vue précise. Le rechargement du contrôleur est évité par
	 * `reloadOnSearch: false` sur l'état.
	 *
	 * ⚠️ TOUT EST PROVISOIRE tant que la campagne est ouverte. Le bandeau qui le dit n'est pas une
	 * politesse : un taux de participation de 40 % en novembre se lit comme un résultat si rien ne
	 * précise qu'il reste un mois de campagne.
	 *
	 * ⚠️ AUCUN SEUIL D'ANONYMAT — décision assumée de la spécification. Le pilote voit ses
	 * officines une par une, y compris dans un réseau de trois. L'écran le rappelle.
	 */
	/** @ngInject */
	function AutoEvalGroupementController($scope, $rootScope, $state, $stateParams, $timeout, $filter,
			AutoEvalGroupementService, AeqAccesOfficine, UserService, toastr) {

		var TAILLE_PAGE = 25;
		var DELAI_RECHERCHE = 350;

		// Les résultats en dernier, à la demande de PHSQ : le pilote suit d'abord le remplissage. La
		// satisfaction s'ajoute après eux (décision PHSQ du 17/10/2026).
		var ONGLETS = ['dashboard', 'pharmacies', 'profil', 'resultats', 'satisfaction'];
		var LIBELLES_ONGLETS = {
			dashboard: 'Tableau de bord',
			resultats: 'Résultats',
			pharmacies: 'Pharmacies',
			profil: 'Profil',
			satisfaction: 'Satisfaction'
		};
		var LIBELLES_PHASES = {
			A_VENIR: 'Campagne à venir',
			OUVERTE: 'Campagne en cours',
			PROLONGATION: 'Prolongation',
			CLOTUREE: 'Campagne clôturée'
		};
		// Les quatre modalités d'une question standard, dans l'ordre de lecture des barres.
		var MODALITES = ['OUI', 'EN_COURS', 'NON', 'NON_CONCERNE'];
		// Largeur de la barre de pages : la même que la liste des soumissions de l'administration.
		var LARGEUR_PAGINATION = 9;

		/**
		 * Le filtre de statut ne propose que les statuts POSSIBLES dans l'état de la campagne,
		 * comme le suivi de l'administration : « Non répondues » sur une campagne ouverte rendait
		 * un tableau vide. Une fois la campagne clôturée, « Proposées au passage ENC » réunit
		 * partielles et non répondues (recette groupement, ligne 10) — la valeur ENC est
		 * traduite côté serveur.
		 *
		 * Des CONSTANTES : un ng-repeat sur un tableau recréé à chaque lecture relancerait le
		 * cycle d'Angular sans fin.
		 */
		var STATUTS_CAMPAGNE_OUVERTE = [
			{ code: 'VALIDEE', libelle: 'Validées' },
			{ code: 'EN_COURS', libelle: 'En cours' },
			{ code: 'ROUVERTE', libelle: 'Rouvertes' },
			{ code: 'NON_COMMENCEE', libelle: 'Non commencées' }
		];
		var STATUTS_CAMPAGNE_CLOTUREE = [
			{ code: 'VALIDEE', libelle: 'Validées' },
			{ code: 'PARTIELLE', libelle: 'Partielles' },
			{ code: 'NON_REPONDUE', libelle: 'Non répondues' },
			{ code: 'ENC', libelle: 'Proposées au passage ENC' }
		];

		// La colonne Vigilance (recette groupement, ligne 9) : infobulle de l'en-tête, de la
		// pastille, et note sous le tableau.
		$scope.DEFINITION_ALERTE = 'une officine validée dont la synthèse compte moins de 60 % de « Oui » '
			+ 'est signalée en vigilance : un point d’attention pour l’accompagnement, pas une sanction. '
			+ 'Une auto-évaluation non validée n’est jamais signalée. Un clic sur l’en-tête remet ces '
			+ 'officines en tête de liste.';

		// La colonne Satisfaction (17/10/2026) : infobulle de l'en-tête et note sous le tableau.
		$scope.DEFINITION_SATISFACTION = 'le nombre de questions du chapitre « Votre satisfaction » '
			+ 'auxquelles l’officine a répondu « Insatisfait » ou « Très insatisfait ». Une alerte '
			+ 's’affiche dès la première ; un clic dessus ouvre ses réponses et son commentaire dans '
			+ 'l’onglet Satisfaction. Une auto-évaluation non validée n’a pas encore de réponse. Un clic '
			+ 'sur l’en-tête remet les officines insatisfaites en tête de liste, les plus nombreuses d’abord.';

		// La colonne Compte titulaire (21/10/2026) : infobulle de l'en-tête et note sous le tableau.
		$scope.DEFINITION_COMPTE = '« Activé » quand le titulaire a créé son mot de passe ; la date est celle de '
			+ 'sa dernière connexion à LQO. Un clic sur l’état montre les comptes de l’officine, leurs adresses '
			+ 'et les e-mails de la campagne qu’elle a reçus. Tant que la campagne est ouverte, « Renvoyer '
			+ 'l’e-mail » renvoie à une officine non validée l’e-mail de lancement de la campagne.';

		// Le filtre « Compte titulaire » : les officines à appeler avant qu'elles n'appellent. Une
		// CONSTANTE, pour la même raison que les statuts.
		$scope.FILTRES_COMPTE = [
			{ code: 'NON_ACTIVE', libelle: 'Titulaire non activé' },
			{ code: 'JAMAIS_CONNECTE', libelle: 'Titulaire jamais connecté' }
		];
		var TITRES_COMPTE = {
			ACTIVE: 'Le titulaire a créé son mot de passe.',
			NON_ACTIVE: 'Le titulaire n’a pas encore créé son mot de passe.',
			SANS_ADRESSE: 'Le compte titulaire n’a pas d’adresse e-mail : il ne peut pas se connecter.',
			AUCUN: 'L’officine n’a pas de compte titulaire actif.'
		};

		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.onglets = ONGLETS;
		$scope.onglet = ONGLETS.indexOf($stateParams.tab) >= 0 ? $stateParams.tab : 'dashboard';
		$scope.chargement = {};
		$scope.erreur = null;

		$scope.dashboard = null;
		$scope.resultats = null;
		$scope.pharmacies = null;
		$scope.profil = null;
		$scope.focusReseau = null;
		$scope.archives = [];
		$scope.segmentsCompletion = [];
		// La boîte à outils du millésime, et si la campagne est encore À VENIR (programmée) : la page
		// se réduit alors aux dates et aux documents, sans onglets.
		$scope.boite = null;
		$scope.aVenir = false;
		// Le millésime repris (2025) n'est pas ouvert aux réseaux : il n'est plus au menu, et un
		// ancien lien n'affiche que le message du serveur, sans onglets.
		$scope.ferme = false;

		// ⚠️ LES FILTRES VIVENT SUR UN OBJET, ET C'EST OBLIGATOIRE. Les onglets de cet écran sont
		// rendus sous des `ng-if`, qui créent un SCOPE ENFANT : un `ng-model` posé sur une variable
		// simple du contrôleur y écrit une copie qui masque l'originale, et le contrôleur relit
		// indéfiniment la valeur vide. Recherche, statut et année d'engagement étaient muets pour
		// cette seule raison. Le point suffit, comme pour `tri` et `pagination` juste en dessous.
		//
		// ⚠️ Recherche, statut, tri et page sont RELUS DEPUIS L'ADRESSE : le retour depuis le
		// détail d'une officine recrée ce contrôleur, et sans cela le pilote qui ouvre la dixième
		// officine d'une liste filtrée revenait sur une première page non filtrée.
		$scope.filtres = {
			anneeEngagement: null,
			recherche: $stateParams.q || '',
			statut: $stateParams.statut || '',
			compte: $stateParams.compte || ''
		};
		$scope.tri = { colonne: $stateParams.tri || 'alerte', sens: $stateParams.sens === 'desc' ? 'desc' : 'asc' };
		$scope.pagination = { page: Math.max(1, parseInt($stateParams.page, 10) || 1), taille: TAILLE_PAGE, total: 0 };
		$scope.exportEnCours = false;

		var minuteurRecherche = null;
		var minuteurArchive = null;

		function groupementCourant() {
			return UserService.getSelectedGroupementId();
		}

		$scope.aUneValeur = AutoEvalGroupementService.aUneValeur;

		$scope.libelleOnglet = function (onglet) {
			if ($scope.aVenir) {
				return LIBELLES_PHASES.A_VENIR;
			}
			return LIBELLES_ONGLETS[onglet] || onglet;
		};

		$scope.libellePhase = function (phase) {
			return LIBELLES_PHASES[phase] || phase || '';
		};

		/**
		 * La légende des barres : les quatre modalités standards, dans les couleurs de la
		 * palette du millésime — jamais d'une table codée ici (spécification §3).
		 */
		$scope.legendeModalites = function (palette) {
			var items = [];
			angular.forEach(MODALITES, function (valeur) {
				angular.forEach(palette || [], function (item) {
					if (item.valeur === valeur) {
						items.push(item);
					}
				});
			});
			return items;
		};

		// ------------------------------------------------------------------ onglets

		/**
		 * L'adresse suit l'écran sans recharger le contrôleur : le lien reste partageable, et le
		 * retour depuis un détail retrouve la même vue. Les filtres ne s'écrivent que sur
		 * l'onglet Pharmacies, le seul qui en ait.
		 */
		function synchroniserAdresse() {
			var params = { annee: $scope.annee, tab: $scope.onglet };
			if ($scope.onglet === 'pharmacies') {
				params.q = $scope.filtres.recherche || '';
				params.statut = $scope.filtres.statut || '';
				params.compte = $scope.filtres.compte || '';
				params.tri = $scope.tri.colonne;
				params.sens = $scope.tri.sens;
				params.page = String($scope.pagination.page);
			}
			$state.go('app.groupement.autoeval', params, { notify: false, location: 'replace' });
		}

		$scope.changerOnglet = function (onglet) {
			if ($scope.onglet === onglet) {
				return;
			}
			$scope.onglet = onglet;
			synchroniserAdresse();
			$scope.chargerOnglet();
		};

		$scope.chargerOnglet = function () {
			switch ($scope.onglet) {
			case 'satisfaction':
				return chargerSatisfaction();
			case 'resultats':
				return chargerResultats();
			case 'pharmacies':
				return chargerPharmacies();
			case 'profil':
				return chargerProfil();
			default:
				return chargerDashboard();
			}
		};

		function echec(cle) {
			return function (erreur) {
				$scope.chargement[cle] = false;
				$scope.erreur = erreur;
			};
		}

		// ------------------------------------------------------------------ tableau de bord

		function chargerDashboard() {
			$scope.chargement.dashboard = true;
			$scope.erreur = null;
			return AutoEvalGroupementService.getDashboard($scope.annee, groupementCourant())
				.then(function (dashboard) {
					$scope.dashboard = dashboard;
					$scope.segmentsCompletion = calculerSegmentsCompletion(dashboard);
					$scope.texteSansValidation = decrireSansValidation(dashboard);
					$scope.chargement.dashboard = false;
				}).catch(echec('dashboard'));
		}

		/**
		 * La phrase qui décompose les officines sans validation. Elle ne cite que les états
		 * NON NULS : « 0 en cours, 0 non commencée, 243 sans validation » se lit mal, et sur une
		 * campagne clôturée il n'y a plus d'« encore » qui tienne.
		 */
		function decrireSansValidation(d) {
			var reste = d && d.compteurs ? (d.nbNonValidees || 0) : 0;
			if (!reste) {
				return 'Toutes les officines de votre périmètre ont validé.';
			}
			var c = d.compteurs;
			var parts = [];
			var enCours = (c.enCours || 0) + (c.rouvertes || 0);
			var sansValidation = (c.partielles || 0) + (c.nonRepondues || 0);
			if (enCours) {
				parts.push(enCours + ' en cours de remplissage');
			}
			if (c.nonCommencees) {
				parts.push(c.nonCommencees + ' non commencée' + (c.nonCommencees > 1 ? 's' : ''));
			}
			if (sansValidation) {
				parts.push(sansValidation + ' restée' + (sansValidation > 1 ? 's' : '') + ' sans validation à la clôture');
			}
			var verbe = reste > 1 ? 'n’ont pas ' : 'n’a pas ';
			verbe += d.provisoire ? 'encore validé' : 'validé';
			return reste + ' officine' + (reste > 1 ? 's ' : ' ') + verbe
				+ (parts.length ? ' : ' + parts.join(', ') + '.' : '.');
		}

		/**
		 * Les officines qui n'ont pas validé : le compteur du serveur, pas une soustraction. Le
		 * recalculer ici, c'est risquer d'afficher un nombre que la décomposition dément.
		 */
		$scope.nbSansValidation = function () {
			var d = $scope.dashboard;
			return d && d.nbNonValidees ? d.nbNonValidees : 0;
		};

		/**
		 * Les segments de la barre de complétion, avec leur légende chiffrée (spécification §5).
		 *
		 * ⚠️ Les couleurs disent un ÉTAT, pas un jugement : validée en vert, en cours en ambre,
		 * non commencée en gris. Après la clôture, ce qui est resté sans validation — partielle
		 * ou non répondue — passe en rouge doux : c'est le seul état qui ne bougera plus. Un
		 * segment vide n'est pas rendu, pour que la barre boucle à 100 % sans liseré.
		 *
		 * ⚠️ CALCULÉS UNE FOIS, au chargement du tableau de bord, et posés sur le scope. Une
		 * fonction appelée depuis le `ng-repeat` rendait des objets NEUFS à chaque digest : la
		 * collection changeait sans fin, et Angular abandonnait sur « infinite digest » — la page
		 * restait sur l'écran d'attente.
		 */
		function calculerSegmentsCompletion(d) {
			if (!d || !d.compteurs || !d.effectif) {
				return [];
			}
			var c = d.compteurs;
			var candidats = [
				{ cle: 'validees', libelle: 'validées', nb: c.validees || 0, couleur: '#3FA662' },
				{ cle: 'enCours', libelle: 'en cours', nb: (c.enCours || 0) + (c.rouvertes || 0), couleur: '#EBB122' },
				{ cle: 'nonCommencees', libelle: 'non commencées', nb: c.nonCommencees || 0, couleur: '#C9D3DB', pale: true },
				{ cle: 'sansValidation', libelle: 'sans validation à la clôture',
					nb: (c.partielles || 0) + (c.nonRepondues || 0), couleur: '#EF5450' }
			];
			var segments = [];
			angular.forEach(candidats, function (segment) {
				if (segment.nb > 0) {
					segment.pct = segment.nb * 100 / d.effectif;
					segments.push(segment);
				}
			});
			return segments;
		}

		// ------------------------------------------------------------------ résultats

		function chargerResultats() {
			$scope.chargement.resultats = true;
			$scope.erreur = null;
			return AutoEvalGroupementService.getResultats($scope.annee, groupementCourant(),
					$scope.filtres.anneeEngagement)
				.then(function (resultats) {
					$scope.resultats = resultats;
					$scope.chargement.resultats = false;
				}).catch(echec('resultats'));
		}

		$scope.changerAnneeEngagement = function () {
			if ($scope.onglet === 'profil') {
				chargerProfil();
			} else {
				chargerResultats();
			}
		};

		/** Les lignes de chapitre, hors synthèse globale : l'écran les présente séparément. */
		$scope.lignesChapitres = function () {
			var lignes = [];
			angular.forEach($scope.resultats ? $scope.resultats.lignes : [], function (ligne) {
				if (!ligne.global) {
					lignes.push(ligne);
				}
			});
			return lignes;
		};

		$scope.ligneGlobale = function () {
			var trouvee = null;
			angular.forEach($scope.resultats ? $scope.resultats.lignes : [], function (ligne) {
				if (!trouvee && ligne.global) {
					trouvee = ligne;
				}
			});
			return trouvee;
		};

		// ------------------------------------------------------------------ pharmacies

		function chargerPharmacies() {
			$scope.chargement.pharmacies = true;
			$scope.erreur = null;
			var query = {
				recherche: $scope.filtres.recherche,
				statut: $scope.filtres.statut,
				compte: $scope.filtres.compte,
				tri: $scope.tri.colonne,
				sens: $scope.tri.sens,
				page: $scope.pagination.page - 1,
				taille: $scope.pagination.taille
			};
			return AutoEvalGroupementService.getPharmacies($scope.annee, groupementCourant(), query)
				.then(function (page) {
					$scope.pharmacies = page;
					$scope.pagination.total = page.total;
					$scope.chargement.pharmacies = false;
				}).catch(echec('pharmacies'));
		}

		/** L'état de la campagne est lu sur la page reçue ; avant elle, celui d'une campagne ouverte. */
		$scope.statutsFiltrables = function () {
			return $scope.pharmacies && $scope.pharmacies.provisoire === false
				? STATUTS_CAMPAGNE_CLOTUREE : STATUTS_CAMPAGNE_OUVERTE;
		};

		$scope.rechercheModifiee = function () {
			if (minuteurRecherche) {
				$timeout.cancel(minuteurRecherche);
			}
			minuteurRecherche = $timeout(function () {
				$scope.pagination.page = 1;
				synchroniserAdresse();
				chargerPharmacies();
			}, DELAI_RECHERCHE);
		};

		$scope.filtrer = function () {
			$scope.pagination.page = 1;
			synchroniserAdresse();
			chargerPharmacies();
		};

		$scope.trierPar = function (colonne) {
			// Le tri par vigilance n'a qu'un sens : les officines signalées d'abord. Le serveur
			// ignore la direction, la flèche ne doit donc pas se retourner. De même pour la
			// satisfaction : les officines insatisfaites d'abord, les plus nombreuses en tête.
			if (colonne === 'alerte' || colonne === 'satisfaction') {
				if ($scope.tri.colonne === colonne) {
					return;
				}
				$scope.tri.colonne = colonne;
				$scope.tri.sens = 'asc';
			} else if ($scope.tri.colonne === colonne) {
				$scope.tri.sens = $scope.tri.sens === 'asc' ? 'desc' : 'asc';
			} else {
				$scope.tri.colonne = colonne;
				$scope.tri.sens = 'asc';
			}
			synchroniserAdresse();
			chargerPharmacies();
		};

		$scope.changerPage = function (page) {
			var dernier = Math.max(1, Math.ceil($scope.pagination.total / $scope.pagination.taille));
			var cible = Math.min(Math.max(1, page), dernier);
			if (cible === $scope.pagination.page) {
				return;
			}
			$scope.pagination.page = cible;
			synchroniserAdresse();
			chargerPharmacies();
		};

		$scope.nbPages = function () {
			return Math.max(1, Math.ceil($scope.pagination.total / $scope.pagination.taille));
		};

		/**
		 * Les numéros de la barre de pages, avec des « ... » quand il y en a trop — le même
		 * découpage que la liste des soumissions de l'administration, pour que la barre se lise
		 * pareil d'un espace à l'autre.
		 */
		$scope.pages = function () {
			return decouperPages(Number($scope.pagination.page) || 1, $scope.nbPages());
		};

		function decouperPages(courante, nbPages) {
			var largeur = LARGEUR_PAGINATION;
			if (nbPages <= largeur) {
				var toutes = [];
				for (var n = 1; n <= nbPages; n++) {
					toutes.push(n);
				}
				return toutes;
			}
			var moitie = Math.ceil(largeur / 2);
			var pages = [];
			for (var i = 1; i <= largeur; i++) {
				var numero;
				if (i === 1) {
					numero = 1;
				} else if (i === largeur) {
					numero = nbPages;
				} else if (nbPages - moitie < courante) {
					numero = nbPages - largeur + i;
				} else if (moitie < courante) {
					numero = courante - moitie + i;
				} else {
					numero = i;
				}
				// Les bornes s'écrivent en points quand elles ne sont pas contiguës.
				if ((i === 2 && numero > 2) || (i === largeur - 1 && numero < nbPages - 1)) {
					numero = '...';
				}
				pages.push(numero);
			}
			return pages;
		}

		$scope.ouvrirPharmacie = function (ligne) {
			// Une officine qui n'a pas validé n'a pas de détail : ses réponses vives ne sont pas
			// restituées à son réseau.
			if (!ligne.detailOuvrable) {
				return;
			}
			$state.go('app.groupement.autoeval-pharmacie', {
				annee: $scope.annee,
				soumissionId: ligne.soumissionId
			});
		};

		// ------------------------------------------------------------------ accès de l'officine

		$scope.libelleCompte = function (ligne) {
			return $filter('aeqCompteTitulaire')(ligne.compteTitulaire) || '—';
		};

		$scope.titreCompte = function (ligne) {
			return (TITRES_COMPTE[ligne.compteTitulaire] || '') + ' Voir les comptes et les e-mails de l’officine.';
		};

		$scope.classeCompte = function (ligne) {
			if (ligne.compteTitulaire === 'ACTIVE') {
				return 'aeq-compte-chip--ok';
			}
			return ligne.compteTitulaire === 'NON_ACTIVE' ? 'aeq-compte-chip--warn' : 'aeq-compte-chip--err';
		};

		/**
		 * Le bouton de renvoi n'existe que là où il a un sens : campagne ouverte, officine non
		 * validée. Ailleurs, la ligne garde « Voir le détail » ou « Non validée ».
		 */
		$scope.renvoiAffiche = function (ligne) {
			return !ligne.detailOuvrable && ligne.refusRenvoi !== 'CAMPAGNE_FERMEE'
				&& ligne.refusRenvoi !== 'DEJA_VALIDEE';
		};

		$scope.heure = function (millis) {
			return $filter('date')(millis, "HH 'h' mm");
		};

		/**
		 * La fenêtre « Accès de l'officine » (21/10/2026). Si un e-mail est parti, la liste est
		 * relue : son bouton doit dire « Envoyé à … » en revenant.
		 */
		$scope.ouvrirAcces = function (ligne, evenement) {
			var groupementId = groupementCourant();
			AeqAccesOfficine.ouvrir({
				nom: ligne.nom,
				cip: ligne.cip,
				annee: $scope.annee,
				vueAdmin: false,
				event: evenement,
				charger: function () {
					return AutoEvalGroupementService.getAcces($scope.annee, ligne.soumissionId, groupementId);
				},
				renvoyer: function () {
					return AutoEvalGroupementService.renvoyerLancement($scope.annee, ligne.soumissionId, groupementId);
				}
			}).then(function (etat) {
				if (etat && etat.envoye) {
					chargerPharmacies();
				}
			});
		};

		// ------------------------------------------------------------------ profil

		function chargerProfil() {
			$scope.chargement.profil = true;
			$scope.erreur = null;
			return AutoEvalGroupementService.getProfil($scope.annee, groupementCourant(),
					$scope.filtres.anneeEngagement)
				.then(function (profil) {
					$scope.profil = profil;
					$scope.chargement.profil = false;
					return chargerFocus();
				}).catch(echec('profil'));
		}

		/**
		 * Les focus du réseau (recette groupement, ligne 11), lus APRÈS le profil : la carte se
		 * range sous lui. Un échec ne vide pas l'onglet — le profil reste affiché, sans elle.
		 */
		function chargerFocus() {
			return AutoEvalGroupementService.getFocus($scope.annee, groupementCourant(),
					$scope.filtres.anneeEngagement)
				.then(function (focus) {
					$scope.focusReseau = focus;
				}).catch(function () {
					$scope.focusReseau = null;
				});
		}

		/**
		 * Les parts d'une distribution qui ont une VALEUR : un segment absent n'est pas un
		 * segment de largeur nulle, et la barre doit boucler à 100 % sans liseré.
		 */
		$scope.partsAvecValeur = function (question) {
			var parts = [];
			angular.forEach(question && question.distribution ? question.distribution : [], function (part) {
				if ($scope.aUneValeur(part.pct) && part.pct > 0) {
					parts.push(part);
				}
			});
			return parts;
		};

		// ------------------------------------------------------------------ satisfaction

		/**
		 * L'onglet Satisfaction : la répartition du réseau, puis la liste nominative des officines.
		 *
		 * ⚠️ Recherche, filtre, tri et page vivent sur un OBJET, pour la même raison que les filtres
		 * de l'onglet Pharmacies : l'onglet est rendu sous un `ng-if`, qui crée un scope enfant.
		 */
		$scope.satisfaction = null;
		$scope.satisfactionOfficines = null;
		$scope.satisfactionFiltres = { recherche: '', filtre: '' };
		$scope.satisfactionTri = { colonne: 'satisfaction', sens: 'asc' };
		$scope.satisfactionPagination = { page: 1, taille: TAILLE_PAGE, total: 0 };
		$scope.exportSatisfaction = false;
		var minuteurRechercheSatisfaction = null;

		function chargerSatisfaction() {
			$scope.chargement.satisfaction = true;
			$scope.erreur = null;
			return AutoEvalGroupementService.getSatisfaction($scope.annee, groupementCourant())
				.then(function (satisfaction) {
					$scope.satisfaction = satisfaction;
					$scope.chargement.satisfaction = false;
					return chargerSatisfactionOfficines();
				}).catch(echec('satisfaction'));
		}

		function chargerSatisfactionOfficines() {
			$scope.chargement.satisfactionOfficines = true;
			return AutoEvalGroupementService.getSatisfactionOfficines($scope.annee, groupementCourant(), {
				recherche: $scope.satisfactionFiltres.recherche,
				filtre: $scope.satisfactionFiltres.filtre,
				tri: $scope.satisfactionTri.colonne,
				sens: $scope.satisfactionTri.sens,
				page: $scope.satisfactionPagination.page - 1,
				taille: $scope.satisfactionPagination.taille
			}).then(function (page) {
				$scope.satisfactionOfficines = page;
				$scope.satisfactionPagination.total = page.total;
				$scope.satisfactionPagination.page = (page.page || 0) + 1;
				$scope.chargement.satisfactionOfficines = false;
			}).catch(echec('satisfactionOfficines'));
		}

		$scope.rechercheSatisfactionModifiee = function () {
			if (minuteurRechercheSatisfaction) {
				$timeout.cancel(minuteurRechercheSatisfaction);
			}
			minuteurRechercheSatisfaction = $timeout(function () {
				$scope.satisfactionPagination.page = 1;
				chargerSatisfactionOfficines();
			}, DELAI_RECHERCHE);
		};

		$scope.filtrerSatisfaction = function () {
			$scope.satisfactionPagination.page = 1;
			chargerSatisfactionOfficines();
		};

		$scope.trierSatisfaction = function (colonne) {
			if ($scope.satisfactionTri.colonne === colonne) {
				$scope.satisfactionTri.sens = $scope.satisfactionTri.sens === 'asc' ? 'desc' : 'asc';
			} else {
				$scope.satisfactionTri.colonne = colonne;
				$scope.satisfactionTri.sens = 'asc';
			}
			$scope.satisfactionPagination.page = 1;
			chargerSatisfactionOfficines();
		};

		$scope.nbPagesSatisfaction = function () {
			return Math.max(1, Math.ceil($scope.satisfactionPagination.total / $scope.satisfactionPagination.taille));
		};

		$scope.pagesSatisfaction = function () {
			return decouperPages(Number($scope.satisfactionPagination.page) || 1, $scope.nbPagesSatisfaction());
		};

		$scope.changerPageSatisfaction = function (page) {
			var cible = Math.min(Math.max(1, page), $scope.nbPagesSatisfaction());
			if (cible === $scope.satisfactionPagination.page) {
				return;
			}
			$scope.satisfactionPagination.page = cible;
			chargerSatisfactionOfficines();
		};

		/**
		 * Les parts d'une barre de satisfaction qui ont une valeur — réseau ou national. Le pendant
		 * de `partsAvecValeur`, qui lit, elle, la distribution d'une question du Profil.
		 */
		$scope.partsSatisfaction = function (parts) {
			var retenues = [];
			angular.forEach(parts || [], function (part) {
				if ($scope.aUneValeur(part.pct) && part.pct > 0) {
					retenues.push(part);
				}
			});
			return retenues;
		};

		/** Le libellé et la couleur d'une réponse, lus dans la palette du millésime. */
		$scope.modaliteSatisfaction = function (valeur) {
			var trouvee = null;
			angular.forEach($scope.satisfaction ? $scope.satisfaction.palette : [], function (modalite) {
				if (!trouvee && modalite.valeur === valeur) {
					trouvee = modalite;
				}
			});
			return trouvee;
		};

		/** L'abréviation d'une réponse dans le tableau : TS, S, I, TI, NC. */
		$scope.abregeSatisfaction = function (valeur) {
			return { TRES_SATISFAIT: 'TS', SATISFAIT: 'S', INSATISFAIT: 'I', TRES_INSATISFAIT: 'TI',
				NON_CONCERNE: 'NC' }[valeur] || '—';
		};

		/**
		 * Depuis l'alerte de la colonne Satisfaction de l'onglet Pharmacies : l'onglet Satisfaction,
		 * filtré sur cette officine par son CIP.
		 */
		$scope.voirSatisfaction = function (ligne) {
			$scope.satisfactionFiltres.recherche = ligne.cip || ligne.nom || '';
			$scope.satisfactionFiltres.filtre = '';
			$scope.satisfactionPagination.page = 1;
			$scope.changerOnglet('satisfaction');
		};

		$scope.exporterSatisfaction = function () {
			$scope.exportSatisfaction = true;
			AutoEvalGroupementService.exporterSatisfaction($scope.annee, groupementCourant())
				.catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.exportSatisfaction = false;
				});
		};

		// ------------------------------------------------------------------ exports

		$scope.exporter = function (type) {
			$scope.exportEnCours = true;
			AutoEvalGroupementService.exporter($scope.annee, type, groupementCourant(),
					$scope.filtres.anneeEngagement)
				.catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.exportEnCours = false;
				});
		};

		$scope.exporterRapportSynthese = function () {
			$scope.exportRapportSynthese = true;
			AutoEvalGroupementService.exporterRapportSynthese($scope.annee, groupementCourant())
				.catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.exportRapportSynthese = false;
				});
		};

		/**
		 * Demande l'archive des rapports, puis surveille sa construction.
		 *
		 * ⚠️ L'archive se construit en arrière-plan : la réponse ne porte qu'un identifiant. On
		 * interroge ensuite toutes les cinq secondes. Attendre le fichier au bout de la requête
		 * ferait expirer le navigateur sur un réseau de trois cents officines.
		 */
		$scope.demanderArchive = function () {
			AutoEvalGroupementService.demanderArchive($scope.annee, groupementCourant())
				.then(function (reponse) {
					toastr.info('Archive en préparation ; elle apparaîtra dans « Archives de rapports ».');
					chargerArchives();
					surveillerArchive(reponse.id);
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				});
		};

		function surveillerArchive(id) {
			if (minuteurArchive) {
				$timeout.cancel(minuteurArchive);
			}
			minuteurArchive = $timeout(function () {
				AutoEvalGroupementService.getArchive(id).then(function (archive) {
					chargerArchives();
					if (archive.statut === 'EN_PREPARATION') {
						surveillerArchive(id);
					} else if (archive.statut === 'PRET') {
						toastr.success('Votre archive est prête au téléchargement.');
					} else {
						toastr.error('La préparation de l’archive a échoué.');
					}
				});
			}, 5000);
		}

		function chargerArchives() {
			AutoEvalGroupementService.getArchives($scope.annee).then(function (archives) {
				$scope.archives = archives;
			});
		}

		$scope.telechargerArchive = function (archive) {
			AutoEvalGroupementService.telechargerArchive(archive.id).catch(function (erreur) {
				toastr.error(erreur.message);
			});
		};

		// ------------------------------------------------------------------ cycle de vie

		// Le sélecteur de la barre du haut change de réseau : tout est rechargé.
		var arreterEcoute = $scope.$on('groupementContextChanged', function () {
			// Une campagne à venir n'a rien par réseau : la boîte à outils vaut pour tous.
			if ($scope.aVenir || $scope.ferme) {
				return;
			}
			$scope.pagination.page = 1;
			$scope.satisfactionPagination.page = 1;
			chargerArchives();
			if ($scope.onglet !== 'dashboard') {
				chargerDashboard();
			}
			$scope.chargerOnglet();
		});

		$scope.$on('$destroy', function () {
			arreterEcoute();
			if (minuteurRecherche) {
				$timeout.cancel(minuteurRecherche);
			}
			if (minuteurRechercheSatisfaction) {
				$timeout.cancel(minuteurRechercheSatisfaction);
			}
			if (minuteurArchive) {
				$timeout.cancel(minuteurArchive);
			}
		});

		/**
		 * ⚠️ LA BOÎTE À OUTILS D'ABORD : c'est elle qui dit si la campagne est À VENIR. Une campagne
		 * programmée répond 404 au tableau de bord, aux résultats et aux pharmacies ; les appeler
		 * quand même afficherait une erreur sur une page qui a pourtant quelque chose à montrer.
		 * Son échec, lui, ne bloque rien : la boîte n'est qu'un complément de l'espace.
		 */
		function demarrer() {
			chargerArchives();
			// ⚠️ Le bandeau et son compteur lisent le tableau de bord quel que soit l'onglet ouvert :
			// un lien partagé vers « Résultats » doit arriver sur une page qui dit où en est la
			// campagne. Le tableau de bord n'est chargé qu'une fois si c'est déjà lui qu'on ouvre.
			if ($scope.onglet !== 'dashboard') {
				chargerDashboard();
			}
			$scope.chargerOnglet();
		}

		AutoEvalGroupementService.getBoiteAOutils($scope.annee).then(function (boite) {
			$scope.boite = boite;
			$scope.aVenir = !!boite && boite.statut === 'PROGRAMMEE';
		}).catch(function (erreur) {
			$scope.boite = null;
			if (erreur && erreur.code === 'MILLESIME_REPRIS') {
				$scope.ferme = true;
				$scope.erreur = erreur;
			}
		}).finally(function () {
			if ($scope.ferme) {
				return;
			}
			if ($scope.aVenir) {
				$scope.onglet = 'dashboard';
				return;
			}
			demarrer();
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('GroupementAuditsController', GroupementAuditsController);

	/**
	 * Écran D — la liste d'audits transverse (§7).
	 *
	 * Répond à « où en sont mes officines » sans ouvrir trois cents fiches. Le périmètre est aligné
	 * sur celui du parc : audit non archivé ET pharmacie non archivée — une officine « Sortie » ou
	 * « En attente » affiche donc son historique, ce qui est le plus souvent l'information
	 * recherchée.
	 */
	/** @ngInject */
	function GroupementAuditsController($scope, $rootScope, $state, EspaceGroupementService, UserService, toastr) {
		var TAILLE_PAGE = 25;

		// ⚠️ L'ORDRE SUIT CELUI DES COLONNES, déclarées juste en dessous : le menu et le tableau se
		// répondent, et les étiquettes se rangent dans le même ordre. Déplacer une colonne sans
		// déplacer son filtre casse la correspondance.
		//
		// « Année prévue » (`base_audit.annee`) décrit la PLANIFICATION de l'audit et « Année
		// réalisée » l'année de sa DATE : les deux divergent réellement (513 audits du parc).
		//
		// « Semestre » et « Année réalisée » sont des FILTRES SANS COLONNE. Le semestre ne se lit
		// pas sans l'année prévue qu'il découpe ; « Année réalisée » a perdu sa colonne le
		// 16/09/2026 (demande des réseaux) — la date, affichée juste à côté en JJ/MM/AAAA, porte
		// déjà l'information — mais reste filtrable : « tous les audits réalisés en 2025 » est une
		// question qu'une plage de dates exprime mal.
		//
		// « Groupement » ne s'affiche qu'en vue consolidée, comme la colonne du même nom : avec un
		// réseau sélectionné, le périmètre n'en contient qu'un et le filtre serait sans objet.
		$scope.filtresDisponibles = [
			{ cle: 'groupement', libelle: 'Groupement', consolideeSeulement: true },
			{ cle: 'type', libelle: "Type d'audit" },
			{ cle: 'equipe', libelle: 'Équipe' },
			{ cle: 'auditeur', libelle: 'Auditeur' },
			{ cle: 'annee', libelle: 'Année prévue' },
			{ cle: 'semestre', libelle: 'Semestre' },
			{ cle: 'anneeRealisee', libelle: 'Année réalisée' },
			{ cle: 'realise', libelle: 'Réalisé' },
			{ cle: 'ecartLeve', libelle: 'Écarts levés' }
		];

		$scope.audits = [];
		$scope.metasFiltres = {};
		$scope.filtres = {};
		$scope.recherche = '';
		$scope.chargement = false;
		$scope.erreur = null;
		$scope.exportEnCours = false;
		// `pageSaisie` double `page` : c'est ce que l'utilisateur tape, qui peut être vide ou hors
		// bornes le temps de la frappe, alors que `page` est toujours la page réellement affichée.
		$scope.pagination = { page: 1, taille: TAILLE_PAGE, total: 0, pageSaisie: 1 };
		$scope.taillesPage = [10, 25, 50, 100];
		$scope.tri = { colonne: 'dateAudit', sens: 'desc' };

		// Les colonnes sont décrites plutôt qu'écrites en dur dans le gabarit : c'est ce qui permet
		// d'y accrocher le tri et de masquer « Groupement » hors vue consolidée sans dupliquer.
		$scope.colonnes = [
			{ cle: 'pharmacie', champ: 'pharmacieNom', libelle: 'Pharmacie', style: 'nom' },
			{ cle: 'pharmacieRef', champ: 'pharmacieIdentifiant', libelle: 'Réf PHSQ', style: 'ref' },
			// Sans style « ref » : le CIP reste en fonte courante, comme dans la liste des
			// pharmacies. Le monospace y est réservé aux références internes (PHA-…, n° d'audit).
			{ cle: 'pharmacieCodeCip', champ: 'pharmacieCodeCip', libelle: 'Code CIP' },
			{ cle: 'groupement', champ: 'groupement', libelle: 'Groupement', consolidee: true },
			{ cle: 'numero', champ: 'numero', libelle: "N° d'audit", style: 'ref' },
			{ cle: 'type', champ: 'type', libelle: 'Type' },
			{ cle: 'equipe', champ: 'equipe', libelle: 'Équipe' },
			{ cle: 'auditeur', champ: 'auditeur', libelle: 'Auditeur', groupe: true },
			// Groupe visuel à elle seule : l'année prévue est de la planification, pas de la
			// réalisation — le filet la sépare de la « Date » qui suit, laquelle dit quand
			// l'audit a réellement eu lieu.
			{ cle: 'annee', champ: 'annee', libelle: 'Année prévue', groupe: true },
			{ cle: 'dateAudit', champ: 'dateAudit', libelle: 'Date', style: 'date', groupe: true },
			{ cle: 'realise', champ: 'realise', libelle: 'Réalisé', style: 'oui-non', groupe: true },
			{ cle: 'ecartsMajeurs', champ: 'ecartsMajeurs', libelle: 'Éc. majeurs', style: 'majeur' },
			{ cle: 'ecartsMineurs', champ: 'ecartsMineurs', libelle: 'Éc. mineurs', style: 'mineur' },
			{ cle: 'ecartLeve', champ: 'ecartLeve', libelle: 'Écart levé', style: 'ecart-leve' }
		];

		$scope.filtresVisibles = function () {
			return $scope.filtresDisponibles.filter(function (filtre) {
				return !filtre.consolideeSeulement || $scope.estVueConsolidee();
			});
		};

		$scope.colonnesVisibles = function () {
			return $scope.colonnes.filter(function (colonne) {
				return !colonne.consolidee || $scope.estVueConsolidee();
			});
		};

		function groupementCourant() {
			return UserService.getSelectedGroupementId();
		}

		$scope.niveauEcartLeve = EspaceGroupementService.niveauEcartLeve;

		$scope.estVueConsolidee = function () {
			return !groupementCourant() && ($rootScope.user && ($rootScope.user.groupements || []).length > 1);
		};

		$scope.nbPages = function () {
			return Math.max(1, Math.ceil(($scope.pagination.total || 0) / $scope.pagination.taille));
		};

		$scope.charger = function () {
			$scope.chargement = true;
			$scope.erreur = null;
			var query = angular.extend({}, $scope.filtres);
			query.pageIndex = $scope.pagination.page - 1;
			query.pageSize = $scope.pagination.taille;
			query.sortActive = $scope.tri.colonne;
			query.sortDirection = $scope.tri.sens;
			if (($scope.recherche || '').trim()) {
				query.q = $scope.recherche.trim();
			}
			EspaceGroupementService.getAudits(groupementCourant(), query).then(function (page) {
				$scope.audits = (page && page.data) || [];
				$scope.pagination.total = (page && page.totalSize) || 0;
			}).catch(function (erreur) {
				$scope.audits = [];
				$scope.pagination.total = 0;
				$scope.erreur = erreur;
			}).finally(function () {
				$scope.chargement = false;
			});
		};

		function chargerFiltres() {
			EspaceGroupementService.getFiltresAudits(groupementCourant()).then(function (metas) {
				$scope.metasFiltres = metas || {};
			}).catch(function () {
				$scope.metasFiltres = {};
			});
		}

		/**
		 * Un filtre vidé doit DISPARAÎTRE de la requête, pas y voyager à vide : sans cela
		 * `aDesFiltres()` croirait qu'un filtre est actif, et un paramètre creux partirait au CRM.
		 *
		 * ⚠️ Le menu de filtres retire déjà lui-même la clé qu'il vide ; la purge reste pour les
		 * bornes numériques, qu'`input[type=number]` laisse à `undefined` plutôt que d'effacer.
		 */
		function purgerFiltres() {
			angular.forEach(Object.keys($scope.filtres), function (cle) {
				var valeur = $scope.filtres[cle];
				if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
					delete $scope.filtres[cle];
				}
			});
		}

		$scope.appliquer = function () {
			purgerFiltres();
			revenirPremierePage();
			$scope.charger();
		};

		/** Remise en tête de liste : un filtre ou un tri qui change invalide le rang courant. */
		function revenirPremierePage() {
			$scope.pagination.page = 1;
			$scope.pagination.pageSaisie = 1;
		}

		/**
		 * Saut direct à une page.
		 *
		 * ⚠️ La borne est posée ICI et pas seulement par l'attribut `max` du champ : un
		 * `input[type=number]` n'empêche pas de taper 9999 au clavier, il se contente de le
		 * signaler. Une valeur illisible ramène simplement à la page courante.
		 */
		$scope.allerALaPage = function () {
			var demandee = parseInt($scope.pagination.pageSaisie, 10);
			if (!isFinite(demandee)) {
				$scope.pagination.pageSaisie = $scope.pagination.page;
				return;
			}
			demandee = Math.min(Math.max(demandee, 1), $scope.nbPages());
			$scope.pagination.pageSaisie = demandee;
			if (demandee !== $scope.pagination.page) {
				$scope.changerPage(demandee);
			}
		};

		/**
		 * Changement du nombre de lignes par page.
		 *
		 * On repart de la première : la 5ᵉ page de 25 lignes n'a pas d'équivalent en pages de 100,
		 * et rester sur un rang devenu hors bornes afficherait une page vide.
		 */
		$scope.changerTaille = function () {
			revenirPremierePage();
			$scope.charger();
		};

		$scope.changerPage = function (page) {
			$scope.pagination.page = page;
			$scope.pagination.pageSaisie = page;
			$scope.charger();
		};

		$scope.trierPar = function (colonne) {
			if ($scope.tri.colonne === colonne) {
				$scope.tri.sens = $scope.tri.sens === 'asc' ? 'desc' : 'asc';
			} else {
				$scope.tri.colonne = colonne;
				$scope.tri.sens = 'asc';
			}
			$scope.appliquer();
		};

		$scope.aDesFiltres = function () {
			return Object.keys($scope.filtres).length > 0 || !!($scope.recherche || '').trim();
		};

		// Le bouton « effacer » vit sous un `ng-if`, donc dans une portée fille : une affectation
		// écrite dans le gabarit y créerait une variable locale sans jamais vider le champ.
		$scope.effacerRecherche = function () {
			$scope.recherche = '';
			$scope.appliquer();
		};

		$scope.reinitialiser = function () {
			$scope.filtres = {};
			$scope.recherche = '';
			$scope.appliquer();
		};

		$scope.ouvrirAudit = function (audit) {
			$state.go('app.groupement.audit', {
				reference: audit.pharmacieIdentifiant,
				auditId: audit.id
			});
		};

		/** L'export reprend ce qui est affiché, causes d'écart comprises (§8). */
		$scope.exporter = function () {
			if ($scope.exportEnCours) {
				return;
			}
			$scope.exportEnCours = true;
			var query = angular.extend({}, $scope.filtres);
			if (($scope.recherche || '').trim()) {
				query.q = $scope.recherche.trim();
			}
			query.sortActive = $scope.tri.colonne;
			query.sortDirection = $scope.tri.sens;
			EspaceGroupementService.exporterAudits(groupementCourant(), query).catch(function (erreur) {
				toastr.error(erreur.message);
			}).finally(function () {
				$scope.exportEnCours = false;
			});
		};

		var arreterEcoute = $scope.$on('groupementContextChanged', function () {
			$scope.filtres = {};
			revenirPremierePage();
			chargerFiltres();
			$scope.charger();
		});
		$scope.$on('$destroy', arreterEcoute);

		chargerFiltres();
		$scope.charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('GroupementFicheAuditController', GroupementFicheAuditController);

	/**
	 * Écran C — la fiche d'audit (§5), en lecture SAUF son fil de commentaires.
	 *
	 * ⚠️ Aucun champ de l'audit n'est modifiable, et le groupement n'y dépose pas de document :
	 * l'arbitrage 17 tient sur tout le reste de l'écran. Seuls les COMMENTAIRES s'écrivent depuis
	 * le 16/09/2026 (demande des réseaux), et **au niveau RESPONSABLE seulement** — à la
	 * différence du commentaire de fiche pharmacie, ouvert aux deux niveaux : celui-ci répond à un
	 * constat d'écart et engage le réseau vis-à-vis de PHSQ. Chacun ne supprime que les siens, et
	 * les auditeurs PHSQ les lisent dans le CRM.
	 *
	 * Un compte de consultation garde donc l'écran tel qu'il était : le fil se lit, la zone de
	 * saisie n'apparaît pas. Le back refuse de toute façon (401/403), mais une zone de texte qu'on
	 * ne peut pas envoyer n'a rien à faire à l'écran.
	 *
	 * ⚠️ Les deux listes de causes n'ont AUCUNE limite de nombre : l'export de l'ancien CRM
	 * plafonnait à cinq majeures et cinq mineures, ce n'est plus le cas (§5).
	 */
	/** @ngInject */
	function GroupementFicheAuditController($scope, $rootScope, $state, $stateParams,
		ConfirmationGroupement, EspaceGroupementService, UserService, toastr) {

		/**
		 * L'utilisateur est-il responsable ? Même règle que sur la fiche pharmacie : en vue
		 * consolidée il suffit de l'être sur au moins un réseau — l'audit affiché appartient
		 * forcément à l'un d'eux, et le back tranchera.
		 */
		$scope.estResponsable = function () {
			var groupements = ($rootScope.user && $rootScope.user.groupements) || [];
			var courant = UserService.getSelectedGroupementId();
			var responsable = false;
			angular.forEach(groupements, function (groupement) {
				if (groupement.isResponsable && (!courant || groupement.id === courant)) {
					responsable = true;
				}
			});
			return responsable;
		};

		$scope.reference = $stateParams.reference;
		$scope.auditId = $stateParams.auditId;
		$scope.audit = null;
		$scope.chargement = true;
		$scope.erreur = null;
		// ⚠️ Un OBJET, pas une chaîne : la zone de saisie vit sous des `ng-if`, donc dans une
		// portée fille — un `ng-model` sur une valeur simple y créerait une propriété locale et la
		// saisie n'atteindrait jamais le contrôleur (même piège que sur la fiche pharmacie).
		$scope.saisieCommentaire = { contenu: '' };
		$scope.enregistrement = false;

		function groupementCourant() {
			return UserService.getSelectedGroupementId();
		}

		$scope.charger = function () {
			$scope.chargement = true;
			$scope.erreur = null;
			EspaceGroupementService.getFicheAudit(groupementCourant(), $scope.auditId).then(function (audit) {
				$scope.audit = audit;
			}).catch(function (erreur) {
				$scope.erreur = erreur;
			}).finally(function () {
				$scope.chargement = false;
			});
		};

		$scope.telechargerDocument = function (doc) {
			EspaceGroupementService.telechargerDocument(groupementCourant(), doc.id,
				doc.titre || doc.nom).catch(function (erreur) {
					toastr.error(erreur.message);
				});
		};

		// ------------------------------------------------- Commentaires (16/09/2026)

		$scope.ajouterCommentaire = function () {
			var contenu = ($scope.saisieCommentaire.contenu || '').trim();
			if (!contenu || $scope.enregistrement) {
				return;
			}
			$scope.enregistrement = true;
			EspaceGroupementService.ajouterCommentaireAudit(groupementCourant(), $scope.auditId, contenu)
				.then(function (commentaire) {
					$scope.audit.commentaires.unshift(commentaire);
					$scope.saisieCommentaire.contenu = '';
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					$scope.enregistrement = false;
				});
		};

		/**
		 * Un commentaire ne se modifie pas ; son auteur peut le supprimer. Les commentaires de
		 * PHSQ et ceux repris de l'ancien CRM restent visibles mais intouchables.
		 *
		 * ⚠️ Le niveau est vérifié EN PLUS de l'auteur : un accès rétrogradé en consultation ne
		 * doit plus pouvoir retirer les commentaires qu'il a écrits du temps où il était
		 * responsable — le back le refuserait, et l'écran ne propose pas ce qu'il refuse.
		 */
		$scope.peutSupprimerCommentaire = function (commentaire) {
			var moi = $rootScope.user && $rootScope.user.id;
			return $scope.estResponsable() && !!commentaire.auteurLqoUserId
				&& String(commentaire.auteurLqoUserId) === String(moi);
		};

		/**
		 * ⚠️ La suppression est DÉFINITIVE côté CRM, sans corbeille : d'où la confirmation.
		 *
		 * La chaîne rejette dans deux cas : le renoncement, sans valeur, et l'échec de l'appel,
		 * avec l'erreur — d'où le test `if (erreur)`, sans lequel refuser la confirmation
		 * afficherait un message d'erreur alors que rien n'a échoué.
		 */
		$scope.supprimerCommentaire = function (commentaire, event) {
			ConfirmationGroupement.demander({
				titre: 'Supprimer ce commentaire',
				texte: "Il sera définitivement retiré de la fiche d'audit dans le CRM. Cette action est irréversible.",
				detail: commentaire.contenu,
				confirmer: 'Supprimer',
				event: event
			}).then(function () {
				return EspaceGroupementService.supprimerCommentaireAudit(groupementCourant(),
					$scope.auditId, commentaire.id);
			}).then(function () {
				var index = $scope.audit.commentaires.indexOf(commentaire);
				if (index >= 0) {
					$scope.audit.commentaires.splice(index, 1);
				}
				toastr.success('Commentaire supprimé.');
			}).catch(function (erreur) {
				if (erreur) {
					toastr.error(erreur.message);
				}
			});
		};

		$scope.retourListe = function () {
			$state.go('app.groupement.pharmacies');
		};

		$scope.retourFiche = function () {
			$state.go('app.groupement.pharmacie', { reference: $scope.reference, tab: 'audits' });
		};

		$scope.charger();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.filter('documentsFilter', documentsFilter);

	function documentsFilter(){
		return function(items, filter){
			var filtered = [];
			if (angular.isArray(items)){
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (angular.isUndefined(filter) || angular.isUndefined(filter.property) || filter.property === '') {
						filtered.push(item);
					} else if (''+item[filter.property] === filter.value) {
						filtered.push(item);
					}
				}
			}
			return filtered;
		};
	}
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('FolderController', FolderController);

  function FolderController($scope, $state, $q, $rootScope, $stateParams, $timeout, $mdDialog, $window, toastr, FolderService, DocumentService, UserService, PERMISSIONS) {
    $scope.folder = {};
    $scope.document = {};
    $scope.documents = {};
    $scope.newFolder = {};
    $scope.filter = {};
    $scope.error = {};
    $scope.document.nameOfDocument = "";
    $scope.filterValue = '';
    $scope.triValue = '';
    $scope.intoSaving = false;
    $scope.folderId = null;

    $scope.sorterName = ['-readOnly', 'name'];
    $scope.sorterReverse = false;

    $scope.permissions = PERMISSIONS;

    $scope.loading = false;

    $scope.loadingPagination = false

    $scope.folders = []
    $scope.foldersMovePopup = {}
    $scope.documentToMove = {}
    $scope.selectedMoveItems = []
    $scope.hasGroupMoveSelectionValue = false
    $scope.isMoveSelectionPopup = false
    $scope.movePopupParentFolder = null
    $scope.movePopupParentSiblings = []
    $scope.movePopupSwipeClass = ''
    $scope.category = { childs: [], folders: [] }

    $scope.pagination = {
      page: 0,
      nbrResults: 5
    }

    $scope.loadingFiles = false

    var txtFolderNotFound = 'Dossier introuvable, veuillez actualiser la page';
    var txtDocNotFound = 'Document introuvable, veuillez actualiser la page';

    function refreshRootsAfterMoveIfNeeded(response) {
      if (!response || !response.data || response.data.emptySubCategoryDeleted !== true) {
        return;
      }
      FolderService.setRoots(null);
      FolderService.findRoots().catch(function () {
      });
    }

    function clearGroupMoveSelectionState() {
      $scope.selectedMoveItems = []
      $scope.hasGroupMoveSelectionValue = false
      if (angular.isArray($scope.category.folders)) {
        for (var i = 0; i < $scope.category.folders.length; i++) {
          $scope.category.folders[i]._groupMoveSelected = false
        }
      }
      if (angular.isArray($scope.category.documents)) {
        for (var j = 0; j < $scope.category.documents.length; j++) {
          $scope.category.documents[j]._groupMoveSelected = false
        }
      }
    }


    $scope.refreshCategory = function (categoryId) {
      $scope.loadingFiles = true
      FolderService.findCatById(categoryId).then(function (response) {
        $scope.category = response.data;
        clearGroupMoveSelectionState()
        $scope.document.parentCategoryId = $scope.category.id;
        $scope.newFolder.parentCategoryId = $scope.category.id;
        $scope.categoryId = $stateParams.categoryId
        if (!!$stateParams.subId) {
          $scope.folderId = $stateParams.subId;
          if (!!$stateParams.subCategoryId) {
            $scope.subCategoryId = $stateParams.subCategoryId
          } else {
            $scope.subCategoryId = null
          }
          $scope.refreshSelectedFolder();
        } else {
          $scope.loadingFiles = false
        }
        FolderService.list().then(function (response) {
          $scope.folders = response.data
        })
      }).catch(function (response) {
        FolderService.setRoots(null)
        $state.go('app.folders');
      });
    }


    $scope.refreshSelectedFolder = function () {
      FolderService.findById($scope.folderId).then(function (response) {
        $scope.folder = response.data;
        $scope.category.folders = $scope.folder.childs;
        $scope.category.documents = $scope.folder.documents;
        clearGroupMoveSelectionState()
        $scope.category.breadcrumbs = $scope.folder.breadcrumbs
        $scope.document.folderId = $scope.folder.id;
        $scope.newFolder.parentId = $scope.folder.id;
        $scope.loadingFiles = false
      }).catch(function (response) {
        // $state.go('app.folders');
      });
      // FolderService.list().then(function (response) {
      //   $scope.folders = response.data
      // })
    };

    if (!!$stateParams.subCategoryId) {
      $scope.subCategoryId = $stateParams.subCategoryId
      $scope.refreshCategory($scope.subCategoryId)
    } else if (!!$stateParams.categoryId) {
      $scope.categoryId = $stateParams.categoryId
      $scope.refreshCategory($scope.categoryId)
    } else {
      $state.go('app.folders');
    }

    $scope.$on('dropEvent', function (evt, dragged, dropped) {
      if (dragged.folder && dropped.folder && dragged.id === dropped.id) {

      } else {
        if (($rootScope.user.isTitulaire || $rootScope.user.isPraq) && dragged != null && dropped != null && !dropped.readOnly && !dragged.readOnly) {
          toastr.clear();
          DocumentService.changeFolder({ documentToMove: dragged, currentMoveFolder: dropped, subCategoryId: $scope.subCategoryId }).then(function (response) {
            if (!!$stateParams.subId) {
              $scope.refreshSelectedFolder()
            } else {
              if ($scope.subCategoryId) {
                $scope.refreshCategory($scope.subCategoryId);
              } else {
                $scope.refreshCategory($scope.categoryId);
              }
            }
            refreshRootsAfterMoveIfNeeded(response)
            if (dragged.folder) {
              toastr.success("Le dossier a été deplacé dans le dossier avec succès");
            } else {
              toastr.success("Le document a été deplacé dans le dossier avec succès");
            }
          }).catch(function (err) {
            toastr.error("Une erreur est survenue, veuillez réessayer plus tard");
          });
        } else {
          if (dropped.readOnly) {
            toastr.error('Ce dossier ne peut être modifié');
          } else if (dragged.readOnly) {
            toastr.error('Ce fichier ne peut être déplacé');
          } else {
            toastr.error("Vous n'avez pas les droits");
          }
        }
      }
      $scope.$apply();
    });

    $scope.filterIndex = function (index) {
      $scope.filterValue = index
    }

    $scope.triIndex = function (index) {
      $scope.triValue = index
    }

    function initDocument() {
      $scope.document = {
        folderId: $scope.folder ? $scope.folder.id : null,
        parentCategoryId: $scope.category ? $scope.category.id : null
      };
    }

    function initNewFolder() {
      $scope.newFolder = {
        parentId: $scope.folder.id,
        parentCategoryId: $scope.category.id
      };
    }

    function initConfirmDocument() {
      $scope.docToDelete = null;
      $scope.docToValidate = null;
    }

    $scope.clearInputFile = function (id_input) {
      var elem = document.getElementById(id_input);
      elem.value = "";
      $scope.document.attachmentOriginalName = null
      $scope.document.nameOfDocument = ""
      $scope.multipleFiles = false
      initDocument()
    };

    $scope.openCat = function (cat) {
      $state.go('app.category', {
        categoryId: cat.id
      });
    };

    $scope.openSubCat = function (category, subCategory) {
      if (subCategory != null && angular.isDefined(subCategory.id)) {
        $state.go('app.category.sub', { categoryId: category.id, subCategoryId: subCategory.id });
      }
    };

    $scope.openFolder = function (folder) {
      if ($scope.folder != null && folder != null && angular.isDefined(folder.id) && $scope.category.breadcrumbs.length > 0) {
        if ($scope.subCategoryId) {
          $state.go('app.category.sub.folder', {
            categoryId: $scope.categoryId,
            subCategoryId: $scope.subCategoryId,
            subId: folder.id
          });
        } else {
          $state.go('app.category.folder', {
            categoryId: $scope.category.id,
            subId: folder.id
          });
        }
      }
    };

    $scope.hidePopup = function () {
      $scope.isMoveSelectionPopup = false
      $mdDialog.hide();
    };

    $scope.openAddFile = function () {
      $scope.editionMode = false;
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initDocument();
      }).catch(function () {
        initDocument();
      });
    };

    $scope.openAddFolder = function () {
      $scope.editionMode = false;
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/folder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initNewFolder();
      }).catch(function () {
        initNewFolder();
      });
    };

    $scope.saveDocument = function (editionMode) {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        var input = document.getElementById('document_input_file');
        var file = null;
        $scope.error.file = false;
        if (input != null) {
          if (input.files[1] != null) {
            $scope.saveManyDocuments(input);
            return;
          }
          file = input.files[0];
          if (file == null && !editionMode) {
            $scope.error.file = true;
            toastr.error('Veuillez ajouter un fichier!');
            $scope.intoSaving = false;
            return;
          }
        } else {
          $scope.error.file = true;
          toastr.error('Veuillez ajouter un fichier!');
          $scope.intoSaving = false;
          return;
        }
        var fd = new FormData();
        fd.append('file', file);
        if (file != null && file.name != null) {
          $scope.document.originalFileName = file.name
        }
        fd.append('dto', angular.toJson($scope.document));
        $scope.loading = true;
        DocumentService.save(fd).then(function (response) {
          $rootScope.$broadcast('refreshCountNotifs');
          UserService.checkPermission([PERMISSIONS.TITULAIRE, PERMISSIONS.PRAQ]).then(function (res) {
            if (res) {
              $scope.document.isRestricted = false;
              $scope.document.status = 'VALIDATED';
            }
            if (!$scope.editionMode) {
              $scope.document.id = parseInt(response.data.id);
              $scope.document.uploadDate = new Date().getTime();
            } else {
              for (var i = 0; i < $scope.category.documents.length; i++) {
                if ($scope.category.documents[i].id === $scope.document.id) {
                  $scope.category.documents.splice(i, 1);
                  break;
                }
              }
            }

            if (file != null && file.type === 'application/pdf') {
              $scope.document.pdf = true;
            } else {
              $scope.document.pdf = false;
            }

            $scope.category.documents.push(angular.copy($scope.document));
            if ($stateParams.subId) {
              $scope.refreshSelectedFolder()
            } else {
              if ($scope.subCategoryId) {
                $scope.refreshCategory($scope.subCategoryId);
              } else {
                $scope.refreshCategory($scope.categoryId);
              }
            }
            $scope.hidePopup();
            $timeout(function () {
              $scope.intoSaving = false;
            });
            $scope.loading = false;
            if (!$scope.editionMode) {
              toastr.success('Le document a été ajouté avec succès');
            } else {
              toastr.success('Le document a été modifié avec succès');
            }
          }).catch(function (res) {
            $scope.loading = false;
            $scope.intoSaving = false;
          });
        }).catch(function (response) {
          $scope.loading = false;
          if (response.status === 404) {
            toastr.error('Dossier parent introuvable, veuillez actualiser la page');
          }
          $scope.intoSaving = false;
        });
      }
    };

    $scope.saveManyDocuments = function (input) {
      var fd = new FormData();
      $scope.document.originalFileNames = [];
      for (var i = 0, iLen = input.files.length; i < iLen; i++) {
        fd.append('files', input.files[i]);
        if (input.files[i] != null && input.files[i].name != null) {
          $scope.document.originalFileNames.push(input.files[i].name);
        }
      }

      fd.append('dto', angular.toJson($scope.document));
      $scope.loading = true;
      DocumentService.saveMulti(fd).then(function (response) {
        $rootScope.$broadcast('refreshCountNotifs');
        UserService.checkPermission([PERMISSIONS.TITULAIRE, PERMISSIONS.PRAQ]).then(function (res) {
          if (res) {
            $scope.document.isRestricted = false;
            $scope.document.status = 'VALIDATED';
          }
          if ($stateParams.subId) {
            $scope.refreshSelectedFolder()
          } else {
            if ($scope.subCategoryId) {
              $scope.refreshCategory($scope.subCategoryId);
            } else {
              $scope.refreshCategory($scope.categoryId);
            }
          }
          $scope.hidePopup();
          $scope.loading = false;
          toastr.success('Les documents ont été ajouter avec succès');
          $timeout(function () {
            $scope.intoSaving = false;
          });
        }).catch(function (res) {
          $scope.loading = false;
          $scope.intoSaving = false;
        });
      }).catch(function (response) {
        $scope.loading = false;
        if (response.status === 404) {
          toastr.error('Dossier parent introuvable, veuillez actualiser la page');
        }
        $scope.intoSaving = false;
      });
    }


    $scope.simulationclick = function (doc) {
      var fileinput = document.getElementById("document_input_file");
      fileinput.click();
      var title = document.getElementsByName("name")[0];
      setTimeout(function () {
        title.focus();
      }, 1500);
    }

    $scope.$on('fileUploaded', function () {
      var fileinput = document.getElementById("document_input_file");
      $scope.document.nameOfDocument = "";
      $scope.multipleFiles = fileinput.files.length > 1;
      $scope.document.name = ''
      console.log(fileinput.files)
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        if ($scope.document.name.length > 0) {
          $scope.document.name += ' '
          $scope.document.nameOfDocument += ' '
        }
        $scope.document.name += name ? name : "Nom du fichier indisponible"
        $scope.document.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.openEditDocument = function (doc) {
      $scope.editionMode = true;
      $scope.document = angular.copy(doc);
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true

      }).then(function () {
        initDocument();
      }).catch(function () {
        initDocument();
      });
    };

    $scope.saveFolder = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        FolderService.save($scope.newFolder).then(function (response) {
          UserService.checkPermission([PERMISSIONS.TITULAIRE, PERMISSIONS.PRAQ]).then(function (res) {
            if (!$scope.editionMode) {
              $scope.newFolder.id = parseInt(response.data);
            }
            for (var i = 0; i < $scope.category.folders.length; i++) {
              if ($scope.category.folders[i].id === $scope.newFolder.id) {
                $scope.category.folders.splice(i, 1);
                break;
              }
            }
            $scope.category.folders.push(angular.copy($scope.newFolder));
            if ($stateParams.subId) {
              $scope.refreshSelectedFolder()
            } else {
              if ($scope.subCategoryId) {
                $scope.refreshCategory($scope.subCategoryId);
              } else {
                $scope.refreshCategory($scope.categoryId);
              }
            }
            $scope.hidePopup();
            $timeout(function () {
              $scope.intoSaving = false;
            });
            if (!$scope.editionMode) {
              toastr.success('Le dossier a été ajouté avec succès');
            } else {
              toastr.success('Le dossier a été modifié avec succès');
            }
          }).catch(function (res) {
            $scope.intoSaving = false;
          });

        }).catch(function (response) {

          if (response.status === 404) {
            toastr.error('Dossier parent introuvable, veuillez actualiser la page');
          }
          $scope.intoSaving = false;
        });
      }

    };

    $scope.oepnEditFolder = function (folder) {
      $scope.editionMode = true;
      $scope.newFolder = angular.copy(folder);
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/folder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initNewFolder();
      }).catch(function () {
        initNewFolder();
      });
    };

    $scope.openDeleteFolder = function (folder) {
      $scope.folderToDelete = angular.copy(folder);
      $scope.deleteFolderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/delete_folder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.folderToDelete = {};
      }).catch(function () {
        $scope.folderToDelete = {};
      });
    };

    $scope.deleteFolder = function () {
      FolderService.remove($scope.folderToDelete.id, $scope.subCategoryId).then(function (response) {
        for (var i = 0; i < $scope.category.folders.length; i++) {
          if ($scope.category.folders[i].id === $scope.folderToDelete.id) {
            $scope.category.folders.splice(i, 1);
            break;
          }
        }
        refreshRootsAfterMoveIfNeeded(response)
        $rootScope.$broadcast('refreshCountNotifs');
        toastr.success("Le dossier a été supprimé avec succès");
        $scope.hidePopup();
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtFolderNotFound);
        }
        else toastr.error("Il y'a eu une erreur, veuillez réessayer ultérieurement");
      });
    };

    $scope.openDeleteDocument = function (doc) {
      $scope.docToDelete = angular.copy(doc);
      $scope.deleteDocPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/confirm_document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initConfirmDocument();
      }).catch(function () {
        initConfirmDocument();
      });
    };

    $scope.deleteDocument = function () {
      DocumentService.remove($scope.docToDelete.id, $scope.subCategoryId).then(function (response) {
        for (var i = 0; i < $scope.category.documents.length; i++) {
          if ($scope.category.documents[i].id === $scope.docToDelete.id) {
            $scope.category.documents.splice(i, 1);
            $scope.hidePopup();
            break;
          }
        }
        refreshRootsAfterMoveIfNeeded(response)
        $rootScope.$broadcast('refreshCountNotifs');
        toastr.success("Le document a été supprimé avec succès");
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
        else toastr.error("Il y a eu une erreur, veuillez réessayer ultérieurement");
      });
    };



    $scope.openValidDocument = function (doc) {
      $scope.docToValidate = angular.copy(doc);
      $scope.validDocPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/confirm_document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initConfirmDocument();
      }).catch(function () {
        initConfirmDocument();
      });
    };

    $scope.validDocument = function () {
      DocumentService.validate($scope.docToValidate.id).then(function (response) {
        for (var i = 0; i < $scope.folder.documents.length; i++) {
          if ($scope.folder.documents[i].id === $scope.docToValidate.id) {
            $scope.folder.documents[i].status = 'VALIDATED';
            $rootScope.$broadcast('refreshCountNotifs');
            $scope.hidePopup();
            break;
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
      });

    };

    $scope.setRestrictedDoc = function (doc) {
      DocumentService.setRestricted(doc.id, !doc.isRestricted).then(function () {
        for (var i = 0; i < $scope.folder.documents.length; i++) {
          if ($scope.folder.documents[i].id == doc.id) {
            $scope.folder.documents[i].isRestricted = !doc.isRestricted
            break
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
      });
    };

    $scope.setRestrictedFolder = function (folder) {
      FolderService.setRestricted(folder.id, !folder.isRestricted).then(function () {
        for (var i = 0; i < $scope.folder.childs.length; i++) {
          if ($scope.folder.childs[i].id == folder.id) {
            $scope.folder.childs[i].isRestricted = !folder.isRestricted
            break
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtFolderNotFound);
        }
      });
    };



    $scope.download = function (doc) {
      $window.location.href = DocumentService.getDownloadLink(doc.id);
    };

    $scope.openPDF = function (doc) {
      FolderService.getPDF(doc.id).then(function (res) {
        var file = new Blob([res.data], {
          type: 'application/pdf'
        });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.sortBy = function (property, reverse) {
      $scope.sorterName = [property];
      $scope.sorterReverse = reverse;
      $scope.filter = {}
      $scope.filterValue = ''
    };

    $scope.setFilter = function (property, value) {
      $scope.filter = {
        property: property,
        value: value
      };
      $scope.triValue = ''
      $scope.sorterName = ['-readOnly', 'name'];
      $scope.sorterReverse = false;
    };

    $scope.canSelectForGroupMove = function (item) {
      return !!item && !$scope.loadingFiles && !!$rootScope.user && ($rootScope.user.isTitulaire || $rootScope.user.isPraq) && !item.readOnly
    }

    $scope.toggleGroupMoveSelection = function () {
      var selected = []
      if (angular.isArray($scope.category.folders)) {
        for (var i = 0; i < $scope.category.folders.length; i++) {
          var folder = $scope.category.folders[i]
          if (folder._groupMoveSelected && $scope.canSelectForGroupMove(folder)) {
            folder.folder = true
            selected.push(folder)
          }
        }
      }
      if (angular.isArray($scope.category.documents)) {
        for (var j = 0; j < $scope.category.documents.length; j++) {
          var document = $scope.category.documents[j]
          if (document._groupMoveSelected && $scope.canSelectForGroupMove(document)) {
            selected.push(document)
          }
        }
      }
      $scope.selectedMoveItems = selected
      $scope.hasGroupMoveSelectionValue = selected.length > 0
    }

    $scope.hasGroupMoveSelection = function () {
      return !!$scope.hasGroupMoveSelectionValue
    }

    $scope.clearGroupMoveSelection = function () {
      clearGroupMoveSelectionState()
    }

    $scope.openInformationPopup = function () {
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/informations_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    var findCategories = function (id, categories) {
      var res = null
      for (var i = 0; i < categories.length; i++) {
        if (categories[i].id == id) {
          res = categories[i]
          break;
        }
        if (res == null) {
          res = findFolder(id, categories[i].childs)
        }
      }
      return res
    }

    var findFolderFromCategories = function (id, categories) {
      var res = null
      for (var i = 0; i < categories.length; i++) {
        var category = categories[i]
        if (category.childs.length > 0) {
          for (var j = 0; j < category.childs.length; j++) {
            var child = category.childs[j]
            if (child.folders.length > 0) {
              res = findFolder(id, child.folders)
              if (res != null) {
                break
              }
            }
          }
          if (res != null) {
            break
          }
        } else {
          res = findFolder(id, category.folders)
          if (res != null) {
            break
          }
        }
      }

      return res
    }

    var findFolder = function (id, folders) {
      var res = null
      for (var i = 0; i < folders.length; i++) {
        if (folders[i].id == id) {
          res = folders[i]
          break;
        }
        if (res == null) {
          res = findFolder(id, folders[i].childs)
        }
      }
      return res
    }

    var getMovePopupContent = function (folder) {
      if (!folder) {
        return []
      }
      if (angular.isArray(folder.childs) && folder.childs.length > 0) {
        return folder.childs
      }
      if (angular.isArray(folder.folders)) {
        return folder.folders
      }
      return []
    }

    var resolveMoveFolder = function (entry) {
      if (!entry || !angular.isDefined(entry.id)) {
        return null
      }
      if (entry.folder) {
        return findFolderFromCategories(entry.id, $scope.folders)
      }
      return findCategories(entry.id, $scope.folders)
    }

    var getMovePopupParent = function (folder) {
      if (!folder) {
        return null
      }
      if (folder.parentId) {
        return findFolderFromCategories(folder.parentId, $scope.folders)
      }
      if (angular.isArray(folder.breadcrumbs) && folder.breadcrumbs.length > 1) {
        return resolveMoveFolder(folder.breadcrumbs[folder.breadcrumbs.length - 2])
      }
      return null
    }

    var updateMovePopupPanels = function (siblingsOverride) {
      var parentFolder = getMovePopupParent($scope.currentMoveFolder)

      $scope.movePopupParentFolder = parentFolder
      if (angular.isArray(siblingsOverride)) {
        $scope.movePopupParentSiblings = siblingsOverride
        return
      }
      if (parentFolder) {
        $scope.movePopupParentSiblings = getMovePopupContent(parentFolder)
      } else {
        $scope.movePopupParentSiblings = angular.copy($scope.folders)
      }
    }

    var movePopupSwipeResetPromise = null
    var movePopupSwipeToggle = false

    var resetMovePopupSwipe = function () {
      if (movePopupSwipeResetPromise) {
        $timeout.cancel(movePopupSwipeResetPromise)
      }
      $scope.movePopupSwipeClass = ''
    }

    var triggerMovePopupSwipe = function (direction) {
      if (direction !== 'left' && direction !== 'right') {
        return
      }
      if (movePopupSwipeResetPromise) {
        $timeout.cancel(movePopupSwipeResetPromise)
      }
      movePopupSwipeToggle = !movePopupSwipeToggle
      if (direction === 'left') {
        $scope.movePopupSwipeClass = movePopupSwipeToggle ? 'iv-MovePopup__grid--swipe-left-a' : 'iv-MovePopup__grid--swipe-left-b'
      } else {
        $scope.movePopupSwipeClass = movePopupSwipeToggle ? 'iv-MovePopup__grid--swipe-right-a' : 'iv-MovePopup__grid--swipe-right-b'
      }
      movePopupSwipeResetPromise = $timeout(function () {
        $scope.movePopupSwipeClass = ''
      }, 550)
    }

    var isMoveRootDestination = function (folder) {
      if (!folder) {
        return true
      }
      if (folder.folder) {
        var hasParentInfo = folder.parentId != null || folder.parentCategoryId != null
        if (hasParentInfo) {
          return false
        }
        if (angular.isArray(folder.breadcrumbs)) {
          return folder.breadcrumbs.length <= 1
        }
        return false
      }
      if (getRootCategory(folder)) {
        return true
      }
      if (angular.isArray(folder.breadcrumbs)) {
        return folder.breadcrumbs.length <= 1
      }
      return false
    }

    var canMoveToCurrentDestination = function () {
      if (!$scope.currentMoveFolder) {
        return false
      }
      var canMoveToFolder = $scope.currentMoveFolder.folder || !$scope.currentMoveFolder.folder &&
        (($scope.currentMoveFolder.childs != null && $scope.currentMoveFolder.childs.length === 0) ||
          $scope.currentMoveFolder.index === 3)
      return canMoveToFolder && !isMoveRootDestination($scope.currentMoveFolder)
    }

    $scope.isCurrentMoveFolderRoot = function () {
      return isMoveRootDestination($scope.currentMoveFolder)
    }

    $scope.canSubmitMove = function () {
      return canMoveToCurrentDestination()
    }

    var getRootCategory = function (folder) {
      if (!folder || !angular.isDefined(folder.id)) {
        return null
      }
      for (var i = 0; i < $scope.folders.length; i++) {
        if ($scope.folders[i].id == folder.id) {
          return $scope.folders[i]
        }
      }
      return null
    }

    var getRootCategoryFromDirectChild = function (folder) {
      if (!folder || !angular.isDefined(folder.id)) {
        return null
      }
      for (var i = 0; i < $scope.folders.length; i++) {
        var root = $scope.folders[i]
        if (!angular.isArray(root.childs)) {
          continue
        }
        for (var j = 0; j < root.childs.length; j++) {
          if (root.childs[j].id == folder.id) {
            return root
          }
        }
      }
      return null
    }

    $scope.getMovePopupIconSrc = function (folder) {
      var defaultIcon = './assets/icons/app/V3/folder.svg'
      var colorableFolderIcon = './assets/icons/app/V3/folder_colorable.svg'
      if (!folder) {
        return defaultIcon
      }
      if (getRootCategory(folder)) {
        return colorableFolderIcon
      }
      if (getRootCategoryFromDirectChild(folder) && folder.icon) {
        if (folder.icon === 'folder.svg') {
          return defaultIcon
        }
        return './assets/icons/app/V3/' + folder.icon
      }
      return defaultIcon
    }

    $scope.getMovePopupIconClass = function (folder) {
      var root = getRootCategory(folder)
      if (!root || !angular.isDefined(root.index)) {
        var rootFromChild = getRootCategoryFromDirectChild(folder)
        if (!rootFromChild || !angular.isDefined(rootFromChild.index)) {
          return ''
        }
        if (folder.icon === 'folder.svg') {
          return 'iv-MovePopup__icon--folder'
        }
        return 'iv-MovePopup__icon--child-' + rootFromChild.index
      }
      return 'iv-MovePopup__icon--root-bg-' + root.index
    }

    $scope.openMoveFolder = function (folder, source) {
      var previousRightPanel = angular.copy($scope.foldersMovePopup)
      if (folder.folder) {
        $scope.currentMoveFolder = findFolderFromCategories(folder.id, $scope.folders)
      } else {
        $scope.currentMoveFolder = findCategories(folder.id, $scope.folders)
      }
      $scope.foldersMovePopup = getMovePopupContent($scope.currentMoveFolder)
      if (source === 'right') {
        updateMovePopupPanels(previousRightPanel)
      } else {
        updateMovePopupPanels()
      }
      if (source === 'right') {
        triggerMovePopupSwipe('left')
      }
    }

    $scope.openMoveFilePopup = function (document) {
      $scope.isMoveSelectionPopup = false
      $scope.documentToMove = document
      var folder = null
      if (document.folderId) {
        folder = findFolderFromCategories(document.folderId, $scope.folders)
      } else {
        folder = angular.copy($scope.category)
      }
      $scope.currentMoveFolder = folder
      $scope.foldersMovePopup = getMovePopupContent($scope.currentMoveFolder)
      updateMovePopupPanels()
      resetMovePopupSwipe()
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/moveFile_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.openMoveFolderPopup = function (folder) {
      $scope.isMoveSelectionPopup = false
      $scope.folderToMove = folder;
      var current = findFolderFromCategories(folder.id, $scope.folders)
      var startFolder = getMovePopupParent(current)
      $scope.currentMoveFolder = startFolder || current
      $scope.foldersMovePopup = getMovePopupContent($scope.currentMoveFolder)
      updateMovePopupPanels()
      resetMovePopupSwipe()
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/moveFolder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    var getCurrentMoveSource = function () {
      if ($scope.folder && $scope.folder.id) {
        return findFolderFromCategories($scope.folder.id, $scope.folders)
      }
      return angular.copy($scope.category)
    }

    var redirectToMoveDestination = function (destination) {
      if (!destination || !angular.isDefined(destination.id)) {
        return
      }
      if (destination.folder) {
        var categoryId = destination.id
        var subCategoryId = null
        if (angular.isArray(destination.breadcrumbs) && destination.breadcrumbs.length > 0) {
          categoryId = destination.breadcrumbs[0].id
          if (destination.breadcrumbs.length >= 2 && !destination.breadcrumbs[1].folder) {
            subCategoryId = destination.breadcrumbs[1].id
          }
        } else {
          categoryId = $scope.categoryId
          subCategoryId = $scope.subCategoryId
        }
        if (subCategoryId) {
          $state.go('app.category.sub.folder', { categoryId: categoryId, subCategoryId: subCategoryId, subId: destination.id })
        } else {
          $state.go('app.category.folder', { categoryId: categoryId, subId: destination.id })
        }
        return
      }
      if (angular.isArray(destination.breadcrumbs) && destination.breadcrumbs.length >= 2) {
        $state.go('app.category.sub', { categoryId: destination.breadcrumbs[0].id, subCategoryId: destination.id })
      } else {
        $state.go('app.category', { categoryId: destination.id })
      }
    }

    $scope.openMoveSelectionPopup = function () {
      if (!$scope.hasGroupMoveSelection()) {
        return
      }
      $scope.isMoveSelectionPopup = true
      $scope.currentMoveFolder = getCurrentMoveSource()
      $scope.foldersMovePopup = getMovePopupContent($scope.currentMoveFolder)
      updateMovePopupPanels()
      resetMovePopupSwipe()
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/moveSelection_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.moveSelectedItems = function () {
      if (!$scope.hasGroupMoveSelection()) {
        toastr.error('Veuillez sélectionner au moins un élément')
        return
      }
      if (!canMoveToCurrentDestination()) {
        if (isMoveRootDestination($scope.currentMoveFolder)) {
          toastr.error('Vous ne pouvez pas déplacer ces éléments dans un dossier root')
        } else {
          toastr.error('Vous ne pouvez pas déplacer ces éléments ici')
        }
        return
      }

      var destination = angular.copy($scope.currentMoveFolder)
      var selectedItems = angular.copy($scope.selectedMoveItems)

      if ($scope.isForbiddenSelectionDestination(destination)) {
        toastr.error('Vous ne pouvez pas choisir un dossier sélectionné (ou un de ses sous-dossiers) comme destination')
        return
      }

      for (var i = 0; i < selectedItems.length; i++) {
        if (selectedItems[i].folder && selectedItems[i].id === destination.id) {
          toastr.error('Vous ne pouvez pas déplacer un dossier dans lui-même')
          return
        }
      }

      $scope.submitting = true
      var payload = {
        currentMoveFolder: destination,
        subCategoryId: $scope.subCategoryId,
        documentsToMove: [],
        foldersToMove: []
      }
      for (var j = 0; j < selectedItems.length; j++) {
        var item = selectedItems[j]
        if (item.folder) {
          payload.foldersToMove.push({ id: item.id })
        } else {
          payload.documentsToMove.push({ id: item.id, folder: false })
        }
      }

      DocumentService.changeFolderBatch(payload).then(function (response) {
        clearGroupMoveSelectionState()
        refreshRootsAfterMoveIfNeeded(response)
        toastr.success('Les éléments sélectionnés ont été déplacés avec succès')
        $mdDialog.hide()
        redirectToMoveDestination(destination)
      }).catch(function (err) {
        if (err && err.status === 400 && err.data) {
          toastr.error(err.data)
        } else {
          toastr.error("Une erreur est survenue, veuillez réessayer plus tard")
        }
      }).finally(function () {
        $scope.submitting = false
      })
    }

    var getSelectedFolderIdsForMoveSelection = function () {
      var selectedFolderIds = {}
      if (!angular.isArray($scope.selectedMoveItems)) {
        return selectedFolderIds
      }
      for (var i = 0; i < $scope.selectedMoveItems.length; i++) {
        var item = $scope.selectedMoveItems[i]
        if (item && item.folder && angular.isDefined(item.id)) {
          selectedFolderIds[item.id] = true
        }
      }
      return selectedFolderIds
    }

    $scope.isForbiddenSelectionDestination = function (folder) {
      if (!$scope.isMoveSelectionPopup || !folder || !folder.folder || !angular.isDefined(folder.id)) {
        return false
      }
      var selectedFolderIds = getSelectedFolderIdsForMoveSelection()
      if (Object.keys(selectedFolderIds).length === 0) {
        return false
      }
      if (selectedFolderIds[folder.id]) {
        return true
      }
      if (!angular.isArray(folder.breadcrumbs)) {
        return false
      }
      for (var i = 0; i < folder.breadcrumbs.length; i++) {
        var breadcrumb = folder.breadcrumbs[i]
        if (breadcrumb && breadcrumb.folder && selectedFolderIds[breadcrumb.id]) {
          return true
        }
      }
      return false
    }

    $scope.findHistories = function () {
      return $q(function (resolve, reject) {
        DocumentService.findHistories($scope.documentToHistory.id, $scope.pagination).then(function (res) {
          resolve(res)
        }).catch(function () {
          toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
          reject()
        })

      })
    }

    $scope.openHistoriquePopup = function (document) {
      $scope.dto = {
        histories: []
      }
      $scope.pagination = {
        page: 0,
        nbrResults: 5
      }
      $scope.documentToHistory = document
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.folderPopup = $mdDialog.show({
          templateUrl: 'app/main/front/folders/folder/popup/historique_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        });
      }).catch(function () {

      })
    };



    $scope.previousPage = function () {
      if ($scope.loadingPagination) {
        return
      }
      $scope.loadingPagination = true
      $scope.pagination.page -= 1
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.loadingPagination = false
      }).catch(function () {
        $scope.loadingPagination = false
      })
    }

    $scope.nextPage = function () {
      if ($scope.loadingPagination) {
        return
      }
      $scope.loadingPagination = true
      $scope.pagination.page += 1
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.loadingPagination = false
      }).catch(function () {
        $scope.loadingPagination = false
      })
    }

    $scope.printUser = function (user) {
      if (user == null) {
        return ''
      } else if (user.titulaire) {
        return ' par le Titulaire'
      } else if (user.praq) {
        return ' par le Responsable Qualité'
      } else if (user.team) {
        return ' par l\'Equipe'
      }
    }

    $scope.nbPages = function () {
      if ($scope.dto == null || $scope.dto.total == null) {
        return 0
      }
      var mod = $scope.dto.total % $scope.pagination.nbrResults
      var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
      if (mod != 0) {
        res += 1
      }
      return res
    }




    $scope.moveDocument = function () {
      if (canMoveToCurrentDestination()) {
        var destination = angular.copy($scope.currentMoveFolder)
        DocumentService.changeFolder({ documentToMove: $scope.documentToMove, currentMoveFolder: $scope.currentMoveFolder, subCategoryId: $scope.subCategoryId }).then(function (response) {
          refreshRootsAfterMoveIfNeeded(response)
          toastr.success("Le document a été deplacé dans le dossier avec succès");
          $mdDialog.hide()
          redirectToMoveDestination(destination)
        }).catch(function (err) {
          if (err && err.status === 400 && err.data) {
            toastr.error(err.data)
          } else {
            toastr.error("Une erreur est survenue, veuillez réessayer plus tard");
          }
        });
      } else {
        if (isMoveRootDestination($scope.currentMoveFolder)) {
          toastr.error('Vous ne pouvez pas déplacer ce document dans un dossier root')
        } else {
          toastr.error('Vous ne pouvez pas déplacer ce document ici')
        }
      }
    }

    $scope.moveFolderToNew = function () {
      if (canMoveToCurrentDestination()) {
        var destination = angular.copy($scope.currentMoveFolder)
        FolderService.changeFolder({ folderToMove: $scope.folderToMove, currentMoveFolder: $scope.currentMoveFolder, subCategoryId: $scope.subCategoryId }).then(function (response) {
          refreshRootsAfterMoveIfNeeded(response)
          toastr.success("Le dossier a été deplacé dans le dossier avec succès");
          $mdDialog.hide()
          redirectToMoveDestination(destination)
        }).catch(function (err) {
          if (err && err.status === 400 && err.data) {
            toastr.error(err.data)
          } else {
            toastr.error("Une erreur est survenue, veuillez réessayer plus tard");
          }
        });
      } else {
        if (isMoveRootDestination($scope.currentMoveFolder)) {
          toastr.error('Vous ne pouvez pas déplacer ce dossier dans un dossier root')
        } else {
          toastr.error('Vous ne pouvez pas déplacer ce dossier ici')
        }
      }
    }

    $scope.goToMoveFolder = function (breadcrumb) {
      var folder = null
      if (breadcrumb.folder) {
        folder = findFolderFromCategories(breadcrumb.id, $scope.folders)
      } else {
        folder = findCategories(breadcrumb.id, $scope.folders)
      }
      $scope.currentMoveFolder = folder
      $scope.foldersMovePopup = getMovePopupContent(folder)
      updateMovePopupPanels()
      triggerMovePopupSwipe('right')
    }

    $scope.goToRoot = function () {
      $scope.foldersMovePopup = angular.copy($scope.folders)
      $scope.currentMoveFolder = { breadcrumbs: [] }
      $scope.movePopupParentFolder = null
      $scope.movePopupParentSiblings = angular.copy($scope.folders)
      triggerMovePopupSwipe('right')
    }

    $scope.backFolder = function (folder) {
      if (folder.parentId) {
        $scope.openFolder({ id: folder.parentId })
      } else {
        if ($scope.subCategoryId) {
          $scope.openSubCat({ id: $scope.categoryId }, $scope.category)
        } else {
          $scope.openCat($scope.category)
        }
      }
    }

    $scope.buildBreadcrumb = function (index) {
      var breadcrumb = $scope.category.breadcrumbs[index]
      if (index === 0) {
        return `./category/${breadcrumb.id}`
      } else {
        var categoryId = $scope.category.breadcrumbs[0].id
        var subCategoryId = null
        if ($scope.category.breadcrumbs.length >= 2) {
          if (!$scope.category.breadcrumbs[1].folder) {
            subCategoryId = $scope.category.breadcrumbs[1].id
          }
        }
        if (breadcrumb.folder) {
          if (subCategoryId) {
            return `./category/${categoryId}/${subCategoryId}/folder/${breadcrumb.id}`
          } else {
            return `./category/${categoryId}/folder/${breadcrumb.id}`
          }
        } else {
          if (subCategoryId) {
            return `./category/${categoryId}/${breadcrumb.id}`
          } else {
            return `./category/${breadcrumb.id}`
          }
        }
      }

    }

  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .factory('TachesGeneralesService', TachesGeneralesService);

  function TachesGeneralesService($q, $http) {

    var thisResource = "/api/rest/tacheGeneral";
    var userResource = "/api/rest/user";
    var reunionRessource = "api/rest/reunion";

    var service = {};

    service.users = function () {
      return $q(function (resolve, reject) {
        $http({
          url: userResource + "/find/active",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.page = function (page, fromQuality) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/page",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'fromQuality': !!fromQuality
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: page
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.save = function (task, updateFutureTask) {
      var finalUpdateFutureTask = !!updateFutureTask;
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/save",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'update-future-tasks': finalUpdateFutureTask
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: task
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function (id, deleteRecurrentTasks) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/delete/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime(),
            'deleteRecurrentTasks': deleteRecurrentTasks
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };
    service.deleteReunion = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: reunionRessource + "/delete/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.done = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/done/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    service.findByPharmacyAndPageAndEventAndDone = function (page, nbrResults, event, done) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/" + page + "/" + nbrResults + "/" + event + "/" + done,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    service.listEventAndTaskHome = function (collabId) {
      var id = null
      if (collabId) {
        id = collabId
      }

      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/home",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            collabId: id
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    service.findNotReunionByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/notReunions/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findNextEvents = function (collabId, page, nbrResults) {
      var id = null
      if (collabId) {
        id = collabId
      }
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/next/events/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            collabId: id
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };



    service.findReunionByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/list/reunions/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    service.findHistoryPaginate = function (taskId, page) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/history/" + taskId + "/" + page,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.saveRisk = function (risk) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planStrat" + "/saveRisk",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: risk
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getPagination = function (pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/paginated",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: thisResource + "/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return service;

  };
})();

(function () {
	'use strict';

	angular.module('app.front')
		.factory('EventService', EventService);

	function EventService($q, $http) {

		var thisResource = "/api/rest/event";
		var userResource = "/api/rest/user";

		var service = {};

		service.save = function (event, updateFuture) {
			var updateFutureTasks = !!updateFuture;
			return $q(function (resolve, reject) {
				$http({
					url: thisResource + "/save",
					method: "POST",
					params: {
						'_v': new Date().getTime(),
						'update-future-tasks': updateFutureTasks
					},
					headers: { "Content-Type": undefined },
					transformRequest: angular.identity,
					data: event
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;

	};
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('ReunionsController', ReunionsController);

  function ReunionsController($scope, $rootScope, $state, $location, $mdDialog, ReunionService, TachesGeneralesService, SELECT_HOURS_EVENTS, REUNION, api, toastr, TASKS_EVENTS_REMINDERS, PERMISSIONS, UserService) {

    // Constants

    $scope.REUNION = REUNION;
    $scope.permissions = PERMISSIONS;
    $scope.hourEvents = SELECT_HOURS_EVENTS;

    $scope.tabs = {
      reunion: 'reunion',
      history: 'history'
    }

    if ($state.params.tab) {
      $scope.tabActive = $state.params.tab
      $location.search('tab', null)
    } else {
      $scope.tabActive = $scope.tabs.reunion
    }

    // api

    $scope.api = api;

    // Helpers

    $scope._getHours = function (_date) {
      return _date.getHours();
    };

    $scope._setHours = function (_date, _hours) {
      _date.setHours(_hours);
    };

    $scope._getMinutes = function (_date) {
      return _date.getMinutes();
    };

    $scope._setMinutes = function (_date, _minutes) {
      _date.setMinutes(_minutes);
    };

    // Variables

    $scope._today = new Date();
    $scope._minDate = angular.copy($scope._today);
    $scope._maxDate = angular.copy($scope._minDate);
    $scope._maxDate.setFullYear($scope._today.getFullYear() + 20);
    $scope._archivesLoaded = false;
    $scope._yearContainsMoreThanTen = false;
    $scope.archiveEmpty = true;
    $scope.archive = { value: 'none' };
    $scope.archiveMonth = { value: 'none', index: 0 };
    $scope.numbers = {
      hasMoreThanTen: false,
      total: 0
    };
    $scope.numbersArchive = {
      hasMoreThanTen: false,
      total: 0
    };

    $scope._reunions = [];
    $scope._reunionsArchive = [];

    $scope._pages = {
      nonArchive: {
        page: 0,
        output: 10,
        filter: {
          archived: false,
          year: (new Date()).getFullYear()
        },
        sort: null
      },
      archive: {
        page: 0,
        output: 10,
        filter: {
          archived: true,
          year: null,
          month: 0
        },
        sort: null,
        noMoreData: false
      }
    };

    // Init reunion when we open the dialog from home

    $scope._reunion = {};
    $scope._reunion.dateStart = angular.copy($scope._today);
    // 9h
    $scope._reunion.hourSelect = 32400000;
    $scope._reunion.dateEnd = new Date($scope._today.getTime() + 60 * 60 * 1000);
    $scope._reunion.title = "Réunion ";
    $scope._reunion.lieu = "l'officine ";
    $scope.reminders = TASKS_EVENTS_REMINDERS;

    // Filters

    $scope.years = [];
    $scope.months = [];

    $scope.loadingAddReunion = false

    // Open new dialog

    $scope._openDialog = function () {
      if ($scope.loadingAddReunion) {
        return;
      }
      $scope.loadingAddReunion = true
      $scope._reunion = {};
      $scope._reunion.title = "Réunion ";
      $scope._reunion.lieu = "l'officine ";
      $scope._reunion.dateStart = angular.copy($scope._today);
      $scope._reunion.dateStart.setHours(0, 0, 0, 0)
      // 9h
      $scope._reunion.hourSelect = 32400000;
      $scope._reunion.dateEnd = new Date($scope._today.getTime() + 60 * 60 * 1000);
      ReunionService.save($scope._reunion).then(function (response) {
        if ($scope.fromHome == null) {
          $scope.fromHome = false;
        }
        $scope.loadingAddReunion = false
        $state.go('app.equipe.reunions.ordre-du-jour', {
          id: response.data.id,
          fromHome: $scope.fromHome,
          subTab: 'one'
        });
      }).catch(function (error) {
        $scope.loadingAddReunion = false
      });
      // showReunionModal();
    };

    function showReunionModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/reunions/reunion.dialog.html',
        locals: {
          type: "REUNION",
          datasource: {
            reunion: $scope._reunion,
          },
        },
        onRemoving: function (event, promise) {
          $scope._reunion = null;
        },
        controller: "DialogController"
      }).then(function (param) {
        $scope._reunions.push(param);
        $scope._ordreDuJour(param);
      }).catch(function (err) {

      });
    }

    // $scope.dialogDelete = function(reunion, index, archive) {
    //   $scope.reunionToDelete = reunion;
    //   $scope.indexToDelete = index;
    //   $scope.deleteArchive = archive;

    //   $mdDialog.show({
    //     templateUrl: 'app/main/front/equipe/reunions/deleteReunion.dialog.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: true,
    //     scope: $scope,
    //     preserveScope: true
    //   });
    // };

    // Close dialog

    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    // Form interaction

    $scope._wholeDay = function () {
      if ($scope._reunion.wholeDay) {

        $scope._setHours($scope._reunion.dateStart, 9);
        $scope._setMinutes($scope._reunion.dateStart, 0);
        $scope._reunion.hourStart = $scope._getHours($scope._reunion.dateStart);
        $scope._reunion.minuteStart = $scope._getMinutes($scope._reunion.dateStart);

        var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
        $scope._reunion.dateEnd = angular.copy(_newDateEndInstance);
        $scope._setHours($scope._reunion.dateEnd, 18);
        $scope._setMinutes($scope._reunion.dateEnd, 0);
        $scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
        $scope._reunion.minuteEnd = $scope._getMinutes($scope._reunion.dateEnd);

      }
    };

    $scope._dateStartHandle = function () {
      if ($scope._reunion.wholeDay) {
        $scope._wholeDay();
      } else {
        //$scope._setHours($scope._reunion.dateStart, $scope._reunion.hourStart);
        //$scope._setMinutes($scope._reunion.dateStart, $scope._reunion.minuteStart);

        if ($scope._reunion.dateStart > $scope._reunion.dateEnd) {

          var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
          $scope._reunion.dateEnd = angular.copy(_newDateEndInstance);

          $scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
          $scope._setHours($scope._reunion.dateEnd, $scope._reunion.hourEnd + 1);

          $scope._reunion.minuteEnd = $scope._getMinutes($scope._reunion.dateEnd);
          $scope._setMinutes($scope._reunion.dateEnd, $scope._reunion.minuteEnd);

        }
      }

    };

    $scope._dateEndHandle = function () {

      $scope._setHours($scope._reunion.dateEnd, $scope._reunion.hourEnd);
      $scope._setMinutes($scope._reunion.dateEnd, $scope._reunion.minuteEnd);

    };

    $scope.refresh = function () {
      ReunionService.countReunions().then(function (nbr) {
        nbr.data > $scope._pages.nonArchive.output ? $scope.numbers.hasMoreThanTen = true : $scope.numbers.hasMoreThanTen = false;
        $scope.numbers.total = nbr.data;
      }).catch(function (err) {
        console.log(err);
      })

      ReunionService.page($scope._pages.nonArchive).then(function (data) {
        $scope._reunions = data.data;
      }).catch(function (err) {
        console.log("Error getReunions()");
      });
    };

    $scope.refresh();

    $scope.getMore = function () {
      $scope._pages.nonArchive.output = $scope._pages.nonArchive.output + $scope._pages.nonArchive.output;
      $scope.refresh();
    }

    $scope.getMoreArchived = function () {
      $scope._pages.archive.output = $scope._pages.archive.output + $scope._pages.archive.output;
      $scope.searchArchives();
    }

    $scope.searchArchives = function (type) {
      ReunionService.countReunionsArchived().then(function (nbr) {
        nbr.data > $scope._pages.archive.output ? $scope.numbersArchive.hasMoreThanTen = true : $scope.numbersArchive.hasMoreThanTen = false;
        $scope.numbersArchive.total = nbr.data;
      }).catch(function (err) {
        console.log(err);
      })
      $scope.type = type;
      ReunionService.pageArchived($scope._pages.archive).then(function (res) {
        $scope._reunionsArchive = res.data;
      }).catch(function () { })
    };
    $scope.searchArchives()

    $scope.initStartEnd = function (type) {
      var today = new Date();
      var start = new Date(today.getFullYear(), 0, 1).getTime();
      var end = new Date(today.getFullYear(), 11, 31).getTime();
      if (!isNaN($scope.archive.value) && type === 'YEAR') {
        var year = parseInt($scope.archive.value);
        start = new Date(year, 0, 1).getTime();
        end = new Date(year, 11, 31).getTime();
      }
      else if (type === 'MONTH') {
        var month = $scope.archiveMonth.index;
        if ($scope.archiveMonth.value === 'all') {
          return 'all';
        }
        year = parseInt($scope.archive.value);
        start = new Date(year, month, 1).getTime();
        end = new Date(year, month, 31).getTime();
      }
      return { start: start, end: end };
    }

    $scope._openReunion = function (_reunion) {
      if (_reunion.statut === "Finaliser le compte-rendu") {
        $scope._ordreDuJour(_reunion);
      } else {
        $scope._ordreDuJour(_reunion);
      }
    };

    // Ordre du jour

    $scope._ordreDuJour = function (_reunion) {
      if ($scope.fromHome == null) {
        $scope.fromHome = false;
      }
      $state.go('app.equipe.reunions.ordre-du-jour', {
        id: _reunion.id,
        fromHome: $scope.fromHome
      });
    };

    // Compte rendu

    $scope._compteRendu = function (_reunion) {
      $state.go('app.equipe.reunions.compte-rendu', {
        id: _reunion.id
      });
    };

    // delete
    $scope._openDelete = function (task) {
      $scope.reunionToDelete = task;
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/reunions/deleteReunion.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        onRemoving: function (event, promise) {
          $scope.reunionToDelete = null;
        }
      });
    };

    $scope._delete = function (id) {
      ReunionService.delete(id).then(function (response) {
        $scope._closeDialog();
        $scope._reunions = $scope._reunions.filter(function (element) {
          return element.id != id;
        })
        $rootScope.$broadcast('refreshCountNotifs');
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.setActive = function (tab) {
      $scope.tabActive = tab
    }

  };


})();

(function () {
    'use strict';

    angular.module('app.front')
        .factory('ReunionService', ReunionService);

    function ReunionService($q, $http, api) {

        var url = "/api/rest/reunion";

        var service = {};

        service.hasArchived = function (page) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/hasArchived",
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.save = function (dto) {
            var _dto = angular.copy(dto);
            if (_dto.dateStart && _dto.dateEnd) {
                _dto.dateStart = api._dateToTimestamp(_dto.dateStart);
                _dto.dateEnd = api._dateToTimestamp(_dto.dateEnd);
            }
            if (_dto.hourSelect) {
                _dto.dateStart += _dto.hourSelect;
            }
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/save",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: _dto
                }).then(function (response) {
                    if (response.data.dateStart) {
                        response.data.dateStart = api._timestampToDate(response.data.dateStart);
                    }
                    if (response.data.dateEnd) {
                        response.data.dateEnd = api._timestampToDate(response.data.dateEnd);
                    }
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.countReunions = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/countReunions/",
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.countReunionsArchived = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/countReunions/archived",
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.listYears = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/years/",
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.listMonths = function (year) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/months/" + year,
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.list = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/list/",
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.page = function (page) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/page",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: page
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.pageArchived = function (page) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/page/archived",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: page
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.listAllArchived = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/listAllArchived/",
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.listArchived = function (start, end) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/listArchived/" + start + "/" + end,
                    method: "GET",
                    params: { '_v': new Date().getTime() }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findReunion = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/findReunion/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                }).then(function (response) {
                    response.data.dateStart = api._timestampToDate(response.data.dateStart);
                    response.data.dateEnd = api._timestampToDate(response.data.dateEnd);
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.elementAssociationDetails = function (rubriqueType, elementAssociationId) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/elementAssociationDetails/" + rubriqueType + "/" + elementAssociationId,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.saveOrdreDuJour = function (reunion, rubriques) {
            const fmData = new FormData()
            var _ordreDuJourDTO = angular.copy(reunion.ordreDuJour);
            _ordreDuJourDTO.rubriques = rubriques.filter(function (rubrique) {
                return rubrique.elements.length > 0
            })
            _ordreDuJourDTO.elements = []
            angular.forEach(rubriques, function (_rItem, _rIndex) {
                angular.forEach(_rItem.elements, function (_eItem, _eIndex) {
                    if (_eItem.type === 'DOCUMENT_MODIFIE' && _eItem.file) {
                        fmData.append('files', _eItem.file, _eItem.libelle)
                        delete _eItem.file
                    }
                    _ordreDuJourDTO.elements.push(angular.copy(_eItem));
                });
            });
            fmData.append('dto', angular.toJson(_ordreDuJourDTO))

            return $q(function (resolve, reject) {
                $http({
                    url: url + "/saveOrdreDuJour/",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: {
                        "Content-Type": undefined
                    },
                    data: fmData
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.reunionRealisee = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/reunionRealisee/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.compteRenduDetails = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/compteRenduDetails/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.saveCompteRendu = function (dto, rubriques) {
            dto.ordreDuJour.rubriques = rubriques.filter(function (rubrique) {
                return rubrique.elements.length > 0
            })
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/saveCompteRendu/",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.cloturerEtArchiverReunion = function (dto, rubriques) {
            dto.ordreDuJour.rubriques = rubriques.filter(function (rubrique) {
                return rubrique.elements.length > 0
            })
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/cloturerEtArchiverReunion/",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.delete = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/delete/" + id,
                    method: "DELETE",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            })
        };

        service.getPagination = function (pagination) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + "/paginated",
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json; charset=UTF-8" },
                    data: pagination
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.getDownloadLink = function (elementId) {
            return url + '/elementAssociationDetails/' + elementId + '/download';
        };

        service.getPDF = function (elementId) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/elementAssociationDetails/' + elementId + '/download',
                    method: "GET",
                    params: { '_v': new Date().getTime(), pdf: true },
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    responseType: 'arraybuffer'
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        return service;

    };
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('ProjectsController', ProjectsController);

    function ProjectsController($scope, $rootScope, $state, $location, $mdDialog, ProjectService, TachesGeneralesService, SELECT_HOURS_EVENTS, REUNION, api, toastr, TASKS_EVENTS_REMINDERS, PERMISSIONS, UserService) {

        $scope.archived = []
        $scope.loadingDelete = false
        $scope.loadingSave = false
        $scope.tabs = {
            actifs: 'actifs',
            archives: 'archives',
        }
        $scope.tabActive = $scope.tabs.actifs
        $scope.projects = []

        $scope.init = function () {
            ProjectService.findAll(false).then(function (res) {
                $scope.projects = res.data
            }).catch(function () {

            })
            ProjectService.findAll(true).then(function (res) {
                $scope.archived = res.data
            }).catch(function () {

            })
        }

        $scope.init()

        $scope.openNewProject = function () {
            $scope.newProject = {}
            $scope.equipePopup = $mdDialog.show({
                templateUrl: 'app/main/front/equipe/projects/popup/add_project_popup.html',
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
            }).then(function (data) {
            }).catch(function (error) {
            });
        }

        $scope.saveProject = function () {
            if ($scope.loadingSave) {
                return
            }
            $scope.loadingSave = true
            ProjectService.save($scope.newProject).then(function () {
                toastr.success('Projet créé')
                $scope.loadingSave = false
                $mdDialog.hide()
                $scope.init()
            }).catch(function () {
                $scope.loadingSave = false
                toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
            })
        }

        $scope.closeModal = function () {
            $mdDialog.hide()
        }

        $scope.openDelete = function (project) {
            $scope.projectToDelete = project
            $scope.equipePopup = $mdDialog.show({
                templateUrl: 'app/main/front/equipe/projects/popup/confirm_delete_dialog.html',
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
            }).then(function (data) {
            }).catch(function (error) {
            });
        }

        $scope.delete = function () {
            if ($scope.loadingDelete) {
                return
            }
            $scope.loadingDelete = true
            ProjectService.delete($scope.projectToDelete.id).then(function () {
                $scope.loadingDelete = false
                $mdDialog.hide()
                $scope.init()
            }).catch(function () {
                $scope.loadingDelete = false
                toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
            })
        }

        $scope.setArchive = function (project, archive) {
            ProjectService.setArchive(project.id, archive).then(function () {
                $scope.init();
                if (project.archived) {
                    toastr.success("Projet désarchivé avec succès")
                } else {
                    toastr.success("Projet archivé avec succès")
                }
            }).catch(function () {
                toastr.error("Erreur durant l'archivage")
            })
        }

        $scope.setConfidential = function (project) {
            ProjectService.setConfidential(project.id, !project.confidential).then(function () {
                if (project.confidential) {
                    toastr.success("Projet masqué avec succès")
                } else {
                    toastr.success("Projet démasqué avec succès")
                }
                project.confidential = !project.confidential
            }).catch(function (response) {
                if (response.status === 404) {
                    toastr.error(txtDocNotFound);
                }
            });
        };

        $scope.details = function (project) {
            $state.go('app.equipe.projects.details', { id: project.id })
        }

    };

})();
(function () {
    'use strict';

    angular.module('app.front')
        .factory('ProjectService', ProjectService);

    function ProjectService($q, $http, api) {

        var url = "/api/rest/project";

        var service = {};

        service.findAll = function (archived) {
            return $q(function (resolve, reject) {
                $http({
                    url: url,
                    method: "GET",
                    params: { '_v': new Date().getTime(), archived: archived },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.findById = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/' + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.findTasks = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/' + id + '/tasks',
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.save = function (dto) {
            return $q(function (resolve, reject) {
                $http({
                    url: url,
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.setConfidential = function (id, confidential) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/' + id + '/confidential',
                    method: "PATCH",
                    params: { '_v': new Date().getTime(), confidential: confidential },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.setArchive = function (id, archive) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/' + id + '/archive',
                    method: "PATCH",
                    params: { '_v': new Date().getTime(), archive: archive },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        service.delete = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: url + '/' + id,
                    method: "DELETE",
                    params: { '_v': new Date().getTime() },
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });

            });
        }

        return service;

    };
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('ProjectController', ProjectController);

    function ProjectController($scope, $rootScope, $state, $mdDialog, ProjectService, EquipeDetailService, TachesGeneralesService, toastr) {

        $scope.loadingSave = false
        $scope.progress = 0
        $scope.project = {}
        $scope._project = {}
        $scope.realised = 0
        $scope.total = 0


        $scope.refreshRealised = function () {
            $scope.realised = $scope.project.tasks.filter(t => t.done).length
            $scope.total = $scope.project.tasks.length
            if ($scope.total != 0) {
                $scope.progress = Math.round($scope.realised / $scope.total * 100)
            } else {
                $scope.progress = 0
            }
        }

        ProjectService.findById($state.params.id).then(function (res) {
            $scope.project = res.data
            $scope._project = angular.copy($scope.project)
            $scope.refreshRealised()
        }).catch(function () {

        })

        EquipeDetailService.getCollaborateurs().then(function (data) {
            $scope._users = data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope.$on('refreshTasks', () => {
            $scope.refreshTasks()
        })


        function showTaskModal($event) {
            var parentEl = angular.element(document.body);
            var datasource = {
                task: $scope._task,
            }
            if (typeof $scope._task.echeance === 'number') {
                datasource.echeance = new Date($scope._task.echeance)
            }
            $mdDialog.show({
                parent: parentEl,
                clickOutsideToClose: true,
                templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
                locals: {
                    type: "PROJECT",
                    datasource: datasource,
                },
                controller: "DialogController"
            }).then(function () {
            }).catch(function () {

            });
        }

        $scope.goBack = function () {
            $state.go('app.equipe.projects', { id: $state.params.id })
        }

        $scope.refreshTasks = function () {
            ProjectService.findTasks($state.params.id).then(function (res) {
                $scope.project.tasks = res.data
                $scope._project.tasks = angular.copy(res.data)
                $scope.refreshRealised()
            }).catch(function () {

            })
        }

        $scope.addTask = function (obj) {
            $scope._task = {
                projectId: $state.params.id,
                category: 'PROJECT'
            };
            ProjectService.save($scope.project).then(function () {
                showTaskModal();
            }).catch(function () {
                toastr.error('Une erreur est survenue')
            })
        }

        $scope._openDeleteTask = function (task) {
            $scope._task = task;
            $scope.deleteRecurrentTasks = {
                value: false
            };
            $mdDialog.show({
                templateUrl: 'app/main/front/equipe/taches-generales/confirm_delete_dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
                onRemoving: function (event, promise) {
                    $scope._task = null;
                }
            });
        };
        $scope._delete = function (task) {
            if ($scope.loadingDeleteTask) {
                return;
            }
            $scope.loadingDeleteTask = true;
            TachesGeneralesService.delete(task.id, $scope.deleteRecurrentTasks.value).then(function () {
                $scope.loadingDeleteTask = false;
                $scope.project.tasks = $scope.project.tasks.filter(t => t.id != task.id)
                $scope._project.tasks = angular.copy($scope.project.tasks)
                $scope.refreshRealised()
                $rootScope.$broadcast('refreshCountNotifs')
                toastr.success("La tâche a bien été supprimée");
                $mdDialog.hide()
            }).catch(function (error) {
                $scope.loadingDeleteTask = false;
                console.log(error);
            });

        };

        $scope._closeDialog = function () {
            $mdDialog.hide();
        };

        $scope.showElement = function (element) {
            $scope._task = angular.copy(element)
            showTaskModal()
        }

        $scope.upIndex = function (index) {
            var down = angular.copy($scope.project.tasks[index - 1])
            var up = angular.copy($scope.project.tasks[index])
            $scope.project.tasks[index - 1] = up
            $scope.project.tasks[index] = down
        }

        $scope.downIndex = function (index) {
            var up = angular.copy($scope.project.tasks[index + 1])
            var down = angular.copy($scope.project.tasks[index])
            $scope.project.tasks[index + 1] = down
            $scope.project.tasks[index] = up
        }

        $scope.save = function () {
            if ($scope.loadingSave) {
                return
            }
            $scope.loadingSave = true
            ProjectService.save($scope.project).then(function () {
                toastr.success('Modifications enregistrées')
                $scope.loadingSave = false
            }).catch(function () {
                toastr.error('Une erreur est survenue')
                $scope.loadingSave = false
            })
        }

        $scope._actionDecideeFaite = function (_actionDecidee) {
            $scope.refreshRealised()
            TachesGeneralesService.done(_actionDecidee.id).then(function (response) {
            }).catch(function (error) {
                console.log(error);
            });
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('PlanningGeneralController', PlanningGeneralController);

  function PlanningGeneralController(toastr, $scope, $state, $q, $mdDialog, $rootScope, $location, PlanningService, msUtils, TachesGeneralesService, CahierTransmissionService, TASKS_EVENTS_REMINDERS, EquipeDetailService, EventService, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD, SELECT_HOURS_EVENTS) {
    var today = new Date();
    today.setSeconds(0, 0);
    $scope.today = today.getTime()
    $scope.planning = {
      beginDate: new Date(today.getFullYear(), today.getMonth(), 1).getTime(),
      endDate: new Date(today.getFullYear(), today.getMonth() + 2, 0).getTime()
    };
    $scope.canNext = false

    $scope.dateFilter = {
      isOpen: false,
      dateTask: new Date(),
      dateCheck: new Date()
    }

    $scope.textFilter = {
      value: ''
    }

    $scope.tabs = {
      task: 'task',
      qualite: 'qualite',
      checklist: 'checklist'
    }
    if ($state.params.tab) {
      $scope.tabActive = $state.params.tab
      $location.search('tab', null)
    } else {
      $scope.tabActive = 'task'
    }

    if (msUtils.isMobile()) {
      $scope.isMobile = true
    }

    $scope.intoSaving = false;
    $scope._reminders = angular.copy(TASKS_EVENTS_REMINDERS);
    $scope.fromQuality = ($state.current.name.lastIndexOf('app.qualite') > -1);
    $scope.isEvent = null;
    $scope.collaborateurID = null;
    $scope.noMoreFirstMonth = false;
    $scope.noMoreLastMonth = false;
    $scope.closeFiche = false;
    var listing = {
      firstMonth: false,
      lastMonth: false
    };
    $scope.firstMonth = [];
    $scope.lastMonth = [];
    $scope.taskHistories = [];
    $scope.reunionIDsToExclude = {
      firstMonth: [],
      lastMonth: []
    };
    $scope.planningIDsToExcule = {
      firstMonth: [],
      lastMonth: []
    };
    $scope.cal = [];
    $scope.paginationFirstMonth = 0;
    $scope.paginationLastMonth = 0;
    var planningRequest = null;
    var findHistoryRequest = null;
    var wholeDay = {};
    $scope._categories = angular.copy(GENERAL_TASK_TYPES);
    $scope._recurrences = angular.copy(GENERAL_TASK_PERIOD);
    $scope.minDateEcheance = angular.copy(today);
    $scope.echeance = angular.copy(today);
    $scope.reminders = TASKS_EVENTS_REMINDERS;
    $scope.hourEvents = SELECT_HOURS_EVENTS;
    $scope._baseResource = '/api/rest/tacheGeneral';
    $scope._icsResource = '/api/public/unsecured/ics';
    $scope.filterValue = '';
    $scope.collabValue = '';
    $scope.icsToken = null;
    $scope.showReset = false;

    $scope.filterType = { value: '' }
    $scope.typeValues = {
      notDone: 'notDone',
      done: 'done',
      late: 'late'
    }


    $scope.checks = []

    $scope.$on('changePlanningFilter', function (event, data) {
      if (data && data.filter) {
        $scope.tabActive = $scope.tabs.task
        $scope.filterType.value = $scope.typeValues[data.filter]
        initPlannings()
      }
    })

    $scope.$on('changePlanningTab', function (event, data) {
      if (data && data.tab) {
        $scope.tabActive = data.tab
      }
    })

    function initPlannings() {
      $scope.paginationFirstMonth = 0;
      $scope.paginationLastMonth = 0;
      $scope.reunionIDsToExclude = {
        firstMonth: [],
        lastMonth: []
      };
      $scope.planningIDsToExcule = {
        firstMonth: [],
        lastMonth: []
      };
      $scope.noMoreFirstMonth = false;
      $scope.noMoreLastMonth = false;
      if ($state.params.filter) {
        $scope.tabActive = $scope.tabs.task
        $scope.filterType.value = $scope.typeValues[$state.params.filter]
        $location.search('filter', null)
      }
      $scope.listPlanning();
    }

    $scope.refreshTags = function () {
      CahierTransmissionService.findTags().then(function (res) {
        $scope.tags = res.data
        $scope.editedTags = angular.copy(res.data)
        $scope._tags = angular.copy(res.data)
      }).catch(function () { })
    }

    $scope.refreshTags()

    $scope.listChecklist = function () {
      var start = new Date($scope.dateFilter.dateCheck)
      start.setHours(0, 0, 0, 0)
      var end = new Date($scope.dateFilter.dateCheck)
      end.setHours(23, 59, 59, 999)
      PlanningService.getChecklist(start.getTime(), end.getTime()).then(function (res) {
        $scope.checks = res.data
      }).catch(function () {

      })
    }

    PlanningService.generateIcs(false).then(function (res) {
      $scope.icsToken = window.location.origin + $scope._icsResource + '/' + res.data.value
    }).catch(function () {
      toastr.error('Une erreur est survenue')
    })


    $scope.filterType = function (val) {
      $scope.isEvent = val;
    }

    $scope.filterIndex = function (val) {
      $scope.filterValue = val;
    }

    $scope.filterCollab = function (user) {
      if (user != null) {
        $scope.collaborateurID = user.id;
        $scope.collabValue = user.name + ' ' + user.surname
      }
      else {
        $scope.collaborateurID = null;
        $scope.collabValue = user;
      }
      // $scope.listPlanning(true);
    }

    $scope.getCalendarDay = function (day, isFirstMonth) {
      var date = angular.copy(day.date);

      date.setHours(0, 0, 0, 0);
      wholeDay.start = date.getTime();
      date.setHours(23, 59, 59, 99);
      wholeDay.end = date.getTime();

      if (isFirstMonth) {
        $scope.paginationFirstMonth = 0;
        $scope.reunionIDsToExclude.firstMonth = [];
        $scope.planningIDsToExcule.firstMonth = [];
        $scope.noMoreFirstMonth = false;
      } else {
        $scope.paginationLastMonth = 0;
        $scope.reunionIDsToExclude.lastMonth = [];
        $scope.planningIDsToExcule.lastMonth = [];
        $scope.noMoreLastMonth = false;
      }
      $scope.listPlanning(isFirstMonth);
    };

    $scope.listPlanning = function () {
      var start = $scope.dateFilter.dateTask
      start.setHours(0, 0, 0, 0)
      var end = null;
      if (moment($scope.dateFilter.dateTask).format('dd-MM-yyyy') === moment($scope.today).format('dd-MM-yyyy')) {
        end = moment($scope.today).add(1, 'month').valueOf()
      } else {
        end = moment($scope.dateFilter.dateTask).add(1, 'month').valueOf()
      }
      var done = null
      var late = null
      var ecor = null
      if ($scope.filterType.value === $scope.typeValues.notDone) {
        done = false
      } else if ($scope.filterType.value === $scope.typeValues.done) {
        done = true
      } else if ($scope.filterType.value === $scope.typeValues.late) {
        late = true
        done = false
      }
      if ($scope.filterType.ecor) {
        ecor = true
      }

      PlanningService.list(start.getTime(), end, $scope.fromQuality,
        null, null, null, null, done, late, $scope.today, $scope.collaborateurID, false, $scope.textFilter.value, $scope.filterType.tag).then(function (response) {
          $scope.tasks = response.data
        }).catch(function () {
        });
      PlanningService.list(start.getTime(), end, $scope.fromQuality,
        null, null, null, null, null, null, $scope.today, $scope.collaborateurID, true, $scope.textFilter.value, $scope.filterType.tag).then(function (response) {
          $scope.events = response.data
        }).catch(function () {
        });

    };
    $scope.cancelSearch = function () {
      $scope.textFilter.value = null;
      $scope.tasks = [];
      $scope.events = [];
      $scope.listPlanning()
    }

    $scope.findCategory = function (task) {
      for (var i = 0; i < GENERAL_TASK_TYPES.length; i++) {
        if (task.category === GENERAL_TASK_TYPES[i].value) {
          return GENERAL_TASK_TYPES[i].libelle;
        }
      }
    };

    // $scope.$on('refreshDate', function () {
    //   initPlannings();
    // });

    // $scope.$watch('isEvent', function () {
    //   initPlannings();
    // });



    $scope.isMoreThanOneDay = function (task) {
      return (task.end - task.echeance > 24 * 60 * 60 * 1000);
    };

    $scope._openDelete = function (task) {
      $scope._task = task;
      $scope.deleteRecurrentTasks = {
        value: false
      };
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/taches-generales/confirm_delete_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        onRemoving: function (event, promise) {
          $scope._task = null;
        }
      });
    };
    $scope._delete = function (task) {
      if ($scope.loadingDeleteTask) {
        return;
      }
      $scope.loadingDeleteTask = true;
      if (task.reunion) {
        TachesGeneralesService.deleteReunion(task.id).then(function (response) {
          $scope.reunionIDsToExclude = {
            firstMonth: [],
            lastMonth: []
          };
          $scope.planningIDsToExcule = {
            firstMonth: [],
            lastMonth: []
          };
          $scope.loadingDeleteTask = false;
          initPlannings();
          $rootScope.$broadcast('refreshCountNotifs')
          toastr.success("La réunion a bien été supprimée")
          $scope._closeDialog();
        }).catch(function (error) {
          $scope.loadingDeleteTask = false;
          console.log(error);
        });
      } else {
        TachesGeneralesService.delete(task.id, $scope.deleteRecurrentTasks.value).then(function (response) {
          $scope.reunionIDsToExclude = {
            firstMonth: [],
            lastMonth: []
          };
          $scope.planningIDsToExcule = {
            firstMonth: [],
            lastMonth: []
          };
          $scope.loadingDeleteTask = false;
          initPlannings();
          $rootScope.$broadcast('refreshCountNotifs')
          task.event ? toastr.success("L'évènement a bien été supprimé") : toastr.success("La tâche a bien été supprimée");
          $scope._closeDialog();
        }).catch(function (error) {
          $scope.loadingDeleteTask = false;
          console.log(error);
        });
      }

    };

    //TASK
    $scope.onEcheanceChange = function (object) {
      object.echeance = object._echeance.valueOf();
    };

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {

    });
    $scope.addTask = function () {
      $scope._task = {
      };

      if ($scope.fromQuality) {
        for (var i = 0; i < $scope._categories.length; i++) {
          if ($scope._categories[i].value === 'QUALITE') {
            $scope._task.category = $scope._categories[i].value;
          }
        }
      }
      $scope.editMode = false;
      $scope.echeance = null;
      showTaskModal();
    };

    function showTaskModal(url) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: url ? url : 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "AUTRE",
          datasource: {
            task: $scope._task,
            event: $scope.event,
            echeance: $scope.echeance,
          }
        },
        controller: "DialogController"
      }).then(function (param) {
        $scope.reunionIDsToExclude = {
          firstMonth: [],
          lastMonth: []
        };
        $scope.planningIDsToExcule = {
          firstMonth: [],
          lastMonth: []
        };
        if (param) {
          initPlannings();
        }
      }).catch(function () {
      });
    }

    $scope.addTaskOrEventPopup = function () {
      $scope._task = {
      }
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/add_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          type: "AUTRE",
          datasource: {
            task: $scope._task,
            event: $scope.event,
          }
        },
        controller: "DialogController"
      }).then(function (param) {
        if (param) {
          initPlannings();
        }
      });
    }

    $scope.showRDVPopup = function () {
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/showRDV_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.showSynchroPopup = function () {
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/showSynchro_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });

    }

    $scope.resetFilters = function () {
      $scope.filterType = { value: '' }
      $scope.typeValues = {
        notDone: 'notDone',
        done: 'done',
        late: 'late'
      }
      $scope.switchType();
      $scope.showReset = false;
    }

    $scope._edit = function (task) {
      $scope.taskType = ''
      var templateUrl = '';
      $scope.editMode = true;
      $scope._task = null;
      $scope.event = null;
      if (task.reunion) {
        if (task.statut === "Finaliser le compte-rendu") {
          $scope._compteRendu(task);
        } else {
          $scope._ordreDuJour(task);
        }
      } else {
        if (!task.event) {
          $scope._task = angular.copy(task);

          if (task.hasOwnProperty('echeance') && task.echeance != null) {
            $scope._task.echeance = new Date(task.echeance);
            $scope.echeance = new Date(task.echeance);
          } else {
            $scope._task.echeance = angular.copy(today);
            $scope.echeance = angular.copy(today);
          }

          templateUrl = 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html';
        } else {
          $scope._task = task;

          if (task.hasOwnProperty('echeance') && task.echeance != null) {
            $scope._task.echeance = new Date(task.echeance);
            $scope.echeance = new Date(task.echeance);
          } else {
            $scope._task.echeance = angular.copy(today);
            $scope.echeance = angular.copy(today);
          }
          if (task.hasOwnProperty('end') && task.end != null) {
            var ending = moment.utc(task.end - task.echeance).format('HH:mm')
            $scope._task.duration = ending
          }
          templateUrl = 'app/main/front/equipe/planning-general/popup/showRDV_popup.html';
        }

        showTaskModal(templateUrl);
      }
    };

    $scope._ordreDuJour = function (_reunion) {
      $state.go('app.equipe.reunions.ordre-du-jour', {
        id: _reunion.id
      });
    };

    // Compte rendu

    $scope._compteRendu = function (_reunion) {
      $state.go('app.equipe.reunions.compte-rendu', {
        id: _reunion.id
      });
    };

    // Done
    $scope._done = function () {
      $scope.taskDone = true;
      if ($scope._taskToConfirm.done) {
        TachesGeneralesService.done($scope._taskToConfirm.id).then(function (response) {
          if ($scope._taskToConfirm.progressFormId != null) {
            $scope._taskToConfirm.nbrProgressFormLeft--;
            if ($scope._taskToConfirm.nbrProgressFormLeft > 1) {
              toastr.success('Il reste ' + $scope._taskToConfirm.nbrProgressFormLeft + ' tâches associées à la fiche de progrès.');
            } else if ($scope._taskToConfirm.nbrProgressFormLeft === 1) {
              toastr.success('Il reste ' + $scope._taskToConfirm.nbrProgressFormLeft + ' tâche associée à la fiche de progrès.');
            } else {
              toastr.success('La fiche de progrès associée a été cloturée');
            }
          } else {
            toastr.success('Tâche effectuée: ' + $scope._taskToConfirm.title);
          }
          $scope._closeDialog();
        }).catch(function (error) {
          console.log(error);
        });
      }
      $scope.closeFiche = false;
    };

    $scope.setDone = function (task) {
      if (task.progressFormId != null && task.nbrProgressFormLeft === 1) {
        $scope.closeFiche = true;
        $scope._taskToConfirm = task;
        $mdDialog
          .show({
            templateUrl:
              "app/main/front/equipe/taches-generales/confirm_progress_form.html",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            // onRemoving: function (event, removePromise) {
            //   $scope._hideConfirmEventPopUp();
            // },
            scope: $scope,
            preserveScope: true
          })
          .then(function () { })
          .catch(function () { });
      } else {
        TachesGeneralesService.done(task.id).then(function (response) {
          if (task.done) {
            if (task.progressFormId != null) {
              task.nbrProgressFormLeft--;
              if (task.nbrProgressFormLeft > 1) {
                toastr.success('Il reste ' + task.nbrProgressFormLeft + ' tâches associées à la fiche de progrès.');
              } else if (task.nbrProgressFormLeft === 1) {
                toastr.success('Il reste ' + task.nbrProgressFormLeft + ' tâche associée à la fiche de progrès.');
              } else {
                toastr.success('La fiche de progrès associée a été cloturée');
              }
            }
          }
          initPlannings()
          $rootScope.$broadcast('refreshCountNotifs');
        }).catch(function (error) {
          console.log(error);
        });
        $scope.closeFiche = false;
      }
    };

    $scope._hideConfirmEventPopUp = function () {
      $scope._taskToConfirm.done = !$scope._taskToConfirm.done;
      $scope._taskToConfirm = null;
      $scope.closeFiche = false;
      $scope._closeDialog();
    }

    //Historique des taches
    $scope._openHistory = function (task) {
      $scope._task = angular.copy(task);
      $scope.taskHistories = [];
      $scope.historyPagination = 0;
      $scope.noMoreHistory = false;
      $scope.historyLoading = true;
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/taches-generales/historique.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        onRemoving: function (event, promise) {
          $scope.taskHistories = [];
          $scope._task = null;
          $scope.historyLoading = false;
        }
      });
      $scope.findHistories().finally(function () {
        $scope.historyLoading = false;
      });
    };

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    $scope.findHistories = function () {
      return $q(function (resolve, reject) {
        TachesGeneralesService.findHistoryPaginate($scope._task.id, $scope.historyPagination).then(function (response) {
          if (response.data.length === 0) {
            $scope.noMoreHistory = true;
          }
          $scope.taskHistories = $scope.taskHistories.concat(response.data);
          $scope.historyPagination = $scope.historyPagination + 1;
          resolve()
        }).catch(function (error) {
          reject(error)
        });
      })

    };

    // Close dialog
    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    $scope.addEvent = function () {
      $scope.event = {
        echeance: null,
        end: null,
        endDate: angular.copy(today),
        startDate: angular.copy(today),
        endHoursDay: 36000000,
        startHoursDay: 36000000
      };

      $scope.editMode = false;

      $scope.addTaskPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/add_evenement_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: PlanningGeneralController,
        preserveScope: true
      }).then(function () {
        initPlannings();
      }).catch(function () { });
    };

    $scope.saveEvent = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;
        if (!$scope.event.allDay) {
          var start = $scope.event.startDate;
          var end = $scope.event.endDate || new Date();

          start.setHours(0, 0, 0, 0);

          if ($scope.event.endHoursDay || $scope.event.endHoursDay === 0) {
            end.setHours(0, 0, 0, 0);
          } else {
            end.setHours(23, 59, 59);
          }

          var startTime = start.getTime() + ($scope.event.startHoursDay ? $scope.event.startHoursDay : 0);
          var endTime = end.getTime() + ($scope.event.endHoursDay ? $scope.event.endHoursDay : 0);

          if (startTime > endTime) {
            toastr.error("Erreur: la date de début doit être antérieure à la date de fin.");
            $scope.intoSaving = false;
            return;
          }
          if (!$scope.event.startHoursDay && !$scope.event.endHoursDay && $scope.event.startDate.getFullYear() === end.getFullYear() &&
            $scope.event.startDate.getMonth() === end.getMonth() &&
            $scope.event.startDate.getDate() === end.getDate()) {
            $scope.event.echeance = $scope.event.startDate.getTime();
            $scope.event.allDay = true;
          } else {
            $scope.event.echeance = startTime;
            $scope.event.ending = endTime;
          }

        } else {
          $scope.event.echeance = $scope.event.startDate.getTime();
        }

        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }
        formData.append('dto', angular.toJson($scope.event));
        EventService.save(formData).then(function (response) {
          if ($scope.event.id) {
            toastr.success("Evénement modifié avec succès");
          } else {
            toastr.success("Evénement sauvegardée avec succès");
          }
          $scope.reunionIDsToExclude = {
            firstMonth: [],
            lastMonth: []
          };
          $scope.planningIDsToExcule = {
            firstMonth: [],
            lastMonth: []
          };
          initPlannings();
          $scope._closeDialog();
          $timeout(function () {
            $scope.intoSaving = false;
          });
        }).catch(function (err) {
          console.log(err);
          $scope.intoSaving = false;
        });
      }

    };
    // Download
    $scope._downloadAttachement = function (_attachment) {
      location.href = $scope._baseResource + '/download/' + _attachment.id;
    };

    $scope.initPlannings = initPlannings();
    $scope.listChecklist()
    $scope.$watch('collaborateurID', function (newValue, oldValue, scope) {
      if (newValue != oldValue) {
        initPlannings();
      }
    });

    $scope.openAddPopup = function () {
      if ($scope.checks.length >= 12) {
        toastr.error('Vous ne pouvez ajouter que 12 tâches maximum')
        return
      }
      var date = $scope.dateFilter.dateCheck
      date.setHours(0, 0, 0, 0)
      $scope.check = {
        date: date.getTime()
      }
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/add_checklist_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.previous = function (variable) {
      var date = moment($scope.dateFilter[variable])
      $scope.dateFilter[variable] = date.subtract(1, 'day').toDate()
      if (variable === 'dateTask') {
        $scope.listPlanning()
      } else if (variable === 'dateCheck') {
        $scope.canNext = true;
        $scope.listChecklist()
      }
    }

    $scope.next = function (variable) {
      var date = moment($scope.dateFilter[variable])
      $scope.dateFilter[variable] = date.add(1, 'day').toDate()
      if (variable === 'dateTask') {
        $scope.listPlanning()
      } else if (variable === 'dateCheck') {
        if (moment($scope.today).format('YYYY-MM-DD') === moment($scope.dateFilter[variable]).format('YYYY-MM-DD')) {
          $scope.canNext = false
        }
        $scope.listChecklist()
      }
    }

    $scope.switchType = function () {
      if ($scope.filterType.value !== '') {
        $scope.dateFilter.dateTask = new Date($scope.today)
      }
      $scope.listPlanning()
      $scope.showReset = true;
    }

    $scope.copyIcsToken = function () {
      navigator.clipboard.writeText($scope.icsToken)
      toastr.success('Lien copié')
    }

    $scope.changeIcs = function () {
      PlanningService.generateIcs(true).then(function (res) {
        $scope.icsToken = window.location.origin + $scope._icsResource + '/' + res.data.value
        toastr.success('Nouveau lien créé')
      }).catch(function () {

      })
    }

    $scope.saveCheck = function () {
      if ($scope.loading) {
        return
      }
      $scope.loading = true
      var start = $scope.dateFilter.dateCheck
      start.setHours(0, 0, 0, 0)
      var end = $scope.dateFilter.dateCheck
      end.setHours(23, 59, 59, 999)
      PlanningService.saveChecklist(start.getTime(), end.getTime(), $scope.check).then(function (res) {
        toastr.success('Tâche enregistrée')
        $scope.listChecklist()
        $mdDialog.hide()
        $scope.loading = false;
      }).catch(function () {
        toastr.error('Une erreur est survenue')
        $scope.loading = false;
      })
    }

    $scope.setCheckDone = function (check) {
      PlanningService.setChecklistDone(check.id).then(function (res) {
        $mdDialog.hide()
      }).catch(function () {
        toastr.error('Une erreur est survenue')
      })
    }

    $scope.openEditCheck = function (check) {
      $scope.check = angular.copy(check)
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/add_checklist_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDeleteCheck = function (check) {
      $scope.check = angular.copy(check)
      $mdDialog.show({
        templateUrl: 'app/main/front/equipe/planning-general/popup/confirm_delete_checklist.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.deleteCheck = function () {
      if ($scope.loading) {
        return
      }
      $scope.loading = true
      PlanningService.deleteChecklist($scope.check.id).then(function () {
        toastr.success('Tâche supprimée')
        $scope.loading = false
        $mdDialog.hide()
        $scope.listChecklist()
      }).catch(function () {
        toastr.error('Une erreur est survenue')
        $scope.loading = false
      })
    }

    $scope.filterTag = function (tag) {
      $scope.filterType.tag = tag
      $scope.listPlanning()
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('PlanningService', PlanningService);

  function PlanningService($q, $http) {

    var list = function (start, end, fromQuality, startFirst, endFirst, reunionIDsToExclude, planningIDsToExclude, done, late, today, collaborateurID, event, searchTxt, tag) {
      var data = {
        start: start,
        end: end,
        event: event,
        fromQuality: !!fromQuality,
        startFirst: startFirst,
        endFirst: endFirst,
        reunionIDsToExclude: reunionIDsToExclude,
        planningIDsToExclude: planningIDsToExclude,
        done: done,
        late: late,
        today: today,
        searchTxt: searchTxt,
        tag: tag
      };

      if (collaborateurID != null && collaborateurID != 'null') {
        data.collaborateurID = collaborateurID;
      }

      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planning/getList",
          method: "POST",
          data: data,
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var listForCalendar = function (start, end, fromQuality) {
      return $q(function (resolve, reject) {
        var endDate = new Date(end);
        endDate.setHours(23, 59, 59, 999);
        $http({
          url: "/api/rest/planning",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'start': start,
            'end': endDate.getTime(),
            'fromQuality': !!fromQuality
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var generateIcs = function (reset) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planning/ics-link",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            reset: !!reset
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var saveChecklist = function (start, end, dto) {
      return $q(function (resolve, reject) {
        const params = {
          '_v': new Date().getTime()
        }
        if (start) {
          params.start = start
          params.end = end
        }
        $http({
          url: "/api/rest/planning/checklist",
          method: "POST",
          params: params,
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var getChecklist = function (start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planning/checklist",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            start: start,
            end: end
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var setChecklistDone = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planning/checklist/" + id + "/done",
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var deleteChecklist = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/planning/checklist/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime(),
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }


    return {
      list: list,
      listForCalendar: listForCalendar,
      generateIcs: generateIcs,
      saveChecklist: saveChecklist,
      getChecklist: getChecklist,
      setChecklistDone: setChecklistDone,
      deleteChecklist: deleteChecklist
    }
  };
})();

(function() {
    'use strict';

    angular.module('app.front')
    .service('FichePosteService', FichePosteService);

    function FichePosteService($q, $http) {
        var URL_FICHEPOSTE = "/api/rest/ficheposte";

        var saveFichePoste = function(fd) {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_FICHEPOSTE,
                    method: "POST",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": undefined },
                    data: fd
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        }

        var getFichesPoste = function() {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_FICHEPOSTE,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        }

        var getFichesPosteByIdCollabId = function(id) {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_FICHEPOSTE+ "/user/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        }

        var downloadFichePoste = function(id) {
            return URL_FICHEPOSTE + "/download/" + id;
        }

        var deleteFiche = function(id) {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_FICHEPOSTE + "/" + id,
                    method: "PUT",
                    params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response);
                }).catch(function(response) {
                    reject(response);
                });
            });
        }
 
        return {
            saveFichePoste: saveFichePoste,
            getFichesPoste: getFichesPoste,
            deleteFiche: deleteFiche,
            downloadFichePoste: downloadFichePoste,
            getFichesPosteByIdCollabId: getFichesPosteByIdCollabId
        }
    };
})();
(function() {
    'use strict';

    angular.module('app.front')
    .service('EquipeDetailService', EquipeDetailService);

    function EquipeDetailService($q, $http) {
        var URL_COLABORATEUR = "/api/rest/collaborateur";

        var getCollaborateurs = function() {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_COLABORATEUR,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        };

        var getCollaborateursSimple = function() {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_COLABORATEUR + '/simple',
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        };

        var getCollaborateursWithoutPoste = function() {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_COLABORATEUR + "/withoutPoste",
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response.data);
                }).catch(function(response) {
                    reject(response);
                });
            });
        };

        var saveCollaborateur = function(fd) {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_COLABORATEUR,
                    method: "POST",
                    params: { '_v': new Date().getTime() },
					headers: { "Content-Type": undefined },
					data: fd
                }).then(function(response) {
                    resolve(response);
                }).catch(function(response) {
                    reject(response);
                });
            });
        };

        var deleteCollaborateur = function(id) {
            return $q(function(resolve, reject) {
                $http({
                    url: URL_COLABORATEUR + "/" + id,
                    method: "PUT",
                    params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function(response) {
                    resolve(response);
                }).catch(function(response) {
                    reject(response);
                });
            });
        };

        return {
            getCollaborateurs: getCollaborateurs,
            getCollaborateursWithoutPoste: getCollaborateursWithoutPoste,
            saveCollaborateur: saveCollaborateur,
            deleteCollaborateur: deleteCollaborateur,
            getCollaborateursSimple: getCollaborateursSimple
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('EquipeDetailController', EquipeDetailController);

  function EquipeDetailController($scope, $rootScope, $timeout, EquipeDetailService, toastr, FichePosteService, $mdDialog, PERMISSIONS, $window) {

    $scope.string = '';
    $scope.collaborateurs = [];
    $scope.collaborateur = {
      name: null,
      surname: null,
      id: null,
      fichePoste: {
        document: false,
        description: null,
        originalFileName: null
      }
    };
    $scope.updateMode = false;
    $scope.permissions = PERMISSIONS;
    $scope.titlePopupSave = '';
    $scope.intoSaving = false;

    $scope.getCollaborateurs = function () {
      EquipeDetailService.getCollaborateurs().then(function (data) {
        $scope.collaborateurs = data;
        // collaborateur taches
        if ($scope._users) {
          $scope._users = data;
        }
      }).catch(function (response) {
        console.log("Error getCollaborateurs()");
      });
    }
    $scope.getCollaborateurs();

    $scope.saveCollaborateur = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;
        var input = document.getElementById("document_input_file");
        var file = null;
        if (input != null && input.files[0] != undefined) {
          file = input.files[0];
          $scope.collaborateur.fichePoste.document = true;
        }
        else {
          $scope.collaborateur.fichePoste.document = false;
        }
        $scope.addCollaborateurMode = false;

        var fd = new FormData();
        fd.append('file', file);
        if (file != null && file.name != null) {
          $scope.collaborateur.originalFileName = file.name
        }
        fd.append('dto', angular.toJson($scope.collaborateur));


        EquipeDetailService.saveCollaborateur(fd).then(function (data) {
          $scope.hidePopup(data.data);
          $timeout(function () {
            $scope.intoSaving = false;
          });
          toastr.success('Le collaborateur a bien été ' + ($scope.collaborateur.id ? 'modifié' : 'créé'));
          $scope.collaborateur.id = data.data;
          $scope.getCollaborateurs();
          // if ($scope.updateMode) {
          //   for (var i = 0; i < $scope.collaborateurs.length; i++) {
          //     if ($scope.collaborateurs[i].id == $scope.collaborateur.id) {
          //       $scope.collaborateurs[i] = angular.copy($scope.collaborateur);
          //     }
          //   }
          //   $scope.updateMode = false;
          // } else {
          //   $scope.collaborateurs.push(angular.copy($scope.collaborateur));
          // };
          // $scope.updateMode = false;
        }).catch(function (response) {
          $scope.intoSaving = false;
          toastr.error('Erreur lors de la ' + ($scope.collaborateur.id ? 'modification' : 'création') + ' du collaborateur');
          console.log("Error saveCollaborateur()");
        });
      };

    }


    $scope.saveCollaborateurMin = function () {
      var btn = document.getElementById("btnSaveCollabMin");
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        var file = null;

        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.collaborateur));


        EquipeDetailService.saveCollaborateur(fd).then(function (data) {
          $scope.hidePopup(data.data);
          $scope.collaborateur.id = data.data;

          if ($scope.updateMode) {
            for (var i = 0; i < $scope.collaborateurs.length; i++) {
              if ($scope.collaborateurs[i].id == $scope.collaborateur.id) {
                $scope.collaborateurs[i] = angular.copy($scope.collaborateur);
              }
            }
            $scope.updateMode = false;
          } else {
            $scope.collaborateurs.push(angular.copy($scope.collaborateur));
            if ($scope._filteredUserTags) {
              var collabToAdd = angular.copy($scope.collaborateur);
              collabToAdd.value = collabToAdd.name + ' ' + collabToAdd.surname;
              $scope._filteredUserTags.push(collabToAdd);
            }
          };
          $scope.updateMode = false;
          $scope.intoSaving = false;
        }).catch(function (response) {
          $scope.intoSaving = false;
          console.log("Error saveCollaborateur()");
        });
      }

    };

    $scope._closeDialog = function (id) {
      EquipeDetailService._closeDialog(id).then(function () {
        for (var i = 0; i < $scope.collaborateurs.length; i++) {
          if ($scope.collaborateurs[i].id == id) {
            $scope.collaborateurs.splice(i, 1);
          }
        }
      }).catch(function (response) {
        console.log("Error deleteCollaborateur()");
      });
    }
    $scope._closeDialog = function () {
      $mdDialog.hide();
    }

    $scope._hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.dialogDelete = function (collaborateur, index) {
      $scope.collaborateurToDelete = collaborateur;
      $scope.indexToDelete = index;

      $scope.equipePopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/equipe/popup/delete_collaborateur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.delete = function () {
      if ($scope.collaborateurToDelete && $scope.collaborateurToDelete.id) {
        EquipeDetailService.deleteCollaborateur($scope.collaborateurToDelete.id).then(function () {
          if ($scope.indexToDelete !== null) {
            $scope.collaborateurs.splice($scope.indexToDelete, 1);
            $scope.hidePopup();
          }
          toastr.success('Le collaborateur a bien été supprimé');
        }).catch(function (err) {
          //toast error network delete collaborateur
          toastr.error('Erreur lors de la suppression du collaborateur');
        })
      }
    }

    $scope.dialogSave = function (updateMode, collaborateur) {
      if (updateMode) {
        $scope.updateMode = true;
        $scope.collaborateur = angular.copy(collaborateur);
        $scope.titlePopupSave = 'Modifier un collaborateur';

        if ($scope.collaborateur.fichePoste != null) {
          if ($scope.collaborateur.fichePoste.description != null) {
            $scope.descriptionMode = true;
          } else {
            $scope.descriptionMode = false;
          }
        }
      } else {
        $scope.collaborateur = {
          name: null,
          surname: null,
          id: null,
          fichePoste: {}
        };
        $scope.titlePopupSave = 'Ajouter un collaborateur';
        $scope.updateMode = false;
        $scope.descriptionMode = true;
      }

      $scope.equipePopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.hidePopup = function (data) {
      $mdDialog.hide(data);
    }

    $scope.openFichePostefunction = function (idCollaborateur) {


      FichePosteService.getFichesPosteByIdCollabId(idCollaborateur).then(function (data) {
        $scope.fichePoste = data;
        $scope.fichePostePopup = $mdDialog.show({
          templateUrl: 'app/main/front/equipe/equipe/popup/detail_ficheposte_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () { }).catch(function () { });
      });


    };

    $scope.downloadDocument = function (documentDTO) {
      if (documentDTO != null) {
        if (documentDTO.id != null) {
          $window.location.href = FichePosteService.downloadFichePoste(documentDTO.id);
        }
      }
    }

    $scope.saveFichePoste = function () {
      var input = document.getElementById("ficheposte_input_file");
      var file = null;
      if (input != null) {
        file = input.files[0];
        $scope.fichePoste.document = true;
        $scope.fichePoste.description = null;
      }
      $scope.addCollaborateurMode = false;

      var fd = new FormData();
      fd.append('file', file);
      fd.append('dto', angular.toJson($scope.fichePoste));
      FichePosteService.saveFichePoste(fd).then(function (data) {
        $scope.hidePopup();
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error('Dossier parent introuvable, veuillez actualiser la page');
        }
        console.log("Error saveFichePoste()");
        console.log(response);
      });
    }

    $scope.$on('fileUploaded', function (event, data) {
      var fileinput = document.getElementById('document_input_file');
      $scope.collaborateur.nameOfDocument = "";
      for (var i = 0; i < fileinput.files.length; i++) {
        var name = fileinput.files[i].name
        $scope.collaborateur.nameOfDocument += name ? name : "Nom du fichier indisponible";
      }
    });

    $scope.clearInputFile = function (collaborateur, id_input) {
      var elem = document.getElementById(id_input);
      elem.value = ''
      collaborateur.originalFileName = null
      collaborateur.nameOfDocument = ''
    };

  };
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('TracesController', TracesController);

  function TracesController($scope, toastr, $location, $state, EquipeDetailService, $mdDialog, TraceService, PERMISSIONS, $timeout) {

    $scope.dateValue = 'Date'
    $scope.permissions = PERMISSIONS;
    $scope.filter = {
      type: '',
      collaborateur: '',
      typeValue: '',
      collabValue: ''
    }
    $scope.traces = [];
    $scope.modeles = [];
    $scope.tracesArchived = [];
    $scope.collaborateurs = [];
    $scope.archive = {
      value: "none"
    };
    $scope.years = [];
    $scope.initPage = true;
    $scope.disabledIndex = false
    $scope.loadingDelete = false
    $scope.tabs = {
      active: false,
      modeles: false,
      archive: false
    }

    $scope.switchTab = function (tab) {
      var tabs = Object.keys($scope.tabs)
      for (var i = 0; i < tabs.length; i++) {
        $scope.tabs[tabs[i]] = false;
      }
      $scope.tabs[tab] = true;
    }

    if ($state.params.tab) {
      $scope.switchTab($state.params.tab)
      $location.search('tab', null)
    } else {
      $scope.switchTab('active')
    }

    $scope.init = function () {
      $scope.getYears();
      $scope.findAllTracesNotArchived();
      $scope.findAllTracesArchived();
      $scope.findAllTemplates();

    }

    $scope.findAllTemplates = function () {
      TraceService.findAllTemplates().then(function (res) {
        $scope.modeles = res
      }).catch(function (err) {

      })
    }

    $scope.getYears = function () {
      TraceService.years().then(function (res) {
        $scope.years = res;
        $scope.archive.value = "none";

      }).catch(function (err) {

      })
    }
    $scope.getCollaborateurs = function () {
      EquipeDetailService.getCollaborateursSimple().then(function (data) {
        $scope.collaborateurs = data;
      }).catch(function (response) {
        console.log("Error getCollaborateurs()");
      });
    }
    $scope.getCollaborateurs();
    $scope.findAllTracesNotArchived = function () {
      TraceService.getTraces($scope.filter, false, null).then(function (res) {
        $scope.traces = res;
        if ($scope.initPage) {
          $scope.copyTraces = res;
          $scope.initPage = !$scope.initPage;
        }
      }).catch(function (err) {

      })
    }

    $scope.openTrace = function (trace) {
      $state.go('app.controle.trace.subtraces', { id: trace.id });
    }
    $scope.setFilter = function (type, value, name) {
      switch (type) {
        case 'type':
          $scope.filter.type = value;
          $scope.filter.typeValue = name;
          break;
        case 'collaborateur':
          $scope.filter.collaborateur = value;
          $scope.filter.collabValue = name;
          break;
        default:
          break;
      }
      $scope.init();
    }
    $scope.findAllTracesArchived = function () {
      TraceService.getTraces($scope.filter, true, $scope.archive.value).then(function (res) {
        $scope.tracesArchived = res;
      }).catch(function (err) {

      })
    }
    $scope.openNewTrace = function () {
      $scope.traceToAdd = {
        name: null,
        parameters: []
      }
      $scope.traceToAdd.parameters[0] = {
        name: null,
        index: 0,
        type: 'TEXT'
      }
      $state.go('app.controle.trace.add')
    }

    $scope.saveNewTrace = function () {
      if ($scope.traceToAdd == null || $scope.loading) {
        return;
      }
      $scope.loading = true
      TraceService.save($scope.traceToAdd).then(function (res) {
        $mdDialog.hide();
        $scope.traceToAdd = null;
        $scope.loading = false
        $scope.init();
      }).catch(function (err) {
        $scope.loading = false
      })

    }

    $scope.addParameter = function (type) {
      $scope.traceToAdd.parameters.push({ name: null, index: $scope.traceToAdd.parameters.length, type: type })
    }
    $scope.init();
    $scope.closeModal = function () {
      $mdDialog.hide();
    }

    $scope.archive = function (trace) {
      TraceService.archive(trace.id).then(function () {
        $scope.init();
        toastr.success("Traçabilité archivée avec succès")
      }).catch(function () {
        toastr.error("Erreur durant l'archivage")
      })
    }
    $scope.desarchive = function (trace) {
      TraceService.desarchive(trace.id).then(function () {
        $scope.init();
        toastr.success("Traçabilité desarchivée avec succès")
      }).catch(function () {
        toastr.error("Erreur durant le desarchivage")
      })
    }

    $scope.searchArchives = function () {
      $scope.showArchives = true;
      $scope.findAllTracesArchived();
    }

    $scope.openInfosTracePopup = function () {
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/controle/trace/popup/infos_trace_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.upIndex = function (id) {
      TraceService.upIndex(id).then(function (data) {
        $scope.traces = data
        toastr.success('Index changé')
        $scope.disabledIndex = false
      }).catch(function () {
        $scope.disabledIndex = false
      })
    }

    $scope.downIndex = function (id) {
      if ($scope.disabledIndex) {
        return
      }
      $scope.disabledIndex = true
      TraceService.downIndex(id).then(function (data) {
        $scope.traces = data
        toastr.success('Index changé')
        $scope.disabledIndex = false
      }).catch(function () {
        $scope.disabledIndex = false
      })
    }

    $scope.deleteRow = function (index) {
      $scope.traceToAdd.parameters.splice(index, 1)
    }

    $scope.openModele = function (modele) {
      $state.go('app.controle.trace.templates', { id: modele.id });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('TraceService', TraceService);

  function TraceService($q, $http) {
    var URL_TRACE = "/api/rest/trace";
    var URL_DOCGEN = "/api/rest/docgeneration";

    var save = function (trace) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/saveTrace",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: trace
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });

      });
    };
    var saveSubtrace = function (fmData, traceId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/saveSubtrace/" + traceId,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: { "Content-Type": undefined },
          transformRequest: angular.identity,
          data: fmData
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var saveEditSubtrace = function (fmData) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/saveEditSubtrace",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fmData
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var getTraces = function (filterDto, isArchived, yearValue) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/getAll",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'archived': isArchived,
            'year': yearValue
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: filterDto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };
    var archive = function (id) {

      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/archive/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };
    var desarchive = function (id) {

      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/desarchive/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteSubTrace = function (trace, subtrace) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/deleteSubtrace/" + trace.id + "/" + subtrace.id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }


    var years = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/years",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var exportTrace = function (trace, exportT) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_DOCGEN + "/trace/" + trace.id,
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'dateStart': exportT.startDate.getTime(),
            'dateEnd': exportT.endDate.getTime()
          },
          headers: {
            "Content-Type": undefined
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getSubtracesByTrace = function (trace, pagination, date, searchTxt) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/getSubtracesByDate/" + trace.id,
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'dateStart': date.startDate,
            'dateEnd': date.endDate,
            'searchTxt': searchTxt
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: pagination
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var edit = function (trace) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + "/edit",
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: trace
        }).then(function (response) {

          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var getSubtraceHistory = function (subtraceId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/subtrace/' + subtraceId + '/history',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getHomeSubtrace = function (subtraceId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/subtrace/' + subtraceId + '/home',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var downloadDocx = function (id, name) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/subtrace/' + id + '/export',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
          },
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', name + '.docx');
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject();
        });
      });
    };

    var upIndex = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/' + id + '/up',
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var downIndex = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/' + id + '/down',
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var findAllTemplates = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/templates',
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var findTemplateById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_TRACE + '/templates/' + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }


    return {
      save: save,
      getTraces: getTraces,
      findById: findById,
      saveSubtrace: saveSubtrace,
      deleteSubTrace: deleteSubTrace,
      archive: archive,
      desarchive: desarchive,
      years: years,
      exportTrace: exportTrace,
      saveEditSubtrace: saveEditSubtrace,
      getSubtracesByTrace: getSubtracesByTrace,
      edit: edit,
      getSubtraceHistory: getSubtraceHistory,
      getHomeSubtrace: getHomeSubtrace,
      downloadDocx: downloadDocx,
      upIndex: upIndex,
      downIndex: downIndex,
      findAllTemplates: findAllTemplates,
      findTemplateById: findTemplateById
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('TraceController', TraceController);

    function TraceController($scope, toastr, $location, $state, EquipeDetailService, $mdDialog, TraceService, PERMISSIONS, $timeout) {

        $scope.orderParameters = function (trace) {
            var params = angular.copy(trace.parameters);

            params.sort(function (a, b) {
                if (a.index < b.index) {
                    return -1
                } else if (b.index < a.index) {
                    return 1;
                } else {
                    return 0;
                }
            })
            trace.parameters = params;
        }

        $scope.traceToAdd = {
            name: null,
            parameters: []
        }

        // Aperçu des colonnes « Liste des collaborateurs » : les collaborateurs de l'onglet Équipe
        $scope.collaborateurs = []
        EquipeDetailService.getCollaborateursSimple().then(function (data) {
            $scope.collaborateurs = data
        }).catch(function () {
        })

        if ($state.params.id) {
            TraceService.findById($state.params.id).then(function (res) {
                $scope.traceToAdd = res;
                for (var i = 0; i < $scope.traceToAdd.parameters.length; i++) {
                    var param = $scope.traceToAdd.parameters[i]
                    if (param.type === 'LIST') {
                        // oldName : intitulé d'origine, pour reporter un renommage sur les enregistrements
                        param.options = param.options.map(o => { return { name: o, oldName: o } })
                    }
                }
                $scope.orderParameters($scope.traceToAdd);
            }).catch(function (err) {

            })
        } else if ($state.params.templateId) {
            TraceService.findTemplateById($state.params.templateId).then(function (res) {
                $scope.traceToAdd = res;
                $scope.traceToAdd.templateType = $scope.traceToAdd.type
                $scope.traceToAdd.name = $scope.traceToAdd.name.replace('MODÈLE : ', '')
                delete $scope.traceToAdd.id
                for (var i = 0; i < $scope.traceToAdd.parameters.length; i++) {
                    var param = $scope.traceToAdd.parameters[i]
                    if (param.type === 'LIST') {
                        param.options = (param.options || []).map(o => { return { name: o } })
                    }
                }
                $scope.orderParameters($scope.traceToAdd);
            }).catch(function (err) {

            })
        }

        $scope.goBack = function () {
            if ($state.params.id) {
                $state.go('app.controle.trace.subtraces', { id: $state.params.id })
            } else if ($state.params.templateId) {
                $state.go('app.controle.trace.templates', { id: $state.params.templateId })
            } else {
                $state.go('app.controle.trace')
            }
        }

        $scope.openAddColumn = function () {
            $scope.columnToAdd = {
                type: null,
                options: []
            }
            $scope.updateIndex = null
            $scope.step = 0
            $mdDialog.show({
                templateUrl: 'app/main/front/controle/trace/popup/add_column.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            }).then(function () {
            }).catch(function () {
            });
        }

        $scope.closeModal = function () {
            $mdDialog.hide();
        }

        $scope.setColumnToAdd = function (type) {
            $scope.columnToAdd.type = type
            // Seule la liste déroulante a des options (la liste des collaborateurs vient de l'onglet Équipe)
            $scope.columnToAdd.options = type === 'LIST' ? [{}, {}] : []
        }

        $scope.nextStep = function () {
            $scope.step = 1
        }

        $scope.addOption = function () {
            $scope.columnToAdd.options.push({})
        }

        $scope.deleteOption = function (index, form) {
            $scope.columnToAdd.options.splice(index, 1)
            // Après le rendu : les champs suivants ont été renommés optionName_{index - 1}
            $timeout(function () {
                $scope.checkDuplicateOptions(form)
            })
        }

        function optionKey(option) {
            return (option.name || '').trim().toLowerCase()
        }

        // Deux options identiques (aux espaces et à la casse près) sont signalées toutes les deux,
        // y compris celle qu'on n'a pas touchée (sinon son message reste masqué)
        $scope.checkDuplicateOptions = function (form) {
            var counts = {}
            $scope.columnToAdd.options.forEach(function (option) {
                var key = optionKey(option)
                counts[key] = (counts[key] || 0) + 1
            })
            $scope.columnToAdd.options.forEach(function (option, index) {
                var key = optionKey(option)
                var field = form['optionName_' + index]
                if (field) {
                    var duplicate = !!key && counts[key] > 1
                    field.$setValidity('duplicate', !duplicate)
                    if (duplicate) {
                        field.$setTouched()
                    }
                }
            })
        }

        $scope.saveColumn = function () {
            if ($scope.updateIndex != null) {
                $scope.traceToAdd.parameters[$scope.updateIndex] = angular.copy($scope.columnToAdd)
            } else {
                $scope.traceToAdd.parameters.push($scope.columnToAdd)
            }
            $mdDialog.hide()
        }

        $scope.deleteRow = function (index) {
            if ($scope.traceToAdd.id) {
                $scope.columnIndexToDelete = index
                $mdDialog.show({
                    templateUrl: 'app/main/front/controle/trace/popup/confirm_delete_column.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true
                }).then(function () {
                }).catch(function () {
                });
            } else {
                $scope.traceToAdd.parameters.splice(index, 1)
            }
        }

        $scope.forceDeleteRow = function () {
            $scope.traceToAdd.parameters.splice($scope.columnIndexToDelete, 1)
            $mdDialog.hide()
        }

        $scope.saveNewTrace = function () {
            if ($scope.traceToAdd == null || $scope.loading) {
                return;
            }
            $scope.loading = true
            var trace = angular.copy($scope.traceToAdd)
            for (var param of trace.parameters) {
                if (param.options) {
                    param.oldOptions = param.options.map(o => o.oldName || null)
                    param.options = param.options.map(o => o.name)
                }
            }
            for (var i = 0; i < trace.parameters.length; i++) {
                trace.parameters[i].index = i
            }
            if ($state.params.id) {
                TraceService.edit(trace).then(function (res) {
                    $scope.loading = false
                    $state.go('app.controle.trace.subtraces', { id: $state.params.id })
                }).catch(function (err) {
                    $scope.loading = false
                    toastr.error("Erreur pendant l'enregistrement")
                })
            } else {
                TraceService.save(trace).then(function (res) {
                    $scope.loading = false
                    $state.go('app.controle.trace')
                }).catch(function (err) {
                    $scope.loading = false
                    toastr.error("Erreur pendant l'enregistrement")
                })
            }

        }

        $scope.upIndex = function (index) {
            var down = angular.copy($scope.traceToAdd.parameters[index - 1])
            var up = angular.copy($scope.traceToAdd.parameters[index])
            $scope.traceToAdd.parameters[index - 1] = up
            $scope.traceToAdd.parameters[index] = down
        }

        $scope.downIndex = function (index) {
            var up = angular.copy($scope.traceToAdd.parameters[index + 1])
            var down = angular.copy($scope.traceToAdd.parameters[index])
            $scope.traceToAdd.parameters[index + 1] = down
            $scope.traceToAdd.parameters[index] = up
        }

        $scope.updateParam = function (index) {
            $scope.columnToAdd = angular.copy($scope.traceToAdd.parameters[index])
            $scope.updateIndex = index
            $scope.step = 1
            $mdDialog.show({
                templateUrl: 'app/main/front/controle/trace/popup/add_column.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            }).then(function () {
            }).catch(function () {
            });
        }

    }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalValidationController', AutoEvalValidationController);

	/**
	 * L'écran de validation (spécification §4.4).
	 *
	 * ⚠️ Le bouton n'est actif que pour le TITULAIRE. Le responsable qualité voit le même bouton,
	 * désactivé, avec la raison : « Seul le titulaire peut valider ». Le masquer laisserait croire
	 * à un défaut d'affichage ; le montrer inerte dit qui doit agir.
	 *
	 * ⚠️ Le serveur refait TOUS les contrôles. Cet écran ne fait que les annoncer : un 409
	 * `INCOMPLET` renvoie au chapitre fautif, un 403 `SEUL_TITULAIRE` s'affiche tel quel.
	 */
	/** @ngInject */
	function AutoEvalValidationController($scope, $rootScope, $state, $stateParams, AutoEvalService) {
		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.chargement = true;
		$scope.enCours = false;
		$scope.erreur = null;
		$scope.contexte = null;
		$scope.parcours = null;
		$scope.chapitresIncomplets = [];

		AutoEvalService.getContexte().then(function (contexte) {
			$scope.contexte = contexte;
			return AutoEvalService.getSoumissionCourante();
		}).then(function (parcours) {
			$scope.parcours = parcours;
			$scope.chargement = false;
		}).catch(function (erreur) {
			$scope.chargement = false;
			$scope.erreur = erreur;
		});

		$scope.motif = function () {
			var droits = $scope.contexte ? $scope.contexte.droits : null;
			return droits ? droits.motifValidation : null;
		};

		$scope.texteMotif = function () {
			switch ($scope.motif()) {
			case 'SEUL_TITULAIRE':
				return 'Responsable qualité connecté — remplit mais ne valide pas. Seul le titulaire peut valider.';
			case 'AUCUN_TITULAIRE':
				return 'Aucun compte titulaire actif n’est rattaché à votre officine : la validation restera impossible tant que ce compte n’aura pas été créé ou réactivé.';
			case 'CAMPAGNE_FERMEE':
				return 'La campagne n’accepte plus de réponses.';
			default:
				return null;
			}
		};

		$scope.peutValider = function () {
			return !!($scope.contexte && $scope.contexte.droits && $scope.contexte.droits.peutValider);
		};

		$scope.complete = function () {
			return !!($scope.parcours && $scope.parcours.progression
				&& $scope.parcours.progression.enAttente === 0);
		};

		$scope.valider = function () {
			if (!$scope.peutValider() || $scope.enCours) {
				return;
			}
			$scope.enCours = true;
			$scope.erreur = null;
			$scope.chapitresIncomplets = [];
			AutoEvalService.valider($scope.parcours.soumissionId).then(function () {
				$scope.enCours = false;
				// Validée : plus rien à faire, le bandeau du haut doit disparaître.
				$rootScope.$broadcast('refreshAutoEvalContext');
				$state.go('app.autoeval.recap', { annee: $scope.annee });
			}).catch(function (erreur) {
				$scope.enCours = false;
				$scope.erreur = erreur;
				// Le message d'un 409 INCOMPLET porte le tableau des chapitres en attente : il
				// permet d'emmener l'officine directement là où il manque une réponse.
				if (erreur.code === 'INCOMPLET' && erreur.message) {
					try {
						$scope.chapitresIncomplets = angular.fromJson(erreur.message);
					} catch (ignore) {
						$scope.chapitresIncomplets = [];
					}
				}
			});
		};

		$scope.allerAuChapitre = function (ligne) {
			$state.go('app.autoeval.questionnaire', {
				annee: $scope.annee,
				chapitreId: ligne.chapitreId
			});
		};

		/**
		 * ⚠️ LE CHAPITRE EST DÉSIGNÉ EXPLICITEMENT, et c'est indispensable : ouvrir le
		 * questionnaire sans chapitre alors que tout est répondu y déclenche la redirection vers
		 * CET écran. Sans identifiant, « Retour au questionnaire » rebondirait donc aussitôt sur
		 * la validation, et le bouton paraîtrait mort.
		 */
		$scope.retourQuestionnaire = function () {
			var chapitres = $scope.parcours ? $scope.parcours.chapitres : null;
			$state.go('app.autoeval.questionnaire', {
				annee: $scope.annee,
				chapitreId: chapitres && chapitres.length ? chapitres[0].id : null
			});
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalResultatsController', AutoEvalResultatsController);

	/**
	 * Les résultats personnels d'un millésime (spécification §4.5).
	 *
	 * ⚠️ Le rapport est GÉNÉRÉ EN DIFFÉRÉ. Tant qu'il est en préparation, l'écran relit l'état
	 * toutes les dix secondes, pendant deux minutes au plus — au-delà, une officine qui laisse la
	 * page ouverte interrogerait le serveur indéfiniment pour une tâche qui, si elle n'a pas
	 * abouti, ne le fera pas dans la minute.
	 */
	/** @ngInject */
	function AutoEvalResultatsController($scope, $state, $stateParams, $interval, AutoEvalService) {
		var PERIODE_RELECTURE = 10000;
		var DUREE_MAXIMALE = 120000;

		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.chargement = true;
		$scope.erreur = null;
		$scope.resultats = null;
		$scope.telechargement = false;

		var relecture = null;
		var debut = null;

		function charger() {
			return AutoEvalService.getResultats($scope.annee).then(function (resultats) {
				$scope.resultats = resultats;
				// ⚠️ Filtré UNE FOIS ici, et non par un `ng-if` posé sur le `ng-repeat` : deux
				// directives structurelles sur un même élément se compilent dans un ordre qui
				// dépend de leurs priorités, et cela se lit mal. Un chapitre non concerné n'a de
				// toute façon pas de barre — il a sa ligne d'explication dans le tableau.
				$scope.chapitresConcernes = [];
				angular.forEach(resultats.chapitres, function (ligne) {
					if (ligne.concerne) {
						$scope.chapitresConcernes.push(ligne);
					}
				});
				$scope.chargement = false;
				surveillerRapport();
			}).catch(function (erreur) {
				$scope.chargement = false;
				$scope.erreur = erreur;
			});
		}

		function surveillerRapport() {
			var etat = $scope.resultats.rapport ? $scope.resultats.rapport.etat : null;
			if (etat !== 'EN_COURS') {
				arreter();
				return;
			}
			if (relecture) {
				return;
			}
			debut = Date.now();
			relecture = $interval(function () {
				if (Date.now() - debut > DUREE_MAXIMALE) {
					arreter();
					return;
				}
				AutoEvalService.getResultats($scope.annee).then(function (resultats) {
					$scope.resultats = resultats;
					surveillerRapport();
				});
			}, PERIODE_RELECTURE);
		}

		function arreter() {
			if (relecture) {
				$interval.cancel(relecture);
				relecture = null;
			}
		}

		$scope.$on('$destroy', arreter);

		$scope.telecharger = function () {
			$scope.telechargement = true;
			AutoEvalService.telechargerRapport($scope.annee).finally(function () {
				$scope.telechargement = false;
			});
		};

		$scope.voirComparaison = function () {
			$state.go('app.autoeval.comparaison', { annee: $scope.annee });
		};

		$scope.score = function () {
			var valeur = $scope.resultats ? $scope.resultats.scoreGlobal : null;
			if (valeur === null || angular.isUndefined(valeur)) {
				return null;
			}
			return Math.round(valeur);
		};

		$scope.urlRessource = AutoEvalService.urlRessource;

		// ------------------------------------------------------------------ satisfaction

		$scope.aUneValeur = function (valeur) {
			return valeur !== null && angular.isDefined(valeur);
		};

		/**
		 * Les parts qui ont une valeur, pour la barre nationale : un segment absent n'est pas un
		 * segment de largeur nulle, et la barre doit boucler à 100 % sans liseré.
		 */
		$scope.partsAvecValeur = function (parts) {
			var retenues = [];
			angular.forEach(parts || [], function (part) {
				if ($scope.aUneValeur(part.pct) && part.pct > 0) {
					retenues.push(part);
				}
			});
			return retenues;
		};

		/** Le « Très insatisfait » est rouge vif : son texte passe en blanc. */
		$scope.reponseFoncee = function (valeur) {
			return valeur === 'TRES_INSATISFAIT';
		};

		charger();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalRecapController', AutoEvalRecapController);

	/**
	 * Le récapitulatif qui suit la validation (spécification §4.4).
	 *
	 * Il rejoue `validate`, qui est IDEMPOTENTE : une soumission déjà validée rend son
	 * récapitulatif sans rien réécrire. C'est ce qui rend l'écran atteignable par un simple lien,
	 * un rafraîchissement ou un retour arrière du navigateur, sans risquer un second e-mail.
	 */
	/** @ngInject */
	function AutoEvalRecapController($scope, $state, $stateParams, AutoEvalService) {
		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.chargement = true;
		$scope.erreur = null;
		$scope.recap = null;

		AutoEvalService.getSoumissionCourante().then(function (parcours) {
			return AutoEvalService.valider(parcours.soumissionId);
		}).then(function (recap) {
			$scope.recap = recap;
			$scope.chargement = false;
		}).catch(function (erreur) {
			$scope.chargement = false;
			$scope.erreur = erreur;
		});

		$scope.urlRessource = AutoEvalService.urlRessource;

		$scope.voirResultats = function () {
			$state.go('app.autoeval.resultats', { annee: $scope.annee });
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalQuestionnaireController', AutoEvalQuestionnaireController);

	/**
	 * LE PARCOURS DE REMPLISSAGE (spécification §4.2 et §4.3).
	 *
	 * Trois partis pris structurent cet écran.
	 *
	 * ⚠️ **L'enregistrement est au fil de l'eau, et sérialisé.** Une seule requête à la fois par
	 * soumission : les réponses partent dans une file, chaînée sur la précédente. Sans cela, deux
	 * clics rapides sur deux questions d'un même chapitre produiraient deux requêtes concurrentes
	 * dont la seconde pourrait revenir avant la première, et l'écran afficherait alors une
	 * progression périmée.
	 *
	 * ⚠️ **On n'envoie QUE ce qui change.** Le contrat distingue le champ absent du `null`
	 * explicite : envoyer l'objet réponse entier effacerait le commentaire à chaque changement de
	 * valeur. Chaque appel porte `questionId` et la seule clé modifiée.
	 *
	 * ⚠️ **La complétude est guidée, pas bloquante** (arbitrage 11). « Suivant » reste cliquable ;
	 * s'il manque des réponses, l'écran ouvre un bandeau et saute à la première question en
	 * attente, qu'il signale d'un liseré. Le serveur, lui, refusera la validation finale.
	 */
	/** @ngInject */
	function AutoEvalQuestionnaireController($scope, $rootScope, $state, $stateParams, $timeout, $q,
			$document, AutoEvalService) {

		/** Délai avant envoi d'un texte en cours de frappe. */
		var DEBOUNCE_TEXTE = 700;

		/** Durée d'affichage de « Enregistré à l'instant ». */
		var DUREE_CONFIRMATION = 4000;

		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.chargement = true;
		$scope.erreur = null;
		$scope.parcours = null;
		$scope.chapitre = null;
		$scope.menuOuvert = false;
		$scope.alerteCompletude = null;
		$scope.messageRouvertes = false;
		$scope.etatEnregistrement = null;
		$scope.questionSignalee = null;

		/** File d'envoi : une requête à la fois, chaînée sur la précédente. */
		var file = $q.when();
		var minuteurs = {};
		var minuteurConfirmation = null;

		// ------------------------------------------------------------------ Chargement

		/**
		 * Charge un chapitre.
		 *
		 * ⚠️ `silencieux` NE TOUCHE PAS À `chargement`, et ce n'est pas un détail d'affichage :
		 * tout l'écran est sous un `ng-if="!chargement"`. Le passer à vrai DÉTRUIT le DOM, que
		 * le navigateur reconstruit en haut de page. Répondre à une question d'orientation
		 * recharge le chapitre — c'est nécessaire, la liste des questions visibles change — et
		 * renvoyait donc l'officine tout en haut. Sur la question 110, sixième de son chapitre,
		 * on perdait sa place à chaque clic. En rechargeant sans le drapeau, Angular remanie la
		 * liste sur place et le défilement ne bouge pas.
		 */
		function charger(chapitreId, silencieux) {
			if (!silencieux) {
				$scope.chargement = true;
			}
			$scope.erreur = null;
			return AutoEvalService.getChapitre($scope.soumissionId, chapitreId)
				.then(function (parcours) {
					appliquerParcours(parcours);
					$scope.chargement = false;
				}).catch(function (erreur) {
					$scope.chargement = false;
					$scope.erreur = erreur;
				});
		}

		function appliquerParcours(parcours) {
			$scope.parcours = parcours;
			$scope.soumissionId = parcours.soumissionId;
			$scope.chapitre = parcours.chapitre || null;
			calculerModeOrientation();
		}

		/**
		 * La question d'orientation est-elle présentée SEULE, en pleine largeur ?
		 *
		 * Oui tant qu'elle n'a pas de réponse — c'est la question qui commande tout le chapitre —
		 * et oui encore lorsque la réponse a masqué le chapitre : il ne reste alors rien d'autre à
		 * montrer, et l'officine doit pouvoir revenir sur son choix.
		 */
		function calculerModeOrientation() {
			var chapitre = $scope.chapitre;
			$scope.modeOrientation = !!(chapitre && chapitre.questionFiltre
				&& (!aUneReponse(chapitre.questionFiltre) || !chapitre.questions.length));
		}

		function aUneReponse(question) {
			if (!question || !question.reponse) {
				return false;
			}
			if (question.type === 'CHOIX') {
				return !!(question.reponse.optionIds && question.reponse.optionIds.length);
			}
			if (question.type === 'TEXTE_LIBRE') {
				return !!question.reponse.texteLibre;
			}
			return !!question.reponse.valeur;
		}

		$scope.aUneReponse = aUneReponse;

		// ------------------------------------------------------------------ Navigation

		/**
		 * « 2 · Ressources humaines », ou le seul titre quand le chapitre n'a pas de code.
		 *
		 * ⚠️ Le Profil et le Baromètre n'ont PAS de code. Concaténer sans tester rendait
		 * « · Pour mieux vous connaître », avec un séparateur orphelin en tête.
		 */
		$scope.libelleEtape = function (etape) {
			if (!etape) {
				return '';
			}
			return etape.code ? etape.code + ' · ' + etape.titre : etape.titre;
		};

		$scope.allerAuChapitre = function (chapitre) {
			if (!chapitre.cliquable) {
				return;
			}
			$scope.menuOuvert = false;
			$state.go('app.autoeval.questionnaire', {
				annee: $scope.annee,
				chapitreId: chapitre.id
			});
		};

		$scope.precedent = function () {
			if ($scope.chapitre && $scope.chapitre.precedentChapitreId) {
				$state.go('app.autoeval.questionnaire', {
					annee: $scope.annee,
					chapitreId: $scope.chapitre.precedentChapitreId
				});
			}
		};

		/**
		 * « Suivant » : toujours cliquable. S'il manque des réponses, l'écran alerte et saute à la
		 * première en attente au lieu d'avancer.
		 */
		$scope.suivant = function () {
			var chapitre = $scope.chapitre;
			if (!chapitre) {
				return;
			}
			if (chapitre.nbEnAttente > 0) {
				$scope.alerteCompletude = {
					titre: chapitre.titre,
					nombre: chapitre.nbEnAttente
				};
				$scope.allerALaPremiereEnAttente();
				return;
			}
			if (chapitre.suivantChapitreId) {
				$state.go('app.autoeval.questionnaire', {
					annee: $scope.annee,
					chapitreId: chapitre.suivantChapitreId
				});
			} else {
				// Dernier chapitre : la suite du parcours est la validation.
				$state.go('app.autoeval.validation', { annee: $scope.annee });
			}
		};

		$scope.fermerAlerte = function () {
			$scope.alerteCompletude = null;
		};

		/** Défile jusqu'à la première question sans réponse et la signale d'un liseré. */
		$scope.allerALaPremiereEnAttente = function () {
			var cible = null;
			angular.forEach($scope.chapitre.questions, function (question) {
				if (!cible && question.enAttente) {
					cible = question;
				}
			});
			if (!cible) {
				return;
			}
			$scope.questionSignalee = cible.id;
			$timeout(function () {
				var element = $document[0].getElementById('aeq-q-' + cible.id);
				if (element && element.scrollIntoView) {
					element.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			});
		};

		/** Retour à la question qui a fermé un chapitre, depuis l'encart du chapitre sauté. */
		$scope.revenirAuDeclencheur = function (chapitreSaute) {
			$state.go('app.autoeval.questionnaire', {
				annee: $scope.annee,
				chapitreId: chapitreSaute.id
			});
		};

		// ------------------------------------------------------------------ Saisie

		/** Une modalité cochée : l'envoi est immédiat, le clic vaut décision. */
		$scope.choisirValeur = function (question, valeur) {
			if (!$scope.parcours.modifiable) {
				return;
			}
			question.reponse = question.reponse || {};
			question.reponse.valeur = valeur;
			question.enAttente = false;
			$scope.questionSignalee = null;
			enregistrer(question, { valeur: valeur });
		};

		/** Une option de question à choix ; le multiple bascule, le simple remplace. */
		$scope.basculerOption = function (question, option) {
			if (!$scope.parcours.modifiable) {
				return;
			}
			question.reponse = question.reponse || {};
			var ids = question.reponse.optionIds || [];
			var index = ids.indexOf(option.id);
			if (question.choixMultiple) {
				if (index >= 0) {
					ids.splice(index, 1);
				} else {
					ids.push(option.id);
				}
			} else {
				ids = index >= 0 ? [] : [option.id];
			}
			question.reponse.optionIds = ids;
			question.enAttente = !ids.length;
			$scope.questionSignalee = null;
			enregistrer(question, { optionIds: ids });
		};

		$scope.estOptionRetenue = function (question, option) {
			var ids = question.reponse ? question.reponse.optionIds : null;
			return !!(ids && ids.indexOf(option.id) >= 0);
		};

		/**
		 * Un texte en cours de frappe : envoi différé de 700 ms, pour ne pas écrire à chaque
		 * touche. Le `blur` force l'envoi — quitter le champ vaut validation de la saisie.
		 */
		$scope.texteModifie = function (question, champ) {
			if (!$scope.parcours.modifiable) {
				return;
			}
			var cle = question.id + ':' + champ;
			if (minuteurs[cle]) {
				$timeout.cancel(minuteurs[cle]);
			}
			minuteurs[cle] = $timeout(function () {
				delete minuteurs[cle];
				envoyerTexte(question, champ);
			}, DEBOUNCE_TEXTE);
		};

		$scope.texteTermine = function (question, champ) {
			var cle = question.id + ':' + champ;
			if (minuteurs[cle]) {
				$timeout.cancel(minuteurs[cle]);
				delete minuteurs[cle];
				envoyerTexte(question, champ);
			}
		};

		function envoyerTexte(question, champ) {
			var modifications = {};
			var valeur = question.reponse ? question.reponse[champ] : null;
			// Une chaîne vide vaut effacement : le serveur la ramène à null, et l'écran doit dire
			// la même chose que la base.
			modifications[champ] = valeur && valeur.length ? valeur : null;
			if (champ === 'texteLibre') {
				question.enAttente = !modifications.texteLibre;
			}
			enregistrer(question, modifications);
		}

		$scope.basculerCommentaire = function (question) {
			question.commentaireOuvert = !question.commentaireOuvert;
		};

		/**
		 * Met une modification dans la file.
		 *
		 * ⚠️ `modifications` ne porte QUE ce qui change. Le contrat traite une clé absente comme
		 * « ne touche pas » et un `null` explicite comme « efface » ; transmettre la réponse
		 * entière effacerait le commentaire à chaque clic sur une modalité.
		 */
		function enregistrer(question, modifications) {
			var corps = angular.extend({ questionId: question.id }, modifications);
			$scope.etatEnregistrement = 'encours';
			file = file.then(function () {
				return AutoEvalService.enregistrerReponse($scope.soumissionId, corps)
					.then(function (resultat) {
						appliquerEnregistrement(question, resultat);
					});
			}).catch(function (erreur) {
				$scope.etatEnregistrement = 'erreur';
				$scope.erreurEnregistrement = erreur;
				// La file ne doit pas rester cassée : on la repart d'une promesse saine, sinon
				// toutes les réponses suivantes seraient rejetées sans être envoyées.
				file = $q.when();
			});
			return file;
		}

		function appliquerEnregistrement(question, resultat) {
			$scope.parcours.chapitres = resultat.chapitres;
			$scope.parcours.progression = resultat.progression;
			$scope.parcours.statutSoumission = resultat.statutSoumission;
			question.reponse = resultat.reponse;
			question.focus = resultat.focus || null;
			$scope.erreurEnregistrement = null;
			confirmer();

			// Les compteurs du bandeau viennent du chapitre recalculé.
			angular.forEach(resultat.chapitres, function (ligne) {
				if ($scope.chapitre && ligne.id === $scope.chapitre.id) {
					$scope.chapitre.nbActives = ligne.nbActives;
					$scope.chapitre.nbRepondues = ligne.nbRepondues;
					$scope.chapitre.nbEnAttente = ligne.nbEnAttente;
				}
			});
			if ($scope.alerteCompletude && $scope.chapitre && $scope.chapitre.nbEnAttente === 0) {
				$scope.alerteCompletude = null;
			}

			if (resultat.questionsRouvertes) {
				$scope.messageRouvertes = true;
			}
			// ⚠️ Une question d'orientation change la LISTE des questions visibles, ici comme
			// ailleurs : il faut recharger le chapitre, la réponse seule ne suffit pas.
			if (question.type === 'FILTRE') {
				charger($scope.chapitre.id, true);
			}
		}

		function confirmer() {
			$scope.etatEnregistrement = 'ok';
			if (minuteurConfirmation) {
				$timeout.cancel(minuteurConfirmation);
			}
			minuteurConfirmation = $timeout(function () {
				if ($scope.etatEnregistrement === 'ok') {
					$scope.etatEnregistrement = null;
				}
			}, DUREE_CONFIRMATION);
		}

		$scope.fermerMessageRouvertes = function () {
			$scope.messageRouvertes = false;
		};

		// ------------------------------------------------------------------ Affichage

		/** Modalité d'une question, pour lire sa couleur et son libellé. */
		$scope.estChoisie = function (question, modalite) {
			return !!(question.reponse && question.reponse.valeur === modalite.valeur);
		};

		/**
		 * Le libellé de la réponse donnée, pour la nommer dans la statistique du focus (retours
		 * PHSQ, SP-147) : « ont répondu « Non », comme vous ». Lu dans les modalités de la
		 * question, seule source des libellés — le focus de la 150 se déclenche sur « Oui ».
		 */
		$scope.libelleReponse = function (question) {
			var libelle = null;
			angular.forEach(question.modalites, function (modalite) {
				if (libelle === null && $scope.estChoisie(question, modalite)) {
					libelle = modalite.libelleLong || modalite.libelleCourt;
				}
			});
			return libelle;
		};

		/**
		 * LE STYLE D'UNE MODALITÉ CHOISIE : sa couleur en fond très dilué, bordure pleine.
		 *
		 * ⚠️ LE FOND EST DILUÉ, JAMAIS PLEIN, et c'est une contrainte d'accessibilité, pas un
		 * goût. Les couleurs viennent de l'API et sont figées par millésime (voir l'en-tête de
		 * `auto-evaluation.scss`) : le jaune « En cours » #EBB122 en aplat ne donne que 2,6:1
		 * avec du texte blanc, sous le seuil AA. Une variante assombrie par modalité tiendrait
		 * cette année et se casserait au premier millésime dont PHSQ change la palette. Dilué,
		 * le texte reste sombre et le contraste est garanti quelle que soit la couleur reçue.
		 *
		 * ⚠️ Posé en `ng-style` et non en CSS : le style en ligne l'emporte sur toute règle non
		 * `!important`, et la bordure était déjà posée ici.
		 */
		var OPACITE_FOND_CHOISIE = 0.14;

		$scope.styleModalite = function (question, modalite) {
			if (!$scope.estChoisie(question, modalite) || !modalite.couleurHex) {
				return {};
			}
			return {
				borderColor: modalite.couleurHex,
				background: enRgba(modalite.couleurHex, OPACITE_FOND_CHOISIE)
			};
		};

		/** #RRGGBB vers rgba(). Rend la couleur telle quelle si elle n'a pas cette forme. */
		function enRgba(hex, opacite) {
			var m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
			if (!m) {
				return hex;
			}
			var n = parseInt(m[1], 16);
			return 'rgba(' + ((n >> 16) & 255) + ', ' + ((n >> 8) & 255) + ', ' + (n & 255)
				+ ', ' + opacite + ')';
		}

		/**
		 * Cette réponse FERME-T-ELLE le chapitre ?
		 *
		 * ⚠️ La réponse masquante vient du serveur (`consequence.valeurMasquante`). C'est « NON »
		 * pour les deux questions d'orientation de 2026, mais rien ne l'impose : un millésime
		 * peut poser « Sous-traitez-vous ? » où c'est « OUI » qui ferme. Tester le mot « NON »
		 * ici marcherait aujourd'hui et se retournerait sans prévenir.
		 */
		$scope.estMasquante = function (question, modalite) {
			var c = question ? question.consequence : null;
			return !!(c && modalite && c.valeurMasquante === modalite.valeur);
		};

		/**
		 * La réponse a-t-elle été posée par QUELQU'UN D'AUTRE ?
		 *
		 * Titulaire et responsable qualité remplissent la même auto-évaluation, parfois le même
		 * jour. Signaler qui a répondu évite de défaire sans le savoir le travail de son collègue.
		 */
		$scope.modifieeParUnAutre = function (question) {
			var moi = nomUtilisateur();
			return !!(question.reponse && question.reponse.auteurNom && moi
				&& question.reponse.auteurNom !== moi);
		};

		function nomUtilisateur() {
			var user = $rootScope.user;
			if (!user) {
				return null;
			}
			if (user.firstName && user.lastName) {
				return (user.firstName + ' ' + user.lastName).trim();
			}
			return user.mail || null;
		}

		$scope.pourcentage = function () {
			var progression = $scope.parcours ? $scope.parcours.progression : null;
			if (!progression || progression.pourcentage === null
					|| angular.isUndefined(progression.pourcentage)) {
				return 0;
			}
			return Math.round(progression.pourcentage);
		};

		$scope.urlRessource = AutoEvalService.urlRessource;
		$scope.urlLienQuestion = AutoEvalService.urlLienQuestion;

		$scope.$on('$destroy', function () {
			angular.forEach(minuteurs, function (minuteur) {
				$timeout.cancel(minuteur);
			});
			if (minuteurConfirmation) {
				$timeout.cancel(minuteurConfirmation);
			}
		});

		// ------------------------------------------------------------------ Démarrage

		AutoEvalService.getSoumissionCourante().then(function (parcours) {
			appliquerParcours(parcours);
			// ⚠️ TOUT EST RÉPONDU : ON VA DROIT À LA VALIDATION. Ouvrir le questionnaire au
			// chapitre 1 obligeait à retraverser quinze chapitres déjà remplis pour trouver le
			// bouton. `location: 'replace'` évite de laisser dans l'historique une adresse qui
			// redirigerait encore au retour arrière.
			//
			// La redirection ne vaut QUE sans chapitre demandé : « Retour au questionnaire »
			// depuis la validation en désigne un, et échappe donc à ce renvoi — sans quoi le
			// bouton rebondirait sur place. Celui de la carte d'accueil, qui ne connaît pas les
			// chapitres, passe `relecture` pour la même raison.
			if (!$stateParams.chapitreId && !$stateParams.relecture && parcours.modifiable
					&& parcours.progression && parcours.progression.enAttente === 0) {
				return $state.go('app.autoeval.validation', { annee: $scope.annee },
					{ location: 'replace' });
			}

			// ⚠️ `chapitreCourantId` EST ABSENT QUAND TOUT EST RÉPONDU : il désigne le premier
			// chapitre incomplet, et il n'y en a plus. Le repli garde l'écran utilisable pour une
			// soumission complète mais NON modifiable — déjà validée, ou campagne close — qui ne
			// passe pas par la redirection ci-dessus.
			var premier = parcours.chapitres && parcours.chapitres.length
				? parcours.chapitres[0].id : null;
			var demande = $stateParams.chapitreId
				? parseInt($stateParams.chapitreId, 10)
				: (parcours.chapitreCourantId || premier);
			if (demande) {
				return charger(demande);
			}
			$scope.chargement = false;
		}).catch(function (erreur) {
			$scope.chargement = false;
			$scope.erreur = erreur;
		});
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqTableauRepartition', aeqTableauRepartition);

	/**
	 * Le tableau de répartition : une ligne de synthèse globale, puis les chapitres standards.
	 *
	 * ⚠️ LE TIRET. Une cellule vide ne veut pas dire 0 % : elle signale qu'aucune question du
	 * chapitre n'ouvre le « Non concerné ». La confusion entre les deux est précisément ce que la
	 * légende de l'écran met en garde (spécification §14), et elle ne peut être évitée qu'ici :
	 * Gson omettant les champs nuls, `ligne.pctNc` est *absent*, pas nul, et un `ng-if` naïf sur
	 * la valeur afficherait un tiret sur un vrai zéro.
	 *
	 * Un chapitre NON CONCERNÉ occupe une ligne pleine largeur qui dit pourquoi et combien de
	 * questions n'ont pas été posées, au lieu d'une rangée de zéros.
	 *
	 * Usage : `<aeq-tableau-repartition global="dto.global" chapitres="dto.chapitres"
	 *                                   palette="dto.palette"></aeq-tableau-repartition>`
	 */
	function aeqTableauRepartition() {
		return {
			restrict: 'E',
			scope: { global: '=', chapitres: '=', palette: '=' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-tableau-repartition.html',
			link: function (scope) {
				/** Présent ? — distingue l'absence du zéro. */
				scope.aUneValeur = function (valeur) {
					return valeur !== null && angular.isDefined(valeur);
				};

				scope.pourcent = function (valeur) {
					if (!scope.aUneValeur(valeur)) {
						return null;
					}
					return Math.round(valeur) + ' %';
				};

				scope.libelle = function (valeur) {
					var trouve = null;
					angular.forEach(scope.palette || [], function (item) {
						if (!trouve && item.valeur === valeur) {
							trouve = item.libelleLong;
						}
					});
					return trouve || valeur;
				};
			}
		};
	}
})();

(function () {
	'use strict';

	/**
	 * LES LIBELLÉS DES ÉNUMÉRATIONS du module, en un seul endroit.
	 *
	 * ⚠️ Sans eux, les écrans affichaient la valeur BRUTE : « NON_COMMENCEE », « GENERER_RAPPORT »,
	 * « EMAIL_ENVOYE ». C'est du vocabulaire de base de données, montré à un pilote qualité ou à
	 * un administrateur qui n'a aucune raison de le connaître — et le souligné le rend en plus
	 * pénible à lire dans un tableau dense.
	 *
	 * ⚠️ Une valeur INCONNUE est rendue TELLE QUELLE, jamais remplacée par un vide. Si le serveur
	 * gagne un statut que ce fichier ignore, l'écran affichera son nom technique — moche, mais
	 * lisible et réparable. Un vide ferait croire à une donnée manquante, et le défaut passerait
	 * inaperçu.
	 *
	 * Ces filtres servent les TROIS espaces — officine, groupement, administration — qui montrent
	 * les mêmes statuts. Les dupliquer ferait diverger les libellés d'un écran à l'autre.
	 */
	var MODULE = angular.module('fuse');

	/** Fabrique un filtre à partir d'une table, avec repli sur la valeur reçue. */
	function filtreDe(table) {
		return function () {
			return function (valeur) {
				if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
					return '';
				}
				return table[valeur] || valeur;
			};
		};
	}

	/** Espaces uniformisés, points de suite retirés, casse ignorée : on compare du sens. */
	function normaliser(valeur) {
		return String(valeur === null || angular.isUndefined(valeur) ? '' : valeur)
			.replace(/\u2026/g, '')
			.replace(/\.\.\./g, '')
			.replace(/[\s\u00a0]+/g, ' ')
			.trim()
			.toLowerCase();
	}

	/** Fabrique un filtre à partir d'une transformation — la sœur de `filtreDe`, qui part d'une
	 *  table. Les deux rendent une fabrique, ce qu'attend `.filter()`. */
	function filtreAvec(transformation) {
		return function () {
			return transformation;
		};
	}

	/**
	 * LE LIBELLÉ D'UNE QUESTION, débarrassé de la notation d'aiguillage du tableur source.
	 *
	 * ⚠️ Deux questions d'orientation du millésime 2026 traînent la consigne de rédaction de leur
	 * tableur d'origine : « … à Administrer : NON >> transfert question 96 / Si OUI : ». C'est une
	 * note d'auteur destinée à celui qui bâtit le questionnaire, pas au pharmacien qui le remplit
	 * — et l'application fait déjà cet aiguillage toute seule, en le disant en français sur les
	 * deux cartes de réponse.
	 *
	 * La coupe est volontairement ÉTROITE : il faut « OUI » ou « NON » suivi de « >> ». Un libellé
	 * qui contiendrait « >> » pour une autre raison n'est pas touché.
	 */
	function libelleSansAiguillage(libelle) {
		var texte = String(libelle === null || angular.isUndefined(libelle) ? '' : libelle);
		var propre = texte.replace(/[\s:;\/]*\b(?:OUI|NON)\b\s*>>[\s\S]*$/i, '');
		if (propre === texte) {
			return texte;
		}
		// La coupe emporte parfois la ponctuation finale : « … à Administrer : » devient
		// « … à Administrer ». On rend son point d'interrogation à la question.
		propre = propre.replace(/[\s:;\/]+$/, '').trim();
		return /[?!.]$/.test(propre) ? propre : propre + ' ?';
	}

	function titreOuRien(titre, libelleQuestion) {
		var t = normaliser(titre);
		if (!t) {
			return '';
		}
		var q = normaliser(libelleQuestion);
		return q && q.indexOf(t) === 0 ? '' : titre;
	}

	// Une soumission : le mot est féminin, les libellés s'accordent.
	MODULE.filter('aeqStatutSoumission', filtreDe({
		NON_COMMENCEE: 'Non commencée',
		EN_COURS: 'En cours',
		VALIDEE: 'Validée',
		ROUVERTE: 'Rouverte',
		PARTIELLE: 'Partielle',
		NON_REPONDUE: 'Non répondue'
	}));

	/**
	 * LE TITRE D'UN FOCUS, ou rien quand il ne fait que répéter la question.
	 *
	 * ⚠️ Les titres de focus du millésime 2026 sont PROVISOIRES : faute de contenu fourni par
	 * PHSQ, le générateur y a mis le libellé de la question coupé à 70 caractères. On lisait donc,
	 * juste sous la question, la même phrase amputée en plein mot — « … abordées ave… ».
	 *
	 * Plutôt que de rallonger la coupe, qui ne ferait que rendre la répétition entière, le titre
	 * est masqué quand il est le DÉBUT de la question : dans ce cas il n'apprend rien, la question
	 * étant affichée en toutes lettres à côté. Le jour où PHSQ livrera de vrais titres, ils ne
	 * seront plus des préfixes et s'afficheront d'eux-mêmes — sans qu'on ait à retoucher ceci.
	 *
	 * Usage : {{ point.titre | aeqTitreFocus:point.libelleQuestion }}
	 */
	MODULE.filter('aeqTitreFocus', filtreAvec(titreOuRien));

	MODULE.filter('aeqLibelleQuestion', filtreAvec(libelleSansAiguillage));

	MODULE.filter('aeqStatutCampagne', filtreDe({
		BROUILLON: 'Brouillon',
		PROGRAMMEE: 'Programmée',
		OUVERTE: 'Ouverte',
		CLOTUREE: 'Clôturée'
	}));

	MODULE.filter('aeqStatutQuestionnaire', filtreDe({
		ABSENT: 'Aucun questionnaire',
		EDITABLE: 'Chargé, modifiable',
		FIGE: 'Figé'
	}));

	MODULE.filter('aeqTypeChapitre', filtreDe({
		STANDARD: 'Standard',
		PROFIL: 'Profil',
		BAROMETRE: 'Baromètre'
	}));

	// Le type dit CE QU'ON RÉPOND, pas le nom du composant qui l'affiche : c'est la seule chose
	// qu'un administrateur ait besoin de savoir en parcourant un chapitre.
	MODULE.filter('aeqTypeQuestion', filtreDe({
		OUI_ENCOURS_NON: 'Oui / En cours / Non',
		OUI_ENCOURS_NON_NC: 'Oui / En cours / Non / Non concerné',
		FILTRE: 'Question d’orientation',
		CHOIX: 'Choix dans une liste',
		SATISFACTION: 'Échelle de satisfaction',
		TEXTE_LIBRE: 'Texte libre'
	}));

	// Le type dit le TRAVAIL fait, pas le nom de la classe qui le fait.
	MODULE.filter('aeqTypeTache', filtreDe({
		GENERER_RAPPORT: 'Génération du rapport',
		ENVOYER_EMAIL: 'Envoi d’e-mail',
		NOTIFIER_INTERNE: 'Notification interne',
		EXPORT_LOT: 'Archive de rapports'
	}));

	// Une tâche : féminin.
	MODULE.filter('aeqStatutTache', filtreDe({
		A_FAIRE: 'À faire',
		EN_COURS: 'En cours',
		FAIT: 'Faite',
		ECHEC: 'En échec'
	}));

	// Une archive : féminin.
	MODULE.filter('aeqStatutExport', filtreDe({
		EN_PREPARATION: 'En préparation',
		PRET: 'Prête',
		ECHEC: 'En échec',
		EXPIRE: 'Expirée'
	}));

	MODULE.filter('aeqRoleActeur', filtreDe({
		TITULAIRE: 'Titulaire',
		PRAQ: 'Responsable Qualité',
		ADMINISTRATEUR: 'Administrateur',
		GROUPEMENT: 'Groupement',
		SYSTEME: 'Automatique',
		IMPORT: 'Reprise Vocaza'
	}));

	MODULE.filter('aeqEvenement', filtreDe({
		PREMIERE_SAISIE: 'Première saisie',
		VALIDATION: 'Validation',
		REVALIDATION: 'Revalidation',
		REOUVERTURE: 'Réouverture',
		EMAIL_ENVOYE: 'E-mail envoyé',
		AJOUT_CIBLE: 'Ajout à la cible',
		CLOTURE: 'Clôture',
		RELANCE_DEMANDEE: 'Relance demandée'
	}));

	// L'état du compte titulaire (colonne « Compte titulaire », 21/10/2026) : « activé » quand la
	// personne a créé son mot de passe.
	MODULE.filter('aeqCompteTitulaire', filtreDe({
		ACTIVE: 'Activé',
		NON_ACTIVE: 'Non activé',
		SANS_ADRESSE: 'Sans adresse',
		AUCUN: 'Aucun compte'
	}));

	MODULE.filter('aeqTypeNotification', filtreDe({
		OUVERTURE: 'Ouverture de campagne — officines LQO',
		OUVERTURE_NON_LQO: 'Ouverture de campagne — officines non LQO',
		RELANCE: 'Relance des officines LQO',
		RELANCE_NON_LQO: 'Relance des officines non LQO',
		RAPPORT: 'Rapport disponible',
		REOUVERTURE: 'Réouverture d’une auto-évaluation',
		CLOTURE: 'Clôture — rapport définitif',
		CLOTURE_INTERNE: 'Clôture — PHSQ et groupements'
	}));
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqFocusReseau', aeqFocusReseau);

	/**
	 * « FOCUS DU RÉSEAU » : pour chaque focus du millésime, la part des officines validées du
	 * périmètre qui ont donné la réponse qui le déclenche, du plus fréquent au moins fréquent
	 * (recette groupement, ligne 11).
	 *
	 * Le but est de faire voir les sujets qui ressortent le plus, pour que le groupement les
	 * prenne en compte dans son accompagnement : « Bonnes pratiques de dispensation — 34 % ont
	 * répondu « Non » — attention ».
	 *
	 * ⚠️ UNE SEULE CARTE POUR DEUX ESPACES : l'onglet Profil du groupement et l'onglet Résultats
	 * nationaux de l'administration, qui la filtre par groupement. Le tri et le seuil viennent du
	 * serveur ; la carte les affiche, elle ne les recalcule pas.
	 *
	 * Usage : `<aeq-focus-reseau donnees="focusReseau" titre="Focus du réseau"></aeq-focus-reseau>`
	 */
	function aeqFocusReseau() {
		return {
			restrict: 'E',
			scope: { donnees: '=', titre: '@' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-focus-reseau.html',
			link: function (scope) {
				scope.aUneValeur = function (valeur) {
					return valeur !== null && angular.isDefined(valeur);
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqBoiteOutils', aeqBoiteOutils);

	/**
	 * LA BOÎTE À OUTILS d'une campagne : les documents que PHSQ met à disposition — mode
	 * opératoire, questionnaire papier vierge, guide de communication.
	 *
	 * Un seul composant pour les trois endroits qui la montrent : la carte de l'officine, la page
	 * « à venir » et le tableau de bord du groupement. Le lien est le même partout
	 * (`/autoEvaluation/outil/{id}`), et la route admet les trois profils.
	 *
	 * Le composant ne rend que la LISTE : l'intitulé revient au conteneur, qui a déjà le sien
	 * (titre de carte, intertitre).
	 *
	 * Usage : `<aeq-boite-outils outils="contexte.outils"></aeq-boite-outils>`
	 */
	function aeqBoiteOutils() {
		// L'étiquette dit ce qu'on va ouvrir, comme les icônes de la boîte des journées qualité.
		var ETIQUETTES = [
			{ type: 'pdf', libelle: 'PDF', extensions: ['pdf'] },
			{ type: 'word', libelle: 'DOC', extensions: ['doc', 'docx', 'odt', 'rtf'] },
			{ type: 'excel', libelle: 'XLS', extensions: ['xls', 'xlsx', 'xlsm', 'csv', 'ods'] },
			{ type: 'ppt', libelle: 'PPT', extensions: ['ppt', 'pptx', 'odp'] },
			{ type: 'image', libelle: 'IMG', extensions: ['png', 'jpg', 'jpeg', 'gif', 'svg'] },
			{ type: 'archive', libelle: 'ZIP', extensions: ['zip', 'rar', '7z'] }
		];

		return {
			restrict: 'E',
			scope: { outils: '=' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-boite-outils.html',
			link: function (scope) {
				function extension(outil) {
					var nom = outil && outil.nomFichier ? String(outil.nomFichier) : '';
					var point = nom.lastIndexOf('.');
					return point >= 0 ? nom.substring(point + 1).toLowerCase() : '';
				}

				scope.etiquette = function (outil) {
					if (!outil.fichier) {
						return { type: 'lien', libelle: 'LIEN' };
					}
					var ext = extension(outil);
					var trouvee = null;
					angular.forEach(ETIQUETTES, function (etiquette) {
						if (!trouvee && etiquette.extensions.indexOf(ext) !== -1) {
							trouvee = etiquette;
						}
					});
					return trouvee || { type: 'fichier', libelle: ext ? ext.toUpperCase().substring(0, 4) : 'DOC' };
				};

				scope.url = function (outil) {
					return '/api/rest/autoEvaluation/outil/' + outil.id;
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqBarreEmpilee', aeqBarreEmpilee);

	/**
	 * Barre 100 % à quatre modalités — Oui, En cours, Non, Non concerné.
	 *
	 * ⚠️ Les COULEURS viennent de la palette du millésime renvoyée par l'API, jamais d'une table
	 * codée ici : une année passée doit garder les siennes, même si PHSQ change de palette
	 * ensuite (spécification §3).
	 *
	 * ⚠️ Les largeurs utilisent les pourcentages BRUTS, non arrondis. Arrondir d'abord ferait une
	 * barre qui ne boucle pas à 100 % — trois chapitres sur treize montraient un liseré de fond à
	 * droite dans la maquette pour cette raison.
	 *
	 * Le libellé s'inscrit dans le segment quand il a la place (≥ 8 %) ; sinon il ne reste que
	 * l'infobulle, qui porte toujours le texte complet.
	 *
	 * Usage : `<aeq-barre-empilee ligne="ligne" palette="palette"></aeq-barre-empilee>`
	 */
	function aeqBarreEmpilee() {
		var LARGEUR_MINIMALE_LIBELLE = 8;

		var CHAMPS = [
			{ valeur: 'OUI', pct: 'pctOui', secours: '#3CB4A1' },
			{ valeur: 'EN_COURS', pct: 'pctEnCours', secours: '#EBB122' },
			{ valeur: 'NON', pct: 'pctNon', secours: '#EF5450' },
			{ valeur: 'NON_CONCERNE', pct: 'pctNc', secours: '#B0BFC9' }
		];

		return {
			restrict: 'E',
			scope: { ligne: '=', palette: '=' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-barre-empilee.html',
			link: function (scope) {
				function modalite(valeur) {
					var trouvee = null;
					angular.forEach(scope.palette || [], function (item) {
						if (!trouvee && item.valeur === valeur) {
							trouvee = item;
						}
					});
					return trouvee;
				}

				function construire() {
					var ligne = scope.ligne || {};
					var segments = [];
					angular.forEach(CHAMPS, function (champ) {
						var pct = ligne[champ.pct];
						// ⚠️ Absent ≠ zéro : un chapitre dont aucune question n'ouvre le « Non
						// concerné » n'a pas de segment, il n'en a pas un de largeur nulle.
						if (pct === null || angular.isUndefined(pct) || pct <= 0) {
							return;
						}
						var item = modalite(champ.valeur);
						var libelle = item && item.libelleLong ? item.libelleLong : champ.valeur;
						segments.push({
							valeur: champ.valeur,
							largeur: pct,
							couleur: item && item.couleurHex ? item.couleurHex : champ.secours,
							texte: Math.round(pct) + ' %',
							infobulle: libelle + ' : ' + arrondi(pct) + ' %',
							afficheTexte: pct >= LARGEUR_MINIMALE_LIBELLE,
							pale: champ.valeur === 'NON_CONCERNE'
						});
					});
					scope.segments = segments;
					scope.vide = segments.length === 0;
				}

				function arrondi(valeur) {
					return (Math.round(valeur * 10) / 10).toString().replace('.', ',');
				}

				scope.$watch('ligne', construire, true);
				scope.$watch('palette', construire, true);
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqBadgeEcart', aeqBadgeEcart);

	/**
	 * Écart en points, avec son signe, sa flèche et sa couleur.
	 *
	 * ⚠️ Ce badge n'est PAS une note. La spécification §4.6 insiste : « repère indicatif, sans
	 * classement ni note ». D'où l'unité explicite — « +3 pts vs groupement » — plutôt qu'un
	 * chiffre nu qu'on lirait comme un score.
	 *
	 * Un écart ABSENT n'est pas un écart nul : il rend un tiret et le motif. « Jamais 0 % » vaut
	 * aussi pour les écarts.
	 *
	 * Usage : `<aeq-badge-ecart valeur="ligne.ecartPts" suffixe="'vs groupement'"
	 *                          motif="ligne.motif"></aeq-badge-ecart>`
	 */
	function aeqBadgeEcart() {
		var MOTIFS = {
			NON_CONCERNE: 'non concerné, non comparé',
			NON_CONCERNE_N1: 'non concerné l’an dernier',
			NOUVELLES_QUESTIONS: 'nouvelles questions',
			SANS_REFERENT: 'sans référent',
			PREMIERE_PARTICIPATION: 'première participation'
		};

		return {
			restrict: 'E',
			scope: { valeur: '=', suffixe: '=', motif: '=' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-badge-ecart.html',
			link: function (scope) {
				function construire() {
					var valeur = scope.valeur;
					scope.absent = valeur === null || angular.isUndefined(valeur);
					scope.texteMotif = MOTIFS[scope.motif] || scope.motif || null;
					if (scope.absent) {
						return;
					}
					var arrondie = Math.round(valeur * 10) / 10;
					scope.sens = arrondie > 0 ? 'hausse' : (arrondie < 0 ? 'baisse' : 'egal');
					// Le pluriel se joue sur la valeur ABSOLUE : « −1 pt », « −2 pts ».
					var unite = Math.abs(arrondie) >= 2 ? 'pts' : 'pt';
					var signe = arrondie > 0 ? '+' : (arrondie < 0 ? '−' : '');
					scope.texte = signe + Math.abs(arrondie).toString().replace('.', ',') + ' ' + unite;
				}

				scope.$watch('valeur', construire);
				scope.$watch('motif', construire);
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqAide', aeqAide);

	/**
	 * LE BLOC D'AIDE D'UN ÉCRAN, replié par défaut.
	 *
	 * ⚠️ Les explications étaient posées à plat au-dessus du tableau. Elles rendent service la
	 * première fois, puis repoussent le contenu vers le bas à chaque visite suivante — or on
	 * revient sur ces écrans pour le tableau, pas pour le mode d'emploi. Repliées, elles restent
	 * à portée sans coûter une ligne de défilement.
	 *
	 * ⚠️ REPLIÉ À L'OUVERTURE, et volontairement : l'état n'est pas mémorisé d'une visite à
	 * l'autre. Un bloc qui rouvrirait tout seul redeviendrait le bandeau qu'on cherche à éviter.
	 *
	 * Le `resume` dit ce qu'on trouvera dedans : sans lui, ouvrir le bloc est un pari.
	 *
	 * Usage : `<aeq-aide resume="À quoi sert cette file">…</aeq-aide>`
	 */
	function aeqAide() {
		return {
			restrict: 'E',
			transclude: true,
			scope: { titre: '@', resume: '@' },
			templateUrl: 'app/main/front/auto-evaluation/partages/aeq-aide.html',
			link: function (scope) {
				scope.ouvert = false;

				scope.basculer = function () {
					scope.ouvert = !scope.ouvert;
				};
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').service('AeqAccesOfficine', AeqAccesOfficine);

	/**
	 * LA FENÊTRE « ACCÈS DE L'OFFICINE » (retour PHSQ du 21/10/2026), commune à l'espace groupement
	 * et à l'administration : répondre sur-le-champ à « dites-moi comment me connecter, je n'ai
	 * rien reçu ».
	 *
	 * Elle montre les comptes qui reçoivent les e-mails de la campagne — adresse en clair, compte
	 * activé ou non, dernière connexion —, les e-mails déjà envoyés à l'officine, et RENVOIE
	 * L'E-MAIL DE LANCEMENT. Le serveur décide de tout : quel e-mail part (celui du contrat), à
	 * qui, et si le renvoi est permis. La fenêtre ne fait qu'afficher sa réponse.
	 *
	 * ⚠️ PAS DE SECONDE CONFIRMATION : la fenêtre montre déjà à qui l'e-mail part, et le serveur
	 * refuse un second renvoi dans les quinze minutes. Une confirmation de plus ralentirait l'appel
	 * sans rien protéger.
	 *
	 * ⚠️ Montée par `$mdDialog` dans `<body>`, donc HORS des conteneurs `.aeq-gpt` et `.aeq-admin` :
	 * ses styles sont à la racine de `auto-evaluation.scss`, et sa charpente est celle de la
	 * famille globale `admin-dialog`.
	 *
	 * @param options {nom, cip, annee, vueAdmin, event, charger(): promesse du DTO,
	 *        renvoyer(): promesse du DTO à jour}
	 * @return promesse résolue à la fermeture avec `{envoye}` : la liste se recharge si un e-mail
	 *         est parti, pour que son bouton dise « Envoyé à … ».
	 */
	/** @ngInject */
	function AeqAccesOfficine($mdDialog, $document, $filter, $timeout) {

		var GABARIT = 'app/main/front/auto-evaluation/partages/aeq-acces-officine.html';

		/** @ngInject */
		function ControleurAcces($scope, $mdDialog, options, etat) {
			$scope.nom = options.nom;
			$scope.cip = options.cip;
			$scope.annee = options.annee;
			$scope.vueAdmin = !!options.vueAdmin;
			$scope.acces = null;
			$scope.chargement = true;
			$scope.erreur = null;
			$scope.envoi = false;
			$scope.erreurEnvoi = null;
			$scope.confirmation = null;
			$scope.copiee = null;

			function heure(millis) {
				return $filter('date')(millis, 'HH \'h\' mm');
			}

			$scope.heure = heure;

			options.charger().then(function (acces) {
				$scope.acces = acces;
			}).catch(function (erreur) {
				$scope.erreur = (erreur && erreur.message) || 'Les informations de l’officine n’ont pas pu être lues.';
			}).finally(function () {
				$scope.chargement = false;
			});

			/**
			 * Le bouton n'existe que là où un renvoi a un sens : campagne ouverte, officine non
			 * validée. Ailleurs, la fenêtre sert à consulter.
			 */
			$scope.boutonVisible = function () {
				var a = $scope.acces;
				return !!a && a.refusRenvoi !== 'CAMPAGNE_FERMEE' && a.refusRenvoi !== 'DEJA_VALIDEE';
			};

			/**
			 * Un envoi peut-il partir, maintenant ou à la fin du délai ? Sans adresse, ou e-mail coupé
			 * par PHSQ, les phrases sur le lien personnel et le délai d'arrivée n'ont pas d'objet.
			 */
			$scope.envoiEnvisageable = function () {
				var a = $scope.acces;
				return $scope.boutonVisible() && a.refusRenvoi !== 'AUCUNE_ADRESSE'
					&& a.refusRenvoi !== 'EMAIL_NON_CONFIGURE';
			};

			/** Le motif d'un bouton grisé, sauf le délai de quinze minutes : le bouton le dit déjà. */
			$scope.motifAffiche = function () {
				var a = $scope.acces;
				return a && !a.renvoiPossible && a.refusRenvoi !== 'RENVOI_RECENT' && $scope.boutonVisible()
					? a.motifRenvoi : null;
			};

			$scope.renvoyer = function () {
				if ($scope.envoi || !$scope.acces || !$scope.acces.renvoiPossible) {
					return;
				}
				$scope.envoi = true;
				$scope.erreurEnvoi = null;
				$scope.confirmation = null;
				options.renvoyer().then(function (acces) {
					etat.envoye = true;
					$scope.acces = acces;
					$scope.confirmation = {
						a: heure(acces.dernierRenvoi),
						prochain: heure(acces.prochainRenvoi),
						destinataires: acces.destinataires || []
					};
				}).catch(function (erreur) {
					// ⚠️ La fenêtre RESTE OUVERTE sur un refus, avec sa raison : un collègue a pu
					// renvoyer l'e-mail entre-temps, ou l'officine valider. On relit l'état pour que
					// le bouton dise la vérité.
					$scope.erreurEnvoi = (erreur && erreur.message) || 'L’e-mail n’a pas pu être renvoyé.';
					options.charger().then(function (acces) {
						$scope.acces = acces;
					});
				}).finally(function () {
					$scope.envoi = false;
				});
			};

			/**
			 * Copie une adresse, pour la dicter ou la coller dans un e-mail à l'officine.
			 *
			 * ⚠️ `navigator.clipboard` n'existe qu'en contexte sécurisé (HTTPS ou localhost). Ailleurs,
			 * on sélectionne le texte d'un champ caché et on passe par `execCommand('copy')`.
			 */
			$scope.copier = function (adresse) {
				function fait() {
					$scope.copiee = adresse;
					$timeout(function () {
						if ($scope.copiee === adresse) {
							$scope.copiee = null;
						}
					}, 2000);
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(adresse).then(function () {
						$scope.$applyAsync(fait);
					}).catch(function () {
						$scope.$applyAsync(function () { copierAncien(adresse, fait); });
					});
				} else {
					copierAncien(adresse, fait);
				}
			};

			function copierAncien(adresse, fait) {
				var racine = $document[0];
				var champ = racine.createElement('textarea');
				champ.value = adresse;
				champ.setAttribute('readonly', '');
				champ.style.position = 'absolute';
				champ.style.left = '-9999px';
				racine.body.appendChild(champ);
				champ.select();
				try {
					if (racine.execCommand('copy')) {
						fait();
					}
				} finally {
					racine.body.removeChild(champ);
				}
			}

			$scope.fermer = function () {
				$mdDialog.hide();
			};
		}

		this.ouvrir = function (options) {
			var etat = { envoye: false };
			function fin() {
				return etat;
			}
			return $mdDialog.show({
				templateUrl: GABARIT,
				controller: ControleurAcces,
				locals: { options: options || {}, etat: etat },
				parent: angular.element($document[0].body),
				targetEvent: (options || {}).event,
				clickOutsideToClose: true,
				escapeToClose: true
			}).then(fin, fin);
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('AutoEvalComparaisonController', AutoEvalComparaisonController);

	/**
	 * La comparaison au groupement et à l'année précédente (spécification §4.6).
	 *
	 * ⚠️ En campagne OUVERTE, la page s'ouvre quand même : l'évolution N-1 y est valable — elle
	 * oppose deux instantanés figés de la même officine — alors que la moyenne du réseau, elle,
	 * bougerait à chaque validation. Le back masque donc la seule moitié « groupement », avec le
	 * motif `CAMPAGNE_EN_COURS` ; la page n'est plus refusée en bloc.
	 *
	 * Le 403 `COMPARAISON_INDISPONIBLE` n'est plus émis, mais reste traité : un back non encore
	 * déployé afficherait sinon une erreur rouge là où il n'y a qu'une attente.
	 */
	/** @ngInject */
	function AutoEvalComparaisonController($scope, $state, $stateParams, AutoEvalService) {
		$scope.annee = parseInt($stateParams.annee, 10);
		$scope.chargement = true;
		$scope.erreur = null;
		$scope.pasEncore = false;
		$scope.comparaison = null;

		AutoEvalService.getComparaison($scope.annee).then(function (comparaison) {
			$scope.comparaison = comparaison;
			$scope.chargement = false;
		}).catch(function (erreur) {
			$scope.chargement = false;
			if (erreur.code === 'COMPARAISON_INDISPONIBLE') {
				$scope.pasEncore = true;
				return;
			}
			$scope.erreur = erreur;
		});

		$scope.texteIndisponible = function () {
			var groupement = $scope.comparaison ? $scope.comparaison.groupement : null;
			if (!groupement) {
				return null;
			}
			if (groupement.motifIndisponible === 'SANS_GROUPEMENT') {
				return 'Votre officine n’est rattachée à aucun groupement : il n’y a pas de réseau auquel vous comparer.';
			}
			if (groupement.motifIndisponible === 'EFFECTIF_INSUFFISANT') {
				return 'Aucune autre officine de votre groupement n’a validé son auto-évaluation : la moyenne du réseau serait la vôtre.';
			}
			if (groupement.motifIndisponible === 'CAMPAGNE_EN_COURS') {
				return 'La campagne est encore ouverte : la moyenne de votre réseau changerait à chaque validation et ne constituerait pas un repère. Elle sera affichée après la clôture. Votre évolution par rapport à l’an dernier, elle, est déjà définitive.';
			}
			return null;
		};

		$scope.texteN1Indisponible = function () {
			var n1 = $scope.comparaison ? $scope.comparaison.n1 : null;
			if (!n1 || n1.disponible) {
				return null;
			}
			switch (n1.motif) {
			case 'PREMIERE_PARTICIPATION':
				return 'Première participation : il n’y a pas d’année précédente à laquelle vous comparer.';
			case 'AUCUNE_CORRESPONDANCE':
				return 'Aucune question du questionnaire de cette année n’a d’équivalent l’an dernier : la comparaison n’aurait pas de sens.';
			case 'CAMPAGNE_N1_OUVERTE':
				return 'La campagne de l’année précédente n’est pas encore clôturée.';
			default:
				return 'La comparaison à l’année précédente n’est pas disponible.';
			}
		};

		$scope.retourResultats = function () {
			$state.go('app.autoeval.resultats', { annee: $scope.annee });
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').directive('aeqAccueilCampagne', aeqAccueilCampagne);

	/**
	 * La carte « Auto-évaluation <année> » en tête de l'onglet Auto-évaluation de
	 * « Mes évaluations » — le point d'entrée du module (spécification §4.1).
	 *
	 * ⚠️ La SITUATION vient du serveur. Six cas — campagne à venir, remplissage en cours, validée
	 * campagne ouverte, rouverte, clôturée validée, clôturée non validée — qui croisent deux
	 * cycles de vie. Les reconstituer ici à coups de conditions imbriquées, c'est se tromper sur
	 * l'un d'eux tôt ou tard ; le back les tranche une fois pour toutes et rend un mot.
	 *
	 * ⚠️ La carte ne remplace PAS la liste des synthèses déjà déposées : elle se pose AU-DESSUS.
	 * Le dépôt de PDF existe depuis 2021 et porte les millésimes antérieurs, 2025 compris — c'est
	 * par lui que l'officine relit ses auto-évaluations passées.
	 *
	 * ⚠️ Aucun message d'erreur pour un compte hors périmètre. Un 404 ou un 401 signifie que le
	 * module ne concerne pas ce compte : la carte disparaît, et l'onglet reste ce qu'il était.
	 */
	function aeqAccueilCampagne() {
		return {
			restrict: 'E',
			scope: {},
			templateUrl: 'app/main/front/auto-evaluation/accueil/aeq-accueil-campagne.html',
			controller: AeqAccueilCampagneController
		};
	}

	/** @ngInject */
	function AeqAccueilCampagneController($scope, $rootScope, $state, AutoEvalService) {
		var JOURS_TEASING = 30;

		$scope.chargement = true;
		$scope.contexte = null;
		$scope.erreur = null;

		AutoEvalService.getContexte().then(function (contexte) {
			$scope.contexte = contexte;
			$scope.chargement = false;
			// Le bandeau du haut lit le même contexte : le rafraîchir ici le remet d'accord
			// avec la carte, validation comprise.
			$rootScope.autoEvalContext = contexte;
		}).catch(function (erreur) {
			// Un compte sans officine, ou une pharmacie hors de toute campagne : la carte ne
			// s'affiche pas, et ce n'est pas une anomalie à signaler à l'utilisateur.
			$scope.chargement = false;
			$scope.erreur = (erreur.status === 404 || erreur.status === 401) ? null : erreur;
		});

		$scope.estSituation = function () {
			if (!$scope.contexte) {
				return false;
			}
			for (var i = 0; i < arguments.length; i++) {
				if ($scope.contexte.situation === arguments[i]) {
					return true;
				}
			}
			return false;
		};

		/**
		 * La page de teasing : une campagne À VENIR qui ouvre dans trente jours au plus. Au-delà,
		 * rien n'est montré — ni teaser, ni carte (recette pharmacie, ligne 18).
		 */
		$scope.enTeasing = function () {
			var jours = $scope.joursAvantOuverture();
			return $scope.estSituation('A_VENIR') && jours !== null && jours >= 0 && jours <= JOURS_TEASING;
		};

		/** Pourcentage de complétude, arrondi à l'entier pour l'affichage. */
		$scope.pourcentage = function () {
			var progression = $scope.contexte && $scope.contexte.soumission
				? $scope.contexte.soumission.progression : null;
			if (!progression || progression.pourcentage === null
					|| angular.isUndefined(progression.pourcentage)) {
				return 0;
			}
			return Math.round(progression.pourcentage);
		};

		/**
		 * Le nombre de JOURS, en dates de calendrier.
		 *
		 * ⚠️ On compare des MINUITS, pas des instants. Les bornes de campagne portent l'heure à
		 * laquelle elles ont été posées — 12 h 43 pour 2026, parce qu'elles ont été écrites
		 * directement en base lors de la recette. Une soustraction brute rendrait « 59 jours »
		 * un matin et « 60 » l'après-midi pour la même échéance. Un titulaire compte en jours de
		 * calendrier : le jour de clôture est le dernier jour utile, donc il vaut zéro.
		 */
		function joursEntre(depuis, jusqua) {
			if (depuis === null || jusqua === null || angular.isUndefined(jusqua)) {
				return null;
			}
			var a = new Date(depuis);
			var b = new Date(jusqua);
			a.setHours(0, 0, 0, 0);
			b.setHours(0, 0, 0, 0);
			return Math.round((b.getTime() - a.getTime()) / 86400000);
		}

		/** Jours restants avant la clôture EFFECTIVE — prolongation comprise. */
		$scope.joursRestants = function () {
			return $scope.contexte && $scope.contexte.campagne
				? joursEntre(Date.now(), $scope.contexte.campagne.dateClotureEffective) : null;
		};

		/** Jours avant l'ouverture, pour une campagne encore à venir. */
		$scope.joursAvantOuverture = function () {
			return $scope.contexte && $scope.contexte.campagne
				? joursEntre(Date.now(), $scope.contexte.campagne.dateOuverture) : null;
		};

		/** Questions encore sans réponse ; zéro veut dire « prêt à valider ». */
		$scope.resteAFaire = function () {
			var progression = $scope.contexte && $scope.contexte.soumission
				? $scope.contexte.soumission.progression : null;
			return progression ? progression.enAttente : null;
		};

		/**
		 * Le libellé du bouton d'action.
		 *
		 * ⚠️ TOUT EST RÉPONDU : LE BOUTON MÈNE À LA VALIDATION, il doit donc le dire. Ouvrir le
		 * questionnaire sans chapitre y renvoie directement — promettre « reprendre le
		 * remplissage » pour arriver sur l'écran de validation ferait passer le raccourci pour
		 * une erreur.
		 *
		 * ⚠️ `resteAFaire()` rend NULL, et non zéro, tant que la soumission n'existe pas — le cas
		 * de l'officine qui n'a pas encore ouvert son questionnaire. Trois `ng-if` écrits sur le
		 * seul nombre laissaient ce cas-là SANS AUCUN LIBELLÉ : le bouton s'affichait réduit à sa
		 * flèche. Rien à répondre encore, c'est « commencer ».
		 */
		$scope.libelleAction = function () {
			if ($scope.resteAFaire() === 0) {
				return 'Valider mon questionnaire';
			}
			// Les libellés de la recette pharmacie, ligne 2.
			return $scope.pourcentage() > 0 ? 'Reprendre le questionnaire' : 'Commencer l’auto-évaluation';
		};

		$scope.reprendre = function () {
			// Sans chapitre dans l'adresse, le questionnaire reprend là où l'officine s'était
			// arrêtée : c'est très exactement ce que promet le bouton.
			$state.go('app.autoeval.questionnaire', { annee: $scope.contexte.campagne.annee });
		};

		/**
		 * Tout est répondu mais rien n'est validé : le titulaire peut vouloir relire avant de
		 * valider (recette pharmacie, ligne 14). Sans `relecture`, le questionnaire ouvert sans
		 * chapitre renverrait aussitôt à la validation.
		 */
		$scope.retourQuestionnaire = function () {
			$state.go('app.autoeval.questionnaire', { annee: $scope.contexte.campagne.annee, relecture: true });
		};

		$scope.voirResultats = function () {
			$state.go('app.autoeval.resultats', { annee: $scope.contexte.campagne.annee });
		};

		$scope.voirComparaison = function () {
			$state.go('app.autoeval.comparaison', { annee: $scope.contexte.campagne.annee });
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.admin', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		// State
		$stateProvider
			.state('admin.home', {
				url: '/home',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/home/admin-home.html',
						controller: 'AdminHomeController as vm'
					}
				}
			})
			.state('admin.bandeau', {
				url: '/bandeau',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/bandeau/admin-bandeau.html',
						controller: 'AdminBandeauController as vm'
					}
				}
			})
			.state('admin.bandeau.history', {
				url: '/bandeau/historique/:type',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/bandeau/history_bandeaux.html',
						controller: 'AdminHistoryBandeauxController as vm'
					}
				}
			})
			.state('admin.configuration-campagne', {
				url: '/configuration-campagne',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/campagne/configuration-campagne.html',
						controller: 'ConfigurationCampagneController as vm'
					}
				}
			});

	}
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminPharmaciesStatistiquesController', AdminPharmaciesStatistiquesController);

  /** @ngInject */
  function AdminPharmaciesStatistiquesController($scope, PharmacyService) {
    $scope.stats = null;
    $scope.loading = false;
    $scope.perTypeSelected = {};
    $scope.progressForm = 'OPEN';
    $scope.types = [
      {
        id: 0,
        name: "ALL",
        displayName: "Toutes les pharmacies"
      },
      {
        id: 1,
        name: "LQO",
        displayName: "LQO"
      },
      {
        id: 2,
        name: "LQO_MINI",
        displayName: "LQO découverte"
      },
      {
        id: 3,
        name: "NON_LQO",
        displayName: "Non-LQO"
      },
      {
        id: 4,
        name: "OSYS",
        displayName: "OSyS"
      },
    ];

    $scope.type = $scope.types[0];

    $scope.getCurrentMalfunctionStats = function (stats, myType) {
      var filteredMal = stats.malfunctionByType.filter(function (mal) {
        if (mal.type === myType) { return mal };
      })[0];
      return filteredMal;
    }

    $scope.getStats = function () {
      $scope.loading = true;
      PharmacyService.getStats($scope.type).then(function (res) {
        $scope.stats = res.data;
        if ($scope.stats.malfunctionByType && $scope.stats.malfunctionByType.length > 0) {
          if ($scope.perTypeSelected.type) {
            $scope.perTypeSelected = $scope.getCurrentMalfunctionStats($scope.stats, $scope.perTypeSelected.type);
          }
          else $scope.perTypeSelected = $scope.stats.malfunctionByType[0];
        }
        $scope.loading = false;
      }).catch(function (err) {
        $scope.loading = false;
      })
    }

    $scope.getStats();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('GroupementDetailController', GroupementDetailController);

  /**
   * Détail d'un groupement : la gestion complète de ses accès (§2 et §9.1).
   *
   * ⚠️ Un réseau compte N personnes sur deux niveaux — la notion d'« un responsable par
   * groupement » a disparu. On ajoute une personne par son adresse : si le compte existe déjà, il
   * est réutilisé (c'est ainsi que naît la double casquette d'un titulaire également responsable
   * de réseau) ; sinon il est créé et l'invitation part.
   *
   * ⚠️ Retirer un accès ne supprime PAS le compte : la personne peut être titulaire d'une officine
   * par ailleurs, et ses commentaires déjà déposés dans le CRM gardent son nom.
   */
  /** @ngInject */
  function GroupementDetailController($scope, $state, $stateParams, $q, toastr,
    ConfirmationGroupement, GroupementAdminService) {

    var FORMAT_MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    /**
     * Refus explicite du serveur. Ce n'est pas une panne : la situation appelle un autre geste, et
     * le message doit le dire.
     */
    var REFUS_CORRECTION = {
      deja_rattache: 'Cette personne a déjà un accès à ce groupement.'
    };

    var NIVEAUX = [
      { valeur: 'RESPONSABLE', libelle: 'Responsable' },
      { valeur: 'CONSULTATION', libelle: 'Consultation' }
    ];

    $scope.niveaux = NIVEAUX;
    $scope.codeCrm = Number($stateParams.codeCrm);
    $scope.groupement = null;
    $scope.loading = true;
    $scope.traitement = false;
    $scope.formulaire = { mail: '', niveau: 'RESPONSABLE' };
    $scope.edition = null;

    $scope.libelleNiveau = function (niveau) {
      var trouve = NIVEAUX.filter(function (item) { return item.valeur === niveau; })[0];
      return trouve ? trouve.libelle : niveau;
    };

    function extractCollection(data) {
      if (!data) {
        return [];
      }
      return angular.isArray(data) ? data : (data.groupements || []);
    }

    /**
     * Le détail est extrait de la liste : le CRM ne sert pas de fiche par groupement, et un
     * second appel pour un seul objet n'apporterait rien.
     */
    $scope.load = function () {
      $scope.loading = true;
      GroupementAdminService.getGroupements().then(function (response) {
        var trouve = extractCollection(response.data).filter(function (groupement) {
          return Number(groupement.codeCrm) === $scope.codeCrm;
        })[0];
        if (!trouve) {
          toastr.error("Ce groupement n'existe pas dans le référentiel du CRM.");
          $scope.retour();
          return;
        }
        trouve.acces = trouve.acces || [];
        $scope.groupement = trouve;
      }).catch(function () {
        toastr.error('Impossible de charger le groupement.');
      }).finally(function () {
        $scope.loading = false;
      });
    };

    $scope.retour = function () {
      $state.go('admin.groupements');
    };

    $scope.nbEnAttente = function () {
      if (!$scope.groupement) {
        return 0;
      }
      return $scope.groupement.acces.filter(function (acces) { return !acces.invitationAcceptee; }).length;
    };

    $scope.nbResponsables = function () {
      if (!$scope.groupement) {
        return 0;
      }
      return $scope.groupement.acces.filter(function (acces) { return acces.niveau === 'RESPONSABLE'; }).length;
    };

    // --- Créer

    $scope.ajouter = function () {
      var mail = ($scope.formulaire.mail || '').trim();
      if (!mail || $scope.traitement) {
        return;
      }
      $scope.traitement = true;
      GroupementAdminService.ajouterAcces($scope.codeCrm, mail, $scope.formulaire.niveau)
        .then(function (response) {
          var acces = response.data;
          // Une personne déjà rattachée revient avec son niveau ajusté : on remplace, on n'empile pas.
          // ⚠️ `acces.id &&` : sans identifiant, la comparaison aurait valu `undefined ===
          // undefined` sur la première ligne de la liste, et l'accès ajouté l'aurait ÉCRASÉE au
          // lieu de s'ajouter — l'autre visage du bogue du 08/09/2026.
          var existant = !acces.id ? null
            : $scope.groupement.acces.filter(function (item) { return item.id === acces.id; })[0];
          if (existant) {
            angular.extend(existant, acces);
            toastr.success('Niveau mis à jour pour ' + acces.mail + '.');
          } else {
            $scope.groupement.acces.push(acces);
            toastr.success(acces.invitationAcceptee
              ? 'Accès accordé à ' + acces.mail + '.'
              : 'Accès accordé — une invitation a été envoyée à ' + acces.mail + '.');
          }
          $scope.formulaire = { mail: '', niveau: 'RESPONSABLE' };
        }).catch(function (error) {
          toastr.error(messageErreur(error, "L'accès n'a pas pu être accordé."));
        }).finally(function () {
          $scope.traitement = false;
        });
    };

    // --- Modifier

    $scope.ouvrirEdition = function (acces) {
      $scope.edition = { id: acces.id, niveau: acces.niveau, mail: acces.mail };
    };

    /**
     * Cette ligne est-elle celle qu'on modifie ?
     *
     * ⚠️ Le test ne peut PAS s'écrire `edition.id === acces.id` dans le gabarit : hors édition,
     * `edition` est nul, donc `edition.id` vaut `undefined` — et un accès sans identifiant vaut
     * `undefined` lui aussi. Les deux se valaient, et la ligne s'ouvrait toute seule en mode
     * modification, avec un champ vide (bogue du 08/09/2026 à l'ajout d'un accès, quand le
     * serveur renvoyait un accès sans `id`). On exige donc une édition ouverte ET un
     * identifiant réel.
     */
    $scope.enEdition = function (acces) {
      return !!$scope.edition && !!acces && $scope.edition.id === acces.id;
    };

    /**
     * Ce qu'il faut savoir avant de renommer ce compte, ou `null` s'il n'existe que par cet accès.
     *
     * Corriger l'adresse ne pose aucun problème sur un compte créé pour l'invitation. Sur un
     * compte qui sert par ailleurs, c'est l'identifiant de connexion d'une personne réelle qui
     * change : le serveur l'accepte, l'écran doit le dire avant.
     */
    $scope.avertissementMail = function (acces) {
      if (!acces) {
        return null;
      }
      if (acces.rattachementAutre) {
        return 'Ce compte est aussi ' + acces.rattachementAutre + '. Changer son adresse change '
          + 'aussi son identifiant de connexion à LQO.';
      }
      if (acces.invitationAcceptee) {
        return 'Ce compte est déjà activé : la personne se connecte aujourd\'hui avec cette adresse.';
      }
      return null;
    };

    $scope.annulerEdition = function () {
      $scope.edition = null;
    };

    /**
     * Enregistre les deux modifications possibles d'un accès : son niveau et, tant que
     * l'invitation est en attente, son adresse.
     *
     * ⚠️ L'ADRESSE D'ABORD. Corriger l'adresse peut transférer l'accès à un compte existant ;
     * l'identifiant de l'accès ne change pas, mais son titulaire si. Dans l'autre ordre, on
     * modifierait le niveau de quelqu'un avant de découvrir que le transfert est refusé.
     */
    $scope.enregistrerEdition = function (acces) {
      if ($scope.traitement) {
        return;
      }
      var mail = ($scope.edition.mail || '').trim();
      var mailModifie = !!mail && mail.toLowerCase() !== (acces.mail || '').toLowerCase();
      if (mailModifie && !FORMAT_MAIL.test(mail)) {
        toastr.error('Cette adresse électronique n\'est pas valide.');
        return;
      }
      var niveauModifie = $scope.edition.niveau !== acces.niveau;
      if (!mailModifie && !niveauModifie) {
        $scope.edition = null;
        return;
      }

      // Le renommage d'un compte qui sert ailleurs se fait confirmer : le serveur ne s'y oppose
      // pas, c'est donc à l'écran de s'assurer que la conséquence est comprise.
      var avertissement = mailModifie ? $scope.avertissementMail(acces) : null;
      var accord = !avertissement ? $q.when(true) : ConfirmationGroupement.demander({
        titre: 'Changer l\'adresse de ce compte',
        texte: avertissement + ' L\'ancienne adresse ne permettra plus de se connecter.',
        detail: (acces.mail || '') + '  →  ' + mail,
        confirmer: 'Changer l\'adresse',
        danger: false
      });

      $scope.traitement = true;
      var faits = [];

      var chaine = accord.then(function () {
        return !mailModifie ? null
          : GroupementAdminService.corrigerMail(acces.id, mail).then(function (response) {
            angular.extend(acces, response.data);
            // L'ancien lien d'activation est neutralisé ; une nouvelle invitation ne part que si
            // le compte n'a pas encore de mot de passe.
            faits.push(response.data.invitationAcceptee ? 'Adresse corrigée'
              : 'Adresse corrigée, invitation renvoyée');
          });
      });

      chaine.then(function () {
        if (!niveauModifie) {
          return null;
        }
        return GroupementAdminService.modifierNiveau(acces.id, $scope.edition.niveau)
          .then(function (response) {
            angular.extend(acces, response.data);
            faits.push('Niveau modifié');
          });
      }).then(function () {
        $scope.edition = null;
        toastr.success(faits.join(' · ') + '.');
      }).catch(function (error) {
        // Renoncer à la confirmation rejette SANS valeur : ce n'est pas un échec.
        if (!error) {
          return;
        }
        var type = error.data ? error.data.type : null;
        toastr.error(REFUS_CORRECTION[type] || messageErreur(error, "La modification n'a pas pu être enregistrée."));
      }).finally(function () {
        $scope.traitement = false;
      });
    };

    // --- Supprimer

    /**
     * ⚠️ La MÊME boîte que la confirmation de changement d'adresse, quelques lignes plus haut :
     * `ConfirmationGroupement` remplace `$mdDialog.confirm()`, dont le gabarit intégré ne se
     * laisse ni habiller ni hiérarchiser — « Annuler » et l'action destructrice y sont deux
     * boutons plats identiques. Deux styles de confirmation sur le même écran, c'était
     * exactement l'incohérence à corriger.
     *
     * Le contrat de promesse est identique à celui de `$mdDialog.confirm()` — aboutie si
     * l'utilisateur confirme, REJETÉE SANS VALEUR s'il renonce — donc l'enchaînement ci-dessous
     * n'a pas eu à changer, et le renoncement continue de ne rien afficher.
     */
    $scope.retirer = function (acces, event) {
      ConfirmationGroupement.demander({
        titre: "Retirer l'accès",
        texte: 'Cet accès au groupement ' + $scope.groupement.name + ' sera retiré. Le compte '
          + 'n\'est pas supprimé : la personne peut être titulaire d\'une officine par ailleurs, '
          + 'et vous pourrez lui redonner un accès à tout moment.',
        detail: acces.mail,
        confirmer: "Retirer l'accès",
        event: event
      }).then(function () {
        return GroupementAdminService.retirerAcces(acces.id);
      }).then(function () {
        var index = $scope.groupement.acces.indexOf(acces);
        if (index >= 0) {
          $scope.groupement.acces.splice(index, 1);
        }
        toastr.success('Accès retiré.');
      }).catch(function (error) {
        // Le renoncement rejette SANS valeur : ce n'est pas une erreur.
        if (error) {
          toastr.error(messageErreur(error, "L'accès n'a pas pu être retiré."));
        }
      });
    };

    $scope.renvoyerInvitation = function (acces) {
      GroupementAdminService.renvoyerInvitation(acces.id).then(function () {
        toastr.success('Invitation renvoyée à ' + acces.mail + '.');
      }).catch(function (error) {
        toastr.error(messageErreur(error, "L'invitation n'a pas pu être renvoyée."));
      });
    };

    function messageErreur(error, defaut) {
      if (error && error.data && error.data.message) {
        return error.data.message;
      }
      if (error && error.status === 503) {
        return 'Le CRM est momentanément indisponible.';
      }
      return defaut;
    }

    $scope.load();
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('ShareMalfunctionController', ShareMalfunctionController);

  function ShareMalfunctionController($scope, $stateParams, $window, $state, PublicService, PRIORITIES_MALFUNCTION) {
    $scope.malfunction = null;
    $scope.wrongLink = false;
    $scope.PRIORITIES_MALFUNCTION = PRIORITIES_MALFUNCTION;

    if ($stateParams.token != null) {
      PublicService.getSharedMalfunction($stateParams.token).then(function (data) {
        if (data != null) {
          $scope.malfunction = data;
        } else {
          $scope.wrongLink = true;
        }
      }).catch(function (err) {
        $scope.wrongLink = true;
        console.log(err);
      });
    }

    $scope.goHome = function () {
      $state.go('login');
    }

    $scope.downloadMalfunctionAttachment = function () {
      $window.location.href = PublicService.getDownloadLink($stateParams.token);
    };
  };
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('QuestionnaireSatisfactionController', QuestionnaireSatisfactionController);

  function QuestionnaireSatisfactionController($scope, $stateParams, $q, $timeout, $interval, $window, PublicService) {
    var vm = this;

    vm.q1Items = [
      { key: 'visibiliteExterieur', label: 'La visibilité depuis l\'extérieur' },
      { key: 'horairesOuverture', label: 'Les horaires d\'ouverture' },
      { key: 'agencementInterieur', label: 'L\'agencement intérieur' },
      { key: 'tempsAttente', label: 'Le temps d\'attente' },
      { key: 'ecouteDisponibilite', label: 'Notre écoute et notre disponibilité' },
      { key: 'expertiseConseils', label: 'Notre expertise et nos conseils' },
      { key: 'confidentialiteEchanges', label: 'La confidentialité de nos échanges' },
      { key: 'offresPromotionnelles', label: 'Nos offres promotionnelles' },
      { key: 'servicesMisenPlace', label: 'Les services mis en place pour vous aider (si utilisés) : test, vaccination, livraison…' },
      { key: 'reponseAttentesGlobale', label: 'Globalement, avons-nous répondu à vos attentes ?' }
    ];

    vm.q5Options = [
      { key: 'gammesNaturelles', label: 'Vous proposer des gammes naturelles, bio, locales…' },
      { key: 'medicamentsNonUtilises', label: 'Ramener vos médicaments non utilisés à la pharmacie pour qu\'ils soient traités par une filière spécialisée' },
      { key: 'informationRisques', label: 'Vous fournir une information fiable sur les facteurs de risques qui impactent votre santé' },
      { key: 'infosLocales', label: 'Vous communiquer des informations sur les initiatives environnementales locales' },
      { key: 'justeNecessaire', label: 'Vous délivrer le juste nécessaire et vous aider à comprendre et suivre votre traitement' },
      { key: 'sacsUsageUnique', label: 'Supprimer la distribution de sacs à usage unique à la pharmacie' }
    ];

    vm.q6Options = [
      { key: 'petitePlaie', label: 'Petites plaies' },
      { key: 'brulurePremierDegre', label: 'Brûlures 1° degré' },
      { key: 'rhinite', label: 'Rhinites' },
      { key: 'conjonctivite', label: 'Conjonctivites' },
      { key: 'malDeDos', label: 'Mal de dos / douleurs lombaires' },
      { key: 'piqureTique', label: 'Piqûres de tique' },
      { key: 'diarrheesVomissements', label: 'Diarrhées / vomissements' },
      { key: 'mauxDeTete', label: 'Maux de tête' },
      { key: 'brulureEstomac', label: 'Brûlures d\'estomac' },
      { key: 'constipation', label: 'Constipation' },
      { key: 'endometriose', label: 'Endométriose' },
      { key: 'menopause', label: 'Ménopause' },
      { key: 'douleursDentaires', label: 'Douleurs dentaires' }
    ];

    vm.identifier = (($stateParams.identifier || $stateParams.shortIdentifier || '') + '').trim();
    vm.sourceIdentifier = resolveSourceIdentifier($stateParams.source, vm.identifier);
    vm.isPaperSource = vm.sourceIdentifier === 'PAPIER';
    vm.isTabletSource = vm.sourceIdentifier === 'TABLETTE';
    vm.campaignContext = null;
    vm.responseDateMin = null;
    vm.responseDateMax = null;
    vm.datePickers = {
      responseDate: false
    };

    vm.isSubmitting = false;
    vm.hasSubmitted = false;
    vm.successMessage = '';
    vm.errorMessage = '';
    vm.draftSaveTimeout = null;
    vm.draftSaveInFlight = false;
    vm.draftSavePromise = null;
    vm.draftSaveQueued = false;
    vm.lastDraftSavedSignature = null;

    vm.warningQ5 = '';
    vm.warningQ6 = '';
    vm.hasTrackedInteraction = false;

    // Progression de scroll (0 -> 100 %) pour la barre sticky en haut
    vm.scrollProgress = 0;

    vm.countSelected = countSelected;
    vm.onLimitedSelectionChange = onLimitedSelectionChange;
    vm.submit = submit;
    vm.q2Range = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    vm.resetForm = resetForm;
    vm.trackInteraction = trackInteraction;
    vm.scrollToSection = scrollToSection;

    vm.resetForm();
    loadCampaignContext();
    setupScrollProgress();

    $scope.$watch('vm.form', function () {
      if (!vm.form || !vm.hasTrackedInteraction || vm.hasSubmitted || vm.isSubmitting || vm.isPaperSource) {
        return;
      }
      if (!hasAnyAnswer() && !vm.lastDraftSavedSignature && !vm.draftSaveInFlight) {
        return;
      }
      queueDraftSave();
    }, true);

    function hasText(value) {
      return typeof value === 'string' && value.trim().length > 0;
    }

    function generateDraftToken() {
      if ($window.crypto && typeof $window.crypto.randomUUID === 'function') {
        return $window.crypto.randomUUID();
      }

      var template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      return template.replace(/[xy]/g, function (character) {
        var random = Math.random() * 16 | 0;
        var value = character === 'x' ? random : (random & 0x3 | 0x8);
        return value.toString(16);
      });
    }

    function hasAnyAnswer() {
      if (countSelected(vm.form.visitReason) > 0 || hasText(vm.form.visitReasonOther)) {
        return true;
      }

      for (var i = 0; i < vm.q1Items.length; i++) {
        var rating = vm.form.q1[vm.q1Items[i].key];
        if (rating !== null && rating !== undefined) {
          return true;
        }
      }

      if (vm.form.q2 !== null && vm.form.q2 !== undefined) {
        return true;
      }
      if (hasText(vm.form.q3Comments)) {
        return true;
      }
      if (vm.form.q4Recommend === 'Oui' || vm.form.q4Recommend === 'Non') {
        return true;
      }
      if (countSelected(vm.form.q5Selections) > 0 || hasText(vm.form.q5Other)) {
        return true;
      }
      if (countSelected(vm.form.q6Selections) > 0 || hasText(vm.form.q6Other)) {
        return true;
      }
      return !!vm.form.gender || !!vm.form.ageRange || !!vm.form.regularCustomer;
    }

    function buildPayload(isDraft) {
      return {
        draftToken: vm.form.draftToken,
        generatedAt: isDraft ? 'FORM_INTERACTION' : new Date().toISOString(),
        responseDate: isDraft ? null : parseInputDateToEpoch(vm.form.responseDate),
        raisonVisite: {
          choix: buildVisitReasons(),
          autre: (vm.form.visitReasonOther || '').trim()
        },
        question1: angular.copy(vm.form.q1),
        question2: {
          satisfactionGenerale: vm.form.q2 === null || vm.form.q2 === undefined ? null : Number(vm.form.q2)
        },
        question3: {
          commentaires: (vm.form.q3Comments || '').trim()
        },
        question4: {
          recommanderPharmacie: vm.form.q4Recommend
        },
        question5: {
          prioritesEnvironnement: selectedValues(vm.form.q5Selections, vm.q5Options),
          autre: (vm.form.q5Other || '').trim()
        },
        question6: {
          prisesEnChargeUtiles: selectedValues(vm.form.q6Selections, vm.q6Options),
          autre: (vm.form.q6Other || '').trim()
        },
        profil: {
          genre: vm.form.gender,
          trancheAge: vm.form.ageRange,
          clientHabituel: vm.form.regularCustomer
        }
      };
    }

    function queueDraftSave() {
      if (vm.isPaperSource || vm.hasSubmitted || vm.isSubmitting || !vm.identifier || !vm.hasTrackedInteraction) {
        return;
      }
      if (!hasAnyAnswer() && !vm.lastDraftSavedSignature && !vm.draftSaveInFlight) {
        return;
      }
      if (vm.campaignContext && vm.campaignContext.canSubmit === false) {
        return;
      }
      if (vm.draftSaveTimeout) {
        $timeout.cancel(vm.draftSaveTimeout);
      }
      vm.draftSaveTimeout = $timeout(function () {
        vm.draftSaveTimeout = null;
        saveDraft();
      }, 700);
    }

    function saveDraft() {
      if (vm.isPaperSource || vm.hasSubmitted || vm.isSubmitting || !vm.identifier || !vm.hasTrackedInteraction) {
        return $q.when();
      }
      if (!hasAnyAnswer() && !vm.lastDraftSavedSignature && !vm.draftSaveInFlight) {
        return $q.when();
      }
      if (vm.campaignContext && vm.campaignContext.canSubmit === false) {
        return $q.when();
      }

      var payload = buildPayload(true);
      var signature = angular.toJson(payload);
      if (signature === vm.lastDraftSavedSignature) {
        return $q.when();
      }
      if (vm.draftSaveInFlight) {
        vm.draftSaveQueued = true;
        return vm.draftSavePromise || $q.when();
      }

      vm.draftSaveInFlight = true;
      vm.draftSaveQueued = false;
      vm.draftSavePromise = PublicService.submitQuestionnaireSatisfaction(vm.identifier, vm.sourceIdentifier, payload)
        .then(function () {
          vm.lastDraftSavedSignature = signature;
        })
        .catch(function () {
          // On laisse la prochaine interaction réessayer l'enregistrement.
        })
        .finally(function () {
          vm.draftSaveInFlight = false;
          vm.draftSavePromise = null;
          if (vm.draftSaveQueued && !vm.hasSubmitted && !vm.isSubmitting) {
            vm.draftSaveQueued = false;
            queueDraftSave();
          } else {
            vm.draftSaveQueued = false;
          }
        });
      return vm.draftSavePromise;
    }

    function waitForDraftSave() {
      if (!vm.draftSavePromise) {
        return $q.when();
      }
      return vm.draftSavePromise.catch(function () {
        return null;
      });
    }

    function scrollToSection(sectionId) {
      var el = document.getElementById(sectionId);
      if (!el) { return; }
      var mdContent = document.getElementById('content');
      var doc = document.documentElement;
      var rect = el.getBoundingClientRect();
      var offset = 16;
      if (mdContent && mdContent.scrollHeight > mdContent.clientHeight + 2) {
        var contentRect = mdContent.getBoundingClientRect();
        var target = mdContent.scrollTop + (rect.top - contentRect.top) - offset;
        if (typeof mdContent.scrollTo === 'function') {
          mdContent.scrollTo({ top: target, behavior: 'smooth' });
        } else {
          mdContent.scrollTop = target;
        }
      } else if (doc.scrollHeight > doc.clientHeight + 2) {
        var winTarget = window.scrollY + rect.top - offset;
        if (typeof window.scrollTo === 'function') {
          window.scrollTo({ top: winTarget, behavior: 'smooth' });
        } else {
          window.scrollTo(0, winTarget);
        }
      } else if (typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function normalizeToStartOfDay(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return null;
      }
      var normalized = new Date(date.getTime());
      normalized.setHours(0, 0, 0, 0);
      return normalized;
    }

    function isShortIdentifier(identifier) {
      return /^[A-Za-z0-9]{5,6}$/.test((identifier || '').trim());
    }

    function resolveSourceIdentifier(source, identifier) {
      var normalizedSource = ((source || '') + '').trim().toUpperCase();
      if (normalizedSource.length > 0) {
        return normalizedSource;
      }
      if (isShortIdentifier(identifier)) {
        return 'SMS';
      }
      return '';
    }

    function epochToDate(epoch) {
      if (!epoch) {
        return null;
      }
      return normalizeToStartOfDay(new Date(epoch));
    }

    function epochToStartOfDayEpoch(epoch) {
      var normalizedDate = epochToDate(epoch);
      return normalizedDate ? normalizedDate.getTime() : null;
    }

    function setupScrollProgress() {
      // Sample la progression à intervalle régulier (plus fiable que scroll
      // event qui n'est pas toujours émis par md-content d'Angular Material)
      var measure = function () {
        var mdContent = document.getElementById('content');
        var doc = document.documentElement;
        var top = 0, max = 1;
        if (mdContent && mdContent.scrollHeight > mdContent.clientHeight + 2) {
          top = mdContent.scrollTop;
          max = mdContent.scrollHeight - mdContent.clientHeight;
        } else if (doc.scrollHeight > doc.clientHeight + 2) {
          top = doc.scrollTop;
          max = doc.scrollHeight - doc.clientHeight;
        }
        return Math.min(100, Math.max(0, (top / max) * 100));
      };

      $interval(function () {
        var pct = measure();
        if (Math.abs(vm.scrollProgress - pct) > 0.3) {
          vm.scrollProgress = pct;
        }
      }, 150);
    }

    function parseInputDateToEpoch(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        var normalizedDate = normalizeToStartOfDay(value);
        return normalizedDate ? normalizedDate.getTime() : null;
      }
      var date = new Date(value + 'T00:00:00');
      var normalized = normalizeToStartOfDay(date);
      if (!normalized) {
        return null;
      }
      return normalized.getTime();
    }

    function loadCampaignContext() {
      if (!vm.identifier) {
        return;
      }
      PublicService.getQuestionnaireSatisfactionContext(vm.identifier, vm.sourceIdentifier).then(function (context) {
        vm.campaignContext = context;
        vm.responseDateMin = epochToDate(context.dateDebutCampagne);
        vm.responseDateMax = epochToDate(context.dateFinCollecte);
        if (vm.isPaperSource && !vm.form.responseDate) {
          vm.form.responseDate = normalizeToStartOfDay(new Date());
        }
      }).catch(function () {
        vm.campaignContext = null;
      });
    }

    function createDefaultQ1() {
      return {
        visibiliteExterieur: null,
        horairesOuverture: null,
        agencementInterieur: null,
        tempsAttente: null,
        ecouteDisponibilite: null,
        expertiseConseils: null,
        confidentialiteEchanges: null,
        offresPromotionnelles: null,
        servicesMisenPlace: null,
        reponseAttentesGlobale: null
      };
    }

    function createDefaultForm() {
      return {
        draftToken: generateDraftToken(),
        responseDate: vm.isPaperSource ? normalizeToStartOfDay(new Date()) : null,
        visitReason: {
          ordonnance: false,
          sansOrdonnance: false,
          parapharmacie: false,
          vaccinationTestService: false
        },
        visitReasonOther: '',
        q1: createDefaultQ1(),
        q2: null,
        q3Comments: '',
        q4Recommend: null,
        q5Selections: {},
        q5Other: '',
        q6Selections: {},
        q6Other: '',
        gender: null,
        ageRange: null,
        regularCustomer: null
      };
    }

    function resetForm() {
      if (vm.draftSaveTimeout) {
        $timeout.cancel(vm.draftSaveTimeout);
        vm.draftSaveTimeout = null;
      }
      vm.draftSaveInFlight = false;
      vm.draftSavePromise = null;
      vm.draftSaveQueued = false;
      vm.lastDraftSavedSignature = null;
      vm.hasTrackedInteraction = false;
      vm.form = createDefaultForm();
      vm.warningQ5 = '';
      vm.warningQ6 = '';
    }

    function shouldReloadAfterSubmit() {
      return vm.isPaperSource || vm.isTabletSource;
    }

    function countSelected(group) {
      var count = 0;
      angular.forEach(group, function (selected) {
        if (selected) {
          count++;
        }
      });
      return count;
    }

    function onLimitedSelectionChange(groupName, changedKey, max, warningField) {
      var group = vm.form[groupName];
      if (countSelected(group) > max) {
        group[changedKey] = false;
        vm[warningField] = 'Vous pouvez sélectionner au maximum ' + max + ' choix.';
        $timeout(function () {
          vm[warningField] = '';
        }, 2200);
      }
    }

    function selectedValues(group, options) {
      var values = [];
      angular.forEach(options, function (option) {
        if (group[option.key]) {
          values.push(option.label);
        }
      });
      return values;
    }

    function buildVisitReasons() {
      var reasons = [];
      if (vm.form.visitReason.ordonnance) {
        reasons.push('Ordonnance');
      }
      if (vm.form.visitReason.sansOrdonnance) {
        reasons.push('Sans ordonnance, conseil');
      }
      if (vm.form.visitReason.parapharmacie) {
        reasons.push('Parapharmacie');
      }
      if (vm.form.visitReason.vaccinationTestService) {
        reasons.push('Vaccination, test ou autre service');
      }
      return reasons;
    }

    function isTrackableInteractionTarget(target) {
      if (!target) {
        return false;
      }

      var tagName = ((target.tagName || '') + '').toLowerCase();
      if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
        return true;
      }
      if (tagName === 'button' && target.getAttribute('data-note')) {
        return true;
      }
      if (target.closest && target.closest('label.qs26-check, label.qs26-radio')) {
        return true;
      }
      if (target.closest && target.closest('.iv-Input-date-wrapper')) {
        return true;
      }
      return false;
    }

    function trackInteraction($event) {
      if (vm.hasSubmitted || vm.isSubmitting || !vm.identifier) {
        return;
      }
      if (vm.campaignContext && vm.campaignContext.canSubmit === false) {
        return;
      }
      if (!isTrackableInteractionTarget($event && $event.target)) {
        return;
      }

      vm.hasTrackedInteraction = true;
      queueDraftSave();
    }

    function submit() {
      vm.successMessage = '';
      vm.errorMessage = '';

      if (!vm.identifier) {
        vm.errorMessage = 'Identifiant questionnaire manquant dans l\'URL. Merci de vérifier le lien du questionnaire.';
        return;
      }

      if (vm.campaignContext && vm.campaignContext.canSubmit === false) {
        vm.errorMessage = "La campagne n'est pas active actuellement.";
        return;
      }

      if (vm.isPaperSource) {
        var responseDateEpoch = parseInputDateToEpoch(vm.form.responseDate);
        var campaignStartEpoch = vm.campaignContext ? epochToStartOfDayEpoch(vm.campaignContext.dateDebutCampagne) : null;
        var campaignEndEpoch = vm.campaignContext ? epochToStartOfDayEpoch(vm.campaignContext.dateFinCollecte) : null;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (!responseDateEpoch) {
          vm.errorMessage = 'La date de réponse est obligatoire pour la saisie papier.';
          return;
        }
        if (campaignStartEpoch !== null && responseDateEpoch < campaignStartEpoch) {
          vm.errorMessage = 'La date de réponse ne peut pas être antérieure au lancement de la campagne.';
          return;
        }
        if (campaignEndEpoch !== null && responseDateEpoch > campaignEndEpoch) {
          vm.errorMessage = 'La date de réponse doit être comprise dans la période de campagne.';
          return;
        }
        if (responseDateEpoch > today.getTime()) {
          vm.errorMessage = 'La date de réponse ne peut pas être dans le futur.';
          return;
        }
      }

      vm.isSubmitting = true;
      if (vm.draftSaveTimeout) {
        $timeout.cancel(vm.draftSaveTimeout);
        vm.draftSaveTimeout = null;
      }
      vm.draftSaveQueued = false;

      waitForDraftSave().then(function () {
        return PublicService.submitQuestionnaireSatisfaction(vm.identifier, vm.sourceIdentifier, buildPayload(false));
      }).then(function () {
          vm.resetForm();
          vm.hasSubmitted = true;
          vm.successMessage = 'Merci, vos réponses ont bien été envoyées.';
          if (shouldReloadAfterSubmit()) {
            $timeout(function () {
              $window.location.reload();
            }, 3000);
          }
        }).catch(function (response) {
          if (response && response.status === 404) {
            vm.errorMessage = 'Identifiant invalide : pharmacie introuvable.';
          } else if (response && response.status === 400) {
            vm.errorMessage = 'Identifiant invalide ou données du questionnaire incorrectes.';
          } else {
            vm.errorMessage = 'Une erreur est survenue lors de l\'envoi. Merci de réessayer.';
          }
        }).finally(function () {
          vm.isSubmitting = false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('LegalMentionsController', LegalMentionsController);

  function LegalMentionsController($scope, $location, $anchorScroll) {
    $scope.goToHash = function () {
      if($location.hash()){
        var element = document.getElementById($location.hash());
        element.scrollIntoView();
      }
    };
    $scope.goToHash();
    $scope.gotoAnchor = function(anchor) {
      if ($location.hash() !== anchor) {
        $location.hash(anchor);
      } else {
        $anchorScroll();
      }
    };
  }
})();

(function () {
	'use strict';

	angular.module('app.front')
		.factory('OsysVerrou', OsysVerrou)
		.factory('osysVerrouIntercepteur', osysVerrouIntercepteur)
		.config(enregistrerIntercepteur)
		.run(demarrer);

	/**
	 * PHSQ-240 — verrouillage du module après 30 minutes sans activité (§7.6, A11, M27).
	 *
	 * Le serveur fait foi : à l'entrée dans `app.osys.*`, la minuterie se cale sur
	 * `GET verrou/etat` ; à son échéance, elle redemande l'état au lieu de verrouiller d'office
	 * (une autre fenêtre a pu garder le module actif). Les interactions envoient
	 * `POST verrou/activite` au plus une fois par minute, avec un dernier envoi différé pour
	 * qu'une saisie faite pendant la minute compte. Un 423 `VERROUILLE` affiche la surcouche.
	 *
	 * La surcouche est montée dans `<body>`, HORS de la vue : elle ne détruit rien, la saisie en
	 * cours est gardée. Elle couvre la zone de contenu (le menu LQO reste utilisable) ou, si une
	 * fenêtre `$mdDialog` est ouverte, tout l'écran au-dessus d'elle (M27).
	 *
	 * @ngInject
	 */
	function OsysVerrou($rootScope, $timeout, $document, $window, $compile, $injector) {
		var EVENEMENTS = ['mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
		var INTERVALLE_ACTIVITE_MS = 60000;

		var dansModule = false;
		var verrouille = false;
		var minuterie = null;
		var pingDiffere = null;
		var dernierPing = 0;
		var surcouche = null;
		var portee = null;

		function api() {
			return $injector.get('OsysService');
		}

		function estModule(nom) {
			return !!nom && nom.indexOf('app.osys.') === 0;
		}

		// --- Activité -------------------------------------------------------------------------

		function interaction(evenement) {
			if (!dansModule || verrouille || (surcouche && surcouche[0].contains(evenement.target))) {
				return;
			}
			var ecoule = Date.now() - dernierPing;
			if (ecoule >= INTERVALLE_ACTIVITE_MS) {
				// Hors digest (écouteur natif) : $evalAsync en programme un pour que $http parte.
				$rootScope.$evalAsync(ping);
			} else if (!pingDiffere) {
				pingDiffere = $timeout(ping, INTERVALLE_ACTIVITE_MS - ecoule);
			}
		}

		function ping() {
			if (pingDiffere) {
				$timeout.cancel(pingDiffere);
				pingDiffere = null;
			}
			if (!dansModule || verrouille) {
				return;
			}
			dernierPing = Date.now();
			// Un 423 passe par l'intercepteur, qui verrouille.
			api().activite().then(armer).catch(angular.noop);
		}

		function armer(etat) {
			annulerMinuterie();
			if (!etat || etat.verrouille) {
				verrouiller();
				return;
			}
			minuterie = $timeout(verifier, Math.max(1, etat.resteSecondes) * 1000 + 500);
		}

		function verifier() {
			minuterie = null;
			if (dansModule && !verrouille) {
				api().verrouEtat().then(armer).catch(angular.noop);
			}
		}

		function annulerMinuterie() {
			if (minuterie) {
				$timeout.cancel(minuterie);
				minuterie = null;
			}
		}

		// --- Entrée et sortie du module ---------------------------------------------------------

		function entrer() {
			dansModule = true;
			EVENEMENTS.forEach(function (nom) {
				$document[0].addEventListener(nom, interaction, true);
			});
			$window.addEventListener('resize', placer);
			api().verrouEtat().then(function (etat) {
				if (!etat.verrouille) {
					verrouille = false;
					masquer();
				}
				armer(etat);
			}).catch(angular.noop);
		}

		function sortir() {
			dansModule = false;
			EVENEMENTS.forEach(function (nom) {
				$document[0].removeEventListener(nom, interaction, true);
			});
			$window.removeEventListener('resize', placer);
			annulerMinuterie();
			if (pingDiffere) {
				$timeout.cancel(pingDiffere);
				pingDiffere = null;
			}
			masquer();
		}

		// --- Surcouche ---------------------------------------------------------------------------

		function verrouiller() {
			annulerMinuterie();
			verrouille = true;
			if (dansModule) {
				afficher();
			}
		}

		function afficher() {
			if (!surcouche) {
				creer();
			}
			portee.v.visible = true;
			portee.v.pleinEcran = !!$document[0].querySelector('.md-dialog-container');
			placer();
			$timeout(function () {
				var champ = surcouche[0].querySelector('input[type=password]');
				if (champ) {
					champ.focus();
				}
			}, 50);
		}

		function masquer() {
			if (portee) {
				portee.v.visible = false;
				portee.v.erreur = null;
				portee.v.motDePasse = '';
			}
		}

		/** Zone de contenu (sous la barre, à droite du menu), sauf en plein écran. */
		function placer() {
			if (!surcouche || !portee.v.visible) {
				return;
			}
			var style = surcouche[0].style;
			var contenu = $document[0].getElementById('content');
			if (portee.v.pleinEcran || !contenu) {
				style.top = style.left = '0';
				style.width = style.height = '';
				style.right = style.bottom = '0';
				return;
			}
			var r = contenu.getBoundingClientRect();
			style.right = style.bottom = '';
			style.top = r.top + 'px';
			style.left = r.left + 'px';
			style.width = r.width + 'px';
			style.height = r.height + 'px';
		}

		function creer() {
			portee = $rootScope.$new(true);
			portee.v = {
				visible: false,
				pleinEcran: false,
				motDePasse: '',
				erreur: null,
				envoi: false,
				deverrouiller: deverrouiller,
				seDeconnecter: seDeconnecter
			};
			surcouche = $compile(
				'<div class="osy-verrou" ng-show="v.visible" ng-class="{\'osy-verrou--plein-ecran\': v.pleinEcran}"' +
				'     role="dialog" aria-modal="true" aria-labelledby="osy-verrou-titre">' +
				'  <form class="osy-verrou__carte" ng-submit="v.deverrouiller()" novalidate autocomplete="off">' +
				'    <div class="osy-verrou__corps">' +
				'      <span class="osy-verrou__icone"><md-icon md-font-icon="icon-lock-outline" class="s24"></md-icon></span>' +
				'      <h2 id="osy-verrou-titre" class="osy-verrou__titre">Module Triage OSyS verrouillé</h2>' +
				'      <p class="osy-verrou__texte">Pour protéger les données des patients, le module se verrouille après 30 minutes' +
				'        d’inactivité. Le reste de LQO reste ouvert.</p>' +
				'      <label class="osy-verrou__libelle" for="osy-verrou-mdp">Mot de passe du compte Titulaire' +
				'        <span class="osy-requis">*</span></label>' +
				'      <input id="osy-verrou-mdp" class="osy-champ" type="password" autocomplete="current-password"' +
				'             ng-model="v.motDePasse" ng-disabled="v.envoi">' +
				'      <p class="osy-verrou__erreur" role="alert" ng-if="v.erreur">{{v.erreur}}</p>' +
				'    </div>' +
				'    <div class="osy-verrou__actions">' +
				'      <button type="button" class="osy-btn osy-btn--lien" ng-click="v.seDeconnecter()">' +
				'        <md-icon md-font-icon="icon-logout" class="s18"></md-icon> Se déconnecter</button>' +
				'      <button type="submit" class="osy-btn osy-btn--principal" ng-disabled="!v.motDePasse || v.envoi">' +
				'        <md-icon md-font-icon="icon-key" class="s18"></md-icon> Déverrouiller</button>' +
				'    </div>' +
				'  </form>' +
				'</div>')(portee);
			angular.element($document[0].body).append(surcouche);
		}

		function deverrouiller() {
			var v = portee.v;
			if (!v.motDePasse || v.envoi) {
				return;
			}
			v.envoi = true;
			v.erreur = null;
			api().deverrouiller(v.motDePasse).then(function (etat) {
				verrouille = false;
				dernierPing = Date.now();
				masquer();
				armer(etat);
				$rootScope.$broadcast('osys:deverrouille');
			}).catch(function (err) {
				v.motDePasse = '';
				if (err.code === 'DECONNECTE' || err.status === 401) {
					v.erreur = err.message || 'Vous avez été déconnecté.';
					$timeout(versConnexion, 1500);
				} else {
					v.erreur = err.message || 'Déverrouillage impossible.';
				}
			}).finally(function () {
				v.envoi = false;
			});
		}

		function seDeconnecter() {
			$injector.get('UserService').logout().finally(versConnexion);
		}

		/** Rechargement complet : rien du module ne reste en mémoire. */
		function versConnexion() {
			$window.location.href = '/login';
		}

		return {
			demarrer: function () {
				var arreter = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
					var dedans = estModule(toState && toState.name);
					if (dedans && !dansModule) {
						entrer();
					} else if (!dedans && dansModule) {
						sortir();
					}
				});
				$rootScope.$on('$destroy', arreter);
			},
			verrouiller: verrouiller,
			estVerrouille: function () {
				return verrouille;
			}
		};
	}

	/**
	 * Le 423 `VERROUILLE` de n'importe quel appel du module affiche la surcouche ; le rejet suit
	 * son cours, et l'écran se recharge sur `osys:deverrouille`.
	 *
	 * @ngInject
	 */
	function osysVerrouIntercepteur($q, $injector) {
		return {
			responseError: function (rejet) {
				if (rejet && rejet.status === 423 && rejet.data && rejet.data.code === 'VERROUILLE') {
					$injector.get('OsysVerrou').verrouiller();
				}
				return $q.reject(rejet);
			}
		};
	}

	/** @ngInject */
	function enregistrerIntercepteur($httpProvider) {
		$httpProvider.interceptors.push('osysVerrouIntercepteur');
	}

	/** @ngInject */
	function demarrer(OsysVerrou) {
		OsysVerrou.demarrer();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').factory('OsysService', OsysService);

	/**
	 * PHSQ-240 — API /rest/osys. Les refus portent {code, message, champs?, details?} ; la
	 * promesse est rejetée avec {status, code, message, champs, details}.
	 *
	 * Le contexte (compteurs du menu et de l'accueil, habilitations, arbres) est gardé dans
	 * `$rootScope.osysContexte` ; il ne contient aucune donnée patient.
	 *
	 * @ngInject
	 */
	function OsysService($http, $q, $rootScope) {
		var BASE = '/api/rest/osys';

		function appel(methode, url, donnees, params) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE + url,
					method: methode,
					params: angular.extend({ '_v': new Date().getTime() }, params || {}),
					headers: { 'Content-Type': 'application/json;charset=UTF-8' },
					data: donnees
				}).then(function (reponse) {
					resolve(reponse.data);
				}).catch(function (reponse) {
					reject(erreur(reponse));
				});
			});
		}

		function erreur(reponse) {
			var d = (reponse && reponse.data) || {};
			return {
				status: reponse ? reponse.status : 0,
				code: d.code,
				message: d.message,
				champs: d.champs || [],
				details: d.details
			};
		}

		function chargerContexte() {
			return appel('GET', '/contexte').then(function (contexte) {
				$rootScope.osysContexte = contexte;
				$rootScope.$broadcast('osys:contexte', contexte);
				return contexte;
			});
		}

		/** Nombre de patients à rappeler (aujourd'hui et en retard) : pastille du menu, tâche d'accueil. */
		function aRappeler() {
			var c = $rootScope.osysContexte && $rootScope.osysContexte.compteurs;
			return c ? (c.aujourdhui || 0) + (c.enRetard || 0) : 0;
		}

		function ajouterPhoto(triageId, fichier) {
			var donnees = new FormData();
			donnees.append('file', fichier);
			return $q(function (resolve, reject) {
				$http.post(BASE + '/triages/' + triageId + '/photos', donnees, {
					transformRequest: angular.identity,
					headers: { 'Content-Type': undefined }
				}).then(function (reponse) {
					resolve(reponse.data);
				}).catch(function (reponse) {
					reject(erreur(reponse));
				});
			});
		}

		return {
			chargerContexte: chargerContexte,
			aRappeler: aRappeler,
			accepterCgu: function (version) { return appel('POST', '/cgu/accepter', { version: version }); },

			tableauDeBord: function (mois, arbre, page) {
				return appel('GET', '/tableau-de-bord', null, { mois: mois, arbre: arbre, page: page });
			},
			rechercherTriages: function (texte) { return appel('POST', '/triages/recherche', { texte: texte }); },

			rechercherPatients: function (texte, arbreCode) {
				return appel('POST', '/patients/recherche', { texte: texte, arbreCode: arbreCode });
			},
			patient: function (id) { return appel('GET', '/patients/' + id); },
			modifierPatient: function (id, saisie) { return appel('PUT', '/patients/' + id, saisie); },
			triagesDuPatient: function (id) { return appel('GET', '/patients/' + id + '/triages'); },

			creerTriage: function (dto) { return appel('POST', '/triages', dto); },
			triage: function (id) { return appel('GET', '/triages/' + id); },
			redFlags: function (id, codes, aucun) { return appel('PUT', '/triages/' + id + '/red-flags', { codes: codes, aucun: aucun }); },
			reponse: function (id, noeud, valeur) { return appel('PUT', '/triages/' + id + '/reponses', { noeud: noeud, valeur: valeur }); },
			gestes: function (id, codes) { return appel('PUT', '/triages/' + id + '/gestes', { codes: codes }); },
			etape: function (id, etape) { return appel('PUT', '/triages/' + id + '/etape', { etape: etape }); },
			conclusion: function (id, dto) { return appel('PUT', '/triages/' + id + '/conclusion', dto); },
			valider: function (id, verifier) { return appel('POST', '/triages/' + id + '/valider', null, verifier ? { verifier: true } : {}); },
			abandonner: function (id) { return appel('POST', '/triages/' + id + '/abandonner'); },
			retraitConsentement: function (id, dto) { return appel('POST', '/triages/' + id + '/retrait-consentement', dto); },
			transmission: function (id, dto) { return appel('PUT', '/triages/' + id + '/transmission', dto); },

			ajouterPhoto: ajouterPhoto,
			supprimerPhoto: function (id, photoId) { return appel('DELETE', '/triages/' + id + '/photos/' + photoId); },
			urlPhoto: function (id, photoId) { return BASE + '/triages/' + id + '/photos/' + photoId; },
			urlCompteRendu: function (id, version) {
				return BASE + '/triages/' + id + '/compte-rendu' + (version ? '?version=' + version : '');
			},
			urlConsentement: function (patientId, habilitationId) {
				var params = [];
				if (patientId) {
					params.push('patientId=' + patientId);
				}
				if (habilitationId) {
					params.push('habilitationId=' + habilitationId);
				}
				return BASE + '/documents/consentement' + (params.length ? '?' + params.join('&') : '');
			},

			rappel: function (id) { return appel('GET', '/rappels/' + id); },
			tentative: function (id, dto) { return appel('POST', '/rappels/' + id + '/tentatives', dto); },
			cloturer: function (id, dto) { return appel('POST', '/rappels/' + id + '/cloturer', dto); },
			evaluerRappel: function (id, dto) { return appel('POST', '/rappels/' + id + '/evaluer', dto); },
			realiserRappel: function (id, dto) { return appel('POST', '/rappels/' + id + '/realiser', dto); },

			refus: function (dto) { return appel('POST', '/refus', dto); },

			verrouEtat: function () { return appel('GET', '/verrou/etat'); },
			activite: function () { return appel('POST', '/verrou/activite'); },
			deverrouiller: function (motDePasse) { return appel('POST', '/verrou/deverrouiller', { motDePasse: motDePasse }); }
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').factory('OsysVues', OsysVues);

	/**
	 * PHSQ-240 — libellés et petites mises en forme partagées par les écrans du module.
	 *
	 * @ngInject
	 */
	function OsysVues($http, $q, $window, $filter, $timeout) {
		var MOIS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre',
			'Novembre', 'Décembre'];
		var DELAIS = { H2: 'À 2 h', J1: 'J+1', J3: 'J+3', J7: 'J+7', J30: 'J+30' };
		var PRISES_EN_CHARGE = {
			PHARMACIEN: { libelle: 'Officine', type: 'vert' },
			MEDECIN: { libelle: 'Médecin', type: 'orange' },
			URGENCES: { libelle: 'Urgences', type: 'rouge' }
		};
		var date = $filter('date');

		// Libellés des énumérations du back (enums com.webapp.osys.enums), dans leur ordre.
		var LIBELLES = {
			SEXES: { F: 'Femme', H: 'Homme' },
			MOTIFS_SANS_NIR: { ETRANGER: 'Patient étranger', NUMERO_INCONNU: 'Numéro inconnu du patient', AUTRE: 'Autre' },
			TRANCHES_AGE: { MOINS_18: 'Moins de 18 ans', DE_18_A_39: '18 à 39 ans', DE_40_A_64: '40 à 64 ans', PLUS_65: '65 ans et plus' },
			MOTIFS_REFUS: { PREFERE_MEDECIN: 'Préfère consulter son médecin', PAS_LE_TEMPS: 'Pas le temps',
				REFUSE_DONNEES: 'Refuse l\u2019enregistrement de ses données', AUTRE: 'Autre' },
			SANS_SERVICE: { URGENCES: 'Aller aux urgences', ATTENDRE_MEDECIN: 'Attendre une disponibilité médecin',
				MEDECIN_IMMEDIAT: 'Aller de suite chez un médecin', AUTOMEDICATION: 'Automédication seule', AUTRE: 'Autres' },
			POURQUOI: { MEDECIN_INDISPONIBLE: 'Médecin non disponible / consultation trop lointaine',
				PAS_ACCES_URGENCES: 'Non accès aux urgences / hôpital',
				GERABLE_PHARMACIE: 'Pour cette situation, le patient estime la situation gérable en pharmacie / par habitude',
				AUTRE: 'Autres' },
			CONNU: { NE_CONNAISSAIT_PAS: 'Je ne le connaissais pas', AFFICHES: 'Affiches en pharmacie',
				BOUCHE_A_OREILLE: 'Bouche à oreille', PUBLICITE_INTERNET: 'Publicités internet, réseaux sociaux\u2026',
				MEDECIN: 'Communication par le médecin', AUTRE: 'Autres' },
			// Pastille de la colonne « Transmission » de Mes triages.
			MODES_TRANSMISSION_COURTS: { MSSANTE: 'MSSanté', MAIN_PROPRE_DESTINATAIRE: 'En main propre', MAIN_PROPRE_SANS_TRANSMISSION: 'Remis, non transmis',
				AUTRE: 'Autre' },
			MODES_TRANSMISSION: { MSSANTE: 'Par messagerie sécurisée (MSSanté)',
				MAIN_PROPRE_DESTINATAIRE: 'En main propre au patient, à destination de son médecin ou des urgences',
				MAIN_PROPRE_SANS_TRANSMISSION: 'En main propre au patient, qui ne souhaite pas le transmettre', AUTRE: 'Autre' },
			PRISES_EN_CHARGE_DECISION: { PHARMACIEN: 'Pharmacien', MEDECIN: 'Médecin', URGENCES: 'Urgences' }
		};
		/** Catégorie de l'issue proposée → prise en charge correspondante (§7.4). */
		var CORRESPONDANCE = { OFFICINE: 'PHARMACIEN', MEDECIN: 'MEDECIN', URGENCES: 'URGENCES' };

		function memeJour(a, b) {
			return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
		}

		/** « 2027-01 » → « Janvier 2027 ». */
		function libelleMois(mois) {
			if (!mois) {
				return '';
			}
			var p = mois.split('-');
			return MOIS[parseInt(p[1], 10) - 1] + ' ' + p[0];
		}

		/** « aujourd'hui 10:05 », « hier 18:40 » ou « 12/01 09:31 ». */
		function commence(ms) {
			var d = new Date(ms);
			var aujourdhui = new Date();
			var hier = new Date(aujourdhui.getFullYear(), aujourdhui.getMonth(), aujourdhui.getDate() - 1);
			if (memeJour(d, aujourdhui)) {
				return 'aujourd’hui ' + date(ms, 'HH:mm');
			}
			if (memeJour(d, hier)) {
				return 'hier ' + date(ms, 'HH:mm');
			}
			return date(ms, 'dd/MM HH:mm');
		}

		/** Âge en années révolues aujourd'hui, depuis une date ISO « aaaa-mm-jj ». */
		function ans(iso) {
			if (!iso) {
				return null;
			}
			var p = iso.split('-').map(function (x) { return parseInt(x, 10); });
			var t = new Date();
			var n = t.getFullYear() - p[0];
			if (t.getMonth() + 1 < p[1] || (t.getMonth() + 1 === p[1] && t.getDate() < p[2])) {
				n--;
			}
			return n;
		}

		/** « jj/mm/aaaa » → « aaaa-mm-jj », ou null si la date n'existe pas. */
		function dateIso(texte) {
			var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((texte || '').trim());
			if (!m) {
				return null;
			}
			var j = parseInt(m[1], 10);
			var mo = parseInt(m[2], 10);
			var a = parseInt(m[3], 10);
			var d = new Date(a, mo - 1, j);
			if (d.getFullYear() !== a || d.getMonth() !== mo - 1 || d.getDate() !== j) {
				return null;
			}
			return m[3] + '-' + m[2] + '-' + m[1];
		}

		/** Masque de saisie « jj/mm/aaaa » : les barres s'ajoutent toutes seules. */
		function masqueDate(texte) {
			var c = (texte || '').replace(/\D/g, '').slice(0, 8);
			if (c.length > 4) {
				return c.slice(0, 2) + '/' + c.slice(2, 4) + '/' + c.slice(4);
			}
			if (c.length > 2) {
				return c.slice(0, 2) + '/' + c.slice(2);
			}
			return c;
		}

		/** NIR affiché par groupes : « 2 90 09 34 172 055 18 » (Corse : 2A ou 2B en 6e-7e position). */
		function formaterNir(texte) {
			var c = (texte || '').toUpperCase().replace(/[^0-9AB]/g, '').slice(0, 15);
			var groupes = [1, 2, 2, 2, 3, 3, 2];
			var morceaux = [];
			var i = 0;
			groupes.forEach(function (n) {
				if (i < c.length) {
					morceaux.push(c.substr(i, n));
					i += n;
				}
			});
			return morceaux.join(' ');
		}

		/**
		 * Contrôle du NIR, même algorithme que le serveur (ControleNir) : la clé fausse bloque ;
		 * les incohérences avec le sexe ou la date de naissance ne sont que des avertissements
		 * (les NIR provisoires existent, §7.3).
		 */
		function controlerNir(texte, sexe, isoNaissance) {
			var nir = (texte || '').replace(/[\s.]/g, '').toUpperCase();
			var resultat = { erreur: null, avertissements: [] };
			if (nir.length < 15) {
				return nir.length ? { erreur: 'Le NIR compte 15 caractères.', avertissements: [] } : resultat;
			}
			if (!/^[0-9]{5}(2A|2B|[0-9]{2})[0-9]{8}$/.test(nir)) {
				return { erreur: 'Ce NIR n\u2019est pas valide (15 chiffres ; 2A ou 2B pour la Corse).', avertissements: [] };
			}
			var corps = nir.substring(0, 13).replace('2A', '19').replace('2B', '18');
			// 13 chiffres : en deçà de 2^53, le calcul reste exact en nombre JavaScript.
			if (97 - (parseInt(corps, 10) % 97) !== parseInt(nir.substring(13), 10)) {
				return { erreur: 'Ce NIR n\u2019est pas valide (clé incorrecte).', avertissements: [] };
			}
			var premier = nir.charAt(0);
			if ((premier === '1' && sexe === 'F') || (premier === '2' && sexe === 'H')) {
				resultat.avertissements.push('Le 1er chiffre du NIR ne correspond pas au sexe saisi (NIR provisoire possible).');
			}
			if (isoNaissance) {
				if (nir.substring(1, 3) !== isoNaissance.substring(2, 4)) {
					resultat.avertissements.push('L\u2019année de naissance ne correspond pas au NIR.');
				}
				var mois = parseInt(nir.substring(3, 5), 10);
				if (mois >= 1 && mois <= 12 && nir.substring(3, 5) !== isoNaissance.substring(5, 7)) {
					resultat.avertissements.push('Le mois de naissance ne correspond pas au NIR.');
				}
			}
			return resultat;
		}

		/** Tranche d'âge d'un refus, depuis la date de naissance ISO. */
		function trancheAge(iso) {
			var n = ans(iso);
			if (n === null) {
				return null;
			}
			return n < 18 ? 'MOINS_18' : n < 40 ? 'DE_18_A_39' : n < 65 ? 'DE_40_A_64' : 'PLUS_65';
		}

		function erreurBinaire(reponse) {
			var corps = {};
			try {
				corps = angular.fromJson(new $window.TextDecoder('utf-8').decode(reponse.data));
			} catch (e) {
				corps = {};
			}
			return { status: reponse.status, code: corps.code, message: corps.message };
		}

		/**
		 * Ouvre un PDF du module dans un nouvel onglet. L'onglet est ouvert AVANT l'appel, dans le
		 * geste de l'utilisateur, sans quoi le bloqueur de fenêtres l'arrêterait (motif `openPDF`
		 * de folders.controller.js) ; il est refermé si l'appel échoue.
		 */
		function ouvrirPdf(url) {
			var onglet = $window.open('', '_blank');
			return $http.get(url, { responseType: 'arraybuffer', params: { '_v': new Date().getTime() } }).then(function (reponse) {
				var lien = $window.URL.createObjectURL(new $window.Blob([reponse.data], { type: 'application/pdf' }));
				if (onglet) {
					onglet.location = lien;
				} else {
					$window.location.href = lien;
				}
				$timeout(function () {
					$window.URL.revokeObjectURL(lien);
				}, 60000, false);
			}).catch(function (reponse) {
				if (onglet) {
					onglet.close();
				}
				return $q.reject(erreurBinaire(reponse));
			});
		}

		return {
			libelleMois: libelleMois,
			libelleDelai: function (delai) {
				return DELAIS[delai] || delai;
			},
			priseEnCharge: function (code) {
				return PRISES_EN_CHARGE[code] || null;
			},
			commence: commence,
			memeJour: memeJour,
			ouvrirPdf: ouvrirPdf,
			date: function (ms) {
				return ms ? date(ms, 'dd/MM/yyyy') : '';
			},
			heure: function (ms) {
				return date(ms, 'HH:mm');
			},
			/** « lundi 18/01/2027 » (locale fr chargée par index.html). */
			jourEnClair: function (ms) {
				return date(ms, 'EEEE dd/MM/yyyy');
			},
			/** Date du jour au format ISO « aaaa-mm-jj », pour les champs date. */
			aujourdhuiIso: function () {
				return date(new Date(), 'yyyy-MM-dd');
			},
			ans: ans,
			dateIso: dateIso,
			masqueDate: masqueDate,
			formaterNir: formaterNir,
			controlerNir: controlerNir,
			trancheAge: trancheAge,
			libelleSexe: function (code) {
				return LIBELLES.SEXES[code] || '';
			},
			correspondance: function (categorie) {
				return CORRESPONDANCE[categorie] || null;
			},
			LIBELLES: LIBELLES,
			MOTIFS_SANS_NIR: LIBELLES.MOTIFS_SANS_NIR
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').factory('OsysFileEnvoi', OsysFileEnvoi);

	/**
	 * PHSQ-240 — enregistrement en continu de la conclusion : UNE requête en vol au plus. Une
	 * saisie arrivée pendant l'envoi remplace la précédente en attente (seule la dernière compte).
	 * `vider()` résout quand plus rien n'est en vol ni en attente (« Valider » l'attend).
	 *
	 * @ngInject
	 */
	function OsysFileEnvoi($q) {
		return {
			creer: function (envoyer) {
				var enVol = null;
				var enAttente = null;
				var attentes = [];

				function lancer(donnees) {
					enVol = envoyer(donnees).finally(function () {
						enVol = null;
						if (enAttente !== null) {
							var suivante = enAttente;
							enAttente = null;
							lancer(suivante);
						} else {
							attentes.splice(0).forEach(function (d) { d.resolve(); });
						}
					});
					return enVol;
				}

				return {
					envoyer: function (donnees) {
						if (enVol) {
							enAttente = donnees;
							return;
						}
						lancer(donnees);
					},
					vider: function () {
						if (!enVol && enAttente === null) {
							return $q.resolve();
						}
						var d = $q.defer();
						attentes.push(d);
						return d.promise;
					},
					occupe: function () {
						return !!enVol || enAttente !== null;
					}
				};
			}
		};
	}
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('QualiteController', QualiteController);

    function QualiteController($scope, $state, QUALITE_CATEGORIES,$rootScope) {
        $scope.categories = QUALITE_CATEGORIES;

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('app.qualite.' + cat.name);
            }
        }
    };
})();
(function() {
	'use strict';

	angular
		.module('app.front')
		.controller('ProfileController', ProfileController);

	/**
	 * Écran 4 — « Paramètres du compte », allégé (chantier PHSQ-220).
	 *
	 * Il n'affiche plus que le COMPTE CONNECTÉ : son rôle, son courriel de connexion, son mot de
	 * passe masqué, sa dernière connexion. La gestion des trois accès de l'officine a déménagé dans
	 * « Mon officine », avec la liste des personnes du référentiel : les trois comptes ne sont plus
	 * lus ici (`getAccounts()` n'est plus appelé). Le dialogue de modification est inchangé.
	 */
	/** @ngInject */
	function ProfileController($scope, $rootScope, $state, $mdDialog, UserService, toastr) {



		function initAccount() {
			$scope.account = {};
			$scope.error = {};
		};

		/** Le rôle du compte connecté, dans les mots de la maquette. */
		$scope.libelleRole = function () {
			var user = $rootScope.user || {};
			if (user.isTitulaire) {
				return 'Titulaire';
			}
			if (user.isPraq) {
				return 'Responsable Qualité';
			}
			if (user.isTeam) {
				return 'Équipe';
			}
			return user.isAdmin ? 'Administrateur' : '';
		};

		// Le renvoi parle des accès de l'équipe : il mène droit à la sous-page « Accès LQO » (PHSQ-220).
		$scope.goToMonOfficine = function () {
			$state.go('app.officine.acces');
		};

		/**
		 * Ouvre le dialogue existant sur le compte CONNECTÉ. ⚠️ Le compte est recomposé champ par
		 * champ, aux seuls champs d'`AccountDTO` : copier tout `$rootScope.user` enverrait au back
		 * des objets entiers (groupements, droits) qu'il n'attend pas.
		 */
		$scope.openUpdateAccount = function() {
			var user = $rootScope.user || {};
			$scope.account = {
				id: user.id,
				mail: user.mail,
				isTitulaire: !!user.isTitulaire,
				isPraq: !!user.isPraq,
				isTeam: !!user.isTeam
			};
			$scope.accountPopup = $mdDialog.show({
				templateUrl: 'app/main/front/profile/popup/account_dialog.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function() {
				initAccount();
			}).catch(function() {
				initAccount();
			});
		};

		$scope.hidePopup = function() {
			$mdDialog.hide();
		};

		$scope.checkPwdField = function(field) {
			return field != null && field !== '';
		};

    // $scope.deleteAccount = function(account) {
    //   var acc = angular.copy(account);
    //   if(account.isTitulaire || $scope.$root.user.id==account.id){
    //     return;
    //   }
    //   UserService.deleteAccount(acc).then(function(){
    //     console.log('OK')
    //     $scope.getAccounts();
    //   }).catch(function(){

    //   })
    // }
		$scope.updateAccount = function() {
			$scope.error = {};
			UserService.updateAccount($scope.account).then(function() {
				$scope.hidePopup();
				if ($rootScope.user && $rootScope.user.id === $scope.account.id) {
					$rootScope.user.mail = $scope.account.mail;
				}

				toastr.success('Modifié avec succès.');
				initAccount();
			}).catch(function(response) {
				if (response.status == 409 || response.status == 417) {
					$scope.error[response.data.type] = true;
				}
			});
		};
	}
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('PerformancesController', PerformancesController);

    function PerformancesController($scope, $state, PERFORMANCES_CATEGORIES) {
        $scope.categories = PERFORMANCES_CATEGORIES;

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('app.performances.' + cat.name);
            }
        }
    };
})();
(function () {
    "use strict";

    angular.module("app.front").controller("HelpController", HelpController);

    function HelpController(
        $scope,
        $sce
    ) {
        $scope.videos = [
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/1.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/2.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/3.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/4.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/5.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/6.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/7.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/8.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/9.mp4"), type: "video/mp4" }
                ]

            },
            {
                sources: [
                    // Cahier de transmission
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/10.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Traçabilités et nouveaux types de dysfonctionnements
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/11.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Ajouter le LQO en raccourcis bureau
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/12.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Evaluation fournisseurs
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/13.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Notification qualités
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/14.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Présentation V3
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/15.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Présentation des évolutions - 2
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/16.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Planning - Tâches et RDV
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/17.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Planning - Checklist Quotidienne
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/18.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Réunions
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/19.mp4"), type: "video/mp4" }
                ]
            },
            {
                sources: [
                    // Traçabilité
                    { src: $sce.trustAsResourceUrl("/alternatedocroots/20.mp4"), type: "video/mp4" }
                ]
            }
            
        ];
        $scope.config = {
            // sources: {
            //     1:{src: $sce.trustAsResourceUrl("/alternatedocroots/1.mp4"), type: "video/mp4"},
            //     2:{src: $sce.trustAsResourceUrl("/alternatedocroots/2.mp4"), type: "video/mp4"}
            // },
            tracks: [
                {
                    src: "",
                    kind: "subtitles",
                    srclang: "fr",
                    label: "French",
                    default: ""
                }
            ],
            // theme: "/assets/fonts/videogular.scss",
            plugins: {
                poster: ""
            }
        };

    }
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('DecouvrirLqoController', DecouvrirLqoController);

  function DecouvrirLqoController($scope, $mdDialog, $window, toastr, PharmacyService, UserService) {
    var currentPharmacyPromise = null;
    var REDIRECT_AFTER_LQO_ACTIVATION_KEY = 'phsq.redirectAfterLqoActivation';

    $scope.loadingCurrent = false;
    $scope.loadingActivation = false;
    $scope.premiumActivationConfirmed = false;
    $scope.currentPharmacy = null;

    $scope.openCguPopup = function ($event) {
      if ($event) {
        $event.preventDefault();
      }

      $mdDialog.show({
        templateUrl: 'app/main/login/cgu_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true,
        controller: function ($scope, $mdDialog) {
          $scope.showCguActions = false;
          $scope.close = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    function loadCurrentPharmacy() {
      if (currentPharmacyPromise) {
        return currentPharmacyPromise;
      }

      $scope.loadingCurrent = true;
      currentPharmacyPromise = PharmacyService.getCurrent().then(function (response) {
        $scope.currentPharmacy = response && response.data ? response.data : null;
        return $scope.currentPharmacy;
      }).catch(function (error) {
        toastr.error('Impossible de charger votre pharmacie');
        throw error;
      }).finally(function () {
        $scope.loadingCurrent = false;
        currentPharmacyPromise = null;
      });

      return currentPharmacyPromise;
    }

    function showActivatedPopup() {
      return $mdDialog.show({
        templateUrl: 'app/main/front/other/decouvrir-lqo-activated-popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        multiple: true,
        controller: function ($scope, $mdDialog) {
          $scope.close = function () {
            $mdDialog.hide();
          };
        }
      }).then(function () {
        try {
          $window.sessionStorage.setItem(REDIRECT_AFTER_LQO_ACTIVATION_KEY, 'home');
        } catch (error) {
        }
        $window.location.reload();
      });
    }

    $scope.activatePremium = function () {
      if ($scope.loadingActivation || $scope.loadingCurrent) {
        return;
      }

      if (!$scope.premiumActivationConfirmed) {
        toastr.error('Veuillez valider le contrat HDS pour activer le LQO Premium');
        return;
      }

      $scope.loadingActivation = true;
      loadCurrentPharmacy().then(function (pharmacy) {
        if (!pharmacy || !pharmacy.id) {
          throw new Error('Pharmacy is missing');
        }

        pharmacy.contractType = 'LQO';
        return PharmacyService.savePharmacy(pharmacy);
      }).then(function () {
        return UserService.getCurrent();
      }).then(function () {
        return showActivatedPopup();
      }).catch(function (error) {
        if (!(error && error.message === 'Pharmacy is missing')) {
          toastr.error("L'activation du LQO Premium a échoué");
        }
      }).finally(function () {
        $scope.loadingActivation = false;
      });
    };

    loadCurrentPharmacy().catch(angular.noop);
  }
})();

(function () {
	'use strict';

	angular.module('fuse').service('OfficineService', OfficineService);

	/**
	 * Accès à « Mon officine » — servi en direct par le CRM, relayé par LQO (chantier PHSQ-220).
	 *
	 * ⚠️ Aucune donnée n'est gardée ici : chaque affichage rappelle le back, qui rappelle le CRM
	 * (R2). La fraîcheur est celle du référentiel à l'instant où l'on regarde.
	 *
	 * ⚠️ Aucune route ne prend d'identifiant d'officine : le back la déduit du compte connecté. Une
	 * route `…/{reference}/…` laisserait l'appelant choisir l'officine qu'il consulte.
	 *
	 * Les erreurs sont rendues sous une forme unique, `toError()` : c'est elle qui dit au contrôleur
	 * s'il faut basculer sur un écran plein (référentiel indisponible, officine non rapprochée) ou
	 * afficher le message du serveur à l'endroit du geste.
	 */
	/** @ngInject */
	function OfficineService($q, $http) {
		var BASE = '/api/rest/espace-officine';
		// Les mises en forme sont posées telles quelles sur les portées (`$scope.dateLongue = …`) :
		// elles s'appellent entre elles par `service`, jamais par `this`, qui serait alors la portée.
		var service = this;

		var MESSAGE_INDISPONIBLE = 'Données momentanément indisponibles, réessayez dans quelques instants.';
		var MESSAGE_GENERIQUE = 'Une erreur est survenue, veuillez réessayer plus tard.';

		/** Le paramètre anti-cache, comme partout dans LQO. */
		function params() {
			return { '_v': new Date().getTime() };
		}

		function appel(method, url, body) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: method,
					params: params(),
					data: body,
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		/**
		 * Normalise l'échec en `{ status, message, erreur, indisponible, nonRapprochee, conflit,
		 * codeCip, motif, motifRefus }`.
		 *
		 * `motifRefus` : le `details.motif` d'un refus MÉTIER du CRM ou de LQO (`MAIL_INVALIDE`,
		 * `MAIL_AUTRE_OFFICINE`, `ROLE_NON_ATTRIBUABLE`…), qui permet à un formulaire de placer le
		 * message sous le champ en cause. Distinct de `motif`, celui de l'officine non rapprochée.
		 *
		 * Le CODE MACHINE `erreur` est lu AVANT le statut : le front n'a aucun intercepteur global,
		 * et sans ce code il devrait reconnaître une phrase française au mot près.
		 *
		 * - `REFERENTIEL_INDISPONIBLE` (503), ou le navigateur qui n'atteint pas le serveur : l'écran
		 *   entier passe sur « Données momentanément indisponibles » (R24) ;
		 * - `OFFICINE_NON_RAPPROCHEE` (409) : l'écran entier passe sur « appelez PHSQ », avec le code
		 *   CIP et le motif, `inconnu` ou `archivee` (R23) ;
		 * - les autres 409 (R3, R13) : `conflit`, et le message du CRM est affiché TEL QUEL — il est
		 *   écrit pour être lu par l'officine, le front ne le réécrit pas.
		 */
		function toError(response) {
			var status = response ? response.status : 0;
			var data = response && angular.isObject(response.data) ? response.data : {};
			var message = data.message || null;
			var erreur = {
				status: status,
				message: message,
				erreur: data.erreur || null,
				indisponible: false,
				nonRapprochee: false,
				conflit: false,
				motifRefus: data.details && data.details.motif ? data.details.motif : null,
				// Le reste de `details`, pour un formulaire qui en a l'usage : `contactId` d'une personne
				// retirée que l'officine peut faire revenir (MAIL_CONTACT_ARCHIVE, 12/10/2026).
				details: angular.isObject(data.details) ? data.details : null
			};
			if (data.erreur === 'REFERENTIEL_INDISPONIBLE' || status === 503 || status === -1 || status === 0) {
				erreur.indisponible = true;
				erreur.message = message || MESSAGE_INDISPONIBLE;
				return erreur;
			}
			if (data.erreur === 'OFFICINE_NON_RAPPROCHEE') {
				erreur.nonRapprochee = true;
				erreur.codeCip = data.codeCip || null;
				erreur.motif = data.motif === 'archivee' ? 'archivee' : 'inconnu';
				return erreur;
			}
			if (status === 409) {
				erreur.conflit = true;
			}
			if (!erreur.message) {
				erreur.message = status === 401 || status === 403
					? "Vous n'avez pas accès à cet espace."
					: MESSAGE_GENERIQUE;
			}
			return erreur;
		}

		// --------------------------------------------------------------- La fiche et l'adresse

		this.fiche = function () {
			return appel('GET', BASE + '/fiche');
		};

		/** Quatre champs, et eux seuls : rue, complément, code postal, ville. Rend la fiche relue. */
		this.modifierAdresse = function (adresse) {
			return appel('PUT', BASE + '/adresse', {
				rue: adresse.rue,
				adresseSuite: adresse.adresseSuite,
				codePostal: adresse.codePostal,
				ville: adresse.ville
			});
		};

		/** La seule route qui réponde quand le CRM est éteint : le numéro de secours de R23 et R24. */
		this.contactPhsq = function () {
			return appel('GET', BASE + '/contact-phsq');
		};

		// ------------------------------------------------------------ Les personnes et les accès

		/** `{ personnes: [...], acces: { TITULAIRE, PRAQ, EQUIPE } }`, dans l'ordre du CRM. */
		this.personnes = function () {
			return appel('GET', BASE + '/personnes');
		};

		this.ajouterPersonne = function (personne) {
			return appel('POST', BASE + '/personnes', personne);
		};

		this.modifierPersonne = function (contactId, personne) {
			return appel('PUT', BASE + '/personnes/' + encodeURIComponent(contactId), personne);
		};

		/** Le contact principal : une personne active, pourvue d'un courriel (règle du CRM). */
		this.definirPrincipal = function (contactId) {
			return appel('POST', BASE + '/personnes/' + encodeURIComponent(contactId) + '/principal');
		};

		/**
		 * Retirer une personne de la liste — archivée chez PHSQ. `nouveauPrincipalId` est exigé quand
		 * elle est le contact principal : son remplaçant, posé dans le même geste. `transfertAccesA`,
		 * quand elle a un accès PrAQ ou Équipe : la personne à qui le transférer d'abord.
		 */
		this.retirerPersonne = function (contactId, nouveauPrincipalId, transfertAccesA) {
			var corps = {};
			if (nouveauPrincipalId) {
				corps.nouveauPrincipalId = nouveauPrincipalId;
			}
			if (transfertAccesA) {
				corps.transfertAccesA = transfertAccesA;
			}
			return appel('POST', BASE + '/personnes/' + encodeURIComponent(contactId) + '/archiver', corps);
		};

		/** Faire revenir une personne retirée : sa fiche archivée redevient active (12/10/2026). */
		this.reactiverPersonne = function (contactId) {
			return appel('POST', BASE + '/personnes/' + encodeURIComponent(contactId) + '/reactiver');
		};

		/**
		 * Les rôles que l'officine attribue elle-même à ses personnes : `[{ id, libelle, description }]`,
		 * ceux que PHSQ lui a ouverts. Les autres restent sur la personne, en lecture seule.
		 */
		this.rolesContact = function () {
			return appel('GET', BASE + '/roles-contact');
		};

		/** `slot` : `PRAQ` ou `EQUIPE`. Le titre de titulaire ne se donne pas, il se cède. */
		this.donnerAcces = function (contactId, slot) {
			return appel('POST', BASE + '/acces', { contactId: contactId, slot: slot });
		};

		this.retirerAcces = function (slot) {
			return appel('DELETE', BASE + '/acces/' + encodeURIComponent(slot));
		};

		this.renvoyerActivation = function (slot) {
			return appel('POST', BASE + '/acces/' + encodeURIComponent(slot) + '/activation');
		};

		/**
		 * La passation. ⚠️ Le mot de passe ne voyage qu'en CORPS de requête, jamais en paramètre :
		 * une adresse se retrouve dans les journaux et l'historique du navigateur.
		 */
		this.passerLeTitre = function (contactId, motDePasse) {
			return appel('POST', BASE + '/passation', { contactId: contactId, motDePasse: motDePasse });
		};

		// -------------------------------------------------------------- La sortie de groupement

		/** La déclaration ouverte, sinon la dernière close de l'officine, sinon le littéral `null`. */
		this.sortie = function () {
			return appel('GET', BASE + '/sortie');
		};

		this.declarerSortie = function (corps) {
			return appel('POST', BASE + '/sortie', corps);
		};

		this.retirerSortie = function (declarationId) {
			return appel('DELETE', BASE + '/sortie/' + encodeURIComponent(declarationId));
		};

		this.groupements = function () {
			return appel('GET', BASE + '/groupements');
		};

		this.causesSortie = function () {
			return appel('GET', BASE + '/causes-sortie');
		};

		// ------------------------------------------- La sortie de la démarche qualité (PHSQ-220)

		/**
		 * La demande ouverte, quelle que soit son origine ; sinon la dernière close SI l'officine l'a
		 * déposée ; sinon le littéral `null`. Une demande du groupement ou de PHSQ arrive AMPUTÉE
		 * (`id`, `origine`, `etat`, `retraitPossible`), et seulement tant qu'elle est ouverte : c'est
		 * le CRM qui ampute, l'écran lit ce qu'il reçoit (SQ14).
		 */
		this.sortieQualite = function () {
			return appel('GET', BASE + '/sortie-qualite');
		};

		/**
		 * `{ raisonIds, dateSouhaitee, nps, commentaires, engagements }` (contrat § 3.2). Les quatre
		 * engagements valent `true` : le serveur les horodate à la réception et répond 400 s'il en
		 * manque un ; 409 si une demande est déjà ouverte pour l'officine.
		 */
		this.declarerSortieQualite = function (corps) {
			return appel('POST', BASE + '/sortie-qualite', corps);
		};

		this.retirerSortieQualite = function (demandeId) {
			return appel('DELETE', BASE + '/sortie-qualite/' + encodeURIComponent(demandeId));
		};

		/** Le référentiel dédié (Q7) — `[{ id, libelle }]`, actives, dans l'ordre du CRM. */
		this.raisonsSortieQualite = function () {
			return appel('GET', BASE + '/raisons-sortie-qualite');
		};

		// -------------------------------------------------------------------- La mise en forme

		var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août',
			'septembre', 'octobre', 'novembre', 'décembre'];

		/**
		 * « 9 septembre 2026 ». Écrit ici plutôt que confié au filtre `date` : la locale française
		 * d'AngularJS n'est pas chargée partout, et un « September » au milieu d'un écran français
		 * se remarque.
		 */
		this.dateLongue = function (horodatage) {
			if (horodatage === null || angular.isUndefined(horodatage) || horodatage === '') {
				return '';
			}
			var date = new Date(Number(horodatage));
			if (isNaN(date.getTime())) {
				return '';
			}
			return date.getDate() + ' ' + MOIS[date.getMonth()] + ' ' + date.getFullYear();
		};

		/** « 09/09/2026 ». */
		this.dateCourte = function (horodatage) {
			if (horodatage === null || angular.isUndefined(horodatage) || horodatage === '') {
				return '';
			}
			var date = new Date(Number(horodatage));
			if (isNaN(date.getTime())) {
				return '';
			}
			var jour = ('0' + date.getDate()).slice(-2);
			var mois = ('0' + (date.getMonth() + 1)).slice(-2);
			return jour + '/' + mois + '/' + date.getFullYear();
		};

		/**
		 * « 12 octobre 2026 à 14 h 05 » : l'horodatage d'un engagement. Les validations de la sortie
		 * qualité sont horodatées (spécification § 5.1) — la date seule en perdrait la moitié.
		 */
		this.dateHeure = function (horodatage) {
			var jour = service.dateLongue(horodatage);
			if (!jour) {
				return '';
			}
			var date = new Date(Number(horodatage));
			return jour + ' à ' + date.getHours() + ' h ' + ('0' + date.getMinutes()).slice(-2);
		};

		/**
		 * « 2026-10-12 » → « 12 octobre 2026 ». Une date SEULE (contrat : `AAAA-MM-JJ`) se lit sur
		 * ses chiffres : passée par `new Date()`, elle deviendrait minuit UTC et pourrait reculer
		 * d'un jour selon le fuseau du poste.
		 */
		this.dateIso = function (chaine) {
			var morceaux = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(chaine || ''));
			if (!morceaux) {
				return '';
			}
			return Number(morceaux[3]) + ' ' + MOIS[Number(morceaux[2]) - 1] + ' ' + morceaux[1];
		};

		/** Une `Date` du poste → `AAAA-MM-JJ`, sur le jour LOCAL (celui que l'officine a choisi). */
		this.versIso = function (date) {
			if (!angular.isDate(date) || isNaN(date.getTime())) {
				return null;
			}
			return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-'
				+ ('0' + date.getDate()).slice(-2);
		};

		/** Aujourd'hui, en `AAAA-MM-JJ` : la borne basse de la date souhaitée. */
		this.aujourdhuiIso = function () {
			return service.versIso(new Date());
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').factory('OfficineEcran', OfficineEcran);

	/**
	 * Ce que les huit écrans de « Mon officine » ont en commun (chantier PHSQ-220) : l'accueil à
	 * tuiles et ses sept sous-pages se chargent chacun SEUL, mais tous suivent les mêmes règles.
	 *
	 * `sections` : les sept rubriques, en trois sections — la seule définition des tuiles de
	 * l'accueil, de la rangée de mini-tuiles et du bandeau de chaque sous-page (en-tete/).
	 *
	 * Trois « équipements », posés sur la portée du contrôleur :
	 *  - `equiper`          : le chargement et ses écrans pleins (R23, R24), le contact de secours,
	 *                         les mises en forme ;
	 *  - `equiperDemandes`  : la lecture des deux demandes adressées à PHSQ — sortie de groupement et
	 *                         sortie de la démarche qualité —, leurs états et leur retrait ;
	 *  - `equiperPersonnes` : les personnes du référentiel, les trois places LQO et leurs dialogues.
	 *
	 * ⚠️ LES ÉTATS D'ERREUR SONT DES ÉCRANS, PAS DES BANDEAUX. Une officine non rapprochée ou un
	 * référentiel éteint remplacent la page entière : `etatEcran` vaut `chargement`, `normal`,
	 * `indisponible`, `non_rapprochee` ou `erreur`, et rien d'autre n'est rendu hors de `normal`.
	 *
	 * ⚠️ Rien n'est mis en cache (R2) : chaque ouverture rappelle le back, qui rappelle le CRM.
	 */
	/** @ngInject */
	function OfficineEcran($q, $rootScope, $state, $mdDialog, $document, ConfirmationGroupement,
		OfficineService, toastr) {

		// Ni les articles ni la civilité ne font une initiale : « PHARMACIE DES TILLEULS » donne PT.
		var MOTS_SANS_INITIALE = /^(de|des|du|la|le|les|l'|d'|et|m|mme|mlle|mr|dr)\.?$/i;

		function initialesDe(texte) {
			var mots = String(texte || '').split(/[\s._-]+/).filter(function (mot) {
				return /^[a-z0-9À-ÿ]/i.test(mot) && !MOTS_SANS_INITIALE.test(mot);
			});
			if (!mots.length) {
				return '?';
			}
			var initiales = mots[0].charAt(0) + (mots.length > 1 ? mots[mots.length - 1].charAt(0) : '');
			return initiales.toUpperCase();
		}

		// ================================================================ Les rubriques

		var ICONES = 'assets/icons/app/V3/';

		/**
		 * Les sept rubriques de « Mon officine », en trois sections (spécification § 8.1). `couleur`
		 * est l'indice des classes `doc-card--0..2` de la base documentaire : turquoise, bleu, cyan.
		 * `demandes` marque la rubrique qui porte la pastille des demandes ouvertes.
		 */
		var SECTIONS = [
			{
				id: 'officine', titre: 'Mon officine', couleur: 0, rubriques: [
					{ etat: 'app.officine.informations', libelle: 'Informations et adresse', icone: ICONES + 'locaux.svg' },
					{ etat: 'app.officine.contacts', libelle: 'Contacts', icone: ICONES + 'rh.svg' },
					{ etat: 'app.officine.acces', libelle: 'Accès LQO', icone: ICONES + 'accueil.svg' }
				]
			},
			{
				id: 'demarches', titre: 'Mes démarches auprès de PHSQ', couleur: 1, rubriques: [
					{ etat: 'app.officine.sortie', libelle: 'Sortie de groupement', icone: ICONES + 'responsability.svg' },
					{ etat: 'app.officine.sortieQualite', libelle: 'Sortie de la démarche qualité', icone: ICONES + 'quality.svg' },
					{ etat: 'app.officine.demandes', libelle: 'Mes demandes', icone: ICONES + 'mes_documents.svg', demandes: true }
				]
			},
			{
				id: 'aide', titre: "Besoin d'aide ?", couleur: 2, rubriques: [
					{ etat: 'app.officine.contact', libelle: 'Contacter PHSQ', icone: ICONES + 'communication_interne.svg' }
				]
			}
		];

		// Chaque rubrique connaît la couleur de sa section : le bandeau la lit sans remonter à elle.
		SECTIONS.forEach(function (section) {
			section.rubriques.forEach(function (rubrique) {
				rubrique.couleur = section.couleur;
			});
		});

		/** La rubrique d'un état (`app.officine.contacts`…), ou `null`. */
		function rubrique(etat) {
			var trouvee = null;
			SECTIONS.forEach(function (section) {
				section.rubriques.forEach(function (candidate) {
					if (candidate.etat === etat) {
						trouvee = candidate;
					}
				});
			});
			return trouvee;
		}

		// ======================================================================= L'écran

		/**
		 * @param $scope    la portée du contrôleur de l'écran
		 * @param charger   fonction qui lit ce que l'écran affiche et le pose sur la portée ; elle
		 *                  rend une promesse. Son échec bascule l'écran entier.
		 * @param options   `{ contact: false }` pour ne pas lire le contact PHSQ à part (l'écran
		 *                  « Contacter PHSQ » le lit lui-même, c'est tout son contenu)
		 * @return `{ demarrer }`, à appeler une fois la portée prête.
		 */
		function equiper($scope, charger, options) {
			var reglages = angular.extend({ contact: true }, options || {});

			$scope.etatEcran = 'chargement';
			$scope.erreur = null;
			$scope.rapprochement = null;
			$scope.contact = null;
			// L'aide repliable vit dans le bandeau de la sous-page (directive offBandeau).

			$scope.dateLongue = OfficineService.dateLongue;
			$scope.dateCourte = OfficineService.dateCourte;
			$scope.dateHeure = OfficineService.dateHeure;
			$scope.dateIso = OfficineService.dateIso;

			/**
			 * Écrire (adresse, personnes, accès, déclarations) est réservé au titulaire. Aujourd'hui
			 * seul le titulaire ouvre ces écrans, mais la consultation pourra s'ouvrir au PrAQ et à
			 * l'équipe : les boutons suivent déjà la règle.
			 */
			$scope.peutEcrire = function () {
				return !!($rootScope.user && $rootScope.user.isTitulaire);
			};

			/** Le nom du groupement actuel, relu sur la fiche — jamais celui d'une déclaration. */
			$scope.nomGroupement = function () {
				var groupement = $scope.fiche && $scope.fiche.groupement;
				return groupement && groupement.libelle ? groupement.libelle : 'Aucun groupement';
			};

			$scope.initialesOfficine = function () {
				return initialesDe($scope.fiche && $scope.fiche.nom);
			};

			/** Le vert est réservé au statut « Actif » : tout autre statut reste neutre. */
			$scope.statutActif = function () {
				return String(($scope.fiche && $scope.fiche.statut) || '').trim().toLowerCase() === 'actif';
			};

			/** Les deux écrans pleins de R23 et R24, ou le message du serveur pour tout le reste. */
			function basculer(erreur) {
				if (erreur && erreur.nonRapprochee) {
					$scope.rapprochement = { codeCip: erreur.codeCip, motif: erreur.motif };
					$scope.etatEcran = 'non_rapprochee';
					return;
				}
				if (erreur && erreur.indisponible) {
					$scope.etatEcran = 'indisponible';
					return;
				}
				$scope.erreur = erreur || { message: 'Une erreur est survenue, veuillez réessayer plus tard.' };
				$scope.etatEcran = 'erreur';
			}

			$scope.basculer = basculer;

			/**
			 * Le contact PHSQ se charge À PART : c'est la seule route qui réponde CRM éteint, et c'est
			 * précisément sur les écrans d'erreur qu'il sert.
			 */
			function chargerContact() {
				OfficineService.contactPhsq().then(function (contact) {
					$scope.contact = contact && (contact.mail || contact.tel) ? contact : null;
				}).catch(function () {
					$scope.contact = null;
				});
			}

			function lire() {
				$scope.etatEcran = 'chargement';
				$scope.erreur = null;
				return $q.when().then(charger).then(function () {
					$scope.etatEcran = 'normal';
				}).catch(basculer);
			}

			function demarrer() {
				lire();
				if (reglages.contact) {
					chargerContact();
				}
			}

			$scope.reessayer = demarrer;

			return { demarrer: demarrer };
		}

		// ============================================================ Les demandes à PHSQ

		/** Les pastilles d'état des deux demandes : un libellé, une couleur (officine.scss). */
		var PASTILLES = {
			attente: { libelle: 'En attente de traitement', classe: 'off-pastille--attente' },
			encours: { libelle: 'En cours de traitement', classe: 'off-pastille--encours' },
			refusee: { libelle: 'Refusée', classe: 'off-pastille--refus' },
			traitee: { libelle: 'Traitée', classe: 'off-pastille--actif' },
			effective: { libelle: 'Sortie effective', classe: 'off-pastille--actif' },
			annulee: { libelle: 'Annulée', classe: 'off-pastille--annulee' }
		};

		/**
		 * Les deux demandes qu'une officine adresse à PHSQ, telles que le CRM les sert : la
		 * déclaration de sortie de groupement (`sortie`) et la demande de sortie de la démarche
		 * qualité (`sortieQualite`). L'écran les pose lui-même sur la portée au chargement ; il faut
		 * aussi `fiche` (le nom du groupement, `sansGroupement`) et `equiper` au préalable
		 * (`basculer`, `peutEcrire`).
		 *
		 * Le front ne recalcule RIEN : l'état, la date de prise en charge et le retrait possible se
		 * lisent chacun sur leur champ (R13, SQ13).
		 */
		function equiperDemandes($scope) {
			$scope.sortie = null;
			$scope.sortieQualite = null;
			$scope.retrait = { groupement: false, qualite: false };

			/** Une déclaration ouverte : deux états seulement, jamais le nom d'une étape (R9). */
			function pastilleOuverte(demande) {
				return demande && demande.etat === 'EN_ATTENTE' ? PASTILLES.attente : PASTILLES.encours;
			}

			// ------------------------------------------------- La sortie de groupement

			/**
			 * Les états du bloc, déduits ENTIÈREMENT de la fiche et de la déclaration :
			 * - `F` : la déclaration ne vient pas de l'officine (groupement ou PHSQ) ; le back l'a
			 *   amputée (R14, R26), il n'y a rien à reconstituer ;
			 * - `suivi` : une déclaration de l'officine est OUVERTE ;
			 * - `E` : la dernière déclaration de l'officine a été refusée ;
			 * - `B` / `A` : rien en cours — ou une close traitée ou annulée, qui ramène à l'état
			 *   normal (règle P1). `B` si l'officine n'a aucun groupement à quitter (R20).
			 */
			$scope.etatGroupement = function () {
				var sortie = $scope.sortie;
				if (sortie && sortie.origine && sortie.origine !== 'OFFICINE') {
					return 'F';
				}
				if (sortie && !sortie.issue) {
					return 'suivi';
				}
				if (sortie && sortie.issue === 'REFUSEE') {
					return 'E';
				}
				return $scope.fiche && $scope.fiche.sansGroupement ? 'B' : 'A';
			};

			/** Une sortie menée à son terme, que l'officine voit revenir sans groupement. */
			$scope.sortieTraitee = function () {
				return !!($scope.sortie && $scope.sortie.issue === 'TRAITEE');
			};

			/**
			 * La pastille d'état de la sortie de groupement, ou `null` quand rien n'est en cours. Une
			 * déclaration d'un tiers (F) n'a que son état : la pastille ne dit rien de plus.
			 */
			$scope.pastilleGroupement = function () {
				switch ($scope.etatGroupement()) {
					case 'suivi':
					case 'F':
						return pastilleOuverte($scope.sortie);
					case 'E':
						return PASTILLES.refusee;
					case 'B':
						return $scope.sortieTraitee() ? PASTILLES.traitee : null;
					default:
						return null;
				}
			};

			/** Le deuxième jalon : lu sur la date d'attribution, ou à défaut sur l'état. */
			$scope.priseEnCharge = function () {
				var sortie = $scope.sortie;
				return !!(sortie && (sortie.priseEnChargeLe || sortie.etat !== 'EN_ATTENTE'));
			};

			/** Vers le formulaire ; la sous-page de la sortie le redéfinit pour l'ouvrir en place. */
			$scope.declarer = function () {
				$state.go('app.officine.sortie', { nouvelle: true });
			};

			$scope.relireSortie = function () {
				return OfficineService.sortie().then(function (sortie) {
					$scope.sortie = sortie || null;
				}).catch($scope.basculer);
			};

			/**
			 * Retirer sa propre déclaration, tant que personne chez PHSQ ne l'a prise en charge (R13).
			 * Le CRM tranche : si elle vient d'être attribuée, il répond 409 et son message est
			 * affiché tel quel, puis la déclaration est relue.
			 */
			$scope.retirerDeclaration = function (event) {
				if (!$scope.sortie || $scope.retrait.groupement) {
					return;
				}
				var declaration = $scope.sortie;
				ConfirmationGroupement.demander({
					titre: 'Annuler ma déclaration',
					texte: 'Votre déclaration de sortie sera retirée. Votre rattachement reste '
						+ $scope.nomGroupement() + ', et vous pourrez en déposer une nouvelle quand vous le souhaitez.',
					confirmer: 'Annuler ma déclaration',
					annuler: 'Garder ma déclaration',
					danger: true,
					event: event
				}).then(function () {
					$scope.retrait.groupement = true;
					return OfficineService.retirerSortie(declaration.id);
				}).then(function () {
					toastr.success('Votre déclaration a été retirée.');
					return $scope.relireSortie();
				}).catch(function (erreur) {
					if (erreur) {
						toastr.error(erreur.message);
						return $scope.relireSortie();
					}
				}).finally(function () {
					$scope.retrait.groupement = false;
				});
			};

			// ---------------------------------------- La sortie de la démarche qualité

			/**
			 * - `aucune`   : rien à montrer ;
			 * - `tiers`    : déposée par le groupement ou par PHSQ — forme AMPUTÉE, toujours ouverte
			 *                (SQ14, contrat § 3.1) ;
			 * - `suivi`    : celle de l'officine, ouverte ;
			 * - `refusee`, `traitee`, `annulee` : celle de l'officine, close, avec son issue.
			 */
			$scope.etatQualite = function () {
				var demande = $scope.sortieQualite;
				if (!demande) {
					return 'aucune';
				}
				if ((demande.origine && demande.origine !== 'OFFICINE') || angular.isUndefined(demande.deposeeLe)) {
					return 'tiers';
				}
				if (!demande.issue) {
					return 'suivi';
				}
				if (demande.issue === 'REFUSEE') {
					return 'refusee';
				}
				return demande.issue === 'TRAITEE' ? 'traitee' : 'annulee';
			};

			/** La pastille : deux états, puis l'issue (SQ13). Jamais le nom d'une étape. `null` sans demande. */
			$scope.pastilleQualite = function () {
				switch ($scope.etatQualite()) {
					case 'refusee':
						return PASTILLES.refusee;
					case 'traitee':
						return PASTILLES.effective;
					case 'annulee':
						return PASTILLES.annulee;
					case 'aucune':
						return null;
					default:
						// Le libellé d'avant, à l'identique : « En cours » sur EN_COURS seulement.
						return $scope.sortieQualite.etat === 'EN_COURS' ? PASTILLES.encours : PASTILLES.attente;
				}
			};

			$scope.qualitePriseEnCharge = function () {
				var demande = $scope.sortieQualite;
				return !!(demande && (demande.priseEnChargeLe || demande.etat !== 'EN_ATTENTE' || demande.issue));
			};

			/** La demande déposée par l'officine, close ou non : celle dont on montre le détail. */
			$scope.qualiteDetaillee = function () {
				return ['suivi', 'refusee', 'traitee', 'annulee'].indexOf($scope.etatQualite()) >= 0;
			};

			/** Vers le formulaire ; la sous-page de la sortie qualité le redéfinit pour l'ouvrir en place. */
			$scope.demanderSortieQualite = function () {
				$state.go('app.officine.sortieQualite', { nouvelle: true });
			};

			$scope.relireSortieQualite = function () {
				return OfficineService.sortieQualite().then(function (demande) {
					$scope.sortieQualite = demande || null;
				}).catch($scope.basculer);
			};

			/**
			 * Retirer sa demande tant qu'elle n'est pas attribuée (SQ8) : le bouton suit
			 * `retraitPossible`, le CRM tranche (409 si elle vient d'être prise en charge).
			 */
			$scope.retirerDemandeQualite = function (event) {
				if (!$scope.sortieQualite || $scope.retrait.qualite) {
					return;
				}
				var demande = $scope.sortieQualite;
				ConfirmationGroupement.demander({
					titre: 'Retirer ma demande',
					texte: 'Votre demande de sortie de la démarche qualité sera retirée : PHSQ ne la traitera pas. '
						+ 'Vous pourrez en déposer une nouvelle quand vous le souhaitez.',
					confirmer: 'Retirer ma demande',
					annuler: 'Garder ma demande',
					danger: true,
					event: event
				}).then(function () {
					$scope.retrait.qualite = true;
					return OfficineService.retirerSortieQualite(demande.id);
				}).then(function () {
					toastr.success('Votre demande a été retirée.');
					return $scope.relireSortieQualite();
				}).catch(function (erreur) {
					if (erreur) {
						toastr.error(erreur.message);
						return $scope.relireSortieQualite();
					}
				}).finally(function () {
					$scope.retrait.qualite = false;
				});
			};

			// ----------------------------------------------------------- Les deux

			/** La pastille de la tuile « Mes demandes » : les demandes OUVERTES, d'où qu'elles viennent. */
			$scope.demandesEnCours = function () {
				var compte = 0;
				var groupement = $scope.etatGroupement();
				if (groupement === 'suivi' || groupement === 'F') {
					compte++;
				}
				var qualite = $scope.etatQualite();
				if (qualite === 'suivi' || qualite === 'tiers') {
					compte++;
				}
				return compte;
			};
		}

		// ============================================================ Les personnes

		var LIBELLES_ACCES = { TITULAIRE: 'Titulaire', PRAQ: 'Responsable Qualité', EQUIPE: 'Équipe' };

		/**
		 * Les personnes du référentiel PHSQ et les trois places de LQO, lues par
		 * `OfficineService.personnes()` : `{ personnes: [...], acces: { TITULAIRE, PRAQ, EQUIPE } }`.
		 * Il faut `fiche` sur la portée (les dialogues la rappellent en sous-titre).
		 */
		function equiperPersonnes($scope) {
			$scope.personnes = [];
			$scope.personnesReferentiel = [];
			$scope.comptesOrphelins = [];
			$scope.acces = {};
			$scope.places = [];

			/** Le même compte, vu dans la liste et sur une place : par son identifiant LQO, sinon son courriel. */
			function memeCompte(a, b) {
				if (a.userId && b.userId) {
					return a.userId === b.userId;
				}
				return !!(a.mail && a.mail === b.mail && a.acces === b.acces);
			}

			/**
			 * La liste du back est coupée en deux : les personnes du référentiel, dans l'ordre du CRM
			 * (pas de tri ici), puis les comptes LQO qu'aucune d'elles ne réclame (`sansContact`), que
			 * le back range déjà en fin de liste. Les trois places se lisent sur `acces`.
			 *
			 * `comptesOrphelins` ne garde que les comptes sans personne que les trois cartes ne montrent
			 * PAS (décision du PO, 12/10/2026) : un occupant sans personne est déjà sur sa carte, avec la
			 * mention « non rattaché à un contact ». Restent, par exemple, un second compte à la même
			 * adresse, ou un compte qui n'occupe aucune place.
			 */
			$scope.poserPersonnes = function (reponse) {
				$scope.personnes = (reponse && reponse.personnes) || [];
				$scope.acces = (reponse && reponse.acces) || {};
				var occupants = [$scope.acces.TITULAIRE, $scope.acces.PRAQ, $scope.acces.EQUIPE].filter(Boolean);
				$scope.personnesReferentiel = $scope.personnes.filter(function (personne) {
					return !personne.sansContact;
				});
				$scope.comptesOrphelins = $scope.personnes.filter(function (personne) {
					return personne.sansContact && !occupants.some(function (occupant) {
						return memeCompte(personne, occupant);
					});
				});
				$scope.places = [
					{ slot: 'TITULAIRE', libelle: 'Titulaire', description: "Titulaire de l'officine", occupant: $scope.acces.TITULAIRE || null },
					{ slot: 'PRAQ', libelle: 'Responsable Qualité', description: 'Pharmacien Responsable Qualité', occupant: $scope.acces.PRAQ || null },
					{ slot: 'EQUIPE', libelle: 'Équipe', description: 'Collaborateur', occupant: $scope.acces.EQUIPE || null }
				];
			};

			/** Après un geste : on relit la liste, on ne recompose pas l'état local. */
			function rechargerPersonnes() {
				return OfficineService.personnes().then($scope.poserPersonnes).catch(function (erreur) {
					toastr.error(erreur.message);
				});
			}

			/** Sans nom, les initiales se lisent sur le courriel : « m.roux@… » donne MR. */
			$scope.initiales = function (personne) {
				if ($scope.aUnNom(personne)) {
					return initialesDe([personne.prenom, personne.nom].join(' '));
				}
				return initialesDe(String(personne.mail || '').split('@')[0]);
			};

			/** Un contact du référentiel peut n'avoir ni prénom ni nom : la ligne le dit, sans répéter le courriel. */
			$scope.aUnNom = function (personne) {
				return !!(personne && (String(personne.prenom || '').trim() || String(personne.nom || '').trim()));
			};

			$scope.nomPersonne = function (personne) {
				var nom = [personne.prenom, personne.nom].filter(function (morceau) {
					return morceau && String(morceau).trim();
				}).join(' ');
				return nom || personne.mail || 'Personne sans nom';
			};

			/**
			 * Un courriel en deux morceaux, avant et à partir de « @ » : la carte d'une place y place une
			 * coupure possible (`<wbr>`), plutôt que de couper le courriel au milieu d'un mot.
			 */
			$scope.morceauxCourriel = function (mail) {
				var texte = String(mail || '');
				var arobase = texte.indexOf('@');
				return arobase > 0 ? [texte.slice(0, arobase), texte.slice(arobase)] : [texte, ''];
			};

			/** Le compte connecté, repéré par son identifiant LQO et non par le courriel. */
			$scope.estMoi = function (personne) {
				return !!(personne && personne.userId && $rootScope.user && personne.userId === $rootScope.user.id);
			};

			$scope.libelleAcces = function (acces) {
				return LIBELLES_ACCES[acces] || 'Aucun accès';
			};

			/**
			 * L'état affichable d'un compte : `actif`, `attente` (jamais connecté), ou `null`. Un compte
			 * SANS COURRIEL ne reçoit pas d'invitation et ne peut pas se connecter : « Jamais connecté »
			 * ne lui dit rien.
			 */
			$scope.etatCompte = function (personne) {
				if (!personne || !personne.etat) {
					return null;
				}
				if (personne.etat === 'ACTIF') {
					return 'actif';
				}
				return personne.etat === 'JAMAIS_CONNECTE' && personne.mail ? 'attente' : null;
			};

			/** Renvoyer l'invitation : une place PrAQ ou Équipe dont le compte ne s'est jamais connecté. */
			$scope.peutRenvoyer = function (personne) {
				return $scope.peutEcrire() && !!personne && (personne.acces === 'PRAQ' || personne.acces === 'EQUIPE')
					&& $scope.etatCompte(personne) === 'attente';
			};

			/**
			 * La couleur d'un rôle du RÉFÉRENTIEL (« Titulaire », « Responsable qualité »…), lue sur son
			 * libellé : le CRM ne sert que le libellé. Tous les rôles sont NEUTRES : les couleurs
			 * Titulaire / PrAQ / Équipe sont réservées aux accès LQO, pour qu'un rôle de contact ne se
			 * lise pas comme un accès (choix du PO). Seule l'étiquette « principal » garde la sienne.
			 */
			$scope.classeRole = function (role) {
				var libelle = String(role || '').toLowerCase();
				if (libelle.indexOf('principal') >= 0) {
					return 'off-role--principal';
				}
				return 'off-role--contact';
			};

			/**
			 * Le geste d'une ligne. Le titre de titulaire se cède ; une place PrAQ ou Équipe ne se retire
			 * pas d'ici : on la libère en la DONNANT à une autre personne, et le dialogue nomme le compte
			 * remplacé avant de confirmer (décision du 02/10/2026).
			 */
			$scope.actionAcces = function (personne) {
				if (personne.acces === 'TITULAIRE') {
					return 'ceder';
				}
				if (personne.acces || personne.sansContact) {
					return null;
				}
				// « Donner » reste proposé même quand les deux places sont prises : le dialogue nomme
				// l'occupant à remplacer. Sans courriel, aucun accès ne peut partir.
				return personne.mail ? 'donner' : 'sans_courriel';
			};

			function ouvrirDialogue(gabarit, controleur, locaux, event) {
				return $mdDialog.show({
					templateUrl: 'app/main/front/officine/contacts/' + gabarit,
					controller: controleur,
					locals: angular.extend({
						fiche: $scope.fiche,
						acces: $scope.acces,
						personnes: $scope.personnes,
						prefill: null
					}, locaux || {}),
					parent: angular.element($document[0].body),
					targetEvent: event,
					clickOutsideToClose: true,
					escapeToClose: true
				});
			}

			/** Ajouter une personne, ou la corriger (crayon), avec le même dialogue. */
			$scope.ouvrirPersonne = function (personne, event) {
				ouvrirDialogue('nouveau-contact.dialog.html', 'OfficineContactDialogController',
					{ personne: personne || null }, event)
					.then(function (message) {
						toastr.success(message);
						return rechargerPersonnes();
					}).catch(angular.noop);
			};

			/**
			 * Désigner le contact principal (12/10/2026). Il lui faut un courriel : sans, l'étoile reste
			 * grisée et ne fait rien — son infobulle dit pourquoi.
			 */
			$scope.designerPrincipal = function (personne, event) {
				if (!personne.mail || personne.principal || $scope.gesteEnCours) {
					return;
				}
				var actuel = $scope.personnesReferentiel.filter(function (p) {
					return p.principal;
				})[0];
				ConfirmationGroupement.demander({
					titre: 'Changer de contact principal',
					texte: $scope.nomPersonne(personne) + ' deviendra le contact principal de votre officine'
						+ (actuel ? ', à la place de ' + $scope.nomPersonne(actuel) : '')
						+ ' : c\'est la personne que PHSQ joindra en priorité.',
					confirmer: 'Désigner',
					annuler: 'Annuler',
					danger: false,
					event: event
				}).then(function () {
					$scope.gesteEnCours = true;
					return OfficineService.definirPrincipal(personne.contactId);
				}).then(function () {
					toastr.success($scope.nomPersonne(personne) + ' est désormais le contact principal.');
					return rechargerPersonnes();
				}).catch(function (erreur) {
					if (erreur) {
						toastr.error(erreur.message);
					}
				}).finally(function () {
					$scope.gesteEnCours = false;
				});
			};

			/**
			 * Pourquoi une personne ne peut pas être retirée, ou null si elle peut l'être. Seul le titulaire
			 * est concerné : un accès PrAQ ou Équipe se transfère dans la fenêtre de retrait (12/10/2026).
			 */
			$scope.raisonNonRetirable = function (personne) {
				if (personne.acces === 'TITULAIRE') {
					return 'Le titulaire de l\'officine ne peut pas être retiré de la liste : cédez d\'abord le titre';
				}
				return null;
			};

			/**
			 * Retirer une personne de la liste (12/10/2026) : archivée chez PHSQ. Le dialogue fait
			 * choisir le remplaçant quand c'est le contact principal, et la personne à qui transférer son
			 * accès PrAQ ou Équipe. Le titulaire ne se retire pas : le bouton reste grisé.
			 */
			$scope.retirerPersonne = function (personne, event) {
				if ($scope.raisonNonRetirable(personne)) {
					return;
				}
				ouvrirDialogue('retirer-contact.dialog.html', 'OfficineRetirerContactDialogController',
					{ personne: personne, candidats: $scope.personnesReferentiel }, event)
					.then(function (message) {
						toastr.success(message);
						return rechargerPersonnes();
					}).catch(angular.noop);
			};

			/**
			 * Transférer une place occupée à une autre personne de la liste (12/10/2026) : le même compte
			 * LQO change de main — nouveau courriel, mot de passe à créer —, et l'occupant ne peut plus
			 * entrer.
			 */
			$scope.transfererAcces = function (place, event) {
				ouvrirDialogue('transfert-acces.dialog.html', 'OfficineTransfertAccesDialogController',
					{ place: place }, event)
					.then(function (message) {
						toastr.success(message);
						return rechargerPersonnes();
					}).catch(angular.noop);
			};

			/**
			 * Un compte LQO qu'aucune personne de la liste ne réclame : on crée la personne (12/10/2026),
			 * pré-remplie avec le courriel et le nom du compte — la jointure sur le courriel les rattache.
			 */
			$scope.creerContactDepuisCompte = function (personne, event) {
				ouvrirDialogue('nouveau-contact.dialog.html', 'OfficineContactDialogController', {
					personne: null,
					prefill: { mail: personne.mail, prenom: personne.prenomCompte, nom: personne.nomCompte }
				}, event)
					.then(function (message) {
						toastr.success(message);
						return rechargerPersonnes();
					}).catch(angular.noop);
			};

			/** Donner un accès PrAQ ou Équipe à une personne de la liste. */
			$scope.donnerAcces = function (personne, event) {
				ouvrirDialogue('assignation.dialog.html', 'OfficineAssignationDialogController',
					{ personne: personne }, event)
					.then(function (message) {
						toastr.success(message);
						return rechargerPersonnes();
					}).catch(angular.noop);
			};

			/** Céder le titre de titulaire. Au succès, le dialogue déconnecte lui-même. */
			$scope.cederTitre = function (event) {
				ouvrirDialogue('passation.dialog.html', 'OfficinePassationDialogController', {}, event)
					.catch(angular.noop);
			};

			/**
			 * Renvoyer l'invitation à une personne restée « Jamais connecté ». Le courriel est DÉPOSÉ
			 * dans la file d'envoi de LQO : l'écran ne promet pas qu'il est reçu.
			 */
			$scope.renvoyerInvitation = function (personne) {
				if (personne.renvoiEnCours) {
					return;
				}
				personne.renvoiEnCours = true;
				OfficineService.renvoyerActivation(personne.acces).then(function () {
					toastr.success("L'invitation a été renvoyée à " + personne.mail + '.');
				}).catch(function (erreur) {
					toastr.error(erreur.message);
				}).finally(function () {
					personne.renvoiEnCours = false;
				});
			};
		}

		return {
			sections: SECTIONS,
			rubrique: rubrique,
			equiper: equiper,
			equiperDemandes: equiperDemandes,
			equiperPersonnes: equiperPersonnes
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.service('NotificationsService', NotificationsService);

	function NotificationsService($q, $http) {
        var URL_NOTIFICATIONS = "/api/rest/notifications";

		var getNotifications = function() {
			return $q(function (resolve, reject) {
				$http({
					url: URL_NOTIFICATIONS + "/poll",
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
        };
        
        var setNotification = function() {
            return $q(function (resolve, reject) {
				$http({
					url: URL_NOTIFICATIONS + "/printed",
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json; charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
        }

		return {
			getNotifications: getNotifications
		}
	};
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('NotificationsController', NotificationsController);

  /** @ngInject */
  function NotificationsController($scope, $rootScope, $window, NotificationService, NOTIFICATION_TYPES) {
    $scope.NOTIFICATION_TYPES = NOTIFICATION_TYPES;

    $scope.loadMoreNotifs = function (start) {

      if (start === 0) {
        $scope.disable = false;
        $scope.notifications = [];
      }
      if (!$scope.disable) {
        $scope.disable = true;
        NotificationService.find(start).then(function (response) {
          var totalRowsFiltered = response.data.totalRowsFiltered;
          var totalRows = response.data.totalRows;
          if (totalRowsFiltered > 0) {
            $scope.notifications = $scope.notifications.concat(response.data.data);
            if(totalRows > (totalRowsFiltered + start)){
              $scope.disable = false;
            }
          }
        }).catch(function () {
          $scope.disable = true;
        });
      }
    };

    $scope.loadMoreNotifs(0);

    $scope.$on('$destroy', function () {
      if (angular.isArray($scope.notifications)) {
        var ids = [];
        angular.forEach($scope.notifications, function (item) {
          ids.push(item.id);
        });
        NotificationService.viewed(ids).then(function () {
        }).catch(function () {
        });
      }

    });

    $scope.openNotification = function (notification) {
      if (notification.type) {
        $window.location.href = NOTIFICATION_TYPES[notification.type];
      }
    };

    $window.onbeforeunload = function () {
      if (angular.isArray($scope.notifications)) {
        var ids = [];
        angular.forEach($scope.notifications, function (item) {
          ids.push(item.id);
        });
        NotificationService.viewed(ids).then(function () {
          $rootScope.$broadcast('refreshCountNotifs');
        }).catch(function () {
        });
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('MalfunctionsProgressFormsAssociatedController', MalfunctionsProgressFormsAssociatedController);

  function MalfunctionsProgressFormsAssociatedController($scope, EquipeDetailService, FicheProgresService, TachesGeneralesService,
    $state, MalfunctionService, toastr, $mdDialog, $window, GENERAL_TASK_TYPES, TASKS_EVENTS_REMINDERS, GENERAL_TASK_PERIOD, $timeout) {
    $scope.malfunction = null;
    $scope._users = null;
    $scope.intoSaving = false;

    init();

    $scope.openFicheProgres = function (ficheProgres) {
      $scope.ficheProgres = ficheProgres;
      $scope.ficheProgresPopup = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/popup/fiche_progres_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () { }).catch(function () { });
    };

    $scope.addAction = function (ficheProgres, addAgain) {
      if (!$scope._users) {
        EquipeDetailService.getCollaborateurs().then(function (data) {
          $scope._users = data;
        }).catch(function (response) {

        });
      }

      $scope.ficheProgres = angular.copy(ficheProgres);
      $scope._today = new Date();
      $scope.minDateEcheance = angular.copy($scope._today);
      $scope.maxDateEcheance = angular.copy($scope.minDateEcheance);
      $scope.maxDateEcheance.setFullYear();
      $scope.maxDateEcheance.setFullYear($scope._today.getFullYear() + 20);
      $scope._categories = GENERAL_TASK_TYPES;
      $scope.fromFicheProgres = true;
      $scope.echeance = new Date();

      if (!addAgain) {
        $scope._task = {
          progressFormId: ficheProgres.id,
          _echeance: moment($scope._today),
          echeance: $scope._today.getTime()
        };
      }
      for (var i = 0; i < $scope._categories.length; i++) {
        if ($scope._categories[i].value === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
          $scope._task.category = $scope._categories[i].value;
        }
      }
      $scope._recurrences = GENERAL_TASK_PERIOD;
      $scope.reminders = angular.copy(TASKS_EVENTS_REMINDERS);

      //On remplace "1h avant par le jour même"
      // for (var i = 0; i < $scope.reminders.length; i++) {
      //   if ($scope.reminders[i].value === 3600000) {
      //     $scope.reminders[i] = {
      //       name: 'Le jour même',
      //       value: 0
      //     };
      //   }
      // }
      $scope.addTaskPopup = $mdDialog.show({
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          type: "PROGRESS_FORM",
          datasource: {
            task: $scope._task,
            progress_form: $scope.ficheProgres
          },
        },
        controller: "DialogController",
      }).then(function () { }).catch(function () { });
    };

    $scope._save = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;

        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }

        $scope._task.echeance = $scope.echeance.getTime();

        //Reminder: "le jour même"
        if ($scope._task.reminder === 0) {
          var date = new Date($scope._task.echeance);
          date.setHours(0, 0, 0, 0);
          $scope._task.reminder = $scope._task.echeance - date.getTime();
        }

        formData.append('dto', angular.toJson($scope._task));
        TachesGeneralesService.save(formData).then(function (response) {
          $scope._closeDialog();
          $timeout(function () {
            $scope.intoSaving = false;
          });
          if (!!$scope._task.addAgain) {
            $scope.addAction($scope.ficheProgres, true);
          }
        }).catch(function (error) {
          $scope.intoSaving = false;
          console.log(error);
        });
      }

    };

    // Close dialog
    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    $scope.openMalfunction = function () {
      $scope.malfunctionPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/apercu_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: 'ApercuController',
        locals: {
          pj: { type: 'MALFUNCTION', malfunction: $scope.malfunction },
          info: null
        }
      }).then(function () { }).catch(function () { });
    };

    $scope.update = function (ficheProgres) {
      var params = {
        malfunctionId: null,
        ficheProgresId: ficheProgres.id
      };

      if (ficheProgres.malfunction != null) {
        params.malfunctionId = ficheProgres.malfunction.id;
      }
      $state.go('app.fiches-progres.update-fiche-progres', params);
    };

    $scope.openDelete = function (ficheProgres) {
      $scope.ficheProgres = ficheProgres;
      $scope.ficheProgresPopup = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/popup/confirm_delete_fiche_progres_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () { }).catch(function () { });
    };

    $scope.delete = function (ficheProgres) {
      FicheProgresService.delete(ficheProgres.id).then(function (response) {
        $scope._closeDialog();
        init();
      }).catch(function () {
        toastr.error('Une erreur est survenue, veuillez réessayer plus tard.');
      });
    };

    $scope.downloadMalfunctionAttachment = function (id) {
      $window.location.href = '/api/rest/malfunction/download/' + id;
    };

    function init() {
      if (!$state.params.id) {
        $state.go('app.malfunctions');
      }
      MalfunctionService.findDetails($state.params.id).then(function (res) {
        if (!res.data) {
          $state.go('app.malfunctions');
        } else {
          $scope.malfunction = res.data;
        }
      }).catch(function (err) {
        console.log(err);
        toastr.error('Erreur lors de la récupération du dysfonctionnement');
        $state.go('app.malfunctions');
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .filter('malfunctionsFilter', malfunctionsFilter);

  function malfunctionsFilter() {
    return function (items, filter) {
      var filtered = [];
      if (angular.isArray(items)) {
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (angular.isUndefined(filter) || (filter.status === '' && filter.type === '' && filter.priority === '')) {
            filtered.push(item);
          } else if (filter.status !== '' && filter.type !== '') {
            if (item.status === filter.status && item.type != null && item.type.id === parseInt(filter.type)) {
              filtered.push(item)
            }
          } else if (filter.priority !== '' && filter.type !== '') {
            if (item.priority === filter.priority && item.type != null && item.type.id === parseInt(filter.type)) {
              filtered.push(item)
            }
          } else if (filter.status !== '') {
            if (item.status === filter.status) {
              filtered.push(item);
            }
          } else if (filter.type !== '') {
            if (item.type != null && item.type.id === parseInt(filter.type)) {
              filtered.push(item);
            }
          } else if (filter.priority !== '') {
            if (item.priority === filter.priority) {
              filtered.push(item);
            }
          }
        }
      }
      return filtered;
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('MalfunctionsController', MalfunctionsController);

	function MalfunctionsController($scope, $location, PRIORITIES_MALFUNCTION_NAMES, $rootScope, $timeout, $state, $mdDialog, $window, toastr,
		MalfunctionService, BANDEAU_DURATIONS, BANDEAU_CUSTOM_DURATIONS, STATUSES_MALFUNCTION, TYPES_SUPPLIER) {
		if ($rootScope.malfunction != null) {
			$scope.malfunction = $rootScope.malfunction;
		}

		if ($rootScope.fromRDD != null) {
			$scope.fromRDD = $rootScope.fromRDD;
		}

		var MINIMUM_CHARS_SEARCH = 1;
		$scope.malfunctionsSearch = [];

		$scope.searching = false;
		$scope.archiveEmpty = true;
		// if (malfunction != null){
		//   $scope.malfunction = malfunction;
		// }

		$scope.statuses = STATUSES_MALFUNCTION;
		$scope.supplierTypes = TYPES_SUPPLIER;
		$scope.filter = {
			status: '',
			statusValue: '',
			type: '',
			typeValue: '',
			priority: '',
			searchTxt: ''
		};
		$scope.archive = { value: 'none' };
		$scope.archiveMonth = { value: 'none' };
		$scope.archivedMalfunctions = [];
		$scope.priorities = PRIORITIES_MALFUNCTION_NAMES;
		$scope.months = [];
		$scope.type = 'none';

		$scope.tabs = {
			active: true,
			archive: false
		}

		$scope.switchTab = function (tab) {
			$scope.cancelSearch()
			var tabs = Object.keys($scope.tabs)
			for (var i = 0; i < tabs.length; i++) {
				$scope.tabs[tabs[i]] = false;
			}
			$scope.tabs[tab] = true;
			if ($scope.tabs.archive && $scope.archivedMalfunctions.length === 0) {
				$scope.archive.value = 'all'
				$scope.months.length = 0
				$scope.searchArchives('YEAR')
			}
		}

		$scope.searchArchives = function (type) {
			$scope.type = type;
			$scope.archivedMalfunctions = [];
			if (type === 'YEAR') {
				var date = $scope.initStartEnd('YEAR');
				MalfunctionService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
					if ($scope.archive.value === 'all') {
						$scope.archivedMalfunctions = response.data;
						$scope.months = [];
					}
					else if (response.data.length > 10) {
						MalfunctionService.listMonths($scope.archive.value).then(function (months) {
							$scope.months = months.data;
							$scope.archivedMalfunctions = response.data;
						}).catch(function () {
							toastr.error('Impossible de récupérer les dysfonctionnements');
							$scope.months = [];
						})
					} else {
						$scope.archivedMalfunctions = response.data;
						$scope.months = [];
					}

				}).catch(function () {
					toastr.error('Impossible de récupérer les dysfonctionnements');
					$scope.archivedMalfunctions = [];
				});
			}
			else if (type === 'MONTH') {
				if ($scope.archiveMonth.value === 'all') {
					date = $scope.initStartEnd('YEAR');
					MalfunctionService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
						$scope.archivedMalfunctions = response.data;
					}).catch(function () {
						toastr.error('Impossible de récupérer les dysfonctionnements');
					})
				}
				else {
					date = $scope.initStartEnd('MONTH');
					MalfunctionService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
						$scope.archivedMalfunctions = response.data;
					})
				}
			}
		};

		$scope.initStartEnd = function (type) {
			var today = new Date();
			var start = new Date(today.getFullYear(), 0, 1).getTime();
			var end = new Date(today.getFullYear(), 11, 31).getTime();
			if (!isNaN($scope.archive.value) && type === 'YEAR') {
				var year = parseInt($scope.archive.value);
				start = new Date(year, 0, 1).getTime();
				end = new Date(year, 11, 31).getTime();
			}
			else if (type === 'MONTH') {
				var month = $scope.archiveMonth.index;
				if ($scope.archiveMonth.value === 'all') {
					return 'all';
				}
				year = parseInt($scope.archive.value);
				start = new Date(year, month, 1).getTime();
				end = new Date(year, month, 31).getTime();
			}
			return { start: start, end: end };
		}

		$scope.cancelSearch = function () {
			$scope.searching = false;
			$scope.filter.searchTxt = '';
			$scope.malfunctionsSearch = [];
		};

		MalfunctionService.listTypes().then(function (response) {
			$scope.types = response.data;
		}).catch(function () {
			$state.go('app.home');
		});

		$scope.search = function () {
			if ($scope.filter.searchTxt.length >= MINIMUM_CHARS_SEARCH) {
				$scope.searching = true;
				MalfunctionService.search($scope.filter.searchTxt).then(function (res) {
					$scope.malfunctionsSearch = res.data;
				}).catch(function (err) {
					toastr.error('Erreur lors de la recherche');
				});
			} else {
				$scope.searching = false;
			}
		};

		$scope.cancelSearch = function () {
			$scope.searching = false;
			$scope.filter.searchTxt = '';
		};

		$scope.refresh = function () {
			MalfunctionService.listYears().then(function (response) {
				$scope.years = [];
				if (response.data.length === 2) {
					var minYear = new Date(response.data[0].value).getFullYear();
					var maxYear = new Date(response.data[1].value).getFullYear();
					var i = maxYear;
					while (i >= minYear && i <= maxYear) {
						$scope.years.push({
							value: i
						});
						i--;
					}
				} else if (response.data.length === 1) {
					$scope.years.push({
						value: new Date(response.data[0].value).getFullYear()
					});
				} else {

				}
			}).catch(function () {
				$state.go('app.home');
			});
			MalfunctionService.list().then(function (response) {
				$scope.malfunctions = response.data;
			}).catch(function () {

			});

			// COUNT ALL MALFUNCTIONs BY FILTERs
			MalfunctionService.counts().then(function (response) {
				var data = response.data;
				$scope.counts = {};

				for (var k = 0; k < data.length; k++) {
					$scope.counts[data[k].type] = {};
					for (var l = 0; l < data[k].values.length; l++) {
						$scope.counts[data[k].type][Object.keys(data[k].values[l])[0]] = data[k].values[l][(Object.keys(data[k].values[l])[0])];
					}
				}

			}).catch(function (error) {
				console.log('error : ' + error)
			});

			MalfunctionService.hasArchived().then(function (response) {
				$scope.archiveEmpty = response.data === "false" ? true : false;
				if (!$scope.archiveEmpty) {
					$scope.searchArchives($scope.type);
				}
			}).catch(function () {
				$scope.archiveEmpty = true;
			})
		};
		$scope.refresh();

		$scope.countFilter = function (filter, value) {

			if ($scope.counts) {
				if (filter == 'type') {
					var filterStatusValue = $scope.filter.status != '' ? $scope.filter.status : ($scope.filter.priority != '' ? $scope.filter.priority : false);
					switch (value) {
						case 'all':
							return (filterStatusValue ? $scope.counts.all[filterStatusValue] : $scope.counts.all.all);

						default:
							return (filterStatusValue ? $scope.counts[value][filterStatusValue] : $scope.counts[value].all);
					}
				}
				else if (filter == 'status') {
					var filterStatusValue = $scope.filter.typeValue != '' ? $scope.filter.typeValue : false;

					switch (value) {
						case 'all':
							return (filterStatusValue ? $scope.counts[filterStatusValue].all : $scope.counts.all.all);
						case 'NOT_OPEN':
							return (filterStatusValue ? $scope.counts[filterStatusValue].NOT_OPEN : $scope.counts.all.NOT_OPEN);
						case 'IN_PROGRESS':
							return (filterStatusValue ? $scope.counts[filterStatusValue].IN_PROGRESS : $scope.counts.all.IN_PROGRESS);
						case 'HIGH':
							return (filterStatusValue ? $scope.counts[filterStatusValue].HIGH : $scope.counts.all.HIGH);
						case 'NORMAL':
							return (filterStatusValue ? $scope.counts[filterStatusValue].NORMAL : $scope.counts.all.NORMAL);
						case 'LOW':
							return (filterStatusValue ? $scope.counts[filterStatusValue].LOW : $scope.counts.all.LOW);
						default:
							return (filterStatusValue ? $scope.counts[filterStatusValue].all : $scope.counts.all.all);
					}
				}
			}
		}

		function initMalfunction() {
			$scope.malfunction = {};
		}

		$scope.openAddMalfunction = function () {
			$state.go('app.malfunctions.add');
		};

		$scope.openMalfunction = function (malfunction, addCommentMode, shareMode) {
			$scope.malfunction = malfunction;
			if (malfunction.status === $scope.statuses.NOT_OPEN && !$rootScope.user.isTeam) {
				MalfunctionService.setOpened(malfunction.id).then(function (response) {
					//malfunction.status = $scope.statuses.NOT_READ;
					$rootScope.$broadcast('refreshCountNotifs');
					$scope.refresh();
				}).catch(function (response) {

				});
			}
			$scope.malfunctionPopup = $mdDialog.show({
				templateUrl: 'app/main/front/home/popup/apercu_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				controller: 'ApercuController',
				locals: {
					pj: { type: 'MALFUNCTION', malfunction: malfunction, fromMalfunction: true, addCommentMode: addCommentMode, shareMode: shareMode },
					info: null
				}
			}).then(function () {
				initMalfunction();
			}).catch(function () {
				initMalfunction();
			});
		};

		$scope.openDelete = function (malfunction, deleteAll) {
			$scope.malfunction = angular.copy(malfunction);
			if (!!deleteAll) {
				$scope.disableSwitch = true;
			}
			$scope.malfunction._deleteAll = !!deleteAll;
			$scope.malfunctionPopup = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/popup/confirm_delete_malfunction_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {
				initMalfunction();
			}).catch(function () {
				initMalfunction();
			});
		};

		$scope.setArchived = function (malfunction) {
			MalfunctionService.setArchived(malfunction.id).then(function (response) {
				$scope.hidePopup();
				$scope.refresh();
			}).catch(function (response) {

			});
		};

		$scope.update = function (malfunction) {
			$state.go('app.malfunctions.update', {
				id: malfunction.id
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.delete = function (malfunction) {
			MalfunctionService.remove(malfunction.id, malfunction._deleteAll).then(function (response) {
				$scope.hidePopup();
				$rootScope.$broadcast('refreshCountNotifs');
				$scope.refresh();
			}).catch(function () {
				toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
			});
		};

		$scope.setFilter = function (property, typeLevel, value) {
			if (property === 'priority') {
				$scope.filter.status = '';
				$scope.filter["statusValue"] = value;
			} else if (property === 'status') {
				$scope.filter.priority = '';
				$scope.filter["statusValue"] = value;
			} else {
				// $scope.filter["formatName"] = value.toUpperCase().replace(/ /g, '_');
				$scope.filter["typeValue"] = value;
			}

			$scope.filter[property] = typeLevel;
		};
		if ($state.params.status === 'NOT_OPEN') {
			$scope.setFilter('status', 'NOT_OPEN', 'Non Lus')
		}
		if ($state.params.tab === 'archive') {
			$scope.switchTab('archive')
			$location.search('tab', null)
		}

		$scope.openActivate = function (malfunction) {
			if (malfunction.automaticallyClosed) {
				toastr.error('Vous ne pouvez pas désarchiver ce dysfonctionnement car ses fiches de progrès associées sont clôturées.');
				return;
			}
			$scope.malfunction = malfunction;
			$scope.malfunctionPopup = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/popup/confirm_activate_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {
				initMalfunction();
			}).catch(function () {
				initMalfunction();
			});
		};

		$scope.activate = function (malfunction) {
			MalfunctionService.activate(malfunction.id).then(function () {
				$scope.hidePopup();
				$scope.refresh();
			}).catch(function () {
				toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
			});
		};

		$scope.openProgressForm = function (malfunction) {
			$scope.hidePopup();
			$state.go('app.malfunctions.add-fiche-progres', {
				malfunctionId: malfunction.id
			});
		};

		$scope.openShareMalfunctionPopup = function (malfunction) {
			$scope.malfunctionToShare = malfunction;
			$scope.sharedMalfunction = malfunction;
			$scope.linkCopied = false;
			$scope.displayDisable = false;
			$scope.linkDisabled = false;
			if (malfunction.token) {

				$scope.malfunctionToShare.link = $scope.getShareLink($scope.malfunctionToShare.token);
				$scope.openMalfunction($scope.malfunctionToShare, undefined, true)

				$scope.sharedMalfunction = {
					id: malfunction.id
				};

			} else {
				MalfunctionService.shareMalfunction($scope.sharedMalfunction).then(function (data) {
					$scope.malfunctionToShare.token = data;
					$scope.malfunctionToShare.link = $scope.getShareLink($scope.malfunctionToShare.token);

					$scope.sharedMalfunction = {
						id: $scope.malfunctionToShare.id
					};
					$scope.openMalfunction($scope.malfunctionToShare, undefined, true)
				}).catch(function (err) {
					console.log(err);
				});
			}

		};

		$scope.setCustomDurationMode = function () {
			$scope.customDurationMode = !$scope.customDurationMode;
		}

		$scope.getShareLink = function (token) {
			return $location.protocol() + "://" + $location.host() + "/shareMalfunction/" + token;
		}

		$scope.addToODJ = function (malfunction) {
			if (malfunction.id != null) {
				MalfunctionService.addToODJ(malfunction.id).then(function (res) {
					toastr.success("Dysfonctionnement ajouté à l'ordre du jour");
				}).catch(function (err) {
					console.log(err);
					toastr.error("Problème lors de l'ajout à l'ordre du jour");
				})
			} else {
				toastr.error("Problème lors de l'ajout à l'ordre du jour");
			}
		}

		$scope.openProgressFormAssociated = function (malfunction) {
			$state.go('app.malfunctions.progress_forms_associated', { id: malfunction.id });
		}

		$scope.downloadMalfunctionAttachment = function (id) {
			$window.location.href = '/api/rest/malfunction/download/' + id;
		};

		$scope.openExport = function () {
			$scope.exportDates = {}
			$scope.expPopup = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/popup/export.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				controller: MalfunctionsController,
				preserveScope: true
			}).then(function () {
			}).catch(function () {
			});
		};

		$scope.export = function () {
			if ($scope.loadingExport) {
				return;
			}
			$scope.loadingExport = true;
			MalfunctionService.downloadXlsx($scope.exportDates.startDate.getTime(), $scope.exportDates.endDate.getTime()).then(function () {
				$scope.loadingExport = false;
				$mdDialog.hide();
			}).catch(function () {
				$scope.loadingExport = false;
				toastr.error('Une erreur est survenue.');
			});

		};

		$scope.openInfosMalfunctionsPopup = function () {
			$scope.folderPopup = $mdDialog.show({
				templateUrl: 'app/main/front/malfunctions/popup/infos_malfunctions_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			});
		};

	};
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('MalfunctionService', MalfunctionService);

  function MalfunctionService($q, $http) {

    var list = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var counts = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/counts",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var search = function (searchTxt) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/search",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'searchTxt': searchTxt
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var save = function (fmData) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: { "Content-Type": undefined },
          data: fmData
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listTypes = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/types",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setOpened = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/setOpen/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var find = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findDetails = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/details/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };


    var update = function (fmData) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          data: fmData
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var remove = function (id, deleteAll) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime(),
            'deleteAll': deleteAll
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var setArchived = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/desactivate/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listYears = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/years",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listMonths = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/months/" + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var hasArchived = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/hasArchived",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listArchived = function (property, start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/archived",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'property': property,
            'start': start,
            'end': end
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var activate = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/activate/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var findByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/list/" + page + "/" + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var shareMalfunction = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/share",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var disableShareMalfunction = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/disableShare",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var addToODJ = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/addToODJ/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var addToRDD = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/addToRDD/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }


    var saveType = function (type) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/saveType/",
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
            'name': type.name,
            'id': type.id
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var deleteType = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/deleteType/" + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime(),
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var countByType = function (typeid) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/countByType/" + typeid,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getDownloadLink = function (id) {
      return "/api/rest/malfunction/download/" + id;
    };

    var downloadXlsx = function (start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/malfunction/export',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'start': start,
            'end': end
          },
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', 'dysfonctionnements.xlsx');
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject();
        });
      });
    };

    var getPagination = function (pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/paginated",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var addComment = function (id, dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/malfunction/" + id + "/comment",
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      list: list,
      counts: counts,
      save: save,
      listTypes: listTypes,
      setOpened: setOpened,
      find: find,
      update: update,
      remove: remove,
      setArchived: setArchived,
      listYears: listYears,
      listMonths: listMonths,
      hasArchived: hasArchived,
      listArchived: listArchived,
      activate: activate,
      findByPharmacyAndPage: findByPharmacyAndPage,
      shareMalfunction: shareMalfunction,
      addToODJ: addToODJ,
      addToRDD: addToRDD,
      disableShareMalfunction: disableShareMalfunction,
      findDetails: findDetails,
      search: search,
      saveType: saveType,
      deleteType: deleteType,
      countByType: countByType,
      getDownloadLink: getDownloadLink,
      downloadXlsx: downloadXlsx,
      getPagination: getPagination,
      addComment: addComment
    }
  };
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('MalFichesfunctionsController', MalFichesfunctionsController);

    function MalFichesfunctionsController($rootScope, $scope, $state, MAL_FICHES_CATEGORIES) {
        if($rootScope.user && $rootScope.user.isMini){
            $scope.isMini = true;
            $scope.categories = MAL_FICHES_CATEGORIES.filter(function(cat){
                if(cat.name != 'controle.trace'){
                    return cat;
                }
            });
        }
        else{
            $scope.isMini = false;
            $scope.categories = MAL_FICHES_CATEGORIES;
        }

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('app.' + cat.name);
            }
        }
    };
})();
(function () {
	'use strict';

	angular
		.module('app.front')
		.filter('fichesProgresFilter', fichesProgresFilter);

	function fichesProgresFilter() {		
		return function (items, filter) {
			var filtered = [];
			if (angular.isArray(items)) {
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (angular.isUndefined(filter) || filter.type === '' || angular.isUndefined(item)) {
						filtered.push(item);
					} else if (filter.type !== '') {
						if (item.type != null && item.type.id === parseInt(filter.type)) {
							filtered.push(item)
						}
					} 
				}
			}
			return filtered;
		};
	}
})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('FichesProgresController', FichesProgresController);

  function FichesProgresController($rootScope, $scope, $state, $timeout, $mdDialog, toastr, MalfunctionService, FicheProgresService, TachesGeneralesService, EquipeDetailService, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD, TASKS_EVENTS_REMINDERS) {
    $scope.filter = {
      type: '',
      value: ''
    };
    $scope.archive = { value: 'all' };
    $scope.archiveMonth = { value: 'all', index: 0 };
    $scope.months = [];

    var MINIMUM_CHARS_SEARCH = 1;
    $scope.searchResults = [];

    $scope.intoSaving = false;
    $scope.searching = false;
    $scope.searchTxt = '';
    $scope.archiveEmpty = true;
    $scope.type = 'none';
    $scope.datepicker = {
      isOpen: false
    };

    $scope.tabs = {
      active: true,
      archive: false
    }

    $scope.search = function () {
      if ($scope.searchTxt.length >= MINIMUM_CHARS_SEARCH) {
        $scope.searching = true;
        FicheProgresService.search($scope.searchTxt, !$scope.tabs.archive).then(function (res) {
          $scope.searchResults = res.data;
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de la recherche');
        });
      } else {
        $scope.searching = false;
      }
    };

    $scope.cancelSearch = function () {
      $scope.searching = false;
      $scope.searchTxt = '';
    };

    function initMalfunction() {
      $scope.malfunction = {};
    }

    function initFicheProgres() {
      $scope.ficheProgres = {};
    }

    EquipeDetailService.getCollaborateurs().then(function (data) {
      $scope._users = data;
    }).catch(function (response) {

    });

    $scope.onEcheanceChange = function (object) {
      object.echeance = object._echeance.valueOf();
    };

    $scope.addAction = function (ficheProgres, addAgain) {
      $state.params.actionFromProgressForm = null;
      $scope.ficheProgres = angular.copy(ficheProgres);
      $scope._today = new Date();
      $scope.minDateEcheance = angular.copy($scope._today);
      $scope.maxDateEcheance = angular.copy($scope.minDateEcheance);
      $scope.maxDateEcheance.setFullYear();
      $scope.maxDateEcheance.setFullYear($scope._today.getFullYear() + 20);
      $scope._categories = GENERAL_TASK_TYPES;
      $scope.fromFicheProgres = true;
      $scope.echeance = new Date();

      if (!addAgain) {
        $scope._task = {
          progressFormId: ficheProgres.id,
          _echeance: moment($scope._today),
          echeance: $scope._today.getTime()
        };
      }
      for (var i = 0; i < $scope._categories.length; i++) {
        if ($scope._categories[i].value === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
          $scope._task.category = $scope._categories[i].value;
        }
      }
      $scope._recurrences = GENERAL_TASK_PERIOD;
      $scope.reminders = angular.copy(TASKS_EVENTS_REMINDERS);

      showTaskModal();

    };

    function showTaskModal($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
        locals: {
          type: "PROGRESS_FORM",
          datasource: {
            task: $scope._task,
            progress_form: $scope.ficheProgres
          },
        },
        controller: "DialogController"
      }).then(function () {
        $scope.refresh();
      }).catch(function () {

      });
    }

    if ($state.params.actionFromProgressForm != null) {
      $scope.addAction(angular.copy($state.params.actionFromProgressForm));
    }

    $scope.searchArchives = function (type) {
      $scope.type = type;
      $scope.archivedFichesProgres = [];
      if (type === 'YEAR') {
        var date = $scope.initStartEnd('YEAR');
        //When loading the page
        $scope.archive.value = $scope.archive.value == 'none' ? new Date().getFullYear() : $scope.archive.value;
        FicheProgresService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
          if (response.data.length > 0) {
            $scope.archiveEmpty = false;
          }
          else {
            $scope.archiveEmpty = true;
          }

          if ($scope.archive.value === 'all') {
            $scope.archivedFichesProgres = response.data;
            $scope.months = [];
          }
          else if (response.data.length > 10) {
            FicheProgresService.listMonths($scope.archive.value).then(function (months) {
              $scope.archivedFichesProgres = response.data;
              $scope.months = months.data;
            }).catch(function (e) {
              console.log('error : ' + e)
              toastr.error('Impossible de récupérer les dysfonctionnements');
              $scope.months = [];
            })
          }
          else {
            $scope.archivedFichesProgres = response.data;
            $scope.months = [];
          }

        }).catch(function (e) {
          console.log('error : ' + e)
          toastr.error('Impossible de récupérer les dysfonctionnements');
          $scope.archivedFichesProgres = [];
        });
      }
      else if (type === 'MONTH') {
        if ($scope.archiveMonth.value === 'all') {
          date = $scope.initStartEnd('YEAR');
          FicheProgresService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
            $scope.archivedFichesProgres = response.data;
          }).catch(function () {
            toastr.error('Impossible de récupérer les dysfonctionnements');
          })
        }
        else {
          date = $scope.initStartEnd('MONTH');
          FicheProgresService.listArchived($scope.archive.value, date.start, date.end).then(function (response) {
            $scope.archivedFichesProgres = response.data;
          })
        }
      }
    };



    $scope.initStartEnd = function (type) {
      var today = new Date();
      var start = new Date(today.getFullYear(), 0, 1).getTime();
      var end = new Date(today.getFullYear(), 11, 31).getTime();
      if (!isNaN($scope.archive.value) && type === 'YEAR') {
        var year = parseInt($scope.archive.value);
        start = new Date(year, 0, 1).getTime();
        end = new Date(year, 11, 31).getTime();
      }
      else if (type === 'MONTH') {
        var month = $scope.archiveMonth.index;
        if ($scope.archiveMonth.value === 'all') {
          return 'all';
        }
        year = parseInt($scope.archive.value);
        start = new Date(year, month, 1).getTime();
        end = new Date(year, month, 31).getTime();
      }
      return { start: start, end: end };
    }

    MalfunctionService.listTypes().then(function (response) {
      $scope.types = response.data;
    }).catch(function () {
      $state.go('app.home');
    });

    $scope.mapActionFiche = new Map();

    $scope.refresh = function () {
      // COUNT ALL MALFUNCTIONs BY FILTERs
      FicheProgresService.counts().then(function (response) {
        var data = response.data;
        $scope.counts = {};
        for (var k = 0; k < data.length; k++) {
          $scope.counts[data[k].type] = {};
          for (var l = 0; l < data[k].values.length; l++) {
            $scope.counts[data[k].type][Object.keys(data[k].values[l])[0]] = data[k].values[l][(Object.keys(data[k].values[l])[0])];
          }
        }
      }).catch(function (error) {
        console.log('error : ' + error)
      });

      FicheProgresService.listYears().then(function (response) {
        $scope.years = [];
        if (response.data.length === 2) {
          var minYear = new Date(response.data[0].value).getFullYear();
          var maxYear = new Date(response.data[1].value).getFullYear();
          var i = maxYear;
          while (i >= minYear && i <= maxYear) {
            $scope.years.push({
              value: i
            });
            i--;
          }
        } else if (response.data.length === 1) {
          $scope.years.push({
            value: new Date(response.data[0].value).getFullYear()
          });
        } else {

        }
      }).catch(function () {
        $state.go('app.home');
      });
      FicheProgresService.list().then(function (response) {
        $scope.fichesProgres = response.data;
        $scope.fichesProgres.forEach(function (element) {
          FicheProgresService.getTacheByProgressId(element.id).then(function (response) {
            var dateEcheance = response.data.echeance;
            var responsable = response.data.responsable.name + ' ' + response.data.responsable.surname;
            var infos = {
              date: new Date(dateEcheance).toLocaleDateString(),
              responsable: responsable
            };
            $scope.mapActionFiche.set(element.id, infos);
          })
            .catch(function (res) {
              //console.log(res);
            });

        });
      }).catch(function () {
        $state.go('app.home');
      });

      FicheProgresService.hasArchived().then(function (response) {
        $scope.archiveEmpty = response.data === "false" ? true : false;
        if (!$scope.archiveEmpty) {
          $scope.searchArchives($scope.type);
        }
      }).catch(function () {
        $scope.archiveEmpty = true;
      });
    };

    $scope.refresh();
    $scope.searchArchives('YEAR');

    $scope.openMalfunction = function (malfunction) {
      $scope.malfunction = malfunction;
      $scope.malfunctionPopup = $mdDialog.show({
        templateUrl: 'app/main/front/home/popup/apercu_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        controller: 'ApercuController',
        locals: {
          pj: { type: 'MALFUNCTION', malfunction: malfunction },
          info: null
        }
      }).then(function () {
        initMalfunction();
      }).catch(function () {
        initMalfunction();
      });
    };

    $scope.setFilter = function (property, typeId, value) {
      $scope.filter[property] = typeId;
      $scope.filter['value'] = value;
    };

    $scope.addProgressForm = function () {
      $state.go('app.fiches-progres.add-fiche-progres', {
        malfunctionId: null,
        actionFromProgressForm: null
      });
    };

    $scope.openFicheProgres = function (ficheProgres) {
      $scope.ficheProgres = ficheProgres;
      $scope.tachesFC = [];
      FicheProgresService.getAllTacheByProgressId(ficheProgres.id).then(function (response) {
        var taches = response;
        if (taches && taches.data && taches.data.length > 0) {
          angular.forEach(taches.data, function (item, key) {
            $scope.tachesFC.push({
              date: new Date(item.echeance).toLocaleDateString(),
              responsable: item.responsable.name + ' ' + item.responsable.surname,
              title: item.title,
              doneDate: item.doneDate,
              done: item.done
            });
          });
        }

        $scope.ficheProgresPopup = $mdDialog.show({
          templateUrl: 'app/main/front/malfunctions/popup/fiche_progres_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        }).then(function () {
          initFicheProgres();
        }).catch(function () {
          initFicheProgres();
        });
      }).catch(function (error) {
        console.log(error);
      });

    };

    $scope.update = function (ficheProgres) {
      var params = {
        malfunctionId: null,
        ficheProgresId: ficheProgres.id
      };

      if (ficheProgres.malfunction != null) {
        params.malfunctionId = ficheProgres.malfunction.id;
      }
      $state.go('app.fiches-progres.update-fiche-progres', params);
    };

    $scope.openDelete = function (ficheProgres) {
      $scope.ficheProgres = ficheProgres;
      $scope.ficheProgresPopup = $mdDialog.show({
        templateUrl: 'app/main/front/malfunctions/popup/confirm_delete_fiche_progres_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initFicheProgres();
      }).catch(function () {
        initFicheProgres();
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.cancel();
    };

    $scope.delete = function (ficheProgres) {
      FicheProgresService.delete(ficheProgres.id).then(function (response) {
        $scope.hidePopup();
        toastr.success("La fiche de progrès a été supprimée avec succès");
        $scope.refresh();
      }).catch(function () {
        toastr.error('Une erreur est survenue, veuillez réessayer plus tard.');
      });
    };


    $scope._save = function () {
      if (!$scope.intoSaving) {
        $scope.intoSaving = true;
        var file = document.getElementById('document_input_file').files[0];
        var formData = new FormData();
        if (file != null) {
          formData.append('file', file);
        }

        $scope._task.echeance = $scope.echeance.getTime();

        //Reminder: "le jour même"
        if ($scope._task.reminder === 0) {
          var date = new Date($scope._task.echeance);
          date.setHours(0, 0, 0, 0);
          $scope._task.reminder = $scope._task.echeance - date.getTime();
        }

        formData.append('dto', angular.toJson($scope._task));
        TachesGeneralesService.save(formData).then(function (response) {
          $scope._closeDialog();
          $timeout(function () {
            $scope.intoSaving = false;
          });
          if (!!$scope._task.addAgain) {
            $scope.addAction($scope.ficheProgres, true);
          }
          toastr.success('Sauvegardée avec succès.');
        }).catch(function (error) {
          console.log(error);
          $scope.intoSaving = false;
        });
      }
    };

    $scope._dateToTimestamp = function (_date) {
      var _result = angular.copy(_date);
      return _result.getTime();
    };

    // Close dialog
    $scope._closeDialog = function () {
      $mdDialog.hide();
    };

    $scope.addCollaborateur = function () {
      $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
      $scope._task.responsable = {};
    };

    $scope.countFilter = function (value) {
      if ($scope.counts) {
        switch (value) {
          case 'all':
            return $scope.counts.all.all;

          default:
            return $scope.counts[value].all;
        }
      }
    }

    $scope.switchTab = function (tab) {
      $scope.cancelSearch()
      var tabs = Object.keys($scope.tabs)
      for (var i = 0; i < tabs.length; i++) {
        $scope.tabs[tabs[i]] = false;
      }
      $scope.tabs[tab] = true;
      if ($scope.tabs.archive && $scope.archivedMalfunctions && $scope.archivedMalfunctions.length === 0) {
        $scope.archive.value = 'none'
        $scope.months.length = 0
        $scope.searchArchives('YEAR')
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .service('FicheProgresService', FicheProgresService);

  function FicheProgresService($q, $http) {
    var URL_PROGRESS = "/api/rest/progressform/";

    var save = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var search = function (searchTxt, activated) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/progressform/search",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'searchTxt': searchTxt,
            'activated': activated
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var list = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var counts = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "counts",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getNbrOpenedAndClosed = function (rddID) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + 'nbrOpenedAndClosed/' + rddID,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var find = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var update = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var remove = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + id,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listYears = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "years",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listMonths = function (year) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "months/" + year,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var hasArchived = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "hasArchived",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var listArchived = function (property, start, end) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "archived",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'property': property,
            'start': start,
            'end': end
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var cloturerFicheDeProgres = function (id, taskID) {
      var url;

      if (taskID) {
        url = URL_PROGRESS + "cloturerFicheDeProgres/" + id + "/" + taskID;
      } else {
        url = URL_PROGRESS + "cloturerFicheDeProgres/" + id;
      }
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getTacheByProgressId = function (id) {
      var url = "getFirstTache/";
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + url + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          if (response.data != null && response.data != "") {
            resolve(response);
          } else {
            reject(response);
          }

        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getAllTacheByProgressId = function (id) {
      var url = "getAllTache/";
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + url + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {

          resolve(response);


        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getPagination = function (pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "paginated",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var linkedToManagementReview = function (id,idManagementReview,linked){
      return $q(function (resolve, reject) {
        $http({
          url: URL_PROGRESS + "linkedToManagementReview/" + id,
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            idManagementReview: idManagementReview,
            linked: linked
          },
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return {
      save: save,
      list: list,
      counts: counts,
      find: find,
      update: update,
      delete: remove,
      listYears: listYears,
      listMonths: listMonths,
      hasArchived: hasArchived,
      listArchived: listArchived,
      cloturerFicheDeProgres: cloturerFicheDeProgres,
      getNbrOpenedAndClosed: getNbrOpenedAndClosed,
      search: search,
      getTacheByProgressId: getTacheByProgressId,
      getAllTacheByProgressId: getAllTacheByProgressId,
      getPagination: getPagination,
      linkedToManagementReview: linkedToManagementReview
    };
  }

})();

(function () {
	"use strict";

	angular.module("app.front").controller("HomeController", HomeController);

	/** @ngInject */
	function HomeController(
		$q, $scope, GENERAL_TASK_TYPES, CahierTransmissionService, EquipeDetailService, SELECT_HOURS_EVENTS, AppelMedecinsService, EventService,
		GENERAL_TASK_PERIOD, GENERAL_TASK_SORTS, $window, TableauDeBordService, $state, $mdDialog, $filter, $rootScope, TachesGeneralesService,
		AdministrationBandeauService, toastr, $location, TASKS_EVENTS_REMINDERS, UserService, $mdPanel, $timeout, FolderService, DocumentService, PlanningService,
		PharmacyService, ReunionService, TraceService, msUtils, QuestionnaireSatisfactionCampaignService, OsysService) {

		// PHSQ-240 (A3) — bouton « Nouveau triage OSyS » et tâche « Rappeler N patients OSyS ».
		// La tâche reste due module désactivé ; le bouton exige un module actif et un habilité.
		$scope.osysVisible = function () {
			return !!($rootScope.user && $rootScope.user.isTitulaire && $rootScope.user.osysModule);
		};
		$scope.osysBoutonVisible = function () {
			var c = $rootScope.osysContexte;
			return $scope.osysVisible() && !!c && c.moduleActif && (c.habilitations || []).length > 0;
		};
		$scope.osysARappeler = function () {
			return $scope.osysVisible() ? OsysService.aRappeler() : 0;
		};
		$scope.osysEnRetard = function () {
			var c = $rootScope.osysContexte;
			return c && c.compteurs ? c.compteurs.enRetard : 0;
		};
		UserService.isConnected().then(function (response) {
			if (response && response.data && response.data.osysModule) {
				OsysService.chargerContexte().catch(angular.noop);
			}
		}).catch(angular.noop);

		var today = new Date();
		today.setSeconds(0, 0);
		$scope.weather = [];
		$scope._tasks = [];
		$scope._events = [];
		$scope.isEvent = null;
		$scope.addAppelantMode = false;
		$scope.submitting = false;
		$scope.hourEvents = SELECT_HOURS_EVENTS;
		$scope._baseResource = '/api/rest/tacheGeneral';
		$scope.inComment = false;
		$scope.intoSaving = false;
		$scope._mdPanel = $mdPanel;
		$scope.inSearch = false;
		$scope.writerId = null;
		$scope.editTransmission = false
		$scope.THRESHOLD = 60;
		$scope.checks = []
		$scope.tags = []
		$scope.editedTags = []
		$scope._tags = []
		$scope.tagsToUpdate = []
		$scope.questionnaireCampaignContext = null;

		//Cahier
		$scope.allLoaded = false;
		$scope.pagination = {
			nbrResults: 10,
			searchText: '',
			excludeIds: []
		};
		$scope.informations = [];
		$scope.information = {
			writer: {
				id: null
			},
			content: null,
			pjs: [],
			tags: []
		};
		$scope.editedInformation = {
			writer: {
				id: null
			},
			content: null,
			pjs: [],
			tags: []
		};
		$scope.comment = {
			content: null,
			writer: {
				id: null
			},
			information: {
				id: null
			}
		};

		$scope.hideBanner = false

		$scope.hideBan = function () {
			$scope.hideBanner = true
		}

		$scope.customModules = {
			// toolbar: [['bold', 'underline', { 'color': ['#FF5853', 'black'] }]],
			toolbar: '#toolbar--new',
			mention: {
				allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
				mentionDenotationChars: ["@"],
				source: function (searchTerm, renderList, mentionChar) {
					let values;

					if (mentionChar === "@") {
						values = $scope._filteredUserTags;
					} else {
						values = hashValues;
					}

					if (searchTerm.length === 0) {
						renderList(values, searchTerm);
					} else {
						const matches = [];
						for (let i = 0; i < values.length; i++)
							if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
						renderList(matches, searchTerm);
					}
				},
			}
		};

		$scope.customModulesEdit = angular.copy($scope.customModules)
		$scope.customModulesEdit.toolbar = '#toolbar--edit'

		$scope.customModulesComment = angular.copy($scope.customModules)
		$scope.customModulesComment.toolbar = '#toolbar--comment'

		$scope.focusYouAre = function () {
			$mdDialog.show({
				templateUrl:
					"app/main/front/home/select_user_dialog.html",
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			});
			// var element = document.getElementById("selectCollab");
			// element.focus();
			// angular.element(element).triggerHandler("click");
		};

		$scope._downloadAttachement = function (_attachment) {
			location.href = $scope._baseResource + '/download/' + _attachment.id;
		};

		$scope.toCheckRead = false;
		$scope.infoToDoSomething = null;
		$scope.infoToFirst = null
		$scope.toComment = false;
		$scope.getInfoSorted = false;
		$scope.loading = false;
		$scope.searchBarOpen = false;
		// Carousel Slider
		$scope.slickConfig = {
			accessibility: true,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			dots: true,
			dotsClass: "slick-dots nl-Slick-dots",
			draggable: true,
			infinite: true,
			enabled: true,
			method: {},
			event: {
				beforeChange: function (event, slick, currentSlide, nextSlide) { },
				afterChange: function (event, slick, currentSlide, nextSlide) { }
			}
		};

		if (msUtils.isMobile()) {
			$scope.isMobile = true
		}

		$scope.openSearchBar = function () {
			$scope.searchBarOpen = true;
		}

		$scope.closeSearch = function () {
			$scope.inSearch = false;
			$scope.pagination.searchText = '';
			$scope.getInfos(true);
			$scope.searchBarOpen = false;
		}

		$scope.search = function () {
			$scope.inSearch = true;
			if ($scope.pagination.searchText != null && $scope.pagination.searchText != "") {
				$scope.getInfos(true);
			} else {
				$scope.closeSearch()
			}
		}
		$scope.openMenu = function ($mdMenu, ev) {
			originatorEv = ev;
			$mdMenu.open(ev);
		};
		var today = new Date();
		today.setSeconds(0, 0);
		$scope.minDateEcheance = angular.copy(today);
		$scope._task = {
			_echeance: moment(today),
			echeance: today.getTime()
		};
		$scope.addCollaborateurMode = false;

		$scope._categories = GENERAL_TASK_TYPES;

		$scope._recurrences = GENERAL_TASK_PERIOD;

		$scope._sorts = GENERAL_TASK_SORTS;

		$scope.reminders = TASKS_EVENTS_REMINDERS;

		// Users
		EquipeDetailService.getCollaborateurs()
			.then(function (data) {
				$scope._users = data;
				$scope.collaborateurs = data;
				$scope._userTags = data.map(function (userTag) {
					userTag.value = userTag.name + ' ' + userTag.surname;
					return userTag;
				}).sort(function (t1, t2) {
					if (t1.value.toLowerCase() == t2.value.toLowerCase()) {
						return 0;
					}
					return t1.value.toLowerCase() < t2.value.toLowerCase() ? -1 : 1;
				});
				$scope._filteredUserTags = $scope._userTags;
			})
			.catch(function (error) {
				console.log(error);
			});

		if ($state.params.reunionId || $state.params.subtraceId) {
			$scope.focusYouAre();
		}
		// CHECKLIST
		$scope.listChecklist = function () {
			var today = new Date()
			today.setHours(0, 0, 0, 0)
			var end = angular.copy(today)
			end.setHours(23, 59, 59, 999)
			PlanningService.getChecklist(today.getTime(), end.getTime()).then(function (res) {
				$scope.checks = res.data
			}).catch(function () {

			})
		}

		$scope.openEditCheck = function (check) {
			$scope.check = angular.copy(check)
			$mdDialog.show({
				templateUrl: 'app/main/front/equipe/planning-general/popup/add_checklist_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			});
		}

		$scope.saveCheck = function () {
			if ($scope.loading) {
				return
			}
			$scope.loading = true
			PlanningService.saveChecklist(null, null, $scope.check).then(function (res) {
				toastr.success('Tâche enregistrée')
				$scope.listChecklist()
				$mdDialog.hide()
				$scope.loading = false;
			}).catch(function () {
				toastr.error('Une erreur est survenue')
				$scope.loading = false;
			})
		}

		$scope.goToChecklist = function () {
			$state.go('app.equipe.planning-general', { tab: 'checklist' })
		}

		$scope.listChecklist()

		$scope.setCheckDone = function (check) {
			PlanningService.setChecklistDone(check.id).then(function (res) {
				$mdDialog.hide()
			}).catch(function () {
				toastr.error('Une erreur est survenue')
			})
		}


		$scope.addCollaborateur = function () {
			if ($scope.fromTask) {
				$scope.addCollaborateurMode = !$scope.addCollaborateurMode;
				$scope._task.responsable = {};
			} else {
				$scope.addAppelantMode = !$scope.addAppelantMode;
				$scope.appel.appelant = {};
			}
		};

		$scope.getCurrentUser = function () {
			UserService.getCurrent().then(function (response) {
				$scope.user = response.data;
				PharmacyService.getCurrent().then(function (res) {
					if (!res.data.team && !res.data.praq && $scope.user.isTitulaire) {
						$scope.pharmacy = res.data
						if (!res.data.team) {
							$scope.pharmacy.team = {}
						}
						if (!res.data.praq) {
							$scope.pharmacy.praq = {}
						}
						$mdDialog.show({
							templateUrl: 'app/main/front/home/popup/new_account.html',
							parent: angular.element(document.body),
							clickOutsideToClose: false,
							scope: $scope,
							preserveScope: true
						})
					}
				}).catch(function () {

				})
			}).catch(function (response) {
				console.log(response);
			});
		};


		$scope.getCurrentUser();

		$scope.refreshQuestionnaireCampaignContext = function () {
			QuestionnaireSatisfactionCampaignService.getContext(false).then(function (context) {
				$scope.questionnaireCampaignContext = context;
			}).catch(function () {
				$scope.questionnaireCampaignContext = null;
			});
		};

		$scope.openMonEnquete = function () {
			$state.go('app.performances.mes-evaluations', { tab: 'mon-enquete' });
		};

		$scope.refreshQuestionnaireCampaignContext();

		$scope.$on('refreshQuestionnaireCampaignContext', function () {
			$scope.refreshQuestionnaireCampaignContext();
		});

		// AdministrationBandeauService.getBanner().then(function (data) {
		//   $scope.banners = data;
		// }).catch(function (err) {
		//   console.log(err);
		// });


		CahierTransmissionService.getFront()
			.then(function (data) {
				$scope.banners = data;
			})
			.catch(function (err) {
				console.log(err);
				toastr.error("Erreur lors de la récupération du bandeau déroulant");
			});

		TableauDeBordService.findWeather()
			.then(function (data) {
				$scope.weather = data;
			})
			.catch(function (err) {
				console.log(err);
			});

		$scope.refreshTags = function () {
			CahierTransmissionService.findTags().then(function (res) {
				$scope.tags = res.data
				$scope.editedTags = angular.copy(res.data)
				$scope._tags = angular.copy(res.data)
			}).catch(function () { })
		}

		$scope.refreshTags()

		$scope.initEventsAndTasks = function () {
			// if ($scope.information.writer.id != null) {
			//Recuperation des 3 prochaines taches/events non cloturees
			TachesGeneralesService.listEventAndTaskHome($scope.information.writer.id).then(function (response) {
				$scope._tasks = response.data;
			}).catch(function (error) {
				console.log(error);
			});

			//Récupération des 3 prochains événements
			TachesGeneralesService.findNextEvents($scope.information.writer.id, 0, 3)
				.then(function (response) {
					$scope._events = response.data;
				})
				.catch(function (error) {
					console.log(error);
				});
			// } else {

			// }
		};
		$scope.initEventsAndTasks();

		$scope.getBanner = function () {
			$scope.slickConfig.enabled = false

			AdministrationBandeauService.getBanner()
				.then(function (data) {
					$scope.banner = data;
					$scope.slickConfig.enabled = true
				})
				.catch(function (err) {
					console.log(err);
				});
		}
		$scope.getBanner()


		$scope.refresh = function () {
			//Recuperation des 3 prochaines taches non cloturees
			TachesGeneralesService.listEventAndTaskHome($scope.information.writer.id).then(function (response) {
				$scope._tasks = response.data;
			}).catch(function (error) {
				console.log(error);
			});

			$scope.banner = [];

			AdministrationBandeauService.getBanner()
				.then(function (data) {
					$scope.banner = data;
				})
				.catch(function (err) {
					console.log(err);
				});
		};

		FolderService.getCovidId().then(function (response) {
			$scope.covid = response.data;
		});

		$scope._showConfirmationProgressForm = function (task) {
			$scope._task = task;
			$mdDialog.show({
				templateUrl:
					"app/main/front/equipe/taches-generales/confirm_progress_form.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				preserveScope: true,
				scope: $scope
			});
		};

		$scope._dismissConfirmProgress = function () {
			$scope._task.done = !$scope._task.done;
			$scope._closeDialog();
		};

		// Done
		$scope._confirmDone = function (task) {
			if (task.progressFormId !== null && task.nbrTasksNotDonePF === 1) {
				$scope._taskToConfirm = task;
				$scope.closeFiche = true;
				$scope.progressFormPopup = $mdDialog
					.show({
						templateUrl:
							"app/main/front/equipe/taches-generales/confirm_progress_form.html",
						parent: angular.element(document.body),
						clickOutsideToClose: true,
						onRemoving: function (event, removePromise) {
							$scope._hideConfirmEventPopUp();
						},
						scope: $scope,
						preserveScope: true
					})
					.then(function () { })
					.catch(function () { });
			} else {
				$scope._taskToConfirm = task;
				$scope.addTaskPopup = $mdDialog
					.show({
						templateUrl:
							"app/main/front/equipe/planning-general/confirm_event_popup.html",
						parent: angular.element(document.body),
						clickOutsideToClose: true,
						onRemoving: function (event, removePromise) {
							$scope._hideConfirmEventPopUp();
						},
						scope: $scope,
						preserveScope: true
					})
					.then(function () { })
					.catch(function () { });
			}
		};

		$scope._hideConfirmEventPopUp = function () {
			$scope._closeDialog();
			if ($scope._taskToConfirm != null) {
				$scope._taskToConfirm.done = false;
			}
		};

		$scope._done = function () {
			var task = $scope._taskToConfirm;
			if (task.done) {
				TachesGeneralesService.done(task.id)
					.then(function (response) {
						if (task.progressFormId != null) {
							for (var i = 0; i < $scope._tasks.length; i++) {
								if ($scope._tasks[i].progressFormId === task.progressFormId) {
									$scope._tasks[i].nbrTasksNotDonePF =
										$scope._tasks[i].nbrTasksNotDonePF - 1;
								}
							}
							if (task.nbrTasksNotDonePF > 1) {
								toastr.success(
									"Il reste " +
									task.nbrTasksNotDonePF +
									" tâches associées à la fiche de progrès."
								);
							} else {
								toastr.success(
									"Il reste " +
									task.nbrTasksNotDonePF +
									" tâche associée à la fiche de progrès."
								);
							}
						}

						$scope.refresh();
						$scope._closeDialog();
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		};

		$scope._editEvent = function (event) {
			if (event.isReunion) {
				var url = "";
				if (event.reunionStatut === "EN_COURS") {
					url = $state.href("app.equipe.reunions.ordre-du-jour", {
						id: event.id
					});
				} else {
					url = $state.href("app.equipe.reunions.compte-rendu", {
						id: event.id
					});
				}
				$window.open(url, "_blank");
			} else {
				$scope._edit(event);
			}
		};

		$scope._edit = function (task) {
			var templateUrl = "";

			if (!task.event) {
				$scope._task = angular.copy(task);

				if (task.hasOwnProperty("echeance") && task.echeance != null) {
					$scope.echeance = new Date(task.echeance);
				} else {
					$scope.echeance = angular.copy(today);
				}

				templateUrl =
					"app/main/front/equipe/taches-generales/tacheGenerales.dialog.html";
			} else {
				$scope._task = angular.copy(task);


				if (task.hasOwnProperty('echeance') && task.echeance != null) {
					$scope._task.echeance = new Date(task.echeance);
					$scope.echeance = new Date(task.echeance);
				} else {
					$scope._task.echeance = angular.copy(today);
					$scope.echeance = angular.copy(today);
				}
				if (task.hasOwnProperty('ending') && task.ending != null) {
					var ending = moment.utc(task.ending - task.echeance).format('HH:mm')
					$scope._task.duration = ending
				}
				console.log($scope._task)
				templateUrl =
					'app/main/front/equipe/planning-general/popup/showRDV_popup.html';
			}

			$scope.addAppelantMode = false;
			showTaskModal(templateUrl);
		};

		$scope.saveEvent = function () {
			if (!$scope.intoSaving) {
				$scope.intoSaving = true;
				if (!$scope.event.allDay) {
					var start = $scope.event.startDate;
					var end = $scope.event.endDate;

					start.setHours(0, 0, 0, 0);
					end.setHours(0, 0, 0, 0);

					var startTime = start.getTime() + $scope.event.startHoursDay;
					var endTime = end.getTime() + $scope.event.endHoursDay;

					if (startTime > endTime) {
						toastr.error(
							"Erreur: la date de début doit être antérieure à la date de fin."
						);
						return;
					}

					$scope.event.echeance = startTime;
					$scope.event.ending = endTime;
				} else {
					$scope.event.echeance = $scope.event.startDate.getTime();
				}

				var file = document.getElementById("file_evenement").files[0];
				var formData = new FormData();
				if (file != null) {
					formData.append("file", file);
				}
				formData.append("dto", angular.toJson($scope.event));
				EventService.save(formData)
					.then(function (response) {
						$scope._closeDialog();
						$scope.intoSaving = false;
						$scope.initEventsAndTasks();
					})
					.catch(function () {
						$scope.intoSaving = false;
					});
			}
		};

		$scope.onEcheanceChange = function (object) {
			object.echeance = object._echeance.valueOf();
		};

		// Close dialog
		$scope._closeDialog = function () {
			$mdDialog.hide();
			$location.search('reunionId', null)
			$location.search('subtraceId', null)
			$scope.intoSaving = false;
		};

		// Close dialog
		$scope._closeDialog2 = function (idSelected) {
			$scope.information.writer.id = idSelected;
			$scope.__filterUserTags(idSelected);
			$mdDialog.hide();
		};

		//DYSFONCTIONNEMENT
		$scope.addMalfunction = function () {
			$state.go("app.malfunctions.add");
		};

		//TACHES
		$scope.addTask = function () {
			$scope.addAppelantMode = false;
			$scope.fromTask = true;
			$scope._task = {
			};
			$scope.echeance = null;
			showTaskModal();
		};

		function showTaskModal(url) {
			var parentEl = angular.element(document.body);
			$mdDialog.show({
				parent: parentEl,
				clickOutsideToClose: false,
				templateUrl: url ? url : 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
				locals: {
					type: "HOME",
					datasource: {
						task: $scope._task,
						event: $scope.event,
						echeance: $scope.echeance
					},
				},
				controller: "DialogController"
			}).finally(function () {
				$scope.initEventsAndTasks();
			}).then(function () {
				if ($scope._task.id) {
					var _index = $scope._tasks
						.map(function (_task) {
							return _task.id;
						})
						.indexOf($scope._task.id);
					if (_index > -1) {
						$scope._tasks[_index] = angular.copy($scope._task);
					}
				} else {
					if ($rootScope.qualityTask) {
						$rootScope.newQualityTask = response.data;
					} else {
						$scope._tasks.push(response.data);
					}
				}
				$scope.initEventsAndTasks();
			}).catch(function () {
			});
		}

		//REUNION
		$scope.planReunion = function () {
			$scope._reunion = {};
			var today = new Date();
			$scope._reunion.dateStart = today;
			$scope._reunion.hourSelect = 36000000;
			$scope._reunion.dateEnd = new Date(today.getTime() + 60 * 60 * 1000);
			$scope._reunion.title = "Réunion ";
			$scope._reunion.lieu = "l'officine ";
			$scope._reunion.wholeDay = true;
			showReunionModal();
		};

		function showReunionModal($event) {
			var parentEl = angular.element(document.body);
			$mdDialog.show({
				parent: parentEl,
				clickOutsideToClose: true,
				templateUrl: 'app/main/front/equipe/reunions/reunion.dialog.html',
				locals: {
					type: "REUNION",
					datasource: {
						reunion: $scope._reunion,
					},
				},
				controller: "DialogController"
			}).then(function (param) {
				$scope.initEventsAndTasks();
			}).catch(function (err) {
			});
		}

		$scope._wholeDay = function () {
			if ($scope._reunion.wholeDay) {
				$scope._setHours($scope._reunion.dateStart, 9);
				$scope._setMinutes($scope._reunion.dateStart, 0);
				$scope._reunion.hourStart = $scope._getHours($scope._reunion.dateStart);
				$scope._reunion.minuteStart = $scope._getMinutes(
					$scope._reunion.dateStart
				);

				var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
				$scope._reunion.dateEnd = angular.copy(_newDateEndInstance);
				$scope._setHours($scope._reunion.dateEnd, 18);
				$scope._setMinutes($scope._reunion.dateEnd, 0);
				$scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
				$scope._reunion.minuteEnd = $scope._getMinutes($scope._reunion.dateEnd);
			}
		};

		$scope._dateStartHandle = function () {
			if ($scope._reunion.wholeDay) {
				$scope._wholeDay();
			} else {
				$scope._setHours($scope._reunion.dateStart, $scope._reunion.hourStart);
				$scope._setMinutes(
					$scope._reunion.dateStart,
					$scope._reunion.minuteStart
				);

				if ($scope._reunion.dateStart > $scope._reunion.dateEnd) {
					var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
					$scope._reunion.dateEnd = angular.copy(_newDateEndInstance);

					$scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
					$scope._setHours($scope._reunion.dateEnd, $scope._reunion.hourEnd);

					$scope._reunion.minuteEnd = $scope._getMinutes(
						$scope._reunion.dateEnd
					);
					$scope._setMinutes(
						$scope._reunion.dateEnd,
						$scope._reunion.minuteEnd
					);
				}
			}
		};

		$scope._dateEndHandle = function () {
			$scope._setHours($scope._reunion.dateEnd, $scope._reunion.hourEnd);
			$scope._setMinutes($scope._reunion.dateEnd, $scope._reunion.minuteEnd);
		};

		$scope.signalerAppelPopup = function () {
			$scope.fromTask = false;
			$scope.updateMode = false;
			$scope.addAppelantMode = false;
			$scope.appel = {
				nomMedecin: null,
				nomPatient: null,
				appelant: null,
				sujet: null,
				id: null
			};

			$scope.signalerAppelPopupVar = $mdDialog.show({
				templateUrl:
					"app/main/front/malfunctions/appel-medecins/popup/add_appel.html",
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {
			}).catch(function () {
			});
		};

		$scope.saveAppel = function () {
			if (!$scope.intoSaving) {
				$scope.intoSaving = true;
				var input = document.getElementById('document_input_file');
				var file = null;
				if (input != null) {
					file = input.files[0];
				}
				var fd = new FormData();
				fd.append('file', file);
				fd.append('dto', angular.toJson($scope.appel));
				AppelMedecinsService.saveAppel(fd).then(function (data) {
					$scope.hidePopup();
					$scope.intoSaving = false;
					toastr.success("Appel signalé avec succès");
				})
					.catch(function (err) {
						$scope.intoSaving = false;
						console.log(err);
						toastr.error("Erreur lors du signalement de l'appel");
					});
			}
		};

		$scope.getDateString = function (millis) {
			var date = new Date(millis);
			var day = "" + date.getDate();
			var month = "";
			switch (date.getMonth()) {
				case 0:
					month = " jan";
					break;
				case 1:
					month = " fév";
					break;
				case 2:
					month = " mar";
					break;
				case 3:
					month = " avr";
					break;
				case 4:
					month = " mai";
					break;
				case 5:
					month = " juin";
					break;
				case 6:
					month = " juil";
					break;
				case 7:
					month = " août";
					break;
				case 8:
					month = " sep";
					break;
				case 9:
					month = " oct";
					break;
				case 10:
					month = " nov";
					break;
				case 11:
					month = " déc";
					break;
				default:
					break;
			}



			return day + month + " " + date.getFullYear();
		}

		$scope.downloadDoc = function (id) {
			location.href = '/api/rest/trace/download/document/' + id;
		}

		$scope.hidePopup = function () {
			$scope.intoSaving = false;
			$mdDialog.hide();
		};

		$scope.closeModal = function () {
			$scope.hidePopup()
		};

		$scope.findMore = function () {
			$scope.getInfoSorted = true;
			$scope.getInfos(false);
		}

		$scope.getInfos = function (reset, id) {
			if (reset) {
				$scope.allLoaded = false;
				$scope.pagination.excludeIds = []
				$scope.pagination.includeId = null
			} else {
				$scope.pagination.excludeIds = $scope.informations.map(function (info) { return info.id });
				$scope.pagination.includeId = null
			}
			if (id) {
				$scope.pagination.includeId = id
			}
			CahierTransmissionService.getAll($scope.pagination, $scope.idSelected)
				.then(function (data) {
					if (reset) {
						if ($scope.infoToFirst) {
							$scope.informations = [angular.copy($scope.infoToFirst)];
						} else {
							$scope.informations = [];
						}
					}
					if (data.informations.length < $scope.pagination.nbrResults) {
						$scope.allLoaded = true;
					}

					for (var i = 0; i < data.informations.length; i++) {
						if ($scope.infoToFirst == null || $scope.infoToFirst.id != data.informations[i].id) {
							$scope.informations.push(data.informations[i])
						}
					}
					$scope.infoToFirst = null


					if ($scope.pagination.searchText && $scope.pagination.searchText != '') {
						$scope.informations.forEach(function (element) {
							if (element.content && element.content.indexOf('<strong>') > -1) {
								element.full = true;
							}
						});
					}

					$scope.pagination = data.pagination;
					//-----------------------------------
					if ($scope.idSelected && $scope.idSelected != -1) {
						CahierTransmissionService.getCollabInfos($scope.idSelected)
							.then(function (res) {
								$scope.principalInitials = res.data.initials;

								var newList = [];

								$scope.__filterUserTags($scope.idSelected);

								$scope.informations.forEach(function (element) {
									var read = false;
									// je suis auteur
									element.readers.forEach(function (reader) {
										if (reader.id === $scope.information.writer.id) {
											read = true;
										}
									});
									if (read === false) {
										newList.push(element);
									}
								});
								// msg lu
								$scope.informations.forEach(function (element) {
									element.readers.forEach(function (reader) {
										if (reader.id === $scope.information.writer.id) {
											newList.push(element);
										}
									});
								});

								$scope.loading = false;
							}).catch(function (err) {
								console.log(err);
							});
					}
					if ($scope.toComment != null && $scope.pagination.includeId != null && $scope.infoToDoSomething != null) {
						$scope.openCommentArea($scope.infoToDoSomething);
						$scope.toComment = false;
						$scope.infoToDoSomething = null;
					}
				})
				.catch(function (err) {
					console.log(err);
					$scope.loading = false;
					toastr.error("Erreur lors de la récupération de la liste");
				});
		};

		$scope.getInfos();

		$scope.openCommentArea = function (info) {
			if ($scope.information.writer.id === null) {
				//verifie si un collaborateur a ete choisi
				$scope.toComment = true;
				$scope.infoToDoSomething = info;
				$scope.focusYouAre();
			} else {
				if ($scope.comment.information.id === info.id) {
					$scope.comment.information.id = null;
				} else {
					$scope.comment.information.id = info.id;
				}

				$scope.comment.content = null;
			}
		};

		$scope.searchNameWritter = function (id) {
			for (var i = 0; i < $scope.collaborateurs.length; i++) {
				if ($scope.collaborateurs[i].id == id) {
					var test = $scope.collaborateurs[i].surname + ' ' + $scope.collaborateurs[i].name;
					return test;
				}
			}
		}

		$scope.sendComment = function (info) {
			if ($scope.information.writer.id === null) {
				//verifie si un collaborateur a ete choisi
				$scope.focusYouAre();
			}
			else {
				$scope.comment.writer.id = $scope.information.writer.id;
				$scope.getMentionsFromHTML('comment');
				CahierTransmissionService.comment($scope.comment)
					.then(function (comment) {
						$scope.comment.information.id = null;
						$scope.comment.content = null;
						info.comments.push(comment);
						info.visibleComments.push(comment);
						var alreadyRead = false;
						info.readers.filter(function (element) {
							if (element.id === $scope.information.writer.id) {
								alreadyRead = true;
							}
						});
						info.readers = [];
						info.countReaders = 0;
						info.readers.push({ id: $scope.information.writer.id, completeName: $scope.searchNameWritter($scope.information.writer.id) });

						// if (!alreadyRead && $scope.information.writer.id != info.writer.id) {
						$scope.inComment = true;
						// }

						$scope.setRead(info);
					})
					.catch(function (err) {
						console.log(err);
						toastr.error("Erreur lors de l'envoi du commentaire");
					});
			}
		};

		$scope.saveInformation = function () {
			if (!$scope.intoSaving) {
				$scope.intoSaving = true;
				$scope.getMentionsFromHTML('information');
				var fmData = new FormData()
				var files = []
				for (var i = 0; i < $scope.information.pjs.length; i++) {
					if ($scope.information.pjs[i].type === 'FILE' && $scope.information.pjs[i].files != null) {
						for (var j = 0; j < $scope.information.pjs[i].files.length; j++) {
							files.push($scope.information.pjs[i].files[j])
						}
					}
				}
				for (var i = 0; i < files.length; i++) {
					fmData.append('files', files[i]);
				}
				fmData.append('dto', angular.toJson($scope.information))
				CahierTransmissionService.add(fmData).then(function (data) {
					$scope.information.content = null;
					$scope.information.pjs = []
					$scope.information.tags = []
					$scope.tags = angular.copy($scope._tags)
					document.getElementById("add_info_file").value = "";
					toastr.success('Message envoyé')
					if ($scope.information.writer.id === null) {
						$scope.toCheckRead = true;
						$scope.infoToDoSomething = data;
						$scope.focusYouAre();
					}
					else {
						CahierTransmissionService.markAsView($scope.information.writer.id, data.id, $scope.pagination).then(function (res) {
							if (res) {
								$scope.infoToFirst = res.data
								$scope.getInfos(true);
							}
						});
					}

					$scope.intoSaving = false;
				})
					.catch(function (err) {
						$scope.intoSaving = false;
						console.log(err);
						toastr.error("Erreur lors de l'ajout");
					});
			}
		};

		$scope.updateInformation = function (info, index) {
			if (!$scope.intoSaving) {
				$scope.intoSaving = true;
				$scope.getMentionsFromHTML('msg', index);
				var fmData = new FormData()
				var files = []
				for (var i = 0; i < $scope.editedInformation.pjs.length; i++) {
					if ($scope.editedInformation.pjs[i].type === 'FILE' && $scope.editedInformation.pjs[i].files != null) {
						for (var j = 0; j < $scope.editedInformation.pjs[i].files.length; j++) {
							files.push($scope.editedInformation.pjs[i].files[j])
						}
					}
				}
				for (var i = 0; i < files.length; i++) {
					fmData.append('files', files[i]);
				}
				fmData.append('dto', angular.toJson($scope.editedInformation))
				CahierTransmissionService.update(fmData).then(function (data) {
					$scope.intoSaving = false;
					$scope.informations[index] = data
					$scope.editedInformation = {
						writer: {
							id: null
						},
						content: null,
						pjs: []
					};
				})
					.catch(function (err) {
						$scope.intoSaving = false;
						console.log(err);
						toastr.error("Erreur lors de la modification");
					});
			}
		}

		$scope.getMentionsFromHTML = function (type, index) {
			var elements;
			if (type === "information") {
				$scope.information.mentions = [];
				elements = new DOMParser().parseFromString($scope.information.content, 'text/html').body.children;
			}
			if (type === "comment") {
				$scope.comment.mentions = [];
				elements = new DOMParser().parseFromString($scope.comment.content, 'text/html').body.children;
			}
			if (type === 'msg') {
				$scope.informations[index].mentions = []
				elements = new DOMParser().parseFromString($scope.informations[index].content, 'text/html').body.children;
			}
			for (var i = 0, iLen = elements.length; i < iLen; i++) {
				for (var j = 0, jLen = elements[i].children.length; j < jLen; j++) {
					if (elements[i].children[j].className === 'mention') {
						const dataset = elements[i].children[j].dataset;
						var collab = $scope.collaborateurs.filter(function (collab) {
							return collab.id === Number(dataset.id);
						});
						if (collab.length > 0) {
							if (type === "information") {
								$scope.information.mentions.push(collab[0]);
							}
							if (type === "comment") {
								$scope.comment.mentions.push(collab[0]);
							}
							if (type === 'msg') {
								$scope.informations[index].mentions.push(collab[0])
							}
						}
					}
				}
			}
		}

		$scope.manqueJusteCreateur = function (info) {
			var bool = true;
			if (info != null && info.readers != null && $scope.collaborateurs != null) {
				if (info.readers.length === ($scope.collaborateurs.length - 1)) {
					info.readers.forEach(function (element) {
						if (element.id == info.writer.id) {
							bool = false;
						}
					});
					return bool;
				} else {

					if (info.readers.length == $scope.collaborateurs.length) {
						return true;
					} else {
						return false;
					}
				}
			} else {
				return false;
			}


		}

		//Sort post to put unread first
		$scope.userChange = function (idSelected) {
			$scope.idSelected = idSelected ? idSelected : $scope.idSelected;
			$scope._selected = null
			for (var i = 0; i < $scope.collaborateurs.length; i++) {
				var collab = $scope.collaborateurs[i]
				if (collab.id === $scope.idSelected) {
					$scope._selected = angular.copy(collab)
					break
				}
			}
			if ($state.params.reunionId) {
				$scope.information.content = 'Merci à tous de consulter le compte-rendu de réunion ci-dessous, et pour les absents de cliquer sur "J\'ai bien lu" en fin de compte-rendu.'
				ReunionService.findReunion($state.params.reunionId).then(function (response) {
					$scope._thisReunion = response.data;
					var row = { type: 'REUNION', reunion: { id: $state.params.reunionId, title: response.data.title } }
					$scope.information.pjs.push(row)
					$location.search('reunionId', null)
				}).catch(function (error) {
					console.log(error);
				});

			}
			if ($state.params.subtraceId) {
				$scope.information.content = 'Merci à tous de consulter la traçabilité ci-dessous.'
				TraceService.getHomeSubtrace($state.params.subtraceId).then(function (response) {
					$scope.subtrace = response;
					var row = { type: 'SUBTRACE', subtrace: { id: $state.params.subtraceId, traceName: response.traceName } }
					$scope.information.pjs.push(row)
					$location.search('subtraceId', null)
				}).catch(function (error) {
					console.log(error);
				});
			}
			if (!idSelected) {
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};

				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					controller: 'EquipeDetailController'
				}).then(function (data) {
					console.log(data)
					$scope.information.writer.id = data || $scope.idSelected;
				}).catch(function (error) {
					$scope.information.writer.id = null;
				});
				return;
			}
			if ($scope.information.writer.id === -1) {
				$scope.information.writer.id = null
			}
			$scope.initEventsAndTasks()
			$scope.getInfos(true);
		};

		$scope.checkUser = function (idSelected) {
			if (!idSelected) {
				$scope.information.writer.id = null;
				$scope.writerId = null;
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};
				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					controller: 'EquipeDetailController'
				});
				return;
			}
		}

		$scope.__filterUserTags = function (id) {
			// RETURN MENTION TAGS WITHOUT CURRENT USER SELECTED
			$scope._userTags.filter(function (userTag) {
				return userTag.id != id;
			});
			$scope.informations.forEach(function (information) {
				// INFORMATION POST TREATMENT
				$scope.__highlightCurrentUserMention(information, id);
				// INFORMATION COMMENTS POST TREATMENT
				if (information.visibleComments && information.comments.length > 0) {
					information.visibleComments.forEach(function (comment) {
						$scope.__highlightCurrentUserMention(comment, id);
					});
				}
			});
		}

		$scope.__highlightCurrentUserMention = function (element, id) {
			const childNodes = new DOMParser().parseFromString(element.content, 'text/html').body.childNodes;
			childNodes.forEach(function (childNode) {
				childNode.childNodes.forEach(function (childElem) {
					if (childElem.className === "mention" && childElem.dataset.id == id) {
						childElem.className = "mention-y";
					}
				});
			})
			element.content = childNodes[0].parentElement.innerHTML;
		}

		$scope.changeUser = function (idSelected) {
			$scope._selected = null
			for (var i = 0; i < $scope.collaborateurs.length; i++) {
				var collab = $scope.collaborateurs[i]
				if (collab.id === idSelected) {
					$scope._selected = angular.copy(collab)
					break
				}
			}
			if ($state.params.reunionId) {
				$scope.information.content = 'Merci à tous de consulter le compte-rendu de réunion ci-dessous, et pour les absents de cliquer sur "J\'ai bien lu" en fin de compte-rendu.'
				ReunionService.findReunion($state.params.reunionId).then(function (response) {
					$scope._thisReunion = response.data;
					var row = { type: 'REUNION', reunion: { id: $state.params.reunionId, title: response.data.title } }
					$scope.information.pjs.push(row)
					$location.search('reunionId', null)
				}).catch(function (error) {
					console.log(error);
				});

			}
			if ($state.params.subtraceId) {
				TraceService.getHomeSubtrace($state.params.subtraceId).then(function (response) {
					$scope.subtrace = response;
					$scope.information.content = 'Merci à tous de consulter la traçabilité du ' + $filter('date')($scope.subtrace.subtrace.firstCreationDate, "dd/MM/yyyy 'à' HH'h'mm") + '.'
					var row = { type: 'SUBTRACE', subtrace: { id: $state.params.subtraceId, traceName: response.traceName } }
					$scope.information.pjs.push(row)
					$location.search('subtraceId', null)
				}).catch(function (error) {
					console.log(error);
				});
			}
			CahierTransmissionService.getCollabInfos(idSelected)
				.then(function (res) {
					$scope.information.writer.id = idSelected;
					$scope.idSelected = idSelected
					$scope.principalInitials = res.data.initials;

					var newList = [];

					$scope.informations.forEach(function (element) {
						var read = false;
						element.readers.forEach(function (reader) {
							if (reader.id === $scope.information.writer.id) {
								read = true;
							}
						});
						if (read === false) {
							newList.push(element);
						}
					});

					$scope.informations.forEach(function (element) {
						element.readers.forEach(function (reader) {
							if (reader.id === $scope.information.writer.id) {
								newList.push(element);
							}
						});
					});

					$scope.informations = newList;

					if ($scope.toComment && $scope.infoToDoSomething) {
						var id = $scope.infoToDoSomething.id
						$scope.initEventsAndTasks()
						$scope.__filterUserTags(idSelected);
						$scope.getInfos(true, id);
					} else if ($scope.toCheckRead && $scope.infoToDoSomething) {
						var alreadyReader = false;
						$scope.infoToDoSomething.readers.forEach(function (r) {
							if (r.id === $scope.information.writer.id) {
								alreadyReader = true;
							}
						})

						if (!alreadyReader && $scope.idSelected != $scope.infoToDoSomething.writer.id) {
							$scope.setRead($scope.infoToDoSomething, true).then(function () {
								$scope.initEventsAndTasks()
								$scope.__filterUserTags(idSelected);
								$scope.getInfos(true);
								$scope.toCheckRead = false;
								$scope.infoToDoSomething = null;
							});
						} else {
							$scope.initEventsAndTasks()
							$scope.__filterUserTags(idSelected);
							$scope.getInfos(true);
						}
					} else {
						$scope.initEventsAndTasks()
						$scope.__filterUserTags(idSelected);
						$scope.getInfos(true);
					}

				})
				.catch(function (err) {
					console.log(err);
				});

			$mdDialog.hide();
		}

		$scope.isUnread = function (info, reunionMode) {
			if ($scope.information.writer.id === null) {
				return !!reunionMode;
			}
			var unread = true;
			if (info && info.readers) {
				info.readers.forEach(function (reader) {
					if (reader.id == $scope.information.writer.id) {
						unread = false;
					}
				});
			}

			return unread;
		};

		$scope.isAtLeastUnreadComment = function (info) {
			if (!info || !Array.isArray(info.comments) || !$scope.information.writer.id) {
				return false;
			}
			if (!$scope.isUnread(info)) {
				return false;
			}
			return info.comments.some(function (com) {
				return $scope.isUnreadComment(com, info);
			});
		};

		$scope.isUnreadComment = function (comment, info) {
			var currentUserId = $scope.information.writer.id;
			if (!currentUserId || !comment || !Array.isArray(comment.readers)) {
				return false;
			}
			if (info && !$scope.isUnread(info)) {
				return false;
			}

			// Never show "Nouveau" on a comment authored by the selected user.
			if (comment.writer && comment.writer.id == currentUserId) {
				return false;
			}

			return !comment.readers.some(function (reader) {
				var readerId = reader && (reader.id || (reader.collaborateur && reader.collaborateur.id) || (reader.user && reader.user.id));
				return readerId == currentUserId;
			});
		};

		$scope.isMentionned = function (info) {
			var mentionned = true;
			if (info.mentions) {
				mentionned = info.writer.id === $scope.information.writer.id
				info.mentions.forEach(function (mention) {
					if ($scope.information.writer.id === mention.id) {
						mentionned = true;
					}
				});
				info.comments.forEach(function (comment) {
					if (comment.mentions) {
						comment.mentions.forEach(function (mention) {
							if ($scope.information.writer.id === mention.id) {
								mentionned = true;
							}
						});
					}
				});
			}
			return mentionned;
		};

		$scope.setRead = function (info, noReplace, loading) {
			return $q(function (resolve, reject) {
				$scope.currentWriterId = info.writer.id;
				/*$scope.collaborateurs.forEach(function (item, index) {
				  if (item.id == $scope.currentWriterId) {
					$scope.collaborateurs.splice(index, 1);
				  }
				});*/
				if ($scope.information.writer.id === null) {
					//verifie si un collaborateur a ete choisi
					$scope.toCheckRead = true;
					$scope.infoToDoSomething = info;
					$scope.focusYouAre();
					$scope.loadingRead = false;
					resolve()
				} else {
					if (loading) {
						if (info._loading) {
							return
						}
						$scope.loadingRead = true
						info._loading = true
					}
					CahierTransmissionService.markAsView($scope.information.writer.id, info.id, $scope.pagination).then(function (res) {
						if (res && res.data) {
							$scope.getInfoSorted = true;
							if (!noReplace) {
								for (var i = 0; i < $scope.informations.length; i++) {
									var information = $scope.informations[i]
									if (information.id == info.id) {
										res.data.full = info.full;
										$scope.informations[i] = res.data;
										if ($scope.inComment) {
											$scope.inComment = false;
										}
										break;
									}
								}
							}
							// $rootScope.$broadcast('refreshCountNotifs');
							resolve()
						}
					}).catch(function (err) {
						reject(err);
					}).finally(function () {
						$scope.loadingRead = false;
						info._loading = false;
					});

				}

			})
		};



		$scope._openDeleteInfo = function (info) {
			$scope.infoToDelete = info;
			$mdDialog.show({
				templateUrl:
					"app/main/front/home/popup/delete_popup.html",
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true,
				onRemoving: function (event, promise) {
					$scope.infoToDelete = null;
				}
			});
		};

		$scope._deleteInformation = function (info) {
			CahierTransmissionService.deleteInfo(info.id)
				.then(function (data) {
					$scope._closeDialog();
					$scope.getInfos(true);
				})
				.catch(function (err) {
					console.log(err);
					toastr.error("Erreur lors de la suppression");
				});
		};

		$scope.validateDelete = function () {
			if ($scope.infoToDelete != null) {
				$scope._deleteInformation($scope.infoToDelete);
			} else if ($scope.deleteComment != null && $scope.info != null) {
				$scope._deleteComment($scope.info, $scope.deleteComment)
			}
		}

		$scope._openDeleteComment = function (info, comment) {
			// if ($scope.information.writer.id === null) {
			//   //verifie si un collaborateur a ete choisi
			//   $scope.focusYouAre();
			// } else {
			$scope.info = info;
			$scope.deleteComment = comment;
			$mdDialog.show({
				templateUrl:
					"app/main/front/home/popup/delete_popup.html",
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true,
				onRemoving: function (event, promise) {
					$scope.info = null;
					$scope.deleteComment = null;
				}
			});
			// }
		};

		$scope._deleteComment = function (info, comment) {
			CahierTransmissionService.deleteComment(info.id, comment.id)
				.then(function (data) {
					$scope._closeDialog();
					$scope.getInfos(true);
				})
				.catch(function (err) {
					console.log(err);
					toastr.error("Erreur lors de la suppression");
				});
		};

		// CHECK IF TEXT IS LONGER THAN EXPECTED, IF IT IS, CUT IT
		$scope.shortVersion = function (raw) {
			try {
				var text = angular.copy(raw);
				const node = new DOMParser().parseFromString(text, 'text/html').body.firstElementChild;
				var html = "";

				// IF IT'S NOT HTML
				if (node == null) {
					if (text.length < $scope.THRESHOLD) {
						return text;
					} else {
						return text.substring(0, $scope.THRESHOLD - 3) + "...";
					}
				}

				var accumulator = 0;
				// BROWSE ALL CHILD NODES
				for (var i = 0, iLen = node.childNodes.length; i < iLen; i++) {
					var currentValue = node.childNodes[i];
					// IF IT'S A MENTION TAG (IT HAS MENTION CLASS NAME)
					if (currentValue.className && currentValue.className === "mention" && (accumulator + currentValue.innerText.length) < $scope.THRESHOLD) {
						const childNode = new DOMParser().parseFromString(currentValue.innerHTML, 'text/html').body.firstElementChild;
						childNode.className = "mention";
						html += childNode.outerHTML;
					}
					if (currentValue.className && currentValue.className === "mention-y" && (accumulator + currentValue.innerText.length) < $scope.THRESHOLD) {
						const childNode = new DOMParser().parseFromString(currentValue.innerHTML, 'text/html').body.firstElementChild;
						childNode.className = "mention-y";
						html += childNode.outerHTML;
					}
					// IF IT'S URL
					if (currentValue.className && currentValue.className === 'url-info' && (accumulator + currentValue.innerText.length) < $scope.THRESHOLD) {
						html += currentValue.outerHTML;
					}
					// IF IT'S JUST TEXT
					if (currentValue.data && accumulator < $scope.THRESHOLD) {
						// IF IT DOESN T EXCEDE TOTAL THRESHOLD
						if (accumulator + currentValue.data < $scope.THRESHOLD) {
							html += currentValue.data;
						}
						// ELSE WE SEE IF WE HAVE TO CUT THE REMAINING TEXT
						else {
							var endString = $scope.THRESHOLD - accumulator;
							html += currentValue.data.substring(0, endString);
						}
					}
					// ADD TEXT LENGTH TOTAL TO THE ACCUMULATOR
					accumulator += ((currentValue.innerText && currentValue.innerText.length) || (currentValue.nodeValue && currentValue.nodeValue.length) || (currentValue.outerHTML.length));
				}
				return (accumulator >= $scope.THRESHOLD ? html.substring(0, html.length - 1) + "..." : html);
			}
			catch (e) {
				console.log('error' + e);
			}
		};

		$scope.toggleFull = function (info) {
			if (info.full === null) {
				info.full = true;
			} else {
				var writerId = $scope.information.writer.id;
				var alreadyRead = info.readers.filter(function (reader) {
					return reader.id === info.writer.id;
				}).length > 0;
				if (writerId != null && writerId === info.writer.id && !alreadyRead) {
					CahierTransmissionService.markAsView($scope.information.writer.id, info.id, $scope.pagination).then(function (res) {
						if (res && res.data) {
							$scope.informations.forEach(function (information, index) {
								if (information.id == info.id) {
									res.data.full = true;
									$scope.informations[index] = res.data;
								}
							});
						}
					});
				}
				info.full = !info.full;
			}
		};

		$scope.toggleFullTrue = function (info) {
			info.full = true;
		};

		$scope.loadPreviousComments = function (info) {
			if (info.comments.length === info.visibleComments.length) {
				return;
			} else {
				CahierTransmissionService.loadPreviousComments(info)
					.then(function (res) {
						info.visibleComments = res.data.visibleComments;
					})
					.catch(function (err) {
						console.log(err);
						toastr.error("Erreur lors du chargement");
					});
			}
		};

		$scope.__closePanel = function () {
			if ($scope._panelRef != null) {
				$scope._panelRef.$$state.value.close();
			}
		}

		$scope.initEditor = function (editor) {
			var quillEditor = editor.container.parentElement.parentElement;
			if (quillEditor.id === "post") {
				$scope.editorTop = editor;
			}
			if (!$scope.editorComment) $scope.editorComment = [];
			if (quillEditor.id.slice(0, 7) === "comment") {
				$scope.editorComment[quillEditor.id.slice(7)] = editor;
			}
			if (!$scope.editorMsg) $scope.editorMsg = [];
			if (quillEditor.id.slice(0, 3) === "msg") {
				$scope.editorMsg[quillEditor.id.slice(3)] = editor;
			}
		}

		$scope.addMention = function (id, index) {
			if (id === "post") {
				var content = $scope.information.content;
				content != null && content != '' ? $scope.information.content += "@" : $scope.information.content = "@";
				$timeout(function () {
					$scope.editorTop.setSelection($scope.information.content.length, 0);
				});
			}
			if (id === "comment") {
				var content = $scope.comment.content;
				content != null && content != '' ? $scope.comment.content += "@" : $scope.comment.content = "@";
				$timeout(function () {
					$scope.editorComment[index].setSelection($scope.comment.content.length, 0);
				});
			}
			if (id === "msg") {
				var content = $scope.informations[index].content;
				content != null && content != '' ? $scope.informations[index].content += "@" : $scope.informations[index].content = "@";
				$timeout(function () {
					$scope.editorMsg[index].setSelection($scope.informations[index].content.length, 0);
				});
			}
		}

		$scope.getPdfHome = function (id, ev) {
			ev.preventDefault();
			$window.location.href = '/api/rest/document/pdfHome/' + id;
		};

		// collab appel médecin
		$scope.changeCollab = function (idSelected) {
			$scope.idSelected = idSelected ? idSelected : $scope.idSelected;
			if (!idSelected) {
				$scope.collaborateur = {
					name: null,
					surname: null,
					id: null,
					fichePoste: {}
				};

				$scope.titlePopupSave = 'Ajouter un collaborateur';
				$scope.updateMode = false;
				$scope.descriptionMode = true;

				$scope.equipePopup = $mdDialog.show({
					templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true,
					multiple: true,
					controller: 'EquipeDetailController'
				}).then(function (data) {
					$scope.appel.appelant.id = data || $scope.idSelected;
				}).catch(function (error) {
					$scope.appel.appelant.id = null;
				});
				return;
			}
		};

		// POPUP V3
		$scope.openDeletePopup = function () {
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/delete_popup.html',
				parent: angular.element(document.body),
				scope: $scope,
				preserveScope: true
			});
		}

		$scope.pinInfo = function (info) {
			CahierTransmissionService.setPin(info.id).then(function (res) {
				$scope.getInfos(true)
				$scope.getBanner()
			}).catch(function (err) {
				if (err.status === 409) {
					$mdDialog.show({
						templateUrl: 'app/main/front/home/popup/pin_popup.html',
						parent: angular.element(document.body),
						scope: $scope,
						preserveScope: true
					});
				}
			})
		}

		//
		$scope.openJoindreFile = function (index) {
			if (index != null) {
				$('#file_' + index).off('change')
				$('#file_' + index).on('change', function (evt) {
					$scope.editedInformation.pjs.push({ type: 'FILE', name: evt.target.files[0].name, files: evt.target.files })
					$scope.$apply()
				})
				$('#file_' + index).click()
			} else {
				$('#add_info_file').off('change')
				$('#add_info_file').on('change', function (evt) {
					$scope.information.pjs.push({ type: 'FILE', name: evt.target.files[0].name, files: evt.target.files })
					$scope.$apply()
				})
				$('#add_info_file').click()
			}
		}

		$scope.openJoindreDocPopup = function (index) {
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/joindreDoc_popup.html',
				parent: angular.element(document.body),
				controller: 'JoindreDocController',
				locals: {
					index: index,
					excludeIds: []
				}
			});
		}

		$scope.openJoindreDysPopup = function (index) {
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/joindreDys_popup.html',
				parent: angular.element(document.body),
				controller: "JoindreDysController",
				locals: {
					index: index,
					reunionMode: false,
					excludeIds: []
				}
			});
		}
		$scope.openJoindreFDPPopup = function (index) {
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/joindreFDP_popup.html',
				parent: angular.element(document.body),
				controller: "JoindreFDPController",
				locals: {
					index: index,
					reunionMode: false,
					excludeIds: []
				}
			});
		}
		$scope.openJoindreReunionPopup = function (index) {
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/joindreReunion_popup.html',
				parent: angular.element(document.body),
				controller: "JoindreReunionController",
				locals: {
					index: index
				}
			});
		}

		$scope.openApercuPopup = function (pj, info) {
			pj.read = !$scope.isUnread(info)
			$mdDialog.show({
				templateUrl: 'app/main/front/home/popup/apercu_popup.html',
				parent: angular.element(document.body),
				controller: 'ApercuController',
				locals: {
					pj: pj,
					info: info
				}
			}).then(function (res) {
				if (res && res.info) {
					$scope.setRead(res.info)
				}
			});
		}

		$scope.$on('resultsadded', function (event, data) {
			for (var i = 0; i < data.selected.length; i++) {
				var row = data.selected[i]
				if (data.type === 'MALFUNCTION') {
					var row = { type: data.type, malfunction: { id: row.id, title: row.title } }
					if (data.index != null) {
						$scope.editedInformation.pjs.push(row)
					} else {
						$scope.information.pjs.push(row)
					}
				} else if (data.type === 'PROGRESS_FORM') {
					var row = { type: data.type, progressForm: { id: row.id, title: row.title } }
					if (data.index != null) {
						$scope.editedInformation.pjs.push(row)
					} else {
						$scope.information.pjs.push(row)
					}
				} else if (data.type === 'REUNION') {
					var row = { type: data.type, reunion: { id: row.id, title: row.title } }
					if (data.index != null) {
						$scope.editedInformation.pjs.push(row)
						$scope.addReunionTag($scope.editedInformation)
					} else {
						$scope.information.pjs.push(row)
						$scope.addReunionTag($scope.information)
					}
				} else if (data.type === 'DOC') {
					var row = { type: data.type, document: { id: row.id, name: row.name } }
					if (data.index != null) {
						$scope.editedInformation.pjs.push(row)
					} else {
						$scope.information.pjs.push(row)
					}
				}
			}
		})

		$scope.displayPj = function (pj) {
			if (pj.type === 'MALFUNCTION') {
				return pj.malfunction.title
			} else if (pj.type === 'PROGRESS_FORM') {
				return pj.progressForm.title
			} else if (pj.type === 'REUNION') {
				return pj.reunion.title
			} else if (pj.type === 'DOC') {
				return pj.document.name
			} else if (pj.type === 'FILE') {
				return pj.name
			} else if (pj.type === 'SUBTRACE') {
				return pj.subtrace.traceName
			}
		}

		$scope.deletePj = function (index, editionMode, parentIndex) {
			if (editionMode) {
				if ($scope.editedInformation.pjs[index].type === 'FILE') {
					document.getElementById("file_" + parentIndex).value = "";
				}
				$scope.editedInformation.pjs.splice(index, 1)
			} else {
				if ($scope.information.pjs[index].type === 'FILE') {
					document.getElementById("add_info_file").value = "";
				}
				$scope.information.pjs.splice(index, 1)
			}
		}

		$scope.showDisplay = function (pj) {
			if (pj.type === 'DOC') {
				return pj.document != null && pj.document.pdf
			} else if (pj.type === 'FILE') {
				var names = pj.name.split('.');
				return pj.name != null && names[names.length - 1] === 'pdf'
			} else {
				return true;
			}
		}

		$scope.downloadPj = function (pj) {
			if (pj.type === 'DOC') {
				if (pj.document.fileName.includes('.pdf')) {
					FolderService.getPDF(pj.document.id).then(function (res) {
						var file = new Blob([res.data], {
							type: 'application/pdf'
						});
						var fileURL = URL.createObjectURL(file);
						window.open(fileURL);
					}).catch(function (err) {
						console.log(err);
					});
				} else {
					$window.location.href = DocumentService.getDownloadLink(pj.document.id);
				}
			} else if (pj.type === 'FILE') {
				if (pj.name.includes('.pdf')) {
					CahierTransmissionService.getPDF(pj.id).then(function (res) {
						var file = new Blob([res.data], {
							type: 'application/pdf'
						});
						var fileURL = URL.createObjectURL(file);
						window.open(fileURL);
					}).catch(function (err) {
						console.log(err);
					});
				} else {
					$window.location.href = CahierTransmissionService.getDownloadLink(pj.id);
				}
			}
		}

		$scope.orderParameters = function (trace) {
			var params = angular.copy(trace.parameters);

			params.sort(function (a, b) {
				if (a.index < b.index) {
					return -1
				} else if (b.index < a.index) {
					return 1;
				} else {
					return 0;
				}
			})
			trace.parameters = params;
		}

		$scope.openHistory = function (subtrace, index) {
			TraceService.getSubtraceHistory(subtrace.id).then(function (data) {
				data.forEach(function (item) {
					$scope.orderParameters(item);
				});
				$scope.subtraceToShow = subtrace;
				$scope.subtraceHistories = data;
				$scope.historyPopup = $mdDialog.show({
					templateUrl: 'app/main/front/controle/trace/subtraces/popup/subtrace_history.html',
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true
				}).then(function () {
				}).catch(function () {
				});
			}).catch(function (err) {
				console.log(err)
				toastr.error('Une erreur est survenue');
			});
		}

		$scope.displayOrDownload = function (pj, info) {
			if ($scope.showDisplay(pj) && pj.type != 'FILE' && pj.type != 'DOC' && pj.type != 'SUBTRACE') {
				$scope.openApercuPopup(pj, info)
			} else if (pj.type === 'SUBTRACE') {
				$scope.openHistory(pj.subtrace)
			} else {
				$scope.downloadPj(pj)
			}
		}

		$scope.openEditInfo = function (info) {
			$scope.editedTags = angular.copy($scope._tags)
			$scope.editedInformation = angular.copy(info);
			for (var i = $scope.editedTags.length - 1; i >= 0; i--) {
				if (info.tags.find(t => t.id === $scope.editedTags[i].id) != null) {
					$scope.editedTags.splice(i, 1)
				}
			}
		}

		$scope.$on('fileUploaded', function () {
			var fileinput = document.getElementById("document_input_file");
			$scope.appel.nameOfDocument = "";
			for (var i = 0; i < fileinput.files.length; i++) {
				var name = fileinput.files[i].name
				$scope.appel.nameOfDocument += name ? name : "Nom du fichier indisponible";
			}
		});

		$scope.clearInputFile = function (input, id_input) {
			var elem = document.getElementById(id_input);
			elem.value = "";
			input.nameOfDocument = ""
			input.attachmentOriginalName = null
		};

		$scope.openEcor = function () {
			$scope.ecorPopup = $mdDialog.show({
				templateUrl: 'app/main/front/home/popup/ecor_popup.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {
			}).catch(function () {
			});
		}

		$scope.updatePharmacyUsers = function () {
			$scope.loading = true
			PharmacyService.updateUsers($scope.pharmacy).then(function () {
				toastr.success('Un mail d\'activation a été envoyé aux adresses mails renseignées')
				$mdDialog.hide()
				$scope.loading = false
			}).catch(function (err) {
				$scope.loading = false
				if (err.status === 409) {
					if (err.data.type === 'team') {
						toastr.error('L\'adresse mail renseignée pour l\'équipe existe déjà, veuillez en choisir une autre.')
					} else {
						toastr.error('L\'adresse mail renseignée pour le Responsable Qualité existe déjà, veuillez en choisir une autre.')
					}
				} else {
					toastr.error('Une erreur est survenue')
				}
			})
		}
		$scope.openTag = function () {
			if ($rootScope.user.isTeam) {
				toastr.error('La création d’un système de tags est réservée aux comptes Titulaire et Responsable Qualité')
				return
			}
			$scope.tagsToUpdate = angular.copy($scope._tags.filter(t => !t.notDeletable))
			if ($scope.tagsToUpdate.length === 0) {
				$scope.tagsToUpdate = [{}, {}, {}]
			}
			$mdDialog.show({
				templateUrl:
					"app/main/front/home/popup/add_tag.html",
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true,
				onRemoving: function (event, promise) {
				}
			});
		}

		$scope.deleteTag = function (index) {
			$scope.tagsToUpdate.splice(index, 1)
		}

		$scope.addTag = function () {
			if ($scope.tagsToUpdate.length < 20) {
				$scope.tagsToUpdate.push({})
			} else {
				toastr.error('Vous avez atteint le nombre maximal de tags')
			}
		}

		$scope.selectTag = function (tag, information) {
			if (information.tags.length >= 3) {
				toastr.error('Vous pouvez sélectionner 3 tags maximum')
				return
			}
			information.tags.push(tag)
			if (information.id) {
				for (var i = $scope.editedTags.length - 1; i >= 0; i--) {
					if (tag.id === $scope.editedTags[i].id) {
						$scope.editedTags.splice(i, 1)
						break
					}
				}
			} else {
				for (var i = $scope.tags.length - 1; i >= 0; i--) {
					if (tag.id === $scope.tags[i].id) {
						$scope.tags.splice(i, 1)
						break
					}
				}
			}
		}

		$scope.addReunionTag = function (information) {
			if (information.tags.length >= 3) {
				toastr.error('Le tag #Réunion sera pas ajouté car vous avez déjà 3 tags.')
				return
			}
			var tag = $scope._tags.find(t => t.libelle === '#Réunion' && t.notDeletable)
			console.log(tag)
			information.tags.push(tag)
			if (information.id) {
				for (var i = $scope.editedTags.length - 1; i >= 0; i--) {
					if (tag.id === $scope.editedTags[i].id) {
						$scope.editedTags.splice(i, 1)
						break
					}
				}
			} else {
				for (var i = $scope.tags.length - 1; i >= 0; i--) {
					if (tag.id === $scope.tags[i].id) {
						$scope.tags.splice(i, 1)
						break
					}
				}
			}
		}

		$scope.saveTags = function () {
			CahierTransmissionService.saveTags($scope.tagsToUpdate.filter(t => t.libelle)).then(function (res) {
				$scope.tags = res.data
				$scope.editedTags = angular.copy(res.data)
				$scope._tags = angular.copy(res.data)
				if ($scope.information) {
					for (var i = $scope.tags.length - 1; i >= 0; i--) {
						if ($scope.information.tags.find(t => t.id === $scope.tags[i].id) != null) {
							$scope.tags.splice(i, 1)
						}
					}
				}
				if ($scope.editedInformation) {
					for (var i = $scope.editedTags.length - 1; i >= 0; i--) {
						if ($scope.editedInformation.tags.find(t => t.id === $scope.editedTags[i].id) != null) {
							$scope.editedTags.splice(i, 1)
						}
					}
				}
				$mdDialog.hide()
			}).catch(function () {
				toastr.error('Une erreur est survenue')
			})
		}

		$scope.deleteInfTag = function (index, information) {
			if (information.id) {
				$scope.editedTags.push(information.tags[index])
				$scope.editedTags.sort((a, b) => a.libelle.localeCompare(b.libelle))
			} else {
				$scope.tags.push(information.tags[index])
				$scope.tags.sort((a, b) => a.libelle.localeCompare(b.libelle))
			}
			information.tags.splice(index, 1)
		}

		$scope.includeTag = function (tag) {
			if (tag.libelle != null) {
				tag.libelle = tag.libelle.replace(/[^a-zA-Z0-9]/g, "");
				if (tag.libelle.length > 0 && !tag.libelle.startsWith('#')) {
					tag.libelle = '#' + tag.libelle
				}
			}
		}

		$scope.filterTag = function (tag) {
			$scope.pagination.tag = tag
			$scope.getInfos(true)
		}

	}
})();

(function () {
	'use strict';

	angular.module('app.front').directive('gptFiltreMenu', gptFiltreMenu);

	/**
	 * Menu de filtres de l'espace groupement — portage de `dt-filter-menu` du CRM.
	 *
	 * Deux rangées de `md-select` figées, une par filtre déclaré, ne disaient PAS lesquels
	 * mordaient : un menu resté sur « Tous » et un menu posé sur « Actif » se ressemblaient trait
	 * pour trait. On reprend donc le montage du CRM, qui inverse la logique :
	 *
	 *   - un seul point d'entrée, « Ajouter un filtre », qui ouvre la liste des champs puis, en
	 *     cascade, les valeurs du champ choisi ;
	 *   - chaque filtre posé devient une ÉTIQUETTE affichée à côté du bouton, retirable d'un clic.
	 *
	 * L'écran ne montre ainsi que ce qui est appliqué, jamais ce qui ne l'est pas.
	 *
	 * ⚠️ Le type de contrôle n'est pas écrit ici : il vient des métadonnées servies par le CRM
	 * (`/pharmacies/filtres`, `/audits/filtres`), qui décident d'après les données réelles — liste
	 * de valeurs quand la colonne en compte peu, champ « contient » au-delà de 50. La directive ne
	 * connaît aucune colonne en dur, c'est ce qui lui permet de servir les deux écrans.
	 *
	 * ⚠️ Un seul filtre par champ : choisir une autre valeur remplace la précédente. Le CRM
	 * construit une égalité SQL par clé de filtre (`buildFilterConditions`), il n'y a pas de
	 * clause `IN` — poser deux valeurs sur le même champ ne donnerait aucune ligne.
	 */

	// Suffixes d'opérateur, alignés sur ceux du CRM (`utils/DtFilter.ts`). Le nom du paramètre
	// porte l'opérateur : le back n'a pas à deviner si `ville=Lyon` veut dire « égal » ou
	// « contient ». LQO relaie les paramètres tels quels, la grammaire doit donc être la même
	// des deux côtés — un suffixe inventé ici serait ignoré en silence par le CRM.
	var SUF_LIKE = '_like';
	var SUF_FROM = '_from';
	var SUF_TO = '_to';
	var SUF_SET = '_set';
	var SUFFIXES = [SUF_LIKE, SUF_FROM, SUF_TO, SUF_SET];

	/** Au-delà de ce nombre de valeurs, la liste reçoit son propre champ de recherche. */
	var SEUIL_RECHERCHE = 12;

	/** Sépare une clé de filtre en (champ, suffixe d'opérateur). */
	function decouper(cle) {
		for (var i = 0; i < SUFFIXES.length; i++) {
			var suffixe = SUFFIXES[i];
			if (cle.length > suffixe.length && cle.indexOf(suffixe, cle.length - suffixe.length) !== -1) {
				return { champ: cle.slice(0, -suffixe.length), suffixe: suffixe };
			}
		}
		return { champ: cle, suffixe: '' };
	}

	/** @ngInject */
	function gptFiltreMenu($rootScope) {
		return {
			restrict: 'E',
			templateUrl: 'app/main/front/groupement/gpt-filtre-menu.html',
			scope: {
				/**
				 * Champs filtrables, DANS L'ORDRE DU TABLEAU. Fonction et non valeur : les écrans
				 * la calculent (`filtresVisibles()`) et rendent un tableau neuf à chaque appel —
				 * une liaison `<` s'y verrait un changement à chaque cycle de digest.
				 */
				colonnes: '&',
				/** Métadonnées servies par le CRM : `{ cle: { type, options } }`. */
				metas: '=',
				/** Filtres posés, partagés avec l'écran : `{ cle: valeur }`. */
				filtres: '=',
				/** Libellés lisibles de certaines valeurs techniques : `{ cle: { brut: lisible } }`. */
				libelles: '=',
				/** Appelée après chaque pose ou retrait — c'est l'écran qui recharge. */
				onChange: '&',
				/** Remise à zéro complète, recherche comprise : c'est l'écran qui sait la vider. */
				onReset: '&'
			},
			link: function ($scope, $element) {
				link($scope, $element, $rootScope);
			}
		};
	}

	function link($scope, $element, $rootScope) {
		/** Saisies « contient » en cours, non encore validées par Entrée. */
		$scope.brouillon = {};
		/** Recherche dans la liste de valeurs d'un champ, quand elle est longue. */
		$scope.rechercheOption = {};
		/**
		 * Étiquettes des filtres posés. Recalculées sur changement et NON à la volée : un tableau
		 * d'objets neufs rendu à chaque digest ferait boucler `ng-repeat`.
		 */
		$scope.chips = [];

		/**
		 * Bornes de date en cours d'édition. Le champ date de l'application (`md-datepicker`)
		 * travaille en objet `Date`, alors que le filtre voyage en ISO : les deux formes ne
		 * peuvent pas partager la même case.
		 */
		$scope.bornesDate = {};

		/** Calendriers ouverts, une entrée par borne (`md-is-open` est à double sens). */
		$scope.calendriers = {};

		/**
		 * ⚠️ Le clic est RETENU ici. Sans cela il remonte au menu Material, qui referme la
		 * cascade sous le calendrier qui vient de s'ouvrir — le champ paraîtrait alors inerte.
		 *
		 * ⚠️ Et pas de `md-open-on-focus` : Material donne le focus au premier élément d'un
		 * sous-menu dès son ouverture, le calendrier s'ouvrirait donc tout seul sur la borne
		 * « Du » avant qu'on ait rien demandé.
		 */
		$scope.ouvrirCalendrier = function (cle, $event) {
			if ($event) {
				$event.stopPropagation();
			}
			$scope.calendriers[cle] = true;
		};

		$scope.metaDe = function (cle) {
			return ($scope.metas || {})[cle] || null;
		};

		/** Champs réellement proposables : ceux dont le CRM a décrit le contrôle à afficher. */
		$scope.colonnesFiltrables = function () {
			var self = $scope;
			return ($scope.colonnes() || []).filter(function (colonne) {
				return !!self.metaDe(colonne.cle);
			});
		};

		$scope.typeDe = function (cle) {
			var meta = $scope.metaDe(cle);
			return meta ? meta.type : null;
		};

		/**
		 * Vrai quand le champ libre cherche un DÉBUT de valeur et non une sous-chaîne. Décidé par
		 * le CRM colonne par colonne (`prefix` dans `utils/DtFilter.ts`) : le code postal est le
		 * seul concerné, « 75 » devant rendre Paris et non les 33750. L'écran n'en déduit que le
		 * vocabulaire — la condition SQL, elle, est posée côté CRM.
		 */
		$scope.estPrefixe = function (cle) {
			var meta = $scope.metaDe(cle);
			return !!(meta && meta.prefix);
		};

		$scope.libelleValeur = function (cle, valeur) {
			var table = ($scope.libelles || {})[cle];
			if (table && table[valeur]) {
				return table[valeur];
			}
			// Les booléens voyagent en « oui »/« non » : c'est la convention du CRM, pas un
			// libellé d'écran.
			if ($scope.typeDe(cle) === 'bool') {
				return valeur === 'oui' ? 'Oui' : 'Non';
			}
			// Les dates voyagent en ISO et se lisent en JJ/MM/AAAA (16/09/2026), comme dans les
			// colonnes : « à partir du 2025-01-01 » sur une étiquette posée au calendrier français
			// se lisait comme une autre date que celle qu'on venait de choisir.
			if ($scope.typeDe(cle) === 'date') {
				var iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valeur);
				if (iso) {
					return iso[3] + '/' + iso[2] + '/' + iso[1];
				}
			}
			return valeur;
		};

		/**
		 * Vrai si CETTE valeur est celle qui est posée sur ce champ.
		 *
		 * ⚠️ Sans ce repère, rien dans le menu ne disait ce qui était appliqué — et comme Material
		 * donne le focus au premier bouton dès l'ouverture d'un sous-menu, le premier choix se
		 * lisait comme la sélection courante : on croyait avoir posé « Renseigné » alors qu'on
		 * venait de choisir « Non renseigné ».
		 */
		$scope.estPosee = function (cle, valeur) {
			return !!$scope.filtres && $scope.filtres[cle] === valeur;
		};

		$scope.listeLongue = function (cle) {
			var meta = $scope.metaDe(cle);
			return !!(meta && meta.options && meta.options.length > SEUIL_RECHERCHE);
		};

		/**
		 * Valeurs proposées pour un champ, restreintes par la recherche du menu.
		 *
		 * ⚠️ Rendre `meta.options` tel quel quand la recherche est vide n'est pas une optimisation
		 * gratuite : `ng-repeat` compare la collection élément par élément, et une liste de
		 * chaînes reconstruite reste égale à la précédente — mais la référence stable évite le
		 * travail inutile sur les longues listes de villes.
		 */
		$scope.optionsVisibles = function (cle) {
			var meta = $scope.metaDe(cle);
			var toutes = (meta && meta.options) || [];
			var recherche = ($scope.rechercheOption[cle] || '').trim().toLowerCase();
			if (recherche === '') {
				return toutes;
			}
			var self = $scope;
			return toutes.filter(function (option) {
				return self.libelleValeur(cle, option).toString().toLowerCase().indexOf(recherche) !== -1;
			});
		};

		/** Pose un filtre, ou le retire si la valeur est vide. */
		$scope.poser = function (cle, valeur) {
			if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
				delete $scope.filtres[cle];
			} else {
				$scope.filtres[cle] = valeur;
			}
			$scope.rechercheOption = {};
			construireChips();
			$scope.onChange();
		};

		$scope.retirer = function (cle) {
			$scope.poser(cle, null);
		};

		/**
		 * ⚠️ La remise à zéro est déléguée à l'écran et non faite ici : elle doit aussi vider la
		 * recherche, qui ne passe pas par cette directive. L'écran, lui, réaffecte `filtres` à
		 * `{}` — les étiquettes suivent par la liaison, il n'y a rien à reconstruire d'ici.
		 */
		$scope.toutEffacer = function () {
			$scope.onReset();
		};

		/**
		 * Borne numérique : le champ écrit directement dans `filtres`, on se contente de nettoyer
		 * la clé quand il est vidé et de prévenir l'écran.
		 */
		$scope.majBorne = function (cle) {
			$scope.poser(cle, $scope.filtres[cle]);
		};

		$scope.majBorneDate = function (cle) {
			var date = $scope.bornesDate[cle];
			var valide = date instanceof Date && !isNaN(date.getTime());
			$scope.poser(cle, valide ? enIso(date) : null);
		};

		/**
		 * ⚠️ Date locale et non `toISOString()` : celui-ci passe par UTC et rend la veille pour
		 * toute heure du matin en heure d'été française.
		 */
		function enIso(date) {
			var mois = date.getMonth() + 1;
			var jour = date.getDate();
			return date.getFullYear() + '-' + (mois < 10 ? '0' : '') + mois + '-' + (jour < 10 ? '0' : '') + jour;
		}

		/**
		 * Recale les champs de date sur les filtres posés, et vide ceux qui ont été retirés.
		 *
		 * ⚠️ Une borne sans filtre vaut `null`, et n'est PAS supprimée : le champ date de
		 * l'application affiche la date du jour quand son modèle est absent — `formatDate` du
		 * `$mdDateLocaleProvider` passe par `moment(undefined)`, qui vaut « maintenant ». À
		 * `null`, moment est invalide et l'invite « jj/mm/aaaa » revient. Sans cela, les deux
		 * bornes s'ouvraient sur aujourd'hui et se lisaient comme un filtre déjà posé.
		 */
		function synchroniserBornesDate() {
			var filtres = $scope.filtres || {};
			angular.forEach(Object.keys($scope.bornesDate), function (cle) {
				if (!filtres.hasOwnProperty(cle)) {
					$scope.bornesDate[cle] = null;
				}
			});
			// Même raison à l'autre bout : la borne doit EXISTER à `null` avant le premier rendu
			// du champ, donc dès que les métadonnées ont dit quels champs sont des dates.
			angular.forEach($scope.colonnesFiltrables(), function (colonne) {
				if ($scope.typeDe(colonne.cle) !== 'date') {
					return;
				}
				angular.forEach([SUF_FROM, SUF_TO], function (suffixe) {
					var cle = colonne.cle + suffixe;
					if (!filtres.hasOwnProperty(cle) && !$scope.bornesDate[cle]) {
						$scope.bornesDate[cle] = null;
					}
				});
			});
			angular.forEach(filtres, function (valeur, cle) {
				var partie = decouper(cle);
				if (partie.suffixe !== SUF_FROM && partie.suffixe !== SUF_TO) {
					return;
				}
				if ($scope.typeDe(partie.champ) !== 'date') {
					return;
				}
				var courante = $scope.bornesDate[cle];
				if (!(courante instanceof Date) || enIso(courante) !== valeur) {
					$scope.bornesDate[cle] = new Date(valeur + 'T00:00:00');
				}
			});
		}

		/**
		 * Le menu Material capte les touches pour sa navigation clavier — flèches, Entrée — et
		 * s'arrête à la première qu'il reconnaît (`stopImmediatePropagation`). Sans cette coupure,
		 * une flèche gauche tapée dans un champ fermerait le sous-menu au lieu de déplacer le
		 * curseur. Échap reste transmis : c'est ainsi qu'on referme.
		 */
		$scope.toucheChamp = function ($event) {
			if ($event.keyCode !== 27) {
				$event.stopPropagation();
			}
		};

		/** Champ libre (« contient » / « commence par ») : la saisie n'est appliquée qu'à la validation. */
		$scope.toucheTexte = function ($event, cle) {
			$scope.toucheChamp($event);
			if ($event.keyCode !== 13) {
				return;
			}
			var valeur = ($scope.brouillon[cle] || '').trim();
			if (valeur !== '') {
				$scope.poser(cle + SUF_LIKE, valeur);
				$scope.brouillon[cle] = '';
			}
		};

		/**
		 * Étiquettes en TROIS morceaux — champ, opérateur, valeur — et non une phrase d'un seul
		 * tenant : « Statut : Actif » écrit d'un bloc oblige à lire toute la phrase pour trouver
		 * l'information, alors que c'est la valeur qu'on cherche. `titre` garde la phrase entière
		 * pour l'infobulle et le nom accessible du bouton de retrait.
		 *
		 * Une plage produit DEUX étiquettes, chacune retirable séparément.
		 */
		function construireChips() {
			synchroniserBornesDate();
			var colonnes = $scope.colonnes() || [];
			var rang = {};
			var libelles = {};
			angular.forEach(colonnes, function (colonne, index) {
				rang[colonne.cle] = index;
				libelles[colonne.cle] = colonne.libelle;
			});

			var chips = [];
			angular.forEach($scope.filtres || {}, function (valeur, cle) {
				if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
					return;
				}
				var partie = decouper(cle);
				// Un filtre portant sur un champ que l'écran ne propose pas (la vue consolidée
				// vient d'être quittée, par exemple) n'a plus d'étiquette : il serait autrement
				// impossible à retirer, puisque son menu a disparu.
				if (!libelles.hasOwnProperty(partie.champ)) {
					return;
				}
				chips.push(construireChip(cle, partie, libelles[partie.champ], valeur, rang[partie.champ]));
			});

			chips.sort(function (a, b) {
				return (a.rang - b.rang) || a.suffixe.localeCompare(b.suffixe);
			});
			$scope.chips = chips;
		}

		function construireChip(cle, partie, libelleChamp, valeur, rang) {
			var lisible = $scope.libelleValeur(partie.champ, valeur);
			var nombre = $scope.typeDe(partie.champ) === 'number';

			function chip(operateur, valeurAffichee, titre) {
				return {
					cle: cle,
					rang: rang,
					suffixe: partie.suffixe,
					champ: libelleChamp,
					operateur: operateur,
					valeur: valeurAffichee,
					titre: titre
				};
			}

			if (partie.suffixe === SUF_LIKE) {
				var operateur = $scope.estPrefixe(partie.champ) ? 'commence par' : 'contient';
				return chip(operateur, '« ' + lisible + ' »', libelleChamp + ' ' + operateur + ' « ' + lisible + ' »');
			}
			if (partie.suffixe === SUF_FROM) {
				return nombre
					? chip('au moins', lisible, libelleChamp + ' : au moins ' + lisible)
					: chip('à partir du', lisible, libelleChamp + ' à partir du ' + lisible);
			}
			if (partie.suffixe === SUF_TO) {
				return nombre
					? chip('au plus', lisible, libelleChamp + ' : au plus ' + lisible)
					: chip('jusqu\'au', lisible, libelleChamp + ' jusqu\'au ' + lisible);
			}
			if (partie.suffixe === SUF_SET) {
				var etat = valeur === 'oui' ? 'renseigné' : 'non renseigné';
				return chip('', etat, libelleChamp + ' : ' + etat);
			}
			return chip('', lisible, libelleChamp + ' : ' + lisible);
		}

		// Les filtres changent aussi HORS de la directive : les chiffres clés du parc en posent
		// (`basculerIndicateur`), « Réinitialiser » les vide, un changement de réseau les remplace
		// par un objet neuf. `$watchCollection` suit les trois cas.
		$scope.$watchCollection(function () {
			return $scope.filtres;
		}, construireChips);

		// La liste des champs bouge quand on entre ou sort de la vue consolidée : « Groupement »
		// apparaît ou disparaît, et son étiquette avec lui.
		$scope.$watch(function () {
			return ($scope.colonnes() || []).length;
		}, construireChips);

		// Les métadonnées arrivent APRÈS le premier rendu — c'est un appel au CRM. Elles seules
		// disent quels champs sont des dates : sans cette veille, leurs bornes n'auraient jamais
		// leur valeur initiale.
		$scope.$watch('metas', construireChips);

		/**
		 * Un seul sous-menu ouvert à la fois — c'est nous qui devons y veiller.
		 *
		 * ⚠️ Angular Material ferme le sous-menu précédent en s'appuyant sur `currentlyOpenMenu`,
		 * qu'il tient à jour au fil des événements `$mdMenuOpen` / `$mdMenuClose`. En balayant vite
		 * la liste des champs, l'ouverture du suivant part AVANT que celle du précédent ne soit
		 * enregistrée : la référence vaut alors `undefined`, la branche « ferme puis ouvre » est
		 * sautée, et deux listes de valeurs restent superposées — définitivement, ce n'est pas une
		 * animation qui traîne.
		 *
		 * ⚠️ L'événement est émis AVANT `$mdMenu.show()`. C'est ce qui rend ce rattrapage possible :
		 * le menu qui s'ouvre n'est pas encore sur la pile, donc `close()` — qui dépile le dernier
		 * élément — retire bien le périmé et non le nouveau. Une fermeture faite après l'ouverture
		 * refermerait celui qu'on vient de demander.
		 */
		var arreterEcouteMenu = $rootScope.$on('$mdMenuOpen', function (evenement, element) {
			var racine = conteneurRacine();
			if (!racine || !racine.contains(element[0])) {
				return;
			}
			// Le conteneur du sous-menu est encore fils de son `md-menu` : c'est le moment de le
			// marquer, après quoi Material l'emporte sous `<body>`.
			marquer(element[0].querySelector('.md-open-menu-container'));

			angular.forEach(racine.querySelectorAll('md-menu'), function (autre) {
				if (autre === element[0]) {
					return;
				}
				var controleur = angular.element(autre).controller('mdMenu');
				if (controleur && controleur.isOpen) {
					controleur.close(true);
				}
			});
		});
		$scope.$on('$destroy', arreterEcouteMenu);

		/**
		 * Le conteneur du menu racine. Material le déplace sous `<body>` à la première ouverture :
		 * on le retrouve donc par la référence gardée ici, et non en repartant de la directive.
		 */
		var racineMemorisee = null;
		function conteneurRacine() {
			if (!racineMemorisee) {
				racineMemorisee = $element[0].querySelector('.md-open-menu-container');
				marquer(racineMemorisee);
			}
			return racineMemorisee;
		}

		/** Rend un conteneur de menu reconnaissable par la feuille de style (durées d'animation). */
		function marquer(conteneur) {
			if (conteneur) {
				conteneur.classList.add('gpt-menu-conteneur');
			}
		}
	}
})();

(function () {
	'use strict';

	angular.module('fuse').service('EspaceGroupementService', EspaceGroupementService);

	/**
	 * Accès aux écrans « Mes pharmacies » — servis en direct par le CRM, relayés par LQO.
	 *
	 * ⚠️ Aucune donnée n'est recopiée ici : la fraîcheur est celle du CRM à l'instant où l'on
	 * regarde (§10 de la spécification). Quand il ne répond pas, le back rend un 503 avec le
	 * message d'attente, que les écrans affichent tel quel.
	 *
	 * `groupementId` est le CODE DU GROUPEMENT DANS LE CRM, tel que le sélecteur de la barre du
	 * haut le fournit. Absent = vue consolidée sur tous les groupements de l'utilisateur.
	 */
	function EspaceGroupementService($q, $http, $window, $document) {
		var BASE = '/api/rest/espace-groupement';

		/** Message affiché quand le CRM est indisponible ; le back en fournit déjà le texte. */
		var MESSAGE_INDISPONIBLE = 'Données momentanément indisponibles, réessayez dans quelques instants.';

		function params(groupementId, extra) {
			var query = angular.extend({ '_v': new Date().getTime() }, extra || {});
			if (groupementId) {
				query.groupementId = groupementId;
			}
			// Les valeurs vides ne partent pas : le back relaie tout au CRM, et un filtre vide y
			// serait une condition inutile de plus.
			angular.forEach(query, function (value, key) {
				if (value === null || angular.isUndefined(value) || value === '') {
					delete query[key];
				}
			});
			return query;
		}

		/** Enveloppe commune : rend la charge utile, ou une erreur portant un message affichable. */
		function get(url, query) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: query,
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		function send(method, url, query, body) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: method,
					params: query,
					data: body,
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		/**
		 * Normalise l'échec en `{ status, message, indisponible }`.
		 * Le 503 est distingué : ce n'est pas une erreur de l'utilisateur, c'est une panne passagère
		 * du CRM, et l'écran propose alors de réessayer plutôt que d'accuser la saisie.
		 */
		function toError(response) {
			var status = response ? response.status : 0;
			var data = response ? response.data : null;
			var message = data && data.message ? data.message : null;
			if (status === 503 || status === -1 || status === 0) {
				return { status: status, message: message || MESSAGE_INDISPONIBLE, indisponible: true };
			}
			if (status === 404) {
				return {
					status: status,
					message: message || 'Cette pharmacie ne fait pas partie de votre périmètre.',
					indisponible: false
				};
			}
			return {
				status: status,
				message: message || 'Une erreur est survenue, veuillez réessayer plus tard.',
				indisponible: false
			};
		}

		/**
		 * Téléchargement d'un flux binaire (exports Excel, fiche Word, document).
		 * Le jeton de session voyage par cookie, mais le nom du fichier est dans l'en-tête :
		 * on passe donc par un Blob plutôt que par un simple lien.
		 */
		function download(url, query, nomParDefaut) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: query,
					responseType: 'arraybuffer'
				}).then(function (response) {
					var type = (response.headers('Content-Type') || 'application/octet-stream').split(';')[0];
					var blob = new Blob([response.data], { type: type });
					var nom = parseFilename(response.headers('Content-Disposition')) || nomParDefaut;
					var objectUrl = $window.URL.createObjectURL(blob);
					// ⚠️ Le lien est créé puis retiré : un `href` direct ne permettrait pas de
					// nommer le fichier d'après l'en-tête Content-Disposition.
					var racine = $document[0];
					var link = racine.createElement('a');
					link.href = objectUrl;
					link.download = nom;
					racine.body.appendChild(link);
					link.click();
					racine.body.removeChild(link);
					$window.URL.revokeObjectURL(objectUrl);
					resolve(nom);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		/** Nom de fichier proposé par le serveur, `filename*=UTF-8''` compris. */
		function parseFilename(disposition) {
			if (!disposition) {
				return null;
			}
			var utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
			if (utf8 && utf8[1]) {
				try {
					return decodeURIComponent(utf8[1]);
				} catch (error) {
					return utf8[1];
				}
			}
			var simple = /filename="?([^";]+)"?/i.exec(disposition);
			return simple && simple[1] ? simple[1] : null;
		}

		// ---------------------------------------------------------------- Écran A : le parc

		this.getPharmacies = function (groupementId, query) {
			return get(BASE + '/pharmacies', params(groupementId, query));
		};

		this.getCompteurs = function (groupementId, query) {
			return get(BASE + '/pharmacies/compteurs', params(groupementId, query));
		};

		this.getFiltresPharmacies = function (groupementId) {
			return get(BASE + '/pharmacies/filtres', params(groupementId));
		};

		this.exporterParc = function (groupementId, query) {
			return download(BASE + '/pharmacies/export', params(groupementId, query), 'pharmacies.xlsx');
		};

		// ------------------------------------------------------- Écran B : la fiche pharmacie

		this.getFiche = function (groupementId, reference) {
			return get(BASE + '/pharmacies/' + encodeURIComponent(reference), params(groupementId));
		};

		this.getContacts = function (groupementId, reference) {
			return get(BASE + '/pharmacies/' + encodeURIComponent(reference) + '/contacts', params(groupementId));
		};

		this.getAuditsDePharmacie = function (groupementId, reference) {
			return get(BASE + '/pharmacies/' + encodeURIComponent(reference) + '/audits', params(groupementId));
		};

		this.exporterFicheWord = function (groupementId, reference, nom) {
			return download(BASE + '/pharmacies/' + encodeURIComponent(reference) + '/fiche.docx',
				params(groupementId), 'fiche-' + (nom || reference) + '.docx');
		};

		this.modifierCoordonnees = function (groupementId, reference, coordonnees) {
			return send('PUT', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/coordonnees',
				params(groupementId), coordonnees);
		};

		/**
		 * Contacts en écriture (16/09/2026) — les quatre gestes rendent la LISTE à jour, que
		 * l'écran réaffiche telle quelle plutôt que de recomposer son état à partir d'un
		 * enregistrement isolé.
		 *
		 * L'e-mail principal se modifie directement (PHSQ-237) : le contact garde son identité dans
		 * le CRM, qui contrôle le format (400) et l'unicité sur la plateforme (409).
		 */
		function contactsUrl(reference, contactId, action) {
			var url = BASE + '/pharmacies/' + encodeURIComponent(reference) + '/contacts';
			if (contactId) {
				url += '/' + encodeURIComponent(contactId);
			}
			return action ? url + '/' + action : url;
		}

		this.creerContact = function (groupementId, reference, contact) {
			return send('POST', contactsUrl(reference), params(groupementId), contact);
		};

		this.modifierContact = function (groupementId, reference, contactId, contact) {
			return send('PUT', contactsUrl(reference, contactId), params(groupementId), contact);
		};

		this.archiverContact = function (groupementId, reference, contactId) {
			return send('POST', contactsUrl(reference, contactId, 'archiver'), params(groupementId), null);
		};

		this.definirContactPrincipal = function (groupementId, reference, contactId) {
			return send('POST', contactsUrl(reference, contactId, 'principal'), params(groupementId), null);
		};

		/**
		 * Palier de couleur d'« écart levé », partagé par la liste d'audits et l'onglet Audits
		 * d'une fiche : sans source unique, les deux écrans finissaient par diverger sur la même
		 * information. Le CRM colore « Non » en rouge et non en gris — un écart non levé est un
		 * reste à traiter, pas une absence de donnée.
		 */
		this.niveauEcartLeve = function (valeur) {
			var texte = (valeur || '').toString().trim().toLowerCase();
			if (texte === 'oui') {
				return 'oui';
			}
			if (texte === 'non') {
				return 'ko';
			}
			if (texte === 'en cours') {
				return 'encours';
			}
			return 'neutre';
		};

		this.ajouterCommentaire = function (groupementId, reference, contenu) {
			return send('POST', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/commentaires',
				params(groupementId), { contenu: contenu });
		};

		this.supprimerCommentaire = function (groupementId, reference, commentaireId) {
			return send('DELETE', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/commentaires/'
				+ encodeURIComponent(commentaireId), params(groupementId));
		};

		this.supprimerDocument = function (groupementId, reference, documentId) {
			return send('DELETE', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/documents/'
				+ encodeURIComponent(documentId), params(groupementId));
		};

		/**
		 * Dépôt d'un document : multipart, donc `Content-Type` laissé au navigateur (il doit y
		 * poser la frontière). Tous formats, 25 Mo — le contrôle antiviral est fait par le CRM.
		 */
		this.deposerDocument = function (groupementId, reference, fichier, titre) {
			return $q(function (resolve, reject) {
				var formData = new FormData();
				formData.append('file', fichier);
				if (titre) {
					formData.append('titre', titre);
				}
				$http({
					url: BASE + '/pharmacies/' + encodeURIComponent(reference) + '/documents',
					method: 'POST',
					params: params(groupementId),
					data: formData,
					headers: { 'Content-Type': undefined },
					transformRequest: angular.identity
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		};

		this.telechargerDocument = function (groupementId, documentId, nom) {
			return download(BASE + '/documents/' + encodeURIComponent(documentId), params(groupementId),
				nom || 'document');
		};

		// ----------------------------------------- Sortie de groupement (PHSQ-220, chapitre 06)

		/**
		 * La déclaration de sortie de l'officine, telle que le CRM la sert au groupement : l'ouverte,
		 * quelle que soit son origine, sinon la dernière close déposée par lui, sinon `null` — une
		 * réponse valide, pas une absence (règle P11).
		 *
		 * ⚠️ La FORME dépend de qui a déclaré, et c'est le CRM qui l'ampute : complète quand
		 * l'officine a déclaré (R15) ou quand c'est ce groupement ; quatre clés quand c'est PHSQ ou
		 * un autre groupement (R26). L'écran lit ce qu'il reçoit, il ne masque rien.
		 */
		this.sortie = function (groupementId, reference) {
			return get(BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie', params(groupementId));
		};

		/**
		 * Déclarer la sortie — responsable seul, vérifié par le back. Le corps ne porte que le motif
		 * et les précisions : la destination ne se déclare pas d'ici (R17, 400 si elle est envoyée).
		 */
		this.declarerSortie = function (groupementId, reference, corps) {
			return send('POST', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie',
				params(groupementId), corps);
		};

		this.retirerSortie = function (groupementId, reference, declarationId) {
			return send('DELETE', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie/'
				+ encodeURIComponent(declarationId), params(groupementId));
		};

		/** Les causes de sortie : la même liste que le formulaire de l'officine (R17). */
		this.causesSortie = function (groupementId) {
			return get(BASE + '/causes-sortie', params(groupementId));
		};

		// ------------------------- Sortie de la démarche qualité (PHSQ-220, spécification § 8.2)

		/**
		 * La demande de sortie qualité de l'officine : l'ouverte, quelle que soit son origine ; sinon la
		 * dernière close déposée par CE groupement ; sinon `null` (contrat sortie-qualite § 3.2).
		 *
		 * ⚠️ Comme pour la sortie de groupement, c'est le CRM qui ampute : complète quand ce groupement
		 * ou l'officine l'a déposée, quatre clés (`id`, `origine`, `etat`, `retraitPossible`) quand
		 * c'est PHSQ ou un autre groupement.
		 */
		this.sortieQualite = function (groupementId, reference) {
			return get(BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie-qualite',
				params(groupementId));
		};

		/**
		 * Déposer la demande — responsable seul, vérifié par le back. Le corps ne porte que
		 * `raisonIds`, `dateSouhaitee` et `commentaires` : ni recommandation ni engagements, que seule
		 * l'officine peut donner (spécification § 5.1 ; le CRM répond 400 s'ils sont envoyés).
		 */
		this.declarerSortieQualite = function (groupementId, reference, corps) {
			return send('POST', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie-qualite',
				params(groupementId), corps);
		};

		this.retirerSortieQualite = function (groupementId, reference, demandeId) {
			return send('DELETE', BASE + '/pharmacies/' + encodeURIComponent(reference) + '/sortie-qualite/'
				+ encodeURIComponent(demandeId), params(groupementId));
		};

		/** Les raisons de sortie qualité : le référentiel dédié, le même que pour l'officine (Q7). */
		this.raisonsSortieQualite = function (groupementId) {
			return get(BASE + '/raisons-sortie-qualite', params(groupementId));
		};

		/** « 2026-10-12 » → « 12 octobre 2026 », lu sur ses chiffres (pas de fuseau pour une date seule). */
		this.dateIso = function (chaine) {
			var morceaux = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(chaine || ''));
			if (!morceaux) {
				return '';
			}
			return Number(morceaux[3]) + ' ' + MOIS[Number(morceaux[2]) - 1] + ' ' + morceaux[1];
		};

		var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août',
			'septembre', 'octobre', 'novembre', 'décembre'];

		/**
		 * « 21 septembre 2026 » — le même rendu que l'espace officine, qui lit le même refus au mot
		 * près. Écrit ici plutôt que confié au filtre `date` : la locale française d'AngularJS
		 * n'est pas chargée partout.
		 */
		this.dateLongue = function (horodatage) {
			if (horodatage === null || angular.isUndefined(horodatage) || horodatage === '') {
				return '';
			}
			var date = new Date(Number(horodatage));
			if (isNaN(date.getTime())) {
				return '';
			}
			return date.getDate() + ' ' + MOIS[date.getMonth()] + ' ' + date.getFullYear();
		};

		// ------------------------------------------------- Écrans C et D : les audits

		this.getAudits = function (groupementId, query) {
			return get(BASE + '/audits', params(groupementId, query));
		};

		this.getFiltresAudits = function (groupementId) {
			return get(BASE + '/audits/filtres', params(groupementId));
		};

		this.getFicheAudit = function (groupementId, auditId) {
			return get(BASE + '/audits/' + encodeURIComponent(auditId), params(groupementId));
		};

		this.exporterAudits = function (groupementId, query) {
			return download(BASE + '/audits/export', params(groupementId, query), 'audits.xlsx');
		};

		/**
		 * Commentaires de fiche d'audit (16/09/2026) : mêmes règles que ceux de la fiche pharmacie
		 * — ouverts aux deux niveaux, chacun ne supprimant que les siens.
		 */
		this.ajouterCommentaireAudit = function (groupementId, auditId, contenu) {
			return send('POST', BASE + '/audits/' + encodeURIComponent(auditId) + '/commentaires',
				params(groupementId), { contenu: contenu });
		};

		this.supprimerCommentaireAudit = function (groupementId, auditId, commentaireId) {
			return send('DELETE', BASE + '/audits/' + encodeURIComponent(auditId) + '/commentaires/'
				+ encodeURIComponent(commentaireId), params(groupementId));
		};
	}
})();

(function () {
	'use strict';

	angular.module('fuse').service('ConfirmationGroupement', ConfirmationGroupement);

	/**
	 * Boîte de confirmation de l'espace groupement.
	 *
	 * Remplace `$mdDialog.confirm()`, dont le gabarit intégré ne se laisse ni habiller ni
	 * structurer : titre et texte y sont deux blocs nus, et les actions deux boutons plats du
	 * thème Material, sans hiérarchie entre « Annuler » et l'action destructrice.
	 *
	 * ⚠️ La boîte est montée par `$mdDialog` dans `<body>`, DONC HORS de `.gpt-page`. Toutes les
	 * règles de `groupement.scss` étant imbriquées sous cette classe, elles ne l'atteindraient
	 * pas : le style de `gpt-confirm` est défini à la racine de la feuille, pas dans le bloc de
	 * l'écran.
	 */
	/** @ngInject */
	function ConfirmationGroupement($mdDialog) {

		var GABARIT =
			'<md-dialog class="gpt-confirm {{classe}}" role="alertdialog" aria-label="{{titre}}">' +
			'  <div class="gpt-confirm__corps">' +
			'    <span class="gpt-confirm__icone" ng-class="{\'gpt-confirm__icone--danger\': danger}">' +
			'      <md-icon md-font-icon="{{danger ? \'icon-delete\' : \'icon-help-circle\'}}" class="s20"></md-icon>' +
			'    </span>' +
			'    <div class="gpt-confirm__texte">' +
			'      <h2 class="gpt-confirm__titre">{{titre}}</h2>' +
			'      <p class="gpt-confirm__message">{{texte}}</p>' +
			'      <p class="gpt-confirm__detail" ng-if="detail">{{detail}}</p>' +
			'    </div>' +
			'  </div>' +
			'  <div class="gpt-confirm__actions">' +
			'    <button type="button" class="gpt-confirm__btn gpt-confirm__btn--fantome"' +
			'            ng-click="annuler()" md-autofocus>{{libelleAnnuler}}</button>' +
			'    <button type="button" class="gpt-confirm__btn"' +
			'            ng-class="danger ? \'gpt-confirm__btn--danger\' : \'gpt-confirm__btn--principal\'"' +
			'            ng-click="valider()">{{libelleConfirmer}}</button>' +
			'  </div>' +
			'</md-dialog>';

		/** @ngInject */
		function ControleurConfirmation($scope, $mdDialog, options) {
			$scope.titre = options.titre;
			$scope.texte = options.texte;
			// Deuxième ligne facultative : ce qu'on supprime au juste, quand le titre ne suffit
			// pas à l'identifier — un document parmi plusieurs, par exemple.
			$scope.detail = options.detail;
			$scope.danger = options.danger !== false;
			$scope.libelleConfirmer = options.confirmer || 'Confirmer';
			$scope.libelleAnnuler = options.annuler || 'Annuler';
			$scope.classe = options.classe || '';

			$scope.valider = function () {
				$mdDialog.hide(true);
			};
			$scope.annuler = function () {
				$mdDialog.cancel();
			};
		}

		/**
		 * @param options {titre, texte, detail, confirmer, annuler, danger, event, classe}
		 *        `classe` : classe ajoutée à la boîte pour l'habiller hors de l'espace groupement
		 *        (PHSQ-240 : `osy-confirm`, boutons du module OSyS et de l'administration).
		 * @return promesse RÉSOLUE si l'utilisateur confirme, REJETÉE SANS VALEUR s'il renonce.
		 *         L'appelant distingue ainsi le renoncement d'un échec, qui rejette avec l'erreur.
		 */
		this.demander = function (options) {
			return $mdDialog.show({
				template: GABARIT,
				controller: ControleurConfirmation,
				locals: { options: options || {} },
				// Le focus part sur « Annuler » (md-autofocus) : une frappe sur Entrée par réflexe
				// ne doit pas déclencher la suppression.
				targetEvent: (options || {}).event,
				clickOutsideToClose: true,
				escapeToClose: true,
				focusOnOpen: true
			});
		};
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('FoldersController', FoldersController);

  function FoldersController($rootScope, $scope, $state, FolderService, DocumentService, toastr, $window, $mdDialog, $q, UserService) {
    $scope.filter = {
      searchTxt: ''
    };
    var isDocumentationState = function (stateName) {
      return angular.isString(stateName) && (stateName === 'app.folders' || stateName.indexOf('app.category') === 0);
    };
    var isDocumentationUrl = function (url) {
      if (!angular.isString(url) || url.length === 0) {
        return false;
      }
      var parser = $window.document.createElement('a');
      parser.href = url;
      var path = parser.pathname || '';
      return /(^|\/)(folders|category)(\/|$)/.test(path);
    };
    var shouldShowMoveOldPopup = function () {
      var previousState = $state.previous && $state.previous.fromState;
      var previousStateName = previousState && previousState.name ? previousState.name : '';
      var referrer = $window.document && $window.document.referrer ? $window.document.referrer : '';
      return !isDocumentationState(previousStateName) && !isDocumentationUrl(referrer);
    };

    var MINIMUM_CHARS_SEARCH = 1;
    $scope.resultSearch = {};
    $scope.searching = false;
    $scope.error = {};
    $scope.newFolder = {};
    $scope.intoSaving = false;
    $scope.waiting = $state.params.waiting == 'true'
    $scope.documents = []
    $scope.currentFolders = []

    $scope.searchDocuments = function () {
      if ($scope.filter.searchTxt.length >= MINIMUM_CHARS_SEARCH) {
        $scope.searching = true;
        DocumentService.findByPharmacyAndSearchText($scope.filter.searchTxt, true, []).then(function (res) {
          $scope.resultSearch = res.data;
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de la recherche');
        });
      } else {
        $scope.searching = false;
      }
    };

    $scope.cancelSearch = function () {
      $scope.searching = false;
      $scope.filter.searchTxt = '';
    };

    $scope.saveDocument = function () {
      if ($scope.working) return;

      $scope.working = true;
      var input = document.getElementById('document_input_file');
      var file = null;
      $scope.error.file = false;
      if (input != null) {
        file = input.files[0];
        if (file == null) {
          $scope.error.file = true;
        }
      } else {
        $scope.error.file = true;
      }
      var fd = new FormData();
      fd.append('file', file);
      fd.append('dto', angular.toJson($scope.document));
      DocumentService.save(fd).then(function (response) {
        $scope.searchDocuments();
        $scope.hidePopup();
        $scope.working = false;
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error('Dossier parent introuvable, veuillez actualiser la page');
        }
        $scope.working = false;
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };
    if (!$scope.waiting) {
      FolderService.findRoots().then(function (data) {
        $scope.folders = data;
        $scope.showMoveOld = false
        for (var i = 0; i < $scope.folders.length; i++) {
          var f = $scope.folders[i]
          if (f.childs) {
            for (var j = 0; j < f.childs.length; j++) {
              var c = f.childs[j]
              if (c.icon == 'folder.svg' && f.name != 'Mes documents') {
                $scope.showMoveOld = true
              }
            }
          }
        }
        if ($scope.showMoveOld && shouldShowMoveOldPopup()) {
          $mdDialog.show({
            templateUrl: 'app/main/front/folders/popup/move_old_popup.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            scope: $scope,
            preserveScope: true
          }).then(function () {
          }).catch(function () {
          });
        }
      }).catch(function (response) {

      });
    } else {


      $scope.refresh = function () {
        DocumentService.findWaitings().then(function (res) {
          $scope.documents = res.data
        }).catch(function () {

        })
      }
      $scope.refresh()
    }



    $scope.saveFolder = function () {
      FolderService.save($scope.newFolder).then(function (response) {
        for (var i = 0; i < $scope.resultSearch.folders.length; i++) {
          if ($scope.resultSearch.folders[i].id == response.data) {
            $scope.resultSearch.folders[i] = $scope.newFolder;
          }
        }
        $scope.hidePopup();
      }).catch(function (response) {
        console.err("catch response :" + response);
        if (response.status === 404) {
          toastr.error('Dossier parent introuvable, veuillez actualiser la page');
        }
      });
    };

    $scope.openCat = function (category) {
      if (category != null && angular.isDefined(category.id)) {
        $state.go('app.category', { categoryId: category.id });
      }
    };

    $scope.openSubCat = function (category, subCategory) {
      if (subCategory != null && angular.isDefined(subCategory.id)) {
        $state.go('app.category.sub', { categoryId: category.id, subCategoryId: subCategory.id });
      }
    };

    $scope.oepnEditFolder = function (folder) {
      $scope.editionMode = true;
      $scope.newFolder = angular.copy(folder);
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/folder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.openDeleteFolder = function (folder) {
      $scope.folderToDelete = angular.copy(folder);
      $scope.deleteFolderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/delete_folder_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        $scope.folderToDelete = {};
      }).catch(function () {
        $scope.folderToDelete = {};
      });
    };

    $scope.deleteFolder = function () {
      FolderService.remove($scope.folderToDelete.id).then(function (response) {
        for (var i = 0; i < $scope.resultSearch.folders.length; i++) {
          if ($scope.resultSearch.folders[i].id == $scope.folderToDelete.id) {
            $scope.resultSearch.folders.splice(i, 1);
            $rootScope.$broadcast('refreshCountNotifs');
            $scope.hidePopup();
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtFolderNotFound);
        }
      });
    };

    function initConfirmDocument() {
      $scope.docToDelete = null;
      $scope.docToValidate = null;
    }

    $scope.openDeleteDocument = function (doc) {
      $scope.docToDelete = angular.copy(doc);
      $scope.deleteDocPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/confirm_document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initConfirmDocument();
      }).catch(function () {
        initConfirmDocument();
      });
    };

    $scope.deleteDocument = function () {
      DocumentService.remove($scope.docToDelete.id).then(function (response) {
        for (var i = 0; i < $scope.resultSearch.documents.length; i++) {
          if ($scope.resultSearch.documents[i].id === $scope.docToDelete.id) {
            $scope.resultSearch.documents.splice(i, 1);
            $rootScope.$broadcast('refreshCountNotifs');
            $scope.hidePopup();
            break;
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
      });
    };

    $scope.openEditDocument = function (doc) {
      $scope.editionMode = true;
      $scope.document = angular.copy(doc);
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.openValidDocument = function (doc) {
      $scope.docToValidate = angular.copy(doc);
      $scope.validDocPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/confirm_document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
        initConfirmDocument();
      }).catch(function () {
        initConfirmDocument();
      });
    };

    $scope.validDocument = function () {
      DocumentService.validate($scope.docToValidate.id).then(function (response) {
        $rootScope.$broadcast('refreshCountNotifs');
        $scope.hidePopup();
        $scope.refresh()
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
      });

    };

    $scope.setRestrictedDoc = function (doc) {
      DocumentService.setRestricted(doc.id, !doc.isRestricted).then(function () {
        if ($scope.searching) {
          for (var i = 0; i < $scope.resultSearch.documents.length; i++) {
            if ($scope.resultSearch.documents[i].id == doc.id) {
              $scope.resultSearch.documents[i].isRestricted = !doc.isRestricted
              break
            }
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtDocNotFound);
        }
      });
    };

    $scope.setRestrictedFolder = function (folder) {
      FolderService.setRestricted(folder.id, !folder.isRestricted).then(function () {
        if ($scope.searching) {
          for (var i = 0; i < $scope.resultSearch.folders.length; i++) {
            if ($scope.resultSearch.folders[i].id == folder.id) {
              $scope.resultSearch.folders[i].isRestricted = !folder.isRestricted
              break
            }
          }
        }
      }).catch(function (response) {
        if (response.status === 404) {
          toastr.error(txtFolderNotFound);
        }
      });
    };

    $scope.download = function (doc) {
      $window.location.href = DocumentService.getDownloadLink(doc.id);
    };

    $scope.openPDF = function (doc) {
      var newWindow = $window.open('', '_blank');
      FolderService.getPDF(doc.id).then(function (res) {
        var file = new Blob([res.data], {
          type: 'application/pdf'
        });

        var fileURL = URL.createObjectURL(file);
        newWindow.location = fileURL;
      }).catch(function (err) {
        console.log(err);
      });
    };

    var findFolder = function (id, folders) {
      var res = null
      for (var i = 0; i < folders.length; i++) {
        if (folders[i].id == id) {
          res = folders[i]
          break;
        }
        if (res == null) {
          res = findFolder(id, folders[i].childs)
        }
      }
      return res
    }
    $scope.openMoveFolder = function (id) {
      for (var i = 0; i < $scope.foldersMovePopup.length; i++) {
        if ($scope.foldersMovePopup[i].id == id) {
          $scope.foldersMovePopup = $scope.foldersMovePopup[i].childs
          $scope.currentMoveFolder = findFolder(id, $scope.currentFolders)
          break
        }
      }
    }

    $scope.openMoveFilePopup = function (document) {
      FolderService.list().then(function (response) {
        $scope.currentFolders = response.data
        $scope.documentToMove = document
        var folder = findFolder($scope.documentToMove.folderId, $scope.currentFolders)
        $scope.foldersMovePopup = folder.childs
        $scope.currentMoveFolder = folder
        $scope.folderPopup = $mdDialog.show({
          templateUrl: 'app/main/front/folders/folder/popup/moveFile_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        });
      })
    };

    $scope.findHistories = function () {
      return $q(function (resolve, reject) {
        DocumentService.findHistories($scope.documentToHistory.id, $scope.pagination).then(function (res) {
          resolve(res)
        }).catch(function () {
          toastr.error('Une erreur est survenue, veuillez réessayer plus tard')
          reject()
        })

      })
    }

    $scope.openHistoriquePopup = function (document) {
      $scope.dto = {
        histories: []
      }
      $scope.pagination = {
        page: 0,
        nbrResults: 5
      }
      $scope.documentToHistory = document
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.folderPopup = $mdDialog.show({
          templateUrl: 'app/main/front/folders/folder/popup/historique_popup.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          scope: $scope,
          preserveScope: true
        });
      }).catch(function () {

      })
    };



    $scope.previousPage = function () {
      if ($scope.loadingPagination) {
        return
      }
      $scope.loadingPagination = true
      $scope.pagination.page -= 1
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.loadingPagination = false
      }).catch(function () {
        $scope.loadingPagination = false
      })
    }

    $scope.nextPage = function () {
      if ($scope.loadingPagination) {
        return
      }
      $scope.loadingPagination = true
      $scope.pagination.page += 1
      $scope.findHistories().then(function (res) {
        $scope.dto = res.data
        $scope.loadingPagination = false
      }).catch(function () {
        $scope.loadingPagination = false
      })
    }

    $scope.printUser = function (user) {
      if (user == null) {
        return ''
      } else if (user.titulaire) {
        return ' par le Titulaire'
      } else if (user.praq) {
        return ' par le Responsable Qualité'
      } else if (user.team) {
        return ' par l\'Equipe'
      }
    }

    $scope.nbPages = function () {
      if ($scope.dto == null || $scope.dto.total == null) {
        return 0
      }
      var mod = $scope.dto.total % $scope.pagination.nbrResults
      var res = Math.trunc($scope.dto.total / $scope.pagination.nbrResults)
      if (mod != 0) {
        res += 1
      }
      return res
    }

    $scope.openInfosFoldersPopup = function () {
      $scope.folderPopup = $mdDialog.show({
        templateUrl: 'app/main/front/folders/folder/popup/infos_folders_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.moveDocument = function () {
      DocumentService.changeFolder($scope.documentToMove.id, $scope.currentMoveFolder.id, $scope.documentToMove.folderId).then(function (response) {
        if (!!response.data) {
          $scope.searchDocuments()
          toastr.success("Le document a été deplacé dans le dossier avec succès");
          $mdDialog.hide()
        }
      }).catch(function (err) {
        console.log(err)
        toastr.error("Une erreur est survenue, veuillez réessayer plus tard");
      });
    }



    $scope.goToMoveFolder = function (id) {
      var folder = findFolder(id, $scope.currentFolders)
      $scope.foldersMovePopup = folder.childs
      $scope.currentMoveFolder = folder
    }

    $scope.goToRoot = function () {
      $scope.foldersMovePopup = angular.copy($scope.currentFolders)
      $scope.currentMoveFolder = { breadcrumbs: [] }
    }

    $scope.openFolder = function (folder) {
      if (folder != null && angular.isDefined(folder.id) && folder.breadcrumbs.length > 0) {
        var subCategoryId = null
        if (folder.breadcrumbs.length >= 2) {
          if (!folder.breadcrumbs[1].folder) {
            subCategoryId = folder.breadcrumbs[1].id
          }
        }
        if (subCategoryId) {
          $state.go('app.category.sub.folder', {
            categoryId: folder.breadcrumbs[0].id,
            subCategoryId: subCategoryId,
            subId: folder.id,
          });
        } else {
          $state.go('app.category.folder', {
            categoryId: folder.breadcrumbs[0].id,
            subId: folder.id,
          });
        }
      }
    };

    $scope.goToHelp = function () {
      $mdDialog.hide();
      $window.open('https://vimeo.com/1186295876?share=copy&fl=sv&fe=ci', '_blank', 'noopener');
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('FolderService', FolderService);

  function FolderService($q, $http) {
    var ROOTS = null;

    var setRoots = function (roots) {
      ROOTS = roots
    }

    var findRoots = function () {
      return $q(function (resolve, reject) {
        if (ROOTS == null) {
          $http({
            url: "/api/rest/folder/roots",
            method: "GET",
            params: { '_v': new Date().getTime() },
            headers: { "Content-Type": "application/json;charset=UTF-8" }
          }).then(function (response) {
            ROOTS = response.data;
            resolve(ROOTS);
          }).catch(function (response) {
            reject(response);
          });
        } else {
          resolve(ROOTS);
        }
      });
    };

    var getPDF = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/pdf/" + id,
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          responseType: 'arraybuffer'
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var findCatById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder/category/" + id,
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder/" + id,
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var changeFolder = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder/changeFolder",
          method: "PATCH",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var save = function (folder) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder",
          method: "POST",
          params: {
            '_v': new Date().getTime(),
            'isRestricted': folder.isRestricted
          },
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          data: folder
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var remove = function (folderId, subCategoryId) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder/disable/" + folderId,
          method: "PUT",
          params: { '_v': new Date().getTime(), 'subCategoryId': subCategoryId },
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var setRestricted = function (folderId, isRestricted) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/folder/restricted/" + folderId,
          method: "PUT",
          params: { '_v': new Date().getTime(), 'isRestricted': isRestricted },
          headers: { "Content-Type": "application/json; charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var getCovidId = function () {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/folder/covid',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: { "Content-Type": "application/json; charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        })
      })
    };

    var list = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/folder/list',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          headers: { "Content-Type": "application/json; charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        })
      })
    }


    return {
      setRoots: setRoots,
      findRoots: findRoots,
      findById: findById,
      findCatById: findCatById,
      save: save,
      remove: remove,
      setRestricted: setRestricted,
      getPDF: getPDF,
      getCovidId: getCovidId,
      list: list,
      changeFolder: changeFolder
    }
  }


})();

(function () {
  'use strict';

  angular.module('app.front').service('DocumentService', DocumentService);

  function DocumentService($q, $http) {
    var working = false;

    var save = function (fd) {
      return $q(function (resolve, reject) {
        if (working) {
          resolve(null);
        }

        working = true;

        $http({
          url: "/api/rest/document",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          working = false;
          resolve(response);
        }).catch(function (response) {
          working = false;
          reject(response);
        });

      });
    };

    var saveMulti = function (fd) {
      return $q(function (resolve, reject) {
        if (working) {
          resolve(null);
        }

        working = true;

        $http({
          url: "/api/rest/document/multi",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          working = false;
          resolve(response);
        }).catch(function (response) {
          working = false;
          reject(response);
        });

      });
    };

    var remove = function (id, subCategoryId) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/disable/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
            'subCategoryId': subCategoryId
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var findByPharmacyAndSearchText = function (searchTxt, withFolder, excludeIds) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/search",
          method: "GET",
          params: {
            '_v': new Date().getTime(),
            'searchTxt': searchTxt,
            'withFolder': !!withFolder,
            'excludeIds': excludeIds
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          working = false;
          reject(response);
        });
      });
    };

    var validate = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/validate/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var setRestricted = function (documentId, isRestricted) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/restricted/" + documentId,
          method: "PUT",
          params: {
            '_v': new Date().getTime(),
            'isRestricted': isRestricted
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getDownloadLink = function (documentId) {
      return '/api/rest/document/download/' + documentId;
    };

    var getFile = function (documentId) {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/document/download/' + documentId,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Uint8Array(response.data);
          resolve(file);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getPdfHome = function () {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/document/pdfHome',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          },
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Uint8Array(response.data);
          resolve(file);
        }).catch(function (response) {
          reject(response);
        });
      });
    };


    var findByPharmacyAndPage = function (page, nbrResults) {
      return $q(function (resolve, reject) {
        $http({
          url: '/api/rest/document/list/' + page + '/' + nbrResults,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var changeFolder = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/changeFolder",
          method: "PATCH",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var changeFolderBatch = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/changeFolder/batch",
          method: "PATCH",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var findWaitings = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/waiting",
          method: "GET",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    var findHistories = function (id, pagination) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/document/" + id + "/history",
          method: "POST",
          params: { '_v': new Date().getTime() },
          headers: { "Content-Type": "application/json; charset=UTF-8" },
          data: pagination
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    }

    return {
      save: save,
      saveMulti: saveMulti,
      remove: remove,
      validate: validate,
      setRestricted: setRestricted,
      getDownloadLink: getDownloadLink,
      findByPharmacyAndPage: findByPharmacyAndPage,
      getFile: getFile,
      findByPharmacyAndSearchText: findByPharmacyAndSearchText,
      changeFolder: changeFolder,
      changeFolderBatch: changeFolderBatch,
      getPdfHome: getPdfHome,
      findWaitings: findWaitings,
      findHistories: findHistories
    };
  }
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('EquipeController', EquipeController);

    function EquipeController($rootScope, $scope, $state, CATEGORIES_EQUIPES) {
        if($rootScope.user && $rootScope.user.isMini){
            $scope.categories = CATEGORIES_EQUIPES.filter(function(cat){
                if(cat.name != 'reunions'){
                    return cat;
                }
            });
        }
        else{
            $scope.categories = CATEGORIES_EQUIPES;
        }

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('app.equipe.' + cat.name);
            }
        }
    };
})();
(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('ControleController', ControleController);

    function ControleController($scope, $state, CONTROLE_CATEGORIES,$rootScope) {
        $scope.categories = CONTROLE_CATEGORIES;

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('app.controle.' + cat.name);
            }
        }
    };
})();

(function () {
	'use strict';

	angular.module('fuse').service('AutoEvalService', AutoEvalService);

	/**
	 * Accès à l'espace officine de l'auto-évaluation qualité PHSQ.
	 *
	 * Le contrat est décrit dans `phsq-back/docs/auto-evaluation/API.md`, section Officine. Deux
	 * points en découlent directement ici :
	 *
	 * ⚠️ **Gson omet les champs nuls.** Un pourcentage absent de la réponse n'est pas zéro : c'est
	 * le tiret « — » de la spécification §14. Les écrans testent donc l'absence de clé, jamais
	 * `=== 0`, et `aUneValeur()` sert à trancher.
	 *
	 * ⚠️ **Un champ absent du corps d'enregistrement n'est pas modifié ; un `null` explicite
	 * efface.** C'est ce qui permet d'enregistrer une valeur sans toucher au commentaire.
	 * `enregistrerReponse` transmet donc EXACTEMENT les clés qu'on lui donne — ne jamais lui
	 * passer un objet complet « par sécurité », il effacerait ce qu'il ne connaît pas.
	 */
	function AutoEvalService($q, $http, $window, $document) {
		var BASE = '/api/rest/autoEvaluation';

		var MESSAGE_ERREUR = 'Une erreur est survenue, veuillez réessayer plus tard.';

		/** Anti-cache, comme tous les services du dépôt. */
		function params(extra) {
			return angular.extend({ '_v': new Date().getTime() }, extra || {});
		}

		function get(url, query) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: params(query),
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		function put(url, body) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'PUT',
					params: params(),
					data: body,
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		/**
		 * Traduit une réponse en erreur affichable, en conservant le CODE du serveur.
		 *
		 * Le code est ce qui permet à l'écran de réagir juste : `SEUL_TITULAIRE` désactive un
		 * bouton et l'explique, `INCOMPLET` ouvre le bandeau de complétude, `HORS_CIBLE` affiche
		 * une page d'explication plutôt qu'une erreur.
		 */
		function toError(response) {
			var status = response ? response.status : 0;
			var data = response ? response.data : null;
			var code = data && data.code ? data.code : null;
			var message = data && data.message ? data.message : null;
			if (status === -1 || status === 0) {
				return {
					status: status,
					code: 'RESEAU',
					message: 'Connexion interrompue. Vos réponses précédentes sont enregistrées.',
					reseau: true
				};
			}
			return {
				status: status,
				code: code,
				message: message || MESSAGE_ERREUR,
				reseau: false
			};
		}

		/**
		 * La valeur est-elle présente ? Distingue l'absence — le tiret — du zéro.
		 *
		 * ⚠️ `if (ligne.pctNc)` serait faux pour 0 % comme pour l'absence, et l'écran afficherait
		 * un tiret sur un vrai zéro. C'est exactement la confusion que la légende des résultats
		 * demande d'éviter.
		 */
		this.aUneValeur = function (valeur) {
			return valeur !== null && angular.isDefined(valeur);
		};

		// ---------------------------------------------------------------- Accueil

		this.getContexte = function () {
			return get(BASE + '/campagne/context');
		};

		/**
		 * L'onglet de « Mes évaluations » sur lequel arrive une officine NON LQO : son
		 * auto-évaluation tant que la campagne est ouverte pour elle — à remplir, validée ou
		 * rouverte —, « Mon enquête » (Journées qualité) le reste de l'année ou hors cible.
		 *
		 * ⚠️ Tranché AVANT la redirection, et non par l'écran d'arrivée : après un rechargement
		 * complet, celui-ci s'initialise avant que l'utilisateur courant soit connu, et
		 * retomberait sur l'onglet des officines LQO (retour PHSQ du 20/10/2026).
		 */
		this.ongletAccueilNonLqo = function () {
			return this.getContexte().then(function (contexte) {
				var ouverte = contexte && ['EN_COURS', 'VALIDEE_OUVERTE', 'ROUVERTE'].indexOf(contexte.situation) >= 0;
				return ouverte ? 'auto' : 'mon-enquete';
			}).catch(function () {
				return 'mon-enquete';
			});
		};

		this.getMillesimes = function () {
			return get(BASE + '/millesimes');
		};

		// ---------------------------------------------------------------- Parcours

		this.getSoumissionCourante = function () {
			return get(BASE + '/soumission/current');
		};

		this.getChapitres = function (soumissionId) {
			return get(BASE + '/soumission/' + soumissionId + '/chapitres');
		};

		this.getChapitre = function (soumissionId, chapitreId) {
			return get(BASE + '/soumission/' + soumissionId + '/chapitre/' + chapitreId);
		};

		/**
		 * Enregistre une réponse.
		 *
		 * @param modifications objet ne portant QUE ce qui change, `questionId` compris. Une clé
		 *        absente laisse la donnée en place ; une clé à `null` l'efface.
		 */
		this.enregistrerReponse = function (soumissionId, modifications) {
			return put(BASE + '/soumission/' + soumissionId + '/reponse', modifications);
		};

		this.valider = function (soumissionId) {
			return put(BASE + '/soumission/' + soumissionId + '/validate', null);
		};

		// ---------------------------------------------------------------- Restitution

		this.getResultats = function (annee) {
			return get(BASE + '/resultats/' + annee);
		};

		this.getComparaison = function (annee) {
			return get(BASE + '/resultats/' + annee + '/comparaison');
		};

		this.urlRessource = function (ressourceId) {
			return BASE + '/ressource/' + ressourceId;
		};

		/**
		 * Le lien d'une question, sous son intitulé. Toujours par la route du serveur, qui sert le
		 * document hébergé par LQO ou redirige vers l'adresse externe : l'écran n'a pas à savoir
		 * lequel des deux, comme pour une ressource de focus.
		 */
		this.urlLienQuestion = function (questionId) {
			return BASE + '/lien/' + questionId;
		};

		this.telechargerRapport = function (annee) {
			return download(BASE + '/rapport/' + annee, 'auto-evaluation-' + annee + '.pdf');
		};

		/**
		 * Télécharge un flux binaire en respectant le nom proposé par le serveur.
		 *
		 * ⚠️ Le lien est créé puis retiré : un `href` direct ne permettrait pas de nommer le
		 * fichier d'après l'en-tête `Content-Disposition`.
		 */
		function download(url, nomParDefaut) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: params(),
					responseType: 'arraybuffer'
				}).then(function (response) {
					var type = (response.headers('Content-Type') || 'application/octet-stream').split(';')[0];
					var blob = new Blob([response.data], { type: type });
					var nom = parseFilename(response.headers('Content-Disposition')) || nomParDefaut;
					var objectUrl = $window.URL.createObjectURL(blob);
					var racine = $document[0];
					var link = racine.createElement('a');
					link.href = objectUrl;
					link.download = nom;
					racine.body.appendChild(link);
					link.click();
					racine.body.removeChild(link);
					$window.URL.revokeObjectURL(objectUrl);
					resolve(nom);
				}).catch(function (response) {
					reject(toError(response));
				});
			});
		}

		function parseFilename(disposition) {
			if (!disposition) {
				return null;
			}
			var utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
			if (utf8 && utf8[1]) {
				try {
					return decodeURIComponent(utf8[1]);
				} catch (error) {
					return utf8[1];
				}
			}
			var simple = /filename="?([^";]+)"?/i.exec(disposition);
			return simple && simple[1] ? simple[1] : null;
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('app.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.error-404', {
            url: '/error-404',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.error-404': {
                    templateUrl: 'app/main/errors/404/error-404.html',
                    controller: 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

    }

})();

(function() {
    'use strict';

    angular
        .module('app.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller() {
        // Data

        // Methods

        //////////
    }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .service('ToolboxAdminService', ToolboxAdminService);

  function ToolboxAdminService($q, $http) {
    var TOOLBOX_BASE_URL = '/api/rest/toolbox';
    var TOOLBOX_ADMIN_BASE_URL = '/api/rest/toolbox/admin';

    function withVersion(params) {
      var nextParams = angular.extend({}, params || {});
      nextParams._v = new Date().getTime();
      return nextParams;
    }

    function getTools() {
      return $q(function (resolve, reject) {
        $http({
          method: 'GET',
          url: TOOLBOX_ADMIN_BASE_URL,
          params: withVersion()
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function saveTool(formData) {
      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: TOOLBOX_ADMIN_BASE_URL,
          params: withVersion(),
          data: formData,
          headers: { 'Content-Type': undefined },
          transformRequest: angular.identity
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function deleteTool(id) {
      return $q(function (resolve, reject) {
        $http({
          method: 'DELETE',
          url: TOOLBOX_ADMIN_BASE_URL + '/' + id,
          params: withVersion()
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function moveTool(id, up) {
      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: TOOLBOX_ADMIN_BASE_URL + '/' + id + '/move',
          params: withVersion({ up: up })
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function getDownloadUrl(id) {
      return TOOLBOX_BASE_URL + '/' + id + '/download';
    }

    return {
      getTools: getTools,
      saveTool: saveTool,
      deleteTool: deleteTool,
      moveTool: moveTool,
      getDownloadUrl: getDownloadUrl
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ToolboxAdminController', ToolboxAdminController);

  function ToolboxAdminController($scope, $mdDialog, $window, toastr, ToolboxAdminService) {
    $scope.loading = false;
    $scope.loadingSave = false;
    $scope.loadingDelete = false;
    $scope.tools = [];
    $scope.moveLoading = {};
    $scope.editMode = false;
    $scope.selectedFile = null;

    function extractTools(data) {
      if (angular.isArray(data)) {
        return data;
      }
      if (data && angular.isArray(data.tools)) {
        return data.tools;
      }
      if (data && data.data && angular.isArray(data.data.tools)) {
        return data.data.tools;
      }
      return [];
    }

    function normalizeTool(raw) {
      var tool = angular.copy(raw || {});
      tool.title = tool.title || '';
      tool.linkTitle = tool.linkTitle || '';
      tool.originalFileName = tool.originalFileName || '';
      tool.url = tool.url || '';
      tool.externalUrl = !!tool.externalUrl;
      return tool;
    }

    function resetEditionTool() {
      $scope.tool = {
        id: null,
        title: '',
        linkTitle: '',
        originalFileName: '',
        url: '',
        externalUrl: false
      };
      $scope.selectedFile = null;
      $scope.fileError = null;
      $scope.loadingSave = false;
    }

    resetEditionTool();

    $scope.getTools = function () {
      $scope.loading = true;
      ToolboxAdminService.getTools().then(function (response) {
        $scope.tools = extractTools(response.data).map(normalizeTool);
      }).catch(function () {
        toastr.error('Erreur lors du chargement des outils');
      }).finally(function () {
        $scope.loading = false;
      });
    };

    $scope.getTools();

    $scope.showToolDialog = function (tool) {
      resetEditionTool();
      $scope.editMode = !!tool;
      if (tool) {
        $scope.tool = {
          id: tool.id,
          title: tool.title,
          linkTitle: tool.linkTitle,
          originalFileName: tool.originalFileName,
          url: tool.url || '',
          externalUrl: !!tool.externalUrl
        };
      }

      $mdDialog.show({
        templateUrl: 'app/main/admin/toolbox/popup/toolbox_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
        resetEditionTool();
      });
    };

    $scope.openDelete = function (tool) {
      $scope.toolToDelete = tool;
      $scope.loadingDelete = false;
      $mdDialog.show({
        templateUrl: 'app/main/admin/toolbox/popup/toolbox_delete_confirm.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      });
    };

    $scope.openToolFilePicker = function () {
      var input = document.getElementById('toolbox-file-input');
      if (input) {
        input.value = null;
        input.click();
      }
    };

    $scope.onToolboxFileChange = function (files) {
      if (!files || !files.length) {
        $scope.selectedFile = null;
      } else {
        $scope.selectedFile = files[0];
        $scope.tool.url = '';
      }
      $scope.fileError = null;
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    };

    $scope.onToolboxUrlChange = function () {
      if ($scope.tool && $scope.tool.url && $scope.tool.url.trim().length) {
        $scope.selectedFile = null;
      }
      $scope.fileError = null;
    };

    $scope.saveTool = function () {
      if ($scope.loadingSave) {
        return;
      }

      if (!$scope.tool || !$scope.tool.title || !$scope.tool.linkTitle) {
        return;
      }

      var hasFile = !!$scope.selectedFile;
      var url = ($scope.tool.url || '').trim();
      var hasUrl = !!url;

      if (hasFile && hasUrl) {
        $scope.fileError = 'Veuillez choisir soit un fichier, soit une URL.';
        return;
      }

      if (!$scope.editMode && !hasFile && !hasUrl) {
        $scope.fileError = 'Le dépôt d\'un fichier ou la saisie d\'une URL est obligatoire.';
        return;
      }

      $scope.loadingSave = true;
      $scope.fileError = null;

      var formData = new FormData();
      if ($scope.editMode && $scope.tool.id) {
        formData.append('id', $scope.tool.id);
      }
      formData.append('title', $scope.tool.title);
      formData.append('linkTitle', $scope.tool.linkTitle);
      if ($scope.selectedFile) {
        formData.append('file', $scope.selectedFile);
      }
      if (hasUrl) {
        formData.append('url', url);
      }

      ToolboxAdminService.saveTool(formData).then(function () {
        toastr.success($scope.editMode ? 'Outil modifié' : 'Outil ajouté');
        $scope.hidePopup();
        $scope.getTools();
      }).catch(function (response) {
        var errorMessage = 'Erreur lors de l\'enregistrement de l\'outil';
        if (response && response.data) {
          if (angular.isString(response.data)) {
            try {
              var parsed = angular.fromJson(response.data);
              if (parsed && parsed.message) {
                errorMessage = parsed.message;
              }
            } catch (e) {
            }
          } else if (response.data.message) {
            errorMessage = response.data.message;
          }
        }
        toastr.error(errorMessage);
      }).finally(function () {
        $scope.loadingSave = false;
      });
    };

    $scope.deleteTool = function () {
      if (!$scope.toolToDelete || !$scope.toolToDelete.id || $scope.loadingDelete) {
        return;
      }
      $scope.loadingDelete = true;
      ToolboxAdminService.deleteTool($scope.toolToDelete.id).then(function () {
        toastr.success('Outil supprimé');
        $scope.hidePopup();
        $scope.getTools();
      }).catch(function () {
        toastr.error('Erreur lors de la suppression de l\'outil');
      }).finally(function () {
        $scope.loadingDelete = false;
      });
    };

    $scope.moveTool = function (tool, up) {
      if (!tool || !tool.id || $scope.moveLoading[tool.id]) {
        return;
      }
      $scope.moveLoading[tool.id] = true;
      ToolboxAdminService.moveTool(tool.id, up).then(function () {
        $scope.getTools();
      }).catch(function () {
        toastr.error('Erreur lors du déplacement de l\'outil');
      }).finally(function () {
        $scope.moveLoading[tool.id] = false;
      });
    };

    $scope.downloadTool = function (tool) {
      if (!tool || !tool.id) {
        return;
      }
      $window.location.href = ToolboxAdminService.getDownloadUrl(tool.id);
    };

    $scope.getToolActionLabel = function (tool) {
      return tool && tool.externalUrl ? 'Accéder' : 'Télécharger';
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
      resetEditionTool();
    };

    $scope.cancelPopup = function () {
      $mdDialog.cancel();
      resetEditionTool();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .service('QuestionnaireSatisfactionAdminService', QuestionnaireSatisfactionAdminService);

  function QuestionnaireSatisfactionAdminService($q, $http) {
    var ADMIN_BASE_URL = '/api/rest/questionnaireSatisfaction/admin';

    function withVersion(params) {
      var nextParams = angular.extend({}, params || {});
      nextParams._v = new Date().getTime();
      return nextParams;
    }

    function normalizePharmacyIds(rawIds) {
      var ids = [];
      angular.forEach(rawIds || [], function (id) {
        var numericId = Number(id);
        if (isFinite(numericId) && numericId > 0) {
          ids.push(numericId);
        }
      });
      return ids;
    }

    function normalizeFilters(filters) {
      var nextFilters = angular.extend({}, filters || {});
      nextFilters.pharmacyIds = normalizePharmacyIds(nextFilters.pharmacyIds || nextFilters.selectedPharmacyIds);
      var groupementId = Number(nextFilters.groupementId);
      nextFilters.groupementId = isFinite(groupementId) && groupementId > 0 ? groupementId : null;
      var page = Number(nextFilters.page);
      if (isFinite(page) && page > 0) {
        nextFilters.page = page;
      } else {
        delete nextFilters.page;
      }
      var nbrResults = Number(nextFilters.nbrResults);
      if (isFinite(nbrResults) && nbrResults > 0) {
        nextFilters.nbrResults = nbrResults;
      } else {
        delete nextFilters.nbrResults;
      }
      var searchText = (nextFilters.searchText || '').toString().trim();
      if (searchText) {
        nextFilters.searchText = searchText;
      } else {
        delete nextFilters.searchText;
      }
      return nextFilters;
    }

    function resolveBaseUrl(scope) {
      return scope === 'groupement' ? '/api/rest/questionnaireSatisfaction/admin' : ADMIN_BASE_URL;
    }

    function request(scope, method, path, filters, data, responseType) {
      var params = withVersion(filters ? normalizeFilters(filters) : null);
      return $q(function (resolve, reject) {
        $http({
          method: method,
          url: resolveBaseUrl(scope) + path,
          params: params,
          data: data,
          responseType: responseType,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function getFilterPharmacies(scope, filters) {
      return request(scope, 'GET', '/filters/pharmacies', filters);
    }

    /**
     * D'où vient le périmètre des restitutions : { source: 'CRM' | 'SECOURS', luLe }. SECOURS =
     * le CRM ne répond pas, les officines sont rattachées selon le dernier état connu.
     */
    function getPerimetre(scope) {
      return request(scope, 'GET', '/perimetre', null);
    }

    function getSolicitationStats(filters, scope) {
      var payload = normalizeFilters(filters);
      return request(scope, 'POST', '/results/solicitations', null, payload);
    }

    function getVerbatimStats(filters, scope) {
      var payload = normalizeFilters(filters);
      return request(scope, 'POST', '/results/verbatims', null, payload);
    }

    function getProfileStats(filters, scope) {
      var payload = normalizeFilters(filters);
      return request(scope, 'POST', '/results/profils', null, payload);
    }

    function getCriteriaDetailsStats(filters, scope) {
      var payload = normalizeFilters(filters);
      return request(scope, 'POST', '/results/detail-criteres', null, payload);
    }

    function getEngagedPharmacies(filters, pagination, scope) {
      var payload = normalizeFilters(filters);
      payload.page = pagination && pagination.page ? pagination.page : 1;
      payload.nbrResults = pagination && pagination.nbrResults ? pagination.nbrResults : 10;

      return request(scope, 'POST', '/results/pharmacies-engagees', null, payload);
    }

    function parseFilenameFromDisposition(contentDispositionHeader) {
      if (!contentDispositionHeader) {
        return null;
      }

      var utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDispositionHeader);
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]);
        } catch (error) {
          return utf8Match[1];
        }
      }

      var filenameMatch = /filename=\"?([^\";]+)\"?/i.exec(contentDispositionHeader);
      if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1];
      }

      return null;
    }

    function downloadEngagedPharmaciesExport(filters, scope) {
      var payload = normalizeFilters(filters);

      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: resolveBaseUrl(scope) + '/results/pharmacies-engagees/export',
          params: withVersion(),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: payload,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          var filename = parseFilenameFromDisposition(response.headers('content-disposition')) || 'pharmacies_engagees.xlsx';
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', filename);
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function downloadEngagedPharmaciesReportsZip(filters, scope) {
      var payload = normalizeFilters(filters);

      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: resolveBaseUrl(scope) + '/results/pharmacies-engagees/reports-zip',
          params: withVersion(),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: payload,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/zip' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          var filename = parseFilenameFromDisposition(response.headers('content-disposition')) || 'rapports_pharmacies_engagees.zip';
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', filename);
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function downloadVerbatimExport(filters, scope) {
      var payload = normalizeFilters(filters);

      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: resolveBaseUrl(scope) + '/results/verbatims/export',
          params: withVersion(),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: payload,
          responseType: 'arraybuffer'
        }).then(function (response) {
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          var filename = parseFilenameFromDisposition(response.headers('content-disposition')) || 'questionnaire-satisfaction-verbatims.xlsx';
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', filename);
          downloadLink[0].click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    function downloadAllResponsesExport(filters, scope) {
      var payload = normalizeFilters(filters);

      return $q(function (resolve, reject) {
        $http({
          method: 'POST',
          url: resolveBaseUrl(scope) + '/results/responses/export',
          params: withVersion(),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: payload,
          responseType: 'arraybuffer'
        }).then(function (response) {
          // Avec responseType 'arraybuffer', response.data est toujours un ArrayBuffer,
          // même pour un corps vide/JSON : on détecte le cas « 0 réponse » via le statut 204
          // (ou un content-type JSON) et on ne déclenche alors aucun téléchargement.
          var contentType = (response.headers('content-type') || '').toLowerCase();
          if (response.status === 204 || contentType.indexOf('application/json') !== -1) {
            resolve({ empty: true });
            return;
          }
          var file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url = window.URL || window.webkitURL;
          var downloadLink = angular.element('<a></a>');
          var filename = parseFilenameFromDisposition(response.headers('content-disposition')) || 'questionnaire-satisfaction-reponses.xlsx';
          downloadLink.attr('href', url.createObjectURL(file));
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', filename);
          downloadLink[0].click();
          resolve({ empty: false });
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    return {
      getFilterPharmacies: getFilterPharmacies,
      getPerimetre: getPerimetre,
      getSolicitationStats: getSolicitationStats,
      getVerbatimStats: getVerbatimStats,
      getProfileStats: getProfileStats,
      getCriteriaDetailsStats: getCriteriaDetailsStats,
      getEngagedPharmacies: getEngagedPharmacies,
      downloadEngagedPharmaciesExport: downloadEngagedPharmaciesExport,
      downloadEngagedPharmaciesReportsZip: downloadEngagedPharmaciesReportsZip,
      downloadVerbatimExport: downloadVerbatimExport,
      downloadAllResponsesExport: downloadAllResponsesExport
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminSuiviEnqueteController', AdminSuiviEnqueteController);

  function AdminSuiviEnqueteController($scope, $state, $stateParams, $window, $document, $timeout, toastr, QuestionnaireSatisfactionAdminService, UserService) {
    var DEFAULT_END_OF_CAMPAIGN_NOTICE = 'En fin de campagne, vous recevrez par email : rapport consolidé du groupement (comparatif national), rapports individuels par pharmacie (ZIP).';
    var DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE = 'Envoi sous 48h après fin de campagne.';
    $scope.tabs = {
      diffusion: 'diffusion',
      verbatims: 'verbatims',
      detailCriteres: 'detail-criteres',
      profils: 'profils',
      pharmacies: 'pharmacies'
    };

    var currentStateName = $state.current && $state.current.name ? $state.current.name : '';
    var isGroupementView = currentStateName.indexOf('app.groupement.') === 0;
    var isGroupementPharmaciesPage = currentStateName === 'app.groupement.restitutions.pharmacies-engagees';
    var statsScope = isGroupementView ? 'groupement' : 'admin';
    $scope.isGroupementView = isGroupementView;
    $scope.isGroupementPharmaciesPage = isGroupementPharmaciesPage;
    var initialTab = ($stateParams && $stateParams.initialTab) ? $stateParams.initialTab : null;
    if (isGroupementPharmaciesPage) {
      initialTab = $scope.tabs.pharmacies;
    }
    $scope.tabActive = (initialTab === $scope.tabs.pharmacies || initialTab === $scope.tabs.diffusion
      || initialTab === $scope.tabs.verbatims || initialTab === $scope.tabs.profils || initialTab === $scope.tabs.detailCriteres)
      ? initialTab
      : $scope.tabs.diffusion;
    $scope.isPharmaciesOnlyMode = isGroupementPharmaciesPage || (isGroupementView && $scope.tabActive === $scope.tabs.pharmacies);

    $scope.filters = {
      responseDateStart: null,
      responseDateEnd: null,
      groupementId: isGroupementView ? UserService.getSelectedGroupementId() : null,
      selectedPharmacyIds: []
    };
    $scope.isConsolidatedGroupementView = isGroupementView && !$scope.filters.groupementId;
    $scope.datePickers = {
      responseDateStart: false,
      responseDateEnd: false
    };

    $scope.pharmacySearch = '';
    $scope.pharmacyOptions = [];
    $scope.pharmacyGroups = [];
    $scope.pharmacyGroupExpanded = {};
    var pharmacyGroupExpansionBeforeSearch = null;
    var WITHOUT_GROUPEMENT_KEY = '__sans_groupement__';
    var WITHOUT_GROUPEMENT_LABEL = 'Sans groupement';

    $scope.loadingTabs = {
      diffusion: false,
      verbatims: false,
      detailCriteres: false,
      profils: false,
      pharmacies: false
    };

    $scope.errorTabs = {
      diffusion: false,
      verbatims: false,
      detailCriteres: false,
      profils: false,
      pharmacies: false
    };

    $scope.perimetre = null;
    $scope.solicitationStats = null;
    $scope.selectedHistoricalSolicitationYear = null;
    $scope.verbatimStats = null;
    $scope.verbatimPagination = {
      page: 1,
      nbrResults: 10,
      total: 0,
      pageCount: 0,
      searchText: ''
    };
    $scope.criteriaDetailsStats = null;
    $scope.criteriaDetailsScopes = [
      { key: 'groupement', title: 'Mon groupement', data: null },
      { key: 'national', title: 'National', data: null }
    ];
    $scope.profileStats = null;
    $scope.engagedPharmacies = [];
    $scope.engagedPharmaciesSummary = {
      completedCount: 0,
      unansweredCount: 0
    };
    $scope.endOfCampaignNotice = DEFAULT_END_OF_CAMPAIGN_NOTICE;
    $scope.endOfCampaignDelayMessage = DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE;
    $scope.groupementReportLoading = false;
    $scope.verbatimExportLoading = false;
    $scope.allResponsesExportLoading = false;
    $scope.engagedPagination = {
      page: 1,
      nbrResults: 10,
      total: 0
    };
    var verbatimStatsRequestId = 0;
    var verbatimSearchDebouncePromise = null;

    var charts = {};
    var getChartDatasetColor = function (dataset, index) {
      if (!dataset || !dataset.backgroundColor) {
        return null;
      }
      if (angular.isArray(dataset.backgroundColor)) {
        return dataset.backgroundColor[index] || dataset.backgroundColor[dataset.backgroundColor.length - 1];
      }
      return dataset.backgroundColor;
    };
    var getHexColorRgb = function (color) {
      if (!color || color.charAt(0) !== '#') {
        return null;
      }
      var normalizedColor = color.slice(1);
      if (normalizedColor.length === 3) {
        normalizedColor = normalizedColor.charAt(0) + normalizedColor.charAt(0)
          + normalizedColor.charAt(1) + normalizedColor.charAt(1)
          + normalizedColor.charAt(2) + normalizedColor.charAt(2);
      }
      if (normalizedColor.length !== 6) {
        return null;
      }
      return {
        r: parseInt(normalizedColor.slice(0, 2), 16),
        g: parseInt(normalizedColor.slice(2, 4), 16),
        b: parseInt(normalizedColor.slice(4, 6), 16)
      };
    };
    var getChartContrastTextColor = function (backgroundColor) {
      var rgb = getHexColorRgb(backgroundColor);
      if (!rgb) {
        return '#ffffff';
      }
      var luminance = (0.299 * rgb.r) + (0.587 * rgb.g) + (0.114 * rgb.b);
      return luminance > 165 ? '#1e2a3a' : '#ffffff';
    };
    var resolveChartValueLabelColor = function (colorConfig, numericValue, dataset, index, chartInstance) {
      if (angular.isFunction(colorConfig)) {
        return colorConfig(numericValue, dataset, index, chartInstance);
      }
      return colorConfig || '#425166';
    };
    var chartValueLabelsPlugin = {
      afterDatasetsDraw: function (chartInstance) {
        var pluginOptions = ((chartInstance.config || {}).options || {}).valueLabels;
        if (!pluginOptions || !pluginOptions.enabled) {
          return;
        }

        var ctx = chartInstance.chart.ctx;
        var isHorizontal = chartInstance.config.type === 'horizontalBar';
        var fontSize = pluginOptions.fontSize || 11;
        var fontWeight = pluginOptions.fontWeight || '600';
        var fontFamily = pluginOptions.fontFamily || "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
        var offset = angular.isNumber(pluginOptions.offset) ? pluginOptions.offset : 8;
        var position = pluginOptions.position || (isHorizontal ? 'end' : 'top');

        ctx.save();
        ctx.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;

        angular.forEach((chartInstance.data && chartInstance.data.datasets) || [], function (dataset, datasetIndex) {
          var meta = chartInstance.getDatasetMeta(datasetIndex);
          if (!meta || meta.hidden) {
            return;
          }

          angular.forEach(meta.data || [], function (element, index) {
            var rawValue = dataset.data[index];
            var numericValue = Number(rawValue);
            if (!isFinite(numericValue)) {
              return;
            }
            if (pluginOptions.skipZero !== false && numericValue <= 0) {
              return;
            }

            var label = angular.isFunction(pluginOptions.formatter)
              ? pluginOptions.formatter(numericValue, dataset, index, chartInstance)
              : String(numericValue);
            if (!label) {
              return;
            }

            var model = element && element._model;
            if (!model) {
              return;
            }

            var coordinates = getChartValueLabelCoordinates(model, isHorizontal, position, offset);
            if (!coordinates) {
              return;
            }

            if (pluginOptions.skipIfTooSmall !== false && position === 'center') {
              var barSize = isHorizontal
                ? Math.abs((model.x || 0) - (model.base || 0))
                : Math.abs((model.y || 0) - (model.base || 0));
              if (barSize < ctx.measureText(label).width + 10) {
                return;
              }
            }

            ctx.fillStyle = resolveChartValueLabelColor(pluginOptions.color, numericValue, dataset, index, chartInstance);
            ctx.textAlign = coordinates.textAlign;
            ctx.textBaseline = coordinates.textBaseline;
            ctx.fillText(label, coordinates.x, coordinates.y);
          });
        });

        ctx.restore();
      }
    };

    function toDateObject(value) {
      if (!value) {
        return null;
      }
      if (angular.isDate(value)) {
        return new Date(value.getTime());
      }
      var parsedDate = new Date(value);
      if (isNaN(parsedDate.getTime())) {
        return null;
      }
      return parsedDate;
    }

    function toEpochAtStartOfDay(value) {
      var date = toDateObject(value);
      if (!date) {
        return null;
      }
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
    }

    function buildFiltersForApi() {
      return {
        responseDateStart: toEpochAtStartOfDay($scope.filters.responseDateStart),
        responseDateEnd: toEpochAtStartOfDay($scope.filters.responseDateEnd),
        groupementId: isGroupementView ? $scope.filters.groupementId : null,
        pharmacyIds: angular.copy($scope.filters.selectedPharmacyIds)
      };
    }

    function buildVerbatimFiltersForApi(page) {
      var targetPage = page && page > 0 ? page : $scope.verbatimPagination.page;
      return angular.extend({}, buildFiltersForApi(), {
        page: targetPage,
        nbrResults: $scope.verbatimPagination.nbrResults,
        searchText: $scope.verbatimPagination.searchText
      });
    }

    function buildVerbatimPageNumbers() {
      var total = Number($scope.verbatimPagination.total) || 0;
      var pageSize = Number($scope.verbatimPagination.nbrResults) || 1;
      var currentPage = Number($scope.verbatimPagination.page) || 1;
      var paginationRange = 9;
      var pageCount = total > 0 ? Math.max(Math.ceil(total / pageSize), 1) : 0;

      if (pageCount <= 0) {
        return [];
      }

      var pages = [];
      var halfWay = Math.ceil(paginationRange / 2);
      var position;

      if (currentPage <= halfWay) {
        position = 'start';
      } else if (pageCount - halfWay < currentPage) {
        position = 'end';
      } else {
        position = 'middle';
      }

      var ellipsesNeeded = paginationRange < pageCount;
      var i = 1;
      while (i <= pageCount && i <= paginationRange) {
        var pageNumber;
        if (i === paginationRange) {
          pageNumber = pageCount;
        } else if (i === 1) {
          pageNumber = i;
        } else if (paginationRange < pageCount) {
          if (pageCount - halfWay < currentPage) {
            pageNumber = pageCount - paginationRange + i;
          } else if (halfWay < currentPage) {
            pageNumber = currentPage - halfWay + i;
          } else {
            pageNumber = i;
          }
        } else {
          pageNumber = i;
        }

        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...');
        } else {
          pages.push(pageNumber);
        }
        i++;
      }
      return pages;
    }

    function syncGroupementContext() {
      $scope.filters.groupementId = isGroupementView ? UserService.getSelectedGroupementId() : null;
      $scope.isConsolidatedGroupementView = isGroupementView && !$scope.filters.groupementId;
      $scope.criteriaDetailsScopes[0].title = $scope.isConsolidatedGroupementView ? 'Vue consolidée' : 'Mon groupement';
    }

    function compareNullable(left, right) {
      var normalizedLeft = (left || '').toString().toLowerCase();
      var normalizedRight = (right || '').toString().toLowerCase();
      if (normalizedLeft < normalizedRight) {
        return -1;
      }
      if (normalizedLeft > normalizedRight) {
        return 1;
      }
      return 0;
    }

    function normalizePharmacyOption(raw) {
      var option = angular.copy(raw || {});
      option.id = Number(option.id || 0);
      option.cipCode = option.cipCode || '';
      option.name = option.name || '';
      option.groupement = option.groupement || '';
      option.groupementName = (option.groupement || '').trim() || WITHOUT_GROUPEMENT_LABEL;
      option.groupementKey = option.groupementName === WITHOUT_GROUPEMENT_LABEL
        ? WITHOUT_GROUPEMENT_KEY
        : ('groupement:' + option.groupementName.toLowerCase());
      option.label = option.cipCode ? (option.cipCode + ' - ' + option.name) : option.name;
      return option;
    }

    function getPharmacySearch() {
      return ($scope.pharmacySearch || '').trim().toLowerCase();
    }

    function hasActivePharmacySearch() {
      return !!getPharmacySearch();
    }

    function matchesPharmacySearch(option) {
      var search = getPharmacySearch();
      if (!search) {
        return true;
      }
      var cip = (option.cipCode || '').toLowerCase();
      var name = (option.name || '').toLowerCase();
      return cip.indexOf(search) !== -1 || name.indexOf(search) !== -1;
    }

    function getVisiblePharmacyOptions() {
      if (!hasActivePharmacySearch()) {
        return $scope.pharmacyOptions;
      }
      return ($scope.pharmacyOptions || []).filter(function (option) {
        return matchesPharmacySearch(option);
      });
    }

    function getSelectedPharmacyIds() {
      return $scope.filters.selectedPharmacyIds || [];
    }

    function isPharmacySelected(id) {
      return getSelectedPharmacyIds().indexOf(id) !== -1;
    }

    function buildPharmacyGroups() {
      var groupsByKey = {};
      angular.forEach($scope.pharmacyOptions || [], function (option) {
        var key = option.groupementKey || WITHOUT_GROUPEMENT_KEY;
        if (!groupsByKey[key]) {
          groupsByKey[key] = {
            key: key,
            name: option.groupementName || WITHOUT_GROUPEMENT_LABEL,
            isWithoutGroupement: key === WITHOUT_GROUPEMENT_KEY,
            expanded: false,
            options: [],
            visibleOptions: []
          };
        }
        groupsByKey[key].options.push(option);
        if (matchesPharmacySearch(option)) {
          groupsByKey[key].visibleOptions.push(option);
        }
      });

      return Object.keys(groupsByKey).map(function (key) {
        groupsByKey[key].expanded = isPharmacyGroupExpandedByKey(key);
        return groupsByKey[key];
      }).filter(function (group) {
        return group.visibleOptions.length > 0;
      }).sort(function (left, right) {
        if (left.isWithoutGroupement && !right.isWithoutGroupement) {
          return 1;
        }
        if (!left.isWithoutGroupement && right.isWithoutGroupement) {
          return -1;
        }
        return compareNullable(left.name, right.name);
      });
    }

    function refreshPharmacyGroups() {
      $scope.pharmacyGroups = buildPharmacyGroups();
    }

    function isPharmacyGroupExpandedByKey(key) {
      if (!key) {
        return false;
      }
      if (hasActivePharmacySearch() && !angular.isDefined($scope.pharmacyGroupExpanded[key])) {
        return true;
      }
      return !!$scope.pharmacyGroupExpanded[key];
    }

    function isPharmacyGroupExpanded(group) {
      if (!group || !group.key) {
        return false;
      }
      if (angular.isDefined(group.expanded)) {
        return !!group.expanded;
      }
      return isPharmacyGroupExpandedByKey(group.key);
    }

    function setAllPharmacyGroupsCollapsed() {
      var expanded = {};
      angular.forEach($scope.pharmacyOptions || [], function (option) {
        if (option && option.groupementKey) {
          expanded[option.groupementKey] = false;
        }
      });
      $scope.pharmacyGroupExpanded = expanded;
      refreshPharmacyGroups();
    }

    function getGroupSelectedCount(options) {
      var count = 0;
      angular.forEach(options || [], function (option) {
        if (option && isPharmacySelected(option.id)) {
          count++;
        }
      });
      return count;
    }

    function getSelectedVisiblePharmacyCount() {
      var count = 0;
      angular.forEach($scope.pharmacyGroups || [], function (group) {
        if (!group.expanded) {
          return;
        }
        angular.forEach(group.visibleOptions || [], function (option) {
          if (option && isPharmacySelected(option.id)) {
            count++;
          }
        });
      });
      return count;
    }

    function setPharmacySelection(ids) {
      $scope.filters.selectedPharmacyIds = ids;
      refreshAfterSelectFiltersChange();
    }

    function destroyChart(key) {
      if (charts[key]) {
        charts[key].destroy();
        charts[key] = null;
      }
    }

    function destroyAllCharts() {
      angular.forEach(charts, function (_, chartKey) {
        destroyChart(chartKey);
      });
    }

    function normalizeNumericValue(value) {
      var numericValue = Number(value);
      return isFinite(numericValue) ? numericValue : 0;
    }

    function normalizeChartValue(value) {
      var numericValue = Number(value);
      if (!isFinite(numericValue)) {
        return null;
      }
      return Math.round(numericValue * 10) / 10;
    }

    function formatChartNumericValue(value) {
      var normalizedValue = normalizeChartValue(value);
      if (normalizedValue === null) {
        return '';
      }
      var decimals = normalizedValue % 1 === 0 ? 0 : 1;
      return normalizedValue.toFixed(decimals).replace('.', ',');
    }

    function formatChartPercentageValue(value) {
      var normalizedValue = normalizeChartValue(value);
      if (normalizedValue === null) {
        return '';
      }
      var decimals = normalizedValue % 1 === 0 ? 0 : 1;
      return normalizedValue.toFixed(decimals).replace('.', ',') + ' %';
    }

    function getChartValueLabelCoordinates(model, isHorizontal, position, offset) {
      if (position === 'center') {
        return {
          x: isHorizontal ? model.base + ((model.x - model.base) / 2) : model.x,
          y: isHorizontal ? model.y : model.base + ((model.y - model.base) / 2),
          textAlign: 'center',
          textBaseline: 'middle'
        };
      }
      return {
        x: isHorizontal ? model.x + offset : model.x,
        y: isHorizontal ? model.y : model.y - offset,
        textAlign: isHorizontal ? 'left' : 'center',
        textBaseline: isHorizontal ? 'middle' : 'bottom'
      };
    }

    function formatProfilePercentage(value) {
      if (!angular.isNumber(value)) {
        return '0,0 %';
      }
      return value.toFixed(1).replace('.', ',') + ' %';
    }

    function formatCriteriaAverage(value) {
      if (!angular.isNumber(value)) {
        return '-';
      }
      return value.toFixed(1).replace('.', ',');
    }

    function buildSolicitationChartPayload(campaigns) {
      var labels = [];
      var sent = [];
      var partial = [];
      var completed = [];

      angular.forEach(campaigns || [], function (campaign) {
        angular.forEach((campaign && campaign.channels) || [], function (channel) {
          labels.push((campaign.year || '') + ' - ' + (channel.label || ''));
          sent.push(normalizeNumericValue(channel.sent));
          partial.push(normalizeNumericValue(channel.partial));
          completed.push(normalizeNumericValue(channel.completed));
        });
      });

      return {
        labels: labels,
        datasets: [
          {
            label: 'Envoyé',
            backgroundColor: '#2563eb',
            borderColor: '#2563eb',
            borderWidth: 1,
            data: sent
          },
          {
            label: 'Partiel',
            backgroundColor: '#f59e0b',
            borderColor: '#f59e0b',
            borderWidth: 1,
            data: partial
          },
          {
            label: 'Complété',
            backgroundColor: '#16a34a',
            borderColor: '#16a34a',
            borderWidth: 1,
            data: completed
          }
        ]
      };
    }

    function buildSolicitationChartConfig(campaigns) {
      return {
        type: 'bar',
        plugins: [chartValueLabelsPlugin],
        data: buildSolicitationChartPayload(campaigns),
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 24 }
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 14,
              fontColor: '#425166',
              fontStyle: 'bold'
            }
          },
          valueLabels: {
            enabled: true,
            color: '#425166',
            formatter: formatChartNumericValue
          },
          tooltips: {
            mode: 'index',
            intersect: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
                fontColor: '#5b6b82'
              },
              categoryPercentage: 0.72,
              barPercentage: 0.84
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(91, 107, 130, 0.15)',
                drawBorder: false
              },
              ticks: {
                beginAtZero: true,
                fontColor: '#5b6b82'
              }
            }]
          }
        }
      };
    }

    function getSolicitationChannelList() {
      var stats = $scope.solicitationStats;
      if (!stats || !stats.currentCampaign || !stats.currentCampaign.channels) {
        return [];
      }

      var order = ['SMS', 'EMAIL', 'QR_CODE', 'RESEAUX_SOCIAUX', 'TABLETTE', 'PAPIER'];
      var byKey = {};
      angular.forEach(stats.currentCampaign.channels, function (channel) {
        byKey[channel.channel] = channel;
      });

      var result = [];
      angular.forEach(order, function (channelKey) {
        if (byKey[channelKey]) {
          result.push(byKey[channelKey]);
        }
      });
      angular.forEach(stats.currentCampaign.channels, function (channel) {
        if (order.indexOf(channel.channel) === -1) {
          result.push(channel);
        }
      });
      return result;
    }

    function getSolicitationTotalSent() {
      var total = 0;
      angular.forEach(getSolicitationChannelList(), function (channel) {
        total += channel.sent || 0;
      });
      return total;
    }

    function getSolicitationTotalCompleted() {
      var total = 0;
      angular.forEach(getSolicitationChannelList(), function (channel) {
        total += channel.completed || 0;
      });
      return total;
    }

    function getSolicitationCompletionRate() {
      var sent = getSolicitationTotalSent();
      if (!sent) {
        return null;
      }
      return Math.round((getSolicitationTotalCompleted() / sent) * 100);
    }

    function getSolicitationChannelRate(channel) {
      if (!channel || !channel.sent) {
        return null;
      }
      return Math.round((channel.completed / channel.sent) * 100);
    }

    function getSolicitationChannelIconKind(channelKey) {
      switch (channelKey) {
        case 'SMS':
          return 'sms';
        case 'EMAIL':
          return 'email';
        case 'QR_CODE':
          return 'qr';
        case 'RESEAUX_SOCIAUX':
          return 'share';
        case 'TABLETTE':
          return 'tablet';
        case 'PAPIER':
          return 'paper';
        default:
          return 'other';
      }
    }

    function renderSolicitationChart(chartKey, canvasId, campaigns) {
      destroyChart(chartKey);
      if (typeof $window.Chart === 'undefined' || !campaigns || !campaigns.length) {
        return;
      }
      var payload = buildSolicitationChartPayload(campaigns);
      if (!payload.labels.length) {
        return;
      }
      var canvas = $document[0].getElementById(canvasId);
      if (!canvas) {
        return;
      }
      charts[chartKey] = new $window.Chart(canvas.getContext('2d'), buildSolicitationChartConfig(campaigns));
    }

    function getHistoricalSolicitationCampaigns() {
      return (($scope.solicitationStats && $scope.solicitationStats.historicalCampaigns) || []).slice().sort(function (left, right) {
        return Number(right.year || 0) - Number(left.year || 0);
      });
    }

    function getSelectedHistoricalCampaign() {
      var campaigns = getHistoricalSolicitationCampaigns();
      if (!campaigns.length) {
        return null;
      }
      var selected = null;
      angular.forEach(campaigns, function (campaign) {
        if (campaign.year === $scope.selectedHistoricalSolicitationYear) {
          selected = campaign;
        }
      });
      return selected || campaigns[0];
    }

    function syncSelectedHistoricalCampaignYear() {
      var selectedCampaign = getSelectedHistoricalCampaign();
      $scope.selectedHistoricalSolicitationYear = selectedCampaign ? selectedCampaign.year : null;
    }

    function renderSolicitationCharts() {
      $timeout(function () {
        renderSolicitationChart('solicitationCurrent', 'qsAdminSolicitationsCurrentChart', [$scope.solicitationStats.currentCampaign]);

        if ($scope.solicitationStats.historicalVisible) {
          syncSelectedHistoricalCampaignYear();
          var selectedHistoricalCampaign = getSelectedHistoricalCampaign();
          renderSolicitationChart('solicitationHistorical', 'qsAdminSolicitationsHistoricalChart', selectedHistoricalCampaign ? [selectedHistoricalCampaign] : []);
        } else {
          destroyChart('solicitationHistorical');
        }
      }, 0);
    }

    function buildProfileChartConfig(question, campaignYear, colors) {
      var datasets = [];
      angular.forEach((question && question.values) || [], function (value, index) {
        datasets.push({
          label: value.label,
          data: [normalizeNumericValue(value.percentage)],
          backgroundColor: colors[index] || colors[colors.length - 1],
          borderColor: colors[index] || colors[colors.length - 1],
          borderWidth: 0,
          maxBarThickness: 56
        });
      });

      return {
        type: 'bar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: [String(campaignYear || '')],
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 24 }
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 14,
              fontColor: '#425166'
            }
          },
          valueLabels: {
            enabled: true,
            color: '#425166',
            formatter: formatChartPercentageValue
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex] || {};
                return (dataset.label || '') + ' : ' + tooltipItem.yLabel + '%';
              }
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                fontColor: '#5b6b82'
              },
              categoryPercentage: 0.64,
              barPercentage: 0.9
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(91, 107, 130, 0.15)',
                drawBorder: false
              },
              ticks: {
                beginAtZero: true,
                max: 100,
                fontColor: '#5b6b82',
                callback: function (value) {
                  return value + '%';
                }
              }
            }]
          }
        }
      };
    }

    function renderProfileChart(chartKey, canvasId, question, campaignYear, colors) {
      destroyChart(chartKey);
      if (typeof $window.Chart === 'undefined' || !question || !question.values || !question.values.length) {
        return;
      }
      var canvas = $document[0].getElementById(canvasId);
      if (!canvas) {
        return;
      }
      charts[chartKey] = new $window.Chart(canvas.getContext('2d'), buildProfileChartConfig(question, campaignYear, colors));
    }

    function renderProfileCharts() {
      $timeout(function () {
        renderProfileChart('profileGender', 'qsAdminProfileGenderChart', $scope.profileStats.gender,
          $scope.profileStats.campaignYear, ['#0f766e', '#2563eb']);
        renderProfileChart('profileAgeRange', 'qsAdminProfileAgeRangeChart', $scope.profileStats.ageRange,
          $scope.profileStats.campaignYear, ['#ea580c', '#f59e0b', '#22c55e', '#0ea5e9', '#6366f1']);
        renderProfileChart('profileRegularCustomer', 'qsAdminProfileRegularCustomerChart', $scope.profileStats.regularCustomer,
          $scope.profileStats.campaignYear, ['#1d4ed8', '#dc2626']);
      }, 0);
    }

    function syncCriteriaDetailsScopes() {
      var stats = $scope.criteriaDetailsStats || {};
      angular.forEach($scope.criteriaDetailsScopes, function (scope) {
        scope.data = stats[scope.key] || null;
      });
    }

    function splitCriteriaLabel(label, maxLength) {
      if (!label || label.length <= maxLength) {
        return label;
      }
      var words = label.split(' ');
      var lines = [];
      var currentLine = '';
      angular.forEach(words, function (word) {
        var candidate = currentLine ? currentLine + ' ' + word : word;
        if (candidate.length > maxLength && currentLine) {
          lines.push(currentLine);
          currentLine = word;
          return;
        }
        currentLine = candidate;
      });
      if (currentLine) {
        lines.push(currentLine);
      }
      return lines.length > 1 ? lines : label;
    }

    function buildPercentageScale() {
      return [{
        stacked: false,
        gridLines: {
          color: 'rgba(91, 107, 130, 0.15)',
          drawBorder: false
        },
        ticks: {
          beginAtZero: true,
          max: 100,
          fontColor: '#5b6b82',
          callback: function (value) {
            return value + '%';
          }
        }
      }];
    }

    function createCriteriaChart(chartKey, canvasId, config) {
      destroyChart(chartKey);
      if (typeof $window.Chart === 'undefined') {
        return;
      }
      var canvas = $document[0].getElementById(canvasId);
      if (!canvas) {
        return;
      }
      charts[chartKey] = new $window.Chart(canvas.getContext('2d'), config);
    }

    function buildCriteriaBarChartConfig(labels, values, colors, horizontal) {
      return {
        type: horizontal ? 'horizontalBar' : 'bar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: colors,
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          layout: {
            padding: horizontal ? { right: 42 } : { top: 24 }
          },
          valueLabels: {
            enabled: true,
            color: '#425166',
            formatter: formatChartPercentageValue
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                var value = horizontal ? tooltipItem.xLabel : tooltipItem.yLabel;
                return value + '%';
              }
            }
          },
          scales: {
            xAxes: horizontal ? buildPercentageScale() : [{
              gridLines: { display: false, drawBorder: false },
              ticks: { autoSkip: false, fontColor: '#5b6b82' }
            }],
            yAxes: horizontal ? [{
              gridLines: { display: false, drawBorder: false },
              ticks: { fontColor: '#5b6b82' }
            }] : buildPercentageScale()
          }
        }
      };
    }

    function buildCriteriaGaugeChartConfig(average) {
      var safeAverage = angular.isNumber(average) ? Math.max(0, Math.min(10, average)) : 0;
      return {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [safeAverage, Math.max(0, 10 - safeAverage)],
            backgroundColor: ['#6cc343', '#7c7c7c'],
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          rotation: -Math.PI,
          circumference: Math.PI,
          cutoutPercentage: 72,
          legend: { display: false },
          tooltips: { enabled: false }
        }
      };
    }

    function buildCriteriaStackedChartConfig(rows) {
      var labels = [];
      var veryDissatisfied = [];
      var dissatisfied = [];
      var neutral = [];
      var satisfied = [];
      var verySatisfied = [];

      angular.forEach(rows || [], function (row) {
        labels.push(splitCriteriaLabel(row.label, 28));
        veryDissatisfied.push(row.veryDissatisfied || 0);
        dissatisfied.push(row.dissatisfied || 0);
        neutral.push(row.neutral || 0);
        satisfied.push(row.satisfied || 0);
        verySatisfied.push(row.verySatisfied || 0);
      });

      return {
        type: 'horizontalBar',
        plugins: [chartValueLabelsPlugin],
        data: {
          labels: labels,
          datasets: [
            { label: 'Très insatisfait', data: veryDissatisfied, backgroundColor: '#df3e48', borderWidth: 0 },
            { label: 'Insatisfait', data: dissatisfied, backgroundColor: '#d2776c', borderWidth: 0 },
            { label: 'Neutre', data: neutral, backgroundColor: '#7c7c7c', borderWidth: 0 },
            { label: 'Satisfait', data: satisfied, backgroundColor: '#a1d273', borderWidth: 0 },
            { label: 'Très satisfait', data: verySatisfied, backgroundColor: '#83c14f', borderWidth: 0 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          valueLabels: {
            enabled: true,
            position: 'center',
            fontSize: 10,
            fontWeight: '700',
            color: function (_, dataset, index) {
              return getChartContrastTextColor(getChartDatasetColor(dataset, index));
            },
            formatter: formatChartPercentageValue
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.xLabel + '%';
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: { color: 'rgba(91, 107, 130, 0.15)', drawBorder: false },
              ticks: { beginAtZero: true, max: 100, fontColor: '#5b6b82', callback: function (value) { return value + '%'; } }
            }],
            yAxes: [{
              stacked: true,
              gridLines: { display: false, drawBorder: false },
              ticks: { fontColor: '#5b6b82' }
            }]
          }
        }
      };
    }

    function getCriteriaItemPercentages(items) {
      var values = [];
      angular.forEach(items || [], function (item) {
        values.push(item.percentage || 0);
      });
      return values;
    }

    function getCriteriaItemLabels(items, maxLength) {
      var labels = [];
      angular.forEach(items || [], function (item) {
        labels.push(splitCriteriaLabel(item.label, maxLength || 18));
      });
      return labels;
    }

    function getCriteriaBarColors(items, palette) {
      var colors = [];
      angular.forEach(items || [], function (_, index) {
        colors.push(palette[index] || palette[palette.length - 1]);
      });
      return colors;
    }

    function destroyCriteriaScopeCharts(scopeKey) {
      angular.forEach(['gauge', 'distribution', 'criteria', 'visit', 'priority', 'recommendation', 'urgent', 'customer'], function (suffix) {
        destroyChart(scopeKey + '-' + suffix);
      });
    }

    function renderCriteriaScopeCharts(scope) {
      if (!scope || !scope.key) {
        return;
      }
      if (!scope.data || !scope.data.questionnaireCount) {
        destroyCriteriaScopeCharts(scope.key);
        return;
      }

      createCriteriaChart(scope.key + '-gauge', 'qsAdminCriteriaGaugeChart-' + scope.key, buildCriteriaGaugeChartConfig(scope.data.overallSatisfactionAverage));
      createCriteriaChart(scope.key + '-distribution', 'qsAdminCriteriaDistributionChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.overallSatisfactionDistribution, 2),
        getCriteriaItemPercentages(scope.data.overallSatisfactionDistribution),
        ['#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#d64045', '#9dd46d', '#9dd46d'],
        false
      ));
      createCriteriaChart(scope.key + '-criteria', 'qsAdminCriteriaStackedChart-' + scope.key, buildCriteriaStackedChartConfig(scope.data.criteriaEvaluation));
      createCriteriaChart(scope.key + '-visit', 'qsAdminCriteriaVisitReasonsChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.visitReasons, 18),
        getCriteriaItemPercentages(scope.data.visitReasons),
        getCriteriaBarColors(scope.data.visitReasons, ['#4d7dbf', '#b44752', '#97b54c', '#7f5fa6', '#94a3b8']),
        false
      ));
      createCriteriaChart(scope.key + '-priority', 'qsAdminCriteriaPrioritiesChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.environmentalPriorities, 26),
        getCriteriaItemPercentages(scope.data.environmentalPriorities),
        getCriteriaBarColors(scope.data.environmentalPriorities, ['#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#91cfa9', '#d8e7dd']),
        true
      ));
      createCriteriaChart(scope.key + '-recommendation', 'qsAdminCriteriaRecommendationChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.recommendation && scope.data.recommendation.values, 10),
        getCriteriaItemPercentages(scope.data.recommendation && scope.data.recommendation.values),
        ['#9dd46d', '#d2776c'],
        false
      ));
      createCriteriaChart(scope.key + '-urgent', 'qsAdminCriteriaUrgentCareChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.urgentCare, 26),
        getCriteriaItemPercentages(scope.data.urgentCare),
        getCriteriaBarColors(scope.data.urgentCare, ['#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#7ea8d9', '#cfdbe8']),
        true
      ));
      createCriteriaChart(scope.key + '-customer', 'qsAdminCriteriaCustomerChart-' + scope.key, buildCriteriaBarChartConfig(
        getCriteriaItemLabels(scope.data.regularCustomer && scope.data.regularCustomer.values, 10),
        getCriteriaItemPercentages(scope.data.regularCustomer && scope.data.regularCustomer.values),
        ['#9dd46d', '#d2776c'],
        false
      ));
    }

    function renderCriteriaDetailsCharts() {
      $timeout(function () {
        angular.forEach($scope.criteriaDetailsScopes, function (scope) {
          renderCriteriaScopeCharts(scope);
        });
      }, 0);
    }

    function validateDateFilters() {
      var start = toEpochAtStartOfDay($scope.filters.responseDateStart);
      var end = toEpochAtStartOfDay($scope.filters.responseDateEnd);
      if (start !== null && end !== null && start > end) {
        toastr.error('La date de début doit être antérieure ou égale à la date de fin');
        return false;
      }
      return true;
    }

    function setTabLoading(tabKey, value) {
      $scope.loadingTabs[tabKey] = !!value;
    }

    function setTabError(tabKey, value) {
      $scope.errorTabs[tabKey] = !!value;
    }

    function loadSolicitationStats() {
      setTabLoading('diffusion', true);
      setTabError('diffusion', false);
      QuestionnaireSatisfactionAdminService.getSolicitationStats(buildFiltersForApi(), statsScope).then(function (data) {
        $scope.solicitationStats = data;
        syncSelectedHistoricalCampaignYear();
        renderSolicitationCharts();
      }).catch(function () {
        $scope.solicitationStats = null;
        $scope.selectedHistoricalSolicitationYear = null;
        setTabError('diffusion', true);
        destroyChart('solicitationCurrent');
        destroyChart('solicitationHistorical');
      }).finally(function () {
        setTabLoading('diffusion', false);
      });
    }

    function loadVerbatimStats(page, restoreScrollTop) {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      var targetPage = page && page > 0 ? page : ($scope.verbatimPagination.page || 1);
      var targetScrollTop = angular.isNumber(restoreScrollTop) ? restoreScrollTop : null;
      var requestId = ++verbatimStatsRequestId;

      setTabLoading('verbatims', true);
      setTabError('verbatims', false);
      $scope.verbatimPagination.page = targetPage;

      QuestionnaireSatisfactionAdminService.getVerbatimStats(buildVerbatimFiltersForApi(targetPage), statsScope)
        .then(function (data) {
          if (requestId !== verbatimStatsRequestId) {
            return;
          }

          var comments = data && angular.isArray(data.comments) ? data.comments : [];
          $scope.verbatimStats = data || null;
          if ($scope.verbatimStats) {
            $scope.verbatimStats.comments = comments;

            var resolvedPage = Number($scope.verbatimStats.page);
            if (isFinite(resolvedPage) && resolvedPage > 0) {
              $scope.verbatimPagination.page = resolvedPage;
            }

            var resolvedNbrResults = Number($scope.verbatimStats.nbrResults);
            if (isFinite(resolvedNbrResults) && resolvedNbrResults > 0) {
              $scope.verbatimPagination.nbrResults = resolvedNbrResults;
            }

            var resolvedTotal = Number($scope.verbatimStats.commentCount);
            $scope.verbatimPagination.total = isFinite(resolvedTotal) && resolvedTotal >= 0
              ? resolvedTotal
              : comments.length;
            $scope.verbatimPagination.pageCount = $scope.verbatimPagination.total > 0
              ? Math.max(Math.ceil($scope.verbatimPagination.total / ($scope.verbatimPagination.nbrResults || 1)), 1)
              : 0;
          } else {
            $scope.verbatimPagination.total = 0;
            $scope.verbatimPagination.pageCount = 0;
          }
        }).catch(function () {
          if (requestId !== verbatimStatsRequestId) {
            return;
          }
          $scope.verbatimStats = null;
          $scope.verbatimPagination.total = 0;
          $scope.verbatimPagination.pageCount = 0;
          setTabError('verbatims', true);
        }).finally(function () {
          if (requestId !== verbatimStatsRequestId) {
            return;
          }
          setTabLoading('verbatims', false);
          if (targetScrollTop !== null) {
            $timeout(function () {
              var content = $document[0].getElementById('content');
              if (content) {
                content.scrollTop = targetScrollTop;
              } else {
                $window.scrollTo(0, targetScrollTop);
              }
            }, 0);
          }
        });
    }

    function loadCriteriaDetailsStats() {
      setTabLoading('detailCriteres', true);
      setTabError('detailCriteres', false);
      QuestionnaireSatisfactionAdminService.getCriteriaDetailsStats(buildFiltersForApi(), statsScope).then(function (data) {
        $scope.criteriaDetailsStats = data;
        syncCriteriaDetailsScopes();
        renderCriteriaDetailsCharts();
      }).catch(function () {
        $scope.criteriaDetailsStats = null;
        syncCriteriaDetailsScopes();
        setTabError('detailCriteres', true);
        angular.forEach($scope.criteriaDetailsScopes, function (scope) {
          destroyCriteriaScopeCharts(scope.key);
        });
      }).finally(function () {
        setTabLoading('detailCriteres', false);
      });
    }

    function loadProfileStats() {
      setTabLoading('profils', true);
      setTabError('profils', false);
      QuestionnaireSatisfactionAdminService.getProfileStats(buildFiltersForApi(), statsScope).then(function (data) {
        $scope.profileStats = data;
        renderProfileCharts();
      }).catch(function () {
        $scope.profileStats = null;
        setTabError('profils', true);
        destroyChart('profileGender');
        destroyChart('profileAgeRange');
        destroyChart('profileRegularCustomer');
      }).finally(function () {
        setTabLoading('profils', false);
      });
    }

    function loadEngagedPharmacies(page, restoreScrollTop) {
      var targetPage = page && page > 0 ? page : 1;
      var targetScrollTop = angular.isNumber(restoreScrollTop) ? restoreScrollTop : null;
      var isPagingRequest = targetScrollTop !== null;
      var previousRows = angular.copy($scope.engagedPharmacies);
      var previousTotal = $scope.engagedPagination.total;
      var previousPage = $scope.engagedPagination.page;

      if (!isPagingRequest) {
        setTabLoading('pharmacies', true);
        setTabError('pharmacies', false);
      }

      QuestionnaireSatisfactionAdminService.getEngagedPharmacies(buildFiltersForApi(), {
        page: targetPage,
        nbrResults: $scope.engagedPagination.nbrResults
      }, statsScope).then(function (data) {
        var rows = [];
        if (data && angular.isArray(data.pharmacies)) {
          rows = data.pharmacies;
        } else if (angular.isArray(data)) {
          rows = data;
        }

        $scope.engagedPharmacies = rows;
        var total = Number(data && data.total);
        $scope.engagedPagination.total = isFinite(total) ? total : rows.length;
        $scope.engagedPagination.page = targetPage;
        $scope.engagedPharmaciesSummary.completedCount = Number(data && data.completedCount) || 0;
        $scope.engagedPharmaciesSummary.unansweredCount = Number(data && data.unansweredCount) || 0;
        $scope.endOfCampaignNotice = (data && data.endOfCampaignNotice) || DEFAULT_END_OF_CAMPAIGN_NOTICE;
        $scope.endOfCampaignDelayMessage = (data && data.endOfCampaignDelayMessage) || DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE;
      }).catch(function () {
        if (isPagingRequest) {
          $scope.engagedPharmacies = previousRows;
          $scope.engagedPagination.total = previousTotal;
          $scope.engagedPagination.page = previousPage;
          toastr.error('Erreur lors du changement de page des pharmacies engagées');
          return;
        }
        $scope.engagedPharmacies = [];
        $scope.engagedPagination.total = 0;
        $scope.engagedPagination.page = targetPage;
        $scope.engagedPharmaciesSummary.completedCount = 0;
        $scope.engagedPharmaciesSummary.unansweredCount = 0;
        setTabError('pharmacies', true);
      }).finally(function () {
        if (!isPagingRequest) {
          setTabLoading('pharmacies', false);
        }
        if (targetScrollTop !== null) {
          $timeout(function () {
            $window.scrollTo(0, targetScrollTop);
          }, 0);
        }
      });
    }

    function getVerbatimTableScrollTop() {
      var tableAnchor = $document[0].getElementById('qsAdminVerbatimTableAnchor');
      if (!tableAnchor || !tableAnchor.getBoundingClientRect) {
        return null;
      }
      var currentOffset = $window.pageYOffset || 0;
      var absoluteTop = tableAnchor.getBoundingClientRect().top + currentOffset;
      return Math.max(absoluteTop - 16, 0);
    }

    function getEngagedTableScrollTop() {
      var tableAnchor = $document[0].getElementById('qsAdminEngagedTableAnchor');
      if (!tableAnchor || !tableAnchor.getBoundingClientRect) {
        return null;
      }
      var currentOffset = $window.pageYOffset || 0;
      var absoluteTop = tableAnchor.getBoundingClientRect().top + currentOffset;
      return Math.max(absoluteTop - 16, 0);
    }

    // Quand le CRM ne répond pas, les officines sont rattachées à leur groupement selon le
    // dernier état connu : l'écran le dit, avec la date de cette lecture.
    function loadPerimetre() {
      QuestionnaireSatisfactionAdminService.getPerimetre(statsScope).then(function (data) {
        $scope.perimetre = data || null;
      }).catch(function () {
        $scope.perimetre = null;
      });
    }

    function loadActiveTabData() {
      loadPerimetre();
      loadEngagedPharmacies(1);
      if ($scope.isPharmaciesOnlyMode) {
        return;
      }
      loadVerbatimStats(1);
      loadCriteriaDetailsStats();
      loadProfileStats();
      loadSolicitationStats();
    }

    function refreshAfterSelectFiltersChange() {
      if (!validateDateFilters()) {
        return;
      }
      loadActiveTabData();
    }

    function loadPharmacyOptions() {
      QuestionnaireSatisfactionAdminService.getFilterPharmacies(statsScope, buildFiltersForApi()).then(function (data) {
        var options = angular.isArray(data) ? data : [];
        $scope.pharmacyOptions = options.map(normalizePharmacyOption).sort(function (left, right) {
          var byCip = compareNullable(left.cipCode, right.cipCode);
          if (byCip !== 0) {
            return byCip;
          }
          return compareNullable(left.name, right.name);
        });
        setAllPharmacyGroupsCollapsed();
      }).catch(function () {
        $scope.pharmacyOptions = [];
        $scope.pharmacyGroups = [];
        $scope.pharmacyGroupExpanded = {};
        toastr.error('Erreur lors du chargement de la liste des pharmacies');
      });
    }

    $scope.setTab = function (tab) {
      if ($scope.tabActive === tab) {
        return;
      }
      $scope.tabActive = tab;
      $scope.isPharmaciesOnlyMode = isGroupementPharmaciesPage || (isGroupementView && $scope.tabActive === $scope.tabs.pharmacies);
    };

    $scope.applyFilters = function () {
      if (!validateDateFilters()) {
        return;
      }
      loadActiveTabData();
    };

    $scope.clearDateFilter = function () {
      $scope.filters.responseDateStart = null;
      $scope.filters.responseDateEnd = null;
    };

    $scope.clearPharmacyFilter = function () {
      $scope.filters.selectedPharmacyIds = [];
      $scope.pharmacySearch = '';
      refreshAfterSelectFiltersChange();
    };

    $scope.selectAllPharmacies = function () {
      var allIds = [];
      angular.forEach($scope.pharmacyOptions || [], function (option) {
        if (option && option.id) {
          allIds.push(option.id);
        }
      });
      $scope.filters.selectedPharmacyIds = allIds;
      refreshAfterSelectFiltersChange();
    };

    $scope.unselectAllPharmacies = function () {
      $scope.filters.selectedPharmacyIds = [];
      refreshAfterSelectFiltersChange();
    };

    $scope.isPharmacySelected = function (id) {
      return isPharmacySelected(id);
    };

    $scope.togglePharmacySelection = function (id) {
      var ids = getSelectedPharmacyIds();
      var index = ids.indexOf(id);
      if (index === -1) {
        ids.push(id);
      } else {
        ids.splice(index, 1);
      }
      setPharmacySelection(ids);
    };

    $scope.getVisiblePharmacyOptions = function () {
      return getVisiblePharmacyOptions();
    };

    $scope.getVisiblePharmacyGroups = function () {
      return $scope.pharmacyGroups;
    };

    $scope.togglePharmacyGroup = function (group, event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      if (!group || !group.key) {
        return;
      }
      $scope.pharmacyGroupExpanded[group.key] = !group.expanded;
      refreshPharmacyGroups();
    };

    $scope.isPharmacyGroupExpanded = function (group) {
      return isPharmacyGroupExpanded(group);
    };

    $scope.isPharmacyGroupChecked = function (group) {
      var options = (group && group.options) || [];
      return options.length > 0 && getGroupSelectedCount(options) === options.length;
    };

    $scope.isPharmacyGroupIndeterminate = function (group) {
      var options = (group && group.options) || [];
      var selectedCount = getGroupSelectedCount(options);
      return selectedCount > 0 && selectedCount < options.length;
    };

    $scope.togglePharmacyGroupSelection = function (group) {
      if (!group || !group.options || !group.options.length) {
        return;
      }
      var ids = getSelectedPharmacyIds().slice();
      var shouldSelect = !$scope.isPharmacyGroupChecked(group);
      angular.forEach(group.options, function (option) {
        if (!option || !option.id) {
          return;
        }
        var index = ids.indexOf(option.id);
        if (shouldSelect && index === -1) {
          ids.push(option.id);
        }
        if (!shouldSelect && index !== -1) {
          ids.splice(index, 1);
        }
      });
      setPharmacySelection(ids);
    };

    $scope.getPharmacyGroupSelectedVisibleCount = function (group) {
      return getGroupSelectedCount((group && group.visibleOptions) || []);
    };

    $scope.getPharmacySelectedCount = function () {
      return getSelectedPharmacyIds().length;
    };

    $scope.getPharmacySelectedNotVisibleCount = function () {
      return Math.max(getSelectedPharmacyIds().length - getSelectedVisiblePharmacyCount(), 0);
    };

    $scope.hasPharmacySelectedNotVisible = function () {
      return $scope.getPharmacySelectedNotVisibleCount() > 0;
    };

    $scope.getHistoricalSolicitationCampaigns = function () {
      return getHistoricalSolicitationCampaigns();
    };

    $scope.getCriteriaDetailsScopes = function () {
      return $scope.criteriaDetailsScopes;
    };

    $scope.shouldShowEngagedGroupementColumn = function () {
      return !isGroupementView || $scope.isConsolidatedGroupementView;
    };

    $scope.selectHistoricalSolicitationYear = function (year) {
      if ($scope.selectedHistoricalSolicitationYear === year) {
        return;
      }
      $scope.selectedHistoricalSolicitationYear = year;
      renderSolicitationCharts();
    };

    $scope.formatCriteriaAverage = function (value) {
      return formatCriteriaAverage(value);
    };

    $scope.formatProfilePercentage = function (value) {
      return formatProfilePercentage(value);
    };

    $scope.getSolicitationChannelList = function () {
      return getSolicitationChannelList();
    };

    $scope.getSolicitationTotalSent = function () {
      return getSolicitationTotalSent();
    };

    $scope.getSolicitationTotalCompleted = function () {
      return getSolicitationTotalCompleted();
    };

    $scope.getSolicitationCompletionRate = function () {
      return getSolicitationCompletionRate();
    };

    $scope.getSolicitationChannelRate = function (channel) {
      return getSolicitationChannelRate(channel);
    };

    $scope.getSolicitationChannelIconKind = function (channelKey) {
      return getSolicitationChannelIconKind(channelKey);
    };

    $scope.getVerbatimPageNumbers = function () {
      return buildVerbatimPageNumbers();
    };

    $scope.onVerbatimPageChange = function (newPageNumber, oldPageNumber) {
      if ($scope.tabActive !== $scope.tabs.verbatims) {
        return;
      }
      var targetPage = Number(newPageNumber);
      if (angular.isNumber(oldPageNumber) && Number(newPageNumber) === Number(oldPageNumber)) {
        return;
      }
      if (!isFinite(targetPage) || targetPage <= 0) {
        return;
      }
      var content = $document[0].getElementById('content');
      loadVerbatimStats(targetPage, content ? Number(content.scrollTop) || 0 : null);
    };

    $scope.onVerbatimSearchChange = function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
      }
      verbatimSearchDebouncePromise = $timeout(function () {
        verbatimSearchDebouncePromise = null;
        loadVerbatimStats(1);
      }, 300);
    };

    $scope.clearVerbatimSearch = function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      if (!$scope.verbatimPagination.searchText) {
        return;
      }
      $scope.verbatimPagination.searchText = '';
      loadVerbatimStats(1);
    };

    $scope.retryVerbatims = function () {
      loadVerbatimStats(Number($scope.verbatimPagination.page) || 1, getVerbatimTableScrollTop());
    };

    $scope.onEngagedPageChange = function (newPageNumber, oldPageNumber) {
      if ($scope.tabActive !== $scope.tabs.pharmacies) {
        return;
      }
      if (angular.isNumber(oldPageNumber) && Number(newPageNumber) === Number(oldPageNumber)) {
        return;
      }
      loadEngagedPharmacies(newPageNumber, getEngagedTableScrollTop());
    };

    $scope.exportEngagedPharmacies = function () {
      if (!validateDateFilters()) {
        return;
      }
      QuestionnaireSatisfactionAdminService.downloadEngagedPharmaciesExport(buildFiltersForApi(), statsScope).catch(function () {
        toastr.error('Erreur lors de l\'export des pharmacies engagées');
      });
    };

    $scope.downloadVerbatimXlsx = function () {
      if (!validateDateFilters()) {
        return;
      }
      $scope.verbatimExportLoading = true;
      return QuestionnaireSatisfactionAdminService.downloadVerbatimExport(buildVerbatimFiltersForApi(), statsScope).catch(function () {
        toastr.error('Erreur lors de l\'export des verbatims');
      }).finally(function () {
        $scope.verbatimExportLoading = false;
      });
    };

    $scope.exportAllResponses = function () {
      if (!validateDateFilters()) {
        return;
      }
      $scope.allResponsesExportLoading = true;
      return QuestionnaireSatisfactionAdminService.downloadAllResponsesExport(buildFiltersForApi(), statsScope)
        .then(function (result) {
          if (result && result.empty) {
            toastr.info('Aucune réponse pour ces filtres');
          }
        })
        .catch(function () {
          toastr.error('Erreur lors de l\'export des réponses');
        })
        .finally(function () {
          $scope.allResponsesExportLoading = false;
        });
    };

    $scope.downloadEngagedPharmaciesReportsZip = function () {
      if (isGroupementView && !$scope.filters.groupementId) {
        toastr.warning('Sélectionnez un groupement dans le sélecteur du haut pour télécharger son rapport consolidé.');
        return;
      }
      if (!validateDateFilters()) {
        return;
      }
      $scope.groupementReportLoading = true;
      return QuestionnaireSatisfactionAdminService.downloadEngagedPharmaciesReportsZip(buildFiltersForApi(), statsScope).catch(function (error) {
        if (error && Number(error.status) === 400) {
          toastr.warning('Le ZIP des rapports PDF est disponible après la clôture de la campagne');
          return;
        }
        toastr.error('Erreur lors du téléchargement du ZIP des rapports PDF');
      }).finally(function () {
        $scope.groupementReportLoading = false;
      });
    };

    $scope.$on('$destroy', function () {
      if (verbatimSearchDebouncePromise) {
        $timeout.cancel(verbatimSearchDebouncePromise);
        verbatimSearchDebouncePromise = null;
      }
      destroyAllCharts();
    });

    $scope.$on('groupementContextChanged', function () {
      if (!isGroupementView) {
        return;
      }
      syncGroupementContext();
      $scope.filters.selectedPharmacyIds = [];
      $scope.pharmacySearch = '';
      loadPharmacyOptions();
      loadActiveTabData();
    });

    $scope.$watch('pharmacySearch', function (newValue, oldValue) {
      var hadSearch = !!(oldValue || '').trim();
      var hasSearch = !!(newValue || '').trim();
      if (!hadSearch && hasSearch) {
        pharmacyGroupExpansionBeforeSearch = angular.copy($scope.pharmacyGroupExpanded || {});
        angular.forEach($scope.pharmacyOptions || [], function (option) {
          if (option && option.groupementKey) {
            $scope.pharmacyGroupExpanded[option.groupementKey] = true;
          }
        });
        refreshPharmacyGroups();
      }
      if (hadSearch && !hasSearch) {
        $scope.pharmacyGroupExpanded = pharmacyGroupExpansionBeforeSearch || {};
        pharmacyGroupExpansionBeforeSearch = null;
        refreshPharmacyGroups();
      }
      if (hadSearch && hasSearch) {
        refreshPharmacyGroups();
      }
    });

    syncGroupementContext();
    loadPharmacyOptions();
    loadActiveTabData();
  }
})();

(function () {
	'use strict';

	angular.module('app.admin').service('PharmacyService', PharmacyService);

	function PharmacyService($q, $http) {
		var getPharmacies = function (type, pagination) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/" + type,
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: pagination
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getCurrent = function () {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy",
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		var savePharmacy = function (pharmacy) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy",
					method: "POST",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: pharmacy
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateUsers = function (pharmacy) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/users",
					method: "PATCH",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: pharmacy
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var setActivated = function (id, isActivated, getZip) {
			var getZipBool = false;

			if (getZip) {
				getZipBool = true;
			}

			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/setActivated/" + id + "/" + isActivated + "/" + getZipBool,
					method: "GET",
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var deletePermanently = function (pharmacyId) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/delete/" + pharmacyId,
					method: "DELETE",
					params: {
						'_v': new Date().getTime()
					},
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		var resentActivationEmail = function (id, type) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/resendActivation/" + id,
					method: "GET",
					params: {
						'_v': new Date().getTime(),
						'type': type
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getUrlActivation = function (id, type) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/getUrlActivation/" + id,
					method: "GET",
					params: {
						'_v': new Date().getTime(),
						'type': type
					},
					transformResponse: function (value) {
						return value;
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getStats = function (type) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/getStatistiques/" + type.name,
					method: "GET",
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		var getGroupements = function (type) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/" + type + "/groupements",
					method: "GET",
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// Le parc du CRM est-il lisible ? 503 si le CRM n'a jamais répondu depuis le démarrage (PHSQ-249).
		var getEtatParcCrm = function () {
			return $http({
				url: "/api/rest/crm/parc/etat",
				method: "GET",
				params: {
					'_v': new Date().getTime()
				}
			});
		};

		var getStatusBaseOptions = function (type) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/" + type + "/status-base-options",
					method: "GET",
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var importGroupementAssociations = function (formData) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/pharmacy/groupement/import",
					method: "POST",
					params: {
						'_v': new Date().getTime()
					},
					data: formData,
					headers: { 'Content-Type': undefined },
					transformRequest: angular.identity
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		return {
			getPharmacies: getPharmacies,
			getCurrent: getCurrent,
			savePharmacy: savePharmacy,
			updateUsers: updateUsers,
			deletePermanently: deletePermanently,
			setActivated: setActivated,
			resentActivationEmail: resentActivationEmail,
			getUrlActivation: getUrlActivation,
			getStats: getStats,
			getGroupements: getGroupements,
			getStatusBaseOptions: getStatusBaseOptions,
			getEtatParcCrm: getEtatParcCrm,
			importGroupementAssociations: importGroupementAssociations
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('PharmaciesController', PharmaciesController);

  /** @ngInject */
  function PharmaciesController($scope, $state, toastr, $mdDialog, PharmacyService, $window) {
    $scope.todayMinusElevenMonths = 0;
    $scope.loading = false;
    $scope.pharmacies = [];
    $scope.order = 'isActivated';
    $scope.reverse = true;
    $scope.mailsSent = {
      titulaire: false,
      praq: false,
      equipe: false
    };
    $scope.urlValidation = {
      titulaire: '',
      praq: '',
      equipe: ''
    }
    $scope.contractTypes = [{
      id: 0,
      name: 'LQO',
      displayName: 'LQO'
    }, {
      id: 1,
      name: 'LQO_MINI',
      displayName: 'LQO découverte'
    }, {
      id: 2,
      name: 'NON_LQO',
      displayName: 'Non-LQO'
    }, {
      // PHSQ-240 : affiché et conservé à la modification ; jamais proposé à la création (un compte
      // OSyS se crée par « OSyS · Officines », qui active aussi le module).
      id: 3,
      name: 'OSYS',
      displayName: 'OSyS'
    }];

    $scope.convertType = {
      LQO: $scope.contractTypes[0].displayName,
      LQO_MINI: $scope.contractTypes[1].displayName,
      NON_LQO: $scope.contractTypes[2].displayName,
      OSYS: $scope.contractTypes[3].displayName
    };

    function isKnownContractType(type) {
      return $scope.contractTypes.some(function (contractType) {
        return contractType.name === type;
      });
    }

    $scope.pagination = {
      page: 1,
      nbrResults: 10,
      searchText: '',
      sort: "u.pharmacy.isActivated desc",
      total: 0,
      withoutActivatedAccount: false,
      withActivatedAccount: false,
      withoutActivatedAccountTotal: 0,
      accountActivationFilter: 'all',
      statusBase: 'all',
      engageQualite: 'all',
      groupement: 'all'
    };

    $scope.statusBaseOptions = [{
      value: 'all',
      label: 'Statut base (Tous)'
    }, {
      value: '__null__',
      label: 'Sans statut'
    }];

    $scope.engageQualiteOptions = [{
      value: 'all',
      label: 'Engagé qualité (Tous)'
    }, {
      value: 'yes',
      label: 'Oui'
    }, {
      value: 'no',
      label: 'Non'
    }];

    $scope.groupementOptions = [{
      value: 'all',
      label: 'Groupement (Tous)'
    }];

    $scope.reset = function () {
      $scope.pagination.page = 1;
      $scope.getPharmacies();
    }

    $scope.resetFilters = function () {
      $scope.pagination.searchText = '';
      $scope.pagination.withoutActivatedAccount = false;
      $scope.pagination.withActivatedAccount = false;
      $scope.pagination.accountActivationFilter = 'all';
      $scope.pagination.statusBase = 'all';
      $scope.pagination.engageQualite = 'all';
      $scope.pagination.groupement = 'all';
      $scope.reset();
    };

    $scope.hasActiveFilters = function () {
      return !!($scope.pagination.searchText
        || $scope.pagination.withoutActivatedAccount
        || $scope.pagination.accountActivationFilter !== 'all'
        || $scope.pagination.statusBase !== 'all'
        || $scope.pagination.engageQualite !== 'all'
        || $scope.pagination.groupement !== 'all');
    };

    function initToday() {
      var today = (new Date()).getTime();
      $scope.todayMinusElevenMonths = today - 28857600000;
    }
    initToday();

    function initPharmacy() {
      $scope.pharmacy = {
        titulaire: {

        },
        praq: {

        },
        team: {

        },
        contractType: $scope.contractTypes[0].name,
        testPharmacy: false,
        engageQualiteForced: null
      };
      var normalizedType = $scope.type ? $scope.type.toUpperCase() : null;
      $scope.pharmacy.contractType = isKnownContractType(normalizedType) ? normalizedType : $scope.contractTypes[0].name;
      $scope.error = {};
    }
    initPharmacy();

    function initGroupementImport() {
      $scope.groupementImport = {
        loading: false,
        result: null,
        error: null
      };
    }
    initGroupementImport();

    $scope.syncTestPharmacyState = function () {
      if (!$scope.pharmacy) {
        return;
      }
      if (!$scope.pharmacy.testPharmacy) {
        $scope.pharmacy.engageQualiteForced = null;
      } else if ($scope.pharmacy.engageQualiteForced === null || typeof $scope.pharmacy.engageQualiteForced === 'undefined') {
        $scope.pharmacy.engageQualiteForced = false;
      }
    };

    if ($state.params && $state.params.type) {
      $scope.type = $state.params.type;
      var currentRouteType = $scope.type ? $scope.type.toUpperCase() : null;
      if (isKnownContractType(currentRouteType)) {
        $scope.pharmacy.contractType = currentRouteType;
      }
    }

    $scope.getContractTypePillClass = function (contractType) {
      if (contractType === 'LQO') {
        return 'admin-pharmacies-pill--lqo';
      }
      if (contractType === 'NON_LQO') {
        return 'admin-pharmacies-pill--non-lqo';
      }
      if (contractType === 'OSYS') {
        return 'admin-pharmacies-pill--osys';
      }
      return 'admin-pharmacies-pill--mini';
    }

    $scope.getStatusBaseBadgeClass = function (status) {
      var normalizedStatus = (status || '').toString().trim().toLowerCase();
      if (!normalizedStatus) {
        return 'admin-pharmacies-status-badge--off';
      }
      if (normalizedStatus === 'actif') {
        return 'admin-pharmacies-status-badge--on';
      }
      if (normalizedStatus.indexOf('attente') !== -1) {
        return 'admin-pharmacies-status-badge--pending';
      }
      return 'admin-pharmacies-status-badge--off';
    };

    $scope.activateLqo = function (pharmacy) {
      if (!pharmacy || pharmacy.contractType !== 'NON_LQO' || $scope.loadingSave) {
        return;
      }
      $scope.pharmacy = pharmacy;
      $scope.pharmacy.contractType = 'LQO';
      $scope.savePharmacy(false, pharmacy, null, false, true);
    };

    if (!$scope.type) {
      $scope.type = 'all';
    }

    function loadGroupements() {
      PharmacyService.getGroupements($scope.type).then(function (response) {
        var groupements = response.data || [];
        $scope.groupementOptions = [{
          value: 'all',
          label: 'Groupement (Tous)'
        }].concat((groupements || []).map(function (groupement) {
          return {
            value: groupement,
            label: groupement
          };
        }));
      }).catch(function () {
        $scope.groupementOptions = [{
          value: 'all',
          label: 'Groupement (Tous)'
        }];
      });
    }
    loadGroupements();

    function formatStatusBaseLabel(status) {
      if (!status) {
        return '';
      }
      return status.charAt(0).toUpperCase() + status.slice(1);
    }

    function loadStatusBaseOptions() {
      PharmacyService.getStatusBaseOptions($scope.type).then(function (response) {
        var statuses = response.data || [];
        $scope.statusBaseOptions = [{
          value: 'all',
          label: 'Statut base (Tous)'
        }, {
          value: '__null__',
          label: 'Sans statut'
        }].concat((statuses || []).map(function (status) {
          return {
            value: status,
            label: formatStatusBaseLabel(status)
          };
        }));
      }).catch(function () {
        $scope.statusBaseOptions = [{
          value: 'all',
          label: 'Statut base (Tous)'
        }, {
          value: '__null__',
          label: 'Sans statut'
        }];
      });
    }
    loadStatusBaseOptions();

    $scope.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    $scope.getPharmacies = function () {
      $scope.pagination.withoutActivatedAccount = $scope.pagination.accountActivationFilter === 'without_activated';
      $scope.pagination.withActivatedAccount = $scope.pagination.accountActivationFilter === 'with_activated';
      PharmacyService.getPharmacies($scope.type, $scope.pagination).then(function (response) {
        $scope.erreurCrm = null;
        $scope.parcCrm = { source: response.data.parcCrmSource, luLe: response.data.parcCrmLuLe };
        $scope.pagination.total = response.data.total;
        $scope.pagination.withoutActivatedAccountTotal = response.data.withoutActivatedAccountTotal || 0;
        $scope.pharmacies = response.data.pharmacies || [];
      }, function (response) {
        // 503 : un filtre « statut » ou « engagée » est demandé alors que le CRM ne répond pas.
        if (response && response.status === 503) {
          $scope.erreurCrm = (response.data && response.data.message) || 'Le CRM ne répond pas.';
          $scope.pharmacies = [];
          $scope.pagination.total = 0;
        }
      });
    };
    $scope.getPharmacies();

    $scope.toggleWithoutActivatedAccountFilter = function () {
      if (!$scope.pagination.withoutActivatedAccountTotal) {
        return;
      }
      $scope.pagination.withoutActivatedAccount = !$scope.pagination.withoutActivatedAccount;
      $scope.pagination.withActivatedAccount = false;
      $scope.pagination.accountActivationFilter = $scope.pagination.withoutActivatedAccount ? 'without_activated' : 'all';
      $scope.reset();
    };

    $scope.onAccountActivationFilterChange = function () {
      if ($scope.pagination.accountActivationFilter === 'without_activated') {
        $scope.pagination.withoutActivatedAccount = true;
        $scope.pagination.withActivatedAccount = false;
      } else if ($scope.pagination.accountActivationFilter === 'with_activated') {
        $scope.pagination.withoutActivatedAccount = false;
        $scope.pagination.withActivatedAccount = true;
      } else {
        $scope.pagination.withoutActivatedAccount = false;
        $scope.pagination.withActivatedAccount = false;
      }
      $scope.reset();
    };

    $scope.isWithoutActivatedAccount = function (pharmacy) {
      return !!(pharmacy
        && pharmacy.withoutActivatedAccount
        && !pharmacy.titulaireChecked
        && !pharmacy.praqChecked
        && !pharmacy.teamChecked);
    };

    $scope.sortBy = function (order, reverse) {
      $scope.order = order;
      $scope.reverse = reverse;
    }

    $scope.showPharmacyDialog = function (pharmacy) {
      $scope.editMode = false;
      $scope.error = {};
      if (pharmacy != null) {
        $scope.editMode = true;
        $scope.pharmacy = angular.copy(pharmacy);
        $scope.syncTestPharmacyState();
      } else {
        initPharmacy();
      }
      $scope.mailsSent = {
        titulaire: false,
        praq: false,
        equipe: false
      };
      $scope.urlValidation = {
        titulaire: '',
        praq: '',
        equipe: ''
      }
      $scope.pharmacyPopup = $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        onRemoving: function (scope, element) {
          $scope.getPharmacies();
          initPharmacy();
        },
        preserveScope: true
      }).then(function () {

      }).catch(function () {
      });
    };

    $scope.savePharmacy = function (sendActivationMail, ph, type, getLink, close) {
      $scope.error = {};
      $scope.syncTestPharmacyState();
      if (!getLink) {
        if ($scope.pharmacy.praq && $scope.pharmacy.praq.mail === '') {
          $scope.pharmacy.praq.mail = null;
        }
        if ($scope.pharmacy.team && $scope.pharmacy.team.mail === '') {
          $scope.pharmacy.team.mail = null;
        }
      }
      if ($scope.pharmacy.team && $scope.pharmacy.team.mail && $scope.pharmacy.team.mail !== '' && (($scope.pharmacy.team.mail === $scope.pharmacy.titulaire.mail) || ($scope.pharmacy.praq && $scope.pharmacy.praq.mail && $scope.pharmacy.praq !== '' && ($scope.pharmacy.praq.mail === $scope.pharmacy.team.mail)))) {
        $scope.error.sameemailteam = true;
        console.log('err1')
        return;
      } else {
        $scope.error.sameemailteam = false;
      }
      if ($scope.pharmacy.praq && $scope.pharmacy.praq.mail && $scope.pharmacy.praq.mail !== '' && (($scope.pharmacy.team && $scope.pharmacy.team.mail && $scope.pharmacy.team != '' && ($scope.pharmacy.praq.mail === $scope.pharmacy.team.mail)) || ($scope.pharmacy.praq.mail === $scope.pharmacy.titulaire.mail))) {
        $scope.error.sameemailpraq = true;
        console.log("err2")
        return;
      } else {
        $scope.error.sameemailpraq = false;
      }
      if (!$scope.error.sameemailpraq && !$scope.error.sameemailteam) {
        if ($scope.loadingSave) {
          return
        }
        $scope.loadingSave = true;
        PharmacyService.savePharmacy($scope.pharmacy).then(function (response) {
          if (!getLink && close) {
            $scope.hidePopup();
            $scope.getPharmacies();
            initPharmacy();
          }
          toastr.success('Modification(s) sauvegardée(s)');
          $scope.loadingSave = false;
          effacerDrapeauxRattachement();
          if (sendActivationMail) {
            PharmacyService.resentActivationEmail(ph.id, type).then(function (res) {
              toastr.success('Invitations renvoyées');
              $scope.mailsSent[type] = true;
            }).catch(function (err) {
              toastr.error('Erreur lors de l\'envoi des invitations');
            });
          }
          if (getLink) {
            PharmacyService.getUrlActivation(ph.id, type).then(function (res) {
              var url = res.data;
              $scope.urlValidation[type] = url;
            }).catch(function (err) {
              console.log(err);
              toastr.error('Erreur lors da recharge du lien d\'activation');
            });
          }

        }).catch(function (response) {
          $scope.loadingSave = false;
          effacerDrapeauxRattachement();
          if (response.status === 409) {
            // Pas de « Email non disponible » sous le champ quand une question est posée : le
            // rattachement n'est pas un refus, et les deux messages se contrediraient.
            if (!response.data.rattachable) {
              $scope.error[response.data.type] = true;
            }
            if (response.data.type == "numidentification") {
              toastr.error('Le numèro d\'identification existe déjà');
            } else if (response.data.rattachable) {
              // Le compte existe et peut rejoindre l'officine : on pose la question au lieu
              // d'afficher un refus sans issue.
              $scope.proposerRattachement(response.data, function () {
                $scope.savePharmacy(sendActivationMail, ph, type, getLink, close);
              });
            } else {
              toastr.error('Un des emails choisis existe déjà');
            }
          }
        });
      }
    };

    /**
     * Une confirmation ne vaut que pour LA sauvegarde qu'elle déclenche.
     *
     * ⚠️ Sans cette remise à zéro, le drapeau restait posé sur la fiche après un rattachement
     * réussi. La fiche se referme en général, mais pas quand la sauvegarde vient des boutons
     * « renvoyer l'invitation » ou « lien d'activation » : une AUTRE adresse existante saisie
     * ensuite aurait été rattachée sans que la question soit reposée.
     */
    function effacerDrapeauxRattachement() {
      angular.forEach(['titulaire', 'praq', 'team'], function (role) {
        if ($scope.pharmacy && $scope.pharmacy[role]) {
          $scope.pharmacy[role].rattacherCompteExistant = false;
        }
      });
    }

    /**
     * Le compte existe déjà : proposer de le RATTACHER à l'officine dans ce rôle.
     *
     * ⚠️ Une confirmation, et pas un rattachement d'office : le compte rattaché reçoit l'accès à
     * toutes les données de l'officine, et celui qui tenait le rôle le perd. Une adresse tapée de
     * travers ne doit pas suffire à provoquer ça — d'où le nom du compte dans la question.
     *
     * ⚠️ `multiple: true` : la fiche de l'officine est déjà ouverte, sans cela Material la ferme
     * pour afficher la confirmation et la saisie en cours est perdue.
     */
    $scope.proposerRattachement = function (reponse, rejouer) {
      $scope.rattachement = {
        role: reponse.type,
        libelleRole: reponse.type === 'titulaire' ? 'titulaire'
          : (reponse.type === 'praq' ? 'Responsable Qualité' : 'compte équipe'),
        compteMail: reponse.compteMail,
        // Un compte jamais activé n'a ni nom ni prénom : le back renvoie alors son adresse, il ne
        // faut pas l'afficher deux fois.
        compteNom: reponse.compteNom && reponse.compteNom !== reponse.compteMail
          ? reponse.compteNom : reponse.compteMail,
        rejouer: rejouer
      };
      $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_rattachement_confirm.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      }).catch(function () {
        // Fermeture par un clic à l'extérieur : Material rejette la promesse, le drapeau doit
        // être retiré comme sur « Annuler ».
        $scope.annulerRattachement(true);
      });
    };

    $scope.confirmerRattachement = function () {
      var demande = $scope.rattachement;
      $scope.rattachement = null;
      $mdDialog.hide();
      $scope.error = {};
      if (demande && $scope.pharmacy[demande.role]) {
        $scope.pharmacy[demande.role].rattacherCompteExistant = true;
      }
      if (demande && demande.rejouer) {
        demande.rejouer();
      }
    };

    /**
     * Refus : le drapeau ne doit pas rester posé, la prochaine sauvegarde reposerait la question
     * toute seule. `dejaFermee` évite de refermer une fenêtre que Material vient de fermer.
     */
    $scope.annulerRattachement = function (dejaFermee) {
      if ($scope.rattachement && $scope.pharmacy[$scope.rattachement.role]) {
        $scope.pharmacy[$scope.rattachement.role].rattacherCompteExistant = false;
      }
      $scope.rattachement = null;
      if (!dejaFermee) {
        $mdDialog.hide();
      }
    };

    $scope.changingEmail = function (origine, value, form) {
      if (value) {
        if (origine == "TITULAIRE") {
          if (($scope.pharmacy.praq && $scope.pharmacy.praq.mail != "" && $scope.pharmacy.praq.mail === value) || ($scope.pharmacy.team && $scope.pharmacy.team.mail != "" && $scope.pharmacy.team.mail === value)) {
            $scope.error.sameemailtitulaire = true;
            form.$valid = false;
            form.$invalid = true;
          } else {
            $scope.error.sameemailtitulaire = false;
          }
        } else if (origine == "PRAQ") {
          if (($scope.pharmacy.titulaire && $scope.pharmacy.titulaire.mail != "" && $scope.pharmacy.titulaire.mail === value) || ($scope.pharmacy.team && $scope.pharmacy.team.mail != "" && $scope.pharmacy.team.mail === value)) {
            $scope.error.sameemailpraq = true;
            form.$valid = false;
            form.$invalid = true;
          } else {
            $scope.error.sameemailpraq = false;
          }
        } else {
          if (($scope.pharmacy.praq && $scope.pharmacy.praq.mail != "" && $scope.pharmacy.praq.mail === value) || ($scope.pharmacy.titulaire && $scope.pharmacy.titulaire.mail != "" && $scope.pharmacy.titulaire.mail === value)) {
            $scope.error.sameemailteam = true;
            form.$valid = false;
            form.$invalid = true;
          } else {
            $scope.error.sameemailteam = false;
          }
        }
      }

    }

    $scope.openDelete = function (pharmacy) {
      if (pharmacy != null) {
        $scope.pharmacy = pharmacy;
      }
      $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_delete_confirm.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    }

    $scope.deletePermanently = function () {
      $scope.loading = true;
      PharmacyService.deletePermanently($scope.pharmacy.id).then(function (response) {
        toastr.success('La pharmacie a bien été supprimée');
        $scope.hidePopup();
        $scope.getPharmacies();
        initPharmacy();
        $scope.loading = false;
      }).catch(function (response) {
        toastr.error('Erreur lors de la suppression de la pharmacie');
        if (response.status === 409) {
          $scope.error[response.data.type] = true;
        }
        $scope.loading = false;
      });
    }

    $scope.showConfirm = function (pharmacy) {

      if (pharmacy != null) {
        $scope.pharmacy = pharmacy;
      }
      $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_confirm.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.setActivated = function (pharmacy, isActivated, getZip) {
      if (isActivated || !getZip) {
        PharmacyService.setActivated(pharmacy.id, isActivated, getZip).then(function (response) {
          for (var i = 0; i < $scope.pharmacies.length; i++) {
            if ($scope.pharmacies[i].id === pharmacy.id) {
              $scope.pharmacies[i].isActivated = isActivated;
              break;
            }
          }
          $scope.hidePopup();
        }).catch(function (err) {
        });
      } else {
        $window.location.href = "/api/rest/pharmacy/setActivated/" + pharmacy.id + "/" + isActivated + "/" + getZip;
        for (var i = 0; i < $scope.pharmacies.length; i++) {
          if ($scope.pharmacies[i].id === pharmacy.id) {
            $scope.pharmacies[i].isActivated = isActivated;
            break;
          }
        }
        pharmacy.isActivated = isActivated;
        $scope.hidePopup();
      }
      $scope.hidePopup();
    };

    $scope.resentActivationEmail = function (pharmacy, type) {
      $scope.savePharmacy(true, pharmacy, type, false, false);
    };

    $scope.openURLtoCopy = function (pharmacy, type, form) {
      if (form.$dirty) {
        $scope.savePharmacy(false, pharmacy, type, true, false);
      } else {
        PharmacyService.getUrlActivation(pharmacy.id, type).then(function (res) {
          var url = res.data;
          $scope.urlValidation[type] = url;
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors da recharge du lien d\'activation');
        });
      }

    }

    $scope.downloadZip = function (pharmacy) {
      $window.location.href = "/api/rest/pharmacy/downloadZip/" + pharmacy.id;
    };

    $scope.hidePopup = function (bool) {
      $mdDialog.hide();
      if (!bool) {
        $scope.urlValidation = {
          titulaire: '',
          praq: '',
          equipe: ''
        }
      }
    };

    $scope.cancelPopup = function () {
      $mdDialog.cancel();
    };

    $scope.exportAll = function (type) {
      var params = [];
      if ($scope.pagination.searchText) {
        params.push('searchText=' + encodeURIComponent($scope.pagination.searchText));
      }
      if ($scope.pagination.withoutActivatedAccount) {
        params.push('withoutActivatedAccount=true');
      }
      if ($scope.pagination.withActivatedAccount) {
        params.push('withActivatedAccount=true');
      }
      if ($scope.pagination.statusBase && $scope.pagination.statusBase !== 'all') {
        params.push('statusBase=' + encodeURIComponent($scope.pagination.statusBase));
      }
      if ($scope.pagination.engageQualite && $scope.pagination.engageQualite !== 'all') {
        params.push('engageQualite=' + encodeURIComponent($scope.pagination.engageQualite));
      }
      if ($scope.pagination.groupement && $scope.pagination.groupement !== 'all') {
        params.push('groupement=' + encodeURIComponent($scope.pagination.groupement));
      }

      var queryString = params.length ? '?' + params.join('&') : '';
      // Statut et engagement se lisent au CRM : sans aucune lecture depuis le démarrage, l'export
      // répondrait 503 et le navigateur afficherait le JSON brut à la place de l'application.
      PharmacyService.getEtatParcCrm().then(function () {
        $scope.erreurCrm = null;
        $window.location.href = '/api/rest/pharmacy/' + type + '/export' + queryString;
      }, function (response) {
        if (response && response.status === 503) {
          $scope.erreurCrm = 'Export impossible : ' + ((response.data && response.data.message) || 'le CRM ne répond pas.');
        } else {
          $window.location.href = '/api/rest/pharmacy/' + type + '/export' + queryString;
        }
      });
    }

    $scope.showGroupementImportDialog = function () {
      initGroupementImport();
      $scope.pharmacyPopup = $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_groupement_import.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.importGroupementAssociations = function () {
      var input = document.getElementById('groupement-association-input');
      if (!input || !input.files || !input.files.length) {
        $scope.groupementImport.error = 'Veuillez sélectionner un fichier.';
        return;
      }

      var formData = new FormData();
      formData.append('file', input.files[0]);
      $scope.groupementImport.loading = true;
      $scope.groupementImport.error = null;

      PharmacyService.importGroupementAssociations(formData).then(function (response) {
        var result = response.data;
        if (angular.isString(result)) {
          result = angular.fromJson(result);
        }

        $scope.groupementImport.result = result || { successCount: 0, errors: [] };
        $scope.getPharmacies();
        toastr.success('Import terminé');
      }).catch(function (response) {
        var errorMessage = 'Erreur lors de l\'import du fichier';
        if (response && response.data) {
          if (angular.isString(response.data)) {
            try {
              var parsed = angular.fromJson(response.data);
              if (parsed && parsed.message) {
                errorMessage = parsed.message;
              }
            } catch (e) {
            }
          } else if (response.data.message) {
            errorMessage = response.data.message;
          }
        }
        $scope.groupementImport.error = errorMessage;
        toastr.error(errorMessage);
      }).finally(function () {
        $scope.groupementImport.loading = false;
      });
    };

    $scope.changeContractType = function (pharmacy) {
      $scope.pharmacyPopup = $mdDialog.show({
        templateUrl: 'app/main/admin/pharmacies/popup/pharmacy_change_status.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        multiple: true,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
        $scope.setContractTypeBefore();
      });
    }

    $scope.setContractTypeBefore = function (before) {
      if (before && !$scope.contractTypeBefore) {
        $scope.contractTypeBefore = $scope.pharmacy.contractType;
      }
      else if (!before && $scope.contractTypeBefore) {
        $scope.pharmacy.contractType = $scope.contractTypeBefore;
        $scope.contractTypeBefore = null;
      }
    }

    $scope.openJoindreFile = function () {
      $('#groupement-association-input').click()
    }

  }
})();

(function() {
    'use strict';

    angular
    .module('app.front')
    .controller('PharmacyCategoriesController', PharmacyCategoriesController);

    function PharmacyCategoriesController($scope, $state, PHARMACIES_CATEGORIES) {
        $scope.categories = PHARMACIES_CATEGORIES;

        $scope.openCategorie = function(cat) {
            if (cat != null && angular.isDefined(cat.name)) {
                $state.go('admin.pharmacies.' + cat.name);
            }
        }
    };
})();
(function () {
  'use strict';

  angular.module('app.admin').factory('OsysAdminService', OsysAdminService);

  /**
   * PHSQ-240 — API /rest/admin/osys. Les refus portent {code, message, champs?} ; la promesse est
   * rejetée avec {status, code, message, champs}.
   *
   * @ngInject
   */
  function OsysAdminService($http, $q, $window) {
    var BASE = '/api/rest/admin/osys';

    function erreur(r) {
      var d = (r && r.data) || {};
      return { status: r ? r.status : 0, code: d.code, message: d.message, champs: d.champs || [] };
    }

    function appel(methode, url, donnees, params) {
      return $http({
        url: BASE + url,
        method: methode,
        params: angular.extend({ '_v': new Date().getTime() }, params || {}),
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: donnees
      }).then(function (r) {
        return r.data;
      }, function (r) {
        return $q.reject(erreur(r));
      });
    }

    function fichier(url, fichierChoisi) {
      var f = new FormData();
      f.append('file', fichierChoisi, fichierChoisi.name);
      return $http.post(BASE + url, f, { transformRequest: angular.identity, headers: { 'Content-Type': undefined } })
        .then(function (r) {
          return r.data;
        }, function (r) {
          return $q.reject(erreur(r));
        });
    }

    /** Téléchargement d'un xlsx : nom lu dans Content-Disposition. */
    function telecharger(url, params, nomParDefaut) {
      return $http.get(BASE + url, { params: angular.extend({ '_v': new Date().getTime() }, params || {}), responseType: 'arraybuffer' })
        .then(function (r) {
          var m = /filename="?([^";]+)"?/.exec(r.headers('content-disposition') || '');
          var lien = $window.URL.createObjectURL(new $window.Blob([r.data], { type: r.headers('content-type') }));
          var a = $window.document.createElement('a');
          a.href = lien;
          a.download = m ? m[1] : nomParDefaut;
          $window.document.body.appendChild(a);
          a.click();
          a.remove();
          $window.setTimeout(function () {
            $window.URL.revokeObjectURL(lien);
          }, 60000);
        }, function (r) {
          return $q.reject(erreur(r));
        });
    }

    /**
     * Confirmation d'activation (liste H3 et fiche H4). Deux notions à ne pas confondre :
     * - les COMPTES Titulaire LQO de l'officine, qui verront le menu du module ;
     * - les titulaires HABILITÉS (pharmaciens formés, import des formations), sans lesquels
     *   « Nouveau triage » reste bloqué (D-68).
     * Avertissements non bloquants : aucun compte Titulaire actif (M50), aucun titulaire habilité.
     */
    function confirmationActivation(nom, titulaireActif, habilitationsActives) {
      var avertissements = [];
      if (!titulaireActif) {
        avertissements.push('Aucun compte Titulaire actif : personne ne verra le module avant l’activation d’un compte.');
      }
      if (!habilitationsActives) {
        avertissements.push('Aucun titulaire habilité : le module sera visible, mais « Nouveau triage » restera bloqué '
          + 'jusqu’à l’import des habilitations (fichier des formations).');
      }
      return {
        texte: nom + ' : le menu Triage OSyS apparaîtra pour les comptes Titulaire de l’officine, après rechargement de leur page.',
        detail: avertissements.length ? 'Attention. ' + avertissements.join(' ') : null
      };
    }

    return {
      confirmationActivation: confirmationActivation,
      officines: function (filtre) { return appel('POST', '/officines', filtre); },
      officine: function (id) { return appel('GET', '/officines/' + id); },
      activer: function (id) { return appel('POST', '/officines/' + id + '/activer'); },
      desactiver: function (id) { return appel('POST', '/officines/' + id + '/desactiver'); },
      retirer: function (habilitationId) { return appel('POST', '/habilitations/' + habilitationId + '/retirer'); },
      symphony: function (cip) { return appel('GET', '/symphony/' + encodeURIComponent(cip)); },
      creerCompte: function (dto) { return appel('POST', '/comptes-osys', dto); },
      verifierImport: function (f) { return fichier('/habilitations/import/verification', f); },
      importer: function (f) { return fichier('/habilitations/import', f); },
      modele: function () { return telecharger('/habilitations/modele', null, 'modele-habilitations-osys.xlsx'); },
      indicateurs: function (mois) { return appel('GET', '/indicateurs', null, { mois: mois }); },
      exporter: function (mois) { return telecharger('/exports/evaluation', { mois: mois }, 'OSyS_evaluation.xlsx'); }
    };
  }
})();

(function () {
  'use strict';

  /** PHSQ-240 — libellés partagés de l'administration OSyS. */
  angular.module('app.admin').constant('OSYS_ADMIN_LIBELLES', {
    CONTRATS: { LQO: 'LQO', LQO_MINI: 'LQO découverte', NON_LQO: 'Non-LQO', OSYS: 'OSyS' },
    ETATS: { ACTIVE: 'Activé', DESACTIVE: 'Désactivé', NON_ACTIVE: 'Non activé' },
    STATUTS_IMPORT: {
      PRETE: 'Prête', MISE_A_JOUR: 'Déjà habilitée · date mise à jour', DEJA_HABILITE: 'Déjà habilitée', CIP_INCONNU: 'CIP inconnu',
      RPPS_INVALIDE: 'RPPS invalide', DATE_INVALIDE: 'Date invalide', CHAMP_MANQUANT: 'Champ manquant', DOUBLON_FICHIER: 'En double dans le fichier'
    }
  });
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('OsysAdminOfficinesController', OsysAdminOfficinesController);

  /**
   * PHSQ-240 — H3 : toutes les officines, filtres région, état, recherche ; activation ; création
   * d'un compte OSyS (D-55). Pagination côté serveur.
   *
   * @ngInject
   */
  function OsysAdminOfficinesController($state, $mdDialog, $timeout, toastr, OsysAdminService, ConfirmationGroupement, OSYS_ADMIN_LIBELLES) {
    var vm = this;
    var minuterie = null;
    vm.L = OSYS_ADMIN_LIBELLES;
    vm.filtre = { page: 1, region: '', etat: '', texte: '' };
    vm.resultat = null;

    function charger() {
      OsysAdminService.officines({
        page: vm.filtre.page, region: vm.filtre.region || null, etat: vm.filtre.etat || null, texte: vm.filtre.texte || null
      }).then(function (r) {
        vm.resultat = r;
      }).catch(signaler);
    }

    vm.filtrer = function () {
      vm.filtre.page = 1;
      charger();
    };

    vm.saisie = function () {
      if (minuterie) {
        $timeout.cancel(minuterie);
      }
      minuterie = $timeout(vm.filtrer, 350);
    };

    vm.pages = function () {
      return vm.resultat ? Math.max(1, Math.ceil(vm.resultat.total / vm.resultat.parPage)) : 1;
    };

    vm.allerPage = function (p) {
      vm.filtre.page = p;
      charger();
    };

    vm.ouvrir = function (ligne) {
      $state.go('admin.osys.officine', { id: ligne.pharmacyId });
    };

    /** Confirmation ; avertissements non bloquants : aucun compte Titulaire actif (M50), aucun titulaire habilité (D-68). */
    vm.activer = function (ligne, $event) {
      var confirmation = OsysAdminService.confirmationActivation(ligne.nom, ligne.titulaireActif, ligne.habilitations);
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: 'Activer le module Triage OSyS ?',
        texte: confirmation.texte,
        detail: confirmation.detail,
        confirmer: 'Activer',
        danger: false,
        event: $event
      }).then(function () {
        return OsysAdminService.activer(ligne.pharmacyId).then(function () {
          toastr.success('Module activé.');
          charger();
        });
      }).catch(function (err) {
        if (err) {
          signaler(err);
        }
      });
    };

    vm.creerCompte = function ($event) {
      $mdDialog.show({
        templateUrl: 'app/main/admin/osys/compte-osys.html',
        controller: CompteOsysController,
        controllerAs: 'd',
        targetEvent: $event,
        clickOutsideToClose: false
      }).then(function (pharmacyId) {
        toastr.success('Compte OSyS créé : l’invitation est partie au titulaire.');
        $state.go('admin.osys.officine', { id: pharmacyId });
      }).catch(angular.noop);
    };

    function signaler(err) {
      toastr.error((err && err.message) || 'Opération impossible.');
    }

    charger();
  }

  /** @ngInject */
  function CompteOsysController($mdDialog, toastr, OsysAdminService) {
    var d = this;
    d.saisie = { cip: '', mail: '', nom: '' };
    d.apercu = null;
    d.erreurs = {};
    d.envoi = false;

    d.chercher = function () {
      d.apercu = null;
      d.erreurs = {};
      if (!d.saisie.cip) {
        return;
      }
      OsysAdminService.symphony(d.saisie.cip.trim()).then(function (a) {
        d.apercu = a;
        if (a.nom) {
          d.saisie.nom = a.nom;
        }
      }).catch(function (err) {
        toastr.error(err.message || 'Recherche impossible.');
      });
    };

    d.peutCreer = function () {
      return d.apercu && !d.apercu.dejaDansLqo && d.saisie.mail && (d.apercu.nom || d.saisie.nom) && !d.envoi;
    };

    d.creer = function () {
      d.envoi = true;
      d.erreurs = {};
      OsysAdminService.creerCompte({ cip: d.saisie.cip.trim(), mail: d.saisie.mail.trim(), nom: d.saisie.nom || null }).then(function (r) {
        $mdDialog.hide(r.pharmacyId);
      }).catch(function (err) {
        d.envoi = false;
        (err.champs || []).forEach(function (c) {
          d.erreurs[c.champ] = c.message;
        });
        if (!err.champs || !err.champs.length) {
          toastr.error(err.message || 'Création impossible.');
        }
      });
    };

    d.annuler = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('OsysAdminOfficineController', OsysAdminOfficineController);

  /**
   * PHSQ-240 — H4 : fiche d'une officine, module (activer, désactiver, réactiver ; M51, M52),
   * habilitations (retirer ; état « Habilitation active » ou « Retirée le … », D-60).
   *
   * @ngInject
   */
  function OsysAdminOfficineController($stateParams, toastr, OsysAdminService, ConfirmationGroupement, OSYS_ADMIN_LIBELLES) {
    var vm = this;
    var id = parseInt($stateParams.id, 10);
    vm.L = OSYS_ADMIN_LIBELLES;
    vm.f = null;

    function charger() {
      OsysAdminService.officine(id).then(function (f) {
        vm.f = f;
      }).catch(signaler);
    }

    /** Habilitations en cours (les retirées restent listées). */
    vm.habilitationsActives = function () {
      return vm.f ? (vm.f.habilitations || []).filter(function (h) {
        return h.statut === 'HABILITE';
      }).length : 0;
    };

    vm.activer = function ($event) {
      var confirmation = OsysAdminService.confirmationActivation(vm.f.nom, vm.f.titulaireActif, vm.habilitationsActives());
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: vm.f.etat === 'DESACTIVE' ? 'Réactiver le module Triage OSyS ?' : 'Activer le module Triage OSyS ?',
        texte: confirmation.texte,
        detail: confirmation.detail,
        confirmer: vm.f.etat === 'DESACTIVE' ? 'Réactiver' : 'Activer',
        danger: false,
        event: $event
      }).then(function () {
        return OsysAdminService.activer(id).then(function (f) {
          vm.f = f;
          toastr.success('Module activé.');
        });
      }).catch(function (err) {
        if (err) {
          signaler(err);
        }
      });
    };

    vm.desactiver = function ($event) {
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: 'Désactiver le module Triage OSyS ?',
        texte: 'Plus de nouveau triage ; les rappels déjà prévus restent faisables, et les triages consultables.',
        confirmer: 'Désactiver',
        danger: true,
        event: $event
      }).then(function () {
        return OsysAdminService.desactiver(id).then(function (f) {
          vm.f = f;
          toastr.success('Module désactivé.');
        });
      }).catch(function (err) {
        if (err) {
          signaler(err);
        }
      });
    };

    vm.retirer = function (h, $event) {
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: 'Retirer l’habilitation ?',
        texte: h.prenom + ' ' + h.nom + ' ne pourra plus réaliser de triage. Les triages passés gardent son nom.',
        confirmer: 'Retirer',
        danger: true,
        event: $event
      }).then(function () {
        return OsysAdminService.retirer(h.id).then(function (f) {
          vm.f = f;
          toastr.success('Habilitation retirée.');
        });
      }).catch(function (err) {
        if (err) {
          signaler(err);
        }
      });
    };

    function signaler(err) {
      toastr.error((err && err.message) || 'Opération impossible.');
    }

    charger();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('OsysAdminIndicateursController', OsysAdminIndicateursController);

  /**
   * PHSQ-240 — H6 : indicateurs du mois, toutes officines (§10.1), et export d'évaluation sans
   * identité des patients (§10.2, M58). Pas d'export de facturation (décidé le 11/10).
   *
   * @ngInject
   */
  function OsysAdminIndicateursController(toastr, OsysAdminService) {
    var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var vm = this;
    vm.mois = null;
    vm.i = null;
    vm.export = false;

    vm.libelleMois = function (m, majuscule) {
      if (!m) {
        return '';
      }
      var p = m.split('-');
      var l = MOIS[parseInt(p[1], 10) - 1] + ' ' + p[0];
      return majuscule ? l.charAt(0).toUpperCase() + l.slice(1) : l;
    };

    vm.charger = function () {
      OsysAdminService.indicateurs(vm.mois).then(function (i) {
        vm.i = i;
        vm.mois = i.mois;
      }).catch(function (err) {
        toastr.error(err.message || 'Indicateurs indisponibles.');
      });
    };

    vm.exporter = function () {
      vm.export = true;
      OsysAdminService.exporter(vm.mois).catch(function (err) {
        toastr.error((err && err.message) || 'Export impossible.');
      }).finally(function () {
        vm.export = false;
      });
    };

    vm.charger();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('OsysAdminImportController', OsysAdminImportController);

  /**
   * PHSQ-240 — H5 : import des habilitations. Le fichier est vérifié dès le dépôt (rien n'est
   * écrit), puis « Importer » renvoie le MÊME fichier, que le serveur revérifie (M54).
   *
   * @ngInject
   */
  function OsysAdminImportController($scope, $state, $element, toastr, OsysAdminService, OSYS_ADMIN_LIBELLES) {
    var vm = this;
    vm.L = OSYS_ADMIN_LIBELLES;
    vm.fichier = null;
    vm.verification = null;
    vm.envoi = false;

    // Le champ fichier est caché ; un bouton l'ouvre. Écoute déléguée : le champ ne change pas.
    $element.on('change', function (evenement) {
      var champ = evenement.target;
      if (!champ.classList.contains('osy-import__fichier') || !champ.files.length) {
        return;
      }
      var f = champ.files[0];
      champ.value = '';
      $scope.$apply(function () {
        vm.verifier(f);
      });
    });

    vm.choisir = function () {
      $element[0].querySelector('.osy-import__fichier').click();
    };

    vm.verifier = function (f) {
      vm.fichier = f;
      vm.verification = null;
      vm.envoi = true;
      OsysAdminService.verifierImport(f).then(function (v) {
        vm.verification = v;
      }).catch(function (err) {
        vm.fichier = null;
        toastr.error((err.champs && err.champs[0] && err.champs[0].message) || err.message || 'Fichier illisible.');
      }).finally(function () {
        vm.envoi = false;
      });
    };

    vm.aImporter = function () {
      return vm.verification ? vm.verification.pretes + vm.verification.misesAJour : 0;
    };

    vm.importer = function () {
      vm.envoi = true;
      OsysAdminService.importer(vm.fichier).then(function (r) {
        var morceaux = [r.importees + (r.importees > 1 ? ' habilitations importées' : ' habilitation importée')];
        if (r.misesAJour) {
          morceaux.push(r.misesAJour + (r.misesAJour > 1 ? ' mises à jour' : ' mise à jour'));
        }
        if (r.ignorees) {
          morceaux.push(r.ignorees + ' déjà habilitée' + (r.ignorees > 1 ? 's' : ''));
        }
        if (r.erreurs) {
          morceaux.push(r.erreurs + ' en erreur');
        }
        toastr.success(morceaux.join(' · ') + '.');
        $state.go('admin.osys.officines');
      }).catch(function (err) {
        vm.envoi = false;
        toastr.error(err.message || 'Import impossible.');
      });
    };

    vm.modele = function () {
      OsysAdminService.modele().catch(function () {
        toastr.error('Téléchargement impossible.');
      });
    };

    vm.classe = function (statut) {
      return statut === 'PRETE' ? 'vert' : statut === 'MISE_A_JOUR' ? 'bleu' : statut === 'DEJA_HABILITE' ? 'gris' : 'rouge';
    };

    $scope.$on('$destroy', function () {
      $element.off('change');
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminHomeController', AdminHomeController);

  /** @ngInject */
  function AdminHomeController($scope, $state, $window, toastr) {
    // PHSQ-240 : alerte posée à la connexion quand il reste 2 codes de secours ou moins.
    try {
      var restants = $window.sessionStorage.getItem('lqo.codesSecoursRestants');
      if (restants !== null) {
        $window.sessionStorage.removeItem('lqo.codesSecoursRestants');
        toastr.warning('Il vous reste ' + restants + ' code' + (restants === '1' ? '' : 's')
          + ' de secours. Régénérez-les depuis « Administrateurs ».', 'Codes de secours',
          { timeOut: 0, extendedTimeOut: 0, closeButton: true });
      }
    } catch (e) {
      // stockage indisponible : pas d'alerte
    }
    $scope.sections = [
      {
        title: 'Pharmacies',
        description: 'Gérer les pharmacies, leurs comptes et consulter les statistiques.',
        icon: 'icon-pharmacy',
        state: 'admin.pharmacies',
        accent: 'orange',
        index: 1
      },
      {
        title: 'Bandeau déroulant',
        description: 'Publier et historiser les messages affichés dans le bandeau.',
        icon: 'icon-message-text-outline',
        state: 'admin.bandeau',
        accent: 'blue',
        index: 2
      },
      {
        title: 'Groupements',
        description: 'Administrer les groupements et leurs accès.',
        icon: 'icon-account-multiple-outline',
        state: 'admin.groupements',
        accent: 'slate',
        index: 3
      },
      {
        title: 'Journées qualité',
        description: 'Configurer les campagnes, la boîte à outils et le suivi des enquêtes.',
        icon: 'icon-chart-line',
        state: 'admin.configuration-campagne',
        accent: 'cyan',
        index: 4
      }
    ];

    $scope.openSection = function (section) {
      if (section && section.state) {
        $state.go(section.state);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .service('GroupementAdminService', GroupementAdminService);

  /**
   * Administration des accès à l'espace groupement (§9.1).
   *
   * ⚠️ La liste des groupements vient du CRM : LQO n'en tient aucun miroir. Ce que l'administrateur
   * gère ici, ce sont les ACCÈS — qui a le droit d'entrer, sur quel réseau, à quel niveau.
   * Création, renommage et suppression d'un groupement se font dans le CRM.
   */
  function GroupementAdminService($q, $http) {
    var BASE = '/api/rest/groupement/admin';

    function requete(method, url, data) {
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: method,
          params: { _v: new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' },
          data: data
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    /** Groupements du CRM, chacun avec les accès enregistrés dans LQO. */
    function getGroupements() {
      return requete('GET', BASE);
    }

    /** Donne accès à un groupement CRM. Le compte est créé et invité s'il n'existe pas encore. */
    function ajouterAcces(codeCrm, mail, niveau) {
      return requete('POST', BASE + '/' + codeCrm + '/acces', { mail: mail, niveau: niveau });
    }

    function modifierNiveau(accesId, niveau) {
      return requete('PUT', BASE + '/acces/' + accesId, { niveau: niveau });
    }

    function retirerAcces(accesId) {
      return requete('DELETE', BASE + '/acces/' + accesId);
    }

    /**
     * Corrige l'adresse d'un accès (faute de frappe à l'invitation). Le serveur refuse en 409
     * dès que le compte a été activé ou qu'il sert ailleurs — voir GroupementService côté back.
     */
    function corrigerMail(accesId, mail) {
      return requete('PUT', BASE + '/acces/' + accesId + '/mail', { mail: mail });
    }

    function renvoyerInvitation(accesId) {
      return requete('POST', BASE + '/acces/' + accesId + '/invitation');
    }

    /**
     * Reprise unique des responsables historiques (§13). Fait correspondre la liste des
     * groupements du CRM aux responsables actuels de LQO. Idempotent.
     */
    function reprendreResponsables() {
      return requete('POST', BASE + '/reprise-acces');
    }

    /**
     * Rattachement des officines LQO aux groupements du CRM, relu à l'instant : d'où vient le
     * périmètre des restitutions Journées qualité, et quelles officines en sortent à cause du lien.
     */
    function getRattachements() {
      return requete('GET', BASE + '/rattachements');
    }

    /** Ré-associe des officines à la fiche du CRM que désigne aujourd'hui leur code CIP. */
    function reassocier(ids) {
      return requete('POST', BASE + '/rattachements/reassocier', { ids: ids });
    }

    return {
      getGroupements: getGroupements,
      ajouterAcces: ajouterAcces,
      modifierNiveau: modifierNiveau,
      retirerAcces: retirerAcces,
      corrigerMail: corrigerMail,
      renvoyerInvitation: renvoyerInvitation,
      reprendreResponsables: reprendreResponsables,
      getRattachements: getRattachements,
      reassocier: reassocier
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('GroupementsController', GroupementsController);

  /**
   * Liste des groupements — miroir du référentiel du CRM (§9.1).
   *
   * ⚠️ La liste vient du CRM et n'est pas modifiable ici : créer, renommer ou supprimer un
   * groupement se fait dans le CRM. Cet écran sert à voir où en sont les accès et à ouvrir le
   * détail d'un réseau pour les gérer.
   */
  /** @ngInject */
  function GroupementsController($scope, $state, toastr, $mdDialog, GroupementAdminService) {
    $scope.groupements = [];
    $scope.loading = false;
    $scope.searchText = '';

    // Le bouton « effacer » vit sous un `ng-if` : sans passer par le contrôleur, l'affectation
    // resterait dans la portée fille et le champ ne se viderait jamais.
    $scope.clearSearch = function () {
        $scope.searchText = '';
    };
    $scope.statusFilter = null;
    $scope.traitement = false;

    function extractCollection(data) {
      if (!data) {
        return [];
      }
      if (angular.isArray(data)) {
        return data;
      }
      return angular.isArray(data.groupements) ? data.groupements : [];
    }

    $scope.load = function () {
      $scope.loading = true;
      GroupementAdminService.getGroupements().then(function (response) {
        $scope.groupements = extractCollection(response.data).map(function (groupement) {
          groupement.acces = groupement.acces || [];
          return groupement;
        });
      }).catch(function () {
        $scope.groupements = [];
        toastr.error('Impossible de charger les groupements du CRM.');
      }).finally(function () {
        $scope.loading = false;
      });
    };

    $scope.ouvrirDetail = function (groupement) {
      $state.go('admin.groupement', { codeCrm: groupement.codeCrm });
    };

    // --- Compteurs de tête, qui servent aussi de filtres

    $scope.countAvecAcces = function () {
      return ($scope.groupements || []).filter(function (g) { return g.acces.length > 0; }).length;
    };

    $scope.countSansAcces = function () {
      return ($scope.groupements || []).filter(function (g) { return !g.acces.length; }).length;
    };

    $scope.countInvitationsEnAttente = function () {
      return ($scope.groupements || []).filter(function (g) {
        return g.acces.some(function (acces) { return !acces.invitationAcceptee; });
      }).length;
    };

    $scope.setStatusFilter = function (filtre) {
      $scope.statusFilter = $scope.statusFilter === filtre ? null : filtre;
    };

    $scope.matchStatus = function (groupement) {
      if (!$scope.statusFilter) {
        return true;
      }
      if ($scope.statusFilter === 'avec') {
        return groupement.acces.length > 0;
      }
      if ($scope.statusFilter === 'sans') {
        return !groupement.acces.length;
      }
      return groupement.acces.some(function (acces) { return !acces.invitationAcceptee; });
    };

    $scope.nbEnAttente = function (groupement) {
      return groupement.acces.filter(function (acces) { return !acces.invitationAcceptee; }).length;
    };

    // --- Opérations de mise en service

    /**
     * Reprise unique des responsables historiques. Le CRM ne contient aucun utilisateur de
     * groupement : la seule migration possible est de faire correspondre sa liste de groupements
     * aux responsables déjà enregistrés dans LQO.
     */
    $scope.reprendreResponsables = function (event) {
      var confirmation = $mdDialog.confirm()
        .title('Reprendre les responsables existants')
        .textContent('Chaque responsable de groupement déjà enregistré dans LQO recevra un accès '
          + 'de niveau Responsable sur le groupement CRM de même nom. Sans effet si l\'opération a '
          + 'déjà été passée.')
        .targetEvent(event)
        .ok('Reprendre')
        .cancel('Annuler');

      $mdDialog.show(confirmation).then(function () {
        $scope.traitement = true;
        return GroupementAdminService.reprendreResponsables();
      }).then(function (response) {
        var rapport = response.data;
        toastr.success(rapport.accesCrees + ' accès repris, ' + rapport.dejaPresents + ' déjà présents.');
        if ((rapport.ambiguites || []).length) {
          // Plusieurs groupements CRM portent le même nom : on ne tranche pas à leur place.
          toastr.warning((rapport.ambiguites || []).length + ' groupement(s) à arbitrer à la main : '
            + rapport.ambiguites.map(function (cas) { return cas.groupement; }).join(', '));
        }
        $scope.load();
      }).catch(function (error) {
        if (error) {
          toastr.error(messageErreur(error, 'La reprise a échoué.'));
        }
      }).finally(function () {
        $scope.traitement = false;
      });
    };

    // --- Rattachement des officines au CRM (périmètre des Journées qualité)

    /*
     * Plus de bouton « Rafraîchir le parc » : LQO relit lui-même le CRM (29/09/2026). Il ne reste
     * à l'administrateur qu'un geste : ré-associer les officines dont la référence n'existe plus
     * dans le CRM, qui n'est jamais remplacée sans qu'il le décide. Les officines jamais
     * rapprochées (code CIP inconnu du CRM) ne sont pas proposées : sans référence, elles sont
     * retentées d'elles-mêmes par leur code CIP à chaque lecture.
     */
    $scope.rattachements = null;
    $scope.officinesAReassocier = [];
    $scope.rattachementsChargement = false;
    $scope.reassociationEnCours = false;

    function appliquerEtat(etat) {
      $scope.rattachements = etat || null;
      $scope.officinesAReassocier = ((etat && etat.horsRestitutions) || []).filter(function (officine) {
        return officine.motif !== 'NON_RAPPROCHEE';
      });
    }

    $scope.chargerRattachements = function () {
      $scope.rattachementsChargement = true;
      GroupementAdminService.getRattachements().then(function (response) {
        appliquerEtat(response.data);
      }).catch(function () {
        appliquerEtat(null);
        toastr.error('Impossible de lire le rattachement des officines au CRM.');
      }).finally(function () {
        $scope.rattachementsChargement = false;
      });
    };

    /** Relie des officines à la fiche du CRM que désigne aujourd'hui leur code CIP. */
    $scope.reassocier = function (officines, event) {
      var ids = (officines || []).map(function (officine) { return officine.id; });
      if (!ids.length) {
        return;
      }
      var confirmation = $mdDialog.confirm()
        .title(ids.length === 1 ? 'Ré-associer ' + officines[0].nom : 'Ré-associer ' + ids.length + ' officines')
        .textContent('Chaque officine sera reliée à la fiche du CRM que désigne aujourd\'hui son code CIP, '
          + 'à la place de sa référence actuelle. Une officine dont le code CIP est inconnu du CRM reste '
          + 'en l\'état.')
        .targetEvent(event)
        .ok('Ré-associer')
        .cancel('Annuler');

      $mdDialog.show(confirmation).then(function () {
        $scope.reassociationEnCours = true;
        return GroupementAdminService.reassocier(ids);
      }).then(function (response) {
        var rapport = response.data;
        if (rapport.etat) {
          appliquerEtat(rapport.etat);
        }
        toastr.success(rapport.reassociees + ' officine(s) ré-associée(s)'
          + (rapport.introuvables ? ', ' + rapport.introuvables + ' sans fiche active au CRM pour leur code CIP.' : '.'));
      }).catch(function (error) {
        if (error) {
          toastr.error(messageErreur(error, 'La ré-association a échoué.'));
        }
      }).finally(function () {
        $scope.reassociationEnCours = false;
      });
    };

    function messageErreur(error, defaut) {
      if (error && error.data && error.data.message) {
        return error.data.message;
      }
      if (error && error.status === 503) {
        return 'Le CRM est momentanément indisponible.';
      }
      return defaut;
    }

    $scope.load();
    $scope.chargerRattachements();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin')
    .service('ConfigurationCampagneAdminService', ConfigurationCampagneAdminService);

  function ConfigurationCampagneAdminService($q, $http) {
    var URL_CONFIGURATION_CAMPAGNE = "/api/rest/configurationCampagne/admin";
    var URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES = URL_CONFIGURATION_CAMPAGNE + "/brevo/templates";
    var URL_CONFIGURATION_CAMPAGNE_NON_LQO_RELANCE_EMAIL_SEND = URL_CONFIGURATION_CAMPAGNE + "/non-lqo-relance-email/send";
    var URL_CONFIGURATION_CAMPAGNE_NON_LQO_RELANCE_EMAIL_TEST = URL_CONFIGURATION_CAMPAGNE + "/non-lqo-relance-email/test";

    var getCurrentAdmin = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var saveAdmin = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getBrevoTemplatesAdmin = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var validateBrevoTemplateAdmin = function (templateId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES + "/" + templateId + "/validate",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var validateBrevoReportAvailableEmailTemplateAdmin = function (templateId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES + "/" + templateId + "/validate/report-available-email",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var validateBrevoGroupementReportAvailableEmailTemplateAdmin = function (templateId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES + "/" + templateId + "/validate/groupement-report-available-email",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var validateBrevoNonLqoRelanceEmailTemplateAdmin = function (templateId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_BREVO_TEMPLATES + "/" + templateId + "/validate/non-lqo-relance-email",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var sendNonLqoRelanceEmails = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_NON_LQO_RELANCE_EMAIL_SEND,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var testNonLqoRelanceEmail = function (pharmacyId) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_CONFIGURATION_CAMPAGNE_NON_LQO_RELANCE_EMAIL_TEST + "/" + pharmacyId,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      getCurrentAdmin: getCurrentAdmin,
      saveAdmin: saveAdmin,
      getBrevoTemplatesAdmin: getBrevoTemplatesAdmin,
      validateBrevoTemplateAdmin: validateBrevoTemplateAdmin,
      validateBrevoReportAvailableEmailTemplateAdmin: validateBrevoReportAvailableEmailTemplateAdmin,
      validateBrevoGroupementReportAvailableEmailTemplateAdmin: validateBrevoGroupementReportAvailableEmailTemplateAdmin,
      validateBrevoNonLqoRelanceEmailTemplateAdmin: validateBrevoNonLqoRelanceEmailTemplateAdmin,
      sendNonLqoRelanceEmails: sendNonLqoRelanceEmails,
      testNonLqoRelanceEmail: testNonLqoRelanceEmail
    };
  };
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ConfigurationCampagneController', ConfigurationCampagneController);

  function ConfigurationCampagneController($scope, $rootScope, $mdDialog, toastr, ConfigurationCampagneAdminService) {
    var DEFAULT_DIFFUSION_MESSAGE = "Diffusez votre enquête via les canaux ci-dessous. Les liens sont tracés par origine (SMS, Email, QR code, Papier, Tablette, Réseaux sociaux).";
    var DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE = "Envoi sous 48h après fin de campagne.";
    var DEFAULT_END_OF_CAMPAIGN_NOTICES = [
      {
        title: "Pharmacies",
        message: "En fin de campagne, chaque pharmacie recevra par email son rapport individuel."
      },
      {
        title: "Groupements",
        message: "En fin de campagne, chaque groupement recevra par email un rapport consolidé du groupement (comparatif national) et un ZIP des rapports individuels de ses pharmacies."
      },
      {
        title: "Administrateur",
        message: "En fin de campagne, l'administrateur disposera dans l'interface du ZIP des rapports des pharmacies engagées."
      }
    ];
    var DEFAULT_BAD_REQUEST_MESSAGE = "Les données saisies sont invalides";
    var NON_LQO_RELANCE_COOLDOWN_MS = 24 * 60 * 60 * 1000;
    var NON_LQO_RELANCE_COOLDOWN_ERROR_MESSAGE = "Une relance non-LQO a déjà été lancée il y a moins de 24h. Vous pourrez relancer après expiration du délai.";
    var BREVO_TEMPLATE_POPUP_URL = 'app/main/admin/campagne/popup/configuration-campagne-brevo-template-popup.html';
    var TEMPLATE_CHANNEL_EMAIL_CAMPAIGN = 'campaign-email';
    var TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL = 'report-available-email';
    var TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL = 'groupement-report-available-email';
    var TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL = 'non-lqo-relance-email';
    var BREVO_TEMPLATE_POPUP_CONFIG = {};
    var requiredKeysByTemplateKind = {};
    var helpKeysByTemplateKind = {};

    BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN] = {
      title: "Template Brevo - Email enquête",
      intro: "Sélectionnez le template Brevo qui sera utilisé pour envoyer l'enquête de satisfaction par email.",
      successMessage: "Template Brevo sélectionné"
    };
    BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL] = {
      title: "Template Brevo - Email disponibilité synthèse PDF",
      intro: "Sélectionnez le template Brevo qui sera utilisé pour notifier la disponibilité de la synthèse PDF.",
      successMessage: "Template Brevo sélectionné"
    };
    BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL] = {
      title: "Template Brevo - Email groupement synthèses PDF",
      intro: "Sélectionnez le template Brevo qui sera utilisé pour notifier les responsables groupement que le ZIP des synthèses est disponible.",
      successMessage: "Template Brevo sélectionné"
    };
    BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL] = {
      title: "Template Brevo - Mail de relance non-LQO",
      intro: "Sélectionnez le template Brevo qui sera utilisé pour envoyer le mail de relance aux pharmacies non-LQO.",
      successMessage: "Template Brevo sélectionné"
    };

    requiredKeysByTemplateKind[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN] = ['[[LIEN_ENQUETE]]', '[[NOM_PHARMACIE]]'];
    requiredKeysByTemplateKind[TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL] = ['[[URL_LQO]]'];
    requiredKeysByTemplateKind[TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL] = ['[[URL_LQO]]'];
    requiredKeysByTemplateKind[TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL] = ['[[LIEN_CREATION_MOT_PASS]]'];
    helpKeysByTemplateKind[TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL] = ['[[NOM_PHARMACIE]]'];

    $scope.loading = false;
    $scope.submitting = false;
    $scope.sendingNonLqoRelance = false;

    $scope.configuration = {
      endOfCampaignDelayMessage: DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE,
      endOfCampaignNotices: angular.copy(DEFAULT_END_OF_CAMPAIGN_NOTICES)
    };
    $scope._configuration = {};
    $scope.datePickers = {
      dateDebutCampagne: false,
      dateFinCollecte: false
    };
    $scope.templatePopup = {
      loading: false,
      submitting: false,
      templates: [],
      searchText: '',
      selectedTemplateId: null,
      channel: TEMPLATE_CHANNEL_EMAIL_CAMPAIGN,
      title: BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN].title,
      intro: BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN].intro,
      requiredKeys: requiredKeysByTemplateKind[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN],
      helpKeys: helpKeysByTemplateKind[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN] || []
    };

    var toDate = function (value) {
      return value ? new Date(value) : null;
    };

    var toTimestamp = function (value) {
      return value ? value.getTime() : null;
    };

    var isNonLqoRelanceLocked = function (lastSentAt) {
      if (!lastSentAt) {
        return false;
      }
      return (new Date().getTime() - lastSentAt) < NON_LQO_RELANCE_COOLDOWN_MS;
    };

    var refreshNonLqoRelanceCooldownState = function () {
      $scope.configuration.nonLqoRelanceLocked = isNonLqoRelanceLocked($scope.configuration.lastNonLqoRelanceEmailSentAt);
      $scope.configuration.nonLqoRelanceCooldownErrorMessage = $scope.configuration.nonLqoRelanceLocked
        ? NON_LQO_RELANCE_COOLDOWN_ERROR_MESSAGE
        : null;
    };

    var extractErrorMessage = function (response) {
      if (!response || !response.data) {
        return null;
      }
      if (angular.isString(response.data)) {
        try {
          var parsed = JSON.parse(response.data);
          return parsed && parsed.message ? parsed.message : response.data;
        } catch (e) {
          return response.data;
        }
      }
      if (response.data.message) {
        return response.data.message;
      }
      return null;
    };

    var getTemplatePopupConfig = function (channel) {
      return BREVO_TEMPLATE_POPUP_CONFIG[channel] || BREVO_TEMPLATE_POPUP_CONFIG[TEMPLATE_CHANNEL_EMAIL_CAMPAIGN];
    };

    var resolveSelectedTemplateIdByChannel = function (channel) {
      if (channel === TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL) {
        return $scope.configuration.brevoReportAvailableEmailTemplateId || null;
      }
      if (channel === TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL) {
        return $scope.configuration.brevoGroupementReportAvailableEmailTemplateId || null;
      }
      if (channel === TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL) {
        return $scope.configuration.brevoNonLqoRelanceEmailTemplateId || null;
      }
      return $scope.configuration.brevoEmailTemplateId || null;
    };

    var applyTemplatePopupConfiguration = function (channel) {
      var config = getTemplatePopupConfig(channel);
      $scope.templatePopup.channel = channel || TEMPLATE_CHANNEL_EMAIL_CAMPAIGN;
      $scope.templatePopup.title = config.title;
      $scope.templatePopup.intro = config.intro;
      $scope.templatePopup.requiredKeys = angular.copy(requiredKeysByTemplateKind[$scope.templatePopup.channel] || []);
      $scope.templatePopup.helpKeys = angular.copy(helpKeysByTemplateKind[$scope.templatePopup.channel] || []);
      $scope.templatePopup.selectedTemplateId = resolveSelectedTemplateIdByChannel($scope.templatePopup.channel);
    };

    var resetTemplatePopupState = function (channel) {
      $scope.templatePopup.loading = false;
      $scope.templatePopup.submitting = false;
      $scope.templatePopup.templates = [];
      $scope.templatePopup.searchText = '';
      applyTemplatePopupConfiguration(channel || $scope.templatePopup.channel || TEMPLATE_CHANNEL_EMAIL_CAMPAIGN);
    };

    var loadBrevoTemplates = function () {
      $scope.templatePopup.loading = true;
      ConfigurationCampagneAdminService.getBrevoTemplatesAdmin().then(function (templates) {
        $scope.templatePopup.templates = angular.isArray(templates) ? templates : [];
      }).catch(function () {
        toastr.error("Erreur lors du chargement des templates Brevo");
      }).finally(function () {
        $scope.templatePopup.loading = false;
      });
    };

    var hydrateConfiguration = function (data) {
      if (!data) {
        $scope.configuration.id = null;
        $scope.configuration.dateDebutCampagne = toDate(null);
        $scope.configuration.dateFinCollecte = toDate(null);
        $scope.configuration.diffusionMessage = DEFAULT_DIFFUSION_MESSAGE;
        $scope.configuration.brevoEmailTemplateId = null;
        $scope.configuration.brevoEmailTemplateName = null;
        $scope.configuration.brevoReportAvailableEmailTemplateId = null;
        $scope.configuration.brevoReportAvailableEmailTemplateName = null;
        $scope.configuration.brevoGroupementReportAvailableEmailTemplateId = null;
        $scope.configuration.brevoGroupementReportAvailableEmailTemplateName = null;
        $scope.configuration.brevoNonLqoRelanceEmailTemplateId = null;
        $scope.configuration.brevoNonLqoRelanceEmailTemplateName = null;
        $scope.configuration.lastNonLqoRelanceEmailSentAt = null;
        $scope.configuration.brevoEmailSendingStandby = false;
        $scope.configuration.brevoEmailSendingStandbyReason = null;
        $scope.configuration.endOfCampaignDelayMessage = DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE;
        $scope.configuration.endOfCampaignNotices = angular.copy(DEFAULT_END_OF_CAMPAIGN_NOTICES);
        refreshNonLqoRelanceCooldownState();
        return;
      }

      $scope.configuration.id = data.id;
      $scope.configuration.dateDebutCampagne = toDate(data.dateDebutCampagne);
      $scope.configuration.dateFinCollecte = toDate(data.dateFinCollecte);
      $scope.configuration.diffusionMessage = data.diffusionMessage || DEFAULT_DIFFUSION_MESSAGE;
      $scope.configuration.brevoEmailTemplateId = data.brevoEmailTemplateId || null;
      $scope.configuration.brevoEmailTemplateName = data.brevoEmailTemplateName || null;
      $scope.configuration.brevoReportAvailableEmailTemplateId = data.brevoReportAvailableEmailTemplateId || null;
      $scope.configuration.brevoReportAvailableEmailTemplateName = data.brevoReportAvailableEmailTemplateName || null;
      $scope.configuration.brevoGroupementReportAvailableEmailTemplateId = data.brevoGroupementReportAvailableEmailTemplateId || null;
      $scope.configuration.brevoGroupementReportAvailableEmailTemplateName = data.brevoGroupementReportAvailableEmailTemplateName || null;
      $scope.configuration.brevoNonLqoRelanceEmailTemplateId = data.brevoNonLqoRelanceEmailTemplateId || null;
      $scope.configuration.brevoNonLqoRelanceEmailTemplateName = data.brevoNonLqoRelanceEmailTemplateName || null;
      $scope.configuration.lastNonLqoRelanceEmailSentAt = data.lastNonLqoRelanceEmailSentAt || null;
      $scope.configuration.brevoEmailSendingStandby = !!data.brevoEmailSendingStandby;
      $scope.configuration.brevoEmailSendingStandbyReason = data.brevoEmailSendingStandbyReason || null;
      $scope.configuration.endOfCampaignDelayMessage = data.endOfCampaignDelayMessage || DEFAULT_END_OF_CAMPAIGN_DELAY_MESSAGE;
      $scope.configuration.endOfCampaignNotices = angular.isArray(data.endOfCampaignNotices) && data.endOfCampaignNotices.length
        ? angular.copy(data.endOfCampaignNotices)
        : angular.copy(DEFAULT_END_OF_CAMPAIGN_NOTICES);
      refreshNonLqoRelanceCooldownState();
    };

    $scope.getConfiguration = function () {
      $scope.loading = true;
      ConfigurationCampagneAdminService.getCurrentAdmin().then(function (data) {
        hydrateConfiguration(data);
        $scope.loading = false;
      }).catch(function () {
        toastr.error("Erreur lors du chargement de la configuration de campagne");
      }).finally(function () {
        $scope.loading = false;
      });
    };

    $scope.saveConfiguration = function () {
      var payload = {
        id: $scope.configuration.id,
        dateDebutCampagne: toTimestamp($scope.configuration.dateDebutCampagne),
        dateFinCollecte: toTimestamp($scope.configuration.dateFinCollecte),
        diffusionMessage: $scope.configuration.diffusionMessage,
        brevoEmailTemplateId: $scope.configuration.brevoEmailTemplateId,
        brevoEmailTemplateName: $scope.configuration.brevoEmailTemplateName,
        brevoReportAvailableEmailTemplateId: $scope.configuration.brevoReportAvailableEmailTemplateId,
        brevoReportAvailableEmailTemplateName: $scope.configuration.brevoReportAvailableEmailTemplateName,
        brevoGroupementReportAvailableEmailTemplateId: $scope.configuration.brevoGroupementReportAvailableEmailTemplateId,
        brevoGroupementReportAvailableEmailTemplateName: $scope.configuration.brevoGroupementReportAvailableEmailTemplateName,
        brevoNonLqoRelanceEmailTemplateId: $scope.configuration.brevoNonLqoRelanceEmailTemplateId,
        brevoNonLqoRelanceEmailTemplateName: $scope.configuration.brevoNonLqoRelanceEmailTemplateName
      };

      if (payload.dateDebutCampagne > payload.dateFinCollecte) {
        toastr.error("La date de fin de collecte doit être après la date de début de campagne");
        return;
      }

      $scope.submitting = true;
      ConfigurationCampagneAdminService.saveAdmin(payload).then(function (data) {
        hydrateConfiguration(data);
        toastr.success("Configuration de campagne enregistrée");
        $rootScope.$broadcast('refreshQuestionnaireCampaignContext');
        $scope.submitting = false;
      }).catch(function (response) {
        if (response && response.status === 400) {
          toastr.error(extractErrorMessage(response) || DEFAULT_BAD_REQUEST_MESSAGE);
        } else {
          toastr.error("Erreur lors de l'enregistrement de la configuration de campagne");
        }
      }).finally(function () {
        $scope.submitting = false;
      });
    };

    var openBrevoTemplatePopupForChannel = function (event, channel) {
      resetTemplatePopupState(channel);
      $mdDialog.show({
        templateUrl: BREVO_TEMPLATE_POPUP_URL,
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).finally(function () {
        resetTemplatePopupState(TEMPLATE_CHANNEL_EMAIL_CAMPAIGN);
      });
      loadBrevoTemplates();
    };

    $scope.openBrevoTemplatePopup = function (event) {
      openBrevoTemplatePopupForChannel(event, TEMPLATE_CHANNEL_EMAIL_CAMPAIGN);
    };

    $scope.openBrevoReportAvailableTemplatePopup = function (event) {
      openBrevoTemplatePopupForChannel(event, TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL);
    };

    $scope.openBrevoGroupementReportAvailableTemplatePopup = function (event) {
      openBrevoTemplatePopupForChannel(event, TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL);
    };

    $scope.openBrevoNonLqoRelanceTemplatePopup = function (event) {
      openBrevoTemplatePopupForChannel(event, TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL);
    };

    $scope.closeBrevoTemplatePopup = function () {
      $mdDialog.cancel();
    };

    $scope.cancelPopup = function () {
      $mdDialog.cancel();
    };

    $scope.confirmBrevoTemplateSelection = function () {
      if (!$scope.templatePopup.selectedTemplateId) {
        toastr.error("Veuillez sélectionner un template Brevo");
        return;
      }
      var popupConfig = getTemplatePopupConfig($scope.templatePopup.channel);
      $scope.templatePopup.submitting = true;
      var validationPromise = null;
      if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL) {
        validationPromise = ConfigurationCampagneAdminService
          .validateBrevoReportAvailableEmailTemplateAdmin($scope.templatePopup.selectedTemplateId);
      } else if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL) {
        validationPromise = ConfigurationCampagneAdminService
          .validateBrevoGroupementReportAvailableEmailTemplateAdmin($scope.templatePopup.selectedTemplateId);
      } else if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL) {
        validationPromise = ConfigurationCampagneAdminService
          .validateBrevoNonLqoRelanceEmailTemplateAdmin($scope.templatePopup.selectedTemplateId);
      } else {
        validationPromise = ConfigurationCampagneAdminService
          .validateBrevoTemplateAdmin($scope.templatePopup.selectedTemplateId);
      }
      validationPromise
        .then(function (template) {
          if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_REPORT_AVAILABLE_EMAIL) {
            $scope.configuration.brevoReportAvailableEmailTemplateId = template.id;
            $scope.configuration.brevoReportAvailableEmailTemplateName = template.name;
          } else if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_GROUPEMENT_REPORT_AVAILABLE_EMAIL) {
            $scope.configuration.brevoGroupementReportAvailableEmailTemplateId = template.id;
            $scope.configuration.brevoGroupementReportAvailableEmailTemplateName = template.name;
          } else if ($scope.templatePopup.channel === TEMPLATE_CHANNEL_NON_LQO_RELANCE_EMAIL) {
            $scope.configuration.brevoNonLqoRelanceEmailTemplateId = template.id;
            $scope.configuration.brevoNonLqoRelanceEmailTemplateName = template.name;
          } else {
            $scope.configuration.brevoEmailTemplateId = template.id;
            $scope.configuration.brevoEmailTemplateName = template.name;
            $scope.configuration.brevoEmailSendingStandby = false;
            $scope.configuration.brevoEmailSendingStandbyReason = null;
          }
          toastr.success(popupConfig.successMessage || "Template Brevo sélectionné");
          $mdDialog.hide();
        }).catch(function (response) {
          if (response && response.status === 400) {
            toastr.error(extractErrorMessage(response) || DEFAULT_BAD_REQUEST_MESSAGE);
            return;
          }
          toastr.error("Erreur lors de la validation du template Brevo");
        }).finally(function () {
          $scope.templatePopup.submitting = false;
      });
    };

    $scope.confirmNonLqoRelanceEmails = function (event) {
      if (!$scope.configuration.brevoNonLqoRelanceEmailTemplateId) {
        toastr.warning("Veuillez sélectionner un template Brevo pour le mail de relance non-LQO");
        return;
      }
      if ($scope.sendingNonLqoRelance) {
        return;
      }

      $scope.nonLqoRelanceDialog = {
        locked: isNonLqoRelanceLocked($scope.configuration.lastNonLqoRelanceEmailSentAt),
        errorMessage: isNonLqoRelanceLocked($scope.configuration.lastNonLqoRelanceEmailSentAt) ? NON_LQO_RELANCE_COOLDOWN_ERROR_MESSAGE : null
      };

      $scope.cancelNonLqoRelanceDialog = function () {
        $mdDialog.cancel();
      };

      $scope.submitNonLqoRelanceDialog = function () {
        if ($scope.nonLqoRelanceDialog.locked) {
          return;
        }
        $scope.sendingNonLqoRelance = true;
        ConfigurationCampagneAdminService.sendNonLqoRelanceEmails().then(function (result) {
          var totalRecipients = result && angular.isDefined(result.totalRecipients) ? result.totalRecipients : 0;
          var queuedCount = result && angular.isDefined(result.queuedCount) ? result.queuedCount : 0;
          var sentCount = result && angular.isDefined(result.sentCount) ? result.sentCount : 0;
          var failedCount = result && angular.isDefined(result.failedCount) ? result.failedCount : 0;
          if (totalRecipients > 0 && queuedCount > 0) {
            $scope.configuration.lastNonLqoRelanceEmailSentAt = new Date().getTime();
            refreshNonLqoRelanceCooldownState();
          }
          if (result && result.asynchronous) {
            if (totalRecipients === 0) {
              toastr.info("Aucune pharmacie non-LQO sans compte activé n'a été trouvée");
            } else if (failedCount > 0) {
              toastr.warning("Relance lancée pour " + queuedCount + " destinataires sur " + totalRecipients + ". L'envoi continue en arrière-plan (" + failedCount + " destinataires ignorés avant envoi)");
            } else {
              toastr.success("Relance lancée pour " + queuedCount + " destinataires. L'envoi continue en arrière-plan.");
            }
          } else if (failedCount > 0) {
            toastr.warning("Relance envoyée à " + sentCount + " destinataires sur " + totalRecipients + " (" + failedCount + " échecs)");
          } else if (totalRecipients === 0) {
            toastr.info("Aucune pharmacie non-LQO sans compte activé n'a été trouvée");
          } else {
            toastr.success("Relance envoyée à " + sentCount + " destinataires");
          }
          $mdDialog.hide();
        }).catch(function (response) {
          if (response && response.status === 400) {
            toastr.error(extractErrorMessage(response) || DEFAULT_BAD_REQUEST_MESSAGE);
          } else {
            toastr.error("Erreur lors de l'envoi de la relance non-LQO");
          }
        }).finally(function () {
          $scope.sendingNonLqoRelance = false;
        });
      };

      $mdDialog.show({
        template: [
          '<md-dialog aria-label="Relance non-LQO" class="admin-dialog admin-dialog--confirm">',
          '  <form ng-submit="submitNonLqoRelanceDialog()">',
          '    <div class="admin-dialog__header admin-dialog__header--info">',
          '      <div class="admin-dialog__icon-badge">',
          '        <md-icon md-font-icon="icon-email" class="s32"></md-icon>',
          '      </div>',
          '      <div class="admin-dialog__heading">',
          '        <div class="admin-dialog__title">Relancer les pharmacies non-LQO sans compte</div>',
          '        <div class="admin-dialog__subtitle">Envoi Brevo à toutes les pharmacies non-LQO sans compte activé</div>',
          '      </div>',
          '      <md-button class="md-icon-button admin-dialog__close" ng-click="cancelNonLqoRelanceDialog()" aria-label="Fermer">',
          '        <md-icon md-font-icon="icon-close"></md-icon>',
          '      </md-button>',
          '    </div>',
          '    <md-dialog-content class="admin-dialog__body">',
          '      <p>Cette action enverra un email de relance avec l\'expéditeur contact@pharmasystemequalite.com.</p>',
          '      <p ng-if="configuration.lastNonLqoRelanceEmailSentAt"><strong>Dernier envoi :</strong> {{configuration.lastNonLqoRelanceEmailSentAt | date:"dd/MM/yyyy à HH:mm"}}</p>',
          '      <p ng-if="!configuration.lastNonLqoRelanceEmailSentAt"><strong>Dernier envoi :</strong> aucun envoi enregistré</p>',
          '      <div class="admin-dialog__alert admin-dialog__alert--error" ng-if="nonLqoRelanceDialog.locked">{{nonLqoRelanceDialog.errorMessage}}</div>',
          '    </md-dialog-content>',
          '    <md-dialog-actions class="admin-dialog__actions">',
          '      <md-button class="admin-dialog__btn admin-dialog__btn--ghost" ng-click="cancelNonLqoRelanceDialog()">Annuler</md-button>',
          '      <md-button class="admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--success" type="submit" ng-disabled="sendingNonLqoRelance || nonLqoRelanceDialog.locked">',
          '        <md-progress-circular md-diameter="15px" md-mode="indeterminate" ng-if="sendingNonLqoRelance"></md-progress-circular>',
          '        <span ng-if="!sendingNonLqoRelance">Relancer</span>',
          '      </md-button>',
          '    </md-dialog-actions>',
          '  </form>',
          '</md-dialog>'
        ].join(''),
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.testNonLqoRelanceEmail = function (event) {
      if (!$scope.configuration.brevoNonLqoRelanceEmailTemplateId) {
        toastr.warning("Veuillez sélectionner un template Brevo pour le mail de relance non-LQO");
        return;
      }

      $mdDialog.show({
        template: [
          '<md-dialog aria-label="Tester l\'envoi non-LQO" class="admin-dialog admin-dialog--confirm">',
          '  <form ng-submit="confirmTestNonLqoRelanceEmail()">',
          '    <div class="admin-dialog__header admin-dialog__header--info">',
          '      <div class="admin-dialog__icon-badge">',
          '        <md-icon md-font-icon="icon-email" class="s32"></md-icon>',
          '      </div>',
          '      <div class="admin-dialog__heading">',
          '        <div class="admin-dialog__title">Tester l\'envoi sur une pharmacie</div>',
          '        <div class="admin-dialog__subtitle">Saisissez l\'ID de la pharmacie NON-LQO</div>',
          '      </div>',
          '      <md-button class="md-icon-button admin-dialog__close" ng-click="cancelPopup()" aria-label="Fermer">',
          '        <md-icon md-font-icon="icon-close"></md-icon>',
          '      </md-button>',
          '    </div>',
          '    <md-dialog-content class="admin-dialog__body">',
          '      <md-input-container class="nl-Input-container" flex="100">',
          '        <label class="nl-Input-label md-no-float md-container-ignore">ID pharmacie<span class="asterix">*</span></label>',
          '        <input type="number" min="1" ng-model="testPharmacyId" class="nl-Input" required />',
          '      </md-input-container>',
          '    </md-dialog-content>',
          '    <md-dialog-actions class="admin-dialog__actions">',
          '      <md-button class="admin-dialog__btn admin-dialog__btn--ghost" ng-click="cancelPopup()">Annuler</md-button>',
          '      <md-button class="admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--success" type="submit" ng-disabled="loadingTest || !testPharmacyId">',
          '        <md-progress-circular md-diameter="15px" md-mode="indeterminate" ng-if="loadingTest"></md-progress-circular>',
          '        <span ng-if="!loadingTest">Tester l\'envoi</span>',
          '      </md-button>',
          '    </md-dialog-actions>',
          '  </form>',
          '</md-dialog>'
        ].join(''),
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });

      $scope.testPharmacyId = null;
      $scope.loadingTest = false;

      $scope.confirmTestNonLqoRelanceEmail = function () {
        if (!$scope.testPharmacyId) {
          toastr.error("Veuillez renseigner un ID de pharmacie");
          return;
        }
        $scope.loadingTest = true;
        ConfigurationCampagneAdminService.testNonLqoRelanceEmail($scope.testPharmacyId).then(function () {
          toastr.success("Email de test envoyé");
          $mdDialog.hide();
        }).catch(function (response) {
          if (response && response.status === 400) {
            toastr.error(extractErrorMessage(response) || DEFAULT_BAD_REQUEST_MESSAGE);
          } else {
            toastr.error("Erreur lors de l'envoi de l'email de test");
          }
        }).finally(function () {
          $scope.loadingTest = false;
        });
      };
    };

    $scope.getConfiguration();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('AutoEvalAdminTachesController', AutoEvalAdminTachesController);

  /**
   * La file de tâches d'une campagne : rapports, e-mails, notifications, archives.
   *
   * ⚠️ C'est un écran d'EXPLOITATION, pas de restitution. Il est donc attaché à une CAMPAGNE par
   * son identifiant, et non à un millésime comme le reste des écrans : on y vient pour comprendre
   * pourquoi un envoi n'est pas parti.
   *
   * ⚠️ Une tâche en `ECHEC` se relance à la main, compteur de tentatives remis à zéro. C'est
   * volontaire : une tâche qui a échoué cinq fois demande un regard, pas une boucle.
   */
  /** @ngInject */
  function AutoEvalAdminTachesController($scope, $stateParams, $interval, toastr, AutoEvalAdminService) {
    var PERIODE_RAFRAICHISSEMENT = 15000;

    $scope.campagneId = $stateParams.id;
    $scope.statut = '';
    $scope.compteurs = [];
    $scope.taches = [];
    $scope.chargement = false;
    $scope.erreur = null;

    var rafraichissement = null;

    $scope.charger = function () {
      $scope.chargement = true;
      return AutoEvalAdminService.getTaches($scope.campagneId, $scope.statut).then(function (reponse) {
        $scope.compteurs = reponse.compteurs || [];
        $scope.taches = reponse.taches || [];
        $scope.erreur = null;
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      }).finally(function () {
        $scope.chargement = false;
      });
    };

    $scope.relancer = function (tache) {
      AutoEvalAdminService.relancerTache(tache.id).then(function () {
        toastr.success('Tâche remise en file.');
        $scope.charger();
      }).catch(function (erreur) {
        toastr.error(erreur.message);
      });
    };

    // La file avance toute seule : l'écran se rafraîchit pour qu'on voie les tâches progresser
    // sans avoir à recharger la page.
    rafraichissement = $interval(function () {
      $scope.charger();
    }, PERIODE_RAFRAICHISSEMENT);

    $scope.$on('$destroy', function () {
      if (rafraichissement) {
        $interval.cancel(rafraichissement);
      }
    });

    $scope.charger();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('AutoEvalAdminCampagnesController',
    AutoEvalAdminCampagnesController);

  /**
   * La liste des campagnes d'auto-évaluation (maquette `scr-campagnes`).
   *
   * ⚠️ AUCUN BOUTON N'OUVRE NI NE CLÔTURE une campagne : ces transitions sont automatiques, aux
   * dates enregistrées. L'écran montre la fenêtre et l'état ; il ne les déclenche pas. Ajouter un
   * bouton « ouvrir » donnerait une commande qui n'existe pas côté serveur.
   *
   * ⚠️ Ce que l'écran a le droit de proposer vient du SERVEUR — `supprimable`, `deprogrammable`,
   * `datesModifiables`. Rejouer ces règles ici reviendrait à maintenir deux fois des conditions
   * qui dépendent du questionnaire et des réponses déjà saisies.
   */
  /** @ngInject */
  function AutoEvalAdminCampagnesController($scope, $state, $mdDialog, $document, toastr,
      AutoEvalAdminService) {

    var POPUP_SUPPRESSION = 'app/main/admin/auto-evaluation/popup/autoeval-suppression-popup.html';

    $scope.campagnes = [];
    $scope.chargement = false;
    $scope.traitement = false;
    $scope.erreur = null;

    $scope.charger = function () {
      $scope.chargement = true;
      $scope.erreur = null;
      AutoEvalAdminService.getCampagnes().then(function (campagnes) {
        $scope.campagnes = campagnes || [];
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      }).finally(function () {
        $scope.chargement = false;
      });
    };

    $scope.ouvrir = function (campagne) {
      $state.go('admin.autoeval.campagne', { id: campagne.id });
    };

    /** Crée la prochaine année libre, en brouillon et sans dates. */
    $scope.creer = function () {
      $scope.traitement = true;
      AutoEvalAdminService.creerCampagne().then(function (campagne) {
        toastr.success('Campagne ' + campagne.annee + ' créée en brouillon.');
        $state.go('admin.autoeval.campagne', { id: campagne.id });
      }).catch(function (erreur) {
        toastr.error(erreur.message);
      }).finally(function () {
        $scope.traitement = false;
      });
    };

    /**
     * La suppression d'une campagne en brouillon, dans une FENÊTRE DE CONFIRMATION du produit.
     *
     * ⚠️ C'était un `$mdDialog.confirm()`, le composant brut d'Angular Material : ni en-tête, ni
     * icône, ni le rouge dont la famille `admin-dialog` marque l'irréversible — alors que la
     * suppression d'une pharmacie, geste de même nature, ouvre une vraie fenêtre. Les deux
     * détruisent définitivement des données et se ressemblent maintenant.
     *
     * ⚠️ `stopPropagation` reste indispensable : la ligne entière est cliquable et ouvre la
     * campagne. Sans lui, on partait sur le détail derrière la fenêtre.
     */
    $scope.supprimer = function (campagne, evenement) {
      evenement.stopPropagation();
      $scope.suppression = { id: campagne.id, annee: campagne.annee, envoi: false };
      $mdDialog.show({
        templateUrl: POPUP_SUPPRESSION,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerSuppression = function () {
      $mdDialog.hide();
    };

    $scope.confirmerSuppression = function () {
      var demande = $scope.suppression;
      if (!demande || demande.envoi) {
        return;
      }
      demande.envoi = true;
      AutoEvalAdminService.supprimerCampagne(demande.id).then(function () {
        $mdDialog.hide();
        toastr.success('Campagne supprimée.');
        $scope.charger();
      }).catch(function (erreur) {
        // ⚠️ La fenêtre RESTE OUVERTE sur un refus : le serveur écarte une campagne qui n'est
        // plus en brouillon ou qui porte déjà des réponses, et un toast derrière un dialogue
        // ouvert se voit mal.
        demande.envoi = false;
        if (erreur && erreur.message) {
          toastr.error(erreur.message);
        }
      });
    };

    $scope.charger();
  }
})();

(function () {
  'use strict';

  angular.module('app.admin').controller('AutoEvalAdminCampagneController',
    AutoEvalAdminCampagneController);

  /**
   * La fiche d'une campagne : configuration, questionnaire, résultats, soumissions.
   *
   * ⚠️ LES DATES CIRCULENT EN MILLISECONDES, `md-datepicker` TRAVAILLE SUR DES `Date`. La
   * conversion se fait ici, dans les deux sens. Sans elle, les champs restent vides devant une
   * campagne pourtant datée : c'est le défaut constaté le 11/09/2026.
   *
   * ⚠️ CHAQUE SECTION S'ENREGISTRE SÉPARÉMENT, et ce n'est pas un caprice : les deux n'ont pas
   * les mêmes règles. Les dates se verrouillent à l'ouverture, où seule la prolongation bouge ;
   * les notifications restent modifiables pendant toute la campagne ouverte et se verrouillent à
   * la clôture. Un formulaire unique enverrait à chaque fois des champs que le serveur refuse, et
   * l'enregistrement échouerait en bloc — y compris pour la partie légitime.
   *
   * Il n'y a plus d'options de campagne : les focus sont obligatoires dans toutes les campagnes
   * (recette, ligne 15), et la notification interne est devenue une carte de gabarit.
   *
   * ⚠️ Ce qui est modifiable vient du SERVEUR : `datesModifiables`, `prolongationModifiable`,
   * `notificationsModifiables`, `deprogrammable`. Ces règles dépendent de
   * l'état du questionnaire et des réponses déjà saisies ; les rejouer ici afficherait des
   * contrôles que le serveur refusera.
   */
  /** @ngInject */
  function AutoEvalAdminCampagneController($scope, $rootScope, $state, $stateParams, $mdDialog, $timeout,
      $document, $filter, toastr, AutoEvalAdminService, AeqAccesOfficine) {

    var ONGLETS = ['configuration', 'emails', 'questionnaire', 'outils', 'resultats', 'soumissions',
      'satisfaction'];
    var TAILLE_PAGE = 25;
    var DELAI_RECHERCHE = 350;
    var POPUP_GABARIT = 'app/main/admin/auto-evaluation/popup/autoeval-brevo-template-popup.html';
    var POPUP_JOURNAL = 'app/main/admin/auto-evaluation/popup/autoeval-journal-popup.html';
    var POPUP_REOUVERTURE = 'app/main/admin/auto-evaluation/popup/autoeval-reouverture-popup.html';
    var POPUP_FIGER = 'app/main/admin/auto-evaluation/popup/autoeval-figer-popup.html';
    var POPUP_RECHARGER = 'app/main/admin/auto-evaluation/popup/autoeval-recharger-popup.html';
    var POPUP_RELANCE_LOT = 'app/main/admin/auto-evaluation/popup/autoeval-relance-lot-popup.html';
    var POPUP_RELANCE_OFFICINE =
      'app/main/admin/auto-evaluation/popup/autoeval-relance-officine-popup.html';
    var POPUP_AJOUT_CIBLE = 'app/main/admin/auto-evaluation/popup/autoeval-ajout-cible-popup.html';
    var POPUP_OUTIL = 'app/main/admin/auto-evaluation/popup/autoeval-outil-popup.html';
    var POPUP_SUPPRESSION_OUTIL = 'app/main/admin/auto-evaluation/popup/autoeval-outil-suppression-popup.html';
    var POPUP_EMAIL_TEST = 'app/main/admin/auto-evaluation/popup/autoeval-email-test-popup.html';

    // Le libellé des types vient du filtre partagé : la même notification est nommée ici,
    // dans la fenêtre de sélection et dans les messages de confirmation.
    var libelleType = $filter('aeqTypeNotification');

    // ⚠️ Ouverture et relance existent en DEUX versions, selon le contrat de l'officine : une
    // officine non LQO n'a le plus souvent jamais activé son compte, son e-mail porte donc un lien
    // de création de mot de passe. Les descriptions disent qui reçoit quoi, et ce qui arrive si
    // l'une des deux versions n'est pas activée : rien, pour sa population.
    var DESCRIPTIONS_TYPE = {
      OUVERTURE: 'Envoyé au moment où la campagne s’ouvre à chaque officine de la cible sous contrat '
        + 'LQO ou LQO mini.',
      OUVERTURE_NON_LQO: 'Envoyé le même jour, à la place de l’ouverture LQO, aux officines sous '
        + 'contrat non LQO, avec un lien personnel de création de mot de passe. S’il n’est pas '
        + 'activé, elles ne reçoivent aucun e-mail d’ouverture.',
      RELANCE: 'Envoyé aux officines LQO qui n’ont pas encore validé, à la demande ou à date fixe.',
      RELANCE_NON_LQO: 'Envoyé aux officines non LQO qui n’ont pas encore validé, à la place de la '
        + 'relance LQO, avec leur lien de création de mot de passe. S’il n’est pas activé, elles ne '
        + 'sont pas relancées.',
      RAPPORT: 'Envoyé après une validation, une fois le rapport de synthèse produit.',
      REOUVERTURE: 'Envoyé quand un administrateur rouvre une auto-évaluation déjà validée.',
      CLOTURE: 'Envoyé à la clôture à chaque officine validée, dès que son rapport définitif, '
        + 'comparé à son groupement et à l’année précédente, est produit.',
      CLOTURE_INTERNE: 'Envoyé une fois aux administrateurs et aux comptes groupement, quand tous '
        + 'les rapports de la clôture sont produits.'
    };

    // Le tableau de synthèse de l'onglet E-mails : QUI reçoit chaque e-mail, et QUAND. Les deux
    // questions que l'administrateur se pose avant d'activer un gabarit, et que huit cartes
    // dispersées ne permettaient pas de comparer d'un coup d'œil.
    var DESTINATAIRES_TYPE = {
      OUVERTURE: 'Officines LQO et LQO mini de la cible',
      OUVERTURE_NON_LQO: 'Officines non LQO de la cible',
      RELANCE: 'Officines LQO non validées',
      RELANCE_NON_LQO: 'Officines non LQO non validées',
      RAPPORT: 'L’officine qui vient de valider',
      REOUVERTURE: 'L’officine rouverte',
      CLOTURE: 'Officines validées',
      CLOTURE_INTERNE: 'Administrateurs et comptes groupement'
    };
    var MOMENTS_TYPE = {
      OUVERTURE: 'À l’ouverture',
      OUVERTURE_NON_LQO: 'À l’ouverture',
      RELANCE: 'Sur demande, depuis le suivi',
      RELANCE_NON_LQO: 'Sur demande, depuis le suivi',
      RAPPORT: 'Après chaque validation',
      REOUVERTURE: 'À chaque réouverture',
      CLOTURE: 'À la clôture',
      CLOTURE_INTERNE: 'Une fois, à la fin de la clôture'
    };

    // Les e-mails par MOMENT de la campagne : la version LQO et la version non LQO d'un même
    // envoi se lisent côte à côte. Un type inconnu de cette table tombe dans le dernier groupe
    // plutôt que de disparaître de l'écran.
    var GROUPES_EMAILS = [
      { cle: 'ouverture', titre: 'Ouverture de la campagne', types: ['OUVERTURE', 'OUVERTURE_NON_LQO'],
        aide: 'Un seul jour d’envoi : chaque officine de la cible reçoit la version de son contrat.' },
      { cle: 'relance', titre: 'Relances', types: ['RELANCE', 'RELANCE_NON_LQO'],
        aide: 'Aux officines qui n’ont pas validé. Chaque officine reçoit la version de son contrat.' },
      { cle: 'campagne', titre: 'Pendant la campagne', types: ['RAPPORT', 'REOUVERTURE'],
        aide: 'À l’officine, après une validation ou une réouverture.' },
      { cle: 'cloture', titre: 'Clôture', types: ['CLOTURE', 'CLOTURE_INTERNE'],
        aide: 'Une fois les rapports définitifs produits.' }
    ];

    $scope.campagneId = $stateParams.id;
    $scope.onglet = ONGLETS.indexOf($stateParams.tab) >= 0 ? $stateParams.tab : 'configuration';
    $scope.campagne = null;
    $scope.questionnaire = null;
    $scope.notifications = [];
    $scope.groupesEmails = [];
    $scope.resultats = null;
    $scope.soumissions = null;
    $scope.journalPopup = null;
    $scope.estimation = null;
    $scope.ajoutCible = null;
    $scope.completionGroupements = false;
    $scope.rafraichissementParc = false;

    $scope.chargement = false;
    $scope.traitement = false;
    $scope.erreur = null;

    $scope.datePickers = {};
    $scope.dates = {};
    // ⚠️ LES FILTRES VIVENT SUR UN OBJET, ET C'EST OBLIGATOIRE. Chaque onglet de cette fiche est
    // rendu sous un `ng-if`, qui crée un SCOPE ENFANT : un `ng-model` posé sur une variable simple
    // du contrôleur y écrit une copie qui masque l'originale, et le contrôleur relit indéfiniment
    // la valeur vide. La recherche et le filtre de statut étaient muets pour cette seule raison —
    // l'appel partait bien à chaque frappe, mais toujours sans critère. Le point suffit à le
    // corriger, comme pour `dates`, `options` et `datePickers` juste au-dessus.
    // Le groupement des RÉSULTATS est distinct de celui du suivi : filtrer l'un ne filtre pas l'autre.
    $scope.filtres = {
      recherche: '', statut: '', compte: '', groupement: null, anneeEngagement: null, groupementResultats: null
    };
    // Le filtre « Compte titulaire » du suivi (21/10/2026), le même que celui de l'espace groupement.
    $scope.FILTRES_COMPTE = [
      { code: 'NON_ACTIVE', libelle: 'Titulaire non activé' },
      { code: 'JAMAIS_CONNECTE', libelle: 'Titulaire jamais connecté' }
    ];
    // Les groupements proposés au filtre, lus une seule fois par millésime (voir chargerGroupements).
    $scope.groupements = [];
    $scope.pagination = { page: 1, taille: TAILLE_PAGE, total: 0 };
    $scope.templatePopup = {};

    var minuteurRecherche = null;
    var minuteurCandidats = null;
    var gabarits = null;
    var groupementsCharges = false;

    // ------------------------------------------------------------------ dates

    /**
     * Millisecondes vers `Date`, pour `md-datepicker`.
     *
     * ⚠️ La valeur nulle doit rester nulle : un `new Date(null)` donnerait le 1er janvier 1970,
     * et le champ afficherait une date au lieu de rester vide.
     */
    function versDate(millis) {
      return millis === null || angular.isUndefined(millis) ? null : new Date(millis);
    }

    function versMillis(date) {
      return date instanceof Date ? date.getTime() : null;
    }

    // ------------------------------------------------------------------ chargement

    function charger() {
      $scope.chargement = true;
      $scope.erreur = null;
      return AutoEvalAdminService.getCampagne($scope.campagneId).then(function (campagne) {
        appliquerCampagne(campagne);
        $scope.chargement = false;
        return chargerOnglet();
      }).catch(function (erreur) {
        $scope.chargement = false;
        $scope.erreur = erreur;
      });
    }

    function appliquerCampagne(campagne) {
      $scope.campagne = campagne;
      $scope.dates = {
        dateOuverture: versDate(campagne.dateOuverture),
        dateClotureOfficielle: versDate(campagne.dateClotureOfficielle),
        dateProlongation: versDate(campagne.dateProlongation)
      };
    }

    $scope.onglets = function () {
      var visibles = ['configuration'];
      // Les e-mails ont leur onglet ; un millésime repris n'en envoie aucun, il n'en a donc pas.
      if (!$scope.campagne || !$scope.campagne.historique) {
        visibles.push('emails');
      }
      // La boîte à outils se prépare dès le brouillon : les officines la voient à la programmation.
      visibles.push('questionnaire');
      visibles.push('outils');
      // Avant l'ouverture, il n'y a ni instantané ni soumission : les onglets seraient vides.
      if ($scope.campagne && ($scope.campagne.statut === 'OUVERTE'
          || $scope.campagne.statut === 'CLOTUREE')) {
        visibles.push('resultats');
        visibles.push('soumissions');
        // La satisfaction ferme la marche (décision PHSQ du 17/10/2026). Un millésime repris n'en
        // a pas : sa satisfaction n'est pas restituée, le rapport xlsx du suivi reste son accès.
        if (!$scope.campagne.historique) {
          visibles.push('satisfaction');
        }
      }
      return visibles;
    };

    $scope.libelleOnglet = function (onglet) {
      switch (onglet) {
      case 'configuration': return 'Configuration';
      case 'emails': return 'E-mails';
      case 'questionnaire': return 'Questionnaire';
      case 'outils': return 'Boîte à outils';
      case 'resultats': return 'Résultats nationaux';
      case 'satisfaction': return 'Satisfaction';
      default: return 'Suivi des officines';
      }
    };

    $scope.changerOnglet = function (onglet) {
      if ($scope.onglet === onglet) {
        return;
      }
      $scope.onglet = onglet;
      $state.go('admin.autoeval.campagne', { id: $scope.campagneId, tab: onglet },
        { notify: false, location: 'replace' });
      chargerOnglet();
    };

    function chargerOnglet() {
      switch ($scope.onglet) {
      case 'emails':
        return chargerEmails();
      case 'questionnaire':
        return chargerQuestionnaire();
      case 'outils':
        return chargerOutils();
      case 'resultats':
        return chargerResultats();
      case 'satisfaction':
        return chargerSatisfaction();
      case 'soumissions':
        // La participation par groupement est lue à l'ouverture de l'onglet, et non à chaque
        // filtre : elle porte sur toute la campagne, aucun filtre de la liste ne la change.
        chargerParticipation();
        return chargerSoumissions();
      default:
        return chargerConfiguration();
      }
    }

    // ------------------------------------------------------------------ configuration

    function chargerConfiguration() {
      if ($scope.campagne && $scope.campagne.statut === 'BROUILLON') {
        AutoEvalAdminService.estimerCible($scope.campagneId).then(function (reponse) {
          $scope.estimation = reponse.effectif;
        }).catch(function () {
          $scope.estimation = null;
        });
      }
    }

    // ------------------------------------------------------------------ e-mails

    function chargerEmails() {
      return AutoEvalAdminService.getNotifications($scope.campagneId).then(function (notifications) {
        $scope.notifications = decorer(notifications || []);
        $scope.groupesEmails = grouper($scope.notifications);
      });
    }

    /**
     * Range les e-mails par moment de la campagne.
     *
     * ⚠️ CALCULÉ AU CHARGEMENT et posé sur le scope : une fonction appelée depuis le `ng-repeat`
     * rendrait des tableaux neufs à chaque digest, et Angular abandonnerait sur « infinite
     * digest » — c'est arrivé à la barre de complétion de l'espace groupement.
     */
    function grouper(notifications) {
      var groupes = GROUPES_EMAILS.map(function (groupe) {
        return { cle: groupe.cle, titre: groupe.titre, aide: groupe.aide, notifications: [] };
      });
      angular.forEach(notifications, function (notification) {
        var rang = -1;
        angular.forEach(GROUPES_EMAILS, function (groupe, index) {
          if (rang < 0 && groupe.types.indexOf(notification.type) >= 0) {
            rang = index;
          }
        });
        groupes[rang >= 0 ? rang : groupes.length - 1].notifications.push(notification);
      });
      return groupes.filter(function (groupe) {
        return groupe.notifications.length;
      });
    }

    /** Depuis le tableau de synthèse, amène la carte de l'e-mail sous les yeux. */
    $scope.allerAEmail = function (notification) {
      var carte = $document[0].getElementById('aeq-email-' + notification.type);
      var contenu = $document[0].getElementById('content');
      if (carte && contenu) {
        contenu.scrollTop += carte.getBoundingClientRect().top - 90;
      }
    };

    /**
     * Ajoute à chaque notification son libellé, sa description et ses balises obligatoires.
     *
     * ⚠️ LES BALISES VIENNENT DU SERVEUR (`balisesObligatoires`), elles ne sont pas listées ici.
     * Une table locale en tenait la copie et avait dérivé de celle du serveur : la fenêtre
     * annonçait `[[URL_LQO]]` pour le rapport alors que le contrôle exige `[[LIEN_RAPPORT]]`, et
     * omettait `[[DATE_CLOTURE]]` de la réouverture. Un gabarit conforme à ce que l'écran
     * demandait se faisait donc refuser, sur une balise jamais annoncée.
     *
     * Le serveur rend les noms nus ; les doubles crochets sont une mise en forme d'affichage. Les
     * balises facultatives suivent la même règle : ce sont celles que le serveur sait remplir.
     */
    function decorer(notifications) {
      angular.forEach(notifications, function (notification) {
        notification.libelle = libelleType(notification.type);
        notification.description = DESCRIPTIONS_TYPE[notification.type] || '';
        notification.destinataires = DESTINATAIRES_TYPE[notification.type] || '';
        notification.moment = MOMENTS_TYPE[notification.type] || '';
        notification.balises = entreCrochets(notification.balisesObligatoires);
        notification.balisesFacultatives = entreCrochets(notification.balisesFacultatives);
      });
      return notifications;
    }

    function entreCrochets(balises) {
      return (balises || []).map(function (balise) {
        return '[[' + balise + ']]';
      });
    }

    $scope.enregistrerDates = function () {
      $scope.traitement = true;
      AutoEvalAdminService.enregistrerDates($scope.campagneId, {
        dateOuverture: versMillis($scope.dates.dateOuverture),
        dateClotureOfficielle: versMillis($scope.dates.dateClotureOfficielle),
        dateProlongation: versMillis($scope.dates.dateProlongation)
      }).then(function (campagne) {
        appliquerCampagne(campagne);
        toastr.success('Dates de la campagne enregistrées.');
      }).catch(afficherErreur).finally(function () {
        $scope.traitement = false;
      });
    };

    $scope.deprogrammer = function () {
      $scope.traitement = true;
      AutoEvalAdminService.deprogrammer($scope.campagneId).then(function (campagne) {
        appliquerCampagne(campagne);
        toastr.success('Campagne revenue en brouillon.');
      }).catch(afficherErreur).finally(function () {
        $scope.traitement = false;
      });
    };

    /** Un refus de validation porte la liste complète des anomalies : les montrer toutes. */
    function afficherErreur(erreur) {
      if (erreur && erreur.anomalies && erreur.anomalies.length) {
        angular.forEach(erreur.anomalies, function (anomalie) {
          toastr.error(anomalie);
        });
        return;
      }
      toastr.error(erreur && erreur.message ? erreur.message : 'Une erreur est survenue.');
    }

    // ------------------------------------------------------------------ boîte à outils

    /**
     * LA BOÎTE À OUTILS de la campagne : sur le modèle des journées qualité — un nom, un libellé de
     * lien, un fichier OU une URL, un ordre — mais pour UNE campagne. Les officines la voient dans
     * leur carte d'auto-évaluation dès la programmation, les groupements dans leur espace.
     */
    $scope.outils = [];

    function chargerOutils() {
      AutoEvalAdminService.getOutils($scope.campagneId).then(function (outils) {
        $scope.outils = outils || [];
      }).catch(function () {
        $scope.outils = [];
      });
    }

    $scope.urlOutil = function (outil) {
      return AutoEvalAdminService.urlOutil(outil.id);
    };

    $scope.ouvrirOutil = function (outil, evenement) {
      $scope.outilPopup = {
        edition: !!outil,
        id: outil ? outil.id : null,
        titre: outil ? outil.titre : '',
        libelleLien: outil ? outil.libelleLien : '',
        fichierActuel: outil && outil.fichier ? outil.nomFichier : null,
        urlActuelle: outil && !outil.fichier ? outil.url : null,
        url: '',
        fichier: null,
        erreur: null,
        envoi: false
      };
      $mdDialog.show({
        templateUrl: POPUP_OUTIL,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerOutil = function () {
      $mdDialog.hide();
    };

    $scope.choisirFichierOutil = function () {
      var champ = $document[0].getElementById('autoeval-outil-fichier');
      if (champ) {
        champ.value = null;
        champ.click();
      }
    };

    // ⚠️ Appelée par l'attribut onchange du champ fichier, HORS du cycle d'Angular : d'où le
    // $applyAsync. Choisir un fichier vide l'URL, et inversement — le serveur refuse les deux ensemble.
    $scope.fichierOutilChoisi = function (fichiers) {
      $scope.outilPopup.fichier = fichiers && fichiers.length ? fichiers[0] : null;
      if ($scope.outilPopup.fichier) {
        $scope.outilPopup.url = '';
      }
      $scope.outilPopup.erreur = null;
      $scope.$applyAsync();
    };

    $scope.urlOutilModifiee = function () {
      if ($scope.outilPopup.url && $scope.outilPopup.url.trim().length) {
        $scope.outilPopup.fichier = null;
      }
      $scope.outilPopup.erreur = null;
    };

    $scope.enregistrerOutil = function () {
      var popup = $scope.outilPopup;
      if (!popup || popup.envoi) {
        return;
      }
      var url = (popup.url || '').trim();
      if (!popup.edition && !popup.fichier && !url) {
        popup.erreur = 'Déposez un fichier ou saisissez une URL.';
        return;
      }
      var formulaire = new FormData();
      if (popup.id) {
        formulaire.append('id', popup.id);
      }
      formulaire.append('titre', popup.titre);
      formulaire.append('libelleLien', popup.libelleLien);
      if (popup.fichier) {
        formulaire.append('fichier', popup.fichier);
      }
      if (url) {
        formulaire.append('url', url);
      }
      popup.envoi = true;
      popup.erreur = null;
      AutoEvalAdminService.enregistrerOutil($scope.campagneId, formulaire).then(function () {
        toastr.success(popup.edition ? 'Outil modifié.' : 'Outil ajouté.');
        $mdDialog.hide();
        chargerOutils();
      }).catch(function (erreur) {
        // L'erreur reste DANS la fenêtre : la saisie n'est pas perdue, et le motif du serveur
        // (URL invalide, fichier ET URL…) se lit à côté du champ concerné.
        popup.envoi = false;
        popup.erreur = erreur && erreur.message ? erreur.message : 'Une erreur est survenue.';
      });
    };

    $scope.deplacerOutil = function (outil, versLeHaut) {
      AutoEvalAdminService.deplacerOutil(outil.id, versLeHaut).then(function (outils) {
        $scope.outils = outils || [];
      }).catch(afficherErreur);
    };

    $scope.supprimerOutil = function (outil, evenement) {
      $scope.suppressionOutil = { outil: outil, envoi: false };
      $mdDialog.show({
        templateUrl: POPUP_SUPPRESSION_OUTIL,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerSuppressionOutil = function () {
      $mdDialog.hide();
    };

    $scope.confirmerSuppressionOutil = function () {
      if (!$scope.suppressionOutil || $scope.suppressionOutil.envoi) {
        return;
      }
      $scope.suppressionOutil.envoi = true;
      AutoEvalAdminService.supprimerOutil($scope.suppressionOutil.outil.id).then(function () {
        toastr.success('Outil supprimé.');
        $mdDialog.hide();
        chargerOutils();
      }).catch(function (erreur) {
        $scope.suppressionOutil.envoi = false;
        afficherErreur(erreur);
      });
    };

    // ------------------------------------------------------------------ gabarits Brevo

    // ------------------------------------------------------------------ e-mail de test

    /**
     * L'E-MAIL DE TEST d'un gabarit, pour en voir le rendu dans une vraie boîte.
     *
     * ⚠️ Le bouton est toujours actif ; c'est la fenêtre qui bloque, en disant pourquoi, quand le
     * gabarit manque ou n'est pas conforme. Le serveur refait le contrôle sur le gabarit relu chez
     * Brevo : son refus éventuel s'affiche dans la même fenêtre.
     *
     * L'adresse proposée est celle de l'administrateur connecté ; elle se change, pour envoyer
     * le test à la personne qui relit.
     */
    $scope.testerNotification = function (notification, evenement) {
      $scope.testEmail = {
        notification: notification,
        destinataire: ($rootScope.user && $rootScope.user.mail) || '',
        defaut: defautGabarit(notification),
        erreur: null,
        envoi: false
      };
      $mdDialog.show({
        templateUrl: POPUP_EMAIL_TEST,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    /** Ce qui bloque l'envoi d'après la carte, ou null. Mêmes termes que l'encart de la carte. */
    function defautGabarit(notification) {
      if (!notification.templateBrevoId) {
        return 'Aucun gabarit Brevo n’est sélectionné pour cet e-mail : choisissez-en un, puis relancez le test.';
      }
      if (!notification.templateValide) {
        return (notification.templateErreur || 'Le gabarit ne porte pas toutes les balises attendues.')
          + ' Corrigez le gabarit dans Brevo : l’e-mail des officines serait bloqué de la même façon.';
      }
      return null;
    }

    $scope.fermerTestEmail = function () {
      $mdDialog.hide();
    };

    $scope.confirmerTestEmail = function () {
      var test = $scope.testEmail;
      if (!test || test.envoi || test.defaut || !test.destinataire) {
        return;
      }
      test.envoi = true;
      test.erreur = null;
      AutoEvalAdminService.envoyerTestNotification($scope.campagneId, test.notification.type,
        test.destinataire).then(function (reponse) {
        test.envoi = false;
        $mdDialog.hide();
        toastr.success('E-mail de test « ' + test.notification.libelle + ' » envoyé à '
          + (reponse && reponse.destinataire ? reponse.destinataire : test.destinataire) + '.');
      }).catch(function (erreur) {
        test.envoi = false;
        test.erreur = erreur && erreur.message ? erreur.message : 'L’e-mail de test n’a pas pu être envoyé.';
      });
    };

    $scope.ouvrirGabarit = function (notification, evenement) {
      if (!$scope.campagne.notificationsModifiables) {
        return;
      }
      $scope.templatePopup = {
        notification: notification,
        titre: notification.libelle,
        balises: notification.balises,
        balisesFacultatives: notification.balisesFacultatives,
        gabaritId: notification.templateBrevoId || null,
        recherche: '',
        gabarits: gabarits || [],
        chargement: !gabarits,
        envoi: false
      };
      $mdDialog.show({
        templateUrl: POPUP_GABARIT,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
      chargerGabarits();
    };

    /**
     * Charge la liste Brevo, une seule fois.
     *
     * ⚠️ Elle est mise en cache dans le contrôleur : l'appel traverse le réseau jusqu'à Brevo, et
     * le rejouer à chaque ouverture de la fenêtre ferait attendre pour une liste qui ne bouge pas
     * pendant la configuration d'une campagne.
     */
    function chargerGabarits() {
      if (gabarits) {
        $scope.templatePopup.gabarits = gabarits;
        $scope.templatePopup.chargement = false;
        return;
      }
      AutoEvalAdminService.getGabaritsBrevo().then(function (liste) {
        gabarits = liste || [];
        $scope.templatePopup.gabarits = gabarits;
      }).catch(function (erreur) {
        $scope.templatePopup.gabarits = [];
        $scope.templatePopup.erreur = erreur.message;
      }).finally(function () {
        $scope.templatePopup.chargement = false;
      });
    }

    $scope.fermerGabarit = function () {
      $mdDialog.cancel();
    };

    $scope.confirmerGabarit = function () {
      if (!$scope.templatePopup.gabaritId) {
        toastr.error('Sélectionnez un gabarit.');
        return;
      }
      var notification = $scope.templatePopup.notification;
      $scope.templatePopup.envoi = true;
      AutoEvalAdminService.enregistrerNotification($scope.campagneId, {
        type: notification.type,
        templateBrevoId: $scope.templatePopup.gabaritId,
        active: notification.active
      }).then(function () {
        toastr.success('Gabarit enregistré pour « ' + notification.libelle + ' ».');
        $mdDialog.hide();
        chargerEmails();
      }).catch(afficherErreur).finally(function () {
        $scope.templatePopup.envoi = false;
      });
    };

    /** Bascule l'activation d'une notification, sans passer par la fenêtre. */
    $scope.basculerNotification = function (notification) {
      AutoEvalAdminService.enregistrerNotification($scope.campagneId, {
        type: notification.type,
        templateBrevoId: notification.templateBrevoId,
        active: notification.active
      }).then(function () {
        chargerEmails();
      }).catch(function (erreur) {
        // On remet la case dans son état d'avant : le serveur a refusé.
        notification.active = !notification.active;
        afficherErreur(erreur);
      });
    };

    $scope.libelleEtat = function (notification) {
      if (!notification.templateBrevoId) {
        return 'Aucun gabarit';
      }
      if (!notification.templateValide) {
        return 'Gabarit invalide';
      }
      // ⚠️ « Envoyé » l'emporte sur « actif » : c'est un fait accompli, et il dit à
      // l'administrateur que son changement de gabarit ne vaudra que pour la suite.
      if (notification.etat === 'ENVOYE') {
        return 'Déjà envoyé';
      }
      return notification.active ? 'Actif' : 'Gabarit prêt, envoi désactivé';
    };

    /**
     * ⚠️ Un envoi volontairement désactivé n'est PAS une alerte : c'est un choix. Il porte donc
     * la pastille neutre, et non le rouge réservé au gabarit invalide ni l'orange du gabarit
     * manquant, qui sont, eux, des blocages.
     */
    $scope.classeEtat = function (notification) {
      if (!notification.templateBrevoId) {
        return 'is-empty';
      }
      if (!notification.templateValide) {
        return 'is-standby';
      }
      if (notification.etat === 'ENVOYE') {
        return 'is-selected';
      }
      return notification.active ? 'is-selected' : 'is-neutre';
    };

    // ------------------------------------------------------------------ questionnaire

    function chargerQuestionnaire() {
      return AutoEvalAdminService.getQuestionnaire($scope.campagneId).then(function (questionnaire) {
        $scope.questionnaire = questionnaire;
        $scope.chapitresDeplies = {};
        compterFocus(questionnaire);
      }).catch(function () {
        $scope.questionnaire = null;
        $scope.chapitresDeplies = {};
      });
    }

    /**
     * Le dépliage d'un chapitre, pour lire les questions qu'il contient.
     *
     * ⚠️ Les questions sont DÉJÀ dans la charge utile du questionnaire — le tableau s'en sert
     * pour compter. Le dépliage n'appelle donc rien : il ne fait que montrer ce qui est chargé.
     *
     * ⚠️ Plusieurs chapitres peuvent rester ouverts en même temps. On vient ici pour comparer
     * deux chapitres ou retrouver où vit une question, et un accordéon qui referme le précédent
     * oblige à faire des allers-retours.
     */
    $scope.chapitresDeplies = {};

    $scope.basculerChapitre = function (chapitre) {
      $scope.chapitresDeplies[chapitre.id] = !$scope.chapitresDeplies[chapitre.id];
    };

    /**
     * LES FOCUS du questionnaire : la pastille de chaque ligne de chapitre et le bouton « Voir
     * tous les focus ». Seule une poignée de questions en porte un ; sans ces repères, relire ce
     * que les officines recevront obligeait à déplier tous les chapitres un par un.
     */
    function compterFocus(questionnaire) {
      $scope.nbFocusTotal = 0;
      angular.forEach(questionnaire && questionnaire.chapitres, function (chapitre) {
        chapitre.nbFocus = 0;
        angular.forEach(chapitre.questions, function (question) {
          if (question.focusActif) {
            chapitre.nbFocus++;
          }
        });
        $scope.nbFocusTotal += chapitre.nbFocus;
      });
    }

    $scope.voirTousLesFocus = function () {
      angular.forEach($scope.questionnaire ? $scope.questionnaire.chapitres : [], function (chapitre) {
        if (chapitre.nbFocus) {
          $scope.chapitresDeplies[chapitre.id] = true;
        }
      });
    };

    /** Le libellé de la réponse qui déclenche un focus, tel que l'officine le lit : « Non ». */
    $scope.libelleValeur = function (valeur) {
      var libelle = valeur;
      angular.forEach($scope.questionnaire ? $scope.questionnaire.palette : [], function (modalite) {
        if (modalite.valeur === valeur && modalite.libelleLong) {
          libelle = modalite.libelleLong;
        }
      });
      return libelle;
    };

    $scope.urlRessource = AutoEvalAdminService.urlRessource;
    $scope.urlLienQuestion = AutoEvalAdminService.urlLienQuestion;

    $scope.chapitreDeplie = function (chapitre) {
      return !!$scope.chapitresDeplies[chapitre.id];
    };

    /**
     * Fige le questionnaire.
     *
     * ⚠️ C'est ce geste qui programme la campagne : tant qu'un questionnaire reste modifiable,
     * aucune officine ne doit pouvoir y répondre.
     */
    $scope.figerQuestionnaire = function (evenement) {
      $scope.figeage = { envoi: false };
      $mdDialog.show({
        templateUrl: POPUP_FIGER,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerFigeage = function () {
      $mdDialog.hide();
    };

    $scope.confirmerFigeage = function () {
      if (!$scope.figeage || $scope.figeage.envoi) {
        return;
      }
      $scope.figeage.envoi = true;
      AutoEvalAdminService.figerQuestionnaire($scope.campagneId).then(function (campagne) {
        $mdDialog.hide();
        appliquerCampagne(campagne);
        toastr.success('Questionnaire figé.');
        chargerQuestionnaire();
      }).catch(function (erreur) {
        // La fenêtre reste ouverte : le serveur refuse un questionnaire vide, et l'erreur porte
        // parfois une liste d'anomalies qu'un toast sous un dialogue ne montrerait pas.
        $scope.figeage.envoi = false;
        if (erreur && (erreur.message || erreur.anomalies)) {
          afficherErreur(erreur);
        }
      });
    };

    /**
     * RECHARGER le questionnaire depuis le millésime livré avec LQO. Le cas d'origine : une
     * campagne créée avant que le war ne porte la bonne version de son millésime (préproduction
     * 2026, créée sur la copie de 2025). Le bouton n'existe que si le serveur l'accepte
     * (`questionnaireRechargeable`) ; il rend la liste complète des anomalies s'il refuse.
     */
    $scope.rechargerQuestionnaire = function (evenement) {
      $scope.rechargement = { envoi: false };
      $mdDialog.show({
        templateUrl: POPUP_RECHARGER,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerRechargement = function () {
      $mdDialog.hide();
    };

    $scope.confirmerRechargement = function () {
      if (!$scope.rechargement || $scope.rechargement.envoi) {
        return;
      }
      $scope.rechargement.envoi = true;
      AutoEvalAdminService.rechargerQuestionnaireDepot($scope.campagneId).then(function (rapport) {
        $mdDialog.hide();
        toastr.success('Questionnaire rechargé : ' + rapport.nbQuestions + ' questions, ' + rapport.nbFocus
          + ' focus, ' + rapport.nbRessources + ' ressources'
          + (rapport.nbCorrespondances ? ', ' + rapport.nbCorrespondancesAppariees + ' questions appariées à '
            + (($scope.campagne && $scope.campagne.annee) - 1) : '') + '.');
        angular.forEach(rapport.avertissements, function (avertissement) {
          toastr.warning(avertissement);
        });
        AutoEvalAdminService.getCampagne($scope.campagneId).then(appliquerCampagne);
        chargerQuestionnaire();
      }).catch(function (erreur) {
        // Comme le figeage : la fenêtre reste ouverte, l'erreur peut porter une liste d'anomalies.
        $scope.rechargement.envoi = false;
        if (erreur && (erreur.message || erreur.anomalies)) {
          afficherErreur(erreur);
        }
      });
    };

    // ------------------------------------------------------------------ résultats

    /**
     * Les résultats du périmètre choisi : national, ou un groupement (recette, lignes 17 et 25).
     *
     * ⚠️ Le filtre vaut pour les DEUX cartes de l'onglet — Répartition et Vue d'ensemble lisent
     * les mêmes lignes. Filtré sur un groupement, le serveur rend en plus le « Oui » national,
     * l'écart et l'alerte de vigilance : le tableau devient celui de l'espace groupement.
     *
     * ⚠️ Les années d'engagement proposées dépendent du périmètre. Une année choisie qui n'existe
     * pas dans le nouveau groupement laisserait un filtre invisible — le select l'affiche vide —
     * et un tableau vide sans raison apparente : on la relâche, et on relit.
     *
     * ⚠️ Le périmètre NOMMÉ dans les titres est celui des résultats REÇUS, pas celui du filtre :
     * lu sur le filtre, le titre annonçait déjà « GIPHAR » au-dessus du tableau national, le temps
     * que la réponse arrive. Et seule la DERNIÈRE demande compte : deux choix rapprochés ne doivent
     * pas laisser la réponse la plus lente écraser la plus récente.
     */
    var demandeResultats = 0;

    function chargerResultats() {
      if (!$scope.campagne) {
        return null;
      }
      chargerGroupements();
      var numero = ++demandeResultats;
      var groupement = $scope.filtres.groupementResultats;
      return AutoEvalAdminService.getResultats($scope.campagne.annee, groupement,
        $scope.filtres.anneeEngagement).then(function (resultats) {
        if (numero !== demandeResultats) {
          return null;
        }
        var annee = $scope.filtres.anneeEngagement;
        if (annee !== null && angular.isDefined(annee)
            && (resultats.anneesEngagementDisponibles || []).indexOf(annee) < 0) {
          $scope.filtres.anneeEngagement = null;
          return chargerResultats();
        }
        $scope.resultats = resultats;
        $scope.groupementDesResultats = groupementDeCode(groupement);
        return chargerFocus(numero, groupement);
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      });
    }

    /**
     * Les focus du réseau (recette groupement, ligne 11), sur le MÊME périmètre que les
     * résultats, et lus après eux : une réponse périmée est écartée par le même numéro de
     * demande. Un échec retire la carte sans toucher au reste de l'onglet.
     */
    function chargerFocus(numero, groupement) {
      return AutoEvalAdminService.getFocus($scope.campagne.annee, groupement,
        $scope.filtres.anneeEngagement).then(function (focus) {
        if (numero === demandeResultats) {
          $scope.focusReseau = focus;
        }
        return null;
      }).catch(function () {
        if (numero === demandeResultats) {
          $scope.focusReseau = null;
        }
      });
    }

    $scope.changerFiltresResultats = function () {
      chargerResultats();
    };

    /** Le groupement d'un code, pour nommer le périmètre dans les titres ; null au national. */
    function groupementDeCode(code) {
      var choisi = null;
      angular.forEach($scope.groupements, function (groupement) {
        if (!choisi && code !== null && groupement.code === code) {
          choisi = groupement;
        }
      });
      return choisi;
    }

    $scope.lignesChapitres = function () {
      var lignes = [];
      angular.forEach($scope.resultats ? $scope.resultats.lignes : [], function (ligne) {
        if (!ligne.global) {
          lignes.push(ligne);
        }
      });
      return lignes;
    };

    $scope.ligneGlobale = function () {
      var trouvee = null;
      angular.forEach($scope.resultats ? $scope.resultats.lignes : [], function (ligne) {
        if (!trouvee && ligne.global) {
          trouvee = ligne;
        }
      });
      return trouvee;
    };

    /** Présent ? — distingue l'absence, qui s'affiche en tiret, du zéro. */
    $scope.aUneValeur = AutoEvalAdminService.aUneValeur;

    // ------------------------------------------------------------------ soumissions

    /**
     * La liste des groupements du filtre — UNE SEULE FOIS pour la durée de l'écran.
     *
     * ⚠️ `chargerSoumissions` est rappelée à chaque frappe, chaque changement de filtre, chaque
     * page et après chaque relance. Poser ce chargement là sans mémoire, c'est une requête de
     * plus par caractère tapé, pour une liste qui ne bouge pas : le groupement est FIGÉ sur les
     * soumissions, rien de ce que fait cet écran ne peut le changer — sauf le rattrapage, qui
     * remet donc le drapeau à zéro.
     */
    function chargerGroupements() {
      if (groupementsCharges || !$scope.campagne) {
        return;
      }
      groupementsCharges = true;
      AutoEvalAdminService.getGroupementsSuivi($scope.campagne.annee).then(function (liste) {
        $scope.groupements = liste || [];
      }).catch(function () {
        // Le filtre disparaît, la liste reste : ce n'est pas une raison de casser l'onglet.
        // ⚠️ Le drapeau reste LEVÉ. Le rabaisser ici ferait re-tenter à chaque frappe de la
        // recherche, soit une rafale de requêtes vers une route qui vient déjà d'échouer.
        $scope.groupements = [];
      });
    }

    function chargerSoumissions() {
      if (!$scope.campagne) {
        return null;
      }
      chargerGroupements();
      return AutoEvalAdminService.getSoumissions($scope.campagne.annee, {
        recherche: $scope.filtres.recherche,
        statut: $scope.filtres.statut,
        compte: $scope.filtres.compte,
        groupement: $scope.filtres.groupement,
        page: $scope.pagination.page - 1,
        taille: $scope.pagination.taille
      }).then(function (page) {
        $scope.soumissions = page;
        $scope.pagination.total = page.total;
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      });
    }

    $scope.rechercheModifiee = function () {
      if (minuteurRecherche) {
        $timeout.cancel(minuteurRecherche);
      }
      minuteurRecherche = $timeout(function () {
        $scope.pagination.page = 1;
        chargerSoumissions();
      }, DELAI_RECHERCHE);
    };

    $scope.filtrer = function () {
      $scope.pagination.page = 1;
      chargerSoumissions();
    };

    /** L'avancement par groupement (retours PHSQ, SP-149) ; la carte disparaît s'il échoue. */
    function chargerParticipation() {
      if (!$scope.campagne) {
        return;
      }
      AutoEvalAdminService.getParticipation($scope.campagne.annee).then(function (participation) {
        $scope.participation = participation;
      }).catch(function () {
        $scope.participation = null;
      });
    }

    /**
     * Une ligne de la participation filtre la liste sur son groupement ; recliquée, elle rend la
     * liste entière. La ligne « Sans groupement » n'a pas de code : le filtre ne sait pas la
     * désigner, elle reste inerte.
     */
    $scope.filtrerSurGroupement = function (ligne) {
      if (!ligne || !ligne.code) {
        return;
      }
      $scope.filtres.groupement = $scope.filtres.groupement === ligne.code ? null : ligne.code;
      $scope.filtrer();
    };

    /**
     * Les statuts d'une soumission, et ce que chacun veut dire (recette, ligne 20).
     *
     * ⚠️ DEUX FAMILLES QUI NE COEXISTENT PAS. Pendant la campagne : non commencée, en cours,
     * validée, rouverte. La clôture tranche le sort de chacune — non commencée devient non
     * répondue, en cours devient partielle, rouverte redevient validée sur sa dernière version
     * validée. Le filtre proposait les six en permanence : choisir « Non répondues » sur une
     * campagne ouverte rendait un tableau vide, et entretenait la confusion que la recette
     * relevait. Il ne propose donc que les statuts possibles dans l'état de la campagne.
     *
     * Les listes sont des CONSTANTES : un `ng-repeat` sur un tableau recréé à chaque lecture
     * relancerait le cycle d'Angular sans fin.
     */
    var DEFINITIONS_STATUT = {
      NON_COMMENCEE: 'Aucune réponse enregistrée pour l’instant.',
      EN_COURS: 'Au moins une réponse enregistrée, questionnaire pas encore validé.',
      VALIDEE: 'Questionnaire validé par le titulaire : il compte dans les résultats.',
      ROUVERTE: 'Rouverte par PHSQ après validation ; la dernière version validée reste acquise.',
      PARTIELLE: 'À la clôture : des réponses, mais aucune validation.',
      NON_REPONDUE: 'À la clôture : aucune réponse.'
    };
    var STATUTS_CAMPAGNE_OUVERTE = [
      { code: 'VALIDEE', libelle: 'Validées' },
      { code: 'EN_COURS', libelle: 'En cours' },
      { code: 'ROUVERTE', libelle: 'Rouvertes' },
      { code: 'NON_COMMENCEE', libelle: 'Non commencées' }
    ];
    var STATUTS_CAMPAGNE_CLOTUREE = [
      { code: 'VALIDEE', libelle: 'Validées' },
      { code: 'PARTIELLE', libelle: 'Partielles' },
      { code: 'NON_REPONDUE', libelle: 'Non répondues' }
    ];

    $scope.statutsFiltrables = function () {
      return $scope.campagne && $scope.campagne.statut === 'CLOTUREE'
        ? STATUTS_CAMPAGNE_CLOTUREE : STATUTS_CAMPAGNE_OUVERTE;
    };

    /** Un filtre du suivi est-il actif ? L'export des réponses, lui, le suit. */
    $scope.suiviFiltre = function () {
      var f = $scope.filtres;
      return !!(f.groupement || f.statut || (f.recherche && f.recherche.trim()));
    };

    $scope.definitionStatut = function (statut) {
      return DEFINITIONS_STATUT[statut] || '';
    };

    $scope.nbPages = function () {
      var total = Number($scope.pagination.total) || 0;
      var taille = Number($scope.pagination.taille) || 1;
      return total > 0 ? Math.max(Math.ceil(total / taille), 1) : 0;
    };

    /**
     * Change de page, en ignorant un clic sur la page déjà affichée.
     *
     * ⚠️ Le numéro d'ancienne page est transmis par le gabarit : un clic sur le numéro courant
     * relancerait sinon la requête pour rien, et l'écran clignoterait à chaque fois qu'on vise
     * une page voisine et qu'on retombe sur celle d'origine.
     */
    $scope.changerPage = function (nouvelle, ancienne) {
      var cible = Number(nouvelle);
      if (angular.isNumber(ancienne) && cible === Number(ancienne)) {
        return;
      }
      if (!isFinite(cible) || cible <= 0 || cible > $scope.nbPages()) {
        return;
      }
      $scope.pagination.page = cible;
      chargerSoumissions();
    };

    /**
     * Les numéros à afficher, avec des points de suspension quand il y a trop de pages.
     *
     * ⚠️ MÊME ALGORITHME que la liste des verbatims du suivi d'enquête, et même balisage : un
     * administrateur ne doit pas réapprendre une pagination d'un écran à l'autre. Neuf entrées au
     * plus, la première et la dernière toujours visibles, la page courante au milieu quand elle
     * le peut.
     *
     * Sur 2 602 soumissions et 25 par page, c'est 105 pages : sans les points de suspension, la
     * barre ferait plusieurs écrans de large.
     */
    $scope.pagesSoumissions = function () {
      return decouperPages(Number($scope.pagination.page) || 1, $scope.nbPages());
    };

    function decouperPages(courante, nbPages) {
      if (nbPages <= 0) {
        return [];
      }
      var largeur = 9;
      var moitie = Math.ceil(largeur / 2);
      var position;
      if (courante <= moitie) {
        position = 'debut';
      } else if (nbPages - moitie < courante) {
        position = 'fin';
      } else {
        position = 'milieu';
      }

      var pages = [];
      var pointsNecessaires = largeur < nbPages;
      var i = 1;
      while (i <= nbPages && i <= largeur) {
        var numero;
        if (i === largeur) {
          numero = nbPages;
        } else if (i === 1) {
          numero = i;
        } else if (largeur < nbPages) {
          if (nbPages - moitie < courante) {
            numero = nbPages - largeur + i;
          } else if (moitie < courante) {
            numero = courante - moitie + i;
          } else {
            numero = i;
          }
        } else {
          numero = i;
        }

        var pointsAvant = (i === 2 && (position === 'milieu' || position === 'fin'));
        var pointsApres = (i === largeur - 1 && (position === 'milieu' || position === 'debut'));
        pages.push(pointsNecessaires && (pointsAvant || pointsApres) ? '...' : numero);
        i++;
      }
      return pages;
    }

    // ------------------------------------------------------------------ satisfaction

    /**
     * L'onglet « Satisfaction » (décision PHSQ du 17/10/2026) : le Baromètre au national ou d'un
     * groupement, puis les réponses de chaque officine avec son commentaire.
     *
     * ⚠️ Même règle que les résultats nationaux : le périmètre NOMMÉ est celui de la réponse reçue,
     * et seule la dernière demande compte.
     */
    $scope.satisfaction = null;
    $scope.satisfactionOfficines = null;
    $scope.groupementDeLaSatisfaction = null;
    $scope.satisfactionFiltres = { groupement: null, recherche: '', filtre: '' };
    $scope.satisfactionTri = { colonne: 'satisfaction', sens: 'asc' };
    $scope.satisfactionPagination = { page: 1, taille: 25, total: 0 };
    var demandeSatisfaction = 0;
    var minuteurRechercheSatisfaction = null;

    function chargerSatisfaction() {
      if (!$scope.campagne) {
        return null;
      }
      chargerGroupements();
      var numero = ++demandeSatisfaction;
      var groupement = $scope.satisfactionFiltres.groupement;
      return AutoEvalAdminService.getSatisfaction($scope.campagne.annee, groupement).then(function (satisfaction) {
        if (numero !== demandeSatisfaction) {
          return null;
        }
        $scope.satisfaction = satisfaction;
        $scope.groupementDeLaSatisfaction = groupementDeCode(groupement);
        return chargerSatisfactionOfficines();
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      });
    }

    function chargerSatisfactionOfficines() {
      var numero = demandeSatisfaction;
      return AutoEvalAdminService.getSatisfactionOfficines($scope.campagne.annee, {
        groupement: $scope.satisfactionFiltres.groupement,
        recherche: $scope.satisfactionFiltres.recherche,
        filtre: $scope.satisfactionFiltres.filtre,
        tri: $scope.satisfactionTri.colonne,
        sens: $scope.satisfactionTri.sens,
        page: $scope.satisfactionPagination.page - 1,
        taille: $scope.satisfactionPagination.taille
      }).then(function (page) {
        if (numero !== demandeSatisfaction) {
          return null;
        }
        $scope.satisfactionOfficines = page;
        $scope.satisfactionPagination.total = page.total;
        $scope.satisfactionPagination.page = (page.page || 0) + 1;
        return null;
      }).catch(function (erreur) {
        $scope.erreur = erreur;
      });
    }

    $scope.changerGroupementSatisfaction = function () {
      $scope.satisfactionPagination.page = 1;
      chargerSatisfaction();
    };

    $scope.rechercheSatisfactionModifiee = function () {
      if (minuteurRechercheSatisfaction) {
        $timeout.cancel(minuteurRechercheSatisfaction);
      }
      minuteurRechercheSatisfaction = $timeout(function () {
        $scope.satisfactionPagination.page = 1;
        chargerSatisfactionOfficines();
      }, 350);
    };

    $scope.filtrerSatisfaction = function () {
      $scope.satisfactionPagination.page = 1;
      chargerSatisfactionOfficines();
    };

    $scope.trierSatisfaction = function (colonne) {
      if ($scope.satisfactionTri.colonne === colonne) {
        $scope.satisfactionTri.sens = $scope.satisfactionTri.sens === 'asc' ? 'desc' : 'asc';
      } else {
        $scope.satisfactionTri.colonne = colonne;
        $scope.satisfactionTri.sens = 'asc';
      }
      $scope.satisfactionPagination.page = 1;
      chargerSatisfactionOfficines();
    };

    $scope.nbPagesSatisfaction = function () {
      var total = Number($scope.satisfactionPagination.total) || 0;
      return total > 0 ? Math.max(Math.ceil(total / $scope.satisfactionPagination.taille), 1) : 0;
    };

    $scope.pagesSatisfaction = function () {
      return decouperPages(Number($scope.satisfactionPagination.page) || 1, $scope.nbPagesSatisfaction());
    };

    $scope.changerPageSatisfaction = function (nouvelle, ancienne) {
      var cible = Number(nouvelle);
      if ((angular.isNumber(ancienne) && cible === Number(ancienne)) || !isFinite(cible) || cible <= 0
          || cible > $scope.nbPagesSatisfaction()) {
        return;
      }
      $scope.satisfactionPagination.page = cible;
      chargerSatisfactionOfficines();
    };

    /** Les parts qui ont une valeur : la barre boucle à 100 % sans liseré. */
    $scope.partsAvecValeur = function (parts) {
      var retenues = [];
      angular.forEach(parts || [], function (part) {
        if ($scope.aUneValeur(part.pct) && part.pct > 0) {
          retenues.push(part);
        }
      });
      return retenues;
    };

    $scope.partSatisfaction = function (question, valeur) {
      var trouvee = null;
      angular.forEach(question ? question.distribution : [], function (part) {
        if (!trouvee && part.cle === valeur) {
          trouvee = part;
        }
      });
      return trouvee;
    };

    $scope.modaliteSatisfaction = function (valeur) {
      var trouvee = null;
      angular.forEach($scope.satisfaction ? $scope.satisfaction.palette : [], function (modalite) {
        if (!trouvee && modalite.valeur === valeur) {
          trouvee = modalite;
        }
      });
      return trouvee;
    };

    $scope.abregeSatisfaction = function (valeur) {
      return { TRES_SATISFAIT: 'TS', SATISFAIT: 'S', INSATISFAIT: 'I', TRES_INSATISFAIT: 'TI',
        NON_CONCERNE: 'NC' }[valeur] || '—';
    };

    /**
     * Rouvre une soumission validée, avec un motif obligatoire.
     *
     * ⚠️ Le motif est une donnée INTERNE : tracé au journal, jamais montré à l'officine, qui
     * reçoit seulement l'information de la réouverture.
     */
    /**
     * La réouverture d'une auto-évaluation, dans une FENÊTRE DE CONFIRMATION du produit.
     *
     * ⚠️ C'était un `$mdDialog.prompt()`, le composant brut d'Angular Material : un titre, une
     * ligne de texte et un champ nu, sans rapport avec les autres confirmations de
     * l'administration. Elle emprunte désormais la famille `admin-dialog`, que sa feuille de
     * style annonce comme partagée par les fenêtres de confirmation, de suppression et de
     * changement de statut.
     *
     * ⚠️ L'opération est d'exception — deux à trois par an — et elle oblige l'officine à
     * revalider. La fenêtre le dit avant, pas après.
     */
    $scope.rouvrir = function (ligne, evenement) {
      $scope.reouverture = {
        soumissionId: ligne.soumissionId,
        nom: ligne.nom,
        motif: '',
        envoi: false
      };
      $mdDialog.show({
        templateUrl: POPUP_REOUVERTURE,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerReouverture = function () {
      $mdDialog.hide();
    };

    $scope.confirmerReouverture = function () {
      var demande = $scope.reouverture;
      if (!demande || !demande.motif || demande.envoi) {
        return;
      }
      demande.envoi = true;
      AutoEvalAdminService.rouvrir(demande.soumissionId, demande.motif).then(function () {
        $mdDialog.hide();
        toastr.success('Auto-évaluation rouverte.');
        chargerSoumissions();
      }).catch(function (erreur) {
        // ⚠️ La fenêtre RESTE OUVERTE sur un refus : le motif saisi n'est pas perdu, et un toast
        // derrière un dialogue ouvert se voit mal. Le serveur refuse par exemple une campagne
        // clôturée ou une soumission non validée.
        demande.envoi = false;
        if (erreur && (erreur.message || erreur.anomalies)) {
          afficherErreur(erreur);
        }
      });
    };

    /**
     * Le journal d'une officine, dans une FENÊTRE.
     *
     * ⚠️ Il s'affichait auparavant dans une carte en bas de page. Avec vingt-cinq lignes et la
     * pagination au-dessus, cette carte naissait à 1 300 px sous le pli : on cliquait, rien ne
     * bougeait, et le bouton passait pour cassé. Une fenêtre répond sur place, et rend la liste
     * intacte quand on la referme — c'est le détail d'une ligne, pas une section de l'écran.
     */
    $scope.voirJournal = function (ligne, evenement) {
      $scope.journalPopup = {
        titre: ligne.nom,
        chargement: true,
        entrees: [],
        erreur: null
      };
      $mdDialog.show({
        templateUrl: POPUP_JOURNAL,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
      AutoEvalAdminService.getJournal(ligne.soumissionId).then(function (journal) {
        $scope.journalPopup.entrees = journal || [];
      }).catch(function (erreur) {
        // L'erreur reste DANS la fenêtre : un toast derrière un dialogue ouvert se voit mal, et
        // l'écran n'aurait plus rien à montrer à la place.
        $scope.journalPopup.erreur = (erreur && erreur.message)
          || 'Le journal n’a pas pu être lu.';
      }).finally(function () {
        $scope.journalPopup.chargement = false;
      });
    };

    $scope.fermerJournal = function () {
      $mdDialog.hide();
    };

    /**
     * Relance d'une seule officine — sous confirmation.
     *
     * ⚠️ ELLE PARTAIT AUPARAVANT SUR UN SEUL CLIC, et elle ne s'annule pas : un e-mail est mis en
     * file vers une officine réelle, que le planificateur envoie à la minute suivante. Le bouton
     * est de surcroît collé à « Journal », qui ne fait qu'ouvrir une fiche.
     */
    $scope.relancerOfficine = function (ligne, evenement) {
      $scope.relanceOfficine = {
        soumissionId: ligne.soumissionId,
        nom: ligne.nom,
        cip: ligne.cip,
        statut: ligne.statut,
        envoi: false
      };
      $mdDialog.show({
        templateUrl: POPUP_RELANCE_OFFICINE,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerRelanceOfficine = function () {
      $mdDialog.hide();
    };

    $scope.confirmerRelanceOfficine = function () {
      if (!$scope.relanceOfficine || $scope.relanceOfficine.envoi) {
        return;
      }
      $scope.relanceOfficine.envoi = true;
      var nom = $scope.relanceOfficine.nom;
      AutoEvalAdminService.relancerOfficine($scope.relanceOfficine.soumissionId).then(function () {
        $mdDialog.hide();
        toastr.success('Relance mise en file pour ' + nom + '.');
      }).catch(function (erreur) {
        // La fenêtre reste ouverte : le serveur refuse une officine qui vient de valider
        // (DEJA_VALIDEE), et l'administrateur doit lire pourquoi sans la rouvrir.
        $scope.relanceOfficine.envoi = false;
        if (erreur && (erreur.message || erreur.anomalies)) {
          afficherErreur(erreur);
        }
      });
    };

    /**
     * La fenêtre « Accès de l'officine » (21/10/2026), commune avec l'espace groupement : comptes,
     * e-mails de la campagne déjà envoyés, renvoi de l'e-mail de lancement. Si un e-mail est parti,
     * la liste est relue pour que la ligne le dise.
     */
    $scope.ouvrirAcces = function (ligne, evenement) {
      AeqAccesOfficine.ouvrir({
        nom: ligne.nom,
        cip: ligne.cip,
        annee: $scope.campagne ? $scope.campagne.annee : null,
        vueAdmin: true,
        event: evenement,
        charger: function () {
          return AutoEvalAdminService.getAcces(ligne.soumissionId);
        },
        renvoyer: function () {
          return AutoEvalAdminService.renvoyerLancement(ligne.soumissionId);
        }
      }).then(function (etat) {
        if (etat && etat.envoye) {
          chargerSoumissions();
        }
      });
    };

    $scope.classeCompte = function (ligne) {
      if (ligne.compteTitulaire === 'ACTIVE') {
        return 'aeq-compte-chip--ok';
      }
      return ligne.compteTitulaire === 'NON_ACTIVE' ? 'aeq-compte-chip--warn' : 'aeq-compte-chip--err';
    };

    $scope.relancerLot = function (evenement) {
      $scope.relanceLot = { envoi: false, chargement: true, derniere: null, envoyables: {} };
      // La dernière relance vient des cartes de relance, LQO et non LQO : la même date que
      // Configuration, lue au moment d'ouvrir la fenêtre pour ne pas afficher une date périmée.
      // Leur état dit aussi QUI sera relancé : une population dont la relance n'est pas activée
      // ne recevra rien, et la fenêtre doit le dire avant l'envoi.
      AutoEvalAdminService.getNotifications($scope.campagneId).then(function (notifications) {
        angular.forEach(notifications || [], function (notification) {
          if (notification.type === 'RELANCE' || notification.type === 'RELANCE_NON_LQO') {
            $scope.relanceLot.envoyables[notification.type] = !!notification.envoyable;
            if (notification.dateDernierEnvoi
                && (!$scope.relanceLot.derniere || notification.dateDernierEnvoi > $scope.relanceLot.derniere)) {
              $scope.relanceLot.derniere = notification.dateDernierEnvoi;
            }
          }
        });
      }).finally(function () {
        $scope.relanceLot.chargement = false;
      });
      $mdDialog.show({
        templateUrl: POPUP_RELANCE_LOT,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    $scope.fermerRelanceLot = function () {
      $mdDialog.hide();
    };

    /** Le périmètre réellement relancé, tel que la fenêtre de confirmation doit le nommer. */
    $scope.libelleGroupementFiltre = function () {
      var choisi = null;
      angular.forEach($scope.groupements, function (groupement) {
        if (!choisi && groupement.code === $scope.filtres.groupement) {
          choisi = groupement;
        }
      });
      return choisi ? choisi.libelle : null;
    };

    $scope.confirmerRelanceLot = function () {
      if (!$scope.relanceLot || $scope.relanceLot.envoi) {
        return;
      }
      $scope.relanceLot.envoi = true;
      // ⚠️ SEUL LE GROUPEMENT RESTREINT LA RELANCE. La route `/{annee}/relancer` ne connaît que ce
      // paramètre : elle relance TOUTES les non validées du périmètre, sans regarder la recherche
      // ni le statut affichés. La fenêtre de confirmation nomme donc ce périmètre-là, et rien
      // d'autre, sous peine de promettre une restriction que le serveur n'applique pas.
      AutoEvalAdminService.relancerLot($scope.campagne.annee, {
        groupement: $scope.filtres.groupement
      }).then(function (reponse) {
        $mdDialog.hide();
        // Le serveur rend `relancees` — pas `nb`, qui affichait « 0 relance(s) » à chaque fois —
        // et `sansEmail`, les officines laissées de côté faute de relance activée pour leur contrat.
        toastr.success((reponse && reponse.relancees ? reponse.relancees : 0)
          + ' relance(s) mise(s) en file.');
        if (reponse && reponse.sansEmail) {
          toastr.warning(reponse.sansEmail + ' officine(s) non relancée(s) : l’e-mail de relance de leur '
            + 'contrat (LQO ou non LQO) n’est pas activé.');
        }
        chargerSoumissions();
      }).catch(function (erreur) {
        $scope.relanceLot.envoi = false;
        if (erreur && (erreur.message || erreur.anomalies)) {
          afficherErreur(erreur);
        }
      });
    };

    // ------------------------------------------------------------------ rapport de satisfaction

    /**
     * LE RAPPORT DE SATISFACTION : le baromètre du millésime au format que PHSQ tenait à la main
     * depuis l'export Vocaza (identité, parc, demande de contact, satisfaction, verbatims).
     *
     * ⚠️ IL IGNORE LES FILTRES DE L'ÉCRAN, et c'est voulu : PHSQ le relit d'une année sur l'autre
     * et compare les totaux. Un fichier tantôt national, tantôt restreint au groupement affiché
     * fausserait la comparaison sans rien dire. Ne pas y brancher `$scope.filtres`.
     *
     * ⚠️ Il porte TOUTE LA CIBLE : une officine qui n'a pas répondu y figure avec « Non » dans la
     * colonne « A répondu » et aucune réponse.
     */
    $scope.exporterSatisfaction = function () {
      if ($scope.exportSatisfaction) {
        return;
      }
      $scope.exportSatisfaction = true;
      AutoEvalAdminService.exporterSatisfaction($scope.campagne.annee).then(function () {
        $scope.exportSatisfaction = false;
      }).catch(function (erreur) {
        $scope.exportSatisfaction = false;
        afficherErreur(erreur);
      });
    };

    /**
     * L'EXPORT DES RÉPONSES : le téléchargement brut du millésime, au format Vocaza.
     *
     * ⚠️ IL SUIT LES FILTRES DU SUIVI (recette, ligne 27) : groupement, statut et recherche, les
     * trois critères de la liste affichée. Sans filtre, c'est le classeur national. Les deux
     * autres exports, eux, restent nationaux — PHSQ les compare d'une année sur l'autre.
     *
     * ⚠️ IL EST LONG — 2 600 officines sur plus de 350 colonnes. Le bouton se verrouille le temps
     * de la préparation, faute de quoi un second clic relance tout le calcul côté serveur.
     */
    $scope.exporterReponses = function () {
      if ($scope.exportReponses) {
        return;
      }
      $scope.exportReponses = true;
      AutoEvalAdminService.exporterReponses($scope.campagne.annee, {
        groupement: $scope.filtres.groupement,
        statut: $scope.filtres.statut,
        compte: $scope.filtres.compte,
        recherche: $scope.filtres.recherche
      }).then(function () {
        $scope.exportReponses = false;
      }).catch(function (erreur) {
        $scope.exportReponses = false;
        afficherErreur(erreur);
      });
    };

    $scope.exporterRapportSynthese = function () {
      if ($scope.exportRapportSynthese) {
        return;
      }
      $scope.exportRapportSynthese = true;
      AutoEvalAdminService.exporterRapportSynthese($scope.campagne.annee).then(function () {
        $scope.exportRapportSynthese = false;
      }).catch(function (erreur) {
        $scope.exportRapportSynthese = false;
        afficherErreur(erreur);
      });
    };

    // ------------------------------------------------------------------ rattrapage du groupement

    /**
     * Recopie le groupement du cache du parc CRM sur les soumissions qui n'en ont pas.
     *
     * ⚠️ Le groupement est figé sur la soumission à sa création. Quand le cache CRM était vide à
     * l'ouverture, les soumissions naissent sans réseau et rien ne les relit : la segmentation
     * par groupement du millésime est perdue pour l'année. C'est le seul rattrapage possible, et
     * il n'écrase jamais un groupement déjà posé.
     */
    /**
     * Rafraîchit le cache du parc CRM, puis recharge la campagne pour que le bandeau se remette à
     * jour — il passera de « rafraîchir » à « compléter » si le CRM a répondu.
     */
    $scope.rafraichirParcCrm = function () {
      if ($scope.rafraichissementParc) {
        return;
      }
      $scope.rafraichissementParc = true;
      AutoEvalAdminService.rafraichirParcCrm().then(function (rapport) {
        $scope.rafraichissementParc = false;
        if (rapport && rapport.crmIndisponible) {
          toastr.error('Le CRM n\'a pas répondu : le cache est inchangé.');
          return;
        }
        toastr.success((rapport && rapport.rattachementsCacheMisAJour ? rapport.rattachementsCacheMisAJour : 0)
          + ' officine(s) rattachée(s) dans le cache du parc.');
        return AutoEvalAdminService.getCampagne($scope.campagneId).then(appliquerCampagne);
      }).catch(function (erreur) {
        $scope.rafraichissementParc = false;
        afficherErreur(erreur);
      });
    };

    $scope.completerGroupements = function () {
      if ($scope.completionGroupements) {
        return;
      }
      $scope.completionGroupements = true;
      AutoEvalAdminService.completerGroupements($scope.campagneId).then(function (reponse) {
        $scope.completionGroupements = false;
        // Des réseaux viennent d'apparaître sur les soumissions : le filtre doit les relire.
        groupementsCharges = false;
        appliquerCampagne(reponse.campagne);
        if (reponse.completees) {
          toastr.success(reponse.completees + ' soumission(s) rattachée(s) à leur groupement.');
          chargerSoumissions();
        } else {
          toastr.warning('Aucune soumission complétée : le cache du parc CRM ne connaît aucune '
            + 'de ces officines.');
        }
      }).catch(function (erreur) {
        $scope.completionGroupements = false;
        afficherErreur(erreur);
      });
    };

    // ------------------------------------------------------------------ ajout à la cible

    /**
     * Ajoute une officine à une cible déjà figée (spécification §6) : celle qui s'engage après
     * l'ouverture.
     *
     * ⚠️ N'a de sens que sur une campagne OUVERTE. Avant l'ouverture la cible n'existe pas encore
     * — elle est recalculée à chaque affichage — et après la clôture il n'y a plus rien à
     * rejoindre. Le serveur refuse les deux cas ; le bouton ne s'affiche donc pas (voir le
     * `ng-if` de la barre d'outils).
     */
    $scope.ouvrirAjoutCible = function (evenement) {
      $scope.ajoutCible = {
        recherche: '', candidats: [], choisie: null, chargement: false, envoi: false,
        emailOuverture: { OUVERTURE: false, OUVERTURE_NON_LQO: false }
      };
      // ⚠️ L'e-mail d'ouverture ne part QUE si la notification correspondante est envoyable —
      // active ET gabarit Brevo valide (`creerSoumissions`, côté serveur). La fenêtre l'annonçait
      // sans condition : sur une campagne aux notifications inactives, elle promettait un envoi
      // qui n'avait pas lieu. On va donc chercher l'état réel, et la fenêtre dit ce qui se
      // passera vraiment — pour LA VERSION que recevra l'officine choisie, LQO ou non LQO.
      AutoEvalAdminService.getNotifications($scope.campagneId).then(function (notifications) {
        angular.forEach(notifications || [], function (notification) {
          if (notification.type === 'OUVERTURE' || notification.type === 'OUVERTURE_NON_LQO') {
            $scope.ajoutCible.emailOuverture[notification.type] = !!notification.envoyable;
          }
        });
      });
      $mdDialog.show({
        templateUrl: POPUP_AJOUT_CIBLE,
        parent: angular.element($document[0].body),
        targetEvent: evenement,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    };

    /** L'e-mail d'ouverture que recevrait l'officine choisie partira-t-il ? Celui de son contrat. */
    $scope.ouvertureEnvoyablePour = function (officine) {
      var type = officine && officine.nonLqo ? 'OUVERTURE_NON_LQO' : 'OUVERTURE';
      return !!($scope.ajoutCible && $scope.ajoutCible.emailOuverture[type]);
    };

    $scope.fermerAjoutCible = function () {
      if (minuteurCandidats) {
        $timeout.cancel(minuteurCandidats);
        minuteurCandidats = null;
      }
      $mdDialog.hide();
    };

    /**
     * ⚠️ Même temporisation que la recherche de soumissions : une frappe au clavier ne doit pas
     * valoir une requête. En dessous de deux caractères on n'interroge pas — sur 3 000 officines,
     * une lettre seule ne réduit rien.
     */
    $scope.chercherCandidats = function () {
      if (minuteurCandidats) {
        $timeout.cancel(minuteurCandidats);
      }
      var terme = $scope.ajoutCible.recherche || '';
      if (terme.length < 2) {
        $scope.ajoutCible.candidats = [];
        $scope.ajoutCible.chargement = false;
        return;
      }
      $scope.ajoutCible.chargement = true;
      minuteurCandidats = $timeout(function () {
        AutoEvalAdminService.candidatsCible($scope.campagneId, terme).then(function (candidats) {
          // La réponse d'une frappe abandonnée ne doit pas écraser celle de la frappe courante.
          if (($scope.ajoutCible.recherche || '') !== terme) {
            return;
          }
          $scope.ajoutCible.candidats = candidats || [];
          $scope.ajoutCible.chargement = false;
        }).catch(function (erreur) {
          $scope.ajoutCible.chargement = false;
          afficherErreur(erreur);
        });
      }, DELAI_RECHERCHE);
    };

    $scope.choisirCandidat = function (candidat) {
      $scope.ajoutCible.choisie = candidat;
    };

    $scope.revenirRecherche = function () {
      $scope.ajoutCible.choisie = null;
    };

    $scope.confirmerAjoutCible = function () {
      if (!$scope.ajoutCible || !$scope.ajoutCible.choisie || $scope.ajoutCible.envoi) {
        return;
      }
      $scope.ajoutCible.envoi = true;
      var nom = $scope.ajoutCible.choisie.nom;
      AutoEvalAdminService.ajouterALaCible($scope.campagneId, $scope.ajoutCible.choisie.id)
        .then(function (campagne) {
          $mdDialog.hide();
          // La campagne revient du serveur avec son effectif de cible incrémenté : l'appliquer
          // plutôt que recharger, sinon le compteur affiché reste en arrière d'un ajout.
          appliquerCampagne(campagne);
          toastr.success($scope.ajoutCible && $scope.ajoutCible.emailOuverture
            ? nom + ' ajoutée à la cible ; l\'e-mail d\'ouverture part.'
            : nom + ' ajoutée à la cible.');
          chargerSoumissions();
        }).catch(function (erreur) {
          $scope.ajoutCible.envoi = false;
          afficherErreur(erreur);
        });
    };

    $scope.voirTaches = function () {
      $state.go('admin.autoeval.taches', { id: $scope.campagneId });
    };

    $scope.$on('$destroy', function () {
      if (minuteurRecherche) {
        $timeout.cancel(minuteurRecherche);
      }
      if (minuteurCandidats) {
        $timeout.cancel(minuteurCandidats);
      }
    });

    charger();
  }
})();

(function () {
  'use strict';

  angular.module('fuse').service('AutoEvalAdminService', AutoEvalAdminService);

  /**
   * Pilotage des campagnes d'auto-évaluation — réservé à l'administration PHSQ.
   *
   * ⚠️ IL N'EXISTE AUCUN APPEL POUR OUVRIR OU CLÔTURER une campagne, et ce n'est pas un oubli :
   * la spécification veut ces transitions AUTOMATIQUES, aux dates prévues. L'écran affiche la
   * fenêtre, il ne la déclenche pas. Ne pas ajouter de bouton qui ferait semblant.
   *
   * ⚠️ Gson omet les champs nuls : un pourcentage absent n'est pas zéro, c'est le tiret « — ».
   *
   * ⚠️ Le DTO de campagne porte `supprimable`, `deprogrammable`, `datesModifiables` et
   * `prolongationModifiable`. S'y fier plutôt que de rejouer les règles ici : elles dépendent de
   * l'état du questionnaire et des réponses déjà saisies, que le front ne connaît pas.
   */
  function AutoEvalAdminService($q, $http, $window, $document) {
    var BASE = '/api/rest/autoEvaluation/admin';

    var MESSAGE_ERREUR = 'Une erreur est survenue, veuillez réessayer plus tard.';

    function params(extra) {
      var query = angular.extend({ '_v': new Date().getTime() }, extra || {});
      angular.forEach(query, function (valeur, cle) {
        if (valeur === null || angular.isUndefined(valeur) || valeur === '') {
          delete query[cle];
        }
      });
      return query;
    }

    function envoyer(methode, url, query, corps) {
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: methode,
          params: params(query),
          data: corps,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(toError(response));
        });
      });
    }

    /**
     * Conserve le CODE et les ANOMALIES du serveur.
     *
     * Un chargement de millésime fautif en rend une vingtaine d'un coup : l'écran doit toutes les
     * afficher, pas seulement la première, sinon on corrige le fichier ligne à ligne.
     */
    function toError(response) {
      var data = response ? response.data : null;
      return {
        status: response ? response.status : 0,
        code: data && data.code ? data.code : null,
        message: (data && data.message) ? data.message : MESSAGE_ERREUR,
        anomalies: (data && data.anomalies) ? data.anomalies : []
      };
    }

    this.aUneValeur = function (valeur) {
      return valeur !== null && angular.isDefined(valeur);
    };

    // ---------------------------------------------------------------- campagnes

    this.getCampagnes = function () {
      return envoyer('GET', BASE + '/campagnes');
    };

    this.creerCampagne = function () {
      return envoyer('POST', BASE + '/campagnes');
    };

    this.creerHistorique = function (corps) {
      return envoyer('POST', BASE + '/campagnes/historique', null, corps);
    };

    this.getCampagne = function (id) {
      return envoyer('GET', BASE + '/campagne/' + id);
    };

    this.enregistrerDates = function (id, corps) {
      return envoyer('PUT', BASE + '/campagne/' + id + '/dates', null, corps);
    };

    this.deprogrammer = function (id) {
      return envoyer('POST', BASE + '/campagne/' + id + '/deprogrammer');
    };

    this.supprimerCampagne = function (id) {
      return envoyer('DELETE', BASE + '/campagne/' + id);
    };

    // ---------------------------------------------------------------- questionnaire et cible

    this.getQuestionnaire = function (id) {
      return envoyer('GET', BASE + '/campagne/' + id + '/questionnaire');
    };

    // ---------------------------------------------------------------- boîte à outils

    this.getOutils = function (id) {
      return envoyer('GET', BASE + '/campagne/' + id + '/outils');
    };

    /**
     * Crée ou modifie un outil : un formulaire multipart, comme la boîte à outils des journées
     * qualité — le fichier ne passe pas en JSON.
     */
    this.enregistrerOutil = function (id, formulaire) {
      return $q(function (resolve, reject) {
        $http({
          url: BASE + '/campagne/' + id + '/outils',
          method: 'POST',
          params: params(),
          data: formulaire,
          headers: { 'Content-Type': undefined },
          transformRequest: angular.identity
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(toError(response));
        });
      });
    };

    this.supprimerOutil = function (outilId) {
      return envoyer('DELETE', BASE + '/outil/' + outilId);
    };

    this.deplacerOutil = function (outilId, versLeHaut) {
      return envoyer('POST', BASE + '/outil/' + outilId + '/deplacer', { haut: versLeHaut ? 'true' : 'false' });
    };

    /** Le document tel que l'officine le télécharge : l'administration ouvre le même lien. */
    this.urlOutil = function (outilId) {
      return '/api/rest/autoEvaluation/outil/' + outilId;
    };

    /**
     * Une ressource de focus, ouverte depuis l'aperçu de l'onglet Questionnaire.
     *
     * ⚠️ HORS de `BASE` : c'est la route de l'officine (`/autoEvaluation/ressource/{id}`), qui admet
     * aussi l'administrateur. L'aperçu ouvre ainsi exactement le document que l'officine recevra.
     */
    this.urlRessource = function (ressourceId) {
      return '/api/rest/autoEvaluation/ressource/' + ressourceId;
    };

    /** Le lien d'une question, par la même route que l'officine (elle admet l'administrateur). */
    this.urlLienQuestion = function (questionId) {
      return '/api/rest/autoEvaluation/lien/' + questionId;
    };

    /**
     * Recharge le questionnaire depuis le millésime EMBARQUÉ dans la version de LQO déployée
     * (questionnaire, fichiers des focus, correspondance N-1). Rend le compte rendu du chargement.
     */
    this.rechargerQuestionnaireDepot = function (id) {
      return envoyer('POST', BASE + '/campagne/' + id + '/questionnaire/depot');
    };

    this.figerQuestionnaire = function (id) {
      return envoyer('POST', BASE + '/campagne/' + id + '/questionnaire/figer');
    };

    this.estimerCible = function (id) {
      return envoyer('GET', BASE + '/campagne/' + id + '/cible/estimation');
    };

    /**
     * Officines que l'on peut encore ajouter à la cible : actives et hors cible.
     *
     * ⚠️ Le serveur n'écarte PAS les officines non engagées dans la démarche qualité, et c'est
     * voulu : l'ajout manuel sert précisément à celle que la règle n'a pas retenue. Il rend
     * `engageQualite` pour que l'écran le signale — ne pas filtrer dessus ici.
     */
    this.candidatsCible = function (id, recherche) {
      return envoyer('GET', BASE + '/campagne/' + id + '/cible/candidats', { recherche: recherche });
    };

    /**
     * Ajoute une officine à une cible déjà figée.
     *
     * ⚠️ L'appel ENVOIE l'e-mail d'ouverture à l'officine et l'inscrit au dénominateur à compter
     * de son ajout — la règle de la spécification §6, sans option. Ne l'appeler que derrière une
     * confirmation qui le dit.
     */
    /**
     * Recopie le groupement du cache du parc CRM sur les soumissions qui n'en ont pas.
     *
     * ⚠️ Rattrapage, pas synchronisation : le serveur ne comble que les trous et ne réécrit
     * jamais un groupement déjà figé. Le cache du parc CRM doit avoir été rafraîchi avant, sinon
     * il n'y a rien à recopier.
     */
    /**
     * Rafraîchit le cache du parc CRM — « quelle officine dans quel réseau ».
     *
     * ⚠️ Route de l'administration des GROUPEMENTS, pas de l'auto-évaluation : elle touche tout le
     * parc, pas une campagne. Elle est appelée d'ici parce que c'est là qu'on constate le
     * manque, et le bouton dit ce qu'il fait.
     */
    this.rafraichirParcCrm = function () {
      return envoyer('POST', '/api/rest/groupement/admin/cache-parc-crm');
    };

    this.completerGroupements = function (id) {
      return envoyer('POST', BASE + '/campagne/' + id + '/groupements/completer');
    };

    this.ajouterALaCible = function (id, pharmacieId) {
      return envoyer('POST', BASE + '/campagne/' + id + '/cible', null, { pharmacieId: pharmacieId });
    };

    // ---------------------------------------------------------------- notifications

    this.getNotifications = function (id) {
      return envoyer('GET', BASE + '/campagne/' + id + '/notifications');
    };

    /**
     * Enregistre le réglage d'UN e-mail.
     *
     * ⚠️ La route attend un TABLEAU : elle est faite pour enregistrer les quatre types d'un coup.
     * Lui envoyer un objet seul produit un 500 côté serveur, que rien dans l'écran ne laissait
     * deviner — le défaut est resté invisible tant que la campagne ouverte interdisait toute
     * modification, et il n'y avait aucune campagne en brouillon pour le révéler.
     */
    this.enregistrerNotification = function (id, corps) {
      return envoyer('PUT', BASE + '/campagne/' + id + '/notifications', null, [corps]);
    };

    /**
     * Envoie un e-mail de TEST d'un gabarit de la campagne. Un gabarit absent ou non conforme
     * répond 409, avec la raison dans le message.
     */
    this.envoyerTestNotification = function (id, type, destinataire) {
      return envoyer('POST', BASE + '/campagne/' + id + '/notification/' + type + '/test', null,
        { destinataire: destinataire });
    };

    this.getGabaritsBrevo = function () {
      return envoyer('GET', BASE + '/brevo/templates');
    };

    // ---------------------------------------------------------------- restitution

    this.getResultats = function (annee, groupement, anneeEngagement) {
      return envoyer('GET', BASE + '/' + annee + '/resultats', {
        groupement: groupement, anneeEngagement: anneeEngagement
      });
    };

    /** Onglet « Satisfaction » : le Baromètre au national, ou d'un groupement comparé au national. */
    this.getSatisfaction = function (annee, groupement) {
      return envoyer('GET', BASE + '/' + annee + '/satisfaction', { groupement: groupement });
    };

    /** Les réponses de chaque officine au Baromètre, avec leur commentaire. */
    this.getSatisfactionOfficines = function (annee, query) {
      return envoyer('GET', BASE + '/' + annee + '/satisfaction/officines', query);
    };

    this.getProfil = function (annee, groupement, anneeEngagement) {
      return envoyer('GET', BASE + '/' + annee + '/profil', {
        groupement: groupement, anneeEngagement: anneeEngagement
      });
    };

    /** « Focus du réseau » : la part des officines qui déclenchent chaque focus. */
    this.getFocus = function (annee, groupement, anneeEngagement) {
      return envoyer('GET', BASE + '/' + annee + '/focus', {
        groupement: groupement, anneeEngagement: anneeEngagement
      });
    };

    // ---------------------------------------------------------------- suivi

    this.getSoumissions = function (annee, query) {
      return envoyer('GET', BASE + '/' + annee + '/soumissions', query);
    };

    /**
     * Les groupements à proposer au filtre du suivi.
     *
     * ⚠️ Ce ne sont pas ceux du CRM (`GroupementAdminService`) : ce sont ceux FIGÉS sur les
     * soumissions du millésime. C'est la même clé que le paramètre `groupement` du suivi, donc
     * aucune entrée ne rend une liste vide — et la route répond même CRM arrêté.
     */
    this.getGroupementsSuivi = function (annee) {
      return envoyer('GET', BASE + '/' + annee + '/groupements');
    };

    /** L'avancement de la campagne par groupement, à date (retours PHSQ, SP-149). */
    this.getParticipation = function (annee) {
      return envoyer('GET', BASE + '/' + annee + '/participation');
    };

    this.rouvrir = function (soumissionId, motif) {
      return envoyer('POST', BASE + '/soumission/' + soumissionId + '/rouvrir', null, { motif: motif });
    };

    this.getJournal = function (soumissionId) {
      return envoyer('GET', BASE + '/soumission/' + soumissionId + '/journal');
    };

    this.relancerOfficine = function (soumissionId) {
      return envoyer('POST', BASE + '/soumission/' + soumissionId + '/relancer');
    };

    /**
     * La fenêtre « Accès de l'officine » (21/10/2026) : comptes, e-mails de la campagne déjà
     * envoyés, et ce que permet un renvoi du lancement. La même que dans l'espace groupement.
     */
    this.getAcces = function (soumissionId) {
      return envoyer('GET', BASE + '/soumission/' + soumissionId + '/acces');
    };

    /** Renvoie l'e-mail de lancement ; un refus revient en 409 avec sa phrase. */
    this.renvoyerLancement = function (soumissionId) {
      return envoyer('POST', BASE + '/soumission/' + soumissionId + '/lancement');
    };

    this.relancerLot = function (annee, query) {
      return envoyer('POST', BASE + '/' + annee + '/relancer', query);
    };

    // ---------------------------------------------------------------- exports

    /**
     * LE RAPPORT DE SATISFACTION du millésime : le baromètre au format que PHSQ tenait à la main.
     *
     * ⚠️ Route d'ADMINISTRATION et non l'export du groupement : c'est le seul classeur qui sorte
     * le baromètre, et un réseau ne doit pas pouvoir le demander.
     */
    this.exporterSatisfaction = function (annee) {
      return telecharger(BASE + '/' + annee + '/export/satisfaction',
        'PHSQ_AE' + annee + '_Satisfaction_recla_verbatim.xlsx');
    };

    /**
     * L'EXPORT DES RÉPONSES : toute la cible en lignes, tout le questionnaire en colonnes, au
     * format du téléchargement que PHSQ tirait de Vocaza.
     *
     * ⚠️ Route d'ADMINISTRATION comme le rapport de satisfaction : le classeur porte le baromètre,
     * et un réseau ne doit pas pouvoir le demander.
     *
     * `filtres` : ceux du suivi — `groupement`, `statut`, `recherche` (recette, ligne 27). Vides,
     * c'est le classeur national.
     */
    this.exporterReponses = function (annee, filtres) {
      return telecharger(BASE + '/' + annee + '/export/reponses',
        'PHSQ_AE' + annee + '_Reponses.xlsx', filtres);
    };

    /**
     * LE RAPPORT DE SYNTHÈSE du millésime : une feuille PHSQ puis une feuille par groupement.
     *
     * ⚠️ Route d'ADMINISTRATION : elle seule rend le classeur complet, tous réseaux réunis.
     */
    this.exporterRapportSynthese = function (annee) {
      return telecharger(BASE + '/' + annee + '/export/rapport-synthese',
        'Autoevaluation_PHSQ_Synthese' + annee + '.xlsx');
    };

    /**
     * Téléchargement d'un flux binaire.
     *
     * ⚠️ `responseType: 'arraybuffer'` : sans lui, Angular décode le xlsx en UTF-8 et le classeur
     * arrive corrompu. Le nom vient du serveur (`Content-Disposition`) quand il le donne.
     */
    function telecharger(url, nomParDefaut, query) {
      return $q(function (resolve, reject) {
        $http({ url: url, method: 'GET', params: params(query), responseType: 'arraybuffer' })
          .then(function (response) {
            var type = (response.headers('Content-Type') || 'application/octet-stream').split(';')[0];
            var blob = new Blob([response.data], { type: type });
            var nom = nomFichier(response.headers('Content-Disposition')) || nomParDefaut;
            var objectUrl = $window.URL.createObjectURL(blob);
            var racine = $document[0];
            var lien = racine.createElement('a');
            lien.href = objectUrl;
            lien.download = nom;
            racine.body.appendChild(lien);
            lien.click();
            racine.body.removeChild(lien);
            $window.URL.revokeObjectURL(objectUrl);
            resolve(nom);
          }).catch(function (response) {
            reject(toError(response));
          });
      });
    }

    function nomFichier(disposition) {
      if (!disposition) {
        return null;
      }
      var utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
      if (utf8 && utf8[1]) {
        try {
          return decodeURIComponent(utf8[1]);
        } catch (error) {
          return utf8[1];
        }
      }
      var simple = /filename="?([^";]+)"?/i.exec(disposition);
      return simple && simple[1] ? simple[1] : null;
    }

    // ---------------------------------------------------------------- file de tâches

    this.getTaches = function (campagneId, statut) {
      return envoyer('GET', BASE + '/campagne/' + campagneId + '/taches', { statut: statut });
    };

    this.relancerTache = function (tacheId) {
      return envoyer('POST', BASE + '/tache/' + tacheId + '/relancer');
    };

    // ---------------------------------------------------------------- imports

    this.getImports = function (campagneId) {
      return envoyer('GET', BASE + '/campagne/' + campagneId + '/imports');
    };

    this.getImport = function (importId) {
      return envoyer('GET', BASE + '/import/' + importId);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminHistoryBandeauxController', AdminHistoryBandeauxController);

  function AdminHistoryBandeauxController($scope, $state, AdministrationBandeauService, $mdDialog) {
    $scope.bandeaux = [];

    if ($state.params && $state.params.type) {
      if ($state.params.type === 'lqo') {
        $scope.type = 'LQO';
        $scope.displayType = 'LQO';
      }
      if ($state.params.type === 'lqo_mini') {
        $scope.type = 'LQO_MINI';
        $scope.displayType = 'LQO découverte';
      }
      AdministrationBandeauService.getHistoryAdmin($state.params.type).then(function (data) {
        $scope.bandeaux = data;
      }).catch(function (err) {
        console.log(err);
      })
    }

    $scope.goAdministrationBandeau = function () {
      $state.go('admin.bandeau');
    }

    $scope.openDialogDelete = function (bandeau, index) {
      $scope.bandeauToDelete = bandeau;
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/delete_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDialogDisplay = function (bandeau) {
      $scope.bandeauToDisplay = bandeau;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/display_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.delete = function () {
      AdministrationBandeauService.deleteBandeau($scope.bandeauToDelete.id).then(function (res) {
        $scope.hidePopup();
        $scope.bandeaux.splice($scope.indexToDelete, 1);
      }).catch(function (err) {
        console.log(err);
      })
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }
  };
})();

(function () {
  'use strict';

  angular.module('app.admin')
    .service('AdministrationBandeauAdminService', AdministrationBandeauAdminService);

  function AdministrationBandeauAdminService($q, $http) {
    var URL_BANDEAU = "/api/rest/bandeauAccueil";

    var getCurrentsAdmin = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/admin",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getHistoryAdmin = function () {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/admin/history",
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var deleteBandeau = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU + "/delete/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    var save = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_BANDEAU,
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: dto
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    }

    return {
      deleteBandeau: deleteBandeau,
      save: save,
      getCurrentsAdmin: getCurrentsAdmin,
      getHistoryAdmin: getHistoryAdmin
    }
  };
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminBandeauController', AdminBandeauController);

  /** @ngInject */
  function AdminBandeauController($scope, $mdDialog, toastr, AdministrationBandeauAdminService, BANDEAU_DURATIONS, BANDEAU_CUSTOM_DURATIONS, $state, $filter) {
    $scope.durations = [];
    $scope.customDurations = [];
    $scope.bandeaux = [];
    $scope.contractTypes = [{
      id: 0,
      name: 'all',
      displayName: 'Toutes'
    },
    {
      id: 1,
      name: 'LQO',
      displayName: 'LQO'
    }, {
      id: 2,
      name: 'LQO_MINI',
      displayName: 'LQO découverte'
    }];
    $scope.convertType = {
      LQO: $scope.contractTypes[1].displayName,
      LQO_MINI: $scope.contractTypes[2].displayName
    }

    $scope.getCurrentsAdmin = function () {
      AdministrationBandeauAdminService.getCurrentsAdmin().then(function (data) {
        if (data != null) {
          $scope.bandeaux = data;
          $scope.bandeauxLQO = $filter('filter')(data, { contractType: 'LQO' }, true);
          $scope.bandeauxLQOMINI = $filter('filter')(data, { contractType: 'LQO_MINI' }, true);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
    $scope.getCurrentsAdmin();

    $scope.openDialogUpdate = function (bandeau, index) {
      $scope.newBandeau = angular.copy(bandeau);
      $scope.indexToUpdate = index;
      $scope.customDurationMode = true;
      $scope.titlePopupSave = "Modifier le message";
      $scope.updateMode = true;
      $scope.oldContract = bandeau.contractType;

      if ($scope.durations.length === 0) {
        $scope.durations = BANDEAU_DURATIONS;
      }

      if ($scope.customDurations.length === 0) {
        $scope.customDurations = BANDEAU_CUSTOM_DURATIONS;
      }

      $scope.customDuration = {
        number: null,
        ms: $scope.durations[0].value
      };

      for (var i = 0; i < $scope.durations.length; i++) {
        if ($scope.durations[i].value === $scope.newBandeau.duration) {
          $scope.customDurationMode = false;
        }
      }

      if ($scope.customDurationMode) {
        for (var i = 0; i < $scope.customDurations.length; i++) {
          if ($scope.newBandeau.duration % $scope.customDurations[$scope.customDurations.length - 1 - i].value === 0) {
            $scope.customDuration.number = $scope.newBandeau.duration / $scope.customDurations[$scope.customDurations.length - 1 - i].value;
            $scope.customDuration.ms = $scope.customDurations[$scope.customDurations.length - 1 - i].value;
            break;
          }
        }
      }

      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/add_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.openDialogDelete = function (bandeau, index) {
      $scope.bandeauToDelete = bandeau;
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/delete_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.delete = function () {
      AdministrationBandeauAdminService.deleteBandeau($scope.bandeauToDelete.id).then(function (res) {
        if ($scope.bandeauToDelete.contractType === 'LQO') {
          $scope.bandeauxLQO = $scope.bandeauxLQO.filter(function (bandeau) {
            return bandeau.id != $scope.bandeauToDelete.id;
          });
        }
        else if ($scope.bandeauToDelete.contractType === 'LQO_MINI') {
          $scope.bandeauxLQOMINI = $scope.bandeauxLQOMINI.filter(function (bandeau) {
            return bandeau.id != $scope.bandeauToDelete.id;
          });
        }
        $scope.bandeaux = $scope.bandeaux.filter(function (bandeau) {
          return bandeau.id != $scope.bandeauToDelete.id;
        });
        $scope.hidePopup();
      }).catch(function (err) {
        console.log(err);
      })
    }

    $scope.openDialogNew = function (preselectedContractType) {
      $scope.updateMode = false;
      $scope.newBandeau = {
        admin: true
      };
      if (preselectedContractType) {
        $scope.newBandeau.contractType = preselectedContractType;
      }
      $scope.titlePopupSave = "Ajouter un message";
      $scope.customDurationMode = false;

      if ($scope.durations.length === 0) {
        $scope.durations = BANDEAU_DURATIONS;
      }

      if ($scope.customDurations.length === 0) {
        $scope.customDurations = BANDEAU_CUSTOM_DURATIONS;
      }

      $scope.customDuration = {
        number: null,
        ms: $scope.durations[0].value
      };

      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/add_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }


    $scope.saveBandeau = function () {
      if ($scope.customDurationMode) {
        if (Math.sign($scope.customDuration.number) === 1) {
          $scope.newBandeau.duration = $scope.customDuration.number * $scope.customDuration.ms;
        } else {
          return;
        }
      }

      $scope.submitting = true;

      var LQO_LENGTH = $scope.bandeauxLQO.length;
      var LQO_MINI_LENGTH = $scope.bandeauxLQOMINI.length;

      //MAJ
      if ($scope.updateMode) {
        // TYPE NOT CHANGED
        if ($scope.newBandeau.contractType == $scope.oldContract) {
          saveBandeauServiceCall(angular.copy($scope.newBandeau));
        }
        // CONTRACT TYPE CHANGED
        else {
          // CHANGED TO ALL
          if ($scope.newBandeau.contractType === 'all') {
            if ('LQO' !== $scope.oldContract && LQO_LENGTH < 3) {
              filterSaveCallBandeau(false, false, true, 'LQO', false, true);
            }
            else if (LQO_LENGTH > 2 && 'LQO' !== $scope.oldContract) {
              filterSaveCallBandeau('LQO', true, false, false, true);
            }
            else {
              filterSaveCallBandeau(false, false, true, 'LQO');
            }

            if ('LQO_MINI' !== $scope.oldContract && LQO_MINI_LENGTH < 3) {
              filterSaveCallBandeau(false, false, true, 'LQO_MINI', false, true);
            }
            else if (LQO_MINI_LENGTH > 2 && 'LQO_MINI' !== $scope.oldContract) {
              filterSaveCallBandeau('LQO découverte', true, false, false, true);
            }
            else {
              filterSaveCallBandeau(false, false, true, 'LQO_MINI');
            }
          }
          // CHANGED TO LQO
          else if ($scope.newBandeau.contractType === 'LQO') {
            if (LQO_LENGTH > 2) {
              filterSaveCallBandeau('LQO', true, false, false, true);
            }
            else {
              filterSaveCallBandeau(false, false, true, 'LQO');
            }
          }
          // CHANGED TO LQO MINI
          else if ($scope.newBandeau.contractType === 'LQO_MINI') {
            if (LQO_MINI_LENGTH > 2) {
              filterSaveCallBandeau('LQO découverte', true, false, false, true);
            }
            else {
              filterSaveCallBandeau(false, false, true, 'LQO_MINI');
            }
          }
        }
      }
      else { // NEW BANDEAU
        if ($scope.newBandeau.contractType === 'all') {
          if (LQO_LENGTH > 2 && LQO_MINI_LENGTH > 2) {
            toastr.error("Vous ne pouvez pas créer plus de 3 bandeaux pour chaque type");
            $scope.submitting = false;
          }
          else if (LQO_LENGTH > 2 && LQO_MINI_LENGTH < 3) {
            filterSaveCallBandeau('LQO', false, true, 'LQO_MINI');
          }
          else if (LQO_MINI_LENGTH > 2 && LQO_LENGTH < 3) {
            filterSaveCallBandeau('LQO découverte', false, true, 'LQO');
          }
          else {
            filterSaveCallBandeau(false, false, true, 'LQO');
            filterSaveCallBandeau(false, false, true, 'LQO_MINI');
          }
        }
        else {
          if (LQO_MINI_LENGTH > 2 && $scope.newBandeau.contractType === 'LQO_MINI') {
            filterSaveCallBandeau('LQO découverte', true);
          }
          else if ((LQO_LENGTH > 2 && $scope.newBandeau.contractType === 'LQO')) {
            filterSaveCallBandeau('LQO', true);
          }
          else {
            saveBandeauServiceCall(angular.copy($scope.newBandeau));
          }
        }
      }
    }

    var filterSaveCallBandeau = function (typeMsg, activateButton, call, newType, update, reset) {
      if (update && typeMsg) {
        toastr.error("Vous avez atteint la limite pour les bandeaux " + typeMsg);
      }
      else if (typeMsg && !update) {
        toastr.error("Vous ne pouvez pas créer plus de 3 bandeaux " + typeMsg);
      }
      if (activateButton) {
        $scope.submitting = false;
      }
      if (newType) {
        $scope.newBandeau.contractType = newType;
      }
      if (call) {
        saveBandeauServiceCall(angular.copy($scope.newBandeau), reset);
      }
    }

    var saveBandeauServiceCall = function (bandeauToSave, reset) {
      if (reset) {
        delete bandeauToSave.id;
        delete bandeauToSave.dateDebut;
        delete bandeauToSave.dateFin;
        bandeauToSave.admin = true;
      }
      AdministrationBandeauAdminService.save(bandeauToSave).then(function (data) {
        // var LQO = $scope.bandeauxLQO;
        // var LQO_MINI = $scope.bandeauxLQOMINI;
        // var BAND = $scope.bandeaux;
        // if (!$scope.updateMode) {
        //   if(bandeauToSave.contractType === 'LQO'){
        //     $scope.bandeauxLQO.push(data);
        //     if($scope.oldContract !== 'LQO'){
        //       $scope.bandeauxLQOMINI = filterArrayByTypeAndDiffId(LQO_MINI, 'index');
        //     }
        //   }
        //   else{
        //     $scope.bandeauxLQOMINI.push(data);
        //     if($scope.oldContract !== 'LQO_MINI'){
        //       $scope.bandeauxLQO = filterArrayByTypeAndDiffId(LQO, 'index');
        //     }
        //   }
        //   $scope.bandeaux.push(data);
        // } 
        // else {
        //   if(bandeauToSave.contractType === 'LQO'){
        //     $scope.bandeauxLQO = filterArrayByTypeAndDiffId(LQO, 'index');
        //     $scope.bandeauxLQO = filterArrayByTypeAndDiffId(LQO, 'newBandeau');
        //     $scope.bandeauxLQO.push(data);
        //   }
        //   else{
        //     $scope.bandeauxLQOMINI = filterArrayByTypeAndDiffId(LQO_MINI, 'index');
        //     $scope.bandeauxLQOMINI = filterArrayByTypeAndDiffId(LQO_MINI, 'newBandeau');
        //     $scope.bandeauxLQOMINI.push(data);
        //   }
        //   $scope.bandeaux = filterArrayByTypeAndDiffId(BAND, 'index');
        //   $scope.bandeaux = filterArrayByTypeAndDiffId(BAND, 'newBandeau');
        //   $scope.bandeaux.push(data);
        // }
        $scope.getCurrentsAdmin();

        toastr.success("Le message " + $scope.convertType[bandeauToSave.contractType] + " a bien été " + ($scope.updateMode && !reset ? "modifié" : "crée"));
        $scope.submitting = false;

        $scope.hidePopup();
      }).catch(function () {
        $scope.submitting = false;
      });
    }

    var filterArrayByTypeAndDiffId = function (array, type) {
      if (type === 'index') {
        return array.filter(function (element) {
          return element.id != $scope.indexToUpdate;
        });
      }
      if (type === 'newBandeau') {
        return array.filter(function (element) {
          return element.id != $scope.newBandeau.id;
        });
      }
    }

    $scope.openDialogDisplay = function (bandeau) {
      $scope.bandeauToDisplay = bandeau;
      $mdDialog.show({
        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/popup/display_bandeau.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      });
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.setCustomDurationMode = function () {
      $scope.customDurationMode = !$scope.customDurationMode;
    }

    $scope.goHistory = function (contractType) {
      $state.go("admin.bandeau.history", { type: contractType });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .factory('AdministrateursService', AdministrateursService);

  /**
   * PHSQ-240 — API /rest/admin/administrateurs. Les refus métier portent {resultat} :
   * COURRIEL_DEJA_UTILISE, CHAMPS_INVALIDES, PROPRE_COMPTE, DERNIER_ADMINISTRATEUR,
   * PAS_UNE_INVITATION.
   *
   * @ngInject
   */
  function AdministrateursService($http, $q) {
    var BASE = '/api/rest/admin/administrateurs';

    function appel(methode, url, donnees) {
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: methode,
          params: { '_v': new Date().getTime() },
          headers: { 'Content-Type': 'application/json;charset=UTF-8' },
          data: donnees
        }).then(function (reponse) {
          resolve(reponse.data);
        }).catch(function (reponse) {
          reject({ status: reponse.status, resultat: reponse.data && reponse.data.resultat });
        });
      });
    }

    return {
      lister: function () { return appel('GET', BASE); },
      creer: function (saisie) { return appel('POST', BASE, saisie); },
      renvoyerInvitation: function (id) { return appel('POST', BASE + '/' + id + '/invitation'); },
      annulerInvitation: function (id) { return appel('DELETE', BASE + '/' + id + '/invitation'); },
      desactiver: function (id) { return appel('POST', BASE + '/' + id + '/desactiver'); },
      reactiver: function (id) { return appel('POST', BASE + '/' + id + '/reactiver'); }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdministrateursController', AdministrateursController);

  var MESSAGES = {
    COURRIEL_DEJA_UTILISE: 'Ce courriel est déjà utilisé par un compte LQO.',
    CHAMPS_INVALIDES: 'Prénom, nom et courriel valide sont obligatoires.',
    PROPRE_COMPTE: 'Vous ne pouvez pas désactiver votre propre compte.',
    DERNIER_ADMINISTRATEUR: 'Impossible de désactiver le dernier administrateur actif.',
    PAS_UNE_INVITATION: 'Ce compte n\'est plus une invitation en attente.'
  };

  /**
   * PHSQ-240 — écran « Administrateurs » (H7) : comptes nominatifs, double authentification,
   * invitations, désactivation. Tous les administrateurs ont les mêmes droits.
   *
   * @ngInject
   */
  function AdministrateursController($scope, $filter, $mdDialog, $window, toastr, AdministrateursService,
    ConfirmationGroupement, UserService) {
    $scope.chargement = true;
    $scope.administrateurs = [];

    var date = function (ms) { return ms ? $filter('date')(ms, 'dd/MM/yyyy') : ''; };
    var erreur = function (e) {
      toastr.error((e && MESSAGES[e.resultat]) || 'L\'opération n\'a pas abouti.');
    };

    var charger = function () {
      $scope.chargement = true;
      AdministrateursService.lister().then(function (liste) {
        $scope.administrateurs = liste;
      }).catch(erreur).finally(function () {
        $scope.chargement = false;
      });
    };
    charger();

    $scope.nomComplet = function (a) {
      var nom = ((a.prenom || '') + ' ' + (a.nom || '')).trim();
      return nom || a.mail;
    };
    $scope.libelleEtat = function (a) {
      switch (a.etat) {
        case 'ACTIF': return 'Actif';
        case 'INVITE': return 'Invité le ' + date(a.dateEtat);
        case 'INVITATION_EXPIREE': return 'Invitation expirée le ' + date(a.dateEtat);
        case 'DESACTIVE': return a.dateEtat ? 'Désactivé le ' + date(a.dateEtat) : 'Désactivé';
        default: return '';
      }
    };
    $scope.derniereConnexion = function (a) {
      return a.derniereConnexion ? $filter('date')(a.derniereConnexion, 'dd/MM/yyyy HH:mm') : '—';
    };
    $scope.estInvitation = function (a) {
      return a.etat === 'INVITE' || a.etat === 'INVITATION_EXPIREE';
    };

    $scope.ajouter = function ($event) {
      $mdDialog.show({
        templateUrl: 'app/main/admin/administrateurs/popup/ajout-administrateur.html',
        controller: AjoutAdministrateurController,
        targetEvent: $event,
        clickOutsideToClose: false
      }).then(function (cree) {
        toastr.success('Invitation envoyée à ' + cree.mail + '.');
        charger();
      }).catch(angular.noop); // fenêtre abandonnée : rien à faire
    };

    $scope.desactiver = function (a, $event) {
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: 'Désactiver ' + $scope.nomComplet(a) + ' ?',
        texte: 'Ce compte ne pourra plus se connecter à l\'administration ; ses sessions ouvertes sont fermées. Vous pourrez le réactiver.',
        confirmer: 'Désactiver',
        event: $event
      }).then(function () {
        return AdministrateursService.desactiver(a.id).then(function () {
          toastr.success('Compte désactivé.');
          charger();
        }).catch(erreur);
      }).catch(angular.noop); // fenêtre abandonnée : rien à faire
    };

    $scope.reactiver = function (a) {
      AdministrateursService.reactiver(a.id).then(function () {
        toastr.success('Compte réactivé.');
        charger();
      }).catch(erreur);
    };

    $scope.renvoyerInvitation = function (a) {
      AdministrateursService.renvoyerInvitation(a.id).then(function () {
        toastr.success('Nouvelle invitation envoyée à ' + a.mail + ' ; l\'ancien lien ne fonctionne plus.');
        charger();
      }).catch(erreur);
    };

    $scope.annulerInvitation = function (a, $event) {
      ConfirmationGroupement.demander({
        classe: 'osy-confirm',
        titre: 'Annuler l\'invitation de ' + $scope.nomComplet(a) + ' ?',
        texte: 'Le compte, jamais activé, est supprimé et le lien d\'invitation ne fonctionne plus.',
        confirmer: 'Annuler l\'invitation',
        annuler: 'Garder',
        event: $event
      }).then(function () {
        return AdministrateursService.annulerInvitation(a.id).then(function () {
          toastr.success('Invitation annulée.');
          charger();
        }).catch(erreur);
      }).catch(angular.noop); // fenêtre abandonnée : rien à faire
    };

    $scope.regenererCodes = function ($event) {
      $mdDialog.show({
        templateUrl: 'app/main/admin/administrateurs/popup/codes-secours.html',
        controller: CodesSecoursController,
        targetEvent: $event,
        clickOutsideToClose: false
      }).finally(charger).catch(angular.noop);
    };

    // Injection explicite : ces contrôleurs de fenêtre sont des fonctions internes.
    AjoutAdministrateurController.$inject = ['$scope', '$mdDialog'];
    CodesSecoursController.$inject = ['$scope', '$mdDialog'];

    function AjoutAdministrateurController($scope, $mdDialog) {
      $scope.saisie = { prenom: '', nom: '', mail: '' };
      $scope.envoi = false;
      $scope.erreur = '';
      $scope.annuler = function () {
        $mdDialog.cancel();
      };
      $scope.envoyer = function () {
        $scope.envoi = true;
        $scope.erreur = '';
        AdministrateursService.creer($scope.saisie).then(function (cree) {
          $mdDialog.hide(cree);
        }).catch(function (e) {
          $scope.erreur = (e && MESSAGES[e.resultat]) || 'L\'invitation n\'a pas pu être envoyée.';
        }).finally(function () {
          $scope.envoi = false;
        });
      };
    }

    function CodesSecoursController($scope, $mdDialog) {
      $scope.saisie = { code: '' };
      $scope.codes = null;
      $scope.erreur = '';
      $scope.envoi = false;
      $scope.fermer = function () {
        $mdDialog.hide();
      };
      $scope.envoyer = function () {
        var code = ($scope.saisie.code || '').replace(/\D/g, '');
        if (code.length !== 6) {
          return;
        }
        $scope.envoi = true;
        $scope.erreur = '';
        UserService.regenererCodesSecours(code).then(function (resultat) {
          $scope.codes = resultat.codesSecours;
        }).catch(function (e) {
          var r = (e && e.data) || {};
          if (r.resultat === 'CODE_INCORRECT') {
            $scope.erreur = 'Code incorrect : il vous reste ' + r.essaisRestants + (r.essaisRestants > 1 ? ' essais.' : ' essai.');
          } else if (r.resultat === 'BLOQUE') {
            $window.location.href = '/login';
          } else {
            $scope.erreur = 'Les codes n\'ont pas pu être régénérés.';
          }
        }).finally(function () {
          $scope.envoi = false;
        });
      };
      $scope.telecharger = function () {
        var contenu = 'Codes de secours — administration LQO\n'
          + 'Chaque code ne sert qu\'une fois. Gardez-les en lieu sûr.\n\n' + $scope.codes.join('\n') + '\n';
        var lien = $window.document.createElement('a');
        lien.href = $window.URL.createObjectURL(new Blob([contenu], { type: 'text/plain;charset=utf-8' }));
        lien.download = 'codes-secours-LQO.txt';
        $window.document.body.appendChild(lien);
        lien.click();
        $window.document.body.removeChild(lien);
      };
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'pascalprecht.translate',
            'ui.router'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;

        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function (ev, toState) {
                        // Close the sidenav
                        if (toState != null) {
                            sidenav.close();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            }
            else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            }
            else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // PHSQ-240 — `node.etatsActifs` ({classes: 'etat(params)'}, syntaxe objet de ui-sref-active) :
            // états sans entrée de menu propre (page d'un triage, fiche d'une officine…) qui ouvrent le
            // groupe et surlignent cette entrée, y compris après un rechargement de la page.
            var etatAssocie = function () {
                if (!angular.isObject(vm.node.etatsActifs)) {
                    return false;
                }
                return Object.keys(vm.node.etatsActifs).some(function (classes) {
                    var ref = vm.node.etatsActifs[classes];
                    var nom = ref.split('(')[0];
                    var params = ref.indexOf('(') > -1 ? $scope.$eval(ref.slice(ref.indexOf('(') + 1, ref.lastIndexOf(')'))) : undefined;
                    return $state.includes(nom, params);
                });
            };

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state) || etatAssocie()) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) && !$state.includes(vm.node.state)) {
                    return;
                }
                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || etatAssocie()) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ($state.includes(vm.node.state) || etatAssocie()) {
                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            }
            else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height': height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        // fix car enfants d'un menu n'apparaissait pas
                        'height': '1px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) && !$state.includes(vm.node.state)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
                else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        console.log("state changed");
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }
        
        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('fuse')
    .service('PublicService', PublicService);

  function PublicService($q, $http) {
    var URL_PUBLIC = "/api/public/unsecured"

    var getSharedMalfunction = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PUBLIC + "/malfunction/" + id,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };


    // Pièces d'un dysfonctionnement partagé : servies par le jeton de partage (PHSQ-240).
    var getDownloadLink = function (token) {
      return URL_PUBLIC + "/malfunction/" + encodeURIComponent(token) + "/download";
    };

    var getIsActivated = function (email) {
      return $q(function (resolve, reject) {
        $http({
          url: URL_PUBLIC + "/isActivated/" + email,
          method: "GET",
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        })
      })
    };

    var submitQuestionnaireSatisfaction = function (identifier, source, payload) {
      return $q(function (resolve, reject) {
        var params = {
          '_v': new Date().getTime()
        };
        if (source && source.trim().length > 0) {
          params.source = source;
        }

        $http({
          url: URL_PUBLIC + "/questionnaire-satisfaction-2026/" + encodeURIComponent(identifier),
          method: "POST",
          params: params,
          data: payload,
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var getQuestionnaireSatisfactionContext = function (identifier, source) {
      return $q(function (resolve, reject) {
        var params = {
          '_v': new Date().getTime()
        };
        if (source && source.trim().length > 0) {
          params.source = source;
        }
        $http({
          url: URL_PUBLIC + "/questionnaire-satisfaction-2026/" + encodeURIComponent(identifier) + "/context",
          method: "GET",
          params: params,
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      getSharedMalfunction: getSharedMalfunction,
      getIsActivated: getIsActivated,
      getDownloadLink: getDownloadLink,
      submitQuestionnaireSatisfaction: submitQuestionnaireSatisfaction,
      getQuestionnaireSatisfactionContext: getQuestionnaireSatisfactionContext
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.controller('UpdatePasswordController', UpdatePasswordController);

	/** @ngInject */
	function UpdatePasswordController($scope, $state, $location, toastr, UserService) {
    // Data
    $scope.buttonClicked = false;
    $scope.noRepeat = false;
		var key = $location.search().key;
    $scope.loginDTO = {};

    $scope.checkPasswordEquals = function() {
			if($scope.loginDTO.password != undefined && $scope.loginDTO.confirmPassword != undefined){
				if($scope.loginDTO.password === $scope.loginDTO.confirmPassword){
					$scope.noRepeat = false;
				}
				else $scope.noRepeat = true;
			}
			else $scope.noRepeat = false;
		}

		$scope.sendUpdatePassword = function () {
      if(!$scope.noRepeat){
        $scope.buttonClicked = true;
        UserService.updatePassword(key, $scope.loginDTO).then(function (response) {
          $scope.buttonClicked = true;
          $state.go("login");
          toastr.success('Mot de passe réinitialisé avec succès. Vous pouvez vous connecter.', {closeButton: true, timeOut: 0, extendedTimeOut: 0});
        }).catch(function (response) {
          if (response.status === 401) {
            toastr.error('Le lien pour changer le mot de passe est expiré, veuillez refaire une demande.', 'Lien expiré');
          }
          $scope.buttonClicked = false;
        })
      }
		};
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($rootScope, $scope, $state, $stateParams, $window, $timeout, $document, toastr, UserService, $mdDialog,
    AutoEvalService) {
    // Data
    $scope.loginError = false;
    $scope.loginErrorMessage = "";
    $scope.loginDTO = {
      usermail: '',
      password: '',
      checkedCgu: false
    };
    $scope.isFirstTime = false;
    $scope.isAdmin = false;
    //toastr.clear();

    if ($stateParams.successUpdatePwd) {
      toastr.success('Compte activé, vous pouvez vous connecter !', 'Activation réussie');
    }

    // ---------------------------------------------------------------------------------------
    // PHSQ-240 — double authentification des administrateurs : après le mot de passe, la page
    // passe à la saisie du code de l'application (H1) ou d'un code de secours (H8). Une première
    // connexion part sur la page d'activation (H2).
    // ---------------------------------------------------------------------------------------
    $scope.etape = 'identifiants';
    $scope.deuxFacteurs = { chiffres: ['', '', '', '', '', ''], secours: '', erreur: '', envoi: false };

    var deuxChiffres = function (n) { return (n < 10 ? '0' : '') + n; };
    var heureDe = function (ms) {
      var fin = new Date(ms);
      return deuxChiffres(fin.getHours()) + ':' + deuxChiffres(fin.getMinutes());
    };
    // Focus immédiat quand la case existe déjà (frappe rapide : la touche suivante doit tomber dans
    // la case suivante), différé sinon (changement d'étape : les cases ne sont pas encore affichées).
    var focaliserChiffre = function (index) {
      var focaliser = function () {
        var champ = $document[0].getElementById('lqo-2fa-chiffre-' + index);
        if (champ) {
          champ.focus();
          champ.select();
        }
        return !!champ;
      };
      if (!focaliser()) {
        $timeout(focaliser);
      }
    };
    var viderCode = function () {
      $scope.deuxFacteurs.chiffres = ['', '', '', '', '', ''];
      $scope.deuxFacteurs.secours = '';
      $scope.deuxFacteurs.envoi = false;
    };
    var revenirAuxIdentifiants = function (message) {
      viderCode();
      $scope.etape = 'identifiants';
      $scope.loginDTO.password = '';
      $scope.loginError = !!message;
      $scope.loginErrorMessage = message || '';
    };
    var allerAuCode = function () {
      viderCode();
      $scope.deuxFacteurs.erreur = '';
      $scope.etape = 'code';
      focaliserChiffre(0);
    };
    var allerAActivation = function () {
      $state.go('login2faActivation');
    };
    /**
     * PHSQ-240 (A16) — adresse du module mémorisée par `returnLogin` (index.run.js), lue une
     * seule fois. Revérifiée ici : seules les adresses du module sont suivies.
     */
    var lireRetourOsys = function () {
      try {
        var adresse = $window.sessionStorage.getItem('osys.retourApresConnexion');
        $window.sessionStorage.removeItem('osys.retourApresConnexion');
        return adresse && /^\/triage-osys\/((nouveau)|(triages\/\d+(\/fin)?))?$/.test(adresse) ? adresse : null;
      } catch (e) {
        return null;
      }
    };
    var connexionAdministrateurReussie = function (resultat) {
      if (resultat && angular.isNumber(resultat.codesSecoursRestants) && resultat.codesSecoursRestants <= 2) {
        try {
          $window.sessionStorage.setItem('lqo.codesSecoursRestants', String(resultat.codesSecoursRestants));
        } catch (e) {
          // stockage indisponible : l'alerte ne s'affichera pas, sans conséquence
        }
      }
      $window.location.href = '/admin/home';
    };
    var traiterRefus = function (erreur) {
      var r = (erreur && erreur.data) || {};
      $scope.deuxFacteurs.envoi = false;
      if (r.resultat === 'CODE_INCORRECT') {
        var n = r.essaisRestants;
        $scope.deuxFacteurs.erreur = 'Code incorrect : il vous reste ' + n + (n > 1 ? ' essais.' : ' essai.');
        viderCode();
        if ($scope.etape === 'code') {
          focaliserChiffre(0);
        }
      } else if (r.resultat === 'BLOQUE') {
        revenirAuxIdentifiants("Trop d'essais : réessayez à " + heureDe(r.bloqueJusqua) + '.');
      } else if (r.resultat === 'ACTIVATION_REQUISE') {
        allerAActivation();
      } else {
        revenirAuxIdentifiants('Votre session a expiré : reconnectez-vous.');
      }
    };

    $scope.chiffreSaisi = function (index) {
      var chiffres = $scope.deuxFacteurs.chiffres;
      var saisie = (chiffres[index] || '').replace(/\D/g, '');
      if (saisie.length > 2) {
        // Code rempli d'un coup (téléphone, gestionnaire de mots de passe) : réparti sur les cases.
        saisie.split('').forEach(function (chiffre, i) {
          if (index + i < 6) {
            chiffres[index + i] = chiffre;
          }
        });
      } else {
        // Un chiffre tapé dans une case déjà remplie la remplace.
        chiffres[index] = saisie.slice(-1);
      }
      var suivante = chiffres.indexOf('');
      if (suivante === -1) {
        $scope.envoyerCode();
      } else if (chiffres[index]) {
        focaliserChiffre(suivante > index ? suivante : index + 1);
      }
    };
    $scope.toucheChiffre = function (index, $event) {
      if ($event.keyCode === 8 && !$scope.deuxFacteurs.chiffres[index] && index > 0) {
        focaliserChiffre(index - 1);
      }
    };
    $scope.collerCode = function ($event) {
      var presse = ($event.originalEvent || $event).clipboardData;
      var texte = presse ? presse.getData('text') : '';
      var chiffres = (texte || '').replace(/\D/g, '');
      if (chiffres.length === 6) {
        $event.preventDefault();
        $scope.deuxFacteurs.chiffres = chiffres.split('');
        $scope.envoyerCode();
      }
    };
    $scope.envoyerCode = function () {
      var code = $scope.deuxFacteurs.chiffres.join('');
      if (code.length !== 6 || $scope.deuxFacteurs.envoi) {
        return;
      }
      $scope.deuxFacteurs.envoi = true;
      $scope.deuxFacteurs.erreur = '';
      UserService.verifierCodeDeuxFacteurs(code).then(connexionAdministrateurReussie).catch(traiterRefus);
    };
    $scope.utiliserCodeSecours = function () {
      viderCode();
      $scope.deuxFacteurs.erreur = '';
      $scope.etape = 'secours';
    };
    $scope.utiliserApplication = function () {
      allerAuCode();
    };
    $scope.envoyerCodeSecours = function () {
      if (!$scope.deuxFacteurs.secours || $scope.deuxFacteurs.envoi) {
        return;
      }
      $scope.deuxFacteurs.envoi = true;
      $scope.deuxFacteurs.erreur = '';
      UserService.verifierCodeSecours($scope.deuxFacteurs.secours).then(connexionAdministrateurReussie).catch(traiterRefus);
    };
    $scope.retourConnexion = function () {
      UserService.logout().finally(function () {
        revenirAuxIdentifiants('');
      });
    };

    // Rechargement de la page pendant l'attente du code : on reprend à la bonne étape.
    UserService.isConnected().then(function (response) {
      var attente = response && response.data && response.data.deuxFacteurs;
      if (attente === 'CODE') {
        allerAuCode();
      } else if (attente === 'ACTIVATION') {
        allerAActivation();
      }
    }).catch(function () {
      // pas de session : on reste sur les identifiants
    });

    $scope.checkedCgu = function () {
      if (!$scope.loginDTO.checkedCgu) {
        $scope.loginDTO.checkedCgu = false;
      }
    }

    // PHSQ-240 : après 5 mots de passe faux, le serveur refuse tout essai pendant 15 minutes
    // et renvoie l'heure de fin (bloqueJusqua, en ms).
    var messageIdentifiantsRefuses = function (data) {
      if (data && data.bloqueJusqua) {
        var fin = new Date(data.bloqueJusqua);
        var deuxChiffres = function (n) { return (n < 10 ? '0' : '') + n; };
        return "Trop d'essais : réessayez à " + deuxChiffres(fin.getHours()) + ':' + deuxChiffres(fin.getMinutes()) + '.';
      }
      return "Ces identifiants sont invalides";
    };

    $scope.check = function () {
      toastr.clear();
      $scope.loginError = false;
      $scope.loginErrorMessage = "";
      UserService.isActivated($scope.loginDTO).then(function (response) {
        if (response.isAdmin) {
          $scope.login();
          return;
        }
        if (response.isConnected) {
          if (response.isActivated) {
            if (response.isFirstTime) {
              $mdDialog.show({
                templateUrl: 'app/main/login/cgu_popup.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                scope: $scope,
                preserveScope: true
              })
            }
            else {
              $scope.login();
            }
          }
          else {
            $scope.loginError = true;
            $scope.loginErrorMessage = "Ce compte a été désactivé, merci de vous rapprocher de votre Responsable Qualité Groupement";
            if ($rootScope.user) {
              $rootScope.user.isConnected = false;
            }
          }
        } else {
          $scope.loginError = true;
          $scope.loginErrorMessage = messageIdentifiantsRefuses(response);
          if ($rootScope.user) {
            $rootScope.user.isConnected = false;
          }
        }
      }).catch(function (response) {
        $scope.loginError = true;
        $scope.loginErrorMessage = "Connexion impossible";
        if ($rootScope.user) {
          $rootScope.user.isConnected = false;
        }
      });
    };

    $scope.login = function () {
      UserService.login($scope.loginDTO).then(function (response) {
        // PHSQ-240 : un administrateur n'est connecté qu'après la double authentification ; rien
        // n'est chargé (utilisateur, menu) avant.
        if (response.data.deuxFacteurs === 'CODE') {
          allerAuCode();
          return;
        }
        if (response.data.deuxFacteurs === 'ACTIVATION') {
          allerAActivation();
          return;
        }
        $scope.$emit('getCurrentUser');
        $scope.$emit('refreshMenuItems');
        if (response.data.isSuspended) {
          $scope.loginError = true;
          $scope.loginErrorMessage = "Votre accès LQO a été suspendu";
        } else if (response.data.isConnected) {
          if ($rootScope.user) {
            $rootScope.user.isConnected = true;
          }

          var retourOsys = lireRetourOsys();
          if (response.data.isAdmin) {
            $window.location.href = '/admin/home';
            // $state.go('admin.home', {}, {reload: true});
          } else if (retourOsys && response.data.osysModule) {
            // PHSQ-240 (A16) : arrivée par le lien de l'e-mail du matin.
            $window.location.href = retourOsys;
          } else if (response.data.contratOsys && response.data.hasPharmacy) {
            $window.location.href = '/triage-osys/';
          } else if (response.data.isNonLqo) {
            AutoEvalService.ongletAccueilNonLqo().then(function (onglet) {
              $window.location.href = '/performances/mes-evaluations?tab=' + onglet;
            });
          } else if (response.data.isGroupement && !response.data.hasPharmacy) {
            // « Mes pharmacies » est la page d'arrivée de l'espace groupement (§1) : c'est le
            // parc du réseau, pas la restitution d'une campagne.
            $window.location.href = '/groupement/pharmacies';
          } else {
            $window.location.href = '/home';
            // $scope.$on('foldersReady', function () {
            //   $state.go('app.home');
            // });
            // $state.go('app.home', {}, {reload: true});
          }
        } else {
          $scope.loginError = true;
          $scope.loginErrorMessage = messageIdentifiantsRefuses(response.data);
          if ($rootScope.user) {
            $rootScope.user.isConnected = false;
          }
        }
      }).catch(function (response) {
        $scope.loginError = true;
        $scope.loginErrorMessage = "Ces identifiants sont invalides";
        if ($rootScope.user) {
          $rootScope.user.isConnected = false;
        }
      });
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.controller('ForgotPasswordController', ForgotPasswordController);

	/** @ngInject */
	function ForgotPasswordController($scope, $state, $location, toastr, UserService, PublicService) {
		// Data
		$scope.loginDTO = {};
		$scope.sendForgotPassword = function () {
			PublicService.getIsActivated($scope.loginDTO.email).then(function (response) {
				if (response == true) {
					$scope.buttonClicked = true;
					UserService.forgotPassword($scope.loginDTO.email).then(function (response) {
						$state.go("login");
						toastr.success('Veuillez consulter votre boîte de réception, un lien permettant de générer un nouveau mot de passe vous a été envoyé par e-mail.',
							{ closeButton: true, timeOut: 0, extendedTimeOut: 0 });
					}).catch(function (res) {

					});
				} else {
					toastr.error('Ce compte a été désactivé, merci de vous rapprocher de votre Responsable Qualité Groupement');
				}
			}).catch(function (res) {
				if (res.status === 404) {
					toastr.error('Ce mail ne correspond à aucun compte');
				}
			});

		};

		$scope.goToLogin = function () {
			toastr.clear();
			$state.go("login");
		};
	}
})();

(function () {
  'use strict';

  /**
   * PHSQ-240 — un appel refusé en 401 {"type":"DEUX_FACTEURS_REQUIS"} (session administrateur
   * qui n'a pas encore validé sa double authentification) renvoie vers la connexion, qui reprend
   * à la saisie du code. Les autres 401 gardent leur traitement habituel, appel par appel.
   */
  angular
    .module('fuse')
    .factory('deuxFacteursInterceptor', deuxFacteursInterceptor)
    .config(enregistrerInterceptor);

  /** @ngInject */
  function deuxFacteursInterceptor($q, $window) {
    return {
      responseError: function (rejet) {
        if (rejet && rejet.status === 401 && rejet.data && rejet.data.type === 'DEUX_FACTEURS_REQUIS'
          && $window.location.pathname !== '/login') {
          $window.location.href = '/login';
        }
        return $q.reject(rejet);
      }
    };
  }

  /** @ngInject */
  function enregistrerInterceptor($httpProvider) {
    $httpProvider.interceptors.push('deuxFacteursInterceptor');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('Activation2faController', Activation2faController);

  /**
   * PHSQ-240 — H2 : activation de la double authentification d'un administrateur, à sa première
   * connexion. L'administration reste fermée tant qu'elle n'est pas faite. Les 8 codes de secours
   * ne sont montrés qu'une fois, après la validation du premier code.
   *
   * @ngInject
   */
  function Activation2faController($scope, $window, $timeout, UserService) {
    $scope.chargement = true;
    $scope.enrolement = null;
    $scope.saisie = { code: '' };
    $scope.erreur = '';
    $scope.envoi = false;
    $scope.codesSecours = null;

    var deuxChiffres = function (n) { return (n < 10 ? '0' : '') + n; };
    var versConnexion = function () {
      $window.location.href = '/login';
    };

    UserService.enrolementDeuxFacteurs().then(function (enrolement) {
      $scope.enrolement = enrolement;
    }).catch(function () {
      // Session absente, expirée, ou double authentification déjà active : retour à la connexion.
      versConnexion();
    }).finally(function () {
      $scope.chargement = false;
    });

    $scope.activer = function () {
      var code = ($scope.saisie.code || '').replace(/\D/g, '');
      if (code.length !== 6 || $scope.envoi) {
        return;
      }
      $scope.envoi = true;
      $scope.erreur = '';
      UserService.activerDeuxFacteurs(code).then(function (resultat) {
        $scope.codesSecours = resultat.codesSecours;
      }).catch(function (erreur) {
        var r = (erreur && erreur.data) || {};
        if (r.resultat === 'CODE_INCORRECT') {
          $scope.erreur = 'Code incorrect : il vous reste ' + r.essaisRestants + (r.essaisRestants > 1 ? ' essais.' : ' essai.');
          $scope.saisie.code = '';
        } else if (r.resultat === 'BLOQUE') {
          var fin = new Date(r.bloqueJusqua);
          $scope.erreur = "Trop d'essais : réessayez à " + deuxChiffres(fin.getHours()) + ':' + deuxChiffres(fin.getMinutes())
            + '. Retour à la connexion…';
          $timeout(versConnexion, 4000);
        } else {
          versConnexion();
        }
      }).finally(function () {
        $scope.envoi = false;
      });
    };

    $scope.telechargerCodes = function () {
      var contenu = 'Codes de secours — administration LQO\n'
        + 'Chaque code ne sert qu\'une fois. Gardez-les en lieu sûr.\n\n'
        + $scope.codesSecours.join('\n') + '\n';
      var fichier = new Blob([contenu], { type: 'text/plain;charset=utf-8' });
      var lien = $window.document.createElement('a');
      lien.href = $window.URL.createObjectURL(fichier);
      lien.download = 'codes-secours-LQO.txt';
      $window.document.body.appendChild(lien);
      lien.click();
      $window.document.body.removeChild(lien);
    };

    $scope.terminer = function () {
      $window.location.href = '/admin/home';
    };

    $scope.seDeconnecter = function () {
      UserService.logout().finally(versConnexion);
    };
  }
})();

(function() {
	'use strict';

	angular
		.module('fuse')
		.controller('ActivateAccountController', ActivateAccountController);

	/** @ngInject */
	function ActivateAccountController($scope, $state, $location, toastr, UserService) {
		// Data
		var key = $location.search().key;
    $scope.passwordDTO = {};
    $scope.noRepeat = false;

		UserService.logout().then(function() {
			$scope.$emit("stopNotifs");
		}).catch(function() {

    });

		$scope.checkPasswordEquals = function() {
			if($scope.passwordDTO.password != undefined && $scope.passwordDTO.confirmPassword != undefined){
				if($scope.passwordDTO.password === $scope.passwordDTO.confirmPassword){
					$scope.noRepeat = false;
				}
				else $scope.noRepeat = true;
			}
			else $scope.noRepeat = false;
		}

		$scope.updatePassword = function() {
			if(!$scope.noRepeat){
				UserService.updatePassword(key, $scope.passwordDTO).then(function(response) {
					$state.go("login", { successUpdatePwd: true });
				}).catch(function(response) {
					if (response.status === 401) {
						toastr.error('Le lien pour créer un mot de passe est expiré, veuillez faire une demande d\'oubli de mot de passe.', 'Lien expiré');
					}
					if (response.status === 409) {
						console.log(response);
					}
				})
			}
		};
	}
})();

const Embed = Quill.import('blots/embed');


class MentionBlot extends Embed {
  static create(data) {
    const node = super.create();
    const denotationChar = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    denotationChar.textContent = data.denotationChar;
    node.appendChild(denotationChar);
    node.appendChild(document.createTextNode(data.value));
    return MentionBlot.setDataValues(node, data);
  }

  static setDataValues(element, data) {
    const domNode = element;
    Object.keys(data).forEach((key) => {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  }

  static value(domNode) {
    return domNode.dataset;
  }
}

MentionBlot.blotName = 'mention';
MentionBlot.tagName = 'span';
MentionBlot.className = 'mention';

Quill.register(MentionBlot);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            // Le HTML vient des posts et commentaires du cahier, saisis par n'importe quel compte de l'officine :
            // il doit être nettoyé avant d'être déclaré sûr, sinon un <img onerror> s'exécute chez chaque lecteur.
            // target est gardé : InformationDTO transforme les URL en liens target="_blank", qui sans lui
            // ouvriraient le site dans l'onglet de PHSQ.
            return $sce.trustAsHtml(DOMPurify.sanitize(value, { ADD_ATTR: ['target'] }));
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
  'use strict';

  var BREVO_COUNTRIES = [
    'al', 'dz', 'as', 'ad', 'ao', 'ai', 'ag', 'ar', 'am', 'aw', 'au', 'at', 'az',
    'bs', 'bh', 'bd', 'bb', 'by', 'be', 'bz', 'bj', 'bm', 'bt', 'bo', 'ba', 'bw', 'br', 'bn', 'bg', 'bf',
    'kh', 'cm', 'ca', 'ky', 'td', 'cl', 'cn', 'co', 'km', 'cd', 'ck', 'cr', 'hr', 'cy', 'cz',
    'dk', 'dj', 'dm', 'do', 'tl', 'ec', 'eg', 'sv', 'gq', 'ee', 'sz', 'et',
    'fo', 'fj', 'fi', 'fr', 'gf', 'pf',
    'ga', 'gm', 'ge', 'de', 'gh', 'gi', 'gr', 'gl', 'gd', 'gp', 'gu', 'gt', 'gw', 'gy',
    'ht', 'hn', 'hk', 'hu', 'is', 'in', 'id', 'ie', 'il', 'it', 'ci',
    'jm', 'jp', 'jo', 'ke', 'xk', 'kw', 'kg',
    'la', 'lv', 'lb', 'ls', 'lr', 'li', 'lt', 'lu',
    'mo', 'mk', 'mg', 'mw', 'my', 'mv', 'ml', 'mt', 'mq', 'mr', 'mu', 'yt', 're', 'mx', 'md', 'mc', 'mn', 'me', 'ms', 'ma', 'mz', 'mm',
    'na', 'nr', 'np', 'nl', 'nc', 'nz', 'ni', 'ne', 'ng', 'no',
    'om', 'pk', 'pw', 'ps', 'pa', 'pg', 'py', 'pe', 'ph', 'pl', 'pt', 'pr', 'qa',
    'ro', 'ru', 'rw', 'bl', 'kn', 'lc', 'pm', 'vc', 'ws', 'sm', 'sa', 'sn', 'rs', 'sc', 'sl', 'sk', 'si', 'za', 'kr', 'ss', 'es', 'lk', 'sr', 'se', 'ch',
    'tw', 'tj', 'tz', 'th', 'tg', 'to', 'tt', 'tn', 'tr', 'tm', 'tc',
    'ug', 'ua', 'ae', 'gb', 'us', 'uy', 'uz', 'vu', 'vn', 'vg', 'vi', 'wf', 'zm'
  ];

  angular
    .module('app.core')
    .directive('itiPhone', itiPhoneDirective);

  /** @ngInject */
  function itiPhoneDirective() {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: { initialCountry: '@' },
      link: function (scope, element, attrs, ngModel) {
        if (typeof window.intlTelInput !== 'function') {
          // Librairie pas chargée — on laisse l'input fonctionner en mode texte simple.
          return;
        }

        var iti = window.intlTelInput(element[0], {
          initialCountry: scope.initialCountry || 'fr',
          onlyCountries: BREVO_COUNTRIES,
          preferredCountries: ['fr', 'gp', 'mq', 'gf', 're', 'yt', 'pm', 'pf', 'nc', 'wf'],
          separateDialCode: false,
          nationalMode: true,
          autoPlaceholder: 'aggressive',
          placeholderNumberType: 'MOBILE',
          // Attache le dropdown au <body> pour échapper aux parents ayant overflow:hidden
          // (md-content, .layout-column.flex). Sinon la liste est rognée par la card SMS.
          dropdownContainer: document.body,
          utilsScript: 'bower_components/intl-tel-input/build/js/utils.js'
        });

        function sync() {
          var raw = (element[0].value || '').trim();
          if (raw.length === 0) {
            ngModel.$setValidity('phone', true);
            scope.$evalAsync(function () { ngModel.$setViewValue(null); });
            return;
          }
          if (iti.isValidNumber()) {
            ngModel.$setValidity('phone', true);
            scope.$evalAsync(function () { ngModel.$setViewValue(iti.getNumber()); });
          } else {
            ngModel.$setValidity('phone', false);
            scope.$evalAsync(function () { ngModel.$setViewValue(null); });
          }
        }

        element.on('input countrychange', sync);
        scope.$on('$destroy', function () { iti.destroy(); });
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
	'use strict';

	angular.module('fuse').service('UserService', UserService);

	function UserService($q, $http, msNavigationService, $rootScope, $window) {
		var USER_PERMISSIONS = null;
		var USER_CONNECTED = null;
		var USER_GROUPEMENTS = null;
		var SELECTED_GROUPEMENT_ID_KEY = 'phsq.selectedGroupementId';

		/**
		 * VUES DU COMPTE — un même utilisateur peut cumuler les casquettes : administrateur PHSQ,
		 * responsable/consultant d'un ou plusieurs groupements, et titulaire/équipe/PRAQ d'une
		 * officine. Chaque casquette a son propre menu et ses propres écrans, donc on ne peut pas
		 * les afficher ensemble : la « vue active » dit laquelle est portée à l'instant.
		 *
		 * C'est l'ÉTAT COURANT qui porte cette information (pas un drapeau à mémoriser) : les
		 * espaces vivent sous des préfixes d'états distincts, et l'URL reste ainsi partageable.
		 */
		var VUE_ADMINISTRATION = 'administration';
		var VUE_GROUPEMENT = 'groupement';
		var VUE_PHARMACIE = 'pharmacie';

		/**
		 * Les vues auxquelles ce compte a droit, dans l'ordre où on les propose — la première fait
		 * office de vue par défaut hors des espaces dédiés.
		 *
		 * `droits` accepte indifféremment le compte courant (`/rest/user`) ou la réponse
		 * `isConnected` : les deux portent les mêmes drapeaux.
		 */
		function getAvailableViews(droits) {
			var vues = [];
			if (!droits) {
				return vues;
			}
			if (droits.hasPharmacy) {
				vues.push(VUE_PHARMACIE);
			}
			if (droits.isGroupement) {
				vues.push(VUE_GROUPEMENT);
			}
			if (droits.isAdmin) {
				vues.push(VUE_ADMINISTRATION);
			}
			return vues;
		}

		function resolveActiveView(droits, stateName) {
			var vues = getAvailableViews(droits);
			var etat = stateName || '';
			if (etat.indexOf('admin.') === 0 && vues.indexOf(VUE_ADMINISTRATION) !== -1) {
				return VUE_ADMINISTRATION;
			}
			if (etat.indexOf('app.groupement.') === 0 && vues.indexOf(VUE_GROUPEMENT) !== -1) {
				return VUE_GROUPEMENT;
			}
			return vues.length ? vues[0] : VUE_PHARMACIE;
		}

		/**
		 * ⚠️ `id` PORTE DÉSORMAIS LE CODE DU GROUPEMENT DANS LE CRM.
		 *
		 * L'espace groupement ne s'appuie plus sur un référentiel local : LQO ne connaît que le
		 * code du groupement CRM et le niveau de l'utilisateur dessus. On garde volontairement la
		 * clé `id` pour que le sélecteur de la barre du haut, les restitutions et les nouveaux
		 * écrans continuent de parler la même langue — c'est ce code qui part en `groupementId`
		 * vers le back, qui l'attend maintenant sous cette forme.
		 *
		 * `niveau` accompagne le groupement : les écrans en déduisent s'ils affichent les actions
		 * d'écriture (modifier les coordonnées, déposer un document), réservées au responsable.
		 */
		function normalizeGroupements(groupements) {
			var normalized = [];
			angular.forEach(groupements || [], function (groupement) {
				var code = groupement ? Number(groupement.codeCrm || groupement.id) : NaN;
				if (!isFinite(code) || code <= 0) {
					return;
				}
				var acces = (groupement.acces || [])[0] || {};
				normalized.push({
					id: code,
					name: groupement.name || '',
					niveau: acces.niveau || null,
					isResponsable: acces.niveau === 'RESPONSABLE'
				});
			});
			return normalized.sort(function (left, right) {
				return (left.name || '').toLowerCase().localeCompare((right.name || '').toLowerCase());
			});
		}

		function syncConnectedResponse(response) {
			USER_CONNECTED = response;
			if (response && response.data && angular.isArray(response.data.groupements)) {
				USER_GROUPEMENTS = normalizeGroupements(response.data.groupements);
			}
		}

		function clearSelectedGroupementId() {
			try {
				$window.sessionStorage.removeItem(SELECTED_GROUPEMENT_ID_KEY);
			} catch (error) {
			}
		}

		function getSelectedGroupementId() {
			try {
				var rawValue = $window.sessionStorage.getItem(SELECTED_GROUPEMENT_ID_KEY);
				var selectedId = Number(rawValue);
				return isFinite(selectedId) && selectedId > 0 ? selectedId : null;
			} catch (error) {
				return null;
			}
		}

		function setSelectedGroupementId(groupementId) {
			var selectedId = Number(groupementId);
			try {
				if (isFinite(selectedId) && selectedId > 0) {
					$window.sessionStorage.setItem(SELECTED_GROUPEMENT_ID_KEY, String(selectedId));
				} else {
					clearSelectedGroupementId();
					selectedId = null;
				}
			} catch (error) {
			}
			$rootScope.$broadcast('groupementContextChanged', { groupementId: selectedId || null });
			return selectedId || null;
		}

		function getMyGroupements(forceRefresh) {
			return $q(function (resolve, reject) {
				if (!forceRefresh && USER_GROUPEMENTS !== null) {
					resolve(USER_GROUPEMENTS);
					return;
				}
				$http({
					url: '/api/rest/groupement/mine',
					method: 'GET',
					params: { '_v': new Date().getTime() },
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					var payload = response.data || {};
					USER_GROUPEMENTS = normalizeGroupements(payload.groupements || payload);
					resolve(USER_GROUPEMENTS);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		var getUserRoles = function () {
			return $q(function (resolve, reject) {
				if (USER_PERMISSIONS == null) {
					$http({
						url: "/api/rest/permissions/find",
						method: "GET",
						params: { '_v': new Date().getTime() },
						headers: { "Content-Type": "application/json;charset=UTF-8" }
					}).then(function (response) {
						USER_PERMISSIONS = response;
						resolve(USER_PERMISSIONS);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_PERMISSIONS);
				}
			});
		};

		var checkPermission = function (permissionsTOcheck) {
			var _found = false;
			var self = this;
			return $q(function (resolve, reject) {
				self.getUserRoles().then(function (response) {
					angular.forEach(permissionsTOcheck, function (item, _index) {
						if (response.data.indexOf(item) > -1) {
							_found = true;
							return;
						}
					});
					resolve(_found);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var isConnected = function () {
			return $q(function (resolve, reject) {
				if (USER_CONNECTED == null) {
					$http({
						url: "/api/public/unsecured/isConnected",
						method: "GET",
						params: { '_v': new Date().getTime() },
						headers: { "Content-Type": "application/json;charset=UTF-8" }
					}).then(function (response) {
						syncConnectedResponse(response);
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_CONNECTED);
				}
			});
		};

		var login = function (loginDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/login',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'rememberMe': true },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: loginDTO
				}).then(function (response) {
					clearSelectedGroupementId();
					syncConnectedResponse(response);
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var logout = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/logout',
					method: 'GET',
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					USER_CONNECTED = null;
					USER_PERMISSIONS = null;
					USER_GROUPEMENTS = null;
					clearSelectedGroupementId();
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getCurrent = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'GET',
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					if (response.data) {
						if (USER_GROUPEMENTS !== null) {
							response.data.groupements = USER_GROUPEMENTS;
						}
						$rootScope.user = response.data;
						$rootScope.$broadcast('rooScopeUser:ready');
					}
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getAccounts = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/accounts',
					method: 'GET',
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// update password after forgot password
		var updatePassword = function (token, passwordDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/updatePassword',
					method: 'PUT',
					params: { '_v': new Date().getTime() },
					// Le mot de passe passe dans le corps, jamais dans l'URL (PHSQ-240).
					data: { key: token, password: passwordDTO.password },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateAccount = function (accountDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/account',
					method: 'PUT',
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: accountDTO
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var forgotPassword = function (email) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/forgotPassword',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'email': email },
					headers: { "Content-Type": "application/json;charset=UTF-8" }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// PHSQ-240 — double authentification des administrateurs. Les réponses d'erreur portent
		// {resultat, essaisRestants, bloqueJusqua} : on les rend telles quelles à l'appelant.
		var appelDeuxFacteurs = function (methode, url, donnees) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: methode,
					params: { '_v': new Date().getTime() },
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: donnees
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject({ status: response.status, data: response.data || {} });
				});
			});
		};

		var verifierCodeDeuxFacteurs = function (code) {
			return appelDeuxFacteurs('POST', '/api/public/unsecured/2fa/verifier', { code: code });
		};

		var verifierCodeSecours = function (code) {
			return appelDeuxFacteurs('POST', '/api/public/unsecured/2fa/secours', { code: code });
		};

		var enrolementDeuxFacteurs = function () {
			return appelDeuxFacteurs('GET', '/api/rest/admin/2fa/enrolement');
		};

		var activerDeuxFacteurs = function (code) {
			return appelDeuxFacteurs('POST', '/api/rest/admin/2fa/activer', { code: code });
		};

		var regenererCodesSecours = function (code) {
			return appelDeuxFacteurs('POST', '/api/rest/admin/2fa/codes-secours/regenerer', { code: code });
		};

		var isActivated = function (loginDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/isActivated',
					method: "POST",
					params: {
						'_v': new Date().getTime(),
					},
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: loginDTO
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (response) {
					reject(response);
				})
			})
		}
		var deleteAccount = function (account) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/accountDelete',
					method: "POST",
					params: {
						'_v': new Date().getTime(),
					},
					headers: { "Content-Type": "application/json;charset=UTF-8" },
					data: account
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				})
			})
		}

		var getNotifs = function () {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/user/notifs",
					method: "GET",
					params: { '_v': new Date().getTime() }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		var checkTimezone = function (timezone) {
			return $q(function (resolve, reject) {
				$http({
					url: "/api/rest/user/timezone",
					method: "GET",
					params: { '_v': new Date().getTime(), timezone: timezone }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		return {
			VUE_ADMINISTRATION: VUE_ADMINISTRATION,
			VUE_GROUPEMENT: VUE_GROUPEMENT,
			VUE_PHARMACIE: VUE_PHARMACIE,
			getAvailableViews: getAvailableViews,
			resolveActiveView: resolveActiveView,
			getUserRoles: getUserRoles,
			checkPermission: checkPermission,
			isConnected: isConnected,
			login: login,
			logout: logout,
			getCurrent: getCurrent,
			getAccounts: getAccounts,
			updatePassword: updatePassword,
			verifierCodeDeuxFacteurs: verifierCodeDeuxFacteurs,
			verifierCodeSecours: verifierCodeSecours,
			enrolementDeuxFacteurs: enrolementDeuxFacteurs,
			activerDeuxFacteurs: activerDeuxFacteurs,
			regenererCodesSecours: regenererCodesSecours,
			updateAccount: updateAccount,
			forgotPassword: forgotPassword,
			isActivated: isActivated,
			deleteAccount: deleteAccount,
			getNotifs: getNotifs,
			checkTimezone: checkTimezone,
			getMyGroupements: getMyGroupements,
			getSelectedGroupementId: getSelectedGroupementId,
			setSelectedGroupementId: setSelectedGroupementId,
			clearSelectedGroupementId: clearSelectedGroupementId
		}
	}
})();

'use strict';

// Angular scroll events module
angular.module('g1b.scroll-events', [])

  // scroll-up directive
  .directive('scrollUp', function () {
    return {
      restrict: 'A',
      compile: function () {
        return {
          pre: function preLink() {},
          post: function postLink(scope, element, attrs) {
            element.bind('mousewheel wheel', function (ev) {
              ev = ev.originalEvent || ev;
              var delta = ev.wheelDelta || (ev.deltaY * -1) || 0;
              if ( delta > 0 ) {
                scope.$apply(function () {
                  scope.$eval(attrs.scrollUp);
                });
                ev.preventDefault();
              }
            });
          }
        };
      }
    };
  })

  // scroll-down directive
  .directive('scrollDown', function () {
    return {
      restrict: 'A',
      compile: function () {
        return {
          pre: function preLink() {},
          post: function postLink(scope, element, attrs) {
            element.bind('mousewheel wheel', function (ev) {
              ev = ev.originalEvent || ev;
              var delta = ev.wheelDelta || (ev.deltaY * -1) || 0;
              if ( delta < 0 ) {
                scope.$apply(function () {
                  scope.$eval(attrs.scrollDown);
                });
                ev.preventDefault();
              }
            });
          }
        };
      }
    };
  });

var numberIsNaN = function (x) {
  return x !== x;
};

var Keys = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  UP: 38,
  DOWN: 40,
};

class Mention {
  constructor(quill, options) {
    this.isOpen = false;
    this.itemIndex = 0;
    this.mentionCharPos = null;
    this.cursorPos = null;
    this.values = [];
    this.suspendMouseEnter = false;

    this.quill = quill;

    this.options = {
      source: null,
      renderItem(item, searchTerm) {
        return `${item.value}`;
      },
      onSelect(item, insertItem) {
        insertItem(item);
      },
      mentionDenotationChars: ['@'],
      showDenotationChar: true,
      allowedChars: /^[a-zA-Z0-9_]*$/,
      minChars: 0,
      maxChars: 31,
      offsetTop: 2,
      offsetLeft: 0,
      isolateCharacter: false,
      fixMentionsToQuill: false,
      defaultMenuOrientation: 'top',
      dataAttributes: ['id', 'value', 'denotationChar', 'link', 'target'],
      linkTarget: '_blank',
      onOpen() {
        return true;
      },
      onClose() {
        return true;
      },
      // Style options
      listItemClass: 'ql-mention-list-item',
      mentionContainerClass: 'ql-mention-list-container',
      mentionListClass: 'ql-mention-list',
      spaceAfterInsert: true,
    };

    Object.assign(this.options, options, {
      dataAttributes: Array.isArray(options.dataAttributes)
        ? this.options.dataAttributes.concat(options.dataAttributes)
        : this.options.dataAttributes,
    });

    this.mentionContainer = document.createElement('div');
    this.mentionContainer.className = this.options.mentionContainerClass ? this.options.mentionContainerClass : '';
    this.mentionContainer.style.cssText = 'display: none; position: absolute;';
    this.mentionContainer.onmousemove = this.onContainerMouseMove.bind(this);

    if (this.options.fixMentionsToQuill) {
      this.mentionContainer.style.width = 'auto';
    }

    this.mentionList = document.createElement('ul');
    this.mentionList.className = this.options.mentionListClass ? this.options.mentionListClass : '';
    this.mentionContainer.appendChild(this.mentionList);

    this.quill.container.appendChild(this.mentionContainer);

    quill.on('text-change', this.onTextChange.bind(this));
    quill.on('selection-change', this.onSelectionChange.bind(this));

    quill.keyboard.addBinding({
      key: Keys.TAB,
    }, this.selectHandler.bind(this));
    quill.keyboard.bindings[9].unshift(quill.keyboard.bindings[9].pop());

    quill.keyboard.addBinding({
      key: Keys.ENTER,
    }, this.selectHandler.bind(this));
    quill.keyboard.bindings[13].unshift(quill.keyboard.bindings[13].pop());

    quill.keyboard.addBinding({
      key: Keys.ESCAPE,
    }, this.escapeHandler.bind(this));

    quill.keyboard.addBinding({
      key: Keys.UP,
    }, this.upHandler.bind(this));

    quill.keyboard.addBinding({
      key: Keys.DOWN,
    }, this.downHandler.bind(this));
  }

  selectHandler() {
    if (this.isOpen) {
      this.selectItem();
      return false;
    }
    return true;
  }

  escapeHandler() {
    if (this.isOpen) {
      this.hideMentionList();
      return false;
    }
    return true;
  }

  upHandler() {
    if (this.isOpen) {
      this.prevItem();
      return false;
    }
    return true;
  }

  downHandler() {
    if (this.isOpen) {
      this.nextItem();
      return false;
    }
    return true;
  }

  showMentionList() {
    this.mentionContainer.style.visibility = 'hidden';
    this.mentionContainer.style.display = '';
    this.setMentionContainerPosition();
    this.setIsOpen(true);
  }

  hideMentionList() {
    this.mentionContainer.style.display = 'none';
    this.setIsOpen(false);
  }

  highlightItem(scrollItemInView = true) {
    for (let i = 0; i < this.mentionList.childNodes.length; i += 1) {
      this.mentionList.childNodes[i].classList.remove('selected');
    }
    this.mentionList.childNodes[this.itemIndex].classList.add('selected');

    if (scrollItemInView) {
      const itemHeight = this.mentionList.childNodes[this.itemIndex].offsetHeight;
      const itemPos = this.itemIndex * itemHeight;
      const containerTop = this.mentionContainer.scrollTop;
      const containerBottom = containerTop + this.mentionContainer.offsetHeight;

      if (itemPos < containerTop) {
        // Scroll up if the item is above the top of the container
        this.mentionContainer.scrollTop = itemPos;
      } else if (itemPos > (containerBottom - itemHeight)) {
        // scroll down if any part of the element is below the bottom of the container
        this.mentionContainer.scrollTop += (itemPos - containerBottom) + itemHeight;
      }
    }
  }

  getItemData() {
    const { link } = this.mentionList.childNodes[this.itemIndex].dataset;
    const hasLinkValue = typeof link !== 'undefined';
    const itemTarget = this.mentionList.childNodes[this.itemIndex].dataset.target;
    if (hasLinkValue) {
      this.mentionList.childNodes[this.itemIndex].dataset.value = `<a href="${link}" target=${itemTarget || this.options.linkTarget}>${this.mentionList.childNodes[this.itemIndex].dataset.value}`;
    }
    return this.mentionList.childNodes[this.itemIndex].dataset;
  }

  onContainerMouseMove() {
    this.suspendMouseEnter = false;
  }

  selectItem() {
    const data = this.getItemData();
    this.options.onSelect(data, (asyncData) => {
      this.insertItem(asyncData);
    });
    this.hideMentionList();
  }

  insertItem(data) {
    const render = data;
    if (render === null) {
      return;
    }
    if (!this.options.showDenotationChar) {
      render.denotationChar = '';
    }

    const prevMentionCharPos = this.mentionCharPos;

    this.quill
      .deleteText(this.mentionCharPos, this.cursorPos - this.mentionCharPos, Quill.sources.USER);
    this.quill.insertEmbed(prevMentionCharPos, 'mention', render, Quill.sources.USER);
    if (this.options.spaceAfterInsert) {
      this.quill.insertText(prevMentionCharPos + 1, ' ', Quill.sources.USER);
      // setSelection here sets cursor position
      this.quill.setSelection(prevMentionCharPos + 2, Quill.sources.USER);
    } else {
      this.quill.setSelection(prevMentionCharPos + 1, Quill.sources.USER);
    }
    this.hideMentionList();
  }

  onItemMouseEnter(e) {
    if (this.suspendMouseEnter) {
      return;
    }

    const index = Number(e.target.dataset.index);

    if (!numberIsNaN(index) && index !== this.itemIndex) {
      this.itemIndex = index;
      this.highlightItem(false);
    }
  }

  onItemClick(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    this.itemIndex = e.currentTarget.dataset.index;
    this.highlightItem();
    this.selectItem();
  }

  attachDataValues(element, data) {
    const mention = element;
    Object.keys(data).forEach((key) => {
      if (this.options.dataAttributes.indexOf(key) > -1) {
        mention.dataset[key] = data[key];
      } else {
        delete mention.dataset[key];
      }
    });
    return mention;
  }

  renderList(mentionChar, data, searchTerm) {
    if (data && data.length > 0) {
      this.values = data;
      this.mentionList.innerHTML = '';

      for (let i = 0; i < data.length; i += 1) {
        const li = document.createElement('li');
        li.className = this.options.listItemClass ? this.options.listItemClass : '';
        li.dataset.index = i;
        li.textContent = this.options.renderItem(data[i], searchTerm);
        li.onmouseenter = this.onItemMouseEnter.bind(this);
        li.dataset.denotationChar = mentionChar;
        li.onclick = this.onItemClick.bind(this);
        this.mentionList.appendChild(this.attachDataValues(li, data[i]));
      }
      this.itemIndex = 0;
      this.highlightItem();
      this.showMentionList();
    } else {
      this.hideMentionList();
    }
  }

  nextItem() {
    this.itemIndex = (this.itemIndex + 1) % this.values.length;
    this.suspendMouseEnter = true;
    this.highlightItem();
  }

  prevItem() {
    this.itemIndex = ((this.itemIndex + this.values.length) - 1) % this.values.length;
    this.suspendMouseEnter = true;
    this.highlightItem();
  }

  hasValidChars(s) {
    return this.options.allowedChars.test(s);
  }

  containerBottomIsNotVisible(topPos, containerPos) {
    const mentionContainerBottom = topPos + this.mentionContainer.offsetHeight + containerPos.top;
    return mentionContainerBottom > window.pageYOffset + window.innerHeight;
  }

  containerRightIsNotVisible(leftPos, containerPos) {
    if (this.options.fixMentionsToQuill) {
      return false;
    }

    const rightPos = leftPos + this.mentionContainer.offsetWidth + containerPos.left;
    const browserWidth = window.pageXOffset + document.documentElement.clientWidth;
    return rightPos > browserWidth;
  }

  setIsOpen(isOpen) {
    if (this.isOpen !== isOpen) {
      if (isOpen) {
        this.options.onOpen();
      } else {
        this.options.onClose();
      }
      this.isOpen = isOpen;
    }
  }

  setMentionContainerPosition() {
    const containerPos = this.quill.container.getBoundingClientRect();
    const mentionCharPos = this.quill.getBounds(this.mentionCharPos);
    const containerHeight = this.mentionContainer.offsetHeight;

    let topPos = this.options.offsetTop;
    let leftPos = this.options.offsetLeft;

    // handle horizontal positioning
    if (this.options.fixMentionsToQuill) {
      const rightPos = 0;
      this.mentionContainer.style.right = `${rightPos}px`;
    } else {
      leftPos += mentionCharPos.left;
    }

    if (this.containerRightIsNotVisible(leftPos, containerPos)) {
      const containerWidth = this.mentionContainer.offsetWidth + this.options.offsetLeft;
      const quillWidth = containerPos.width;
      leftPos = quillWidth - containerWidth;
    }

    // handle vertical positioning
    if (this.options.defaultMenuOrientation === 'top') {
      // Attempt to align the mention container with the top of the quill editor
      if (this.options.fixMentionsToQuill) {
        topPos = -1 * (containerHeight + this.options.offsetTop);
      } else {
        topPos = mentionCharPos.top - (containerHeight + this.options.offsetTop);
      }

      // default to bottom if the top is not visible
      if (topPos + containerPos.top <= 0) {
        let overMentionCharPos = this.options.offsetTop;

        if (this.options.fixMentionsToQuill) {
          overMentionCharPos += containerPos.height;
        } else {
          overMentionCharPos += mentionCharPos.bottom;
        }

        topPos = overMentionCharPos;
      }
    } else {
      // Attempt to align the mention container with the bottom of the quill editor
      if (this.options.fixMentionsToQuill) {
        topPos += containerPos.height;
      } else {
        topPos += mentionCharPos.bottom;
      }

      // default to the top if the bottom is not visible
      if (this.containerBottomIsNotVisible(topPos, containerPos)) {
        let overMentionCharPos = this.options.offsetTop * -1;

        if (!this.options.fixMentionsToQuill) {
          overMentionCharPos += mentionCharPos.top;
        }

        topPos = overMentionCharPos - containerHeight;
      }
    }

    if (topPos >= 0) {
      this.mentionContainer.classList.add(`${this.options.mentionContainerClass}-bottom`);
      this.mentionContainer.classList.remove(`${this.options.mentionContainerClass}-top`);
    } else {
      this.mentionContainer.classList.add(`${this.options.mentionContainerClass}-top`);
      this.mentionContainer.classList.remove(`${this.options.mentionContainerClass}-bottom`);
    }

    this.mentionContainer.style.top = `${topPos}px`;
    this.mentionContainer.style.left = `${leftPos}px`;

    this.mentionContainer.style.visibility = 'visible';
  }

  onSomethingChange() {
    const range = this.quill.getSelection();
    if (range == null) return;
    this.cursorPos = range.index;
    const startPos = Math.max(0, this.cursorPos - this.options.maxChars);
    const beforeCursorPos = this.quill.getText(startPos, this.cursorPos - startPos);
    const mentionCharIndex = this.options.mentionDenotationChars.reduce((prev, cur) => {
      const previousIndex = prev;
      const mentionIndex = beforeCursorPos.lastIndexOf(cur);

      return mentionIndex > previousIndex ? mentionIndex : previousIndex;
    }, -1);
    if (mentionCharIndex > -1) {
      if (this.options.isolateCharacter && !(mentionCharIndex === 0 || !!beforeCursorPos[mentionCharIndex - 1].match(/\s/g))) {
        this.hideMentionList();
        return;
      }
      const mentionCharPos = this.cursorPos - (beforeCursorPos.length - mentionCharIndex);
      this.mentionCharPos = mentionCharPos;
      const textAfter = beforeCursorPos.substring(mentionCharIndex + 1);
      if (textAfter.length >= this.options.minChars && this.hasValidChars(textAfter)) {
        const mentionChar = beforeCursorPos[mentionCharIndex];
        this.options.source(textAfter, this.renderList.bind(this, mentionChar), mentionChar);
      } else {
        this.hideMentionList();
      }
    } else {
      this.hideMentionList();
    }
  }

  onTextChange(delta, oldDelta, source) {
    if (source === 'user') {
      this.onSomethingChange();
    }
  }

  onSelectionChange(range) {
    if (range && range.length === 0) {
      this.onSomethingChange();
    } else {
      this.hideMentionList();
    }
  }
}

Quill.register('modules/mention', Mention);

/*! @license DOMPurify 3.4.16 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.16/LICENSE */
(function(e,t){typeof exports==`object`&&typeof module<`u`?module.exports=t():typeof define==`function`&&define.amd?define([],t):(e=typeof globalThis<`u`?globalThis:e||self,e.DOMPurify=t())})(this,function(){"use strict";function e(e,t){this.v=e,this.k=t}function t(e,t){(t==null||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}function n(e){if(Array.isArray(e))return e}function r(e,t){var n=e==null?null:typeof Symbol<`u`&&e[Symbol.iterator]||e[`@@iterator`];if(n!=null){var r,i,a,o,s=[],c=!0,l=!1;try{if(a=(n=n.call(e)).next,t===0){if(Object(n)!==n)return;c=!1}else for(;!(c=(r=a.call(n)).done)&&(s.push(r.value),s.length!==t);c=!0);}catch(e){l=!0,i=e}finally{try{if(!c&&n.return!=null&&(o=n.return(),Object(o)!==o))return}finally{if(l)throw i}}return s}}function i(){throw TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)}
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
function a(e,t){return n(e)||r(e,t)||o(e,t)||i()}function o(e,n){if(e){if(typeof e==`string`)return t(e,n);var r={}.toString.call(e).slice(8,-1);return r===`Object`&&e.constructor&&(r=e.constructor.name),r===`Map`||r===`Set`?Array.from(e):r===`Arguments`||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?t(e,n):void 0}}function s(t){var n,r;function i(n,r){try{var o=t[n](r),s=o.value,c=s instanceof e;Promise.resolve(c?s.v:s).then(function(e){if(c){var r=n===`return`&&s.k?n:`next`;if(!s.k||e.done)return i(r,e);e=t[r](e).value}a(!!o.done,e)},function(e){i(`throw`,e)})}catch(e){a(2,e)}}function a(e,t){e===2?n.reject(t):n.resolve({value:t,done:e}),(n=n.next)?i(n.key,n.arg):r=null}this._invoke=function(e,t){return new Promise(function(a,o){var s={key:e,arg:t,resolve:a,reject:o,next:null};r?r=r.next=s:(n=r=s,i(e,t))})},typeof t.return!=`function`&&(this.return=void 0)}s.prototype[typeof Symbol==`function`&&Symbol.asyncIterator||`@@asyncIterator`]=function(){return this},s.prototype.next=function(e){return this._invoke(`next`,e)},s.prototype.throw=function(e){return this._invoke(`throw`,e)},s.prototype.return=function(e){return this._invoke(`return`,e)};let c=Object.entries,l=Object.setPrototypeOf,u=Object.isFrozen,d=Object.getPrototypeOf,f=Object.getOwnPropertyDescriptor,p=Object.freeze,m=Object.seal,h=Object.create,ee=typeof Reflect<`u`&&Reflect,g=ee.apply,te=ee.construct;p||(p=function(e){return e}),m||(m=function(e){return e}),g||(g=function(e,t){var n=[...arguments].slice(2);return e.apply(t,n)}),te||(te=function(e){return new e(...[...arguments].slice(1))});let _=T(Array.prototype.forEach);Array.prototype.indexOf;let ne=T(Array.prototype.lastIndexOf),re=T(Array.prototype.pop),ie=T(Array.prototype.push);Array.prototype.slice;let ae=T(Array.prototype.splice),v=Array.isArray,oe=T(String.prototype.toLowerCase),se=T(String.prototype.toString),ce=T(String.prototype.match),le=T(String.prototype.replace),ue=T(String.prototype.indexOf),de=T(String.prototype.trim),fe=T(Number.prototype.toString),y=T(Boolean.prototype.toString),b=typeof BigInt>`u`?null:T(BigInt.prototype.toString),pe=typeof Symbol>`u`?null:T(Symbol.prototype.toString),x=T(Object.prototype.hasOwnProperty),S=T(Object.prototype.toString),C=T(RegExp.prototype.test),w=E(TypeError);function T(e){return function(t){t instanceof RegExp&&(t.lastIndex=0);var n=[...arguments].slice(1);return g(e,t,n)}}function E(e){return function(){return te(e,[...arguments])}}function D(e,t){let n=arguments.length>2&&arguments[2]!==void 0?arguments[2]:oe;if(l&&l(e,null),!v(t))return e;let r=t.length;for(;r--;){let i=t[r];if(typeof i==`string`){let e=n(i);e!==i&&(u(t)||(t[r]=e),i=e)}e[i]=!0}return e}function me(e){for(let t=0;t<e.length;t++)x(e,t)||(e[t]=null);return e}function O(e){let t=h(null);for(let r of c(e)){var n=a(r,2);let i=n[0],o=n[1];x(e,i)&&(t[i]=v(o)?me(o):o&&typeof o==`object`&&o.constructor===Object?O(o):o)}return t}function he(e){switch(typeof e){case`string`:return e;case`number`:return fe(e);case`boolean`:return y(e);case`bigint`:return b?b(e):`0`;case`symbol`:return pe?pe(e):`Symbol()`;case`undefined`:return S(e);case`function`:case`object`:{if(e===null)return S(e);let t=e,n=k(t,`toString`);if(typeof n==`function`){let e=n(t);return typeof e==`string`?e:S(e)}return S(e)}default:return S(e)}}function k(e,t){for(;e!==null;){let n=f(e,t);if(n){if(n.get)return T(n.get);if(typeof n.value==`function`)return T(n.value)}e=d(e)}function n(){return null}return n}function ge(e){try{return C(e,``),!0}catch(e){return!1}}let _e=p(/* @__PURE__ */ `a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr`.split(`.`)),ve=p(/* @__PURE__ */ `svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern`.split(`.`)),ye=p([`feBlend`,`feColorMatrix`,`feComponentTransfer`,`feComposite`,`feConvolveMatrix`,`feDiffuseLighting`,`feDisplacementMap`,`feDistantLight`,`feDropShadow`,`feFlood`,`feFuncA`,`feFuncB`,`feFuncG`,`feFuncR`,`feGaussianBlur`,`feImage`,`feMerge`,`feMergeNode`,`feMorphology`,`feOffset`,`fePointLight`,`feSpecularLighting`,`feSpotLight`,`feTile`,`feTurbulence`]),be=p([`animate`,`color-profile`,`cursor`,`discard`,`font-face`,`font-face-format`,`font-face-name`,`font-face-src`,`font-face-uri`,`foreignobject`,`hatch`,`hatchpath`,`mesh`,`meshgradient`,`meshpatch`,`meshrow`,`missing-glyph`,`script`,`set`,`solidcolor`,`unknown`,`use`]),xe=p(/* @__PURE__ */ `math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts`.split(`.`)),Se=p([`maction`,`maligngroup`,`malignmark`,`mlongdiv`,`mscarries`,`mscarry`,`msgroup`,`mstack`,`msline`,`msrow`,`semantics`,`annotation`,`annotation-xml`,`mprescripts`,`none`]),Ce=p([`#text`]),we=p(/* @__PURE__ */ `accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns`.split(`.`)),Te=p(/* @__PURE__ */ `accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dominant-baseline.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.pointer-events.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-orientation.text-rendering.textlength.type.u1.u2.unicode.values.vector-effect.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan`.split(`.`)),Ee=p(/* @__PURE__ */ `accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns`.split(`.`)),De=p([`xlink:href`,`xml:id`,`xlink:title`,`xml:space`,`xmlns:xlink`]),Oe=m(/{{[\w\W]*|^[\w\W]*}}/g),ke=m(/<%[\w\W]*|^[\w\W]*%>/g),Ae=m(/\${[\w\W]*/g),je=m(/^data-[\-\w.\u00B7-\uFFFF]+$/),Me=m(/^aria-[\-\w]+$/),Ne=m(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),Pe=m(/^(?:\w+script|data):/i),Fe=m(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),Ie=m(/^html$/i),Le=m(/^[a-z][.\w]*(-[.\w]+)+$/i),Re=m(/<[/\w!]/g),ze=m(/<[/\w]/g),Be=m(/<\/no(script|embed|frames)/i),Ve=m(/\/>/i),A={element:1,attribute:2,text:3,cdataSection:4,entityReference:5,entityNode:6,processingInstruction:7,comment:8,document:9,documentType:10,documentFragment:11,notation:12},j=[`style`,`script`,`xmp`,`iframe`,`noembed`,`noframes`,`plaintext`,`noscript`],He=p(D({},j)),Ue=function(){let e={};return _(j,t=>{e[t]=m(RegExp(`</`+t+`(?=[\\t\\n\\f\\r />])`,`i`))}),p(e)}(),We=function(){return typeof window>`u`?null:window},Ge=function(e,t){if(typeof e!=`object`||typeof e.createPolicy!=`function`)return null;let n=null,r=`data-tt-policy-suffix`;t&&t.hasAttribute(r)&&(n=t.getAttribute(r));let i=`dompurify`+(n?`#`+n:``);try{return e.createPolicy(i,{createHTML(e){return e},createScriptURL(e){return e}})}catch(e){return console.warn(`TrustedTypes policy `+i+` could not be created.`),null}},Ke=function(){return{afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}},M=function(e,t,n,r){return x(e,t)&&v(e[t])?D(r.base?O(r.base):{},e[t],r.transform):n},qe=function(e,t,n){let r=x(e,t)?e[t]:void 0;return r&&typeof r==`object`?O(r):n()};function Je(){let e=arguments.length>0&&arguments[0]!==void 0?arguments[0]:We(),t=e=>Je(e);if(t.version=`3.4.16`,t.removed=[],!e||!e.document||e.document.nodeType!==A.document||!e.Element)return t.isSupported=!1,t;let n=e.document,r=n,i=r.currentScript;e.DocumentFragment;let a=e.HTMLTemplateElement,o=e.Node,s=e.Element,l=e.NodeFilter;e.NamedNodeMap===void 0&&(e.NamedNodeMap||e.MozNamedAttrMap),e.HTMLFormElement;let u=e.DOMParser,d=e.trustedTypes,f=s.prototype,ee=k(f,`cloneNode`),g=k(f,`remove`),te=k(f,`removeAttributeNode`),fe=k(f,`nextSibling`),y=k(f,`childNodes`),b=k(f,`parentNode`),pe=k(f,`shadowRoot`),S=k(f,`attributes`),T=o&&o.prototype?k(o.prototype,`nodeType`):null,E=o&&o.prototype?k(o.prototype,`nodeName`):null,me=o&&o.prototype?k(o.prototype,`ownerDocument`):null,j=function(e){return T?T(e):e.nodeType},Ye=function(e){return E?E(e):e.nodeName};if(typeof a==`function`){let e=n.createElement(`template`);e.content&&e.content.ownerDocument&&(n=e.content.ownerDocument)}let N,P=``,Xe,Ze=!1,Qe=0,$e=function(){if(Qe>0)throw w(`A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.`)},F=function(e){$e(),Qe++;try{return N.createHTML(e)}finally{Qe--}},et=function(e){$e(),Qe++;try{return N.createScriptURL(e)}finally{Qe--}},tt=function(){return Ze||(Xe=Ge(d,i),Ze=!0),Xe},nt=n,rt=nt.implementation,it=nt.createNodeIterator,at=nt.createDocumentFragment,ot=nt.getElementsByTagName,st=r.importNode,I=Ke();t.isSupported=typeof c==`function`&&typeof b==`function`&&rt&&rt.createHTMLDocument!==void 0;let ct=Oe,lt=ke,ut=Ae,dt=je,ft=Me,pt=Pe,mt=Fe,ht=Le,gt=Ne,L=null,_t=D({},[..._e,...ve,...ye,...xe,...Ce]),R=null,vt=D({},[...we,...Te,...Ee,...De]),z=Object.seal(h(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),yt=null,bt=null,B=Object.seal(h(null,{tagCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeCheck:{writable:!0,configurable:!1,enumerable:!0,value:null}})),xt=!0,St=!0,Ct=!1,wt=!0,V=!1,H=!0,U=!1,Tt=!1,Et=null,Dt=null,Ot=!1,W=!1,kt=!1,At=!1,jt=!0,Mt=!1,Nt=`user-content-`,Pt=!0,Ft=!1,G={},K=null,It=D({},/* @__PURE__ */ `annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp`.split(`.`)),Lt=null,Rt=D({},[`audio`,`video`,`img`,`source`,`image`,`track`]),zt=null,Bt=D({},[`alt`,`class`,`for`,`id`,`label`,`name`,`pattern`,`placeholder`,`role`,`summary`,`title`,`value`,`style`,`xmlns`]),Vt=`http://www.w3.org/1998/Math/MathML`,Ht=`http://www.w3.org/2000/svg`,q=`http://www.w3.org/1999/xhtml`,J=q,Ut=!1,Wt=null,Gt=D({},[Vt,Ht,q],se),Kt=p([`mi`,`mo`,`mn`,`ms`,`mtext`]),qt=D({},Kt),Jt=p([`annotation-xml`]),Yt=D({},Jt),Xt=D({},[`title`,`style`,`font`,`a`,`script`]),Zt=null,Qt=[`application/xhtml+xml`,`text/html`],Y=null,$t=null,en=n.createElement(`form`),tn=function(e){return e instanceof RegExp||e instanceof Function},nn=function(){let e=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};if($t&&$t===e)return;(!e||typeof e!=`object`)&&(e={}),e=O(e),Zt=Qt.indexOf(e.PARSER_MEDIA_TYPE)===-1?`text/html`:e.PARSER_MEDIA_TYPE,Y=Zt===`application/xhtml+xml`?se:oe,L=M(e,`ALLOWED_TAGS`,_t,{transform:Y}),R=M(e,`ALLOWED_ATTR`,vt,{transform:Y}),Wt=M(e,`ALLOWED_NAMESPACES`,Gt,{transform:se}),zt=M(e,`ADD_URI_SAFE_ATTR`,Bt,{transform:Y,base:Bt}),Lt=M(e,`ADD_DATA_URI_TAGS`,Rt,{transform:Y,base:Rt}),K=M(e,`FORBID_CONTENTS`,It,{transform:Y}),yt=M(e,`FORBID_TAGS`,O({}),{transform:Y}),bt=M(e,`FORBID_ATTR`,O({}),{transform:Y}),G=x(e,`USE_PROFILES`)?e.USE_PROFILES&&typeof e.USE_PROFILES==`object`?O(e.USE_PROFILES):e.USE_PROFILES:!1,xt=e.ALLOW_ARIA_ATTR!==!1,St=e.ALLOW_DATA_ATTR!==!1,Ct=e.ALLOW_UNKNOWN_PROTOCOLS||!1,wt=e.ALLOW_SELF_CLOSE_IN_ATTR!==!1,V=e.SAFE_FOR_TEMPLATES||!1,H=e.SAFE_FOR_XML!==!1,U=e.WHOLE_DOCUMENT||!1,W=e.RETURN_DOM||!1,kt=e.RETURN_DOM_FRAGMENT||!1,At=e.RETURN_TRUSTED_TYPE||!1,Ot=e.FORCE_BODY||!1,jt=e.SANITIZE_DOM!==!1,Mt=e.SANITIZE_NAMED_PROPS||!1,Pt=e.KEEP_CONTENT!==!1,Ft=e.IN_PLACE||!1,gt=ge(e.ALLOWED_URI_REGEXP)?e.ALLOWED_URI_REGEXP:Ne,J=typeof e.NAMESPACE==`string`?e.NAMESPACE:q,qt=qe(e,`MATHML_TEXT_INTEGRATION_POINTS`,()=>D({},Kt)),Yt=qe(e,`HTML_INTEGRATION_POINTS`,()=>D({},Jt));let t=qe(e,`CUSTOM_ELEMENT_HANDLING`,()=>h(null));if(z=h(null),x(t,`tagNameCheck`)&&tn(t.tagNameCheck)&&(z.tagNameCheck=t.tagNameCheck),x(t,`attributeNameCheck`)&&tn(t.attributeNameCheck)&&(z.attributeNameCheck=t.attributeNameCheck),x(t,`allowCustomizedBuiltInElements`)&&typeof t.allowCustomizedBuiltInElements==`boolean`&&(z.allowCustomizedBuiltInElements=t.allowCustomizedBuiltInElements),m(z),V&&(St=!1),kt&&(W=!0),G&&(L=D({},Ce),R=h(null),G.html===!0&&(D(L,_e),D(R,we)),G.svg===!0&&(D(L,ve),D(R,Te),D(R,De)),G.svgFilters===!0&&(D(L,ye),D(R,Te),D(R,De)),G.mathMl===!0&&(D(L,xe),D(R,Ee),D(R,De))),B.tagCheck=null,B.attributeCheck=null,x(e,`ADD_TAGS`)&&(typeof e.ADD_TAGS==`function`?B.tagCheck=e.ADD_TAGS:v(e.ADD_TAGS)&&(L===_t&&(L=O(L)),D(L,e.ADD_TAGS,Y))),x(e,`ADD_ATTR`)&&(typeof e.ADD_ATTR==`function`?B.attributeCheck=e.ADD_ATTR:v(e.ADD_ATTR)&&(R===vt&&(R=O(R)),D(R,e.ADD_ATTR,Y))),x(e,`ADD_FORBID_CONTENTS`)&&v(e.ADD_FORBID_CONTENTS)&&(K===It&&(K=O(K)),D(K,e.ADD_FORBID_CONTENTS,Y)),Pt&&(L[`#text`]=!0),U&&D(L,[`html`,`head`,`body`]),L.table&&(D(L,[`tbody`]),delete yt.tbody),e.TRUSTED_TYPES_POLICY){if(typeof e.TRUSTED_TYPES_POLICY.createHTML!=`function`)throw w(`TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.`);if(typeof e.TRUSTED_TYPES_POLICY.createScriptURL!=`function`)throw w(`TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.`);let t=N;N=e.TRUSTED_TYPES_POLICY;try{P=F(``)}catch(e){throw N=t,e}}else e.TRUSTED_TYPES_POLICY===null?(N=void 0,P=``):(N===void 0&&(N=tt()),N&&typeof P==`string`&&(P=F(``)));p&&p(e),$t=e},rn=D({},[...ve,...ye,...be]),an=D({},[...xe,...Se]),on=function(e,t,n){return t.namespaceURI===q?e===`svg`:t.namespaceURI===Vt?e===`svg`&&(n===`annotation-xml`||qt[n]):!!rn[e]},sn=function(e,t,n){return t.namespaceURI===q?e===`math`:t.namespaceURI===Ht?e===`math`&&Yt[n]:!!an[e]},cn=function(e,t,n){return t.namespaceURI===Ht&&!Yt[n]||t.namespaceURI===Vt&&!qt[n]?!1:!an[e]&&(Xt[e]||!rn[e])},ln=function(e){let t=b(e);(!t||!t.tagName)&&(t={namespaceURI:J,tagName:`template`});let n=oe(e.tagName),r=oe(t.tagName);return Wt[e.namespaceURI]?e.namespaceURI===Ht?on(n,t,r):e.namespaceURI===Vt?sn(n,t,r):e.namespaceURI===q?cn(n,t,r):!!(Zt===`application/xhtml+xml`&&Wt[e.namespaceURI]):!1},X=function(e){ie(t.removed,{element:e});try{b(e).removeChild(e)}catch(t){if(g(e),!b(e))throw w(`a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place`)}},un=function(e,t,n){try{te(e,t)}catch(t){try{e.removeAttribute(n)}catch(e){}}},dn=function(e){pn(e);let t=y(e);if(t){let e=[];_(t,t=>{ie(e,t)}),_(e,e=>{try{g(e)}catch(e){}})}let n=S(e);if(n)for(let t=n.length-1;t>=0;--t){let r=n[t],i=r&&r.name;typeof i==`string`&&un(e,r,i)}},Z=function(e,n,r){if(!r)try{r=n.getAttributeNode(e)}catch(e){r=null}ie(t.removed,{attribute:r||null,from:n});try{r?te(n,r):n.removeAttribute(e)}catch(t){try{n.removeAttribute(e)}catch(e){}}if(e===`is`){if(W||kt)try{X(n)}catch(e){}else try{n.setAttribute(e,``)}catch(e){}}},fn=function(e){let t=S(e);if(t)for(let n=t.length-1;n>=0;--n){let r=t[n],i=r&&r.name;typeof i!=`string`||R[Y(i)]||un(e,r,i)}},pn=function(e){let t=[e];for(;t.length>0;){let e=t.pop();j(e)===A.element&&fn(e);let n=y(e);if(n)for(let e=n.length-1;e>=0;--e)t.push(n[e])}},mn=function(e,t){return H?e===`patchsrc`||e===`for`&&t!==`label`&&t!==`output`:!1},hn=function(e){if(!H)return;let t=[e];for(;t.length>0;){let e=t.pop(),n=j(e);if(n===A.processingInstruction||n===A.comment&&C(ze,e.data)){try{g(e)}catch(e){}continue}if(n===A.element){let t=e,n=Y(Ye(e));try{t.hasAttribute&&t.hasAttribute(`patchsrc`)&&t.removeAttribute(`patchsrc`),t.hasAttribute&&t.hasAttribute(`for`)&&mn(`for`,n)&&t.removeAttribute(`for`)}catch(e){}}let r=y(e);if(r)for(let e=r.length-1;e>=0;--e)t.push(r[e])}},gn=function(e){let t=null,r=null;if(Ot)e=`<remove></remove>`+e;else{let t=ce(e,/^[\r\n\t ]+/);r=t&&t[0]}Zt===`application/xhtml+xml`&&J===q&&(e=`<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>`+e+`</body></html>`);let i=N?F(e):e;if(J===q)try{t=new u().parseFromString(i,Zt)}catch(e){}if(!t||!t.documentElement){t=rt.createDocument(J,`template`,null);try{t.documentElement.innerHTML=Ut?P:i}catch(e){}}let a=t.body||t.documentElement;return e&&r&&a.insertBefore(n.createTextNode(r),a.childNodes[0]||null),J===q?ot.call(t,U?`html`:`body`)[0]:U?t.documentElement:a},_n=function(e){let t=me?me(e):e.ownerDocument;return it.call(t||e,e,l.SHOW_ELEMENT|l.SHOW_COMMENT|l.SHOW_TEXT|l.SHOW_PROCESSING_INSTRUCTION|l.SHOW_CDATA_SECTION,null)},vn=function(e){return e=le(e,ct,` `),e=le(e,lt,` `),e=le(e,ut,` `),e},yn=function(e){var t;e.normalize();let n=me?me(e):e.ownerDocument,r=it.call(n||e,e,l.SHOW_TEXT|l.SHOW_COMMENT|l.SHOW_CDATA_SECTION|l.SHOW_PROCESSING_INSTRUCTION,null),i=r.nextNode();for(;i;)i.data=vn(i.data),i=r.nextNode();let a=(t=e.querySelectorAll)==null?void 0:t.call(e,`template`);a&&_(a,e=>{xn(e.content)&&yn(e.content)})},bn=function(e){let t=E?E(e):null;return typeof t!=`string`||Y(t)!==`form`?!1:typeof e.nodeName!=`string`||typeof e.textContent!=`string`||typeof e.removeChild!=`function`||e.attributes!==S(e)||typeof e.removeAttribute!=`function`||typeof e.removeAttributeNode!=`function`||typeof e.getAttributeNode!=`function`||typeof e.setAttribute!=`function`||typeof e.namespaceURI!=`string`||typeof e.insertBefore!=`function`||typeof e.hasChildNodes!=`function`||e.nodeType!==T(e)||e.childNodes!==y(e)},xn=function(e){if(!T||typeof e!=`object`||!e)return!1;try{return T(e)===A.documentFragment}catch(e){return!1}},Sn=function(e){if(!T||typeof e!=`object`||!e)return!1;try{return typeof T(e)==`number`}catch(e){return!1}};function Q(e,n,r){e.length!==0&&_(e,e=>{e.call(t,n,r,$t)})}let Cn=function(e,t){return!!(H&&e.hasChildNodes()&&!Sn(e.firstElementChild)&&C(Re,e.textContent)&&C(Re,e.innerHTML)||H&&e.namespaceURI===q&&He[t]&&(Sn(e.firstElementChild)||typeof e.textContent==`string`&&C(Ue[t],e.textContent))||e.nodeType===A.processingInstruction||H&&e.nodeType===A.comment&&C(ze,e.data))},wn=function(e,t){return e instanceof RegExp?C(e,t):e instanceof Function&&!!e(t,...[...arguments].slice(2))},Tn=function(e,t,n){if(!yt[t]&&An(t)&&wn(z.tagNameCheck,t))return!1;if(Pt&&!K[t]){let t=b(e),r=y(e);if(r&&t){let i=r.length;for(let a=i-1;a>=0;--a){let i=e===n?ee(r[a],!0):r[a];t.insertBefore(i,fe(e))}}}return X(e),!0},En=function(e,t,n,r){return e.length===0?t:t===n||t===r?O(t):t},$=function(e,t){return e===t||b(e)!==null?!1:(Ft&&pn(e),!0)},Dn=function(e,n){if(Q(I.beforeSanitizeElements,e,null),$(e,n))return!0;if(bn(e))return X(e),!0;let r=Y(Ye(e));if(L=En(I.uponSanitizeElement,L,_t,Et),Q(I.uponSanitizeElement,e,{tagName:r,allowedTags:L}),$(e,n))return!0;if(Cn(e,r))return X(e),!0;if(yt[r]||!(B.tagCheck instanceof Function&&B.tagCheck(r))&&!L[r]){let t=Tn(e,r,n);return t===!1&&(Q(I.afterSanitizeElements,e,null),$(e,n))?!0:t}if(j(e)===A.element&&!ln(e)||(r===`noscript`||r===`noembed`||r===`noframes`)&&C(Be,e.innerHTML))return X(e),!0;if(V&&e.nodeType===A.text){let n=vn(e.textContent);e.textContent!==n&&(ie(t.removed,{element:e.cloneNode()}),e.textContent=n)}return Q(I.afterSanitizeElements,e,null),$(e,n)},On=function(e,t,r){if(bt[t]||mn(t,e)||jt&&(t===`id`||t===`name`)&&(r in n||r in en))return!1;let i=R[t]||B.attributeCheck instanceof Function&&B.attributeCheck(t,e);return St&&C(dt,t)||xt&&C(ft,t)?!0:i?zt[t]||C(gt,le(r,mt,``))||(t===`src`||t===`xlink:href`||t===`href`)&&e!==`script`&&ue(r,`data:`)===0&&Lt[e]||Ct&&!C(pt,le(r,mt,``))?!0:!r:An(e)&&wn(z.tagNameCheck,e)&&wn(z.attributeNameCheck,t,e)||t===`is`&&z.allowCustomizedBuiltInElements&&wn(z.tagNameCheck,r)},kn=D({},[`annotation-xml`,`color-profile`,`font-face`,`font-face-format`,`font-face-name`,`font-face-src`,`font-face-uri`,`missing-glyph`]),An=function(e){return!kn[oe(e)]&&C(ht,e)},jn=function(e,t,n,r){if(N&&typeof d==`object`&&typeof d.getAttributeType==`function`&&!n)switch(d.getAttributeType(e,t)){case`TrustedHTML`:return F(r);case`TrustedScriptURL`:return et(r)}return r},Mn=function(e,t,n,r){try{return n?e.setAttributeNS(n,t,r):e.setAttribute(t,r),!bn(e)||(X(e),!1)}catch(n){return Z(t,e),!1}},Nn=function(e,n){if(Q(I.beforeSanitizeAttributes,e,null),$(e,n))return;let r=e.attributes;if(!r||bn(e))return;R=En(I.uponSanitizeAttribute,R,vt,Dt);let i={attrName:``,attrValue:``,keepAttr:!0,allowedAttributes:R,forceKeepAttr:void 0},a=r.length,o=Y(e.nodeName);for(;a--;){let n=r[a],s=n.name,c=n.namespaceURI,l=n.value,u=Y(s),d=l,f=s===`value`?d:de(d),p=!1;if(i.attrName=u,i.attrValue=f,i.keepAttr=!0,i.forceKeepAttr=void 0,Q(I.uponSanitizeAttribute,e,i),f=i.attrValue,Mt&&(u===`id`||u===`name`)&&ue(f,Nt)!==0&&(Z(s,e,n),f=Nt+f,p=!0),H&&C(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i,f)){Z(s,e,n);continue}if(u===`attributename`&&ce(f,`href`)){Z(s,e,n);continue}if(!i.forceKeepAttr){if(!i.keepAttr){Z(s,e,n);continue}if(!wt&&C(Ve,f)){Z(s,e,n);continue}if(V&&(f=vn(f)),!On(o,u,f)){Z(s,e,n);continue}f=jn(o,u,c,f),f!==d&&Mn(e,s,c,f)&&p&&re(t.removed)}}Q(I.afterSanitizeAttributes,e,null),$(e,n)},Pn=function(e){let t=null,n=_n(e);for(Q(I.beforeSanitizeShadowDOM,e,null);t=n.nextNode();)if(Q(I.uponSanitizeShadowNode,t,null),Dn(t,e),Nn(t,e),xn(t.content)&&Pn(t.content),j(t)===A.element){let e=pe(t);xn(e)&&(Fn(e),Pn(e))}Q(I.afterSanitizeShadowDOM,e,null)},Fn=function(e){let t=[{node:e,shadow:null}];for(;t.length>0;){let e=t.pop();if(e.shadow){Pn(e.shadow);continue}let n=e.node,r=j(n)===A.element,i=y(n);if(i)for(let e=i.length-1;e>=0;--e)t.push({node:i[e],shadow:null});if(r){let e=E?E(n):null;if(typeof e==`string`&&Y(e)===`template`){let e=n.content;xn(e)&&t.push({node:e,shadow:null})}}if(r){let e=pe(n);xn(e)&&t.push({node:null,shadow:e},{node:e,shadow:null})}}};return t.sanitize=function(e){let n=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},i=null,a=null,o=null,s=null;if(Ut=!e,Ut&&(e=`<!-->`),typeof e!=`string`&&!Sn(e)&&(e=he(e),typeof e!=`string`))throw w(`dirty is not a string, aborting`);if(!t.isSupported)return e;Tt?(L=Et,R=Dt):nn(n),(I.uponSanitizeElement.length>0||I.uponSanitizeAttribute.length>0)&&(L=O(L)),I.uponSanitizeAttribute.length>0&&(R=O(R)),t.removed=[];let c=Ft&&typeof e!=`string`&&Sn(e);if(c){hn(e);let t=Ye(e);if(typeof t==`string`){let n=Y(t);if(!L[n]||yt[n])throw dn(e),w(`root node is forbidden and cannot be sanitized in-place`)}if(bn(e))throw dn(e),w(`root node is clobbered and cannot be sanitized in-place`);try{Fn(e)}catch(t){throw dn(e),t}}else if(Sn(e))i=gn(`<!---->`),a=i.ownerDocument.importNode(e,!0),a.nodeType===A.element&&a.nodeName===`BODY`||a.nodeName===`HTML`?i=a:i.appendChild(a),Fn(i);else{if(!W&&!V&&!U&&e.indexOf(`<`)===-1)return N&&At?F(e):e;if(i=gn(e),!i)return W?null:At?P:``}i&&Ot&&X(i.firstChild);let l=c?e:i;try{let e=_n(l);for(;o=e.nextNode();)Dn(o,l),Nn(o,l),xn(o.content)&&Pn(o.content)}catch(n){throw c&&(dn(e),_(t.removed,e=>{e.element&&pn(e.element)})),n}if(c){let n=!1;if(_(t.removed,t=>{t.element&&(t.element===e&&(n=!0),pn(t.element))}),n)throw w(`a node selected for removal could not be safely returned; refusing to sanitize in place`);return V&&yn(e),e}if(W){if(V&&yn(i),kt)for(s=at.call(i.ownerDocument);i.firstChild;)s.appendChild(i.firstChild);else s=i;return(R.shadowroot||R.shadowrootmode)&&(s=st.call(r,s,!0)),s}let u=U?i.outerHTML:i.innerHTML;return U&&L[`!doctype`]&&i.ownerDocument&&i.ownerDocument.doctype&&i.ownerDocument.doctype.name&&C(Ie,i.ownerDocument.doctype.name)&&(u=`<!DOCTYPE `+i.ownerDocument.doctype.name+`>
`+u),V&&(u=vn(u)),N&&At?F(u):u},t.setConfig=function(){let e=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};nn(e),Tt=!0,Et=L,Dt=R},t.clearConfig=function(){$t=null,Tt=!1,Et=null,Dt=null,N=Xe,P=``},t.isValidAttribute=function(e,t,n){$t||nn({});let r=Y(e),i=Y(t);return On(r,i,n)},t.addHook=function(e,t){typeof t==`function`&&x(I,e)&&ie(I[e],t)},t.removeHook=function(e,t){if(x(I,e)){if(t!==void 0){let n=ne(I[e],t);return n===-1?void 0:ae(I[e],n,1)[0]}return re(I[e])}},t.removeHooks=function(e){x(I,e)&&(I[e]=[])},t.removeAllHooks=function(){I=Ke()},t}return Je()});

(function () {
  'use strict';

  angular.module('fuse')
    .service('NotificationService', NotificationService);

  function NotificationService($q, $http) {

    var notViewed = function () {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/notifications/not-viewed",
          method: "GET",
          params: { '_v': new Date().getTime() }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var find = function (start) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/notifications",
          method: "GET",
          params: { '_v': new Date().getTime(), 'start': start }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    var viewed = function (ids) {
      return $q(function (resolve, reject) {
        $http({
          url: "/api/rest/notifications/viewed",
          method: "PUT",
          params: { '_v': new Date().getTime(), 'ids': ids }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return {
      notViewed: notViewed,
      find: find,
      viewed: viewed
    }
  }
})();

/*
 * ngComboDatePicker v1.5.1
 * http://github.com/jfmdev/ngComboDatePicker
 * «Copyright 2015 Jose F. Maldonado»
 * This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */

// Declare module.
angular.module("ngComboDatePicker", [])

// Declare directive.
.directive('ngComboDatePicker', function() {
    // Define fuction for getting the maximum date for a month.
    function maxDate(month, year) {
        var res = 31;
        if(month != null) {
            if(month == 4 || month == 6 || month == 9 || month == 11) {
                res = 30;
            }
            if(year != null && month == 2) {
                res = (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)? 29 : 28;
            }
        }
        return res;
    }

    // Define function for adjust timezone.
    function adjustTimezone (myDate, myTimezone) {
        var offset = isNaN(myTimezone)? new Date().getTimezoneOffset() : parseFloat(myTimezone)*60;
        return new Date(myDate.getTime() + offset*60*1000);                           
    }
    
    // Define function for parse dates.
    function parseDate(myDate, myTimezone) {
        var res = null;
        if(myDate !== undefined && myDate !== null) {
            if(myDate instanceof Date) {
                res = myDate;
            } else {
                if(typeof myDate == 'number' || typeof myDate == 'string') {
                    // Parse date.
                    res = new Date(isNaN(myDate)? myDate : parseInt(myDate, 10));
                    
                    // Adjust timezone.
                    res = adjustTimezone(res, myTimezone);
                }
            }
        }
        return res;
    };

    // Function to parse an string returning either a number or 'null' (instead of NaN).
    function parseIntStrict(num) {
        return (num !== null && num !== '' && parseInt(num) != NaN)? parseInt(num) : null;
    };
    
    // Function to parse a JSON object.
    function parseJsonPlus(jsonObj) {
        var res = null;
        if(jsonObj != null) {
            try{ res = JSON.parse(jsonObj); }catch(ex) {}
            if(res == null) try{ res = JSON.parse(jsonObj.replace(/'/g, '"')); }catch(ex) {}
        }
        return res;
    }
    
    // Create directive.
    return {
        restrict: 'AEC',
        scope: {
            ngModel: '=',
            ngDate : '@',
            ngMinDate : '@',
            ngMaxDate : '@',
            ngMinModel : '=?',
            ngMaxModel : '=?',
            ngMonths : '@',
            ngTimezone: '@',
            ngOrder: '@',
            ngAttrsDate: '@',
            ngAttrsMonth: '@',
            ngAttrsYear: '@',
            ngDisabled: '=?',
            ngYearOrder: '@',
            ngPlaceholder: '@',
            ngPlaceholderEnabled: '@',
            ngRequired: '@'
        },
        require: 'ngModel',
        controller: ['$scope', function($scope) {
            // Initialize models.
            $scope.ngModel = parseDate($scope.ngModel, $scope.ngTimezone);
            $scope.ngMinModel = parseDate($scope.ngMinModel, $scope.ngTimezone);
            $scope.ngMaxModel = parseDate($scope.ngMaxModel, $scope.ngTimezone);
            
            // Initialize attributes variables.
            $scope.ngAttrsDate = parseJsonPlus($scope.ngAttrsDate);
            $scope.ngAttrsMonth = parseJsonPlus($scope.ngAttrsMonth);
            $scope.ngAttrsYear = parseJsonPlus($scope.ngAttrsYear);
            
            // Verify if initial date was defined.
            var initDate = parseDate($scope.ngDate, $scope.ngTimezone);
            if(initDate != null) $scope.ngModel = initDate;

            // Initialize order.
            if(typeof $scope.ngOrder != 'string') {
                $scope.ngOrder = 'dmy';
            } else {
                $scope.ngOrder = $scope.ngOrder.toLowerCase();
            }

            // Initialize minimal and maximum values.
            if($scope.ngMinDate) {
                $scope.ngMinModel = parseDate($scope.ngMinDate, $scope.ngTimezone);
            }
            if(!$scope.ngMinModel) {
                var now = new Date();
                $scope.ngMinModel = new Date(now.getFullYear()-100, now.getMonth(), now.getDate(),
                                          now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
            }
            if($scope.ngMaxDate) {
                $scope.ngMaxModel = parseDate($scope.ngMaxDate, $scope.ngTimezone);
            }
            if(!$scope.ngMaxModel) {
                $scope.ngMaxModel = new Date();
            }

            // Watch for changes in the minimum and maximum dates.
            $scope.$watch('[ngMinModel, ngMaxModel]', function() {
                // Update list of years (if possible).
                if($scope.ngMinModel && $scope.ngMaxModel) {
                    // Get list of years.
                    $scope.years = [];
                    for(var i=$scope.ngMinModel.getFullYear(); i<=$scope.ngMaxModel.getFullYear(); i++) {
                        $scope.years.push({value:i, name:i});
                    }

                    // Verify if the order of the years must be reversed.
                    if(typeof $scope.ngYearOrder == 'string' && $scope.ngYearOrder.indexOf('des') == 0) {
                        $scope.years.reverse();
                    }

                    // Prepend the years placeholder
                    if($scope.placeHolders) $scope.years.unshift($scope.placeHolders[0]);
                }
                
                // Verify if selected date is in the valid range.
                if($scope.ngModel && $scope.ngMinModel && $scope.ngModel < $scope.ngMinModel) $scope.ngModel = $scope.ngMinModel;
                if($scope.ngModel && $scope.ngMaxModel && $scope.ngModel > $scope.ngMaxModel) $scope.ngModel = $scope.ngMaxModel;
            });

            // Initialize place holders.
            $scope.placeHolders = null;
            if($scope.ngPlaceholder !== undefined && $scope.ngPlaceholder !== null && (typeof $scope.ngPlaceholder == 'string' || Array.isArray($scope.ngPlaceholder))) {
                var holders = typeof $scope.ngPlaceholder == 'string'? $scope.ngPlaceholder.split(',') : $scope.ngPlaceholder;
                if(holders.length == 3) {
                    $scope.placeHolders = [];
                    for(var h=0; h<holders.length; h++) {
                        $scope.placeHolders.push({value:'', name:holders[h], disabled:false});
                    }
                }
            }

            // Initialize list of months names.
            var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            if($scope.ngMonths !== undefined && $scope.ngMonths !== null) {
                if(typeof $scope.ngMonths == 'string') {
                    var months = $scope.ngMonths.split(',');
                    if(months.length == 12) monthNames = months;
                }
                if(Array.isArray($scope.ngMonths) && $scope.ngMonths.length == 12) {
                     monthNames = $scope.ngMonths;
                }
            }
            
            // Update list of months.
            $scope.updateMonthList = function(year) {
                // Parse parameter.
                year = parseIntStrict(year);

                // Some months can not be choosed if the year matchs with the year of the minimum or maximum dates.
                var start = year !== null && year == $scope.ngMinModel.getFullYear()? $scope.ngMinModel.getMonth() : 0;
                var end = year !== null && year == $scope.ngMaxModel.getFullYear()? $scope.ngMaxModel.getMonth() : 11;

                // Generate list.
                $scope.months = [];
                if($scope.placeHolders) $scope.months.push($scope.placeHolders[1]);
                for(var i=start; i<=end; i++) {
                    $scope.months.push({value:i, name:monthNames[i]});
                }
            };

            // Initialize list of days.
            $scope.updateDateList = function(month, year) {
                // Parse parameters.
                month = parseIntStrict(month);
                year = parseIntStrict(year);
                
                // Start date is 1, unless the selected month and year matchs the minimum date.
                var start = 1;
                if(month !== null && month == $scope.ngMinModel.getMonth() && 
                   year !== null && year == $scope.ngMinModel.getFullYear()) {
                    start = $scope.ngMinModel.getDate();
                }

                // End date is 30 or 31 (28 or 29 in February), unless the selected month and year matchs the maximum date.
                var end = maxDate(month !== null? (month+1) : null, year);
                if(month !== null && month == $scope.ngMaxModel.getMonth() && 
                   year !== null && year == $scope.ngMaxModel.getFullYear()) {
                    end = $scope.ngMaxModel.getDate();
                }

                // Generate list.
                $scope.dates = [];
                if($scope.placeHolders) $scope.dates.push($scope.placeHolders[2]);
                for(var i=start; i<=end; i++) {
                    $scope.dates.push({value:i, name:i});
                }
            };
        } ],
        
        link: function(scope, element, attrs, ngModelCtrl) {
            // Initialize variables.
            var jqLite = angular.element;
            var children = jqLite(element[0]).children();
            var order = scope.ngOrder.split('');

            // Reorder elements.
            for(var i=0; i<order.length; i++) {
                if(order[i] == 'd') jqLite(element[0]).append(children[0]);
                if(order[i] == 'm') jqLite(element[0]).append(children[1]);
                if(order[i] == 'y') jqLite(element[0]).append(children[2]);
            }
            
            // Set formatter function.
            ngModelCtrl.$formatters.push(function(modelValue) {
                var res = {date: null, month: null, year: null};

                // Verify if model is defined.
                if (modelValue) {
                    res.date = modelValue.getDate();
                    res.month = modelValue.getMonth();
                    res.year = modelValue.getFullYear();
                } else {
                    res.date = '';
                    res.month = '';
                    res.year = '';
                    
                    if(scope.placeHolders) {
                        scope.placeHolders[0].disabled = false;
                        scope.placeHolders[1].disabled = false;
                        scope.placeHolders[2].disabled = false;
                    }
                }

                // Hide or show days and months according to the min and max dates.
                scope.updateMonthList(res.year);
                scope.updateDateList(res.month, res.year);
                return res;
            });
            
            // Set render function.
            ngModelCtrl.$render = function() {
                scope.date  = ngModelCtrl.$viewValue.date;
                scope.month = ngModelCtrl.$viewValue.month;
                scope.year  = ngModelCtrl.$viewValue.year;
            };
            
            // Set watch function for update the view value.
            scope.$watch('date + "-" + month + "-" + year', function(newValue, oldValue) {
                if(newValue != oldValue) {
                    ngModelCtrl.$setViewValue({
                        date: scope.date,
                        month: scope.month,
                        year: scope.year
                    });
                }
            });
            
            // Override function to check if the value is empty.
            ngModelCtrl.$isEmpty = function(viewValue) {
                return viewValue.date == null || viewValue.date == '' || 
                       isNaN(parseInt(viewValue.month)) ||
                       viewValue.year == null || viewValue.year == '';
            };
            
            // Set parser function.
            ngModelCtrl.$parsers.push(function(viewValue) {
                var res = null;

                // Check that the three combo boxes have values.
                if(viewValue.date != null && viewValue.date != '' && !isNaN(parseInt(viewValue.month)) && viewValue.year != null && viewValue.year != '') {
                    var maxDay = maxDate(viewValue.month+1, viewValue.year);
                    
                    var hours = 0, minutes = 0, seconds = 0, milliseconds = 0;
                    if(scope.ngModel != null) {
                        hours = scope.ngModel.getHours();
                        minutes = scope.ngModel.getMinutes();
                        seconds = scope.ngModel.getSeconds();
                        milliseconds = scope.ngModel.getMilliseconds();
                    }
                    
                    res = new Date(viewValue.year, viewValue.month, viewValue.date > maxDay? maxDay : viewValue.date, hours, minutes, seconds, milliseconds);
                }
                
                // Disable placeholders after selecting a value.
                if(scope.placeHolders && angular.isUndefined(scope.ngPlaceholderEnabled)) {
                    if(scope.year != '') scope.placeHolders[0].disabled = true;
                    if(scope.month != '') scope.placeHolders[1].disabled = true;
                    if(scope.date != '') scope.placeHolders[2].disabled = true;
                }
                
                // Hide or show days and months according to the min and max dates.
                scope.updateMonthList(viewValue.year);
                scope.updateDateList(viewValue.month, viewValue.year);
                          
                return res;
            });
            
            // Method called when one of the combo boxes is touched.
            scope.touched = function() {
                ngModelCtrl.$touched = true;
                ngModelCtrl.$untouched = false;
            };
        },
        template: function(element, attrs) {
            // Verify if addtional attributes were defined.
            var strAttrs = ['', '', ''];
            var attrNames = ['ngAttrsDate', 'ngAttrsMonth', 'ngAttrsYear'];
            for(var i=0; i<3; i++) {
                try{
                    // Verify if the attributes were defined.
                    if(attrs && attrs[attrNames[i]]) {
                        // Iterate over each attribute.
                        eval("var attrsAux= " + attrs[attrNames[i]]);
                        for(var key in attrsAux) {
                            var value = attrsAux[key];
                            if(typeof value == "boolean") {
                                if(value) strAttrs[i] += key + ' ';
                            } else {
                                if(typeof value == "string" && value.indexOf('"') > 0) { value = value.replace(/"/g, '&quot;'); }
                                strAttrs[i] += key + '="' + value + '" ';
                            }
                        }
                    }
                }catch(err){console.log(err);}
            }

            // Generate HTML code.
            var html =
                '<select ng-disabled="ngDisabled === true || ngDisabled[0] === true" ng-model="date" ng-blur="touched()" '+strAttrs[0]+' ng-options="date.value as date.name disable when date.disabled for date in dates"></select>' +
                '<select ng-disabled="ngDisabled === true || ngDisabled[1] === true" ng-model="month" ng-blur="touched()" '+strAttrs[1]+' ng-options="month.value as month.name disable when month.disabled for month in months"></select>' +
                '<select ng-disabled="ngDisabled === true || ngDisabled[2] === true" ng-model="year" ng-blur="touched()" '+strAttrs[2]+' ng-options="year.value as year.name disable when year.disabled for year in years"></select>'
            ;

            return html;
        }
    }
});

"use strict";/*!
 * @module ng-browser-detector
 * @description AngularJs service to detect platform, browser and version
 * @version v1.1.7
 * @link https://github.com/sibiraj-s/ng-browser-detector#readme
 * @licence MIT License, https://opensource.org/licenses/MIT
 */var $browser=function(a){var b=function(a){var b=a.toLowerCase(),c=/(edge)\/([\w.]+)/.exec(b)||/(opr)[/]([\w.]+)/.exec(b)||/(chrome)[/]([\w.]+)/.exec(b)||/(version)(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(b)||/(webkit)[/]([\w.]+).*(version)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(b)||/(webkit)[/]([\w.]+)/.exec(b)||/(opera)(?:.*version|)[/]([\w.]+)/.exec(b)||/(msie) ([\w.]+)/.exec(b)||0<=b.indexOf("trident")&&/(rv)(?::| )([\w.]+)/.exec(b)||0>b.indexOf("compatible")&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(b)||[],d=/(ipad)/.exec(b)||/(iphone)/.exec(b)||/(android)/.exec(b)||/(windows phone)/.exec(b)||/(win)/.exec(b)||/(mac)/.exec(b)||/(linux)/.exec(b)||/(cros)/.exec(b)||[];return{browser:c[5]||c[3]||c[1]||"",version:c[2]||c[4]||"0",versionNumber:c[4]||c[2]||"0",platform:d[0]||""}}(a.navigator.userAgent),c={};if(b.browser&&(c[b.browser]=!0,c.version=b.version,c.versionNumber=parseInt(b.versionNumber,10)),b.platform&&(c[b.platform]=!0),c.opr){b.browser="opera",c.opera=!0}if(c.rv){b.browser="msie",c.msie=!0}if(c.edge){b.browser="edge",c.edge=!0}if(c.safari&&c.android){b.browser="android",c.android=!0}return c.name=b.browser,c.platform=b.platform,{get:function(){return c},getName:function(){return c.name},getPlatform:function(){return"win"===c.platform?"windows":c.platform},getVersion:function(){return c.versionNumber},isIE:function(){return angular.isUndefined(c.msie)?null:c.msie},isMobile:function(){return c.android||c.ipad||c.iphone||c["windows phone"]},isDeskTop:function(){return c.cros||c.mac||c.linux||c.win},isWebKit:function(){return c.chrome||c.opr||c.safari}}},$browserDetector=function(a){return{restrict:"A",link:function(b,c,d){"attr"===d.browserDetector?(c.attr("browser",a.getName()),c.attr("browser-version","v-".concat(a.getVersion())),c.attr("platform",a.getPlatform())):(c.addClass(a.getPlatform()),c.addClass(a.getName()),c.addClass("v-".concat(a.getVersion())))}}};$browser.$inject=["$window"],$browserDetector.$inject=["appBrowser"],angular.module("ngBrowser",[]).factory("appBrowser",$browser).directive("browserDetector",$browserDetector);
//# sourceMappingURL=ng-browser-detector.min.js.map

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, PERMISSIONS)
    {   
        $scope.permissions = PERMISSIONS;
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
!function(t){"function"==typeof define&&define.amd?define(t):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3","function"==typeof define&&define.amd?define("jsPDF",function(){return ae}):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/*!
 * jQuery blockUI plugin
 * Version 2.70.0-2014.11.23
 * Requires jQuery v1.7 or later
 *
 * Examples at: http://malsup.com/jquery/block/
 * Copyright (c) 2007-2013 M. Alsup
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
 */

; (function () {
    /*jshint eqeqeq:false curly:false latedef:false */
    "use strict";

    function setup($) {
        $.fn._fadeIn = $.fn.fadeIn;

        var noOp = $.noop || function () { };

        // this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
        // confusing userAgent strings on Vista)
        var msie = /MSIE/.test(navigator.userAgent);
        var ie6 = /MSIE 6.0/.test(navigator.userAgent) && ! /MSIE 8.0/.test(navigator.userAgent);
        var mode = document.documentMode || 0;
        var setExpr = $.isFunction(document.createElement('div').style.setExpression);

        // global $ methods for blocking/unblocking the entire page
        $.blockUI = function (opts) { install(window, opts); };
        $.unblockUI = function (opts) { remove(window, opts); };

        // convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
        $.growlUI = function (title, message, timeout, onClose) {
            var $m = $('<div class="growlUI"></div>');
            if (title) $m.append('<h1>' + title + '</h1>');
            if (message) $m.append('<h2>' + message + '</h2>');
            if (timeout === undefined) timeout = 3000;

            // Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
            var callBlock = function (opts) {
                opts = opts || {};

                $.blockUI({
                    message: $m,
                    fadeIn: typeof opts.fadeIn !== 'undefined' ? opts.fadeIn : 700,
                    fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
                    timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
                    centerY: false,
                    showOverlay: false,
                    onUnblock: onClose,
                    css: $.blockUI.defaults.growlCSS
                });
            };

            callBlock();
            var nonmousedOpacity = $m.css('opacity');
            $m.mouseover(function () {
                callBlock({
                    fadeIn: 0,
                    timeout: 30000
                });

                var displayBlock = $('.blockMsg');
                displayBlock.stop(); // cancel fadeout if it has started
                displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
            }).mouseout(function () {
                $('.blockMsg').fadeOut(1000);
            });
            // End konapun additions
        };

        // plugin method for blocking element content
        $.fn.block = function (opts) {
            if (this[0] === window) {
                $.blockUI(opts);
                return this;
            }
            var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
            this.each(function () {
                var $el = $(this);
                if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked'))
                    return;
                $el.unblock({ fadeOut: 0 });
            });

            return this.each(function () {
                if ($.css(this, 'position') == 'static') {
                    this.style.position = 'relative';
                    $(this).data('blockUI.static', true);
                }
                this.style.zoom = 1; // force 'hasLayout' in ie
                install(this, opts);
            });
        };

        // plugin method for unblocking element content
        $.fn.unblock = function (opts) {
            if (this[0] === window) {
                $.unblockUI(opts);
                return this;
            }
            return this.each(function () {
                remove(this, opts);
            });
        };

        $.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!

        // override these in your code to change the default behavior and style
        $.blockUI.defaults = {
            // message displayed when blocking (use null for no message)
            message: '<h1>Please wait...</h1>',

            title: null,		// title string; only used when theme == true
            draggable: true,	// only used when theme == true (requires jquery-ui.js to be loaded)

            theme: false, // set to true to use with jQuery UI themes

            // styles for the message when blocking; if you wish to disable
            // these and use an external stylesheet then do this in your code:
            // $.blockUI.defaults.css = {};
            css: {
                padding: 0,
                margin: 0,
                width: '30%',
                top: '40%',
                left: '35%',
                textAlign: 'center',
                color: '#000',
                border: '3px solid #aaa',
                backgroundColor: '#fff',
                cursor: 'wait'
            },

            // minimal style set used when themes are used
            themedCSS: {
                width: '30%',
                top: '40%',
                left: '35%'
            },

            // styles for the overlay
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.6,
                cursor: 'wait'
            },

            // style to replace wait cursor before unblocking to correct issue
            // of lingering wait cursor
            cursorReset: 'default',

            // styles applied when using $.growlUI
            growlCSS: {
                width: '350px',
                top: '10px',
                left: '',
                right: '10px',
                border: 'none',
                padding: '5px',
                opacity: 0.6,
                cursor: 'default',
                color: '#fff',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                'border-radius': '10px'
            },

            // IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
            // (hat tip to Jorge H. N. de Vasconcelos)
            /*jshint scripturl:true */
            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',

            // force usage of iframe in non-IE browsers (handy for blocking applets)
            forceIframe: false,

            // z-index for the blocking overlay
            baseZ: 1000,

            // set these to true to have the message automatically centered
            centerX: true, // <-- only effects element blocking (page block controlled via css above)
            centerY: true,

            // allow body element to be stetched in ie6; this makes blocking look better
            // on "short" pages.  disable if you wish to prevent changes to the body height
            allowBodyStretch: true,

            // enable if you want key and mouse events to be disabled for content that is blocked
            bindEvents: true,

            // be default blockUI will supress tab navigation from leaving blocking content
            // (if bindEvents is true)
            constrainTabKey: true,

            // fadeIn time in millis; set to 0 to disable fadeIn on block
            fadeIn: 200,

            // fadeOut time in millis; set to 0 to disable fadeOut on unblock
            fadeOut: 400,

            // time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
            timeout: 0,

            // disable if you don't want to show the overlay
            showOverlay: true,

            // if true, focus will be placed in the first available input field when
            // page blocking
            focusInput: true,

            // elements that can receive focus
            focusableElements: ':input:enabled:visible',

            // suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
            // no longer needed in 2012
            // applyPlatformOpacityRules: true,

            // callback method invoked when fadeIn has completed and blocking message is visible
            onBlock: null,

            // callback method invoked when unblocking has completed; the callback is
            // passed the element that has been unblocked (which is the window object for page
            // blocks) and the options that were passed to the unblock call:
            //	onUnblock(element, options)
            onUnblock: null,

            // callback method invoked when the overlay area is clicked.
            // setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
            onOverlayClick: null,

            // don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
            quirksmodeOffsetHack: 4,

            // class name of the message block
            blockMsgClass: 'blockMsg',

            // if it is already blocked, then ignore it (don't unblock and reblock)
            ignoreIfBlocked: false
        };

        // private data and functions follow...

        var pageBlock = null;
        var pageBlockEls = [];

        function install(el, opts) {
            var css, themedCSS;
            var full = (el == window);
            var msg = (opts && opts.message !== undefined ? opts.message : undefined);
            opts = $.extend({}, $.blockUI.defaults, opts || {});

            if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked'))
                return;

            opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
            css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
            if (opts.onOverlayClick)
                opts.overlayCSS.cursor = 'pointer';

            themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
            msg = msg === undefined ? opts.message : msg;

            // remove the current block (if there is one)
            if (full && pageBlock)
                remove(window, { fadeOut: 0 });

            // if an existing element is being used as the blocking content then we capture
            // its current place in the DOM (and current display style) so we can restore
            // it when we unblock
            if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
                var node = msg.jquery ? msg[0] : msg;
                var data = {};
                $(el).data('blockUI.history', data);
                data.el = node;
                data.parent = node.parentNode;
                data.display = node.style.display;
                data.position = node.style.position;
                if (data.parent)
                    data.parent.removeChild(node);
            }

            $(el).data('blockUI.onUnblock', opts.onUnblock);
            var z = opts.baseZ;

            // blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
            // layer1 is the iframe layer which is used to supress bleed through of underlying content
            // layer2 is the overlay layer which has opacity and a wait cursor (by default)
            // layer3 is the message content that is displayed while blocking
            var lyr1, lyr2, lyr3, s;
            if (msie || opts.forceIframe)
                lyr1 = $('<iframe class="blockUI" style="z-index:' + (z++) + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + opts.iframeSrc + '"></iframe>');
            else
                lyr1 = $('<div class="blockUI" style="display:none"></div>');

            if (opts.theme)
                lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + (z++) + ';display:none"></div>');
            else
                lyr2 = $('<div class="blockUI blockOverlay" style="z-index:' + (z++) + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');

            if (opts.theme && full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:fixed">';
                if (opts.title) {
                    s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
                }
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += '</div>';
            }
            else if (opts.theme) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:absolute">';
                if (opts.title) {
                    s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
                }
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += '</div>';
            }
            else if (full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:' + (z + 10) + ';display:none;position:fixed"></div>';
            }
            else {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:' + (z + 10) + ';display:none;position:absolute"></div>';
            }
            lyr3 = $(s);

            // if we have a message, style it
            if (msg) {
                if (opts.theme) {
                    lyr3.css(themedCSS);
                    lyr3.addClass('ui-widget-content');
                }
                else
                    lyr3.css(css);
            }

            // style the overlay
            if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/)
                lyr2.css(opts.overlayCSS);
            lyr2.css('position', full ? 'fixed' : 'absolute');

            // make iframe layer transparent in IE
            if (msie || opts.forceIframe)
                lyr1.css('opacity', 0.0);

            //$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
            var layers = [lyr1, lyr2, lyr3], $par = full ? $('body') : $(el);
            $.each(layers, function () {
                this.appendTo($par);
            });

            if (opts.theme && opts.draggable && $.fn.draggable) {
                lyr3.draggable({
                    handle: '.ui-dialog-titlebar',
                    cancel: 'li'
                });
            }

            // ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
            var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
            if (ie6 || expr) {
                // give body 100% height
                if (full && opts.allowBodyStretch && $.support.boxModel)
                    $('html,body').css('height', '100%');

                // fix ie6 issue when blocked element has a border width
                if ((ie6 || !$.support.boxModel) && !full) {
                    var t = sz(el, 'borderTopWidth'), l = sz(el, 'borderLeftWidth');
                    var fixT = t ? '(0 - ' + t + ')' : 0;
                    var fixL = l ? '(0 - ' + l + ')' : 0;
                }

                // simulate fixed position
                $.each(layers, function (i, o) {
                    var s = o[0].style;
                    s.position = 'absolute';
                    if (i < 2) {
                        if (full)
                            s.setExpression('height', 'Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:' + opts.quirksmodeOffsetHack + ') + "px"');
                        else
                            s.setExpression('height', 'this.parentNode.offsetHeight + "px"');
                        if (full)
                            s.setExpression('width', 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
                        else
                            s.setExpression('width', 'this.parentNode.offsetWidth + "px"');
                        if (fixL) s.setExpression('left', fixL);
                        if (fixT) s.setExpression('top', fixT);
                    }
                    else if (opts.centerY) {
                        if (full) s.setExpression('top', '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
                        s.marginTop = 0;
                    }
                    else if (!opts.centerY && full) {
                        var top = (opts.css && opts.css.top) ? parseInt(opts.css.top, 10) : 0;
                        var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + ' + top + ') + "px"';
                        s.setExpression('top', expression);
                    }
                });
            }

            // show the message
            if (msg) {
                if (opts.theme)
                    lyr3.find('.ui-widget-content').append(msg);
                else
                    lyr3.append(msg);
                if (msg.jquery || msg.nodeType)
                    $(msg).show();
            }

            if ((msie || opts.forceIframe) && opts.showOverlay)
                lyr1.show(); // opacity is zero
            if (opts.fadeIn) {
                var cb = opts.onBlock ? opts.onBlock : noOp;
                var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
                var cb2 = msg ? cb : noOp;
                if (opts.showOverlay)
                    lyr2._fadeIn(opts.fadeIn, cb1);
                if (msg)
                    lyr3._fadeIn(opts.fadeIn, cb2);
            }
            else {
                if (opts.showOverlay)
                    lyr2.show();
                if (msg)
                    lyr3.show();
                if (opts.onBlock)
                    opts.onBlock.bind(lyr3)();
            }

            // bind key and mouse events
            bind(1, el, opts);

            if (full) {
                pageBlock = lyr3[0];
                pageBlockEls = $(opts.focusableElements, pageBlock);
                if (opts.focusInput)
                    setTimeout(focus, 20);
            }
            else
                center(lyr3[0], opts.centerX, opts.centerY);

            if (opts.timeout) {
                // auto-unblock
                var to = setTimeout(function () {
                    if (full)
                        $.unblockUI(opts);
                    else
                        $(el).unblock(opts);
                }, opts.timeout);
                $(el).data('blockUI.timeout', to);
            }
        }

        // remove the block
        function remove(el, opts) {
            var count;
            var full = (el == window);
            var $el = $(el);
            var data = $el.data('blockUI.history');
            var to = $el.data('blockUI.timeout');
            if (to) {
                clearTimeout(to);
                $el.removeData('blockUI.timeout');
            }
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            bind(0, el, opts); // unbind events

            if (opts.onUnblock === null) {
                opts.onUnblock = $el.data('blockUI.onUnblock');
                $el.removeData('blockUI.onUnblock');
            }

            var els;
            if (full) // crazy selector to handle odd field errors in ie6/7
                els = $('body').children().filter('.blockUI').add('body > .blockUI');
            else
                els = $el.find('>.blockUI');

            // fix cursor issue
            if (opts.cursorReset) {
                if (els.length > 1)
                    els[1].style.cursor = opts.cursorReset;
                if (els.length > 2)
                    els[2].style.cursor = opts.cursorReset;
            }

            if (full)
                pageBlock = pageBlockEls = null;

            if (opts.fadeOut) {
                count = els.length;
                els.stop().fadeOut(opts.fadeOut, function () {
                    if (--count === 0)
                        reset(els, data, opts, el);
                });
            }
            else
                reset(els, data, opts, el);
        }

        // move blocking element back into the DOM where it started
        function reset(els, data, opts, el) {
            var $el = $(el);
            if ($el.data('blockUI.isBlocked'))
                return;

            els.each(function (i, o) {
                // remove via DOM calls so we don't lose event handlers
                if (this.parentNode)
                    this.parentNode.removeChild(this);
            });

            if (data && data.el) {
                data.el.style.display = data.display;
                data.el.style.position = data.position;
                data.el.style.cursor = 'default'; // #59
                if (data.parent)
                    data.parent.appendChild(data.el);
                $el.removeData('blockUI.history');
            }

            if ($el.data('blockUI.static')) {
                $el.css('position', 'static'); // #22
            }

            if (typeof opts.onUnblock == 'function')
                opts.onUnblock(el, opts);

            // fix issue in Safari 6 where block artifacts remain until reflow
            var body = $(document.body), w = body.width(), cssW = body[0].style.width;
            body.width(w - 1).width(w);
            body[0].style.width = cssW;
        }

        // bind/unbind the handler
        function bind(b, el, opts) {
            var full = el == window, $el = $(el);

            // don't bother unbinding if there is nothing to unbind
            if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
                return;

            $el.data('blockUI.isBlocked', b);

            // don't bind events when overlay is not in use or if bindEvents is false
            if (!full || !opts.bindEvents || (b && !opts.showOverlay))
                return;

            // bind anchors and inputs for mouse and key events
            var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
            if (b)
                $(document).bind(events, opts, handler);
            else
                $(document).unbind(events, handler);

            // former impl...
            //		var $e = $('a,:input');
            //		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
        }

        // event handler to suppress keyboard/mouse events when blocking
        function handler(e) {
            // allow tab navigation (conditionally)
            if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
                if (pageBlock && e.data.constrainTabKey) {
                    var els = pageBlockEls;
                    var fwd = !e.shiftKey && e.target === els[els.length - 1];
                    var back = e.shiftKey && e.target === els[0];
                    if (fwd || back) {
                        setTimeout(function () { focus(back); }, 10);
                        return false;
                    }
                }
            }
            var opts = e.data;
            var target = $(e.target);
            if (target.hasClass('blockOverlay') && opts.onOverlayClick)
                opts.onOverlayClick(e);

            // allow events within the message content
            if (target.parents('div.' + opts.blockMsgClass).length > 0)
                return true;

            // allow events for content that is not being blocked
            return target.parents().children().filter('div.blockUI').length === 0;
        }

        function focus(back) {
            if (!pageBlockEls)
                return;
            var e = pageBlockEls[back === true ? pageBlockEls.length - 1 : 0];
            if (e)
                e.focus();
        }

        function center(el, x, y) {
            var p = el.parentNode, s = el.style;
            var l = ((p.offsetWidth - el.offsetWidth) / 2) - sz(p, 'borderLeftWidth');
            var t = ((p.offsetHeight - el.offsetHeight) / 2) - sz(p, 'borderTopWidth');
            if (x) s.left = l > 0 ? (l + 'px') : '0';
            if (y) s.top = t > 0 ? (t + 'px') : '0';
        }

        function sz(el, p) {
            return parseInt($.css(el, p), 10) || 0;
        }

    }


    /*global define:true */
    if (typeof define === 'function' && define.amd && define.amd.jQuery) {
        define(['jquery'], setup);
    } else {
        setup(jQuery);
    }

})();
(function () {
  'use strict';

  angular
    .module('app.front')
    .directive('fileUpload', function ($rootScope) {
      return {
        templateUrl: 'app/main/input-file.html',

        link: function (scope, element) {
          scope.fileName = 'Choisir un fichier...';
          scope.fileNames = [];
          scope.nofile = true;
          element.bind('change', function () {
            scope.$apply(function () {
              scope.fileNames = element[0].getElementsByTagName('input')['document_input_file'].files;
              if (scope.fileNames.length > 0) {
                var container = element[0].getElementsByTagName('div')['container'];
                container.classList.remove('upload-field');
                container.classList.add('upload-field-file');
                scope.fileName = '';
                scope.nofile = false;
                var el = element[0].getAttribute("id")
                var parts = []
                if (el) {
                  parts = el.split('_')
                }
                var id = parts.length > 0 ? parts[1] : null
                scope.$emit('fileUploaded', { id: id });
              }
              else {
                scope.removeFile();
              }
            });
          });

          var elem = element[0].getElementsByTagName('input')['document_input_file'];
          elem.addEventListener('click', function () {
            scope.$emit('filefocus')
          })

          scope.removeFile = function () {
            var elem = element[0].getElementsByTagName('input')['document_input_file'];
            elem.value = "";
            var container = element[0].getElementsByTagName('div')['container'];
            container.classList.remove('upload-field-file');
            container.classList.add('upload-field');
            scope.fileName = 'Choisir un fichier...';
            scope.nofile = true;

            // Add code to submit the formData
          };
        }
      };
    }).directive('fileUploadSingle', function () {
      return {
        templateUrl: 'app/main/input-file-single.html',

        link: function (scope, element) {
          scope.fileName = 'Choisir un fichier...';
          scope.fileNames = [];
          scope.nofile = true;
          element.bind('change', function () {
            scope.$apply(function () {
              scope.fileNames = element[0].getElementsByTagName('input')['document_input_file'].files;
              if (scope.fileNames.length > 0) {
                var container = element[0].getElementsByTagName('div')['container'];
                container.classList.remove('upload-field');
                container.classList.add('upload-field-file');
                scope.fileName = '';
                scope.nofile = false;
                var el = element[0].getAttribute("id")
                var parts = []
                if (el) {
                  parts = el.split('_')
                }
                var id = parts.length > 0 ? parts[1] : null
                scope.$emit('fileUploaded', { id: id });
              }
              else {
                scope.removeFile();
              }
            });
          });

          var elem = element[0].getElementsByTagName('input')['document_input_file'];
          elem.addEventListener('click', function () {
            scope.$emit('filefocus')
          })

          scope.removeFile = function () {
            var elem = element[0].getElementsByTagName('input')['document_input_file'].files;
            elem.value = "";
            var container = element[0].getElementsByTagName('div')['container'];
            container.classList.remove('upload-field-file');
            container.classList.add('upload-field');
            scope.fileName = 'Choisir un fichier...';
            scope.nofile = true;
            scope.$emit('fileUploaded');
            // Add code to submit the formData
          };
        }
      };
    });
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .directive("droppable", ['$rootScope', function($rootScope) {

            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    scope.dropData = scope[attrs["droppable"]];
                    scope.dropStyle = attrs["dropstyle"];

                    // Counter to handle dragenter/dragleave bubbling from child nodes:
                    // dragleave fires when crossing onto a child, so we only remove
                    // the highlight when the counter returns to 0 (cursor truly left).
                    var enterCounter = 0;

                    function clearHighlight() {
                        enterCounter = 0;
                        element.removeClass(scope.dropStyle);
                    }

                    element.bind('dragenter', function(evt) {
                        evt.preventDefault();
                        enterCounter++;
                        if (enterCounter === 1) {
                            element.addClass(scope.dropStyle);
                        }
                    });
                    element.bind('dragleave', function(evt) {
                        evt.preventDefault();
                        enterCounter--;
                        if (enterCounter <= 0) {
                            clearHighlight();
                        }
                    });
                    element.bind('dragover', function(evt) {
                        evt.preventDefault();
                    });
                    element.bind('drop', function(evt) {
                        evt.preventDefault();
                        clearHighlight();
                        $rootScope.$broadcast('dropEvent', $rootScope.dragData, scope.dropData);
                    });
                    // Safety net: if the drag ends anywhere (Esc, drop outside),
                    // make sure the highlight is cleared.
                    element.bind('dragend', clearHighlight);
                }
            }
    }]);
})();
(function () {
    'use strict';

    angular
        .module('app.front')
        .directive("draggable", ["$rootScope", function ($rootScope) {

            function dragStart(evt, element, scope) {
                element.addClass(scope.dragStyle);
                evt.originalEvent.dataTransfer.setData("document", scope["drag"]);
                evt.originalEvent.dataTransfer.effectAllowed = 'move';
            };
            function dragEnd(evt, element, dragStyle) {
                element.removeClass(dragStyle);
            };

            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.dragStyle = attrs["dragstyle"];
                    element.bind('dragstart', function (evt) {
                        $rootScope.dragData = scope[attrs["drag"]]
                        dragStart(evt, element, scope);
                    });
                    element.bind('dragend', function (evt) {
                        dragEnd(evt, element, scope.dragStyle);
                    });
                }
            }
        }]);
})();
(function () {
    'use strict';

    angular.module('fuse').service('DocGenerationService', DocGenerationService);

    function DocGenerationService($q, $http, $window) {

        var service = {};

        service.generateDocumentType = function (type) {
            return $q(function (resolve, reject) {
                $http({
                    url: "/api/rest/docgeneration/" + type,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    var printWindow = window.open("/api/rest/docgeneration/download/?location=" + response.data);
                    printWindow.print();
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        };

        service.generateDocumentTypeWithId = function (type, id) {
            return $q(function (resolve, reject) {
                $http({
                    url: "/api/rest/docgeneration/" + type + "/" + id,
                    method: "GET",
                    params: { '_v': new Date().getTime() },
                    headers: { "Content-Type": "application/json;charset=UTF-8" }
                }).then(function (response) {
                    window.open("/api/rest/docgeneration/download/?location=" + response.data);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .controller('DialogController', DialogController);

    function DialogController(type, datasource, $scope, $mdDialog, $filter, toastr, EquipeDetailService, TachesGeneralesService,
        ReunionService, TASKS_EVENTS_REMINDERS, GENERAL_TASK_TYPES, GENERAL_TASK_PERIOD, SELECT_HOURS_EVENTS, api, EventService, CahierTransmissionService, $timeout, $rootScope) {

        /* VARIABLES */
        $scope._isSaving = false;
        $scope._reminders = angular.copy(TASKS_EVENTS_REMINDERS);
        $scope._categories = angular.copy(GENERAL_TASK_TYPES);
        $scope._recurrences = angular.copy(GENERAL_TASK_PERIOD);
        $scope.hourEvents = angular.copy(SELECT_HOURS_EVENTS);
        $scope._task = angular.copy(datasource.task);
        $scope._oldTask = angular.copy(datasource.task);
        $scope.event = angular.copy(datasource.event);
        $scope._oldEvent = angular.copy(datasource.event);
        $scope.echeance = angular.copy(datasource.echeance);
        $scope.fromManagementReview = datasource.fromManagementReview;
        $scope.hours = []
        $scope.durations = []
        $scope.start = new Date()
        $scope.start.setHours(7, 0, 0, 0)
        var originalDayOfYear = moment($scope.start).dayOfYear()
        while (moment($scope.start).dayOfYear() === originalDayOfYear) {
            $scope.hours.push($filter('date')($scope.start, 'HH:mm'))
            $scope.start = moment($scope.start).add(5, 'minutes').toDate()
        }
        $scope.start.setHours(0, 0, 0, 0)
        while (moment($scope.start).hour() < 4 || moment($scope.start).hour() === 4 && moment($scope.start).minute() === 0) {
            $scope.durations.push($filter('date')($scope.start, 'HH:mm'))
            $scope.start = moment($scope.start).add(5, 'minutes').toDate()
        }
        $scope.taskType = null

        if ($scope._task) {
            if ($scope._task.category === 'ACTION_DECIDEE_REVUE_DIRECTION') {
                $scope.taskType = 'Tâche décidée en Bilan de performances'
                $scope._task.fromManagementReview = datasource.fromManagementReview;
            } else if ($scope._task.category === 'ACTION_DECIDEE_REVUE_EQUIPE') {
                $scope.taskType = 'Tâche décidée en compte-rendu'
            } else if ($scope._task.category === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
                $scope.taskType = 'Tâche décidée en fiche de progrès'
            } else if ($scope._task.category === 'OBJECTIF_STRATEGIQUE') {
                $scope.taskType = 'Tâche décidée en plan stratégique'
            } else if ($scope._task.category === 'AUDITS_ET_ECARTS') {
                $scope.taskType = 'Tâche décidée en audit'
            } else if ($scope._task.category === 'REUNION') {
                $scope.taskType = 'Tâche décidée en réunion'
            } else if ($scope._task.category === 'PROJECT') {
                $scope.taskType = 'Tâche décidée en suivi de projet'
            } else if ($scope._task.category != null && $scope._task.category.lastIndexOf('PREMIERE_ANNEE_DEMARCHE_QUALITE') > -1) {
                $scope.taskType = 'Tâche décidée en démarche qualité'
            }
            if ($scope._task.echeance != null) {
                $scope._task.heure = $filter('date')($scope._task.echeance, 'HH:mm')
            }
        }

        $scope._tools = {
            AGAIN: false,
            OPEN: false
        }
        $scope.updateFutureTasks = {
            value: false
        };
        $scope._baseResource = '/api/rest/tacheGeneral';

        // api
        $scope.api = api;

        // Helpers

        $scope._getHours = function (_date) {
            return _date.getHours();
        };

        $scope._setHours = function (_date, _hours) {
            _date.setHours(_hours);
        };

        $scope._getMinutes = function (_date) {
            return _date.getMinutes();
        };

        $scope._setMinutes = function (_date, _minutes) {
            _date.setMinutes(_minutes);
        };

        $scope.refreshTags = function () {
            CahierTransmissionService.findTags().then(function (res) {
                $scope.tags = res.data
                $scope._tags = angular.copy(res.data)
                for (var i = $scope.tags.length - 1; i >= 0; i--) {
                    if ($scope._task.tags.find(t => t.id === $scope.tags[i].id) != null) {
                        $scope.tags.splice(i, 1)
                    }
                }
            }).catch(function () { })
        }

        $scope.refreshTags()


        /* CHECK TYPE AND ADAPT TEMPLATE */
        var __checkType = function (myType) {
            switch (myType) {
                case 'PROGRESS_FORM':
                    $scope._from_FICHE = true;
                    break;
                case 'AUTO':
                    $scope._from_AUTO = true;
                    break;
                case 'CRR':
                    $scope._from_REUNION = true;
                    break;
                case 'REUNION':
                    $scope._reunion = datasource.reunion;
                    break;
                case 'ODJ':
                    $scope._reunion = datasource.reunion;
                    $scope._odj = true;
                    break;
                case 'AUDIT':
                    $scope._from_AUDIT = true;
                    break;
                case 'RDD':
                    $scope._from_RDD = true;
                    break;
                case 'PLAN':
                    $scope._from_PLAN = true;
                    break;
                case 'PLAN_STRATEGIQUE':
                    $scope._from_PLAN_STRATEGIQUE = true;
                    break;
                case 'QUALITY':
                    $scope._from_QUALITY = true;
                    break;
                default:
                    break;
            }
            if ($scope._task && $scope._task.category == null) {
                $scope._task.category = "AUTRE";
            }
        };

        $scope.$on('fileUploaded', function () {
            var fileinput = document.getElementById("document_input_file");
            var popup = document.getElementById('add-task-event-popup')
            if (popup) {
                if ($scope._task.event) {
                    fileinput = document.getElementById('event-input-file').getElementsByTagName('input')['document_input_file'];
                } else {
                    fileinput = document.getElementById('task-input-file').getElementsByTagName('input')['document_input_file'];
                }
            }
            $scope._task.nameOfDocument = "";
            for (var i = 0; i < fileinput.files.length; i++) {
                var name = fileinput.files[i].name
                $scope._task.nameOfDocument += name ? name : "Nom du fichier indisponible";
            }
        });

        $scope.clearInputFile = function (input, id_input) {
            var elem = document.getElementById(id_input);
            elem.value = "";
            input.nameOfDocument = ""
            input.attachmentOriginalName = null
        };



        /* FUNCTIONS */

        $scope.saveEvent = function () {
            if (!$scope.intoSaving) {
                $scope.intoSaving = true;
                if (!$scope.event.allDay) {
                    var start = $scope.event.startDate;
                    var end = $scope.event.endDate;

                    start.setHours(0, 0, 0, 0);
                    end.setHours(0, 0, 0, 0);

                    var startTime = start.getTime() + $scope.event.startHoursDay;
                    var endTime = end.getTime() + $scope.event.endHoursDay;

                    if (startTime > endTime) {
                        toastr.error("Erreur: la date de début doit être antérieure à la date de fin.");
                        $scope.intoSaving = false;
                        return;
                    }

                    $scope.event.echeance = startTime;
                    $scope.event.ending = endTime;
                } else {
                    $scope.event.echeance = $scope.event.startDate.getTime();
                }

                var file = document.getElementById('document_input_file').files[0];
                var formData = new FormData();
                if (file != null) {
                    formData.append('file', file);
                }
                formData.append('dto', angular.toJson($scope.event));
                EventService.save(formData, $scope.updateFutureTasks.value).then(function (response) {
                    if ($scope.event.id) {
                        toastr.success("Evénement modifié avec succès");
                    } else {
                        toastr.success("Evénement sauvegardée avec succès");
                    }
                    $scope.__closeDialog();
                    $timeout(function () {
                        $scope.intoSaving = false;
                    });
                }).catch(function (err) {
                    console.log(err);
                    $scope.intoSaving = false;
                });
            }

        };

        $scope._closeDialog = function () {
            $scope.__closeDialog();
        }

        $scope.hidePopup = function () {
            $scope.__closeDialog();
        }

        $scope.__closeDialog = function (param) {
            $mdDialog.hide(param);
        }
        $scope.__saveTask = function () {
            if (!$scope._isSaving) {
                var formData = __commonSave();
                if (type === 'PROGRESS_FORM') {
                    __checkReminder();
                }
                if (type === 'RDD') {
                    if ($scope._task.fromManagementReview == null && $scope.fromManagementReview != null) {
                        $scope._task.fromManagementReview = $scope.fromManagementReview;
                    }
                    if (($scope._task.category === 'ACTION_DECIDEE_REVUE_DIRECTION' || $scope._from_RDD) && !$scope._task.categoryTmp) {
                        toastr.error("Veuillez enregistrer la catégorie avant de planifier une tâche.");
                        $scope._isSaving = false;
                        return;
                    }
                }
                formData.append('dto', angular.toJson($scope._task));
                if ($scope._task.event) {
                    EventService.save(formData, $scope.updateFutureTasks.value).then(function (response) {
                        if ($scope._task.id) {
                            toastr.success("Evénement modifié avec succès");
                        } else {
                            toastr.success("Evénement sauvegardée avec succès");
                        }
                        $scope.__closeDialog('success');
                        $timeout(function () {
                            $scope.intoSaving = false;
                        });
                    }).catch(function (err) {
                        console.log(err);
                        $scope.intoSaving = false;
                    });
                } else {
                    if ($scope._task.progressFormId != null && !$scope._oldTask.done && $scope._task.done && $scope._task.nbrProgressFormLeft === 1) {
                        $mdDialog
                            .show({
                                templateUrl:
                                    "app/main/front/equipe/taches-generales/confirm_progress_form.html",
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                                multiple: true,
                                // onRemoving: function (event, removePromise) {
                                //   $scope._hideConfirmEventPopUp();
                                // },
                                scope: $scope,
                                preserveScope: true
                            })
                            .then(function () { })
                            .catch(function () { });
                        $scope._isSaving = false;
                        return;
                    }
                    __SaveTaskCall(formData);
                }
            }
        };

        $scope.__saveReunion = function () {
            if (!$scope._isSaving) {
                $scope._reunion.dateStart.setHours(0, 0, 0, 0);
                if (!$scope._odj && $scope._reunion.dateStart < $scope._reunion.dateEnd) {
                    __SaveReunionCall();
                }
                else if ($scope._odj) {
                    __SaveReunionCall();
                }
            }
        };
        $scope.__addCollaborateur = function () {
            $scope.addCollaborateurMode = !$scope.addCollaborateurMode;
            $scope._task.responsable = {};
        };
        $scope.__addAction = function (ficheProgres, addAgain) {
            $scope.ficheProgres = angular.copy(ficheProgres);
            $scope._today = new Date();
            $scope.minDateEcheance = angular.copy($scope._today);
            $scope.maxDateEcheance = angular.copy($scope.minDateEcheance);
            $scope.maxDateEcheance.setFullYear();
            $scope.maxDateEcheance.setFullYear($scope._today.getFullYear() + 20);
            $scope._categories = GENERAL_TASK_TYPES;
            $scope.fromFicheProgres = true;
            $scope.echeance = new Date();

            if (!addAgain) {
                $scope._task = {
                    progressFormId: ficheProgres.id,
                    _echeance: moment($scope._today),
                    echeance: $scope._today.getTime()
                };
            }
            for (var i = 0; i < $scope._categories.length; i++) {
                if ($scope._categories[i].value === 'ACTION_PREVENTIVE_OU_CORRECTIVE') {
                    $scope._task.category = $scope._categories[i].value;
                }
            }

            showTaskModal();
        };

        function showTaskModal($event) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                clickOutsideToClose: true,
                templateUrl: 'app/main/front/equipe/taches-generales/tacheGenerales.dialog.html',
                locals: {
                    type: "PROGRESS_FORM",
                    datasource: {
                        task: $scope._task,
                        progress_form: datasource.progress_form
                    }
                },
                controller: "DialogController"
            }).then(function () {

            }).catch(function () {

            });
        }

        var __commonSave = function () {
            $scope._isSaving = true;
            var popup = document.getElementById('add-task-event-popup')
            var file = null
            if (popup) {
                if ($scope._task.event) {
                    file = document.getElementById('event-input-file').getElementsByTagName('input')['document_input_file'].files[0];
                } else {
                    file = document.getElementById('task-input-file').getElementsByTagName('input')['document_input_file'].files[0];
                }
            } else {
                file = document.getElementById('document_input_file').files[0];
            }
            var formData = new FormData();
            if (file != null) {
                formData.append('file', file);
            }
            if ($scope.echeance) {
                $scope._task.echeance = $scope.echeance.getTime();
            } else if ($scope._task.echeance) {
                $scope._task.echeance = $scope._task.echeance.getTime();
            }
            if ($scope._task.heure != null && $scope._task.echeance != null) {
                var day = moment($scope._task.echeance).format('DD/MM/YYYY')
                $scope._task.echeance = moment(day + ' ' + $scope._task.heure, 'DD/MM/YYYY HH:mm').valueOf()
            }
            if ($scope._task.event && $scope._task.duration != null) {
                var begin = moment($scope._task.echeance)
                var hour = $scope._task.duration.split(':')[0]
                var minute = $scope._task.duration.split(':')[1]
                var end = begin.add(parseInt(hour), 'hours').add(parseInt(minute), 'minutes').valueOf()
                $scope._task.ending = end
            }
            return formData;
        }
        var __checkReminder = function () {
            //Reminder: "le jour même"
            if ($scope._task.reminder === 0) {
                var date = new Date($scope._task.echeance);
                date.setHours(0, 0, 0, 0);
                $scope._task.reminder = $scope._task.echeance - date.getTime();
            }
        }
        $scope._dateStartHandle = function () {
            if ($scope._reunion.wholeDay) {
                $scope._wholeDay();
            } else {
                //$scope._setHours($scope._reunion.dateStart, $scope._reunion.hourStart);
                //$scope._setMinutes($scope._reunion.dateStart, $scope._reunion.minuteStart);

                if ($scope._reunion.dateStart > $scope._reunion.dateEnd) {

                    var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
                    $scope._reunion.dateEnd = angular.copy(_newDateEndInstance);

                    $scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
                    $scope._setHours($scope._reunion.dateEnd, $scope._reunion.hourEnd + 1);

                    $scope._reunion.minuteEnd = $scope._getMinutes($scope._reunion.dateEnd);
                    $scope._setMinutes($scope._reunion.dateEnd, $scope._reunion.minuteEnd);

                }
            }

        };

        $scope._wholeDay = function () {
            if ($scope._reunion.wholeDay) {

                $scope._setHours($scope._reunion.dateStart, 9);
                $scope._setMinutes($scope._reunion.dateStart, 0);
                $scope._reunion.hourStart = $scope._getHours($scope._reunion.dateStart);
                $scope._reunion.minuteStart = $scope._getMinutes($scope._reunion.dateStart);

                var _newDateEndInstance = angular.copy($scope._reunion.dateStart);
                $scope._reunion.dateEnd = angular.copy(_newDateEndInstance);
                $scope._setHours($scope._reunion.dateEnd, 18);
                $scope._setMinutes($scope._reunion.dateEnd, 0);
                $scope._reunion.hourEnd = $scope._getHours($scope._reunion.dateEnd);
                $scope._reunion.minuteEnd = $scope._getMinutes($scope._reunion.dateEnd);

            }
        };

        $scope._downloadAttachement = function (_attachment) {
            location.href = $scope._baseResource + '/download/' + _attachment.id;
        };

        /* CALL TO SERVICES */
        var __SaveTaskCall = function (formData) {
            TachesGeneralesService.save(formData, $scope.updateFutureTasks.value).then(function (response) {
                $rootScope.$broadcast('refreshCountNotifs');
                if ($scope._task.category === 'OBJECTIF_STRATEGIQUE') {
                    if ($scope._task.idEnum) {
                        $rootScope.$broadcast('refreshPlan')
                    } else {
                        $rootScope.$broadcast('refreshObjectives')
                    }
                } else if ($scope._task.category === 'PROJECT') {
                    $rootScope.$broadcast('refreshTasks')
                }
                if (response.data.progressFormId != null && $scope._task.nbrTasksNotDonePF != response.data.nbrTasksNotDonePF) {
                    if (response.data.nbrTasksNotDonePF > 1) {
                        toastr.success('Il reste ' + response.data.nbrTasksNotDonePF + ' tâches associées à la fiche de progrès.');
                    } else if (response.data.nbrTasksNotDonePF === 1) {
                        toastr.success('Il reste ' + response.data.nbrTasksNotDonePF + ' tâche associée à la fiche de progrès.');
                    } else {
                        toastr.success('La fiche de progrès associée a été cloturée');
                    }
                }
                if ($scope._tools.AGAIN) {
                    $scope.__addAction(datasource.progress_form, true);
                }
                if (type === 'REUNION' || type === 'CRR') {
                    SUCC('Sauvegardée avec succès.', true, response.data);
                } else if (type === 'AUTRE') {
                    SUCC('Sauvegardée avec succès.', true, 'success');
                } else {
                    SUCC('Sauvegardée avec succès.', true);
                }

            }).catch(function (error) {
                ERR(error);
            });
        }
        var __SaveReunionCall = function () {
            ReunionService.save($scope._reunion).then(function (response) {
                ReunionService.findReunion(response.data.id).then(function (response) {
                    $rootScope.$broadcast('refreshCountNotifs');
                    SUCC('Sauvegardée avec succès.', true, response.data);
                }).catch(function (error) {
                    ERR(error);
                });
            }).catch(function (error) {
                ERR(error);
            });
        }
        var __GetCollaborateurs = function () {
            EquipeDetailService.getCollaborateurs().then(function (data) {
                $scope._users = data;
            }).catch(function (response) {

            });
        }



        /* GESTION DES ETATS */
        var ERR = function (error) {
            console.log(error);
            $scope._isSaving = false;
            toastr.error('Une erreur s\'est produite.');
        }
        var SUCC = function (success, close, param) {
            toastr.success(success);
            $scope._isSaving = false;
            if (close) $scope.__closeDialog(param);
        }



        /* ALL INIT */
        $scope._inits = function (refresh) {
            __checkType(type);
            __GetCollaborateurs();
        }
        $scope._inits();

        $scope.recurrenceChanged = function () {
            if ($scope._oldTask != null) {
                // si on change de récurrence, on coche la case "Appliquer aux éléments futurs"
                if ($scope._oldTask.recurrence !== $scope._task.recurrence) {
                    $scope.updateFutureTasks.value = true;
                    // sinon si la checkbox est désactivée, on décoche la case "Appliquer aux éléments futurs"
                } else if ($scope._task.echeance != null && $scope._oldTask.echeance === $scope._task.echeance.getTime()) {
                    $scope.updateFutureTasks.value = false;
                }
            }
            if ($scope._oldEvent != null) {
                // si on change de récurrence, on coche la case "Appliquer aux éléments futurs"
                if ($scope._oldEvent.recurrence !== $scope.event.recurrence) {
                    $scope.updateFutureTasks.value = true;
                    // sinon si la checkbox est désactivée, on décoche la case "Appliquer aux éléments futurs"
                } else if ($scope.disableCheckbox()) {
                    $scope.updateFutureTasks.value = false;
                }
            }
        };

        // fonction seulement pour modification événement
        $scope.disableCheckbox = function () {
            if ($scope.event != null && $scope._oldEvent != null) {
                if ($scope.event.recurrence !== $scope._oldEvent.recurrence) {
                    return true;
                }
                if ($scope._oldEvent.allDay != $scope.event.allDay) {
                    return false;
                }
                if ($scope.event.allDay) {
                    if ($scope._oldEvent.startDate.getTime() !== $scope.event.startDate.getTime()) {
                        return false;
                    }
                } else {
                    if ($scope.event.startDate.getTime() != $scope._oldEvent.startDate.getTime() || $scope.event.endDate.getTime() !== $scope._oldEvent.endDate.getTime()
                        || $scope.event.startHoursDay !== $scope._oldEvent.startHoursDay || $scope.event.endHoursDay !== $scope._oldEvent.endHoursDay) {
                        return false;
                    }
                }
            }
            return true;
        }

        $scope.changeCollab = function (idSelected) {
            $scope.idSelected = idSelected ? idSelected : $scope.idSelected;
            if (!idSelected) {
                $scope.collaborateur = {
                    name: null,
                    surname: null,
                    id: null,
                    fichePoste: {}
                };

                $scope.titlePopupSave = 'Ajouter un collaborateur';
                $scope.updateMode = false;
                $scope.descriptionMode = true;

                $scope.equipePopup = $mdDialog.show({
                    templateUrl: 'app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true,
                    multiple: true,
                    controller: 'EquipeDetailController'
                }).then(function (data) {
                    $scope._task.responsable.id = data || $scope.idSelected;
                }).catch(function (error) {
                    $scope._task.responsable.id = null;
                });
                return;
            }
        };

        $scope._done = function (task) {
            $mdDialog.hide();
            $scope._task.nbrProgressFormLeft--;
            $scope.__saveTask(task)
        }

        $scope._hideConfirmEventPopUp = function () {
            $mdDialog.hide()
        }

        $scope.tagSelected = function () {

        }

        $scope.openTag = function () {
            if ($rootScope.user.isTeam) {
                toastr.error('La création d’un système de tags est réservée aux comptes Titulaire et Responsable Qualité')
                return
            }
            $scope.tagsToUpdate = angular.copy($scope._tags.filter(t => !t.notDeletable))
            if ($scope.tagsToUpdate.length === 0) {
                $scope.tagsToUpdate = [{}, {}, {}]
            }
            $mdDialog.show({
                templateUrl:
                    "app/main/front/home/popup/add_tag.html",
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true,
                multiple: true,
                onRemoving: function (event, promise) {
                }
            });
        }

        $scope.deleteTag = function (index) {
            $scope.tagsToUpdate.splice(index, 1)
        }

        $scope.addTag = function () {
            if ($scope.tagsToUpdate.length < 20) {
                $scope.tagsToUpdate.push({})
            } else {
                toastr.error('Vous avez atteint le nombre maximal de tags')
            }
        }

        $scope.saveTags = function () {
            CahierTransmissionService.saveTags($scope.tagsToUpdate.filter(t => t.libelle)).then(function (res) {
                $scope.tags = res.data
                $scope._tags = angular.copy(res.data)
                if ($scope._task) {
                    for (var i = $scope.tags.length - 1; i >= 0; i--) {
                        if ($scope._task.tags && $scope._task.tags.find(t => t.id === $scope.tags[i].id) != null) {
                            $scope.tags.splice(i, 1)
                        }
                    }
                }
                $mdDialog.hide()
            }).catch(function (err) {
                console.log(err)
                toastr.error('Une erreur est survenue')
            })
        }

        $scope.deleteTaskTag = function (index, task) {
            $scope.tags.push(task.tags[index])
            $scope.tags.sort((a, b) => a.libelle.localeCompare(b.libelle))
            task.tags.splice(index, 1)
        }

        $scope.includeTag = function (tag) {
            if (tag.libelle != null) {
                tag.libelle = tag.libelle.replace(/[^a-zA-Z0-9]/g, "");
                if (tag.libelle.length > 0 && !tag.libelle.startsWith('#')) {
                    tag.libelle = '#' + tag.libelle
                }
            }
        }

        $scope.selectTag = function (tag, task) {
            if (task.tags == null) {
                task.tags = []
            }
            if (task.tags.length >= 3) {
                toastr.error('Vous pouvez sélectionner 3 tags maximum')
                return
            }
            task.tags.push(tag)
            for (var i = $scope.tags.length - 1; i >= 0; i--) {
                if (tag.id === $scope.tags[i].id) {
                    $scope.tags.splice(i, 1)
                    break
                }
            }
        }
    }

})();

(function () {
	'use strict';

	angular.module("app.front").directive('calendar', function ($http, $filter, moment, $document, $window, $timeout, $state) {


		var directive = {
			restrict: "E",
			templateUrl: 'app/main/calendar.html',
			scope: {
				//tableau de dates des éléments sélectionnées
				selected: "=?",
				calendar: "=cal",
				//planning
				planning: "=planning",
				// Classname for color theme
				colorTheme: "@",
				getday: '&getDayFn'
			},
			link: linkFunc
		};

		return directive;

		function linkFunc(scope) {
			scope.previousMonth = function () {
				var firstMonth = moment(scope.months[0].date).subtract(1, 'months');
				var newFirstDateMonth = angular.copy(firstMonth).date(1).isoWeekday(1).hour(0).minute(0).second(0).millisecond(0);
				var newFirstMonth = {
					date: firstMonth.toDate(),
					name: $filter('date')(firstMonth.toDate(), 'MMMM'),
					year: $filter('date')(firstMonth.toDate(), 'yyyy'),
					weeks: _buildMonth(scope, newFirstDateMonth, firstMonth, [])
				};
				scope.planning.beginDate = moment(firstMonth).startOf('month').valueOf();
				scope.planning.endDate = moment(scope.months[0].date).endOf('month').valueOf();
				scope.$emit('refreshDate');
				scope.months.splice(0, 0, newFirstMonth);
				scope.months.splice(scope.months.length - 1, 1);
			};

			scope.nextMonth = function () {
				var lastMonth = moment(scope.months[1].date).add(1, 'months');
				var newFirstDateMonth = angular.copy(lastMonth).date(1).isoWeekday(1).hour(0).minute(0).second(0).millisecond(0);
				var newLastMonth = {
					date: lastMonth.toDate(),
					name: $filter('date')(lastMonth.toDate(), 'MMMM'),
					year: $filter('date')(lastMonth.toDate(), 'yyyy'),
					weeks: _buildMonth(scope, newFirstDateMonth, lastMonth, [])
				};
				scope.planning.beginDate = moment(scope.months[1].date).startOf('month').valueOf();
				scope.planning.endDate = moment(lastMonth).endOf('month').valueOf();
				scope.$emit('refreshDate');
				scope.months.push(newLastMonth);
				scope.months.splice(0, 1);
			};

			scope.hasNext = function (month) {
				if (angular.isDefined(month) && angular.isDefined(month.date)) {
					var currentMonth = moment(month.date);
					var end = moment(scope.planning.endDate);
					return currentMonth.month() + 1 <= end.month();
				}
				return false;
			};

			scope.hasPrevious = function (month) {
				if (angular.isDefined(month) && angular.isDefined(month.date)){
					var currentMonth = moment(month.date);
					var begin = moment(scope.planning.beginDate);
					return currentMonth.month() - 1 >= begin.month();
				}
				return false;
			};

			scope.today = function(){
				var today = new Date();
				scope.planning.beginDate = new Date(today.getFullYear(), today.getMonth(), 1).getTime();
				scope.planning.endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0).getTime();
				scope.$emit('refreshDate');
				_build(scope);
			};

			scope.$on('refreshCalendar', function(){
				_build(scope);
				selectDays(scope);
			});

			scope.getCalendarDay = function(day, isFirstMonth) {
				scope.getday({ day: day, isFirstMonth: isFirstMonth });
			};

			_build(scope);
			selectDays(scope);
		}

		function selectTask(dateM, scope){
			for (var i = 0; i < scope.months.length; i++){
				var monthM = moment(scope.months[i].date);
				if (monthM.month() === dateM.month() && monthM.year() === dateM.year()){
					var weekFound = false;
					for (var j = 0; j < scope.months[i].weeks.length; j++){
						for (var k = 0; k < scope.months[i].weeks[j].days.length; k++){
							if (scope.months[i].weeks[j].days[k].date != null){
								var dayM = moment(scope.months[i].weeks[j].days[k].date);
								if (dayM.isSame(dateM, 'day')){
									scope.months[i].weeks[j].days[k].selectedOne = !scope.months[i].weeks[j].days[k].firstSelected && !scope.months[i].weeks[j].days[k].lastSelected && !scope.months[i].weeks[j].days[k].selected;
									weekFound = true;
									break;
								}
							}
						}
						if (weekFound){
							break;
						}
					}
					break;
				}
			}
		}

		function selectLongEvent(event, scope) {
			var echeanceM = moment(event.echeance);
			var endM = moment(event.end);
			for (var i = 0; i < scope.months.length; i++) {
				var monthM = moment(scope.months[i].date);
				if (monthM.month() === echeanceM.month() && monthM.year() === echeanceM.year() || monthM.month() === endM.month() && monthM.year() === endM.year()) {
					var weekFound = false;
					for (var j = 0; j < scope.months[i].weeks.length; j++) {
						for (var k = 0; k < scope.months[i].weeks[j].days.length; k++) {
              if (scope.months[i].weeks[j].days[k].date) {
                var dayM = moment(scope.months[i].weeks[j].days[k].date);
                var alreadySelected = !!scope.months[i].weeks[j].days[k].selectedOne;

                if (dayM.isSame(echeanceM, 'day')) {
                  scope.months[i].weeks[j].days[k].firstSelected = !scope.months[i].weeks[j].days[k].selected;
                  if(scope.months[i].weeks[j].days[k].firstSelected && scope.months[i].weeks[j].days[k].lastSelected){
                    scope.months[i].weeks[j].days[k].selected = true;
                    delete scope.months[i].weeks[j].days[k].firstSelected;
                    delete scope.months[i].weeks[j].days[k].lastSelected;
                  }
                  if (alreadySelected) {
                    delete scope.months[i].weeks[j].days[k].selectedOne;
                  }
                } else if (dayM.isSame(endM, 'day')) {
                  scope.months[i].weeks[j].days[k].lastSelected = !scope.months[i].weeks[j].days[k].selected;
                  if(scope.months[i].weeks[j].days[k].firstSelected && scope.months[i].weeks[j].days[k].lastSelected){
                    scope.months[i].weeks[j].days[k].selected = true;
                    delete scope.months[i].weeks[j].days[k].firstSelected;
                    delete scope.months[i].weeks[j].days[k].lastSelected;
                  }
                  weekFound = true;
                  if (alreadySelected) {
                    delete scope.months[i].weeks[j].days[k].selectedOne;
                  }
                  break;
                } else if (dayM.isBetween(echeanceM, endM)) {
                  scope.months[i].weeks[j].days[k].selected = true;
                  delete scope.months[i].weeks[j].days[k].firstSelected;
                  delete scope.months[i].weeks[j].days[k].lastSelected;
                  if (alreadySelected) {
                    delete scope.months[i].weeks[j].days[k].selectedOne;
                  }
                }
              }
						}
						if (weekFound) {
							break;
						}
					}
				}
			}
		}

		function selectDays(scope){
			if (angular.isArray(scope.calendar)) {
				for (var i = 0; i < scope.calendar.length; i++) {
					if (scope.calendar[i].echeance != null) {
						scope.calendar[i].echeance = _removeTime(moment(scope.calendar[i].echeance));
					}
					if (scope.calendar[i].end != null) {
						scope.calendar[i].end = _removeTime(moment(scope.calendar[i].end));
					}
				}
			}
			var copy = angular.copy(scope.calendar);
			for (var i = copy.length - 1; i >= 0; i--){
				if (copy[i].event){
					var echeanceM = moment(copy[i].echeance);
					var endM = null;
					if (copy[i].end != null){
						endM = moment(copy[i].end);
					}
					if (copy[i].allDay || endM != null && echeanceM.date() === endM.date() && echeanceM.month() === endM.month() && echeanceM.year() === endM.year()){
						selectTask(copy[i].echeance, scope);
					}else{
						selectLongEvent(copy[i], scope);
					}
				}else{
					selectTask(copy[i].echeance, scope);
				}
			}
		}

		function findActiveMonth(scope) {
			var notFound = true;
			var i = 0;
			var indexIsActive = -1;
			while (i < scope.months.length && notFound) {
				var month = scope.months[i];
				if (month.isActive) {
					indexIsActive = i;
					notFound = false;
				}
				i++;
			}
			return indexIsActive;
		}

		function _build(scope) {
			var start, end;
			var i = 0;

			if (scope.planning != null) {
				if (scope.planning.beginDate == null) {
					start = _removeTime(moment());
				} else {
					start = _removeTime(moment(scope.planning.beginDate));
				}

				if (scope.planning.endDate == null) {
					end = _removeTime(moment());
				} else {
					end = _removeTime(moment(scope.planning.endDate));
				}
				if (!angular.isArray(scope.selected)) {
					scope.selected = [];
				}



				var array = [];
				i = 0;
				for (; i < scope.selected.length; i++) {
					var selected = _removeTime(moment(scope.selected[i]));
					if (selected.isSameOrAfter(start) && selected.isSameOrBefore(end)) {
						array.push(selected.toDate());
					}
				}
				scope.selected = array;
				var month = start.clone();
				month.date(1);
				start.date(1);
				start.isoWeekday(1).hour(0).minute(0).second(0).millisecond(0);
				_buildCalendar(scope, start, end, month);
			}
		}


		function _removeTime(date) {
			return date.hour(0).minute(0).second(0).millisecond(0);
		}

		function _buildCalendar(scope, start, end, month) {
			scope.months = [];
			var done = false, startDate = start.clone(), endDate = end.clone(), startMonth = month.clone();
			var today = moment();
			var todayNotFound = true;
			var i = 0;
			while (!done) {
				var monthToAdd = {
					date: startMonth.toDate(),
					name: $filter('date')(startMonth.toDate(), 'MMMM'),
					year: $filter('date')(startMonth.toDate(), 'yyyy'),
					weeks: _buildMonth(scope, startDate, startMonth)
				};
				if (today.month() === startMonth.month() && today.year() === startMonth.year()) {
					monthToAdd.isActive = true;
					todayNotFound = false;
				}
				scope.months.push(monthToAdd);
				startMonth.add(1, "M").date(1);
				startDate.add(1, "M");
				i++;
				done = startMonth.month() > endDate.month() && startMonth.year() === endDate.year() || startMonth.year() > endDate.year();
				startDate = startMonth.clone().isoWeekday(1);
			}
			if (todayNotFound) {
				scope.months[0].isActive = true;
			}
		}

		function _buildMonth(scope, start, month) {
			var weeks = [];
			var done = false, date = start.clone(), monthIndex = date.month(), count = 0;
			while (!done) {
				weeks.push(
					{
						days: _buildWeek(scope, date.clone(), month)
					}
				);
				date.add(1, "w");
				done = count++ > 2 && monthIndex !== date.month();
				monthIndex = date.month();
			}
			return weeks;
		}

		function _buildWeek(scope, date, month) {
			var days = [];
			for (var i = 1; i <= 7; i++) {
				if (date.month() === month.month() && date.isoWeekday() === i) {
					var day = {
						name: date.format("dd").substring(0, 1),
						number: date.date(),
						isToday: date.isSame(new Date(), "day"),
						date: date.toDate()
					};
					var endMonth = _removeTime(date.clone().endOf('month'));
					if (date.toDate().getTime() === endMonth.toDate().getTime()) {
						day.lastDay = true;
					}
					days.push(day);
					date = date.clone();
				} else {
					days.push({ isEmpty: true });
				}
				date.add(1, "d");
			}
			return days;
		}
	});

})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "ERANAMES": [
      "avant J\u00e9sus-Christ",
      "apr\u00e8s J\u00e9sus-Christ"
    ],
    "ERAS": [
      "av. J.-C.",
      "ap. J.-C."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "janvier",
      "f\u00e9vrier",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "ao\u00fbt",
      "septembre",
      "octobre",
      "novembre",
      "d\u00e9cembre"
    ],
    "SHORTDAY": [
      "dim.",
      "lun.",
      "mar.",
      "mer.",
      "jeu.",
      "ven.",
      "sam."
    ],
    "SHORTMONTH": [
      "janv.",
      "f\u00e9vr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "ao\u00fbt",
      "sept.",
      "oct.",
      "nov.",
      "d\u00e9c."
    ],
    "STANDALONEMONTH": [
      "janvier",
      "f\u00e9vrier",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "ao\u00fbt",
      "septembre",
      "octobre",
      "novembre",
      "d\u00e9cembre"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "d MMM y HH:mm:ss",
    "mediumDate": "d MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/y HH:mm",
    "shortDate": "dd/MM/y",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": "\u00a0",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "fr",
  "localeID": "fr",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  if (i == 0 || i == 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.moment=t()}(this,function(){"use strict";function e(){return Qe.apply(null,arguments)}function t(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function n(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function s(e){return void 0===e}function i(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function r(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function a(e,t){var n,s=[];for(n=0;n<e.length;++n)s.push(t(e[n],n));return s}function o(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function u(e,t){for(var n in t)o(t,n)&&(e[n]=t[n]);return o(t,"toString")&&(e.toString=t.toString),o(t,"valueOf")&&(e.valueOf=t.valueOf),e}function l(e,t,n,s){return ge(e,t,n,s,!0).utc()}function d(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function h(e){if(null==e._isValid){var t=d(e),n=Xe.call(t.parsedDateParts,function(e){return null!=e}),s=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n);if(e._strict&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return s;e._isValid=s}return e._isValid}function c(e){var t=l(NaN);return null!=e?u(d(t),e):d(t).userInvalidated=!0,t}function f(e,t){var n,i,r;if(s(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),s(t._i)||(e._i=t._i),s(t._f)||(e._f=t._f),s(t._l)||(e._l=t._l),s(t._strict)||(e._strict=t._strict),s(t._tzm)||(e._tzm=t._tzm),s(t._isUTC)||(e._isUTC=t._isUTC),s(t._offset)||(e._offset=t._offset),s(t._pf)||(e._pf=d(t)),s(t._locale)||(e._locale=t._locale),Ke.length>0)for(n=0;n<Ke.length;n++)s(r=t[i=Ke[n]])||(e[i]=r);return e}function m(t){f(this,t),this._d=new Date(null!=t._d?t._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===et&&(et=!0,e.updateOffset(this),et=!1)}function _(e){return e instanceof m||null!=e&&null!=e._isAMomentObject}function y(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function g(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=y(t)),n}function p(e,t,n){var s,i=Math.min(e.length,t.length),r=Math.abs(e.length-t.length),a=0;for(s=0;s<i;s++)(n&&e[s]!==t[s]||!n&&g(e[s])!==g(t[s]))&&a++;return a+r}function w(t){!1===e.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+t)}function v(t,n){var s=!0;return u(function(){if(null!=e.deprecationHandler&&e.deprecationHandler(null,t),s){for(var i,r=[],a=0;a<arguments.length;a++){if(i="","object"==typeof arguments[a]){i+="\n["+a+"] ";for(var o in arguments[0])i+=o+": "+arguments[0][o]+", ";i=i.slice(0,-2)}else i=arguments[a];r.push(i)}w(t+"\nArguments: "+Array.prototype.slice.call(r).join("")+"\n"+(new Error).stack),s=!1}return n.apply(this,arguments)},n)}function M(t,n){null!=e.deprecationHandler&&e.deprecationHandler(t,n),tt[t]||(w(n),tt[t]=!0)}function S(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function D(e,t){var s,i=u({},e);for(s in t)o(t,s)&&(n(e[s])&&n(t[s])?(i[s]={},u(i[s],e[s]),u(i[s],t[s])):null!=t[s]?i[s]=t[s]:delete i[s]);for(s in e)o(e,s)&&!o(t,s)&&n(e[s])&&(i[s]=u({},i[s]));return i}function k(e){null!=e&&this.set(e)}function Y(e,t){var n=e.toLowerCase();st[n]=st[n+"s"]=st[t]=e}function O(e){return"string"==typeof e?st[e]||st[e.toLowerCase()]:void 0}function T(e){var t,n,s={};for(n in e)o(e,n)&&(t=O(n))&&(s[t]=e[n]);return s}function x(e,t){it[e]=t}function b(e,t,n){var s=""+Math.abs(e),i=t-s.length;return(e>=0?n?"+":"":"-")+Math.pow(10,Math.max(0,i)).toString().substr(1)+s}function P(e,t,n,s){var i=s;"string"==typeof s&&(i=function(){return this[s]()}),e&&(ut[e]=i),t&&(ut[t[0]]=function(){return b(i.apply(this,arguments),t[1],t[2])}),n&&(ut[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function W(e){return e.match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"")}function H(e,t){return e.isValid()?(t=R(t,e.localeData()),ot[t]=ot[t]||function(e){var t,n,s=e.match(rt);for(t=0,n=s.length;t<n;t++)ut[s[t]]?s[t]=ut[s[t]]:s[t]=W(s[t]);return function(t){var i,r="";for(i=0;i<n;i++)r+=S(s[i])?s[i].call(t,e):s[i];return r}}(t),ot[t](e)):e.localeData().invalidDate()}function R(e,t){function n(e){return t.longDateFormat(e)||e}var s=5;for(at.lastIndex=0;s>=0&&at.test(e);)e=e.replace(at,n),at.lastIndex=0,s-=1;return e}function C(e,t,n){Yt[e]=S(t)?t:function(e,s){return e&&n?n:t}}function F(e,t){return o(Yt,e)?Yt[e](t._strict,t._locale):new RegExp(function(e){return U(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i}))}(e))}function U(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function L(e,t){var n,s=t;for("string"==typeof e&&(e=[e]),i(t)&&(s=function(e,n){n[t]=g(e)}),n=0;n<e.length;n++)Ot[e[n]]=s}function N(e,t){L(e,function(e,n,s,i){s._w=s._w||{},t(e,s._w,s,i)})}function G(e,t,n){null!=t&&o(Ot,e)&&Ot[e](t,n._a,n,e)}function V(e){return E(e)?366:365}function E(e){return e%4==0&&e%100!=0||e%400==0}function I(t,n){return function(s){return null!=s?(j(this,t,s),e.updateOffset(this,n),this):A(this,t)}}function A(e,t){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+t]():NaN}function j(e,t,n){e.isValid()&&!isNaN(n)&&("FullYear"===t&&E(e.year())&&1===e.month()&&29===e.date()?e._d["set"+(e._isUTC?"UTC":"")+t](n,e.month(),Z(n,e.month())):e._d["set"+(e._isUTC?"UTC":"")+t](n))}function Z(e,t){if(isNaN(e)||isNaN(t))return NaN;var n=function(e,t){return(e%t+t)%t}(t,12);return e+=(t-n)/12,1===n?E(e)?29:28:31-n%7%2}function z(e,t){var n;if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=g(t);else if(t=e.localeData().monthsParse(t),!i(t))return e;return n=Math.min(e.date(),Z(e.year(),t)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](t,n),e}function $(t){return null!=t?(z(this,t),e.updateOffset(this,!0),this):A(this,"Month")}function q(){function e(e,t){return t.length-e.length}var t,n,s=[],i=[],r=[];for(t=0;t<12;t++)n=l([2e3,t]),s.push(this.monthsShort(n,"")),i.push(this.months(n,"")),r.push(this.months(n,"")),r.push(this.monthsShort(n,""));for(s.sort(e),i.sort(e),r.sort(e),t=0;t<12;t++)s[t]=U(s[t]),i[t]=U(i[t]);for(t=0;t<24;t++)r[t]=U(r[t]);this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function J(e){var t=new Date(Date.UTC.apply(null,arguments));return e<100&&e>=0&&isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e),t}function B(e,t,n){var s=7+t-n;return-((7+J(e,0,s).getUTCDay()-t)%7)+s-1}function Q(e,t,n,s,i){var r,a,o=1+7*(t-1)+(7+n-s)%7+B(e,s,i);return o<=0?a=V(r=e-1)+o:o>V(e)?(r=e+1,a=o-V(e)):(r=e,a=o),{year:r,dayOfYear:a}}function X(e,t,n){var s,i,r=B(e.year(),t,n),a=Math.floor((e.dayOfYear()-r-1)/7)+1;return a<1?s=a+K(i=e.year()-1,t,n):a>K(e.year(),t,n)?(s=a-K(e.year(),t,n),i=e.year()+1):(i=e.year(),s=a),{week:s,year:i}}function K(e,t,n){var s=B(e,t,n),i=B(e+1,t,n);return(V(e)-s+i)/7}function ee(){function e(e,t){return t.length-e.length}var t,n,s,i,r,a=[],o=[],u=[],d=[];for(t=0;t<7;t++)n=l([2e3,1]).day(t),s=this.weekdaysMin(n,""),i=this.weekdaysShort(n,""),r=this.weekdays(n,""),a.push(s),o.push(i),u.push(r),d.push(s),d.push(i),d.push(r);for(a.sort(e),o.sort(e),u.sort(e),d.sort(e),t=0;t<7;t++)o[t]=U(o[t]),u[t]=U(u[t]),d[t]=U(d[t]);this._weekdaysRegex=new RegExp("^("+d.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+u.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+a.join("|")+")","i")}function te(){return this.hours()%12||12}function ne(e,t){P(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function se(e,t){return t._meridiemParse}function ie(e){return e?e.toLowerCase().replace("_","-"):e}function re(e){var t=null;if(!Xt[e]&&"undefined"!=typeof module&&module&&module.exports)try{t=Jt._abbr;require("./locale/"+e),ae(t)}catch(e){}return Xt[e]}function ae(e,t){var n;return e&&(n=s(t)?ue(e):oe(e,t))&&(Jt=n),Jt._abbr}function oe(e,t){if(null!==t){var n=Qt;if(t.abbr=e,null!=Xt[e])M("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),n=Xt[e]._config;else if(null!=t.parentLocale){if(null==Xt[t.parentLocale])return Kt[t.parentLocale]||(Kt[t.parentLocale]=[]),Kt[t.parentLocale].push({name:e,config:t}),null;n=Xt[t.parentLocale]._config}return Xt[e]=new k(D(n,t)),Kt[e]&&Kt[e].forEach(function(e){oe(e.name,e.config)}),ae(e),Xt[e]}return delete Xt[e],null}function ue(e){var n;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return Jt;if(!t(e)){if(n=re(e))return n;e=[e]}return function(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=ie(e[r]).split("-")).length,n=(n=ie(e[r+1]))?n.split("-"):null;t>0;){if(s=re(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&p(i,n,!0)>=t-1)break;t--}r++}return null}(e)}function le(e){var t,n=e._a;return n&&-2===d(e).overflow&&(t=n[xt]<0||n[xt]>11?xt:n[bt]<1||n[bt]>Z(n[Tt],n[xt])?bt:n[Pt]<0||n[Pt]>24||24===n[Pt]&&(0!==n[Wt]||0!==n[Ht]||0!==n[Rt])?Pt:n[Wt]<0||n[Wt]>59?Wt:n[Ht]<0||n[Ht]>59?Ht:n[Rt]<0||n[Rt]>999?Rt:-1,d(e)._overflowDayOfYear&&(t<Tt||t>bt)&&(t=bt),d(e)._overflowWeeks&&-1===t&&(t=Ct),d(e)._overflowWeekday&&-1===t&&(t=Ft),d(e).overflow=t),e}function de(e,t,n){return null!=e?e:null!=t?t:n}function he(t){var n,s,i,r,a,o=[];if(!t._d){for(i=function(t){var n=new Date(e.now());return t._useUTC?[n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()]:[n.getFullYear(),n.getMonth(),n.getDate()]}(t),t._w&&null==t._a[bt]&&null==t._a[xt]&&function(e){var t,n,s,i,r,a,o,u;if(null!=(t=e._w).GG||null!=t.W||null!=t.E)r=1,a=4,n=de(t.GG,e._a[Tt],X(pe(),1,4).year),s=de(t.W,1),((i=de(t.E,1))<1||i>7)&&(u=!0);else{r=e._locale._week.dow,a=e._locale._week.doy;var l=X(pe(),r,a);n=de(t.gg,e._a[Tt],l.year),s=de(t.w,l.week),null!=t.d?((i=t.d)<0||i>6)&&(u=!0):null!=t.e?(i=t.e+r,(t.e<0||t.e>6)&&(u=!0)):i=r}s<1||s>K(n,r,a)?d(e)._overflowWeeks=!0:null!=u?d(e)._overflowWeekday=!0:(o=Q(n,s,i,r,a),e._a[Tt]=o.year,e._dayOfYear=o.dayOfYear)}(t),null!=t._dayOfYear&&(a=de(t._a[Tt],i[Tt]),(t._dayOfYear>V(a)||0===t._dayOfYear)&&(d(t)._overflowDayOfYear=!0),s=J(a,0,t._dayOfYear),t._a[xt]=s.getUTCMonth(),t._a[bt]=s.getUTCDate()),n=0;n<3&&null==t._a[n];++n)t._a[n]=o[n]=i[n];for(;n<7;n++)t._a[n]=o[n]=null==t._a[n]?2===n?1:0:t._a[n];24===t._a[Pt]&&0===t._a[Wt]&&0===t._a[Ht]&&0===t._a[Rt]&&(t._nextDay=!0,t._a[Pt]=0),t._d=(t._useUTC?J:function(e,t,n,s,i,r,a){var o=new Date(e,t,n,s,i,r,a);return e<100&&e>=0&&isFinite(o.getFullYear())&&o.setFullYear(e),o}).apply(null,o),r=t._useUTC?t._d.getUTCDay():t._d.getDay(),null!=t._tzm&&t._d.setUTCMinutes(t._d.getUTCMinutes()-t._tzm),t._nextDay&&(t._a[Pt]=24),t._w&&void 0!==t._w.d&&t._w.d!==r&&(d(t).weekdayMismatch=!0)}}function ce(e){var t,n,s,i,r,a,o=e._i,u=en.exec(o)||tn.exec(o);if(u){for(d(e).iso=!0,t=0,n=sn.length;t<n;t++)if(sn[t][1].exec(u[1])){i=sn[t][0],s=!1!==sn[t][2];break}if(null==i)return void(e._isValid=!1);if(u[3]){for(t=0,n=rn.length;t<n;t++)if(rn[t][1].exec(u[3])){r=(u[2]||" ")+rn[t][0];break}if(null==r)return void(e._isValid=!1)}if(!s&&null!=r)return void(e._isValid=!1);if(u[4]){if(!nn.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),_e(e)}else e._isValid=!1}function fe(e,t,n,s,i,r){var a=[function(e){var t=parseInt(e,10);{if(t<=49)return 2e3+t;if(t<=999)return 1900+t}return t}(e),Vt.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&a.push(parseInt(r,10)),a}function me(e){var t=on.exec(function(e){return e.replace(/\([^)]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").trim()}(e._i));if(t){var n=fe(t[4],t[3],t[2],t[5],t[6],t[7]);if(!function(e,t,n){if(e&&jt.indexOf(e)!==new Date(t[0],t[1],t[2]).getDay())return d(n).weekdayMismatch=!0,n._isValid=!1,!1;return!0}(t[1],n,e))return;e._a=n,e._tzm=function(e,t,n){if(e)return un[e];if(t)return 0;var s=parseInt(n,10),i=s%100;return(s-i)/100*60+i}(t[8],t[9],t[10]),e._d=J.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),d(e).rfc2822=!0}else e._isValid=!1}function _e(t){if(t._f!==e.ISO_8601)if(t._f!==e.RFC_2822){t._a=[],d(t).empty=!0;var n,s,i,r,a,o=""+t._i,u=o.length,l=0;for(i=R(t._f,t._locale).match(rt)||[],n=0;n<i.length;n++)r=i[n],(s=(o.match(F(r,t))||[])[0])&&((a=o.substr(0,o.indexOf(s))).length>0&&d(t).unusedInput.push(a),o=o.slice(o.indexOf(s)+s.length),l+=s.length),ut[r]?(s?d(t).empty=!1:d(t).unusedTokens.push(r),G(r,s,t)):t._strict&&!s&&d(t).unusedTokens.push(r);d(t).charsLeftOver=u-l,o.length>0&&d(t).unusedInput.push(o),t._a[Pt]<=12&&!0===d(t).bigHour&&t._a[Pt]>0&&(d(t).bigHour=void 0),d(t).parsedDateParts=t._a.slice(0),d(t).meridiem=t._meridiem,t._a[Pt]=function(e,t,n){var s;if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((s=e.isPM(n))&&t<12&&(t+=12),s||12!==t||(t=0),t):t}(t._locale,t._a[Pt],t._meridiem),he(t),le(t)}else me(t);else ce(t)}function ye(o){var l=o._i,y=o._f;return o._locale=o._locale||ue(o._l),null===l||void 0===y&&""===l?c({nullInput:!0}):("string"==typeof l&&(o._i=l=o._locale.preparse(l)),_(l)?new m(le(l)):(r(l)?o._d=l:t(y)?function(e){var t,n,s,i,r;if(0===e._f.length)return d(e).invalidFormat=!0,void(e._d=new Date(NaN));for(i=0;i<e._f.length;i++)r=0,t=f({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[i],_e(t),h(t)&&(r+=d(t).charsLeftOver,r+=10*d(t).unusedTokens.length,d(t).score=r,(null==s||r<s)&&(s=r,n=t));u(e,n||t)}(o):y?_e(o):function(o){var u=o._i;s(u)?o._d=new Date(e.now()):r(u)?o._d=new Date(u.valueOf()):"string"==typeof u?function(t){var n=an.exec(t._i);null===n?(ce(t),!1===t._isValid&&(delete t._isValid,me(t),!1===t._isValid&&(delete t._isValid,e.createFromInputFallback(t)))):t._d=new Date(+n[1])}(o):t(u)?(o._a=a(u.slice(0),function(e){return parseInt(e,10)}),he(o)):n(u)?function(e){if(!e._d){var t=T(e._i);e._a=a([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),he(e)}}(o):i(u)?o._d=new Date(u):e.createFromInputFallback(o)}(o),h(o)||(o._d=null),o))}function ge(e,s,i,r,a){var o={};return!0!==i&&!1!==i||(r=i,i=void 0),(n(e)&&function(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(e.hasOwnProperty(t))return!1;return!0}(e)||t(e)&&0===e.length)&&(e=void 0),o._isAMomentObject=!0,o._useUTC=o._isUTC=a,o._l=i,o._i=e,o._f=s,o._strict=r,function(e){var t=new m(le(ye(e)));return t._nextDay&&(t.add(1,"d"),t._nextDay=void 0),t}(o)}function pe(e,t,n,s){return ge(e,t,n,s,!1)}function we(e,n){var s,i;if(1===n.length&&t(n[0])&&(n=n[0]),!n.length)return pe();for(s=n[0],i=1;i<n.length;++i)n[i].isValid()&&!n[i][e](s)||(s=n[i]);return s}function ve(e){var t=T(e),n=t.year||0,s=t.quarter||0,i=t.month||0,r=t.week||0,a=t.day||0,o=t.hour||0,u=t.minute||0,l=t.second||0,d=t.millisecond||0;this._isValid=function(e){for(var t in e)if(-1===Ut.call(hn,t)||null!=e[t]&&isNaN(e[t]))return!1;for(var n=!1,s=0;s<hn.length;++s)if(e[hn[s]]){if(n)return!1;parseFloat(e[hn[s]])!==g(e[hn[s]])&&(n=!0)}return!0}(t),this._milliseconds=+d+1e3*l+6e4*u+1e3*o*60*60,this._days=+a+7*r,this._months=+i+3*s+12*n,this._data={},this._locale=ue(),this._bubble()}function Me(e){return e instanceof ve}function Se(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function De(e,t){P(e,0,0,function(){var e=this.utcOffset(),n="+";return e<0&&(e=-e,n="-"),n+b(~~(e/60),2)+t+b(~~e%60,2)})}function ke(e,t){var n=(t||"").match(e);if(null===n)return null;var s=((n[n.length-1]||[])+"").match(cn)||["-",0,0],i=60*s[1]+g(s[2]);return 0===i?0:"+"===s[0]?i:-i}function Ye(t,n){var s,i;return n._isUTC?(s=n.clone(),i=(_(t)||r(t)?t.valueOf():pe(t).valueOf())-s.valueOf(),s._d.setTime(s._d.valueOf()+i),e.updateOffset(s,!1),s):pe(t).local()}function Oe(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Te(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}function xe(e,t){var n,s,r,a=e,u=null;return Me(e)?a={ms:e._milliseconds,d:e._days,M:e._months}:i(e)?(a={},t?a[t]=e:a.milliseconds=e):(u=fn.exec(e))?(n="-"===u[1]?-1:1,a={y:0,d:g(u[bt])*n,h:g(u[Pt])*n,m:g(u[Wt])*n,s:g(u[Ht])*n,ms:g(Se(1e3*u[Rt]))*n}):(u=mn.exec(e))?(n="-"===u[1]?-1:(u[1],1),a={y:be(u[2],n),M:be(u[3],n),w:be(u[4],n),d:be(u[5],n),h:be(u[6],n),m:be(u[7],n),s:be(u[8],n)}):null==a?a={}:"object"==typeof a&&("from"in a||"to"in a)&&(r=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Ye(t,e),e.isBefore(t)?n=Pe(e,t):((n=Pe(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(pe(a.from),pe(a.to)),(a={}).ms=r.milliseconds,a.M=r.months),s=new ve(a),Me(e)&&o(e,"_locale")&&(s._locale=e._locale),s}function be(e,t){var n=e&&parseFloat(e.replace(",","."));return(isNaN(n)?0:n)*t}function Pe(e,t){var n={milliseconds:0,months:0};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function We(e,t){return function(n,s){var i,r;return null===s||isNaN(+s)||(M(t,"moment()."+t+"(period, number) is deprecated. Please use moment()."+t+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),r=n,n=s,s=r),n="string"==typeof n?+n:n,i=xe(n,s),He(this,i,e),this}}function He(t,n,s,i){var r=n._milliseconds,a=Se(n._days),o=Se(n._months);t.isValid()&&(i=null==i||i,o&&z(t,A(t,"Month")+o*s),a&&j(t,"Date",A(t,"Date")+a*s),r&&t._d.setTime(t._d.valueOf()+r*s),i&&e.updateOffset(t,a||o))}function Re(e,t){var n,s=12*(t.year()-e.year())+(t.month()-e.month()),i=e.clone().add(s,"months");return n=t-i<0?(t-i)/(i-e.clone().add(s-1,"months")):(t-i)/(e.clone().add(s+1,"months")-i),-(s+n)||0}function Ce(e){var t;return void 0===e?this._locale._abbr:(null!=(t=ue(e))&&(this._locale=t),this)}function Fe(){return this._locale}function Ue(e,t){P(0,[e,e.length],0,t)}function Le(e,t,n,s,i){var r;return null==e?X(this,s,i).year:(r=K(e,s,i),t>r&&(t=r),function(e,t,n,s,i){var r=Q(e,t,n,s,i),a=J(r.year,0,r.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}.call(this,e,t,n,s,i))}function Ne(e,t){t[Rt]=g(1e3*("0."+e))}function Ge(e){return e}function Ve(e,t,n,s){var i=ue(),r=l().set(s,t);return i[n](r,e)}function Ee(e,t,n){if(i(e)&&(t=e,e=void 0),e=e||"",null!=t)return Ve(e,t,n,"month");var s,r=[];for(s=0;s<12;s++)r[s]=Ve(e,s,n,"month");return r}function Ie(e,t,n,s){"boolean"==typeof e?(i(t)&&(n=t,t=void 0),t=t||""):(n=t=e,e=!1,i(t)&&(n=t,t=void 0),t=t||"");var r=ue(),a=e?r._week.dow:0;if(null!=n)return Ve(t,(n+a)%7,s,"day");var o,u=[];for(o=0;o<7;o++)u[o]=Ve(t,(o+a)%7,s,"day");return u}function Ae(e,t,n,s){var i=xe(t,n);return e._milliseconds+=s*i._milliseconds,e._days+=s*i._days,e._months+=s*i._months,e._bubble()}function je(e){return e<0?Math.floor(e):Math.ceil(e)}function Ze(e){return 4800*e/146097}function ze(e){return 146097*e/4800}function $e(e){return function(){return this.as(e)}}function qe(e){return function(){return this.isValid()?this._data[e]:NaN}}function Je(e){return(e>0)-(e<0)||+e}function Be(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n=An(this._milliseconds)/1e3,s=An(this._days),i=An(this._months);t=y((e=y(n/60))/60),n%=60,e%=60;var r=y(i/12),a=i%=12,o=s,u=t,l=e,d=n?n.toFixed(3).replace(/\.?0+$/,""):"",h=this.asSeconds();if(!h)return"P0D";var c=h<0?"-":"",f=Je(this._months)!==Je(h)?"-":"",m=Je(this._days)!==Je(h)?"-":"",_=Je(this._milliseconds)!==Je(h)?"-":"";return c+"P"+(r?f+r+"Y":"")+(a?f+a+"M":"")+(o?m+o+"D":"")+(u||l||d?"T":"")+(u?_+u+"H":"")+(l?_+l+"M":"")+(d?_+d+"S":"")}var Qe,Xe;Xe=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1};var Ke=e.momentProperties=[],et=!1,tt={};e.suppressDeprecationWarnings=!1,e.deprecationHandler=null;var nt;nt=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)o(e,t)&&n.push(t);return n};var st={},it={},rt=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,at=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,ot={},ut={},lt=/\d/,dt=/\d\d/,ht=/\d{3}/,ct=/\d{4}/,ft=/[+-]?\d{6}/,mt=/\d\d?/,_t=/\d\d\d\d?/,yt=/\d\d\d\d\d\d?/,gt=/\d{1,3}/,pt=/\d{1,4}/,wt=/[+-]?\d{1,6}/,vt=/\d+/,Mt=/[+-]?\d+/,St=/Z|[+-]\d\d:?\d\d/gi,Dt=/Z|[+-]\d\d(?::?\d\d)?/gi,kt=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,Yt={},Ot={},Tt=0,xt=1,bt=2,Pt=3,Wt=4,Ht=5,Rt=6,Ct=7,Ft=8;P("Y",0,0,function(){var e=this.year();return e<=9999?""+e:"+"+e}),P(0,["YY",2],0,function(){return this.year()%100}),P(0,["YYYY",4],0,"year"),P(0,["YYYYY",5],0,"year"),P(0,["YYYYYY",6,!0],0,"year"),Y("year","y"),x("year",1),C("Y",Mt),C("YY",mt,dt),C("YYYY",pt,ct),C("YYYYY",wt,ft),C("YYYYYY",wt,ft),L(["YYYYY","YYYYYY"],Tt),L("YYYY",function(t,n){n[Tt]=2===t.length?e.parseTwoDigitYear(t):g(t)}),L("YY",function(t,n){n[Tt]=e.parseTwoDigitYear(t)}),L("Y",function(e,t){t[Tt]=parseInt(e,10)}),e.parseTwoDigitYear=function(e){return g(e)+(g(e)>68?1900:2e3)};var Ut,Lt=I("FullYear",!0);Ut=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},P("M",["MM",2],"Mo",function(){return this.month()+1}),P("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),P("MMMM",0,0,function(e){return this.localeData().months(this,e)}),Y("month","M"),x("month",8),C("M",mt),C("MM",mt,dt),C("MMM",function(e,t){return t.monthsShortRegex(e)}),C("MMMM",function(e,t){return t.monthsRegex(e)}),L(["M","MM"],function(e,t){t[xt]=g(e)-1}),L(["MMM","MMMM"],function(e,t,n,s){var i=n._locale.monthsParse(e,s,n._strict);null!=i?t[xt]=i:d(n).invalidMonth=e});var Nt=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Gt="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Vt="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Et=kt,It=kt;P("w",["ww",2],"wo","week"),P("W",["WW",2],"Wo","isoWeek"),Y("week","w"),Y("isoWeek","W"),x("week",5),x("isoWeek",5),C("w",mt),C("ww",mt,dt),C("W",mt),C("WW",mt,dt),N(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=g(e)});P("d",0,"do","day"),P("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),P("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),P("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),P("e",0,0,"weekday"),P("E",0,0,"isoWeekday"),Y("day","d"),Y("weekday","e"),Y("isoWeekday","E"),x("day",11),x("weekday",11),x("isoWeekday",11),C("d",mt),C("e",mt),C("E",mt),C("dd",function(e,t){return t.weekdaysMinRegex(e)}),C("ddd",function(e,t){return t.weekdaysShortRegex(e)}),C("dddd",function(e,t){return t.weekdaysRegex(e)}),N(["dd","ddd","dddd"],function(e,t,n,s){var i=n._locale.weekdaysParse(e,s,n._strict);null!=i?t.d=i:d(n).invalidWeekday=e}),N(["d","e","E"],function(e,t,n,s){t[s]=g(e)});var At="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),jt="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Zt="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),zt=kt,$t=kt,qt=kt;P("H",["HH",2],0,"hour"),P("h",["hh",2],0,te),P("k",["kk",2],0,function(){return this.hours()||24}),P("hmm",0,0,function(){return""+te.apply(this)+b(this.minutes(),2)}),P("hmmss",0,0,function(){return""+te.apply(this)+b(this.minutes(),2)+b(this.seconds(),2)}),P("Hmm",0,0,function(){return""+this.hours()+b(this.minutes(),2)}),P("Hmmss",0,0,function(){return""+this.hours()+b(this.minutes(),2)+b(this.seconds(),2)}),ne("a",!0),ne("A",!1),Y("hour","h"),x("hour",13),C("a",se),C("A",se),C("H",mt),C("h",mt),C("k",mt),C("HH",mt,dt),C("hh",mt,dt),C("kk",mt,dt),C("hmm",_t),C("hmmss",yt),C("Hmm",_t),C("Hmmss",yt),L(["H","HH"],Pt),L(["k","kk"],function(e,t,n){var s=g(e);t[Pt]=24===s?0:s}),L(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),L(["h","hh"],function(e,t,n){t[Pt]=g(e),d(n).bigHour=!0}),L("hmm",function(e,t,n){var s=e.length-2;t[Pt]=g(e.substr(0,s)),t[Wt]=g(e.substr(s)),d(n).bigHour=!0}),L("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[Pt]=g(e.substr(0,s)),t[Wt]=g(e.substr(s,2)),t[Ht]=g(e.substr(i)),d(n).bigHour=!0}),L("Hmm",function(e,t,n){var s=e.length-2;t[Pt]=g(e.substr(0,s)),t[Wt]=g(e.substr(s))}),L("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[Pt]=g(e.substr(0,s)),t[Wt]=g(e.substr(s,2)),t[Ht]=g(e.substr(i))});var Jt,Bt=I("Hours",!0),Qt={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Gt,monthsShort:Vt,week:{dow:0,doy:6},weekdays:At,weekdaysMin:Zt,weekdaysShort:jt,meridiemParse:/[ap]\.?m?\.?/i},Xt={},Kt={},en=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,tn=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,nn=/Z|[+-]\d\d(?::?\d\d)?/,sn=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],rn=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],an=/^\/?Date\((\-?\d+)/i,on=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,un={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};e.createFromInputFallback=v("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),e.ISO_8601=function(){},e.RFC_2822=function(){};var ln=v("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=pe.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:c()}),dn=v("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=pe.apply(null,arguments);return this.isValid()&&e.isValid()?e>this?this:e:c()}),hn=["year","quarter","month","week","day","hour","minute","second","millisecond"];De("Z",":"),De("ZZ",""),C("Z",Dt),C("ZZ",Dt),L(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=ke(Dt,e)});var cn=/([\+\-]|\d\d)/gi;e.updateOffset=function(){};var fn=/^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,mn=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;xe.fn=ve.prototype,xe.invalid=function(){return xe(NaN)};var _n=We(1,"add"),yn=We(-1,"subtract");e.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",e.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var gn=v("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});P(0,["gg",2],0,function(){return this.weekYear()%100}),P(0,["GG",2],0,function(){return this.isoWeekYear()%100}),Ue("gggg","weekYear"),Ue("ggggg","weekYear"),Ue("GGGG","isoWeekYear"),Ue("GGGGG","isoWeekYear"),Y("weekYear","gg"),Y("isoWeekYear","GG"),x("weekYear",1),x("isoWeekYear",1),C("G",Mt),C("g",Mt),C("GG",mt,dt),C("gg",mt,dt),C("GGGG",pt,ct),C("gggg",pt,ct),C("GGGGG",wt,ft),C("ggggg",wt,ft),N(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=g(e)}),N(["gg","GG"],function(t,n,s,i){n[i]=e.parseTwoDigitYear(t)}),P("Q",0,"Qo","quarter"),Y("quarter","Q"),x("quarter",7),C("Q",lt),L("Q",function(e,t){t[xt]=3*(g(e)-1)}),P("D",["DD",2],"Do","date"),Y("date","D"),x("date",9),C("D",mt),C("DD",mt,dt),C("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),L(["D","DD"],bt),L("Do",function(e,t){t[bt]=g(e.match(mt)[0])});var pn=I("Date",!0);P("DDD",["DDDD",3],"DDDo","dayOfYear"),Y("dayOfYear","DDD"),x("dayOfYear",4),C("DDD",gt),C("DDDD",ht),L(["DDD","DDDD"],function(e,t,n){n._dayOfYear=g(e)}),P("m",["mm",2],0,"minute"),Y("minute","m"),x("minute",14),C("m",mt),C("mm",mt,dt),L(["m","mm"],Wt);var wn=I("Minutes",!1);P("s",["ss",2],0,"second"),Y("second","s"),x("second",15),C("s",mt),C("ss",mt,dt),L(["s","ss"],Ht);var vn=I("Seconds",!1);P("S",0,0,function(){return~~(this.millisecond()/100)}),P(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),P(0,["SSS",3],0,"millisecond"),P(0,["SSSS",4],0,function(){return 10*this.millisecond()}),P(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),P(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),P(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),P(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),P(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),Y("millisecond","ms"),x("millisecond",16),C("S",gt,lt),C("SS",gt,dt),C("SSS",gt,ht);var Mn;for(Mn="SSSS";Mn.length<=9;Mn+="S")C(Mn,vt);for(Mn="S";Mn.length<=9;Mn+="S")L(Mn,Ne);var Sn=I("Milliseconds",!1);P("z",0,0,"zoneAbbr"),P("zz",0,0,"zoneName");var Dn=m.prototype;Dn.add=_n,Dn.calendar=function(t,n){var s=t||pe(),i=Ye(s,this).startOf("day"),r=e.calendarFormat(this,i)||"sameElse",a=n&&(S(n[r])?n[r].call(this,s):n[r]);return this.format(a||this.localeData().calendar(r,this,pe(s)))},Dn.clone=function(){return new m(this)},Dn.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Ye(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=O(t)){case"year":r=Re(this,s)/12;break;case"month":r=Re(this,s);break;case"quarter":r=Re(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:y(r)},Dn.endOf=function(e){return void 0===(e=O(e))||"millisecond"===e?this:("date"===e&&(e="day"),this.startOf(e).add(1,"isoWeek"===e?"week":e).subtract(1,"ms"))},Dn.format=function(t){t||(t=this.isUtc()?e.defaultFormatUtc:e.defaultFormat);var n=H(this,t);return this.localeData().postformat(n)},Dn.from=function(e,t){return this.isValid()&&(_(e)&&e.isValid()||pe(e).isValid())?xe({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},Dn.fromNow=function(e){return this.from(pe(),e)},Dn.to=function(e,t){return this.isValid()&&(_(e)&&e.isValid()||pe(e).isValid())?xe({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},Dn.toNow=function(e){return this.to(pe(),e)},Dn.get=function(e){return e=O(e),S(this[e])?this[e]():this},Dn.invalidAt=function(){return d(this).overflow},Dn.isAfter=function(e,t){var n=_(e)?e:pe(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=O(s(t)?"millisecond":t))?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())},Dn.isBefore=function(e,t){var n=_(e)?e:pe(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=O(s(t)?"millisecond":t))?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())},Dn.isBetween=function(e,t,n,s){return("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},Dn.isSame=function(e,t){var n,s=_(e)?e:pe(e);return!(!this.isValid()||!s.isValid())&&("millisecond"===(t=O(t||"millisecond"))?this.valueOf()===s.valueOf():(n=s.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))},Dn.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},Dn.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},Dn.isValid=function(){return h(this)},Dn.lang=gn,Dn.locale=Ce,Dn.localeData=Fe,Dn.max=dn,Dn.min=ln,Dn.parsingFlags=function(){return u({},d(this))},Dn.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t=[];for(var n in e)t.push({unit:n,priority:it[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}(e=T(e)),s=0;s<n.length;s++)this[n[s].unit](e[n[s].unit]);else if(e=O(e),S(this[e]))return this[e](t);return this},Dn.startOf=function(e){switch(e=O(e)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":case"date":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===e&&this.weekday(0),"isoWeek"===e&&this.isoWeekday(1),"quarter"===e&&this.month(3*Math.floor(this.month()/3)),this},Dn.subtract=yn,Dn.toArray=function(){return[this.year(),this.month(),this.date(),this.hour(),this.minute(),this.second(),this.millisecond()]},Dn.toObject=function(){return{years:this.year(),months:this.month(),date:this.date(),hours:this.hours(),minutes:this.minutes(),seconds:this.seconds(),milliseconds:this.milliseconds()}},Dn.toDate=function(){return new Date(this.valueOf())},Dn.toISOString=function(e){if(!this.isValid())return null;var t=!0!==e,n=t?this.clone().utc():this;return n.year()<0||n.year()>9999?H(n,t?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):S(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this._d.valueOf()).toISOString().replace("Z",H(n,"Z")):H(n,t?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},Dn.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e="moment",t="";this.isLocal()||(e=0===this.utcOffset()?"moment.utc":"moment.parseZone",t="Z");var n="["+e+'("]',s=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",i=t+'[")]';return this.format(n+s+"-MM-DD[T]HH:mm:ss.SSS"+i)},Dn.toJSON=function(){return this.isValid()?this.toISOString():null},Dn.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},Dn.unix=function(){return Math.floor(this.valueOf()/1e3)},Dn.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},Dn.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},Dn.year=Lt,Dn.isLeapYear=function(){return E(this.year())},Dn.weekYear=function(e){return Le.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},Dn.isoWeekYear=function(e){return Le.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},Dn.quarter=Dn.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},Dn.month=$,Dn.daysInMonth=function(){return Z(this.year(),this.month())},Dn.week=Dn.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},Dn.isoWeek=Dn.isoWeeks=function(e){var t=X(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},Dn.weeksInYear=function(){var e=this.localeData()._week;return K(this.year(),e.dow,e.doy)},Dn.isoWeeksInYear=function(){return K(this.year(),1,4)},Dn.date=pn,Dn.day=Dn.days=function(e){if(!this.isValid())return null!=e?this:NaN;var t=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(e=function(e,t){return"string"!=typeof e?e:isNaN(e)?"number"==typeof(e=t.weekdaysParse(e))?e:null:parseInt(e,10)}(e,this.localeData()),this.add(e-t,"d")):t},Dn.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")},Dn.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=function(e,t){return"string"==typeof e?t.weekdaysParse(e)%7||7:isNaN(e)?null:e}(e,this.localeData());return this.day(this.day()%7?t:t-7)}return this.day()||7},Dn.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},Dn.hour=Dn.hours=Bt,Dn.minute=Dn.minutes=wn,Dn.second=Dn.seconds=vn,Dn.millisecond=Dn.milliseconds=Sn,Dn.utcOffset=function(t,n,s){var i,r=this._offset||0;if(!this.isValid())return null!=t?this:NaN;if(null!=t){if("string"==typeof t){if(null===(t=ke(Dt,t)))return this}else Math.abs(t)<16&&!s&&(t*=60);return!this._isUTC&&n&&(i=Oe(this)),this._offset=t,this._isUTC=!0,null!=i&&this.add(i,"m"),r!==t&&(!n||this._changeInProgress?He(this,xe(t-r,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,e.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?r:Oe(this)},Dn.utc=function(e){return this.utcOffset(0,e)},Dn.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(Oe(this),"m")),this},Dn.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=ke(St,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},Dn.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?pe(e).utcOffset():0,(this.utcOffset()-e)%60==0)},Dn.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},Dn.isLocal=function(){return!!this.isValid()&&!this._isUTC},Dn.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},Dn.isUtc=Te,Dn.isUTC=Te,Dn.zoneAbbr=function(){return this._isUTC?"UTC":""},Dn.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},Dn.dates=v("dates accessor is deprecated. Use date instead.",pn),Dn.months=v("months accessor is deprecated. Use month instead",$),Dn.years=v("years accessor is deprecated. Use year instead",Lt),Dn.zone=v("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}),Dn.isDSTShifted=v("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){if(!s(this._isDSTShifted))return this._isDSTShifted;var e={};if(f(e,this),(e=ye(e))._a){var t=e._isUTC?l(e._a):pe(e._a);this._isDSTShifted=this.isValid()&&p(e._a,t.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted});var kn=k.prototype;kn.calendar=function(e,t,n){var s=this._calendar[e]||this._calendar.sameElse;return S(s)?s.call(t,n):s},kn.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])},kn.invalidDate=function(){return this._invalidDate},kn.ordinal=function(e){return this._ordinal.replace("%d",e)},kn.preparse=Ge,kn.postformat=Ge,kn.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return S(i)?i(e,t,n,s):i.replace(/%d/i,e)},kn.pastFuture=function(e,t){var n=this._relativeTime[e>0?"future":"past"];return S(n)?n(t):n.replace(/%s/i,t)},kn.set=function(e){var t,n;for(n in e)S(t=e[n])?this[n]=t:this["_"+n]=t;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},kn.months=function(e,n){return e?t(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||Nt).test(n)?"format":"standalone"][e.month()]:t(this._months)?this._months:this._months.standalone},kn.monthsShort=function(e,n){return e?t(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[Nt.test(n)?"format":"standalone"][e.month()]:t(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},kn.monthsParse=function(e,t,n){var s,i,r;if(this._monthsParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=l([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=Ut.call(this._shortMonthsParse,a))?i:null:-1!==(i=Ut.call(this._longMonthsParse,a))?i:null:"MMM"===t?-1!==(i=Ut.call(this._shortMonthsParse,a))?i:-1!==(i=Ut.call(this._longMonthsParse,a))?i:null:-1!==(i=Ut.call(this._longMonthsParse,a))?i:-1!==(i=Ut.call(this._shortMonthsParse,a))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=l([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(r="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(r.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},kn.monthsRegex=function(e){return this._monthsParseExact?(o(this,"_monthsRegex")||q.call(this),e?this._monthsStrictRegex:this._monthsRegex):(o(this,"_monthsRegex")||(this._monthsRegex=It),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},kn.monthsShortRegex=function(e){return this._monthsParseExact?(o(this,"_monthsRegex")||q.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(o(this,"_monthsShortRegex")||(this._monthsShortRegex=Et),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},kn.week=function(e){return X(e,this._week.dow,this._week.doy).week},kn.firstDayOfYear=function(){return this._week.doy},kn.firstDayOfWeek=function(){return this._week.dow},kn.weekdays=function(e,n){return e?t(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(n)?"format":"standalone"][e.day()]:t(this._weekdays)?this._weekdays:this._weekdays.standalone},kn.weekdaysMin=function(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin},kn.weekdaysShort=function(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort},kn.weekdaysParse=function(e,t,n){var s,i,r;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=l([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=Ut.call(this._weekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ut.call(this._shortWeekdaysParse,a))?i:null:-1!==(i=Ut.call(this._minWeekdaysParse,a))?i:null:"dddd"===t?-1!==(i=Ut.call(this._weekdaysParse,a))?i:-1!==(i=Ut.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ut.call(this._minWeekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ut.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ut.call(this._weekdaysParse,a))?i:-1!==(i=Ut.call(this._minWeekdaysParse,a))?i:null:-1!==(i=Ut.call(this._minWeekdaysParse,a))?i:-1!==(i=Ut.call(this._weekdaysParse,a))?i:-1!==(i=Ut.call(this._shortWeekdaysParse,a))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=l([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".",".?")+"$","i")),this._weekdaysParse[s]||(r="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(r.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},kn.weekdaysRegex=function(e){return this._weekdaysParseExact?(o(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(o(this,"_weekdaysRegex")||(this._weekdaysRegex=zt),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},kn.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(o(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(o(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=$t),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},kn.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(o(this,"_weekdaysRegex")||ee.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(o(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=qt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},kn.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},kn.meridiem=function(e,t,n){return e>11?n?"pm":"PM":n?"am":"AM"},ae("en",{dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===g(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}}),e.lang=v("moment.lang is deprecated. Use moment.locale instead.",ae),e.langData=v("moment.langData is deprecated. Use moment.localeData instead.",ue);var Yn=Math.abs,On=$e("ms"),Tn=$e("s"),xn=$e("m"),bn=$e("h"),Pn=$e("d"),Wn=$e("w"),Hn=$e("M"),Rn=$e("y"),Cn=qe("milliseconds"),Fn=qe("seconds"),Un=qe("minutes"),Ln=qe("hours"),Nn=qe("days"),Gn=qe("months"),Vn=qe("years"),En=Math.round,In={ss:44,s:45,m:45,h:22,d:26,M:11},An=Math.abs,jn=ve.prototype;return jn.isValid=function(){return this._isValid},jn.abs=function(){var e=this._data;return this._milliseconds=Yn(this._milliseconds),this._days=Yn(this._days),this._months=Yn(this._months),e.milliseconds=Yn(e.milliseconds),e.seconds=Yn(e.seconds),e.minutes=Yn(e.minutes),e.hours=Yn(e.hours),e.months=Yn(e.months),e.years=Yn(e.years),this},jn.add=function(e,t){return Ae(this,e,t,1)},jn.subtract=function(e,t){return Ae(this,e,t,-1)},jn.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=O(e))||"year"===e)return t=this._days+s/864e5,n=this._months+Ze(t),"month"===e?n:n/12;switch(t=this._days+Math.round(ze(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},jn.asMilliseconds=On,jn.asSeconds=Tn,jn.asMinutes=xn,jn.asHours=bn,jn.asDays=Pn,jn.asWeeks=Wn,jn.asMonths=Hn,jn.asYears=Rn,jn.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*g(this._months/12):NaN},jn._bubble=function(){var e,t,n,s,i,r=this._milliseconds,a=this._days,o=this._months,u=this._data;return r>=0&&a>=0&&o>=0||r<=0&&a<=0&&o<=0||(r+=864e5*je(ze(o)+a),a=0,o=0),u.milliseconds=r%1e3,e=y(r/1e3),u.seconds=e%60,t=y(e/60),u.minutes=t%60,n=y(t/60),u.hours=n%24,a+=y(n/24),i=y(Ze(a)),o+=i,a-=je(ze(i)),s=y(o/12),o%=12,u.days=a,u.months=o,u.years=s,this},jn.clone=function(){return xe(this)},jn.get=function(e){return e=O(e),this.isValid()?this[e+"s"]():NaN},jn.milliseconds=Cn,jn.seconds=Fn,jn.minutes=Un,jn.hours=Ln,jn.days=Nn,jn.weeks=function(){return y(this.days()/7)},jn.months=Gn,jn.years=Vn,jn.humanize=function(e){if(!this.isValid())return this.localeData().invalidDate();var t=this.localeData(),n=function(e,t,n){var s=xe(e).abs(),i=En(s.as("s")),r=En(s.as("m")),a=En(s.as("h")),o=En(s.as("d")),u=En(s.as("M")),l=En(s.as("y")),d=i<=In.ss&&["s",i]||i<In.s&&["ss",i]||r<=1&&["m"]||r<In.m&&["mm",r]||a<=1&&["h"]||a<In.h&&["hh",a]||o<=1&&["d"]||o<In.d&&["dd",o]||u<=1&&["M"]||u<In.M&&["MM",u]||l<=1&&["y"]||["yy",l];return d[2]=t,d[3]=+e>0,d[4]=n,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,d)}(this,!e,t);return e&&(n=t.pastFuture(+this,n)),t.postformat(n)},jn.toISOString=Be,jn.toString=Be,jn.toJSON=Be,jn.locale=Ce,jn.localeData=Fe,jn.toIsoString=v("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",Be),jn.lang=gn,P("X",0,0,"unix"),P("x",0,0,"valueOf"),C("x",Mt),C("X",/[+-]?\d+(\.\d{1,3})?/),L("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),L("x",function(e,t,n){n._d=new Date(g(e))}),e.version="2.20.1",function(e){Qe=e}(pe),e.fn=Dn,e.min=function(){return we("isBefore",[].slice.call(arguments,0))},e.max=function(){return we("isAfter",[].slice.call(arguments,0))},e.now=function(){return Date.now?Date.now():+new Date},e.utc=l,e.unix=function(e){return pe(1e3*e)},e.months=function(e,t){return Ee(e,t,"months")},e.isDate=r,e.locale=ae,e.invalid=c,e.duration=xe,e.isMoment=_,e.weekdays=function(e,t,n){return Ie(e,t,n,"weekdays")},e.parseZone=function(){return pe.apply(null,arguments).parseZone()},e.localeData=ue,e.isDuration=Me,e.monthsShort=function(e,t){return Ee(e,t,"monthsShort")},e.weekdaysMin=function(e,t,n){return Ie(e,t,n,"weekdaysMin")},e.defineLocale=oe,e.updateLocale=function(e,t){if(null!=t){var n,s,i=Qt;null!=(s=re(e))&&(i=s._config),(n=new k(t=D(i,t))).parentLocale=Xt[e],Xt[e]=n,ae(e)}else null!=Xt[e]&&(null!=Xt[e].parentLocale?Xt[e]=Xt[e].parentLocale:null!=Xt[e]&&delete Xt[e]);return Xt[e]},e.locales=function(){return nt(Xt)},e.weekdaysShort=function(e,t,n){return Ie(e,t,n,"weekdaysShort")},e.normalizeUnits=O,e.relativeTimeRounding=function(e){return void 0===e?En:"function"==typeof e&&(En=e,!0)},e.relativeTimeThreshold=function(e,t){return void 0!==In[e]&&(void 0===t?In[e]:(In[e]=t,"s"===e&&(In.ss=t-1),!0))},e.calendarFormat=function(e,t){var n=e.diff(t,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"},e.prototype=Dn,e.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"YYYY-[W]WW",MONTH:"YYYY-MM"},e});
/**
* @version: 3.0.3
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2018 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/
// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
      // AMD. Make globaly available as well
      define(['moment', 'jquery'], function (moment, jquery) {
          if (!jquery.fn) jquery.fn = {}; // webpack server rendering
          return factory(moment, jquery);
      });
  } else if (typeof module === 'object' && module.exports) {
      // Node / Browserify
      //isomorphic issue
      var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
      if (!jQuery) {
          jQuery = require('jquery');
          if (!jQuery.fn) jQuery.fn = {};
      }
      var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
      module.exports = factory(moment, jQuery);
  } else {
      // Browser globals
      root.daterangepicker = factory(root.moment, root.jQuery);
  }
}(this, function(moment, $) {
  var DateRangePicker = function(element, options, cb) {

      //default settings for options
      this.parentEl = 'body';
      this.element = $(element);
      this.startDate = moment().startOf('day');
      this.endDate = moment().endOf('day');
      this.minDate = false;
      this.maxDate = false;
      this.maxSpan = false;
      this.autoApply = false;
      this.singleDatePicker = false;
      this.showDropdowns = false;
      this.minYear = moment().subtract(100, 'year').format('YYYY');
      this.maxYear = moment().add(100, 'year').format('YYYY');
      this.showWeekNumbers = false;
      this.showISOWeekNumbers = false;
      this.showCustomRangeLabel = true;
      this.timePicker = false;
      this.timePicker24Hour = false;
      this.timePickerIncrement = 1;
      this.timePickerSeconds = false;
      this.linkedCalendars = true;
      this.autoUpdateInput = true;
      this.alwaysShowCalendars = false;
      this.ranges = {};

      this.opens = 'right';
      if (this.element.hasClass('pull-right'))
          this.opens = 'left';

      this.drops = 'down';
      if (this.element.hasClass('dropup'))
          this.drops = 'up';

      this.buttonClasses = 'btn btn-sm';
      this.applyButtonClasses = 'btn-primary';
      this.cancelButtonClasses = 'btn-default';

      this.locale = {
          direction: 'ltr',
          format: moment.localeData().longDateFormat('L'),
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: moment.weekdaysMin(),
          monthNames: moment.monthsShort(),
          firstDay: moment.localeData().firstDayOfWeek()
      };

      this.callback = function() { };

      //some state information
      this.isShowing = false;
      this.leftCalendar = {};
      this.rightCalendar = {};

      //custom options from user
      if (typeof options !== 'object' || options === null)
          options = {};

      //allow setting options with data attributes
      //data-api options will be overwritten with custom javascript options
      options = $.extend(this.element.data(), options);

      //html template for the picker UI
      if (typeof options.template !== 'string' && !(options.template instanceof $))
          options.template =
          '<div class="daterangepicker">' +
              '<div class="ranges"></div>' +
              '<div class="drp-calendar left">' +
                  '<div class="calendar-table"></div>' +
                  '<div class="calendar-time"></div>' +
              '</div>' +
              '<div class="drp-calendar right">' +
                  '<div class="calendar-table"></div>' +
                  '<div class="calendar-time"></div>' +
              '</div>' +
              '<div class="drp-buttons">' +
                  '<span class="drp-selected"></span>' +
                  '<button class="cancelBtn" type="button"></button>' +
                  '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
              '</div>' +
          '</div>';

      this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
      this.container = $(options.template).appendTo(this.parentEl);

      //
      // handle all the possible options overriding defaults
      //

      if (typeof options.locale === 'object') {

          if (typeof options.locale.direction === 'string')
              this.locale.direction = options.locale.direction;

          if (typeof options.locale.format === 'string')
              this.locale.format = options.locale.format;

          if (typeof options.locale.separator === 'string')
              this.locale.separator = options.locale.separator;

          if (typeof options.locale.daysOfWeek === 'object')
              this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

          if (typeof options.locale.monthNames === 'object')
            this.locale.monthNames = options.locale.monthNames.slice();

          if (typeof options.locale.firstDay === 'number')
            this.locale.firstDay = options.locale.firstDay;

          if (typeof options.locale.applyLabel === 'string')
            this.locale.applyLabel = options.locale.applyLabel;

          if (typeof options.locale.cancelLabel === 'string')
            this.locale.cancelLabel = options.locale.cancelLabel;

          if (typeof options.locale.weekLabel === 'string')
            this.locale.weekLabel = options.locale.weekLabel;

          if (typeof options.locale.customRangeLabel === 'string'){
              //Support unicode chars in the custom range name.
              var elem = document.createElement('textarea');
              elem.innerHTML = options.locale.customRangeLabel;
              var rangeHtml = elem.value;
              this.locale.customRangeLabel = rangeHtml;
          }
      }
      this.container.addClass(this.locale.direction);

      if (typeof options.startDate === 'string')
          this.startDate = moment(options.startDate, this.locale.format).toLowerCase();

      if (typeof options.endDate === 'string')
          this.endDate = moment(options.endDate, this.locale.format).toLowerCase();

      if (typeof options.minDate === 'string')
          this.minDate = moment(options.minDate, this.locale.format).toLowerCase();

      if (typeof options.maxDate === 'string')
          this.maxDate = moment(options.maxDate, this.locale.format).toLowerCase();

      if (typeof options.startDate === 'object')
          this.startDate = moment(options.startDate).toLowerCase();

      if (typeof options.endDate === 'object')
          this.endDate = moment(options.endDate).toLowerCase();

      if (typeof options.minDate === 'object')
          this.minDate = moment(options.minDate).toLowerCase();

      if (typeof options.maxDate === 'object')
          this.maxDate = moment(options.maxDate).toLowerCase();

      // sanity check for bad options
      if (this.minDate && this.startDate.isBefore(this.minDate))
          this.startDate = this.minDate.clone();

      // sanity check for bad options
      if (this.maxDate && this.endDate.isAfter(this.maxDate))
          this.endDate = this.maxDate.clone();

      if (typeof options.applyButtonClasses === 'string')
          this.applyButtonClasses = options.applyButtonClasses;

      if (typeof options.applyClass === 'string') //backwards compat
          this.applyButtonClasses = options.applyClass;

      if (typeof options.cancelButtonClasses === 'string')
          this.cancelButtonClasses = options.cancelButtonClasses;

      if (typeof options.cancelClass === 'string') //backwards compat
          this.cancelButtonClasses = options.cancelClass;

      if (typeof options.maxSpan === 'object')
          this.maxSpan = options.maxSpan;

      if (typeof options.dateLimit === 'object') //backwards compat
          this.maxSpan = options.dateLimit;

      if (typeof options.opens === 'string')
          this.opens = options.opens;

      if (typeof options.drops === 'string')
          this.drops = options.drops;

      if (typeof options.showWeekNumbers === 'boolean')
          this.showWeekNumbers = options.showWeekNumbers;

      if (typeof options.showISOWeekNumbers === 'boolean')
          this.showISOWeekNumbers = options.showISOWeekNumbers;

      if (typeof options.buttonClasses === 'string')
          this.buttonClasses = options.buttonClasses;

      if (typeof options.buttonClasses === 'object')
          this.buttonClasses = options.buttonClasses.join(' ');

      if (typeof options.showDropdowns === 'boolean')
          this.showDropdowns = options.showDropdowns;

      if (typeof options.minYear === 'number')
          this.minYear = options.minYear;

      if (typeof options.maxYear === 'number')
          this.maxYear = options.maxYear;

      if (typeof options.showCustomRangeLabel === 'boolean')
          this.showCustomRangeLabel = options.showCustomRangeLabel;

      if (typeof options.singleDatePicker === 'boolean') {
          this.singleDatePicker = options.singleDatePicker;
          if (this.singleDatePicker)
              this.endDate = this.startDate.clone();
      }

      if (typeof options.timePicker === 'boolean')
          this.timePicker = options.timePicker;

      if (typeof options.timePickerSeconds === 'boolean')
          this.timePickerSeconds = options.timePickerSeconds;

      if (typeof options.timePickerIncrement === 'number')
          this.timePickerIncrement = options.timePickerIncrement;

      if (typeof options.timePicker24Hour === 'boolean')
          this.timePicker24Hour = options.timePicker24Hour;

      if (typeof options.autoApply === 'boolean')
          this.autoApply = options.autoApply;

      if (typeof options.autoUpdateInput === 'boolean')
          this.autoUpdateInput = options.autoUpdateInput;

      if (typeof options.linkedCalendars === 'boolean')
          this.linkedCalendars = options.linkedCalendars;

      if (typeof options.isInvalidDate === 'function')
          this.isInvalidDate = options.isInvalidDate;

      if (typeof options.isCustomDate === 'function')
          this.isCustomDate = options.isCustomDate;

      if (typeof options.alwaysShowCalendars === 'boolean')
          this.alwaysShowCalendars = options.alwaysShowCalendars;

      // update day names order to firstDay
      if (this.locale.firstDay != 0) {
          var iterator = this.locale.firstDay;
          while (iterator > 0) {
              this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
              iterator--;
          }
      }

      var start, end, range;

      //if no start/end dates set, check if an input element contains initial values
      if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
          if ($(this.element).is(':text')) {
              var val = $(this.element).val(),
                  split = val.split(this.locale.separator);

              start = end = null;

              if (split.length == 2) {
                  start = moment(split[0], this.locale.format);
                  end = moment(split[1], this.locale.format);
              } else if (this.singleDatePicker && val !== "") {
                  start = moment(val, this.locale.format);
                  end = moment(val, this.locale.format);
              }
              if (start !== null && end !== null) {
                  this.setStartDate(start);
                  this.setEndDate(end);
              }
          }
      }

      if (typeof options.ranges === 'object') {
          for (range in options.ranges) {

              if (typeof options.ranges[range][0] === 'string')
                  start = moment(options.ranges[range][0], this.locale.format);
              else
                  start = moment(options.ranges[range][0]);

              if (typeof options.ranges[range][1] === 'string')
                  end = moment(options.ranges[range][1], this.locale.format);
              else
                  end = moment(options.ranges[range][1]);

              // If the start or end date exceed those allowed by the minDate or maxSpan
              // options, shorten the range to the allowable period.
              if (this.minDate && start.isBefore(this.minDate))
                  start = this.minDate.clone();

              var maxDate = this.maxDate;
              if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate))
                  maxDate = start.clone().add(this.maxSpan);
              if (maxDate && end.isAfter(maxDate))
                  end = maxDate.clone();

              // If the end of the range is before the minimum or the start of the range is
              // after the maximum, don't display this range option at all.
              if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
                || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                  continue;

              //Support unicode chars in the range names.
              var elem = document.createElement('textarea');
              elem.innerHTML = range;
              var rangeHtml = elem.value;

              this.ranges[rangeHtml] = [start, end];
          }

          var list = '<ul>';
          for (range in this.ranges) {
              list += '<li data-range-key="' + range + '">' + range + '</li>';
          }
          if (this.showCustomRangeLabel) {
              list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
          }
          list += '</ul>';
          this.container.find('.ranges').prepend(list);
      }

      if (typeof cb === 'function') {
          this.callback = cb;
      }

      if (!this.timePicker) {
          this.startDate = this.startDate.startOf('day');
          this.endDate = this.endDate.endOf('day');
          this.container.find('.calendar-time').hide();
      }

      //can't be used together for now
      if (this.timePicker && this.autoApply)
          this.autoApply = false;

      if (this.autoApply) {
          this.container.addClass('auto-apply');
      }

      if (typeof options.ranges === 'object')
          this.container.addClass('show-ranges');

      if (this.singleDatePicker) {
          this.container.addClass('single');
          this.container.find('.drp-calendar.left').addClass('single');
          this.container.find('.drp-calendar.left').show();
          this.container.find('.drp-calendar.right').hide();
          if (!this.timePicker) {
              this.container.addClass('auto-apply');
          }
      }

      if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
          this.container.addClass('show-calendar');
      }

      this.container.addClass('opens' + this.opens);

      //apply CSS classes and labels to buttons
      this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
      if (this.applyButtonClasses.length)
          this.container.find('.applyBtn').addClass(this.applyButtonClasses);
      if (this.cancelButtonClasses.length)
          this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
      this.container.find('.applyBtn').html(this.locale.applyLabel);
      this.container.find('.cancelBtn').html(this.locale.cancelLabel);

      //
      // event listeners
      //

      this.container.find('.drp-calendar')
          .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
          .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
          .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
          .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
          .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
          .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
          .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))

      this.container.find('.ranges')
          .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))

      this.container.find('.drp-buttons')
          .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
          .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))

      if (this.element.is('input') || this.element.is('button')) {
          this.element.on({
              'click.daterangepicker': $.proxy(this.show, this),
              'focus.daterangepicker': $.proxy(this.show, this),
              'keyup.daterangepicker': $.proxy(this.elementChanged, this),
              'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
          });
      } else {
          this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
          this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
      }

      //
      // if attached to a text input, set the initial value
      //

      this.updateElement();

  };

  DateRangePicker.prototype = {

      constructor: DateRangePicker,

      setStartDate: function(startDate) {
          if (typeof startDate === 'string')
              this.startDate = moment(startDate, this.locale.format).toLowerCase();

          if (typeof startDate === 'object')
              this.startDate = moment(startDate);

          if (!this.timePicker)
              this.startDate = this.startDate.startOf('day');

          if (this.timePicker && this.timePickerIncrement)
              this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

          if (this.minDate && this.startDate.isBefore(this.minDate)) {
              this.startDate = this.minDate.clone();
              if (this.timePicker && this.timePickerIncrement)
                  this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
          }

          if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
              this.startDate = this.maxDate.clone();
              if (this.timePicker && this.timePickerIncrement)
                  this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
          }

          if (!this.isShowing)
              this.updateElement();

          this.updateMonthsInView();
      },

      setEndDate: function(endDate) {
          if (typeof endDate === 'string')
              this.endDate = moment(endDate, this.locale.format).toLowerCase();

          if (typeof endDate === 'object')
              this.endDate = moment(endDate);

          if (!this.timePicker)
              this.endDate = this.endDate.add(1,'d').startOf('day').subtract(1,'second');

          if (this.timePicker && this.timePickerIncrement)
              this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

          if (this.endDate.isBefore(this.startDate))
              this.endDate = this.startDate.clone();

          if (this.maxDate && this.endDate.isAfter(this.maxDate))
              this.endDate = this.maxDate.clone();

          if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
              this.endDate = this.startDate.clone().add(this.maxSpan);

          this.previousRightTime = this.endDate.clone();

          this.container.find('.drp-selected').html(this.startDate.format(this.locale.format).toLowerCase() + this.locale.separator + this.endDate.format(this.locale.format).toLowerCase());
          if (!this.isShowing)
              this.updateElement();

          this.updateMonthsInView();
      },

      isInvalidDate: function() {
          return false;
      },

      isCustomDate: function() {
          return false;
      },

      updateView: function() {
          if (this.timePicker) {
              this.renderTimePicker('left');
              this.renderTimePicker('right');
              if (!this.endDate) {
                  this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
              } else {
                  this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
              }
          }
          if (this.endDate)
              this.container.find('.drp-selected').html(this.startDate.format(this.locale.format).toLowerCase() + this.locale.separator + this.endDate.format(this.locale.format).toLowerCase());
          this.updateMonthsInView();
          this.updateCalendars();
          this.updateFormInputs();
      },

      updateMonthsInView: function() {
          if (this.endDate) {

              //if both dates are visible already, do nothing
              if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                  (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                  &&
                  (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                  ) {
                  return;
              }

              this.leftCalendar.month = this.startDate.clone().date(2);
              if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                  this.rightCalendar.month = this.endDate.clone().date(2);
              } else {
                  this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
              }

          } else {
              if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                  this.leftCalendar.month = this.startDate.clone().date(2);
                  this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
              }
          }
          if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
            this.rightCalendar.month = this.maxDate.clone().date(2);
            this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
          }
      },

      updateCalendars: function() {

          if (this.timePicker) {
              var hour, minute, second;
              if (this.endDate) {
                  hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                  minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                  second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                  if (!this.timePicker24Hour) {
                      var ampm = this.container.find('.left .ampmselect').val();
                      if (ampm === 'PM' && hour < 12)
                          hour += 12;
                      if (ampm === 'AM' && hour === 12)
                          hour = 0;
                  }
              } else {
                  hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                  minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                  second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                  if (!this.timePicker24Hour) {
                      var ampm = this.container.find('.right .ampmselect').val();
                      if (ampm === 'PM' && hour < 12)
                          hour += 12;
                      if (ampm === 'AM' && hour === 12)
                          hour = 0;
                  }
              }
              this.leftCalendar.month.hour(hour).minute(minute).second(second);
              this.rightCalendar.month.hour(hour).minute(minute).second(second);
          }

          this.renderCalendar('left');
          this.renderCalendar('right');

          //highlight any predefined range matching the current start and end dates
          this.container.find('.ranges li').removeClass('active');
          if (this.endDate == null) return;

          this.calculateChosenLabel();
      },

      renderCalendar: function(side) {

          //
          // Build the matrix of dates that will populate the calendar
          //

          var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
          var month = calendar.month.month();
          var year = calendar.month.year();
          var hour = calendar.month.hour();
          var minute = calendar.month.minute();
          var second = calendar.month.second();
          var daysInMonth = moment([year, month]).daysInMonth();
          var firstDay = moment([year, month, 1]);
          var lastDay = moment([year, month, daysInMonth]);
          var lastMonth = moment(firstDay).subtract(1, 'month').month();
          var lastYear = moment(firstDay).subtract(1, 'month').year();
          var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
          var dayOfWeek = firstDay.day();

          //initialize a 6 rows x 7 columns array for the calendar
          var calendar = [];
          calendar.firstDay = firstDay;
          calendar.lastDay = lastDay;

          for (var i = 0; i < 6; i++) {
              calendar[i] = [];
          }

          //populate the calendar with date objects
          var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
          if (startDay > daysInLastMonth)
              startDay -= 7;

          if (dayOfWeek == this.locale.firstDay)
              startDay = daysInLastMonth - 6;

          var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

          var col, row;
          for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
              if (i > 0 && col % 7 === 0) {
                  col = 0;
                  row++;
              }
              calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
              curDate.hour(12);

              if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                  calendar[row][col] = this.minDate.clone();
              }

              if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                  calendar[row][col] = this.maxDate.clone();
              }

          }

          //make the calendar object available to hoverDate/clickDate
          if (side == 'left') {
              this.leftCalendar.calendar = calendar;
          } else {
              this.rightCalendar.calendar = calendar;
          }

          //
          // Display the calendar
          //

          var minDate = side == 'left' ? this.minDate : this.startDate;
          var maxDate = this.maxDate;
          var selected = side == 'left' ? this.startDate : this.endDate;
          var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

          var html = '<table class="table-condensed">';
          html += '<thead>';
          html += '<tr>';

          // add empty cell for week number
          if (this.showWeekNumbers || this.showISOWeekNumbers)
              html += '<th></th>';

          if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
              html += '<th class="prev available"><span></span></th>';
          } else {
              html += '<th></th>';
          }

          var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

          if (this.showDropdowns) {
              var currentMonth = calendar[1][1].month();
              var currentYear = calendar[1][1].year();
              var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
              var minYear = (minDate && minDate.year()) || (this.minYear);
              var inMinYear = currentYear == minYear;
              var inMaxYear = currentYear == maxYear;

              var monthHtml = '<select class="monthselect">';
              for (var m = 0; m < 12; m++) {
                  if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
                      monthHtml += "<option value='" + m + "'" +
                          (m === currentMonth ? " selected='selected'" : "") +
                          ">" + this.locale.monthNames[m] + "</option>";
                  } else {
                      monthHtml += "<option value='" + m + "'" +
                          (m === currentMonth ? " selected='selected'" : "") +
                          " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                  }
              }
              monthHtml += "</select>";

              var yearHtml = '<select class="yearselect">';
              for (var y = minYear; y <= maxYear; y++) {
                  yearHtml += '<option value="' + y + '"' +
                      (y === currentYear ? ' selected="selected"' : '') +
                      '>' + y + '</option>';
              }
              yearHtml += '</select>';

              dateHtml = monthHtml + yearHtml;
          }

          html += '<th colspan="5" class="month">' + dateHtml + '</th>';
          if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
              html += '<th class="next available"><span></span></th>';
          } else {
              html += '<th></th>';
          }

          html += '</tr>';
          html += '<tr>';

          // add week number label
          if (this.showWeekNumbers || this.showISOWeekNumbers)
              html += '<th class="week">' + this.locale.weekLabel + '</th>';

          $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
              html += '<th>' + dayOfWeek + '</th>';
          });

          html += '</tr>';
          html += '</thead>';
          html += '<tbody>';

          //adjust maxDate to reflect the maxSpan setting in order to
          //grey out end dates beyond the maxSpan
          if (this.endDate == null && this.maxSpan) {
              var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
              if (!maxDate || maxLimit.isBefore(maxDate)) {
                  maxDate = maxLimit;
              }
          }

          for (var row = 0; row < 6; row++) {
              html += '<tr>';

              // add week number
              if (this.showWeekNumbers)
                  html += '<td class="week">' + calendar[row][0].week() + '</td>';
              else if (this.showISOWeekNumbers)
                  html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

              for (var col = 0; col < 7; col++) {

                  var classes = [];

                  //highlight today's date
                  if (calendar[row][col].isSame(new Date(), "day"))
                      classes.push('today');

                  //highlight weekends
                  if (calendar[row][col].isoWeekday() > 5)
                      classes.push('weekend');

                  //grey out the dates in other months displayed at beginning and end of this calendar
                  if (calendar[row][col].month() != calendar[1][1].month())
                      classes.push('off');

                  //don't allow selection of dates before the minimum date
                  if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                      classes.push('off', 'disabled');

                  //don't allow selection of dates after the maximum date
                  if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                      classes.push('off', 'disabled');

                  //don't allow selection of date if a custom function decides it's invalid
                  if (this.isInvalidDate(calendar[row][col]))
                      classes.push('off', 'disabled');

                  //highlight the currently selected start date
                  if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                      classes.push('active', 'start-date');

                  //highlight the currently selected end date
                  if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                      classes.push('active', 'end-date');

                  //highlight dates in-between the selected dates
                  if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                      classes.push('in-range');

                  //apply custom classes for this date
                  var isCustom = this.isCustomDate(calendar[row][col]);
                  if (isCustom !== false) {
                      if (typeof isCustom === 'string')
                          classes.push(isCustom);
                      else
                          Array.prototype.push.apply(classes, isCustom);
                  }

                  var cname = '', disabled = false;
                  for (var i = 0; i < classes.length; i++) {
                      cname += classes[i] + ' ';
                      if (classes[i] == 'disabled')
                          disabled = true;
                  }
                  if (!disabled)
                      cname += 'available';

                  html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

              }
              html += '</tr>';
          }

          html += '</tbody>';
          html += '</table>';

          this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);

      },

      renderTimePicker: function(side) {

          // Don't bother updating the time picker if it's currently disabled
          // because an end date hasn't been clicked yet
          if (side == 'right' && !this.endDate) return;

          var html, selected, minDate, maxDate = this.maxDate;

          if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isAfter(this.maxDate)))
              maxDate = this.startDate.clone().add(this.maxSpan);

          if (side == 'left') {
              selected = this.startDate.clone();
              minDate = this.minDate;
          } else if (side == 'right') {
              selected = this.endDate.clone();
              minDate = this.startDate;

              //Preserve the time already selected
              var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
              if (timeSelector.html() != '') {

                  selected.hour(selected.hour() || timeSelector.find('.hourselect option:selected').val());
                  selected.minute(selected.minute() || timeSelector.find('.minuteselect option:selected').val());
                  selected.second(selected.second() || timeSelector.find('.secondselect option:selected').val());

                  if (!this.timePicker24Hour) {
                      var ampm = timeSelector.find('.ampmselect option:selected').val();
                      if (ampm === 'PM' && selected.hour() < 12)
                          selected.hour(selected.hour() + 12);
                      if (ampm === 'AM' && selected.hour() === 12)
                          selected.hour(0);
                  }

              }

              if (selected.isBefore(this.startDate))
                  selected = this.startDate.clone();

              if (maxDate && selected.isAfter(maxDate))
                  selected = maxDate.clone();

          }

          //
          // hours
          //

          html = '<select class="hourselect">';

          var start = this.timePicker24Hour ? 0 : 1;
          var end = this.timePicker24Hour ? 23 : 12;

          for (var i = start; i <= end; i++) {
              var i_in_24 = i;
              if (!this.timePicker24Hour)
                  i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

              var time = selected.clone().hour(i_in_24);
              var disabled = false;
              if (minDate && time.minute(59).isBefore(minDate))
                  disabled = true;
              if (maxDate && time.minute(0).isAfter(maxDate))
                  disabled = true;

              if (i_in_24 == selected.hour() && !disabled) {
                  html += '<option value="' + i + '" selected="selected">' + i + '</option>';
              } else if (disabled) {
                  html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
              } else {
                  html += '<option value="' + i + '">' + i + '</option>';
              }
          }

          html += '</select> ';

          //
          // minutes
          //

          html += ': <select class="minuteselect">';

          for (var i = 0; i < 60; i += this.timePickerIncrement) {
              var padded = i < 10 ? '0' + i : i;
              var time = selected.clone().minute(i);

              var disabled = false;
              if (minDate && time.second(59).isBefore(minDate))
                  disabled = true;
              if (maxDate && time.second(0).isAfter(maxDate))
                  disabled = true;

              if (selected.minute() == i && !disabled) {
                  html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
              } else if (disabled) {
                  html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
              } else {
                  html += '<option value="' + i + '">' + padded + '</option>';
              }
          }

          html += '</select> ';

          //
          // seconds
          //

          if (this.timePickerSeconds) {
              html += ': <select class="secondselect">';

              for (var i = 0; i < 60; i++) {
                  var padded = i < 10 ? '0' + i : i;
                  var time = selected.clone().second(i);

                  var disabled = false;
                  if (minDate && time.isBefore(minDate))
                      disabled = true;
                  if (maxDate && time.isAfter(maxDate))
                      disabled = true;

                  if (selected.second() == i && !disabled) {
                      html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                  } else if (disabled) {
                      html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                  } else {
                      html += '<option value="' + i + '">' + padded + '</option>';
                  }
              }

              html += '</select> ';
          }

          //
          // AM/PM
          //

          if (!this.timePicker24Hour) {
              html += '<select class="ampmselect">';

              var am_html = '';
              var pm_html = '';

              if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                  am_html = ' disabled="disabled" class="disabled"';

              if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                  pm_html = ' disabled="disabled" class="disabled"';

              if (selected.hour() >= 12) {
                  html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
              } else {
                  html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
              }

              html += '</select>';
          }

          this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);

      },

      updateFormInputs: function() {

          if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
              this.container.find('button.applyBtn').removeAttr('disabled');
          } else {
              this.container.find('button.applyBtn').attr('disabled', 'disabled');
          }

      },

      move: function() {
          var parentOffset = { top: 0, left: 0 },
              containerTop;
          var parentRightEdge = $(window).width();
          if (!this.parentEl.is('body')) {
              parentOffset = {
                  top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                  left: this.parentEl.offset().left - this.parentEl.scrollLeft()
              };
              parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
          }

          if (this.drops == 'up')
              containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
          else
              containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
          this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('drop-up');

          if (this.opens == 'left') {
              this.container.css({
                  top: containerTop,
                  right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
                  left: 'auto'
              });
              if (this.container.offset().left < 0) {
                  this.container.css({
                      right: 'auto',
                      left: 9
                  });
              }
          } else if (this.opens == 'center') {
              this.container.css({
                  top: containerTop,
                  left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                          - this.container.outerWidth() / 2,
                  right: 'auto'
              });
              if (this.container.offset().left < 0) {
                  this.container.css({
                      right: 'auto',
                      left: 9
                  });
              }
          } else {
              this.container.css({
                  top: containerTop,
                  left: this.element.offset().left - parentOffset.left,
                  right: 'auto'
              });
              if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
                  this.container.css({
                      left: 'auto',
                      right: 0
                  });
              }
          }
      },

      show: function(e) {
          if (this.isShowing) return;

          // Create a click proxy that is private to this instance of datepicker, for unbinding
          this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

          // Bind global datepicker mousedown for hiding and
          $(document)
            .on('mousedown.daterangepicker', this._outsideClickProxy)
            // also support mobile devices
            .on('touchend.daterangepicker', this._outsideClickProxy)
            // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
            .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
            // and also close when focus changes to outside the picker (eg. tabbing between controls)
            .on('focusin.daterangepicker', this._outsideClickProxy);

          // Reposition the picker if the window is resized while it's open
          $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

          this.oldStartDate = this.startDate.clone();
          this.oldEndDate = this.endDate.clone();
          this.previousRightTime = this.endDate.clone();

          this.updateView();
          this.container.show();
          this.move();
          this.element.trigger('show.daterangepicker', this);
          this.isShowing = true;
      },

      hide: function(e) {
          if (!this.isShowing) return;

          //incomplete date selection, revert to last values
          if (!this.endDate) {
              this.startDate = this.oldStartDate.clone();
              this.endDate = this.oldEndDate.clone();
          }

          //if a new date range was selected, invoke the user callback function
          if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
              this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);

          //if picker is attached to a text input, update it
          this.updateElement();

          $(document).off('.daterangepicker');
          $(window).off('.daterangepicker');
          this.container.hide();
          this.element.trigger('hide.daterangepicker', this);
          this.isShowing = false;
      },

      toggle: function(e) {
          if (this.isShowing) {
              this.hide();
          } else {
              this.show();
          }
      },

      outsideClick: function(e) {
          var target = $(e.target);
          // if the page is clicked anywhere except within the daterangerpicker/button
          // itself then call this.hide()
          if (
              // ie modal dialog fix
              e.type == "focusin" ||
              target.closest(this.element).length ||
              target.closest(this.container).length ||
              target.closest('.calendar-table').length
              ) return;
          this.hide();
          this.element.trigger('outsideClick.daterangepicker', this);
      },

      showCalendars: function() {
          this.container.addClass('show-calendar');
          this.move();
          this.element.trigger('showCalendar.daterangepicker', this);
      },

      hideCalendars: function() {
          this.container.removeClass('show-calendar');
          this.element.trigger('hideCalendar.daterangepicker', this);
      },

      clickRange: function(e) {
          var label = e.target.getAttribute('data-range-key');
          this.chosenLabel = label;
          if (label == this.locale.customRangeLabel) {
              this.showCalendars();
          } else {
              var dates = this.ranges[label];
              this.startDate = dates[0];
              this.endDate = dates[1];

              if (!this.timePicker) {
                  this.startDate.startOf('day');
                  this.endDate.endOf('day');
              }

              if (!this.alwaysShowCalendars)
                  this.hideCalendars();
              this.clickApply();
          }
      },

      clickPrev: function(e) {
          var cal = $(e.target).parents('.drp-calendar');
          if (cal.hasClass('left')) {
              this.leftCalendar.month.subtract(1, 'month');
              if (this.linkedCalendars)
                  this.rightCalendar.month.subtract(1, 'month');
          } else {
              this.rightCalendar.month.subtract(1, 'month');
          }
          this.updateCalendars();
      },

      clickNext: function(e) {
          var cal = $(e.target).parents('.drp-calendar');
          if (cal.hasClass('left')) {
              this.leftCalendar.month.add(1, 'month');
          } else {
              this.rightCalendar.month.add(1, 'month');
              if (this.linkedCalendars)
                  this.leftCalendar.month.add(1, 'month');
          }
          this.updateCalendars();
      },

      hoverDate: function(e) {

          //ignore dates that can't be selected
          if (!$(e.target).hasClass('available')) return;

          var title = $(e.target).attr('data-title');
          var row = title.substr(1, 1);
          var col = title.substr(3, 1);
          var cal = $(e.target).parents('.drp-calendar');
          var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

          //highlight the dates between the start date and the date being hovered as a potential end date
          var leftCalendar = this.leftCalendar;
          var rightCalendar = this.rightCalendar;
          var startDate = this.startDate;
          if (!this.endDate) {
              this.container.find('.drp-calendar tbody td').each(function(index, el) {

                  //skip week numbers, only look at dates
                  if ($(el).hasClass('week')) return;

                  var title = $(el).attr('data-title');
                  var row = title.substr(1, 1);
                  var col = title.substr(3, 1);
                  var cal = $(el).parents('.drp-calendar');
                  var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                  if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                      $(el).addClass('in-range');
                  } else {
                      $(el).removeClass('in-range');
                  }

              });
          }

      },

      clickDate: function(e) {

          if (!$(e.target).hasClass('available')) return;

          var title = $(e.target).attr('data-title');
          var row = title.substr(1, 1);
          var col = title.substr(3, 1);
          var cal = $(e.target).parents('.drp-calendar');
          var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

          //
          // this function needs to do a few things:
          // * alternate between selecting a start and end date for the range,
          // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
          // * if autoapply is enabled, and an end date was chosen, apply the selection
          // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
          // * if one of the inputs above the calendars was focused, cancel that manual input
          //

          if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
              if (this.timePicker) {
                  var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                  if (!this.timePicker24Hour) {
                      var ampm = this.container.find('.left .ampmselect').val();
                      if (ampm === 'PM' && hour < 12)
                          hour += 12;
                      if (ampm === 'AM' && hour === 12)
                          hour = 0;
                  }
                  var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                  var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                  date = date.clone().hour(hour).minute(minute).second(second);
              }
              this.endDate = null;
              this.setStartDate(date.clone());
          } else if (!this.endDate && date.isBefore(this.startDate)) {
              //special case: clicking the same date for start/end,
              //but the time of the end date is before the start date
              this.setEndDate(this.startDate.clone());
          } else { // picking end
              if (this.timePicker) {
                  var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                  if (!this.timePicker24Hour) {
                      var ampm = this.container.find('.right .ampmselect').val();
                      if (ampm === 'PM' && hour < 12)
                          hour += 12;
                      if (ampm === 'AM' && hour === 12)
                          hour = 0;
                  }
                  var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                  var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                  date = date.clone().hour(hour).minute(minute).second(second);
              }
              this.setEndDate(date.clone());
              if (this.autoApply) {
                this.calculateChosenLabel();
                this.clickApply();
              }
          }

          if (this.singleDatePicker) {
              this.setEndDate(this.startDate);
              if (!this.timePicker)
                  this.clickApply();
          }

          this.updateView();

          //This is to cancel the blur event handler if the mouse was in one of the inputs
          e.stopPropagation();

      },

      calculateChosenLabel: function () {
          var customRange = true;
          var i = 0;
          for (var range in this.ranges) {
            if (this.timePicker) {
                  var format = this.timePickerSeconds ? "YYYY-MM-DD hh:mm:ss" : "YYYY-MM-DD hh:mm";
                  //ignore times when comparing dates if time picker seconds is not enabled
                  if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                      customRange = false;
                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                      break;
                  }
              } else {
                  //ignore times when comparing dates if time picker is not enabled
                  if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                      customRange = false;
                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                      break;
                  }
              }
              i++;
          }
          if (customRange) {
              if (this.showCustomRangeLabel) {
                  this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
              } else {
                  this.chosenLabel = null;
              }
              this.showCalendars();
          }
      },

      clickApply: function(e) {
          this.hide();
          this.element.trigger('apply.daterangepicker', this);
      },

      clickCancel: function(e) {
          this.startDate = this.oldStartDate;
          this.endDate = this.oldEndDate;
          this.hide();
          this.element.trigger('cancel.daterangepicker', this);
      },

      monthOrYearChanged: function(e) {
          var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'),
              leftOrRight = isLeft ? 'left' : 'right',
              cal = this.container.find('.drp-calendar.'+leftOrRight);

          // Month must be Number for new moment versions
          var month = parseInt(cal.find('.monthselect').val(), 10);
          var year = cal.find('.yearselect').val();

          if (!isLeft) {
              if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                  month = this.startDate.month();
                  year = this.startDate.year();
              }
          }

          if (this.minDate) {
              if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                  month = this.minDate.month();
                  year = this.minDate.year();
              }
          }

          if (this.maxDate) {
              if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                  month = this.maxDate.month();
                  year = this.maxDate.year();
              }
          }

          if (isLeft) {
              this.leftCalendar.month.month(month).year(year);
              if (this.linkedCalendars)
                  this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
          } else {
              this.rightCalendar.month.month(month).year(year);
              if (this.linkedCalendars)
                  this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
          }
          this.updateCalendars();
      },

      timeChanged: function(e) {

          var cal = $(e.target).closest('.drp-calendar'),
              isLeft = cal.hasClass('left');

          var hour = parseInt(cal.find('.hourselect').val(), 10);
          var minute = parseInt(cal.find('.minuteselect').val(), 10);
          var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

          if (!this.timePicker24Hour) {
              var ampm = cal.find('.ampmselect').val();
              if (ampm === 'PM' && hour < 12)
                  hour += 12;
              if (ampm === 'AM' && hour === 12)
                  hour = 0;
          }

          if (isLeft) {
              var start = this.startDate.clone();
              start.hour(hour);
              start.minute(minute);
              start.second(second);
              this.setStartDate(start);
              if (this.singleDatePicker) {
                  this.endDate = this.startDate.clone();
              } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                  this.setEndDate(start.clone());
              }
          } else if (this.endDate) {
              var end = this.endDate.clone();
              end.hour(hour);
              end.minute(minute);
              end.second(second);
              this.setEndDate(end);
          }

          //update the calendars so all clickable dates reflect the new time component
          this.updateCalendars();

          //update the form inputs above the calendars with the new time
          this.updateFormInputs();

          //re-render the time pickers because changing one selection can affect what's enabled in another
          this.renderTimePicker('left');
          this.renderTimePicker('right');

      },

      elementChanged: function() {
          if (!this.element.is('input')) return;
          if (!this.element.val().length) return;

          var dateString = this.element.val().split(this.locale.separator),
              start = null,
              end = null;

          if (dateString.length === 2) {
              start = moment(dateString[0], this.locale.format).toLowerCase();
              end = moment(dateString[1], this.locale.format).toLowerCase();
          }

          if (this.singleDatePicker || start === null || end === null) {
              start = moment(this.element.val(), this.locale.format).toLowerCase();
              end = start;
          }

          if (!start.isValid() || !end.isValid()) return;

          this.setStartDate(start);
          this.setEndDate(end);
          this.updateView();
      },

      keydown: function(e) {
          //hide on tab or enter
          if ((e.keyCode === 9) || (e.keyCode === 13)) {
              this.hide();
          }

          //hide on esc and prevent propagation
          if (e.keyCode === 27) {
              e.preventDefault();
              e.stopPropagation();

              this.hide();
          }
      },

      updateElement: function() {
          if (this.element.is('input') && this.autoUpdateInput) {

              var newValue = this.startDate.format(this.locale.format).toLowerCase();
              if (!this.singleDatePicker) {
                  newValue += this.locale.separator + this.endDate.format(this.locale.format).toLowerCase();

              }
              if (newValue !== this.element.val()) {
                  this.element.val(newValue).trigger('change');

              }
          }
      },

      remove: function() {
          this.container.remove();
          this.element.off('.daterangepicker');
          this.element.removeData();
      }

  };

  $.fn.daterangepicker = function(options, callback) {
      var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
      this.each(function() {
          var el = $(this);
          if (el.data('daterangepicker'))
              el.data('daterangepicker').remove();
          el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
      });
      return this;
  };

  return DateRangePicker;

}));
(function(){var a;a=angular.module("daterangepicker",[]),a.constant("dateRangePickerConfig",{cancelOnOutsideClick:!0,locale:{separator:" - ",format:"YYYY-MM-DD",clearLabel:"Clear"}}),a.directive("dateRangePicker",["$compile","$timeout","$parse","dateRangePickerConfig",function(a,b,c,d){return{require:"ngModel",restrict:"A",scope:{min:"=",max:"=",picker:"=?",model:"=ngModel",opts:"=options",clearable:"="},link:function(a,c,e,f){var g,h,i,j,k,l,m,n,o,p,q,r,s,t;return j=function(){var a,b;return b=angular.extend.apply(angular,Array.prototype.slice.call(arguments).map(function(a){return null!=a?a.locale:void 0}).filter(function(a){return!!a})),a=angular.extend.apply(angular,arguments),a.locale=b,a},r=$(c),r.attr("ng-trim","false"),e.ngTrim="false",p=!1,function(){var a,b;if(f.$options&&"function"==typeof f.$options.getOption?(b=f.$options.getOption("updateOn"),p=!!f.$options.getOption("allowInvalid")):(b=f.$options&&f.$options.updateOn||"",p=!(!f.$options||!f.$options.allowInvalid)),!b.includes("change"))return"function"==typeof f.$overrideModelOptions?(b+=" change",f.$overrideModelOptions({"*":"$inherit",updateOn:b})):(b+=" change",b.replace(/default/g," "),a=angular.copy(f.$options)||{},a.updateOn=b,a.updateOnDefault=!1,f.$options=a)}(),q=a.opts,t=j({},angular.copy(d),q),k=null,g=function(){if(k)return k.setStartDate(),k.setEndDate()},l=function(a){return function(b){if(b&&(!moment.isMoment(b)||b.isValid()))return b=moment(b),k?a(b):void 0}},n=l(function(a){return a&&k.endDate<a&&k.setEndDate(a),k.setStartDate(a),t.startDate=k.startDate}),m=l(function(a){return a&&k.startDate>a?(k.setEndDate(k.startDate),t.endDate=k.endDate,k.setStartDate(a),t.startDate=k.startDate):(k.setEndDate(a),t.endDate=k.endDate)}),s=function(a){var b;return b=function(a){return moment.isMoment(a)?a.format(t.locale.format):moment(a).format(t.locale.format)},t.singleDatePicker&&a?b(a):a&&(a.startDate||a.endDate)?[b(a.startDate).toLowerCase(),b(a.endDate).toLowerCase()].join(t.locale.separator):""},f.$formatters.push(function(a){return s(a)}),f.$renderOriginal=f.$render,f.$render=function(){if(f.$modelValue&&t.singleDatePicker?(n(f.$modelValue),m(f.$modelValue)):f.$modelValue&&(f.$modelValue.startDate||f.$modelValue.endDate)?(n(f.$modelValue.startDate),m(f.$modelValue.endDate)):g(),f.$valid)return f.$renderOriginal()},f.$parsers.push(function(a){var b,c,d;return b=function(a){var b;return b=moment(a,t.locale.format),b.isValid()&&b||null},c=t.singleDatePicker?null:{startDate:null,endDate:null},angular.isString(a)&&a.length>0&&(t.singleDatePicker?c=b(a):(d=a.split(t.locale.separator).map(b),c.startDate=d[0]?d[0].startOf("day"):null,c.endDate=d[1]?d[1].endOf("day"):null)),c}),f.$isEmpty=function(a){return!(angular.isString(a)&&a.length>0)},h=function(){var b;r.daterangepicker(angular.extend(t,{autoUpdateInput:!1}),function(b,c,d){return a.$apply(function(){if("function"==typeof t.changeCallback)return t.changeCallback.apply(this,arguments)})}),k=r.data("daterangepicker"),a.picker=k,k.container.hide(),k.container.addClass((t.pickerClasses||"")+" "+(e.pickerClasses||"")),r.on("show.daterangepicker",function(b,c){return r.addClass("picker-open"),a.$apply(function(){t.singleDatePicker?c.startDate.isSame(a.model)||(n(a.model),m(a.model)):(a.model&&!c.startDate.isSame(a.model.startDate)&&n(a.model.startDate),a.model&&!c.endDate.isSame(a.model.endDate)&&m(a.model.endDate)),c.updateView()})}),r.on("hide.daterangepicker",function(a,b){return r.removeClass("picker-open")}),r.on("apply.daterangepicker",function(b,c){return a.$apply(function(){t.singleDatePicker?c.startDate?c.startDate.isSame(a.model)||(a.model=c.startDate):a.model=null:c.startDate.isSame(c.oldStartDate)&&c.endDate.isSame(c.oldEndDate)&&a.model&&c.startDate.isSame(a.model.startDate)&&c.endDate.isSame(a.model.endDate)||(a.model={startDate:c.startDate,endDate:c.endDate,label:c.chosenLabel})})}),r.on("outsideClick.daterangepicker",function(b,c){return t.cancelOnOutsideClick?a.$apply(function(){return c.cancelingClick=!0,c.clickCancel()}):c.clickApply()});for(b in t.eventHandlers)r.on(b,function(b,c){var d;return d=b.type+"."+b.namespace,a.$evalAsync(t.eventHandlers[d])});if(f.$validate(),!a.model)return r.trigger("change")},a.$watch(function(){return s(a.model)},function(a){return"function"==typeof f.$processModelValue?(f.$processModelValue(),f.$render()):("function"==typeof f.$$updateEmptyClasses&&f.$$updateEmptyClasses(a),f.$viewValue=f.$$lastCommittedViewValue=a,f.$render())}),f.$validators.invalid=function(a,b){var c,d;return c=e.required&&!f.$isEmpty(b),d=t.singleDatePicker?a&&a.isValid():a&&a.startDate&&a.startDate.isValid()&&a.endDate&&a.endDate.isValid(),!c||!!d},o=function(a,b,c){var d;return!a||!b&&!c||(d=[a,b,c].map(function(a){return a?moment(a):a}),a=d[0],b=d[1],c=d[2],(!b||b.isBefore(a)||b.isSame(a,"day"))&&(!c||c.isSame(a,"day")||c.isAfter(a)))},i=function(c,d,g,h){if(f.$validators[c]=function(a){return!t[h]||(t.singleDatePicker?"min"===c?!a||d(a,t.minDate,a):"max"===c?!a||d(a,a,t.maxDate):void 0:a&&d(a[g],t.minDate,t.maxDate))},e[c])return a.$watch(c,function(a){if(t[h]=!!a&&moment(a),k)return k[h]=t[h],b(function(){return f.$validate()})})},i("min",o,"startDate","minDate"),i("max",o,"endDate","maxDate"),a.$watch("opts",function(a){return null==a&&(a={}),t=j(t,a),h()},!0),e.clearable&&a.$watch("clearable",function(c){if(c&&(t=j(t,{locale:{cancelLabel:t.locale.clearLabel}})),h(),c)return r.on("cancel.daterangepicker",function(c,d){return d.cancelingClick||(a.model=t.singleDatePicker?null:{startDate:null,endDate:null},r.val("")),d.cancelingClick=null,b(function(){return a.$apply()})})}),a.$on("$destroy",function(){return null!=k?k.remove():void 0})}}}])}).call(this);
//# sourceMappingURL=angular-daterangepicker.min.js.map

/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 2.7.1
 *
 * Copyright 2017 Nick Downie
 * Released under the MIT license
 * https://github.com/chartjs/Chart.js/blob/master/LICENSE.md
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Chart = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){

},{}],2:[function(require,module,exports){
/* MIT license */
var colorNames = require(6);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}

},{"6":6}],3:[function(require,module,exports){
/* MIT license */
var convert = require(5);
var string = require(2);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;

},{"2":2,"5":5}],4:[function(require,module,exports){
/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}

},{}],5:[function(require,module,exports){
var conversions = require(4);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;
},{"4":4}],6:[function(require,module,exports){
'use strict'

module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

},{}],7:[function(require,module,exports){
/**
 * @namespace Chart
 */
var Chart = require(29)();

Chart.helpers = require(45);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
require(27)(Chart);

Chart.defaults = require(25);
Chart.Element = require(26);
Chart.elements = require(40);
Chart.Interaction = require(28);
Chart.platform = require(48);

require(31)(Chart);
require(22)(Chart);
require(23)(Chart);
require(24)(Chart);
require(30)(Chart);
require(33)(Chart);
require(32)(Chart);
require(35)(Chart);

require(54)(Chart);
require(52)(Chart);
require(53)(Chart);
require(55)(Chart);
require(56)(Chart);
require(57)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
require(15)(Chart);
require(16)(Chart);
require(17)(Chart);
require(18)(Chart);
require(19)(Chart);
require(20)(Chart);
require(21)(Chart);

require(8)(Chart);
require(9)(Chart);
require(10)(Chart);
require(11)(Chart);
require(12)(Chart);
require(13)(Chart);
require(14)(Chart);

// Loading built-it plugins
var plugins = [];

plugins.push(
	require(49)(Chart),
	require(50)(Chart),
	require(51)(Chart)
);

Chart.plugins.register(plugins);

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;

},{"10":10,"11":11,"12":12,"13":13,"14":14,"15":15,"16":16,"17":17,"18":18,"19":19,"20":20,"21":21,"22":22,"23":23,"24":24,"25":25,"26":26,"27":27,"28":28,"29":29,"30":30,"31":31,"32":32,"33":33,"35":35,"40":40,"45":45,"48":48,"49":49,"50":50,"51":51,"52":52,"53":53,"54":54,"55":55,"56":56,"57":57,"8":8,"9":9}],8:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};

},{}],9:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};

},{}],11:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};

},{}],12:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};

},{}],13:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};

},{}],14:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};

},{}],15:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks.length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @private
		 */
		getStackIndex: function(datasetIndex) {
			return this.getStackCount(datasetIndex) - 1;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var pixels = [];
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var i, ilen;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			return {
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var stackIndex = me.getStackIndex(datasetIndex);
			var pixels = ruler.pixels;
			var base = pixels[index];
			var length = pixels.length;
			var start = ruler.start;
			var end = ruler.end;
			var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;

			if (length === 1) {
				leftSampleSize = base > start ? base - start : end - base;
				rightSampleSize = base < end ? end - base : base - start;
			} else {
				if (index > 0) {
					leftSampleSize = (base - pixels[index - 1]) / 2;
					if (index === length - 1) {
						rightSampleSize = leftSampleSize;
					}
				}
				if (index < length - 1) {
					rightSampleSize = (pixels[index + 1] - base) / 2;
					if (index === 0) {
						leftSampleSize = rightSampleSize;
					}
				}
			}

			leftCategorySize = leftSampleSize * options.categoryPercentage;
			rightCategorySize = rightSampleSize * options.categoryPercentage;
			fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
			size = fullBarSize * options.barPercentage;

			size = Math.min(
				helpers.valueOrDefault(options.barThickness, size),
				helpers.valueOrDefault(options.maxBarThickness, Infinity));

			base -= leftCategorySize;
			base += fullBarSize * stackIndex;
			base += (fullBarSize - size) / 2;

			return {
				size: size,
				base: base,
				head: base + size,
				center: base + size / 2
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};

},{"25":25,"40":40,"45":45}],16:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @protected
		 */
		removeHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = options.backgroundColor;
			model.borderColor = options.borderColor;
			model.borderWidth = options.borderWidth;
			model.radius = options.radius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});
};

},{"25":25,"40":40,"45":45}],17:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (value / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};

},{"25":25,"40":40,"45":45}],18:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};

},{"25":25,"40":40,"45":45}],19:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};

},{"25":25,"40":40,"45":45}],20:[function(require,module,exports){
'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};

},{"25":25,"40":40,"45":45}],21:[function(require,module,exports){
'use strict';

var defaults = require(25);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};

},{"25":25}],22:[function(require,module,exports){
/* global window: false */
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};

},{"25":25,"26":26,"45":45}],23:[function(require,module,exports){
'use strict';

var defaults = require(25);
var helpers = require(45);
var Interaction = require(28);
var platform = require(48);

module.exports = function(Chart) {
	var plugins = Chart.plugins;

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		// Update Scale(s) with options
		if (newOptions.scale) {
			chart.scale.options = newOptions.scale;
		} else if (newOptions.scales) {
			newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
				chart.scales[scaleOptions.id].options = scaleOptions;
			});
		}

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales = {};
			var items = [];

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
				var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				var scale = new scaleClass({
					id: scaleOptions.id,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});

				scales[scale.id] = scale;
				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			helpers.each(newControllers, function(controller) {
				controller.reset();
			});

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			Chart.layoutService.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			changed |= tooltip && tooltip.handleEvent(e);

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};

},{"25":25,"28":28,"45":45,"48":48}],24:[function(require,module,exports){
'use strict';

var helpers = require(45);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};

},{"45":45}],25:[function(require,module,exports){
'use strict';

var helpers = require(45);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};

},{"45":45}],26:[function(require,module,exports){
'use strict';

var color = require(3);
var helpers = require(45);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;

},{"3":3,"45":45}],27:[function(require,module,exports){
/* global window: false */
/* global document: false */
'use strict';

var color = require(3);
var defaults = require(25);
var helpers = require(45);

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			return Math.log(x) / Math.LN10;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		canvas.style.height = height + 'px';
		canvas.style.width = width + 'px';
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

},{"25":25,"3":3,"45":45}],28:[function(require,module,exports){
'use strict';

var helpers = require(45);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

},{"45":45}],29:[function(require,module,exports){
'use strict';

var defaults = require(25);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};

},{"25":25}],30:[function(require,module,exports){
'use strict';

var helpers = require(45);

module.exports = function(Chart) {

	function filterByPosition(array, position) {
		return helpers.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	Chart.layoutService = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, chartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}

			helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;

			helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});

			helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers.each(leftBoxes.concat(rightBoxes), fitBox);

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			// Set the Left and Right margins for the horizontal boxes
			helpers.each(topBoxes.concat(bottomBoxes), fitBox);

			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});

			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};

				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				helpers.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers.each(rightBoxes, placeBox);
			helpers.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};

			// Step 9
			helpers.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
};

},{"45":45}],31:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	plugins: {}
});

module.exports = function(Chart) {

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	Chart.plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart._plugins || (chart._plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers.clone(defaults.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		}
	};

	/**
	 * Plugin extension hooks.
	 * @interface IPlugin
	 * @since 2.1.0
	 */
	/**
	 * @method IPlugin#beforeInit
	 * @desc Called before initializing `chart`.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterInit
	 * @desc Called after `chart` has been initialized and before the first update.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeUpdate
	 * @desc Called before updating `chart`. If any plugin returns `false`, the update
	 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart update.
	 */
	/**
	 * @method IPlugin#afterUpdate
	 * @desc Called after `chart` has been updated and before rendering. Note that this
	 * hook will not be called if the chart update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsUpdate
 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
	 * the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} false to cancel the datasets update.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#afterDatasetsUpdate
	 * @desc Called after the `chart` datasets have been updated. Note that this hook
	 * will not be called if the datasets update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#beforeDatasetUpdate
 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
	 * returns `false`, the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetUpdate
 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
	 * that this hook will not be called if the datasets update has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeLayout
	 * @desc Called before laying out `chart`. If any plugin returns `false`,
	 * the layout update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart layout.
	 */
	/**
	 * @method IPlugin#afterLayout
	 * @desc Called after the `chart` has been layed out. Note that this hook will not
	 * be called if the layout update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeRender
	 * @desc Called before rendering `chart`. If any plugin returns `false`,
	 * the rendering is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart rendering.
	 */
	/**
	 * @method IPlugin#afterRender
	 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
	 * that this hook will not be called if the rendering has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDraw
	 * @desc Called before drawing `chart` at every animation frame specified by the given
	 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
	 * another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart drawing.
	 */
	/**
	 * @method IPlugin#afterDraw
	 * @desc Called after the `chart` has been drawn for the specific easing value. Note
	 * that this hook will not be called if the drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsDraw
 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
	 * the datasets drawing is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetsDraw
	 * @desc Called after the `chart` datasets have been drawn. Note that this hook
	 * will not be called if the datasets drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetDraw
 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
	 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
	 * is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetDraw
 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
	 * (datasets are drawn in the reverse order). Note that this hook will not be called
	 * if the datasets drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
  	 * @method IPlugin#beforeTooltipDraw
	 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
	 * the tooltip drawing is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
  	 */
	/**
 	 * @method IPlugin#afterTooltipDraw
  	 * @desc Called after drawing the `tooltip`. Note that this hook will not
 	 * be called if the tooltip drawing has been previously cancelled.
 	 * @param {Chart} chart - The chart instance.
 	 * @param {Object} args - The call arguments.
 	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 	 * @param {Object} options - The plugin options.
 	 */
	/**
	 * @method IPlugin#beforeEvent
 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
	 * the event will be discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterEvent
	 * @desc Called after the `event` has been consumed. Note that this hook
	 * will not be called if the `event` has been previously discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#resize
	 * @desc Called after the chart as been resized.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#destroy
	 * @desc Called after the chart as been destroyed.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Element.extend({});
};

},{"25":25,"26":26,"45":45}],32:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);
var Ticks = require(34);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var xTickStart = options.position === 'right' ? me.left : me.right - tl;
			var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
			var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						for (var i = 0, y = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += (tickFont.size * 1.5);
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right;
				var y1 = me.top;
				var y2 = me.bottom;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};

},{"25":25,"26":26,"34":34,"45":45}],33:[function(require,module,exports){
'use strict';

var defaults = require(25);
var helpers = require(45);

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				Chart.layoutService.addBox(chart, scale);
			});
		}
	};
};

},{"25":25,"45":45}],34:[function(require,module,exports){
'use strict';

var helpers = require(45);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold generators for different types of ticks
	 * @namespace Chart.Ticks.generators
	 */
	generators: {
		/**
		 * Interface for the options provided to the numeric tick generator
		 * @interface INumericTickGenerationOptions
		 */
		/**
		 * The maximum number of ticks to display
		 * @name INumericTickGenerationOptions#maxTicks
		 * @type Number
		 */
		/**
		 * The distance between each tick.
		 * @name INumericTickGenerationOptions#stepSize
		 * @type Number
		 * @optional
		 */
		/**
		 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
		 * @name INumericTickGenerationOptions#min
		 * @type Number
		 * @optional
		 */
		/**
		 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
		 * @name INumericTickGenerationOptions#max
		 * @type Number
		 * @optional
		 */

		/**
		 * Generate a set of linear ticks
		 * @method Chart.Ticks.generators.linear
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		linear: function(generationOptions, dataRange) {
			var ticks = [];
			// To get a "nice" value for the tick spacing, we will use the appropriately named
			// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
			// for details.

			var spacing;
			if (generationOptions.stepSize && generationOptions.stepSize > 0) {
				spacing = generationOptions.stepSize;
			} else {
				var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
				spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
			}
			var niceMin = Math.floor(dataRange.min / spacing) * spacing;
			var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

			// If min, max and stepSize is set and they make an evenly spaced scale use it.
			if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
				// If very close to our whole number, use it.
				if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
					niceMin = generationOptions.min;
					niceMax = generationOptions.max;
				}
			}

			var numSpaces = (niceMax - niceMin) / spacing;
			// If very close to our rounded value, use it.
			if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
				numSpaces = Math.round(numSpaces);
			} else {
				numSpaces = Math.ceil(numSpaces);
			}

			// Put the values into the ticks array
			ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
			for (var j = 1; j < numSpaces; ++j) {
				ticks.push(niceMin + (j * spacing));
			}
			ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

			return ticks;
		},

		/**
		 * Generate a set of logarithmic ticks
		 * @method Chart.Ticks.generators.logarithmic
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		logarithmic: function(generationOptions, dataRange) {
			var ticks = [];
			var valueOrDefault = helpers.valueOrDefault;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph
			var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

			var endExp = Math.floor(helpers.log10(dataRange.max));
			var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
			var exp, significand;

			if (tickVal === 0) {
				exp = Math.floor(helpers.log10(dataRange.minNotZero));
				significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

				ticks.push(tickVal);
				tickVal = significand * Math.pow(10, exp);
			} else {
				exp = Math.floor(helpers.log10(tickVal));
				significand = Math.floor(tickVal / Math.pow(10, exp));
			}

			do {
				ticks.push(tickVal);

				++significand;
				if (significand === 10) {
					significand = 1;
					++exp;
				}

				tickVal = significand * Math.pow(10, exp);
			} while (exp < endExp || (exp === endExp && significand < endSignificand));

			var lastTick = valueOrDefault(generationOptions.max, tickVal);
			ticks.push(lastTick);

			return ticks;
		}
	},

	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

},{"45":45}],35:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width > chart.width;
		};
		orf = function(x) {
			return x - size.width < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = ptX + (width / 2);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// If tooltip didn't change, do not handle the target event
			if (!changed) {
				return false;
			}

			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				var model = me._model;
				me.update(true);
				me.pivot();

				// See if our tooltip position changed
				changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};

},{"25":25,"26":26,"45":45}],36:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});

},{"25":25,"26":26,"45":45}],37:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});

},{"25":25,"26":26,"45":45}],38:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});

},{"25":25,"26":26,"45":45}],39:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

},{"25":25,"26":26}],40:[function(require,module,exports){
'use strict';

module.exports = {};
module.exports.Arc = require(36);
module.exports.Line = require(37);
module.exports.Point = require(38);
module.exports.Rectangle = require(39);

},{"36":36,"37":37,"38":38,"39":39}],41:[function(require,module,exports){
'use strict';

var helpers = require(42);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};

},{"42":42}],42:[function(require,module,exports){
'use strict';

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

},{}],43:[function(require,module,exports){
'use strict';

var helpers = require(42);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;

},{"42":42}],44:[function(require,module,exports){
'use strict';

var helpers = require(42);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};

},{"42":42}],45:[function(require,module,exports){
'use strict';

module.exports = require(42);
module.exports.easing = require(43);
module.exports.canvas = require(41);
module.exports.options = require(44);

},{"41":41,"42":42,"43":43,"44":44}],46:[function(require,module,exports){
/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

},{}],47:[function(require,module,exports){
/**
 * Chart.Platform implementation for targeting a web browser
 */

'use strict';

var helpers = require(45);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;

},{"45":45}],48:[function(require,module,exports){
'use strict';

var helpers = require(45);
var basic = require(46);
var dom = require(47);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */

},{"45":45,"46":46,"47":47}],49:[function(require,module,exports){
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */

'use strict';

var defaults = require(25);
var elements = require(40);
var helpers = require(45);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

module.exports = function() {

	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;

			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	return {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers.canvas.unclipArea(ctx);
			}
		}
	};
};

},{"25":25,"40":40,"45":45}],50:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}

	Chart.Legend = Element.extend({

		initialize: function(config) {
			helpers.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var globalDefault = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = defaults.global;
			var lineDefault = globalDefault.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var cursor;

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;

				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;

						// Draw pointStyle as legend symbol
						helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;

					ctx.fillText(legendItem.text, xLeft, yMiddle);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;

					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;

			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			var x = e.x;
			var y = e.y;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}

			return changed;
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Chart.Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		layout.configure(chart, legend, legendOpts);
		layout.addBox(chart, legend);
		chart.legend = legend;
	}

	return {
		id: 'legend',

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers.mergeIf(legendOpts, defaults.global.legend);

				if (legend) {
					layout.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layout.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
};

},{"25":25,"26":26,"45":45}],51:[function(require,module,exports){
'use strict';

var defaults = require(25);
var Element = require(26);
var helpers = require(45);

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	Chart.Title = Element.extend({
		initialize: function(config) {
			var me = this;
			helpers.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: noop,
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var display = opts.display;
			var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
			var minSize = me.minSize;
			var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var globalDefaults = defaults.global;

			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
				var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
				var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
				var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;

				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';

				var text = opts.text;
				if (helpers.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}

				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Chart.Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		layout.configure(chart, title, titleOpts);
		layout.addBox(chart, title);
		chart.titleBlock = title;
	}

	return {
		id: 'title',

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers.mergeIf(titleOpts, defaults.global.title);

				if (titleBlock) {
					layout.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				Chart.layoutService.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
};

},{"25":25,"26":26,"45":45}],52:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};

},{}],53:[function(require,module,exports){
'use strict';

var defaults = require(25);
var helpers = require(45);
var Ticks = require(34);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
				return Math.round(pixel);
			}

			pixel = me.bottom - (me.height / range * (rightValue - start));
			return Math.round(pixel);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};

},{"25":25,"34":34,"45":45}],54:[function(require,module,exports){
'use strict';

var helpers = require(45);
var Ticks = require(34);

module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};

},{"34":34,"45":45}],55:[function(require,module,exports){
'use strict';

var helpers = require(45);
var Ticks = require(34);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var valueOrDefault = helpers.valueOrDefault;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							values[index] = values[index] || 0;

							if (opts.relativePoints) {
								values[index] = 100;
							} else {
								// Don't need to split positive and negative since the log scale can't handle a 0 crossing
								values[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var minVal = helpers.min(valuesForType);
					var maxVal = helpers.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = 1;
					me.max = 10;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);

			if (!me.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				ticks.reverse();
			}

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		getPixelForValue: function(value) {
			var me = this;
			var start = me.start;
			var newVal = +me.getRightValue(value);
			var opts = me.options;
			var tickOpts = opts.ticks;
			var innerDimension, pixel, range;

			if (me.isHorizontal()) {
				range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
				if (newVal === 0) {
					pixel = me.left;
				} else {
					innerDimension = me.width;
					pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			} else {
				// Bottom - top since pixels increase downward on a screen
				innerDimension = me.height;
				if (start === 0 && !tickOpts.reverse) {
					range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
					if (newVal === start) {
						pixel = me.bottom;
					} else if (newVal === me.minNotZero) {
						pixel = me.bottom - innerDimension * 0.02;
					} else {
						pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (me.end === 0 && tickOpts.reverse) {
					range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
					if (newVal === me.end) {
						pixel = me.top;
					} else if (newVal === me.minNotZero) {
						pixel = me.top + innerDimension * 0.02;
					} else {
						pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (newVal === 0) {
					pixel = tickOpts.reverse ? me.top : me.bottom;
				} else {
					range = helpers.log10(me.end) - helpers.log10(start);
					innerDimension = me.height;
					pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var range = helpers.log10(me.end) - helpers.log10(me.start);
			var value, innerDimension;

			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
			} else { // todo: if start === 0
				innerDimension = me.height;
				value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};

},{"34":34,"45":45}],56:[function(require,module,exports){
'use strict';

var defaults = require(25);
var helpers = require(45);
var Ticks = require(34);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};

},{"25":25,"34":34,"45":45}],57:[function(require,module,exports){
/* global window: false */
'use strict';

var moment = require(1);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = require(25);
var helpers = require(45);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / ((capacity || 1) * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, let's use today limits
			min = min === MAX_INTEGER ? +moment().startOf('day') : min;
			max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}

			return label;
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			return Math.floor(innerWidth / tickLabelWidth);
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};

},{"1":1,"25":25,"45":45}]},{},[7])(7)
});

(function (factory) {
  'use strict';
  if (typeof exports === 'object') {
    // Node/CommonJS
    module.exports = factory(
      typeof angular !== 'undefined' ? angular : require('angular'),
      typeof Chart !== 'undefined' ? Chart : require('chart.js'));
  }  else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['angular', 'chart'], factory);
  } else {
    // Browser globals
    if (typeof angular === 'undefined') {
        throw new Error('AngularJS framework needs to be included, see https://angularjs.org/');
    } else if (typeof Chart === 'undefined') {
      throw new Error('Chart.js library needs to be included, see http://jtblin.github.io/angular-chart.js/');
    }
    factory(angular, Chart);
  }
}(function (angular, Chart) {
  'use strict';

  Chart.defaults.global.multiTooltipTemplate = '<%if (datasetLabel){%><%=datasetLabel%>: <%}%><%= value %>';
  Chart.defaults.global.tooltips.mode = 'label';
  Chart.defaults.global.elements.line.borderWidth = 2;
  Chart.defaults.global.elements.rectangle.borderWidth = 2;
  Chart.defaults.global.legend.display = false;
  Chart.defaults.global.colors = [
    '#97BBCD', // blue
    '#DCDCDC', // light grey
    '#F7464A', // red
    '#46BFBD', // green
    '#FDB45C', // yellow
    '#949FB1', // grey
    '#4D5360'  // dark grey
  ];

  var useExcanvas = typeof window.G_vmlCanvasManager === 'object' &&
    window.G_vmlCanvasManager !== null &&
    typeof window.G_vmlCanvasManager.initElement === 'function';

  if (useExcanvas) Chart.defaults.global.animation = false;

  return angular.module('chart.js', [])
    .provider('ChartJs', ChartJsProvider)
    .factory('ChartJsFactory', ['ChartJs', '$timeout', ChartJsFactory])
    .directive('chartBase', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory(); }])
    .directive('chartLine', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('line'); }])
    .directive('chartBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bar'); }])
    .directive('chartHorizontalBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('horizontalBar'); }])
    .directive('chartRadar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('radar'); }])
    .directive('chartDoughnut', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('doughnut'); }])
    .directive('chartPie', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('pie'); }])
    .directive('chartPolarArea', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('polarArea'); }])
    .directive('chartBubble', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bubble'); }])
    .name;

  /**
   * Wrapper for chart.js
   * Allows configuring chart js using the provider
   *
   * angular.module('myModule', ['chart.js']).config(function(ChartJsProvider) {
   *   ChartJsProvider.setOptions({ responsive: false });
   *   ChartJsProvider.setOptions('Line', { responsive: true });
   * })))
   */
  function ChartJsProvider () {
    var options = { responsive: true };
    var ChartJs = {
      Chart: Chart,
      getOptions: function (type) {
        var typeOptions = type && options[type] || {};
        return angular.extend({}, options, typeOptions);
      }
    };

    /**
     * Allow to set global options during configuration
     */
    this.setOptions = function (type, customOptions) {
      // If no type was specified set option for the global object
      if (! customOptions) {
        customOptions = type;
        options = angular.merge(options, customOptions);
      } else {
        // Set options for the specific chart
        options[type] = angular.merge(options[type] || {}, customOptions);
      }

      angular.merge(ChartJs.Chart.defaults, options);
    };

    this.$get = function () {
      return ChartJs;
    };
  }

  function ChartJsFactory (ChartJs, $timeout) {
    return function chart (type) {
      return {
        restrict: 'CA',
        scope: {
          chartGetColor: '=?',
          chartType: '=',
          chartData: '=?',
          chartLabels: '=?',
          chartOptions: '=?',
          chartSeries: '=?',
          chartColors: '=?',
          chartClick: '=?',
          chartHover: '=?',
          chartDatasetOverride: '=?'
        },
        link: function (scope, elem/*, attrs */) {
          if (useExcanvas) window.G_vmlCanvasManager.initElement(elem[0]);

          // Order of setting "watch" matter
          scope.$watch('chartData', watchData, true);
          scope.$watch('chartSeries', watchOther, true);
          scope.$watch('chartLabels', watchOther, true);
          scope.$watch('chartOptions', watchOther, true);
          scope.$watch('chartColors', watchOther, true);
          scope.$watch('chartDatasetOverride', watchOther, true);
          scope.$watch('chartType', watchType, false);

          scope.$on('$destroy', function () {
            destroyChart(scope);
          });

          scope.$on('$resize', function () {
            if (scope.chart) scope.chart.resize();
          });

          function watchData (newVal, oldVal) {
            if (! newVal || ! newVal.length || (Array.isArray(newVal[0]) && ! newVal[0].length)) {
              destroyChart(scope);
              return;
            }
            var chartType = type || scope.chartType;
            if (! chartType) return;

            if (scope.chart && canUpdateChart(newVal, oldVal))
              return updateChart(newVal, scope);

            createChart(chartType, scope, elem);
          }

          function watchOther (newVal, oldVal) {
            if (isEmpty(newVal)) return;
            if (angular.equals(newVal, oldVal)) return;
            var chartType = type || scope.chartType;
            if (! chartType) return;

            // chart.update() doesn't work for series and labels
            // so we have to re-create the chart entirely
            createChart(chartType, scope, elem);
          }

          function watchType (newVal, oldVal) {
            if (isEmpty(newVal)) return;
            if (angular.equals(newVal, oldVal)) return;
            createChart(newVal, scope, elem);
          }
        }
      };
    };

    function createChart (type, scope, elem) {
      var options = getChartOptions(type, scope);
      if (! hasData(scope) || ! canDisplay(type, scope, elem, options)) return;

      var cvs = elem[0];
      var ctx = cvs.getContext('2d');

      scope.chartGetColor = getChartColorFn(scope);
      var data = getChartData(type, scope);
      // Destroy old chart if it exists to avoid ghost charts issue
      // https://github.com/jtblin/angular-chart.js/issues/187
      destroyChart(scope);

      scope.chart = new ChartJs.Chart(ctx, {
        type: type,
        data: data,
        options: options
      });
      scope.$emit('chart-create', scope.chart);
      bindEvents(cvs, scope);
    }

    function canUpdateChart (newVal, oldVal) {
      if (newVal && oldVal && newVal.length && oldVal.length) {
        return Array.isArray(newVal[0]) ?
        newVal.length === oldVal.length && newVal.every(function (element, index) {
          return element.length === oldVal[index].length; }) :
          oldVal.reduce(sum, 0) > 0 ? newVal.length === oldVal.length : false;
      }
      return false;
    }

    function sum (carry, val) {
      return carry + val;
    }

    function getEventHandler (scope, action, triggerOnlyOnChange) {
      var lastState = {
        point: void 0,
        points: void 0
      };
      return function (evt) {
        var atEvent = scope.chart.getElementAtEvent || scope.chart.getPointAtEvent;
        var atEvents = scope.chart.getElementsAtEvent || scope.chart.getPointsAtEvent;
        if (atEvents) {
          var points = atEvents.call(scope.chart, evt);
          var point = atEvent ? atEvent.call(scope.chart, evt)[0] : void 0;

          if (triggerOnlyOnChange === false ||
            (! angular.equals(lastState.points, points) && ! angular.equals(lastState.point, point))
          ) {
            lastState.point = point;
            lastState.points = points;
            scope[action](points, evt, point);
          }
        }
      };
    }

    function getColors (type, scope) {
      var colors = angular.copy(scope.chartColors ||
        ChartJs.getOptions(type).chartColors ||
        Chart.defaults.global.colors
      );
      var notEnoughColors = colors.length < scope.chartData.length;
      while (colors.length < scope.chartData.length) {
        colors.push(scope.chartGetColor());
      }
      // mutate colors in this case as we don't want
      // the colors to change on each refresh
      if (notEnoughColors) scope.chartColors = colors;
      return colors.map(convertColor);
    }

    function convertColor (color) {
      // Allows RGB and RGBA colors to be input as a string: e.g.: "rgb(159,204,0)", "rgba(159,204,0, 0.5)"
      if (typeof color === 'string' && color[0] === 'r') return getColor(rgbStringToRgb(color));
      // Allows hex colors to be input as a string.
      if (typeof color === 'string' && color[0] === '#') return getColor(hexToRgb(color.substr(1)));
      // Allows colors to be input as an object, bypassing getColor() entirely
      if (typeof color === 'object' && color !== null) return color;
      return getRandomColor();
    }

    function getRandomColor () {
      var color = [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
      return getColor(color);
    }

    function getColor (color) {
      var alpha = color[3] || 1;
      color = color.slice(0, 3);
      return {
        backgroundColor: rgba(color, 0.2),
        pointBackgroundColor: rgba(color, alpha),
        pointHoverBackgroundColor: rgba(color, 0.8),
        borderColor: rgba(color, alpha),
        pointBorderColor: '#fff',
        pointHoverBorderColor: rgba(color, alpha)
      };
    }

    function getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function rgba (color, alpha) {
      // rgba not supported by IE8
      return useExcanvas ? 'rgb(' + color.join(',') + ')' : 'rgba(' + color.concat(alpha).join(',') + ')';
    }

    // Credit: http://stackoverflow.com/a/11508164/1190235
    function hexToRgb (hex) {
      var bigint = parseInt(hex, 16),
        r = (bigint >> 16) & 255,
        g = (bigint >> 8) & 255,
        b = bigint & 255;

      return [r, g, b];
    }

    function rgbStringToRgb (color) {
      var match = color.match(/^rgba?\(([\d,.]+)\)$/);
      if (! match) throw new Error('Cannot parse rgb value');
      color = match[1].split(',');
      return color.map(Number);
    }

    function hasData (scope) {
      return scope.chartData && scope.chartData.length;
    }

    function getChartColorFn (scope) {
      return typeof scope.chartGetColor === 'function' ? scope.chartGetColor : getRandomColor;
    }

    function getChartData (type, scope) {
      var colors = getColors(type, scope);
      return Array.isArray(scope.chartData[0]) ?
        getDataSets(scope.chartLabels, scope.chartData, scope.chartSeries || [], colors, scope.chartDatasetOverride) :
        getData(scope.chartLabels, scope.chartData, colors, scope.chartDatasetOverride);
    }

    function getDataSets (labels, data, series, colors, datasetOverride) {
      return {
        labels: labels,
        datasets: data.map(function (item, i) {
          var dataset = angular.extend({}, colors[i], {
            label: series[i],
            data: item
          });
          if (datasetOverride && datasetOverride.length >= i) {
            angular.merge(dataset, datasetOverride[i]);
          }
          return dataset;
        })
      };
    }

    function getData (labels, data, colors, datasetOverride) {
      var dataset = {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors.map(function (color) {
            return color.pointBackgroundColor;
          }),
          hoverBackgroundColor: colors.map(function (color) {
            return color.backgroundColor;
          })
        }]
      };
      if (datasetOverride) {
        angular.merge(dataset.datasets[0], datasetOverride);
      }
      return dataset;
    }

    function getChartOptions (type, scope) {
      return angular.extend({}, ChartJs.getOptions(type), scope.chartOptions);
    }

    function bindEvents (cvs, scope) {
      cvs.onclick = scope.chartClick ? getEventHandler(scope, 'chartClick', false) : angular.noop;
      cvs.onmousemove = scope.chartHover ? getEventHandler(scope, 'chartHover', true) : angular.noop;
    }

    function updateChart (values, scope) {
      if (Array.isArray(scope.chartData[0])) {
        scope.chart.data.datasets.forEach(function (dataset, i) {
          dataset.data = values[i];
        });
      } else {
        scope.chart.data.datasets[0].data = values;
      }

      scope.chart.update();
      scope.$emit('chart-update', scope.chart);
    }

    function isEmpty (value) {
      return ! value ||
        (Array.isArray(value) && ! value.length) ||
        (typeof value === 'object' && ! Object.keys(value).length);
    }

    function canDisplay (type, scope, elem, options) {
      // TODO: check parent?
      if (options.responsive && elem[0].clientHeight === 0) {
        $timeout(function () {
          createChart(type, scope, elem);
        }, 50, false);
        return false;
      }
      return true;
    }

    function destroyChart(scope) {
      if(! scope.chart) return;
      scope.chart.destroy();
      scope.$emit('chart-destroy', scope.chart);
    }
  }
}));

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
	'use strict';

	angular
		.module('app.toolbar')
		.controller('ToolbarController', ToolbarController);

	/** @ngInject */
	function ToolbarController($rootScope, $scope, $state, $window, $mdSidenav, msNavigationService, UserService, NotificationService, $timeout, msUtils) {
		var vm = this;

		if (msUtils.isMobile()) {
			$scope.isMobile = true
		}

		// Data
		$rootScope.global = {
			search: ''
		};

		$scope.notifs = {
			malfunctions: 0,
			documents: 0,
			tasks: 0,
			lateTasks: 0,
			reunions: 0,
			indicateurs: 0
		}

		$scope.nbNotifs = 0;

		/**
		 * BASCULE DE VUE — même menu que la déconnexion, une entrée par casquette que le compte
		 * porte sans l'afficher : administration, groupement, pharmacie. Chaque vue s'ouvre sur
		 * sa page d'arrivée, et c'est l'état atteint qui fait basculer le menu de gauche.
		 */
		$scope.getActiveView = function () {
			if ($rootScope.activeView) {
				return $rootScope.activeView;
			}
			return UserService.resolveActiveView($rootScope.user, $state.current && $state.current.name);
		}

		/**
		 * OCTOBRE ROSE — sensibilisation au cancer du sein, sous le nom du logiciel, pendant tout le
		 * mois d'octobre et rien d'autre : il disparaît seul le 1er novembre et revient l'an prochain
		 * avec la bonne année. Vues pharmacie et groupement seulement, pas en administration.
		 */
		$scope.afficherOctobreRose = function () {
			return !!$rootScope.user && new Date().getMonth() === 9
				&& $scope.getActiveView() !== UserService.VUE_ADMINISTRATION;
		}

		$scope.anneeOctobreRose = function () {
			return new Date().getFullYear();
		}

		$scope.getSwitchableViews = function () {
			var vueActive = $scope.getActiveView();
			return UserService.getAvailableViews($rootScope.user).filter(function (vue) {
				return vue !== vueActive;
			});
		}

		$scope.canSwitchToView = function (vue) {
			return $scope.getSwitchableViews().indexOf(vue) !== -1;
		}

		$scope.getViewLandingState = function (vue) {
			if (vue === UserService.VUE_ADMINISTRATION) {
				return 'admin.home';
			}
			if (vue === UserService.VUE_GROUPEMENT) {
				// « Mes pharmacies » est la page d'arrivée de l'espace groupement.
				return 'app.groupement.pharmacies';
			}
			if ($scope.isNonLqoUser()) {
				return 'app.performances.mes-evaluations';
			}
			// PHSQ-240 : un compte au contrat OSYS n'a que le module.
			if ($scope.isContratOsys()) {
				return 'app.osys.mesTriages';
			}
			return 'app.home';
		}

		$scope.isContratOsys = function () {
			var user = $rootScope.user;
			return !!(user && user.contratOsys && user.hasPharmacy && !user.isAdmin);
		}

		function estEtatAdministration(stateName) {
			return (stateName || '').indexOf('admin.') === 0;
		}

		/**
		 * `app` et `admin` sont deux arborescences d'états distinctes (barre du haut, menu et vues
		 * racines comprises) : on les traverse par un chargement complet de page, comme le fait
		 * déjà la redirection d'après connexion, et non par une transition interne.
		 */
		$scope.navigateTo = function (etat, params) {
			var cible = params || {};
			if (estEtatAdministration(etat) !== estEtatAdministration($state.current && $state.current.name)) {
				$window.location.href = $state.href(etat, cible);
				return null;
			}
			return $state.go(etat, cible);
		}

		$scope.goToView = function (vue) {
			var params = vue === UserService.VUE_PHARMACIE && $scope.isNonLqoUser()
				? { tab: 'mon-enquete' }
				: {};
			var transition = $scope.navigateTo($scope.getViewLandingState(vue), params);
			if (transition) {
				transition.then(function () {
					$scope.refreshNotifs();
				});
			}
		}

		$scope.getAccountMenuLabel = function () {
			var user = $rootScope.user;
			if (!user) {
				return 'Mon compte';
			}
			var vue = $scope.getActiveView();
			if (vue === UserService.VUE_ADMINISTRATION) {
				// PHSQ-240 : comptes administrateurs nominatifs, la barre du haut nomme la personne.
				var nom = ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
				return nom || 'Compte administrateur';
			}
			if (vue === UserService.VUE_GROUPEMENT) {
				return user.groupementName ? 'Groupement ' + user.groupementName : 'Compte groupement';
			}
			if (user.isTitulaire) {
				return 'Compte Titulaire';
			}
			if (user.isTeam) {
				return 'Compte équipe';
			}
			if (user.isPraq) {
				return 'Compte Responsable Qualité';
			}
			return 'Mon compte';
		}

		// PHSQ-240 (M43) : pas de cloche « Notifications qualité » pour un contrat OSYS.
		function shouldLoadNotifs() {
			return !!($rootScope.user && !$rootScope.user.isNonLqo && $rootScope.user.hasPharmacy
				&& !$scope.isContratOsys()
				&& $scope.getActiveView() === UserService.VUE_PHARMACIE);
		}

		$scope.shouldShowQualityNotifs = function () {
			return shouldLoadNotifs() && !$rootScope.user.isMini;
		}

		$scope.refreshNotifs = function () {
			if (!shouldLoadNotifs()) {
				$scope.notifs = {
					malfunctions: 0,
					documents: 0,
					tasks: 0,
					lateTasks: 0,
					reunions: 0,
					indicateurs: 0
				};
				return;
			}
			UserService.getNotifs().then(function (res) {
				$scope.notifs = res.data
			}).catch(function () {

			})
		}

		$scope.refreshNotifs()

		// $scope.refreshCount = function () {
		// 	NotificationService.notViewed().then(function (res) {
		// 		$scope.nbNotifs = res.data;
		// 	}).catch(function () {

		// 	});
		// };

		// $scope.loadNotifs = function () {
		// 	if ($rootScope.user && $rootScope.user.isConnected) {
		// 		var http = $window.location.protocol;
		// 		var protocol = 'ws://';
		// 		if (http === 'https:') {
		// 			protocol = 'wss://';
		// 		}
		// 		var domain = $window.location.host;
		// 		var ws = new WebSocket(protocol + domain + '/socket/websocket/' + $rootScope.user.id);
		// 		ws.onopen = function (event) {
		// 		};

		// 		ws.onclose = function (event) {
		// 		};

		// 		ws.onerror = function (event) {
		// 		};

		// 		ws.onmessage = function (event) {
		// 			$scope.nbNotifs = parseInt(event.data);
		// 		}
		// 	}
		// };



		$scope.$on('refreshCountNotifs', function () {
			$scope.refreshNotifs();
		});

		$scope.$on('rooScopeUser:ready', function () {
			$scope.refreshNotifs();
			$scope.loadGroupementSelector();
		});

		$scope.$on('$stateChangeSuccess', function () {
			$scope.loadGroupementSelector();
		});

		//DECOMMENTER ICI POUR REACTIVER POLL
		// $timeout(function () {
		// 	$scope.refreshCount();
		// 	$scope.loadNotifs();
		// });

		$scope.$on('stopNotifs', function () {

		})

		$scope.$on('startNotifs', function () {
			//DECOMMENTER ICI POUR REACTIVER POLL
			// $scope.loadNotifs();
		})

		$scope.goToNotifs = function () {
			$state.go('app.notifications');
		};

		$scope.goToMalfunctions = function () {
			$state.go('app.malfunctions', { status: 'NOT_OPEN' })
		}

		$scope.goToDocuments = function () {
			$state.go('app.folders', { waiting: true })
		}

		$scope.goToTasks = function () {
			if ($state.current && $state.current.name === 'app.equipe.planning-general') {
				$rootScope.$broadcast('changePlanningFilter', { filter: 'late' })
			} else {
				$state.go('app.equipe.planning-general', { filter: 'late' });
			}
		}

		$scope.goToDemarche = function () {
			if ($state.current && $state.current.name === 'app.equipe.planning-general') {
				$rootScope.$broadcast('changePlanningTab', { tab: 'qualite' })
			} else {
				$state.go('app.equipe.planning-general', { tab: 'qualite' });
			}
		}

		$scope.goToReunions = function () {
			$state.go('app.equipe.reunions')
		}

		$scope.goToTdb = function () {
			$state.go('app.performances.tableau-de-bord')
		}

		$scope.isGroupementRoute = function () {
			return $state.current && $state.current.name && $state.current.name.indexOf('app.groupement.') === 0;
		}

		$scope.groupementSelector = {
			groupements: [],
			search: '',
			selectedGroupementId: UserService.getSelectedGroupementId()
		};

		function normalizeGroupementId(groupementId) {
			var numericId = Number(groupementId);
			return isFinite(numericId) && numericId > 0 ? numericId : null;
		}

		function findGroupementById(groupementId) {
			var selectedId = normalizeGroupementId(groupementId);
			var found = null;
			angular.forEach($scope.groupementSelector.groupements || [], function (groupement) {
				if (selectedId !== null && Number(groupement.id) === selectedId) {
					found = groupement;
				}
			});
			return found;
		}

		function syncValidSelectedGroupement() {
			var groupements = $scope.groupementSelector.groupements || [];
			var selectedId = UserService.getSelectedGroupementId();
			if (!selectedId || findGroupementById(selectedId)) {
				$scope.groupementSelector.selectedGroupementId = selectedId;
				return;
			}
			$scope.groupementSelector.selectedGroupementId = UserService.setSelectedGroupementId(null);
		}

		$scope.loadGroupementSelector = function () {
			if (!$rootScope.user || !$rootScope.user.isGroupement) {
				$scope.groupementSelector.groupements = [];
				$scope.groupementSelector.selectedGroupementId = null;
				return;
			}
			UserService.getMyGroupements(true).then(function (groupements) {
				$scope.groupementSelector.groupements = groupements || [];
				if ($rootScope.user) {
					$rootScope.user.groupements = $scope.groupementSelector.groupements;
					if ($scope.groupementSelector.groupements.length === 1) {
						$rootScope.user.groupementName = $scope.groupementSelector.groupements[0].name;
					}
				}
				// Compte mono-groupement : le sélecteur n'est qu'un libellé statique (rien à
				// choisir), donc on sélectionne automatiquement l'unique groupement pour sortir
				// de la vue consolidée et rendre disponible le rapport / ZIP du groupement.
				if ($scope.groupementSelector.groupements.length === 1 && !UserService.getSelectedGroupementId()) {
					$scope.selectGroupementContext($scope.groupementSelector.groupements[0].id);
				}
				syncValidSelectedGroupement();
			}).catch(function () {
				$scope.groupementSelector.groupements = [];
			});
		}

		$scope.shouldShowGroupementContext = function () {
			return $rootScope.user && $rootScope.user.isGroupement && $scope.isGroupementRoute();
		}

		$scope.hasMultipleGroupements = function () {
			return ($scope.groupementSelector.groupements || []).length > 1;
		}

		$scope.needsGroupementSearch = function () {
			return ($scope.groupementSelector.groupements || []).length >= 6;
		}

		$scope.getSelectedGroupementLabel = function () {
			var selected = findGroupementById($scope.groupementSelector.selectedGroupementId);
			return selected ? selected.name : 'Vue consolidée';
		}

		$scope.getSingleGroupementLabel = function () {
			var groupements = $scope.groupementSelector.groupements || [];
			return groupements.length ? groupements[0].name : ($rootScope.user && $rootScope.user.groupementName) || 'Groupement';
		}

		$scope.selectGroupementContext = function (groupementId) {
			$scope.groupementSelector.selectedGroupementId = UserService.setSelectedGroupementId(groupementId);
			$scope.groupementSelector.search = '';
		}

		$scope.getFilteredGroupementOptions = function () {
			var groupements = $scope.groupementSelector.groupements || [];
			var search = ($scope.groupementSelector.search || '').trim().toLowerCase();
			if (!search) {
				return groupements;
			}
			return groupements.filter(function (groupement) {
				return (groupement.name || '').toLowerCase().indexOf(search) !== -1;
			});
		}

		$scope.isNonLqoUser = function () {
			return !!($rootScope.user && !$rootScope.user.isAdmin && $rootScope.user.hasPharmacy && $rootScope.user.isNonLqo);
		}

		$scope.toggleNonLqoNavigation = function ($event) {
			if ($scope.isNonLqoUser()) {
				if (angular.isFunction($rootScope.openNonLqoMenuPopup)) {
					$rootScope.openNonLqoMenuPopup($event);
				}
				return;
			}
			vm.toggleMsNavigationNew();
		}

		$scope.goToHome = function () {
			$scope.goToView($scope.getActiveView());
		}

		vm.bodyEl = angular.element('body');
		vm.userStatusOptions = [{
			'title': 'Online',
			'icon': 'icon-checkbox-marked-circle',
			'color': '#4CAF50'
		},
		{
			'title': 'Away',
			'icon': 'icon-clock',
			'color': '#FFC107'
		},
		{
			'title': 'Do not Disturb',
			'icon': 'icon-minus-circle',
			'color': '#F44336'
		},
		{
			'title': 'Invisible',
			'icon': 'icon-checkbox-blank-circle-outline',
			'color': '#BDBDBD'
		},
		{
			'title': 'Offline',
			'icon': 'icon-checkbox-blank-circle-outline',
			'color': '#616161'
		}
		];
		vm.languages = {
			en: {
				'title': 'English',
				'translation': 'TOOLBAR.ENGLISH',
				'code': 'en',
				'flag': 'us'
			},
			es: {
				'title': 'Spanish',
				'translation': 'TOOLBAR.SPANISH',
				'code': 'es',
				'flag': 'es'
			},
			tr: {
				'title': 'Turkish',
				'translation': 'TOOLBAR.TURKISH',
				'code': 'tr',
				'flag': 'tr'
			}
		};

		// Methods
		vm.toggleSidenav = toggleSidenav;
		vm.logout = logout;
		vm.setUserStatus = setUserStatus;
		vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		vm.toggleMsNavigationNew = toggleMsNavigationNew;

		$scope.goToProfile = function () {
			$scope.navigateTo('app.profile');
		}

		// Chantier PHSQ-220 : l'espace officine, ouvert au titulaire depuis le menu du compte.
		$scope.goToMonOfficine = function () {
			$scope.navigateTo('app.officine');
		}

		//////////

		init();
		$scope.loadGroupementSelector();

		/**
		 * Initialize
		 */
		function init() {
			// Select the first status as a default
			vm.userStatus = vm.userStatusOptions[0];
		}


		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		/**
		 * Sets User Status
		 * @param status
		 */
		function setUserStatus(status) {
			vm.userStatus = status;
		}

		/**
		 * Logout Function
		 */
		function logout() {
			UserService.logout().then(function (response) {
				$rootScope.user.isConnected = false;
				$state.go('login');
				$scope.$emit("stopNotifs");
			}).catch(function () {

			});
		}

		/**
		 * Toggle horizontal mobile menu
		 */
		function toggleHorizontalMobileMenu() {
			vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
		}

		/**
		 * Toggle msNavigation folded
		 */
		function toggleMsNavigationFolded() {
			msNavigationService.toggleFolded();
		}

		/**
			 * New Toggle msNavigation
			 */
		function toggleMsNavigationNew() {
			// fold / unfold
			if (window.innerWidth >= 1200) {
				console.log('desktop');
				msNavigationService.toggleFolded();
			} else {
				console.log('mobile');
				$mdSidenav('navigation').toggle();
			}
		}

	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,$state)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        $scope.goHelp = function() {
            $state.go('app.help');
        };

        $scope.goLegalMentions = function() {
            $state.go('legal_mentions');
        };

        $scope.goContact = function() {
            $state.go('app.contact');
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
/* globals define, angular, DOMPurify */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      define(['quill'], factory)
    } else if (typeof module !== 'undefined' && typeof exports === 'object') {
      module.exports = factory(require('quill'))
    } else {
      root.Requester = factory(root.Quill)
    }
  }(this, function (Quill) {
    'use strict'
  
    var atValues = [
      { id: 1, value: 'Fredrik Sundqvist' },
      { id: 2, value: 'Patrik Sjölin' }
    ];
    var hashValues = [
      { id: 3, value: 'Fredrik Sundqvist 2' },
      { id: 4, value: 'Patrik Sjölin 2' }
    ]

    // clipboard.convert() écrit le HTML par innerHTML dans un conteneur du DOM (CVE-2021-3163) :
    // un <img onerror> enregistré s'exécuterait à l'ouverture de l'éditeur. Les iframes des vidéos Quill restent permises.
    function sanitizeForEditor(html) {
      return DOMPurify.sanitize(html, { ADD_TAGS: ['iframe'], ADD_ATTR: ['allowfullscreen', 'frameborder'] })
    }

    var app;
    // declare ngQuill module
    app = angular.module('ngQuill', []);
  
    app.provider('ngQuillConfig', function () {
      var config = {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
  
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
  
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],
  
            ['clean'],                                         // remove formatting button
  
            ['link', 'image', 'video']                         // link and image, video
          ],
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@", "#"],
            source: function (searchTerm, renderList, mentionChar) {
              let values;

              if (mentionChar === "@") {
                values = atValues;
              } else {
                values = hashValues;
              }
              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            },
          },
        },
        theme: 'snow',
        placeholder: 'Insert text here ...',
        readOnly: false,
        scrollContainer: null,
        bounds: document.body
      }
  
      this.set = function (customConf) {
        customConf = customConf || {}
  
        if (customConf.modules) {
          config.modules = customConf.modules
        }
        if (customConf.theme) {
          config.theme = customConf.theme
        }
        if (customConf.placeholder !== null && customConf.placeholder !== undefined) {
          config.placeholder = customConf.placeholder.trim()
        }
        if (customConf.bounds) {
          config.bounds = customConf.bounds
        }
        if (customConf.scrollContainer) {
          config.scrollContainer = customConf.scrollContainer
        }
        if (customConf.readOnly) {
          config.readOnly = customConf.readOnly
        }
        if (customConf.formats) {
          config.formats = customConf.formats
        }
      }
  
      this.$get = function () {
        return config
      }
    })

    app.component('ngQuillEditor', {
      bindings: {
        'modules': '<modules',
        'theme': '@?',
        'readOnly': '<?',
        'formats': '<?',
        'placeholder': '@?',
        'bounds': '<?',
        'scrollContainer': '<?',
        'strict': '<?',
        'onEditorCreated': '&?',
        'onContentChanged': '&?',
        'onSelectionChanged': '&?',
        'onFocus': '&?',
        'ngModel': '<',
        'maxLength': '<',
        'minLength': '<',
        'customOptions': '<?'
      },
      require: {
        ngModelCtrl: 'ngModel'
      },
      transclude: {
        'toolbar': '?ngQuillToolbar'
      },
      template: '<div class="ng-hide" ng-show="$ctrl.ready"><ng-transclude ng-transclude-slot="toolbar"></ng-transclude></div>',
      controller: ['$scope', '$element', '$timeout', '$transclude', 'ngQuillConfig', function ($scope, $element, $timeout, $transclude, ngQuillConfig) {
        var config = {}
        var content
        var editorElem
        var modelChanged = false
        var editorChanged = false
        var editor
        var placeholder = ngQuillConfig.placeholder
  
        this.validate = function (text) {
          if (this.maxLength) {
            if (text.length > this.maxLength + 1) {
              this.ngModelCtrl.$setValidity('maxlength', false)
            } else {
              this.ngModelCtrl.$setValidity('maxlength', true)
            }
          }
  
          if (this.minLength > 1) {
            // validate only if text.length > 1
            if (text.length <= this.minLength && text.length > 1) {
              this.ngModelCtrl.$setValidity('minlength', false)
            } else {
              this.ngModelCtrl.$setValidity('minlength', true)
            }
          }
        }
  
        this.$onChanges = function (changes) {
          if (changes.ngModel && changes.ngModel.currentValue !== changes.ngModel.previousValue) {
            content = changes.ngModel.currentValue
  
            if (editor && !editorChanged) {
              modelChanged = true
              if (content) {
                editor.setContents(editor.clipboard.convert(sanitizeForEditor(content)))
              } else {
                editor.setText('')
              }
            }
            editorChanged = false
          }
  
          if (editor && changes.readOnly) {
            editor.enable(!changes.readOnly.currentValue)
          }
        }
  
        this.$onInit = function () {
          if (this.placeholder !== null && this.placeholder !== undefined) {
            placeholder = this.placeholder.trim()
          }
  
          config = {
            theme: this.theme || ngQuillConfig.theme,
            readOnly: this.readOnly || ngQuillConfig.readOnly,
            modules: this.modules || ngQuillConfig.modules,
            formats: this.formats || ngQuillConfig.formats,
            placeholder: placeholder,
            bounds: this.bounds || ngQuillConfig.bounds,
            strict: this.strict,
            scrollContainer: this.scrollContainer || ngQuillConfig.scrollContainer
          }
        }
  
        this.$postLink = function () {
          // create quill instance after dom is rendered
          $timeout(function () {
            this._initEditor(editorElem)
          }.bind(this), 0)
        }
  
        this._initEditor = function (editorElem) {
          var $editorElem = angular.element('<div></div>')
          var container = $element.children()
  
          editorElem = $editorElem[0]
  
          if (config.bounds === 'self') {
            config.bounds = editorElem
          }
  
          // set toolbar to custom one
          if ($transclude.isSlotFilled('toolbar')) {
            config.modules.toolbar = container.find('ng-quill-toolbar').children()[0]
          }
  
          container.append($editorElem);
  
          if (this.customOptions) {
            this.customOptions.forEach(function (customOption) {
              var newCustomOption = Quill.import(customOption.import);
              newCustomOption.whitelist = customOption.whitelist;
              if (customOption.toRegister) {
                newCustomOption[customOption.toRegister.key] = customOption.toRegister.value;
              }
              Quill.register(newCustomOption, true);
              // Quill.register('/node_modules/quill )
            })
          }
  
          editor = new Quill(editorElem, config)
  
          this.ready = true


          if(editor.root.parentNode && editor.root.parentNode.parentNode && editor.root.parentNode.parentNode.parentNode && editor.root.parentNode.parentNode.parentNode.classList.contains('nl_quill-line')){
              editor.root.style['overflow'] = 'hidden';
              editor.root.parentNode.style['height'] = '46px';
          }

          // mark model as touched if editor lost focus
          editor.on('selection-change', function (range, oldRange, source) {
            if (range === null && this.onBlur) {
              this.onBlur({
                editor: editor,
                source: source
              })
            } else if (oldRange === null && this.onFocus) {
              this.onFocus({
                editor: editor,
                source: source
              })
            }

            if (this.onSelectionChanged) {
              this.onSelectionChanged({
                editor: editor,
                oldRange: oldRange,
                range: range,
                source: source
              })
            }
  
            if (range) {
              return
            }
            $scope.$applyAsync(function () {
              this.ngModelCtrl.$setTouched()
            }.bind(this))
          }.bind(this))
  
          // update model if text changes
          editor.on('text-change', function (delta, oldDelta, source) {
            var html = editorElem.children[0].innerHTML
            var text = editor.getText()
            var emptyModelTag = ['<' + editor.root.firstChild.localName + '>', '</' + editor.root.firstChild.localName + '>']

            var offset = 0;

            // if(editor.childNodes.length > 4){
            //   offset = editor.childNodes.length * 13;
            // }
            // console.log(offset);
            var postHome = editor.root.parentNode.parentNode.parentNode;
            var scrollHeight = editor.root.scrollHeight;
            var basePx = 46;
            if(postHome.classList.contains('nl_quill-line') && scrollHeight > basePx){
              if(scrollHeight < parseInt(editorElem.style.height.split('px')[0])){
                var lines = editor.getLines(0, editor.getLength()).length;
                if( lines > 1){
                  editorElem.style.height = (basePx+(lines-1)*22) + 'px';
                } else {
                  editorElem.style.height = basePx+'px';
                }
              } else {
                editorElem.style.height = scrollHeight + 'px';
              }
            }
            
            if (html === emptyModelTag[0] + '<br>' + emptyModelTag[1]) {
                html = null
            }
            this.validate(text)

            if (!modelChanged) {

              $scope.$applyAsync(function () {
                editorChanged = true
  
                this.ngModelCtrl.$setViewValue(html)
                if (this.onContentChanged) {
                  this.onContentChanged({
                    editor: editor,
                    html: html,
                    text: text,
                    delta: delta,
                    oldDelta: oldDelta,
                    source: source
                  })
                }
              }.bind(this))
            }
            modelChanged = false
          }.bind(this))
  
          // set initial content
          if (content) {
            modelChanged = true
  
            var contents = editor.clipboard.convert(sanitizeForEditor(content))
            editor.setContents(contents)
            editor.history.clear()
          }
  
          // provide event to get informed when editor is created -> pass editor object.
          if (this.onEditorCreated) {
            this.onEditorCreated({editor: editor})
          }
        }
      }]
    })
  
    return app.name;
  }));

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $mdDialog, msUtils, UserService, AutoEvalService) {
        // Activate loading indicator
        // PHSQ-240 (A16) — retour dans le module après la connexion, pour le lien de l'e-mail du
        // matin. Seules les adresses du module sont gardées : pas de redirection ouverte.
        var RETOUR_OSYS = 'osys.retourApresConnexion';
        var RETOUR_OSYS_VALIDE = /^\/triage-osys\/((nouveau)|(triages\/\d+(\/fin)?))?$/;

        var returnLogin = function (event, toState, toParams) {
            event.preventDefault();
            if (toState && toState.name && toState.name.indexOf('app.osys.') === 0) {
                try {
                    var adresse = $state.href(toState.name, toParams);
                    if (adresse && RETOUR_OSYS_VALIDE.test(adresse)) {
                        $window.sessionStorage.setItem(RETOUR_OSYS, adresse);
                    }
                } catch (e) {
                    // stockage indisponible : on arrivera sur la page d'accueil habituelle
                }
            }
            $window.location.href = './login';
        };

        var NON_LQO_TAB = 'mon-enquete';

        var isNonLqoOnlyUser = function (response) {
            return !!(response && response.data
                && response.data.isConnected
                && !response.data.isAdmin
                && response.data.hasPharmacy
                && response.data.isNonLqo);
        };

        var isAllowedNonLqoState = function (toState, toParams) {
            return !!(toState
                && (
                    toState.name === 'app.decouvrirLqo'
                    || toState.name === 'app.contact'
                    // L'auto-évaluation PHSQ s'adresse aux officines ENGAGÉES dans la démarche,
                    // qu'elles soient clientes LQO ou non. Les rediriger vers « Mon enquête »
                    // les empêcherait de remplir un questionnaire auquel elles sont pourtant
                    // attendues ; celles qui ne sont pas dans la cible reçoivent de toute façon
                    // un « hors cible » du serveur.
                    || (toState.name && toState.name.indexOf('app.autoeval') === 0)
                    // PHSQ-240 : une officine NON_LQO peut avoir le module activé.
                    || (toState.name && toState.name.indexOf('app.osys.') === 0)
                    || (toState.name === 'app.performances.mes-evaluations'
                        && toParams
                        && (toParams.tab === NON_LQO_TAB || toParams.tab === 'auto'))
                ));
        };

        // L'accueil d'une officine non LQO : son auto-évaluation pendant la campagne, « Mon
        // enquête » sinon (AutoEvalService.ongletAccueilNonLqo).
        var redirectNonLqoToAccueil = function (event) {
            event.preventDefault();
            AutoEvalService.ongletAccueilNonLqo().then(function (onglet) {
                $state.go('app.performances.mes-evaluations', { tab: onglet });
            });
        };

        // PHSQ-240 — contrat OSYS : le module, les tutoriels, le contact et le profil, rien
        // d'autre ; toute autre adresse ramène à « Mes triages » (A4). « Découvrir LQO » est
        // exclu : cette page passe l'officine elle-même en LQO Premium (E26).
        var isOsysOnlyUser = function (response) {
            return !!(response && response.data
                && response.data.isConnected
                && !response.data.isAdmin
                && response.data.hasPharmacy
                && response.data.contratOsys);
        };

        var OSYS_ETATS_OUVERTS = ['app.help', 'app.contact', 'app.profile'];

        var isAllowedOsysState = function (toState) {
            return !!(toState && (toState.name.indexOf('app.osys.') === 0 || OSYS_ETATS_OUVERTS.indexOf(toState.name) !== -1));
        };

        var redirectOsysToMesTriages = function (event) {
            event.preventDefault();
            $state.go('app.osys.mesTriages');
        };

        var ORIENTATION_EXCLUDED_STATES = [
            'login',
            'app.error-404',
            'activateAccount',
            'forgotPassword',
            'updatePassword',
            'shareMalfunction',
            'legal_mentions',
            'questionnaire_satisfaction_2026',
            'questionnaire_satisfaction_2026_short',
            'questionnaire_satisfaction_2026_sms_short',
            'login2faActivation'
        ];

        var isOrientationEnabledForState = function (stateName) {
            return !!stateName && ORIENTATION_EXCLUDED_STATES.indexOf(stateName) === -1;
        };

        var currentStateName = $state.current && $state.current.name;
        var isPaused = false
        // Indique si la popup d'avertissement d'orientation (block-portrait) est affichée.
        // Permet de ne fermer QUE cette popup et pas une autre popup applicative ouverte.
        var portraitDialogVisible = false

        var showPortraitDialog = function () {
            if (portraitDialogVisible) {
                return
            }
            portraitDialogVisible = true
            $mdDialog.show({
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                templateUrl: 'app/main/block-portrait.html',
            }).then(function () {
                portraitDialogVisible = false
            }).catch(function () {
                portraitDialogVisible = false
            });
        }

        var hidePortraitDialog = function () {
            if (!portraitDialogVisible) {
                return
            }
            portraitDialogVisible = false
            $mdDialog.hide()
        }
        var matchMedia = window.matchMedia("(orientation: portrait)")
        var watcher = function (e) {
            if (isPaused) {
                return
            }
            if (!isOrientationEnabledForState(currentStateName)) {
                return
            }
            if (!e.matches) { // Si ce n'est plus portrait, donc c'est paysage
                hidePortraitDialog()
                // fais ici ton code pour gérer le paysage
            } else {
                showPortraitDialog()
            }
        }

        $rootScope.$on('filefocus', function () {
            isPaused = true
        })

        var checkOrientation = function (stateName) {
            currentStateName = stateName || currentStateName || ($state.current && $state.current.name)

            matchMedia.removeEventListener('change', watcher)
            if (!msUtils.isMobile() || !isOrientationEnabledForState(currentStateName)) {
                hidePortraitDialog()
                return
            }

            if (matchMedia.matches) {
                showPortraitDialog()
            }
            matchMedia.addEventListener("change", watcher);
        }

        var cancelCheck = function () {
            if (msUtils.isMobile()) {
                matchMedia.removeEventListener('change', watcher)
            }
            hidePortraitDialog()
        }

        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.loadingProgress = true;
            if (toState.name === 'login') {
                UserService.isConnected().then(function (response) {
                    console.log(response.data.isConnected)
                    if (response.data.isConnected) {
                        event.preventDefault();
                        if (response.data.isAdmin) {
                            $window.location.href = './admin/home';
                        } else if (isOsysOnlyUser(response)) {
                            $window.location.href = './triage-osys/';
                        } else if (isNonLqoOnlyUser(response)) {
                            AutoEvalService.ongletAccueilNonLqo().then(function (onglet) {
                                $window.location.href = './performances/mes-evaluations?tab=' + onglet;
                            });
                        } else if (response.data.isGroupement && !response.data.hasPharmacy) {
                            $window.location.href = './groupement/pharmacies';
                        } else {
                            $window.location.href = './home';
                        }
                    }
                }).catch(function (response) {

                });
            } else if (toState.name === 'app.error-404' || toState.name === 'activateAccount' || toState.name === 'forgotPassword' || toState.name === 'updatePassword' || toState.name === 'shareMalfunction' || toState.name === 'legal_mentions' || toState.name === 'questionnaire_satisfaction_2026' || toState.name === 'questionnaire_satisfaction_2026_short' || toState.name === 'questionnaire_satisfaction_2026_sms_short' || toState.name === 'login2faActivation') {

            }
            // routes non LQO MINI
            else if (toState.name.includes('app.malfunctions.trace') || toState.name.includes('app.qualite')) {
                UserService.isConnected().then(function (response) {
                    // Un administrateur SANS officine n'a rien à faire sur ces écrans ; s'il en a
                    // une, il peut porter la casquette pharmacie et y accéder comme un titulaire.
                    if (response.data.isAdmin && !response.data.hasPharmacy) {
                        $state.go('admin.home');
                    }
                    else if (isOsysOnlyUser(response)) {
                        redirectOsysToMesTriages(event);
                    }
                    else if (isNonLqoOnlyUser(response)) {
                        redirectNonLqoToAccueil(event);
                    }
                    else if (response.data.isMini) {
                        $state.go('app.home');
                    } else if (!response.data.isConnected) {
                        returnLogin(event);
                    }
                }).catch(function (response) {
                    returnLogin(event);
                });
            }
            else {
                $state.previous = { 'fromState': fromState, 'fromParams': fromParams };
                UserService.isConnected().then(function (response) {
                    if (response.data.isConnected) {
                        if (isOsysOnlyUser(response) && !isAllowedOsysState(toState)) {
                            redirectOsysToMesTriages(event);
                            return;
                        }
                        if (isNonLqoOnlyUser(response) && !isAllowedNonLqoState(toState, toParams)) {
                            redirectNonLqoToAccueil(event);
                            return;
                        }
                        if (!angular.isUndefined(toState.data) && !angular.isUndefined(toState.data.permissions) && toState.data.permissions.length > 0) {
                            UserService.checkPermission(toState.data.permissions).then(function (response) {
                                if (!response) {
                                    event.preventDefault();
                                    $window.location.href = './error-404';
                                }
                            }).catch(function (response) {
                                if (response.status === 401) {
                                    returnLogin(event, toState, toParams);
                                }
                            });
                        }
                    } else {
                        returnLogin(event, toState, toParams);
                    }
                }).catch(function (response) {
                    returnLogin(event, toState, toParams);
                });
            }

        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            currentStateName = toState && toState.name
            if (toState.name === 'login') {
                cancelCheck()
            } else if (!isOrientationEnabledForState(toState.name)) {
                cancelCheck()
            }
            // routes non LQO MINI
            else if (toState.name.includes('app.malfunctions.trace') || toState.name.includes('app.qualite')) {
                checkOrientation(toState.name)
            }
            else {
                checkOrientation(toState.name)
            }
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });

        });

        var onVisibilityChange = function () {
            isPaused = document.hidden
            if (!isPaused) {
                checkOrientation(currentStateName)
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            matchMedia.removeEventListener('change', watcher)
            document.removeEventListener('visibilitychange', onVisibilityChange)
        });

    }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    // Compatibilité des anciens signets « Revue de direction », renommée en
    // « Bilan de performances ». Sans ces règles, une ancienne URL tombe dans le
    // otherwise() ci-dessous et ramène silencieusement l'utilisateur à l'accueil.
    $urlRouterProvider.when('/revue-de-direction', '/bilan-de-performances');
    $urlRouterProvider.when(/^\/revue-de-direction\/details\/(.*)$/, '/bilan-de-performances/details/$1');
    $urlRouterProvider.when(/^\/revue-de-direction\/([^\/]+)$/, '/bilan-de-performances/$1');

    $urlRouterProvider.otherwise(function ($injector, $scope) {
      var state = $injector.get('$state');
      var userService = $injector.get('UserService');
      var window_ = $injector.get('$window');
      userService.isConnected().then(function (response) {
        if (response.data.isConnected) {
          if (response.data.isAdmin) {
            state.go('admin.home');
          } else if (response.data.isGroupement && !response.data.hasPharmacy) {
            // Le compte groupement arrive sur « Mes pharmacies », devenue la partie
            // principale de l'espace (§1).
            state.go('app.groupement.pharmacies');
          } else {
            state.go('app.home');
          }
        } else {
          state.go('login');
        }
      });
    });

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies',
      function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = 'verticalNavigationFullwidthToolbar2';

    var layouts = {
      verticalNavigation: {
        main: 'app/navigation/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/navigation/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        },
        data: {
          permissions: ['TITULAIRE', 'EQUIPE', 'PRAQ', 'ADMINISTRATEUR', 'GROUPEMENT']
        }
      }).state('admin', {
        abstract: true,
        url: '/admin',
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@admin': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@admin': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@admin': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        },
        data: {
          permissions: ['ADMINISTRATEUR']
        }
      });
  }

})();

angular.module('fuse')
    .filter('dateInformation', function (moment) {
        return function (date) {
            var now = new Date().getTime();
            var offset = now - date;
            var dateForm = new Date(date);

            if (offset < 60000) {
                return 'À l\'instant';
            }

            var nbrMinutes = offset / 60000;

            if (nbrMinutes <= 59) {
                return 'Il y a ' + Math.ceil(nbrMinutes) + ' min';
            }

            var today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            var todayMs = (now - today.getTime());

            var nbrHours = offset / 3600000;

            if (nbrHours < 24 && (todayMs / 3600000) > nbrHours) {
                var dateFormMom = moment(dateForm);
                return dateFormMom.format('HH:mm');
            }

            if (offset < (86400000 + todayMs)) {
                var dateFormMom = moment(dateForm);
                return 'Hier à ' + dateFormMom.format('HH:mm');
            }

            var dateMom = moment(date);
            dateMom.locale('fr');

            if (offset < 31536000000) {
                return dateMom.format('DD MMM HH:mm');
            }

            if (offset > 31536000000) {
                return dateMom.format('DD MMM YYYY');
            }
        };
    });

angular.module("fuse").directive('permission', ['UserService', function (UserService) {
  return {
    restrict: 'A',
    scope: {
      permission: '='
    },
    link: function (scope, elt, attrs) {
      UserService.checkPermission(scope.permission).then(function (data) {
        if (data) {
          elt.show();
        } else {
          elt.hide();
        }
      }, function (error) {
        console.log(error);
      });
    }
  };
}]);

angular
  .module('fuse')
  .directive('nlFooter', function () {
    return {
      restrict: 'E',
      templateUrl: "app/main/footer/footer.html",
    };
  });

angular
  .module('fuse').directive('autoSelect', function ($timeout) {
    return {
      restrict: 'AC',
      link: function (_scope, _element) {
        $timeout(function () {
          _element[0].select();
        }, 0);
      }
    };
  });

angular
  .module('fuse').directive('profilPicture', function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        imgUrl: '@',
        profileName: '@',
        phsqProfile: '='
      },
      controller: ['$scope', function ($scope) {
        $scope.srcResult = '';
        $scope.calculSrc = function () {
          if (!$scope.imgUrl || $scope.imgUrl === '') {
            var tmp = $scope.profileName;
            var colorBackgd = ['#EBB121', '#F08917', '#445E7E', '#6296AE', '#267D8C', '#3CB4A1'];
            var colorBorder = ['#EBB121', '#F08917', '#445E7E', '#6296AE', '#267D8C', '#3CB4A1'];

            var rdm = ($scope.profileName.charCodeAt(0) + $scope.profileName.charCodeAt(1)) % 6;

            var c = document.createElement('CANVAS');
            c.width = 64;
            c.height = 64;

            var ctx = c.getContext('2d');
            ctx.globalCompositeOperation = 'destination-over';
            // text
            ctx.font = '500 26px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = '#ffffff';
            ctx.fillText(tmp, 32, 34);

            // circle + border
            ctx.beginPath();
            ctx.arc(32, 32, 30, 0, 2 * Math.PI);
            if ($scope.phsqProfile) {
              ctx.fillStyle = colorBackgd[5];
            } else {
              ctx.fillStyle = colorBackgd[rdm];
            }
            ctx.fill();
            ctx.lineWidth = 0.001;
            if ($scope.phsqProfile) {
              ctx.fillStyle = colorBorder[5];
            } else {
              ctx.fillStyle = colorBorder[rdm];
            }
            ctx.stroke();

            // export
            var img = c.toDataURL('image/png');
            return img;
          } else {
            return $scope.imgUrl;
          }
        };
        $scope.srcResult = $scope.calculSrc();
        $scope.$watch('profileName', function () {
          $scope.srcResult = $scope.calculSrc();
        });
      }],
      template: '<img class="img-rounded" alt="Avatar" ng-src="{{srcResult}}"></img>'
    };
  });


angular
  .module('fuse')
  .directive('nlMenuClass', function ($window) {
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {
        var menuContent = el[0].querySelector('md-menu-content');
        scope.$on('$mdMenuOpen', function () {
          $window.requestAnimationFrame(function () {
            menuContent.parentNode.classList.add(attrs.nlMenuClass);
          });
        });

        scope.$on('$destroy', function () {
          menuContent = null;
        });
      }
    };
  });

angular.module('fuse').directive('ngEnter', function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.ngEnter, { 'event': event });
        });

        event.preventDefault();
      }
    });
  };
});






angular.module("fuse").directive('nlCategory', ['$compile', '$mdDialog', '$window', 'toastr', 'SatisfactionService', 'AutoEvaluationService', 'UserService',
  function ($compile, $mdDialog, $window, toastr, SatisfactionService, AutoEvaluationService, UserService) {
    return {
      restrict: 'E',
      templateUrl: 'app/main/front/performances/revue-de-direction/revue-de-direction-questions.html',
      scope: {
        question: '=ngModel',
        category: '=category',
        evals: '=evals',
        update: '=update'
      },
      compile: function (element, attrs) {
        var content, directive;
        content = element.contents().remove();
        return function (scope, element, attrs) {
          scope.cantUpdate = true && scope.update;

          // check permissions to know if user can update ordre du jour
          UserService.getUserRoles().then(function (res) {
            if (res.data.includes('TITULAIRE') || res.data.includes('PRAQ')) {
              scope.cantUpdate = false || scope.update;
            }
          }).catch(function (err) {
            toastr.success('Erreur: impossible de récupérer vos droits');
          });

          scope.setBaseDate = function (evals) {
            if (scope.question.title === "Auto évaluation annuelle réalisée") {
              //Condition check is bad but questions come from backend without an initial chosen answer
              //If someone find a better way feel free to change it

              if (evals != null && evals.length > 0) {
                var diffTime = Date.now() - evals[0]['uploadDate'];
                if (new Date(diffTime).getUTCFullYear() - 1970 < 1) {
                  scope.question.checkValue = true;
                  scope.question.dateValueInput = new Date(evals[0]['uploadDate']);
                }
              }
            }
          }

          scope.setBaseDate(scope.evals);

          scope.$on('autoeval', function (event, params) {
            scope.setBaseDate(params);
          });


          scope.nextLevel = scope.level + 1;
          directive || (directive = $compile(content));

          scope.hidePopup = function () {
            $mdDialog.hide();
          };

          scope.openAddFile = function () {
            scope.document = {};
            scope.editionMode = false;
            var templateUrl = null;
            if (scope.category.index === 6) {
              templateUrl = 'app/main/front/performances/mes-evaluations/add-satisfaction-client-popup.html';
            } else {
              templateUrl = 'app/main/front/qualite/auto-evaluation/add-auto-evaluation-popup.html';
            }
            scope.documentPopup = $mdDialog.show({
              templateUrl: templateUrl,
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              scope: scope,
              preserveScope: true
            }).then(function () { }).catch(function () { });
          };

          scope.saveDocument = function () {
            var input = null;
            if (scope.category.index === 6) {
              input = document.getElementById('satisfaction_input_file');
            } else {
              input = document.getElementById('auto_evaluation_input_file');
            }
            var file = null;
            if (input != null) {
              file = input.files[0];
            }
            var fd = new FormData();
            fd.append('file', file);
            fd.append('dto', angular.toJson(scope.document));
            if (scope.category.index === 6) {
              SatisfactionService.save(fd).then(function (response) {
                scope.hidePopup();
                scope.question.numberValue = parseInt(response.data);
              }).catch(function (response) {
                toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
              });
            } else {
              AutoEvaluationService.save(fd).then(function (response) {
                scope.hidePopup();
                scope.question.numberValue = parseInt(response.data);
              }).catch(function (response) {
                toastr.error('Une erreur est survenue, veuillez réessayer plus tard');
              });
            }
          };

          scope.download = function (id, category) {
            if (category.index === 6) {
              $window.location.href = SatisfactionService.getDownloadLink(id);
            } else {
              //index === 9
              $window.location.href = AutoEvaluationService.getDownloadLink(id);
            }
          };

          element.append(directive(scope, function ($compile) {
            return $compile;
          }));
        };
      }
    };
  }
]);

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $window, $rootScope, $scope, $mdDialog, UserService, msNavigationService, moment,
    FolderService, $state, appBrowser, QuestionnaireSatisfactionCampaignService,
    AutoEvalGroupementService, AutoEvalService, OsysService, ConfirmationGroupement) {
    var bodyEl = angular.element('body');
    var vm = this;
    // Droits du compte tels que servis par `isConnected` — source de vérité de la vue active,
    // disponible avant `$rootScope.user` (qui arrive, lui, avec `/rest/user`).
    var connectedRights = null;


    // Data
    vm.themes = fuseTheming.themes;
    //FOOTER

    moment.locale('fr');
    var REDIRECT_AFTER_LQO_ACTIVATION_KEY = 'phsq.redirectAfterLqoActivation';
    // angular.element(function () {

    //   if (appBrowser && appBrowser.getName() != 'chrome' && appBrowser.getName() != 'mozilla') {
    //     $.blockUI({
    //       message: '<div class="nl-BlockUI-inner">Cette application n\'est pas optimisée pour ce navigateur.<br> Installez Chrome : <a target="_blank" class="nl-BlockUI-btn" href="https://www.google.com/intl/fr_fr/chrome/">Installation Chrome</a><br><br>Installez Mozilla :<a target="_blank" class="nl-BlockUI-btn" href="https://www.mozilla.org/fr/firefox/download/thanks/">Installation Mozilla</a> </div> ',
    //       css: {
    //         top: '50%',
    //         left: '50%',
    //         width: 'auto',
    //         'max-width': '80%',
    //         transform: 'translate3d(-50%,-50%,0)',
    //         border: '0',
    //         'border-radius': '100px'
    //       }
    //     });
    //   }
    // });


    //////////

    function syncNonLqoMode(isNonLqo) {
      bodyEl.toggleClass('nl-non-lqo-mode', !!isNonLqo);
      if (isNonLqo) {
        // Keep the restricted menu expanded; only the overlay should block access.
        msNavigationService.setFolded(false);
      }
    }

    /**
     * VUE ACTIVE — voir UserService : un compte peut cumuler administrateur, groupement et
     * pharmacie, et chaque casquette a son menu. On la recalcule à chaque changement d'état,
     * puisque c'est l'état courant qui la porte.
     */
    function computeActiveView(stateName) {
      return UserService.resolveActiveView(connectedRights || $rootScope.user,
        stateName || ($state.current && $state.current.name));
    }

    // Lecture seule : appelée en boucle par les `hidden` du menu, elle ne doit rien écrire.
    function getActiveView() {
      return $rootScope.activeView || computeActiveView();
    }

    function syncActiveView(stateName) {
      var vue = computeActiveView(stateName);
      $rootScope.activeView = vue;
      // Conservé sous ce nom : le bandeau « Journées Qualité » de la barre du haut et de
      // l'accueil s'appuie déjà dessus.
      $scope.isGroupementMenuActive = vue === UserService.VUE_GROUPEMENT;
      return vue;
    }

    $rootScope.isNonLqoUser = function () {
      return !!($rootScope.user
        && !$rootScope.user.isAdmin
        && $rootScope.user.hasPharmacy
        && $rootScope.user.isNonLqo);
    };

    /** PHSQ-240 — clic sur un espace grisé du contrat OSYS (M3). */
    function ouvrirEspaceNonInclus($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      ConfirmationGroupement.demander({
        titre: 'Espace non inclus',
        texte: 'Cet espace n\u2019est pas inclus dans votre accès OSyS. Pour découvrir LQO, contactez PHSQ.',
        confirmer: 'Contact',
        annuler: 'Fermer',
        danger: false,
        event: $event
      }).then(function () {
        $state.go('app.contact');
      }).catch(angular.noop);
    }

    $rootScope.openNonLqoMenuPopup = function ($event) {
      if (!$rootScope.isNonLqoUser()) {
        return;
      }
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      $state.go('app.decouvrirLqo');
    };

    $scope.getCurrentUser = function () {
      UserService.getCurrent().then(function (response) {
        syncNonLqoMode($rootScope.isNonLqoUser());
        try {
          var redirectAfterLqoActivation = $window.sessionStorage.getItem(REDIRECT_AFTER_LQO_ACTIVATION_KEY);
          if (redirectAfterLqoActivation === 'home') {
            $window.sessionStorage.removeItem(REDIRECT_AFTER_LQO_ACTIVATION_KEY);
            $state.go('app.home', {}, { reload: true });
            return;
          }
        } catch (error) {
        }
        $rootScope.$broadcast('startNotifs');
      }).catch(function (response) {
        syncNonLqoMode(false);
        if (response.status === 404) {
          UserService.logout().then(function (response) {
            $rootScope.user.isConnected = false;
            $state.go('login');
            $scope.$emit("stopNotifs");
          }).catch(function () {
            $state.go('login');
          });
        }
      });
    };

    UserService.checkTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone).then(function () {

    })

    $scope.getCurrentUser();

    $scope.$on('getCurrentUser', function () {
      $scope.getCurrentUser();
    });

    /**
     * Millésimes d'auto-évaluation du groupement, chargés UNE SEULE FOIS.
     *
     * Nul tant que la réponse n'est pas arrivée ; tableau vide si elle a échoué — dans les deux
     * cas, on ne relance pas l'appel à chaque reconstruction du menu.
     */
    var millesimesAutoEval = null;

    $scope.refreshMenuItems = function () {
      msNavigationService.clearNavigation();
      UserService.isConnected().then(function (response) {
        var droits = response && response.data ? response.data : null;
        connectedRights = droits;
        syncActiveView();

        // Le menu monte TOUTES les casquettes du compte d'un seul coup ; c'est `hidden`, relu à
        // chaque cycle de digest, qui n'en laisse voir qu'une — celle de la vue active. La
        // bascule d'une vue à l'autre n'a donc rien à reconstruire.
        var horsVuePharmacie = function () {
          return getActiveView() !== UserService.VUE_PHARMACIE;
        };
        var horsVueGroupement = function () {
          return getActiveView() !== UserService.VUE_GROUPEMENT;
        };
        var horsVueAdministration = function () {
          return getActiveView() !== UserService.VUE_ADMINISTRATION;
        };

        if (droits && droits.isConnected && droits.hasPharmacy) {
          QuestionnaireSatisfactionCampaignService.getContext(true).then(function (context) {
            $rootScope.questionnaireCampaignContext = context;
          }).catch(function () {
            $rootScope.questionnaireCampaignContext = null;
          });
        } else {
          $rootScope.questionnaireCampaignContext = null;
        }
        chargerContexteAutoEval(droits);

        if (droits && droits.isGroupement) {
          // « Mes pharmacies » devient la partie principale de l'espace groupement (§1), en
          // couleur d'espace orange (arbitrage 28 — nl-Nav-item--2 porte déjà #FF9800).
          msNavigationService.saveItem('app-groupement-pharmacies', {
            icon: 'pharmacies',
            title: 'Mes pharmacies',
            class: 'nl-Nav-item nl-Nav-item--2',
            state: 'app.groupement.pharmacies',
            hidden: horsVueGroupement,
            weight: 1
          });

          msNavigationService.saveItem('app-groupement-pharmacies.liste', {
            title: 'Liste des pharmacies',
            class: 'nl-Nav-item-subItem',
            state: 'app.groupement.pharmacies',
            hidden: horsVueGroupement
          });

          msNavigationService.saveItem('app-groupement-pharmacies.audits', {
            title: 'Audits',
            class: 'nl-Nav-item-subItem',
            state: 'app.groupement.audits',
            hidden: horsVueGroupement
          });

          // « Journées qualité » : l'existant, rangé sous sa propre entrée. Le classement par
          // millésime attend l'ouverture des campagnes antérieures côté serveur — aujourd'hui
          // seule la campagne courante est servie.
          msNavigationService.saveItem('app-groupement-restitutions', {
            icon: 'performances',
            title: 'Journées qualité',
            class: 'nl-Nav-item nl-Nav-item--1',
            state: 'app.groupement.restitutions',
            hidden: horsVueGroupement,
            weight: 2
          });

          msNavigationService.saveItem('app-groupement-restitutions.suivi-enquete', {
            title: 'Suivi enquête',
            class: 'nl-Nav-item-subItem',
            state: 'app.groupement.restitutions.suivi-enquete',
            hidden: horsVueGroupement
          });

          msNavigationService.saveItem('app-groupement-restitutions.pharmacies-engagees', {
            title: 'Pharmacies engagées',
            class: 'nl-Nav-item-subItem',
            state: 'app.groupement.restitutions.pharmacies-engagees',
            hidden: horsVueGroupement
          });

          // « Auto-évaluation » : un sous-item par millésime, sur le modèle des journées qualité.
          //
          // ⚠️ Les sous-items sont posés APRÈS la réponse du serveur, puis le menu est rafraîchi.
          // Les années ne sont pas devinables côté client : une campagne apparaît dès sa
          // programmation. L'historique repris de 2025 n'y figure pas — le serveur l'écarte.
          msNavigationService.saveItem('app-groupement-autoeval', {
            icon: 'qualite',
            title: 'Auto-évaluation',
            class: 'nl-Nav-item nl-Nav-item--3',
            hidden: horsVueGroupement,
            weight: 3
          });

          var poserMillesimes = function (millesimes) {
            angular.forEach(millesimes, function (millesime) {
              msNavigationService.saveItem('app-groupement-autoeval.' + millesime.annee, {
                // Une campagne programmée mène à sa page « à venir » : dates et boîte à outils.
                title: millesime.statut === 'PROGRAMMEE' ? millesime.annee + ' · à venir' : String(millesime.annee),
                class: 'nl-Nav-item-subItem',
                state: 'app.groupement.autoeval',
                stateParams: { annee: millesime.annee },
                hidden: horsVueGroupement,
                // Années décroissantes : la campagne courante en tête.
                weight: -millesime.annee
              });
            });
          };

          // ⚠️ LA LISTE N'EST CHARGÉE QU'UNE FOIS. `refreshMenuItems` est rappelé par son propre
          // événement (voir l'écouteur en fin de contrôleur) : relancer l'appel à chaque passage
          // rediffuserait l'événement, qui relancerait l'appel — une boucle de requêtes sans fin.
          // Les passages suivants reposent les sous-items depuis la liste déjà obtenue.
          if (millesimesAutoEval) {
            poserMillesimes(millesimesAutoEval);
          } else {
            AutoEvalGroupementService.getMillesimes().then(function (millesimes) {
              millesimesAutoEval = millesimes || [];
              poserMillesimes(millesimesAutoEval);
              // Un seul rafraîchissement, à la première réponse : il repasse par ici, trouve la
              // liste en mémoire, et s'arrête.
              $rootScope.$broadcast('refreshMenuItems');
            }).catch(function () {
              // Aucun millésime lisible : l'entrée reste sans sous-item plutôt que de faire
              // échouer la construction de tout le menu — et on ne réessaie pas en boucle.
              millesimesAutoEval = [];
            });
          }
        }

        // PHSQ-240 — contrat OSYS : les espaces LQO sont montrés grisés, avec un cadenas, sans
        // état ni sous-entrées ; un clic ouvre la fenêtre « espace non inclus » (M3, A4).
        var contratOsys = !!(droits && droits.contratOsys && droits.hasPharmacy && !droits.isAdmin);
        var espaceNonInclus = function (id, icon, title, numero) {
          msNavigationService.saveItem(id, {
            icon: icon,
            title: title,
            class: 'nl-Nav-item nl-Nav-item--' + numero + ' osy-Nav-item--verrouille',
            verrouille: true,
            clic: ouvrirEspaceNonInclus,
            hidden: horsVuePharmacie,
            weight: numero
          });
        };

        // ACCUEIL
        if (contratOsys) {
          espaceNonInclus('app-home', 'accueil', 'Accueil', 1);
        } else {
          msNavigationService.saveItem('app-home', {
            icon: 'accueil',
            title: 'Accueil',
            class: 'nl-Nav-item nl-Nav-item--1',
            state: 'app.home',
            hidden: function () {
              return horsVuePharmacie();
            },
            weight: 1
          });
        }

        // TRIAGE OSYS (PHSQ-240) — enregistré ICI, de façon synchrone, juste après l'Accueil :
        // `weight` n'est lu qu'en entier, et les autres espaces arrivent plus tard, dans le
        // `.then` de findRoots (E25). Réservé au titulaire d'une officine dont le module a été
        // activé ; la pastille compte les rappels du jour et en retard (M11).
        var horsModuleOsys = function () {
          return horsVuePharmacie() || !($rootScope.user && $rootScope.user.isTitulaire && droits && droits.osysModule);
        };
        msNavigationService.saveItem('app-osys', {
          icon: 'triage',
          title: 'Triage OSyS',
          class: 'nl-Nav-item nl-Nav-item--7',
          pastille: OsysService.aRappeler,
          hidden: horsModuleOsys,
          weight: 1
        });
        // `etatsActifs` : pages sans entrée de menu rattachées à une entrée (surlignage et groupe ouvert,
        // même après F5). Clés distinctes pour les mêmes classes : la syntaxe objet de ui-sref-active
        // associe un seul état à chaque clé. Écran de fin : rouvert (valide nul) → Mes triages ; juste
        // après la validation → Nouveau triage.
        msNavigationService.saveItem('app-osys.mes-triages', {
          title: 'Mes triages',
          class: 'nl-Nav-item-subItem',
          state: 'app.osys.mesTriages',
          etatsActifs: { 'active md-accent-bg': 'app.osys.mesTriages', 'md-accent-bg active': 'app.osys.fin({valide: null})' },
          pastille: OsysService.aRappeler,
          hidden: horsModuleOsys
        });
        msNavigationService.saveItem('app-osys.nouveau', {
          title: 'Nouveau triage',
          class: 'nl-Nav-item-subItem',
          state: 'app.osys.nouveau',
          etatsActifs: { 'active md-accent-bg': 'app.osys.nouveau', 'md-accent-bg active': 'app.osys.triage',
            'active  md-accent-bg': 'app.osys.fin({valide: true})' },
          hidden: horsModuleOsys
        });
        if (droits && droits.osysModule) {
          OsysService.chargerContexte().catch(angular.noop);
        }

        if (contratOsys) {
          espaceNonInclus('app-folders', 'documentaire', 'Base documentaire', 2);
          espaceNonInclus('app-malfunctions', 'dysfonctionnements', 'Dysfonctionnements <br> & traçabilités', 3);
          espaceNonInclus('app-equipe', 'equipe', 'Equipe', 5);
          espaceNonInclus('app-performances', 'performances', 'Performances', 6);
        } else if (droits && droits.hasPharmacy) {
          FolderService.findRoots().then(function (folders) {

            msNavigationService.saveItem('app-folders', {
              icon: 'documentaire',
              title: 'Base documentaire',
              class: 'nl-Nav-item nl-Nav-item--2',
              state: 'app.folders',
              hidden: function () {
                return horsVuePharmacie();
              },
              weight: 2
            });

            //DYSFONCTIONNEMENTS
            msNavigationService.saveItem('app-malfunctions', {
              icon: 'dysfonctionnements',
              title: 'Dysfonctionnements <br> & traçabilités',
              class: 'nl-Nav-item nl-Nav-item--3',
              //state: 'app.malfunctions-fiches',
              hidden: function () {
                return horsVuePharmacie();
              },
              weight: 3
            });
            msNavigationService.saveItem('app-malfunctions.malfunctions', {
              title: 'Dysfonctionnements',
              class: 'nl-Nav-item-subItem',
              state: 'app.malfunctions',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-malfunctions.progress', {
              title: 'Fiches de progrès',
              class: 'nl-Nav-item-subItem',
              state: 'app.fiches-progres',
              hidden: function () {
                return horsVuePharmacie() || response.data.isMini;
              }
            });
            msNavigationService.saveItem('app-malfunctions.appel-medecins', {
              title: 'Appels aux médecins',
              class: 'nl-Nav-item-subItem',
              state: 'app.appel-medecins',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-malfunctions.trace', {
              title: 'Autres traçabilités',
              class: 'nl-Nav-item-subItem',
              state: 'app.controle.trace',
              hidden: function () {
                return horsVuePharmacie();
              }
            });

            //CONTROLES

            // msNavigationService.saveItem('app-controle', {
            //   title: 'Contrôles',
            //   class: 'nl-Nav-item nl-Nav-item--4',
            //   state: 'app.controle.summary',
            //   hidden: function () {
            //     return response.data.isConnected && response.data.isAdmin;
            //   },
            //   weight: 4
            // });
            //
            // msNavigationService.saveItem('app-controle.trace', {
            //   title: 'Traçabilité',
            //   class: 'nl-Nav-item-subItem',
            //   state: 'app.controle.trace',
            //   hidden: function () {
            //     return response.data.isConnected && response.data.isAdmin;
            //   }
            // });


            //QUALITE
            /* msNavigationService.saveItem('app-qualite', {
              icon: 'qualite',
              title: 'Qualité',
              class: 'nl-Nav-item nl-Nav-item--4',
              state: 'app.qualite.summary',
              hidden: function () {
                return response.data.isConnected && (response.data.isAdmin || response.data.isMini);
              },
              weight: 4
            });
            msNavigationService.saveItem('app-qualite.communication-interne', {
              title: 'Communication interne',
              class: 'nl-Nav-item-subItem',
              state: 'app.qualite.communication-interne',
              hidden: function () {
                return response.data.isConnected && response.data.isAdmin;
              }
            });
            msNavigationService.saveItem('app-qualite.auto-controles', {
              title: 'Auto-contrôles',
              class: 'nl-Nav-item-subItem',
              state: 'app.qualite.auto-controles',
              hidden: function () {
                return response.data.isConnected && response.data.isAdmin;
              }
            });
            msNavigationService.saveItem('app-qualite.auto-evaluation', {
              title: 'Auto-évaluation',
              class: 'nl-Nav-item-subItem',
              state: 'app.qualite.auto-evaluation',
              hidden: function () {
                return response.data.isConnected && response.data.isAdmin;
              }
            });
            msNavigationService.saveItem('app-qualite.audit', {
              title: 'Audit',
              class: 'nl-Nav-item-subItem',
              state: 'app.qualite.audit',
              hidden: function () {
                return response.data.isConnected && response.data.isAdmin;
              }
            });
            msNavigationService.saveItem('app-qualite.taches', {
              title: 'Mise en œuvre de la démarche',
              class: 'nl-Nav-item-subItem',
              state: 'app.qualite.demarche',
              hidden: function () {
                return response.data.isConnected && response.data.isAdmin;
              }
            }); */

            //EQUIPE
            msNavigationService.saveItem('app-equipe', {
              icon: 'equipe',
              title: 'Equipe',
              class: 'nl-Nav-item nl-Nav-item--5',
              // state: 'app.equipe.summary',
              hidden: function () {
                return horsVuePharmacie();
              },
              weight: 5
            });
            msNavigationService.saveItem('app-equipe.planning-general', {
              title: 'Planning',
              class: 'nl-Nav-item-subItem',
              state: 'app.equipe.planning-general',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-equipe.projects', {
              title: 'Suivi de projets',
              class: 'nl-Nav-item-subItem',
              state: 'app.equipe.projects',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-equipe.reunions', {
              title: 'Réunions',
              class: 'nl-Nav-item-subItem',
              state: 'app.equipe.reunions',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-equipe.equipe', {
              title: 'Collaborateurs',
              class: 'nl-Nav-item-subItem',
              state: 'app.equipe.equipe',
              hidden: function () {
                return horsVuePharmacie();
              }
            });

            //PERFORMANCES
            // « nl-Nav-item--ouvertNonLqo » : pour une officine sans LQO, le groupe doit rester
            // dépliable — « Mes évaluations », sa seule page, est dedans (voir index.scss).
            msNavigationService.saveItem('app-performances', {
              icon: 'performances',
              title: 'Performances',
              class: 'nl-Nav-item nl-Nav-item--6 nl-Nav-item--ouvertNonLqo',
              //state: 'app.performances.summary',
              hidden: function () {
                return horsVuePharmacie();
              },
              weight: 6
            });
            msNavigationService.saveItem('app-performances.plan-strategique', {
              title: 'Plan stratégique',
              class: 'nl-Nav-item-subItem',
              state: 'app.performances.plan-strategique',
              hidden: function () {
                return horsVuePharmacie() || response.data.isMini;
              }
            });
            msNavigationService.saveItem('app-performances.tableau-de-bord', {
              title: 'Tableau de bord',
              class: 'nl-Nav-item-subItem',
              state: 'app.performances.tableau-de-bord',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-performances.evaluation-fournisseurs', {
              title: 'Suivi fournisseurs',
              class: 'nl-Nav-item-subItem',
              state: 'app.performances.evaluation-fournisseurs',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            // « nl-Nav-item--ouvertNonLqo » : la seule entrée qu'une officine sans LQO peut
            // suivre — le reste du menu est grisé et recouvert (voir index.scss).
            msNavigationService.saveItem('app-performances.mes-evaluations', {
              title: 'Mes évaluations',
              class: 'nl-Nav-item-subItem nl-Nav-item--ouvertNonLqo',
              state: 'app.performances.mes-evaluations',
              hidden: function () {
                return horsVuePharmacie();
              }
            });
            msNavigationService.saveItem('app-performances.bilan-de-performances', {
              title: 'Bilan de performances',
              class: 'nl-Nav-item-subItem',
              state: 'app.performances.bilan-de-performances',
              hidden: function () {
                return horsVuePharmacie() || response.data.isMini;
              }
            });

            // MON OFFICINE (chantier PHSQ-220, spécification sortie-qualite § 8.1) : sous Performances,
            // pour le TITULAIRE seulement — la même condition que l'entrée du menu du compte, qui
            // reste. La garde de route le vérifie aussi côté serveur : masquer l'entrée ne suffirait
            // pas, l'adresse reste tapable. `nl-Nav-item--4` : la teinte libre de la palette du menu.
            msNavigationService.saveItem('app-officine', {
              icon: 'pharmacies',
              title: 'Mon officine',
              class: 'nl-Nav-item nl-Nav-item--4',
              state: 'app.officine',
              hidden: function () {
                var user = $rootScope.user;
                return horsVuePharmacie() || !(user && user.isTitulaire && user.hasPharmacy && !user.isNonLqo);
              },
              weight: 7
            });

            // $rootScope.$broadcast('foldersReady');


            for (var index = 0; index < folders.length; index++) {
              var cat = folders[index];
              msNavigationService.saveItem('app-folders.' + cat.id, {
                // icon: 'documentaire',
                title: cat.name,
                class: 'nl-Nav-item-subItem',
                state: 'app.category',
                stateParams: {
                  categoryId: cat.id
                },
                weight: cat.index
              });
            }
          }).catch(function (err) {
            console.log(err);
          });
        }

        //ADMIN
        msNavigationService.saveItem('admin-home', {
          icon: 'accueil',
          title: 'Accueil',
          state: 'admin.home',
          class: 'nl-Nav-item nl-Nav-item--1',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 1
        });

        msNavigationService.saveItem('admin-pharmacies', {
          icon: 'equipe',
          title: 'Pharmacies',
          state: 'admin.pharmacies',
          class: 'nl-Nav-item nl-Nav-item--2',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 2
        });
        msNavigationService.saveItem('admin-pharmacies.all', {
          title: 'Toutes les pharmacies',
          class: 'nl-Nav-item-subItem',
          state: 'admin.pharmacies.all',
          hidden: function () {
            return horsVueAdministration();
          }
        });
        msNavigationService.saveItem('admin-pharmacies.lqo', {
          title: 'LQO',
          class: 'nl-Nav-item-subItem',
          state: 'admin.pharmacies.lqo',
          hidden: function () {
            return horsVueAdministration();
          }
        });
        msNavigationService.saveItem('admin-pharmacies.lqo-mini', {
          title: 'LQO découverte',
          class: 'nl-Nav-item-subItem',
          state: 'admin.pharmacies.lqo-mini',
          hidden: function () {
            return horsVueAdministration();
          }
        });
        msNavigationService.saveItem('admin-pharmacies.non-lqo', {
          title: 'Non-LQO',
          class: 'nl-Nav-item-subItem',
          state: 'admin.pharmacies.non-lqo',
          hidden: function () {
            return horsVueAdministration();
          }
        });
        msNavigationService.saveItem('admin-pharmacies.statistiques', {
          title: 'Statistiques',
          class: 'nl-Nav-item-subItem',
          state: 'admin.pharmacies.statistiques',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        msNavigationService.saveItem('admin-bandeau', {
          icon: 'qualite',
          title: 'Bandeau<br/>déroulant',
          state: 'admin.bandeau',
          class: 'nl-Nav-item nl-Nav-item--3',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 3
        });

        msNavigationService.saveItem('admin-groupements', {
          icon: 'equipe',
          title: 'Groupements',
          state: 'admin.groupements',
          class: 'nl-Nav-item nl-Nav-item--4',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 4
        });

        msNavigationService.saveItem('admin-journees-qualite', {
          icon: 'performances',
          title: 'Journées qualité',
          class: 'nl-Nav-item nl-Nav-item--5',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 5
        });

        // AUTO-ÉVALUATION — le pilotage des campagnes PHSQ.
        msNavigationService.saveItem('admin-auto-evaluation', {
          icon: 'qualite',
          title: 'Auto-évaluation',
          class: 'nl-Nav-item nl-Nav-item--3',
          state: 'admin.autoeval',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 6
        });

        msNavigationService.saveItem('admin-auto-evaluation.campagnes', {
          title: 'Campagnes',
          class: 'nl-Nav-item-subItem',
          state: 'admin.autoeval',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        msNavigationService.saveItem('admin-journees-qualite.configuration-campagne', {
          title: 'Configuration campagne',
          class: 'nl-Nav-item-subItem',
          state: 'admin.configuration-campagne',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        msNavigationService.saveItem('admin-journees-qualite.boite-a-outils', {
          title: 'Boîte à outils',
          class: 'nl-Nav-item-subItem',
          state: 'admin.toolbox',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        msNavigationService.saveItem('admin-journees-qualite.suivi-enquete', {
          title: 'Suivi enquête',
          class: 'nl-Nav-item-subItem',
          state: 'admin.suivi-enquete',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        // PHSQ-240 — espace OSyS de l'administration (H3 à H6). Pas de sous-entrée OSyS dans
        // « Pharmacies » (M59).
        msNavigationService.saveItem('admin-osys', {
          icon: 'triage',
          title: 'OSyS',
          class: 'nl-Nav-item nl-Nav-item--7',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 6
        });
        msNavigationService.saveItem('admin-osys.officines', {
          title: 'Officines',
          class: 'nl-Nav-item-subItem',
          state: 'admin.osys.officines',
          // Fiche d'une officine et import des habilitations : rattachés à « Officines ».
          etatsActifs: { 'active md-accent-bg': 'admin.osys.officines', 'md-accent-bg active': 'admin.osys.officine',
            'active  md-accent-bg': 'admin.osys.import' },
          hidden: function () {
            return horsVueAdministration();
          }
        });
        msNavigationService.saveItem('admin-osys.indicateurs', {
          title: 'Indicateurs et exports',
          class: 'nl-Nav-item-subItem',
          state: 'admin.osys.indicateurs',
          hidden: function () {
            return horsVueAdministration();
          }
        });

        // PHSQ-240 — comptes administrateurs : entrée commune à toute l'administration, séparée
        // des espaces métier, en bas du menu (enregistrée en dernier : l'ordre d'enregistrement
        // fait l'ordre d'affichage).
        msNavigationService.saveItem('admin-administrateurs', {
          icon: 'equipe',
          title: 'Administrateurs',
          state: 'admin.administrateurs',
          class: 'nl-Nav-item nl-Nav-item--6 lqo-Nav-item--bas',
          hidden: function () {
            return horsVueAdministration();
          },
          weight: 99
        });





      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.refreshMenuItems();

    $scope.$on('refreshMenuItems', function () {
      $scope.refreshMenuItems();
    });

    $scope.$on('refreshQuestionnaireCampaignContext', function () {
      if (!$rootScope.user || !$rootScope.user.hasPharmacy) {
        $rootScope.questionnaireCampaignContext = null;
        return;
      }
      QuestionnaireSatisfactionCampaignService.clearCache();
      QuestionnaireSatisfactionCampaignService.getContext(true).then(function (context) {
        $rootScope.questionnaireCampaignContext = context;
      }).catch(function () {
        $rootScope.questionnaireCampaignContext = null;
      });
    });

    // ------------------------------------------------------------------ auto-évaluation

    var JOURS_TEASING_AUTOEVAL = 30;

    /**
     * Le contexte d'auto-évaluation de la pharmacie, pour le bandeau du haut. Un 404 — pharmacie
     * hors cible, aucune campagne — n'est pas une erreur : pas de bandeau, c'est tout.
     */
    function chargerContexteAutoEval(droits) {
      if (!droits || !droits.isConnected || !droits.hasPharmacy || droits.isAdmin) {
        $rootScope.autoEvalContext = null;
        return;
      }
      AutoEvalService.getContexte().then(function (contexte) {
        $rootScope.autoEvalContext = contexte;
      }).catch(function () {
        $rootScope.autoEvalContext = null;
      });
    }

    // Après une validation, ou quand la carte a relu son contexte : le bandeau suit.
    $scope.$on('refreshAutoEvalContext', function () {
      chargerContexteAutoEval(connectedRights);
    });

    /** Jours de calendrier avant l'ouverture de la campagne d'auto-évaluation ; null sans date. */
    $rootScope.joursAvantOuvertureAutoEval = function () {
      var ctx = $rootScope.autoEvalContext;
      if (!ctx || !ctx.campagne || !angular.isNumber(ctx.campagne.dateOuverture)) {
        return null;
      }
      var ouverture = new Date(ctx.campagne.dateOuverture);
      ouverture.setHours(0, 0, 0, 0);
      var aujourdhui = new Date();
      aujourdhui.setHours(0, 0, 0, 0);
      return Math.round((ouverture.getTime() - aujourdhui.getTime()) / 86400000);
    };

    /**
     * La campagne d'auto-évaluation a-t-elle quelque chose à montrer à la pharmacie ? Faux
     * pour une campagne à venir à plus de trente jours : ni carte, ni teaser (recette pharmacie,
     * ligne 18). L'onglet des comptes non-LQO en dépend.
     */
    $rootScope.autoEvalAffichable = function () {
      var ctx = $rootScope.autoEvalContext;
      if (!ctx || !ctx.campagne || !ctx.situation || ctx.situation === 'AUCUNE_CAMPAGNE') {
        return false;
      }
      if (ctx.situation !== 'A_VENIR') {
        return true;
      }
      var jours = $rootScope.joursAvantOuvertureAutoEval();
      return jours !== null && jours >= 0 && jours <= JOURS_TEASING_AUTOEVAL;
    };

    /**
     * LE BANDEAU « AUTO-ÉVALUATION » du haut de page, sur le modèle de celui des Journées
     * qualité : dans les trente jours avant l'ouverture (il mène au teaser), puis pendant la
     * campagne TANT QU'IL RESTE À FAIRE — rien après la validation.
     *
     * ⚠️ Réservé au TITULAIRE et au RESPONSABLE QUALITÉ : ce sont eux qui remplissent. Un membre
     * de l'équipe n'a rien à y faire.
     */
    $rootScope.shouldShowAutoEvalBanner = function () {
      var ctx = $rootScope.autoEvalContext;
      var user = $rootScope.user;
      if (!ctx || !ctx.campagne || getActiveView() !== UserService.VUE_PHARMACIE) {
        return false;
      }
      if (!user || !(user.isTitulaire || user.isPraq)) {
        return false;
      }
      if (ctx.situation === 'A_VENIR') {
        return $rootScope.autoEvalAffichable();
      }
      return ctx.situation === 'EN_COURS' || ctx.situation === 'ROUVERTE';
    };

    // Le bandeau "Journées Qualité" + bouton "Accéder à mon enquête" s'affiche
    // si la campagne est en cours OU si elle commence dans moins de 30 jours.
    // ⚠️ L'auto-évaluation a la PRIORITÉ : tant que son bandeau s'affiche, celui des Journées
    // qualité s'efface — le haut de page n'a qu'une place (voir la barre d'outils).
    $rootScope.shouldShowCampaignBanner = function () {
      var ctx = $rootScope.questionnaireCampaignContext;
      if (!ctx || getActiveView() !== UserService.VUE_PHARMACIE) {
        return false;
      }
      if (ctx.campaignActive) {
        return true;
      }
      if (typeof ctx.dateDebutCampagne === 'number') {
        var msUntilStart = ctx.dateDebutCampagne - Date.now();
        var thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;
        return msUntilStart > 0 && msUntilStart <= thirtyDaysMs;
      }
      return false;
    };

    //COLORS
    $scope.currentState = $state.current.name;
    //Il faudrait changer les routes des dysfonctionnements, pas le temps pour le moment
    $scope.$on("$stateChangeStart", function (event, toState) {
      if (toState.name.split(".")[1] !== undefined) {
        if (toState.name.split(".")[1] === "fiches-progres" || toState.name.split(".")[1] === "appel-medecins" || toState.name.split(".")[1] === "malfunctions-fiches") {
          $scope.currentState = "malfunctions";
        } else {
          $scope.currentState = toState.name.split(".")[1];
        }
      }

      syncActiveView(toState && toState.name);
    });

    $scope.$on('$stateChangeSuccess', function () {
      syncActiveView();
    });



    $scope.goTo = function (url, restricted) {
      if ($rootScope.isNonLqoUser && $rootScope.isNonLqoUser() && restricted) {
        AutoEvalService.ongletAccueilNonLqo().then(function (onglet) {
          $state.go('app.performances.mes-evaluations', { tab: onglet });
        });
        return;
      }
      if (!($rootScope.user.isMini && restricted)) {
        $window.location = url;
      }
      else $scope.showMiniModal();
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.showMiniModal = function ($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        clickOutsideToClose: true,
        templateUrl: 'app/main/front/other/mini_restrictions_modal.html',
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {

      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .constant('PERMISSIONS', {
      ADMINISTRATEUR: 'ADMINISTRATEUR',
      TITULAIRE: 'TITULAIRE',
      PRAQ: 'PRAQ',
      EQUIPE: 'EQUIPE'
    })
    .constant('PRIORITIES_MALFUNCTION', {
      HIGH: 'HIGH',
      NORMAL: 'NORMAL',
      LOW: 'LOW'
    })
    .constant('PRIORITIES_MALFUNCTION_NAMES', {
      HIGH: 'Forte',
      NORMAL: 'Moyenne',
      LOW: 'Faible'
    })
    .constant('TYPES_SUPPLIER', {
      LAB: 'LAB',
      SERVICE: 'SERVICE'
    })
    .constant('TYPES_DESPENSATION', {
      INTERNE_CONTROL: 'INTERNE_CONTROL',
      DMP: 'DMP',
      CLIENT: 'CLIENT',
      PAYER_ORGANISM: 'PAYER_ORGANISM'
    })
    .constant('ECOR_DOMAINS', {
      ACHAT: 'Achats - prestataires',
      DECHETS: 'Déchets',
      ENERGIE: 'Energie',
      ORGANISATION: 'Organisation équipe',
      PARCOURS: 'Parcours patients',
      AUTRE: 'Autre',
    })
    .constant('DISPENSATION_DATES', [
      {
        index: 0,
        libelle: 'Une seule prise',
        code: 'ONE_TAKE'
      },
      {
        index: 1,
        libelle: 'Deux prises',
        code: 'TWO_TAKES'
      },
      {
        index: 2,
        libelle: 'Plus d\'une journée',
        code: 'MORE_THAN_DAY'
      },
      {
        index: 3,
        libelle: 'Plus d\'une semaine',
        code: 'MORE_THAN_WEEK'
      },
      {
        index: 4,
        libelle: 'Plus d\'un mois',
        code: 'MORE_THAN_MONTH'
      }
    ])
    .constant('DISPENSATION_ERRORS', [
      {
        index: 0,
        libelle: 'Mauvais produit',
        code: 'BAD_PRODUCT'
      },
      {
        index: 1,
        libelle: 'Mauvais dosage',
        code: 'BAD_DOSAGE'
      },

      {
        index: 2,
        libelle: 'Mauvaise forme galénique',
        code: 'BAD_PHARMACEUTICAL_FORM'
      },

      {
        index: 3,
        libelle: 'Mauvais nombre de boîte',
        code: 'BAD_BOX_NUMBERS'
      },
      {
        index: 4,
        libelle: 'Oubli d\'un produit',
        code: 'PRODUCT_FORGOT'
      },
      {
        index: 5,
        libelle: 'Vente d\'un périmé',
        code: 'OBSELETE_SELL'
      },
      {
        index: 6,
        libelle: 'Erreur de tarification/facturation',
        code: 'TARIF_ERROR'
      },
      {
        index: 7,
        libelle: 'Non-respect des règles de délivrance',
        code: 'NON_RESPECT_RULES'
      },
      {
        index: 8,
        libelle: 'Erreur de prescription (dont incomplète)',
        code: 'PRESCRIPTION_ERROR'
      },
      {
        index: 9,
        libelle: 'Autre',
        code: 'OTHER'
      }
    ])
    .constant('STATUSES_MALFUNCTION', {
      NOT_OPEN: 'NOT_OPEN',
      NOT_READ: 'NOT_READ',
      READ: 'READ',
      IN_PROGRESS: 'IN_PROGRESS',
      HIGH: 'HIGH',
      NORMAL: 'NORMAL',
      LOW: 'LOW'
    })
    .constant('GENERAL_TASK_TYPES', [{
      index: 0,
      libelle: "Autre",
      value: "AUTRE"
    },
    {
      index: 1,
      libelle: "Action décidée / Bilan de performances",
      value: "ACTION_DECIDEE_REVUE_DIRECTION"
    },
    {
      index: 2,
      libelle: "Action décidée / Réunion d'équipe",
      value: "ACTION_DECIDEE_REVUE_EQUIPE"
    },
    {
      index: 3,
      libelle: "Action préventive ou corrective",
      value: "ACTION_PREVENTIVE_OU_CORRECTIVE"
    },
    {
      index: 4,
      libelle: "Objectif stratégique",
      value: "OBJECTIF_STRATEGIQUE"
    },
    {
      index: 5,
      libelle: "Audits et écarts",
      value: "AUDITS_ET_ECARTS"
    },
    {
      index: 6,
      libelle: "Qualité",
      value: "QUALITE"
    }
    ])
    .constant('GENERAL_TASK_TYPES_FIRST_YEAR_QUALITY', [
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_METIER_DISP', libelle: 'Métier dispensation', index: 7 },
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_METIER_HORS_DISP', libelle: 'Métier hors dispensation', index: 8 },
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_STRATEGIE', libelle: 'Stratégie et pilotage', index: 9 },
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_RH', libelle: 'Ressources humaines', index: 10 },
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_AMELIORATION_CONTINUE', libelle: 'Amélioration continue', index: 11 },
      { value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_RESSOURCES_MATERIELLES', libelle: 'Ressources matérielles', index: 12 }
    ])
    // {
    //   index: 0,
    //   libelle: "Quotidienne",
    //   value: "QUOTIDIENNE"
    // },
    .constant('GENERAL_TASK_PERIOD', [{
      index: 1,
      libelle: "Hebdomadaire",
      value: "HEBDOMADAIRE"
    },
    {
      index: 2,
      libelle: "Mensuelle (toutes les 4 semaines)",
      value: "FOUR_WEEKS"
    },
    {
      index: 3,
      libelle: "Mensuelle (tous les mois)",
      value: "MENSUELLE"
    },
    {
      index: 4,
      libelle: "Trimestrielle",
      value: "TRIMESTRIELLE"
    },
    {
      index: 5,
      libelle: "Semestrielle",
      value: "SEMESTRIELLE"
    },
    {
      index: 6,
      libelle: "Annuelle",
      value: "ANNUELLE"
    }
    ])
    .constant('GENERAL_TASK_PERIOD_JSON', {
      QUOTIDIENNE: "Quotidienne",
      HEBDOMADAIRE: "Hebdomadaire",
      FOUR_WEEKS: "Mensuelle (toutes les 4 semaines)",
      MENSUELLE: "Mensuelle (tous les mois)",
      TRIMESTRIELLE: "Trimestrielle",
      SEMESTRIELLE: "Semestrielle",
      ANNUELLE: "Annuelle"
    })
    .constant('moment', moment)
    .constant('REUNION', {
      RECURRENCES: [{
        index: 0,
        libelle: "Quotidienne",
        value: "QUOTIDIENNE"
      },
      {
        index: 1,
        libelle: "Hebdomadaire",
        value: "HEBDOMADAIRE"
      },
      {
        index: 2,
        libelle: "Mensuelle (toutes les 4 semaines)",
        value: "FOUR_WEEKS"
      },
      {
        index: 3,
        libelle: "Mensuelle (tous les mois)",
        value: "MENSUELLE"
      },
      {
        index: 4,
        libelle: "Trimestrielle",
        value: "TRIMESTRIELLE"
      },
      {
        index: 5,
        libelle: "Semestrielle",
        value: "SEMESTRIELLE"
      },
      {
        index: 6,
        libelle: "Annuelle",
        value: "ANNUELLE"
      }
      ],
      ORDRES_DU_JOUR: {
        RUBRIQUES: [
          {
            index: 0,
            libelle: "Dysfonctionnements",
            type: "DYSFONCTIONNEMENT"
          },
          {
            index: 1,
            libelle: "Fiches de progrès",
            type: "PROGRESS_FORM"
          },
          {
            index: 2,
            libelle: "Documents ajoutés",
            type: "DOCUMENT_MODIFIE"
          },
          {
            index: 3,
            libelle: "Tâches et évènements planifiés",
            type: "TACHE_ET_EVENEMENT_PLANIFIE"
          },
          {
            index: 4,
            libelle: "Dernières actions décidées",
            type: "DERNIERE_ACTION_DECIDEE"
          },
          {
            index: 5,
            libelle: "Suivi de l'activité de l'officine",
            type: "NOTE_ODJ"
          },
          {
            index: 6,
            libelle: "Indicateurs du tableau de bord",
            type: "INDICATEUR_DU_TABLEAU_DE_BORD"
          },
          {
            index: 7,
            libelle: "Mes évaluations",
            type: "MES_EVALUATIONS"
          },
          {
            index: 8,
            libelle: "Zone de texte",
            type: "TEXT"
          }
        ]
      }
    })
    .constant('GENERAL_TASK_SORTS', [{
      index: 0,
      libelle: "Titre",
      value: "TITLE"
    },
    {
      index: 1,
      libelle: "Date de création",
      value: "CREATION"
    },
    {
      index: 3,
      libelle: "Responsable",
      value: "RESPONSABLE"
    },
    {
      index: 2,
      libelle: "Echéance",
      value: "ECHEANCE"
    }
    ])
    .constant('PHARMACIES_CATEGORIES', [{
      title: 'Toutes les pharmacies',
      name: 'all',
      index: 0
    },
    {
      title: 'LQO',
      name: 'lqo',
      index: 1
    },
    {
      title: 'LQO découverte',
      name: 'lqo-mini',
      index: 2
    },
    {
      title: 'Non-LQO',
      name: 'non-lqo',
      index: 3
    }
    ])
    .constant('CATEGORIES_EQUIPES', [{
      title: 'Planning',
      icon: 'planning.svg',
      name: 'planning-general',
      index: 0
    },
    //{
    //  title: 'Tâches générales',
    //  icon: 'icon-checkbox-multiple-blank',
    //  name: 'taches-generales',
    //  index: 4
    //},
    {
      title: 'Réunions',
      icon: 'reunions.svg',
      name: 'reunions',
      index: 1
    },
    {
      title: 'Gestion des collaborateurs',
      icon: 'gestioncol.svg',
      name: 'equipe',
      index: 2
    },
      //{
      //  title: 'Fiches de poste',
      //  icon: 'icon-document',
      //  name: 'fiches-poste',
      //  index: 1
      //}
    ])
    .constant('MAL_FICHES_CATEGORIES', [{
      title: 'Dysfonctionnements',
      icon: 'dysfonc.svg',
      name: 'malfunctions',
      index: 0
    },
    {
      title: 'Fiches de progrès',
      icon: 'fichier.svg',
      name: 'fiches-progres',
      index: 1
    },
    {
      title: 'Appels aux médecins',
      icon: 'appels.svg',
      name: 'appel-medecins',
      index: 2
    },
    {
      title: 'Autres traçabilités',
      icon: 'auto-evaluation.svg',
      name: 'controle.trace',
      index: 3
    }
    ])
    .constant('EVAL_FOURNISSEURS_STOCKS', [{
      name: "Moins d'un mois",
      id: "LESS1MONTH"
    },
    {
      name: "Entre 1 et 2 mois",
      id: "LESS2MONTHS"
    },
    {
      name: "Entre 2 et 3 mois",
      id: "LESS3MONTHS"
    },
    {
      name: "Entre 3 et 5 mois",
      id: "LESS5MONTHS"
    },
    {
      name: "Plus de 5 mois",
      id: "MORE5MONTHS"
    },
    ])
    .constant('EVAL_FOURNISSEURS_TYPES', [{
      name: "Laboratoire",
      id: "LAB"
    },
    {
      name: "Prestataire de services",
      id: "SERVICE"
    }
    ])
    .constant('PLAN_STRAT_CATEGORIES', [{
      title: "Stratégie",
      risks: [{
        title: "Baisse des prix des médicaments",
        exposition: "normal",
        selected: false,
        idEnum: 1,
        moyens: "Projet d'entreprise / Amélioration de la qualité\nSpécialisation/Diversification / Anticipation"
      },
      {
        title: "Ouverture à la concurrence",
        exposition: "normal",
        selected: false,
        idEnum: 2,
        moyens: "Projet d'entreprise / Améliorer la qualité\nSpécialisation/diversification /Anticipation"
      },
      {
        title: "Difficulté de trésorerie",
        exposition: "normal",
        selected: false,
        idEnum: 3,
        moyens: "Boxs / relation banquier anticipée"
      },
      {
        title: "Perte d'un client stratégique",
        exposition: "normal",
        selected: false,
        idEnum: 4,
        moyens: "Diversification - stratégie\nSatisfaction clients"
      },
      {
        title: "Départ-retraite d'un médecin",
        exposition: "normal",
        selected: false,
        idEnum: 5,
        moyens: "Projet d'entreprise / rencontre avec la mairie, l'ordre / projet maison médicale"
      },
      {
        title: "Installation d'un concurrent à proximité",
        exposition: "normal",
        selected: false,
        idEnum: 6,
        moyens: "Valorisation démarche ISO / spécialisation des services / projet d'entreprise"
      }
      ]
    },
    {
      title: "RH",
      risks: [{
        title: "Absence non prévisible d’un salarié",
        exposition: "normal",
        selected: false,
        idEnum: 7,
        moyens: "Démarche ISO 9001 : harmonisation des méthodes de travail / Gestion des agendas"
      },
      {
        title: "Malversation d’un membre de l'équipe",
        exposition: "normal",
        selected: false,
        idEnum: 8,
        moyens: "Contrôles comptabilité"
      },
      {
        title: "Démission d’un salarié",
        exposition: "normal",
        selected: false,
        idEnum: 9,
        moyens: "Communication/Entretien annuel / Plan de carrière /Formation/Rémunération / Management"
      },
      {
        title: "Mésentente entre associés",
        exposition: "normal",
        selected: false,
        idEnum: 10,
        moyens: "Communication permanente / Réunions d'associés\nRèglement intérieur"
      },
      {
        title: "Accident de travail",
        exposition: "normal",
        selected: false,
        idEnum: 11,
        moyens: "Document unique des risques professionnels\nPlan d'action / Assurances"
      },
      {
        title: "Vol (interne)",
        exposition: "normal",
        selected: false,
        idEnum: 12,
        moyens: "Vidéosurveillance, analyse des erreurs de stocks"
      },
      {
        title: "Sabotage",
        exposition: "normal",
        selected: false,
        idEnum: 51,
        moyens: "Gestion des mots de passe et code d'accès en cas de départ d'un salarié"
      },
      {
        title: "Conflit avec un salarié",
        exposition: "normal",
        selected: false,
        idEnum: 13,
        moyens: "Communication/Management"
      },
      {
        title: "Mésentente au sein de l'équipe",
        exposition: "normal",
        selected: false,
        idEnum: 14,
        moyens: "Réunions d'équipe / Ecoute Titulaire"
      },
      {
        title: "Absence de formation de l'équipe",
        exposition: "normal",
        selected: false,
        idEnum: 15,
        moyens: "Réunion d'équipe/ entretiens annuels/ plan de formation"
      }
      ]
    },
    {
      title: "Informatique",
      risks: [{
        title: "Virus",
        exposition: "normal",
        selected: false,
        idEnum: 16,
        moyens: "Antivirus / mises à jour régulières"
      },
      {
        title: "Vol de données, piratage",
        exposition: "normal",
        selected: false,
        idEnum: 17,
        moyens: "Cryptage des données / Sécurité des locaux / Code d'accès"
      },
      {
        title: "Panne téléphonie",
        exposition: "normal",
        selected: false,
        idEnum: 18,
        moyens: "Entretien /Maintenance / Contrat dépannage rapide"
      },
      {
        title: "Panne matériel informatique",
        exposition: "normal",
        selected: false,
        idEnum: 19,
        moyens: "Entretien /Maintenance / Contrat dépannage rapide"
      },
      {
        title: "Panne internet",
        exposition: "normal",
        selected: false,
        idEnum: 20,
        moyens: "Entretien /Maintenance / Contrat dépannage rapide"
      },
      {
        title: "Perte de données informatiques",
        exposition: "normal",
        selected: false,
        idEnum: 21,
        moyens: "Sauvegarde protégée et Entretien du matériel"
      }
      ]
    },
    {
      title: "Matériels - infrastructures",
      risks: [{
        title: "Panne robot ou automate",
        exposition: "normal",
        selected: false,
        idEnum: 22,
        moyens: "Entretien /Maintenance / Contrat dépannage rapide"
      },
      {
        title: "Panne Frigo",
        exposition: "normal",
        selected: false,
        idEnum: 23,
        moyens: "Vérification quotidienne, dispositif d'alarme (SMS…), raccordement électrique direct…"
      },
      {
        title: "Perte du bail ",
        exposition: "normal",
        selected: false,
        idEnum: 24,
        moyens: "Transfert anticipé / recherche de local / achat des murs / rencontre anticipée avec le bailleur"
      },
      {
        title: "Cambriolage",
        exposition: "normal",
        selected: false,
        idEnum: 25,
        moyens: "Alarme / Coffre-fort scellé"
      },
      {
        title: "Incendie",
        exposition: "normal",
        selected: false,
        idEnum: 26,
        moyens: "Vérifications réglementaires électricité, extincteurs…Détecteurs de fumée / Coffre inifugé"
      },
      {
        title: "Catastrophe naturelle (inondation, séisme…)",
        exposition: "normal",
        selected: false,
        idEnum: 27,
        moyens: "Alerte météo / Dispositif de protection / Rangement adapté"
      },
      {
        title: "Sinistre (dégât des eaux, humidité…)",
        exposition: "normal",
        selected: false,
        idEnum: 28,
        moyens: "Alerte météo / Dispositif de protection / Rangement adapté"
      },
      {
        title: "Amende suite à non-conformité réglementaire",
        exposition: "normal",
        selected: false,
        idEnum: 29,
        moyens: "Vérification annuelle des contrôles réglementaires"
      }
      ]
    },
    {
      title: "Métier",
      risks: [{
        title: "Accident client dans l'espace de vente (enfants…)",
        exposition: "normal",
        selected: false,
        idEnum: 30,
        moyens: "Contrôles obligatoires à jour / procédure 1er secours / aménagement espace de vente"
      },
      {
        title: "Urgence santé d'un client (malaise etc…)",
        exposition: "normal",
        selected: false,
        idEnum: 31,
        moyens: "Procédure 1ers secours, affichage des numéros d'urgence"
      },
      {
        title: "Incivilités des clients",
        exposition: "normal",
        selected: false,
        idEnum: 32,
        moyens: "DU / vidéosurveillance enregistrée / formation des collaborateurs"
      },
      {
        title: "Agression par les clients",
        exposition: "normal",
        selected: false,
        idEnum: 33,
        moyens: "DU / alarme avec appel vers un centre"
      },
      {
        title: "Vols par les clients",
        exposition: "normal",
        selected: false,
        idEnum: 34,
        moyens: "Sécurité des accès aux locaux / Signalement\nConsignes de sécurité / Formation à la gestion des situations difficiles"
      },
      {
        title: "Erreurs grave de dispensation",
        exposition: "normal",
        selected: false,
        idEnum: 35,
        moyens: "Procédure de délivrance / double contrôle"
      },
      {
        title: "Ordonnance falsifiée",
        exposition: "normal",
        selected: false,
        idEnum: 36,
        moyens: "Alerte Ordre des pharmaciens"
      },
      {
        title: "Utilisation frauduleuse des produits",
        exposition: "normal",
        selected: false,
        idEnum: 37,
        moyens: "Vigilance au comptoir"
      },
      {
        title: "Mauvaise utilisation des produits-médicaments",
        exposition: "normal",
        selected: false,
        idEnum: 38,
        moyens: "Dialogues patients -  procédures"
      },
      {
        title: "Délivrance de produits retirés (cf.retrait de lot)",
        exposition: "normal",
        selected: false,
        idEnum: 39,
        moyens: "Gestion réactive des alertes"
      },
      {
        title: "Erreurs grave de préparation",
        exposition: "normal",
        selected: false,
        idEnum: 40,
        moyens: "Procédure Préparation / Evaluation pharmaceutique "
      },
      {
        title: "Erreurs grave de prescription",
        exposition: "normal",
        selected: false,
        idEnum: 41,
        moyens: "Procédure de délivrance / contact prescripteur"
      },
      {
        title: "Mauvaise relation médecins",
        exposition: "normal",
        selected: false,
        idEnum: 42,
        moyens: "Réunions interprofessionnelles / participation à des réseaux"
      },
      {
        title: "Mauvaise relation infirmières",
        exposition: "normal",
        selected: false,
        idEnum: 43,
        moyens: "Réunions interprofessionnelles / participation à des réseaux"
      },
      {
        title: "Sanction ordinale, civile, pénale",
        exposition: "normal",
        selected: false,
        idEnum: 44,
        moyens: "Suivi des rapports d'inspection / veille réglementaire"
      },
      {
        title: "Erreur significative de facturation laboratoire",
        exposition: "normal",
        selected: false,
        idEnum: 45,
        moyens: "Contrôle à réception"
      },
      {
        title: "Erreur grave de rangement produit (froid…)",
        exposition: "normal",
        selected: false,
        idEnum: 46,
        moyens: "Procédure de froid connue et respectée"
      },
      {
        title: "Produits manquants",
        exposition: "normal",
        selected: false,
        idEnum: 47,
        moyens: "Contrôle analytique des stocks"
      },
      {
        title: "Sur-stockage",
        exposition: "normal",
        selected: false,
        idEnum: 48,
        moyens: "Contrôle analytique des stocks"
      },
      {
        title: "Impayés clients",
        exposition: "normal",
        selected: false,
        idEnum: 49,
        moyens: "Vérification régulière - planification des tâches"
      },
      {
        title: "Impayés Organismes payeurs",
        exposition: "normal",
        selected: false,
        idEnum: 50,
        moyens: "Vérification régulière - planification des tâches"
      }
      ]
    }
    ])
    .constant('PLAN_STRAT_EXPOSITIONS', [{
      value: "LOW",
      title: "Exposition faible"
    },
    {
      value: "NORMAL",
      title: "Exposition normale"
    },
    {
      value: "STRONG",
      title: "Exposition forte"
    }
    ])
    .constant('REVUE_DIRECTION_SORTS', [{
      index: 0,
      libelle: "Titre",
      value: "TITLE"
    },
    {
      index: 1,
      libelle: "Date",
      value: "CREATION"
    },
    {
      index: 1,
      libelle: "Catégorie",
      value: "CATEGORY"
    },
    {
      index: 1,
      libelle: "Responsable",
      value: "RESPONSABLE"
    }
    ])
    .constant('TABLEAU_BORD_PERIODS', {
      MONTHLY: "mensuel",
      QUARTERLY: "trimestriel",
      ANNUAL: "annuel"
    })
    .constant('PERFORMANCES_CATEGORIES', [

      {
        title: 'Plan stratégique',
        icon: 'plastrat.svg',
        name: 'plan-strategique',
        index: 2
      },
      {
        title: 'Satisfaction client',
        icon: 'satisfaction.svg',
        name: 'satisfaction-client',
        index: 4
      },
      {
        title: 'Tableau de bord',
        icon: 'tdb.svg',
        name: 'tableau-de-bord',
        index: 0
      },
      {
        title: 'Suivi fournisseurs',
        icon: 'evaluatio.svg',
        name: 'evaluation-fournisseurs',
        index: 1
      },
      {
        title: 'Bilan de performances',
        icon: 'rdd.svg',
        name: 'bilan-de-performances',
        index: 3
      }
    ])
    .constant('BANDEAU_DURATIONS', [{
      name: "1 jour",
      value: 86400000
    },
    {
      name: "2 jours",
      value: 172800000
    },
    {
      name: "1 semaine",
      value: 604800000
    },
    {
      name: "2 semaines",
      value: 1209600000
    },
    {
      name: "1 mois",
      value: 2629746000
    }
    ])
    .constant('BANDEAU_CUSTOM_DURATIONS', [{
      name: "jours",
      value: 86400000
    },
    {
      name: "semaines",
      value: 604800000
    },
    {
      name: "mois",
      value: 2629746000
    }
    ])
    .constant('NOTES_INTERNES_CATEGORIES', {
      malfunctions: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      documents: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      tasks: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      actions: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      indicators: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      evaluations: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      reports: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      satisfaction: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      },
      audit: {
        show: false,
        loaded: false,
        allLoaded: false,
        checked: false,
        elements: []
      }
    })
    .constant('NOTIFICATION_TYPES', {
      DOCUMENT: '/folders',
      PLAN_STRAT: '/plan-strategique',
      FOLDER: '/folders',
      TASK: '/planning-general',
      CALL: '/appel-medecins',
      COLLAB: '/equipe-collab',
      EVENT: '/planning-general',
      INDICATOR: '/tableau-de-bord',
      AUTO_EVAL: '/auto-evaluation',
      FICHE_POSTE: '/equipe-collab',
      SATISFACTION: '/satisfaction-client',
      INTERNAL_NOTE: '/communication-interne/notes-internes',
      REUNION: '/reunions',
      AUDIT: '/audit',
      SUPPLIER: '/evaluation-fournisseurs'
    })
    .constant('NOTES_INTERNES_PAGES', {
      documents: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      malfunctions: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      tasks: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      indicators: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      evaluations: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      satisfaction: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      reports: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      },
      actions: {
        page: 0,
        nbrResults: 10,
        loadedPages: []
      }
    })
    .constant('LIMIT_NBR_INFO_FRONT_PAGE', 3)
    .constant('QUALITE_CATEGORIES', [{
      title: 'Auto évaluation',
      icon: 'auto-evaluation.svg',
      name: 'auto-evaluation',
      index: 2
    },
    {
      title: 'Mise en œuvre de la démarche',
      icon: 'taches.svg',
      name: 'demarche',
      index: 4
    },
    {
      title: 'Audit',
      icon: 'audit.svg',
      name: 'audit',
      index: 3
    },
    {
      title: 'Communication interne',
      icon: 'com.svg',
      name: 'communication-interne',
      index: 0
    },
    {
      title: 'Auto-contrôles qualité',
      icon: 'auto-controle-qualite.svg',
      name: 'auto-controles',
      index: 1
    }
    ])
    .constant('CONTROLE_CATEGORIES', [{
      title: 'Traçabilité',
      icon: 'auto-evaluation.svg',
      name: 'trace',
      index: 0
    }])
    .constant('TASKS_EVENTS_REMINDERS', [{
      name: 'Le jour même',
      value: 0
    },
    {
      name: '1 jour avant',
      value: 86400000
    },
    {
      name: '1 semaine avant',
      value: 604800000
    },
    {
      name: '1 mois avant',
      value: 2629746000
    }
    ]).constant('STATUT_DOCS', {
      WAITING: 'En attente de validation',
      VALIDATED: 'Validé'
    })
    .constant('MONTHS', [{
      name: 'Janvier',
      value: 0
    },
    {
      name: 'Février',
      value: 1
    },
    {
      name: 'Mars',
      value: 2
    },
    {
      name: 'Avril',
      value: 3
    },
    {
      name: 'Mai',
      value: 4
    },
    {
      name: 'Juin',
      value: 5
    },
    {
      name: 'Juillet',
      value: 6
    },
    {
      name: 'Août',
      value: 7
    },
    {
      name: 'Septembre',
      value: 8
    },
    {
      name: 'Octobre',
      value: 9
    },
    {
      name: 'Novembre',
      value: 10
    },
    {
      name: 'Décembre',
      value: 11
    }
    ])
    .constant('MONTHS_REUNION', [{
      name: 'Janvier',
      value: 0
    },
    {
      name: 'Février',
      value: 1
    },
    {
      name: 'Mars',
      value: 2
    },
    {
      name: 'Avril',
      value: 3
    },
    {
      name: 'Mai',
      value: 4
    },
    {
      name: 'Juin',
      value: 5
    },
    {
      name: 'Juillet',
      value: 6
    },
    {
      name: 'Août',
      value: 7
    },
    {
      name: 'Septembre',
      value: 8
    },
    {
      name: 'Octobre',
      value: 9
    },
    {
      name: 'Novembre',
      value: 10
    },
    {
      name: 'Décembre',
      value: 11
    },
    {
      name: 'Tous les mois',
      value: 12
    }
    ])
    .constant('TASKS_CATEGORIES_QUALITY', [
      { name: 'Métier dispensation', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_METIER_DISP' },
      { name: 'Métier hors dispensation', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_METIER_HORS_DISP' },
      { name: 'Stratégie et pilotage', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_STRATEGIE' },
      { name: 'Ressources humaines', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_RH' },
      { name: 'Amélioration continue', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_AMELIORATION_CONTINUE' },
      { name: 'Ressources matérielles', value: 'PREMIERE_ANNEE_DEMARCHE_QUALITE_RESSOURCES_MATERIELLES' }
    ])
    .constant('TASKS_DEMARCHE_NBR_SELECTED_MAX', 3)
    .constant('SELECT_HOURS_EVENTS', [{
      "name": "00:00",
      "value": 0
    }, {
      "name": "00:15",
      "value": 900000
    }, {
      "name": "00:30",
      "value": 1800000
    }, {
      "name": "00:45",
      "value": 2700000
    }, {
      "name": "01:00",
      "value": 3600000
    }, {
      "name": "01:15",
      "value": 4500000
    }, {
      "name": "01:30",
      "value": 5400000
    }, {
      "name": "01:45",
      "value": 6300000
    }, {
      "name": "02:00",
      "value": 7200000
    }, {
      "name": "02:15",
      "value": 8100000
    }, {
      "name": "02:30",
      "value": 9000000
    }, {
      "name": "02:45",
      "value": 9900000
    }, {
      "name": "03:00",
      "value": 10800000
    }, {
      "name": "03:15",
      "value": 11700000
    }, {
      "name": "03:30",
      "value": 12600000
    }, {
      "name": "03:45",
      "value": 13500000
    }, {
      "name": "04:00",
      "value": 14400000
    }, {
      "name": "04:15",
      "value": 15300000
    }, {
      "name": "04:30",
      "value": 16200000
    }, {
      "name": "04:45",
      "value": 17100000
    }, {
      "name": "05:00",
      "value": 18000000
    }, {
      "name": "05:15",
      "value": 18900000
    }, {
      "name": "05:30",
      "value": 19800000
    }, {
      "name": "05:45",
      "value": 20700000
    }, {
      "name": "06:00",
      "value": 21600000
    }, {
      "name": "06:15",
      "value": 22500000
    }, {
      "name": "06:30",
      "value": 23400000
    }, {
      "name": "06:45",
      "value": 24300000
    }, {
      "name": "07:00",
      "value": 25200000
    }, {
      "name": "07:15",
      "value": 26100000
    }, {
      "name": "07:30",
      "value": 27000000
    }, {
      "name": "07:45",
      "value": 27900000
    }, {
      "name": "08:00",
      "value": 28800000
    }, {
      "name": "08:15",
      "value": 29700000
    }, {
      "name": "08:30",
      "value": 30600000
    }, {
      "name": "08:45",
      "value": 31500000
    }, {
      "name": "09:00",
      "value": 32400000
    }, {
      "name": "09:15",
      "value": 33300000
    }, {
      "name": "09:30",
      "value": 34200000
    }, {
      "name": "09:45",
      "value": 35100000
    }, {
      "name": "10:00",
      "value": 36000000,
      "default": true
    }, {
      "name": "10:15",
      "value": 36900000
    }, {
      "name": "10:30",
      "value": 37800000
    }, {
      "name": "10:45",
      "value": 38700000
    }, {
      "name": "11:00",
      "value": 39600000
    }, {
      "name": "11:15",
      "value": 40500000
    }, {
      "name": "11:30",
      "value": 41400000
    }, {
      "name": "11:45",
      "value": 42300000
    }, {
      "name": "12:00",
      "value": 43200000
    }, {
      "name": "12:15",
      "value": 44100000
    }, {
      "name": "12:30",
      "value": 45000000
    }, {
      "name": "12:45",
      "value": 45900000
    }, {
      "name": "13:00",
      "value": 46800000
    }, {
      "name": "13:15",
      "value": 47700000
    }, {
      "name": "13:30",
      "value": 48600000
    }, {
      "name": "13:45",
      "value": 49500000
    }, {
      "name": "14:00",
      "value": 50400000
    }, {
      "name": "14:15",
      "value": 51300000
    }, {
      "name": "14:30",
      "value": 52200000
    }, {
      "name": "14:45",
      "value": 53100000
    }, {
      "name": "15:00",
      "value": 54000000
    }, {
      "name": "15:15",
      "value": 54900000
    }, {
      "name": "15:30",
      "value": 55800000
    }, {
      "name": "15:45",
      "value": 56700000
    }, {
      "name": "16:00",
      "value": 57600000
    }, {
      "name": "16:15",
      "value": 58500000
    }, {
      "name": "16:30",
      "value": 59400000
    }, {
      "name": "16:45",
      "value": 60300000
    }, {
      "name": "17:00",
      "value": 61200000
    }, {
      "name": "17:15",
      "value": 62100000
    }, {
      "name": "17:30",
      "value": 63000000
    }, {
      "name": "17:45",
      "value": 63900000
    }, {
      "name": "18:00",
      "value": 64800000
    }, {
      "name": "18:15",
      "value": 65700000
    }, {
      "name": "18:30",
      "value": 66600000
    }, {
      "name": "18:45",
      "value": 67500000
    }, {
      "name": "19:00",
      "value": 68400000
    }, {
      "name": "19:15",
      "value": 69300000
    }, {
      "name": "19:30",
      "value": 70200000
    }, {
      "name": "19:45",
      "value": 71100000
    }, {
      "name": "20:00",
      "value": 72000000
    }, {
      "name": "20:15",
      "value": 72900000
    }, {
      "name": "20:30",
      "value": 73800000
    }, {
      "name": "20:45",
      "value": 74700000
    }, {
      "name": "21:00",
      "value": 75600000
    }, {
      "name": "21:15",
      "value": 76500000
    }, {
      "name": "21:30",
      "value": 77400000
    }, {
      "name": "21:45",
      "value": 78300000
    }, {
      "name": "22:00",
      "value": 79200000
    }, {
      "name": "22:15",
      "value": 80100000
    }, {
      "name": "22:30",
      "value": 81000000
    }, {
      "name": "22:45",
      "value": 81900000
    }, {
      "name": "23:00",
      "value": 82800000
    }, {
      "name": "23:15",
      "value": 83700000
    }, {
      "name": "23:30",
      "value": 84600000
    }, {
      "name": "23:45",
      "value": 85500000
    }]);
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config($mdDateLocaleProvider, ngQuillConfigProvider) {
    // Put your common app configurations here
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : '';
    };
    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      return m.isValid() ? m.toDate() : new Date();
    };
    $mdDateLocaleProvider.firstDayOfWeek = 1;


    var FontAttributor = Quill.import('attributors/class/font');
    FontAttributor.whitelist = [
      'roboto'
    ];



    Quill.register(FontAttributor, true);

    var toolbarOptions = [
      ['bold', 'italic', 'strike'],
      [{ 'header': 1 }, 'blockquote', { 'list': 'bullet' }, { 'list': 'ordered' }],
      ['undo', 'redo']
    ];

    ngQuillConfigProvider.set({
      bounds: 'self',
      placeholder: '',
      modules: {
        toolbar: {
          container: toolbarOptions,
          handlers: {
            undo: function (value) {
              this.quill.history.undo();
            },
            redo: function (value) {
              this.quill.history.redo();
            }
          }
        },
        history: {
          delay: 2000,
          maxStack: 500,
          userOnly: true
        }
      }
    });

  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {

      var api = {};

      // Base Url
      api.baseUrl = 'app/data/';

      // api.sample = $resource(api.baseUrl + 'sample/sample.json');

      api._history = function() {
         window.history.back();
      };

      api._timestampToDate = function (_timestamp) {
         var _result = angular.copy(_timestamp);
         return new Date(_result);
      };

      api._dateToTimestamp = function (_date) {
         var _result = angular.copy(_date);
         return _result.getTime();
      }; 

      return api;
    }

})();
(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('shareMalfunction', {
      url: '/shareMalfunction/:token',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@shareMalfunction': {
          templateUrl: 'app/main/public/shareMalfunction/shareMalfunction.html',
          controller: 'ShareMalfunctionController as vm'
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('questionnaire_satisfaction_2026', {
        url: '/questionnaire-satisfaction-2026/:identifier?source',
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/content-only.html',
            controller: 'MainController as vm'
          },
          'content@questionnaire_satisfaction_2026': {
            templateUrl: 'app/main/public/questionnaireSatisfaction/questionnaireSatisfaction.html',
            controller: 'QuestionnaireSatisfactionController as vm'
          }
        }
      })
      .state('questionnaire_satisfaction_2026_sms_short', {
        url: '/q/{shortIdentifier:[A-Za-z0-9]{5,6}}',
        params: {
          source: 'SMS'
        },
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/content-only.html',
            controller: 'MainController as vm'
          },
          'content@questionnaire_satisfaction_2026_sms_short': {
            templateUrl: 'app/main/public/questionnaireSatisfaction/questionnaireSatisfaction.html',
            controller: 'QuestionnaireSatisfactionController as vm'
          }
        }
      })
      .state('questionnaire_satisfaction_2026_short', {
        url: '/q/:identifier?source',
        views: {
          'main@': {
            templateUrl: 'app/core/layouts/content-only.html',
            controller: 'MainController as vm'
          },
          'content@questionnaire_satisfaction_2026_short': {
            templateUrl: 'app/main/public/questionnaireSatisfaction/questionnaireSatisfaction.html',
            controller: 'QuestionnaireSatisfactionController as vm'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('legal_mentions', {
        url: '/legal_mentions',
        views: {
          'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
          'content@legal_mentions': {
            templateUrl: 'app/main/public/legalMentions/legal_mentions.html',
            controller: 'LegalMentionsController as vm'
          }
        }
      });
  }

})();

(function () {
	'use strict';

	angular.module('app.front').config(config);

	/**
	 * PHSQ-240 — module Triage OSyS (officine).
	 *
	 * ⚠️ `data.permissions` est redéclaré sur CHAQUE état : ui-router 0.3.2 hérite de `data`, et
	 * un état oublié prendrait les permissions de son parent (celles de `app`, ouvertes à tous).
	 * La recherche de « Mes triages » reste dans le contrôleur, jamais dans l'URL (données patient).
	 *
	 * @ngInject
	 */
	function config($stateProvider) {
		var PERMISSIONS_OSYS = ['OSYS_TRIAGE'];

		$stateProvider
			.state('app.osys', {
				abstract: true,
				url: '/triage-osys',
				data: { permissions: PERMISSIONS_OSYS }
			})
			.state('app.osys.mesTriages', {
				url: '/',
				data: { permissions: PERMISSIONS_OSYS },
				params: { suivi: null },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/triage-osys/mes-triages/mes-triages.html',
						controller: 'OsysMesTriagesController as vm'
					}
				}
			})
			.state('app.osys.nouveau', {
				// `?etape=patient` : « Précédent » du navigateur revient de B2 à B1 sans quitter le parcours (§3.6).
				url: '/nouveau?etape',
				reloadOnSearch: false,
				data: { permissions: PERMISSIONS_OSYS },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/triage-osys/triage/nouveau.html',
						controller: 'OsysNouveauController as vm'
					}
				}
			})
			.state('app.osys.triage', {
				url: '/triages/:id',
				data: { permissions: PERMISSIONS_OSYS },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/triage-osys/triage/triage.html',
						controller: 'OsysTriageController as vm'
					}
				}
			})
			.state('app.osys.fin', {
				url: '/triages/:id/fin',
				data: { permissions: PERMISSIONS_OSYS },
				// `valide` : arrivée juste après la validation ; sinon, écran rouvert (M15).
				params: { valide: null },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/triage-osys/triage/fin.html',
						controller: 'OsysFinController as vm'
					}
				}
			});
	}
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.qualite.summary', {
                url: '/qualite',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/qualite.html',
                        controller: 'QualiteController as vm'
                    }
                }
            })

            .state('app.qualite', {
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/qualite.html',
                        controller: 'QualiteController as vm'
                    }
                }
            })

            .state('app.qualite.auto-controles', {
                url: '/auto-controles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/auto-controles/autoControles.html',
                        controller: 'AutoControlesController'
                    }
                }
            })

            .state('app.qualite.auto-controles.flashs', {
                url: '/flashs',
                params: {
                    autoCtrlID: null,
                    titleAutoCtrl: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/auto-controles/flashs.html',
                        controller: 'FlashsController'
                    }
                }
            })

            .state('app.qualite.auto-controles.flash', {
                url: '/flash',
                params: {
                    autoCtrlID: null,
                    titleAutoCtrl: null,
                    flashID: null,
                    titleFlash: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/auto-controles/flash.html',
                        controller: 'FlashController'
                    }
                }
            })

            .state('app.qualite.communication-interne', {
                url: '/communication-interne',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/communication-interne.html',
                        controller: 'CommunicationInterneController'
                    }
                }
            })

            .state('app.qualite.communication-interne.notes-internes', {
                url: '/notes-internes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/notes-internes.html',
                        controller: 'NotesInternesController'
                    }
                }
            })

            .state('app.qualite.communication-interne.administration-bandeau', {
                url: '/administration-bandeau',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/administration-bandeau.html',
                        controller: 'AdministrationBandeauController'
                    }
                }
            })

            .state('app.qualite.communication-interne.administration-bandeau.historique', {
                url: '/historique',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/administration-bandeau/history_bandeaux.html',
                        controller: 'HistoryBandeauxController'
                    }
                }
            })

            .state('app.qualite.communication-interne.notes-internes.add', {
                url: '/add',
                params: {
                    note: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/add-note-interne.html',
                        controller: 'AddNoteInterneController'
                    }
                }
            })

            .state('app.qualite.communication-interne.notes-internes.display', {
                url: '/display/{id}',
                params: {
                    note: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/communication-interne/notes-internes/display-note-interne.html',
                        controller: 'DisplayNoteInterneController'
                    }
                }
            })
            .state('app.qualite.auto-evaluation', {
                url: '/auto-evaluation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/auto-evaluation/auto-evaluation.html',
                        controller: 'AutoEvaluationController'
                    }
                }
            })
            .state('app.qualite.planning', {
                url: '/planning',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/planning-general/planning-general.html',
                        controller: 'PlanningGeneralController'
                    }
                }
            })
            .state('app.qualite.audit', {
                url: '/audit',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/audit/audit.html',
                        controller: 'AuditController'
                    }
                }
            })
            .state('app.qualite.demarche', {
                url: '/demarche',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/demarche/demarche.html',
                        controller: 'DemarcheController'
                    }
                }
            })
            .state('app.qualite.demarche.selection', {
                url: '/selection_tasks',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/qualite/demarche/selectionTasks/selectionTasks.html',
                        controller: 'DemarcheSelectionTasksController'
                    }
                }
            });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.front')
		.config(config).directive('equalsTo', [function () {
			/*
			* <input type="password" ng-model="Password" />
			* <input type="password" ng-model="ConfirmPassword" equals-to="Password" />
			*/
			return {
				restrict: 'A', // S'utilise uniquement en tant qu'attribut
				scope: true,
				require: 'ngModel',
				link: function (scope, elem, attrs, control) {
					var check = function () {
					//Valeur du champs courant 
					var v1 = scope.$eval(attrs.ngModel); // attrs.ngModel = "ConfirmPassword"
					//valeur du champ à comparer
					var v2 = null;
					if(scope.$eval(attrs.equalsTo)){
						v2 = scope.$eval(attrs.equalsTo).$viewValue; // attrs.equalsTo = "Password"
					}else{
						return;
					}
					return v1 == v2;
				};
	 
				scope.$watch(check, function (isValid) {
					// Défini si le champ est valide
					control.$setValidity("equalsTo", isValid);
				});
			}
		};}]);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.profile', {
			url: '/profile',
			views: {
				'content@app': {
					templateUrl: 'app/main/front/profile/profile.html',
					controller: 'ProfileController as vm'
				}
			}
		});


	}

})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.performances.summary', {
                url: '/performances',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/performances.html',
                        controller: 'PerformancesController as vm'
                    }
                }
            })

            .state('app.performances', {
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/performances.html',
                        controller: 'PerformancesController as vm'
                    }
                }
            })





            .state('app.performances.plan-strategique.add', {
                url: '/add/:id/:step?',
                params: {
                    plan: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/plan-strategique/plan-strategique.html',
                        controller: 'PlanStrategiqueController'
                    }
                },
            })

            .state('app.performances.plan-strategique.display', {
                url: '/display/:planID/:display?',
                params: {
                    plan: null,
                    rddParams: null,
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/plan-strategique/display-plan-strategique.html',
                        controller: 'DisplayPlanStrategiqueController'
                    }
                },
            })

            .state('app.performances.plan-strategique', {
                url: '/plan-strategique',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/plan-strategique/list-plans-strategiques.html',
                        controller: 'ListPlansStrategiquesController'
                    }
                }
            })

            .state('app.performances.mes-evaluations', {
                url: '/mes-evaluations?tab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/mes-evaluations/satisfaction-client.html',
                        controller: 'SatisfactionClientController'
                    }
                }
            })

            .state('app.performances.mes-evaluations.flashs', {
                url: '/flashs',
                params: {
                    autoCtrlID: null,
                    titleAutoCtrl: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/mes-evaluations/flashs.html',
                        controller: 'FlashsController'
                    }
                }
            })

            .state('app.performances.mes-evaluations.flash', {
                url: '/flash',
                params: {
                    autoCtrlID: null,
                    titleAutoCtrl: null,
                    flashID: null,
                    titleFlash: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/mes-evaluations/flash.html',
                        controller: 'FlashController'
                    }
                }
            })

            .state('app.performances.tableau-de-bord', {
                url: '/tableau-de-bord',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/tableau-de-bord/tableau-de-bord.html',
                        controller: 'TableauDeBordController'
                    }
                }
            })

            .state('app.performances.graphs', {
                url: '/graphs',
                params: {
                    indicateurs: null,
                    year: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/tableau-de-bord/page-graphs.html',
                        controller: 'GraphsController'
                    }
                }
            })

            .state('app.performances.tableau-de-bord.add-indicateur', {
                url: '/add-indicateur',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/tableau-de-bord/page-add-indicateur.html',
                        controller: 'AddIndicateurController as vm'
                    }
                }
            })

            .state('app.performances.evaluation-fournisseurs', {
                url: '/evaluation-fournisseurs',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/evaluation-fournisseurs.html',
                        controller: 'EvaluationFournisseursController'
                    }
                }
            })

            .state('app.performances.evaluation-fournisseurs.details', {
                url: '/:id/details',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/evaluation-fournisseurs/details-evaluation.html',
                        controller: 'EvaluationFournisseursDetailsController'
                    }
                }
            })

            .state('app.performances.bilan-de-performances', {
                url: '/bilan-de-performances',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/revue-de-direction/list-revue-de-direction.html',
                        controller: 'ListRevueDeDirectionController'
                    }
                }
            })



            .state('app.performances.bilan-de-performances.add', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/revue-de-direction/revue-de-direction.html',
                        controller: 'RevueDeDirectionController'
                    }
                },
            })


            .state('app.performances.bilan-de-performances.details-category', {
                url: '/details/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/performances/revue-de-direction/revue-de-direction-details.html',
                        controller: 'RevueDeDirectionDetailsController'
                    }
                },
                params: {
                    category: null,
                    managementReview: null
                }
            })

    }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('app.help', {
        url: '/help',
        views: {
          'content@app': {
            templateUrl: 'app/main/front/other/help.html',
            controller: 'HelpController'
          }
        }
      });

    $stateProvider
      .state('app.contact', {
        url: '/contact',
        views: {
          'content@app': {
            templateUrl: 'app/main/front/other/contact.html'
          }
        }
      })
      .state('app.decouvrirLqo', {
        url: '/decouvrir-lqo',
        views: {
          'content@app': {
            templateUrl: 'app/main/front/other/decouvrir-lqo.html',
            controller: 'DecouvrirLqoController'
          }
        }
      });
  }

})();

(function () {
	'use strict';

	angular.module('app.front').config(config);

	/**
	 * Espace officine — « Mon officine » (chantier PHSQ-220).
	 *
	 * Un ACCUEIL À TUILES (`app.officine`) et sept SOUS-PAGES, chacune avec sa propre adresse et son
	 * fil d'Ariane « Mon officine › … » (spécification sortie-qualite § 8.1, contrat § 5). Chaque
	 * sous-page remplace la vue `content@app` de l'accueil : elle se charge seule, rappelle le back
	 * à chaque ouverture (R2) et porte ses propres états d'erreur.
	 *
	 * ⚠️ `data.permissions` est déclaré sur CHAQUE état : en ui-router 0.3.2, `data` est hérité de
	 * `app`, et sans déclaration explicite l'état ouvrirait l'écran au PrAQ et à l'équipe
	 * (décision A15). `['OFFICINE']` seul : un administrateur PHSQ n'a pas d'officine (écart E26).
	 *
	 * ⚠️ L'adresse `/mon-officine/sortie` est INCHANGÉE (contrat § 5) : des liens y mènent déjà.
	 */
	/** @ngInject */
	function config($stateProvider) {
		var PERMISSIONS_OFFICINE = ['OFFICINE'];
		var DOSSIER = 'app/main/front/officine/';

		/** Une sous-page : son adresse, son gabarit, son contrôleur, ses paramètres sans adresse. */
		function sousPage(url, gabarit, controleur, params) {
			var etat = {
				url: url,
				data: { permissions: PERMISSIONS_OFFICINE },
				views: {
					'content@app': {
						templateUrl: DOSSIER + gabarit,
						controller: controleur
					}
				}
			};
			if (params) {
				etat.params = params;
			}
			return etat;
		}

		$stateProvider
			.state('app.officine', {
				url: '/mon-officine',
				data: { permissions: PERMISSIONS_OFFICINE },
				// Le message d'un refus rapporté par une sous-page (409) : un paramètre sans adresse,
				// affiché une fois dans un bandeau en tête de l'accueil.
				params: { alerte: null },
				views: {
					'content@app': {
						templateUrl: DOSSIER + 'mon-officine/mon-officine.html',
						controller: 'MonOfficineController'
					}
				}
			})
			.state('app.officine.informations', sousPage('/informations',
				'informations/informations.html', 'OfficineInformationsController'))
			.state('app.officine.contacts', sousPage('/contacts',
				'contacts/contacts.html', 'OfficineContactsController'))
			.state('app.officine.acces', sousPage('/acces',
				'acces/acces.html', 'OfficineAccesController'))
			// `nouvelle` : ouvrir directement le formulaire après un refus (bouton « Déclarer à
			// nouveau » de « Mes demandes »).
			.state('app.officine.sortie', sousPage('/sortie',
				'sortie/declarer-sortie.html', 'DeclarerSortieController', { nouvelle: null }))
			.state('app.officine.sortieQualite', sousPage('/sortie-qualite',
				'sortie-qualite/sortie-qualite.html', 'OfficineSortieQualiteController', { nouvelle: null }))
			// `confirmation` : le message affiché une fois après le dépôt d'une demande.
			.state('app.officine.demandes', sousPage('/demandes',
				'demandes/demandes.html', 'OfficineDemandesController', { confirmation: null }))
			.state('app.officine.contact', sousPage('/contacter-phsq',
				'contact-phsq/contact-phsq.html', 'OfficineContactPhsqController'));
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		// State
		$stateProvider
			.state('app.notifications', {
				url: '/notifications',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/notifications/notifications.html',
						controller: 'NotificationsController as vm'
					}
				}
			});

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	function config($stateProvider) {
		$stateProvider
			.state('app.malfunctions-fiches', {
				url: '/dysfonctionnements_fiches',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/mal_fiches.html',
						controller: 'MalFichesfunctionsController as vm'
					}
				}
			})
			.state('app.malfunctions', {
				url: '/dysfonctionnements?status&tab',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/malfunctions.html',
						controller: 'MalfunctionsController as vm'
					}
				},
				resolve: {
					malfunction: function () {
						return null;
					}
				},
				reloadOnSearch: false
			})
			.state('app.malfunctions.progress_forms_associated', {
				url: '/dysfonctionnements/{id}',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/malfunfunction_progress_forms_associated.html',
						controller: 'MalfunctionsProgressFormsAssociatedController as vm'
					}
				},
				resolve: {
					malfunction: function () {
						return null;
					}
				}
			})
			.state('app.malfunctions.add', {
				url: '/ajout',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/add/add_malfunction.html',
						controller: 'AddMalfunctionController as vm'
					}
				}
			})
			.state('app.malfunctions.update', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/update/update_malfunction.html',
						controller: 'UpdateMalfunctionController as vm'
					}
				}
			})
			.state('app.fiches-progres', {
				url: '/fiches-progres',
				params: {
					actionFromProgressForm: null
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/fiches_progres.html',
						controller: 'FichesProgresController as vm'
					}
				}
			})
			.state('app.malfunctions.add-fiche-progres', {
				url: '/:malfunctionId/fiche-progres/ajout',
				params: {
					editionMode: false
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/add/add_fiche_progres.html',
						controller: 'AddFicheProgresController as vm'
					}
				}
			})
			.state('app.fiches-progres.add-fiche-progres', {
				url: '/:malfunctionId/fiche-progres/ajout',
				params: {
					editionMode: false
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/add/add_fiche_progres.html',
						controller: 'AddFicheProgresController as vm'
					}
				}
			})
			.state('app.fiches-progres.update-fiche-progres', {
				url: '/:malfunctionId/fiche-progres/:ficheProgresId',
				params: {
					editionMode: true
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/add/add_fiche_progres.html',
						controller: 'AddFicheProgresController as vm'
					}
				}
			})

			.state('app.appel-medecins', {
				url: '/appel-medecins',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/malfunctions/appel-medecins/appelMedecins.html',
						controller: 'AppelMedecinsController'
					}
				}
			})
	}

})();
(function () {
	'use strict';

	angular.module('app.front').config(config);

	/**
	 * Espace groupement — « Mes pharmacies » (§3 à §7 de la spécification).
	 *
	 * ⚠️ Les états sont déclarés ICI et non dans `main/front/home/home.module.js`, où vivaient les
	 * anciennes routes « Restitutions » : un espace entier n'a rien à faire dans le module de la
	 * page d'accueil.
	 *
	 * La fiche pharmacie et la fiche d'audit sont de vraies SOUS-PAGES, chacune avec son adresse,
	 * partageable par courriel entre collègues (§1). L'onglet de la fiche est dans l'URL pour la
	 * même raison — l'ancien écran de restitution changeait d'onglet sans changer d'adresse, et
	 * l'on ne pouvait donc pas envoyer un lien vers un onglet précis.
	 */
	/** @ngInject */
	function config($stateProvider) {
		var PERMISSIONS_GROUPEMENT = ['GROUPEMENT', 'ADMINISTRATEUR'];

		$stateProvider
			.state('app.groupement.pharmacies', {
				url: '/pharmacies',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/pharmacies/pharmacies.html',
						controller: 'GroupementPharmaciesController'
					}
				}
			})
			.state('app.groupement.pharmacie', {
				url: '/pharmacies/:reference?tab',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				params: { tab: { value: 'pharmacie', squash: true } },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/pharmacie/fiche-pharmacie.html',
						controller: 'GroupementFichePharmacieController'
					}
				},
				// L'onglet change l'adresse sans recharger le contrôleur : le changement d'onglet
				// doit rester instantané tout en restant partageable.
				reloadOnSearch: false
			})
			.state('app.groupement.audit', {
				url: '/pharmacies/:reference/audits/:auditId',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/audit/fiche-audit.html',
						controller: 'GroupementFicheAuditController'
					}
				}
			})
			.state('app.groupement.autoeval', {
				// ⚠️ L'onglet est DANS L'ADRESSE : un pilote qualité envoie à un collègue le lien
				// de ce qu'il regarde. `reloadOnSearch: false` évite de recharger le contrôleur à
				// chaque changement d'onglet, comme pour la fiche pharmacie.
				// ⚠️ Les FILTRES de l'onglet Pharmacies sont aussi dans l'adresse : recherche,
				// statut, tri et page. C'est ce qui permet au retour depuis le détail d'une officine
				// de retrouver la liste telle qu'elle était (spécification §5), et à un lien partagé
				// d'arriver sur la même vue. `squash: true` : une valeur par défaut n'encombre pas
				// l'adresse.
				url: '/auto-evaluation/:annee?tab&q&statut&compte&tri&sens&page',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				params: {
					tab: { value: 'dashboard', squash: true },
					q: { value: '', squash: true },
					statut: { value: '', squash: true },
					compte: { value: '', squash: true },
					tri: { value: 'alerte', squash: true },
					sens: { value: 'asc', squash: true },
					page: { value: '1', squash: true }
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/auto-evaluation/autoeval-groupement.html',
						controller: 'AutoEvalGroupementController'
					}
				},
				reloadOnSearch: false
			})
			.state('app.groupement.autoeval-pharmacie', {
				url: '/auto-evaluation/:annee/pharmacies/:soumissionId',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/auto-evaluation/autoeval-pharmacie.html',
						controller: 'AutoEvalGroupementPharmacieController'
					}
				}
			})
			.state('app.groupement.audits', {
				url: '/audits',
				data: { permissions: PERMISSIONS_GROUPEMENT },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/groupement/audits/audits.html',
						controller: 'GroupementAuditsController'
					}
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.folders', {
				url: '/folders?waiting',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/folders/folders.html',
						controller: 'FoldersController as vm'
					}
				}
			})
			.state('app.category', {
				url: '/category/{categoryId:int}',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/folders/folder/folder.html',
						controller: 'FolderController'
					}
				}
			})

			.state('app.category.folder', {
				url: '/folder/{subId:int}',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/folders/folder/folder.html',
						controller: 'FolderController'
					}
				}
			})


			.state('app.category.sub', {
				url: '/{subCategoryId:int}',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/folders/folder/folder.html',
						controller: 'FolderController'
					}
				}
			})

			.state('app.category.sub.folder', {
				url: '/folder/{subId:int}',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/folders/folder/folder.html',
						controller: 'FolderController'
					}
				}
			});


	}

})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.equipe.summary', {
                url: '/equipe',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/equipe.html',
                        controller: 'EquipeController as vm'
                    }
                }
            })

            .state('app.equipe', {
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/equipe.html',
                        controller: 'EquipeController as vm'
                    }
                }
            })

            .state('app.equipe.projects', {
                url: '/projets',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/projects/projects.html',
                        controller: 'ProjectsController as vm'
                    }
                }
            })

            .state('app.equipe.projects.details', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/projects/project.html',
                        controller: 'ProjectController as vm'
                    }
                }
            })

            .state('app.equipe.planning-general', {
                url: '/planning-general?filter&tab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/planning-general/planning-general.html',
                        controller: 'PlanningGeneralController',

                    }
                },
                reloadOnSearch: false
            })


            .state('app.equipe.reunions', {
                url: '/reunions?tab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/reunions/reunions.html',
                        controller: 'ReunionsController'
                    }
                }
            })

            .state('app.equipe.reunions.ordre-du-jour', {
                url: '/reunions/:id/ordre-du-jour?subTab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/reunions/ordre-du-jour/ordre-du-jour.html',
                        controller: 'OrdreDuJourController'
                    }
                },
                params: {
                    id: null,
                    fromHome: null
                }
            })

            .state('app.equipe.reunions.compte-rendu', {
                url: '/reunions/:id/compte-rendu?toHome',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/reunions/compte-rendu/compte-rendu.html',
                        controller: 'OrdreDuJourController'
                    }
                },
                params: {
                    id: null
                },
                reloadOnSearch: false
            })

            .state('app.equipe.equipe', {
                url: '/equipe-collab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/equipe/equipe/equipe.html',
                        controller: 'EquipeDetailController'
                    }
                }
            })

    }
})();

(function () {
    'use strict';

    angular
        .module('app.front')
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.controle.summary', {
                url: '/controle',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/controle.html',
                        controller: 'ControleController as vm'
                    }
                }
            })
            .state('app.controle', {
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/controle.html',
                        controller: 'ControleController as vm'
                    }
                }
            })
            .state('app.controle.trace', {
                url: '/trace?tab',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/traces.html',
                        controller: 'TracesController'
                    }
                },
                reloadOnSearch: false
            })
            .state('app.controle.trace.add', {
                url: '/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/trace.html',
                        controller: 'TraceController'
                    }
                },
                reloadOnSearch: false
            })
            .state('app.controle.trace.template', {
                url: '/add/:templateId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/trace.html',
                        controller: 'TraceController'
                    }
                },
                reloadOnSearch: false
            })
            .state('app.controle.trace.update', {
                url: '/update/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/trace.html',
                        controller: 'TraceController'
                    }
                },
                reloadOnSearch: false
            })
            .state('app.controle.trace.subtraces', {
                url: '/{id}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/subtraces/subtraces.html',
                        controller: 'SubtracesController'
                    }
                }
            }).state('app.controle.trace.templates', {
                url: '/templates/{id}',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/front/controle/trace/templates/templates.html',
                        controller: 'TemplatesController'
                    }
                }
            });


    }
})();

(function () {
	'use strict';

	angular.module('app.front').config(config);

	/**
	 * Espace officine de l'auto-évaluation qualité PHSQ (spécification §4).
	 *
	 * Le point d'entrée n'est PAS un item de menu : c'est l'onglet « Auto-évaluation » de
	 * « Mes évaluations », où la directive d'accueil pose la carte de la campagne en cours. Les
	 * écrans ci-dessous sont les pages de travail qu'on atteint depuis cette carte.
	 *
	 * ⚠️ Chaque écran a sa propre adresse, **l'année comprise**. Une officine qui revient sur ses
	 * résultats 2026 depuis un lien doit retomber sur 2026, et le chapitre en cours de
	 * remplissage doit pouvoir être repris tel quel après une déconnexion.
	 */
	/** @ngInject */
	function config($stateProvider) {
		var PERMISSIONS_OFFICINE = ['TITULAIRE', 'PRAQ'];

		$stateProvider
			.state('app.autoeval', {
				abstract: true,
				url: '/auto-evaluation',
				data: { permissions: PERMISSIONS_OFFICINE }
			})
			.state('app.autoeval.questionnaire', {
				// Le chapitre est FACULTATIF : sans lui, le contrôleur reprend là où l'officine
				// s'était arrêtée, ce qui est le comportement attendu du bouton « Reprendre ».
				url: '/:annee/questionnaire/:chapitreId',
				// `relecture` n'est pas dans l'adresse : il demande d'ouvrir le questionnaire au
				// premier chapitre même quand tout est répondu, au lieu de filer à la validation
				// (« Retour au questionnaire » de la carte d'accueil, recette pharmacie, ligne 14).
				params: { chapitreId: { value: null, squash: true }, relecture: false },
				views: {
					'content@app': {
						templateUrl: 'app/main/front/auto-evaluation/questionnaire/questionnaire.html',
						controller: 'AutoEvalQuestionnaireController'
					}
				}
			})
			.state('app.autoeval.validation', {
				url: '/:annee/validation',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/auto-evaluation/validation/validation.html',
						controller: 'AutoEvalValidationController'
					}
				}
			})
			.state('app.autoeval.recap', {
				url: '/:annee/recapitulatif',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/auto-evaluation/recap/recap.html',
						controller: 'AutoEvalRecapController'
					}
				}
			})
			.state('app.autoeval.resultats', {
				url: '/:annee/resultats',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/auto-evaluation/resultats/resultats.html',
						controller: 'AutoEvalResultatsController'
					}
				}
			})
			.state('app.autoeval.comparaison', {
				url: '/:annee/comparaison',
				views: {
					'content@app': {
						templateUrl: 'app/main/front/auto-evaluation/comparaison/comparaison.html',
						controller: 'AutoEvalComparaisonController'
					}
				}
			});
	}
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('admin.toolbox', {
      url: '/boite-a-outils',
      views: {
        'content@admin': {
          templateUrl: 'app/main/admin/toolbox/toolbox.html',
          controller: 'ToolboxAdminController as vm'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('admin.suivi-enquete', {
      url: '/suivi-enquete',
      views: {
        'content@admin': {
          templateUrl: 'app/main/admin/suivi-enquete/suivi-enquete.html',
          controller: 'AdminSuiviEnqueteController'
        }
      }
    });
  }
})();

(function() {
	'use strict';

	angular
		.module('app.admin')
		.config(config);

	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		// State
		$stateProvider
			.state('admin.pharmacies', {
				url: '/pharmacies',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/pharmacies_categories.html',
						controller: 'PharmacyCategoriesController as vm'
					}
				}
			})
			.state('admin.pharmacies.all', {
				url: '/pharmacies/all',
				params: {
					type: 'all'
				},
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/pharmacies.html',
						controller: 'PharmaciesController as vm'
					}
				}
			})
			.state('admin.pharmacies.lqo', {
				url: '/pharmacies/lqo',
				params: {
					type: 'lqo'
				},
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/pharmacies.html',
						controller: 'PharmaciesController as vm'
					}
				}
			})
			.state('admin.pharmacies.lqo-mini', {
				url: '/pharmacies/lqo_mini',
				params: {
					type: 'lqo_mini'
				},
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/pharmacies.html',
						controller: 'PharmaciesController as vm'
					}
				}
			})
			.state('admin.pharmacies.non-lqo', {
				url: '/pharmacies/non_lqo',
				params: {
					type: 'non_lqo'
				},
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/pharmacies.html',
						controller: 'PharmaciesController as vm'
					}
				}
			})
			.state('admin.pharmacies.statistiques', {
				url: '/pharmacies/statistiques',
				views: {
					'content@admin': {
						templateUrl: 'app/main/admin/pharmacies/statistiques/statistiques.html',
						controller: 'AdminPharmaciesStatistiquesController as vm'
					}
				}
			});


	}
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /**
   * PHSQ-240 — espace OSyS de l'administration (H3 à H6). `data.permissions` redéclaré sur
   * chaque état (ui-router 0.3.2 hérite de `data`).
   *
   * @ngInject
   */
  function config($stateProvider) {
    var PERMISSIONS = ['ADMINISTRATEUR'];
    $stateProvider
      .state('admin.osys', {
        abstract: true,
        url: '/osys',
        data: { permissions: PERMISSIONS }
      })
      .state('admin.osys.officines', {
        url: '/officines',
        data: { permissions: PERMISSIONS },
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/osys/officines.html',
            controller: 'OsysAdminOfficinesController as vm'
          }
        }
      })
      .state('admin.osys.officine', {
        url: '/officines/:id',
        data: { permissions: PERMISSIONS },
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/osys/officine.html',
            controller: 'OsysAdminOfficineController as vm'
          }
        }
      })
      .state('admin.osys.import', {
        url: '/import',
        data: { permissions: PERMISSIONS },
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/osys/import.html',
            controller: 'OsysAdminImportController as vm'
          }
        }
      })
      .state('admin.osys.indicateurs', {
        url: '/indicateurs',
        data: { permissions: PERMISSIONS },
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/osys/indicateurs.html',
            controller: 'OsysAdminIndicateursController as vm'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('admin.groupements', {
        url: '/groupements',
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/groupements/groupements.html',
            controller: 'GroupementsController as vm'
          }
        }
      })
      // Page de détail : la gestion des accès se fait groupement par groupement, plutôt que
      // dans une seule liste où chaque ligne portait son propre formulaire.
      .state('admin.groupement', {
        url: '/groupements/:codeCrm',
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/groupements/detail/groupement-detail.html',
            controller: 'GroupementDetailController as vm'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /**
   * Administration des campagnes d'auto-évaluation (spécification §6).
   *
   * ⚠️ L'onglet de la fiche de campagne est DANS L'ADRESSE, avec `reloadOnSearch: false` : un
   * administrateur partage le lien de l'écran qu'il regarde, et la bascule d'onglet doit rester
   * instantanée. Même parti pris que l'espace groupement.
   *
   * ⚠️ La fiche et les tâches sont des ÉTATS ENFANTS de `admin.autoeval`, et pas des frères.
   * C'est ce qui garde « Auto-évaluation » allumé dans le menu de gauche : `ms-navigation`
   * relève l'élément actif avec `$state.includes(...)`, qui ne remonte qu'une descendance.
   * Leur `url` est donc relative — ui-router la concatène à celle du parent, et les adresses
   * `/admin/auto-evaluation/:id` et `/admin/auto-evaluation/:id/taches` sont inchangées.
   *
   * La garde de rôle est celle de l'espace d'administration : ces états n'en redéclarent pas.
   */
  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('admin.autoeval', {
        url: '/auto-evaluation',
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/auto-evaluation/campagnes.html',
            controller: 'AutoEvalAdminCampagnesController'
          }
        }
      })
      .state('admin.autoeval.campagne', {
        url: '/:id?tab',
        params: { tab: { value: 'configuration', squash: true } },
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/auto-evaluation/campagne.html',
            controller: 'AutoEvalAdminCampagneController'
          }
        },
        reloadOnSearch: false
      })
      .state('admin.autoeval.taches', {
        url: '/:id/taches',
        views: {
          'content@admin': {
            templateUrl: 'app/main/admin/auto-evaluation/taches.html',
            controller: 'AutoEvalAdminTachesController'
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // PHSQ-240 — comptes administrateurs nominatifs (commun à toute l'administration, hors OSyS).
    $stateProvider.state('admin.administrateurs', {
      url: '/administrateurs',
      data: { permissions: ['ADMINISTRATEUR'] },
      views: {
        'content@admin': {
          templateUrl: 'app/main/admin/administrateurs/administrateurs.html',
          controller: 'AdministrateursController as vm'
        }
      }
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login-v2',
            params: {
                successUpdatePwd: null
            }
        }).state('login2faActivation', {
            // PHSQ-240 — H2 : activation de la double authentification, hors de l'arbre admin.*
            // et sans menu, dans le cadre de la connexion.
            url: '/double-authentification',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@login2faActivation': {
                    templateUrl: 'app/main/login/activation_2fa.html',
                    controller: 'Activation2faController as vm'
                }
            },
            bodyClass: 'login-v2'
        }).state('activateAccount', {
            url: '/activateAccount',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@activateAccount': {
                    templateUrl: 'app/main/login/activate_account.html',
                    controller: 'ActivateAccountController as vm'
                }
            }
        }).state('forgotPassword', {
            url: '/forgotPassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@forgotPassword': {
                    templateUrl: 'app/main/login/forgot_password.html',
                    controller: 'ForgotPasswordController as vm'
                }
            }
        })
        .state('updatePassword', {
            url: '/updatePassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@updatePassword': {
                    templateUrl: 'app/main/login/update_password.html',
                    controller: 'UpdatePasswordController as vm'
                }
            }
        });
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/navigation/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"nl-Header md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'min-width: 1200px\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\">\n</md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2 nl-md-Content\" ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/main/block-portrait.html","<md-dialog flex=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xs=\"90\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Passer en mode paysage</div></div></div></md-toolbar>\n<md-dialog-content class=\"px-35 py-10\"><div layout=\"row\" layout-wrap>\nMerci de passer votre appareil en mode paysage pour accéder au LQO</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/calendar.html","<div class=\"nl-calendar nl-calendar--wrapper\"><div class=\"nl-calendar-control\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-calendar-content-arrow no-focus\" flex=\"20\" ng-click=\"previousMonth()\"><i \nclass=\"icon-chevron-left\"></i></div><div class=\"nl-calendar-control-button\" flex=\"60\"><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--sm nl-dib\" ng-click=\"today()\">Aujourd\'hui</button></div><div \nclass=\"nl-calendar-content-arrow no-focus\" flex=\"20\" ng-click=\"nextMonth()\"><i class=\"icon-chevron-right\"></i></div>\n</div><div ng-repeat=\"month in months\" class=\"nl-calendar {{ colorTheme }}\" \nng-class=\"{\'nl-calendar-active\': month.isActive}\"><div class=\"header nl-calendar-header row no-padding\"><div \nclass=\"nl-calendar-header-title col col-67\"><div class=\"nl-calendar-header-title-month\">{{month.name}} {{month.year}}\n</div><div class=\"nl-calendar-header-title-subMonth\">{{planning.planningName}}</div></div><span \nclass=\"nl-calendar-header-unavail col col-33\" ng-show=\"$first && selected.length > 0\"><span \nclass=\"nl-calendar-header-value\">{{selected.length}}</span></span></div><div class=\"nl-calendar-content-wrapper\"><div \nclass=\"nl-calendar-content\"><div class=\"week names nl-calendar-subHeader\"><span class=\"day nl-calendar-subHeader-tile\">\nLun</span> <span class=\"day nl-calendar-subHeader-tile\">Mar</span> <span class=\"day nl-calendar-subHeader-tile\">Mer\n</span> <span class=\"day nl-calendar-subHeader-tile\">Jeu</span> <span class=\"day nl-calendar-subHeader-tile\">Ven</span>\n <span class=\"day nl-calendar-subHeader-tile\">Sam</span> <span class=\"day nl-calendar-subHeader-tile\">Dim</span></div>\n<div class=\"week nl-calendar-body\" ng-repeat=\"week in month.weeks\"><div ng-repeat=\"day in week.days\"><span \nng-click=\"getCalendarDay(day, $parent.$parent.$first)\" class=\"day nl-calendar-body-day no-focus\" \nng-class=\"{ \'last-day\': day.lastDay,\'today\': day.isToday, \'FirstDayEvent\': day.firstSelected, \'DayEvent\': day.selected, \'LastDayEvent\': day.lastSelected, \'DayEventOne\': day.selectedOne}\">\n<span class=\"nl-calendar-body-day-title\">{{day.number}}</span></span></div></div></div><div \nclass=\"nl-calendar-legende-wrapper\"></div></div></div></div>");
$templateCache.put("app/main/input-file-single.html","<div layout=\"row\" layout-align=\"start center\"><div class=\"upload-field\" id=\"container\"><div>{{ fileName }}</div><div \nclass=\"nl-upload-file-name\" ng-repeat=\"fileName in fileNames\"><span>{{ fileName.name }}</span></div><input type=\"file\" \nid=\"document_input_file\"></div><md-button ng-if=\"!nofile\" \nclass=\"nl-Btn nl-Btn--outline nl-Btn--clear nl-Btn--sm nl-Btn--file nl-Btn--icon\" ng-click=\"removeFile()\"><md-icon \nclass=\"icon-window-close\"></md-icon><span>Supprimer</span></md-button></div>");
$templateCache.put("app/main/input-file.html","<div layout=\"row\" layout-align=\"start center\"><div class=\"upload-field\" id=\"container\"><div>{{ fileName }}</div><div \nclass=\"nl-upload-file-name\" ng-repeat=\"fileName in fileNames\"><span>{{ fileName.name }}</span></div><input type=\"file\" \nid=\"document_input_file\" multiple=\"multiple\"></div><md-button ng-if=\"!nofile\" \nclass=\"nl-Btn nl-Btn--outline nl-Btn--clear nl-Btn--sm nl-Btn--file nl-Btn--icon\" ng-click=\"removeFile()\"><md-icon \nclass=\"icon-window-close\"></md-icon><span>Supprimer</span></md-button></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/footer/footer.html","<div class=\"nl-Footer\"><div class=\"nl_bs_container\"><div class=\"nl-Footer-inner\"><div layout=\"row\"><div flex=\"20\"><a \nhref=\"/folders\" target=\"_self\" class=\"nl-Footer-title\">Base documentaire</a> <a ng-repeat=\"title in footerDocTitles\" \nng-click=\"goTo(\'folder/\'+title.id, false)\" class=\"nl-Footer-link\">{{title.name}}</a></div><div flex=\"20\"><a \nng-click=\"goTo(\'/dysfonctionnements_fiches\', false)\" class=\"nl-Footer-title\">Dysfonctionnements &<br>traçabilités</a> \n<a ng-click=\"goTo(\'/dysfonctionnements\', false)\" class=\"nl-Footer-link\">Dysfonctionnements</a> <a \nng-click=\"goTo(\'/fiches-progres\', false)\" class=\"nl-Footer-link\">Fiches de progrès</a> <a \nng-click=\"goTo(\'/appel-medecins\', false)\" class=\"nl-Footer-link\">Appels aux médecins</a> <a \nng-click=\"goTo(\'/trace\', true)\" class=\"nl-Footer-link\">Autres traçabilités</a></div><div flex=\"20\"><a \nng-click=\"goTo(\'/qualite\', true)\" class=\"nl-Footer-title\">Qualité</a> <a \nng-click=\"goTo(\'/communication-interne\', true)\" class=\"nl-Footer-link\">Communication interne</a> <a \nng-click=\"goTo(\'/auto-controles\', true)\" class=\"nl-Footer-link\">Auto-contrôles</a> <a \nng-click=\"goTo(\'/auto-evaluation\', true)\" class=\"nl-Footer-link\">Auto-évaluation</a> <a \nng-click=\"goTo(\'/audit\', true)\" class=\"nl-Footer-link\">Audit</a> <a ng-click=\"goTo(\'/demarche\', true)\" \nclass=\"nl-Footer-link\">Mise en œuvre de la démarche</a></div><div flex=\"20\"><a ng-click=\"goTo(\'/equipe\', false)\" \nclass=\"nl-Footer-title\">Equipe</a> <a ng-click=\"goTo(\'/planning-general\', false)\" class=\"nl-Footer-link\">Planning</a> \n<a ng-click=\"goTo(\'/reunions\', true)\" class=\"nl-Footer-link\">Réunions</a> <a ng-click=\"goTo(\'/equipe-collab\', false)\" \nclass=\"nl-Footer-link\">Collaborateurs</a></div><div flex=\"20\"><a ng-click=\"goTo(\'/performances\', true)\" \nclass=\"nl-Footer-title\">Performances</a> <a ng-click=\"goTo(\'/tableau-de-bord\', true)\" class=\"nl-Footer-link\">\nTableau de bord</a> <a ng-click=\"goTo(\'/evaluation-fournisseurs\', true)\" class=\"nl-Footer-link\">Suivi fournisseurs</a> \n<a ng-click=\"goTo(\'/plan-strategique\', true)\" class=\"nl-Footer-link\">Plan stratégique</a> <a \nng-click=\"goTo(\'/bilan-de-performances\', true)\" class=\"nl-Footer-link\">Bilan de performances</a> <a \nng-click=\"goTo(\'/mes-evaluations\', true)\" class=\"nl-Footer-link\">Mes évaluations</a></div><div flex=\"15\"><img \nclass=\"nl-Footer-logo\" src=\"assets/images/PHSQ/logopharma.png\" alt=\"\"><div class=\"nl-Footer-mentions\">\nCopyright © Pharma Système Qualité 2018</div></div></div></div></div></div>");
$templateCache.put("app/main/login/activate_account.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>P</span></div><div class=\"title\">Activation du compte</div><form \nname=\"activateAccountForm\" novalidate ng-submit=\"activateAccountForm.$valid && updatePassword()\"><input \ntype=\"password\" name=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password1\" \nng-change=\"checkPasswordEquals()\" ng-model=\"passwordDTO.password\" placeholder=\"Mot de passe\" required><div \nng-messages=\"activateAccountForm.password1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"confirmPassword1\" ng-change=\"checkPasswordEquals()\" ng-model=\"passwordDTO.confirmPassword\" \nplaceholder=\"Confirmation du mot de passe\" required><div ng-messages=\"activateAccountForm.confirmPassword1.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Information requise.</span></div></div><div \nclass=\"input-error\" ng-if=\"noRepeat\">Les mots de passes sont différents.</div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Activer le compte\" \nng-disabled=\"activateAccountForm.$pristine\">Activer mon compte</md-button></form></div></div></div>");
$templateCache.put("app/main/login/activation_2fa.html","<div id=\"login-v2\" style=\"background-color:#1C3E64 !important; background:url()\" layout=\"row\" layout-align=\"start\"><div\n id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\"><img class=\"\" src=\"assets/images/PHSQ/logopharma.png\" \nalt=\"PHSQ logo\"></div><div class=\"title\" style=\"color: white\">Administration LQO</div><div \nclass=\"description lqo-2fa-intro\">\nChaque administrateur se connecte avec son propre compte et une double authentification.</div></div><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\" \nclass=\"lqo-2fa lqo-2fa--activation\"><div class=\"title\">Activer la double authentification</div><div \nclass=\"lqo-2fa__guide\"><div class=\"lqo-2fa__guide-titre\"><span class=\"lqo-2fa__guide-icone\"><md-icon \nmd-font-icon=\"icon-book-open\" class=\"s20\"></md-icon></span>Première fois ? Suivez le guide</div><div \nclass=\"lqo-2fa__guide-texte\">Chaque étape en images, de l\'application à installer jusqu\'aux codes de secours.</div><div\n class=\"lqo-2fa__guide-actions\"><a class=\"osy-btn osy-btn--contour\" \nhref=\"/assets/documents/Guide-double-authentification-LQO.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" \naria-label=\"Ouvrir le guide de la double authentification (PDF) dans un nouvel onglet\"><md-icon \nmd-font-icon=\"icon-open-in-new\" class=\"s18\"></md-icon>Ouvrir le guide </a><a class=\"lqo-2fa__guide-telecharger\" \nhref=\"/assets/documents/Guide-double-authentification-LQO.pdf\" download=\"Guide-double-authentification-LQO.pdf\" \naria-label=\"Télécharger le guide de la double authentification (PDF)\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s18\"></md-icon>Télécharger</a></div></div><div ng-if=\"chargement\" class=\"lqo-2fa__texte\">Chargement…</div><div \nng-if=\"!chargement && enrolement && !codesSecours\"><ol class=\"lqo-2fa__etapes\"><li><strong>\nInstallez une application d\'authentification</strong>\n sur votre téléphone (par exemple Google Authenticator, Microsoft Authenticator ou FreeOTP).</li><li><strong>\nScannez ce QR code</strong> avec l\'application.<div class=\"lqo-2fa__qr\"><img \nng-src=\"data:image/png;base64,{{enrolement.qrPngBase64}}\" alt=\"QR code de la double authentification\"></div><div \nclass=\"lqo-2fa__cle\">Impossible de scanner ? Saisissez la clé : <code>{{enrolement.cle}}</code></div></li><li><strong>\nSaisissez le code à 6 chiffres</strong> affiché par l\'application.<form name=\"activationForm\" class=\"lqo-2fa__saisie\" \nnovalidate ng-submit=\"activer()\"><input type=\"text\" class=\"osy-champ lqo-2fa__champ\" inputmode=\"numeric\" \nautocomplete=\"one-time-code\" maxlength=\"7\" ng-model=\"saisie.code\" placeholder=\"123 456\" aria-label=\"Code à 6 chiffres\" \nng-disabled=\"envoi\"> <button type=\"submit\" class=\"osy-btn osy-btn--principal\" \nng-disabled=\"(saisie.code || \'\').replace(\' \', \'\').length !== 6 || envoi\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s18\"></md-icon>Activer</button></form><span class=\"red-600-fg lqo-2fa__erreur\" ng-show=\"erreur\">{{erreur}}\n</span></li></ol><div class=\"lqo-2fa__info\">Ensuite : vos 8 codes de secours, affichés une seule fois.</div></div><div \nng-if=\"codesSecours\"><p class=\"lqo-2fa__texte\">Double authentification activée. Voici vos <strong>8 codes de secours\n</strong> : ils servent si vous n\'avez plus votre téléphone. <strong>Ils ne seront plus affichés.</strong></p><ul \nclass=\"lqo-2fa__codes\"><li ng-repeat=\"code in codesSecours track by $index\"><code>{{code}}</code></li></ul><div \nclass=\"lqo-2fa__actions\"><button type=\"button\" class=\"osy-btn osy-btn--tonal\" ng-click=\"telechargerCodes()\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s18\"></md-icon>Télécharger les codes</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand osy-btn--bloc\" ng-click=\"terminer()\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon>J\'ai conservé mes codes</button></div></div><div \nclass=\"lqo-2fa__liens\"><span></span> <a href=\"\" ng-click=\"seDeconnecter()\">Se déconnecter</a></div></div></div></div>");
$templateCache.put("app/main/login/cgu_popup.html","<md-dialog class=\"nl_dialog-cgu\" aria-label=\"CGU\" flex=\"40\" flex-sm=\"60\" flex-xs=\"80\"><form name=\"cguForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"showCguActions !== false && cguForm.$valid && login()\"><md-toolbar \nlayout=\"column\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"cgu\">Les conditions générales d\'utilisations</div></div><button type=\"button\" \nclass=\"md-icon-button\" ng-if=\"showCguActions === false\" ng-click=\"close()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></md-toolbar><md-dialog-content><p ms-scroll></p><p class=\"western\" \nalign=\"center\"><em><span style=\"color: #68aeb8\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: x-large\"><strong>CONDITIONS GENERALES D&rsquo;UTILISATION </strong></span></span></span></em></p><p \nclass=\"western\" align=\"center\"><em><span style=\"color: #68aeb8\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: x-large\"><strong>DU LOGICIEL DE GESTION QUALITE (LQO) </strong></span></span></span></em></p><p \nclass=\"western\" align=\"center\"><em><span style=\"color: #68aeb8\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: x-large\"><strong>PHARMA SYSTEME QUALITE </strong></span></span></span></em></p><p class=\"western\">\n&nbsp;</p><div id=\"Table des mati&egrave;res1\" dir=\"ltr\"><p align=\"center\"><span style=\"color: #666699\"><span \nstyle=\"font-size: small\"><a href=\"#_Toc536455199\"><span style=\"font-family: Calibri, serif\">\nARTICLE 1&nbsp;: DEFINITIONS</span> 1</a></span></span></p><p align=\"center\"><span style=\"color: #666699\"><span \nstyle=\"font-size: small\"><a href=\"#_Toc536455200\"><span style=\"font-family: Calibri, serif\">\nARTICLE 2&nbsp;: CHAMP D&rsquo;APPLICATION</span> 1</a></span></span></p><p align=\"center\"><span \nstyle=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455201\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 3&nbsp;: DESCRIPTION DES SERVICES</span> 2</a></span></span></p><p \nalign=\"center\"><span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455202\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 4&nbsp;: SUPPORT TECHNIQUE</span> 3</a></span></span></p><p align=\"center\">\n<span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455203\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 5&nbsp;: PROPRIETE INTELLECTUELLE</span> 4</a></span></span></p><p \nalign=\"center\"><span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455204\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 6 : TRAITEMENT DES DONNEES</span> 4</a></span></span></p><p align=\"center\">\n<span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455205\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 7&nbsp;: RESPONSABILITE</span> 6</a></span></span></p><p align=\"center\">\n<span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455206\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 8&nbsp;: CESSION</span> 7</a></span></span></p><p align=\"center\"><span \nstyle=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455207\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 9&nbsp;: ABSENCE DE RENONCIATION</span> 7</a></span></span></p><p \nalign=\"center\"><span style=\"color: #666699\"><span style=\"font-size: small\"><a href=\"#_Toc536455208\"><span \nstyle=\"font-family: Calibri, serif\">ARTICLE 10&nbsp;: DROIT APPLICABLE ET LITIGES</span> 7</a></span></span></p><h1 \nclass=\"western\" align=\"left\"><a name=\"_Toc536455199\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 1&nbsp;: DEFINITIONS </span></span></span>\n</h1></div><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\"><em><strong>&laquo;&nbsp;Conditions G&eacute;n&eacute;rales d&rsquo;Utilisation &raquo; \n</strong></em></span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><em>ou</em></span>\n</span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><em><strong>\n &laquo;&nbsp;CGU&nbsp;&raquo;&nbsp;</strong></em></span></span><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\n: d&eacute;signe les pr&eacute;sentes Conditions G&eacute;n&eacute;rales d&rsquo;Utilisation des Services de la soci&eacute;t&eacute; PHARMA SYSTEME QUALITE.\n</span></span></p><p class=\"western\"><a name=\"_GoBack\"></a></p><p class=\"western\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><em><strong>\n&laquo;&nbsp;Plateforme&nbsp;&raquo;&nbsp;:</strong></em></span></span><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\n d&eacute;signe la plateforme web de la Solution (SaaS) permettant d&rsquo;acc&eacute;der aux Services en ligne.</span>\n</span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\"><em><strong>&laquo;&nbsp;Services&nbsp;&raquo; :</strong></em></span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n d&eacute;signe l&rsquo;ensemble des services propos&eacute;s par PHARMA SYSTEME QUALITE via la Solution, &agrave; savoir notamment&nbsp;: un support &agrave; l&rsquo;organisation d&rsquo;une base documentaire, des syst&egrave;mes de gestion des informations au sein de l&rsquo;&eacute;quipe (suivi de dysfonctionnements, messagerie interne, compte rendu d&rsquo;audit, informations entre membres de l&rsquo;&eacute;quipe,&hellip;), des syst&egrave;mes de planification et de suivi des performances, des syst&egrave;mes d&rsquo;organisation et de planification ainsi que des outils d&rsquo;accompagnement &agrave; la d&eacute;marche Qualit&eacute;. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\"><em><strong>&laquo;&nbsp;Solution&nbsp;&raquo;&nbsp;:</strong></em></span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n d&eacute;signe l&rsquo;application PHARMA SYSTEME QUALITE commun&eacute;ment appel&eacute; Logiciel Qualit&eacute; Officinal (&laquo;&nbsp;\n</span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><strong>LQO&nbsp;&raquo;\n</strong></span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n) d&rsquo;aide aux pharmacies &agrave; la mise en place de la d&eacute;marche Qualit&eacute;, accessible sur la Plateforme, par le biais d&rsquo;un espace personnel sp&eacute;cifique selon la cat&eacute;gorie d&rsquo;Utilisateur (Titulaire, responsable qualit&eacute;, membre de l&rsquo;&eacute;quipe).\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\"><em><strong>&laquo;&nbsp;Tiers&nbsp;&raquo;</strong></em></span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n&nbsp;: d&eacute;signe toute personne, physique ou morale, ext&eacute;rieure aux CGU.</span></span></p><p \nclass=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n<em><strong>&laquo;&nbsp;Utilisateur(s)&nbsp;&raquo;&nbsp;</strong></em></span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n: d&eacute;signe toute personne, utilisant les Services de la Solution. </span></span></p><h1 class=\"western\" \nalign=\"left\"><a name=\"_Toc536455200\"></a> <span style=\"color: #68aeb8\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">ARTICLE 2&nbsp;: CHAMP D&rsquo;APPLICATION</span></span></span></h1><p class=\"western\">&nbsp;\n</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nLes pr&eacute;sentes Conditions G&eacute;n&eacute;rales d&rsquo;Utilisation ont pour objet de d&eacute;finir les modalit&eacute;s et conditions selon lesquelles PHARMA SYSTEME QUALITE (ci-apr&egrave;s \n</span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><strong>\n&laquo;&nbsp;PHARMA SYSTEME QUALITE&nbsp;&raquo;</strong></span></span><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\n), d&rsquo;une part, met &agrave; la disposition de l&rsquo;Utilisateur la Solution et les Services associ&eacute;s et d&rsquo;autre part, la mani&egrave;re par laquelle l&rsquo;Utilisateur acc&egrave;de et utilise lesdits Services. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes pr&eacute;sentes Conditions G&eacute;n&eacute;rales d&rsquo;Utilisation s&rsquo;appliquent sans restriction ni r&eacute;serve &agrave; toute utilisation des Services.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur reconna&icirc;t avoir eu une parfaite information concernant la Solution et les Services associ&eacute;s et notamment leurs caract&eacute;ristiques essentielles et avoir &eacute;t&eacute; invit&eacute; &agrave; consulter les conditions g&eacute;n&eacute;rales applicables.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE se r&eacute;serve la possibilit&eacute; de modifier, &agrave; tout moment et sans pr&eacute;avis, les pr&eacute;sentes CGU afin de les adapter aux &eacute;volutions de la Solution et/ou des Services et/ou de leur exploitation. Les modifications de ces CGU sont opposables aux Utilisateurs &agrave; compter de leur mise en ligne. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE se r&eacute;serve le droit de refuser l&rsquo;acc&egrave;s aux Services en cas de non-acceptation d&rsquo;une nouvelle version des CGU par l&rsquo;Utilisateur.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455201\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 3&nbsp;: DESCRIPTION DES SERVICES</span>\n</span></span></h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLa Solution est une application r&eacute;serv&eacute;e aux pharmacies engag&eacute;es dans la d&eacute;marche de certification ISO9001-QMS Pharma\n</span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">&reg;</span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n via PHARMA SYSTEME QUALITE pour la mise en place de la d&eacute;marche Qualit&eacute; et la simplification des actions quotidiennes. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLa Solution fait partie des outils mis &agrave; disposition par PHSQ pour le d&eacute;ploiement de la qualit&eacute;, Si la pharmacie sort de la d&eacute;marche qualit&eacute;, les Services sont r&eacute;sili&eacute;s par PHSQ, la pharmacie r&eacute;cup&egrave;re &agrave; la r&eacute;siliation du contrat le contenu de sa base de donn&eacute;es et une synth&egrave;se des appels m&eacute;decins enregistr&eacute;s dans la solution.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nAfin de pouvoir b&eacute;n&eacute;ficier des Services, l&rsquo;Utilisateur doit disposer d&rsquo;un acc&egrave;s internet via un navigateur type Google Chrome, version 68 ou sup&eacute;rieur ainsi que d&rsquo;un support de type ordinateur ou tablette. Avant toute utilisation des Services, l&rsquo;Utilisateur s&rsquo;assure qu&rsquo;il dispose d&rsquo;un appareil compatible avec les Services. \n</span></span></p><p align=\"justify\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nPour l&rsquo;acc&egrave;s &agrave; la Solution, l&rsquo;Utilisateur peut &ecirc;tre invit&eacute; &agrave; saisir ses informations personnelles. Dans cette hypoth&egrave;se, l&rsquo;Utilisateur s&rsquo;engage &agrave; fournir des informations personnelles exactes et compl&egrave;tes et &agrave; les maintenir &agrave; jour. PHARMA SYSTEME QUALITE se r&eacute;serve le droit de demander &agrave; l&rsquo;Utilisateur des documents justificatifs pour v&eacute;rifier l&rsquo;exactitude des informations communiqu&eacute;es.\n</span></span></p><p align=\"justify\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n&Agrave; validation de son inscription, l&rsquo;Utilisateur re&ccedil;oit un lien contenant l&rsquo;ensemble des &eacute;l&eacute;ments lui permettant de se connecter pour la premi&egrave;re fois sur la Plateforme. Lors de la premi&egrave;re connexion aux Services, l&rsquo;Utilisateur est invit&eacute; &agrave; cr&eacute;er son mot de passe.\n</span></span></p><p align=\"justify\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nLes Services sont accessibles en continu, 24h/24, 7 jours/7. </span></span></p><p class=\"western\">&nbsp;</p><p \nclass=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nPHARMA SYSTEME QUALITE d&eacute;ploie les moyens n&eacute;cessaires afin d&rsquo;assurer la permanence, la continuit&eacute; et la qualit&eacute; de la Solution et notamment des Services, et est tenue &agrave; ce titre d&rsquo;une obligation de moyens.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE se r&eacute;serve toutefois le droit d&rsquo;interrompre ponctuellement l&rsquo;acc&egrave;s aux Services en vue d&rsquo;en assurer la s&eacute;curit&eacute; et la maintenance. PHARMA SYSTEME QUALITE en informera l&rsquo;Utilisateur par courrier &eacute;lectronique, par avertissement visible sur la page d&rsquo;accueil de la Plateforme ou tout autre moyen de communication.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nDans le cadre de l&rsquo;utilisation des Services, l&rsquo;Utilisateur s&rsquo;engage notamment &agrave;&nbsp;:</span>\n</span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nRespecter les obligations en mati&egrave;re de propri&eacute;t&eacute; intellectuelle fix&eacute;es &agrave; l&rsquo;article 5 des pr&eacute;sentes&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nUtiliser les Services uniquement et exclusivement pour ses besoins propres</span></span><span style=\"color: #ff0000\">\n<span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">, </span></span></span><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n&eacute;tant pr&eacute;cis&eacute; que toute reproduction, repr&eacute;sentation, publication, diffusion ou modification ou extraction du contenu de la Solution et/ou des Services est prohib&eacute;e.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLa disponibilit&eacute; des syst&egrave;mes tiers (notamment internet) est limit&eacute;e par des facteurs technologiques et environnementaux susceptibles d&rsquo;impacter la transmission de donn&eacute;es. Les Services peuvent ainsi &ecirc;tre limit&eacute;s ou temporairement indisponibles, et ce sans pr&eacute;avis. PHARMA SYSTEME QUALITE ne saurait &ecirc;tre tenue responsable des dysfonctionnements et interruptions li&eacute;s &agrave; ces services tiers.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455202\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 4&nbsp;: SUPPORT TECHNIQUE</span></span>\n</span></h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur s&rsquo;engage &agrave; informer PHARMA SYSTEME QUALITE dans les plus brefs d&eacute;lais, de toute difficult&eacute; rencontr&eacute;e au cours de l&rsquo;utilisation des Services. &Agrave; cet effet, PHARMA SYSTEME QUALITE met &agrave; la disposition de l&rsquo;Utilisateur un num&eacute;ro de t&eacute;l&eacute;phone et une adresse e-mail de contact lui permettant de communiquer avec le support technique accessibles directement via le bouton Contact situ&eacute; dans le compte personnel de l&rsquo;Utilisateur. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLe support technique est disponible de 10h00 &agrave; 12h00 les lundi, mardi, mercredi, jeudi et vendredi et de 14h00 &agrave; 16h00 les lundi, mardi, mercredi et jeudi. PHARMA SYSTEME QUALITE se r&eacute;serve le droit de modifier la disponibilit&eacute; et les horaires du support technique sans pr&eacute;avis.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLe support technique s&rsquo;engage &agrave; r&eacute;pondre par tout moyen &agrave; toute demande d&rsquo;intervention au titre du support technique sous 72 heures. Le support technique informe notamment l&rsquo;Utilisateur des d&eacute;lais pr&eacute;visibles de r&eacute;tablissement et/ou de r&eacute;paration.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE se r&eacute;serve le droit exclusif d&rsquo;intervenir sur les Services pour leur permettre d&rsquo;&ecirc;tre utilis&eacute;s conform&eacute;ment &agrave; leur destination et notamment pour en corriger les erreurs.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur s&rsquo;interdit de recourir de mani&egrave;re abusive au support technique. PHARMA SYSTEME QUALITE se r&eacute;serve le droit de refuser de r&eacute;pondre &agrave; certaines demandes si celles-ci sont de nature &agrave; perturber le fonctionnement normal du support technique.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLe non-respect par l&rsquo;Utilisateur des CGU applicables &agrave; la fourniture des Services entra&icirc;nera le droit pour PHARMA SYSTEME QUALITE d&rsquo;interrompre, de suspendre ou de supprimer l&rsquo;acc&egrave;s aux Services, sans pr&eacute;judice du droit &agrave; tous dommages et int&eacute;r&ecirc;ts auxquels PHARMA SYSTEME QUALITE pourrait pr&eacute;tendre.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455203\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 5&nbsp;: PROPRIETE INTELLECTUELLE</span>\n</span></span></h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur reconna&icirc;t que la Solution et les Services associ&eacute;s, notamment les textes, photographies, illustrations, vid&eacute;os, logiciels, bases de donn&eacute;es, API, sons, graphismes, logos, ou toute autre information ou support pr&eacute;sent&eacute; par PHARMA SYSTEME QUALITE sont prot&eacute;g&eacute;s par le droit d&rsquo;auteur, le droit des marques et des brevets et tout autre droit de propri&eacute;t&eacute; intellectuelle.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nCes &eacute;l&eacute;ments font partie des &eacute;l&eacute;ments couverts par la clause de confidentialit&eacute; de PHARMA SYSTEME QUALITE.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE conc&egrave;de &agrave; l&rsquo;Utilisateur, un droit d&rsquo;utilisation non-exclusif des Services ainsi que de l&rsquo;&eacute;ventuelle documentation y attach&eacute;e, sous la forme d&rsquo;une licence et non d&rsquo;une vente, pour toute la dur&eacute;e de l&rsquo;inscription &agrave; ces Services. Aucune disposition des pr&eacute;sentes CGU ne peut &ecirc;tre interpr&eacute;t&eacute;e comme conf&eacute;rant &agrave; l&rsquo;Utilisateur un transfert de propri&eacute;t&eacute; sur ces droits de propri&eacute;t&eacute; intellectuelle.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nToute utilisation, reproduction, extraction non express&eacute;ment autoris&eacute;e par PHARMA SYSTEME QUALITE au titre des pr&eacute;sentes est illicite, conform&eacute;ment &agrave; l\'article L.122-6 du Code de la propri&eacute;t&eacute; intellectuelle. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">L&rsquo;Utilisateur n&rsquo;est notamment pas autoris&eacute; &agrave; :</span></span></p><p \nclass=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nRepr&eacute;senter, diffuser, commercialiser les &eacute;l&eacute;ments des Services, que ce soit &agrave; titre gracieux ou on&eacute;reux, sans autorisation pr&eacute;alable et &eacute;crite de PHARMA SYSTEME QUALITE ;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nUtiliser les Services associ&eacute;s de quelque fa&ccedil;on que ce soit aux fins de conception, r&eacute;alisation, diffusion ou commercialisation d&rsquo;un service similaire, &eacute;quivalent ou de substitution ;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nMettre &agrave; disposition directe ou indirecte la totalit&eacute; ou une partie des Services et/ou de la documentation au b&eacute;n&eacute;fice d\'un Tiers non autoris&eacute;, notamment par licence, location, cession ou pr&ecirc;t, m&ecirc;me &agrave; titre gratuit, sauf en cas d&rsquo;accord pr&eacute;alable &eacute;crit de PHARMA SYSTEME QUALITE ;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nModifier, traduire, reproduire, d&eacute;monter, d&eacute;sassembler, ni d&eacute;river d\'une fa&ccedil;on ou d\'une autre le code source du logiciel ou de la documentation qui l\'accompagne&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nMettre la totalit&eacute; ou une partie des fichiers des Services &agrave; la disposition du public sur une page Internet sous la forme d\'un fichier s&eacute;par&eacute;, r&eacute;utilisable ou transf&eacute;rable.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc482866212\"></a><a name=\"_Toc536455204\"></a> <span \nstyle=\"color: #68aeb8\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nARTICLE 6 : TRAITEMENT DES DONNEES</span></span></span></h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nPHARMA SYSTEME QUALITE met en &oelig;uvre tous les moyens raisonnables pour assurer la s&eacute;curit&eacute; et la confidentialit&eacute; des donn&eacute;es &eacute;chang&eacute;es et g&eacute;n&eacute;r&eacute;es dans le cadre de l&rsquo;utilisation des Services. PHARMA SYSTEME QUALITE s&rsquo;engage &agrave; garantir la confidentialit&eacute; des donn&eacute;es transmises par l&rsquo;Utilisateur, sous r&eacute;serve qu&rsquo;elles soient express&eacute;ment identifi&eacute;es comme telles par l&rsquo;Utilisateur.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE est seule propri&eacute;taire des contenus qu&rsquo;elle produit et communique via la Solution notamment dans le cadre de l&rsquo;aide &agrave; la d&eacute;marche Qualit&eacute;. &Agrave; ce titre, PHARMA SYSTEME QUALITE se r&eacute;serve le droit d&rsquo;utiliser ces contenus et de transmettre tout ou partie des donn&eacute;es &agrave; des Tiers. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><a name=\"_Hlk482870361\"></a> <span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\"><strong>\nL&rsquo;Utilisateur est express&eacute;ment averti qu&rsquo;il lui appartient de proc&eacute;der &agrave; toute mesure de sauvegarde des donn&eacute;es trait&eacute;es au moyen des Services. \n</strong></span></span></p><p align=\"justify\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nPHARMA SYSTEME QUALITE est amen&eacute;e &agrave; collecter des donn&eacute;es &agrave; caract&egrave;re personnel concernant l&rsquo;Utilisateur, destin&eacute;es exclusivement &agrave; l&rsquo;utilisation des Services et qui font l&rsquo;objet d&rsquo;un traitement automatis&eacute; &agrave; des fins techniques dans le cadre de la gestion des comptes ainsi que de l&rsquo;am&eacute;lioration de la Solution. \n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nLes donn&eacute;es personnelles de l&rsquo;Utilisateur ne sont en aucun cas transmises &agrave; des Tiers &agrave; l&rsquo;exclusion des cas pour lesquels leur communication est strictement n&eacute;cessaire &agrave; la gestion du compte et au bon fonctionnement des Services.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nConform&eacute;ment &agrave; la loi &laquo;&nbsp;Informatique et&nbsp;libert&eacute;s&nbsp;&raquo; du 6 janvier 1978 et au R&egrave;glement G&eacute;n&eacute;ral sur la Protection des Donn&eacute;es personnelles (RGPD), l&rsquo;Utilisateur dispose d&rsquo;un droit d&rsquo;acc&egrave;s, de rectification, d&rsquo;opposition, de limitation, de portabilit&eacute; et de suppression des donn&eacute;es personnelles le concernant. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur peut exercer ces droits &agrave; tout moment &agrave; l&rsquo;adresse&nbsp;suivante&nbsp;: Pharma Syst&egrave;me Qualit&eacute;, Buroclub Paris Vend&ocirc;me, 5 rue de Castiglione, 75001 Paris.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nL&rsquo;Utilisateur dispose &eacute;galement du droit d&rsquo;introduire une r&eacute;clamation aupr&egrave;s de l&rsquo;autorit&eacute; de contr&ocirc;le comp&eacute;tente, s&rsquo;il estime que PHARMA SYSTEME QUALITE effectue un traitement illicite de ses donn&eacute;es personnelles.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes donn&eacute;es personnelles collect&eacute;es sont conserv&eacute;es pendant un (1) an suivant la fin de sa relation avec l&rsquo;Utilisateur.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes donn&eacute;es &eacute;chang&eacute;es et g&eacute;n&eacute;r&eacute;es dans le cadre de l\'utilisation des Services sont h&eacute;berg&eacute;es sur l\'infrastructure d\'un prestataire technique externe disposant de mesures de contr&ocirc;le et de s&eacute;curit&eacute; de grande qualit&eacute;, garantissant ainsi l&rsquo;exigence la plus &eacute;lev&eacute;e en mati&egrave;re de s&eacute;curit&eacute;, de fiabilit&eacute; et de disponibilit&eacute; des donn&eacute;es h&eacute;berg&eacute;es.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes donn&eacute;es sensibles sont h&eacute;berg&eacute;es aupr&egrave;s d&rsquo;un h&eacute;bergeur certifi&eacute; &laquo;&nbsp;h&eacute;bergeur de donn&eacute;es de sant&eacute;&nbsp;&raquo; habilit&eacute; &agrave; traiter cette cat&eacute;gorie sp&eacute;cifique de donn&eacute;es. L&rsquo;Utilisateur peut obtenir, sur simple demande aupr&egrave;s de PHARMA SYSTEME QUALITE l&rsquo;identit&eacute; de l&rsquo;h&eacute;bergeur des donn&eacute;es de sant&eacute;. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes Services permettent &agrave; l&rsquo;Utilisateur de charger et de stocker des documents contenant certaines donn&eacute;es &agrave; caract&egrave;re personnel relatives &agrave; des Tiers et notamment des donn&eacute;es dites &laquo;&nbsp;sensibles&nbsp;&raquo; (donn&eacute;es de sant&eacute;).\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nConcernant l&rsquo;h&eacute;bergement de donn&eacute;es &agrave; caract&egrave;re personnel de Tiers communiqu&eacute;es par l&rsquo;Utilisateur, y compris les donn&eacute;es sensibles, PHARMA SYSTEME QUALITE est sous-traitant du traitement de ces donn&eacute;es au sens du RGPD. &Agrave; ce titre, l&rsquo;Utilisateur est invit&eacute; &agrave; consulter et accepter &laquo;&nbsp;l&rsquo;Annexe de traitement des donn&eacute;es personnelles pour le compte de l&rsquo;Utilisateur&nbsp;&raquo; de PHARMA SYSTEME QUALITE.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455205\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 7&nbsp;: RESPONSABILITE</span></span></span>\n</h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE met tout en &oelig;uvre pour assurer la fiabilit&eacute; des Services. L&rsquo;Utilisateur reconna&icirc;t que PHARMA SYSTEME QUALITE n&rsquo;est tenue que d&rsquo;une obligation de moyens et ne saurait &ecirc;tre tenue responsable des &eacute;ventuelles erreurs engendr&eacute;es par les Services ne r&eacute;sultant pas d&rsquo;une faute lourde ou d&rsquo;une n&eacute;gligence fautive de sa part. \n</span></span></p><p class=\"western\" align=\"left\">&nbsp;</p><p class=\"western\" align=\"left\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nLa soci&eacute;t&eacute; PHARMA SYSTEME QUALITE ne peut en aucune mani&egrave;re &ecirc;tre tenue responsable :</span>\n</span></p><p class=\"western\" align=\"left\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span\n style=\"font-size: small\">\nDu non-respect des prescriptions de PHARMA SYSTEME QUALITE par l&rsquo;Utilisateur ou un Tiers&nbsp;;</span></span></p>\n<p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDe l&rsquo;erreur de manipulation des Services par l&rsquo;Utilisateur ou un Tiers et ses cons&eacute;quences&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDe l&rsquo;intervention sur les &eacute;quipements et mat&eacute;riels appartenant &agrave; l&rsquo;Utilisateur&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDes dommages ayant une cause ext&eacute;rieure aux Services ou relevant d&rsquo;un cas de force majeure&nbsp;;</span>\n</span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDe la contamination par virus des donn&eacute;es et/ou outils et/ou logiciels et/ou &eacute;quipements de l&rsquo;Utilisateur, dont la protection incombe &agrave; ce dernier&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDes intrusions malveillantes de Tiers sur l&rsquo;espace de l&rsquo;Utilisateur ou du piratage des donn&eacute;es, malgr&eacute; les mesures raisonnables de s&eacute;curit&eacute; mises en place&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nEn cas de dommage r&eacute;sultant de la perte, de l&rsquo;alt&eacute;ration ou de toute utilisation frauduleuse des Services, de la transmission accidentelle de virus ou autres &eacute;l&eacute;ments nuisibles, de l&rsquo;attitude ou comportement d&rsquo;un Tiers, de la non-conclusion d&rsquo;une op&eacute;ration&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDes dommages que pourraient subir les &eacute;quipements connect&eacute;s aux Services, ceux-ci &eacute;tant sous l&rsquo;enti&egrave;re responsabilit&eacute; de l&rsquo;Utilisateur&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nDes d&eacute;tournements &eacute;ventuels des mots de passe, codes confidentiels, et plus g&eacute;n&eacute;ralement de toute information &agrave; caract&egrave;re sensible pour l&rsquo;Utilisateur.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLes donn&eacute;es entr&eacute;es par l&rsquo;Utilisateur sont sous sa propre responsabilit&eacute; de sorte que PHARMA SYSTEME QUALITE, en qualit&eacute; d&rsquo;h&eacute;bergeur des donn&eacute;es, ne pourra voir sa responsabilit&eacute; engag&eacute;e &agrave; raison de ces donn&eacute;es.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLa responsabilit&eacute; de PHARMA SYSTEME QUALITE est limit&eacute;e aux dommages pr&eacute;visibles et directs subis exclusivement par l&rsquo;Utilisateur. PHARMA SYSTEME QUALITE ne sera pas responsable des dommages indirects, accessoires, particuliers, cons&eacute;cutifs ou punitifs ou de toute perte de profits ou de revenus, qu\'ils soient occasionn&eacute;s directement ou indirectement, ou de toute perte de donn&eacute;es ou d\'autres pertes irr&eacute;cup&eacute;rables, r&eacute;sultant de l\'acc&egrave;s ou l\'utilisation ou l&rsquo;incapacit&eacute; d\'acc&eacute;der ou d\'utiliser les Services ainsi que de l\'acc&egrave;s, l\'utilisation ou la modification non autoris&eacute;s des transmissions ou contenus. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nEn cas de cessation d&eacute;finitive de la fourniture des Services par PHARMA SYSTEME QUALITE, PHARMA SYSTEME QUALITE s&rsquo;engage &agrave; avertir l&rsquo;Utilisateur de l&rsquo;arr&ecirc;t des Services dans les meilleurs d&eacute;lais. La cessation ne pourra en aucun cas donner lieu &agrave; indemnisation ni r&eacute;paration quelconque au profit de l&rsquo;Utilisateur.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE n&rsquo;est pas tenue responsable du retard dans l&rsquo;ex&eacute;cution ou de l&rsquo;inex&eacute;cution de ses obligations lorsque le retard ou l&rsquo;inex&eacute;cution est imputable&nbsp;:\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\n&Agrave; un &eacute;v&eacute;nement de force majeure, tel que d&eacute;fini &agrave; l&rsquo;article 1218 du Code civil. PHARMA SYSTEME QUALITE informe l&rsquo;Utilisateur, par tout moyen et dans les meilleurs d&eacute;lais, de la survenance d&rsquo;un tel &eacute;v&eacute;nement&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n&Agrave; l&rsquo;Utilisateur du fait de l&rsquo;incompatibilit&eacute; de son &eacute;quipement ou outils avec les Services&nbsp;;\n</span></span></p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\n&Agrave; un Tiers, notamment en cas de dysfonctionnement, de d&eacute;faillance ou d&rsquo;indisponibilit&eacute;s des r&eacute;seaux.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nPHARMA SYSTEME QUALITE et/ou ses partenaires ne peuvent, en outre, &ecirc;tre tenus responsables de tout dysfonctionnement du r&eacute;seau ou des serveurs ou de tout autre &eacute;v&eacute;nement &eacute;chappant &agrave; leur contr&ocirc;le raisonnable, qui emp&ecirc;cherait, d&eacute;graderait l&rsquo;acc&egrave;s aux Services ou entra&icirc;nerait un dommage quelconque.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455206\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 8&nbsp;: CESSION</span></span></span></h1><p\n class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nLes CGU ainsi que les droits accord&eacute;s en vertu des pr&eacute;sentes ne peuvent pas &ecirc;tre transf&eacute;r&eacute;s ni c&eacute;d&eacute;s par l&rsquo;Utilisateur mais peuvent &ecirc;tre c&eacute;d&eacute;s par PHARMA SYSTEME QUALITE sans restriction. Toute tentative de transfert ou de cession en violation des pr&eacute;sentes sera nulle et non avenue.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455207\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 9&nbsp;: ABSENCE DE RENONCIATION</span>\n</span></span></h1><p class=\"western\">&nbsp;</p><p><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">\nLe fait pour PHARMA SYSTEME QUALITE de ne pas se pr&eacute;valoir de l&rsquo;inobservation par l&rsquo;Utilisateur de ses obligations ne saurait &ecirc;tre interpr&eacute;t&eacute; comme une renonciation &agrave; invoquer toute inobservation ult&eacute;rieure de la m&ecirc;me obligation ou d&rsquo;autres obligations, ou comme une renonciation au droit de veiller &agrave; l&rsquo;application desdites obligations.\n</span></span></p><h1 class=\"western\" align=\"left\"><a name=\"_Toc536455208\"></a> <span style=\"color: #68aeb8\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">ARTICLE 10&nbsp;: DROIT APPLICABLE ET LITIGES</span>\n</span></span></h1><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span \nstyle=\"font-size: small\">Les pr&eacute;sentes CGU sont soumises &agrave; la loi fran&ccedil;aise.</span></span></p><p \nclass=\"western\">&nbsp;</p><p class=\"western\"><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nPHARMA SYSTEME QUALITE et l&rsquo;Utilisateur s&rsquo;efforceront de r&eacute;soudre &agrave; l&rsquo;amiable les contestations qui pourraient surgir relatives &agrave; la validit&eacute;, l&rsquo;interpr&eacute;tation ou l&rsquo;ex&eacute;cution des pr&eacute;sentes. \n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\"><span style=\"color: #000000\"><span \nstyle=\"font-family: Calibri, serif\"><span style=\"font-size: small\">A d&eacute;faut d&rsquo;accord amiable, </span>\n</span></span><span style=\"font-family: Calibri, serif\"><span style=\"font-size: small\">\nle Tribunal de Commerce de PARIS sera seul comp&eacute;tent pour conna&icirc;tre de tout litige relatif &agrave; l&rsquo;ex&eacute;cution et/ou &agrave; l&rsquo;interpr&eacute;tation des Conditions G&eacute;n&eacute;rales d&rsquo;Utilisation, y compris en cas d&rsquo;urgence, d&rsquo;appel en garantie ou de pluralit&eacute; de d&eacute;fendeurs.\n</span></span></p><p class=\"western\">&nbsp;</p><p class=\"western\">&nbsp;</p><p class=\"western\">&nbsp;</p><p \nclass=\"western\">&nbsp;</p><p></p></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"showCguActions !== false\"><md-checkbox class=\"nl-Checkbox\" \nng-model=\"loginDTO.checkedCgu\" ng-change=\"checkedCgu()\" \naria-label=\"Je confirme avoir bien lu et j\'accepte les conditions générales d\'utilisations.\" md-no-ink required>\nJ\'ai lu et j\'accepte les conditions générales d\'utilisations.</md-checkbox><button id=\"btnAccept\" \nng-disabled=\"cguForm.$invalid\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Continuer\">Continuer</button>\n</md-dialog-actions><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"showCguActions === false\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"close()\" aria-label=\"Fermer\">Fermer</button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/login/forgot_password.html","<div id=\"forgot-password\" style=\"background-color:#1C3E64 !important; background:url()\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img class=\"\" \nsrc=\"assets/images/PHSQ/logopharma.png\" alt=\"PHSQ logo\"></div><div class=\"title\">Mot de passe oublié</div><form \nname=\"forgotPasswordForm\" novalidate ng-submit=\"forgotPasswordForm.$valid && sendForgotPassword()\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"loginDTO.email\" placeholder=\"Adresse email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email requis</span></div><div ng-message=\"pattern\"><span>\nEmail invalide</span></div><div ng-message=\"email\"><span>Email invalide</span></div></div></md-input-container>\n<md-button type=\"submit\" ng-disabled=\"buttonClicked\" class=\"md-raised md-accent submit-button\" \naria-label=\"Réinitialiser\">Réinitialiser</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ng-click=\"goToLogin()\">Retour au login</a></div></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login-v2\" style=\"background-color:#1C3E64 !important; background:url()\" layout=\"row\" layout-align=\"start\"><div\n id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\"><img class=\"\" src=\"assets/images/PHSQ/logopharma.png\" \nalt=\"PHSQ logo\"></div><div class=\"title\" style=\"color: white\" ng-if=\"etape === \'identifiants\'\">Bienvenue sur PHSQ</div>\n<div class=\"description\" ng-if=\"etape === \'identifiants\'\"></div><div class=\"title\" style=\"color: white\" \nng-if=\"etape !== \'identifiants\'\">Administration LQO</div><div class=\"description lqo-2fa-intro\" \nng-if=\"etape !== \'identifiants\'\">\nChaque administrateur se connecte avec son propre compte et une double authentification.</div><div class=\"nl-Mentions\">\nLogiciel proposé par <a href=\"https://www.pharmasystemequalite.com/\">www.pharmasystemequalite.com</a> &nbsp; | &nbsp; \n<a ui-sref=\"legal_mentions\">Mentions légales</a></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><img class=\"\" \nsrc=\"assets/images/PHSQ/logopharma.png\" alt=\"PHSQ logo\"></div><div class=\"title\" ng-if=\"etape === \'identifiants\'\">\nConnexion à PHSQ</div><div class=\"description\" ng-if=\"etape === \'identifiants\'\"></div><form name=\"loginForm\" \nnovalidate ng-submit=\"check()\" ng-if=\"etape === \'identifiants\'\"><span class=\"red-600-fg\" ng-show=\"loginError\">\n{{loginErrorMessage}}</span><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"loginDTO.usermail\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail obligatoire</span></div><div ng-message=\"pattern\"><span>Email doit être valide</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"loginDTO.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Mot de passe obligatoire</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><a \nui-sref=\"forgotPassword\" class=\"forgot-password md-accent-color\">Mot de passe oublié ?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"SE CONNECTER\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">SE CONNECTER</md-button></form><div class=\"lqo-2fa\" \nng-if=\"etape === \'code\'\"><div class=\"title\">Vérification en deux étapes</div><p class=\"lqo-2fa__texte\">\nSaisissez le code à 6 chiffres affiché par votre application d\'authentification.</p><form name=\"codeForm\" novalidate \nng-submit=\"envoyerCode()\"><div class=\"lqo-2fa__chiffres\" ng-paste=\"collerCode($event)\"><input \nng-repeat=\"c in deuxFacteurs.chiffres track by $index\" id=\"lqo-2fa-chiffre-{{$index}}\" type=\"text\" inputmode=\"numeric\" \nautocomplete=\"one-time-code\" maxlength=\"6\" class=\"lqo-2fa__chiffre\" aria-label=\"Chiffre {{$index + 1}}\" \nng-model=\"deuxFacteurs.chiffres[$index]\" ng-change=\"chiffreSaisi($index)\" ng-keydown=\"toucheChiffre($index, $event)\" \nng-disabled=\"deuxFacteurs.envoi\"></div><span class=\"red-600-fg lqo-2fa__erreur\" ng-show=\"deuxFacteurs.erreur\">\n{{deuxFacteurs.erreur}}</span> <button type=\"submit\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand osy-btn--bloc lqo-2fa__valider\" \nng-disabled=\"deuxFacteurs.chiffres.join(\'\').length !== 6 || deuxFacteurs.envoi\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s18\"></md-icon>Valider</button></form><div class=\"lqo-2fa__guide\"><div class=\"lqo-2fa__guide-titre\"><span \nclass=\"lqo-2fa__guide-icone\"><md-icon md-font-icon=\"icon-book-open\" class=\"s20\"></md-icon></span>\nBesoin d\'aide ? Suivez le guide</div><div class=\"lqo-2fa__guide-texte\">\nOù lire le code, codes de secours, nouveau téléphone : tout est expliqué en images.</div><div \nclass=\"lqo-2fa__guide-actions\"><a class=\"osy-btn osy-btn--contour\" \nhref=\"/assets/documents/Guide-double-authentification-LQO.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" \naria-label=\"Ouvrir le guide de la double authentification (PDF) dans un nouvel onglet\"><md-icon \nmd-font-icon=\"icon-open-in-new\" class=\"s18\"></md-icon>Ouvrir le guide </a><a class=\"lqo-2fa__guide-telecharger\" \nhref=\"/assets/documents/Guide-double-authentification-LQO.pdf\" download=\"Guide-double-authentification-LQO.pdf\" \naria-label=\"Télécharger le guide de la double authentification (PDF)\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s18\"></md-icon>Télécharger</a></div></div><div class=\"lqo-2fa__info\">\nPas de code par SMS : seule une application d\'authentification est acceptée.</div><div class=\"lqo-2fa__liens\"><a \nhref=\"\" ng-click=\"utiliserCodeSecours()\">Utiliser un code de secours</a> <a href=\"\" ng-click=\"retourConnexion()\">\nRetour à la connexion</a></div></div><div class=\"lqo-2fa\" ng-if=\"etape === \'secours\'\"><div class=\"title\">\nCode de secours</div><p class=\"lqo-2fa__texte\">Saisissez l\'un de vos codes de secours. Chaque code ne sert qu\'une fois.\n</p><form name=\"secoursForm\" novalidate ng-submit=\"envoyerCodeSecours()\"><md-input-container class=\"md-block\" \nmd-no-float><input type=\"text\" name=\"secours\" ng-model=\"deuxFacteurs.secours\" placeholder=\"XXXX-XXXX\" \nautocomplete=\"off\" maxlength=\"9\" aria-label=\"Code de secours\" required ng-disabled=\"deuxFacteurs.envoi\">\n</md-input-container><span class=\"red-600-fg lqo-2fa__erreur\" ng-show=\"deuxFacteurs.erreur\">{{deuxFacteurs.erreur}}\n</span> <button type=\"submit\" class=\"osy-btn osy-btn--principal osy-btn--grand osy-btn--bloc lqo-2fa__valider\" \nng-disabled=\"!deuxFacteurs.secours || deuxFacteurs.envoi\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>\nValider</button></form><div class=\"lqo-2fa__info\">\nPlus de téléphone ni de code de secours : contactez l\'équipe technique de LQO, qui réinitialise votre double authentification.\n</div><div class=\"lqo-2fa__liens\"><a href=\"\" ng-click=\"utiliserApplication()\">Utiliser l\'application d\'authentification\n</a> <a href=\"\" ng-click=\"retourConnexion()\">Retour à la connexion</a></div></div></div></div></div>");
$templateCache.put("app/main/login/update_password.html","<div id=\"forgot-password\" style=\"background-color:#1C3E64 !important; background:url()\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img class=\"\" \nsrc=\"assets/images/PHSQ/logopharma.png\" alt=\"PHSQ logo\"></div><div class=\"title\">Réinitialisation du mot de passe</div>\n<form name=\"initPasswordForm\" novalidate ng-submit=\"initPasswordForm.$valid && sendUpdatePassword()\"><input \ntype=\"password\" name=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"> <input \ntype=\"password\" name=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordUpdt\" autocomplete=\"off\" \nng-change=\"checkPasswordEquals()\" ng-model=\"loginDTO.password\" placeholder=\"Mot de passe\" read-only required><div \nng-messages=\"initPasswordForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nMot de passe requis</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"confirmPasswordUpdt\" ng-change=\"checkPasswordEquals()\" ng-model=\"loginDTO.confirmPassword\" \nplaceholder=\"Confirmation du mot de passe\" required><div ng-messages=\"initPasswordForm.confirmPasswordUpdt.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Mot de passe requis</span></div></div><div \nclass=\"input-error\" ng-if=\"noRepeat\">Les mots de passes sont différents.</div></md-input-container><md-button \ntype=\"submit\" ng-disabled=\"buttonClicked\" class=\"md-raised md-accent submit-button\" aria-label=\"Réinitialiser\">\nRéinitialiser</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"login\">Retour au login</a></div></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<div class=\"nl-non-lqo-nav-shell\" \nng-class=\"{\'nl-non-lqo-nav-shell--disabled\': $root.isNonLqoUser && $root.isNonLqoUser()}\"><ms-navigation \nclass=\"nl-msNavigation scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation><button \ntype=\"button\" class=\"nl-non-lqo-nav-overlay\" ng-if=\"$root.isNonLqoUser && $root.isNonLqoUser()\" \nng-click=\"$root.openNonLqoMenuPopup($event)\" aria-label=\"Découvrir le LQO\"></button><div class=\"nl-Nav-link\" \nng-if=\"!($root.isNonLqoUser && $root.isNonLqoUser())\"><div class=\"nl-Nav-link__wrapper\"><button type=\"button\" \nng-click=\"goHelp()\" class=\"nl-Nav-link-item\"><md-icon md-svg-src=\"assets/icons/app/V3/tuto.svg\"></md-icon><span>\nTUTORIELS</span></button> <span class=\"nl-Nav-link-separator\"></span> <button type=\"button\" class=\"nl-Nav-link-item\" \nng-click=\"goContact()\"><md-icon md-svg-src=\"assets/icons/app/V3/mentionner.svg\"></md-icon><span>CONTACT</span></button>\n</div><div class=\"nl-Nav-link__wrapper mt-10\"><button type=\"button\" class=\"nl-Nav-link-item\" \nng-click=\"goLegalMentions()\">Mentions légales</button></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/main/admin/administrateurs/administrateurs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-grp-page adm-page\"><div \nclass=\"header md-accent-bg admin-grp-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg admin-grp-header__title-group\"><div class=\"h1 admin-grp-header__title\"><md-icon \nmd-font-icon=\"icon-account-key\" class=\"s24\"></md-icon><span>Administrateurs</span></div><div \nclass=\"admin-grp-header__subtitle\">\nChaque administrateur a son propre compte et sa double authentification : l\'identifiant partagé est désactivé. Tous ont les mêmes droits.\n</div></div><div layout=\"row\" layout-align=\"end center\" class=\"admin-grp-header__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"ajouter($event)\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\nAjouter un administrateur</button></div></div><div class=\"content admin-grp-content\"><div class=\"admin-grp-card\"><div \nclass=\"adm-card-titre\">Comptes administrateurs</div><div class=\"admin-grp-loading\" ng-if=\"chargement\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span>Chargement…</span></div>\n<table class=\"admin-grp-table\" ng-if=\"!chargement\"><thead><tr><th>Administrateur</th><th>Courriel</th><th>\nDouble authentification</th><th>Dernière connexion</th><th>État</th><th class=\"admin-grp-table__right\"></th></tr>\n</thead><tbody><tr ng-repeat=\"a in administrateurs track by a.id\" class=\"adm-row\" \nng-class=\"{\'adm-row--desactive\': a.etat === \'DESACTIVE\'}\"><td><span class=\"admin-grp-name\">{{nomComplet(a)}}</span> \n<span class=\"adm-vous\" ng-if=\"a.vous\">(vous)</span></td><td class=\"adm-mail\">{{a.mail}}</td><td><span \nclass=\"admin-grp-chip\" ng-class=\"a.deuxFacteurs === \'ACTIVEE\' ? \'admin-grp-chip--ok\' : \'admin-grp-chip--warn\'\">\n{{a.deuxFacteurs === \'ACTIVEE\' ? \'Activée\' : \'En attente\'}}</span></td><td>{{derniereConnexion(a)}}</td><td>\n{{libelleEtat(a)}}<div class=\"adm-alerte\" \nng-if=\"a.vous && a.codesSecoursRestants !== null && a.codesSecoursRestants <= 2\">\nIl vous reste {{a.codesSecoursRestants}} code(s) de secours.</div></td><td class=\"admin-grp-table__right adm-actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-if=\"a.vous\" ng-click=\"regenererCodes($event)\">\nRégénérer mes codes de secours</button> <button type=\"button\" class=\"osy-btn osy-btn--contour\" \nng-if=\"estInvitation(a)\" ng-click=\"renvoyerInvitation(a)\">Renvoyer l\'invitation</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour osy-btn--rouge\" ng-if=\"estInvitation(a)\" ng-click=\"annulerInvitation(a, $event)\">\nAnnuler l\'invitation</button> <button type=\"button\" class=\"osy-btn osy-btn--contour osy-btn--rouge\" \nng-if=\"!a.vous && a.etat === \'ACTIF\'\" ng-click=\"desactiver(a, $event)\">Désactiver</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-if=\"a.etat === \'DESACTIVE\'\" ng-click=\"reactiver(a)\">Réactiver</button></td></tr>\n</tbody></table></div><div class=\"adm-aide\"><p>\nChaque connexion et chaque export sont tracés au nom de l\'administrateur. On ne peut désactiver ni son propre compte, ni le dernier administrateur actif.\n</p><p>\nTéléphone perdu et plus de code de secours : l\'équipe technique réinitialise la double authentification, sur demande.\n</p></div></div></div>");
$templateCache.put("app/main/admin/auto-evaluation/campagne.html","<div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page qs-config-campagne-page aeq-admin\"><div \nclass=\"header md-accent-bg qs-config-campagne-header\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\"><span><md-icon md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\" \nclass=\"s24\"></md-icon></span><span>Auto-évaluation {{campagne.annee}}</span></div><div class=\"h2 mt-4\">\n{{campagne.statut === \'BROUILLON\' ? \'Brouillon, pas encore programmée\' : \'\'}} {{campagne.statut === \'PROGRAMMEE\' ? \'Programmée : elle s\\\'ouvrira à la date prévue\' : \'\'}} {{campagne.statut === \'OUVERTE\' ? \'Campagne en cours\' : \'\'}} {{campagne.statut === \'CLOTUREE\' ? \'Campagne clôturée\' : \'\'}}\n</div></div></div></div><div class=\"white-fg\" layout=\"row\" layout-align=\"end center\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"voirTaches()\">File de tâches</button></div></div><div \nclass=\"nl-Content qs-config-campagne-content\"><div class=\"aeq-crumb\"><a ui-sref=\"admin.autoeval\">Campagnes</a> <span \nclass=\"aeq-sep\">/</span> <span class=\"aeq-cur\">{{campagne.annee}}</span></div><div class=\"aeq-note aeq-note--warn\" \nng-if=\"erreur\">{{erreur.message}}</div><div ng-if=\"campagne\"><div class=\"aeq-resume\"><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n            \'is-selected\': campagne.statut === \'OUVERTE\',\n            \'is-brouillon\': campagne.statut === \'BROUILLON\',\n            \'is-neutre\': campagne.statut !== \'OUVERTE\' && campagne.statut !== \'BROUILLON\'}\">\n{{campagne.statut | aeqStatutCampagne}} </span><span ng-if=\"campagne.dateOuverture\">Du <b>\n{{campagne.dateOuverture | date:\'dd/MM/yyyy\'}}</b> au <b>{{campagne.dateClotureEffective | date:\'dd/MM/yyyy\'}}</b> \n</span><span ng-if=\"campagne.effectifCible\">Cible figée : <b>{{campagne.effectifCible}}</b> officines</span> <span \nng-if=\"campagne.nbSoumissions\">\n{{campagne.nbValidees || 0}} questionnaire{{campagne.nbValidees > 1 ? \'s\' : \'\'}} validé{{campagne.nbValidees > 1 ? \'s\' : \'\'}} sur {{campagne.nbSoumissions}}\n</span></div><div class=\"aeq-onglets\"><div class=\"aeq-onglet\" ng-repeat=\"item in onglets() track by item\" \nng-class=\"{\'aeq-onglet--actif\': onglet === item}\" ng-click=\"changerOnglet(item)\">{{libelleOnglet(item)}}</div></div>\n<div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'configuration\'\"><section class=\"qs-config-card\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Dates de la campagne</h2><p class=\"qs-config-card-subtitle\">\nLa campagne s\'ouvre et se clôture <b>automatiquement</b> aux dates indiquées.</p></div></header><div \nclass=\"qs-config-timeline qs-config-timeline--trois\"><div class=\"qs-config-timeline-step\"><div \nclass=\"qs-config-step-badge\"><span>1</span></div><div class=\"qs-config-step-body\"><div class=\"qs-config-step-caption\">\nOuverture</div><md-input-container class=\"iv-Input-container no--errors-spacer qs-config-date\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date d\'ouverture</label><div class=\"iv-Input-date-wrapper\">\n<md-icon class=\"iv-Input-date-icon\" ng-click=\"datePickers.ouverture = campagne.datesModifiables\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" \nng-click=\"datePickers.ouverture = campagne.datesModifiables\" md-is-open=\"datePickers.ouverture\" placeholder=\"\" \nmd-hide-icons=\"all\" md-open-on-focus name=\"dateOuverture\" ng-model=\"dates.dateOuverture\" \nng-disabled=\"!campagne.datesModifiables\"></md-datepicker></div></md-input-container><div class=\"qs-config-step-hint\">\nÀ cette date, la liste des officines participantes est fixée et l\'e-mail d\'ouverture leur est envoyé — celui des officines LQO, ou celui des officines non LQO selon leur contrat.\n</div></div></div><div class=\"qs-config-timeline-connector\" aria-hidden=\"true\"></div><div \nclass=\"qs-config-timeline-step\"><div class=\"qs-config-step-badge\"><span>2</span></div><div class=\"qs-config-step-body\">\n<div class=\"qs-config-step-caption\">Clôture officielle</div><md-input-container \nclass=\"iv-Input-container no--errors-spacer qs-config-date\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de clôture</label><div class=\"iv-Input-date-wrapper\">\n<md-icon class=\"iv-Input-date-icon\" ng-click=\"datePickers.cloture = campagne.datesModifiables\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" \nng-click=\"datePickers.cloture = campagne.datesModifiables\" md-is-open=\"datePickers.cloture\" placeholder=\"\" \nmd-hide-icons=\"all\" md-open-on-focus name=\"dateClotureOfficielle\" ng-model=\"dates.dateClotureOfficielle\" \nmd-min-date=\"dates.dateOuverture\" ng-disabled=\"!campagne.datesModifiables\"></md-datepicker></div></md-input-container>\n<div class=\"qs-config-step-hint\">\nDernier jour pour répondre. La campagne se clôture automatiquement à minuit, à la fin de cette journée.</div></div>\n</div><div class=\"qs-config-timeline-connector\" aria-hidden=\"true\"></div><div class=\"qs-config-timeline-step\"><div \nclass=\"qs-config-step-badge\"><span>3</span></div><div class=\"qs-config-step-body\"><div class=\"qs-config-step-caption\">\nProlongation</div><md-input-container class=\"iv-Input-container no--errors-spacer qs-config-date\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Nouvelle date de clôture, si prolongation</label><div \nclass=\"iv-Input-date-wrapper\"><md-icon class=\"iv-Input-date-icon\" \nng-click=\"datePickers.prolongation = campagne.prolongationModifiable\" md-svg-src=\"assets/icons/app/V3/calendar.svg\">\n</md-icon><md-datepicker class=\"iv-Input-date\" ng-click=\"datePickers.prolongation = campagne.prolongationModifiable\" \nmd-is-open=\"datePickers.prolongation\" placeholder=\"\" md-hide-icons=\"all\" md-open-on-focus name=\"dateProlongation\" \nng-model=\"dates.dateProlongation\" md-min-date=\"dates.dateClotureOfficielle\" \nng-disabled=\"!campagne.prolongationModifiable\"></md-datepicker></div></md-input-container><div \nclass=\"qs-config-step-hint\">Facultatif : choisissez une date plus tardive pour <b>prolonger</b> la campagne.</div>\n</div></div></div><div class=\"aeq-note aeq-note--warn\" \nng-if=\"!campagne.datesModifiables && campagne.prolongationModifiable\">La campagne est ouverte : <b>\nseule la prolongation reste modifiable</b>\n. Les dates d\'ouverture et de clôture sont figées pour toute la durée de la collecte.</div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"!campagne.datesModifiables && !campagne.prolongationModifiable\">\nLa campagne est clôturée : ses dates ne sont plus modifiables.</div><div class=\"qs-config-card-actions\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-if=\"campagne.deprogrammable\" ng-click=\"deprogrammer()\" \nng-disabled=\"traitement\">Déprogrammer</button> <button type=\"button\" class=\"nl-Btn\" ng-click=\"enregistrerDates()\" \nng-disabled=\"traitement || (!campagne.datesModifiables && !campagne.prolongationModifiable)\">Enregistrer les dates\n</button></div></section><div class=\"aeq-note aeq-note--info\" ng-if=\"onglets().indexOf(\'emails\') >= 0\">\nLes e-mails envoyés aux officines, à PHSQ et aux groupements se règlent dans l\'onglet <a href=\"\" \nclass=\"aeq-renvoi-onglet\" ng-click=\"changerOnglet(\'emails\')\"><b>E-mails</b></a>.</div><section class=\"qs-config-card\" \nng-if=\"estimation !== null\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-pharmacy\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Officines concernées par la campagne</h2><p \nclass=\"qs-config-card-subtitle\">Officines actives et engagées dans la démarche qualité.</p></div></header><p \nclass=\"aeq-estimation\"><b>{{estimation}}</b>\n officines seraient incluses si la campagne ouvrait aujourd\'hui. La liste définitive sera <b>fixée à l\'ouverture</b>\n. Pour ajouter ensuite une officine nouvellement engagée, rendez-vous dans l\'onglet <b>Suivi des officines</b>.</p>\n</section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'emails\'\"><div class=\"aeq-section-config\"><h2 \nclass=\"aeq-section-config-titre\">E-mails de la campagne</h2><p class=\"aeq-section-config-aide\">\nLes e-mails envoyés automatiquement aux officines, à PHSQ et aux groupements, à partir des gabarits Brevo. Un e-mail ne part que s\'il a un gabarit valide \n<b>et</b> que son envoi est activé.</p></div><section class=\"qs-config-card\" ng-if=\"notifications.length\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon \nmd-font-icon=\"icon-email\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Vue d\'ensemble</h2><p class=\"qs-config-card-subtitle\">\nQui reçoit chaque e-mail, à quel moment, et s\'il partira. Cliquez sur une ligne pour régler l\'e-mail.</p></div>\n</header><table class=\"aeq-tbl aeq-emails-synthese\"><thead><tr><th>E-mail</th><th>Destinataires</th><th>Envoi</th><th>\nGabarit Brevo</th><th>État</th></tr></thead><tbody ng-repeat=\"groupe in groupesEmails track by groupe.cle\"><tr \nclass=\"aeq-emails-groupe\"><td colspan=\"5\">{{groupe.titre}}</td></tr><tr class=\"aeq-emails-ligne\" \nng-repeat=\"notification in groupe.notifications track by notification.type\" ng-click=\"allerAEmail(notification)\"><td>\n<b>{{notification.libelle}}</b></td><td>{{notification.destinataires}}</td><td>{{notification.moment}}</td><td \nclass=\"aeq-emails-gabarit\"><span ng-if=\"notification.templateBrevoId\">\n{{notification.templateBrevoNom || (\'Gabarit #\' + notification.templateBrevoId)}}</span> <span class=\"aeq-t-faible\" \nng-if=\"!notification.templateBrevoId\">—</span></td><td><span class=\"qs-campagne-template-state\" \nng-class=\"classeEtat(notification)\">{{libelleEtat(notification)}}</span></td></tr></tbody></table></section><div \nng-repeat=\"groupe in groupesEmails track by groupe.cle\"><div class=\"aeq-section-config\"><h2 \nclass=\"aeq-section-config-titre\">{{groupe.titre}}</h2><p class=\"aeq-section-config-aide\">{{groupe.aide}}</p></div>\n<section class=\"qs-config-card\" id=\"aeq-email-{{notification.type}}\" \nng-repeat=\"notification in groupe.notifications track by notification.type\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-email\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">{{notification.libelle}}</h2><p \nclass=\"qs-config-card-subtitle\">{{notification.description}}</p><p class=\"aeq-dernier-envoi\"><md-icon \nmd-font-icon=\"icon-history\" class=\"s14\"></md-icon><span ng-if=\"notification.dateDernierEnvoi\">Dernier envoi le <b>\n{{notification.dateDernierEnvoi | date:\'dd/MM/yyyy à HH:mm\'}}</b> </span><span ng-if=\"!notification.dateDernierEnvoi\">\nAucun envoi pour l\'instant</span></p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"classeEtat(notification)\">{{libelleEtat(notification)}}</span></header><div class=\"qs-config-brevo\" \nng-class=\"{\n                \'is-empty\': !notification.templateBrevoId,\n                \'is-standby\': notification.templateBrevoId && !notification.templateValide}\">\n<div ng-if=\"notification.templateBrevoId\" class=\"qs-config-brevo-info\"><div class=\"qs-campagne-template-name\" \ntitle=\"{{notification.templateBrevoNom}}\">\n{{notification.templateBrevoNom || (\'Gabarit #\' + notification.templateBrevoId)}}</div><div \nclass=\"qs-campagne-template-meta\">ID Brevo : {{notification.templateBrevoId}}</div><div \nng-if=\"!notification.templateValide\" class=\"qs-campagne-template-standby mt-8\"><div \nclass=\"qs-campagne-template-standby-title\">Pourquoi l\'envoi est bloqué</div><div>\n{{notification.templateErreur || \'Le gabarit ne porte pas toutes les balises attendues.\'}}</div></div><div \nclass=\"aeq-switch\"><md-checkbox ng-model=\"notification.active\" ng-change=\"basculerNotification(notification)\" \nng-disabled=\"!campagne.notificationsModifiables\" class=\"nl-Checkbox\">Envoi activé</md-checkbox></div><div \nclass=\"qs-campagne-template-actions\" ng-if=\"campagne.notificationsModifiables\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"ouvrirGabarit(notification, $event)\">Modifier le gabarit</button></div></div>\n<div ng-if=\"!notification.templateBrevoId\" class=\"qs-config-brevo-empty\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24 qs-config-brevo-empty-icon\"></md-icon><div \nclass=\"qs-config-brevo-empty-body\"><div class=\"qs-config-brevo-empty-title\">Aucun gabarit sélectionné</div><div \nclass=\"qs-config-brevo-empty-text\">Cet e-mail ne partira pas. Le gabarit doit porter les balises <code \nng-repeat=\"balise in notification.balises track by balise\">{{balise}}</code>. <span \nng-if=\"notification.balisesFacultatives.length\">Il peut aussi utiliser <code \nng-repeat=\"balise in notification.balisesFacultatives track by balise\">{{balise}}</code>.</span></div></div><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline qs-config-brevo-empty-action\" ng-if=\"campagne.notificationsModifiables\" \nng-click=\"ouvrirGabarit(notification, $event)\">Sélectionner un gabarit</button></div></div><div class=\"aeq-email-test\">\n<button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"testerNotification(notification, $event)\"><md-icon \nmd-font-icon=\"icon-send\" class=\"s16\"></md-icon><span>Envoyer un e-mail de test</span></button></div></section></div>\n<div class=\"aeq-note aeq-note--warn\" ng-if=\"campagne.notificationsModifiables && campagne.statut === \'OUVERTE\'\">\nUn changement de gabarit vaut pour les <b>envois à venir</b>. Les e-mails déjà partis ne changent pas.</div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"!campagne.notificationsModifiables\">\nLa campagne est clôturée : le réglage de ses e-mails est figé. Les e-mails de clôture partent avec les gabarits choisis avant la clôture, au fil des rapports produits.\n</div></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'questionnaire\'\"><section class=\"qs-config-card\">\n<header class=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Questionnaire d\'autoévaluation {{campagne.annee}}</h2><p class=\"qs-config-card-subtitle\">\nLe questionnaire ne peut plus être modifié après l\'ouverture de la campagne.</p><p class=\"qs-config-card-subtitle\">\n{{campagne.versionQuestionnaire || \'Aucun questionnaire chargé\'}}</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"campagne.statutQuestionnaire === \'FIGE\' ? \'is-selected\' : (campagne.statutQuestionnaire === \'EDITABLE\' ? \'is-neutre\' : \'is-empty\')\">\n{{campagne.statutQuestionnaire === \'FIGE\' ? \'Version verrouillée\' : (campagne.statutQuestionnaire === \'EDITABLE\' ? \'Modifiable\' : \'Absent\')}}\n</span></header><aeq-aide resume=\"Comment lire ce tableau, ce que disent les pastilles et les étiquettes\"><p>\nCet écran montre le <b>contenu du questionnaire</b>\n du millésime : ses chapitres et les questions de chacun. Rien ne s\'y modifie : le questionnaire est celui que livre LQO pour l\'année, chargé à la création de la campagne. Si une version plus récente est déployée depuis, et tant que la campagne est en brouillon sans aucune soumission, le bouton \n<b>« Recharger le questionnaire livré »</b> la met en place ; tout autre chargement se fait <b>hors interface</b>.</p>\n<p><b>Cliquez sur la ligne d\'un chapitre</b>\n pour déplier ses questions. Plusieurs chapitres peuvent rester ouverts en même temps.</p><div \nclass=\"aeq-aide-section\">L\'état du questionnaire</div><ul class=\"aeq-aide-liste\"><li><dfn>Absent</dfn><span>\nAucun millésime n\'est chargé : la campagne ne peut pas s\'ouvrir.</span></li><li><dfn>Modifiable</dfn><span>\nChargé, mais pas encore figé. Aucune officine ne doit y répondre tant qu\'il l\'est.</span></li><li><dfn>\nVersion verrouillée</dfn><span>Figé. C\'est ce geste qui programme la campagne.</span></li></ul><div \nclass=\"aeq-aide-section\">La colonne Code</div><ul class=\"aeq-aide-liste\"><li><dfn>Pastille colorée</dfn> <span>\nLe numéro du chapitre. Sa couleur est celle du millésime et se retrouve dans le questionnaire de l\'officine.</span>\n</li><li><dfn>Pictogramme gris</dfn> <span>Chapitre <b>non numéroté</b>\n — le Profil (silhouette) et le Baromètre (étoile). Ils n\'entrent pas dans les pourcentages, donc ils n\'ont pas de code.\n</span></li></ul><div class=\"aeq-aide-section\">Les types de chapitre</div><ul class=\"aeq-aide-liste\"><li><dfn>Standard\n</dfn><span>Un chapitre du référentiel, compté dans les résultats.</span></li><li><dfn>Profil</dfn> <span>\nCe que fait l\'officine hors du référentiel noté — chapitre « Pour mieux vous connaître ».</span></li><li><dfn>Baromètre\n</dfn> <span>\nLa satisfaction de l\'officine vis-à-vis de la démarche et de son groupement — chapitre « Votre satisfaction ».</span>\n</li></ul><div class=\"aeq-aide-section\">Sur chaque question dépliée</div><ul class=\"aeq-aide-liste\"><li><dfn>\nLe type de réponse</dfn> <span>Ce que l\'officine choisit : <b>Oui / En cours / Non</b>, la même chose avec <b>\nNon concerné</b>, un <b>choix dans une liste</b>, une <b>échelle de satisfaction</b> ou un <b>texte libre</b>.</span>\n</li><li><dfn>Question d’orientation</dfn> <span>\nSa réponse commande l\'affichage des questions suivantes du chapitre. C\'est elle qui décide, par exemple, si tout le bloc PDA est posé ou non.\n</span></li><li><dfn><span class=\"aeq-qtag\">hors calcul</span></dfn> <span>\nLa question est posée mais n\'entre pas dans les pourcentages du chapitre.</span></li><li><dfn><span class=\"aeq-qtag\">\nfocus</span></dfn> <span>\nUn encart d\'accompagnement s\'affiche sous la réponse qui le déclenche. Son aperçu figure sous la question.</span></li>\n<li><dfn><span class=\"aeq-qtag\">plusieurs réponses</span></dfn> <span>\nDans une question à choix, l\'officine peut en cocher plusieurs.</span></li><li><dfn><span class=\"aeq-qtag\">\ndemande de contact</span></dfn> <span>\nLa réponse vaut demande d\'être recontacté — sur ce millésime, par le responsable qualité du groupement.</span></li><li>\n<dfn><span class=\"aeq-qref\">2026-Q001</span></dfn> <span>La référence de la question dans ce millésime.</span></li><li>\n<dfn><span class=\"aeq-qref\">← 2025-Q001</span></dfn> <span>\nLa question correspondante du millésime précédent, telle que la table de correspondance les apparie. C\'est ce lien qui permet de comparer une année à l\'autre ; son absence signale une question nouvelle.\n</span></li></ul></aeq-aide><div class=\"aeq-note aeq-note--warn\" ng-if=\"!questionnaire\">\nAucun questionnaire n\'est chargé pour cette campagne.</div><div class=\"qs-config-card-actions\" \nng-if=\"!questionnaire && campagne.questionnaireRechargeable\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"rechargerQuestionnaire($event)\">Charger le questionnaire livré</button></div><div ng-if=\"questionnaire\"><div \nclass=\"aeq-resume\"><span><b>{{campagne.nbChapitres}}</b> chapitres</span> <span><b>{{campagne.nbQuestions}}</b>\n questions</span> <span ng-if=\"nbFocusTotal\"><b>{{nbFocusTotal}}</b> focus</span> <button type=\"button\" \nclass=\"nl-Btn nl-Btn--sm nl-Btn--outline\" ng-if=\"nbFocusTotal\" ng-click=\"voirTousLesFocus()\">Voir tous les focus\n</button></div><table class=\"aeq-tbl\" ng-if=\"questionnaire.chapitres\"><thead><tr><th>Code</th><th>Chapitre</th><th>Type\n</th><th>Questions</th><th></th></tr></thead><tbody \nng-repeat=\"chapitre in questionnaire.chapitres track by chapitre.id\"><tr class=\"aeq-tbl-ouvrable\" \nng-click=\"basculerChapitre(chapitre)\"><td><span class=\"aeq-ccode\" ng-if=\"chapitre.code\" \nng-style=\"{background: chapitre.couleurHex}\">{{chapitre.code}}</span> <span class=\"aeq-ccode aeq-ccode--pict\" \nng-if=\"!chapitre.code\" title=\"Chapitre non numéroté : il n\'entre pas dans les pourcentages\"><svg \nng-if=\"chapitre.type === \'PROFIL\'\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"8\" cy=\"5.6\" r=\"2.6\"></circle><path \nd=\"M3.2 13.2c.7-2.3 2.5-3.5 4.8-3.5s4.1 1.2 4.8 3.5\"></path></svg> <svg ng-if=\"chapitre.type !== \'PROFIL\'\" \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M8 2.2l1.8 3.7 4 .6-2.9 2.8.7 4L8 11.4l-3.6 1.9.7-4L2.2 6.5l4-.6z\">\n</path></svg> </span></td><td><b>{{chapitre.titre}}</b><span class=\"aeq-qtag aeq-qtag--focus\" ng-if=\"chapitre.nbFocus\">\n{{chapitre.nbFocus}} focus</span></td><td>{{chapitre.type | aeqTypeChapitre}}</td><td class=\"aeq-mono\">\n{{chapitre.questions.length}}</td><td class=\"aeq-chev\"><span class=\"aeq-chev-fleche\" \nng-class=\"{\'is-ouvert\': chapitreDeplie(chapitre)}\" aria-hidden=\"true\"></span> <span class=\"aeq-chev-txt\">\n{{chapitreDeplie(chapitre) ? \'Replier\' : \'Voir\'}}</span></td></tr><tr class=\"aeq-questions-ligne\" \nng-if=\"chapitreDeplie(chapitre)\"><td colspan=\"5\"><ol class=\"aeq-questions\" ng-if=\"chapitre.questions.length\"><li \nng-repeat=\"question in chapitre.questions track by question.id\"><span class=\"aeq-qnum\">{{question.numero}}</span><div>\n<div class=\"aeq-qlib\">{{question.libelle | aeqLibelleQuestion}}</div><a class=\"aeq-lien-question\" \nng-if=\"question.lien\" ng-href=\"{{urlLienQuestion(question.id)}}\" target=\"_blank\" rel=\"noopener\"><svg \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M9.5 2.5h4v4M13.5 2.5l-6 6M12 9.5v3a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3\"></path></svg><span>\n{{question.lien.libelle}}</span></a><div class=\"aeq-qmeta\"><span>{{question.type | aeqTypeQuestion}}</span> <span \nclass=\"aeq-qtag\" ng-if=\"question.choixMultiple\">plusieurs réponses</span> <span class=\"aeq-qtag\" \nng-if=\"!question.entreDansCalcul\">hors calcul</span> <span class=\"aeq-qtag\" ng-if=\"question.focusActif\">focus</span> \n<span class=\"aeq-qtag\" ng-if=\"question.demandeContact\">demande de contact</span> <span class=\"aeq-qref\" \nng-if=\"question.reference\">{{question.reference}}</span> <span class=\"aeq-qref\" ng-if=\"question.correspondanceN1\" \ntitle=\"Question correspondante du millésime précédent\">← {{question.correspondanceN1}}</span></div><ul \nclass=\"aeq-qoptions\" ng-if=\"question.options.length\"><li ng-repeat=\"option in question.options track by $index\">\n{{option}}</li></ul><div class=\"aeq-focus\" ng-if=\"question.focusActif\"><div class=\"aeq-focus-quand\">\nAffiché à l\'officine si elle répond « {{libelleValeur(question.focusValeur)}} »</div><div class=\"aeq-focus-tete\" \nng-if=\"question.focusTitre | aeqTitreFocus:question.libelle\">{{question.focusTitre}}</div><p class=\"aeq-focus-texte\" \nng-if=\"question.focusTexte\">{{question.focusTexte}}</p><div class=\"aeq-ressources\" \nng-if=\"question.focusRessources.length\"><a ng-repeat=\"ressource in question.focusRessources track by ressource.id\" \nng-href=\"{{urlRessource(ressource.id)}}\" target=\"_blank\" rel=\"noopener\">{{ressource.libelle}}</a></div></div></div>\n</li></ol><p class=\"aeq-hint\" ng-if=\"!chapitre.questions.length\">Ce chapitre ne contient aucune question.</p></td></tr>\n</tbody></table><div class=\"qs-config-card-actions\" \nng-if=\"campagne.statutQuestionnaire === \'EDITABLE\' || campagne.questionnaireRechargeable\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-if=\"campagne.questionnaireRechargeable\" ng-click=\"rechargerQuestionnaire($event)\">\nRecharger le questionnaire livré</button> <button type=\"button\" class=\"nl-Btn\" \nng-if=\"campagne.statutQuestionnaire === \'EDITABLE\'\" ng-click=\"figerQuestionnaire($event)\">Figer le questionnaire\n</button></div></div></section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'outils\'\"><section \nclass=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-folder-outline\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Boîte à outils</h2><p \nclass=\"qs-config-card-subtitle\">\nDocuments mis à disposition des officines, dans leur carte d\'auto-évaluation, et des groupements, dès que la campagne est programmée.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge is-neutre\">\n{{outils.length}} outil{{outils.length > 1 ? \'s\' : \'\'}}</span></header><p class=\"aeq-hint\" ng-if=\"!outils.length\">\nAucun outil pour l\'instant : la carte des officines n\'affichera pas de boîte à outils.</p><table class=\"aeq-tbl\" \nng-if=\"outils.length\"><thead><tr><th>Ordre</th><th>Outil</th><th>Libellé du lien</th><th>Document</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"outil in outils track by outil.id\"><td><div class=\"qs-toolbox-order\"><button \ntype=\"button\" class=\"qs-toolbox-order-btn\" ng-click=\"deplacerOutil(outil, true)\" ng-disabled=\"$first\" \naria-label=\"Monter\"><md-icon md-svg-src=\"assets/icons/app/board/arrow_up.svg\"></md-icon></button> <span \nclass=\"qs-toolbox-order-pos\">{{$index + 1}}</span> <button type=\"button\" class=\"qs-toolbox-order-btn\" \nng-click=\"deplacerOutil(outil, false)\" ng-disabled=\"$last\" aria-label=\"Descendre\"><md-icon \nmd-svg-src=\"assets/icons/app/board/arrow_down.svg\"></md-icon></button></div></td><td><b>{{outil.titre}}</b></td><td>\n{{outil.libelleLien}}</td><td class=\"aeq-outil-document\"><a ng-href=\"{{urlOutil(outil)}}\" target=\"_blank\" \nrel=\"noopener\" title=\"{{outil.fichier ? outil.nomFichier : outil.url}}\">\n{{outil.fichier ? outil.nomFichier : outil.url}}</a></td><td class=\"aeq-actions\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--sm nl-Btn--outline\" ng-click=\"ouvrirOutil(outil, $event)\">Modifier</button> <button \ntype=\"button\" class=\"nl-Btn nl-Btn--sm nl-Btn--outline\" ng-click=\"supprimerOutil(outil, $event)\">Supprimer</button>\n</td></tr></tbody></table><div class=\"qs-config-card-actions\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"ouvrirOutil(null, $event)\">Ajouter un outil</button></div></section></div><div \nclass=\"qs-config-campagne-form\" ng-if=\"onglet === \'resultats\' && resultats\"><div \nclass=\"aeq-barre-outils aeq-barre-onglet\"><label ng-if=\"groupements.length\">Groupement<select \nng-model=\"filtres.groupementResultats\" ng-change=\"changerFiltresResultats()\" \nng-options=\"g.code as g.libelle for g in groupements\"><option value=\"\">National (tous les groupements)</option>\n</select></label><label>Année d\'engagement<select ng-model=\"filtres.anneeEngagement\" \nng-change=\"changerFiltresResultats()\" ng-options=\"a as a for a in resultats.anneesEngagementDisponibles\"><option \nvalue=\"\">Toutes</option></select></label></div><section class=\"qs-config-card\"><header class=\"qs-config-card-header\">\n<div class=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">\n{{groupementDesResultats ? \'Répartition — \' + groupementDesResultats.libelle : \'Répartition nationale\'}}</h2><p \nclass=\"qs-config-card-subtitle\">\nMoyenne des scores d\'officine : chaque officine y pèse le même poids, quelle que soit sa taille.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" ng-class=\"resultats.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{resultats.nbValidees}} validées{{resultats.provisoire ? \' · provisoire\' : \'\'}}</span></header><div \nclass=\"aeq-note aeq-note--info\" ng-if=\"resultats.provisoire\"><b>Campagne en cours</b>\n : ces chiffres évoluent à chaque validation.</div><div class=\"aeq-note aeq-note--warn\" \nng-if=\"resultats.provisoire && resultats.n1Disponible\">L\'<b>évolution N-1</b>\n compare {{resultats.nbValidees > 1 ? \'les \' + resultats.nbValidees + \' officines déjà validées\' : \'la seule officine déjà validée\'}} en {{resultats.annee}} à l\'\n<b>ensemble</b>\n de {{resultats.anneeN1}} : tant que la campagne est ouverte, elle reflète surtout la composition de l\'échantillon.\n</div><table class=\"aeq-tbl\"><thead><tr><th>Chapitre</th><th>Effectif</th><th>Oui</th><th>En cours</th><th>Non</th><th>\nNon concerné</th><th ng-if=\"resultats.perimetre === \'GROUPEMENT\'\">National (Oui)</th><th \nng-if=\"resultats.perimetre === \'GROUPEMENT\'\">Écart</th><th ng-if=\"resultats.n1Disponible\">{{resultats.anneeN1}} (Oui)\n</th><th>Évolution N-1</th></tr></thead><tbody><tr class=\"aeq-tbl-synthese\" ng-if=\"ligneGlobale()\"><td><b>\nSynthèse globale</b></td><td class=\"aeq-mono\">{{ligneGlobale().effectif}}</td><td class=\"aeq-mono aeq-t-oui\">\n{{aUneValeur(ligneGlobale().pctOui) ? (ligneGlobale().pctOui | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-encours\">\n{{aUneValeur(ligneGlobale().pctEnCours) ? (ligneGlobale().pctEnCours | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-non\">{{aUneValeur(ligneGlobale().pctNon) ? (ligneGlobale().pctNon | number:0) + \' %\' : \'—\'}}</td>\n<td class=\"aeq-mono\">{{aUneValeur(ligneGlobale().pctNc) ? (ligneGlobale().pctNc | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono\" ng-if=\"resultats.perimetre === \'GROUPEMENT\'\">\n{{aUneValeur(ligneGlobale().nationalPctOui) ? (ligneGlobale().nationalPctOui | number:0) + \' %\' : \'—\'}}</td><td \nng-if=\"resultats.perimetre === \'GROUPEMENT\'\"><aeq-badge-ecart valeur=\"ligneGlobale().ecartPts\" suffixe=\"\'vs national\'\">\n</aeq-badge-ecart></td><td class=\"aeq-mono\" ng-if=\"resultats.n1Disponible\">\n{{aUneValeur(ligneGlobale().pctOuiN1) ? (ligneGlobale().pctOuiN1 | number:0) + \' %\' : \'—\'}}</td><td><aeq-badge-ecart \nvaleur=\"ligneGlobale().evolutionN1Pts\" motif=\"ligneGlobale().evolutionMotif\"></aeq-badge-ecart></td></tr><tr \nng-repeat=\"ligne in lignesChapitres() track by ligne.chapitreId\" ng-class=\"{\'aeq-tbl-alerte\': ligne.alerte}\"><td><b>\n<span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span> {{ligne.titre}}</b><span \nclass=\"aeq-pill aeq-pill--alerte\" ng-if=\"ligne.alerte\" title=\"Moins de 60 % de « Oui » : point de vigilance\">vigilance\n</span> <span class=\"aeq-pill aeq-pill--close\" ng-if=\"ligne.sousPopulation\">sous-population</span></td><td \nclass=\"aeq-mono\">{{ligne.effectif}}</td><td class=\"aeq-mono aeq-t-oui\">\n{{aUneValeur(ligne.pctOui) ? (ligne.pctOui | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono aeq-t-encours\">\n{{aUneValeur(ligne.pctEnCours) ? (ligne.pctEnCours | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono aeq-t-non\">\n{{aUneValeur(ligne.pctNon) ? (ligne.pctNon | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono\">\n{{aUneValeur(ligne.pctNc) ? (ligne.pctNc | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono\" \nng-if=\"resultats.perimetre === \'GROUPEMENT\'\">\n{{aUneValeur(ligne.nationalPctOui) ? (ligne.nationalPctOui | number:0) + \' %\' : \'—\'}}</td><td \nng-if=\"resultats.perimetre === \'GROUPEMENT\'\"><aeq-badge-ecart valeur=\"ligne.ecartPts\" suffixe=\"\'vs national\'\">\n</aeq-badge-ecart></td><td class=\"aeq-mono\" ng-if=\"resultats.n1Disponible\">\n{{aUneValeur(ligne.pctOuiN1) ? (ligne.pctOuiN1 | number:0) + \' %\' : \'—\'}}</td><td><aeq-badge-ecart \nvaleur=\"ligne.evolutionN1Pts\" motif=\"ligne.evolutionMotif\"></aeq-badge-ecart></td></tr></tbody></table><p \nclass=\"aeq-hint\">\nLe tiret « — » signale un chapitre dont aucune question n\'ouvre le « Non concerné », à ne pas confondre avec 0 %. Un chapitre à \n<b>sous-population</b> porte sur moins d\'officines que les autres : son pourcentage n\'est pas comparable au leur. <span\n ng-if=\"resultats.perimetre === \'GROUPEMENT\'\">Un chapitre sous <b>60 % de « Oui »</b>\n est signalé comme point de vigilance, comme dans l\'espace du groupement.</span></p></section><section \nclass=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">\nVue d\'ensemble{{groupementDesResultats ? \' — \' + groupementDesResultats.libelle : \' nationale\'}}</h2><p \nclass=\"qs-config-card-subtitle\">Répartition en quatre modalités, chapitre par chapitre.</p></div></header><div \nclass=\"aeq-hgrid\"><div class=\"aeq-hrow\" ng-repeat=\"ligne in lignesChapitres() track by ligne.chapitreId\"><span \nclass=\"aeq-hlab\"><span class=\"aeq-cdot\" ng-style=\"{background: ligne.couleurHex}\"></span>\n {{ligne.code}} · {{ligne.titre}}</span><aeq-barre-empilee ligne=\"ligne\" palette=\"resultats.palette\">\n</aeq-barre-empilee></div></div></section><aeq-focus-reseau ng-if=\"focusReseau\" donnees=\"focusReseau\" \ntitre=\"{{groupementDesResultats ? \'Focus du réseau — \' + groupementDesResultats.libelle : \'Focus du réseau — national\'}}\">\n</aeq-focus-reseau></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'soumissions\'\"><div \nclass=\"aeq-note aeq-note--warn aeq-note--action\" \nng-if=\"campagne.nbSansGroupement > 0\n                    && (campagne.nbGroupementRattrapable > 0 || campagne.parcCrmVide)\">\n<span><b>{{campagne.nbSansGroupement}} soumission(s) sans groupement.</b>\n Le cache du parc CRM était vide quand elles ont été créées ; tant qu\'elles ne sont pas rattachées, l\'espace groupement de ce millésime reste vide. \n<span ng-if=\"campagne.nbGroupementRattrapable > 0\"><b>{{campagne.nbGroupementRattrapable}}</b>\n peuvent être rattachées tout de suite. </span><span ng-if=\"!campagne.nbGroupementRattrapable && campagne.parcCrmVide\">\n<b>Aucune ne peut l\'être pour l\'instant</b>\n : le cache du parc CRM n\'a jamais été rempli, les fiches des officines ne portent donc aucun réseau. Rafraîchissez-le d\'abord — c\'est lui que le rattrapage recopie, pas le CRM directement. \n</span></span><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-if=\"campagne.parcCrmVide\" \nng-click=\"rafraichirParcCrm()\" ng-disabled=\"rafraichissementParc\">\n{{rafraichissementParc ? \'Rafraîchissement…\' : \'Rafraîchir le cache du parc CRM\'}}</button> <button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-if=\"campagne.nbGroupementRattrapable > 0\" ng-click=\"completerGroupements()\" \nng-disabled=\"completionGroupements\">{{completionGroupements ? \'Complétion…\' : \'Compléter les groupements\'}}</button>\n</div><section class=\"qs-config-card\" ng-if=\"participation && participation.groupements.length\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon \nmd-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Participation par groupement</h2><p class=\"qs-config-card-subtitle\">\nOfficines ayant validé, sur la cible de chaque groupement{{participation.provisoire ? \', à date\' : \'\'}}. Cliquez sur un groupement pour filtrer la liste des officines.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"participation.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{participation.total.tauxParticipation | number:1}} % au national</span></header><table \nclass=\"aeq-tbl aeq-participation\"><thead><tr><th>Groupement</th><th>Cible</th><th>Validées</th><th \nng-if=\"participation.total.rouvertes > 0\">Rouvertes</th><th ng-if=\"campagne.statut !== \'CLOTUREE\'\">En cours</th><th \nng-if=\"campagne.statut !== \'CLOTUREE\'\">Non commencées</th><th ng-if=\"campagne.statut === \'CLOTUREE\'\">Partielles</th><th\n ng-if=\"campagne.statut === \'CLOTUREE\'\">Non répondues</th><th>Participation</th></tr></thead><tbody><tr \nng-repeat=\"ligne in participation.groupements track by $index\" class=\"aeq-participation-ligne\" \nng-class=\"{\'aeq-participation-ligne--active\': ligne.code && filtres.groupement === ligne.code,\n                             \'aeq-participation-ligne--inerte\': !ligne.code}\" \nng-click=\"filtrerSurGroupement(ligne)\" title=\"{{ligne.code ? \'Filtrer la liste sur \' + ligne.libelle : \'\'}}\"><td><b>\n{{ligne.libelle}}</b></td><td class=\"aeq-mono\">{{ligne.cible}}</td><td class=\"aeq-mono\">{{ligne.validees}}</td><td \nclass=\"aeq-mono\" ng-if=\"participation.total.rouvertes > 0\">{{ligne.rouvertes}}</td><td class=\"aeq-mono\" \nng-if=\"campagne.statut !== \'CLOTUREE\'\">{{ligne.enCours}}</td><td class=\"aeq-mono\" \nng-if=\"campagne.statut !== \'CLOTUREE\'\">{{ligne.nonCommencees}}</td><td class=\"aeq-mono\" \nng-if=\"campagne.statut === \'CLOTUREE\'\">{{ligne.partielles}}</td><td class=\"aeq-mono\" \nng-if=\"campagne.statut === \'CLOTUREE\'\">{{ligne.nonRepondues}}</td><td><span class=\"aeq-participation-taux\"><span \nclass=\"aeq-participation-piste\"><span ng-style=\"{width: (ligne.tauxParticipation || 0) + \'%\'}\"></span></span> <b>\n{{aUneValeur(ligne.tauxParticipation) ? (ligne.tauxParticipation | number:1) + \' %\' : \'—\'}}</b></span></td></tr><tr \nclass=\"aeq-tbl-synthese\"><td><b>Total</b></td><td class=\"aeq-mono\">{{participation.total.cible}}</td><td \nclass=\"aeq-mono\">{{participation.total.validees}}</td><td class=\"aeq-mono\" ng-if=\"participation.total.rouvertes > 0\">\n{{participation.total.rouvertes}}</td><td class=\"aeq-mono\" ng-if=\"campagne.statut !== \'CLOTUREE\'\">\n{{participation.total.enCours}}</td><td class=\"aeq-mono\" ng-if=\"campagne.statut !== \'CLOTUREE\'\">\n{{participation.total.nonCommencees}}</td><td class=\"aeq-mono\" ng-if=\"campagne.statut === \'CLOTUREE\'\">\n{{participation.total.partielles}}</td><td class=\"aeq-mono\" ng-if=\"campagne.statut === \'CLOTUREE\'\">\n{{participation.total.nonRepondues}}</td><td><span class=\"aeq-participation-taux\"><span \nclass=\"aeq-participation-piste\"><span ng-style=\"{width: (participation.total.tauxParticipation || 0) + \'%\'}\"></span>\n</span> <b>\n{{aUneValeur(participation.total.tauxParticipation) ? (participation.total.tauxParticipation | number:1) + \' %\' : \'—\'}}\n</b></span></td></tr></tbody></table></section><section class=\"qs-config-card\"><header class=\"qs-config-card-header\">\n<div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-pharmacy\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Suivi des officines</h2><p \nclass=\"qs-config-card-subtitle\">Consultez l\'avancement du questionnaire de chaque officine concernée.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge is-selected\">{{pagination.total}}</span></header><div \nclass=\"aeq-barre-outils aeq-suivi-filtres\"><input type=\"search\" ng-model=\"filtres.recherche\" \nng-change=\"rechercheModifiee()\" placeholder=\"Rechercher une officine ou un CIP\"><select class=\"aeq-filtre-groupement\" \nng-model=\"filtres.groupement\" ng-change=\"filtrer()\" ng-if=\"groupements.length\" \nng-options=\"g.code as (g.libelle + \' (\' + g.nbSoumissions + \')\') for g in groupements\"><option value=\"\">\nTous les groupements</option></select><select ng-model=\"filtres.statut\" ng-change=\"filtrer()\"><option value=\"\">\nTous les statuts</option><option ng-repeat=\"s in statutsFiltrables() track by s.code\" value=\"{{s.code}}\">{{s.libelle}}\n</option></select><select ng-model=\"filtres.compte\" ng-change=\"filtrer()\"><option value=\"\">Tous les comptes</option>\n<option ng-repeat=\"c in FILTRES_COMPTE track by c.code\" value=\"{{c.code}}\">{{c.libelle}}</option></select></div><div \nclass=\"aeq-suivi-actions\"><div class=\"aeq-suivi-groupe\" ng-if=\"campagne.statut === \'OUVERTE\'\"><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost\" ng-if=\"campagne.statut === \'OUVERTE\'\" \nng-click=\"ouvrirAjoutCible($event)\"><md-icon md-font-icon=\"icon-plus\" class=\"s14\"></md-icon><span>\nAjouter une officine à la campagne en cours</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-if=\"campagne.statut !== \'CLOTUREE\'\" ng-click=\"relancerLot($event)\">\n<md-icon md-font-icon=\"icon-email\" class=\"s14\"></md-icon><span>Relancer les non validées</span></button></div><div \nclass=\"aeq-suivi-groupe aeq-suivi-groupe--exports\"><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--secondary\" \ntitle=\"Réclamations, verbatims et baromètre de satisfaction de toute la campagne, quels que soient les filtres.\" \nng-click=\"exporterSatisfaction()\" ng-disabled=\"exportSatisfaction\"><md-icon md-font-icon=\"icon-download\" class=\"s14\">\n</md-icon><span>{{exportSatisfaction ? \'Préparation…\' : \'Rapport satisfaction\'}}</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--secondary\" \ntitle=\"Une feuille PHSQ pour toute la campagne, puis une feuille par groupement, quels que soient les filtres.\" \nng-click=\"exporterRapportSynthese()\" ng-disabled=\"exportRapportSynthese\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s14\"></md-icon><span>{{exportRapportSynthese ? \'Préparation…\' : \'Rapport de synthèse\'}}</span></button> <button \ntype=\"button\" class=\"admin-suivi-btn admin-suivi-btn--secondary\" \ntitle=\"{{suiviFiltre() ? \'Les réponses des \' + pagination.total + \' officine(s) affichée(s) : il suit les filtres.\' : \'Les réponses de toutes les officines de la campagne, une ligne par officine.\'}}\" \nng-click=\"exporterReponses()\" ng-disabled=\"exportReponses\"><md-icon md-font-icon=\"icon-download\" class=\"s14\"></md-icon>\n<span>{{exportReponses ? \'Préparation…\' : \'Exporter les réponses\'}}</span></button></div></div><p \nclass=\"aeq-suivi-exports-aide\"><span ng-if=\"!suiviFiltre()\">Les trois exports portent sur toute la campagne.</span> \n<span ng-if=\"suiviFiltre()\">« Exporter les réponses » portera sur les <b>{{pagination.total}} officine(s) affichée(s)\n</b> ; les rapports satisfaction et de synthèse portent toujours sur toute la campagne.</span></p><aeq-aide \nresume=\"Comment lire les statuts, et ce que la clôture en fait\"><div class=\"aeq-aide-section\">Pendant la campagne</div>\n<ul class=\"aeq-aide-liste\"><li><dfn>Non commencée</dfn><span>{{definitionStatut(\'NON_COMMENCEE\')}}</span></li><li><dfn>\nEn cours</dfn><span>{{definitionStatut(\'EN_COURS\')}} Titulaire et responsable qualité peuvent tous deux répondre.\n</span></li><li><dfn>Validée</dfn><span>{{definitionStatut(\'VALIDEE\')}}</span></li><li><dfn>Rouverte</dfn><span>\n{{definitionStatut(\'ROUVERTE\')}} L\'officine doit valider à nouveau.</span></li></ul><div class=\"aeq-aide-section\">\nÀ la clôture, chaque officine prend son statut définitif</div><ul class=\"aeq-aide-liste\"><li><dfn>Non répondue</dfn>\n<span>Elle était « Non commencée » : aucune réponse.</span></li><li><dfn>Partielle</dfn><span>\nElle était « En cours » : des réponses, mais aucune validation.</span></li><li><dfn>Validée</dfn><span>\nUne officine « Rouverte » revient à sa dernière version validée.</span></li></ul><div class=\"aeq-aide-section\">\nÀ retenir</div><p>\nLes deux familles ne se mélangent donc pas : une campagne ouverte n\'a ni « Partielle » ni « Non répondue », une campagne clôturée n\'a plus ni « Non commencée » ni « En cours ». Le filtre de statut ne propose que ceux de l\'état de la campagne.\n</p></aeq-aide><table class=\"aeq-tbl aeq-suivi-tbl\"><thead><tr><th>Pharmacie</th><th>CIP</th><th>Groupement</th><th>\nStatut</th><th \ntitle=\"« Activé » quand le titulaire a créé son mot de passe ; la date est celle de sa dernière connexion à LQO.\">\nCompte titulaire</th><th>Date de validation</th><th>Score</th><th></th></tr></thead><tbody><tr \nng-repeat=\"ligne in soumissions.lignes track by ligne.soumissionId\"><td><b>{{ligne.nom}}</b></td><td class=\"aeq-mono\">\n{{ligne.cip}}</td><td>{{ligne.groupement}}</td><td><span class=\"qs-campagne-template-state\" \ntitle=\"{{definitionStatut(ligne.statut)}}\" \nng-class=\"{\n                      \'is-selected\': ligne.statut === \'VALIDEE\',\n                      \'is-empty\': ligne.statut === \'NON_REPONDUE\',\n                      \'is-neutre\': ligne.statut !== \'VALIDEE\' &amp;&amp; ligne.statut !== \'NON_REPONDUE\'}\">\n{{ligne.statut | aeqStatutSoumission}}</span></td><td><div class=\"aeq-compte\"><button type=\"button\" \nclass=\"aeq-compte-chip\" ng-class=\"classeCompte(ligne)\" ng-click=\"ouvrirAcces(ligne, $event)\"><span \nclass=\"aeq-compte-point\"></span> <span>{{ligne.compteTitulaire | aeqCompteTitulaire}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s14\"></md-icon></button> <span class=\"aeq-compte-connexion\" \nng-if=\"ligne.derniereConnexion\" title=\"{{ligne.derniereConnexion | date:\'dd/MM/yyyy à HH:mm\'}}\">\nConnecté le {{ligne.derniereConnexion | date:\'dd/MM/yyyy\'}}</span> <span \nclass=\"aeq-compte-connexion aeq-compte-connexion--jamais\" ng-if=\"!ligne.derniereConnexion\">Jamais connecté</span></div>\n</td><td>{{ligne.dateValidation | date:\'dd/MM/yyyy\'}}</td><td class=\"aeq-mono\">\n{{aUneValeur(ligne.scoreOui) ? (ligne.scoreOui | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-actions\"><button \ntype=\"button\" class=\"admin-suivi-btn admin-suivi-btn--ghost admin-suivi-btn--sm\" \nng-if=\"ligne.statut === \'VALIDEE\' && campagne.statut !== \'CLOTUREE\'\" ng-click=\"rouvrir(ligne, $event)\"><md-icon \nmd-font-icon=\"icon-restore\" class=\"s14\"></md-icon><span>Rouvrir</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary admin-suivi-btn--sm\" \nng-if=\"ligne.statut !== \'VALIDEE\' && campagne.statut === \'OUVERTE\'\" ng-click=\"relancerOfficine(ligne, $event)\"><md-icon\n md-font-icon=\"icon-email\" class=\"s14\"></md-icon><span>Relancer</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost admin-suivi-btn--sm admin-suivi-btn--icone\" \nng-click=\"ouvrirAcces(ligne, $event)\" \ntitle=\"Accès de l\'officine : comptes, e-mails envoyés, renvoi de l\'e-mail de lancement\" \naria-label=\"Accès de l\'officine\"><md-icon md-font-icon=\"icon-key\" class=\"s14\"></md-icon></button> <button \ntype=\"button\" class=\"admin-suivi-btn admin-suivi-btn--ghost admin-suivi-btn--sm\" ng-click=\"voirJournal(ligne, $event)\">\n<md-icon md-font-icon=\"icon-history\" class=\"s14\"></md-icon><span>Journal</span></button></td></tr></tbody></table><div \nclass=\"qs-verbatim-pagination\" ng-if=\"nbPages() > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: pagination.page <= 1}\"><button type=\"button\" ng-disabled=\"pagination.page <= 1\" \nng-click=\"changerPage(pagination.page - 1, pagination.page)\" aria-label=\"Page précédente\">&lsaquo;</button></li><li \nng-repeat=\"numero in pagesSoumissions() track by $index\" \nng-class=\"{active: pagination.page === numero, disabled: numero === \'...\'}\"><button type=\"button\" \nng-if=\"numero !== \'...\'\" ng-disabled=\"pagination.page === numero\" ng-click=\"changerPage(numero, pagination.page)\">\n{{numero}}</button> <button type=\"button\" ng-if=\"numero === \'...\'\" disabled=\"disabled\">...</button></li><li \nng-class=\"{disabled: pagination.page >= nbPages()}\"><button type=\"button\" ng-disabled=\"pagination.page >= nbPages()\" \nng-click=\"changerPage(pagination.page + 1, pagination.page)\" aria-label=\"Page suivante\">&rsaquo;</button></li></ul>\n</div></section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'satisfaction\'\"><div \nclass=\"aeq-barre-outils aeq-barre-onglet\"><label ng-if=\"groupements.length\">Groupement<select \nng-model=\"satisfactionFiltres.groupement\" ng-change=\"changerGroupementSatisfaction()\" \nng-options=\"g.code as g.libelle for g in groupements\"><option value=\"\">National (tous les groupements)</option>\n</select></label><span class=\"aeq-espace\"></span><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--secondary\" \ntitle=\"Réclamations, verbatims et baromètre de satisfaction de toute la campagne, quels que soient les filtres.\" \nng-click=\"exporterSatisfaction()\" ng-disabled=\"exportSatisfaction\"><md-icon md-font-icon=\"icon-download\" class=\"s14\">\n</md-icon><span>{{exportSatisfaction ? \'Préparation…\' : \'Rapport satisfaction\'}}</span></button></div><section \nclass=\"qs-config-card\" ng-if=\"satisfaction\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-emoticon-happy\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">\n{{groupementDeLaSatisfaction ? \'Satisfaction — \' + groupementDeLaSatisfaction.libelle : \'Satisfaction nationale\'}}</h2>\n<p class=\"qs-config-card-subtitle\">\nLe chapitre « Votre satisfaction », officines validées. « % satisfaits » : « Très satisfait » et « Satisfait » sur les réponses autres que « Non concerné ».\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"satisfaction.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{satisfaction.nbOfficines}} validée{{satisfaction.nbOfficines > 1 ? \'s\' : \'\'}}{{satisfaction.provisoire ? \' · provisoire\' : \'\'}}\n</span></header><div class=\"aeq-note aeq-note--info\" ng-if=\"satisfaction.provisoire\"><b>Campagne en cours</b>\n : ces chiffres évoluent à chaque validation.</div><table class=\"aeq-tbl\"><thead><tr><th>Question</th><th \nclass=\"aeq-sat-d\">Réponses</th><th class=\"aeq-sat-d\" \nng-repeat=\"modalite in satisfaction.palette track by modalite.valeur\">{{modalite.libelle}}</th><th class=\"aeq-sat-d\">\n% satisfaits</th><th class=\"aeq-sat-d\" ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\">National</th><th \nng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\">Écart</th></tr></thead><tbody><tr \nng-repeat=\"question in satisfaction.questions track by question.questionId\"><td><span class=\"aeq-sat-num\">\n{{question.numero}}</span> {{question.libelle}}</td><td class=\"aeq-mono aeq-sat-d\">{{question.nbReponses}}</td><td \nclass=\"aeq-mono aeq-sat-d\" ng-repeat=\"modalite in satisfaction.palette track by modalite.valeur\">\n{{partSatisfaction(question, modalite.valeur) && aUneValeur(partSatisfaction(question, modalite.valeur).pct) ? (partSatisfaction(question, modalite.valeur).pct | number:0) + \' %\' : \'—\'}}\n</td><td class=\"aeq-mono aeq-sat-d\"><b>\n{{aUneValeur(question.pctSatisfaits) ? (question.pctSatisfaits | number:0) + \' %\' : \'—\'}}</b></td><td \nclass=\"aeq-mono aeq-sat-d\" ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\">\n{{aUneValeur(question.nationalPctSatisfaits) ? (question.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}</td><td \nng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\"><aeq-badge-ecart valeur=\"question.ecartPts\" suffixe=\"\'vs national\'\">\n</aeq-badge-ecart></td></tr><tr class=\"aeq-tbl-synthese\"><td><b>Ensemble du baromètre</b></td><td></td><td \nng-repeat=\"modalite in satisfaction.palette track by modalite.valeur\"></td><td class=\"aeq-mono aeq-sat-d\">\n{{aUneValeur(satisfaction.pctSatisfaits) ? (satisfaction.pctSatisfaits | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-sat-d\" ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\">\n{{aUneValeur(satisfaction.nationalPctSatisfaits) ? (satisfaction.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}</td>\n<td ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\"><aeq-badge-ecart valeur=\"satisfaction.ecartPts\" \nsuffixe=\"\'vs national\'\"></aeq-badge-ecart></td></tr></tbody></table><div class=\"aeq-hgrid\"><div class=\"aeq-hrow\" \nng-repeat=\"question in satisfaction.questions track by question.questionId\"><span class=\"aeq-hlab\"><span \nclass=\"aeq-sat-num\">{{question.numero}}</span> {{question.libelle}}</span> <span class=\"aeq-barre\" \nng-class=\"{\'aeq-barre--vide\': !question.nbReponses}\"><span class=\"aeq-barre-seg\" \nng-repeat=\"part in partsAvecValeur(question.distribution) track by part.cle\" \nng-class=\"{\'aeq-barre-seg--pale\': part.cle !== \'TRES_SATISFAIT\' && part.cle !== \'TRES_INSATISFAIT\'}\" \nng-style=\"{width: part.pct + \'%\', background: part.couleurHex}\" \ntitle=\"{{part.libelle}} : {{part.nb}} ({{part.pct | number:1}} %)\"><span ng-if=\"part.pct >= 8\">\n{{part.pct | number:0}} %</span></span></span></div></div><div class=\"aeq-sat-legende\"><span \nng-repeat=\"modalite in satisfaction.palette track by modalite.valeur\"><span class=\"aeq-sat-legende-dot\" \nng-style=\"{background: modalite.couleurHex}\"></span>{{modalite.libelle}}</span></div></section><section \nclass=\"qs-config-card\" ng-if=\"satisfaction && satisfaction.nbOfficines\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-table-large\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Réponses par officine</h2><p \nclass=\"qs-config-card-subtitle\">\nChaque officine validée{{groupementDeLaSatisfaction ? \' du groupement\' : \'\'}}, ses réponses et son commentaire. Les moins satisfaites d\'abord.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge is-selected\" \nng-if=\"satisfactionPagination.total\">{{satisfactionPagination.total}}</span></header><div class=\"aeq-barre-outils\">\n<input type=\"search\" ng-model=\"satisfactionFiltres.recherche\" ng-change=\"rechercheSatisfactionModifiee()\" \nplaceholder=\"Rechercher une officine, un CIP ou un groupement\"><select ng-model=\"satisfactionFiltres.filtre\" \nng-change=\"filtrerSatisfaction()\"><option value=\"\">Toutes les officines</option><option value=\"INSATISFAITS\">\nAu moins une insatisfaction{{satisfactionOfficines ? \' (\' + satisfactionOfficines.totalAvecInsatisfaction + \')\' : \'\'}}\n</option></select></div><div style=\"overflow-x: auto\" ng-if=\"satisfactionOfficines\"><table class=\"aeq-tbl\"><thead><tr>\n<th><span class=\"aeq-triable\" ng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'nom\'}\" \nng-click=\"trierSatisfaction(\'nom\')\">Pharmacie<span class=\"aeq-tri-fleche\" ng-if=\"satisfactionTri.colonne === \'nom\'\">\n{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></span></th><th><span class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'groupement\'}\" ng-click=\"trierSatisfaction(\'groupement\')\">\nGroupement<span class=\"aeq-tri-fleche\" ng-if=\"satisfactionTri.colonne === \'groupement\'\">\n{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></span></th><th class=\"aeq-sat-c\" \nng-repeat=\"question in satisfactionOfficines.questions track by question.questionId\" title=\"{{question.libelle}}\">\n{{question.numero}}</th><th class=\"aeq-sat-d\"><span class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'satisfaction\'}\" \nng-click=\"trierSatisfaction(\'satisfaction\')\">Satisfaits<span class=\"aeq-tri-fleche\" \nng-if=\"satisfactionTri.colonne === \'satisfaction\'\">{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></span></th>\n<th>Commentaire</th></tr></thead><tbody><tr ng-if=\"!satisfactionOfficines.lignes.length\"><td \ncolspan=\"{{satisfactionOfficines.questions.length + 4}}\" class=\"aeq-t-faible\">\nAucune officine ne correspond à la recherche.</td></tr><tr \nng-repeat=\"ligne in satisfactionOfficines.lignes track by ligne.soumissionId\"><td><b>{{ligne.nom}}</b><br><span \nclass=\"aeq-t-faible\">{{ligne.cip}}<span ng-if=\"ligne.ville\"> · {{ligne.ville}}</span></span></td><td>\n{{ligne.groupement || \'—\'}}</td><td class=\"aeq-sat-c\" ng-repeat=\"valeur in ligne.reponses track by $index\"><span \nclass=\"aeq-sat-rep\" ng-if=\"valeur\" ng-class=\"{\'aeq-sat-rep--fonce\': valeur === \'TRES_INSATISFAIT\'}\" \nng-style=\"{background: modaliteSatisfaction(valeur).couleurHex}\" title=\"{{modaliteSatisfaction(valeur).libelle}}\">\n{{abregeSatisfaction(valeur)}}</span> <span class=\"aeq-sat-rep aeq-sat-rep--vide\" ng-if=\"!valeur\">—</span></td><td \nclass=\"aeq-mono aeq-sat-d\"><b>{{aUneValeur(ligne.pctSatisfaits) ? (ligne.pctSatisfaits | number:0) + \' %\' : \'—\'}}</b>\n</td><td class=\"aeq-sat-com\">{{ligne.commentaire ? \'« \' + ligne.commentaire + \' »\' : \'—\'}}</td></tr></tbody></table>\n</div><div class=\"qs-verbatim-pagination\" ng-if=\"nbPagesSatisfaction() > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: satisfactionPagination.page <= 1}\"><button type=\"button\" \nng-disabled=\"satisfactionPagination.page <= 1\" \nng-click=\"changerPageSatisfaction(satisfactionPagination.page - 1, satisfactionPagination.page)\" \naria-label=\"Page précédente\">&lsaquo;</button></li><li ng-repeat=\"numero in pagesSatisfaction() track by $index\" \nng-class=\"{active: satisfactionPagination.page === numero, disabled: numero === \'...\'}\"><button type=\"button\" \nng-if=\"numero !== \'...\'\" ng-disabled=\"satisfactionPagination.page === numero\" \nng-click=\"changerPageSatisfaction(numero, satisfactionPagination.page)\">{{numero}}</button> <button type=\"button\" \nng-if=\"numero === \'...\'\" disabled=\"disabled\">...</button></li><li \nng-class=\"{disabled: satisfactionPagination.page >= nbPagesSatisfaction()}\"><button type=\"button\" \nng-disabled=\"satisfactionPagination.page >= nbPagesSatisfaction()\" \nng-click=\"changerPageSatisfaction(satisfactionPagination.page + 1, satisfactionPagination.page)\" \naria-label=\"Page suivante\">&rsaquo;</button></li></ul></div><p class=\"aeq-hint\"><b>Questions</b> : <span \nng-repeat=\"question in satisfactionOfficines.questions track by question.questionId\">\n{{question.numero}} {{question.libelle}}{{$last ? \'.\' : \' · \'}}</span> <b>Réponses</b>\n : TS très satisfait, S satisfait, I insatisfait, TI très insatisfait, NC non concerné.</p></section></div></div></div>\n</div>");
$templateCache.put("app/main/admin/auto-evaluation/campagnes.html","<div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page qs-config-campagne-page aeq-admin\"><div \nclass=\"header md-accent-bg qs-config-campagne-header\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\"><span><md-icon md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\" \nclass=\"s24\"></md-icon></span><span>Auto-évaluation</span></div><div class=\"h2 mt-4\">\nLes campagnes annuelles et leur cycle de vie</div></div></div></div><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"end center\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"creer()\" \nng-disabled=\"traitement\">Créer la prochaine campagne</button></div></div><div \nclass=\"nl-Content qs-config-campagne-content\"><div class=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">{{erreur.message}}\n</div><div class=\"aeq-note aeq-note--info\"><b>L\'ouverture et la clôture sont automatiques</b>\n, aux dates enregistrées dans chaque campagne. Il n\'existe volontairement aucun bouton pour les déclencher à la main.\n</div><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Campagnes</h2><p \nclass=\"qs-config-card-subtitle\">Une ligne par millésime, la plus récente en tête.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge is-selected\" ng-if=\"campagnes.length\">{{campagnes.length}}\n</span></header><div class=\"aeq-note aeq-note--info\" ng-if=\"!chargement && !campagnes.length\">\nAucune campagne. Créez la prochaine pour commencer.</div><table class=\"aeq-tbl\" ng-if=\"campagnes.length\"><thead><tr>\n<th>Année</th><th>Statut</th><th>Fenêtre</th><th>Questionnaire</th><th>Cible</th><th>Soumissions</th><th>Validées</th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"campagne in campagnes track by campagne.id\" class=\"aeq-tbl-ouvrable\" \nng-click=\"ouvrir(campagne)\"><td><b>{{campagne.annee}}</b> <span class=\"aeq-pill aeq-pill--close\" \nng-if=\"campagne.historique\">reprise</span></td><td><span class=\"qs-campagne-template-state\" \nng-class=\"{\n                  \'is-selected\': campagne.statut === \'OUVERTE\',\n                  \'is-brouillon\': campagne.statut === \'BROUILLON\',\n                  \'is-neutre\': campagne.statut !== \'OUVERTE\' && campagne.statut !== \'BROUILLON\'}\">\n{{campagne.statut | aeqStatutCampagne}}</span></td><td><span ng-if=\"campagne.dateOuverture\">\n{{campagne.dateOuverture | date:\'dd/MM/yyyy\'}} &ndash; {{campagne.dateClotureEffective | date:\'dd/MM/yyyy\'}} </span>\n<span ng-if=\"!campagne.dateOuverture\" class=\"aeq-t-faible\">dates non saisies</span> <span class=\"aeq-hint\" \nng-if=\"campagne.dateProlongation\">prolongée jusqu\'au {{campagne.dateProlongation | date:\'dd/MM/yyyy\'}}</span></td><td>\n{{campagne.statutQuestionnaire | aeqStatutQuestionnaire}} <span class=\"aeq-hint\" ng-if=\"campagne.nbQuestions\">\n{{campagne.nbChapitres}} chapitres, {{campagne.nbQuestions}} questions</span></td><td class=\"aeq-mono\">\n{{campagne.effectifCible || \'—\'}}</td><td class=\"aeq-mono\">{{campagne.nbSoumissions || \'—\'}}</td><td class=\"aeq-mono\">\n{{campagne.nbValidees || \'—\'}}</td><td class=\"aeq-actions\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--sm nl-Btn--danger\" ng-if=\"campagne.supprimable\" ng-click=\"supprimer(campagne, $event)\">Supprimer\n</button></td></tr></tbody></table><p class=\"aeq-hint\" ng-if=\"campagnes.length\">Une campagne n\'est supprimable qu\'en \n<b>brouillon</b> et sans aucune soumission.</p></section></div></div>");
$templateCache.put("app/main/admin/auto-evaluation/taches.html","<div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page qs-config-campagne-page aeq-admin\"><div \nclass=\"header md-accent-bg qs-config-campagne-header\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\"><span><md-icon md-font-icon=\"icon-history\" class=\"s24\"></md-icon></span>\n<span>File de tâches</span></div><div class=\"h2 mt-4\">Rapports, e-mails, notifications et archives</div></div></div>\n</div><div class=\"white-fg\" layout=\"row\" layout-align=\"end center\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"charger()\" ng-disabled=\"chargement\">Rafraîchir</button></div></div><div \nclass=\"nl-Content qs-config-campagne-content\"><div class=\"aeq-crumb\"><a ui-sref=\"admin.autoeval\">Campagnes</a> <span \nclass=\"aeq-sep\">/</span> <a ui-sref=\"admin.autoeval.campagne({id: campagneId})\">Campagne</a> <span class=\"aeq-sep\">/\n</span> <span class=\"aeq-cur\">File de tâches</span></div><div class=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">\n{{erreur.message}}</div><aeq-aide \nresume=\"À quoi sert cette file, ce que veut dire chaque type de tâche, et la règle de reprise\"><p><b>\nTout ce que la campagne produit en arrière-plan passe par cette file.</b>\n Un rapport, un e-mail ou une archive ne sont pas fabriqués sur le moment : ils sont mis en attente, puis traités un par un. Cette page montre où en est chacun de ces travaux.\n</p><p>\nVenez-y quand une officine n\'a pas reçu son e-mail ou son rapport : sa ligne dit si le travail attend encore, s\'il est passé, ou pourquoi il a échoué. Rien ne se saisit ici, on ne fait qu\'observer et, au besoin, relancer.\n</p><div class=\"aeq-aide-section\">Les types de tâche</div><ul class=\"aeq-aide-liste\"><li><dfn>Génération du rapport\n</dfn> <span>Le rapport d\'une officine, calculé à partir de ses réponses.</span></li><li><dfn>Envoi d\'e-mail</dfn> \n<span>Un e-mail de la campagne à une officine, monté sur son gabarit.</span></li><li><dfn>Notification interne</dfn> \n<span>Un message à PHSQ ou à un groupement, qui ne part pas aux officines.</span></li><li><dfn>Archive de rapports\n</dfn> <span>Plusieurs rapports regroupés en une archive à télécharger.</span></li></ul><div class=\"aeq-aide-section\">\nLes statuts</div><ul class=\"aeq-aide-liste\"><li><dfn>À faire</dfn><span>\nEn attente dans la file, rien n\'a encore commencé.</span></li><li><dfn>En cours</dfn><span>\nLe travail est en train de se faire.</span></li><li><dfn>Faite</dfn><span>\nTerminée, l\'envoi ou le calcul est allé au bout.</span></li><li><dfn>En échec</dfn><span>\nLe travail n\'est pas passé ; la colonne « Dernière erreur » dit pourquoi.</span></li></ul><div \nclass=\"aeq-aide-section\">La règle de reprise</div><p>Une tâche en échec est <b>réessayée cinq fois</b>\n, avec un délai qui double à chaque fois — c\'est ce que compte la colonne <b>Tentatives</b>\n. Passé ces cinq essais elle s\'arrête et attend une relance manuelle : une tâche qui a échoué cinq fois demande un regard, pas une boucle. Le bouton \n<b>Relancer</b> n\'apparaît que sur ces lignes-là et remet le compteur à zéro.</p></aeq-aide><div class=\"aeq-chiffres\" \nng-if=\"compteurs.length\"><div class=\"aeq-chiffre\" ng-repeat=\"compteur in compteurs track by $index\"><span \nclass=\"aeq-chiffre-val\">{{compteur.nombre}}</span> <span class=\"aeq-chiffre-lab\">\n{{compteur.type | aeqTypeTache}} &middot; {{compteur.statut | aeqStatutTache}}</span></div></div><section \nclass=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-history\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Tâches</h2><p \nclass=\"qs-config-card-subtitle\">Les cent plus récentes, rafraîchies toutes les quinze secondes.</p></div></header><div \nclass=\"aeq-barre-outils\"><select ng-model=\"statut\" ng-change=\"charger()\"><option value=\"\">Tous les statuts</option>\n<option value=\"A_FAIRE\">À faire</option><option value=\"EN_COURS\">En cours</option><option value=\"FAIT\">Faites</option>\n<option value=\"ECHEC\">En échec</option></select></div><table class=\"aeq-tbl\" ng-if=\"taches.length\"><thead><tr><th>Type\n</th><th>Statut</th><th>Tentatives</th><th>Créée</th><th>Terminée</th><th>Dernière erreur</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"tache in taches track by tache.id\"><td><b>{{tache.type | aeqTypeTache}}</b></td><td><span \nclass=\"qs-campagne-template-state\" \nng-class=\"{\n                  \'is-selected\': tache.statut === \'FAIT\',\n                  \'is-neutre\': tache.statut === \'A_FAIRE\' || tache.statut === \'EN_COURS\',\n                  \'is-empty\': tache.statut === \'ECHEC\'}\">\n{{tache.statut | aeqStatutTache}}</span></td><td class=\"aeq-mono\">{{tache.tentatives}}</td><td>\n{{tache.dateCreation | date:\'dd/MM HH:mm\'}}</td><td>{{tache.dateFin | date:\'dd/MM HH:mm\'}}</td><td class=\"aeq-erreur\">\n{{tache.derniereErreur}}</td><td class=\"aeq-actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--sm nl-Btn--outline\" \nng-if=\"tache.statut === \'ECHEC\'\" ng-click=\"relancer(tache)\">Relancer</button></td></tr></tbody></table><div \nclass=\"aeq-note aeq-note--info\" ng-if=\"!taches.length && !chargement\">Aucune tâche pour ce filtre.</div></section>\n</div></div>");
$templateCache.put("app/main/admin/bandeau/admin-bandeau.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-bandeau-page\"><div \nclass=\"header md-accent-bg admin-bandeau-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"admin-bandeau-header__title-group\"><div \nclass=\"h1 admin-bandeau-header__title\"><md-icon md-font-icon=\"icon-message-text-outline\" \nclass=\"s24 admin-bandeau-header__icon\"></md-icon><span>Bandeau déroulant</span></div><div \nclass=\"admin-bandeau-header__subtitle\"><span>{{bandeauxLQO.length + bandeauxLQOMINI.length}} message<span \nng-if=\"(bandeauxLQO.length + bandeauxLQOMINI.length) > 1\">s</span> actif<span \nng-if=\"(bandeauxLQO.length + bandeauxLQOMINI.length) > 1\">s</span></span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button aria-label=\"Ajouter un bandeau\" class=\"admin-bandeau-header__add\" \nng-disabled=\"bandeauxLQO.length > 2 && bandeauxLQOMINI.length > 2\" ng-click=\"openDialogNew()\"><md-tooltip \nmd-direction=\"bottom\" ng-if=\"bandeauxLQO.length > 2 && bandeauxLQOMINI.length > 2\">\nLimite de 3 messages par type atteinte</md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"!(bandeauxLQO.length > 2 && bandeauxLQOMINI.length > 2)\">Ajouter un bandeau</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span>Ajouter un message</span></md-button></div></div><div \nclass=\"content admin-bandeau-content\"><div class=\"admin-bandeau-columns\"><div \nclass=\"admin-bandeau-column admin-bandeau-column--lqo\"><div class=\"admin-bandeau-column__header\"><div \nclass=\"admin-bandeau-column__title\"><span class=\"admin-bandeau-column__pill admin-bandeau-column__pill--lqo\">LQO</span>\n <span class=\"admin-bandeau-column__count-pill\" \nng-class=\"{\n                    \'admin-bandeau-column__count-pill--empty\': bandeauxLQO.length === 0,\n                    \'admin-bandeau-column__count-pill--ok\': bandeauxLQO.length === 1,\n                    \'admin-bandeau-column__count-pill--mid\': bandeauxLQO.length === 2,\n                    \'admin-bandeau-column__count-pill--full\': bandeauxLQO.length >= 3\n                  }\">\n{{bandeauxLQO.length}}/3</span></div><button type=\"button\" class=\"admin-bandeau-column__history-btn\" \nng-click=\"goHistory(\'lqo\')\"><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon><span>Historique</span></button>\n</div><div class=\"admin-bandeau-list\" ng-if=\"bandeauxLQO.length > 0\"><div \nclass=\"admin-bandeau-card admin-bandeau-card--lqo\" ng-repeat=\"bandeau in bandeauxLQO\"><div \nclass=\"admin-bandeau-card__icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s22\"></md-icon></div><div \nclass=\"admin-bandeau-card__body\"><div class=\"admin-bandeau-card__message\" ng-bind-html=\"bandeau.message\"></div><div \nclass=\"admin-bandeau-card__meta\"><md-icon md-font-icon=\"icon-calendar-outline\" class=\"s14\"></md-icon><span>\nPublié le {{bandeau.dateDebut | date: \'dd/MM/yyyy\'}}</span></div></div><md-menu class=\"admin-bandeau-card__menu\" \nmd-menu-origin md-offset=\"-3 0\"><button type=\"button\" class=\"admin-bandeau-card__menu-btn\" aria-label=\"Actions\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"s18\"></md-icon></button>\n<md-menu-content width=\"3\" class=\"admin-bandeau-menu-content\"><md-menu-item><md-button \nng-click=\"openDialogDisplay(bandeau)\"><md-icon md-font-icon=\"icon-eye-outline\" class=\"s16\"></md-icon><span>Voir</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"openDialogUpdate(bandeau, $index)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span>Modifier</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"admin-bandeau-menu-danger\" ng-click=\"openDialogDelete(bandeau, $index)\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s16\"></md-icon><span>Supprimer</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"admin-bandeau-empty\" ng-if=\"bandeauxLQO.length === 0\"><md-icon \nmd-font-icon=\"icon-message-outline\" class=\"s28 admin-bandeau-empty__icon\"></md-icon><div \nclass=\"admin-bandeau-empty__text\">Aucun message LQO actif</div><button type=\"button\" \nclass=\"admin-bandeau-empty__cta admin-bandeau-empty__cta--lqo\" ng-click=\"openDialogNew(\'LQO\')\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s16\"></md-icon><span>Créer un message LQO</span></button></div></div><div \nclass=\"admin-bandeau-column admin-bandeau-column--mini\"><div class=\"admin-bandeau-column__header\"><div \nclass=\"admin-bandeau-column__title\"><span class=\"admin-bandeau-column__pill admin-bandeau-column__pill--mini\">\nLQO Découverte</span> <span class=\"admin-bandeau-column__count-pill\" \nng-class=\"{\n                    \'admin-bandeau-column__count-pill--empty\': bandeauxLQOMINI.length === 0,\n                    \'admin-bandeau-column__count-pill--ok\': bandeauxLQOMINI.length === 1,\n                    \'admin-bandeau-column__count-pill--mid\': bandeauxLQOMINI.length === 2,\n                    \'admin-bandeau-column__count-pill--full\': bandeauxLQOMINI.length >= 3\n                  }\">\n{{bandeauxLQOMINI.length}}/3</span></div><button type=\"button\" class=\"admin-bandeau-column__history-btn\" \nng-click=\"goHistory(\'lqo_mini\')\"><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon><span>Historique</span>\n</button></div><div class=\"admin-bandeau-list\" ng-if=\"bandeauxLQOMINI.length > 0\"><div \nclass=\"admin-bandeau-card admin-bandeau-card--mini\" ng-repeat=\"bandeau in bandeauxLQOMINI\"><div \nclass=\"admin-bandeau-card__icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"s22\"></md-icon></div><div \nclass=\"admin-bandeau-card__body\"><div class=\"admin-bandeau-card__message\" ng-bind-html=\"bandeau.message\"></div><div \nclass=\"admin-bandeau-card__meta\"><md-icon md-font-icon=\"icon-calendar-outline\" class=\"s14\"></md-icon><span>\nPublié le {{bandeau.dateDebut | date: \'dd/MM/yyyy\'}}</span></div></div><md-menu class=\"admin-bandeau-card__menu\" \nmd-menu-origin md-offset=\"-3 0\"><button type=\"button\" class=\"admin-bandeau-card__menu-btn\" aria-label=\"Actions\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"s18\"></md-icon></button>\n<md-menu-content width=\"3\" class=\"admin-bandeau-menu-content\"><md-menu-item><md-button \nng-click=\"openDialogDisplay(bandeau)\"><md-icon md-font-icon=\"icon-eye-outline\" class=\"s16\"></md-icon><span>Voir</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"openDialogUpdate(bandeau, $index)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><span>Modifier</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"admin-bandeau-menu-danger\" ng-click=\"openDialogDelete(bandeau, $index)\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s16\"></md-icon><span>Supprimer</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"admin-bandeau-empty\" ng-if=\"bandeauxLQOMINI.length === 0\"><md-icon \nmd-font-icon=\"icon-message-outline\" class=\"s28 admin-bandeau-empty__icon\"></md-icon><div \nclass=\"admin-bandeau-empty__text\">Aucun message LQO Découverte actif</div><button type=\"button\" \nclass=\"admin-bandeau-empty__cta admin-bandeau-empty__cta--mini\" ng-click=\"openDialogNew(\'LQO_MINI\')\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s16\"></md-icon><span>Créer un message Découverte</span></button></div></div></div>\n</div></div>");
$templateCache.put("app/main/admin/bandeau/history_bandeaux.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-bandeau-history-page\" \nng-class=\"type === \'LQO\' ? \'admin-bandeau-history-page--lqo\' : \'admin-bandeau-history-page--mini\'\"><div \nclass=\"header md-accent-bg admin-bandeau-history-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"admin-bandeau-history-header__title-group\">\n<div class=\"h1 admin-bandeau-history-header__title\"><md-icon md-font-icon=\"icon-history\" \nclass=\"s24 admin-bandeau-history-header__icon\"></md-icon><span>Historique des bandeaux</span> <span \nclass=\"admin-bandeau-history-header__type-pill\" \nng-class=\"type === \'LQO\' ? \'admin-bandeau-history-header__type-pill--lqo\' : \'admin-bandeau-history-header__type-pill--mini\'\">\n{{displayType}}</span></div><div class=\"admin-bandeau-history-header__subtitle\"><span ng-if=\"bandeaux.length > 0\">\n{{bandeaux.length}} message<span ng-if=\"bandeaux.length > 1\">s</span> archivé<span ng-if=\"bandeaux.length > 1\">s</span>\n</span> <span ng-if=\"bandeaux.length === 0\">Aucun message archivé</span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><button type=\"button\" class=\"admin-bandeau-history-header__back\" \nng-click=\"goAdministrationBandeau()\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon><span>Retour\n</span></button></div></div><div class=\"content admin-bandeau-history-content\"><div class=\"admin-bandeau-list\" \nng-if=\"bandeaux.length > 0\"><div class=\"admin-bandeau-card\" \nng-class=\"type === \'LQO\' ? \'admin-bandeau-card--lqo\' : \'admin-bandeau-card--mini\'\" \nng-repeat=\"bandeau in bandeaux | orderBy:\'-dateDebut\' track by $index\"><div class=\"admin-bandeau-card__icon\"><md-icon \nmd-font-icon=\"icon-message-text\" class=\"s22\"></md-icon></div><div class=\"admin-bandeau-card__body\"><div \nclass=\"admin-bandeau-card__message\" ng-bind-html=\"bandeau.message\"></div><div class=\"admin-bandeau-card__meta\"><md-icon\n md-font-icon=\"icon-calendar-outline\" class=\"s14\"></md-icon><span>Publié le {{bandeau.dateDebut | date: \'dd/MM/yyyy\'}}\n</span></div></div><md-menu class=\"admin-bandeau-card__menu\" md-menu-origin md-offset=\"-3 0\"><button type=\"button\" \nclass=\"admin-bandeau-card__menu-btn\" aria-label=\"Actions\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"s18\"></md-icon></button><md-menu-content width=\"3\" \nclass=\"admin-bandeau-menu-content\"><md-menu-item><md-button ng-click=\"openDialogDisplay(bandeau)\"><md-icon \nmd-font-icon=\"icon-eye-outline\" class=\"s16\"></md-icon><span>Voir</span></md-button></md-menu-item><md-menu-item>\n<md-button class=\"admin-bandeau-menu-danger\" ng-click=\"openDialogDelete(bandeau, $index)\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s16\"></md-icon><span>Supprimer</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"admin-bandeau-empty admin-bandeau-empty--full\" ng-if=\"bandeaux.length === 0\"><md-icon\n md-font-icon=\"icon-archive-outline\" class=\"s44 admin-bandeau-empty__icon\"></md-icon><div \nclass=\"admin-bandeau-empty__text\">Aucun message archivé</div><div class=\"admin-bandeau-empty__hint\">\nLes messages expirés apparaîtront ici</div></div></div></div>");
$templateCache.put("app/main/admin/campagne/configuration-campagne.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page qs-config-campagne-page\"><div \nclass=\"header md-accent-bg qs-config-campagne-header\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\"><span><md-icon md-font-icon=\"icon-pharmacy\" class=\"s24\"></md-icon></span>\n<span>Configuration campagne</span></div><div class=\"h2 mt-4\">Paramètres de la campagne en cours</div></div></div>\n</div></div><div class=\"nl-Content qs-config-campagne-content\"><form name=\"configurationCampagneForm\" \nclass=\"md-inline-form qs-config-campagne-form\" novalidate \nng-submit=\"configurationCampagneForm.$valid && saveConfiguration()\"><section class=\"qs-config-card\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Planification de la campagne</h2><p class=\"qs-config-card-subtitle\">\nDéfinissez les jalons clés du cycle de collecte.</p></div></header><div class=\"qs-config-timeline\"><div \nclass=\"qs-config-timeline-step\"><div class=\"qs-config-step-badge\"><span>1</span></div><div class=\"qs-config-step-body\">\n<div class=\"qs-config-step-caption\">Ouverture</div><md-input-container \nclass=\"iv-Input-container no--errors-spacer qs-config-date\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de début de la campagne<span class=\"asterix\">*</span>\n</label><div class=\"iv-Input-date-wrapper\"><md-icon class=\"iv-Input-date-icon\" \nng-click=\"datePickers.dateDebutCampagne = true\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" ng-click=\"datePickers.dateDebutCampagne = true\" md-is-open=\"datePickers.dateDebutCampagne\" \nplaceholder=\"\" md-hide-icons=\"all\" md-open-on-focus name=\"dateDebutCampagne\" \nng-model=\"configuration.dateDebutCampagne\" required></md-datepicker></div><div \nng-messages=\"configurationCampagneForm.dateDebutCampagne.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><div class=\"qs-config-step-hint\">\nPremier jour d\'ouverture aux répondants.</div></div></div><div class=\"qs-config-timeline-connector\" aria-hidden=\"true\">\n</div><div class=\"qs-config-timeline-step\"><div class=\"qs-config-step-badge\"><span>2</span></div><div \nclass=\"qs-config-step-body\"><div class=\"qs-config-step-caption\">Clôture</div><md-input-container \nclass=\"iv-Input-container no--errors-spacer qs-config-date\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de fin de la collecte<span class=\"asterix\">*</span></label>\n<div class=\"iv-Input-date-wrapper\"><md-icon class=\"iv-Input-date-icon\" ng-click=\"datePickers.dateFinCollecte = true\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" \nng-click=\"datePickers.dateFinCollecte = true\" md-is-open=\"datePickers.dateFinCollecte\" placeholder=\"\" \nmd-hide-icons=\"all\" md-open-on-focus name=\"dateFinCollecte\" ng-model=\"configuration.dateFinCollecte\" \nmd-min-date=\"configuration.dateDebutCampagne\" required></md-datepicker></div><div \nng-messages=\"configurationCampagneForm.dateFinCollecte.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><div class=\"qs-config-step-hint\">\nDernier jour pour recueillir les réponses.<br>\nLes emails de disponibilité synthèse pour pharmacies et groupements seront envoyés à minuit après cette date.</div>\n</div></div></div><div class=\"qs-config-end-campaign\" \nng-if=\"configuration.endOfCampaignNotices && configuration.endOfCampaignNotices.length\"><div \nclass=\"qs-config-end-campaign__header\"><div class=\"qs-config-end-campaign__heading\"><div \nclass=\"qs-config-end-campaign__title\">Ce qui sera reçu en fin de campagne</div><div \nclass=\"qs-config-end-campaign__subtitle\">\nLe récapitulatif est affiché ici pour éviter toute surprise côté pharmacies, groupements et administrateur.</div></div>\n<div class=\"qs-config-end-campaign__delay\" ng-if=\"configuration.endOfCampaignDelayMessage\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>{{configuration.endOfCampaignDelayMessage}}</span>\n</div></div><div class=\"qs-config-end-campaign__grid\"><article class=\"qs-config-end-campaign__item\" \nng-repeat=\"notice in configuration.endOfCampaignNotices track by notice.title\"><div \nclass=\"qs-config-end-campaign__item-title\">{{notice.title}}</div><div class=\"qs-config-end-campaign__item-message\">\n{{notice.message}}</div></article></div></div></section><section class=\"qs-config-card\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon \nmd-font-icon=\"icon-bullhorn\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Texte de diffusion</h2><p class=\"qs-config-card-subtitle\">\nMessage affiché sous les canaux de diffusion (SMS, Email, QR code, Papier, Tablette, Réseaux sociaux).</p></div>\n</header><div class=\"qs-config-quill\"><ng-quill-editor ng-model=\"configuration.diffusionMessage\"></ng-quill-editor>\n</div></section><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-email\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Canal email</h2><p \nclass=\"qs-config-card-subtitle\">Template Brevo utilisé pour l\'envoi d\'enquêtes par email.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n              \'is-standby\': configuration.brevoEmailTemplateId && configuration.brevoEmailSendingStandby,\n              \'is-selected\': configuration.brevoEmailTemplateId && !configuration.brevoEmailSendingStandby,\n              \'is-empty\': !configuration.brevoEmailTemplateId\n            }\">\n{{!configuration.brevoEmailTemplateId ? \'Aucun template\' : (configuration.brevoEmailSendingStandby ? \'Template en standby\' : \'Template sélectionné\')}}\n</span></header><div class=\"qs-config-brevo\" \nng-class=\"{\n            \'is-empty\': !configuration.brevoEmailTemplateId,\n            \'is-standby\': configuration.brevoEmailTemplateId && configuration.brevoEmailSendingStandby\n          }\">\n<div ng-if=\"configuration.brevoEmailTemplateId\" class=\"qs-config-brevo-info\"><div class=\"qs-campagne-template-name\" \ntitle=\"{{configuration.brevoEmailTemplateName}}\">\n{{configuration.brevoEmailTemplateName || (\'Template #\' + configuration.brevoEmailTemplateId)}}</div><div \nclass=\"qs-campagne-template-meta\">ID Brevo : {{configuration.brevoEmailTemplateId}}</div><div \nng-if=\"configuration.brevoEmailSendingStandby\" class=\"qs-campagne-template-standby mt-8\"><div \nclass=\"qs-campagne-template-standby-title\">Raison du standby</div><div>\n{{configuration.brevoEmailSendingStandbyReason || \'Le template est temporairement indisponible.\'}}</div></div><div \nclass=\"qs-campagne-template-actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"openBrevoTemplatePopup($event)\">Modifier le template</button></div></div><div \nng-if=\"!configuration.brevoEmailTemplateId\" class=\"qs-config-brevo-empty\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24 qs-config-brevo-empty-icon\"></md-icon><div \nclass=\"qs-config-brevo-empty-body\"><div class=\"qs-config-brevo-empty-title\">Aucun template sélectionné</div><div \nclass=\"qs-config-brevo-empty-text\">Sélectionnez un template actif Brevo pour permettre l\'envoi d\'enquêtes par email.\n</div></div><button type=\"button\" class=\"nl-Btn nl-Btn--outline qs-config-brevo-empty-action\" \nng-click=\"openBrevoTemplatePopup($event)\">Sélectionner un template</button></div></div></section><section \nclass=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-email\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Email disponibilité synthèse PDF</h2><p \nclass=\"qs-config-card-subtitle\">\nTemplate Brevo utilisé pour notifier la mise à disposition de la synthèse PDF en fin de campagne.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n              \'is-selected\': configuration.brevoReportAvailableEmailTemplateId,\n              \'is-empty\': !configuration.brevoReportAvailableEmailTemplateId\n            }\">\n{{!configuration.brevoReportAvailableEmailTemplateId ? \'Aucun template\' : \'Template sélectionné\'}}</span></header><div \nclass=\"qs-config-brevo\" \nng-class=\"{\n            \'is-empty\': !configuration.brevoReportAvailableEmailTemplateId\n          }\"><div \nng-if=\"configuration.brevoReportAvailableEmailTemplateId\" class=\"qs-config-brevo-info\"><div \nclass=\"qs-campagne-template-name\" title=\"{{configuration.brevoReportAvailableEmailTemplateName}}\">\n{{configuration.brevoReportAvailableEmailTemplateName || (\'Template #\' + configuration.brevoReportAvailableEmailTemplateId)}}\n</div><div class=\"qs-campagne-template-meta\">ID Brevo : {{configuration.brevoReportAvailableEmailTemplateId}}</div><div\n class=\"qs-campagne-template-actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"openBrevoReportAvailableTemplatePopup($event)\">Modifier le template</button></div></div><div \nng-if=\"!configuration.brevoReportAvailableEmailTemplateId\" class=\"qs-config-brevo-empty\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24 qs-config-brevo-empty-icon\"></md-icon><div \nclass=\"qs-config-brevo-empty-body\"><div class=\"qs-config-brevo-empty-title\">Aucun template sélectionné</div><div \nclass=\"qs-config-brevo-empty-text\">Sélectionnez un template actif Brevo contenant la clé obligatoire <code>[[URL_LQO]]\n</code>.</div></div><button type=\"button\" class=\"nl-Btn nl-Btn--outline qs-config-brevo-empty-action\" \nng-click=\"openBrevoReportAvailableTemplatePopup($event)\">Sélectionner un template</button></div></div></section>\n<section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-email\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Email groupement synthèses PDF</h2><p \nclass=\"qs-config-card-subtitle\">\nTemplate Brevo utilisé pour notifier les responsables groupement que le ZIP des synthèses est disponible dans \"Pharmacies engagées\".\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n              \'is-selected\': configuration.brevoGroupementReportAvailableEmailTemplateId,\n              \'is-empty\': !configuration.brevoGroupementReportAvailableEmailTemplateId\n            }\">\n{{!configuration.brevoGroupementReportAvailableEmailTemplateId ? \'Aucun template\' : \'Template sélectionné\'}}</span>\n</header><div class=\"qs-config-brevo\" \nng-class=\"{\n            \'is-empty\': !configuration.brevoGroupementReportAvailableEmailTemplateId\n          }\"><div \nng-if=\"configuration.brevoGroupementReportAvailableEmailTemplateId\" class=\"qs-config-brevo-info\"><div \nclass=\"qs-campagne-template-name\" title=\"{{configuration.brevoGroupementReportAvailableEmailTemplateName}}\">\n{{configuration.brevoGroupementReportAvailableEmailTemplateName || (\'Template #\' + configuration.brevoGroupementReportAvailableEmailTemplateId)}}\n</div><div class=\"qs-campagne-template-meta\">ID Brevo : {{configuration.brevoGroupementReportAvailableEmailTemplateId}}\n</div><div class=\"qs-campagne-template-actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"openBrevoGroupementReportAvailableTemplatePopup($event)\">Modifier le template</button></div></div><div \nng-if=\"!configuration.brevoGroupementReportAvailableEmailTemplateId\" class=\"qs-config-brevo-empty\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24 qs-config-brevo-empty-icon\"></md-icon><div \nclass=\"qs-config-brevo-empty-body\"><div class=\"qs-config-brevo-empty-title\">Aucun template sélectionné</div><div \nclass=\"qs-config-brevo-empty-text\">Sélectionnez un template actif Brevo contenant la clé obligatoire <code>[[URL_LQO]]\n</code> vers la vue groupement \"Pharmacies engagées\".</div></div><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline qs-config-brevo-empty-action\" \nng-click=\"openBrevoGroupementReportAvailableTemplatePopup($event)\">Sélectionner un template</button></div></div>\n</section><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-email\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Mail de relance non-LQO</h2><p \nclass=\"qs-config-card-subtitle\">\nTemplate Brevo utilisé pour relancer les pharmacies non-LQO et leur permettre de créer leur mot de passe.</p></div>\n<span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n              \'is-selected\': configuration.brevoNonLqoRelanceEmailTemplateId,\n              \'is-empty\': !configuration.brevoNonLqoRelanceEmailTemplateId\n            }\">\n{{!configuration.brevoNonLqoRelanceEmailTemplateId ? \'Aucun template\' : \'Template sélectionné\'}}</span></header><div \nclass=\"qs-config-brevo\" \nng-class=\"{\n            \'is-empty\': !configuration.brevoNonLqoRelanceEmailTemplateId\n          }\"><div \nng-if=\"configuration.brevoNonLqoRelanceEmailTemplateId\" class=\"qs-config-brevo-info\"><div \nclass=\"qs-campagne-template-name\" title=\"{{configuration.brevoNonLqoRelanceEmailTemplateName}}\">\n{{configuration.brevoNonLqoRelanceEmailTemplateName || (\'Template #\' + configuration.brevoNonLqoRelanceEmailTemplateId)}}\n</div><div class=\"qs-campagne-template-meta\">ID Brevo : {{configuration.brevoNonLqoRelanceEmailTemplateId}}</div><div \nclass=\"qs-campagne-template-actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"openBrevoNonLqoRelanceTemplatePopup($event)\">Modifier le template</button></div><div \nclass=\"qs-config-brevo-relance-actions\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--primary qs-config-brevo-relance-action\" ng-click=\"confirmNonLqoRelanceEmails($event)\" \nng-disabled=\"sendingNonLqoRelance || !configuration.brevoNonLqoRelanceEmailTemplateId\"><md-progress-circular \nmd-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"sendingNonLqoRelance\"></md-progress-circular><span \nng-if=\"!sendingNonLqoRelance\">Relancer les pharmacies non-LQO sans compte</span></button></div></div><div \nng-if=\"!configuration.brevoNonLqoRelanceEmailTemplateId\" class=\"qs-config-brevo-empty\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24 qs-config-brevo-empty-icon\"></md-icon><div \nclass=\"qs-config-brevo-empty-body\"><div class=\"qs-config-brevo-empty-title\">Aucun template sélectionné</div><div \nclass=\"qs-config-brevo-empty-text\">Sélectionnez un template actif Brevo contenant la clé obligatoire <code>\n[[LIEN_CREATION_MOT_PASS]]</code>. La variable <code>[[NOM_PHARMACIE]]</code>\n reste disponible pour personnaliser le message.</div></div><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline qs-config-brevo-empty-action\" ng-click=\"openBrevoNonLqoRelanceTemplatePopup($event)\">\nSélectionner un template</button></div></div></section><div class=\"qs-config-footer\"><div \nclass=\"qs-config-footer-hint\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>\nLes modifications s\'appliquent à la campagne en cours.</span></div><button type=\"submit\" class=\"nl-Btn qs-config-save\" \nng-disabled=\"submitting || loading || configurationCampagneForm.$invalid\"><md-progress-circular md-diameter=\"15px\" \nmd-mode=\"indeterminate\" ng-if=\"submitting\"></md-progress-circular><span ng-if=\"!submitting\">\nSauvegarder les modifications</span></button></div></form></div></div>");
$templateCache.put("app/main/admin/groupements/groupements.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-grp-page\"><div \nclass=\"header md-accent-bg admin-grp-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg admin-grp-header__title-group\"><div class=\"h1 admin-grp-header__title\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon><span>Groupements</span></div><div \nclass=\"admin-grp-header__subtitle\">Référentiel servi par le CRM — les accès se gèrent ici, groupement par groupement\n</div></div><div layout=\"row\" layout-align=\"end center\" class=\"admin-grp-header__actions\"></div></div><div \nclass=\"content admin-grp-content\"><div class=\"admin-grp-toolbar\"><div class=\"admin-grp-search\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s20\"></md-icon><input type=\"text\" placeholder=\"Rechercher un groupement\" \nng-model=\"searchText\"> <button type=\"button\" class=\"admin-grp-search__clear\" ng-if=\"searchText\" \nng-click=\"clearSearch()\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></div><div \nclass=\"admin-grp-chips\"><button type=\"button\" class=\"admin-grp-chip admin-grp-chip--ok\" \nng-class=\"{ \'admin-grp-chip--active\': statusFilter === \'avec\' }\" ng-click=\"setStatusFilter(\'avec\')\">\n{{countAvecAcces()}} avec accès</button> <button type=\"button\" class=\"admin-grp-chip admin-grp-chip--warn\" \nng-class=\"{ \'admin-grp-chip--active\': statusFilter === \'attente\' }\" ng-click=\"setStatusFilter(\'attente\')\">\n{{countInvitationsEnAttente()}} en attente</button> <button type=\"button\" class=\"admin-grp-chip admin-grp-chip--muted\" \nng-class=\"{ \'admin-grp-chip--active\': statusFilter === \'sans\' }\" ng-click=\"setStatusFilter(\'sans\')\">\n{{countSansAcces()}} sans accès</button></div></div><div class=\"admin-grp-card\"><div class=\"admin-grp-loading\" \nng-if=\"loading\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span>\nChargement du référentiel…</span></div><div class=\"admin-grp-empty\" ng-if=\"!loading && !groupements.length\">\nAucun groupement — le CRM n\'a pas répondu ou son référentiel est vide.</div><table class=\"admin-grp-table\" \nng-if=\"!loading && groupements.length\"><thead><tr><th>Groupement</th><th class=\"admin-grp-table__center\">Officines</th>\n<th class=\"admin-grp-table__center\">Accès</th><th>État</th><th class=\"admin-grp-table__right\"></th></tr></thead><tbody>\n<tr ng-repeat=\"groupement in groupements | filter:searchText\" ng-if=\"matchStatus(groupement)\" class=\"admin-grp-row\" \nng-click=\"ouvrirDetail(groupement)\"><td><div class=\"admin-grp-name\">{{groupement.name}}</div><div \nclass=\"admin-grp-warn\" ng-if=\"groupement.absentDuCrm\">absent du référentiel CRM</div></td><td \nclass=\"admin-grp-table__center\">{{groupement.nbPharmacies === null ? \'—\' : groupement.nbPharmacies}}</td><td \nclass=\"admin-grp-table__center\">{{groupement.acces.length}}</td><td><span class=\"admin-grp-chip admin-grp-chip--muted\" \nng-if=\"!groupement.acces.length\">Aucun accès </span><span class=\"admin-grp-chip admin-grp-chip--warn\" \nng-if=\"nbEnAttente(groupement)\">{{nbEnAttente(groupement)}} invitation(s) en attente </span><span \nclass=\"admin-grp-chip admin-grp-chip--ok\" ng-if=\"groupement.acces.length && !nbEnAttente(groupement)\">\nTous les accès sont actifs</span></td><td class=\"admin-grp-table__right\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s20 admin-grp-row__chevron\"></md-icon></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/home/admin-home.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-home-page\"><div \nclass=\"header md-accent-bg admin-home-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"h1 admin-home-header__title\">Administration</div></div></div>\n<div class=\"content admin-home-content\"><div class=\"admin-home-grid\"><div class=\"admin-home-card\" \nng-repeat=\"section in sections | orderBy:\'index\'\" ng-class=\"\'admin-home-card--\' + section.accent\" \nng-click=\"openSection(section)\" tabindex=\"0\" ng-keydown=\"$event.keyCode === 13 && openSection(section)\"><div \nclass=\"admin-home-card__deco\"></div><div class=\"admin-home-card__deco admin-home-card__deco--small\"></div><div \nclass=\"admin-home-card__icon-wrapper\"><div class=\"admin-home-card__icon-glow\"></div><div class=\"admin-home-card__icon\">\n<md-icon md-font-icon=\"{{section.icon}}\" class=\"s36\"></md-icon></div></div><div class=\"admin-home-card__body\"><div \nclass=\"admin-home-card__title\">{{section.title}}</div><div class=\"admin-home-card__description\">{{section.description}}\n</div><div class=\"admin-home-card__cta\"><span class=\"admin-home-card__cta-label\">Accéder</span><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"s18 admin-home-card__cta-arrow\"></md-icon></div></div></div></div></div></div>");
$templateCache.put("app/main/admin/osys/compte-osys.html","<md-dialog class=\"osy-fenetre\" aria-label=\"Créer un compte OSyS\"><div class=\"osy-fenetre__entete\"><div><h2 \nclass=\"osy-fenetre__titre\">Créer un compte OSyS</h2><p class=\"osy-fenetre__sous-titre\">\nOfficine au contrat OSyS, compte Titulaire invité par courriel, module activé.</p></div><button type=\"button\" \nclass=\"osy-fenetre__fermer\" ng-click=\"d.annuler()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\">\n</md-icon></button></div><md-dialog-content class=\"osy-fenetre__corps\"><div class=\"osy-champ-bloc\"><label \nclass=\"osy-libelle\" for=\"osy-compte-cip\">CIP de l’officine <span class=\"osy-requis\">*</span></label><div \nclass=\"osy-ajout\"><input id=\"osy-compte-cip\" class=\"osy-champ\" ng-model=\"d.saisie.cip\" maxlength=\"20\" \nautocomplete=\"off\" ng-keydown=\"$event.keyCode === 13 && d.chercher()\" ng-change=\"d.apercu = null\"> <button \ntype=\"button\" class=\"osy-btn osy-btn--contour\" ng-click=\"d.chercher()\" ng-disabled=\"!d.saisie.cip\">Rechercher</button>\n</div><p class=\"osy-erreur\" ng-if=\"d.erreurs.cip\">{{d.erreurs.cip}}</p></div><div class=\"osy-alerte osy-alerte--rouge\" \nng-if=\"d.apercu.dejaDansLqo\">Officine déjà dans LQO : activez le module depuis la liste des officines.</div><div \nclass=\"osy-alerte osy-alerte--gris\" ng-if=\"d.apercu && !d.apercu.dejaDansLqo && d.apercu.nom\">Symphony : <strong>\n{{d.apercu.nom}}</strong><span ng-if=\"d.apercu.ville\"> · {{d.apercu.ville}} ({{d.apercu.codePostal}})</span></div><div \nng-if=\"d.apercu && !d.apercu.dejaDansLqo\"><div class=\"osy-champ-bloc\" ng-if=\"!d.apercu.nom\"><p \nclass=\"osy-note osy-note--haut\">CIP absent de Symphony : indiquez le nom de l’officine.</p><label class=\"osy-libelle\" \nfor=\"osy-compte-nom\">Nom de l’officine <span class=\"osy-requis\">*</span></label><input id=\"osy-compte-nom\" \nclass=\"osy-champ\" ng-model=\"d.saisie.nom\" maxlength=\"200\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.nom\">{{d.erreurs.nom}}\n</p></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-compte-mail\">Courriel du Titulaire <span \nclass=\"osy-requis\">*</span></label><input id=\"osy-compte-mail\" class=\"osy-champ\" type=\"email\" ng-model=\"d.saisie.mail\" \nmaxlength=\"200\" autocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.mail\">{{d.erreurs.mail}}</p></div></div>\n</md-dialog-content><div class=\"osy-fenetre__actions\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" \nng-click=\"d.annuler()\">Annuler</button> <button type=\"button\" class=\"osy-btn osy-btn--principal\" ng-click=\"d.creer()\" \nng-disabled=\"!d.peutCreer()\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>Créer le compte</button></div>\n</md-dialog>");
$templateCache.put("app/main/admin/osys/import.html","<div class=\"osy-page osy-admin osy-import\"><a class=\"osy-retour\" ui-sref=\"admin.osys.officines\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Officines</a><div class=\"osy-entete\"><div><h1 \nclass=\"osy-entete__titre\">Importer les habilitations</h1><div class=\"osy-entete__sous-titre\">\nFichier des titulaires formés à OSyS, transmis par les coordonnateurs régionaux.</div></div></div><section \nclass=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-upload\" class=\"s20 osy-carte__icone\">\n</md-icon><h2 class=\"osy-carte__titre\">Fichier</h2></header><div class=\"osy-carte__corps\"><div \nclass=\"osy-import__ligne\"><div class=\"osy-import__depot\"><input type=\"file\" class=\"osy-import__fichier\" \naccept=\".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel\" hidden> \n<span ng-if=\"!vm.fichier\" class=\"osy-texte-doux\">Déposez le fichier Excel des formations (xlsx ou xls).</span> <span \nng-if=\"vm.fichier\"><md-icon md-font-icon=\"icon-file-document\" class=\"s18\"></md-icon><strong>{{vm.fichier.name}}\n</strong> <span class=\"osy-texte-doux\" ng-if=\"vm.verification\">\n· {{vm.verification.lignes}} {{vm.verification.lignes > 1 ? \'lignes\' : \'ligne\'}}</span></span> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"vm.choisir()\" ng-disabled=\"vm.envoi\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"s16\"></md-icon>{{vm.fichier ? \'Changer\' : \'Choisir le fichier\'}}</button></div><button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-click=\"vm.modele()\"><md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon>\nTélécharger le modèle</button></div><p class=\"osy-note\">Colonnes : CIP, nom, prénom, RPPS, date de formation, session.\n</p></div></section><section class=\"osy-carte\" ng-if=\"vm.verification\"><header class=\"osy-carte__entete\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Vérification</h2>\n</header><div class=\"osy-carte__corps\"><div class=\"osy-import__compteurs\"><span \nclass=\"osy-pastille osy-pastille--point osy-pastille--vert\">\n{{vm.verification.pretes}} {{vm.verification.pretes > 1 ? \'prêtes\' : \'prête\'}}</span> <span \nclass=\"osy-pastille osy-pastille--point osy-pastille--bleu\" ng-if=\"vm.verification.misesAJour\">\n{{vm.verification.misesAJour}} à mettre à jour</span> <span \nclass=\"osy-pastille osy-pastille--point osy-pastille--rouge\">\n{{vm.verification.erreurs}} {{vm.verification.erreurs > 1 ? \'erreurs\' : \'erreur\'}}</span> <span \nclass=\"osy-pastille osy-pastille--point osy-pastille--gris\">\n{{vm.verification.dejaHabilitees}} déjà {{vm.verification.dejaHabilitees > 1 ? \'habilitées\' : \'habilitée\'}}</span>\n</div><table class=\"osy-table\" ng-if=\"vm.verification.detail.length\"><thead><tr><th>Ligne</th><th>CIP</th><th>Officine\n</th><th>Titulaire</th><th>RPPS</th><th>Formation</th><th>Résultat</th></tr></thead><tbody><tr \nng-repeat=\"l in vm.verification.detail track by l.ligne\" \nng-class=\"{\'osy-table__ligne--retard\': vm.classe(l.statut) === \'rouge\'}\"><td>{{l.ligne}}</td><td>{{l.cip || \'—\'}}</td>\n<td>{{l.officine || \'—\'}}</td><td>{{(l.nom | uppercase) || \'—\'}} {{l.prenom}}</td><td>{{l.rpps || \'—\'}}</td><td>\n{{l.dateFormation ? (l.dateFormation | date:\'dd/MM/yyyy\') : \'—\'}}</td><td><span \nclass=\"osy-pastille osy-pastille--point osy-pastille--{{vm.classe(l.statut)}}\">\n{{vm.L.STATUTS_IMPORT[l.statut] || l.statut}}</span></td></tr></tbody></table></div></section><div \nclass=\"osy-actions osy-actions--droite\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" \nui-sref=\"admin.osys.officines\">Annuler</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand\" ng-disabled=\"!vm.aImporter() || vm.envoi\" ng-click=\"vm.importer()\">\n<md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>\nImporter {{vm.aImporter()}} {{vm.aImporter() > 1 ? \'habilitations\' : \'habilitation\'}}</button></div></div>");
$templateCache.put("app/main/admin/osys/indicateurs.html","<div class=\"osy-page osy-admin\" ng-if=\"vm.i\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\">\nOSyS · Indicateurs et exports</h1><div class=\"osy-entete__sous-titre\">\nDonnées pour PHSQ, le ministère et l’Assurance maladie. Elles ne sont pas affichées aux pharmaciens.</div></div><select\n class=\"osy-select\" ng-model=\"vm.mois\" ng-change=\"vm.charger()\" aria-label=\"Période\"><option \nng-repeat=\"m in vm.i.moisDisponibles track by m\" value=\"{{m}}\">{{vm.libelleMois(m, true)}}</option></select></div><div \nclass=\"osy-tuiles-indicateurs\"><div class=\"osy-indicateur\"><span class=\"osy-indicateur__icone\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/menu/triage.svg\"></md-icon></span><div><div class=\"osy-indicateur__titre\">Triages</div>\n<div class=\"osy-indicateur__valeur\">{{vm.i.triages}}</div><div class=\"osy-indicateur__sous\">\n{{vm.libelleMois(vm.i.mois)}}</div></div></div><div class=\"osy-indicateur\"><span class=\"osy-indicateur__icone\"><md-icon\n md-font-icon=\"icon-clock\" class=\"s20\"></md-icon></span><div><div class=\"osy-indicateur__titre\">\nDurée moyenne pharmacien / patient</div><div class=\"osy-indicateur__valeur\">\n{{vm.i.dureeMoyenneMin === null ? \'—\' : vm.i.dureeMoyenneMin + \' min\'}}</div><div class=\"osy-indicateur__sous\">\nindicateur clé pour le ministère</div></div></div><div class=\"osy-indicateur\"><span class=\"osy-indicateur__icone\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"s20\"></md-icon></span><div><div class=\"osy-indicateur__titre\">\nRefus enregistrés</div><div class=\"osy-indicateur__valeur\">{{vm.i.refus}}</div><div class=\"osy-indicateur__sous\" \nng-if=\"vm.i.tauxInclusion !== null\">taux d’inclusion {{vm.i.tauxInclusion}} %</div></div></div><div \nclass=\"osy-indicateur\"><span class=\"osy-indicateur__icone\"><md-icon md-font-icon=\"icon-phone\" class=\"s20\"></md-icon>\n</span><div><div class=\"osy-indicateur__titre\">Patients rappelés</div><div class=\"osy-indicateur__valeur\">\n{{vm.i.rappelsPourcentage === null ? \'—\' : vm.i.rappelsPourcentage + \' %\'}}</div><div class=\"osy-indicateur__sous\">\nrappels faits / prévus ({{vm.i.rappelsFaits}} / {{vm.i.rappelsEchus}})</div></div></div></div><div class=\"osy-paire\">\n<section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-flag-outline\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Orientations : proposition et décision</h2>\n</header><div class=\"osy-carte__corps\"><table class=\"osy-table\"><thead><tr><th>Orientation</th><th>Proposée par l’outil\n</th><th>Décidée par le pharmacien</th></tr></thead><tbody><tr ng-repeat=\"o in vm.i.orientations track by o.code\"><td>\n<osy-decision prise-en-charge=\"o.code === \'OFFICINE\' ? \'PHARMACIEN\' : o.code\"></osy-decision></td><td>{{o.proposees}}\n</td><td>{{o.decidees}}</td></tr></tbody></table><p class=\"osy-note\">\nL’écart montre que le pharmacien décide, l’outil propose.</p></div></section><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-download\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Exports</h2></header><div class=\"osy-carte__corps\"><button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand\" ng-click=\"vm.exporter()\" ng-disabled=\"vm.export\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s18\"></md-icon>\n{{vm.export ? \'Export…\' : \'Export d’évaluation (sans identité des patients)\'}}</button><p \nclass=\"osy-admin__liste-titre\">L’export d’évaluation de {{vm.libelleMois(vm.mois)}} contient, pour chaque triage :</p>\n<ul class=\"osy-admin__liste\"><li>situation ; officine (CIP, nom, code postal) ;</li><li>\npatient sans aucune identité : sexe, âge, département ;</li><li>date et heure de début et de fin, durées ;</li><li>\nles trois questions au patient (sans ce service, pourquoi il est venu, comment il a connu le service) ;</li><li>\norientation proposée par l’arbre et prise en charge décidée avec le patient ;</li><li>\nproduits délivrés, satisfaction, mode de transmission du compte rendu ;</li><li>\nchaque rappel (deux pour la piqûre de tique et certaines plaies) : date et heure, patient joint, évolution, orientation suivie, suite donnée, satisfaction.\n</li></ul><p class=\"osy-note\">\nUne feuille « Refus » liste les refus du mois (tranche d’âge, sexe, motif). Les triages en pause (non terminés) et abandonnés sont signalés. Chaque export est tracé : qui, quand, quelle période.\n</p></div></section></div></div>");
$templateCache.put("app/main/admin/osys/officine.html","<div class=\"osy-page osy-admin\" ng-if=\"vm.f\"><a class=\"osy-retour\" ui-sref=\"admin.osys.officines\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Officines</a><div class=\"osy-entete\"><div><h1 \nclass=\"osy-entete__titre osy-entete__titre--pastille\"><span>{{vm.f.nom}}</span> <span \nclass=\"osy-pastille osy-pastille--point\" \nng-class=\"vm.f.etat === \'ACTIVE\' ? \'osy-pastille--vert\' : \'osy-pastille--gris\'\">\n{{vm.f.etat === \'ACTIVE\' ? \'Module activé\' : vm.f.etat === \'DESACTIVE\' ? \'Module désactivé\' : \'Module non activé\'}}\n</span></h1><div class=\"osy-entete__sous-titre\"><span ng-if=\"vm.f.ville\">{{vm.f.ville}} ({{vm.f.codePostal}}) · </span>\n{{vm.f.region}} · CIP {{vm.f.cip}}</div></div></div><div class=\"osy-admin__fiche\"><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-svg-src=\"assets/icons/app/V3/menu/triage.svg\" class=\"s20 osy-carte__icone\">\n</md-icon><h2 class=\"osy-carte__titre\">Module Triage OSyS</h2></header><div class=\"osy-carte__corps\"><dl \nclass=\"osy-recap osy-recap--etroit\"><dt>État</dt><dd><span class=\"osy-pastille osy-pastille--point\" \nng-class=\"vm.f.etat === \'ACTIVE\' ? \'osy-pastille--vert\' : \'osy-pastille--gris\'\">{{vm.L.ETATS[vm.f.etat]}}</span></dd>\n<dt ng-if=\"vm.f.dateEtat\">Depuis le</dt><dd ng-if=\"vm.f.dateEtat\">{{vm.f.dateEtat | date:\'dd/MM/yyyy\'}}</dd><dt>Contrat\n</dt><dd>{{vm.L.CONTRATS[vm.f.contrat] || vm.f.contrat}}</dd></dl><div class=\"osy-admin__module\"><button type=\"button\" \nclass=\"osy-btn osy-btn--contour osy-btn--rouge\" ng-if=\"vm.f.etat === \'ACTIVE\'\" ng-click=\"vm.desactiver($event)\">\n<md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>Désactiver le module</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal\" ng-if=\"vm.f.etat !== \'ACTIVE\'\" ng-click=\"vm.activer($event)\">\n{{vm.f.etat === \'DESACTIVE\' ? \'Réactiver le module\' : \'Activer le module\'}}</button><p class=\"osy-note\">\nDésactivé : plus de nouveau triage ; les rappels déjà prévus restent faisables.</p></div></div></section><section \nclass=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-shield-outline\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Titulaires habilités</h2></header><div \nclass=\"osy-carte__corps\"><table class=\"osy-table\" ng-if=\"vm.f.habilitations.length\"><thead><tr><th>Titulaire</th><th>\nRPPS</th><th>Formation</th><th>État</th><th></th></tr></thead><tbody><tr \nng-repeat=\"h in vm.f.habilitations track by h.id\"><td class=\"osy-table__patient\">{{h.prenom}} {{h.nom | uppercase}}\n</td><td>{{h.rpps}}</td><td>{{h.dateFormation | date:\'dd/MM/yyyy\'}}</td><td><osy-pastille \nng-if=\"h.statut === \'HABILITE\'\" type=\"vert\">Habilitation active</osy-pastille><osy-pastille \nng-if=\"h.statut === \'RETIRE\'\" type=\"gris\">Retirée le {{h.dateRetrait | date:\'dd/MM/yyyy\'}}</osy-pastille></td><td \nclass=\"osy-table__actions\"><button type=\"button\" class=\"osy-btn osy-btn--contour osy-btn--rouge\" \nng-if=\"h.statut === \'HABILITE\'\" ng-click=\"vm.retirer(h, $event)\">Retirer</button></td></tr></tbody></table><p \nclass=\"osy-vide\" ng-if=\"!vm.f.habilitations.length && vm.f.etat !== \'ACTIVE\'\">Aucun titulaire habilité.</p><div \nclass=\"osy-alerte osy-alerte--ambre\" ng-if=\"vm.f.etat === \'ACTIVE\' && !vm.habilitationsActives()\"><strong>\nAucun titulaire habilité.</strong>\n Le module est visible pour l’officine, mais « Nouveau triage » reste bloqué jusqu’à l’import des habilitations.</div>\n<p class=\"osy-note\">Les habilitations s’ajoutent par import du fichier des formations.</p></div></section></div></div>");
$templateCache.put("app/main/admin/osys/officines.html","<div class=\"osy-page osy-admin\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\">OSyS · Officines</h1><div \nclass=\"osy-entete__sous-titre\">Activation du module et titulaires habilités.</div></div><div \nclass=\"osy-entete__boutons\"><button type=\"button\" class=\"osy-btn osy-btn--contour osy-btn--grand\" \nui-sref=\"admin.osys.import\"><md-icon md-font-icon=\"icon-upload\" class=\"s18\"></md-icon>Importer les habilitations\n</button> <button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" ng-click=\"vm.creerCompte($event)\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>Créer un compte OSyS</button></div></div><div \nclass=\"osy-admin__filtres\"><div class=\"osy-recherche osy-admin__recherche\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"s18\"></md-icon><input type=\"text\" ng-model=\"vm.filtre.texte\" ng-change=\"vm.saisie()\" \nplaceholder=\"Officine, CIP ou ville\" aria-label=\"Rechercher une officine\" autocomplete=\"off\"></div><select \nclass=\"osy-select\" ng-model=\"vm.filtre.region\" ng-change=\"vm.filtrer()\" aria-label=\"Région\"><option value=\"\">\nToutes les régions</option><option ng-repeat=\"r in vm.resultat.regions track by r\" value=\"{{r}}\">{{r}}</option>\n</select><select class=\"osy-select\" ng-model=\"vm.filtre.etat\" ng-change=\"vm.filtrer()\" aria-label=\"État du module\">\n<option value=\"\">Tous les états</option><option value=\"ACTIVE\">Activé</option><option value=\"DESACTIVE\">Désactivé\n</option><option value=\"NON_ACTIVE\">Non activé</option></select></div><div class=\"osy-admin__resultats\" \nng-if=\"vm.resultat.total\"><span class=\"osy-admin__resultats-nombre\">{{vm.resultat.total}}</span><span \nclass=\"osy-admin__resultats-libelle\">{{vm.resultat.total > 1 ? \'officines\' : \'officine\'}} <span \nng-if=\"vm.filtre.texte\">pour «&nbsp;{{vm.filtre.texte}}&nbsp;»</span></span></div><section class=\"osy-carte\"><div \nclass=\"osy-carte__corps\"><table class=\"osy-table\" ng-if=\"vm.resultat.lignes.length\"><thead><tr><th>Officine</th><th>\nRégion</th><th>Contrat</th><th>Module</th><th>Titulaires habilités</th><th>Triages du mois</th><th></th></tr></thead>\n<tbody><tr dir-paginate=\"o in vm.resultat.lignes | itemsPerPage: vm.resultat.parPage track by o.pharmacyId\" \ntotal-items=\"vm.resultat.total\" current-page=\"vm.filtre.page\"><td><span class=\"osy-table__patient\">{{o.nom}}</span>\n<span class=\"osy-texte-doux\" ng-if=\"o.ville\"> · {{o.ville}} ({{o.departement}})</span> <span class=\"osy-texte-doux\" \nng-if=\"!o.ville\">· —</span></td><td>{{o.region === \'Région inconnue\' ? \'—\' : o.region}}</td><td><span \nclass=\"osy-pastille osy-pastille--{{o.contrat === \'OSYS\' ? \'vert\' : o.contrat === \'NON_LQO\' ? \'gris\' : \'bleu\'}}\">\n{{vm.L.CONTRATS[o.contrat] || o.contrat}}</span></td><td><span class=\"osy-pastille osy-pastille--point\" \nng-class=\"o.etat === \'ACTIVE\' ? \'osy-pastille--vert\' : \'osy-pastille--gris\'\">{{vm.L.ETATS[o.etat]}}<span \nng-if=\"o.dateEtat\"> · {{o.dateEtat | date:\'dd/MM/yyyy\'}}</span></span></td><td><span \nclass=\"osy-pastille osy-pastille--point osy-pastille--ambre\" ng-if=\"o.etat === \'ACTIVE\' && !o.habilitations\">Aucun\n</span> <span ng-if=\"o.etat !== \'ACTIVE\' || o.habilitations\">{{o.habilitations}}</span></td><td>\n{{o.etat === \'NON_ACTIVE\' ? \'—\' : o.triagesDuMois}}</td><td class=\"osy-table__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--principal\" ng-if=\"o.etat === \'NON_ACTIVE\'\" ng-click=\"vm.activer(o, $event)\">Activer</button> \n<button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-if=\"o.etat !== \'NON_ACTIVE\'\" ng-click=\"vm.ouvrir(o)\">Ouvrir\n</button></td></tr></tbody></table><p class=\"osy-vide\" ng-if=\"vm.resultat && !vm.resultat.lignes.length\">\nAucune officine ne correspond.</p></div><div class=\"osy-admin__pagination\" ng-if=\"vm.pages() > 1\">\n<dir-pagination-controls on-page-change=\"vm.allerPage(newPageNumber)\"></dir-pagination-controls></div></section></div>");
$templateCache.put("app/main/admin/pharmacies/pharmacies.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-pharmacies-page\"><div \nclass=\"header md-accent-bg admin-pharmacies-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div class=\"admin-pharmacies-header__title-group\"><div \nclass=\"h1 admin-pharmacies-header__title\"><md-icon md-font-icon=\"icon-pharmacy\" \nclass=\"s24 admin-pharmacies-header__icon\"></md-icon><span>Gestion des pharmacies</span></div><div \nclass=\"admin-pharmacies-header__subtitle\"><span ng-if=\"pagination.total\">{{pagination.total}} pharmacie<span \nng-if=\"pagination.total > 1\">s</span> enregistrée<span ng-if=\"pagination.total > 1\">s</span></span></div></div></div>\n<div layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"Ajouter une pharmacie\" \nclass=\"admin-pharmacies-header__add\" ng-click=\"showPharmacyDialog()\"><md-tooltip md-direction=\"bottom\">\nAjouter une pharmacie</md-tooltip><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span>Ajouter</span>\n</md-button></div></div><div class=\"content admin-pharmacies-content\"><div class=\"admin-pharmacies-toolbar\"><div \nclass=\"admin-pharmacies-toolbar__top-row\"><div class=\"admin-pharmacies-toolbar__search\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s18 admin-pharmacies-toolbar__search-icon\"></md-icon><input type=\"text\" \nclass=\"admin-pharmacies-toolbar__search-input\" placeholder=\"Rechercher une pharmacie, un email, un numéro...\" \nng-model=\"pagination.searchText\" ng-model-options=\"{ debounce: 350 }\" ng-change=\"reset()\"><md-icon \nng-if=\"pagination.searchText\" md-font-icon=\"icon-close-circle\" class=\"s16 admin-pharmacies-toolbar__search-clear\" \nng-click=\"pagination.searchText=\'\'; reset()\"></md-icon></div><div class=\"admin-pharmacies-toolbar__filters\"><div \nclass=\"admin-pharmacies-toolbar__filter\"><md-icon md-font-icon=\"icon-filter\" \nclass=\"s16 admin-pharmacies-toolbar__sort-icon\"></md-icon><md-select ng-model=\"pagination.statusBase\" \nng-change=\"reset()\" class=\"admin-pharmacies-toolbar__sort-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option ng-repeat=\"option in statusBaseOptions\" ng-value=\"option.value\">\n{{option.label}}</md-option></md-select></div><div class=\"admin-pharmacies-toolbar__filter\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s16 admin-pharmacies-toolbar__sort-icon\"></md-icon><md-select \nng-model=\"pagination.engageQualite\" ng-change=\"reset()\" class=\"admin-pharmacies-toolbar__sort-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option ng-repeat=\"option in engageQualiteOptions\" ng-value=\"option.value\">\n{{option.label}}</md-option></md-select></div><div class=\"admin-pharmacies-toolbar__filter\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s16 admin-pharmacies-toolbar__sort-icon\"></md-icon><md-select \nng-model=\"pagination.groupement\" ng-change=\"reset()\" class=\"admin-pharmacies-toolbar__sort-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option ng-repeat=\"option in groupementOptions\" ng-value=\"option.value\">\n{{option.label}}</md-option></md-select></div><div class=\"admin-pharmacies-toolbar__filter\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"s16 admin-pharmacies-toolbar__sort-icon\"></md-icon><md-select \nng-model=\"pagination.accountActivationFilter\" ng-change=\"onAccountActivationFilterChange()\" \nclass=\"admin-pharmacies-toolbar__sort-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-option \nng-value=\"\'all\'\">Pharmacies (Toutes)</md-option><md-option ng-value=\"\'with_activated\'\">Pharmacies avec un compte activé\n</md-option><md-option ng-value=\"\'without_activated\'\">Pharmacies sans compte activé</md-option></md-select></div>\n<button type=\"button\" class=\"admin-pharmacies-toolbar__reset md-button\" ng-if=\"hasActiveFilters()\" \nng-click=\"resetFilters()\">Réinitialiser les filtres</button><md-button aria-label=\"Exporter toutes les pharmacies\" \nclass=\"admin-pharmacies-toolbar__export\" ng-click=\"exportAll(type)\"><md-tooltip md-direction=\"bottom\">\nExporter toutes les pharmacies en fichier Excel</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"s16\">\n</md-icon><span>Exporter</span></md-button></div></div><div class=\"admin-pharmacies-toolbar__sort\"><md-icon \nmd-font-icon=\"icon-sort\" class=\"s16 admin-pharmacies-toolbar__sort-icon\"></md-icon><md-select \nng-model=\"pagination.sort\" ng-change=\"reset()\" class=\"admin-pharmacies-toolbar__sort-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option ng-value=\"\'u.pharmacy.isActivated desc\'\">Statut — actives en premier\n</md-option><md-option ng-value=\"\'u.pharmacy.isActivated asc\'\">Statut — inactives en premier</md-option><md-option \nng-value=\"\'lower(u.pharmacy.name) asc\'\">Nom — A à Z</md-option><md-option ng-value=\"\'lower(u.pharmacy.name) desc\'\">\nNom — Z à A</md-option><md-option ng-value=\"\'lower(u.pharmacy.numIdentification) asc\'\">N° identification — A à Z\n</md-option><md-option ng-value=\"\'lower(u.pharmacy.numIdentification) desc\'\">N° identification — Z à A</md-option>\n</md-select></div></div><div class=\"admin-pharmacies-crm-secours\" \nng-if=\"erreurCrm || parcCrm.source === \'SECOURS\' || parcCrm.source === \'INDISPONIBLE\'\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s20\"></md-icon><div><div class=\"admin-pharmacies-crm-secours__titre\" \nng-if=\"erreurCrm\">{{erreurCrm}}</div><div class=\"admin-pharmacies-crm-secours__titre\" \nng-if=\"!erreurCrm && parcCrm.source === \'SECOURS\'\">\nStatut et engagement au {{parcCrm.luLe | date:\'dd/MM/yyyy\'}} à {{parcCrm.luLe | date:\'HH:mm\'}}</div><div \nclass=\"admin-pharmacies-crm-secours__titre\" ng-if=\"!erreurCrm && parcCrm.source === \'INDISPONIBLE\'\">\nStatut et engagement indisponibles</div><div class=\"admin-pharmacies-crm-secours__texte\">\nLe CRM ne répond pas. Ces deux colonnes et leurs filtres suivront le CRM dès son retour.</div></div></div><div \nclass=\"admin-pharmacies-results\" ng-if=\"pagination.total\"><span class=\"admin-pharmacies-results__count\">\n{{pagination.total}}</span> <span class=\"admin-pharmacies-results__label\">résultat<span ng-if=\"pagination.total > 1\">s\n</span><span ng-if=\"pagination.searchText\"> pour «&nbsp;{{pagination.searchText}}&nbsp;»</span> <span \nng-if=\"pagination.accountActivationFilter === \'without_activated\'\">sans compte activé</span> <span \nng-if=\"pagination.accountActivationFilter === \'with_activated\'\">avec un compte activé</span></span></div><div \nclass=\"admin-pharmacies-card\"><div class=\"admin-pharmacies-table-wrap\"><table class=\"admin-pharmacies-table\"><thead>\n<tr><th class=\"admin-pharmacies-table__th admin-pharmacies-table__th--name\">Pharmacie</th><th \nclass=\"admin-pharmacies-table__th admin-pharmacies-table__th--center admin-pharmacies-table__th--status\">Statut (LQO)\n</th><th class=\"admin-pharmacies-table__th admin-pharmacies-table__th--center admin-pharmacies-table__th--status\">\nStatut (Base)</th><th class=\"admin-pharmacies-table__th\">N° id.</th><th class=\"admin-pharmacies-table__th\">Titulaire\n</th><th class=\"admin-pharmacies-table__th\">Responsable Qualité</th><th class=\"admin-pharmacies-table__th\">Équipe</th>\n<th class=\"admin-pharmacies-table__th\">Groupement</th><th \nclass=\"admin-pharmacies-table__th admin-pharmacies-table__th--center admin-pharmacies-table__th--quality\">\nEngagée Qualité</th><th \nclass=\"admin-pharmacies-table__th admin-pharmacies-table__th--center admin-pharmacies-table__th--test\">\nPharmacie de test</th><th class=\"admin-pharmacies-table__th admin-pharmacies-table__th--actions\">Actions</th></tr>\n</thead><tbody><tr class=\"admin-pharmacies-row\" \nng-class=\"{ \'admin-pharmacies-row--deactivated\': !pharmacy.isActivated }\" \ndir-paginate=\"pharmacy in pharmacies | itemsPerPage: pagination.nbrResults\" total-items=\"pagination.total\" \ncurrent-page=\"pagination.page\"><td class=\"admin-pharmacies-cell admin-pharmacies-cell--name\"><div \nclass=\"admin-pharmacies-name\"><div class=\"admin-pharmacies-name__text\"><div class=\"admin-pharmacies-name__badges\"><span\n class=\"admin-pharmacies-pill\" ng-if=\"type === \'all\'\" ng-class=\"getContractTypePillClass(pharmacy.contractType)\">\n{{convertType[pharmacy.contractType]}} </span><span ng-if=\"pharmacy.testPharmacy\" \nclass=\"admin-pharmacies-pill admin-pharmacies-pill--test\">Test</span></div><span class=\"admin-pharmacies-name__label\">\n{{ pharmacy.name }}</span><div class=\"admin-pharmacies-name__hint admin-pharmacies-name__hint--warn\" \nng-if=\"isWithoutActivatedAccount(pharmacy)\">Aucun compte activé</div></div></div></td><td \nclass=\"admin-pharmacies-cell admin-pharmacies-cell--center admin-pharmacies-cell--status\"><span \nclass=\"admin-pharmacies-status-badge\" \nng-class=\"pharmacy.isActivated ? \'admin-pharmacies-status-badge--on\' : \'admin-pharmacies-status-badge--off\'\"><span \nclass=\"admin-pharmacies-status-badge__dot\"></span> <span>{{ pharmacy.isActivated ? \'Actif\' : \'Inactif\' }}</span></span>\n</td><td class=\"admin-pharmacies-cell admin-pharmacies-cell--center admin-pharmacies-cell--status\"><span \nclass=\"admin-pharmacies-status-badge\" ng-if=\"pharmacy.statutCrm\" \nng-class=\"getStatusBaseBadgeClass(pharmacy.statutCrm)\"><span class=\"admin-pharmacies-status-badge__dot\"></span> <span \nclass=\"symph-status\">{{ pharmacy.statutCrm }}</span></span></td><td \nclass=\"admin-pharmacies-cell admin-pharmacies-cell--id\">{{ pharmacy.numIdentification }}</td><td \nclass=\"admin-pharmacies-cell\"><div class=\"admin-pharmacies-email\" ng-if=\"pharmacy.titulaire.mail\"><md-icon \nng-if=\"pharmacy.titulaireChecked\" md-font-icon=\"icon-check-circle\" \nclass=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--on\"><md-tooltip md-direction=\"top\">\nCompte activé</md-tooltip></md-icon><md-icon ng-if=\"!pharmacy.titulaireChecked\" md-font-icon=\"icon-close-circle\" \nclass=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--off\"><md-tooltip md-direction=\"top\">\nCompte non activé</md-tooltip></md-icon><div class=\"admin-pharmacies-email__content\"><div \nclass=\"admin-pharmacies-email__addr\">{{ pharmacy.titulaire.mail }}</div><div class=\"admin-pharmacies-email__date\" \nng-if=\"pharmacy.titulaire.lastConnection\">{{ pharmacy.titulaire.lastConnection | date: \'dd/MM/yyyy\'}}</div></div></div>\n<span class=\"admin-pharmacies-empty\" ng-if=\"!pharmacy.titulaire.mail\">—</span></td><td class=\"admin-pharmacies-cell\">\n<div class=\"admin-pharmacies-email\" ng-if=\"pharmacy.praq.mail\"><md-icon ng-if=\"pharmacy.praqChecked\" \nmd-font-icon=\"icon-check-circle\" class=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--on\">\n<md-tooltip md-direction=\"top\">Compte activé</md-tooltip></md-icon><md-icon ng-if=\"!pharmacy.praqChecked\" \nmd-font-icon=\"icon-close-circle\" class=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--off\">\n<md-tooltip md-direction=\"top\">Compte non activé</md-tooltip></md-icon><div class=\"admin-pharmacies-email__content\">\n<div class=\"admin-pharmacies-email__addr\">{{ pharmacy.praq.mail }}</div><div class=\"admin-pharmacies-email__date\" \nng-if=\"pharmacy.praq.lastConnection\">{{ pharmacy.praq.lastConnection | date: \'dd/MM/yyyy\'}}</div></div></div><span \nclass=\"admin-pharmacies-empty\" ng-if=\"!pharmacy.praq.mail\">—</span></td><td class=\"admin-pharmacies-cell\"><div \nclass=\"admin-pharmacies-email\" ng-if=\"pharmacy.team.mail\"><md-icon ng-if=\"pharmacy.teamChecked\" \nmd-font-icon=\"icon-check-circle\" class=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--on\">\n<md-tooltip md-direction=\"top\">Compte activé</md-tooltip></md-icon><md-icon ng-if=\"!pharmacy.teamChecked\" \nmd-font-icon=\"icon-close-circle\" class=\"s14 admin-pharmacies-email__check admin-pharmacies-email__check--off\">\n<md-tooltip md-direction=\"top\">Compte non activé</md-tooltip></md-icon><div class=\"admin-pharmacies-email__content\">\n<div class=\"admin-pharmacies-email__addr\">{{ pharmacy.team.mail }}</div><div class=\"admin-pharmacies-email__date\" \nng-if=\"pharmacy.team.lastConnection\">{{ pharmacy.team.lastConnection | date: \'dd/MM/yyyy\'}}</div></div></div><span \nclass=\"admin-pharmacies-empty\" ng-if=\"!pharmacy.team.mail\">—</span></td><td class=\"admin-pharmacies-cell\"><span \nng-if=\"pharmacy.groupement\" class=\"admin-pharmacies-groupement\">{{ pharmacy.groupement }}</span> <span \nng-if=\"!pharmacy.groupement\" class=\"admin-pharmacies-empty\">—</span></td><td \nclass=\"admin-pharmacies-cell admin-pharmacies-cell--center\"><span ng-if=\"pharmacy.engageQualite\" \nclass=\"admin-pharmacies-medal\"><md-tooltip md-direction=\"top\">Pharmacie engagée qualité</md-tooltip><md-icon \nmd-font-icon=\"icon-star-circle\" class=\"s16\"></md-icon><span>Oui</span> </span><span \nng-if=\"pharmacy.engageQualite === false\" class=\"admin-pharmacies-boolean admin-pharmacies-boolean--no\">Non</span> <span\n ng-if=\"pharmacy.engageQualite === null || pharmacy.engageQualite === undefined\" class=\"admin-pharmacies-empty\">—\n</span></td><td class=\"admin-pharmacies-cell admin-pharmacies-cell--center\"><span ng-if=\"pharmacy.testPharmacy\" \nclass=\"admin-pharmacies-boolean admin-pharmacies-boolean--yes\">Oui</span> <span ng-if=\"!pharmacy.testPharmacy\" \nclass=\"admin-pharmacies-boolean admin-pharmacies-boolean--no\">Non</span></td><td \nclass=\"admin-pharmacies-cell admin-pharmacies-cell--actions\"><div class=\"admin-pharmacies-actions\"><button \ntype=\"button\" class=\"admin-pharmacies-action admin-pharmacies-action--toggle\" \nng-class=\"pharmacy.isActivated ? \'is-active\' : \'is-inactive\'\" ng-click=\"showConfirm(pharmacy)\" \naria-label=\"Activer/Désactiver la pharmacie\"><md-tooltip>\n{{pharmacy.isActivated ? \'Désactiver\' : \'Activer\'}} la pharmacie</md-tooltip><md-icon ng-if=\"pharmacy.isActivated\" \nmd-svg-src=\"assets/icons/app/admin/check.svg\" class=\"s16\"></md-icon><md-icon ng-if=\"!pharmacy.isActivated\" \nmd-svg-src=\"assets/icons/app/admin/close.svg\" class=\"s16\"></md-icon></button> <button type=\"button\" \nclass=\"admin-pharmacies-action admin-pharmacies-action--edit\" ng-click=\"showPharmacyDialog(pharmacy)\" \naria-label=\"Modifier la pharmacie\"><md-tooltip>Modifier la pharmacie</md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon></button> <button type=\"button\" \nclass=\"admin-pharmacies-action admin-pharmacies-action--download\" ng-if=\"!pharmacy.isActivated\" \nng-click=\"downloadZip(pharmacy)\" aria-label=\"Télécharger le zip\"><md-tooltip>Télécharger le zip</md-tooltip><md-icon \nmd-font-icon=\"icon-box-download\" class=\"s16\"></md-icon></button> <button type=\"button\" \nclass=\"admin-pharmacies-action admin-pharmacies-action--delete\" ng-if=\"!pharmacy.isActivated\" \nng-click=\"openDelete(pharmacy)\" aria-label=\"Supprimer la pharmacie\"><md-tooltip>Supprimer définitivement la pharmacie\n</md-tooltip><md-icon md-font-icon=\"icon-trash\" class=\"s16\"></md-icon></button></div></td></tr></tbody></table></div>\n<div class=\"admin-pharmacies-pagination\"><dir-pagination-controls on-page-change=\"getPharmacies()\">\n</dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/main/admin/pharmacies/pharmacies_categories.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Pharmacies</h1><div class=\"nl-listing mt-45\">\n<div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"cat in categories | orderBy: \'index\'\" \nng-click=\"openCategorie(cat)\"><div flex class=\"text-truncate nl-listing-item-title pbt-10\">{{cat.title}}</div></div>\n</div></div></section>");
$templateCache.put("app/main/admin/suivi-enquete/suivi-enquete.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-suivi-page\"><div \nclass=\"header md-accent-bg admin-suivi-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"admin-suivi-header__title-group\"><div \nclass=\"h1 admin-suivi-header__title\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s24 admin-suivi-header__icon\">\n</md-icon><span>{{isGroupementPharmaciesPage ? \'Pharmacies engagées\' : \'Suivi enquête\'}}</span></div><div \nclass=\"admin-suivi-header__subtitle\">\n{{isGroupementView ? (isConsolidatedGroupementView ? \'Vue consolidée — tous vos groupements\' : \'Vision groupement\') : \'Vision nationale — toutes pharmacies confondues\'}}\n</div></div></div></div><div class=\"content admin-suivi-content\"><div class=\"admin-suivi-perimetre-secours\" \nng-if=\"perimetre && perimetre.source === \'SECOURS\'\"><md-icon md-font-icon=\"icon-alert\" class=\"s20\"></md-icon><div><div \nclass=\"admin-suivi-perimetre-secours__titre\" ng-if=\"perimetre.luLe\">\nRattachements au {{perimetre.luLe | date:\'dd/MM/yyyy\'}} à {{perimetre.luLe | date:\'HH:mm\'}}</div><div \nclass=\"admin-suivi-perimetre-secours__titre\" ng-if=\"!perimetre.luLe\">Rattachements du dernier état connu</div><div \nclass=\"admin-suivi-perimetre-secours__texte\">\nLe CRM ne répond pas : chaque officine est comptée dans le groupement où il la plaçait lors de sa dernière lecture. Les chiffres suivront le CRM dès son retour.\n</div></div></div><div class=\"admin-suivi-end-campaign\" \nng-if=\"isGroupementView && !isConsolidatedGroupementView && endOfCampaignNotice\"><div \nclass=\"admin-suivi-end-campaign__head\"><div class=\"admin-suivi-end-campaign__eyebrow\">Fin de campagne</div><div \nclass=\"admin-suivi-end-campaign__delay\" ng-if=\"endOfCampaignDelayMessage\">{{endOfCampaignDelayMessage}}</div></div><div\n class=\"admin-suivi-end-campaign__message\">{{endOfCampaignNotice}}</div><div class=\"admin-suivi-end-campaign__actions\">\n<button type=\"button\" class=\"admin-suivi-btn admin-suivi-btn--secondary admin-suivi-end-campaign__action\" \nng-click=\"downloadEngagedPharmaciesReportsZip()\" ng-disabled=\"groupementReportLoading\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"15px\" ng-if=\"groupementReportLoading\"></md-progress-circular><md-icon \nmd-font-icon=\"icon-download\" class=\"s14\" ng-if=\"!groupementReportLoading\"></md-icon><span \nng-if=\"!groupementReportLoading\">Générer et télécharger le rapport groupement</span> <span \nng-if=\"groupementReportLoading\">Génération en cours…</span></button><div class=\"admin-suivi-end-campaign__hint\">\nLe téléchargement inclut le rapport consolidé du groupement et le ZIP des rapports individuels des pharmacies.</div>\n</div></div><div class=\"admin-suivi-end-campaign admin-suivi-end-campaign--consolidated\" \nng-if=\"isGroupementView && isConsolidatedGroupementView\"><div class=\"admin-suivi-end-campaign__head\"><div \nclass=\"admin-suivi-end-campaign__eyebrow\">Fin de campagne</div><div class=\"admin-suivi-end-campaign__delay\">\nEnvoi sous 48h après fin de campagne.</div></div><div class=\"admin-suivi-end-campaign__message\">\nSélectionnez un groupement dans le sélecteur du haut pour télécharger son rapport consolidé et le ZIP des rapports individuels des pharmacies.\n</div></div><div class=\"admin-suivi-filters\"><div class=\"admin-suivi-filter admin-suivi-filter--date\"><div \nclass=\"admin-suivi-filter__head\"><div class=\"admin-suivi-filter__icon admin-suivi-filter__icon--blue\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s18\"></md-icon></div><div><div class=\"admin-suivi-filter__title\">Date de réponse\n</div><div class=\"admin-suivi-filter__hint\">Filtrer sur une période</div></div></div><div class=\"qs-admin-filter-row\">\n<div class=\"iv-Input-date-wrapper\"><md-icon ng-click=\"datePickers.responseDateStart = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" \nmd-is-open=\"datePickers.responseDateStart\" ng-click=\"datePickers.responseDateStart = true\" \nng-model=\"filters.responseDateStart\" placeholder=\"Date de début\" md-open-on-focus md-hide-icons=\"all\"></md-datepicker>\n</div><div class=\"iv-Input-date-wrapper\"><md-icon ng-click=\"datePickers.responseDateEnd = true\" \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"datePickers.responseDateEnd\" ng-click=\"datePickers.responseDateEnd = true\" \nng-model=\"filters.responseDateEnd\" placeholder=\"Date de fin\" md-open-on-focus md-hide-icons=\"all\"></md-datepicker>\n</div></div><div class=\"admin-suivi-filter__actions\"><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"applyFilters()\"><md-icon md-font-icon=\"icon-filter\" \nclass=\"s14\"></md-icon><span>Filtrer</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost\" ng-click=\"clearDateFilter()\">Effacer</button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--secondary\" ng-if=\"!isGroupementView\" ng-click=\"exportAllResponses()\" \nng-disabled=\"allResponsesExportLoading\"><md-icon md-font-icon=\"icon-download\" class=\"s14\"></md-icon><span>\n{{allResponsesExportLoading ? \'Export en cours...\' : \'Exporter les réponses (Excel)\'}}</span></button></div><div \nclass=\"admin-suivi-filter__export-hint\" ng-if=\"!isGroupementView\">\nL\'export respecte tous les filtres (période + pharmacies).</div></div><div \nclass=\"admin-suivi-filter admin-suivi-filter--pharmacy\"><div class=\"admin-suivi-filter__head\"><div \nclass=\"admin-suivi-filter__icon admin-suivi-filter__icon--orange\"><md-icon md-font-icon=\"icon-pharmacy\" class=\"s18\">\n</md-icon></div><div><div class=\"admin-suivi-filter__title\">Pharmacie</div><div class=\"admin-suivi-filter__hint\">\nSélectionner une ou plusieurs pharmacies</div></div></div><div class=\"admin-suivi-search\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s16 admin-suivi-search__icon\"></md-icon><input type=\"text\" \nclass=\"admin-suivi-search__input\" placeholder=\"Rechercher par code CIP ou nom...\" ng-model=\"pharmacySearch\"></div><div \nclass=\"qs-admin-pharmacy-list qs-admin-pharmacy-list--grouped\" ng-if=\"!isGroupementView\"><div \nclass=\"qs-admin-pharmacy-group\" ng-repeat=\"group in getVisiblePharmacyGroups() track by group.key\"><div \nclass=\"qs-admin-pharmacy-group__head\" ng-click=\"togglePharmacyGroup(group, $event)\" \nng-class=\"{\'qs-admin-pharmacy-group__head--open\': group.expanded}\"><md-checkbox \nclass=\"qs-admin-pharmacy-group__checkbox\" aria-label=\"Sélectionner le groupement {{group.name}}\" \nng-checked=\"isPharmacyGroupChecked(group)\" md-indeterminate=\"isPharmacyGroupIndeterminate(group)\" \nng-click=\"$event.stopPropagation(); togglePharmacyGroupSelection(group)\"></md-checkbox><md-icon \nmd-font-icon=\"{{group.expanded ? \'icon-chevron-down\' : \'icon-chevron-right\'}}\" \nclass=\"s16 qs-admin-pharmacy-group__chevron\"></md-icon><span class=\"qs-admin-pharmacy-group__name\">{{group.name}}\n</span> <span class=\"qs-admin-pharmacy-group__count\">\n{{getPharmacyGroupSelectedVisibleCount(group)}} / {{group.visibleOptions.length}} sélectionnées</span></div><div \nclass=\"qs-admin-pharmacy-group__items\" ng-if=\"group.expanded\"><label class=\"qs-admin-pharmacy-item\" \nng-repeat=\"option in group.visibleOptions track by option.id\"><input type=\"checkbox\" \nng-checked=\"isPharmacySelected(option.id)\" ng-click=\"togglePharmacySelection(option.id)\"> <span>{{option.label}}</span>\n</label></div></div><div class=\"qs-admin-pharmacy-empty\" ng-if=\"!getVisiblePharmacyGroups().length\">\nAucune pharmacie trouvée.</div></div><div class=\"qs-admin-pharmacy-list\" ng-if=\"isGroupementView\"><label \nclass=\"qs-admin-pharmacy-item\" ng-repeat=\"option in getVisiblePharmacyOptions() track by option.id\"><input \ntype=\"checkbox\" ng-checked=\"isPharmacySelected(option.id)\" ng-click=\"togglePharmacySelection(option.id)\"> <span>\n{{option.label}}</span></label><div class=\"qs-admin-pharmacy-empty\" ng-if=\"!getVisiblePharmacyOptions().length\">\nAucune pharmacie trouvée.</div></div><div class=\"admin-suivi-filter__actions\"><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost\" ng-click=\"selectAllPharmacies()\">Tout</button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost\" ng-click=\"unselectAllPharmacies()\">Aucun</button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--ghost\" ng-click=\"clearPharmacyFilter()\">Effacer</button></div></div></div><div \nclass=\"admin-suivi-tabs\" ng-if=\"!(isGroupementView && isPharmaciesOnlyMode)\"><button type=\"button\" \nclass=\"admin-suivi-tab\" ng-click=\"setTab(tabs.diffusion)\" \nng-class=\"{\'admin-suivi-tab--active\': tabActive === tabs.diffusion}\"><md-icon md-font-icon=\"icon-chart-bar\" \nclass=\"s16\"></md-icon><span>Sollicitations</span></button> <button type=\"button\" class=\"admin-suivi-tab\" \nng-click=\"setTab(tabs.verbatims)\" ng-class=\"{\'admin-suivi-tab--active\': tabActive === tabs.verbatims}\"><md-icon \nmd-font-icon=\"icon-comment-text\" class=\"s16\"></md-icon><span>Verbatims</span></button> <button type=\"button\" \nclass=\"admin-suivi-tab\" ng-click=\"setTab(tabs.detailCriteres)\" \nng-class=\"{\'admin-suivi-tab--active\': tabActive === tabs.detailCriteres}\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s16\"></md-icon><span>Détail critères</span></button> <button \ntype=\"button\" class=\"admin-suivi-tab\" ng-click=\"setTab(tabs.profils)\" \nng-class=\"{\'admin-suivi-tab--active\': tabActive === tabs.profils}\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"s16\"></md-icon><span>Profil</span></button> <button type=\"button\" class=\"admin-suivi-tab\" \nng-if=\"!isGroupementView\" ng-click=\"setTab(tabs.pharmacies)\" \nng-class=\"{\'admin-suivi-tab--active\': tabActive === tabs.pharmacies}\"><md-icon md-font-icon=\"icon-pharmacy\" \nclass=\"s16\"></md-icon><span>Pharmacies engagées</span></button></div><div class=\"admin-suivi-loading\" \nng-if=\"tabActive === tabs.diffusion && loadingTabs.diffusion\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"34\"></md-progress-circular><span>Chargement…</span></div><div class=\"admin-suivi-loading\" \nng-if=\"tabActive === tabs.verbatims && loadingTabs.verbatims && !verbatimStats\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular><span>Chargement…</span></div><div \nclass=\"admin-suivi-loading\" ng-if=\"tabActive === tabs.detailCriteres && loadingTabs.detailCriteres\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular><span>Chargement…</span></div>\n<div class=\"admin-suivi-loading\" ng-if=\"tabActive === tabs.profils && loadingTabs.profils\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular><span>Chargement…</span></div><div \nclass=\"admin-suivi-loading\" ng-if=\"tabActive === tabs.pharmacies && loadingTabs.pharmacies\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular><span>Chargement…</span></div><div \nclass=\"admin-suivi-error\" ng-if=\"tabActive === tabs.diffusion && !loadingTabs.diffusion && errorTabs.diffusion\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"admin-suivi-error__title\">\nImpossible de charger le suivi diffusion pour le moment.</div><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"applyFilters()\">Réessayer</button></div><div \nclass=\"admin-suivi-error\" ng-if=\"tabActive === tabs.verbatims && !loadingTabs.verbatims && errorTabs.verbatims\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"admin-suivi-error__title\">\nImpossible de charger les verbatims pour le moment.</div><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"retryVerbatims()\">Réessayer</button></div><div \nclass=\"admin-suivi-error\" \nng-if=\"tabActive === tabs.detailCriteres && !loadingTabs.detailCriteres && errorTabs.detailCriteres\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"admin-suivi-error__title\">\nImpossible de charger le détail des critères pour le moment.</div><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"applyFilters()\">Réessayer</button></div><div \nclass=\"admin-suivi-error\" ng-if=\"tabActive === tabs.profils && !loadingTabs.profils && errorTabs.profils\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"admin-suivi-error__title\">\nImpossible de charger les profils pour le moment.</div><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"applyFilters()\">Réessayer</button></div><div \nclass=\"admin-suivi-error\" ng-if=\"tabActive === tabs.pharmacies && !loadingTabs.pharmacies && errorTabs.pharmacies\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"admin-suivi-error__title\">\nImpossible de charger les pharmacies engagées pour le moment.</div><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"applyFilters()\">Réessayer</button></div><div \nng-show=\"tabActive === tabs.diffusion && !loadingTabs.diffusion && !errorTabs.diffusion && solicitationStats\"><div \nclass=\"qs-solic\"><div class=\"qs-solic-header\"><h3 class=\"qs-solic-title\">\nSollicitations {{solicitationStats.currentCampaignYear}}</h3><p class=\"qs-solic-subtitle\">\nSuivi des envois et des réponses, ventilé par canal de diffusion.</p></div><div class=\"qs-solic-kpis\"><div \nclass=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--sent\" aria-hidden=\"true\"><svg \nviewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n<path d=\"M22 2 11 13\"/><path d=\"M22 2l-7 20-4-9-9-4 20-7z\"/></svg></div><div class=\"qs-solic-kpi-body\"><div \nclass=\"qs-solic-kpi-value\">{{getSolicitationTotalSent()}}</div><div class=\"qs-solic-kpi-label\">Sollicitations envoyées\n</div></div></div><div class=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--completed\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 6L9 17l-5-5\"/></svg></div><div class=\"qs-solic-kpi-body\">\n<div class=\"qs-solic-kpi-value\">{{getSolicitationTotalCompleted()}}</div><div class=\"qs-solic-kpi-label\">\nRéponses complètes</div></div></div><div class=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--rate\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M7 15l4-8 2 5 4-3\"/></svg></div><div \nclass=\"qs-solic-kpi-body\"><div class=\"qs-solic-kpi-value\" ng-if=\"getSolicitationCompletionRate() !== null\">\n{{getSolicitationCompletionRate()}}<small>%</small></div><div class=\"qs-solic-kpi-value qs-solic-kpi-value--empty\" \nng-if=\"getSolicitationCompletionRate() === null\">—</div><div class=\"qs-solic-kpi-label\">Taux de complétion</div><div \nclass=\"qs-solic-kpi-sub\" ng-if=\"getSolicitationTotalSent() > 0\">sur {{getSolicitationTotalSent()}} envoi<span \nng-if=\"getSolicitationTotalSent() !== 1\">s</span></div></div></div></div><div class=\"qs-solic-channels-header\"><h4 \nclass=\"qs-solic-channels-title\">Détail par canal</h4></div><div class=\"qs-solic-channels\"><article \nclass=\"qs-solic-channel\" ng-repeat=\"ch in getSolicitationChannelList() track by ch.channel\"><div \nclass=\"qs-solic-channel-head\"><span \nclass=\"qs-solic-channel-icon qs-solic-channel-icon--{{getSolicitationChannelIconKind(ch.channel)}}\" aria-hidden=\"true\">\n<svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'sms\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"/>\n</svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'email\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"/><polyline points=\"22,6 12,13 2,6\"/>\n</svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'qr\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" \nheight=\"7\" rx=\"1\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"/>\n<path d=\"M14 14h3v3h-3zM20 14v3M14 20h3v1M20 20v1\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'share\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18\" cy=\"5\" r=\"3\"/><circle cx=\"6\" cy=\"12\" \nr=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"/><line x1=\"15.41\" y1=\"6.51\" \nx2=\"8.59\" y2=\"10.49\"/></svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'tablet\'\" viewBox=\"0 0 24 24\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"2\" \nwidth=\"16\" height=\"20\" rx=\"2\"/><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'paper\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"/><polyline points=\"14 2 14 8 20 8\"/><line x1=\"9\" \ny1=\"13\" x2=\"15\" y2=\"13\"/><line x1=\"9\" y1=\"17\" x2=\"15\" y2=\"17\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'other\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><line x1=\"12\" y1=\"8\" \nx2=\"12\" y2=\"12\"/><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"/></svg></span><div class=\"qs-solic-channel-name\">{{ch.label}}\n</div><div class=\"qs-solic-channel-rate\" ng-if=\"getSolicitationChannelRate(ch) !== null\">\n{{getSolicitationChannelRate(ch)}}%</div><div class=\"qs-solic-channel-rate qs-solic-channel-rate--empty\" \nng-if=\"getSolicitationChannelRate(ch) === null\">—</div></div><div class=\"qs-solic-channel-bar\" ng-if=\"ch.sent > 0\"><div\n class=\"qs-solic-channel-bar-fill\" ng-style=\"{width: (ch.completed / ch.sent * 100) + \'%\'}\"></div></div><div \nclass=\"qs-solic-channel-bar qs-solic-channel-bar--empty\" ng-if=\"!ch.sent\"></div><div class=\"qs-solic-channel-numbers\">\n<span><strong>{{ch.completed}}</strong> complétée<span ng-if=\"ch.completed !== 1\">s</span></span> <span \nclass=\"qs-solic-channel-sep\">·</span> <span>{{ch.sent}} envoyée<span ng-if=\"ch.sent !== 1\">s</span></span></div>\n</article></div><div class=\"qs-results-card qs-solic-status-help\"><div class=\"qs-solic-status-help-icon\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M12 8h.01\"></path><path d=\"M11 12h1v4h1\">\n</path></svg></div><div class=\"qs-solic-status-help-content\"><div class=\"qs-solic-status-help-title\">\nComment lire ces statuts ?</div><p class=\"qs-solic-status-help-line\"><strong>Envoyé</strong>\n - Sollicitation transmise au client (SMS, email) ou lien généré (QR code, tablette, papier, lien partagé).</p><p \nclass=\"qs-solic-status-help-line\"><strong>Partielle</strong>\n - Le client a ouvert le questionnaire et commencé à répondre, sans aller jusqu\'au bout. N\'est pas comptabilisé dans les graphiques de résultats.\n</p><p class=\"qs-solic-status-help-line\"><strong>Complète</strong>\n - Le client a soumis l\'ensemble du questionnaire jusqu\'à la confirmation finale.</p><p \nclass=\"qs-solic-status-help-note\">\nÀ noter : un canal pour lequel aucun envoi ni accès n\'a été enregistré n\'est pas comptabilisé.</p></div></div><div \nclass=\"qs-results-card qs-solic-chart\"><div class=\"qs-results-card-title\">Vue histogramme</div><div \nclass=\"qs-results-card-caption\">Nombre de réponses complétées par canal d\'origine.</div><div \nclass=\"qs-results-chart-shell\"><canvas id=\"qsAdminSolicitationsCurrentChart\" height=\"110\"></canvas></div></div><div \nclass=\"qs-results-card qs-solic-historical\" ng-if=\"solicitationStats.historicalVisible\"><div \nclass=\"qs-results-card-header\"><div><div class=\"qs-results-card-title\">Sollicitations historiques</div><div \nclass=\"qs-results-card-caption\">Campagnes précédentes</div></div><div class=\"admin-suivi-year-switcher\" \nng-if=\"getHistoricalSolicitationCampaigns().length\"><button type=\"button\" class=\"admin-suivi-year-btn\" \nng-repeat=\"campaign in getHistoricalSolicitationCampaigns() track by campaign.year\" \nng-click=\"selectHistoricalSolicitationYear(campaign.year)\" \nng-class=\"{\'is-active\': selectedHistoricalSolicitationYear === campaign.year}\">{{campaign.year}}</button></div></div>\n<div class=\"qs-results-chart-shell\"><canvas id=\"qsAdminSolicitationsHistoricalChart\" height=\"120\"></canvas></div></div>\n</div></div><div ng-if=\"tabActive === tabs.verbatims && !errorTabs.verbatims && verbatimStats\"><div \nclass=\"qs-results-card admin-suivi-chart-card\" id=\"qsAdminVerbatimTableAnchor\" \nng-class=\"{\'qs-results-card--loading\': loadingTabs.verbatims}\"><div class=\"qs-results-card__overlay\" \nng-if=\"loadingTabs.verbatims\" aria-hidden=\"true\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\">\n</md-progress-circular></div><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--teal\"></div><div><div \nclass=\"qs-results-card-title\">Commentaires {{verbatimStats.campaignYear}}</div><div class=\"qs-results-card-caption\">\n{{verbatimStats.questionLabel}}</div><div class=\"qs-results-card-meta\">\n{{verbatimStats.commentCount || 0}} commentaires trouvés <span ng-if=\"verbatimStats.searchText\">\npour «&nbsp;{{verbatimStats.searchText}}&nbsp;»</span></div></div></div><div class=\"qs-verbatim-toolbar\"><div \nclass=\"qs-verbatim-search\"><md-icon md-font-icon=\"icon-magnify\" class=\"s16 qs-verbatim-search__icon\"></md-icon><input \ntype=\"text\" class=\"qs-verbatim-search__input\" ng-model=\"verbatimPagination.searchText\" \nng-change=\"onVerbatimSearchChange()\" placeholder=\"Rechercher dans les commentaires\"> <button type=\"button\" \nclass=\"qs-verbatim-search__clear\" ng-if=\"verbatimPagination.searchText\" ng-click=\"clearVerbatimSearch()\" \naria-label=\"Effacer la recherche\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"downloadVerbatimXlsx()\" ng-disabled=\"verbatimExportLoading\">\n{{verbatimExportLoading ? \'Export en cours...\' : \'Exporter en Excel\'}}</button></div><div \nclass=\"admin-suivi-empty-state\" ng-if=\"!(verbatimStats.comments && verbatimStats.comments.length)\"><md-icon \nmd-font-icon=\"icon-comment-text\" class=\"s44 admin-suivi-empty-state__icon\"></md-icon><div \nclass=\"admin-suivi-empty-state__title\">Aucun commentaire à afficher</div><div class=\"admin-suivi-empty-state__hint\" \nng-if=\"!verbatimStats.searchText\">\nAucun commentaire exploitable pour les filtres sélectionnés. Modifiez les filtres pour obtenir plus de résultats.</div>\n<div class=\"admin-suivi-empty-state__hint\" ng-if=\"verbatimStats.searchText\">\nAucun commentaire ne correspond à votre recherche «&nbsp;{{verbatimStats.searchText}}&nbsp;».</div></div><div \nclass=\"qs-verbatim-table qs-verbatim-table--comments\" ng-if=\"verbatimStats.comments && verbatimStats.comments.length\">\n<div class=\"qs-verbatim-row qs-verbatim-row--head\"><div class=\"qs-verbatim-cell qs-verbatim-cell-date\">Date de réponse\n</div><div class=\"qs-verbatim-cell qs-verbatim-cell-comment\">{{verbatimStats.questionLabel}}</div></div><div \nclass=\"qs-verbatim-row\" ng-repeat=\"comment in verbatimStats.comments track by $index\"><div \nclass=\"qs-verbatim-cell qs-verbatim-cell-date\">{{comment.responseDateTime | date:\'dd/MM/yyyy HH:mm:ss\'}}</div><div \nclass=\"qs-verbatim-cell qs-verbatim-cell-comment\">{{comment.comment}}</div></div></div><div \nclass=\"qs-verbatim-pagination\" ng-if=\"verbatimPagination.pageCount > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: verbatimPagination.page <= 1}\"><button type=\"button\" ng-disabled=\"verbatimPagination.page <= 1\" \nng-click=\"onVerbatimPageChange(verbatimPagination.page - 1, verbatimPagination.page)\">‹</button></li><li \nng-repeat=\"pageNumber in getVerbatimPageNumbers() track by $index\" \nng-class=\"{active: verbatimPagination.page === pageNumber, disabled: pageNumber === \'...\'}\"><button type=\"button\" \nng-if=\"pageNumber !== \'...\'\" ng-disabled=\"verbatimPagination.page === pageNumber\" \nng-click=\"onVerbatimPageChange(pageNumber, verbatimPagination.page)\">{{pageNumber}}</button> <button type=\"button\" \nng-if=\"pageNumber === \'...\'\" disabled=\"disabled\">...</button></li><li \nng-class=\"{disabled: verbatimPagination.page >= verbatimPagination.pageCount}\"><button type=\"button\" \nng-disabled=\"verbatimPagination.page >= verbatimPagination.pageCount\" \nng-click=\"onVerbatimPageChange(verbatimPagination.page + 1, verbatimPagination.page)\">›</button></li></ul></div></div>\n</div><div \nng-show=\"tabActive === tabs.detailCriteres && !loadingTabs.detailCriteres && !errorTabs.detailCriteres && criteriaDetailsStats\">\n<div class=\"qs-criteria-grid\"><div class=\"qs-criteria-column\" \nng-repeat=\"scope in getCriteriaDetailsScopes() track by scope.key\"><div class=\"admin-suivi-scope-title\">{{scope.title}}\n</div><div class=\"qs-results-card admin-suivi-chart-card qs-criteria-empty\" \nng-if=\"!scope.data || !scope.data.questionnaireCount\">Aucun questionnaire disponible pour cette campagne.</div><div \nng-if=\"scope.data && scope.data.questionnaireCount\"><div class=\"qs-results-card admin-suivi-chart-card\"><div \nclass=\"admin-suivi-chart-card__head\"><div class=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--cyan\">\n</div><div><div class=\"qs-results-card-title\">Note d\'appréciation globale</div><div class=\"qs-results-card-caption\">\nCampagne {{criteriaDetailsStats.campaignYear}}</div></div></div><div class=\"qs-criteria-gauge-shell\"><canvas \nid=\"qsAdminCriteriaGaugeChart-{{scope.key}}\"></canvas><div class=\"qs-criteria-gauge-value\">\n{{formatCriteriaAverage(scope.data.overallSatisfactionAverage)}}</div></div><div class=\"qs-criteria-gauge-scale\"><span>\n0</span> <span>10</span></div></div><div class=\"qs-results-card admin-suivi-chart-card\"><div \nclass=\"admin-suivi-chart-card__head\"><div class=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--blue\">\n</div><div><div class=\"qs-results-card-title\">Histogramme de satisfaction</div><div class=\"qs-results-card-caption\">\nVotre satisfaction générale sur cette pharmacie</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas \nid=\"qsAdminCriteriaDistributionChart-{{scope.key}}\"></canvas></div></div><div \nclass=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--teal\"></div><div><div \nclass=\"qs-results-card-title\">Évaluation de la pharmacie</div><div class=\"qs-results-card-caption\">\nVotre satisfaction générale sur cette pharmacie</div><div class=\"qs-criteria-legend\"><span \nclass=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" style=\"background-color: #df3e48\"></span>\nTrès insatisfait</span> <span class=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" \nstyle=\"background-color: #d2776c\"></span>Insatisfait</span> <span class=\"qs-criteria-legend-item\"><span \nclass=\"qs-criteria-legend-swatch\" style=\"background-color: #7c7c7c\"></span>Neutre</span> <span \nclass=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" style=\"background-color: #a1d273\"></span>\nSatisfait</span> <span class=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" \nstyle=\"background-color: #83c14f\"></span>Très satisfait</span></div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas id=\"qsAdminCriteriaStackedChart-{{scope.key}}\">\n</canvas></div></div><div class=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div\n class=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--orange\"></div><div><div \nclass=\"qs-results-card-title\">Raisons de visite</div><div class=\"qs-results-card-caption\">\nOrdonnance, sans ordonnance, parapharmacie, vaccination ou test, autre</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas \nid=\"qsAdminCriteriaVisitReasonsChart-{{scope.key}}\"></canvas></div></div><div \nclass=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--teal\"></div><div><div \nclass=\"qs-results-card-title\">Priorités environnementales</div><div class=\"qs-results-card-caption\">\nPour vous, la priorité en pharmacie pour protéger l’environnement, c’est surtout...</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas \nid=\"qsAdminCriteriaPrioritiesChart-{{scope.key}}\"></canvas></div></div><div \nclass=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--amber\"></div><div><div \nclass=\"qs-results-card-title\">Recommandation</div><div class=\"qs-results-card-caption\">\nRecommanderiez-vous notre pharmacie</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas \nid=\"qsAdminCriteriaRecommendationChart-{{scope.key}}\"></canvas></div></div><div \nclass=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--coral\"></div><div><div \nclass=\"qs-results-card-title\">Prises en charge urgence</div><div class=\"qs-results-card-caption\">\nParmi ces situations, les prises en charge le plus utiles à la pharmacie en première intention sont</div></div></div>\n<div class=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas \nid=\"qsAdminCriteriaUrgentCareChart-{{scope.key}}\"></canvas></div></div></div></div></div></div><div \nng-show=\"tabActive === tabs.profils && !loadingTabs.profils && !errorTabs.profils && profileStats\"><div \nclass=\"qs-profile-stack\"><div class=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\">\n<div class=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--purple\"></div><div><div \nclass=\"qs-results-card-title\">{{profileStats.gender.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{profileStats.campaignYear}}</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\" \nng-if=\"profileStats.gender && profileStats.gender.questionnaireCount\"><canvas id=\"qsAdminProfileGenderChart\"></canvas>\n</div><div class=\"qs-profile-empty\" ng-if=\"!(profileStats.gender && profileStats.gender.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div class=\"qs-profile-table\" \nng-if=\"profileStats.gender && profileStats.gender.questionnaireCount\"><div \nclass=\"qs-profile-table-row qs-profile-table-row--head\"><div class=\"qs-profile-table-cell qs-profile-table-cell-label\">\nSexe</div><div class=\"qs-profile-table-cell qs-profile-table-cell-value\">{{profileStats.campaignYear}}</div></div><div \nclass=\"qs-profile-table-row\" ng-repeat=\"item in profileStats.gender.values track by item.label\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">{{item.label}}</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{formatProfilePercentage(item.percentage)}}</div></div>\n</div></div><div class=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--blue\"></div><div><div \nclass=\"qs-results-card-title\">{{profileStats.ageRange.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{profileStats.campaignYear}}</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\" \nng-if=\"profileStats.ageRange && profileStats.ageRange.questionnaireCount\"><canvas id=\"qsAdminProfileAgeRangeChart\">\n</canvas></div><div class=\"qs-profile-empty\" \nng-if=\"!(profileStats.ageRange && profileStats.ageRange.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div class=\"qs-profile-table\" \nng-if=\"profileStats.ageRange && profileStats.ageRange.questionnaireCount\"><div \nclass=\"qs-profile-table-row qs-profile-table-row--head\"><div class=\"qs-profile-table-cell qs-profile-table-cell-label\">\nÂge</div><div class=\"qs-profile-table-cell qs-profile-table-cell-value\">{{profileStats.campaignYear}}</div></div><div \nclass=\"qs-profile-table-row\" ng-repeat=\"item in profileStats.ageRange.values track by item.label\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">{{item.label}}</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{formatProfilePercentage(item.percentage)}}</div></div>\n</div></div><div class=\"qs-results-card admin-suivi-chart-card\"><div class=\"admin-suivi-chart-card__head\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--teal\"></div><div><div \nclass=\"qs-results-card-title\">{{profileStats.regularCustomer.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{profileStats.campaignYear}}</div></div></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\" \nng-if=\"profileStats.regularCustomer && profileStats.regularCustomer.questionnaireCount\"><canvas \nid=\"qsAdminProfileRegularCustomerChart\"></canvas></div><div class=\"qs-profile-empty\" \nng-if=\"!(profileStats.regularCustomer && profileStats.regularCustomer.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div class=\"qs-results-card-meta\" \nng-if=\"profileStats.regularCustomer\">Questionnaires : {{profileStats.regularCustomer.questionnaireCount || 0}}</div>\n</div></div></div><div ng-show=\"tabActive === tabs.pharmacies && !loadingTabs.pharmacies && !errorTabs.pharmacies\"><div\n class=\"qs-results-card admin-suivi-chart-card\"><div \nclass=\"admin-suivi-chart-card__head admin-suivi-chart-card__head--split\"><div \nclass=\"admin-suivi-chart-card__head-main\"><div \nclass=\"admin-suivi-chart-card__accent admin-suivi-chart-card__accent--orange\"></div><div><div \nclass=\"qs-results-card-title\">Pharmacies engagées</div><div class=\"qs-results-card-caption\">Détail par pharmacie</div>\n</div></div><div class=\"admin-suivi-export-actions\"><button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--primary\" ng-click=\"exportEngagedPharmacies()\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s14\"></md-icon><span>Excel</span></button> <button type=\"button\" \nclass=\"admin-suivi-btn admin-suivi-btn--secondary\" ng-if=\"!isGroupementView\" \nng-click=\"downloadEngagedPharmaciesReportsZip()\"><md-icon md-font-icon=\"icon-box-download\" class=\"s14\"></md-icon><span>\nZIP PDF</span></button></div></div><div class=\"qs-solic-kpis\"><div class=\"qs-solic-kpi\"><div \nclass=\"qs-solic-kpi-icon qs-solic-kpi-icon--completed\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 6L9 17l-5-5\"/>\n</svg></div><div class=\"qs-solic-kpi-body\"><div class=\"qs-solic-kpi-value\">\n{{engagedPharmaciesSummary.completedCount || 0}}</div><div class=\"qs-solic-kpi-label\">Pharmacies ayant complété</div>\n</div></div><div class=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--rate\" aria-hidden=\"true\"><svg \nviewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M8 12h8\"/></svg></div><div class=\"qs-solic-kpi-body\">\n<div class=\"qs-solic-kpi-value\">{{engagedPharmaciesSummary.unansweredCount || 0}}</div><div class=\"qs-solic-kpi-label\">\nPharmacies non répondues</div></div></div></div><div class=\"qs-admin-table-empty\" ng-if=\"!engagedPharmacies.length\">\nAucune pharmacie à afficher pour les filtres sélectionnés.</div><div id=\"qsAdminEngagedTableAnchor\" \nclass=\"qs-admin-table-wrapper\" ng-if=\"engagedPharmacies.length\"><table class=\"qs-admin-table\" \nng-class=\"{\'qs-admin-table--groupement\': isGroupementView && !shouldShowEngagedGroupementColumn()}\"><thead><tr><th \nng-if=\"shouldShowEngagedGroupementColumn()\">Groupement</th><th>Code CIP</th><th>Nom</th><th>Complétés</th><th>\nPartielles</th><th>Non répondues</th></tr></thead><tbody><tr \ndir-paginate=\"row in engagedPharmacies | itemsPerPage: engagedPagination.nbrResults\" \ntotal-items=\"engagedPagination.total\" current-page=\"engagedPagination.page\"><td \nng-if=\"shouldShowEngagedGroupementColumn()\">{{row.groupement}}</td><td>{{row.cipCode}}</td><td>{{row.pharmacyName}}\n</td><td><span class=\"admin-suivi-count admin-suivi-count--ok\">{{row.completed || 0}}</span></td><td><span \nclass=\"admin-suivi-count admin-suivi-count--partial\">{{row.partial || 0}}</span></td><td><span \nclass=\"admin-suivi-count admin-suivi-count--muted\">{{row.unanswered || 0}}</span></td></tr></tbody></table>\n<dir-pagination-controls on-page-change=\"onEngagedPageChange(newPageNumber, oldPageNumber)\"></dir-pagination-controls>\n</div></div></div></div></div>");
$templateCache.put("app/main/admin/toolbox/toolbox.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page qs-toolbox-page\"><div \nclass=\"header md-accent-bg qs-toolbox-header\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span>\n<md-icon md-font-icon=\"icon-pharmacy\" class=\"s24\"></md-icon></span><span>Boîte à outils</span></div><div \nclass=\"h2 mt-4\">Documents et ressources partagés avec les pharmacies du groupement.</div></div></div></div><div \nclass=\"content qs-toolbox-content\"><div class=\"qs-toolbox-toolbar\"><div class=\"qs-toolbox-count\"><md-icon \nmd-font-icon=\"icon-folder-outline\" class=\"s22\"></md-icon><span ng-if=\"!loading\"><strong>{{tools.length}}</strong>\n {{tools.length &lt;= 1 ? \'outil disponible\' : \'outils disponibles\'}} </span><span ng-if=\"loading\" \nclass=\"qs-toolbox-count-loading\">Chargement…</span></div><button type=\"button\" class=\"nl-Btn qs-toolbox-add\" \nng-click=\"showToolDialog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><span>Ajouter un outil</span>\n</button></div><div class=\"qs-toolbox-card\"><div ng-if=\"loading\" class=\"qs-toolbox-loading\" layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular>\n<span class=\"ml-10\">Chargement des outils…</span></div><div ng-if=\"!loading && !tools.length\" class=\"qs-toolbox-empty\">\n<div class=\"qs-toolbox-empty-icon\"><md-icon md-font-icon=\"icon-folder-plus-outline\" class=\"s44\"></md-icon></div><div \nclass=\"qs-toolbox-empty-title\">Aucun outil pour l\'instant</div><div class=\"qs-toolbox-empty-text\">\nAjoutez un premier document pour que vos pharmacies y aient accès.</div><button type=\"button\" \nclass=\"nl-Btn qs-toolbox-empty-cta\" ng-click=\"showToolDialog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\">\n</md-icon><span>Ajouter un premier outil</span></button></div><div ng-if=\"!loading && tools.length\" \nclass=\"qs-admin-table-wrapper\"><table class=\"qs-admin-table qs-toolbox-table\"><thead><tr><th \nclass=\"qs-toolbox-col-order\">Ordre</th><th>Nom de l\'outil</th><th>Lien</th><th class=\"qs-toolbox-col-actions\">Actions\n</th></tr></thead><tbody><tr ng-repeat=\"tool in tools track by tool.id\"><td class=\"qs-toolbox-col-order\"><div \nclass=\"qs-toolbox-order\"><button type=\"button\" class=\"qs-toolbox-order-btn\" ng-click=\"moveTool(tool, true)\" \nng-disabled=\"$first || moveLoading[tool.id]\" aria-label=\"Monter\"><md-tooltip md-direction=\"top\" ng-if=\"!$first\">\nMonter dans la liste</md-tooltip><md-icon md-svg-src=\"assets/icons/app/board/arrow_up.svg\"></md-icon></button> <span \nclass=\"qs-toolbox-order-pos\">{{$index + 1}}</span> <button type=\"button\" class=\"qs-toolbox-order-btn\" \nng-click=\"moveTool(tool, false)\" ng-disabled=\"$last || moveLoading[tool.id]\" aria-label=\"Descendre\"><md-tooltip \nmd-direction=\"top\" ng-if=\"!$last\">Descendre dans la liste</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/app/board/arrow_down.svg\"></md-icon></button></div></td><td><div \nclass=\"qs-toolbox-title-cell\"><md-icon md-font-icon=\"icon-file-document-outline\" class=\"qs-toolbox-file-icon\">\n</md-icon><div class=\"qs-toolbox-title-block\"><div class=\"qs-toolbox-title\">{{tool.title}}</div><div \nclass=\"qs-toolbox-filename\" ng-if=\"tool.originalFileName\" title=\"{{tool.originalFileName}}\">{{tool.originalFileName}}\n</div></div></div></td><td><a href=\"\" ng-click=\"downloadTool(tool)\" class=\"qs-toolbox-link\" \ntitle=\"{{getToolActionLabel(tool)}}\"><md-icon ng-if=\"tool.externalUrl\" md-font-icon=\"icon-link-variant\" class=\"s18\">\n</md-icon><md-icon ng-if=\"!tool.externalUrl\" md-font-icon=\"icon-download\" class=\"s18\"></md-icon><span>\n{{tool.linkTitle}}</span></a></td><td class=\"qs-toolbox-col-actions\"><button type=\"button\" \nclass=\"qs-toolbox-action qs-toolbox-action--edit\" ng-click=\"showToolDialog(tool)\" aria-label=\"Modifier\"><md-tooltip \nmd-direction=\"top\">Modifier</md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></button> <button \ntype=\"button\" class=\"qs-toolbox-action qs-toolbox-action--delete\" ng-click=\"openDelete(tool)\" aria-label=\"Supprimer\">\n<md-tooltip md-direction=\"top\">Supprimer</md-tooltip><md-icon md-font-icon=\"icon-trash\" class=\"s18\"></md-icon></button>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">404</div><div class=\"message\">\nDésolé, nous n\'avons pu trouver la page à laquelle vous voulez accéder</div><a class=\"back-link md-accent-color mt-32\" \nhref=\"/\">Retour à l\'accueil</a></div></div>");
$templateCache.put("app/main/front/controle/controle.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Contrôles</h1><div class=\"nl-listing mt-45\">\n<div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"cat in categories | orderBy: \'index\'\" \nng-click=\"openCategorie(cat)\"><md-button class=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/animationqual/{{cat.icon}}\" class=\"nl-listing-item-icon\"></md-icon></md-button><div \nclass=\"text-truncate nl-listing-item-title\">{{cat.title}}</div></div></div></div></section>");
$templateCache.put("app/main/front/equipe/equipe.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Equipes</h1><div class=\"nl-listing mt-45\"><div\n class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"cat in categories | orderBy: \'index\'\" \nng-click=\"openCategorie(cat)\"><md-button class=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/animationequi/{{cat.icon}}\" class=\"nl-listing-item-icon\"></md-icon></md-button><div \nclass=\"text-truncate nl-listing-item-title\">{{cat.title}}</div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"folders.length === 0\"><p>Aucun résultat...</p></md-list-item></div></section>");
$templateCache.put("app/main/front/folders/folders.html","<section class=\"nl-Page pb-45\" ng-if=\"!waiting\"><h1 class=\"nl-H1\"><div layout=\"row\"><a class=\"nl-H1--backBtn\" \nng-click=\"cancelSearch()\" ng-if=\"searching\"><md-icon md-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a>\n<button class=\"iv-BtnIconFill mr-20\" ng-click=\"openInfosFoldersPopup()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/information.svg\"></md-icon></button><div>Base documentaire</div></div><div \nlayout=\"row\" layout-align=\"end end\"></div><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"nl-SearchBar nl-SearchBar--home\" style=\"min-width: 80px\" layout=\"row\"><md-icon \nng-click=\"cancelSearch();searchDocuments()\" ng-show=\"filter.searchTxt\" md-svg-src=\"assets/icons/app/V3/del.svg\" \nclass=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon ng-click=\"searchDocuments()\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\"></md-icon>\n<md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" layout-align=\"end center\" \nflex=\"100\"><input ng-enter=\"searchDocuments()\" class=\"nl-Input-input--searchHome\" placeholder=\"Rechercher...\" \ntype=\"text\" name=\"title\" ng-model=\"filter.searchTxt\"></md-input-container></div></div></h1><div class=\"nl-Content\"><div\n class=\"nl-listing-bigTitle mb-20\" ng-if=\"searching\">Résultat de la recherche</div><div class=\"nl-listing doc-section\" \nng-if=\"!searching\" ng-repeat=\"folder in folders track by folder.id\"><div class=\"doc-category\" layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"openCat(folder)\" class=\"md-icon-button nl-listing-item-button\" \naria-label=\"Dossier\"><md-icon md-svg-src=\"assets/icons/app/V3/blue_arrow_right.svg\" \nclass=\"iv-listing-item-icon-folder\"></md-icon></md-button><h2 class=\"doc-section__title\" ng-click=\"openCat(folder)\">\n{{folder.name}}</h2></div><div class=\"doc-section__grid\"><div class=\"doc-separator\" \nng-repeat-start=\"child in folder.childs track by child.id\" ng-if=\"folder.index === 0 && child.index === 5\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/sort_by.svg\"></md-icon></div><div ng-repeat-end ng-click=\"openSubCat(folder, child)\" \nclass=\"doc-card\" \nng-class=\"{\'doc-card--{{folder.index}}\': child.icon != \'folder.svg\', \'doc-card--folder\': child.icon == \'folder.svg\'}\">\n<md-icon md-svg-src=\"assets/icons/app/V3/{{child.icon}}\"></md-icon><span>{{child.name}}</span></div></div></div><div \nng-if=\"searching\" class=\"nl-listing mt-10\"><div ng-repeat=\"document in resultSearch.documents | orderBy: \'name\'\" \nstyle=\"cursor: default !important\"><div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon md-svg-src=\"assets/icons/app/V3/file.svg\" \nclass=\"iv-listing-item-icon-file\" ng-if=\"!document.readOnly\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/app/V3/phsq.svg\" class=\"iv-listing-item-icon-file\" ng-if=\"document.readOnly\"></md-icon>\n</md-button><div layout=\"column\" layout-align=\"center start\" class=\"flex-40\"><div \nclass=\"text-truncate nl-listing-item-title\">{{document.name}}</div><div \nng-if=\"document.path != null && document.path.length > 0\" class=\"nl-indicator-header-infos\">Dans {{document.path}}\n</div></div><div class=\"text-truncate nl-indicator-header-infos flex-auto\">\n{{document.uploadDate | date: \'dd.MM.yyyy\'}} <span ng-if=\"document.status !== \'VALIDATED\'\">\nNon validé par le Responsable Qualité</span></div><div class=\"mr-5\"><button ng-show=\"document.isRestricted\" \nclass=\"iv-BtnIcon\" type=\"button\" ng-click=\"event.preventDefault()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon></button><md-tooltip ng-show=\"document.isRestricted\" \nmd-direction=\"bottom\">Visible uniquement par le titulaire et le Responsable Qualité</md-tooltip></div><div \nflex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-20\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item ng-if=\"document.pdf\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openPDF(document)\">\n<md-icon md-svg-src=\"./assets/icons/app/V3/open.svg\"></md-icon>Ouvrir</md-button></md-menu-item><md-menu-item>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/download.svg\"></md-icon>Télécharger</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openEditDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon>Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setRestrictedDoc(document)\"><md-icon ng-if=\"!document.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon><md-icon ng-if=\"document.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/show.svg\"></md-icon><div ng-if=\"!document.isRestricted\">Masquer pour l\'équipe</div>\n<div ng-if=\"document.isRestricted\">Démasquer pour l\'équipe</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openMoveFilePopup(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/move.svg\"></md-icon><div>Déplacer</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openHistoriquePopup(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/history.svg\"></md-icon><div>Historique des versions</div></md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openDeleteDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon>Supprimer</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div ng-repeat=\"folder in resultSearch.folders | orderBy: \'name\' track by folder.id\"><div \nclass=\"nl-listing-item\" layout=\"row\" layout-align=\"space-between center\" ng-click=\"openFolder(folder)\"><div \nlayout=\"row\"><md-button class=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\" layout-align=\"start\">\n<md-icon md-svg-src=\"assets/icons/app/V3/folder.svg\" class=\"iv-listing-item-icon-folder\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"text-truncate nl-listing-item-title\">{{folder.name}}</div><div \nclass=\"nl-indicator-header-infos\" ng-if=\"folder.path != null && folder.path.length > 0\">Dans {{folder.path}}</div>\n</div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-5\" ng-if=\"folder.isRestricted\">\n<button class=\"iv-BtnIcon\" type=\"button\" ng-click=\"event.preventDefault()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon></button><md-tooltip md-direction=\"bottom\">\nVisible uniquement par le titulaire et le Responsable Qualité</md-tooltip></div><md-menu class=\"iv-Menu mr-20\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openFolder(folder)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/open.svg\"></md-icon><div>Ouvrir</div></md-button></md-menu-item><md-menu-item \nng-if=\"(user.isPraq || user.isTitulaire) && !folder.readOnly\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"oepnEditFolder(folder)\"><md-icon md-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon><div>Modifier</div>\n</md-button></md-menu-item><md-menu-item ng-if=\"(user.isPraq || user.isTitulaire)\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setRestrictedFolder(folder)\"><md-icon ng-if=\"!folder.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon><md-icon ng-if=\"folder.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/show.svg\"></md-icon><div ng-if=\"!folder.isRestricted\">Masquer pour l\'équipe</div><div\n ng-if=\"folder.isRestricted\">Démasquer pour l\'équipe</div></md-button></md-menu-item><md-menu-item \nng-if=\"(user.isPraq || user.isTitulaire) && !folder.readOnly\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDeleteFolder(folder)\"><md-icon md-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer\n</div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nng-if=\"resultSearch.documents.length === 0 && resultSearch.folders.length === 0\">Aucun résultat</div></div>\n<md-list-item class=\"no-results md-white-bg\" ng-show=\"folders.length === 0\"><p>Aucun résultat...</p></md-list-item>\n</div></section><section class=\"nl-Page pb-45\" ng-if=\"waiting\"><h1 class=\"nl-H1\"><div>Base documentaire</div></h1><div \nclass=\"nl-Content\"><div class=\"nl-listing mt-45\" ng-if=\"!searching\"><div class=\"nl-listing-bigTitle mb-20\">\n{{documents.length > 1 ? documents.length + \' documents sont en attente de validation\' : documents.length + \' document est en attente de validation\'}}{{$root.user.isTeam ? \' par le Titulaire ou le Responsable Qualité\':\'\'}}\n</div><div layout=\"column\" ng-repeat=\"document in documents\"><div class=\"mt-10\"><div \nng-if=\"document.path != null && document.path.length > 0\" class=\"text-truncate nl-listing-item-upperTitle\">\nDans {{document.path}}</div></div><div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon md-svg-src=\"assets/icons/app/V3/file.svg\" \nclass=\"iv-listing-item-icon-file\"></md-icon></md-button><div class=\"text-truncate nl-listing-item-title flex-40\">\n{{document.name}}</div><div class=\"text-truncate nl-indicator-header-infos flex-auto\">\n{{document.uploadDate | date: \'dd/MM/yyyy HH:mm\'}} {{document.status !== \'VALIDATED\' ? \'Non validé par le Responsable Qualité\': \'\'}}\n</div><div class=\"mr-5\"><button ng-show=\"document.isRestricted\" class=\"iv-BtnIcon\" type=\"button\" \nng-click=\"event.preventDefault()\"><md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon></button><md-tooltip \nng-show=\"document.isRestricted\" md-direction=\"bottom\">Visible uniquement par le titulaire et le Responsable Qualité\n</md-tooltip></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item ng-if=\"document.pdf\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openPDF(document)\">\n<md-icon md-svg-src=\"./assets/icons/app/V3/open.svg\"></md-icon>Ouvrir</md-button></md-menu-item><md-menu-item>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/download.svg\"></md-icon>Télécharger</md-button></md-menu-item><md-menu-item \nng-if=\"document.status !== \'VALIDATED\'\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openValidDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon>Valider</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div></div></section>");
$templateCache.put("app/main/front/groupement/gpt-filtre-menu.html","<div class=\"gpt-filtre-menu\"><md-menu md-position-mode=\"target-left bottom\" md-offset=\"0 6\"><button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome gpt-filtre-menu__ajout\" ng-click=\"$mdOpenMenu($event)\" \ntitle=\"Filtrer sur un champ. Un seul filtre par champ : choisir une autre valeur remplace la précédente.\"><md-icon \nmd-font-icon=\"icon-filter-variant\" class=\"s16\"></md-icon><span>Ajouter un filtre</span></button><md-menu-content \nclass=\"gpt-menu\" width=\"4\"><md-menu-item ng-repeat=\"colonne in colonnesFiltrables()\"><md-menu><md-button \nng-click=\"$mdOpenMenu($event)\" class=\"gpt-menu__champ\"><span>{{colonne.libelle}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16\"></md-icon></md-button><md-menu-content \nclass=\"gpt-menu gpt-menu--valeurs\" width=\"4\"><div ng-if=\"typeDe(colonne.cle) === \'enum\'\"><div \nclass=\"gpt-menu__recherche\" ng-if=\"listeLongue(colonne.cle)\"><md-icon md-font-icon=\"icon-magnify\" class=\"s16\">\n</md-icon><input type=\"text\" placeholder=\"Filtrer la liste…\" ng-model=\"rechercheOption[colonne.cle]\" \nng-keydown=\"toucheChamp($event)\"></div><md-menu-item ng-repeat=\"option in optionsVisibles(colonne.cle)\"><md-button \nng-click=\"poser(colonne.cle, option)\" class=\"gpt-menu__valeur\" \nng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle, option)}\"><span>{{libelleValeur(colonne.cle, option)}}\n</span><md-icon ng-if=\"estPosee(colonne.cle, option)\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></md-button>\n</md-menu-item><div class=\"gpt-menu__vide\" ng-if=\"!optionsVisibles(colonne.cle).length\">Aucune valeur</div>\n<md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'oui\')\" \nclass=\"gpt-menu__valeur\" ng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'oui\')}\"><span>Renseigné\n</span><md-icon ng-if=\"estPosee(colonne.cle + \'_set\', \'oui\')\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'non\')\" \nclass=\"gpt-menu__valeur\" ng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'non\')}\"><span>\nNon renseigné</span><md-icon ng-if=\"estPosee(colonne.cle + \'_set\', \'non\')\" md-font-icon=\"icon-check\" class=\"s16\">\n</md-icon></md-button></md-menu-item></div><div ng-if=\"typeDe(colonne.cle) === \'bool\'\"><md-menu-item \nng-repeat=\"choix in [\'oui\', \'non\']\"><md-button ng-click=\"poser(colonne.cle, choix)\" class=\"gpt-menu__valeur\" \nng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle, choix)}\"><span>{{choix === \'oui\' ? \'Oui\' : \'Non\'}}</span>\n<md-icon ng-if=\"estPosee(colonne.cle, choix)\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></md-button>\n</md-menu-item></div><div ng-if=\"typeDe(colonne.cle) === \'date\'\"><div class=\"gpt-menu__bornes\"><label><span>Du</span>\n<div class=\"iv-Input-date-wrapper\" ng-keydown=\"toucheChamp($event)\"><md-icon class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\" md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"ouvrirCalendrier(colonne.cle + \'_from\', $event)\"></md-icon><md-datepicker class=\"iv-Input-date\" \nmd-hide-icons=\"all\" md-placeholder=\"jj/mm/aaaa\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-is-open=\"calendriers[colonne.cle + \'_from\']\" ng-click=\"ouvrirCalendrier(colonne.cle + \'_from\', $event)\" \nng-model=\"bornesDate[colonne.cle + \'_from\']\" ng-change=\"majBorneDate(colonne.cle + \'_from\')\"></md-datepicker></div>\n</label><label><span>Au</span><div class=\"iv-Input-date-wrapper\" ng-keydown=\"toucheChamp($event)\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"ouvrirCalendrier(colonne.cle + \'_to\', $event)\"></md-icon>\n<md-datepicker class=\"iv-Input-date\" md-hide-icons=\"all\" md-placeholder=\"jj/mm/aaaa\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" md-is-open=\"calendriers[colonne.cle + \'_to\']\" \nng-click=\"ouvrirCalendrier(colonne.cle + \'_to\', $event)\" ng-model=\"bornesDate[colonne.cle + \'_to\']\" \nng-change=\"majBorneDate(colonne.cle + \'_to\')\"></md-datepicker></div></label></div><md-menu-divider></md-menu-divider>\n<md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'oui\')\" class=\"gpt-menu__valeur\" \nng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'oui\')}\"><span>Renseignée</span><md-icon \nng-if=\"estPosee(colonne.cle + \'_set\', \'oui\')\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'non\')\" class=\"gpt-menu__valeur\" \nng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'non\')}\"><span>Non renseignée</span><md-icon \nng-if=\"estPosee(colonne.cle + \'_set\', \'non\')\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon></md-button>\n</md-menu-item></div><div ng-if=\"typeDe(colonne.cle) === \'number\'\"><div class=\"gpt-menu__bornes\"><label><span>Au moins\n</span> <input type=\"number\" ng-model=\"filtres[colonne.cle + \'_from\']\" ng-change=\"majBorne(colonne.cle + \'_from\')\" \nng-keydown=\"toucheChamp($event)\"></label><label><span>Au plus</span> <input type=\"number\" \nng-model=\"filtres[colonne.cle + \'_to\']\" ng-change=\"majBorne(colonne.cle + \'_to\')\" ng-keydown=\"toucheChamp($event)\">\n</label></div></div><div ng-if=\"typeDe(colonne.cle) === \'text\'\"><div class=\"gpt-menu__saisie\"><input type=\"text\" \nplaceholder=\"{{ estPrefixe(colonne.cle) ? \'Commence par…\' : \'Contient…\' }}\" ng-model=\"brouillon[colonne.cle]\" \nng-keydown=\"toucheTexte($event, colonne.cle)\"> <span class=\"gpt-menu__aide\">Entrée pour appliquer</span></div>\n<md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'oui\')\" \nclass=\"gpt-menu__valeur\" ng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'oui\')}\"><span>Renseigné\n</span><md-icon ng-if=\"estPosee(colonne.cle + \'_set\', \'oui\')\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"poser(colonne.cle + \'_set\', \'non\')\" \nclass=\"gpt-menu__valeur\" ng-class=\"{\'gpt-menu__valeur--posee\': estPosee(colonne.cle + \'_set\', \'non\')}\"><span>\nNon renseigné</span><md-icon ng-if=\"estPosee(colonne.cle + \'_set\', \'non\')\" md-font-icon=\"icon-check\" class=\"s16\">\n</md-icon></md-button></md-menu-item></div></md-menu-content></md-menu></md-menu-item><div class=\"gpt-menu__vide\" \nng-if=\"!colonnesFiltrables().length\">Aucun champ filtrable</div></md-menu-content></md-menu><div class=\"gpt-chips\">\n<span class=\"gpt-chip\" ng-repeat=\"chip in chips\" title=\"{{chip.titre}}\"><span class=\"gpt-chip__champ\">\n{{chip.champ}}{{chip.operateur ? \'\' : \' :\'}}</span> <span class=\"gpt-chip__operateur\" ng-if=\"chip.operateur\">\n{{chip.operateur}}</span> <span class=\"gpt-chip__valeur\">{{chip.valeur}}</span> <button type=\"button\" \nclass=\"gpt-chip__retrait\" ng-click=\"retirer(chip.cle)\" aria-label=\"Retirer le filtre : {{chip.titre}}\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s14\"></md-icon></button> </span><button type=\"button\" class=\"gpt-chips__effacer\" \nng-if=\"chips.length\" ng-click=\"toutEffacer()\">Tout effacer</button></div></div>");
$templateCache.put("app/main/front/home/home.html","<section class=\"nl-Page mb-40\"><div ng-if=\"banner.length > 0 && slickConfig.enabled && !hideBanner\"><slick \nsettings=\"slickConfig\" class=\"nl-Slick\"><div class=\"nl-Slick-slide\" ng-repeat=\"item in banner track by $index\" \nng-bind-html=\"item\">&nbsp;</div></slick><md-button type=\"button\" ng-if=\"isMobile\" \nclass=\"md-icon-button nl-Slick__close\" ng-click=\"hideBan()\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\">\n</md-icon></md-button></div><div class=\"nl-Content\"><div class=\"mt-20 pb-30\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div flex=\"auto\" layout=\"row\" layout-align=\"center center\" \nng-if=\"osysBoutonVisible()\"><button type=\"button\" class=\"nl-Btn nl-Btn--soft mv-5 mh-5\" ui-sref=\"app.osys.nouveau\">\n<md-icon md-svg-src=\"assets/icons/app/V3/triage_vert.svg\"></md-icon><div>\n{{isMobile ? \'Triage OSyS\':\'Nouveau triage OSyS\'}}</div></button></div><div flex=\"auto\" layout=\"row\" \nlayout-align=\"center center\"><button type=\"button\" class=\"nl-Btn nl-Btn--soft mv-5 mh-5\" ng-disabled=\"submitting\" \nng-click=\"addMalfunction()\"><md-icon md-svg-src=\"assets/icons/app/V3/dysfonctionnement_blue.svg\"></md-icon><div>\n{{isMobile ? \'Dysfonctionnements\':\'Signaler un dysfonctionnement\'}}</div></button></div><div flex=\"auto\" layout=\"row\" \nlayout-align=\"center center\"><button type=\"button\" class=\"nl-Btn nl-Btn--soft mv-5 mh-5\" \nng-click=\"signalerAppelPopup()\"><md-icon md-svg-src=\"assets/icons/app/V3/appel_dark_blue.svg\"></md-icon><div>\n{{isMobile ? \'Appels médecin\':\'Signaler un appel médecin\'}}</div></button></div><div flex=\"auto\" layout=\"row\" \nlayout-align=\"center center\"><button type=\"button\" class=\"nl-Btn nl-Btn--soft mv-5 mh-5\" ng-click=\"addTask()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/calendar_blue.svg\"></md-icon><div>{{isMobile ? \'Tâches\':\'Ajouter une tâche\'}}</div>\n</button></div><div flex=\"auto\" layout=\"row\" layout-align=\"center center\" ng-if=\"!$root.user.isMini\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--soft--ecor mv-5 mh-5\" ng-click=\"openEcor()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/ecor_green.svg\"></md-icon><div>ECOR</div></button></div><div flex=\"auto\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"$root.shouldShowCampaignBanner() && !isGroupementMenuActive\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--soft mv-5 mh-5\" ng-click=\"openMonEnquete()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/client_mystere_blue.svg\"></md-icon><div>Mon enquête</div></button></div></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"nl-newLookBlock-comment-wrapper\"><div class=\"nl-newLookBlock-comment-title pr-16\">Je m’identifie :</div>\n<md-select ng-model=\"information.writer.id\" placeholder=\"Sélectionnez votre nom\" required name=\"writer\" \nclass=\"nl-newLookBlock-comment-select md-no-underline\" md-container-class=\"iv-Select-dropdown\" id=\"selectCollab\" \nng-change=\"userChange(information.writer.id)\"><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"-1\">Aucun</md-option>\n<md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"collaborateur in collaborateurs\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select></div></div><div flex=\"66\"><div class=\"nl-newLookBlock--list\"><div><div \nclass=\"nl-newLookBlock--header\"><div class=\"nl-newLookBlock--header--title\">Cahier de transmission</div><div \nlayout=\"row\" layout-align=\"end center\"><div class=\"nl-SearchBar nl-SearchBar--home\" style=\"min-width: 80px\" \nlayout=\"row\"><md-icon ng-click=\"closeSearch()\" ng-show=\"pagination.searchText\" \nmd-svg-src=\"assets/icons/app/V3/del.svg\" class=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon \nng-click=\"search()\" md-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\">\n</md-icon><md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" \nlayout-align=\"end center\" flex=\"100\"><input ng-enter=\"search()\" class=\"nl-Input-input--searchHome\" \nplaceholder=\"Rechercher...\" type=\"text\" name=\"title\" ng-model=\"pagination.searchText\"></md-input-container></div><div \nclass=\"iv-Cmt-tag-wrapper no--margin no--padding no-background\" ng-if=\"pagination.tag\"><div class=\"iv-Cmt-item-W\"><div \nclass=\"iv-Cmt-tag-item tag-filter no-border no-background\"><div style=\"max-width:100%\"><div \nclass=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title text-bold\">{{pagination.tag.libelle}}</div>\n</div></div><button type=\"button\" class=\"iv-Cmt-tag-item-delete\" ng-click=\"filterTag(null)\"><md-icon \nclass=\"tag-filter\" md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div><md-menu \nng-if=\"_tags.length > 0 && pagination.tag == null\" md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown-tag\" md-offset=\"0 20\"><button type=\"button\" aria-label=\"Tag\" \nclass=\"nl-newLookBlock-comment-tag mr-16\" ng-click=\"$mdMenu.open($event)\"><div>Filtrer par tag</div><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\">\n<md-menu-item ng-repeat=\"tag in _tags\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterTag(tag)\"><div>\n{{tag.libelle}}</div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"p-15\" \nng-if=\"information.writer.id != null\"><form name=\"addInformationForm\" \nng-submit=\"addInformationForm.$valid && saveInformation();\"><div class=\"nl-newLookBlock nl-newLookBlock-commentaire\">\n<div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"100\" \nclass=\"md-block nl-Input-container nl-Input-container--no-error ql-home\" md-no-float style=\"padding-bottom: 0\">\n<ng-quill-editor id=\"post\" class=\"nl_quill-line\" flex=\"100\" modules=\"customModules\" \nplaceholder=\"Ecrivez dans le cahier de transmission...\" name=\"content\" on-editor-created=\"initEditor(editor)\" \nng-model=\"information.content\" formats=\"[\'mention\', \'bold\', \'underline\', \'color\']\" required></ng-quill-editor>\n</md-input-container></div><div class=\"iv-Cmt-wrapper mb-10\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"pj in information.pjs\"><div class=\"iv-Cmt-item mt-5 mb-5\"><div \nclass=\"nl-Tooltips nl-Tooltips--IB nl-Tooltips--underline\" style=\"max-width:90%\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'DOC\'\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'FILE\'\" \nmd-svg-src=\"assets/icons/app/V3/computer.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'REUNION\'\" md-svg-src=\"assets/icons/app/V3/reunion.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'MALFUNCTION\'\" md-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon \nclass=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'PROGRESS_FORM\'\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon>\n<md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'SUBTRACE\'\" md-svg-src=\"assets/icons/app/V3/tracabilite.svg\">\n</md-icon><div class=\"iv-Tabs-section-item-title\">{{displayPj(pj)}}</div></div><span class=\"nl-Tooltips--inner\"><p \nclass=\"nl-Tooltips--item\">{{displayPj(pj)}}</p></span></div></div><button type=\"button\" class=\"iv-Cmt-item-delete\" \nng-click=\"deletePj($index)\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div><div \nclass=\"iv-Cmt-tag-wrapper mb-10\" ng-if=\"information.tags.length > 0\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"tag in information.tags\"><div class=\"iv-Cmt-tag-item mt-5 mb-5\"><div style=\"max-width:100%\"><div \nclass=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title\">{{tag.libelle}}</div></div></div><button \ntype=\"button\" class=\"iv-Cmt-tag-item-delete\" ng-click=\"deleteInfTag($index, information)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div><div \nclass=\"nl-newLookBlock-comment-actions\"><div layout=\"row\" layout-align=\"start center\"><div id=\"toolbar--new\" \nstyle=\"border: none\"><button class=\"ql-bold\"></button> <button class=\"ql-underline\"></button><select class=\"ql-color\">\n<option value=\"#FF5853\"></option><option value=\"black\"></option></select></div><md-menu \nmd-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\" \nstyle=\"margin-left:12px;border-left: 1px solid #b8d4de; padding-left: 20px\"><button type=\"button\" aria-label=\"Mention\" \nclass=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre.svg\"></md-icon><div>joindre</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreFile()\"><md-icon md-svg-src=\"./assets/icons/app/V3/computer.svg\"></md-icon><div>\nUn fichier de mon ordinateur</div></md-button><input type=\"file\" id=\"add_info_file\" ng-hide=\"true\"></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openJoindreDocPopup()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/document.svg\"></md-icon><div>Un fichier de la base documentaire</div></md-button>\n</md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openJoindreDysPopup()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><div>Un dysfonctionnement</div></md-button>\n</md-menu-item><md-menu-item ng-if=\"!$root.user.isMini\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreFDPPopup()\"><md-icon md-svg-src=\"./assets/icons/app/V3/fdp.svg\"></md-icon><div>\nUne fiche de progrès</div></md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreReunionPopup()\"><md-icon md-svg-src=\"./assets/icons/app/V3/reunion.svg\"></md-icon><div>\nUn compte-rendu de réunion</div></md-button></md-menu-item></md-menu-content></md-menu><button \nng-disabled=\"!!intoSaving\" type=\"button\" aria-label=\"Mention\" class=\"nl-newLookBlock-comment-mention mr-16\" \nng-click=\"addMention(\'post\')\"><md-icon md-svg-src=\"assets/icons/app/V3/mentionner_main.svg\"></md-icon><div>mentionner\n</div></button> <button ng-if=\"tags.length === 0\" ng-disabled=\"!!intoSaving\" type=\"button\" aria-label=\"Tag\" \nclass=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"openTag()\"><md-icon md-svg-src=\"assets/icons/app/V3/tag.svg\">\n</md-icon><div>taguer</div></button><md-menu ng-if=\"tags.length > 0\" md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" aria-label=\"Mention\" \nclass=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon><div>taguer</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-repeat=\"tag in tags\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"selectTag(tag, information)\"><div>{{tag.libelle}}</div></md-button></md-menu-item><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openTag()\"><div style=\"font-weight: bold\">+ Gérer mes tags</div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><button ng-disabled=\"!!intoSaving\" type=\"submit\" \naria-label=\"Sauvegarder\" class=\"nl-newLookBlock-comment-button\" style=\"padding: 8px\">Envoyer</button></div></div>\n</form></div><md-card class=\"nl-newLookBlock-publication\" ng-repeat=\"info in informations track by $index\" \nng-class=\"{\'is--notRead\' : !info.reunion && (isUnread(info) || isAtLeastUnreadComment(info)), \'is--notReadRed\': info.reunion && isUnread(info, true)}\">\n<md-card-title><md-card-title-text><div layout=\"row\" layout-align=\"space-between center\"><div class=\"layout-row flex\">\n<div \nclass=\"md-headline nl-newLookBlock-publication-profilpicWrapper nl-newLookBlock-publication-profilpicWrapper--fixed flex-none\">\n<profil-picture class=\"nl-addBlock--profilpic\" img-url=\"\" profile-name=\"{{info.writer.initials}}\" phsq-profile=\"false\">\n</div><div class=\"layout-row flex\" ng-if=\"editedInformation.id != info.id\"><div class=\"flex\" layout=\"column\"><div><div \nclass=\"nl-newLookBlock-publication-description\"><pre class=\"nl-newLookBlock-publication-description\" \nng-bind-html=\"info.content | toTrusted\"></pre></div><div class=\"\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"pj in info.pjs\"><div class=\"iv-Cmt-item mt-5 mb-5\" ng-click=\"displayOrDownload(pj, info)\"><div \nclass=\"nl-Tooltips nl-Tooltips--IB nl-Tooltips--underline\" style=\"max-width:90%\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'DOC\'\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'FILE\'\" \nmd-svg-src=\"assets/icons/app/V3/computer.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'REUNION\'\" md-svg-src=\"assets/icons/app/V3/reunion.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'MALFUNCTION\'\" md-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon \nclass=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'PROGRESS_FORM\'\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon>\n<md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'SUBTRACE\'\" md-svg-src=\"assets/icons/app/V3/tracabilite.svg\">\n</md-icon><div class=\"iv-Tabs-section-item-title\">{{displayPj(pj)}}</div></div><span class=\"nl-Tooltips--inner\"><p \nclass=\"nl-Tooltips--item\">{{displayPj(pj)}}</p></span></div><div \nclass=\"nl-Tooltips nl-Tooltips--IB nl-Tooltips--underline\" style=\"max-width:90%\" ng-if=\"showDisplay(pj)\"><button \nclass=\"iv-Cmt-item-action\" type=\"button\"><md-icon md-svg-src=\"assets/icons/app/V3/show.svg\"></md-icon></button> <span \nclass=\"nl-Tooltips--inner\"><p class=\"nl-Tooltips--item\">Afficher</p></span></div><div ng-if=\"!showDisplay(pj)\" \nclass=\"nl-Tooltips nl-Tooltips--IB nl-Tooltips--underline\" style=\"max-width:90%\"><button class=\"iv-Cmt-item-action\" \ntype=\"button\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon></button> <span \nclass=\"nl-Tooltips--inner\"><p class=\"nl-Tooltips--item\">Télécharger</p></span></div></div></div></div><div \nstyle=\"display: flex;flex-wrap: wrap;gap: 5px\"><div class=\"iv-Cmt-item-W\" ng-repeat=\"tag in info.tags\"><div \nclass=\"iv-Cmt-tag-item\"><div class=\"\" style=\"max-width:100%\"><div class=\"iv-Tabs-section-item-inner\"><div \nclass=\"iv-Tabs-section-item-title\">{{tag.libelle}}</div></div></div></div></div></div></div><div \nclass=\"layout-row layout-align-start-center layout-wrap\"><div class=\"nl-newLookBlock-publication-name\">\n{{info.writer.completeName}}</div><div class=\"nl-newLookBlock-publication-separator\"><i \nclass=\"icon icon-checkbox-blank-circle\"></i></div><div class=\"nl-newLookBlock-publication-name\">\n{{info.date | dateInformation}}</div><div class=\"nl-newLookBlock-publication-separator\"><i \nclass=\"icon icon-checkbox-blank-circle\"></i></div><div \nclass=\"nl-newLookBlock-publication-viewBy nl-Tooltips nl-Tooltips--underline\" ng-if=\"!info.reunion\"><span \nng-if=\"info.readers.length===0 || info.countReaders === 0\">Non lu </span><span \nng-if=\"!info.allRead && info.countReaders > 0\">\n{{info.countReaders}} personne{{info.countReaders > 1 ? \'s ont\' : \' a\'}} lu </span><span ng-if=\"info.allRead\">\nLu par tous</span><md-tooltip md-direction=\"top\" class=\"iv-Tooltips\" ng-if=\"info.readers.length > 0\"><div \nclass=\"iv-Tooltips--item\" ng-repeat=\"reader in info.readers\">{{reader.completeName}}</div></md-tooltip></div><div \nclass=\"nl-newLookBlock-publication-viewBy nl-Tooltips nl-Tooltips--underline\" ng-if=\"info.reunion\"><span \nng-if=\"info.readers.length===0 || info.countPresenceReaders === 0\">Non lu par les présents</span> <span \nng-if=\"!info.allRead && info.countPresenceReaders > 0\">\n{{info.countPresenceReaders}} présent{{info.countPresenceReaders > 1 ? \'s ont\' : \' a\'}} lu </span><span \nng-if=\"info.allRead\">Lu par tous</span><md-tooltip md-direction=\"top\" class=\"iv-Tooltips\" \nng-if=\"info.presenceReaders.length > 0\"><div class=\"iv-Tooltips--item\" \nng-repeat=\"reader in info.presenceReaders track by reader.id\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/popup/marquer_comme_lu.svg\" ng-if=\"reader.read\" class=\"nl-listing-item-icon--popup\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><md-icon md-svg-src=\"assets/icons/app/V3/popup/non_lu.svg\" \nng-if=\"!reader.read\" class=\"nl-listing-item-icon--popup\" role=\"img\" aria-hidden=\"true\"></md-icon>\n{{reader.name + \' \' + reader.surname}}</div></md-tooltip></div><div class=\"nl-newLookBlock-publication-separator\" \nng-if=\"info.reunion\"><i class=\"icon icon-checkbox-blank-circle\"></i></div><div \nclass=\"nl-newLookBlock-publication-viewBy nl-Tooltips nl-Tooltips--underline\" ng-if=\"info.reunion\"><span \nng-if=\"info.readers.length===0 || info.countAbsenceReaders === 0\">Non lu par les absents</span> <span \nng-if=\"!info.allRead && info.countAbsenceReaders > 0\">\n{{info.countAbsenceReaders}} absent{{info.countAbsenceReaders > 1 ? \'s ont\' : \' a\'}} lu </span><span \nng-if=\"info.allRead\">Lu par tous</span><md-tooltip md-direction=\"top\" class=\"iv-Tooltips\" \nng-if=\"info.absenceReaders.length > 0\"><div class=\"iv-Tooltips--item\" \nng-repeat=\"reader in info.absenceReaders track by reader.id\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/popup/marquer_comme_lu.svg\" ng-if=\"reader.read\" class=\"nl-listing-item-icon--popup\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><md-icon md-svg-src=\"assets/icons/app/V3/popup/non_lu.svg\" \nng-if=\"!reader.read\" class=\"nl-listing-item-icon--popup\" role=\"img\" aria-hidden=\"true\"></md-icon>\n{{reader.name + \' \' + reader.surname}}</div></md-tooltip></div></div></div><div layout=\"row\" layout-align=\"end start\" \nng-if=\"$root.user.isTitulaire || $root.user.isPraq\"><div ng-if=\"info.dateEndPin != null\" ng-click=\"pinInfo(info)\" \nclass=\"pr-10\" layout=\"row\" layout-align=\"end center\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/pin_red.svg\"></md-icon></div><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button type=\"button\" \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"pinInfo(info)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/pin.svg\"></md-icon><div>\n{{info.dateEndPin != null ? \'Désépingler de la\' : \'Épingler en\'}} tête de liste</div></md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" type=\"button\" ng-click=\"openEditInfo(info)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon><div>Modifier le message</div></md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"_openDeleteInfo(info)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer le message</div></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div ng-if=\"editedInformation.id === info.id\" class=\"flex-auto\"><div \nclass=\"nl-newLookBlock nl-newLookBlock-commentaire\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nflex=\"100\" class=\"md-block nl-Input-container nl-Input-container--no-error ql-home\" md-no-float><ng-quill-editor \nid=\"msg{{$index}}\" class=\"nl_quill-line\" flex=\"100\" modules=\"customModulesEdit\" ng-model=\"editedInformation.content\" \nplaceholder=\"\" name=\"content\" on-editor-created=\"initEditor(editor)\" \nformats=\"[\'mention\', \'bold\', \'underline\', \'color\']\" required></ng-quill-editor></md-input-container></div><div \nclass=\"iv-Cmt-wrapper mb-10\" ng-if=\"editedInformation.pjs.length > 0\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"pj in editedInformation.pjs\"><div class=\"iv-Cmt-item mt-5 mb-5\"><div \nclass=\"nl-Tooltips nl-Tooltips--IB nl-Tooltips--underline\" style=\"max-width:90%\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'DOC\'\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'FILE\'\" \nmd-svg-src=\"assets/icons/app/V3/computer.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'REUNION\'\" md-svg-src=\"assets/icons/app/V3/reunion.svg\"></md-icon><md-icon class=\"iv-Cmt-item-icon\" \nng-if=\"pj.type === \'MALFUNCTION\'\" md-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon \nclass=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'PROGRESS_FORM\'\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon>\n<md-icon class=\"iv-Cmt-item-icon\" ng-if=\"pj.type === \'SUBTRACE\'\" md-svg-src=\"assets/icons/app/V3/tracabilite.svg\">\n</md-icon><div class=\"iv-Tabs-section-item-title\">{{displayPj(pj)}}</div></div><span class=\"nl-Tooltips--inner\"><p \nclass=\"nl-Tooltips--item\">{{displayPj(pj)}}</p></span></div></div><button type=\"button\" class=\"iv-Cmt-item-delete\" \nng-click=\"deletePj($index, true, $parent.$index)\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</button></div></div><div class=\"iv-Cmt-tag-wrapper mb-10\" ng-if=\"editedInformation.tags.length > 0\"><div \nclass=\"iv-Cmt-item-W\" ng-repeat=\"tag in editedInformation.tags\"><div class=\"iv-Cmt-tag-item mt-5 mb-5\"><div \nstyle=\"max-width:100%\"><div class=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title\">{{tag.libelle}}\n</div></div></div><button type=\"button\" class=\"iv-Cmt-tag-item-delete\" \nng-click=\"deleteInfTag($index, editedInformation)\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</button></div></div></div><div class=\"nl-newLookBlock-comment-actions\"><div layout=\"row\" layout-align=\"start center\">\n<div id=\"toolbar--edit\" style=\"border: none\"><button class=\"ql-bold\"></button> <button class=\"ql-underline\"></button>\n<select class=\"ql-color\"><option value=\"#FF5853\"></option><option value=\"black\"></option></select></div><md-menu \nmd-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" \naria-label=\"Mention\" class=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre.svg\"></md-icon><div>joindre</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreFile($index)\"><md-icon md-svg-src=\"./assets/icons/app/V3/computer.svg\"></md-icon><div>\nUn fichier de mon ordinateur</div></md-button><input type=\"file\" id=\"file_{{$index}}\" ng-hide=\"true\"></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openJoindreDocPopup($index)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/document.svg\"></md-icon><div>Un fichier de la base documentaire</div></md-button>\n</md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openJoindreDysPopup($index)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><div>Un dysfonctionnement</div></md-button>\n</md-menu-item><md-menu-item ng-if=\"!$root.user.isMini\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreFDPPopup($index)\"><md-icon md-svg-src=\"./assets/icons/app/V3/fdp.svg\"></md-icon><div>\nUne fiche de progrès</div></md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openJoindreReunionPopup($index)\"><md-icon md-svg-src=\"./assets/icons/app/V3/reunion.svg\"></md-icon><div>\nUn compte-rendu de réunion</div></md-button></md-menu-item></md-menu-content></md-menu><button \nng-disabled=\"!!intoSaving\" type=\"button\" aria-label=\"Mention\" class=\"nl-newLookBlock-comment-mention mr-16\" \nng-click=\"addMention(\'msg\', $index)\"><md-icon md-svg-src=\"assets/icons/app/V3/mentionner_main.svg\"></md-icon><div>\nmentionner</div></button> <button ng-if=\"editedTags.length === 0\" ng-disabled=\"!!intoSaving\" type=\"button\" \naria-label=\"Tag\" class=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"openTag()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon><div>taguer</div></button><md-menu ng-if=\"editedTags.length > 0\" \nmd-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" \naria-label=\"Mention\" class=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon><div>taguer</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-repeat=\"tag in editedTags\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"selectTag(tag, editedInformation)\"><div>{{tag.libelle}}</div></md-button>\n</md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openTag()\"><div \nstyle=\"font-weight: bold\">+ Gérer mes tags</div></md-button></md-menu-item></md-menu-content></md-menu></div><button \nng-disabled=\"!!intoSaving\" type=\"button\" ng-click=\"updateInformation(info, $index)\" aria-label=\"Sauvegarder\" \nclass=\"nl-newLookBlock-comment-button\" style=\"padding: 8px\">Valider</button></div></div></div></div></div>\n</md-card-title-text></md-card-title><md-card-actions class=\"nl-newLookBlock-comment nl-newLookBlock-comment-card\" \nlayout=\"row\"><md-button \nng-show=\"(isUnread(info)||isAtLeastUnreadComment(info)) && isMentionned(info) && !info.reunion\" \nid=\"markViewButton{{info.id}}\" class=\"nl-Btn--comment nl-Btn nl-Btn-msg nl-Btn--small pr-50\" \nng-click=\"setRead(info, false, true)\" ng-class=\"{\'nl-Btn-msg--disabled\': loadingRead}\"><md-progress-circular \nmd-diameter=\"12px\" md-mode=\"indeterminate\" ng-if=\"info._loading\"></md-progress-circular><md-icon \nmd-svg-src=\"assets/icons/app/V3/check_as_read.svg\" ng-if=\"!loadingRead\" class=\"nl-listing-item-icon\" role=\"img\" \naria-hidden=\"true\"></md-icon><md-icon md-svg-src=\"assets/icons/app/V3/check_as_read_light.svg\" \nng-if=\"loadingRead && !info._loading\" class=\"nl-listing-item-icon\" role=\"img\" aria-hidden=\"true\"></md-icon><span \nclass=\"nl-block-button\">Marquer comme lu</span></md-button><md-button ng-show=\"isUnread(info, true) && info.reunion\" \nid=\"markViewButton{{info.id}}\" class=\"nl-Btn--comment nl-Btn nl-Btn-msg nl-Btn--small pr-50\" \nng-click=\"setRead(info, false, true)\" ng-class=\"{\'nl-Btn-msg--disabled\': loadingRead}\"><md-progress-circular \nmd-diameter=\"12px\" md-mode=\"indeterminate\" ng-if=\"info._loading\"></md-progress-circular><md-icon \nmd-svg-src=\"assets/icons/app/V3/check_as_read.svg\" ng-if=\"!loadingRead\" class=\"nl-listing-item-icon\" role=\"img\" \naria-hidden=\"true\"></md-icon><md-icon md-svg-src=\"assets/icons/app/V3/check_as_read_light.svg\" \nng-if=\"loadingRead && !info._loading\" class=\"nl-listing-item-icon\" role=\"img\" aria-hidden=\"true\"></md-icon><span \nclass=\"nl-block-button\" ng-if=\"!(info.comments && info.comments.length > 0)\">J\'ai bien lu le CR </span><span \nclass=\"nl-block-button\" ng-if=\"info.comments && info.comments.length > 0\">Marquer comme lu</span></md-button><md-button\n class=\"nl-Btn nl-Btn-msg nl-Btn--small nl-Btn--comment\" type=\"button\" ng-click=\"openCommentArea(info)\"><md-icon \nmd-svg-src=\"assets/icons/app/transmission/comment.svg\" class=\"nl-listing-item-icon\" role=\"img\" aria-hidden=\"true\">\n</md-icon><span class=\"nl-block-button\">Commenter</span></md-button></md-card-actions><md-card-content \nclass=\"nl-newLookBlock-comment-voirplus\" layout=\"row\" layout-align=\"start center\" \nng-if=\"info.visibleComments.length < info.comments.length\"><a class=\"nl-newLookBlock-publication-plus\" \nng-click=\"loadPreviousComments(info); toggleFullTrue(info);\"><span ng-if=\"!inSearch\">Voir les commentaires précédents\n</span> <span ng-if=\"inSearch\">Voir les autres commentaires</span></a></md-card-content><md-card-content \nclass=\"nl-newLookBlock-comment-list\" ng-repeat=\"comment in info.visibleComments\"><md-list-item><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"row\"><div \nclass=\"md-headline nl-newLookBlock-publication-profilpicWrapper--comment flex-none\"><profil-picture \nclass=\"nl-addBlock--profilpic\" img-url=\"\" profile-name=\"{{comment.writer.initials}}\" phsq-profile=\"false\"></div><div \nlayout=\"row\" class=\"nl-newLookBlock-publication-inner\"><div flex layout=\"column\"><div \nclass=\"nl-newLookBlock-publication-description--comment\"><pre class=\"pre-render\" \nng-bind-html=\"comment.content | toTrusted\"></pre></div><div class=\"layout-row layout-align-start-center\"><div \nclass=\"layout-row layout-align-start-center\"><div class=\"nl-newLookBlock-publication-name--comment\">\n{{comment.writer.completeName}}</div><div class=\"nl-newLookBlock-publication-separator\"><i \nclass=\"icon icon-checkbox-blank-circle\"></i></div><div class=\"nl-newLookBlock-publication-name--comment\">\n{{comment.date | dateInformation}} <span style=\"color:#EF5450; padding: 0;margin:0 0.5rem\" \nng-if=\"isUnreadComment(comment, info) && information.writer.id\"><i class=\"icon icon-checkbox-blank-circle\" \nstyle=\"font-size: 6px; color:#EF5450\"></i><strong> Nouveau</strong></span></div></div></div></div><div \nng-if=\"!$root.user.isTeam\" layout=\"row\" layout-align=\"end start\"><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button type=\"button\" \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"_openDeleteComment(info,comment)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer le commentaire</div></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></md-list-item></md-card-content><md-card-content \nclass=\"nl-newLookBlock-comment-list\" ng-if=\"comment.information.id === info.id\"><form name=\"commentForm\" \nng-submit=\"commentForm.$valid && sendComment(info)\"><div><div class=\"nl-newLookBlock nl-newLookBlock-comment\"><div \nlayout=\"row\" layout-align=\"start center\"><div \nclass=\"md-headline nl-newLookBlock-publication-profilpicWrapper--comment flex-none\" ng-if=\"principalInitials\">\n<profil-picture class=\"nl-addBlock--profilpic\" img-url=\"\" profile-name=\"{{principalInitials}}\" phsq-profile=\"false\">\n</div><div class=\"nl-newLookBlock-inner\" layout=\"row\" layout-align=\"start center\"><md-input-container flex \nclass=\"md-block nl-Input-container nl-Input-container--no-error ql-home\" md-no-float><ng-quill-editor flex=\"100\" \nmodules=\"customModulesComment\" ng-model=\"comment.content\" placeholder=\"Rédigez votre commentaire...\" \nname=\"contentComment\" class=\"nl-newLookBlock-Input-textarea nl_quill-line\" on-editor-created=\"initEditor(editor)\" \nid=\"comment{{$index}}\" formats=\"[\'mention\', \'bold\', \'underline\', \'color\']\" required></ng-quill-editor>\n</md-input-container><div class=\"nl-newLookBlock-comment-actions\"><div layout=\"row\" layout-align=\"start center\"><div \nid=\"toolbar--comment\" style=\"border: none\"><button class=\"ql-bold\"></button> <button class=\"ql-underline\"></button>\n<select class=\"ql-color\"><option value=\"#FF5853\"></option><option value=\"black\"></option></select></div></div><button \nng-disabled=\"loading\" type=\"submit\" aria-label=\"Envoyer\" class=\"nl-newLookBlock-comment-button\" style=\"padding: 8px\">\nEnvoyer</button></div></div></div></div></div></form></md-card-content></md-card><md-card \nclass=\"nl-newLookBlock-publication\" ng-if=\"allLoaded\"><md-card-title><md-card-title-text><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"layout-row flex\"><div \nclass=\"md-headline nl-newLookBlock-publication-profilpicWrapper flex-none\"><profil-picture \nclass=\"nl-addBlock--profilpic\" img-url=\"\" profile-name=\"PH\" phsq-profile=\"true\"></div><div class=\"flex-90\" \nlayout=\"column\"><div class=\"mb-10\"><div class=\"nl-newLookBlock-publication-oldName\">Pharma Système Qualité</div></div>\n<div><div class=\"nl-newLookBlock-publication-description\">Bienvenue sur le Logiciel Qualité Officinal !<br>\nAméliorez la mise en oeuvre de votre démarche qualité et devenez plus efficace.<br><br>\nPour plus de renseignements, consultez nos vidéos tutorielles disponibles dans l\'onglet \"Aide\" ou bien cliquez ci-dessous :\n<br><br><a href=\"/help\"><button class=\"nl-Btn\">Visionner les vidéos</button></a><h3 \nclass=\"nl-newLookBlock-publication-oldbold\">A vous de jouer !</h3></div></div></div></div></div></md-card-title-text>\n</md-card-title></md-card><div class=\"nl-newLookBlock-publication-moreWrapper\"><a \nclass=\"nl-newLookBlock-publication-more\" ng-click=\"findMore()\" ng-if=\"!allLoaded\">Charger plus...</a></div></div></div>\n</div><div flex=\"33\"><div class=\"nl-newLookBlock\"><div class=\"mb-10\" \nng-if=\"_tasks.length> 0 || _events.length > 0 || osysARappeler() > 0\"><div \nclass=\"nl-newLookBlock-header layout-row layout-align-space-between-center\"><div \nclass=\"nl-newLookBlock--header--title flex-80\">Tâches et RDV {{_selected != null ? \' de \' : \'\'}} <span \nng-if=\"_selected != null\">{{_selected.surname + \' \' + _selected.name}}</span></div><div \nclass=\"nl-newLookBlock-actions flex-20\"><a class=\"nl-newLookBlock-button\" href=\"/planning-general\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></a></div></div><div class=\"nl-newLookBlock-content\"><div \nclass=\"nl-HomeList-item osy-tache-accueil\" layout=\"row\" ng-if=\"osysARappeler() > 0\"><span \nclass=\"osy-tache-accueil__etiquette\">À faire</span> <span class=\"osy-tache-accueil__texte\">\nRappeler {{osysARappeler()}} {{osysARappeler() > 1 ? \'patients\' : \'patient\'}} OSyS<span ng-if=\"osysEnRetard() > 0\">\n · {{osysEnRetard()}} en retard</span> · <a ui-sref=\"app.osys.mesTriages({suivi: true})\">Voir</a></span></div><div><div\n class=\"nl-HomeList-item\" flex=\"\" layout=\"row\" ng-repeat=\"task in _tasks track by $index\"><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!task.event && !task.reunion\"><md-checkbox class=\"nl-Checkbox\" \nng-model=\"task.done\" aria-label=\"Checkbox\" ng-disabled=\"task.done\" md-no-ink ng-change=\"_confirmDone(task, true);\">\n</md-checkbox></div><div class=\"flex\" role=\"button\" ng-click=\"_editEvent(task)\"><div \nclass=\"nl-list-item-title ng-binding\">{{ task.title }}</div><div style=\"display: flex;flex-wrap: wrap;gap: 5px\"><div \nclass=\"iv-Cmt-item-W\" ng-repeat=\"tag in task.tags\"><div class=\"iv-planning-tag-item\"><div class=\"\" \nstyle=\"max-width:100%\"><div class=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title\">{{tag.libelle}}\n</div></div></div></div></div></div><div class=\"nl-list-item-description\" ng-if=\"!task.reunion\">\n{{task.echeance | date: \'dd/MM/yyyy\'}} <span ng-if=\"task.responsable.surname != null\">\n• {{ task.responsable.surname }} {{ task.responsable.name }}</span></div></div></div></div><div \nng-class=\"{\'nl-HomeList-item--2\': _events.length > 0}\" ng-if=\"_events.length > 0\"><div class=\"nl-HomeList-item\" \nflex=\"\" layout=\"row\" ng-repeat=\"task in _events track by $index\"><div class=\"flex\" role=\"button\" \nng-click=\"_editEvent(task)\"><div class=\"nl-list-item-title ng-binding\">{{ task.title }}</div><div \nclass=\"nl-list-item-description\" ng-if=\"!task.reunion\">{{task.echeance | date: \'dd/MM/yyyy\'}} <span \nng-if=\"task.allDay\">• Toute la journée </span><span ng-if=\"!task.allDay\">\n• de {{task.echeance | date: \"HH\'h\'mm\"}} à {{task.ending | date: \"HH\'h\'mm\"}}</span></div></div></div></div></div></div>\n<div class=\"mb-10\" ng-if=\"checks.length > 0\"><div \nclass=\"nl-newLookBlock-header layout-row layout-align-space-between-center\"><div \nclass=\"nl-newLookBlock--header--title flex-80\">Checklist quotidienne</div><div class=\"nl-newLookBlock-actions flex-20\">\n<button class=\"nl-newLookBlock-button\" type=\"button\" ng-click=\"goToChecklist()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div><div class=\"nl-newLookBlock-content\">\n<div><div class=\"nl-HomeList-item\" flex=\"\" layout=\"row\" ng-repeat=\"task in checks track by task.id\"><div layout=\"row\" \nlayout-align=\"center center\"><md-checkbox class=\"iv-Checkbox\" ng-model=\"task.done\" ng-change=\"setCheckDone(task)\" \naria-label=\"Checkbox\" md-no-ink></md-checkbox></div><div class=\"flex ml-8\" role=\"button\" \nng-click=\"openEditCheck(task)\"><div class=\"nl-list-item-title\" ng-class=\"{\'line-through\': task.done}\">{{ task.title }}\n</div></div></div></div></div></div><div><div \nclass=\"nl-newLookBlock-header layout-row layout-align-space-between-center\"><div \nclass=\"nl-newLookBlock--header--title flex-80\">Météo qualité</div><div class=\"nl-newLookBlock-actions flex-20\"><a \nclass=\"nl-newLookBlock-button\" href=\"/tableau-de-bord\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\">\n</md-icon></a></div></div><div class=\"nl-newLookBlock-content\"><div class=\"nl-HomeList-item\" flex=\"\" layout=\"row\" \nng-repeat=\"indic in weather\"><div class=\"nl-HomeList-item-icon\"><img src=\"assets/icons/app/V3/sun.svg\" \nng-if=\"indic.weatherState===\'HIGH\'\" alt=\"\"> <img src=\"assets/icons/app/V3/cloudy.svg\" alt=\"\" \nng-if=\"indic.weatherState===\'MEDIUM\'\"> <img src=\"assets/icons/app/V3/rain.svg\" alt=\"\" \nng-if=\"indic.weatherState===\'LOW\'\"></div><div class=\"ml-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-list-item-title\">{{ indic.title }}</div><div class=\"nl-list-item-description ng-binding ng-scope\"></div>\n</div></div><div class=\"nl-newLookBlock-empty nl-newLookBlock-empty--only\" ng-if=\"weather.length === 0\">\nRenseignez chaque mois vos indicateurs et mettez-les en avant grâce à la météo qualité.<div \nclass=\"nl-newLookBlock-empty-action\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nui-sref=\"app.performances.tableau-de-bord\">Créer ma météo qualité</button></div></div></div></div></div></div></div>\n</div></section>");
$templateCache.put("app/main/front/home/select_user_dialog.html","<md-dialog aria-label=\"Cahier de transmission\" flex=\"40\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nJe m\'identifie</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><p class=\"ml-15 mr-15\">\nPour pouvoir interagir sur le cahier de transmission, vous devez d\'abord sélectionner votre nom.</p><div layout=\"row\" \nlayout-align=\"start center\" class=\"mh-16\"><div flex=\"100\"><md-select ng-model=\"writerId\" \nplaceholder=\"Sélectionner votre nom\" required name=\"writer\" class=\"nl-newLookBlock-comment-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" id=\"selectCollab\" ng-change=\"checkUser(writerId)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"collaborateur in collaborateurs\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option ng-value=\"\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><button class=\"nl-Btn nl-Btn--outline mr-10\" ng-click=\"_closeDialog()\">Annuler\n</button> <button class=\"nl-Btn\" ng-click=\"changeUser(writerId)\">Valider</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/home/template.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Composants (Accueil)</h1><button \nclass=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\">\nRetour en arrière</span></button><h1 class=\"nl-H1\">Composants (Accueil)</h1><div class=\"nl_breadcumb\"><div \nclass=\"nl_breadcumb--item\"><a href=\"\" class=\"nl_breadcumb--item--title\">Fil d\'Ariane</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nhref=\"\" class=\"nl_breadcumb--item--title\">Niveau -1</a><div class=\"nl_breadcumb--item--icon\"><i \nclass=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a href=\"\" \nclass=\"nl_breadcumb--item--title\">Niveau 0</a><div class=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i>\n</div></div></div><h1 class=\"nl-H1\">Composants (Accueil)<md-menu class=\"nl-Menu\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"openMenu($mdMenu, $event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\">Actions 1</md-button></md-menu-item>\n<md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 2</md-button></md-menu-item><md-menu-divider \nclass=\"nl-Menu-dropdown-separator\"></md-menu-divider><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 3\n</md-button></md-menu-item></md-menu-content></md-menu></h1><button class=\"nl-H1-backBtn\"><i \nclass=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\">Retour en arrière</span></button><h2\n class=\"nl-H2\">H2 de la page</h2><div class=\"pt-45 pb-45\"><div class=\"nl-FilterBar\"><div><span \nclass=\"nl-FilterBar-text\">Afficher</span><md-menu class=\"nl-Menu nl-Menu--filtre\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"openMenu($mdMenu, $event)\"><span class=\"nl-Menu-btn-title\">Type</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_dysfonctionnement.svg\"></md-icon></button><md-menu-content \nwidth=\"4\"><md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\">Actions 1</md-button>\n</md-menu-item><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 2</md-button></md-menu-item>\n<md-menu-divider class=\"nl-Menu-dropdown-separator\"></md-menu-divider><md-menu-item><md-button \nclass=\"nl-Menu-dropdown-btn\">Actions 3</md-button></md-menu-item></md-menu-content></md-menu><md-menu \nclass=\"nl-Menu nl-Menu--filtre\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" \nclass=\"nl-Menu-btn\" ng-click=\"openMenu($mdMenu, $event)\"><span class=\"nl-Menu-btn-title\">Status</span><md-icon \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/filtres/icon_chevron_dysfonctionnement.svg\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\">Actions 1\n</md-button></md-menu-item><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 2</md-button></md-menu-item>\n<md-menu-divider class=\"nl-Menu-dropdown-separator\"></md-menu-divider><md-menu-item><md-button \nclass=\"nl-Menu-dropdown-btn\">Actions 3</md-button></md-menu-item></md-menu-content></md-menu></div><div><button \ntype=\"button\" class=\"nl-Btn\">Signaler un dysfonctionnement</button></div></div></div><div class=\"pt-45\"><button \ntype=\"button\" class=\"nl-Btn\">Enregistrer</button> <button type=\"button\" class=\"nl-Btn nl-Btn--outline\">Enregistrer\n</button></div><div class=\"pt-45\"><md-menu class=\"nl-Menu\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" \nmd-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"openMenu($mdMenu, $event)\"><span \nclass=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\">Actions 1</md-button></md-menu-item>\n<md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 2</md-button></md-menu-item><md-menu-divider \nclass=\"nl-Menu-dropdown-separator\"></md-menu-divider><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 3\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu class=\"nl-Menu nl-Menu--filtre\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"openMenu($mdMenu, $event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\">Actions 1</md-button></md-menu-item>\n<md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 2</md-button></md-menu-item><md-menu-divider \nclass=\"nl-Menu-dropdown-separator\"></md-menu-divider><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\">Actions 3\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-45\"><md-checkbox class=\"nl-Checkbox\" \nng-model=\"isChecked\" aria-label=\"Checkbox\" md-no-ink>Checkbox button test</md-checkbox></div><div class=\"pt-45\">\n<md-radio-group class=\"nl-Radio-wrapper\" ng-model=\"selected\" md-no-ink><md-radio-button class=\"nl-Radio\" value=\"1\" \naria-label=\"1\">Radio 1</md-radio-button><md-radio-button class=\"nl-Radio\" value=\"2\" aria-label=\"2\">Radio 2\n</md-radio-button><md-radio-button class=\"nl-Radio\" value=\"3\" aria-label=\"3\">Radio 3</md-radio-button></md-radio-group>\n</div><div class=\"pt-45\"><a class=\"nl-Link\" href=\"http://google.com\" target=\"_blank\">Link Google</a></div><div \nclass=\"pt-45\"><form action=\"\" layout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Libellé du champ</label><input ng-model=\"user.title\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"50\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Libellé du champ</label><input \nng-model=\"user.title2\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\" md-maxlength=\"150\"></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex=\"50\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nLibellé du champ</label><input ng-model=\"user.title3\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\">\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Libellé du champ</label><input ng-model=\"user.title4\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"50\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Libellé du champ Date</label><div \nclass=\"nl-Input-date-wrapper\"><md-icon ng-click=\"user.isOpen = true\" class=\"nl-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/tracabilite/calendar.svg\"></md-icon><md-datepicker md-is-open=\"user.isOpen\" \nmd-hide-icons=\"all\" md-open-on-focus ng-model=\"user.date\" class=\"nl-Input-date\" placeholder=\"\"></md-datepicker></div>\n</md-input-container></form></div><div class=\"pt-45\"><form action=\"\" layout=\"row\" layout-wrap><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Libellé du Textarea\n</label><textarea name=\"bio\" ng-model=\"biography\" required md-maxlength=\"150\" class=\"nl-Input-textarea\" rows=\"2\" \nmax-rows=\"4\" md-no-resize></textarea></md-input-container></form></div><div class=\"pt-45\"><form action=\"\" layout=\"row\" \nlayout-wrap><md-input-container class=\"nl-Input-container\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Libellé du Select</label><md-select ng-model=\"someModel\" \nclass=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"axe\">Axe</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"sword\">Sword</md-option><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"wand\">Wand</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"pen\">Pen?\n</md-option></md-select><button type=\"button\" class=\"nl-Input-select-addEntry\"><i \nclass=\"nl-Input-select-addEntry-icon icon-plus\"></i><div class=\"nl-Input-select-addEntry-text\">\nCréer une nouvelle entrée</div></button></md-input-container></form></div><div class=\"pt-45\"><div class=\"nl-apercu\" \nlayout=\"row\" layout-wrap><div class=\"nl-apercu-item\" flex=\"50\"><div class=\"nl-apercu-item-title\">Titre menu</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">Votre entrée sélectionnée</div></div><div \nclass=\"nl-apercu-item\" flex=\"50\"><div class=\"nl-apercu-item-title\">Titre menu</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">Votre entrée sélectionnée</div></div><div \nclass=\"nl-apercu-item\" flex=\"50\"><div class=\"nl-apercu-item-title\">Titre menu</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">Votre entrée sélectionnée</div></div><div \nclass=\"nl-apercu-item\" flex=\"50\"><div class=\"nl-apercu-item-title\">Titre menu</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">Votre entrée sélectionnée</div></div><div \nclass=\"nl-apercu-item\" flex=\"100\"><div class=\"nl-apercu-item-title\">Titre menu Grand</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">\nLorem ipsum dolor sit amet, consectetur adipisicing elit. Modi ducimus doloribus totam accusamus sequi, nulla eaque eius error expedita explicabo! Libero ab maxime voluptatem nesciunt necessitatibus inventore illum unde aspernatur.\n</div></div></div></div></div></section>");
$templateCache.put("app/main/front/malfunctions/fiches_progres.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Fiches de progrès<div layout=\"row\" layout-align=\"center center\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"addProgressForm() \">+ Nouvelle fiche de progrès</button></div></h1><div \nclass=\"nl-Content\"><div class=\"iv-SmallTabs-wrapper\"><div class=\"iv-SmallTabs-item\" \nng-class=\"{\'iv-Tabs-item--active\': tabs.active}\" ng-click=\"switchTab(\'active\')\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/fdp_blue.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon><div>\nFiches de progrès en cours</div></div><div class=\"iv-SmallTabs-item\" ng-class=\"{\'iv-Tabs-item--active\': tabs.archive}\" \nng-click=\"switchTab(\'archive\')\"><md-icon class=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/history_tab.svg\" \nclass=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon><div>Fiches de progrès archivées</div></div></div><br>\n<div layout=\"row\" layout-align=\"space-between center\" style=\"gap:1rem\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"nl-FilterBar-2\" ng-if=\"!searching && tabs.active\"><div layout=\"row\" layout-align=\"start center\"><md-menu \nclass=\"nl-Menu nl-Menu--filtre\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"0 35\"><button \nclass=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\" style=\"background-color: transparent !important\"><div \nclass=\"nl-Menu-btn-title color-dys\"><strong>\n{{filter.value ? filter.value + \" (\" + countFilter(filter.value) + \")\" : \"Filtrer par\"}}</strong></div><md-icon \nng-if=\"!$mdMenuIsOpen\" class=\"nl-Menu-btn-svg\" md-svg-src=\"assets/icons/app/filtres/arrow_down_blue.svg\" \nstyle=\"width: 16px !important; height: 16px !important\"></md-icon><md-icon ng-if=\"$mdMenuIsOpen\" \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"assets/icons/app/filtres/arrow_up_blue.svg\" \nstyle=\"width: 16px !important; height: 16px !important\"></md-icon></button><md-menu-content width=\"4\" \nstyle=\"scrollbar-width: none !important; border-color: rgba(197, 220, 244, 1) !important\"><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" ng-click=\"setFilter(\'type\', \'\',\'\')\" \nng-style=\"filter.type === \'\' && {\'font-weight\':\'600\'}\">Tous ({{countFilter(\'all\')}})</md-button></md-menu-item>\n<md-menu-item md-menu-align-target ng-repeat=\"type in types\"><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"setFilter(\'type\', \'\'+type.id,type.name)\" ng-style=\"filter.type === \'\'+type.id && {\'font-weight\':\'600\'}\">\n{{type.name}} ({{countFilter(type.name)}})</md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"nl-FilterBar-2\" ng-if=\"tabs.archive && !searching\" style=\"border-color: transparent !important\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"gap:1rem\"><md-menu class=\"nl-Menu nl-Menu--filtre\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"0 35\"><button class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\" \nstyle=\"background-color: transparent !important\"><div class=\"nl-Menu-btn-title color-dys\"><strong>\n{{archive.value && archive.value !== \'all\' ? archive.value : \"Afficher par année\"}}</strong></div><md-icon \nng-if=\"!$mdMenuIsOpen\" class=\"nl-Menu-btn-svg\" md-svg-src=\"assets/icons/app/filtres/arrow_down_blue.svg\" \nstyle=\"width: 16px !important; height: 16px !important\"></md-icon><md-icon ng-if=\"$mdMenuIsOpen\" \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"assets/icons/app/filtres/arrow_up_blue.svg\" \nstyle=\"width: 16px !important; height: 16px !important\"></md-icon></button><md-menu-content width=\"4\" \nstyle=\"scrollbar-width: none !important; border-color: rgba(197, 220, 244, 1) !important\"><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archive.value = \'all\'; months.length = 0; searchArchives(\'YEAR\');\">Toutes</md-button></md-menu-item>\n<md-menu-item md-menu-align-target ng-repeat=\"year in years\"><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archive.value = year.value; months.length = 0; archiveMonth.value = \'none\'; searchArchives(\'YEAR\');\">\n{{year.value}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu class=\"nl-Menu nl-Menu--filtre\" \nmd-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"0 35\" ng-if=\"months.length > 0\"><button class=\"nl-Menu-btn\" \nng-click=\"$mdMenu.open($event)\" style=\"background-color: transparent !important\"><div \nclass=\"nl-Menu-btn-title color-dys\"><strong>\n{{(archiveMonth.value && archiveMonth.value != \'all\' && archiveMonth.value != \'none\') ? archiveMonth.value : \"Sélectionner un mois\"}}\n</strong></div><md-icon ng-if=\"!$mdMenuIsOpen\" class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"assets/icons/app/filtres/arrow_down_blue.svg\" style=\"width: 16px !important; height: 16px !important\">\n</md-icon><md-icon ng-if=\"$mdMenuIsOpen\" class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"assets/icons/app/filtres/arrow_up_blue.svg\" style=\"width: 16px !important; height: 16px !important\">\n</md-icon></button><md-menu-content width=\"4\" \nstyle=\"scrollbar-width: none !important; border-color: rgba(197, 220, 244, 1) !important\"><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archiveMonth.value = \'all\'; searchArchives(\'MONTH\'); \">Tous</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"month in months\"><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archiveMonth.index = month.index; archiveMonth.value = month.value; searchArchives(\'MONTH\');\">{{month.value}}\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-SearchBar nl-SearchBar--home\" layout=\"row\"><md-icon \nng-click=\"cancelSearch();refresh()\" ng-show=\"searchTxt\" md-svg-src=\"assets/icons/app/V3/del.svg\" \nclass=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon ng-click=\"search()\" \nclass=\"nl-SearchBar--icon--search--home color-trac\" md-svg-src=\"assets/icons/app/V3/search.svg\"></md-icon>\n<md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" layout-align=\"end center\" \nflex=\"100\"><input ng-enter=\"search()\" class=\"nl-Input-input--searchHome\" placeholder=\"Rechercher...\" type=\"text\" \nname=\"title\" ng-model=\"searchTxt\" style=\"font-weight: bold\"></md-input-container></div></div></div><h2 class=\"nl-H2\" \nng-if=\"searching\">Résultat de la recherche</h2><div class=\"pb-55\" ng-if=\"searching\"><div class=\"nl-list mt-20\"><div \nclass=\"nl-list-item\" ng-repeat=\"ficheProgres in filteredFichesProgresSearch = searchResults track by $index\" \nng-click=\"openFicheProgres(ficheProgres)\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\"><div flex layout=\"column\"><div \nclass=\"text-truncate nl-listing-item-title\">{{ficheProgres.title}} {{ficheProgres.num}}</div><div \nclass=\"nl-indicator-header-infos\"><span ng-if=\"ficheProgres.malfunction.type.name\">\nDysfonctionnement: {{ficheProgres.malfunction.type.name}} - </span><span ng-if=\"ficheProgres.type.name\">\nFiche de progrès: {{ficheProgres.type.name}} - </span>{{ficheProgres.creation | date : \'dd/MM/yyyy\'}} <span \nng-if=\"mapActionFiche.get(ficheProgres.id)!=null\">\n- Action corrective planifiée le {{mapActionFiche.get(ficheProgres.id).date}} pour <b>\n{{mapActionFiche.get(ficheProgres.id).responsable}}</b></span></div></div></div><div class=\"nogrow\"><md-menu \nclass=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" style=\"border-color:rgba(197, 220, 244, 1) !important\"><md-menu-item \nng-if=\"ficheProgres.malfunction != null\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openMalfunction(ficheProgres.malfunction)\">Voir le dysfonctionnement</md-button></md-menu-item><md-menu-item>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"addAction(ficheProgres)\">\nPlanifier une action corrective en vue de clôturer la FDP</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"update(ficheProgres)\">Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDelete(ficheProgres)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nng-disabled=\"$root.user.isPraq\" ng-if=\"document.isRestricted != null && !$root.user.isTeam\" class=\"nl-Checkbox\" \nng-model=\"document.isRestricted\" aria-label=\"Confidentiel\" md-no-ink ng-change=\"setRestrictedDoc(document)\">\nConfidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredFichesProgresSearch.length === 0\"><p>Aucun résultat...</p></md-list-item><div \nng-if=\"!archiveEmpty && tabs.archive && !searching\"><h2 class=\"nl-H2\">Archives</h2><div class=\"nl-listing\"><div \nclass=\"nl-listing-item\" \nng-repeat=\"ficheProgres in filteredFichesProgresSearchArchived = (searchResults | filter: {\'activated\': false}) track by $index\" \nng-click=\"openFicheProgres(ficheProgres)\"><div layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\">\n<div flex layout=\"column\"><div class=\"text-truncate nl-listing-item-title\">{{ficheProgres.title}}</div><div \nclass=\"nl-indicator-header-infos\"><span ng-if=\"ficheProgres.malfunction\">{{ficheProgres.malfunction.type.name}} - \n</span>{{ficheProgres.creation | date : \'dd/MM/yyyy\'}} <span ng-if=\"mapActionFiche.get(ficheProgres.id)!=null\">\n- Action corrective planifiée le : {{mapActionFiche.get(ficheProgres.id).date}} pour <b>\n{{mapActionFiche.get(ficheProgres.id).responsable}}</b></span></div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"nl-list-item-icon\" style=\"cursor: default !important\"><img \nsrc=\"assets/icons/app/planning/trophy.png\" alt=\"\"><md-tooltip md-direction=\"bottom\">Clôturée</md-tooltip></div><div \nstyle=\"width: 44px; min-width: 44px\"><md-menu class=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" \nmd-menu-origin nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\" ng-if=\"malfunction.status !== statuses.NOT_OPEN\">\n<button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\">\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openMalfunction(ficheProgres.malfunction)\">\nVoir le dysfonctionnement</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div>\n<md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredFichesProgresSearchArchived.length === 0 \"><p>\nAucun résultat...</p></md-list-item></div></div><div class=\"pb-55\" ng-if=\"!searching\"><div class=\"nl-list mt-20\" \nng-if=\"tabs.active\"><div class=\"nl-list-item\" \nng-repeat=\"ficheProgres in fichesProgres | fichesProgresFilter: filter as filteredFichesProgres track by $index\" \nng-click=\"openFicheProgres(ficheProgres)\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\"><div flex layout=\"column\"><div \nclass=\"text-truncate nl-listing-item-title\">{{ficheProgres.title}} {{ficheProgres.num}}</div><div \nclass=\"nl-indicator-header-infos\"><span ng-if=\"ficheProgres.malfunction.type.name\">\nDysfonctionnement: {{ficheProgres.malfunction.type.name}} - </span><span ng-if=\"ficheProgres.type.name\">\nFiche de progrès: {{ficheProgres.type.name}} - </span>{{ficheProgres.creation | date : \'dd/MM/yyyy\'}} <span \nng-if=\"mapActionFiche.get(ficheProgres.id)!=null\">\n- Action corrective planifiée le {{mapActionFiche.get(ficheProgres.id).date}} pour <b>\n{{mapActionFiche.get(ficheProgres.id).responsable}}</b></span></div></div></div><div flex=\"nogrow\"><md-menu \nclass=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" style=\"border-color:rgba(197, 220, 244, 1) !important\"><md-menu-item \nng-if=\"ficheProgres.malfunction != null\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openMalfunction(ficheProgres.malfunction)\">Voir le dysfonctionnement</md-button></md-menu-item><md-menu-item>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"addAction(ficheProgres)\">\nPlanifier une action corrective en vue de clôturer la FDP</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"update(ficheProgres)\">Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDelete(ficheProgres)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nng-if=\"document.isRestricted != null && !$root.user.isTeam\" class=\"nl-Checkbox\" ng-model=\"document.isRestricted\" \naria-label=\"Confidentiel\" md-no-ink ng-change=\"setRestrictedDoc(document)\">Confidentiel<md-tooltip \nmd-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredFichesProgres.length === 0 && filter.type != \'\'\"><p>Aucun résultat...</p></md-list-item><div \nng-if=\"!archiveEmpty && tabs.archive\"><div class=\"nl-listing mt-20\"><div \nng-repeat=\"ficheProgres in archivedFichesProgres track by $index\" ng-click=\"openFicheProgres(ficheProgres)\"><div \nclass=\"nl-listing-item\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\"><div flex layout=\"column\"><div \nclass=\"text-truncate nl-listing-item-title\">{{ficheProgres.title}}</div><div class=\"nl-indicator-header-infos\"><span \nng-if=\"ficheProgres.malfunction\">{{ficheProgres.malfunction.type.name}} - </span>\n{{ficheProgres.creation | date : \'dd/MM/yyyy\'}} <span ng-if=\"ficheProgres.clotureDate\">\n- Clôturée le : {{ficheProgres.clotureDate | date : \'dd/MM/yyyy\'}}</span> <span \nng-if=\"mapActionFiche.get(ficheProgres.id)!=null\">\n- Action corrective planifiée le {{mapActionFiche.get(ficheProgres.id).date}} pour <b>\n{{mapActionFiche.get(ficheProgres.id).responsable}}</b></span></div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"end center\"><div ng-if=\"ficheProgres.hasClosingTaskDone\" class=\"nl-list-item-icon\" \nstyle=\"cursor: default !important\"><img src=\"assets/icons/app/planning/trophy.svg\" alt=\"\"><md-tooltip \nmd-direction=\"bottom\">Clôturée</md-tooltip></div><div style=\"width: 44px; min-width: 44px\"><md-menu \nclass=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\" ng-if=\"ficheProgres.malfunction != null\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" style=\"border-color:rgba(197, 220, 244, 1) !important\">\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openMalfunction(ficheProgres.malfunction)\">\nVoir le dysfonctionnement</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div>\n</div></div></div></section>");
$templateCache.put("app/main/front/malfunctions/mal_fiches.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">\n{{$root.user.isMini ? \'Dysfonctionnements\' : \'Dysfonctionnements & traçabilités\'}}</h1><div class=\"nl-listing mt-45\">\n<div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"cat in categories | orderBy: \'index\'\" \nng-click=\"openCategorie(cat)\"><md-button class=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/dysfonc/{{cat.icon}}\" class=\"nl-listing-item-icon\"></md-icon></md-button><div flex \nclass=\"text-truncate nl-listing-item-title\">{{cat.title}}</div></div></div></div></section>");
$templateCache.put("app/main/front/malfunctions/malfunction_item.html","<div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"pl-10 pr-10\"><md-icon class=\"iv-list-item-warning\" \nng-if=\"malfunction.status === statuses.NOT_OPEN\" md-svg-src=\"assets/icons/app/V3/warning.svg\"></md-icon><md-icon \nclass=\"iv-list-item-warning\" ng-if=\"malfunction.status === statuses.NOT_READ\" md-svg-src=\"assets/icons/app/V3/lu.svg\">\n</md-icon><md-icon class=\"iv-list-item-warning\" ng-if=\"malfunction.status === statuses.READ\" \nmd-svg-src=\"assets/icons/app/V3/lu.svg\"></md-icon><md-icon class=\"iv-list-item-warning\" \nng-if=\"malfunction.status === statuses.IN_PROGRESS\" md-svg-src=\"assets/icons/app/V3/fdp_progress.svg\"></md-icon></div>\n<div class=\"flex layout-column\" layout=\"column\" role=\"button\"><div class=\"nl-list-item-title text-truncate\">\n{{malfunction.title}}</div><div class=\"nl-list-item-description layout-row\">{{malfunction.type.name}}<div \nclass=\"nl-newLookBlock-publication-separator\"><i class=\"icon icon-checkbox-blank-circle\"></i></div>\n{{priorities[malfunction.priority]}}<div class=\"nl-newLookBlock-publication-separator\"><i \nclass=\"icon icon-checkbox-blank-circle\"></i></div>{{malfunction.creation | date : \'dd/MM/yyyy\'}}</div></div><div \nflex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div class=\"mr-10\"><div class=\"iv-list-item-status\" \nng-if=\"malfunction.activated && malfunction.status === statuses.NOT_OPEN\">Non lu</div><div class=\"iv-list-item-status\" \nng-if=\"malfunction.activated && malfunction.status === statuses.NOT_READ || malfunction.status === statuses.READ\">Lu\n</div><div class=\"iv-list-item-status\" ng-if=\"malfunction.activated && malfunction.status === statuses.IN_PROGRESS\">\nFiche de progrès en cours</div><div class=\"iv-list-item-status\" \nng-if=\"!malfunction.activated && malfunction.status === statuses.IN_PROGRESS\">Fiche de progrès clôturée</div><div \nclass=\"iv-list-item-status\" ng-if=\"!malfunction.activated && malfunction.status != statuses.IN_PROGRESS\">Archivé</div>\n<md-tooltip md-direction=\"bottom\" ng-if=\"malfunction.activated && malfunction.status === statuses.NOT_OPEN\">\nDoit être lu par le compte Titulaire ou Responsable Qualité</md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"malfunction.activated && malfunction.status === statuses.NOT_READ\">Lu</md-tooltip><md-tooltip \nmd-direction=\"bottom\" ng-if=\"malfunction.activated && malfunction.status === statuses.READ\">Lu</md-tooltip><md-tooltip \nmd-direction=\"bottom\" ng-if=\"malfunction.activated && malfunction.status === statuses.IN_PROGRESS\">\nFiche de progrès en cours</md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"!malfunction.activated && malfunction.status === statuses.IN_PROGRESS\">Fiche de progrès clôturée</md-tooltip>\n<md-tooltip md-direction=\"bottom\" ng-if=\"!malfunction.activated && malfunction.status != statuses.IN_PROGRESS\">Archivé\n</md-tooltip></div><div class=\"nl-list-item-icon--wrapper\"><div class=\"nl-list-item-icon\" \nng-if=\"malfunction.documents.length > 0\" role=\"button\"><img src=\"assets/icons/app/V3/joindre_dark.svg\" alt=\"fichier\">\n<md-tooltip md-direction=\"bottom\">{{ malfunction.documents.length > 1 ? \'Pièces jointes\' : \'Pièce jointe\' }}\n</md-tooltip></div></div><md-menu ng-if=\"malfunction.activated\" class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item \nng-if=\"(malfunction.status === statuses.NOT_READ || malfunction.status === statuses.READ || malfunction.status === statuses.IN_PROGRESS) && !$root.user.isMini\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openProgressForm(malfunction)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/fdp.svg\"></md-icon><div>Ouvrir / Ajouter une fiche de progrès</div></md-button>\n</md-menu-item><md-menu-item ng-if=\"malfunction.documents.length > 0\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"downloadMalfunctionAttachment(malfunction.id)\"><md-icon md-svg-src=\"./assets/icons/app/V3/download.svg\">\n</md-icon><div>Télécharger {{ malfunction.documents.length > 1 ? \'les pièces jointes\' : \'la pièce jointe\' }}</div>\n</md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openMalfunction(malfunction, true)\"><md-icon md-svg-src=\"./assets/icons/app/V3/add_commentaire.svg\">\n</md-icon><div>Ajouter un commentaire</div></md-button></md-menu-item><md-menu-item \nng-if=\"(malfunction.status !== statuses.NOT_OPEN) && !$root.user.isMini\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"addToODJ(malfunction)\"><md-icon md-svg-src=\"./assets/icons/app/V3/reunion.svg\"></md-icon><div>\nAjouter à l\'ODJ de la réunion</div></md-button></md-menu-item><md-menu-item \nng-if=\"malfunction.status !== statuses.NOT_OPEN\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openShareMalfunctionPopup(malfunction)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/lien.svg\"></md-icon><div>Générer un lien de partage</div></md-button></md-menu-item>\n<md-menu-item ng-if=\"malfunction.status !== statuses.NOT_OPEN\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"update(malfunction)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon><div>Modifier</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setArchived(malfunction)\"><md-icon md-svg-src=\"./assets/icons/app/V3/archiver.svg\"></md-icon><div>Archiver\n</div></md-button></md-menu-item><md-menu-item ng-if=\"malfunction.status !== statuses.NOT_OPEN\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDelete(malfunction)\"><md-icon md-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer\n</div></md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=\"!malfunction.activated\" \nclass=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openActivate(malfunction)\"><div>Désarchiver</div></md-button></md-menu-item><md-menu-item \nng-if=\"malfunction.status === statuses.IN_PROGRESS\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openProgressFormAssociated(malfunction)\"><div>Voir fiche(s) de progrès associée(s)</div></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div>");
$templateCache.put("app/main/front/malfunctions/malfunctions.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><div>Dysfonctionnements</div><button type=\"button\" class=\"nl-Btn\" \nng-click=\"openAddMalfunction()\"><div class=\"mr-5\">+</div><div>Signaler un dysfonctionnement</div></button></h1><div \nclass=\"nl-Content\"><div class=\"iv-SmallTabs-wrapper\"><div class=\"iv-SmallTabs-item\" \nng-class=\"{\'iv-Tabs-item--active\': tabs.active}\" ng-click=\"switchTab(\'active\')\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement_tab.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\">\n</md-icon><div>Dysfonctionnements récents</div></div><div class=\"iv-SmallTabs-item\" \nng-class=\"{\'iv-Tabs-item--active\': tabs.archive}\" ng-click=\"switchTab(\'archive\')\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/history_tab.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon><div>\nDysfonctionnements archivés</div></div></div><div class=\"pb-55\"><div ng-if=\"tabs.active\"><div class=\"nl-FilterBar\"><div\n flex=\"60\" layout=\"row\" layout-align=\"start start\"><button class=\"iv-BtnIconFill mr-20\" \nng-click=\"openInfosMalfunctionsPopup()\"><md-icon md-svg-src=\"./assets/icons/app/V3/information.svg\"></md-icon></button>\n<md-menu class=\"iv-Filtre mr-10\" md-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"-12 35\" flex=\"40\"><button aria-label=\"\" class=\"iv-Filtre-btn\" ng-click=\"$mdMenu.open($event)\"><span \nng-if=\"filter.typeValue==\'\'\" class=\"iv-Filtre-btn-title\">Filtrer par type </span><span ng-if=\"filter.typeValue!=\'\'\" \nng-class=\"{\'nl-Menu-btn-title--empty\': filter.typeValue === \'Tous\'}\" \nclass=\"nl-Menu-btn-title nl-Menu-btn-title--value\"><span>Type : </span><span class=\"nl-Menu-btn-title-value\">\n{{filter.typeValue}}</span></span><md-icon class=\"iv-Filtre-btn-svg\" md-svg-src=\"./assets/icons/app/V3/arrow_down.svg\">\n</md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"4\"><md-menu-item md-menu-align-target>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"setFilter(\'type\', \'\',\'\')\"><md-icon ng-if=\"filter.type === \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.type != \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>Tous ({{countFilter(\'type\', \'all\')}})</div>\n</md-button></md-menu-item><md-menu-item md-menu-align-target ng-repeat=\"type in types\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setFilter(\'type\', \'\'+type.id,type.name)\"><md-icon \nng-if=\"filter.type == \'\'+type.id\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon \nng-if=\"filter.type != \'\'+type.id\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>\n{{type.name}} ({{countFilter(\'type\', type.name)}})</div></md-button></md-menu-item></md-menu-content></md-menu><md-menu\n class=\"iv-Filtre\" md-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"-12 35\" flex=\"45\">\n<button aria-label=\"\" class=\"iv-Filtre-btn\" ng-click=\"$mdMenu.open($event)\"><span ng-if=\"filter.statusValue == \'\' \" \nclass=\"iv-Filtre-btn-title\">Filtrer par statut </span><span ng-if=\"filter.statusValue != \'\' \" \nclass=\"nl-Menu-btn-title nl-Menu-btn-title--value\"><span>Statut : </span><span class=\"nl-Menu-btn-title-value\">\n{{filter.statusValue}}</span></span><md-icon class=\"iv-Filtre-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/arrow_down.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"4\"><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'status\', \'\',\'\')\"><md-icon ng-if=\"filter.status === \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.status != \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>Tous ({{countFilter(\'status\', \'all\')}})</div>\n</md-button></md-menu-item><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'status\', \'NOT_OPEN\',\'Non Lus\')\"><md-icon ng-if=\"filter.status == \'NOT_OPEN\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.status != \'NOT_OPEN\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>Non Lus ({{countFilter(\'status\', \'NOT_OPEN\')}})\n</div></md-button></md-menu-item><md-menu-item md-menu-align-target ng-if=\"!user.isMini\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setFilter(\'status\', \'IN_PROGRESS\',\'Avec une fiche de progrès\')\"><md-icon \nng-if=\"filter.status == \'IN_PROGRESS\'\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon \nng-if=\"filter.status != \'IN_PROGRESS\'\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>\nAvec une fiche de progrès ({{countFilter(\'status\', \'IN_PROGRESS\')}})</div></md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'priority\', \'HIGH\',\'Importance forte\')\"><md-icon ng-if=\"filter.status == \'HIGH\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.status != \'HIGH\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>\nImportance forte ({{countFilter(\'status\', \'HIGH\')}})</div></md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'priority\', \'NORMAL\',\'Importance moyenne\')\"><md-icon ng-if=\"filter.status == \'NORMAL\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.status != \'NORMAL\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>\nImportance moyenne ({{countFilter(\'status\', \'NORMAL\')}})</div></md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'priority\', \'LOW\',\'Importance faible\')\"><md-icon ng-if=\"filter.status == \'LOW\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon ng-if=\"filter.status != \'LOW\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><div>\nImportance faible ({{countFilter(\'status\', \'LOW\')}})</div></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div flex=\"40\" layout=\"row\" layout-align=\"end start\"><div class=\"nl-SearchBar nl-SearchBar--home\" \nstyle=\"min-width: 80px\" layout=\"row\"><md-icon ng-click=\"cancelSearch();refresh()\" ng-show=\"filter.searchTxt\" \nmd-svg-src=\"assets/icons/app/V3/del.svg\" class=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon \nng-click=\"search()\" md-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\">\n</md-icon><md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" \nlayout-align=\"end center\" flex=\"100\"><input ng-enter=\"search()\" class=\"nl-Input-input--searchHome\" \nplaceholder=\"Rechercher...\" type=\"text\" name=\"title\" ng-model=\"filter.searchTxt\"></md-input-container></div><button \nclass=\"iv-Btn iv-Btn--export ml-20\" ng-click=\"openExport()\"><md-icon class=\"w-15 h-15\" \nmd-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>Exporter <span \nng-if=\"trace.templateType === \'SUIVI_FORMATION\'\">le plan de formation</span></div></button></div></div><div \nclass=\"nl-listing mt-30\"><div ng-if=\"!searching\" \nng-repeat=\"malfunction in malfunctions | malfunctionsFilter:filter as filteredMalfunctions track by $index\" \nng-click=\"openMalfunction(malfunction)\" ng-include=\"\'app/main/front/malfunctions/malfunction_item.html\'\"></div><div \nng-if=\"searching\" \nng-repeat=\"malfunction in malfunctionsSearch | filter: {\'activated\': true} as filteredMalfunctionsSearch track by $index\" \nng-click=\"openMalfunction(malfunction)\" ng-include=\"\'app/main/front/malfunctions/malfunction_item.html\'\"></div></div>\n</div><div ng-if=\"tabs.archive\"><div class=\"nl-FilterBar\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n<md-menu class=\"iv-Filtre mr-10\" md-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"-12 35\"><button aria-label=\"\" class=\"iv-Filtre-btn\" ng-click=\"$mdMenu.open($event)\"><span \nng-if=\"archive.value==\'all\' || archive.value == \'none\'\" class=\"iv-Filtre-btn-title\">Filtrer par année </span><span \nng-if=\"archive.value!=\'all\' && archive.value!=\'none\'\" class=\"iv-Filtre-btn-title\">{{ archive.value}}</span><md-icon \nclass=\"iv-Filtre-btn-svg\" md-svg-src=\"./assets/icons/app/V3/arrow_down.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"4\"><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"archive.value = \'all\'; months.length = 0; searchArchives(\'YEAR\');\"><md-icon \nng-if=\"archive.value == \'all\' || archive.value == \'none\'\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon>\n<md-icon ng-if=\"archive.value != \'all\' && archive.value!= \'none\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>Toutes</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"year in years\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"archive.value = year.value; months.length = 0; archiveMonth.value = \'none\'; searchArchives(\'YEAR\');\"><md-icon\n ng-if=\"archive.value == year.value\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon \nng-if=\"archive.value != year.value\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>{{year.value}}\n</md-button></md-menu-item></md-menu-content></md-menu><md-menu class=\"iv-Filtre\" \nmd-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"-12 35\" ng-if=\"months.length > 0\">\n<button aria-label=\"\" class=\"iv-Filtre-btn\" ng-click=\"$mdMenu.open($event)\"><span \nng-if=\"archiveMonth.value==\'all\' || archiveMonth.value == \'none\'\" class=\"iv-Filtre-btn-title\">Filtrer par mois </span>\n<span ng-if=\"archiveMonth.value!=\'all\' && archiveMonth.value!=\'none\'\" class=\"iv-Filtre-btn-title\">\n{{ archiveMonth.value}}</span><md-icon class=\"iv-Filtre-btn-svg\" md-svg-src=\"./assets/icons/app/V3/arrow_down.svg\">\n</md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"4\"><md-menu-item md-menu-align-target>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"archiveMonth.value = \'all\'; searchArchives(\'MONTH\'); \"><md-icon \nng-if=\"archiveMonth.value == \'all\' || archiveMonth.value == \'none\'\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\">\n</md-icon><md-icon ng-if=\"archiveMonth.value != \'all\' && archiveMonth.value!=\'none\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>Tous</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"month in months\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"archiveMonth.index = month.index; archiveMonth.value = month.value; searchArchives(\'MONTH\');\"><md-icon \nng-if=\"archiveMonth.value == month.value\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><md-icon \nng-if=\"archiveMonth.value != month.value\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>\n{{month.value}}</md-button></md-menu-item></md-menu-content></md-menu></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end start\"><div class=\"nl-SearchBar nl-SearchBar--home\" style=\"min-width: 80px\" layout=\"row\"><md-icon \nng-click=\"cancelSearch();refresh()\" ng-show=\"filter.searchTxt\" md-svg-src=\"assets/icons/app/V3/del.svg\" \nclass=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon ng-click=\"search()\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\"></md-icon>\n<md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" layout-align=\"end center\" \nflex=\"100\"><input ng-enter=\"search()\" class=\"nl-Input-input--searchHome\" placeholder=\"Rechercher...\" type=\"text\" \nname=\"title\" ng-model=\"filter.searchTxt\"></md-input-container></div><button class=\"iv-Btn iv-Btn--export ml-20\" \nng-click=\"openExport()\"><md-icon class=\"w-15 h-15\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\nExporter <span ng-if=\"trace.templateType === \'SUIVI_FORMATION\'\">le plan de formation</span></div></button></div></div>\n<div class=\"nl-listing mt-30\"><div ng-if=\"!searching\" ng-repeat=\"malfunction in archivedMalfunctions track by $index\" \nng-include=\"\'app/main/front/malfunctions/malfunction_item.html\'\" ng-click=\"openMalfunction(malfunction)\"></div><div \nng-if=\"searching\" \nng-repeat=\"malfunction in malfunctionsSearch | filter: {\'activated\': false} as filteredMalfunctionsSearch track by $index\" \nng-click=\"openMalfunction(malfunction)\" ng-include=\"\'app/main/front/malfunctions/malfunction_item.html\'\"></div></div>\n</div></div></div></section>");
$templateCache.put("app/main/front/malfunctions/malfunfunction_progress_forms_associated.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><a \nhref=\"./dysfonctionnements{{malfunction.activated ? \'\' : \'?tab=archive\'}}\" class=\"iv-H1-backBtn\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>\nFiches de progrès associées à \"{{malfunction.title}}\"</div></h1><div class=\"iv-Content\"><div class=\"mt-50 pb-50\"><div \nclass=\"nl-listing-item\" ng-repeat=\"ficheProgres in malfunction.progressForms\" \nng-click=\"openFicheProgres(ficheProgres)\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><div \nlayout=\"column\"><div class=\"text-truncate nl-listing-item-title\">{{ficheProgres.title}} {{ficheProgres.num}}</div><div \nclass=\"nl-indicator-header-infos\"><span ng-if=\"ficheProgres.malfunction.type.name\">\n{{ficheProgres.malfunction.type.name}} - </span>{{ficheProgres.creation | date : \'dd/MM/yyyy\'}}</div></div></div><div>\n<md-menu class=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\" ng-if=\"malfunction.status !== statuses.NOT_OPEN\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openMalfunction(ficheProgres.malfunction)\">Voir le dysfonctionnement</md-button>\n</md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"addAction(ficheProgres)\">\nPlanifier une action corrective en vue de clôturer la fiche progrès</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"update(ficheProgres)\">Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDelete(ficheProgres)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nng-if=\"document.isRestricted != null && !$root.user.isTeam\" class=\"nl-Checkbox\" ng-model=\"document.isRestricted\" \naria-label=\"Confidentiel\" md-no-ink ng-change=\"setRestrictedDoc(document)\">Confidentiel<md-tooltip \nmd-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredFichesProgres.length === 0\"><p>Aucun résultat...</p></md-list-item></div></div></section>");
$templateCache.put("app/main/front/notifications/notifications.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1 nl-H1--fs pl-40\">Notifications</h1><div \nclass=\"pb-55\"><div class=\"mt-20\"><div class=\"nl-list\"><div class=\"nl-list-item\" \nng-click=\"openNotification(notification)\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"notification in notifications track by notification.id \"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Document \"><md-icon\n md-font-icon=\"icon-checkbox-blank-circle-outline\" ng-if=\"!notification.seen\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" ng-if=\"notification.seen\"></md-icon></md-button><div layout=\"column\"><div \nclass=\"nl-listing-item-title ng-binding\">{{notification.title}}</div><div class=\"nl-indicator-header-infos\">\nReçue le {{notification.creation | date: \'dd/MM/yyyy\'}}</div></div></div></div></div><div class=\"mt-45\" layout=\"row\" \nlayout-align=\"center center\"><div><md-button type=\"button\" class=\"nl-Btn\" \nng-click=\"loadMoreNotifs(notifications.length)\" ng-hide=\"disable\">Voir plus de notifications</md-button><md-tooltip \nmd-direction=\"bottom\" ng-if=\"disable\">Toutes les notifications sont chargées</md-tooltip></div></div></div></div></div>\n</div></section>");
$templateCache.put("app/main/front/other/contact.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Contact</h1><br><br><div \nng-if=\"$root.user.isMini\"><h2 class=\"nl-Contact__encart\">\nPour toute question relative à la prise en main du logiciel ou à un problème d’ordre technique (hors questions de fond relatives à la démarche qualité), une hotline est à votre disposition :\n</h2><div class=\"ml-25\"><ul><li><h2>par mail à <a href=\"mailto:lqo@phsq.fr\" style=\"color:rgba(0,0,0,0.87)\"><b>\nlqo@phsq.fr</b></a></h2></li></ul></div></div><div ng-if=\"!$root.user.isMini\"><h2>\nPour toute question relative à la prise en main du logiciel ou à un problème d’ordre technique, une <b>hotline</b>\n est à votre disposition :</h2><br><div class=\"ml-25\"><ul><li><h2>Par téléphone au <b>01 89 47 23 17</b><br>\ndu lundi au jeudi de 10h à 12h et de 14h à 16h<br>le vendredi de 10h à 12h</h2></li><br><li><h2>Par mail à <a \nhref=\"mailto:lqo@phsq.fr\" style=\"color:rgba(0,0,0,0.87)\"><b>lqo@phsq.fr</b></a></h2></li></ul></div><div \nclass=\"nl-Contact__encart mt-60 mb-60\">\nPour toute question de fond relative à la démarche qualité, nous vous invitons à vous adresser directement à votre \n<span class=\"highlight\">Responsable Qualité Groupement</span>.</div></div></div></section>");
$templateCache.put("app/main/front/other/decouvrir-lqo-activated-popup.html","<md-dialog class=\"dl-ActivatedDialog\" aria-label=\"Activation LQO Premium\"><md-toolbar \nclass=\"dl-ActivatedDialog__toolbar\"><div class=\"dl-ActivatedDialog__toolbarRow\"><div \nclass=\"dl-ActivatedDialog__toolbarTitle\">Votre accès LQO Premium est désormais activé !</div><button type=\"button\" \nclass=\"dl-ActivatedDialog__close\" ng-click=\"close()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</button></div></md-toolbar><md-dialog-content class=\"dl-ActivatedDialog__content\"><p class=\"dl-ActivatedDialog__lead\">\nBienvenue dans l’environnement complet du Logiciel Qualité Officinal.</p><p class=\"dl-ActivatedDialog__text\">\nVous pouvez dès à présent accéder à l’ensemble des fonctionnalités avancées du LQO Premium.</p><div \nclass=\"dl-ActivatedDialog__block\"><p class=\"dl-ActivatedDialog__blockTitle\">\nAfin de vous accompagner dans vos premiers pas sur le logiciel, Pharma Système Qualité met à votre disposition plusieurs ressources :\n</p><div class=\"dl-ActivatedDialog__resource\"><div class=\"dl-ActivatedDialog__resourceIcon\"><md-icon \nmd-font-icon=\"icon-play-box-outline\"></md-icon></div><div class=\"dl-ActivatedDialog__resourceBody\"><strong>\nConsulter les tutoriels de prise en main</strong> <a target=\"_blank\" href=\"/help\">Accéder aux tutoriels</a></div></div>\n<div class=\"dl-ActivatedDialog__resource\"><div class=\"dl-ActivatedDialog__resourceIcon\"><md-icon \nmd-font-icon=\"icon-school\"></md-icon></div><div class=\"dl-ActivatedDialog__resourceBody\"><strong>\nVous inscrire au prochain webinaire « LQO Niveau 1 » afin de découvrir les bonnes pratiques et optimiser votre utilisation de l’outil\n</strong> <a target=\"_blank\" href=\"https://fhg58.r.sp1-brevo.net/mk/mr/sh/6rqJ8GoudeITQLmvDDuevGr6v3w/0zvyN978rWX5\">\nDemander mon inscription</a></div></div></div><div \nclass=\"dl-ActivatedDialog__block dl-ActivatedDialog__block--contact\"><p class=\"dl-ActivatedDialog__blockTitle\">\nBesoin d’aide ou d’un accompagnement personnalisé ? Notre hotline qualité est à votre disposition :</p><div \nclass=\"dl-ActivatedDialog__contact\"><a href=\"mailto:lqo@phsq.fr\" ng-click=\"$event.stopPropagation()\">lqo@phsq.fr</a> \n<span class=\"dl-ActivatedDialog__dot\">•</span> <span>Hotline LQO : <a href=\"tel:0189472317\" \nng-click=\"$event.stopPropagation()\">01 89 47 23 17</a></span></div><div class=\"dl-ActivatedDialog__hours\">Horaires :\n<br>Lundi au jeudi : 10h-12h et 14h-16h<br>Vendredi : 10h-12h</div></div><p class=\"dl-ActivatedDialog__footer\">\nPHSQ est à vos côtés pour vous accompagner au quotidien dans votre démarche qualité.</p></md-dialog-content>\n<md-dialog-actions class=\"dl-ActivatedDialog__actions\"><button type=\"button\" class=\"nl-Btn\" ng-click=\"close()\">Fermer\n</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/other/decouvrir-lqo.html","<section class=\"nl-Page nl-non-lqo-page dl-Page\"><div class=\"nl-H1\"><div>Découvrez le LQO</div></div><div \nclass=\"nl-Content dl-Content\"><header class=\"dl-Hero\"><div class=\"dl-Hero__icon\"><span \nclass=\"dl-UiIcon dl-UiIcon--star\" aria-hidden=\"true\"></span></div><div class=\"dl-Hero__text\"><h2 \nclass=\"dl-Hero__title\">Découvrez l\'ensemble des fonctionnalités du LQO Premium</h2><p class=\"dl-Hero__tagline\">\n\"Transformez votre espace Journées Qualité en véritable outil de pilotage officinal.\"</p></div></header><article \nclass=\"dl-Card dl-Features\"><div class=\"dl-Features__cols\"><div class=\"dl-Features__left\"><div \nclass=\"dl-Features__shield\"><span class=\"dl-BNIcon dl-BNIcon--shieldCheck\" aria-hidden=\"true\"></span></div><h3 \nclass=\"dl-Features__title\">Bonne nouvelle :</h3><p class=\"dl-Features__text\">\nVotre engagement dans la démarche Certification ISO 9001 - QMS Pharma<sup>®</sup>\n vous permet d\'accéder au LQO Premium, <span class=\"dl-Features__highlight\">sans coût additionnel.</span></p></div><div\n class=\"dl-Features__right\"><p class=\"dl-Features__lead\">Le LQO Premium accompagne votre pharmacie dans :</p><ul \nclass=\"dl-FeatureList\"><li><span class=\"dl-BNIcon dl-BNIcon--shieldCheck\" aria-hidden=\"true\"></span><span>\nla gestion qualité</span></li><li><span class=\"dl-BNIcon dl-BNIcon--users\" aria-hidden=\"true\"></span><span>\nle suivi fournisseurs</span></li><li><span class=\"dl-BNIcon dl-BNIcon--alert\" aria-hidden=\"true\"></span><span>\nles dysfonctionnements &amp; traçabilités</span></li><li><span class=\"dl-BNIcon dl-BNIcon--bars\" aria-hidden=\"true\">\n</span><span>les indicateurs &amp; tableaux de bord</span></li><li><span class=\"dl-BNIcon dl-BNIcon--folder\" \naria-hidden=\"true\"></span><span>la base documentaire</span></li><li><span class=\"dl-BNIcon dl-BNIcon--home\" \naria-hidden=\"true\"></span><span>l\'organisation officinale</span></li><li><span class=\"dl-BNIcon dl-BNIcon--phone\" \naria-hidden=\"true\"></span><span>les appels médecins</span></li><li><span class=\"dl-BNIcon dl-BNIcon--layers\" \naria-hidden=\"true\"></span><span>la centralisation de vos démarches qualité</span></li></ul></div></div><p \nclass=\"dl-Features__more\">et plein d\'autres fonctionnalités qui facilitent votre quotidien</p></article><div \nclass=\"dl-TwoCols\"><article class=\"dl-Card dl-MiniCard\"><h3 class=\"dl-MiniCard__title\">Pourquoi passer au LQO Premium ?\n</h3><ul class=\"dl-MiniList\"><li><span class=\"dl-MiniIcon dl-MiniIcon--clockFast\" aria-hidden=\"true\"></span><span>\nGain de temps au quotidien</span></li><li><span class=\"dl-MiniIcon dl-MiniIcon--users\" aria-hidden=\"true\"></span><span>\nAccompagnement structuré de l\'équipe</span></li><li><span class=\"dl-MiniIcon dl-MiniIcon--clipboardCheck\" \naria-hidden=\"true\"></span><span>Simplification de l\'organisation qualité</span></li><li><span \nclass=\"dl-MiniIcon dl-MiniIcon--history\" aria-hidden=\"true\"></span><span>Meilleure traçabilité des actions</span></li>\n<li><span class=\"dl-MiniIcon dl-MiniIcon--folderMultiple\" aria-hidden=\"true\"></span><span>\nCentralisation des outils et documents</span></li><li><span class=\"dl-MiniIcon dl-MiniIcon--chartLine\" \naria-hidden=\"true\"></span><span>Pilotage simplifié de l\'officine</span></li></ul></article><article \nclass=\"dl-Card dl-MiniCard\"><h3 class=\"dl-MiniCard__title\">Pour une prise en main optimale,<br>nous vous recommandons :\n</h3><ul class=\"dl-MiniList dl-MiniList--stack\"><li><span class=\"dl-MiniIcon dl-MiniIcon--playCircle\" \naria-hidden=\"true\"></span><span>de consulter les tutoriels d\'utilisation</span></li><li><span \nclass=\"dl-MiniIcon dl-MiniIcon--school\" aria-hidden=\"true\"></span><span>de participer au webinaire de présentation\n</span></li><li><span class=\"dl-MiniIcon dl-MiniIcon--headset\" aria-hidden=\"true\"></span><span>\nou de prendre rendez-vous avec notre équipe support</span></li></ul></article></div><article \nclass=\"dl-Card dl-Premium\"><div class=\"dl-Premium__head\"><div class=\"dl-Premium__icon\"><span \nclass=\"dl-UiIcon dl-UiIcon--gift\" aria-hidden=\"true\"></span></div><div class=\"dl-Premium__intro\"><h3 \nclass=\"dl-Premium__title\">Votre accès Premium est déjà inclus dans votre engagement qualité.</h3><p \nclass=\"dl-Premium__text\">\nActivez votre accès complet en quelques clics et profitez pleinement du LQO Premium pour simplifier votre quotidien et piloter efficacement votre qualité.\n</p></div></div><div class=\"dl-Premium__actions\"><div class=\"dl-Premium__left\"><button type=\"button\" \nclass=\"dl-Premium__btn dl-Premium__btn--primary\" ng-click=\"activatePremium()\" \nng-disabled=\"loadingActivation || loadingCurrent\"><span class=\"dl-Premium__btnIcon\"><span \nclass=\"dl-UiIcon dl-UiIcon--lock-badge\" aria-hidden=\"true\"></span> </span><span class=\"dl-Premium__btnBody\"><strong \nng-if=\"!loadingActivation\">Activer mon accès LQO Premium</strong> <strong ng-if=\"loadingActivation\">\nActivation en cours...</strong> <small>Consultation du contrat HDS et activation immédiate</small></span></button>\n<label class=\"dl-Premium__hds\"><input type=\"checkbox\" class=\"dl-Premium__hdsInput\" \nng-model=\"premiumActivationConfirmed\"> <span class=\"dl-Premium__hdsBox\" aria-hidden=\"true\"></span> <span \nclass=\"dl-Premium__hdsLabel\"><strong>Je confirme avoir pris connaissance et je valide le </strong><a href=\"\" \nclass=\"dl-Premium__hdsLink\" ng-click=\"openCguPopup($event)\">contrat HDS</a> <strong>.</strong></span></label></div><a \nclass=\"dl-Premium__btn dl-Premium__btn--ghost\" ui-sref=\"app.contact\"><span \nclass=\"dl-Premium__btnIcon dl-Premium__btnIcon--ghost\"><span class=\"dl-UiIcon dl-UiIcon--headset\" aria-hidden=\"true\">\n</span> </span><span class=\"dl-Premium__btnBody\"><strong>Être accompagné(e) par la hotline</strong> <small>\nPrenez rendez-vous avec notre équipe support</small> </span><span class=\"dl-Premium__btnArrow\" aria-hidden=\"true\"><span\n class=\"dl-UiIcon dl-UiIcon--chevron\" aria-hidden=\"true\"></span></span></a></div></article><footer class=\"dl-Footer\">\n<span class=\"dl-UiIcon dl-UiIcon--lock\" aria-hidden=\"true\"></span> <span>\nVos données sont sécurisées et hébergées en France</span></footer></div></section>");
$templateCache.put("app/main/front/other/help.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Tutoriels</h1><div class=\"nl-Content\"><br><br>\nRetrouvez ici toutes les vidéos tutorielles pour vous accompagner dans la prise en main du Logiciel Qualité Officinal. Si vous avez encore des questions, rendez-vous dans la rubrique \'Contact\'. Bonne découverte !\n<br><br><br><div class=\"nl-newLookBlockHelp\" style=\"background-color: #ddedfe\" ng-if=\"!$root.user.isMini\"><div \nclass=\"layout-row layout-align-start-center\"><div class=\"nl-newLookBlockHelp--header--title flex-80\">\nVisioconférences de formation au LQO</div></div></div><div layout=\"row\" layout-align=\"space-between start\" layout-wrap \nng-if=\"!$root.user.isMini\"><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1101850188?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" \nreferrerpolicy=\"strict-origin-when-cross-origin\" style=\"position:absolute;top:0;left:0;width:100%;height:100%\" \ntitle=\"Vidéo de formation niveau 1 - 2025\"></iframe></div><h2 class=\"nl-H2--help\">Vidéo de formation niveau 1</h2>\n</div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div style=\"padding:56.25% 0 0 0;position:relative\">\n<iframe src=\"https://player.vimeo.com/video/1040144095?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Visio LQO Niveau 2\"></iframe></div><h2 \nclass=\"nl-H2--help\">Vidéo de formation niveau 2</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\">\n<div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1102007800?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" \nreferrerpolicy=\"strict-origin-when-cross-origin\" style=\"position:absolute;top:0;left:0;width:100%;height:100%\" \ntitle=\"Vidéo de formation niveau 3 - 2025\"></iframe></div><h2 class=\"nl-H2--help\">Vidéo de formation niveau 3</h2>\n</div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div style=\"padding:56.25% 0 0 0;position:relative\">\n<iframe src=\"https://player.vimeo.com/video/1210904871?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" \nreferrerpolicy=\"strict-origin-when-cross-origin\" style=\"position:absolute;top:0;left:0;width:100%;height:100%\" \ntitle=\"Vidéo de formation niveau 4 - 2025\"></iframe></div><h2 class=\"nl-H2--help\">Vidéo de formation niveau 4</h2>\n</div></div><div class=\"nl-newLookBlockHelp\" style=\"background-color: #ddedfe\" ng-if=\"$root.user.isMini\"><div \nclass=\"layout-row layout-align-start-center\"><div class=\"nl-newLookBlockHelp--header--title flex-80\">\nVisioconférences de formation au LQO</div></div></div><div layout=\"row\" layout-align=\"space-between start\" layout-wrap \nng-if=\"$root.user.isMini\"><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1104870976?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" \nreferrerpolicy=\"strict-origin-when-cross-origin\" style=\"position:absolute;top:0;left:0;width:100%;height:100%\" \ntitle=\"Prise en main LQO Découverte\"></iframe></div><h2 class=\"nl-H2--help\">Vidéo de formation niveau 1</h2></div>\n</div><div class=\"nl-newLookBlockHelp\" style=\"background-color: #ddedfe\"><div \nclass=\"layout-row layout-align-start-center\"><div class=\"nl-newLookBlockHelp--header--title flex-80\">\nVidéos tutorielles par thème</div></div></div><div layout=\"row\" layout-align=\"space-between start\" layout-wrap><div \nflex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\" ng-if=\"!$root.user.isMini\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040122814?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Presentation des évolutions\"></iframe></div><h2 \nclass=\"nl-H2--help\">Présentation des évolutions</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\" \nng-if=\"!$root.user.isMini\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040115374?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Présentation générale\"></iframe></div><h2 \nclass=\"nl-H2--help\">Présentation générale</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040008472?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Activation\"></iframe></div><h2 \nclass=\"nl-H2--help\">Activation</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040113057?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Raccourci bureau\"></iframe></div><h2 \nclass=\"nl-H2--help\">Ajouter le LQO en raccourci bureau</h2></div><div flex=\"100\" flex-gt-sm=\"30\" \nstyle=\"padding-bottom: 25px\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040115959?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Collaborateurs\"></iframe></div><h2 \nclass=\"nl-H2--help\">Collaborateurs</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040116747?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Cahier de transmission\"></iframe></div><h2 \nclass=\"nl-H2--help\">Cahier de transmission</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040157554?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Base documentaire\"></iframe></div><h2 \nclass=\"nl-H2--help\">Base documentaire</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040117774?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Dysfonctionnements & Fiches de progrès\"></iframe>\n</div><h2 class=\"nl-H2--help\">Dysfonctionnements & fiches de progrès</h2></div><div flex=\"100\" flex-gt-sm=\"30\" \nstyle=\"padding-bottom: 25px\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040119116?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Appels médecins\"></iframe></div><h2 \nclass=\"nl-H2--help\">Appels médecins</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040139908?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Traçabilités\"></iframe></div><h2 \nclass=\"nl-H2--help\">Traçabilités</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040141690?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Planning - tâches et RDV\"></iframe></div><h2 \nclass=\"nl-H2--help\">Planning - Tâches et RDV</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\" \nng-if=\"!$root.user.isMini\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040134445?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Planning - Checklist Quotidienne\"></iframe></div>\n<h2 class=\"nl-H2--help\">Planning - Checklist quotidienne</h2></div><div flex=\"100\" flex-gt-sm=\"30\" \nstyle=\"padding-bottom: 25px\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040139039?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Réunions\"></iframe></div><h2 class=\"nl-H2--help\">\nRéunions</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040121187?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Tableau de bord\"></iframe></div><h2 \nclass=\"nl-H2--help\">Tableau de bord</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\"><div \nstyle=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040121142?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"Suivi fournisseurs\"></iframe></div><h2 \nclass=\"nl-H2--help\">Suivi fournisseurs</h2></div><div flex=\"100\" flex-gt-sm=\"30\" style=\"padding-bottom: 25px\" \nng-if=\"!$root.user.isMini\"><div style=\"padding:56.25% 0 0 0;position:relative\"><iframe \nsrc=\"https://player.vimeo.com/video/1040157521?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write\" \nstyle=\"position:absolute;top:0;left:0;width:100%;height:100%\" title=\"9. Plan Stratégique et RDD\"></iframe></div><h2 \nclass=\"nl-H2--help\">Plan stratégique et RDD</h2></div></div></div></section>");
$templateCache.put("app/main/front/other/legal_mentions.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Mentions légales</h1><br><br>\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel commodo eros, et tempus est. Morbi faucibus ultricies purus in gravida. Etiam nec pretium mauris. Duis lobortis venenatis felis, ut iaculis nisl ullamcorper sit amet. Morbi blandit ipsum elementum elementum porta. Pellentesque tempus quis enim vitae rutrum. Nam libero lacus, dignissim non maximus vitae, interdum eu sem. Donec lacinia fringilla odio eget auctor. Vivamus ac pharetra elit. Sed mollis enim sit amet sapien tincidunt ultrices. Vivamus pharetra felis augue, at pretium est consectetur non. Cras posuere tellus non imperdiet commodo. Phasellus tempor dui at vehicula consequat. Pellentesque non quam erat. Aenean sed elit orci. Maecenas in ligula velit. In volutpat quam et varius euismod. Pellentesque suscipit, lacus vel tincidunt molestie, sem nunc vestibulum ante, vitae facilisis nunc lacus et purus. Donec volutpat turpis libero, at porttitor velit placerat ut. Phasellus varius odio sed magna finibus facilisis. Etiam eu molestie ligula. Pellentesque quis mauris sodales, scelerisque odio at, suscipit erat. Praesent eleifend purus vitae interdum congue. Donec sed diam vitae massa posuere dapibus. Phasellus pellentesque tristique est eget porttitor. Suspendisse potenti. Mauris eu elementum ligula. Vestibulum posuere feugiat ligula finibus feugiat. Suspendisse potenti. Vivamus non nisi et turpis imperdiet interdum eu non nulla. Cras velit felis, tristique ut commodo non, fringilla sed erat. Donec eu fringilla purus, at porttitor magna. Mauris posuere dolor eu mollis tempor. Nunc sit amet elementum ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Proin viverra ligula dapibus, efficitur magna pulvinar, sagittis neque. Vestibulum sed sodales urna. Mauris sit amet nisl lorem. Vivamus vulputate accumsan lobortis. Ut hendrerit eleifend ipsum vel suscipit. Mauris velit lacus, pharetra vitae elit et, interdum fermentum nulla. Maecenas neque magna, ullamcorper id odio ut, fermentum gravida ipsum. Donec rutrum nisi in sem efficitur, id hendrerit velit sodales. Proin at sapien a quam ultricies mattis quis ac ex. Phasellus pretium mauris a nisl ornare, a scelerisque tortor imperdiet. Morbi leo sapien, ornare id ipsum ut, posuere euismod quam. Nunc ac tellus tincidunt, blandit velit eget, pharetra nunc. Aenean sed feugiat dolor, sit amet feugiat sapien. Praesent et ex a justo egestas ultrices. Etiam nulla nibh, convallis ac lobortis in, ultricies a felis. Cras at enim ut magna porta dignissim sed et eros. Aliquam laoreet lacus nisl, a tempus diam consequat eu. Nullam eleifend varius tempus. Quisque lacinia nunc purus, sed consequat eros gravida at.\n</div></section>");
$templateCache.put("app/main/front/other/mini_restrictions_modal.html","<md-dialog aria-label=\"restriction_mini\" flex=\"40\" flex-sm=\"60\" flex-xs=\"80\"><md-toolbar layout=\"column\"><div flex \nlayout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">Accès réservé</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\" layout-wrap>\nFonction disponible aux pharmacies engagées dans une démarche de certification ISO 9001-QMS Pharma®.<p>\nMerci de contacter votre Responsable Qualité Groupement.</p></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/front/performances/performances.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Performances</h1><div \nclass=\"nl-listing mt-45\"><div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"cat in categories | orderBy: \'index\'\" ng-click=\"openCategorie(cat)\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/performances/{{cat.icon}}\" class=\"nl-listing-item-icon\"></md-icon></md-button><div \nclass=\"text-truncate nl-listing-item-title\">{{cat.title}}</div></div></div></div></section>");
$templateCache.put("app/main/front/profile/profile.html","<section class=\"nl-Page off-page\"><h1 class=\"nl-H1\">Paramètres du compte</h1><div class=\"nl-Content off-content\"><div \nclass=\"off-compte\"><div class=\"off-bloc\"><div class=\"off-bloc__titre\"><span class=\"off-bloc__intitule\"><span \nclass=\"off-bloc__icone\"><md-icon md-font-icon=\"icon-account-key\" class=\"s16\"></md-icon></span>Mon compte </span><span \nclass=\"off-role\" ng-if=\"libelleRole()\" \nng-class=\"{\n                \'off-role--titulaire\': $root.user.isTitulaire,\n                \'off-role--praq\': $root.user.isPraq,\n                \'off-role--equipe\': $root.user.isTeam}\">\n{{libelleRole()}}</span></div><div class=\"off-ligne\"><span class=\"off-ligne__k\">Courriel de connexion</span> <span \nclass=\"off-ligne__v\">{{$root.user.mail}}</span></div><div class=\"off-ligne\"><span class=\"off-ligne__k\">Mot de passe\n</span> <span class=\"off-ligne__v\">••••••••</span></div><div class=\"off-ligne\"><span class=\"off-ligne__k\">\nDernière connexion</span> <span class=\"off-ligne__v\" ng-if=\"$root.user.lastConnection\">\n{{$root.user.lastConnection | date:\'dd/MM/yyyy\'}}</span> <span class=\"off-ligne__v off-fil__absent\" \nng-if=\"!$root.user.lastConnection\">Non renseignée</span></div><div class=\"off-texte-petit off-compte__note\" \nng-if=\"$root.user.isTeam\">Votre courriel et votre mot de passe sont gérés par le titulaire de l\'officine.</div><div \nclass=\"off-actions-droite\" ng-if=\"!$root.user.isTeam\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"openUpdateAccount()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Modifier mon courriel ou mon mot de passe\n</button></div></div><div class=\"off-bloc off-bloc--renvoi\"><div class=\"off-bloc__titre\"><span \nclass=\"off-bloc__intitule\"><span class=\"off-bloc__icone\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s16\">\n</md-icon></span>Les accès de votre équipe</span></div><div class=\"off-renvoi__texte\" ng-if=\"$root.user.isTitulaire\">\nLa gestion des accès de votre équipe se trouve désormais dans <strong>Mon officine › Accès LQO</strong>\n&#8239;: les trois accès LQO de l\'officine — Titulaire, Responsable Qualité, Équipe — y sont réunis, à côté de vos contacts et du reste de votre fiche.\n</div><div class=\"off-renvoi__texte\" ng-if=\"!$root.user.isTitulaire\">\nLes accès de l\'équipe — Titulaire, Responsable Qualité, Équipe — sont gérés par le titulaire de l\'officine, depuis \n<strong>Mon officine</strong>.</div><div class=\"off-actions-droite\" ng-if=\"$root.user.isTitulaire\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"goToMonOfficine()\">Gérer les accès LQO<md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"off-icone-apres\"></md-icon></button></div></div></div></div></section>");
$templateCache.put("app/main/front/qualite/qualite.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Qualité</h1><div class=\"nl-listing mt-45\"><div\n class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"cat in categories | orderBy: \'index\'\" \nng-click=\"openCategorie(cat)\"><md-button class=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/animationqual/{{cat.icon}}\" class=\"nl-listing-item-icon\"></md-icon></md-button><div \nclass=\"text-truncate nl-listing-item-title\">{{cat.title}}</div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"folders.length === 0\"><p>Aucun résultat...</p></md-list-item></div></section>");
$templateCache.put("app/main/public/legalMentions/legal_mentions.html","<section class=\"nl-Page pb-45\" style=\"overflow:visible\"><div class=\"nl-Content\"><h1><strong><u>MENTIONS</u></strong> \n<strong><u>LEGALES APPLICATION LQO</u></strong></h1><p><u>Application &eacute;dit&eacute;e par </u></p><p>\nL&rsquo;association Pharma Syst&egrave;me Qualit&eacute;,</p><p>66 avenue des Champs-Elysées 75008 Paris</p><p>\nAssociation loi 1901&nbsp;/ SIRET 522 401 173&nbsp;00011</p><p>Mail&nbsp;: <a \nhref=\"mailto:contact@pharmasystemequalite.com\">contact@pharmasystemequalite.com</a></p><p>\nDirecteur de la publication&nbsp;: Laetita Hible (<a href=\"mailto:contact@pharmasystemequalite.com\">\ncontact@pharmasystemequalite.com</a>)</p><p>\nD&eacute;l&eacute;gu&eacute; &agrave; la protection des donn&eacute;es&nbsp;: Nicolas Fauquet (<img \nclass=\"nl-Mentions--img\" src=\"assets/images/PHSQ/nfauquet.png\" alt=\"\">pharmasystemequalite.com)</p><h1>\n1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Conception, d&eacute;veloppement et r&eacute;alisation du site</h1><p>\nAssociation Pharma Syst&egrave;me Qualit&eacute;</p><p>66 avenue des Champs-Elysées 75008 Paris</p><h1>\n2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; H&eacute;bergement</h1><p>OVH Healthcare</p><p>2 rue Kellermann</p><p>\n59100 Roubaix - France</p><h1>3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Objectif et qualit&eacute; des contenus</h1><p>\nL&rsquo;application LQO est un outil d&eacute;mat&eacute;rialis&eacute; ayant pour objectif de regrouper les outils &laquo;&nbsp;classiques&nbsp;&raquo; et sur mesure pour dynamiser le syst&egrave;me qualit&eacute; de l&rsquo;utilisateur dans le cadre de sa d&eacute;marche ISO 9001 &ndash; QMS Pharma.\n</p><p>\nIl contient de la documentation concernant la d&eacute;marche qualit&eacute; ainsi que des contenus ins&eacute;r&eacute;s par l&rsquo;utilisateur.\n</p><p>\nSi toutefois une information est inexacte ou contient une erreur, vous pouvez contacter le concepteur de l&rsquo;application &agrave; l&rsquo;adresse \n<a href=\"mailto:contact@pharmasystemequalite.com\">contact@pharmasystemequalite.com</a></p><h1>\n4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Droit de propri&eacute;t&eacute; intellectuelle</h1><p>\nLe Site Internet de PHSQ et chacun des &eacute;l&eacute;ments qui le composent, notamment les textes, images, photographies, illustrations, sons, musiques, sont, sauf mentions particuli&egrave;res, la propri&eacute;t&eacute; exclusive de PHSQ. De m&ecirc;me, PHSQ est propri&eacute;taire exclusif des noms de domaine qu&rsquo;elle exploite.\n</p><p>\nEn cons&eacute;quence, en application des dispositions du Code de la propri&eacute;t&eacute; intellectuelle, toute reproduction int&eacute;grale ou partielle, du site ou de l&rsquo;un quelconque des &eacute;l&eacute;ments qui le composent, est interdite.\n</p><h1>5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Liens hypertextes</h1><p>\nLes liens hypertextes mis en place dans le cadre du site internet PHSQ en direction d&rsquo;autres ressources pr&eacute;sentes sur le r&eacute;seau Internet ne sauraient engager la responsabilit&eacute; de PHSQ.\n</p><p>\nPHSQ ne prend aucun engagement concernant ces autres sites internet auquel l&rsquo;utilisateur pourrait avoir acc&egrave;s via le site internet notamment en ce qui concerne le contenu, fonctionnement, l&rsquo;acc&egrave;s et l&rsquo;utilisation de ses donn&eacute;es personnelles par ces derniers.\n</p><h1>6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Cookie</h1><p>La politique de cookies de PHSQ est présente dans le chapitre « \n<a ng-click=\"gotoAnchor(\'cookies\')\">Gestion des cookies LQO</a> ».</p><p>\nL’utilisateur est informé que, lors de l’utilisation de l’application, des cookies peuvent être installés automatiquement via son logiciel de navigation.\n</p><p>\nUn cookie se définit comme un ensemble de données qui n’identifient pas directement les internautes mais permet d’enregistrer des informations relatives à la navigation de celui-ci sur le site.v\n</p><p>\nL’utilisateur peut paramétrer son logiciel de navigation pour gérer la présence de cookies et les refuser le cas échéant. La procédure est expliquée dans le chapitre « \n<a ng-click=\"gotoAnchor(\'cookies\')\">Gestion des cookies LQO</a> ».</p><p>\nL’utilisateur dispose d’un droit d’opposition, d’accès, de modification et de suppression des données à caractère personnel communiquées par le biais des cookies en contactant le délégué à la protection des données de PHSQ à l’adresse : \n<img class=\"nl-Mentions--img\" src=\"assets/images/PHSQ/nfauquet.png\" alt=\"\">pharmasystemequalite.com</p><h1>\n7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Gestion des donn&eacute;es personnelles</h1><p>\nLa politique de gestion des données personnelles de l’application est consultable à tout moment dans le chapitre « <a \nng-click=\"gotoAnchor(\'conditions_rgpd\')\">\nConditions de sous-traitance de traitement de données à caractère personnel – RGPD</a> ».</p><p>\nPour toute question relative &agrave; la gestion de ses donn&eacute;es personnelles, l&rsquo;utilisateur peut contacter le d&eacute;l&eacute;gu&eacute; &agrave; la protection des donn&eacute;es de PHSQ par courrier &agrave; l&rsquo;adresse du si&egrave;ge de PHSQ ou par mail &agrave; l&rsquo;adresse&nbsp;: \n<img class=\"nl-Mentions--img\" src=\"assets/images/PHSQ/nfauquet.png\" alt=\"\">pharmasystemequalite.com</p><p>&nbsp;</p><p>\n&nbsp;</p><p>&nbsp;</p><h1 id=\"cookies\"><span style=\"text-decoration: underline\">GESTION DES COOKIES LQO</span></h1>\n<h1>1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Qu&rsquo;est-ce qu&rsquo;un cookie&nbsp;?</h1><p>\nUn cookie est un petit fichier texte au format alphanum&eacute;rique d&eacute;pos&eacute; sur le disque dur de l&rsquo;Internaute par le serveur du site visit&eacute; ou par un serveur tiers (r&eacute;gie publicitaire, service de web analytique, etc.)\n</p><p>\nUn cookie permet &agrave; l&rsquo;application de reconna&icirc;tre la navigation. Il peut conserver des donn&eacute;es li&eacute;es aux choix de l&rsquo;Utilisateur, la langue utilis&eacute;e et les pr&eacute;f&eacute;rences.\n</p><p>\nUn cookie peut aussi permettre un meilleur fonctionnement de l&rsquo;application et l&rsquo;optimisation des contenus et des fonctionnalit&eacute;s.\n</p><p>&nbsp;</p><h1>2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Quels cookies sont utilis&eacute;s&nbsp;?</h1><p>\nL&rsquo;application LQO r&eacute;cup&egrave;re les cookies suivants&nbsp;:</p><ul><li>Les cookies fonctionnels&nbsp;:\n<ul><li>selectedTheme</li><li>JSESSIONID</li></ul></li><li>Les cookies techniques&nbsp;:<ul><li>rememberMe</li></ul>\n</li></ul><p>\nL&rsquo;Utilisateur peut, &agrave; tout moment, refuser l&rsquo;utilisation des cookies sur son navigateur.</p><h1>\n3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Combien de temps sont conserv&eacute;s les cookies&nbsp;?</h1><p>\nLes cookies fonctionnels sont conserv&eacute;s le temps de la connexion &agrave; l&rsquo;application. Ils sont supprim&eacute;s d&egrave;s la d&eacute;connection de l&rsquo;utilisateur.\n</p><p>\nLes cookies techniques sont conserv&eacute;s douze (12) mois &agrave; compter du recueil du consentement de l&rsquo;utilisateur.\n</p><h1>4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Puis-je d&eacute;sactiver les cookies&nbsp;?</h1><p>\nL&rsquo;utilisateur peut param&eacute;trer son navigateur pour d&eacute;sactiver la r&eacute;cup&eacute;ration des cookies&nbsp;:\n</p><h2>4.1&nbsp;&nbsp;&nbsp;&nbsp; Sur Mozilla Firefox</h2><p>\nLa proc&eacute;dure compl&egrave;te est pr&eacute;sente sur ce <a \nhref=\"https://support.mozilla.org/fr/kb/autoriser-bloquer-cookies-preferences-sites?redirectlocale=fr&amp;redirectslug=activer-desactiver-cookies\">\nlien</a></p><ul><li>Cliquez sur le bouton de menu et s&eacute;lectionnez Options.</li><li>\nS&eacute;lectionnez le panneau Vie priv&eacute;e.</li><li>\nDans la zone Historique, cliquez sur Supprimez des cookies sp&eacute;cifiques. S&eacute;lectionnez les Cookies que vous souhaitez d&eacute;sactiver puis supprimez-les.\n</li></ul><p>&nbsp;</p><h2>4.2&nbsp;&nbsp;&nbsp;&nbsp; Sur Chrome</h2><p>\nLa proc&eacute;dure compl&egrave;te est pr&eacute;sente sur ce <a \nhref=\"https://support.google.com/accounts/answer/61416?hl=fr\">lien</a></p><ul><li>\nCliquez sur le menu Chrome dans la barre d&rsquo;outils du navigateur.</li><li>S&eacute;lectionnez Param&egrave;tres.\n</li><li>Cliquez sur Afficher les param&egrave;tres avanc&eacute;s.</li><li>\nDans la section &laquo; Confidentialit&eacute; &raquo;, cliquez sur le bouton Param&egrave;tres de contenu.</li><li>\nDans la section &laquo; Cookies &raquo;, s&eacute;lectionnez l&rsquo;option &laquo; Interdire &agrave; tous les sites de stocker des donn&eacute;es. &raquo;\n</li></ul><p>&nbsp;</p><h1>\n5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Quels sont les incidences de la d&eacute;sactivation des cookies&nbsp;?</h1><p>\nEn cas de d&eacute;sactivation des cookies, il est possible que certaines fonctionnalit&eacute;s de l&rsquo;application LQO ne soient plus accessibles ou ne fonctionnement plus correctement.\n</p><p>\nPour toute question relative aux cookies et plus g&eacute;n&eacute;ralement &agrave; la politique de gestion des donn&eacute;es personnelles, l&rsquo;utilisateur peut contacter le d&eacute;l&eacute;gu&eacute; &agrave; la protection des donn&eacute;es de PSHQ par courrier &agrave; l&rsquo;adresse du si&egrave;ge de PHSQ ou par mail &agrave; l&rsquo;adresse&nbsp;: \n<img class=\"nl-Mentions--img\" src=\"assets/images/PHSQ/nfauquet.png\" alt=\"\">pharmasystemequalite.com.</p><p>&nbsp;</p>\n<p>&nbsp;</p><h1 id=\"conditions_rgpd\"><span style=\"text-decoration: underline\">\nConditions de sous-traitance de traitement de données à caractère personnel – RGPD</span></h1><h1>\nArticle 1&nbsp;: Objet</h1><p>Les présentes conditions (ci-après le « <strong>Contrat</strong>\n ») définit les modalités selon lesquelles PHSQ s’engage à réaliser les opérations de traitement de données à caractère personnel définies ci-après, pour le compte et conformément aux instructions du Client.\n</p><p>\nLes Parties s’engagent à respecter la réglementation applicable au traitement des données personnelles et notamment la Loi Informatique et Libertés du 6 janvier 1978 et le Règlement Européen sur la Protection des Données (ci-après « \n<strong>RGPD</strong> »).</p><p><strong>&nbsp;</strong></p><h1>Article 2&nbsp;: Description des traitements</h1><p>\nLe Client, en qualité de responsable de traitement, autorise PHSQ à traiter pour son compte les données à caractère personnel nécessaires pour fournir le ou les service(s) suivant(s)&nbsp;: Logiciel Qualité Officinal (LQO).\n</p><ol start=\"1\" type=\"1\"><li>\nLes données personnelles enregistrées par le Client sur la solution sont notamment les suivantes :&nbsp;<ol start=\"1\" \ntype=\"a\"><li>\nEléments d’identification de patients (nom, prénom,…), traitements médicaux, et toutes autres donnés que le Client s’autorisera à tracer pour assurer le suivi pharmaceutique du patient et/ou l’amélioration de son organisation.\n</li><li>\nCoordonnées de la pharmacie, adresses mails de la pharmacie et/ou de salariés de la pharmacie, documents de travails de la pharmacie, échanges entre membres de l’équipe et toutes autres données que le Client s’autorisera à tracer pour assurer le suivi pharmaceutique de patients et/ou l’amélioration de son organisation.\n</li></ol></li><li>Les opérations réalisées sur les données personnelles sont limitées au stockage et à la maintenance.\n</li></ol><p>\nLes données personnelles ne font pas l’objet d’une analyse ou d’une transmission à un tiers autre que les Sous-traitants ultérieurs visés à l’article 6/\n</p><p>\nLe traitement de ces données personnelles a pour finalités&nbsp;le stockage pour le compte du Client ses données.</p>\n<ol start=\"3\" type=\"1\"><li>\nLes personnes concernées par le traitement de leurs données personnelles sont les suivantes&nbsp;: Salariés, clients, professionnels de santé et autres personnes enregistrées par le Client.\n</li></ol><p>&nbsp;</p><h1>Article 3&nbsp;: Durée de la sous-traitance</h1><p>\nLa sous-traitance mise en place par le présent Contrat prend effet à compter de la date de signature du présent contrat pour une durée de un an, renouvelable par tacite reconduction.\n</p><p>&nbsp;</p><h1>Article 4&nbsp;: Obligations de PHSQ</h1><h2>\n4.1&nbsp;&nbsp;&nbsp;&nbsp; Obligations relatives au traitement des données personnelles</h2><p>\nPHSQ s’engage à réaliser les prestations de sous-traitance prévues dans les présentes conformément aux obligations ci-après mentionnées, et notamment&nbsp;:\n</p><ul type=\"disc\"><li>\nTraiter les données exclusivement pour les finalités mentionnées à l’Article 2 du présent Contrat&nbsp;;</li><li>\nTraiter les données personnelles conformément aux instructions documentées du Client&nbsp;prévue aux présentes. En outre, PHSQ s’engage à informer immédiatement le Client s’il considère qu’une de ses instructions constituent une violation de la législation relative à la protection des données personnelles et notamment du RGPD&nbsp;;\n</li></ul><p>\nDans l’hypothèse où PHSQ est tenue de procéder à un transfert de données vers un pays tiers ou une organisation internationale, en vertu du droit de l’Union ou du droit de l’Etat membre auquel il est soumis, il doit en informer le Client avant tout traitement, sauf si le droit concerné interdit une telle information pour des motifs d’intérêt public&nbsp;;\n</p><ul type=\"disc\"><li>\nMettre en place toutes les mesures nécessaires afin de garantir la confidentialité des données personnelles traitées.\n</li></ul><p>\nCette obligation de confidentialité est étendue à l’ensemble des personnes autorisées à traiter les données personnelles objet des présentes. A cette fin, la désignation des personnes autorisées à traiter les données personnelles doit être strictement limitée aux nécessités liées à l’exécution des présentes et recevoir une formation en matière de protection des données à caractère personnel&nbsp;;\n</p><ul type=\"disc\"><li>\nPrendre en compte, s’agissant de ses outils, produits, applications et/ou services, les principes de protection des données dès la conception et de protection des données par défaut&nbsp;;\n</li><li>PHSQ s’engage à mettre en place les mesures de sécurités suivantes&nbsp;:</li></ul><ul><li>\nLes moyens permettant de garantir la confidentialité, l’intégrité, la disponibilité et la résilience constantes des systèmes et des services de traitement&nbsp;;\n</li><li>\nLes moyens permettant de rétablir la disponibilité des données personnelles et l’accès de celles-ci dans des délais appropriés en cas d’incident physique ou technique&nbsp;;\n</li></ul><ul type=\"disc\"><li>\nUne fois la prestation de service relative au traitement des données personnelles terminée, PHSQ s’engage à&nbsp;:</li>\n</ul><ul><li>\nSupprimer l’ensemble des données personnelles traitées pour le compte du Client au plus tard dans un délai de 1 an après la résiliation du service.\n</li></ul><p>&nbsp;</p><h2>4.2&nbsp;&nbsp;&nbsp;&nbsp; Obligations relatives aux droits des personnes</h2><ul \ntype=\"disc\"><li><strong>Information des personnes concernées&nbsp;:</strong></li></ul><p>\nLes personnes dont les données personnelles font l’objet d’un traitement doivent en être informées au moment de la collecte de celles-ci. Il appartient au Client en sa qualité de responsable de traitement, de fournir l’ensemble des informations à adresser aux personnes concernées, conformément aux dispositions de l’Article 13 du RGPD.\n</p><p>&nbsp;</p><ul type=\"disc\"><li><strong>Exercice des droits des personnes</strong></li></ul><p>\nConformément aux dispositions du RGPD, le Client a l’obligation de donner suite aux demandes d’exercice des droits des personnes concernées à savoir, le droit d’accès, de rectification, d’effacement et d’opposition, le droit à la limitation du traitement, le droit à la portabilité des données, le droit de ne pas faire l’objet d’une décision individuelle automatisée.\n</p><p>\nAfin de garantir l’exercice de ces droits, PHSQ est tenue de mettre en œuvre toutes les mesures possibles pour aider le Client à s’acquitter de ses obligations.\n</p><p>&nbsp;</p><p>\nEn cas de demande d’exercice de leurs droits auprès de PHSQ, cette dernière doit adresser ces demandes au Client dès leur réception. Cette signification doit avoir lieu par mail à l’adresse suivante :&nbsp;president@pharmasystemequalite.com\n</p><p>\n&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;\n</p><h2>4.3&nbsp;&nbsp;&nbsp;&nbsp; Obligations envers le Client</h2><p><strong>\n• Notification des violations de données personnelles</strong></p><p>\nLe RGPD impose de notifier à l’autorité compétente, dans les meilleurs délais et au plus tard 72 heures après en avoir pris connaissance, toutes violations de données personnelles.\n</p><p>\nAfin de respecter cette obligation, PHSQ notifie au Client toute violation des données personnelles dans un délai maximal de 72 heures après en avoir eu connaissance. Cette notification est accompagnée de toute documentation utile afin de déterminer la nature, l’étendue et l’impact sur les personnes de la violation et permettre au Client de notifier cette violation à l’autorité compétente. La notification pourra être réalisée par PHSQ sous réserve de l’accord préalable du Client.\n</p><p>&nbsp;</p><p>La notification contient a minima&nbsp;:</p><ul><li>\nLa description de la nature de la violation des données personnelles y compris, si possible, les catégories et le nombre approximatif de personnes concernées et les catégories et le nombre approximatif d’enregistrements de données personnelles&nbsp;;\n</li><li>Le nom et les coordonnées du Délégué à la Protection des Données ou d’un autre point de contact&nbsp;;</li>\n<li>La description des conséquences probables de la violation des données personnelles&nbsp;;</li><li>\nLa description des mesures prises ou que le Client souhaite prendre pour remédier à la violation des données personnelles, y compris, le cas échéant, les mesures pour en atténuer les éventuelles conséquences négatives.\n</li></ul><p>&nbsp;</p><p>\nLe RGPD impose également une notification à la personne concernée par la violation de ses données personnelle, lorsque celle-ci est susceptible d’engendrer un risque élevé pour les droits et libertés d’une personne physique.\n</p><p>&nbsp;</p><p>\nCette notification doit être écrite dans des termes clairs et simples, et doit contenir l’ensemble des informations mentionnées ci-dessus. PHSQ peut procéder à ladite notification après accord du Client et en agissant au nom pour le compte de ce-dernier.\n</p><p>&nbsp;</p><p><strong>• Assistance du Client</strong></p><p>\nPHSQ met à la disposition du Client la documentation nécessaire disponible sous son profil utilisateur lui permettant de démontrer éventuellement, tout ou partie du respect de ses obligations dans le cadre de la réalisation d’audit et/ou d’inspections.\n</p><p>&nbsp;</p><p><strong>• Délégué à la Protection des Données</strong></p><p>\nEn cas de désignation d’un Délégué à la Protection des Données par PHSQ, il communique au Client le nom et les coordonnées de celui-ci.\n</p><p>&nbsp;</p><h1>Article 5&nbsp;: Obligations du Client</h1><p>Le Client s’engage à&nbsp;:</p><ul type=\"disc\"><li>\nFournir à PHSQ les données nécessaires à l’usage du LQO&nbsp;;</li><li>\nDocumenter par écrit toute instruction concernant le traitement des données personnelles par PHSQ&nbsp;;</li><li>\nVeiller au respect par PHSQ de l’ensemble des obligations posées par le RGPD et à superviser le traitement, y compris réaliser les audits et les inspections nécessaires auprès de PHSQ\n</li></ul><p>&nbsp;</p><h1>Article 6&nbsp;: Sous-traitance</h1><p>\nPHSQ sous-traite le stockage et la maintenance du système LQO à&nbsp;:</p><p>&nbsp;</p><ol start=\"3\" type=\"1\"><ol \nstart=\"1\" type=\"a\"><li>\nPour le stockage : la société OVH, SAS enregistrée sous la numéro &nbsp; &nbsp; &nbsp; &nbsp; 424 761 419 et dont le siège social se situe 2 rue Kellerman BP 80157 59100 Roubaix\n</li><li>\nPour la maintenance&nbsp;: la société NOOLINE, SARL, enregistrée sous le numéro 788&nbsp;429&nbsp;132 et dont le siège social est 5/7 Rue du Petit Albi, 95800 Cergy\n</li></ol></ol><p>Ces 2 entreprises sont désignées « <strong>Sous-traitant&nbsp;ultérieur</strong>\n », que le Client accepte expressément.</p><p>&nbsp;</p><p>\nPSHQ pourra faire appel à un autre Sous-traitant ultérieur, notamment pour mener des activités de traitement spécifiques. Cette sous-traitance (ci-après « \n<strong>Sous-traitance spécifique</strong> ») sera soumise à l’accord préalable du Client.</p><p>&nbsp;</p><p>\nCette demande doit contenir les informations suivantes&nbsp;: activités de traitement faisant l’objet d’une Sous-traitance spécifique, identité et coordonnée du Sous-traitant ultérieur ainsi que la durée de la Sous-traitance spécifique.\n</p><p>&nbsp;</p><p>\nEn l’absence de réponse du Client dans un délai de 3 mois, le consentement du Client est réputé favorable.</p><p>&nbsp;\n</p><p>\nTout Sous-traitant ultérieur est tenu de respecter les obligations prévues dans les présentes. Les traitements à sa charge se font pour le compte et selon les instructions de PHSQ.\n</p><p>&nbsp;</p><p>\nPHSQ garantit que le Sous-traitant spécifique met en place les mesures techniques et organisationnelles nécessaires afin de garantir la sécurité des données personnelles traitées et le respect de la législation relative à la protection des données personnelles.\n</p><p>&nbsp;</p><h1>Article 7&nbsp;: Registre des traitements</h1><p>\nConformément aux dispositions de l’Article 30 du RGPD, PHSQ doit tenir un registre des traitements effectués pour le compte du Client comprenant notamment&nbsp;:\n</p><p>&nbsp;</p><ul type=\"disc\"><li>\nLe nom et les coordonnées du Client pour le compte duquel il agit, des éventuels sous-traitants et, le cas échéant, du Délégué à la Protection des Données&nbsp;;\n</li><li>Les catégories de traitements effectués pour le compte du Client&nbsp;;</li><li>\nLe cas échéant, les transferts de données à caractère personnel vers un pays tiers ou à une organisation internationale, y compris l’identification de ce pays tiers ou de cette organisation internationale et, dans le cas des transferts visés à l’Article 49, paragraphe 1, deuxième alinéa du RGPD, les documents attestant de l’existence de garanties appropriées&nbsp;;\n</li><li>\nDans la mesure du possible, une description générale des mesures de sécurité techniques et organisationnelles, y compris entre autres, selon les besoins&nbsp;:\n</li></ul><ul><li>\ndes moyens permettant de garantir la confidentialité, l’intégrité, la disponibilité et la résilience constantes des systèmes et des services de traitement&nbsp;;\n</li><li>\ndes moyens permettant de rétablir la disponibilité des données personnelles et l’accès à celles-ci dans des délais appropriés en cas d’incident physique ou technique&nbsp;;\n</li><li>\nune procédure visant à tester, à analyser et à évaluer régulièrement l’efficacité des mesures techniques et organisationnelles pour assurer la sécurité du traitement.\n</li></ul><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p></div></section>");
$templateCache.put("app/main/public/questionnaireSatisfaction/questionnaireSatisfaction.html","<div class=\"qs26-page\"><div class=\"qs26-wrap\" ng-click=\"vm.trackInteraction($event)\"><div class=\"qs26-progress\" \naria-hidden=\"true\"><div class=\"qs26-progress-fill\" ng-style=\"{width: vm.scrollProgress + \'%\'}\"></div></div><header \nclass=\"qs26-header\"><div class=\"qs26-brand\"><div class=\"qs26-brand-logo\"><img src=\"assets/images/PHSQ/logopharma.png\" \nalt=\"PHSQ\"></div></div><h1 class=\"qs26-title\">Enquête satisfaction Patients 2026</h1><p class=\"qs26-subtitle\">\nVos retours sont précieux pour nous !</p><p class=\"qs26-intro\">\nAfin d\'améliorer notre service, nous vous remercions de répondre à ces quelques questions.</p><p class=\"qs26-help\">\n<strong>Pensez à cliquer sur “Envoyer”</strong> à la fin pour qu\'elles soient bien prises en compte.</p><p \nclass=\"qs26-mandatory-note\">Toutes les questions sont facultatives.</p></header><section class=\"qs26-card\" \nng-if=\"vm.isPaperSource\"><h2>Date de réponse (saisie papier)</h2><p class=\"qs26-help\">\nLa date doit être comprise dans la période de campagne.</p><div class=\"iv-Input-date-wrapper\"><md-icon \nclass=\"iv-Input-date-icon\" ng-click=\"vm.datePickers.responseDate = true\" md-svg-src=\"assets/icons/app/V3/calendar.svg\">\n</md-icon><md-datepicker class=\"iv-Input-date\" ng-click=\"vm.datePickers.responseDate = true\" \nmd-is-open=\"vm.datePickers.responseDate\" placeholder=\"\" md-hide-icons=\"all\" md-open-on-focus \nng-model=\"vm.form.responseDate\" md-min-date=\"vm.responseDateMin\" md-max-date=\"vm.responseDateMax\"></md-datepicker>\n</div></section><section class=\"qs26-card\" id=\"qs26-section-visit-reason\"><h2><span class=\"qs26-qtext\">\nRaison(s) de votre visite</span></h2><div class=\"qs26-grid-2\"><label class=\"qs26-check\"><span>Ordonnance</span><input \ntype=\"checkbox\" ng-model=\"vm.form.visitReason.ordonnance\"></label><label class=\"qs26-check\"><span>\nSans ordonnance, conseil</span><input type=\"checkbox\" ng-model=\"vm.form.visitReason.sansOrdonnance\"></label><label \nclass=\"qs26-check\"><span>Parapharmacie</span><input type=\"checkbox\" ng-model=\"vm.form.visitReason.parapharmacie\">\n</label><label class=\"qs26-check\"><span>Vaccination, test ou autre service</span><input type=\"checkbox\" \nng-model=\"vm.form.visitReason.vaccinationTestService\"></label></div><div class=\"qs26-other-row\"><span>Autre :</span> \n<input class=\"qs26-input\" type=\"text\" maxlength=\"160\" ng-model=\"vm.form.visitReasonOther\" placeholder=\"Précisez…\">\n</div></section><section class=\"qs26-card\" id=\"qs26-section-q1\"><h2><span class=\"qs26-qnum\">1</span><span \nclass=\"qs26-qtext\">Mon évaluation de cette pharmacie</span></h2><div class=\"qs26-rating-list\"><div \nclass=\"qs26-rating-row\" ng-repeat=\"item in vm.q1Items track by item.key\"><span class=\"qs26-rating-title\">{{item.label}}\n</span><div class=\"qs26-rating-buttons\"><button type=\"button\" class=\"qs26-rating-btn\" data-note=\"{{n}}\" \nng-class=\"{\'is-selected\': vm.form.q1[item.key] === n}\" ng-click=\"vm.form.q1[item.key] = n\" \nng-repeat=\"n in [1,2,3,4,5]\">{{n}}</button></div></div></div><div class=\"qs26-scale\"><span>1 — peu satisfait</span> \n<span>5 — très satisfait</span></div></section><section class=\"qs26-card\" id=\"qs26-section-q2\"><h2><span \nclass=\"qs26-qnum\">2</span><span class=\"qs26-qtext\">Votre satisfaction générale sur cette pharmacie</span></h2><div \nclass=\"qs26-q2-wrap\"><div class=\"qs26-q2-buttons\"><button type=\"button\" class=\"qs26-q2-btn\" data-note=\"{{n}}\" \nng-class=\"{\'is-selected\': vm.form.q2 === n}\" ng-click=\"vm.form.q2 = n\" ng-repeat=\"n in vm.q2Range\">{{n}}</button></div>\n<div class=\"qs26-scale\"><span>1 — pas satisfait</span> <span>10 — très satisfait</span></div></div></section><section \nclass=\"qs26-card\" id=\"qs26-section-q3\"><h2><span class=\"qs26-qnum\">3</span><span class=\"qs26-qtext\">\nVos commentaires sur les améliorations possibles</span></h2><textarea class=\"qs26-textarea\" maxlength=\"2000\" \nng-model=\"vm.form.q3Comments\" placeholder=\"Votre commentaire…\"></textarea></section><section class=\"qs26-card\" \nid=\"qs26-section-q4\"><h2><span class=\"qs26-qnum\">4</span><span class=\"qs26-qtext\">Recommanderiez-vous notre pharmacie ?\n</span></h2><div class=\"qs26-grid-2\"><label class=\"qs26-radio\"><span>Oui</span><input type=\"radio\" \nng-model=\"vm.form.q4Recommend\" value=\"Oui\"></label><label class=\"qs26-radio\"><span>Non</span><input type=\"radio\" \nng-model=\"vm.form.q4Recommend\" value=\"Non\"></label></div></section><section class=\"qs26-card\" id=\"qs26-section-q5\"><h2>\n<span class=\"qs26-qnum\">5</span><span class=\"qs26-qtext\">\nPour vous, la priorité en pharmacie pour protéger l’environnement, c’est surtout...</span></h2><p class=\"qs26-help\">\nCocher vos <strong>3 choix prioritaires</strong></p><p class=\"qs26-counter\"><strong>\n{{vm.countSelected(vm.form.q5Selections)}}</strong> / 3 sélection(s)</p><div class=\"qs26-grid-2\"><label \nclass=\"qs26-check\" ng-repeat=\"option in vm.q5Options track by option.key\"><span>{{option.label}}</span> <input \ntype=\"checkbox\" ng-model=\"vm.form.q5Selections[option.key]\" \nng-change=\"vm.onLimitedSelectionChange(\'q5Selections\', option.key, 3, \'warningQ5\')\"></label></div><div \nclass=\"qs26-other-row\"><span>Autre :</span> <input class=\"qs26-input\" type=\"text\" maxlength=\"200\" \nng-model=\"vm.form.q5Other\" placeholder=\"Précisez…\"></div><p class=\"qs26-warning\" ng-if=\"vm.warningQ5\">{{vm.warningQ5}}\n</p></section><section class=\"qs26-card\" id=\"qs26-section-q6\"><h2><span class=\"qs26-qnum\">6</span><span \nclass=\"qs26-qtext\">\nParmi ces situations, les prises en charge le plus utiles à la pharmacie en première intention sont...</span></h2><p \nclass=\"qs26-help\">Cocher vos <strong>4 choix prioritaires</strong></p><p class=\"qs26-counter\"><strong>\n{{vm.countSelected(vm.form.q6Selections)}}</strong> / 4 sélection(s)</p><div class=\"qs26-grid-2\"><label \nclass=\"qs26-check\" ng-repeat=\"option in vm.q6Options track by option.key\"><span>{{option.label}}</span> <input \ntype=\"checkbox\" ng-model=\"vm.form.q6Selections[option.key]\" \nng-change=\"vm.onLimitedSelectionChange(\'q6Selections\', option.key, 4, \'warningQ6\')\"></label></div><div \nclass=\"qs26-other-row\"><span>Autre :</span> <input class=\"qs26-input\" type=\"text\" maxlength=\"200\" \nng-model=\"vm.form.q6Other\" placeholder=\"Précisez…\"></div><p class=\"qs26-warning\" ng-if=\"vm.warningQ6\">{{vm.warningQ6}}\n</p></section><section class=\"qs26-card\" id=\"qs26-section-q7\"><h2><span class=\"qs26-qnum\">7</span><span \nclass=\"qs26-qtext\">Pour mieux vous connaître</span></h2><div class=\"qs26-grid-3\"><div><h3 \nstyle=\"margin:0 0 10px; font-size:15px; font-weight:700; color:var(--qs-text-soft)\">Vous êtes</h3><div \nclass=\"qs26-stack\"><label class=\"qs26-radio\"><span>Un homme</span><input type=\"radio\" ng-model=\"vm.form.gender\" \nvalue=\"Un homme\"></label><label class=\"qs26-radio\"><span>Une femme</span><input type=\"radio\" ng-model=\"vm.form.gender\" \nvalue=\"Une femme\"></label></div></div><div><h3 \nstyle=\"margin:0 0 10px; font-size:15px; font-weight:700; color:var(--qs-text-soft)\">Votre âge</h3><div \nclass=\"qs26-stack\"><label class=\"qs26-radio\"><span>Moins de 20 ans</span><input type=\"radio\" \nng-model=\"vm.form.ageRange\" value=\"< 20 ans\"></label><label class=\"qs26-radio\"><span>21 à 34 ans</span><input \ntype=\"radio\" ng-model=\"vm.form.ageRange\" value=\"21 à 34 ans\"></label><label class=\"qs26-radio\"><span>35 à 50 ans</span>\n<input type=\"radio\" ng-model=\"vm.form.ageRange\" value=\"35 à 50 ans\"></label><label class=\"qs26-radio\"><span>51 à 70 ans\n</span><input type=\"radio\" ng-model=\"vm.form.ageRange\" value=\"51 à 70 ans\"></label><label class=\"qs26-radio\"><span>\nPlus de 70 ans</span><input type=\"radio\" ng-model=\"vm.form.ageRange\" value=\"> à 70 ans\"></label></div></div><div><h3 \nstyle=\"margin:0 0 10px; font-size:15px; font-weight:700; color:var(--qs-text-soft)\">Êtes-vous un·e client·e habitué·e ?\n</h3><div class=\"qs26-stack\"><label class=\"qs26-radio\"><span>Oui</span><input type=\"radio\" \nng-model=\"vm.form.regularCustomer\" value=\"Oui\"></label><label class=\"qs26-radio\"><span>Non</span><input type=\"radio\" \nng-model=\"vm.form.regularCustomer\" value=\"Non\"></label></div></div></div></section><section \nclass=\"qs26-card qs26-card-submit\"><div class=\"qs26-actions\"><button type=\"button\" class=\"qs26-btn qs26-btn-primary\" \nng-if=\"!vm.hasSubmitted\" ng-click=\"vm.submit()\" \nng-disabled=\"vm.isSubmitting || !vm.identifier || (vm.campaignContext && vm.campaignContext.canSubmit === false)\">\n{{vm.isSubmitting ? \"Validation en cours...\" : \"Valider mes réponses\"}}</button></div><p class=\"qs26-warning\" \nng-if=\"!vm.identifier\">Identifiant UUID manquant dans l\'URL. Merci de vérifier le lien du questionnaire.</p><p \nclass=\"qs26-status qs26-status-success\" ng-if=\"vm.successMessage\">{{vm.successMessage}}</p><p \nclass=\"qs26-status qs26-status-error\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</p><p class=\"qs26-footer-note\">\nMerci de votre participation !</p><p class=\"qs26-footer-note\">Pharmacie engagée qualité ISO 9001 – QMS Pharma ®</p>\n</section></div></div>");
$templateCache.put("app/main/public/shareMalfunction/shareMalfunction.html","<div class=\"nl-popupMalfunction\" layout=\"column\" ms-scroll><div class=\"nl-popupMalfunction-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"nl-popupMalfunction-inner\" class=\"md-whiteframe-8dp\"><div \nclass=\"nl-popupMalfunction-logo-wrapper\"><img class=\"nl-popupMalfunction-logo\" src=\"assets/images/PHSQ/logopharma.png\" \nalt=\"\"></div><div ng-if=\"!wrongLink\"><h2 class=\"nl-H2\">{{malfunction.title}}</h2><div class=\"nl-popupMalfunction-date\">\nDate de création: {{malfunction.creation | date: \'dd/MM/yyyy\'}}</div><div class=\"nl-popupMalfunction-date\">\n{{malfunction.type.name}}</div><div class=\"nl-popupMalfunction-date\">{{PRIORITIES_MALFUNCTION[malfunction.priority]}}\n</div><p class=\"nl-popupMalfunction-text\">{{malfunction.description}}</p><p class=\"nl-popupMalfunction-rapporter\">\n{{malfunction.collaborateur.name}} {{malfunction.collaborateur.surname}}</p><button class=\"nl-Btn\" \nng-if=\"malfunction.documents.length > 0\" ng-click=\"downloadMalfunctionAttachment()\">\nTélécharger {{ malfunction.documents.length > 1 ? \'les pièces jointes\' : \'la pièce jointe\' }}</button></div><div \nng-if=\"wrongLink\">Le lien du dysfonctionnement est invalide.</div><div class=\"mt-40\" layout=\"row\" \nlayout-align=\"center center\"><button class=\"nl-Btn\" ng-click=\"goHome()\">Accueil</button></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div class=\"qs-toolbar-main-row\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'qs-toolbar-main-row--centre-occupe\': $root.shouldShowCampaignBanner() && !isGroupementMenuActive}\"><div \nclass=\"qs-toolbar-main-left\" layout=\"row\" layout-align=\"start center\"><div class=\"pl-8\" layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"toggleNonLqoNavigation($event)\" \nclass=\"md-icon-button nl-Header-logo-btn\" ng-class=\"{\'nl-Header-logo-btn--disabled\': isNonLqoUser()}\" type=\"button\" \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" role=\"img\" aria-hidden=\"true\"></md-icon></md-button><a \nng-click=\"goToHome()\"><img class=\"nl-Header-logo-img\" src=\"assets/images/PHSQ/logopharma.png\" alt=\"PHSQ logo\"></a><div \nclass=\"qs-marque\"><span class=\"nl-Header-logo-text\" ng-if=\"user.isNonLqo\">PHSQ - LQO - Journées qualité</span> <span \nclass=\"nl-Header-logo-text\" ng-if=\"isContratOsys()\">PHSQ · OSyS</span> <span class=\"nl-Header-logo-text\" \nng-if=\"!user.isNonLqo && !user.isMini && !isContratOsys()\">{{isMobile ? \'PHSQ\':\'PHSQ - LQO premium\'}}</span> <span \nclass=\"nl-Header-logo-text\" ng-if=\"!user.isNonLqo && user.isMini\">PHSQ - LQO découverte</span><div \nclass=\"qs-octobre-rose\" ng-if=\"afficherOctobreRose()\"><span class=\"qs-octobre-rose__pastille\"><svg \nclass=\"qs-octobre-rose__ruban\" viewBox=\"0 0 40 56\" aria-hidden=\"true\" focusable=\"false\"><path \nd=\"M30 52L14 26C7 17 10 5 20 5C30 5 33 17 26 26L10 52\" fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"7\" \nstroke-linejoin=\"round\"></path><path d=\"M23.6 29.9L15.6 42.9\" fill=\"none\" stroke=\"#E3007C\" stroke-width=\"12\"></path>\n<path d=\"M26 26L10 52\" fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"7\"></path></svg> <span>\nOctobre Rose {{anneeOctobreRose()}}</span> </span><span class=\"qs-octobre-rose__slogan\">\n« La qualité, c’est aussi sensibiliser. »</span></div></div></div></div><div class=\"qs-campaign-header\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"qs-campaign-header-inner\" \nng-if=\"$root.shouldShowAutoEvalBanner() && !isGroupementMenuActive\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"qs-campaign-header-main\"><span class=\"qs-campaign-header-title\">\nAuto-évaluation {{$root.autoEvalContext.campagne.annee}}</span> <span class=\"qs-campaign-header-sep\">·</span> <span \nclass=\"qs-campaign-header-dates\" ng-if=\"$root.autoEvalContext.situation === \'A_VENIR\'\">\nouverture le {{$root.autoEvalContext.campagne.dateOuverture | date:\'dd/MM\'}}</span> <span \nclass=\"qs-campaign-header-dates\" ng-if=\"$root.autoEvalContext.situation !== \'A_VENIR\'\">\nà valider avant le {{$root.autoEvalContext.campagne.dateClotureEffective | date:\'dd/MM\'}}</span></div><div \nclass=\"qs-campaign-header-cta-band\"><a class=\"qs-campaign-header-btn\" \nui-sref=\"app.performances.mes-evaluations({tab: \'auto\'})\"><span>\n{{$root.autoEvalContext.situation === \'A_VENIR\' ? \'Découvrir la campagne\' : \'Accéder à mon auto-évaluation\'}}</span> \n<span class=\"qs-campaign-header-btn-arrow\" aria-hidden=\"true\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\" class=\"qs-campaign-header-btn-arrow-icon\"></md-icon></span></a></div>\n</div><div class=\"qs-campaign-header-inner\" \nng-if=\"$root.shouldShowCampaignBanner() && !$root.shouldShowAutoEvalBanner() && !isGroupementMenuActive\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"qs-campaign-header-main\"><span class=\"qs-campaign-header-title\">\n*Journées Qualité*</span> <span class=\"qs-campaign-header-sep\">·</span> <span class=\"qs-campaign-header-dates\">\ndu {{$root.questionnaireCampaignContext.dateDebutCampagne | date:\'dd/MM\'}} au {{$root.questionnaireCampaignContext.dateFinCollecte | date:\'dd/MM\'}}\n</span></div><div class=\"qs-campaign-header-cta-band\"><a class=\"qs-campaign-header-btn\" \nui-sref=\"app.performances.mes-evaluations({tab: \'mon-enquete\'})\"><span>Accéder à mon enquête</span> <span \nclass=\"qs-campaign-header-btn-arrow\" aria-hidden=\"true\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\" \nclass=\"qs-campaign-header-btn-arrow-icon\"></md-icon></span></a></div></div></div><div class=\"qs-toolbar-main-right\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"qs-groupement-context\" ng-if=\"shouldShowGroupementContext()\"><div \nclass=\"qs-groupement-context-static\" ng-if=\"!hasMultipleGroupements()\">{{getSingleGroupementLabel()}}</div><md-menu \nmd-position-mode=\"target-right target\" ng-if=\"hasMultipleGroupements()\"><button type=\"button\" \nclass=\"qs-groupement-context-trigger\" ng-click=\"$mdMenu.open($event)\"><span>{{getSelectedGroupementLabel()}}</span>\n<md-icon md-svg-src=\"assets/icons/app/V3/arrow_down_light.svg\"></md-icon></button><md-menu-content \nclass=\"qs-groupement-context-menu\"><md-menu-item ng-if=\"needsGroupementSearch()\"><div \nclass=\"qs-groupement-context-search\" ng-click=\"$event.stopPropagation()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"s16\"></md-icon><input type=\"text\" ng-model=\"groupementSelector.search\" placeholder=\"Tapez pour filtrer...\">\n</div></md-menu-item><md-menu-item><md-button ng-click=\"selectGroupementContext(null)\" \nng-class=\"{\'is-active\': !groupementSelector.selectedGroupementId}\">Vue consolidée</md-button></md-menu-item>\n<md-menu-item ng-repeat=\"groupement in getFilteredGroupementOptions() track by groupement.id\"><md-button \nng-click=\"selectGroupementContext(groupement.id)\" \nng-class=\"{\'is-active\': groupementSelector.selectedGroupementId === groupement.id}\">{{groupement.name}}</md-button>\n</md-menu-item><md-menu-item ng-if=\"!getFilteredGroupementOptions().length\"><div class=\"qs-groupement-context-empty\">\nAucun groupement trouvé</div></md-menu-item></md-menu-content></md-menu></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><div class=\"nl-Header-account\"><md-menu md-position-mode=\"right bottom\"><button type=\"button\" \nclass=\"nl-Header-account-item\" ng-click=\"$mdMenu.open()\" ng-show=\"shouldShowQualityNotifs()\"><div>Notifications qualité\n</div><span class=\"nl-Header-account-item-badge\">\n{{notifs.malfunctions + notifs.documents + notifs.tasks + notifs.lateTasks + notifs.reunions + notifs.indicateurs}}\n</span></button><md-menu-content class=\"iv-notification-dropdown\"><md-menu-item><md-button \nclass=\"iv-notification-dropdown-btn\" ng-if=\"notifs.malfunctions > 0\" ng-click=\"goToMalfunctions()\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><div class=\"iv-notification-icon-value\">\n{{notifs.malfunctions}}</div></div><div><div class=\"iv-notification-btn-title\">Dysfonctionnements</div><div \nclass=\"iv-notification-btn-subtitle\">\n{{notifs.malfunctions}}{{notifs.malfunctions > 1 ? \' nouveaux dysfonctionnements\':\' nouveau dysfonctionnement\'}} à lire\n</div></div></div><div class=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\">\n</md-icon></div></md-button><md-button class=\"iv-notification-dropdown-btn\" ng-if=\"notifs.documents > 0\" \nng-click=\"goToDocuments()\"><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon\n md-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><div class=\"iv-notification-icon-value\">{{notifs.documents}}</div>\n</div><div><div class=\"iv-notification-btn-title\">Base documentaire</div><div class=\"iv-notification-btn-subtitle\">\n{{notifs.documents}}{{notifs.documents > 1 ? \' documents\': \' document\'}} en attente de validation</div></div></div><div\n class=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</md-button><md-button class=\"iv-notification-dropdown-btn\" ng-if=\"notifs.lateTasks > 0\" ng-click=\"goToTasks()\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><div class=\"iv-notification-icon-value\">{{notifs.lateTasks}}\n</div></div><div><div class=\"iv-notification-btn-title\">Planning</div><div class=\"iv-notification-btn-subtitle\">\n{{notifs.lateTasks}} {{notifs.lateTasks > 1 ? \' tâches en retard\': \' tâche en retard\'}}</div></div></div><div \nclass=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</md-button><md-button class=\"iv-notification-dropdown-btn\" ng-if=\"notifs.tasks > 0\" ng-click=\"goToDemarche()\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/quality.svg\"></md-icon><div class=\"iv-notification-icon-value\">{{notifs.tasks}}</div>\n</div><div><div class=\"iv-notification-btn-title\">Mise en oeuvre de la démarche</div><div \nclass=\"iv-notification-btn-subtitle\">\n{{notifs.tasks}} {{notifs.tasks > 1 ? \' tâches non programmées\': \' tâche non programée\'}}</div></div></div><div \nclass=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</md-button><md-button class=\"iv-notification-dropdown-btn\" ng-if=\"notifs.reunions > 0\" ng-click=\"goToReunions()\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/modify.svg\"></md-icon><div class=\"iv-notification-icon-value\">{{notifs.reunions}}</div>\n</div><div><div class=\"iv-notification-btn-title\">Réunion</div><div class=\"iv-notification-btn-subtitle\">\n{{notifs.reunions}} {{notifs.reunions > 1 ? \' comptes-rendus \': \' compte-rendu \' }}à rédiger</div></div></div><div \nclass=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</md-button><md-button class=\"iv-notification-dropdown-btn\" ng-click=\"goToTdb()\" ng-if=\"notifs.indicateurs > 0\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"iv-notification-btn-icon\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tab.svg\"></md-icon><div class=\"iv-notification-icon-value\">{{notifs.indicateurs}}</div>\n</div><div><div class=\"iv-notification-btn-title\">Tableau de bord</div><div class=\"iv-notification-btn-subtitle\">\n{{notifs.indicateurs}} {{notifs.indicateurs > 1 ? \' indicateurs \':\' indicateur \'}} qualité à renseigner ce mois-ci\n</div></div></div><div class=\"iv-notification-btn-arrow\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\">\n</md-icon></div></md-button></md-menu-item></md-menu-content></md-menu><span class=\"nl-Header-account-separator\" \nng-if=\"shouldShowQualityNotifs()\"></span><md-menu md-position-mode=\"right bottom\"><button type=\"button\" \nclass=\"nl-Header-account-item\" ng-click=\"$mdMenu.open()\"><div>{{getAccountMenuLabel()}}</div><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_down_light.svg\"></md-icon></button><md-menu-content \nclass=\"iv-notification-dropdown\"><md-menu-item><md-button class=\"iv-account-dropdown-btn iv-account-dropdown-text\">\n{{user.mail}}</md-button><md-button class=\"iv-account-dropdown-btn\" ng-if=\"user.hasPharmacy && !user.isNonLqo\" \nng-click=\"goToProfile()\">Paramètres du compte</md-button><md-button class=\"iv-account-dropdown-btn\" \nng-if=\"user.isTitulaire && user.hasPharmacy && !user.isNonLqo\" ng-click=\"goToMonOfficine()\">Mon officine</md-button>\n<md-button class=\"iv-account-dropdown-btn\" ng-if=\"canSwitchToView(\'groupement\')\" ng-click=\"goToView(\'groupement\')\">\nVue groupement</md-button><md-button class=\"iv-account-dropdown-btn\" ng-if=\"canSwitchToView(\'pharmacie\')\" \nng-click=\"goToView(\'pharmacie\')\">Vue pharmacie</md-button><md-button class=\"iv-account-dropdown-btn\" \nng-if=\"canSwitchToView(\'administration\')\" ng-click=\"goToView(\'administration\')\">Vue administration</md-button>\n<md-button class=\"iv-account-dropdown-btn\" ng-click=\"vm.logout()\">Déconnexion</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div class=\"qs-octobre-rose-lisere\" ng-if=\"afficherOctobreRose()\" \naria-hidden=\"true\"></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <!-- PHSQ-240 : `node.pastille` (fonction, compteur rouge), `node.verrouille` (cadenas à la\n             place du chevron) et `node.clic` (espace grisé du contrat OSYS). -->\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\" ng-click=\"node.clic && node.clic($event)\">\n                <md-icon class=\"nl-Nav-item-icon\" ng-if=\"node.icon\" md-svg-src=\"assets/icons/app/V3/menu/{{node.icon}}.svg\"></md-icon>\n                <span class=\"nl-Nav-item-text\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n                <!-- Groupe ouvert : la pastille est portée par le sous-menu, pas de doublon. -->\n                <span class=\"nl-Nav-item-pastille\" ng-if=\"node.pastille && node.pastille() && (vm.collapsed || !vm.hasChildren)\">{{node.pastille()}}</span>\n                <i class=\"nl-Nav-item-cadenas icon-lock-outline\" ng-if=\"node.verrouille\"></i>\n                <i class=\"nl-Nav-item-arrow icon-chevron-right\" ng-if=\"!node.verrouille\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"node.etatsActifs || \'active md-accent-bg\'\" ng-if=\"node.uisref && node.title\">\n            <div class=\"nl-Nav-item-box\">\n                <md-icon class=\"nl-Nav-item-icon\" ng-if=\"node.icon\" md-svg-src=\"assets/icons/app/V3/menu/{{node.icon}}.svg\"></md-icon>\n                <span class=\"nl-Nav-item-text\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n                <span class=\"nl-Nav-item-pastille\" ng-if=\"node.pastille && node.pastille()\">{{node.pastille()}}</span>\n                <i class=\"nl-Nav-item-arrow icon-chevron-right\"></i>\n            </div>\n        </a>\n\n    </div>\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/admin/administrateurs/popup/ajout-administrateur.html","<md-dialog class=\"osy-fenetre adm-fenetre\" aria-label=\"Ajouter un administrateur\"><form name=\"ajoutForm\" \nclass=\"adm-fenetre__form\" novalidate ng-submit=\"ajoutForm.$valid && envoyer()\"><div class=\"osy-fenetre__entete\"><div>\n<h2 class=\"osy-fenetre__titre\">Ajouter un administrateur</h2><p class=\"osy-fenetre__sous-titre\">\nUne invitation lui est envoyée par courriel. Il crée son mot de passe, puis active sa double authentification à sa première connexion.\n</p></div><button type=\"button\" class=\"osy-fenetre__fermer\" ng-click=\"annuler()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s20\"></md-icon></button></div><md-dialog-content class=\"osy-fenetre__corps\"><div \nclass=\"adm-fenetre__paire\"><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"adm-ajout-prenom\">Prénom <span \nclass=\"osy-requis\">*</span></label><input id=\"adm-ajout-prenom\" class=\"osy-champ\" name=\"prenom\" \nng-model=\"saisie.prenom\" required></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"adm-ajout-nom\">Nom \n<span class=\"osy-requis\">*</span></label><input id=\"adm-ajout-nom\" class=\"osy-champ\" name=\"nom\" ng-model=\"saisie.nom\" \nrequired></div></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"adm-ajout-mail\">\nCourriel professionnel <span class=\"osy-requis\">*</span></label><input id=\"adm-ajout-mail\" class=\"osy-champ\" \ntype=\"email\" name=\"mail\" ng-model=\"saisie.mail\" required><p class=\"adm-fenetre__aide\">\nIl sert d\'identifiant de connexion.</p></div><div class=\"osy-alerte osy-alerte--gris\">\nTous les administrateurs ont les mêmes droits sur l\'ensemble de l\'administration.</div><p class=\"osy-erreur\" \nng-if=\"erreur\">{{erreur}}</p></md-dialog-content><div class=\"osy-fenetre__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-click=\"annuler()\">Annuler</button> <button type=\"submit\" \nclass=\"osy-btn osy-btn--principal\" ng-disabled=\"ajoutForm.$invalid || envoi\"><md-icon md-font-icon=\"icon-send\" \nclass=\"s18\"></md-icon>Envoyer l\'invitation</button></div></form></md-dialog>");
$templateCache.put("app/main/admin/administrateurs/popup/codes-secours.html","<md-dialog class=\"osy-fenetre adm-fenetre\" aria-label=\"Régénérer mes codes de secours\"><div \nclass=\"osy-fenetre__entete\"><div><h2 class=\"osy-fenetre__titre\">Régénérer mes codes de secours</h2><p \nclass=\"osy-fenetre__sous-titre\">Vos anciens codes de secours ne fonctionneront plus.</p></div><button type=\"button\" \nclass=\"osy-fenetre__fermer\" ng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\">\n</md-icon></button></div><md-dialog-content class=\"osy-fenetre__corps\"><form id=\"adm-codes-form\" name=\"codeForm\" \nnovalidate ng-submit=\"envoyer()\" ng-if=\"!codes\"><label class=\"osy-libelle\" for=\"adm-codes-code\">\nCode à 6 chiffres de votre application d\'authentification <span class=\"osy-requis\">*</span></label><input \nid=\"adm-codes-code\" class=\"osy-champ osy-champ--court\" type=\"text\" inputmode=\"numeric\" autocomplete=\"one-time-code\" \nmaxlength=\"7\" ng-model=\"saisie.code\" ng-disabled=\"envoi\"><p class=\"osy-erreur\" ng-if=\"erreur\">{{erreur}}</p></form><div\n ng-if=\"codes\"><p class=\"adm-fenetre__texte\">Voici vos 8 nouveaux codes de secours. <strong>\nIls ne seront plus affichés.</strong></p><ul class=\"adm-codes\"><li ng-repeat=\"c in codes track by $index\"><code>{{c}}\n</code></li></ul></div></md-dialog-content><div class=\"osy-fenetre__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-if=\"!codes\" ng-click=\"fermer()\">Annuler</button> <button type=\"submit\" \nform=\"adm-codes-form\" class=\"osy-btn osy-btn--principal\" ng-if=\"!codes\" ng-disabled=\"envoi\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"s18\"></md-icon>Régénérer</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--tonal\" ng-if=\"codes\" ng-click=\"telecharger()\"><md-icon md-font-icon=\"icon-download\" \nclass=\"s18\"></md-icon>Télécharger les codes</button> <button type=\"button\" class=\"osy-btn osy-btn--principal\" \nng-if=\"codes\" ng-click=\"fermer()\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>J\'ai conservé mes codes\n</button></div></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-ajout-cible-popup.html","<md-dialog aria-label=\"Ajouter une officine à la cible\" \nclass=\"aeq-admin admin-dialog admin-dialog--confirm aeq-dialog-ajout-cible\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-pharmacy\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Ajouter une officine à la cible</div><div class=\"admin-dialog__subtitle\">\nCampagne {{campagne.annee}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"fermerAjoutCible()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><div ng-if=\"!ajoutCible.choisie\"><p class=\"admin-dialog__message\">\nLa cible a été <strong>figée à l\'ouverture</strong>\n. Cherchez l\'officine qui s\'est engagée depuis, par son nom ou son code CIP.</p><input type=\"search\" \nclass=\"aeq-dialog-recherche\" ng-model=\"ajoutCible.recherche\" ng-change=\"chercherCandidats()\" \nplaceholder=\"Nom de l\'officine ou code CIP\" aria-label=\"Rechercher une officine\"><div class=\"aeq-dialog-chargement\" \nng-if=\"ajoutCible.chargement\"><md-progress-circular md-diameter=\"22px\" md-mode=\"indeterminate\"></md-progress-circular>\n</div><p class=\"aeq-dialog-vide\" \nng-if=\"!ajoutCible.chargement &amp;&amp; ajoutCible.recherche.length >= 2\n					       &amp;&amp; !ajoutCible.candidats.length\">\nAucune officine active hors cible ne correspond. Une officine déjà dans la cible n\'apparaît pas ici.</p><p \nclass=\"aeq-dialog-vide\" ng-if=\"!ajoutCible.chargement &amp;&amp; ajoutCible.recherche.length < 2\">\nSaisissez au moins deux caractères.</p><ul class=\"aeq-dialog-candidats\" \nng-if=\"!ajoutCible.chargement && ajoutCible.candidats.length\"><li \nng-repeat=\"candidat in ajoutCible.candidats track by candidat.id\"><button type=\"button\" class=\"aeq-dialog-candidat\" \nng-click=\"choisirCandidat(candidat)\"><span class=\"aeq-dialog-candidat__id\"><span class=\"aeq-dialog-candidat__nom\">\n{{candidat.nom}}</span> <span class=\"aeq-dialog-candidat__meta\"><span class=\"aeq-mono\">{{candidat.cip || \'—\'}}</span>\n<span ng-if=\"candidat.ville\"> · {{candidat.codePostal}} {{candidat.ville}}</span></span> </span><span \nclass=\"aeq-dialog-candidat__engagee\" ng-if=\"candidat.engageQualite\">Engagée qualité</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s18 aeq-dialog-candidat__fleche\"></md-icon></button></li></ul><div \nclass=\"admin-dialog__alert aeq-dialog-note\" ng-if=\"ajoutCible.candidats.length >= 20\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>\nLes 20 premières officines seulement. Affinez la recherche.</span></div></div><div ng-if=\"ajoutCible.choisie\"><p \nclass=\"admin-dialog__message\">Ajouter <strong>{{ajoutCible.choisie.nom}}</strong> <span \nng-if=\"ajoutCible.choisie.ville\">({{ajoutCible.choisie.codePostal}} {{ajoutCible.choisie.ville}})</span>\n à la cible de la campagne {{campagne.annee}} ?</p><div \nclass=\"admin-dialog__alert aeq-dialog-note aeq-dialog-note--warn\" ng-if=\"!ajoutCible.choisie.engageQualite\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span>Elle n\'est <strong>pas engagée dans la démarche qualité\n</strong> dans le CRM. La règle d\'éligibilité ne l\'aurait pas retenue ; vous l\'ajoutez malgré elle.</span></div><div \nclass=\"admin-dialog__alert aeq-dialog-note aeq-dialog-note--ok\" ng-if=\"ajoutCible.choisie.engageQualite\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon><span>Elle est <strong>engagée dans la démarche qualité</strong>\n dans le CRM : elle entrerait dans la cible si la campagne s\'ouvrait aujourd\'hui.</span></div><div \nclass=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>\n<span><span ng-if=\"ouvertureEnvoyablePour(ajoutCible.choisie)\">Elle recevra <strong>l\'e-mail d\'ouverture<span \nng-if=\"ajoutCible.choisie.nonLqo\"> des officines non LQO</span></strong><span ng-if=\"ajoutCible.choisie.nonLqo\">\n, avec son lien de création de mot de passe,</span> et entrera</span><span \nng-if=\"!ouvertureEnvoyablePour(ajoutCible.choisie)\"><strong>Aucun e-mail ne partira</strong> — l\'e-mail d\'ouverture\n<span ng-if=\"ajoutCible.choisie.nonLqo\"> des officines non LQO</span> de cette campagne est inactif. Elle entrera\n</span> au dénominateur des taux de participation <strong>à compter d\'aujourd\'hui</strong>\n — pas rétroactivement, pour que les chiffres déjà annoncés ne changent pas. <strong>Un ajout ne se retire pas.\n</strong></span></div><button type=\"button\" class=\"aeq-dialog-retour\" ng-click=\"revenirRecherche()\" \nng-disabled=\"ajoutCible.envoi\">Choisir une autre officine</button></div></md-dialog-content><md-dialog-actions \nclass=\"admin-dialog__actions\"><md-button class=\"admin-dialog__btn admin-dialog__btn--ghost\" \nng-click=\"fermerAjoutCible()\" ng-disabled=\"ajoutCible.envoi\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" ng-if=\"ajoutCible.choisie\" \nng-click=\"confirmerAjoutCible()\" ng-disabled=\"ajoutCible.envoi\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"ajoutCible.envoi\"></md-progress-circular><span ng-if=\"!ajoutCible.envoi\">\nAjouter à la cible</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-brevo-template-popup.html","<md-dialog aria-label=\"Sélection du gabarit Brevo\" class=\"qs-brevo-dialog\" flex=\"60\" flex-sm=\"85\" flex-xs=\"95\"><form \nclass=\"md-inline-form qs-brevo-dialog-form\" novalidate ng-submit=\"confirmerGabarit()\"><md-toolbar \nclass=\"qs-brevo-dialog-toolbar\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"qs-brevo-dialog-title\" layout=\"row\" layout-align=\"start center\"><span>\n{{templatePopup.titre}}</span></div><md-button class=\"md-icon-button qs-brevo-dialog-close\" ng-click=\"fermerGabarit()\" \naria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll class=\"qs-brevo-dialog-content\"><p class=\"qs-brevo-dialog-intro\">\nChoisissez le gabarit Brevo qui servira à cet envoi. Le serveur vérifie qu\'il porte bien toutes les balises attendues, et refuse le gabarit s\'il en manque une.\n</p><div class=\"qs-brevo-dialog-hint\"><md-icon class=\"qs-brevo-dialog-hint-icon\" \nmd-font-icon=\"icon-information-outline\"></md-icon><div><div class=\"qs-brevo-dialog-hint-title\">\nBalises obligatoires dans le gabarit</div><div class=\"qs-brevo-dialog-hint-keys\"><code \nng-repeat=\"balise in templatePopup.balises track by balise\">{{balise}}</code></div><div \nng-if=\"templatePopup.balisesFacultatives.length\"><div \nclass=\"qs-brevo-dialog-hint-title aeq-balises-facultatives-titre\">Balises facultatives</div><div \nclass=\"qs-brevo-dialog-hint-keys aeq-balises-facultatives\"><code \nng-repeat=\"balise in templatePopup.balisesFacultatives track by balise\">{{balise}}</code></div></div></div></div>\n<md-input-container class=\"nl-Input-container qs-brevo-dialog-select\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Gabarit Brevo<span class=\"asterix\">*</span></label><md-select \nng-model=\"templatePopup.gabaritId\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown qs-brevo-dialog-dropdown\" ng-disabled=\"templatePopup.chargement\" \nplaceholder=\"Choisir un gabarit…\"><md-select-header class=\"nl-Input-select-header\"><input type=\"search\" \nng-model=\"templatePopup.recherche\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Rechercher un gabarit\" \nclass=\"md-text\"></md-select-header><md-option \nng-repeat=\"gabarit in templatePopup.gabarits | filter:templatePopup.recherche track by gabarit.id\" \nng-value=\"gabarit.id\" class=\"nl-Select-dropdown-btn\">{{gabarit.nom}}</md-option></md-select></md-input-container><div \nclass=\"qs-brevo-dialog-status qs-brevo-dialog-status--loading\" ng-if=\"templatePopup.chargement\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular md-diameter=\"22px\" md-mode=\"indeterminate\"></md-progress-circular>\n<span class=\"ml-10\">Chargement des gabarits Brevo…</span></div><div \nclass=\"qs-brevo-dialog-status qs-brevo-dialog-status--empty\" \nng-if=\"!templatePopup.chargement && !templatePopup.gabarits.length\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"s22\"></md-icon><span>{{templatePopup.erreur || \"Aucun gabarit Brevo n\'a été trouvé.\"}}</span></div>\n</md-dialog-content><md-dialog-actions class=\"qs-brevo-dialog-actions\" layout=\"row\" layout-align=\"end center\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"fermerGabarit()\">Annuler</button> <button type=\"submit\" \nclass=\"nl-Btn qs-brevo-dialog-submit\" \nng-disabled=\"templatePopup.chargement || templatePopup.envoi || !templatePopup.gabaritId\"><md-progress-circular \nmd-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"templatePopup.envoi\"></md-progress-circular><span \nng-if=\"!templatePopup.envoi\">Valider la sélection</span></button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-email-test-popup.html","<md-dialog aria-label=\"Envoyer un e-mail de test\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--info\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-email\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Envoyer un e-mail de test</div><div class=\"admin-dialog__subtitle\">\n{{testEmail.notification.libelle}} · campagne {{campagne.annee}}</div></div><md-button \nclass=\"md-icon-button admin-dialog__close\" ng-click=\"fermerTestEmail()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body\"><div \nclass=\"admin-dialog__alert aeq-dialog-note aeq-dialog-note--warn\" ng-if=\"testEmail.defaut\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span><strong>Envoi impossible.</strong> {{testEmail.defaut}}\n</span></div><p class=\"admin-dialog__message\" ng-if=\"!testEmail.defaut\">Le gabarit <strong>\n{{testEmail.notification.templateBrevoNom || (\'#\' + testEmail.notification.templateBrevoId)}}</strong>\n est relu chez Brevo, rendu par LQO et envoyé à l\'adresse ci-dessous, comme le serait l\'e-mail d\'une officine.</p>\n<label class=\"aeq-dialog-libelle\" for=\"aeq-email-test\">Adresse de réception</label><input id=\"aeq-email-test\" \ntype=\"email\" class=\"aeq-dialog-recherche aeq-dialog-champ\" ng-model=\"testEmail.destinataire\" \nng-disabled=\"testEmail.envoi || testEmail.defaut\" ng-keydown=\"$event.keyCode === 13 && confirmerTestEmail()\" \nplaceholder=\"prenom.nom@exemple.fr\"><div class=\"admin-dialog__alert aeq-dialog-note\" ng-if=\"!testEmail.defaut\"><md-icon\n md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \nng-if=\"testEmail.notification.type !== \'CLOTURE_INTERNE\'\">L\'objet commence par <strong>[TEST]</strong>\n. Les balises reçoivent un exemple fictif — « Pharmacie de démonstration », trois points d\'attention — mais les vraies dates de la campagne et le vrai lien vers LQO. \n</span><span ng-if=\"testEmail.notification.type === \'CLOTURE_INTERNE\'\">L\'objet commence par <strong>[TEST]</strong>\n. Les chiffres sont ceux de la campagne à ce jour : cet e-mail ne parle d\'aucune officine en particulier.</span></div>\n<div class=\"admin-dialog__alert aeq-dialog-note\" ng-if=\"!testEmail.defaut\"><md-icon md-font-icon=\"icon-history\" \nclass=\"s18\"></md-icon><span>\nUn test ne compte pas comme un envoi : ni « Dernier envoi », ni journal d\'officine. En préproduction, les e-mails partent tous vers l\'adresse de redirection du serveur.\n</span></div><div class=\"admin-dialog__alert aeq-dialog-note aeq-dialog-note--warn\" ng-if=\"testEmail.erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span>{{testEmail.erreur}}</span></div></md-dialog-content>\n<md-dialog-actions class=\"admin-dialog__actions\"><md-button class=\"admin-dialog__btn admin-dialog__btn--ghost\" \nng-click=\"fermerTestEmail()\" ng-disabled=\"testEmail.envoi\">{{testEmail.defaut ? \'Fermer\' : \'Annuler\'}}</md-button>\n<md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--success\" \nng-click=\"confirmerTestEmail()\" ng-disabled=\"testEmail.envoi || testEmail.defaut || !testEmail.destinataire\">\n<md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" ng-if=\"testEmail.envoi\"></md-progress-circular><span \nng-if=\"!testEmail.envoi\">Envoyer le test</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-figer-popup.html","<md-dialog aria-label=\"Figer le questionnaire\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-lock-outline\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Figer le questionnaire</div><div class=\"admin-dialog__subtitle\">Campagne {{campagne.annee}}\n</div></div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"fermerFigeage()\" aria-label=\"Fermer\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body\"><p \nclass=\"admin-dialog__message\">Le millésime devient <strong>intangible</strong>\n : chapitres, questions, conditions et focus ne bougent plus.</p><div class=\"admin-dialog__alert aeq-dialog-note\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>La campagne passera en <strong>\n« programmée »</strong>\n si ses dates sont saisies. Le questionnaire reste rechargeable jusqu\'à la première réponse d\'une officine ; au-delà, plus jamais.\n</span></div></md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermerFigeage()\" ng-disabled=\"figeage.envoi\">Annuler\n</md-button><md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" \nng-click=\"confirmerFigeage()\" ng-disabled=\"figeage.envoi\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"figeage.envoi\"></md-progress-circular><span ng-if=\"!figeage.envoi\">Figer</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-journal-popup.html","<md-dialog aria-label=\"Journal d\'une auto-évaluation\" class=\"aeq-admin qs-brevo-dialog aeq-journal-dialog\" flex=\"80\" \nflex-sm=\"90\" flex-xs=\"95\"><md-toolbar class=\"qs-brevo-dialog-toolbar\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"qs-brevo-dialog-title\" layout=\"row\" \nlayout-align=\"start center\"><span>Journal — {{journalPopup.titre}}</span></div><md-button \nclass=\"md-icon-button qs-brevo-dialog-close\" ng-click=\"fermerJournal()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"qs-brevo-dialog-content\"><p class=\"qs-brevo-dialog-intro\">\nTout ce qui est arrivé à cette auto-évaluation, du premier enregistrement à la dernière validation. Le motif d\'une réouverture est \n<b>interne</b> : il figure ici, jamais dans l\'écran de l\'officine.</p><div \nclass=\"qs-brevo-dialog-status qs-brevo-dialog-status--loading\" ng-if=\"journalPopup.chargement\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular md-diameter=\"22px\" md-mode=\"indeterminate\"></md-progress-circular>\n<span class=\"ml-10\">Lecture du journal…</span></div><div class=\"aeq-note aeq-note--info aeq-journal-dialog-vide\" \nng-if=\"!journalPopup.chargement && !journalPopup.entrees.length && !journalPopup.erreur\">\nAucun événement : cette officine n\'a pas encore touché à son auto-évaluation.</div><div \nclass=\"qs-brevo-dialog-status qs-brevo-dialog-status--empty\" ng-if=\"journalPopup.erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s22\"></md-icon><span>{{journalPopup.erreur}}</span></div><div \nclass=\"aeq-journal-dialog-table\" ng-if=\"!journalPopup.chargement && journalPopup.entrees.length\"><table \nclass=\"aeq-tbl\"><thead><tr><th>Date</th><th>Événement</th><th>Acteur</th><th>Avant</th><th>Après</th><th>Détail</th>\n</tr></thead><tbody><tr ng-repeat=\"entree in journalPopup.entrees track by $index\"><td class=\"aeq-mono\">\n{{entree.date | date:\'dd/MM/yyyy à HH:mm\'}}</td><td><b>{{entree.evenement | aeqEvenement}}</b></td><td>\n{{entree.acteur || (entree.role | aeqRoleActeur)}}</td><td>{{entree.statutAvant | aeqStatutSoumission}}</td><td>\n{{entree.statutApres | aeqStatutSoumission}}</td><td>{{entree.motif || entree.detail}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions class=\"qs-brevo-dialog-actions\" layout=\"row\" layout-align=\"end center\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"fermerJournal()\">Fermer</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-outil-popup.html","<md-dialog aria-label=\"Boîte à outils de la campagne\" class=\"qs-toolbox-dialog\" flex=\"50\" flex-sm=\"75\" flex-xs=\"95\">\n<form name=\"outilForm\" class=\"md-inline-form qs-toolbox-dialog-form\" novalidate \nng-submit=\"outilForm.$valid && enregistrerOutil()\"><md-toolbar class=\"qs-toolbox-dialog-toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"qs-toolbox-dialog-title\" layout=\"row\" layout-align=\"start center\">\n<span>{{outilPopup.edition ? \'Modifier un outil\' : \'Ajouter un outil\'}}</span></div><md-button \nclass=\"md-icon-button qs-toolbox-dialog-close\" ng-click=\"fermerOutil()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar><md-dialog-content ms-scroll \nclass=\"qs-toolbox-dialog-content\"><p class=\"qs-toolbox-dialog-intro\">\nPartagez un fichier ou un lien URL pour la campagne {{campagne.annee}}. Il apparaîtra dans la carte de l\'auto-évaluation des officines et dans l\'espace des groupements, dès que la campagne sera programmée.\n</p><div class=\"qs-toolbox-dialog-section\"><div class=\"qs-toolbox-dialog-section-title\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"qs-toolbox-dialog-section-icon\"></md-icon><span>Informations</span></div>\n<md-input-container class=\"nl-Input-container md-icon-float md-block\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nom de l\'outil<span class=\"asterix\">*</span></label><input \nclass=\"nl-Input-input\" type=\"text\" name=\"titre\" ng-model=\"outilPopup.titre\" required \nplaceholder=\"Ex : Mode opératoire 2026\"><div ng-messages=\"outilForm.titre.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><md-input-container \nclass=\"nl-Input-container md-icon-float md-block\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nLibellé du lien<span class=\"asterix\">*</span></label><input class=\"nl-Input-input\" type=\"text\" name=\"libelleLien\" \nng-model=\"outilPopup.libelleLien\" required placeholder=\"Ex : Télécharger le mode opératoire\"> <span \nclass=\"qs-toolbox-dialog-field-hint\">Texte cliquable affiché pour accéder à l\'outil.</span><div \nng-messages=\"outilForm.libelleLien.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span>\n</div></div></md-input-container></div><div class=\"qs-toolbox-dialog-section\"><div \nclass=\"qs-toolbox-dialog-section-title\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"qs-toolbox-dialog-section-icon\"></md-icon><span>Fichier ou URL{{outilPopup.edition ? \'\' : \' *\'}}</span></div>\n<div ng-if=\"outilPopup.edition && outilPopup.fichierActuel && !outilPopup.fichier\" \nclass=\"qs-toolbox-dialog-current-file\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"qs-toolbox-dialog-current-file-icon\"></md-icon><div class=\"qs-toolbox-dialog-current-file-body\"><div \nclass=\"qs-toolbox-dialog-current-file-label\">Fichier actuel</div><div class=\"qs-toolbox-dialog-current-file-name\" \ntitle=\"{{outilPopup.fichierActuel}}\">{{outilPopup.fichierActuel}}</div></div></div><div \nng-if=\"outilPopup.edition && outilPopup.urlActuelle && !outilPopup.fichier\" class=\"qs-toolbox-dialog-current-file\">\n<md-icon md-font-icon=\"icon-link-variant\" class=\"qs-toolbox-dialog-current-file-icon\"></md-icon><div \nclass=\"qs-toolbox-dialog-current-file-body\"><div class=\"qs-toolbox-dialog-current-file-label\">URL actuelle</div><div \nclass=\"qs-toolbox-dialog-current-file-name\" title=\"{{outilPopup.urlActuelle}}\">{{outilPopup.urlActuelle}}</div></div>\n</div><button type=\"button\" class=\"qs-toolbox-dialog-drop\" ng-click=\"choisirFichierOutil()\" \nng-class=\"{ \'has-file\': outilPopup.fichier, \'has-error\': outilPopup.erreur }\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"qs-toolbox-dialog-drop-icon\" ng-if=\"!outilPopup.fichier\"></md-icon><md-icon md-font-icon=\"icon-file-document\" \nclass=\"qs-toolbox-dialog-drop-icon\" ng-if=\"outilPopup.fichier\"></md-icon><div class=\"qs-toolbox-dialog-drop-body\"><div \nclass=\"qs-toolbox-dialog-drop-title\" ng-if=\"!outilPopup.fichier\">\n{{outilPopup.edition ? \'Remplacer le fichier\' : \'Sélectionner un fichier\'}}</div><div \nclass=\"qs-toolbox-dialog-drop-title\" ng-if=\"outilPopup.fichier\" title=\"{{outilPopup.fichier.name}}\">\n{{outilPopup.fichier.name}}</div><div class=\"qs-toolbox-dialog-drop-hint\" \nng-if=\"!outilPopup.fichier && !outilPopup.edition\">\nCliquez pour parcourir vos fichiers (PDF, Word, Excel, PowerPoint, image…)</div><div \nclass=\"qs-toolbox-dialog-drop-hint\" ng-if=\"!outilPopup.fichier && outilPopup.edition\">\nFacultatif — laissez vide pour conserver l\'élément actuel.</div><div class=\"qs-toolbox-dialog-drop-hint\" \nng-if=\"outilPopup.fichier\">Cliquez pour choisir un autre fichier.</div></div></button> <input type=\"file\" \nid=\"autoeval-outil-fichier\" ng-hide=\"true\" onchange=\"angular.element(this).scope().fichierOutilChoisi(this.files)\"><div\n class=\"qs-toolbox-dialog-field-hint mt-10\">ou</div><md-input-container \nclass=\"nl-Input-container md-icon-float md-block\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nURL de l\'outil</label><input class=\"nl-Input-input\" type=\"url\" name=\"url\" ng-model=\"outilPopup.url\" \nng-change=\"urlOutilModifiee()\" placeholder=\"https://exemple.com/mon-outil\"> <span class=\"qs-toolbox-dialog-field-hint\">\nFacultatif — renseignez une URL HTTP/HTTPS si vous ne déposez pas de fichier.</span></md-input-container><div \nclass=\"qs-toolbox-dialog-file-error\" ng-if=\"outilPopup.erreur\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon>\n<span>{{outilPopup.erreur}}</span></div></div></md-dialog-content><md-dialog-actions class=\"qs-toolbox-dialog-actions\" \nlayout=\"row\" layout-align=\"end center\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"fermerOutil()\" \naria-label=\"Annuler\">Annuler</button> <button type=\"submit\" class=\"nl-Btn qs-toolbox-dialog-submit\" \nng-disabled=\"outilForm.$invalid || outilPopup.envoi\" aria-label=\"Enregistrer\"><md-progress-circular md-diameter=\"15px\" \nmd-mode=\"indeterminate\" ng-if=\"outilPopup.envoi\"></md-progress-circular><span ng-if=\"!outilPopup.envoi\">\n{{outilPopup.edition ? \'Enregistrer les modifications\' : \'Ajouter l\\\'outil\'}}</span></button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-outil-suppression-popup.html","<md-dialog aria-label=\"Supprimer un outil\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--danger\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Supprimer l\'outil</div><div class=\"admin-dialog__subtitle\">\nBoîte à outils — campagne {{campagne.annee}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"fermerSuppressionOutil()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><p class=\"admin-dialog__message\">Êtes-vous sûr de vouloir supprimer \n<strong>{{suppressionOutil.outil.titre}}</strong>&nbsp;?</p><div class=\"admin-dialog__warning\" \nng-if=\"suppressionOutil.outil.fichier\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>\nLe fichier <strong>{{suppressionOutil.outil.nomFichier}}</strong>\n sera effacé du serveur : les officines et les groupements ne pourront plus le télécharger.</span></div>\n</md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermerSuppressionOutil()\" \nng-disabled=\"suppressionOutil.envoi\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--danger\" ng-click=\"confirmerSuppressionOutil()\" \nng-disabled=\"suppressionOutil.envoi\"><md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" \nng-if=\"suppressionOutil.envoi\"></md-progress-circular><md-icon ng-if=\"!suppressionOutil.envoi\" \nmd-font-icon=\"icon-trash\" class=\"s16\"></md-icon><span ng-if=\"!suppressionOutil.envoi\">Supprimer</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-recharger-popup.html","<md-dialog aria-label=\"Recharger le questionnaire livré\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Recharger le questionnaire livré</div><div class=\"admin-dialog__subtitle\">\nCampagne {{campagne.annee}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"fermerRechargement()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><p class=\"admin-dialog__message\">Le questionnaire de la campagne est \n<strong>remplacé</strong>\n par le millésime {{campagne.annee}} livré avec cette version de LQO : chapitres, questions, focus et leurs documents, et correspondance avec {{campagne.annee - 1}}.\n</p><div class=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\">\n</md-icon><span>\nAucune réponse n\'est en jeu : la campagne est en brouillon et ne porte aucune soumission. Le questionnaire rechargé reste modifiable jusqu\'à son figeage.\n</span></div></md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermerRechargement()\" ng-disabled=\"rechargement.envoi\">\nAnnuler</md-button><md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" \nng-click=\"confirmerRechargement()\" ng-disabled=\"rechargement.envoi\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"rechargement.envoi\"></md-progress-circular><span ng-if=\"!rechargement.envoi\">Recharger\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-relance-lot-popup.html","<md-dialog aria-label=\"Relancer les officines\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-email\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Relancer les officines non validées</div><div class=\"admin-dialog__subtitle\">\nCampagne {{campagne.annee}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"fermerRelanceLot()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><p class=\"admin-dialog__message\" ng-if=\"libelleGroupementFiltre()\">\nUn e-mail sera mis en file pour <strong>chaque officine non validée</strong> du groupement <strong>\n{{libelleGroupementFiltre()}}</strong>.</p><p class=\"admin-dialog__message\" ng-if=\"!libelleGroupementFiltre()\">\nUn e-mail sera mis en file pour <strong>chaque officine de la campagne</strong> qui n\'a pas validé — <strong>\ntoute la cible</strong>, sans restriction.</p><div class=\"admin-dialog__alert aeq-dialog-note\" \nng-if=\"filtres.recherche || filtres.statut\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span>La \n<strong>recherche et le filtre de statut ne s\'appliquent pas</strong>\n à la relance : seul le groupement choisi la restreint.</span></div><div class=\"admin-dialog__alert aeq-dialog-note\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>\nUne officine ne reçoit qu\'une relance par jour, même relancée deux fois. Les officines <strong>non LQO</strong>\n reçoivent leur propre relance, avec leur lien de création de mot de passe.</span></div><div \nclass=\"admin-dialog__alert aeq-dialog-note\" \nng-if=\"!relanceLot.chargement && (!relanceLot.envoyables.RELANCE || !relanceLot.envoyables.RELANCE_NON_LQO)\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span \nng-if=\"!relanceLot.envoyables.RELANCE && !relanceLot.envoyables.RELANCE_NON_LQO\"><strong>Aucune relance n\'est activée\n</strong> : aucune officine ne sera relancée. Réglez les e-mails de relance dans l\'onglet E-mails. </span><span \nng-if=\"relanceLot.envoyables.RELANCE && !relanceLot.envoyables.RELANCE_NON_LQO\">\nLa relance des officines non LQO n\'est pas activée : <strong>elles ne seront pas relancées</strong>. </span><span \nng-if=\"!relanceLot.envoyables.RELANCE && relanceLot.envoyables.RELANCE_NON_LQO\">\nLa relance des officines LQO n\'est pas activée : <strong>seules les officines non LQO seront relancées</strong>.</span>\n</div><div class=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-history\" class=\"s18\"></md-icon>\n<span><span ng-if=\"relanceLot.chargement\">Recherche de la dernière relance…</span> <span \nng-if=\"!relanceLot.chargement && relanceLot.derniere\">Dernière relance de la campagne le <strong>\n{{relanceLot.derniere | date:\'dd/MM/yyyy à HH:mm\'}}</strong>. </span><span \nng-if=\"!relanceLot.chargement && !relanceLot.derniere\">Aucune relance envoyée pour cette campagne. </span>\nLe détail par officine (date, heure, destinataires) est dans son <strong>Journal</strong>.</span></div>\n</md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermerRelanceLot()\" ng-disabled=\"relanceLot.envoi\">Annuler\n</md-button><md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" \nng-click=\"confirmerRelanceLot()\" ng-disabled=\"relanceLot.envoi\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"relanceLot.envoi\"></md-progress-circular><span ng-if=\"!relanceLot.envoi\">Relancer</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-relance-officine-popup.html","<md-dialog aria-label=\"Relancer une officine\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-email\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Relancer cette officine</div><div class=\"admin-dialog__subtitle\">{{relanceOfficine.nom}}\n</div></div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"fermerRelanceOfficine()\" \naria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content \nclass=\"admin-dialog__body\"><p class=\"admin-dialog__message\">Un e-mail de relance sera mis en file pour <strong>\n{{relanceOfficine.nom}}</strong><span ng-if=\"relanceOfficine.cip\"> (CIP {{relanceOfficine.cip}})</span>\n, dont l\'auto-évaluation est <strong>{{relanceOfficine.statut | aeqStatutSoumission}}</strong>.</p><div \nclass=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>\n<span>Il part au <strong>titulaire et au responsable qualité</strong>\n de l\'officine, comptes actifs seulement. Sans aucun des deux, rien n\'est envoyé et le journal le note.</span></div>\n<div class=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span>\nUne officine ne reçoit <strong>qu\'une relance par jour</strong>\n : relancée une seconde fois aujourd\'hui, elle ne recevra rien de plus.</span></div></md-dialog-content>\n<md-dialog-actions class=\"admin-dialog__actions\"><md-button class=\"admin-dialog__btn admin-dialog__btn--ghost\" \nng-click=\"fermerRelanceOfficine()\" ng-disabled=\"relanceOfficine.envoi\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" ng-click=\"confirmerRelanceOfficine()\" \nng-disabled=\"relanceOfficine.envoi\"><md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" \nng-if=\"relanceOfficine.envoi\"></md-progress-circular><span ng-if=\"!relanceOfficine.envoi\">Relancer</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-reouverture-popup.html","<md-dialog aria-label=\"Réouverture d\'une auto-évaluation\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-history\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Rouvrir l\'auto-évaluation</div><div class=\"admin-dialog__subtitle\">{{reouverture.nom}}\n</div></div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"fermerReouverture()\" aria-label=\"Fermer\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body\"><p \nclass=\"admin-dialog__message\">Ses réponses redeviennent modifiables, et <strong>le titulaire devra revalider</strong>\n. Tant qu\'il ne l\'a pas fait, ses derniers résultats validés restent comptés dans les agrégats.</p><md-input-container \nclass=\"nl-Input-container aeq-reouverture-motif\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Motif de la réouverture<span class=\"asterix\">*</span></label>\n<input class=\"nl-Input\" type=\"text\" ng-model=\"reouverture.motif\" ng-disabled=\"reouverture.envoi\" \nplaceholder=\"Par exemple : erreur de saisie signalée par l\'officine\"></md-input-container><div \nclass=\"admin-dialog__alert aeq-dialog-note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>\n<span>Le motif est <strong>interne</strong>\n : il est tracé au journal d\'audit, jamais montré à l\'officine. Celle-ci est prévenue par e-mail de la réouverture.\n</span></div></md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermerReouverture()\" ng-disabled=\"reouverture.envoi\">\nAnnuler</md-button><md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" \nng-click=\"confirmerReouverture()\" ng-disabled=\"reouverture.envoi || !reouverture.motif\"><md-progress-circular \nmd-diameter=\"18px\" md-mode=\"indeterminate\" ng-if=\"reouverture.envoi\"></md-progress-circular><span \nng-if=\"!reouverture.envoi\">Rouvrir</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/auto-evaluation/popup/autoeval-suppression-popup.html","<md-dialog aria-label=\"Supprimer la campagne\" class=\"aeq-admin admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--danger\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Supprimer définitivement</div><div class=\"admin-dialog__subtitle\">\nCampagne {{suppression.annee}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"fermerSuppression()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><p class=\"admin-dialog__message\">\nÊtes-vous sûr de vouloir supprimer la campagne <strong>{{suppression.annee}}</strong>, encore en brouillon&nbsp;?</p>\n<div class=\"admin-dialog__warning\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>Le \n<strong>questionnaire chargé</strong> et la <strong>cible figée</strong>\n seront supprimés avec elle. Les données ne pourront plus être récupérées.</span></div></md-dialog-content>\n<md-dialog-actions class=\"admin-dialog__actions\"><md-button class=\"admin-dialog__btn admin-dialog__btn--ghost\" \nng-click=\"fermerSuppression()\" ng-disabled=\"suppression.envoi\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--danger\" ng-click=\"confirmerSuppression()\" \nng-disabled=\"suppression.envoi\"><md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" \nng-if=\"suppression.envoi\"></md-progress-circular><md-icon ng-if=\"!suppression.envoi\" md-font-icon=\"icon-trash\" \nclass=\"s16\"></md-icon><span ng-if=\"!suppression.envoi\">Supprimer</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/bandeau/popup/add_bandeau.html","<md-dialog aria-label=\"addBandeau\" flex=\"40\"><form name=\"addBandeauForm\" class=\"md-inline-form\" novalidate \nng-submit=\"addBandeauForm.$valid && saveBandeau()\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-30\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">{{titlePopupSave}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Message<span \nng-if=\"newBandeau.message == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"message\" \nng-model=\"newBandeau.message\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addBandeauForm.message.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Contrat</label><div flex flex-sm=\"100\"><md-select \nname=\"contract\" ng-model-options=\"{trackBy: \'$value\'}\" style=\"margin:0\" ng-model=\"pharmacy.contractType\" \nplaceholder=\"Type\" required><md-select-header class=\"nl-Input-select-header\">Choisir le type de contrat\n</md-select-header><md-option ng-value=\"all\">Toutes</md-option><md-option ng-repeat=\"contractType in contractTypes\" \nng-value=\"contractType.name\">{{contractType.displayName}}</md-option></md-select></div><div class=\"md-errors-spacer\">\n</div></md-input-container><div flex=\"100\" ng-if=\"!customDurationMode\"><md-input-container class=\"nl-Input-container\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">Durée d\'affichage</label><md-select \nng-model=\"newBandeau.duration\" required name=\"duration\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-select-header class=\"nl-Input-select-header\">Sélectionnez la durée\n</md-select-header><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"duration in durations\" \nng-value=\"duration.value\">{{duration.name}}</md-option></md-select><div ng-messages=\"addBandeauForm.duration.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div><div \nclass=\"mt-20\" flex=\"100\" ng-if=\"customDurationMode\"><md-input-container class=\"nl-Input-container\" flex=\"20\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Durée<span ng-if=\"customDuration.number == null\" \nclass=\"asterix\">*</span></label><input type=\"number\" min=\"1\" name=\"customDurationNbr\" ng-model=\"customDuration.number\" \nplaceholder=\"\" class=\"nl-Input-input\" required><div ng-messages=\"addBandeauForm.customDurationNbr.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Information requise</span></div><div ng-message=\"min\"><span>\nLa durée doit être minimum de 1</span></div></div></md-input-container><md-input-container flex=\"50\" \nclass=\"nl-Input-container\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Durée d\'affichage</label>\n<md-select ng-model=\"customDuration.ms\" required name=\"customDurationMS\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-select-header class=\"nl-Input-select-header\">Sélectionnez la durée\n</md-select-header><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"duration in customDurations\" \nng-value=\"duration.value\">{{duration.name}}</md-option></md-select><div \nng-messages=\"addBandeauForm.customDurationMS.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div><div class=\"mt-20\" layout=\"row\" layout-align=\"center center\"><button \nclass=\"nl-Btn\" ng-click=\"setCustomDurationMode()\"><span ng-if=\"!customDurationMode\">Durée personnalisée</span> <span \nng-if=\"customDurationMode\">Durée par défaut</span></button></div></div></md-dialog-content><md-dialog-actions><button \nng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin/bandeau/popup/delete_bandeau.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\">Suppression du message</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Êtes-vous sûr de vouloir supprimer ce message ?</md-dialog-content><md-dialog-actions layout=\"row\">\n<button class=\"nl-Btn\" ng-click=\"delete()\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/bandeau/popup/display_bandeau.html","<md-dialog aria-label=\"Bandeau (accueil)\" class=\"nl_dialog nl_mw\"><md-toolbar layout=\"column\"><div layout=\"row\" \nclass=\"pt-15\" layout-align=\"space-between center\"><div class=\"flex-10\"></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\">Affichage du bandeau</div><md-button class=\"md-icon-button flex-10\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"mb-10\" layout=\"row\" layout-align=\"center center\"><div style=\"font-size: 1.1rem\">\nDate de début: {{bandeauToDisplay.dateDebut | date: \'dd/MM/yyyy\'}} -</div><div style=\"font-size: 1.1rem\">\nDate de fin: {{bandeauToDisplay.dateFin | date: \'dd/MM/yyyy\'}}</div></div></md-toolbar><md-dialog-content \nstyle=\"white-space: pre-wrap\">{{bandeauToDisplay.message}}</md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn\" ng-click=\"hidePopup()\">OK</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/campagne/popup/configuration-campagne-brevo-template-popup.html","<md-dialog aria-label=\"Sélection template Brevo\" class=\"qs-brevo-dialog\" flex=\"60\" flex-sm=\"85\" flex-xs=\"95\"><form \nclass=\"md-inline-form qs-brevo-dialog-form\" novalidate ng-submit=\"confirmBrevoTemplateSelection()\"><md-toolbar \nclass=\"qs-brevo-dialog-toolbar\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"qs-brevo-dialog-title\" layout=\"row\" layout-align=\"start center\"><span>\n{{templatePopup.title}}</span></div><md-button class=\"md-icon-button qs-brevo-dialog-close\" \nng-click=\"closeBrevoTemplatePopup()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll class=\"qs-brevo-dialog-content\"><p class=\"qs-brevo-dialog-intro\">\n{{templatePopup.intro}}</p><div class=\"qs-brevo-dialog-hint\"><md-icon class=\"qs-brevo-dialog-hint-icon\" \nmd-font-icon=\"icon-information-outline\"></md-icon><div><div class=\"qs-brevo-dialog-hint-title\">\nClés obligatoires dans le template</div><div class=\"qs-brevo-dialog-hint-keys\"><code \nng-repeat=\"requiredKey in templatePopup.requiredKeys track by requiredKey\">{{requiredKey}}</code></div></div></div><div\n class=\"qs-brevo-dialog-hint mt-16\" ng-if=\"templatePopup.helpKeys && templatePopup.helpKeys.length\"><md-icon \nclass=\"qs-brevo-dialog-hint-icon\" md-font-icon=\"icon-information-outline\"></md-icon><div><div \nclass=\"qs-brevo-dialog-hint-title\">Variables utiles</div><div class=\"qs-brevo-dialog-hint-keys\"><code \nng-repeat=\"helpKey in templatePopup.helpKeys track by helpKey\">{{helpKey}}</code></div></div></div><md-input-container \nclass=\"nl-Input-container qs-brevo-dialog-select\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Template Brevo<span class=\"asterix\">*</span></label><md-select \nng-model=\"templatePopup.selectedTemplateId\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown qs-brevo-dialog-dropdown\" ng-disabled=\"templatePopup.loading\" \nplaceholder=\"Choisir un template…\"><md-select-header class=\"nl-Input-select-header\"><input type=\"search\" \nng-model=\"templatePopup.searchText\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Rechercher un template\" \nclass=\"md-text\"></md-select-header><md-option \nng-repeat=\"template in templatePopup.templates | filter:templatePopup.searchText track by template.id\" \nng-value=\"template.id\" class=\"nl-Select-dropdown-btn\">{{template.name}}</md-option></md-select></md-input-container>\n<div class=\"qs-brevo-dialog-status qs-brevo-dialog-status--loading\" ng-if=\"templatePopup.loading\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular md-diameter=\"22px\" md-mode=\"indeterminate\"></md-progress-circular>\n<span class=\"ml-10\">Chargement des templates Brevo…</span></div><div \nclass=\"qs-brevo-dialog-status qs-brevo-dialog-status--empty\" \nng-if=\"!templatePopup.loading && !templatePopup.templates.length\"><md-icon md-font-icon=\"icon-alert-outline\" \nclass=\"s22\"></md-icon><span>Aucun template Brevo actif n\'a été trouvé côté Brevo.</span></div></md-dialog-content>\n<md-dialog-actions class=\"qs-brevo-dialog-actions\" layout=\"row\" layout-align=\"end center\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"closeBrevoTemplatePopup()\">Annuler</button> <button type=\"submit\" \nclass=\"nl-Btn qs-brevo-dialog-submit\" \nng-disabled=\"templatePopup.loading || templatePopup.submitting || !templatePopup.selectedTemplateId\">\n<md-progress-circular md-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"templatePopup.submitting\">\n</md-progress-circular><span ng-if=\"!templatePopup.submitting\">Valider la sélection</span></button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin/groupements/detail/groupement-detail.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page admin-grp-page\"><div \nclass=\"header md-accent-bg admin-grp-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg admin-grp-header__title-group\"><div class=\"admin-grp-breadcrumb\" ng-click=\"retour()\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon><span>Groupements</span></div><div \nclass=\"h1 admin-grp-header__title\"><span>{{groupement.name || \'Groupement\'}}</span></div><div \nclass=\"admin-grp-header__subtitle\" ng-if=\"groupement\">\n{{groupement.nbPharmacies === null ? \'Nombre d\\\'officines indisponible\' : groupement.nbPharmacies + \' officines\'}} · {{groupement.acces.length}} accès · {{nbResponsables()}} responsable(s)\n</div></div></div><div class=\"content admin-grp-content\"><div class=\"admin-grp-loading\" ng-if=\"loading\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"></md-progress-circular><span>Chargement…</span></div>\n<div ng-if=\"!loading && groupement\"><div class=\"admin-grp-card admin-grp-card--form\"><div \nclass=\"admin-grp-card__title\"><md-icon md-font-icon=\"icon-account-plus\" class=\"s20\"></md-icon><span>\nDonner accès à une personne</span></div><div class=\"admin-grp-form\"><div class=\"admin-grp-field\"><label>Adresse e-mail\n</label><input type=\"email\" placeholder=\"prenom.nom@reseau.fr\" ng-model=\"formulaire.mail\" \nng-keypress=\"$event.which === 13 && ajouter()\"></div><div class=\"admin-grp-field\"><label>Niveau</label><md-select \nng-model=\"formulaire.niveau\" class=\"md-no-underline\" aria-label=\"Niveau\"><md-option ng-repeat=\"niveau in niveaux\" \nvalue=\"{{niveau.valeur}}\">{{niveau.libelle}}</md-option></md-select></div><button type=\"button\" \nclass=\"admin-grp-btn admin-grp-btn--primary\" ng-disabled=\"!formulaire.mail || traitement\" ng-click=\"ajouter()\"><md-icon\n md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><span>Ajouter</span></button></div><div class=\"admin-grp-form__hint\">\nLe responsable consulte et écrit (coordonnées, documents). La consultation lit tout et peut commenter. Si le compte n\'existe pas encore, une invitation part automatiquement.\n</div></div><div class=\"admin-grp-card\"><div class=\"admin-grp-card__title\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"s20\"></md-icon><span>Personnes ayant accès ({{groupement.acces.length}})\n</span></div><div class=\"admin-grp-empty\" ng-if=\"!groupement.acces.length\">Personne n\'a encore accès à ce groupement.\n</div><table class=\"admin-grp-table\" ng-if=\"groupement.acces.length\"><thead><tr><th>Personne</th><th>Niveau</th><th>\nÉtat</th><th class=\"admin-grp-table__right\">Actions</th></tr></thead><tbody><tr ng-repeat=\"acces in groupement.acces\" \nclass=\"admin-grp-row admin-grp-row--static\"><td><div ng-if=\"!enEdition(acces)\"><div class=\"admin-grp-name\">\n{{acces.nom || acces.mail}}</div><div class=\"admin-grp-sub\" ng-if=\"acces.nom\">{{acces.mail}}</div></div><div \nng-if=\"enEdition(acces)\"><input type=\"email\" class=\"admin-grp-inline-input\" ng-model=\"edition.mail\" \naria-label=\"Adresse électronique\" placeholder=\"prenom.nom@exemple.fr\"><div class=\"admin-grp-avertissement\" \nng-if=\"avertissementMail(acces)\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span>\n{{avertissementMail(acces)}}</span></div></div></td><td><span ng-if=\"!enEdition(acces)\" class=\"admin-grp-chip\" \nng-class=\"acces.niveau === \'RESPONSABLE\' ? \'admin-grp-chip--ok\' : \'admin-grp-chip--muted\'\">\n{{libelleNiveau(acces.niveau)}}</span><md-select ng-if=\"enEdition(acces)\" ng-model=\"edition.niveau\" \nclass=\"md-no-underline admin-grp-inline-select\" aria-label=\"Niveau\"><md-option ng-repeat=\"niveau in niveaux\" \nvalue=\"{{niveau.valeur}}\">{{niveau.libelle}}</md-option></md-select></td><td><span \nclass=\"admin-grp-chip admin-grp-chip--ok\" ng-if=\"acces.invitationAcceptee\">Compte actif</span> <span \nclass=\"admin-grp-chip admin-grp-chip--warn\" ng-if=\"!acces.invitationAcceptee\">Invitation en attente</span></td><td \nclass=\"admin-grp-table__right\"><div class=\"admin-grp-actions\" ng-if=\"!enEdition(acces)\"><button type=\"button\" \nclass=\"admin-grp-btn admin-grp-btn--ghost\" ng-if=\"!acces.invitationAcceptee\" ng-click=\"renvoyerInvitation(acces)\">\n<md-icon md-font-icon=\"icon-email\" class=\"s18\"></md-icon><span>Relancer</span></button> <button type=\"button\" \nclass=\"admin-grp-btn admin-grp-btn--ghost\" ng-click=\"ouvrirEdition(acces)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18\"></md-icon><span>Modifier</span></button> <button type=\"button\" class=\"admin-grp-btn admin-grp-btn--danger\" \nng-click=\"retirer(acces, $event)\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><span>Retirer</span>\n</button></div><div class=\"admin-grp-actions\" ng-if=\"enEdition(acces)\"><button type=\"button\" \nclass=\"admin-grp-btn admin-grp-btn--ghost\" ng-click=\"annulerEdition()\">Annuler</button> <button type=\"button\" \nclass=\"admin-grp-btn admin-grp-btn--primary\" ng-disabled=\"traitement\" ng-click=\"enregistrerEdition(acces)\">Enregistrer\n</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/groupements/popup/groupement_dialog.html","<md-dialog aria-label=\"Groupement\" class=\"admin-dialog admin-dialog--form admin-dialog--compact\" flex=\"40\" \nflex-sm=\"60\" flex-xs=\"90\"><form name=\"groupementForm\" class=\"md-inline-form\" novalidate \nng-submit=\"groupementForm.$valid && saveGroupement()\"><div class=\"admin-dialog__header admin-dialog__header--primary\">\n<div class=\"admin-dialog__icon-badge\"><md-icon md-font-icon=\"icon-account-key\" class=\"s32\"></md-icon></div><div \nclass=\"admin-dialog__heading\"><div class=\"admin-dialog__title\">Responsable du groupement</div><div \nclass=\"admin-dialog__subtitle\">{{groupement.name}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><div class=\"admin-dialog__info-banner\" \nng-if=\"groupement.responsableMail\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nModifier l\'email responsable remplacera l\'accès du responsable actuel.</span></div><md-input-container \nclass=\"nl-Input-container md-icon-float md-block\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nEmail responsable<span class=\"asterix\">*</span></label><input class=\"nl-Input-input\" type=\"email\" \nname=\"responsableMail\" ng-model=\"groupement.responsableMail\" required><div \nng-messages=\"groupementForm.responsableMail.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div><div ng-message=\"email\"><span>Mauvais format.</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"admin-dialog__actions\"><md-button type=\"button\" ng-click=\"hidePopup()\" \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" aria-label=\"Annuler\">Annuler</md-button><md-button type=\"submit\" \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--primary-blue\" \nng-disabled=\"groupementForm.$invalid || loadingSave\" aria-label=\"Sauvegarder\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"loadingSave\"></md-progress-circular><md-icon ng-if=\"!loadingSave\" \nmd-font-icon=\"icon-content-save\" class=\"s16\"></md-icon><span ng-if=\"!loadingSave\">Sauvegarder</span></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_change_status.html","<md-dialog aria-label=\"Changer le type de contrat\" class=\"admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--warn\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-swap-horizontal\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Changer le type de contrat</div><div class=\"admin-dialog__subtitle\">{{pharmacy.name}}</div>\n</div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"cancelPopup()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body\"><p \nclass=\"admin-dialog__message\">Êtes-vous sûr de vouloir changer le type de contrat de <strong>{{pharmacy.name}}</strong>\n&nbsp;?</p></md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"cancelPopup()\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--warn\" ng-click=\"hidePopup(\'true\')\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><span>Confirmer</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_confirm.html","<md-dialog aria-label=\"Activation - Désactivation\" class=\"admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--{{pharmacy.isActivated ? \'warn\' : \'info\'}}\"><div \nclass=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"{{pharmacy.isActivated ? \'icon-pause-circle-outline\' : \'icon-play-circle-outline\'}}\" class=\"s32\">\n</md-icon></div><div class=\"admin-dialog__heading\"><div class=\"admin-dialog__title\">\n{{pharmacy.isActivated ? \'Désactiver\' : \'Activer\'}} la pharmacie</div><div class=\"admin-dialog__subtitle\">\n{{pharmacy.name}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content \nclass=\"admin-dialog__body\"><p class=\"admin-dialog__message\">Êtes-vous sûr de vouloir <strong>\n{{pharmacy.isActivated ? \'désactiver\' : \'activer\'}}</strong> cette pharmacie&nbsp;?</p><div \nclass=\"admin-dialog__option\" ng-show=\"pharmacy.isActivated\"><md-checkbox ng-model=\"getZip\" \nclass=\"admin-dialog__checkbox\">Télécharger un zip contenant les données de la pharmacie</md-checkbox></div>\n</md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"hidePopup()\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--{{pharmacy.isActivated ? \'warn\' : \'success\'}}\" \nng-click=\"setActivated(pharmacy, !pharmacy.isActivated, getZip)\"><md-icon \nmd-font-icon=\"{{pharmacy.isActivated ? \'icon-pause\' : \'icon-check\'}}\" class=\"s16\"></md-icon><span>\n{{pharmacy.isActivated ? \'Désactiver\' : \'Activer\'}}</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_delete_confirm.html","<md-dialog aria-label=\"Suppression\" class=\"admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--danger\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-alert-circle-outline\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Supprimer définitivement</div><div class=\"admin-dialog__subtitle\">{{pharmacy.name}}</div>\n</div><md-button class=\"md-icon-button admin-dialog__close\" ng-click=\"hidePopup()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body\"><p \nclass=\"admin-dialog__message\">Êtes-vous sûr de vouloir supprimer la pharmacie <strong>«&nbsp;{{pharmacy.name}}&nbsp;»\n</strong> définitivement&nbsp;?</p><div class=\"admin-dialog__warning\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s18\"></md-icon><span>Une fois supprimée, les données ne pourront plus être récupérées.</span></div>\n</md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"hidePopup()\" ng-disabled=\"loading\">Annuler</md-button>\n<md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--danger\" \nng-click=\"deletePermanently(pharmacy)\" ng-disabled=\"loading\"><md-progress-circular md-diameter=\"18px\" \nmd-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular><md-icon ng-if=\"!loading\" md-font-icon=\"icon-trash\" \nclass=\"s16\"></md-icon><span ng-if=\"!loading\">Supprimer</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_dialog.html","<md-dialog aria-label=\"Pharmacie\" class=\"admin-dialog admin-dialog--form\" flex=\"40\" flex-sm=\"60\" flex-xs=\"80\"><form \nname=\"createPharmacyForm\" class=\"md-inline-form\" novalidate><div \nclass=\"admin-dialog__header admin-dialog__header--primary\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"{{editMode ? \'icon-pencil\' : \'icon-plus\'}}\" class=\"s32\"></md-icon></div><div \nclass=\"admin-dialog__heading\"><div class=\"admin-dialog__title\">{{editMode ? \'Modifier\' : \'Créer\'}} une pharmacie</div>\n<div class=\"admin-dialog__subtitle\" ng-if=\"editMode\">{{pharmacy.name}}</div><div class=\"admin-dialog__subtitle\" \nng-if=\"!editMode\">Renseignez les informations ci-dessous</div></div><md-button \nclass=\"md-icon-button admin-dialog__close\" ng-click=\"hidePopup()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-dialog-content \nclass=\"admin-dialog__body admin-dialog__body--form\" ms-scroll><div class=\"admin-dialog-section\"><div \nclass=\"admin-dialog-section__title\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nIdentité de la pharmacie</span></div><md-input-container class=\"nl-Input-container md-icon-float md-block\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nom<span ng-if=\"pharmacy.name == null\" class=\"asterix\">*</span>\n</label><input class=\"nl-Input-input\" type=\"text\" name=\"name\" ng-model=\"pharmacy.name\" required><div \nng-messages=\"createPharmacyForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container md-icon-float md-block\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Contrat</label><div flex flex-sm=\"100\"><md-select \nng-model-options=\"{trackBy: \'$value\'}\" style=\"margin:0\" ng-focus=\"setContractTypeBefore(true)\" \nng-change=\"editMode ? changeContractType(pharmacy) : \'\'\" ng-model=\"pharmacy.contractType\" \nng-disabled=\"!editMode && type != \'all\'\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\" required><md-select-header class=\"nl-Input-select-header\">\nChoisir le type de contrat</md-select-header><md-option ng-repeat=\"contractType in contractTypes\" \nng-if=\"contractType.name !== \'OSYS\' || pharmacy.contractType === \'OSYS\'\" ng-value=\"contractType.name\" \nclass=\"nl-Select-dropdown-btn\">{{contractType.displayName}}</md-option></md-select></div><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"mb-10\" ng-if=\"editMode && pharmacy.contractType === \'NON_LQO\'\"><md-button \ntype=\"button\" class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--primary-blue\" \nng-click=\"activateLqo(pharmacy)\" ng-disabled=\"loadingSave\">Activer LQO</md-button></div><md-input-container \nclass=\"nl-Input-container md-icon-float md-block md-input-has-value\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Numéro d\'identification<span \nng-if=\"pharmacy.numIdentification == null\" class=\"asterix\">*</span></label><input class=\"nl-Input-input\" type=\"text\" \nname=\"numIdentification\" ng-model=\"pharmacy.numIdentification\" required><div \nng-messages=\"createPharmacyForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span>\n</div></div><div ng-messages=\"error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"numidentification\"><span>\nCe numéro d\'identification n\'est pas disponible</span></div></div></md-input-container></div><div \nclass=\"admin-dialog-section\"><div class=\"admin-dialog-section__title\"><md-icon md-font-icon=\"icon-account-outline\" \nclass=\"s16\"></md-icon><span>Comptes utilisateurs</span></div><div class=\"admin-dialog-field\"><div \nclass=\"admin-dialog-field__label\"><span class=\"admin-dialog-field__role admin-dialog-field__role--titulaire\">Titulaire\n</span></div><div class=\"admin-dialog-field__row\" layout=\"row\" layout-align=\"space-between center\"><md-input-container \nflex=\"80\" class=\"nl-Input-container md-icon-float md-block md-input-has-value\" \nng-class=\"{\'md-input-invalid\': error.titulaire}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nEmail du titulaire<span ng-if=\"pharmacy.titulaire.mail == null\" class=\"asterix\">*</span></label><input \nclass=\"nl-Input-input\" type=\"email\" name=\"titulaireMail\" ng-model=\"pharmacy.titulaire.mail\" \nng-change=\"changingEmail(\'TITULAIRE\',pharmacy.titulaire.mail,createPharmacyForm)\" required><div \nng-messages=\"createPharmacyForm.titulaireMail.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div><div ng-message=\"email\"><span>Mauvais format</span></div></div><div \nng-messages=\"error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"titulaire\"><span>Email non disponible</span>\n</div></div><div ng-messages=\"error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"sameemailtitulaire\" \nng-if=\"pharmacy.titulaire.mail && pharmacy.praq.mail && pharmacy.titulaire.mail == pharmacy.praq.mail\"><span>\nVous avez mis le même email que le Responsable Qualité</span></div><div ng-message=\"sameemailtitulaire\" \nng-if=\"pharmacy.titulaire.mail && pharmacy.team.mail && pharmacy.titulaire.mail == pharmacy.team.mail\"><span>\nVous avez mis le même email que l\'Équipe</span></div></div></md-input-container><div \nclass=\"admin-dialog-field__actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"editMode && pharmacy.isActivated\" ng-disabled=\"mailsSent.titulaire || !pharmacy.titulaire.mail\" \nclass=\"admin-dialog-field__btn\" ng-click=\"resentActivationEmail(pharmacy, \'titulaire\')\"><md-icon \nng-if=\"!mailsSent.titulaire\" md-svg-src=\"assets/icons/app/admin/mail.svg\"></md-icon><md-icon \nng-if=\"mailsSent.titulaire\" md-svg-src=\"assets/icons/app/admin/check_white.svg\"></md-icon><md-tooltip \nmd-direction=\"top\">Renvoyer le mail d\'activation</md-tooltip></md-button><md-button \nng-if=\"editMode && pharmacy.isActivated\" ng-disabled=\"!pharmacy.titulaire.mail\" class=\"admin-dialog-field__btn\" \nng-click=\"openURLtoCopy(pharmacy, \'titulaire\', createPharmacyForm);\"><md-icon md-font-icon=\"icon-link-variant\">\n</md-icon><md-tooltip md-direction=\"top\">Lien d\'activation</md-tooltip></md-button></div></div><div \nclass=\"admin-dialog-field__hint\" ng-if=\"editMode && pharmacy.isActivated && urlValidation.titulaire\"><md-icon \nmd-font-icon=\"icon-link\" class=\"s14\"></md-icon><span>{{urlValidation.titulaire}}</span></div></div><div \nclass=\"admin-dialog-field\"><div class=\"admin-dialog-field__label\"><span \nclass=\"admin-dialog-field__role admin-dialog-field__role--team\">Équipe</span></div><div \nclass=\"admin-dialog-field__row\" layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"80\" \nclass=\"nl-Input-container md-icon-float md-block\" ng-class=\"{\'md-input-invalid\': error.team}\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Email de l\'équipe</label><input class=\"nl-Input-input\" \ntype=\"email\" name=\"teamMail\" ng-model=\"pharmacy.team.mail\" \nng-change=\"changingEmail(\'TEAM\',pharmacy.team.mail,createPharmacyForm)\"><div \nng-messages=\"createPharmacyForm.teamMail.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div><div ng-message=\"email\"><span>Mauvais format</span></div></div><div ng-messages=\"error\" role=\"alert\"><div \nng-message=\"team\"><span>Email non disponible</span></div></div><div ng-messages=\"error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"sameemailteam\" \nng-if=\"pharmacy.team.mail && pharmacy.praq.mail && pharmacy.team.mail != \'\' && pharmacy.praq.mail != \'\' && pharmacy.team.mail == pharmacy.praq.mail\">\n<span>Vous avez mis le même email que le Responsable Qualité</span></div><div ng-message=\"sameemailteam\" \nng-if=\"pharmacy.team.mail != \'\' && pharmacy.titulaire.mail != \'\' && pharmacy.team.mail == pharmacy.titulaire.mail\">\n<span>Vous avez mis le même email que le Titulaire</span></div></div></md-input-container><div \nclass=\"admin-dialog-field__actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"editMode && pharmacy.isActivated\" ng-disabled=\"mailsSent.equipe || !pharmacy.team.mail\" \nclass=\"admin-dialog-field__btn\" ng-click=\"resentActivationEmail(pharmacy, \'equipe\')\"><md-icon \nng-if=\"!mailsSent.equipe\" md-svg-src=\"assets/icons/app/admin/mail.svg\"></md-icon><md-icon ng-if=\"mailsSent.equipe\" \nmd-svg-src=\"assets/icons/app/admin/check_white.svg\"></md-icon><md-tooltip md-direction=\"top\">\nRenvoyer le mail d\'activation</md-tooltip></md-button><md-button ng-if=\"editMode && pharmacy.isActivated\" \nng-disabled=\"!pharmacy.team.mail\" class=\"admin-dialog-field__btn\" \nng-click=\"openURLtoCopy(pharmacy, \'equipe\', createPharmacyForm)\"><md-icon md-font-icon=\"icon-link-variant\"></md-icon>\n<md-tooltip md-direction=\"top\">Lien d\'activation</md-tooltip></md-button></div></div><div \nclass=\"admin-dialog-field__hint\" ng-if=\"editMode && pharmacy.isActivated && urlValidation.equipe\"><md-icon \nmd-font-icon=\"icon-link\" class=\"s14\"></md-icon><span>{{urlValidation.equipe}}</span></div></div><div \nclass=\"admin-dialog-field\"><div class=\"admin-dialog-field__label\"><span \nclass=\"admin-dialog-field__role admin-dialog-field__role--praq\">Responsable Qualité</span></div><div \nclass=\"admin-dialog-field__row\" layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"80\" \nclass=\"nl-Input-container md-icon-float md-block md-input-has-value\" ng-class=\"{\'md-input-invalid\': error.praq}\"><label\n class=\"nl-Input-label md-no-float md-container-ignore\">Email du Responsable Qualité</label><input \nclass=\"nl-Input-input\" type=\"email\" name=\"praqMail\" \nng-change=\"changingEmail(\'PRAQ\',pharmacy.praq.mail,createPharmacyForm)\" ng-model=\"pharmacy.praq.mail\"><div \nng-messages=\"createPharmacyForm.praqMail.$error\" role=\"alert\"><div ng-message=\"email\"><span>Mauvais format</span></div>\n</div><div ng-messages=\"error\" role=\"alert\"><div ng-message=\"praq\"><span>Email non disponible</span></div></div><div \nng-messages=\"error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"sameemailpraq\" \nng-if=\"pharmacy.praq.mail && pharmacy.titulaire.mail && pharmacy.praq.mail!=\'\' && pharmacy.titulaire.mail!=\'\' && pharmacy.praq.mail == pharmacy.titulaire.mail\">\n<span>Vous avez mis le même email que le Titulaire</span></div><div ng-message=\"sameemailpraq\" \nng-if=\"pharmacy.praq.mail && pharmacy.team.mail && pharmacy.praq.mail!=\'\' && pharmacy.team.mail!=\'\' && pharmacy.praq.mail == pharmacy.team.mail\">\n<span>Vous avez mis le même email que l\'Équipe</span></div></div></md-input-container><div \nclass=\"admin-dialog-field__actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"editMode && pharmacy.isActivated\" ng-disabled=\"mailsSent.praq || !pharmacy.praq.mail\" \nclass=\"admin-dialog-field__btn\" ng-click=\"resentActivationEmail(pharmacy, \'praq\')\"><md-icon ng-if=\"!mailsSent.praq\" \nmd-svg-src=\"assets/icons/app/admin/mail.svg\"></md-icon><md-icon ng-if=\"mailsSent.praq\" \nmd-svg-src=\"assets/icons/app/admin/check_white.svg\"></md-icon><md-tooltip md-direction=\"top\">\nRenvoyer le mail d\'activation</md-tooltip></md-button><md-button ng-if=\"editMode && pharmacy.isActivated\" \nng-disabled=\"!pharmacy.praq.mail\" class=\"admin-dialog-field__btn\" \nng-click=\"openURLtoCopy(pharmacy, \'praq\', createPharmacyForm)\"><md-icon md-font-icon=\"icon-link-variant\"></md-icon>\n<md-tooltip md-direction=\"top\">Lien d\'activation</md-tooltip></md-button></div></div><div \nclass=\"admin-dialog-field__hint\" ng-if=\"editMode && pharmacy.isActivated && urlValidation.praq\"><md-icon \nmd-font-icon=\"icon-link\" class=\"s14\"></md-icon><span>{{urlValidation.praq}}</span></div></div></div><div \nclass=\"admin-dialog-section\" ng-if=\"editMode\"><div class=\"admin-dialog-section__title\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s16\"></md-icon><span>Paramètres administratifs</span></div><div \nclass=\"admin-dialog__option\"><md-checkbox ng-model=\"pharmacy.testPharmacy\" class=\"admin-dialog__checkbox\" \nng-change=\"syncTestPharmacyState()\">Pharmacie de test</md-checkbox></div><div class=\"admin-dialog__option\" \nng-class=\"{ \'admin-dialog__option--disabled\': !pharmacy.testPharmacy }\"><md-checkbox \nng-model=\"pharmacy.engageQualiteForced\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"admin-dialog__checkbox\" \nng-disabled=\"!pharmacy.testPharmacy\">Engagée Qualité (forcée)</md-checkbox></div></div></md-dialog-content>\n<md-dialog-actions class=\"admin-dialog__actions admin-dialog__actions--form\"><md-button type=\"button\" \nng-click=\"showConfirm()\" class=\"admin-dialog__btn admin-dialog__btn--ghost admin-dialog__btn--danger-text\" \naria-label=\"Désactiver la pharmacie\" ng-if=\"editMode\"><md-icon \nmd-font-icon=\"{{pharmacy.isActivated ? \'icon-pause\' : \'icon-play\'}}\" class=\"s16\"></md-icon><span>\n{{pharmacy.isActivated ? \'Désactiver\' : \'Activer\'}} la pharmacie</span></md-button><span flex></span><md-button \ntype=\"button\" ng-click=\"hidePopup()\" class=\"admin-dialog__btn admin-dialog__btn--ghost\">Annuler</md-button><md-button \ntype=\"submit\" ng-click=\"savePharmacy(false,null,null,false,true)\" \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--primary-blue\" \nng-disabled=\"createPharmacyForm.$invalid || createPharmacyForm.$pristine || loadingSave\" aria-label=\"Sauvegarder\">\n<md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" ng-if=\"loadingSave\"></md-progress-circular><md-icon \nng-if=\"!loadingSave\" md-font-icon=\"icon-content-save\" class=\"s16\"></md-icon><span ng-if=\"!loadingSave\">Sauvegarder\n</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_groupement_import.html","<md-dialog aria-label=\"Import groupement/pharmacie\" flex=\"50\" flex-sm=\"80\" flex-xs=\"95\"><md-toolbar layout=\"column\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"contact-name pt-10\">Mettre à jour l\'association groupement/pharmacie</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"mb-16\">\nColonnes attendues dans le fichier :<ul style=\"margin: 8px 0 0 0\"><li>CIP</li><li>Nom du groupement</li></ul></div>\n<md-input-container class=\"iv-Input-container no--errors-spacer\"><button class=\"iv-Btn iv-Btn--file\" type=\"button\" \nng-click=\"openJoindreFile()\" style=\"width: 100%; justify-content: flex-start; border: 0\"><div class=\"iv-Btn__file\">\n</div><md-icon class=\"m-0\" md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter un fichier d\'import\n</div></button></md-input-container><input type=\"file\" id=\"groupement-association-input\" ng-hide=\"true\" \naccept=\".xls,.xlsx\"><div class=\"md-warn\" ng-if=\"groupementImport.error\" style=\"color: rgb(213, 0, 0); font-size: 12px\">\n{{groupementImport.error}}</div><div ng-if=\"groupementImport.result\" class=\"mt-16\"><div><b>\nLignes traitées avec succès :</b> {{groupementImport.result.successCount || 0}}</div><div class=\"mt-12\"><b>\nLignes en erreur :</b> {{(groupementImport.result.errors || []).length}}</div><table \nclass=\"dataTable row-border hover mt-12\" ng-if=\"(groupementImport.result.errors || []).length\"><thead><tr><th>Ligne\n</th><th>CIP</th><th>Motif</th></tr></thead><tbody><tr ng-repeat=\"error in groupementImport.result.errors\"><td>\n{{error.lineNumber}}</td><td>{{error.cip || \'-\'}}</td><td>{{error.reason}}</td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions><md-button class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Fermer\n</md-button><md-button class=\"nl-Btn\" ng-if=\"!groupementImport.result\" ng-click=\"importGroupementAssociations()\" \nng-disabled=\"groupementImport.loading\"><md-progress-circular md-diameter=\"15px\" md-mode=\"indeterminate\" \nng-if=\"groupementImport.loading\"></md-progress-circular><span ng-if=\"!groupementImport.loading\">Importer</span>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/popup/pharmacy_rattachement_confirm.html","<md-dialog aria-label=\"Rattacher un compte existant\" class=\"admin-dialog admin-dialog--confirm\"><div \nclass=\"admin-dialog__header admin-dialog__header--primary\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"s32\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Rattacher un compte existant</div><div class=\"admin-dialog__subtitle\">\n{{rattachement.compteMail}}</div></div><md-button class=\"md-icon-button admin-dialog__close\" \nng-click=\"annulerRattachement()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-dialog-content class=\"admin-dialog__body\"><p class=\"admin-dialog__message\">Cette adresse appartient déjà au compte \n<strong>«&nbsp;{{rattachement.compteNom}}&nbsp;»</strong>, qui n\'est rattaché à aucune officine. Le rattacher comme \n<strong>{{rattachement.libelleRole}}</strong> de <strong>«&nbsp;{{pharmacy.name}}&nbsp;»</strong>&nbsp;?</p><div \nclass=\"admin-dialog__option\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s18 mr-10\"></md-icon><span flex>\nIl gardera son mot de passe et ses accès actuels — aucune invitation ne lui sera envoyée. Le compte qui tient ce rôle aujourd\'hui le perdra, mais restera rattaché à l\'officine avec tout son historique.\n</span></div></md-dialog-content><md-dialog-actions class=\"admin-dialog__actions\"><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"annulerRattachement()\">Annuler</md-button><md-button \nclass=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--primary-blue\" \nng-click=\"confirmerRattachement()\"><md-icon md-font-icon=\"icon-account-plus\" class=\"s16\"></md-icon><span>\nRattacher ce compte</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/pharmacies/statistiques/statistiques.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span><md-icon md-font-icon=\"icon-chart-bar\" class=\"s24\"></md-icon></span><span>\nStatistiques Générales</span></div><div flex flex-sm=\"100\" class=\"pl-20\"><md-select ng-model=\"type\" placeholder=\"Type\" \nng-change=\"getStats()\"><md-select-header class=\"nl-Input-select-header\">Filtrer par contrat</md-select-header>\n<md-option ng-repeat=\"childType in types track by $index\" ng-value=\"childType\">{{childType.displayName}}</md-option>\n</md-select></div></div></div></div></div><div class=\"content\"><div ng-if=\"loading\" layout=\"row\" \nlayout-align=\"center center\" style=\"padding: 40px 0\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\">\n</md-progress-circular><span class=\"ml-10\">Chargement des statistiques…</span></div><div layout=\"row\" layout-wrap \nng-if=\"!loading && stats\"><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-if=\"stats.registered!=null\"><ms-widget \nflex=\"100\" flippable=\"true\" layout=\"column\"><ms-widget-front class=\"widget-admin\"><div class=\"widget-admin--title\">\nPharmacies Inscrites</div><div layout=\"column\" layout-align=\"center center\" style=\"padding-top: 30px\"><div \nclass=\"widget-admin--number\">{{stats.registered}}</div></div></ms-widget-front></ms-widget></div><div flex=\"33\" \nflex-sm=\"50\" flex-xs=\"100\" ng-if=\"stats.oneAccountActivated!=null\"><ms-widget flex=\"100\" flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"widget-admin\"><div class=\"widget-admin--title\">Total de Pharmacies</div><div \nlayout=\"column\" layout-align=\"center center\" style=\"padding-top: 30px\"><div class=\"widget-admin--number\">\n{{stats.oneAccountActivated}}</div><div class=\"widget-admin--subtitle\">ayant activée au moins un compte</div></div>\n</ms-widget-front></ms-widget></div><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-if=\"stats.connectionLast7Days!=null\">\n<ms-widget flex=\"100\" flippable=\"true\" layout=\"column\"><ms-widget-front class=\"widget-admin\"><div \nclass=\"widget-admin--title\">Total de pharmacies</div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"padding-top: 30px\"><div class=\"widget-admin--number\">{{stats.connectionLast7Days}}</div><div \nclass=\"widget-admin--subtitle\">connectés plusieurs fois au cours des 7 derniers jours</div></div></ms-widget-front>\n</ms-widget></div><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-if=\"stats.malfunctionPerPharmacy!=null\"><ms-widget \nflex=\"100\" flippable=\"true\" layout=\"column\"><ms-widget-front class=\"widget-admin\"><div class=\"widget-admin--title\">\nMoyenne de dysfonctionnements par pharmacie</div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"padding-top: 30px\"><div class=\"widget-admin--number\">{{stats.malfunctionPerPharmacy}}</div></div>\n</ms-widget-front></ms-widget></div><div flex=\"33\" flex-sm=\"50\" flex-xs=\"100\" \nng-if=\"stats.malfunctionByType && stats.malfunctionByType.length>0\"><ms-widget flex=\"100\" flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"widget-admin\"><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\" style=\"margin:0\"><div class=\"widget-admin--title\" flex flex-sm=\"100\">\nDysfonctionnements par type</div><div flex flex-sm=\"100\"><md-select ng-model-options=\"{trackBy: \'$value.type\'}\" \nstyle=\"margin:0\" ng-model=\"perTypeSelected\" placeholder=\"Type\"><md-option ng-repeat=\"stat in stats.malfunctionByType\" \nng-value=\"stat\">{{stat.type}}</md-option></md-select></div></div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"padding-top: 30px\"><div class=\"widget-admin--number\">{{perTypeSelected.malfunctions}}</div><div \nclass=\"widget-admin--subtitle\">{{perTypeSelected.type}}</div></div></ms-widget-front></ms-widget></div><div flex=\"33\" \nflex-sm=\"50\" flex-xs=\"100\" ng-if=\"stats.progressOpen!=null && stats.progressClose!=null\"><ms-widget flex=\"100\" \nflippable=\"true\" layout=\"column\"><ms-widget-front class=\"widget-admin\"><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\" style=\"margin:0\"><div class=\"widget-admin--title\" flex flex-sm=\"100\">\nTotal fiches de progrès</div><div flex flex-sm=\"100\"><md-select style=\"margin:0\" ng-model=\"progressForm\" \nplaceholder=\"Statut\"><md-option ng-value=\"\'OPEN\'\">Ouvertes</md-option><md-option ng-value=\"\'CLOSE\'\">Fermées</md-option>\n</md-select></div></div><div layout=\"column\" layout-align=\"center center\" style=\"padding-top: 30px\"><div \nclass=\"widget-admin--number\" ng-if=\"progressForm==\'OPEN\'\">{{stats.progressOpen}}</div><div \nclass=\"widget-admin--number\" ng-if=\"progressForm==\'CLOSE\'\">{{stats.progressClose}}</div><div \nclass=\"widget-admin--subtitle\" ng-if=\"progressForm==\'OPEN\'\">Ouvertes</div><div class=\"widget-admin--subtitle\" \nng-if=\"progressForm==\'CLOSE\'\">Fermées</div></div></ms-widget-front></ms-widget></div><div flex=\"33\" flex-sm=\"50\" \nflex-xs=\"100\" ng-if=\"stats.numberUsingProgressForm!=null\"><ms-widget flex=\"100\" flippable=\"true\" layout=\"column\">\n<ms-widget-front class=\"widget-admin\"><div class=\"widget-admin--title\">Pharmacies utilisant les fiches de progrès</div>\n<div layout=\"column\" layout-align=\"center center\" style=\"padding-top: 30px\"><div class=\"widget-admin--number\">\n{{stats.numberUsingProgressForm}}</div></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/admin/toolbox/popup/toolbox_delete_confirm.html","<md-dialog aria-label=\"Suppression outil\" class=\"qs-toolbox-delete-dialog\" flex=\"40\" flex-sm=\"70\" flex-xs=\"95\">\n<md-toolbar class=\"qs-toolbox-delete-toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"qs-toolbox-delete-title\" layout=\"row\" layout-align=\"start center\"><span>Supprimer un outil</span></div>\n<md-button class=\"md-icon-button qs-toolbox-delete-close\" ng-click=\"hidePopup()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar><md-dialog-content class=\"qs-toolbox-delete-content\"><p \nclass=\"qs-toolbox-delete-intro\">Vous êtes sur le point de supprimer l\'outil suivant :</p><div \nclass=\"qs-toolbox-delete-card\"><md-icon md-font-icon=\"icon-file-document\" class=\"qs-toolbox-delete-card-icon\">\n</md-icon><div class=\"qs-toolbox-delete-card-body\"><div class=\"qs-toolbox-delete-card-title\">{{toolToDelete.title}}\n</div><div class=\"qs-toolbox-delete-card-meta\" ng-if=\"toolToDelete.originalFileName\">\nFichier : {{toolToDelete.originalFileName}}</div><div class=\"qs-toolbox-delete-card-meta\" \nng-if=\"toolToDelete.linkTitle\">Lien : {{toolToDelete.linkTitle}}</div></div></div><p class=\"qs-toolbox-delete-warn\">\nCette action est <strong>définitive</strong> et rendra l\'outil inaccessible à toutes les pharmacies du groupement.</p>\n</md-dialog-content><md-dialog-actions class=\"qs-toolbox-delete-actions\" layout=\"row\" layout-align=\"end center\"><button\n type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button type=\"button\" \nclass=\"nl-Btn qs-toolbox-delete-confirm\" ng-click=\"deleteTool()\" ng-disabled=\"loadingDelete\"><md-progress-circular \nmd-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"loadingDelete\"></md-progress-circular><span ng-if=\"!loadingDelete\">\nSupprimer définitivement</span></button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/toolbox/popup/toolbox_dialog.html","<md-dialog aria-label=\"Boîte à outils\" class=\"qs-toolbox-dialog\" flex=\"50\" flex-sm=\"75\" flex-xs=\"95\"><form \nname=\"toolForm\" class=\"md-inline-form qs-toolbox-dialog-form\" novalidate ng-submit=\"toolForm.$valid && saveTool()\">\n<md-toolbar class=\"qs-toolbox-dialog-toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"qs-toolbox-dialog-title\" layout=\"row\" layout-align=\"start center\"><span>\n{{editMode ? \'Modifier un outil\' : \'Ajouter un outil\'}}</span></div><md-button \nclass=\"md-icon-button qs-toolbox-dialog-close\" ng-click=\"hidePopup()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-toolbar><md-dialog-content ms-scroll \nclass=\"qs-toolbox-dialog-content\"><p class=\"qs-toolbox-dialog-intro\">\nPartagez un fichier ou un lien URL avec toutes les pharmacies du groupement. Il apparaîtra dans leur boîte à outils.\n</p><div class=\"qs-toolbox-dialog-section\"><div class=\"qs-toolbox-dialog-section-title\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"qs-toolbox-dialog-section-icon\"></md-icon><span>Informations</span></div>\n<md-input-container class=\"nl-Input-container md-icon-float md-block\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nom de l\'outil<span class=\"asterix\">*</span></label><input \nclass=\"nl-Input-input\" type=\"text\" name=\"title\" ng-model=\"tool.title\" required placeholder=\"Ex : Guide qualité 2026\">\n<div ng-messages=\"toolForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container md-icon-float md-block\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Libellé du lien<span class=\"asterix\">*</span></label><input \nclass=\"nl-Input-input\" type=\"text\" name=\"linkTitle\" ng-model=\"tool.linkTitle\" required \nplaceholder=\"Ex : Télécharger le guide\"> <span class=\"qs-toolbox-dialog-field-hint\">\nTexte cliquable affiché pour accéder à l\'outil.</span><div ng-messages=\"toolForm.linkTitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nclass=\"qs-toolbox-dialog-section\"><div class=\"qs-toolbox-dialog-section-title\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"qs-toolbox-dialog-section-icon\"></md-icon><span>\nFichier ou URL{{editMode ? \'\' : \' *\'}}</span></div><div \nng-if=\"editMode && !tool.externalUrl && tool.originalFileName && !selectedFile\" class=\"qs-toolbox-dialog-current-file\">\n<md-icon md-font-icon=\"icon-file-document\" class=\"qs-toolbox-dialog-current-file-icon\"></md-icon><div \nclass=\"qs-toolbox-dialog-current-file-body\"><div class=\"qs-toolbox-dialog-current-file-label\">Fichier actuel</div><div \nclass=\"qs-toolbox-dialog-current-file-name\" title=\"{{tool.originalFileName}}\">{{tool.originalFileName}}</div></div>\n</div><div ng-if=\"editMode && tool.externalUrl && tool.url && !selectedFile\" class=\"qs-toolbox-dialog-current-file\">\n<md-icon md-font-icon=\"icon-link-variant\" class=\"qs-toolbox-dialog-current-file-icon\"></md-icon><div \nclass=\"qs-toolbox-dialog-current-file-body\"><div class=\"qs-toolbox-dialog-current-file-label\">URL actuelle</div><div \nclass=\"qs-toolbox-dialog-current-file-name\" title=\"{{tool.url}}\">{{tool.url}}</div></div></div><button type=\"button\" \nclass=\"qs-toolbox-dialog-drop\" ng-click=\"openToolFilePicker()\" \nng-class=\"{ \'has-file\': selectedFile, \'has-error\': fileError }\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"qs-toolbox-dialog-drop-icon\" ng-if=\"!selectedFile\"></md-icon><md-icon md-font-icon=\"icon-file-document\" \nclass=\"qs-toolbox-dialog-drop-icon\" ng-if=\"selectedFile\"></md-icon><div class=\"qs-toolbox-dialog-drop-body\"><div \nclass=\"qs-toolbox-dialog-drop-title\" ng-if=\"!selectedFile\">\n{{editMode ? \'Remplacer le fichier\' : \'Sélectionner un fichier\'}}</div><div class=\"qs-toolbox-dialog-drop-title\" \nng-if=\"selectedFile\" title=\"{{selectedFile.name}}\">{{selectedFile.name}}</div><div class=\"qs-toolbox-dialog-drop-hint\" \nng-if=\"!selectedFile && !editMode\">Cliquez pour parcourir vos fichiers (PDF, Word, Excel, PowerPoint, image…)</div><div\n class=\"qs-toolbox-dialog-drop-hint\" ng-if=\"!selectedFile && editMode\">\nFacultatif — laissez vide pour conserver l\'élément actuel.</div><div class=\"qs-toolbox-dialog-drop-hint\" \nng-if=\"selectedFile\">Cliquez pour choisir un autre fichier.</div></div></button> <input type=\"file\" \nid=\"toolbox-file-input\" ng-hide=\"true\" onchange=\"angular.element(this).scope().onToolboxFileChange(this.files)\"><div \nclass=\"qs-toolbox-dialog-field-hint mt-10\">ou</div><md-input-container \nclass=\"nl-Input-container md-icon-float md-block\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nURL de l\'outil</label><input class=\"nl-Input-input\" type=\"url\" name=\"url\" ng-model=\"tool.url\" \nng-change=\"onToolboxUrlChange()\" placeholder=\"https://exemple.com/mon-outil\"> <span \nclass=\"qs-toolbox-dialog-field-hint\">Facultatif — renseignez une URL HTTP/HTTPS si vous ne déposez pas de fichier.\n</span></md-input-container><div class=\"qs-toolbox-dialog-file-error\" ng-if=\"fileError\"><md-icon \nmd-font-icon=\"icon-alert-outline\"></md-icon><span>{{fileError}}</span></div></div></md-dialog-content>\n<md-dialog-actions class=\"qs-toolbox-dialog-actions\" layout=\"row\" layout-align=\"end center\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\" aria-label=\"Annuler\">Annuler</button> <button type=\"submit\" \nclass=\"nl-Btn qs-toolbox-dialog-submit\" ng-disabled=\"toolForm.$invalid || loadingSave\" aria-label=\"Sauvegarder\">\n<md-progress-circular md-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"loadingSave\"></md-progress-circular><span \nng-if=\"!loadingSave\">{{editMode ? \'Enregistrer les modifications\' : \'Ajouter l\\\'outil\'}}</span></button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/auto-evaluation/accueil/aeq-accueil-campagne.html","<div class=\"aeq aeq-accueil\" ng-if=\"!chargement && contexte && contexte.campagne && !estSituation(\'A_VENIR\')\"><div \nclass=\"qs-closed-campaign-summary aeq-resume\"><div class=\"qs-closed-campaign-summary__head\"><span \nclass=\"qs-closed-campaign-summary__status\" \nng-class=\"{\n					\'aeq-statut--ok\': estSituation(\'VALIDEE_OUVERTE\'),\n					\'aeq-statut--action\': estSituation(\'ROUVERTE\') || contexte.campagne.phase === \'PROLONGATION\',\n					\'aeq-statut--neutre\': estSituation(\'CLOTUREE_VALIDEE\', \'CLOTUREE_NON_VALIDEE\')}\">\n<span class=\"qs-closed-campaign-summary__status-dot\" aria-hidden=\"true\"></span> <span \nng-if=\"estSituation(\'EN_COURS\') && contexte.campagne.phase !== \'PROLONGATION\'\">\nCampagne {{contexte.campagne.annee}} en cours</span> <span \nng-if=\"estSituation(\'EN_COURS\') && contexte.campagne.phase === \'PROLONGATION\'\">Prolongation</span> <span \nng-if=\"estSituation(\'VALIDEE_OUVERTE\')\">Validée</span> <span ng-if=\"estSituation(\'ROUVERTE\')\">Rouverte — à revalider\n</span> <span ng-if=\"estSituation(\'CLOTUREE_VALIDEE\', \'CLOTUREE_NON_VALIDEE\')\">Campagne clôturée</span></span><h2 \nclass=\"qs-closed-campaign-summary__title\">Auto-évaluation {{contexte.campagne.annee}}</h2><div class=\"aeq-echeance\" \nng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\')\" \nng-class=\"{\'aeq-echeance--urgent\': (joursRestants() !== null && joursRestants() <= 7)\n						|| contexte.campagne.phase === \'PROLONGATION\'}\">\n<svg viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"8\" cy=\"8\" r=\"6.2\"></circle><path d=\"M8 4.6V8l2.4 1.6\"></path>\n</svg> <span ng-if=\"joursRestants() > 1\"><span ng-if=\"contexte.campagne.phase === \'PROLONGATION\'\">Prolongation : à\n</span><span ng-if=\"contexte.campagne.phase !== \'PROLONGATION\'\">À</span> compléter et à valider avant le <b>\n{{contexte.campagne.dateClotureEffective | date:\'d MMMM yyyy\'}}</b> — il vous reste <b>{{joursRestants()}} jours</b> \n</span><span ng-if=\"joursRestants() === 1\"><b>Dernier jour demain</b> — à compléter et à valider avant le <b>\n{{contexte.campagne.dateClotureEffective | date:\'d MMMM yyyy\'}}</b> </span><span ng-if=\"joursRestants() === 0\"><b>\nDernier jour pour valider.</b></span> <span ng-if=\"joursRestants() === null || joursRestants() < 0\">\nÀ compléter et à valider avant le <b>{{contexte.campagne.dateClotureEffective | date:\'d MMMM yyyy\'}}</b></span></div>\n<div class=\"aeq-echeance aeq-echeance--fini\" \nng-if=\"estSituation(\'VALIDEE_OUVERTE\', \'CLOTUREE_VALIDEE\') && contexte.soumission.dateValidation\"><svg \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.9\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 8.4l3.2 3.2L13 5\"></path></svg> <span>Validée le <b>\n{{contexte.soumission.dateValidation | date:\'d MMMM yyyy\'}}</b><span ng-if=\"contexte.soumission.validantNom\"> par <b>\n{{contexte.soumission.validantNom}}</b></span></span></div><p class=\"qs-closed-campaign-summary__lead\" \nng-if=\"estSituation(\'EN_COURS\') && resteAFaire() !== 0\">\nToutes les questions affichées sont obligatoires. Vos réponses sont <b>enregistrées au fur et à mesure</b>\n : vous pouvez interrompre le questionnaire et le reprendre plus tard.</p><p class=\"qs-closed-campaign-summary__lead\" \nng-if=\"estSituation(\'EN_COURS\') && resteAFaire() === 0\">Vous avez répondu à tout. Il ne reste qu\'à <b>valider</b>\n pour transmettre votre auto-évaluation à votre groupement.</p><p class=\"qs-closed-campaign-summary__lead\" \nng-if=\"estSituation(\'VALIDEE_OUVERTE\')\">Vos réponses sont <b>figées</b>\n et transmises à votre groupement. La comparaison au groupement sera disponible après la clôture de la campagne.</p><p \nclass=\"qs-closed-campaign-summary__lead\" ng-if=\"estSituation(\'ROUVERTE\')\">Vos réponses sont de nouveau modifiables<span\n ng-if=\"contexte.soumission.dateReouverture\"> depuis le {{contexte.soumission.dateReouverture | date:\'d MMMM yyyy\'}}\n</span>, et <b>le titulaire doit revalider</b>. Vos résultats redeviendront accessibles dès la revalidation.</p><p \nclass=\"qs-closed-campaign-summary__lead\" ng-if=\"estSituation(\'CLOTUREE_VALIDEE\')\">\nLa campagne est terminée. Vos résultats et votre comparaison au groupement restent consultables ici.</p><p \nclass=\"qs-closed-campaign-summary__lead\" ng-if=\"estSituation(\'CLOTUREE_NON_VALIDEE\')\">\nVotre auto-évaluation n\'a pas été validée avant la clôture : aucun résultat personnel n\'est disponible pour ce millésime. Vous pourrez participer à la prochaine campagne.\n</p><p class=\"aeq-roles\" ng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\')\">\nLe pharmacien titulaire (compte titulaire) et le responsable qualité (compte PRACQ s\'il existe) peuvent remplir l\'auto-évaluation. \n<b>Seul le compte titulaire peut la valider.</b></p><p class=\"aeq-roles\" ng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\')\">\n<b>Seuls les questionnaires validés par le titulaire avant la clôture seront pris en compte.</b>\n Nous vous rappelons que l\'auto-évaluation qualité annuelle est obligatoire dans le cadre de votre engagement qualité certifié ISO 9001 – QMS Pharma®.\n</p><p class=\"aeq-rappel\" ng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\', \'VALIDEE_OUVERTE\')\"><svg viewBox=\"0 0 16 16\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n<circle cx=\"8\" cy=\"8\" r=\"6.2\"></circle><path d=\"M8 7.4v3.8M8 4.9v.1\"></path></svg> <span><b>Rappel :</b>\n à ce jour, le renseignement de l\'auto-évaluation PHSQ n\'affranchit pas la pharmacie du renseignement de l\'auto-évaluation « DQO » nécessaire à l\'obtention de la ROSP conventionnelle.\n</span></p><div class=\"aeq-outils-bloc\" ng-if=\"contexte.outils.length\"><div class=\"aeq-outils-intitule\">Boîte à outils\n</div><p class=\"aeq-outils-texte\" ng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\')\">\nRetrouvez ici les documents utiles pour compléter votre auto-évaluation.</p><aeq-boite-outils outils=\"contexte.outils\">\n</aeq-boite-outils></div></div><div class=\"qs-closed-campaign-summary__kpi\"><div \nclass=\"qs-closed-campaign-summary__kpi-main\" ng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\') && contexte.soumission\"><div \nclass=\"aeq-kpi-titre\">Remplissage en cours</div><div class=\"qs-closed-campaign-summary__kpi-label\" \nng-if=\"resteAFaire() > 0\">Question<span ng-if=\"resteAFaire() > 1\">s</span> restante<span ng-if=\"resteAFaire() > 1\">s\n</span></div><div class=\"qs-closed-campaign-summary__kpi-value\" ng-if=\"resteAFaire() > 0\">{{resteAFaire()}}</div><div \nclass=\"qs-closed-campaign-summary__kpi-label\" ng-if=\"resteAFaire() === 0\">Complétude</div><div \nclass=\"qs-closed-campaign-summary__kpi-value\" ng-if=\"resteAFaire() === 0\">100<span class=\"aeq-kpi-unite\"> %</span>\n</div><div class=\"aeq-jauge\"><div class=\"aeq-jauge-piste\"><span class=\"aeq-progfill\" \nng-style=\"{width: pourcentage() + \'%\'}\"></span></div><div class=\"aeq-jauge-txt\" ng-if=\"resteAFaire() > 0\"><b>\n{{pourcentage()}} %</b>\n complété · {{contexte.soumission.progression.repondues}} / {{contexte.soumission.progression.actives}}</div><div \nclass=\"aeq-jauge-txt\" ng-if=\"resteAFaire() === 0\"><b>{{contexte.soumission.progression.repondues}} questions</b>\n répondues</div></div></div><div class=\"qs-closed-campaign-summary__kpi-main\" \nng-if=\"estSituation(\'VALIDEE_OUVERTE\', \'CLOTUREE_VALIDEE\')\"><div class=\"qs-tool-card-icon qs-tool-card-icon--report\" \naria-hidden=\"true\"><svg viewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\">\n</path><path d=\"M20 4v6h6\"></path><path d=\"M11 18h10M11 22h7M11 14h6\"></path></svg></div><div \nclass=\"qs-tool-card-body\"><span class=\"qs-tool-card-type qs-tool-card-type--report\">\nRestitution Campagne {{contexte.campagne.annee}}</span><h4 class=\"qs-tool-card-title\">\nVos résultats {{contexte.campagne.annee}}</h4><p class=\"qs-tool-card-subtitle\" \nng-if=\"contexte.soumission.nbPointsAttention\">{{contexte.soumission.nbPointsAttention}} point<span \nng-if=\"contexte.soumission.nbPointsAttention > 1\">s</span> d\'attention à examiner avec votre équipe.</p></div></div>\n<div class=\"qs-closed-campaign-summary__kpi-main\" ng-if=\"estSituation(\'CLOTUREE_NON_VALIDEE\')\"><div \nclass=\"aeq-kpi-muet\">Aucun résultat pour ce millésime</div></div><div class=\"qs-tool-card-actions\" \nng-if=\"!estSituation(\'CLOTUREE_NON_VALIDEE\')\"><button type=\"button\" class=\"nl-Btn aeq-btn-remplir\" \nng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\')\" ng-disabled=\"!contexte.droits.peutRemplir\" ng-click=\"reprendre()\"><svg \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M2.5 8h11m0 0l-4-4m4 4l-4 4\"></path></svg> <span>\n{{libelleAction()}}</span></button> <button type=\"button\" class=\"nl-Btn aeq-btn--ghost aeq-btn-remplir\" \nng-if=\"estSituation(\'EN_COURS\', \'ROUVERTE\') && resteAFaire() === 0\" ng-click=\"retourQuestionnaire()\"><span>\nRetour au questionnaire</span></button> <button type=\"button\" class=\"qs-tool-card-btn qs-tool-card-btn--external\" \nng-if=\"estSituation(\'CLOTUREE_VALIDEE\', \'VALIDEE_OUVERTE\') && contexte.comparaisonDisponible\" \nng-click=\"voirComparaison()\">\n{{estSituation(\'CLOTUREE_VALIDEE\') ? \'Comparer à mon groupement\' : \'Comparer à l’an dernier\'}}</button> <button \ntype=\"button\" class=\"qs-tool-card-btn\" ng-if=\"estSituation(\'VALIDEE_OUVERTE\', \'CLOTUREE_VALIDEE\')\" \nng-click=\"voirResultats()\"><svg viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 13V7.5M8 13V3M13 13V9.5\"></path></svg>\n Voir mes résultats</button></div></div></div></div><section class=\"qs-teaser aeq-teaser\" \nng-if=\"!chargement && contexte && contexte.campagne && enTeasing()\"><header class=\"qs-teaser-hero\"><div \nclass=\"qs-teaser-rocket\" aria-hidden=\"true\">📋</div><h1 class=\"qs-teaser-title\">\nAuto-évaluation {{contexte.campagne.annee}}</h1><p class=\"qs-teaser-subtitle\">Démarche Qualité ISO 9001 – QMS Pharma®\n</p><div class=\"qs-teaser-launch-row\"><div class=\"qs-teaser-launch-badge\">Ouverture : <strong>\n{{contexte.campagne.dateOuverture | date:\'dd MMMM yyyy\'}}</strong></div><div class=\"qs-teaser-countdown\" \nng-if=\"joursAvantOuverture() > 0\">Plus que <strong>{{joursAvantOuverture()}}</strong> jour<span \nng-if=\"joursAvantOuverture() > 1\">s</span></div><div class=\"qs-teaser-countdown\" ng-if=\"joursAvantOuverture() === 0\">\nOuverture <strong>aujourd\'hui</strong></div></div></header><div class=\"qs-teaser-pillars\"><article \nclass=\"qs-teaser-pillar\"><div class=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">🔎</div><h3 \nclass=\"qs-teaser-pillar-title\">Faire le point</h3><p class=\"qs-teaser-pillar-desc\">\nÉvaluez votre démarche qualité chapitre par chapitre : pilotage, équipe, dispensation, préparations, mesure des résultats.\n</p></article><article class=\"qs-teaser-pillar\"><div class=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">📈</div><h3 \nclass=\"qs-teaser-pillar-title\">Progresser</h3><p class=\"qs-teaser-pillar-desc\">\nRepérez vos points forts et vos axes d\'amélioration : votre rapport de synthèse et votre plan d\'action sont prêts dès la validation.\n</p></article><article class=\"qs-teaser-pillar\"><div class=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">🏅</div><h3 \nclass=\"qs-teaser-pillar-title\">Maintenir votre certification</h3><p class=\"qs-teaser-pillar-desc\">\nL\'auto-évaluation qualité annuelle est obligatoire dans le cadre de votre engagement qualité certifié ISO 9001 – QMS Pharma®.\n</p></article></div><p class=\"qs-teaser-mobilisation\">\nChaque année, l\'auto-évaluation permet à chaque officine engagée de mesurer le chemin parcouru. <strong>\nPréparez-vous dès maintenant : le questionnaire sera à compléter et à valider avant le {{contexte.campagne.dateClotureOfficielle | date:\'dd MMMM yyyy\'}}.\n</strong></p><section class=\"qs-teaser-block\"><h2 class=\"qs-teaser-block-title\">🗓️ Comment ça se passe</h2><div \nclass=\"qs-teaser-steps\"><div class=\"qs-teaser-step\"><div class=\"qs-teaser-step-num\">1</div><div \nclass=\"qs-teaser-step-body\"><h4 class=\"qs-teaser-step-title\">Le {{contexte.campagne.dateOuverture | date:\'dd MMMM\'}}\n</h4><p class=\"qs-teaser-step-desc\">\nLa campagne s\'ouvre : vous recevez un e-mail, et le questionnaire devient accessible ici même.</p></div></div><div \nclass=\"qs-teaser-step\"><div class=\"qs-teaser-step-num\">2</div><div class=\"qs-teaser-step-body\"><h4 \nclass=\"qs-teaser-step-title\">À votre rythme</h4><p class=\"qs-teaser-step-desc\">\nLe pharmacien titulaire (compte titulaire) et le responsable qualité (compte PRACQ s\'il existe) remplissent le questionnaire ; les réponses sont enregistrées au fur et à mesure.\n</p></div></div><div class=\"qs-teaser-step\"><div class=\"qs-teaser-step-num\">3</div><div class=\"qs-teaser-step-body\"><h4\n class=\"qs-teaser-step-title\">Avant le {{contexte.campagne.dateClotureOfficielle | date:\'dd MMMM\'}}</h4><p \nclass=\"qs-teaser-step-desc\">\nSeul le compte titulaire valide. Seuls les questionnaires validés par le titulaire avant la clôture seront pris en compte.\n</p></div></div></div></section><section class=\"qs-teaser-block\" ng-if=\"contexte.outils.length\"><h2 \nclass=\"qs-teaser-block-title\">🧰 Ressources à votre disposition</h2><p class=\"qs-teaser-block-lead\">\nLes documents de la campagne sont déjà disponibles : prenez-en connaissance avec votre équipe avant l\'ouverture.</p>\n<aeq-boite-outils outils=\"contexte.outils\"></aeq-boite-outils></section></section>");
$templateCache.put("app/main/front/auto-evaluation/comparaison/comparaison.html","<section class=\"nl-Page aeq\"><div class=\"nl-H1\"><div style=\"padding: 0; min-height: 3.4rem\">\nAuto-évaluation {{annee}} — comparaison</div></div><div class=\"nl-Content\"><div class=\"aeq-crumb\"><a \nui-sref=\"app.performances.mes-evaluations\">Mes évaluations</a> <span class=\"aeq-sep\">/</span> <span>\nAuto-évaluation {{annee}}</span> <span class=\"aeq-sep\">/</span> <a href=\"\" ng-click=\"retourResultats()\">Résultats</a> \n<span class=\"aeq-sep\">/</span> <span class=\"aeq-cur\">Comparaison</span></div><div class=\"aeq-note aeq-note--warn\" \nng-if=\"erreur\">{{erreur.message}}</div><div class=\"aeq-carte\" ng-if=\"pasEncore\"><div class=\"aeq-note aeq-note--info\">\n<b>La comparaison sera disponible après la clôture de la campagne.</b>\n Tant que des officines remplissent encore, la moyenne du réseau changerait chaque jour et ne constituerait pas un repère.\n</div><div class=\"aeq-navrow\"><button type=\"button\" class=\"nl-Btn aeq-btn--prim\" ng-click=\"retourResultats()\">\nRevenir à mes résultats</button></div></div><div ng-if=\"!chargement && comparaison\"><div \nclass=\"aeq-note aeq-note--neutre\">Ces chiffres sont un <b>repère indicatif</b>, sans classement ni note.</div><div \nclass=\"aeq-carte\"><h4>Mon groupement <small ng-if=\"comparaison.groupement.libelle\">\n{{comparaison.groupement.libelle}} · {{comparaison.groupement.effectifValides}} officine<span \nng-if=\"comparaison.groupement.effectifValides > 1\">s</span> validée<span \nng-if=\"comparaison.groupement.effectifValides > 1\">s</span></small></h4><div class=\"aeq-note aeq-note--neutre\" \nng-if=\"!comparaison.groupement.disponible\">{{texteIndisponible()}}</div><div ng-if=\"comparaison.groupement.disponible\">\n<div class=\"aeq-compare\" ng-if=\"comparaison.groupement.global\"><div class=\"aeq-compare-tete\"><b>Synthèse globale</b>\n<aeq-badge-ecart valeur=\"comparaison.groupement.global.ecartPts\" suffixe=\"\'vs groupement\'\"></aeq-badge-ecart></div><div\n class=\"aeq-compare-ligne\"><span class=\"aeq-compare-lab\">Vous</span><aeq-barre-empilee \nligne=\"comparaison.groupement.global.vous\" palette=\"comparaison.palette\"></aeq-barre-empilee></div><div \nclass=\"aeq-compare-ligne\"><span class=\"aeq-compare-lab\">Groupement</span><aeq-barre-empilee \nligne=\"comparaison.groupement.global.reference\" palette=\"comparaison.palette\"></aeq-barre-empilee></div></div><div \nclass=\"aeq-compare\" ng-repeat=\"ligne in comparaison.groupement.chapitres track by ligne.chapitreId\"><div \nclass=\"aeq-compare-tete\"><b><span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span>\n {{ligne.titre}}</b><aeq-badge-ecart valeur=\"ligne.ecartPts\" suffixe=\"\'vs groupement\'\" motif=\"ligne.motif\">\n</aeq-badge-ecart></div><div class=\"aeq-hint\" ng-if=\"ligne.nonCompare\">\nChapitre non concerné pour votre officine : il n\'est donc pas comparé.</div><div ng-if=\"!ligne.nonCompare\"><div \nclass=\"aeq-compare-ligne\"><span class=\"aeq-compare-lab\">Vous</span><aeq-barre-empilee ligne=\"ligne.vous\" \npalette=\"comparaison.palette\"></aeq-barre-empilee></div><div class=\"aeq-compare-ligne\"><span class=\"aeq-compare-lab\">\nGroupement</span><aeq-barre-empilee ligne=\"ligne.reference\" palette=\"comparaison.palette\"></aeq-barre-empilee></div>\n</div></div></div></div><div class=\"aeq-carte\"><h4>Par rapport à {{comparaison.n1.annee}} <small \nng-if=\"comparaison.n1.disponible\">sur {{comparaison.n1.nbQuestionsComparees}} questions communes aux deux millésimes\n</small></h4><div class=\"aeq-note aeq-note--neutre\" ng-if=\"!comparaison.n1.disponible\">{{texteN1Indisponible()}}</div>\n<div ng-if=\"comparaison.n1.disponible\"><table class=\"aeq-tbl\"><thead><tr><th>Chapitre</th><th>{{annee}}</th><th>\n{{comparaison.n1.annee}}</th><th>Évolution</th></tr></thead><tbody><tr class=\"aeq-tbl-synthese\" \nng-if=\"comparaison.n1.global\"><td><b>Synthèse globale</b></td><td class=\"aeq-mono\">{{comparaison.n1.global.pctOuiN}} %\n</td><td class=\"aeq-mono\">{{comparaison.n1.global.pctOuiN1}} %</td><td><aeq-badge-ecart \nvaleur=\"comparaison.n1.global.evolutionPts\" motif=\"comparaison.n1.global.motif\"></aeq-badge-ecart></td></tr><tr \nng-repeat=\"ligne in comparaison.n1.chapitres track by ligne.chapitreId\"><td><b><span class=\"aeq-ccode\" \nng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span> {{ligne.titre}}</b></td><td class=\"aeq-mono\">\n{{ligne.pctOuiN}} %</td><td class=\"aeq-mono\" ng-if=\"ligne.pctOuiN1 !== null && ligne.pctOuiN1 !== undefined\">\n{{ligne.pctOuiN1}} %</td><td class=\"aeq-mono\" ng-if=\"ligne.pctOuiN1 === null || ligne.pctOuiN1 === undefined\">&mdash;\n</td><td><aeq-badge-ecart valeur=\"ligne.evolutionPts\" motif=\"ligne.motif\"></aeq-badge-ecart></td></tr></tbody></table>\n<p class=\"aeq-hint\">Seules les questions présentes dans les <b>deux</b>\n millésimes sont comparées. Un chapitre sans équivalent l\'an dernier affiche un tiret, et non 0&nbsp;%.</p></div></div>\n<div class=\"aeq-navrow\"><button type=\"button\" class=\"nl-Btn aeq-btn--ghost\" ng-click=\"retourResultats()\">\nRevenir à mes résultats</button></div></div></div></section>");
$templateCache.put("app/main/front/auto-evaluation/questionnaire/aeq-issues.html","<div class=\"aeq-issues\"><button type=\"button\" class=\"aeq-issue\" \nng-repeat=\"modalite in question.modalites track by modalite.valeur\" \nng-class=\"{\'aeq-issue--choisie\': estChoisie(question, modalite)}\" \nng-style=\"estChoisie(question, modalite) ? {borderColor: modalite.couleurHex} : {}\" ng-disabled=\"!parcours.modifiable\" \nng-click=\"choisirValeur(question, modalite.valeur)\"><span class=\"aeq-issue-tete\"><span class=\"aeq-rcd\" \nng-style=\"{background: modalite.couleurHex}\"></span> <span class=\"aeq-issue-rep\">{{modalite.libelleLong}} <span \nng-if=\"question.consequence\">· <span ng-if=\"question.consequence.masqueToutLeChapitre\"><span \nng-if=\"!estMasquante(question, modalite)\">{{question.consequence.nbQuestionsMasquees}} question<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">s</span> à remplir</span> <span \nng-if=\"estMasquante(question, modalite)\">aucune question</span> </span><span \nng-if=\"!question.consequence.masqueToutLeChapitre\">{{question.consequence.nbQuestionsMasquees}} question<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">s</span> <span ng-if=\"!estMasquante(question, modalite)\">de plus\n</span> <span ng-if=\"estMasquante(question, modalite)\">en moins</span> </span></span></span><span \nclass=\"aeq-issue-coche\" \nng-style=\"estChoisie(question, modalite)\n							? {background: modalite.couleurHex, borderColor: modalite.couleurHex} : {}\" \naria-hidden=\"true\">&#10003;</span> </span><span class=\"aeq-issue-quoi\" ng-if=\"question.consequence\"><span \nng-if=\"question.consequence.masqueToutLeChapitre\"><span ng-if=\"!estMasquante(question, modalite)\">Elle<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">s</span> porte<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">nt</span>\n toutes sur le chapitre «&nbsp;{{chapitre.titre}}&nbsp;». </span><span ng-if=\"estMasquante(question, modalite)\">\nVous passez directement à la suite du questionnaire. </span></span><span \nng-if=\"!question.consequence.masqueToutLeChapitre\"><span ng-if=\"!estMasquante(question, modalite)\">Elle<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">s</span> s\'ajoute<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">nt</span> aux autres questions de ce chapitre. </span><span \nng-if=\"estMasquante(question, modalite)\">Vous poursuivez le chapitre sans elle<span \nng-if=\"question.consequence.nbQuestionsMasquees > 1\">s</span>.</span></span></span></button></div>");
$templateCache.put("app/main/front/auto-evaluation/questionnaire/questionnaire.html","<section class=\"nl-Page aeq\"><div class=\"nl-H1\"><div style=\"padding: 0; min-height: 3.4rem\">Auto-évaluation {{annee}}\n</div><div layout=\"row\" layout-align=\"end center\"><span class=\"aeq-savechip aeq-savechip--encours\" \nng-if=\"etatEnregistrement === \'encours\'\"><span class=\"aeq-gd\"></span>Enregistrement… </span><span class=\"aeq-savechip\" \nng-if=\"etatEnregistrement === \'ok\'\"><span class=\"aeq-gd\"></span>Enregistré à l\'instant </span><span \nclass=\"aeq-savechip aeq-savechip--erreur\" ng-if=\"etatEnregistrement === \'erreur\'\"><span class=\"aeq-gd\"></span>\nErreur d\'enregistrement</span></div></div><div class=\"nl-Content\"><div class=\"aeq-crumb\"><a \nui-sref=\"app.performances.mes-evaluations\">Mes évaluations</a> <span class=\"aeq-sep\">/</span> <span>\nAuto-évaluation {{annee}}</span> <span class=\"aeq-sep\">/</span> <span class=\"aeq-cur\">Questionnaire</span></div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">{{erreur.message}}</div><div class=\"aeq-note aeq-note--warn\" \nng-if=\"erreurEnregistrement\"><b>Votre dernière réponse n\'a pas pu être enregistrée.</b>\n {{erreurEnregistrement.message}}</div><div ng-if=\"!chargement && parcours\"><div class=\"aeq-stepper\"><div \nclass=\"aeq-step\" ng-repeat=\"etape in parcours.chapitres track by etape.id\" \nng-class=\"{\'aeq-step--fait\': etape.statut === \'REPONDU\',\n								\'aeq-step--courant\': chapitre.id === etape.id,\n								\'aeq-step--avenir\': etape.statut === \'A_VENIR\',\n								\'aeq-step--masque\': etape.statut === \'NON_CONCERNE\'}\" \nng-click=\"allerAuChapitre(etape)\" title=\"{{libelleEtape(etape)}}\"><span class=\"aeq-step-dot\" \nng-style=\"{background: etape.statut === \'REPONDU\' ? etape.couleurHex : null,\n									 borderColor: etape.statut === \'REPONDU\' ? etape.couleurHex : null}\">\n<svg class=\"aeq-step-coche\" ng-if=\"etape.statut === \'REPONDU\'\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 8.4l3.4 3.4L13 4.8\">\n</path></svg> <span ng-if=\"etape.code\">{{etape.code}}</span> <svg ng-if=\"!etape.code && etape.type === \'PROFIL\'\" \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"8\" cy=\"5.6\" r=\"2.6\"></circle><path \nd=\"M3.2 13.2c.7-2.3 2.5-3.5 4.8-3.5s4.1 1.2 4.8 3.5\"></path></svg> <svg ng-if=\"!etape.code && etape.type !== \'PROFIL\'\" \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M8 2.2l1.8 3.7 4 .6-2.9 2.8.7 4L8 11.4l-3.6 1.9.7-4L2.2 6.5l4-.6z\">\n</path></svg> </span><span class=\"aeq-step-lab\" ng-if=\"chapitre.id === etape.id\">{{etape.titre}}</span></div></div><div\n class=\"aeq-toolbar\"><button type=\"button\" class=\"nl-Btn aeq-btn--ghost\" ng-click=\"menuOuvert = !menuOuvert\">\nAller à un chapitre</button> <span class=\"aeq-prog\"><span class=\"aeq-progbar\"><span class=\"aeq-progfill\" \nng-style=\"{width: pourcentage() + \'%\'}\"></span></span> <span class=\"aeq-progval\">{{pourcentage()}} %</span> </span>\n<span class=\"aeq-reste\" ng-if=\"parcours.progression.enAttente > 0\">{{parcours.progression.enAttente}} question<span \nng-if=\"parcours.progression.enAttente > 1\">s</span> restante<span ng-if=\"parcours.progression.enAttente > 1\">s</span>\n</span></div><div class=\"aeq-menu\" ng-if=\"menuOuvert\"><div class=\"aeq-menu-item\" \nng-repeat=\"item in parcours.chapitres track by item.id\" \nng-class=\"{\'aeq-menu-item--inactif\': !item.cliquable,\n								\'aeq-menu-item--courant\': chapitre.id === item.id}\" \nng-click=\"allerAuChapitre(item)\"><span class=\"aeq-ccode\" ng-if=\"item.code\" ng-style=\"{background: item.couleurHex}\">\n{{item.code}}</span> <span class=\"aeq-ccode aeq-ccode--pict\" ng-if=\"!item.code\"><svg ng-if=\"item.type === \'PROFIL\'\" \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"8\" cy=\"5.6\" r=\"2.6\"></circle><path \nd=\"M3.2 13.2c.7-2.3 2.5-3.5 4.8-3.5s4.1 1.2 4.8 3.5\"></path></svg> <svg ng-if=\"item.type !== \'PROFIL\'\" \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M8 2.2l1.8 3.7 4 .6-2.9 2.8.7 4L8 11.4l-3.6 1.9.7-4L2.2 6.5l4-.6z\">\n</path></svg> </span><span class=\"aeq-menu-titre\">{{item.titre}}</span> <span class=\"aeq-menu-statut\"><span \nng-if=\"item.type === \'PROFIL\'\">Profil</span> <span ng-if=\"item.type === \'BAROMETRE\'\">Baromètre</span> <span \nng-if=\"item.type === \'STANDARD\' && item.statut === \'REPONDU\'\">répondu</span> <span \nng-if=\"item.type === \'STANDARD\' && item.statut === \'EN_COURS\'\">en cours</span> <span \nng-if=\"item.type === \'STANDARD\' && item.statut === \'A_VENIR\'\">à venir</span> <span \nng-if=\"item.statut === \'NON_CONCERNE\'\">non concerné</span></span></div></div><div \nclass=\"aeq-note aeq-note--warn aeq-alerte\" ng-if=\"alerteCompletude\"><span><b>\nToutes les questions doivent être répondues avant de continuer</b> — {{alerteCompletude.nombre}} question<span \nng-if=\"alerteCompletude.nombre > 1\">s</span> en attente dans «&nbsp;{{alerteCompletude.titre}}&nbsp;». </span><button \ntype=\"button\" class=\"nl-Btn aeq-btn--ghost\" ng-click=\"allerALaPremiereEnAttente()\">Aller à la question en attente\n</button> <button type=\"button\" class=\"aeq-fermer\" ng-click=\"fermerAlerte()\">&times;</button></div><div \nclass=\"aeq-note aeq-note--info aeq-alerte\" ng-if=\"messageRouvertes\"><span>Votre réponse a <b>rouvert des questions</b>\n qui étaient masquées : les chapitres concernés repassent en incomplet. </span><button type=\"button\" \nclass=\"aeq-fermer\" ng-click=\"fermerMessageRouvertes()\">&times;</button></div><div class=\"aeq-note aeq-note--neutre\" \nng-if=\"!parcours.modifiable\">Cette auto-évaluation n\'est plus modifiable ; vous pouvez la relire.</div><div \nclass=\"aeq-saute aeq-colonne\" ng-if=\"chapitre.chapitrePrecedentNonConcerne\"><div class=\"aeq-saute-tete\"><span \nclass=\"aeq-ccode\" ng-style=\"{background: chapitre.chapitrePrecedentNonConcerne.couleurHex}\">\n{{chapitre.chapitrePrecedentNonConcerne.code}}</span> <b>{{chapitre.chapitrePrecedentNonConcerne.titre}}</b> <span \nclass=\"aeq-pill aeq-pill--close\">non concerné</span></div><p ng-if=\"chapitre.chapitrePrecedentNonConcerne.declencheur\">\nVous avez répondu «&nbsp;<b>{{chapitre.chapitrePrecedentNonConcerne.declencheur.valeurLibelle}}</b>\n&nbsp;» à la question {{chapitre.chapitrePrecedentNonConcerne.declencheur.numero}}, «&nbsp;{{chapitre.chapitrePrecedentNonConcerne.declencheur.libelle | aeqLibelleQuestion}}&nbsp;» : \n<span ng-if=\"chapitre.chapitrePrecedentNonConcerne.declencheur.nbQuestionsMasquees > 1\">ses <b>\n{{chapitre.chapitrePrecedentNonConcerne.declencheur.nbQuestionsMasquees}} questions</b> ne vous sont pas posées.</span>\n <span ng-if=\"chapitre.chapitrePrecedentNonConcerne.declencheur.nbQuestionsMasquees === 1\">sa <b>question</b>\n ne vous est pas posée.</span></p><p class=\"aeq-hint\"><b>Cela ne vous fait rien perdre</b>\n : votre résultat est calculé sans ce chapitre, il n\'est pas compté à 0&nbsp;%.</p><button type=\"button\" \nclass=\"nl-Btn aeq-btn--ghost\" ng-click=\"revenirAuDeclencheur(chapitre.chapitrePrecedentNonConcerne)\">\nModifier ma réponse</button></div><div class=\"aeq-orientation aeq-colonne\" ng-if=\"modeOrientation && chapitre\"><div \nclass=\"aeq-orientation-eyebrow\">Question d\'orientation</div><div class=\"aeq-orientation-chap\"><span class=\"aeq-ccode\" \nng-style=\"{background: chapitre.couleurHex}\">{{chapitre.code}}</span> {{chapitre.titre}}</div><h3 \nclass=\"aeq-orientation-libelle\"><span class=\"aeq-qnum\">{{chapitre.questionFiltre.numero}}</span>\n {{chapitre.questionFiltre.libelle | aeqLibelleQuestion}}</h3><div \nng-repeat=\"question in [chapitre.questionFiltre] track by $index\"><div \nng-include=\"\'app/main/front/auto-evaluation/questionnaire/aeq-issues.html\'\"></div></div><div class=\"aeq-navrow\"><button\n type=\"button\" class=\"nl-Btn aeq-btn--ghost\" ng-click=\"precedent()\" ng-if=\"chapitre.precedentChapitreId\">Précédent\n</button> <button type=\"button\" class=\"nl-Btn aeq-btn--prim\" ng-click=\"suivant()\">Suivant</button></div></div><div \nclass=\"aeq-colonne\" ng-if=\"!modeOrientation && chapitre\"><div class=\"aeq-chaphead\"><span class=\"aeq-cpast\" \nng-if=\"chapitre.code\" ng-style=\"{background: chapitre.couleurHex}\">{{chapitre.code}}</span> <span \nclass=\"aeq-cpast aeq-cpast--pict\" ng-if=\"!chapitre.code\"><svg ng-if=\"chapitre.type === \'PROFIL\'\" viewBox=\"0 0 16 16\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n<circle cx=\"8\" cy=\"5.6\" r=\"2.6\"></circle><path d=\"M3.2 13.2c.7-2.3 2.5-3.5 4.8-3.5s4.1 1.2 4.8 3.5\"></path></svg> <svg \nng-if=\"chapitre.type !== \'PROFIL\'\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M8 2.2l1.8 3.7 4 .6-2.9 2.8.7 4L8 11.4l-3.6 1.9.7-4L2.2 6.5l4-.6z\"></path></svg> </span><span class=\"aeq-ctxt\"><span\n class=\"aeq-ct\">{{chapitre.titre}}</span> <span class=\"aeq-cs\">{{chapitre.nbActives}} question<span \nng-if=\"chapitre.nbActives > 1\">s</span></span> </span><span class=\"aeq-cprog\"><span class=\"aeq-progbar\"><span \nclass=\"aeq-progfill\" \nng-style=\"{width: (chapitre.nbActives ? (100 * chapitre.nbRepondues / chapitre.nbActives) : 0) + \'%\',\n										   background: chapitre.couleurHex}\">\n</span> </span><span class=\"aeq-cs\" ng-if=\"chapitre.nbEnAttente === 0\">\n{{chapitre.nbRepondues}} / {{chapitre.nbActives}} répondues</span> <span class=\"aeq-cs\" \nng-if=\"chapitre.nbEnAttente > 0\">{{chapitre.nbEnAttente}} question<span ng-if=\"chapitre.nbEnAttente > 1\">s</span>\n restante<span ng-if=\"chapitre.nbEnAttente > 1\">s</span> dans ce chapitre</span></span></div><div class=\"aeq-aide\" \nng-if=\"chapitre.nbEnAttente > 0\"><span>{{chapitre.nbEnAttente}} question<span ng-if=\"chapitre.nbEnAttente > 1\">s</span>\n sans réponse dans ce chapitre.</span> <button type=\"button\" class=\"nl-Btn aeq-btn--ghost\" \nng-click=\"allerALaPremiereEnAttente()\">Aller à la première question non répondue</button></div><div \nclass=\"aeq-note aeq-note--neutre\" ng-if=\"chapitre.type === \'BAROMETRE\'\">Vos réponses de satisfaction sont <b>collectées\n</b> pour aider PHSQ à faire progresser la démarche, mais <b>ne vous seront pas restituées</b>.</div><div \nclass=\"aeq-qcard aeq-qcard--filtre\" ng-if=\"chapitre.questionFiltre\" \nng-class=\"{\'aeq-qcard--attente\': chapitre.questionFiltre.enAttente}\"><div class=\"aeq-qtete\"><span class=\"aeq-qnum\">\n{{chapitre.questionFiltre.numero}}</span> <span class=\"aeq-qlib\">\n{{chapitre.questionFiltre.libelle | aeqLibelleQuestion}}</span> <span class=\"aeq-pill aeq-pill--attente\">\nquestion d\'orientation</span></div><div ng-repeat=\"question in [chapitre.questionFiltre] track by $index\"><div \nng-include=\"\'app/main/front/auto-evaluation/questionnaire/aeq-issues.html\'\"></div></div></div><div class=\"aeq-qcard\" \nng-repeat=\"question in chapitre.questions track by question.id\" id=\"aeq-q-{{question.id}}\" \nng-class=\"{\'aeq-qcard--signalee\': questionSignalee === question.id,\n								\'aeq-qcard--attente\': question.enAttente,\n								\'aeq-qcard--filtre\': question.consequence}\">\n<div class=\"aeq-qtete\"><span class=\"aeq-qnum\">{{question.numero}}</span> <span class=\"aeq-qlib\">\n{{question.libelle | aeqLibelleQuestion}}<a class=\"aeq-lien-question\" ng-if=\"question.lien\" \nng-href=\"{{urlLienQuestion(question.id)}}\" target=\"_blank\" rel=\"noopener\"><svg viewBox=\"0 0 16 16\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M9.5 2.5h4v4M13.5 2.5l-6 6M12 9.5v3a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3\"></path></svg><span>\n{{question.lien.libelle}}</span></a><a class=\"aeq-lien-question\" \nng-repeat=\"document in question.documents track by document.id\" ng-if=\"!question.focus\" \nng-href=\"{{urlRessource(document.id)}}\" target=\"_blank\" rel=\"noopener\"><svg viewBox=\"0 0 16 16\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M9.5 2.5h4v4M13.5 2.5l-6 6M12 9.5v3a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3\"></path></svg><span>\n{{document.libelle}}</span></a></span> <span class=\"aeq-pill aeq-pill--attente\" ng-if=\"question.consequence\">\nquestion d\'orientation</span></div><div ng-if=\"question.consequence\"><div \nng-include=\"\'app/main/front/auto-evaluation/questionnaire/aeq-issues.html\'\"></div></div><div class=\"aeq-modalites\" \nng-if=\"question.modalites.length && !question.consequence\"><button type=\"button\" class=\"aeq-modalite\" \nng-repeat=\"modalite in question.modalites track by modalite.valeur\" \nng-class=\"{\'aeq-modalite--choisie\': estChoisie(question, modalite)}\" ng-style=\"styleModalite(question, modalite)\" \nng-disabled=\"!parcours.modifiable\" ng-click=\"choisirValeur(question, modalite.valeur)\"><span class=\"aeq-rcd\" \nng-style=\"{background: modalite.couleurHex}\"></span> <span>{{modalite.libelleCourt || modalite.libelleLong}}</span>\n</button></div><div class=\"aeq-options\" ng-if=\"question.type === \'CHOIX\'\"><button type=\"button\" class=\"aeq-option\" \nng-repeat=\"option in question.options track by option.id\" \nng-class=\"{\'aeq-option--choisie\': estOptionRetenue(question, option)}\" ng-disabled=\"!parcours.modifiable\" \nng-click=\"basculerOption(question, option)\"><span class=\"aeq-case\" \nng-class=\"{\'aeq-case--ronde\': !question.choixMultiple}\"></span> <span>{{option.libelle}}</span></button><p \nclass=\"aeq-hint\" ng-if=\"question.choixMultiple\">Plusieurs réponses possibles.</p></div><div \nng-if=\"question.type === \'TEXTE_LIBRE\'\"><textarea class=\"aeq-textarea\" rows=\"4\" maxlength=\"2000\" \nng-model=\"question.reponse.texteLibre\" ng-disabled=\"!parcours.modifiable\" \nng-change=\"texteModifie(question, \'texteLibre\')\" ng-blur=\"texteTermine(question, \'texteLibre\')\" \nplaceholder=\"Votre réponse (facultative)\"></textarea></div><div class=\"aeq-commentaire\" \nng-if=\"question.commentaireActif\"><button type=\"button\" class=\"aeq-lien\" ng-click=\"basculerCommentaire(question)\"><span\n ng-if=\"!question.commentaireOuvert && !question.reponse.commentaire\">+ Ajouter un commentaire</span> <span \nng-if=\"question.commentaireOuvert || question.reponse.commentaire\">Commentaire</span></button><textarea \nclass=\"aeq-textarea\" rows=\"3\" maxlength=\"2000\" ng-if=\"question.commentaireOuvert || question.reponse.commentaire\" \nng-model=\"question.reponse.commentaire\" ng-disabled=\"!parcours.modifiable\" \nng-change=\"texteModifie(question, \'commentaire\')\" ng-blur=\"texteTermine(question, \'commentaire\')\" \nplaceholder=\"Précisez si vous le souhaitez\"></textarea></div><div class=\"aeq-focus\" ng-if=\"question.focus\"><div \nclass=\"aeq-focus-tete\" ng-if=\"question.focus.titre | aeqTitreFocus:question.libelle\">{{question.focus.titre}}</div><p \nclass=\"aeq-focus-texte\" ng-if=\"question.focus.texte\">{{question.focus.texte}}</p><p class=\"aeq-hint\" \nng-if=\"question.focus.statistiqueN1 !== null && question.focus.statistiqueN1 !== undefined\">\nEn {{question.focus.anneeN1}}, <b>{{question.focus.statistiqueN1}} %</b>\n des officines ont répondu «&nbsp;{{libelleReponse(question)}}&nbsp;» à cette question, comme vous.</p><div \nclass=\"aeq-ressources\" ng-if=\"question.focus.ressources.length\"><a \nng-repeat=\"ressource in question.focus.ressources track by ressource.id\" ng-href=\"{{urlRessource(ressource.id)}}\" \ntarget=\"_blank\" rel=\"noopener\">{{ressource.libelle}}</a></div></div><p class=\"aeq-signature\" \nng-if=\"modifieeParUnAutre(question)\">Modifié par {{question.reponse.auteurNom}} <span \nng-if=\"question.reponse.dateModification\">le {{question.reponse.dateModification | date:\'dd/MM/yyyy à HH:mm\'}}</span>\n</p></div><div class=\"aeq-navrow\"><button type=\"button\" class=\"nl-Btn aeq-btn--ghost\" ng-click=\"precedent()\" \nng-if=\"chapitre.precedentChapitreId\">Précédent</button> <span class=\"aeq-savechip\" ng-if=\"parcours.modifiable\"><span \nclass=\"aeq-gd\"></span>Réponses enregistrées </span><button type=\"button\" class=\"nl-Btn aeq-btn--prim\" \nng-click=\"suivant()\"><span ng-if=\"chapitre.suivantChapitreId\">Suivant</span> <span ng-if=\"!chapitre.suivantChapitreId\">\nFinaliser mon auto-évaluation</span></button></div></div></div></div></section>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-acces-officine.html","<md-dialog aria-label=\"Accès de l\'officine\" class=\"admin-dialog aeq-acces-dialog\"><div \nclass=\"admin-dialog__header admin-dialog__header--primary\"><div class=\"admin-dialog__icon-badge\"><md-icon \nmd-font-icon=\"icon-key\" class=\"s28\"></md-icon></div><div class=\"admin-dialog__heading\"><div \nclass=\"admin-dialog__title\">Accès de l\'officine</div><div class=\"admin-dialog__subtitle\">{{nom}}<span ng-if=\"cip\">\n · CIP {{cip}}</span><span ng-if=\"acces\"> · officine {{acces.nonLqo ? \'non LQO\' : \'LQO\'}}</span></div></div><md-button \nclass=\"md-icon-button admin-dialog__close\" ng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-dialog-content class=\"admin-dialog__body aeq-acces-corps\"><div \nclass=\"aeq-acces-chargement\" ng-if=\"chargement\"><md-progress-circular md-diameter=\"22px\" md-mode=\"indeterminate\">\n</md-progress-circular><span>Lecture des comptes de l\'officine…</span></div><div \nclass=\"aeq-acces-note aeq-acces-note--erreur\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s18\">\n</md-icon><span>{{erreur}}</span></div><div ng-if=\"acces\"><section class=\"aeq-acces-section\"><h4 \nclass=\"aeq-acces-intertitre\">Comptes qui reçoivent les e-mails de la campagne</h4><table class=\"aeq-tbl aeq-acces-tbl\">\n<thead><tr><th>Rôle</th><th>Nom</th><th>Adresse e-mail (identifiant)</th><th>Compte</th><th>Dernière connexion</th>\n</tr></thead><tbody><tr ng-repeat=\"compte in acces.comptes track by $index\"><td>\n{{compte.role === \'TITULAIRE\' ? \'Titulaire\' : \'Responsable qualité\'}}</td><td>{{compte.nom || \'—\'}}</td><td><span \nclass=\"aeq-acces-adresse\" ng-if=\"compte.mail\"><span class=\"aeq-acces-mail\">{{compte.mail}}</span> <button \ntype=\"button\" class=\"aeq-acces-copier\" ng-click=\"copier(compte.mail)\" title=\"Copier l\'adresse\">\n{{copiee === compte.mail ? \'Copiée\' : \'Copier\'}}</button> </span><span class=\"aeq-acces-faible\" ng-if=\"!compte.mail\">\nAucune adresse</span></td><td><span class=\"aeq-acces-etat aeq-acces-etat--err\" ng-if=\"!compte.mail\">Sans adresse</span>\n <span class=\"aeq-acces-etat aeq-acces-etat--ok\" ng-if=\"compte.mail && compte.active\">Activé</span> <span \nclass=\"aeq-acces-etat aeq-acces-etat--warn\" ng-if=\"compte.mail && !compte.active\" \ntitle=\"La personne n\'a pas encore créé son mot de passe\">Non activé</span></td><td class=\"aeq-mono\"><span \nng-if=\"compte.derniereConnexion\">{{compte.derniereConnexion | date:\'dd/MM/yyyy à HH:mm\'}}</span> <span \nclass=\"aeq-acces-faible\" ng-if=\"!compte.derniereConnexion\">Jamais</span></td></tr><tr ng-if=\"!acces.comptes.length\"><td\n colspan=\"5\" class=\"aeq-acces-faible\">Aucun compte titulaire ni responsable qualité actif.</td></tr></tbody></table><p \nclass=\"aeq-acces-hint\" ng-if=\"!vueAdmin\">\nUne adresse erronée ? Contactez PHSQ pour la faire corriger, puis renvoyez l\'e-mail.</p></section><section \nclass=\"aeq-acces-section\"><h4 class=\"aeq-acces-intertitre\">E-mails de la campagne {{annee}} envoyés à l\'officine</h4>\n<table class=\"aeq-tbl aeq-acces-tbl\" ng-if=\"acces.emails.length\"><thead><tr><th>Envoyé le</th><th>E-mail</th><th>À</th>\n<th>Par</th></tr></thead><tbody><tr ng-repeat=\"email in acces.emails track by $index\"><td \nclass=\"aeq-mono aeq-acces-date\">{{email.date | date:\'dd/MM/yyyy à HH:mm\'}}</td><td>{{email.libelle}}</td><td><span \nng-if=\"!email.aucunDestinataire\">{{email.destinataires.join(\', \')}}</span> <span class=\"aeq-acces-faible\" \nng-if=\"email.aucunDestinataire\">Aucun destinataire : rien n\'est parti</span></td><td \nng-class=\"{\'aeq-acces-faible\': email.par === \'Envoi automatique\'}\">{{email.par}}<span ng-if=\"email.parVous\"> (vous)\n</span></td></tr></tbody></table><p class=\"aeq-acces-vide\" ng-if=\"!acces.emails.length\">\nAucun e-mail de la campagne n\'a encore été envoyé à cette officine.</p></section><div \nclass=\"aeq-acces-note aeq-acces-note--warn\" ng-if=\"acces.aideMotDePasseOublie\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s18\"></md-icon><span><b>Le compte titulaire n\'est pas activé.</b>\n L\'e-mail de lancement des officines LQO ne contient que le lien de connexion. Pour se connecter, le titulaire clique sur \n<b>« Mot de passe oublié ? »</b> sur la page de connexion et saisit <span class=\"aeq-acces-kbd\">\n{{acces.adresseTitulaire}}</span>. Il reçoit un lien pour créer son mot de passe, et son compte est activé.</span>\n</div><div class=\"aeq-acces-note aeq-acces-note--info\" ng-if=\"acces.nonLqo && envoiEnvisageable() && !confirmation\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span>\nL\'e-mail de lancement des officines non LQO contient un <b>lien personnel de création de mot de passe</b>\n pour chaque compte, valable deux mois. Le lien reste le même d\'un envoi à l\'autre : un ancien e-mail retrouvé fonctionne aussi.\n</span></div><div class=\"aeq-acces-note aeq-acces-note--ok\" ng-if=\"confirmation\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s18\"></md-icon><span>E-mail mis en file à {{confirmation.a}} pour <b>{{confirmation.destinataires.join(\', \')}}\n</b>. Un nouvel envoi sera possible à <b>{{confirmation.prochain}}</b>.</span></div><div \nclass=\"aeq-acces-note aeq-acces-note--erreur\" ng-if=\"motifAffiche() || erreurEnvoi\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span>{{erreurEnvoi || motifAffiche()}}</span></div></div>\n</md-dialog-content><md-dialog-actions class=\"admin-dialog__actions aeq-acces-actions\"><span class=\"aeq-acces-pied\">\n<span ng-if=\"acces && envoiEnvisageable()\">L\'e-mail arrive en une à deux minutes. Pensez aux courriers indésirables.\n</span></span><md-button class=\"admin-dialog__btn admin-dialog__btn--ghost\" ng-click=\"fermer()\">Fermer</md-button>\n<md-button class=\"admin-dialog__btn admin-dialog__btn--primary admin-dialog__btn--primary-blue\" \nng-if=\"boutonVisible()\" ng-disabled=\"!acces.renvoiPossible || envoi\" ng-click=\"renvoyer()\" \ntitle=\"{{acces.refusRenvoi === \'RENVOI_RECENT\' ? \'Nouvel envoi possible à \' + heure(acces.prochainRenvoi) : \'\'}}\">\n<md-progress-circular md-diameter=\"18px\" md-mode=\"indeterminate\" ng-if=\"envoi\"></md-progress-circular><md-icon \nmd-font-icon=\"{{acces.refusRenvoi === \'RENVOI_RECENT\' ? \'icon-check\' : \'icon-email\'}}\" ng-if=\"!envoi\"></md-icon><span \nng-if=\"acces.refusRenvoi !== \'RENVOI_RECENT\'\">Renvoyer l\'e-mail de lancement</span> <span \nng-if=\"acces.refusRenvoi === \'RENVOI_RECENT\'\">Envoyé à {{heure(acces.dernierRenvoi)}}</span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-aide.html","<section class=\"aeq-aide\" ng-class=\"{\'is-ouvert\': ouvert}\"><button type=\"button\" class=\"aeq-aide-tete\" \nng-click=\"basculer()\" aria-expanded=\"{{ouvert}}\"><span class=\"aeq-aide-picto\" aria-hidden=\"true\">?</span> <span \nclass=\"aeq-aide-titres\"><span class=\"aeq-aide-titre\">{{titre || \'Aide de cette page\'}}</span> <span \nclass=\"aeq-aide-resume\" ng-if=\"resume\">{{resume}}</span> </span><span class=\"aeq-aide-action\">\n{{ouvert ? \'Masquer\' : \'Afficher\'}}</span> <span class=\"aeq-aide-fleche\" aria-hidden=\"true\"></span></button><div \nclass=\"aeq-aide-corps\" ng-if=\"ouvert\" ng-transclude></div></section>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-badge-ecart.html","<span class=\"aeq-ecart aeq-ecart--absent\" ng-if=\"absent\"><span class=\"aeq-ecart-tiret\">&mdash;</span> <em \nng-if=\"texteMotif\">{{texteMotif}}</em> </span><span class=\"aeq-ecart\" ng-if=\"!absent\" ng-class=\"\'aeq-ecart--\' + sens\">\n<span class=\"aeq-ecart-fleche\" ng-if=\"sens === \'hausse\'\">&#9650;</span> <span class=\"aeq-ecart-fleche\" \nng-if=\"sens === \'baisse\'\">&#9660;</span> <span>{{texte}}</span> <em ng-if=\"suffixe\">{{suffixe}}</em> </span>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-barre-empilee.html","<div class=\"aeq-barre\" ng-class=\"{\'aeq-barre--vide\': vide}\"><span class=\"aeq-barre-seg\" \nng-repeat=\"segment in segments track by segment.valeur\" ng-class=\"{\'aeq-barre-seg--pale\': segment.pale}\" \nng-style=\"{width: segment.largeur + \'%\', background: segment.couleur}\" title=\"{{segment.infobulle}}\"><span \nng-if=\"segment.afficheTexte\">{{segment.texte}}</span></span></div>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-boite-outils.html","<ul class=\"aeq-outils\" ng-if=\"outils.length\"><li class=\"aeq-outil\" ng-repeat=\"outil in outils track by outil.id\"><span \nclass=\"aeq-outil-type aeq-outil-type--{{etiquette(outil).type}}\" aria-hidden=\"true\">{{etiquette(outil).libelle}}</span>\n <span class=\"aeq-outil-titre\">{{outil.titre}}</span> <a class=\"aeq-outil-lien\" ng-href=\"{{url(outil)}}\" \ntarget=\"_blank\" rel=\"noopener\">{{outil.libelleLien}} <svg viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M2.5 8h11m0 0l-4-4m4 4l-4 4\"></path></svg></a></li></ul>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-focus-reseau.html","<section class=\"qs-config-card aeq-focus-reseau\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-lightbulb-outline\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">{{titre || \'Focus du réseau\'}}\n</h2><p class=\"qs-config-card-subtitle\">\nLes focus qui ressortent le plus : pour chacun, la part des officines validées qui ont donné la réponse qui le déclenche, du plus fréquent au moins fréquent.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"donnees.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{donnees.nbOfficines}} validée{{donnees.nbOfficines > 1 ? \'s\' : \'\'}}{{donnees.provisoire ? \' · provisoire\' : \'\'}}\n</span></header><div class=\"aeq-note aeq-note--info\" ng-if=\"!donnees.nbOfficines\">\nAucune officine validée sur ce périmètre : les taux se construiront à la première validation.</div><div \nclass=\"aeq-note aeq-note--info\" ng-if=\"donnees.nbOfficines && donnees.provisoire\"><b>Campagne en cours</b>\n : ces taux évoluent à chaque validation.</div><table class=\"aeq-tbl\" \nng-if=\"donnees.nbOfficines && donnees.focus.length\"><thead><tr><th>Focus</th><th class=\"aeq-focus-valeur\">Déclenché par\n</th><th>Part des officines</th><th ng-if=\"donnees.perimetre === \'GROUPEMENT\'\">National</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"f in donnees.focus track by f.questionId\"><td><b><span class=\"aeq-ccode\" ng-if=\"f.chapitreCode\" \nng-style=\"{background: f.chapitreCouleurHex}\">{{f.chapitreCode}}</span>\n{{(f.titre | aeqTitreFocus:f.libelleQuestion) || (f.libelleQuestion | aeqLibelleQuestion)}}</b><div \nclass=\"aeq-focus-question\">{{f.chapitreCode ? \'\' : f.chapitreTitre + \' · \'}}Question {{f.numero}}<span \nng-if=\"f.titre | aeqTitreFocus:f.libelleQuestion\"> · {{f.libelleQuestion | aeqLibelleQuestion}}</span></div></td><td \nclass=\"aeq-focus-valeur\">« {{f.libelleValeur}} »</td><td><span class=\"aeq-focus-part\" ng-if=\"aUneValeur(f.pct)\" \ntitle=\"{{f.nbDeclenches}} officine{{f.nbDeclenches > 1 ? \'s\' : \'\'}} sur {{f.nbRepondants}} ont répondu « {{f.libelleValeur}} »\">\n<span class=\"aeq-focus-jauge\"><span class=\"aeq-focus-jauge-fill\" ng-class=\"{\'is-attention\': f.attention}\" \nng-style=\"{width: f.pct + \'%\'}\"></span> </span><b class=\"aeq-mono\">{{f.pct | number:0}} %</b> <small \nclass=\"aeq-t-faible\">({{f.nbDeclenches}}/{{f.nbRepondants}})</small> </span><span class=\"aeq-t-faible\" \nng-if=\"!aUneValeur(f.pct)\" title=\"Aucune officine validée n\'a répondu à cette question\">—</span></td><td \nclass=\"aeq-mono\" ng-if=\"donnees.perimetre === \'GROUPEMENT\'\">\n{{aUneValeur(f.nationalPct) ? (f.nationalPct | number:0) + \' %\' : \'—\'}}</td><td><span \nclass=\"aeq-pill aeq-pill--alerte\" style=\"margin-left: 0\" ng-if=\"f.attention\" \ntitle=\"Au moins {{donnees.seuilAttention | number:0}} % des officines déclenchent ce focus\">attention</span></td></tr>\n</tbody></table><p class=\"aeq-hint\" ng-if=\"donnees.nbOfficines\">\nDénominateur : les officines validées ayant répondu à la question, « Non concerné » compris — le même que la statistique affichée dans l\'encart de focus des officines. Un focus déclenché par au moins \n<b>{{donnees.seuilAttention | number:0}} %</b> des officines porte la mention <b>attention</b>. <span \nng-if=\"donnees.perimetre === \'GROUPEMENT\'\">\nLa colonne National donne la même part sur l\'ensemble des officines validées.</span></p></section>");
$templateCache.put("app/main/front/auto-evaluation/partages/aeq-tableau-repartition.html","<table class=\"aeq-tbl\"><thead><tr><th>Chapitre</th><th>{{libelle(\'OUI\')}}</th><th>{{libelle(\'EN_COURS\')}}</th><th>\n{{libelle(\'NON\')}}</th><th>{{libelle(\'NON_CONCERNE\')}}</th></tr></thead><tbody><tr class=\"aeq-tbl-synthese\" \nng-if=\"global\"><td><b>Synthèse globale</b></td><td class=\"aeq-mono aeq-t-oui\">{{pourcent(global.pctOui) || \'—\'}}</td>\n<td class=\"aeq-mono aeq-t-encours\">{{pourcent(global.pctEnCours) || \'—\'}}</td><td class=\"aeq-mono aeq-t-non\">\n{{pourcent(global.pctNon) || \'—\'}}</td><td class=\"aeq-mono\">{{pourcent(global.pctNc) || \'—\'}}</td></tr><tr \nng-repeat=\"ligne in chapitres track by ligne.chapitreId\" ng-class=\"{\'aeq-tbl-nonconcerne\': !ligne.concerne}\"><td \nng-if=\"!ligne.concerne\" colspan=\"5\"><b><span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}\n</span> {{ligne.titre}}</b> <span class=\"aeq-tbl-nonconcerne-txt\">non concerné<span ng-if=\"ligne.declencheur\">\n &mdash; vous avez répondu «&nbsp;{{ligne.declencheur.valeurLibelle}}&nbsp;» à la question {{ligne.declencheur.numero}}, \n<span ng-if=\"ligne.declencheur.nbQuestionsMasquees > 1\">\nses {{ligne.declencheur.nbQuestionsMasquees}}&nbsp;questions ne vous ont pas été posées</span><span \nng-if=\"ligne.declencheur.nbQuestionsMasquees === 1\">sa question ne vous a pas été posée</span></span>\n. Votre résultat est calculé sans ce chapitre : il n\'est pas compté à 0&nbsp;%.</span></td><td ng-if=\"ligne.concerne\">\n<b><span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span> {{ligne.titre}}</b></td><td \nclass=\"aeq-mono aeq-t-oui\" ng-if=\"ligne.concerne\">{{pourcent(ligne.pctOui) || \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-encours\" ng-if=\"ligne.concerne\">{{pourcent(ligne.pctEnCours) || \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-non\" ng-if=\"ligne.concerne\">{{pourcent(ligne.pctNon) || \'—\'}}</td><td class=\"aeq-mono\" \nng-if=\"ligne.concerne\">{{pourcent(ligne.pctNc) || \'—\'}}</td></tr></tbody></table><p class=\"aeq-hint\">\nLe tiret «&nbsp;—&nbsp;» signale un chapitre dont <b>aucune question n\'ouvre le «&nbsp;Non concerné&nbsp;»</b>\n — à ne pas confondre avec 0&nbsp;%. Les questions d\'orientation et les questions non affichées n\'entrent pas dans le calcul.\n</p>");
$templateCache.put("app/main/front/auto-evaluation/recap/recap.html","<section class=\"nl-Page aeq\"><div class=\"nl-H1\"><div style=\"padding: 0; min-height: 3.4rem\">\nAuto-évaluation {{annee}} — récapitulatif</div></div><div class=\"nl-Content\"><div class=\"aeq-crumb\"><a \nui-sref=\"app.performances.mes-evaluations\">Mes évaluations</a> <span class=\"aeq-sep\">/</span> <span>\nAuto-évaluation {{annee}}</span> <span class=\"aeq-sep\">/</span> <span class=\"aeq-cur\">Récapitulatif</span></div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">{{erreur.message}}</div><div ng-if=\"!chargement && recap\"><div \nclass=\"aeq-carte aeq-carte--validee\"><div class=\"aeq-note aeq-note--ok\">Votre auto-évaluation {{annee}} est <b>validée\n</b> <span ng-if=\"recap.dateValidation\">le {{recap.dateValidation | date:\'dd/MM/yyyy à HH:mm\'}}</span> <span \nng-if=\"recap.validantNom\">par {{recap.validantNom}}</span>. Vos réponses sont désormais figées.</div><p \nclass=\"aeq-hint\" ng-if=\"recap.emailProgramme\">\nUn e-mail récapitulatif vous est envoyé, avec votre rapport de synthèse et <b>{{recap.nbPointsAttention}} point<span \nng-if=\"recap.nbPointsAttention > 1\">s</span> d\'attention</b>.</p><p class=\"aeq-hint\" \nng-if=\"recap.rapportEtat === \'EN_COURS\'\">\nVotre rapport de synthèse est en cours de préparation ; il apparaîtra dans «&nbsp;Mes évaluations&nbsp;» dès qu\'il sera prêt.\n</p></div><div class=\"aeq-carte\" ng-if=\"recap.pointsAttention.length\"><h4>Points d\'attention <small>\n{{recap.pointsAttention.length}} question<span ng-if=\"recap.pointsAttention.length > 1\">s</span> focus déclenchée<span \nng-if=\"recap.pointsAttention.length > 1\">s</span></small></h4><div class=\"aeq-focus\" \nng-repeat=\"point in recap.pointsAttention track by point.questionId\"><div class=\"aeq-focus-tete\" \nng-if=\"point.titre | aeqTitreFocus:point.libelleQuestion\">{{point.titre}}</div><p class=\"aeq-hint\"><b>\n{{point.chapitreCode}} · {{point.chapitreTitre}}</b>\n — question {{point.numero}} : «&nbsp;{{point.libelleQuestion}}&nbsp;», vous avez répondu «&nbsp;<b>\n{{point.valeurLibelle}}</b>&nbsp;».</p><p class=\"aeq-focus-texte\">{{point.texte}}</p><p class=\"aeq-hint\" \nng-if=\"point.statistiqueN1 !== null && point.statistiqueN1 !== undefined\">En {{point.anneeN1}}, <b>\n{{point.statistiqueN1}} %</b>\n des officines ont répondu «&nbsp;{{point.valeurLibelle}}&nbsp;» à cette question, comme vous.</p><div \nclass=\"aeq-ressources\" ng-if=\"point.ressources.length\"><a \nng-repeat=\"ressource in point.ressources track by ressource.id\" ng-href=\"{{urlRessource(ressource.id)}}\" \ntarget=\"_blank\" rel=\"noopener\">{{ressource.libelle}}</a></div></div></div><div class=\"aeq-carte\" \nng-if=\"!recap.pointsAttention.length\"><div class=\"aeq-note aeq-note--ok\">\nAucun point d\'attention n\'a été déclenché par vos réponses.</div></div><div class=\"aeq-navrow\"><button type=\"button\" \nclass=\"nl-Btn aeq-btn--ghost\" ui-sref=\"app.performances.mes-evaluations\">Retour à Mes évaluations</button> <button \ntype=\"button\" class=\"nl-Btn aeq-btn--prim\" ng-click=\"voirResultats()\">Voir mes résultats</button></div></div></div>\n</section>");
$templateCache.put("app/main/front/auto-evaluation/resultats/resultats.html","<section class=\"nl-Page aeq\"><div class=\"nl-H1\"><div style=\"padding: 0; min-height: 3.4rem\">\nAuto-évaluation {{annee}} — mes résultats</div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"resultats.rapport.etat === \'DISPONIBLE\'\"><button type=\"button\" class=\"nl-Btn\" ng-click=\"telecharger()\" \nng-disabled=\"telechargement\">Télécharger mon rapport</button></div></div><div class=\"nl-Content\"><div \nclass=\"aeq-crumb\"><a ui-sref=\"app.performances.mes-evaluations\">Mes évaluations</a> <span class=\"aeq-sep\">/</span> \n<span>Auto-évaluation {{annee}}</span> <span class=\"aeq-sep\">/</span> <span class=\"aeq-cur\">Résultats</span></div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">{{erreur.message}}</div><div ng-if=\"!chargement && resultats\"><div \nclass=\"aeq-carte aeq-carte--validee\"><div class=\"aeq-statusrow\"><span>Auto-évaluation validée <span \nng-if=\"resultats.dateValidation\">le {{resultats.dateValidation | date:\'dd/MM/yyyy\'}}</span> <span \nng-if=\"resultats.validantNom\">par {{resultats.validantNom}}</span> </span><span class=\"aeq-score\" \nng-if=\"score() !== null\">Score global <b>{{score()}} %</b></span></div></div><div class=\"aeq-note aeq-note--info\" \nng-if=\"resultats.statutCampagne !== \'CLOTUREE\'\"><b>\nLa moyenne de votre groupement sera disponible après la clôture de la campagne</b>\n : tant que des officines remplissent encore, elle changerait chaque jour. Votre évolution par rapport à l’an dernier, elle, est consultable dès maintenant.\n</div><div class=\"aeq-carte\"><h4>Ma répartition par chapitre <small>% de mes réponses · chapitres standards</small>\n</h4><aeq-tableau-repartition global=\"resultats.global\" chapitres=\"resultats.chapitres\" palette=\"resultats.palette\">\n</aeq-tableau-repartition><p class=\"aeq-hint\" ng-if=\"resultats.chapitresExclus.length\"><b>\n{{resultats.chapitresExclus.join(\' et \')}}</b> ne <span ng-if=\"resultats.chapitresExclus.length > 1\">sont</span><span \nng-if=\"resultats.chapitresExclus.length === 1\">est</span> pas compté<span ng-if=\"resultats.chapitresExclus.length > 1\">\ns</span> dans les pourcentages.</p><div class=\"aeq-hgrid\"><div class=\"aeq-hrow aeq-hrow--synthese\" \nng-if=\"resultats.global\"><span class=\"aeq-hlab\"><b>Synthèse globale</b></span><aeq-barre-empilee \nligne=\"resultats.global\" palette=\"resultats.palette\"></aeq-barre-empilee></div><div class=\"aeq-hrow\" \nng-repeat=\"ligne in chapitresConcernes track by ligne.chapitreId\"><span class=\"aeq-hlab\"><span class=\"aeq-cdot\" \nng-style=\"{background: ligne.couleurHex}\"></span> {{ligne.code}} · {{ligne.titre}}</span><aeq-barre-empilee \nligne=\"ligne\" palette=\"resultats.palette\"></aeq-barre-empilee></div></div></div><div class=\"aeq-carte\" \nng-if=\"resultats.pointsAttention.length\"><h4>Points d\'attention <small>{{resultats.pointsAttention.length}} question\n<span ng-if=\"resultats.pointsAttention.length > 1\">s</span> focus déclenchée<span \nng-if=\"resultats.pointsAttention.length > 1\">s</span></small></h4><div class=\"aeq-focus\" \nng-repeat=\"point in resultats.pointsAttention track by point.questionId\"><div class=\"aeq-focus-tete\" \nng-if=\"point.titre | aeqTitreFocus:point.libelleQuestion\">{{point.titre}}</div><p class=\"aeq-hint\"><b>\n{{point.chapitreCode}} · {{point.chapitreTitre}}</b> — question {{point.numero}}<span ng-if=\"point.libelleQuestion\">\n : «&nbsp;{{point.libelleQuestion}}&nbsp;»</span>, vous avez répondu «&nbsp;<b>{{point.valeurLibelle}}</b>&nbsp;».</p>\n<p class=\"aeq-focus-texte\" ng-if=\"point.texte\">{{point.texte}}</p><div class=\"aeq-ressources\" \nng-if=\"point.ressources.length\"><a ng-repeat=\"ressource in point.ressources track by ressource.id\" \nng-href=\"{{urlRessource(ressource.id)}}\" target=\"_blank\" rel=\"noopener\">{{ressource.libelle}}</a></div></div></div><div\n class=\"aeq-carte\" ng-if=\"resultats.satisfaction.questions.length\"><h4>Ma satisfaction <small>\nchapitre « Votre satisfaction » · hors score</small></h4><div class=\"aeq-note aeq-note--info\" \nng-if=\"!resultats.satisfaction.comparaisonDisponible\"><b>\nLe comparatif national sera disponible après la clôture de la campagne</b>\n : tant que des officines répondent encore, il changerait chaque jour.</div><div class=\"aeq-sat-resume\" \nng-if=\"resultats.satisfaction.comparaisonDisponible\"><div class=\"aeq-sat-chiffre\"><strong>\n{{aUneValeur(resultats.satisfaction.pctSatisfaits) ? (resultats.satisfaction.pctSatisfaits | number:0) + \' %\' : \'—\'}}\n</strong> <span>de vos réponses satisfaites</span></div><div class=\"aeq-sat-chiffre\"><strong>\n{{aUneValeur(resultats.satisfaction.nationalPctSatisfaits) ? (resultats.satisfaction.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}\n</strong> <span>National</span></div><aeq-badge-ecart valeur=\"resultats.satisfaction.ecartPts\" suffixe=\"\'vs national\'\">\n</aeq-badge-ecart></div><div><div class=\"aeq-sat-orow aeq-sat-orow--tete\" \nng-class=\"{\'aeq-sat-orow--sans-national\': !resultats.satisfaction.comparaisonDisponible}\"><span>Question</span> <span>\nVotre réponse</span> <span ng-if=\"resultats.satisfaction.comparaisonDisponible\">Répartition nationale</span> <span \nclass=\"aeq-sat-r\" ng-if=\"resultats.satisfaction.comparaisonDisponible\">Satisfaits</span></div><div \nclass=\"aeq-sat-orow\" ng-repeat=\"question in resultats.satisfaction.questions track by question.questionId\" \nng-class=\"{\'aeq-sat-orow--sans-national\': !resultats.satisfaction.comparaisonDisponible}\"><span><span \nclass=\"aeq-sat-num\">{{question.numero}}</span> {{question.libelle}}</span> <span><span \nclass=\"aeq-sat-rep aeq-sat-rep--long\" ng-if=\"question.valeur\" \nng-class=\"{\'aeq-sat-rep--fonce\': reponseFoncee(question.valeur)}\" ng-style=\"{background: question.couleurHex}\">\n{{question.valeurLibelle}}</span> <span class=\"aeq-sat-rep aeq-sat-rep--long aeq-sat-rep--vide\" \nng-if=\"!question.valeur\">—</span> </span><span ng-if=\"resultats.satisfaction.comparaisonDisponible\"><span \nclass=\"aeq-barre\" style=\"height: 20px\"><span class=\"aeq-barre-seg\" \nng-repeat=\"part in partsAvecValeur(question.national) track by part.cle\" \nng-class=\"{\'aeq-barre-seg--pale\': part.cle === \'NON_CONCERNE\' || part.cle === \'SATISFAIT\' || part.cle === \'INSATISFAIT\'}\" \nng-style=\"{width: part.pct + \'%\', background: part.couleurHex}\" title=\"{{part.libelle}} : {{part.pct | number:1}} %\">\n<span ng-if=\"part.pct >= 8\">{{part.pct | number:0}} %</span> </span></span></span><span class=\"aeq-sat-r\" \nng-if=\"resultats.satisfaction.comparaisonDisponible\">\n{{aUneValeur(question.nationalPctSatisfaits) ? (question.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}</span></div>\n</div><div class=\"aeq-sat-legende\" ng-if=\"resultats.satisfaction.comparaisonDisponible\"><span \nng-repeat=\"modalite in resultats.satisfaction.palette track by modalite.valeur\"><span class=\"aeq-sat-legende-dot\" \nng-style=\"{background: modalite.couleurHex}\"></span>{{modalite.libelle}}</span></div><div class=\"aeq-sat-commentaire\" \nng-if=\"resultats.satisfaction.commentaire\"><b>Votre commentaire</b>«&nbsp;{{resultats.satisfaction.commentaire}}&nbsp;»\n</div><p class=\"aeq-hint\"><b>Satisfaits</b>\n : «&nbsp;Très satisfait&nbsp;» et «&nbsp;Satisfait&nbsp;», rapportés aux réponses autres que «&nbsp;Non concerné&nbsp;». \n<span ng-if=\"resultats.satisfaction.comparaisonDisponible\">\nNational : les {{resultats.satisfaction.nationalEffectif}} officines validées du millésime.</span></p></div><div \nclass=\"aeq-carte\"><h4>Mon rapport de synthèse</h4><div class=\"aeq-note aeq-note--neutre\" \nng-if=\"resultats.rapport.etat === \'EN_COURS\'\">Votre rapport est <b>en cours de génération</b>\n. Cette page se met à jour automatiquement ; il sera aussi rangé dans «&nbsp;Mes évaluations&nbsp;».</div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"resultats.rapport.etat === \'ERREUR\'\">\nVotre rapport n\'a pas pu être produit. Réessayez plus tard ; si le problème persiste, signalez-le à PHSQ.</div><div \nng-if=\"resultats.rapport.etat === \'DISPONIBLE\'\"><p class=\"aeq-hint\">\nLe rapport reprend votre répartition, vos points d\'attention et le détail de vos réponses, avec le plan d\'action des «&nbsp;Non&nbsp;» et «&nbsp;En cours&nbsp;», puis votre satisfaction.\n</p><button type=\"button\" class=\"nl-Btn aeq-btn--prim\" ng-click=\"telecharger()\" ng-disabled=\"telechargement\">\nTélécharger mon rapport</button></div></div><div class=\"aeq-carte\" ng-if=\"resultats.comparaisonDisponible\"><h4>\n{{resultats.statutCampagne === \'CLOTUREE\' ? \'Comparaison au groupement\' : \'Comparaison à l’an dernier\'}}</h4><p \nclass=\"aeq-hint\" ng-if=\"resultats.statutCampagne === \'CLOTUREE\'\">\nComparez votre répartition à celle de votre réseau et à votre propre année précédente. Repère indicatif, <b>\nsans classement ni note</b>.</p><p class=\"aeq-hint\" ng-if=\"resultats.statutCampagne !== \'CLOTUREE\'\">\nComparez votre répartition à votre propre année précédente. La moyenne de votre réseau s’ajoutera à la clôture. Repère indicatif, \n<b>sans classement ni note</b>.</p><button type=\"button\" class=\"nl-Btn aeq-btn--prim\" ng-click=\"voirComparaison()\">\nOuvrir la comparaison</button></div></div></div></section>");
$templateCache.put("app/main/front/auto-evaluation/validation/validation.html","<section class=\"nl-Page aeq\"><div class=\"nl-H1\"><div style=\"padding: 0; min-height: 3.4rem\">\nAuto-évaluation {{annee}} — validation</div></div><div class=\"nl-Content\"><div class=\"aeq-crumb\"><a \nui-sref=\"app.performances.mes-evaluations\">Mes évaluations</a> <span class=\"aeq-sep\">/</span> <span>\nAuto-évaluation {{annee}}</span> <span class=\"aeq-sep\">/</span> <span class=\"aeq-cur\">Validation</span></div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"erreur && erreur.code !== \'INCOMPLET\'\">{{erreur.message}}</div><div \nclass=\"aeq-carte\" ng-if=\"!chargement && parcours\"><h4>Prêt à valider</h4><div class=\"aeq-statusrow\"><span>Complétude : \n<b>{{parcours.progression.repondues}} / {{parcours.progression.actives}} questions actives</b> </span><span \nclass=\"aeq-pill\" ng-class=\"complete() ? \'aeq-pill--ouverte\' : \'aeq-pill--attente\'\"><span class=\"aeq-pdot\"></span> <span\n ng-if=\"complete()\">Prêt à valider</span> <span ng-if=\"!complete()\">{{parcours.progression.enAttente}} en attente\n</span></span></div><div class=\"aeq-note aeq-note--warn\">La validation <b>fige votre auto-évaluation</b>\n. Elle ne pourra plus être réouverte pour modification.</div><div class=\"aeq-note aeq-note--neutre\" \nng-if=\"texteMotif()\">{{texteMotif()}}</div><div class=\"aeq-note aeq-note--warn\" ng-if=\"chapitresIncomplets.length\"><b>\nIl reste des questions sans réponse :</b><ul class=\"aeq-liste\"><li \nng-repeat=\"ligne in chapitresIncomplets track by ligne.chapitreId\"><a href=\"\" ng-click=\"allerAuChapitre(ligne)\">\n{{ligne.code}} · {{ligne.titre}}</a> — {{ligne.enAttente}} question<span ng-if=\"ligne.enAttente > 1\">s</span>\n en attente</li></ul></div><div class=\"aeq-navrow\"><button type=\"button\" class=\"nl-Btn aeq-btn--ghost\" \nng-click=\"retourQuestionnaire()\">Retour au questionnaire</button> <button type=\"button\" class=\"nl-Btn aeq-btn--prim\" \nng-disabled=\"!peutValider() || enCours\" title=\"{{texteMotif()}}\" ng-click=\"valider()\"><span ng-if=\"!enCours\">\nValider l\'auto-évaluation</span> <span ng-if=\"enCours\">Validation…</span></button></div></div></div></section>");
$templateCache.put("app/main/front/controle/trace/trace.html","<section class=\"nl-Page\"><h1 class=\"nl-H1--v2\"><a class=\"nl-H1--backBtn\" ng-click=\"goBack()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>\n{{traceToAdd.id ? \'Modifier la traçabilité\' : \'Nouveau tableau de traçabilité\'}}</div></h1><div class=\"nl-Content\"><div\n class=\"pt-20 pb-55\"><form name=\"addTrace\" novalidate ng-submit=\"addTrace.$valid && saveNewTrace()\"><div \nclass=\"nl-form-wrapper\" layout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nQuel nom souhaitez-vous donner à votre tableau ? <span class=\"asterix\">*</span></label><input class=\"iv-Input-input\" \ntype=\"text\" name=\"name\" ng-model=\"traceToAdd.name\" required><div ng-messages=\"addTrace.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><p \nclass=\"nl-Dialog__textInfos2\">\nDéfinissez ensuite le nombre et l’intitulé de vos colonnes. Une colonne correspond à la nature d’un élément à tracer.\n<br><span>Exemple : pour un tableau de relevé de température frigo, créez une colonne « Température ».</span></p>\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-container-readOnly\" flex=\"35\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon class=\"iv-Input-date-icon--fake\" md-svg-src=\"assets/icons/app/V3/calendar.svg\">\n</md-icon><input class=\"iv-Input-input\" type=\"text\" name=\"name\" disabled=\"disabled\"></div></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-container-readOnly pl-10\" flex=\"65\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">\n{{traceToAdd.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\'}} <span class=\"asterix\">*</span>\n</label><input class=\"iv-Input-input\" type=\"text\" name=\"rapporteur\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-repeat=\"param in traceToAdd.parameters\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">{{param.name}} <span class=\"asterix\" \nng-if=\"param.required\">*</span></label><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"iv-Checkbox--specialWrapper\"><input flex=\"auto\" ng-if=\"param.type === \'TEXT\'\" class=\"iv-Input-input\" \ntype=\"text\" name=\"param{{$index}}Name\" ng-model=\"param.value\" disabled=\"disabled\"><div class=\"iv-Input-date-wrapper\" \nng-if=\"param.type === \'DATE\'\" flex=\"auto\"><md-icon class=\"iv-Input-date-icon--fake\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><input class=\"iv-Input-input\" type=\"text\" name=\"name\" \ndisabled=\"disabled\"></div><md-checkbox ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-if=\"param.type === \'SUIVI\'\" \nflex=\"auto\" ng-model=\"param.value\" class=\"nl-Checkbox-trac iv-Checkbox mt-5\" disabled=\"disabled\"></md-checkbox>\n<md-select flex=\"auto\" class=\"iv-Input-select md-no-underline\" ng-if=\"param.type === \'LIST\'\" ng-model=\"param.value\">\n<md-option ng-repeat=\"option in param.options track by $index\" ng-value=\"option.name\" disabled=\"disabled\">\n{{option.name}}</md-option></md-select><md-select flex=\"auto\" class=\"iv-Input-select md-no-underline\" \nng-if=\"param.type === \'COLLABORATEUR\'\" ng-model=\"param.value\"><md-option \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\" disabled=\"disabled\">\n{{collaborateur.completeName}}</md-option></md-select></div><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item ng-if=\"$index > 0\"><md-button class=\"iv-Menu-dropdown-btn\" type=\"button\" \nng-click=\"upIndex($index)\">Déplacer vers le haut</md-button></md-menu-item><md-menu-item ng-if=\"!$last\"><md-button \nclass=\"iv-Menu-dropdown-btn\" type=\"button\" ng-click=\"downIndex($index)\">Déplacer vers le bas</md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" type=\"button\" ng-click=\"updateParam($index)\">Modifier</md-button>\n</md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" type=\"button\" ng-click=\"deleteRow($index)\">\nSupprimer</md-button></md-menu-item></md-menu-content></md-menu></div></md-input-container><div flex=\"100\" \nclass=\"mt-20 mb-10\"><button type=\"button\" class=\"iv-Btn\" ng-click=\"openAddColumn()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon><div>Ajouter une nouvelle colonne</div></button></div></div><div \nclass=\"nl-form-wrapper mt-40\" flex=\"100\" layout=\"row\" layout-align=\"end center\"><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" type=\"button\" ng-click=\"goBack()\">Annuler</button> <button \nclass=\"nl-Btn ml-10 nl-Btn--trac\" type=\"submit\" ng-disabled=\"loading\"><span ng-if=\"!loadingAdd\">\n{{traceToAdd.id ? \'Valider la modification\' : \'Valider la création\'}}</span><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></button></div></form></div></div></section>");
$templateCache.put("app/main/front/controle/trace/traces.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Autres traçabilités<div layout=\"row\" layout-align=\"center center\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--trac\" ng-click=\"openNewTrace()\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><div class=\"mr-5\">+</div><div>Nouveau tableau de traçabilité\n</div></button></div></h1><div class=\"nl-Content\"><div class=\"iv-SmallTabs-wrapper wrapper--trac\"><div \nclass=\"iv-SmallTabs-item item--trac\" ng-class=\"{\'iv-Tabs-item--active\': tabs.active}\" ng-click=\"switchTab(\'active\')\">\n<md-icon class=\"iv-SmallTabs-icon color-dys\" md-svg-src=\"assets/icons/app/V3/modify_tab.svg\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Tableaux actifs</div></div><div class=\"iv-SmallTabs-item item--trac\" \nng-class=\"{\'iv-Tabs-item--active\': tabs.modeles}\" ng-click=\"switchTab(\'modeles\')\"><md-icon \nclass=\"iv-SmallTabs-icon color-dys\" md-svg-src=\"assets/icons/app/V3/tabs/auto-eval.svg\" role=\"img\" aria-hidden=\"true\">\n</md-icon><div>Modèles</div></div><div class=\"iv-SmallTabs-item item--trac\" \nng-class=\"{\'iv-Tabs-item--active\': tabs.archive}\" ng-click=\"switchTab(\'archive\')\"><md-icon \nclass=\"iv-SmallTabs-icon color-dys\" md-svg-src=\"assets/icons/app/V3/history_tab.svg\" role=\"img\" aria-hidden=\"true\">\n</md-icon><div>Tableaux archivés</div></div></div><div class=\"pt-20 pb-55\"><div class=\"nl-listing mt-15\" \nng-if=\"tabs.active\"><div class=\"mb-30\"><button class=\"iv-BtnIconFill\" ng-click=\"openInfosTracePopup()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/information.svg\"></md-icon></button></div><div ng-repeat=\"trace in traces\" \nng-click=\"openTrace(trace)\"><div class=\"nl-listing-item--2\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" \nclass=\"flex\"><div class=\"flex layout-column\" layout=\"column\" ng-click=\"_display(audit)\" role=\"button\"><div \nclass=\"nl-list-item-title text-truncate ng-binding\">{{trace.name}}</div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"start center\"><md-menu class=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-if=\"document.pdf\"><md-button \nclass=\"iv-Menu-dropdown-btn\">Ouvrir</md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"archive(trace)\">Archiver</md-button></md-menu-item><md-menu-item ng-if=\"trace.index > 0\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-disabled=\"disabledIndex\" ng-click=\"upIndex(trace.id)\">Déplacer vers le haut</md-button>\n</md-menu-item><md-menu-item ng-if=\"trace.index < traces.length - 1\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-disabled=\"disabledIndex\" ng-click=\"downIndex(trace.id)\">Déplacer vers le bas</md-button></md-menu-item>\n</md-menu-content></md-menu></div><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\" \nclass=\"nl-listing-item-icon2\"></md-icon></div></div></div><div class=\"nl-listing mt-15\" ng-if=\"tabs.modeles\"><div \nclass=\"mb-30\">Les modèles de tableaux de traçabilités ci-dessous sont à votre disposition. Comment les utiliser ?<br>\n<span style=\"font-style: italic\">\nCliquez sur un tableau pour le visualiser. Cliquez ensuite sur &laquo; Adapter et utiliser ce modèle &raquo;, effectuez les adaptations souhaitées puis validez.\n<br>Le tableau apparaitra dans l\'onglet &laquo; Tableaux actifs &raquo;.<br></span>\nCes propositions ne sont pas limitantes, n\'hésitez pas à créer toute autre traçabilité avec la fonction &laquo; Nouveau tableau de traçabilité &raquo;.\n</div><div ng-repeat=\"trace in modeles\" ng-click=\"openModele(trace)\"><div class=\"nl-listing-item--2\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"\" class=\"flex\"><div class=\"flex layout-column\" layout=\"column\" \nng-click=\"_display(audit)\" role=\"button\"><div class=\"nl-list-item-title text-truncate ng-binding\">{{trace.name}}</div>\n</div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div class=\"iv-Menu mr-20\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"></div></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\" class=\"nl-listing-item-icon2\"></md-icon></div></div></div><div \nclass=\"nl-listing mt-15\" ng-if=\"tabs.archive\"><div ng-repeat=\"trace in tracesArchived\"><div class=\"nl-listing-item--2\" \nlayout=\"row\" layout-align=\"start center\"><div flex=\"\" class=\"flex\"><div class=\"flex layout-column\" layout=\"column\" \nrole=\"button\"><div class=\"nl-list-item-title text-truncate ng-binding\">{{trace.name}}</div></div></div><div \nflex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-20\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item ng-if=\"document.pdf\"><md-button class=\"iv-Menu-dropdown-btn\">Ouvrir</md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"desarchive(trace)\">Désarchiver</md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\" \nclass=\"nl-listing-item-icon2\"></md-icon></div></div></div></div></div></section>");
$templateCache.put("app/main/front/equipe/equipe/equipe.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Collaborateurs<div layout=\"row\" layout-align=\"center center\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"dialogSave(false) \">+ Nouveau collaborateur</button></div></h1><div \nclass=\"nl-Content\"><div class=\"mt-20\"><div class=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"collaborateur in collaborateurs track by $index\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div flex \nng-click=\"openFichePostefunction(collaborateur.id)\"><div><div class=\"nl-list-item-title\">\n{{collaborateur.surname}} {{collaborateur.name}}</div></div></div><div><md-menu class=\"iv-Menu mr-20\" \nmd-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"btn-menu\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nstyle=\"border-color: rgba(197, 220, 244, 1) !important\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \ntype=\"button \" ng-click=\"dialogSave(true, collaborateur) \">Modifier</md-button></md-menu-item><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" type=\"button \" ng-click=\"dialogDelete(collaborateur, $index) \">Supprimer</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></section>");
$templateCache.put("app/main/front/equipe/planning-general/add_evenement_popup.html","<md-dialog aria-label=\"dialog\" flex=\"40\" flex-sm=\"60\" flex-xs=\"80\"><form name=\"_form\" class=\"md-inline-form\" \nnovalidate ng-submit=\"_form.$valid && saveEvent()\"><md-toolbar layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\" ng-hide=\"event.id\">Ajouter un événement</div><div class=\"contact-name\" ng-show=\"event.id\">\nModifier un événement</div></div><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Titre<span ng-if=\"event.title == null\" class=\"asterix\">*</span>\n</label><input type=\"text\" name=\"title\" ng-model=\"event.title\" placeholder=\"\" required class=\"nl-Input-input\"><div \nng-messages=\"_form.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Lieu<span ng-if=\"event.location == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"location\" ng-model=\"event.location\" placeholder=\"\" required \nclass=\"nl-Input-input\"><div ng-messages=\"_form.location.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-checkbox ng-model=\"event.allDay\" \naria-label=\"Jour entier\" class=\"nl-Checkbox\">Jour entier</md-checkbox><div \nclass=\"mt-20 layout-row layout-align-start-start\" flex=\"100\"><md-input-container class=\"nl-Input-container\" flex=\"50\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">{{event.allDay ? \'Echéance\' : \'Date début\'}}<span \nng-if=\"event.startDate == null\" class=\"asterix\">*</span></label><div class=\"nl-Input-date-wrapper\"><md-icon \nng-click=\"event.isOpen = true\" class=\"nl-Input-date-icon\" md-svg-src=\"assets/icons/app/tracabilite/calendar.svg\">\n</md-icon><md-datepicker class=\"nl-Input-date\" name=\"dateStart\" md-open-on-focus md-is-open=\"event.isOpen\" \nmd-hide-icons=\"all\" required ng-model=\"event.startDate\" placeholder=\"\"></md-datepicker></div><div \nng-messages=\"_form.dateStart.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><md-input-container class=\"nl-Input-container\" md-no-float flex=\"50\" ng-if=\"!event.allDay\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">Heure de début</label><md-select \nng-model=\"event.startHoursDay\" placeholder=\"Heure de fin\" name=\"hours\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"hour in hourEvents\" \nng-value=\"hour.value\">{{hour.name}}</md-option></md-select></md-input-container></div><div \nclass=\"mt-20 layout-row layout-align-start-start\" flex=\"100\"><md-input-container class=\"nl-Input-container\" flex=\"50\" \nng-if=\"!event.allDay\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Date fin<span \nng-if=\"event.endDate == null\" class=\"asterix\">*</span></label><div class=\"nl-Input-date-wrapper\"><md-icon \nng-click=\"event.isOpen2 = true\" class=\"nl-Input-date-icon\" md-svg-src=\"assets/icons/app/tracabilite/calendar.svg\">\n</md-icon><md-datepicker class=\"nl-Input-date\" name=\"dateEnd\" md-open-on-focus md-is-open=\"event.isOpen2\" \nmd-hide-icons=\"all\" ng-model=\"event.endDate\" placeholder=\"\" ng-required=\"!event.allDay\" ng-disabled=\"event.allDay\">\n</md-datepicker></div><div ng-messages=\"_form.dateEnd.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div><div ng-message=\"mindate\"><span>Date fin incorrecte</span></div></div>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"50\" ng-if=\"!event.allDay\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Heure de fin</label><md-select ng-model=\"event.endHoursDay\" \nname=\"hours\" palceholder=\"Heure de fin\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"hour in hourEvents\" \nng-value=\"hour.value\">{{hour.name}}</md-option></md-select></md-input-container></div><div flex=\"100\">\n<md-input-container class=\"nl-Input-container\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nMe le rappeler :</label><md-select ng-model=\"event.reminder\" name=\"rappel\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"duration in _reminders\" \nng-value=\"duration.value\">{{duration.name}}</md-option></md-select></md-input-container></div><div class=\"mt-20\" \nflex=\"100\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Récurrence</label><md-select ng-disabled=\"editMode\" \nname=\"responsible\" ng-model=\"event.recurrence\" placeholder=\"\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\" ng-change=\"recurrenceChanged()\"><md-option [value]=\"null\">Aucune</md-option>\n<md-option class=\"nl-Select-dropdown-btn\" ng-value=\"_recurrence.value\" \nng-repeat=\"_recurrence in _recurrences | orderBy:\'index\'\">{{ _recurrence.libelle }}</md-option></md-select>\n</md-input-container></div><div flex=\"100\"><md-checkbox ng-model=\"updateFutureTasks.value\" \nng-if=\"event.id && _oldEvent.recurrence != null\" ng-disabled=\"disableCheckbox()\" class=\"nl-Checkbox\">\nAppliquer aux éléments futurs</md-checkbox></div><div flex=\"100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"mt-16\"><span class=\"nl-indicator-header-infos\" ng-show=\"event.id\">Document actuel : </span><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline nl-Btn--sm nl-Btn--truncated\" aria-label=\"Télécharger la pièce jointe\" \nng-if=\"event.attachmentOriginalName != null\" ng-click=\"_downloadAttachement(event)\">{{ event.attachmentOriginalName }}\n</button></div><div layout=\"row\" layout-align=\"start center\" class=\"mt-16\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore mr-8 mt-8\">Pièce jointe :</label><div file-upload-single></div>\n</div></div></div></md-dialog-content><md-dialog-actions><button id=\"boutonSendEvent\" \nng-disabled=\"!!intoSaving || !!working\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/confirm_event_popup.html","<md-dialog aria-label=\"Confirmation tâche\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" \nng-click=\"_hideConfirmEventPopUp()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\">{{_taskToConfirm.title}}</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Confirmez-vous que cette {{_taskToConfirm.event ? \'événement\' : \'tâche\'}} a été réalisée?\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"nl-Btn\" ng-click=\"_done()\">Oui</md-button>\n<md-button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_hideConfirmEventPopUp()\">Non</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/planning-general.html","<section class=\"nl-Page\"><div class=\"nl-H1\"><div style=\"padding: 0;min-height: 3.4rem\">Planning</div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"tabActive === tabs.task\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"addTaskOrEventPopup()\">+ Ajouter</button></div></div><div class=\"nl-Content\"><div \nclass=\"iv-SmallTabs-wrapper\"><div class=\"iv-SmallTabs-item\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.task }\" ng-click=\"tabActive = tabs.task\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/calendar_blue.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Tâches et RDV</div></div><div class=\"iv-SmallTabs-item\" ng-show=\"!$root.user.isMini\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.qualite}\" ng-click=\"tabActive = tabs.qualite\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/quality_blue.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Démarche qualité</div></div><div class=\"iv-SmallTabs-item\" \nng-show=\"!$root.user.isMini\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.checklist}\" \nng-click=\"tabActive = tabs.checklist\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/tabs/checklist.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon>\n<div>Checklist quotidienne</div></div></div><div ng-if=\"tabActive === tabs.task\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mt-20 mb-20\"><div class=\"iv-BtnDatePicker\"><button type=\"button\" \nng-click=\"previous(\'dateTask\')\"><md-icon md-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nng-click=\"dateFilter.isOpen = true\">{{dateFilter.dateTask | date:\'dd MMMM yyyy\'}}<md-datepicker \nclass=\"iv-BtnDatePicker__input\" md-is-open=\"dateFilter.isOpen\" md-hide-icons=\"all\" name=\"date\" md-open-on-focus \nng-change=\"listPlanning()\" ng-model=\"dateFilter.dateTask\" required></md-datepicker></div><button type=\"button\" \nng-click=\"next(\'dateTask\')\"><md-icon md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div><div \nlayout=\"row\" layout-align=\"end center\" ng-if=\"isMobile\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"nl-SearchBar nl-SearchBar--home\"><md-icon ng-click=\"resetFilters();searchDocuments()\" \nng-show=\"textFilter.value\" md-svg-src=\"assets/icons/app/V3/del.svg\" class=\"nl-SearchBar--icon--clean color-trac\">\n</md-icon><md-icon ng-click=\"listPlanning()\" md-svg-src=\"assets/icons/app/V3/search.svg\" \nclass=\"nl-SearchBar--icon--search--home color-trac\"></md-icon><md-input-container md-no-float \nclass=\"nl-Input-container nl-SearchBar--input\" flex=\"100\"><input class=\"nl-Input-input--searchHome\" \nplaceholder=\"Rechercher...\" type=\"text\" name=\"title\" ng-enter=\"listPlanning()\" ng-model=\"textFilter.value\">\n</md-input-container></div></div><div><button class=\"iv-BtnIconFill ml-15\" ng-click=\"showSynchroPopup()\"><img \nsrc=\"./assets/icons/app/V3/sync.svg\"></button><md-tooltip md-direction=\"top\" class=\"md-origin-special\">\nSynchroniser vos tâches et RDV avec votre agenda habituel</md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!isMobile\"><span class=\"mr-5\">Voir les tâches et RDV de</span><md-menu \nclass=\"iv-Filtre\" md-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"-12 35\"><button \naria-label=\"\" class=\"iv-Filtre-btn\" ng-click=\"$mdMenu.open($event)\"><span class=\"iv-Filtre-btn-title\">\n{{collaborateurID ==null ? \"Toute l\'équipe\" : collabValue }}</span><md-icon class=\"iv-Filtre-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/arrow_down.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"4\"><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterCollab(null);\" \nng-class=\"{\'iv-Menu-dropdown-btn--isActive\': collabValue === \'\' }\"><md-icon ng-if=\"collabValue !== \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><md-icon ng-if=\"collabValue === \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon>Toute l\'équipe</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"user in _users\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterCollab(user);\" \nng-class=\"{\'iv-Menu-dropdown-btn--isActive\': collabValue === user.name + \' \' + user.surname }\"><md-icon \nng-if=\"collabValue !== user.name + \' \' + user.surname\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>\n<md-icon ng-if=\"collabValue === user.name + \' \' + user.surname\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\">\n</md-icon>{{user.surname + \' \' + user.name}}</md-button></md-menu-item></md-menu-content></md-menu><div layout=\"row\" \nlayout-align=\"end center\" flex style=\"padding-left: 1.5rem\"><div class=\"nl-SearchBar nl-SearchBar--home\"><md-icon \nng-click=\"cancelSearch();searchDocuments()\" ng-show=\"textFilter.value\" md-svg-src=\"assets/icons/app/V3/del.svg\" \nclass=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon ng-click=\"listPlanning()\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\"></md-icon>\n<md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" flex=\"100\"><input \nclass=\"nl-Input-input--searchHome\" placeholder=\"Rechercher...\" type=\"text\" name=\"title\" ng-enter=\"listPlanning()\" \nng-model=\"textFilter.value\"></md-input-container></div></div><div><button class=\"iv-BtnIconFill ml-15\" \nng-click=\"showSynchroPopup()\"><img src=\"./assets/icons/app/V3/sync.svg\"></button><md-tooltip md-direction=\"top\" \nclass=\"md-origin-special\">Synchroniser vos tâches et RDV avec votre agenda habituel</md-tooltip></div></div></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-20 mb-20\" ng-if=\"isMobile\"><span class=\"mr-5\">\nVoir les tâches et RDV de</span><md-menu class=\"iv-Filtre\" md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"-12 35\"><button aria-label=\"\" class=\"iv-Filtre-btn\" \nng-click=\"$mdMenu.open($event)\"><span class=\"iv-Filtre-btn-title\">\n{{collaborateurID ==null ? \"Toute l\'équipe\" : collabValue }}</span><md-icon class=\"iv-Filtre-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/arrow_down.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"4\"><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterCollab(null);\" \nng-class=\"{\'iv-Menu-dropdown-btn--isActive\': collabValue === \'\' }\"><md-icon ng-if=\"collabValue !== \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon><md-icon ng-if=\"collabValue === \'\'\" \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon>Toute l\'équipe</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"user in _users\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterCollab(user);\" \nng-class=\"{\'iv-Menu-dropdown-btn--isActive\': collabValue === user.name + \' \' + user.surname }\"><md-icon \nng-if=\"collabValue !== user.name + \' \' + user.surname\" md-svg-src=\"./assets/icons/app/V3/checkmark_blue.svg\"></md-icon>\n<md-icon ng-if=\"collabValue === user.name + \' \' + user.surname\" md-svg-src=\"./assets/icons/app/V3/checkmark.svg\">\n</md-icon>{{user.surname + \' \' + user.name}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nlayout=\"row\" layout-align=\"space-between start\" layout-wrap><div flex=\"65\"><div class=\"nl-newLookBlock\"><div \nclass=\"nl-newLookBlock--header--2\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"nl-newLookBlock--header--title\">Tâches</div><div layout=\"row\" layout-align=\"end center\" layout-wrap><md-menu \nmd-position-mode=\"target-left target\" nl-menu-class=\"iv-Menu-dropdown-tag\" md-offset=\"0 20\"><button type=\"button\" \naria-label=\"Tag\" class=\"nl-newLookBlock-comment-tag mr-6\" ng-click=\"$mdMenu.open($event)\"><div class=\"mr-4\"><div \nng-if=\"!filterType.value || filterType.value == \'\'\">Filtrer par statut</div><div \nng-if=\"filterType.value == typeValues.notDone\">Tâches à faire</div><div ng-if=\"filterType.value == typeValues.late\">\nTâches en retard</div><div ng-if=\"filterType.value == typeValues.done\">Tâches terminées</div></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_down_no_color.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"resetFilters()\"><div>Aucun</div></md-button></md-menu-item><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"filterType.value = typeValues.notDone;switchType()\"><div>Tâches à faire</div>\n</md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"filterType.value = typeValues.late;switchType()\"><div>Tâches en retard</div></md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterType.value = typeValues.done;switchType()\"><div>\nTâches terminées</div></md-button></md-menu-item></md-menu-content></md-menu><div class=\"divider-vertical\" \nng-if=\"!$root.user.isMini\"></div><div class=\"iv-Cmt-tag-wrapper no--margin no--padding no-background\" \nng-if=\"filterType.tag\"><div class=\"iv-Cmt-item-W\"><div class=\"iv-Cmt-tag-item tag-filter no-border no-background\"><div \nstyle=\"max-width:100%\"><div class=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title text-bold\">\n{{filterType.tag.libelle}}</div></div></div><button type=\"button\" class=\"iv-Cmt-tag-item-delete\" \nng-click=\"filterTag(null)\"><md-icon class=\"tag-filter\" md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button>\n</div></div></div><md-menu ng-if=\"_tags.length > 0 && filterType.tag == null\" md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown-tag\" md-offset=\"0 20\"><button type=\"button\" aria-label=\"Tag\" \nclass=\"nl-newLookBlock-comment-tag ml-6\" ng-click=\"$mdMenu.open($event)\"><div>Filtrer par tag</div><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\">\n<md-menu-item ng-repeat=\"tag in _tags\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"filterTag(tag)\"><div>\n{{tag.libelle}}</div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"nl-newLookBlock-content\"><div class=\"nl-HomeList-item--full\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"task in tasks track by task.id\"><div layout=\"row\" ng-click=\"_edit(task)\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"mr-15\"><md-checkbox class=\"iv-Checkbox\" ng-click=\"$event.stopPropagation()\" \nng-change=\"setDone(task)\" ng-model=\"task.done\" aria-label=\"Checkbox\" md-no-ink></md-checkbox></div><div class=\"flex\" \nrole=\"button\"><div class=\"nl-list-item-title\" ng-class=\"{\'line-through\': task.done}\">{{task.title}}</div><div \nstyle=\"display: flex;flex-wrap: wrap;gap: 5px\"><div class=\"iv-Cmt-item-W\" ng-repeat=\"tag in task.tags\"><div \nclass=\"iv-planning-tag-item\"><div class=\"\" style=\"max-width:100%\"><div class=\"iv-Tabs-section-item-inner\"><div \nclass=\"iv-Tabs-section-item-title\">{{tag.libelle}}</div></div></div></div></div></div><div \nclass=\"nl-list-item-description\" ng-if=\"!task.reunion\">\n{{task.echeance | date: \"dd/MM/yyyy \'à\' HH:mm\"}} • {{task.responsable.name + \' \' + task.responsable.surname}}</div>\n</div></div><div layout=\"row\" layout-align=\"end center\"><div class=\"mr-5\"><button class=\"iv-BtnIcon\" type=\"button\" \nng-if=\"task.recurrence != null\"><md-icon md-svg-src=\"./assets/icons/app/V3/recurrence.svg\"></md-icon></button> <button \nclass=\"iv-BtnIcon\" type=\"button\" ng-click=\"_downloadAttachement(task)\" \nng-if=\"task.attachment != null && task.attachment.length > 0\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon></button> <button class=\"iv-BtnIcon\" type=\"button\" \nng-if=\"today > task.echeance && !task.done\"><md-icon md-svg-src=\"./assets/icons/app/V3/warning.svg\"></md-icon></button>\n</div><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button type=\"button\" aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"_edit(task)\">\n<div>Modifier</div></md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"_openDelete(task, true)\"><div>Supprimer</div></md-button>\n</md-menu-item><md-menu-item ng-if=\"!task.event && !task.reunion\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"_openHistory(task)\"><div>Voir l\'historique</div></md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></div></div></div><div flex=\"33\"><div class=\"nl-newLookBlock\"><div class=\"nl-newLookBlock--header--2\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"nl-newLookBlock--header--title flex-80\">RDV</div></div><div\n class=\"nl-newLookBlock-content\"><div class=\"nl-HomeList-item--full\" ng-click=\"_edit(event)\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"event in events track by event.id\"><div class=\"flex\" role=\"button\"><div \nclass=\"nl-list-item-title ng-binding\">{{event.title}}</div><div class=\"nl-list-item-description\" ng-if=\"!task.reunion\">\n{{event.echeance | date: \"dd/MM/yyyy \'à\' HH:mm\"}} • {{event.responsable.name + \' \' + event.responsable.surname}}</div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button type=\"button\" aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"_edit(event)\"><div>Modifier</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"_openDelete(event, true)\"><div>Supprimer</div></md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></div></div></div></div></div><div ng-if=\"tabActive === tabs.qualite\" ng-controller=\"DemarcheController\"><div \nclass=\"nl-Content\"><h2 class=\"nl-H2\">Tâches annuelles</h2><div class=\"nl-listing\" \nng-repeat=\"task in annualTasks track by $index\"><div class=\"nl-listing-item\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div \nclass=\"nl-list-item-description\"><span ng-if=\"task.echeance && !task.done\">\nA faire le {{task.echeance | date: \"dd/MM/yyyy\"}} <span ng-if=\"task.responsable\">\n• {{task.responsable.name + \" \" + task.responsable.surname}} </span></span><span ng-if=\"!task.echeance && !task.done\">\nA planifier </span><span ng-if=\"task.done\">Réalisé le {{task.echeance | date: \"dd/MM/yyyy\"}} <span \nng-if=\"task.responsable\">• {{task.responsable.name + \" \" + task.responsable.surname}}</span></span></div></div></div>\n<div layout=\"row\" layout-align=\"start center\"><div class=\"nl-dib\"><md-button ng-click=\"_edit(task, true)\" \nclass=\"nl-Btn nl-Btn--outline nl-Btn--sm m-0\" ng-if=\"task.echeance && !task.done\">Modifier</md-button><md-button \nng-click=\"_edit(task, true)\" class=\"nl-Btn nl-Btn--sm m-0\" ng-if=\"!task.echeance && !task.done\">Planifier</md-button>\n<md-icon class=\"icon-check nl-Icon-checked\" ng-if=\"task.done\"></md-icon></div></div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-if=\"annualTasks.length === 0\"><p>Aucune tâche annuelle...</p></md-list-item></div><h2\n class=\"nl-H2\">Initier la démarche qualité</h2><div class=\"nl-listing\"><div class=\"nl-listing-item\" \nng-repeat=\"task in tasksSelectedNotDone track by $index\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div class=\"nl-list-item-description\"><span \nng-if=\"task.echeance\">A faire le {{task.echeance | date: \"dd/MM/yyyy\"}} <span ng-if=\"task.responsable\">\n• {{task.responsable.name + \" \" + task.responsable.surname}} </span></span><span ng-if=\"!task.echeance\">A planifier\n</span></div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-dib\"><md-button \nng-click=\"_edit(task, false)\" class=\"nl-Btn nl-Btn--outline nl-Btn--sm m-0\" ng-if=\"task.echeance\">Modifier</md-button>\n<md-button ng-click=\"_edit(task, false)\" class=\"nl-Btn nl-Btn--sm m-0\" ng-if=\"!task.echeance\">Planifier</md-button>\n</div></div></div></div><md-list-item class=\"no-results md-white-bg\" ng-if=\"tasksSelectedNotDone.length === 0\"><p>\nBravo, choisissez vos prochaines tâches à planifier</p></md-list-item><button ng-click=\"goSelectionTasks()\" \nclass=\"nl-Btn ml-10 mb-10 mt-10\">Sélectionner 3 tâches</button></div><div class=\"nl-listing\"><div \nclass=\"nl-listing-item\" ng-repeat=\"task in tasksDone track by $index\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div \nclass=\"nl-list-item-description\">\nRéalisé le {{task.echeance | date: \"dd/MM/yyyy\"}} • {{task.responsable.name + \" \" + task.responsable.surname}}</div>\n</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-dib\"><md-icon \nclass=\"icon-check nl-Icon-checked\"></md-icon></div></div></div></div></div><button ng-hide=\"allLoaded.selectedDone\" \nng-click=\"getTasksSelectedDone(false)\" class=\"nl-Btn nl-Btn--outline ml-10 mb-25\">Charger plus</button></div></div><div\n ng-if=\"tabActive === tabs.checklist\"><div layout=\"row\" layout-align=\"space-between center\" class=\"mt-20 mb-20\"><div \nclass=\"iv-BtnDatePicker\"><button disabled=\"disabled\" type=\"button\"></button> <button type=\"button\" \nng-click=\"previous(\'dateCheck\')\"><md-icon md-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div>\n{{dateFilter.dateCheck | date:\'dd MMMM yyyy\'}}<md-datepicker class=\"iv-BtnDatePicker__input\" \nmd-is-open=\"dateFilter.isOpen\" md-hide-icons=\"all\" name=\"date\" md-open-on-focus ng-change=\"listPlanning()\" \nng-model=\"dateFilter.dateCheck\" required></md-datepicker></div><button type=\"button\" ng-if=\"canNext\" \nng-click=\"next(\'dateCheck\')\"><md-icon md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></button> <button \ndisabled=\"disabled\" type=\"button\"></button></div><div></div></div><div class=\"pb-10\"><h2 class=\"iv-H2\">\nChecklist quotidienne</h2></div><div class=\"nl-listing\"><div class=\"nl-listing-item\" \nng-repeat=\"check in checks track by check.id\"><div layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-checkbox ng-model=\"check.done\" aria-label=\"Tâche réalisée\" \nng-change=\"setCheckDone(check)\" class=\"nl-Checkbox iv-Checkbox\"></md-checkbox><div flex layout=\"row\" \nlayout-align=\"start center\" ng-click=\"openEditCheck(check)\"><div flex=\"50\" class=\"text-truncate nl-listing-item-title\" \nng-class=\"{\'line-through\': check.done}\">{{check.title}}</div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>{{check.date | date: \'dd/MM/yyyy\'}}</div></div></div></div><div \nflex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openEditCheck(check)\"><md-icon md-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon><div>Modifier</div>\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openDeleteCheck(check)\"><md-icon md-svg-src=\"./assets/icons/app/V3/delete.svg\">\n</md-icon><div>Supprimer</div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div \nclass=\"mt-25\" ng-if=\"!canNext\"><button class=\"iv-Btn\" type=\"button\" ng-click=\"openAddPopup();\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon><div>Ajouter 1 tâche à la checklist quotidienne</div></button></div>\n</div></div></section>");
$templateCache.put("app/main/front/equipe/projects/project.html","<section class=\"nl-Page\"><h1 class=\"nl-H1--v2\"><a class=\"nl-H1--backBtn\" ng-click=\"goBack()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>{{_project.name}}</div></h1><div \nclass=\"nl-Content\"><div class=\"pt-20 pb-55\"><form name=\"projectForm\" novalidate \nng-submit=\"projectForm.$valid && save()\"><div class=\"nl-form-wrapper\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><h2 class=\"nl-H2\">État d\'avancement</h2><div class=\"font-size-14\">\n{{realised}} {{realised > 1 ? \' tâches réalisées \' : \' tâche réalisée \'}} sur {{total}}</div><div \nstyle=\"position: relative;width:100%\"><md-progress-linear md-mode=\"determinate\" value=\"{{progress}}\">\n</md-progress-linear><span class=\"progress-label\" ng-style=\"{\'left\': progress + 3 + \'%\'}\">{{progress}}%</span></div><h2\n class=\"nl-H2\">Données du projet</h2><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label\n class=\"iv-Input-label md-no-float md-container-ignore\">Nom du projet <span class=\"asterix\">*</span></label><input \nclass=\"iv-Input-input\" type=\"text\" name=\"name\" ng-model=\"project.name\" required><div \nng-messages=\"projectForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Objectif</label><input class=\"iv-Input-input\" type=\"text\" \nname=\"objectiveTitle\" ng-model=\"project.objectiveTitle\"></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nDescription</label><textarea class=\"iv-Input-textarea\" type=\"text\" name=\"description\" ng-model=\"project.description\">\n</textarea></md-input-container><div flex=\"100\" class=\"mt-20 mb-10\"><div class=\"iv-Tabs-item-list\"><div \nclass=\"iv-Tabs-item-list-item\" ng-repeat=\"_element in project.tasks track by _element.id\" \nng-click=\"showElement(_element)\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mr-15\"><md-checkbox ng-change=\"_actionDecideeFaite(_element);\" \nng-click=\"$event.stopPropagation()\" class=\"iv-Checkbox\" ng-model=\"_element.done\" aria-label=\"Checkbox\" md-no-ink>\n</md-checkbox></div><div layout=\"row\" layout-align=\"start center\"><md-icon flex=\"auto\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div class=\"iv-Tabs-item-list-item-title\">\n{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\">\n<md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();showElement(_element)\">Afficher l\'aperçu</md-button></md-menu-item><md-menu-item \nng-if=\"$index > 0\"><md-button type=\"button\" ng-click=\"$event.stopPropagation();upIndex($index)\">Déplacer vers le haut\n</md-button></md-menu-item><md-menu-item ng-if=\"!$last\"><md-button type=\"button\" \nng-click=\"$event.stopPropagation();downIndex($index)\">Déplacer vers le bas</md-button></md-menu-item><md-menu-item>\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();_openDeleteTask(_element)\">Supprimer</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><button type=\"button\" class=\"mt-10 iv-Btn\" \nng-click=\"addTask()\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div>Planifier une tâche\n</div></button></div></div><div class=\"nl-form-wrapper mt-40\" flex=\"100\" layout=\"row\" layout-align=\"end center\"><button\n class=\"nl-Btn nl-Btn--outline--trac nl-Btn--outline\" type=\"button\" ng-click=\"goBack()\">Annuler</button> <button \nclass=\"nl-Btn nl-Btn--trac ml-10\" type=\"submit\" ng-disabled=\"loadingSave\"><md-progress-circular md-diameter=\"15px\" \nng-if=\"loadingSave\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingSave\">\nEnregistrer</span></button></div></form></div></div></section>");
$templateCache.put("app/main/front/equipe/projects/projects.html","<section class=\"iv-Page\"><h1 class=\"nl-H1\">Suivi de projets<div layout=\"row\" layout-align=\"center center\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--trac\" ng-click=\"openNewProject()\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><div class=\"mr-5\">+</div><div>Nouveau projet</div></button>\n</div></h1><div class=\"nl-Content\"><div class=\"iv-SmallTabs-wrapper wrapper--trac\"><div \nclass=\"iv-SmallTabs-item item--trac\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.actifs }\" \nng-click=\"tabActive = tabs.actifs\"><md-icon class=\"iv-SmallTabs-icon md-default-theme\" style=\"color: currentColor\" \nmd-svg-src=\"assets/icons/app/V3/modify_tab.svg\" role=\"img\" aria-hidden=\"true\"></md-icon><div>Projets actifs</div></div>\n<div class=\"iv-SmallTabs-item item--trac\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.archives}\" \nng-click=\"tabActive = tabs.archives\"><md-icon class=\"iv-SmallTabs-icon md-default-theme\" style=\"color: currentColor\" \nmd-svg-src=\"assets/icons/app/V3/history_tab.svg\" role=\"img\" aria-hidden=\"true\"></md-icon><div>Projets archivés</div>\n</div></div><div ng-if=\"tabActive === tabs.actifs\" class=\"pt-20\"><div ng-repeat=\"project in projects\" \nng-click=\"details(project)\"><div class=\"nl-listing-item--2\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" \nclass=\"flex\"><div class=\"flex layout-column\" layout=\"column\" role=\"button\"><div \nclass=\"nl-list-item-title text-truncate ng-binding\">{{project.name}}</div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"mr-20\"><button ng-show=\"project.confidential\" class=\"iv-BtnIcon-3\" \ntype=\"button\" ng-click=\"event.preventDefault()\"><md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon>\n</button><md-tooltip ng-show=\"project.confidential\" md-direction=\"bottom\">\nVisible uniquement par le titulaire et le Responsable Qualité</md-tooltip></div><div class=\"mr-20\" \nstyle=\"color: #3D94FF; font-weight: bold\" ng-if=\"project.totalTasks != 0\">\nRéalisé à {{project.realisedTasks/project.totalTasks*100 | number: 0}}%</div><div class=\"mr-20\" \nstyle=\"color: #3D94FF; font-weight: bold\" ng-if=\"project.totalTasks === 0\">Réalisé à 0%</div><md-menu \nclass=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"details(project)\">Afficher</md-button>\n</md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setConfidential(project)\"><div ng-if=\"!project.confidential\">\nMasquer pour l\'équipe</div><div ng-if=\"project.confidential\">Démasquer pour l\'équipe</div></md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setArchive(project, true)\">Archiver</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDelete(project)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n<div ng-if=\"tabActive === tabs.archives\" class=\"pt-20\"><div ng-repeat=\"project in archived\" \nng-click=\"details(project)\"><div class=\"nl-listing-item--2\" layout=\"row\" layout-align=\"start center\"><div flex=\"\" \nclass=\"flex\"><div class=\"flex layout-column\" layout=\"column\" role=\"button\"><div \nclass=\"nl-list-item-title text-truncate ng-binding\">{{project.name}}</div></div></div><div flex=\"nogrow\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"mr-20\"><button ng-show=\"project.confidential\" class=\"iv-BtnIcon-3\" \ntype=\"button\" ng-click=\"event.preventDefault()\"><md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon>\n</button><md-tooltip ng-show=\"project.confidential\" md-direction=\"bottom\">\nVisible uniquement par le titulaire et le Responsable Qualité</md-tooltip></div><div class=\"mr-20\" \nstyle=\"color: #3D94FF; font-weight: bold\" ng-if=\"project.totalTasks != 0\">\nRéalisé à {{project.realisedTasks/project.totalTasks*100 | number: 0}}%</div><div class=\"mr-20\" \nstyle=\"color: #3D94FF; font-weight: bold\" ng-if=\"project.totalTasks === 0\">Réalisé à 0%</div><md-menu \nclass=\"iv-Menu mr-20\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"details(project)\">Afficher</md-button>\n</md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setArchive(project, false)\">Désarchiver</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div></section>");
$templateCache.put("app/main/front/equipe/reunions/deleteReunion.dialog.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nSupprimer l\'ordre du jour</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer l\'ordre du jour de \"{{reunionToDelete.title}}\" ?</md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" ng-click=\"_delete(reunionToDelete.id)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_closeDialog()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/reunion.dialog.html","<md-dialog aria-label=\"dialog\" flex=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xs=\"80\"><form name=\"_form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"_form.$valid && __saveReunion(_form)\"><md-toolbar layout=\"column\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div\n class=\"contact-name\" ng-hide=\"_reunion.id\">Planifier une réunion</div><div class=\"contact-name\" ng-show=\"_reunion.id\">\nModifier la réunion</div></div><md-button class=\"md-icon-button\" ng-click=\"__closeDialog()\" aria-label=\"dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Titre<span ng-if=\"_reunion.title == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"title\" ng-model=\"_reunion.title\" placeholder=\"\" required \nclass=\"nl-Input-input\"><div ng-messages=\"_form.title.$error\" role=\"alert\"><div ng-message=\"required\">: <span>\nInformation requise</span></div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">Lieu<span ng-if=\"_reunion.lieu == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"lieu\" ng-model=\"_reunion.lieu\" placeholder=\"\" required class=\"nl-Input-input\">\n<div ng-messages=\"_form.lieu.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><div class=\"mt-20\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"start center\"><div \nflex=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"nl-Input-container\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Date début<span ng-if=\"_reunion.dateStart == null\" \nclass=\"asterix\">*</span></label><div class=\"nl-Input-date-wrapper\"><md-icon ng-click=\"_reunion.isOpen = true\" \nclass=\"nl-Input-date-icon\" md-svg-src=\"assets/icons/app/tracabilite/calendar.svg\"></md-icon><md-datepicker \nclass=\"nl-Input-date\" name=\"dateStart\" md-is-open=\"_reunion.isOpen\" md-hide-icons=\"all\" md-open-on-focus \nng-model=\"_reunion.dateStart\" placeholder=\"\" required ng-change=\"_dateStartHandle();\"></md-datepicker></div><div \nng-messages=\"_form.dateStart.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container></div><div flex=\"100\" flex-gt-sm=\"50\"><md-input-container class=\"nl-Input-container\">\n<md-select ng-model=\"_reunion.hourSelect\" name=\"hours\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"hour in hourEvents\" \nng-value=\"hour.value\">{{hour.name}}</md-option></md-select></md-input-container></div></div><div flex=\"100\">\n<md-input-container class=\"nl-Input-container\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nMe le rappeler :</label><md-select ng-model=\"_reunion.rappel\" name=\"rappel\" class=\"nl-Input-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-repeat=\"duration in _reminders\" \nng-value=\"duration.value\">{{duration.name}}</md-option></md-select></md-input-container></div><div class=\"mt-20\" \nflex=\"100\"><md-input-container class=\"nl-Input-container nl-noError\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Récurrence</label><md-select \nclass=\"nl-Input-select md-no-underline\" name=\"recurrence\" ng-model=\"_reunion.recurrence\" placeholder=\"\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" ng-value=\"_recurrence.value\" \nng-repeat=\"_recurrence in _recurrences | orderBy:\'index\'\">{{ _recurrence.libelle }}</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions><button \nng-disabled=\"_form.$invalid || isSaving\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/reunions.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Réunions<div layout=\"row\" layout-align=\"center center\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><button class=\"nl-Btn\" ng-disabled=\"loadingAddReunion\" \nng-click=\"_openDialog();\">+ Nouvelle réunion</button></div></h1><div class=\"nl-Content\"><div \nclass=\"iv-SmallTabs-wrapper\"><div class=\"iv-SmallTabs-item\" ng-click=\"setActive(tabs.reunion)\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.reunion}\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/tabs/auto-eval.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon>\n<div>Réunions en cours</div></div><div class=\"iv-SmallTabs-item\" ng-click=\"setActive(tabs.history)\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.history}\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/tabs/audit.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon><div>\nHistorique des comptes-rendus</div></div></div><div class=\"pt-20\"><div ng-if=\"tabActive === tabs.reunion\"><div \nng-if=\"_reunions == null || _reunions.length == 0\" class=\"iv-list-item-title text-center\">Aucune réunion planifiée\n</div><div ng-if=\"_reunions != null && _reunions.length > 0\"><div class=\"iv-list\"><div class=\"iv-list-item\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"_thisReunion in _reunions\" \nng-click=\"_openReunion(_thisReunion);\"><div><div class=\"nl-dib ml-5\"><div class=\"iv-list-item-title\">\n{{_thisReunion.title}}</div><div class=\"iv-list-item-description\">\nLe {{_thisReunion.dateStart | date:\"EEEE d MMMM y\"}} • {{_thisReunion.lieu}}</div></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-list-item-status mr-15\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"_thisReunion.statut != \'Ordre du jour en cours\'\" class=\"iv-list-item-warning\" \nmd-svg-src=\"./assets/icons/app/filtres/warning.svg\"></md-icon><div>{{_thisReunion.statut}}</div></div><md-menu \nclass=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/more.svg\"></md-icon></button><md-menu-content width=\"2\"><md-menu-item><md-button\n ng-click=\"_openReunion(_thisReunion)\">Renseigner</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"_thisReunion.deletable != false\"><md-button \nng-click=\"_openDelete(_thisReunion)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div></div>\n<button ng-if=\"numbers.hasMoreThanTen\" ng-hide=\"numbers.total <= _pages.nonArchive.output\" ng-click=\"getMore()\" \nclass=\"nl-Btn nl-Btn--outline ml-10\">Charger plus</button></div></div><div ng-if=\"tabActive === tabs.history\"><div \nclass=\"iv-list\"><div class=\"iv-list-item\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"_thisReunion in _reunionsArchive\" ng-click=\"_compteRendu(_thisReunion);\"><div><div class=\"nl-dib ml-5\"><div \nclass=\"iv-list-item-title\">{{_thisReunion.title}}</div><div class=\"iv-list-item-description\">\nLe {{_thisReunion.dateStart | date:\"EEEE d MMMM y\"}} • {{_thisReunion.lieu}}</div></div></div></div></div><button \nng-if=\"numbersArchive.hasMoreThanTen\" ng-hide=\"numbersArchive.total <= _pages.archive.output\" \nng-click=\"getMoreArchived()\" class=\"nl-Btn nl-Btn--outline ml-10\">Charger plus</button></div></div></div></section>");
$templateCache.put("app/main/front/equipe/taches-generales/confirm_delete_dialog.html","<md-dialog aria-label=\"Suppression\" flex=\"40\" flex-md=\"55\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nSuppression {{_task.title}}</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><span ng-if=\"_task.reunion\">Êtes-vous sûr de vouloir supprimer cette reunion ?</span> \n<span ng-if=\"_task.event\">Êtes-vous sûr de vouloir supprimer cet évènement ?</span> <span \nng-if=\"!_task.event && !_task.reunion\">Êtes-vous sûr de vouloir supprimer cette tâche ?</span><div \nng-if=\"_task.recurrence != null\"><br><md-checkbox ng-model=\"deleteRecurrentTasks.value\" class=\"nl-Checkbox\">\nSupprimer toutes les tâches liées à cette tâche récurrente</md-checkbox></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"_delete(_task)\" ng-disabled=\"loadingDeleteTask\"><md-progress-circular \nmd-diameter=\"15px\" ng-if=\"loadingDeleteTask\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span \nng-if=\"!loadingDeleteTask\" class=\"nl-Menu-btn-title\">Oui</span></button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"_closeDialog()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/taches-generales/confirm_done_dialog.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_dismissConfirmProgress();\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nValidation de la tâche</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>Confirmez-vous que cette tâche est effectuée ?\n</md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" ng-click=\"_done(_task, false)\">Oui</button> \n<button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_dismissConfirmProgress();\">Non</button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/front/equipe/taches-generales/confirm_progress_form.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"_hideConfirmEventPopUp();\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nClôture de la fiche de progrès associée</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" \nlayout=\"column\" layout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nConfirmez-vous que cette action correctrice a été réalisée et qu\'elle est efficace? Cela clôturera la fiche de progrès associée.\n</md-dialog-content><md-dialog-actions layout=\"row\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"_done(_task, false)\">Oui</button> <button type=\"button\" class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"_hideConfirmEventPopUp();\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/taches-generales/historique.html","<md-dialog aria-label=\"dialog\" flex=\"35\" flex-md=\"55\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nHistorique de {{_task.title}}</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div><p ng-if=\"historyLoading\">Chargement de l\'historique...</p><p \nng-repeat=\"history in taskHistories\">Tâche effectuée le {{history.validation | date: \"dd/MM/yyyy \'à\' HH:mm\"}}</p><p \nng-if=\"!historyLoading && taskHistories.length ===0\">Aucun historique disponible</p></div><div class=\"mt-45\" \nlayout=\"column\" layout-align=\"space-between center\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/front/equipe/taches-generales/tacheGenerales.dialog.html","<md-dialog aria-label=\"addTache\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"_form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"_form.$valid && __saveTask()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center center\" class=\"iv-Dialog__title-wrapper\" ng-if=\"!_from_FICHE && !_from_REUNION && !_from_AUDIT\">\n<div class=\"iv-Dialog__title\" ng-hide=\"_task.id\">Nouvelle tâche</div><div class=\"iv-Dialog__title\" ng-show=\"_task.id\">\nAperçu de la tâche</div></div><div layout=\"column\" layout-align=\"center center\" class=\"iv-Dialog__title-wrapper\" \nng-if=\"!!_from_FICHE\"><div class=\"iv-Dialog__title\">Planifier une action corrective<br>\nen vue de clôturer la fiche de progrès</div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"iv-Dialog__title-wrapper\" ng-if=\"!!_from_REUNION\"><div class=\"iv-Dialog__title\">Planifier une action décidée\n</div></div><div layout=\"column\" layout-align=\"center center\" class=\"iv-Dialog__title-wrapper\" ng-if=\"!!_from_AUDIT\">\n<div class=\"iv-Dialog__title\">Planifier la levée des écarts</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"iv-popup-disclaimer flex-100\" \nng-if=\"taskType != null\">{{taskType}}</div><md-checkbox ng-model=\"_task.done\" aria-label=\"Tâche réalisée\" \nclass=\"nl-Checkbox\">Cette tâche a déjà été réalisée</md-checkbox><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nIntitulé de la tâche<span class=\"asterix\" ng-if=\"_task.title == null\">*</span></label><input type=\"text\" name=\"title\" \nng-model=\"_task.title\" placeholder=\"\" required class=\"iv-Input-input\"><div ng-messages=\"_form.title.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Responsable<span class=\"asterix\" \nng-if=\"_task.responsable == null\">*</span></label><md-select name=\"responsable\" md-no-asterisk \nng-model=\"_task.responsable.id\" placeholder=\"\" required class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.responsable.id)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"_user.id\" ng-repeat=\"_user in _users track by _user.id\">\n{{_user.surname + \' \' + _user.name }}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"_form.responsable.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-5\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span ng-if=\"echeance == null\">*</span></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon ng-click=\"_tools.OPEN = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" name=\"echeance\" \nmd-is-open=\"_tools.OPEN\" ng-click=\"_tools.OPEN = true\" md-hide-icons=\"all\" ng-model=\"echeance\" placeholder=\"\" required>\n</md-datepicker></div><div ng-messages=\"_form.echeance.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-5\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Heure <span class=\"asterix\" ng-if=\"_task.heure == null\">*</span>\n</label><md-select name=\"heure\" md-no-asterisk ng-model=\"_task.heure\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.heure)\">\n<md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"hour in hours\" ng-value=\"hour\">{{hour}}</md-option></md-select>\n<div ng-messages=\"_form.heure.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-if=\"!_from_FICHE\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Récurrence</label><md-select \nname=\"responsible\" ng-model=\"_task.recurrence\" placeholder=\"\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"recurrenceChanged()\"><md-option class=\"iv-Select-dropdown-btn\" \n[value]=\"null\">Aucune</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"_recurrence.value\" \nng-repeat=\"_recurrence in _recurrences | orderBy:\'index\'\">{{_recurrence.libelle }}</md-option></md-select>\n</md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Description\n</label><textarea ng-model=\"_task.description\" name=\"description\" class=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" \nmd-no-resize></textarea><div ng-messages=\"_form.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><div class=\"nl-newLookBlock-comment-actions pt-20\" \nng-class=\"{\'pb-20\': !_task.tags || _task.tags.length === 0}\"><md-menu md-position-mode=\"target-left target\" flex=\"100\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" aria-label=\"Mention\" \nclass=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon><div>Associer à un ou plusieurs tags</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-repeat=\"tag in tags\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"selectTag(tag, _task)\"><div>{{tag.libelle}}</div></md-button></md-menu-item><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openTag()\"><div style=\"font-weight: bold\">+ Gérer mes tags</div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"iv-Cmt-tag-wrapper no--padding\" flex=\"100\" \nng-if=\"_task.tags.length > 0\" style=\"padding-bottom: 20px !important\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"tag in _task.tags\"><div class=\"iv-planning-tag-item\"><div style=\"max-width:100%\"><div \nclass=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title\">{{tag.libelle}}</div></div></div><button \ntype=\"button\" class=\"iv-Cmt-tag-item-delete\" ng-click=\"deleteTaskTag($index, _task)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div><div flex=\"100\" class=\"mt-10\" \nng-show=\"!_task.nameOfDocument && !_task.attachmentOriginalName && !_from_AUDIT\"><button flex=\"100\" class=\"iv-Btn\" \ntype=\"button\"><div class=\"iv-Btn__file\" file-upload-single></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nflex=\"100\" class=\"mt-10\" ng-if=\"(_task.nameOfDocument||_task.attachmentOriginalName) && !_from_AUDIT\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" \nng-if=\"_task.attachmentOriginalName != null\" ng-click=\"_downloadAttachement(_task)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ _task.attachmentOriginalName}}</div></div><div \nclass=\"iv-Btn\" ng-if=\"_task.nameOfDocument != null\"><div>{{ _task.nameOfDocument}}</div></div><button type=\"button\" \nclass=\"iv-BtnIcon iv-BtnIcon-2\" ng-click=\"clearInputFile(_task,\'document_input_file\');\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div><md-checkbox style=\"margin: 10px 0 0 0\" \nng-model=\"updateFutureTasks.value\" aria-label=\"Tâche réalisée\" ng-if=\"_task.id && _oldTask.recurrence != null\" \nng-disabled=\"_task.echeance != null && _oldTask.echeance === echeance.getTime() || _oldTask.recurrence !== _task.recurrence\" \nclass=\"nl-Checkbox\">Appliquer aux éléments futurs</md-checkbox></div></md-dialog-content><md-dialog-actions><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"_closeDialog()\" aria-label=\"Annuler\">Annuler</button> <button \nng-disabled=\"!!_isSaving\" id=\"btnSaveTache\" type=\"submit\" class=\"nl-Btn ml-10\" aria-label=\"Sauvegarder\">Sauvegarder\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/folder.html","<section class=\"nl-Page\"><h1 class=\"nl-H1--v2\" ng-if=\"!loadingFiles\"><a class=\"nl-H1--backBtn\" ng-href=\"./folders\">\n<md-icon md-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div><span class=\"nl-H1--fw\"><a \nng-href=\"./folders\">Base doc /</a> <a ng-href=\"{{buildBreadcrumb($index)}}\" \nng-repeat=\"breadcrumb in category.breadcrumbs\" ng-if=\"!$last\">{{breadcrumb.name}}&nbsp;/&nbsp;</a></span>\n{{folder.id ? folder.name : category.name}}</div></h1><div class=\"nl-Content\" ng-if=\"!loadingFiles\"><div \nclass=\"nl-listing doc-section mt-25\" ng-if=\"!searching\"><div class=\"doc-section__grid\" ng-if=\"category.parent == null\">\n<div class=\"doc-separator\" ng-repeat-start=\"child in category.childs track by child.id\" \nng-if=\"category.index === 0 && child.index === 5\"><md-icon md-svg-src=\"assets/icons/app/V3/sort_by.svg\"></md-icon>\n</div><div ng-repeat-end ng-click=\"openSubCat(category, child)\" class=\"doc-card doc-card--{{category.index}}\" \nng-class=\"{\'doc-card--{{category.index}}\': child.icon != \'folder.svg\', \'doc-card--folder\': child.icon == \'folder.svg\',\n            \'doc-card--active\': child.id === subCategoryId}\">\n<md-icon md-svg-src=\"assets/icons/app/V3/{{child.icon}}\"></md-icon><span>{{child.name}}</span></div></div><div \nclass=\"doc-section__grid\" ng-if=\"category.parent != null\"><div class=\"doc-separator\" \nng-repeat-start=\"child in category.parent.childs track by child.id\" \nng-if=\"category.parent.index === 0 && child.index === 5\"><md-icon md-svg-src=\"assets/icons/app/V3/sort_by.svg\">\n</md-icon></div><div ng-repeat-end ng-click=\"openSubCat(category.parent, child)\" class=\"doc-card\" \nng-class=\"{\'doc-card--{{category.parent.index}}\': child.icon != \'folder.svg\', \'doc-card--folder\': child.icon == \'folder.svg\',\n            \'doc-card--active\': child.id === subCategoryId}\" \ndrop=\"handleDrop\" droppable=\"child\" dropstyle=\"columnDrop\"><md-icon md-svg-src=\"assets/icons/app/V3/{{child.icon}}\">\n</md-icon><span>{{child.name}}</span></div></div></div><div layout=\"column\"><div class=\"mt-15\" \nng-if=\"category.parent && category.icon == \'folder.svg\'\" style=\"color: #EF5450; font-style: italic; font-size: 14pt\">\nDossier temporaire — Veuillez déplacer vos documents vers les nouveaux dossiers.</div><div class=\"mt-25\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"category.parent\"><div layout=\"row\" layout-align=\"space-between center\">\n<button ng-if=\"folder.folder\" class=\"mr-15 text-bold\" ng-click=\"backFolder(folder)\"><md-icon class=\"mr-5\" \nstyle=\"min-height: 19px !important; height: 19px !important\" md-svg-src=\"./assets/icons/app/V3/arrow_left.svg\">\n</md-icon>Retour</button><md-menu class=\"iv-Filtre--v2\" md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"-12 35\"><button aria-label=\"\" class=\"iv-Filtre-btn--v2\" \nng-click=\"$mdMenu.open($event)\"><span class=\"iv-Filtre-btn-title--v2\">Filtres</span><md-icon class=\"iv-Filtre-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/arrow_down_blue.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"4\"><md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"sortBy(\'name\', false); triIndex(\'Titre (A-Z)\');\" \nng-class=\"{\'iv-Menu-dropdown-btn--notActive\': triValue != \'Titre (A-Z)\'}\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><div>Nom</div></md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"sortBy(\'-uploadDate\', false); triIndex(\'Date décroissante\');\" \nng-class=\"{\'iv-Menu-dropdown-btn--notActive\': triValue != \'Date décroissante\'}\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><div>Date</div></md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'status\', \'WAITING\'); filterIndex(\'En attente\');\" \nng-class=\"{\'iv-Menu-dropdown-btn--notActive\': filterValue != \'En attente\'}\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><div>Fichiers non validés</div></md-button></md-menu-item>\n<md-menu-item md-menu-align-target><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setFilter(\'isRestricted\', \'true\'); filterIndex(\'Confidentiels\');\" \nng-class=\"{\'iv-Menu-dropdown-btn--notActive\': filterValue != \'Confidentiels\'}\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon><div>Masqués pour l\'équipe</div></md-button></md-menu-item>\n</md-menu-content></md-menu><button type=\"button\" class=\"nl-Btn nl-Btn--outline ml-10\" \nng-show=\"hasGroupMoveSelectionValue\" ng-click=\"openMoveSelectionPopup()\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\">Déplacer les éléments sélectionnés</button></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!folder.readOnly\"><button class=\"iv-Btn mr-10\" type=\"button\" \nng-click=\"openAddFolder()\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-icon class=\"w-20 h-20\" \nmd-svg-src=\"assets/icons/app/V3/add_folder.svg\"></md-icon><div>Créer un dossier</div></button> <button type=\"button\" \nclass=\"nl-Btn nl-Btn--trac flex-none\" ng-click=\"openAddFile()\">+ Importer un fichier</button></div></div><div \nclass=\"nl-listing mt-25\"><div style=\"cursor: pointer\" drop=\"handleDrop\" class=\"nl-listing-item\" \nng-repeat=\"child in category.folders | orderBy: \'name\' track by child.id\" draggable=\"true\" drag=\"child\" \ndragstyle=\"columnDrag\" droppable=\"child\" dropstyle=\"columnDrop\" ng-click=\"openFolder(child)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-if=\"canSelectForGroupMove(child)\" class=\"iv-Checkbox mr-10\" ng-model=\"child._groupMoveSelected\" \naria-label=\"Sélectionner le dossier\" md-no-ink ng-change=\"toggleGroupMoveSelection()\" \nng-click=\"$event.stopPropagation()\"></md-checkbox><md-button class=\"md-icon-button nl-listing-item-button\" \naria-label=\"Dossier\"><md-icon md-svg-src=\"assets/icons/app/V3/folder.svg\" class=\"iv-listing-item-icon-folder\">\n</md-icon></md-button><div flex class=\"text-truncate nl-listing-item-title\">{{child.name}}</div></div><div \nflex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"child.isRestricted\"><button class=\"iv-BtnIcon\" \ntype=\"button\" ng-click=\"event.preventDefault()\"><md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon>\n</button><md-tooltip md-direction=\"bottom\">Visible uniquement par le titulaire et le Responsable Qualité</md-tooltip>\n</div><md-menu class=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openFolder(child)\"><md-icon md-svg-src=\"./assets/icons/app/V3/open.svg\"></md-icon><div>Ouvrir</div>\n</md-button></md-menu-item><md-menu-item ng-if=\"(user.isPraq || user.isTitulaire) && !child.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"oepnEditFolder(child)\"><md-icon md-svg-src=\"./assets/icons/app/V3/modify.svg\">\n</md-icon><div>Modifier</div></md-button></md-menu-item><md-menu-item ng-if=\"(user.isPraq || user.isTitulaire)\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"setRestrictedFolder(child)\"><md-icon ng-if=\"!child.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon><md-icon ng-if=\"child.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/show.svg\"></md-icon><div ng-if=\"!child.isRestricted\">Masquer pour l\'équipe</div><div \nng-if=\"child.isRestricted\">Démasquer pour l\'équipe</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"(user.isPraq || user.isTitulaire) && !child.readOnly\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openMoveFolderPopup(child)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/move.svg\"></md-icon><div>Déplacer</div></md-button></md-menu-item><md-menu-item \nng-if=\"(user.isPraq || user.isTitulaire) && !child.readOnly\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDeleteFolder(child)\"><md-icon md-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer\n</div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div class=\"nl-listing\"><div \nng-click=\"document.pdf ? openPDF(document) : download(document)\" \nng-repeat=\"document in category.documents | orderBy: sorterName:sorterReverse | documentsFilter:filter as filteredDocs track by document.id\">\n<div class=\"nl-listing-item\" draggable=\"true\" drag=\"document\" dragstyle=\"columnDrag\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-if=\"canSelectForGroupMove(document)\" class=\"iv-Checkbox mr-10\" ng-model=\"document._groupMoveSelected\" \naria-label=\"Sélectionner le fichier\" md-no-ink ng-change=\"toggleGroupMoveSelection()\" \nng-click=\"$event.stopPropagation()\"></md-checkbox><md-button class=\"md-icon-button nl-listing-item-button\" \naria-label=\"Dossier\"><md-icon md-svg-src=\"assets/icons/app/V3/file.svg\" class=\"iv-listing-item-icon-file\" \nng-if=\"!document.readOnly\"></md-icon><md-icon md-svg-src=\"assets/icons/app/V3/phsq.svg\" \nclass=\"iv-listing-item-icon-file\" ng-if=\"document.readOnly\"></md-icon></md-button><div flex layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" class=\"text-truncate nl-listing-item-title\">{{document.name}}</div><div \nflex=\"50\" class=\"nl-indicator-header-infos2\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{document.uploadDate | date: \'dd/MM/yyyy HH:mm\'}} {{document.status != \'VALIDATED\' ? \'Non validé par le Responsable Qualité\':\'\'}}\n</div><div><button class=\"iv-BtnIcon\" type=\"button\" ng-click=\"event.preventDefault()\" ng-if=\"document.isRestricted\">\n<md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon></button><md-tooltip md-direction=\"bottom\">\nVisible uniquement par le titulaire et le Responsable Qualité</md-tooltip></div></div></div></div><div flex=\"nogrow\" \nlayout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-if=\"document.pdf\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openPDF(document)\"><md-icon md-svg-src=\"./assets/icons/app/V3/open.svg\">\n</md-icon><div>Ouvrir</div></md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"download(document)\"><md-icon md-svg-src=\"./assets/icons/app/V3/download.svg\"></md-icon><div>Télécharger</div>\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" \nng-if=\"!document.readOnly\"><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openEditDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/modify.svg\"></md-icon><div>Modifier</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"setRestrictedDoc(document)\"><md-icon ng-if=\"!document.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon><md-icon ng-if=\"document.isRestricted\" \nmd-svg-src=\"./assets/icons/app/V3/show.svg\"></md-icon><div ng-if=\"!document.isRestricted\">Masquer pour l\'équipe</div>\n<div ng-if=\"document.isRestricted\">Démasquer pour l\'équipe</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openMoveFilePopup(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/move.svg\"></md-icon><div>Déplacer</div></md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openHistoriquePopup(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/history.svg\"></md-icon><div>Historique des versions</div></md-button></md-menu-item>\n<md-menu-item ng-if=\"document.status !== \'VALIDATED\'\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button\n class=\"iv-Menu-dropdown-btn\" ng-click=\"openValidDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/checkmark.svg\"></md-icon>Valider</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"!document.readOnly\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openDeleteDocument(document)\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/delete.svg\"></md-icon><div>Supprimer</div></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredDocs.length === 0 && (filterValue != \'\' || triValue != \'\')\"><p>Aucun résultat...</p></md-list-item>\n</div></div></div></section>");
$templateCache.put("app/main/front/folders/popup/move_old_popup.html","<md-dialog aria-label=\"Validation - Suppression\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nNouvelle base documentaire</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div \nstyle=\"color: #2269D5; font-weight: 700; font-size: 16px; margin-top: 6px\">Qu\'est-ce qui change ?</div><div \nstyle=\"font-size: 14px; margin-top: 8px\">\nUne structure entièrement repensée pour être visuelle et intuitive, alignée sur la <strong>\ncartographie du manuel qualité</strong>.</div><div \nstyle=\"color: #2269D5; font-weight: 700; font-size: 16px; margin-top: 18px\">Comment ré-organiser mes documents ?</div>\n<div style=\"font-size: 14px; margin-top: 8px\">Vos <strong>anciens dossiers</strong>\n sont pré-rangés dans la bonne catégorie.<br>Vous n\'avez plus qu\'à <strong>dispatcher leurs contenus</strong>\n au sein des nouveaux dossiers. Une fois vides, les anciens dossiers disparaîtront pour laisser place aux nouveaux.\n</div><img src=\"assets/images/new_base_doc.png\" style=\"display: block; max-width: 100%; margin: 18px auto 6px\">\n</md-dialog-content><md-dialog-actions><button class=\"nl-Btn nl-Btn--outline mr-10\" ng-click=\"hidePopup()\">Fermer\n</button> <button class=\"nl-Btn\" ng-click=\"goToHelp()\">Voir la vidéo d\'explication<md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\" \nstyle=\"filter: brightness(0) invert(1); margin-right: 0; margin-left: 0.6rem; height: 1rem; width: 1rem; min-height: 1rem; min-width: 1rem\">\n</md-icon></button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/groupement/audit/fiche-audit.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"column\"><div class=\"nl_breadcumb gpt-breadcrumb\"><span \nclass=\"nl_breadcumb--item\" ng-click=\"retourListe()\">Mes pharmacies</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item\" ng-click=\"retourFiche()\">\n{{audit.pharmacieNom || reference}}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item nl_breadcumb--item--title\">\nAudit n° {{audit.numero || auditId}}</span></div><div class=\"white-fg gpt-fiche-entete\" ng-if=\"audit\"><div \nclass=\"h1 gpt-header__title\">Audit n° {{audit.numero}}</div><div class=\"gpt-pastilles\"><span class=\"gpt-pastille\" \nng-class=\"audit.realise ? \'gpt-pastille--on\' : \'\'\">{{audit.realise ? \'Réalisé\' : \'Non réalisé\'}} </span><span \nclass=\"gpt-pastille\" ng-if=\"audit.type\">{{audit.type}}</span> <span class=\"gpt-pastille\" ng-if=\"audit.equipe\">\n{{audit.equipe}}</span></div></div></div><div class=\"content gpt-content\"><div class=\"gpt-loading\" ng-if=\"chargement\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><span>Chargement de l\'audit…\n</span></div><div class=\"gpt-erreur\" ng-if=\"!chargement && erreur\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"s28\"></md-icon><div class=\"gpt-erreur__titre\">{{erreur.message}}</div><md-button \nclass=\"gpt-erreur__retry md-raised md-accent\" ng-click=\"charger()\">Réessayer</md-button></div><div \nng-if=\"!chargement && !erreur && audit\"><div class=\"gpt-bloc\"><div class=\"gpt-bloc__titre\"><span \nclass=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s16\">\n</md-icon></span>Informations audit </span><span class=\"gpt-voyant\" \nng-class=\"audit.realise ? \'gpt-voyant--ok\' : \'gpt-voyant--ko\'\"><span class=\"gpt-voyant__point\"></span>\n{{audit.realise ? \'Réalisé\' : \'Non réalisé\'}}</span></div><div class=\"gpt-infos\"><div class=\"gpt-info\"><span>Numéro\n</span> <span ng-class=\"{\'gpt-info--absent\': !audit.numero}\">{{audit.numero || \'Non renseigné\'}}</span></div><div \nclass=\"gpt-info\"><span>Type</span> <span ng-class=\"{\'gpt-info--absent\': !audit.type}\">{{audit.type || \'Non renseigné\'}}\n</span></div><div class=\"gpt-info\"><span>Équipe</span> <span ng-class=\"{\'gpt-info--absent\': !audit.equipe}\">\n{{audit.equipe || \'Non renseignée\'}}</span></div><div class=\"gpt-info\"><span>Auditeur</span> <span \nng-class=\"{\'gpt-info--absent\': !audit.auditeur}\">{{audit.auditeur || \'Non renseigné\'}}</span></div><div \nclass=\"gpt-info\"><span>Statut</span> <span ng-class=\"{\'gpt-info--absent\': !audit.statutAudit}\">\n{{audit.statutAudit || \'Non renseigné\'}}</span></div><div class=\"gpt-info\"><span>Date</span> <span \nng-class=\"{\'gpt-info--absent\': !audit.dateAudit}\">{{(audit.dateAudit | date:\'dd/MM/yyyy\') || \'Non renseignée\'}}</span>\n</div><div class=\"gpt-info\"><span>Horaires</span> <span ng-class=\"{\'gpt-info--absent\': !audit.horaires}\">\n{{audit.horaires || \'Non renseignés\'}}</span></div><div class=\"gpt-info\"><span>Année prévue</span> <span \nng-class=\"{\'gpt-info--absent\': !audit.annee}\">{{audit.annee || \'Non renseignée\'}}</span></div><div class=\"gpt-info\">\n<span>Semestre</span> <span ng-class=\"{\'gpt-info--absent\': !audit.semestre}\">{{audit.semestre || \'Non renseigné\'}}\n</span></div></div></div><div class=\"gpt-bloc-groupe\"><div class=\"gpt-bloc gpt-bloc--demi\"><div \nclass=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-alert-octagon\" class=\"s16\"></md-icon></span>Infos écart</span></div><div class=\"gpt-mesures\"><div \nclass=\"gpt-mesure\"><div class=\"gpt-mesure__libelle\">Écarts majeurs</div><div \nclass=\"gpt-mesure__valeur gpt-mesure__valeur--majeur\">{{audit.ecartsMajeurs || 0}}</div></div><div class=\"gpt-mesure\">\n<div class=\"gpt-mesure__libelle\">Écarts mineurs</div><div class=\"gpt-mesure__valeur gpt-mesure__valeur--mineur\">\n{{audit.ecartsMineurs || 0}}</div></div></div><div class=\"gpt-paires\"><div class=\"gpt-paire\"><span>Levée prévisionnelle\n</span> <span ng-class=\"{\'gpt-info--absent\': !audit.dateLeveeEcart}\">\n{{(audit.dateLeveeEcart | date:\'dd/MM/yyyy\') || \'Non renseignée\'}}</span></div><div class=\"gpt-paire\"><span>Écart levé\n</span> <span ng-class=\"{\'gpt-info--absent\': !audit.ecartLeve}\">{{audit.ecartLeve || \'Non renseigné\'}}</span></div>\n</div></div><div class=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-file-document\" class=\"s16\"></md-icon></span>Documents d\'audit \n</span><span class=\"gpt-bloc__compte\">{{audit.documents.length}}</span></div><table class=\"gpt-table\" \nng-if=\"audit.documents.length\"><thead><tr><th>Nom du document</th><th></th></tr></thead><tbody><tr \nng-repeat=\"doc in audit.documents\"><td>{{doc.titre || doc.nom}}</td><td class=\"gpt-table__actions\"><button \ntype=\"button\" class=\"gpt-action\" ng-if=\"doc.telechargeable\" ng-click=\"telechargerDocument(doc)\" title=\"Télécharger\" \naria-label=\"Télécharger\"><md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon></button></td></tr></tbody>\n</table><div class=\"gpt-vide\" ng-if=\"!audit.documents.length\">Aucun document.</div></div></div><div \nclass=\"gpt-bloc-groupe\"><div class=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span \nclass=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone gpt-bloc__icone--majeur\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon></span>Causes écart majeures </span><span class=\"gpt-bloc__compte\">\n{{audit.causesMajeures.length}}</span></div><div class=\"gpt-causes\"><div class=\"gpt-causes__entete\">Causes</div><div \nclass=\"gpt-cause\" ng-repeat=\"cause in audit.causesMajeures\">{{cause}}</div><div class=\"gpt-causes__vide\" \nng-if=\"!audit.causesMajeures.length\">Aucune cause d\'écart majeur trouvée</div></div></div><div \nclass=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone gpt-bloc__icone--mineur\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon></span>\nCauses écart mineures </span><span class=\"gpt-bloc__compte\">{{audit.causesMineures.length}}</span></div><div \nclass=\"gpt-causes\"><div class=\"gpt-causes__entete\">Causes</div><div class=\"gpt-cause\" \nng-repeat=\"cause in audit.causesMineures\">{{cause}}</div><div class=\"gpt-causes__vide\" \nng-if=\"!audit.causesMineures.length\">Aucune cause d\'écart mineur trouvée</div></div></div></div><div class=\"gpt-bloc\">\n<div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-comment-text\" class=\"s16\"></md-icon></span>Commentaires d\'audit </span><span \nclass=\"gpt-bloc__compte\">{{audit.commentaires.length}}</span></div><div class=\"gpt-commentaire-saisie\" \nng-if=\"estResponsable()\"><textarea rows=\"2\" placeholder=\"Ajouter un commentaire…\" ng-model=\"saisieCommentaire.contenu\">\n</textarea><button type=\"button\" class=\"gpt-btn gpt-btn--principal\" \nng-disabled=\"!saisieCommentaire.contenu.trim() || enregistrement\" ng-click=\"ajouterCommentaire()\">Ajouter</button>\n</div><div class=\"gpt-journal\"><div class=\"gpt-journal__ligne\" ng-repeat=\"commentaire in audit.commentaires\"><div \nclass=\"gpt-journal__entete\"><span class=\"gpt-journal__auteur\">{{commentaire.auteurNom || \"Reprise de l\'ancien CRM\"}}\n</span> <span class=\"gpt-journal__date\">{{commentaire.date | date:\'dd/MM/yyyy HH:mm\'}}</span><button type=\"button\" \nclass=\"gpt-action gpt-action--danger gpt-journal__supprimer\" ng-if=\"peutSupprimerCommentaire(commentaire)\" \nng-click=\"supprimerCommentaire(commentaire, $event)\" title=\"Supprimer\" aria-label=\"Supprimer\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></button></div><div class=\"gpt-journal__contenu\">\n{{commentaire.contenu}}</div></div><div class=\"gpt-vide\" ng-if=\"!audit.commentaires.length\">Aucun commentaire.</div>\n</div></div></div></div></div>");
$templateCache.put("app/main/front/groupement/audits/audits.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page gpt-page--liste\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg gpt-header__titre-bloc\"><div class=\"gpt-header__titre\">Audits</div><div class=\"gpt-header__sous-titre\">\nLes audits de tout le parc du réseau</div></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"gpt-header__actions\"><span class=\"gpt-header__compteur\" ng-if=\"pagination.total\">{{pagination.total}} <span>\naudit{{pagination.total > 1 ? \'s\' : \'\'}}</span> </span><button type=\"button\" class=\"gpt-btn gpt-btn--sur-bandeau\" \nng-disabled=\"exportEnCours || !pagination.total\" ng-click=\"exporter()\" title=\"Export Excel, causes d\'écart comprises\">\n<md-icon md-font-icon=\"icon-download\" class=\"s18\"></md-icon><span>{{exportEnCours ? \'Export…\' : \'Exporter\'}}</span>\n</button></div></div><div class=\"content gpt-content\"><div class=\"gpt-carte\"><div class=\"gpt-outils\"><div \nclass=\"gpt-outils__ligne\"><span class=\"gpt-outils__etiquette\">Recherche</span><div class=\"gpt-champ-recherche\"><md-icon\n md-font-icon=\"icon-magnify\" class=\"s18\"></md-icon><input type=\"text\" ng-model=\"recherche\" \nng-model-options=\"{ debounce: 350 }\" ng-change=\"appliquer()\" \nplaceholder=\"Pharmacie, réf PHSQ, code CIP ou n° d\'audit…\"> <button type=\"button\" class=\"gpt-champ-recherche__effacer\" \nng-if=\"recherche\" ng-click=\"effacerRecherche()\" aria-label=\"Effacer\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></button></div></div><div class=\"gpt-outils__ligne gpt-outils__ligne--filtres\"><span \nclass=\"gpt-outils__etiquette\">Filtres</span><gpt-filtre-menu colonnes=\"filtresVisibles()\" metas=\"metasFiltres\" \nfiltres=\"filtres\" on-change=\"appliquer()\" on-reset=\"reinitialiser()\"></gpt-filtre-menu></div></div><div \nclass=\"gpt-etat\" ng-if=\"chargement\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\">\n</md-progress-circular><span>Chargement des audits…</span></div><div class=\"gpt-etat gpt-etat--erreur\" \nng-if=\"!chargement && erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div \nclass=\"gpt-etat__titre\">{{erreur.message}}</div><button type=\"button\" class=\"gpt-btn gpt-btn--principal\" \nng-click=\"charger()\">Réessayer</button></div><div class=\"gpt-tableau-cadre\" ng-if=\"!chargement && !erreur\"><table \nclass=\"gpt-tableau\" ng-if=\"audits.length\"><thead><tr><th ng-repeat=\"colonne in colonnesVisibles()\" \nng-click=\"trierPar(colonne.cle)\" \nng-class=\"{\'gpt-tableau__th--trie\': tri.colonne === colonne.cle,\n                             \'gpt-table__groupe\': colonne.groupe,\n                             \'gpt-table__centre\': colonne.style === \'oui-non\' || colonne.style === \'majeur\'\n                                                  || colonne.style === \'mineur\' || colonne.style === \'ecart-leve\'}\">\n<span>{{colonne.libelle}}</span><md-icon ng-if=\"tri.colonne === colonne.cle\" \nmd-font-icon=\"{{tri.sens === \'asc\' ? \'icon-menu-up\' : \'icon-menu-down\'}}\" class=\"s14\"></md-icon></th></tr></thead>\n<tbody><tr ng-repeat=\"audit in audits\" class=\"gpt-ligne\" ng-click=\"ouvrirAudit(audit)\"><td \nng-repeat=\"colonne in colonnesVisibles()\" \nng-class=\"{\'gpt-cellule--ref\': colonne.style === \'ref\',\n                             \'gpt-cellule--nom\': colonne.style === \'nom\',\n                             \'gpt-cellule--date\': colonne.style === \'date\',\n                             \'gpt-table__groupe\': colonne.groupe,\n                             \'gpt-table__centre\': colonne.style === \'oui-non\' || colonne.style === \'majeur\'\n                                                  || colonne.style === \'mineur\' || colonne.style === \'ecart-leve\'}\">\n<span ng-if=\"colonne.style === \'oui-non\'\" class=\"gpt-pastille\" \nng-class=\"audit[colonne.champ] ? \'gpt-pastille--oui\' : \'gpt-pastille--non\'\">{{audit[colonne.champ] ? \'Oui\' : \'Non\'}} \n</span><span ng-if=\"colonne.style === \'majeur\' || colonne.style === \'mineur\'\"><span \nclass=\"gpt-compte gpt-compte--{{colonne.style}}\" ng-if=\"audit[colonne.champ]\">{{audit[colonne.champ]}}</span> <span \nclass=\"gpt-nul\" ng-if=\"!audit[colonne.champ]\">—</span> </span><span ng-if=\"colonne.style === \'ecart-leve\'\"><span \nclass=\"gpt-pastille gpt-pastille--{{niveauEcartLeve(audit[colonne.champ])}}\" ng-if=\"audit[colonne.champ]\">\n{{audit[colonne.champ]}}</span> <span class=\"gpt-nul\" ng-if=\"!audit[colonne.champ]\">—</span> </span><span \nng-if=\"colonne.style === \'date\'\">{{(audit[colonne.champ] | date:\'dd/MM/yyyy\') || \'—\'}} </span><span \nng-if=\"colonne.style !== \'oui-non\' && colonne.style !== \'majeur\'\n                             && colonne.style !== \'mineur\' && colonne.style !== \'ecart-leve\'\n                             && colonne.style !== \'date\'\">\n{{audit[colonne.champ] === 0 ? 0 : (audit[colonne.champ] || \'—\')}}</span></td></tr></tbody></table><div \nclass=\"gpt-etat\" ng-if=\"!audits.length\">Aucun audit ne correspond à ces critères.</div></div><div class=\"gpt-pied\" \nng-if=\"!chargement && !erreur && pagination.total\"><div class=\"gpt-pied__taille\"><label for=\"taille-audits\">Lignes\n</label><md-select id=\"taille-audits\" ng-model=\"pagination.taille\" ng-change=\"changerTaille()\" \nclass=\"gpt-select gpt-select--compact md-no-underline\" aria-label=\"Nombre de lignes par page\"><md-option \nng-repeat=\"taille in taillesPage\" ng-value=\"taille\">{{taille}}</md-option></md-select></div><div \nclass=\"gpt-pied__saut\"><label for=\"page-audits\">Page</label><input id=\"page-audits\" type=\"number\" \nclass=\"gpt-pied__champ\" min=\"1\" max=\"{{nbPages()}}\" ng-model=\"pagination.pageSaisie\" ng-blur=\"allerALaPage()\" \nng-keydown=\"$event.keyCode === 13 ? allerALaPage() : null\"> <span>sur {{nbPages()}}</span></div><span \nclass=\"gpt-pied__compte\">{{pagination.total}} audits</span><div class=\"gpt-pied__nav\"><button type=\"button\" \nclass=\"gpt-action\" ng-disabled=\"pagination.page <= 1\" ng-click=\"changerPage(1)\" title=\"Première page\" \naria-label=\"Première page\"><md-icon md-font-icon=\"icon-chevron-double-left\" class=\"s16\"></md-icon></button> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"pagination.page <= 1\" \nng-click=\"changerPage(pagination.page - 1)\">Précédent</button> <button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" \nng-disabled=\"pagination.page >= nbPages()\" ng-click=\"changerPage(pagination.page + 1)\">Suivant</button> <button \ntype=\"button\" class=\"gpt-action\" ng-disabled=\"pagination.page >= nbPages()\" ng-click=\"changerPage(nbPages())\" \ntitle=\"Dernière page\" aria-label=\"Dernière page\"><md-icon md-font-icon=\"icon-chevron-double-right\" class=\"s16\">\n</md-icon></button></div></div></div></div></div>");
$templateCache.put("app/main/front/groupement/auto-evaluation/autoeval-groupement.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page aeq-gpt\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"column\"><div class=\"nl_breadcumb gpt-breadcrumb\"><span \nclass=\"nl_breadcumb--item\" ng-click=\"changerOnglet(\'dashboard\')\">Auto-évaluation</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item\" \nng-click=\"changerOnglet(\'dashboard\')\">{{annee}}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item nl_breadcumb--item--title\">\n{{libelleOnglet(onglet)}}</span></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg gpt-fiche-entete\"><div class=\"h1 gpt-header__title\">Auto-évaluation {{annee}}</div><div \nclass=\"gpt-fiche-entete__identite\"><span ng-if=\"dashboard.groupement.libelle\">{{dashboard.groupement.libelle}}</span> \n<span ng-if=\"!dashboard.groupement.libelle && !ferme\">Vue consolidée de vos réseaux</span> <span \nng-if=\"dashboard.effectif\">\n· {{dashboard.effectif}} officine{{dashboard.effectif > 1 ? \'s\' : \'\'}} engagée{{dashboard.effectif > 1 ? \'s\' : \'\'}}\n</span> <span ng-if=\"dashboard.dateOuverture\">\n· du {{dashboard.dateOuverture | date:\'dd/MM/yyyy\'}} au {{dashboard.dateClotureEffective | date:\'dd/MM/yyyy\'}}</span> \n<span ng-if=\"aVenir && boite.dateOuverture\">\n· du {{boite.dateOuverture | date:\'dd/MM/yyyy\'}} au {{boite.dateClotureEffective | date:\'dd/MM/yyyy\'}}</span></div><div\n class=\"gpt-pastilles\" ng-if=\"dashboard\"><span class=\"gpt-pastille gpt-pastille--on\">{{libellePhase(dashboard.phase)}}\n</span> <span class=\"gpt-pastille\" ng-if=\"dashboard.provisoire\">Chiffres provisoires</span> <span class=\"gpt-pastille\" \nng-if=\"!dashboard.provisoire\">Résultats définitifs</span></div><div class=\"gpt-pastilles\" ng-if=\"aVenir\"><span \nclass=\"gpt-pastille gpt-pastille--on\">{{libellePhase(boite.phase)}}</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"gpt-header__actions\"><span class=\"gpt-header__compteur\" ng-if=\"dashboard.compteurs\">\n{{dashboard.compteurs.validees}} <span>\nvalidée{{dashboard.compteurs.validees > 1 ? \'s\' : \'\'}} sur {{dashboard.effectif}}</span></span></div></div></div><div \nclass=\"content gpt-content\"><div class=\"aeq-note aeq-note--warn\" ng-if=\"erreur\">{{erreur.message}}</div><div \nclass=\"aeq-note aeq-note--info\" ng-if=\"dashboard.provisoire\"><b>Campagne en cours.</b>\n Les chiffres de cet espace évoluent chaque jour, au fil des validations. La comparaison complète sera stable après la clôture \n<span ng-if=\"dashboard.dateClotureEffective\">du {{dashboard.dateClotureEffective | date:\'dd/MM/yyyy\'}}</span>.</div>\n<div class=\"gpt-tabs\" ng-if=\"!aVenir && !ferme\"><button type=\"button\" class=\"gpt-tab\" \nng-repeat=\"item in onglets track by item\" ng-class=\"{\'gpt-tab--actif\': onglet === item}\" \nng-click=\"changerOnglet(item)\">{{libelleOnglet(item)}}</button></div><div class=\"qs-config-campagne-form\" \nng-if=\"aVenir\"><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Campagne à venir</h2><p \nclass=\"qs-config-card-subtitle\">\nLe suivi de vos officines, les résultats et le profil seront disponibles dès l\'ouverture.</p></div></header><p \nclass=\"aeq-hint\">Ouverture le <b>{{boite.dateOuverture | date:\'d MMMM yyyy\'}}</b>, clôture le <b>\n{{boite.dateClotureEffective | date:\'d MMMM yyyy\'}}</b>. Vos officines seront prévenues par e-mail à l\'ouverture.</p>\n</section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'dashboard\' && !aVenir && !ferme\"><div \nclass=\"aeq-chargement\" ng-if=\"chargement.dashboard && !dashboard\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular><span>Chargement du tableau de bord…</span></div><section \nclass=\"qs-config-card\" ng-if=\"dashboard\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Avancement du réseau</h2><p \nclass=\"qs-config-card-subtitle\" ng-if=\"dashboard.provisoire\">\nSuivez l\'avancement de vos {{dashboard.effectif}} officines engagées. Une auto-évaluation est comptabilisée dans les résultats uniquement après sa \n<b>validation</b> par le titulaire.</p><p class=\"qs-config-card-subtitle\" ng-if=\"!dashboard.provisoire\">\nLe bilan de vos {{dashboard.effectif}} officines engagées à la clôture. Une auto-évaluation est comptabilisée dans les résultats uniquement après sa \n<b>validation</b> par le titulaire.</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"dashboard.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{aUneValeur(dashboard.completionPct) ? (dashboard.completionPct | number:0) + \' % d\\\'auto-évaluations validées\' : \'auto-évaluations validées —\'}}\n</span></header><div class=\"aeq-chiffres\"><div class=\"aeq-chiffre aeq-chiffre--accent\"><span class=\"aeq-chiffre-val\">\n{{dashboard.compteurs.validees}}</span> <span class=\"aeq-chiffre-lab\">validées</span></div><div class=\"aeq-chiffre\">\n<span class=\"aeq-chiffre-val\">{{dashboard.compteurs.enCours + dashboard.compteurs.rouvertes}}</span> <span \nclass=\"aeq-chiffre-lab\">en cours de remplissage</span></div><div class=\"aeq-chiffre\"><span class=\"aeq-chiffre-val\">\n{{dashboard.compteurs.nonCommencees}}</span> <span class=\"aeq-chiffre-lab\">non commencées</span></div><div \nclass=\"aeq-chiffre\" ng-if=\"dashboard.compteurs.partielles || dashboard.compteurs.nonRepondues\"><span \nclass=\"aeq-chiffre-val\">{{dashboard.compteurs.partielles + dashboard.compteurs.nonRepondues}}</span> <span \nclass=\"aeq-chiffre-lab\">sans validation à la clôture</span></div></div><div class=\"aeq-completion\" \nng-if=\"dashboard.effectif\"><div class=\"aeq-barre\"><span class=\"aeq-barre-seg\" \nng-repeat=\"segment in segmentsCompletion track by segment.cle\" ng-class=\"{\'aeq-barre-seg--pale\': segment.pale}\" \nng-style=\"{width: segment.pct + \'%\', background: segment.couleur}\" \ntitle=\"{{segment.libelle}} : {{segment.nb}} ({{segment.pct | number:1}} %)\"><span ng-if=\"segment.pct >= 8\">\n{{segment.pct | number:0}} %</span></span></div><div class=\"aeq-legende\"><span class=\"aeq-legende-item\" \nng-repeat=\"segment in segmentsCompletion track by segment.cle\"><span class=\"aeq-legende-dot\" \nng-style=\"{background: segment.couleur}\"></span> <span class=\"aeq-legende-val\">{{segment.nb}}</span>\n {{segment.libelle}}</span></div></div><ul class=\"aeq-definitions\" ng-if=\"dashboard.provisoire\"><li><dfn>Validée</dfn>\n : le titulaire a terminé le questionnaire et validé sa soumission.</li><li><dfn>En cours</dfn>\n : le titulaire a répondu à au moins une question, mais n\'a pas encore validé sa soumission.</li><li><dfn>Non commencée\n</dfn> : aucune réponse n\'a été enregistrée.</li></ul><ul class=\"aeq-definitions\" ng-if=\"!dashboard.provisoire\"><li>\n<dfn>Validée</dfn> : le titulaire a terminé le questionnaire et validé sa soumission.</li><li><dfn>Partielle</dfn>\n : le titulaire a répondu à au moins une question, mais n\'a pas validé sa soumission avant la clôture.</li><li><dfn>\nNon répondue</dfn> : aucune réponse n\'a été enregistrée avant la clôture.</li><li>\nLes officines partielles et non répondues sont proposées au passage au statut <b>ENC</b> (Engagé Non Certifié).</li>\n</ul><p class=\"aeq-hint\"><b>Taux de validation</b>\n = auto-évaluations validées / officines engagées. Une auto-évaluation <b>rouverte</b>\n par PHSQ compte avec les « en cours ». Ce n\'est pas le taux de participation, qui inclut aussi les soumissions partielles.\n</p></section><section class=\"qs-config-card\" ng-if=\"dashboard\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Dates de la campagne</h2><p \nclass=\"qs-config-card-subtitle\">Les dates sont fixées par PHSQ ; l\'ouverture et la clôture sont automatiques.</p></div>\n<span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"{\n              \'is-selected\': dashboard.phase === \'OUVERTE\',\n              \'is-brouillon\': dashboard.phase === \'PROLONGATION\',\n              \'is-neutre\': dashboard.phase !== \'OUVERTE\' && dashboard.phase !== \'PROLONGATION\'}\">\n{{libellePhase(dashboard.phase)}}</span></header><div class=\"qs-config-timeline qs-config-timeline--trois\"><div \nclass=\"qs-config-timeline-step\"><div class=\"qs-config-step-badge\"><span>1</span></div><div class=\"qs-config-step-body\">\n<div class=\"qs-config-step-caption\">Ouverture</div><div class=\"aeq-step-valeur\">\n{{dashboard.dateOuverture | date:\'dd/MM/yyyy\'}}</div><div class=\"qs-config-step-hint\">\nLa cible a été figée ce jour-là ; vos officines ont reçu l\'e-mail d\'ouverture.</div></div></div><div \nclass=\"qs-config-timeline-connector\" aria-hidden=\"true\"></div><div class=\"qs-config-timeline-step\"><div \nclass=\"qs-config-step-badge\"><span>2</span></div><div class=\"qs-config-step-body\"><div class=\"qs-config-step-caption\">\nClôture officielle</div><div class=\"aeq-step-valeur\">{{dashboard.dateClotureOfficielle | date:\'dd/MM/yyyy\'}}</div><div \nclass=\"qs-config-step-hint\">Dernier jour de saisie annoncé aux officines.</div></div></div><div \nclass=\"qs-config-timeline-connector\" aria-hidden=\"true\"></div><div class=\"qs-config-timeline-step\"><div \nclass=\"qs-config-step-badge\"><span>3</span></div><div class=\"qs-config-step-body\"><div class=\"qs-config-step-caption\">\nProlongation</div><div class=\"aeq-step-valeur\" ng-if=\"dashboard.dateProlongation\">\n{{dashboard.dateProlongation | date:\'dd/MM/yyyy\'}}</div><div class=\"aeq-step-valeur aeq-step-valeur--absente\" \nng-if=\"!dashboard.dateProlongation\">Aucune</div><div class=\"qs-config-step-hint\" ng-if=\"dashboard.dateProlongation\">\nLa saisie reste ouverte jusqu\'à cette date.</div><div class=\"qs-config-step-hint\" ng-if=\"!dashboard.dateProlongation\">\nPHSQ peut prolonger la campagne ; la date apparaîtra ici.</div></div></div></div><p class=\"aeq-hint\">Le groupement <b>\nne configure pas la campagne</b>\n : dates, questionnaire et e-mails sont du ressort de PHSQ. Cet espace sert à piloter le remplissage et à exploiter les résultats de votre périmètre.\n</p></section><section class=\"qs-config-card\" ng-if=\"dashboard\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Officines sans validation</h2><p \nclass=\"qs-config-card-subtitle\">{{texteSansValidation}}</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" ng-class=\"nbSansValidation() ? \'is-brouillon\' : \'is-selected\'\">\n{{nbSansValidation()}} restante{{nbSansValidation() > 1 ? \'s\' : \'\'}}</span></header><div \nclass=\"aeq-note aeq-note--info\">L\'auto-évaluation annuelle ISO 9001 « QMS Pharma » est <b>obligatoire</b>\n dans le cadre de la certification avec PHSQ. Chaque titulaire doit valider sa soumission avant la clôture du questionnaire.\n<br>À la clôture, les officines <b>sans soumission validée</b>\n seront proposées au passage au statut ENC (Engagé Non Certifié).</div><div class=\"aeq-note aeq-note--ok\" \nng-if=\"!nbSansValidation()\">Toutes les officines de votre périmètre ont validé leur auto-évaluation.</div><div \nclass=\"aeq-navrow\"><span class=\"aeq-hint\" style=\"margin: 0\">\nLe détail officine par officine est dans l\'onglet Pharmacies, avec ses filtres et son tri. Des relances des officines sont \n<b>envoyées par PHSQ</b>. </span><span class=\"aeq-navrow-actions\"><button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome\" ng-if=\"nbSansValidation()\" ng-click=\"changerOnglet(\'pharmacies\')\"><span>\nVoir toutes les officines</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16\"></md-icon></button></span></div>\n</section></div><div class=\"qs-config-campagne-form\" ng-if=\"(aVenir || onglet === \'dashboard\') && boite.outils.length\">\n<section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-folder-outline\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Boîte à outils</h2><p \nclass=\"qs-config-card-subtitle\">\nConsultez les documents de la campagne {{annee}} mis à la disposition des officines dans leur espace d\'auto-évaluation.\n</p></div></header><aeq-boite-outils outils=\"boite.outils\"></aeq-boite-outils></section></div><div \nclass=\"qs-config-campagne-form\" ng-if=\"onglet === \'resultats\' && !ferme\"><div class=\"aeq-chargement\" \nng-if=\"chargement.resultats && !resultats\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular><span>Calcul des agrégats…</span></div><section class=\"qs-config-card\" ng-if=\"resultats\"><header\n class=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Répartition du réseau</h2><p class=\"qs-config-card-subtitle\">\nMoyenne des scores d\'officine, comparée au national sur le « Oui ». Chaque officine pèse le même poids, quelle que soit sa taille.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"resultats.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{resultats.nbValidees}} validée{{resultats.nbValidees > 1 ? \'s\' : \'\'}}{{resultats.provisoire ? \' · provisoire\' : \'\'}}\n</span></header><div class=\"aeq-barre-outils\"><label>Année d\'engagement<select ng-model=\"filtres.anneeEngagement\" \nng-change=\"changerAnneeEngagement()\" ng-options=\"a as a for a in resultats.anneesEngagementDisponibles\"><option \nvalue=\"\">Toutes</option></select></label><span class=\"aeq-espace\"></span><button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome\" ng-click=\"exporterRapportSynthese()\" ng-disabled=\"exportRapportSynthese\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon><span>\n{{exportRapportSynthese ? \'Préparation…\' : \'Rapport de synthèse\'}}</span></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"exportEnCours\" ng-click=\"exporter(\'synthese\')\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon><span>Export de synthèse</span></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"exportEnCours\" ng-click=\"exporter(\'detail\')\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s16\"></md-icon><span>Export détaillé</span></button></div><ul \nclass=\"aeq-definitions aeq-exports\"><li><dfn>Rapport de synthèse</dfn>\n : le classeur mis en forme par PHSQ, chapitre par chapitre puis question par question — votre réseau en {{annee}}, comparé à {{annee - 1}} et au national PHSQ, sur toutes vos officines.\n<span ng-if=\"dashboard && !dashboard.groupement.code\">\n En vue consolidée, une première feuille « Vue consolidée » réunit vos réseaux, puis chacun a la sienne.</span></li>\n<li><dfn>Export de synthèse</dfn>\n : les chiffres de ce tableau (national, écart, évolution N-1) et la répartition du profil, en données brutes, selon le filtre d\'année d\'engagement.\n</li><li><dfn>Export détaillé</dfn> : une ligne par officine validée, une colonne par question, selon le même filtre.\n</li></ul><div class=\"aeq-note aeq-note--info\" ng-if=\"filtres.anneeEngagement\">Résultats des officines engagées en <b>\n{{filtres.anneeEngagement}}</b>\n. Le national et l\'évolution N-1 sont re-segmentés sur le même critère, pour que la comparaison porte sur un périmètre comparable.\n</div><div class=\"aeq-note aeq-note--info\" ng-if=\"!resultats.nbValidees\">\nAucune officine de votre périmètre n\'a encore validé : les agrégats apparaîtront à la première validation.</div><div \nclass=\"aeq-note aeq-note--warn\" ng-if=\"resultats.provisoire && resultats.n1Disponible\">L\'<b>évolution N-1</b>\n compare {{resultats.nbValidees > 1 ? \'les \' + resultats.nbValidees + \' officines déjà validées\' : \'la seule officine déjà validée\'}} en {{resultats.annee}} à l\'\n<b>ensemble</b>\n de {{resultats.anneeN1}} : tant que la campagne est ouverte, elle reflète surtout la composition de l\'échantillon.\n</div><table class=\"aeq-tbl\"><thead><tr><th>Chapitre</th><th>Effectif</th><th>Oui</th><th>En cours</th><th>Non</th><th>\nNon concerné</th><th>National (Oui)</th><th>Écart</th><th>Évolution N-1</th></tr></thead><tbody><tr \nclass=\"aeq-tbl-synthese\" ng-if=\"ligneGlobale()\"><td><b>Synthèse globale</b></td><td class=\"aeq-mono\">\n{{ligneGlobale().effectif}}</td><td class=\"aeq-mono aeq-t-oui\">\n{{aUneValeur(ligneGlobale().pctOui) ? (ligneGlobale().pctOui | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-encours\">\n{{aUneValeur(ligneGlobale().pctEnCours) ? (ligneGlobale().pctEnCours | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-non\">{{aUneValeur(ligneGlobale().pctNon) ? (ligneGlobale().pctNon | number:0) + \' %\' : \'—\'}}</td>\n<td class=\"aeq-mono\">{{aUneValeur(ligneGlobale().pctNc) ? (ligneGlobale().pctNc | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono\">\n{{aUneValeur(ligneGlobale().nationalPctOui) ? (ligneGlobale().nationalPctOui | number:0) + \' %\' : \'—\'}}</td><td>\n<aeq-badge-ecart valeur=\"ligneGlobale().ecartPts\" suffixe=\"\'vs national\'\"></aeq-badge-ecart></td><td><aeq-badge-ecart \nvaleur=\"ligneGlobale().evolutionN1Pts\" motif=\"ligneGlobale().evolutionMotif\"></aeq-badge-ecart></td></tr><tr \nng-repeat=\"ligne in lignesChapitres() track by ligne.chapitreId\" ng-class=\"{\'aeq-tbl-alerte\': ligne.alerte}\"><td><b>\n<span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span> {{ligne.titre}}</b><span \nclass=\"aeq-pill aeq-pill--alerte\" ng-if=\"ligne.alerte\" title=\"Moins de 60 % de « Oui » : point de vigilance\">vigilance\n</span><span class=\"aeq-pill aeq-pill--close\" ng-if=\"ligne.sousPopulation\">sous-population</span></td><td \nclass=\"aeq-mono\">{{ligne.effectif}}</td><td class=\"aeq-mono aeq-t-oui\">\n{{aUneValeur(ligne.pctOui) ? (ligne.pctOui | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono aeq-t-encours\">\n{{aUneValeur(ligne.pctEnCours) ? (ligne.pctEnCours | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono aeq-t-non\">\n{{aUneValeur(ligne.pctNon) ? (ligne.pctNon | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono\">\n{{aUneValeur(ligne.pctNc) ? (ligne.pctNc | number:0) + \' %\' : \'—\'}}</td><td class=\"aeq-mono\">\n{{aUneValeur(ligne.nationalPctOui) ? (ligne.nationalPctOui | number:0) + \' %\' : \'—\'}}</td><td><aeq-badge-ecart \nvaleur=\"ligne.ecartPts\" suffixe=\"\'vs national\'\"></aeq-badge-ecart></td><td><aeq-badge-ecart \nvaleur=\"ligne.evolutionN1Pts\" motif=\"ligne.evolutionMotif\"></aeq-badge-ecart></td></tr></tbody></table><p \nclass=\"aeq-hint\">\nLe tiret « — » signale une modalité qu\'aucune question du chapitre n\'ouvre, à ne pas confondre avec 0 %. Un chapitre sous \n<b>60 % de « Oui »</b> est signalé comme point de vigilance. Le <b>Baromètre</b> et le <b>Profil</b>\n sont exclus des agrégats de chapitre.</p></section><section class=\"qs-config-card\" \nng-if=\"resultats && resultats.nbValidees\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Vue d\'ensemble</h2><p \nclass=\"qs-config-card-subtitle\">Répartition en quatre modalités, la synthèse globale puis chaque chapitre.</p></div>\n</header><div class=\"aeq-legende\"><span class=\"aeq-legende-item\" \nng-repeat=\"item in legendeModalites(resultats.palette) track by item.valeur\"><span class=\"aeq-legende-dot\" \nng-style=\"{background: item.couleurHex}\"></span>{{item.libelleLong}}</span></div><div class=\"aeq-hgrid\"><div \nclass=\"aeq-hrow aeq-hrow--synthese\" ng-if=\"ligneGlobale()\"><span class=\"aeq-hlab\">Synthèse globale</span>\n<aeq-barre-empilee ligne=\"ligneGlobale()\" palette=\"resultats.palette\"></aeq-barre-empilee></div><div class=\"aeq-hrow\" \nng-repeat=\"ligne in lignesChapitres() track by ligne.chapitreId\"><span class=\"aeq-hlab\"><span class=\"aeq-cdot\" \nng-style=\"{background: ligne.couleurHex}\"></span> {{ligne.code}} · {{ligne.titre}}</span><aeq-barre-empilee \nligne=\"ligne\" palette=\"resultats.palette\"></aeq-barre-empilee></div></div></section></div><div \nclass=\"qs-config-campagne-form\" ng-if=\"onglet === \'pharmacies\' && !ferme\"><section class=\"qs-config-card\" \nng-if=\"archives.length\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-folder-download\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Archives de rapports</h2><p \nclass=\"qs-config-card-subtitle\">Une archive rassemble les rapports PDF <b>déjà produits</b>\n des officines validées ; elle reste disponible sept jours.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge is-neutre\">{{archives.length}}</span></header><table \nclass=\"aeq-tbl\"><thead><tr><th>Demandée le</th><th>Périmètre</th><th>État</th><th>Rapports</th><th>Expire le</th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"archive in archives track by archive.id\"><td>\n{{archive.dateCreation | date:\'dd/MM/yyyy à HH:mm\'}}</td><td>{{archive.perimetre}}</td><td><span \nclass=\"qs-campagne-template-state\" \nng-class=\"{\n                    \'is-selected\': archive.statut === \'PRET\',\n                    \'is-standby\': archive.statut === \'ECHEC\',\n                    \'is-neutre\': archive.statut !== \'PRET\' && archive.statut !== \'ECHEC\'}\">\n{{archive.statut | aeqStatutExport}}</span></td><td class=\"aeq-mono\"><span ng-if=\"archive.statut === \'PRET\'\">\n{{archive.avancement}} / {{archive.total}}</span> <span ng-if=\"archive.statut === \'EN_PREPARATION\'\">en préparation…\n</span> <span ng-if=\"archive.statut !== \'PRET\' && archive.statut !== \'EN_PREPARATION\'\">—</span></td><td>\n{{archive.dateExpiration | date:\'dd/MM/yyyy\'}}</td><td class=\"aeq-actions\"><button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome aeq-btn-ligne\" ng-if=\"archive.statut === \'PRET\'\" \nng-click=\"telechargerArchive(archive)\"><md-icon md-font-icon=\"icon-download\" class=\"s14\"></md-icon><span>Télécharger\n</span></button></td></tr></tbody></table></section><section class=\"qs-config-card\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-font-icon=\"icon-pharmacy\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Officines du réseau</h2><p class=\"qs-config-card-subtitle\">\nOù en est chaque officine de votre périmètre. Une officine validée avec moins de <b>60 % de « Oui »</b>\n est signalée en vigilance ; par défaut, ces officines sont listées en premier.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge is-selected\" ng-if=\"pagination.total\">{{pagination.total}}\n</span></header><div class=\"aeq-barre-outils\"><input type=\"search\" ng-model=\"filtres.recherche\" \nng-change=\"rechercheModifiee()\" placeholder=\"Rechercher une officine ou un CIP\"><select ng-model=\"filtres.statut\" \nng-change=\"filtrer()\"><option value=\"\">Tous les statuts</option><option \nng-repeat=\"s in statutsFiltrables() track by s.code\" value=\"{{s.code}}\" ng-selected=\"filtres.statut === s.code\">\n{{s.libelle}}</option></select><select ng-model=\"filtres.compte\" ng-change=\"filtrer()\"><option value=\"\">\nTous les comptes</option><option ng-repeat=\"c in FILTRES_COMPTE track by c.code\" value=\"{{c.code}}\" \nng-selected=\"filtres.compte === c.code\">{{c.libelle}}</option></select><span class=\"aeq-espace\"></span> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"exportEnCours\" ng-click=\"exporter(\'non-repondants\')\">\n<md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon><span>Export des non-répondants</span></button> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-click=\"demanderArchive()\"><md-icon \nmd-font-icon=\"icon-folder-download\" class=\"s16\"></md-icon><span>Archive des rapports</span></button></div><div \nclass=\"aeq-chargement\" ng-if=\"chargement.pharmacies\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular><span>Chargement des officines…</span></div><div class=\"aeq-note aeq-note--info\" \nng-if=\"!chargement.pharmacies && pharmacies && !pharmacies.lignes.length\">Aucune officine ne correspond à ces critères.\n</div><table class=\"aeq-tbl\" ng-if=\"!chargement.pharmacies && pharmacies.lignes.length\"><thead><tr><th \nclass=\"aeq-triable\" ng-class=\"{\'aeq-triable--actif\': tri.colonne === \'nom\'}\" ng-click=\"trierPar(\'nom\')\">Pharmacie<span \nclass=\"aeq-tri-fleche\" ng-if=\"tri.colonne === \'nom\'\">{{tri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></th><th>CIP</th><th>\nVille</th><th class=\"aeq-triable\" ng-class=\"{\'aeq-triable--actif\': tri.colonne === \'statut\'}\" \nng-click=\"trierPar(\'statut\')\">Statut<span class=\"aeq-tri-fleche\" ng-if=\"tri.colonne === \'statut\'\">\n{{tri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></th><th class=\"aeq-th-compte\" \ntitle=\"Compte titulaire : {{DEFINITION_COMPTE}}\">Compte titulaire<md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s14 aeq-th-info\"></md-icon></th><th class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': tri.colonne === \'score\'}\" ng-click=\"trierPar(\'score\')\">Synthèse (% Oui)<span \nclass=\"aeq-tri-fleche\" ng-if=\"tri.colonne === \'score\'\">{{tri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></th><th \nclass=\"aeq-triable\" ng-class=\"{\'aeq-triable--actif\': tri.colonne === \'alerte\'}\" ng-click=\"trierPar(\'alerte\')\" \ntitle=\"Vigilance : {{DEFINITION_ALERTE}}\">Vigilance<span class=\"aeq-tri-fleche\" ng-if=\"tri.colonne === \'alerte\'\">▲\n</span><md-icon md-font-icon=\"icon-information-outline\" class=\"s14 aeq-th-info\"></md-icon></th><th class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': tri.colonne === \'satisfaction\'}\" ng-click=\"trierPar(\'satisfaction\')\" \ntitle=\"Satisfaction : {{DEFINITION_SATISFACTION}}\">Satisfaction<span class=\"aeq-tri-fleche\" \nng-if=\"tri.colonne === \'satisfaction\'\">▲</span><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s14 aeq-th-info\"></md-icon></th><th></th></tr></thead><tbody><tr \nng-repeat=\"ligne in pharmacies.lignes track by ligne.soumissionId\" \nng-class=\"{\'aeq-tbl-alerte\': ligne.alerte, \'aeq-tbl-ouvrable\': ligne.detailOuvrable}\" \nng-click=\"ouvrirPharmacie(ligne)\"><td><b>{{ligne.nom}}</b></td><td class=\"aeq-mono\">{{ligne.cip}}</td><td>\n{{ligne.ville}}</td><td><span class=\"qs-campagne-template-state\" \nng-class=\"{\n                    \'is-selected\': ligne.statut === \'VALIDEE\',\n                    \'is-empty\': ligne.statut === \'NON_REPONDUE\',\n                    \'is-neutre\': ligne.statut !== \'VALIDEE\' && ligne.statut !== \'NON_REPONDUE\'}\">\n{{ligne.statut | aeqStatutSoumission}} </span><span class=\"aeq-pill aeq-pill--enc\" \nng-if=\"ligne.statut === \'PARTIELLE\' || ligne.statut === \'NON_REPONDUE\'\" \ntitle=\"Proposée au passage au statut ENC (Engagé Non Certifié)\">ENC</span></td><td><div class=\"aeq-compte\"><button \ntype=\"button\" class=\"aeq-compte-chip\" ng-class=\"classeCompte(ligne)\" title=\"{{titreCompte(ligne)}}\" \nng-click=\"ouvrirAcces(ligne, $event); $event.stopPropagation()\"><span class=\"aeq-compte-point\"></span> <span>\n{{libelleCompte(ligne)}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s14\"></md-icon></button> <span \nclass=\"aeq-compte-connexion\" ng-if=\"ligne.derniereConnexion\" \ntitle=\"{{ligne.derniereConnexion | date:\'dd/MM/yyyy à HH:mm\'}}\">\nConnecté le {{ligne.derniereConnexion | date:\'dd/MM/yyyy\'}}</span> <span \nclass=\"aeq-compte-connexion aeq-compte-connexion--jamais\" ng-if=\"!ligne.derniereConnexion\">Jamais connecté</span></div>\n</td><td class=\"aeq-mono\"><span ng-if=\"aUneValeur(ligne.scoreOui)\"><b>{{ligne.scoreOui | number:0}} %</b></span> <span \nng-if=\"!aUneValeur(ligne.scoreOui)\">— <span class=\"aeq-score-rempli\" ng-if=\"aUneValeur(ligne.tauxRemplissage)\">\n· {{ligne.tauxRemplissage | number:0}} % rempli</span></span></td><td><span class=\"aeq-pill aeq-pill--alerte\" \nstyle=\"margin-left: 0\" ng-if=\"ligne.alerte\" title=\"Vigilance : {{DEFINITION_ALERTE}}\">&lt; 60 % de Oui</span> <span \nclass=\"aeq-t-faible\" ng-if=\"!ligne.alerte\">—</span></td><td><button type=\"button\" class=\"aeq-sat-alerte\" \nng-if=\"ligne.nbInsatisfactions > 0\" \ntitle=\"{{ligne.nbInsatisfactions}} question{{ligne.nbInsatisfactions > 1 ? \'s\' : \'\'}} du chapitre « Votre satisfaction » répondue{{ligne.nbInsatisfactions > 1 ? \'s\' : \'\'}} « Insatisfait » ou « Très insatisfait ». Voir ses réponses dans l\'onglet Satisfaction.\" \nng-click=\"voirSatisfaction(ligne); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-emoticon-sad\" \nclass=\"s16 aeq-sat-alerte-ico\"></md-icon><span><b>{{ligne.nbInsatisfactions}}</b>\n question{{ligne.nbInsatisfactions > 1 ? \'s\' : \'\'}}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s14 aeq-sat-alerte-suite\"></md-icon></button> <span class=\"aeq-t-faible\" ng-if=\"!(ligne.nbInsatisfactions > 0)\">\n—</span></td><td class=\"aeq-actions\"><button type=\"button\" class=\"gpt-btn gpt-btn--fantome aeq-btn-ligne\" \nng-if=\"ligne.detailOuvrable\" ng-click=\"ouvrirPharmacie(ligne); $event.stopPropagation()\"><span>Voir le détail</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s14\"></md-icon></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome aeq-btn-ligne aeq-btn-renvoi\" \nng-if=\"renvoiAffiche(ligne) && ligne.refusRenvoi !== \'RENVOI_RECENT\'\" ng-disabled=\"!ligne.renvoiPossible\" \ntitle=\"{{ligne.motifRenvoi || \'Renvoyer l’e-mail de lancement de la campagne à cette officine\'}}\" \nng-click=\"ouvrirAcces(ligne, $event); $event.stopPropagation()\"><md-icon md-font-icon=\"icon-email\" class=\"s14\">\n</md-icon><span>Renvoyer l\'e-mail</span></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome aeq-btn-ligne aeq-btn-envoye\" \nng-if=\"renvoiAffiche(ligne) && ligne.refusRenvoi === \'RENVOI_RECENT\'\" disabled=\"disabled\" \ntitle=\"Nouvel envoi possible à {{heure(ligne.prochainRenvoi)}}\"><md-icon md-font-icon=\"icon-check\" class=\"s14\">\n</md-icon><span>Envoyé à {{heure(ligne.dernierRenvoi)}}</span></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--fantome aeq-btn-ligne\" ng-if=\"!ligne.detailOuvrable && !renvoiAffiche(ligne)\" \ndisabled=\"disabled\" title=\"Le détail ne s\'ouvre qu\'une fois l\'auto-évaluation validée\"><span>Non validée</span>\n</button></td></tr></tbody></table><div class=\"aeq-pied aeq-pied-cadre\" \nng-if=\"!chargement.pharmacies && pagination.total\"><span class=\"aeq-pied-compte\"><b>{{pagination.total}}</b>\n officine{{pagination.total > 1 ? \'s\' : \'\'}} <span ng-if=\"nbPages() > 1\">· page {{pagination.page}} sur {{nbPages()}}\n</span></span><div class=\"qs-verbatim-pagination\" ng-if=\"nbPages() > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: pagination.page <= 1}\"><button type=\"button\" ng-disabled=\"pagination.page <= 1\" \nng-click=\"changerPage(pagination.page - 1)\" aria-label=\"Page précédente\">&lsaquo;</button></li><li \nng-repeat=\"numero in pages() track by $index\" \nng-class=\"{active: pagination.page === numero, disabled: numero === \'...\'}\"><button type=\"button\" \nng-if=\"numero !== \'...\'\" ng-disabled=\"pagination.page === numero\" ng-click=\"changerPage(numero)\">{{numero}}</button> \n<button type=\"button\" ng-if=\"numero === \'...\'\" disabled=\"disabled\">...</button></li><li \nng-class=\"{disabled: pagination.page >= nbPages()}\"><button type=\"button\" ng-disabled=\"pagination.page >= nbPages()\" \nng-click=\"changerPage(pagination.page + 1)\" aria-label=\"Page suivante\">&rsaquo;</button></li></ul></div></div><p \nclass=\"aeq-hint\"><b>Compte titulaire</b> : {{DEFINITION_COMPTE}}</p><p class=\"aeq-hint\"><b>Satisfaction</b>\n : {{DEFINITION_SATISFACTION}}</p><p class=\"aeq-hint\"><b>Vigilance</b> : {{DEFINITION_ALERTE}} <span \nng-if=\"!pharmacies.provisoire\">La pastille <b>ENC</b>\n signale les officines proposées au passage au statut ENC (Engagé Non Certifié), faute de soumission validée à la clôture.\n</span></p><p class=\"aeq-hint\">Le détail n\'est ouvrable que pour une officine <b>validée</b>\n : les réponses d\'une auto-évaluation en cours ne sont pas restituées au réseau. Aucun seuil d\'anonymat n\'est appliqué — c\'est une décision assumée de la démarche.\n</p></section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'profil\' && !ferme\"><div \nclass=\"aeq-chargement\" ng-if=\"chargement.profil && !profil\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular><span>Chargement du profil…</span></div><section class=\"qs-config-card\" \nng-if=\"profil\"><header class=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Profil du réseau</h2><p class=\"qs-config-card-subtitle\">\nLe chapitre « Pour mieux vous connaître », question par question : une distribution des réponses, pas un score.</p>\n</div><span class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"profil.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{profil.nbOfficines}} validée{{profil.nbOfficines > 1 ? \'s\' : \'\'}}{{profil.provisoire ? \' · provisoire\' : \'\'}}</span>\n</header><div class=\"aeq-note aeq-note--info\" ng-if=\"!profil.nbOfficines\">\nAucune officine de votre périmètre n\'a encore validé : le profil se construira à la première validation.</div><div \nclass=\"aeq-profil-q\" ng-repeat=\"question in profil.questions track by question.questionId\"><div \nclass=\"aeq-profil-tete\"><span class=\"aeq-profil-num\">{{question.numero}}</span> <span class=\"aeq-profil-lib\">\n{{question.libelle}}</span> <span class=\"aeq-profil-denom\">\n{{question.nbReponses}} réponse{{question.nbReponses > 1 ? \'s\' : \'\'}}</span></div><div ng-if=\"!question.choixMultiple\">\n<div class=\"aeq-barre\" ng-class=\"{\'aeq-barre--vide\': !question.nbReponses}\"><span class=\"aeq-barre-seg\" \nng-repeat=\"part in partsAvecValeur(question) track by part.cle\" \nng-class=\"{\'aeq-barre-seg--pale\': part.cle === \'NON_CONCERNE\'}\" \nng-style=\"{width: part.pct + \'%\', background: part.couleurHex}\" \ntitle=\"{{part.libelle}} : {{part.nb}} ({{part.pct | number:1}} %)\"><span ng-if=\"part.pct >= 8\">\n{{part.pct | number:0}} %</span></span></div><div class=\"aeq-legende\"><span class=\"aeq-legende-item\" \nng-repeat=\"part in question.distribution track by part.cle\"><span class=\"aeq-legende-dot\" \nng-style=\"{background: part.couleurHex}\"></span> {{part.libelle}} <span class=\"aeq-legende-val\">\n{{aUneValeur(part.pct) ? (part.pct | number:0) + \' %\' : \'—\'}}</span> <span class=\"aeq-t-faible\">({{part.nb}})</span>\n</span></div></div><div class=\"aeq-profil-options\" ng-if=\"question.choixMultiple\"><div class=\"aeq-profil-option\" \nng-repeat=\"part in question.distribution track by part.cle\"><span>{{part.libelle}}</span> <span \nclass=\"aeq-profil-option-barre\"><span class=\"aeq-profil-option-fill\" \nng-style=\"{width: (part.pct || 0) + \'%\', background: part.couleurHex || \'#1C5BB8\'}\"></span> </span><span \nclass=\"aeq-profil-option-val\">{{aUneValeur(part.pct) ? (part.pct | number:0) + \' %\' : \'—\'}} <small>({{part.nb}})\n</small></span></div></div></div><p class=\"aeq-hint\">\nDénominateur : les officines validées ayant répondu à la question. Les questions du profil <b>changent chaque année</b>\n : aucune comparaison nationale ni N-1 n\'est proposée sur ce chapitre. Les réponses en texte libre figurent dans l\'export détaillé.\n</p></section><aeq-focus-reseau ng-if=\"focusReseau\" donnees=\"focusReseau\"></aeq-focus-reseau><section \nclass=\"qs-config-card\" ng-if=\"profil && profil.demandesContact.length\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-phone\" class=\"s22\"></md-icon></div>\n<div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Demandes de contact</h2><p \nclass=\"qs-config-card-subtitle\">\nLes officines qui souhaitent être contactées par le responsable qualité de leur groupement — la contrepartie de la promesse faite pendant le remplissage.\n</p></div><span class=\"qs-campagne-template-state qs-config-card-badge is-selected\">{{profil.demandesContact.length}}\n</span></header><table class=\"aeq-tbl\"><thead><tr><th>Pharmacie</th><th>CIP</th><th>Ville</th><th>Commentaire</th><th>\nValidée le</th></tr></thead><tbody><tr ng-repeat=\"demande in profil.demandesContact track by $index\"><td><b>\n{{demande.nom}}</b></td><td class=\"aeq-mono\">{{demande.cip}}</td><td>{{demande.ville}}</td><td>\n{{demande.commentaire || \'—\'}}</td><td class=\"aeq-mono\">{{demande.dateValidation | date:\'dd/MM/yyyy\'}}</td></tr>\n</tbody></table></section></div><div class=\"qs-config-campagne-form\" ng-if=\"onglet === \'satisfaction\' && !ferme\"><div \nclass=\"aeq-chargement\" ng-if=\"chargement.satisfaction && !satisfaction\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"24\"></md-progress-circular><span>Chargement de la satisfaction…</span></div><section \nclass=\"qs-config-card\" ng-if=\"satisfaction\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-emoticon-happy\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Satisfaction du réseau</h2><p \nclass=\"qs-config-card-subtitle\">\nLe chapitre « Votre satisfaction », question par question, comparé à l\'ensemble des officines PHSQ.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"satisfaction.provisoire ? \'is-neutre\' : \'is-selected\'\">\n{{satisfaction.nbOfficines}} validée{{satisfaction.nbOfficines > 1 ? \'s\' : \'\'}}{{satisfaction.provisoire ? \' · provisoire\' : \'\'}}\n</span></header><div class=\"aeq-note aeq-note--info\" ng-if=\"!satisfaction.nbOfficines\">\nAucune officine de votre périmètre n\'a encore validé : la satisfaction se construira à la première validation.</div>\n<div class=\"aeq-sat-resume\" ng-if=\"satisfaction.nbOfficines\"><div class=\"aeq-sat-chiffre\"><strong>\n{{aUneValeur(satisfaction.pctSatisfaits) ? (satisfaction.pctSatisfaits | number:0) + \' %\' : \'—\'}}</strong> <span>\nde satisfaits dans {{satisfaction.perimetre === \'GROUPEMENT\' ? \'le réseau\' : \'le périmètre\'}}</span></div><div \nclass=\"aeq-sat-chiffre\" ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\"><strong>\n{{aUneValeur(satisfaction.nationalPctSatisfaits) ? (satisfaction.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}\n</strong> <span>National</span></div><aeq-badge-ecart ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\" \nvaleur=\"satisfaction.ecartPts\" suffixe=\"\'vs national\'\"></aeq-badge-ecart></div><div class=\"aeq-sat-legende\"><span \nng-repeat=\"modalite in satisfaction.palette track by modalite.valeur\"><span class=\"aeq-sat-legende-dot\" \nng-style=\"{background: modalite.couleurHex}\"></span>{{modalite.libelle}}</span></div><div class=\"aeq-sat-q\" \nng-repeat=\"question in satisfaction.questions track by question.questionId\"><div class=\"aeq-sat-qtete\"><span \nclass=\"aeq-sat-num\">{{question.numero}}</span> <span class=\"aeq-sat-lib\">{{question.libelle}}</span> <span \nclass=\"aeq-sat-pct\">\n{{aUneValeur(question.pctSatisfaits) ? (question.pctSatisfaits | number:0) + \' % satisfaits\' : \'—\'}}</span>\n<aeq-badge-ecart ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\" valeur=\"question.ecartPts\" suffixe=\"\'vs national\'\">\n</aeq-badge-ecart></div><div class=\"aeq-sat-ligne\"><span>Réseau</span> <span class=\"aeq-barre\" \nng-class=\"{\'aeq-barre--vide\': !question.nbReponses}\"><span class=\"aeq-barre-seg\" \nng-repeat=\"part in partsSatisfaction(question.distribution) track by part.cle\" \nng-class=\"{\'aeq-barre-seg--pale\': part.cle !== \'TRES_SATISFAIT\' && part.cle !== \'TRES_INSATISFAIT\'}\" \nng-style=\"{width: part.pct + \'%\', background: part.couleurHex}\" \ntitle=\"{{part.libelle}} : {{part.nb}} ({{part.pct | number:1}} %)\"><span ng-if=\"part.pct >= 8\">\n{{part.pct | number:0}} %</span> </span></span><span class=\"aeq-sat-val\">\n{{aUneValeur(question.pctSatisfaits) ? (question.pctSatisfaits | number:0) + \' %\' : \'—\'}}</span></div><div \nclass=\"aeq-sat-ligne\" ng-if=\"satisfaction.perimetre === \'GROUPEMENT\'\"><span>National</span> <span class=\"aeq-barre\">\n<span class=\"aeq-barre-seg\" ng-repeat=\"part in partsSatisfaction(question.national) track by part.cle\" \nng-class=\"{\'aeq-barre-seg--pale\': part.cle !== \'TRES_SATISFAIT\' && part.cle !== \'TRES_INSATISFAIT\'}\" \nng-style=\"{width: part.pct + \'%\', background: part.couleurHex}\" \ntitle=\"{{part.libelle}} : {{part.nb}} ({{part.pct | number:1}} %)\"><span ng-if=\"part.pct >= 8\">\n{{part.pct | number:0}} %</span> </span></span><span class=\"aeq-sat-val\">\n{{aUneValeur(question.nationalPctSatisfaits) ? (question.nationalPctSatisfaits | number:0) + \' %\' : \'—\'}}</span></div>\n</div><p class=\"aeq-hint\"><b>% de satisfaits</b>\n : « Très satisfait » et « Satisfait », rapportés aux réponses autres que « Non concerné ». <span \nng-if=\"satisfaction.provisoire\">Campagne en cours : réseau et national évoluent à chaque validation.</span></p>\n</section><section class=\"qs-config-card\" ng-if=\"satisfaction && satisfaction.nbOfficines\"><header \nclass=\"qs-config-card-header\"><div class=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon \nmd-font-icon=\"icon-table-large\" class=\"s22\"></md-icon></div><div class=\"qs-config-card-heading\"><h2 \nclass=\"qs-config-card-title\">Réponses par officine</h2><p class=\"qs-config-card-subtitle\">\nChaque officine validée, ses réponses et son commentaire. Les moins satisfaites d\'abord.</p></div><span \nclass=\"qs-campagne-template-state qs-config-card-badge is-selected\" ng-if=\"satisfactionPagination.total\">\n{{satisfactionPagination.total}}</span></header><div class=\"aeq-barre-outils\"><input type=\"search\" \nng-model=\"satisfactionFiltres.recherche\" ng-change=\"rechercheSatisfactionModifiee()\" \nplaceholder=\"Rechercher une officine ou un CIP\"><select ng-model=\"satisfactionFiltres.filtre\" \nng-change=\"filtrerSatisfaction()\"><option value=\"\">Toutes les officines</option><option value=\"INSATISFAITS\">\nAu moins une insatisfaction{{satisfactionOfficines ? \' (\' + satisfactionOfficines.totalAvecInsatisfaction + \')\' : \'\'}}\n</option></select><span class=\"aeq-espace\"></span> <button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" \nng-disabled=\"exportSatisfaction\" ng-click=\"exporterSatisfaction()\"><md-icon md-font-icon=\"icon-download\" class=\"s16\">\n</md-icon><span>{{exportSatisfaction ? \'Préparation…\' : \'Export satisfaction\'}}</span></button></div><div \nclass=\"aeq-chargement\" ng-if=\"chargement.satisfactionOfficines && !satisfactionOfficines\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular><span>Chargement des réponses…</span></div><div \nstyle=\"overflow-x: auto\" ng-if=\"satisfactionOfficines\"><table class=\"aeq-tbl\"><thead><tr><th><span class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'nom\'}\" ng-click=\"trierSatisfaction(\'nom\')\">Pharmacie<span\n class=\"aeq-tri-fleche\" ng-if=\"satisfactionTri.colonne === \'nom\'\">{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span>\n</span></th><th ng-if=\"!dashboard.groupement.code\"><span class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'groupement\'}\" ng-click=\"trierSatisfaction(\'groupement\')\">\nGroupement<span class=\"aeq-tri-fleche\" ng-if=\"satisfactionTri.colonne === \'groupement\'\">\n{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></span></th><th class=\"aeq-sat-c\" \nng-repeat=\"question in satisfactionOfficines.questions track by question.questionId\" title=\"{{question.libelle}}\">\n{{question.numero}}</th><th class=\"aeq-sat-d\"><span class=\"aeq-triable\" \nng-class=\"{\'aeq-triable--actif\': satisfactionTri.colonne === \'satisfaction\'}\" \nng-click=\"trierSatisfaction(\'satisfaction\')\">Satisfaits<span class=\"aeq-tri-fleche\" \nng-if=\"satisfactionTri.colonne === \'satisfaction\'\">{{satisfactionTri.sens === \'asc\' ? \'▲\' : \'▼\'}}</span></span></th>\n<th>Commentaire</th></tr></thead><tbody><tr ng-if=\"!satisfactionOfficines.lignes.length\"><td \ncolspan=\"{{satisfactionOfficines.questions.length + 4}}\" class=\"aeq-t-faible\">\nAucune officine ne correspond à la recherche.</td></tr><tr \nng-repeat=\"ligne in satisfactionOfficines.lignes track by ligne.soumissionId\"><td><b>{{ligne.nom}}</b><br><span \nclass=\"aeq-t-faible\">{{ligne.cip}}<span ng-if=\"ligne.ville\"> · {{ligne.ville}}</span></span></td><td \nng-if=\"!dashboard.groupement.code\">{{ligne.groupement || \'—\'}}</td><td class=\"aeq-sat-c\" \nng-repeat=\"valeur in ligne.reponses track by $index\"><span class=\"aeq-sat-rep\" ng-if=\"valeur\" \nng-class=\"{\'aeq-sat-rep--fonce\': valeur === \'TRES_INSATISFAIT\'}\" \nng-style=\"{background: modaliteSatisfaction(valeur).couleurHex}\" title=\"{{modaliteSatisfaction(valeur).libelle}}\">\n{{abregeSatisfaction(valeur)}}</span> <span class=\"aeq-sat-rep aeq-sat-rep--vide\" ng-if=\"!valeur\">—</span></td><td \nclass=\"aeq-mono aeq-sat-d\"><b>{{aUneValeur(ligne.pctSatisfaits) ? (ligne.pctSatisfaits | number:0) + \' %\' : \'—\'}}</b>\n</td><td class=\"aeq-sat-com\">{{ligne.commentaire ? \'« \' + ligne.commentaire + \' »\' : \'—\'}}</td></tr></tbody></table>\n</div><div class=\"aeq-pied aeq-pied-cadre\" ng-if=\"satisfactionPagination.total\"><span class=\"aeq-pied-compte\"><b>\n{{satisfactionPagination.total}}</b> officine{{satisfactionPagination.total > 1 ? \'s\' : \'\'}} <span \nng-if=\"nbPagesSatisfaction() > 1\">· page {{satisfactionPagination.page}} sur {{nbPagesSatisfaction()}}</span></span>\n<div class=\"qs-verbatim-pagination\" ng-if=\"nbPagesSatisfaction() > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: satisfactionPagination.page <= 1}\"><button type=\"button\" \nng-disabled=\"satisfactionPagination.page <= 1\" ng-click=\"changerPageSatisfaction(satisfactionPagination.page - 1)\" \naria-label=\"Page précédente\">&lsaquo;</button></li><li ng-repeat=\"numero in pagesSatisfaction() track by $index\" \nng-class=\"{active: satisfactionPagination.page === numero, disabled: numero === \'...\'}\"><button type=\"button\" \nng-if=\"numero !== \'...\'\" ng-disabled=\"satisfactionPagination.page === numero\" \nng-click=\"changerPageSatisfaction(numero)\">{{numero}}</button> <button type=\"button\" ng-if=\"numero === \'...\'\" \ndisabled=\"disabled\">...</button></li><li ng-class=\"{disabled: satisfactionPagination.page >= nbPagesSatisfaction()}\">\n<button type=\"button\" ng-disabled=\"satisfactionPagination.page >= nbPagesSatisfaction()\" \nng-click=\"changerPageSatisfaction(satisfactionPagination.page + 1)\" aria-label=\"Page suivante\">&rsaquo;</button></li>\n</ul></div></div><p class=\"aeq-hint\"><b>Questions</b> : <span \nng-repeat=\"question in satisfactionOfficines.questions track by question.questionId\">\n{{question.numero}} {{question.libelle}}{{$last ? \'.\' : \' · \'}}</span> <b>Réponses</b>\n : TS très satisfait, S satisfait, I insatisfait, TI très insatisfait, NC non concerné. Seules les officines validées apparaissent.\n</p></section></div></div></div>");
$templateCache.put("app/main/front/groupement/auto-evaluation/autoeval-pharmacie.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page aeq-gpt\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"column\"><div class=\"nl_breadcumb gpt-breadcrumb\"><span \nclass=\"nl_breadcumb--item\" ng-click=\"retour()\">Auto-évaluation {{annee}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item\" \nng-click=\"retour()\">Pharmacies</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 nl_breadcumb--item--icon\">\n</md-icon><span class=\"nl_breadcumb--item nl_breadcumb--item--title\">{{detail.pharmacie.nom || \'Officine\'}}</span>\n</div><div layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg gpt-fiche-entete\"><div \nclass=\"h1 gpt-header__title\">{{detail.pharmacie.nom || \'Officine\'}}</div><div class=\"gpt-fiche-entete__identite\" \nng-if=\"detail\"><span>CIP {{detail.pharmacie.cip}}</span> <span ng-if=\"detail.pharmacie.ville\">\n· {{detail.pharmacie.codePostal}} {{detail.pharmacie.ville}}</span> <span ng-if=\"detail.pharmacie.anneeEngagement\">\n· engagée depuis {{detail.pharmacie.anneeEngagement}}</span></div><div class=\"gpt-pastilles\" ng-if=\"detail\"><span \nclass=\"gpt-pastille gpt-pastille--on\">\n{{detail.statut | aeqStatutSoumission}} le {{detail.dateValidation | date:\'dd/MM/yyyy\'}}</span> <span \nclass=\"gpt-pastille\" ng-if=\"detail.provisoire\">Comparaison provisoire</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"gpt-header__actions\"><span class=\"gpt-header__compteur\" \nng-if=\"aUneValeur(detail.scoreOui)\">{{detail.scoreOui | number:0}} % <span>de « Oui »</span></span></div></div></div>\n<div class=\"content gpt-content\"><div class=\"aeq-chargement\" ng-if=\"chargement\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular><span>Chargement du détail…</span></div><div \nclass=\"gpt-erreur\" ng-if=\"!chargement && erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div \nclass=\"gpt-erreur__titre\">{{erreur.message}}</div><button type=\"button\" class=\"gpt-btn gpt-btn--principal\" \nng-click=\"retour()\">Retour à la liste</button></div><div class=\"qs-config-campagne-form\" ng-if=\"!chargement && detail\">\n<div class=\"aeq-note aeq-note--info\" ng-if=\"detail.provisoire\"><b>Campagne en cours.</b>\n Les écarts au réseau ci-dessous évoluent au fil des validations des autres officines ; les réponses de celle-ci, elles, sont figées par sa validation.\n</div><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--blue\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Répartition par chapitre</h2><p \nclass=\"qs-config-card-subtitle\">\nLes réponses de l\'officine, et son écart à la moyenne du réseau en points de « Oui », chapitre par chapitre.</p></div>\n<span class=\"qs-campagne-template-state qs-config-card-badge is-selected\" ng-if=\"aUneValeur(detail.scoreOui)\">\n{{detail.scoreOui | number:0}} % de « Oui »</span></header><table class=\"aeq-tbl\"><thead><tr><th>Chapitre</th><th>Oui\n</th><th>En cours</th><th>Non</th><th>Non concerné</th><th>Écart réseau</th></tr></thead><tbody><tr \nng-repeat=\"ligne in detail.chapitres track by ligne.chapitreId\" ng-class=\"{\'aeq-nonconcerne\': !ligne.concerne}\"><td><b>\n<span class=\"aeq-ccode\" ng-style=\"{background: ligne.couleurHex}\">{{ligne.code}}</span> {{ligne.titre}}</b> <span \nclass=\"aeq-nonconcerne-txt\" ng-if=\"!ligne.concerne && ligne.declencheur\">\nNon concerné — «&nbsp;{{ligne.declencheur.valeurLibelle}}&nbsp;» à la question {{ligne.declencheur.numero}} : <span \nng-if=\"ligne.declencheur.nbQuestionsMasquees > 1\">\nses {{ligne.declencheur.nbQuestionsMasquees}} questions n\'ont pas été posées</span><span \nng-if=\"ligne.declencheur.nbQuestionsMasquees === 1\">sa question n\'a pas été posée</span>. </span><span \nclass=\"aeq-pill aeq-pill--close\" ng-if=\"!ligne.concerne && !ligne.declencheur\">non concerné</span></td><td \nclass=\"aeq-mono aeq-t-oui\">{{ligne.concerne && aUneValeur(ligne.pctOui) ? (ligne.pctOui | number:0) + \' %\' : \'—\'}}</td>\n<td class=\"aeq-mono aeq-t-encours\">\n{{ligne.concerne && aUneValeur(ligne.pctEnCours) ? (ligne.pctEnCours | number:0) + \' %\' : \'—\'}}</td><td \nclass=\"aeq-mono aeq-t-non\">{{ligne.concerne && aUneValeur(ligne.pctNon) ? (ligne.pctNon | number:0) + \' %\' : \'—\'}}</td>\n<td class=\"aeq-mono\">{{ligne.concerne && aUneValeur(ligne.pctNc) ? (ligne.pctNc | number:0) + \' %\' : \'—\'}}</td><td>\n<aeq-badge-ecart valeur=\"ligne.concerne ? ligne.ecartGroupementPts : null\" suffixe=\"\'vs réseau\'\"></aeq-badge-ecart>\n</td></tr></tbody></table><p class=\"aeq-hint\">L\'écart est calculé sur les <b>mêmes chapitres</b>\n que la moyenne du réseau, en points de « Oui ». Pas de colonne nationale ni d\'évolution N-1 à ce niveau : ce sont des repères de réseau, sans classement ni note.\n</p></section><section class=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--teal\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s22\"></md-icon>\n</div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Vue d\'ensemble</h2><p \nclass=\"qs-config-card-subtitle\">Répartition en quatre modalités, chapitre par chapitre.</p></div></header><div \nclass=\"aeq-legende\"><span class=\"aeq-legende-item\" \nng-repeat=\"item in legendeModalites(detail.palette) track by item.valeur\"><span class=\"aeq-legende-dot\" \nng-style=\"{background: item.couleurHex}\"></span>{{item.libelleLong}}</span></div><div class=\"aeq-hgrid\"><div \nclass=\"aeq-hrow\" ng-repeat=\"ligne in chapitresConcernes() track by ligne.chapitreId\"><span class=\"aeq-hlab\"><span \nclass=\"aeq-cdot\" ng-style=\"{background: ligne.couleurHex}\"></span> {{ligne.code}} · {{ligne.titre}}</span>\n<aeq-barre-empilee ligne=\"ligne\" palette=\"detail.palette\"></aeq-barre-empilee></div></div></section><section \nclass=\"qs-config-card\"><header class=\"qs-config-card-header\"><div \nclass=\"qs-config-card-icon qs-config-card-icon--violet\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s22\">\n</md-icon></div><div class=\"qs-config-card-heading\"><h2 class=\"qs-config-card-title\">Points d\'attention</h2><p \nclass=\"qs-config-card-subtitle\">\nLes focus déclenchés par les réponses de l\'officine : un sujet d\'accompagnement, pas une non-conformité.</p></div><span\n class=\"qs-campagne-template-state qs-config-card-badge\" \nng-class=\"detail.pointsAttention.length ? \'is-brouillon\' : \'is-selected\'\">{{detail.pointsAttention.length}} focus\n</span></header><div class=\"aeq-note aeq-note--ok\" ng-if=\"!detail.pointsAttention.length\">\nAucun point d\'attention déclenché par les réponses de cette officine.</div><table class=\"aeq-tbl\" \nng-if=\"detail.pointsAttention.length\"><thead><tr><th>Chapitre</th><th>N°</th><th>Question</th><th>Réponse</th><th>Sujet\n</th></tr></thead><tbody><tr ng-repeat=\"point in pointsAffiches() track by point.questionId\"><td \nstyle=\"white-space: nowrap\">{{point.chapitreCode}} · {{point.chapitreTitre}}</td><td class=\"aeq-mono\">{{point.numero}}\n</td><td>{{point.libelleQuestion}}</td><td><b>{{point.valeurLibelle}}</b></td><td>\n{{point.titre | aeqTitreFocus:point.libelleQuestion}}</td></tr></tbody></table><div class=\"aeq-navrow\" \nng-if=\"detail.pointsAttention.length > LIMITE_POINTS\"><span class=\"aeq-hint\" style=\"margin: 0\" ng-if=\"!tousLesPoints\">\n{{LIMITE_POINTS}} affichés sur {{detail.pointsAttention.length}}, par ordre de chapitre. </span><span \nclass=\"aeq-espace\"></span> <button type=\"button\" class=\"aeq-lien\" ng-click=\"tousLesPoints = !tousLesPoints\">\n{{tousLesPoints ? \'Réduire la liste\' : \'Voir les \' + detail.pointsAttention.length + \' points d’attention\'}}</button>\n</div><p class=\"aeq-hint\">\nLes commentaires saisis par l\'officine ne sont pas affichés ici ; ils figurent dans l\'export détaillé.</p></section>\n<div class=\"aeq-navrow\" style=\"border-top: 0; padding-top: 0\"><button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" \nng-click=\"retour()\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16\"></md-icon><span>Retour à la liste</span>\n</button></div></div></div></div>");
$templateCache.put("app/main/front/groupement/pharmacie/declarer-sortie-qualite.dialog.html","<md-dialog class=\"gpt-dialog\" aria-label=\"Déclarer une sortie de la démarche qualité\"><form name=\"formSortieQualite\" \nnovalidate ng-submit=\"valider()\"><div class=\"gpt-dialog__entete\"><button type=\"button\" class=\"gpt-dialog__fermer\" \nng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div \nclass=\"gpt-dialog__titre\">Déclarer une sortie de la démarche qualité</div><div class=\"gpt-dialog__sous-titre\">\n{{fiche.nom}}<span ng-if=\"fiche.codeCip\"> · CIP {{fiche.codeCip}}</span><span ng-if=\"fiche.groupement\">\n · {{fiche.groupement}}</span></div></div><md-dialog-content class=\"gpt-dialog__corps\"><div class=\"gpt-dialog__erreur\" \nrole=\"alert\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span>{{erreur}}</span>\n</div><div class=\"gpt-dialog__encart\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nL\'officine quitte la démarche qualité PHSQ (certification ISO 9001 QMS PHARMA®, LQO Premium inclus). Cette demande est \n<strong>transmise à PHSQ</strong>, qui la traite et recueille auprès de l\'officine les engagements de sortie.</span>\n</div><div class=\"gpt-dialog__champ\"><div class=\"gpt-dialog__label\" id=\"gpt-sq-raisons-label\">Raisons de la sortie \n<span class=\"gpt-dialog__facultatif\">(une ou plusieurs)</span></div><div class=\"gpt-dialog__cases\" role=\"group\" \naria-labelledby=\"gpt-sq-raisons-label\" \nng-class=\"{\'gpt-dialog__cases--invalide\': tentative && !raisonsChoisies().length}\"><label class=\"gpt-dialog__case\" \nng-repeat=\"raison in raisons track by raison.id\"><input type=\"checkbox\" ng-model=\"saisie.raisons[raison.id]\"> <span>\n{{raison.libelle}}</span></label><div class=\"gpt-dialog__aide\" ng-if=\"raisons === null\">Chargement des raisons…</div>\n<div class=\"gpt-dialog__aide\" ng-if=\"raisons && !raisons.length && !erreurRaisons\">\nAucune raison n\'est proposée pour le moment.</div></div><div class=\"gpt-dialog__aide gpt-dialog__aide--erreur\" \nng-if=\"erreurRaisons\">{{erreurRaisons}}</div><div class=\"gpt-dialog__aide gpt-dialog__aide--erreur\" \nng-if=\"tentative && !raisonsChoisies().length && !erreurRaisons\">Cochez au moins une raison.</div></div><div \nclass=\"gpt-dialog__champ\" ng-if=\"raisonExigeante()\"><label class=\"gpt-dialog__label\" for=\"gpt-sq-precision\">\nPrécisez la raison «&#8239;{{raisonExigeante().libelle}}&#8239;»</label><textarea id=\"gpt-sq-precision\" \nclass=\"gpt-dialog__zone\" ng-model=\"saisie.raisonPrecision\" rows=\"2\" maxlength=\"500\"></textarea><div \nclass=\"gpt-dialog__aide gpt-dialog__aide--erreur\" ng-if=\"tentative && manquePrecision()\">Précisez la raison.</div>\n</div><div class=\"gpt-dialog__champ\"><label class=\"gpt-dialog__label\" for=\"gpt-sq-date\">Date effective souhaitée\n</label><input id=\"gpt-sq-date\" class=\"gpt-dialog__date\" type=\"date\" ng-model=\"saisie.dateSouhaitee\" \nmin=\"{{aujourdhui}}\" ng-model-options=\"{ allowInvalid: true }\" \nng-class=\"{\'gpt-dialog__date--invalide\': tentative && !dateValide()}\"><div class=\"gpt-dialog__aide\" \nng-if=\"!(tentative && !dateValide())\">\nAujourd\'hui ou plus tard. La date effective sera fixée par PHSQ à la fin du traitement.</div><div \nclass=\"gpt-dialog__aide gpt-dialog__aide--erreur\" ng-if=\"tentative && !dateValide()\">\nChoisissez aujourd\'hui ou une date à venir.</div></div><div class=\"gpt-dialog__champ\"><label class=\"gpt-dialog__label\" \nfor=\"gpt-sq-commentaires\">Commentaires <span class=\"gpt-dialog__facultatif\">(facultatif)</span></label><textarea \nid=\"gpt-sq-commentaires\" class=\"gpt-dialog__zone\" ng-model=\"saisie.commentaires\" rows=\"3\" maxlength=\"2000\" \nplaceholder=\"Ce que vous souhaitez que PHSQ sache…\"></textarea></div><div \nclass=\"gpt-dialog__encart gpt-dialog__encart--or\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span>\n<strong>L\'officine n\'est pas prévenue par LQO.</strong>\n Elle voit seulement qu\'une demande est en cours de traitement pour elle&#8239;; il vous revient de l\'informer de votre côté.\n</span></div></md-dialog-content><div class=\"gpt-dialog__actions\"><button type=\"button\" \nclass=\"gpt-dialog__btn gpt-dialog__btn--fantome\" ng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button \ntype=\"submit\" class=\"gpt-dialog__btn gpt-dialog__btn--principal\" ng-disabled=\"envoi || raisons === null\">\n{{envoi ? \'Transmission…\' : \'Transmettre la demande\'}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/groupement/pharmacie/declarer-sortie.dialog.html","<md-dialog class=\"gpt-dialog\" aria-label=\"Déclarer la sortie de cette officine\"><form name=\"formSortie\" novalidate \nng-submit=\"valider()\"><div class=\"gpt-dialog__entete\"><button type=\"button\" class=\"gpt-dialog__fermer\" \nng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div \nclass=\"gpt-dialog__titre\">Déclarer la sortie de cette officine</div><div class=\"gpt-dialog__sous-titre\">{{fiche.nom}}\n<span ng-if=\"fiche.codeCip\"> · CIP {{fiche.codeCip}}</span><span ng-if=\"fiche.groupement\">\n · sort de {{fiche.groupement}}</span></div></div><md-dialog-content class=\"gpt-dialog__corps\"><div \nclass=\"gpt-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon>\n<span>{{erreur}}</span></div><div class=\"gpt-dialog__encart\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16\"></md-icon><span>Cette déclaration est <strong>transmise à PHSQ</strong>\n, qui prendra contact avec vous. Le rattachement de l\'officine n\'est pas modifié en l\'envoyant&#8239;: c\'est PHSQ qui le fait, une fois la demande instruite.\n</span></div><div class=\"gpt-dialog__champ\"><label class=\"gpt-dialog__label\" id=\"gpt-sortie-motif-label\">\nMotif de la sortie <span class=\"gpt-dialog__facultatif\">(facultatif)</span></label><md-select class=\"gpt-select\" \nng-model=\"saisie.motifId\" placeholder=\"Sélectionner un motif\" aria-labelledby=\"gpt-sortie-motif-label\" \nmd-container-class=\"gpt-select-panneau\" ng-disabled=\"causes === null\"><md-option ng-value=\"null\">Aucun motif\n</md-option><md-option ng-repeat=\"cause in causes\" ng-value=\"cause.id\">{{cause.libelle}}</md-option></md-select><div \nclass=\"gpt-dialog__aide\" ng-if=\"!erreurCauses\">Liste proposée par PHSQ.</div><div \nclass=\"gpt-dialog__aide gpt-dialog__aide--erreur\" ng-if=\"erreurCauses\">\n{{erreurCauses}} La déclaration peut partir sans motif.</div></div><div class=\"gpt-dialog__champ\"><label \nclass=\"gpt-dialog__label\" for=\"gpt-sortie-precisions\">Précisions <span class=\"gpt-dialog__facultatif\">(facultatif)\n</span></label><textarea id=\"gpt-sortie-precisions\" class=\"gpt-dialog__zone\" ng-model=\"saisie.precisions\" rows=\"3\" \nmaxlength=\"2000\" placeholder=\"Ce que vous souhaitez que PHSQ sache avant de vous rappeler…\"></textarea></div><div \nclass=\"gpt-dialog__encart gpt-dialog__encart--or\"><md-icon md-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span>\n<strong>L\'officine n\'est pas prévenue par LQO.</strong>\n Cette déclaration circule entre vous et PHSQ&#8239;; il vous revient d\'informer la pharmacie de votre côté. Elle verra son nouveau rattachement une fois le changement effectué.\n</span></div></md-dialog-content><div class=\"gpt-dialog__actions\"><button type=\"button\" \nclass=\"gpt-dialog__btn gpt-dialog__btn--fantome\" ng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button \ntype=\"submit\" class=\"gpt-dialog__btn gpt-dialog__btn--principal\" ng-disabled=\"envoi\">\n{{envoi ? \'Transmission…\' : \'Transmettre la déclaration\'}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/groupement/pharmacie/fiche-pharmacie.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"column\"><div class=\"nl_breadcumb gpt-breadcrumb\"><span \nclass=\"nl_breadcumb--item\" ng-click=\"retourListe()\">Mes pharmacies</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 nl_breadcumb--item--icon\"></md-icon><span class=\"nl_breadcumb--item nl_breadcumb--item--title\">\n{{fiche.nom || reference}}</span></div><div layout=\"row\" layout-align=\"space-between center\" ng-if=\"fiche\"><div \nclass=\"white-fg gpt-fiche-entete\"><div class=\"h1 gpt-header__title\">{{fiche.nom}}</div><div \nclass=\"gpt-fiche-entete__identite\"><span>{{fiche.identifiant}}</span> <span ng-if=\"fiche.codeCip\">\n· CIP {{fiche.codeCip}}</span> <span ng-if=\"fiche.groupement\">· {{fiche.groupement}}</span> <span \nng-if=\"fiche.sousGroupe\">· {{fiche.sousGroupe}}</span><span ng-if=\"fiche.numeroAdherent\">\n· n° adhérent {{fiche.numeroAdherent}}</span> <span ng-if=\"fiche.adresse.ville\">· {{fiche.adresse.ville}}</span></div>\n<div class=\"gpt-pastilles\"><span class=\"gpt-pastille\">{{fiche.statut || \'Statut inconnu\'}}</span> <span \nclass=\"gpt-pastille\" ng-class=\"fiche.engagement.engage ? \'gpt-pastille--on\' : \'\'\">\n{{fiche.engagement.engage ? \'Engagée qualité\' : \'Non engagée\'}} </span><span class=\"gpt-pastille\" \nng-if=\"fiche.certification.certification\">{{fiche.certification.certification}}</span> <span class=\"gpt-pastille\" \nng-class=\"fiche.lqo.inscrit ? \'gpt-pastille--on\' : \'\'\">LQO</span> <span class=\"gpt-pastille\" \nng-class=\"fiche.ecor.inscrit ? \'gpt-pastille--on\' : \'\'\">ECOR</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"gpt-fiche-actions\"><button type=\"button\" \nclass=\"gpt-btn gpt-btn--sur-bandeau gpt-btn--sortie\" ng-if=\"peutDeclarerSortie()\" \nng-click=\"ouvrirDeclarationSortie($event)\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16\"></md-icon><span>\nDéclarer une sortie de groupement</span></button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--sur-bandeau gpt-btn--sortie\" ng-if=\"peutDeclarerSortieQualite()\" \nng-click=\"ouvrirDeclarationSortieQualite($event)\"><md-icon md-font-icon=\"icon-ribbon\" class=\"s16\"></md-icon><span>\nDéclarer une sortie de la démarche qualité</span></button> <button type=\"button\" class=\"gpt-word\" \nng-click=\"exporterFiche()\" ng-disabled=\"exportFiche\" ng-class=\"{\'gpt-word--en-cours\': exportFiche}\"><span \nclass=\"gpt-word__vignette\"><md-icon md-font-icon=\"icon-file-word\" class=\"s16\"></md-icon></span><span \nclass=\"gpt-word__texte\"><span class=\"gpt-word__titre\">Fiche pharmacie</span> <span class=\"gpt-word__format\">\n{{exportFiche ? \'Génération en cours…\' : \'Document Word · .docx\'}}</span></span><md-progress-circular \nng-if=\"exportFiche\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><md-icon ng-if=\"!exportFiche\" \nmd-font-icon=\"icon-download\" class=\"s16 gpt-word__fleche\"></md-icon></button></div></div></div><div \nclass=\"content gpt-content\"><div class=\"gpt-loading\" ng-if=\"chargement\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><span>Chargement de la fiche…</span></div><div class=\"gpt-erreur\" \nng-if=\"!chargement && erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div \nclass=\"gpt-erreur__titre\">{{erreur.message}}</div><md-button class=\"gpt-erreur__retry md-raised md-accent\" \nng-click=\"retourListe()\">Retour à la liste</md-button></div><div ng-if=\"!chargement && !erreur && fiche\"><div \nclass=\"gpt-tabs\"><button type=\"button\" class=\"gpt-tab\" ng-class=\"{\'gpt-tab--actif\': onglet === \'pharmacie\'}\" \nng-click=\"changerOnglet(\'pharmacie\')\">Pharmacie</button> <button type=\"button\" class=\"gpt-tab\" \nng-class=\"{\'gpt-tab--actif\': onglet === \'contact\'}\" ng-click=\"changerOnglet(\'contact\')\">Contact</button> <button \ntype=\"button\" class=\"gpt-tab\" ng-class=\"{\'gpt-tab--actif\': onglet === \'audits\'}\" ng-click=\"changerOnglet(\'audits\')\">\nAudits ({{fiche.nbAudits}})</button></div><div ng-if=\"onglet === \'pharmacie\'\"><div class=\"gpt-fiche-grille\" \nng-class=\"{\'gpt-fiche-grille--edition\': edition}\"><div class=\"gpt-rail\"><div class=\"gpt-bloc\" ng-if=\"!edition\"><div \nclass=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-sitemap\" class=\"s16\"></md-icon></span>Identité &amp; groupement </span><button type=\"button\" \nclass=\"gpt-bloc__modifier\" ng-if=\"estResponsable()\" ng-click=\"ouvrirEdition()\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s14\"></md-icon><span>Modifier</span></button></div><div class=\"gpt-ident__nom\">{{fiche.nom || \'—\'}}</div><div \nclass=\"gpt-ident__cles\"><span class=\"gpt-cle gpt-cle--cip\">CIP {{fiche.codeCip || \'—\'}}</span> <span \nclass=\"gpt-cle gpt-cle--ref\">Réf PHSQ {{fiche.identifiant}}</span></div><div class=\"gpt-ident__section\"><div \nclass=\"gpt-ident__etiquette\">Rattachement groupement</div><div class=\"gpt-fil\" \nng-if=\"fiche.cohorte || fiche.groupement || fiche.sousGroupe\"><span class=\"gpt-cle gpt-cle--cohorte\" \nng-if=\"fiche.cohorte\">{{fiche.cohorte}}</span> <span class=\"gpt-fil__sep\" ng-if=\"fiche.cohorte && fiche.groupement\">›\n</span> <span class=\"gpt-fil__fort\" ng-if=\"fiche.groupement\">{{fiche.groupement}}</span> <span class=\"gpt-fil__sep\" \nng-if=\"(fiche.cohorte || fiche.groupement)\">›</span> <span class=\"gpt-fil__doux\" ng-if=\"fiche.sousGroupe\">\n{{fiche.sousGroupe}}</span><span class=\"gpt-fil__absent\" ng-if=\"!fiche.sousGroupe\">Sous-groupe non renseigné</span>\n</div><div class=\"gpt-fil__absent\" ng-if=\"!fiche.cohorte && !fiche.groupement && !fiche.sousGroupe\">\nGroupement non renseigné</div><div class=\"gpt-ident__adherent\" ng-if=\"fiche.numeroAdherent\">Réf groupement <strong>\n{{fiche.numeroAdherent}}</strong></div></div><div class=\"gpt-ident__section\"><div class=\"gpt-ident__etiquette\"><md-icon\n md-font-icon=\"icon-map-marker\" class=\"s14\"></md-icon>Adresse</div><div class=\"gpt-adresse\" \nng-if=\"fiche.adresse.rue || fiche.adresse.adresseSuite\n                     || fiche.adresse.codePostal || fiche.adresse.ville\">\n<div ng-if=\"fiche.adresse.rue || fiche.adresse.adresseSuite\">\n{{fiche.adresse.rue}}{{fiche.adresse.rue && fiche.adresse.adresseSuite ? \', \' : \'\'}}{{fiche.adresse.adresseSuite}}\n</div><div class=\"gpt-adresse__ville\">{{fiche.adresse.codePostal}} {{fiche.adresse.ville}}</div></div><div \nclass=\"gpt-fil__absent\" \nng-if=\"!fiche.adresse.rue && !fiche.adresse.adresseSuite\n                     && !fiche.adresse.codePostal && !fiche.adresse.ville\">\nNon renseignée</div></div><div class=\"gpt-ident__section gpt-ident__section--statut\"><span \nclass=\"gpt-ident__etiquette\">Statut</span> <span class=\"gpt-voyant\" \nng-class=\"fiche.statut === \'Actif\' ? \'gpt-voyant--ok\' : \'gpt-voyant--neutre\'\"><span class=\"gpt-voyant__point\"></span>\n{{fiche.statut || \'Non renseigné\'}}</span></div></div><div class=\"gpt-bloc\" ng-if=\"edition\"><div \nclass=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></span>Modifier les coordonnées</span></div><div class=\"gpt-edition\">\n<div class=\"gpt-edition__grille\"><div class=\"gpt-saisie\"><label for=\"edition-cip\">Code CIP <em>*</em></label><input \nid=\"edition-cip\" type=\"text\" ng-model=\"edition.codeCip\" maxlength=\"20\" \nng-class=\"{\'gpt-saisie__champ--vide\': !codeCipValide()}\"></div><div class=\"gpt-saisie gpt-saisie--large\"><label \nfor=\"edition-nom\">Nom de la pharmacie <em>*</em></label><input id=\"edition-nom\" type=\"text\" ng-model=\"edition.nom\" \nng-class=\"{\'gpt-saisie__champ--vide\': !edition.nom.trim()}\"></div><div class=\"gpt-saisie\"><label \nfor=\"edition-sous-groupe\">Sous-groupe</label><input id=\"edition-sous-groupe\" type=\"text\" ng-model=\"edition.sousGroupe\" \nplaceholder=\"Aucun\"></div><div class=\"gpt-saisie\"><label for=\"edition-adherent\">N° d\'adhérent</label><input \nid=\"edition-adherent\" type=\"text\" ng-model=\"edition.numeroAdherent\" placeholder=\"Aucun\"></div><div \nclass=\"gpt-saisie gpt-saisie--large\"><label for=\"edition-rue\">Adresse <em>*</em></label><input id=\"edition-rue\" \ntype=\"text\" ng-model=\"edition.rue\" ng-class=\"{\'gpt-saisie__champ--vide\': !edition.rue.trim()}\"></div><div \nclass=\"gpt-saisie gpt-saisie--large\"><label for=\"edition-complement\">Complément d\'adresse</label><input \nid=\"edition-complement\" type=\"text\" ng-model=\"edition.adresseSuite\" placeholder=\"Bâtiment, étage, lieu-dit…\"></div><div\n class=\"gpt-saisie\"><label for=\"edition-cp\">Code postal <em>*</em></label><input id=\"edition-cp\" type=\"text\" \nng-model=\"edition.codePostal\" maxlength=\"10\" ng-class=\"{\'gpt-saisie__champ--vide\': !edition.codePostal.trim()}\"></div>\n<div class=\"gpt-saisie gpt-saisie--triple\"><label for=\"edition-ville\">Ville <em>*</em></label><input \nid=\"edition-ville\" type=\"text\" ng-model=\"edition.ville\" ng-class=\"{\'gpt-saisie__champ--vide\': !edition.ville.trim()}\">\n</div></div><div class=\"gpt-edition__pied\"><div class=\"gpt-edition__note\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nLa modification part dans le CRM dès l\'enregistrement, avec votre nom et la date. <em ng-if=\"!coordonneesValides()\">\nLes champs suivis d\'une étoile sont obligatoires.</em> <em ng-if=\"edition.codeCip.trim() && !codeCipValide()\">\nLe code CIP ne doit contenir que des chiffres.</em></span></div><div class=\"gpt-edition__actions\"><button \ntype=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"enregistrement\" ng-click=\"annulerEdition()\">Annuler\n</button> <button type=\"button\" class=\"gpt-btn gpt-btn--principal\" \nng-disabled=\"enregistrement || !coordonneesValides()\" ng-click=\"enregistrerCoordonnees()\"><md-progress-circular \nng-if=\"enregistrement\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><span>\n{{enregistrement ? \'Enregistrement…\' : \'Enregistrer\'}}</span></button></div></div></div></div></div><div \nclass=\"gpt-colonne\"><div class=\"gpt-bloc gpt-bloc--sortie\" ng-if=\"etatSortie()\"><div class=\"gpt-bloc__titre\"><span \nclass=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16\">\n</md-icon></span>Sortie du groupement </span><span class=\"gpt-etat-sortie\" ng-if=\"etatSortie() !== \'indisponible\'\" \nng-class=\"{\'gpt-etat-sortie--refusee\': etatSortie() === \'refusee\',\n                                  \'gpt-etat-sortie--encours\': etatSortie() !== \'refusee\' && sortie.etat === \'EN_COURS\'}\">\n{{libelleEtatSortie()}}</span></div><div class=\"gpt-sortie__pied\" ng-if=\"etatSortie() === \'indisponible\'\"><span \nclass=\"gpt-sortie__phrase\">\nImpossible de savoir pour l\'instant si une déclaration de sortie est en cours pour cette officine. {{sortieErreur.message}}\n</span> <button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-click=\"rechargerSortie()\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"s16\"></md-icon><span>Réessayer</span></button></div><div \nclass=\"gpt-sortie__phrase gpt-sortie__phrase--seule\" ng-if=\"etatSortie() === \'tiers\'\">\nUne déclaration de sortie est en cours de traitement pour cette officine. Pour en connaître le détail, contactez PHSQ.\n</div><div ng-if=\"etatSortie() === \'groupement\'\"><div class=\"gpt-sortie__ligne\">Déclarée le <strong>\n{{dateLongue(sortie.deposeeLe)}}</strong> par {{sortie.declarantGroupement || fiche.groupement}}<span \nng-if=\"sortie.deposeePar\"> · {{sortie.deposeePar}}</span></div><div class=\"gpt-sortie__ligne\" \nng-if=\"sortie.priseEnChargeLe\">Prise en charge par PHSQ le <strong>{{dateLongue(sortie.priseEnChargeLe)}}</strong>\n</div><div class=\"gpt-sortie__duo\"><div><div class=\"gpt-ident__etiquette\">Motif</div><div class=\"gpt-sortie__valeur\" \nng-if=\"sortie.motif\">{{sortie.motif}}</div><div class=\"gpt-fil__absent\" ng-if=\"!sortie.motif\">Non précisé</div></div>\n<div><div class=\"gpt-ident__etiquette\">Précisions</div><div class=\"gpt-sortie__valeur\" ng-if=\"sortie.precisions\">\n{{sortie.precisions}}</div><div class=\"gpt-fil__absent\" ng-if=\"!sortie.precisions\">Aucune précision</div></div></div>\n<div class=\"gpt-sortie__filet\"></div><div class=\"gpt-sortie__pied\"><span class=\"gpt-sortie__phrase\" \nng-if=\"sortie.retraitPossible && estResponsable()\">\nPersonne chez PHSQ n\'a encore pris en charge cette déclaration&#8239;: vous pouvez la retirer. L\'officine n\'en a pas été avisée par LQO.\n</span> <span class=\"gpt-sortie__phrase\" ng-if=\"sortie.retraitPossible && !estResponsable()\">\nPersonne chez PHSQ n\'a encore pris en charge cette déclaration&#8239;: un responsable du groupement peut la retirer. L\'officine n\'en a pas été avisée par LQO.\n</span> <span class=\"gpt-sortie__phrase\" ng-if=\"!sortie.retraitPossible\">\nCette déclaration est prise en charge par PHSQ&#8239;: elle ne peut plus être retirée depuis LQO.</span> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--retrait\" ng-if=\"sortie.retraitPossible && estResponsable()\" \nng-click=\"retirerDeclarationSortie($event)\" ng-disabled=\"retraitSortie\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon><span>Retirer la déclaration</span></button></div></div><div ng-if=\"etatSortie() === \'refusee\'\"><div \nclass=\"gpt-sortie__refus\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span><strong>\nPHSQ n\'a pas donné suite à votre déclaration</strong><span ng-if=\"sortie.refus.le\">, le {{dateLongue(sortie.refus.le)}}\n</span>. <span class=\"gpt-sortie__refus-ligne\" ng-if=\"sortie.refus.motif\">Motif&#8239;: <strong>{{sortie.refus.motif}}\n</strong>.</span> <span class=\"gpt-sortie__refus-ligne\" ng-if=\"sortie.refus.message\">\n«&#8239;{{sortie.refus.message}}&#8239;»</span></span></div><div class=\"gpt-sortie__filet\"></div><div \nclass=\"gpt-sortie__ligne\">Déclarée le <strong>{{dateLongue(sortie.deposeeLe)}}</strong>\n par {{sortie.declarantGroupement || fiche.groupement}}<span ng-if=\"sortie.deposeePar\"> · {{sortie.deposeePar}}</span>\n</div><div class=\"gpt-sortie__duo\"><div><div class=\"gpt-ident__etiquette\">Motif déclaré</div><div \nclass=\"gpt-sortie__valeur\" ng-if=\"sortie.motif\">{{sortie.motif}}</div><div class=\"gpt-fil__absent\" \nng-if=\"!sortie.motif\">Non précisé</div></div><div><div class=\"gpt-ident__etiquette\">Rattachement</div><div \nclass=\"gpt-sortie__valeur\"><strong>{{fiche.groupement}}</strong>, inchangé</div></div></div><div \nclass=\"gpt-sortie__filet\"></div><div class=\"gpt-sortie__pied\"><span class=\"gpt-sortie__phrase\" \nng-if=\"estResponsable()\">\nVous pouvez déposer une nouvelle déclaration pour cette officine. L\'officine n\'a pas été avisée du refus par LQO.\n</span> <span class=\"gpt-sortie__phrase\" ng-if=\"!estResponsable()\">\nUn responsable du groupement peut déposer une nouvelle déclaration pour cette officine. L\'officine n\'a pas été avisée du refus par LQO.\n</span> <button type=\"button\" class=\"gpt-btn gpt-btn--principal\" ng-if=\"estResponsable()\" \nng-click=\"ouvrirDeclarationSortie($event)\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16\"></md-icon><span>\nDéclarer à nouveau la sortie</span></button></div></div><div ng-if=\"etatSortie() === \'officine\'\"><div \nclass=\"gpt-sortie__ligne\">Déclarée le <strong>{{dateLongue(sortie.deposeeLe)}}</strong> par <strong>\nl\'officine elle-même</strong></div><div class=\"gpt-sortie__ligne\" ng-if=\"sortie.priseEnChargeLe\">\nPrise en charge par PHSQ le <strong>{{dateLongue(sortie.priseEnChargeLe)}}</strong></div><div class=\"gpt-sortie__duo\">\n<div><div class=\"gpt-ident__etiquette\">Motif</div><div class=\"gpt-sortie__valeur\" ng-if=\"sortie.motif\">{{sortie.motif}}\n</div><div class=\"gpt-fil__absent\" ng-if=\"!sortie.motif\">Non précisé</div></div><div><div class=\"gpt-ident__etiquette\">\nDestination annoncée</div><div class=\"gpt-sortie__valeur\" ng-if=\"sortie.destination\">{{sortie.destination}}</div><div \nclass=\"gpt-sortie__valeur\" ng-if=\"!sortie.destination && sortie.destinationInconnue\">Je ne sais pas encore</div><div \nclass=\"gpt-fil__absent\" ng-if=\"!sortie.destination && !sortie.destinationInconnue\">Non précisée</div></div></div><div \nclass=\"gpt-sortie__filet\"></div><div class=\"gpt-note gpt-note--sortie\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nUne seule déclaration circule par officine&#8239;: PHSQ n\'instruit pas deux fois le même départ. Vous ne pouvez pas retirer celle-ci, elle n\'est pas de vous. Pour la contester, adressez-vous à PHSQ.\n</span></div></div></div><div class=\"gpt-bloc gpt-bloc--sortie\" ng-if=\"etatSortieQualite()\"><div \nclass=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-ribbon\" class=\"s16\"></md-icon></span>Sortie de la démarche qualité </span><span \nclass=\"gpt-etat-sortie\" ng-if=\"etatSortieQualite() !== \'indisponible\'\" \nng-class=\"{\'gpt-etat-sortie--refusee\': etatSortieQualite() === \'refusee\',\n                                  \'gpt-etat-sortie--encours\': etatSortieQualite() !== \'refusee\' && sortieQualite.etat === \'EN_COURS\'}\">\n{{libelleEtatSortieQualite()}}</span></div><div class=\"gpt-sortie__pied\" \nng-if=\"etatSortieQualite() === \'indisponible\'\"><span class=\"gpt-sortie__phrase\">\nImpossible de savoir pour l\'instant si une demande de sortie de la démarche qualité est en cours pour cette officine. {{sortieQualiteErreur.message}}\n</span> <button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-click=\"rechargerSortieQualite()\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"s16\"></md-icon><span>Réessayer</span></button></div><div \nclass=\"gpt-sortie__phrase gpt-sortie__phrase--seule\" ng-if=\"etatSortieQualite() === \'tiers\'\">\nUne demande de sortie de la démarche qualité est en cours de traitement pour cette officine. Pour en connaître le détail, contactez PHSQ.\n</div><div ng-if=\"etatSortieQualite() === \'groupement\'\"><div class=\"gpt-sortie__ligne\">Déclarée le <strong>\n{{dateLongue(sortieQualite.deposeeLe)}}</strong> par {{sortieQualite.declarantGroupement || fiche.groupement}}<span \nng-if=\"sortieQualite.deposeePar\"> · {{sortieQualite.deposeePar}}</span></div><div class=\"gpt-sortie__ligne\" \nng-if=\"sortieQualite.priseEnChargeLe\">Prise en charge par PHSQ le <strong>{{dateLongue(sortieQualite.priseEnChargeLe)}}\n</strong></div><div class=\"gpt-sortie__duo\"><div><div class=\"gpt-ident__etiquette\">Raisons</div><ul \nclass=\"gpt-sortie__liste\" ng-if=\"sortieQualite.raisons.length\"><li \nng-repeat=\"raison in sortieQualite.raisons track by $index\">{{raison}}</li></ul><div class=\"gpt-fil__absent\" \nng-if=\"!sortieQualite.raisons.length\">Non précisées</div></div><div><div class=\"gpt-ident__etiquette\">\nDate effective souhaitée</div><div class=\"gpt-sortie__valeur\" ng-if=\"sortieQualite.dateSouhaitee\">\n{{dateIso(sortieQualite.dateSouhaitee)}}</div><div class=\"gpt-fil__absent\" ng-if=\"!sortieQualite.dateSouhaitee\">\nNon précisée</div></div></div><div class=\"gpt-sortie__duo\" ng-if=\"sortieQualite.commentaires\"><div><div \nclass=\"gpt-ident__etiquette\">Commentaires</div><div class=\"gpt-sortie__valeur\">{{sortieQualite.commentaires}}</div>\n</div></div><div class=\"gpt-sortie__filet\"></div><div class=\"gpt-sortie__pied\"><span class=\"gpt-sortie__phrase\" \nng-if=\"sortieQualite.retraitPossible && estResponsable()\">\nPersonne chez PHSQ n\'a encore pris en charge cette demande&#8239;: vous pouvez la retirer. L\'officine n\'en a pas été avisée par LQO.\n</span> <span class=\"gpt-sortie__phrase\" ng-if=\"sortieQualite.retraitPossible && !estResponsable()\">\nPersonne chez PHSQ n\'a encore pris en charge cette demande&#8239;: un responsable du groupement peut la retirer. L\'officine n\'en a pas été avisée par LQO.\n</span> <span class=\"gpt-sortie__phrase\" ng-if=\"!sortieQualite.retraitPossible\">\nCette demande est prise en charge par PHSQ&#8239;: elle ne peut plus être retirée depuis LQO.</span> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--retrait\" ng-if=\"sortieQualite.retraitPossible && estResponsable()\" \nng-click=\"retirerDemandeSortieQualite($event)\" ng-disabled=\"retraitSortieQualite\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon><span>Retirer la demande</span></button></div></div><div \nng-if=\"etatSortieQualite() === \'refusee\'\"><div class=\"gpt-sortie__refus\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"s16\"></md-icon><span><strong>PHSQ n\'a pas donné suite à votre demande</strong><span \nng-if=\"sortieQualite.refus.le\">, le {{dateLongue(sortieQualite.refus.le)}}</span>. <span \nclass=\"gpt-sortie__refus-ligne\" ng-if=\"sortieQualite.refus.motif\">Motif&#8239;: <strong>{{sortieQualite.refus.motif}}\n</strong>.</span> <span class=\"gpt-sortie__refus-ligne\" ng-if=\"sortieQualite.refus.message\">\n«&#8239;{{sortieQualite.refus.message}}&#8239;»</span></span></div><div class=\"gpt-sortie__filet\"></div><div \nclass=\"gpt-sortie__ligne\">Déclarée le <strong>{{dateLongue(sortieQualite.deposeeLe)}}</strong>\n par {{sortieQualite.declarantGroupement || fiche.groupement}}<span ng-if=\"sortieQualite.deposeePar\">\n · {{sortieQualite.deposeePar}}</span></div><div class=\"gpt-sortie__duo\"><div><div class=\"gpt-ident__etiquette\">\nRaisons déclarées</div><ul class=\"gpt-sortie__liste\" ng-if=\"sortieQualite.raisons.length\"><li \nng-repeat=\"raison in sortieQualite.raisons track by $index\">{{raison}}</li></ul><div class=\"gpt-fil__absent\" \nng-if=\"!sortieQualite.raisons.length\">Non précisées</div></div><div><div class=\"gpt-ident__etiquette\">Démarche qualité\n</div><div class=\"gpt-sortie__valeur\">L\'officine y reste</div></div></div><div class=\"gpt-sortie__filet\"></div><div \nclass=\"gpt-sortie__pied\"><span class=\"gpt-sortie__phrase\" ng-if=\"estResponsable()\">\nVous pouvez déposer une nouvelle demande pour cette officine. L\'officine n\'a pas été avisée du refus par LQO.</span> \n<span class=\"gpt-sortie__phrase\" ng-if=\"!estResponsable()\">\nUn responsable du groupement peut déposer une nouvelle demande pour cette officine. L\'officine n\'a pas été avisée du refus par LQO.\n</span> <button type=\"button\" class=\"gpt-btn gpt-btn--principal\" ng-if=\"estResponsable()\" \nng-click=\"ouvrirDeclarationSortieQualite($event)\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16\"></md-icon><span>\nDéclarer à nouveau la sortie</span></button></div></div><div ng-if=\"etatSortieQualite() === \'officine\'\"><div \nclass=\"gpt-sortie__ligne\">Déposée le <strong>{{dateLongue(sortieQualite.deposeeLe)}}</strong> par <strong>\nl\'officine elle-même</strong></div><div class=\"gpt-sortie__ligne\" ng-if=\"sortieQualite.priseEnChargeLe\">\nPrise en charge par PHSQ le <strong>{{dateLongue(sortieQualite.priseEnChargeLe)}}</strong></div><div \nclass=\"gpt-sortie__duo\"><div><div class=\"gpt-ident__etiquette\">Raisons</div><ul class=\"gpt-sortie__liste\" \nng-if=\"sortieQualite.raisons.length\"><li ng-repeat=\"raison in sortieQualite.raisons track by $index\">{{raison}}</li>\n</ul><div class=\"gpt-fil__absent\" ng-if=\"!sortieQualite.raisons.length\">Non précisées</div></div><div><div \nclass=\"gpt-ident__etiquette\">Date effective souhaitée</div><div class=\"gpt-sortie__valeur\" \nng-if=\"sortieQualite.dateSouhaitee\">{{dateIso(sortieQualite.dateSouhaitee)}}</div><div class=\"gpt-fil__absent\" \nng-if=\"!sortieQualite.dateSouhaitee\">Non précisée</div></div></div><div class=\"gpt-sortie__filet\"></div><div \nclass=\"gpt-note gpt-note--sortie\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nUne seule demande circule par officine&#8239;: PHSQ n\'instruit pas deux fois la même sortie. Vous ne pouvez pas retirer celle-ci, elle n\'est pas de vous. Pour la contester, adressez-vous à PHSQ.\n</span></div></div></div><div class=\"gpt-bloc\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-shield-outline\" class=\"s16\"></md-icon></span>\nEngagement &amp; certification</span></div><div class=\"gpt-duo\"><div class=\"gpt-sous-bloc\"><div \nclass=\"gpt-sous-bloc__titre\">Engagement</div><div class=\"gpt-sous-bloc__verdict\" \nng-class=\"fiche.engagement.engage ? \'gpt-sous-bloc__verdict--oui\' : \'gpt-sous-bloc__verdict--non\'\">\n{{fiche.engagement.engage ? \'Engagée\' : \'Non engagée\'}}</div><div class=\"gpt-millesimes\"><div><div \nclass=\"gpt-millesime__libelle\">Premier</div><div class=\"gpt-millesime__valeur\">\n{{fiche.engagement.anneeEngagementInitial || \'—\'}}</div></div><div><div class=\"gpt-millesime__libelle\">Dernier</div>\n<div class=\"gpt-millesime__valeur\">{{fiche.engagement.anneeDernierEngagement || \'—\'}}</div></div></div><div \nclass=\"gpt-paires\"><div class=\"gpt-paire\" ng-if=\"fiche.engagement.inscriptionInitial\"><span>Inscription initiale</span>\n <span>{{(fiche.engagement.inscriptionInitial | date:\'dd/MM/yyyy\') || fiche.engagement.inscriptionInitial}}</span>\n</div><div class=\"gpt-paire\" ng-if=\"fiche.engagement.inscription\"><span>Inscription</span> <span>\n{{(fiche.engagement.inscription | date:\'dd/MM/yyyy\') || fiche.engagement.inscription}}</span></div></div><div \nclass=\"gpt-sortie\" ng-if=\"fiche.engagement.anneeSortie\"><md-icon md-font-icon=\"icon-logout\" class=\"s14\"></md-icon>\nSortie qualité {{fiche.engagement.moisSortie}} {{fiche.engagement.anneeSortie}}<span \nng-if=\"fiche.engagement.causeSortie\"> · {{fiche.engagement.causeSortie}}</span></div><div class=\"gpt-paire\" \nng-if=\"!fiche.engagement.anneeSortie\"><span>Sortie qualité</span><span class=\"gpt-fil__absent\">Non renseignée</span>\n</div></div><div class=\"gpt-sous-bloc\"><div class=\"gpt-sous-bloc__titre\">Certification</div><div \nclass=\"gpt-sous-bloc__verdict\" \nng-class=\"fiche.certification.certification ? \'gpt-sous-bloc__verdict--label\' : \'gpt-sous-bloc__verdict--non\'\">\n{{fiche.certification.certification || \'Non renseignée\'}}</div><div class=\"gpt-paires\" \nng-if=\"fiche.certification.certification\"><div class=\"gpt-paire\"><span>Date ENC</span> <span>\n{{(fiche.certification.certificationDate | date:\'dd/MM/yyyy\') || \'—\'}}</span></div><div class=\"gpt-paire\"><span>\nCause ENC</span><span>{{fiche.certification.causeEnc || \'—\'}}</span></div></div></div></div></div><div \nclass=\"gpt-section\"><div class=\"gpt-section__titre\"><span>Services PHSQ</span></div><div class=\"gpt-cartouches\"><div \nclass=\"gpt-cartouche\"><div class=\"gpt-cartouche__titre\">LQO</div><div class=\"gpt-cartouche__valeur\" \nng-class=\"{\'gpt-cartouche__valeur--vide\': !fiche.lqo.statut}\">{{fiche.lqo.statut || \'Non renseignée\'}}</div><div \nclass=\"gpt-cartouche__detail\" ng-if=\"fiche.lqo.dateLqo\">LQO {{fiche.lqo.dateLqo | date:\'dd/MM/yyyy\'}}</div><div \nclass=\"gpt-cartouche__detail gpt-cartouche__detail--alerte\" ng-if=\"fiche.lqo.dateCloture\">\nClôture {{fiche.lqo.dateCloture | date:\'dd/MM/yyyy\'}}</div><div class=\"gpt-cartouche__detail\">\nInscrite : {{fiche.lqo.inscrit ? \'Oui\' : \'Non\'}}</div></div><div class=\"gpt-cartouche\"><div \nclass=\"gpt-cartouche__titre\">ECOR</div><div class=\"gpt-cartouche__valeur\" \nng-class=\"{\'gpt-cartouche__valeur--vide\': !fiche.ecor.inscrit}\">{{fiche.ecor.inscrit ? \'Oui\' : \'Non\'}}</div><div \nclass=\"gpt-cartouche__detail\" ng-if=\"fiche.ecor.dateEcor\">{{fiche.ecor.dateEcor | date:\'dd/MM/yyyy\'}}</div><div \nclass=\"gpt-cartouche__detail\" ng-if=\"fiche.ecor.anneeEngagementEcor\">Eng. {{fiche.ecor.anneeEngagementEcor}}</div><div \nclass=\"gpt-cartouche__detail gpt-cartouche__detail--fort\" ng-if=\"fiche.ecor.labelisee\">Label. {{fiche.ecor.labelisee}}\n</div><div class=\"gpt-cartouche__detail gpt-cartouche__detail--alerte\" ng-if=\"fiche.ecor.dateSortie\">\nSortie {{fiche.ecor.dateSortie | date:\'dd/MM/yyyy\'}}</div></div><div class=\"gpt-cartouche\"><div \nclass=\"gpt-cartouche__titre\">PDA</div><div class=\"gpt-cartouche__valeur\" \nng-class=\"{\'gpt-cartouche__valeur--vide\': !fiche.pda}\">{{fiche.pda || \'—\'}}</div></div><div class=\"gpt-cartouche\"><div \nclass=\"gpt-cartouche__titre\">OSYS</div><div class=\"gpt-cartouche__valeur\" \nng-class=\"{\'gpt-cartouche__valeur--vide\': !fiche.osys}\">{{fiche.osys ? \'Oui\' : \'Non\'}}</div><div \nclass=\"gpt-cartouche__detail\" ng-if=\"fiche.osysDate\">{{fiche.osysDate | date:\'dd/MM/yyyy\'}}</div></div></div></div><div\n class=\"gpt-section\"><div class=\"gpt-section__titre\"><span>Activité qualité</span></div><div class=\"gpt-bloc-groupe\">\n<div class=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-chart-line\" class=\"s16\"></md-icon></span>Auto-évaluations </span>\n<span class=\"gpt-bloc__compte\">{{fiche.autoEvaluations.length}}</span></div><div class=\"gpt-evals\" \nng-if=\"fiche.autoEvaluations.length\"><div class=\"gpt-eval\" \nng-repeat=\"evaluation in fiche.autoEvaluations | orderBy:\'-annee\'\"><span class=\"gpt-eval__annee\">{{evaluation.annee}}\n</span><div class=\"gpt-eval__mesure\"><div class=\"gpt-jauge\"><div \nclass=\"gpt-jauge__part gpt-jauge__part--{{niveauScore(evaluation.score)}}\" \nng-style=\"{width: largeurScore(evaluation.score) + \'%\'}\"></div></div><span \nclass=\"gpt-eval__score gpt-eval__score--{{niveauScore(evaluation.score)}}\">\n{{niveauScore(evaluation.score) === \'absent\' ? \'—\' : (evaluation.score | number:2)}}</span></div></div></div><div \nclass=\"gpt-vide\" ng-if=\"!fiche.autoEvaluations.length\">Aucune auto-évaluation.</div></div><div \nclass=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-school\" class=\"s16\"></md-icon></span>Formations </span><span \nclass=\"gpt-bloc__compte\">{{fiche.formations.length}}</span></div><table class=\"gpt-table\" \nng-if=\"fiche.formations.length\"><thead><tr><th>Ville</th><th>Date</th><th>Participants</th></tr></thead><tbody><tr \nng-repeat=\"formation in fiche.formations\"><td>{{formation.ville || \'—\'}}</td><td>\n{{(formation.date | date:\'dd/MM/yyyy\') || \'—\'}}</td><td>{{formation.participants.join(\', \') || \'—\'}}</td></tr></tbody>\n</table><div class=\"gpt-vide\" ng-if=\"!fiche.formations.length\">Aucune formation.</div></div><div \nclass=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-calendar-check\" class=\"s16\"></md-icon></span>Journées qualité \n</span><span class=\"gpt-bloc__compte\">{{fiche.journeesQualite.length}}</span></div><div class=\"gpt-jetons\" \nng-if=\"fiche.journeesQualite.length\"><span class=\"gpt-jeton\" ng-repeat=\"journee in fiche.journeesQualite\">\n{{journee.annee}}</span></div><div class=\"gpt-vide\" ng-if=\"!fiche.journeesQualite.length\">Aucune journée qualité.</div>\n</div><div class=\"gpt-bloc gpt-bloc--demi\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon></span>Historique des groupements \n</span><span class=\"gpt-bloc__compte\">{{fiche.historiqueGroupements.length}}</span></div><table class=\"gpt-table\" \nng-if=\"fiche.historiqueGroupements.length\"><thead><tr><th>Année</th><th>Groupement</th></tr></thead><tbody><tr \nng-repeat=\"historique in fiche.historiqueGroupements\"><td>{{historique.annee}}</td><td>{{historique.groupement || \'—\'}}\n</td></tr></tbody></table><div class=\"gpt-vide\" ng-if=\"!fiche.historiqueGroupements.length\">Aucun historique.</div>\n</div></div></div><div class=\"gpt-section\"><div class=\"gpt-section__titre\"><span>Échanges avec PHSQ</span></div><div \nclass=\"gpt-bloc\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s16\"></md-icon></span>Documents </span><span class=\"gpt-bloc__compte\">\n{{fiche.documents.length}}</span></div><div class=\"gpt-depot\" ng-if=\"estResponsable()\"><input type=\"text\" \nplaceholder=\"Titre du document\" ng-model=\"depot.titre\" class=\"gpt-depot__titre\"><label class=\"gpt-depot__fichier\">\n<md-icon md-font-icon=\"icon-paperclip\" class=\"s18\"></md-icon><span>\n{{depot.fichier ? depot.fichier.name : \'Choisir un fichier…\'}}</span> <input type=\"file\" \nonchange=\"angular.element(this).scope().choisirFichier(this)\"></label><span class=\"gpt-depot__aide\">\nTous formats, 25 Mo maximum</span> <button type=\"button\" class=\"gpt-btn gpt-btn--principal\" \nng-disabled=\"!depot.fichier || enregistrement\" ng-click=\"deposerDocument()\">Déposer</button></div><table \nclass=\"gpt-table\" ng-if=\"fiche.documents.length\"><thead><tr><th>Nom</th><th>Date</th><th>Déposant</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"doc in fiche.documents\"><td>{{doc.titre || doc.nom}}</td><td>\n{{doc.date | date:\'dd/MM/yyyy\'}}</td><td>{{doc.deposantNom || \'—\'}}</td><td class=\"gpt-table__actions\"><button \ntype=\"button\" class=\"gpt-action\" ng-if=\"doc.telechargeable\" ng-click=\"telechargerDocument(doc)\" title=\"Télécharger\" \naria-label=\"Télécharger\"><md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon></button> <button type=\"button\" \nclass=\"gpt-action gpt-action--danger\" ng-if=\"estResponsable() && doc.supprimable\" \nng-click=\"supprimerDocument(doc, $event)\" title=\"Supprimer\" aria-label=\"Supprimer\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s16\"></md-icon></button></td></tr></tbody></table><div class=\"gpt-vide\" ng-if=\"!fiche.documents.length\">\nAucun document.</div></div><div class=\"gpt-bloc\"><div class=\"gpt-bloc__titre\"><span class=\"gpt-bloc__intitule\"><span \nclass=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-comment-text\" class=\"s16\"></md-icon></span>Commentaires </span>\n<span class=\"gpt-bloc__compte\">{{fiche.commentaires.length}}</span></div><div class=\"gpt-commentaire-saisie\"><textarea \nrows=\"2\" placeholder=\"Ajouter un commentaire…\" ng-model=\"saisieCommentaire.contenu\"></textarea><button type=\"button\" \nclass=\"gpt-btn gpt-btn--principal\" ng-disabled=\"!saisieCommentaire.contenu.trim() || enregistrement\" \nng-click=\"ajouterCommentaire()\">Ajouter</button></div><div class=\"gpt-journal\"><div class=\"gpt-journal__ligne\" \nng-repeat=\"commentaire in fiche.commentaires\"><div class=\"gpt-journal__entete\"><span class=\"gpt-journal__auteur\">\n{{commentaire.auteurNom || \"Reprise de l\'ancien CRM\"}}</span> <span class=\"gpt-journal__date\">\n{{commentaire.date | date:\'dd/MM/yyyy HH:mm\'}}</span><button type=\"button\" \nclass=\"gpt-action gpt-action--danger gpt-journal__supprimer\" ng-if=\"peutSupprimerCommentaire(commentaire)\" \nng-click=\"supprimerCommentaire(commentaire, $event)\" title=\"Supprimer\" aria-label=\"Supprimer\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></button></div><div class=\"gpt-journal__contenu\">\n{{commentaire.contenu}}</div></div><div class=\"gpt-vide\" ng-if=\"!fiche.commentaires.length\">Aucun commentaire.</div>\n</div></div></div></div></div></div><div ng-if=\"onglet === \'contact\'\"><div class=\"gpt-bloc\"><div \nclass=\"gpt-bloc__titre gpt-bloc__titre--action\"><span class=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"s16\"></md-icon></span>Contacts associés </span><span \nclass=\"gpt-bloc__compte\">{{contacts.length}}</span> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--principal gpt-bloc__action\" ng-if=\"estResponsable() && !contactEdition\" \nng-click=\"ouvrirCreationContact()\"><md-icon md-font-icon=\"icon-plus\" class=\"s16\"></md-icon><span>Ajouter un contact\n</span></button></div><div class=\"gpt-note\" ng-if=\"!estResponsable()\"><md-icon md-font-icon=\"icon-information\" \nclass=\"s16\"></md-icon><span>\nLes contacts se modifient depuis un compte responsable du groupement. Pour signaler un changement, déposez un commentaire sur la fiche.\n</span></div><div class=\"gpt-edition gpt-edition--encart\" ng-if=\"contactEdition\"><div class=\"gpt-edition__grille\"><div \nclass=\"gpt-saisie gpt-saisie--large\"><label for=\"contact-mail\">E-mail <em ng-if=\"mailObligatoire()\">*</em></label>\n<input id=\"contact-mail\" type=\"text\" inputmode=\"email\" autocomplete=\"off\" spellcheck=\"false\" \nng-model=\"contactEdition.mail\" ng-class=\"{\'gpt-saisie__champ--vide\': mailEnDefaut()}\"></div><div class=\"gpt-saisie\">\n<label for=\"contact-prenom\">Prénom</label><input id=\"contact-prenom\" type=\"text\" ng-model=\"contactEdition.prenom\">\n</div><div class=\"gpt-saisie\"><label for=\"contact-nom\">Nom</label><input id=\"contact-nom\" type=\"text\" \nng-model=\"contactEdition.nom\"></div><div class=\"gpt-saisie\"><label for=\"contact-telephone\">Téléphone</label><input \nid=\"contact-telephone\" type=\"text\" ng-model=\"contactEdition.telephone\"></div><div class=\"gpt-saisie\"><label \nfor=\"contact-mobile\">Mobile</label><input id=\"contact-mobile\" type=\"text\" ng-model=\"contactEdition.mobile\"></div><div \nclass=\"gpt-saisie gpt-saisie--large\"><label for=\"contact-mail2\">E-mail auto-évaluation</label><input \nid=\"contact-mail2\" type=\"email\" ng-model=\"contactEdition.mailSecondaire\" \nplaceholder=\"Si différent de l\'e-mail principal\"></div></div><div class=\"gpt-edition__pied\"><div \nclass=\"gpt-edition__note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nLa modification part dans le CRM dès l\'enregistrement, avec votre nom et la date. <em \nng-if=\"mailRemplace() && contactValide()\">L\'adresse {{contactEdition.mailInitial}} sera remplacée.</em> <em \nng-if=\"!contactEdition.id && !mailObligatoire() && !contactEdition.mail && contactValide()\">\nE-mail facultatif : le contact principal en a déjà un.</em> <em ng-if=\"motifSaisie()\">{{motifSaisie()}}</em></span>\n</div><div class=\"gpt-edition__actions\"><button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" \nng-disabled=\"enregistrement\" ng-click=\"annulerEditionContact()\">Annuler</button> <button type=\"button\" \nclass=\"gpt-btn gpt-btn--principal\" ng-disabled=\"enregistrement || !contactValide()\" ng-click=\"enregistrerContact()\">\n<md-progress-circular ng-if=\"enregistrement\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><span>\n{{enregistrement ? \'Enregistrement…\' : \'Enregistrer\'}}</span></button></div></div></div><div class=\"gpt-contacts\" \nng-if=\"contacts.length\"><div class=\"gpt-contact\" ng-repeat=\"contact in contacts\" \nng-class=\"{\'gpt-contact--principal\': contact.principal}\"><div class=\"gpt-contact__identite\"><div \nclass=\"gpt-contact__ligne\"><span class=\"gpt-contact__nom\">{{contact.prenom}} {{contact.nom}}</span> <span \nclass=\"gpt-contact__nom\" ng-if=\"!contact.prenom && !contact.nom\">{{contact.mail || \'—\'}}</span> <span \nclass=\"gpt-principal\" ng-if=\"contact.principal\"><md-icon md-font-icon=\"icon-star\" class=\"s12\"></md-icon>Principal\n</span></div><div class=\"gpt-contact__mail\" ng-if=\"contact.prenom || contact.nom\">{{contact.mail || \'—\'}}</div></div>\n<div class=\"gpt-contact__colonne\"><div class=\"gpt-contact__etiquette\">Téléphone</div><div class=\"gpt-contact__valeur\" \nng-class=\"{\'gpt-contact__valeur--vide\': !contact.telephone}\">{{contact.telephone || \'Non renseigné\'}}</div></div><div \nclass=\"gpt-contact__colonne\"><div class=\"gpt-contact__etiquette\">Mobile</div><div class=\"gpt-contact__valeur\" \nng-class=\"{\'gpt-contact__valeur--vide\': !contact.mobile}\">{{contact.mobile || \'Non renseigné\'}}</div></div><div \nclass=\"gpt-contact__colonne gpt-contact__colonne--large\"><div class=\"gpt-contact__etiquette\">E-mail auto-évaluation\n</div><div class=\"gpt-contact__valeur\" ng-class=\"{\'gpt-contact__valeur--vide\': !contact.mailSecondaire}\">\n{{contact.mailSecondaire || \'Non renseigné\'}}</div></div><div class=\"gpt-contact__colonne gpt-contact__colonne--large\">\n<div class=\"gpt-contact__etiquette\">Rôles PHSQ</div><div class=\"gpt-roles\" ng-if=\"contact.roles.length\"><span \nclass=\"gpt-role\" ng-repeat=\"role in contact.roles\">{{role}}</span></div><div \nclass=\"gpt-contact__valeur gpt-contact__valeur--vide\" ng-if=\"!contact.roles.length\">Aucun</div></div><div \nclass=\"gpt-contact__actions\" ng-if=\"estResponsable() && !contactEdition\"><button type=\"button\" class=\"gpt-action\" \nng-if=\"!contact.principal\" ng-click=\"definirContactPrincipal(contact)\" title=\"Définir comme contact principal\" \naria-label=\"Définir comme contact principal\"><md-icon md-font-icon=\"icon-star-outline\" class=\"s16\"></md-icon></button> \n<button type=\"button\" class=\"gpt-action\" ng-click=\"ouvrirEditionContact(contact)\" title=\"Modifier\" \naria-label=\"Modifier\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></button> <button type=\"button\" \nclass=\"gpt-action gpt-action--danger\" ng-click=\"archiverContact(contact, $event)\" title=\"Archiver\" \naria-label=\"Archiver\"><md-icon md-font-icon=\"icon-archive\" class=\"s16\"></md-icon></button></div></div></div><div \nclass=\"gpt-vide\" ng-if=\"contacts && !contacts.length\">Aucun contact actif.</div></div></div><div \nng-if=\"onglet === \'audits\'\"><div class=\"gpt-bloc gpt-bloc--tableau\"><div class=\"gpt-bloc__titre\"><span \nclass=\"gpt-bloc__intitule\"><span class=\"gpt-bloc__icone\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"s16\">\n</md-icon></span>Audits de l\'officine </span><span class=\"gpt-bloc__compte\">{{audits.length}}</span></div><div \nclass=\"gpt-tableau-cadre\" ng-if=\"audits.length\"><table class=\"gpt-table gpt-table--audits\"><thead><tr><th>N°</th><th>\nType</th><th>Équipe</th><th class=\"gpt-table__groupe\">Auditeur</th><th class=\"gpt-table__groupe\">Date</th><th>Horaires\n</th><th class=\"gpt-table__groupe gpt-table__centre\">Réalisé</th><th class=\"gpt-table__centre\">Éc. majeurs</th><th \nclass=\"gpt-table__centre\">Éc. mineurs</th><th class=\"gpt-table__centre\">Écart levé</th></tr></thead><tbody><tr \nng-repeat=\"audit in audits\" class=\"gpt-table__row\" ng-click=\"ouvrirAudit(audit)\"><td class=\"gpt-cellule--numero\">\n{{audit.numero}}</td><td>{{audit.type || \'—\'}}</td><td class=\"gpt-cellule--doux\">{{audit.equipe || \'—\'}}</td><td \nclass=\"gpt-table__groupe\">{{audit.auditeur || \'—\'}}</td><td class=\"gpt-table__groupe gpt-cellule--date\">\n{{(audit.dateAudit | date:\'dd/MM/yyyy\') || \'—\'}}</td><td class=\"gpt-cellule--doux\">{{audit.horaires || \'—\'}}</td><td \nclass=\"gpt-table__groupe gpt-table__centre\"><span class=\"gpt-pastille\" \nng-class=\"audit.realise ? \'gpt-pastille--oui\' : \'gpt-pastille--non\'\">{{audit.realise ? \'Oui\' : \'Non\'}}</span></td><td \nclass=\"gpt-table__centre\"><span class=\"gpt-compte gpt-compte--majeur\" ng-if=\"audit.ecartsMajeurs\">\n{{audit.ecartsMajeurs}}</span> <span class=\"gpt-nul\" ng-if=\"!audit.ecartsMajeurs\">—</span></td><td \nclass=\"gpt-table__centre\"><span class=\"gpt-compte gpt-compte--mineur\" ng-if=\"audit.ecartsMineurs\">\n{{audit.ecartsMineurs}}</span> <span class=\"gpt-nul\" ng-if=\"!audit.ecartsMineurs\">—</span></td><td \nclass=\"gpt-table__centre\"><span class=\"gpt-pastille gpt-pastille--{{niveauEcartLeve(audit.ecartLeve)}}\" \nng-if=\"audit.ecartLeve\">{{audit.ecartLeve}}</span> <span class=\"gpt-nul\" ng-if=\"!audit.ecartLeve\">—</span></td></tr>\n</tbody></table></div><div class=\"gpt-vide\" ng-if=\"audits && !audits.length\">Aucun audit pour cette officine.</div>\n</div></div></div></div></div>");
$templateCache.put("app/main/front/groupement/pharmacies/pharmacies.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page gpt-page gpt-page--liste\"><div \nclass=\"header md-accent-bg gpt-header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg gpt-header__titre-bloc\"><div class=\"gpt-header__titre\">Mes pharmacies</div><div \nclass=\"gpt-header__sous-titre\">Tout le parc du réseau, officines clientes LQO ou non</div></div><div layout=\"row\" \nlayout-align=\"end center\" class=\"gpt-header__actions\"><span class=\"gpt-header__compteur\" ng-if=\"pagination.total\">\n{{pagination.total}} <span>officine{{pagination.total > 1 ? \'s\' : \'\'}}</span> </span><button type=\"button\" \nclass=\"gpt-btn gpt-btn--sur-bandeau\" ng-disabled=\"exportEnCours || !pagination.total\" ng-click=\"exporter()\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s18\"></md-icon><span>{{exportEnCours ? \'Export…\' : \'Exporter\'}}</span></button>\n</div></div><div class=\"content gpt-content\"><div class=\"gpt-carte\"><div class=\"gpt-bandeau-chiffres\" \nng-if=\"compteurs\"><button type=\"button\" class=\"gpt-chiffre\" ng-repeat=\"indicateur in indicateurs\" \nng-class=\"{\'gpt-chiffre--actif\': indicateurActif(indicateur)}\" ng-click=\"basculerIndicateur(indicateur)\" \ntitle=\"{{indicateur.aide}}\"><span class=\"gpt-chiffre__valeur\">{{compteurs[indicateur.cle]}}</span> <span \nclass=\"gpt-chiffre__libelle\">{{indicateur.libelle}}</span></button></div><div class=\"gpt-outils\"><div \nclass=\"gpt-outils__ligne\"><span class=\"gpt-outils__etiquette\">Recherche</span><div class=\"gpt-champ-recherche\"><md-icon\n md-font-icon=\"icon-magnify\" class=\"s18\"></md-icon><input type=\"text\" ng-model=\"recherche\" \nng-model-options=\"{ debounce: 350 }\" ng-change=\"appliquer()\" \nplaceholder=\"Nom, code CIP, réf PHSQ, n° d\'adhérent, ville ou code postal…\"> <button type=\"button\" \nclass=\"gpt-champ-recherche__effacer\" ng-if=\"recherche\" ng-click=\"effacerRecherche()\" aria-label=\"Effacer\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div></div><div \nclass=\"gpt-outils__ligne gpt-outils__ligne--filtres\"><span class=\"gpt-outils__etiquette\">Filtres</span><gpt-filtre-menu\n colonnes=\"filtresVisibles()\" metas=\"metasFiltres\" filtres=\"filtres\" libelles=\"libellesValeurs\" \non-change=\"appliquer()\" on-reset=\"reinitialiser()\"></gpt-filtre-menu></div></div><div class=\"gpt-etat\" \nng-if=\"chargement\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\"></md-progress-circular><span>\nChargement du parc…</span></div><div class=\"gpt-etat gpt-etat--erreur\" ng-if=\"!chargement && erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s28\"></md-icon><div class=\"gpt-etat__titre\">{{erreur.message}}</div><button \ntype=\"button\" class=\"gpt-btn gpt-btn--principal\" ng-click=\"charger()\">Réessayer</button></div><div \nclass=\"gpt-tableau-cadre\" ng-if=\"!chargement && !erreur\"><table class=\"gpt-tableau\" ng-if=\"pharmacies.length\"><thead>\n<tr><th ng-repeat=\"colonne in colonnesVisibles()\" ng-click=\"trierPar(colonne.cle)\" \nng-class=\"{\'gpt-tableau__th--trie\': tri.colonne === colonne.cle,\n                             \'gpt-table__centre\': colonne.type === \'nombre\'}\">\n<span>{{colonne.libelle}}</span><md-icon ng-if=\"tri.colonne === colonne.cle\" \nmd-font-icon=\"{{tri.sens === \'asc\' ? \'icon-menu-up\' : \'icon-menu-down\'}}\" class=\"s14\"></md-icon></th></tr></thead>\n<tbody><tr ng-repeat=\"pharmacie in pharmacies\" class=\"gpt-ligne\" ng-click=\"ouvrirFiche(pharmacie)\"><td \nng-repeat=\"colonne in colonnesVisibles()\" \nng-class=\"{\'gpt-cellule--ref\': colonne.cle === \'identifiant\',\n                             \'gpt-cellule--nom\': colonne.cle === \'nom\',\n                             \'gpt-cellule--date\': colonne.type === \'date\',\n                             \'gpt-table__centre\': colonne.type === \'nombre\'}\">\n<span ng-if=\"colonne.cle === \'engage\'\" class=\"gpt-pastille\" \nng-class=\"pharmacie.engage ? \'gpt-pastille--oui\' : \'gpt-pastille--non\'\">{{pharmacie.engage ? \'Oui\' : \'Non\'}} </span>\n<span ng-if=\"colonne.cle === \'statut\'\" class=\"gpt-statut\"><span class=\"gpt-statut__point\" \nng-class=\"{\'gpt-statut__point--actif\': pharmacie.statut === \'Actif\'}\"></span> {{pharmacie.statut || \'—\'}} </span><span \nng-if=\"colonne.type === \'date\'\">{{(pharmacie[colonne.cle] | date:\'dd/MM/yyyy\') || \'—\'}} </span><span \nng-if=\"colonne.type === \'nombre\'\">{{pharmacie[colonne.cle] === 0 ? 0 : (pharmacie[colonne.cle] || \'—\')}} </span><span \nng-if=\"colonne.cle !== \'engage\' && colonne.cle !== \'statut\' && !colonne.type\">{{pharmacie[colonne.cle] || \'—\'}}</span>\n</td></tr></tbody></table><div class=\"gpt-etat\" ng-if=\"!pharmacies.length\">\nAucune pharmacie ne correspond à ces critères.</div></div><div class=\"gpt-pied\" \nng-if=\"!chargement && !erreur && pagination.total\"><div class=\"gpt-pied__taille\"><label for=\"taille-parc\">Lignes\n</label><md-select id=\"taille-parc\" ng-model=\"pagination.taille\" ng-change=\"changerTaille()\" \nclass=\"gpt-select gpt-select--compact md-no-underline\" aria-label=\"Nombre de lignes par page\"><md-option \nng-repeat=\"taille in taillesPage\" ng-value=\"taille\">{{taille}}</md-option></md-select></div><div \nclass=\"gpt-pied__saut\"><label for=\"page-parc\">Page</label><input id=\"page-parc\" type=\"number\" class=\"gpt-pied__champ\" \nmin=\"1\" max=\"{{nbPages()}}\" ng-model=\"pagination.pageSaisie\" ng-blur=\"allerALaPage()\" \nng-keydown=\"$event.keyCode === 13 ? allerALaPage() : null\"> <span>sur {{nbPages()}}</span></div><span \nclass=\"gpt-pied__compte\">{{pagination.total}} officines</span><div class=\"gpt-pied__nav\"><button type=\"button\" \nclass=\"gpt-action\" ng-disabled=\"pagination.page <= 1\" ng-click=\"changerPage(1)\" title=\"Première page\" \naria-label=\"Première page\"><md-icon md-font-icon=\"icon-chevron-double-left\" class=\"s16\"></md-icon></button> <button \ntype=\"button\" class=\"gpt-btn gpt-btn--fantome\" ng-disabled=\"pagination.page <= 1\" \nng-click=\"changerPage(pagination.page - 1)\">Précédent</button> <button type=\"button\" class=\"gpt-btn gpt-btn--fantome\" \nng-disabled=\"pagination.page >= nbPages()\" ng-click=\"changerPage(pagination.page + 1)\">Suivant</button> <button \ntype=\"button\" class=\"gpt-action\" ng-disabled=\"pagination.page >= nbPages()\" ng-click=\"changerPage(nbPages())\" \ntitle=\"Dernière page\" aria-label=\"Dernière page\"><md-icon md-font-icon=\"icon-chevron-double-right\" class=\"s16\">\n</md-icon></button></div></div></div></div></div>");
$templateCache.put("app/main/front/home/confirmDialog/confirm_delete_comment_dialog.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\">Suppression d\'un commentaire</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Êtes-vous sûr de vouloir supprimer ce commentaire ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"_deleteComment(info,deleteComment)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_closeDialog()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/home/confirmDialog/confirm_delete_info_dialog.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\">Suppression d\'une information</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Êtes-vous sûr de vouloir supprimer cette information ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"_deleteInformation(infoToDelete)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_closeDialog()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/home/popup/add_tag.html","<md-dialog flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Créer mes tags</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div style=\"font-weight: bold\" class=\"mb-10\">\nAjoutez des tags à vos messages et vos tâches pour un filtrage simplifié.</div><md-input-container md-no-float \nng-repeat=\"tag in tagsToUpdate\" class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"75\"><input \nclass=\"iv-Input-input\" type=\"text\" placeholder=\"#monTag\" ng-keyup=\"includeTag(tag)\" name=\"name\" ng-model=\"tag.libelle\">\n<div flex=\"5\" class=\"icon-close--types\" layout-align=\"end center\"><md-icon ng-click=\"deleteTag($index)\" \nclass=\"icon-close--types\" md-font-icon=\"icon-close\"></md-icon></div></md-input-container><div class=\"mt-25\" \nng-if=\"tagsToUpdate.length < 20\"><button class=\"iv-Btn\" type=\"button\" ng-click=\"addTag()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon><div>Ajouter un tag</div></button></div><div \nng-if=\"tagsToUpdate && tagsToUpdate.length > 19\" style=\"color: #d0021b\">Vous avez atteint la limite du nombre de tags.\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn ml-10\" type=\"button\" \nng-click=\"saveTags()\">Enregistrer</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/home/popup/apercu_popup.html","<md-dialog class=\"iv-Dialog\" aria-label=\"fiche de progrès\" flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"setRead()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">{{title}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll ng-if=\"pj.type != \'REUNION\'\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"iv-Dialog__apercu__item\" ng-class=\"info.class\" ng-repeat=\"info in infos\"><div \nclass=\"iv-Dialog__apercu__item__title\">{{info.libelle}}</div><div class=\"iv-Dialog__apercu__item__text\" \nng-bind-html=\"info.value\"></div></div></div><div class=\"flex-100 mt-10\" ng-if=\"pj.type === \'MALFUNCTION\'\" \nng-repeat=\"document in pj.malfunction.documents\"><div class=\"iv-Btn\" \nng-click=\"downloadMalfunctionAttachment(document.id)\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon>\n<div>{{ document.attachmentOriginalName }}</div></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap>\n<div flex=\"100\" class=\"iv-Dialog__apercu__item mt-10\" ng-if=\"pj.type === \'MALFUNCTION\'\" \nng-repeat=\"comment in pj.malfunction.comments | orderBy: \'creation\'\"><div class=\"iv-Dialog__apercu__item__title\">\nCommentaire ajouté le {{comment.creation | date: \'dd/MM/yyyy\'}} à {{comment.creation | date: \'HH\'}}h{{comment.creation | date: \'mm\'}}\n</div><div class=\"iv-Dialog__apercu__item__text\" style=\"white-space: pre-wrap\">{{comment.text}}</div></div></div><div \nflex=\"100\" class=\"mt-5\" ng-if=\"addCommentMode\" id=\"add_comment_input\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Ajouter un commentaire<span class=\"asterix\">*</span></label>\n<textarea type=\"text\" name=\"text\" ng-model=\"comment.text\" class=\"iv-Input-textarea\" required=\"\"></textarea><div \nng-if=\"noComment\" role=\"alert\"><span style=\"color: red;font-size: 12px\">Information requise.</span></div>\n</md-input-container></div><div ng-if=\"pj.shareMode\" layout=\"row\" layout-align=\"start end\" layout-wrap><div flex \nlayout-align=\"start center\" layout=\"row\"><md-input-container \nclass=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Copier ce lien privé pour le partager <span \nng-if=\"ficheProgres.title == null\" class=\"asterix\">*</span></label><input id=\"linkShare\" ng-disabled=\"linkDisabled\" \nauto-select readonly=\"readonly\" type=\"text\" name=\"title\" ng-model=\"pj.malfunction.link\" \nclass=\"iv-Input-input ng-pristine md-input\" placeholder=\"\"></md-input-container></div><div layout-align=\"center start\" \nlayout=\"row\"><button type=\"button\" class=\"iv-Btn iv-Btn--export ml-5 mb-5\" ng-click=\"copyText()\" \nng-disabled=\"linkDisabled\"><md-icon class=\"w-15 h-15\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\nCopier</div></button></div></div><div class=\"mt-10\" ng-if=\"displayDisable\" layout=\"row\" layout-align=\"start end\" \nlayout-wrap><div class=\"iv-Input-label md-no-float md-container-ignore\" flex=\"100\">\nVous ne souhaitez plus que ce lien soit actif ?</div><div layout=\"row\" layout-align=\"center start\"><button \ntype=\"button\" class=\"iv-Btn iv-Btn--export\" ng-click=\"disableMalfunction()\" ng-disabled=\"linkDisabled\"><md-icon \nclass=\"w-15 h-15\" md-svg-src=\"assets/icons/app/V3/delete.svg\"></md-icon><div>Désactiver le lien</div></button></div>\n</div><div class=\"flex-100 mt-10\" \nng-if=\"pj.type === \'MES_EVALUATIONS\' && (pj.monEval.type === \'AUTO_EVALUATION\'||pj.monEval.type === \'RAPPORT_D_AUDIT\'||pj.monEval.type === \'SATISFACTION_CLIENT\') \">\n<div class=\"iv-Btn\" ng-click=\"downloadMesEval(pj.monEval.data.id, pj.monEval.type)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ pj.monEval.data.name }}</div></div></div>\n</md-dialog-content><md-dialog-content class=\"mh-20\" ms-scroll ng-if=\"pj.type === \'REUNION\'\"><div class=\"mt-15\"><h2 \nclass=\"iv-Tabs-inner-Title\">{{_thisReunion.title}}</h2><div>\nA eu lieu le {{_thisReunion.dateStart | date: \"EEEE dd MMMM yyyy \'à\' HH\'h\'mm\"}} • {{_thisReunion.lieu}}</div></div><div\n class=\"mt-35\"><h2 class=\"iv-Tabs-inner-Title\">Liste d\'absence</h2><div class=\"mt-10\"><div class=\"iv-Tabs-inner-CR\">\n<span>Personnes présentes : </span>{{printUsers(_thisReunion.presences)}}</div><div class=\"iv-Tabs-inner-CR\"><span>\nPersonnes absentes : </span>{{printUsers(_thisReunion.absences)}}</div></div></div><div class=\"mt-35\"><h2 \nclass=\"iv-Tabs-inner-Title\">Sujets et éléments abordés</h2><h3 class=\"iv-Tabs-item-sectionTitle\" \nng-if=\"!hasOdjRubrique\">Suivi de l\'activité de l\'officine</h3><div class=\"iv-Tabs-item-list\" ng-if=\"!hasOdjRubrique\">\n<div><div ng-if=\"!(_thisReunion.statut == \'Finaliser le compte-rendu\' || _thisReunion.archived)\" \nng-bind-html=\"_thisReunion.ordreDuJour.note\"></div><div \nng-if=\"_thisReunion.statut == \'Finaliser le compte-rendu\' || _thisReunion.archived\" \nng-bind-html=\"_thisReunion.noteCompteRendu\"></div></div></div><div \nng-repeat=\"(parentIndex, _rubrique) in _rubriques track by $index\" ng-show=\"_rubrique.elements.length > 0\"><h3 \nclass=\"iv-Tabs-item-sectionTitle\"><div>{{_rubrique.libelle}}</div></h3><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type != \'TEXT\' && _rubrique.type != \'NOTE_ODJ\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n<div class=\"iv-Tabs-item-list-item\" ng-repeat=\"_element in _rubrique.elements track by $index\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon \nng-if=\"_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DYSFONCTIONNEMENT\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon ng-if=\"_rubrique.type === \'PROGRESS_FORM\'\" \nflex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'RAPPORT_D_AUDIT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/audit.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'AUTO_EVALUATION\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'SATISFACTION_CLIENT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/client_mystere.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'FLASH_QUALITE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/flash_dark.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.libelle}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type != \'DOCUMENT_MODIFIE\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n{{_element.collaborateur ? _element.collaborateur.surname + \' \' + _element.collaborateur.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div><div class=\"iv-Tabs-item-list-item-date\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\">\n{{_element.date | date: \'dd/MM/yyyy HH:mm\'}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">{{_element.date}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"(_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\') && _element.done\">\n<md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div><div \nng-if=\"_rubrique.comment\"><md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label>\n<textarea disabled=\"disabled\" placeholder=\"\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" \nmax-rows=\"4\" md-no-resize></textarea></md-input-container></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'TEXT\'\"><div ng-repeat=\"_element in _rubrique.elements track by $index\"><div layout=\"row\" \nstyle=\"white-space: pre-wrap\" layout-align=\"start center\" ng-bind-html=\"_element.note\"></div></div></div><div \nclass=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'NOTE_ODJ\'\"><div style=\"white-space: pre-wrap\" \nng-if=\"!(_thisReunion.statut == \'Finaliser le compte-rendu\' || _thisReunion.archived)\" layout=\"row\" \nlayout-align=\"start center\" ng-bind-html=\"_thisReunion.ordreDuJour.note\"></div><div style=\"white-space: pre-wrap\" \nng-if=\"_thisReunion.statut == \'Finaliser le compte-rendu\' || _thisReunion.archived\" layout=\"row\" \nlayout-align=\"start center\" ng-bind-html=\"_thisReunion.noteCompteRendu\"></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><div ng-repeat=\"indicateur in indicateurs track by $index\">\n<div class=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"iv-Tabs-item-list-item-title\">{{indicateur.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div layout=\"row\" layout-align=\"start center\"></div></div></div><div \nng-if=\"_rubrique.comment\"><md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label>\n<textarea disabled=\"disabled\" placeholder=\"\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" \nmax-rows=\"4\" md-no-resize></textarea></md-input-container></div></div></div><div class=\"mt-20\" \nng-if=\"_actionsDecidees.length > 0\"><h2 class=\"iv-Tabs-inner-Title\">Tâches</h2><div class=\"iv-Tabs-step-subtitle\">\nActions décidées au cours de la réunion</div><div class=\"iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in _actionsDecidees track by _element.id\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nflex=\"auto\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div \nclass=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div></div></div></div></div></div></md-dialog-content><md-dialog-actions \nng-if=\"!(pj.type == \'MALFUNCTION\' && pj.malfunction.activated && pj.fromMalfunction)\"><button ng-disabled=\"submitting\" \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Fermer</button> <button ng-disabled=\"submitting\" \ntype=\"button\" class=\"nl-Btn ml-10\" ng-click=\"openProgressFormAssociated(pj.malfunction)\" \nng-if=\"pj.fromMalfunction && pj.malfunction.numProgress > 1\">Voir fiche(s) de progrès associée(s)</button> <button \nng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\" ng-if=\"pj.type === \'REUNION\' && !pj.read\">\nJ\'ai bien lu le CR</button></md-dialog-actions><md-dialog-actions \nng-if=\"pj.type == \'MALFUNCTION\' && pj.malfunction.activated && pj.fromMalfunction && !addCommentMode\"><button \nng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"showAddComment()\">\nAjouter un commentaire</button> <button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn ml-10\" \nng-click=\"openProgressForm(pj.malfunction)\" ng-if=\"pj.malfunction.numProgress == 1 && !$root.user.isMini\">\nOuvrir une fiche de progrès</button> <button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn ml-10\" \nng-click=\"openProgressFormAssociated(pj.malfunction)\" ng-if=\"pj.malfunction.numProgress > 1 && !$root.user.isMini\">\nVoir fiche(s) de progrès associée(s)</button></md-dialog-actions><md-dialog-actions \nng-if=\"pj.type == \'MALFUNCTION\' && pj.malfunction.activated && pj.fromMalfunction && addCommentMode\"><button \nclass=\"nl-Btn nl-Btn--outline mr-10\" type=\"button\" ng-click=\"cancelAddComment()\">Annuler</button> <button \nclass=\"nl-Btn\" type=\"button\" ng-click=\"addComment()\">Valider</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/delete_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"validateDelete()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Supprimer le message</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-Dialog__text\">Voulez-vous supprimer définitivement ce message ?</div></md-dialog-content>\n<md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\"><div></div>Non</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">\n<div></div>Oui</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/ecor_popup.html","<md-dialog aria-label=\"ecor\" flex=\"50\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"100\" style=\"overflow: hidden\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">ECOR</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nLe Logiciel Qualité Officinal (LQO) intègre désormais plusieurs adaptations pour aider ceux qui le souhaitent à suivre la thématique \n<b>écoresponsabilité</b> « ECOR » en plus des enjeux généraux d\'organisation et de qualité.<br><br>\nRetrouvez ainsi, signalés par le pictogramme 🌿, plusieurs aménagements pour en faciliter le suivi :<br><ul><li><b>\nDysfonctionnements :</b>\n intégration d\'un nouveau type de dysfonctionnement dédié ECOR, ainsi que des sous-thèmes associés, pour simplifier le suivi en lien avec l\'écoresponsabilité.\n</li><li><b>Tâches :</b> identification possible des tâches relevant du sujet ECOR.</li><li><b>\nPerformances - Tableau de bord :</b>\n propositions d\'indicateurs ECOR à suivre, disponibles dans « administrer mes indicateurs » <span \nstyle=\"font-style: italic\">\n(consommations d\'électricité, d\'eau... pour lesquelles des données de consommation benchmarkées sont disponibles dans le guide ECOR sur votre portail qualité)\n</span>.</li></ul>N\'hésitez pas à utiliser ces fonctionnalités dès maintenant !<br><br>\nD\'autres améliorations suivront dans les mois à venir.<br><br><u>Vous voulez aller plus loin ?</u>\n PHSQ dispose d\'outils, guides, Webconf et divers supports de formation et d\'accompagnement pouvant conduire à une labellisation ECOR si vous le souhaitez. N\'hésitez pas à vous renseigner auprès de votre Responsable Qualité Groupement.\n</div></md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\"><div></div>Fermer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/joindreDoc_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Joindre un fichier de la base documentaire</div></div>\n<md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"ph-40 mb-20\"><div layout=\"row\" layout-align=\"space-between center\" class=\"iv-SearchBar_stickyContainer\"><div \nclass=\"iv-SearchBar\"><md-input-container class=\"iv-SearchBar--input\" flex=\"100\"><label></label><input \nplaceholder=\"Rechercher...\" ng-enter=\"searchDocuments()\" type=\"text\" name=\"search\" ng-model=\"popupDoc.q\">\n</md-input-container><md-icon ng-click=\"searchDocuments()\" class=\"iv-SearchBar--icon\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\"></md-icon></div></div><div class=\"iv-ListBloc__inner mt-20\"><div \nclass=\"iv-ListBloc__item iv-ListBloc__item--SB\" ng-repeat=\"doc in popupDoc.documents\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"doc.selected\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">{{doc.name}}</div></div><div class=\"iv-ListBloc__item__subtitle\">\n{{doc.uploadDate | date: \'dd/MM/yyyy HH:mm\'}}</div></div></div></md-dialog-content><md-dialog-actions><button \nng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting\" ng-if=\"popupDoc.documents.length === 0\" ng-click=\"searchDocuments()\" type=\"button\" \nclass=\"nl-Btn ml-10\">Rechercher</button> <button ng-disabled=\"submitting\" ng-if=\"popupDoc.documents.length > 0\" \ntype=\"submit\" class=\"nl-Btn ml-10\">Joindre</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/joindreDys_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Joindre un dysfonctionnement</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos dysfonctionnements</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-click=\"apercu(dys)\" \nng-repeat=\"dys in dto.results track by dys.id\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-click=\"$event.stopPropagation();\" ng-change=\"checkSelected(dys)\" \nng-model=\"dys.selected\" class=\"iv-Checkbox\"></md-checkbox><div class=\"iv-ListBloc__item__title\">{{dys.title}}</div><div\n class=\"iv-ListBloc__item__subtitle\">\n{{dys.collaborateur.name + \' \' + dys.collaborateur.surname}} • {{dys.creation | date: \'dd/MM/yyyy\'}}</div></div></div>\n</div></div></div><div class=\"iv-ListBloc__footer\"><div></div><div class=\"iv-ListBloc__pagination\"><button \nng-if=\"pagination.page + 1 > 1\" type=\"button\" ng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Previous\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nclass=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}}/{{nbPages()}}</div><button \nng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" ng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div>\n</md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Joindre\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/joindreFDP_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Joindre une fiches de progrès</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\" style=\"border-color:#3D94FF !important\"><div class=\"iv-ListBloc__title color-dys\" \nstyle=\"border-color:#3D94FF !important\">Liste de vos fiches de progrès</div><div class=\"iv-ListBloc__inner\"><div \nclass=\"iv-ListBloc__item\" ng-click=\"apercu(fdp)\" ng-repeat=\"fdp in dto.results track by fdp.id\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\" flex><md-checkbox \nng-click=\"$event.stopPropagation()\" ng-change=\"checkSelected(fdp)\" ng-model=\"fdp.selected\" class=\"iv-Checkbox\">\n</md-checkbox><div class=\"iv-ListBloc__item__title\">{{fdp.title}}</div><div class=\"iv-ListBloc__item__subtitle\">\n{{fdp.creation | date: \'dd/MM/yyyy\'}}</div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\" \nclass=\"iv-ListBloc__item__status mr-10 color-dys\">{{fdp.activated ? \'En cours\':\'Clôturée\'}}</div></div></div></div>\n</div><div class=\"iv-ListBloc__footer\"><div></div><div class=\"iv-ListBloc__pagination\"><button \nng-if=\"pagination.page + 1 > 1\" type=\"button\" ng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Previous\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nclass=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}}/{{nbPages()}}</div><button \nng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" ng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div>\n</md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Joindre\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/joindreReunion_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Joindre un compte-rendu de réunion</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos CR de réunion</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-repeat=\"reunion in dto.results track by reunion.id\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-change=\"checkSelected(reunion)\" ng-model=\"reunion.selected\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">{{reunion.title}}</div><div class=\"iv-ListBloc__item__subtitle\">\n{{reunion.dateStart | date: \'dd/MM/yyyy\'}}</div></div></div></div></div></div><div class=\"iv-ListBloc__footer\"><div>\n</div><div class=\"iv-ListBloc__pagination\"><button ng-if=\"pagination.page + 1 > 1\" type=\"button\" \nng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" aria-label=\"Previous\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div class=\"iv-ListBloc__pagination__title\">\nPage {{pagination.page + 1}}/{{nbPages()}}</div><button ng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" \nng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div></md-dialog-content><md-dialog-actions>\n<button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> \n<button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Joindre</button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/front/home/popup/new_account.html","<md-dialog flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Création des comptes</div></div></div></md-toolbar><form \nname=\"form\" class=\"md-inline-form\" novalidate ng-submit=\"form.$valid && updatePharmacyUsers()\"><md-dialog-content \nclass=\"mh-20\" ms-scroll><div style=\"font-weight: bold\" class=\"mb-10\">\nVeuillez créer un compte équipe et/ou un compte Responsable Qualité<br>\n(adresse mail différente de celle du compte titulaire)</div><md-input-container md-no-float \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"75\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Email d\'équipe<span class=\"asterix\"> *</span></label><input \nclass=\"iv-Input-input\" type=\"email\" name=\"equipe\" ng-model=\"pharmacy.team.mail\" required><div \nng-messages=\"form.equipe.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div>\n</md-input-container><md-input-container md-no-float \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"75\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Email du Responsable Qualité (facultatif)</label><input \nclass=\"iv-Input-input\" type=\"email\" name=\"praq\" ng-model=\"pharmacy.praq.mail\"></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn ml-10\" type=\"submit\" ng-disabled=\"loading\"><span \nng-if=\"!loading\">Envoyer un mail d\'activation de compte</span><md-progress-circular md-diameter=\"15px\" ng-if=\"loading\" \nclass=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/home/popup/pin_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Épingler en tête de liste</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nVous avez déjà épinglé 2 messages sur le cahier de transmission. Veuillez désépingler l’un de ces messages pour en ajouter un nouveau en tête de liste.\n</div></md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\"><div></div>Fermer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/add/add_fiche_progres.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><a ng-if=\"isMalfunction\" href=\"./dysfonctionnements\" class=\"iv-H1-backBtn\">\n<md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></a><a ng-if=\"!isMalfunction\" \nhref=\"./fiches-progres\" class=\"iv-H1-backBtn\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></a>\n<div>{{editionMode ? \'Modification d\\\'une fiche progrès\': \'Nouvelle fiche de progrès\'}}</div></h1><div \nclass=\"iv-Content\"><form class=\"mt-25 mb-50\" name=\"addFicheProgresForm\" \nng-submit=\"addFicheProgresForm.$valid && addFicheProgres()\" novalidate><div class=\"mb-20\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><h2 class=\"iv-H2 text-center\" flex=\"100\">{{malfunction.title}}</h2><div \nclass=\"text-center\" flex=\"100\" style=\"white-space: pre-wrap; font-size: 1.3rem\">{{malfunction.description}}</div></div>\n<div class=\"nl-form-wrapper\" layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\"><md-input-container \nclass=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Motif d\'ouverture de la Fiche de progrès</label><md-select \nng-model=\"ficheProgres.type.id\" required name=\"type\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" style=\"background-color: rgba(255, 255, 255, 1) !important\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option class=\"iv-Select-dropdown-btn\" \nng-selected=\"malfunction != null ? malfunction.type.id == type.id : ficheProgres.type.id == type.id\" \nng-repeat=\"type in types track by type.id\" ng-value=\"type.id\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div flex=\"100\" class=\"mt-10\"><md-input-container \nclass=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Intitulé <span ng-if=\"ficheProgres.title == null\" \nclass=\"asterix\">*</span></label><input class=\"iv-Input-input ng-pristine md-input\" type=\"text\" name=\"title\" \nng-model=\"ficheProgres.title\" required><div ng-messages=\"addFicheProgresForm.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div flex=\"100\" \nclass=\"mt-10\"><md-input-container class=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nng-if=\"!isMalfunction\" class=\"iv-Input-label md-no-float md-container-ignore\">\nQuelles sont les causes de la situation actuelle ?<span ng-if=\"ficheProgres.reason == null\" class=\"asterix\">*</span>\n</label><label ng-if=\"isMalfunction\" class=\"iv-Input-label md-no-float md-container-ignore\">\nQuelles sont les causes du dysfonctionnement ?<span ng-if=\"ficheProgres.reason == null\" class=\"asterix\">*</span>\n</label><textarea class=\"iv-Input-textarea\" ng-model=\"ficheProgres.reason\" name=\"reason\" rows=\"2\" max-rows=\"4\" \nmd-no-resize required></textarea><div ng-messages=\"addFicheProgresForm.reason.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div flex=\"100\" \nclass=\"mt-10\"><md-input-container class=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nng-if=\"isMalfunction\" class=\"iv-Input-label md-no-float md-container-ignore\">\nComment éviter que le dysfonctionnement ne se reproduise ?<span ng-if=\"ficheProgres.fix == null\" class=\"asterix\">*\n</span></label><label ng-if=\"!isMalfunction\" class=\"iv-Input-label md-no-float md-container-ignore\">\nQuelles sont les sources d\'amélioration ?<span ng-if=\"ficheProgres.fix == null\" class=\"asterix\">*</span></label>\n<textarea class=\"iv-Input-textarea\" ng-model=\"ficheProgres.fix\" name=\"fix\" rows=\"2\" max-rows=\"4\" md-no-resize required>\n</textarea><div ng-messages=\"addFicheProgresForm.fix.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container></div><div flex=\"100\" class=\"mt-10\"><p \nstyle=\"font-size: 1.3rem; font-style: italic\">\nCliquez sur « Planifier une action corrective » en vue de clôturer votre fiche de progrès.<br>\nCela créera automatiquement une tâche sur votre planning. Dès que vous l’aurez cochée comme « terminée », nous vous informerons que votre fiche de progrès sera clôturée avec succès.\n</p></div><div class=\"mt-40\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\"><div layout=\"row\" \nlayout-align=\"center center\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" aria-label=\"Annuler\" \nng-click=\"cancel()\">Annuler</button></div><div layout=\"row\" layout-align=\"center center\"><button id=\"btnSaveFp\" \ntype=\"submit\" class=\"nl-Btn nl-Btn\" aria-label=\"Sauvegarder\" ng-disabled=\"addFicheProgresForm.$invalid\">Sauvegarder\n</button> <button type=\"button\" class=\"nl-Btn ml-10\" aria-label=\"Planifier\" \nng-click=\"saveAndOpen(addFicheProgresForm)\" ng-disabled=\"addFicheProgresForm.$invalid\">Planifier une action corrective\n</button></div></div></div></form></div></section>");
$templateCache.put("app/main/front/malfunctions/add/add_malfunction.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><a class=\"iv-H1-backBtn\" href=\"{{backRoute}}\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>Signaler un dysfonctionnement</div></h1><div \nclass=\"iv-Content\"><form class=\"mt-50 mb-50\" name=\"addMalfunctionForm\" \nng-submit=\"addMalfunctionForm.$valid && addMalfunction()\" novalidate><div class=\"nl-form-wrapper\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"66\" class=\"pr-15\"><md-input-container \nclass=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Type de dysfonctionnement</label><md-select \nng-model=\"malfunction.type\" required name=\"type\" ng-change=\"typeChanged()\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"type in types track by type.id\" ng-value=\"type\">{{type.name}}</md-option>\n<md-option class=\"iv-Select-dropdown-btn iv-Select-dropdown-newType\" ng-click=\"openModalCreateType()\" \nng-if=\"($root.user.isTitulaire || $root.user.isPraq) && !$root.user.isMini\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"add-new-Btn-icon icon-plus\"></i><div>Gérer les types de dysfonctionnements</div>\n</div></md-option></md-select><div ng-messages=\"addMalfunctionForm.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div flex=\"33\">\n<md-input-container class=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" md-is-open=\"isOpen\" \nmd-hide-icons=\"all\" name=\"dateStart\" ng-model=\"malfunction.creation\" md-max-date=\"today\" md-open-on-focus required>\n</md-datepicker></div><div ng-messages=\"addMalfunctionForm.dateStart.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Information requise.</span></div></div></md-input-container></div><div ng-if=\"malfunction.type.index === 2\" \nflex=\"100\" class=\"mt-15\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Erreur détectée par <span \nng-if=\"malfunction.dispensation.detector == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.detector\" md-no-ink><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"column\" flex=\"50\"><md-radio-button class=\"iv-Radio p-5\" \nvalue=\"{{dispensationTypes.INTERNE_CONTROL}}\">La pharmacie - contrôle interne</md-radio-button><md-radio-button \nclass=\"iv-Radio p-5\" value=\"{{dispensationTypes.DMP}}\">La pharmacie - DMP</md-radio-button></div><div layout=\"column\" \nflex=\"50\"><md-radio-button class=\"iv-Radio p-5\" value=\"{{dispensationTypes.CLIENT}}\">Le client</md-radio-button>\n<md-radio-button class=\"iv-Radio p-5\" value=\"{{dispensationTypes.PAYER_ORGANISM}}\">L\'organisme payeur</md-radio-button>\n</div></div></md-radio-group></md-input-container><div class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Caractérisation de l\'erreur <span \nng-if=\"malfunction.dispensation.error == null\" class=\"asterix\">*</span></label><md-select \nng-model=\"malfunction.dispensation.error\" required name=\"errorDispensation\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"error in dispensationErrors track by error.index\" ng-value=\"error.code\">\n{{error.libelle}}</md-option></md-select><div ng-messages=\"addMalfunctionForm.errorDispensation.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div class=\"mt-10\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Le produit a été délivré <span \nng-if=\"malfunction.dispensation.delivered == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.delivered\" md-no-ink><md-radio-button \nclass=\"iv-Radio\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"false\">Non\n</md-radio-button></md-radio-group></md-input-container></div><div \nng-if=\"malfunction.dispensation && malfunction.dispensation.delivered == true\" class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Le traitement a été administré<span \nng-if=\"malfunction.dispensation.beginTraitement == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" ng-model=\"malfunction.dispensation.beginTraitement\" required md-no-ink><md-radio-button \nclass=\"iv-Radio\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"false\">Non\n</md-radio-button></md-radio-group></md-input-container><div ng-if=\"malfunction.dispensation.beginTraitement == true\" \nlayout=\"row\" layout-wrap><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Depuis quand :</label><md-select \nng-model=\"malfunction.dispensation.sinceWhen\" required name=\"since\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"date in dispensationDates track by date.index\" ng-value=\"date.code\">{{date.libelle}}</md-option></md-select>\n<div ng-messages=\"updateMalfunctionForm.since.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container><div class=\"mt-20\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Conséquence pour le patient<span \nng-if=\"malfunction.dispensation.consequence == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.consequence\" md-no-ink><md-radio-button \nclass=\"iv-Radio\" value=\"{{\'ANY\'}}\">Aucune</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{\'DOCTOR\'}}\">\nVisite chez le médecin</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{\'HOSPITAL\'}}\">Hospitalisation\n</md-radio-button></md-radio-group></md-input-container></div></div></div></div><div class=\"mt-10\" flex=\"100\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Importance <span ng-if=\"malfunction.priority == null\" \nclass=\"asterix\">*</span></label><md-radio-group class=\"iv-Radio-wrapper\" ng-model=\"malfunction.priority\" required \nmd-no-ink><md-radio-button class=\"iv-Radio\" value=\"{{priorities.HIGH}}\">Forte</md-radio-button><md-radio-button \nclass=\"iv-Radio\" value=\"{{priorities.NORMAL}}\">Moyenne</md-radio-button><md-radio-button class=\"iv-Radio\" \nvalue=\"{{priorities.LOW}}\">Faible</md-radio-button></md-radio-group></md-input-container></div><div class=\"mt-10\" \nflex=\"100\" ng-if=\"malfunction.type.index === 6\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Domaine impacté *</label><md-select \nng-model=\"malfunction.ecorDomain\" class=\"iv-Input-select md-no-underline\" required name=\"ecorDomain\" \nmd-container-class=\"iv-Select-dropdown\"><md-select-header class=\"nl-Input-select-header\">Sélectionnez votre entrée\n</md-select-header><md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"domain in ecorDomains\" ng-value=\"domain.value\">\n{{domain.libelle}}</md-option></md-select><div ng-messages=\"addMalfunctionForm.ecorDomain.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nng-if=\"malfunction.type.index === 4||malfunction.type.index === 6 && malfunction.ecorDomain === \'ACHAT\'\" flex=\"100\" \nclass=\"mt-10\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Type de prestataire <span \nng-if=\"malfunction.supplier.type == null\" class=\"asterix\">*</span></label><md-radio-group class=\"iv-Radio-wrapper\" \nng-model=\"malfunction.supplier.type\" md-no-ink><md-radio-button class=\"iv-Radio\" value=\"{{supplierTypes.LAB}}\">\nLaboratoire</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{supplierTypes.SERVICE}}\">\nPrestataire de services</md-radio-button></md-radio-group></md-input-container></div><div flex=\"100\" \nng-if=\"malfunction.type.index === 4||malfunction.type.index === 6 && malfunction.ecorDomain === \'ACHAT\'\" class=\"mt-10\" \nlayout=\"row\" layout-align=\"space-between end\"><div flex><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Prestataire<md-progress-circular md-diameter=\"25px\" \nng-if=\"loading\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></label><md-select \nng-model=\"malfunction.supplier\" ng-disabled=\"loading || malfunction.supplier.type==null\" \nclass=\"iv-Input-select md-no-underline\" required name=\"supplier\" md-container-class=\"iv-Select-dropdown\">\n<md-select-header class=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"supplier in suppliers track by supplier.id\" ng-value=\"supplier\" \nng-selected=\"malfunction.supplier.id==supplier.id\">{{supplier.name}}</md-option></md-select><div \nng-messages=\"addMalfunctionForm.supplier.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div><div><button type=\"button\" class=\"iv-Btn iv-Btn--export ml-5 mb-5\" \nng-click=\"dialogSave(malfunction.supplier.type)\" ng-disabled=\"loading || malfunction.supplier.type==null\" \naria-label=\"Ajouter un prestataire\"><md-icon class=\"w-15 h-15\" md-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon><div>\nAjouter un prestataire</div></button></div></div><div flex=\"100\" class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Titre <span ng-if=\"malfunction.title == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"title\" ng-model=\"malfunction.title\" \nclass=\"iv-Input-input ng-pristine md-input\" placeholder=\"\" required><div ng-messages=\"addMalfunctionForm.title.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nflex=\"100\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Constat <span ng-if=\"malfunction.description == null\" \nclass=\"asterix\">*</span></label><textarea ng-model=\"malfunction.description\" name=\"description\" \nclass=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea><div \nng-messages=\"addMalfunctionForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div \nflex=\"50\" class=\"mr-20\" ng-if=\"!addCollaborateurMode\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Rapporteur</label><md-select \nng-model=\"malfunction.collaborateur.id\" required name=\"collaborateur\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\" \nng-change=\"changeCollab(malfunction.collaborateur.id)\"><md-select-header class=\"nl-Input-select-header\">\nSélectionnez votre entrée</md-select-header><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' +collaborateur.name}}</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select><div ng-messages=\"addMalfunctionForm.collaborateur.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"50\" ng-if=\"addCollaborateurMode\"><div class=\"mr-5\" flex=\"50\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Nom <span \nng-if=\"malfunction.collaborateur.surname == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"surnameCollaborateur\" ng-model=\"malfunction.collaborateur.surname\" required class=\"nl-Input-input\" \nplaceholder=\"\"><div ng-messages=\"addMalfunctionForm.surnameCollaborateur.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div><div class=\"mr-20\" \nflex=\"50\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Prénom <span \nng-if=\"malfunction.collaborateur.name == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"nameCollabrateur\" ng-model=\"malfunction.collaborateur.name\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addMalfunctionForm.nameCollabrateur.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div></div><div flex=\"50\" \nng-if=\"malfunction.type.index === 2 && !addPersonIssuedMode\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Personne ayant délivré</label><md-select \nng-model=\"malfunction.personIssued.id\" name=\"personIssued\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\" \nng-change=\"changePerson(malfunction.personIssued.id)\"><md-select-header class=\"nl-Input-select-header\">\nSélectionnez votre entrée</md-select-header><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></md-input-container></div></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row\" ng-if=\"malfunction.documents == null||malfunction.documents.length < 3\">\n<md-input-container class=\"iv-Input-container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">ㅤ</label><button class=\"iv-Btn iv-Btn--file\" type=\"button\" \nng-click=\"openJoindreFile()\" style=\"width: 100%; justify-content: flex-start; border: 0\"><div class=\"iv-Btn__file\">\n</div><md-icon class=\"m-0\" md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe\n</div></button></md-input-container><input type=\"file\" id=\"add_file\" ng-hide=\"true\"></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row mt-10\" ng-repeat=\"document in malfunction.documents\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Btn iv-Btn--file\" ng-if=\"document.attachmentOriginalName != null\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\" ng-click=\"downloadDoc(document.id)\"><md-icon \nng-if=\"document.id\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.attachmentOriginalName}}\n</div></div><button type=\"button\" class=\"iv-BtnIcon--file\" ng-click=\"deleteDocument($index);\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div><div class=\"mt-40\" flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><button type=\"button\" ng-click=\"goBack()\" class=\"nl-Btn nl-Btn--outline\" \naria-label=\"Annuler\">Annuler</button> <button id=\"btnSaveMalfunction\" type=\"submit\" class=\"nl-Btn ml-8\" \naria-label=\"Sauvegarder\" ng-disabled=\"addMalfunctionForm.$invalid || !(malfunction.type && malfunction.type.id)\">\nSauvegarder<md-progress-circular md-diameter=\"25px\" ng-if=\"loading\" class=\"md-accent nl-Spinner--center ml-8\" \nmd-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></button></div></div></form></div></section>");
$templateCache.put("app/main/front/malfunctions/add/add_type.html","<md-dialog flex=\"40\" flex-md=\"70\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nstyle=\"padding-left:15px\">Gérer les types de dysfonctionnements</div></div><md-button class=\"md-icon-button\" \nng-click=\"closeModalType()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div layout=\"row\" ng-click=\"openEditType(type)\" \nlayout-align=\"space-between center\" class=\"types-malfunction--list\" flex=\"100\" \nng-repeat=\"type in types track by type.id\"><div>{{type.name}}</div><div ng-if=\"type.pharmacy\" flex=\"5\" \nclass=\"icon-close--types\" layout-align=\"end center\"><md-icon ng-click=\"openDeleteType($event,type.id)\" \nclass=\"icon-close--types\" md-font-icon=\"icon-close\"></md-icon></div></div><md-input-container md-no-float \nng-if=\"!loadingType && types && types.length < 10\" class=\"nl-Input-container\" flex=\"100\"><input class=\"nl-Input-input\" \ntype=\"text\" placeholder=\"Créer un nouveau type\" ng-enter=\"saveType()\" ng-blur=\"saveType()\" name=\"name\" \nng-model=\"typeToAdd.name\"></md-input-container><div ng-if=\"types && types.length > 9\" style=\"color: #d0021b\">\nVous avez atteint la limite du nombre de types de dysfonctionnement.</div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn ml-10\" ng-click=\"closeModalType()\">Valider</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/appel-medecins/appelMedecins.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><div>Appels aux médecins</div><button type=\"button\" class=\"nl-Btn\" \nng-click=\"signalerAppelPopup()\">+ Nouvel appel médecin</button></h1><div class=\"nl-Content\"><div \nclass=\"iv-SmallTabs-wrapper\"><div class=\"iv-SmallTabs-item\" ng-class=\"{\'iv-Tabs-item--active\': tabs.active}\" \nng-click=\"switchTab(\'active\')\"><md-icon class=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/appel_blue.svg\" \nclass=\"md-default-theme\" role=\"img\" aria-hidden=\"true\"></md-icon><div>Appels récents</div></div><div \nclass=\"iv-SmallTabs-item\" ng-class=\"{\'iv-Tabs-item--active\': tabs.archive}\" ng-click=\"switchTab(\'archive\')\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/history_tab.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Appels archivés</div></div></div><br><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"gap:1rem\"><div layout=\"row\" layout-align=\"start center\" \nng-show=\"!archiveEmpty && tabs.archive\"><div class=\"nl-FilterBar-2\" ng-if=\"!searching\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu class=\"nl-Menu nl-Menu--filtre\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\" \nstyle=\"background-color: transparent !important\"><div class=\"nl-Menu-btn-title color-dys\"><strong>\n{{archive.value && archive.value != \'none\' && archive.value != \'all\' ? archive.value : \"Afficher par année\"}}</strong>\n</div><md-icon ng-if=\"!$mdMenuIsOpen\" class=\"nl-Menu-btn-svg w-16 h-16\" \nmd-svg-src=\"assets/icons/app/filtres/arrow_down_blue.svg\"></md-icon><md-icon ng-if=\"$mdMenuIsOpen\" \nclass=\"nl-Menu-btn-svg w-16 h-16\" md-svg-src=\"assets/icons/app/filtres/arrow_up_blue.svg\"></md-icon></button>\n<md-menu-content width=\"4\" style=\"scrollbar-width: none !important; border-color: rgba(197, 220, 244, 1) !important\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archive.value = \'all\'; months.length = 0; searchArchives(\'YEAR\');\">Toutes</md-button></md-menu-item>\n<md-menu-item md-menu-align-target ng-repeat=\"year in years\"><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archive.value = year.value; months.length = 0; archiveMonth.value = \'none\'; searchArchives(\'YEAR\');\">\n{{year.value}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu class=\"nl-Menu nl-Menu--filtre\" \nmd-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"0 35\" ng-if=\"months.length > 0\"><button aria-label=\"\" \nclass=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\" style=\"background-color: transparent !important\"><div \nclass=\"nl-Menu-btn-title color-dys\"><strong>\n{{(archiveMonth.value && archiveMonth.value != \'none\') && archiveMonth.value != \'all\' ? archiveMonth.value : \"Sélectionner un mois\"}}\n</strong></div><md-icon ng-if=\"!$mdMenuIsOpen\" class=\"nl-Menu-btn-svg w-16 h-16\" \nmd-svg-src=\"assets/icons/app/filtres/arrow_down_blue.svg\"></md-icon><md-icon ng-if=\"$mdMenuIsOpen\" \nclass=\"nl-Menu-btn-svg w-16 h-16\" md-svg-src=\"assets/icons/app/filtres/arrow_up_blue.svg\"></md-icon></button>\n<md-menu-content width=\"4\" style=\"scrollbar-width: none !important; border-color: rgba(197, 220, 244, 1) !important\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archiveMonth.value = \'all\'; searchArchives(\'MONTH\'); \">Tous</md-button></md-menu-item><md-menu-item \nmd-menu-align-target ng-repeat=\"month in months\"><md-button class=\"nl-Menu-dropdown-btn dropdown-btn-blue\" \nng-click=\"archiveMonth.index = month.index; archiveMonth.value = month.value; searchArchives(\'MONTH\');\">{{month.value}}\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div layout=\"row\" layout-align=\"start center\" \nng-show=\"archiveEmpty || !tabs.archive\"></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"nl-SearchBar nl-SearchBar--home\" style=\"min-width: 80px\" layout=\"row\"><md-icon \nng-click=\"cancelSearch();refresh()\" ng-show=\"searchTxt\" md-svg-src=\"assets/icons/app/V3/del.svg\" \nclass=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon ng-click=\"search()\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\" class=\"nl-SearchBar--icon--search--home color-trac\"></md-icon>\n<md-input-container md-no-float class=\"nl-Input-container nl-SearchBar--input\" layout=\"row\" layout-align=\"end center\" \nflex=\"100\"><input ng-enter=\"search()\" class=\"nl-Input-input--searchHome\" placeholder=\"Rechercher...\" type=\"text\" \nname=\"title\" ng-model=\"searchTxt\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><button \nclass=\"nl-Btn nl-Btn--transparent\" ng-click=\"openExport()\" style=\"font-weight: bold\"><span class=\"mr-5\">Exporter</span>\n <span ng-if=\"trace.templateType === \'SUIVI_FORMATION\'\">le plan de formation</span><md-icon class=\"w-20 h-20\" \nmd-svg-src=\"assets/icons/app/V3/download.svg\" style=\"color:#3D94FF\"></md-icon></button></div></div></div><div \nclass=\"mt-25\" ng-if=\"searching && tabs.active\"><div class=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"appel in appelsSearch track by appel.id\" \nng-click=\"openAppelPopup(appel)\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"column\" class=\"nl-dib ml-5\" style=\"width:50%\"><div \nclass=\"nl-list-item-title\"><strong>Médecin : </strong>{{appel.nomMedecin}}</div><div class=\"nl-list-item-title\">\n<strong>Patient : </strong>{{appel.nomPatient}}</div></div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>\n{{appel.creationDate | date: \'dd/MM/yyyy à HH:mm\'}} • {{appel.appelant.surname}} {{appel.appelant.name}}</div><div \nclass=\"nl-list-item-icon\" style=\"cursor: default !important\" \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0\" \nng-click=\"$event.stopPropagation();download(appel.id)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Pièce jointe\n</md-tooltip></div></div></div><div flex=\"nogrow\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"btn-menu\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nstyle=\"border-color:rgba(197, 220, 244, 1) !important\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openAppelPopup(appel)\">Afficher</md-button></md-menu-item><md-menu-item ng-if=\"!appel.archived\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openAppelPopup(appel, true)\">Ajouter un commentaire</md-button></md-menu-item>\n<md-menu-item \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0 && !appel.archived\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"download(appel.id)\">Télécharger la pièce jointe</md-button></md-menu-item>\n<md-menu-item aria-label=\"Archivé\" class=\"nl-Checkbox\"><md-button class=\"iv-Menu-dropdown-btn\" ng-if=\"!appel.archived\" \nng-click=\"appel.archived = !appel.archived;setArchived(appel)\">Archiver</md-button><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-if=\"appel.archived\" ng-click=\"appel.archived = !appel.archived;setArchived(appel)\">\nDésarchiver</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"appelsSearch.length === 0\"><p>Aucun résultat...</p></md-list-item></div></div>\n<div class=\"mt-25\" ng-if=\"!searching && tabs.active\"><div class=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"appel in appels track by appel.id\" ng-click=\"openAppelPopup(appel)\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"column\" class=\"nl-dib ml-5\" style=\"width:50%\"><div \nclass=\"nl-list-item-title\"><strong>Médecin : </strong>{{appel.nomMedecin}}</div><div class=\"nl-list-item-title\">\n<strong>Patient : </strong>{{appel.nomPatient}}</div></div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>\n{{appel.creationDate | date: \'dd/MM/yyyy à HH:mm\'}} • {{appel.appelant.surname}} {{appel.appelant.name}}</div><div \nclass=\"nl-list-item-icon\" style=\"cursor: default !important\" \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0\" \nng-click=\"$event.stopPropagation();download(appel.id)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Pièce jointe\n</md-tooltip></div></div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu \nclass=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"btn-menu\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" style=\"border-color:rgba(197, 220, 244, 1) !important\"><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openAppelPopup(appel)\">Afficher</md-button></md-menu-item><md-menu-item>\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openAppelPopup(appel, true)\">Ajouter un commentaire</md-button>\n</md-menu-item><md-menu-item ng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0\">\n<md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(appel.id)\">Télécharger la pièce jointe</md-button>\n</md-menu-item><md-menu-item aria-label=\"Archivé\" class=\"nl-Checkbox\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"appel.archived = !appel.archived;setArchived(appel)\">Archiver</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div><div ng-show=\"!archiveEmpty && tabs.archive\"><div class=\"mt-25\" ng-if=\"!searching\">\n<div class=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"openAppelPopup(appel)\" ng-repeat=\"appel in appelsArchived track by appel.id\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"column\" class=\"nl-dib ml-5\" style=\"width:50%\"><div \nclass=\"nl-list-item-title\"><strong>Médecin : </strong>{{appel.nomMedecin}}</div><div class=\"nl-list-item-title\">\n<strong>Patient : </strong>{{appel.nomPatient}}</div></div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>\n{{appel.creationDate | date: \'dd/MM/yyyy à HH:mm\'}} • {{appel.appelant.surname}} {{appel.appelant.name}}</div><div \nclass=\"nl-list-item-icon\" style=\"cursor: default !important\" \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0\" \nng-click=\"$event.stopPropagation();download(appel.id)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Pièce jointe\n</md-tooltip></div></div></div><md-menu class=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" md-menu-origin \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"btn-menu\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" style=\"border-color:rgba(197, 220, 244, 1) !important\">\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openAppelPopup(appel)\">Afficher</md-button>\n</md-menu-item><md-menu-item aria-label=\"Archivé\" class=\"nl-Checkbox\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"appel.archived = !appel.archived;setArchived(appel)\">Désarchiver</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div class=\"mt-25\" ng-if=\"searching\"><div class=\"nl-list\"><div class=\"nl-list-item\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"appel in appelsArchivedSearch track by appel.id\" \nng-click=\"openAppelPopup(appel)\" \nstyle=\"border-top:transparent !important; border-bottom: 1px solid rgba(197, 220, 244, 1) !important\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"column\" class=\"nl-dib ml-5\" style=\"width:50%\"><div \nclass=\"nl-list-item-title\"><strong>Médecin : </strong>{{appel.nomMedecin}}</div><div class=\"nl-list-item-title\">\n<strong>Patient : </strong>{{appel.nomPatient}}</div></div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>\n{{appel.creationDate | date: \'dd/MM/yyyy à HH:mm\'}} • {{appel.appelant.surname}} {{appel.appelant.name}}</div><div \nclass=\"nl-list-item-icon\" style=\"cursor: default !important\" \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0\" \nng-click=\"$event.stopPropagation();download(appel.id)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon><md-tooltip md-direction=\"bottom\">Pièce jointe\n</md-tooltip></div></div></div><div flex=\"nogrow\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" md-menu-origin nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"btn-menu\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nstyle=\"border-color:rgba(197, 220, 244, 1) !important\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openAppelPopup(appel)\">Afficher</md-button></md-menu-item><md-menu-item ng-if=\"!appel.archived\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openAppelPopup(appel, true)\">Ajouter un commentaire</md-button></md-menu-item>\n<md-menu-item \nng-if=\"appel.attachmentOriginalName != null && appel.attachmentOriginalName.length > 0 && !appel.archived\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"download(appel.id)\">Télécharger la pièce jointe</md-button></md-menu-item>\n<md-menu-item aria-label=\"Archivé\" class=\"nl-Checkbox\"><md-button class=\"iv-Menu-dropdown-btn\" ng-if=\"!appel.archived\" \nng-click=\"appel.archived = !appel.archived;setArchived(appel)\">Archiver</md-button><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-if=\"appel.archived\" ng-click=\"appel.archived = !appel.archived;setArchived(appel)\">\nDésarchiver</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"appelsArchivedSearch.length === 0\"><p>Aucun résultat...</p></md-list-item>\n</div></div></div></div></section>");
$templateCache.put("app/main/front/malfunctions/popup/confirm_activate_popup.html","<md-dialog aria-label=\"Activation\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nDésarchivage d\'un dysfonctionnement</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" \nlayout=\"column\" layout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir désarchiver ce dysfonctionnement ?</md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn\" ng-click=\"activate(malfunction)\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/confirm_delete_fiche_progres_popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar \nstyle=\"background-color: #DDEDFE; color: #1A2A33\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><span layout=\"row\" layout-align=\"center center\" \nstyle=\"width: 100%\">Suppression de la fiche de progrès</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\" style=\"color: #1A2A33\"></md-icon></md-button></div>\n</div></md-toolbar><md-dialog-content>Êtes-vous sûr de vouloir supprimer cette fiche progrès ?</md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline mr-10\" ng-click=\"hidePopup()\">Non</button> \n<button class=\"nl-Btn\" ng-click=\"delete(ficheProgres)\">Oui</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/confirm_delete_malfunction_popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nSupprimer un dysfonctionnement</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer ce dysfonctionnement ?<md-switch ng-model=\"malfunction._deleteAll\" \naria-label=\"Tout supprimer\" ng-disabled=\"!!disableSwitch\">\nSupprimer toutes les fiches progrès associées ainsi que leurs actions correctives</md-switch></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" ng-click=\"delete(malfunction)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/confirm_delete_type.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nSupprimer ce type de dysfonctionnement</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" \nlayout=\"column\" layout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer ce type de dysfonctionnement ?<br><br><span ng-if=\"countType > 0\">\nLes dysfonctionnements qui auront été crées avec ce type seront automatiquement rebasculés dans la catégorie \"Dysfonctionnements\". Êtes-vous sûrs de vouloir poursuivre la suppression ?\n</span></md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Non</button> <button class=\"nl-Btn ml-10\" ng-click=\"deleteType(typeToDelete)\">Oui, supprimer\n</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/edit_type.html","<md-dialog flex=\"40\" flex-md=\"70\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nstyle=\"padding-left:15px\">Modifier le type de dysfonctionnement</div></div><md-button class=\"md-icon-button\" \nng-click=\"closeModalType()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container nl-noError\" flex=\"100\"><input \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"Nom à modifier\" name=\"name\" ng-model=\"typeToEdit.name\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline\" \nng-click=\"closeModalType()\">Annuler</button> <button class=\"nl-Btn mr-20\" ng-click=\"editType()\">Valider</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/export.html","<md-dialog class=\"iv-Dialog\" flex=\"30\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"80\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">Exporter\n</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\">\n<md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><form name=\"exportForm\" \nnovalidate ng-submit=\"exportForm.$valid && export()\"><md-dialog-content><div class=\"iv-Dialog__text mb-10\">\nVeuillez sélectionner une plage de dates correspondante aux données que vous souhaitez exporter</div><div layout=\"row\" \nlayout-align=\"space-between start\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de début<span ng-if=\"exportDates.startDate == null\" \nclass=\"asterix\">*</span></label><div class=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"isOpen\" md-hide-icons=\"all\" name=\"dateStart\" ng-model=\"exportDates.startDate\" \nmd-open-on-focus required></md-datepicker></div><div ng-messages=\"exportForm.dateStart.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de fin<span ng-if=\"exportDates.endDate == null\" \nclass=\"asterix\">*</span></label><div class=\"iv-Input-date-wrapper\" ng-click=\"isOpen2 = !isOpen2\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"isOpen2\" md-hide-icons=\"all\" name=\"dateEnd\" ng-model=\"exportDates.endDate\" required>\n</md-datepicker></div><div ng-messages=\"exportForm.dateEnd.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<button class=\"nl-Btn nl-Btn--outline\" type=\"button\" ng-click=\"hidePopup()\">Annuler</button> <button \nclass=\"nl-Btn ml-10\" type=\"submit\"><md-progress-circular md-diameter=\"15px\" ng-if=\"loadingExport\" class=\"md-accent\" \nmd-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingExport\" class=\"nl-Menu-btn-title\">Exporter</span>\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/fiche_progres_popup.html","<md-dialog aria-label=\"Dysfonctionnement\" class=\"iv-Dialog\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\">\n<md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nAperçu de la fiche de progrès</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"iv-Dialog__apercu__item ng-scope\"><div \nclass=\"iv-Dialog__apercu__item__title ng-binding\">Motif d\'ouverture de la fiche de progrès</div><div \nclass=\"iv-Dialog__apercu__item__text ng-binding\">{{ficheProgres.type.name}}</div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\" style=\"width:50%\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">Date\n</div><div class=\"iv-Dialog__apercu__item__text ng-binding\">{{ficheProgres.creation | date : \'dd/MM/yyyy\'}}</div></div>\n<div class=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">\nQuelles sont les causes de la situation actuelle ?</div><div class=\"iv-Dialog__apercu__item__text ng-binding\">\n{{ficheProgres.reason}}</div></div><div class=\"iv-Dialog__apercu__item ng-scope\"><div \nclass=\"iv-Dialog__apercu__item__title ng-binding\">Quelles sont les sources d\'amélioration ?</div><div \nclass=\"iv-Dialog__apercu__item__text ng-binding\">{{ficheProgres.fix}}</div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\" style=\"border-bottom: transparent !important\"><div \nclass=\"iv-Dialog__apercu__item__title ng-binding\">Actions correctives planifiées</div><div \nng-repeat=\"tache in tachesFC\"><md-icon flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon>{{tache.title}} <span \nclass=\"iv-Dialog__apercu__item__title ml-5\">{{tache.responsable}} • {{tache.date}}</span> <span class=\"ml-40\" \nng-if=\"tache.done\"><md-icon flex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon>\n<span style=\"color: #6296AE\">Réalisée</span></span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\" ng-if=\"ficheProgres.activated && !fromRDD\" style=\"gap:1rem\"><button \nclass=\"nl-Btn nl-Btn--outline mb-5\" ng-click=\"_closeDialog()\">Fermer</button> <button class=\"nl-Btn mb-5\" \nng-click=\"addAction(ficheProgres)\" ng-if=\"tachesFC.length === 0\">Planifier une action</button> <button \nclass=\"nl-Btn mb-5\" ng-click=\"addAction(ficheProgres)\" ng-if=\"tachesFC.length > 0\">Planifier une autre action</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/malfunctions/popup/infos_malfunctions_popup.html","<md-dialog aria-label=\"dysfonctionnements\" flex=\"50\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"100\" style=\"overflow: hidden\">\n<form class=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Information</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nLes dysfonctionnements, quel que soit leur thème, ont la plupart du temps un impact direct ou indirect sur la qualité de la prestation\n<br>(et/ou la sécurité de la délivrance dans la pharmacie !), la perception par les clients, les coûts internes…<br>\nSavoir les identifier, les comprendre et les traiter efficacement est un défi d’une grande importance pour la pharmacie :\n<br>il s’agit d’un vecteur d’amélioration immédiatement disponible, basé sur des cas concrets rencontrés par l’équipe !\n<br><br>Encouragez votre équipe à les signaler via la fonction \"dysfonctionnement\".<br>\nNous vous encourageons ensuite à les étudier régulièrement, et pour les plus significatifs ou à risque de se reproduire à ouvrir une fiche de progrès.\n<br>\nSur le LQO vous pourrez ensuite partager sur le cahier de transmission ou dans vos réunions d\'équipe les pistes d\'améliorations à mettre en place.\n<br>De même vous pouvez créer des catégories de dysfonctionnements qui vous sont propres : erreurs de caisse, PDA,…<br>\ndans ce cas vous pourrez retrouver dans votre tableau de bord un indicateur comptabilisant les enregistrements effectués (automatiquement créé et alimenté).\n<br><br>N\'hésitez pas à consulter la fiche information <b>Gérer efficacement les dysfonctionnements</b>\n (portail qualité) à ce sujet ou le tutoriel disponible (en bas à gauche de votre écran)<br><br>\nPar ailleurs cette fonction permet de tracer les dysfonctionnements fournisseurs et les erreurs de délivrances pour en assurer un suivi efficace.\n<br>Pour aller plus loin sur ce sujet, sont disponibles sur le portail :<br><br>Double contrôle :<br>- <b>\nFiche INFO Double contrôle de la dispensation </b>- <b>Mode opératoire double contrôle (en fonction des LGO)</b><br>\nSuivi fournisseurs :<br>- <b>BOX aide à la négociation commerciale/gestion des stocks</b><br>\nGérer les avis clients sur Internet :<br>- <b>Fiche INFO : Gérer les avis google des clients</b></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/update/update_malfunction.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><a class=\"iv-H1-backBtn\" href=\"./dysfonctionnements\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>Modifier un dysfonctionnement</div></h1><div \nclass=\"iv-Content\"><form class=\"mt-50 mb-50\" name=\"updateMalfunctionForm\" \nng-submit=\"updateMalfunctionForm.$valid && updateMalfunction()\" novalidate><div class=\"nl-form-wrapper\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div flex=\"66\" class=\"pr-15\"><md-input-container \nclass=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Type de dysfonctionnement</label><md-select \nng-model=\"malfunction.type\" ng-model-options=\"{trackBy: \'$value.id\'}\" required name=\"type\" ng-change=\"typeChanged()\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"type in types track by type.id\" ng-value=\"type\">{{type.name}}</md-option>\n<md-option class=\"iv-Select-dropdown-btn iv-Select-dropdown-newType\" ng-click=\"openModalCreateType()\" \nng-if=\"($root.user.isTitulaire || $root.user.isPraq) && !$root.user.isMini\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"add-new-Btn-icon icon-plus\"></i><div>Gérer les types de dysfonctionnements</div>\n</div></md-option></md-select><div ng-messages=\"updateMalfunctionForm.type.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div flex=\"33\">\n<md-input-container class=\"iv-form__container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" md-is-open=\"isOpen\" \nmd-hide-icons=\"all\" name=\"dateStart\" ng-model=\"malfunction.creation\" md-max-date=\"today\" md-open-on-focus required>\n</md-datepicker></div><div ng-messages=\"updateMalfunctionForm.dateStart.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nng-if=\"malfunction.type.index === 2\" flex=\"100\" class=\"mt-15\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Erreur détectée par <span \nng-if=\"malfunction.dispensation.detector == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.detector\" md-no-ink><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div layout=\"column\" flex=\"50\"><md-radio-button class=\"iv-Radio p-5\" \nvalue=\"{{dispensationTypes.INTERNE_CONTROL}}\">La pharmacie - contrôle interne</md-radio-button><md-radio-button \nclass=\"iv-Radio p-5\" value=\"{{dispensationTypes.DMP}}\">La pharmacie - DMP</md-radio-button></div><div layout=\"column\" \nflex=\"50\"><md-radio-button class=\"iv-Radio p-5\" value=\"{{dispensationTypes.CLIENT}}\">Le client</md-radio-button>\n<md-radio-button class=\"iv-Radio p-5\" value=\"{{dispensationTypes.PAYER_ORGANISM}}\">L\'organisme payeur</md-radio-button>\n</div></div></md-radio-group></md-input-container><div class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Caractérisation de l\'erreur <span \nng-if=\"malfunction.dispensation.error == null\" class=\"asterix\">*</span></label><md-select \nng-model=\"malfunction.dispensation.error\" required name=\"errorDispensation\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"error in dispensationErrors track by error.index\" ng-value=\"error.code\">\n{{error.libelle}}</md-option></md-select><div ng-messages=\"updateMalfunctionForm.errorDispensation.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nclass=\"mt-10\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Le produit a été délivré <span \nng-if=\"malfunction.dispensation.delivered == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.delivered\" md-no-ink><md-radio-button \nclass=\"iv-Radio\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"false\">Non\n</md-radio-button></md-radio-group></md-input-container></div><div \nng-if=\"malfunction.dispensation && malfunction.dispensation.delivered == true\" class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Le traitement a été administré<span \nng-if=\"malfunction.dispensation.beginTraitement == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" ng-model=\"malfunction.dispensation.beginTraitement\" required md-no-ink><md-radio-button \nclass=\"iv-Radio\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"false\">Non\n</md-radio-button></md-radio-group></md-input-container><div ng-if=\"malfunction.dispensation.beginTraitement == true\" \nclass=\"mt-10\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"100\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Depuis quand :</label><md-select \nng-model=\"malfunction.dispensation.sinceWhen\" required name=\"since\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"date in dispensationDates track by date.index\" ng-value=\"date.code\">{{date.libelle}}</md-option></md-select>\n<div ng-messages=\"updateMalfunctionForm.since.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container><div class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Conséquence pour le patient<span \nng-if=\"malfunction.dispensation.consequence == null\" class=\"asterix\">*</span> :</label><md-radio-group \nclass=\"iv-Radio-wrapper\" required ng-model=\"malfunction.dispensation.consequence\" md-no-ink><md-radio-button \nclass=\"iv-Radio\" value=\"{{\'ANY\'}}\">Aucune</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{\'DOCTOR\'}}\">\nVisite chez le médecin</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{\'HOSPITAL\'}}\">Hospitalisation\n</md-radio-button></md-radio-group></md-input-container></div></div></div></div><div class=\"mt-10\" flex=\"100\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Importance <span ng-if=\"malfunction.priority == null\" \nclass=\"asterix\">*</span></label><md-radio-group class=\"iv-Radio-wrapper\" ng-model=\"malfunction.priority\" required \nmd-no-ink><md-radio-button class=\"iv-Radio\" value=\"{{priorities.HIGH}}\">Forte</md-radio-button><md-radio-button \nclass=\"iv-Radio\" value=\"{{priorities.NORMAL}}\">Moyenne</md-radio-button><md-radio-button class=\"iv-Radio\" \nvalue=\"{{priorities.LOW}}\">Faible</md-radio-button></md-radio-group></md-input-container></div><div class=\"mt-10\" \nflex=\"100\" ng-if=\"malfunction.type.index === 6\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Domaine impacté *</label><md-select \nng-model=\"malfunction.ecorDomain\" class=\"iv-Input-select md-no-underline\" required name=\"ecorDomain\" \nmd-container-class=\"iv-Select-dropdown\"><md-select-header class=\"nl-Input-select-header\">Sélectionnez votre entrée\n</md-select-header><md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"domain in ecorDomains\" ng-value=\"domain.value\">\n{{domain.libelle}}</md-option></md-select><div ng-messages=\"addMalfunctionForm.ecorDomain.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container></div><div \nng-if=\"malfunction.type.index === 4||malfunction.type.index === 6 && malfunction.ecorDomain === \'ACHAT\'\" flex=\"100\" \nclass=\"mt-10\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Type de prestataire <span \nng-if=\"malfunction.supplier.type == null\" class=\"asterix\">*</span></label><md-radio-group class=\"iv-Radio-wrapper\" \nng-model=\"malfunction.supplier.type\" md-no-ink><md-radio-button class=\"iv-Radio\" value=\"{{supplierTypes.LAB}}\">\nLaboratoire</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"{{supplierTypes.SERVICE}}\">\nPrestataire de services</md-radio-button></md-radio-group></md-input-container></div><div flex=\"100\" \nng-if=\"malfunction.type.index === 4||malfunction.type.index === 6 && malfunction.ecorDomain === \'ACHAT\'\" class=\"mt-10\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Prestataire<md-progress-circular md-diameter=\"25px\" \nng-if=\"loading\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></label><md-select \nng-model=\"malfunction.supplier\" ng-disabled=\"loading || malfunction.supplier.type==null\" \nclass=\"iv-Input-select md-no-underline\" required name=\"supplier\" md-container-class=\"iv-Select-dropdown\">\n<md-select-header class=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"supplier in suppliers track by supplier.id\" ng-value=\"supplier\" \nng-selected=\"malfunction.supplier.id==supplier.id\">{{supplier.name}}</md-option></md-select><div \nng-messages=\"updateMalfunctionForm.supplier.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div><button type=\"button\" class=\"add-new-Btn\" ng-click=\"dialogSave(malfunction.supplier.type)\" \nng-disabled=\"loading || malfunction.supplier.type==null\" aria-label=\"Ajouter un prestataire\"><i \nclass=\"add-new-Btn-icon icon-plus\"></i><div class=\"add-new-Btn-text\">Ajouter un prestataire</div></button>\n</md-input-container></div><div flex=\"100\" class=\"mt-10\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Titre <span ng-if=\"malfunction.title == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"title\" ng-model=\"malfunction.title\" \nclass=\"iv-Input-input ng-pristine md-input\" placeholder=\"\" required><div \nng-messages=\"updateMalfunctionForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div><div flex=\"100\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Constat <span ng-if=\"malfunction.description == null\" \nclass=\"asterix\">*</span></label><textarea ng-model=\"malfunction.description\" name=\"description\" \nclass=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea><div \nng-messages=\"updateMalfunctionForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div flex=\"50\" class=\"mr-20\" ng-if=\"!addCollaborateurMode\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Rapporteur</label><md-select \nng-model=\"malfunction.collaborateur.id\" required name=\"collaborateur\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\" \nng-change=\"changeCollab(malfunction.collaborateur.id)\"><md-select-header class=\"nl-Input-select-header\">\nSélectionnez votre entrée</md-select-header><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' +collaborateur.name}}</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select><div \nng-messages=\"updateMalfunctionForm.collaborateur.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"50\" ng-if=\"addCollaborateurMode\"><div class=\"mr-5\" flex=\"50\">\n<md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Nom <span \nng-if=\"malfunction.collaborateur.surname == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"surnameCollaborateur\" ng-model=\"malfunction.collaborateur.surname\" required class=\"nl-Input-input\" \nplaceholder=\"\"><div ng-messages=\"updateMalfunctionForm.surnameCollaborateur.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div><div class=\"mr-20\" \nflex=\"50\"><md-input-container class=\"iv-Input-container no--errors-spacer iv-Input-container--full\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Prénom <span \nng-if=\"malfunction.collaborateur.name == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"nameCollabrateur\" ng-model=\"malfunction.collaborateur.name\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"updateMalfunctionForm.nameCollabrateur.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div></div><div flex=\"50\" \nng-if=\"malfunction.type.index === 2 && !addPersonIssuedMode\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Personne ayant délivré</label><md-select \nng-model=\"malfunction.personIssued.id\" name=\"personIssued\" \nclass=\"iv-Input-select nl-Input-select--arrow md-no-underline\" md-container-class=\"iv-Select-dropdown\" \nng-change=\"changePerson(malfunction.personIssued.id)\"><md-select-header class=\"nl-Input-select-header\">\nSélectionnez votre entrée</md-select-header><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></md-input-container></div></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row\" ng-if=\"malfunction.documents == null||malfunction.documents.length < 3\">\n<md-input-container class=\"iv-Input-container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">ㅤ</label><button class=\"iv-Btn iv-Btn--file\" type=\"button\" \nng-click=\"openJoindreFile()\" style=\"width: 100%; justify-content: flex-start; border: 0\"><div class=\"iv-Btn__file\">\n</div><md-icon class=\"m-0\" md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe\n</div></button></md-input-container><input type=\"file\" id=\"update_file\" ng-hide=\"true\"></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row mt-10\" ng-repeat=\"document in malfunction.documents\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Btn iv-Btn--file\" ng-if=\"document.attachmentOriginalName != null\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\" ng-click=\"downloadDoc(document.id)\"><md-icon \nng-if=\"document.id\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.attachmentOriginalName}}\n</div></div><button type=\"button\" class=\"iv-BtnIcon--file\" ng-click=\"deleteDocument($index);\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div><div class=\"mt-40\" flex=\"100\" layout=\"row\" \nlayout-align=\"end center\"><button type=\"button\" ng-click=\"goBack()\" class=\"nl-Btn nl-Btn--outline\" \naria-label=\"Annuler\">Annuler</button> <button id=\"btnSaveMalfunction\" type=\"submit\" class=\"nl-Btn ml-8\" \naria-label=\"Sauvegarder\" ng-disabled=\"updateMalfunctionForm.$invalid || !(malfunction.type && malfunction.type.id)\">\nSauvegarder<md-progress-circular md-diameter=\"25px\" ng-if=\"loading\" class=\"md-accent nl-Spinner--center ml-8\" \nmd-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></button></div></div></form></div></section>");
$templateCache.put("app/main/front/officine/acces/acces-compte.html","<span class=\"off-etat-compte off-etat-compte--actif\" ng-if=\"etatCompte(personne) === \'actif\'\"><span class=\"off-point\">\n</span>Actif</span> <span class=\"off-etat-compte off-etat-compte--attente\" ng-if=\"etatCompte(personne) === \'attente\'\">\n<span class=\"off-point\"></span>Jamais connecté</span> <span class=\"off-tab__vide\" ng-if=\"!etatCompte(personne)\">—\n</span> <button type=\"button\" class=\"off-lien-invitation\" ng-if=\"peutRenvoyer(personne)\" \nng-click=\"renvoyerInvitation(personne)\" ng-disabled=\"personne.renvoiEnCours\">\n{{personne.renvoiEnCours ? \'Envoi…\' : \'Renvoyer l\\\'invitation\'}}</button>");
$templateCache.put("app/main/front/officine/acces/acces-gestes.html","<button type=\"button\" class=\"off-tab-action\" ng-if=\"actionAcces(personne) === \'donner\'\" \nng-click=\"donnerAcces(personne, $event)\">Donner un accès</button> <button type=\"button\" \nclass=\"off-tab-action off-tab-action--neutre\" ng-if=\"actionAcces(personne) === \'ceder\'\" ng-click=\"cederTitre($event)\">\nCéder le titre</button> <button type=\"button\" class=\"off-tab-action off-tab-action--neutre\" \nng-if=\"personne.sansContact && personne.mail\" ng-click=\"creerContactDepuisCompte(personne, $event)\">Créer le contact\n</button> <button type=\"button\" class=\"off-tab-crayon\" ng-if=\"!personne.sansContact\" \nng-click=\"ouvrirPersonne(personne, $event)\" aria-label=\"Modifier\"><md-icon md-font-icon=\"icon-pencil\" class=\"s14\">\n</md-icon><md-tooltip md-direction=\"top\" ng-if=\"actionAcces(personne) === \'sans_courriel\'\">\nAjoutez un courriel pour pouvoir donner un accès.</md-tooltip><md-tooltip md-direction=\"top\" \nng-if=\"actionAcces(personne) !== \'sans_courriel\'\">Modifier</md-tooltip></button>");
$templateCache.put("app/main/front/officine/acces/acces.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Accès LQO</a></div></div><div class=\"nl-Content off-content\"><off-navigation>\n</off-navigation><off-bandeau etat=\"app.officine.acces\"><off-bandeau-phrase>Trois accès par officine&#8239;: <span \nclass=\"off-role off-role--titulaire\">Titulaire</span> <span class=\"off-role off-role--praq\">Responsable Qualité</span> \n<span class=\"off-role off-role--equipe\">Équipe</span>, chacun donné à une personne de vos contacts.\n</off-bandeau-phrase><off-bandeau-aide><p><strong>Donner un accès</strong>\n Responsable Qualité ou Équipe à une personne de la liste lui crée son compte et lui envoie une invitation. Donner un accès déjà occupé le retire à son occupant, et l\'écran le nomme avant de confirmer.\n</p><p><strong>Renvoyer l\'invitation</strong> reste possible tant que la personne ne s\'est jamais connectée.</p><p>\n<strong>Céder le titre</strong>\n de titulaire est définitif&#8239;: votre mot de passe est redemandé, et vous êtes déconnecté une fois le titre transmis.\n</p><p>\nUne personne sans courriel ne peut pas recevoir d\'accès&#8239;: ajoutez-lui un courriel avec le crayon. Les coordonnées des personnes se tiennent dans \n<a ui-sref=\"app.officine.contacts\">Contacts</a>.</p><p>Un <strong>compte sans personne rattachée</strong>\n ouvre toujours votre officine, mais aucune personne de votre liste ne porte son courriel. Pour libérer sa place, donnez l\'accès à une personne de votre liste.\n</p></off-bandeau-aide></off-bandeau><div ng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div \nclass=\"off-pile\" ng-if=\"etatEcran === \'normal\'\"><div class=\"off-places-lqo\"><section class=\"off-place-lqo\" \nng-repeat=\"place in places\" \nng-class=\"[\'off-place-lqo--\' + (place.slot | lowercase), {\'off-place-lqo--libre\': !place.occupant}]\" \naria-label=\"Accès {{place.libelle}}\"><div class=\"off-place-lqo__tete\"><span class=\"off-place-lqo__icone\" \naria-hidden=\"true\"><md-icon class=\"s20\" md-font-icon=\"icon-key-variant\" ng-if=\"place.slot === \'TITULAIRE\'\"></md-icon>\n<md-icon class=\"s20\" md-font-icon=\"icon-shield-outline\" ng-if=\"place.slot === \'PRAQ\'\"></md-icon><md-icon class=\"s20\" \nmd-font-icon=\"icon-account-multiple\" ng-if=\"place.slot === \'EQUIPE\'\"></md-icon></span><div \nclass=\"off-place-lqo__intitule\"><span class=\"off-place-lqo__role\">{{place.libelle}}</span> <span \nclass=\"off-place-lqo__description\">{{place.description}}</span></div></div><div class=\"off-place-lqo__corps\" \nng-if=\"place.occupant\"><div class=\"off-personne\"><span class=\"off-avatar\" aria-hidden=\"true\" \nng-class=\"{\n                    \'off-avatar--titulaire\': place.slot === \'TITULAIRE\',\n                    \'off-avatar--praq\': place.slot === \'PRAQ\',\n                    \'off-avatar--equipe\': place.slot === \'EQUIPE\'}\">\n{{initiales(place.occupant)}}</span><div class=\"off-personne__texte\"><div class=\"off-tab__nom\"><span \nng-if=\"aUnNom(place.occupant)\">{{nomPersonne(place.occupant)}}</span> <span class=\"off-place-lqo__mail-seul\" \nng-if=\"!aUnNom(place.occupant) && place.occupant.mail\">{{morceauxCourriel(place.occupant.mail)[0]}}<wbr>\n{{morceauxCourriel(place.occupant.mail)[1]}}</span> <span class=\"off-fil__absent\" \nng-if=\"!aUnNom(place.occupant) && !place.occupant.mail\">Compte sans courriel</span> <span \nclass=\"off-cle off-cle--vous\" ng-if=\"estMoi(place.occupant)\">vous</span></div><div class=\"off-tab__mail\" \nng-if=\"aUnNom(place.occupant) && place.occupant.mail\">{{morceauxCourriel(place.occupant.mail)[0]}}<wbr>\n{{morceauxCourriel(place.occupant.mail)[1]}}</div></div></div><div class=\"off-place-lqo__etat\"><span \nclass=\"off-etat-compte off-etat-compte--actif\" ng-if=\"etatCompte(place.occupant) === \'actif\'\"><span class=\"off-point\">\n</span>Actif</span> <span class=\"off-etat-compte off-etat-compte--attente\" \nng-if=\"etatCompte(place.occupant) === \'attente\'\"><span class=\"off-point\"></span>Jamais connecté</span> <span \nclass=\"off-place-lqo__connexion\" ng-if=\"place.occupant.derniereConnexion\">\nDernière connexion le {{dateCourte(place.occupant.derniereConnexion)}}</span></div><div \nclass=\"off-place-lqo__orphelin\" ng-if=\"place.occupant.sansContact\"><md-icon md-font-icon=\"icon-alert\" class=\"s14\">\n</md-icon><span>non rattaché à un contact</span><md-tooltip md-direction=\"top\">\nAucune personne de votre liste de contacts ne porte ce courriel.</md-tooltip></div></div><div \nclass=\"off-place-lqo__corps off-place-lqo__libre\" ng-if=\"!place.occupant\"><span class=\"off-place-lqo__libre-titre\">\nPlace libre</span> <span ng-if=\"place.slot !== \'TITULAIRE\'\">Donnez-la à une personne de la liste ci-dessous.</span>\n</div><div class=\"off-place-lqo__pied\" ng-if=\"peutEcrire() && place.occupant\"><button type=\"button\" \nclass=\"off-tab-action off-tab-action--neutre\" ng-if=\"place.slot === \'TITULAIRE\'\" ng-click=\"cederTitre($event)\">\nCéder le titre</button> <button type=\"button\" class=\"off-tab-action off-tab-action--neutre\" \nng-if=\"place.slot !== \'TITULAIRE\'\" ng-click=\"transfererAcces(place, $event)\">Transférer</button> <button type=\"button\" \nclass=\"off-tab-action off-tab-action--neutre\" ng-if=\"place.occupant.sansContact && place.occupant.mail\" \nng-click=\"creerContactDepuisCompte(place.occupant, $event)\">Créer le contact</button> <button type=\"button\" \nclass=\"off-tab-action off-tab-action--neutre\" ng-if=\"peutRenvoyer(place.occupant)\" \nng-click=\"renvoyerInvitation(place.occupant)\" ng-disabled=\"place.occupant.renvoiEnCours\">\n{{place.occupant.renvoiEnCours ? \'Envoi…\' : \'Renvoyer l\\\'invitation\'}}</button></div></section></div><div \nclass=\"off-liste\"><div class=\"off-liste__tete\"><span class=\"off-liste__titre\">\nDonner un accès à une personne de vos contacts <span class=\"off-bloc__compte\">{{personnesReferentiel.length}}</span>\n</span> <button type=\"button\" class=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-if=\"peutEcrire()\" \nng-click=\"ouvrirPersonne(null, $event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Ajouter un contact</button></div>\n<div class=\"off-tab-cadre\"><table class=\"off-tab off-tab--aere\"><thead><tr><th>Personne</th><th>Accès LQO</th><th>\nDernière connexion</th><th class=\"off-tab__colonne-gestes\"><span class=\"off-sr\">Actions</span></th></tr></thead><tbody>\n<tr ng-repeat=\"personne in personnesReferentiel\"><td><div class=\"off-personne\"><span class=\"off-avatar\" \naria-hidden=\"true\" \nng-class=\"{\n                          \'off-avatar--titulaire\': personne.acces === \'TITULAIRE\',\n                          \'off-avatar--praq\': personne.acces === \'PRAQ\',\n                          \'off-avatar--equipe\': personne.acces === \'EQUIPE\'}\">\n{{initiales(personne)}}</span><div class=\"off-personne__texte\"><div class=\"off-tab__nom\"><span \nng-if=\"aUnNom(personne)\">{{nomPersonne(personne)}}</span> <span class=\"off-fil__absent\" ng-if=\"!aUnNom(personne)\">\nNom non renseigné</span> <span class=\"off-cle off-cle--vous\" ng-if=\"estMoi(personne)\">vous</span></div><div \nclass=\"off-tab__mail\" ng-if=\"personne.mail\">{{personne.mail}}</div><div class=\"off-tab__mail off-tab__vide\" \nng-if=\"!personne.mail\">Aucun courriel</div></div></div></td><td><div class=\"off-acces\" ng-if=\"personne.acces\"><span \nclass=\"off-role\" \nng-class=\"{\n                          \'off-role--titulaire\': personne.acces === \'TITULAIRE\',\n                          \'off-role--praq\': personne.acces === \'PRAQ\',\n                          \'off-role--equipe\': personne.acces === \'EQUIPE\'}\">\n{{libelleAcces(personne.acces)}}</span><div ng-include=\"\'app/main/front/officine/acces/acces-compte.html\'\"></div></div>\n<span class=\"off-acces__aucun\" ng-if=\"!personne.acces\">Aucun accès</span></td><td><span \nng-if=\"personne.derniereConnexion\">{{dateCourte(personne.derniereConnexion)}}</span> <span class=\"off-tab__vide\" \nng-if=\"!personne.derniereConnexion\">—</span></td><td class=\"off-tab__colonne-gestes\"><div class=\"off-acces__gestes\" \nng-if=\"peutEcrire()\" ng-include=\"\'app/main/front/officine/acces/acces-gestes.html\'\"></div></td></tr><tr \nng-if=\"!personnesReferentiel.length\"><td colspan=\"4\" class=\"off-tab__vide-ligne\">\nAucune personne n\'est enregistrée pour votre officine.</td></tr></tbody></table></div></div><div \nclass=\"off-liste off-liste--orphelins\" ng-if=\"comptesOrphelins.length\"><div class=\"off-liste__alerte\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><div class=\"off-liste__alerte-texte\"><strong>\nComptes LQO sans personne rattachée</strong> <span>\nCes comptes ouvrent toujours votre officine. Créez la personne correspondante pour la rattacher à votre liste, ou transférez sa place à une personne de votre liste.\n</span></div><span class=\"off-bloc__compte off-bloc__compte--alerte\">{{comptesOrphelins.length}}</span></div><div \nclass=\"off-tab-cadre\"><table class=\"off-tab off-tab--aere\"><tbody><tr ng-repeat=\"personne in comptesOrphelins\"><td><div\n class=\"off-personne\"><span class=\"off-avatar\" aria-hidden=\"true\" \nng-class=\"{\n                          \'off-avatar--titulaire\': personne.acces === \'TITULAIRE\',\n                          \'off-avatar--praq\': personne.acces === \'PRAQ\',\n                          \'off-avatar--equipe\': personne.acces === \'EQUIPE\'}\">\n<md-icon class=\"s16\" md-font-icon=\"icon-key-variant\" ng-if=\"personne.acces === \'TITULAIRE\'\"></md-icon><md-icon \nclass=\"s16\" md-font-icon=\"icon-shield-outline\" ng-if=\"personne.acces === \'PRAQ\'\"></md-icon><md-icon class=\"s16\" \nmd-font-icon=\"icon-account-multiple\" ng-if=\"personne.acces === \'EQUIPE\'\"></md-icon><md-icon class=\"s16\" \nmd-font-icon=\"icon-account-alert\" ng-if=\"!personne.acces\"></md-icon></span><div class=\"off-personne__texte\"><div \nclass=\"off-tab__nom\"><span ng-if=\"personne.mail\">{{personne.mail}}</span> <span class=\"off-fil__absent\" \nng-if=\"!personne.mail\">Compte sans courriel</span> <span class=\"off-cle off-cle--vous\" ng-if=\"estMoi(personne)\">vous\n</span></div></div></div></td><td><span class=\"off-role\" ng-if=\"personne.acces\" \nng-class=\"{\n                        \'off-role--titulaire\': personne.acces === \'TITULAIRE\',\n                        \'off-role--praq\': personne.acces === \'PRAQ\',\n                        \'off-role--equipe\': personne.acces === \'EQUIPE\'}\">\n{{libelleAcces(personne.acces)}}</span></td><td ng-include=\"\'app/main/front/officine/acces/acces-compte.html\'\"></td>\n<td><span ng-if=\"personne.derniereConnexion\">{{dateCourte(personne.derniereConnexion)}}</span> <span \nclass=\"off-tab__vide\" ng-if=\"!personne.derniereConnexion\">—</span></td><td class=\"off-tab__colonne-gestes\"><div \nclass=\"off-acces__gestes\" ng-if=\"peutEcrire()\" ng-include=\"\'app/main/front/officine/acces/acces-gestes.html\'\"></div>\n</td></tr></tbody></table></div></div></div></div></section>");
$templateCache.put("app/main/front/officine/contact-phsq/contact-phsq.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Contacter PHSQ</a></div></div><div class=\"nl-Content off-content\"><off-navigation>\n</off-navigation><off-bandeau etat=\"app.officine.contact\"><off-bandeau-phrase>\nUne question sur votre officine, vos accès LQO ou une demande en cours&#8239;? L\'équipe PHSQ vous répond.\n</off-bandeau-phrase><off-bandeau-aide><p>\nPour quitter votre groupement ou la démarche qualité, préférez les formulaires <a ui-sref=\"app.officine.sortie\">\nSortie de groupement</a> et <a ui-sref=\"app.officine.sortieQualite\">Sortie de la démarche qualité</a>\n&#8239;: ils arrivent directement chez PHSQ, et vous en suivez l\'avancement dans <a ui-sref=\"app.officine.demandes\">\nMes demandes</a>.</p><p>\nPensez à indiquer le code CIP de votre officine&#8239;: il permet à PHSQ de retrouver votre dossier.</p>\n</off-bandeau-aide></off-bandeau><div ng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div \nclass=\"off-pile\" ng-if=\"etatEcran === \'normal\'\"><div class=\"off-contact-phsq\" ng-if=\"contact\"><a \nclass=\"off-contact-phsq__carte\" ng-if=\"contact.mail\" ng-href=\"mailto:{{contact.mail}}\"><span \nclass=\"off-contact-phsq__icone\"><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon></span><span \nclass=\"off-contact-phsq__texte\"><span class=\"off-micro\">Par courriel</span> <span class=\"off-contact-phsq__valeur\">\n{{contact.mail}}</span> </span></a><a class=\"off-contact-phsq__carte\" ng-if=\"contact.tel\" \nng-href=\"tel:{{telephoneComposable()}}\"><span class=\"off-contact-phsq__icone\"><md-icon md-font-icon=\"icon-phone\" \nclass=\"s24\"></md-icon></span><span class=\"off-contact-phsq__texte\"><span class=\"off-micro\">Par téléphone</span> <span \nclass=\"off-contact-phsq__valeur\">{{contact.tel}}</span></span></a></div><div class=\"off-vide off-vide--arrondi\" \nng-if=\"!contact\"><span class=\"off-vide__icone off-vide__icone--aide\"><md-icon md-font-icon=\"icon-phone\" class=\"s24\">\n</md-icon></span><div class=\"off-vide__titre\">Les coordonnées de PHSQ ne sont pas disponibles pour le moment</div><div \nclass=\"off-vide__texte\">Réessayez dans quelques instants.</div></div></div></div></section>");
$templateCache.put("app/main/front/officine/contacts/assignation.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"Donner un accès LQO\"><form name=\"formAcces\" novalidate ng-submit=\"valider()\">\n<div class=\"off-dialog__tete\"><button type=\"button\" class=\"off-dialog__fermer\" ng-click=\"fermer()\" aria-label=\"Fermer\">\n<md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div class=\"off-dialog__titre\">Donner un accès LQO\n</div><div class=\"off-dialog__sous\">{{nomPersonne}}<span ng-if=\"aUnNom\"> · {{personne.mail}}</span></div></div>\n<md-dialog-content class=\"off-dialog__corps\"><div class=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span>{{erreur}}</span></div><div \nclass=\"off-micro off-dialog__question\">Quel accès&#8239;?</div><div class=\"off-places\" role=\"radiogroup\" \naria-label=\"Quel accès\"><div class=\"off-place off-place--fermee\"><span class=\"off-place__radio\"></span> <span \nclass=\"off-place__corps\"><span class=\"off-place__entete\"><span class=\"off-role off-role--titulaire\">Titulaire</span> \n<span class=\"off-place__description\">Administrateur de l\'officine</span> </span><span \nclass=\"off-place__occupant off-place__occupant--avertissement\">\nOccupé par vous-même. Le céder se fait par «&#8239;Céder&#8239;», sur votre ligne, qui exige de désigner un remplaçant.\n</span></span></div><label class=\"off-place\" ng-repeat=\"place in places\" \nng-class=\"{\'off-place--choisie\': choix.slot === place.slot}\"><input type=\"radio\" class=\"off-sr\" name=\"slot\" \nng-model=\"choix.slot\" ng-value=\"place.slot\" ng-change=\"choisir(place)\"> <span class=\"off-place__radio\" \naria-hidden=\"true\"></span> <span class=\"off-place__corps\"><span class=\"off-place__entete\"><span class=\"off-role\" \nng-class=\"place.slot === \'PRAQ\' ? \'off-role--praq\' : \'off-role--equipe\'\">{{place.libelle}}</span> <span \nclass=\"off-place__description\">{{place.description}}</span> </span><span class=\"off-place__occupant\" \nng-if=\"place.occupant\">Occupé par {{nomDe(place.occupant)}}.</span> <span \nclass=\"off-place__occupant off-place__occupant--libre\" ng-if=\"!place.occupant\">Libre.</span></span></label></div><div \nclass=\"off-note off-note--or off-dialog__note\" ng-if=\"placeChoisie().occupant\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon><span><strong>\nLe compte {{placeChoisie().libelle}} de {{nomDe(placeChoisie().occupant)}} passe à {{nomPersonne}}.</strong>\n Il n\'existe qu\'un accès {{placeChoisie().libelle}} par officine&#8239;: le même compte prend le courriel de {{nomPersonne}}, qui recevra un lien pour créer son mot de passe, et {{nomDe(placeChoisie().occupant)}} ne pourra plus se connecter. Ce qui a été saisi avec ce compte reste sur le compte.\n</span></div><div class=\"off-champ off-dialog__note\"><div class=\"off-champ__label\">Courriel de connexion</div><div \nclass=\"off-input off-input--lecture\">{{personne.mail}}</div><div class=\"off-champ__aide\">\nC\'est ce courriel qui servira à se connecter. Ouvrir un accès envoie un courriel d\'activation à la personne.</div>\n</div></md-dialog-content><div class=\"off-dialog__actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" class=\"nl-Btn\" \nng-disabled=\"!choix.slot || envoi\">{{envoi ? \'Enregistrement…\' : libelleBouton()}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/officine/contacts/contacts.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Contacts</a></div></div><div class=\"nl-Content off-content\"><off-navigation>\n</off-navigation><off-bandeau etat=\"app.officine.contacts\"><off-bandeau-phrase>\nLes personnes de votre officine connues de PHSQ&#8239;: tenez-les à jour pour être joint par la bonne personne.\n</off-bandeau-phrase><off-bandeau-aide><p>Une personne ajoutée ou corrigée est <strong>\nenregistrée immédiatement sur votre fiche PHSQ</strong>. Le prénom et le nom sont exigés, le reste est facultatif.</p>\n<p>\nLe courriel d\'une personne ne se change pas une fois posé&#8239;: c\'est lui qui la relie à son compte LQO. Il se pose, en revanche, sur une personne qui n\'en a pas encore — saisi deux fois, pour éviter toute faute de frappe.\n</p><p>\nVous attribuez vous-même, en modifiant une personne, les rôles que PHSQ a ouverts (responsable qualité, référents…). Les autres rôles restent attribués par PHSQ.\n</p><p>L\'étoile désigne le <strong>contact principal</strong>\n, celui que PHSQ joint en priorité&#8239;: il lui faut un courriel. Pour retirer le contact principal, vous choisissez qui le remplace.\n</p><p>Une personne <strong>retirée</strong>\n n\'apparaît plus dans votre liste&#8239;; PHSQ la garde dans ses archives. Pour la faire revenir, ajoutez-la de nouveau avec son courriel&#8239;: sa fiche est retrouvée. Si elle a un accès Responsable Qualité ou Équipe, vous choisissez à qui le transférer en la retirant&#8239;; le titulaire, lui, cède d\'abord son titre.\n</p><p>Qui peut se connecter à LQO, et avec quel accès&#8239;: voyez <a ui-sref=\"app.officine.acces\">Accès LQO</a>.</p>\n</off-bandeau-aide><off-bandeau-actions><button type=\"button\" class=\"nl-Btn off-btn-bandeau\" \nng-if=\"peutEcrire() && etatEcran === \'normal\'\" ng-click=\"ouvrirPersonne(null, $event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Ajouter un contact</button></off-bandeau-actions></off-bandeau><div \nng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div class=\"off-pile\" \nng-if=\"etatEcran === \'normal\'\"><div class=\"off-liste\"><div class=\"off-liste__tete\"><span class=\"off-liste__titre\">\nPersonnes inscrites sur votre fiche PHSQ <span class=\"off-bloc__compte\">{{personnesReferentiel.length}}</span></span>\n</div><div class=\"off-tab-cadre\"><table class=\"off-tab off-tab--aere\"><thead><tr><th>Personne</th><th>Téléphone</th>\n<th>Rôles</th><th class=\"off-tab__colonne-gestes\"><span class=\"off-sr\">Actions</span></th></tr></thead><tbody><tr \nng-repeat=\"personne in personnesReferentiel\"><td><div class=\"off-personne\"><span class=\"off-avatar\" aria-hidden=\"true\">\n{{initiales(personne)}}</span><div class=\"off-personne__texte\"><div class=\"off-tab__nom\"><span \nng-if=\"aUnNom(personne)\">{{nomPersonne(personne)}}</span> <span class=\"off-fil__absent\" ng-if=\"!aUnNom(personne)\">\nNom non renseigné</span> <span class=\"off-cle off-cle--principal\" ng-if=\"personne.principal\">principal</span> <span \nclass=\"off-cle off-cle--vous\" ng-if=\"estMoi(personne)\">vous</span></div><div class=\"off-tab__mail\" \nng-if=\"personne.mail\">{{personne.mail}}</div><div class=\"off-tab__mail off-tab__vide\" ng-if=\"!personne.mail\">\nAucun courriel</div></div></div></td><td class=\"off-tab__telephones\"><div ng-if=\"personne.telephone\">\n{{personne.telephone}}</div><div class=\"off-tab__mail\" ng-if=\"personne.mobile\">{{personne.mobile}}</div><span \nclass=\"off-tab__vide\" ng-if=\"!personne.telephone && !personne.mobile\">—</span></td><td class=\"off-tab__roles\"><div \nclass=\"off-roles\" ng-if=\"personne.roles.length\"><span class=\"off-role\" ng-class=\"classeRole(role)\" \nng-repeat=\"role in personne.roles track by $index\">{{role}}</span></div><span class=\"off-tab__vide\" \nng-if=\"!personne.roles.length\">—</span></td><td class=\"off-tab__colonne-gestes\"><div \nclass=\"off-acces__gestes off-acces__gestes--seul\" ng-if=\"peutEcrire()\"><span \nclass=\"off-tab-crayon off-tab-crayon--principal off-tab-crayon--etat\" ng-if=\"personne.principal\" \naria-label=\"Contact principal\" role=\"img\"><md-icon md-font-icon=\"icon-star\" class=\"s14\"></md-icon><md-tooltip \nmd-direction=\"top\">Contact principal</md-tooltip></span><button type=\"button\" \nclass=\"off-tab-crayon off-tab-crayon--principal\" ng-if=\"!personne.principal\" \nng-class=\"{\'off-tab-crayon--inactif\': !personne.mail}\" aria-disabled=\"{{!personne.mail}}\" \nng-click=\"designerPrincipal(personne, $event)\" aria-label=\"Désigner comme contact principal\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"s14\"></md-icon><md-tooltip md-direction=\"top\">\n{{personne.mail ? \'Désigner comme contact principal\' : \'Ajoutez-lui d\\\'abord un courriel pour en faire le contact principal\'}}\n</md-tooltip></button> <button type=\"button\" class=\"off-tab-crayon\" ng-click=\"ouvrirPersonne(personne, $event)\" \naria-label=\"Modifier\"><md-icon md-font-icon=\"icon-pencil\" class=\"s14\"></md-icon><md-tooltip md-direction=\"top\">Modifier\n</md-tooltip></button> <button type=\"button\" class=\"off-tab-crayon off-tab-crayon--danger\" \nng-class=\"{\'off-tab-crayon--inactif\': !!raisonNonRetirable(personne)}\" \naria-disabled=\"{{!!raisonNonRetirable(personne)}}\" ng-click=\"retirerPersonne(personne, $event)\" \naria-label=\"Retirer de la liste\"><md-icon md-font-icon=\"icon-delete\" class=\"s14\"></md-icon><md-tooltip \nmd-direction=\"top\">{{raisonNonRetirable(personne) || \'Retirer de la liste\'}}</md-tooltip></button></div></td></tr><tr \nng-if=\"!personnesReferentiel.length\"><td colspan=\"4\" class=\"off-tab__vide-ligne\">\nAucune personne n\'est enregistrée pour votre officine.</td></tr></tbody></table></div></div></div></div></section>");
$templateCache.put("app/main/front/officine/contacts/nouveau-contact.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"{{modification ? \'Modifier un contact\' : \'Ajouter un contact\'}}\"><form \nname=\"formContact\" novalidate ng-submit=\"valider()\"><div class=\"off-dialog__tete\"><button type=\"button\" \nclass=\"off-dialog__fermer\" ng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\">\n</md-icon></button><div class=\"off-dialog__titre\">{{modification ? \'Modifier un contact\' : \'Ajouter un contact\'}}</div>\n<div class=\"off-dialog__sous\">{{fiche.nom}}<span ng-if=\"fiche.codeCip\"> · CIP {{fiche.codeCip}}</span></div></div>\n<md-dialog-content class=\"off-dialog__corps\"><div class=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span>{{erreur}}</span></div><div \nclass=\"off-formulaire off-formulaire--deux\"><div class=\"off-champ\"><label class=\"off-champ__label\" for=\"off-c-prenom\">\nPrénom <span class=\"off-asterisque\" ng-if=\"!modification\">*</span></label><input id=\"off-c-prenom\" class=\"off-input\" \ntype=\"text\" ng-model=\"saisie.prenom\" maxlength=\"255\" placeholder=\"Prénom\" \nng-class=\"{\'off-input--invalide\': manque(\'prenom\')}\" md-autofocus><div class=\"off-champ__erreur\" \nng-if=\"manque(\'prenom\') && !modification\">Information requise.</div></div><div class=\"off-champ\"><label \nclass=\"off-champ__label\" for=\"off-c-nom\">Nom <span class=\"off-asterisque\" ng-if=\"!modification\">*</span></label><input \nid=\"off-c-nom\" class=\"off-input\" type=\"text\" ng-model=\"saisie.nom\" maxlength=\"255\" placeholder=\"Nom\" \nng-class=\"{\'off-input--invalide\': manque(\'nom\')}\"><div class=\"off-champ__erreur\" \nng-if=\"manque(\'nom\') && !modification\">Information requise.</div><div class=\"off-champ__erreur\" \nng-if=\"manque(\'nom\') && modification\">Indiquez au moins un prénom ou un nom.</div></div><div \nclass=\"off-champ off-champ--large\"><label class=\"off-champ__label\" for=\"off-c-mail\">Courriel</label><input \nid=\"off-c-mail\" class=\"off-input\" type=\"text\" inputmode=\"email\" autocomplete=\"off\" autocapitalize=\"off\" \nspellcheck=\"false\" ng-model=\"saisie.mail\" placeholder=\"prenom.nom@exemple.fr\" ng-if=\"mailModifiable\" \nng-class=\"{\'off-input--invalide\': problemeMail() || erreurMail}\" aria-describedby=\"off-c-mail-aide\"><div \nclass=\"off-input off-input--lecture\" ng-if=\"!mailModifiable\">{{mailInitial}}</div><div class=\"off-champ__erreur\" \nrole=\"alert\" ng-if=\"problemeMail() || erreurMail\">{{problemeMail() || erreurMail}}</div><div \nclass=\"off-champ__suggestion\" ng-if=\"archiveRetrouve && !problemeMail()\"><md-icon md-font-icon=\"icon-restore\" \nclass=\"s14\"></md-icon><button type=\"button\" class=\"off-lien-bouton\" ng-click=\"faireRevenir()\" ng-disabled=\"envoi\">\nLa faire revenir dans votre liste</button></div><div class=\"off-champ__suggestion\" \nng-if=\"!problemeMail() && suggestionMail()\"><md-icon md-font-icon=\"icon-lightbulb-outline\" class=\"s14\"></md-icon><span>\nVouliez-vous dire <button type=\"button\" class=\"off-lien-bouton\" ng-click=\"appliquerSuggestion()\">{{suggestionMail()}}\n</button>&#8239;?</span></div><div class=\"off-champ__aide\" id=\"off-c-mail-aide\" ng-if=\"mailModifiable\">\nFacultatif — sans courriel, pas d\'accès LQO possible. <strong>\nVérifiez-le bien&#8239;: une fois enregistré, il ne pourra plus être modifié.</strong></div><div \nclass=\"off-champ__aide\" ng-if=\"!mailModifiable\">\nLe courriel ne se modifie pas&#8239;: c\'est lui qui rapproche la personne de son compte LQO. Pour le corriger, ajoutez la personne avec la bonne adresse, puis demandez à PHSQ de retirer l\'ancienne.\n</div></div><div class=\"off-champ off-champ--large\" ng-if=\"mailSaisi()\"><label class=\"off-champ__label\" \nfor=\"off-c-mail-bis\">Confirmez le courriel <span class=\"off-asterisque\">*</span></label><div \nclass=\"off-champ__avec-icone\"><input id=\"off-c-mail-bis\" class=\"off-input\" type=\"text\" inputmode=\"email\" \nautocomplete=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-model=\"saisie.mailConfirmation\" \nplaceholder=\"Saisissez-le une seconde fois\" ng-class=\"{\'off-input--invalide\': confirmationDifferente()}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16 off-champ__icone-ok\" ng-if=\"confirmationJuste()\" \naria-label=\"Les deux saisies correspondent\"></md-icon></div><div class=\"off-champ__erreur\" \nng-if=\"confirmationDifferente()\">Les deux saisies ne correspondent pas.</div></div><div class=\"off-champ\"><label \nclass=\"off-champ__label\" for=\"off-c-tel\">Téléphone</label><input id=\"off-c-tel\" class=\"off-input\" type=\"text\" \nng-model=\"saisie.telephone\" maxlength=\"30\" placeholder=\"03…\"></div><div class=\"off-champ\"><label \nclass=\"off-champ__label\" for=\"off-c-mobile\">Mobile</label><input id=\"off-c-mobile\" class=\"off-input\" type=\"text\" \nng-model=\"saisie.mobile\" maxlength=\"30\" placeholder=\"06…\"></div><div class=\"off-champ off-champ--large\" role=\"group\" \naria-labelledby=\"off-c-roles-titre\"><span class=\"off-champ__label\" id=\"off-c-roles-titre\">Rôles</span><div \nclass=\"off-champ__aide\" ng-if=\"!roles.charges && !roles.erreur\">Chargement des rôles…</div><div \nclass=\"off-champ__erreur\" ng-if=\"roles.erreur\">{{roles.erreur}}</div><div class=\"off-roles-choix\" \nng-if=\"roles.charges && roles.ouverts.length\"><label class=\"off-case\" \nng-repeat=\"role in roles.ouverts track by role.id\"><input type=\"checkbox\" ng-model=\"roles.coches[role.id]\"> <span>\n{{role.libelle}}<span class=\"off-case__detail\" ng-if=\"role.description\">{{role.description}}</span></span></label>\n</div><div class=\"off-champ__aide\" ng-if=\"roles.charges && !roles.ouverts.length\">\nAucun rôle ne s\'attribue depuis LQO pour le moment.</div><div class=\"off-champ__aide\" ng-if=\"roles.gardes.length\">\nAttribués par PHSQ&#8239;: {{roles.gardes.join(\', \')}}.</div></div></div><div class=\"off-note off-dialog__note\" \nng-if=\"!modification\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nAjouter une personne ne lui ouvre pas LQO. L\'accès se donne ensuite, depuis la liste, s\'il en reste un de disponible.\n</span></div><div class=\"off-note off-dialog__note\" ng-if=\"modification\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nLa correction est enregistrée directement sur votre fiche PHSQ&#8239;: PHSQ la voit aussitôt.</span></div>\n</md-dialog-content><div class=\"off-dialog__actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" class=\"nl-Btn\" ng-disabled=\"envoi\">\n{{envoi ? \'Enregistrement…\' : (modification ? \'Enregistrer\' : \'Ajouter le contact\')}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/officine/contacts/passation.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"Céder le titre de titulaire\"><form name=\"formPassation\" novalidate \nng-submit=\"valider()\" autocomplete=\"off\"><div class=\"off-dialog__tete\"><button type=\"button\" \nclass=\"off-dialog__fermer\" ng-click=\"fermer()\" aria-label=\"Fermer\" ng-if=\"!termine\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s20\"></md-icon></button><div class=\"off-dialog__titre\">Céder le titre de titulaire</div><div \nclass=\"off-dialog__sous\">{{fiche.nom}}<span ng-if=\"fiche.codeCip\"> · CIP {{fiche.codeCip}}</span></div></div>\n<md-dialog-content class=\"off-dialog__corps\"><div class=\"off-dialog__succes\" role=\"status\" ng-if=\"termine\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s20\"></md-icon><span>\nLe titre de titulaire est cédé à {{nomDe(resultat.successeur)}}. Votre session est fermée<span \nng-if=\"resultat.conserve\">&#8239;: reconnectez-vous pour retrouver votre accès {{libelle(resultat.conserve)}}.</span>\n<span ng-if=\"!resultat.conserve\"> et vous n\'avez plus accès à LQO.</span></span></div><div ng-if=\"!termine\"><div \nclass=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon>\n<span>{{erreur}}</span></div><div class=\"off-passation\"><div><div class=\"off-micro off-passation__etiquette\">\nTitulaire actuel</div><div class=\"off-passation__carte\"><div class=\"off-passation__nom\">{{nomDe(titulaire) || \'Vous\'}}\n</div><div class=\"off-passation__mail\" ng-if=\"aUnNom(titulaire)\">{{titulaire.mail}}</div><div \nclass=\"off-passation__perte\">Ne sera plus titulaire de cette officine</div></div></div><div><div \nclass=\"off-micro off-passation__etiquette\">Nouveau titulaire <span class=\"off-asterisque\">*</span></div><md-select \nclass=\"off-select\" ng-model=\"choix.contactId\" placeholder=\"Choisir parmi vos contacts\" aria-label=\"Nouveau titulaire\" \nmd-container-class=\"off-select-panneau\" ng-disabled=\"!successeurs.length\"><md-option ng-repeat=\"ligne in successeurs\" \nng-value=\"ligne.contactId\">{{nomDe(ligne)}}<span ng-if=\"aUnNom(ligne)\"> · {{ligne.mail}}</span></md-option></md-select>\n<div class=\"off-champ__erreur\" ng-if=\"tentative && !successeur()\">Choisissez le nouveau titulaire.</div><div \nclass=\"off-champ__aide\" ng-if=\"!successeurs.length\">\nAucune personne de votre liste n\'a de courriel&#8239;: ajoutez d\'abord votre successeur, avec son courriel.</div><div \nclass=\"off-champ__aide\" ng-if=\"successeur().acces\">Son accès {{libelle(successeur().acces)}} actuel sera libéré.</div>\n</div></div><div class=\"off-passation__consequence\" ng-if=\"successeur()\"><strong>\nVous ne serez plus titulaire de cette officine</strong><span ng-if=\"placeConservee()\">\n. Vous conserverez un accès {{libelle(placeConservee())}}, mais votre session sera fermée dès la confirmation&#8239;: vous devrez vous reconnecter.\n</span><span ng-if=\"placeConservee() === null\">\n, vous n\'aurez plus accès à LQO et votre session sera fermée dès la confirmation.</span></div><div \nclass=\"off-champ off-passation__mdp\"><label class=\"off-champ__label\" for=\"off-p-mdp\">\nVotre mot de passe, pour confirmer <span class=\"off-asterisque\">*</span></label><input id=\"off-p-mdp\" \nclass=\"off-input\" type=\"password\" ng-model=\"choix.motDePasse\" autocomplete=\"current-password\" \nng-class=\"{\'off-input--invalide\': manqueMotDePasse()}\"><div class=\"off-champ__erreur\" ng-if=\"manqueMotDePasse()\">\nInformation requise.</div></div><div class=\"off-note off-note--or off-dialog__note\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"s16\"></md-icon><span>\nCe geste est immédiat et vous ne pourrez pas le défaire vous-même. En cas d\'erreur, seul PHSQ pourra rétablir l\'accès depuis son administration.\n</span></div></div></md-dialog-content><div class=\"off-dialog__actions\" ng-if=\"!termine\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" \nclass=\"nl-Btn nl-Btn--danger\" ng-disabled=\"envoi || !successeurs.length\">\n{{envoi ? \'Cession…\' : \'Céder le titre de titulaire\'}}</button></div><div class=\"off-dialog__actions\" ng-if=\"termine\">\n<button type=\"button\" class=\"nl-Btn\" ng-click=\"revenirALaConnexion()\">Revenir à la connexion</button></div></form>\n</md-dialog>");
$templateCache.put("app/main/front/officine/contacts/retirer-contact.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"Retirer de la liste\"><form name=\"formRetrait\" novalidate \nng-submit=\"valider()\"><div class=\"off-dialog__tete\"><button type=\"button\" class=\"off-dialog__fermer\" \nng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div \nclass=\"off-dialog__titre\">Retirer de la liste</div><div class=\"off-dialog__sous\">{{nomPersonne}}<span \nng-if=\"aUnNom(personne) && personne.mail\"> · {{personne.mail}}</span></div></div><md-dialog-content \nclass=\"off-dialog__corps\"><div class=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span>{{erreur}}</span></div><p class=\"off-dialog__question\">\n<strong>{{nomPersonne}}</strong> n\'apparaîtra plus dans votre liste de contacts.</p><div class=\"off-champ\" \nng-if=\"principal\"><label class=\"off-champ__label\" id=\"off-r-remplacant\">\nC\'est votre contact principal&#8239;: qui le remplace&#8239;? <span class=\"off-asterisque\">*</span></label><md-select \nclass=\"off-select\" ng-model=\"choix.remplacantId\" placeholder=\"Choisir parmi vos contacts\" \naria-labelledby=\"off-r-remplacant\" md-container-class=\"off-select-panneau\" ng-disabled=\"!remplacants.length\"><md-option\n ng-repeat=\"ligne in remplacants\" ng-value=\"ligne.contactId\">{{nomDe(ligne)}}<span ng-if=\"aUnNom(ligne)\">\n · {{ligne.mail}}</span></md-option></md-select><div class=\"off-champ__erreur\" \nng-if=\"tentative && manqueRemplacant() && remplacants.length\">Choisissez le nouveau contact principal.</div><div \nclass=\"off-champ__aide\" ng-if=\"!remplacants.length\">\nAucune autre personne de votre liste n\'a de courriel&#8239;: ajoutez d\'abord celle qui deviendra le contact principal, avec son courriel.\n</div></div><div class=\"off-champ off-dialog__note\" ng-if=\"acces\"><label class=\"off-champ__label\" \nid=\"off-r-beneficiaire\">Son accès {{libelleAcces}} à LQO&#8239;: à qui le transférer&#8239;? <span \nclass=\"off-asterisque\">*</span></label><md-select class=\"off-select\" ng-model=\"choix.beneficiaireId\" \nplaceholder=\"Choisir parmi vos contacts\" aria-labelledby=\"off-r-beneficiaire\" md-container-class=\"off-select-panneau\" \nng-disabled=\"!beneficiaires.length\"><md-option ng-repeat=\"ligne in beneficiaires\" ng-value=\"ligne.contactId\">\n{{nomDe(ligne)}}<span ng-if=\"aUnNom(ligne)\"> · {{ligne.mail}}</span></md-option></md-select><div \nclass=\"off-champ__erreur\" ng-if=\"tentative && manqueBeneficiaire() && beneficiaires.length\">\nChoisissez la personne qui reçoit l\'accès.</div><div class=\"off-champ__aide\" ng-if=\"!beneficiaires.length\">\nAucune autre personne de votre liste n\'a de courriel&#8239;: ajoutez d\'abord celle qui reprendra l\'accès, avec son courriel.\n</div></div><div class=\"off-note off-note--or off-dialog__note\" ng-if=\"consequenceTransfert()\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span>{{consequenceTransfert()}}</span></div><div \nclass=\"off-note off-dialog__note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nPHSQ garde cette personne dans ses archives. Pour la faire revenir, ajoutez-la de nouveau avec son courriel&#8239;: sa fiche sera retrouvée.\n</span></div></md-dialog-content><div class=\"off-dialog__actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" class=\"nl-Btn nl-Btn--danger\" \nng-disabled=\"envoi || (principal && !remplacants.length) || (acces && !beneficiaires.length)\">\n{{envoi ? \'Retrait…\' : \'Retirer de la liste\'}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/officine/contacts/transfert-acces.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"Transférer l\'accès {{place.libelle}}\"><form name=\"formTransfert\" novalidate \nng-submit=\"valider()\"><div class=\"off-dialog__tete\"><button type=\"button\" class=\"off-dialog__fermer\" \nng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div \nclass=\"off-dialog__titre\">Transférer l\'accès {{place.libelle}}</div><div class=\"off-dialog__sous\">\nAujourd\'hui&#8239;: {{nomOccupant}}<span ng-if=\"aUnNom(place.occupant) && place.occupant.mail\">\n · {{place.occupant.mail}}</span></div></div><md-dialog-content class=\"off-dialog__corps\"><div \nclass=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon>\n<span>{{erreur}}</span></div><div class=\"off-champ\"><label class=\"off-champ__label\" id=\"off-t-beneficiaire\">\nÀ quelle personne de votre liste&#8239;? <span class=\"off-asterisque\">*</span></label><md-select class=\"off-select\" \nng-model=\"choix.contactId\" placeholder=\"Choisir parmi vos contacts\" aria-labelledby=\"off-t-beneficiaire\" \nmd-container-class=\"off-select-panneau\" ng-disabled=\"!beneficiaires.length\"><md-option \nng-repeat=\"ligne in beneficiaires\" ng-value=\"ligne.contactId\">{{nomDe(ligne)}}<span ng-if=\"aUnNom(ligne)\">\n · {{ligne.mail}}</span></md-option></md-select><div class=\"off-champ__erreur\" \nng-if=\"tentative && !beneficiaire() && beneficiaires.length\">Choisissez la personne qui reçoit l\'accès.</div><div \nclass=\"off-champ__aide\" ng-if=\"!beneficiaires.length\">\nAucune autre personne de votre liste n\'a de courriel&#8239;: ajoutez d\'abord celle qui reprendra l\'accès, avec son courriel.\n</div></div><div class=\"off-note off-note--or off-dialog__note\" ng-if=\"consequence()\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"s16\"></md-icon><span>{{consequence()}}</span></div></md-dialog-content><div \nclass=\"off-dialog__actions\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"fermer()\" \nng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" class=\"nl-Btn\" ng-disabled=\"envoi || !beneficiaires.length\">\n{{envoi ? \'Transfert…\' : \'Transférer l\\\'accès\'}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/officine/demandes/demandes.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Mes demandes</a></div></div><div class=\"nl-Content off-content\"><off-navigation>\n</off-navigation><off-bandeau etat=\"app.officine.demandes\"><off-bandeau-phrase>\nVos demandes adressées à PHSQ — sortie de groupement, sortie de la démarche qualité — et leur avancement.\n</off-bandeau-phrase><off-bandeau-aide><p>\nUne demande passe par trois étapes&#8239;: transmise, prise en charge par PHSQ, puis traitée. Tant que personne chez PHSQ ne l\'a prise en charge, vous pouvez la retirer.\n</p><p>\nSi PHSQ refuse une demande, le motif et son message s\'affichent ici&#8239;; vous pouvez alors en déposer une nouvelle.\n</p><p>Une demande déposée par votre groupement ou par PHSQ apparaît sans le détail&#8239;: pour en savoir plus, <a \nui-sref=\"app.officine.contact\">contactez PHSQ</a>.</p><p>\nLes deux demandes sont indépendantes&#8239;: une sortie de groupement ne vous fait pas quitter la démarche qualité, et inversement.\n</p></off-bandeau-aide></off-bandeau><div class=\"off-confirmation\" role=\"status\" ng-if=\"confirmation\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon><span class=\"off-alerte__texte\">{{confirmation}}</span> <button \ntype=\"button\" class=\"off-alerte__fermer\" ng-click=\"fermerConfirmation()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div><div \nng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div class=\"off-demandes\" \nng-if=\"etatEcran === \'normal\'\"><section class=\"off-bloc off-demande off-demandes__colonne\" \naria-labelledby=\"off-demande-groupement\"><div class=\"off-bloc__titre\"><h2 class=\"off-bloc__intitule\" \nid=\"off-demande-groupement\"><span class=\"off-bloc__icone off-bloc__icone--demarches\"><md-icon \nmd-font-icon=\"icon-sitemap\" class=\"s16\"></md-icon></span>Sortie de groupement</h2><span \nclass=\"off-pastille {{pastilleGroupement().classe}}\" ng-if=\"pastilleGroupement()\"><span class=\"off-point\"></span>\n{{pastilleGroupement().libelle}}</span></div><div class=\"off-demande__corps\" ng-if=\"etatGroupement() !== \'A\'\" \nng-include=\"\'app/main/front/officine/demandes/suivi-sortie-groupement.html\'\"></div><div class=\"off-demande__corps\" \nng-if=\"etatGroupement() === \'A\'\"><div class=\"off-demande__etat off-vide off-vide--interne\"><span \nclass=\"off-vide__icone\"><md-icon md-font-icon=\"icon-sitemap\" class=\"s24\"></md-icon></span><div class=\"off-vide__titre\">\nAucune sortie de groupement en cours</div><div class=\"off-vide__texte\">\nSi vous quittez votre groupement {{nomGroupement()}}, déclarez-le&#8239;: PHSQ traitera votre déclaration et prendra contact avec vous.\n</div><button type=\"button\" class=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-if=\"peutEcrire()\" \nui-sref=\"app.officine.sortie\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon>Déclarer une sortie de groupement\n</button></div></div></section><section class=\"off-bloc off-demande off-demandes__colonne\" \naria-labelledby=\"off-demande-qualite\"><div class=\"off-bloc__titre\"><h2 class=\"off-bloc__intitule\" \nid=\"off-demande-qualite\"><span class=\"off-bloc__icone off-bloc__icone--demarches\"><md-icon md-font-icon=\"icon-ribbon\" \nclass=\"s16\"></md-icon></span>Sortie de la démarche qualité</h2><span class=\"off-pastille {{pastilleQualite().classe}}\" \nng-if=\"pastilleQualite()\"><span class=\"off-point\"></span>{{pastilleQualite().libelle}}</span></div><div \nclass=\"off-demande__corps\" ng-if=\"etatQualite() !== \'aucune\'\" \nng-include=\"\'app/main/front/officine/demandes/suivi-sortie-qualite.html\'\"></div><div class=\"off-demande__corps\" \nng-if=\"etatQualite() === \'aucune\'\"><div class=\"off-demande__etat off-vide off-vide--interne\"><span \nclass=\"off-vide__icone\"><md-icon md-font-icon=\"icon-ribbon\" class=\"s24\"></md-icon></span><div class=\"off-vide__titre\">\nAucune sortie de la démarche qualité en cours</div><div class=\"off-vide__texte\">\nSi votre officine quitte la démarche qualité PHSQ, formalisez votre demande&#8239;: PHSQ la traitera et pourra vous recontacter.\n</div><button type=\"button\" class=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-if=\"peutEcrire()\" \nui-sref=\"app.officine.sortieQualite\"><md-icon md-font-icon=\"icon-open-in-new\"></md-icon>\nDemander la sortie de la démarche qualité</button></div></div></section></div></div></section>");
$templateCache.put("app/main/front/officine/demandes/sortie-qualite-recap.html","<div class=\"off-qrecap\"><div class=\"off-qrecap__ligne\"><span class=\"off-sortie__etiquette\">Raisons de la sortie</span>\n<ul class=\"off-qrecap__raisons\" ng-if=\"sortieQualite.raisons.length\"><li \nng-repeat=\"raison in sortieQualite.raisons track by $index\">{{raison}}</li></ul><div \nclass=\"off-sortie__valeur off-fil__absent\" ng-if=\"!sortieQualite.raisons.length\">Non précisées</div></div><div \nclass=\"off-qrecap__duo\"><div><span class=\"off-sortie__etiquette\">Date effective souhaitée</span><div \nclass=\"off-sortie__valeur\" ng-if=\"sortieQualite.dateSouhaitee\">{{dateIso(sortieQualite.dateSouhaitee)}}</div><div \nclass=\"off-sortie__valeur off-fil__absent\" ng-if=\"!sortieQualite.dateSouhaitee\">Non précisée</div></div><div><span \nclass=\"off-sortie__etiquette\">Recommandation</span><div class=\"off-sortie__valeur\" \nng-if=\"sortieQualite.nps !== null && sortieQualite.nps !== undefined\"><strong>{{sortieQualite.nps}}</strong> / 10</div>\n<div class=\"off-sortie__valeur off-fil__absent\" ng-if=\"sortieQualite.nps === null || sortieQualite.nps === undefined\">\nNon renseignée</div></div></div><div class=\"off-qrecap__ligne\" ng-if=\"sortieQualite.commentaires\"><span \nclass=\"off-sortie__etiquette\">Vos suggestions d\'amélioration / commentaires</span><div class=\"off-sortie__valeur\">\n{{sortieQualite.commentaires}}</div></div><div class=\"off-qrecap__ligne\" ng-if=\"sortieQualite.engagements\"><span \nclass=\"off-sortie__etiquette\">Engagements et validation</span><ul class=\"off-qrecap__engagements\"><li \nng-if=\"sortieQualite.engagements.charteAccepteeLe\"><md-icon md-font-icon=\"icon-check\" class=\"s14\"></md-icon><span>\n<strong>Charte de sortie de la certification ISO 9001 QMS-Pharma®</strong>\n — le {{dateHeure(sortieQualite.engagements.charteAccepteeLe)}}</span></li><li \nng-if=\"sortieQualite.engagements.communicationRetireeLe\"><md-icon md-font-icon=\"icon-check\" class=\"s14\"></md-icon>\n<span><strong>Charte de communication PHSQ et Bureau Veritas</strong>\n — le {{dateHeure(sortieQualite.engagements.communicationRetireeLe)}}</span></li><li \nng-if=\"sortieQualite.engagements.clotureLqoAccepteeLe\"><md-icon md-font-icon=\"icon-check\" class=\"s14\"></md-icon><span>\n<strong>LQO Premium</strong> — le {{dateHeure(sortieQualite.engagements.clotureLqoAccepteeLe)}}</span></li><li \nng-if=\"sortieQualite.engagements.valideeLe\"><md-icon md-font-icon=\"icon-check\" class=\"s14\"></md-icon><span><strong>\nDemande validée</strong> le {{dateHeure(sortieQualite.engagements.valideeLe)}}<span \nng-if=\"sortieQualite.engagements.valideePar\">, par {{sortieQualite.engagements.valideePar}}</span></span></li></ul>\n</div></div>");
$templateCache.put("app/main/front/officine/demandes/sortie-recap.html","<div class=\"off-sortie__trajet\"><div class=\"off-sortie__groupement\"><span class=\"off-sortie__etiquette\">\nGroupement actuel</span> <span class=\"off-sortie__nom\">{{nomGroupement()}}</span></div><span \nclass=\"off-sortie__fleche\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16\"></md-icon></span>\n<div class=\"off-sortie__groupement off-sortie__groupement--destination\"><span class=\"off-sortie__etiquette\">\nGroupement de destination</span> <span class=\"off-sortie__nom\" ng-if=\"sortie.destination\">{{sortie.destination}}</span>\n<span class=\"off-sortie__nom\" ng-if=\"!sortie.destination && sortie.destinationInconnue\">Je ne sais pas encore</span> \n<span class=\"off-sortie__nom off-fil__absent\" ng-if=\"!sortie.destination && !sortie.destinationInconnue\">Non précisé\n</span></div></div><div class=\"off-sortie__details\"><div><span class=\"off-sortie__etiquette\">Motif</span><div \nclass=\"off-sortie__valeur\" ng-if=\"sortie.motif\">{{sortie.motif}}</div><div class=\"off-sortie__valeur off-fil__absent\" \nng-if=\"!sortie.motif\">Non précisé</div></div><div ng-if=\"sortie.precisions\"><span class=\"off-sortie__etiquette\">\nPrécisions</span><div class=\"off-sortie__valeur\">{{sortie.precisions}}</div></div></div>");
$templateCache.put("app/main/front/officine/demandes/suivi-sortie-groupement.html","<div class=\"off-demande__etat\" ng-if=\"etatGroupement() === \'suivi\'\"><div class=\"off-demande__contenu\"><ol \nclass=\"off-etapes\"><li class=\"off-etape off-etape--faite\"><span class=\"off-etape__pastille\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s14\"></md-icon></span><span class=\"off-etape__titre\">Déclaration déposée</span> <span \nclass=\"off-etape__detail\">le {{dateLongue(sortie.deposeeLe)}}<span ng-if=\"sortie.deposeePar\">,<br>\npar {{sortie.deposeePar}}</span></span></li><li class=\"off-etape\" \nng-class=\"priseEnCharge() ? \'off-etape--faite\' : \'off-etape--courante\'\"><span class=\"off-etape__pastille\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s14\" ng-if=\"priseEnCharge()\"></md-icon><span ng-if=\"!priseEnCharge()\">2</span> </span>\n<span class=\"off-etape__titre\">Prise en charge par PHSQ</span> <span class=\"off-etape__detail\" \nng-if=\"sortie.priseEnChargeLe\">le {{dateLongue(sortie.priseEnChargeLe)}}</span> <span class=\"off-etape__detail\" \nng-if=\"!sortie.priseEnChargeLe\">{{priseEnCharge() ? \'En cours\' : \'En attente\'}}</span></li><li class=\"off-etape\" \nng-class=\"priseEnCharge() ? \'off-etape--courante\' : \'off-etape--a-venir\'\"><span class=\"off-etape__pastille\">3</span> \n<span class=\"off-etape__titre\">Rattachement modifié</span> <span class=\"off-etape__detail\">\npar PHSQ, à la fin du traitement</span></li></ol><div class=\"off-sortie__recap\" \nng-include=\"\'app/main/front/officine/demandes/sortie-recap.html\'\"></div><div class=\"off-sortie__pied\" \nng-if=\"sortie.retraitPossible\"><span class=\"off-texte-petit\">\nPersonne chez PHSQ n\'a encore pris en charge votre déclaration&#8239;: vous pouvez la retirer.</span> <button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline off-btn-retrait\" ng-if=\"peutEcrire()\" \nng-click=\"retirerDeclaration($event)\" ng-disabled=\"retrait.groupement\"><md-icon md-font-icon=\"icon-close\"></md-icon>\nAnnuler ma déclaration</button></div></div><div class=\"off-sortie__note\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span ng-if=\"sortie.retraitPossible\">\nTant que la demande est ouverte, vous ne pouvez pas en déposer une seconde. Votre rattachement reste {{nomGroupement()}} jusqu\'à ce que PHSQ le modifie.\n</span> <span ng-if=\"!sortie.retraitPossible\">\nVotre déclaration est prise en charge&#8239;: elle ne peut plus être retirée depuis LQO. Pour revenir dessus, contactez PHSQ. Votre rattachement reste {{nomGroupement()}} jusqu\'à ce que PHSQ le modifie.\n</span></div></div><div class=\"off-demande__etat\" ng-if=\"etatGroupement() === \'E\'\"><div class=\"off-demande__contenu\">\n<ol class=\"off-etapes\"><li class=\"off-etape off-etape--faite\"><span class=\"off-etape__pastille\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s14\"></md-icon></span><span class=\"off-etape__titre\">Déclaration déposée</span> <span \nclass=\"off-etape__detail\">le {{dateLongue(sortie.deposeeLe)}}<span ng-if=\"sortie.deposeePar\">,<br>\npar {{sortie.deposeePar}}</span></span></li><li class=\"off-etape off-etape--refusee\"><span class=\"off-etape__pastille\">\n<md-icon md-font-icon=\"icon-close\" class=\"s14\"></md-icon></span><span class=\"off-etape__titre\">Refusée par PHSQ</span> \n<span class=\"off-etape__detail\" ng-if=\"sortie.refus.le\">le {{dateLongue(sortie.refus.le)}}</span></li><li \nclass=\"off-etape off-etape--a-venir\"><span class=\"off-etape__pastille\">3</span> <span class=\"off-etape__titre\">\nRattachement inchangé</span> <span class=\"off-etape__detail\">vous restez chez {{nomGroupement()}}</span></li></ol><div \nclass=\"off-note off-note--refus off-sortie__refus\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon>\n<span><strong>PHSQ n\'a pas donné suite à votre déclaration</strong><span ng-if=\"sortie.refus.le\">\n, le {{dateLongue(sortie.refus.le)}}</span>. <span class=\"off-note__ligne\" ng-if=\"sortie.refus.motif\">Motif&#8239;: \n<strong>{{sortie.refus.motif}}</strong>.</span> <span class=\"off-note__ligne\" ng-if=\"sortie.refus.message\">\n«&#8239;{{sortie.refus.message}}&#8239;»</span></span></div><div class=\"off-sortie__etiquette off-sortie__rappel\">\nCe que vous aviez déclaré</div><div class=\"off-sortie__recap off-sortie__recap--passe\" \nng-include=\"\'app/main/front/officine/demandes/sortie-recap.html\'\"></div><div class=\"off-sortie__pied\" \nng-if=\"!fiche.sansGroupement\"><span class=\"off-texte-petit\">\nVous pouvez déposer une nouvelle déclaration&#8239;; celle-ci restera dans votre historique.</span> <button \ntype=\"button\" class=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-if=\"peutEcrire()\" ng-click=\"declarer()\"><md-icon \nmd-font-icon=\"icon-open-in-new\"></md-icon>Déclarer une sortie de groupement</button></div></div><div \nclass=\"off-sortie__note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nUn refus ne ferme rien&#8239;: votre rattachement reste {{nomGroupement()}}, et vous pouvez redéclarer votre sortie quand vous le souhaitez. Pour en discuter, contactez PHSQ.\n</span></div></div><div class=\"off-demande__etat off-vide off-vide--interne\" ng-if=\"etatGroupement() === \'B\'\"><span \nclass=\"off-vide__icone\"><md-icon md-font-icon=\"icon-sitemap\" class=\"s24\"></md-icon></span><div class=\"off-vide__titre\">\nAucune sortie de groupement en cours</div><div class=\"off-vide__texte\" ng-if=\"sortieTraitee()\">\nVotre sortie de {{sortie.groupementQuitte}} a été traitée par PHSQ<span ng-if=\"sortie.traiteeLe\"> le <strong>\n{{dateLongue(sortie.traiteeLe)}}</strong></span>.</div><div class=\"off-vide__texte\">\nVous n\'êtes plus rattachée à un groupement&#8239;: il n\'y a donc rien à déclarer ici. Si vous rejoignez un groupement, c\'est lui qui vous y inscrit auprès de PHSQ.\n</div></div><div class=\"off-demande__etat off-vide off-vide--interne\" ng-if=\"etatGroupement() === \'F\'\"><span \nclass=\"off-vide__icone\"><md-icon md-font-icon=\"icon-sitemap\" class=\"s24\"></md-icon></span><div class=\"off-vide__titre\">\nUne déclaration de sortie est en cours de traitement pour votre officine</div><div class=\"off-vide__texte\">\nPour en connaître le détail, contactez PHSQ.</div></div>");
$templateCache.put("app/main/front/officine/demandes/suivi-sortie-qualite.html","<div class=\"off-demande__etat\" ng-if=\"qualiteDetaillee()\"><div class=\"off-demande__contenu\"><ol class=\"off-etapes\" \nng-if=\"etatQualite() !== \'annulee\'\"><li class=\"off-etape off-etape--faite\"><span class=\"off-etape__pastille\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s14\"></md-icon></span><span class=\"off-etape__titre\">Demande transmise</span> <span \nclass=\"off-etape__detail\">le {{dateLongue(sortieQualite.deposeeLe)}}<span ng-if=\"sortieQualite.deposeePar\">,<br>\npar {{sortieQualite.deposeePar}}</span></span></li><li class=\"off-etape\" \nng-class=\"qualitePriseEnCharge() ? \'off-etape--faite\' : \'off-etape--courante\'\"><span class=\"off-etape__pastille\">\n<md-icon md-font-icon=\"icon-check\" class=\"s14\" ng-if=\"qualitePriseEnCharge()\"></md-icon><span \nng-if=\"!qualitePriseEnCharge()\">2</span> </span><span class=\"off-etape__titre\">Prise en charge par PHSQ</span> <span \nclass=\"off-etape__detail\" ng-if=\"sortieQualite.priseEnChargeLe\">le {{dateLongue(sortieQualite.priseEnChargeLe)}}</span>\n <span class=\"off-etape__detail\" ng-if=\"!sortieQualite.priseEnChargeLe\">\n{{qualitePriseEnCharge() ? \'Faite\' : \'En attente\'}}</span></li><li class=\"off-etape\" \nng-class=\"{\n            \'off-etape--faite\': etatQualite() === \'traitee\',\n            \'off-etape--refusee\': etatQualite() === \'refusee\',\n            \'off-etape--courante\': etatQualite() === \'suivi\' && qualitePriseEnCharge(),\n            \'off-etape--a-venir\': etatQualite() === \'suivi\' && !qualitePriseEnCharge()}\">\n<span class=\"off-etape__pastille\"><md-icon md-font-icon=\"icon-check\" class=\"s14\" ng-if=\"etatQualite() === \'traitee\'\">\n</md-icon><md-icon md-font-icon=\"icon-close\" class=\"s14\" ng-if=\"etatQualite() === \'refusee\'\"></md-icon><span \nng-if=\"etatQualite() === \'suivi\'\">3</span> </span><span class=\"off-etape__titre\" ng-if=\"etatQualite() !== \'refusee\'\">\nSortie effective</span> <span class=\"off-etape__titre\" ng-if=\"etatQualite() === \'refusee\'\">Refusée par PHSQ</span> \n<span class=\"off-etape__detail\" ng-if=\"etatQualite() === \'suivi\'\">à la validation complète de votre demande par PHSQ\n</span> <span class=\"off-etape__detail\" ng-if=\"etatQualite() === \'traitee\' && sortieQualite.traiteeLe\">\nle {{dateLongue(sortieQualite.traiteeLe)}}</span> <span class=\"off-etape__detail\" \nng-if=\"etatQualite() === \'refusee\' && sortieQualite.refus.le\">le {{dateLongue(sortieQualite.refus.le)}}</span></li>\n</ol><div class=\"off-note off-note--refus off-sortie__refus\" ng-if=\"etatQualite() === \'refusee\'\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span><strong>PHSQ n\'a pas donné suite à votre demande</strong>\n<span ng-if=\"sortieQualite.refus.le\">, le {{dateLongue(sortieQualite.refus.le)}}</span>. <span class=\"off-note__ligne\" \nng-if=\"sortieQualite.refus.motif\">Motif&#8239;: <strong>{{sortieQualite.refus.motif}}</strong>.</span> <span \nclass=\"off-note__ligne\" ng-if=\"sortieQualite.refus.message\">«&#8239;{{sortieQualite.refus.message}}&#8239;»</span>\n</span></div><div class=\"off-sortie__texte\" ng-if=\"etatQualite() === \'annulee\'\">Votre demande transmise le <strong>\n{{dateLongue(sortieQualite.deposeeLe)}}</strong> a été annulée&#8239;: elle ne sera pas traitée.</div><div \nclass=\"off-sortie__etiquette off-sortie__rappel\" ng-if=\"etatQualite() !== \'suivi\'\">Ce que vous aviez demandé</div><div \nclass=\"off-sortie__recap\" ng-class=\"{\'off-sortie__recap--passe\': etatQualite() !== \'suivi\'}\" \nng-include=\"\'app/main/front/officine/demandes/sortie-qualite-recap.html\'\"></div><div class=\"off-sortie__pied\" \nng-if=\"etatQualite() === \'suivi\' && sortieQualite.retraitPossible\"><span class=\"off-texte-petit\">\nPersonne chez PHSQ n\'a encore pris en charge votre demande&#8239;: vous pouvez la retirer.</span> <button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline off-btn-retrait\" ng-if=\"peutEcrire()\" \nng-click=\"retirerDemandeQualite($event)\" ng-disabled=\"retrait.qualite\"><md-icon md-font-icon=\"icon-close\"></md-icon>\nRetirer ma demande</button></div><div class=\"off-sortie__pied\" ng-if=\"etatQualite() !== \'suivi\' && peutEcrire()\"><span \nclass=\"off-texte-petit\">\nCette demande est close&#8239;: vous pouvez en déposer une nouvelle si votre situation a changé.</span> <button \ntype=\"button\" class=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-click=\"demanderSortieQualite()\"><md-icon \nmd-font-icon=\"icon-open-in-new\"></md-icon>Déposer une nouvelle demande</button></div></div><div \nclass=\"off-sortie__note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span \nng-if=\"etatQualite() === \'suivi\' && sortieQualite.retraitPossible\">\nTant que la demande est ouverte, vous ne pouvez pas en déposer une seconde. La date effective de sortie sera prise en compte à compter de la validation complète de votre demande par nos équipes.\n</span> <span ng-if=\"etatQualite() === \'suivi\' && !sortieQualite.retraitPossible\">\nVotre demande est prise en charge&#8239;: elle ne peut plus être retirée depuis LQO. Vous êtes susceptible d\'être recontacté·e par un membre de PHSQ afin de valider ou préciser certains éléments.\n</span> <span ng-if=\"etatQualite() === \'refusee\'\">\nUn refus ne ferme rien&#8239;: votre officine reste dans la démarche qualité. Pour en discuter, contactez PHSQ.</span> \n<span ng-if=\"etatQualite() === \'traitee\'\">\nPHSQ a traité votre demande de sortie. Pour toute question sur la clôture de vos accès ou de votre certification, contactez PHSQ.\n</span> <span ng-if=\"etatQualite() === \'annulee\'\">Une demande annulée ne change rien à votre démarche qualité.</span>\n</div></div><div class=\"off-demande__etat off-vide off-vide--interne\" ng-if=\"etatQualite() === \'tiers\'\"><span \nclass=\"off-vide__icone\"><md-icon md-font-icon=\"icon-ribbon\" class=\"s24\"></md-icon></span><div class=\"off-vide__titre\">\nUne demande de sortie de la démarche qualité est en cours de traitement pour votre officine</div><div \nclass=\"off-vide__texte\">Elle a été déposée par <span ng-if=\"sortieQualite.origine === \'GROUPEMENT\'\">votre groupement\n</span><span ng-if=\"sortieQualite.origine !== \'GROUPEMENT\'\">PHSQ</span>. Pour en connaître le détail, contactez PHSQ.\n</div></div>");
$templateCache.put("app/main/front/officine/en-tete/bandeau.html","<header class=\"off-bandeau off-bandeau--{{rubrique.couleur}}\"><div class=\"off-bandeau__corps\"><span \nclass=\"off-bandeau__icone\" aria-hidden=\"true\"><md-icon md-svg-src=\"{{rubrique.icone}}\"></md-icon></span><div \nclass=\"off-bandeau__texte\"><h1 class=\"off-bandeau__titre\">{{rubrique.libelle}}</h1><div class=\"off-bandeau__phrase\" \nng-transclude=\"phrase\"></div></div><div class=\"off-bandeau__outils\" ng-if=\"avecActions || avecAide\"><div \nclass=\"off-bandeau__actions\" ng-if=\"avecActions\" ng-transclude=\"actions\"></div><button type=\"button\" \nclass=\"off-bandeau__bouton-aide\" ng-if=\"avecAide\" ng-click=\"basculerAide()\" \nng-class=\"{\'off-bandeau__bouton-aide--ouvert\': aide.ouverte}\" aria-expanded=\"{{aide.ouverte}}\" \naria-controls=\"{{idAide}}\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon>En savoir plus\n</button></div></div><div ng-if=\"avecAide && aide.ouverte\"><section class=\"off-bandeau__aide\" id=\"{{idAide}}\" \naria-label=\"Bon à savoir\"><div class=\"off-bandeau__aide-tete\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16\"></md-icon><span class=\"off-bandeau__aide-titre\">Bon à savoir</span> <button type=\"button\" \nclass=\"off-bandeau__aide-fermer\" ng-click=\"basculerAide()\" aria-label=\"Fermer l\'aide\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div><div class=\"off-bandeau__aide-corps\" \nng-transclude=\"aide\"></div></section></div></header>");
$templateCache.put("app/main/front/officine/en-tete/navigation.html","<nav class=\"off-navigation\" aria-label=\"Rubriques de Mon officine\"><ul class=\"off-navigation__section\" \nng-repeat=\"section in sections track by section.id\"><li \nng-repeat=\"rubrique in section.rubriques track by rubrique.etat\"><a \nclass=\"doc-card doc-card--{{section.couleur}} off-mini-tuile\" ui-state=\"rubrique.etat\" \nng-class=\"{\'doc-card--active\': estCourante(rubrique.etat)}\" \nng-attr-aria-current=\"{{estCourante(rubrique.etat) ? \'page\' : undefined}}\"><md-icon md-svg-src=\"{{rubrique.icone}}\" \naria-hidden=\"true\"></md-icon><span class=\"off-mini-tuile__libelle\">{{rubrique.libelle}}</span> <span \nclass=\"off-tuile__pastille\" ng-if=\"rubrique.demandes && demandesEnCours()\" \naria-label=\"{{demandesEnCours() > 1 ? demandesEnCours() + \' demandes en cours\' : \'1 demande en cours\'}}\">\n{{demandesEnCours()}}</span></a></li></ul></nav>");
$templateCache.put("app/main/front/officine/etats/etats-ecran.html","<div class=\"off-chargement\" ng-if=\"etatEcran === \'chargement\'\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><span>Chargement…</span></div><div ng-if=\"etatEcran === \'indisponible\'\" \nng-include=\"\'app/main/front/officine/etats/indisponible.html\'\"></div><div ng-if=\"etatEcran === \'non_rapprochee\'\" \nng-include=\"\'app/main/front/officine/etats/non-rapprochee.html\'\"></div><div class=\"off-etat\" \nng-if=\"etatEcran === \'erreur\'\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s40 off-etat__icone\"></md-icon><div \nclass=\"off-etat__titre\">{{titreErreur || \"Cette page n\'a pas pu s\'afficher\"}}</div><div class=\"off-etat__texte\">\n{{erreur.message}}</div><button type=\"button\" class=\"nl-Btn off-etat__bouton\" ng-click=\"reessayer()\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon>Réessayer</button></div>");
$templateCache.put("app/main/front/officine/etats/indisponible.html","<div class=\"off-etat\"><md-icon md-font-icon=\"icon-cloud-outline-off\" class=\"s40 off-etat__icone\"></md-icon><div \nclass=\"off-etat__titre\">Données momentanément indisponibles</div><div class=\"off-etat__texte\">\nLes informations de votre fiche PHSQ sont momentanément indisponibles. <strong>Le reste de LQO fonctionne normalement\n</strong>, et «&#8239;Paramètres du compte&#8239;» reste accessible pour votre mot de passe.</div><button \ntype=\"button\" class=\"nl-Btn off-etat__bouton\" ng-click=\"reessayer()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\nRéessayer</button><div class=\"off-etat__aide\">Si l\'écran reste indisponible plusieurs heures, signalez-le à PHSQ<span \nng-if=\"contact.tel\"> au {{contact.tel}}</span>.</div></div>");
$templateCache.put("app/main/front/officine/etats/non-rapprochee.html","<div class=\"off-etat off-etat--large\"><md-icon md-font-icon=\"icon-link-variant-off\" class=\"s40 off-etat__icone\">\n</md-icon><div class=\"off-etat__titre\" ng-if=\"rapprochement.motif !== \'archivee\'\">\nVotre officine n\'est pas encore reliée à sa fiche PHSQ</div><div class=\"off-etat__titre\" \nng-if=\"rapprochement.motif === \'archivee\'\">La fiche PHSQ de votre officine est archivée</div><div \nclass=\"off-etat__texte\">Code CIP enregistré dans LQO&#8239;: <strong>{{rapprochement.codeCip || \'non renseigné\'}}\n</strong>. <span ng-if=\"rapprochement.motif !== \'archivee\'\">Contactez PHSQ pour rattacher votre officine.</span> <span \nng-if=\"rapprochement.motif === \'archivee\'\">Contactez PHSQ pour la réactiver.</span></div><div class=\"off-etat__cip\" \nng-if=\"rapprochement.codeCip\"><span class=\"off-micro\">Votre code CIP</span> <span class=\"off-etat__cip-valeur\">\n{{rapprochement.codeCip}}</span></div><div class=\"off-etat__texte\">\nVos données qualité dans LQO ne sont pas concernées, et «&#8239;Paramètres du compte&#8239;» reste accessible.</div>\n<div class=\"off-etat__contact\" ng-if=\"contact\"><span ng-if=\"contact.tel\">Contactez PHSQ au <strong>{{contact.tel}}\n</strong></span> <span ng-if=\"!contact.tel\">Contactez PHSQ</span><div class=\"off-etat__contact-mail\" \nng-if=\"contact.mail\">ou par courriel à <a ng-href=\"mailto:{{contact.mail}}\">{{contact.mail}}</a></div></div></div>");
$templateCache.put("app/main/front/officine/informations/adresse.dialog.html","<md-dialog class=\"off-dialog\" aria-label=\"Modifier l\'adresse de l\'officine\"><form name=\"formAdresse\" novalidate \nng-submit=\"enregistrer()\"><div class=\"off-dialog__tete\"><button type=\"button\" class=\"off-dialog__fermer\" \nng-click=\"fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button><div \nclass=\"off-dialog__titre\">Modifier l\'adresse de l\'officine</div><div class=\"off-dialog__sous\">{{fiche.nom}}<span \nng-if=\"fiche.codeCip\"> · CIP {{fiche.codeCip}}</span></div></div><md-dialog-content class=\"off-dialog__corps\"><div \nclass=\"off-dialog__erreur\" role=\"alert\" ng-if=\"erreur\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon>\n<span>{{erreur}}</span></div><div class=\"off-formulaire off-formulaire--deux\"><div class=\"off-champ off-champ--large\">\n<label class=\"off-champ__label\" for=\"off-a-rue\">Numéro et rue <span class=\"off-asterisque\">*</span></label><input \nid=\"off-a-rue\" class=\"off-input\" type=\"text\" ng-model=\"saisie.rue\" maxlength=\"255\" \nng-class=\"{\'off-input--invalide\': manque(\'rue\')}\" md-autofocus><div class=\"off-champ__erreur\" ng-if=\"manque(\'rue\')\">\nInformation requise.</div></div><div class=\"off-champ off-champ--large\"><label class=\"off-champ__label\" \nfor=\"off-a-complement\">Complément d\'adresse</label><input id=\"off-a-complement\" class=\"off-input\" type=\"text\" \nng-model=\"saisie.adresseSuite\" maxlength=\"255\" placeholder=\"Bâtiment, centre commercial…\"></div><div class=\"off-champ\">\n<label class=\"off-champ__label\" for=\"off-a-cp\">Code postal <span class=\"off-asterisque\">*</span></label><input \nid=\"off-a-cp\" class=\"off-input\" type=\"text\" ng-model=\"saisie.codePostal\" maxlength=\"10\" \nng-class=\"{\'off-input--invalide\': manque(\'codePostal\')}\"><div class=\"off-champ__erreur\" ng-if=\"manque(\'codePostal\')\">\nInformation requise.</div></div><div class=\"off-champ\"><label class=\"off-champ__label\" for=\"off-a-ville\">Ville <span \nclass=\"off-asterisque\">*</span></label><input id=\"off-a-ville\" class=\"off-input\" type=\"text\" ng-model=\"saisie.ville\" \nmaxlength=\"255\" ng-class=\"{\'off-input--invalide\': manque(\'ville\')}\"><div class=\"off-champ__erreur\" \nng-if=\"manque(\'ville\')\">Information requise.</div></div></div><div class=\"off-note off-dialog__note\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>L\'adresse est <strong>\nenregistrée immédiatement sur votre fiche PHSQ</strong>, sans validation préalable. <span class=\"off-asterisque\">*\n</span> Champs obligatoires.</span></div></md-dialog-content><div class=\"off-dialog__actions\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"fermer()\" ng-disabled=\"envoi\">Annuler</button> <button type=\"submit\" \nclass=\"nl-Btn\" ng-disabled=\"envoi\">{{envoi ? \'Enregistrement…\' : \'Enregistrer\'}}</button></div></form></md-dialog>");
$templateCache.put("app/main/front/officine/informations/informations.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Informations et adresse</a></div></div><div class=\"nl-Content off-content\">\n<off-navigation></off-navigation><off-bandeau etat=\"app.officine.informations\"><off-bandeau-phrase>\nCe que contient votre fiche PHSQ&#8239;; seule l\'adresse se modifie ici.</off-bandeau-phrase><off-bandeau-aide><p>\nLe nom, le code CIP, le sous-groupe et le numéro d\'adhérent sont des identifiants&#8239;: ils ne se modifient pas ici. Pour les corriger, contactez PHSQ.\n</p><p>Une adresse modifiée est <strong>enregistrée immédiatement sur votre fiche PHSQ</strong>\n, sans validation préalable, et PHSQ en est informé avec l\'ancienne valeur à côté de la nouvelle.</p><p>\nLes numéros de téléphone et les courriels appartiennent aux personnes&#8239;: ils se corrigent dans <a \nui-sref=\"app.officine.contacts\">Contacts</a>.</p><p>\nLe groupement est celui que PHSQ a enregistré. Pour le quitter, utilisez le formulaire <a \nui-sref=\"app.officine.sortie\">Sortie de groupement</a>.</p></off-bandeau-aide></off-bandeau><div \nng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div class=\"off-cartes\" \nng-if=\"etatEcran === \'normal\'\"><section class=\"off-carte\" aria-labelledby=\"off-carte-identite\"><div \nclass=\"off-carte__tete\"><span class=\"off-carte__icone off-carte__icone--turquoise\" aria-hidden=\"true\"><md-icon \nmd-font-icon=\"icon-file-document-box\" class=\"s20\"></md-icon></span><h2 class=\"off-carte__titre\" \nid=\"off-carte-identite\">Identité de l\'officine</h2></div><div class=\"off-carte__vedette\">{{fiche.nom || \'—\'}}</div><dl \nclass=\"off-carte__liste\"><div class=\"off-carte__ligne\"><dt>Code CIP</dt><dd>{{fiche.codeCip || \'—\'}}</dd></div><div \nclass=\"off-carte__ligne\"><dt>Statut PHSQ</dt><dd><span class=\"off-pastille\" \nng-class=\"statutActif() ? \'off-pastille--actif\' : \'off-pastille--on\'\"><span class=\"off-point\" ng-if=\"statutActif()\">\n</span>{{fiche.statut || \'non renseigné\'}}</span></dd></div><div class=\"off-carte__ligne\"><dt>Sous-groupe</dt><dd \nng-class=\"{\'off-fil__absent\': !fiche.sousGroupe}\">{{fiche.sousGroupe || \'Non renseigné\'}}</dd></div><div \nclass=\"off-carte__ligne\"><dt>N° d\'adhérent</dt><dd ng-class=\"{\'off-fil__absent\': !fiche.numeroAdherent}\">\n{{fiche.numeroAdherent || \'Non renseigné\'}}</dd></div></dl></section><section class=\"off-carte\" \naria-labelledby=\"off-carte-adresse\"><div class=\"off-carte__tete\"><span class=\"off-carte__icone off-carte__icone--bleu\" \naria-hidden=\"true\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s20\"></md-icon></span><h2 class=\"off-carte__titre\" \nid=\"off-carte-adresse\">Adresse</h2></div><address class=\"off-carte__adresse\"><span class=\"off-carte__vedette\" \nng-if=\"fiche.adresse.rue\">{{fiche.adresse.rue}}</span> <span class=\"off-fil__absent\" ng-if=\"!fiche.adresse.rue\">\nRue non renseignée</span> <span ng-if=\"fiche.adresse.adresseSuite\">{{fiche.adresse.adresseSuite}}</span> <span><strong \nng-if=\"fiche.adresse.codePostal\">{{fiche.adresse.codePostal}}</strong><span class=\"off-fil__absent\" \nng-if=\"!fiche.adresse.codePostal\">Code postal non renseigné</span> <span ng-if=\"fiche.adresse.ville\">\n{{fiche.adresse.ville}}</span><span class=\"off-fil__absent\" ng-if=\"!fiche.adresse.ville\">ville non renseignée</span>\n</span></address><div class=\"off-carte__pied\" ng-if=\"peutEcrire()\"><span class=\"off-texte-petit\">\nEnregistrée immédiatement sur votre fiche PHSQ.</span> <button type=\"button\" \nclass=\"nl-Btn nl-Btn--soft off-btn-compact\" ng-click=\"ouvrirEdition($event)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>Modifier l\'adresse</button></div></section><section class=\"off-carte\" aria-labelledby=\"off-carte-groupement\">\n<div class=\"off-carte__tete\"><span class=\"off-carte__icone off-carte__icone--indigo\" aria-hidden=\"true\"><md-icon \nmd-font-icon=\"icon-sitemap\" class=\"s20\"></md-icon></span><h2 class=\"off-carte__titre\" id=\"off-carte-groupement\">\nGroupement</h2></div><div class=\"off-micro\">Groupement actuel</div><div \nclass=\"off-carte__vedette off-carte__vedette--grande\">{{nomGroupement()}}</div><div class=\"off-carte__historique\"><div \nclass=\"off-micro\">Groupements quittés</div><div class=\"off-carte__aucun\" ng-if=\"!fiche.historiqueGroupements.length\">\nAucun changement enregistré</div><dl class=\"off-carte__liste\" ng-if=\"fiche.historiqueGroupements.length\"><div \nclass=\"off-carte__ligne\" ng-repeat=\"periode in fiche.historiqueGroupements\"><dt>{{periode.annee}}</dt><dd \nng-class=\"{\'off-fil__absent\': !periode.groupement}\">{{periode.groupement || \'Non renseigné\'}}</dd></div></dl></div>\n</section></div></div></section>");
$templateCache.put("app/main/front/officine/mon-officine/mon-officine.html","<section class=\"nl-Page off-page off-accueil\"><h1 class=\"nl-H1\">Mon officine</h1><div class=\"nl-Content off-content\">\n<div class=\"off-alerte\" role=\"alert\" ng-if=\"alerte\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon>\n<span class=\"off-alerte__texte\">{{alerte}}</span> <button type=\"button\" class=\"off-alerte__fermer\" \nng-click=\"fermerAlerte()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div>\n<div ng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div ng-if=\"etatEcran === \'normal\'\"><section \nclass=\"off-dossier off-carte-officine\" aria-label=\"Votre officine\"><div class=\"off-entete\"><div \nclass=\"off-entete__identite\"><div class=\"off-entete__avatar\" aria-hidden=\"true\">{{initialesOfficine()}}</div><div \nclass=\"off-entete__texte\"><div class=\"off-entete__nom\">{{fiche.nom}}</div><div class=\"off-entete__cles\"><span \nclass=\"off-cle\">CIP {{fiche.codeCip || \'—\'}}</span><span class=\"off-pastille\" \nng-class=\"statutActif() ? \'off-pastille--actif\' : \'off-pastille--on\'\"><span class=\"off-point\" ng-if=\"statutActif()\">\n</span>Statut PHSQ&#8239;: {{fiche.statut || \'non renseigné\'}}</span></div><div class=\"off-entete__adresse\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon><span><span ng-if=\"fiche.adresse.rue\">{{fiche.adresse.rue}}</span>\n<span class=\"off-fil__absent\" ng-if=\"!fiche.adresse.rue\">Rue non renseignée</span><span \nng-if=\"fiche.adresse.adresseSuite\">, {{fiche.adresse.adresseSuite}}</span>, <span \nng-if=\"fiche.adresse.codePostal || fiche.adresse.ville\"><strong>{{fiche.adresse.codePostal}}</strong>\n {{fiche.adresse.ville}}</span><span class=\"off-fil__absent\" ng-if=\"!fiche.adresse.codePostal && !fiche.adresse.ville\">\ncode postal et ville non renseignés</span></span></div></div></div><div class=\"off-entete__cote\"><div><div \nclass=\"off-entete__etiquette\">Groupement</div><div class=\"off-entete__ligne\"><span class=\"off-entete__valeur\">\n{{nomGroupement()}}</span></div></div></div></div></section><div class=\"off-tuiles\"><section \nclass=\"doc-section off-tuiles__section\" ng-repeat=\"section in sections track by section.id\" \naria-labelledby=\"off-tuiles-{{section.id}}\"><div class=\"doc-category off-tuiles__entete\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"off-tuiles__fleche\" aria-hidden=\"true\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/blue_arrow_right.svg\" class=\"iv-listing-item-icon-folder\"></md-icon></span><h2 \nclass=\"doc-section__title\" id=\"off-tuiles-{{section.id}}\">{{section.titre}}</h2></div><div class=\"doc-section__grid\"><a\n class=\"doc-card doc-card--{{section.couleur}} off-tuile\" ui-state=\"rubrique.etat\" \nng-repeat=\"rubrique in section.rubriques track by rubrique.etat\"><md-icon md-svg-src=\"{{rubrique.icone}}\" \naria-hidden=\"true\"></md-icon><span>{{rubrique.libelle}}</span><span class=\"off-tuile__pastille\" \nng-if=\"rubrique.demandes && demandesEnCours()\" \naria-label=\"{{demandesEnCours() > 1 ? demandesEnCours() + \' demandes en cours\' : \'1 demande en cours\'}}\">\n{{demandesEnCours()}}</span></a></div></section></div></div></div></section>");
$templateCache.put("app/main/front/officine/sortie/declarer-sortie.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Sortie de groupement</a></div></div><div class=\"nl-Content off-content\">\n<off-navigation></off-navigation><off-bandeau etat=\"app.officine.sortie\"><off-bandeau-phrase>\nVotre officine quitte son groupement&#8239;? Déclarez-le ici&#8239;: PHSQ instruit la demande et modifie votre rattachement.\n</off-bandeau-phrase><off-bandeau-aide><p>\nLes trois champs du formulaire sont facultatifs&#8239;: une déclaration envoyée à vide est valide. PHSQ prendra contact avec vous.\n</p><p>\nVotre rattachement n\'est pas modifié en envoyant la déclaration&#8239;: c\'est PHSQ qui le fait, une fois la demande instruite. Une seule déclaration peut être ouverte à la fois.\n</p><p>\nTant que personne chez PHSQ ne l\'a prise en charge, vous pouvez la retirer. Vous en suivez l\'avancement ici et dans <a \nui-sref=\"app.officine.demandes\">Mes demandes</a>.</p><p>\nVous quittez la démarche qualité, et non votre groupement&#8239;? Utilisez le formulaire <a \nui-sref=\"app.officine.sortieQualite\">Sortie de la démarche qualité</a>.</p></off-bandeau-aide></off-bandeau><div \nng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div class=\"off-pile\" \nng-if=\"etatEcran === \'normal\'\"><section class=\"off-bloc off-demande\" ng-if=\"!afficherFormulaire()\" \naria-labelledby=\"off-suivi-groupement\"><div class=\"off-bloc__titre\"><h2 class=\"off-bloc__intitule\" \nid=\"off-suivi-groupement\"><span class=\"off-bloc__icone off-bloc__icone--demarches\"><md-icon \nmd-font-icon=\"icon-sitemap\" class=\"s16\"></md-icon></span>\n{{etatGroupement() === \'suivi\' || etatGroupement() === \'E\' ? \'Ma déclaration de sortie de groupement\' : \'Votre rattachement\'}}\n</h2><span class=\"off-pastille {{pastilleGroupement().classe}}\" ng-if=\"pastilleGroupement()\"><span class=\"off-point\">\n</span>{{pastilleGroupement().libelle}}</span></div><div class=\"off-demande__corps\" \nng-include=\"\'app/main/front/officine/demandes/suivi-sortie-groupement.html\'\"></div></section><form name=\"formSortie\" \nnovalidate ng-submit=\"transmettre()\" ng-if=\"afficherFormulaire()\"><div class=\"off-bloc off-sortie off-sortie--saisie\">\n<div class=\"off-bloc__titre\"><span class=\"off-bloc__intitule\"><span class=\"off-bloc__icone off-bloc__icone--demarches\">\n<md-icon md-font-icon=\"icon-sitemap\" class=\"s16\"></md-icon></span>Ma déclaration de sortie de groupement</span></div>\n<ol class=\"off-etapes\"><li class=\"off-etape off-etape--courante\"><span class=\"off-etape__pastille\">1</span> <span \nclass=\"off-etape__titre\">Vous déclarez votre sortie</span> <span class=\"off-etape__detail\">sur cette page</span></li>\n<li class=\"off-etape off-etape--a-venir\"><span class=\"off-etape__pastille\">2</span> <span class=\"off-etape__titre\">\nPrise en charge par PHSQ</span> <span class=\"off-etape__detail\">qui prendra contact avec vous</span></li><li \nclass=\"off-etape off-etape--a-venir\"><span class=\"off-etape__pastille\">3</span> <span class=\"off-etape__titre\">\nRattachement modifié</span> <span class=\"off-etape__detail\">par PHSQ, une fois la demande instruite</span></li></ol>\n<div class=\"off-sortie__recap\"><div class=\"off-sortie__trajet\"><div class=\"off-sortie__groupement\"><span \nclass=\"off-sortie__etiquette\">Groupement actuel</span> <span class=\"off-sortie__nom\">{{nomGroupement()}}</span></div>\n<span class=\"off-sortie__fleche\" aria-hidden=\"true\"><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16\"></md-icon>\n</span><div class=\"off-sortie__groupement off-sortie__groupement--destination\"><span class=\"off-sortie__etiquette\">\nGroupement de destination <span class=\"off-facultatif\">(facultatif)</span></span><md-select class=\"off-select\" \nng-model=\"saisie.destination\" placeholder=\"Sélectionner un groupement\" aria-label=\"Groupement de destination\" \nmd-container-class=\"off-select-panneau\"><md-option ng-value=\"INCONNUE\">Je ne sais pas encore</md-option><md-divider>\n</md-divider><md-option ng-repeat=\"groupement in groupements\" ng-value=\"groupement.id\">{{groupement.libelle}}\n</md-option></md-select></div></div><div class=\"off-sortie__details off-sortie__details--saisie\"><div \nclass=\"off-champ\"><label class=\"off-champ__label\">Motif de votre sortie <span class=\"off-facultatif\">(facultatif)\n</span></label><md-select class=\"off-select\" ng-model=\"saisie.motifId\" placeholder=\"Sélectionner un motif\" \naria-label=\"Motif de votre sortie\" md-container-class=\"off-select-panneau\"><md-option ng-value=\"null\">Aucun motif\n</md-option><md-option ng-repeat=\"cause in causes\" ng-value=\"cause.id\">{{cause.libelle}}</md-option></md-select><div \nclass=\"off-champ__aide\">Liste proposée par PHSQ.</div></div><div class=\"off-champ\"><label class=\"off-champ__label\" \nfor=\"off-precisions\">Précisions <span class=\"off-facultatif\">(facultatif)</span></label><textarea id=\"off-precisions\" \nclass=\"off-input off-input--zone\" ng-model=\"saisie.precisions\" rows=\"4\" maxlength=\"2000\" \nplaceholder=\"Ce que vous souhaitez que PHSQ sache avant de vous rappeler…\"></textarea></div></div></div><div \nclass=\"off-sortie__pied\"><span class=\"off-texte-petit\">Les trois champs sont facultatifs.</span><div \nclass=\"off-boutons\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"annuler()\" ng-disabled=\"envoi\">\nAnnuler</button> <button type=\"submit\" class=\"nl-Btn\" ng-disabled=\"envoi\">\n{{envoi ? \'Transmission…\' : \'Transmettre ma déclaration\'}}</button></div></div><div class=\"off-sortie__note\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>Cette déclaration est <strong>transmise à PHSQ\n</strong>\n, qui prendra contact avec vous. Votre rattachement n\'est pas modifié en l\'envoyant&#8239;: c\'est PHSQ qui le fait, une fois la demande instruite. Vous pourrez suivre l\'avancement depuis «&#8239;Mon officine › Mes demandes&#8239;».\n</span></div></div></form></div></div></section>");
$templateCache.put("app/main/front/officine/sortie-qualite/sortie-qualite.html","<section class=\"nl-Page off-page off-sous-page\"><div class=\"nl_breadcumb off-fil-ariane\"><div \nclass=\"nl_breadcumb--item\"><a class=\"nl_breadcumb--item--title\" ui-sref=\"app.officine\">Mon officine</a><div \nclass=\"nl_breadcumb--item--icon\"><i class=\"icon-chevron-right\"></i></div></div><div class=\"nl_breadcumb--item\"><a \nclass=\"nl_breadcumb--item--title\">Sortie de la démarche qualité</a></div></div><div class=\"nl-Content off-content\">\n<off-navigation></off-navigation><off-bandeau etat=\"app.officine.sortieQualite\"><off-bandeau-phrase>\nVotre officine quitte la démarche qualité PHSQ (certification ISO 9001 QMS PHARMA®, LQO Premium inclus)&#8239;? Formalisez votre demande ici.\n</off-bandeau-phrase><off-bandeau-aide><p>\nVotre demande est transmise à PHSQ, qui la traite et peut vous recontacter. Rien ne change à l\'envoi&#8239;: c\'est PHSQ qui met à jour votre dossier et vos accès LQO, une fois la demande traitée.\n</p><p>\nUne seule demande peut être ouverte à la fois. Tant que personne chez PHSQ ne l\'a prise en charge, vous pouvez la retirer. Vous en suivez l\'avancement ici et dans \n<a ui-sref=\"app.officine.demandes\">Mes demandes</a>.</p><p>\nVotre groupement ou PHSQ peuvent aussi déposer cette demande pour votre officine&#8239;: vous la voyez alors ici, sans le détail.\n</p><p>Vous quittez votre groupement, et non la démarche qualité&#8239;? Utilisez le formulaire <a \nui-sref=\"app.officine.sortie\">Sortie de groupement</a>.</p></off-bandeau-aide></off-bandeau><div \nng-include=\"\'app/main/front/officine/etats/etats-ecran.html\'\"></div><div class=\"off-pile\" \nng-if=\"etatEcran === \'normal\'\"><section class=\"off-bloc off-demande\" ng-if=\"!afficherFormulaire()\" \naria-labelledby=\"off-suivi-qualite\"><div class=\"off-bloc__titre\"><h2 class=\"off-bloc__intitule\" id=\"off-suivi-qualite\">\n<span class=\"off-bloc__icone off-bloc__icone--demarches\"><md-icon md-font-icon=\"icon-ribbon\" class=\"s16\"></md-icon>\n</span>\n{{qualiteDetaillee() ? \'Ma demande de sortie de la démarche qualité\' : \'Demande de sortie de la démarche qualité\'}}\n</h2><span class=\"off-pastille {{pastilleQualite().classe}}\" ng-if=\"pastilleQualite()\"><span class=\"off-point\"></span>\n{{pastilleQualite().libelle}}</span></div><div class=\"off-demande__corps\" \nng-include=\"\'app/main/front/officine/demandes/suivi-sortie-qualite.html\'\"></div></section><form name=\"formQualite\" \nnovalidate ng-submit=\"transmettre()\" ng-if=\"afficherFormulaire()\"><div \nclass=\"off-bloc off-sortie off-sortie--saisie off-qualite\"><div class=\"off-bloc__titre\"><span \nclass=\"off-bloc__intitule\"><span class=\"off-bloc__icone off-bloc__icone--demarches\"><md-icon \nmd-font-icon=\"icon-ribbon\" class=\"s16\"></md-icon></span>Demande de sortie de la certification ISO 9001 QMS PHARMA®\n</span></div><p class=\"off-qualite__intro\">\nCe formulaire vous permet de formaliser votre demande de sortie de la certification. Une fois complétée et validée, votre demande sera traitée dans les meilleurs délais.\n</p><div class=\"off-note off-qualite__annulee\" ng-if=\"etatQualite() === \'annulee\'\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s16\"></md-icon><span>\nVotre demande précédente, transmise le {{dateLongue(sortieQualite.deposeeLe)}}, a été annulée.</span></div><div \nclass=\"off-qualite__identite\"><div><div class=\"off-micro\">Officine</div><div class=\"off-lecture-seule__valeur\">\n{{fiche.nom || \'—\'}}</div></div><div><div class=\"off-micro\">Code CIP</div><div class=\"off-lecture-seule__valeur\">\n{{fiche.codeCip || \'—\'}}</div></div><div><div class=\"off-micro\">Groupement</div><div class=\"off-lecture-seule__valeur\">\n{{nomGroupement()}}</div></div><div><div class=\"off-micro\">Compte</div><div class=\"off-lecture-seule__valeur\">\n{{compte() || \'—\'}}</div></div></div><section class=\"off-qualite__bloc\" aria-labelledby=\"off-qualite-bloc-1\"><h2 \nclass=\"off-qualite__bloc-titre\" id=\"off-qualite-bloc-1\"><span class=\"off-qualite__numero\" aria-hidden=\"true\">1</span>\nVos raisons</h2><div class=\"off-note off-note--info off-qualite__bandeau\"><md-icon md-font-icon=\"icon-sitemap\" \nclass=\"s16\"></md-icon><span>\nVous changez de groupement ? Ce formulaire ne concerne que la sortie de la démarche qualité : déclarez votre changement avec le formulaire de sortie de groupement. \n<a class=\"off-qualite__lien\" ui-sref=\"app.officine.sortie\">Formulaire de sortie de groupement<md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"s14\"></md-icon></a></span></div><fieldset class=\"off-qualite__section\"><legend \nclass=\"off-qualite__question\">Raisons de votre sortie <span class=\"off-asterisque\">*</span> <span \nclass=\"off-facultatif\">(une ou plusieurs)</span></legend><div class=\"off-cases\" \nng-class=\"{\'off-cases--invalide\': manque(\'raisons\')}\"><label class=\"off-case\" \nng-repeat=\"raison in raisons track by raison.id\"><input type=\"checkbox\" ng-model=\"saisie.raisons[raison.id]\"> <span>\n{{raison.libelle}}</span></label></div><div class=\"off-champ__aide\" ng-if=\"!raisons.length\">\nAucune raison n\'est proposée pour le moment&#8239;: contactez PHSQ.</div><div class=\"off-champ__erreur\" \nng-if=\"manque(\'raisons\')\">Cochez au moins une raison.</div><div class=\"off-champ off-qualite__precision\" \nng-if=\"raisonExigeante()\"><label class=\"off-champ__label\" for=\"off-raison-precision\">\nPrécisez la raison «&#8239;{{raisonExigeante().libelle}}&#8239;» <span class=\"off-asterisque\">*</span></label><textarea\n id=\"off-raison-precision\" class=\"off-input off-input--zone\" ng-model=\"saisie.raisonPrecision\" rows=\"2\" \nmaxlength=\"500\" ng-class=\"{\'off-input--invalide\': manque(\'precision\')}\"></textarea><div class=\"off-champ__erreur\" \nng-if=\"manque(\'precision\')\">Précisez la raison.</div></div></fieldset><fieldset class=\"off-qualite__section\"><legend \nclass=\"off-qualite__question\" id=\"off-nps-question\">\nSur une échelle de 0 à 10, quelle est la probabilité que vous recommandiez notre service à un confrère ou partenaire ? \n<span class=\"off-facultatif\">(facultatif)</span></legend><div class=\"off-nps\" role=\"radiogroup\" \naria-labelledby=\"off-nps-question\"><button type=\"button\" class=\"off-nps__note\" ng-repeat=\"note in notes\" role=\"radio\" \naria-checked=\"{{saisie.nps === note}}\" ng-class=\"{\'off-nps__note--choisie\': saisie.nps === note}\" \nng-click=\"choisirNote(note)\">{{note}}</button></div><button type=\"button\" class=\"off-lien off-nps__effacer\" \nng-if=\"saisie.nps !== null\" ng-click=\"choisirNote(null)\">Ne pas répondre</button></fieldset></section><section \nclass=\"off-qualite__bloc\" aria-labelledby=\"off-qualite-bloc-2\"><h2 class=\"off-qualite__bloc-titre\" \nid=\"off-qualite-bloc-2\"><span class=\"off-qualite__numero\" aria-hidden=\"true\">2</span>Vos engagements</h2><fieldset \nclass=\"off-qualite__section\"><legend class=\"off-qualite__question\">Engagements <span class=\"off-asterisque\">*</span>\n</legend><div class=\"off-engagements\"><div class=\"off-engagement\" \nng-class=\"{\'off-engagement--invalide\': manque(\'charte\'), \'off-engagement--coche\': saisie.charte}\"><div \nclass=\"off-engagement__titre\">Charte de sortie de la certification ISO 9001 QMS-Pharma®</div><label class=\"off-case\">\n<input type=\"checkbox\" ng-model=\"saisie.charte\"> <span>\nJe reconnais avoir pris connaissance de la charte de sortie de la certification ISO 9001 QMS-Pharma®</span></label>\n</div><div class=\"off-engagement\" \nng-class=\"{\'off-engagement--invalide\': manque(\'communication\'), \'off-engagement--coche\': saisie.communication}\"><div \nclass=\"off-engagement__titre\">Charte de communication PHSQ et Bureau Veritas</div><label class=\"off-case\"><input \ntype=\"checkbox\" ng-model=\"saisie.communication\"> <span>\nJe confirme avoir retiré l\'ensemble des éléments de communication liés à la certification (supports physiques, digitaux, signalétique officinale, site, etc.)\n</span></label></div><div class=\"off-engagement\" \nng-class=\"{\'off-engagement--invalide\': manque(\'clotureLqo\'), \'off-engagement--coche\': saisie.clotureLqo}\"><div \nclass=\"off-engagement__titre\">LQO Premium</div><label class=\"off-case\"><input type=\"checkbox\" \nng-model=\"saisie.clotureLqo\"> <span>\nJe valide la clôture des accès au LQO Premium, Admin et équipe (inclus dans l\'accompagnement vers la certification ISO 9001 QMS PHARMA par PHSQ).\n</span></label><div class=\"off-engagement__aide\">\nOutil dédié au pilotage de la qualité et performance. PHSQ peut conserver les éléments de travail déjà enregistrés pour une durée maximale de 11 mois. Au-delà de ce délai, les données seront définitivement supprimées conformément à la réglementation RGPD.\n</div></div></div><div class=\"off-champ__erreur\" \nng-if=\"manque(\'charte\') || manque(\'communication\') || manque(\'clotureLqo\')\">\nLes trois engagements sont nécessaires pour transmettre la demande.</div></fieldset></section><section \nclass=\"off-qualite__bloc\" aria-labelledby=\"off-qualite-bloc-3\"><h2 class=\"off-qualite__bloc-titre\" \nid=\"off-qualite-bloc-3\"><span class=\"off-qualite__numero\" aria-hidden=\"true\">3</span>Date et validation</h2><fieldset \nclass=\"off-qualite__section\"><legend class=\"off-qualite__question\"><label for=\"off-date-souhaitee\">\nDate effective souhaitée</label><span class=\"off-asterisque\">*</span></legend><input id=\"off-date-souhaitee\" \nclass=\"off-input off-input--date\" type=\"date\" ng-model=\"saisie.dateSouhaitee\" min=\"{{aujourdhui}}\" \nng-model-options=\"{ allowInvalid: true }\" ng-class=\"{\'off-input--invalide\': manque(\'date\')}\"><div \nclass=\"off-champ__aide\">Aujourd\'hui ou plus tard.</div><div class=\"off-champ__erreur\" \nng-if=\"manque(\'date\') && !saisie.dateSouhaitee\">Information requise.</div><div class=\"off-champ__erreur\" \nng-if=\"manque(\'date\') && saisie.dateSouhaitee\">Choisissez aujourd\'hui ou une date à venir.</div></fieldset><fieldset \nclass=\"off-qualite__section\"><legend class=\"off-qualite__question\"><label for=\"off-commentaires\">\nVos suggestions d\'amélioration / commentaires</label><span class=\"off-facultatif\">(facultatif)</span></legend><textarea\n id=\"off-commentaires\" class=\"off-input off-input--zone\" ng-model=\"saisie.commentaires\" rows=\"4\" maxlength=\"2000\">\n</textarea><div class=\"off-champ__aide off-qualite__compteur\">{{(saisie.commentaires || \'\').length}} / 2 000</div>\n</fieldset><div class=\"off-note off-qualite__note\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s16\">\n</md-icon><span>\nLes validations effectuées dans ce formulaire sont horodatées et associées à votre compte. La date effective de sortie sera prise en compte à compter de la validation complète de votre demande par nos équipes. Dans ce cadre, vous êtes susceptible d\'être recontacté·e par un membre de PHSQ afin de valider ou préciser certains éléments.\n</span></div><div class=\"off-engagement off-engagement--validation\" \nng-class=\"{\'off-engagement--invalide\': manque(\'validation\'), \'off-engagement--coche\': saisie.validation}\"><label \nclass=\"off-case\"><input type=\"checkbox\" ng-model=\"saisie.validation\"> <span>\nJe valide ma demande de sortie de la certification ISO 9001 QMS PHARMA®</span></label></div><div \nclass=\"off-champ__erreur\" ng-if=\"manque(\'validation\')\">Cochez cette case pour transmettre la demande.</div><div \nclass=\"off-sortie__pied off-qualite__pied\"><span class=\"off-texte-petit\" ng-if=\"!tentative || valide()\"><span \nclass=\"off-asterisque\">*</span> Champs obligatoires.</span> <span class=\"off-champ__erreur off-qualite__resume\" \nng-if=\"tentative && !valide()\" role=\"alert\">Complétez les champs signalés pour transmettre votre demande.</span><div \nclass=\"off-boutons\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"annuler()\" ng-disabled=\"envoi\">\nAnnuler</button> <button type=\"submit\" class=\"nl-Btn\" ng-disabled=\"envoi\">\n{{envoi ? \'Transmission…\' : \'Transmettre ma demande\'}}</button></div></div></section></div></form></div></div>\n</section>");
$templateCache.put("app/main/front/performances/evaluation-fournisseurs/details-evaluation.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><a class=\"nl-H1--backBtn\" ng-href=\"./evaluation-fournisseurs\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a>{{fournisseurEvaluation.name}}<div \nclass=\"nl-tdb-indicator\"><span class=\"nl-tdb-indicator-arrow\" ng-click=\"changeYear(\'minus\')\"><img \nsrc=\"./assets/icons/app/indicators/indicator_left.png\" alt=\"\"> </span><span class=\"nl-tdb-indicator-year\">\nAnnée {{yearChosen}}</span> <span class=\"nl-tdb-indicator-arrow\" ng-click=\"changeYear(\'plus\')\"><img \nsrc=\"./assets/icons/app/indicators/indicator_right.png\" alt=\"\"></span></div></h1><div class=\"nl-Content\"><h2 \nclass=\"nl-H2\">Évaluation générale {{yearChosen}}</h2><form name=\"evaluateFournisseurForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"evaluateFournisseurForm.$valid && saveEvaluation()\"><div \nng-if=\"fournisseurEvaluation.malfunctions.length > 0\"><div class=\"iv-Libelle\">\nDysfonctionnements enregistrés pour ce laboratoire</div><md-list class=\"iv-List\"><md-list-item class=\"iv-ListItem\" \nng-click=\"openMalfunction(dys)\" class=\"\" ng-repeat=\"dys in fournisseurEvaluation.malfunctions | orderBy: \'creation\'\"><p\n class=\"iv-ListItem__title text-truncate\" flex=\"40\">{{dys.title}}</p><p class=\"iv-ListItem__text text-truncate\" \nflex=\"40\">{{dys.type.name}}</p><p class=\"iv-ListItem__text text-truncate\" flex=\"20\">\n{{dys.creation | date: \'dd.MM.yyyy\'}}</p></md-list-item></md-list></div><div class=\"mt-35\" layout=\"row\" layout-wrap>\n<div flex=\"33\" class=\"pr-10\" ng-if=\"fournisseurEvaluation.type != \'SERVICE\'\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Stock</label><md-select placeholder=\"\" \nng-model=\"fournisseurEvaluation.stock\" name=\"selectStock\" class=\"nl-newInput-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" \nng-repeat=\"stock in stocksFournisseur\" value=\"{{stock.id}}\">{{stock.name}}</md-option></md-select></md-input-container>\n</div><div flex=\"33\" class=\"pl-10 pr-10\" ng-if=\"fournisseurEvaluation.type != \'SERVICE\'\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Marge (€)</label><input class=\"nl-newInput-input\" \ntype=\"number\" name=\"margin\" placeholder=\"\" ng-model=\"fournisseurEvaluation.margin\"><div \nng-messages=\"evaluateFournisseurForm.margin.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container></div><div flex=\"33\" class=\"pl-10\" \nng-if=\"fournisseurEvaluation.type != \'SERVICE\'\"><md-input-container class=\"nl-Input-container\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">\nStock valorisé en prix d\'achat net remisé (€)</label><input class=\"nl-newInput-input\" type=\"number\" name=\"margin\" \nplaceholder=\"\" ng-model=\"fournisseurEvaluation.valorizedStock\"><div \nng-messages=\"evaluateFournisseurForm.margin.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container></div><div flex=\"66\" class=\"pr-10 mt-15\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Notation</label><div layout=\"row\" \nlayout-align=\"start center\"><md-slider flex class=\"iv-Slider\" ng-model=\"fournisseurEvaluation.mark\" step=\"1\" min=\"1\" \nmax=\"10\"></md-slider><div class=\"iv-Slider__value flex-shrink\">{{fournisseurEvaluation.mark}} /10</div></div>\n</md-input-container></div><div flex=\"33\" class=\"pl-10 mt-15\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Fournisseur stratégique</label><md-select placeholder=\"\" \nng-model=\"fournisseurEvaluation.strategicalSupplier\" name=\"selectStrategicalSupplier\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-option \nclass=\"nl-Select-dropdown-btn\" ng-value=\"true\">Oui</md-option><md-option class=\"nl-Select-dropdown-btn\" \nng-value=\"false\">Non</md-option></md-select></md-input-container></div><div flex=\"66\" class=\"pr-10 mt-15\">\n<md-input-container class=\"nl-Input-container\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Commentaire</label><textarea class=\"nl-newInput-textarea\" \ntype=\"text\" name=\"evaluationComment\" ng-model=\"fournisseurEvaluation.evaluationComment\" placeholder=\"\"></textarea><div \nng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div><div class=\"33\"></div><div flex=\"66\" \nclass=\"pr-10 mt-15\" ng-if=\"!$root.user.isMini\"><h2 class=\"nl-H3\" ng-click=\"showEvaluation = !showEvaluation\" \nstyle=\"color:#1A2A33\"><button class=\"nl-fournisseurs__showMore mr-10\" type=\"button\" \nng-class=\"{\'nl-is--hidden\': !showEvaluation}\"><md-icon class=\"nl-fournisseurs__showMore__icon\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\" role=\"img\" aria-hidden=\"true\"></md-icon></button>\n Évaluation 🌿 ECOR</h2><div ng-if=\"showEvaluation\"><h3 class=\"nl-H3-fournisseurs\">1. Produits : <span>\nCompositions, origines, lieu de fabrication, emballages...</span></h3><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Notation</label><div layout=\"row\" \nlayout-align=\"start center\"><md-slider flex class=\"iv-Slider\" ng-model=\"fournisseurEvaluation.produitsmark\" step=\"1\" \nmin=\"1\" max=\"10\"></md-slider><div class=\"iv-Slider__value flex-shrink\">{{fournisseurEvaluation.produitsmark}} /10</div>\n</div></md-input-container><h3 class=\"nl-H3-fournisseurs pt-15\">2. Organisation : <span>\nLogistique, facturation, présentoirs, politique d\'achalandage...</span></h3><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Notation</label><div layout=\"row\" \nlayout-align=\"start center\"><md-slider flex class=\"iv-Slider\" ng-model=\"fournisseurEvaluation.organisationmark\" \nstep=\"1\" min=\"1\" max=\"10\"></md-slider><div class=\"iv-Slider__value flex-shrink\">\n{{fournisseurEvaluation.organisationmark}} /10</div></div></md-input-container><h3 class=\"nl-H3-fournisseurs pt-15\">\n3. Engagements : <span>Labels, projets, communication...</span></h3><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Notation</label><div layout=\"row\" \nlayout-align=\"start center\"><md-slider flex class=\"iv-Slider\" ng-model=\"fournisseurEvaluation.engagementsmark\" \nstep=\"1\" min=\"1\" max=\"10\"></md-slider><div class=\"iv-Slider__value flex-shrink\">\n{{fournisseurEvaluation.engagementsmark}} /10</div></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Commentaire</label><textarea class=\"nl-newInput-textarea\" \ntype=\"text\" name=\"evaluationCommentEngagement\" ng-model=\"fournisseurEvaluation.evaluationCommentEngagement\" \nplaceholder=\"\"></textarea><div ng-messages=\"evaluateFournisseurForm.evaluationCommentEngagement.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div></div><div flex=\"66\" \nclass=\"pr-10 mt-15\"><h2 class=\"nl-H3\" style=\"color:#1A2A33\">Documents</h2><div class=\"ml-5 mr-5 flex-100 layout-row\" \nng-if=\"fournisseurEvaluation.documents == null||fournisseurEvaluation.documents.length < 3\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\"><button class=\"iv-Btn iv-Btn--file\" type=\"button\" \nng-click=\"openJoindreFile()\" style=\"width: 100%; justify-content: flex-start; border: 0\"><div class=\"iv-Btn__file\">\n</div><md-icon class=\"m-0\" md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe\n</div></button></md-input-container><input type=\"file\" id=\"add_file\" ng-hide=\"true\"></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row mt-10\" ng-repeat=\"document in fournisseurEvaluation.documents\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Btn iv-Btn--file\" ng-if=\"document.attachmentOriginalName != null\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\" ng-click=\"downloadDoc(document.id)\"><md-icon \nng-if=\"document.id\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.attachmentOriginalName}}\n</div></div><button type=\"button\" class=\"iv-BtnIcon--file\" ng-click=\"deleteDocument($index);\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div></div><div class=\"pt-30 pb-30\" \nlayout=\"row\" layout-align=\"space-between center\"><div><button type=\"button\" \nng-click=\"showContact(fournisseurEvaluation)\" class=\"nl-Btn\" aria-label=\"Contact\">Contact</button></div><div \nflex-shrink ng-if=\"!changesAreWaiting()\"><button type=\"button\" ng-click=\"goBack()\" class=\"nl-Btn nl-Btn--outline\" \naria-label=\"Fermer\">Fermer</button></div><div ng-if=\"changesAreWaiting()\" layout=\"row\" \nlayout-align=\"space-between center\"><button type=\"button\" ng-click=\"reset()\" class=\"nl-Btn nl-Btn--outline mr-10\" \naria-label=\"Annuler\">Annuler</button> <button type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Enregistrer\n</button></div></div></form></div></section>");
$templateCache.put("app/main/front/performances/evaluation-fournisseurs/evaluation-fournisseurs.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Liste des Fournisseurs</h1><div class=\"nl-Content\"><div class=\"pt-20\" \nlayout=\"row\" layout-align=\"space-between center\"><div><button class=\"iv-BtnIconFill\" ng-click=\"openInfosEvalPopup()\">\n<md-icon md-svg-src=\"./assets/icons/app/V3/information.svg\"></md-icon></button></div><div class=\"text-center\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"dialogSave(false)\">Ajouter un fournisseur</button></div></div><div><div \nclass=\"mb-20\"><div class=\"nl-FilterBar\"><div><span class=\"nl-FilterBar-text\">Filtrer par</span><md-menu \nclass=\"nl-Menu nl-Menu--filtre\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-25 -10\"><button \naria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><span ng-if=\"printFilterValue() == null\" \nclass=\"nl-Menu-btn-title\"><span>Statut : </span><span class=\"nl-Menu-btn-title-value\">Tous</span></span> <span \nng-if=\"printFilterValue() != null\" class=\"nl-Menu-btn-title nl-Menu-btn-title--value\"><span>Statut : </span><span \nclass=\"nl-Menu-btn-title-value\">{{ printFilterValue()}}</span></span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"initFilter();search();\" \nng-style=\"printFilterValue() == null && {\'font-weight\':\'600\'}\">Tous</md-button></md-menu-item><md-menu-item \nmd-menu-align-target class=\"iv-Menu__dropdown__sep\"><div></div></md-menu-item><md-menu-item md-menu-align-target>\n<md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"initFilter(); filter.criteria.laboratory = true;search();\" \nng-style=\"filter.criteria.laboratory && {\'font-weight\':\'600\'}\">Laboratoires</md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initFilter(); filter.criteria.serviceProvider = true;search();\" \nng-style=\"filter.criteria.serviceProvider && {\'font-weight\':\'600\'}\">Prestataires de services</md-button></md-menu-item>\n<md-menu-item md-menu-align-target class=\"iv-Menu__dropdown__sep\"><div></div></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initFilter(); filter.criteria.withMalfunctions = true;search();\" \nng-style=\"filter.criteria.withMalfunctions && {\'font-weight\':\'600\'}\">Avec dysfonctionnements</md-button></md-menu-item>\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initFilter(); filter.criteria.withoutMalfunction = true;search();\" \nng-style=\"filter.criteria.withoutMalfunction && {\'font-weight\':\'600\'}\">Sans dysfonctionnement</md-button>\n</md-menu-item><md-menu-item md-menu-align-target class=\"iv-Menu__dropdown__sep\"><div></div></md-menu-item>\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initFilter(); filter.criteria.withEvaluationEcor = true;search();\" \nng-style=\"filter.criteria.withEvaluationEcor && {\'font-weight\':\'600\'}\">Avec évaluation 🌿 ECOR</md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu class=\"nl-Menu nl-Menu--filtre\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-25 -10\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><span ng-if=\"printOrderValue() == null\" class=\"nl-Menu-btn-title\"><span>Ordre : </span>\n<span class=\"nl-Menu-btn-title-value\">Aucun</span></span> <span ng-if=\"printOrderValue() != null\" \nclass=\"nl-Menu-btn-title nl-Menu-btn-title--value\"><span>Ordre : </span><span class=\"nl-Menu-btn-title-value\">\n{{ printOrderValue()}}</span></span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content width=\"3\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"initOrder();search();\" \nng-style=\"printOrderValue() == null && {\'font-weight\':\'600\'}\">Aucun</md-button></md-menu-item><md-menu-item \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initOrder(); filter.order.name = true;search();\" ng-style=\"filter.order.name && {\'font-weight\':\'600\'}\">Nom\n</md-button></md-menu-item><md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"initOrder(); filter.order.evalDate = true;search();\" \nng-style=\"filter.order.evalDate && {\'font-weight\':\'600\'}\">Date d\'évaluation</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div><div class=\"mt-20\"><div class=\"nl-listing\"><div \nclass=\"nl-listing-item\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"fournisseur in fournisseurs track by fournisseur.id\"><div class=\"flex\"><div \nng-click=\"dialogEvaluate(fournisseur)\"><div class=\"nl-list-item-title\">\n{{fournisseur.name}} - {{findTypeById(fournisseur.type)}}</div><div class=\"nl-list-item-description\">\n{{fournisseur.contactName}}{{fournisseur.contactName && fournisseur.contactPhone? \" • \" : \"\"}}{{fournisseur.contactPhone}}{{(fournisseur.contactName || fournisseur.contactPhone) && fournisseur.contactMail ? \" • \" : \"\"}}{{fournisseur.contactMail}}\n</div></div></div><div><div class=\"nl-dib mr-45\"><div class=\"nl-list-item-description\" \nng-if=\"fournisseur.mark != null\"><span ng-if=\"fournisseur.lastEvalDate != null\">\n{{\'Évalué le \' + (fournisseur.lastEvalDate | date: \'dd/MM/yyyy\') + \' : \'}}</span> <span class=\"nl-list-item-mark\">\n{{fournisseur.mark}}/10</span></div><div class=\"nl-list-item-description\" ng-if=\"fournisseur.mark == null\"><span>\nÀ évaluer</span></div></div><div class=\"nl-dib\"><md-menu class=\"nl-Menu\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"showContact(fournisseur)\">Contact\n</md-button></md-menu-item><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"dialogEvaluate(fournisseur)\">Évaluer</md-button></md-menu-item><md-menu-item><md-button \nclass=\"nl-Menu-dropdown-btn\" ng-click=\"dialogSave(true, fournisseur) \">Modifier</md-button></md-menu-item><md-menu-item\n permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"dialogDelete(fournisseur.id) \">Supprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredFournisseur.length === 0 && (filterValue != \'\' || triValue != \'\')\"><p>Aucun résultat...</p>\n</md-list-item><md-progress-circular md-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></div></div>\n</section>");
$templateCache.put("app/main/front/performances/mes-evaluations/flash.html","<section class=\"nl-Page pb-45\"><h1 class=\"nl-H1\"><div class=\"nl-H1--backBtn\" ng-click=\"goBack()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></div><div>Flash Qualité : <span class=\"nl-H1--fw\">\n{{titleFlash}}</span></div></h1><form name=\"flashForm\" ng-submit=\"flashForm.$valid && validate()\"><div \nclass=\"nl-Content\"><div class=\"mt-20\" layout=\"row\" layout-wrap layout-align=\"start start\" \nstyle=\"max-width: 600px; margin: auto\"><div class=\"mt-30 mb-10\"><h2 class=\"iv-H2\">{{titleFlash}}</h2></div>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Les points forts*<span \nng-if=\"flash.plus == null\" class=\"asterix\">*</span></label><textarea class=\"iv-Input-textarea\" ng-model=\"flash.plus\" \nname=\"plus\" rows=\"3\" max-rows=\"5\" md-no-resize required></textarea><div ng-messages=\"flashForm.plus.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Les points faibles*<span \nng-if=\"flash.moins == null\" class=\"asterix\">*</span></label><textarea class=\"iv-Input-textarea\" ng-model=\"flash.moins\" \nname=\"moins\" rows=\"3\" max-rows=\"5\" md-no-resize required></textarea><div ng-messages=\"flashForm.moins.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Dysfonctionnements rencontrés*<span \nng-if=\"flash.malfunctions == null\" class=\"asterix\">*</span></label><textarea class=\"iv-Input-textarea\" \nng-model=\"flash.malfunctions\" name=\"malfunctions\" rows=\"3\" max-rows=\"5\" md-no-resize required></textarea><div \nng-messages=\"flashForm.malfunctions.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container><md-input-container class=\"iv-Input-container\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Existe-t-il une procédure ?*<span \nng-if=\"flash.processExist == null\" class=\"asterix\">*</span></label><md-radio-group name=\"processExist\" required \nclass=\"iv-Radio-wrapper pt-5 pb-10\" ng-model=\"flash.processExist\" md-no-ink><md-radio-button class=\"iv-Radio\" \nng-value=\"trueValue\" aria-label=\"oui\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"falseValue\" \naria-label=\"non\">Non</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"iv-Input-container\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nUne procédure serait-elle utile ?*<span ng-if=\"flash.processUseful == null\" class=\"asterix\">*</span></label>\n<md-radio-group name=\"processUseful\" required class=\"iv-Radio-wrapper pt-5 pb-10\" ng-model=\"flash.processUseful\" \nmd-no-ink><md-radio-button class=\"iv-Radio\" ng-value=\"trueValue\" aria-label=\"oui\">Oui</md-radio-button><md-radio-button\n class=\"iv-Radio\" ng-value=\"falseValue\" aria-label=\"non\">Non</md-radio-button></md-radio-group></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Personne ayant réalisé l\'auto-contrôle</label><md-select \nrequired name=\"collaborateur\" ng-model=\"flash.collaborateurID\" ng-change=\"changeCollab(flash.collaborateurID)\" \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez le collaborateur</md-select-header><md-option \nclass=\"nl-Select-dropdown-btn\" ng-value=\"collaborateur.id\" ng-repeat=\"collaborateur in collaborateurs\">\n{{collaborateur.surname}} {{collaborateur.name}}</md-option><md-option class=\"nl-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-20 mt-35\" style=\"border-top: 1px solid #C5DCF4\"><div></div><div \nlayout=\"row\" layout-align=\"start center\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\">Annuler</button> <button \ntype=\"submit\" class=\"nl-Btn ml-10\">Sauvegarder</button></div></div></div></form></section><nl-footer></nl-footer>");
$templateCache.put("app/main/front/performances/mes-evaluations/flashs.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><div class=\"nl-H1--backBtn\" ng-click=\"goBack()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></div><div>Flash Qualité : <span class=\"nl-H1--fw\">\n{{titleAutoCtrl}}</span></div></h1><div class=\"nl-Content\"><div class=\"mt-25 mb-20\" layout=\"flex row\" \nlayout-align=\"end center\"><button class=\"iv-Btn\" type=\"button\" ng-click=\"generateDoc()\"><md-icon class=\"w-18 h-18\" \nmd-svg-src=\"assets/icons/app/V3/print.svg\"></md-icon><div>Imprimer le support</div></button> <button \nclass=\"iv-Btn ml-15\" type=\"button\" ng-click=\"planTache()\"><md-icon class=\"w-18 h-18\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div>Planifier une tâche correctrice</div></button></div>\n<div class=\"iv-list\"><div class=\"iv-list-item\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"flash in flashs  | orderBy : \'index\'\" ng-click=\"goFlash(flash)\"><div layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/app/V3/flash.svg\"></md-icon></div><div class=\"ml-10\"><div\n class=\"iv-list-item-title\">{{flash.name}}</div><div class=\"iv-list-item-description\">\nEnregistré le {{flash.updateDate | date:\"dd/MM/yyyy\"}} par {{flash.author}}</div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\" class=\"nl-listing-item-icon2\">\n</md-icon></div></div></div></div></section><nl-footer></nl-footer>");
$templateCache.put("app/main/front/performances/mes-evaluations/satisfaction-client.html","<section class=\"nl-Page\"><div class=\"nl-H1\"><div style=\"padding: 0;min-height: 3.4rem\">Mes évaluations</div><div \nlayout=\"row\" layout-align=\"end center\" \nng-if=\"!$root.user.isNonLqo && tabActive != tabs.flash && tabActive != tabs.monEnquete\"><button type=\"button\" \nclass=\"nl-Btn\" ng-click=\"openAddFile()\">+ Archiver une évaluation</button></div></div><div class=\"nl-Content\"><div \nclass=\"iv-SmallTabs-wrapper\" ng-if=\"!$root.user.isNonLqo\"><div class=\"iv-SmallTabs-item\" \nng-click=\"setActive(tabs.auto)\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.auto}\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/auto-eval.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Auto-évaluation</div></div><div class=\"iv-SmallTabs-item\" ng-if=\"!$root.user.isMini\" \nng-click=\"setActive(tabs.audit)\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.audit}\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/audit.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Audits</div></div><div class=\"iv-SmallTabs-item\" ng-click=\"setActive(tabs.client)\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.client}\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/tabs/client_mystere.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\">\n</md-icon><div>Satisfaction clients</div></div><div class=\"iv-SmallTabs-item\" ng-click=\"setActive(tabs.monEnquete)\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.monEnquete}\"><md-icon class=\"iv-SmallTabs-icon\" \nmd-svg-src=\"assets/icons/app/V3/tabs/client_mystere.svg\" class=\"md-default-theme\" role=\"img\" aria-hidden=\"true\">\n</md-icon><div>Mon enquête</div></div><div class=\"iv-SmallTabs-item\" ng-if=\"!$root.user.isMini\" \nng-click=\"setActive(tabs.flash)\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.flash}\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/flash.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Flash qualité</div></div></div><div class=\"iv-SmallTabs-wrapper\" \nng-if=\"$root.user.isNonLqo\"><div class=\"iv-SmallTabs-item\" ng-if=\"$root.autoEvalAffichable()\" \nng-click=\"setActive(tabs.auto)\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.auto}\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/auto-eval.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Auto-évaluation</div></div><div class=\"iv-SmallTabs-item\" \nng-click=\"setActive(tabs.monEnquete)\" ng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.monEnquete}\"><md-icon \nclass=\"iv-SmallTabs-icon\" md-svg-src=\"assets/icons/app/V3/tabs/client_mystere.svg\" class=\"md-default-theme\" role=\"img\" \naria-hidden=\"true\"></md-icon><div>Mon enquête</div></div></div><div class=\"mt-20\"><aeq-accueil-campagne \nng-if=\"tabActive === tabs.auto\"></aeq-accueil-campagne><div class=\"aeq-historique-tete\" \nng-if=\"tabActive === tabs.auto && autos.length && !$root.user.isNonLqo\"><h2 class=\"aeq-historique-titre\">\nHistorique des auto-évaluations</h2><p class=\"aeq-historique-texte\">\nRetrouvez vos auto-évaluations des années précédentes et consultez leurs résultats.</p></div><div \nng-if=\"tabActive === tabs.auto && !$root.user.isNonLqo\" class=\"nl-listing\"><div \nng-click=\"display(document, tabs.auto)\" ng-repeat=\"document in autos track by document.id\"><div \nclass=\"nl-listing-item\"><div layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button nl-listing-item-button\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/file.svg\" class=\"iv-listing-item-icon-file\" ng-if=\"!document.fromPhsq\"></md-icon>\n<md-icon md-svg-src=\"assets/icons/app/V3/phsq.svg\" class=\"iv-listing-item-icon-file\" ng-if=\"document.fromPhsq\">\n</md-icon></md-button><div flex layout=\"row\" layout-align=\"start center\"><div flex=\"50\" \nclass=\"text-truncate nl-listing-item-title\">{{document.name}}</div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>{{document.uploadDate | date: \'dd/MM/yyyy\'}}</div></div></div>\n</div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(document, tabs.auto)\">Télécharger\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"addToODJ(document, tabs.auto)\">Ajouter à l\'ordre du jour</md-button>\n</md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openDeleteDocument(document, tabs.auto)\">Supprimer</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div><div ng-if=\"tabActive === tabs.audit\" class=\"nl-listing\"><div\n ng-click=\"display(document, tabs.audit)\" ng-repeat=\"document in audits track by document.id\"><div \nclass=\"nl-listing-item\"><div layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button nl-listing-item-button\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/file.svg\" class=\"iv-listing-item-icon-file\"></md-icon></md-button><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" class=\"text-truncate nl-listing-item-title\">{{document.name}}\n</div><div flex=\"50\" class=\"nl-indicator-header-infos2\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{document.uploadDate | date: \'dd/MM/yyyy\'}}</div><div><button class=\"iv-BtnIcon\" type=\"button\" \nng-click=\"event.preventDefault()\" ng-if=\"document.confidential\"><md-icon md-svg-src=\"./assets/icons/app/V3/hide.svg\">\n</md-icon></button><md-tooltip md-direction=\"bottom\">Visible uniquement par le titulaire et le Responsable Qualité\n</md-tooltip></div></div></div></div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu \nclass=\"iv-Menu mr-10\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(document, tabs.audit)\">Télécharger\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"addToODJ(document, tabs.audit)\">Ajouter à l\'ordre du jour</md-button>\n</md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"setRestricted(document, tabs.audit)\"><div ng-if=\"!document.confidential\">\nMasquer pour l\'équipe</div><div ng-if=\"document.confidential\">Démasquer pour l\'équipe</div></md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openDeleteDocument(document, tabs.audit)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>\n</div></div></div></div></div><div ng-if=\"tabActive === tabs.client\" class=\"nl-listing\"><div \nng-click=\"display(document, tabs.client)\" ng-repeat=\"document in satisfactions track by document.id\"><div \nclass=\"nl-listing-item\"><div layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button nl-listing-item-button\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/file.svg\" class=\"iv-listing-item-icon-file\" ng-if=\"!document.fromPhsq\"></md-icon>\n<md-icon md-svg-src=\"assets/icons/app/V3/phsq.svg\" class=\"iv-listing-item-icon-file\" ng-if=\"document.fromPhsq\">\n</md-icon></md-button><div flex layout=\"row\" layout-align=\"start center\"><div flex=\"50\" \nclass=\"text-truncate nl-listing-item-title\">{{document.name}}</div><div flex=\"50\" class=\"nl-indicator-header-infos2\" \nlayout=\"row\" layout-align=\"space-between center\"><div>{{document.uploadDate | date: \'dd/MM/yyyy\'}}</div></div></div>\n</div><div flex=\"nogrow\" layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"download(document, tabs.client)\">Télécharger\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"addToODJ(document, tabs.client)\">Ajouter à l\'ordre du jour</md-button>\n</md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openDeleteDocument(document, tabs.client)\">Supprimer</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div><div ng-if=\"tabActive === tabs.monEnquete\"><div class=\"\"><div\n ng-if=\"questionnaireCampaignContext && questionnaireCampaignContext.discoveryPharmacy\" class=\"mon-enquete-upsell\"><div\n class=\"mon-enquete-upsell__deco\"></div><div class=\"mon-enquete-upsell__deco mon-enquete-upsell__deco--small\"></div>\n<div class=\"mon-enquete-upsell__badge\"><md-icon md-font-icon=\"icon-verified\" class=\"s18\"></md-icon><span>\nRéservé Certification ISO 9001 - QMS Pharma®</span></div><h2 class=\"mon-enquete-upsell__title\"><span \nclass=\"mon-enquete-upsell__title-icon\"><md-icon md-font-icon=\"icon-chart-bar\" class=\"s24\"></md-icon></span><span>\nActivez votre enquête patient</span></h2><p class=\"mon-enquete-upsell__lead\">\nL’accès à l’enquête est réservé aux officines engagées dans une démarche qualité <strong>\nCertification ISO 9001 – QMS Pharma®</strong>.</p><ul class=\"mon-enquete-upsell__benefits\"><li><div \nclass=\"mon-enquete-upsell__benefit-icon\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon></div><div><div \nclass=\"mon-enquete-upsell__benefit-title\">Mesurer la satisfaction de vos patients</div><div \nclass=\"mon-enquete-upsell__benefit-desc\">Un dispositif structurant pour objectiver concrètement la qualité perçue.\n</div></div></li><li><div class=\"mon-enquete-upsell__benefit-icon\"><md-icon md-font-icon=\"icon-trending-up\" \nclass=\"s16\"></md-icon></div><div><div class=\"mon-enquete-upsell__benefit-title\">Piloter votre amélioration continue\n</div><div class=\"mon-enquete-upsell__benefit-desc\">\nDes indicateurs fiables pour suivre votre progression dans le temps.</div></div></li><li><div \nclass=\"mon-enquete-upsell__benefit-icon\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon></div><div><div \nclass=\"mon-enquete-upsell__benefit-title\">Valoriser votre officine</div><div class=\"mon-enquete-upsell__benefit-desc\">\nRenforcez votre positionnement auprès de vos patients et partenaires.</div></div></li></ul><div \nclass=\"mon-enquete-upsell__cta-bar\"><button type=\"button\" class=\"mon-enquete-upsell__cta\" \nng-click=\"openQualityApproach()\"><span>Découvrir la démarche qualité</span><md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"s18\"></md-icon></button> <span class=\"mon-enquete-upsell__hint\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"s14\"></md-icon><span>Utilisé par près de 2&nbsp;700 officines certifiées ISO 9001 - QMS Pharma®</span></span>\n</div></div><div \nng-if=\"questionnaireCampaignContext && !questionnaireCampaignContext.discoveryPharmacy && !questionnaireCampaignContext.campaignActive\">\n<div ng-if=\"questionnaireCampaignContext.campaignClosed\" class=\"qs-toolbox qs-toolbox--closed-campaign\"><div \nclass=\"qs-closed-campaign-summary\"><div class=\"qs-closed-campaign-summary__head\"><span \nclass=\"qs-closed-campaign-summary__status\"><span class=\"qs-closed-campaign-summary__status-dot\" aria-hidden=\"true\">\n</span> Campagne clôturée</span><h2 class=\"qs-closed-campaign-summary__title\">\nJournées Qualité {{questionnaireCampaignContext.closedCampaignReportYear || 2026}}</h2><p \nclass=\"qs-closed-campaign-summary__lead\">Vos retours patients/clients :</p><div \nclass=\"qs-closed-campaign-summary__kpi-value\">{{getEnqueteTotalCompleted() !== null ? getEnqueteTotalCompleted() : 0}}\n</div><p></p><p class=\"qs-closed-campaign-summary__lead\">\nMerci pour votre engagement, vos résultats complets sont désormais disponibles pour consultation, analyse et partage avec votre équipe.\n</p></div><div class=\"qs-closed-campaign-summary__kpi\"><div class=\"qs-closed-campaign-summary__kpi-main\"><div \nclass=\"qs-tool-card-icon qs-tool-card-icon--report\" aria-hidden=\"true\"><svg viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/><path \nd=\"M11 18h10M11 22h7M11 14h6\"/></svg></div><div class=\"qs-tool-card-body\"><span \nclass=\"qs-tool-card-type qs-tool-card-type--report\">Rapport — synthèse annuelle</span><h4 class=\"qs-tool-card-title\">\nSynthèse annuelle – Téléchargez vos résultats 2026</h4><p class=\"qs-tool-card-meta\" \nng-if=\"questionnaireCampaignContext.showClosedCampaignReportDownload\">\nAnalyse détaillée de votre campagne {{questionnaireCampaignContext.closedCampaignReportYear || \'\'}} : indicateurs, verbatims, profils patients.\n</p><p class=\"qs-tool-card-meta qs-tool-card-meta--soon\" \nng-if=\"!questionnaireCampaignContext.showClosedCampaignReportDownload\"><svg viewBox=\"0 0 16 16\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle \ncx=\"8\" cy=\"8\" r=\"6\"/><path d=\"M8 5v3l2 2\"/></svg> Disponible prochainement</p></div></div><div \nclass=\"qs-tool-card-actions\"><button type=\"button\" class=\"qs-tool-card-btn\" \nng-if=\"questionnaireCampaignContext.showClosedCampaignReportDownload\" ng-click=\"downloadClosedCampaignReportPdf()\"><svg\n viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M8 2v9m0 0l-3-3m3 3l3-3M3 13h10\"/></svg> Télécharger le PDF\n</button></div></div></div><div class=\"qs-toolbox-header\"><h3 class=\"qs-toolbox-title\">Supports de restitution</h3><p \nclass=\"qs-toolbox-subtitle\">Personnalisez votre affiche de communication et téléchargez votre rapport annuel.</p></div>\n<div class=\"qs-toolbox-grid\"><article class=\"qs-tool-card qs-tool-card--actions qs-tool-card--feature\"><div \nclass=\"qs-tool-card-icon qs-tool-card-icon--poster\" aria-hidden=\"true\"><svg viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"5\" y=\"4\" width=\"22\" \nheight=\"24\" rx=\"2\"/><path d=\"M9 10h14M9 14h10M9 18h14M9 22h8\"/></svg></div><div class=\"qs-tool-card-body\"><span \nclass=\"qs-tool-card-type qs-tool-card-type--poster\">Affiche — Communication</span><h4 class=\"qs-tool-card-title\">\nAffiche de résultats</h4><p class=\"qs-tool-card-meta\">\nPersonnalisez vos mots-clés et générez un visuel prêt à imprimer pour valoriser vos résultats auprès de vos patients.\n</p></div><div class=\"qs-tool-card-actions\"><button type=\"button\" class=\"qs-tool-card-btn qs-tool-card-btn--secondary\" \nng-if=\"questionnaireCampaignContext.showClosedCampaignResultsPosterDownload\" \nng-click=\"downloadClosedCampaignResultsPosterPdf()\" title=\"Télécharger la dernière version générée\"><svg \nviewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M8 2v9m0 0l-3-3m3 3l3-3M3 13h10\"/></svg> Télécharger</button> \n<button type=\"button\" class=\"qs-tool-card-btn\" ng-click=\"openResultsPosterPopup()\" ng-disabled=\"resultsPosterLoading\">\n<svg ng-if=\"!resultsPosterLoading\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M11 2l3 3-8 8H3v-3l8-8z\"/></svg> <span \nng-if=\"!resultsPosterLoading\">\n{{questionnaireCampaignContext.showClosedCampaignResultsPosterDownload ? \'Personnaliser\' : \'Personnaliser et générer\'}}\n</span> <span ng-if=\"resultsPosterLoading\" class=\"qs-tool-card-btn__spinner\" aria-hidden=\"true\"></span> <span \nng-if=\"resultsPosterLoading\">Préparation…</span></button></div></article></div></div><section class=\"qs-teaser\" \nng-if=\"shouldShowCampaignTeaser()\"><header class=\"qs-teaser-hero\"><div class=\"qs-teaser-rocket\" aria-hidden=\"true\">🚀\n</div><h1 class=\"qs-teaser-title\">Journées Qualité {{getCampaignYear()}}</h1><div class=\"qs-teaser-launch-row\"><div \nclass=\"qs-teaser-launch-badge\">Démarrage officiel : <strong>\n{{questionnaireCampaignContext.dateDebutCampagne | date:\'dd MMMM yyyy\'}}</strong></div><div \nclass=\"qs-teaser-countdown\" ng-if=\"getDaysUntilCampaignStart() > 0\">Plus que <strong>{{getDaysUntilCampaignStart()}}\n</strong> jour<span ng-if=\"getDaysUntilCampaignStart() > 1\">s</span></div></div></header><div \nclass=\"qs-teaser-pillars\"><article class=\"qs-teaser-pillar\"><div class=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">🎯\n</div><h3 class=\"qs-teaser-pillar-title\">Mieux comprendre</h3><p class=\"qs-teaser-pillar-desc\">\nMieux comprendre les patients et leurs besoins au quotidien.</p></article><article class=\"qs-teaser-pillar\"><div \nclass=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">✅</div><h3 class=\"qs-teaser-pillar-title\">Améliorer les pratiques</h3>\n<p class=\"qs-teaser-pillar-desc\">Faire évoluer les pratiques officinales vers plus d\'excellence.</p></article><article \nclass=\"qs-teaser-pillar\"><div class=\"qs-teaser-pillar-icon\" aria-hidden=\"true\">⭐</div><h3 \nclass=\"qs-teaser-pillar-title\">Renforcer la qualité</h3><p class=\"qs-teaser-pillar-desc\">\nRenforcer la qualité de service au plus proche de vos patients.</p></article></div><p class=\"qs-teaser-mobilisation\">\nChaque année, les Journées Qualité mobilisent les officines autour d\'un objectif commun. <strong>\nNous vous attendons nombreux pour cette nouvelle aventure.</strong></p><section class=\"qs-teaser-block\"><h2 \nclass=\"qs-teaser-block-title\">🎬 Ressources à votre disposition</h2><div class=\"qs-teaser-resources\"><article \nclass=\"qs-teaser-resource\"><div class=\"qs-teaser-resource-icon\" aria-hidden=\"true\">🎬</div><h4 \nclass=\"qs-teaser-resource-title\">Vidéo de présentation</h4><p class=\"qs-teaser-resource-desc\">\nDécouvrez la démarche Journées Qualité {{getCampaignYear()}} en vidéo. Un support idéal pour embarquer toute votre équipe dans l\'aventure dès le premier jour.\n</p><div style=\"padding:56.25% 0 0 0;position:relative;margin-top:10px\"><iframe \nsrc=\"https://player.vimeo.com/video/1195668152?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479\" \nframeborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share\" \nreferrerpolicy=\"strict-origin-when-cross-origin\" style=\"position:absolute;top:0;left:0;width:100%;height:100%\" \ntitle=\"Vidéo de présentation Journées Qualité\"></iframe></div></article><article class=\"qs-teaser-resource\"><div \nclass=\"qs-teaser-resource-icon\" aria-hidden=\"true\">📖</div><h4 class=\"qs-teaser-resource-title\">Mode opératoire</h4><p \nclass=\"qs-teaser-resource-desc\">\nUn guide détaillé est disponible pour vous accompagner pas à pas dans l\'organisation et le déploiement de votre campagne officine.\n</p><a class=\"qs-teaser-resource-link qs-teaser-resource-link--button\" \nhref=\"/assets/documents/Mode-Operatoire-JQ-LQO-2026.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" \naria-label=\"Ouvrir le guide du mode opératoire dans un nouvel onglet\"><span>Ouvrir le guide</span></a></article></div>\n</section></section><p class=\"mb-10\" \nng-if=\"!questionnaireCampaignContext.campaignClosed && !shouldShowCampaignTeaser()\">\n{{getOutsideCampaignMessage(questionnaireCampaignContext)}}</p></div><div \nng-if=\"questionnaireCampaignContext && !questionnaireCampaignContext.discoveryPharmacy && questionnaireCampaignContext.campaignActive\">\n<div class=\"iv-SmallTabs-wrapper mb-20\"><div class=\"iv-SmallTabs-item\" \nng-click=\"setMonEnqueteSubTab(monEnqueteSubTabs.enquete)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteSubTabActive === monEnqueteSubTabs.enquete}\"><div>Enquête</div></div><div \nclass=\"iv-SmallTabs-item\" ng-click=\"setMonEnqueteSubTab(monEnqueteSubTabs.toolbox)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteSubTabActive === monEnqueteSubTabs.toolbox}\"><div>Boîte à outils</div>\n</div><div class=\"iv-SmallTabs-item\" ng-click=\"setMonEnqueteSubTab(monEnqueteSubTabs.results)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteSubTabActive === monEnqueteSubTabs.results}\"><div>Mes résultats</div>\n</div></div><div ng-if=\"monEnqueteSubTabActive === monEnqueteSubTabs.enquete\" class=\"qs-enq\"><div \nclass=\"qs-enq-status\"><div class=\"qs-enq-status-main\"><span class=\"qs-enq-status-badge\"><span \nclass=\"qs-enq-status-dot\"></span> Campagne en cours </span><span class=\"qs-enq-status-period\" \nng-if=\"questionnaireCampaignContext.dateDebutCampagne && questionnaireCampaignContext.dateFinCollecte\">\ndu {{questionnaireCampaignContext.dateDebutCampagne | date:\'dd/MM/yyyy\'}} au {{questionnaireCampaignContext.dateFinCollecte | date:\'dd/MM/yyyy\'}}\n</span></div><div class=\"qs-enq-status-metrics\"><div class=\"qs-enq-status-metric\"><span \nclass=\"qs-enq-status-metric-value\"><span ng-if=\"getEnqueteTotalCompleted() !== null\">{{getEnqueteTotalCompleted()}}\n</span> <span ng-if=\"getEnqueteTotalCompleted() === null\" class=\"qs-enq-status-metric-empty\">—</span> </span><span \nclass=\"qs-enq-status-metric-label\">réponses collectées</span></div></div></div><div class=\"qs-enq-groups-row\"><div \nclass=\"qs-enq-group\"><div class=\"qs-enq-group-header\"><h3 class=\"qs-enq-group-title\">Envoyer l\'enquête à un client</h3>\n<p class=\"qs-enq-group-desc\">Transmettez le questionnaire directement après le passage en officine.</p></div><div \nclass=\"qs-enq-grid qs-enq-grid--stack\"><div class=\"qs-enq-card qs-enq-card--hero\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--sms\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"/>\n</svg></span><div class=\"qs-enq-card-head-text\"><div class=\"qs-enq-card-title\">Par SMS</div><div \nclass=\"qs-enq-card-desc\">Le plus utilisé — numéro mobile du client</div></div><span class=\"qs-enq-card-count\" \nng-if=\"getEnqueteChannelStats(\'SMS\')\" \ntitle=\"{{getEnqueteChannelStats(\'SMS\').completed}} complétée(s) sur {{getEnqueteChannelStats(\'SMS\').sent}} envoyée(s)\">\n{{getEnqueteChannelStats(\'SMS\').completed}} / {{getEnqueteChannelStats(\'SMS\').sent}}</span></div><div \nclass=\"qs-enq-card-body\"><div class=\"qs-enq-card-tel\"><input type=\"tel\" class=\"qs-enq-card-tel-input\" iti-phone \ninitial-country=\"fr\" ng-model=\"smsData.mobile\"></div><button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--primary\" ng-click=\"sendQuestionnaireBySms()\" \nng-disabled=\"!smsData.mobile\">Envoyer le SMS</button></div><p class=\"qs-enq-card-help\">\nSélectionnez le pays via le drapeau, puis tapez le numéro mobile au format local (avec ou sans le 0). Métropole, DOM-TOM et destinations Brevo accessibles.\n</p><div class=\"qs-enq-card-note qs-enq-card-note--warning\"><md-icon md-svg-src=\"assets/icons/app/V3/information.svg\" \nclass=\"qs-enq-card-note-icon\" aria-hidden=\"true\"></md-icon><span>\nLa réception du SMS peut prendre jusqu\'à 5 minutes. Pour des raisons légales, les opérateurs téléphoniques limitent à 2 envois du même message vers un même numéro afin d\'éviter le spam.\n</span></div><div class=\"qs-enq-card-note\"><md-icon md-svg-src=\"assets/icons/app/V3/information.svg\" \nclass=\"qs-enq-card-note-icon\" aria-hidden=\"true\"></md-icon><span>\nLe numéro de mobile saisi n\'est pas enregistré. Il est uniquement utilisé pour transmettre le SMS au client.</span>\n</div></div><div class=\"qs-enq-card\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--email\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"/><polyline points=\"22,6 12,13 2,6\"/>\n</svg></span><div class=\"qs-enq-card-head-text\"><div class=\"qs-enq-card-title\">Par email</div><div \nclass=\"qs-enq-card-desc\">Adresse email du client</div></div><span class=\"qs-enq-card-count\" \nng-if=\"getEnqueteChannelStats(\'EMAIL\')\" \ntitle=\"{{getEnqueteChannelStats(\'EMAIL\').completed}} complétée(s) sur {{getEnqueteChannelStats(\'EMAIL\').sent}} envoyée(s)\">\n{{getEnqueteChannelStats(\'EMAIL\').completed}} / {{getEnqueteChannelStats(\'EMAIL\').sent}}</span></div><div \nclass=\"qs-enq-card-body\"><md-input-container md-no-float \nclass=\"nl-Input-container nl-Input-container--no-error qs-enq-card-input\"><input type=\"email\" class=\"nl-Input-input\" \nng-model=\"emailData.email\" placeholder=\"client@exemple.fr\"></md-input-container><button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn\" ng-click=\"sendQuestionnaireByEmail()\" ng-disabled=\"emailSending\"><md-progress-circular \nmd-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"emailSending\"></md-progress-circular><span ng-if=\"!emailSending\">\nEnvoyer l\'email</span> <span ng-if=\"emailSending\" class=\"ml-2\">Envoi en cours...</span></button></div><div \nclass=\"qs-enq-card-note\"><md-icon md-svg-src=\"assets/icons/app/V3/information.svg\" class=\"qs-enq-card-note-icon\" \naria-hidden=\"true\"></md-icon><span>\nL\'adresse email saisie n\'est pas enregistrée. Elle est uniquement utilisée pour transmettre le questionnaire au client.\n</span></div></div></div></div><div class=\"qs-enq-group\"><div class=\"qs-enq-group-header\"><h3 \nclass=\"qs-enq-group-title\">Diffuser en libre-service</h3><p class=\"qs-enq-group-desc\">\nMettez le questionnaire à disposition. Les clients y accèdent quand ils veulent.</p></div><div \nclass=\"qs-enq-grid qs-enq-grid--stack\"><div class=\"qs-enq-card\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--qr\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" \nheight=\"7\" rx=\"1\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"/>\n<path d=\"M14 14h3v3h-3zM20 14v3M14 20h3v1M20 20v1\"/></svg></span><div class=\"qs-enq-card-head-text\"><div \nclass=\"qs-enq-card-title\">QR code à afficher</div><div class=\"qs-enq-card-desc\">\nTéléchargez l\'affiche complète ou seulement le QR code</div></div><span class=\"qs-enq-card-count\" \nng-if=\"getEnqueteChannelStats(\'QR_CODE\')\" title=\"{{getEnqueteChannelStats(\'QR_CODE\').completed}} complétée(s)\">\n{{getEnqueteChannelStats(\'QR_CODE\').completed}}</span></div><div class=\"qs-enq-card-body\"><button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" ng-click=\"downloadQrCodePdf()\">\nTélécharger l\'affiche avec le QR code</button> <button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--link\" ng-click=\"downloadQrCodePng()\">Télécharger le QR code</button>\n</div></div><div class=\"qs-enq-card\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--share\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18\" cy=\"5\" r=\"3\"/>\n<circle cx=\"6\" cy=\"12\" r=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"/><line \nx1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"/></svg></span><div class=\"qs-enq-card-head-text\"><div \nclass=\"qs-enq-card-title\">Lien à partager</div><div class=\"qs-enq-card-desc\">Réseaux sociaux, site web, newsletter\n</div></div><span class=\"qs-enq-card-count\" ng-if=\"getEnqueteChannelStats(\'RESEAUX_SOCIAUX\')\" \ntitle=\"{{getEnqueteChannelStats(\'RESEAUX_SOCIAUX\').completed}} complétée(s)\">\n{{getEnqueteChannelStats(\'RESEAUX_SOCIAUX\').completed}}</span></div><div class=\"qs-enq-card-body\"><button \ntype=\"button\" class=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" ng-click=\"copySocialLink()\">Copier le lien</button>\n</div></div></div></div><div class=\"qs-enq-group\"><div class=\"qs-enq-group-header\"><h3 class=\"qs-enq-group-title\">\nRecueillir sur place</h3><p class=\"qs-enq-group-desc\">\nFaites répondre en officine ou saisissez un questionnaire papier déjà rempli.</p></div><div \nclass=\"qs-enq-grid qs-enq-grid--stack\"><div class=\"qs-enq-card\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--tablet\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"2\" width=\"16\" \nheight=\"20\" rx=\"2\"/><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"/></svg></span><div class=\"qs-enq-card-head-text\"><div \nclass=\"qs-enq-card-title\">Depuis une tablette</div><div class=\"qs-enq-card-desc\">Le client répond en officine</div>\n</div><span class=\"qs-enq-card-count\" ng-if=\"getEnqueteChannelStats(\'TABLETTE\')\" \ntitle=\"{{getEnqueteChannelStats(\'TABLETTE\').completed}} complétée(s)\">{{getEnqueteChannelStats(\'TABLETTE\').completed}}\n</span></div><div class=\"qs-enq-card-body\"><button type=\"button\" class=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" \nng-click=\"copyTabletQuestionnaireLink()\">Copier le lien</button></div></div><div class=\"qs-enq-card\"><div \nclass=\"qs-enq-card-head\"><span class=\"qs-enq-card-icon qs-enq-card-icon--paper\" aria-hidden=\"true\"><svg \nviewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n<path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"/><polyline points=\"14 2 14 8 20 8\"/><line x1=\"9\" \ny1=\"13\" x2=\"15\" y2=\"13\"/><line x1=\"9\" y1=\"17\" x2=\"15\" y2=\"17\"/></svg></span><div class=\"qs-enq-card-head-text\"><div \nclass=\"qs-enq-card-title\">Saisir les réponses papier</div><div class=\"qs-enq-card-desc\">\nSaisir les réponses d\'un formulaire rempli</div></div><span class=\"qs-enq-card-count\" \nng-if=\"getEnqueteChannelStats(\'PAPIER\')\" title=\"{{getEnqueteChannelStats(\'PAPIER\').completed}} complétée(s)\">\n{{getEnqueteChannelStats(\'PAPIER\').completed}}</span></div><div class=\"qs-enq-card-body\"><button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" ng-click=\"openPaperQuestionnaire()\">Saisir les réponses</button>\n</div></div><div class=\"qs-enq-card\"><div class=\"qs-enq-card-head\"><span \nclass=\"qs-enq-card-icon qs-enq-card-icon--paper\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline \npoints=\"6 9 6 2 18 2 18 9\"/><path d=\"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2\"/><rect\n x=\"6\" y=\"14\" width=\"12\" height=\"8\"/></svg></span><div class=\"qs-enq-card-head-text\"><div class=\"qs-enq-card-title\">\nImprimer le questionnaire papier</div><div class=\"qs-enq-card-desc\">\nDeux formats disponibles au téléchargement - condensé sur 1 page ou aéré sur 2 pages.</div></div></div><div \nclass=\"qs-enq-card-body\"><button type=\"button\" class=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" \nng-click=\"downloadQuestionnaire1Page()\">Télécharger le questionnaire sur 1 page</button> <button type=\"button\" \nclass=\"nl-Btn qs-enq-card-btn qs-enq-card-btn--full\" ng-click=\"downloadQuestionnaire2Pages()\">\nTélécharger le questionnaire sur 2 pages</button></div></div></div></div></div><div class=\"mt-20 mon-enquete-text\" \nng-bind-html=\"getQuestionnaireDiffusionMessage()\"></div></div><div \nng-if=\"monEnqueteSubTabActive === monEnqueteSubTabs.toolbox\"><div class=\"qs-toolbox\"><div class=\"qs-toolbox-header\"><h3\n class=\"qs-toolbox-title\">Boîte à outils</h3><p class=\"qs-toolbox-subtitle\">\nRetrouvez ici l’ensemble des supports prêts à l’emploi pour lancer, diffuser et valoriser votre enquête patients.</p><p\n class=\"qs-toolbox-subtitle\">\nCes outils ont été conçus pour vous faire gagner du temps et maximiser le taux de participation ainsi que l’impact de vos résultats.\n</p><p class=\"qs-toolbox-subtitle\">\nVous retrouverez ici tous les outils nécessaires : mode d’emploi, fiches personnalisables (si souhaité) et supports de communication pour mobiliser et engager votre équipe.\n</p></div><div ng-if=\"toolboxLoading\" class=\"qs-toolbox-loading\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"34\"></md-progress-circular><p>Chargement de la boîte à outils…</p></div><div \nng-if=\"!toolboxLoading && !toolboxTools.length\" class=\"qs-toolbox-empty\"><div class=\"qs-toolbox-empty-icon\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 7h18l-2 13H5L3 7z\"/><path d=\"M8 7V5a4 4 0 1 1 8 0v2\"/></svg>\n</div><p class=\"qs-toolbox-empty-title\">Aucun outil disponible pour le moment</p><p class=\"qs-toolbox-empty-text\">\nLes ressources arriveront ici dès que le réseau PHSQ les publiera.</p></div><div \nng-if=\"!toolboxLoading && toolboxTools.length\" class=\"qs-toolbox-grid\"><article class=\"qs-tool-card\" \nng-repeat=\"tool in toolboxTools track by tool.id\"><div \nclass=\"qs-tool-card-icon qs-tool-card-icon--{{getToolboxToolIconKind(tool)}}\" aria-hidden=\"true\"><svg \nng-if=\"getToolboxToolIconKind(tool) === \'pdf\'\" viewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/><text x=\"16\" y=\"24\" \ntext-anchor=\"middle\" font-size=\"7\" font-weight=\"800\" fill=\"currentColor\" stroke=\"none\" style=\"font-family:inherit\">PDF\n</text></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'excel\'\" viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/><path \nd=\"M11 17l4 7M15 17l-4 7\"/></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'word\'\" viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/><path \nd=\"M10 17l2 7 2-5 2 5 2-7\"/></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'ppt\'\" viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/><rect x=\"10\" y=\"16\" width=\"7\" \nheight=\"8\" rx=\"1\"/></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'image\'\" viewBox=\"0 0 32 32\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"6\" width=\"24\" \nheight=\"20\" rx=\"2\"/><circle cx=\"12\" cy=\"14\" r=\"2\"/><path d=\"M28 22l-6-6-10 10\"/></svg> <svg \nng-if=\"getToolboxToolIconKind(tool) === \'video\'\" viewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"7\" width=\"20\" height=\"18\" rx=\"2\"/>\n<path d=\"M24 13l5-3v12l-5-3z\" fill=\"currentColor\"/></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'audio\'\" \nviewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><path d=\"M9 22V10l14-3v15\"/><circle cx=\"7\" cy=\"22\" r=\"3\"/><circle cx=\"21\" cy=\"22\" r=\"3\"/></svg>\n <svg ng-if=\"getToolboxToolIconKind(tool) === \'archive\'\" viewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"5\" y=\"4\" width=\"22\" height=\"24\" rx=\"2\"/>\n<path d=\"M16 4v8M16 14v2M16 18v2M16 22v2\"/></svg> <svg ng-if=\"getToolboxToolIconKind(tool) === \'file\'\" \nviewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><path d=\"M8 4h12l6 6v18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z\"/><path d=\"M20 4v6h6\"/>\n</svg></div><div class=\"qs-tool-card-body\"><span \nclass=\"qs-tool-card-type qs-tool-card-type--{{getToolboxToolIconKind(tool)}}\" ng-if=\"!tool.externalUrl\">\n{{getToolboxToolTypeLabel(tool)}}</span> <span class=\"qs-tool-card-type qs-tool-card-type--link\" \nng-if=\"tool.externalUrl\">Lien externe</span><h4 class=\"qs-tool-card-title\">{{tool.title}}</h4><span \nclass=\"qs-tool-card-subtitle\">{{tool.linkTitle}}</span></div><button type=\"button\" class=\"qs-tool-card-btn\" \nng-class=\"{\'qs-tool-card-btn--external\': tool.externalUrl}\" ng-click=\"downloadToolboxTool(tool)\" \naria-label=\"{{tool.externalUrl ? \'Accéder à\' : \'Télécharger\'}} {{tool.linkTitle || tool.title}}\"><svg \nng-if=\"!tool.externalUrl\" viewBox=\"0 0 20 20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M10 3v10M5 8l5 5 5-5M3 17h14\"/></svg> <svg \nng-if=\"tool.externalUrl\" viewBox=\"0 0 20 20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\" aria-hidden=\"true\"><path \nd=\"M11 3h6v6M9 11l8-8M16 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4\"/></svg> <span>\n{{tool.externalUrl ? \'Accéder\' : \'Télécharger\'}}</span></button></article></div></div></div><div \nng-if=\"monEnqueteSubTabActive === monEnqueteSubTabs.results\"><div class=\"qs-results-shell\"><div \nclass=\"iv-SmallTabs-wrapper mb-20 qs-results-tabs\"><div class=\"iv-SmallTabs-item\" \nng-click=\"setMonEnqueteResultsTab(monEnqueteResultsTabs.solicitations)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteResultsTabActive === monEnqueteResultsTabs.solicitations}\"><div>\nSollicitations</div></div><div class=\"iv-SmallTabs-item\" \nng-click=\"setMonEnqueteResultsTab(monEnqueteResultsTabs.verbatims)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteResultsTabActive === monEnqueteResultsTabs.verbatims}\"><div>Verbatims\n</div></div><div class=\"iv-SmallTabs-item\" ng-click=\"setMonEnqueteResultsTab(monEnqueteResultsTabs.detailCriteres)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteResultsTabActive === monEnqueteResultsTabs.detailCriteres}\"><div>\nDétail critères</div></div><div class=\"iv-SmallTabs-item\" \nng-click=\"setMonEnqueteResultsTab(monEnqueteResultsTabs.profils)\" \nng-class=\"{\'iv-Tabs-item--active\': monEnqueteResultsTabActive === monEnqueteResultsTabs.profils}\"><div>Profils</div>\n</div></div><div class=\"qs-results-state\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.solicitations && questionnaireSolicitationStatsLoading\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular></div><div \nclass=\"qs-results-state\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.verbatims && questionnaireVerbatimStatsLoading && !questionnaireVerbatimStats\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular></div><div \nclass=\"qs-results-state\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.detailCriteres && questionnaireCriteriaDetailsStatsLoading\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular></div><div \nclass=\"qs-results-state\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.profils && questionnaireProfileStatsLoading\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"34\"></md-progress-circular></div><div \nclass=\"qs-results-error\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.solicitations && !questionnaireSolicitationStatsLoading && questionnaireSolicitationStatsError\">\n<div class=\"qs-results-error-title\">Impossible de charger les résultats pour le moment.</div><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"refreshQuestionnaireSolicitationStats(true)\">Réessayer</button></div><div \nclass=\"qs-results-error\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.verbatims && !questionnaireVerbatimStatsLoading && questionnaireVerbatimStatsError\">\n<div class=\"qs-results-error-title\">Impossible de charger les verbatims pour le moment.</div><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" \nng-click=\"refreshQuestionnaireVerbatimStats(true, questionnaireVerbatimPagination.page)\">Réessayer</button></div><div \nclass=\"qs-results-error\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.detailCriteres && !questionnaireCriteriaDetailsStatsLoading && questionnaireCriteriaDetailsStatsError\">\n<div class=\"qs-results-error-title\">Impossible de charger le détail des critères pour le moment.</div><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"refreshQuestionnaireCriteriaDetailsStats(true)\">Réessayer\n</button></div><div class=\"qs-results-error\" \nng-if=\"monEnqueteResultsTabActive === monEnqueteResultsTabs.profils && !questionnaireProfileStatsLoading && questionnaireProfileStatsError\">\n<div class=\"qs-results-error-title\">Impossible de charger les profils pour le moment.</div><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"refreshQuestionnaireProfileStats(true)\">Réessayer</button></div><div \nng-if=\"!questionnaireSolicitationStatsLoading && !questionnaireSolicitationStatsError && monEnqueteResultsTabActive === monEnqueteResultsTabs.solicitations && questionnaireSolicitationStats\" \nclass=\"qs-solic\"><div class=\"qs-solic-header\"><h3 class=\"qs-solic-title\">\nSollicitations {{questionnaireSolicitationStats.currentCampaignYear}}</h3><p class=\"qs-solic-subtitle\">\nSuivi des envois et des réponses, ventilé par canal de diffusion.</p></div><div class=\"qs-solic-kpis\"><div \nclass=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--sent\" aria-hidden=\"true\"><svg \nviewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n<path d=\"M22 2 11 13\"/><path d=\"M22 2l-7 20-4-9-9-4 20-7z\"/></svg></div><div class=\"qs-solic-kpi-body\"><div \nclass=\"qs-solic-kpi-value\">{{getSolicitationTotalSent()}}</div><div class=\"qs-solic-kpi-label\">Sollicitations envoyées\n</div></div></div><div class=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--completed\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 6L9 17l-5-5\"/></svg></div><div class=\"qs-solic-kpi-body\">\n<div class=\"qs-solic-kpi-value\">{{getSolicitationTotalCompleted()}}</div><div class=\"qs-solic-kpi-label\">\nRéponses complètes</div></div></div><div class=\"qs-solic-kpi\"><div class=\"qs-solic-kpi-icon qs-solic-kpi-icon--rate\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M7 15l4-8 2 5 4-3\"/></svg></div><div \nclass=\"qs-solic-kpi-body\"><div class=\"qs-solic-kpi-value\" ng-if=\"getSolicitationCompletionRate() !== null\">\n{{getSolicitationCompletionRate()}}<small>%</small></div><div class=\"qs-solic-kpi-value qs-solic-kpi-value--empty\" \nng-if=\"getSolicitationCompletionRate() === null\">—</div><div class=\"qs-solic-kpi-label\">Taux de complétion</div><div \nclass=\"qs-solic-kpi-sub\" ng-if=\"getSolicitationTotalSent() > 0\">sur {{getSolicitationTotalSent()}} envoi<span \nng-if=\"getSolicitationTotalSent() !== 1\">s</span></div></div></div></div><div class=\"qs-solic-channels-header\"><h4 \nclass=\"qs-solic-channels-title\">Détail par canal</h4></div><div class=\"qs-solic-channels\"><article \nclass=\"qs-solic-channel\" ng-repeat=\"ch in getSolicitationChannelList() track by ch.channel\"><div \nclass=\"qs-solic-channel-head\"><span \nclass=\"qs-solic-channel-icon qs-solic-channel-icon--{{getSolicitationChannelIconKind(ch.channel)}}\" aria-hidden=\"true\">\n<svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'sms\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z\"/>\n</svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'email\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z\"/><polyline points=\"22,6 12,13 2,6\"/>\n</svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'qr\'\" viewBox=\"0 0 24 24\" fill=\"none\" \nstroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" \nheight=\"7\" rx=\"1\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"/>\n<path d=\"M14 14h3v3h-3zM20 14v3M14 20h3v1M20 20v1\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'share\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18\" cy=\"5\" r=\"3\"/><circle cx=\"6\" cy=\"12\" \nr=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"/><line x1=\"15.41\" y1=\"6.51\" \nx2=\"8.59\" y2=\"10.49\"/></svg> <svg ng-if=\"getSolicitationChannelIconKind(ch.channel) === \'tablet\'\" viewBox=\"0 0 24 24\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"2\" \nwidth=\"16\" height=\"20\" rx=\"2\"/><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'paper\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path \nd=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"/><polyline points=\"14 2 14 8 20 8\"/><line x1=\"9\" \ny1=\"13\" x2=\"15\" y2=\"13\"/><line x1=\"9\" y1=\"17\" x2=\"15\" y2=\"17\"/></svg> <svg \nng-if=\"getSolicitationChannelIconKind(ch.channel) === \'other\'\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><line x1=\"12\" y1=\"8\" \nx2=\"12\" y2=\"12\"/><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\"/></svg></span><div class=\"qs-solic-channel-name\">{{ch.label}}\n</div><div class=\"qs-solic-channel-rate\" ng-if=\"getSolicitationChannelRate(ch) !== null\">\n{{getSolicitationChannelRate(ch)}}%</div><div class=\"qs-solic-channel-rate qs-solic-channel-rate--empty\" \nng-if=\"getSolicitationChannelRate(ch) === null\">—</div></div><div class=\"qs-solic-channel-bar\" ng-if=\"ch.sent > 0\"><div\n class=\"qs-solic-channel-bar-fill\" ng-style=\"{width: (ch.completed / ch.sent * 100) + \'%\'}\"></div></div><div \nclass=\"qs-solic-channel-bar qs-solic-channel-bar--empty\" ng-if=\"!ch.sent\"></div><div class=\"qs-solic-channel-numbers\">\n<span><strong>{{ch.completed}}</strong> complétée<span ng-if=\"ch.completed !== 1\">s</span></span> <span \nclass=\"qs-solic-channel-sep\">·</span> <span>{{ch.sent}} envoyée<span ng-if=\"ch.sent !== 1\">s</span></span></div>\n</article></div><div class=\"qs-results-card qs-solic-status-help\"><div class=\"qs-solic-status-help-icon\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" \nstroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><path d=\"M12 8h.01\"></path><path d=\"M11 12h1v4h1\">\n</path></svg></div><div class=\"qs-solic-status-help-content\"><div class=\"qs-solic-status-help-title\">\nComment lire ces statuts ?</div><p class=\"qs-solic-status-help-line\"><strong>Envoyé</strong>\n - Sollicitation transmise au client (SMS, email) ou lien généré (QR code, tablette, papier, lien partagé).</p><p \nclass=\"qs-solic-status-help-line\"><strong>Partielle</strong>\n - Le client a ouvert le questionnaire et commencé à répondre, sans aller jusqu\'au bout. N\'est pas comptabilisé dans les graphiques de résultats.\n</p><p class=\"qs-solic-status-help-line\"><strong>Complète</strong>\n - Le client a soumis l\'ensemble du questionnaire jusqu\'à la confirmation finale.</p><p \nclass=\"qs-solic-status-help-note\">\nÀ noter : un canal pour lequel aucun envoi ni accès n\'a été enregistré n\'est pas comptabilisé.</p></div></div><div \nclass=\"qs-results-card qs-solic-chart\"><div class=\"qs-results-card-title\">Vue histogramme</div><div \nclass=\"qs-results-card-caption\">Nombre de réponses complétées par canal d\'origine.</div><div \nclass=\"qs-results-chart-shell\"><canvas id=\"qsSolicitationsCurrentChart\" height=\"110\"></canvas></div></div><div \nclass=\"qs-results-card qs-solic-historical\" ng-if=\"questionnaireSolicitationStats.historicalVisible\"><div \nclass=\"qs-results-card-header\"><div><div class=\"qs-results-card-title\">Sollicitations historiques</div><div \nclass=\"qs-results-card-caption\">Consultez les campagnes précédentes</div></div><div class=\"qs-results-year-switcher\" \nng-if=\"getHistoricalSolicitationCampaigns().length\"><button type=\"button\" class=\"qs-results-year-button\" \nng-repeat=\"campaign in getHistoricalSolicitationCampaigns() track by campaign.year\" \nng-click=\"selectHistoricalSolicitationYear(campaign.year)\" \nng-class=\"{\'is-active\': selectedHistoricalSolicitationYear === campaign.year}\">{{campaign.year}}</button></div></div>\n<div class=\"qs-results-chart-shell\"><canvas id=\"qsSolicitationsHistoricalChart\" height=\"120\"></canvas></div></div>\n</div><div \nng-if=\"!questionnaireVerbatimStatsError && monEnqueteResultsTabActive === monEnqueteResultsTabs.verbatims && questionnaireVerbatimStats\">\n<div class=\"qs-results-card\" id=\"qsClientVerbatimTableAnchor\" \nng-class=\"{\'qs-results-card--loading\': questionnaireVerbatimStatsLoading}\"><div class=\"qs-results-card__overlay\" \nng-if=\"questionnaireVerbatimStatsLoading\" aria-hidden=\"true\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"34\"></md-progress-circular></div><div class=\"qs-results-card-title\">\nCommentaires {{questionnaireVerbatimStats.campaignYear}}</div><div class=\"qs-results-card-caption\">\n{{questionnaireVerbatimStats.questionLabel}}</div><div class=\"qs-results-card-meta\">\n{{questionnaireVerbatimStats.commentCount || 0}} commentaires trouvés <span \nng-if=\"questionnaireVerbatimStats.searchText\">pour «&nbsp;{{questionnaireVerbatimStats.searchText}}&nbsp;»</span></div>\n<div class=\"qs-verbatim-toolbar\"><div class=\"qs-verbatim-search\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"s16 qs-verbatim-search__icon\"></md-icon><input type=\"text\" class=\"qs-verbatim-search__input\" \nng-model=\"questionnaireVerbatimPagination.searchText\" ng-change=\"onQuestionnaireVerbatimSearchChange()\" \nplaceholder=\"Rechercher dans les commentaires\"> <button type=\"button\" class=\"qs-verbatim-search__clear\" \nng-if=\"questionnaireVerbatimPagination.searchText\" ng-click=\"clearQuestionnaireVerbatimSearch()\" \naria-label=\"Effacer la recherche\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"downloadVerbatimXlsx()\">Exporter en Excel</button></div><div \nclass=\"qs-verbatim-empty\" ng-if=\"!(questionnaireVerbatimStats.comments && questionnaireVerbatimStats.comments.length)\">\n<span ng-if=\"!questionnaireVerbatimStats.searchText\">Aucun commentaire exploitable pour cette campagne.</span> <span \nng-if=\"questionnaireVerbatimStats.searchText\">\nAucun commentaire ne correspond à votre recherche «&nbsp;{{questionnaireVerbatimStats.searchText}}&nbsp;».</span></div>\n<div class=\"qs-verbatim-table qs-verbatim-table--comments\" \nng-if=\"questionnaireVerbatimStats.comments && questionnaireVerbatimStats.comments.length\"><div \nclass=\"qs-verbatim-row qs-verbatim-row--head\"><div class=\"qs-verbatim-cell qs-verbatim-cell-date\">Date de réponse</div>\n<div class=\"qs-verbatim-cell qs-verbatim-cell-comment\">{{questionnaireVerbatimStats.questionLabel}}</div></div><div \nclass=\"qs-verbatim-row\" ng-repeat=\"comment in questionnaireVerbatimStats.comments track by $index\"><div \nclass=\"qs-verbatim-cell qs-verbatim-cell-date\">{{comment.responseDateTime | date:\'dd/MM/yyyy HH:mm:ss\'}}</div><div \nclass=\"qs-verbatim-cell qs-verbatim-cell-comment\">{{comment.comment}}</div></div></div><div \nclass=\"qs-verbatim-pagination\" ng-if=\"questionnaireVerbatimPagination.pageCount > 1\"><ul class=\"pagination\"><li \nng-class=\"{disabled: questionnaireVerbatimPagination.page <= 1}\"><button type=\"button\" \nng-disabled=\"questionnaireVerbatimPagination.page <= 1\" \nng-click=\"onQuestionnaireVerbatimPageChange(questionnaireVerbatimPagination.page - 1, questionnaireVerbatimPagination.page)\">\n‹</button></li><li ng-repeat=\"pageNumber in getQuestionnaireVerbatimPageNumbers() track by $index\" \nng-class=\"{active: questionnaireVerbatimPagination.page === pageNumber, disabled: pageNumber === \'...\'}\"><button \ntype=\"button\" ng-if=\"pageNumber !== \'...\'\" ng-disabled=\"questionnaireVerbatimPagination.page === pageNumber\" \nng-click=\"onQuestionnaireVerbatimPageChange(pageNumber, questionnaireVerbatimPagination.page)\">{{pageNumber}}</button> \n<button type=\"button\" ng-if=\"pageNumber === \'...\'\" disabled=\"disabled\">...</button></li><li \nng-class=\"{disabled: questionnaireVerbatimPagination.page >= questionnaireVerbatimPagination.pageCount}\"><button \ntype=\"button\" ng-disabled=\"questionnaireVerbatimPagination.page >= questionnaireVerbatimPagination.pageCount\" \nng-click=\"onQuestionnaireVerbatimPageChange(questionnaireVerbatimPagination.page + 1, questionnaireVerbatimPagination.page)\">\n›</button></li></ul></div></div></div><div \nng-if=\"!questionnaireCriteriaDetailsStatsLoading && !questionnaireCriteriaDetailsStatsError && monEnqueteResultsTabActive === monEnqueteResultsTabs.detailCriteres && questionnaireCriteriaDetailsStats\">\n<div class=\"qs-criteria-grid\"><div class=\"qs-criteria-column\" \nng-repeat=\"scope in getCriteriaDetailsScopes() track by scope.key\"><div class=\"qs-criteria-column-title\">\n{{scope.title}}</div><div class=\"qs-results-card qs-criteria-empty\" \nng-if=\"!scope.data || !scope.data.questionnaireCount\">Aucun questionnaire disponible pour cette campagne.</div><div \nng-if=\"scope.data && scope.data.questionnaireCount\"><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">\nNote d\'appréciation globale</div><div class=\"qs-results-card-caption\">\nCampagne {{questionnaireCriteriaDetailsStats.campaignYear}}</div><div class=\"qs-criteria-gauge-shell\"><canvas \nid=\"qsCriteriaGaugeChart-{{scope.key}}\"></canvas><div class=\"qs-criteria-gauge-value\">\n{{formatCriteriaAverage(scope.data.overallSatisfactionAverage)}}</div></div><div class=\"qs-criteria-gauge-scale\"><span>\n0</span> <span>10</span></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">\nHistogramme de satisfaction</div><div class=\"qs-results-card-caption\">Votre satisfaction générale sur cette pharmacie\n</div><div class=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas \nid=\"qsCriteriaDistributionChart-{{scope.key}}\"></canvas></div></div><div class=\"qs-results-card\"><div \nclass=\"qs-results-card-title\">Évaluation de la pharmacie</div><div class=\"qs-results-card-caption\">\nVotre satisfaction générale sur cette pharmacie</div><div class=\"qs-criteria-legend\"><span \nclass=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" style=\"background-color: #df3e48\"></span>\nTrès insatisfait</span> <span class=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" \nstyle=\"background-color: #d2776c\"></span>Insatisfait</span> <span class=\"qs-criteria-legend-item\"><span \nclass=\"qs-criteria-legend-swatch\" style=\"background-color: #7c7c7c\"></span>Neutre</span> <span \nclass=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" style=\"background-color: #a1d273\"></span>\nSatisfait</span> <span class=\"qs-criteria-legend-item\"><span class=\"qs-criteria-legend-swatch\" \nstyle=\"background-color: #83c14f\"></span>Très satisfait</span></div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas id=\"qsCriteriaStackedChart-{{scope.key}}\">\n</canvas></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">Raisons de visite</div><div \nclass=\"qs-results-card-caption\">Ordonnance, sans ordonnance, parapharmacie, vaccination ou test, autre</div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas id=\"qsCriteriaVisitReasonsChart-{{scope.key}}\">\n</canvas></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">Priorités environnementales</div>\n<div class=\"qs-results-card-caption\">\nPour vous, la priorité en pharmacie pour protéger l’environnement, c’est surtout...</div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas id=\"qsCriteriaPrioritiesChart-{{scope.key}}\">\n</canvas></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">Recommandation</div><div \nclass=\"qs-results-card-caption\">Recommanderiez-vous notre pharmacie</div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas \nid=\"qsCriteriaRecommendationChart-{{scope.key}}\"></canvas></div></div><div class=\"qs-results-card\"><div \nclass=\"qs-results-card-title\">Prises en charge le plus utiles à la pharmacie en première intention</div><div \nclass=\"qs-results-card-caption\">\nParmi ces situations, les prises en charge le plus utiles à la pharmacie en première intention sont</div><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--criteria\"><canvas id=\"qsCriteriaUrgentCareChart-{{scope.key}}\">\n</canvas></div></div></div></div></div></div><div \nng-if=\"!questionnaireProfileStatsLoading && !questionnaireProfileStatsError && monEnqueteResultsTabActive === monEnqueteResultsTabs.profils && questionnaireProfileStats\">\n<div class=\"qs-profile-stack\"><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">\n{{questionnaireProfileStats.gender.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{questionnaireProfileStats.campaignYear}}</div><div class=\"qs-results-card-meta\">\nQuestionnaires : {{(questionnaireProfileStats.gender && questionnaireProfileStats.gender.questionnaireCount) || 0}}\n</div><div class=\"qs-profile-empty\" \nng-if=\"!(questionnaireProfileStats.gender && questionnaireProfileStats.gender.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div \nng-if=\"questionnaireProfileStats.gender && questionnaireProfileStats.gender.questionnaireCount\"><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas id=\"qsProfileGenderChart\"></canvas></div><div \nclass=\"qs-profile-table\"><div class=\"qs-profile-table-row qs-profile-table-row--head\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">Sexe</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{questionnaireProfileStats.campaignYear}}</div></div><div \nclass=\"qs-profile-table-row\" ng-repeat=\"item in questionnaireProfileStats.gender.values track by item.label\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">{{item.label}}</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{formatProfilePercentage(item.percentage)}}</div></div>\n</div></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">\n{{questionnaireProfileStats.ageRange.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{questionnaireProfileStats.campaignYear}}</div><div class=\"qs-results-card-meta\">\nQuestionnaires : {{(questionnaireProfileStats.ageRange && questionnaireProfileStats.ageRange.questionnaireCount) || 0}}\n</div><div class=\"qs-profile-empty\" \nng-if=\"!(questionnaireProfileStats.ageRange && questionnaireProfileStats.ageRange.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div \nng-if=\"questionnaireProfileStats.ageRange && questionnaireProfileStats.ageRange.questionnaireCount\"><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas id=\"qsProfileAgeRangeChart\"></canvas></div><div \nclass=\"qs-profile-table\"><div class=\"qs-profile-table-row qs-profile-table-row--head\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">Âge</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{questionnaireProfileStats.campaignYear}}</div></div><div \nclass=\"qs-profile-table-row\" ng-repeat=\"item in questionnaireProfileStats.ageRange.values track by item.label\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">{{item.label}}</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{formatProfilePercentage(item.percentage)}}</div></div>\n</div></div></div><div class=\"qs-results-card\"><div class=\"qs-results-card-title\">\n{{questionnaireProfileStats.regularCustomer.questionLabel}}</div><div class=\"qs-results-card-caption\">\nCampagne {{questionnaireProfileStats.campaignYear}}</div><div class=\"qs-results-card-meta\">\nQuestionnaires : {{(questionnaireProfileStats.regularCustomer && questionnaireProfileStats.regularCustomer.questionnaireCount) || 0}}\n</div><div class=\"qs-profile-empty\" \nng-if=\"!(questionnaireProfileStats.regularCustomer && questionnaireProfileStats.regularCustomer.questionnaireCount)\">\nAucune réponse exploitable pour cette campagne.</div><div \nng-if=\"questionnaireProfileStats.regularCustomer && questionnaireProfileStats.regularCustomer.questionnaireCount\"><div \nclass=\"qs-results-chart-shell qs-results-chart-shell--compact\"><canvas id=\"qsProfileRegularCustomerChart\"></canvas>\n</div><div class=\"qs-profile-table\"><div class=\"qs-profile-table-row qs-profile-table-row--head\"><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-label\">Réponse</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{questionnaireProfileStats.campaignYear}}</div></div><div \nclass=\"qs-profile-table-row\" ng-repeat=\"item in questionnaireProfileStats.regularCustomer.values track by item.label\">\n<div class=\"qs-profile-table-cell qs-profile-table-cell-label\">{{item.label}}</div><div \nclass=\"qs-profile-table-cell qs-profile-table-cell-value\">{{formatProfilePercentage(item.percentage)}}</div></div>\n</div></div></div></div></div></div></div></div></div></div><div ng-if=\"tabActive === tabs.flash\" class=\"nl-listing\">\n<div ng-click=\"display(document, tabs.flash)\" ng-repeat=\"document in flashs track by document.id\"><div \nclass=\"nl-listing-item\"><div layout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button nl-listing-item-button\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/folder.svg\" class=\"iv-listing-item-icon-folder\"></md-icon></md-button><div flex \nlayout=\"row\" layout-align=\"start center\"><div flex=\"50\" class=\"text-truncate nl-listing-item-title\">{{document.name}}\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\" class=\"nl-listing-item-icon2\"></md-icon></div></div></div></div></div>\n</div></div></section>");
$templateCache.put("app/main/front/performances/mes-evaluations/satisfaction-flash-detail.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><a class=\"nl-H1--backBtn\" ng-href=\"./folders\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div><a ng-href=\"./folders\">Flash Qualité : </a><span \nclass=\"nl-H1--fw\">Dispensation / Suivi dossier pharmaceutique</span></div></h1><div class=\"nl-Content\"><div \nclass=\"mt-20\" layout=\"row\" layout-wrap layout-align=\"start start\" style=\"max-width: 600px; margin: auto\"><div \nclass=\"mt-30 mb-10\"><h2 class=\"iv-H2\">Suivi dossier pharmaceutique</h2></div><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Les points forts*</label><textarea class=\"iv-Input-textarea\" \nname=\"comment\" ng-model=\"test.comment\" rows=\"3\" max-rows=\"5\" md-no-resize></textarea><div \nng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Les points faibles*</label><textarea class=\"iv-Input-textarea\" \nname=\"comment\" ng-model=\"test.comment\" rows=\"3\" max-rows=\"5\" md-no-resize></textarea><div \nng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Dysfonctionnements rencontrés*</label><textarea \nclass=\"iv-Input-textarea\" name=\"comment\" ng-model=\"test.comment\" rows=\"3\" max-rows=\"5\" md-no-resize></textarea><div \nng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container flex=\"100\" class=\"iv-Input-container\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Existe-t-il une procédure ?*</label><md-radio-group \nclass=\"iv-Radio-wrapper pt-5 pb-10\" ng-model=\"testRadio\" required md-no-ink><md-radio-button class=\"iv-Radio\" \nvalue=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"false\">Non</md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex=\"100\" class=\"iv-Input-container\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Une procédure serait-elle utile ?*</label><md-radio-group \nclass=\"iv-Radio-wrapper pt-5 pb-10\" ng-model=\"testRadio\" required md-no-ink><md-radio-button class=\"iv-Radio\" \nvalue=\"true\">Oui</md-radio-button><md-radio-button class=\"iv-Radio\" value=\"false\">Non</md-radio-button>\n</md-radio-group></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Personne ayant réalisé l\'auto-contrôle <span \nclass=\"asterix\" ng-if=\"_task.responsable == null\">*</span></label><md-select name=\"responsable\" md-no-asterisk \nng-model=\"_task.responsable.id\" placeholder=\"\" required class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.responsable.id)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"_user.id\" ng-repeat=\"_user in _users track by _user.id\">\n{{_user.surname + \' \' + _user.name }}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"_form.responsable.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-20 mt-35\" style=\"border-top: 1px solid #C5DCF4\"><div></div><div \ntype=\"button\" layout=\"row\" layout-align=\"start center\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\">Annuler\n</button> <button type=\"button\" class=\"nl-Btn ml-10\">Sauvegarder</button></div></div></div></section><nl-footer>\n</nl-footer>");
$templateCache.put("app/main/front/performances/plan-strategique/display-plan-strategique.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><button class=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i \nclass=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\"><span ng-if=\"!managementReviewMode\">\nRetour à la liste des Plans Stratégiques </span><span ng-if=\"managementReviewMode\">Retour au Bilan de performances\n</span></span></button><div ng-if=\"swotMode || allMode\"><div layout=\"row\"><h2 class=\"nl-H2\" flex=\"80\">\nRésumé de votre SWOT</h2><button type=\"button\" class=\"nl-Btn\" ng-click=\"editSWOT()\" ng-if=\"plan.draft\">Editer</button> \n<button type=\"button\" class=\"nl-Btn\" ng-class=\"{\'ml-10\': plan.draft}\" ng-click=\"download(\'SWOT\')\">Télécharger</button>\n</div><div layout=\"row\" layout-wrap flex=\"80\"><div layout=\"column\" layout-wrap flex=\"100\"><div class=\"nl-apercu-item\">\n<div class=\"nl-apercu-item-title\">Forces</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.strengths\"></div></div><div class=\"nl-apercu-item\"><div \nclass=\"nl-apercu-item-title\">Faiblesses</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.weaknesses\"></div></div></div><div layout=\"column\" layout-wrap \nflex=\"100\"><div class=\"nl-apercu-item\"><div class=\"nl-apercu-item-title\">Opportunités</div><div \nclass=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.opportunities\"></div>\n</div><div class=\"nl-apercu-item\"><div class=\"nl-apercu-item-title\">Risques</div><div class=\"nl-apercu-item-separator\">\n</div><div class=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.threats\"></div></div></div></div></div><div \nng-if=\"risksMode || allMode\"><div layout=\"row\"><h2 class=\"nl-H2\" flex=\"80\">Résumé de vos risques identifiés</h2><button\n type=\"button\" class=\"nl-Btn\" ng-click=\"editRisks()\" ng-if=\"plan.draft\">Editer</button> <button type=\"button\" \nclass=\"nl-Btn\" ng-class=\"{\'ml-10\': plan.draft}\" ng-click=\"download(\'RISK\')\">Télécharger</button></div><li \nclass=\"nl-apercu-item-text\" ng-repeat=\"risk in plan.risks | orderBy: \'idEnum\'\">{{risk.title}} <span \nng-if=\"risk.exposition\">({{expositionsJSON[risk.exposition]}})</span><div class=\"iv-Tabs-item-list\"><div \nclass=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\" ng-repeat=\"_element in risksTasks[risk.idEnum]\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-icon flex=\"auto\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div \nclass=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div></div></div></div></li><div class=\"nl-apercu-item-text\" ng-if=\"plan.risks.length == 0\">Pas de risques identifiés.\n</div></div><div ng-if=\"allMode\"><div layout=\"row\"><h2 class=\"nl-H2\" flex=\"80\">Objectifs</h2><button type=\"button\" \nclass=\"nl-Btn\" ng-click=\"editObjectives()\" ng-if=\"plan.draft\">Editer</button> <button type=\"button\" \nng-show=\"plan.objectives.length > 0\" class=\"nl-Btn\" ng-class=\"{\'ml-10\': plan.draft}\" ng-click=\"download(\'OBJECTIVE\')\">\nTélécharger</button></div><li class=\"nl-apercu-item-text\" ng-repeat=\"objective in plan.objectives | orderBy:\'id\'\">\n{{objective.title}}<br><a class=\"ml-23\" style=\"font-weight: 600\" ng-if=\"objective.projectId\" target=\"_blank\" \nng-href=\"./projets/{{objective.projectId}}\">Voir projet<md-icon \nmd-svg-src=\"./assets/icons/app/V3/noun-right-6211230.svg\"></md-icon></a></li><div class=\"nl-apercu-item-text\" \nng-if=\"plan.objectives.length == 0\">Pas d\'objectifs identifiés.</div></div></div></section>");
$templateCache.put("app/main/front/performances/plan-strategique/list-plans-strategiques.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Plans stratégiques</h1><div class=\"nl-Content\"><div class=\"pt-20 pb-20\" \nlayout=\"row\" layout-align=\"center center\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><button type=\"button\" \nng-click=\"goAddPlan()\" class=\"nl-Btn\">Créer un plan stratégique</button></div><div class=\"nl-listing\"><div \nng-repeat=\"plan in plansStrategiques track by $index\"><div class=\"nl-listing-item\"><div class=\"mv-5\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"!plan.draft ? display(plan) : update(plan)\"><div flex><div \nclass=\"nl-list-item-title\">Plan stratégique du {{plan.creationDate | date:\'dd/MM/yyyy\'}}</div><div \nclass=\"nl-list-item-description\">{{plan.draft ? \"En cours\" : \"Validé\"}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-indicator-header-infos nl-dib\"><a class=\"nl-Link mr-10\" \nng-click=\"!plan.draft ? goSWOT(plan) : update(plan); $event.stopPropagation();\">Swot</a> <a class=\"nl-Link\" \nng-click=\"!plan.draft ? goRisks(plan) : update1(plan); $event.stopPropagation();\">Risques</a></div><div \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><div class=\"nl-dib\"><md-menu class=\"nl-Menu mr-20\" \nmd-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content><md-menu-item \nng-if=\"!plan.draft\" md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"display(plan)\">Voir\n</md-button></md-menu-item><md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"openDuplicate(plan)\">Dupliquer</md-button></md-menu-item><md-menu-item ng-if=\"plan.draft\" \nmd-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"update(plan)\">Modifier</md-button>\n</md-menu-item><md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"openPopUpDelete(plan, $index)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nclass=\"nl-Checkbox\" ng-if=\"!$root.user.isTeam\" ng-model=\"plan.confidential\" aria-label=\"Checkbox\" md-no-ink \nng-click=\"setConfidentiel(plan, plan.confidential, $index);$event.stopPropagation();\">Confidentiel<md-tooltip \nmd-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div></div></div></div><div class=\"nl-indicator-body\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl-indicator-body-item\"><div \nng-repeat=\"data in plan.dataplans | orderBy: \'index\'\" class=\"nl-indicator-body-item-sub\"><md-input-container \nclass=\"nl-Input-container nl-indicator-body-inputWrapper\"><input ng-change=\"inputChanged(data)\" ng-model=\"data.value\" \nclass=\"nl-Input-input nl-indicator-body-input\" type=\"number\"></md-input-container></div></div></div></div></div></div>\n</div></section>");
$templateCache.put("app/main/front/performances/plan-strategique/plan-strategique.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Plan stratégique</h1><button class=\"nl-H1-backBtn\" \nng-click=\"goListPlans()\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\">\nRetour à la liste des Plans Stratégiques</span></button><ms-form-wizard flex \nng-init=\"msWizard.selectedIndex = startIndex\"><md-tabs class=\"nl-step pt-55\" md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab ng-click=\"msWizard.selectedIndex = 0\" \nng-disabled=\"!plan.id\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">SWOT</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"\" \nms-form-wizard-form novalidate><div ng-include=\"\'app/main/front/performances/plan-strategique/step/step1.html\'\"></div>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"!plan.id\"><md-tab-label ng-click=\"msWizard.selectedIndex = 1\"><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid || !stepsPassed.first\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$valid && stepsPassed.first\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Risques</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" class=\"\" \nms-form-wizard-form novalidate><div ng-include=\"\'app/main/front/performances/plan-strategique/step/step2.html\'\"></div>\n</form></md-tab-body></md-tab><md-tab ng-click=\"activatePlanButton2();\" ng-disabled=\"!plan.id\"><md-tab-label \nng-click=\"msWizard.selectedIndex = 2\"><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"(wizardStep3.$invalid && startIndex != 2) || (!stepsPassed.first && startIndex != 2) || (!stepsPassed.second && startIndex != 2)\">\n3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"(wizardStep3.$valid && stepsPassed.first && stepsPassed.second) || startIndex == 2\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\">Génération du plan stratégique</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep3\" class=\"\" ms-form-wizard-form novalidate><div \nng-include=\"\'app/main/front/performances/plan-strategique/step/step3.html\'\"></div></form></md-tab-body></md-tab>\n</md-tabs><div flex layout=\"row\" layout-align=\"space-between center\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-disabled=\"msWizard.isFirstStep()\" \nng-click=\"msWizard.previousStep(); previousStep();\">Précédent</button><div type=\"button\" layout=\"row\" \nlayout-align=\"start center\"><button type=\"button\" class=\"nl-Btn ml-10\" ng-disabled=\"loading\" \nng-class=\"{\'nl-Btn--disabled\': msWizard.currentStepInvalid()}\" \nng-click=\"!msWizard.currentStepInvalid() && msWizard.nextStep();!msWizard.currentStepInvalid() && nextStep(msWizard.selectedIndex); !msWizard.currentStepInvalid() && validate(false, msWizard.selectedIndex);\" \nng-hide=\"msWizard.isLastStep()\">Suivant<md-progress-circular md-diameter=\"25px\" ng-if=\"loading\" \nclass=\"md-accent nl-Spinner--center ml-8\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></button> \n<button type=\"button\" class=\"nl-Btn ml-10\" ng-class=\"{\'nl-Btn--disabled\': msWizard.currentStepInvalid()}\" \nng-click=\"!msWizard.currentStepInvalid() && validate(true, msWizard.selectedIndex);\" ng-disabled=\"loading\">Enregistrer\n<md-progress-circular md-diameter=\"25px\" ng-if=\"loading\" class=\"md-accent nl-Spinner--center ml-8\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></button> <span class=\"nl-Tooltips--inner\" \nng-if=\"msWizard.currentStepInvalid() && msWizard.selectedIndex == 1\"><p class=\"nl-Tooltips--text\">\nVeuillez remplir le niveau d\'exposition associé aux risques cochés</p></span><span class=\"nl-Tooltips--inner\" \nng-if=\"msWizard.currentStepInvalid() && msWizard.selectedIndex == 2\"><p class=\"nl-Tooltips--text\">\nVeuillez remplir le Thème PHSQ associé aux objectifs renseignés</p></span></div><button \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" ng-if=\"msWizard.isLastStep()\" type=\"button\" \nng-disabled=\"!activate || msWizard.formsIncomplete()\" ng-click=\"openValidate()\" class=\"nl-Btn--blue ml-10\">\nValider le plan</button></div></ms-form-wizard></div></section>");
$templateCache.put("app/main/front/performances/revue-de-direction/delete_popup.html","<md-dialog aria-label=\"Suppression\" class=\"iv-Dialog\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nConfirmation de suppression</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"iv-Dialog__text\">Voulez-vous vraiment supprimer ce Bilan de performances ?\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" \nng-click=\"deleteManagementReview(idToDelete)\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/revue-de-direction/list-revue-de-direction.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\">Bilans de performances<div layout=\"row\" layout-align=\"center center\"><button\n class=\"nl-Btn\" ng-disabled=\"loading\" ng-click=\"createRDD()\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\">\nCréer un Bilan de performances<md-progress-circular md-diameter=\"25px\" ng-if=\"loading\" \nclass=\"md-accent nl-Spinner--center ml-8\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></button>\n</div></h1><div class=\"nl-Content\"><div class=\"mt-20\"><div class=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" \nlayout-align=\"space-between center\" \nng-repeat=\"management in managementReviews | orderBy : \'-modificationDate\' | filter: filterRdds\" \nstyle=\"border: 1px solid rgba(197, 220, 244, 1); margin-bottom: 1rem;border-radius: 3px\"><div flex><div class=\"ml-5\" \nng-click=\"goToCategories(management.id)\" layout=\"row\" layout-align=\"space-between center\" style=\"padding-right: 1rem\">\n<div class=\"nl-list-item-title\">Bilan de performances</div><div class=\"nl-list-item-description color-dys\" \nlayout=\"row\" layout-align=\"space-between center\">{{management.validated ? \"Validé le \" : \"En cours\" + \"&nbsp;\"}} <span \nng-if=\"management.modificationDate && !management.validationDate\">\n{{management.modificationDate ? \"- dernières modifications le : \" : \"\"}} {{management.modificationDate | date:\"dd/MM/yyyy\"}}\n</span> {{management.validationDate | date:\"dd/MM/yyyy\"}}</div></div></div><div ng-if=\"management.isHidden\" \nstyle=\"padding: 0 1rem\"><md-icon class=\"w-16 h-16\" md-svg-src=\"./assets/icons/app/V3/hide.svg\"></md-icon></div><div \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon>\n</button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"goToCategories(management.id)\">{{management.validated ? \"Voir\" : \"Renseigner\"}}\n</md-button></md-menu-item><md-menu-item ng-if=\"permissions.TITULAIRE\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"hideRdd(management)\">{{management.isHidden ? \"Afficher\" : \"Masquer\"}} pour l’équipe</md-button>\n</md-menu-item><md-menu-item ng-if=\"!management.validated\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"dialogDelete(management.id) \">Supprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n</div></div></div></section>");
$templateCache.put("app/main/front/performances/revue-de-direction/revue-de-direction-details.html","<section class=\"nl-Page\"><h1 class=\"iv-H1\"><button class=\"iv-H1-backBtn\" ng-click=\"api._history();\" \nstyle=\"padding-left:1rem\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nstyle=\"margin: 0.5rem 2rem !important\">{{category.title}}</div></h1><div class=\"nl-Content\"><div class=\"mt-25\" \nng-if=\"category.type == \'TASK\'\"><div class=\"nl-list\"><h3 ng-if=\"(category.type==\'TASK\')\"><strong>\nTâches planifiées lors de votre précédent Bilan de performances</strong></h3><div class=\"nl-list-item2\" layout=\"row\" \nlayout-align=\"space-between center\" ng-show=\"managementReview.tacheGenerales.length !== 0\" \nng-repeat=\"_task in managementReview.tacheGenerales\" style=\"padding-left: 0\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"gap: 1rem\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar.svg\" \nstyle=\"width: 16px; height: 16px\"></md-icon><div class=\"nl-list-item-title\">{{_task.ecor ? \'🌿 \' : \'\'}}{{_task.title}}\n</div><div class=\"nl-list-item-description\">\n{{_task.responsable.name}} {{_task.responsable.surname}} • {{_task.echeance | date:\"dd/MM/yyyy\"}}</div><div \nclass=\"nl-list-item-icon\" ng-repeat=\"v in [0]\" ng-if=\"_task.done\" \nstyle=\"display: flex; align-items: center; gap: 0.5rem\"><i class=\"icon icon-check s20\" \nstyle=\"color: #3D94FF !important\"></i><span class=\"nl-Link\" style=\"color: #3D94FF !important\">Réalisée</span></div>\n<div><div class=\"nl-list-item-icon\"><img src=\"assets/icons/app/planning/notif.png\" alt=\"\" \nng-if=\"_task.reminder != null\"><md-tooltip md-direction=\"bottom\">Rappel</md-tooltip></div><div \nclass=\"nl-list-item-icon\"><img src=\"assets/icons/app/planning/recurrence.png\" alt=\"\" ng-if=\"_task.recurrence\">\n<md-tooltip md-direction=\"bottom\">Recurrence</md-tooltip></div><div class=\"nl-list-item-icon\"><img \nsrc=\"assets/icons/app/planning/page.png\" alt=\"\" ng-if=\"_task.attachment != null && _task.attachment.length > 0\">\n<md-tooltip md-direction=\"bottom\">Pièce jointe</md-tooltip></div></div></div></div></div><div class=\"mt-40\" \nlayout=\"row\" layout-align=\"space-between center\"><div><md-button type=\"button\" class=\"nl-Btn\" ng-click=\"_findList();\" \nng-if=\"!noData && managementReview.tacheGenerales.length > 0\" ng-hide=\"noMoreData\">Voir plus</md-button><md-tooltip \nmd-direction=\"bottom\" ng-if=\"noMoreData\">Tous les éléments sont chargés</md-tooltip></div></div></div><div \nclass=\"mt-25\" ng-if=\"category.malfunctionTypeIndex != null\"><div class=\"nl-list\"><h3 \nstyle=\"margin: 0;padding-bottom: 1rem\"><strong>Vos dysfonctionnements de type défaillance prestataire</strong></h3><div\n class=\"nl-list-item2\" layout=\"row\" layout-align=\"space-between center\" style=\"margin-left:0;padding:1rem 0\" \nng-repeat=\"malfunction in malfunctions\"><div ng-click=\"openMalfunction(malfunction)\"><div layout=\"row\" \nstyle=\"gap: 1rem; align-items: center\"><md-icon md-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\" \nstyle=\"width: 16px; height: 16px\"></md-icon><div class=\"nl-list-item-title\">{{malfunction.title}}</div><div \nclass=\"nl-list-item-description\">{{malfunction.type.name}} • {{malfunction.creation | date: \'dd/MM/yyyy\'}}</div></div>\n</div></div></div></div><div class=\"mt-25\" \nng-if=\"category.type && category.type != \'TASK\' && category.type != \'INDICATEUR\' && category.type != \'HUMAN_RESOURCES\'\">\n<div class=\"nl-list\" \nng-if=\"category.type != \'SUPPLIER\' && category.type != \'EQUIPMENT\' && category.type != \'DOCUMENTATION\' && category.type != \'EVOLUTION\'\">\n<div class=\"nl-list-item2\" layout=\"column\" ng-if=\"category.type == \'PROGRESS_FORM\'\" \nstyle=\"padding-top: 0;padding-left:0;padding-right:0\"><h3 style=\"margin-top: 0\"><strong>Vos fiches de progrès</strong>\n</h3><div class=\"ml-10\"><button permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" class=\"iv-Btn\" \nng-click=\"openFdpRddModal()\"><md-icon md-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon>\nSélectionner mes fiches de progrès</button></div></div><div class=\"ml-10\" \nng-if=\"category.type == \'PROGRESS_FORM\' && managementReview.elements.length > 0\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"item in managementReview.elements\" ng-click=\"openModal(item)\" style=\"padding: 0\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon flex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\">\n</md-icon><div class=\"iv-Tabs-item-list-item-title\">{{item.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{item.creation | date: \'dd/MM/yyyy\'}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-menu \nclass=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();openModal(item)\">Afficher l\'aperçu</md-button></md-menu-item><md-menu-item>\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();removeFicheProgress(item)\">Retirer de la liste</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div layout=\"column\" \nng-if=\"category.type != \'PROGRESS_FORM\'\"><h3 ng-if=\"category.type == \'PLAN_STRAT\'\" style=\"margin: 0 0 .5rem 0\"><strong>\nVotre dernier plan stratégique</strong></h3><h3 ng-if=\"category.type == \'SATISFACTION\'\" style=\"margin: 0 0 .5rem 0\">\n<strong>Vos évaluations client mystère</strong></h3><h3 ng-if=\"category.type == \'AUTO_EVALUATION\'\" \nstyle=\"margin: 0 0 .5rem 0\"><strong>Votre auto-évaluation annuelle</strong></h3><h3 ng-if=\"category.type == \'AUDIT\'\" \nstyle=\"margin: 0 0 .5rem 0\"><strong>Votre dernier audit</strong></h3><div class=\"p-10\" ng-if=\"lastAudit != null\"><div \nng-if=\"lastAudit.swot == null && category.type == \'AUDIT\'\" layout=\"row\" layout-align=\"space-between start\" \nng-click=\"openModal(lastAudit)\" style=\"gap: 1rem; width: 100%\"><div layout=\"row\" \nstyle=\"gap: 0.5rem; align-items: flex-start; flex: 1; min-width: 0\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/audit.svg\" style=\"width: 16px; height: 16px; margin: 0\"></md-icon><div \nstyle=\"display: flex; flex-direction: column; gap: 0.25rem; min-width: 0\"><div class=\"nl-list-item-title\">\n{{lastAudit.auditName || lastAudit.title || lastAudit.name}}</div><div class=\"nl-list-item-description\">\n{{lastAudit.uploadDate | date: \'dd/MM/yyyy\'}}</div><div class=\"nl-list-item-description\" ng-if=\"lastAudit.comment\" \nng-bind-html=\"lastAudit.comment\"></div></div></div></div><div \nng-if=\"category.index === 10 && category.type == \'AUDIT\'\" style=\"margin-top: 0.5rem; padding-bottom: .8rem\"><button \nclass=\"nl-Btn\" ng-click=\"download(lastAudit)\">Télécharger le document</button></div></div><div class=\"p-10\" \nng-repeat=\"audit in managementReview.elements\" ng-if=\"category.type != \'AUDIT\'\"><div \nng-style=\"{\'border\': category.type != \'PLAN_STRAT\' ? \'none\' : \'1px solid rgba(197, 220, 244, 1)\',\'min-height\': category.type != \'PLAN_STRAT\' ? \'0\' : \'64px\'}\" \nstyle=\"border-radius: 3px;\n         display: flex;flex-direction: row;gap: 1rem; width: 100%;justify-content: center;align-items: center; padding-left:0\">\n<div style=\"width:100%\" style=\"padding-left:0;padding-bottom: 2rem\"><div layout=\"row\" style=\"gap: 0.5rem\" \nng-if=\"audit.swot == null && category.type != \'AUDIT\'\" ng-click=\"openModal(audit)\"><md-icon \nng-if=\"category.type == \'SATISFACTION\'\" md-svg-src=\"assets/icons/app/V3/client_mystere.svg\" \nstyle=\"width: 16px; height: 16px;margin: 0\"></md-icon><md-icon ng-if=\"category.type == \'AUTO_EVALUATION\'\" \nmd-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\" style=\"width: 16px; height: 16px;margin: 0\"></md-icon><div \nclass=\"nl-list-item-title\" ng-if=\"audit.auditName\">{{audit.auditName}}</div><div class=\"nl-list-item-title\" \nng-if=\"audit.name\">{{audit.name}}</div><div class=\"nl-list-item-title\">{{audit.title}}</div><div \nclass=\"nl-list-item-description\" ng-if=\"audit.comment\" ng-bind-html=\"audit.comment\"></div><div \nclass=\"nl-list-item-description\">{{audit.uploadDate | date: \'dd/MM/yyyy\'}}</div><div class=\"nl-list-item-description\" \nng-if=\"audit.type.name || audit.creation || audit.malfunction.type.name\">\n{{audit.malfunction.type.name || audit.type.name}} - {{audit.creation | date : \'dd/MM/yyyy\'}}</div></div><div \nclass=\"nl-dib ml-20\" ng-if=\"audit.swot != null\"><div class=\"nl-list-item-title\">\nPlan stratégique du {{audit.creationDate | date: \'dd/MM/yyyy\'}}</div></div></div><div ng-if=\"audit.swot != null\" \nstyle=\"display: flex !important;justify-content: center;align-items: center\"><div \nclass=\"nl-indicator-header-infos nl-dib\" \nstyle=\"display: flex !important;justify-content: center;align-items: center;gap: 1rem\"><p class=\"color-dys\" \nstyle=\"white-space: nowrap\">{{audit.draft ? \"En cours\" : \"Validé\"}}</p><a class=\"nl-Link\" \nng-click=\"goSWOT(audit); $event.stopPropagation();\" \nng-if=\"audit.swot.strengths != null || audit.swot.opportunities != null || audit.swot.threats != null || audit.swot.weaknesses != null\" \nstyle=\"color:#3D94FF !important\"><strong>Swot</strong></a> <a class=\"nl-Link\" \nng-click=\"goRisks(audit); $event.stopPropagation();\" ng-if=\"audit.risks.length != 0 || true\" \nstyle=\"color:#3D94FF !important\"><strong>Risques</strong></a></div><div style=\"padding:0 20px\"><button class=\"nl-Btn\" \nng-click=\"goToPlanStrat(audit)\" style=\"white-space: nowrap\">Mettre à jour</button></div></div></div><div \nng-if=\"(category.index === 6 || category.index === 9 || category.index === 10) && !cantUpdate\" \nstyle=\"margin-top: 0.5rem; padding-bottom: .8rem\"><button ng-if=\"category.index === 6\" class=\"nl-Btn\" \nng-click=\"downloadSatisfaction(audit.id)\">Télécharger le document</button> <button \nng-if=\"category.index === 9 && audit.hasDoc\" class=\"nl-Btn\" ng-click=\"download(audit)\">Télécharger le document</button>\n</div></div></div></div></div><div ng-if=\"category.type == \'INDICATEUR\'\"><h3 class=\"iv-subTitle\">\nMes indicateurs qualité</h3><span style=\"font-style: italic\">\nEn cliquant sur le bouton ci-dessous, votre tableau de bord s\'ouvrira automatiquement dans un nouvel onglet.<br>\nVous pourrez ainsi le parcourir et extraire vos données en cliquant sur le bouton “Analyse graphique”, puis sur “Exporter” en bas de page.\n<br>\nLe fichier ainsi téléchargé pourra être envoyé par vos soins en même temps que votre Bilan de performances une fois celui-ci terminé. \n</span><button class=\"nl-Btn mt-10\" ng-click=\"openTdb()\">Exporter mon tableau de bord</button></div><div \nng-if=\"category.index > 1\"><div class=\"nl-list\" layout=\"row\" layout-wrap style=\"gap: 1rem\"><div class=\"nl-list-item2\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"question in category.questions | orderBy:\'index\'\" \nng-style=\"{ \'width\': question.type === \'NUMBER\' ? \'calc(50% - 0.5rem)\' : \'100%\' }\" \nstyle=\"padding: 0 !important; margin: 0 !important\"><div style=\"width: 100%\"><div class=\"nl-dib\" \nstyle=\"width: 100%; margin: 0 !important\"><nl-category ng-model=\"question\" category=\"category\" \nevals=\"managementReview.elements\" update=\"managementReview.validated || (question.type == \'NUMBER\')\"></nl-category>\n</div></div></div></div></div><div class=\"mt-20\" ng-if=\"category.type!=\'PLAN_STRAT\' && category.type!=\'DOCUMENTATION\'\">\n<h3 ng-if=\"category.comment!=null || category.type==\'TASK\' || category.type==\'DOCUMENTATION\'\"><strong>\nVos commentaires et votre analyse</strong></h3><md-input-container \nng-if=\"category.comment!=null || category.type==\'TASK\' || category.type==\'DOCUMENTATION\'\" class=\"nl-Input-container\" \nflex=\"100\"><textarea ng-disabled=\"cantUpdate || managementReview.validated\" name=\"bio\" ng-model=\"category.comment\" \nrequired class=\"nl-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize \nstyle=\"background-color: rgba(243, 249, 255, 1) !important\"></textarea></md-input-container></div><div class=\"mt-20\" \nng-if=\"category.type==\'PLAN_STRAT\' || category.type==\'DOCUMENTATION\'\"><h3><strong>Vos commentaires et votre analyse\n</strong></h3><md-input-container class=\"nl-Input-container\" flex=\"100\"><textarea \nng-disabled=\"cantUpdate || managementReview.validated\" name=\"bio\" ng-model=\"category.comment\" required \nclass=\"nl-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize \nstyle=\"background-color: rgba(243, 249, 255, 1) !important\"></textarea></md-input-container></div><div flex=\"100\" \nclass=\"mt-20 mb-10\"><h3 class=\"iv-subTitle\" style=\"padding-bottom: 0px !important\">Planifier une action</h3><div \nclass=\"iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in category.tasks track by _element.id\" ng-click=\"showElement(_element)\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" class=\"mr-15\"><md-checkbox \nng-change=\"_actionDecideeFaite(_element);\" ng-click=\"$event.stopPropagation()\" class=\"iv-Checkbox\" \nng-model=\"_element.done\" aria-label=\"Checkbox\" md-no-ink></md-checkbox></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon flex=\"auto\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div class=\"iv-Tabs-item-list-item-title\">\n{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" \nmd-offset=\"0 35\"><button aria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\">\n<md-icon class=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();showElement(_element)\">Afficher l\'aperçu</md-button></md-menu-item><md-menu-item>\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();_openDeleteTask(_element)\">Supprimer</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><button \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" type=\"button\" class=\"mt-10 iv-Btn\" ng-click=\"addAction()\" \nng-disabled=\"loadingCategoryForTask\"><md-icon md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div>\n{{loadingCategoryForTask ? \'Chargement...\' : \'Planifier une tâche\'}}</div></button></div><div \nclass=\"iv-Tabs-footer mt-10\" style=\"justify-content: flex-end;border-top: none\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"layout-align-end-center layout-row\"><button class=\"nl-Btn nl-Btn--md nl-Btn--outline\" \nng-click=\"api._history()\">Annuler</button></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"layout-align-end-center layout-row\"><button ng-if=\"!managementReview.validated\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" class=\"nl-Btn ml-20\" ng-click=\"saveCategory(category)\" \nng-disabled=\"loadingSave\"><md-progress-circular md-diameter=\"15px\" ng-if=\"loadingSave\" class=\"md-accent\" \nmd-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingSave\">\nEnregistrer et revenir au Bilan de performances</span></button></div></div></div></section>");
$templateCache.put("app/main/front/performances/revue-de-direction/revue-de-direction-questions.html","<h3 ng-if=\"question.type == \'\'\" style=\"margin-top: 0! important\"><strong>{{question.title}}</strong></h3><form>\n<md-input-container class=\"nl-Input-container\" ng-if=\"question.type == \'TEXT\'\" style=\"margin-top: 0 !important\"><h3 \nng-if=\"!(category.id==11 && question.index==1) && (question.title != \'Résultats atteints par l\\\'officine\' && question.title != \'Actions restantes à mener\') && (question.title != \'Commentaires sur les résultats de l\\\'évaluation\')\" \nclass=\"md-no-float md-container-ignore\" style=\"margin-top: 0 !important\"><strong>{{question.title}}</strong></h3><h3 \nng-if=\"!(category.id==11 && question.index==1) && (question.title == \'Résultats atteints par l\\\'officine\' || question.title == \'Actions restantes à mener\')\" \nclass=\"md-no-float md-container-ignore\" style=\"margin-top: 0 !important\">{{question.title}}</h3><h3 \nng-if=\"!(category.id==11 && question.index==1) && (question.title == \'Commentaires sur les résultats de l\\\'évaluation\')\" \nclass=\"md-no-float md-container-ignore\" style=\"margin-top: 0 !important\">{{question.title}}</h3><h3 \nng-if=\"(category.id==11 && question.index==1)\" style=\"margin-top: 0 !important\"><strong>{{question.title}}</strong>\n</h3><textarea ng-disabled=\"cantUpdate\" name=\"bio\" ng-model=\"question.stringValue\" required class=\"nl-Input-textarea\" \ncols=\"200\" rows=\"2\" max-rows=\"4\" md-no-resize style=\"background-color: rgba(243, 249, 255, 1) !important\"></textarea>\n</md-input-container><div class=\"nl-dib\" ng-if=\"question.type == \'CHECKBOX\'\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">{{question.title}} :</label><md-radio-group \nng-disabled=\"cantUpdate\" class=\"nl-Radio-wrapper nl-radio--inline\" ng-model=\"question.checkValue\" required md-no-ink>\n<md-radio-button class=\"nl-Radio rdd\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"nl-Radio rdd\" \nng-value=\"false\">Non</md-radio-button></md-radio-group></div><div class=\"nl-Input-container\" \nng-if=\"question.type==\'NUMBER\'\" style=\"width: 100%\"><label class=\"nl-Input-label md-no-float\" \nstyle=\"color: #999; font-size: 12px\">{{question.title}}</label><md-input-container class=\"nl-Input-container\" \nflex=\"100\" style=\"margin-top: 5px\"><input ng-disabled=\"cantUpdate\" type=\"number\" min=\"0\" step=\"1\" name=\"rappel\" \nng-model=\"question.numberValue\" placeholder=\"\" class=\"nl-Input-input\" aria-label=\"{{question.title}}\">\n</md-input-container></div><div ng-if=\"question.type == \'CHECKBOX_WITH_DATE\'\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">{{question.title}} :</label><md-radio-group \nng-disabled=\"cantUpdate\" class=\"nl-Radio-wrapper nl-radio--inline\" ng-model=\"question.checkValue\" required md-no-ink>\n<md-radio-button class=\"nl-Radio rdd\" ng-value=\"true\">Oui</md-radio-button><md-radio-button class=\"nl-Radio rdd\" \nng-value=\"false\">Non</md-radio-button></md-radio-group><md-input-container class=\"nl-Input-container\" flex=\"100\"><label\n class=\"nl-Input-label md-no-float md-container-ignore\">Date</label><div class=\"nl-Input-date-wrapper\" \nstyle=\"width: 25%\"><md-icon ng-click=\"question.dateValueInput.isOpen = true\" class=\"nl-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\" style=\"width: 15.2px; height: 15.2px;color:rgba(26, 42, 51, 1)\">\n</md-icon><md-datepicker md-is-open=\"question.dateValueInput.isOpen\" md-hide-icons=\"all\" md-open-on-focus \nng-model=\"question.dateValueInput\" class=\"nl-Input-date\" ng-disabled=\"!question.checkValue || cantUpdate\">\n</md-datepicker></div></md-input-container></div><div ng-if=\"question.type == \'CHECKBOX_WITH_ANSWER\'\"><md-checkbox \nng-disabled=\"cantUpdate\" class=\"nl-Checkbox rdd\" ng-model=\"question.checkValue\" aria-label=\"Checkbox\" md-no-ink>\n{{question.title}}</md-checkbox><md-input-container class=\"nl-Input-container\" flex=\"100\"><textarea \nng-disabled=\"cantUpdate\" name=\"bio\" ng-model=\"question.stringValue\" required class=\"nl-Input-textarea\" cols=\"200\" \nrows=\"2\" max-rows=\"4\" md-no-resize style=\"background-color: rgba(243, 249, 255, 1) !important\"></textarea>\n</md-input-container></div></form><div ng-repeat=\"subQuestion in question.subquestions | orderBy: \'index\'\"><nl-category\n ng-model=\"subQuestion\" update=\"cantUpdate\"></nl-category></div>");
$templateCache.put("app/main/front/performances/revue-de-direction/revue-de-direction.html","<section class=\"nl-Page\"><div style=\"display: flex; align-items: center\"><i \nclass=\"nl-H1-backBtn-icon icon-chevron-left\" ng-click=\"goToListReview()\" \nstyle=\"width:5%;text-align: right;font-size: 3rem\"></i><h1 class=\"nl-H1\" style=\"padding-left: 2rem\"><div><strong>\nBilan de performances</strong> <span class=\"nl-H1--fw\" ng-if=\"managementReview.id && !managementReview.validated\">\n: En cours</span> <span class=\"nl-H1--fw\" ng-if=\"managementReview.id && managementReview.validated\">\n: Validé le {{managementReview.validationDate | date: \'dd/MM/yyyy\'}}</span></div></h1></div><div class=\"nl-Content\">\n<div class=\"mt-20\" layout=\"row\" layout-align=\"left center\"><div style=\"position: relative;width:100%\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{progress}}\"></md-progress-linear><span class=\"progress-label\" \nng-style=\"{\'left\': progress + \'%\'}\">{{progress | number : 0}}%</span></div></div><br><div class=\"mt-25\"><div \nclass=\"nl-list\"><div class=\"nl-list-item\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"category in categories |orderBy : \'index\'\" ng-click=\"goToDetails(category)\" \nstyle=\"border-top: transparent;border-bottom: 1px solid #C5DCF4\"><div style=\"max-width: 85%!important\"><div \nclass=\"nl-dib ml-5\"><div class=\"nl-list-item-title\">{{category.title}}</div></div></div><div><div class=\"nl-dib\"><div \nclass=\"nl-list-item-description\"><div ng-if=\"category.validated\"><i class=\"icon icon-check s20 nl-Link\" \nstyle=\"color: #3D94FF !important\"></i></div><div ng-if=\"!category.validated\" class=\"nl-Link\" \nstyle=\"color: #3D94FF !important\"><strong>À renseigner</strong></div></div></div></div></div></div><div \nstyle=\"display:flex; justify-content: flex-end\"><button ng-if=\"!managementReview.validated\" class=\"nl-Btn\" \nng-click=\"openValidateRDD(managementReview.id)\" ng-disabled=\"progress < 100\">Valider le Bilan de performances</button> \n<button ng-if=\"managementReview.validated && !$root.user.isTeam\" class=\"nl-Btn\" ng-disabled=\"loading\" \nng-click=\"exportRDD()\"><span ng-if=\"!loading\">Exporter le Bilan de performances</span><md-progress-circular \nmd-diameter=\"15px\" ng-if=\"loading\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></button></div>\n</div></div></section>");
$templateCache.put("app/main/front/performances/revue-de-direction/validate_popup.html","<md-dialog aria-label=\"Validation\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nValider le Bilan de performances</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nUne fois votre Bilan de performances validé, vous ne pourrez plus le modifier sur le LQO. Êtes-vous sûr de vouloir le valider maintenant ?\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non, continuer</md-button><button class=\"nl-Btn\" ng-click=\"validateRDD()\">Oui, valider</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/tableau-de-bord/page-add-indicateur.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Administrer mes indicateurs</h1><button \nclass=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour en arrière</span></button><div class=\"pt-25\" layout=\"row\" \nlayout-align=\"center center\"><button type=\"button\" ng-click=\"popUpAddIndicateur()\" class=\"nl-Btn\">Créer un indicateur\n</button></div><div layout=\"row\" layout-align=\"center center\"><h2 class=\"nl-H2\">Indicateurs actifs</h2></div><div \nng-click=\"openWindow(indicateur)\" class=\"nl-ListIndicator\" \nng-class=\"{\'nl-ListIndicator--open\': mapIndicateurs.get(indicateur.id)}\" \nng-repeat=\"indicateur in active(indicateurs, true) track by $index\"><div class=\"nl-indicator-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-header-title flex\"><span \nng-if=\"!mapIndicateurs.get(indicateur.id)\"><div>{{indicateur.title}} <span ng-if=\"indicateur.format\">\n( {{indicateur.format}} )</span></div><div class=\"nl-indicator-header-infos\">\nObjectif : {{indicateur.goal}} • Fréquence : {{periods[indicateur.period]}}</div></span><form \nng-click=\"$event.stopPropagation();\" ng-if=\"mapIndicateurs.get(indicateur.id)\" name=\"addIndicateurForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"addIndicateurForm.$valid && saveIndicateur(indicateur)\"><div \nclass=\"pb-10\" layout=\"row\" layout-align=\"start end\" layout-wrap><div class=\"pr-10 pb-15\" flex=\"50\" layout=\"row\" \nlayout-align=\"start end\"><md-input-container class=\"nl-Input-container nl-Input-container--no-error\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">\nTitre de l\'indicateur*<span ng-if=\"indicateur.title == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"title\" ng-model=\"indicateur.title\" required class=\"nl-newInput-input\" placeholder=\"\" \nng-disabled=\"indicateur.status === \'MALFUNCTION\' || indicateur.status === \'DISPENSATION\' ||indicateur.status === \'DYNAMIC\'||indicateur.status === \'ECOR\'\">\n<div ng-messages=\"addIndicateurForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container></div><div class=\"pl-10 pb-15\" flex=\"50\" layout=\"row\" layout-align=\"start end\">\n<md-input-container class=\"nl-Input-container nl-Input-container--no-error\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Périodicité*</label><md-select ng-model=\"indicateur.period\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\" disabled=\"disabled\"><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"MONTHLY\">Mensuel</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"ANNUAL\">Annuel</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"QUARTERLY\">Trimestriel</md-option>\n</md-select></md-input-container></div><div flex=\"15\" layout=\"row\" layout-align=\"start end\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Objectif</label><md-select ng-model=\"indicateur.goalType\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"LOWER\">Inférieur</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"HIGHER\">Supérieur</md-option></md-select></md-input-container></div><div class=\"pr-10\" flex=\"35\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"m-10\">à</div><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><input type=\"text\" \nng-change=\"inputChanged(indicateur)\" name=\"goal\" ng-model=\"indicateur.goal\" class=\"nl-newInput-input\">\n</md-input-container></div><div class=\"pl-10\" flex=\"50\" layout=\"row\" layout-align=\"start end\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\" \nng-if=\"indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\' && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\'\">\n<label class=\"nl-newInput-label md-no-float md-container-ignore\">Format (%,€,..)</label><input type=\"text\" \nname=\"format\" ng-model=\"indicateur.format\" class=\"nl-newInput-input\" placeholder=\"\"></md-input-container></div></div>\n<div layout=\"row\" layout-wrap layout-align=\"start center\"><div class=\"flex-50 layout-row layout-align-start-center\">\n<div flex=\"25\" ng-if=\"!$root.user.isTeam\"><md-checkbox ng-click=\"$event.stopPropagation();\" \nng-change=\"changeWeather(indicateur)\" class=\"nl-newCheckbox\" ng-model=\"indicateur.confidential\" \naria-label=\"CheckboxConfidential\" md-no-ink>Confidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div><md-checkbox flex=\"75\" \nng-disabled=\"(nbIndicateur > 2 && !indicateur.weather) || indicateur.confidential\" class=\"nl-newCheckbox\" \nng-model=\"indicateur.weather\" aria-label=\"CheckboxWeather\" md-no-ink>Ajouter à la météo qualité (3 maximum) <span \nng-if=\"indicateur.confidential\">- Vous ne pouvez pas ajouter un indicateur qui est confidentiel</span></md-checkbox>\n</div><div class=\"flex-50\" ng-if=\"indicateur.weather\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\">\n<div class=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" src=\"assets/images/PHSQ/rain.svg\" alt=\"\"></div>\n<md-input-container class=\"nl-Input-container\" flex=\"25\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Seuil 1</label><input name=\"seuilCloud\" required \nng-model=\"indicateur.thresholdLow\" class=\"nl-newInput-input\" type=\"text\"><div \nng-messages=\"addIndicateurForm.seuilCloud.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><div class=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" \nsrc=\"assets/images/PHSQ/cloudy.svg\" alt=\"\"></div><md-input-container class=\"nl-Input-container\" flex=\"25\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Seuil 2</label><input name=\"seuilSun\" required \nng-model=\"indicateur.thresholdHigh\" class=\"nl-newInput-input\" type=\"text\"><div \nng-messages=\"addIndicateurForm.seuilSun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><div class=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" \nsrc=\"assets/images/PHSQ/sun.svg\" alt=\"\"></div></div></div><div class=\"flex-50 layout-row layout-align-end-center\" \nng-class=\"{\'flex-100\': indicateur.weather, \'mt-15\': indicateur.weather}\"><button ng-disabled=\"submitting\" \ntype=\"button\" ng-click=\"closeWindow(indicateur); $event.stopPropagation();\" class=\"nl-Btn nl-Btn--outline mr-10\">\nAnnuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn\">Enregistrer</button></div></div></form>\n</div><div layout=\"row\" layout-align=\"end center\" ng-if=\"!mapIndicateurs.get(indicateur.id)\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" \nng-show=\"indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\' && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\'\" \nng-click=\"setActif(indicateur, false); $event.stopPropagation();\">Enlever</button> <button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline ml-10\">Modifier</button></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-if=\"active(indicateurs, true).length === 0\"><p>Pas d\'indicateur actif</p></md-list-item><h2 class=\"nl-H2\">\nIndicateurs inactifs</h2><div ng-click=\"openWindow(indicateur)\" class=\"nl-ListIndicator\" \nng-class=\"{\'nl-ListIndicator--open\': mapIndicateurs.get(indicateur.id)}\" \nng-repeat=\"indicateur in active(indicateurs, false) track by $index\"><div class=\"nl-indicator-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-header-title flex\"><span \nng-if=\"!mapIndicateurs.get(indicateur.id)\"><div>{{indicateur.title}} <span ng-if=\"indicateur.format\">\n( {{indicateur.format}} )</span></div><div class=\"nl-indicator-header-infos\">\nObjectif : {{indicateur.goal}} • Fréquence : {{periods[indicateur.period]}}</div></span><form id=\"formulaireOpen\" \nng-show=\"mapIndicateurs.get(indicateur.id)==true\" name=\"addIndicateurForm\" class=\"md-inline-form\" novalidate \nng-submit=\"addIndicateurForm.$valid && saveIndicateur(indicateur)\"><div class=\"pb-10\" layout=\"row\" \nlayout-align=\"start end\" layout-wrap><div class=\"pr-10 pb-15\" flex=\"50\" layout=\"row\" layout-align=\"start end\">\n<md-input-container class=\"nl-Input-container nl-Input-container--no-error\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">\nTitre de l\'indicateur*<span ng-if=\"indicateur.title == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"title\" ng-model=\"indicateur.title\" required class=\"nl-newInput-input\" placeholder=\"\" \nng-disabled=\"indicateur.status === \'MALFUNCTION\' || indicateur.status === \'DISPENSATION\' || indicateur.status === \'DYNAMIC\'||indicateur.status === \'ECOR\'\">\n<div ng-messages=\"addIndicateurForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container></div><div class=\"pl-10 pb-15\" flex=\"50\" layout=\"row\" layout-align=\"start end\">\n<md-input-container class=\"nl-Input-container nl-Input-container--no-error\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Périodicité*</label><md-select ng-model=\"indicateur.period\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\" disabled=\"disabled\"><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"MONTHLY\">Mensuel</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"ANNUAL\">Annuel</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"QUARTERLY\">Trimestriel</md-option>\n</md-select></md-input-container></div><div flex=\"15\" layout=\"row\" layout-align=\"start end\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Objectif</label><md-select ng-model=\"indicateur.goalType\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"LOWER\">Inférieur</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"HIGHER\">Supérieur</md-option></md-select></md-input-container></div><div class=\"pr-10\" flex=\"35\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"m-10\">à</div><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><input type=\"text\" \nng-change=\"inputChanged(indicateur)\" name=\"goal\" ng-model=\"indicateur.goal\" class=\"nl-newInput-input\">\n</md-input-container></div><div class=\"pl-10\" flex=\"50\" layout=\"row\" layout-align=\"start end\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\" \nng-if=\"indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\' &&  indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\'\">\n<label class=\"nl-newInput-label md-no-float md-container-ignore\">Format (%,€,..)</label><input type=\"text\" \nname=\"format\" ng-model=\"indicateur.format\" class=\"nl-newInput-input\" placeholder=\"\"></md-input-container></div></div>\n<div layout=\"row\" layout-wrap layout-align=\"start center\"><div \nclass=\"flex-100 layout-row layout-align-end-center pt-10 pb-10\" \nng-class=\"{\'flex-100\': indicateur.weather, \'mt-15\': indicateur.weather}\"><button ng-disabled=\"submitting\" \ntype=\"button\" ng-click=\"closeWindow(indicateur); $event.stopPropagation();\" class=\"nl-Btn nl-Btn--outline mr-10\">\nAnnuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn\">Enregistrer</button></div></div></form>\n</div><div layout=\"row\" layout-align=\"end center\" ng-if=\"!mapIndicateurs.get(indicateur.id)\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"setActif(indicateur, true); $event.stopPropagation();\">Ajouter</button></div>\n</div></div><md-list-item class=\"no-results md-white-bg\" ng-if=\"active(indicateurs, false).length === 0\"><p>\nPas d\'indicateur inactif</p></md-list-item></div></section>");
$templateCache.put("app/main/front/performances/tableau-de-bord/page-graphs.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><button class=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i \nclass=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\">Retour en arrière</span></button>\n<div id=\"dysfonctionnements\" ng-if=\"!!showDysfonctionnements\"><h1 class=\"nl-H1\">\nDysfonctionnements (dont défaillance prestataire, insatisfaction client et suggestion)</h1><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"canvasDysfPriority\" \nheight=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span ng-if=\"dysInd != null && dysInd.goal != null\">\nObjectif: {{dysInd.goal}} </span><span>Moyenne: {{average(dysInd.dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"canvasDysfStatus\" \nheight=\"75\"></canvas></div><br><div ng-if=\"dysfonctionnements.length > 0\" \nstyle=\"width:50%; border: 1px solid rgb(224, 222, 222); padding: 16px;border-radius: 2px\"><canvas id=\"canvasDysfType\">\n</canvas></div></div><div id=\"dysfonctionnementsEcor\" ng-if=\"!!showDysfonctionnementsEcor\"><h1 class=\"nl-H1\">\nDysfonctionnements 🌿 ECOR</h1><br><div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\">\n<canvas id=\"canvasDysfEcorPriority\" height=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dysInd != null && dysInd.goal != null\">Objectif: {{dysEcorInd.goal}} </span><span>\nMoyenne: {{average(dysEcorInd.dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"canvasDysfEcorStatus\" \nheight=\"75\"></canvas></div><br><div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\">\n<canvas id=\"canvasEcorHorizontal\" height=\"80\"></canvas></div></div><div id=\"dispensation\" ng-if=\"!!showDispensation\">\n<h1 class=\"nl-H1\">Erreurs de dispensation</h1><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"canvasDispensationPriority\" \nheight=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span ng-if=\"disInd != null && disInd.goal != null\">\nObjectif: {{disInd.goal}} </span><span>Moyenne: {{average(disInd.dataIndicateurs)}}</span></div><br><div layout=\"row\" \nng-if=\"dispensationErrors.length > 0\"><div ng-if=\"dispensationAnyDetected\" \nstyle=\"width:49%; border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas \nid=\"canvasDispensationDetected\"></canvas></div><div ng-if=\"dispensationAnyDelivered\" \nstyle=\"width:49%; border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; margin-left: 1%\"><canvas \nid=\"canvasDispensationDelivered\"></canvas></div></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\" ng-if=\"dispensationAnyError\"><canvas \nid=\"canvasDispensationHorizontal\" height=\"80\"></canvas></div></div><div ng-if=\"dynamicIndicator.length > 0\"><h1 \nclass=\"nl-H1\">{{dynamicIndicator[0].title}}</h1><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas id=\"indicmonth0\" \nheight=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dynamicIndicator[0] != null && dynamicIndicator[0].goal != null\">Objectif: {{dynamicIndicator[0].goal}} </span>\n<span>Moyenne: {{average(dynamicIndicator[0].dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"indicstatus0\" height=\"75\">\n</canvas></div></div><div ng-if=\"dynamicIndicator.length > 1\"><h1 class=\"nl-H1\">{{dynamicIndicator[1].title}}</h1><br>\n<div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas \nid=\"indicmonth1\" height=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dynamicIndicator[1] != null && dynamicIndicator[1].goal != null\">Objectif: {{dynamicIndicator[1].goal}} </span>\n<span>Moyenne: {{average(dynamicIndicator[1].dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"indicstatus1\" height=\"75\">\n</canvas></div></div><div ng-if=\"dynamicIndicator.length > 2\"><h1 class=\"nl-H1\">{{dynamicIndicator[2].title}}</h1><br>\n<div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas \nid=\"indicmonth2\" height=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dynamicIndicator[2] != null && dynamicIndicator[2].goal != null\">Objectif: {{dynamicIndicator[2].goal}} </span>\n<span>Moyenne: {{average(dynamicIndicator[2].dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"indicstatus2\" height=\"75\">\n</canvas></div></div><div ng-if=\"dynamicIndicator.length > 3\"><h1 class=\"nl-H1\">{{dynamicIndicator[3].title}}</h1><br>\n<div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas \nid=\"indicmonth3\" height=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dynamicIndicator[3] != null && dynamicIndicator[3].goal != null\">Objectif: {{dynamicIndicator[3].goal}} </span>\n<span>Moyenne: {{average(dynamicIndicator[3].dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"indicstatus3\" height=\"75\">\n</canvas></div></div><div ng-if=\"dynamicIndicator.length > 4\"><h1 class=\"nl-H1\">{{dynamicIndicator[4].title}}</h1><br>\n<div style=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas \nid=\"indicmonth4\" height=\"75\"></canvas></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"dynamicIndicator[4] != null && dynamicIndicator[4].goal != null\">Objectif: {{dynamicIndicator[4].goal}} </span>\n<span>Moyenne: {{average(dynamicIndicator[4].dataIndicateurs)}}</span></div><br><div \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px\"><canvas id=\"indicstatus4\" height=\"75\">\n</canvas></div></div><div ng-repeat=\"graph in graphsDisplayed track by $index\"><h1 class=\"nl-H1\">{{graph.title}}</h1>\n<br><div ng-if=\"!graph.isAnnual\" \nstyle=\"border: 1px solid rgb(224, 222, 222); padding: 30px;border-radius: 2px; width: auto\"><canvas \nid=\"chart{{$index}}\" height=\"75\"></canvas></div><div ng-if=\"!graph.isAnnual\" class=\"nl-Indicator__item__infos\"><span \nng-if=\"graph.indicateur != null && graph.indicateur.goal != null\">\nObjectif: {{graph.indicateur.goal}}{{graph.indicateur.format}} </span><span>\nMoyenne: {{average(graph.indicateur.dataIndicateurs)}}{{graph.indicateur.format}}</span></div><div \nng-if=\"graph.isAnnual\" \nstyle=\"min-width: 150px; width:auto;display: inline-block;text-align: center;border: 1px solid rgb(224, 222, 222); padding-left: 25px; padding-right: 25px; padding-top:5px; padding-bottom:5px; border-radius: 2px; font-size: 35px\">\n<span>\n{{graph.indicateur != null && graph.indicateur.dataIndicateurs.length > 0 ? graph.indicateur.dataIndicateurs[0].value +\' \'+(graph.indicateur.format ? graph.indicateur.format : \'\') : 0 }}\n</span></div></div><div class=\"pt-45\" layout-align=\"end end\" layout=\"row\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"openExport()\">Exporter</button></div></div></section>");
$templateCache.put("app/main/front/performances/tableau-de-bord/tableau-de-bord.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\" layout=\"row\" layout-align=\"space-between center\">Vos indicateurs<div \nclass=\"nl-tdb-indicator\"><span class=\"nl-tdb-indicator-arrow\" ng-click=\"changeYear(\'minus\')\"><img \nsrc=\"./assets/icons/app/indicators/indicator_left.png\" alt=\"\"> </span><span class=\"nl-tdb-indicator-year\">\nAnnée {{yearChosen}}</span> <span class=\"nl-tdb-indicator-arrow\" ng-click=\"changeYear(\'plus\')\"><img \nsrc=\"./assets/icons/app/indicators/indicator_right.png\" alt=\"\"></span></div></h1><div class=\"nl-Content\"><div \nclass=\"pt-25 pb-25\" layout=\"row\" layout-align=\"space-between center\"><div><md-button \nng-click=\"orderMode.active = !orderMode.active\" ng-if=\"orderMode.active\" type=\"button\" \nclass=\"m-0 nl-Btn nl-Btn--outline nl-Btn--clear nl-Btn--icon nl-Indicator__sortBtn\"><md-icon \nmd-svg-src=\"assets/icons/app/board/inverse.svg\"></md-icon>Valider le tri manuel</md-button><md-button \nng-click=\"orderMode.active = !orderMode.active\" ng-if=\"!orderMode.active\" type=\"button\" \nclass=\"m-0 nl-Btn nl-Btn--outline nl-Btn--clear nl-Btn--icon nl-Indicator__sortBtn\"><md-icon \nmd-svg-src=\"assets/icons/app/board/inverse.svg\"></md-icon>Trier manuellement</md-button></div><div layout=\"row\"><button\n type=\"button\" class=\"nl-Btn nl-Btn--outlineTB\" ng-click=\"popUpGenerateGraphs()\">Analyse graphique</button> <button \ntype=\"button\" ng-click=\"goAddIndicateur()\" class=\"nl-Btn ml-10\" ng-if=\"currentYear <= yearChosen\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\">Administrer mes indicateurs</button></div></div><div><div \nclass=\"nl-Indicator__item nl-Indicator__item--featured\" ng-repeat=\"indicateur in indicateursSpecials track by $index\">\n<div class=\"nl-Indicator__header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"nl-indicator-header-title\" layout=\"row\" layout-align=\"start center\"><div class=\"nl-Indicator__title\">\n{{indicateur.title}} <span ng-if=\"indicateur.format\">( {{indicateur.format}} )</span></div></div><div \nclass=\"nl-Indicator__toolbarInfos flex-noshrink\"><div ng-if=\"periods[indicateur.period] === \'mensuel\'\">\nFréquence mensuelle</div><div ng-if=\"periods[indicateur.period] === \'trimestriel\'\">Fréquence trimestrielle</div><div \nng-if=\"periods[indicateur.period] === \'annuel\'\">Fréquence annuelle</div><md-checkbox ng-if=\"!$root.user.isTeam\" \nclass=\"nl-Checkbox nl-Indicator__checkbox\" ng-model=\"indicateur.confidential\" aria-label=\"Checkbox\" md-no-ink \nng-change=\"setConfidentiel(indicateur, indicateur.confidential)\">Confidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox><md-menu class=\"nl-Menu nl-Indicator__menu\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" \nmd-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><span \nclass=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"generateGraph(indicateur)\">\nGénérer graph</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button\n class=\"nl-Menu-dropdown-btn\" ng-click=\"addToODJ(indicateur)\">Ajouter à l\'ordre du jour</md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" \nng-if=\"(indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\' && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\')\">\n<md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"update(indicateur, $index)\">Modifier</md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" \nng-if=\"indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\'  && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\'\">\n<md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"showPopUpArchive(indicateur, $index)\">Archiver</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"nl-Indicator__monthWrapper\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-body-legende\" \nng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div flex=\"100\" class=\"nl-Indicator__month__title\">{{indicateur.dataIndicateurs[0].year}}</div></div><div \nclass=\"nl-indicator-body-legende nl-legende--mensuel\" ng-if=\"periods[indicateur.period] === \'mensuel\'\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"nl-Indicator__month__title\">jan.</div><div \nclass=\"nl-Indicator__month__title\">fév.</div><div class=\"nl-Indicator__month__title\">mar.</div><div \nclass=\"nl-Indicator__month__title\">avr.</div><div class=\"nl-Indicator__month__title\">mai</div><div \nclass=\"nl-Indicator__month__title\">jui.</div><div class=\"nl-Indicator__month__title\">juil.</div><div \nclass=\"nl-Indicator__month__title\">aoû.</div><div class=\"nl-Indicator__month__title\">sep.</div><div \nclass=\"nl-Indicator__month__title\">oct.</div><div class=\"nl-Indicator__month__title\">nov.</div><div \nclass=\"nl-Indicator__month__title\">dec.</div></div><div class=\"nl-indicator-body-legende nl-legende--trimestriel\" \nng-if=\"periods[indicateur.period] === \'trimestriel\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">1er Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">3eme Trimestre\n</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre</div></div></div><div \nclass=\"nl-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\" class=\"nl-indicator-body-item\"><div \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div><input \nng-change=\"inputUpdated(data)\" ng-blur=\"inputChanged(data)\" ng-model=\"data.value\" \nng-class=\"{\n                    \'nl-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                    \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                    \'nl-Text--green\': checkGoalOK(data, indicateur),\n                    \'nl-Indicator__month__input--active\': isToday(data, periods[indicateur.period])}\" \nclass=\"nl-Indicator__month__input\" \nng-disabled=\"indicateur.status === \'MALFUNCTION\' || indicateur.status === \'DISPENSATION\' || indicateur.status === \'DYNAMIC\'||indicateur.status ===\'ECOR\'\">\n</div></div></div></div><div class=\"nl-Indicator__item__infos\"><span ng-if=\"indicateur.goal != null\">\nObjectif : {{printNumber(indicateur.goal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">Moyenne : {{average(indicateur.dataIndicateurs)}}{{indicateur.format}}\n</span></div></div><div ng-if=\"indicateur.previousDataIndicateurs.length > 0 && indicateur.showPrevious\"><div \nclass=\"nl-Indicator__Body\"><div class=\"nl-Indicator__subTitle\">Valeurs {{yearChosen - 1}}</div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl-indicator-body-item\"><div \nng-repeat=\"data in indicateur.previousDataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div>\n<input ng-model=\"data.value\" class=\"nl-Indicator__month__input\" disabled=\"disabled\"></div></div></div></div><div \nclass=\"nl-Indicator__item__infos\"><span ng-if=\"indicateur.previousGoal != null\">\nObjectif : {{printNumber(indicateur.previousGoal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">\nMoyenne : {{average(indicateur.previousDataIndicateurs)}}{{indicateur.format}}</span></div></div><div \nclass=\"nl-Indicator__showMoreWrapper\"><div ng-if=\"indicateur.previousDataIndicateurs.length > 0\"><button \nclass=\"nl-Indicator__showMore\" type=\"button\" ng-class=\"{\'nl-is--hidden\': indicateur.showPrevious}\" \nng-click=\"indicateur.showPrevious = !indicateur.showPrevious\"><md-icon class=\"nl-Indicator__showMore__icon\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\" role=\"img\" aria-hidden=\"true\"></md-icon></button>\n<md-tooltip md-direction=\"top\">{{indicateur.showPrevious ? \'Cacher\' : \'Afficher\'}} les valeurs {{yearChosen - 1}}\n</md-tooltip></div></div></div><div class=\"nl-Indicator__item\" ng-repeat=\"indicateur in indicateurs track by $index\">\n<div class=\"nl-Indicator__header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"nl-indicator-header-title\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"orderMode.active\" \nclass=\"nl-Indicator__sortWrapper\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"nl-Indicator__sort md-icon-button\" type=\"button\" md-no-ink ng-hide=\"$last\" \nng-click=\"move(indicateur, false); $event.stopPropagation();\"><md-icon \nmd-svg-src=\"assets/icons/app/board/arrow_down.svg\"></md-icon></md-button><md-button \nclass=\"nl-Indicator__sort md-icon-button\" type=\"button\" md-no-ink ng-hide=\"$first\" \nng-click=\"move(indicateur, true); $event.stopPropagation();\"><md-icon md-svg-src=\"assets/icons/app/board/arrow_up.svg\">\n</md-icon></md-button></div><div class=\"nl-Indicator__title\">{{indicateur.title}} <span ng-if=\"indicateur.format\">\n( {{indicateur.format}} )</span></div></div><div class=\"nl-Indicator__toolbarInfos flex-noshrink\"><div \nng-if=\"periods[indicateur.period] === \'mensuel\'\">Fréquence mensuelle</div><div \nng-if=\"periods[indicateur.period] === \'trimestriel\'\">Fréquence trimestrielle</div><div \nng-if=\"periods[indicateur.period] === \'annuel\'\">Fréquence annuelle</div><md-checkbox ng-if=\"!$root.user.isTeam\" \nclass=\"nl-Checkbox nl-Indicator__checkbox\" ng-model=\"indicateur.confidential\" aria-label=\"Checkbox\" md-no-ink \nng-change=\"setConfidentiel(indicateur, indicateur.confidential)\">Confidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox><md-menu class=\"nl-Menu nl-Indicator__menu\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" \nmd-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><span \nclass=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"generateGraph(indicateur)\">\nGénérer graph</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button\n class=\"nl-Menu-dropdown-btn\" ng-click=\"addToODJ(indicateur)\">Ajouter à l\'ordre du jour</md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" \nng-if=\"(indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\' && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\')\">\n<md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"update(indicateur, $index)\">Modifier</md-button></md-menu-item>\n<md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" \nng-if=\"indicateur.status !== \'MALFUNCTION\' && indicateur.status !== \'DISPENSATION\'  && indicateur.status !== \'DYNAMIC\' && indicateur.status !== \'ECOR\'\">\n<md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"showPopUpArchive(indicateur, $index)\">Archiver</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"nl-Indicator__monthWrapper\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-body-legende\" \nng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div flex=\"100\" class=\"nl-Indicator__month__title\">{{indicateur.dataIndicateurs[0].year}}</div></div><div \nclass=\"nl-indicator-body-legende nl-legende--mensuel\" ng-if=\"periods[indicateur.period] === \'mensuel\'\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"nl-Indicator__month__title\">jan.</div><div \nclass=\"nl-Indicator__month__title\">fév.</div><div class=\"nl-Indicator__month__title\">mar.</div><div \nclass=\"nl-Indicator__month__title\">avr.</div><div class=\"nl-Indicator__month__title\">mai.</div><div \nclass=\"nl-Indicator__month__title\">jui.</div><div class=\"nl-Indicator__month__title\">juil.</div><div \nclass=\"nl-Indicator__month__title\">aoû.</div><div class=\"nl-Indicator__month__title\">sep.</div><div \nclass=\"nl-Indicator__month__title\">oct.</div><div class=\"nl-Indicator__month__title\">nov.</div><div \nclass=\"nl-Indicator__month__title\">dec.</div></div><div class=\"nl-indicator-body-legende nl-legende--trimestriel\" \nng-if=\"periods[indicateur.period] === \'trimestriel\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">1er Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">3eme Trimestre\n</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre</div></div></div><div \nclass=\"nl-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\"><div \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div><input \nng-change=\"inputUpdated(data)\" ng-blur=\"inputChanged(data)\" ng-model=\"data.value\" \nng-class=\"{\n                    \'nl-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                    \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                    \'nl-Text--green\': checkGoalOK(data, indicateur),\n                    \'nl-indicator--today\': isToday(data, periods[indicateur.period])}\" \nclass=\"nl-Indicator__month__input\"></div></div></div></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"indicateur.goal != null\">Objectif : {{printNumber(indicateur.goal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">Moyenne : {{average(indicateur.dataIndicateurs)}}{{indicateur.format}}\n</span></div></div><div ng-if=\"indicateur.previousDataIndicateurs.length > 0 && indicateur.showPrevious\"><div \nclass=\"nl-Indicator__Body\"><div class=\"nl-Indicator__subTitle\">Valeurs {{yearChosen - 1}}</div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl-indicator-body-item\"><div \nng-repeat=\"data in indicateur.previousDataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div>\n<input ng-model=\"data.value\" class=\"nl-Indicator__month__input\" disabled=\"disabled\"></div></div></div></div><div \nclass=\"nl-Indicator__item__infos\"><span ng-if=\"indicateur.previousGoal != null\">\nObjectif : {{printNumber(indicateur.previousGoal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">\nMoyenne : {{average(indicateur.previousDataIndicateurs)}}{{indicateur.format}}</span></div></div><div \nclass=\"nl-Indicator__showMoreWrapper\"><div ng-if=\"indicateur.previousDataIndicateurs.length > 0\"><button \nclass=\"nl-Indicator__showMore\" type=\"button\" ng-class=\"{\'nl-is--hidden\': indicateur.showPrevious}\" \nng-click=\"indicateur.showPrevious = !indicateur.showPrevious\"><md-icon class=\"nl-Indicator__showMore__icon\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\" role=\"img\" aria-hidden=\"true\"></md-icon></button>\n<md-tooltip md-direction=\"top\">{{indicateur.showPrevious ? \'Cacher\' : \'Afficher\'}} les valeurs {{yearChosen - 1}}\n</md-tooltip></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-show=\"indicateurs.length === 0 && indicateursSpecials.length === 0\"><p>Aucun résultat...</p></md-list-item></div>\n<button type=\"button\" class=\"mb-25 nl-Btn\" ng-show=\"indicateursArchived && indicateursArchived.length>0 && hasArchive\" \nng-click=\"showArchive()\">{{archiveEmpty ? \'Afficher\' : \'Ne plus afficher\'}} les archives</button><div \nclass=\"mt-25 mb-55\" ng-show=\"!archiveEmpty\"><h2 class=\"nl-H2\">Archives</h2><div class=\"nl-Indicator__item\" \nng-repeat=\"indicateur in indicateursArchived track by $index\"><div class=\"nl-Indicator__header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-header-title\"><div class=\"nl-Indicator__title\">\n{{indicateur.title}} <span ng-if=\"indicateur.format\">({{indicateur.format}})</span></div></div><div \nclass=\"nl-Indicator__toolbarInfos flex-noshrink\"><div ng-if=\"periods[indicateur.period] === \'mensuel\'\">\nFréquence mensuelle</div><div ng-if=\"periods[indicateur.period] === \'trimestriel\'\">Fréquence trimestrielle</div><div \nng-if=\"periods[indicateur.period] === \'annuel\'\">Fréquence annuelle</div><md-checkbox ng-disabled=\"true\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\" class=\"nl-Checkbox nl-Indicator__checkbox\" \nng-model=\"indicateur.confidential\" aria-label=\"Checkbox\" md-no-ink \nng-change=\"setConfidentiel(indicateur, !indicateur.confidential)\">Confidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox><md-menu class=\"nl-Menu nl-Indicator__menu\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" \nmd-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\" \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"showPopUpArchive(indicateur, $index, true)\">Désarchiver</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"nl-Indicator__monthWrapper\"><div layout=\"row\" layout-align=\"space-between center\">\n<div class=\"nl-indicator-body-legende\" ng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div flex=\"100\" class=\"nl-Indicator__month__title pr-15\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div class=\"nl-indicator-body-legende nl-legende--mensuel\" \nng-if=\"periods[indicateur.period] === \'mensuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div class=\"nl-Indicator__month__title\">jan.</div><div class=\"nl-Indicator__month__title\">fév.</div><div \nclass=\"nl-Indicator__month__title\">mar.</div><div class=\"nl-Indicator__month__title\">avr.</div><div \nclass=\"nl-Indicator__month__title\">mai.</div><div class=\"nl-Indicator__month__title\">jui.</div><div \nclass=\"nl-Indicator__month__title\">juil.</div><div class=\"nl-Indicator__month__title\">aoû.</div><div \nclass=\"nl-Indicator__month__title\">sep.</div><div class=\"nl-Indicator__month__title\">oct.</div><div \nclass=\"nl-Indicator__month__title\">nov.</div><div class=\"nl-Indicator__month__title\">dec.</div></div><div \nclass=\"nl-indicator-body-legende nl-legende--trimestriel\" ng-if=\"periods[indicateur.period] === \'trimestriel\'\" \nlayout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">\n1er Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">3eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre\n</div></div></div><div class=\"nl-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\"><div \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div><input \ndisabled=\"disabled\" ng-model=\"data.value\" \nng-class=\"{\'nl-Text--red\': checkGoalOK(data, indicateur) === false, \'nl-Text--green\': checkGoalOK(data, indicateur)}\" \nclass=\"nl-Indicator__month__input\"></div></div></div></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"indicateur.goal != null\">Objectif : {{printNumber(indicateur.goal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">Moyenne : {{average(indicateur.dataIndicateurs)}}{{indicateur.format}}\n</span></div></div><div class=\"nl-Indicator__monthWrapper\" \nng-if=\"indicateur.previousDataIndicateurs.length > 0 && indicateur.showPrevious\"><div class=\"nl-Indicator__Body\"><div \nclass=\"nl-Indicator__subTitle\">Valeurs {{yearChosen - 1}}</div><div layout=\"row\" layout-align=\"space-between center\">\n<div ng-repeat=\"data in indicateur.previousDataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\">\n<div><input disabled=\"disabled\" ng-model=\"data.value\" class=\"nl-Indicator__month__input\"></div></div></div></div><div \nclass=\"nl-Indicator__item__infos\"><span ng-if=\"indicateur.previousGoal != null\">\nObjectif : {{printNumber(indicateur.previousGoal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">\nMoyenne : {{average(indicateur.previousDataIndicateurs)}}{{indicateur.format}}</span></div></div><div \nclass=\"nl-Indicator__showMoreWrapper\"><div ng-if=\"indicateur.previousDataIndicateurs.length > 0\"><button \nclass=\"nl-Indicator__showMore\" type=\"button\" ng-class=\"{\'nl-is--hidden\': indicateur.showPrevious}\" \nng-click=\"indicateur.showPrevious = !indicateur.showPrevious\"><md-icon class=\"nl-Indicator__showMore__icon\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_performance.svg\" role=\"img\" aria-hidden=\"true\"></md-icon></button>\n<md-tooltip md-direction=\"top\">{{indicateur.showPrevious ? \'Cacher\' : \'Afficher\'}} les valeurs {{yearChosen - 1}}\n</md-tooltip></div></div></div><md-list-item class=\"no-results md-white-bg\" ng-show=\"indicateursArchived.length === 0\">\n<p>Aucun résultat...</p></md-list-item></div></div></section>");
$templateCache.put("app/main/front/profile/popup/account_dialog.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Compte\" flex=\"40\"><form name=\"accountForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"accountForm.$valid && updateAccount()\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-30\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">\nModification du compte {{account.isTitulaire || account.isAdmin ? \'Administrateur\' : account.isPraq ? \'Responsable Qualité\' : account.isTeam ? \'Equipe\' : \'\'}}\n</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div \nflex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar><md-dialog-content ms-scroll><input \ntype=\"email\" name=\"mailT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"> <input type=\"password\" \nname=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"><md-input-container \nclass=\"nl-Input-container\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-Input-label md-no-float\">Email</label><input ng-disabled=\"user.isTeam\" type=\"email\" name=\"mail\" \nng-model=\"account.mail\" class=\"nl-Input-input\" ng-required=\"account.isTitulaire\" placeholder=\"\"><div \nng-messages=\"accountForm.mail.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div>\n<div ng-message=\"email\"><span>Mauvais format</span></div></div><div ng-messages=\"error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"user\"><span>Email non disponible</span></div></div></md-input-container>\n<md-input-container class=\"nl-Input-container\" \nng-if=\"($root.user.isTitulaire && account.isTitulaire) || ($root.user.isPraq && account.isPraq) || ($root.user.isAdmin && account.isAdmin)\" \nflex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nAncien mot de passe (si vous voulez le changer)</label><input ng-disabled=\"user.isTeam\" type=\"password\" \nname=\"actualPassword\" ng-model=\"account.actualPassword\" ng-required=\"checkPwdField(account.actualPassword)\" \nclass=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"accountForm.actualPassword.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div><div ng-messages=\"error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"pass\"><span>Mot de passe invalide</span></div></div></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nouveau mot de passe</label><input ng-disabled=\"user.isTeam\" \ntype=\"password\" name=\"newPassword\" ng-model=\"account.newPassword\" \nng-required=\"account.actualPassword && account.actualPassword!=\'\' && checkPwdField(account.actualPassword)\" \nclass=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"accountForm.newPassword.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><md-input-container \nclass=\"nl-Input-container nl-noError\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nConfirmation du nouveau mot de passe</label><input ng-disabled=\"user.isTeam\" type=\"password\" name=\"newPasswordConfirm\" \nng-model=\"account.newPasswordConfirm\" equals-to=\"accountForm.newPassword\" \nng-required=\"account.actualPassword && account.actualPassword!=\'\' && checkPwdField(account.actualPassword)\" \nclass=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"accountForm.newPasswordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div><div \nng-if=\"!accountForm.newPasswordConfirm.$error.required\" ng-message=\"equalsTo\"><span>\nLes deux mots de passe sont différents</span></div></div></md-input-container></md-dialog-content><md-dialog-actions>\n<button type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/front/qualite/auto-controles/autoControles.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Auto-contrôles qualité</h1><div \nclass=\"nl-listing mt-45\"><div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"autoCtrl in autoControles | orderBy : order\" ng-click=\"goFlashs(autoCtrl)\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/animationqual/dossier.svg\" class=\"nl-listing-item-icon\"></md-icon></md-button><div \nclass=\"text-truncate nl-listing-item-title\">{{autoCtrl.name}}</div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-if=\"autoControles.length === 0\"><p>Aucun résultat...</p></md-list-item></div>\n</section>");
$templateCache.put("app/main/front/qualite/auto-controles/flash.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Auto-contrôle: {{titleFlash}}</h1><button \nclass=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour à la liste</span></button><form name=\"flashForm\" class=\"md-inline-form\" \nng-submit=\"flashForm.$valid && validate()\"><div class=\"nl-form-wrapper\"><h2 class=\"nl-H2\">{{titleFlash}}</h2><h3 \nng-if=\"flash.updateDate != null\">Dernière modification: {{flash.updateDate | date:\'dd/MM/yyyy à HH:mm\'}}</h3><div \nlayout=\"row\" layout-wrap class=\"pt-25\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Les points forts<span ng-if=\"flash.plus == null\" \nclass=\"asterix\">*</span></label><textarea class=\"nl-Input-textarea\" ng-model=\"flash.plus\" name=\"plus\" rows=\"2\" \nmax-rows=\"4\" md-no-resize required></textarea></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Les points faibles<span \nng-if=\"flash.moins == null\" class=\"asterix\">*</span></label><textarea class=\"nl-Input-textarea\" ng-model=\"flash.moins\" \nname=\"moins\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nDysfonctionnements rencontrés<span ng-if=\"flash.malfunctions == null\" class=\"asterix\">*</span></label><textarea \nclass=\"nl-Input-textarea\" ng-model=\"flash.malfunctions\" name=\"malfunctions\" rows=\"2\" max-rows=\"4\" md-no-resize \nrequired></textarea></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Existe-t-il une procédure<span \nng-if=\"flash.processExist == null\" class=\"asterix\">*</span></label><md-radio-group name=\"processExist\" required \nclass=\"nl-Radio-wrapper nl-radio--inline\" ng-model=\"flash.processExist\" md-no-ink><md-radio-button class=\"nl-Radio\" \nng-value=\"trueValue\" aria-label=\"oui\">Oui</md-radio-button><md-radio-button class=\"nl-Radio\" ng-value=\"falseValue\" \naria-label=\"non\">Non</md-radio-button></md-radio-group></md-input-container><div class=\"pt-25\" flex=\"100\">\n<md-input-container class=\"nl-Input-container\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nUne procédure serait-elle utile ?<span ng-if=\"flash.processUseful == null\" class=\"asterix\">*</span></label>\n<md-radio-group name=\"processUseful\" required class=\"nl-Radio-wrapper nl-radio--inline\" ng-model=\"flash.processUseful\" \nmd-no-ink><md-radio-button class=\"nl-Radio\" ng-value=\"trueValue\" aria-label=\"oui\">Oui</md-radio-button><md-radio-button\n class=\"nl-Radio\" ng-value=\"falseValue\" aria-label=\"non\">Non</md-radio-button></md-radio-group></md-input-container>\n</div><div class=\"pt-25\" flex=\"100\" ng-if=\"!addCollaborateurMode\"><md-input-container class=\"nl-Input-container\"><label\n class=\"nl-Input-label md-no-float md-container-ignore\">Personne ayant réalisé l\'auto-contrôle</label><md-select \nrequired name=\"collaborateur\" ng-model=\"flash.collaborateurID\" ng-change=\"changeCollab(flash.collaborateurID)\" \nclass=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez le collaborateur</md-select-header><md-option \nclass=\"nl-Select-dropdown-btn\" ng-value=\"collaborateur.id\" ng-repeat=\"collaborateur in collaborateurs\">\n{{collaborateur.surname}} {{collaborateur.name}}</md-option><md-option class=\"nl-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></md-input-container></div></div><div class=\"pt-45\" \nlayout=\"row\" layout-align=\"end center\"><button ng-disabled=\"submitting\" class=\"nl-Btn\" type=\"submit\">Enregistrer\n</button></div></div></form></div></section>");
$templateCache.put("app/main/front/qualite/auto-controles/flashs.html","<section class=\"nl-Page pb-45\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">{{titleAutoCtrl}}</h1><button \nclass=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour à la liste</span></button><div class=\"mt-45\" layout=\"row\" layout-align=\"end center\">\n<button type=\"button\" class=\"nl-Btn\" ng-click=\"generateDoc()\">Imprimer le support</button> <button type=\"button\" \nclass=\"nl-Btn ml-20\" ng-click=\"planTache()\">Planifier une action correctrice</button></div><div \nclass=\"nl-listing mt-45\"><div class=\"nl-listing-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"flash in flashs  | orderBy : \'index\'\" ng-click=\"goFlash(flash)\"><div class=\"nl-dib\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Dossier\"><md-icon \nmd-svg-src=\"assets/icons/app/planning/flash.svg\" class=\"nl-listing-item-icon\"></md-icon></md-button></div><div \nclass=\"flex\"><div class=\"text-truncate nl-listing-item-title\">{{flash.name}}</div><div \nclass=\"nl-listing-item-description\" ng-if=\"flash.updateDate\">\nDernière modification le {{flash.updateDate | date:\"dd/MM/yyyy à HH:mm\"}}</div><div \nclass=\"nl-listing-item-description\" ng-if=\"flash.author\">Auteur : {{flash.author}}</div></div></div></div><md-list-item\n class=\"no-results md-white-bg\" ng-if=\"flashs.length === 0\"><p>Aucun résultat...</p></md-list-item></div></section>");
$templateCache.put("app/main/front/qualite/communication-interne/communication-interne.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Communication interne</h1><div class=\"mt-20\" \nlayout=\"row\" layout-align=\"center center\"><button flex=\"50\" class=\"nl-Btn ml-10\" ng-click=\"goNotesInternes()\">\nNotes internes</button></div></div></section>");
$templateCache.put("app/main/front/qualite/demarche/demarche.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Mise en oeuvre de la démarche</h1></div><div \nclass=\"nl-Content\"><h2 class=\"nl-H2\">Tâches annuelles</h2><div class=\"nl-listing\" \nng-repeat=\"task in annualTasks track by $index\"><div class=\"nl-listing-item\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div \nclass=\"nl-list-item-description\"><span ng-if=\"task.echeance && !task.done\">\nA faire le {{task.echeance | date: \"dd/MM/yyyy\"}} <span ng-if=\"task.responsable\">\n• {{task.responsable.name + \" \" + task.responsable.surname}} </span></span><span ng-if=\"!task.echeance && !task.done\">\nA planifier </span><span ng-if=\"task.done\">Réalisé le {{task.echeance | date: \"dd/MM/yyyy\"}} <span \nng-if=\"task.responsable\">• {{task.responsable.name + \" \" + task.responsable.surname}}</span></span></div></div></div>\n<div layout=\"row\" layout-align=\"start center\"><div class=\"nl-dib\"><md-button ng-click=\"_edit(task, true)\" \nclass=\"nl-Btn nl-Btn--outline nl-Btn--sm m-0\" ng-if=\"task.echeance && !task.done\">Modifier</md-button><md-button \nng-click=\"_edit(task, true)\" class=\"nl-Btn nl-Btn--sm m-0\" ng-if=\"!task.echeance && !task.done\">Planifier</md-button>\n<md-icon class=\"icon-check nl-Icon-checked\" ng-if=\"task.done\"></md-icon></div></div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-if=\"annualTasks.length === 0\"><p>Aucune tâche annuelle...</p></md-list-item></div>\n<button ng-hide=\"allLoaded.annualTasks\" ng-click=\"getAnnualTasks(false)\" class=\"nl-Btn nl-Btn--outline ml-10\">\nCharger plus</button><h2 class=\"nl-H2\">Initier la démarche qualité</h2><div class=\"nl-listing\"><div \nclass=\"nl-listing-item\" ng-repeat=\"task in tasksSelectedNotDone track by $index\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div \nclass=\"nl-list-item-description\"><span ng-if=\"task.echeance\">A faire le {{task.echeance | date: \"dd/MM/yyyy\"}} <span \nng-if=\"task.responsable\">• {{task.responsable.name + \" \" + task.responsable.surname}} </span></span><span \nng-if=\"!task.echeance\">A planifier</span></div></div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-dib\"><md-button ng-click=\"_edit(task, false)\" class=\"nl-Btn nl-Btn--outline nl-Btn--sm m-0\" \nng-if=\"task.echeance\">Modifier</md-button><md-button ng-click=\"_edit(task, false)\" class=\"nl-Btn nl-Btn--sm m-0\" \nng-if=\"!task.echeance\">Planifier</md-button></div></div></div></div><md-list-item class=\"no-results md-white-bg\" \nng-if=\"tasksSelectedNotDone.length === 0\"><p>Bravo, choisissez vos prochaines tâches à planifier</p></md-list-item>\n<button ng-click=\"goSelectionTasks()\" class=\"nl-Btn ml-10 mb-10\">Sélectionner 3 tâches</button></div><div \nclass=\"nl-listing\"><div class=\"nl-listing-item\" ng-repeat=\"task in tasksDone track by $index\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div><div class=\"nl-list-item-title\">{{task.title}}</div><div \nclass=\"nl-list-item-description\">\nRéalisé le {{task.echeance | date: \"dd/MM/yyyy\"}} • {{task.responsable.name + \" \" + task.responsable.surname}}</div>\n</div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-dib\"><md-icon \nclass=\"icon-check nl-Icon-checked\"></md-icon></div></div></div></div></div><button ng-hide=\"allLoaded.selectedDone\" \nng-click=\"getTasksSelectedDone(false)\" class=\"nl-Btn nl-Btn--outline ml-10 mb-25\">Charger plus</button></div></section>");
$templateCache.put("app/main/front/triage-osys/composants/osy-question.html","<div class=\"osy-question\" ng-if=\"question.type !== \'AIGUILLAGE\'\" data-noeud=\"{{question.code}}\" \ndata-type=\"{{question.type}}\" data-repondue=\"{{question.reponse ? \'oui\' : \'non\'}}\"><div class=\"osy-question__ligne\">\n<div class=\"osy-question__libelle\">{{question.libelle}}<div class=\"osy-question__aide\" ng-if=\"question.aide\">\n{{question.aide}}</div></div><div class=\"osy-question__reponses\" \nng-if=\"question.type === \'OUI_NON\' || question.type === \'OUI_NON_NSP\' || question.type === \'CHOIX\'\" \nng-class=\"{\'osy-question__reponses--choix\': question.type === \'CHOIX\'}\"><button type=\"button\" class=\"osy-reponse\" \nng-repeat=\"b in listeBoutons track by b.code\" data-valeur=\"{{b.code}}\" \nng-class=\"{\'osy-reponse--choisie\': question.reponse === b.code}\" ng-disabled=\"occupe\" ng-click=\"repondre(b.code)\" \naria-pressed=\"{{question.reponse === b.code}}\"><md-icon ng-if=\"question.reponse === b.code\" md-font-icon=\"icon-check\" \nclass=\"s16\"></md-icon>{{b.libelle}}</button></div><div class=\"osy-question__reponses\" \nng-if=\"question.type === \'INFO_AGE\'\"><span class=\"osy-pastille osy-pastille--gris\">{{question.texteAge}}</span> <span \nclass=\"osy-question__calcule\">calculé</span></div><div class=\"osy-question__reponses\" \nng-if=\"question.type === \'SCORE\' && question.score !== null && question.score !== undefined\"><span \nclass=\"osy-pastille osy-pastille--vert\">{{question.score}} {{unite(question.score)}}</span></div></div><div \nclass=\"osy-score\" ng-if=\"question.type === \'SCORE\'\"><div class=\"osy-score__groupe\" \nng-repeat=\"g in question.groupes track by g.code\"><div class=\"osy-score__titre\" \nng-if=\"g.libelle && g.type === \'RADIO\'\">{{g.libelle}}</div><div class=\"osy-score__option\" ng-if=\"g.type === \'RADIO\'\" \nng-repeat=\"o in g.options track by o.code\"><label class=\"osy-score__case\"><input type=\"radio\" \nname=\"{{question.code}}-{{g.code}}\" value=\"{{o.code}}\" ng-model=\"choix.radios[g.code]\" ng-change=\"changerScore()\" \nng-disabled=\"occupe\"> <span class=\"osy-score__libelle\">{{o.libelle}}</span></label><span class=\"osy-score__points\">\n{{points(o.points)}}</span></div><div class=\"osy-score__option\" ng-if=\"g.type !== \'RADIO\'\"><label \nclass=\"osy-score__case\"><input type=\"checkbox\" ng-model=\"choix.cases[g.code]\" ng-change=\"changerScore()\" \nng-disabled=\"occupe\"> <span class=\"osy-score__libelle\">{{g.libelle}}</span></label><span class=\"osy-score__points\" \nng-if=\"g.points !== null\">{{points(g.points)}}</span></div></div><p class=\"osy-score__note\" ng-if=\"question.note\">\n{{question.note}}</p></div><div class=\"osy-gestes\" ng-if=\"question.gestes.length\"><label class=\"osy-case\" \nng-repeat=\"g in question.gestes track by g.code\" data-geste=\"{{g.code}}\"><input type=\"checkbox\" ng-model=\"g.coche\" \nng-change=\"onGeste()\" ng-disabled=\"occupe\"> <span>{{g.libelle}}</span></label></div><div \nclass=\"osy-encart osy-encart--{{e.ton | lowercase}}\" ng-repeat=\"e in question.encarts track by e.code\" \ndata-encart=\"{{e.code}}\"><div class=\"osy-encart__titre\" ng-if=\"e.titre\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>{{e.titre}}</div><ul ng-if=\"e.lignes.length > 1\"><li \nng-repeat=\"l in e.lignes track by $index\">{{l}}</li></ul><p ng-if=\"e.lignes.length === 1\">{{e.lignes[0]}}</p></div>\n</div>");
$templateCache.put("app/main/front/triage-osys/mes-triages/mes-triages.html","<div class=\"osy-page\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\">Mes triages</h1><div \nclass=\"osy-entete__sous-titre\" ng-if=\"vm.contexte\">{{vm.sousTitre()}}</div></div><button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand\" ui-sref=\"app.osys.nouveau\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon>Nouveau triage</button></div><div class=\"osy-colonnes\"><div class=\"osy-colonnes__principale\">\n<section class=\"osy-carte\" id=\"osy-resultats\" ng-if=\"vm.recherche.active\"><header class=\"osy-carte__entete\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\" \nng-if=\"vm.recherche.lignes\">{{vm.titreRecherche()}}</h2><h2 class=\"osy-carte__titre\" ng-if=\"!vm.recherche.lignes\">\nRecherche…</h2><button type=\"button\" class=\"osy-carte__action-droite osy-btn osy-btn--lien\" \nng-click=\"vm.effacerRecherche()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>Effacer la recherche</button>\n</header><div class=\"osy-carte__corps\"><div class=\"osy-alerte osy-alerte--ambre\" ng-if=\"vm.recherche.tronque\">\n50 premiers résultats : précisez la recherche.</div><table class=\"osy-table\" ng-if=\"vm.recherche.lignes.length\"><thead>\n<tr><th>Date</th><th>Patient</th><th>Situation</th><th>Décision</th><th>Suivi</th><th>Transmission</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"l in vm.recherche.lignes track by l.triageId\"><td class=\"osy-table__date\"><span>\n{{l.debut | date:\'dd/MM/yyyy\'}}</span> <span class=\"osy-table__heure\">{{l.debut | date:\'HH:mm\'}}</span></td><td \nclass=\"osy-table__patient\">{{l.patient.prenom}} {{l.patient.nom | uppercase}}</td><td>{{l.arbre.libelle}}<span \nng-if=\"l.situationDetail\"> · {{l.situationDetail}}</span></td><td><osy-pastille ng-if=\"l.statut === \'EN_COURS\'\" \ntype=\"en-cours\">En cours</osy-pastille><osy-decision ng-if=\"l.statut !== \'EN_COURS\'\" prise-en-charge=\"l.priseEnCharge\" \napres-rappel=\"l.apresRappel\"></osy-decision></td><td><osy-suivi texte=\"l.suivi\"></osy-suivi></td><td><osy-pastille \nng-if=\"l.statut === \'VALIDE\'\" type=\"{{l.modeTransmission ? \'vert\' : \'ambre\'}}\">{{vm.transmissionCourte(l)}}\n</osy-pastille><span class=\"osy-texte-doux\" ng-if=\"l.statut !== \'VALIDE\'\">—</span></td><td class=\"osy-table__actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-if=\"l.statut === \'EN_COURS\'\" \nng-click=\"vm.reprendre(l.triageId)\">Reprendre</button> <button type=\"button\" class=\"osy-btn osy-btn--contour\" \nng-if=\"l.statut === \'VALIDE\' && l.compteRenduVersion\" ng-click=\"vm.ouvrirCompteRendu(l.triageId)\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s16\"></md-icon>Compte rendu</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-if=\"l.statut === \'VALIDE\'\" ng-click=\"vm.transmission(l.triageId)\"><md-icon \nmd-font-icon=\"icon-send\" class=\"s16\"></md-icon>Transmission</button></td></tr></tbody></table><p class=\"osy-vide\" \nng-if=\"vm.recherche.lignes && !vm.recherche.lignes.length\">Aucun triage trouvé pour « {{vm.recherche.texteCherche}} »\n</p><p class=\"osy-note\">\nLa recherche porte sur tous les triages de l’officine, quelle que soit leur date. Aucun numéro de sécurité sociale n’est affiché.\n</p></div></section><section class=\"osy-carte\" id=\"osy-suivi\" ng-if=\"!vm.recherche.active\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-phone\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Suivi des patients</h2><span class=\"osy-carte__sous-titre\">à rappeler aujourd’hui et en retard\n</span></header><div class=\"osy-carte__corps\"><table class=\"osy-table\" ng-if=\"vm.tableau.suivi.length\"><thead><tr><th>\nÉchéance</th><th>Patient</th><th>Situation</th><th>Orientation</th><th>Rappel</th><th></th></tr></thead><tbody><tr \nng-repeat=\"l in vm.tableau.suivi track by l.rappelId\" ng-class=\"{\'osy-table__ligne--retard\': l.enRetard}\"><td>\n<osy-echeance ligne=\"l\"></osy-echeance></td><td class=\"osy-table__patient\">\n{{l.patient.prenom}} {{l.patient.nom | uppercase}}</td><td>{{l.arbre.libelle}}</td><td><osy-decision \nprise-en-charge=\"l.priseEnCharge\" apres-rappel=\"l.apresRappel\"></osy-decision></td><td>{{vm.libelleDelai(l.delai)}}\n</td><td class=\"osy-table__actions\"><button type=\"button\" class=\"osy-btn osy-btn--principal\" \nng-click=\"vm.rappeler(l, $event)\"><md-icon md-font-icon=\"icon-phone\" class=\"s16\"></md-icon>Rappeler</button></td></tr>\n</tbody></table><p class=\"osy-vide\" ng-if=\"vm.tableau && !vm.tableau.suivi.length\">Aucun patient à rappeler aujourd’hui\n</p></div></section><section class=\"osy-carte\" id=\"osy-en-cours\" ng-if=\"!vm.recherche.active\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-clock\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Triages en cours</h2><span class=\"osy-carte__sous-titre\">non validés</span></header><div \nclass=\"osy-carte__corps\"><table class=\"osy-table\" ng-if=\"vm.tableau.enCours.length\"><thead><tr><th>Patient</th><th>\nSituation</th><th>Commencé</th><th></th></tr></thead><tbody><tr \nng-repeat=\"l in vm.tableau.enCours track by l.triageId\"><td class=\"osy-table__patient\">\n{{l.patient.prenom}} {{l.patient.nom | uppercase}}</td><td>{{l.arbre.libelle}}</td><td>{{vm.commence(l.debut)}}<span \nng-if=\"l.titulaire\"> · {{l.titulaire}}</span></td><td class=\"osy-table__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"vm.reprendre(l.triageId)\">Reprendre</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-click=\"vm.abandonner(l, $event)\">Abandonner</button></td></tr></tbody></table><p \nclass=\"osy-vide\" ng-if=\"vm.tableau && !vm.tableau.enCours.length\">Aucun triage en cours</p></div></section><section \nclass=\"osy-carte\" id=\"osy-mois\" ng-if=\"!vm.recherche.active\"><header class=\"osy-carte__entete\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">\nTriages du mois</h2><div class=\"osy-carte__filtres\"><select class=\"osy-select\" ng-model=\"vm.filtres.arbre\" \nng-change=\"vm.changerFiltres()\" aria-label=\"Situation\"><option value=\"\">Toutes les situations</option><option \nng-repeat=\"a in vm.contexte.arbres track by a.code\" value=\"{{a.code}}\">{{a.libelle}}</option></select><select \nclass=\"osy-select\" ng-model=\"vm.filtres.mois\" ng-change=\"vm.changerFiltres()\" aria-label=\"Mois\"><option \nng-repeat=\"m in vm.tableau.moisDisponibles track by m\" value=\"{{m}}\">{{vm.libelleMois(m)}}</option></select></div>\n</header><div class=\"osy-carte__corps\"><table class=\"osy-table\" ng-if=\"vm.tableau.triagesDuMois.lignes.length\"><thead>\n<tr><th>Date</th><th>Patient</th><th>Situation</th><th>Décision</th><th>Suivi</th><th>Transmission</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"l in vm.tableau.triagesDuMois.lignes track by l.triageId\"><td class=\"osy-table__date\">\n{{l.debut | date:\'dd/MM HH:mm\'}}</td><td class=\"osy-table__patient\">{{l.patient.prenom}} {{l.patient.nom | uppercase}}\n</td><td>{{l.arbre.libelle}}</td><td><osy-decision prise-en-charge=\"l.priseEnCharge\" apres-rappel=\"l.apresRappel\">\n</osy-decision></td><td><osy-suivi texte=\"l.suivi\"></osy-suivi></td><td><osy-pastille ng-if=\"l.statut === \'VALIDE\'\" \ntype=\"{{l.modeTransmission ? \'vert\' : \'ambre\'}}\">{{vm.transmissionCourte(l)}}</osy-pastille><span \nclass=\"osy-texte-doux\" ng-if=\"l.statut !== \'VALIDE\'\">—</span></td><td class=\"osy-table__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-if=\"l.compteRenduVersion\" ng-click=\"vm.ouvrirCompteRendu(l.triageId)\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s16\"></md-icon>Compte rendu</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-if=\"l.statut === \'VALIDE\'\" ng-click=\"vm.transmission(l.triageId)\"><md-icon \nmd-font-icon=\"icon-send\" class=\"s16\"></md-icon>Transmission</button></td></tr></tbody></table><p class=\"osy-vide\" \nng-if=\"vm.tableau && !vm.tableau.triagesDuMois.lignes.length\">Aucun triage ce mois-ci</p><div class=\"osy-pagination\" \nng-if=\"vm.pages() > 1\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-disabled=\"vm.page <= 1\" \nng-click=\"vm.allerPage(vm.page - 1)\">‹ Précédents</button> <span>Page {{vm.page}} / {{vm.pages()}}</span> <button \ntype=\"button\" class=\"osy-btn osy-btn--lien\" ng-disabled=\"vm.page >= vm.pages()\" ng-click=\"vm.allerPage(vm.page + 1)\">\nSuivants ›</button></div></div></section></div><aside class=\"osy-colonnes__laterale\"><form class=\"osy-recherche\" \nng-submit=\"vm.rechercher()\" novalidate autocomplete=\"off\"><md-icon md-font-icon=\"icon-magnify\" class=\"s18\"></md-icon>\n<input type=\"text\" ng-model=\"vm.recherche.texte\" ng-change=\"vm.saisieRecherche()\" placeholder=\"Rechercher un patient…\" \naria-label=\"Rechercher un patient\" maxlength=\"100\"> <button type=\"button\" class=\"osy-recherche__effacer\" \nng-if=\"vm.recherche.texte\" ng-click=\"vm.effacerRecherche()\" aria-label=\"Effacer la recherche\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></form><p class=\"osy-recherche__aide\" \nng-if=\"vm.recherche.aide\">{{vm.recherche.aide}}</p><section class=\"osy-carte\"><header class=\"osy-carte__entete\">\n<md-icon md-font-icon=\"icon-chart-bar\" class=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">\n{{vm.libelleMois(vm.tableau.mois)}}</h2><span class=\"osy-carte__sous-titre\">triages réalisés</span></header><div \nclass=\"osy-carte__corps\"><div class=\"osy-anneau\"><canvas id=\"osy-anneau\" width=\"220\" height=\"220\"></canvas><div \nclass=\"osy-anneau__centre\"><span class=\"osy-anneau__total\">{{vm.tableau.repartition.total || 0}}</span> <span \nclass=\"osy-anneau__libelle\">{{vm.tableau.repartition.total > 1 ? \'triages\' : \'triage\'}}</span></div></div><ul \nclass=\"osy-legende\"><li ng-repeat=\"p in vm.tableau.repartition.parArbre track by p.code\"><span \nclass=\"osy-legende__carre\" ng-style=\"{\'background-color\': p.couleur}\"></span> <span class=\"osy-legende__libelle\">\n{{p.libelle}}</span> <span class=\"osy-legende__nombre\">{{p.nombre}}</span> <span class=\"osy-legende__pourcentage\">\n{{p.pourcentage}} %</span></li></ul></div></section></aside></div></div>");
$templateCache.put("app/main/front/triage-osys/dialogs/cgu.html","<md-dialog class=\"osy-fenetre osy-fenetre--large\" aria-label=\"Conditions d\'utilisation du module OSyS\"><div \nclass=\"osy-fenetre__entete\"><div><h2 class=\"osy-fenetre__titre\">Conditions d’utilisation du module OSyS</h2><p \nclass=\"osy-fenetre__sous-titre\">À accepter une fois, avant le premier triage.</p></div><button type=\"button\" \nclass=\"osy-fenetre__fermer\" ng-click=\"d.annuler()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\">\n</md-icon></button></div><md-dialog-content class=\"osy-fenetre__corps\"><div class=\"osy-cgu\">{{d.cgu.texte}}</div><label\n class=\"osy-case osy-case--forte\"><input type=\"checkbox\" ng-model=\"d.accepte\">\n J’accepte les conditions d’utilisation du module OSyS.</label></md-dialog-content><div class=\"osy-fenetre__actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"d.annuler()\">Annuler</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal\" ng-disabled=\"!d.accepte || d.envoi\" ng-click=\"d.valider()\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon>Accepter et continuer</button></div></md-dialog>");
$templateCache.put("app/main/front/triage-osys/dialogs/doublon.html","<md-dialog class=\"osy-fenetre osy-fenetre--large\" aria-label=\"Patient déjà enregistré\"><div \nclass=\"osy-fenetre__entete\"><div><h2 class=\"osy-fenetre__titre\">\n{{d.possible ? \'Ce patient existe peut-être déjà\' : \'Ce NIR est déjà enregistré\'}}</h2><p \nclass=\"osy-fenetre__sous-titre\">{{d.erreur.message}}</p></div><button type=\"button\" class=\"osy-fenetre__fermer\" \nng-click=\"d.annuler()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button></div>\n<md-dialog-content class=\"osy-fenetre__corps\"><table class=\"osy-table\"><thead><tr><th>Patient</th><th>Né(e) le</th><th>\nTéléphone</th><th></th></tr></thead><tbody><tr ng-repeat=\"p in d.patients track by p.id\"><td><span \nclass=\"osy-table__patient\">{{p.prenom}} {{p.nom | uppercase}}</span><span class=\"osy-texte-doux\">\n · {{d.libelleSexe(p.sexe)}} · {{p.age}}</span></td><td>{{p.dateNaissance | date:\'dd/MM/yyyy\'}}</td><td>{{p.telephone}}\n</td><td class=\"osy-table__actions\"><button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-click=\"d.utiliser(p)\">\nUtiliser la fiche existante</button></td></tr></tbody></table></md-dialog-content><div class=\"osy-fenetre__actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"d.annuler()\">Annuler</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-if=\"d.possible\" ng-click=\"d.creerQuandMeme()\">Créer quand même</button></div>\n</md-dialog>");
$templateCache.put("app/main/front/triage-osys/dialogs/fiche-patient.html","<md-dialog class=\"osy-fenetre osy-fenetre--large\" aria-label=\"Fiche patient\"><div class=\"osy-fenetre__entete\"><div \nng-if=\"d.p\"><h2 class=\"osy-fenetre__titre\">{{d.p.prenom}} {{d.p.nom | uppercase}}</h2><p \nclass=\"osy-fenetre__sous-titre\">\n{{d.libelleSexe(d.p.sexe)}} · {{d.p.age}} · né(e) le {{d.p.dateNaissance | date:\'dd/MM/yyyy\'}}</p></div><div \nng-if=\"!d.p\"><h2 class=\"osy-fenetre__titre\">Fiche patient</h2></div><button type=\"button\" class=\"osy-fenetre__fermer\" \nng-click=\"d.fermer()\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button></div>\n<md-dialog-content class=\"osy-fenetre__corps\" ng-if=\"d.p\"><dl class=\"osy-recap\" ng-if=\"!d.edition\"><dt>NIR</dt><dd>\n<osy-pastille ng-if=\"d.p.nirRenseigne\" type=\"vert\" point=\"non\">NIR renseigné</osy-pastille><osy-pastille \nng-if=\"d.p.sansNir\" type=\"gris\" point=\"non\">Sans NIR</osy-pastille><span class=\"osy-texte-doux\" ng-if=\"d.p.sansNir\">\n{{d.MOTIFS_SANS_NIR[d.p.motifSansNir]}}</span></dd><dt>Téléphone</dt><dd>{{d.p.telephone}}</dd><dt>Code postal</dt><dd>\n{{d.p.codePostal}}</dd><dt>Médecin traitant</dt><dd>{{d.p.medecinTraitant || \'—\'}}</dd></dl><button type=\"button\" \nclass=\"osy-btn osy-btn--contour osy-fiche__modifier\" ng-if=\"!d.edition\" ng-click=\"d.modifier()\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>Modifier</button><div ng-if=\"d.edition\"><div class=\"osy-grille\"><div \nclass=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-fiche-nom\">Nom <span class=\"osy-requis\">*</span></label>\n<input id=\"osy-fiche-nom\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': d.erreurs.nom}\" ng-model=\"d.edition.nom\" \nmaxlength=\"100\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.nom\">{{d.erreurs.nom}}</p></div><div class=\"osy-champ-bloc\">\n<label class=\"osy-libelle\" for=\"osy-fiche-prenom\">Prénom <span class=\"osy-requis\">*</span></label><input \nid=\"osy-fiche-prenom\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': d.erreurs.prenom}\" ng-model=\"d.edition.prenom\" \nmaxlength=\"100\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.prenom\">{{d.erreurs.prenom}}</p></div><div \nclass=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-fiche-naissance\">Date de naissance <span class=\"osy-requis\">\n*</span></label><input id=\"osy-fiche-naissance\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': d.erreurs.dateNaissance}\" ng-model=\"d.edition.dateNaissance\" \nng-change=\"d.formaterDate()\" placeholder=\"jj/mm/aaaa\" inputmode=\"numeric\" maxlength=\"10\"><p class=\"osy-erreur\" \nng-if=\"d.erreurs.dateNaissance\">{{d.erreurs.dateNaissance}}</p></div><div class=\"osy-champ-bloc\"><span \nclass=\"osy-libelle\">Sexe <span class=\"osy-requis\">*</span></span><div class=\"osy-radios osy-radios--ligne\"><label \nclass=\"osy-radio\"><input type=\"radio\" name=\"osy-fiche-sexe\" value=\"F\" ng-model=\"d.edition.sexe\"> Femme</label><label \nclass=\"osy-radio\"><input type=\"radio\" name=\"osy-fiche-sexe\" value=\"H\" ng-model=\"d.edition.sexe\"> Homme</label></div>\n</div><div class=\"osy-champ-bloc\" ng-if=\"!d.edition.sansNir\"><label class=\"osy-libelle\" for=\"osy-fiche-nir\">NIR</label>\n<input id=\"osy-fiche-nir\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': d.erreurs.nir}\" ng-model=\"d.edition.nir\" \nng-change=\"d.formaterNir()\" \nplaceholder=\"{{d.p.nirRenseigne ? \'Renseigné : saisir pour le remplacer\' : \'2 90 09 34 172 055 18\'}}\" maxlength=\"21\" \nautocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.nir\">{{d.erreurs.nir}}</p><p class=\"osy-avertissement\" \nng-repeat=\"a in d.controleNir().avertissements track by $index\">{{a}}</p></div><div class=\"osy-champ-bloc\" \nng-if=\"d.edition.sansNir\"><label class=\"osy-libelle\" for=\"osy-fiche-motif\">Motif <span class=\"osy-requis\">*</span>\n</label><select id=\"osy-fiche-motif\" class=\"osy-select osy-select--plein\" ng-model=\"d.edition.motifSansNir\"><option \nvalue=\"\" disabled=\"disabled\">Choisir…</option><option ng-repeat=\"(code, libelle) in d.MOTIFS_SANS_NIR\" \nvalue=\"{{code}}\">{{libelle}}</option></select><p class=\"osy-erreur\" ng-if=\"d.erreurs.motifSansNir\">\n{{d.erreurs.motifSansNir}}</p></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-fiche-tel\">\nTéléphone <span class=\"osy-requis\">*</span></label><input id=\"osy-fiche-tel\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': d.erreurs.telephone}\" ng-model=\"d.edition.telephone\" type=\"tel\" maxlength=\"30\"><p \nclass=\"osy-erreur\" ng-if=\"d.erreurs.telephone\">{{d.erreurs.telephone}}</p></div><div class=\"osy-champ-bloc\"><label \nclass=\"osy-libelle\" for=\"osy-fiche-cp\">Code postal <span class=\"osy-requis\">*</span></label><input id=\"osy-fiche-cp\" \nclass=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': d.erreurs.codePostal}\" ng-model=\"d.edition.codePostal\" \nmaxlength=\"10\"><p class=\"osy-erreur\" ng-if=\"d.erreurs.codePostal\">{{d.erreurs.codePostal}}</p></div><div \nclass=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-fiche-medecin\">Médecin traitant</label><input \nid=\"osy-fiche-medecin\" class=\"osy-champ\" ng-model=\"d.edition.medecinTraitant\" placeholder=\"facultatif\" maxlength=\"200\">\n</div></div><label class=\"osy-case osy-case--compacte\"><input type=\"checkbox\" ng-model=\"d.edition.sansNir\">\n Patient sans NIR</label><div class=\"osy-fiche__boutons\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" \nng-click=\"d.edition = null\">Annuler</button> <button type=\"button\" class=\"osy-btn osy-btn--principal\" \nng-click=\"d.enregistrer()\" ng-disabled=\"d.envoi\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>\nEnregistrer la fiche</button></div></div><h3 class=\"osy-fiche__titre\">Triages</h3><table class=\"osy-table\" \nng-if=\"d.triages.length\"><thead><tr><th>Date</th><th>Situation</th><th>Décision</th><th></th></tr></thead><tbody><tr \nng-repeat=\"t in d.triages track by t.triageId\"><td class=\"osy-table__date\">{{t.debut | date:\'dd/MM/yyyy HH:mm\'}}</td>\n<td>{{t.arbre}}</td><td><osy-decision ng-if=\"t.statut === \'VALIDE\'\" prise-en-charge=\"t.priseEnCharge\" \napres-rappel=\"t.apresRappel\"></osy-decision><osy-pastille ng-if=\"t.statut === \'EN_COURS\'\" type=\"en-cours\">En cours\n</osy-pastille><span class=\"osy-texte-doux\" ng-if=\"t.statut === \'ABANDONNE\'\">Abandonné</span></td><td \nclass=\"osy-table__actions\"><button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-if=\"t.statut === \'VALIDE\'\" \nng-click=\"d.compteRendu(t)\">Compte rendu</button></td></tr></tbody></table><p class=\"osy-vide\" \nng-if=\"!d.triages.length\">Aucun triage.</p></md-dialog-content><div class=\"osy-fenetre__actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"d.fermer()\">Fermer</button></div></md-dialog>");
$templateCache.put("app/main/front/triage-osys/dialogs/rappel.html","<md-dialog class=\"osy-fenetre osy-fenetre--rappel\" aria-label=\"Rappel du patient\"><div class=\"osy-fenetre__entete\"><div\n ng-if=\"d.r\"><h2 class=\"osy-fenetre__titre\">{{d.titre()}}</h2><p class=\"osy-fenetre__sous-titre\">\n{{d.r.triage.arbre}} · triage du {{d.r.triage.date | date:\'dd/MM/yyyy\'}} · décision : {{d.decisionTriage()}}<span \nng-if=\"d.r.triage.apresRappel\"> (après rappel)</span></p></div><div ng-if=\"!d.r\"><h2 class=\"osy-fenetre__titre\">\nRappel du patient</h2></div><button type=\"button\" class=\"osy-fenetre__fermer\" ng-click=\"d.annuler()\" \naria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\" class=\"s20\"></md-icon></button></div><md-dialog-content \nclass=\"osy-fenetre__corps osy-rappel\" ng-if=\"d.r\"><section class=\"osy-rappel__section\"><h3 class=\"osy-rappel__titre\">\n<span class=\"osy-rappel__numero\">1</span> Joindre le patient</h3><div class=\"osy-rappel__ligne\"><span \nclass=\"osy-libelle osy-libelle--ligne\">Téléphone</span> <a class=\"osy-rappel__telephone\" \nng-href=\"tel:{{d.r.patient.telephone}}\">{{d.r.patient.telephone}}</a></div><div class=\"osy-rappel__ligne\" \nng-class=\"{\'osy-bloc--erreur\': d.erreurs.habilitationId}\"><label class=\"osy-libelle osy-libelle--ligne\" \nfor=\"osy-rappel-par\">Rappel réalisé par <span class=\"osy-requis\">*</span></label><select id=\"osy-rappel-par\" \nclass=\"osy-select osy-select--rappel\" ng-model=\"d.habilitationId\" \nng-options=\"h.id as (h.prenom + \' \' + (h.nom | uppercase) + \' · RPPS \' + h.rpps) for h in d.r.habilitations\"><option \nvalue=\"\" disabled=\"disabled\">Choisir le titulaire…</option></select></div><div class=\"osy-rappel__ligne\"><span \nclass=\"osy-libelle osy-libelle--ligne\">Patient joint ? <span class=\"osy-requis\">*</span></span><div \nclass=\"osy-question__reponses\"><button type=\"button\" class=\"osy-reponse\" \nng-class=\"{\'osy-reponse--choisie\': d.joint === true}\" ng-click=\"d.choisirJoint(true)\"><md-icon \nng-if=\"d.joint === true\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon>Oui</button> <button type=\"button\" \nclass=\"osy-reponse\" ng-class=\"{\'osy-reponse--choisie\': d.joint === false}\" ng-click=\"d.choisirJoint(false)\"><md-icon \nng-if=\"d.joint === false\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon>Non</button></div></div><div \nclass=\"osy-rappel__photos\" ng-if=\"d.r.photos.length\"><span class=\"osy-libelle\">Photos du triage</span><div \nclass=\"osy-photos__vignettes\"><button type=\"button\" class=\"osy-photos__vignette osy-photos__vignette--bouton\" \nng-repeat=\"p in d.r.photos track by p.id\" ng-click=\"d.agrandir(p)\" aria-label=\"Agrandir la photo {{$index + 1}}\"><img \nng-src=\"{{d.urlPhoto(p)}}\" alt=\"Photo {{$index + 1}} du triage\"></button></div><div class=\"osy-photo-agrandie\" \nng-if=\"d.photoAgrandie\" ng-click=\"d.photoAgrandie = null\"><img ng-src=\"{{d.urlPhoto(d.photoAgrandie)}}\" \nalt=\"Photo agrandie\"></div></div></section><section class=\"osy-rappel__section\" \nng-if=\"d.joint === false || d.r.tentatives.length\"><h3 class=\"osy-rappel__titre\"><span class=\"osy-rappel__numero\">2\n</span> Tentatives</h3><div class=\"osy-rappel__ligne\" ng-if=\"d.joint === false\" \nng-class=\"{\'osy-bloc--erreur\': d.erreurs.resultat}\"><span class=\"osy-libelle osy-libelle--ligne\">\nRésultat de la tentative <span class=\"osy-requis\">*</span></span><div class=\"osy-radios osy-radios--ligne\"><label \nclass=\"osy-radio\" ng-repeat=\"(code, libelle) in d.RESULTATS_PROPOSES\"><input type=\"radio\" name=\"osy-resultat\" \nvalue=\"{{code}}\" ng-model=\"d.resultat\"> {{libelle}}</label></div></div><table class=\"osy-table\" \nng-if=\"d.r.tentatives.length\"><thead><tr><th>Date et heure</th><th>Par</th><th>Résultat</th></tr></thead><tbody><tr \nng-repeat=\"t in d.r.tentatives track by $index\"><td>{{t.date | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{t.habilitation}}\n</td><td>{{d.RESULTATS[t.resultat] || t.resultat}}</td></tr></tbody></table><p class=\"osy-note\" \nng-if=\"d.joint === false\">\nLe patient reste dans « Suivi des patients ». Vous pouvez clôturer le suivi « patient injoignable » à tout moment.</p>\n</section><div ng-if=\"d.joint === true\"><section class=\"osy-rappel__section\"><h3 class=\"osy-rappel__titre\"><span \nclass=\"osy-rappel__numero\">{{d.numero(\'evolution\')}}</span> Évolution</h3><div class=\"osy-rappel__ligne\" \nng-repeat=\"q in d.r.surveillance track by q.code\" ng-class=\"{\'osy-bloc--erreur\': d.erreurs[\'surveillance.\' + q.code]}\">\n<span class=\"osy-libelle osy-libelle--ligne\">{{q.libelle}} <span class=\"osy-requis\">*</span></span><div \nclass=\"osy-question__reponses\"><button type=\"button\" class=\"osy-reponse\" \nng-class=\"{\'osy-reponse--choisie\': d.saisie.surveillance[q.code] === true}\" ng-click=\"d.repondre(q.code, true)\">\n<md-icon ng-if=\"d.saisie.surveillance[q.code] === true\" md-font-icon=\"icon-check\" class=\"s16\"></md-icon>Oui</button> \n<button type=\"button\" class=\"osy-reponse\" ng-class=\"{\'osy-reponse--choisie\': d.saisie.surveillance[q.code] === false}\" \nng-click=\"d.repondre(q.code, false)\"><md-icon ng-if=\"d.saisie.surveillance[q.code] === false\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon>Non</button></div></div><div class=\"osy-rappel__ligne\" \nng-class=\"{\'osy-bloc--erreur\': d.erreurs.evolution}\"><span class=\"osy-libelle osy-libelle--ligne\">\nÉvolution depuis le triage <span class=\"osy-requis\">*</span></span><div class=\"osy-radios osy-radios--ligne\"><label \nclass=\"osy-radio\" ng-repeat=\"(code, libelle) in d.EVOLUTIONS\"><input type=\"radio\" name=\"osy-evolution\" \nvalue=\"{{code}}\" ng-model=\"d.saisie.evolution\" ng-change=\"d.evaluer()\"> {{libelle}}</label></div></div><div \nclass=\"osy-alerte osy-alerte--vert\" ng-if=\"d.apercu && !d.apercu.issue && d.saisie.evolution === \'AMELIORATION\'\">\n<md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><strong>Évolution favorable</strong>\n : l’arbre ne prévoit pas de nouvelle orientation.</div><div class=\"osy-alerte osy-alerte--gris\" \nng-if=\"d.apercu && !d.apercu.issue && d.saisie.evolution && d.saisie.evolution !== \'AMELIORATION\'\">\nL’arbre ne prévoit pas de nouvelle orientation.</div></section><section class=\"osy-rappel__section\" \nng-if=\"d.apercu.issue\"><h3 class=\"osy-rappel__titre\"><span class=\"osy-rappel__numero\">{{d.numero(\'orientation\')}}\n</span> Nouvelle orientation prévue par l’arbre</h3><osy-orientation issue=\"d.apercu.issue\"></osy-orientation><div \nclass=\"osy-encart osy-encart--attention\" ng-if=\"d.teleconsultation()\"><div class=\"osy-encart__titre\">\nTéléconsultation déconseillée en cas de :</div><ul><li ng-repeat=\"x in d.teleconsultation().connus track by $index\">\n<strong>{{x}}</strong></li><li ng-repeat=\"x in d.teleconsultation().autres track by $index\">{{x}}</li></ul></div><div \nclass=\"osy-decision-ligne\"><p><span ng-bind-html=\"d.phraseDecision()\"></span> <button type=\"button\" class=\"osy-lien\" \nng-click=\"d.decisionOuverte = !d.decisionOuverte\">Choisir une autre prise en charge</button></p><div \nclass=\"osy-decision-choix\" ng-if=\"d.decisionOuverte\"><div class=\"osy-radios osy-radios--ligne\"><label \nclass=\"osy-radio\" ng-repeat=\"(code, libelle) in d.PRISES_EN_CHARGE\"><input type=\"radio\" name=\"osy-rappel-decision\" \nvalue=\"{{code}}\" ng-model=\"d.saisie.priseEnCharge\"> {{libelle}}<span class=\"osy-texte-doux\" \nng-if=\"code === d.apercu.priseEnChargeProposee\"> (proposé)</span></label></div></div></div><div \nclass=\"osy-alerte osy-alerte--bleu\"><md-icon md-font-icon=\"icon-file-document\" class=\"s16\"></md-icon>\nLe compte rendu sera réédité avec une section « Suivi ».</div></section><section class=\"osy-rappel__section\"><h3 \nclass=\"osy-rappel__titre\"><span class=\"osy-rappel__numero\">{{d.numero(\'fin\')}}</span> Fin du rappel</h3><div \nclass=\"osy-rappel__ligne\" ng-class=\"{\'osy-bloc--erreur\': d.erreurs.suiteDonnee}\"><label \nclass=\"osy-libelle osy-libelle--ligne\" for=\"osy-suite\">Suite donnée depuis le triage <span class=\"osy-requis\">*</span>\n</label><select id=\"osy-suite\" class=\"osy-select osy-select--rappel\" ng-model=\"d.saisie.suiteDonnee\"><option value=\"\" \ndisabled=\"disabled\">Choisir…</option><option ng-repeat=\"(code, libelle) in d.SUITES\" value=\"{{code}}\">{{libelle}}\n</option></select></div><div class=\"osy-rappel__ligne\" \nng-class=\"{\'osy-bloc--erreur\': d.erreurs.preconisationsSuivies}\"><span class=\"osy-libelle osy-libelle--ligne\">\nPréconisations suivies ? <span class=\"osy-requis\">*</span></span><div class=\"osy-question__reponses\"><button \ntype=\"button\" class=\"osy-reponse\" ng-class=\"{\'osy-reponse--choisie\': d.saisie.preconisationsSuivies === true}\" \nng-click=\"d.saisie.preconisationsSuivies = true\"><md-icon ng-if=\"d.saisie.preconisationsSuivies === true\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon>Oui</button> <button type=\"button\" class=\"osy-reponse\" \nng-class=\"{\'osy-reponse--choisie\': d.saisie.preconisationsSuivies === false}\" \nng-click=\"d.saisie.preconisationsSuivies = false\"><md-icon ng-if=\"d.saisie.preconisationsSuivies === false\" \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon>Non</button></div></div><div class=\"osy-champ-bloc osy-rappel__bloc\" \nng-if=\"d.saisie.preconisationsSuivies === false\"><label class=\"osy-libelle\" for=\"osy-cause\">Cause du non-suivi <span \nclass=\"osy-requis\">*</span></label><textarea id=\"osy-cause\" class=\"osy-champ osy-champ--zone\" \nng-class=\"{\'osy-champ--erreur\': d.erreurs.causeNonSuivi}\" ng-model=\"d.saisie.causeNonSuivi\" rows=\"2\" maxlength=\"2000\">\n</textarea></div><div class=\"osy-rappel__ligne osy-rappel__ligne--haut\" \nng-class=\"{\'osy-bloc--erreur\': d.erreurs.satisfaction}\"><span class=\"osy-libelle osy-libelle--ligne\">\nSatisfaction du patient <span class=\"osy-requis\">*</span></span><div><div class=\"osy-satisfaction__notes\"><button \ntype=\"button\" class=\"osy-reponse osy-reponse--carree\" ng-repeat=\"n in [1, 2, 3, 4, 5]\" \nng-class=\"{\'osy-reponse--choisie\': d.saisie.satisfaction === n}\" ng-click=\"d.saisie.satisfaction = n\">{{n}}</button>\n</div><div class=\"osy-satisfaction__bornes\"><span>Pas du tout satisfait</span><span>Très satisfait</span></div></div>\n</div><div class=\"osy-champ-bloc osy-rappel__bloc\"><label class=\"osy-libelle\" for=\"osy-commentaire\">Commentaire</label>\n<textarea id=\"osy-commentaire\" class=\"osy-champ osy-champ--zone\" ng-model=\"d.saisie.commentaire\" rows=\"2\" \nmaxlength=\"2000\"></textarea></div></section></div><p class=\"osy-erreur\" ng-if=\"d.erreurGlobale\">{{d.erreurGlobale}}</p>\n</md-dialog-content><div class=\"osy-fenetre__actions osy-fenetre__actions--confirmation\" ng-if=\"d.r && d.confirmation\">\n<span class=\"osy-fenetre__question\">\n{{d.confirmation === \'INJOIGNABLE\' ? \'Clôturer le suivi : patient injoignable ?\' : \'Clôturer le suivi : le patient ne souhaite pas être rappelé ?\'}} \n<span class=\"osy-texte-doux\">La tentative en cours n’est pas enregistrée.</span></span> <button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-click=\"d.confirmation = null\">Revenir</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--danger\" ng-click=\"d.confirmerCloture()\" ng-disabled=\"d.envoi\">Clôturer</button></div><div \nclass=\"osy-fenetre__actions\" ng-if=\"d.r && !d.confirmation\"><div class=\"osy-fenetre__actions-gauche\" \nng-if=\"d.joint === false\"><button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-click=\"d.cloturer(\'INJOIGNABLE\')\" \nng-disabled=\"d.envoi\">Clôturer : patient injoignable</button> <button type=\"button\" class=\"osy-btn osy-btn--lien\" \nng-click=\"d.cloturer(\'NON_SOUHAITE\')\" ng-disabled=\"d.envoi\">Clôturer : le patient ne souhaite pas être rappelé</button>\n</div><button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"d.annuler()\">Annuler</button> <button \ntype=\"button\" class=\"osy-btn osy-btn--principal\" ng-if=\"d.joint === false\" ng-click=\"d.enregistrerTentative()\" \nng-disabled=\"d.envoi\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>Enregistrer la tentative</button> \n<button type=\"button\" class=\"osy-btn osy-btn--principal\" ng-if=\"d.joint === true\" ng-click=\"d.realiser()\" \nng-disabled=\"d.envoi\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>Enregistrer le rappel</button></div>\n</md-dialog>");
$templateCache.put("app/main/front/triage-osys/dialogs/refus.html","<md-dialog class=\"osy-fenetre\" \naria-label=\"{{d.retrait ? \'Le patient retire son consentement\' : \'Le patient refuse le triage\'}}\"><div \nclass=\"osy-fenetre__entete\"><div><h2 class=\"osy-fenetre__titre\">\n{{d.retrait ? \'Le patient retire son consentement\' : \'Le patient refuse le triage\'}}</h2><p \nclass=\"osy-fenetre__sous-titre\" ng-if=\"!d.retrait\">\nAucune donnée d’identité n’est enregistrée. Ces refus servent aux indicateurs transmis par PHSQ.</p><p \nclass=\"osy-fenetre__sous-titre\" ng-if=\"d.retrait\">\nLe triage en cours et ses données sont supprimés. Seuls la tranche d’âge, le sexe et le motif sont gardés, pour les indicateurs.\n</p></div><button type=\"button\" class=\"osy-fenetre__fermer\" ng-click=\"d.annuler()\" aria-label=\"Fermer\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s20\"></md-icon></button></div><md-dialog-content class=\"osy-fenetre__corps\"><div \nclass=\"osy-grille osy-grille--3\"><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-refus-age\">\nTranche d’âge <span class=\"osy-requis\">*</span></label><select id=\"osy-refus-age\" class=\"osy-select osy-select--plein\" \nng-model=\"d.saisie.trancheAge\"><option value=\"\" disabled=\"disabled\">Choisir…</option><option \nng-repeat=\"(code, libelle) in d.TRANCHES\" value=\"{{code}}\">{{libelle}}</option></select></div><div \nclass=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-refus-sexe\">Sexe <span class=\"osy-requis\">*</span></label>\n<select id=\"osy-refus-sexe\" class=\"osy-select osy-select--plein\" ng-model=\"d.saisie.sexe\"><option value=\"\" \ndisabled=\"disabled\">Choisir…</option><option ng-repeat=\"(code, libelle) in d.SEXES\" value=\"{{code}}\">{{libelle}}\n</option></select></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-refus-motif\">Motif <span \nclass=\"osy-requis\">*</span></label><select id=\"osy-refus-motif\" class=\"osy-select osy-select--plein\" \nng-model=\"d.saisie.motif\"><option value=\"\" disabled=\"disabled\">Choisir…</option><option \nng-repeat=\"(code, libelle) in d.MOTIFS\" value=\"{{code}}\">{{libelle}}</option></select></div></div></md-dialog-content>\n<div class=\"osy-fenetre__actions\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"d.annuler()\">Annuler\n</button> <button type=\"button\" class=\"osy-btn osy-btn--principal\" ng-disabled=\"!d.complet() || d.envoi\" \nng-click=\"d.valider()\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>\n{{d.retrait ? \'Enregistrer le retrait\' : \'Enregistrer le refus\'}}</button></div></md-dialog>");
$templateCache.put("app/main/front/triage-osys/triage/fin.html","<div class=\"osy-page osy-page--parcours\" ng-if=\"vm.t\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\" \nng-if=\"!vm.rouvert\">Nouveau triage</h1><h1 class=\"osy-entete__titre\" ng-if=\"vm.rouvert\">\nTriage du {{vm.t.debut | date:\'dd/MM/yyyy\'}} · {{vm.t.patient.prenom}} {{vm.t.patient.nom | uppercase}}</h1><div \nclass=\"osy-entete__sous-titre\" ng-if=\"vm.rouvert\">{{vm.t.arbre.libelle}} · référence {{vm.t.reference}}</div></div>\n</div><osy-stepper ng-if=\"!vm.rouvert\" etape=\"3\" termine=\"true\"></osy-stepper><div class=\"osy-colonne-moyenne\"><section\n class=\"osy-carte osy-fin\"><div class=\"osy-fin__corps\"><span class=\"osy-fin__coche\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24\"></md-icon></span><div><h2 class=\"osy-fin__titre\">Triage enregistré</h2><p class=\"osy-fin__resume\"><span>\n{{vm.t.patient.prenom}} {{vm.t.patient.nom | uppercase}}</span> <span>·</span> <span>{{vm.t.arbre.libelle}}</span> \n<span>·</span><osy-decision prise-en-charge=\"vm.t.conclusion.priseEnCharge\"></osy-decision><span \nng-if=\"vm.datesRappels().length\">·</span> <span ng-if=\"vm.datesRappels().length\">\n{{vm.datesRappels().length > 1 ? \'rappels prévus le\' : \'rappel prévu le\'}} {{vm.datesRappels().join(\' et le \')}}</span>\n</p><div class=\"osy-fin__boutons\"><button type=\"button\" class=\"osy-btn osy-btn--principal\" ng-click=\"vm.telecharger()\">\n<md-icon md-font-icon=\"icon-download\" class=\"s18\"></md-icon>Télécharger le compte rendu</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"vm.imprimer()\"><md-icon md-font-icon=\"icon-printer\" class=\"s18\"></md-icon>\nImprimer le compte rendu</button></div></div></div></section><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-email\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Transmission du compte rendu</h2><osy-pastille class=\"osy-carte__action-droite\" \nng-if=\"vm.enregistree\" type=\"vert\">Enregistrée</osy-pastille></header><div class=\"osy-carte__corps\"><fieldset \nclass=\"osy-groupe\" ng-class=\"{\'osy-bloc--erreur\': vm.erreurs.mode}\"><legend class=\"osy-libelle\">Mode de transmission \n<span class=\"osy-requis\">*</span></legend><label class=\"osy-radio\" ng-repeat=\"(code, libelle) in vm.MODES\"><input \ntype=\"radio\" name=\"osy-mode\" value=\"{{code}}\" ng-model=\"vm.transmission.mode\" ng-change=\"vm.changer()\"> {{libelle}}\n</label><p class=\"osy-erreur\" ng-if=\"vm.erreurs.mode\">{{vm.erreurs.mode}}</p></fieldset><div \nclass=\"osy-champ-bloc osy-champ-bloc--moyen\" ng-if=\"vm.transmission.mode === \'AUTRE\'\"><label class=\"osy-libelle\" \nfor=\"osy-precision\">Précisez <span class=\"osy-requis\">*</span></label><input id=\"osy-precision\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.precision}\" ng-model=\"vm.transmission.precision\" ng-change=\"vm.changer()\" \nmaxlength=\"500\"><p class=\"osy-erreur\" ng-if=\"vm.erreurs.precision\">{{vm.erreurs.precision}}</p></div><div \nclass=\"osy-transmission-ligne\"><label class=\"osy-libelle osy-libelle--ligne\" for=\"osy-date-transmission\" \nng-if=\"vm.avecDate()\">Transmis le</label><input id=\"osy-date-transmission\" class=\"osy-champ osy-champ--date\" \ntype=\"date\" ng-if=\"vm.avecDate()\" ng-model=\"vm.transmission.date\" ng-change=\"vm.changer()\" max=\"{{vm.maxDate}}\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.date}\"> <button type=\"button\" class=\"osy-btn osy-btn--contour\" \nng-click=\"vm.enregistrer()\" ng-disabled=\"vm.envoi\">Enregistrer</button></div><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.date\">{{vm.erreurs.date}}</p></div></section><div class=\"osy-actions\"><button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ui-sref=\"app.osys.mesTriages\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s18\">\n</md-icon>Retour à Mes triages</button> <button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" \nng-if=\"!vm.rouvert\" ui-sref=\"app.osys.nouveau\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>Nouveau triage\n</button></div></div></div>");
$templateCache.put("app/main/front/triage-osys/triage/nouveau.html","<div class=\"osy-page osy-page--parcours\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\">Nouveau triage</h1>\n</div><a class=\"osy-btn osy-btn--lien\" ng-if=\"vm.contexte.lienTutoriel\" ng-href=\"{{vm.contexte.lienTutoriel}}\"><md-icon\n md-font-icon=\"icon-play-circle-outline\" class=\"s18\"></md-icon>Revoir le tutoriel de formation OSyS</a></div>\n<osy-stepper etape=\"1\"></osy-stepper><section class=\"osy-carte\" ng-if=\"vm.vue === \'situation\'\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-view-module\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Situation</h2></header><div class=\"osy-carte__corps\"><div \nclass=\"osy-alerte osy-alerte--ambre\" ng-if=\"vm.bloque()\"><span ng-if=\"!vm.contexte.moduleActif\">\nLe module Triage OSyS est désactivé pour votre officine : vous ne pouvez pas commencer de nouveau triage. Les triages en cours et les rappels restent accessibles depuis « Mes triages ».\n</span> <span ng-if=\"vm.contexte.moduleActif\">\nAucun titulaire de votre officine n’est habilité OSyS : contactez PHSQ pour déclarer les titulaires formés.</span>\n</div><div class=\"osy-tuiles\" ng-if=\"!vm.bloque()\" role=\"radiogroup\" aria-label=\"Situation\"><button type=\"button\" \nclass=\"osy-tuile\" ng-repeat=\"a in vm.contexte.arbres track by a.code\" \nng-class=\"{\'osy-tuile--choisie\': vm.arbre.code === a.code}\" ng-click=\"vm.choisirArbre(a)\" role=\"radio\" \naria-checked=\"{{vm.arbre.code === a.code}}\"><span class=\"osy-tuile__icone\" ng-style=\"{color: a.couleur}\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/osys/{{a.icone}}.svg\"></md-icon></span><span class=\"osy-tuile__texte\"><span \nclass=\"osy-tuile__titre\">{{a.libelle}}</span> <span class=\"osy-tuile__description\">{{a.description}}</span> </span>\n<span class=\"osy-tuile__coche\" ng-if=\"vm.arbre.code === a.code\"><md-icon md-font-icon=\"icon-check\" class=\"s16\">\n</md-icon></span></button></div></div></section><div class=\"osy-actions\" ng-if=\"vm.vue === \'situation\'\"><span></span> \n<button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" ng-disabled=\"!vm.arbre || vm.bloque()\" \nng-click=\"vm.continuerSituation($event)\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon>Continuer\n</button></div><div ng-if=\"vm.vue === \'patient\'\"><section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon \nmd-font-icon=\"icon-view-module\" class=\"s20 osy-carte__icone\"></md-icon><span class=\"osy-carte__texte\">Situation : \n<strong>{{vm.arbre.libelle}}</strong></span> <button type=\"button\" \nclass=\"osy-carte__action-droite osy-btn osy-btn--lien\" ng-click=\"vm.changerSituation()\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>Changer</button></header></section><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-account\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Patient</h2><div class=\"osy-carte__filtres\"><div class=\"osy-recherche osy-recherche--entete\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"s18\"></md-icon><input type=\"text\" ng-model=\"vm.recherche.texte\" \nng-change=\"vm.saisieRecherche()\" autocomplete=\"off\" placeholder=\"Nom, prénom ou date de naissance\" \naria-label=\"Rechercher un patient\" maxlength=\"100\"></div><button type=\"button\" class=\"osy-btn osy-btn--contour\" \nng-click=\"vm.creerPatient(vm.recherche.cherche)\"><md-icon md-font-icon=\"icon-plus\" class=\"s16\"></md-icon>\nNouveau patient</button></div></header><div class=\"osy-carte__corps\"><p class=\"osy-vide\" \nng-if=\"!vm.recherche.lignes && !vm.patient && !vm.nouveau\">\nRecherchez un patient par nom, prénom ou date de naissance, ou créez-le.</p><div class=\"osy-alerte osy-alerte--bleu\" \nng-if=\"vm.nouveau && vm.lignesAffichees().length\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\">\n</md-icon>\nPatients correspondant à « {{vm.recherche.cherche}} » : choisissez-en un, ou poursuivez la saisie du nouveau patient ci-dessous.\n</div><table class=\"osy-table\" ng-if=\"vm.lignesAffichees().length\"><thead><tr><th>Patient</th><th>Né(e) le</th><th>\nTéléphone</th><th>Dernier triage</th><th></th></tr></thead><tbody><tr \nng-repeat=\"p in vm.lignesAffichees() track by p.id\" ng-class=\"{\'osy-table__ligne--choisie\': vm.patient.id === p.id}\">\n<td><span class=\"osy-table__patient\">{{p.prenom}} {{p.nom | uppercase}}</span> <span class=\"osy-texte-doux\">\n· {{vm.libelleSexe(p.sexe)}} · {{p.age}}</span><osy-pastille ng-if=\"p.sansNir\" type=\"gris\" point=\"non\">Sans NIR\n</osy-pastille></td><td>{{p.dateNaissance | date:\'dd/MM/yyyy\'}}</td><td>{{p.telephone}}</td><td>{{vm.dernierTriage(p)}}\n</td><td class=\"osy-table__actions\"><osy-pastille ng-if=\"vm.patient.id === p.id\" type=\"vert\">Choisie</osy-pastille>\n<button type=\"button\" class=\"osy-btn osy-btn--contour\" ng-if=\"vm.patient.id !== p.id\" ng-click=\"vm.choisirPatient(p)\">\nChoisir</button></td></tr></tbody></table><div class=\"osy-alerte osy-alerte--ambre\" \nng-if=\"!vm.nouveau && vm.patient.episodeRecent\"><md-icon md-font-icon=\"icon-clock\" class=\"s18\"></md-icon>\n{{vm.patient.prenom}} {{vm.patient.nom | uppercase}} a déjà eu un triage <strong>{{vm.arbre.libelle}}</strong>\n le {{vm.patient.episodeRecent.date | date:\'dd/MM/yyyy\'}} (il y a {{vm.patient.episodeRecent.jours}} {{vm.patient.episodeRecent.jours > 1 ? \'jours\' : \'jour\'}}). Information seulement : le triage reste possible.\n</div><div class=\"osy-alerte osy-alerte--gris\" ng-if=\"!vm.nouveau && vm.patient.sansNir\">\nPatient sans NIR ({{vm.MOTIFS_SANS_NIR[vm.patient.motifSansNir] | lowercase}}) : le triage reste possible.</div><div \nng-if=\"vm.nouveau\" class=\"osy-nouveau-patient\" ng-class=\"{\'osy-nouveau-patient--separe\': vm.lignesAffichees().length}\">\n<h3 class=\"osy-nouveau-patient__titre\" ng-if=\"vm.lignesAffichees().length\"><md-icon md-font-icon=\"icon-account-plus\" \nclass=\"s18\"></md-icon>Nouveau patient</h3><div class=\"osy-alerte osy-alerte--gris\" \nng-if=\"vm.recherche.cherche && vm.recherche.lignes && !vm.recherche.lignes.length\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>\nAucun patient « {{vm.recherche.cherche}} » dans votre officine : saisissez ses informations.</div><div \nclass=\"osy-grille\"><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-nom\">Nom <span class=\"osy-requis\">*\n</span></label><input id=\"osy-nom\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': vm.erreurs.nom}\" \nng-model=\"vm.nouveau.nom\" maxlength=\"100\" autocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"vm.erreurs.nom\">\n{{vm.erreurs.nom}}</p></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-prenom\">Prénom <span \nclass=\"osy-requis\">*</span></label><input id=\"osy-prenom\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.prenom}\" ng-model=\"vm.nouveau.prenom\" maxlength=\"100\" autocomplete=\"off\"><p \nclass=\"osy-erreur\" ng-if=\"vm.erreurs.prenom\">{{vm.erreurs.prenom}}</p></div><div class=\"osy-champ-bloc\"><label \nclass=\"osy-libelle\" for=\"osy-naissance\">Date de naissance <span class=\"osy-requis\">*</span></label><input \nid=\"osy-naissance\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': vm.erreurs.dateNaissance}\" \nng-model=\"vm.nouveau.dateNaissance\" ng-change=\"vm.formaterDate()\" placeholder=\"jj/mm/aaaa\" inputmode=\"numeric\" \nmaxlength=\"10\" autocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"vm.erreurs.dateNaissance\">{{vm.erreurs.dateNaissance}}\n</p></div><div class=\"osy-champ-bloc\"><span class=\"osy-libelle\">Sexe <span class=\"osy-requis\">*</span></span><div \nclass=\"osy-radios osy-radios--ligne\" ng-class=\"{\'osy-erreur\': vm.erreurs.sexe}\"><label class=\"osy-radio\"><input \ntype=\"radio\" name=\"osy-sexe\" value=\"F\" ng-model=\"vm.nouveau.sexe\"> Femme</label><label class=\"osy-radio\"><input \ntype=\"radio\" name=\"osy-sexe\" value=\"H\" ng-model=\"vm.nouveau.sexe\"> Homme</label></div><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.sexe\">{{vm.erreurs.sexe}}</p></div><div class=\"osy-champ-bloc\" ng-if=\"!vm.nouveau.sansNir\"><label \nclass=\"osy-libelle\" for=\"osy-nir\">NIR <span class=\"osy-requis\">*</span></label><input id=\"osy-nir\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.nir}\" ng-model=\"vm.nouveau.nir\" ng-change=\"vm.formaterNir()\" \nplaceholder=\"2 90 09 34 172 055 18\" maxlength=\"21\" autocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"vm.erreurs.nir\">\n{{vm.erreurs.nir}}</p><p class=\"osy-avertissement\" ng-repeat=\"a in vm.controleNir().avertissements track by $index\">\n{{a}}</p></div><div class=\"osy-champ-bloc\" ng-if=\"vm.nouveau.sansNir\"><label class=\"osy-libelle\" for=\"osy-motif-nir\">\nMotif <span class=\"osy-requis\">*</span></label><select id=\"osy-motif-nir\" class=\"osy-select osy-select--plein\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.motifSansNir}\" ng-model=\"vm.nouveau.motifSansNir\"><option value=\"\" \ndisabled=\"disabled\">Choisir…</option><option ng-repeat=\"(code, libelle) in vm.MOTIFS_SANS_NIR\" value=\"{{code}}\">\n{{libelle}}</option></select><p class=\"osy-erreur\" ng-if=\"vm.erreurs.motifSansNir\">{{vm.erreurs.motifSansNir}}</p>\n</div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-tel\">Téléphone <span class=\"osy-requis\">*</span>\n</label><input id=\"osy-tel\" class=\"osy-champ\" ng-class=\"{\'osy-champ--erreur\': vm.erreurs.telephone}\" \nng-model=\"vm.nouveau.telephone\" type=\"tel\" maxlength=\"30\" autocomplete=\"off\"><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.telephone\">{{vm.erreurs.telephone}}</p></div><div class=\"osy-champ-bloc\"><label class=\"osy-libelle\" \nfor=\"osy-cp\">Code postal <span class=\"osy-requis\">*</span></label><input id=\"osy-cp\" class=\"osy-champ\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.codePostal}\" ng-model=\"vm.nouveau.codePostal\" maxlength=\"10\" \nautocomplete=\"off\"><p class=\"osy-erreur\" ng-if=\"vm.erreurs.codePostal\">{{vm.erreurs.codePostal}}</p></div><div \nclass=\"osy-champ-bloc\"><label class=\"osy-libelle\" for=\"osy-medecin\">Médecin traitant</label><input id=\"osy-medecin\" \nclass=\"osy-champ\" ng-model=\"vm.nouveau.medecinTraitant\" placeholder=\"facultatif\" maxlength=\"200\" autocomplete=\"off\">\n</div></div><div class=\"osy-case-ligne\"><label class=\"osy-case osy-case--compacte\"><input type=\"checkbox\" \nng-model=\"vm.nouveau.sansNir\"> Patient sans NIR</label><span class=\"osy-texte-doux\">\nPour un mineur, le nom du représentant présent est demandé.</span></div></div><div class=\"osy-representant\" \nng-if=\"vm.mineur()\"><span class=\"osy-libelle\">Représentant légal présent <span class=\"osy-requis\">*</span></span><div \nclass=\"osy-representant__champs\"><input class=\"osy-champ\" ng-model=\"vm.representant.nom\" placeholder=\"Nom et prénom\" \naria-label=\"Nom du représentant\" maxlength=\"200\"><select class=\"osy-select\" ng-model=\"vm.representant.lien\" \naria-label=\"Lien avec le patient\"><option value=\"\" disabled=\"disabled\">Lien…</option><option \nng-repeat=\"l in vm.LIENS track by l.code\" value=\"{{l.code}}\">{{l.libelle}}</option></select></div></div></div>\n</section><section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-shield-outline\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Consentement et pharmacien</h2></header><div \nclass=\"osy-carte__corps\"><label class=\"osy-case osy-case--forte\"><input type=\"checkbox\" ng-model=\"vm.consentement\" \nng-disabled=\"!vm.patient && !vm.nouveau\"> <span><strong>Le patient donne son consentement.</strong> <span \nclass=\"osy-consentement\" ng-if=\"vm.contexte.consentement.texte\">{{vm.contexte.consentement.texte}}</span></span>\n</label><div class=\"osy-liens\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" \nng-click=\"vm.imprimerConsentement()\"><md-icon md-font-icon=\"icon-printer\" class=\"s16\"></md-icon>\nImprimer le formulaire de consentement</button> <button type=\"button\" class=\"osy-btn osy-btn--lien\" \nng-click=\"vm.refuser($event)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s16\"></md-icon>\nLe patient refuse : enregistrer le refus</button></div><label class=\"osy-libelle\" for=\"osy-titulaire\">\nTriage réalisé par <span class=\"osy-requis\">*</span></label><select id=\"osy-titulaire\" \nclass=\"osy-select osy-select--titulaire\" ng-model=\"vm.habilitationId\" \nng-options=\"h.id as (h.prenom + \' \' + (h.nom | uppercase) + \' · RPPS \' + h.rpps) for h in vm.contexte.habilitations\">\n<option value=\"\" disabled=\"disabled\">Choisir le titulaire…</option></select></div></section><div class=\"osy-actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"vm.changerSituation()\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Retour</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand\" ng-disabled=\"!vm.peutContinuer()\" ng-click=\"vm.continuer()\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon>{{vm.envoi ? \'Création…\' : \'Continuer\'}}</button></div></div>\n</div>");
$templateCache.put("app/main/front/triage-osys/triage/triage.html","<div class=\"osy-page osy-page--parcours\" ng-if=\"vm.t\"><div class=\"osy-entete\"><div><h1 class=\"osy-entete__titre\">\nTriage — {{vm.t.arbre.libelle}}</h1></div><osy-patient-lien patient=\"vm.t.patient\"></osy-patient-lien></div>\n<osy-stepper etape=\"vm.etapeStepper()\"></osy-stepper><div ng-if=\"vm.vue === \'recap\'\" class=\"osy-colonne-etroite\">\n<section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-clipboard-text\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Situation et patient</h2><span \nclass=\"osy-carte__sous-titre\">en lecture seule : le triage est commencé</span></header><div class=\"osy-carte__corps\">\n<dl class=\"osy-recap\"><dt>Situation</dt><dd>{{vm.t.arbre.libelle}}</dd><dt>Patient</dt><dd>\n{{vm.t.patient.prenom}} {{vm.t.patient.nom | uppercase}} · {{vm.L.SEXES[vm.t.patient.sexe]}} · {{vm.t.patient.age}}\n</dd><dt ng-if=\"vm.t.representant\">Représentant légal</dt><dd ng-if=\"vm.t.representant\">\n{{vm.t.representant.nom}} ({{vm.t.representant.lien}})</dd><dt>Consentement</dt><dd>Donné</dd><dt>Triage réalisé par\n</dt><dd>{{vm.t.titulaire.prenom}} {{vm.t.titulaire.nom | uppercase}}</dd><dt>Commencé</dt><dd>\n{{vm.t.debut | date:\'dd/MM/yyyy HH:mm\'}}</dd></dl><p class=\"osy-note\">\nMauvaise situation ou mauvais patient : abandonnez ce triage depuis « Mes triages » et recommencez.</p></div></section>\n<div class=\"osy-actions\"><span></span> <button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" \nng-click=\"vm.quitterRecap()\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon>Continuer</button></div>\n</div><div ng-if=\"vm.vue === \'redflags\'\" class=\"osy-colonne-etroite\"><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete osy-carte__entete--rouge\"><md-icon md-font-icon=\"icon-flag-outline\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Red flags</h2></header><div \nclass=\"osy-carte__corps\"><p class=\"osy-consigne\">\nCochez chaque signe présent, ou « Aucun des critères ci-dessus ». Un signe coché termine le triage avec l’orientation correspondante. Les signes qui ne concernent pas ce patient (âge, sexe) sont grisés.\n</p><div class=\"osy-redflags\"><div class=\"osy-redflags__colonne osy-redflags__colonne--{{o.cle}}\" \nng-repeat=\"o in vm.colonnes track by o.cle\" ng-if=\"vm.colonne(o.orientation).length\"><div class=\"osy-redflags__titre\">\n<md-icon md-font-icon=\"icon-flag-outline\" class=\"s18\"></md-icon>{{o.titre}}</div><div class=\"osy-redflag\" \nng-repeat=\"r in vm.colonne(o.orientation) track by r.code\" data-code=\"{{r.code}}\" \nng-class=\"{\'osy-redflag--grise\': r.classement === \'NE_CONCERNE_PAS\', \'osy-redflag--concerne\': r.classement === \'CONCERNE\'}\">\n<label class=\"osy-redflag__case\"><input type=\"checkbox\" ng-model=\"r.coche\" ng-change=\"vm.basculerRedFlag()\" \nng-disabled=\"r.classement === \'NE_CONCERNE_PAS\' || vm.occupe\"> <span class=\"osy-redflag__libelle\">{{r.libelle}}<span \nclass=\"osy-redflag__detail\" ng-if=\"r.detail\"> {{r.detail}}</span></span></label><span \nclass=\"osy-pastille osy-pastille--gris\" ng-if=\"r.classement === \'NE_CONCERNE_PAS\'\">Ne concerne pas ce patient</span> \n<span class=\"osy-pastille osy-pastille--ambre\" ng-if=\"r.classement === \'CONCERNE\'\">\nConcerne ce patient · {{vm.t.patient.age}}</span></div></div></div><div class=\"osy-aucun\" \nng-class=\"{\'osy-aucun--coche\': vm.t.etat.aucun}\"><label class=\"osy-aucun__case\"><input type=\"checkbox\" \nng-model=\"vm.t.etat.aucun\" ng-change=\"vm.basculerAucun()\" ng-disabled=\"vm.occupe\"> <strong>Aucun des critères ci-dessus\n</strong></label></div><div class=\"osy-alerte osy-alerte--ambre\" ng-if=\"vm.signesConcernes().length\">\nUn signe concerne ce patient ({{vm.libellesCourts(vm.signesConcernes())}}) : vérifiez avant de continuer.</div></div>\n</section><div class=\"osy-actions\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"vm.retourRecap()\">\n<md-icon md-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Retour</button> <button type=\"button\" \nclass=\"osy-btn osy-btn--principal osy-btn--grand\" ng-disabled=\"!vm.peutQuitterRedFlags()\" \nng-click=\"vm.suivantRedFlags()\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon>Suivant</button></div>\n<div class=\"osy-pied\"><span class=\"osy-mention\" ng-if=\"vm.contexte.mentionFormation\"><md-icon \nmd-font-icon=\"icon-shield-outline\" class=\"s16\"></md-icon>{{vm.contexte.mentionFormation}}</span> <button type=\"button\" \nclass=\"osy-btn osy-btn--lien osy-btn--discret\" ng-click=\"vm.retirerConsentement($event)\">\nLe patient retire son consentement</button></div></div><div ng-if=\"vm.vue === \'questions\'\" class=\"osy-colonne-etroite\">\n<section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-flag-outline\" \nclass=\"s20 osy-carte__icone\"></md-icon><span class=\"osy-carte__texte\">Red flags : <strong>aucun des critères</strong>\n</span> <button type=\"button\" class=\"osy-carte__action-droite osy-btn osy-btn--lien\" ng-click=\"vm.modifierRedFlags()\" \nng-disabled=\"vm.occupe\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>Modifier</button></header></section>\n<section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Questions</h2><span class=\"osy-carte__sous-titre\">\nla question suivante apparaît dès que vous répondez</span></header><div class=\"osy-carte__corps osy-questions\">\n<osy-question ng-repeat=\"q in vm.questionsVisibles() track by q.code\" question=\"q\" occupe=\"vm.occupe\" \non-repondre=\"vm.repondre(code, valeur)\" on-geste=\"vm.changerGestes()\"></osy-question></div></section><div \nclass=\"osy-actions\"><button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"vm.modifierRedFlags()\" \nng-disabled=\"vm.occupe\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Retour aux red flags</button> \n<button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" ng-disabled=\"!vm.t.etat.termine || vm.occupe\" \nng-click=\"vm.suivantQuestions()\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s18\"></md-icon>Suivant</button>\n</div><div class=\"osy-pied\"><span class=\"osy-mention\" ng-if=\"vm.contexte.mentionFormation\"><md-icon \nmd-font-icon=\"icon-shield-outline\" class=\"s16\"></md-icon>{{vm.contexte.mentionFormation}}</span> <button type=\"button\" \nclass=\"osy-btn osy-btn--lien osy-btn--discret\" ng-click=\"vm.retirerConsentement($event)\">\nLe patient retire son consentement</button></div></div><div ng-if=\"vm.vue === \'conclusion\' && vm.c\" \nclass=\"osy-colonnes\"><div class=\"osy-colonnes__principale\"><div class=\"osy-alerte osy-alerte--bleu\" \nng-if=\"vm.t.issueModifiee\">L’orientation a changé : produits, conseils et décision ont été réinitialisés.</div>\n<osy-orientation issue=\"vm.t.etat.issue\" red-flags=\"vm.redFlagsOrientation\"></osy-orientation><div \nclass=\"osy-decision-ligne\" ng-class=\"{\'osy-bloc--erreur\': vm.erreurs.motif}\"><p><span \nng-bind-html=\"vm.phraseDecision()\"></span> <button type=\"button\" class=\"osy-lien\" \nng-click=\"vm.decisionOuverte = !vm.decisionOuverte\">Choisir une autre prise en charge</button> <span \nclass=\"osy-texte-doux\">La décision vous appartient.</span></p><div class=\"osy-decision-choix\" \nng-if=\"vm.decisionOuverte\"><div class=\"osy-radios osy-radios--ligne\"><label class=\"osy-radio\" \nng-repeat=\"(code, libelle) in vm.L.PRISES_EN_CHARGE_DECISION\"><input type=\"radio\" name=\"osy-decision\" value=\"{{code}}\" \nng-model=\"vm.c.priseEnCharge\" ng-change=\"vm.choisirDecision()\"> {{libelle}}<span class=\"osy-texte-doux\" \nng-if=\"code === vm.proposee()\"> (proposé)</span></label></div><div class=\"osy-champ-bloc\" ng-if=\"vm.differe()\"><label \nclass=\"osy-libelle\" for=\"osy-motif\">Motif de votre choix <span class=\"osy-requis\">*</span></label><textarea \nid=\"osy-motif\" class=\"osy-champ osy-champ--zone\" ng-class=\"{\'osy-champ--erreur\': vm.erreurs.motif}\" \nng-model=\"vm.c.motif\" ng-change=\"vm.enregistrer(true)\" rows=\"2\" maxlength=\"2000\"></textarea><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.motif\">{{vm.erreurs.motif}}</p></div></div><div class=\"osy-encart osy-encart--attention\" \nng-if=\"vm.teleconsultation()\"><div class=\"osy-encart__titre\">Téléconsultation déconseillée en cas de :</div><ul><li \nng-repeat=\"x in vm.teleconsultation().connus track by $index\"><strong>{{x}}</strong></li><li \nng-repeat=\"x in vm.teleconsultation().autres track by $index\">{{x}}</li></ul></div></div><section class=\"osy-carte\">\n<header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-account\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Contexte connu ou identifié à l’officine</h2></header><div class=\"osy-carte__corps\"><label \nclass=\"osy-libelle\" for=\"osy-contexte\">\n{{vm.contexte.aideContexte || \'Ce que vous savez du patient et qui sera utile au médecin (allergies, traitements, antécédents…)\'}} \n<span class=\"osy-requis\">*</span></label><textarea id=\"osy-contexte\" class=\"osy-champ osy-champ--zone\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.contexte}\" ng-model=\"vm.c.contexte\" \nng-change=\"vm.enregistrer(true); vm.erreurs.contexte = null\" rows=\"3\" maxlength=\"4000\"></textarea><p \nclass=\"osy-erreur\" ng-if=\"vm.erreurs.contexte\">{{vm.erreurs.contexte}}</p><p class=\"osy-note\">\nRepris dans le compte rendu.</p></div></section><div class=\"osy-paire\"><section \nclass=\"osy-carte osy-carte--debordante\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Produits délivrés</h2></header><div \nclass=\"osy-carte__corps\"><div class=\"osy-puces\"><span class=\"osy-puce\" ng-repeat=\"p in vm.c.produits track by p\">{{p}} \n<button type=\"button\" class=\"osy-puce__retirer\" ng-click=\"vm.retirerProduit(p)\" aria-label=\"Retirer {{p}}\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s14\"></md-icon></button> </span><span class=\"osy-texte-doux\" \nng-if=\"!vm.c.produits.length\">Aucun produit délivré.</span></div><div class=\"osy-autocompletion\"><input \nclass=\"osy-champ\" ng-model=\"vm.produit.saisie\" ng-focus=\"vm.produit.ouvert = true\" \nng-change=\"vm.produit.ouvert = true\" ng-keydown=\"vm.toucheProduit($event)\" ng-blur=\"vm.masquerSuggestions()\" \nmaxlength=\"200\" autocomplete=\"off\" placeholder=\"Ajouter un produit (liste « {{vm.t.arbre.libelle}} » ou saisie libre)\" \naria-label=\"Ajouter un produit\"><ul class=\"osy-autocompletion__liste\" \nng-if=\"vm.produit.ouvert && vm.suggestions().length\"><li ng-repeat=\"s in vm.suggestions() track by s\"><button \ntype=\"button\" ng-mousedown=\"vm.ajouterProduit(s)\">{{s}}</button></li></ul></div><button type=\"button\" \nclass=\"osy-btn osy-btn--contour\" ng-click=\"vm.ajouterProduit()\" ng-disabled=\"!vm.produit.saisie\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s16\"></md-icon>Ajouter</button></div></section><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Conseils remis</h2><span class=\"osy-carte__sous-titre\">facultatif</span></header><div \nclass=\"osy-carte__corps\"><label class=\"osy-case\" ng-repeat=\"x in vm.conseilsProposes track by x\"><input \ntype=\"checkbox\" ng-checked=\"vm.conseilCoche(x)\" ng-click=\"vm.basculerConseil(x)\"> <span>{{x}}</span></label><div \nclass=\"osy-ajout\" ng-if=\"vm.conseil.ouvert\"><input class=\"osy-champ\" ng-model=\"vm.conseil.saisie\" maxlength=\"500\" \nplaceholder=\"Conseil remis au patient\" aria-label=\"Nouveau conseil\" \nng-keydown=\"$event.keyCode === 13 && vm.ajouterConseil()\"> <button type=\"button\" class=\"osy-btn osy-btn--contour\" \nng-click=\"vm.ajouterConseil()\" ng-disabled=\"!vm.conseil.saisie\">Ajouter</button></div><button type=\"button\" \nclass=\"osy-btn osy-btn--lien\" ng-if=\"!vm.conseil.ouvert\" ng-click=\"vm.conseil.ouvert = true\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s16\"></md-icon>Ajouter un conseil</button></div></section></div><div class=\"osy-paire\">\n<section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-camera\" \nclass=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Photos</h2></header><div class=\"osy-carte__corps\">\n<osy-photos triage-id=\"vm.t.id\" photos=\"vm.t.photos\"></osy-photos></div></section><section class=\"osy-carte\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-phone\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Rappel du patient prévu</h2></header><div class=\"osy-carte__corps\"><div \nclass=\"osy-rappel-prevu\" ng-repeat=\"r in vm.t.rappels track by r.numero\"><span class=\"osy-pastille osy-pastille--vert\">\n{{vm.libelleDelai(r.delai)}}</span> <strong class=\"osy-rappel-prevu__date\">{{vm.dateRappel(r)}}</strong> <span \nclass=\"osy-texte-doux\">{{r.critere}}</span></div><p class=\"osy-vide\" ng-if=\"!vm.t.rappels.length\">\nAucun rappel prévu pour cette orientation.</p><div class=\"osy-alerte osy-alerte--bleu\" ng-if=\"vm.phraseRappel()\">\n<md-icon md-font-icon=\"icon-phone\" class=\"s16\"></md-icon><strong>Informez le patient</strong> {{vm.phraseRappel()}}\n</div></div></section></div><section class=\"osy-carte\"><header class=\"osy-carte__entete\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s20 osy-carte__icone\"></md-icon><h2 class=\"osy-carte__titre\">Questions au patient\n</h2></header><div class=\"osy-carte__corps\"><div class=\"osy-grille osy-grille--3\"><fieldset class=\"osy-groupe\" \nng-class=\"{\'osy-bloc--erreur\': vm.erreurs.qSansService}\"><legend class=\"osy-libelle\">\nQu’aurait entrepris le patient s’il n’avait pas pu profiter de ce service ? <span class=\"osy-requis\">*</span></legend>\n<label class=\"osy-radio\" ng-repeat=\"(code, libelle) in vm.L.SANS_SERVICE\"><input type=\"radio\" name=\"osy-q1\" \nvalue=\"{{code}}\" ng-model=\"vm.c.qSansService\" ng-change=\"vm.choisirQuestion(\'qSansService\')\"> {{libelle}}</label><p \nclass=\"osy-erreur\" ng-if=\"vm.erreurs.qSansService\">{{vm.erreurs.qSansService}}</p></fieldset><fieldset \nclass=\"osy-groupe\" ng-class=\"{\'osy-bloc--erreur\': vm.erreurs.qPourquoi}\"><legend class=\"osy-libelle\">\nPourquoi le patient est-il venu en pharmacie ? <span class=\"osy-requis\">*</span></legend><label class=\"osy-radio\" \nng-repeat=\"(code, libelle) in vm.L.POURQUOI\"><input type=\"radio\" name=\"osy-q2\" value=\"{{code}}\" \nng-model=\"vm.c.qPourquoi\" ng-change=\"vm.choisirQuestion(\'qPourquoi\')\"> {{libelle}}</label><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.qPourquoi\">{{vm.erreurs.qPourquoi}}</p></fieldset><fieldset class=\"osy-groupe\" \nng-class=\"{\'osy-bloc--erreur\': vm.erreurs.qConnu}\"><legend class=\"osy-libelle\">Comment avez-vous connu ce service ? \n<span class=\"osy-requis\">*</span></legend><label class=\"osy-radio\" ng-repeat=\"(code, libelle) in vm.L.CONNU\"><input \ntype=\"radio\" name=\"osy-q3\" value=\"{{code}}\" ng-model=\"vm.c.qConnu\" ng-change=\"vm.choisirQuestion(\'qConnu\')\">\n {{libelle}}</label><p class=\"osy-erreur\" ng-if=\"vm.erreurs.qConnu\">{{vm.erreurs.qConnu}}</p></fieldset></div><div \nclass=\"osy-satisfaction\" ng-class=\"{\'osy-bloc--erreur\': vm.erreurs.satisfaction}\"><span class=\"osy-libelle\">\nSatisfaction du patient <span class=\"osy-requis\">*</span></span><div class=\"osy-satisfaction__notes\" role=\"radiogroup\" \naria-label=\"Satisfaction du patient\"><button type=\"button\" class=\"osy-reponse osy-reponse--carree\" \nng-repeat=\"n in [1, 2, 3, 4, 5]\" ng-class=\"{\'osy-reponse--choisie\': vm.c.satisfaction === n}\" \nng-click=\"vm.choisirSatisfaction(n)\" role=\"radio\" aria-checked=\"{{vm.c.satisfaction === n}}\">{{n}}</button></div><div \nclass=\"osy-satisfaction__bornes\"><span>Pas du tout satisfait</span><span>Très satisfait</span></div><p \nclass=\"osy-erreur\" ng-if=\"vm.erreurs.satisfaction\">{{vm.erreurs.satisfaction}}</p></div><div class=\"osy-duree\" \nng-class=\"{\'osy-bloc--erreur\': vm.erreurs.dureeRetenueMin}\"><span ng-if=\"!vm.dureeOuverte\">\nDurée du triage : {{vm.t.dureeCalculeeMin}} min (calculée). <button type=\"button\" class=\"osy-lien\" \nng-click=\"vm.dureeOuverte = true\">Modifier</button></span> <span ng-if=\"vm.dureeOuverte\"><label class=\"osy-libelle\" \nfor=\"osy-duree\">Durée du triage (minutes)<span class=\"osy-requis\" ng-if=\"vm.dureeHorsBornes()\"> *</span></label><input \nid=\"osy-duree\" class=\"osy-champ osy-champ--court\" type=\"number\" min=\"1\" max=\"240\" ng-model=\"vm.c.dureeRetenueMin\" \nng-class=\"{\'osy-champ--erreur\': vm.erreurs.dureeRetenueMin}\" ng-change=\"vm.enregistrer(true)\"> <span \nclass=\"osy-texte-doux\">calculée : {{vm.t.dureeCalculeeMin}} min</span></span><p class=\"osy-erreur\" \nng-if=\"vm.erreurs.dureeRetenueMin\">{{vm.erreurs.dureeRetenueMin}}</p></div></div></section><div class=\"osy-actions\">\n<button type=\"button\" class=\"osy-btn osy-btn--lien\" ng-click=\"vm.retourTriage()\" ng-disabled=\"vm.validation\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"s18\"></md-icon>Retour au triage</button> <span class=\"osy-enregistrement\" \nng-class=\"{\'osy-enregistrement--en-cours\': !vm.enregistre}\">{{vm.enregistre ? \'Enregistré\' : \'Enregistrement…\'}}</span>\n <button type=\"button\" class=\"osy-btn osy-btn--principal osy-btn--grand\" ng-click=\"vm.valider($event)\" \nng-disabled=\"vm.validation\"><md-icon md-font-icon=\"icon-check\" class=\"s18\"></md-icon>\n{{vm.validation ? \'Validation…\' : \'Valider le triage\'}}</button></div><div class=\"osy-pied\"><span class=\"osy-mention\" \nng-if=\"vm.contexte.mentionFormation\"><md-icon md-font-icon=\"icon-shield-outline\" class=\"s16\"></md-icon>\n{{vm.contexte.mentionFormation}}</span> <button type=\"button\" class=\"osy-btn osy-btn--lien osy-btn--discret\" \nng-click=\"vm.retirerConsentement($event)\">Le patient retire son consentement</button></div></div><aside \nclass=\"osy-colonnes__laterale\"><section class=\"osy-carte\" ng-if=\"vm.t.arbre.recommandations.length\"><header \nclass=\"osy-carte__entete\"><md-icon md-font-icon=\"icon-book-open\" class=\"s20 osy-carte__icone\"></md-icon><h2 \nclass=\"osy-carte__titre\">Recommandations officielles</h2></header><div class=\"osy-carte__corps\"><p \nclass=\"osy-note osy-note--haut\">Les références sur lesquelles s’appuie votre décision. Ouverture dans un nouvel onglet.\n</p><div class=\"osy-reco\" ng-repeat=\"r in vm.t.arbre.recommandations track by $index\"><span class=\"osy-reco__icone\">\n<md-icon md-font-icon=\"icon-book-open\" class=\"s18\"></md-icon></span><div><div class=\"osy-reco__organisme\">\n{{r.organisme}}</div><a ng-href=\"{{r.url}}\" target=\"_blank\" rel=\"noopener noreferrer\">{{r.libelle}}</a></div></div>\n</div></section></aside></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/front/controle/trace/popup/add_column.html","<md-dialog class=\"iv-Dialog trace-ColumnDialog\" ng-class=\"{\'trace-ColumnDialog--fit\': step === 0}\" flex=\"40\" \nflex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">{{updateIndex != null ? \'Modifier\' : \'Ajouter\'}} une colonne</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><form name=\"columnForm\" novalidate \nng-submit=\"columnForm.$valid && saveColumn()\"><md-dialog-content><div layout=\"row\" layout-align=\"start\" layout-wrap>\n<div ng-if=\"step === 0\"><div class=\"iv-Dialog__title\">Choisissez la nature de l\'élément à tracer :</div><div \nclass=\"button-container\"><div class=\"button-row\"><button ng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'TEXT\'}\" \nclass=\"custom-button\" ng-click=\"setColumnToAdd(\'TEXT\')\" type=\"button\"><md-icon \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'TEXT\'}\" md-svg-src=\"assets/icons/app/V3/texte.svg\"></md-icon>\n<span>Texte</span></button> <button ng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'SUIVI\'}\" \nclass=\"custom-button\" type=\"button\" ng-click=\"setColumnToAdd(\'SUIVI\')\"><md-icon \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'SUIVI\'}\" md-svg-src=\"assets/icons/app/V3/checkbox_1.svg\">\n</md-icon><span>Case à cocher</span></button> <button ng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'DATE\'}\" \nclass=\"custom-button\" type=\"button\" ng-click=\"setColumnToAdd(\'DATE\')\"><md-icon \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'DATE\'}\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n<span>Date</span></button></div><div class=\"button-row\"><button \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'LIST\'}\" class=\"custom-button\" type=\"button\" \nng-click=\"setColumnToAdd(\'LIST\')\"><md-icon ng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'LIST\'}\" \nmd-svg-src=\"assets/icons/app/V3/liste.svg\"></md-icon><span>Liste déroulante</span></button> <button \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'COLLABORATEUR\'}\" class=\"custom-button\" type=\"button\" \nng-click=\"setColumnToAdd(\'COLLABORATEUR\')\"><md-icon \nng-class=\"{\'nl-Btn--selected\': columnToAdd.type === \'COLLABORATEUR\'}\" \nmd-svg-src=\"assets/icons/app/V3/liste_collaborateurs.svg\"></md-icon><span>Liste des collaborateurs</span></button>\n</div></div></div><div ng-if=\"step === 1\" layout=\"column\" flex=\"100\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nIntitulé de la colonne : <span class=\"asterix\">*</span></label><input flex=\"auto\" class=\"iv-Input-input\" type=\"text\" \nname=\"name\" ng-model=\"columnToAdd.name\" required><div ng-messages=\"columnForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><div \nng-if=\"columnToAdd.type === \'LIST\'\" class=\"pt-10\" layout=\"column\" flex=\"100\"><div style=\"font-size:13px\">\nOptions de la liste déroulante :</div><p class=\"nl-Dialog__textInfos2\" ng-if=\"traceToAdd.id && columnToAdd.id\"><span>\nModifier une option met à jour les enregistrements déjà saisis, historique compris. Supprimer une option la retire de la liste, mais les enregistrements existants la conservent.\n</span></p><md-input-container class=\"pl-20 iv-Input-container no--errors-spacer\" flex=\"100\" \nng-repeat=\"option in columnToAdd.options\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nOption {{$index + 1}} <span class=\"asterix\">*</span></label><input flex=\"auto\" class=\"iv-Input-input\" type=\"text\" \nname=\"optionName_{{$index}}\" ng-model=\"option.name\" ng-change=\"checkDuplicateOptions(columnForm)\" required><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"columnToAdd.options.length > 1\"><button class=\"iv-BtnCleanIcon ml-10\" \nng-click=\"deleteOption($index, columnForm)\" type=\"button\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\">\n</md-icon></button></div><div ng-messages=\"columnForm[\'optionName_\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div><div ng-message=\"duplicate\"><span>\nOption déjà présente dans la liste</span></div></div></md-input-container><div class=\"pl-20 pt-10 pb-10\" \nng-if=\"columnToAdd.options.length < 10\"><button class=\"iv-Btn iv-Btn--file\" type=\"button\" ng-click=\"addOption()\">\n<md-icon class=\"m-0\" md-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon><div>Ajouter une option</div></button></div>\n</div><div layout=\"row\" layout-align=\"start center\" class=\"pr-30\"><md-checkbox class=\"iv-Checkbox mb-0 pr-20\" \nng-model=\"columnToAdd.required\" md-no-ink></md-checkbox><span style=\"font-size:12px\">Requis dès la première saisie\n</span></div></div></div></md-dialog-content><md-dialog-actions><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" type=\"button\" ng-click=\"closeModal()\">Annuler</button><div \nng-if=\"step === 0\" class=\"ml-10\"><button class=\"nl-Btn nl-Btn--trac\" type=\"button\" ng-click=\"nextStep()\" \nng-disabled=\"columnToAdd.type == null\">Suivant</button></div><div ng-if=\"step === 1\" class=\"ml-10\"><button \nclass=\"nl-Btn nl-Btn--trac\" type=\"submit\" ng-disabled=\"columnForm.$invalid\">Enregistrer</button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/controle/trace/popup/confirm_delete_column.html","<md-dialog class=\"iv-Dialog\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nSupprimer une colonne</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><span>\nÊtes-vous sûr de vouloir supprimer cette colonne ainsi que les données qu’elle contient ?</span></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" ng-click=\"closeModal()\">\nAnnuler</button> <button class=\"nl-Btn nl-Btn--trac ml-10\" ng-click=\"forceDeleteRow()\">Supprimer</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/controle/trace/popup/infos_trace_popup.html","<md-dialog aria-label=\"dysfonctionnements\" flex=\"35\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\" style=\"overflow: hidden\">\n<form class=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Information</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"iv-Dialog__text\">\nDe nombreux actes de la pharmacie exigent une traçabilité :<br>\nappels médecins, soins de premiers secours, suivi des températures de l\'enceinte de froid, listes d\'attente, livraison,...\n<br>\ndans le cas particulier des dysfonctionnements, n\'hésitez pas non plus créer à créer une catégorie spécifique de dysfonctionnements.\n<br><br>Ce module vous permet de créer une traçabilité facilement renseignable par votre équipe et de partout.<br>\nN\'hésitez pas à regarder le tutoriel associé à cette fonction (en bas à gauche de votre écran)<br>\nVous retrouverez pas ailleurs sur votre portail de nombreux outils pour vous guider.<br><br>- <b>\nEnregistrement des soins de 1ers secours</b><br>- <b>Procédure vaccination AZ</b><br>- <b>BOX</b><br>- <b>\nTests antigéniques</b><br>- <b>Location : Fiche Désinfection du matériel</b><br>- <b>\nRegistre des Alertes Santé et Environnement</b><br>- <b>Guide PDA</b></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/front/controle/trace/popup/to_information_popup.html","<md-dialog aria-label=\"cahier de transmission\" flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"toInformation()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Partager la traçabilité</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-Dialog__text\">\nSouhaitez-vous transmettre cet enregistrement de traçabilité sur le cahier de transmission ?</div></md-dialog-content>\n<md-dialog-actions class=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"closeModal();\">Non</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Oui</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/controle/trace/subtraces/subtraces.html","<section class=\"nl-Page\"><h1 class=\"nl-H1--v2\"><a class=\"nl-H1--backBtn\" ng-click=\"back()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></a><div>{{trace.name}}</div><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" type=\"button\" ng-click=\"showEditModal()\" \nng-if=\"$root.user.isTitulaire || $root.user.isPraq\">Modifier</button></h1><div class=\"nl-Content\"><div class=\"pb-25\">\n<div class=\"nl-FilterBar\"><div class=\"mb-10 flex layout-row layout-wrap layout-align-space-between-center\"><div \nflex-xs=\"100\" flex-sm=\"100\" flex><button type=\"button\" class=\"nl-Btn nl-Btn--trac\" ng-click=\"openAddSubtrace()\"><div \nclass=\"mr-5\">+</div><div>Nouveau</div></button></div><div ng-if=\"totalSubtrace > 0\" layout=\"row\" \nlayout-align=\"end center\" flex-xs=\"100\" flex-sm=\"100\" flex=\"70\"><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"nl-SearchBar nl-SearchBar--home\"><md-icon ng-click=\"emptySearch()\" ng-show=\"filter.searchTxt\" \nmd-svg-src=\"assets/icons/app/V3/del.svg\" class=\"nl-SearchBar--icon--clean color-trac\"></md-icon><md-icon \nng-click=\"getSubtracesByTraceAndDate(true)\" md-svg-src=\"assets/icons/app/V3/search.svg\" \nclass=\"nl-SearchBar--icon--search--home color-trac\"></md-icon><md-input-container md-no-float \nclass=\"nl-Input-container nl-SearchBar--input nl-SearchBar--input--search\" flex=\"100\"><input \nng-enter=\"getSubtracesByTraceAndDate(true)\" class=\"nl-Input-input--searchTrac\" placeholder=\"Rechercher...\" type=\"text\" \nname=\"title\" ng-model=\"filter.searchTxt\"></md-input-container></div><md-button \nclass=\"nl-Btn nl-Btn-msg nl-Btn--small nl-Btn--comment\" ng-click=\"dateFilter = !dateFilter\" style=\"min-width: 20px\">\n<span class=\"nl-block-button color-trac\">Afficher par dates</span><md-icon \nclass=\"nl-listing-item-icon ml-5 color-trac\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon></md-button>\n<md-input-container ng-if=\"dateFilter\" class=\"iv-Input-container iv-Input-container--filter no--errors-spacer\" \nflex=\"20\" style=\"transform: translate3d(1px,0,0)\"><label class=\"iv-Input-label md-container-ignore\"></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon ng-click=\"fromDate.isOpen = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker placeholder=\"Début\" class=\"iv-Input-date\" \nname=\"echeance\" md-is-open=\"fromDate.isOpen\" ng-click=\"_tools.OPEN = true\" md-open-on-focus md-hide-icons=\"all\" \nng-model=\"fromDate.date\" ng-change=\"getSubtracesByTraceAndDate(true)\" md-max-date=\"endDate.date\"></md-datepicker></div>\n<div ng-messages=\"_form.echeance.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><md-input-container ng-if=\"dateFilter\" \nclass=\"iv-Input-container iv-Input-container--filter no--errors-spacer\" flex=\"20\" style=\"margin-left:10px !important\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\"></label><div class=\"iv-Input-date-wrapper\"><md-icon \nng-click=\"endDate.isOpen = true\" class=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n<md-datepicker placeholder=\"Fin\" class=\"iv-Input-date\" name=\"echeance\" md-is-open=\"endDate.isOpen\" \nng-click=\"_tools.OPEN = true\" md-open-on-focus md-hide-icons=\"all\" ng-model=\"endDate.date\" \nng-change=\"getSubtracesByTraceAndDate(true)\"></md-datepicker></div><div ng-messages=\"_form.echeance.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container><div>\n<md-button class=\"nl-Btn nl-Btn-msg nl-Btn--small nl-Btn--comment\" ng-click=\"openExport()\"><span \nclass=\"nl-block-button color-trac\">Exporter <span ng-if=\"trace.templateType === \'SUIVI_FORMATION\'\">le plan de formation\n</span></span><md-icon class=\"nl-listing-item-icon ml-5 color-trac\" md-svg-src=\"assets/icons/app/V3/download.svg\">\n</md-icon></md-button></div></div></div></div></div><div style=\"overflow-x: auto;width:100%\" class=\"table-container\">\n<table class=\"nl-Table-trac\" ng-if=\"subtraces.length > 0\"><thead class=\"nl-Table__header-trac\"><tr><th class=\"pl-10\" \nstyle=\"min-width:110px\"><div class=\"\" ng-click=\"enableStaticSort(\'date\')\">Date</div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"staticSort.column === \'date\'\"><button class=\"iv-Input-label-btn\" \nng-if=\"staticSort.direction === \'asc\'\"><md-icon md-svg-src=\"assets/icons/app/V3/filters/filter_top.svg\"></md-icon>\n</button> <button class=\"iv-Input-label-btn\" ng-if=\"staticSort.direction === \'desc\'\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/filters/filter_bot.svg\"></md-icon></button></div></th><th class=\"pl-10\" \nstyle=\"min-width:140px\"><div class=\"\" ng-click=\"enableStaticSort(\'reporter\')\">\n{{ trace.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\' }}</div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"staticSort.column === \'reporter\'\"><button class=\"iv-Input-label-btn\" \nng-if=\"staticSort.direction === \'asc\'\"><md-icon md-svg-src=\"assets/icons/app/V3/filters/filter_top.svg\"></md-icon>\n</button> <button class=\"iv-Input-label-btn\" ng-if=\"staticSort.direction === \'desc\'\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/filters/filter_bot.svg\"></md-icon></button></div></th><th class=\"pl-10\" \nng-if=\"trace.parameters.length > 0\" ng-repeat=\"param in trace.parameters\" \nng-style=\"{\'min-width\': getMinWidthForParam(param.name)}\"><div class=\"flex nl-Table__title\" \nng-click=\"enableDynSort($index)\">{{ param.name }}</div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"dynSort.index === $index\"><button class=\"iv-Input-label-btn\" ng-if=\"dynSort.direction === \'asc\'\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/filters/filter_top.svg\"></md-icon></button> <button class=\"iv-Input-label-btn\" \nng-if=\"dynSort.direction === \'desc\'\"><md-icon md-svg-src=\"assets/icons/app/V3/filters/filter_bot.svg\"></md-icon>\n</button></div></th><th class=\"nl-Table__menuEnd\"></th></tr></thead><tbody class=\"nl-Table__body\"><tr \nclass=\"nl-Table__item-trac\" ng-repeat=\"subtrace in subtraces track by subtrace.id\" ng-init=\"_sIndex = $index\" \nng-click=\"setToModif(subtrace, $index)\"><td class=\"pl-10\"><div class=\"\">{{ getDateString(subtrace.date) }}</div><div \nclass=\"nl-Table__modified\" ng-show=\"subtrace.dateModified\"><md-icon class=\"m-0 nl-listing-item-button m-0\" \nmd-svg-src=\"assets/icons/app/V3/information_red.svg\"></md-icon></div></td><td class=\"pl-10\"><div \nclass=\"reporter-container\"><div class=\"reporter-name\">{{ subtrace.reporter.completeName }}</div><div \nclass=\"nl-Table__modified\" ng-show=\"subtrace.reporterModified\"><md-icon class=\"m-0 nl-listing-item-button\" \nmd-svg-src=\"assets/icons/app/tracabilite/info.svg\"></md-icon></div></div></td><td class=\"pl-10\" \nng-repeat=\"param in subtrace.parameters\" ng-if=\"subtrace.parameters.length > 0\"><div class=\"param-container\"><div \nclass=\"param-value\" ng-if=\"param.type === \'TEXT\' || param.type === \'LIST\' || param.type === \'COLLABORATEUR\'\">\n{{ param.value }}</div><div class=\"param-value\" ng-if=\"param.type === \'DATE\'\">{{ param.value | date: \'dd/MM/yyyy\' }}\n</div><div class=\"param-value\" ng-if=\"param.type === \'SUIVI\'\" ng-click=\"$event.stopPropagation()\"><md-checkbox \nng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-model=\"param.value\" ng-change=\"updateCheckbox(subtrace, _sIndex)\" \nclass=\"nl-Checkbox-trac iv-Checkbox mt-5\"></md-checkbox></div><div class=\"nl-Table__modified\" ng-show=\"param.modified\">\n<md-icon class=\"m-0 nl-listing-item-button\" md-svg-src=\"assets/icons/app/tracabilite/info.svg\"></md-icon></div></div>\n</td><td class=\"pr-5\"><div class=\"flex\" layout=\"row\" layout-align=\"end center\"><div \nng-if=\"subtrace.documents.length > 0\" class=\"mr-5\" ng-click=\"$event.stopPropagation();download(subtrace.id)\" \nlayout=\"row\" layout-align=\"end center\" style=\"padding: 0\"><md-tooltip md-direction=\"bottom\">\nTélécharger {{ subtrace.documents.length > 1 ? \'les pièces jointes\' : \'la pièce jointe\' }}</md-tooltip><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/joindre_dark.svg\"></md-icon></div><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"setToModif(subtrace, $index)\" type=\"button\">\nCompléter / Modifier</md-button></md-menu-item><md-menu-item ng-if=\"subtrace.documents.length > 0\"><md-button \nclass=\"iv-Menu-dropdown-btn\" type=\"button\" ng-click=\"download(subtrace.id)\">\nTélécharger {{ subtrace.documents.length > 1 ? \'les pièces jointes\' : \'la pièce jointe\' }}</md-button></md-menu-item>\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openHistory(subtrace, $index)\" type=\"button\">\nAfficher l\'historique</md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"exportDocx(subtrace, trace)\" type=\"button\">\nExporter {{ trace.templateType != \'FICHE_PREPARATION\' && trace.templateType != \'CONTROLE_PREPARATION\' ? \'sous forme de document\' : \'la fiche de préparation à imprimer\' }}\n</md-button></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"openToInformation(subtrace.id)\" type=\"button\">Partager sur le cahier de transmission</md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></div><div class=\"iv-ListBloc__footer\" \nng-if=\"subtraces.length>0\"><div></div><div class=\"iv-ListBloc__pagination\"><button type=\"button\" \nclass=\"iv-ListBloc__pagination__btn\" aria-label=\"Previous\" ng-disabled=\"pagination.page==0\" \nng-click=\"getSubtracesByTraceAndDate(false,false)\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon>\n</button><div class=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}} / {{nbPages()}}</div><button \ntype=\"button\" class=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\" \nng-disabled=\"(pagination.page*pagination.nbrResults+pagination.nbrResults)>=pagination.total\" \nng-click=\"getSubtracesByTraceAndDate(false,true)\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon>\n</button></div></div></div></div></section>");
$templateCache.put("app/main/front/controle/trace/templates/templates.html","<section class=\"nl-Page\"><h1 class=\"nl-H1\"><button type=\"button\" class=\"nl-H1--backBtn\" ng-click=\"back()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div>{{trace.name}}</div></h1><div \nclass=\"nl-Content\"><div class=\"pb-25\"><form name=\"newSubtrace\" novalidate><div class=\"mt-25 mb-10\"><h2 \nclass=\"iv-form__container__title\">Exemple du nouvel enregistrement</h2></div><div class=\"nl-form__container\" \nng-if=\"subtraceToAdd\"><div layout=\"column\" class=\"nl-form__content\"><div layout=\"row\" layout-align=\"\"><div \nclass=\"ml-5 mr-5 flex-50 layout-row\"><md-input-container class=\"iv-Input-container no--errors-spacer flex-100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date</label><div class=\"iv-Input-date-wrapper\"><md-icon \nng-click=\"subtraceToAdd.isOpen = true\" class=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\">\n</md-icon><md-datepicker class=\"iv-Input-date\" md-is-open=\"subtraceToAdd.isOpen\" md-hide-icons=\"all\" name=\"date\" \nmd-open-on-focus ng-model=\"subtraceToAdd.date\" disabled=\"disabled\" required></md-datepicker></div><div \nng-messages=\"newSubtrace.date.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container></div><div class=\"ml-5 mr-5 flex-50 layout-row\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer flex-100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\n{{traceToAdd.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\'}} <span \nng-if=\"collaborateur.id == null\" class=\"asterix\">*</span></label><md-select md-no-asterisk \nng-model=\"subtraceToAdd.reporter.id\" required name=\"collaborateur\" class=\"iv-Input-select md-no-underline\" \nng-change=\"changeCollab(subtraceToAdd.reporter.id, true)\" md-container-class=\"iv-Select-dropdown\" disabled=\"disabled\">\n<md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" \nng-value=\"collaborateur.id\">{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"0\">+ Ajouter un nouveau collaborateur</md-option></md-select><div \nng-messages=\"newSubtrace.collaborateur.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div></div><div layout=\"row\" layout-wrap layout-align=\"start center\"><div \nclass=\"pl-5 pr-5 flex-100 layout-row\" ng-repeat=\"param in subtraceToAdd.parameters\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer flex-100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\n{{param.name}}<span ng-if=\"param.required\" class=\"asterix\">*</span></label><input disabled=\"disabled\" \nng-if=\"param.type === \'TEXT\'\" class=\"iv-Input-input ng-pristine md-input\" type=\"text\" name=\"param1\" \nng-model=\"param.value\" ng-required=\"param.required\"><md-checkbox disabled=\"disabled\" ng-true-value=\"\'true\'\" \nng-false-value=\"\'false\'\" ng-if=\"param.type === \'SUIVI\'\" ng-model=\"param.value\" class=\"nl-Checkbox iv-Checkbox mt-5\">\n</md-checkbox><div class=\"iv-Input-date-wrapper\" ng-if=\"param.type === \'DATE\'\" flex=\"auto\"><md-icon \nng-click=\"param.isOpen = true\" class=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n<md-datepicker class=\"iv-Input-date\" md-is-open=\"param.isOpen\" md-hide-icons=\"all\" name=\"date{{$index}}\" \nmd-open-on-focus ng-model=\"param.value\" required></md-datepicker></div><md-select flex=\"auto\" \nclass=\"iv-Input-select md-no-underline\" ng-if=\"param.type === \'LIST\'\" ng-model=\"param.value\"><md-option \nng-repeat=\"option in param.options track by $index\" ng-value=\"option.name\">{{option.name}}</md-option></md-select><div \nng-messages=\"newSubtrace.param1.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div>\n</div></md-input-container></div></div><div class=\"ml-5 mr-5 flex-100 layout-row\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">ㅤ</label>\n<button class=\"iv-Btn iv-Btn--file\" type=\"button\" style=\"width: 100%; justify-content: flex-start; border: 0\"><md-icon \nclass=\"m-0\" md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button>\n</md-input-container></div></div></div><div layout=\"row\" layout-align=\"end center\" class=\"pr-5 pt-10\"><button \ntype=\"button\" ng-click=\"back()\" class=\"nl-Btn nl-Btn--outline mr-10\">Fermer</button> <button type=\"button\" \nng-disabled=\"loadingAdd\" class=\"nl-Btn\" ng-click=\"openNewTrace()\"><md-progress-circular md-diameter=\"15px\" \nng-if=\"loadingAdd\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingAdd\">\nAdapter et Utiliser ce modèle</span></button></div></form></div></div></section>");
$templateCache.put("app/main/front/equipe/equipe/popup/add_collaborateur_min_popup.html","<md-dialog aria-label=\"addCollaborateur\" flex=\"40\"><form name=\"addCollaborateurForm\" class=\"md-inline-form\" novalidate \nng-submit=\"addCollaborateurForm.$valid && saveCollaborateurMin()\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-30\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\" ng-if=\"titlePopupSave\">{{titlePopupSave}}</div><div class=\"contact-name pt-10\" \nng-if=\"!titlePopupSave\">Ajouter un collaborateur</div></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"></div></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-wrap>\n<md-input-container class=\"nl-Input-container\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nom<span ng-if=\"collaborateur.surname == null\" class=\"asterix\">*\n</span></label><input type=\"text\" name=\"surname\" ng-model=\"collaborateur.surname\" required class=\"nl-Input-input\" \nplaceholder=\"\"><div ng-messages=\"addCollaborateurForm.surname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container class=\"nl-Input-container nl-noError\" \nflex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nPrénom<span ng-if=\"collaborateur.name == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"name\" \nng-model=\"collaborateur.name\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addCollaborateurForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions><button id=\"btnSaveCollabMin\" \nng-disabled=\"addCollaborateurForm.$invalid\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/equipe/popup/add_collaborateur_popup.html","<md-dialog aria-label=\"addCollaborateur\" flex=\"40\"><form name=\"addCollaborateurForm\" class=\"md-inline-form\" novalidate \nng-submit=\"addCollaborateurForm.$valid && saveCollaborateur()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar p-10\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\" \nng-if=\"titlePopupSave\">{{titlePopupSave}}</div><div class=\"iv-Dialog__title\" ng-if=\"!titlePopupSave\">\nAjouter un collaborateur</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" \nflex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nNom<span ng-if=\"collaborateur.surname == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"surname\" \nng-model=\"collaborateur.surname\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addCollaborateurForm.surname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Prénom<span \nng-if=\"collaborateur.name == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"name\" \nng-model=\"collaborateur.name\" required class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addCollaborateurForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container><div flex=\"100\" ng-if=\"$root.user.isTitulaire || $root.user.isPraq\"><div flex=\"100\">\n<md-input-container class=\"nl-Input-container\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Intitulé du poste</label><input type=\"text\" name=\"titre\" \nng-model=\"collaborateur.fichePoste.titre\" class=\"nl-Input-input\" placeholder=\"\"><div \nng-messages=\"addCollaborateurForm.titre.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div><div ng-if=\"!$root.user.isMini\"><div flex=\"100\" \nstyle=\"margin-bottom:10px\"><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label\" style=\"margin-bottom: -8px !important\">\nDescription du poste</label><ng-quill-editor ng-model=\"collaborateur.fichePoste.description\" class=\"ql-2\">\n</ng-quill-editor></md-input-container></div><div layout=\"row\" layout-align=\"start center\" class=\"mb-10\" \nng-show=\"!collaborateur.nameOfDocument && !collaborateur.originalFileName\"><button class=\"iv-Btn iv-Btn--file\" \ntype=\"button\"><div class=\"iv-Btn__file\" file-upload-single id=\"file_\"></div><md-icon class=\"m-0\" \nmd-svg-src=\"assets/icons/app/V3/file_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"mb-10\" \nng-if=\"collaborateur.nameOfDocument || collaborateur.originalFileName\"><div class=\"iv-Btn\" \nng-if=\"collaborateur.originalFileName != null\" ng-click=\"downloadDocument(collaborateur.fichePoste.documentPosteDTO)\">\n<md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ collaborateur.originalFileName}}</div></div>\n<div class=\"iv-Btn iv-Btn--file\" ng-if=\"collaborateur.nameOfDocument != null\"><div>{{ collaborateur.nameOfDocument}}\n</div></div><button type=\"button\" class=\"iv-BtnIcon--file\" \nng-click=\"clearInputFile(collaborateur,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\">\n</md-icon></button></div></div></div></div></md-dialog-content><md-dialog-actions style=\"width: 100%;gap:1rem\"><button \nng-click=\"hidePopup()\" class=\"nl-Btn nl-Btn--outline\" aria-label=\"Annuler\">Annuler</button> <button \nng-disabled=\"(intoSaving != null ? intoSaving : false) ||(working != null ? working : false)\" id=\"btnSaveCollab\" \ntype=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/equipe/popup/delete_collaborateur_popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar \nstyle=\"background-color: #DDEDFE; color: #1A2A33\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Suppression du collaborateur</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\" \nstyle=\"color: #1A2A33\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer {{collaborateurToDelete.name}} {{collaborateurToDelete.surname}} ?\n</md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline mr-10\" \nng-click=\"hidePopup()\">Non</button> <button class=\"nl-Btn\" ng-click=\"delete(ficheProgres)\">Oui</button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/equipe/popup/detail_ficheposte_popup.html","<md-dialog aria-label=\"Fiche de poste\" class=\"iv-Dialog\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{fichePoste.titre}}</div><div class=\"iv-Dialog__title\">\nCollaborateur : {{fichePoste.collaborateurDTO.name}} {{fichePoste.collaborateurDTO.surname}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"iv-Dialog__apercu__item ng-scope\" ng-if=\"fichePoste.description != null\"><div \nclass=\"iv-Dialog__apercu__item__title ng-binding\">Description</div><div \nclass=\"iv-Dialog__apercu__item__text ng-binding\" ng-bind-html=\"fichePoste.description\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\" style=\"gap:1rem\"><button class=\"nl-Btn nl-Btn--outline mb-5\" \nng-click=\"hidePopup()\">Fermer</button> <button class=\"nl-Btn mb-5\" \nng-click=\"downloadDocument(fichePoste.documentPosteDTO)\" ng-if=\"fichePoste.documentPosteDTO != null\">\nTélécharger la fiche de poste</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/popup/add_checklist_popup.html","<md-dialog aria-label=\"addappel\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"taskForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"taskForm.$valid && saveCheck()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{check.id ? \'Modifier\': \'Ajouter\'}}</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nIntitulé de la tâche <span ng-if=\"check.title == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"title\" \nng-model=\"check.title\" required class=\"iv-Input-input\" placeholder=\"\"><div ng-messages=\"taskForm.task.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div></md-input-container>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Description\n<span ng-if=\"check.description == null\" class=\"asterix\">*</span></label><textarea ng-model=\"check.description\" \nname=\"description\" class=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea><div \nng-messages=\"taskForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions><button type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\" aria-label=\"Annuler\">Annuler</button> <button \nng-disabled=\"taskForm.$invalid || loading\" id=\"btnSaveCall\" type=\"submit\" class=\"nl-Btn ml-10\" \naria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/popup/add_popup.html","<md-dialog aria-label=\"addT âche\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\" id=\"add-task-event-popup\"><form \nname=\"_form\" class=\"md-inline-form\" novalidate ng-submit=\"_form.$valid && __saveTask()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center center\" class=\"iv-Dialog__title-wrapper\"><div class=\"iv-Dialog__title\" ng-hide=\"_task.id\">Ajouter\n</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\">\n<md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-radio-group class=\"iv-Radio-wrapper iv-Radio-wrapper--modal mb-10\" layout=\"row\" \nlayout-align=\"end center\" layout-wrap ng-model=\"_task.event\"><md-radio-button class=\"iv-Radio\" ng-value=\"false\">\nAjouter une tâche</md-radio-button><md-radio-button class=\"iv-Radio\" ng-value=\"true\">Ajouter un RDV</md-radio-button>\n</md-radio-group><div ng-if=\"_task.event === false\" layout=\"row\" layout-align=\"start center\" layout-wrap><md-checkbox \nng-if=\"displayCheckBoxDone\" ng-model=\"_task.done\" aria-label=\"Tâche réalisée\" class=\"nl-Checkbox\">\nCette tâche a déjà été réalisée</md-checkbox><md-input-container class=\"iv-Input-container no--errors-spacer\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Intitulé de la tâche<span class=\"asterix\" \nng-if=\"_task.title == null\">*</span></label><input type=\"text\" name=\"title\" ng-model=\"_task.title\" placeholder=\"\" \nrequired class=\"iv-Input-input\"><div ng-messages=\"_form.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nResponsable<span class=\"asterix\" ng-if=\"_task.responsable == null\">*</span></label><md-select name=\"responsable\" \nmd-no-asterisk ng-model=\"_task.responsable.id\" placeholder=\"\" required class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.responsable.id)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"_user.id\" ng-repeat=\"_user in _users track by _user.id\">\n{{_user.surname + \' \' + _user.name }}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"_form.responsable.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"50\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nDate d\'échéance<span ng-if=\"echeance == null\">*</span></label><div class=\"iv-Input-date-wrapper\"><md-icon \nng-click=\"_tools.OPEN = true\" class=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n<md-datepicker class=\"iv-Input-date\" name=\"echeance\" md-is-open=\"_tools.OPEN\" ng-click=\"_tools.OPEN = true\" \nmd-hide-icons=\"all\" ng-model=\"_task.echeance\" placeholder=\"\" required></md-datepicker></div><div \nng-messages=\"_form.echeance.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Heure <span class=\"asterix\" ng-if=\"_task.heure == null\">*</span>\n</label><md-select name=\"heure\" md-no-asterisk ng-model=\"_task.heure\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"hour in hours\" ng-value=\"hour\">{{hour}}</md-option></md-select><div \nng-messages=\"_form.heure.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div>\n</md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-if=\"!_from_FICHE\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Récurrence</label><md-select name=\"responsible\" \nng-model=\"_task.recurrence\" placeholder=\"\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"recurrenceChanged()\"><md-option class=\"iv-Select-dropdown-btn\" \n[value]=\"null\">Aucune</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"_recurrence.value\" \nng-repeat=\"_recurrence in _recurrences | orderBy:\'index\'\">{{_recurrence.libelle }}</md-option></md-select>\n</md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Description\n</label><textarea ng-model=\"_task.description\" name=\"description\" class=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" \nmd-no-resize></textarea><div ng-messages=\"addAppelForm.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Information requise</span></div></div></md-input-container><div class=\"nl-newLookBlock-comment-actions pt-20\" \nng-class=\"{\'pb-20\': !_task.tags || _task.tags.length === 0}\"><md-menu md-position-mode=\"target-left target\" flex=\"100\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" aria-label=\"Mention\" \nclass=\"nl-newLookBlock-comment-mention mr-16\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/tag.svg\"></md-icon><div>Associer à un ou plusieurs tags</div></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item ng-repeat=\"tag in tags\"><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"selectTag(tag, _task)\"><div>{{tag.libelle}}</div></md-button></md-menu-item><md-menu-item><md-button \nclass=\"iv-Menu-dropdown-btn\" ng-click=\"openTag()\"><div style=\"font-weight: bold\">+ Gérer mes tags</div></md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"iv-Cmt-tag-wrapper no--padding\" flex=\"100\" \nng-if=\"_task.tags.length > 0\" style=\"padding-bottom: 20px !important\"><div class=\"iv-Cmt-item-W\" \nng-repeat=\"tag in _task.tags\"><div class=\"iv-planning-tag-item\"><div style=\"max-width:100%\"><div \nclass=\"iv-Tabs-section-item-inner\"><div class=\"iv-Tabs-section-item-title\">{{tag.libelle}}</div></div></div><button \ntype=\"button\" class=\"iv-Cmt-tag-item-delete\" ng-click=\"deleteTaskTag($index, _task)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div><div flex=\"100\" class=\"mt-10\" \nng-show=\"!_task.nameOfDocument && !_task.attachmentOriginalName && !_from_AUDIT\"><button flex=\"100\" class=\"iv-Btn\" \ntype=\"button\"><div class=\"iv-Btn__file\" file-upload-single id=\"task-input-file\"></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/file_dark.svg\"></md-icon><div>Choisir un fichier</div></button></div><div flex=\"100\" \nclass=\"mt-10\" ng-if=\"(_task.nameOfDocument||_task.attachmentOriginalName) && !_from_AUDIT\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"_task.nameOfDocument != null\"><div>\n{{ _task.nameOfDocument}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-click=\"clearInputFile(_task,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</button></div></div></div><div ng-if=\"_task.event === true\" layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Intitulé du RDV<span class=\"asterix\" \nng-if=\"_task.title == null\">*</span></label><input type=\"text\" name=\"title\" ng-model=\"_task.title\" placeholder=\"\" \nrequired class=\"iv-Input-input\"><div ng-messages=\"_form.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nResponsable<span class=\"asterix\" ng-if=\"_task.responsable == null\">*</span></label><md-select name=\"responsable\" \nmd-no-asterisk ng-model=\"_task.responsable.id\" placeholder=\"\" required class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.responsable.id)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"_user.id\" ng-repeat=\"_user in _users track by _user.id\">\n{{_user.surname + \' \' + _user.name }}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"_form.responsable.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-20\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span ng-if=\"echeance == null\">*</span></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon ng-click=\"_tools.OPEN = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" name=\"echeance\" \nmd-is-open=\"_tools.OPEN\" ng-click=\"_tools.OPEN = true\" md-hide-icons=\"all\" ng-model=\"_task.echeance\" placeholder=\"\" \nrequired></md-datepicker></div><div ng-messages=\"_form.echeance.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-20\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Heure <span class=\"asterix\" ng-if=\"_task.heure == null\">*</span>\n</label><md-select name=\"heure\" md-no-asterisk ng-model=\"_task.heure\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"hour in hours\" ng-value=\"hour\">{{hour}}</md-option></md-select><div \nng-messages=\"_form.heure.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div>\n</md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Durée <span class=\"asterix\" ng-if=\"_task.duration == null\">*\n</span></label><md-select name=\"duration\" md-no-asterisk ng-model=\"_task.duration\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"duration in durations\" ng-value=\"duration\">{{duration}}</md-option>\n</md-select><div ng-messages=\"_form.duration.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Description\n</label><textarea ng-model=\"_task.description\" name=\"description\" class=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container><div flex=\"100\" class=\"mt-10\" \nng-show=\"!_task.nameOfDocument && !_task.attachmentOriginalName && !_from_AUDIT\"><button flex=\"100\" class=\"iv-Btn\" \ntype=\"button\"><div class=\"iv-Btn__file\" file-upload-single id=\"event-input-file\"></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nflex=\"100\" class=\"mt-10\" ng-if=\"(_task.nameOfDocument||_task.attachmentOriginalName) && !_from_AUDIT\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"_task.nameOfDocument != null\">\n<div>{{ _task.nameOfDocument}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-click=\"clearInputFile(_task,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</button></div></div></div></md-dialog-content><md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"_closeDialog()\" aria-label=\"Annuler\">Annuler</button> <button ng-disabled=\"!!_isSaving\" id=\"btnSaveTache\" \ntype=\"submit\" class=\"nl-Btn ml-10\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/popup/confirm_delete_checklist.html","<md-dialog aria-label=\"addappel\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"taskForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"taskForm.$valid && deleteCheck()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nSuppression {{check.title}}</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"flex-100\">Êtes-vous sûr de vouloir supprimer cette tâche ?</div>\n</md-dialog-content><md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\" \naria-label=\"Annuler\">Annuler</button> <button ng-disabled=\"taskForm.$invalid || loading\" id=\"btnSaveCall\" \ntype=\"submit\" class=\"nl-Btn ml-10\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/popup/showRDV_popup.html","<md-dialog aria-label=\"addT âche\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"_form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"_form.$valid && __saveTask()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center center\" class=\"iv-Dialog__title-wrapper\"><div class=\"iv-Dialog__title\">Aperçu du RDV</div></div>\n<md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container class=\"iv-Input-container no--errors-spacer\" \nflex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Intitulé du RDV <span class=\"asterix\" \nng-if=\"_task.title == null\">*</span></label><input type=\"text\" name=\"title\" ng-model=\"_task.title\" placeholder=\"\" \nrequired class=\"iv-Input-input\"><div ng-messages=\"_form.title.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nResponsable<span class=\"asterix\" ng-if=\"_task.responsable == null\">*</span></label><md-select name=\"responsable\" \nmd-no-asterisk ng-model=\"_task.responsable.id\" placeholder=\"\" required class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\" ng-change=\"changeCollab(_task.responsable.id)\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-value=\"_user.id\" ng-repeat=\"_user in _users track by _user.id\">\n{{_user.surname + \' \' + _user.name }}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"_form.responsable.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-20\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span ng-if=\"echeance == null\">*</span></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon ng-click=\"_tools.OPEN = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" name=\"echeance\" \nmd-is-open=\"_tools.OPEN\" ng-click=\"_tools.OPEN = true\" md-hide-icons=\"all\" ng-model=\"echeance\" placeholder=\"\" required>\n</md-datepicker></div><div ng-messages=\"_form.echeance.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pr-20\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Heure <span class=\"asterix\" ng-if=\"_task.heure == null\">*</span>\n</label><md-select name=\"heure\" md-no-asterisk ng-model=\"_task.heure\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"hour in hours\" ng-value=\"hour\">{{hour}}</md-option></md-select><div \nng-messages=\"_form.heure.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div></div>\n</md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"33\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Durée <span class=\"asterix\" ng-if=\"_task.duration == null\">*\n</span></label><md-select name=\"duree\" md-no-asterisk ng-model=\"_task.duration\" placeholder=\"\" required \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\"><md-option \nclass=\"iv-Select-dropdown-btn\" ng-repeat=\"duration in durations\" ng-value=\"duration\">{{duration}}</md-option>\n</md-select><div ng-messages=\"_form.duree.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Description\n</label><textarea ng-model=\"_task.description\" name=\"description\" class=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" \nmd-no-resize></textarea><div ng-messages=\"addAppelForm.description.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Information requise</span></div></div></md-input-container><div flex=\"100\" class=\"mt-10\" \nng-show=\"!_task.nameOfDocument && !_task.attachmentOriginalName && !_from_AUDIT\"><button flex=\"100\" class=\"iv-Btn\" \ntype=\"button\"><div class=\"iv-Btn__file\" file-upload-single id=\"task\"></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nflex=\"100\" class=\"mt-10\" ng-if=\"(_task.nameOfDocument||_task.attachmentOriginalName) && !_from_AUDIT\"><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"_task.nameOfDocument != null\">\n<div>{{ _task.nameOfDocument}}</div></div><div class=\"iv-Btn\" ng-if=\"_task.attachmentOriginalName != null\" \nng-click=\"_downloadAttachement(_task)\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\n{{ _task.attachmentOriginalName}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-click=\"clearInputFile(_task,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</button></div></div></div></md-dialog-content><md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"_closeDialog()\" aria-label=\"Annuler\">Annuler</button> <button ng-disabled=\"!!_isSaving\" id=\"btnSaveTache\" \ntype=\"submit\" class=\"nl-Btn ml-10\" aria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/planning-general/popup/showSynchro_popup.html","<md-dialog aria-label=\"addT âche\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"_form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"_form.$valid && __saveTask()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center center\" class=\"iv-Dialog__title-wrapper\"><div class=\"iv-Dialog__title\" ng-hide=\"_task.id\">\nSynchroniser vos tâches et RDV</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"iv-popup-disclaimer flex-100\">\nUtilisez nos liens de connexion pour synchroniser/importer vos tâches et vos RDV du LQO dans votre agenda Google Calendar, iCalendar ou Outlook.\n<br>Copiez le lien ci-dessous, puis effectuer la démarche qui suit.<br><br><b>Pour Google Agenda</b><br>\n1. Connectez-vous à agenda Google<br>2. Dans la colonne de gauche, section ‘Autres agendas’, cliquez sur le bouton ‘+’.\n<br>3. Sélectionnez ‘à partir de l’URL’.<br>4. Collez le lien et sélectionnez ‘Ajouter à l’agenda’.<br><br><b>\nPour Calendrier Outlook :</b><br>1. Connectez-vous à Outlook<br>2. Cliquez sur l’icon ‘Calendrier’ en bas de page<br>\n3. Dans le volet de navigation, sélectionnez ‘Ajouter un calendrier’<br>4. Sélectionnez s’abonner ‘à partir du Web’.\n<br>5. Collez le lien et sélectionnez ‘Importer’.<br><br><b>Pour iCalendar</b><br>\n1. Ouvrez votre application Calendrier sur votre Mac.<br>\n2. Dans l’onglet ‘Ficher’, sélectionnez ‘Abonnement à un calendrier’<br>3. Collez le lien et cliquez sur ’S’abonner’.\n<br></div><div class=\"flex-100 mt-15\" layout=\"row\" layout-align=\"space-between end\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nLien de votre calendrier</label><input type=\"text\" name=\"icsToken\" ng-model=\"icsToken\" placeholder=\"\" \ndisabled=\"disabled\" class=\"iv-Input-input\"></md-input-container><div class=\"pb-5 pl-10\"><button class=\"iv-BtnIconFill\" \nng-click=\"copyIcsToken()\"><md-icon md-svg-src=\"./assets/icons/app/V3/copy.svg\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Copier le lien</md-tooltip></button></div><div class=\"pb-5 pl-10\"><button class=\"iv-BtnIconFill\" \nng-click=\"changeIcs()\"><md-icon md-svg-src=\"./assets/icons/app/V3/sync.svg\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Mettre à jour le lien</md-tooltip></button></div></div></div></md-dialog-content>\n<md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"_closeDialog()\" aria-label=\"Annuler\">\nFermer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/projects/popup/add_project_popup.html","<md-dialog flex=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xs=\"90\"><form name=\"projectForm\" class=\"md-inline-form\" novalidate \nng-submit=\"projectForm.$valid && saveProject()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Ajouter un projet</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-35\">\n<div layout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Nom<span \nclass=\"asterix\">*</span></label><input type=\"text\" name=\"name\" ng-model=\"newProject.name\" required \nclass=\"nl-Input-input\"><div ng-messages=\"projectForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">Objectif</label><input type=\"text\" name=\"objectiveTitle\" \nng-model=\"newProject.objectiveTitle\" class=\"nl-Input-input\"></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Description</label>\n<input type=\"text\" name=\"description\" ng-model=\"newProject.description\" class=\"nl-Input-input\"></md-input-container>\n</div></md-dialog-content><md-dialog-actions><button id=\"btnSaveCollabMin\" \nng-disabled=\"projectForm.$invalid || loadingSave\" type=\"submit\" class=\"nl-Btn\" aria-label=\"Sauvegarder\">\n<md-progress-circular md-diameter=\"15px\" ng-if=\"loadingSave\" class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular><span ng-if=\"!loadingSave\">Enregistrer</span></button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/projects/popup/confirm_delete_dialog.html","<md-dialog aria-label=\"Suppression\" flex=\"30\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"80\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nSupprimer un projet</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><span>Êtes-vous sûr de vouloir supprimer ce projet ?</span></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline\" type=\"button\" ng-click=\"closeModal()\">Annuler\n</button> <button class=\"nl-Btn ml-10\" type=\"button\" ng-disabled=\"loadingDelete\" ng-click=\"delete()\">\n<md-progress-circular md-diameter=\"15px\" ng-if=\"loadingDelete\" class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular><span ng-if=\"!loadingDelete\">Supprimer</span></button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/compte-rendu/compte-rendu.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><button class=\"iv-H1-backBtn\" ng-click=\"goBackFromCR();\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div>Réunions : <span class=\"iv-H1--status\">\nhistorique du compte-rendu</span></div></h1><div class=\"iv-Content\"><div class=\"iv-Tabs-content\"><div \nclass=\"iv-Tabs-step\"><div class=\"iv-Tabs-inner\"><div class=\"mt-15\"><h2 class=\"iv-Tabs-inner-Title\">\n{{_thisReunion.title}}</h2><div>\nA eu lieu le {{_thisReunion.dateStart | date: \"EEEE dd MMM yyyy \'à\' HH\'h\'mm\"}} • {{_thisReunion.lieu}}</div></div><div \nclass=\"mt-35\"><h2 class=\"iv-Tabs-inner-Title\">Liste d\'absence</h2><div class=\"mt-10\"><div class=\"iv-Tabs-inner-CR\">\n<span>Personnes présentes : </span>{{printUsers(_thisReunion.presences)}}</div><div class=\"iv-Tabs-inner-CR\"><span>\nPersonnes absentes : </span>{{printUsers(_thisReunion.absences)}}</div></div></div><div class=\"mt-35\"><h2 \nclass=\"iv-Tabs-inner-Title\" ng-if=\"!hasOdjRubrique\">Suivi de l\'activité de l\'officine</h2><div \nclass=\"iv-Tabs-item-list\" ng-if=\"!hasOdjRubrique\"><div><div ng-bind-html=\"_thisReunion.noteCompteRendu\"></div></div>\n</div><h2 class=\"iv-Tabs-inner-Title\">Éléments abordés lors de la réunion</h2><div \nng-repeat=\"(parentIndex, _rubrique) in _rubriques track by $index\" ng-show=\"_rubrique.elements.length > 0\"><h3 \nclass=\"iv-Tabs-item-sectionTitle\"><div ng-if=\"_rubrique.type === \'TEXT\'\"><md-input-container \nclass=\"iv-Tabs-item-list-item-input\" flex=\"100\"><label></label><input placeholder=\"Zone de texte\" \nng-model=\"_rubrique.libelle\" name=\"libelle\"></md-input-container></div><div ng-if=\"_rubrique.type != \'TEXT\'\">\n{{_rubrique.libelle}}</div></h3><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type != \'TEXT\' && _rubrique.type != \'NOTE_ODJ\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n<div class=\"iv-Tabs-item-list-item\" ng-repeat=\"_element in _rubrique.elements track by $index\" \nng-click=\"showElement(_element, _rubrique.type)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DYSFONCTIONNEMENT\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon ng-if=\"_rubrique.type === \'PROGRESS_FORM\'\" \nflex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'RAPPORT_D_AUDIT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/audit.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'AUTO_EVALUATION\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'SATISFACTION_CLIENT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/client_mystere.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'FLASH_QUALITE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/flash_dark.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.libelle}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type != \'DOCUMENT_MODIFIE\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n{{_element.collaborateur ? _element.collaborateur.surname + \' \' + _element.collaborateur.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div><div class=\"iv-Tabs-item-list-item-date\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\">\n{{_element.date | date: \'dd/MM/yyyy HH:mm\'}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">{{_element.date}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && _element.pdf && (_element.associationId || _element.id)\"><md-button \ntype=\"button\" ng-click=\"$event.stopPropagation();openPDF(_element)\">Afficher l\'aperçu</md-button></md-menu-item>\n<md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && (_element.associationId || _element.id) || _element.type === \'RAPPORT_D_AUDIT\' || _element.type === \'SATISFACTION_CLIENT\' || _element.type === \'AUTO_EVALUATION\'\">\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();download(_element, _rubrique.type)\">Télécharger</md-button>\n</md-menu-item></md-menu-content></md-menu><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"(_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\') && _element.done\">\n<md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nplaceholder=\"Ajouter un commentaire...\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'TEXT\'\"><div ng-repeat=\"_element in _rubrique.elements track by $index\"><div layout=\"row\" \nstyle=\"white-space: pre-wrap\" layout-align=\"start center\" ng-bind-html=\"_element.note\"></div></div></div><div \nclass=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'NOTE_ODJ\'\"><div style=\"white-space: pre-wrap\" layout=\"row\" \nlayout-align=\"start center\" ng-bind-html=\"_thisReunion.noteCompteRendu\"></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><div ng-repeat=\"indicateur in indicateurs track by $index\">\n<div class=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"iv-Tabs-item-list-item-title\">{{indicateur.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"iv-Indicator__monthWrapper pr-15 pl-10 pb-5\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"nl-indicator-body-legende\" \nng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div flex=\"100\" class=\"nl-Indicator__month__title\">{{indicateur.dataIndicateurs[0].year}}</div></div><div \nng-if=\"periods[indicateur.period] === \'mensuel\'\" class=\"iv-Indicator-body-legende nl-legende--mensuel\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"iv-Indicator__month__title\">jan.</div><div \nclass=\"iv-Indicator__month__title\">fév.</div><div class=\"iv-Indicator__month__title\">mar.</div><div \nclass=\"iv-Indicator__month__title\">avr.</div><div class=\"iv-Indicator__month__title\">mai.</div><div \nclass=\"iv-Indicator__month__title\">jui.</div><div class=\"iv-Indicator__month__title\">juil.</div><div \nclass=\"iv-Indicator__month__title\">aoû.</div><div class=\"iv-Indicator__month__title\">sep.</div><div \nclass=\"iv-Indicator__month__title\">oct.</div><div class=\"iv-Indicator__month__title\">nov.</div><div \nclass=\"iv-Indicator__month__title\">dec.</div></div><div class=\"nl-indicator-body-legende nl-legende--trimestriel\" \nng-if=\"periods[indicateur.period] === \'trimestriel\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">1er Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">3eme Trimestre\n</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre</div></div></div><div \nclass=\"iv-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"iv-Indicator__month__item flex\" \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\"><div><input disabled=\"disabled\" \nng-change=\"inputUpdated(data)\" ng-blur=\"inputChanged(data)\" ng-model=\"data.value\" \nng-class=\"{\n                              \'iv-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                              \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                              \'nl-Text--green\': checkGoalOK(data, indicateur),\n                              \'iv-Indicator--today\': isToday(data, periods[indicateur.period])}\" \nclass=\"iv-Indicator__month__input iv-Indicator--today\" aria-invalid=\"false\"></div></div></div></div></div></div><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nplaceholder=\"Ajouter un commentaire...\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div></div><div class=\"mt-20\" ng-if=\"_actionsDecidees.length > 0\">\n<h2 class=\"iv-Tabs-inner-Title\">Actions décidées au cours de la réunion</h2><div class=\"iv-Tabs-step-subtitle\"></div>\n<div class=\"iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in _actionsDecidees track by _element.id\" ng-click=\"showElement(_element, \'ACTION_DECIDEE\')\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" class=\"mr-15\"><md-checkbox \nng-change=\"_actionDecideeFaite(_element);\" ng-click=\"$event.stopPropagation()\" class=\"iv-Checkbox\" \nng-model=\"_element.done\" aria-label=\"Checkbox\" md-no-ink></md-checkbox></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon flex=\"auto\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div class=\"iv-Tabs-item-list-item-title\">\n{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div></div></div></div></div></div></div></div><div class=\"iv-Tabs-footer\"><div><button \nclass=\"nl-Btn nl-Btn--md nl-Btn--outline\" type=\"button\" ng-click=\"_saveCompteRendu();goBackFromCR()\">Fermer</button>\n</div><div layout=\"row\" layout-align=\"end center\"><button type=\"button\" class=\"nl-Btn nl-Btn--md mr-5\" \nng-click=\"openToInformation()\">Transmettre</button> <button type=\"button\" class=\"nl-Btn nl-Btn--md\" \nng-click=\"_imprimerCompteRenduFinaliser()\">Exporter</button></div></div></div></div></section>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/elementDetails.dialog.html","<md-dialog aria-label=\"dialog\" flex=\"40\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-10\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">Détails</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" \nlayout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"\"><div class=\"m-20\">{{_element.libelle}} <span ng-if=\"_element.type\"><br>\nType: {{_element.type}}</span> <span ng-if=\"_element.status\"><br>Statut: {{STATUSES_MALFUNCTION[_element.status]}}\n</span></div><div class=\"m-20\">{{_element.date | date:\"dd/MM/yyyy\"}}</div><div class=\"m-20\" \nng-bind-html=\"_element.description\"></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/indicator_dialog.html","<md-dialog aria-label=\"dialog\"><div layout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button \nclass=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div class=\"nl-Content\"><div ng-repeat=\"graph in graphsDisplayed track by $index\"><h1 \nclass=\"nl-H1\">{{graph.title}}</h1><br><canvas id=\"chart{{$index}}\" chart-series=\"graph.series\" class=\"chart chart-bar\" \nchart-data=\"graph.data\" chart-labels=\"graph.labels\" chart-options=\"chartOptions\"></canvas><div class=\"pt-45\"><button \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"downloadSinglePDF(graph, $index)\">Générer en PDF</button></div>\n</div><div class=\"pt-45\" ng-if=\"graphsDisplayed.length>1\"><button type=\"button\" class=\"nl-Btn\" \nng-click=\"downloadPDF()\">Générer tous les graphs en PDF</button></div></div></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/ordre-du-jour.html","<section class=\"iv-Page\"><h1 class=\"iv-H1\"><button class=\"iv-H1-backBtn\" ng-click=\"api._history();\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div>Réunions : <span class=\"iv-H1--status\">en cours\n</span></div></h1><div class=\"iv-Content\"><div class=\"iv-Tabs-wrapper\"><button class=\"iv-Tabs-item\" \nng-click=\"goToStep(tabs.one);\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.one, \'iv-Tabs-item--valid\': tabActive != tabs.one}\"><div \nclass=\"iv-Tabs-item-nbr\"><div ng-if=\"tabActive === tabs.one\">1</div><md-icon ng-if=\"tabActive != tabs.one\" \nclass=\"iv-Tabs-item-check\" md-svg-src=\"assets/icons/app/V3/check_white.svg\"></md-icon></div><div \nclass=\"iv-Tabs-item-title\">Planification</div></button> <button class=\"iv-Tabs-item\" ng-click=\"goToStep(tabs.two);\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.two, \'iv-Tabs-item--valid\': tabActive === tabs.three}\"><div \nclass=\"iv-Tabs-item-nbr\"><div ng-if=\"tabActive === tabs.two || tabActive !== tabs.three\">2</div><md-icon \nng-if=\"tabActive === tabs.three\" class=\"iv-Tabs-item-check\" md-svg-src=\"assets/icons/app/V3/check_white.svg\"></md-icon>\n</div><div class=\"iv-Tabs-item-title\">Ordre du jour</div></button> <button class=\"iv-Tabs-item\" \nng-class=\"{\'iv-Tabs-item--active\': tabActive === tabs.three}\"><div class=\"iv-Tabs-item-nbr\"><div \nng-if=\"tabActive !== tabs.three\">3</div><md-icon ng-if=\"tabActive === tabs.three\" class=\"iv-Tabs-item-check\" \nmd-svg-src=\"assets/icons/app/V3/check_white.svg\"></md-icon></div><div class=\"iv-Tabs-item-title\">Compte-rendu</div>\n</button></div><div class=\"iv-Tabs-content\"><form name=\"step1Form\" novalidate><div class=\"iv-Tabs-step\" \nng-if=\"tabActive === tabs.one\"><h2 class=\"iv-Tabs-step-title\">Étape 1 : <span>Planification</span></h2><div \nclass=\"iv-Tabs-inner\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div flex=\"66\" class=\"pr-10\">\n<md-input-container class=\"iv-form__container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Nom de la réunion <span class=\"asterix\">*</span></label><input \ntype=\"text\" name=\"title\" ng-model=\"_thisReunion.title\" class=\"iv-Input-input\" placeholder=\"\" required>\n</md-input-container></div><div flex=\"33\" class=\"pl-10\"><md-input-container \nclass=\"iv-form__container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Date <span \nclass=\"asterix\">*</span></label><div class=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"isOpen\" md-hide-icons=\"all\" name=\"dateStart\" ng-model=\"_thisReunion.dateStart\" \nmd-open-on-focus required></md-datepicker></div></md-input-container></div><div flex=\"66\" class=\"pr-10\">\n<md-input-container class=\"iv-form__container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Lieu <span class=\"asterix\">*</span></label><input type=\"text\" \nname=\"lieu\" ng-model=\"_thisReunion.lieu\" class=\"iv-Input-input\" placeholder=\"\" required></md-input-container></div><div\n flex=\"33\" class=\"pl-10\"><md-input-container class=\"iv-form__container no--errors-spacer\" md-no-float><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Heure <span class=\"asterix\">*</span></label><md-select \nng-model=\"_thisReunion.hourSelect\" name=\"hours\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"hour in hourEvents\" \nng-value=\"hour.value\">{{hour.name}}</md-option></md-select></md-input-container></div><div flex=\"50\" class=\"pr-10\">\n<md-input-container class=\"iv-form__container no--errors-spacer\" md-no-float><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Définir un rappel :</label><md-select \nng-model=\"_thisReunion.rappel\" name=\"rappel\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" ng-repeat=\"duration in reminders\" \nng-value=\"duration.value\">{{duration.name}}</md-option></md-select></md-input-container></div><div flex=\"50\" \nclass=\"pl-10\"><md-input-container class=\"iv-form__container no--errors-spacer\" md-no-float><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Définir une récurrence :</label><md-select \nng-model=\"_thisReunion.recurrence\" name=\"hours\" class=\"iv-Input-select md-no-underline\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"_recurrence.value\" \nng-repeat=\"_recurrence in _recurrences | orderBy:\'index\'\">{{ _recurrence.libelle }}</md-option></md-select>\n</md-input-container></div></div></div></div></form><form novalidate name=\"step2Form\"><div class=\"iv-Tabs-step\" \nng-if=\"tabActive === tabs.two\"><div layout=\"row\" layout-align=\"space-between stretch\"><div flex=\"67\" class=\"pr-30\"><h2 \nclass=\"iv-Tabs-step-title\">Étape 2 : <span>Ordre du jour</span></h2><div class=\"iv-Tabs-step-subtitle\">\nÉtablissez l’Ordre du jour de votre réunion en sélectionnant, dans la zone de droite, les éléments que vous souhaitez aborder.\n</div><div><div ng-repeat=\"(parentIndex, _rubrique) in _rubriques track by $index\" \nng-show=\"_rubrique.elements.length > 0\"><h3 class=\"iv-Tabs-item-sectionTitle\"><div ng-if=\"_rubrique.type === \'TEXT\'\" \nflex=\"100\"><md-input-container class=\"iv-Tabs-item-list-item-input\" flex=\"100\"><label></label><input \nplaceholder=\"Zone de texte\" ng-model=\"_rubrique.libelle\" name=\"libelle\"></md-input-container></div><div \nng-if=\"_rubrique.type != \'TEXT\'\">{{_rubrique.libelle}}</div><md-menu class=\"iv-Menu mr-10\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item ng-if=\"_rubrique.type === \'DYSFONCTIONNEMENT\'\"><md-button type=\"button\" \nng-click=\"popUpDysfonctionnements(_rubrique.elements)\">Insérer d\'autres dysfonctionnements</md-button></md-menu-item>\n<md-menu-item ng-if=\"_rubrique.type === \'PROGRESS_FORM\'\"><md-button type=\"button\" \nng-click=\"popUpFicheDeProgres(_rubrique.elements)\">Insérer d\'autres fiches de progrès</md-button></md-menu-item>\n<md-menu-item ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\"><md-button type=\"button\" \nng-click=\"popUpDocument(_rubrique.elements)\">Insérer un fichier de la base documentaire</md-button></md-menu-item>\n<md-menu-item ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\"><md-button type=\"button\" ng-click=\"openJoindreFile()\">\nInsérer un fichier de mon ordinateur</md-button></md-menu-item><md-menu-item \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\'\"><md-button type=\"button\" ng-click=\"popUpEvaluation(_rubrique.elements)\">\nInsérer d\'autres évaluations</md-button></md-menu-item><md-menu-item \nng-if=\"_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\'\"><md-button type=\"button\" \nng-click=\"popUpPlanning(_rubrique.elements)\">Insérer d\'autres tâches</md-button></md-menu-item><md-menu-item \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><md-button type=\"button\" \nng-click=\"popUpTDB(_rubrique.elements)\">Insérer d\'autres indicateurs</md-button></md-menu-item><md-menu-item \nng-if=\"_rubrique.type != \'NOTE_ODJ\' && _rubrique.type != \'DERNIERE_ACTION_DECIDEE\'\"><md-button type=\"button\" \nng-click=\"deleteRubrique($index)\">Retirer la section</md-button></md-menu-item><md-menu-item \nng-if=\"_rubrique.index > 0\"><md-button type=\"button\" ng-click=\"up($index)\">Déplacer la section vers le haut</md-button>\n</md-menu-item><md-menu-item ng-if=\"_rubriques.length > 1 && _rubrique.index < _rubriques.length - 1\"><md-button \ntype=\"button\" ng-click=\"down($index)\">Déplacer la section vers le bas</md-button></md-menu-item></md-menu-content>\n</md-menu></h3><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type != \'TEXT\' && _rubrique.type != \'NOTE_ODJ\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n<div class=\"iv-Tabs-item-list-item\" ng-repeat=\"_element in _rubrique.elements track by $index\" \nng-click=\"showElement(_element, _rubrique.type)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DYSFONCTIONNEMENT\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon ng-if=\"_rubrique.type === \'PROGRESS_FORM\'\" \nflex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'RAPPORT_D_AUDIT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/audit.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'AUTO_EVALUATION\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'SATISFACTION_CLIENT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/client_mystere.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'FLASH_QUALITE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/flash_dark.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.libelle}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\'\"><span ng-if=\"_element.type === \'RAPPORT_D_AUDIT\'\">Audit &nbsp;</span> \n<span ng-if=\"_element.type === \'AUTO_EVALUATION\'\">Auto-évaluation&nbsp;</span> <span \nng-if=\"_element.type === \'SATISFACTION_CLIENT\'\">Satisfaction client&nbsp;</span> <span \nng-if=\"_element.type === \'FLASH_QUALITE\'\">Flash Qualité&nbsp;</span></div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type != \'DOCUMENT_MODIFIE\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n{{_element.collaborateur ? _element.collaborateur.surname + \' \' + _element.collaborateur.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div><div class=\"iv-Tabs-item-list-item-date\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\">\n{{_element.date | date: \'dd/MM/yyyy HH:mm\'}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">{{_element.date}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"(_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\') && _element.done\">\n<md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div><md-menu \nclass=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\" \nng-if=\"_rubrique.type != \'NOTE_ODJ\'\"><button aria-label=\"\" class=\"iv-Menu-btn\" \nng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && _element.pdf && (_element.associationId || _element.id)\"><md-button \ntype=\"button\" ng-click=\"$event.stopPropagation();openPDF(_element)\">Afficher l\'aperçu</md-button></md-menu-item>\n<md-menu-item ng-if=\"_rubrique.type != \'DOCUMENT_MODIFIE\'\"><md-button type=\"button\" \nng-click=\"$event.stopPropagation();showElement(_element, _rubrique.type)\">Afficher l\'aperçu</md-button></md-menu-item>\n<md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && (_element.associationId || _element.id) || _element.type === \'RAPPORT_D_AUDIT\' || _element.type === \'SATISFACTION_CLIENT\' || _element.type === \'AUTO_EVALUATION\'\">\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();download(_element, _rubrique.type)\">Télécharger</md-button>\n</md-menu-item><md-menu-item ng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><md-button type=\"button\" \nng-click=\"$event.stopPropagation();exportIndicateur(_element)\">Exporter le graphique</md-button></md-menu-item>\n<md-menu-item><md-button type=\"button\" ng-click=\"$event.stopPropagation();removeElement($index, parentIndex)\">\nRetirer de la liste</md-button></md-menu-item></md-menu-content></md-menu></div></div><div><md-input-container \nclass=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea placeholder=\"Ajouter un commentaire...\" \nng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" md-no-resize></textarea>\n</md-input-container></div></div><div class=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'TEXT\'\"><div \nng-repeat=\"_element in _rubrique.elements track by $index\"><md-input-container class=\"iv-Tabs-item-list-item-textarea\" \nflex=\"100\"><label></label><textarea class=\"iv-Tabs-item-list-textarea\" placeholder=\"Ajouter du texte...\" \nng-model=\"_element.note\" name=\"note_{{$index}}\" rows=\"1\" max-rows=\"4\" md-no-resize></textarea></md-input-container>\n</div></div><div class=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'NOTE_ODJ\'\"><div><md-input-container \nclass=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea class=\"iv-Tabs-item-list-textarea\" \nplaceholder=\"Ajouter du texte...\" ng-model=\"_thisReunion.ordreDuJour.note\" name=\"note_odj\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><div ng-repeat=\"indicateur in indicateurs track by $index\">\n<div class=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"iv-Tabs-item-list-item-title\">{{indicateur.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-menu \nclass=\"iv-Menu\" md-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button \naria-label=\"\" class=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon \nclass=\"iv-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content \nclass=\"iv-Menu-dropdown--left\" width=\"2\"><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();openIndicateurDialog(indicateur)\">Afficher l\'aperçu</md-button></md-menu-item>\n<md-menu-item><md-button type=\"button\" ng-click=\"$event.stopPropagation();exportIndicateur(indicateur)\">\nExporter le graphique</md-button></md-menu-item><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();removeElement($index, parentIndex);removeIndicateur(indicateur.id, indicateur.dataIndicateurs[0].year)\">\nRetirer de la liste</md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"iv-Indicator__monthWrapper pr-15 pl-10 pb-5\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"nl-indicator-body-legende\" \nng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div flex=\"100\" class=\"nl-Indicator__month__title\">{{indicateur.dataIndicateurs[0].year}}</div></div><div \nng-if=\"periods[indicateur.period] === \'mensuel\'\" class=\"iv-Indicator-body-legende nl-legende--mensuel\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"iv-Indicator__month__title\">jan.</div><div \nclass=\"iv-Indicator__month__title\">fév.</div><div class=\"iv-Indicator__month__title\">mar.</div><div \nclass=\"iv-Indicator__month__title\">avr.</div><div class=\"iv-Indicator__month__title\">mai.</div><div \nclass=\"iv-Indicator__month__title\">jui.</div><div class=\"iv-Indicator__month__title\">juil.</div><div \nclass=\"iv-Indicator__month__title\">aoû.</div><div class=\"iv-Indicator__month__title\">sep.</div><div \nclass=\"iv-Indicator__month__title\">oct.</div><div class=\"iv-Indicator__month__title\">nov.</div><div \nclass=\"iv-Indicator__month__title\">dec.</div></div><div class=\"nl-indicator-body-legende nl-legende--trimestriel\" \nng-if=\"periods[indicateur.period] === \'trimestriel\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">1er Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">3eme Trimestre\n</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre</div></div></div><div \nclass=\"iv-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"iv-Indicator__month__item flex\" \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\"><div><input disabled=\"disabled\" \nng-change=\"inputUpdated(data)\" ng-blur=\"inputChanged(data)\" ng-model=\"data.value\" \nng-class=\"{\n                                  \'iv-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                                  \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                                  \'nl-Text--green\': checkGoalOK(data, indicateur),\n                                  \'iv-Indicator--today\': isToday(data, periods[indicateur.period])}\" \nclass=\"iv-Indicator__month__input iv-Indicator--today\" aria-invalid=\"false\"></div></div></div></div></div></div><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nplaceholder=\"Ajouter un commentaire...\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div></div><div class=\"mt-20\"><button class=\"iv-Tabs-imprimer\" \ntype=\"button\" ng-click=\"_imprimerMonSupportDetaile()\"><md-icon md-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><div>\nImprimer le support</div></button></div></div></div><div flex=\"33\" class=\"iv-Tabs-section\"><h2 \nclass=\"iv-Tabs-step-title\">CRÉER UNE NOUVELLE SECTION</h2><div class=\"iv-Tabs-step-subtitle\">\nPour créer une nouvelle section dans votre Ordre du Jour, cliquez sur un des item ci-dessous. Il s’insérera automatiquement à la suite des autres.\n</div><div><button type=\"button\" ng-click=\"addTextRubrique()\" class=\"iv-Tabs-section-item\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Tabs-section-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/zone_de_texte.svg\"></md-icon><div class=\"iv-Tabs-section-item-title\">Zone de texte\n</div></div><md-icon class=\"iv-Tabs-section-item-add\" md-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button> \n<button type=\"button\" class=\"iv-Tabs-section-item\" \nng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'DYSFONCTIONNEMENT\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'DYSFONCTIONNEMENT\') > -1\" ng-click=\"popUpDysfonctionnements()\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Tabs-section-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnements.svg\"></md-icon><div class=\"iv-Tabs-section-item-title\">\nDysfonctionnements</div></div><md-icon class=\"iv-Tabs-section-item-add\" md-svg-src=\"assets/icons/app/V3/add.svg\">\n</md-icon></button> <button type=\"button\" class=\"iv-Tabs-section-item\" ng-if=\"!$root.user.isMini\" \nng-click=\"popUpFicheDeProgres()\" ng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'PROGRESS_FORM\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'PROGRESS_FORM\') > -1\"><div class=\"iv-Tabs-section-item-inner\"><md-icon \nclass=\"iv-Tabs-section-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon><div \nclass=\"iv-Tabs-section-item-title\">Fiches de progès</div></div><md-icon class=\"iv-Tabs-section-item-add\" \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button><md-menu md-position-mode=\"target-left target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 20\"><button type=\"button\" class=\"iv-Tabs-section-item\" \nng-click=\"$mdMenu.open($event)\" ng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'DOCUMENT_MODIFIE\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'DOCUMENT_MODIFIE\') > -1\"><div class=\"iv-Tabs-section-item-inner\"><md-icon \nclass=\"iv-Tabs-section-item-icon\" md-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><div \nclass=\"iv-Tabs-section-item-title\">Documents</div></div><md-icon class=\"iv-Tabs-section-item-add\" \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" width=\"2\">\n<md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" ng-click=\"openJoindreFile()\"><md-icon \nmd-svg-src=\"./assets/icons/app/V3/computer.svg\"></md-icon><div>Un fichier de mon ordinateur</div></md-button><input \ntype=\"file\" id=\"add_info_file\" ng-hide=\"true\"></md-menu-item><md-menu-item><md-button class=\"iv-Menu-dropdown-btn\" \nng-click=\"popUpDocument()\"><md-icon md-svg-src=\"./assets/icons/app/V3/document.svg\"></md-icon><div>\nUn fichier de la base documentaire</div></md-button></md-menu-item></md-menu-content></md-menu><button type=\"button\" \nclass=\"iv-Tabs-section-item\" ng-click=\"popUpPlanning()\" \nng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'TACHE_ET_EVENEMENT_PLANIFIE\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'TACHE_ET_EVENEMENT_PLANIFIE\') > -1\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Tabs-section-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div class=\"iv-Tabs-section-item-title\">Tâches du planning\n</div></div><md-icon class=\"iv-Tabs-section-item-add\" md-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button> \n<button type=\"button\" class=\"iv-Tabs-section-item\" ng-click=\"popUpTDB()\" \nng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'INDICATEUR_DU_TABLEAU_DE_BORD\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'INDICATEUR_DU_TABLEAU_DE_BORD\') > -1\"><div \nclass=\"iv-Tabs-section-item-inner\"><md-icon class=\"iv-Tabs-section-item-icon\" md-svg-src=\"assets/icons/app/V3/tab.svg\">\n</md-icon><div class=\"iv-Tabs-section-item-title\">Tableau de bord</div></div><md-icon class=\"iv-Tabs-section-item-add\" \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button> <button type=\"button\" class=\"iv-Tabs-section-item\" \nng-click=\"popUpEvaluation()\" ng-class=\"{\'disabled\': _rubriquesSelected.lastIndexOf(\'MES_EVALUATIONS\') > -1}\" \nng-disabled=\"_rubriquesSelected.lastIndexOf(\'MES_EVALUATIONS\') > -1\"><div class=\"iv-Tabs-section-item-inner\"><md-icon \nclass=\"iv-Tabs-section-item-icon\" md-svg-src=\"assets/icons/app/V3/evaluation.svg\"></md-icon><div \nclass=\"iv-Tabs-section-item-title\">Mes évaluations</div></div><md-icon class=\"iv-Tabs-section-item-add\" \nmd-svg-src=\"assets/icons/app/V3/add.svg\"></md-icon></button></div></div></div></div></form><div class=\"iv-Tabs-step\" \nng-if=\"tabActive === tabs.three\"><h2 class=\"iv-Tabs-step-title\">Étape 3 : <span>Compte-rendu</span></h2><div \nclass=\"iv-Tabs-step-subtitle\">\nComplétez les éléments saisis précédemment avec ce qui a été dit ou acté lors de la réunion.</div><div \nclass=\"iv-Tabs-inner\"><div class=\"mt-15\"><h2 class=\"iv-Tabs-inner-Title\">{{_thisReunion.title}}</h2><div>\nA eu lieu le {{_thisReunion.dateStart | date: \"EEEE dd MMM yyyy \'à\' HH\'h\'mm\"}} • {{_thisReunion.lieu}}</div></div><div \nclass=\"mt-35\"><h2 class=\"iv-Tabs-inner-Title\">Liste de présence</h2><div class=\"iv-Tabs-step-subtitle\">\nCochez les personnes ayant assisté à la réunion.</div><div class=\"mt-10\"><div class=\"mb-5\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"user in _users track by user.id\"><div class=\"mr-10\"><md-checkbox \nng-model=\"user.selected\" class=\"iv-Checkbox m-0\"></md-checkbox></div><div class=\"iv-ListBloc__item__title\">\n{{user.surname + \' \' + user.name}}</div></div></div></div><div class=\"mt-35\"><h3 class=\"iv-Tabs-inner-Title\" \nng-if=\"!hasOdjRubrique\">Suivi de l\'activité de l\'officine</h3><div class=\"iv-Tabs-item-list\" ng-if=\"!hasOdjRubrique\">\n<div><md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nclass=\"iv-Tabs-item-list-textarea\" placeholder=\"Ajouter du texte...\" ng-model=\"_thisReunion.noteCompteRendu\" \nname=\"note_odj\" rows=\"1\" max-rows=\"4\" md-no-resize></textarea></md-input-container></div></div><h2 \nclass=\"iv-Tabs-inner-Title\">Éléments abordés lors de la réunion</h2><div \nng-repeat=\"(parentIndex, _rubrique) in _rubriques track by $index\" ng-show=\"_rubrique.elements.length > 0\"><h3 \nclass=\"iv-Tabs-item-sectionTitle\"><div ng-if=\"_rubrique.type === \'TEXT\'\"><md-input-container \nclass=\"iv-Tabs-item-list-item-input\" flex=\"100\"><label></label><input placeholder=\"Zone de texte\" \nng-model=\"_rubrique.libelle\" name=\"libelle\"></md-input-container></div><div ng-if=\"_rubrique.type != \'TEXT\'\">\n{{_rubrique.libelle}}</div></h3><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type != \'TEXT\' && _rubrique.type != \'NOTE_ODJ\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n<div class=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--2\" \nng-repeat=\"_element in _rubrique.elements track by $index\" ng-click=\"showElement(_element, _rubrique.type)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DYSFONCTIONNEMENT\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/dysfonctionnement.svg\"></md-icon><md-icon ng-if=\"_rubrique.type === \'PROGRESS_FORM\'\" \nflex=\"none\" class=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/fdp.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\" flex=\"none\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/doc.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'RAPPORT_D_AUDIT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/audit.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'AUTO_EVALUATION\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/auto_evaluation.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'SATISFACTION_CLIENT\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/client_mystere.svg\"></md-icon><md-icon \nng-if=\"_rubrique.type === \'MES_EVALUATIONS\' && _element.type === \'FLASH_QUALITE\'\" flex=\"none\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/flash_dark.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.libelle}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type != \'DOCUMENT_MODIFIE\' && _rubrique.type != \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">\n{{_element.collaborateur ? _element.collaborateur.surname + \' \' + _element.collaborateur.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div><div class=\"iv-Tabs-item-list-item-date\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\">\n{{_element.date | date: \'dd/MM/yyyy HH:mm\'}}</div><div class=\"iv-Tabs-item-list-item-date\" \nng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\">{{_element.date}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu class=\"iv-Menu\" md-position-mode=\"target-right target\" \nnl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\" ng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\'\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && _element.pdf && (_element.associationId || _element.id)\"><md-button \ntype=\"button\" ng-click=\"$event.stopPropagation();openPDF(_element)\">Afficher l\'aperçu</md-button></md-menu-item>\n<md-menu-item \nng-if=\"_rubrique.type === \'DOCUMENT_MODIFIE\' && (_element.associationId || _element.id) || _element.type === \'RAPPORT_D_AUDIT\' || _element.type === \'SATISFACTION_CLIENT\' || _element.type === \'AUTO_EVALUATION\'\">\n<md-button type=\"button\" ng-click=\"$event.stopPropagation();download(_element, _rubrique.type)\">Télécharger</md-button>\n</md-menu-item></md-menu-content></md-menu><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"(_rubrique.type === \'TACHE_ET_EVENEMENT_PLANIFIE\' || _rubrique.type === \'DERNIERE_ACTION_DECIDEE\') && _element.done\">\n<md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nplaceholder=\"Ajouter un commentaire...\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div><div class=\"iv-Tabs-item-list\" \nng-if=\"_rubrique.type === \'TEXT\'\"><div ng-repeat=\"_element in _rubrique.elements track by $index\"><md-input-container \nclass=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea class=\"iv-Tabs-item-list-textarea\" \nplaceholder=\"Ajouter du texte...\" ng-model=\"_element.note\" name=\"note_{{$index}}\" rows=\"1\" max-rows=\"4\" md-no-resize>\n</textarea></md-input-container></div></div><div class=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'NOTE_ODJ\'\"><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nclass=\"iv-Tabs-item-list-textarea\" placeholder=\"Ajouter du texte...\" ng-model=\"_thisReunion.noteCompteRendu\" \nname=\"note_odj\" rows=\"1\" max-rows=\"4\" md-no-resize></textarea></md-input-container></div></div><div \nclass=\"iv-Tabs-item-list\" ng-if=\"_rubrique.type === \'INDICATEUR_DU_TABLEAU_DE_BORD\'\"><div \nng-repeat=\"indicateur in indicateurs track by $index\"><div \nclass=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"iv-Tabs-item-list-item-title\">{{indicateur.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"iv-Indicator__monthWrapper pr-15 pl-10 pb-5\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"nl-indicator-body-legende\" \nng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div flex=\"100\" class=\"nl-Indicator__month__title\">{{indicateur.dataIndicateurs[0].year}}</div></div><div \nng-if=\"periods[indicateur.period] === \'mensuel\'\" class=\"iv-Indicator-body-legende nl-legende--mensuel\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div class=\"iv-Indicator__month__title\">jan.</div><div \nclass=\"iv-Indicator__month__title\">fév.</div><div class=\"iv-Indicator__month__title\">mar.</div><div \nclass=\"iv-Indicator__month__title\">avr.</div><div class=\"iv-Indicator__month__title\">mai.</div><div \nclass=\"iv-Indicator__month__title\">jui.</div><div class=\"iv-Indicator__month__title\">juil.</div><div \nclass=\"iv-Indicator__month__title\">aoû.</div><div class=\"iv-Indicator__month__title\">sep.</div><div \nclass=\"iv-Indicator__month__title\">oct.</div><div class=\"iv-Indicator__month__title\">nov.</div><div \nclass=\"iv-Indicator__month__title\">dec.</div></div><div class=\"nl-indicator-body-legende nl-legende--trimestriel\" \nng-if=\"periods[indicateur.period] === \'trimestriel\'\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">1er Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">3eme Trimestre\n</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre</div></div></div><div \nclass=\"iv-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div class=\"iv-Indicator__month__item flex\" \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\"><div><input disabled=\"disabled\" \nng-change=\"inputUpdated(data)\" ng-blur=\"inputChanged(data)\" ng-model=\"data.value\" \nng-class=\"{\n                              \'iv-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                              \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                              \'nl-Text--green\': checkGoalOK(data, indicateur),\n                              \'iv-Indicator--today\': isToday(data, periods[indicateur.period])}\" \nclass=\"iv-Indicator__month__input iv-Indicator--today\" aria-invalid=\"false\"></div></div></div></div></div></div><div>\n<md-input-container class=\"iv-Tabs-item-list-item-textarea\" flex=\"100\"><label></label><textarea \nplaceholder=\"Ajouter un commentaire...\" ng-model=\"_rubrique.comment\" name=\"comment_{{$index}}\" rows=\"1\" max-rows=\"4\" \nmd-no-resize></textarea></md-input-container></div></div></div><div class=\"mt-20\"><h2 class=\"iv-Tabs-inner-Title\">\nTâches</h2><div class=\"iv-Tabs-step-subtitle\">Planifiez les actions décidées au cours de la réunion</div><div \nclass=\"iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in _actionsDecidees track by _element.id\" ng-click=\"showElement(_element, \'ACTION_DECIDEE\')\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" class=\"mr-15\"><md-checkbox \nng-change=\"_actionDecideeFaite(_element);\" ng-click=\"$event.stopPropagation()\" class=\"iv-Checkbox\" \nng-model=\"_element.done\" aria-label=\"Checkbox\" md-no-ink></md-checkbox></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon flex=\"auto\" class=\"iv-Tabs-item-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div class=\"iv-Tabs-item-list-item-title\">\n{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div class=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div></div></div></div><button type=\"button\" ng-click=\"_planifierUneAction()\" class=\"iv-Tabs-imprimer mt-10\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/add_simple.svg\"></md-icon><div>Ajouter une tâche dans le planning</div></button></div>\n</div></div></div></div><div class=\"iv-Tabs-footer\"><div layout=\"row\" layout-align=\"start center\"><button \nclass=\"nl-Btn nl-Btn--md nl-Btn--outline\" ng-click=\"api._history()\">Annuler</button> <button \nclass=\"nl-Btn nl-Btn--md nl-Btn--outline ml-5\" ng-if=\"tabActive === tabs.one\" ng-click=\"_saveInfos(true)\">Enregistrer\n</button> <button class=\"nl-Btn nl-Btn--md nl-Btn--outline ml-5\" ng-if=\"tabActive === tabs.two\" \nng-click=\"_saveOrdreDuJour(true)\">Enregistrer</button> <button class=\"nl-Btn nl-Btn--md nl-Btn--outline ml-5\" \nng-if=\"tabActive === tabs.three\" ng-click=\"_saveCompteRendu()\">Enregistrer</button></div><div layout=\"row\" \nlayout-align=\"end center\"><button class=\"nl-Btn nl-Btn--md mr-5\" ng-if=\"tabActive === tabs.two\" \nng-click=\"previousStep()\">&lt; Précédent</button> <button class=\"nl-Btn nl-Btn--md mr-5\" \nng-if=\"tabActive != tabs.three\" ng-disabled=\"step1Form.$invalid\" ng-click=\"nextStep()\">Suivant ></button> <button \nclass=\"nl-Btn nl-Btn--md\" ng-click=\"popUpODJSubmit()\" ng-if=\"tabActive === tabs.three\">Valider</button></div></div>\n</div></section>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/report_odj_dialog.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" aria-label=\"Fermeture modal\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\">Ordre du jour</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Souhaitez-vous reporter ce point à la reunion suivante ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_addToNextReunion(false); _closeDialog();\">Non\n</button> <button class=\"nl-Btn\" ng-click=\"_addToNextReunion(true); _closeDialog();\">Ajouter à la prochaine réunion\n</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/confirm_document_popup.html","<md-dialog aria-label=\"Validation - Suppression\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{docToDelete != null ? \'Suppression \' + docToDelete.name : \'Validation \' + docToValidate.name}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-Dialog__text\">\nÊtes-vous sûr de vouloir {{docToDelete != null ? \'supprimer\' : \'valider\'}} ce document ?</div></md-dialog-content>\n<md-dialog-actions><button class=\"nl-Btn nl-Btn--outline mr-10\" ng-click=\"hidePopup()\">Non</button> <button \nclass=\"nl-Btn\" ng-if=\"docToDelete != null\" ng-click=\"deleteDocument()\">Oui</button> <button class=\"nl-Btn\" \nng-if=\"docToValidate != null\" ng-click=\"validDocument()\">Oui</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/delete_folder_popup.html","<md-dialog aria-label=\"Suppression\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nSuppression {{folderToDelete.name}}</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nÊtes-vous sûr de vouloir supprimer ce dossier ?</div></md-dialog-content><md-dialog-actions><button \nclass=\"nl-Btn nl-Btn--outline mr-10\" ng-click=\"hidePopup()\">Non</button> <button class=\"nl-Btn\" \nng-click=\"deleteFolder()\">Oui</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/document_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"25\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><form name=\"documentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"documentForm.$valid && saveDocument(editionMode)\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\" \nng-if=\"!editionMode\">Importer un fichier</div><div class=\"iv-Dialog__title\" ng-if=\"editionMode\">Modifier un document\n</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\">\n<md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container ng-if=\"editionMode\" class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\nNom du fichier<span ng-if=\"document.name == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"name\" \nng-model=\"document.name\" required class=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"documentForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><div \nng-if=\"editionMode\"><button class=\"iv-Btn\" type=\"button\" ng-click=\"download(document);\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.originalFileName }}</div></button><h4 \nclass=\"text-italic mt-20 mb-20\">\nCliquer sur le bouton ci-dessous « Choisir un autre fichier » si vous souhaitez remplacer le fichier actuel par un nouveau fichier.\n</h4><button class=\"iv-Btn\" type=\"button\"><div class=\"iv-Btn__file\" file-upload></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/file_dark.svg\"></md-icon><div>Choisir un autre fichier</div></button><div \nclass=\"iv-Btn\" ng-if=\"document.nameOfDocument\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\n{{document.nameOfDocument}}</div></div></div><div ng-if=\"!editionMode\"><button class=\"iv-Btn mb-10\" type=\"button\" \nng-show=\"!document.nameOfDocument\"><div class=\"iv-Btn__file\" file-upload></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/file_dark.svg\"></md-icon><div>Choisir un fichier</div></button><div \nng-if=\"document.nameOfDocument\"><md-input-container class=\"nl-Input-container nl-noError\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.user}\" ng-hide=\"multipleFiles\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Nom du fichier</label><input type=\"text\" name=\"name\" \nng-model=\"document.name\" required class=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"documentForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><div \nclass=\"mt-5\" layout=\"row\" layout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" \nng-if=\"document.nameOfDocument\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\n{{document.nameOfDocument}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-if=\"document.nameOfDocument\" ng-click=\"clearInputFile(\'document_input_file\');\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div><md-progress-circular \nmd-mode=\"indeterminate\" ng-if=\"loading\"></md-progress-circular></md-dialog-content><md-dialog-actions><button \nng-disabled=\"(working != null ? working : false) || (intoSaving != null ? intoSaving : false)\" id=\"btnSave\" \ntype=\"submit\" class=\"nl-Btn mh-5\" aria-label=\"Ajouter\" ng-if=\"!editionMode && document.nameOfDocument\" \nng-disabled=\"documentForm.$invalid\">Ajouter</button> <button ng-click=\"hidePopup()\" id=\"btnSave\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline mh-5\" aria-label=\"Annuler\">Annuler</button> <button \nng-disabled=\"(working != null ? working : false) || (intoSaving != null ? intoSaving : false)\" id=\"btnSave\" \ntype=\"submit\" class=\"nl-Btn mh-5\" aria-label=\"Modifier\" ng-if=\"editionMode\" ng-disabled=\"documentForm.$invalid\">\nSauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/folder_popup.html","<md-dialog aria-label=\"Dossier\" flex=\"30\" flex-sm=\"60\" flex-xs=\"80\"><form name=\"folderForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"folderForm.$valid && saveFolder()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">{{editionMode ? \'Modifier\' : \'Ajouter\'}} un dossier</div>\n</div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"nl-Input-container nl-noError\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label\n class=\"nl-Input-label md-no-float md-container-ignore\">Nom du dossier<span ng-if=\"newFolder.name == null\" \nclass=\"asterix\">*</span></label><input name=\"name\" ng-model=\"newFolder.name\" required class=\"nl-Input-input\" \ntype=\"text\" placeholder=\"\"><div ng-messages=\"folderForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><button \ntype=\"submit\" ng-click=\"hidePopup()\" class=\"nl-Btn nl-Btn--outline\" aria-label=\"Annuler\">Annuler</button> <button \nid=\"btnSaveFolder\" ng-disabled=\"folderForm.$invalid\" type=\"submit\" class=\"ml-10 nl-Btn\" aria-label=\"Valider\">\n{{editionMode ? \'Sauvegarder\' : \'Créer\'}}</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/historique_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Historique des versions</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-ListBloc\"><div \nclass=\"iv-ListBloc__title\">Liste des modifications effectuées sur le document</div><div class=\"iv-ListBloc__inner\"><div\n class=\"iv-ListBloc__item\" ng-repeat=\"history in dto.results track by history.id\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"iv-ListBloc__item__icon mr-10\" md-svg-src=\"./assets/icons/app/V3/file.svg\"></md-icon><div layout=\"column\"><div \nclass=\"iv-ListBloc__item__title\">{{history.name}}</div><div class=\"iv-ListBloc__item__underSubtitle\">\nV{{history.number}} • {{history.type === \'UPDATE\' ? \'Modifié\' : history.type === \'REPLACE\' ? \'Remplacé\' : \'Chargé\'}} le {{history.creationDate | date: \"dd/MM/yyyy \'à\' HH:mm\"}} {{printUser(history.user)}}\n</div><div class=\"iv-ListBloc__item__underSubtitle\" ng-if=\"history.validationDate != null\">\nValidé le {{history.validationDate | date: \"dd/MM/yyyy \'à\' HH:mm\"}} {{printUser(history.validationUser)}}</div></div>\n</div></div></div></div></div><div class=\"iv-ListBloc__footer\"><div></div><div class=\"iv-ListBloc__pagination\"><button \nng-if=\"pagination.page + 1 > 1\" type=\"button\" ng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Previous\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nclass=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}}/{{nbPages()}}</div><button \nng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" ng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div>\n</md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Fermer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/informations_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"30\" flex-md=\"40\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Information</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nChargez ici vos documents essentiels à votre fonctionnement. Ceux marqués du logo PHSQ, considérés comme incontournables, sont déjà chargés.\n<br><br>\nPour aller plus loin dans la gestion documentaire, n\'hésitez pas à retrouver sur votre portail qualité les documents suivants :\n<br>- Procédure exemple vierge<br>- Fiche information gérer sa bas documentaire..<br>- …</div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/infos_folders_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"100\" style=\"overflow: hidden\">\n<form class=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Information</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nChargez ici vos documents essentiels à votre fonctionnement. Ceux marqués du logo PHSQ, considérés comme incontournables, sont déjà présents.\n<br>\nIl existe par ailleurs sur votre portail qualité plus de 200 outils pour vous aider dans votre pratique quotidienne.\n<br>La liste de ces documents et leurs niveaux d\'importances sont disponibles dans le fichier \"<b>\nDOCUMENTATION-CHECKLIST- Outils Pharmacie</b>\" (disponible sur le LQO dans \"mes documents\").<br>\nCes documents sont téléchargeables sur votre portail qualité, nous vous invitons à n\'archiver dans le LQO que les documents prioritaires pour votre fonctionnement.\n<br><br>\nPour aller plus loin dans la gestion documentaire, n\'hésitez pas à retrouver sur votre portail qualité les documents suivants :\n<br>- <b>Procédure exemple vierge</b> (disponible sur le LQO dans \"piloter l\'entreprise\")<br>- <b>\nFiche information gérer sa base documentaire.</b><br>- <b>Un exemple de liste de procédures</b><br>- <b>\nUne fiche Délais de Conservation des documents de Gestion</b><br>\nA chaque modification de fichier réalisée, le numéro de version se met à jour.<br>\nSi un document est chargé par un membre de l\'équipe, il sera nécessaire de valider le document par le Responsable Qualité ou le titulaire\n<br>\nLe document sera tout de même consultable avec la mention \"non-validé par le Responsable Qualité\" en attendant cette opération.\n<br><br>\nles outils et supports disponibles sur le portail qualité sont des propositions et des exemples pour vous aider à traduire et intégrer plus rapidement les exigences de la démarche.\n<br>\nIls vous sont transmis en format « ouvert » et vous êtes libre de les modifier autant que vous le souhaitez, ou d’en utiliser d’autres.\n<br>La seule contrainte : répondre au quotidien aux exigences de fond du Manuel Pharma Système Qualité !</div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/moveFile_popup.html","<md-dialog class=\"iv-MovePopupDialog\" aria-label=\"fiche de progrès\" flex=\"55\" flex-md=\"70\" flex-sm=\"90\" flex-xs=\"100\">\n<form class=\"md-inline-form iv-MovePopupDialog__form\" novalidate ng-submit=\"moveDocument()\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nDéplacer \"{{documentToMove.name}}\" vers :</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20 iv-MovePopupDialog__content\" ms-scroll><div \nclass=\"iv-MovePopup__help\"><p>\nVous pouvez naviguer sur le fil d\'Ariane ci-dessous pour revenir en arrière dans les dossiers.</p></div><div \nclass=\"iv-ListBloc__breadcumb\"><div class=\"iv-ListBloc__breadcumb__item\" \nng-class=\"{\'iv-ListBloc__breadcumb__item--current\': !currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0}\" \nng-click=\"goToRoot()\"><a>Base documentaire</a> <span \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\" style=\"color: #999999\">></span></div>\n<div class=\"iv-ListBloc__breadcumb__item\" ng-repeat=\"breadcrumb in currentMoveFolder.breadcrumbs\" \nng-click=\"goToMoveFolder(breadcrumb)\"><a ng-if=\"!$last\">{{breadcrumb.name}} ></a> <span \nclass=\"iv-ListBloc__breadcumb__current\" ng-if=\"$last\">{{breadcrumb.name}}</span></div></div><div \nclass=\"iv-MovePopup__grid\" ng-class=\"movePopupSwipeClass\" layout=\"row\" layout-xs=\"column\"><div \nclass=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\"><div \nclass=\"iv-MovePopup__label\">Dossier parent</div><div class=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"!currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\">\n<div class=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" \nng-class=\"{\'iv-MovePopup__item--selected\': currentMoveFolder && folder.id === currentMoveFolder.id}\" \nng-repeat=\"folder in movePopupParentSiblings track by folder.id\" ng-click=\"openMoveFolder(folder, \'left\')\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div><div class=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\">\n<div class=\"iv-MovePopup__label\">Emplacement cible</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length === 1 && isCurrentMoveFolderRoot()\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--target\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length >= 2\">\nLes éléments sélectionnés seront déplacés ici</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\" \nng-if=\"currentMoveFolder && currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\"><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-repeat=\"folder in foldersMovePopup track by folder.id\" \nng-click=\"openMoveFolder(folder, \'right\')\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div></div></md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting || !canSubmitMove()\" type=\"submit\" class=\"nl-Btn ml-10\">Déplacer</button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/moveFolder_popup.html","<md-dialog class=\"iv-MovePopupDialog\" aria-label=\"fiche de progrès\" flex=\"55\" flex-md=\"70\" flex-sm=\"90\" flex-xs=\"100\">\n<form class=\"md-inline-form iv-MovePopupDialog__form\" novalidate ng-submit=\"moveFolderToNew()\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nDéplacer \"{{folderToMove.name}}\" vers :</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"mh-20 iv-MovePopupDialog__content\" ms-scroll><div \nclass=\"iv-MovePopup__help\"><p>\nVous pouvez naviguer sur le fil d\'Ariane ci-dessous pour revenir en arrière dans les dossiers.</p></div><div \nclass=\"iv-ListBloc__breadcumb\"><div class=\"iv-ListBloc__breadcumb__item\" \nng-class=\"{\'iv-ListBloc__breadcumb__item--current\': !currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0}\" \nng-click=\"goToRoot()\"><a>Base documentaire</a> <span \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\" style=\"color: #999999\">></span></div>\n<div class=\"iv-ListBloc__breadcumb__item\" ng-repeat=\"breadcrumb in currentMoveFolder.breadcrumbs\" \nng-click=\"goToMoveFolder(breadcrumb)\"><a ng-if=\"!$last\">{{breadcrumb.name}} ></a> <span \nclass=\"iv-ListBloc__breadcumb__current\" ng-if=\"$last\">{{breadcrumb.name}}</span></div></div><div \nclass=\"iv-MovePopup__grid\" ng-class=\"movePopupSwipeClass\" layout=\"row\" layout-xs=\"column\"><div \nclass=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\"><div \nclass=\"iv-MovePopup__label\">Dossier parent</div><div class=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"!currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\">\n<div class=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" \nng-class=\"{\'iv-MovePopup__item--selected\': currentMoveFolder && folder.id === currentMoveFolder.id}\" \nng-repeat=\"folder in movePopupParentSiblings track by folder.id\" ng-click=\"openMoveFolder(folder, \'left\')\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div><div class=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\">\n<div class=\"iv-MovePopup__label\">Emplacement cible</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length === 1 && isCurrentMoveFolderRoot()\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--target\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length >= 2\">\nLes éléments sélectionnés seront déplacés ici</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\" \nng-if=\"currentMoveFolder && currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\"><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-repeat=\"folder in foldersMovePopup track by folder.id\" \nng-click=\"openMoveFolder(folder, \'right\')\" ng-if=\"!folder.folder || folder.folder && folder.id != folderToMove.id\"><div\n class=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div></div></md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting || !canSubmitMove()\" type=\"submit\" class=\"nl-Btn ml-10\">Déplacer</button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/front/folders/folder/popup/moveSelection_popup.html","<md-dialog class=\"iv-MovePopupDialog\" aria-label=\"déplacer une sélection\" flex=\"55\" flex-md=\"70\" flex-sm=\"90\" \nflex-xs=\"100\"><form class=\"md-inline-form iv-MovePopupDialog__form\" novalidate ng-submit=\"moveSelectedItems()\">\n<md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nDéplacer {{selectedMoveItems.length}} élément{{selectedMoveItems.length > 1 ? \'s\' : \'\'}} vers :</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"mh-20 iv-MovePopupDialog__content\" ms-scroll><div class=\"iv-MovePopup__help\"><p>\nVous pouvez naviguer sur le fil d\'Ariane ci-dessous pour revenir en arrière dans les dossiers.</p></div><div \nclass=\"iv-ListBloc__breadcumb\"><div class=\"iv-ListBloc__breadcumb__item\" \nng-class=\"{\'iv-ListBloc__breadcumb__item--current\': !currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0}\" \nng-click=\"goToRoot()\"><a>Base documentaire</a> <span \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\" style=\"color: #999999\">></span></div>\n<div class=\"iv-ListBloc__breadcumb__item\" ng-repeat=\"breadcrumb in currentMoveFolder.breadcrumbs\" \nng-click=\"goToMoveFolder(breadcrumb)\"><a ng-if=\"!$last\">{{breadcrumb.name}} ></a> <span \nclass=\"iv-ListBloc__breadcumb__current\" ng-if=\"$last\">{{breadcrumb.name}}</span></div></div><div \nclass=\"iv-MovePopup__grid\" ng-class=\"movePopupSwipeClass\" layout=\"row\" layout-xs=\"column\"><div \nclass=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\"><div \nclass=\"iv-MovePopup__label\">Dossier parent</div><div class=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"!currentMoveFolder.breadcrumbs || currentMoveFolder.breadcrumbs.length === 0\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\">\n<div class=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" \nng-class=\"{\'iv-MovePopup__item--selected\': currentMoveFolder && folder.id === currentMoveFolder.id}\" \nng-repeat=\"folder in movePopupParentSiblings track by folder.id\" ng-if=\"!isForbiddenSelectionDestination(folder)\" \nng-click=\"openMoveFolder(folder, \'left\')\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div><div class=\"iv-MovePopup__col\" flex=\"50\" flex-xs=\"100\"><div class=\"iv-MovePopup__col-header\">\n<div class=\"iv-MovePopup__label\">Emplacement cible</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--error\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length === 1 && isCurrentMoveFolderRoot()\">\nVous ne pouvez pas déplacer d\'éléments dans ce dossier.</div><div \nclass=\"iv-MovePopup__col-info iv-MovePopup__col-info--target\" \nng-if=\"currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length >= 2\">\nLes éléments sélectionnés seront déplacés ici</div></div><div class=\"iv-ListBloc iv-ListBloc--fixedHeight\" \nng-if=\"currentMoveFolder && currentMoveFolder.breadcrumbs && currentMoveFolder.breadcrumbs.length > 0\"><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-repeat=\"folder in foldersMovePopup track by folder.id\" \nng-if=\"!isForbiddenSelectionDestination(folder)\" ng-click=\"openMoveFolder(folder, \'right\')\"><div \nclass=\"iv-ListBloc__item__inner\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"iv-ListBloc__item__icon mr-10\" ng-class=\"getMovePopupIconClass(folder)\" \nmd-svg-src=\"{{getMovePopupIconSrc(folder)}}\"></md-icon><div class=\"iv-ListBloc__item__title\">{{folder.name}}</div>\n</div><md-icon class=\"iv-ListBloc__item__arrow\" md-svg-src=\"./assets/icons/app/V3/arrow_right.svg\"></md-icon></div>\n</div></div></div></div></div></md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting || !canSubmitMove()\" type=\"submit\" class=\"nl-Btn ml-10\">Déplacer</button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/appel-medecins/popup/add_appel.html","<md-dialog aria-label=\"addappel\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"addAppelForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"addAppelForm.$valid && saveAppel()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nNouvel appel médecin</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container\n class=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Nom du médecin<span ng-if=\"appel.nomMedecin == null\" \nclass=\"asterix\">*</span></label><input type=\"text\" name=\"nomMedecin\" ng-model=\"appel.nomMedecin\" required \nclass=\"iv-Input-input\" placeholder=\"\"><div ng-messages=\"addAppelForm.nomMedecin.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Nom du patient<span ng-if=\"appel.nomPatient == null\" \nclass=\"asterix\">*</span></label><input type=\"text\" name=\"nomPatient\" ng-model=\"appel.nomPatient\" required \nclass=\"iv-Input-input\" placeholder=\"\"><div ng-messages=\"addAppelForm.nomPatient.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nAppelant *</label><md-select ng-model=\"appel.appelant.id\" required name=\"appelant\" \nclass=\"iv-Input-select md-no-underline\" md-container-class=\"iv-Select-dropdown\" \nng-change=\"changeCollab(appel.appelant.id)\" md-no-asterisk><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' +collaborateur.name}}</md-option><md-option \nclass=\"iv-Select-dropdown-btn iv-Select-dropdown-btn--action\" ng-value=\"0\">+ Ajouter un nouveau collaborateur\n</md-option></md-select><div ng-messages=\"addAppelForm.appelant.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Sujet, contenu des échanges avec le médecin<span \nng-if=\"appel.sujet == null\" class=\"asterix\">*</span></label><textarea ng-model=\"appel.sujet\" name=\"description\" \nclass=\"iv-Input-textarea\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea><div \nng-messages=\"addAppelForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container><div flex=\"100\" class=\"mt-10\" \nng-show=\"!appel.nameOfDocument && !appel.attachmentOriginalName\"><button flex=\"100\" class=\"iv-Btn\" type=\"button\"><div \nclass=\"iv-Btn__file\" file-upload-single></div><md-icon md-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon>\n<div>Ajouter une pièce jointe</div></button></div><div flex=\"100\" class=\"mt-10\" \nng-if=\"appel.nameOfDocument||appel.attachmentOriginalName\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"appel.nameOfDocument != null\"><div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon>{{ appel.nameOfDocument}}</div></div><button type=\"button\" \nclass=\"iv-BtnIcon iv-BtnIcon-2\" ng-click=\"clearInputFile(appel,\'document_input_file\');\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div><div class=\"iv-popup-disclaimer mt-15\">\nAttention, une fois votre appel enregistré, vous ne pourrez plus le modifier (vous pourrez néanmoins ajouter un commentaire).\n</div></div></md-dialog-content><md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\" aria-label=\"Annuler\">Annuler</button> <button \nng-disabled=\"!!working || addAppelForm.$invalid || !!intoSaving\" id=\"btnSaveCall\" type=\"submit\" class=\"nl-Btn ml-10\" \naria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/appel-medecins/popup/appel_popup.html","<md-dialog flex=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar \nstyle=\"background-color: #DDEDFE; color: #1A2A33\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><span layout=\"row\" layout-align=\"center center\" \nstyle=\"width: 100%\"><strong>Aperçu de l’appel médecin</strong></span><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\" style=\"color: #1A2A33\">\n</md-icon></md-button></div></div></md-toolbar><form class=\"mh-20\" name=\"addCommentForm\" \nng-submit=\"addCommentForm.$valid && addComment()\" novalidate><md-dialog-content><div \nclass=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">Nom du médecin</div>\n<div class=\"iv-Dialog__apercu__item__text ng-binding\">{{appel.nomMedecin}}</div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">Nom du patient</div>\n<div class=\"iv-Dialog__apercu__item__text ng-binding\">{{appel.nomPatient}}</div></div><div layout=\"row\" \nlayout-align=\"space-around center\" style=\"gap: 2rem\"><div class=\"iv-Dialog__apercu__item ng-scope\" style=\"width:50%\">\n<div class=\"iv-Dialog__apercu__item__title ng-binding\">Date et heure de l\'appel</div><div \nclass=\"iv-Dialog__apercu__item__text ng-binding\">{{appel.creationDate | date : \'dd/MM/yyyy\'}}</div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\" style=\"width:50%\"><div class=\"iv-Dialog__apercu__item__title ng-binding\"><br>\n</div><div class=\"iv-Dialog__apercu__item__text ng-binding\">\n{{appel.creationDate | date : \'HH\'}}:{{appel.creationDate | date : \'mm\'}}</div></div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">Appelant</div><div \nclass=\"iv-Dialog__apercu__item__text ng-binding\">{{appel.appelant.surname}} {{appel.appelant.name}}</div></div><div \nclass=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">\nSujet, contenu des échanges avec le médecin</div><div class=\"iv-Dialog__apercu__item__text ng-binding\">{{appel.sujet}}\n</div></div><div class=\"pt-10 pb-10\" ng-if=\"appel.attachmentOriginalName\"><button class=\"nl-pj__btn\" \nng-click=\"download(appel.id)\" aria-label=\"Télécharger la pièce jointe\" style=\"background-color: #F3F9FF !important\">\n<md-icon md-svg-src=\"assets/icons/app/V3/download.svg\" class=\"w-16 h-16\"></md-icon><span \nclass=\"iv-Dialog__apercu__item__text ng-binding ml-5\">{{appel.attachmentOriginalName}}</span></button></div><div \nclass=\"pt-20\" ng-repeat=\"comment in appel.comments | orderBy: \'creation\'\"><div \nclass=\"iv-Dialog__apercu__item ng-scope\"><div class=\"iv-Dialog__apercu__item__title ng-binding\">\nCommentaire ajouté le {{comment.creation | date: \'dd/MM/yyyy\'}} à {{comment.creation | date: \'HH\'}}h{{comment.creation | date: \'mm\'}}\n</div><div class=\"iv-Dialog__apercu__item__text ng-binding\" style=\"overflow-wrap: anywhere\">{{comment.text}}</div>\n</div></div><div flex=\"100\"><md-input-container class=\"iv-form__container no--errors-spacer iv-Input-container--full\">\n<label class=\"iv-Input-label md-no-float md-container-ignore\">Ajouter un commentaire</label><textarea name=\"text\" \nclass=\"iv-Input-textarea\" ng-model=\"comment.text\" name=\"reason\" rows=\"2\" max-rows=\"4\" md-no-resize required></textarea>\n<div ng-messages=\"addCommentForm.text.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn nl-Btn--outline mr-10\" type=\"button\" ng-click=\"cancelAddComment()\">Annuler</button> <button \nclass=\"nl-Btn\" type=\"submit\">Valider</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/malfunctions/appel-medecins/popup/export.html","<md-dialog class=\"iv-Dialog\" flex=\"30\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"80\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">Exporter\n</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\">\n<md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><form name=\"exportForm\" \nnovalidate ng-submit=\"exportForm.$valid && export()\"><md-dialog-content><div class=\"iv-Dialog__text mb-10\">\nVeuillez sélectionner une plage de dates correspondante aux données que vous souhaitez exporter</div><div layout=\"row\" \nlayout-align=\"space-between start\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de début <span ng-if=\"exportDates.startDate == null\" \nclass=\"asterix\">*</span></label><div class=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"isOpen\" md-hide-icons=\"all\" name=\"dateStart\" ng-model=\"exportDates.startDate\" \nmd-open-on-focus required></md-datepicker></div><div ng-messages=\"exportForm.dateStart.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer iv-Input-container--full\" flex=\"50\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date de fin <span ng-if=\"exportDates.endDate == null\" \nclass=\"asterix\">*</span></label><div class=\"iv-Input-date-wrapper\" ng-click=\"isOpen2 = !isOpen2\"><md-icon \nclass=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker \nclass=\"iv-Input-date\" md-is-open=\"isOpen2\" md-hide-icons=\"all\" name=\"dateEnd\" ng-model=\"exportDates.endDate\" required>\n</md-datepicker></div><div ng-messages=\"exportForm.dateEnd.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<button class=\"nl-Btn nl-Btn--outline\" type=\"button\" ng-click=\"hidePopup()\">Annuler</button> <button \nclass=\"nl-Btn ml-10\" type=\"submit\"><md-progress-circular md-diameter=\"15px\" ng-if=\"loadingExport\" class=\"md-accent\" \nmd-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingExport\" class=\"nl-Menu-btn-title\">Exporter</span>\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/performances/evaluation-fournisseurs/popup/add_fournisseur_popup.html","<md-dialog aria-label=\"addCollaborateur\" flex=\"30\" flex-sm=\"60\" flex-xs=\"80\"><form name=\"addFournisseurForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"addFournisseurForm.$valid && saveFournisseur()\"><md-toolbar \nlayout=\"column\" class=\"nl-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-icon-button\"></md-button><div class=\"nl-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"nl-Dialog__toolbar__title\">{{titlePopupSave}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><md-input-container class=\"nl-Input-container\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">\nNom du fournisseur<span ng-if=\"fournisseur.name == null\" class=\"asterix\">*</span></label><input \nclass=\"nl-newInput-input\" type=\"text\" placeholder=\"\" name=\"name\" ng-model=\"fournisseur.name\" required><div \nng-messages=\"addFournisseurForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container><div class=\"mb-20\"><md-input-container class=\"nl-Input-container\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Type de fournisseur<span ng-if=\"fournisseur.type == null\" \nclass=\"asterix\">*</span></label><md-select placeholder=\"\" ng-model=\"fournisseur.type\" name=\"selectType\" \nclass=\"nl-newInput-select md-no-underline\" md-no-asterisk md-container-class=\"nl-Select-dropdown\" \nng-disabled=\"prestataire!=null\" required><md-option class=\"nl-Select-dropdown-btn\" \nng-selected=\"prestataire != null ? prestataire == type.id : fournisseur.type == type.id\" \nng-repeat=\"type in typesFournisseur\" value=\"{{type.id}}\">{{type.name}}</md-option></md-select><div \nng-messages=\"addFournisseurForm.selectType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container></div><md-input-container class=\"nl-Input-container\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">\nNom du contact</label><input class=\"nl-newInput-input\" type=\"text\" placeholder=\"\" name=\"contactName\" \nng-model=\"fournisseur.contactName\"><div ng-messages=\"addFournisseurForm.contactName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Téléphone</label><input class=\"nl-newInput-input\" \ntype=\"text\" placeholder=\"\" name=\"contactPhone\" ng-model=\"fournisseur.contactPhone\"><div \nng-messages=\"addFournisseurForm.contactPhone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><md-input-container class=\"nl-Input-container nl-noError\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">E-mail\n</label><input class=\"nl-newInput-input\" type=\"email\" placeholder=\"\" name=\"contactMail\" \nng-model=\"fournisseur.contactMail\"><div ng-messages=\"addFournisseurForm.contactMail.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div><div ng-message=\"email\"><span>Format invalide</span></div>\n</div></md-input-container></md-dialog-content><md-dialog-actions><button ng-click=\"hidePopup()\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" aria-label=\"Annuler\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" \nclass=\"nl-Btn ml-10\" aria-label=\"Enregistrer\">Enregistrer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/performances/evaluation-fournisseurs/popup/contact_fournisseur_popup.html","<md-dialog flex=\"30\" flex-md=\"40\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar layout=\"column\" class=\"nl-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\"></md-button><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"nl-Dialog__toolbar__title\">Contact</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-35\"><div layout=\"row\" layout-wrap><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div flex=\"100\"><label \nclass=\"nl-Input-label nl-Label-trace\">Nom du contact</label><span class=\"nl-dialogSectionValue\">\n{{fournisseur.contactName}}</span></div></div><div class=\"pt-40\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\"><div flex=\"100\"><label class=\"nl-Input-label nl-Label-trace\">Téléphone</label><span \nclass=\"nl-dialogSectionValue\">{{fournisseur.contactPhone}}</span></div></div><div class=\"pt-40\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div flex=\"100\"><label class=\"nl-Input-label nl-Label-trace\">E-mail\n</label><span class=\"nl-dialogSectionValue\">{{fournisseur.contactMail}}</span></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn ml-10\" ng-click=\"hidePopup()\">Fermer</button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/front/performances/evaluation-fournisseurs/popup/infos_eval_popup.html","<md-dialog aria-label=\"dysfonctionnements\" flex=\"50\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"100\" style=\"overflow: hidden\">\n<form class=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Information</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"iv-Dialog__text\">\nComme dans toute entreprise, les prestations de l’officine peuvent être impactées par la qualité des prestations de ses propres fournisseurs et prestataires :\n<br>\nc’est bien entendu le cas pour les médicaments, en cas de rupture d’approvisionnement par exemple, ou pour le prestataire informatique s’il n’est pas réactif en cas de panne bloquante, etc…\n<br>\nC’est pour cela qu’il est demandé à l’officine engagée dans la démarche qualité de démontrer un suivi efficace pour trois types de fournisseurs et prestataires « significatifs » :\n<br><br><div class=\"pl-20\">- Vos fournisseurs de médicaments référencés par votre groupement<br>\n- Vos fournisseurs de médicaments non référencés par votre groupement<br>\n- Vos fournisseurs de « moyens généraux » (informatique, sécurité, assurance, bureautique etc…).<br></div><br>\nLe LQO facilite cette évaluation des fournisseurs, en effet à chaque dysfonctionnement rencontré avec un fournisseur (et enregistré dans le LQO),\n<br>\ncelui-ci s\'intègre dans la fiche du laboratoire. Ainsi à chaque RDV commercial vous pourrez retrouver les dysfonctionnements que votre équipe a rencontré avec le laboratoire/fournisseur concerné.\n<br><br>\nPour aller plus loin sur l\'optimisation de vos stocks et connaitre quelques valeurs de benchmark n\'hésitez pas à consulter les \n<b>BOX</b> : boites à outils facultatives disponibles sur votre portail.</div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/add-satisfaction-client-popup.html","<md-dialog aria-label=\"Document\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><form name=\"documentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"documentForm.$valid && saveDocument(testRadio)\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nArchiver une évaluation</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container\n flex=\"100\" class=\"iv-Input-container\"><md-radio-group class=\"iv-Radio-wrapper iv-Radio-wrapper--modal\" \nng-change=\"clearInputFile(document, \'document_input_file\')\" ng-model=\"testRadio\" required md-no-ink><md-radio-button \nclass=\"iv-Radio\" ng-value=\"tabs.auto\">Auto-évaluation</md-radio-button><md-radio-button class=\"iv-Radio\" \nng-value=\"tabs.audit\" ng-if=\"!$root.user.isMini\">Audit</md-radio-button><md-radio-button class=\"iv-Radio\" \nng-value=\"tabs.client\">Satisfaction client</md-radio-button></md-radio-group></md-input-container><div \nng-if=\"testRadio === tabs.auto || testRadio === tabs.client\" layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-input-container flex=\"100\" class=\"iv-Input-container no--errors-spacer\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nNom du document <span ng-if=\"document.name == null\" class=\"asterix\">*</span></label><input type=\"text\" name=\"name\" \nng-model=\"document.name\" class=\"iv-Input-input\" required><div ng-messages=\"documentForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Commentaire</label><textarea class=\"iv-Input-textarea\" \nname=\"comment\" ng-model=\"document.comment\" rows=\"3\" max-rows=\"5\" md-no-resize></textarea><div \nng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><div flex=\"100\" class=\"mt-10\" \nng-show=\"!document.nameOfDocument && !document.attachmentOriginalName\"><button flex=\"100\" class=\"iv-Btn\" type=\"button\">\n<div class=\"iv-Btn__file\" file-upload-single id=\"notaudit\"></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nflex=\"100\" class=\"mt-10\" ng-if=\"(document.nameOfDocument||document.attachmentOriginalName)\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"document.nameOfDocument != null\"><div>\n{{ document.nameOfDocument}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-click=\"clearInputFile(document,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\">\n</md-icon></button></div></div></div><div ng-if=\"testRadio == tabs.audit\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><md-input-container flex=\"100\" class=\"iv-Input-container no--errors-spacer\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nNom du document <span ng-if=\"document.auditName == null\" class=\"asterix\">*</span></label><input type=\"text\" \nname=\"name\" ng-model=\"document.auditName\" class=\"iv-Input-input\" required><div ng-messages=\"documentForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"iv-Input-container no--errors-spacer pr-10\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Ecart majeur \n<span ng-if=\"document.ecartsMajeurs == null\" class=\"asterix\">*</span></label><input type=\"number\" name=\"ecartMaj\" \nng-model=\"document.ecartsMajeurs\" class=\"iv-Input-input\" required><div ng-messages=\"documentForm.ecartMaj.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container>\n<md-input-container flex=\"50\" class=\"iv-Input-container no--errors-spacer pl-10\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Ecart mineur \n<span ng-if=\"document.ecartsMineurs == null\" class=\"asterix\">*</span></label><input type=\"number\" name=\"ecartMin\" \nng-model=\"document.ecartsMineurs\" class=\"iv-Input-input\" required><div ng-messages=\"documentForm.ecartMin.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Information requise.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" class=\"iv-Input-container no--errors-spacer\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Commentaire\n</label><textarea class=\"iv-Input-textarea\" name=\"comment\" ng-model=\"document.comment\" rows=\"3\" max-rows=\"5\" \nmd-no-resize></textarea><div ng-messages=\"evaluateFournisseurForm.evaluationComment.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><div flex=\"100\" class=\"mt-10\" \nng-show=\"!document.nameOfDocument && !document.attachmentOriginalName\"><button flex=\"100\" class=\"iv-Btn\" type=\"button\">\n<div class=\"iv-Btn__file\" file-upload-single id=\"audit\"></div><md-icon \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button></div><div \nflex=\"100\" class=\"mt-10\" ng-if=\"(document.nameOfDocument||document.attachmentOriginalName)\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding: 2px\"><div class=\"iv-Btn\" ng-if=\"document.nameOfDocument != null\"><div>\n{{ document.nameOfDocument}}</div></div><button type=\"button\" class=\"iv-BtnIcon iv-BtnIcon-2\" \nng-click=\"clearInputFile(document,\'document_input_file\');\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\">\n</md-icon></button></div></div><div class=\"flex-100 mt-20\"><md-checkbox ng-model=\"document.addODJ\" \naria-label=\"Ajouter à l\'ordre du jour\" class=\"nl-Checkbox iv-Checkbox\">Ajouter à l\'ordre du jour</md-checkbox></div>\n<div class=\"flex-100 mt-10\"><md-checkbox ng-model=\"document.confidential\" aria-label=\"Masquer pour l\'équipe\" \nclass=\"nl-Checkbox iv-Checkbox\">Masquer pour l\'équipe</md-checkbox></div></div></div></md-dialog-content>\n<md-dialog-actions><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\" aria-label=\"Annuler\">\nAnnuler</button> <button id=\"btnSaveClient\" type=\"submit\" class=\"nl-Btn ml-10\" aria-label=\"Sauvegarder\">Sauvegarder\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/delete-auto-evaluation-popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Suppression {{folderToDelete.name}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer cette archive d\'auto-évaluation ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"deleteFolder(tabs.auto)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/delete-satisfaction-client-popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Suppression {{folderToDelete.name}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer cette archive de satisfaction client ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"deleteFolder(tabs.client)\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/delete_audit.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Suppression de l\'audit {{folderToDelete.name}}</div></div>\n<md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer cet audit ?</md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn\" ng-click=\"deleteFolder(tabs.audit)\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/display-auto-evaluation-popup.html","<md-dialog aria-label=\"Dysfonctionnement\" class=\"iv-Dialog\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\">\n<md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{autoEvaluationToDisplay.name}}</div><div class=\"iv-Dialog__subtitle\">\nDate d\'envoi: {{autoEvaluationToDisplay.uploadDate | date: \'dd/MM/yyyy\'}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"iv-Dialog__text\"><div ng-if=\"autoEvaluationToDisplay.comment\"><div>Commentaire:</div><div \nclass=\"iv-Dialog__textareaComment mt-10\" ng-bind-html=\"autoEvaluationToDisplay.comment\"></div></div><div \nng-if=\"!autoEvaluationToDisplay.comment\">Pas de commentaire associé.</div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-if=\"autoEvaluationToDisplay.hasDoc\" \nng-click=\"download(autoEvaluationToDisplay, tabs.auto)\">Télécharger</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/display-satisfaction-client-popup.html","<md-dialog aria-label=\"Satisfaction client\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{satisfactionClientToDisplay.name}}</div><div class=\"iv-Dialog__subtitle\">\nDate d\'envoi: {{satisfactionClientToDisplay.uploadDate | date: \'dd/MM/yyyy\'}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nng-if=\"satisfactionClientToDisplay.comment\"><br>Commentaire:<br><div class=\"iv-Dialog__textareaComment\" \nng-bind-html=\"satisfactionClientToDisplay.comment\"></div></div><div ng-if=\"!satisfactionClientToDisplay.comment\"><br>\nAucun commentaire à afficher<br></div></md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" \nng-click=\"download(satisfactionClientToDisplay, tabs.client)\">Télécharger</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/display_audit.html","<md-dialog aria-label=\"Dysfonctionnement\" class=\"iv-Dialog\" flex=\"35\" flex-md=\"45\" flex-sm=\"80\" flex-xs=\"100\">\n<md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{auditToDisplay.name}}</div><div class=\"iv-Dialog__subtitle\">\nDate d\'envoi: {{auditToDisplay.uploadDate | date: \'dd/MM/yyyy\'}}</div><div class=\"iv-Dialog__subtitle\" \nng-if=\"auditToDisplay.addToManagementReview\">Ajouté au Bilan de performances</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"iv-Dialog__text\"><div ng-if=\"auditToDisplay.ecartsMajeurs != null\">\nEcarts majeurs: {{auditToDisplay.ecartsMajeurs}}</div><div ng-if=\"auditToDisplay.ecartsMineurs != null\">\nEcarts mineurs: {{auditToDisplay.ecartsMineurs}}</div></div><div class=\"iv-Dialog__text mt-20\">Commentaire:</div><div \nclass=\"iv-Dialog__textareaComment mt-10\" ng-bind-html=\"auditToDisplay.comment\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" ng-if=\"!odjMode\"><button type=\"button\" ng-click=\"download(auditToDisplay, tabs.audit)\" \nclass=\"nl-Btn nl-Btn--outline mh-5\" aria-label=\"Télécharger\">Télécharger</button> <button class=\"nl-Btn\" \nng-click=\"displayPopUpPlanTask()\">Planifier la levée des écarts</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/mes-evaluations/popup/generate-results-poster-popup.html","<md-dialog aria-label=\"Affiche de résultats\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><md-toolbar \nlayout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nGénérer mon affiche de résultats</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap class=\"pt-10\"><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Note sur 5\n</label><input class=\"iv-Input-input\" type=\"text\" ng-model=\"resultsPosterPopupData.noteOnFiveLabel\" ng-disabled=\"true\">\n</md-input-container><p class=\"mb-15\" ng-if=\"resultsPosterPopupData.generationMessage\">\n{{resultsPosterPopupData.generationMessage}}</p><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Mot-clé 1\n</label><input class=\"iv-Input-input\" type=\"text\" ng-model=\"resultsPosterPopupData.keywords[0]\" maxlength=\"45\">\n</md-input-container><md-input-container flex=\"100\" class=\"iv-Input-container no--errors-spacer\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Mot-clé 2</label><input class=\"iv-Input-input\" type=\"text\" \nng-model=\"resultsPosterPopupData.keywords[1]\" maxlength=\"45\"></md-input-container><md-input-container flex=\"100\" \nclass=\"iv-Input-container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">Mot-clé 3\n</label><input class=\"iv-Input-input\" type=\"text\" ng-model=\"resultsPosterPopupData.keywords[2]\" maxlength=\"45\">\n</md-input-container><div class=\"qs-results-poster-details\" flex=\"100\" \nng-if=\"resultsPosterPopupData.verbatimWords.length\"><button type=\"button\" class=\"qs-results-poster-details__header\" \nng-click=\"resultsPosterPopupData.verbatimDetailsOpen = !resultsPosterPopupData.verbatimDetailsOpen\" \nng-attr-aria-expanded=\"{{resultsPosterPopupData.verbatimDetailsOpen}}\"><span>Détail de l\'analyse des verbatims</span> \n<svg ng-if=\"!resultsPosterPopupData.verbatimDetailsOpen\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4 6l4 4 4-4\"></path>\n</svg> <svg ng-if=\"resultsPosterPopupData.verbatimDetailsOpen\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" \nstroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4 10l4-4 4 4\"></path>\n</svg></button><div class=\"qs-results-poster-details__content\" ng-if=\"resultsPosterPopupData.verbatimDetailsOpen\"><div \nclass=\"qs-results-poster-details__table-wrapper\"><table class=\"qs-results-poster-details__table\"><thead><tr><th>Mot\n</th><th>Nombre d\'occurrences</th></tr></thead><tbody><tr \nng-repeat=\"verbatimWord in resultsPosterPopupData.verbatimWords\"><td>{{verbatimWord.word}}</td><td>\n{{verbatimWord.occurrence}}</td></tr></tbody></table></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \ntype=\"button\" class=\"nl-Btn ml-10\" ng-disabled=\"resultsPosterGenerating\" ng-click=\"generateResultsPosterPdf()\"><span \nng-if=\"!resultsPosterGenerating\">Générer le PDF</span> <span ng-if=\"resultsPosterGenerating\">Génération...</span>\n</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/plan-strategique/popup/delete_plan_popup.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw pt-5 ph-25 pb-25\"><div \nclass=\"md-toolbar-tools nl_checkbox--categorie--title\"><h2 class=\"nl-H2\">\nSuppression du plan du {{planToDelete.creationDate | date:\'dd/MM/yyyy\'}}</h2></div><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer ce plan stratégique ?</md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-around center\"><button class=\"nl-Btn\" ng-click=\"delete()\">Oui</button> <button \nclass=\"nl-Btn nl-Btn--outline ml-20\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/plan-strategique/popup/duplicate_plan.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw pt-5 ph-25 pb-25\"><div \nclass=\"md-toolbar-tools nl_checkbox--categorie--title\"><h2 class=\"nl-H2\">\nDupliquer le plan du {{planToDuplicate.creationDate | date:\'dd/MM/yyyy\'}}</h2></div><md-dialog-content>\nÊtes-vous sûr de vouloir dupliquer ce plan stratégique ?</md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-around center\"><button class=\"nl-Btn\" ng-click=\"duplicate()\" ng-disabled=\"loadingDup\">\n<md-progress-circular md-diameter=\"15px\" md-mode=\"indeterminate\" ng-if=\"loadingDup\"></md-progress-circular><span \nng-if=\"!loadingDup\">Oui</span></button> <button class=\"nl-Btn nl-Btn--outline ml-20\" ng-click=\"hidePopup()\" \nng-disabled=\"loadingDup\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/plan-strategique/popup/validate_popup.html","<md-dialog aria-label=\"Validation\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"_closeDialog()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nValider le plan stratégique</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nUne fois votre Plan Stratégique validé, vous ne pourrez plus le modifier sur le LQO. Êtes-vous sûr de vouloir le valider maintenant ?\n<md-dialog-actions layout=\"row\"><md-button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"_closeDialog()\">\nNon, continuer</md-button><button class=\"nl-Btn\" ng-click=\"validate();\">Oui, valider</button></md-dialog-actions>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/front/performances/plan-strategique/step/step1.html","<div class=\"md-inline-form step1\"><h2 class=\"nl-H2\">SWOT</h2><div layout=\"column\" layout-wrap class=\"mt-20\"><div \nlayout=\"row\" style=\"width:100%\"><span class=\"nl-Input-container ph-10\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Forces</label><div ng-if=\"canUpdate\"><div \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\"></label>\n<ng-quill-editor ng-model=\"plan.swot.strengths\"></ng-quill-editor></div></div><span ng-if=\"!canUpdate\" \nng-bind-html=\"plan.swot.strengths\"></span> </span><span class=\"nl-Input-container ph-10\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Faiblesses</label><div ng-if=\"canUpdate\"><div \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\"></label>\n<ng-quill-editor ng-model=\"plan.swot.weaknesses\"></ng-quill-editor></div></div><span ng-if=\"!canUpdate\" \nng-bind-html=\"plan.swot.weaknesses\"></span></span></div><div layout=\"row\" class=\"mt-20\" style=\"width:100%\"><span \nclass=\"nl-Input-container ph-10\" flex=\"50\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Opportunités\n</label><div ng-if=\"canUpdate\"><div class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\"></label><ng-quill-editor ng-model=\"plan.swot.opportunities\">\n</ng-quill-editor></div></div><span ng-if=\"!canUpdate\" ng-bind-html=\"plan.swot.opportunities\"></span> </span><span \nclass=\"nl-Input-container ph-10\" flex=\"50\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Risques\n</label><div ng-if=\"canUpdate\"><div class=\"nl-Input-container\" flex=\"100\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\"></label><ng-quill-editor ng-model=\"plan.swot.threats\">\n</ng-quill-editor></div></div><span ng-if=\"!canUpdate\" ng-bind-html=\"plan.swot.threats\"></span></span></div></div>\n</div>");
$templateCache.put("app/main/front/performances/plan-strategique/step/step2.html","<div class=\"\"><h2 class=\"nl-H2\">Risques identifiés</h2><div class=\"nl-accordion mt-20\" \nng-repeat=\"categorie in categories track by $index\"><div class=\"nl-accordion-header\" ng-click=\"showCategorie($index)\">\n{{categorie.title}}<div class=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categorie.show == true\"><div class=\"nl-accordion-body-item\" ng-repeat=\"risk in categorie.risks\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-checkbox ng-disabled=\"!canUpdate\" \nng-model=\"risk.selected\" \nng-change=\"!risk.show ? (risk.selected ? showRisk($parent.$index,$index) : null) : (!risk.selected ? showRisk($parent.$index,$index) : null)\" \nclass=\"nl-Checkbox\" aria-label=\"Checkbox\" md-no-ink></md-checkbox><div layout=\"column\" class=\"nl-Checkbox\"><div \nclass=\"nl-accordion-header md-label\" ng-click=\"showRisk($parent.$index,$index)\">{{risk.title}}<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div></div></div></div><div class=\"mt-10 ml-30\" \nng-if=\"risk.show == true\"><div class=\"nl-accordion-body-item-highlight\">Moyens de prévention existants (exemples)</div>\n<div class=\"nl-accordion-body-item-text\"><pre>{{risk.moyens}}</pre></div><div class=\"mt-10\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><md-input-container class=\"nl-Input-container\" flex=\"40\"><md-select \nng-disabled=\"!canUpdate\" ng-required=\"risk.selected\" ng-model=\"risk.exposition\" \nclass=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option \nng-repeat=\"exposition in expositions\" class=\"nl-Select-dropdown-btn\" ng-value=\"exposition.value\">{{exposition.title}}\n</md-option></md-select></md-input-container><button type=\"button\" ng-if=\"canUpdate\" class=\"nl-Btn ml-10\" \nng-click=\"planAction(risk)\">Planifier une action</button></div></div></div></div></div><div class=\"nl-accordion\"><div \nclass=\"nl-accordion-header\" ng-click=\"showOther()\">Autres risques identifiés<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" ng-if=\"showRisksOther\">\n<div class=\"nl-accordion-body-item\" ng-repeat=\"risk in risksOther\"><div class=\"nl-dib\"><md-checkbox \nng-disabled=\"!canUpdate\" class=\"nl-Checkbox mt-20\" ng-model=\"risk.selected\" aria-label=\"Checkbox\" md-no-ink>\n</md-checkbox></div><md-input-container class=\"nl-Input-container nl-accordion-body-item-customInput\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Titre</label><input ng-disabled=\"!canUpdate\" \nng-required=\"risk.selected\" ng-model=\"risk.title\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\">\n</md-input-container><div class=\"mt-10 ml-30\" ng-if=\"risk.selected\"><md-input-container class=\"nl-Input-container\" \nflex=\"1000\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Commentaire</label><input \nng-disabled=\"!canUpdate\" ng-model=\"risk.commentary\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\">\n</md-input-container><div class=\"mt-10\" layout=\"row\" layout-wrap layout-align=\"space-between center\">\n<md-input-container class=\"nl-Input-container\" flex=\"40\"><md-select ng-disabled=\"!canUpdate\" required \nng-model=\"risk.exposition\" class=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\">\n<md-select-header class=\"nl-Input-select-header\">Sélectionnez votre entrée</md-select-header><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"LOW\">Exposition faible</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"NORMAL\">Exposition normale</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"STRONG\">Exposition forte\n</md-option></md-select></md-input-container><button type=\"button\" ng-if=\"canUpdate && !risk.id && !risk.idEnum\" \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"saveRisk(risk)\">Enregistrer risque</button> <button type=\"button\" \nng-if=\"canUpdate\" ng-disabled=\"(!risk.id && !risk.idEnum)\" class=\"nl-Btn ml-10\" ng-click=\"planAction(risk)\">\nPlanifier une action</button></div></div></div><br><button type=\"button\" ng-if=\"canUpdate\" class=\"nl-Btn ml-10\" \nng-click=\"addRiskOther()\">Ajouter un risque</button></div></div><div class=\"mt-20\"><h2 class=\"iv-Tabs-inner-Title\">\nTâches</h2><div class=\"iv-Tabs-step-subtitle\">Actions décidées au cours de l\'analyse des risques du plan stratégique\n</div><div class=\"iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in plan.tasks track by _element.id\" ng-click=\"showElement(_element)\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-icon flex=\"auto\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div \nclass=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button type=\"button\" ng-click=\"$event.stopPropagation();showElement(_element)\">\nAfficher l\'aperçu</md-button></md-menu-item><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();_openDelete(_element)\">Supprimer</md-button></md-menu-item></md-menu-content>\n</md-menu><div class=\"iv-Tabs-item-list-item-status\" ng-if=\"_element.done\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/front/performances/plan-strategique/step/step3.html","<div><h2 class=\"nl-H2\">Résumé de votre SWOT</h2><div class=\"nl-apercu-item\" flex=\"100\"><div \nclass=\"nl-apercu-item-title\">Forces</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\" \nng-bind-html=\"plan.swot.strengths\"></div></div><div class=\"nl-apercu-item\" flex=\"100\"><div \nclass=\"nl-apercu-item-title\">Faiblesses</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.weaknesses\"></div></div><div class=\"nl-apercu-item\" flex=\"100\"><div\n class=\"nl-apercu-item-title\">Opportunités</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.opportunities\"></div></div><div class=\"nl-apercu-item\" flex=\"100\">\n<div class=\"nl-apercu-item-title\">Risques</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\" ng-bind-html=\"plan.swot.threats\"></div></div><h2 class=\"nl-H2\">\nRésumé de vos risques identifiés</h2><li class=\"nl-apercu-item-text\" \nng-repeat=\"risk in plan.risks | orderBy: \'idEnum\'\">{{risk.title}} <span ng-if=\"risk.exposition\">\n({{expositionsJSON[risk.exposition]}})</span><div class=\"iv-Tabs-item-list\"><div \nclass=\"iv-Tabs-item-list-item iv-Tabs-item-list-item--readOnly\" ng-repeat=\"_element in risksTasks[risk.idEnum]\"><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-icon flex=\"auto\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div \nclass=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Tabs-item-list-item-status\" \nng-if=\"_element.done\"><md-icon md-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div>\n</div></div></div></div></li><div class=\"nl-apercu-item-text\" ng-if=\"plan.risks.length == 0\">Pas de risques identifiés.\n</div><h2 class=\"nl-H2\">Vos objectifs</h2><div layout=\"row\" layout-wrap><div class=\"nl-apercu-item-text\" \nng-if=\"objectives.length==0\">Aucun objectif à afficher</div><div class=\"mt-25\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\" ng-repeat=\"objective in objectives track by $index\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" flex=\"50\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Titre de l\'objectif {{$index + 1}}</label><input \nng-disabled=\"!canUpdate\" ng-model=\"objective.title\" ng-change=\"activatePlanButton(objective.title, objective.theme)\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"25\"><label class=\"nl-Input-label md-no-float md-container-ignore\">Thème PHSQ</label><md-select \nng-disabled=\"!canUpdate\" ng-required=\"objective.title != null && objective.title != \'\'\" ng-model=\"objective.theme\" \nng-change=\"activatePlanButton(objective.title, objective.theme)\" class=\"nl-newInput-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown-noLimit\"><md-select-header class=\"nl-Input-select-header\">\nSélectionnez votre thème</md-select-header><md-option class=\"nl-Select-dropdown-btn\" value=\"CONSEIL\">\nConseil et dispensation</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"RH\">\nRessources humaines et communication interne</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"PRODUIT\">\nProduits, services et accompagnement</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"RELATIONS\">\nRelation clients et partenaires</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"ECOR\">🌿ECOR</md-option>\n</md-select></md-input-container><md-checkbox ng-if=\"!$root.user.isTeam\" class=\"nl-Checkbox mt-20\" \nng-model=\"objective.confidential\" aria-label=\"Checkbox\" md-no-ink flex=\"15\" flex-offset=\"5\">Confidentiel<md-tooltip \nmd-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox><a href=\"\" class=\"nl-Link mt-20\" ng-click=\"deleteObjective(objective, $index)\">Supprimer l\'objectif</a>\n<div flex=\"100\" class=\"mt-10 iv-Tabs-item-list\"><div class=\"iv-Tabs-item-list-item\" \nng-repeat=\"_element in objective.tasks track by _element.id\" ng-click=\"showElement(_element)\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-icon flex=\"auto\" \nclass=\"iv-Tabs-item-icon\" md-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div \nclass=\"iv-Tabs-item-list-item-title\">{{_element.ecor ? \'🌿 \' : \'\'}}{{_element.title}}</div><div \nclass=\"iv-Tabs-item-list-item-date\">\n{{_element.responsable ? _element.responsable.surname + \' \' + _element.responsable.name + \' • \' : \'\'}} {{_element.echeance ? (_element.echeance | date: \'dd/MM/yyyy\') : _element.date ? (_element.date | date: \'dd/MM/yyyy\') : \'\'}}\n</div></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu class=\"iv-Menu\" \nmd-position-mode=\"target-right target\" nl-menu-class=\"iv-Menu-dropdown\" md-offset=\"0 35\"><button aria-label=\"\" \nclass=\"iv-Menu-btn\" ng-click=\"$event.stopPropagation();$mdMenu.open($event)\"><md-icon class=\"iv-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/V3/more.svg\"></md-icon></button><md-menu-content class=\"iv-Menu-dropdown--left\" \nwidth=\"2\"><md-menu-item><md-button type=\"button\" ng-click=\"$event.stopPropagation();showElement(_element)\">\nAfficher l\'aperçu</md-button></md-menu-item><md-menu-item><md-button type=\"button\" \nng-click=\"$event.stopPropagation();_openDelete(_element)\">Supprimer</md-button></md-menu-item></md-menu-content>\n</md-menu><div class=\"iv-Tabs-item-list-item-status\" ng-if=\"_element.done\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div><button \ntype=\"button\" ng-click=\"planActionObjective(objective, $index)\" class=\"iv-Tabs-imprimer mt-10\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/calendar_icon.svg\"></md-icon><div>Planifier une tâche</div></button></div></div></div>\n<div layout=\"row\" class=\"mt-20\" layout-wrap layout-align=\"space-between center\"><button ng-disabled=\"!canUpdate\" \ntype=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"addObjective()\">Ajouter un objectif</button></div></div>");
$templateCache.put("app/main/front/performances/tableau-de-bord/popup/add_indicateur.html","<md-dialog aria-label=\"addIndicateur\" flex=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\"><form name=\"addIndicateurForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"addIndicateurForm.$valid && saveIndicateur()\"><md-toolbar layout=\"column\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"nl-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"nl-Dialog__title\">{{titlePopupSave}}</div></div><md-button \nclass=\"md-icon-button nl-Dialog__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"pb-15\" flex=\"100\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Titre de l\'indicateur <span ng-if=\"indicateur.title == null\" \nclass=\"asterix\">*</span></label><input type=\"text\" name=\"title\" ng-model=\"indicateur.title\" required \nclass=\"nl-newInput-input\" placeholder=\"\"><div ng-messages=\"addIndicateurForm.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div><div class=\"pb-15\" \nflex=\"100\"><md-input-container class=\"nl-Input-container\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Périodicité</label><md-select ng-model=\"indicateur.period\" \nclass=\"nl-newInput-select md-no-underline\" md-container-class=\"nl-Select-dropdown\" ng-disabled=\"updateMode\"><md-option \nclass=\"nl-Select-dropdown-btn\" value=\"MONTHLY\">Mensuel</md-option><md-option class=\"nl-Select-dropdown-btn\" \nvalue=\"ANNUAL\">Annuel</md-option><md-option class=\"nl-Select-dropdown-btn\" value=\"QUARTERLY\">Trimestriel</md-option>\n</md-select></md-input-container></div><div class=\"pb-15\" layout=\"row\" layout-align=\"start end\" flex=\"100\">\n<md-input-container class=\"nl-Input-container nl-Input-container--no-error\" flex=\"25\" \nng-class=\"{\'md-input-invalid\': error.user}\"><label class=\"nl-newInput-label md-no-float md-container-ignore\">Objectif\n</label><md-select ng-model=\"indicateur.goalType\" class=\"nl-newInput-select md-no-underline\" \nmd-container-class=\"nl-Select-dropdown\"><md-option class=\"nl-Select-dropdown-btn\" value=\"LOWER\">Inférieur</md-option>\n<md-option class=\"nl-Select-dropdown-btn\" value=\"HIGHER\">Supérieur</md-option></md-select></md-input-container><div \nclass=\"\" flex=\"75\" layout=\"row\" layout-align=\"start center\"><div class=\"p-10\">à</div><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" flex ng-class=\"{\'md-input-invalid\': error.user}\"><input \ntype=\"text\" ng-change=\"inputChanged(indicateur)\" name=\"goal\" ng-model=\"indicateur.goal\" class=\"nl-newInput-input\">\n</md-input-container></div></div><div flex=\"75\"><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error\" ng-class=\"{\'md-input-invalid\': error.user}\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Format (%,€,..)</label><input type=\"text\" name=\"format\" \nng-model=\"indicateur.format\" class=\"nl-newInput-input\" placeholder=\"\"></md-input-container></div><div \nclass=\"pl-10 layout-row layout-align-end-center\" flex=\"25\"><md-checkbox ng-if=\"!$root.user.isTeam\" \nng-change=\"checkWeather()\" class=\"nl-newCheckbox\" style=\"margin-bottom:0\" ng-model=\"indicateur.confidential\" \naria-label=\"CheckboxConfidential\" md-no-ink>Confidentiel<md-tooltip md-direction=\"bottom\">\nCet élément sera invisible pour l\'équipe, mais restera visible pour le titulaire et le Responsable Qualité</md-tooltip>\n</md-checkbox></div><div class=\"pl-5 pt-10\" flex=\"100\"><md-checkbox \nng-disabled=\"!isAddWeatherOK || indicateur.confidential\" class=\"nl-newCheckbox\" ng-model=\"indicateur.weather\" \naria-label=\"CheckboxWeather\" md-no-ink>Ajouter à la météo qualité (3 maximum) <span ng-if=\"indicateur.confidential\">\n- Vous ne pouvez pas ajouter un indicateur qui est confidentiel</span></md-checkbox><div class=\"flex-100\" \nng-if=\"indicateur.weather\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" src=\"assets/images/PHSQ/rain.svg\" alt=\"\"></div>\n<md-input-container class=\"nl-Input-container\" flex=\"25\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Seuil 1</label><input name=\"seuilCloud\" required \nng-model=\"indicateur.thresholdLow\" class=\"nl-newInput-input\" type=\"text\"><div \nng-messages=\"addIndicateurForm.seuilCloud.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><div class=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" \nsrc=\"assets/images/PHSQ/cloudy.svg\" alt=\"\"></div><md-input-container class=\"nl-Input-container\" flex=\"25\"><label \nclass=\"nl-newInput-label md-no-float md-container-ignore\">Seuil 2</label><input name=\"seuilSun\" required \nng-model=\"indicateur.thresholdHigh\" class=\"nl-newInput-input\" type=\"text\"><div \nng-messages=\"addIndicateurForm.seuilSun.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div></div></md-input-container><div class=\"nl-weather-indicator\" flex><img class=\"nl-Meteo-img\" \nsrc=\"assets/images/PHSQ/sun.svg\" alt=\"\"></div></div></div></div></div></md-dialog-content><md-dialog-actions><button \nng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Enregistrer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/performances/tableau-de-bord/popup/archive_indicateur.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\n{{unarchive ? \'Désarchiver\': \'Archiver\'}} un indicateur</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>\nÊtes-vous sûr de vouloir {{unarchive ? \'désarchiver\': \'archiver\'}} l\'indicateur \"{{indicateurArchive.title}}\" ?\n</md-dialog-content><md-dialog-actions layout=\"row\"><button class=\"nl-Btn\" ng-click=\"archiveIndicateur()\">Oui</button> \n<button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/tableau-de-bord/popup/delete_indicateur.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nlayout=\"row\" class=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nSupprimer un indicateur</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir supprimer l\'indicateur \"{{indicateurDelete.title}}\" ?</md-dialog-content><md-dialog-actions \nlayout=\"row\"><button class=\"nl-Btn\" ng-click=\"delete()\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/performances/tableau-de-bord/popup/export.html","<md-dialog aria-label=\"Suppression\" flex=\"40\" flex-md=\"70\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar layout=\"column\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"nl-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"nl-Dialog__title\">Exporter</div></div><md-button \nclass=\"md-icon-button nl-Dialog__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><button type=\"button\" \nclass=\"nl-Dialog__btn\" ng-click=\"downloadPDF()\" ng-disabled=\"inLoad\"><md-progress-circular md-diameter=\"15px\" \nng-if=\"inLoad\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!inLoad\" \nclass=\"nl-Menu-btn-title\">Les graphiques en format PDF</span></button> <button type=\"button\" class=\"nl-Dialog__btn\" \nng-click=\"downloadXlsx(null, \'indicateurs\')\" ng-disabled=\"loadingXlsx\"><md-progress-circular md-diameter=\"15px\" \nng-if=\"loadingXlsx\" class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span ng-if=\"!loadingXlsx\" \nclass=\"nl-Menu-btn-title\">Les valeurs en format tableur</span></button> <button ng-disabled=\"loadingExport\" \ntype=\"button\" class=\"nl-Dialog__btn\" \nng-if=\"!!showDysfonctionnements || !!showDispensation || dynamicIndicator.length > 0\" ng-click=\"exportMalfunctions()\">\n<md-progress-circular md-diameter=\"15px\" ng-if=\"loadingExport\" class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular><span ng-if=\"!loadingExport\" class=\"nl-Menu-btn-title\">\nL\'intégralité des données dysfonctionnement en format tableur</span></button></md-dialog-content></md-dialog>");
$templateCache.put("app/main/front/performances/tableau-de-bord/popup/generate_graphs.html","<md-dialog aria-label=\"Générer les graphs\" flex=\"40\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-30\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">Générer les graphs</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"pt-20\" ng-repeat=\"indicateur in graphs\"><md-checkbox class=\"nl-Checkbox\" \nng-model=\"indicateur.generate\" aria-label=\"Checkbox\" md-no-ink>{{indicateur.title}}</md-checkbox></div>\n</md-dialog-content><md-dialog-actions><button type=\"button\" ng-click=\"generateGraphs()\" class=\"nl-Btn\">Générer\n</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/administration-bandeau/administration-bandeau.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Administration du bandeau déroulant (page d\'accueil)\n</h1><button ng-click=\"goCommunicationInterne()\" class=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\">\n</i> <span class=\"nl-H1-backBtn-text\">Communication interne</span></button><div class=\"mt-20\" layout=\"row\" \nlayout-align=\"center center\"><button flex permission=\"[permissions.TITULAIRE, permissions.PRAQ]\" class=\"nl-Btn\" \nng-click=\"openDialogNew()\" ng-if=\"noBandeau\">Ajouter un bandeau</button> <button flex \nclass=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"goHistory()\">Voir l\'historique</button></div><div \nclass=\"nl-listing mt-10\" ng-if=\"!noBandeau\"><div class=\"nl-listing-item\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button nl-listing-item-button\" \naria-label=\"Bandeau\"><md-icon md-font-icon=\"icon-file-document\" class=\"nl-listing-item-icon\"></md-icon></md-button><div\n layout=\"column\"><div class=\"text-truncate nl-listing-item-title\">{{currentBandeau.message}}</div><div \nclass=\"nl-indicator-header-infos\">{{currentBandeau.dateDebut | date: \'dd/MM/yyyy\'}}</div></div></div><div><md-menu \nclass=\"nl-Menu mr-20\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" \nclass=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"openDialogDisplay()\">Voir\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"nl-Menu-dropdown-btn\" ng-click=\"openDialogUpdate()\">Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button class=\"nl-Menu-dropdown-btn\" \nng-click=\"openDialogDelete()\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></section>");
$templateCache.put("app/main/front/qualite/communication-interne/administration-bandeau/history_bandeaux.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Historique des bandeaux déroulants</h1><button \nng-click=\"goAdministrationBandeau()\" class=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour à l\'administration</span></button><div class=\"nl-listing mt-10\" \nng-if=\"bandeaux.length !== 0\"><div ng-repeat=\"bandeau in bandeaux track by $index\"><div class=\"nl-listing-item\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-button \nclass=\"md-icon-button nl-listing-item-button\" aria-label=\"Bandeau\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"nl-listing-item-icon\"></md-icon></md-button><div layout=\"column\"><div \nclass=\"text-truncate nl-listing-item-title\">{{bandeau.message}}</div><div class=\"nl-indicator-header-infos\">\n{{bandeau.dateDebut | date: \'dd/MM/yyyy\'}}</div></div></div><div><md-menu class=\"nl-Menu mr-20\" md-menu-origin \nnl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" class=\"nl-Menu-btn\" \nng-click=\"$mdMenu.open($event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon class=\"nl-Menu-btn-svg\" \nmd-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button><md-menu-content width=\"4\">\n<md-menu-item md-menu-align-target><md-button class=\"nl-Menu-dropdown-btn\" ng-click=\"openDialogDisplay(bandeau)\">Voir\n</md-button></md-menu-item><md-menu-item permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button \nclass=\"nl-Menu-dropdown-btn\" ng-click=\"openDialogDelete(bandeau, $index)\">Supprimer</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div></div><div class=\"nl-listing mt-10\" ng-if=\"bandeaux.length === 0\">\n<center>Pas d\'historique pour le moment.</center></div></div></section>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/add-note-interne.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">\n{{editMode ? \"Edition d\'une note interne\" : \"Ajout d\'une note interne\"}}</h1><h3>\nSélectionnez ici les thèmes que vous souhaitez mettre en forme pour éditer une note de communication interne.</h3>\n<button ng-click=\"goBack()\" class=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour à la liste des newsletter</span></button><form class=\"mb-50\" \nname=\"addMalfunctionForm\" ng-submit=\"addMalfunctionForm.$valid && save()\" novalidate><div class=\"nl-form-wrapper\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"mt-20 mb-10\" flex=\"100\"><div class=\"nl-accordion\"><div\n class=\"nl-accordion-header\" ng-click=\"show(\'malfunctions\', true)\"><md-checkbox class=\"nl-Checkbox\" \nng-click=\"selectAllElement(\'malfunctions\'); $event.stopPropagation();\" ng-model=\"categories.malfunctions.checked\" \naria-label=\"Checkbox\" md-no-ink></md-checkbox>Dysfonctionnements<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.malfunctions.show\"><div class=\"nl-accordion-body-item\" \nng-repeat=\"malfunction in categories.malfunctions.elements track by $index\"><md-checkbox class=\"nl-Checkbox\" \nng-change=\"eltChecked(\'malfunctions\')\" ng-model=\"malfunction.checked\" aria-label=\"Checkbox\" md-no-ink>\n{{malfunction.title}} - ({{malfunction.creation | date: \'dd.MM.yyyy\'}})</md-checkbox><a \nclass=\"nl-accordion-body-item-link\" ng-click=\"openDetails(malfunction)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"malfunction.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input \nng-model=\"malfunction.comment\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div \nclass=\"nl-accordion-body-item\" ng-if=\"categories.malfunctions.elements.length === 0\">\nPas de dysfonctionnements à afficher</div><a ng-click=\"loadMore(\'malfunctions\')\" \nng-if=\"!categories.malfunctions.allLoaded\">Charger plus...</a></div></div><div class=\"nl-accordion\"><div \nclass=\"nl-accordion-header\" ng-click=\"show(\'documents\', true)\"><md-checkbox class=\"nl-Checkbox\" \nng-click=\"selectAllElement(\'documents\'); $event.stopPropagation();\" ng-model=\"categories.documents.checked\" \naria-label=\"Checkbox\" md-no-ink></md-checkbox>Documents ajoutés<div class=\"nl-accordion-header-icon icon-chevron-down\">\n</div></div><div class=\"nl-accordion-body\" ng-if=\"categories.documents.show\"><div class=\"nl-accordion-body-item\" \nng-repeat=\"doc in categories.documents.elements\"><md-checkbox class=\"nl-Checkbox\" ng-change=\"eltChecked(\'documents\')\" \nng-model=\"doc.checked\" aria-label=\"Checkbox\" md-no-ink>\n{{doc.name}} - {{statutDocs[doc.status]}} ({{doc.uploadDate | date: \'dd.MM.yyyy\'}})</md-checkbox><a \nclass=\"nl-accordion-body-item-link\" ng-click=\"openDetails(doc)\">Aperçu</a><div class=\"mt-10\" ng-show=\"doc.checked\">\n<md-input-container class=\"nl-Input-container\" flex=\"100\"><input ng-model=\"doc.comment\" class=\"nl-Input-input\" \ntype=\"text\" placeholder=\"\"></md-input-container></div></div><div class=\"nl-accordion-body-item\" \nng-if=\"categories.documents.elements.length === 0\">Pas de documents à afficher</div><a \nng-click=\"loadMore(\'documents\')\" ng-if=\"!categories.documents.allLoaded\">Charger plus...</a></div></div><div \nclass=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'tasks\', true)\"><md-checkbox class=\"nl-Checkbox\" \nng-click=\"selectAllElement(\'tasks\'); $event.stopPropagation();\" ng-model=\"categories.tasks.checked\" \naria-label=\"Checkbox\" md-no-ink></md-checkbox>Tâches et évenements planifiés<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.tasks.show\"><div class=\"nl-accordion-body-item\" ng-repeat=\"task in categories.tasks.elements\">\n<md-checkbox class=\"nl-Checkbox\" ng-change=\"eltChecked(\'tasks\')\" ng-model=\"task.checked\" aria-label=\"Checkbox\" \nmd-no-ink>{{task.title}} - {{recurrencesGeneralTasks[task.recurrence]}} ({{task.echeance | date: \'dd.MM.yyyy\'}})\n</md-checkbox><a class=\"nl-accordion-body-item-link\" ng-click=\"openDetails(task)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"task.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input ng-model=\"task.comment\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div class=\"nl-accordion-body-item\" \nng-if=\"categories.tasks.elements.length === 0\">Pas de taĉhes/évenements à afficher</div><a \nng-click=\"loadMore(\'tasks\')\" ng-if=\"!categories.tasks.allLoaded\">Charger plus...</a></div></div><div \nclass=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'actions\', true)\"><md-checkbox \nclass=\"nl-Checkbox\" ng-click=\"selectAllElement(\'actions\'); $event.stopPropagation();\" \nng-model=\"categories.actions.checked\" aria-label=\"Checkbox\" md-no-ink></md-checkbox>Dernières actions décidées<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.actions.show\"><div class=\"nl-accordion-body-item\" ng-repeat=\"task in categories.actions.elements\">\n<md-checkbox class=\"nl-Checkbox\" ng-change=\"eltChecked(\'actions\')\" ng-model=\"task.checked\" aria-label=\"Checkbox\" \nmd-no-ink>{{task.title}} - {{recurrencesGeneralTasks[task.recurrence]}} ({{task.echeance | date: \'dd.MM.yyyy\'}})\n</md-checkbox><a class=\"nl-accordion-body-item-link\" ng-click=\"openDetails(task)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"task.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input ng-model=\"task.comment\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div class=\"nl-accordion-body-item\" \nng-if=\"categories.actions.elements.length === 0\">Pas de taĉhes/évenements à afficher</div><a \nng-click=\"loadMore(\'actions\')\" ng-if=\"!categories.actions.allLoaded\">Charger plus...</a></div></div><div \nclass=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'indicators\', true)\"><md-checkbox \nclass=\"nl-Checkbox\" ng-click=\"selectAllElement(\'indicators\'); $event.stopPropagation();\" \nng-model=\"categories.indicators.checked\" aria-label=\"Checkbox\" md-no-ink></md-checkbox>Indicateurs du tableau de bord\n<div class=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.indicators.show\"><div class=\"nl-accordion-body-item\" \nng-repeat=\"indicator in categories.indicators.elements\"><md-checkbox class=\"nl-Checkbox\" \nng-change=\"eltChecked(\'indicators\')\" ng-model=\"indicator.checked\" aria-label=\"Checkbox\" md-no-ink>\n{{indicator.title}} - {{indicator.years}}</md-checkbox><a class=\"nl-accordion-body-item-link\" \nng-click=\"openDetails(indicator)\">Aperçu</a><div class=\"mt-10\" ng-show=\"indicator.checked\"><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><input ng-model=\"indicator.comment\" class=\"nl-Input-input\" type=\"text\" \nplaceholder=\"\"></md-input-container></div></div><div class=\"nl-accordion-body-item\" \nng-if=\"categories.indicators.elements.length === 0\">Pas d\'indicateurs à afficher</div><a \nng-click=\"loadMore(\'indicators\')\" ng-if=\"!categories.indicators.allLoaded\">Charger plus...</a></div></div><div \nclass=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'evaluations\', true)\"><md-checkbox \nclass=\"nl-Checkbox\" ng-click=\"selectAllElement(\'evaluations\'); $event.stopPropagation();\" \nng-model=\"categories.evaluations.checked\" aria-label=\"Checkbox\" md-no-ink></md-checkbox>Auto-évaluations<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.evaluations.show\"><div class=\"nl-accordion-body-item\" \nng-repeat=\"evaluation in categories.evaluations.elements\"><md-checkbox class=\"nl-Checkbox\" \nng-change=\"eltChecked(\'evaluations\')\" ng-model=\"evaluation.checked\" aria-label=\"Checkbox\" md-no-ink>\n{{evaluation.name}} ({{evaluation.uploadDate | date: \'dd.MM.yyyy\'}})</md-checkbox><a \nclass=\"nl-accordion-body-item-link\" ng-click=\"openDetails(evaluation)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"evaluation.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input \nng-model=\"evaluation.comment\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div \nclass=\"nl-accordion-body-item\" ng-if=\"categories.evaluations.elements.length === 0\">Pas d\'auto-évaluations à afficher\n</div><a ng-click=\"loadMore(\'evaluations\')\" ng-if=\"!categories.evaluations.allLoaded\">Charger plus...</a></div></div>\n<div class=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'reports\', true)\"><md-checkbox \nclass=\"nl-Checkbox\" ng-click=\"selectAllElement(\'reports\'); $event.stopPropagation();\" \nng-model=\"categories.reports.checked\" aria-label=\"Checkbox\" md-no-ink></md-checkbox>Rapports d\'audit<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.reports.show\"><div class=\"nl-accordion-body-item\" ng-repeat=\"report in categories.reports.elements\">\n<md-checkbox class=\"nl-Checkbox\" ng-change=\"eltChecked(\'reports\')\" ng-model=\"report.checked\" aria-label=\"Checkbox\" \nmd-no-ink>{{report.auditName}} ({{report.uploadDate | date: \'dd.MM.yyyy\'}})</md-checkbox><a \nclass=\"nl-accordion-body-item-link\" ng-click=\"openDetails(report)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"report.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input ng-model=\"report.comment\" \nclass=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div class=\"nl-accordion-body-item\" \nng-if=\"categories.reports.elements.length === 0\">Pas d\'auto-évaluations à afficher</div><a \nng-click=\"loadMore(\'reports\')\" ng-if=\"!categories.reports.allLoaded\">Charger plus...</a></div></div><div \nclass=\"nl-accordion\"><div class=\"nl-accordion-header\" ng-click=\"show(\'satisfaction\', true)\"><md-checkbox \nclass=\"nl-Checkbox\" ng-click=\"selectAllElement(\'satisfaction\'); $event.stopPropagation();\" \nng-model=\"categories.satisfaction.checked\" aria-label=\"Checkbox\" md-no-ink></md-checkbox>Satisfaction client<div \nclass=\"nl-accordion-header-icon icon-chevron-down\"></div></div><div class=\"nl-accordion-body\" \nng-if=\"categories.satisfaction.show\"><div class=\"nl-accordion-body-item\" \nng-repeat=\"satisfaction in categories.satisfaction.elements\"><md-checkbox class=\"nl-Checkbox\" \nng-change=\"eltChecked(\'satisfaction\')\" ng-model=\"satisfaction.checked\" aria-label=\"Checkbox\" md-no-ink>\n{{satisfaction.name}} ({{satisfaction.uploadDate | date: \'dd.MM.yyyy\'}})</md-checkbox><a \nclass=\"nl-accordion-body-item-link\" ng-click=\"openDetails(satisfaction)\">Aperçu</a><div class=\"mt-10\" \nng-show=\"satisfaction.checked\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><input \nng-model=\"satisfaction.comment\" class=\"nl-Input-input\" type=\"text\" placeholder=\"\"></md-input-container></div></div><div\n class=\"nl-accordion-body-item\" ng-if=\"categories.satisfaction.elements.length === 0\">\nPas de rapport de satisfaction client à afficher</div><a ng-click=\"loadMore(\'satisfaction\')\" \nng-if=\"!categories.satisfaction.allLoaded\">Charger plus...</a></div></div><h2 class=\"nl-H2\">Autres</h2><div \nclass=\"nl-Input-container\" flex=\"100\"><label class=\"nl-Input-label md-no-float md-container-ignore\"></label>\n<ng-quill-editor ng-model=\"otherComment\"></ng-quill-editor></div></div><div class=\"nl-Btn-wrapper--right mt-40\"><button\n type=\"button\" ng-click=\"addMalfunctionForm.$valid && sendAndGoPreview()\" class=\"nl-Btn nl-Btn--outline\" \naria-label=\"Annuler\">Prévisualiser puis envoyer</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn\" \naria-label=\"Sauvegarder\">Enregistrer</button></div></div></form></div></section>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/display-note-interne.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">\nNewsletter numéro #{{note.num}} du {{note.creationDate | date:\'dd/MM/yyyy\'}}</h1><button ng-click=\"goBack()\" \nclass=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span class=\"nl-H1-backBtn-text\">\nRetour à la liste des newsletter</span></button><div class=\"mt-45\" layout=\"row\" layout-align=\"end center\"><button \ntype=\"button\" class=\"nl-Btn\" ng-click=\"openPopupMail()\">Envoyer par email</button> <button type=\"button\" \nclass=\"nl-Btn ml-20\" ng-click=\"generateDoc(note.id)\">Imprimer</button></div><div \nng-if=\"categories.malfunctions.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">Dysfonctionnements</h2><div \nclass=\"nl-apercu-item\" flex=\"100\" ng-repeat=\"elt in categories.malfunctions.elements | orderBy: \'malfunction.title\'\">\n<div class=\"nl-apercu-item-title\">{{elt.malfunction.title}}</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\">{{elt.comment}}</div></div></div><div ng-if=\"categories.documents.elements.length > 0\"><h2 \nclass=\"nl-H2\" flex=\"80\">Documents ajoutés</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.documents.elements | orderBy: \'document.name\'\"><div class=\"nl-apercu-item-title\">\n{{elt.document.name}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">{{elt.comment}}\n</div></div></div><div ng-if=\"categories.tasks.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nTâches et évenements planifiés</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.tasks.elements | orderBy: \'tacheGenerale.title\'\"><div class=\"nl-apercu-item-title\">\n{{elt.tacheGenerale.title}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">\n{{elt.comment}}</div></div></div><div ng-if=\"categories.actions.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nDernières actions décidées</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.actions.elements | orderBy: \'action.title\'\"><div class=\"nl-apercu-item-title\">\n{{elt.action.title}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">{{elt.comment}}\n</div></div></div><div ng-if=\"categories.indicators.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nIndicateurs du tableau de bord</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.indicators.elements | orderBy: \'indicateur.title\'\"><div class=\"nl-apercu-item-title\">\n{{elt.indicateur.title}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">\n{{elt.comment}}</div></div></div><div ng-if=\"categories.evaluations.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nAuto-évaluations</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.evaluations.elements | orderBy: \'autoEvaluation.name\'\"><div class=\"nl-apercu-item-title\">\n{{elt.autoEvaluation.name}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">\n{{elt.comment}}</div></div></div><div ng-if=\"categories.audit.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nRapports d\'audit</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.audit.elements | orderBy: \'audit.auditName\'\"><div class=\"nl-apercu-item-title\">\n{{elt.audit.auditName}}</div><div class=\"nl-apercu-item-separator\"></div><div class=\"nl-apercu-item-text\">\n{{elt.comment}}</div></div></div><div ng-if=\"categories.satisfaction.elements.length > 0\"><h2 class=\"nl-H2\" flex=\"80\">\nSatisfaction client</h2><div class=\"nl-apercu-item\" flex=\"100\" \nng-repeat=\"elt in categories.satisfaction.elements | orderBy: \'satisfactionClient.name\'\"><div \nclass=\"nl-apercu-item-title\">{{elt.satisfactionClient.name}}</div><div class=\"nl-apercu-item-separator\"></div><div \nclass=\"nl-apercu-item-text\">{{elt.comment}}</div></div></div><div ng-if=\"otherComment.length > 0\"><h2 class=\"nl-H2\" \nflex=\"80\">Autre commentaire</h2><div class=\"nl-apercu-item\" flex=\"100\"><div class=\"nl-apercu-item-text\" \nng-bind-html=\"otherComment[0].comment\"></div></div></div></div></section>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/notes-internes.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Note internes</h1><button \nng-click=\"goCommunicationInterne()\" class=\"nl-H1-backBtn\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Communication interne</span></button><div class=\"mt-20\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"goAddNote()\" permission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><button \nclass=\"nl-Btn\">Créer une note</button></div><div class=\"mt-25\"><div class=\"nl-list\"><div class=\"nl-list-item\" \nlayout=\"row\" layout-align=\"space-between center\" ng-repeat=\"note in notesInternes\"><div class=\"flex\" \nng-click=\"update(note)\"><div class=\"text-truncate nl-list-item-title\">Newsletter numéro #{{note.num}}</div><div \nclass=\"nl-list-item-description\"><span ng-if=\"note.sendDate\">Envoi: {{note.sendDate | date:\'dd/MM/yyyy\'}} </span><span \nng-if=\"!note.sendDate\">Brouillon </span>- Création: {{note.creationDate | date:\'dd/MM/yyyy\'}}</div></div><md-menu \nclass=\"nl-Menu mr-20\" md-menu-origin nl-menu-class=\"nl-Menu-dropdown\" md-offset=\"-3 0\"><button aria-label=\"\" \nclass=\"nl-Menu-btn\" ng-click=\"$mdMenu.open($event)\"><span class=\"nl-Menu-btn-title\">Actions</span><md-icon \nclass=\"nl-Menu-btn-svg\" md-svg-src=\"./assets/icons/app/filtres/icon_chevron_equipe.svg\"></md-icon></button>\n<md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"display(note)\">Voir</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"update(note)\">Modifier</md-button></md-menu-item><md-menu-item \npermission=\"[permissions.TITULAIRE, permissions.PRAQ]\"><md-button ng-click=\"displayPopUpDelete(note)\">Supprimer\n</md-button></md-menu-item></md-menu-content></md-menu></div><div></div></div></div></div></section>");
$templateCache.put("app/main/front/qualite/demarche/selectionTasks/selectionTasks.html","<section class=\"nl-Page\"><div class=\"nl-Content\"><h1 class=\"nl-H1\">Sélectionner 3 tâches</h1><button \nclass=\"nl-H1-backBtn\" ng-click=\"goBack()\"><i class=\"nl-H1-backBtn-icon icon-chevron-left\"></i> <span \nclass=\"nl-H1-backBtn-text\">Retour en arrière</span></button><h2 class=\"nl-H2\">Tâches annuelles</h2><div \nclass=\"nl-accordion mt-20\" ng-repeat=\"categorie in TASKS_CATEGORIES_QUALITY\"><div class=\"nl-accordion-header\" \nng-click=\"categorie.show = !categorie.show\">{{categorie.name}}<div \nclass=\"nl-accordion-header-icon {{categorie.show ? \'icon-chevron-up\': \'icon-chevron-down\'}}\"></div></div><div \nclass=\"nl-accordion-body\" ng-if=\"categorie.show == true\"><div ng-click=\"selectTask(task)\" \nclass=\"nl-accordion-body-item\" ng-repeat=\"task in tasksNotDone | filter: { category: categorie.value }\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><md-checkbox \nng-disabled=\"!task.selected && isLimitNbrSelectedReached()\" ng-model=\"task.selected\" class=\"nl-Checkbox\" \naria-label=\"Checkbox\" md-no-ink></md-checkbox><div layout=\"column\" class=\"nl-Checkbox\"><div \nclass=\"nl-accordion-header md-label\" \nng-click=\"(task.selected || !isLimitNbrSelectedReached()) ? task.selected = !task.selected: null\">{{task.title}}</div>\n</div></div></div></div></div></div><button ng-click=\"select()\" class=\"nl-Btn ml-10\">Valider</button></div></section>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/front/controle/trace/subtraces/popup/add_subtrace.html","<md-dialog class=\"iv-Dialog\" flex=\"30\" flex-md=\"30\" flex-sm=\"50\" flex-xs=\"100\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\n{{subtraceToAdd.id ? \'Compléter / Modifier\' : \'Nouvel enregistrement\'}}</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><form name=\"columnForm\" novalidate \nng-submit=\"columnForm.$valid && saveNewSubTrace()\"><md-dialog-content><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><md-input-container class=\"iv-Input-container no--errors-spacer\" flex=\"35\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">Date <span class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\"><md-icon ng-click=\"subtraceToAdd.isOpen = true\" class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" \nmd-is-open=\"subtraceToAdd.isOpen\" md-hide-icons=\"all\" name=\"date\" md-open-on-focus ng-model=\"subtraceToAdd.date\" \nrequired></md-datepicker></div></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer pl-10\" flex=\"65\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">\n{{subtraceToAdd.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\'}} <span class=\"asterix\">*</span>\n</label><md-select md-no-asterisk ng-model=\"subtraceToAdd.reporter.id\" required name=\"collaborateur\" \nclass=\"iv-Input-select md-no-underline\" ng-change=\"changeCollab(subtraceToAdd.reporter.id, true)\" \nmd-container-class=\"iv-Select-dropdown\"><md-option class=\"iv-Select-dropdown-btn\" \nng-repeat=\"collaborateur in collaborateurs track by collaborateur.id\" ng-value=\"collaborateur.id\">\n{{collaborateur.surname + \' \' + collaborateur.name}}</md-option><md-option class=\"iv-Select-dropdown-btn\" ng-value=\"0\">\n+ Ajouter un nouveau collaborateur</md-option></md-select></md-input-container><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\" ng-repeat=\"param in subtraceToAdd.parameters\"><label \nclass=\"iv-Input-label md-no-float md-container-ignore\">{{param.name}} <span class=\"asterix\" ng-if=\"param.required\">*\n</span></label><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Checkbox--specialWrapper\"><input \nflex=\"auto\" ng-if=\"param.type === \'TEXT\'\" class=\"iv-Input-input\" type=\"text\" name=\"{{$index}}\" ng-model=\"param.value\" \nng-required=\"param.required\"><div class=\"iv-Input-date-wrapper\" ng-if=\"param.type === \'DATE\'\" flex=\"auto\"><md-icon \nng-click=\"param.isOpen = true\" class=\"iv-Input-date-icon\" md-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon>\n<md-datepicker class=\"iv-Input-date\" md-is-open=\"param.isOpen\" md-hide-icons=\"all\" name=\"{{$index}}\" md-open-on-focus \nng-model=\"param.value\" ng-required=\"param.required\"></md-datepicker></div><md-checkbox ng-true-value=\"\'true\'\" \nng-false-value=\"\'false\'\" ng-if=\"param.type === \'SUIVI\'\" name=\"{{$index}}\" flex=\"auto\" ng-model=\"param.value\" \nclass=\"nl-Checkbox-trac iv-Checkbox mt-5\"></md-checkbox><md-select md-no-asterisk flex=\"auto\" \nclass=\"iv-Input-select md-no-underline\" ng-if=\"param.type === \'LIST\'\" name=\"{{$index}}\" ng-model=\"param.value\" \nng-required=\"param.required\"><md-option ng-repeat=\"option in param.options track by $index\" ng-value=\"option.name\" \nng-disabled=\"option.removed\">{{option.name}}<span ng-if=\"option.removed\"> (option supprimée)</span></md-option>\n</md-select><md-select md-no-asterisk flex=\"auto\" class=\"iv-Input-select md-no-underline\" \nng-if=\"param.type === \'COLLABORATEUR\'\" name=\"{{$index}}\" ng-model=\"param.collaborateurId\" ng-required=\"param.required\">\n<md-option ng-repeat=\"option in param.collaborateurOptions track by option.id\" ng-value=\"option.id\" \nng-disabled=\"option.removed\">{{option.label}}<span ng-if=\"option.removed\"> (collaborateur supprimé)</span></md-option>\n</md-select></div></div><div ng-messages=\"columnForm[$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise</span></div></div></md-input-container><div class=\"ml-5 mr-5 flex-100 layout-row\" \nng-if=\"subtraceToAdd.documents == null||subtraceToAdd.documents.length < 3\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\"><label class=\"iv-Input-label md-no-float md-container-ignore\">ㅤ</label>\n<button class=\"iv-Btn iv-Btn--file\" type=\"button\" ng-click=\"openJoindreFile()\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\"><div class=\"iv-Btn__file\"></div><md-icon class=\"m-0\" \nmd-svg-src=\"assets/icons/app/V3/joindre_dark.svg\"></md-icon><div>Ajouter une pièce jointe</div></button>\n</md-input-container><input type=\"file\" id=\"add_file\" ng-hide=\"true\"></div><div \nclass=\"ml-5 mr-5 flex-100 layout-row mt-10\" ng-repeat=\"document in subtraceToAdd.documents\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"iv-Btn iv-Btn--file\" ng-if=\"document.attachmentOriginalName != null\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\" ng-click=\"downloadDoc(document.id)\"><md-icon \nng-if=\"document.id\" md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.attachmentOriginalName}}\n</div></div><button type=\"button\" class=\"iv-BtnIcon--file\" ng-click=\"deleteDocument($index);\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></button></div></div></div></md-dialog-content><md-dialog-actions>\n<button class=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" style=\"position: absolute; left:40px\" type=\"button\" \nng-click=\"closeModal()\">Annuler</button> <button ng-if=\"subtraceToAdd.id\" \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" type=\"button\" ng-click=\"openToInformation()\">Partager</button> \n<button class=\"nl-Btn ml-10 nl-Btn--trac\" type=\"submit\" ng-disabled=\"columnForm.$invalid || loadingAdd\">\n<md-progress-circular md-diameter=\"15px\" ng-if=\"loadingAdd\" class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular><span ng-if=\"!loadingAdd\">Enregistrer</span></button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/controle/trace/subtraces/popup/confirm_delete_dialog.html","<md-dialog aria-label=\"Suppression\" flex=\"30\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"80\"><md-toolbar layout=\"column\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"mt-20\"><div style=\"padding-left:15px\">Suppression</div></div><md-button class=\"md-icon-button\" \nng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><span>Êtes-vous sûr de vouloir supprimer cette traçabilité ?</span></md-dialog-content>\n<md-dialog-actions layout=\"row\"><button class=\"nl-Btn nl-Btn--outline\" ng-click=\"closeModal()\">Annuler</button> <button\n class=\"nl-Btn ml-10\" ng-click=\"delete(subtraceToDelete)\">Supprimer</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/controle/trace/subtraces/popup/export.html","<md-dialog class=\"iv-Dialog\" aria-label=\"dysfonctionnements\" flex=\"30\" flex-md=\"50\" flex-sm=\"60\" flex-xs=\"100\" \nstyle=\"overflow: hidden\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Exporter</div></div><md-button class=\"md-icon-button iv-popup__close\" \nng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon>\n</md-button></div></md-toolbar><form name=\"exportForm\" novalidate ng-submit=\"exportForm.$valid && exportTrace()\">\n<md-dialog-content><div class=\"iv-Dialog__text\">\nVeuillez sélectionner une plage de dates correspondante aux données que vous souhaitez exporter</div><div class=\"mt-5\" \nlayout=\"row\" layou-align=\"space-between start\"><div class=\"pl-5 pr-5 flex-50 layout-row\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nDate de début <span ng-if=\"exportDates.startDate == null\" class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\" ng-click=\"isOpen = !isOpen\"><md-icon class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" md-is-open=\"isOpen\" \nmd-hide-icons=\"all\" name=\"dateStart\" ng-model=\"exportDates.startDate\" md-open-on-focus required></md-datepicker></div>\n<div ng-messages=\"exportForm.dateStart.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container></div><div class=\"pl-5 pr-5 flex-50 layout-row\"><md-input-container \nclass=\"iv-Input-container no--errors-spacer\" flex=\"100\"><label class=\"iv-Input-label md-no-float md-container-ignore\">\nDate de fin <span ng-if=\"exportDates.endDate == null\" class=\"asterix\">*</span></label><div \nclass=\"iv-Input-date-wrapper\" ng-click=\"isOpen2 = !isOpen2\"><md-icon class=\"iv-Input-date-icon\" \nmd-svg-src=\"assets/icons/app/V3/calendar.svg\"></md-icon><md-datepicker class=\"iv-Input-date\" md-is-open=\"isOpen2\" \nmd-hide-icons=\"all\" name=\"dateEnd\" ng-model=\"exportDates.endDate\" md-open-on-focus required></md-datepicker></div><div \nng-messages=\"exportForm.dateEnd.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span></div>\n</div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" type=\"button\" ng-click=\"closeModal()\">Annuler</button> <button \nclass=\"nl-Btn ml-10 nl-Btn--trac\" type=\"submit\">Exporter</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/controle/trace/subtraces/popup/subtrace_history.html","<md-dialog flex=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xs=\"90\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div\n flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Historique</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"closeModal()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-35\">\n<div ng-if=\"subtraceHistories == null || subtraceHistories.length === 0\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div flex=\"30\"><label class=\"nl-Input-label nl-Label-trace\">Date</label>\n<span ng-class=\"{\'nl-dialogSectionValue__modified\' : subtraceToShow.dateModified}\" class=\"nl-dialogSectionValue\">\n{{getDateString(subtraceToShow.date)}}</span></div><div flex=\"65\"><label class=\"nl-Input-label nl-Label-trace\">\n{{trace.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\'}}</label><span \nclass=\"nl-dialogSectionValue\" ng-class=\"{\'nl-dialogSectionValue__modified\' : subtraceToShow.reporterModified}\">\n{{subtraceToShow.reporter.completeName}}</span></div></div><div class=\"pt-40\" flex=\"100\"><div flex=\"100\" class=\"pb-40\" \nng-repeat=\"param in subtraceToShow.parameters\"><label class=\"nl-Input-label nl-Label-trace\">{{param.name}}</label><span\n class=\"nl-dialogSectionValue\" ng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" \nng-if=\"param.type === \'TEXT\' || param.type === \'LIST\' || param.type === \'COLLABORATEUR\'\">{{param.value}}</span> <span \nclass=\"nl-dialogSectionValue\" ng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" \nng-if=\"param.type === \'DATE\'\">{{param.value | date: \'dd/MM/yyyy\'}}</span> <span class=\"nl-dialogSectionValue\" \nng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" ng-if=\"param.type === \'SUIVI\'\">\n{{param.value === \'true\' ? \'Oui\':\'Non\'}}</span></div><div class=\"ml-5 mr-5 flex-100 layout-row mt-10\" \nng-repeat=\"document in subtraceToShow.documents\"><label class=\"iv-Input-label md-no-float md-container-ignore\">ㅤ\n</label><div layout=\"row\" layout-align=\"start center\"><div class=\"iv-Btn iv-Btn--file\" \nng-if=\"document.attachmentOriginalName != null\" style=\"width: 100%; justify-content: flex-start; border: 0\" \nng-click=\"downloadDoc(document.id)\"><md-icon md-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>\n{{ document.attachmentOriginalName}}</div></div></div></div></div></div><div layout=\"row\" \nng-repeat=\"subtraceHistory in subtraceHistories\" layout-wrap><h2 class=\"nl-dialogSectionTitle\" \nng-class=\"{\'first-title\': $index === 0}\">\n{{$last ? \'Enregistrement du \' : \'Modifié le \'}} {{subtraceHistory.creation | date: \"dd/MM/yyyy à HH\'h\'mm\"}}</h2><div \nlayout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div flex=\"30\" class=\"iv-dialogSectionValue pb-8 mb-10\">\n<label class=\"iv-Input-label\">Date</label><span class=\"nl-dialogSectionValue__text\" \nng-class=\"{\'nl-dialogSectionValue__modified\' : subtraceHistory.dateModified}\">{{getDateString(subtraceHistory.date)}}\n</span></div><div flex=\"65\" class=\"iv-dialogSectionValue pb-8 mb-10\"><label class=\"iv-Input-label\">\n{{trace.templateType === \'FICHE_PREPARATION\' ? \'Préparateur\' : \'Rapporteur\'}}</label><span \nclass=\"nl-dialogSectionValue__text\" ng-class=\"{\'nl-dialogSectionValue__modified\' : subtraceHistory.reporterModified}\">\n{{subtraceHistory.reporter.completeName}}</span></div></div><div flex=\"100\"><div flex=\"100\" \nclass=\"iv-dialogSectionValue pb-8 mb-10\" ng-repeat=\"param in subtraceHistory.parameters\"><label class=\"iv-Input-label\">\n{{param.name}}</label><span class=\"iv-dialogSectionValue__text\" \nng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" \nng-if=\"param.type === \'TEXT\' || param.type === \'LIST\' || param.type === \'COLLABORATEUR\'\">{{param.value}}</span> <span \nclass=\"nl-dialogSectionValue\" ng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" \nng-if=\"param.type === \'DATE\'\">{{param.value | date: \'dd/MM/yyyy\'}}</span> <span class=\"nl-dialogSectionValue__text\" \nng-class=\"{\'nl-dialogSectionValue__modified\' : param.modified}\" ng-if=\"param.type === \'SUIVI\'\">\n{{param.value === \'true\' ? \'Oui\':\'Non\'}}</span></div><div class=\"ml-5 mr-5 flex-100 layout-row mt-10\" \nng-repeat=\"document in subtraceHistory.documents\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"iv-Btn iv-Btn--file\" ng-if=\"document.attachmentOriginalName != null\" \nstyle=\"width: 100%; justify-content: flex-start; border: 0\" ng-click=\"downloadDoc(document.id)\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/download.svg\"></md-icon><div>{{ document.attachmentOriginalName}}</div></div></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn nl-Btn--outline nl-Btn--outline--trac\" ng-if=\"subtraceToShowIndex\" \nng-click=\"setToModif(subtraceToShow, subtraceToShowIndex)\">Modifier</button> <button class=\"nl-Btn ml-10 nl-Btn--trac\" \nng-click=\"closeModal()\">Fermer</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/compte-rendu/popup/to_information_popup.html","<md-dialog aria-label=\"cahier de transmission\" flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"toInformation()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\">\n<div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Transmettre le compte-rendu de réunion</div></div><md-button\n class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-Dialog__text\">\nSouhaitez-vous transmettre le compte-rendu de votre réunion sur le cahier de transmission ?</div></md-dialog-content>\n<md-dialog-actions class=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup();\">Non</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Oui</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/apercu_indicateur_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"60\" flex-md=\"70\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Aperçu de l\'indicateur qualité</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"nl-Indicator__item nl-Indicator__item--featured\"><div class=\"nl-Indicator__header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nl-indicator-header-title\" layout=\"row\" layout-align=\"start center\">\n<div class=\"nl-Indicator__title\">{{indicateur.title}} <span ng-if=\"indicateur.format\">( {{indicateur.format}} )</span>\n</div></div><div class=\"nl-Indicator__toolbarInfos flex-noshrink\"><div \nng-if=\"periods[indicateur.period] === \'mensuel\'\">Fréquence mensuelle</div><div \nng-if=\"periods[indicateur.period] === \'trimestriel\'\">Fréquence trimestrielle</div><div \nng-if=\"periods[indicateur.period] === \'annuel\'\">Fréquence annuelle</div></div></div><div \nclass=\"nl-Indicator__monthWrapper\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"nl-indicator-body-legende\" ng-if=\"periods[indicateur.period] === \'annuel\'\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div flex=\"100\" class=\"nl-Indicator__month__title\">\n{{indicateur.dataIndicateurs[0].year}}</div></div><div class=\"nl-indicator-body-legende nl-legende--mensuel\" \nng-if=\"periods[indicateur.period] === \'mensuel\'\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\">\n<div class=\"nl-Indicator__month__title\">jan.</div><div class=\"nl-Indicator__month__title\">fév.</div><div \nclass=\"nl-Indicator__month__title\">mar.</div><div class=\"nl-Indicator__month__title\">avr.</div><div \nclass=\"nl-Indicator__month__title\">mai.</div><div class=\"nl-Indicator__month__title\">jui.</div><div \nclass=\"nl-Indicator__month__title\">juil.</div><div class=\"nl-Indicator__month__title\">aoû.</div><div \nclass=\"nl-Indicator__month__title\">sep.</div><div class=\"nl-Indicator__month__title\">oct.</div><div \nclass=\"nl-Indicator__month__title\">nov.</div><div class=\"nl-Indicator__month__title\">dec.</div></div><div \nclass=\"nl-indicator-body-legende nl-legende--trimestriel\" ng-if=\"periods[indicateur.period] === \'trimestriel\'\" \nlayout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\"><div flex=\"25\" class=\"nl-Indicator__month__title\">\n1er Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">2eme Trimestre</div><div flex=\"25\" \nclass=\"nl-Indicator__month__title\">3eme Trimestre</div><div flex=\"25\" class=\"nl-Indicator__month__title\">4eme Trimestre\n</div></div></div><div class=\"nl-Indicator__Body\"><div layout=\"row\" layout-align=\"space-between center\"><div \nng-repeat=\"data in indicateur.dataIndicateurs | orderBy: \'index\'\" class=\"nl-Indicator__month__item flex\"><div><input \ndisabled=\"disabled\" ng-model=\"data.value\" \nng-class=\"{\n                            \'nl-Indicator__month__input--weather\': checkWeatherClass(indicateur, data),\n                            \'nl-Text--red\': checkGoalOK(data, indicateur) === false,\n                            \'nl-Text--green\': checkGoalOK(data, indicateur),\n                            \'nl-indicator--today\': isToday(data, periods[indicateur.period])}\" \nclass=\"nl-Indicator__month__input\"></div></div></div></div><div class=\"nl-Indicator__item__infos\"><span \nng-if=\"indicateur.goal != null\">Objectif : {{printNumber(indicateur.goal)}}{{indicateur.format}} </span><span \nng-if=\"periods[indicateur.period] !== \'annuel\'\">Moyenne : {{average(indicateur.dataIndicateurs)}}{{indicateur.format}}\n</span></div></div></div></md-dialog-content><md-dialog-actions><button type=\"button\" class=\"nl-Btn\" \nng-click=\"hidePopup()\">Fermer</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/confirm_odj.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"_redigerCompteRendu()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nPasser à l\'étape suivante</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\">\nVotre réunion est en cours ou a déjà eu lieu ?<br>\nVous allez maintenant être redirigé vers la rédaction de son compte-rendu. Êtes-vous sûr de vouloir continuer ?</div>\n</md-dialog-content><md-dialog-actions class=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup();_saveOrdreDuJour(true);\">Non, enregistrer</button> <button \nng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Oui</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/joindreMesEval_popup.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Sélectionner des évaluations</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos évaluations</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-click=\"apercu(eval)\" \nng-repeat=\"eval in dto.results track by $index\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-click=\"$event.stopPropagation();\" ng-change=\"checkSelected(eval)\" \nng-model=\"eval.selected\" class=\"iv-Checkbox\"></md-checkbox><div class=\"iv-ListBloc__item__title\">{{eval.name}}</div>\n<div class=\"iv-ListBloc__item__subtitle\">\n{{eval.typeLibelle}}{{eval.date ? \' • \' : \'\'}} {{eval.date | date: \'dd/MM/yyyy\'}}</div></div></div></div></div></div>\n<div class=\"iv-ListBloc__footer\"><div></div><div class=\"iv-ListBloc__pagination\"><button \nng-if=\"pagination.page + 1 > 1\" type=\"button\" ng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Previous\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nclass=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}}/{{nbPages()}}</div><button \nng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" ng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div>\n</md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Joindre\n</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_document.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Sélectionner un fichier de la base documentaire</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-SearchBar\"><md-input-container \nclass=\"iv-SearchBar--input\" flex=\"100\"><label></label><input placeholder=\"Rechercher...\" type=\"text\" name=\"search\" \nng-model=\"testInput\"></md-input-container><md-icon class=\"iv-SearchBar--icon\" \nmd-svg-src=\"assets/icons/app/V3/search.svg\"></md-icon></div></div><div class=\"iv-ListBloc__inner mt-20\"><div \nclass=\"iv-ListBloc__item iv-ListBloc__item--SB\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><md-icon class=\"iv-ListBloc__item__icon\" \nmd-svg-src=\"assets/icons/app/V3/document.svg\"></md-icon><div class=\"iv-ListBloc__item__title\">\nListe-des-pharmacie-associées.docx</div></div><div class=\"iv-ListBloc__item__subtitle\">21/06/21 10:34</div></div><div \nclass=\"iv-ListBloc__item iv-ListBloc__item--SB\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><md-icon class=\"iv-ListBloc__item__icon\" \nmd-svg-src=\"assets/icons/app/V3/document.svg\"></md-icon><div class=\"iv-ListBloc__item__title\">\nListe-des-pharmacie-associées-responsable.docx</div></div><div class=\"iv-ListBloc__item__subtitle\">21/06/21 10:34</div>\n</div></div></md-dialog-content><md-dialog-actions class=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" \nclass=\"nl-Btn ml-10\">Sélectionner</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_dysfonctionnement.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Sélectionner des dysfonctionnements</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos dysfonctionnements</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">How Is Leukemia Treated</div><div class=\"iv-ListBloc__item__subtitle\">\nThibaut T. / 05.11.2021</div></div></div></div><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">How Is Leukemia Treated</div><div class=\"iv-ListBloc__item__subtitle\">\nThibaut T. / 05.11.2021</div></div></div></div></div></div><div class=\"iv-ListBloc__footer\"><div></div><div \nclass=\"iv-ListBloc__pagination\"><div class=\"iv-ListBloc__pagination__title\">Page 1/5</div><button \nclass=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\">\n</md-icon></button></div></div></md-dialog-content><md-dialog-actions class=\"pr-25 pb-30\"><button \nng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Annuler</button> <button \nng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">Sélectionner</button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_evaluation.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Sélectionner des évaluations</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos évaluations</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">Audit trimestriel</div><div class=\"iv-ListBloc__item__subtitle\">Audit 23/02/2021</div>\n</div></div></div><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">Retour suite visite mystère</div><div class=\"iv-ListBloc__item__subtitle\">\nClient mystère 23/02/2021</div></div></div></div></div></div><div class=\"iv-ListBloc__footer\"><div></div><div \nclass=\"iv-ListBloc__pagination\"><button class=\"iv-ListBloc__pagination__btn\" aria-label=\"Previous\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div class=\"iv-ListBloc__pagination__title\">page 2/5\n</div><button class=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div></md-dialog-content><md-dialog-actions \nclass=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">\nSélectionner</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_ficheDeProgres.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"iv-Dialog__title\">Sélectionner des fiches de progrès</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos fiches de progrès</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">How Is Leukemia Treated</div><div class=\"iv-ListBloc__item__subtitle\">\nThibaut T. / 05.11.2021</div></div></div></div><div class=\"iv-ListBloc__item\"><div class=\"iv-ListBloc__item__inner\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-model=\"test\" class=\"iv-Checkbox\"></md-checkbox><div \nclass=\"iv-ListBloc__item__title\">How Is Leukemia Treated</div><div class=\"iv-ListBloc__item__subtitle\">\nThibaut T. / 05.11.2021</div></div></div></div></div></div><div class=\"iv-ListBloc__footer\"><div></div><div \nclass=\"iv-ListBloc__pagination\"><button class=\"iv-ListBloc__pagination__btn\" aria-label=\"Previous\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div class=\"iv-ListBloc__pagination__title\">Page 2/5\n</div><button class=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div></md-dialog-content><md-dialog-actions \nclass=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">\nSélectionner</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_tableauDeBord.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Sélectionner des indicateurs qualité</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste de vos indicateurs du tableau de bord</div>\n<div class=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-click=\"apercu(indicateur)\" \nng-repeat=\"indicateur in dto.results track by $index\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-click=\"$event.stopPropagation();\" ng-change=\"checkSelected(indicateur)\" \nng-model=\"indicateur.selected\" class=\"iv-Checkbox\"></md-checkbox><div class=\"iv-ListBloc__item__title\">\n{{indicateur.title}}</div><div class=\"iv-ListBloc__item__subtitle\">{{indicateur.year}}</div></div></div></div></div>\n</div><div class=\"iv-ListBloc__footer\"><div></div><div class=\"iv-ListBloc__pagination\"><button \nng-if=\"pagination.page + 1 > 1\" type=\"button\" ng-click=\"previousPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Previous\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div \nclass=\"iv-ListBloc__pagination__title\">Page {{pagination.page + 1}}/{{nbPages()}}</div><button \nng-if=\"(pagination.page + 1) < nbPages()\" type=\"button\" ng-click=\"nextPage()\" class=\"iv-ListBloc__pagination__btn\" \naria-label=\"Next\"><md-icon md-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div>\n</md-dialog-content><md-dialog-actions class=\"pr-25 pb-30\"><button type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button type=\"submit\" class=\"nl-Btn ml-10\">Sélectionner</button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/select_tachesPlanning.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"40\" flex-md=\"50\" flex-sm=\"80\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"addResults()\"><md-toolbar layout=\"column\" class=\"iv-Dialog__toolbar\"><div \nflex layout=\"row\" layout-align=\"space-between center\"><div class=\"iv-Dialog__title-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"iv-Dialog__title\">Sélectionner des tâches</div></div><md-button \nclass=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"mh-20\" \nms-scroll><div class=\"iv-ListBloc\"><div class=\"iv-ListBloc__title\">Liste des tâches</div><div \nclass=\"iv-ListBloc__inner\"><div class=\"iv-ListBloc__item\" ng-click=\"apercu(task)\" \nng-repeat=\"task in dto.results track by task.id\"><div class=\"iv-ListBloc__item__inner\"><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-click=\"$event.stopPropagation();\" ng-change=\"checkSelected(task)\" \nng-model=\"task.selected\" class=\"iv-Checkbox\"></md-checkbox><div class=\"iv-ListBloc__item__title\">\n{{task.ecor ? \'🌿 \' : \'\'}}{{task.title}}</div><div class=\"iv-ListBloc__item__subtitle\">\n{{task.responsable ? (task.responsable.name + \' \' + task.responsable.surname) + \' • \': \'\'}} {{task.echeance | date: \'dd/MM/yyyy\'}}\n</div></div><div class=\"iv-Tabs-item-list-item-status pl-10\" ng-if=\"task.done\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/check.svg\"></md-icon><div class=\"ml-5\">Réalisée</div></div></div></div></div></div><div\n class=\"iv-ListBloc__footer\"><div><button type=\"button\" ng-click=\"backToToday()\" class=\"iv-ListBloc__link\">\nRevenir à aujourd\'hui</button></div><div class=\"iv-ListBloc__pagination\"><button type=\"button\" \nclass=\"iv-ListBloc__pagination__btn\" aria-label=\"Previous\" ng-click=\"previousPage()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_left.svg\"></md-icon></button><div class=\"iv-ListBloc__pagination__title\">\ndu {{dto.results[0].echeance | date: \'dd/MM/yyyy\'}} au {{dto.results[dto.results.length - 1].echeance | date: \'dd/MM/yyyy\'}}\n</div><button type=\"button\" class=\"iv-ListBloc__pagination__btn\" aria-label=\"Next\" ng-click=\"nextPage()\"><md-icon \nmd-svg-src=\"assets/icons/app/V3/arrow_right.svg\"></md-icon></button></div></div></md-dialog-content><md-dialog-actions \nclass=\"pr-25 pb-30\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Annuler</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">\nSélectionner</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/equipe/reunions/ordre-du-jour/popup/submit_odj.html","<md-dialog aria-label=\"fiche de progrès\" flex=\"35\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"100\"><form \nclass=\"md-inline-form\" novalidate ng-submit=\"_cloturerEtArchiverReunion()\"><md-toolbar layout=\"column\" \nclass=\"iv-Dialog__toolbar\"><div flex layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"iv-Dialog__title-wrapper\" layout=\"column\" layout-align=\"center center\"><div class=\"iv-Dialog__title\">\nValider le compte-rendu</div></div><md-button class=\"md-icon-button iv-popup__close\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-svg-src=\"assets/icons/app/V3/close.svg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"mh-20\" ms-scroll><div class=\"iv-Dialog__text\" ng-if=\"!$root.user.isTeam\">\nVous êtes sur le point de valider le Compte-rendu de votre réunion.<br>\nVous pourrez le retrouver ensuite dans l’onglet « Historique des comptes-rendus ». Êtes-vous certain de vouloir le valider maintenant ?\n</div><div class=\"iv-Dialog__text\" ng-if=\"$root.user.isTeam\">\nLa validation d\'un compte-rendu de réunion doit être effectuée par le compte Titulaire ou Responsable Qualité.<br>\nCliquez sur \"Enregistrer le compte-rendu\" pour sauvegarder votre travail.</div></md-dialog-content><md-dialog-actions \nclass=\"pr-25 pb-30\" ng-if=\"!$root.user.isTeam\"><button ng-disabled=\"submitting\" type=\"button\" \nclass=\"nl-Btn nl-Btn--outline\" ng-click=\"hidePopup()\">Non</button> <button ng-disabled=\"submitting\" type=\"submit\" \nclass=\"nl-Btn ml-10\">Oui, valider</button></md-dialog-actions><md-dialog-actions class=\"pr-25 pb-30\" \nng-if=\"$root.user.isTeam\"><button ng-disabled=\"submitting\" type=\"button\" class=\"nl-Btn nl-Btn--outline\" \nng-click=\"hidePopup()\">Fermer</button> <button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn ml-10\">\nEnregistrer le compte-rendu</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/administration-bandeau/popup/add_bandeau.html","<md-dialog aria-label=\"addBandeau\" flex=\"40\"><form name=\"addBandeauForm\" class=\"md-inline-form\" novalidate \nng-submit=\"addBandeauForm.$valid && saveBandeau()\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-30\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name pt-10\">{{titlePopupSave}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" layout-wrap><md-input-container \nclass=\"nl-Input-container nl-Input-container--no-error mb-24\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.user}\">\n<label class=\"nl-Input-label md-no-float md-container-ignore\">Message<span ng-if=\"newBandeau.message == null\" \nclass=\"asterix\">*</span></label><input type=\"text\" name=\"message\" ng-model=\"newBandeau.message\" required \nclass=\"nl-Input-input\" placeholder=\"\"><div ng-messages=\"addBandeauForm.message.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container><div flex=\"100\" \nng-if=\"!interne\"><md-input-container class=\"nl-Input-container mb-24\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Contrat</label><md-select ng-model=\"newBandeau.contractType\" \nrequired name=\"contrat\" class=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\">\n<md-select-header class=\"nl-Input-select-header\">Sélectionnez le type de contrat</md-select-header><md-option \nclass=\"nl-Select-dropdown-btn\" ng-repeat=\"contractType in contractTypes\" ng-value=\"contractType.name\">\n{{contractType.displayName}}</md-option></md-select><div ng-messages=\"addBandeauForm.contrat.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise</span></div></div></md-input-container></div><div flex=\"100\" \nng-show=\"!customDurationMode\"><md-input-container class=\"nl-Input-container mb-24\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Durée d\'affichage</label><md-select \nng-model=\"newBandeau.duration\" ng-required=\"!customDurationMode\" name=\"duration\" \nclass=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez la durée</md-select-header><md-option class=\"nl-Select-dropdown-btn\" \nng-repeat=\"duration in durations\" ng-value=\"duration.value\">{{duration.name}}</md-option></md-select><div \nng-messages=\"addBandeauForm.duration.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start start\" flex=\"100\" \nng-show=\"customDurationMode\"><md-input-container class=\"nl-Input-container\" flex=\"20\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Durée<span ng-if=\"customDuration.number == null\" \nclass=\"asterix\">*</span></label><input type=\"number\" min=\"1\" name=\"customDurationNbr\" ng-model=\"customDuration.number\" \nplaceholder=\"\" class=\"nl-Input-input\" ng-required=\"customDurationMode\"><div \nng-messages=\"addBandeauForm.customDurationNbr.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise\n</span></div><div ng-message=\"min\"><span>La durée doit être minimum de 1</span></div></div></md-input-container><div \nclass=\"mb-25\" flex=\"50\"><md-input-container class=\"nl-Input-container\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">Unité<span ng-if=\"customDuration.ms == null\" class=\"asterix\">*\n</span></label><md-select ng-model=\"customDuration.ms\" ng-required=\"customDurationMode\" name=\"customDurationMS\" \nclass=\"nl-Input-select md-no-underline\" md-container-class=\"nl-Select-dropdown\"><md-select-header \nclass=\"nl-Input-select-header\">Sélectionnez la durée</md-select-header><md-option class=\"nl-Select-dropdown-btn\" \nng-repeat=\"duration in customDurations\" ng-value=\"duration.value\">{{duration.name}}</md-option></md-select><div \nng-messages=\"addBandeauForm.customDurationMS.$error\" role=\"alert\"><div ng-message=\"required\"><span>Information requise.\n</span></div></div></md-input-container></div></div><div class=\"mt-20\" layout=\"row\" layout-align=\"center center\">\n<button type=\"button\" class=\"nl-Btn\" ng-click=\"setCustomDurationMode()\"><span ng-if=\"!customDurationMode\">\nDurée personnalisée</span> <span ng-if=\"customDurationMode\">Durée par défaut</span></button></div></div>\n</md-dialog-content><md-dialog-actions><button ng-disabled=\"submitting\" type=\"submit\" class=\"nl-Btn\" \naria-label=\"Sauvegarder\">Sauvegarder</button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/administration-bandeau/popup/delete_bandeau.html","<md-dialog aria-label=\"Suppression\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" class=\"pt-15\" \nlayout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"center center\">Suppression du message</div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" layout-align=\"end center\"></div></md-toolbar>\n<md-dialog-content>Êtes-vous sûr de vouloir supprimer ce message ?</md-dialog-content><md-dialog-actions layout=\"row\">\n<button class=\"nl-Btn\" ng-click=\"delete()\">Oui</button> <button class=\"nl-Btn nl-Btn--outline ml-10\" \nng-click=\"hidePopup()\">Non</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/administration-bandeau/popup/display_bandeau.html","<md-dialog aria-label=\"Bandeau (accueil)\" class=\"nl_dialog nl_mw\"><md-toolbar layout=\"column\"><div layout=\"row\" \nclass=\"pt-15\" layout-align=\"space-between center\"><div class=\"flex-10\"></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"center center\">Affichage du bandeau</div><md-button class=\"md-icon-button flex-10\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"mb-10\" layout=\"row\" layout-align=\"center center\"><div style=\"font-size: 1.1rem\">\nDate de début: {{bandeauToDisplay.dateDebut | date: \'dd/MM/yyyy\'}}</div>&nbsp;-&nbsp;<div style=\"font-size: 1.1rem\">\nDate de fin: {{bandeauToDisplay.dateFin | date: \'dd/MM/yyyy\'}}</div></div></md-toolbar><md-dialog-content \nstyle=\"white-space: pre-wrap\">{{bandeauToDisplay.message}}</md-dialog-content><md-dialog-actions layout=\"row\"><button \nclass=\"nl-Btn\" ng-click=\"hidePopup()\">OK</button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/popup/delete_note.html","<md-dialog aria-label=\"Suppression\" class=\"nl_dialog nl_mw pt-5 ph-25 pb-25\"><div \nclass=\"md-toolbar-tools nl_checkbox--categorie--title\"><h2 class=\"nl-H2\">Suppression de la note {{noteToDelete.num}}\n</h2></div><md-dialog-content>Êtes-vous sûr de vouloir supprimer cette note interne ?</md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-around center\"><button class=\"nl-Btn\" ng-click=\"deleteNote()\">Oui\n</button> <button class=\"nl-Btn nl-Btn--outline ml-20\" ng-click=\"hidePopup()\">Non</button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/popup/details_item.html","<md-dialog aria-label=\"dialog\" flex=\"40\"><md-toolbar class=\"md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n</span><md-button class=\"md-icon-button\" ng-click=\"hidePopUp()\" aria-label=\"dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle mt-10\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name pt-10\">Détails\n</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div \nflex layout=\"row\" layout-align=\"center center\"></div></div></md-toolbar><md-dialog-content ms-scroll><div class=\"\"><div\n class=\"m-20\">{{elementDetails.title}} {{elementDetails.name}}</div><div class=\"m-20\">\n{{(elementDetails.echeance ? elementDetails.echeance : elementDetails.creation) | date:\"dd/MM/yyyy\"}} {{elementDetails.creationDate | date:\"dd/MM/yyyy\"}} {{elementDetails.uploadDate | date:\"dd/MM/yyyy\"}}\n</div><div class=\"m-20\">{{elementDetails.description}} {{elementDetails.comment}}</div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/front/qualite/communication-interne/notes-internes/popup/send_mail.html","<md-dialog aria-label=\"Envoyer note internet\"><md-toolbar class=\"md-tall\" layout=\"column\"><div layout=\"row\" \nclass=\"pt-15\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\"><div layout=\"row\" flex=\"100\" layout-align=\"center center\">\nEnvoyer la note {{note.num}}</div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom mb-5\" layout=\"column\" \nlayout-align=\"end center\"></div></md-toolbar><md-dialog-content>\nÊtes-vous sûr de vouloir envoyer cette note interne par mail ?</md-dialog-content><md-dialog-actions layout=\"row\">\n<button class=\"nl-Btn\" ng-disabled=\"loading\" ng-click=\"sendMail(); cancelPopup();\"><span ng-if=\"!loading\">Oui</span>\n</button><md-progress-circular md-diameter=\"15px\" ng-if=\"loading\" class=\"md-accent\" md-mode=\"indeterminate\">\n</md-progress-circular><button class=\"nl-Btn nl-Btn--outline ml-10\" ng-click=\"hidePopup()\">Non</button>\n</md-dialog-actions></md-dialog>");}]);